(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["capshine"] = factory();
	else
		root["capshine"] = factory();
})(self, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uw": () => (/* binding */ WebPlugin),
/* harmony export */   "fo": () => (/* binding */ registerPlugin)
/* harmony export */ });
/* unused harmony exports Capacitor, CapacitorException, CapacitorPlatforms, ExceptionCode, Plugins, WebView, addPlatform, registerWebPlugin, setPlatform */
/*! Capacitor: https://capacitorjs.com/ - MIT License */
const createCapacitorPlatforms = (win) => {
    const defaultPlatformMap = new Map();
    defaultPlatformMap.set('web', { name: 'web' });
    const capPlatforms = win.CapacitorPlatforms || {
        currentPlatform: { name: 'web' },
        platforms: defaultPlatformMap,
    };
    const addPlatform = (name, platform) => {
        capPlatforms.platforms.set(name, platform);
    };
    const setPlatform = (name) => {
        if (capPlatforms.platforms.has(name)) {
            capPlatforms.currentPlatform = capPlatforms.platforms.get(name);
        }
    };
    capPlatforms.addPlatform = addPlatform;
    capPlatforms.setPlatform = setPlatform;
    return capPlatforms;
};
const initPlatforms = (win) => (win.CapacitorPlatforms = createCapacitorPlatforms(win));
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
const CapacitorPlatforms = /*#__PURE__*/ initPlatforms((typeof globalThis !== 'undefined'
    ? globalThis
    : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
            ? window
            : typeof __webpack_require__.g !== 'undefined'
                ? __webpack_require__.g
                : {}));
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
const addPlatform = CapacitorPlatforms.addPlatform;
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */
const setPlatform = CapacitorPlatforms.setPlatform;

const legacyRegisterWebPlugin = (cap, webPlugin) => {
    var _a;
    const config = webPlugin.config;
    const Plugins = cap.Plugins;
    if (!config || !config.name) {
        // TODO: add link to upgrade guide
        throw new Error(`Capacitor WebPlugin is using the deprecated "registerWebPlugin()" function, but without the config. Please use "registerPlugin()" instead to register this web plugin."`);
    }
    // TODO: add link to upgrade guide
    console.warn(`Capacitor plugin "${config.name}" is using the deprecated "registerWebPlugin()" function`);
    if (!Plugins[config.name] || ((_a = config === null || config === void 0 ? void 0 : config.platforms) === null || _a === void 0 ? void 0 : _a.includes(cap.getPlatform()))) {
        // Add the web plugin into the plugins registry if there already isn't
        // an existing one. If it doesn't already exist, that means
        // there's no existing native implementation for it.
        // - OR -
        // If we already have a plugin registered (meaning it was defined in the native layer),
        // then we should only overwrite it if the corresponding web plugin activates on
        // a certain platform. For example: Geolocation uses the WebPlugin on Android but not iOS
        Plugins[config.name] = webPlugin;
    }
};

var ExceptionCode;
(function (ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */
    ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */
    ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
class CapacitorException extends Error {
    constructor(message, code) {
        super(message);
        this.message = message;
        this.code = code;
    }
}
const getPlatformId = (win) => {
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) {
        return 'android';
    }
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) {
        return 'ios';
    }
    else {
        return 'web';
    }
};

const createCapacitor = (win) => {
    var _a, _b, _c, _d, _e;
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = (cap.Plugins = cap.Plugins || {});
    /**
     * @deprecated Use `capCustomPlatform` instead, default functions like registerPlugin will function with the new object.
     */
    const capPlatforms = win.CapacitorPlatforms;
    const defaultGetPlatform = () => {
        return capCustomPlatform !== null
            ? capCustomPlatform.name
            : getPlatformId(win);
    };
    const getPlatform = ((_a = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a === void 0 ? void 0 : _a.getPlatform) || defaultGetPlatform;
    const defaultIsNativePlatform = () => getPlatform() !== 'web';
    const isNativePlatform = ((_b = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b === void 0 ? void 0 : _b.isNativePlatform) || defaultIsNativePlatform;
    const defaultIsPluginAvailable = (pluginName) => {
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
            // JS implementation available for the current platform.
            return true;
        }
        if (getPluginHeader(pluginName)) {
            // Native implementation available.
            return true;
        }
        return false;
    };
    const isPluginAvailable = ((_c = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c === void 0 ? void 0 : _c.isPluginAvailable) ||
        defaultIsPluginAvailable;
    const defaultGetPluginHeader = (pluginName) => { var _a; return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find(h => h.name === pluginName); };
    const getPluginHeader = ((_d = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d === void 0 ? void 0 : _d.getPluginHeader) || defaultGetPluginHeader;
    const handleError = (err) => win.console.error(err);
    const pluginMethodNoop = (_target, prop, pluginName) => {
        return Promise.reject(`${pluginName} does not have an implementation of "${prop}".`);
    };
    const registeredPlugins = new Map();
    const defaultRegisterPlugin = (pluginName, jsImplementations = {}) => {
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async () => {
            if (!jsImplementation && platform in jsImplementations) {
                jsImplementation =
                    typeof jsImplementations[platform] === 'function'
                        ? (jsImplementation = await jsImplementations[platform]())
                        : (jsImplementation = jsImplementations[platform]);
            }
            else if (capCustomPlatform !== null &&
                !jsImplementation &&
                'web' in jsImplementations) {
                jsImplementation =
                    typeof jsImplementations['web'] === 'function'
                        ? (jsImplementation = await jsImplementations['web']())
                        : (jsImplementation = jsImplementations['web']);
            }
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop) => {
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find(m => prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') {
                        return (options) => cap.nativePromise(pluginName, prop.toString(), options);
                    }
                    else {
                        return (options, callback) => cap.nativeCallback(pluginName, prop.toString(), options, callback);
                    }
                }
                else if (impl) {
                    return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
                }
            }
            else if (impl) {
                return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            }
            else {
                throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform}`, ExceptionCode.Unimplemented);
            }
        };
        const createPluginMethodWrapper = (prop) => {
            let remove;
            const wrapper = (...args) => {
                const p = loadPluginImplementation().then(impl => {
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    }
                    else {
                        throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform}`, ExceptionCode.Unimplemented);
                    }
                });
                if (prop === 'addListener') {
                    p.remove = async () => remove();
                }
                return p;
            };
            // Some flair ✨
            wrapper.toString = () => `${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false,
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback) => {
            const call = addListener({ eventName }, callback);
            const remove = async () => {
                const callbackId = await call;
                removeListener({
                    eventName,
                    callbackId,
                }, callback);
            };
            const p = new Promise(resolve => call.then(() => resolve({ remove })));
            p.remove = async () => {
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get(_, prop) {
                switch (prop) {
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return () => ({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            },
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...(pluginHeader ? [platform] : []),
            ]),
        });
        return proxy;
    };
    const registerPlugin = ((_e = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e === void 0 ? void 0 : _e.registerPlugin) || defaultRegisterPlugin;
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) {
        cap.convertFileSrc = filePath => filePath;
    }
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.pluginMethodNoop = pluginMethodNoop;
    cap.registerPlugin = registerPlugin;
    cap.Exception = CapacitorException;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    // Deprecated props
    cap.platform = cap.getPlatform();
    cap.isNative = cap.isNativePlatform();
    return cap;
};
const initCapacitorGlobal = (win) => (win.Capacitor = createCapacitor(win));

const Capacitor = /*#__PURE__*/ initCapacitorGlobal(typeof globalThis !== 'undefined'
    ? globalThis
    : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
            ? window
            : typeof __webpack_require__.g !== 'undefined'
                ? __webpack_require__.g
                : {});
const registerPlugin = Capacitor.registerPlugin;
/**
 * @deprecated Provided for backwards compatibility for Capacitor v2 plugins.
 * Capacitor v3 plugins should import the plugin directly. This "Plugins"
 * export is deprecated in v3, and will be removed in v4.
 */
const Plugins = Capacitor.Plugins;
/**
 * Provided for backwards compatibility. Use the registerPlugin() API
 * instead, and provide the web plugin as the "web" implmenetation.
 * For example
 *
 * export const Example = registerPlugin('Example', {
 *   web: () => import('./web').then(m => new m.Example())
 * })
 *
 * @deprecated Deprecated in v3, will be removed from v4.
 */
const registerWebPlugin = (plugin) => legacyRegisterWebPlugin(Capacitor, plugin);

/**
 * Base class web plugins should extend.
 */
class WebPlugin {
    constructor(config) {
        this.listeners = {};
        this.windowListeners = {};
        if (config) {
            // TODO: add link to upgrade guide
            console.warn(`Capacitor WebPlugin "${config.name}" config object was deprecated in v3 and will be removed in v4.`);
            this.config = config;
        }
    }
    addListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) {
            this.addWindowListener(windowListener);
        }
        const remove = async () => this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({ remove });
        Object.defineProperty(p, 'remove', {
            value: async () => {
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            },
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for (const listener in this.windowListeners) {
            this.removeWindowListener(this.windowListeners[listener]);
        }
        this.windowListeners = {};
    }
    notifyListeners(eventName, data) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            listeners.forEach(listener => listener(data));
        }
    }
    hasListeners(eventName) {
        return !!this.listeners[eventName].length;
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: event => {
                this.notifyListeners(pluginEventName, event);
            },
        };
    }
    unimplemented(msg = 'not implemented') {
        return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            return;
        }
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) {
            this.removeWindowListener(this.windowListeners[eventName]);
        }
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) {
            return;
        }
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
}

const WebView = /*#__PURE__*/ (/* unused pure expression or super */ null && (registerPlugin('WebView')));


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 3:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BASE_TRANSITION": () => (/* reexport */ BASE_TRANSITION),
  "CAMELIZE": () => (/* reexport */ CAMELIZE),
  "CAPITALIZE": () => (/* reexport */ CAPITALIZE),
  "CREATE_BLOCK": () => (/* reexport */ CREATE_BLOCK),
  "CREATE_COMMENT": () => (/* reexport */ CREATE_COMMENT),
  "CREATE_ELEMENT_BLOCK": () => (/* reexport */ CREATE_ELEMENT_BLOCK),
  "CREATE_ELEMENT_VNODE": () => (/* reexport */ CREATE_ELEMENT_VNODE),
  "CREATE_SLOTS": () => (/* reexport */ CREATE_SLOTS),
  "CREATE_STATIC": () => (/* reexport */ CREATE_STATIC),
  "CREATE_TEXT": () => (/* reexport */ CREATE_TEXT),
  "CREATE_VNODE": () => (/* reexport */ CREATE_VNODE),
  "DOMDirectiveTransforms": () => (/* binding */ DOMDirectiveTransforms),
  "DOMNodeTransforms": () => (/* binding */ DOMNodeTransforms),
  "FRAGMENT": () => (/* reexport */ FRAGMENT),
  "GUARD_REACTIVE_PROPS": () => (/* reexport */ GUARD_REACTIVE_PROPS),
  "IS_MEMO_SAME": () => (/* reexport */ IS_MEMO_SAME),
  "IS_REF": () => (/* reexport */ IS_REF),
  "KEEP_ALIVE": () => (/* reexport */ KEEP_ALIVE),
  "MERGE_PROPS": () => (/* reexport */ MERGE_PROPS),
  "NORMALIZE_CLASS": () => (/* reexport */ NORMALIZE_CLASS),
  "NORMALIZE_PROPS": () => (/* reexport */ NORMALIZE_PROPS),
  "NORMALIZE_STYLE": () => (/* reexport */ NORMALIZE_STYLE),
  "OPEN_BLOCK": () => (/* reexport */ OPEN_BLOCK),
  "POP_SCOPE_ID": () => (/* reexport */ POP_SCOPE_ID),
  "PUSH_SCOPE_ID": () => (/* reexport */ PUSH_SCOPE_ID),
  "RENDER_LIST": () => (/* reexport */ RENDER_LIST),
  "RENDER_SLOT": () => (/* reexport */ RENDER_SLOT),
  "RESOLVE_COMPONENT": () => (/* reexport */ RESOLVE_COMPONENT),
  "RESOLVE_DIRECTIVE": () => (/* reexport */ RESOLVE_DIRECTIVE),
  "RESOLVE_DYNAMIC_COMPONENT": () => (/* reexport */ RESOLVE_DYNAMIC_COMPONENT),
  "RESOLVE_FILTER": () => (/* reexport */ RESOLVE_FILTER),
  "SET_BLOCK_TRACKING": () => (/* reexport */ SET_BLOCK_TRACKING),
  "SUSPENSE": () => (/* reexport */ SUSPENSE),
  "TELEPORT": () => (/* reexport */ TELEPORT),
  "TO_DISPLAY_STRING": () => (/* reexport */ TO_DISPLAY_STRING),
  "TO_HANDLERS": () => (/* reexport */ TO_HANDLERS),
  "TO_HANDLER_KEY": () => (/* reexport */ TO_HANDLER_KEY),
  "TRANSITION": () => (/* binding */ TRANSITION),
  "TRANSITION_GROUP": () => (/* binding */ TRANSITION_GROUP),
  "UNREF": () => (/* reexport */ UNREF),
  "V_MODEL_CHECKBOX": () => (/* binding */ V_MODEL_CHECKBOX),
  "V_MODEL_DYNAMIC": () => (/* binding */ V_MODEL_DYNAMIC),
  "V_MODEL_RADIO": () => (/* binding */ V_MODEL_RADIO),
  "V_MODEL_SELECT": () => (/* binding */ V_MODEL_SELECT),
  "V_MODEL_TEXT": () => (/* binding */ V_MODEL_TEXT),
  "V_ON_WITH_KEYS": () => (/* binding */ V_ON_WITH_KEYS),
  "V_ON_WITH_MODIFIERS": () => (/* binding */ V_ON_WITH_MODIFIERS),
  "V_SHOW": () => (/* binding */ V_SHOW),
  "WITH_CTX": () => (/* reexport */ WITH_CTX),
  "WITH_DIRECTIVES": () => (/* reexport */ WITH_DIRECTIVES),
  "WITH_MEMO": () => (/* reexport */ WITH_MEMO),
  "advancePositionWithClone": () => (/* reexport */ advancePositionWithClone),
  "advancePositionWithMutation": () => (/* reexport */ advancePositionWithMutation),
  "assert": () => (/* reexport */ assert),
  "baseCompile": () => (/* reexport */ baseCompile),
  "baseParse": () => (/* reexport */ baseParse),
  "buildDirectiveArgs": () => (/* reexport */ buildDirectiveArgs),
  "buildProps": () => (/* reexport */ buildProps),
  "buildSlots": () => (/* reexport */ buildSlots),
  "checkCompatEnabled": () => (/* reexport */ checkCompatEnabled),
  "compile": () => (/* binding */ compile),
  "createArrayExpression": () => (/* reexport */ createArrayExpression),
  "createAssignmentExpression": () => (/* reexport */ createAssignmentExpression),
  "createBlockStatement": () => (/* reexport */ createBlockStatement),
  "createCacheExpression": () => (/* reexport */ createCacheExpression),
  "createCallExpression": () => (/* reexport */ createCallExpression),
  "createCompilerError": () => (/* reexport */ createCompilerError),
  "createCompoundExpression": () => (/* reexport */ createCompoundExpression),
  "createConditionalExpression": () => (/* reexport */ createConditionalExpression),
  "createDOMCompilerError": () => (/* binding */ createDOMCompilerError),
  "createForLoopParams": () => (/* reexport */ createForLoopParams),
  "createFunctionExpression": () => (/* reexport */ createFunctionExpression),
  "createIfStatement": () => (/* reexport */ createIfStatement),
  "createInterpolation": () => (/* reexport */ createInterpolation),
  "createObjectExpression": () => (/* reexport */ createObjectExpression),
  "createObjectProperty": () => (/* reexport */ createObjectProperty),
  "createReturnStatement": () => (/* reexport */ createReturnStatement),
  "createRoot": () => (/* reexport */ createRoot),
  "createSequenceExpression": () => (/* reexport */ createSequenceExpression),
  "createSimpleExpression": () => (/* reexport */ createSimpleExpression),
  "createStructuralDirectiveTransform": () => (/* reexport */ createStructuralDirectiveTransform),
  "createTemplateLiteral": () => (/* reexport */ createTemplateLiteral),
  "createTransformContext": () => (/* reexport */ createTransformContext),
  "createVNodeCall": () => (/* reexport */ createVNodeCall),
  "extractIdentifiers": () => (/* reexport */ extractIdentifiers),
  "findDir": () => (/* reexport */ findDir),
  "findProp": () => (/* reexport */ findProp),
  "generate": () => (/* reexport */ generate),
  "generateCodeFrame": () => (/* reexport */ shared_esm_bundler.generateCodeFrame),
  "getBaseTransformPreset": () => (/* reexport */ getBaseTransformPreset),
  "getInnerRange": () => (/* reexport */ getInnerRange),
  "getMemoedVNodeCall": () => (/* reexport */ getMemoedVNodeCall),
  "getVNodeBlockHelper": () => (/* reexport */ getVNodeBlockHelper),
  "getVNodeHelper": () => (/* reexport */ getVNodeHelper),
  "hasDynamicKeyVBind": () => (/* reexport */ hasDynamicKeyVBind),
  "hasScopeRef": () => (/* reexport */ hasScopeRef),
  "helperNameMap": () => (/* reexport */ helperNameMap),
  "injectProp": () => (/* reexport */ injectProp),
  "isBuiltInType": () => (/* reexport */ isBuiltInType),
  "isCoreComponent": () => (/* reexport */ isCoreComponent),
  "isFunctionType": () => (/* reexport */ isFunctionType),
  "isInDestructureAssignment": () => (/* reexport */ isInDestructureAssignment),
  "isMemberExpression": () => (/* reexport */ isMemberExpression),
  "isMemberExpressionBrowser": () => (/* reexport */ isMemberExpressionBrowser),
  "isMemberExpressionNode": () => (/* reexport */ isMemberExpressionNode),
  "isReferencedIdentifier": () => (/* reexport */ isReferencedIdentifier),
  "isSimpleIdentifier": () => (/* reexport */ isSimpleIdentifier),
  "isSlotOutlet": () => (/* reexport */ isSlotOutlet),
  "isStaticArgOf": () => (/* reexport */ isStaticArgOf),
  "isStaticExp": () => (/* reexport */ isStaticExp),
  "isStaticProperty": () => (/* reexport */ isStaticProperty),
  "isStaticPropertyKey": () => (/* reexport */ isStaticPropertyKey),
  "isTemplateNode": () => (/* reexport */ isTemplateNode),
  "isText": () => (/* reexport */ isText),
  "isVSlot": () => (/* reexport */ isVSlot),
  "locStub": () => (/* reexport */ locStub),
  "makeBlock": () => (/* reexport */ makeBlock),
  "noopDirectiveTransform": () => (/* reexport */ noopDirectiveTransform),
  "parse": () => (/* binding */ parse),
  "parserOptions": () => (/* binding */ parserOptions),
  "processExpression": () => (/* reexport */ processExpression),
  "processFor": () => (/* reexport */ processFor),
  "processIf": () => (/* reexport */ processIf),
  "processSlotOutlet": () => (/* reexport */ processSlotOutlet),
  "registerRuntimeHelpers": () => (/* reexport */ registerRuntimeHelpers),
  "resolveComponentType": () => (/* reexport */ resolveComponentType),
  "toValidAssetId": () => (/* reexport */ toValidAssetId),
  "trackSlotScopes": () => (/* reexport */ trackSlotScopes),
  "trackVForSlotScopes": () => (/* reexport */ trackVForSlotScopes),
  "transform": () => (/* reexport */ transform),
  "transformBind": () => (/* reexport */ transformBind),
  "transformElement": () => (/* reexport */ transformElement),
  "transformExpression": () => (/* reexport */ transformExpression),
  "transformModel": () => (/* reexport */ transformModel),
  "transformOn": () => (/* reexport */ transformOn),
  "transformStyle": () => (/* binding */ transformStyle),
  "traverseNode": () => (/* reexport */ traverseNode),
  "walkBlockDeclarations": () => (/* reexport */ walkBlockDeclarations),
  "walkFunctionParams": () => (/* reexport */ walkFunctionParams),
  "walkIdentifiers": () => (/* reexport */ walkIdentifiers),
  "warnDeprecation": () => (/* reexport */ warnDeprecation)
});

// EXTERNAL MODULE: ./node_modules/@vue/shared/dist/shared.esm-bundler.js
var shared_esm_bundler = __webpack_require__(577);
;// CONCATENATED MODULE: ./node_modules/@vue/compiler-core/dist/compiler-core.esm-bundler.js



function defaultOnError(error) {
    throw error;
}
function defaultOnWarn(msg) {
    ( false) && 0;
}
function createCompilerError(code, loc, messages, additionalMessage) {
    const msg =  false
        ? 0
        : code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const errorMessages = {
    // parse errors
    [0 /* ABRUPT_CLOSING_OF_EMPTY_COMMENT */]: 'Illegal comment.',
    [1 /* CDATA_IN_HTML_CONTENT */]: 'CDATA section is allowed only in XML context.',
    [2 /* DUPLICATE_ATTRIBUTE */]: 'Duplicate attribute.',
    [3 /* END_TAG_WITH_ATTRIBUTES */]: 'End tag cannot have attributes.',
    [4 /* END_TAG_WITH_TRAILING_SOLIDUS */]: "Illegal '/' in tags.",
    [5 /* EOF_BEFORE_TAG_NAME */]: 'Unexpected EOF in tag.',
    [6 /* EOF_IN_CDATA */]: 'Unexpected EOF in CDATA section.',
    [7 /* EOF_IN_COMMENT */]: 'Unexpected EOF in comment.',
    [8 /* EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */]: 'Unexpected EOF in script.',
    [9 /* EOF_IN_TAG */]: 'Unexpected EOF in tag.',
    [10 /* INCORRECTLY_CLOSED_COMMENT */]: 'Incorrectly closed comment.',
    [11 /* INCORRECTLY_OPENED_COMMENT */]: 'Incorrectly opened comment.',
    [12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13 /* MISSING_ATTRIBUTE_VALUE */]: 'Attribute value was expected.',
    [14 /* MISSING_END_TAG_NAME */]: 'End tag name was expected.',
    [15 /* MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */]: 'Whitespace was expected.',
    [16 /* NESTED_COMMENT */]: "Unexpected '<!--' in comment.",
    [17 /* UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */]: 'Attribute name cannot contain U+0022 ("), U+0027 (\'), and U+003C (<).',
    [18 /* UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */]: 'Unquoted attribute value cannot contain U+0022 ("), U+0027 (\'), U+003C (<), U+003D (=), and U+0060 (`).',
    [19 /* UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */]: "Attribute name cannot start with '='.",
    [21 /* UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */]: "'<?' is allowed only in XML context.",
    [20 /* UNEXPECTED_NULL_CHARACTER */]: `Unexpected null character.`,
    [22 /* UNEXPECTED_SOLIDUS_IN_TAG */]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23 /* X_INVALID_END_TAG */]: 'Invalid end tag.',
    [24 /* X_MISSING_END_TAG */]: 'Element is missing end tag.',
    [25 /* X_MISSING_INTERPOLATION_END */]: 'Interpolation end sign was not found.',
    [27 /* X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */]: 'End bracket for dynamic directive argument was not found. ' +
        'Note that dynamic directive argument cannot contain spaces.',
    [26 /* X_MISSING_DIRECTIVE_NAME */]: 'Legal directive name was expected.',
    // transform errors
    [28 /* X_V_IF_NO_EXPRESSION */]: `v-if/v-else-if is missing expression.`,
    [29 /* X_V_IF_SAME_KEY */]: `v-if/else branches must use unique keys.`,
    [30 /* X_V_ELSE_NO_ADJACENT_IF */]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31 /* X_V_FOR_NO_EXPRESSION */]: `v-for is missing expression.`,
    [32 /* X_V_FOR_MALFORMED_EXPRESSION */]: `v-for has invalid expression.`,
    [33 /* X_V_FOR_TEMPLATE_KEY_PLACEMENT */]: `<template v-for> key should be placed on the <template> tag.`,
    [34 /* X_V_BIND_NO_EXPRESSION */]: `v-bind is missing expression.`,
    [35 /* X_V_ON_NO_EXPRESSION */]: `v-on is missing expression.`,
    [36 /* X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */]: `Unexpected custom directive on <slot> outlet.`,
    [37 /* X_V_SLOT_MIXED_SLOT_USAGE */]: `Mixed v-slot usage on both the component and nested <template>.` +
        `When there are multiple named slots, all slots should use <template> ` +
        `syntax to avoid scope ambiguity.`,
    [38 /* X_V_SLOT_DUPLICATE_SLOT_NAMES */]: `Duplicate slot names found. `,
    [39 /* X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */]: `Extraneous children found when component already has explicitly named ` +
        `default slot. These children will be ignored.`,
    [40 /* X_V_SLOT_MISPLACED */]: `v-slot can only be used on components or <template> tags.`,
    [41 /* X_V_MODEL_NO_EXPRESSION */]: `v-model is missing expression.`,
    [42 /* X_V_MODEL_MALFORMED_EXPRESSION */]: `v-model value must be a valid JavaScript member expression.`,
    [43 /* X_V_MODEL_ON_SCOPE_VARIABLE */]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44 /* X_INVALID_EXPRESSION */]: `Error parsing JavaScript expression: `,
    [45 /* X_KEEP_ALIVE_INVALID_CHILDREN */]: `<KeepAlive> expects exactly one child component.`,
    // generic errors
    [46 /* X_PREFIX_ID_NOT_SUPPORTED */]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [47 /* X_MODULE_MODE_NOT_SUPPORTED */]: `ES module mode is not supported in this build of compiler.`,
    [48 /* X_CACHE_HANDLER_NOT_SUPPORTED */]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [49 /* X_SCOPE_ID_NOT_SUPPORTED */]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [50 /* __EXTEND_POINT__ */]: ``
};

const FRAGMENT = Symbol(( false) ? 0 : ``);
const TELEPORT = Symbol(( false) ? 0 : ``);
const SUSPENSE = Symbol(( false) ? 0 : ``);
const KEEP_ALIVE = Symbol(( false) ? 0 : ``);
const BASE_TRANSITION = Symbol(( false) ? 0 : ``);
const OPEN_BLOCK = Symbol(( false) ? 0 : ``);
const CREATE_BLOCK = Symbol(( false) ? 0 : ``);
const CREATE_ELEMENT_BLOCK = Symbol(( false) ? 0 : ``);
const CREATE_VNODE = Symbol(( false) ? 0 : ``);
const CREATE_ELEMENT_VNODE = Symbol(( false) ? 0 : ``);
const CREATE_COMMENT = Symbol(( false) ? 0 : ``);
const CREATE_TEXT = Symbol(( false) ? 0 : ``);
const CREATE_STATIC = Symbol(( false) ? 0 : ``);
const RESOLVE_COMPONENT = Symbol(( false) ? 0 : ``);
const RESOLVE_DYNAMIC_COMPONENT = Symbol(( false) ? 0 : ``);
const RESOLVE_DIRECTIVE = Symbol(( false) ? 0 : ``);
const RESOLVE_FILTER = Symbol(( false) ? 0 : ``);
const WITH_DIRECTIVES = Symbol(( false) ? 0 : ``);
const RENDER_LIST = Symbol(( false) ? 0 : ``);
const RENDER_SLOT = Symbol(( false) ? 0 : ``);
const CREATE_SLOTS = Symbol(( false) ? 0 : ``);
const TO_DISPLAY_STRING = Symbol(( false) ? 0 : ``);
const MERGE_PROPS = Symbol(( false) ? 0 : ``);
const NORMALIZE_CLASS = Symbol(( false) ? 0 : ``);
const NORMALIZE_STYLE = Symbol(( false) ? 0 : ``);
const NORMALIZE_PROPS = Symbol(( false) ? 0 : ``);
const GUARD_REACTIVE_PROPS = Symbol(( false) ? 0 : ``);
const TO_HANDLERS = Symbol(( false) ? 0 : ``);
const CAMELIZE = Symbol(( false) ? 0 : ``);
const CAPITALIZE = Symbol(( false) ? 0 : ``);
const TO_HANDLER_KEY = Symbol(( false) ? 0 : ``);
const SET_BLOCK_TRACKING = Symbol(( false) ? 0 : ``);
const PUSH_SCOPE_ID = Symbol(( false) ? 0 : ``);
const POP_SCOPE_ID = Symbol(( false) ? 0 : ``);
const WITH_CTX = Symbol(( false) ? 0 : ``);
const UNREF = Symbol(( false) ? 0 : ``);
const IS_REF = Symbol(( false) ? 0 : ``);
const WITH_MEMO = Symbol(( false) ? 0 : ``);
const IS_MEMO_SAME = Symbol(( false) ? 0 : ``);
// Name mapping for runtime helpers that need to be imported from 'vue' in
// generated code. Make sure these are correctly exported in the runtime!
// Using `any` here because TS doesn't allow symbols as index type.
const helperNameMap = {
    [FRAGMENT]: `Fragment`,
    [TELEPORT]: `Teleport`,
    [SUSPENSE]: `Suspense`,
    [KEEP_ALIVE]: `KeepAlive`,
    [BASE_TRANSITION]: `BaseTransition`,
    [OPEN_BLOCK]: `openBlock`,
    [CREATE_BLOCK]: `createBlock`,
    [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
    [CREATE_VNODE]: `createVNode`,
    [CREATE_ELEMENT_VNODE]: `createElementVNode`,
    [CREATE_COMMENT]: `createCommentVNode`,
    [CREATE_TEXT]: `createTextVNode`,
    [CREATE_STATIC]: `createStaticVNode`,
    [RESOLVE_COMPONENT]: `resolveComponent`,
    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
    [RESOLVE_DIRECTIVE]: `resolveDirective`,
    [RESOLVE_FILTER]: `resolveFilter`,
    [WITH_DIRECTIVES]: `withDirectives`,
    [RENDER_LIST]: `renderList`,
    [RENDER_SLOT]: `renderSlot`,
    [CREATE_SLOTS]: `createSlots`,
    [TO_DISPLAY_STRING]: `toDisplayString`,
    [MERGE_PROPS]: `mergeProps`,
    [NORMALIZE_CLASS]: `normalizeClass`,
    [NORMALIZE_STYLE]: `normalizeStyle`,
    [NORMALIZE_PROPS]: `normalizeProps`,
    [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
    [TO_HANDLERS]: `toHandlers`,
    [CAMELIZE]: `camelize`,
    [CAPITALIZE]: `capitalize`,
    [TO_HANDLER_KEY]: `toHandlerKey`,
    [SET_BLOCK_TRACKING]: `setBlockTracking`,
    [PUSH_SCOPE_ID]: `pushScopeId`,
    [POP_SCOPE_ID]: `popScopeId`,
    [WITH_CTX]: `withCtx`,
    [UNREF]: `unref`,
    [IS_REF]: `isRef`,
    [WITH_MEMO]: `withMemo`,
    [IS_MEMO_SAME]: `isMemoSame`
};
function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach(s => {
        helperNameMap[s] = helpers[s];
    });
}

// AST Utilities ---------------------------------------------------------------
// Some expressions, e.g. sequence and conditional expressions, are never
// associated with template nodes, so their source locations are just a stub.
// Container types like CompoundExpression also don't need a real location.
const locStub = {
    source: '',
    start: { line: 1, column: 1, offset: 0 },
    end: { line: 1, column: 1, offset: 0 }
};
function createRoot(children, loc = locStub) {
    return {
        type: 0 /* ROOT */,
        children,
        helpers: [],
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: 0,
        temps: 0,
        codegenNode: undefined,
        loc
    };
}
function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = locStub) {
    if (context) {
        if (isBlock) {
            context.helper(OPEN_BLOCK);
            context.helper(getVNodeBlockHelper(context.inSSR, isComponent));
        }
        else {
            context.helper(getVNodeHelper(context.inSSR, isComponent));
        }
        if (directives) {
            context.helper(WITH_DIRECTIVES);
        }
    }
    return {
        type: 13 /* VNODE_CALL */,
        tag,
        props,
        children,
        patchFlag,
        dynamicProps,
        directives,
        isBlock,
        disableTracking,
        isComponent,
        loc
    };
}
function createArrayExpression(elements, loc = locStub) {
    return {
        type: 17 /* JS_ARRAY_EXPRESSION */,
        loc,
        elements
    };
}
function createObjectExpression(properties, loc = locStub) {
    return {
        type: 15 /* JS_OBJECT_EXPRESSION */,
        loc,
        properties
    };
}
function createObjectProperty(key, value) {
    return {
        type: 16 /* JS_PROPERTY */,
        loc: locStub,
        key: (0,shared_esm_bundler.isString)(key) ? createSimpleExpression(key, true) : key,
        value
    };
}
function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0 /* NOT_CONSTANT */) {
    return {
        type: 4 /* SIMPLE_EXPRESSION */,
        loc,
        content,
        isStatic,
        constType: isStatic ? 3 /* CAN_STRINGIFY */ : constType
    };
}
function createInterpolation(content, loc) {
    return {
        type: 5 /* INTERPOLATION */,
        loc,
        content: (0,shared_esm_bundler.isString)(content)
            ? createSimpleExpression(content, false, loc)
            : content
    };
}
function createCompoundExpression(children, loc = locStub) {
    return {
        type: 8 /* COMPOUND_EXPRESSION */,
        loc,
        children
    };
}
function createCallExpression(callee, args = [], loc = locStub) {
    return {
        type: 14 /* JS_CALL_EXPRESSION */,
        loc,
        callee,
        arguments: args
    };
}
function createFunctionExpression(params, returns = undefined, newline = false, isSlot = false, loc = locStub) {
    return {
        type: 18 /* JS_FUNCTION_EXPRESSION */,
        params,
        returns,
        newline,
        isSlot,
        loc
    };
}
function createConditionalExpression(test, consequent, alternate, newline = true) {
    return {
        type: 19 /* JS_CONDITIONAL_EXPRESSION */,
        test,
        consequent,
        alternate,
        newline,
        loc: locStub
    };
}
function createCacheExpression(index, value, isVNode = false) {
    return {
        type: 20 /* JS_CACHE_EXPRESSION */,
        index,
        value,
        isVNode,
        loc: locStub
    };
}
function createBlockStatement(body) {
    return {
        type: 21 /* JS_BLOCK_STATEMENT */,
        body,
        loc: locStub
    };
}
function createTemplateLiteral(elements) {
    return {
        type: 22 /* JS_TEMPLATE_LITERAL */,
        elements,
        loc: locStub
    };
}
function createIfStatement(test, consequent, alternate) {
    return {
        type: 23 /* JS_IF_STATEMENT */,
        test,
        consequent,
        alternate,
        loc: locStub
    };
}
function createAssignmentExpression(left, right) {
    return {
        type: 24 /* JS_ASSIGNMENT_EXPRESSION */,
        left,
        right,
        loc: locStub
    };
}
function createSequenceExpression(expressions) {
    return {
        type: 25 /* JS_SEQUENCE_EXPRESSION */,
        expressions,
        loc: locStub
    };
}
function createReturnStatement(returns) {
    return {
        type: 26 /* JS_RETURN_STATEMENT */,
        returns,
        loc: locStub
    };
}

const isStaticExp = (p) => p.type === 4 /* SIMPLE_EXPRESSION */ && p.isStatic;
const isBuiltInType = (tag, expected) => tag === expected || tag === (0,shared_esm_bundler.hyphenate)(expected);
function isCoreComponent(tag) {
    if (isBuiltInType(tag, 'Teleport')) {
        return TELEPORT;
    }
    else if (isBuiltInType(tag, 'Suspense')) {
        return SUSPENSE;
    }
    else if (isBuiltInType(tag, 'KeepAlive')) {
        return KEEP_ALIVE;
    }
    else if (isBuiltInType(tag, 'BaseTransition')) {
        return BASE_TRANSITION;
    }
}
const nonIdentifierRE = /^\d|[^\$\w]/;
const isSimpleIdentifier = (name) => !nonIdentifierRE.test(name);
const validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
/**
 * Simple lexer to check if an expression is a member expression. This is
 * lax and only checks validity at the root level (i.e. does not validate exps
 * inside square brackets), but it's ok since these are only used on template
 * expressions and false positives are invalid expressions in the first place.
 */
const isMemberExpressionBrowser = (path) => {
    // remove whitespaces around . or [ first
    path = path.trim().replace(whitespaceRE, s => s.trim());
    let state = 0 /* inMemberExp */;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for (let i = 0; i < path.length; i++) {
        const char = path.charAt(i);
        switch (state) {
            case 0 /* inMemberExp */:
                if (char === '[') {
                    stateStack.push(state);
                    state = 1 /* inBrackets */;
                    currentOpenBracketCount++;
                }
                else if (char === '(') {
                    stateStack.push(state);
                    state = 2 /* inParens */;
                    currentOpenParensCount++;
                }
                else if (!(i === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) {
                    return false;
                }
                break;
            case 1 /* inBrackets */:
                if (char === `'` || char === `"` || char === '`') {
                    stateStack.push(state);
                    state = 3 /* inString */;
                    currentStringType = char;
                }
                else if (char === `[`) {
                    currentOpenBracketCount++;
                }
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) {
                        state = stateStack.pop();
                    }
                }
                break;
            case 2 /* inParens */:
                if (char === `'` || char === `"` || char === '`') {
                    stateStack.push(state);
                    state = 3 /* inString */;
                    currentStringType = char;
                }
                else if (char === `(`) {
                    currentOpenParensCount++;
                }
                else if (char === `)`) {
                    // if the exp ends as a call then it should not be considered valid
                    if (i === path.length - 1) {
                        return false;
                    }
                    if (!--currentOpenParensCount) {
                        state = stateStack.pop();
                    }
                }
                break;
            case 3 /* inString */:
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const isMemberExpressionNode = shared_esm_bundler.NOOP
    ;
const isMemberExpression = isMemberExpressionBrowser
    ;
function getInnerRange(loc, offset, length) {
    const source = loc.source.slice(offset, offset + length);
    const newLoc = {
        source,
        start: advancePositionWithClone(loc.start, loc.source, offset),
        end: loc.end
    };
    if (length != null) {
        newLoc.end = advancePositionWithClone(loc.start, loc.source, offset + length);
    }
    return newLoc;
}
function advancePositionWithClone(pos, source, numberOfCharacters = source.length) {
    return advancePositionWithMutation((0,shared_esm_bundler.extend)({}, pos), source, numberOfCharacters);
}
// advance by mutation without cloning (for performance reasons), since this
// gets called a lot in the parser
function advancePositionWithMutation(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for (let i = 0; i < numberOfCharacters; i++) {
        if (source.charCodeAt(i) === 10 /* newline char code */) {
            linesCount++;
            lastNewLinePos = i;
        }
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column =
        lastNewLinePos === -1
            ? pos.column + numberOfCharacters
            : numberOfCharacters - lastNewLinePos;
    return pos;
}
function assert(condition, msg) {
    /* istanbul ignore if */
    if (!condition) {
        throw new Error(msg || `unexpected compiler condition`);
    }
}
function findDir(node, name, allowEmpty = false) {
    for (let i = 0; i < node.props.length; i++) {
        const p = node.props[i];
        if (p.type === 7 /* DIRECTIVE */ &&
            (allowEmpty || p.exp) &&
            ((0,shared_esm_bundler.isString)(name) ? p.name === name : name.test(p.name))) {
            return p;
        }
    }
}
function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for (let i = 0; i < node.props.length; i++) {
        const p = node.props[i];
        if (p.type === 6 /* ATTRIBUTE */) {
            if (dynamicOnly)
                continue;
            if (p.name === name && (p.value || allowEmpty)) {
                return p;
            }
        }
        else if (p.name === 'bind' &&
            (p.exp || allowEmpty) &&
            isStaticArgOf(p.arg, name)) {
            return p;
        }
    }
}
function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
}
function hasDynamicKeyVBind(node) {
    return node.props.some(p => p.type === 7 /* DIRECTIVE */ &&
        p.name === 'bind' &&
        (!p.arg || // v-bind="obj"
            p.arg.type !== 4 /* SIMPLE_EXPRESSION */ || // v-bind:[_ctx.foo]
            !p.arg.isStatic) // v-bind:[foo]
    );
}
function isText(node) {
    return node.type === 5 /* INTERPOLATION */ || node.type === 2 /* TEXT */;
}
function isVSlot(p) {
    return p.type === 7 /* DIRECTIVE */ && p.name === 'slot';
}
function isTemplateNode(node) {
    return (node.type === 1 /* ELEMENT */ && node.tagType === 3 /* TEMPLATE */);
}
function isSlotOutlet(node) {
    return node.type === 1 /* ELEMENT */ && node.tagType === 2 /* SLOT */;
}
function getVNodeHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
}
function getVNodeBlockHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
}
const propsHelperSet = new Set([NORMALIZE_PROPS, GUARD_REACTIVE_PROPS]);
function getUnnormalizedProps(props, callPath = []) {
    if (props &&
        !(0,shared_esm_bundler.isString)(props) &&
        props.type === 14 /* JS_CALL_EXPRESSION */) {
        const callee = props.callee;
        if (!(0,shared_esm_bundler.isString)(callee) && propsHelperSet.has(callee)) {
            return getUnnormalizedProps(props.arguments[0], callPath.concat(props));
        }
    }
    return [props, callPath];
}
function injectProp(node, prop, context) {
    let propsWithInjection;
    /**
     * 1. mergeProps(...)
     * 2. toHandlers(...)
     * 3. normalizeProps(...)
     * 4. normalizeProps(guardReactiveProps(...))
     *
     * we need to get the real props before normalization
     */
    let props = node.type === 13 /* VNODE_CALL */ ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props &&
        !(0,shared_esm_bundler.isString)(props) &&
        props.type === 14 /* JS_CALL_EXPRESSION */) {
        const ret = getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0,shared_esm_bundler.isString)(props)) {
        propsWithInjection = createObjectExpression([prop]);
    }
    else if (props.type === 14 /* JS_CALL_EXPRESSION */) {
        // merged props... add ours
        // only inject key to object literal if it's the first argument so that
        // if doesn't override user provided keys
        const first = props.arguments[0];
        if (!(0,shared_esm_bundler.isString)(first) && first.type === 15 /* JS_OBJECT_EXPRESSION */) {
            first.properties.unshift(prop);
        }
        else {
            if (props.callee === TO_HANDLERS) {
                // #2366
                propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
                    createObjectExpression([prop]),
                    props
                ]);
            }
            else {
                props.arguments.unshift(createObjectExpression([prop]));
            }
        }
        !propsWithInjection && (propsWithInjection = props);
    }
    else if (props.type === 15 /* JS_OBJECT_EXPRESSION */) {
        let alreadyExists = false;
        // check existing key to avoid overriding user provided keys
        if (prop.key.type === 4 /* SIMPLE_EXPRESSION */) {
            const propKeyName = prop.key.content;
            alreadyExists = props.properties.some(p => p.key.type === 4 /* SIMPLE_EXPRESSION */ &&
                p.key.content === propKeyName);
        }
        if (!alreadyExists) {
            props.properties.unshift(prop);
        }
        propsWithInjection = props;
    }
    else {
        // single v-bind with expression, return a merged replacement
        propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([prop]),
            props
        ]);
        // in the case of nested helper call, e.g. `normalizeProps(guardReactiveProps(props))`,
        // it will be rewritten as `normalizeProps(mergeProps({ key: 0 }, props))`,
        // the `guardReactiveProps` will no longer be needed
        if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) {
            parentCall = callPath[callPath.length - 2];
        }
    }
    if (node.type === 13 /* VNODE_CALL */) {
        if (parentCall) {
            parentCall.arguments[0] = propsWithInjection;
        }
        else {
            node.props = propsWithInjection;
        }
    }
    else {
        if (parentCall) {
            parentCall.arguments[0] = propsWithInjection;
        }
        else {
            node.arguments[2] = propsWithInjection;
        }
    }
}
function toValidAssetId(name, type) {
    // see issue#4422, we need adding identifier on validAssetId if variable `name` has specific character
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue) => {
        return searchValue === '-' ? '_' : name.charCodeAt(replaceValue).toString();
    })}`;
}
// Check if a node contains expressions that reference current context scope ids
function hasScopeRef(node, ids) {
    if (!node || Object.keys(ids).length === 0) {
        return false;
    }
    switch (node.type) {
        case 1 /* ELEMENT */:
            for (let i = 0; i < node.props.length; i++) {
                const p = node.props[i];
                if (p.type === 7 /* DIRECTIVE */ &&
                    (hasScopeRef(p.arg, ids) || hasScopeRef(p.exp, ids))) {
                    return true;
                }
            }
            return node.children.some(c => hasScopeRef(c, ids));
        case 11 /* FOR */:
            if (hasScopeRef(node.source, ids)) {
                return true;
            }
            return node.children.some(c => hasScopeRef(c, ids));
        case 9 /* IF */:
            return node.branches.some(b => hasScopeRef(b, ids));
        case 10 /* IF_BRANCH */:
            if (hasScopeRef(node.condition, ids)) {
                return true;
            }
            return node.children.some(c => hasScopeRef(c, ids));
        case 4 /* SIMPLE_EXPRESSION */:
            return (!node.isStatic &&
                isSimpleIdentifier(node.content) &&
                !!ids[node.content]);
        case 8 /* COMPOUND_EXPRESSION */:
            return node.children.some(c => (0,shared_esm_bundler.isObject)(c) && hasScopeRef(c, ids));
        case 5 /* INTERPOLATION */:
        case 12 /* TEXT_CALL */:
            return hasScopeRef(node.content, ids);
        case 2 /* TEXT */:
        case 3 /* COMMENT */:
            return false;
        default:
            if ((false)) {}
            return false;
    }
}
function getMemoedVNodeCall(node) {
    if (node.type === 14 /* JS_CALL_EXPRESSION */ && node.callee === WITH_MEMO) {
        return node.arguments[1].returns;
    }
    else {
        return node;
    }
}
function makeBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper(getVNodeHelper(inSSR, node.isComponent));
        helper(OPEN_BLOCK);
        helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
}

const deprecationData = {
    ["COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */]: {
        message: `Platform-native elements with "is" prop will no longer be ` +
            `treated as components in Vue 3 unless the "is" value is explicitly ` +
            `prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC" /* COMPILER_V_BIND_SYNC */]: {
        message: key => `.sync modifier for v-bind has been removed. Use v-model with ` +
            `argument instead. \`v-bind:${key}.sync\` should be changed to ` +
            `\`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_PROP" /* COMPILER_V_BIND_PROP */]: {
        message: `.prop modifier for v-bind has been removed and no longer necessary. ` +
            `Vue 3 will automatically set a binding as DOM property when appropriate.`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER" /* COMPILER_V_BIND_OBJECT_ORDER */]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript ` +
            `object spread: it will now overwrite an existing non-mergeable attribute ` +
            `that appears before v-bind in the case of conflict. ` +
            `To retain 2.x behavior, move v-bind to make it the first attribute. ` +
            `You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE" /* COMPILER_V_ON_NATIVE */]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE" /* COMPILER_V_IF_V_FOR_PRECEDENCE */]: {
        message: `v-if / v-for precedence when used on the same element has changed ` +
            `in Vue 3: v-if now takes higher precedence and will no longer have ` +
            `access to v-for scope variables. It is best to avoid the ambiguity ` +
            `with <template> tags or use a computed property that filters v-for ` +
            `data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE" /* COMPILER_NATIVE_TEMPLATE */]: {
        message: `<template> with no special directives will render as a native template ` +
            `element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE" /* COMPILER_INLINE_TEMPLATE */]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTER" /* COMPILER_FILTERS */]: {
        message: `filters have been removed in Vue 3. ` +
            `The "|" symbol will be treated as native JavaScript bitwise OR operator. ` +
            `Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function getCompatValue(key, context) {
    const config = context.options
        ? context.options.compatConfig
        : context.compatConfig;
    const value = config && config[key];
    if (key === 'MODE') {
        return value || 3; // compiler defaults to v3 behavior
    }
    else {
        return value;
    }
}
function isCompatEnabled(key, context) {
    const mode = getCompatValue('MODE', context);
    const value = getCompatValue(key, context);
    // in v3 mode, only enable if explicitly set to true
    // otherwise enable for any non-false value
    return mode === 3 ? value === true : value !== false;
}
function checkCompatEnabled(key, context, loc, ...args) {
    const enabled = isCompatEnabled(key, context);
    if (false) {}
    return enabled;
}
function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === 'suppress-warning') {
        return;
    }
    const { message, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === 'function' ? message(...args) : message}${link ? `\n  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc)
        err.loc = loc;
    context.onWarn(err);
}

// The default decoder only provides escapes for characters reserved as part of
// the template syntax, and is only used if the custom renderer did not provide
// a platform-specific decoder.
const decodeRE = /&(gt|lt|amp|apos|quot);/g;
const decodeMap = {
    gt: '>',
    lt: '<',
    amp: '&',
    apos: "'",
    quot: '"'
};
const defaultParserOptions = {
    delimiters: [`{{`, `}}`],
    getNamespace: () => 0 /* HTML */,
    getTextMode: () => 0 /* DATA */,
    isVoidTag: shared_esm_bundler.NO,
    isPreTag: shared_esm_bundler.NO,
    isCustomElement: shared_esm_bundler.NO,
    decodeEntities: (rawText) => rawText.replace(decodeRE, (_, p1) => decodeMap[p1]),
    onError: defaultOnError,
    onWarn: defaultOnWarn,
    comments: ("production" !== 'production')
};
function baseParse(content, options = {}) {
    const context = createParserContext(content, options);
    const start = getCursor(context);
    return createRoot(parseChildren(context, 0 /* DATA */, []), getSelection(context, start));
}
function createParserContext(content, rawOptions) {
    const options = (0,shared_esm_bundler.extend)({}, defaultParserOptions);
    let key;
    for (key in rawOptions) {
        // @ts-ignore
        options[key] =
            rawOptions[key] === undefined
                ? defaultParserOptions[key]
                : rawOptions[key];
    }
    return {
        options,
        column: 1,
        line: 1,
        offset: 0,
        originalSource: content,
        source: content,
        inPre: false,
        inVPre: false,
        onWarn: options.onWarn
    };
}
function parseChildren(context, mode, ancestors) {
    const parent = last(ancestors);
    const ns = parent ? parent.ns : 0 /* HTML */;
    const nodes = [];
    while (!isEnd(context, mode, ancestors)) {
        const s = context.source;
        let node = undefined;
        if (mode === 0 /* DATA */ || mode === 1 /* RCDATA */) {
            if (!context.inVPre && startsWith(s, context.options.delimiters[0])) {
                // '{{'
                node = parseInterpolation(context, mode);
            }
            else if (mode === 0 /* DATA */ && s[0] === '<') {
                // https://html.spec.whatwg.org/multipage/parsing.html#tag-open-state
                if (s.length === 1) {
                    emitError(context, 5 /* EOF_BEFORE_TAG_NAME */, 1);
                }
                else if (s[1] === '!') {
                    // https://html.spec.whatwg.org/multipage/parsing.html#markup-declaration-open-state
                    if (startsWith(s, '<!--')) {
                        node = parseComment(context);
                    }
                    else if (startsWith(s, '<!DOCTYPE')) {
                        // Ignore DOCTYPE by a limitation.
                        node = parseBogusComment(context);
                    }
                    else if (startsWith(s, '<![CDATA[')) {
                        if (ns !== 0 /* HTML */) {
                            node = parseCDATA(context, ancestors);
                        }
                        else {
                            emitError(context, 1 /* CDATA_IN_HTML_CONTENT */);
                            node = parseBogusComment(context);
                        }
                    }
                    else {
                        emitError(context, 11 /* INCORRECTLY_OPENED_COMMENT */);
                        node = parseBogusComment(context);
                    }
                }
                else if (s[1] === '/') {
                    // https://html.spec.whatwg.org/multipage/parsing.html#end-tag-open-state
                    if (s.length === 2) {
                        emitError(context, 5 /* EOF_BEFORE_TAG_NAME */, 2);
                    }
                    else if (s[2] === '>') {
                        emitError(context, 14 /* MISSING_END_TAG_NAME */, 2);
                        advanceBy(context, 3);
                        continue;
                    }
                    else if (/[a-z]/i.test(s[2])) {
                        emitError(context, 23 /* X_INVALID_END_TAG */);
                        parseTag(context, 1 /* End */, parent);
                        continue;
                    }
                    else {
                        emitError(context, 12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */, 2);
                        node = parseBogusComment(context);
                    }
                }
                else if (/[a-z]/i.test(s[1])) {
                    node = parseElement(context, ancestors);
                    // 2.x <template> with no directive compat
                    if (isCompatEnabled("COMPILER_NATIVE_TEMPLATE" /* COMPILER_NATIVE_TEMPLATE */, context) &&
                        node &&
                        node.tag === 'template' &&
                        !node.props.some(p => p.type === 7 /* DIRECTIVE */ &&
                            isSpecialTemplateDirective(p.name))) {
                        ( false) &&
                            0;
                        node = node.children;
                    }
                }
                else if (s[1] === '?') {
                    emitError(context, 21 /* UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME */, 1);
                    node = parseBogusComment(context);
                }
                else {
                    emitError(context, 12 /* INVALID_FIRST_CHARACTER_OF_TAG_NAME */, 1);
                }
            }
        }
        if (!node) {
            node = parseText(context, mode);
        }
        if ((0,shared_esm_bundler.isArray)(node)) {
            for (let i = 0; i < node.length; i++) {
                pushNode(nodes, node[i]);
            }
        }
        else {
            pushNode(nodes, node);
        }
    }
    // Whitespace handling strategy like v2
    let removedWhitespace = false;
    if (mode !== 2 /* RAWTEXT */ && mode !== 1 /* RCDATA */) {
        const shouldCondense = context.options.whitespace !== 'preserve';
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            if (!context.inPre && node.type === 2 /* TEXT */) {
                if (!/[^\t\r\n\f ]/.test(node.content)) {
                    const prev = nodes[i - 1];
                    const next = nodes[i + 1];
                    // Remove if:
                    // - the whitespace is the first or last node, or:
                    // - (condense mode) the whitespace is adjacent to a comment, or:
                    // - (condense mode) the whitespace is between two elements AND contains newline
                    if (!prev ||
                        !next ||
                        (shouldCondense &&
                            (prev.type === 3 /* COMMENT */ ||
                                next.type === 3 /* COMMENT */ ||
                                (prev.type === 1 /* ELEMENT */ &&
                                    next.type === 1 /* ELEMENT */ &&
                                    /[\r\n]/.test(node.content))))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    }
                    else {
                        // Otherwise, the whitespace is condensed into a single space
                        node.content = ' ';
                    }
                }
                else if (shouldCondense) {
                    // in condense mode, consecutive whitespaces in text are condensed
                    // down to a single space.
                    node.content = node.content.replace(/[\t\r\n\f ]+/g, ' ');
                }
            }
            // Remove comment nodes if desired by configuration.
            else if (node.type === 3 /* COMMENT */ && !context.options.comments) {
                removedWhitespace = true;
                nodes[i] = null;
            }
        }
        if (context.inPre && parent && context.options.isPreTag(parent.tag)) {
            // remove leading newline per html spec
            // https://html.spec.whatwg.org/multipage/grouping-content.html#the-pre-element
            const first = nodes[0];
            if (first && first.type === 2 /* TEXT */) {
                first.content = first.content.replace(/^\r?\n/, '');
            }
        }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function pushNode(nodes, node) {
    if (node.type === 2 /* TEXT */) {
        const prev = last(nodes);
        // Merge if both this and the previous node are text and those are
        // consecutive. This happens for cases like "a < b".
        if (prev &&
            prev.type === 2 /* TEXT */ &&
            prev.loc.end.offset === node.loc.start.offset) {
            prev.content += node.content;
            prev.loc.end = node.loc.end;
            prev.loc.source += node.loc.source;
            return;
        }
    }
    nodes.push(node);
}
function parseCDATA(context, ancestors) {
    advanceBy(context, 9);
    const nodes = parseChildren(context, 3 /* CDATA */, ancestors);
    if (context.source.length === 0) {
        emitError(context, 6 /* EOF_IN_CDATA */);
    }
    else {
        advanceBy(context, 3);
    }
    return nodes;
}
function parseComment(context) {
    const start = getCursor(context);
    let content;
    // Regular comment.
    const match = /--(\!)?>/.exec(context.source);
    if (!match) {
        content = context.source.slice(4);
        advanceBy(context, context.source.length);
        emitError(context, 7 /* EOF_IN_COMMENT */);
    }
    else {
        if (match.index <= 3) {
            emitError(context, 0 /* ABRUPT_CLOSING_OF_EMPTY_COMMENT */);
        }
        if (match[1]) {
            emitError(context, 10 /* INCORRECTLY_CLOSED_COMMENT */);
        }
        content = context.source.slice(4, match.index);
        // Advancing with reporting nested comments.
        const s = context.source.slice(0, match.index);
        let prevIndex = 1, nestedIndex = 0;
        while ((nestedIndex = s.indexOf('<!--', prevIndex)) !== -1) {
            advanceBy(context, nestedIndex - prevIndex + 1);
            if (nestedIndex + 4 < s.length) {
                emitError(context, 16 /* NESTED_COMMENT */);
            }
            prevIndex = nestedIndex + 1;
        }
        advanceBy(context, match.index + match[0].length - prevIndex + 1);
    }
    return {
        type: 3 /* COMMENT */,
        content,
        loc: getSelection(context, start)
    };
}
function parseBogusComment(context) {
    const start = getCursor(context);
    const contentStart = context.source[1] === '?' ? 1 : 2;
    let content;
    const closeIndex = context.source.indexOf('>');
    if (closeIndex === -1) {
        content = context.source.slice(contentStart);
        advanceBy(context, context.source.length);
    }
    else {
        content = context.source.slice(contentStart, closeIndex);
        advanceBy(context, closeIndex + 1);
    }
    return {
        type: 3 /* COMMENT */,
        content,
        loc: getSelection(context, start)
    };
}
function parseElement(context, ancestors) {
    // Start tag.
    const wasInPre = context.inPre;
    const wasInVPre = context.inVPre;
    const parent = last(ancestors);
    const element = parseTag(context, 0 /* Start */, parent);
    const isPreBoundary = context.inPre && !wasInPre;
    const isVPreBoundary = context.inVPre && !wasInVPre;
    if (element.isSelfClosing || context.options.isVoidTag(element.tag)) {
        // #4030 self-closing <pre> tag
        if (isPreBoundary) {
            context.inPre = false;
        }
        if (isVPreBoundary) {
            context.inVPre = false;
        }
        return element;
    }
    // Children.
    ancestors.push(element);
    const mode = context.options.getTextMode(element, parent);
    const children = parseChildren(context, mode, ancestors);
    ancestors.pop();
    // 2.x inline-template compat
    {
        const inlineTemplateProp = element.props.find(p => p.type === 6 /* ATTRIBUTE */ && p.name === 'inline-template');
        if (inlineTemplateProp &&
            checkCompatEnabled("COMPILER_INLINE_TEMPLATE" /* COMPILER_INLINE_TEMPLATE */, context, inlineTemplateProp.loc)) {
            const loc = getSelection(context, element.loc.end);
            inlineTemplateProp.value = {
                type: 2 /* TEXT */,
                content: loc.source,
                loc
            };
        }
    }
    element.children = children;
    // End tag.
    if (startsWithEndTagOpen(context.source, element.tag)) {
        parseTag(context, 1 /* End */, parent);
    }
    else {
        emitError(context, 24 /* X_MISSING_END_TAG */, 0, element.loc.start);
        if (context.source.length === 0 && element.tag.toLowerCase() === 'script') {
            const first = children[0];
            if (first && startsWith(first.loc.source, '<!--')) {
                emitError(context, 8 /* EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT */);
            }
        }
    }
    element.loc = getSelection(context, element.loc.start);
    if (isPreBoundary) {
        context.inPre = false;
    }
    if (isVPreBoundary) {
        context.inVPre = false;
    }
    return element;
}
const isSpecialTemplateDirective = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)(`if,else,else-if,for,slot`);
function parseTag(context, type, parent) {
    // Tag open.
    const start = getCursor(context);
    const match = /^<\/?([a-z][^\t\r\n\f />]*)/i.exec(context.source);
    const tag = match[1];
    const ns = context.options.getNamespace(tag, parent);
    advanceBy(context, match[0].length);
    advanceSpaces(context);
    // save current state in case we need to re-parse attributes with v-pre
    const cursor = getCursor(context);
    const currentSource = context.source;
    // check <pre> tag
    if (context.options.isPreTag(tag)) {
        context.inPre = true;
    }
    // Attributes.
    let props = parseAttributes(context, type);
    // check v-pre
    if (type === 0 /* Start */ &&
        !context.inVPre &&
        props.some(p => p.type === 7 /* DIRECTIVE */ && p.name === 'pre')) {
        context.inVPre = true;
        // reset context
        (0,shared_esm_bundler.extend)(context, cursor);
        context.source = currentSource;
        // re-parse attrs and filter out v-pre itself
        props = parseAttributes(context, type).filter(p => p.name !== 'v-pre');
    }
    // Tag close.
    let isSelfClosing = false;
    if (context.source.length === 0) {
        emitError(context, 9 /* EOF_IN_TAG */);
    }
    else {
        isSelfClosing = startsWith(context.source, '/>');
        if (type === 1 /* End */ && isSelfClosing) {
            emitError(context, 4 /* END_TAG_WITH_TRAILING_SOLIDUS */);
        }
        advanceBy(context, isSelfClosing ? 2 : 1);
    }
    if (type === 1 /* End */) {
        return;
    }
    // 2.x deprecation checks
    if (false) {}
    let tagType = 0 /* ELEMENT */;
    if (!context.inVPre) {
        if (tag === 'slot') {
            tagType = 2 /* SLOT */;
        }
        else if (tag === 'template') {
            if (props.some(p => p.type === 7 /* DIRECTIVE */ && isSpecialTemplateDirective(p.name))) {
                tagType = 3 /* TEMPLATE */;
            }
        }
        else if (isComponent(tag, props, context)) {
            tagType = 1 /* COMPONENT */;
        }
    }
    return {
        type: 1 /* ELEMENT */,
        ns,
        tag,
        tagType,
        props,
        isSelfClosing,
        children: [],
        loc: getSelection(context, start),
        codegenNode: undefined // to be created during transform phase
    };
}
function isComponent(tag, props, context) {
    const options = context.options;
    if (options.isCustomElement(tag)) {
        return false;
    }
    if (tag === 'component' ||
        /^[A-Z]/.test(tag) ||
        isCoreComponent(tag) ||
        (options.isBuiltInComponent && options.isBuiltInComponent(tag)) ||
        (options.isNativeTag && !options.isNativeTag(tag))) {
        return true;
    }
    // at this point the tag should be a native tag, but check for potential "is"
    // casting
    for (let i = 0; i < props.length; i++) {
        const p = props[i];
        if (p.type === 6 /* ATTRIBUTE */) {
            if (p.name === 'is' && p.value) {
                if (p.value.content.startsWith('vue:')) {
                    return true;
                }
                else if (checkCompatEnabled("COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */, context, p.loc)) {
                    return true;
                }
            }
        }
        else {
            // directive
            // v-is (TODO Deprecate)
            if (p.name === 'is') {
                return true;
            }
            else if (
            // :is on plain element - only treat as component in compat mode
            p.name === 'bind' &&
                isStaticArgOf(p.arg, 'is') &&
                true &&
                checkCompatEnabled("COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */, context, p.loc)) {
                return true;
            }
        }
    }
}
function parseAttributes(context, type) {
    const props = [];
    const attributeNames = new Set();
    while (context.source.length > 0 &&
        !startsWith(context.source, '>') &&
        !startsWith(context.source, '/>')) {
        if (startsWith(context.source, '/')) {
            emitError(context, 22 /* UNEXPECTED_SOLIDUS_IN_TAG */);
            advanceBy(context, 1);
            advanceSpaces(context);
            continue;
        }
        if (type === 1 /* End */) {
            emitError(context, 3 /* END_TAG_WITH_ATTRIBUTES */);
        }
        const attr = parseAttribute(context, attributeNames);
        // Trim whitespace between class
        // https://github.com/vuejs/core/issues/4251
        if (attr.type === 6 /* ATTRIBUTE */ &&
            attr.value &&
            attr.name === 'class') {
            attr.value.content = attr.value.content.replace(/\s+/g, ' ').trim();
        }
        if (type === 0 /* Start */) {
            props.push(attr);
        }
        if (/^[^\t\r\n\f />]/.test(context.source)) {
            emitError(context, 15 /* MISSING_WHITESPACE_BETWEEN_ATTRIBUTES */);
        }
        advanceSpaces(context);
    }
    return props;
}
function parseAttribute(context, nameSet) {
    // Name.
    const start = getCursor(context);
    const match = /^[^\t\r\n\f />][^\t\r\n\f />=]*/.exec(context.source);
    const name = match[0];
    if (nameSet.has(name)) {
        emitError(context, 2 /* DUPLICATE_ATTRIBUTE */);
    }
    nameSet.add(name);
    if (name[0] === '=') {
        emitError(context, 19 /* UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME */);
    }
    {
        const pattern = /["'<]/g;
        let m;
        while ((m = pattern.exec(name))) {
            emitError(context, 17 /* UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME */, m.index);
        }
    }
    advanceBy(context, name.length);
    // Value
    let value = undefined;
    if (/^[\t\r\n\f ]*=/.test(context.source)) {
        advanceSpaces(context);
        advanceBy(context, 1);
        advanceSpaces(context);
        value = parseAttributeValue(context);
        if (!value) {
            emitError(context, 13 /* MISSING_ATTRIBUTE_VALUE */);
        }
    }
    const loc = getSelection(context, start);
    if (!context.inVPre && /^(v-[A-Za-z0-9-]|:|\.|@|#)/.test(name)) {
        const match = /(?:^v-([a-z0-9-]+))?(?:(?::|^\.|^@|^#)(\[[^\]]+\]|[^\.]+))?(.+)?$/i.exec(name);
        let isPropShorthand = startsWith(name, '.');
        let dirName = match[1] ||
            (isPropShorthand || startsWith(name, ':')
                ? 'bind'
                : startsWith(name, '@')
                    ? 'on'
                    : 'slot');
        let arg;
        if (match[2]) {
            const isSlot = dirName === 'slot';
            const startOffset = name.lastIndexOf(match[2]);
            const loc = getSelection(context, getNewPosition(context, start, startOffset), getNewPosition(context, start, startOffset + match[2].length + ((isSlot && match[3]) || '').length));
            let content = match[2];
            let isStatic = true;
            if (content.startsWith('[')) {
                isStatic = false;
                if (!content.endsWith(']')) {
                    emitError(context, 27 /* X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END */);
                    content = content.slice(1);
                }
                else {
                    content = content.slice(1, content.length - 1);
                }
            }
            else if (isSlot) {
                // #1241 special case for v-slot: vuetify relies extensively on slot
                // names containing dots. v-slot doesn't have any modifiers and Vue 2.x
                // supports such usage so we are keeping it consistent with 2.x.
                content += match[3] || '';
            }
            arg = {
                type: 4 /* SIMPLE_EXPRESSION */,
                content,
                isStatic,
                constType: isStatic
                    ? 3 /* CAN_STRINGIFY */
                    : 0 /* NOT_CONSTANT */,
                loc
            };
        }
        if (value && value.isQuoted) {
            const valueLoc = value.loc;
            valueLoc.start.offset++;
            valueLoc.start.column++;
            valueLoc.end = advancePositionWithClone(valueLoc.start, value.content);
            valueLoc.source = valueLoc.source.slice(1, -1);
        }
        const modifiers = match[3] ? match[3].slice(1).split('.') : [];
        if (isPropShorthand)
            modifiers.push('prop');
        // 2.x compat v-bind:foo.sync -> v-model:foo
        if (dirName === 'bind' && arg) {
            if (modifiers.includes('sync') &&
                checkCompatEnabled("COMPILER_V_BIND_SYNC" /* COMPILER_V_BIND_SYNC */, context, loc, arg.loc.source)) {
                dirName = 'model';
                modifiers.splice(modifiers.indexOf('sync'), 1);
            }
            if (false) {}
        }
        return {
            type: 7 /* DIRECTIVE */,
            name: dirName,
            exp: value && {
                type: 4 /* SIMPLE_EXPRESSION */,
                content: value.content,
                isStatic: false,
                // Treat as non-constant by default. This can be potentially set to
                // other values by `transformExpression` to make it eligible for hoisting.
                constType: 0 /* NOT_CONSTANT */,
                loc: value.loc
            },
            arg,
            modifiers,
            loc
        };
    }
    // missing directive name or illegal directive name
    if (!context.inVPre && startsWith(name, 'v-')) {
        emitError(context, 26 /* X_MISSING_DIRECTIVE_NAME */);
    }
    return {
        type: 6 /* ATTRIBUTE */,
        name,
        value: value && {
            type: 2 /* TEXT */,
            content: value.content,
            loc: value.loc
        },
        loc
    };
}
function parseAttributeValue(context) {
    const start = getCursor(context);
    let content;
    const quote = context.source[0];
    const isQuoted = quote === `"` || quote === `'`;
    if (isQuoted) {
        // Quoted value.
        advanceBy(context, 1);
        const endIndex = context.source.indexOf(quote);
        if (endIndex === -1) {
            content = parseTextData(context, context.source.length, 4 /* ATTRIBUTE_VALUE */);
        }
        else {
            content = parseTextData(context, endIndex, 4 /* ATTRIBUTE_VALUE */);
            advanceBy(context, 1);
        }
    }
    else {
        // Unquoted
        const match = /^[^\t\r\n\f >]+/.exec(context.source);
        if (!match) {
            return undefined;
        }
        const unexpectedChars = /["'<=`]/g;
        let m;
        while ((m = unexpectedChars.exec(match[0]))) {
            emitError(context, 18 /* UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE */, m.index);
        }
        content = parseTextData(context, match[0].length, 4 /* ATTRIBUTE_VALUE */);
    }
    return { content, isQuoted, loc: getSelection(context, start) };
}
function parseInterpolation(context, mode) {
    const [open, close] = context.options.delimiters;
    const closeIndex = context.source.indexOf(close, open.length);
    if (closeIndex === -1) {
        emitError(context, 25 /* X_MISSING_INTERPOLATION_END */);
        return undefined;
    }
    const start = getCursor(context);
    advanceBy(context, open.length);
    const innerStart = getCursor(context);
    const innerEnd = getCursor(context);
    const rawContentLength = closeIndex - open.length;
    const rawContent = context.source.slice(0, rawContentLength);
    const preTrimContent = parseTextData(context, rawContentLength, mode);
    const content = preTrimContent.trim();
    const startOffset = preTrimContent.indexOf(content);
    if (startOffset > 0) {
        advancePositionWithMutation(innerStart, rawContent, startOffset);
    }
    const endOffset = rawContentLength - (preTrimContent.length - content.length - startOffset);
    advancePositionWithMutation(innerEnd, rawContent, endOffset);
    advanceBy(context, close.length);
    return {
        type: 5 /* INTERPOLATION */,
        content: {
            type: 4 /* SIMPLE_EXPRESSION */,
            isStatic: false,
            // Set `isConstant` to false by default and will decide in transformExpression
            constType: 0 /* NOT_CONSTANT */,
            content,
            loc: getSelection(context, innerStart, innerEnd)
        },
        loc: getSelection(context, start)
    };
}
function parseText(context, mode) {
    const endTokens = mode === 3 /* CDATA */ ? [']]>'] : ['<', context.options.delimiters[0]];
    let endIndex = context.source.length;
    for (let i = 0; i < endTokens.length; i++) {
        const index = context.source.indexOf(endTokens[i], 1);
        if (index !== -1 && endIndex > index) {
            endIndex = index;
        }
    }
    const start = getCursor(context);
    const content = parseTextData(context, endIndex, mode);
    return {
        type: 2 /* TEXT */,
        content,
        loc: getSelection(context, start)
    };
}
/**
 * Get text data with a given length from the current location.
 * This translates HTML entities in the text data.
 */
function parseTextData(context, length, mode) {
    const rawText = context.source.slice(0, length);
    advanceBy(context, length);
    if (mode === 2 /* RAWTEXT */ ||
        mode === 3 /* CDATA */ ||
        !rawText.includes('&')) {
        return rawText;
    }
    else {
        // DATA or RCDATA containing "&"". Entity decoding required.
        return context.options.decodeEntities(rawText, mode === 4 /* ATTRIBUTE_VALUE */);
    }
}
function getCursor(context) {
    const { column, line, offset } = context;
    return { column, line, offset };
}
function getSelection(context, start, end) {
    end = end || getCursor(context);
    return {
        start,
        end,
        source: context.originalSource.slice(start.offset, end.offset)
    };
}
function last(xs) {
    return xs[xs.length - 1];
}
function startsWith(source, searchString) {
    return source.startsWith(searchString);
}
function advanceBy(context, numberOfCharacters) {
    const { source } = context;
    advancePositionWithMutation(context, source, numberOfCharacters);
    context.source = source.slice(numberOfCharacters);
}
function advanceSpaces(context) {
    const match = /^[\t\r\n\f ]+/.exec(context.source);
    if (match) {
        advanceBy(context, match[0].length);
    }
}
function getNewPosition(context, start, numberOfCharacters) {
    return advancePositionWithClone(start, context.originalSource.slice(start.offset, numberOfCharacters), numberOfCharacters);
}
function emitError(context, code, offset, loc = getCursor(context)) {
    if (offset) {
        loc.offset += offset;
        loc.column += offset;
    }
    context.options.onError(createCompilerError(code, {
        start: loc,
        end: loc,
        source: ''
    }));
}
function isEnd(context, mode, ancestors) {
    const s = context.source;
    switch (mode) {
        case 0 /* DATA */:
            if (startsWith(s, '</')) {
                // TODO: probably bad performance
                for (let i = ancestors.length - 1; i >= 0; --i) {
                    if (startsWithEndTagOpen(s, ancestors[i].tag)) {
                        return true;
                    }
                }
            }
            break;
        case 1 /* RCDATA */:
        case 2 /* RAWTEXT */: {
            const parent = last(ancestors);
            if (parent && startsWithEndTagOpen(s, parent.tag)) {
                return true;
            }
            break;
        }
        case 3 /* CDATA */:
            if (startsWith(s, ']]>')) {
                return true;
            }
            break;
    }
    return !s;
}
function startsWithEndTagOpen(source, tag) {
    return (startsWith(source, '</') &&
        source.slice(2, 2 + tag.length).toLowerCase() === tag.toLowerCase() &&
        /[\t\r\n\f />]/.test(source[2 + tag.length] || '>'));
}

function hoistStatic(root, context) {
    walk(root, context, 
    // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    isSingleElementRoot(root, root.children[0]));
}
function isSingleElementRoot(root, child) {
    const { children } = root;
    return (children.length === 1 &&
        child.type === 1 /* ELEMENT */ &&
        !isSlotOutlet(child));
}
function walk(node, context, doNotHoistNode = false) {
    const { children } = node;
    const originalCount = children.length;
    let hoistedCount = 0;
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        // only plain elements & text calls are eligible for hoisting.
        if (child.type === 1 /* ELEMENT */ &&
            child.tagType === 0 /* ELEMENT */) {
            const constantType = doNotHoistNode
                ? 0 /* NOT_CONSTANT */
                : getConstantType(child, context);
            if (constantType > 0 /* NOT_CONSTANT */) {
                if (constantType >= 2 /* CAN_HOIST */) {
                    child.codegenNode.patchFlag =
                        -1 /* HOISTED */ + (( false) ? 0 : ``);
                    child.codegenNode = context.hoist(child.codegenNode);
                    hoistedCount++;
                    continue;
                }
            }
            else {
                // node may contain dynamic children, but its props may be eligible for
                // hoisting.
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13 /* VNODE_CALL */) {
                    const flag = getPatchFlag(codegenNode);
                    if ((!flag ||
                        flag === 512 /* NEED_PATCH */ ||
                        flag === 1 /* TEXT */) &&
                        getGeneratedPropsConstantType(child, context) >=
                            2 /* CAN_HOIST */) {
                        const props = getNodeProps(child);
                        if (props) {
                            codegenNode.props = context.hoist(props);
                        }
                    }
                    if (codegenNode.dynamicProps) {
                        codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                    }
                }
            }
        }
        else if (child.type === 12 /* TEXT_CALL */ &&
            getConstantType(child.content, context) >= 2 /* CAN_HOIST */) {
            child.codegenNode = context.hoist(child.codegenNode);
            hoistedCount++;
        }
        // walk further
        if (child.type === 1 /* ELEMENT */) {
            const isComponent = child.tagType === 1 /* COMPONENT */;
            if (isComponent) {
                context.scopes.vSlot++;
            }
            walk(child, context);
            if (isComponent) {
                context.scopes.vSlot--;
            }
        }
        else if (child.type === 11 /* FOR */) {
            // Do not hoist v-for single child because it has to be a block
            walk(child, context, child.children.length === 1);
        }
        else if (child.type === 9 /* IF */) {
            for (let i = 0; i < child.branches.length; i++) {
                // Do not hoist v-if single child because it has to be a block
                walk(child.branches[i], context, child.branches[i].children.length === 1);
            }
        }
    }
    if (hoistedCount && context.transformHoist) {
        context.transformHoist(children, context, node);
    }
    // all children were hoisted - the entire children array is hoistable.
    if (hoistedCount &&
        hoistedCount === originalCount &&
        node.type === 1 /* ELEMENT */ &&
        node.tagType === 0 /* ELEMENT */ &&
        node.codegenNode &&
        node.codegenNode.type === 13 /* VNODE_CALL */ &&
        (0,shared_esm_bundler.isArray)(node.codegenNode.children)) {
        node.codegenNode.children = context.hoist(createArrayExpression(node.codegenNode.children));
    }
}
function getConstantType(node, context) {
    const { constantCache } = context;
    switch (node.type) {
        case 1 /* ELEMENT */:
            if (node.tagType !== 0 /* ELEMENT */) {
                return 0 /* NOT_CONSTANT */;
            }
            const cached = constantCache.get(node);
            if (cached !== undefined) {
                return cached;
            }
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13 /* VNODE_CALL */) {
                return 0 /* NOT_CONSTANT */;
            }
            if (codegenNode.isBlock &&
                node.tag !== 'svg' &&
                node.tag !== 'foreignObject') {
                return 0 /* NOT_CONSTANT */;
            }
            const flag = getPatchFlag(codegenNode);
            if (!flag) {
                let returnType = 3 /* CAN_STRINGIFY */;
                // Element itself has no patch flag. However we still need to check:
                // 1. Even for a node with no patch flag, it is possible for it to contain
                // non-hoistable expressions that refers to scope variables, e.g. compiler
                // injected keys or cached event handlers. Therefore we need to always
                // check the codegenNode's props to be sure.
                const generatedPropsType = getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0 /* NOT_CONSTANT */) {
                    constantCache.set(node, 0 /* NOT_CONSTANT */);
                    return 0 /* NOT_CONSTANT */;
                }
                if (generatedPropsType < returnType) {
                    returnType = generatedPropsType;
                }
                // 2. its children.
                for (let i = 0; i < node.children.length; i++) {
                    const childType = getConstantType(node.children[i], context);
                    if (childType === 0 /* NOT_CONSTANT */) {
                        constantCache.set(node, 0 /* NOT_CONSTANT */);
                        return 0 /* NOT_CONSTANT */;
                    }
                    if (childType < returnType) {
                        returnType = childType;
                    }
                }
                // 3. if the type is not already CAN_SKIP_PATCH which is the lowest non-0
                // type, check if any of the props can cause the type to be lowered
                // we can skip can_patch because it's guaranteed by the absence of a
                // patchFlag.
                if (returnType > 1 /* CAN_SKIP_PATCH */) {
                    for (let i = 0; i < node.props.length; i++) {
                        const p = node.props[i];
                        if (p.type === 7 /* DIRECTIVE */ && p.name === 'bind' && p.exp) {
                            const expType = getConstantType(p.exp, context);
                            if (expType === 0 /* NOT_CONSTANT */) {
                                constantCache.set(node, 0 /* NOT_CONSTANT */);
                                return 0 /* NOT_CONSTANT */;
                            }
                            if (expType < returnType) {
                                returnType = expType;
                            }
                        }
                    }
                }
                // only svg/foreignObject could be block here, however if they are
                // static then they don't need to be blocks since there will be no
                // nested updates.
                if (codegenNode.isBlock) {
                    context.removeHelper(OPEN_BLOCK);
                    context.removeHelper(getVNodeBlockHelper(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType);
                return returnType;
            }
            else {
                constantCache.set(node, 0 /* NOT_CONSTANT */);
                return 0 /* NOT_CONSTANT */;
            }
        case 2 /* TEXT */:
        case 3 /* COMMENT */:
            return 3 /* CAN_STRINGIFY */;
        case 9 /* IF */:
        case 11 /* FOR */:
        case 10 /* IF_BRANCH */:
            return 0 /* NOT_CONSTANT */;
        case 5 /* INTERPOLATION */:
        case 12 /* TEXT_CALL */:
            return getConstantType(node.content, context);
        case 4 /* SIMPLE_EXPRESSION */:
            return node.constType;
        case 8 /* COMPOUND_EXPRESSION */:
            let returnType = 3 /* CAN_STRINGIFY */;
            for (let i = 0; i < node.children.length; i++) {
                const child = node.children[i];
                if ((0,shared_esm_bundler.isString)(child) || (0,shared_esm_bundler.isSymbol)(child)) {
                    continue;
                }
                const childType = getConstantType(child, context);
                if (childType === 0 /* NOT_CONSTANT */) {
                    return 0 /* NOT_CONSTANT */;
                }
                else if (childType < returnType) {
                    returnType = childType;
                }
            }
            return returnType;
        default:
            if ((false)) {}
            return 0 /* NOT_CONSTANT */;
    }
}
const allowHoistedHelperSet = new Set([
    NORMALIZE_CLASS,
    NORMALIZE_STYLE,
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 /* JS_CALL_EXPRESSION */ &&
        !(0,shared_esm_bundler.isString)(value.callee) &&
        allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
            return getConstantType(arg, context);
        }
        else if (arg.type === 14 /* JS_CALL_EXPRESSION */) {
            // in the case of nested helper call, e.g. `normalizeProps(guardReactiveProps(exp))`
            return getConstantTypeOfHelperCall(arg, context);
        }
    }
    return 0 /* NOT_CONSTANT */;
}
function getGeneratedPropsConstantType(node, context) {
    let returnType = 3 /* CAN_STRINGIFY */;
    const props = getNodeProps(node);
    if (props && props.type === 15 /* JS_OBJECT_EXPRESSION */) {
        const { properties } = props;
        for (let i = 0; i < properties.length; i++) {
            const { key, value } = properties[i];
            const keyType = getConstantType(key, context);
            if (keyType === 0 /* NOT_CONSTANT */) {
                return keyType;
            }
            if (keyType < returnType) {
                returnType = keyType;
            }
            let valueType;
            if (value.type === 4 /* SIMPLE_EXPRESSION */) {
                valueType = getConstantType(value, context);
            }
            else if (value.type === 14 /* JS_CALL_EXPRESSION */) {
                // some helper calls can be hoisted,
                // such as the `normalizeProps` generated by the compiler for pre-normalize class,
                // in this case we need to respect the ConstantType of the helper's arguments
                valueType = getConstantTypeOfHelperCall(value, context);
            }
            else {
                valueType = 0 /* NOT_CONSTANT */;
            }
            if (valueType === 0 /* NOT_CONSTANT */) {
                return valueType;
            }
            if (valueType < returnType) {
                returnType = valueType;
            }
        }
    }
    return returnType;
}
function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13 /* VNODE_CALL */) {
        return codegenNode.props;
    }
}
function getPatchFlag(node) {
    const flag = node.patchFlag;
    return flag ? parseInt(flag, 10) : undefined;
}

function createTransformContext(root, { filename = '', prefixIdentifiers = false, hoistStatic = false, cacheHandlers = false, nodeTransforms = [], directiveTransforms = {}, transformHoist = null, isBuiltInComponent = shared_esm_bundler.NOOP, isCustomElement = shared_esm_bundler.NOOP, expressionPlugins = [], scopeId = null, slotted = true, ssr = false, inSSR = false, ssrCssVars = ``, bindingMetadata = shared_esm_bundler.EMPTY_OBJ, inline = false, isTS = false, onError = defaultOnError, onWarn = defaultOnWarn, compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, '').match(/([^/\\]+)\.\w+$/);
    const context = {
        // options
        selfName: nameMatch && (0,shared_esm_bundler.capitalize)((0,shared_esm_bundler.camelize)(nameMatch[1])),
        prefixIdentifiers,
        hoistStatic,
        cacheHandlers,
        nodeTransforms,
        directiveTransforms,
        transformHoist,
        isBuiltInComponent,
        isCustomElement,
        expressionPlugins,
        scopeId,
        slotted,
        ssr,
        inSSR,
        ssrCssVars,
        bindingMetadata,
        inline,
        isTS,
        onError,
        onWarn,
        compatConfig,
        // state
        root,
        helpers: new Map(),
        components: new Set(),
        directives: new Set(),
        hoists: [],
        imports: [],
        constantCache: new Map(),
        temps: 0,
        cached: 0,
        identifiers: Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper(name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper(name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) {
                    context.helpers.delete(name);
                }
                else {
                    context.helpers.set(name, currentCount);
                }
            }
        },
        helperString(name) {
            return `_${helperNameMap[context.helper(name)]}`;
        },
        replaceNode(node) {
            /* istanbul ignore if */
            if ((false)) {}
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode(node) {
            if (false) {}
            const list = context.parent.children;
            const removalIndex = node
                ? list.indexOf(node)
                : context.currentNode
                    ? context.childIndex
                    : -1;
            /* istanbul ignore if */
            if (false) {}
            if (!node || node === context.currentNode) {
                // current node removed
                context.currentNode = null;
                context.onNodeRemoved();
            }
            else {
                // sibling node removed
                if (context.childIndex > removalIndex) {
                    context.childIndex--;
                    context.onNodeRemoved();
                }
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: () => { },
        addIdentifiers(exp) {
        },
        removeIdentifiers(exp) {
        },
        hoist(exp) {
            if ((0,shared_esm_bundler.isString)(exp))
                exp = createSimpleExpression(exp);
            context.hoists.push(exp);
            const identifier = createSimpleExpression(`_hoisted_${context.hoists.length}`, false, exp.loc, 2 /* CAN_HOIST */);
            identifier.hoisted = exp;
            return identifier;
        },
        cache(exp, isVNode = false) {
            return createCacheExpression(context.cached++, exp, isVNode);
        }
    };
    {
        context.filters = new Set();
    }
    return context;
}
function transform(root, options) {
    const context = createTransformContext(root, options);
    traverseNode(root, context);
    if (options.hoistStatic) {
        hoistStatic(root, context);
    }
    if (!options.ssr) {
        createRootCodegen(root, context);
    }
    // finalize meta information
    root.helpers = [...context.helpers.keys()];
    root.components = [...context.components];
    root.directives = [...context.directives];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    {
        root.filters = [...context.filters];
    }
}
function createRootCodegen(root, context) {
    const { helper } = context;
    const { children } = root;
    if (children.length === 1) {
        const child = children[0];
        // if the single child is an element, turn it into a block.
        if (isSingleElementRoot(root, child) && child.codegenNode) {
            // single element root is never hoisted so codegenNode will never be
            // SimpleExpressionNode
            const codegenNode = child.codegenNode;
            if (codegenNode.type === 13 /* VNODE_CALL */) {
                makeBlock(codegenNode, context);
            }
            root.codegenNode = codegenNode;
        }
        else {
            // - single <slot/>, IfNode, ForNode: already blocks.
            // - single text node: always patched.
            // root codegen falls through via genNode()
            root.codegenNode = child;
        }
    }
    else if (children.length > 1) {
        // root has multiple nodes - return a fragment block.
        let patchFlag = 64 /* STABLE_FRAGMENT */;
        let patchFlagText = shared_esm_bundler.PatchFlagNames[64];
        // check if the fragment actually contains a single valid child with
        // the rest being comments
        if (false) {}
        root.codegenNode = createVNodeCall(context, helper(FRAGMENT), undefined, root.children, patchFlag + (( false) ? 0 : ``), undefined, undefined, true, undefined, false /* isComponent */);
    }
    else ;
}
function traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = () => {
        i--;
    };
    for (; i < parent.children.length; i++) {
        const child = parent.children[i];
        if ((0,shared_esm_bundler.isString)(child))
            continue;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        traverseNode(child, context);
    }
}
function traverseNode(node, context) {
    context.currentNode = node;
    // apply transform plugins
    const { nodeTransforms } = context;
    const exitFns = [];
    for (let i = 0; i < nodeTransforms.length; i++) {
        const onExit = nodeTransforms[i](node, context);
        if (onExit) {
            if ((0,shared_esm_bundler.isArray)(onExit)) {
                exitFns.push(...onExit);
            }
            else {
                exitFns.push(onExit);
            }
        }
        if (!context.currentNode) {
            // node was removed
            return;
        }
        else {
            // node may have been replaced
            node = context.currentNode;
        }
    }
    switch (node.type) {
        case 3 /* COMMENT */:
            if (!context.ssr) {
                // inject import for the Comment symbol, which is needed for creating
                // comment nodes with `createVNode`
                context.helper(CREATE_COMMENT);
            }
            break;
        case 5 /* INTERPOLATION */:
            // no need to traverse, but we need to inject toString helper
            if (!context.ssr) {
                context.helper(TO_DISPLAY_STRING);
            }
            break;
        // for container types, further traverse downwards
        case 9 /* IF */:
            for (let i = 0; i < node.branches.length; i++) {
                traverseNode(node.branches[i], context);
            }
            break;
        case 10 /* IF_BRANCH */:
        case 11 /* FOR */:
        case 1 /* ELEMENT */:
        case 0 /* ROOT */:
            traverseChildren(node, context);
            break;
    }
    // exit transforms
    context.currentNode = node;
    let i = exitFns.length;
    while (i--) {
        exitFns[i]();
    }
}
function createStructuralDirectiveTransform(name, fn) {
    const matches = (0,shared_esm_bundler.isString)(name)
        ? (n) => n === name
        : (n) => name.test(n);
    return (node, context) => {
        if (node.type === 1 /* ELEMENT */) {
            const { props } = node;
            // structural directive transforms are not concerned with slots
            // as they are handled separately in vSlot.ts
            if (node.tagType === 3 /* TEMPLATE */ && props.some(isVSlot)) {
                return;
            }
            const exitFns = [];
            for (let i = 0; i < props.length; i++) {
                const prop = props[i];
                if (prop.type === 7 /* DIRECTIVE */ && matches(prop.name)) {
                    // structural directives are removed to avoid infinite recursion
                    // also we remove them *before* applying so that it can further
                    // traverse itself in case it moves the node around
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit)
                        exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}

const PURE_ANNOTATION = `/*#__PURE__*/`;
function createCodegenContext(ast, { mode = 'function', prefixIdentifiers = mode === 'module', sourceMap = false, filename = `template.vue.html`, scopeId = null, optimizeImports = false, runtimeGlobalName = `Vue`, runtimeModuleName = `vue`, ssrRuntimeModuleName = 'vue/server-renderer', ssr = false, isTS = false, inSSR = false }) {
    const context = {
        mode,
        prefixIdentifiers,
        sourceMap,
        filename,
        scopeId,
        optimizeImports,
        runtimeGlobalName,
        runtimeModuleName,
        ssrRuntimeModuleName,
        ssr,
        isTS,
        inSSR,
        source: ast.loc.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: undefined,
        helper(key) {
            return `_${helperNameMap[key]}`;
        },
        push(code, node) {
            context.code += code;
        },
        indent() {
            newline(++context.indentLevel);
        },
        deindent(withoutNewLine = false) {
            if (withoutNewLine) {
                --context.indentLevel;
            }
            else {
                newline(--context.indentLevel);
            }
        },
        newline() {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push('\n' + `  `.repeat(n));
    }
    return context;
}
function generate(ast, options = {}) {
    const context = createCodegenContext(ast, options);
    if (options.onContextCreated)
        options.onContextCreated(context);
    const { mode, push, prefixIdentifiers, indent, deindent, newline, scopeId, ssr } = context;
    const hasHelpers = ast.helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== 'module';
    // preambles
    // in setup() inline mode, the preamble is generated in a sub context
    // and returned separately.
    const preambleContext = context;
    {
        genFunctionPreamble(ast, preambleContext);
    }
    // enter render function
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? ['_ctx', '_push', '_parent', '_attrs'] : ['_ctx', '_cache'];
    const signature = args.join(', ');
    {
        push(`function ${functionName}(${signature}) {`);
    }
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        // function mode const declarations should be inside with block
        // also they should be renamed to avoid collision with user properties
        if (hasHelpers) {
            push(`const { ${ast.helpers
                .map(s => `${helperNameMap[s]}: _${helperNameMap[s]}`)
                .join(', ')} } = _Vue`);
            push(`\n`);
            newline();
        }
    }
    // generate asset resolution statements
    if (ast.components.length) {
        genAssets(ast.components, 'component', context);
        if (ast.directives.length || ast.temps > 0) {
            newline();
        }
    }
    if (ast.directives.length) {
        genAssets(ast.directives, 'directive', context);
        if (ast.temps > 0) {
            newline();
        }
    }
    if (ast.filters && ast.filters.length) {
        newline();
        genAssets(ast.filters, 'filter', context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for (let i = 0; i < ast.temps; i++) {
            push(`${i > 0 ? `, ` : ``}_temp${i}`);
        }
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`\n`);
        newline();
    }
    // generate the VNode tree expression
    if (!ssr) {
        push(`return `);
    }
    if (ast.codegenNode) {
        genNode(ast.codegenNode, context);
    }
    else {
        push(`null`);
    }
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast,
        code: context.code,
        preamble: ``,
        // SourceMapGenerator does have toJSON() method but it's not in the types
        map: context.map ? context.map.toJSON() : undefined
    };
}
function genFunctionPreamble(ast, context) {
    const { ssr, prefixIdentifiers, push, newline, runtimeModuleName, runtimeGlobalName, ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const aliasHelper = (s) => `${helperNameMap[s]}: _${helperNameMap[s]}`;
    // Generate const declaration for helpers
    // In prefix mode, we place the const declaration at top so it's done
    // only once; But if we not prefixing, we place the declaration inside the
    // with block so it doesn't incur the `in` check cost for every helper access.
    if (ast.helpers.length > 0) {
        {
            // "with" mode.
            // save Vue in a separate variable to avoid collision
            push(`const _Vue = ${VueBinding}\n`);
            // in "with" mode, helpers are declared inside the with block to avoid
            // has check cost, but hoists are lifted out of the function - we need
            // to provide the helper here.
            if (ast.hoists.length) {
                const staticHelpers = [
                    CREATE_VNODE,
                    CREATE_ELEMENT_VNODE,
                    CREATE_COMMENT,
                    CREATE_TEXT,
                    CREATE_STATIC
                ]
                    .filter(helper => ast.helpers.includes(helper))
                    .map(aliasHelper)
                    .join(', ');
                push(`const { ${staticHelpers} } = _Vue\n`);
            }
        }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(type === 'filter'
        ? RESOLVE_FILTER
        : type === 'component'
            ? RESOLVE_COMPONENT
            : RESOLVE_DIRECTIVE);
    for (let i = 0; i < assets.length; i++) {
        let id = assets[i];
        // potential component implicit self-reference inferred from SFC filename
        const maybeSelfReference = id.endsWith('__self');
        if (maybeSelfReference) {
            id = id.slice(0, -6);
        }
        push(`const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) {
            newline();
        }
    }
}
function genHoists(hoists, context) {
    if (!hoists.length) {
        return;
    }
    context.pure = true;
    const { push, newline, helper, scopeId, mode } = context;
    newline();
    for (let i = 0; i < hoists.length; i++) {
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = ${``}`);
            genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function isText$1(n) {
    return (isString(n) ||
        n.type === 4 /* SIMPLE_EXPRESSION */ ||
        n.type === 2 /* TEXT */ ||
        n.type === 5 /* INTERPOLATION */ ||
        n.type === 8 /* COMPOUND_EXPRESSION */);
}
function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 ||
        ((( false)) && 0);
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if ((0,shared_esm_bundler.isString)(node)) {
            push(node);
        }
        else if ((0,shared_esm_bundler.isArray)(node)) {
            genNodeListAsArray(node, context);
        }
        else {
            genNode(node, context);
        }
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(',');
                newline();
            }
            else {
                comma && push(', ');
            }
        }
    }
}
function genNode(node, context) {
    if ((0,shared_esm_bundler.isString)(node)) {
        context.push(node);
        return;
    }
    if ((0,shared_esm_bundler.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch (node.type) {
        case 1 /* ELEMENT */:
        case 9 /* IF */:
        case 11 /* FOR */:
            ( false) &&
                0;
            genNode(node.codegenNode, context);
            break;
        case 2 /* TEXT */:
            genText(node, context);
            break;
        case 4 /* SIMPLE_EXPRESSION */:
            genExpression(node, context);
            break;
        case 5 /* INTERPOLATION */:
            genInterpolation(node, context);
            break;
        case 12 /* TEXT_CALL */:
            genNode(node.codegenNode, context);
            break;
        case 8 /* COMPOUND_EXPRESSION */:
            genCompoundExpression(node, context);
            break;
        case 3 /* COMMENT */:
            genComment(node, context);
            break;
        case 13 /* VNODE_CALL */:
            genVNodeCall(node, context);
            break;
        case 14 /* JS_CALL_EXPRESSION */:
            genCallExpression(node, context);
            break;
        case 15 /* JS_OBJECT_EXPRESSION */:
            genObjectExpression(node, context);
            break;
        case 17 /* JS_ARRAY_EXPRESSION */:
            genArrayExpression(node, context);
            break;
        case 18 /* JS_FUNCTION_EXPRESSION */:
            genFunctionExpression(node, context);
            break;
        case 19 /* JS_CONDITIONAL_EXPRESSION */:
            genConditionalExpression(node, context);
            break;
        case 20 /* JS_CACHE_EXPRESSION */:
            genCacheExpression(node, context);
            break;
        case 21 /* JS_BLOCK_STATEMENT */:
            genNodeList(node.body, context, true, false);
            break;
        // SSR only types
        case 22 /* JS_TEMPLATE_LITERAL */:
            break;
        case 23 /* JS_IF_STATEMENT */:
            break;
        case 24 /* JS_ASSIGNMENT_EXPRESSION */:
            break;
        case 25 /* JS_SEQUENCE_EXPRESSION */:
            break;
        case 26 /* JS_RETURN_STATEMENT */:
            break;
        /* istanbul ignore next */
        case 10 /* IF_BRANCH */:
            // noop
            break;
        default:
            if ((false)) {}
    }
}
function genText(node, context) {
    context.push(JSON.stringify(node.content), node);
}
function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, node);
}
function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure)
        push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
}
function genCompoundExpression(node, context) {
    for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i];
        if ((0,shared_esm_bundler.isString)(child)) {
            context.push(child);
        }
        else {
            genNode(child, context);
        }
    }
}
function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8 /* COMPOUND_EXPRESSION */) {
        push(`[`);
        genCompoundExpression(node, context);
        push(`]`);
    }
    else if (node.isStatic) {
        // only quote keys if necessary
        const text = isSimpleIdentifier(node.content)
            ? node.content
            : JSON.stringify(node.content);
        push(text, node);
    }
    else {
        push(`[${node.content}]`, node);
    }
}
function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) {
        push(PURE_ANNOTATION);
    }
    push(`${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`, node);
}
function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const { tag, props, children, patchFlag, dynamicProps, directives, isBlock, disableTracking, isComponent } = node;
    if (directives) {
        push(helper(WITH_DIRECTIVES) + `(`);
    }
    if (isBlock) {
        push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    }
    if (pure) {
        push(PURE_ANNOTATION);
    }
    const callHelper = isBlock
        ? getVNodeBlockHelper(context.inSSR, isComponent)
        : getVNodeHelper(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, node);
    genNodeList(genNullableArgs([tag, props, children, patchFlag, dynamicProps]), context);
    push(`)`);
    if (isBlock) {
        push(`)`);
    }
    if (directives) {
        push(`, `);
        genNode(directives, context);
        push(`)`);
    }
}
function genNullableArgs(args) {
    let i = args.length;
    while (i--) {
        if (args[i] != null)
            break;
    }
    return args.slice(0, i + 1).map(arg => arg || `null`);
}
// JavaScript
function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = (0,shared_esm_bundler.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) {
        push(PURE_ANNOTATION);
    }
    push(callee + `(`, node);
    genNodeList(node.arguments, context);
    push(`)`);
}
function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
        push(`{}`, node);
        return;
    }
    const multilines = properties.length > 1 ||
        ((( false)) &&
            0);
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for (let i = 0; i < properties.length; i++) {
        const { key, value } = properties[i];
        // key
        genExpressionAsPropertyKey(key, context);
        push(`: `);
        // value
        genNode(value, context);
        if (i < properties.length - 1) {
            // will only reach this if it's multilines
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
}
function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) {
        // wrap slot functions with owner context
        push(`_${helperNameMap[WITH_CTX]}(`);
    }
    push(`(`, node);
    if ((0,shared_esm_bundler.isArray)(params)) {
        genNodeList(params, context);
    }
    else if (params) {
        genNode(params, context);
    }
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) {
            push(`return `);
        }
        if ((0,shared_esm_bundler.isArray)(returns)) {
            genNodeListAsArray(returns, context);
        }
        else {
            genNode(returns, context);
        }
    }
    else if (body) {
        genNode(body, context);
    }
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) {
            push(`, undefined, true`);
        }
        push(`)`);
    }
}
function genConditionalExpression(node, context) {
    const { test, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test.type === 4 /* SIMPLE_EXPRESSION */) {
        const needsParens = !isSimpleIdentifier(test.content);
        needsParens && push(`(`);
        genExpression(test, context);
        needsParens && push(`)`);
    }
    else {
        push(`(`);
        genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */;
    if (!isNested) {
        context.indentLevel++;
    }
    genNode(alternate, context);
    if (!isNested) {
        context.indentLevel--;
    }
    needNewline && deindent(true /* without newline */);
}
function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    push(`_cache[${node.index}] || (`);
    if (node.isVNode) {
        indent();
        push(`${helper(SET_BLOCK_TRACKING)}(-1),`);
        newline();
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (node.isVNode) {
        push(`,`);
        newline();
        push(`${helper(SET_BLOCK_TRACKING)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
}

function walkIdentifiers(root, onIdentifier, includeAll = false, parentStack = [], knownIds = Object.create(null)) {
    {
        return;
    }
}
function isReferencedIdentifier(id, parent, parentStack) {
    {
        return false;
    }
}
function isInDestructureAssignment(parent, parentStack) {
    if (parent &&
        (parent.type === 'ObjectProperty' || parent.type === 'ArrayPattern')) {
        let i = parentStack.length;
        while (i--) {
            const p = parentStack[i];
            if (p.type === 'AssignmentExpression') {
                return true;
            }
            else if (p.type !== 'ObjectProperty' && !p.type.endsWith('Pattern')) {
                break;
            }
        }
    }
    return false;
}
function walkFunctionParams(node, onIdent) {
    for (const p of node.params) {
        for (const id of extractIdentifiers(p)) {
            onIdent(id);
        }
    }
}
function walkBlockDeclarations(block, onIdent) {
    for (const stmt of block.body) {
        if (stmt.type === 'VariableDeclaration') {
            if (stmt.declare)
                continue;
            for (const decl of stmt.declarations) {
                for (const id of extractIdentifiers(decl.id)) {
                    onIdent(id);
                }
            }
        }
        else if (stmt.type === 'FunctionDeclaration' ||
            stmt.type === 'ClassDeclaration') {
            if (stmt.declare || !stmt.id)
                continue;
            onIdent(stmt.id);
        }
    }
}
function extractIdentifiers(param, nodes = []) {
    switch (param.type) {
        case 'Identifier':
            nodes.push(param);
            break;
        case 'MemberExpression':
            let object = param;
            while (object.type === 'MemberExpression') {
                object = object.object;
            }
            nodes.push(object);
            break;
        case 'ObjectPattern':
            for (const prop of param.properties) {
                if (prop.type === 'RestElement') {
                    extractIdentifiers(prop.argument, nodes);
                }
                else {
                    extractIdentifiers(prop.value, nodes);
                }
            }
            break;
        case 'ArrayPattern':
            param.elements.forEach(element => {
                if (element)
                    extractIdentifiers(element, nodes);
            });
            break;
        case 'RestElement':
            extractIdentifiers(param.argument, nodes);
            break;
        case 'AssignmentPattern':
            extractIdentifiers(param.left, nodes);
            break;
    }
    return nodes;
}
const isFunctionType = (node) => {
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const isStaticProperty = (node) => node &&
    (node.type === 'ObjectProperty' || node.type === 'ObjectMethod') &&
    !node.computed;
const isStaticPropertyKey = (node, parent) => isStaticProperty(parent) && parent.key === node;

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
const prohibitedKeywordRE = new RegExp('\\b' +
    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
        'super,throw,while,yield,delete,export,import,return,switch,default,' +
        'extends,finally,continue,debugger,function,arguments,typeof,void')
        .split(',')
        .join('\\b|\\b') +
    '\\b');
// strip strings in expressions
const stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
/**
 * Validate a non-prefixed expression.
 * This is only called when using the in-browser runtime compiler since it
 * doesn't prefix expressions.
 */
function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    // empty expressions are validated per-directive since some directives
    // do allow empty expressions.
    if (!exp.trim()) {
        return;
    }
    try {
        new Function(asRawStatements
            ? ` ${exp} `
            : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    }
    catch (e) {
        let message = e.message;
        const keywordMatch = exp
            .replace(stripStringRE, '')
            .match(prohibitedKeywordRE);
        if (keywordMatch) {
            message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        }
        context.onError(createCompilerError(44 /* X_INVALID_EXPRESSION */, node.loc, undefined, message));
    }
}

const transformExpression = (node, context) => {
    if (node.type === 5 /* INTERPOLATION */) {
        node.content = processExpression(node.content, context);
    }
    else if (node.type === 1 /* ELEMENT */) {
        // handle directives on element
        for (let i = 0; i < node.props.length; i++) {
            const dir = node.props[i];
            // do not process for v-on & v-for since they are special handled
            if (dir.type === 7 /* DIRECTIVE */ && dir.name !== 'for') {
                const exp = dir.exp;
                const arg = dir.arg;
                // do not process exp if this is v-on:arg - we need special handling
                // for wrapping inline statements.
                if (exp &&
                    exp.type === 4 /* SIMPLE_EXPRESSION */ &&
                    !(dir.name === 'on' && arg)) {
                    dir.exp = processExpression(exp, context, 
                    // slot args must be processed as function params
                    dir.name === 'slot');
                }
                if (arg && arg.type === 4 /* SIMPLE_EXPRESSION */ && !arg.isStatic) {
                    dir.arg = processExpression(arg, context);
                }
            }
        }
    }
};
// Important: since this function uses Node.js only dependencies, it should
// always be used with a leading !true check so that it can be
// tree-shaken from the browser build.
function processExpression(node, context, 
// some expressions like v-slot props & v-for aliases should be parsed as
// function params
asParams = false, 
// v-on handler values may contain multiple statements
asRawStatements = false, localVars = Object.create(context.identifiers)) {
    {
        if ((false)) {}
        return node;
    }
}

const transformIf = createStructuralDirectiveTransform(/^(if|else|else-if)$/, (node, dir, context) => {
    return processIf(node, dir, context, (ifNode, branch, isRoot) => {
        // #1587: We need to dynamically increment the key based on the current
        // node's sibling nodes, since chained v-if/else branches are
        // rendered at the same depth
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while (i-- >= 0) {
            const sibling = siblings[i];
            if (sibling && sibling.type === 9 /* IF */) {
                key += sibling.branches.length;
            }
        }
        // Exit callback. Complete the codegenNode when all children have been
        // transformed.
        return () => {
            if (isRoot) {
                ifNode.codegenNode = createCodegenNodeForBranch(branch, key, context);
            }
            else {
                // attach this branch's codegen node to the v-if root.
                const parentCondition = getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
// target-agnostic transform used for both Client and SSR
function processIf(node, dir, context, processCodegen) {
    if (dir.name !== 'else' &&
        (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError(createCompilerError(28 /* X_V_IF_NO_EXPRESSION */, dir.loc));
        dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (false) {}
    if (dir.name === 'if') {
        const branch = createIfBranch(node, dir);
        const ifNode = {
            type: 9 /* IF */,
            loc: node.loc,
            branches: [branch]
        };
        context.replaceNode(ifNode);
        if (processCodegen) {
            return processCodegen(ifNode, branch, true);
        }
    }
    else {
        // locate the adjacent v-if
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while (i-- >= -1) {
            const sibling = siblings[i];
            if (false /* COMMENT */) {}
            if (sibling &&
                sibling.type === 2 /* TEXT */ &&
                !sibling.content.trim().length) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9 /* IF */) {
                // Check if v-else was followed by v-else-if
                if (dir.name === 'else-if' &&
                    sibling.branches[sibling.branches.length - 1].condition === undefined) {
                    context.onError(createCompilerError(30 /* X_V_ELSE_NO_ADJACENT_IF */, node.loc));
                }
                // move the node to the if node's branches
                context.removeNode();
                const branch = createIfBranch(node, dir);
                if (false) {}
                // check if user is forcing same key on different branches
                if (false) {}
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                // since the branch was removed, it will not be traversed.
                // make sure to traverse here.
                traverseNode(branch, context);
                // call on exit
                if (onExit)
                    onExit();
                // make sure to reset currentNode after traversal to indicate this
                // node has been removed.
                context.currentNode = null;
            }
            else {
                context.onError(createCompilerError(30 /* X_V_ELSE_NO_ADJACENT_IF */, node.loc));
            }
            break;
        }
    }
}
function createIfBranch(node, dir) {
    return {
        type: 10 /* IF_BRANCH */,
        loc: node.loc,
        condition: dir.name === 'else' ? undefined : dir.exp,
        children: node.tagType === 3 /* TEMPLATE */ && !findDir(node, 'for')
            ? node.children
            : [node],
        userKey: findProp(node, `key`)
    };
}
function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) {
        return createConditionalExpression(branch.condition, createChildrenCodegenNode(branch, keyIndex, context), 
        // make sure to pass in asBlock: true so that the comment node call
        // closes the current block.
        createCallExpression(context.helper(CREATE_COMMENT), [
            ( false) ? 0 : '""',
            'true'
        ]));
    }
    else {
        return createChildrenCodegenNode(branch, keyIndex, context);
    }
}
function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(`key`, createSimpleExpression(`${keyIndex}`, false, locStub, 2 /* CAN_HOIST */));
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1 /* ELEMENT */;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11 /* FOR */) {
            // optimize away nested fragments when child is a ForNode
            const vnodeCall = firstChild.codegenNode;
            injectProp(vnodeCall, keyProperty, context);
            return vnodeCall;
        }
        else {
            let patchFlag = 64 /* STABLE_FRAGMENT */;
            let patchFlagText = shared_esm_bundler.PatchFlagNames[64];
            // check if the fragment actually contains a single valid child with
            // the rest being comments
            if (false) {}
            return createVNodeCall(context, helper(FRAGMENT), createObjectExpression([keyProperty]), children, patchFlag + (( false) ? 0 : ``), undefined, undefined, true, false, false /* isComponent */, branch.loc);
        }
    }
    else {
        const ret = firstChild.codegenNode;
        const vnodeCall = getMemoedVNodeCall(ret);
        // Change createVNode to createBlock.
        if (vnodeCall.type === 13 /* VNODE_CALL */) {
            makeBlock(vnodeCall, context);
        }
        // inject branch key
        injectProp(vnodeCall, keyProperty, context);
        return ret;
    }
}
function isSameKey(a, b) {
    if (!a || a.type !== b.type) {
        return false;
    }
    if (a.type === 6 /* ATTRIBUTE */) {
        if (a.value.content !== b.value.content) {
            return false;
        }
    }
    else {
        // directive
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) {
            return false;
        }
        if (exp.type !== 4 /* SIMPLE_EXPRESSION */ ||
            exp.isStatic !== branchExp.isStatic ||
            exp.content !== branchExp.content) {
            return false;
        }
    }
    return true;
}
function getParentCondition(node) {
    while (true) {
        if (node.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
            if (node.alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
                node = node.alternate;
            }
            else {
                return node;
            }
        }
        else if (node.type === 20 /* JS_CACHE_EXPRESSION */) {
            node = node.value;
        }
    }
}

const transformFor = createStructuralDirectiveTransform('for', (node, dir, context) => {
    const { helper, removeHelper } = context;
    return processFor(node, dir, context, forNode => {
        // create the loop render function expression now, and add the
        // iterator on exit after all children have been traversed
        const renderExp = createCallExpression(helper(RENDER_LIST), [
            forNode.source
        ]);
        const isTemplate = isTemplateNode(node);
        const memo = findDir(node, 'memo');
        const keyProp = findProp(node, `key`);
        const keyExp = keyProp &&
            (keyProp.type === 6 /* ATTRIBUTE */
                ? createSimpleExpression(keyProp.value.content, true)
                : keyProp.exp);
        const keyProperty = keyProp ? createObjectProperty(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 /* SIMPLE_EXPRESSION */ &&
            forNode.source.constType > 0 /* NOT_CONSTANT */;
        const fragmentFlag = isStableFragment
            ? 64 /* STABLE_FRAGMENT */
            : keyProp
                ? 128 /* KEYED_FRAGMENT */
                : 256 /* UNKEYED_FRAGMENT */;
        forNode.codegenNode = createVNodeCall(context, helper(FRAGMENT), undefined, renderExp, fragmentFlag +
            (( false) ? 0 : ``), undefined, undefined, true /* isBlock */, !isStableFragment /* disableTracking */, false /* isComponent */, node.loc);
        return () => {
            // finish the codegen now that all children have been traversed
            let childBlock;
            const { children } = forNode;
            // check <template v-for> key placement
            if (false) {}
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1 /* ELEMENT */;
            const slotOutlet = isSlotOutlet(node)
                ? node
                : isTemplate &&
                    node.children.length === 1 &&
                    isSlotOutlet(node.children[0])
                    ? node.children[0] // api-extractor somehow fails to infer this
                    : null;
            if (slotOutlet) {
                // <slot v-for="..."> or <template v-for="..."><slot/></template>
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) {
                    // <template v-for="..." :key="..."><slot/></template>
                    // we need to inject the key to the renderSlot() call.
                    // the props for renderSlot is passed as the 3rd argument.
                    injectProp(childBlock, keyProperty, context);
                }
            }
            else if (needFragmentWrapper) {
                // <template v-for="..."> with text or multi-elements
                // should generate a fragment block for each loop
                childBlock = createVNodeCall(context, helper(FRAGMENT), keyProperty ? createObjectExpression([keyProperty]) : undefined, node.children, 64 /* STABLE_FRAGMENT */ +
                    (( false)
                        ? 0
                        : ``), undefined, undefined, true, undefined, false /* isComponent */);
            }
            else {
                // Normal element v-for. Directly use the child's codegenNode
                // but mark it as a block.
                childBlock = children[0]
                    .codegenNode;
                if (isTemplate && keyProperty) {
                    injectProp(childBlock, keyProperty, context);
                }
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        // switch from block to vnode
                        removeHelper(OPEN_BLOCK);
                        removeHelper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                    }
                    else {
                        // switch from vnode to block
                        removeHelper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                    }
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper(OPEN_BLOCK);
                    helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                }
                else {
                    helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                }
            }
            if (memo) {
                const loop = createFunctionExpression(createForLoopParams(forNode.parseResult, [
                    createSimpleExpression(`_cached`)
                ]));
                loop.body = createBlockStatement([
                    createCompoundExpression([`const _memo = (`, memo.exp, `)`]),
                    createCompoundExpression([
                        `if (_cached`,
                        ...(keyExp ? [` && _cached.key === `, keyExp] : []),
                        ` && ${context.helperString(IS_MEMO_SAME)}(_cached, _memo)) return _cached`
                    ]),
                    createCompoundExpression([`const _item = `, childBlock]),
                    createSimpleExpression(`_item.memo = _memo`),
                    createSimpleExpression(`return _item`)
                ]);
                renderExp.arguments.push(loop, createSimpleExpression(`_cache`), createSimpleExpression(String(context.cached++)));
            }
            else {
                renderExp.arguments.push(createFunctionExpression(createForLoopParams(forNode.parseResult), childBlock, true /* force newline */));
            }
        };
    });
});
// target-agnostic transform used for both Client and SSR
function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError(createCompilerError(31 /* X_V_FOR_NO_EXPRESSION */, dir.loc));
        return;
    }
    const parseResult = parseForExpression(
    // can only be simple expression because vFor transform is applied
    // before expression transform.
    dir.exp, context);
    if (!parseResult) {
        context.onError(createCompilerError(32 /* X_V_FOR_MALFORMED_EXPRESSION */, dir.loc));
        return;
    }
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
        type: 11 /* FOR */,
        loc: dir.loc,
        source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult,
        children: isTemplateNode(node) ? node.children : [node]
    };
    context.replaceNode(forNode);
    // bookkeeping
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return () => {
        scopes.vFor--;
        if (onExit)
            onExit();
    };
}
const forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
// This regex doesn't cover the case if key or index aliases have destructuring,
// but those do not make sense in the first place, so this works in practice.
const forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const stripParensRE = /^\(|\)$/g;
function parseForExpression(input, context) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch)
        return;
    const [, LHS, RHS] = inMatch;
    const result = {
        source: createAliasExpression(loc, RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: undefined,
        key: undefined,
        index: undefined
    };
    if (false) {}
    let valueContent = LHS.trim().replace(stripParensRE, '').trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace(forIteratorRE, '').trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(loc, keyContent, keyOffset);
            if (false) {}
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) {
                result.index = createAliasExpression(loc, indexContent, exp.indexOf(indexContent, result.key
                    ? keyOffset + keyContent.length
                    : trimmedOffset + valueContent.length));
                if (false) {}
            }
        }
    }
    if (valueContent) {
        result.value = createAliasExpression(loc, valueContent, trimmedOffset);
        if (false) {}
    }
    return result;
}
function createAliasExpression(range, content, offset) {
    return createSimpleExpression(content, false, getInnerRange(range, offset, content.length));
}
function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([value, key, index, ...memoArgs]);
}
function createParamsList(args) {
    let i = args.length;
    while (i--) {
        if (args[i])
            break;
    }
    return args
        .slice(0, i + 1)
        .map((arg, i) => arg || createSimpleExpression(`_`.repeat(i + 1), false));
}

const defaultFallback = createSimpleExpression(`undefined`, false);
// A NodeTransform that:
// 1. Tracks scope identifiers for scoped slots so that they don't get prefixed
//    by transformExpression. This is only applied in non-browser builds with
//    { prefixIdentifiers: true }.
// 2. Track v-slot depths so that we know a slot is inside another slot.
//    Note the exit callback is executed before buildSlots() on the same node,
//    so only nested slots see positive numbers.
const trackSlotScopes = (node, context) => {
    if (node.type === 1 /* ELEMENT */ &&
        (node.tagType === 1 /* COMPONENT */ ||
            node.tagType === 3 /* TEMPLATE */)) {
        // We are only checking non-empty v-slot here
        // since we only care about slots that introduce scope variables.
        const vSlot = findDir(node, 'slot');
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return () => {
                context.scopes.vSlot--;
            };
        }
    }
};
// A NodeTransform that tracks scope identifiers for scoped slots with v-for.
// This transform is only applied in non-browser builds with { prefixIdentifiers: true }
const trackVForSlotScopes = (node, context) => {
    let vFor;
    if (isTemplateNode(node) &&
        node.props.some(isVSlot) &&
        (vFor = findDir(node, 'for'))) {
        const result = (vFor.parseResult = parseForExpression(vFor.exp, context));
        if (result) {
            const { value, key, index } = result;
            const { addIdentifiers, removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return () => {
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const buildClientSlotFn = (props, children, loc) => createFunctionExpression(props, children, false /* newline */, true /* isSlot */, children.length ? children[0].loc : loc);
// Instead of being a DirectiveTransform, v-slot processing is called during
// transformElement to build the slots object for a component.
function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    // If the slot is inside a v-for or another v-slot, force it to be dynamic
    // since it likely uses a scope variable.
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    // 1. Check for slot with slotProps on component itself.
    //    <Comp v-slot="{ prop }"/>
    const onComponentSlot = findDir(node, 'slot', true);
    if (onComponentSlot) {
        const { arg, exp } = onComponentSlot;
        if (arg && !isStaticExp(arg)) {
            hasDynamicSlots = true;
        }
        slotsProperties.push(createObjectProperty(arg || createSimpleExpression('default', true), buildSlotFn(exp, children, loc)));
    }
    // 2. Iterate through children and check for template slots
    //    <template v-slot:foo="{ prop }">
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = new Set();
    for (let i = 0; i < children.length; i++) {
        const slotElement = children[i];
        let slotDir;
        if (!isTemplateNode(slotElement) ||
            !(slotDir = findDir(slotElement, 'slot', true))) {
            // not a <template v-slot>, skip.
            if (slotElement.type !== 3 /* COMMENT */) {
                implicitDefaultChildren.push(slotElement);
            }
            continue;
        }
        if (onComponentSlot) {
            // already has on-component slot - this is incorrect usage.
            context.onError(createCompilerError(37 /* X_V_SLOT_MIXED_SLOT_USAGE */, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = createSimpleExpression(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        // check if name is dynamic.
        let staticSlotName;
        if (isStaticExp(slotName)) {
            staticSlotName = slotName ? slotName.content : `default`;
        }
        else {
            hasDynamicSlots = true;
        }
        const slotFunction = buildSlotFn(slotProps, slotChildren, slotLoc);
        // check if this slot is conditional (v-if/v-for)
        let vIf;
        let vElse;
        let vFor;
        if ((vIf = findDir(slotElement, 'if'))) {
            hasDynamicSlots = true;
            dynamicSlots.push(createConditionalExpression(vIf.exp, buildDynamicSlot(slotName, slotFunction), defaultFallback));
        }
        else if ((vElse = findDir(slotElement, /^else(-if)?$/, true /* allowEmpty */))) {
            // find adjacent v-if
            let j = i;
            let prev;
            while (j--) {
                prev = children[j];
                if (prev.type !== 3 /* COMMENT */) {
                    break;
                }
            }
            if (prev && isTemplateNode(prev) && findDir(prev, 'if')) {
                // remove node
                children.splice(i, 1);
                i--;
                // attach this slot to previous conditional
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while (conditional.alternate.type === 19 /* JS_CONDITIONAL_EXPRESSION */) {
                    conditional = conditional.alternate;
                }
                conditional.alternate = vElse.exp
                    ? createConditionalExpression(vElse.exp, buildDynamicSlot(slotName, slotFunction), defaultFallback)
                    : buildDynamicSlot(slotName, slotFunction);
            }
            else {
                context.onError(createCompilerError(30 /* X_V_ELSE_NO_ADJACENT_IF */, vElse.loc));
            }
        }
        else if ((vFor = findDir(slotElement, 'for'))) {
            hasDynamicSlots = true;
            const parseResult = vFor.parseResult ||
                parseForExpression(vFor.exp, context);
            if (parseResult) {
                // Render the dynamic slots as an array and add it to the createSlot()
                // args. The runtime knows how to handle it appropriately.
                dynamicSlots.push(createCallExpression(context.helper(RENDER_LIST), [
                    parseResult.source,
                    createFunctionExpression(createForLoopParams(parseResult), buildDynamicSlot(slotName, slotFunction), true /* force newline */)
                ]));
            }
            else {
                context.onError(createCompilerError(32 /* X_V_FOR_MALFORMED_EXPRESSION */, vFor.loc));
            }
        }
        else {
            // check duplicate static names
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError(createCompilerError(38 /* X_V_SLOT_DUPLICATE_SLOT_NAMES */, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === 'default') {
                    hasNamedDefaultSlot = true;
                }
            }
            slotsProperties.push(createObjectProperty(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children) => {
            const fn = buildSlotFn(props, children, loc);
            if (context.compatConfig) {
                fn.isNonScopedSlot = true;
            }
            return createObjectProperty(`default`, fn);
        };
        if (!hasTemplateSlots) {
            // implicit default slot (on component)
            slotsProperties.push(buildDefaultSlotProperty(undefined, children));
        }
        else if (implicitDefaultChildren.length &&
            // #3766
            // with whitespace: 'preserve', whitespaces between slots will end up in
            // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
            implicitDefaultChildren.some(node => isNonWhitespaceContent(node))) {
            // implicit default slot (mixed with named slots)
            if (hasNamedDefaultSlot) {
                context.onError(createCompilerError(39 /* X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN */, implicitDefaultChildren[0].loc));
            }
            else {
                slotsProperties.push(buildDefaultSlotProperty(undefined, implicitDefaultChildren));
            }
        }
    }
    const slotFlag = hasDynamicSlots
        ? 2 /* DYNAMIC */
        : hasForwardedSlots(node.children)
            ? 3 /* FORWARDED */
            : 1 /* STABLE */;
    let slots = createObjectExpression(slotsProperties.concat(createObjectProperty(`_`, 
    // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    createSimpleExpression(slotFlag + (( false) ? 0 : ``), false))), loc);
    if (dynamicSlots.length) {
        slots = createCallExpression(context.helper(CREATE_SLOTS), [
            slots,
            createArrayExpression(dynamicSlots)
        ]);
    }
    return {
        slots,
        hasDynamicSlots
    };
}
function buildDynamicSlot(name, fn) {
    return createObjectExpression([
        createObjectProperty(`name`, name),
        createObjectProperty(`fn`, fn)
    ]);
}
function hasForwardedSlots(children) {
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        switch (child.type) {
            case 1 /* ELEMENT */:
                if (child.tagType === 2 /* SLOT */ ||
                    hasForwardedSlots(child.children)) {
                    return true;
                }
                break;
            case 9 /* IF */:
                if (hasForwardedSlots(child.branches))
                    return true;
                break;
            case 10 /* IF_BRANCH */:
            case 11 /* FOR */:
                if (hasForwardedSlots(child.children))
                    return true;
                break;
        }
    }
    return false;
}
function isNonWhitespaceContent(node) {
    if (node.type !== 2 /* TEXT */ && node.type !== 12 /* TEXT_CALL */)
        return true;
    return node.type === 2 /* TEXT */
        ? !!node.content.trim()
        : isNonWhitespaceContent(node.content);
}

// some directive transforms (e.g. v-model) may return a symbol for runtime
// import, which should be used instead of a resolveDirective call.
const directiveImportMap = new WeakMap();
// generate a JavaScript AST for this element's codegen
const transformElement = (node, context) => {
    // perform the work on exit, after all child expressions have been
    // processed and merged.
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 /* ELEMENT */ &&
            (node.tagType === 0 /* ELEMENT */ ||
                node.tagType === 1 /* COMPONENT */))) {
            return;
        }
        const { tag, props } = node;
        const isComponent = node.tagType === 1 /* COMPONENT */;
        // The goal of the transform is to create a codegenNode implementing the
        // VNodeCall interface.
        let vnodeTag = isComponent
            ? resolveComponentType(node, context)
            : `"${tag}"`;
        const isDynamicComponent = (0,shared_esm_bundler.isObject)(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
        let vnodeProps;
        let vnodeChildren;
        let vnodePatchFlag;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = 
        // dynamic component may resolve to plain elements
        isDynamicComponent ||
            vnodeTag === TELEPORT ||
            vnodeTag === SUSPENSE ||
            (!isComponent &&
                // <svg> and <foreignObject> must be forced into blocks so that block
                // updates inside get proper isSVG flag at runtime. (#639, #643)
                // This is technically web-specific, but splitting the logic out of core
                // leads to too much unnecessary complexity.
                (tag === 'svg' || tag === 'foreignObject'));
        // props
        if (props.length > 0) {
            const propsBuildResult = buildProps(node, context);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives =
                directives && directives.length
                    ? createArrayExpression(directives.map(dir => buildDirectiveArgs(dir, context)))
                    : undefined;
            if (propsBuildResult.shouldUseBlock) {
                shouldUseBlock = true;
            }
        }
        // children
        if (node.children.length > 0) {
            if (vnodeTag === KEEP_ALIVE) {
                // Although a built-in component, we compile KeepAlive with raw children
                // instead of slot functions so that it can be used inside Transition
                // or other Transition-wrapping HOCs.
                // To ensure correct updates with block optimizations, we need to:
                // 1. Force keep-alive into a block. This avoids its children being
                //    collected by a parent block.
                shouldUseBlock = true;
                // 2. Force keep-alive to always be updated, since it uses raw children.
                patchFlag |= 1024 /* DYNAMIC_SLOTS */;
                if (false) {}
            }
            const shouldBuildAsSlots = isComponent &&
                // Teleport is not a real component and has dedicated runtime handling
                vnodeTag !== TELEPORT &&
                // explained above.
                vnodeTag !== KEEP_ALIVE;
            if (shouldBuildAsSlots) {
                const { slots, hasDynamicSlots } = buildSlots(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) {
                    patchFlag |= 1024 /* DYNAMIC_SLOTS */;
                }
            }
            else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
                const child = node.children[0];
                const type = child.type;
                // check for dynamic text children
                const hasDynamicTextChild = type === 5 /* INTERPOLATION */ ||
                    type === 8 /* COMPOUND_EXPRESSION */;
                if (hasDynamicTextChild &&
                    getConstantType(child, context) === 0 /* NOT_CONSTANT */) {
                    patchFlag |= 1 /* TEXT */;
                }
                // pass directly if the only child is a text node
                // (plain / interpolation / expression)
                if (hasDynamicTextChild || type === 2 /* TEXT */) {
                    vnodeChildren = child;
                }
                else {
                    vnodeChildren = node.children;
                }
            }
            else {
                vnodeChildren = node.children;
            }
        }
        // patchFlag & dynamicPropNames
        if (patchFlag !== 0) {
            if ((false)) {}
            else {
                vnodePatchFlag = String(patchFlag);
            }
            if (dynamicPropNames && dynamicPropNames.length) {
                vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
            }
        }
        node.codegenNode = createVNodeCall(context, vnodeTag, vnodeProps, vnodeChildren, vnodePatchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false /* disableTracking */, isComponent, node.loc);
    };
};
function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    // 1. dynamic component
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(node, 'is');
    if (isProp) {
        if (isExplicitDynamic ||
            (isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */, context))) {
            const exp = isProp.type === 6 /* ATTRIBUTE */
                ? isProp.value && createSimpleExpression(isProp.value.content, true)
                : isProp.exp;
            if (exp) {
                return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
                    exp
                ]);
            }
        }
        else if (isProp.type === 6 /* ATTRIBUTE */ &&
            isProp.value.content.startsWith('vue:')) {
            // <button is="vue:xxx">
            // if not <component>, only is value that starts with "vue:" will be
            // treated as component by the parse phase and reach here, unless it's
            // compat mode where all is values are considered components
            tag = isProp.value.content.slice(4);
        }
    }
    // 1.5 v-is (TODO: Deprecate)
    const isDir = !isExplicitDynamic && findDir(node, 'is');
    if (isDir && isDir.exp) {
        return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
            isDir.exp
        ]);
    }
    // 2. built-in components (Teleport, Transition, KeepAlive, Suspense...)
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        // built-ins are simply fallthroughs / have special handling during ssr
        // so we don't need to import their runtime equivalents
        if (!ssr)
            context.helper(builtIn);
        return builtIn;
    }
    // 5. user component (resolve)
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
}
function buildProps(node, context, props = node.props, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    const isComponent = node.tagType === 1 /* COMPONENT */;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    // patchFlag analysis
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const analyzePatchFlag = ({ key, value }) => {
        if (isStaticExp(key)) {
            const name = key.content;
            const isEventHandler = (0,shared_esm_bundler.isOn)(name);
            if (!isComponent &&
                isEventHandler &&
                // omit the flag for click handlers because hydration gives click
                // dedicated fast path.
                name.toLowerCase() !== 'onclick' &&
                // omit v-model handlers
                name !== 'onUpdate:modelValue' &&
                // omit onVnodeXXX hooks
                !(0,shared_esm_bundler.isReservedProp)(name)) {
                hasHydrationEventBinding = true;
            }
            if (isEventHandler && (0,shared_esm_bundler.isReservedProp)(name)) {
                hasVnodeHook = true;
            }
            if (value.type === 20 /* JS_CACHE_EXPRESSION */ ||
                ((value.type === 4 /* SIMPLE_EXPRESSION */ ||
                    value.type === 8 /* COMPOUND_EXPRESSION */) &&
                    getConstantType(value, context) > 0)) {
                // skip if the prop is a cached handler or has constant value
                return;
            }
            if (name === 'ref') {
                hasRef = true;
            }
            else if (name === 'class') {
                hasClassBinding = true;
            }
            else if (name === 'style') {
                hasStyleBinding = true;
            }
            else if (name !== 'key' && !dynamicPropNames.includes(name)) {
                dynamicPropNames.push(name);
            }
            // treat the dynamic class and style binding of the component as dynamic props
            if (isComponent &&
                (name === 'class' || name === 'style') &&
                !dynamicPropNames.includes(name)) {
                dynamicPropNames.push(name);
            }
        }
        else {
            hasDynamicKeys = true;
        }
    };
    for (let i = 0; i < props.length; i++) {
        // static attribute
        const prop = props[i];
        if (prop.type === 6 /* ATTRIBUTE */) {
            const { loc, name, value } = prop;
            let isStatic = true;
            if (name === 'ref') {
                hasRef = true;
                if (context.scopes.vFor > 0) {
                    properties.push(createObjectProperty(createSimpleExpression('ref_for', true), createSimpleExpression('true')));
                }
            }
            // skip is on <component>, or is="vue:xxx"
            if (name === 'is' &&
                (isComponentTag(tag) ||
                    (value && value.content.startsWith('vue:')) ||
                    (isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */, context)))) {
                continue;
            }
            properties.push(createObjectProperty(createSimpleExpression(name, true, getInnerRange(loc, 0, name.length)), createSimpleExpression(value ? value.content : '', isStatic, value ? value.loc : loc)));
        }
        else {
            // directives
            const { name, arg, exp, loc } = prop;
            const isVBind = name === 'bind';
            const isVOn = name === 'on';
            // skip v-slot - it is handled by its dedicated transform.
            if (name === 'slot') {
                if (!isComponent) {
                    context.onError(createCompilerError(40 /* X_V_SLOT_MISPLACED */, loc));
                }
                continue;
            }
            // skip v-once/v-memo - they are handled by dedicated transforms.
            if (name === 'once' || name === 'memo') {
                continue;
            }
            // skip v-is and :is on <component>
            if (name === 'is' ||
                (isVBind &&
                    isStaticArgOf(arg, 'is') &&
                    (isComponentTag(tag) ||
                        (isCompatEnabled("COMPILER_IS_ON_ELEMENT" /* COMPILER_IS_ON_ELEMENT */, context))))) {
                continue;
            }
            // skip v-on in SSR compilation
            if (isVOn && ssr) {
                continue;
            }
            if (
            // #938: elements with dynamic keys should be forced into blocks
            (isVBind && isStaticArgOf(arg, 'key')) ||
                // inline before-update hooks need to force block so that it is invoked
                // before children
                (isVOn && hasChildren && isStaticArgOf(arg, 'vue:before-update'))) {
                shouldUseBlock = true;
            }
            if (isVBind && isStaticArgOf(arg, 'ref') && context.scopes.vFor > 0) {
                properties.push(createObjectProperty(createSimpleExpression('ref_for', true), createSimpleExpression('true')));
            }
            // special case for v-bind and v-on with no argument
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (properties.length) {
                        mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
                        properties = [];
                    }
                    if (isVBind) {
                        {
                            // 2.x v-bind object order compat
                            if ((false)) {}
                            if (isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER" /* COMPILER_V_BIND_OBJECT_ORDER */, context)) {
                                mergeArgs.unshift(exp);
                                continue;
                            }
                        }
                        mergeArgs.push(exp);
                    }
                    else {
                        // v-on="obj" -> toHandlers(obj)
                        mergeArgs.push({
                            type: 14 /* JS_CALL_EXPRESSION */,
                            loc,
                            callee: context.helper(TO_HANDLERS),
                            arguments: [exp]
                        });
                    }
                }
                else {
                    context.onError(createCompilerError(isVBind
                        ? 34 /* X_V_BIND_NO_EXPRESSION */
                        : 35 /* X_V_ON_NO_EXPRESSION */, loc));
                }
                continue;
            }
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                // has built-in directive transform.
                const { props, needRuntime } = directiveTransform(prop, node, context);
                !ssr && props.forEach(analyzePatchFlag);
                properties.push(...props);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0,shared_esm_bundler.isSymbol)(needRuntime)) {
                        directiveImportMap.set(prop, needRuntime);
                    }
                }
            }
            else if (!(0,shared_esm_bundler.isBuiltInDirective)(name)) {
                // no built-in transform, this is a user custom directive.
                runtimeDirectives.push(prop);
                // custom dirs may use beforeUpdate so they need to force blocks
                // to ensure before-update gets called before children update
                if (hasChildren) {
                    shouldUseBlock = true;
                }
            }
        }
    }
    let propsExpression = undefined;
    // has v-bind="object" or v-on="object", wrap with mergeProps
    if (mergeArgs.length) {
        if (properties.length) {
            mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
        }
        if (mergeArgs.length > 1) {
            propsExpression = createCallExpression(context.helper(MERGE_PROPS), mergeArgs, elementLoc);
        }
        else {
            // single v-bind with nothing else - no need for a mergeProps call
            propsExpression = mergeArgs[0];
        }
    }
    else if (properties.length) {
        propsExpression = createObjectExpression(dedupeProperties(properties), elementLoc);
    }
    // patchFlag analysis
    if (hasDynamicKeys) {
        patchFlag |= 16 /* FULL_PROPS */;
    }
    else {
        if (hasClassBinding && !isComponent) {
            patchFlag |= 2 /* CLASS */;
        }
        if (hasStyleBinding && !isComponent) {
            patchFlag |= 4 /* STYLE */;
        }
        if (dynamicPropNames.length) {
            patchFlag |= 8 /* PROPS */;
        }
        if (hasHydrationEventBinding) {
            patchFlag |= 32 /* HYDRATE_EVENTS */;
        }
    }
    if (!shouldUseBlock &&
        (patchFlag === 0 || patchFlag === 32 /* HYDRATE_EVENTS */) &&
        (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) {
        patchFlag |= 512 /* NEED_PATCH */;
    }
    // pre-normalize props, SSR is skipped for now
    if (!context.inSSR && propsExpression) {
        switch (propsExpression.type) {
            case 15 /* JS_OBJECT_EXPRESSION */:
                // means that there is no v-bind,
                // but still need to deal with dynamic key binding
                let classKeyIndex = -1;
                let styleKeyIndex = -1;
                let hasDynamicKey = false;
                for (let i = 0; i < propsExpression.properties.length; i++) {
                    const key = propsExpression.properties[i].key;
                    if (isStaticExp(key)) {
                        if (key.content === 'class') {
                            classKeyIndex = i;
                        }
                        else if (key.content === 'style') {
                            styleKeyIndex = i;
                        }
                    }
                    else if (!key.isHandlerKey) {
                        hasDynamicKey = true;
                    }
                }
                const classProp = propsExpression.properties[classKeyIndex];
                const styleProp = propsExpression.properties[styleKeyIndex];
                // no dynamic key
                if (!hasDynamicKey) {
                    if (classProp && !isStaticExp(classProp.value)) {
                        classProp.value = createCallExpression(context.helper(NORMALIZE_CLASS), [classProp.value]);
                    }
                    if (styleProp &&
                        !isStaticExp(styleProp.value) &&
                        // the static style is compiled into an object,
                        // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                        (hasStyleBinding ||
                            // v-bind:style and style both exist,
                            // v-bind:style with static literal object
                            styleProp.value.type === 17 /* JS_ARRAY_EXPRESSION */)) {
                        styleProp.value = createCallExpression(context.helper(NORMALIZE_STYLE), [styleProp.value]);
                    }
                }
                else {
                    // dynamic key binding, wrap with `normalizeProps`
                    propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [propsExpression]);
                }
                break;
            case 14 /* JS_CALL_EXPRESSION */:
                // mergeProps call, do nothing
                break;
            default:
                // single v-bind
                propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                    createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                        propsExpression
                    ])
                ]);
                break;
        }
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag,
        dynamicPropNames,
        shouldUseBlock
    };
}
// Dedupe props in an object literal.
// Literal duplicated attributes would have been warned during the parse phase,
// however, it's possible to encounter duplicated `onXXX` handlers with different
// modifiers. We also need to merge static and dynamic class / style attributes.
// - onXXX handlers / style: merge into array
// - class: merge into single expression with concatenation
function dedupeProperties(properties) {
    const knownProps = new Map();
    const deduped = [];
    for (let i = 0; i < properties.length; i++) {
        const prop = properties[i];
        // dynamic keys are always allowed
        if (prop.key.type === 8 /* COMPOUND_EXPRESSION */ || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === 'style' || name === 'class' || (0,shared_esm_bundler.isOn)(name)) {
                mergeAsArray(existing, prop);
            }
            // unexpected duplicate, should have emitted error during parse
        }
        else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function mergeAsArray(existing, incoming) {
    if (existing.value.type === 17 /* JS_ARRAY_EXPRESSION */) {
        existing.value.elements.push(incoming.value);
    }
    else {
        existing.value = createArrayExpression([existing.value, incoming.value], existing.loc);
    }
}
function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) {
        // built-in directive with runtime
        dirArgs.push(context.helperString(runtime));
    }
    else {
        {
            // inject statement for resolving directive
            context.helper(RESOLVE_DIRECTIVE);
            context.directives.add(dir.name);
            dirArgs.push(toValidAssetId(dir.name, `directive`));
        }
    }
    const { loc } = dir;
    if (dir.exp)
        dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) {
            dirArgs.push(`void 0`);
        }
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) {
                dirArgs.push(`void 0`);
            }
            dirArgs.push(`void 0`);
        }
        const trueExpression = createSimpleExpression(`true`, false, loc);
        dirArgs.push(createObjectExpression(dir.modifiers.map(modifier => createObjectProperty(modifier, trueExpression)), loc));
    }
    return createArrayExpression(dirArgs, dir.loc);
}
function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for (let i = 0, l = props.length; i < l; i++) {
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1)
            propsNamesString += ', ';
    }
    return propsNamesString + `]`;
}
function isComponentTag(tag) {
    return tag === 'component' || tag === 'Component';
}

( false)
    ? 0
    : {};
( false) ? 0 : [];
const cacheStringFunction = (fn) => {
    const cache = Object.create(null);
    return ((str) => {
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    });
};
const camelizeRE = /-(\w)/g;
/**
 * @private
 */
const camelize = cacheStringFunction((str) => {
    return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''));
});

const transformSlotOutlet = (node, context) => {
    if (isSlotOutlet(node)) {
        const { children, loc } = node;
        const { slotName, slotProps } = processSlotOutlet(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            '{}',
            'undefined',
            'true'
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = createFunctionExpression([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) {
            expectedLen = 5;
        }
        slotArgs.splice(expectedLen); // remove unused arguments
        node.codegenNode = createCallExpression(context.helper(RENDER_SLOT), slotArgs, loc);
    }
};
function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = undefined;
    const nonNameProps = [];
    for (let i = 0; i < node.props.length; i++) {
        const p = node.props[i];
        if (p.type === 6 /* ATTRIBUTE */) {
            if (p.value) {
                if (p.name === 'name') {
                    slotName = JSON.stringify(p.value.content);
                }
                else {
                    p.name = camelize(p.name);
                    nonNameProps.push(p);
                }
            }
        }
        else {
            if (p.name === 'bind' && isStaticArgOf(p.arg, 'name')) {
                if (p.exp)
                    slotName = p.exp;
            }
            else {
                if (p.name === 'bind' && p.arg && isStaticExp(p.arg)) {
                    p.arg.content = camelize(p.arg.content);
                }
                nonNameProps.push(p);
            }
        }
    }
    if (nonNameProps.length > 0) {
        const { props, directives } = buildProps(node, context, nonNameProps);
        slotProps = props;
        if (directives.length) {
            context.onError(createCompilerError(36 /* X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET */, directives[0].loc));
        }
    }
    return {
        slotName,
        slotProps
    };
}

const fnExpRE = /^\s*([\w$_]+|(async\s*)?\([^)]*?\))\s*=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const transformOn = (dir, node, context, augmentor) => {
    const { loc, modifiers, arg } = dir;
    if (!dir.exp && !modifiers.length) {
        context.onError(createCompilerError(35 /* X_V_ON_NO_EXPRESSION */, loc));
    }
    let eventName;
    if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
        if (arg.isStatic) {
            let rawName = arg.content;
            // TODO deprecate @vnodeXXX usage
            if (rawName.startsWith('vue:')) {
                rawName = `vnode-${rawName.slice(4)}`;
            }
            // for all event listeners, auto convert it to camelCase. See issue #2249
            eventName = createSimpleExpression((0,shared_esm_bundler.toHandlerKey)((0,shared_esm_bundler.camelize)(rawName)), true, arg.loc);
        }
        else {
            // #2388
            eventName = createCompoundExpression([
                `${context.helperString(TO_HANDLER_KEY)}(`,
                arg,
                `)`
            ]);
        }
    }
    else {
        // already a compound expression.
        eventName = arg;
        eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
        eventName.children.push(`)`);
    }
    // handler processing
    let exp = dir.exp;
    if (exp && !exp.content.trim()) {
        exp = undefined;
    }
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = isMemberExpression(exp.content);
        const isInlineStatement = !(isMemberExp || fnExpRE.test(exp.content));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (false) {}
        if (isInlineStatement || (shouldCache && isMemberExp)) {
            // wrap inline statement in a function expression
            exp = createCompoundExpression([
                `${isInlineStatement
                    ? `$event`
                    : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
                exp,
                hasMultipleStatements ? `}` : `)`
            ]);
        }
    }
    let ret = {
        props: [
            createObjectProperty(eventName, exp || createSimpleExpression(`() => {}`, false, loc))
        ]
    };
    // apply extended compiler augmentor
    if (augmentor) {
        ret = augmentor(ret);
    }
    if (shouldCache) {
        // cache handlers so that it's always the same handler being passed down.
        // this avoids unnecessary re-renders when users use inline handlers on
        // components.
        ret.props[0].value = context.cache(ret.props[0].value);
    }
    // mark the key as handler for props normalization check
    ret.props.forEach(p => (p.key.isHandlerKey = true));
    return ret;
};

// v-bind without arg is handled directly in ./transformElements.ts due to it affecting
// codegen for the entire props object. This transform here is only for v-bind
// *with* args.
const transformBind = (dir, _node, context) => {
    const { exp, modifiers, loc } = dir;
    const arg = dir.arg;
    if (arg.type !== 4 /* SIMPLE_EXPRESSION */) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    }
    else if (!arg.isStatic) {
        arg.content = `${arg.content} || ""`;
    }
    // .sync is replaced by v-model:arg
    if (modifiers.includes('camel')) {
        if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
            if (arg.isStatic) {
                arg.content = (0,shared_esm_bundler.camelize)(arg.content);
            }
            else {
                arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
            }
        }
        else {
            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.includes('prop')) {
            injectPrefix(arg, '.');
        }
        if (modifiers.includes('attr')) {
            injectPrefix(arg, '^');
        }
    }
    if (!exp ||
        (exp.type === 4 /* SIMPLE_EXPRESSION */ && !exp.content.trim())) {
        context.onError(createCompilerError(34 /* X_V_BIND_NO_EXPRESSION */, loc));
        return {
            props: [createObjectProperty(arg, createSimpleExpression('', true, loc))]
        };
    }
    return {
        props: [createObjectProperty(arg, exp)]
    };
};
const injectPrefix = (arg, prefix) => {
    if (arg.type === 4 /* SIMPLE_EXPRESSION */) {
        if (arg.isStatic) {
            arg.content = prefix + arg.content;
        }
        else {
            arg.content = `\`${prefix}\${${arg.content}}\``;
        }
    }
    else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};

// Merge adjacent text nodes and expressions into a single expression
// e.g. <div>abc {{ d }} {{ e }}</div> should have a single expression node as child.
const transformText = (node, context) => {
    if (node.type === 0 /* ROOT */ ||
        node.type === 1 /* ELEMENT */ ||
        node.type === 11 /* FOR */ ||
        node.type === 10 /* IF_BRANCH */) {
        // perform the transform on node exit so that all expressions have already
        // been processed.
        return () => {
            const children = node.children;
            let currentContainer = undefined;
            let hasText = false;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (isText(child)) {
                    hasText = true;
                    for (let j = i + 1; j < children.length; j++) {
                        const next = children[j];
                        if (isText(next)) {
                            if (!currentContainer) {
                                currentContainer = children[i] = {
                                    type: 8 /* COMPOUND_EXPRESSION */,
                                    loc: child.loc,
                                    children: [child]
                                };
                            }
                            // merge adjacent text node into current
                            currentContainer.children.push(` + `, next);
                            children.splice(j, 1);
                            j--;
                        }
                        else {
                            currentContainer = undefined;
                            break;
                        }
                    }
                }
            }
            if (!hasText ||
                // if this is a plain element with a single text child, leave it
                // as-is since the runtime has dedicated fast path for this by directly
                // setting textContent of the element.
                // for component root it's always normalized anyway.
                (children.length === 1 &&
                    (node.type === 0 /* ROOT */ ||
                        (node.type === 1 /* ELEMENT */ &&
                            node.tagType === 0 /* ELEMENT */ &&
                            // #3756
                            // custom directives can potentially add DOM elements arbitrarily,
                            // we need to avoid setting textContent of the element at runtime
                            // to avoid accidentally overwriting the DOM elements added
                            // by the user through custom directives.
                            !node.props.find(p => p.type === 7 /* DIRECTIVE */ &&
                                !context.directiveTransforms[p.name]) &&
                            // in compat mode, <template> tags with no special directives
                            // will be rendered as a fragment so its children must be
                            // converted into vnodes.
                            !(node.tag === 'template'))))) {
                return;
            }
            // pre-convert text nodes into createTextVNode(text) calls to avoid
            // runtime normalization.
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (isText(child) || child.type === 8 /* COMPOUND_EXPRESSION */) {
                    const callArgs = [];
                    // createTextVNode defaults to single whitespace, so if it is a
                    // single space the code could be an empty call to save bytes.
                    if (child.type !== 2 /* TEXT */ || child.content !== ' ') {
                        callArgs.push(child);
                    }
                    // mark dynamic text with flag so it gets patched inside a block
                    if (!context.ssr &&
                        getConstantType(child, context) === 0 /* NOT_CONSTANT */) {
                        callArgs.push(1 /* TEXT */ +
                            (( false) ? 0 : ``));
                    }
                    children[i] = {
                        type: 12 /* TEXT_CALL */,
                        content: child,
                        loc: child.loc,
                        codegenNode: createCallExpression(context.helper(CREATE_TEXT), callArgs)
                    };
                }
            }
        };
    }
};

const seen = new WeakSet();
const transformOnce = (node, context) => {
    if (node.type === 1 /* ELEMENT */ && findDir(node, 'once', true)) {
        if (seen.has(node) || context.inVOnce) {
            return;
        }
        seen.add(node);
        context.inVOnce = true;
        context.helper(SET_BLOCK_TRACKING);
        return () => {
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) {
                cur.codegenNode = context.cache(cur.codegenNode, true /* isVNode */);
            }
        };
    }
};

const transformModel = (dir, node, context) => {
    const { exp, arg } = dir;
    if (!exp) {
        context.onError(createCompilerError(41 /* X_V_MODEL_NO_EXPRESSION */, dir.loc));
        return createTransformProps();
    }
    const rawExp = exp.loc.source;
    const expString = exp.type === 4 /* SIMPLE_EXPRESSION */ ? exp.content : rawExp;
    // im SFC <script setup> inline mode, the exp may have been transformed into
    // _unref(exp)
    context.bindingMetadata[rawExp];
    const maybeRef = !true    /* SETUP_CONST */;
    if (!expString.trim() ||
        (!isMemberExpression(expString) && !maybeRef)) {
        context.onError(createCompilerError(42 /* X_V_MODEL_MALFORMED_EXPRESSION */, exp.loc));
        return createTransformProps();
    }
    const propName = arg ? arg : createSimpleExpression('modelValue', true);
    const eventName = arg
        ? isStaticExp(arg)
            ? `onUpdate:${arg.content}`
            : createCompoundExpression(['"onUpdate:" + ', arg])
        : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    {
        assignmentExp = createCompoundExpression([
            `${eventArg} => ((`,
            exp,
            `) = $event)`
        ]);
    }
    const props = [
        // modelValue: foo
        createObjectProperty(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        createObjectProperty(eventName, assignmentExp)
    ];
    // modelModifiers: { foo: true, "bar-baz": true }
    if (dir.modifiers.length && node.tagType === 1 /* COMPONENT */) {
        const modifiers = dir.modifiers
            .map(m => (isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`)
            .join(`, `);
        const modifiersKey = arg
            ? isStaticExp(arg)
                ? `${arg.content}Modifiers`
                : createCompoundExpression([arg, ' + "Modifiers"'])
            : `modelModifiers`;
        props.push(createObjectProperty(modifiersKey, createSimpleExpression(`{ ${modifiers} }`, false, dir.loc, 2 /* CAN_HOIST */)));
    }
    return createTransformProps(props);
};
function createTransformProps(props = []) {
    return { props };
}

const validDivisionCharRE = /[\w).+\-_$\]]/;
const transformFilter = (node, context) => {
    if (!isCompatEnabled("COMPILER_FILTER" /* COMPILER_FILTERS */, context)) {
        return;
    }
    if (node.type === 5 /* INTERPOLATION */) {
        // filter rewrite is applied before expression transform so only
        // simple expressions are possible at this stage
        rewriteFilter(node.content, context);
    }
    if (node.type === 1 /* ELEMENT */) {
        node.props.forEach((prop) => {
            if (prop.type === 7 /* DIRECTIVE */ &&
                prop.name !== 'for' &&
                prop.exp) {
                rewriteFilter(prop.exp, context);
            }
        });
    }
};
function rewriteFilter(node, context) {
    if (node.type === 4 /* SIMPLE_EXPRESSION */) {
        parseFilter(node, context);
    }
    else {
        for (let i = 0; i < node.children.length; i++) {
            const child = node.children[i];
            if (typeof child !== 'object')
                continue;
            if (child.type === 4 /* SIMPLE_EXPRESSION */) {
                parseFilter(child, context);
            }
            else if (child.type === 8 /* COMPOUND_EXPRESSION */) {
                rewriteFilter(node, context);
            }
            else if (child.type === 5 /* INTERPOLATION */) {
                rewriteFilter(child.content, context);
            }
        }
    }
}
function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c)
                inSingle = false;
        }
        else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c)
                inDouble = false;
        }
        else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c)
                inTemplateString = false;
        }
        else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c)
                inRegex = false;
        }
        else if (c === 0x7c && // pipe
            exp.charCodeAt(i + 1) !== 0x7c &&
            exp.charCodeAt(i - 1) !== 0x7c &&
            !curly &&
            !square &&
            !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            }
            else {
                pushFilter();
            }
        }
        else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                let j = i - 1;
                let p;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ')
                        break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    }
    else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        ( false) &&
            0;
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i], context);
        }
        node.content = expression;
    }
}
function wrapFilter(exp, filter, context) {
    context.helper(RESOLVE_FILTER);
    const i = filter.indexOf('(');
    if (i < 0) {
        context.filters.add(filter);
        return `${toValidAssetId(filter, 'filter')}(${exp})`;
    }
    else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${toValidAssetId(name, 'filter')}(${exp}${args !== ')' ? ',' + args : args}`;
    }
}

const seen$1 = new WeakSet();
const transformMemo = (node, context) => {
    if (node.type === 1 /* ELEMENT */) {
        const dir = findDir(node, 'memo');
        if (!dir || seen$1.has(node)) {
            return;
        }
        seen$1.add(node);
        return () => {
            const codegenNode = node.codegenNode ||
                context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13 /* VNODE_CALL */) {
                // non-component sub tree should be turned into a block
                if (node.tagType !== 1 /* COMPONENT */) {
                    makeBlock(codegenNode, context);
                }
                node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
                    dir.exp,
                    createFunctionExpression(undefined, codegenNode),
                    `_cache`,
                    String(context.cached++)
                ]);
            }
        };
    }
};

function getBaseTransformPreset(prefixIdentifiers) {
    return [
        [
            transformOnce,
            transformIf,
            transformMemo,
            transformFor,
            ...([transformFilter] ),
            ...(( false)
                    ? 0
                    : []),
            transformSlotOutlet,
            transformElement,
            trackSlotScopes,
            transformText
        ],
        {
            on: transformOn,
            bind: transformBind,
            model: transformModel
        }
    ];
}
// we name it `baseCompile` so that higher order compilers like
// @vue/compiler-dom can export `compile` while re-exporting everything else.
function baseCompile(template, options = {}) {
    const onError = options.onError || defaultOnError;
    const isModuleMode = options.mode === 'module';
    /* istanbul ignore if */
    {
        if (options.prefixIdentifiers === true) {
            onError(createCompilerError(46 /* X_PREFIX_ID_NOT_SUPPORTED */));
        }
        else if (isModuleMode) {
            onError(createCompilerError(47 /* X_MODULE_MODE_NOT_SUPPORTED */));
        }
    }
    const prefixIdentifiers = !true ;
    if (options.cacheHandlers) {
        onError(createCompilerError(48 /* X_CACHE_HANDLER_NOT_SUPPORTED */));
    }
    if (options.scopeId && !isModuleMode) {
        onError(createCompilerError(49 /* X_SCOPE_ID_NOT_SUPPORTED */));
    }
    const ast = (0,shared_esm_bundler.isString)(template) ? baseParse(template, options) : template;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(ast, (0,shared_esm_bundler.extend)({}, options, {
        prefixIdentifiers,
        nodeTransforms: [
            ...nodeTransforms,
            ...(options.nodeTransforms || []) // user transforms
        ],
        directiveTransforms: (0,shared_esm_bundler.extend)({}, directiveTransforms, options.directiveTransforms || {} // user transforms
        )
    }));
    return generate(ast, (0,shared_esm_bundler.extend)({}, options, {
        prefixIdentifiers
    }));
}

const noopDirectiveTransform = () => ({ props: [] });



;// CONCATENATED MODULE: ./node_modules/@vue/compiler-dom/dist/compiler-dom.esm-bundler.js




const V_MODEL_RADIO = Symbol(( false) ? 0 : ``);
const V_MODEL_CHECKBOX = Symbol(( false) ? 0 : ``);
const V_MODEL_TEXT = Symbol(( false) ? 0 : ``);
const V_MODEL_SELECT = Symbol(( false) ? 0 : ``);
const V_MODEL_DYNAMIC = Symbol(( false) ? 0 : ``);
const V_ON_WITH_MODIFIERS = Symbol(( false) ? 0 : ``);
const V_ON_WITH_KEYS = Symbol(( false) ? 0 : ``);
const V_SHOW = Symbol(( false) ? 0 : ``);
const TRANSITION = Symbol(( false) ? 0 : ``);
const TRANSITION_GROUP = Symbol(( false) ? 0 : ``);
registerRuntimeHelpers({
    [V_MODEL_RADIO]: `vModelRadio`,
    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
    [V_MODEL_TEXT]: `vModelText`,
    [V_MODEL_SELECT]: `vModelSelect`,
    [V_MODEL_DYNAMIC]: `vModelDynamic`,
    [V_ON_WITH_MODIFIERS]: `withModifiers`,
    [V_ON_WITH_KEYS]: `withKeys`,
    [V_SHOW]: `vShow`,
    [TRANSITION]: `Transition`,
    [TRANSITION_GROUP]: `TransitionGroup`
});

/* eslint-disable no-restricted-globals */
let decoder;
function decodeHtmlBrowser(raw, asAttr = false) {
    if (!decoder) {
        decoder = document.createElement('div');
    }
    if (asAttr) {
        decoder.innerHTML = `<div foo="${raw.replace(/"/g, '&quot;')}">`;
        return decoder.children[0].getAttribute('foo');
    }
    else {
        decoder.innerHTML = raw;
        return decoder.textContent;
    }
}

const isRawTextContainer = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)('style,iframe,script,noscript', true);
const parserOptions = {
    isVoidTag: shared_esm_bundler.isVoidTag,
    isNativeTag: tag => (0,shared_esm_bundler.isHTMLTag)(tag) || (0,shared_esm_bundler.isSVGTag)(tag),
    isPreTag: tag => tag === 'pre',
    decodeEntities: decodeHtmlBrowser ,
    isBuiltInComponent: (tag) => {
        if (isBuiltInType(tag, `Transition`)) {
            return TRANSITION;
        }
        else if (isBuiltInType(tag, `TransitionGroup`)) {
            return TRANSITION_GROUP;
        }
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace(tag, parent) {
        let ns = parent ? parent.ns : 0 /* HTML */;
        if (parent && ns === 2 /* MATH_ML */) {
            if (parent.tag === 'annotation-xml') {
                if (tag === 'svg') {
                    return 1 /* SVG */;
                }
                if (parent.props.some(a => a.type === 6 /* ATTRIBUTE */ &&
                    a.name === 'encoding' &&
                    a.value != null &&
                    (a.value.content === 'text/html' ||
                        a.value.content === 'application/xhtml+xml'))) {
                    ns = 0 /* HTML */;
                }
            }
            else if (/^m(?:[ions]|text)$/.test(parent.tag) &&
                tag !== 'mglyph' &&
                tag !== 'malignmark') {
                ns = 0 /* HTML */;
            }
        }
        else if (parent && ns === 1 /* SVG */) {
            if (parent.tag === 'foreignObject' ||
                parent.tag === 'desc' ||
                parent.tag === 'title') {
                ns = 0 /* HTML */;
            }
        }
        if (ns === 0 /* HTML */) {
            if (tag === 'svg') {
                return 1 /* SVG */;
            }
            if (tag === 'math') {
                return 2 /* MATH_ML */;
            }
        }
        return ns;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#parsing-html-fragments
    getTextMode({ tag, ns }) {
        if (ns === 0 /* HTML */) {
            if (tag === 'textarea' || tag === 'title') {
                return 1 /* RCDATA */;
            }
            if (isRawTextContainer(tag)) {
                return 2 /* RAWTEXT */;
            }
        }
        return 0 /* DATA */;
    }
};

// Parse inline CSS strings for static style attributes into an object.
// This is a NodeTransform since it works on the static `style` attribute and
// converts it into a dynamic equivalent:
// style="color: red" -> :style='{ "color": "red" }'
// It is then processed by `transformElement` and included in the generated
// props.
const transformStyle = node => {
    if (node.type === 1 /* ELEMENT */) {
        node.props.forEach((p, i) => {
            if (p.type === 6 /* ATTRIBUTE */ && p.name === 'style' && p.value) {
                // replace p with an expression node
                node.props[i] = {
                    type: 7 /* DIRECTIVE */,
                    name: `bind`,
                    arg: createSimpleExpression(`style`, true, p.loc),
                    exp: parseInlineCSS(p.value.content, p.loc),
                    modifiers: [],
                    loc: p.loc
                };
            }
        });
    }
};
const parseInlineCSS = (cssText, loc) => {
    const normalized = (0,shared_esm_bundler.parseStringStyle)(cssText);
    return createSimpleExpression(JSON.stringify(normalized), false, loc, 3 /* CAN_STRINGIFY */);
};

function createDOMCompilerError(code, loc) {
    return createCompilerError(code, loc,  false ? 0 : undefined);
}
const DOMErrorMessages = {
    [50 /* X_V_HTML_NO_EXPRESSION */]: `v-html is missing expression.`,
    [51 /* X_V_HTML_WITH_CHILDREN */]: `v-html will override element children.`,
    [52 /* X_V_TEXT_NO_EXPRESSION */]: `v-text is missing expression.`,
    [53 /* X_V_TEXT_WITH_CHILDREN */]: `v-text will override element children.`,
    [54 /* X_V_MODEL_ON_INVALID_ELEMENT */]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [55 /* X_V_MODEL_ARG_ON_ELEMENT */]: `v-model argument is not supported on plain elements.`,
    [56 /* X_V_MODEL_ON_FILE_INPUT_ELEMENT */]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [57 /* X_V_MODEL_UNNECESSARY_VALUE */]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [58 /* X_V_SHOW_NO_EXPRESSION */]: `v-show is missing expression.`,
    [59 /* X_TRANSITION_INVALID_CHILDREN */]: `<Transition> expects exactly one child element or component.`,
    [60 /* X_IGNORED_SIDE_EFFECT_TAG */]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};

const transformVHtml = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
        context.onError(createDOMCompilerError(50 /* X_V_HTML_NO_EXPRESSION */, loc));
    }
    if (node.children.length) {
        context.onError(createDOMCompilerError(51 /* X_V_HTML_WITH_CHILDREN */, loc));
        node.children.length = 0;
    }
    return {
        props: [
            createObjectProperty(createSimpleExpression(`innerHTML`, true, loc), exp || createSimpleExpression('', true))
        ]
    };
};

const transformVText = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
        context.onError(createDOMCompilerError(52 /* X_V_TEXT_NO_EXPRESSION */, loc));
    }
    if (node.children.length) {
        context.onError(createDOMCompilerError(53 /* X_V_TEXT_WITH_CHILDREN */, loc));
        node.children.length = 0;
    }
    return {
        props: [
            createObjectProperty(createSimpleExpression(`textContent`, true), exp
                ? createCallExpression(context.helperString(TO_DISPLAY_STRING), [exp], loc)
                : createSimpleExpression('', true))
        ]
    };
};

const compiler_dom_esm_bundler_transformModel = (dir, node, context) => {
    const baseResult = transformModel(dir, node, context);
    // base transform has errors OR component v-model (only need props)
    if (!baseResult.props.length || node.tagType === 1 /* COMPONENT */) {
        return baseResult;
    }
    if (dir.arg) {
        context.onError(createDOMCompilerError(55 /* X_V_MODEL_ARG_ON_ELEMENT */, dir.arg.loc));
    }
    function checkDuplicatedValue() {
        const value = findProp(node, 'value');
        if (value) {
            context.onError(createDOMCompilerError(57 /* X_V_MODEL_UNNECESSARY_VALUE */, value.loc));
        }
    }
    const { tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === 'input' ||
        tag === 'textarea' ||
        tag === 'select' ||
        isCustomElement) {
        let directiveToUse = V_MODEL_TEXT;
        let isInvalidType = false;
        if (tag === 'input' || isCustomElement) {
            const type = findProp(node, `type`);
            if (type) {
                if (type.type === 7 /* DIRECTIVE */) {
                    // :type="foo"
                    directiveToUse = V_MODEL_DYNAMIC;
                }
                else if (type.value) {
                    switch (type.value.content) {
                        case 'radio':
                            directiveToUse = V_MODEL_RADIO;
                            break;
                        case 'checkbox':
                            directiveToUse = V_MODEL_CHECKBOX;
                            break;
                        case 'file':
                            isInvalidType = true;
                            context.onError(createDOMCompilerError(56 /* X_V_MODEL_ON_FILE_INPUT_ELEMENT */, dir.loc));
                            break;
                        default:
                            // text type
                            ( false) && 0;
                            break;
                    }
                }
            }
            else if (hasDynamicKeyVBind(node)) {
                // element has bindings with dynamic keys, which can possibly contain
                // "type".
                directiveToUse = V_MODEL_DYNAMIC;
            }
            else {
                // text type
                ( false) && 0;
            }
        }
        else if (tag === 'select') {
            directiveToUse = V_MODEL_SELECT;
        }
        else {
            // textarea
            ( false) && 0;
        }
        // inject runtime directive
        // by returning the helper symbol via needRuntime
        // the import will replaced a resolveDirective call.
        if (!isInvalidType) {
            baseResult.needRuntime = context.helper(directiveToUse);
        }
    }
    else {
        context.onError(createDOMCompilerError(54 /* X_V_MODEL_ON_INVALID_ELEMENT */, dir.loc));
    }
    // native vmodel doesn't need the `modelValue` props since they are also
    // passed to the runtime as `binding.value`. removing it reduces code size.
    baseResult.props = baseResult.props.filter(p => !(p.key.type === 4 /* SIMPLE_EXPRESSION */ &&
        p.key.content === 'modelValue'));
    return baseResult;
};

const isEventOptionModifier = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)(`passive,once,capture`);
const isNonKeyModifier = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)(
// event propagation management
`stop,prevent,self,` +
    // system modifiers + exact
    `ctrl,shift,alt,meta,exact,` +
    // mouse
    `middle`);
// left & right could be mouse or key modifiers based on event type
const maybeKeyModifier = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)('left,right');
const isKeyboardEvent = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)(`onkeyup,onkeydown,onkeypress`, true);
const resolveModifiers = (key, modifiers, context, loc) => {
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for (let i = 0; i < modifiers.length; i++) {
        const modifier = modifiers[i];
        if (modifier === 'native' &&
            checkCompatEnabled("COMPILER_V_ON_NATIVE" /* COMPILER_V_ON_NATIVE */, context, loc)) {
            eventOptionModifiers.push(modifier);
        }
        else if (isEventOptionModifier(modifier)) {
            // eventOptionModifiers: modifiers for addEventListener() options,
            // e.g. .passive & .capture
            eventOptionModifiers.push(modifier);
        }
        else {
            // runtimeModifiers: modifiers that needs runtime guards
            if (maybeKeyModifier(modifier)) {
                if (isStaticExp(key)) {
                    if (isKeyboardEvent(key.content)) {
                        keyModifiers.push(modifier);
                    }
                    else {
                        nonKeyModifiers.push(modifier);
                    }
                }
                else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            }
            else {
                if (isNonKeyModifier(modifier)) {
                    nonKeyModifiers.push(modifier);
                }
                else {
                    keyModifiers.push(modifier);
                }
            }
        }
    }
    return {
        keyModifiers,
        nonKeyModifiers,
        eventOptionModifiers
    };
};
const transformClick = (key, event) => {
    const isStaticClick = isStaticExp(key) && key.content.toLowerCase() === 'onclick';
    return isStaticClick
        ? createSimpleExpression(event, true)
        : key.type !== 4 /* SIMPLE_EXPRESSION */
            ? createCompoundExpression([
                `(`,
                key,
                `) === "onClick" ? "${event}" : (`,
                key,
                `)`
            ])
            : key;
};
const compiler_dom_esm_bundler_transformOn = (dir, node, context) => {
    return transformOn(dir, node, context, baseResult => {
        const { modifiers } = dir;
        if (!modifiers.length)
            return baseResult;
        let { key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
        // normalize click.right and click.middle since they don't actually fire
        if (nonKeyModifiers.includes('right')) {
            key = transformClick(key, `onContextmenu`);
        }
        if (nonKeyModifiers.includes('middle')) {
            key = transformClick(key, `onMouseup`);
        }
        if (nonKeyModifiers.length) {
            handlerExp = createCallExpression(context.helper(V_ON_WITH_MODIFIERS), [
                handlerExp,
                JSON.stringify(nonKeyModifiers)
            ]);
        }
        if (keyModifiers.length &&
            // if event name is dynamic, always wrap with keys guard
            (!isStaticExp(key) || isKeyboardEvent(key.content))) {
            handlerExp = createCallExpression(context.helper(V_ON_WITH_KEYS), [
                handlerExp,
                JSON.stringify(keyModifiers)
            ]);
        }
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map(shared_esm_bundler.capitalize).join('');
            key = isStaticExp(key)
                ? createSimpleExpression(`${key.content}${modifierPostfix}`, true)
                : createCompoundExpression([`(`, key, `) + "${modifierPostfix}"`]);
        }
        return {
            props: [createObjectProperty(key, handlerExp)]
        };
    });
};

const transformShow = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
        context.onError(createDOMCompilerError(58 /* X_V_SHOW_NO_EXPRESSION */, loc));
    }
    return {
        props: [],
        needRuntime: context.helper(V_SHOW)
    };
};

const warnTransitionChildren = (node, context) => {
    if (node.type === 1 /* ELEMENT */ &&
        node.tagType === 1 /* COMPONENT */) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === TRANSITION) {
            return () => {
                if (node.children.length && hasMultipleChildren(node)) {
                    context.onError(createDOMCompilerError(59 /* X_TRANSITION_INVALID_CHILDREN */, {
                        start: node.children[0].loc.start,
                        end: node.children[node.children.length - 1].loc.end,
                        source: ''
                    }));
                }
            };
        }
    }
};
function hasMultipleChildren(node) {
    // #1352 filter out potential comment nodes.
    const children = (node.children = node.children.filter(c => c.type !== 3 /* COMMENT */ &&
        !(c.type === 2 /* TEXT */ && !c.content.trim())));
    const child = children[0];
    return (children.length !== 1 ||
        child.type === 11 /* FOR */ ||
        (child.type === 9 /* IF */ && child.branches.some(hasMultipleChildren)));
}

const ignoreSideEffectTags = (node, context) => {
    if (node.type === 1 /* ELEMENT */ &&
        node.tagType === 0 /* ELEMENT */ &&
        (node.tag === 'script' || node.tag === 'style')) {
        context.onError(createDOMCompilerError(60 /* X_IGNORED_SIDE_EFFECT_TAG */, node.loc));
        context.removeNode();
    }
};

const DOMNodeTransforms = [
    transformStyle,
    ...(( false) ? 0 : [])
];
const DOMDirectiveTransforms = {
    cloak: noopDirectiveTransform,
    html: transformVHtml,
    text: transformVText,
    model: compiler_dom_esm_bundler_transformModel,
    on: compiler_dom_esm_bundler_transformOn,
    show: transformShow
};
function compile(template, options = {}) {
    return baseCompile(template, (0,shared_esm_bundler.extend)({}, parserOptions, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            ignoreSideEffectTags,
            ...DOMNodeTransforms,
            ...(options.nodeTransforms || [])
        ],
        directiveTransforms: (0,shared_esm_bundler.extend)({}, DOMDirectiveTransforms, options.directiveTransforms || {}),
        transformHoist: null 
    }));
}
function parse(template, options = {}) {
    return baseParse(template, (0,shared_esm_bundler.extend)({}, parserOptions, options));
}




/***/ }),

/***/ 229:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BaseTransition": () => (/* reexport */ BaseTransition),
  "Comment": () => (/* reexport */ Comment),
  "EffectScope": () => (/* reexport */ EffectScope),
  "Fragment": () => (/* reexport */ Fragment),
  "KeepAlive": () => (/* reexport */ KeepAlive),
  "ReactiveEffect": () => (/* reexport */ ReactiveEffect),
  "Static": () => (/* reexport */ Static),
  "Suspense": () => (/* reexport */ Suspense),
  "Teleport": () => (/* reexport */ Teleport),
  "Text": () => (/* reexport */ Text),
  "Transition": () => (/* binding */ Transition),
  "TransitionGroup": () => (/* binding */ TransitionGroup),
  "VueElement": () => (/* binding */ VueElement),
  "callWithAsyncErrorHandling": () => (/* reexport */ callWithAsyncErrorHandling),
  "callWithErrorHandling": () => (/* reexport */ callWithErrorHandling),
  "camelize": () => (/* reexport */ shared_esm_bundler.camelize),
  "capitalize": () => (/* reexport */ shared_esm_bundler.capitalize),
  "cloneVNode": () => (/* reexport */ cloneVNode),
  "compatUtils": () => (/* reexport */ compatUtils),
  "computed": () => (/* reexport */ runtime_core_esm_bundler_computed),
  "createApp": () => (/* binding */ createApp),
  "createBlock": () => (/* reexport */ createBlock),
  "createCommentVNode": () => (/* reexport */ createCommentVNode),
  "createElementBlock": () => (/* reexport */ createElementBlock),
  "createElementVNode": () => (/* reexport */ createBaseVNode),
  "createHydrationRenderer": () => (/* reexport */ createHydrationRenderer),
  "createPropsRestProxy": () => (/* reexport */ createPropsRestProxy),
  "createRenderer": () => (/* reexport */ createRenderer),
  "createSSRApp": () => (/* binding */ createSSRApp),
  "createSlots": () => (/* reexport */ createSlots),
  "createStaticVNode": () => (/* reexport */ createStaticVNode),
  "createTextVNode": () => (/* reexport */ createTextVNode),
  "createVNode": () => (/* reexport */ createVNode),
  "customRef": () => (/* reexport */ customRef),
  "defineAsyncComponent": () => (/* reexport */ defineAsyncComponent),
  "defineComponent": () => (/* reexport */ defineComponent),
  "defineCustomElement": () => (/* binding */ defineCustomElement),
  "defineEmits": () => (/* reexport */ defineEmits),
  "defineExpose": () => (/* reexport */ defineExpose),
  "defineProps": () => (/* reexport */ defineProps),
  "defineSSRCustomElement": () => (/* binding */ defineSSRCustomElement),
  "devtools": () => (/* reexport */ devtools),
  "effect": () => (/* reexport */ effect),
  "effectScope": () => (/* reexport */ effectScope),
  "getCurrentInstance": () => (/* reexport */ getCurrentInstance),
  "getCurrentScope": () => (/* reexport */ getCurrentScope),
  "getTransitionRawChildren": () => (/* reexport */ getTransitionRawChildren),
  "guardReactiveProps": () => (/* reexport */ guardReactiveProps),
  "h": () => (/* reexport */ h),
  "handleError": () => (/* reexport */ handleError),
  "hydrate": () => (/* binding */ hydrate),
  "initCustomFormatter": () => (/* reexport */ initCustomFormatter),
  "initDirectivesForSSR": () => (/* binding */ initDirectivesForSSR),
  "inject": () => (/* reexport */ inject),
  "isMemoSame": () => (/* reexport */ isMemoSame),
  "isProxy": () => (/* reexport */ isProxy),
  "isReactive": () => (/* reexport */ isReactive),
  "isReadonly": () => (/* reexport */ isReadonly),
  "isRef": () => (/* reexport */ isRef),
  "isRuntimeOnly": () => (/* reexport */ runtime_core_esm_bundler_isRuntimeOnly),
  "isShallow": () => (/* reexport */ isShallow),
  "isVNode": () => (/* reexport */ isVNode),
  "markRaw": () => (/* reexport */ markRaw),
  "mergeDefaults": () => (/* reexport */ mergeDefaults),
  "mergeProps": () => (/* reexport */ mergeProps),
  "nextTick": () => (/* reexport */ nextTick),
  "normalizeClass": () => (/* reexport */ shared_esm_bundler.normalizeClass),
  "normalizeProps": () => (/* reexport */ shared_esm_bundler.normalizeProps),
  "normalizeStyle": () => (/* reexport */ shared_esm_bundler.normalizeStyle),
  "onActivated": () => (/* reexport */ onActivated),
  "onBeforeMount": () => (/* reexport */ onBeforeMount),
  "onBeforeUnmount": () => (/* reexport */ onBeforeUnmount),
  "onBeforeUpdate": () => (/* reexport */ onBeforeUpdate),
  "onDeactivated": () => (/* reexport */ onDeactivated),
  "onErrorCaptured": () => (/* reexport */ onErrorCaptured),
  "onMounted": () => (/* reexport */ onMounted),
  "onRenderTracked": () => (/* reexport */ onRenderTracked),
  "onRenderTriggered": () => (/* reexport */ onRenderTriggered),
  "onScopeDispose": () => (/* reexport */ onScopeDispose),
  "onServerPrefetch": () => (/* reexport */ onServerPrefetch),
  "onUnmounted": () => (/* reexport */ onUnmounted),
  "onUpdated": () => (/* reexport */ onUpdated),
  "openBlock": () => (/* reexport */ openBlock),
  "popScopeId": () => (/* reexport */ popScopeId),
  "provide": () => (/* reexport */ provide),
  "proxyRefs": () => (/* reexport */ proxyRefs),
  "pushScopeId": () => (/* reexport */ pushScopeId),
  "queuePostFlushCb": () => (/* reexport */ queuePostFlushCb),
  "reactive": () => (/* reexport */ reactive),
  "readonly": () => (/* reexport */ readonly),
  "ref": () => (/* reexport */ ref),
  "registerRuntimeCompiler": () => (/* reexport */ registerRuntimeCompiler),
  "render": () => (/* binding */ render),
  "renderList": () => (/* reexport */ renderList),
  "renderSlot": () => (/* reexport */ renderSlot),
  "resolveComponent": () => (/* reexport */ resolveComponent),
  "resolveDirective": () => (/* reexport */ resolveDirective),
  "resolveDynamicComponent": () => (/* reexport */ resolveDynamicComponent),
  "resolveFilter": () => (/* reexport */ resolveFilter),
  "resolveTransitionHooks": () => (/* reexport */ resolveTransitionHooks),
  "setBlockTracking": () => (/* reexport */ setBlockTracking),
  "setDevtoolsHook": () => (/* reexport */ setDevtoolsHook),
  "setTransitionHooks": () => (/* reexport */ setTransitionHooks),
  "shallowReactive": () => (/* reexport */ shallowReactive),
  "shallowReadonly": () => (/* reexport */ shallowReadonly),
  "shallowRef": () => (/* reexport */ shallowRef),
  "ssrContextKey": () => (/* reexport */ ssrContextKey),
  "ssrUtils": () => (/* reexport */ ssrUtils),
  "stop": () => (/* reexport */ stop),
  "toDisplayString": () => (/* reexport */ shared_esm_bundler.toDisplayString),
  "toHandlerKey": () => (/* reexport */ shared_esm_bundler.toHandlerKey),
  "toHandlers": () => (/* reexport */ toHandlers),
  "toRaw": () => (/* reexport */ reactivity_esm_bundler_toRaw),
  "toRef": () => (/* reexport */ toRef),
  "toRefs": () => (/* reexport */ toRefs),
  "transformVNodeArgs": () => (/* reexport */ transformVNodeArgs),
  "triggerRef": () => (/* reexport */ triggerRef),
  "unref": () => (/* reexport */ unref),
  "useAttrs": () => (/* reexport */ useAttrs),
  "useCssModule": () => (/* binding */ useCssModule),
  "useCssVars": () => (/* binding */ useCssVars),
  "useSSRContext": () => (/* reexport */ useSSRContext),
  "useSlots": () => (/* reexport */ useSlots),
  "useTransitionState": () => (/* reexport */ useTransitionState),
  "vModelCheckbox": () => (/* binding */ vModelCheckbox),
  "vModelDynamic": () => (/* binding */ vModelDynamic),
  "vModelRadio": () => (/* binding */ vModelRadio),
  "vModelSelect": () => (/* binding */ vModelSelect),
  "vModelText": () => (/* binding */ vModelText),
  "vShow": () => (/* binding */ vShow),
  "version": () => (/* reexport */ version),
  "warn": () => (/* reexport */ runtime_core_esm_bundler_warn),
  "watch": () => (/* reexport */ watch),
  "watchEffect": () => (/* reexport */ watchEffect),
  "watchPostEffect": () => (/* reexport */ watchPostEffect),
  "watchSyncEffect": () => (/* reexport */ watchSyncEffect),
  "withAsyncContext": () => (/* reexport */ withAsyncContext),
  "withCtx": () => (/* reexport */ withCtx),
  "withDefaults": () => (/* reexport */ withDefaults),
  "withDirectives": () => (/* reexport */ withDirectives),
  "withKeys": () => (/* binding */ withKeys),
  "withMemo": () => (/* reexport */ withMemo),
  "withModifiers": () => (/* binding */ withModifiers),
  "withScopeId": () => (/* reexport */ withScopeId)
});

// EXTERNAL MODULE: ./node_modules/@vue/shared/dist/shared.esm-bundler.js
var shared_esm_bundler = __webpack_require__(577);
;// CONCATENATED MODULE: ./node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js


function reactivity_esm_bundler_warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}

let activeEffectScope;
class EffectScope {
    constructor(detached = false) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        if (!detached && activeEffectScope) {
            this.parent = activeEffectScope;
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    run(fn) {
        if (this.active) {
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = this.parent;
            }
        }
        else if ((false)) {}
    }
    on() {
        activeEffectScope = this;
    }
    off() {
        activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].stop();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function recordEffectScope(effect, scope = activeEffectScope) {
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {}
}

const createDep = (effects) => {
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const wasTracked = (dep) => (dep.w & trackOpBit) > 0;
const newTracked = (dep) => (dep.n & trackOpBit) > 0;
const initDepMarkers = ({ deps }) => {
    if (deps.length) {
        for (let i = 0; i < deps.length; i++) {
            deps[i].w |= trackOpBit; // set was tracked
        }
    }
};
const finalizeDepMarkers = (effect) => {
    const { deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for (let i = 0; i < deps.length; i++) {
            const dep = deps[i];
            if (wasTracked(dep) && !newTracked(dep)) {
                dep.delete(effect);
            }
            else {
                deps[ptr++] = dep;
            }
            // clear bits
            dep.w &= ~trackOpBit;
            dep.n &= ~trackOpBit;
        }
        deps.length = ptr;
    }
};

const targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let effectTrackDepth = 0;
let trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */
const maxMarkerBits = 30;
let activeEffect;
const ITERATE_KEY = Symbol(( false) ? 0 : '');
const MAP_KEY_ITERATE_KEY = Symbol(( false) ? 0 : '');
class ReactiveEffect {
    constructor(fn, scheduler = null, scope) {
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = undefined;
        recordEffectScope(this, scope);
    }
    run() {
        if (!this.active) {
            return this.fn();
        }
        let parent = activeEffect;
        let lastShouldTrack = shouldTrack;
        while (parent) {
            if (parent === this) {
                return;
            }
            parent = parent.parent;
        }
        try {
            this.parent = activeEffect;
            activeEffect = this;
            shouldTrack = true;
            trackOpBit = 1 << ++effectTrackDepth;
            if (effectTrackDepth <= maxMarkerBits) {
                initDepMarkers(this);
            }
            else {
                cleanupEffect(this);
            }
            return this.fn();
        }
        finally {
            if (effectTrackDepth <= maxMarkerBits) {
                finalizeDepMarkers(this);
            }
            trackOpBit = 1 << --effectTrackDepth;
            activeEffect = this.parent;
            shouldTrack = lastShouldTrack;
            this.parent = undefined;
        }
    }
    stop() {
        if (this.active) {
            cleanupEffect(this);
            if (this.onStop) {
                this.onStop();
            }
            this.active = false;
        }
    }
}
function cleanupEffect(effect) {
    const { deps } = effect;
    if (deps.length) {
        for (let i = 0; i < deps.length; i++) {
            deps[i].delete(effect);
        }
        deps.length = 0;
    }
}
function effect(fn, options) {
    if (fn.effect) {
        fn = fn.effect.fn;
    }
    const _effect = new ReactiveEffect(fn);
    if (options) {
        (0,shared_esm_bundler.extend)(_effect, options);
        if (options.scope)
            recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) {
        _effect.run();
    }
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === undefined ? true : last;
}
function track(target, type, key) {
    if (shouldTrack && activeEffect) {
        let depsMap = targetMap.get(target);
        if (!depsMap) {
            targetMap.set(target, (depsMap = new Map()));
        }
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, (dep = createDep()));
        }
        const eventInfo = ( false)
            ? 0
            : undefined;
        trackEffects(dep, eventInfo);
    }
}
function trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if (effectTrackDepth <= maxMarkerBits) {
        if (!newTracked(dep)) {
            dep.n |= trackOpBit; // set newly tracked
            shouldTrack = !wasTracked(dep);
        }
    }
    else {
        // Full cleanup mode.
        shouldTrack = !dep.has(activeEffect);
    }
    if (shouldTrack) {
        dep.add(activeEffect);
        activeEffect.deps.push(dep);
        if (false) {}
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
        // never been tracked
        return;
    }
    let deps = [];
    if (type === "clear" /* CLEAR */) {
        // collection being cleared
        // trigger all effects for target
        deps = [...depsMap.values()];
    }
    else if (key === 'length' && (0,shared_esm_bundler.isArray)(target)) {
        depsMap.forEach((dep, key) => {
            if (key === 'length' || key >= newValue) {
                deps.push(dep);
            }
        });
    }
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) {
            deps.push(depsMap.get(key));
        }
        // also run for iteration key on ADD | DELETE | Map.SET
        switch (type) {
            case "add" /* ADD */:
                if (!(0,shared_esm_bundler.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0,shared_esm_bundler.isMap)(target)) {
                        deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                }
                else if ((0,shared_esm_bundler.isIntegerKey)(key)) {
                    // new index added to array -> length changes
                    deps.push(depsMap.get('length'));
                }
                break;
            case "delete" /* DELETE */:
                if (!(0,shared_esm_bundler.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0,shared_esm_bundler.isMap)(target)) {
                        deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                }
                break;
            case "set" /* SET */:
                if ((0,shared_esm_bundler.isMap)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                }
                break;
        }
    }
    const eventInfo = ( false)
        ? 0
        : undefined;
    if (deps.length === 1) {
        if (deps[0]) {
            if ((false)) {}
            else {
                triggerEffects(deps[0]);
            }
        }
    }
    else {
        const effects = [];
        for (const dep of deps) {
            if (dep) {
                effects.push(...dep);
            }
        }
        if ((false)) {}
        else {
            triggerEffects(createDep(effects));
        }
    }
}
function triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    for (const effect of (0,shared_esm_bundler.isArray)(dep) ? dep : [...dep]) {
        if (effect !== activeEffect || effect.allowRecurse) {
            if (false) {}
            if (effect.scheduler) {
                effect.scheduler();
            }
            else {
                effect.run();
            }
        }
    }
}

const isNonTrackableKeys = /*#__PURE__*/ (0,shared_esm_bundler.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol)
    .map(key => Symbol[key])
    .filter(shared_esm_bundler.isSymbol));
const get = /*#__PURE__*/ createGetter();
const shallowGet = /*#__PURE__*/ createGetter(false, true);
const readonlyGet = /*#__PURE__*/ createGetter(true);
const shallowReadonlyGet = /*#__PURE__*/ createGetter(true, true);
const arrayInstrumentations = /*#__PURE__*/ createArrayInstrumentations();
function createArrayInstrumentations() {
    const instrumentations = {};
    ['includes', 'indexOf', 'lastIndexOf'].forEach(key => {
        instrumentations[key] = function (...args) {
            const arr = reactivity_esm_bundler_toRaw(this);
            for (let i = 0, l = this.length; i < l; i++) {
                track(arr, "get" /* GET */, i + '');
            }
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) {
                // if that didn't work, run it again using raw values.
                return arr[key](...args.map(reactivity_esm_bundler_toRaw));
            }
            else {
                return res;
            }
        };
    });
    ['push', 'pop', 'shift', 'unshift', 'splice'].forEach(key => {
        instrumentations[key] = function (...args) {
            pauseTracking();
            const res = reactivity_esm_bundler_toRaw(this)[key].apply(this, args);
            resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* IS_REACTIVE */) {
            return !isReadonly;
        }
        else if (key === "__v_isReadonly" /* IS_READONLY */) {
            return isReadonly;
        }
        else if (key === "__v_isShallow" /* IS_SHALLOW */) {
            return shallow;
        }
        else if (key === "__v_raw" /* RAW */ &&
            receiver ===
                (isReadonly
                    ? shallow
                        ? shallowReadonlyMap
                        : readonlyMap
                    : shallow
                        ? shallowReactiveMap
                        : reactiveMap).get(target)) {
            return target;
        }
        const targetIsArray = (0,shared_esm_bundler.isArray)(target);
        if (!isReadonly && targetIsArray && (0,shared_esm_bundler.hasOwn)(arrayInstrumentations, key)) {
            return Reflect.get(arrayInstrumentations, key, receiver);
        }
        const res = Reflect.get(target, key, receiver);
        if ((0,shared_esm_bundler.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
            return res;
        }
        if (!isReadonly) {
            track(target, "get" /* GET */, key);
        }
        if (shallow) {
            return res;
        }
        if (isRef(res)) {
            // ref unwrapping - does not apply for Array + integer key.
            const shouldUnwrap = !targetIsArray || !(0,shared_esm_bundler.isIntegerKey)(key);
            return shouldUnwrap ? res.value : res;
        }
        if ((0,shared_esm_bundler.isObject)(res)) {
            // Convert returned value into a proxy as well. we do the isObject check
            // here to avoid invalid value warning. Also need to lazy access readonly
            // and reactive here to avoid circular dependency.
            return isReadonly ? readonly(res) : reactive(res);
        }
        return res;
    };
}
const set = /*#__PURE__*/ createSetter();
const shallowSet = /*#__PURE__*/ createSetter(true);
function createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if (isReadonly(oldValue) && isRef(oldValue) && !isRef(value)) {
            return false;
        }
        if (!shallow && !isReadonly(value)) {
            if (!isShallow(value)) {
                value = reactivity_esm_bundler_toRaw(value);
                oldValue = reactivity_esm_bundler_toRaw(oldValue);
            }
            if (!(0,shared_esm_bundler.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0,shared_esm_bundler.isArray)(target) && (0,shared_esm_bundler.isIntegerKey)(key)
            ? Number(key) < target.length
            : (0,shared_esm_bundler.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === reactivity_esm_bundler_toRaw(receiver)) {
            if (!hadKey) {
                trigger(target, "add" /* ADD */, key, value);
            }
            else if ((0,shared_esm_bundler.hasChanged)(value, oldValue)) {
                trigger(target, "set" /* SET */, key, value, oldValue);
            }
        }
        return result;
    };
}
function deleteProperty(target, key) {
    const hadKey = (0,shared_esm_bundler.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
        trigger(target, "delete" /* DELETE */, key, undefined, oldValue);
    }
    return result;
}
function has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0,shared_esm_bundler.isSymbol)(key) || !builtInSymbols.has(key)) {
        track(target, "has" /* HAS */, key);
    }
    return result;
}
function ownKeys(target) {
    track(target, "iterate" /* ITERATE */, (0,shared_esm_bundler.isArray)(target) ? 'length' : ITERATE_KEY);
    return Reflect.ownKeys(target);
}
const mutableHandlers = {
    get,
    set,
    deleteProperty,
    has,
    ownKeys
};
const readonlyHandlers = {
    get: readonlyGet,
    set(target, key) {
        if ((false)) {}
        return true;
    },
    deleteProperty(target, key) {
        if ((false)) {}
        return true;
    }
};
const shallowReactiveHandlers = /*#__PURE__*/ (0,shared_esm_bundler.extend)({}, mutableHandlers, {
    get: shallowGet,
    set: shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const shallowReadonlyHandlers = /*#__PURE__*/ (0,shared_esm_bundler.extend)({}, readonlyHandlers, {
    get: shallowReadonlyGet
});

const toShallow = (value) => value;
const getProto = (v) => Reflect.getPrototypeOf(v);
function get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* RAW */];
    const rawTarget = reactivity_esm_bundler_toRaw(target);
    const rawKey = reactivity_esm_bundler_toRaw(key);
    if (key !== rawKey) {
        !isReadonly && track(rawTarget, "get" /* GET */, key);
    }
    !isReadonly && track(rawTarget, "get" /* GET */, rawKey);
    const { has } = getProto(rawTarget);
    const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
    if (has.call(rawTarget, key)) {
        return wrap(target.get(key));
    }
    else if (has.call(rawTarget, rawKey)) {
        return wrap(target.get(rawKey));
    }
    else if (target !== rawTarget) {
        // #3602 readonly(reactive(Map))
        // ensure that the nested reactive `Map` can do tracking for itself
        target.get(key);
    }
}
function has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* RAW */];
    const rawTarget = reactivity_esm_bundler_toRaw(target);
    const rawKey = reactivity_esm_bundler_toRaw(key);
    if (key !== rawKey) {
        !isReadonly && track(rawTarget, "has" /* HAS */, key);
    }
    !isReadonly && track(rawTarget, "has" /* HAS */, rawKey);
    return key === rawKey
        ? target.has(key)
        : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly = false) {
    target = target["__v_raw" /* RAW */];
    !isReadonly && track(reactivity_esm_bundler_toRaw(target), "iterate" /* ITERATE */, ITERATE_KEY);
    return Reflect.get(target, 'size', target);
}
function add(value) {
    value = reactivity_esm_bundler_toRaw(value);
    const target = reactivity_esm_bundler_toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        trigger(target, "add" /* ADD */, value, value);
    }
    return this;
}
function set$1(key, value) {
    value = reactivity_esm_bundler_toRaw(value);
    const target = reactivity_esm_bundler_toRaw(this);
    const { has, get } = getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = reactivity_esm_bundler_toRaw(key);
        hadKey = has.call(target, key);
    }
    else if ((false)) {}
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) {
        trigger(target, "add" /* ADD */, key, value);
    }
    else if ((0,shared_esm_bundler.hasChanged)(value, oldValue)) {
        trigger(target, "set" /* SET */, key, value, oldValue);
    }
    return this;
}
function deleteEntry(key) {
    const target = reactivity_esm_bundler_toRaw(this);
    const { has, get } = getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = reactivity_esm_bundler_toRaw(key);
        hadKey = has.call(target, key);
    }
    else if ((false)) {}
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) {
        trigger(target, "delete" /* DELETE */, key, undefined, oldValue);
    }
    return result;
}
function clear() {
    const target = reactivity_esm_bundler_toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = ( false)
        ? 0
        : undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) {
        trigger(target, "clear" /* CLEAR */, undefined, undefined, oldTarget);
    }
    return result;
}
function createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* RAW */];
        const rawTarget = reactivity_esm_bundler_toRaw(target);
        const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly && track(rawTarget, "iterate" /* ITERATE */, ITERATE_KEY);
        return target.forEach((value, key) => {
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function createIterableMethod(method, isReadonly, isShallow) {
    return function (...args) {
        const target = this["__v_raw" /* RAW */];
        const rawTarget = reactivity_esm_bundler_toRaw(target);
        const targetIsMap = (0,shared_esm_bundler.isMap)(rawTarget);
        const isPair = method === 'entries' || (method === Symbol.iterator && targetIsMap);
        const isKeyOnly = method === 'keys' && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? toShallow : isReadonly ? toReadonly : toReactive;
        !isReadonly &&
            track(rawTarget, "iterate" /* ITERATE */, isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next() {
                const { value, done } = innerIterator.next();
                return done
                    ? { value, done }
                    : {
                        value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
                        done
                    };
            },
            // iterable protocol
            [Symbol.iterator]() {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function (...args) {
        if ((false)) {}
        return type === "delete" /* DELETE */ ? false : this;
    };
}
function createInstrumentations() {
    const mutableInstrumentations = {
        get(key) {
            return get$1(this, key);
        },
        get size() {
            return size(this);
        },
        has: has$1,
        add,
        set: set$1,
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, false)
    };
    const shallowInstrumentations = {
        get(key) {
            return get$1(this, key, false, true);
        },
        get size() {
            return size(this);
        },
        has: has$1,
        add,
        set: set$1,
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get(key) {
            return get$1(this, key, true);
        },
        get size() {
            return size(this, true);
        },
        has(key) {
            return has$1.call(this, key, true);
        },
        add: createReadonlyMethod("add" /* ADD */),
        set: createReadonlyMethod("set" /* SET */),
        delete: createReadonlyMethod("delete" /* DELETE */),
        clear: createReadonlyMethod("clear" /* CLEAR */),
        forEach: createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get(key) {
            return get$1(this, key, true, true);
        },
        get size() {
            return size(this, true);
        },
        has(key) {
            return has$1.call(this, key, true);
        },
        add: createReadonlyMethod("add" /* ADD */),
        set: createReadonlyMethod("set" /* SET */),
        delete: createReadonlyMethod("delete" /* DELETE */),
        clear: createReadonlyMethod("clear" /* CLEAR */),
        forEach: createForEach(true, true)
    };
    const iteratorMethods = ['keys', 'values', 'entries', Symbol.iterator];
    iteratorMethods.forEach(method => {
        mutableInstrumentations[method] = createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = createIterableMethod(method, true, false);
        shallowInstrumentations[method] = createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* #__PURE__*/ createInstrumentations();
function createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow
        ? isReadonly
            ? shallowReadonlyInstrumentations
            : shallowInstrumentations
        : isReadonly
            ? readonlyInstrumentations
            : mutableInstrumentations;
    return (target, key, receiver) => {
        if (key === "__v_isReactive" /* IS_REACTIVE */) {
            return !isReadonly;
        }
        else if (key === "__v_isReadonly" /* IS_READONLY */) {
            return isReadonly;
        }
        else if (key === "__v_raw" /* RAW */) {
            return target;
        }
        return Reflect.get((0,shared_esm_bundler.hasOwn)(instrumentations, key) && key in target
            ? instrumentations
            : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    const rawKey = reactivity_esm_bundler_toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` +
            `versions of the same object${type === `Map` ? ` as keys` : ``}, ` +
            `which can lead to inconsistencies. ` +
            `Avoid differentiating between the raw and reactive versions ` +
            `of an object and only use the reactive version if possible.`);
    }
}

const reactiveMap = new WeakMap();
const shallowReactiveMap = new WeakMap();
const readonlyMap = new WeakMap();
const shallowReadonlyMap = new WeakMap();
function targetTypeMap(rawType) {
    switch (rawType) {
        case 'Object':
        case 'Array':
            return 1 /* COMMON */;
        case 'Map':
        case 'Set':
        case 'WeakMap':
        case 'WeakSet':
            return 2 /* COLLECTION */;
        default:
            return 0 /* INVALID */;
    }
}
function getTargetType(value) {
    return value["__v_skip" /* SKIP */] || !Object.isExtensible(value)
        ? 0 /* INVALID */
        : targetTypeMap((0,shared_esm_bundler.toRawType)(value));
}
function reactive(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (isReadonly(target)) {
        return target;
    }
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0,shared_esm_bundler.isObject)(target)) {
        if ((false)) {}
        return target;
    }
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* RAW */] &&
        !(isReadonly && target["__v_isReactive" /* IS_REACTIVE */])) {
        return target;
    }
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) {
        return existingProxy;
    }
    // only a whitelist of value types can be observed.
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */) {
        return target;
    }
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */ ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* RAW */]);
    }
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */]);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function reactivity_esm_bundler_toRaw(observed) {
    const raw = observed && observed["__v_raw" /* RAW */];
    return raw ? reactivity_esm_bundler_toRaw(raw) : observed;
}
function markRaw(value) {
    (0,shared_esm_bundler.def)(value, "__v_skip" /* SKIP */, true);
    return value;
}
const toReactive = (value) => (0,shared_esm_bundler.isObject)(value) ? reactive(value) : value;
const toReadonly = (value) => (0,shared_esm_bundler.isObject)(value) ? readonly(value) : value;

function trackRefValue(ref) {
    if (shouldTrack && activeEffect) {
        ref = reactivity_esm_bundler_toRaw(ref);
        if ((false)) {}
        else {
            trackEffects(ref.dep || (ref.dep = createDep()));
        }
    }
}
function triggerRefValue(ref, newVal) {
    ref = reactivity_esm_bundler_toRaw(ref);
    if (ref.dep) {
        if ((false)) {}
        else {
            triggerEffects(ref.dep);
        }
    }
}
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, __v_isShallow) {
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : reactivity_esm_bundler_toRaw(value);
        this._value = __v_isShallow ? value : toReactive(value);
    }
    get value() {
        trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        newVal = this.__v_isShallow ? newVal : reactivity_esm_bundler_toRaw(newVal);
        if ((0,shared_esm_bundler.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = this.__v_isShallow ? newVal : toReactive(newVal);
            triggerRefValue(this, newVal);
        }
    }
}
function triggerRef(ref) {
    triggerRefValue(ref, ( false) ? 0 : void 0);
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver) => {
        const oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        }
        else {
            return Reflect.set(target, key, value, receiver);
        }
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs)
        ? objectWithRefs
        : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory) {
        this.dep = undefined;
        this.__v_isRef = true;
        const { get, set } = factory(() => trackRefValue(this), () => triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    if (false) {}
    const ret = (0,shared_esm_bundler.isArray)(object) ? new Array(object.length) : {};
    for (const key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
class ObjectRefImpl {
    constructor(_object, _key, _defaultValue) {
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
}
function toRef(object, key, defaultValue) {
    const val = object[key];
    return isRef(val)
        ? val
        : new ObjectRefImpl(object, key, defaultValue);
}

class ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR) {
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this._dirty = true;
        this.effect = new ReactiveEffect(getter, () => {
            if (!this._dirty) {
                this._dirty = true;
                triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* IS_READONLY */] = isReadonly;
    }
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = reactivity_esm_bundler_toRaw(this);
        trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
}
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0,shared_esm_bundler.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = ( false)
            ? 0
            : shared_esm_bundler.NOOP;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    if (false) {}
    return cRef;
}

var _a;
const tick = Promise.resolve();
const queue = (/* unused pure expression or super */ null && ([]));
let queued = false;
const scheduler = (fn) => {
    queue.push(fn);
    if (!queued) {
        queued = true;
        tick.then(flush);
    }
};
const flush = () => {
    for (let i = 0; i < queue.length; i++) {
        queue[i]();
    }
    queue.length = 0;
    queued = false;
};
class DeferredComputedRefImpl {
    constructor(getter) {
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[_a] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new ReactiveEffect(getter, (computedTrigger) => {
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                }
                else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    scheduler(() => {
                        if (this.effect.active && this._get() !== valueToCompare) {
                            triggerRefValue(this);
                        }
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep) {
                    if (e.computed instanceof DeferredComputedRefImpl) {
                        e.scheduler(true /* computedTrigger */);
                    }
                }
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return (this._value = this.effect.run());
        }
        return this._value;
    }
    get value() {
        trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return reactivity_esm_bundler_toRaw(this)._get();
    }
}
_a = "__v_isReadonly" /* IS_READONLY */;
function deferredComputed(getter) {
    return new DeferredComputedRefImpl(getter);
}



;// CONCATENATED MODULE: ./node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js





const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
function runtime_core_esm_bundler_warn(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    pauseTracking();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) {
        callWithErrorHandling(appWarnHandler, instance, 11 /* APP_WARN_HANDLER */, [
            msg + args.join(''),
            instance && instance.proxy,
            trace
                .map(({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`)
                .join('\n'),
            trace
        ]);
    }
    else {
        const warnArgs = [`[Vue warn]: ${msg}`, ...args];
        /* istanbul ignore if */
        if (trace.length &&
            // avoid spamming console during tests
            !false) {
            warnArgs.push(`\n`, ...formatTrace(trace));
        }
        console.warn(...warnArgs);
    }
    resetTracking();
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
        return [];
    }
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while (currentVNode) {
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) {
            last.recurseCount++;
        }
        else {
            normalizedStack.push({
                vnode: currentVNode,
                recurseCount: 0
            });
        }
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i) => {
        logs.push(...(i === 0 ? [] : [`\n`]), ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props
        ? [open, ...formatProps(vnode.props), close]
        : [open + close];
}
/* istanbul ignore next */
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach(key => {
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) {
        res.push(` ...`);
    }
    return res;
}
/* istanbul ignore next */
function formatProp(key, value, raw) {
    if ((0,shared_esm_bundler.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [`${key}=${value}`];
    }
    else if (typeof value === 'number' ||
        typeof value === 'boolean' ||
        value == null) {
        return raw ? value : [`${key}=${value}`];
    }
    else if (isRef(value)) {
        value = formatProp(key, reactivity_esm_bundler_toRaw(value.value), true);
        return raw ? value : [`${key}=Ref<`, value, `>`];
    }
    else if ((0,shared_esm_bundler.isFunction)(value)) {
        return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
    }
    else {
        value = reactivity_esm_bundler_toRaw(value);
        return raw ? value : [`${key}=`, value];
    }
}

const ErrorTypeStrings = {
    ["sp" /* SERVER_PREFETCH */]: 'serverPrefetch hook',
    ["bc" /* BEFORE_CREATE */]: 'beforeCreate hook',
    ["c" /* CREATED */]: 'created hook',
    ["bm" /* BEFORE_MOUNT */]: 'beforeMount hook',
    ["m" /* MOUNTED */]: 'mounted hook',
    ["bu" /* BEFORE_UPDATE */]: 'beforeUpdate hook',
    ["u" /* UPDATED */]: 'updated',
    ["bum" /* BEFORE_UNMOUNT */]: 'beforeUnmount hook',
    ["um" /* UNMOUNTED */]: 'unmounted hook',
    ["a" /* ACTIVATED */]: 'activated hook',
    ["da" /* DEACTIVATED */]: 'deactivated hook',
    ["ec" /* ERROR_CAPTURED */]: 'errorCaptured hook',
    ["rtc" /* RENDER_TRACKED */]: 'renderTracked hook',
    ["rtg" /* RENDER_TRIGGERED */]: 'renderTriggered hook',
    [0 /* SETUP_FUNCTION */]: 'setup function',
    [1 /* RENDER_FUNCTION */]: 'render function',
    [2 /* WATCH_GETTER */]: 'watcher getter',
    [3 /* WATCH_CALLBACK */]: 'watcher callback',
    [4 /* WATCH_CLEANUP */]: 'watcher cleanup function',
    [5 /* NATIVE_EVENT_HANDLER */]: 'native event handler',
    [6 /* COMPONENT_EVENT_HANDLER */]: 'component event handler',
    [7 /* VNODE_HOOK */]: 'vnode hook',
    [8 /* DIRECTIVE_HOOK */]: 'directive hook',
    [9 /* TRANSITION_HOOK */]: 'transition hook',
    [10 /* APP_ERROR_HANDLER */]: 'app errorHandler',
    [11 /* APP_WARN_HANDLER */]: 'app warnHandler',
    [12 /* FUNCTION_REF */]: 'ref function',
    [13 /* ASYNC_COMPONENT_LOADER */]: 'async component loader',
    [14 /* SCHEDULER */]: 'scheduler flush. This is likely a Vue internals bug. ' +
        'Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core'
};
function callWithErrorHandling(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    }
    catch (err) {
        handleError(err, instance, type);
    }
    return res;
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0,shared_esm_bundler.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0,shared_esm_bundler.isPromise)(res)) {
            res.catch(err => {
                handleError(err, instance, type);
            });
        }
        return res;
    }
    const values = [];
    for (let i = 0; i < fn.length; i++) {
        values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
    }
    return values;
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = ( false) ? 0 : type;
        while (cur) {
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) {
                for (let i = 0; i < errorCapturedHooks.length; i++) {
                    if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
                        return;
                    }
                }
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            callWithErrorHandling(appErrorHandler, null, 10 /* APP_ERROR_HANDLER */, [err, exposedInstance, errorInfo]);
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev = true) {
    if ((false)) {}
    else {
        // recover in prod to reduce the impact on end-user
        console.error(err);
    }
}

let isFlushing = false;
let isFlushPending = false;
const runtime_core_esm_bundler_queue = [];
let flushIndex = 0;
const pendingPreFlushCbs = [];
let activePreFlushCbs = null;
let preFlushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = Promise.resolve();
let currentFlushPromise = null;
let currentPreFlushParentJob = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = flushIndex + 1;
    let end = runtime_core_esm_bundler_queue.length;
    while (start < end) {
        const middle = (start + end) >>> 1;
        const middleJobId = getId(runtime_core_esm_bundler_queue[middle]);
        middleJobId < id ? (start = middle + 1) : (end = middle);
    }
    return start;
}
function queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if ((!runtime_core_esm_bundler_queue.length ||
        !runtime_core_esm_bundler_queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) &&
        job !== currentPreFlushParentJob) {
        if (job.id == null) {
            runtime_core_esm_bundler_queue.push(job);
        }
        else {
            runtime_core_esm_bundler_queue.splice(findInsertionIndex(job.id), 0, job);
        }
        queueFlush();
    }
}
function queueFlush() {
    if (!isFlushing && !isFlushPending) {
        isFlushPending = true;
        currentFlushPromise = resolvedPromise.then(flushJobs);
    }
}
function invalidateJob(job) {
    const i = runtime_core_esm_bundler_queue.indexOf(job);
    if (i > flushIndex) {
        runtime_core_esm_bundler_queue.splice(i, 1);
    }
}
function queueCb(cb, activeQueue, pendingQueue, index) {
    if (!(0,shared_esm_bundler.isArray)(cb)) {
        if (!activeQueue ||
            !activeQueue.includes(cb, cb.allowRecurse ? index + 1 : index)) {
            pendingQueue.push(cb);
        }
    }
    else {
        // if cb is an array, it is a component lifecycle hook which can only be
        // triggered by a job, which is already deduped in the main queue, so
        // we can skip duplicate check here to improve perf
        pendingQueue.push(...cb);
    }
    queueFlush();
}
function queuePreFlushCb(cb) {
    queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
}
function queuePostFlushCb(cb) {
    queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
}
function flushPreFlushCbs(seen, parentJob = null) {
    if (pendingPreFlushCbs.length) {
        currentPreFlushParentJob = parentJob;
        activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
        pendingPreFlushCbs.length = 0;
        if ((false)) {}
        for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
            if (false) {}
            activePreFlushCbs[preFlushIndex]();
        }
        activePreFlushCbs = null;
        preFlushIndex = 0;
        currentPreFlushParentJob = null;
        // recursively flush until it drains
        flushPreFlushCbs(seen, parentJob);
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [...new Set(pendingPostFlushCbs)];
        pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        if ((false)) {}
        activePostFlushCbs.sort((a, b) => getId(a) - getId(b));
        for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
            if (false) {}
            activePostFlushCbs[postFlushIndex]();
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job) => job.id == null ? Infinity : job.id;
function flushJobs(seen) {
    isFlushPending = false;
    isFlushing = true;
    if ((false)) {}
    flushPreFlushCbs(seen);
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    runtime_core_esm_bundler_queue.sort((a, b) => getId(a) - getId(b));
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = ( false)
        ? 0
        : shared_esm_bundler.NOOP;
    try {
        for (flushIndex = 0; flushIndex < runtime_core_esm_bundler_queue.length; flushIndex++) {
            const job = runtime_core_esm_bundler_queue[flushIndex];
            if (job && job.active !== false) {
                if (false) {}
                // console.log(`running:`, job.id)
                callWithErrorHandling(job, null, 14 /* SCHEDULER */);
            }
        }
    }
    finally {
        flushIndex = 0;
        runtime_core_esm_bundler_queue.length = 0;
        flushPostFlushCbs(seen);
        isFlushing = false;
        currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if (runtime_core_esm_bundler_queue.length ||
            pendingPreFlushCbs.length ||
            pendingPostFlushCbs.length) {
            flushJobs(seen);
        }
    }
}
function checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) {
        seen.set(fn, 1);
    }
    else {
        const count = seen.get(fn);
        if (count > RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && getComponentName(instance.type);
            runtime_core_esm_bundler_warn(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` +
                `This means you have a reactive effect that is mutating its own ` +
                `dependencies and thus recursively triggering itself. Possible sources ` +
                `include component template, render function, updated hook or ` +
                `watcher source function.`);
            return true;
        }
        else {
            seen.set(fn, count + 1);
        }
    }
}

/* eslint-disable no-restricted-globals */
let isHmrUpdating = false;
const hmrDirtyComponents = new Set();
// Expose the HMR runtime on the global object
// This makes it entirely tree-shakable without polluting the exports and makes
// it easier to be used in toolings like vue-loader
// Note: for a component to be eligible for HMR it also needs the __hmrId option
// to be set so that its instances can be registered / removed.
if ((false)) {}
const map = new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) {
        return false;
    }
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) {
        return;
    }
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [...record.instances].forEach(instance => {
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        isHmrUpdating = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record)
        return;
    newComp = normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [...record.instances];
    for (const instance of instances) {
        const oldComp = normalizeClassComponent(instance.type);
        if (!hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) {
                updateComponentDef(oldComp, newComp);
            }
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            hmrDirtyComponents.delete(oldComp);
        }
        else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader &&
                instance.parent.ceReload) {
                instance.parent.ceReload(newComp.styles);
            }
        }
        else if (instance.appContext.reload) {
            // root instance mounted via createApp() has a reload method
            instance.appContext.reload();
        }
        else if (typeof window !== 'undefined') {
            // root instance inside tree created via raw render(). Force reload.
            window.location.reload();
        }
        else {
            console.warn('[HMR] Root or manually mounted instance modified. Full reload required.');
        }
    }
    // 5. make sure to cleanup dirty hmr components after update
    queuePostFlushCb(() => {
        for (const instance of instances) {
            hmrDirtyComponents.delete(normalizeClassComponent(instance.type));
        }
    });
}
function updateComponentDef(oldComp, newComp) {
    extend(oldComp, newComp);
    for (const key in oldComp) {
        if (key !== '__file' && !(key in newComp)) {
            delete oldComp[key];
        }
    }
}
function tryWrap(fn) {
    return (id, arg) => {
        try {
            return fn(id, arg);
        }
        catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` +
                `Full reload required.`);
        }
    };
}

let devtools;
let buffer = [];
let devtoolsNotInstalled = false;
function emit(event, ...args) {
    if (devtools) {
        devtools.emit(event, ...args);
    }
    else if (!devtoolsNotInstalled) {
        buffer.push({ event, args });
    }
}
function setDevtoolsHook(hook, target) {
    var _a, _b;
    devtools = hook;
    if (devtools) {
        devtools.enabled = true;
        buffer.forEach(({ event, args }) => devtools.emit(event, ...args));
        buffer = [];
    }
    else if (
    // handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    // eslint-disable-next-line no-restricted-globals
    typeof window !== 'undefined' &&
        // some envs mock window but not fully
        window.HTMLElement &&
        // also exclude jsdom
        !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes('jsdom'))) {
        const replay = (target.__VUE_DEVTOOLS_HOOK_REPLAY__ =
            target.__VUE_DEVTOOLS_HOOK_REPLAY__ || []);
        replay.push((newHook) => {
            setDevtoolsHook(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(() => {
            if (!devtools) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3000);
    }
    else {
        // non-browser env, assume not installed
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit("app:init" /* APP_INIT */, app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit("app:unmount" /* APP_UNMOUNT */, app);
}
const devtoolsComponentAdded = /*#__PURE__*/ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */);
const devtoolsComponentUpdated = 
/*#__PURE__*/ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */);
const devtoolsComponentRemoved = 
/*#__PURE__*/ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */);
function createDevtoolsComponentHook(hook) {
    return (component) => {
        emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const devtoolsPerfStart = /*#__PURE__*/ (/* unused pure expression or super */ null && (createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */)));
const devtoolsPerfEnd = /*#__PURE__*/ (/* unused pure expression or super */ null && (createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */)));
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time) => {
        emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit("component:emit" /* COMPONENT_EMIT */, component.appContext.app, component, event, params);
}

function emit$1(instance, event, ...rawArgs) {
    const props = instance.vnode.props || shared_esm_bundler.EMPTY_OBJ;
    if ((false)) {}
    let args = rawArgs;
    const isModelListener = event.startsWith('update:');
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === 'modelValue' ? 'model' : modelArg}Modifiers`;
        const { number, trim } = props[modifiersKey] || shared_esm_bundler.EMPTY_OBJ;
        if (trim) {
            args = rawArgs.map(a => a.trim());
        }
        else if (number) {
            args = rawArgs.map(shared_esm_bundler.toNumber);
        }
    }
    if (( false) || __VUE_PROD_DEVTOOLS__) {
        devtoolsComponentEmit(instance, event, args);
    }
    if ((false)) {}
    let handlerName;
    let handler = props[(handlerName = (0,shared_esm_bundler.toHandlerKey)(event))] ||
        // also try camelCase event handler (#2249)
        props[(handlerName = (0,shared_esm_bundler.toHandlerKey)((0,shared_esm_bundler.camelize)(event)))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) {
        handler = props[(handlerName = (0,shared_esm_bundler.toHandlerKey)((0,shared_esm_bundler.hyphenate)(event)))];
    }
    if (handler) {
        callWithAsyncErrorHandling(handler, instance, 6 /* COMPONENT_EVENT_HANDLER */, args);
    }
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) {
            instance.emitted = {};
        }
        else if (instance.emitted[handlerName]) {
            return;
        }
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6 /* COMPONENT_EVENT_HANDLER */, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) {
        return cached;
    }
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0,shared_esm_bundler.isFunction)(comp)) {
        const extendEmits = (raw) => {
            const normalizedFromExtend = normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0,shared_esm_bundler.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) {
            appContext.mixins.forEach(extendEmits);
        }
        if (comp.extends) {
            extendEmits(comp.extends);
        }
        if (comp.mixins) {
            comp.mixins.forEach(extendEmits);
        }
    }
    if (!raw && !hasExtends) {
        cache.set(comp, null);
        return null;
    }
    if ((0,shared_esm_bundler.isArray)(raw)) {
        raw.forEach(key => (normalized[key] = null));
    }
    else {
        (0,shared_esm_bundler.extend)(normalized, raw);
    }
    cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function isEmitListener(options, key) {
    if (!options || !(0,shared_esm_bundler.isOn)(key)) {
        return false;
    }
    key = key.slice(2).replace(/Once$/, '');
    return ((0,shared_esm_bundler.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) ||
        (0,shared_esm_bundler.hasOwn)(options, (0,shared_esm_bundler.hyphenate)(key)) ||
        (0,shared_esm_bundler.hasOwn)(options, key));
}

/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */
let currentRenderingInstance = null;
let currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = (instance && instance.type.__scopeId) || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */
function pushScopeId(id) {
    currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */
function popScopeId() {
    currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */
const withScopeId = (_id) => withCtx;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx)
        return fn;
    // already normalized
    if (fn._n) {
        return fn;
    }
    const renderFnWithContext = (...args) => {
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) {
            setBlockTracking(-1);
        }
        const prevInstance = setCurrentRenderingInstance(ctx);
        const res = fn(...args);
        setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) {
            setBlockTracking(1);
        }
        if (( false) || __VUE_PROD_DEVTOOLS__) {
            devtoolsComponentUpdated(ctx);
        }
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}

/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, props, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, data, setupState, ctx, inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = setCurrentRenderingInstance(instance);
    if ((false)) {}
    try {
        if (vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        }
        else {
            // functional
            const render = Component;
            // in dev, mark attrs accessed if optional props (attrs === props)
            if (false) {}
            result = normalizeVNode(render.length > 1
                ? render(props, ( false)
                    ? 0
                    : { attrs, slots, emit })
                : render(props, null /* we know it doesn't need it */));
            fallthroughAttrs = Component.props
                ? attrs
                : getFunctionalFallthrough(attrs);
        }
    }
    catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1 /* RENDER_FUNCTION */);
        result = createVNode(Comment);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (false /* DEV_ROOT_FRAGMENT */) {}
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & (1 /* ELEMENT */ | 6 /* COMPONENT */)) {
                if (propsOptions && keys.some(shared_esm_bundler.isModelListener)) {
                    // If a v-model listener (onUpdate:xxx) has a corresponding declared
                    // prop, it indicates this component expects to handle v-model and
                    // it should not fallthrough.
                    // related: #1543, #1643, #1989
                    fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                }
                root = cloneVNode(root, fallthroughAttrs);
            }
            else if (false) {}
        }
    }
    // inherit directives
    if (vnode.dirs) {
        if (false) {}
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    // inherit transition data
    if (vnode.transition) {
        if (false) {}
        root.transition = vnode.transition;
    }
    if (false) {}
    else {
        result = root;
    }
    setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */
const getChildRoot = (vnode) => {
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren);
    if (!childRoot) {
        return [vnode, undefined];
    }
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot) => {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) {
                dynamicChildren[dynamicIndex] = updatedRoot;
            }
            else if (updatedRoot.patchFlag > 0) {
                vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
            }
        }
    };
    return [normalizeVNode(childRoot), setRoot];
};
function filterSingleRoot(children) {
    let singleRoot;
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (isVNode(child)) {
            // ignore user comment
            if (child.type !== Comment || child.children === 'v-if') {
                if (singleRoot) {
                    // has more than 1 non-comment child, return now
                    return;
                }
                else {
                    singleRoot = child;
                }
            }
        }
        else {
            return;
        }
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs) => {
    let res;
    for (const key in attrs) {
        if (key === 'class' || key === 'style' || (0,shared_esm_bundler.isOn)(key)) {
            (res || (res = {}))[key] = attrs[key];
        }
    }
    return res;
};
const filterModelListeners = (attrs, props) => {
    const res = {};
    for (const key in attrs) {
        if (!(0,shared_esm_bundler.isModelListener)(key) || !(key.slice(9) in props)) {
            res[key] = attrs[key];
        }
    }
    return res;
};
const isElementRoot = (vnode) => {
    return (vnode.shapeFlag & (6 /* COMPONENT */ | 1 /* ELEMENT */) ||
        vnode.type === Comment // potential v-if branch switch
    );
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // Parent component's render function was hot-updated. Since this may have
    // caused the child component's slots content to have changed, we need to
    // force the child to update as well.
    if (false) {}
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) {
        return true;
    }
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* DYNAMIC_SLOTS */) {
            // slot content that references values that might have changed,
            // e.g. in a v-for
            return true;
        }
        if (patchFlag & 16 /* FULL_PROPS */) {
            if (!prevProps) {
                return !!nextProps;
            }
            // presence of this flag indicates props are always non-null
            return hasPropsChanged(prevProps, nextProps, emits);
        }
        else if (patchFlag & 8 /* PROPS */) {
            const dynamicProps = nextVNode.dynamicProps;
            for (let i = 0; i < dynamicProps.length; i++) {
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] &&
                    !isEmitListener(emits, key)) {
                    return true;
                }
            }
        }
    }
    else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) {
                return true;
            }
        }
        if (prevProps === nextProps) {
            return false;
        }
        if (!prevProps) {
            return !!nextProps;
        }
        if (!nextProps) {
            return true;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
        return true;
    }
    for (let i = 0; i < nextKeys.length; i++) {
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] &&
            !isEmitListener(emitsOptions, key)) {
            return true;
        }
    }
    return false;
}
function updateHOCHostEl({ vnode, parent }, el // HostNode
) {
    while (parent && parent.subTree === vnode) {
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}

const isSuspense = (type) => type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const SuspenseImpl = {
    name: 'Suspense',
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, 
    // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) {
            mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        }
        else {
            patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    create: createSuspenseBoundary,
    normalize: normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const Suspense = (SuspenseImpl );
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0,shared_esm_bundler.isFunction)(eventListener)) {
        eventListener();
    }
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement('div');
    const suspense = (vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals));
    // start mounting the content subtree in an off-dom container
    patch(null, (suspense.pendingBranch = vnode.ssContent), hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        triggerEvent(vnode, 'onPending');
        triggerEvent(vnode, 'onFallback');
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    }
    else {
        // Suspense has no async deps. Just resolve.
        suspense.resolve();
    }
}
function patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = (n2.suspense = n1.suspense);
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) {
                suspense.resolve();
            }
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                setActiveBranch(suspense, newFallback);
            }
        }
        else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            }
            else {
                unmount(pendingBranch, parentComponent, suspense);
            }
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement('div');
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) {
                    suspense.resolve();
                }
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
            else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            }
            else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) {
                    suspense.resolve();
                }
            }
        }
    }
    else {
        if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
            // root did not change, just normal patch
            patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            setActiveBranch(suspense, newBranch);
        }
        else {
            // root node toggled
            // invoke @pending event
            triggerEvent(n2, 'onPending');
            // mount pending branch in off-dom container
            suspense.pendingBranch = newBranch;
            suspense.pendingId++;
            patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) {
                // incoming branch has no async deps, resolve now.
                suspense.resolve();
            }
            else {
                const { timeout, pendingId } = suspense;
                if (timeout > 0) {
                    setTimeout(() => {
                        if (suspense.pendingId === pendingId) {
                            suspense.fallback(newFallback);
                        }
                    }, timeout);
                }
                else if (timeout === 0) {
                    suspense.fallback(newFallback);
                }
            }
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    /* istanbul ignore if */
    if (false) {}
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    const timeout = (0,shared_esm_bundler.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode,
        parent,
        parentComponent,
        isSVG,
        container,
        hiddenContainer,
        anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === 'number' ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve(resume = false) {
            if ((false)) {}
            const { vnode, activeBranch, pendingBranch, pendingId, effects, parentComponent, container } = suspense;
            if (suspense.isHydrating) {
                suspense.isHydrating = false;
            }
            else if (!resume) {
                const delayEnter = activeBranch &&
                    pendingBranch.transition &&
                    pendingBranch.transition.mode === 'out-in';
                if (delayEnter) {
                    activeBranch.transition.afterLeave = () => {
                        if (pendingId === suspense.pendingId) {
                            move(pendingBranch, container, anchor, 0 /* ENTER */);
                        }
                    };
                }
                // this is initial anchor on mount
                let { anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) {
                    // move content from off-dom container to actual container
                    move(pendingBranch, container, anchor, 0 /* ENTER */);
                }
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while (parent) {
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) {
                queuePostFlushCb(effects);
            }
            suspense.effects = [];
            // invoke @resolve event
            triggerEvent(vnode, 'onResolve');
        },
        fallback(fallbackVNode) {
            if (!suspense.pendingBranch) {
                return;
            }
            const { vnode, activeBranch, parentComponent, container, isSVG } = suspense;
            // invoke @fallback event
            triggerEvent(vnode, 'onFallback');
            const anchor = next(activeBranch);
            const mountFallback = () => {
                if (!suspense.isInFallback) {
                    return;
                }
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === 'out-in';
            if (delayEnter) {
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, // no suspense so unmount hooks fire now
            true // shouldRemove
            );
            if (!delayEnter) {
                mountFallback();
            }
        },
        move(container, anchor, type) {
            suspense.activeBranch &&
                move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep(instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) {
                suspense.deps++;
            }
            const hydratedEl = instance.vnode.el;
            instance
                .asyncDep.catch(err => {
                handleError(err, instance, 0 /* SETUP_FUNCTION */);
            })
                .then(asyncSetupResult => {
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted ||
                    suspense.isUnmounted ||
                    suspense.pendingId !== instance.suspenseId) {
                    return;
                }
                // retry from this component
                instance.asyncResolved = true;
                const { vnode } = instance;
                if ((false)) {}
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) {
                    // vnode may have been replaced if an update happened before the
                    // async dep is resolved.
                    vnode.el = hydratedEl;
                }
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, 
                // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), 
                // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) {
                    remove(placeholder);
                }
                updateHOCHostEl(instance, vnode.el);
                if ((false)) {}
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) {
                    suspense.resolve();
                }
            });
        },
        unmount(parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) {
                unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            }
            if (suspense.pendingBranch) {
                unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
            }
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */
    const suspense = (vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement('div'), null, isSVG, slotScopeIds, optimized, rendererInternals, true /* hydrating */));
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, (suspense.pendingBranch = vnode.ssContent), parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) {
        suspense.resolve();
    }
    return result;
    /* eslint-enable no-restricted-globals */
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* SLOTS_CHILDREN */;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren
        ? normalizeSuspenseSlot(children.fallback)
        : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0,shared_esm_bundler.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0,shared_esm_bundler.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        if (false) {}
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) {
        s.dynamicChildren = block.filter(c => c !== s);
    }
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0,shared_esm_bundler.isArray)(fn)) {
            suspense.effects.push(...fn);
        }
        else {
            suspense.effects.push(fn);
        }
    }
    else {
        queuePostFlushCb(fn);
    }
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    const el = (vnode.el = branch.el);
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}

function provide(key, value) {
    if (!currentInstance) {
        if ((false)) {}
    }
    else {
        let provides = currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) {
            provides = currentInstance.provides = Object.create(parentProvides);
        }
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = currentInstance || currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null
            ? instance.vnode.appContext && instance.vnode.appContext.provides
            : instance.parent.provides;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && (0,shared_esm_bundler.isFunction)(defaultValue)
                ? defaultValue.call(instance.proxy)
                : defaultValue;
        }
        else if ((false)) {}
    }
    else if ((false)) {}
}

// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, (( false)
        ? 0
        : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, (( false)
        ? 0
        : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
const INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {}
    return doWatch(source, cb, options);
}
function doWatch(source, cb, { immediate, deep, flush, onTrack, onTrigger } = shared_esm_bundler.EMPTY_OBJ) {
    if (false) {}
    const warnInvalidSource = (s) => {
        runtime_core_esm_bundler_warn(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` +
            `a reactive object, or an array of these types.`);
    };
    const instance = currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef(source)) {
        getter = () => source.value;
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = () => source;
        deep = true;
    }
    else if ((0,shared_esm_bundler.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some(isReactive);
        getter = () => source.map(s => {
            if (isRef(s)) {
                return s.value;
            }
            else if (isReactive(s)) {
                return traverse(s);
            }
            else if ((0,shared_esm_bundler.isFunction)(s)) {
                return callWithErrorHandling(s, instance, 2 /* WATCH_GETTER */);
            }
            else {
                ( false) && 0;
            }
        });
    }
    else if ((0,shared_esm_bundler.isFunction)(source)) {
        if (cb) {
            // getter with cb
            getter = () => callWithErrorHandling(source, instance, 2 /* WATCH_GETTER */);
        }
        else {
            // no cb -> simple effect
            getter = () => {
                if (instance && instance.isUnmounted) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return callWithAsyncErrorHandling(source, instance, 3 /* WATCH_CALLBACK */, [onCleanup]);
            };
        }
    }
    else {
        getter = shared_esm_bundler.NOOP;
        ( false) && 0;
    }
    if (cb && deep) {
        const baseGetter = getter;
        getter = () => traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn) => {
        cleanup = effect.onStop = () => {
            callWithErrorHandling(fn, instance, 4 /* WATCH_CLEANUP */);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = shared_esm_bundler.NOOP;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            callWithAsyncErrorHandling(cb, instance, 3 /* WATCH_CALLBACK */, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return shared_esm_bundler.NOOP;
    }
    let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    const job = () => {
        if (!effect.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some((v, i) => (0,shared_esm_bundler.hasChanged)(v, oldValue[i]))
                    : (0,shared_esm_bundler.hasChanged)(newValue, oldValue)) ||
                (false  )) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                callWithAsyncErrorHandling(cb, instance, 3 /* WATCH_CALLBACK */, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            effect.run();
        }
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === 'sync') {
        scheduler = job; // the scheduler function gets called directly
    }
    else if (flush === 'post') {
        scheduler = () => queuePostRenderEffect(job, instance && instance.suspense);
    }
    else {
        // default: 'pre'
        scheduler = () => {
            if (!instance || instance.isMounted) {
                queuePreFlushCb(job);
            }
            else {
                // with 'pre' option, the first call must happen before
                // the component is mounted so it is called synchronously.
                job();
            }
        };
    }
    const effect = new ReactiveEffect(getter, scheduler);
    if ((false)) {}
    // initial run
    if (cb) {
        if (immediate) {
            job();
        }
        else {
            oldValue = effect.run();
        }
    }
    else if (flush === 'post') {
        queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    }
    else {
        effect.run();
    }
    return () => {
        effect.stop();
        if (instance && instance.scope) {
            (0,shared_esm_bundler.remove)(instance.scope.effects, effect);
        }
    };
}
// this.$watch
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0,shared_esm_bundler.isString)(source)
        ? source.includes('.')
            ? createPathGetter(publicThis, source)
            : () => publicThis[source]
        : source.bind(publicThis, publicThis);
    let cb;
    if ((0,shared_esm_bundler.isFunction)(value)) {
        cb = value;
    }
    else {
        cb = value.handler;
        options = value;
    }
    const cur = currentInstance;
    setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    if (cur) {
        setCurrentInstance(cur);
    }
    else {
        unsetCurrentInstance();
    }
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split('.');
    return () => {
        let cur = ctx;
        for (let i = 0; i < segments.length && cur; i++) {
            cur = cur[segments[i]];
        }
        return cur;
    };
}
function traverse(value, seen) {
    if (!(0,shared_esm_bundler.isObject)(value) || value["__v_skip" /* SKIP */]) {
        return value;
    }
    seen = seen || new Set();
    if (seen.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if ((0,shared_esm_bundler.isArray)(value)) {
        for (let i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if ((0,shared_esm_bundler.isSet)(value) || (0,shared_esm_bundler.isMap)(value)) {
        value.forEach((v) => {
            traverse(v, seen);
        });
    }
    else if ((0,shared_esm_bundler.isPlainObject)(value)) {
        for (const key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    onMounted(() => {
        state.isMounted = true;
    });
    onBeforeUnmount(() => {
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [Function, Array];
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: TransitionHookValidator,
        onEnter: TransitionHookValidator,
        onAfterEnter: TransitionHookValidator,
        onEnterCancelled: TransitionHookValidator,
        // leave
        onBeforeLeave: TransitionHookValidator,
        onLeave: TransitionHookValidator,
        onAfterLeave: TransitionHookValidator,
        onLeaveCancelled: TransitionHookValidator,
        // appear
        onBeforeAppear: TransitionHookValidator,
        onAppear: TransitionHookValidator,
        onAfterAppear: TransitionHookValidator,
        onAppearCancelled: TransitionHookValidator
    },
    setup(props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        let prevTransitionKey;
        return () => {
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) {
                return;
            }
            // warn multiple elements
            if (false) {}
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = reactivity_esm_bundler_toRaw(props);
            const { mode } = rawProps;
            // check mode
            if (false) {}
            // at this point children has a guaranteed length of 1.
            const child = children[0];
            if (state.isLeaving) {
                return emptyPlaceholder(child);
            }
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = getKeepAliveChild(child);
            if (!innerChild) {
                return emptyPlaceholder(child);
            }
            const enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance);
            setTransitionHooks(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) {
                    prevTransitionKey = key;
                }
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild &&
                oldInnerChild.type !== Comment &&
                (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                setTransitionHooks(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === 'out-in') {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = () => {
                        state.isLeaving = false;
                        instance.update();
                    };
                    return emptyPlaceholder(child);
                }
                else if (mode === 'in-out' && innerChild.type !== Comment) {
                    leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
                        const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                        leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                        // early removal callback
                        el._leaveCb = () => {
                            earlyRemove();
                            el._leaveCb = undefined;
                            delete enterHooks.delayedLeave;
                        };
                        enterHooks.delayedLeave = delayedLeave;
                    };
                }
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function resolveTransitionHooks(vnode, props, state, instance) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args) => {
        hook &&
            callWithAsyncErrorHandling(hook, instance, 9 /* TRANSITION_HOOK */, args);
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter(el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) {
                    hook = onBeforeAppear || onBeforeEnter;
                }
                else {
                    return;
                }
            }
            // for same element (v-show)
            if (el._leaveCb) {
                el._leaveCb(true /* cancelled */);
            }
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode &&
                isSameVNodeType(vnode, leavingVNode) &&
                leavingVNode.el._leaveCb) {
                // force early removal (not cancelled)
                leavingVNode.el._leaveCb();
            }
            callHook(hook, [el]);
        },
        enter(el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                }
                else {
                    return;
                }
            }
            let called = false;
            const done = (el._enterCb = (cancelled) => {
                if (called)
                    return;
                called = true;
                if (cancelled) {
                    callHook(cancelHook, [el]);
                }
                else {
                    callHook(afterHook, [el]);
                }
                if (hooks.delayedLeave) {
                    hooks.delayedLeave();
                }
                el._enterCb = undefined;
            });
            if (hook) {
                hook(el, done);
                if (hook.length <= 1) {
                    done();
                }
            }
            else {
                done();
            }
        },
        leave(el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) {
                el._enterCb(true /* cancelled */);
            }
            if (state.isUnmounting) {
                return remove();
            }
            callHook(onBeforeLeave, [el]);
            let called = false;
            const done = (el._leaveCb = (cancelled) => {
                if (called)
                    return;
                called = true;
                remove();
                if (cancelled) {
                    callHook(onLeaveCancelled, [el]);
                }
                else {
                    callHook(onAfterLeave, [el]);
                }
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) {
                    delete leavingVNodesCache[key];
                }
            });
            leavingVNodesCache[key] = vnode;
            if (onLeave) {
                onLeave(el, done);
                if (onLeave.length <= 1) {
                    done();
                }
            }
            else {
                done();
            }
        },
        clone(vnode) {
            return resolveTransitionHooks(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getKeepAliveChild(vnode) {
    return isKeepAlive(vnode)
        ? vnode.children
            ? vnode.children[0]
            : undefined
        : vnode;
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* COMPONENT */ && vnode.component) {
        setTransitionHooks(vnode.component.subTree, hooks);
    }
    else if (vnode.shapeFlag & 128 /* SUSPENSE */) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    }
    else {
        vnode.transition = hooks;
    }
}
function getTransitionRawChildren(children, keepComment = false) {
    let ret = [];
    let keyedFragmentCount = 0;
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        // handle fragment children case, e.g. v-for
        if (child.type === Fragment) {
            if (child.patchFlag & 128 /* KEYED_FRAGMENT */)
                keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment));
        }
        // comment placeholders should be skipped, e.g. v-if
        else if (keepComment || child.type !== Comment) {
            ret.push(child);
        }
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) {
        for (let i = 0; i < ret.length; i++) {
            ret[i].patchFlag = -2 /* BAIL */;
        }
    }
    return ret;
}

// implementation, close to no-op
function defineComponent(options) {
    return (0,shared_esm_bundler.isFunction)(options) ? { setup: options, name: options.name } : options;
}

const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
function defineAsyncComponent(source) {
    if ((0,shared_esm_bundler.isFunction)(source)) {
        source = { loader: source };
    }
    const { loader, loadingComponent, errorComponent, delay = 200, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = () => {
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = () => {
        let thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(err => {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise((resolve, reject) => {
                            const userRetry = () => resolve(retry());
                            const userFail = () => reject(err);
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then((comp) => {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {}
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {}
                    resolvedComp = comp;
                    return comp;
                })));
    };
    return defineComponent({
        name: 'AsyncComponentWrapper',
        __asyncLoader: load,
        get __asyncResolved() {
            return resolvedComp;
        },
        setup() {
            const instance = currentInstance;
            // already resolved
            if (resolvedComp) {
                return () => createInnerComp(resolvedComp, instance);
            }
            const onError = (err) => {
                pendingRequest = null;
                handleError(err, instance, 13 /* ASYNC_COMPONENT_LOADER */, !errorComponent /* do not throw in dev if user provided error component */);
            };
            // suspense-controlled or SSR.
            if ((suspensible && instance.suspense) ||
                (isInSSRComponentSetup)) {
                return load()
                    .then(comp => {
                    return () => createInnerComp(comp, instance);
                })
                    .catch(err => {
                    onError(err);
                    return () => errorComponent
                        ? createVNode(errorComponent, {
                            error: err
                        })
                        : null;
                });
            }
            const loaded = ref(false);
            const error = ref();
            const delayed = ref(!!delay);
            if (delay) {
                setTimeout(() => {
                    delayed.value = false;
                }, delay);
            }
            if (timeout != null) {
                setTimeout(() => {
                    if (!loaded.value && !error.value) {
                        const err = new Error(`Async component timed out after ${timeout}ms.`);
                        onError(err);
                        error.value = err;
                    }
                }, timeout);
            }
            load()
                .then(() => {
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) {
                    // parent is keep-alive, force update so the loaded component's
                    // name is taken into account
                    queueJob(instance.parent.update);
                }
            })
                .catch(err => {
                onError(err);
                error.value = err;
            });
            return () => {
                if (loaded.value && resolvedComp) {
                    return createInnerComp(resolvedComp, instance);
                }
                else if (error.value && errorComponent) {
                    return createVNode(errorComponent, {
                        error: error.value
                    });
                }
                else if (loadingComponent && !delayed.value) {
                    return createVNode(loadingComponent);
                }
            };
        }
    });
}
function createInnerComp(comp, { vnode: { ref, props, children } }) {
    const vnode = createVNode(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}

const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [String, RegExp, Array],
        exclude: [String, RegExp, Array],
        max: [String, Number]
    },
    setup(props, { slots }) {
        const instance = getCurrentInstance();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) {
            return slots.default;
        }
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (( false) || __VUE_PROD_DEVTOOLS__) {
            instance.__v_cache = cache;
        }
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement('div');
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized) => {
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* ENTER */, parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(() => {
                instance.isDeactivated = false;
                if (instance.a) {
                    (0,shared_esm_bundler.invokeArrayFns)(instance.a);
                }
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) {
                    invokeVNodeHook(vnodeHook, instance.parent, vnode);
                }
            }, parentSuspense);
            if (( false) || __VUE_PROD_DEVTOOLS__) {
                // Update components tree
                devtoolsComponentAdded(instance);
            }
        };
        sharedContext.deactivate = (vnode) => {
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* LEAVE */, parentSuspense);
            queuePostRenderEffect(() => {
                if (instance.da) {
                    (0,shared_esm_bundler.invokeArrayFns)(instance.da);
                }
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) {
                    invokeVNodeHook(vnodeHook, instance.parent, vnode);
                }
                instance.isDeactivated = true;
            }, parentSuspense);
            if (( false) || __VUE_PROD_DEVTOOLS__) {
                // Update components tree
                devtoolsComponentAdded(instance);
            }
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key) => {
                const name = getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) {
                    pruneCacheEntry(key);
                }
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) {
                unmount(cached);
            }
            else if (current) {
                // current active instance should no longer be kept-alive.
                // we can't unmount it now but it might be later, so reset its flag now.
                resetShapeFlag(current);
            }
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        watch(() => [props.include, props.exclude], ([include, exclude]) => {
            include && pruneCache(name => matches(include, name));
            exclude && pruneCache(name => !matches(exclude, name));
        }, 
        // prune post-render after `current` has been updated
        { flush: 'post', deep: true });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = () => {
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) {
                cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(() => {
            cache.forEach(cached => {
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return () => {
            pendingCacheKey = null;
            if (!slots.default) {
                return null;
            }
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                if ((false)) {}
                current = null;
                return children;
            }
            else if (!isVNode(rawVNode) ||
                (!(rawVNode.shapeFlag & 4 /* STATEFUL_COMPONENT */) &&
                    !(rawVNode.shapeFlag & 128 /* SUSPENSE */))) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = getComponentName(isAsyncWrapper(vnode)
                ? vnode.type.__asyncResolved || {}
                : comp);
            const { include, exclude, max } = props;
            if ((include && (!name || !matches(include, name))) ||
                (exclude && name && matches(exclude, name))) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128 /* SUSPENSE */) {
                    rawVNode.ssContent = vnode;
                }
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) {
                    // recursively update transition hooks on subTree
                    setTransitionHooks(vnode, vnode.transition);
                }
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* COMPONENT_KEPT_ALIVE */;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            }
            else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) {
                    pruneCacheEntry(keys.values().next().value);
                }
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */;
            current = vnode;
            return rawVNode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0,shared_esm_bundler.isArray)(pattern)) {
        return pattern.some((p) => matches(p, name));
    }
    else if ((0,shared_esm_bundler.isString)(pattern)) {
        return pattern.split(',').includes(name);
    }
    else if (pattern.test) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a" /* ACTIVATED */, target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da" /* DEACTIVATED */, target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc ||
        (hook.__wdc = () => {
            // only fire the hook if the target instance is NOT in a deactivated branch.
            let current = target;
            while (current) {
                if (current.isDeactivated) {
                    return;
                }
                current = current.parent;
            }
            return hook();
        });
    injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while (current && current.parent) {
            if (isKeepAlive(current.parent.vnode)) {
                injectToKeepAliveRoot(wrappedHook, type, target, current);
            }
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = injectHook(type, hook, keepAliveRoot, true /* prepend */);
    onUnmounted(() => {
        (0,shared_esm_bundler.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
        shapeFlag -= 256 /* COMPONENT_SHOULD_KEEP_ALIVE */;
    }
    if (shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */) {
        shapeFlag -= 512 /* COMPONENT_KEPT_ALIVE */;
    }
    vnode.shapeFlag = shapeFlag;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* SUSPENSE */ ? vnode.ssContent : vnode;
}

function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh ||
            (hook.__weh = (...args) => {
                if (target.isUnmounted) {
                    return;
                }
                // disable tracking inside all lifecycle hooks
                // since they can potentially be called inside effects.
                pauseTracking();
                // Set currentInstance during hook invocation.
                // This assumes the hook does not synchronously trigger other hooks, which
                // can only be false when the user does something really funky.
                setCurrentInstance(target);
                const res = callWithAsyncErrorHandling(hook, target, type, args);
                unsetCurrentInstance();
                resetTracking();
                return res;
            });
        if (prepend) {
            hooks.unshift(wrappedHook);
        }
        else {
            hooks.push(wrappedHook);
        }
        return wrappedHook;
    }
    else if ((false)) {}
}
const createHook = (lifecycle) => (hook, target = currentInstance) => 
// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
(!isInSSRComponentSetup || lifecycle === "sp" /* SERVER_PREFETCH */) &&
    injectHook(lifecycle, hook, target);
const onBeforeMount = createHook("bm" /* BEFORE_MOUNT */);
const onMounted = createHook("m" /* MOUNTED */);
const onBeforeUpdate = createHook("bu" /* BEFORE_UPDATE */);
const onUpdated = createHook("u" /* UPDATED */);
const onBeforeUnmount = createHook("bum" /* BEFORE_UNMOUNT */);
const onUnmounted = createHook("um" /* UNMOUNTED */);
const onServerPrefetch = createHook("sp" /* SERVER_PREFETCH */);
const onRenderTriggered = createHook("rtg" /* RENDER_TRIGGERED */);
const onRenderTracked = createHook("rtc" /* RENDER_TRACKED */);
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec" /* ERROR_CAPTURED */, hook, target);
}

function createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key) => {
        if (cache[key]) {
            runtime_core_esm_bundler_warn(`${type} property "${key}" is already defined in ${cache[key]}.`);
        }
        else {
            cache[key] = type;
        }
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) {
        callHook(options.beforeCreate, instance, "bc" /* BEFORE_CREATE */);
    }
    const { 
    // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, 
    // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, 
    // public API
    expose, inheritAttrs, 
    // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = ( false) ? 0 : null;
    if ((false)) {}
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) {
        resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    }
    if (methods) {
        for (const key in methods) {
            const methodHandler = methods[key];
            if ((0,shared_esm_bundler.isFunction)(methodHandler)) {
                // In dev mode, we use the `createRenderContext` function to define
                // methods to the proxy target, and those are read-only but
                // reconfigurable, so it needs to be redefined here
                if ((false)) {}
                else {
                    ctx[key] = methodHandler.bind(publicThis);
                }
                if ((false)) {}
            }
            else if ((false)) {}
        }
    }
    if (dataOptions) {
        if (false) {}
        const data = dataOptions.call(publicThis, publicThis);
        if (false) {}
        if (!(0,shared_esm_bundler.isObject)(data)) {
            ( false) && 0;
        }
        else {
            instance.data = reactive(data);
            if ((false)) {}
        }
    }
    // state initialization complete at this point - start caching access
    shouldCacheAccess = true;
    if (computedOptions) {
        for (const key in computedOptions) {
            const opt = computedOptions[key];
            const get = (0,shared_esm_bundler.isFunction)(opt)
                ? opt.bind(publicThis, publicThis)
                : (0,shared_esm_bundler.isFunction)(opt.get)
                    ? opt.get.bind(publicThis, publicThis)
                    : shared_esm_bundler.NOOP;
            if (false) {}
            const set = !(0,shared_esm_bundler.isFunction)(opt) && (0,shared_esm_bundler.isFunction)(opt.set)
                ? opt.set.bind(publicThis)
                : ( false)
                    ? 0
                    : shared_esm_bundler.NOOP;
            const c = runtime_core_esm_bundler_computed({
                get,
                set
            });
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: () => c.value,
                set: v => (c.value = v)
            });
            if ((false)) {}
        }
    }
    if (watchOptions) {
        for (const key in watchOptions) {
            createWatcher(watchOptions[key], ctx, publicThis, key);
        }
    }
    if (provideOptions) {
        const provides = (0,shared_esm_bundler.isFunction)(provideOptions)
            ? provideOptions.call(publicThis)
            : provideOptions;
        Reflect.ownKeys(provides).forEach(key => {
            provide(key, provides[key]);
        });
    }
    if (created) {
        callHook(created, instance, "c" /* CREATED */);
    }
    function registerLifecycleHook(register, hook) {
        if ((0,shared_esm_bundler.isArray)(hook)) {
            hook.forEach(_hook => register(_hook.bind(publicThis)));
        }
        else if (hook) {
            register(hook.bind(publicThis));
        }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0,shared_esm_bundler.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(key => {
                Object.defineProperty(exposed, key, {
                    get: () => publicThis[key],
                    set: val => (publicThis[key] = val)
                });
            });
        }
        else if (!instance.exposed) {
            instance.exposed = {};
        }
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === shared_esm_bundler.NOOP) {
        instance.render = render;
    }
    if (inheritAttrs != null) {
        instance.inheritAttrs = inheritAttrs;
    }
    // asset options.
    if (components)
        instance.components = components;
    if (directives)
        instance.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = shared_esm_bundler.NOOP, unwrapRef = false) {
    if ((0,shared_esm_bundler.isArray)(injectOptions)) {
        injectOptions = normalizeInject(injectOptions);
    }
    for (const key in injectOptions) {
        const opt = injectOptions[key];
        let injected;
        if ((0,shared_esm_bundler.isObject)(opt)) {
            if ('default' in opt) {
                injected = inject(opt.from || key, opt.default, true /* treat default function as factory */);
            }
            else {
                injected = inject(opt.from || key);
            }
        }
        else {
            injected = inject(opt);
        }
        if (isRef(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) {
                Object.defineProperty(ctx, key, {
                    enumerable: true,
                    configurable: true,
                    get: () => injected.value,
                    set: v => (injected.value = v)
                });
            }
            else {
                if ((false)) {}
                ctx[key] = injected;
            }
        }
        else {
            ctx[key] = injected;
        }
        if ((false)) {}
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0,shared_esm_bundler.isArray)(hook)
        ? hook.map(h => h.bind(instance.proxy))
        : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes('.')
        ? createPathGetter(publicThis, key)
        : () => publicThis[key];
    if ((0,shared_esm_bundler.isString)(raw)) {
        const handler = ctx[raw];
        if ((0,shared_esm_bundler.isFunction)(handler)) {
            watch(getter, handler);
        }
        else if ((false)) {}
    }
    else if ((0,shared_esm_bundler.isFunction)(raw)) {
        watch(getter, raw.bind(publicThis));
    }
    else if ((0,shared_esm_bundler.isObject)(raw)) {
        if ((0,shared_esm_bundler.isArray)(raw)) {
            raw.forEach(r => createWatcher(r, ctx, publicThis, key));
        }
        else {
            const handler = (0,shared_esm_bundler.isFunction)(raw.handler)
                ? raw.handler.bind(publicThis)
                : ctx[raw.handler];
            if ((0,shared_esm_bundler.isFunction)(handler)) {
                watch(getter, handler, raw);
            }
            else if ((false)) {}
        }
    }
    else if ((false)) {}
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) {
        resolved = cached;
    }
    else if (!globalMixins.length && !mixins && !extendsOptions) {
        {
            resolved = base;
        }
    }
    else {
        resolved = {};
        if (globalMixins.length) {
            globalMixins.forEach(m => mergeOptions(resolved, m, optionMergeStrategies, true));
        }
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) {
        mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
        mixins.forEach((m) => mergeOptions(to, m, strats, true));
    }
    for (const key in from) {
        if (asMixin && key === 'expose') {
            ( false) &&
                0;
        }
        else {
            const strat = internalOptionMergeStrats[key] || (strats && strats[key]);
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeObjectOptions,
    emits: mergeObjectOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) {
        return to;
    }
    if (!to) {
        return from;
    }
    return function mergedDataFn() {
        return ((0,shared_esm_bundler.extend))((0,shared_esm_bundler.isFunction)(to) ? to.call(this, this) : to, (0,shared_esm_bundler.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0,shared_esm_bundler.isArray)(raw)) {
        const res = {};
        for (let i = 0; i < raw.length; i++) {
            res[raw[i]] = raw[i];
        }
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0,shared_esm_bundler.extend)((0,shared_esm_bundler.extend)(Object.create(null), to), from) : from;
}
function mergeWatchOptions(to, from) {
    if (!to)
        return from;
    if (!from)
        return to;
    const merged = (0,shared_esm_bundler.extend)(Object.create(null), to);
    for (const key in from) {
        merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
}

function initProps(instance, rawProps, isStateful, // result of bitwise flag comparison
isSSR = false) {
    const props = {};
    const attrs = {};
    (0,shared_esm_bundler.def)(attrs, InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for (const key in instance.propsOptions[0]) {
        if (!(key in props)) {
            props[key] = undefined;
        }
    }
    // validation
    if ((false)) {}
    if (isStateful) {
        // stateful
        instance.props = isSSR ? props : shallowReactive(props);
    }
    else {
        if (!instance.type.props) {
            // functional w/ optional props, props === attrs
            instance.props = attrs;
        }
        else {
            // functional w/ declared props
            instance.props = props;
        }
    }
    instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = reactivity_esm_bundler_toRaw(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
     true &&
        (optimized || patchFlag > 0) &&
        !(patchFlag & 16 /* FULL_PROPS */)) {
        if (patchFlag & 8 /* PROPS */) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for (let i = 0; i < propsToUpdate.length; i++) {
                let key = propsToUpdate[i];
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0,shared_esm_bundler.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    }
                    else {
                        const camelizedKey = (0,shared_esm_bundler.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false /* isAbsent */);
                    }
                }
                else {
                    if (value !== attrs[key]) {
                        attrs[key] = value;
                        hasAttrsChanged = true;
                    }
                }
            }
        }
    }
    else {
        // full props update.
        if (setFullProps(instance, rawProps, props, attrs)) {
            hasAttrsChanged = true;
        }
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for (const key in rawCurrentProps) {
            if (!rawProps ||
                // for camelCase
                (!(0,shared_esm_bundler.hasOwn)(rawProps, key) &&
                    // it's possible the original props was passed in as kebab-case
                    // and converted to camelCase (#955)
                    ((kebabKey = (0,shared_esm_bundler.hyphenate)(key)) === key || !(0,shared_esm_bundler.hasOwn)(rawProps, kebabKey)))) {
                if (options) {
                    if (rawPrevProps &&
                        // for camelCase
                        (rawPrevProps[key] !== undefined ||
                            // for kebab-case
                            rawPrevProps[kebabKey] !== undefined)) {
                        props[key] = resolvePropValue(options, rawCurrentProps, key, undefined, instance, true /* isAbsent */);
                    }
                }
                else {
                    delete props[key];
                }
            }
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for (const key in attrs) {
                if (!rawProps ||
                    (!(0,shared_esm_bundler.hasOwn)(rawProps, key) &&
                        (!false ))) {
                    delete attrs[key];
                    hasAttrsChanged = true;
                }
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) {
        trigger(instance, "set" /* SET */, '$attrs');
    }
    if ((false)) {}
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) {
        for (let key in rawProps) {
            // key, ref are reserved and never passed down
            if ((0,shared_esm_bundler.isReservedProp)(key)) {
                continue;
            }
            const value = rawProps[key];
            // prop option names are camelized during normalization, so to support
            // kebab -> camel conversion here we need to camelize the key.
            let camelKey;
            if (options && (0,shared_esm_bundler.hasOwn)(options, (camelKey = (0,shared_esm_bundler.camelize)(key)))) {
                if (!needCastKeys || !needCastKeys.includes(camelKey)) {
                    props[camelKey] = value;
                }
                else {
                    (rawCastValues || (rawCastValues = {}))[camelKey] = value;
                }
            }
            else if (!isEmitListener(instance.emitsOptions, key)) {
                if (!(key in attrs) || value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = reactivity_esm_bundler_toRaw(props);
        const castValues = rawCastValues || shared_esm_bundler.EMPTY_OBJ;
        for (let i = 0; i < needCastKeys.length; i++) {
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0,shared_esm_bundler.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0,shared_esm_bundler.hasOwn)(opt, 'default');
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0,shared_esm_bundler.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) {
                    value = propsDefaults[key];
                }
                else {
                    setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    unsetCurrentInstance();
                }
            }
            else {
                value = defaultValue;
            }
        }
        // boolean casting
        if (opt[0 /* shouldCast */]) {
            if (isAbsent && !hasDefault) {
                value = false;
            }
            else if (opt[1 /* shouldCastTrue */] &&
                (value === '' || value === (0,shared_esm_bundler.hyphenate)(key))) {
                value = true;
            }
        }
    }
    return value;
}
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) {
        return cached;
    }
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0,shared_esm_bundler.isFunction)(comp)) {
        const extendProps = (raw) => {
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw, appContext, true);
            (0,shared_esm_bundler.extend)(normalized, props);
            if (keys)
                needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) {
            appContext.mixins.forEach(extendProps);
        }
        if (comp.extends) {
            extendProps(comp.extends);
        }
        if (comp.mixins) {
            comp.mixins.forEach(extendProps);
        }
    }
    if (!raw && !hasExtends) {
        cache.set(comp, shared_esm_bundler.EMPTY_ARR);
        return shared_esm_bundler.EMPTY_ARR;
    }
    if ((0,shared_esm_bundler.isArray)(raw)) {
        for (let i = 0; i < raw.length; i++) {
            if (false) {}
            const normalizedKey = (0,shared_esm_bundler.camelize)(raw[i]);
            if (validatePropName(normalizedKey)) {
                normalized[normalizedKey] = shared_esm_bundler.EMPTY_OBJ;
            }
        }
    }
    else if (raw) {
        if (false) {}
        for (const key in raw) {
            const normalizedKey = (0,shared_esm_bundler.camelize)(key);
            if (validatePropName(normalizedKey)) {
                const opt = raw[key];
                const prop = (normalized[normalizedKey] =
                    (0,shared_esm_bundler.isArray)(opt) || (0,shared_esm_bundler.isFunction)(opt) ? { type: opt } : opt);
                if (prop) {
                    const booleanIndex = getTypeIndex(Boolean, prop.type);
                    const stringIndex = getTypeIndex(String, prop.type);
                    prop[0 /* shouldCast */] = booleanIndex > -1;
                    prop[1 /* shouldCastTrue */] =
                        stringIndex < 0 || booleanIndex < stringIndex;
                    // if the prop needs boolean casting or default value
                    if (booleanIndex > -1 || (0,shared_esm_bundler.hasOwn)(prop, 'default')) {
                        needCastKeys.push(normalizedKey);
                    }
                }
            }
        }
    }
    const res = [normalized, needCastKeys];
    cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== '$') {
        return true;
    }
    else if ((false)) {}
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? 'null' : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if ((0,shared_esm_bundler.isArray)(expectedTypes)) {
        return expectedTypes.findIndex(t => isSameType(t, type));
    }
    else if ((0,shared_esm_bundler.isFunction)(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    return -1;
}
/**
 * dev only
 */
function validateProps(rawProps, props, instance) {
    const resolvedValues = toRaw(props);
    const options = instance.propsOptions[0];
    for (const key in options) {
        let opt = options[key];
        if (opt == null)
            continue;
        validateProp(key, resolvedValues[key], opt, !hasOwn(rawProps, key) && !hasOwn(rawProps, hyphenate(key)));
    }
}
/**
 * dev only
 */
function validateProp(name, value, prop, isAbsent) {
    const { type, required, validator } = prop;
    // required!
    if (required && isAbsent) {
        runtime_core_esm_bundler_warn('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) {
        return;
    }
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = isArray(type) ? type : [type];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for (let i = 0; i < types.length && !isValid; i++) {
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || '');
            isValid = valid;
        }
        if (!isValid) {
            runtime_core_esm_bundler_warn(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) {
        runtime_core_esm_bundler_warn('Invalid prop: custom validator check failed for prop "' + name + '".');
    }
}
const isSimpleType = /*#__PURE__*/ (/* unused pure expression or super */ null && (makeMap('String,Number,Boolean,Function,Symbol,BigInt')));
/**
 * dev only
 */
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else if (expectedType === 'null') {
        valid = value === null;
    }
    else {
        valid = value instanceof type;
    }
    return {
        valid,
        expectedType
    };
}
/**
 * dev only
 */
function getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` +
        ` Expected ${expectedTypes.map(capitalize).join(' | ')}`;
    const expectedType = expectedTypes[0];
    const receivedType = toRawType(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        !isBoolean(expectedType, receivedType)) {
        message += ` with value ${expectedValue}`;
    }
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += `with value ${receivedValue}.`;
    }
    return message;
}
/**
 * dev only
 */
function styleValue(value, type) {
    if (type === 'String') {
        return `"${value}"`;
    }
    else if (type === 'Number') {
        return `${Number(value)}`;
    }
    else {
        return `${value}`;
    }
}
/**
 * dev only
 */
function isExplicable(type) {
    const explicitTypes = ['string', 'number', 'boolean'];
    return explicitTypes.some(elem => type.toLowerCase() === elem);
}
/**
 * dev only
 */
function isBoolean(...args) {
    return args.some(elem => elem.toLowerCase() === 'boolean');
}

const isInternalKey = (key) => key[0] === '_' || key === '$stable';
const normalizeSlotValue = (value) => (0,shared_esm_bundler.isArray)(value)
    ? value.map(normalizeVNode)
    : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
    const normalized = withCtx((...args) => {
        if (false) {}
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance) => {
    const ctx = rawSlots._ctx;
    for (const key in rawSlots) {
        if (isInternalKey(key))
            continue;
        const value = rawSlots[key];
        if ((0,shared_esm_bundler.isFunction)(value)) {
            slots[key] = normalizeSlot(key, value, ctx);
        }
        else if (value != null) {
            if (false) {}
            const normalized = normalizeSlotValue(value);
            slots[key] = () => normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children) => {
    if (false) {}
    const normalized = normalizeSlotValue(children);
    instance.slots.default = () => normalized;
};
const initSlots = (instance, children) => {
    if (instance.vnode.shapeFlag & 32 /* SLOTS_CHILDREN */) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = reactivity_esm_bundler_toRaw(children);
            // make compiler marker non-enumerable
            (0,shared_esm_bundler.def)(children, '_', type);
        }
        else {
            normalizeObjectSlots(children, (instance.slots = {}));
        }
    }
    else {
        instance.slots = {};
        if (children) {
            normalizeVNodeSlots(instance, children);
        }
    }
    (0,shared_esm_bundler.def)(instance.slots, InternalObjectKey, 1);
};
const updateSlots = (instance, children, optimized) => {
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = shared_esm_bundler.EMPTY_OBJ;
    if (vnode.shapeFlag & 32 /* SLOTS_CHILDREN */) {
        const type = children._;
        if (type) {
            // compiled slots.
            if (false) {}
            else if (optimized && type === 1 /* STABLE */) {
                // compiled AND stable.
                // no need to update, and skip stale slots removal.
                needDeletionCheck = false;
            }
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0,shared_esm_bundler.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* STABLE */) {
                    delete slots._;
                }
            }
        }
        else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    }
    else if (children) {
        // non slot object children (direct value) passed to a component
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = { default: 1 };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for (const key in slots) {
            if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
                delete slots[key];
            }
        }
    }
};

/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/
function validateDirectiveName(name) {
    if (isBuiltInDirective(name)) {
        runtime_core_esm_bundler_warn('Do not use built-in directive ids as custom directive id: ' + name);
    }
}
/**
 * Adds directives to a VNode.
 */
function withDirectives(vnode, directives) {
    const internalInstance = currentRenderingInstance;
    if (internalInstance === null) {
        ( false) && 0;
        return vnode;
    }
    const instance = internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for (let i = 0; i < directives.length; i++) {
        let [dir, value, arg, modifiers = shared_esm_bundler.EMPTY_OBJ] = directives[i];
        if ((0,shared_esm_bundler.isFunction)(dir)) {
            dir = {
                mounted: dir,
                updated: dir
            };
        }
        if (dir.deep) {
            traverse(value);
        }
        bindings.push({
            dir,
            instance,
            value,
            oldValue: void 0,
            arg,
            modifiers
        });
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for (let i = 0; i < bindings.length; i++) {
        const binding = bindings[i];
        if (oldBindings) {
            binding.oldValue = oldBindings[i].value;
        }
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            pauseTracking();
            callWithAsyncErrorHandling(hook, instance, 8 /* DIRECTIVE_HOOK */, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            resetTracking();
        }
    }
}

function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: shared_esm_bundler.NO,
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let uid = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (rootProps != null && !(0,shared_esm_bundler.isObject)(rootProps)) {
            ( false) && 0;
            rootProps = null;
        }
        const context = createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = (context.app = {
            _uid: uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config() {
                return context.config;
            },
            set config(v) {
                if ((false)) {}
            },
            use(plugin, ...options) {
                if (installedPlugins.has(plugin)) {
                    ( false) && 0;
                }
                else if (plugin && (0,shared_esm_bundler.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                }
                else if ((0,shared_esm_bundler.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                else if ((false)) {}
                return app;
            },
            mixin(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) {
                        context.mixins.push(mixin);
                    }
                    else if ((false)) {}
                }
                else if ((false)) {}
                return app;
            },
            component(name, component) {
                if ((false)) {}
                if (!component) {
                    return context.components[name];
                }
                if (false) {}
                context.components[name] = component;
                return app;
            },
            directive(name, directive) {
                if ((false)) {}
                if (!directive) {
                    return context.directives[name];
                }
                if (false) {}
                context.directives[name] = directive;
                return app;
            },
            mount(rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = createVNode(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    // HMR root reload
                    if ((false)) {}
                    if (isHydrate && hydrate) {
                        hydrate(vnode, rootContainer);
                    }
                    else {
                        render(vnode, rootContainer, isSVG);
                    }
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (( false) || __VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getExposeProxy(vnode.component) || vnode.component.proxy;
                }
                else if ((false)) {}
            },
            unmount() {
                if (isMounted) {
                    render(null, app._container);
                    if (( false) || __VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
                else if ((false)) {}
            },
            provide(key, value) {
                if (false) {}
                // TypeScript doesn't allow symbols as index type
                // https://github.com/Microsoft/TypeScript/issues/24587
                context.provides[key] = value;
                return app;
            }
        });
        return app;
    };
}

/**
 * Function for handling a template ref
 */
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0,shared_esm_bundler.isArray)(rawRef)) {
        rawRef.forEach((r, i) => setRef(r, oldRawRef && ((0,shared_esm_bundler.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
        // when mounting async components, nothing needs to be done,
        // because the template ref is forwarded to inner component
        return;
    }
    const refValue = vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */
        ? getExposeProxy(vnode.component) || vnode.component.proxy
        : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    if (false) {}
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === shared_esm_bundler.EMPTY_OBJ ? (owner.refs = {}) : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0,shared_esm_bundler.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0,shared_esm_bundler.hasOwn)(setupState, oldRef)) {
                setupState[oldRef] = null;
            }
        }
        else if (isRef(oldRef)) {
            oldRef.value = null;
        }
    }
    if ((0,shared_esm_bundler.isFunction)(ref)) {
        callWithErrorHandling(ref, owner, 12 /* FUNCTION_REF */, [value, refs]);
    }
    else {
        const _isString = (0,shared_esm_bundler.isString)(ref);
        const _isRef = isRef(ref);
        if (_isString || _isRef) {
            const doSet = () => {
                if (rawRef.f) {
                    const existing = _isString ? refs[ref] : ref.value;
                    if (isUnmount) {
                        (0,shared_esm_bundler.isArray)(existing) && (0,shared_esm_bundler.remove)(existing, refValue);
                    }
                    else {
                        if (!(0,shared_esm_bundler.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [refValue];
                            }
                            else {
                                ref.value = [refValue];
                                if (rawRef.k)
                                    refs[rawRef.k] = ref.value;
                            }
                        }
                        else if (!existing.includes(refValue)) {
                            existing.push(refValue);
                        }
                    }
                }
                else if (_isString) {
                    refs[ref] = value;
                    if ((0,shared_esm_bundler.hasOwn)(setupState, ref)) {
                        setupState[ref] = value;
                    }
                }
                else if (isRef(ref)) {
                    ref.value = value;
                    if (rawRef.k)
                        refs[rawRef.k] = value;
                }
                else if ((false)) {}
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            }
            else {
                doSet();
            }
        }
        else if ((false)) {}
    }
}

let hasMismatch = false;
const isSVGContainer = (container) => /svg/.test(container.namespaceURI) && container.tagName !== 'foreignObject';
const isComment = (node) => node.nodeType === 8 /* COMMENT */;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container) => {
        if (!container.hasChildNodes()) {
            ( false) &&
                0;
            patch(null, vnode, container);
            flushPostFlushCbs();
            return;
        }
        hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        if (hasMismatch && !false) {
            // this error should show up in production
            console.error(`Hydration completed but contains mismatches.`);
        }
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false) => {
        const isFragmentStart = isComment(node) && node.data === '[';
        const onMismatch = () => handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag } = vnode;
        const domType = node.nodeType;
        vnode.el = node;
        let nextNode = null;
        switch (type) {
            case Text:
                if (domType !== 3 /* TEXT */) {
                    nextNode = onMismatch();
                }
                else {
                    if (node.data !== vnode.children) {
                        hasMismatch = true;
                        ( false) &&
                            0;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (domType !== 8 /* COMMENT */ || isFragmentStart) {
                    nextNode = onMismatch();
                }
                else {
                    nextNode = nextSibling(node);
                }
                break;
            case Static:
                if (domType !== 1 /* ELEMENT */) {
                    nextNode = onMismatch();
                }
                else {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for (let i = 0; i < vnode.staticCount; i++) {
                        if (needToAdoptContent)
                            vnode.children += nextNode.outerHTML;
                        if (i === vnode.staticCount - 1) {
                            vnode.anchor = nextNode;
                        }
                        nextNode = nextSibling(nextNode);
                    }
                    return nextNode;
                }
                break;
            case Fragment:
                if (!isFragmentStart) {
                    nextNode = onMismatch();
                }
                else {
                    nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                }
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */) {
                    if (domType !== 1 /* ELEMENT */ ||
                        vnode.type.toLowerCase() !==
                            node.tagName.toLowerCase()) {
                        nextNode = onMismatch();
                    }
                    else {
                        nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                    }
                }
                else if (shapeFlag & 6 /* COMPONENT */) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart
                        ? locateClosingAsyncAnchor(node)
                        : nextSibling(node);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if (isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode
                                ? nextNode.previousSibling
                                : container.lastChild;
                        }
                        else {
                            subTree =
                                node.nodeType === 3 ? createTextVNode('') : createVNode('div');
                        }
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                }
                else if (shapeFlag & 64 /* TELEPORT */) {
                    if (domType !== 8 /* COMMENT */) {
                        nextNode = onMismatch();
                    }
                    else {
                        nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                    }
                }
                else if (shapeFlag & 128 /* SUSPENSE */) {
                    nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                }
                else if ((false)) {}
        }
        if (ref != null) {
            setRef(ref, null, parentSuspense, vnode);
        }
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = (type === 'input' && dirs) || type === 'option';
        // skip props & children if this is hoisted static nodes
        // #5405 in dev, always hydrate children for HMR
        if (( false) || forcePatchValue || patchFlag !== -1 /* HOISTED */) {
            if (dirs) {
                invokeDirectiveHook(vnode, null, parentComponent, 'created');
            }
            // props
            if (props) {
                if (forcePatchValue ||
                    !optimized ||
                    patchFlag & (16 /* FULL_PROPS */ | 32 /* HYDRATE_EVENTS */)) {
                    for (const key in props) {
                        if ((forcePatchValue && key.endsWith('value')) ||
                            ((0,shared_esm_bundler.isOn)(key) && !(0,shared_esm_bundler.isReservedProp)(key))) {
                            patchProp(el, key, null, props[key], false, undefined, parentComponent);
                        }
                    }
                }
                else if (props.onClick) {
                    // Fast path for click listeners (which is most often) to avoid
                    // iterating through props.
                    patchProp(el, 'onClick', null, props.onClick, false, undefined, parentComponent);
                }
            }
            // vnode / directive hooks
            let vnodeHooks;
            if ((vnodeHooks = props && props.onVnodeBeforeMount)) {
                invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            }
            if (dirs) {
                invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
            }
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) {
                queueEffectWithSuspense(() => {
                    vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                    dirs && invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
                }, parentSuspense);
            }
            // children
            if (shapeFlag & 16 /* ARRAY_CHILDREN */ &&
                // skip if element has innerHTML / textContent
                !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while (next) {
                    hasMismatch = true;
                    if (false) {}
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            }
            else if (shapeFlag & 8 /* TEXT_CHILDREN */) {
                if (el.textContent !== vnode.children) {
                    hasMismatch = true;
                    ( false) &&
                        0;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) => {
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for (let i = 0; i < l; i++) {
            const vnode = optimized
                ? children[i]
                : (children[i] = normalizeVNode(children[i]));
            if (node) {
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
            else if (vnode.type === Text && !vnode.children) {
                continue;
            }
            else {
                hasMismatch = true;
                if (false) {}
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) {
            slotScopeIds = slotScopeIds
                ? slotScopeIds.concat(fragmentSlotScopeIds)
                : fragmentSlotScopeIds;
        }
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === ']') {
            return nextSibling((vnode.anchor = next));
        }
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert((vnode.anchor = createComment(`]`)), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) => {
        hasMismatch = true;
        ( false) &&
            0;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while (true) {
                const next = nextSibling(node);
                if (next && next !== end) {
                    remove(next);
                }
                else {
                    break;
                }
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node) => {
        let match = 0;
        while (node) {
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === '[')
                    match++;
                if (node.data === ']') {
                    if (match === 0) {
                        return nextSibling(node);
                    }
                    else {
                        match--;
                    }
                }
            }
        }
        return node;
    };
    return [hydrate, hydrateNode];
}

/* eslint-disable no-restricted-globals */
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        perf.mark(`vue-${type}-${instance.uid}`);
    }
    if (( false) || __VUE_PROD_DEVTOOLS__) {
        devtoolsPerfStart(instance, type, supported ? perf.now() : Date.now());
    }
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        perf.mark(endTag);
        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (( false) || __VUE_PROD_DEVTOOLS__) {
        devtoolsPerfEnd(instance, type, supported ? perf.now() : Date.now());
    }
}
function isSupported() {
    if (supported !== undefined) {
        return supported;
    }
    if (typeof window !== 'undefined' && window.performance) {
        supported = true;
        perf = window.performance;
    }
    else {
        supported = false;
    }
    return supported;
}

/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== 'boolean') {
        ( false) && 0;
        (0,shared_esm_bundler.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    }
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'boolean') {
        ( false) && 0;
        (0,shared_esm_bundler.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (false) {}
}

const queuePostRenderEffect = queueEffectWithSuspense
    ;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */
function createRenderer(options) {
    return baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
// implementation
function baseCreateRenderer(options, createHydrationFns) {
    // compile-time feature flags check
    {
        initFeatureFlags();
    }
    const target = (0,shared_esm_bundler.getGlobalThis)();
    target.__VUE__ = true;
    if (( false) || __VUE_PROD_DEVTOOLS__) {
        setDevtoolsHook(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    }
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = shared_esm_bundler.NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized =  false ? 0 : !!n2.dynamicChildren) => {
        if (n1 === n2) {
            return;
        }
        // patching & not same type, unmount old tree
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* BAIL */) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch (type) {
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) {
                    mountStaticNode(n2, container, anchor, isSVG);
                }
                else if ((false)) {}
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ELEMENT */) {
                    processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
                else if (shapeFlag & 6 /* COMPONENT */) {
                    processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
                else if (shapeFlag & 64 /* TELEPORT */) {
                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                }
                else if (shapeFlag & 128 /* SUSPENSE */) {
                    type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                }
                else if ((false)) {}
        }
        // set ref
        if (ref != null && parentComponent) {
            setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        }
    };
    const processText = (n1, n2, container, anchor) => {
        if (n1 == null) {
            hostInsert((n2.el = hostCreateText(n2.children)), container, anchor);
        }
        else {
            const el = (n2.el = n1.el);
            if (n2.children !== n1.children) {
                hostSetText(el, n2.children);
            }
        }
    };
    const processCommentNode = (n1, n2, container, anchor) => {
        if (n1 == null) {
            hostInsert((n2.el = hostCreateComment(n2.children || '')), container, anchor);
        }
        else {
            // there's no support for dynamic comments
            n2.el = n1.el;
        }
    };
    const mountStaticNode = (n2, container, anchor, isSVG) => {
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */
    const patchStaticNode = (n1, n2, container, isSVG) => {
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        }
        else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
        let next;
        while (el && el !== anchor) {
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor }) => {
        let next;
        while (el && el !== anchor) {
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        isSVG = isSVG || n2.type === 'svg';
        if (n1 == null) {
            mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        else {
            patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        let el;
        let vnodeHook;
        const { type, props, shapeFlag, transition, patchFlag, dirs } = vnode;
        if ( true &&
            vnode.el &&
            hostCloneNode !== undefined &&
            patchFlag === -1 /* HOISTED */) {
            // If a vnode has non-null el, it means it's being reused.
            // Only static vnodes can be reused, so its mounted DOM nodes should be
            // exactly the same, and we can simply do a clone here.
            // only do this in production since cloned trees cannot be HMR updated.
            el = vnode.el = hostCloneNode(vnode.el);
        }
        else {
            el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
            // mount children first, since some props may rely on child content
            // being already rendered, e.g. `<select value>`
            if (shapeFlag & 8 /* TEXT_CHILDREN */) {
                hostSetElementText(el, vnode.children);
            }
            else if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
                mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== 'foreignObject', slotScopeIds, optimized);
            }
            if (dirs) {
                invokeDirectiveHook(vnode, null, parentComponent, 'created');
            }
            // props
            if (props) {
                for (const key in props) {
                    if (key !== 'value' && !(0,shared_esm_bundler.isReservedProp)(key)) {
                        hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
                /**
                 * Special case for setting value on DOM elements:
                 * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
                 * - it needs to be forced (#1471)
                 * #2353 proposes adding another renderer option to configure this, but
                 * the properties affects are so finite it is worth special casing it
                 * here to reduce the complexity. (Special casing it also should not
                 * affect non-DOM renderers)
                 */
                if ('value' in props) {
                    hostPatchProp(el, 'value', null, props.value);
                }
                if ((vnodeHook = props.onVnodeBeforeMount)) {
                    invokeVNodeHook(vnodeHook, parentComponent, vnode);
                }
            }
            // scopeId
            setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        }
        if (( false) || __VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, '__vnode', {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, '__vueParentComponent', {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) {
            invokeDirectiveHook(vnode, null, parentComponent, 'beforeMount');
        }
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || (parentSuspense && !parentSuspense.pendingBranch)) &&
            transition &&
            !transition.persisted;
        if (needCallTransitionHooks) {
            transition.beforeEnter(el);
        }
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) ||
            needCallTransitionHooks ||
            dirs) {
            queuePostRenderEffect(() => {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, 'mounted');
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
        if (scopeId) {
            hostSetScopeId(el, scopeId);
        }
        if (slotScopeIds) {
            for (let i = 0; i < slotScopeIds.length; i++) {
                hostSetScopeId(el, slotScopeIds[i]);
            }
        }
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (false /* DEV_ROOT_FRAGMENT */) {}
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0) => {
        for (let i = start; i < children.length; i++) {
            const child = (children[i] = optimized
                ? cloneIfMounted(children[i])
                : normalizeVNode(children[i]));
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        const el = (n2.el = n1.el);
        let { patchFlag, dynamicChildren, dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* FULL_PROPS */;
        const oldProps = n1.props || shared_esm_bundler.EMPTY_OBJ;
        const newProps = n2.props || shared_esm_bundler.EMPTY_OBJ;
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && toggleRecurse(parentComponent, false);
        if ((vnodeHook = newProps.onVnodeBeforeUpdate)) {
            invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        }
        if (dirs) {
            invokeDirectiveHook(n2, n1, parentComponent, 'beforeUpdate');
        }
        parentComponent && toggleRecurse(parentComponent, true);
        if (false) {}
        const areChildrenSVG = isSVG && n2.type !== 'foreignObject';
        if (dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
            if (false) {}
        }
        else if (!optimized) {
            // full diff
            patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        }
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* FULL_PROPS */) {
                // element props contain dynamic keys, full diff needed
                patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            }
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* CLASS */) {
                    if (oldProps.class !== newProps.class) {
                        hostPatchProp(el, 'class', null, newProps.class, isSVG);
                    }
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* STYLE */) {
                    hostPatchProp(el, 'style', oldProps.style, newProps.style, isSVG);
                }
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PROPS */) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for (let i = 0; i < propsToUpdate.length; i++) {
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === 'value') {
                            hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                        }
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* TEXT */) {
                if (n1.children !== n2.children) {
                    hostSetElementText(el, n2.children);
                }
            }
        }
        else if (!optimized && dynamicChildren == null) {
            // unoptimized, full diff
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        }
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
            queuePostRenderEffect(() => {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
                dirs && invokeDirectiveHook(n2, n1, parentComponent, 'updated');
            }, parentSuspense);
        }
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) => {
        for (let i = 0; i < newChildren.length; i++) {
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = 
            // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el &&
                // - In the case of a Fragment, we need to provide the actual parent
                // of the Fragment itself so it can move its children.
                (oldVNode.type === Fragment ||
                    // - In the case of different nodes, there is going to be a replacement
                    // which also requires the correct parent container
                    !isSameVNodeType(oldVNode, newVNode) ||
                    // - In the case of a component, it could contain anything.
                    oldVNode.shapeFlag & (6 /* COMPONENT */ | 64 /* TELEPORT */))
                ? hostParentNode(oldVNode.el)
                : // In other cases, the parent container is not actually used so we
                    // just pass the block element here to avoid a DOM parentNode call.
                    fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
        if (oldProps !== newProps) {
            for (const key in newProps) {
                // empty string is not valid prop
                if ((0,shared_esm_bundler.isReservedProp)(key))
                    continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== 'value') {
                    hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                }
            }
            if (oldProps !== shared_esm_bundler.EMPTY_OBJ) {
                for (const key in oldProps) {
                    if (!(0,shared_esm_bundler.isReservedProp)(key) && !(key in newProps)) {
                        hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if ('value' in newProps) {
                hostPatchProp(el, 'value', oldProps.value, newProps.value);
            }
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        const fragmentStartAnchor = (n2.el = n1 ? n1.el : hostCreateText(''));
        const fragmentEndAnchor = (n2.anchor = n1 ? n1.anchor : hostCreateText(''));
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (false) {}
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) {
            slotScopeIds = slotScopeIds
                ? slotScopeIds.concat(fragmentSlotScopeIds)
                : fragmentSlotScopeIds;
        }
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        else {
            if (patchFlag > 0 &&
                patchFlag & 64 /* STABLE_FRAGMENT */ &&
                dynamicChildren &&
                // #2715 the previous fragment could've been a BAILed one as a result
                // of renderSlot() with no valid children
                n1.dynamicChildren) {
                // a stable fragment (template root or <template v-for>) doesn't need to
                // patch children order, but it may contain dynamicChildren.
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
                if (false) {}
                else if (
                // #2080 if the stable fragment has a key, it's a <template v-for> that may
                //  get moved around. Make sure all root level vnodes inherit el.
                // #2134 or if it's a component root, it may also get moved around
                // as the component is being moved.
                n2.key != null ||
                    (parentComponent && n2 === parentComponent.subTree)) {
                    traverseStaticChildren(n1, n2, true /* shallow */);
                }
            }
            else {
                // keyed / unkeyed, or manual fragments.
                // for keyed & unkeyed, since they are compiler generated from v-for,
                // each child is guaranteed to be a block so the fragment will never
                // have dynamicChildren.
                patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            }
        }
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* COMPONENT_KEPT_ALIVE */) {
                parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            }
            else {
                mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
            }
        }
        else {
            updateComponent(n1, n2, optimized);
        }
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
        const instance = (initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense));
        if (false) {}
        if ((false)) {}
        // inject renderer internals for keepAlive
        if (isKeepAlive(initialVNode)) {
            instance.ctx.renderer = internals;
        }
        // resolve props and slots for setup context
        {
            if ((false)) {}
            setupComponent(instance);
            if ((false)) {}
        }
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = (instance.subTree = createVNode(Comment));
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
        if ((false)) {}
    };
    const updateComponent = (n1, n2, optimized) => {
        const instance = (n2.component = n1.component);
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep &&
                !instance.asyncResolved) {
                // async & still pending - just update props and slots
                // since the component's reactive effect for render isn't set-up yet
                if ((false)) {}
                updateComponentPreRender(instance, n2, optimized);
                if ((false)) {}
                return;
            }
            else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        }
        else {
            // no update needed. just copy over properties
            n2.component = n1.component;
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
        const componentUpdateFn = () => {
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) {
                    (0,shared_esm_bundler.invokeArrayFns)(bm);
                }
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode &&
                    (vnodeHook = props && props.onVnodeBeforeMount)) {
                    invokeVNodeHook(vnodeHook, parent, initialVNode);
                }
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = () => {
                        if ((false)) {}
                        instance.subTree = renderComponentRoot(instance);
                        if ((false)) {}
                        if ((false)) {}
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                        if ((false)) {}
                    };
                    if (isAsyncWrapperVNode) {
                        initialVNode.type.__asyncLoader().then(
                        // note: we are moving the render call into an async callback,
                        // which means it won't track dependencies - but it's ok because
                        // a server-rendered async wrapper is already in resolved state
                        // and it will never need to change.
                        () => !instance.isUnmounted && hydrateSubTree());
                    }
                    else {
                        hydrateSubTree();
                    }
                }
                else {
                    if ((false)) {}
                    const subTree = (instance.subTree = renderComponentRoot(instance));
                    if ((false)) {}
                    if ((false)) {}
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    if ((false)) {}
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) {
                    queuePostRenderEffect(m, parentSuspense);
                }
                // onVnodeMounted
                if (!isAsyncWrapperVNode &&
                    (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
                    instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                }
                instance.isMounted = true;
                if (( false) || __VUE_PROD_DEVTOOLS__) {
                    devtoolsComponentAdded(instance);
                }
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            }
            else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next, bu, u, parent, vnode } = instance;
                let originNext = next;
                let vnodeHook;
                if ((false)) {}
                // Disallow component effect recursion during pre-lifecycle hooks.
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                }
                else {
                    next = vnode;
                }
                // beforeUpdate hook
                if (bu) {
                    (0,shared_esm_bundler.invokeArrayFns)(bu);
                }
                // onVnodeBeforeUpdate
                if ((vnodeHook = next.props && next.props.onVnodeBeforeUpdate)) {
                    invokeVNodeHook(vnodeHook, parent, next, vnode);
                }
                toggleRecurse(instance, true);
                // render
                if ((false)) {}
                const nextTree = renderComponentRoot(instance);
                if ((false)) {}
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                if ((false)) {}
                patch(prevTree, nextTree, 
                // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), 
                // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                if ((false)) {}
                next.el = nextTree.el;
                if (originNext === null) {
                    // self-triggered update. In case of HOC, update parent component
                    // vnode el. HOC is indicated by parent instance's subTree pointing
                    // to child component's vnode
                    updateHOCHostEl(instance, nextTree.el);
                }
                // updated hook
                if (u) {
                    queuePostRenderEffect(u, parentSuspense);
                }
                // onVnodeUpdated
                if ((vnodeHook = next.props && next.props.onVnodeUpdated)) {
                    queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                }
                if (( false) || __VUE_PROD_DEVTOOLS__) {
                    devtoolsComponentUpdated(instance);
                }
                if ((false)) {}
            }
        };
        // create reactive effect for rendering
        const effect = (instance.effect = new ReactiveEffect(componentUpdateFn, () => queueJob(instance.update), instance.scope // track it in component's effect scope
        ));
        const update = (instance.update = effect.run.bind(effect));
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        toggleRecurse(instance, true);
        if ((false)) {}
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized) => {
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        pauseTracking();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        flushPreFlushCbs(undefined, instance.update);
        resetTracking();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false) => {
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* KEYED_FRAGMENT */) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
            else if (patchFlag & 256 /* UNKEYED_FRAGMENT */) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* TEXT_CHILDREN */) {
            // text children fast path
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */) {
                unmountChildren(c1, parentComponent, parentSuspense);
            }
            if (c2 !== c1) {
                hostSetElementText(container, c2);
            }
        }
        else {
            if (prevShapeFlag & 16 /* ARRAY_CHILDREN */) {
                // prev children was array
                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
                    // two arrays, cannot assume anything, do full diff
                    patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
                else {
                    // no new children, just unmount old
                    unmountChildren(c1, parentComponent, parentSuspense, true);
                }
            }
            else {
                // prev children was text OR null
                // new children is array OR null
                if (prevShapeFlag & 8 /* TEXT_CHILDREN */) {
                    hostSetElementText(container, '');
                }
                // mount new if array
                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
                    mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
            }
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        c1 = c1 || shared_esm_bundler.EMPTY_ARR;
        c2 = c2 || shared_esm_bundler.EMPTY_ARR;
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for (i = 0; i < commonLength; i++) {
            const nextChild = (c2[i] = optimized
                ? cloneIfMounted(c2[i])
                : normalizeVNode(c2[i]));
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) {
            // remove old
            unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        }
        else {
            // mount new
            mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
        }
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while (i <= e1 && i <= e2) {
            const n1 = c1[i];
            const n2 = (c2[i] = optimized
                ? cloneIfMounted(c2[i])
                : normalizeVNode(c2[i]));
            if (isSameVNodeType(n1, n2)) {
                patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            }
            else {
                break;
            }
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while (i <= e1 && i <= e2) {
            const n1 = c1[e1];
            const n2 = (c2[e2] = optimized
                ? cloneIfMounted(c2[e2])
                : normalizeVNode(c2[e2]));
            if (isSameVNodeType(n1, n2)) {
                patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            }
            else {
                break;
            }
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while (i <= e2) {
                    patch(null, (c2[i] = optimized
                        ? cloneIfMounted(c2[i])
                        : normalizeVNode(c2[i])), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        }
        // 4. common sequence + unmount
        // (a b) c
        // (a b)
        // i = 2, e1 = 2, e2 = 1
        // a (b c)
        // (b c)
        // i = 0, e1 = 0, e2 = -1
        else if (i > e2) {
            while (i <= e1) {
                unmount(c1[i], parentComponent, parentSuspense, true);
                i++;
            }
        }
        // 5. unknown sequence
        // [i ... e1 + 1]: a b [c d e] f g
        // [i ... e2 + 1]: a b [e d c h] f g
        // i = 2, e1 = 4, e2 = 5
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for (i = s2; i <= e2; i++) {
                const nextChild = (c2[i] = optimized
                    ? cloneIfMounted(c2[i])
                    : normalizeVNode(c2[i]));
                if (nextChild.key != null) {
                    if (false) {}
                    keyToNewIndexMap.set(nextChild.key, i);
                }
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for (i = 0; i < toBePatched; i++)
                newIndexToOldIndexMap[i] = 0;
            for (i = s1; i <= e1; i++) {
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) {
                    newIndex = keyToNewIndexMap.get(prevChild.key);
                }
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for (j = s2; j <= e2; j++) {
                        if (newIndexToOldIndexMap[j - s2] === 0 &&
                            isSameVNodeType(prevChild, c2[j])) {
                            newIndex = j;
                            break;
                        }
                    }
                }
                if (newIndex === undefined) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                }
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) {
                        maxNewIndexSoFar = newIndex;
                    }
                    else {
                        moved = true;
                    }
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved
                ? getSequence(newIndexToOldIndexMap)
                : shared_esm_bundler.EMPTY_ARR;
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for (i = toBePatched - 1; i >= 0; i--) {
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) {
                    // mount new
                    patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) {
                        move(nextChild, container, anchor, 2 /* REORDER */);
                    }
                    else {
                        j--;
                    }
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6 /* COMPONENT */) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* SUSPENSE */) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* TELEPORT */) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for (let i = 0; i < children.length; i++) {
                move(children[i], container, anchor, moveType);
            }
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* REORDER */ &&
            shapeFlag & 1 /* ELEMENT */ &&
            transition;
        if (needTransition) {
            if (moveType === 0 /* ENTER */) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(() => transition.enter(el), parentSuspense);
            }
            else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove = () => hostInsert(el, container, anchor);
                const performLeave = () => {
                    leave(el, () => {
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) {
                    delayLeave(el, remove, performLeave);
                }
                else {
                    performLeave();
                }
            }
        }
        else {
            hostInsert(el, container, anchor);
        }
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
        // unset ref
        if (ref != null) {
            setRef(ref, null, parentSuspense, vnode, true);
        }
        if (shapeFlag & 256 /* COMPONENT_SHOULD_KEEP_ALIVE */) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ELEMENT */ && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook &&
            (vnodeHook = props && props.onVnodeBeforeUnmount)) {
            invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (shapeFlag & 6 /* COMPONENT */) {
            unmountComponent(vnode.component, parentSuspense, doRemove);
        }
        else {
            if (shapeFlag & 128 /* SUSPENSE */) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) {
                invokeDirectiveHook(vnode, null, parentComponent, 'beforeUnmount');
            }
            if (shapeFlag & 64 /* TELEPORT */) {
                vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            }
            else if (dynamicChildren &&
                // #1153: fast path should not be taken for non-stable (v-for) fragments
                (type !== Fragment ||
                    (patchFlag > 0 && patchFlag & 64 /* STABLE_FRAGMENT */))) {
                // fast path for block nodes: only need to unmount dynamic children.
                unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            }
            else if ((type === Fragment &&
                patchFlag &
                    (128 /* KEYED_FRAGMENT */ | 256 /* UNKEYED_FRAGMENT */)) ||
                (!optimized && shapeFlag & 16 /* ARRAY_CHILDREN */)) {
                unmountChildren(children, parentComponent, parentSuspense);
            }
            if (doRemove) {
                remove(vnode);
            }
        }
        if ((shouldInvokeVnodeHook &&
            (vnodeHook = props && props.onVnodeUnmounted)) ||
            shouldInvokeDirs) {
            queuePostRenderEffect(() => {
                vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
                shouldInvokeDirs &&
                    invokeDirectiveHook(vnode, null, parentComponent, 'unmounted');
            }, parentSuspense);
        }
    };
    const remove = vnode => {
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = () => {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) {
                transition.afterLeave();
            }
        };
        if (vnode.shapeFlag & 1 /* ELEMENT */ &&
            transition &&
            !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = () => leave(el, performRemove);
            if (delayLeave) {
                delayLeave(vnode.el, performRemove, performLeave);
            }
            else {
                performLeave();
            }
        }
        else {
            performRemove();
        }
    };
    const removeFragment = (cur, end) => {
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while (cur !== end) {
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove) => {
        if (false) {}
        const { bum, scope, update, subTree, um } = instance;
        // beforeUnmount hook
        if (bum) {
            (0,shared_esm_bundler.invokeArrayFns)(bum);
        }
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) {
            queuePostRenderEffect(um, parentSuspense);
        }
        queuePostRenderEffect(() => {
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense &&
            parentSuspense.pendingBranch &&
            !parentSuspense.isUnmounted &&
            instance.asyncDep &&
            !instance.asyncResolved &&
            instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) {
                parentSuspense.resolve();
            }
        }
        if (( false) || __VUE_PROD_DEVTOOLS__) {
            devtoolsComponentRemoved(instance);
        }
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
        for (let i = start; i < children.length; i++) {
            unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
        }
    };
    const getNextHostNode = vnode => {
        if (vnode.shapeFlag & 6 /* COMPONENT */) {
            return getNextHostNode(vnode.component.subTree);
        }
        if (vnode.shapeFlag & 128 /* SUSPENSE */) {
            return vnode.suspense.next();
        }
        return hostNextSibling((vnode.anchor || vnode.el));
    };
    const render = (vnode, container, isSVG) => {
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
            }
        }
        else {
            patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        }
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) {
        [hydrate, hydrateNode] = createHydrationFns(internals);
    }
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function toggleRecurse({ effect, update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0,shared_esm_bundler.isArray)(ch1) && (0,shared_esm_bundler.isArray)(ch2)) {
        for (let i = 0; i < ch1.length; i++) {
            // this is only called in the optimized path so array children are
            // guaranteed to be vnodes
            const c1 = ch1[i];
            let c2 = ch2[i];
            if (c2.shapeFlag & 1 /* ELEMENT */ && !c2.dynamicChildren) {
                if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* HYDRATE_EVENTS */) {
                    c2 = ch2[i] = cloneIfMounted(ch2[i]);
                    c2.el = c1.el;
                }
                if (!shallow)
                    traverseStaticChildren(c1, c2);
            }
            // also inherit for comment nodes, but not placeholders (e.g. v-if which
            // would have received .el during block patch)
            if (false) {}
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function getSequence(arr) {
    const p = arr.slice();
    const result = [0];
    let i, j, u, v, c;
    const len = arr.length;
    for (i = 0; i < len; i++) {
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while (u < v) {
                c = (u + v) >> 1;
                if (arr[result[c]] < arrI) {
                    u = c + 1;
                }
                else {
                    v = c;
                }
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) {
                    p[i] = result[u - 1];
                }
                result[u] = i;
            }
        }
    }
    u = result.length;
    v = result[u - 1];
    while (u-- > 0) {
        result[u] = v;
        v = p[v];
    }
    return result;
}

const isTeleport = (type) => type.__isTeleport;
const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === '');
const isTargetSVG = (target) => typeof SVGElement !== 'undefined' && target instanceof SVGElement;
const resolveTarget = (props, select) => {
    const targetSelector = props && props.to;
    if ((0,shared_esm_bundler.isString)(targetSelector)) {
        if (!select) {
            ( false) &&
                0;
            return null;
        }
        else {
            const target = select(targetSelector);
            if (!target) {
                ( false) &&
                    0;
            }
            return target;
        }
    }
    else {
        if (false) {}
        return targetSelector;
    }
};
const TeleportImpl = {
    __isTeleport: true,
    process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { shapeFlag, children, dynamicChildren } = n2;
        // #3302
        // HMR updated, force full diff
        if (false) {}
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = (n2.el = ( false)
                ? 0
                : createText(''));
            const mainAnchor = (n2.anchor = ( false)
                ? 0
                : createText(''));
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = (n2.target = resolveTarget(n2.props, querySelector));
            const targetAnchor = (n2.targetAnchor = createText(''));
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || isTargetSVG(target);
            }
            else if (false) {}
            const mount = (container, anchor) => {
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
                    mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
            }
            else if (target) {
                mount(target, targetAnchor);
            }
        }
        else {
            // update content
            n2.el = n1.el;
            const mainAnchor = (n2.anchor = n1.anchor);
            const target = (n2.target = n1.target);
            const targetAnchor = (n2.targetAnchor = n1.targetAnchor);
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                traverseStaticChildren(n1, n2, true);
            }
            else if (!optimized) {
                patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            }
            if (disabled) {
                if (!wasDisabled) {
                    // enabled -> disabled
                    // move into main container
                    moveTeleport(n2, container, mainAnchor, internals, 1 /* TOGGLE */);
                }
            }
            else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = (n2.target = resolveTarget(n2.props, querySelector));
                    if (nextTarget) {
                        moveTeleport(n2, nextTarget, null, internals, 0 /* TARGET_CHANGE */);
                    }
                    else if ((false)) {}
                }
                else if (wasDisabled) {
                    // disabled -> enabled
                    // move into teleport target
                    moveTeleport(n2, target, targetAnchor, internals, 1 /* TOGGLE */);
                }
            }
        }
    },
    remove(vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetAnchor, target, props } = vnode;
        if (target) {
            hostRemove(targetAnchor);
        }
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
                for (let i = 0; i < children.length; i++) {
                    const child = children[i];
                    unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
                }
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2 /* REORDER */) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TARGET_CHANGE */) {
        insert(vnode.targetAnchor, container, parentAnchor);
    }
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2 /* REORDER */;
    // move main view anchor if this is a re-order.
    if (isReorder) {
        insert(el, container, parentAnchor);
    }
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ARRAY_CHILDREN */) {
            for (let i = 0; i < children.length; i++) {
                move(children[i], container, parentAnchor, 2 /* REORDER */);
            }
        }
    }
    // move main view anchor if this is a re-order.
    if (isReorder) {
        insert(anchor, container, parentAnchor);
    }
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector } }, hydrateChildren) {
    const target = (vnode.target = resolveTarget(vnode.props, querySelector));
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ARRAY_CHILDREN */) {
            if (isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            }
            else {
                vnode.anchor = nextSibling(node);
                vnode.targetAnchor = hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
            target._lpa =
                vnode.targetAnchor && nextSibling(vnode.targetAnchor);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const Teleport = TeleportImpl;

const COMPONENTS = 'components';
const DIRECTIVES = 'directives';
/**
 * @private
 */
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */
function resolveDynamicComponent(component) {
    if ((0,shared_esm_bundler.isString)(component)) {
        return resolveAsset(COMPONENTS, component, false) || component;
    }
    else {
        // invalid types will fallthrough to createVNode and raise warning
        return (component || NULL_DYNAMIC_COMPONENT);
    }
}
/**
 * @private
 */
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
// implementation
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component);
            if (selfName &&
                (selfName === name ||
                    selfName === (0,shared_esm_bundler.camelize)(name) ||
                    selfName === (0,shared_esm_bundler.capitalize)((0,shared_esm_bundler.camelize)(name)))) {
                return Component;
            }
        }
        const res = 
        // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) ||
            // global registration
            resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) {
            // fallback to implicit self-reference
            return Component;
        }
        if (false) {}
        return res;
    }
    else if ((false)) {}
}
function resolve(registry, name) {
    return (registry &&
        (registry[name] ||
            registry[(0,shared_esm_bundler.camelize)(name)] ||
            registry[(0,shared_esm_bundler.capitalize)((0,shared_esm_bundler.camelize)(name))]));
}

const Fragment = Symbol(( false) ? 0 : undefined);
const Text = Symbol(( false) ? 0 : undefined);
const Comment = Symbol(( false) ? 0 : undefined);
const Static = Symbol(( false) ? 0 : undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const blockStack = [];
let currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */
function openBlock(disableTracking = false) {
    blockStack.push((currentBlock = disableTracking ? null : []));
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */
function setBlockTracking(value) {
    isBlockTreeEnabled += value;
}
function setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren =
        isBlockTreeEnabled > 0 ? currentBlock || shared_esm_bundler.EMPTY_ARR : null;
    // close block
    closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if (isBlockTreeEnabled > 0 && currentBlock) {
        currentBlock.push(vnode);
    }
    return vnode;
}
/**
 * @private
 */
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true /* isBlock */));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true /* isBlock: prevent a block from tracking itself */));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    if (false) {}
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args) => {
    return _createVNode(...(vnodeArgsTransformer
        ? vnodeArgsTransformer(args, currentRenderingInstance)
        : args));
};
const InternalObjectKey = `__vInternal`;
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for }) => {
    return (ref != null
        ? (0,shared_esm_bundler.isString)(ref) || isRef(ref) || (0,shared_esm_bundler.isFunction)(ref)
            ? { i: currentRenderingInstance, r: ref, k: ref_key, f: !!ref_for }
            : ref
        : null);
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1 /* ELEMENT */, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* SUSPENSE */) {
            type.normalize(vnode);
        }
    }
    else if (children) {
        // compiled element vnode - if children is passed, only possible types are
        // string or Array.
        vnode.shapeFlag |= (0,shared_esm_bundler.isString)(children)
            ? 8 /* TEXT_CHILDREN */
            : 16 /* ARRAY_CHILDREN */;
    }
    // validate key
    if (false) {}
    // track vnode for block tree
    if (isBlockTreeEnabled > 0 &&
        // avoid a block node from tracking itself
        !isBlockNode &&
        // has current parent block
        currentBlock &&
        // presence of a patch flag indicates this node needs patching on updates.
        // component nodes also should always be patched, because even if the
        // component doesn't need to update, it needs to persist the instance on to
        // the next vnode so that it can be properly unmounted later.
        (vnode.patchFlag > 0 || shapeFlag & 6 /* COMPONENT */) &&
        // the EVENTS flag is only for hydration and if it is the only flag, the
        // vnode should not be considered dynamic due to handler caching.
        vnode.patchFlag !== 32 /* HYDRATE_EVENTS */) {
        currentBlock.push(vnode);
    }
    return vnode;
}
const createVNode = (( false) ? 0 : _createVNode);
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
        if (false) {}
        type = Comment;
    }
    if (isVNode(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = cloneVNode(type, props, true /* mergeRef: true */);
        if (children) {
            normalizeChildren(cloned, children);
        }
        return cloned;
    }
    // class component normalization.
    if (isClassComponent(type)) {
        type = type.__vccOpts;
    }
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0,shared_esm_bundler.isString)(klass)) {
            props.class = (0,shared_esm_bundler.normalizeClass)(klass);
        }
        if ((0,shared_esm_bundler.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if (isProxy(style) && !(0,shared_esm_bundler.isArray)(style)) {
                style = (0,shared_esm_bundler.extend)({}, style);
            }
            props.style = (0,shared_esm_bundler.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0,shared_esm_bundler.isString)(type)
        ? 1 /* ELEMENT */
        : isSuspense(type)
            ? 128 /* SUSPENSE */
            : isTeleport(type)
                ? 64 /* TELEPORT */
                : (0,shared_esm_bundler.isObject)(type)
                    ? 4 /* STATEFUL_COMPONENT */
                    : (0,shared_esm_bundler.isFunction)(type)
                        ? 2 /* FUNCTIONAL_COMPONENT */
                        : 0;
    if (false) {}
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props)
        return null;
    return isProxy(props) || InternalObjectKey in props
        ? (0,shared_esm_bundler.extend)({}, props)
        : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props, ref, patchFlag, children } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref
            ? // #2078 in the case of <component :is="vnode" ref="extra"/>
                // if the vnode itself already has a ref, cloneVNode will need to merge
                // the refs so the single vnode can be set on multiple refs
                mergeRef && ref
                    ? (0,shared_esm_bundler.isArray)(ref)
                        ? ref.concat(normalizeRef(extraProps))
                        : [ref, normalizeRef(extraProps)]
                    : normalizeRef(extraProps)
            : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children:  false
            ? 0
            : children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment
            ? patchFlag === -1 // hoisted node
                ? 16 /* FULL_PROPS */
                : patchFlag | 16 /* FULL_PROPS */
            : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if (isArray(vnode.children)) {
        cloned.children = vnode.children.map(deepCloneVNode);
    }
    return cloned;
}
/**
 * @private
 */
function createTextVNode(text = ' ', flag = 0) {
    return createVNode(Text, null, text, flag);
}
/**
 * @private
 */
function createStaticVNode(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */
function createCommentVNode(text = '', 
// when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock
        ? (openBlock(), createBlock(Comment, null, text))
        : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === 'boolean') {
        // empty placeholder
        return createVNode(Comment);
    }
    else if ((0,shared_esm_bundler.isArray)(child)) {
        // fragment
        return createVNode(Fragment, null, 
        // #3666, avoid reference pollution when reusing vnode
        child.slice());
    }
    else if (typeof child === 'object') {
        // already vnode, this should be the most common since compiled templates
        // always produce all-vnode children arrays
        return cloneIfMounted(child);
    }
    else {
        // strings and numbers
        return createVNode(Text, null, String(child));
    }
}
// optimized normalization for template-compiled render fns
function cloneIfMounted(child) {
    return child.el === null || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) {
        children = null;
    }
    else if ((0,shared_esm_bundler.isArray)(children)) {
        type = 16 /* ARRAY_CHILDREN */;
    }
    else if (typeof children === 'object') {
        if (shapeFlag & (1 /* ELEMENT */ | 64 /* TELEPORT */)) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        }
        else {
            type = 32 /* SLOTS_CHILDREN */;
            const slotFlag = children._;
            if (!slotFlag && !(InternalObjectKey in children)) {
                children._ctx = currentRenderingInstance;
            }
            else if (slotFlag === 3 /* FORWARDED */ && currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if (currentRenderingInstance.slots._ === 1 /* STABLE */) {
                    children._ = 1 /* STABLE */;
                }
                else {
                    children._ = 2 /* DYNAMIC */;
                    vnode.patchFlag |= 1024 /* DYNAMIC_SLOTS */;
                }
            }
        }
    }
    else if ((0,shared_esm_bundler.isFunction)(children)) {
        children = { default: children, _ctx: currentRenderingInstance };
        type = 32 /* SLOTS_CHILDREN */;
    }
    else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* TELEPORT */) {
            type = 16 /* ARRAY_CHILDREN */;
            children = [createTextVNode(children)];
        }
        else {
            type = 8 /* TEXT_CHILDREN */;
        }
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for (let i = 0; i < args.length; i++) {
        const toMerge = args[i];
        for (const key in toMerge) {
            if (key === 'class') {
                if (ret.class !== toMerge.class) {
                    ret.class = (0,shared_esm_bundler.normalizeClass)([ret.class, toMerge.class]);
                }
            }
            else if (key === 'style') {
                ret.style = (0,shared_esm_bundler.normalizeStyle)([ret.style, toMerge.style]);
            }
            else if ((0,shared_esm_bundler.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming &&
                    existing !== incoming &&
                    !((0,shared_esm_bundler.isArray)(existing) && existing.includes(incoming))) {
                    ret[key] = existing
                        ? [].concat(existing, incoming)
                        : incoming;
                }
            }
            else if (key !== '') {
                ret[key] = toMerge[key];
            }
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7 /* VNODE_HOOK */, [
        vnode,
        prevVNode
    ]);
}

/**
 * Actual implementation
 */
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = (cache && cache[index]);
    if ((0,shared_esm_bundler.isArray)(source) || (0,shared_esm_bundler.isString)(source)) {
        ret = new Array(source.length);
        for (let i = 0, l = source.length; i < l; i++) {
            ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
        }
    }
    else if (typeof source === 'number') {
        if (false) {}
        ret = new Array(source);
        for (let i = 0; i < source; i++) {
            ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
        }
    }
    else if ((0,shared_esm_bundler.isObject)(source)) {
        if (source[Symbol.iterator]) {
            ret = Array.from(source, (item, i) => renderItem(item, i, undefined, cached && cached[i]));
        }
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for (let i = 0, l = keys.length; i < l; i++) {
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    }
    else {
        ret = [];
    }
    if (cache) {
        cache[index] = ret;
    }
    return ret;
}

/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */
function createSlots(slots, dynamicSlots) {
    for (let i = 0; i < dynamicSlots.length; i++) {
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0,shared_esm_bundler.isArray)(slot)) {
            for (let j = 0; j < slot.length; j++) {
                slots[slot[j].name] = slot[j].fn;
            }
        }
        else if (slot) {
            // conditional single slot generated by <template v-if="..." #foo>
            slots[slot.name] = slot.fn;
        }
    }
    return slots;
}

/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */
function renderSlot(slots, name, props = {}, 
// this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if (currentRenderingInstance.isCE) {
        return createVNode('slot', name === 'default' ? null : { name }, fallback && fallback());
    }
    let slot = slots[name];
    if (false) {}
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) {
        slot._d = false;
    }
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const rendered = createBlock(Fragment, { key: props.key || `_${name}` }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* STABLE */
        ? 64 /* STABLE_FRAGMENT */
        : -2 /* BAIL */);
    if (!noSlotted && rendered.scopeId) {
        rendered.slotScopeIds = [rendered.scopeId + '-s'];
    }
    if (slot && slot._c) {
        slot._d = true;
    }
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some(child => {
        if (!isVNode(child))
            return true;
        if (child.type === Comment)
            return false;
        if (child.type === Fragment &&
            !ensureValidVNode(child.children))
            return false;
        return true;
    })
        ? vnodes
        : null;
}

/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */
function toHandlers(obj) {
    const ret = {};
    if (false) {}
    for (const key in obj) {
        ret[(0,shared_esm_bundler.toHandlerKey)(key)] = obj[key];
    }
    return ret;
}

/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */
const getPublicInstance = (i) => {
    if (!i)
        return null;
    if (isStatefulComponent(i))
        return getExposeProxy(i) || i.proxy;
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = (0,shared_esm_bundler.extend)(Object.create(null), {
    $: i => i,
    $el: i => i.vnode.el,
    $data: i => i.data,
    $props: i => (( false) ? 0 : i.props),
    $attrs: i => (( false) ? 0 : i.attrs),
    $slots: i => (( false) ? 0 : i.slots),
    $refs: i => (( false) ? 0 : i.refs),
    $parent: i => getPublicInstance(i.parent),
    $root: i => getPublicInstance(i.root),
    $emit: i => i.emit,
    $options: i => (__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type),
    $forceUpdate: i => () => queueJob(i.update),
    $nextTick: i => nextTick.bind(i.proxy),
    $watch: i => (__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : shared_esm_bundler.NOOP)
});
const PublicInstanceProxyHandlers = {
    get({ _: instance }, key) {
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        // for internal formatters to know that this is a Vue instance
        if (false) {}
        // prioritize <script setup> bindings during dev.
        // this allows even properties that start with _ or $ to be used - so that
        // it aligns with the production behavior where the render fn is inlined and
        // indeed has access to all declared variables.
        if (false) {}
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== '$') {
            const n = accessCache[key];
            if (n !== undefined) {
                switch (n) {
                    case 1 /* SETUP */:
                        return setupState[key];
                    case 2 /* DATA */:
                        return data[key];
                    case 4 /* CONTEXT */:
                        return ctx[key];
                    case 3 /* PROPS */:
                        return props[key];
                    // default: just fallthrough
                }
            }
            else if (setupState !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* SETUP */;
                return setupState[key];
            }
            else if (data !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */;
                return data[key];
            }
            else if (
            // only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) &&
                (0,shared_esm_bundler.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */;
                return props[key];
            }
            else if (ctx !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */;
                return ctx[key];
            }
            else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) {
                accessCache[key] = 0 /* OTHER */;
            }
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === '$attrs') {
                track(instance, "get" /* GET */, key);
                ( false) && 0;
            }
            return publicGetter(instance);
        }
        else if (
        // css module (injected by vue-loader)
        (cssModule = type.__cssModules) &&
            (cssModule = cssModule[key])) {
            return cssModule;
        }
        else if (ctx !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* CONTEXT */;
            return ctx[key];
        }
        else if (
        // global properties
        ((globalProperties = appContext.config.globalProperties),
            (0,shared_esm_bundler.hasOwn)(globalProperties, key))) {
            {
                return globalProperties[key];
            }
        }
        else if (false) {}
    },
    set({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (setupState !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(setupState, key)) {
            setupState[key] = value;
            return true;
        }
        else if (data !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        }
        else if ((0,shared_esm_bundler.hasOwn)(instance.props, key)) {
            ( false) &&
                0;
            return false;
        }
        if (key[0] === '$' && key.slice(1) in instance) {
            ( false) &&
                0;
            return false;
        }
        else {
            if (false) {}
            else {
                ctx[key] = value;
            }
        }
        return true;
    },
    has({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
        let normalizedProps;
        return (!!accessCache[key] ||
            (data !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(data, key)) ||
            (setupState !== shared_esm_bundler.EMPTY_OBJ && (0,shared_esm_bundler.hasOwn)(setupState, key)) ||
            ((normalizedProps = propsOptions[0]) && (0,shared_esm_bundler.hasOwn)(normalizedProps, key)) ||
            (0,shared_esm_bundler.hasOwn)(ctx, key) ||
            (0,shared_esm_bundler.hasOwn)(publicPropertiesMap, key) ||
            (0,shared_esm_bundler.hasOwn)(appContext.config.globalProperties, key));
    },
    defineProperty(target, key, descriptor) {
        if (descriptor.get != null) {
            this.set(target, key, descriptor.get(), null);
        }
        else if (descriptor.value != null) {
            this.set(target, key, descriptor.value, null);
        }
        return Reflect.defineProperty(target, key, descriptor);
    }
};
if (false) {}
const RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0,shared_esm_bundler.extend)({}, PublicInstanceProxyHandlers, {
    get(target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) {
            return;
        }
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has(_, key) {
        const has = key[0] !== '_' && !(0,shared_esm_bundler.isGloballyWhitelisted)(key);
        if (false) {}
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: () => instance
    });
    // expose public properties
    Object.keys(publicPropertiesMap).forEach(key => {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: () => publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: NOOP
        });
    });
    return target;
}
// dev only
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) {
        Object.keys(propsOptions).forEach(key => {
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: () => instance.props[key],
                set: NOOP
            });
        });
    }
}
// dev only
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys(toRaw(setupState)).forEach(key => {
        if (!setupState.__isScriptSetup) {
            if (key[0] === '$' || key[0] === '_') {
                runtime_core_esm_bundler_warn(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` +
                    `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: () => setupState[key],
                set: NOOP
            });
        }
    });
}

const emptyAppContext = createAppContext();
let uid$1 = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid$1++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new EffectScope(true /* detached */),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resovled assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: shared_esm_bundler.EMPTY_OBJ,
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: shared_esm_bundler.EMPTY_OBJ,
        data: shared_esm_bundler.EMPTY_OBJ,
        props: shared_esm_bundler.EMPTY_OBJ,
        attrs: shared_esm_bundler.EMPTY_OBJ,
        slots: shared_esm_bundler.EMPTY_OBJ,
        refs: shared_esm_bundler.EMPTY_OBJ,
        setupState: shared_esm_bundler.EMPTY_OBJ,
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    if ((false)) {}
    else {
        instance.ctx = { _: instance };
    }
    instance.root = parent ? parent.root : instance;
    instance.emit = emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) {
        vnode.ce(instance);
    }
    return instance;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
const setCurrentInstance = (instance) => {
    currentInstance = instance;
    instance.scope.on();
};
const unsetCurrentInstance = () => {
    currentInstance && currentInstance.scope.off();
    currentInstance = null;
};
const isBuiltInTag = /*#__PURE__*/ (/* unused pure expression or super */ null && (makeMap('slot,component')));
function validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || NO;
    if (isBuiltInTag(name) || appIsNativeTag(name)) {
        runtime_core_esm_bundler_warn('Do not use built-in or reserved HTML elements as component id: ' + name);
    }
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* STATEFUL_COMPONENT */;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false) {
    isInSSRComponentSetup = isSSR;
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children);
    const setupResult = isStateful
        ? setupStatefulComponent(instance, isSSR)
        : undefined;
    isInSSRComponentSetup = false;
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    if ((false)) {}
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = markRaw(new Proxy(instance.ctx, PublicInstanceProxyHandlers));
    if ((false)) {}
    // 2. call setup()
    const { setup } = Component;
    if (setup) {
        const setupContext = (instance.setupContext =
            setup.length > 1 ? createSetupContext(instance) : null);
        setCurrentInstance(instance);
        pauseTracking();
        const setupResult = callWithErrorHandling(setup, instance, 0 /* SETUP_FUNCTION */, [( false) ? 0 : instance.props, setupContext]);
        resetTracking();
        unsetCurrentInstance();
        if ((0,shared_esm_bundler.isPromise)(setupResult)) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) {
                // return the promise so server-renderer can wait on it
                return setupResult
                    .then((resolvedResult) => {
                    handleSetupResult(instance, resolvedResult, isSSR);
                })
                    .catch(e => {
                    handleError(e, instance, 0 /* SETUP_FUNCTION */);
                });
            }
            else {
                // async setup returned Promise.
                // bail here and wait for re-entry.
                instance.asyncDep = setupResult;
            }
        }
        else {
            handleSetupResult(instance, setupResult, isSSR);
        }
    }
    else {
        finishComponentSetup(instance, isSSR);
    }
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0,shared_esm_bundler.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) {
            // when the function's name is `ssrRender` (compiled by SFC inline mode),
            // set it as ssrRender instead.
            instance.ssrRender = setupResult;
        }
        else {
            instance.render = setupResult;
        }
    }
    else if ((0,shared_esm_bundler.isObject)(setupResult)) {
        if (false) {}
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (( false) || __VUE_PROD_DEVTOOLS__) {
            instance.devtoolsRawSetupState = setupResult;
        }
        instance.setupState = proxyRefs(setupResult);
        if ((false)) {}
    }
    else if (false) {}
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = i => {
        if (i.render._rc) {
            i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
        }
    };
}
// dev only
const runtime_core_esm_bundler_isRuntimeOnly = () => !compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && compile && !Component.render) {
            const template = Component.template;
            if (template) {
                if ((false)) {}
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0,shared_esm_bundler.extend)((0,shared_esm_bundler.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
                if ((false)) {}
            }
        }
        instance.render = (Component.render || shared_esm_bundler.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if (installWithProxy) {
            installWithProxy(instance);
        }
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && !(false )) {
        setCurrentInstance(instance);
        pauseTracking();
        applyOptions(instance);
        resetTracking();
        unsetCurrentInstance();
    }
    // warn missing template/render
    // the runtime compilation of template in SSR is done by server-render
    if (false) {}
}
function createAttrsProxy(instance) {
    return new Proxy(instance.attrs, ( false)
        ? 0
        : {
            get(target, key) {
                track(instance, "get" /* GET */, '$attrs');
                return target[key];
            }
        });
}
function createSetupContext(instance) {
    const expose = exposed => {
        if (false) {}
        instance.exposed = exposed || {};
    };
    let attrs;
    if ((false)) {}
    else {
        return {
            get attrs() {
                return attrs || (attrs = createAttrsProxy(instance));
            },
            slots: instance.slots,
            emit: instance.emit,
            expose
        };
    }
}
function getExposeProxy(instance) {
    if (instance.exposed) {
        return (instance.exposeProxy ||
            (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
                get(target, key) {
                    if (key in target) {
                        return target[key];
                    }
                    else if (key in publicPropertiesMap) {
                        return publicPropertiesMap[key](instance);
                    }
                }
            })));
    }
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str) => str.replace(classifyRE, c => c.toUpperCase()).replace(/[-_]/g, '');
function getComponentName(Component) {
    return (0,shared_esm_bundler.isFunction)(Component)
        ? Component.displayName || Component.name
        : Component.name;
}
/* istanbul ignore next */
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) {
            name = match[1];
        }
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry) => {
            for (const key in registry) {
                if (registry[key] === Component) {
                    return key;
                }
            }
        };
        name =
            inferFromRegistry(instance.components ||
                instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0,shared_esm_bundler.isFunction)(value) && '__vccOpts' in value;
}

const runtime_core_esm_bundler_computed = ((getterOrOptions, debugOptions) => {
    // @ts-ignore
    return computed(getterOrOptions, debugOptions, isInSSRComponentSetup);
});

// dev only
const warnRuntimeUsage = (method) => runtime_core_esm_bundler_warn(`${method}() is a compiler-hint helper that is only usable inside ` +
    `<script setup> of a single file component. Its arguments should be ` +
    `compiled away and passing it at runtime has no effect.`);
// implementation
function defineProps() {
    if ((false)) {}
    return null;
}
// implementation
function defineEmits() {
    if ((false)) {}
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */
function defineExpose(exposed) {
    if ((false)) {}
}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */
function withDefaults(props, defaults) {
    if ((false)) {}
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    const i = getCurrentInstance();
    if (false) {}
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    const props = (0,shared_esm_bundler.isArray)(raw)
        ? raw.reduce((normalized, p) => ((normalized[p] = {}), normalized), {})
        : raw;
    for (const key in defaults) {
        const opt = props[key];
        if (opt) {
            if ((0,shared_esm_bundler.isArray)(opt) || (0,shared_esm_bundler.isFunction)(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if ((false)) {}
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for (const key in props) {
        if (!excludedKeys.includes(key)) {
            Object.defineProperty(ret, key, {
                enumerable: true,
                get: () => props[key]
            });
        }
    }
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    if (false) {}
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if ((0,shared_esm_bundler.isPromise)(awaitable)) {
        awaitable = awaitable.catch(e => {
            setCurrentInstance(ctx);
            throw e;
        });
    }
    return [awaitable, () => setCurrentInstance(ctx)];
}

// Actual implementation
function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0,shared_esm_bundler.isObject)(propsOrChildren) && !(0,shared_esm_bundler.isArray)(propsOrChildren)) {
            // single vnode without props
            if (isVNode(propsOrChildren)) {
                return createVNode(type, null, [propsOrChildren]);
            }
            // props without children
            return createVNode(type, propsOrChildren);
        }
        else {
            // omit props
            return createVNode(type, null, propsOrChildren);
        }
    }
    else {
        if (l > 3) {
            children = Array.prototype.slice.call(arguments, 2);
        }
        else if (l === 3 && isVNode(children)) {
            children = [children];
        }
        return createVNode(type, propsOrChildren, children);
    }
}

const ssrContextKey = Symbol(( false) ? 0 : ``);
const useSSRContext = () => {
    {
        const ctx = inject(ssrContextKey);
        if (!ctx) {
            runtime_core_esm_bundler_warn(`Server rendering context not provided. Make sure to only call ` +
                `useSSRContext() conditionally in the server build.`);
        }
        return ctx;
    }
};

function runtime_core_esm_bundler_isShallow(value) {
    return !!(value && value["__v_isShallow" /* IS_SHALLOW */]);
}

function initCustomFormatter() {
    /* eslint-disable no-restricted-globals */
    if (true) {
        return;
    }
    const vueStyle = { style: 'color:#3ba776' };
    const numberStyle = { style: 'color:#0b1bc9' };
    const stringStyle = { style: 'color:#b62e24' };
    const keywordStyle = { style: 'color:#9d288c' };
    // custom formatter for Chrome
    // https://www.mattzeunert.com/2016/02/19/custom-chrome-devtools-object-formatters.html
    const formatter = {
        header(obj) {
            // TODO also format ComponentPublicInstance & ctx.slots/attrs in setup
            if (!(0,shared_esm_bundler.isObject)(obj)) {
                return null;
            }
            if (obj.__isVue) {
                return ['div', vueStyle, `VueInstance`];
            }
            else if (isRef(obj)) {
                return [
                    'div',
                    {},
                    ['span', vueStyle, genRefFlag(obj)],
                    '<',
                    formatValue(obj.value),
                    `>`
                ];
            }
            else if (isReactive(obj)) {
                return [
                    'div',
                    {},
                    ['span', vueStyle, runtime_core_esm_bundler_isShallow(obj) ? 'ShallowReactive' : 'Reactive'],
                    '<',
                    formatValue(obj),
                    `>${isReadonly(obj) ? ` (readonly)` : ``}`
                ];
            }
            else if (isReadonly(obj)) {
                return [
                    'div',
                    {},
                    ['span', vueStyle, runtime_core_esm_bundler_isShallow(obj) ? 'ShallowReadonly' : 'Readonly'],
                    '<',
                    formatValue(obj),
                    '>'
                ];
            }
            return null;
        },
        hasBody(obj) {
            return obj && obj.__isVue;
        },
        body(obj) {
            if (obj && obj.__isVue) {
                return [
                    'div',
                    {},
                    ...formatInstance(obj.$)
                ];
            }
        }
    };
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) {
            blocks.push(createInstanceBlock('props', reactivity_esm_bundler_toRaw(instance.props)));
        }
        if (instance.setupState !== shared_esm_bundler.EMPTY_OBJ) {
            blocks.push(createInstanceBlock('setup', instance.setupState));
        }
        if (instance.data !== shared_esm_bundler.EMPTY_OBJ) {
            blocks.push(createInstanceBlock('data', reactivity_esm_bundler_toRaw(instance.data)));
        }
        const computed = extractKeys(instance, 'computed');
        if (computed) {
            blocks.push(createInstanceBlock('computed', computed));
        }
        const injected = extractKeys(instance, 'inject');
        if (injected) {
            blocks.push(createInstanceBlock('injected', injected));
        }
        blocks.push([
            'div',
            {},
            [
                'span',
                {
                    style: keywordStyle.style + ';opacity:0.66'
                },
                '$ (internal): '
            ],
            ['object', { object: instance }]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0,shared_esm_bundler.extend)({}, target);
        if (!Object.keys(target).length) {
            return ['span', {}];
        }
        return [
            'div',
            { style: 'line-height:1.25em;margin-bottom:0.6em' },
            [
                'div',
                {
                    style: 'color:#476582'
                },
                type
            ],
            [
                'div',
                {
                    style: 'padding-left:1.25em'
                },
                ...Object.keys(target).map(key => {
                    return [
                        'div',
                        {},
                        ['span', keywordStyle, key + ': '],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v, asRaw = true) {
        if (typeof v === 'number') {
            return ['span', numberStyle, v];
        }
        else if (typeof v === 'string') {
            return ['span', stringStyle, JSON.stringify(v)];
        }
        else if (typeof v === 'boolean') {
            return ['span', keywordStyle, v];
        }
        else if ((0,shared_esm_bundler.isObject)(v)) {
            return ['object', { object: asRaw ? reactivity_esm_bundler_toRaw(v) : v }];
        }
        else {
            return ['span', stringStyle, String(v)];
        }
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0,shared_esm_bundler.isFunction)(Comp)) {
            return;
        }
        const extracted = {};
        for (const key in instance.ctx) {
            if (isKeyOfType(Comp, key, type)) {
                extracted[key] = instance.ctx[key];
            }
        }
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if (((0,shared_esm_bundler.isArray)(opts) && opts.includes(key)) ||
            ((0,shared_esm_bundler.isObject)(opts) && key in opts)) {
            return true;
        }
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
            return true;
        }
        if (Comp.mixins && Comp.mixins.some(m => isKeyOfType(m, key, type))) {
            return true;
        }
    }
    function genRefFlag(v) {
        if (runtime_core_esm_bundler_isShallow(v)) {
            return `ShallowRef`;
        }
        if (v.effect) {
            return `ComputedRef`;
        }
        return `Ref`;
    }
    if (window.devtoolsFormatters) {
        window.devtoolsFormatters.push(formatter);
    }
    else {
        window.devtoolsFormatters = [formatter];
    }
}

function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) {
        return cached;
    }
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return (cache[index] = ret);
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) {
        return false;
    }
    for (let i = 0; i < prev.length; i++) {
        if (prev[i] !== memo[i]) {
            return false;
        }
    }
    // make sure to let parent block track it when returning cached
    if (isBlockTreeEnabled > 0 && currentBlock) {
        currentBlock.push(cached);
    }
    return true;
}

// Core API ------------------------------------------------------------------
const version = "3.2.31";
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode,
    normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in cjs builds.
 * @internal
 */
const ssrUtils = (_ssrUtils );
/**
 * @internal only exposed in compat builds
 */
const resolveFilter = null;
/**
 * @internal only exposed in compat builds.
 */
const compatUtils = (null);



;// CONCATENATED MODULE: ./node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js




const svgNS = 'http://www.w3.org/2000/svg';
const doc = (typeof document !== 'undefined' ? document : null);
const templateContainer = doc && doc.createElement('template');
const nodeOps = {
    insert: (child, parent, anchor) => {
        parent.insertBefore(child, anchor || null);
    },
    remove: child => {
        const parent = child.parentNode;
        if (parent) {
            parent.removeChild(child);
        }
    },
    createElement: (tag, isSVG, is, props) => {
        const el = isSVG
            ? doc.createElementNS(svgNS, tag)
            : doc.createElement(tag, is ? { is } : undefined);
        if (tag === 'select' && props && props.multiple != null) {
            el.setAttribute('multiple', props.multiple);
        }
        return el;
    },
    createText: text => doc.createTextNode(text),
    createComment: text => doc.createComment(text),
    setText: (node, text) => {
        node.nodeValue = text;
    },
    setElementText: (el, text) => {
        el.textContent = text;
    },
    parentNode: node => node.parentNode,
    nextSibling: node => node.nextSibling,
    querySelector: selector => doc.querySelector(selector),
    setScopeId(el, id) {
        el.setAttribute(id, '');
    },
    cloneNode(el) {
        const cloned = el.cloneNode(true);
        // #3072
        // - in `patchDOMProp`, we store the actual value in the `el._value` property.
        // - normally, elements using `:value` bindings will not be hoisted, but if
        //   the bound value is a constant, e.g. `:value="true"` - they do get
        //   hoisted.
        // - in production, hoisted nodes are cloned when subsequent inserts, but
        //   cloneNode() does not copy the custom property we attached.
        // - This may need to account for other custom DOM properties we attach to
        //   elements in addition to `_value` in the future.
        if (`_value` in el) {
            cloned._value = el._value;
        }
        return cloned;
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent(content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) {
            // cached
            while (true) {
                parent.insertBefore(start.cloneNode(true), anchor);
                if (start === end || !(start = start.nextSibling))
                    break;
            }
        }
        else {
            // fresh insert
            templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while (wrapper.firstChild) {
                    template.appendChild(wrapper.firstChild);
                }
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};

// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) {
        value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(' ');
    }
    if (value == null) {
        el.removeAttribute('class');
    }
    else if (isSVG) {
        el.setAttribute('class', value);
    }
    else {
        el.className = value;
    }
}

function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0,shared_esm_bundler.isString)(next);
    if (next && !isCssString) {
        for (const key in next) {
            setStyle(style, key, next[key]);
        }
        if (prev && !(0,shared_esm_bundler.isString)(prev)) {
            for (const key in prev) {
                if (next[key] == null) {
                    setStyle(style, key, '');
                }
            }
        }
    }
    else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) {
                style.cssText = next;
            }
        }
        else if (prev) {
            el.removeAttribute('style');
        }
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ('_vod' in el) {
            style.display = currentDisplay;
        }
    }
}
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0,shared_esm_bundler.isArray)(val)) {
        val.forEach(v => setStyle(style, name, v));
    }
    else {
        if (name.startsWith('--')) {
            // custom property definition
            style.setProperty(name, val);
        }
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) {
                // !important
                style.setProperty((0,shared_esm_bundler.hyphenate)(prefixed), val.replace(importantRE, ''), 'important');
            }
            else {
                style[prefixed] = val;
            }
        }
    }
}
const prefixes = ['Webkit', 'Moz', 'ms'];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) {
        return cached;
    }
    let name = (0,shared_esm_bundler.camelize)(rawName);
    if (name !== 'filter' && name in style) {
        return (prefixCache[rawName] = name);
    }
    name = (0,shared_esm_bundler.capitalize)(name);
    for (let i = 0; i < prefixes.length; i++) {
        const prefixed = prefixes[i] + name;
        if (prefixed in style) {
            return (prefixCache[rawName] = prefixed);
        }
    }
    return rawName;
}

const xlinkNS = 'http://www.w3.org/1999/xlink';
function patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith('xlink:')) {
        if (value == null) {
            el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0,shared_esm_bundler.isSpecialBooleanAttr)(key);
        if (value == null || (isBoolean && !(0,shared_esm_bundler.includeBooleanAttr)(value))) {
            el.removeAttribute(key);
        }
        else {
            el.setAttribute(key, isBoolean ? '' : value);
        }
    }
}

// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function patchDOMProp(el, key, value, 
// the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === 'innerHTML' || key === 'textContent') {
        if (prevChildren) {
            unmountChildren(prevChildren, parentComponent, parentSuspense);
        }
        el[key] = value == null ? '' : value;
        return;
    }
    if (key === 'value' &&
        el.tagName !== 'PROGRESS' &&
        // custom elements may use _value internally
        !el.tagName.includes('-')) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? '' : value;
        if (el.value !== newValue ||
            // #4956: always set for OPTION elements because its value falls back to
            // textContent if no value attribute is present. And setting .value for
            // OPTION has no side effect
            el.tagName === 'OPTION') {
            el.value = newValue;
        }
        if (value == null) {
            el.removeAttribute(key);
        }
        return;
    }
    if (value === '' || value == null) {
        const type = typeof el[key];
        if (type === 'boolean') {
            // e.g. <select multiple> compiles to { multiple: '' }
            el[key] = (0,shared_esm_bundler.includeBooleanAttr)(value);
            return;
        }
        else if (value == null && type === 'string') {
            // e.g. <div :id="null">
            el[key] = '';
            el.removeAttribute(key);
            return;
        }
        else if (type === 'number') {
            // e.g. <img :width="null">
            // the value of some IDL attr must be greater than 0, e.g. input.size = 0 -> error
            try {
                el[key] = 0;
            }
            catch (_a) { }
            el.removeAttribute(key);
            return;
        }
    }
    // some properties perform value validation and throw
    try {
        el[key] = value;
    }
    catch (e) {
        if ((false)) {}
    }
}

// Async edge case fix requires storing an event listener's attach timestamp.
let _getNow = Date.now;
let skipTimestampCheck = false;
if (typeof window !== 'undefined') {
    // Determine what event timestamp the browser is using. Annoyingly, the
    // timestamp can either be hi-res (relative to page load) or low-res
    // (relative to UNIX epoch), so in order to compare time we have to use the
    // same timestamp type when saving the flush timestamp.
    if (_getNow() > document.createEvent('Event').timeStamp) {
        // if the low-res timestamp which is bigger than the event timestamp
        // (which is evaluated AFTER) it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listeners as well.
        _getNow = () => performance.now();
    }
    // #3485: Firefox <= 53 has incorrect Event.timeStamp implementation
    // and does not fire microtasks in between event propagation, so safe to exclude.
    const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
    skipTimestampCheck = !!(ffMatch && Number(ffMatch[1]) <= 53);
}
// To avoid the overhead of repeatedly calling performance.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let cachedNow = 0;
const p = Promise.resolve();
const runtime_dom_esm_bundler_reset = () => {
    cachedNow = 0;
};
const getNow = () => cachedNow || (p.then(runtime_dom_esm_bundler_reset), (cachedNow = _getNow()));
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
        // patch
        existingInvoker.value = nextValue;
    }
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            // add
            const invoker = (invokers[rawName] = createInvoker(nextValue, instance));
            addEventListener(el, name, invoker, options);
        }
        else if (existingInvoker) {
            // remove
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while ((m = name.match(optionsModifierRE))) {
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    return [(0,shared_esm_bundler.hyphenate)(name.slice(2)), options];
}
function createInvoker(initialValue, instance) {
    const invoker = (e) => {
        // async edge case #6566: inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // the solution is simple: we save the timestamp when a handler is attached,
        // and the handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        const timeStamp = e.timeStamp || _getNow();
        if (skipTimestampCheck || timeStamp >= invoker.attached - 1) {
            callWithAsyncErrorHandling(patchStopImmediatePropagation(e, invoker.value), instance, 5 /* NATIVE_EVENT_HANDLER */, [e]);
        }
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function patchStopImmediatePropagation(e, value) {
    if ((0,shared_esm_bundler.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = () => {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(fn => (e) => !e._stopped && fn && fn(e));
    }
    else {
        return value;
    }
}

const nativeOnRE = /^on[a-z]/;
const patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
    if (key === 'class') {
        patchClass(el, nextValue, isSVG);
    }
    else if (key === 'style') {
        patchStyle(el, prevValue, nextValue);
    }
    else if ((0,shared_esm_bundler.isOn)(key)) {
        // ignore v-model listeners
        if (!(0,shared_esm_bundler.isModelListener)(key)) {
            patchEvent(el, key, prevValue, nextValue, parentComponent);
        }
    }
    else if (key[0] === '.'
        ? ((key = key.slice(1)), true)
        : key[0] === '^'
            ? ((key = key.slice(1)), false)
            : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    }
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === 'true-value') {
            el._trueValue = nextValue;
        }
        else if (key === 'false-value') {
            el._falseValue = nextValue;
        }
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === 'innerHTML' || key === 'textContent') {
            return true;
        }
        // or native onclick with function values
        if (key in el && nativeOnRE.test(key) && (0,shared_esm_bundler.isFunction)(value)) {
            return true;
        }
        return false;
    }
    // spellcheck and draggable are numerated attrs, however their
    // corresponding DOM properties are actually booleans - this leads to
    // setting it with a string "false" value leading it to be coerced to
    // `true`, so we need to always treat them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === 'spellcheck' || key === 'draggable') {
        return false;
    }
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === 'form') {
        return false;
    }
    // #1526 <input list> must be set as attribute
    if (key === 'list' && el.tagName === 'INPUT') {
        return false;
    }
    // #2766 <textarea type> must be set as attribute
    if (key === 'type' && el.tagName === 'TEXTAREA') {
        return false;
    }
    // native onclick with string value, must be set as attribute
    if (nativeOnRE.test(key) && (0,shared_esm_bundler.isString)(value)) {
        return false;
    }
    return key in el;
}

function defineCustomElement(options, hydate) {
    const Comp = defineComponent(options);
    class VueCustomElement extends VueElement {
        constructor(initialProps) {
            super(Comp, initialProps, hydate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const defineSSRCustomElement = ((options) => {
    // @ts-ignore
    return defineCustomElement(options, hydrate);
});
const BaseClass = (typeof HTMLElement !== 'undefined' ? HTMLElement : class {
});
class VueElement extends BaseClass {
    constructor(_def, _props = {}, hydrate) {
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */
        this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) {
            hydrate(this._createVNode(), this.shadowRoot);
        }
        else {
            if (false) {}
            this.attachShadow({ mode: 'open' });
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        nextTick(() => {
            if (!this._connected) {
                render(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */
    _resolveDef() {
        if (this._resolved) {
            return;
        }
        this._resolved = true;
        // set initial attrs
        for (let i = 0; i < this.attributes.length; i++) {
            this._setAttr(this.attributes[i].name);
        }
        // watch future attr changes
        new MutationObserver(mutations => {
            for (const m of mutations) {
                this._setAttr(m.attributeName);
            }
        }).observe(this, { attributes: true });
        const resolve = (def) => {
            const { props, styles } = def;
            const hasOptions = !(0,shared_esm_bundler.isArray)(props);
            const rawKeys = props ? (hasOptions ? Object.keys(props) : props) : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) {
                for (const key in this._props) {
                    const opt = props[key];
                    if (opt === Number || (opt && opt.type === Number)) {
                        this._props[key] = (0,shared_esm_bundler.toNumber)(this._props[key]);
                        (numberProps || (numberProps = Object.create(null)))[key] = true;
                    }
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this)) {
                if (key[0] !== '_') {
                    this._setProp(key, this[key], true, false);
                }
            }
            // defining getter/setters on prototype
            for (const key of rawKeys.map(shared_esm_bundler.camelize)) {
                Object.defineProperty(this, key, {
                    get() {
                        return this._getProp(key);
                    },
                    set(val) {
                        this._setProp(key, val);
                    }
                });
            }
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            asyncDef().then(resolve);
        }
        else {
            resolve(this._def);
        }
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) {
            value = (0,shared_esm_bundler.toNumber)(value);
        }
        this._setProp((0,shared_esm_bundler.camelize)(key), value, false);
    }
    /**
     * @internal
     */
    _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */
    _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) {
                this._update();
            }
            // reflect
            if (shouldReflect) {
                if (val === true) {
                    this.setAttribute((0,shared_esm_bundler.hyphenate)(key), '');
                }
                else if (typeof val === 'string' || typeof val === 'number') {
                    this.setAttribute((0,shared_esm_bundler.hyphenate)(key), val + '');
                }
                else if (!val) {
                    this.removeAttribute((0,shared_esm_bundler.hyphenate)(key));
                }
            }
        }
    }
    _update() {
        render(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = createVNode(this._def, (0,shared_esm_bundler.extend)({}, this._props));
        if (!this._instance) {
            vnode.ce = instance => {
                this._instance = instance;
                instance.isCE = true;
                // HMR
                if ((false)) {}
                // intercept emit
                instance.emit = (event, ...args) => {
                    this.dispatchEvent(new CustomEvent(event, {
                        detail: args
                    }));
                };
                // locate nearest Vue custom element parent for provide/inject
                let parent = this;
                while ((parent =
                    parent && (parent.parentNode || parent.host))) {
                    if (parent instanceof VueElement) {
                        instance.parent = parent._instance;
                        break;
                    }
                }
            };
        }
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) {
            styles.forEach(css => {
                const s = document.createElement('style');
                s.textContent = css;
                this.shadowRoot.appendChild(s);
                // record for HMR
                if ((false)) {}
            });
        }
    }
}

function useCssModule(name = '$style') {
    /* istanbul ignore else */
    {
        const instance = getCurrentInstance();
        if (!instance) {
            ( false) && 0;
            return shared_esm_bundler.EMPTY_OBJ;
        }
        const modules = instance.type.__cssModules;
        if (!modules) {
            ( false) && 0;
            return shared_esm_bundler.EMPTY_OBJ;
        }
        const mod = modules[name];
        if (!mod) {
            ( false) &&
                0;
            return shared_esm_bundler.EMPTY_OBJ;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    const instance = getCurrentInstance();
    /* istanbul ignore next */
    if (!instance) {
        ( false) &&
            0;
        return;
    }
    const setVars = () => setVarsOnVNode(instance.subTree, getter(instance.proxy));
    watchPostEffect(setVars);
    onMounted(() => {
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, { childList: true });
        onUnmounted(() => ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* SUSPENSE */) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) {
            suspense.effects.push(() => {
                setVarsOnVNode(suspense.activeBranch, vars);
            });
        }
    }
    // drill down HOCs until it's a non-component vnode
    while (vnode.component) {
        vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 /* ELEMENT */ && vnode.el) {
        setVarsOnNode(vnode.el, vars);
    }
    else if (vnode.type === Fragment) {
        vnode.children.forEach(c => setVarsOnVNode(c, vars));
    }
    else if (vnode.type === Static) {
        let { el, anchor } = vnode;
        while (el) {
            setVarsOnNode(el, vars);
            if (el === anchor)
                break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for (const key in vars) {
            style.setProperty(`--${key}`, vars[key]);
        }
    }
}

const TRANSITION = 'transition';
const ANIMATION = 'animation';
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const Transition = (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots);
Transition.displayName = 'Transition';
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = (Transition.props =
    /*#__PURE__*/ (0,shared_esm_bundler.extend)({}, BaseTransition.props, DOMTransitionPropsValidators));
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */
const runtime_dom_esm_bundler_callHook = (hook, args = []) => {
    if ((0,shared_esm_bundler.isArray)(hook)) {
        hook.forEach(h => h(...args));
    }
    else if (hook) {
        hook(...args);
    }
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */
const hasExplicitCallback = (hook) => {
    return hook
        ? (0,shared_esm_bundler.isArray)(hook)
            ? hook.some(h => h.length > 1)
            : hook.length > 1
        : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for (const key in rawProps) {
        if (!(key in DOMTransitionPropsValidators)) {
            baseProps[key] = rawProps[key];
        }
    }
    if (rawProps.css === false) {
        return baseProps;
    }
    const { name = 'v', type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done) => {
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done) => {
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear) => {
        return (el, done) => {
            const hook = isAppear ? onAppear : onEnter;
            const resolve = () => finishEnter(el, isAppear, done);
            runtime_dom_esm_bundler_callHook(hook, [el, resolve]);
            nextFrame(() => {
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) {
                    whenTransitionEnds(el, type, enterDuration, resolve);
                }
            });
        };
    };
    return (0,shared_esm_bundler.extend)(baseProps, {
        onBeforeEnter(el) {
            runtime_dom_esm_bundler_callHook(onBeforeEnter, [el]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear(el) {
            runtime_dom_esm_bundler_callHook(onBeforeAppear, [el]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave(el, done) {
            const resolve = () => finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            forceReflow();
            addTransitionClass(el, leaveActiveClass);
            nextFrame(() => {
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) {
                    whenTransitionEnds(el, type, leaveDuration, resolve);
                }
            });
            runtime_dom_esm_bundler_callHook(onLeave, [el, resolve]);
        },
        onEnterCancelled(el) {
            finishEnter(el, false);
            runtime_dom_esm_bundler_callHook(onEnterCancelled, [el]);
        },
        onAppearCancelled(el) {
            finishEnter(el, true);
            runtime_dom_esm_bundler_callHook(onAppearCancelled, [el]);
        },
        onLeaveCancelled(el) {
            finishLeave(el);
            runtime_dom_esm_bundler_callHook(onLeaveCancelled, [el]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) {
        return null;
    }
    else if ((0,shared_esm_bundler.isObject)(duration)) {
        return [NumberOf(duration.enter), NumberOf(duration.leave)];
    }
    else {
        const n = NumberOf(duration);
        return [n, n];
    }
}
function NumberOf(val) {
    const res = (0,shared_esm_bundler.toNumber)(val);
    if ((false))
        {}
    return res;
}
function validateDuration(val) {
    if (typeof val !== 'number') {
        warn(`<transition> explicit duration is not a valid number - ` +
            `got ${JSON.stringify(val)}.`);
    }
    else if (isNaN(val)) {
        warn(`<transition> explicit duration is NaN - ` +
            'the duration expression might be incorrect.');
    }
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(c => c && el.classList.add(c));
    (el._vtc ||
        (el._vtc = new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(c => c && el.classList.remove(c));
    const { _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) {
            el._vtc = undefined;
        }
    }
}
function nextFrame(cb) {
    requestAnimationFrame(() => {
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = (el._endId = ++endId);
    const resolveIfNotStale = () => {
        if (id === el._endId) {
            resolve();
        }
    };
    if (explicitTimeout) {
        return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) {
        return resolve();
    }
    const endEvent = type + 'end';
    let ended = 0;
    const end = () => {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e) => {
        if (e.target === el && ++ended >= propCount) {
            end();
        }
    };
    setTimeout(() => {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key) => (styles[key] || '').split(', ');
    const transitionDelays = getStyleProperties(TRANSITION + 'Delay');
    const transitionDurations = getStyleProperties(TRANSITION + 'Duration');
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(ANIMATION + 'Delay');
    const animationDurations = getStyleProperties(ANIMATION + 'Duration');
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    const hasTransform = type === TRANSITION &&
        /\b(transform|all)(,|$)/.test(styles[TRANSITION + 'Property']);
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}
// synchronously force layout to put elements into a certain state
function forceReflow() {
    return document.body.offsetHeight;
}

const positionMap = new WeakMap();
const newPositionMap = new WeakMap();
const TransitionGroupImpl = {
    name: 'TransitionGroup',
    props: /*#__PURE__*/ (0,shared_esm_bundler.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup(props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        let prevChildren;
        let children;
        onUpdated(() => {
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) {
                return;
            }
            const moveClass = props.moveClass || `${props.name || 'v'}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                return;
            }
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            // force reflow to put everything in position
            forceReflow();
            movedChildren.forEach(c => {
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = '';
                const cb = (el._moveCb = (e) => {
                    if (e && e.target !== el) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener('transitionend', cb);
                        el._moveCb = null;
                        removeTransitionClass(el, moveClass);
                    }
                });
                el.addEventListener('transitionend', cb);
            });
        });
        return () => {
            const rawProps = reactivity_esm_bundler_toRaw(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || Fragment;
            prevChildren = children;
            children = slots.default ? getTransitionRawChildren(slots.default()) : [];
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (child.key != null) {
                    setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
                }
                else if ((false)) {}
            }
            if (prevChildren) {
                for (let i = 0; i < prevChildren.length; i++) {
                    const child = prevChildren[i];
                    setTransitionHooks(child, resolveTransitionHooks(child, cssTransitionProps, state, instance));
                    positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            return createVNode(tag, null, children);
        };
    }
};
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) {
        el._moveCb();
    }
    if (el._enterCb) {
        el._enterCb();
    }
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = '0s';
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) {
        el._vtc.forEach(cls => {
            cls.split(/\s+/).forEach(c => c && clone.classList.remove(c));
        });
    }
    moveClass.split(/\s+/).forEach(c => c && clone.classList.add(c));
    clone.style.display = 'none';
    const container = (root.nodeType === 1 ? root : root.parentNode);
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}

const getModelAssigner = (vnode) => {
    const fn = vnode.props['onUpdate:modelValue'];
    return (0,shared_esm_bundler.isArray)(fn) ? value => (0,shared_esm_bundler.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        runtime_dom_esm_bundler_trigger(target, 'input');
    }
}
function runtime_dom_esm_bundler_trigger(el, type) {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const vModelText = {
    created(el, { modifiers: { lazy, trim, number } }, vnode) {
        el._assign = getModelAssigner(vnode);
        const castToNumber = number || (vnode.props && vnode.props.type === 'number');
        addEventListener(el, lazy ? 'change' : 'input', e => {
            if (e.target.composing)
                return;
            let domValue = el.value;
            if (trim) {
                domValue = domValue.trim();
            }
            else if (castToNumber) {
                domValue = (0,shared_esm_bundler.toNumber)(domValue);
            }
            el._assign(domValue);
        });
        if (trim) {
            addEventListener(el, 'change', () => {
                el.value = el.value.trim();
            });
        }
        if (!lazy) {
            addEventListener(el, 'compositionstart', onCompositionStart);
            addEventListener(el, 'compositionend', onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            addEventListener(el, 'change', onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted(el, { value }) {
        el.value = value == null ? '' : value;
    },
    beforeUpdate(el, { value, modifiers: { lazy, trim, number } }, vnode) {
        el._assign = getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing)
            return;
        if (document.activeElement === el) {
            if (lazy) {
                return;
            }
            if (trim && el.value.trim() === value) {
                return;
            }
            if ((number || el.type === 'number') && (0,shared_esm_bundler.toNumber)(el.value) === value) {
                return;
            }
        }
        const newValue = value == null ? '' : value;
        if (el.value !== newValue) {
            el.value = newValue;
        }
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created(el, _, vnode) {
        el._assign = getModelAssigner(vnode);
        addEventListener(el, 'change', () => {
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0,shared_esm_bundler.isArray)(modelValue)) {
                const index = (0,shared_esm_bundler.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) {
                    assign(modelValue.concat(elementValue));
                }
                else if (!checked && found) {
                    const filtered = [...modelValue];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            }
            else if ((0,shared_esm_bundler.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) {
                    cloned.add(elementValue);
                }
                else {
                    cloned.delete(elementValue);
                }
                assign(cloned);
            }
            else {
                assign(getCheckboxValue(el, checked));
            }
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate(el, binding, vnode) {
        el._assign = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    if ((0,shared_esm_bundler.isArray)(value)) {
        el.checked = (0,shared_esm_bundler.looseIndexOf)(value, vnode.props.value) > -1;
    }
    else if ((0,shared_esm_bundler.isSet)(value)) {
        el.checked = value.has(vnode.props.value);
    }
    else if (value !== oldValue) {
        el.checked = (0,shared_esm_bundler.looseEqual)(value, getCheckboxValue(el, true));
    }
}
const vModelRadio = {
    created(el, { value }, vnode) {
        el.checked = (0,shared_esm_bundler.looseEqual)(value, vnode.props.value);
        el._assign = getModelAssigner(vnode);
        addEventListener(el, 'change', () => {
            el._assign(getValue(el));
        });
    },
    beforeUpdate(el, { value, oldValue }, vnode) {
        el._assign = getModelAssigner(vnode);
        if (value !== oldValue) {
            el.checked = (0,shared_esm_bundler.looseEqual)(value, vnode.props.value);
        }
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created(el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0,shared_esm_bundler.isSet)(value);
        addEventListener(el, 'change', () => {
            const selectedVal = Array.prototype.filter
                .call(el.options, (o) => o.selected)
                .map((o) => number ? (0,shared_esm_bundler.toNumber)(getValue(o)) : getValue(o));
            el._assign(el.multiple
                ? isSetModel
                    ? new Set(selectedVal)
                    : selectedVal
                : selectedVal[0]);
        });
        el._assign = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted(el, { value }) {
        setSelected(el, value);
    },
    beforeUpdate(el, _binding, vnode) {
        el._assign = getModelAssigner(vnode);
    },
    updated(el, { value }) {
        setSelected(el, value);
    }
};
function setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0,shared_esm_bundler.isArray)(value) && !(0,shared_esm_bundler.isSet)(value)) {
        ( false) &&
            0;
        return;
    }
    for (let i = 0, l = el.options.length; i < l; i++) {
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if ((0,shared_esm_bundler.isArray)(value)) {
                option.selected = (0,shared_esm_bundler.looseIndexOf)(value, optionValue) > -1;
            }
            else {
                option.selected = value.has(optionValue);
            }
        }
        else {
            if ((0,shared_esm_bundler.looseEqual)(getValue(option), value)) {
                if (el.selectedIndex !== i)
                    el.selectedIndex = i;
                return;
            }
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) {
        el.selectedIndex = -1;
    }
}
// retrieve raw value set via :value bindings
function getValue(el) {
    return '_value' in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function getCheckboxValue(el, checked) {
    const key = checked ? '_trueValue' : '_falseValue';
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created(el, binding, vnode) {
        callModelHook(el, binding, vnode, null, 'created');
    },
    mounted(el, binding, vnode) {
        callModelHook(el, binding, vnode, null, 'mounted');
    },
    beforeUpdate(el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, 'beforeUpdate');
    },
    updated(el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, 'updated');
    }
};
function callModelHook(el, binding, vnode, prevVNode, hook) {
    let modelToUse;
    switch (el.tagName) {
        case 'SELECT':
            modelToUse = vModelSelect;
            break;
        case 'TEXTAREA':
            modelToUse = vModelText;
            break;
        default:
            switch (vnode.props && vnode.props.type) {
                case 'checkbox':
                    modelToUse = vModelCheckbox;
                    break;
                case 'radio':
                    modelToUse = vModelRadio;
                    break;
                default:
                    modelToUse = vModelText;
            }
    }
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value }) => ({ value });
    vModelRadio.getSSRProps = ({ value }, vnode) => {
        if (vnode.props && (0,shared_esm_bundler.looseEqual)(vnode.props.value, value)) {
            return { checked: true };
        }
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode) => {
        if ((0,shared_esm_bundler.isArray)(value)) {
            if (vnode.props && (0,shared_esm_bundler.looseIndexOf)(value, vnode.props.value) > -1) {
                return { checked: true };
            }
        }
        else if ((0,shared_esm_bundler.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) {
                return { checked: true };
            }
        }
        else if (value) {
            return { checked: true };
        }
    };
}

const systemModifiers = ['ctrl', 'shift', 'alt', 'meta'];
const modifierGuards = {
    stop: e => e.stopPropagation(),
    prevent: e => e.preventDefault(),
    self: e => e.target !== e.currentTarget,
    ctrl: e => !e.ctrlKey,
    shift: e => !e.shiftKey,
    alt: e => !e.altKey,
    meta: e => !e.metaKey,
    left: e => 'button' in e && e.button !== 0,
    middle: e => 'button' in e && e.button !== 1,
    right: e => 'button' in e && e.button !== 2,
    exact: (e, modifiers) => systemModifiers.some(m => e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */
const withModifiers = (fn, modifiers) => {
    return (event, ...args) => {
        for (let i = 0; i < modifiers.length; i++) {
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers))
                return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const keyNames = {
    esc: 'escape',
    space: ' ',
    up: 'arrow-up',
    left: 'arrow-left',
    right: 'arrow-right',
    down: 'arrow-down',
    delete: 'backspace'
};
/**
 * @private
 */
const withKeys = (fn, modifiers) => {
    return (event) => {
        if (!('key' in event)) {
            return;
        }
        const eventKey = (0,shared_esm_bundler.hyphenate)(event.key);
        if (modifiers.some(k => k === eventKey || keyNames[k] === eventKey)) {
            return fn(event);
        }
    };
};

const vShow = {
    beforeMount(el, { value }, { transition }) {
        el._vod = el.style.display === 'none' ? '' : el.style.display;
        if (transition && value) {
            transition.beforeEnter(el);
        }
        else {
            setDisplay(el, value);
        }
    },
    mounted(el, { value }, { transition }) {
        if (transition && value) {
            transition.enter(el);
        }
    },
    updated(el, { value, oldValue }, { transition }) {
        if (!value === !oldValue)
            return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            }
            else {
                transition.leave(el, () => {
                    setDisplay(el, false);
                });
            }
        }
        else {
            setDisplay(el, value);
        }
    },
    beforeUnmount(el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el._vod : 'none';
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function initVShowForSSR() {
    vShow.getSSRProps = ({ value }) => {
        if (!value) {
            return { style: { display: 'none' } };
        }
    };
}

const rendererOptions = (0,shared_esm_bundler.extend)({ patchProp }, nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return (renderer ||
        (renderer = createRenderer(rendererOptions)));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration
        ? renderer
        : createHydrationRenderer(rendererOptions);
    enabledHydration = true;
    return renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const render = ((...args) => {
    ensureRenderer().render(...args);
});
const hydrate = ((...args) => {
    ensureHydrationRenderer().hydrate(...args);
});
const createApp = ((...args) => {
    const app = ensureRenderer().createApp(...args);
    if ((false)) {}
    const { mount } = app;
    app.mount = (containerOrSelector) => {
        const container = normalizeContainer(containerOrSelector);
        if (!container)
            return;
        const component = app._component;
        if (!(0,shared_esm_bundler.isFunction)(component) && !component.render && !component.template) {
            // __UNSAFE__
            // Reason: potential execution of JS expressions in in-DOM template.
            // The user must make sure the in-DOM template is trusted. If it's
            // rendered by the server, the template should not contain any user data.
            component.template = container.innerHTML;
        }
        // clear content before mounting
        container.innerHTML = '';
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute('v-cloak');
            container.setAttribute('data-v-app', '');
        }
        return proxy;
    };
    return app;
});
const createSSRApp = ((...args) => {
    const app = ensureHydrationRenderer().createApp(...args);
    if ((false)) {}
    const { mount } = app;
    app.mount = (containerOrSelector) => {
        const container = normalizeContainer(containerOrSelector);
        if (container) {
            return mount(container, true, container instanceof SVGElement);
        }
    };
    return app;
});
function injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, 'isNativeTag', {
        value: (tag) => isHTMLTag(tag) || isSVGTag(tag),
        writable: false
    });
}
// dev only
function injectCompilerOptionsCheck(app) {
    if (isRuntimeOnly()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, 'isCustomElement', {
            get() {
                return isCustomElement;
            },
            set() {
                warn(`The \`isCustomElement\` config option is deprecated. Use ` +
                    `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` +
            `a build of Vue.js that includes the runtime compiler (aka "full build"). ` +
            `Since you are using the runtime-only build, \`compilerOptions\` ` +
            `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` +
            `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` +
            `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` +
            `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, 'compilerOptions', {
            get() {
                warn(msg);
                return compilerOptions;
            },
            set() {
                warn(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0,shared_esm_bundler.isString)(container)) {
        const res = document.querySelector(container);
        if (false) {}
        return res;
    }
    if (false) {}
    return container;
}
let ssrDirectiveInitialized = false;
/**
 * @internal
 */
const initDirectivesForSSR = () => {
        if (!ssrDirectiveInitialized) {
            ssrDirectiveInitialized = true;
            initVModelForSSR();
            initVShowForSSR();
        }
    }
    ;




/***/ }),

/***/ 577:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EMPTY_ARR": () => (/* binding */ EMPTY_ARR),
/* harmony export */   "EMPTY_OBJ": () => (/* binding */ EMPTY_OBJ),
/* harmony export */   "NO": () => (/* binding */ NO),
/* harmony export */   "NOOP": () => (/* binding */ NOOP),
/* harmony export */   "PatchFlagNames": () => (/* binding */ PatchFlagNames),
/* harmony export */   "camelize": () => (/* binding */ camelize),
/* harmony export */   "capitalize": () => (/* binding */ capitalize),
/* harmony export */   "def": () => (/* binding */ def),
/* harmony export */   "escapeHtml": () => (/* binding */ escapeHtml),
/* harmony export */   "escapeHtmlComment": () => (/* binding */ escapeHtmlComment),
/* harmony export */   "extend": () => (/* binding */ extend),
/* harmony export */   "generateCodeFrame": () => (/* binding */ generateCodeFrame),
/* harmony export */   "getGlobalThis": () => (/* binding */ getGlobalThis),
/* harmony export */   "hasChanged": () => (/* binding */ hasChanged),
/* harmony export */   "hasOwn": () => (/* binding */ hasOwn),
/* harmony export */   "hyphenate": () => (/* binding */ hyphenate),
/* harmony export */   "includeBooleanAttr": () => (/* binding */ includeBooleanAttr),
/* harmony export */   "invokeArrayFns": () => (/* binding */ invokeArrayFns),
/* harmony export */   "isArray": () => (/* binding */ isArray),
/* harmony export */   "isBooleanAttr": () => (/* binding */ isBooleanAttr),
/* harmony export */   "isBuiltInDirective": () => (/* binding */ isBuiltInDirective),
/* harmony export */   "isDate": () => (/* binding */ isDate),
/* harmony export */   "isFunction": () => (/* binding */ isFunction),
/* harmony export */   "isGloballyWhitelisted": () => (/* binding */ isGloballyWhitelisted),
/* harmony export */   "isHTMLTag": () => (/* binding */ isHTMLTag),
/* harmony export */   "isIntegerKey": () => (/* binding */ isIntegerKey),
/* harmony export */   "isKnownHtmlAttr": () => (/* binding */ isKnownHtmlAttr),
/* harmony export */   "isKnownSvgAttr": () => (/* binding */ isKnownSvgAttr),
/* harmony export */   "isMap": () => (/* binding */ isMap),
/* harmony export */   "isModelListener": () => (/* binding */ isModelListener),
/* harmony export */   "isNoUnitNumericStyleProp": () => (/* binding */ isNoUnitNumericStyleProp),
/* harmony export */   "isObject": () => (/* binding */ isObject),
/* harmony export */   "isOn": () => (/* binding */ isOn),
/* harmony export */   "isPlainObject": () => (/* binding */ isPlainObject),
/* harmony export */   "isPromise": () => (/* binding */ isPromise),
/* harmony export */   "isReservedProp": () => (/* binding */ isReservedProp),
/* harmony export */   "isSSRSafeAttrName": () => (/* binding */ isSSRSafeAttrName),
/* harmony export */   "isSVGTag": () => (/* binding */ isSVGTag),
/* harmony export */   "isSet": () => (/* binding */ isSet),
/* harmony export */   "isSpecialBooleanAttr": () => (/* binding */ isSpecialBooleanAttr),
/* harmony export */   "isString": () => (/* binding */ isString),
/* harmony export */   "isSymbol": () => (/* binding */ isSymbol),
/* harmony export */   "isVoidTag": () => (/* binding */ isVoidTag),
/* harmony export */   "looseEqual": () => (/* binding */ looseEqual),
/* harmony export */   "looseIndexOf": () => (/* binding */ looseIndexOf),
/* harmony export */   "makeMap": () => (/* binding */ makeMap),
/* harmony export */   "normalizeClass": () => (/* binding */ normalizeClass),
/* harmony export */   "normalizeProps": () => (/* binding */ normalizeProps),
/* harmony export */   "normalizeStyle": () => (/* binding */ normalizeStyle),
/* harmony export */   "objectToString": () => (/* binding */ objectToString),
/* harmony export */   "parseStringStyle": () => (/* binding */ parseStringStyle),
/* harmony export */   "propsToAttrMap": () => (/* binding */ propsToAttrMap),
/* harmony export */   "remove": () => (/* binding */ remove),
/* harmony export */   "slotFlagsText": () => (/* binding */ slotFlagsText),
/* harmony export */   "stringifyStyle": () => (/* binding */ stringifyStyle),
/* harmony export */   "toDisplayString": () => (/* binding */ toDisplayString),
/* harmony export */   "toHandlerKey": () => (/* binding */ toHandlerKey),
/* harmony export */   "toNumber": () => (/* binding */ toNumber),
/* harmony export */   "toRawType": () => (/* binding */ toRawType),
/* harmony export */   "toTypeString": () => (/* binding */ toTypeString)
/* harmony export */ });
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */
function makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(',');
    for (let i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? val => !!map[val.toLowerCase()] : val => !!map[val];
}

/**
 * dev only flag -> name mapping
 */
const PatchFlagNames = {
    [1 /* TEXT */]: `TEXT`,
    [2 /* CLASS */]: `CLASS`,
    [4 /* STYLE */]: `STYLE`,
    [8 /* PROPS */]: `PROPS`,
    [16 /* FULL_PROPS */]: `FULL_PROPS`,
    [32 /* HYDRATE_EVENTS */]: `HYDRATE_EVENTS`,
    [64 /* STABLE_FRAGMENT */]: `STABLE_FRAGMENT`,
    [128 /* KEYED_FRAGMENT */]: `KEYED_FRAGMENT`,
    [256 /* UNKEYED_FRAGMENT */]: `UNKEYED_FRAGMENT`,
    [512 /* NEED_PATCH */]: `NEED_PATCH`,
    [1024 /* DYNAMIC_SLOTS */]: `DYNAMIC_SLOTS`,
    [2048 /* DEV_ROOT_FRAGMENT */]: `DEV_ROOT_FRAGMENT`,
    [-1 /* HOISTED */]: `HOISTED`,
    [-2 /* BAIL */]: `BAIL`
};

/**
 * Dev only
 */
const slotFlagsText = {
    [1 /* STABLE */]: 'STABLE',
    [2 /* DYNAMIC */]: 'DYNAMIC',
    [3 /* FORWARDED */]: 'FORWARDED'
};

const GLOBALS_WHITE_LISTED = 'Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,' +
    'decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,' +
    'Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt';
const isGloballyWhitelisted = /*#__PURE__*/ makeMap(GLOBALS_WHITE_LISTED);

const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx) => idx % 2 === 1);
    lines = lines.filter((_, idx) => idx % 2 === 0);
    let count = 0;
    const res = [];
    for (let i = 0; i < lines.length; i++) {
        count +=
            lines[i].length +
                ((newlineSequences[i] && newlineSequences[i].length) || 0);
        if (count >= start) {
            for (let j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = (newlineSequences[j] && newlineSequences[j].length) || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                }
                else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join('\n');
}

/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /*#__PURE__*/ makeMap(specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */
const isBooleanAttr = /*#__PURE__*/ makeMap(specialBooleanAttrs +
    `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` +
    `loop,open,required,reversed,scoped,seamless,` +
    `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */
function includeBooleanAttr(value) {
    return !!value || value === '';
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) {
        return attrValidationCache[name];
    }
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) {
        console.error(`unsafe attribute name: ${name}`);
    }
    return (attrValidationCache[name] = !isUnsafe);
}
const propsToAttrMap = {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
};
/**
 * CSS properties that accept plain numbers
 */
const isNoUnitNumericStyleProp = /*#__PURE__*/ makeMap(`animation-iteration-count,border-image-outset,border-image-slice,` +
    `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` +
    `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` +
    `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` +
    `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` +
    `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` +
    // SVG
    `fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` +
    `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */
const isKnownHtmlAttr = /*#__PURE__*/ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,` +
    `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` +
    `border,buffered,capture,challenge,charset,checked,cite,class,code,` +
    `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` +
    `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` +
    `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` +
    `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` +
    `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` +
    `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` +
    `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` +
    `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` +
    `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` +
    `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` +
    `start,step,style,summary,tabindex,target,title,translate,type,usemap,` +
    `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */
const isKnownSvgAttr = /*#__PURE__*/ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` +
    `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` +
    `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` +
    `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` +
    `color-interpolation-filters,color-profile,color-rendering,` +
    `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` +
    `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` +
    `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` +
    `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` +
    `font-family,font-size,font-size-adjust,font-stretch,font-style,` +
    `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` +
    `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` +
    `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` +
    `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` +
    `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` +
    `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` +
    `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` +
    `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` +
    `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` +
    `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` +
    `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` +
    `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` +
    `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` +
    `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` +
    `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` +
    `specularConstant,specularExponent,speed,spreadMethod,startOffset,` +
    `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` +
    `strikethrough-position,strikethrough-thickness,string,stroke,` +
    `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` +
    `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` +
    `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` +
    `text-decoration,text-rendering,textLength,to,transform,transform-origin,` +
    `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` +
    `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` +
    `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` +
    `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` +
    `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` +
    `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` +
    `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);

function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for (let i = 0; i < value.length; i++) {
            const item = value[i];
            const normalized = isString(item)
                ? parseStringStyle(item)
                : normalizeStyle(item);
            if (normalized) {
                for (const key in normalized) {
                    res[key] = normalized[key];
                }
            }
        }
        return res;
    }
    else if (isString(value)) {
        return value;
    }
    else if (isObject(value)) {
        return value;
    }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:(.+)/;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.split(listDelimiterRE).forEach(item => {
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    let ret = '';
    if (!styles || isString(styles)) {
        return ret;
    }
    for (const key in styles) {
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
        if (isString(value) ||
            (typeof value === 'number' && isNoUnitNumericStyleProp(normalizedKey))) {
            // only render valid values
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = '';
    if (isString(value)) {
        res = value;
    }
    else if (isArray(value)) {
        for (let i = 0; i < value.length; i++) {
            const normalized = normalizeClass(value[i]);
            if (normalized) {
                res += normalized + ' ';
            }
        }
    }
    else if (isObject(value)) {
        for (const name in value) {
            if (value[name]) {
                res += name + ' ';
            }
        }
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props)
        return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) {
        props.class = normalizeClass(klass);
    }
    if (style) {
        props.style = normalizeStyle(style);
    }
    return props;
}

// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const HTML_TAGS = 'html,body,base,head,link,meta,style,title,address,article,aside,footer,' +
    'header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,' +
    'figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,' +
    'data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,' +
    'time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,' +
    'canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,' +
    'th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,' +
    'option,output,progress,select,textarea,details,dialog,menu,' +
    'summary,template,blockquote,iframe,tfoot';
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const SVG_TAGS = 'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,' +
    'defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,' +
    'feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,' +
    'feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,' +
    'feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,' +
    'fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,' +
    'foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,' +
    'mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,' +
    'polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,' +
    'text,textPath,title,tspan,unknown,use,view';
const VOID_TAGS = 'area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr';
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */
const isHTMLTag = /*#__PURE__*/ makeMap(HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */
const isSVGTag = /*#__PURE__*/ makeMap(SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */
const isVoidTag = /*#__PURE__*/ makeMap(VOID_TAGS);

const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = '' + string;
    const match = escapeRE.exec(str);
    if (!match) {
        return str;
    }
    let html = '';
    let escaped;
    let index;
    let lastIndex = 0;
    for (index = match.index; index < str.length; index++) {
        switch (str.charCodeAt(index)) {
            case 34: // "
                escaped = '&quot;';
                break;
            case 38: // &
                escaped = '&amp;';
                break;
            case 39: // '
                escaped = '&#39;';
                break;
            case 60: // <
                escaped = '&lt;';
                break;
            case 62: // >
                escaped = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) {
            html += str.slice(lastIndex, index);
        }
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, '');
}

function looseCompareArrays(a, b) {
    if (a.length !== b.length)
        return false;
    let equal = true;
    for (let i = 0; equal && i < a.length; i++) {
        equal = looseEqual(a[i], b[i]);
    }
    return equal;
}
function looseEqual(a, b) {
    if (a === b)
        return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) {
        return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    }
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) {
        return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    }
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */
        if (!aValidType || !bValidType) {
            return false;
        }
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) {
            return false;
        }
        for (const key in a) {
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if ((aHasKey && !bHasKey) ||
                (!aHasKey && bHasKey) ||
                !looseEqual(a[key], b[key])) {
                return false;
            }
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex(item => looseEqual(item, val));
}

/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */
const toDisplayString = (val) => {
    return isString(val)
        ? val
        : val == null
            ? ''
            : isArray(val) ||
                (isObject(val) &&
                    (val.toString === objectToString || !isFunction(val.toString)))
                ? JSON.stringify(val, replacer, 2)
                : String(val);
};
const replacer = (_key, val) => {
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) {
        return replacer(_key, val.value);
    }
    else if (isMap(val)) {
        return {
            [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val]) => {
                entries[`${key} =>`] = val;
                return entries;
            }, {})
        };
    }
    else if (isSet(val)) {
        return {
            [`Set(${val.size})`]: [...val.values()]
        };
    }
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) {
        return String(val);
    }
    return val;
};

const EMPTY_OBJ = ( false)
    ? 0
    : {};
const EMPTY_ARR = ( false) ? 0 : [];
const NOOP = () => { };
/**
 * Always return false.
 */
const NO = () => false;
const onRE = /^on[^a-z]/;
const isOn = (key) => onRE.test(key);
const isModelListener = (key) => key.startsWith('onUpdate:');
const extend = Object.assign;
const remove = (arr, el) => {
    const i = arr.indexOf(el);
    if (i > -1) {
        arr.splice(i, 1);
    }
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key) => hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val) => toTypeString(val) === '[object Map]';
const isSet = (val) => toTypeString(val) === '[object Set]';
const isDate = (val) => val instanceof Date;
const isFunction = (val) => typeof val === 'function';
const isString = (val) => typeof val === 'string';
const isSymbol = (val) => typeof val === 'symbol';
const isObject = (val) => val !== null && typeof val === 'object';
const isPromise = (val) => {
    return isObject(val) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const toRawType = (value) => {
    // extract "RawType" from strings like "[object RawType]"
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val) => toTypeString(val) === '[object Object]';
const isIntegerKey = (key) => isString(key) &&
    key !== 'NaN' &&
    key[0] !== '-' &&
    '' + parseInt(key, 10) === key;
const isReservedProp = /*#__PURE__*/ makeMap(
// the leading comma is intentional so empty string "" is also included
',key,ref,ref_for,ref_key,' +
    'onVnodeBeforeMount,onVnodeMounted,' +
    'onVnodeBeforeUpdate,onVnodeUpdated,' +
    'onVnodeBeforeUnmount,onVnodeUnmounted');
const isBuiltInDirective = /*#__PURE__*/ makeMap('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo');
const cacheStringFunction = (fn) => {
    const cache = Object.create(null);
    return ((str) => {
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    });
};
const camelizeRE = /-(\w)/g;
/**
 * @private
 */
const camelize = cacheStringFunction((str) => {
    return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''));
});
const hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */
const hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, '-$1').toLowerCase());
/**
 * @private
 */
const capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */
const toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, arg) => {
    for (let i = 0; i < fns.length; i++) {
        fns[i](arg);
    }
};
const def = (obj, key, value) => {
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value
    });
};
const toNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = () => {
    return (_globalThis ||
        (_globalThis =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof __webpack_require__.g !== 'undefined'
                            ? __webpack_require__.g
                            : {}));
};




/***/ }),

/***/ 41:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CheckoutWeb": () => (/* binding */ CheckoutWeb),
/* harmony export */   "Checkout": () => (/* binding */ Checkout)
/* harmony export */ });
/* harmony import */ var _capacitor_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(895);

class CheckoutWeb extends _capacitor_core__WEBPACK_IMPORTED_MODULE_0__/* .WebPlugin */ .Uw {
    constructor() {
        super({
            name: 'Checkout',
            platforms: ['web'],
        });
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async open(options) {
        console.log(options);
        return new Promise((resolve, reject) => {
            var _a;
            var razorpay;
            //add handlers to options to get the success response
            var finalOps = options;
            finalOps['handler'] = function (res) {
                console.log(res.razorpay_payment_id);
                resolve({
                    response: res
                });
            };
            finalOps['modal.ondismiss'] = function () {
                reject(JSON.stringify({ code: 2, description: 'Payment Canceled by User' }));
            };
            var retryCount = 0;
            if (finalOps.hasOwnProperty('retry')) {
                if (finalOps.retry.enabled === true) {
                    retryCount = finalOps.retry.max_count;
                }
            }
            //get the first script tag in the document
            var rjs = document.getElementsByTagName('script')[0];
            //create a HTMLScriptElement object for rzp script injection
            var rzpjs = document.createElement('script');
            rzpjs.id = 'rzp-jssdk';
            rzpjs.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js');
            (_a = rjs.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(rzpjs);
            rzpjs.addEventListener('load', () => {
                try {
                    razorpay = new window.Razorpay(finalOps);
                    razorpay.open();
                    razorpay.on(('payment.failed'), (res) => {
                        var _a;
                        retryCount = retryCount - 1;
                        if (retryCount < 0) {
                            console.log(res);
                            (_a = rjs.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(rzpjs);
                            reject(res.error);
                        }
                    });
                }
                catch (err) {
                    reject({
                        response: err
                    });
                }
            });
        });
        // var rjs = document.getElementsByTagName('script')[0]
        // var razorpay;
        // var js:HTMLScriptElement = document.createElement('script')
        // js.id = 'rzp-jssdk'
        // js.setAttribute('src','https://checkout.razorpay.com/v1/checkout.js')
        // document.body.appendChild(js);
        // document.body.appendChild(js);
        // rjs.parentNode?.appendChild(js)
        // rjs.addEventListener('load',()=>{
        //   try{
        //     razorpay = new (window as any).Razorpay(options)
        //     razorpay.open()
        //     razorpay.on('payment.failed',function(response:any){
        //         console.log('payment failed')
        //         console.log(response)
        //     })
        //   }catch(err){
        //     document.body.removeChild(js)
        //     return{
        //       response: "Problem opening checkouts"
        //     }
        //   }
        // })
        // return {
        //   response:options.key
        // }
    }
}
const Checkout = (0,_capacitor_core__WEBPACK_IMPORTED_MODULE_0__/* .registerPlugin */ .fo)('Checkout', {
    web: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 41)).then(m => new m.CheckoutWeb())
});

//# sourceMappingURL=web.js.map

/***/ }),

/***/ 90:
/***/ ((module) => {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),

/***/ 988:
/***/ ((module) => {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),

/***/ 744:
/***/ ((__unused_webpack_module, exports) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 961:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

var compilerDom = __webpack_require__(3);
var runtimeDom = __webpack_require__(229);
var shared = __webpack_require__(577);

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      n[k] = e[k];
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var runtimeDom__namespace = /*#__PURE__*/_interopNamespace(runtimeDom);

// This entry is the "full-build" that includes both the runtime
const compileCache = Object.create(null);
function compileToFunction(template, options) {
    if (!shared.isString(template)) {
        if (template.nodeType) {
            template = template.innerHTML;
        }
        else {
            runtimeDom.warn(`invalid template option: `, template);
            return shared.NOOP;
        }
    }
    const key = template;
    const cached = compileCache[key];
    if (cached) {
        return cached;
    }
    if (template[0] === '#') {
        const el = document.querySelector(template);
        if (!el) {
            runtimeDom.warn(`Template element not found or is empty: ${template}`);
        }
        // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's rendered
        // by the server, the template should not contain any user data.
        template = el ? el.innerHTML : ``;
    }
    const { code } = compilerDom.compile(template, shared.extend({
        hoistStatic: true,
        onError: onError ,
        onWarn: e => onError(e, true) 
    }, options));
    function onError(err, asWarning = false) {
        const message = asWarning
            ? err.message
            : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc &&
            shared.generateCodeFrame(template, err.loc.start.offset, err.loc.end.offset);
        runtimeDom.warn(codeFrame ? `${message}\n${codeFrame}` : message);
    }
    // The wildcard import results in a huge object with every export
    // with keys that cannot be mangled, and can be quite heavy size-wise.
    // In the global build we know `Vue` is available globally so we can avoid
    // the wildcard object.
    const render = (new Function('Vue', code)(runtimeDom__namespace));
    render._rc = true;
    return (compileCache[key] = render);
}
runtimeDom.registerRuntimeCompiler(compileToFunction);

Object.keys(runtimeDom).forEach(function (k) {
  if (k !== 'default') exports[k] = runtimeDom[k];
});
exports.compile = compileToFunction;


/***/ }),

/***/ 6:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _PlayerStates = __webpack_require__(275);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 125:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _debug = __webpack_require__(215);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(255);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(279);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(6);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports["default"] = YouTubePlayer;
module.exports = exports['default'];

/***/ }),

/***/ 275:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),

/***/ 279:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports["default"] = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ ((module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports["default"] = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),

/***/ 62:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(988);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(900);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(125);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports["default"] = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),

/***/ 900:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _loadScript = __webpack_require__(90);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ ((module, exports, __webpack_require__) => {

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(128);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),

/***/ 128:
/***/ ((module, exports, __webpack_require__) => {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(680);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 680:
/***/ ((module) => {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 682:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! odometer 0.4.8 */
(function () { var a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G = [].slice; q = '<span class="odometer-value"></span>', n = '<span class="odometer-ribbon"><span class="odometer-ribbon-inner">' + q + "</span></span>", d = '<span class="odometer-digit"><span class="odometer-digit-spacer">8</span><span class="odometer-digit-inner">' + n + "</span></span>", g = '<span class="odometer-formatting-mark"></span>', c = "(,ddd).dd", h = /^\(?([^)]*)\)?(?:(.)(d+))?$/, i = 30, f = 2e3, a = 20, j = 2, e = .5, k = 1e3 / i, b = 1e3 / a, o = "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd", y = document.createElement("div").style, p = null != y.transition || null != y.webkitTransition || null != y.mozTransition || null != y.oTransition, w = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame, l = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver, s = function (a) { var b; return b = document.createElement("div"), b.innerHTML = a, b.children[0] }, v = function (a, b) { return a.className = a.className.replace(new RegExp("(^| )" + b.split(" ").join("|") + "( |$)", "gi"), " ") }, r = function (a, b) { return v(a, b), a.className += " " + b }, z = function (a, b) { var c; return null != document.createEvent ? (c = document.createEvent("HTMLEvents"), c.initEvent(b, !0, !0), a.dispatchEvent(c)) : void 0 }, u = function () { var a, b; return null != (a = null != (b = window.performance) && "function" == typeof b.now ? b.now() : void 0) ? a : +new Date }, x = function (a, b) { return null == b && (b = 0), b ? (a *= Math.pow(10, b), a += .5, a = Math.floor(a), a /= Math.pow(10, b)) : Math.round(a) }, A = function (a) { return 0 > a ? Math.ceil(a) : Math.floor(a) }, t = function (a) { return a - x(a) }, C = !1, (B = function () { var a, b, c, d, e; if (!C && null != window.jQuery) { for (C = !0, d = ["html", "text"], e = [], b = 0, c = d.length; c > b; b++)a = d[b], e.push(function (a) { var b; return b = window.jQuery.fn[a], window.jQuery.fn[a] = function (a) { var c; return null == a || null == (null != (c = this[0]) ? c.odometer : void 0) ? b.apply(this, arguments) : this[0].odometer.update(a) } }(a)); return e } })(), setTimeout(B, 0), m = function () { function a(b) { var c, d, e, g, h, i, l, m, n, o, p = this; if (this.options = b, this.el = this.options.el, null != this.el.odometer) return this.el.odometer; this.el.odometer = this, m = a.options; for (d in m) g = m[d], null == this.options[d] && (this.options[d] = g); null == (h = this.options).duration && (h.duration = f), this.MAX_VALUES = this.options.duration / k / j | 0, this.resetFormat(), this.value = this.cleanValue(null != (n = this.options.value) ? n : ""), this.renderInside(), this.render(); try { for (o = ["innerHTML", "innerText", "textContent"], i = 0, l = o.length; l > i; i++)e = o[i], null != this.el[e] && !function (a) { return Object.defineProperty(p.el, a, { get: function () { var b; return "innerHTML" === a ? p.inside.outerHTML : null != (b = p.inside.innerText) ? b : p.inside.textContent }, set: function (a) { return p.update(a) } }) }(e) } catch (q) { c = q, this.watchForMutations() } } return a.prototype.renderInside = function () { return this.inside = document.createElement("div"), this.inside.className = "odometer-inside", this.el.innerHTML = "", this.el.appendChild(this.inside) }, a.prototype.watchForMutations = function () { var a, b = this; if (null != l) try { return null == this.observer && (this.observer = new l(function (a) { var c; return c = b.el.innerText, b.renderInside(), b.render(b.value), b.update(c) })), this.watchMutations = !0, this.startWatchingMutations() } catch (c) { a = c } }, a.prototype.startWatchingMutations = function () { return this.watchMutations ? this.observer.observe(this.el, { childList: !0 }) : void 0 }, a.prototype.stopWatchingMutations = function () { var a; return null != (a = this.observer) ? a.disconnect() : void 0 }, a.prototype.cleanValue = function (a) { var b; return "string" == typeof a && (a = a.replace(null != (b = this.format.radix) ? b : ".", "<radix>"), a = a.replace(/[.,]/g, ""), a = a.replace("<radix>", "."), a = parseFloat(a, 10) || 0), x(a, this.format.precision) }, a.prototype.bindTransitionEnd = function () { var a, b, c, d, e, f, g = this; if (!this.transitionEndBound) { for (this.transitionEndBound = !0, b = !1, e = o.split(" "), f = [], c = 0, d = e.length; d > c; c++)a = e[c], f.push(this.el.addEventListener(a, function () { return b ? !0 : (b = !0, setTimeout(function () { return g.render(), b = !1, z(g.el, "odometerdone") }, 0), !0) }, !1)); return f } }, a.prototype.resetFormat = function () { var a, b, d, e, f, g, i, j; if (a = null != (i = this.options.format) ? i : c, a || (a = "d"), d = h.exec(a), !d) throw new Error("Odometer: Unparsable digit format"); return j = d.slice(1, 4), g = j[0], f = j[1], b = j[2], e = (null != b ? b.length : void 0) || 0, this.format = { repeating: g, radix: f, precision: e } }, a.prototype.render = function (a) { var b, c, d, e, f, g, h; for (null == a && (a = this.value), this.stopWatchingMutations(), this.resetFormat(), this.inside.innerHTML = "", f = this.options.theme, b = this.el.className.split(" "), e = [], g = 0, h = b.length; h > g; g++)c = b[g], c.length && ((d = /^odometer-theme-(.+)$/.exec(c)) ? f = d[1] : /^odometer(-|$)/.test(c) || e.push(c)); return e.push("odometer"), p || e.push("odometer-no-transitions"), f ? e.push("odometer-theme-" + f) : e.push("odometer-auto-theme"), this.el.className = e.join(" "), this.ribbons = {}, this.formatDigits(a), this.startWatchingMutations() }, a.prototype.formatDigits = function (a) { var b, c, d, e, f, g, h, i, j, k; if (this.digits = [], this.options.formatFunction) for (d = this.options.formatFunction(a), j = d.split("").reverse(), f = 0, h = j.length; h > f; f++)c = j[f], c.match(/0-9/) ? (b = this.renderDigit(), b.querySelector(".odometer-value").innerHTML = c, this.digits.push(b), this.insertDigit(b)) : this.addSpacer(c); else for (e = !this.format.precision || !t(a) || !1, k = a.toString().split("").reverse(), g = 0, i = k.length; i > g; g++)b = k[g], "." === b && (e = !0), this.addDigit(b, e) }, a.prototype.update = function (a) { var b, c = this; return a = this.cleanValue(a), (b = a - this.value) ? (v(this.el, "odometer-animating-up odometer-animating-down odometer-animating"), b > 0 ? r(this.el, "odometer-animating-up") : r(this.el, "odometer-animating-down"), this.stopWatchingMutations(), this.animate(a), this.startWatchingMutations(), setTimeout(function () { return c.el.offsetHeight, r(c.el, "odometer-animating") }, 0), this.value = a) : void 0 }, a.prototype.renderDigit = function () { return s(d) }, a.prototype.insertDigit = function (a, b) { return null != b ? this.inside.insertBefore(a, b) : this.inside.children.length ? this.inside.insertBefore(a, this.inside.children[0]) : this.inside.appendChild(a) }, a.prototype.addSpacer = function (a, b, c) { var d; return d = s(g), d.innerHTML = a, c && r(d, c), this.insertDigit(d, b) }, a.prototype.addDigit = function (a, b) { var c, d, e, f; if (null == b && (b = !0), "-" === a) return this.addSpacer(a, null, "odometer-negation-mark"); if ("." === a) return this.addSpacer(null != (f = this.format.radix) ? f : ".", null, "odometer-radix-mark"); if (b) for (e = !1; ;) { if (!this.format.repeating.length) { if (e) throw new Error("Bad odometer format without digits"); this.resetFormat(), e = !0 } if (c = this.format.repeating[this.format.repeating.length - 1], this.format.repeating = this.format.repeating.substring(0, this.format.repeating.length - 1), "d" === c) break; this.addSpacer(c) } return d = this.renderDigit(), d.querySelector(".odometer-value").innerHTML = a, this.digits.push(d), this.insertDigit(d) }, a.prototype.animate = function (a) { return p && "count" !== this.options.animation ? this.animateSlide(a) : this.animateCount(a) }, a.prototype.animateCount = function (a) { var c, d, e, f, g, h = this; if (d = +a - this.value) return f = e = u(), c = this.value, (g = function () { var i, j, k; return u() - f > h.options.duration ? (h.value = a, h.render(), void z(h.el, "odometerdone")) : (i = u() - e, i > b && (e = u(), k = i / h.options.duration, j = d * k, c += j, h.render(Math.round(c))), null != w ? w(g) : setTimeout(g, b)) })() }, a.prototype.getDigitCount = function () { var a, b, c, d, e, f; for (d = 1 <= arguments.length ? G.call(arguments, 0) : [], a = e = 0, f = d.length; f > e; a = ++e)c = d[a], d[a] = Math.abs(c); return b = Math.max.apply(Math, d), Math.ceil(Math.log(b + 1) / Math.log(10)) }, a.prototype.getFractionalDigitCount = function () { var a, b, c, d, e, f, g; for (e = 1 <= arguments.length ? G.call(arguments, 0) : [], b = /^\-?\d*\.(\d*?)0*$/, a = f = 0, g = e.length; g > f; a = ++f)d = e[a], e[a] = d.toString(), c = b.exec(e[a]), null == c ? e[a] = 0 : e[a] = c[1].length; return Math.max.apply(Math, e) }, a.prototype.resetDigits = function () { return this.digits = [], this.ribbons = [], this.inside.innerHTML = "", this.resetFormat() }, a.prototype.animateSlide = function (a) { var b, c, d, f, g, h, i, j, k, l, m, n, o, p, q, s, t, u, v, w, x, y, z, B, C, D, E; if (s = this.value, j = this.getFractionalDigitCount(s, a), j && (a *= Math.pow(10, j), s *= Math.pow(10, j)), d = a - s) { for (this.bindTransitionEnd(), f = this.getDigitCount(s, a), g = [], b = 0, m = v = 0; f >= 0 ? f > v : v > f; m = f >= 0 ? ++v : --v) { if (t = A(s / Math.pow(10, f - m - 1)), i = A(a / Math.pow(10, f - m - 1)), h = i - t, Math.abs(h) > this.MAX_VALUES) { for (l = [], n = h / (this.MAX_VALUES + this.MAX_VALUES * b * e), c = t; h > 0 && i > c || 0 > h && c > i;)l.push(Math.round(c)), c += n; l[l.length - 1] !== i && l.push(i), b++ } else l = function () { E = []; for (var a = t; i >= t ? i >= a : a >= i; i >= t ? a++ : a--)E.push(a); return E }.apply(this); for (m = w = 0, y = l.length; y > w; m = ++w)k = l[m], l[m] = Math.abs(k % 10); g.push(l) } for (this.resetDigits(), D = g.reverse(), m = x = 0, z = D.length; z > x; m = ++x)for (l = D[m], this.digits[m] || this.addDigit(" ", m >= j), null == (u = this.ribbons)[m] && (u[m] = this.digits[m].querySelector(".odometer-ribbon-inner")), this.ribbons[m].innerHTML = "", 0 > d && (l = l.reverse()), o = C = 0, B = l.length; B > C; o = ++C)k = l[o], q = document.createElement("div"), q.className = "odometer-value", q.innerHTML = k, this.ribbons[m].appendChild(q), o === l.length - 1 && r(q, "odometer-last-value"), 0 === o && r(q, "odometer-first-value"); return 0 > t && this.addDigit("-"), p = this.inside.querySelector(".odometer-radix-mark"), null != p && p.parent.removeChild(p), j ? this.addSpacer(this.format.radix, this.digits[j - 1], "odometer-radix-mark") : void 0 } }, a }(), m.options = null != (E = window.odometerOptions) ? E : {}, setTimeout(function () { var a, b, c, d, e; if (window.odometerOptions) { d = window.odometerOptions, e = []; for (a in d) b = d[a], e.push(null != (c = m.options)[a] ? (c = m.options)[a] : c[a] = b); return e } }, 0), m.init = function () { var a, b, c, d, e, f; if (null != document.querySelectorAll) { for (b = document.querySelectorAll(m.options.selector || ".odometer"), f = [], c = 0, d = b.length; d > c; c++)a = b[c], f.push(a.odometer = new m({ el: a, value: null != (e = a.innerText) ? e : a.textContent })); return f } }, null != (null != (F = document.documentElement) ? F.doScroll : void 0) && null != document.createEventObject ? (D = document.onreadystatechange, document.onreadystatechange = function () { return "complete" === document.readyState && m.options.auto !== !1 && m.init(), null != D ? D.apply(this, arguments) : void 0 }) : document.addEventListener("DOMContentLoaded", function () { return m.options.auto !== !1 ? m.init() : void 0 }, !1),  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () { return m }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0 }).call(this);


/***/ }),

/***/ 86:
/***/ ((module) => {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_552__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_552__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_552__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_552__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_552__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_552__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_552__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_552__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_552__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_552__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_552__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_552__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_552__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_552__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_552__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_552__(__nested_webpack_require_552__.s = "./index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./externals/base64.js":
/*!*****************************!*\
  !*** ./externals/base64.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* $Date: 2007-06-12 18:02:31 $ */
// from: http://bannister.us/weblog/2007/06/09/simple-base64-encodedecode-javascript/
// Handles encode/decode of ASCII and Unicode strings.
var UTF8 = {};

UTF8.encode = function (s) {
  var u = [];

  for (var i = 0; i < s.length; ++i) {
    var c = s.charCodeAt(i);

    if (c < 0x80) {
      u.push(c);
    } else if (c < 0x800) {
      u.push(0xC0 | c >> 6);
      u.push(0x80 | 63 & c);
    } else if (c < 0x10000) {
      u.push(0xE0 | c >> 12);
      u.push(0x80 | 63 & c >> 6);
      u.push(0x80 | 63 & c);
    } else {
      u.push(0xF0 | c >> 18);
      u.push(0x80 | 63 & c >> 12);
      u.push(0x80 | 63 & c >> 6);
      u.push(0x80 | 63 & c);
    }
  }

  return u;
};

UTF8.decode = function (u) {
  var a = [];
  var i = 0;

  while (i < u.length) {
    var v = u[i++];

    if (v < 0x80) {// no need to mask byte
    } else if (v < 0xE0) {
      v = (31 & v) << 6;
      v |= 63 & u[i++];
    } else if (v < 0xF0) {
      v = (15 & v) << 12;
      v |= (63 & u[i++]) << 6;
      v |= 63 & u[i++];
    } else {
      v = (7 & v) << 18;
      v |= (63 & u[i++]) << 12;
      v |= (63 & u[i++]) << 6;
      v |= 63 & u[i++];
    }

    a.push(String.fromCharCode(v));
  }

  return a.join('');
};

var BASE64 = {};

(function (T) {
  var encodeArray = function encodeArray(u) {
    var i = 0;
    var a = [];
    var n = 0 | u.length / 3;

    while (0 < n--) {
      var v = (u[i] << 16) + (u[i + 1] << 8) + u[i + 2];
      i += 3;
      a.push(T.charAt(63 & v >> 18));
      a.push(T.charAt(63 & v >> 12));
      a.push(T.charAt(63 & v >> 6));
      a.push(T.charAt(63 & v));
    }

    if (2 == u.length - i) {
      var v = (u[i] << 16) + (u[i + 1] << 8);
      a.push(T.charAt(63 & v >> 18));
      a.push(T.charAt(63 & v >> 12));
      a.push(T.charAt(63 & v >> 6));
      a.push('=');
    } else if (1 == u.length - i) {
      var v = u[i] << 16;
      a.push(T.charAt(63 & v >> 18));
      a.push(T.charAt(63 & v >> 12));
      a.push('==');
    }

    return a.join('');
  };

  var R = function () {
    var a = [];

    for (var i = 0; i < T.length; ++i) {
      a[T.charCodeAt(i)] = i;
    }

    a['='.charCodeAt(0)] = 0;
    return a;
  }();

  var decodeArray = function decodeArray(s) {
    var i = 0;
    var u = [];
    var n = 0 | s.length / 4;

    while (0 < n--) {
      var v = (R[s.charCodeAt(i)] << 18) + (R[s.charCodeAt(i + 1)] << 12) + (R[s.charCodeAt(i + 2)] << 6) + R[s.charCodeAt(i + 3)];
      u.push(255 & v >> 16);
      u.push(255 & v >> 8);
      u.push(255 & v);
      i += 4;
    }

    if (u) {
      if ('=' == s.charAt(i - 2)) {
        u.pop();
        u.pop();
      } else if ('=' == s.charAt(i - 1)) {
        u.pop();
      }
    }

    return u;
  };

  var ASCII = {};

  ASCII.encode = function (s) {
    var u = [];

    for (var i = 0; i < s.length; ++i) {
      u.push(s.charCodeAt(i));
    }

    return u;
  };

  ASCII.decode = function (u) {
    for (var i = 0; i < s.length; ++i) {
      a[i] = String.fromCharCode(a[i]);
    }

    return a.join('');
  };

  BASE64.decodeArray = function (s) {
    var u = decodeArray(s);
    return new Uint8Array(u);
  };

  BASE64.encodeASCII = function (s) {
    var u = ASCII.encode(s);
    return encodeArray(u);
  };

  BASE64.decodeASCII = function (s) {
    var a = decodeArray(s);
    return ASCII.decode(a);
  };

  BASE64.encode = function (s) {
    var u = UTF8.encode(s);
    return encodeArray(u);
  };

  BASE64.decode = function (s) {
    var u = decodeArray(s);
    return UTF8.decode(u);
  };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
/*The following polyfills are not used in dash.js but have caused multiplayer integration issues.
 Therefore commenting them out.
if (undefined === btoa) {
    var btoa = BASE64.encode;
}
if (undefined === atob) {
    var atob = BASE64.decode;
}
*/


if (true) {
  exports.decode = BASE64.decode;
  exports.decodeArray = BASE64.decodeArray;
  exports.encode = BASE64.encode;
  exports.encodeASCII = BASE64.encodeASCII;
}

/***/ }),

/***/ "./externals/cea608-parser.js":
/*!************************************!*\
  !*** ./externals/cea608-parser.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
(function (exports) {
  "use strict";
  /**
   *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
   */

  var specialCea608CharsCodes = {
    0x2a: 0xe1,
    // lowercase a, acute accent
    0x5c: 0xe9,
    // lowercase e, acute accent
    0x5e: 0xed,
    // lowercase i, acute accent
    0x5f: 0xf3,
    // lowercase o, acute accent
    0x60: 0xfa,
    // lowercase u, acute accent
    0x7b: 0xe7,
    // lowercase c with cedilla
    0x7c: 0xf7,
    // division symbol
    0x7d: 0xd1,
    // uppercase N tilde
    0x7e: 0xf1,
    // lowercase n tilde
    0x7f: 0x2588,
    // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    // Registered symbol (R)
    0x81: 0xb0,
    // degree sign
    0x82: 0xbd,
    // 1/2 symbol
    0x83: 0xbf,
    // Inverted (open) question mark
    0x84: 0x2122,
    // Trademark symbol (TM)
    0x85: 0xa2,
    // Cents symbol
    0x86: 0xa3,
    // Pounds sterling
    0x87: 0x266a,
    // Music 8'th note
    0x88: 0xe0,
    // lowercase a, grave accent
    0x89: 0x20,
    // transparent space (regular)
    0x8a: 0xe8,
    // lowercase e, grave accent
    0x8b: 0xe2,
    // lowercase a, circumflex accent
    0x8c: 0xea,
    // lowercase e, circumflex accent
    0x8d: 0xee,
    // lowercase i, circumflex accent
    0x8e: 0xf4,
    // lowercase o, circumflex accent
    0x8f: 0xfb,
    // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    // capital letter A with acute
    0x91: 0xc9,
    // capital letter E with acute
    0x92: 0xd3,
    // capital letter O with acute
    0x93: 0xda,
    // capital letter U with acute
    0x94: 0xdc,
    // capital letter U with diaresis
    0x95: 0xfc,
    // lowercase letter U with diaeresis
    0x96: 0x2018,
    // opening single quote
    0x97: 0xa1,
    // inverted exclamation mark
    0x98: 0x2a,
    // asterisk
    0x99: 0x2019,
    // closing single quote
    0x9a: 0x2501,
    // box drawings heavy horizontal
    0x9b: 0xa9,
    // copyright sign
    0x9c: 0x2120,
    // Service mark
    0x9d: 0x2022,
    // (round) bullet
    0x9e: 0x201c,
    // Left double quotation mark
    0x9f: 0x201d,
    // Right double quotation mark
    0xa0: 0xc0,
    // uppercase A, grave accent
    0xa1: 0xc2,
    // uppercase A, circumflex
    0xa2: 0xc7,
    // uppercase C with cedilla
    0xa3: 0xc8,
    // uppercase E, grave accent
    0xa4: 0xca,
    // uppercase E, circumflex
    0xa5: 0xcb,
    // capital letter E with diaresis
    0xa6: 0xeb,
    // lowercase letter e with diaresis
    0xa7: 0xce,
    // uppercase I, circumflex
    0xa8: 0xcf,
    // uppercase I, with diaresis
    0xa9: 0xef,
    // lowercase i, with diaresis
    0xaa: 0xd4,
    // uppercase O, circumflex
    0xab: 0xd9,
    // uppercase U, grave accent
    0xac: 0xf9,
    // lowercase u, grave accent
    0xad: 0xdb,
    // uppercase U, circumflex
    0xae: 0xab,
    // left-pointing double angle quotation mark
    0xaf: 0xbb,
    // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    // Uppercase A, tilde
    0xb1: 0xe3,
    // Lowercase a, tilde
    0xb2: 0xcd,
    // Uppercase I, acute accent
    0xb3: 0xcc,
    // Uppercase I, grave accent
    0xb4: 0xec,
    // Lowercase i, grave accent
    0xb5: 0xd2,
    // Uppercase O, grave accent
    0xb6: 0xf2,
    // Lowercase o, grave accent
    0xb7: 0xd5,
    // Uppercase O, tilde
    0xb8: 0xf5,
    // Lowercase o, tilde
    0xb9: 0x7b,
    // Open curly brace
    0xba: 0x7d,
    // Closing curly brace
    0xbb: 0x5c,
    // Backslash
    0xbc: 0x5e,
    // Caret
    0xbd: 0x5f,
    // Underscore
    0xbe: 0x7c,
    // Pipe (vertical line)
    0xbf: 0x223c,
    // Tilde operator
    0xc0: 0xc4,
    // Uppercase A, umlaut
    0xc1: 0xe4,
    // Lowercase A, umlaut
    0xc2: 0xd6,
    // Uppercase O, umlaut
    0xc3: 0xf6,
    // Lowercase o, umlaut
    0xc4: 0xdf,
    // Esszett (sharp S)
    0xc5: 0xa5,
    // Yen symbol
    0xc6: 0xa4,
    // Generic currency sign
    0xc7: 0x2503,
    // Box drawings heavy vertical
    0xc8: 0xc5,
    // Uppercase A, ring
    0xc9: 0xe5,
    // Lowercase A, ring
    0xca: 0xd8,
    // Uppercase O, stroke
    0xcb: 0xf8,
    // Lowercase o, strok
    0xcc: 0x250f,
    // Box drawings heavy down and right
    0xcd: 0x2513,
    // Box drawings heavy down and left
    0xce: 0x2517,
    // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left

  };
  /**
   * Get Unicode Character from CEA-608 byte code
   */

  var getCharForByte = function getCharForByte(_byte) {
    var charCode = _byte;

    if (specialCea608CharsCodes.hasOwnProperty(_byte)) {
      charCode = specialCea608CharsCodes[_byte];
    }

    return String.fromCharCode(charCode);
  };

  var NR_ROWS = 15,
      NR_COLS = 32; // Tables to look up row from PAC data

  var rowsLowCh1 = {
    0x11: 1,
    0x12: 3,
    0x15: 5,
    0x16: 7,
    0x17: 9,
    0x10: 11,
    0x13: 12,
    0x14: 14
  };
  var rowsHighCh1 = {
    0x11: 2,
    0x12: 4,
    0x15: 6,
    0x16: 8,
    0x17: 10,
    0x13: 13,
    0x14: 15
  };
  var rowsLowCh2 = {
    0x19: 1,
    0x1A: 3,
    0x1D: 5,
    0x1E: 7,
    0x1F: 9,
    0x18: 11,
    0x1B: 12,
    0x1C: 14
  };
  var rowsHighCh2 = {
    0x19: 2,
    0x1A: 4,
    0x1D: 6,
    0x1E: 8,
    0x1F: 10,
    0x1B: 13,
    0x1C: 15
  };
  var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
  /**
   * Simple logger class to be able to write with time-stamps and filter on level.
   */

  var logger = {
    verboseFilter: {
      'DATA': 3,
      'DEBUG': 3,
      'INFO': 2,
      'WARNING': 2,
      'TEXT': 1,
      'ERROR': 0
    },
    time: null,
    verboseLevel: 0,
    // Only write errors
    setTime: function setTime(newTime) {
      this.time = newTime;
    },
    log: function log(severity, msg) {
      var minLevel = this.verboseFilter[severity];

      if (this.verboseLevel >= minLevel) {
        console.log(this.time + " [" + severity + "] " + msg);
      }
    }
  };

  var numArrayToHexArray = function numArrayToHexArray(numArray) {
    var hexArray = [];

    for (var j = 0; j < numArray.length; j++) {
      hexArray.push(numArray[j].toString(16));
    }

    return hexArray;
  };
  /**
   * State of CEA-608 pen or character
   * @constructor
   */


  var PenState = function PenState(foreground, underline, italics, background, flash) {
    this.foreground = foreground || "white";
    this.underline = underline || false;
    this.italics = italics || false;
    this.background = background || "black";
    this.flash = flash || false;
  };

  PenState.prototype = {
    reset: function reset() {
      this.foreground = "white";
      this.underline = false;
      this.italics = false;
      this.background = "black";
      this.flash = false;
    },
    setStyles: function setStyles(styles) {
      var attribs = ["foreground", "underline", "italics", "background", "flash"];

      for (var i = 0; i < attribs.length; i++) {
        var style = attribs[i];

        if (styles.hasOwnProperty(style)) {
          this[style] = styles[style];
        }
      }
    },
    isDefault: function isDefault() {
      return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
    },
    equals: function equals(other) {
      return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    },
    copy: function copy(newPenState) {
      this.foreground = newPenState.foreground;
      this.underline = newPenState.underline;
      this.italics = newPenState.italics;
      this.background = newPenState.background;
      this.flash = newPenState.flash;
    },
    toString: function toString() {
      return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
    }
  };
  /**
   * Unicode character with styling and background.
   * @constructor
   */

  var StyledUnicodeChar = function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
    this.uchar = uchar || ' '; // unicode character

    this.penState = new PenState(foreground, underline, italics, background, flash);
  };

  StyledUnicodeChar.prototype = {
    reset: function reset() {
      this.uchar = ' ';
      this.penState.reset();
    },
    setChar: function setChar(uchar, newPenState) {
      this.uchar = uchar;
      this.penState.copy(newPenState);
    },
    setPenState: function setPenState(newPenState) {
      this.penState.copy(newPenState);
    },
    equals: function equals(other) {
      return this.uchar === other.uchar && this.penState.equals(other.penState);
    },
    copy: function copy(newChar) {
      this.uchar = newChar.uchar;
      this.penState.copy(newChar.penState);
    },
    isEmpty: function isEmpty() {
      return this.uchar === ' ' && this.penState.isDefault();
    }
  };
  /**
   * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
   * @constructor
   */

  var Row = function Row() {
    this.chars = [];

    for (var i = 0; i < NR_COLS; i++) {
      this.chars.push(new StyledUnicodeChar());
    }

    this.pos = 0;
    this.currPenState = new PenState();
  };

  Row.prototype = {
    equals: function equals(other) {
      var equal = true;

      for (var i = 0; i < NR_COLS; i++) {
        if (!this.chars[i].equals(other.chars[i])) {
          equal = false;
          break;
        }
      }

      return equal;
    },
    copy: function copy(other) {
      for (var i = 0; i < NR_COLS; i++) {
        this.chars[i].copy(other.chars[i]);
      }
    },
    isEmpty: function isEmpty() {
      var empty = true;

      for (var i = 0; i < NR_COLS; i++) {
        if (!this.chars[i].isEmpty()) {
          empty = false;
          break;
        }
      }

      return empty;
    },

    /**
     *  Set the cursor to a valid column.
     */
    setCursor: function setCursor(absPos) {
      if (this.pos !== absPos) {
        this.pos = absPos;
      }

      if (this.pos < 0) {
        logger.log("ERROR", "Negative cursor position " + this.pos);
        this.pos = 0;
      } else if (this.pos > NR_COLS) {
        logger.log("ERROR", "Too large cursor position " + this.pos);
        this.pos = NR_COLS;
      }
    },

    /** 
     * Move the cursor relative to current position.
     */
    moveCursor: function moveCursor(relPos) {
      var newPos = this.pos + relPos;

      if (relPos > 1) {
        for (var i = this.pos + 1; i < newPos + 1; i++) {
          this.chars[i].setPenState(this.currPenState);
        }
      }

      this.setCursor(newPos);
    },

    /**
     * Backspace, move one step back and clear character.
     */
    backSpace: function backSpace() {
      this.moveCursor(-1);
      this.chars[this.pos].setChar(' ', this.currPenState);
    },
    insertChar: function insertChar(_byte2) {
      if (_byte2 >= 0x90) {
        //Extended char
        this.backSpace();
      }

      var _char = getCharForByte(_byte2);

      if (this.pos >= NR_COLS) {
        logger.log("ERROR", "Cannot insert " + _byte2.toString(16) + " (" + _char + ") at position " + this.pos + ". Skipping it!");
        return;
      }

      this.chars[this.pos].setChar(_char, this.currPenState);
      this.moveCursor(1);
    },
    clearFromPos: function clearFromPos(startPos) {
      var i;

      for (i = startPos; i < NR_COLS; i++) {
        this.chars[i].reset();
      }
    },
    clear: function clear() {
      this.clearFromPos(0);
      this.pos = 0;
      this.currPenState.reset();
    },
    clearToEndOfRow: function clearToEndOfRow() {
      this.clearFromPos(this.pos);
    },
    getTextString: function getTextString() {
      var chars = [];
      var empty = true;

      for (var i = 0; i < NR_COLS; i++) {
        var _char2 = this.chars[i].uchar;

        if (_char2 !== " ") {
          empty = false;
        }

        chars.push(_char2);
      }

      if (empty) {
        return "";
      } else {
        return chars.join("");
      }
    },
    setPenStyles: function setPenStyles(styles) {
      this.currPenState.setStyles(styles);
      var currChar = this.chars[this.pos];
      currChar.setPenState(this.currPenState);
    }
  };
  /**
   * Keep a CEA-608 screen of 32x15 styled characters
   * @constructor
  */

  var CaptionScreen = function CaptionScreen() {
    this.rows = [];

    for (var i = 0; i < NR_ROWS; i++) {
      this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
    }

    this.currRow = NR_ROWS - 1;
    this.nrRollUpRows = null;
    this.reset();
  };

  CaptionScreen.prototype = {
    reset: function reset() {
      for (var i = 0; i < NR_ROWS; i++) {
        this.rows[i].clear();
      }

      this.currRow = NR_ROWS - 1;
    },
    equals: function equals(other) {
      var equal = true;

      for (var i = 0; i < NR_ROWS; i++) {
        if (!this.rows[i].equals(other.rows[i])) {
          equal = false;
          break;
        }
      }

      return equal;
    },
    copy: function copy(other) {
      for (var i = 0; i < NR_ROWS; i++) {
        this.rows[i].copy(other.rows[i]);
      }
    },
    isEmpty: function isEmpty() {
      var empty = true;

      for (var i = 0; i < NR_ROWS; i++) {
        if (!this.rows[i].isEmpty()) {
          empty = false;
          break;
        }
      }

      return empty;
    },
    backSpace: function backSpace() {
      var row = this.rows[this.currRow];
      row.backSpace();
    },
    clearToEndOfRow: function clearToEndOfRow() {
      var row = this.rows[this.currRow];
      row.clearToEndOfRow();
    },

    /**
     * Insert a character (without styling) in the current row.
     */
    insertChar: function insertChar(_char3) {
      var row = this.rows[this.currRow];
      row.insertChar(_char3);
    },
    setPen: function setPen(styles) {
      var row = this.rows[this.currRow];
      row.setPenStyles(styles);
    },
    moveCursor: function moveCursor(relPos) {
      var row = this.rows[this.currRow];
      row.moveCursor(relPos);
    },
    setCursor: function setCursor(absPos) {
      logger.log("INFO", "setCursor: " + absPos);
      var row = this.rows[this.currRow];
      row.setCursor(absPos);
    },
    setPAC: function setPAC(pacData) {
      logger.log("INFO", "pacData = " + JSON.stringify(pacData));
      var newRow = pacData.row - 1;

      if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
        newRow = this.nrRollUpRows - 1;
      }

      this.currRow = newRow;
      var row = this.rows[this.currRow];

      if (pacData.indent !== null) {
        var indent = pacData.indent;
        var prevPos = Math.max(indent - 1, 0);
        row.setCursor(pacData.indent);
        pacData.color = row.chars[prevPos].penState.foreground;
      }

      var styles = {
        foreground: pacData.color,
        underline: pacData.underline,
        italics: pacData.italics,
        background: 'black',
        flash: false
      };
      this.setPen(styles);
    },

    /**
     * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
     */
    setBkgData: function setBkgData(bkgData) {
      logger.log("INFO", "bkgData = " + JSON.stringify(bkgData));
      this.backSpace();
      this.setPen(bkgData);
      this.insertChar(0x20); //Space
    },
    setRollUpRows: function setRollUpRows(nrRows) {
      this.nrRollUpRows = nrRows;
    },
    rollUp: function rollUp() {
      if (this.nrRollUpRows === null) {
        logger.log("DEBUG", "roll_up but nrRollUpRows not set yet");
        return; //Not properly setup
      }

      logger.log("TEXT", this.getDisplayText());
      var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
      var topRow = this.rows.splice(topRowIndex, 1)[0];
      topRow.clear();
      this.rows.splice(this.currRow, 0, topRow);
      logger.log("INFO", "Rolling up"); //logger.log("TEXT", this.get_display_text())
    },

    /**
     * Get all non-empty rows with as unicode text. 
     */
    getDisplayText: function getDisplayText(asOneRow) {
      asOneRow = asOneRow || false;
      var displayText = [];
      var text = "";
      var rowNr = -1;

      for (var i = 0; i < NR_ROWS; i++) {
        var rowText = this.rows[i].getTextString();

        if (rowText) {
          rowNr = i + 1;

          if (asOneRow) {
            displayText.push("Row " + rowNr + ': "' + rowText + '"');
          } else {
            displayText.push(rowText.trim());
          }
        }
      }

      if (displayText.length > 0) {
        if (asOneRow) {
          text = "[" + displayText.join(" | ") + "]";
        } else {
          text = displayText.join("\n");
        }
      }

      return text;
    },
    getTextAndFormat: function getTextAndFormat() {
      return this.rows;
    }
  };
  /**
   * Handle a CEA-608 channel and send decoded data to outputFilter
   * @constructor
   * @param {Number} channelNumber (1 or 2)
   * @param {CueHandler} outputFilter Output from channel1 newCue(startTime, endTime, captionScreen)
  */

  var Cea608Channel = function Cea608Channel(channelNumber, outputFilter) {
    this.chNr = channelNumber;
    this.outputFilter = outputFilter;
    this.mode = null;
    this.verbose = 0;
    this.displayedMemory = new CaptionScreen();
    this.nonDisplayedMemory = new CaptionScreen();
    this.lastOutputScreen = new CaptionScreen();
    this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
    this.writeScreen = this.displayedMemory;
    this.mode = null;
    this.cueStartTime = null; // Keeps track of where a cue started.
  };

  Cea608Channel.prototype = {
    modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"],
    reset: function reset() {
      this.mode = null;
      this.displayedMemory.reset();
      this.nonDisplayedMemory.reset();
      this.lastOutputScreen.reset();
      this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
      this.writeScreen = this.displayedMemory;
      this.mode = null;
      this.cueStartTime = null;
      this.lastCueEndTime = null;
    },
    getHandler: function getHandler() {
      return this.outputFilter;
    },
    setHandler: function setHandler(newHandler) {
      this.outputFilter = newHandler;
    },
    setPAC: function setPAC(pacData) {
      this.writeScreen.setPAC(pacData);
    },
    setBkgData: function setBkgData(bkgData) {
      this.writeScreen.setBkgData(bkgData);
    },
    setMode: function setMode(newMode) {
      if (newMode === this.mode) {
        return;
      }

      this.mode = newMode;
      logger.log("INFO", "MODE=" + newMode);

      if (this.mode == "MODE_POP-ON") {
        this.writeScreen = this.nonDisplayedMemory;
      } else {
        this.writeScreen = this.displayedMemory;
        this.writeScreen.reset();
      }

      if (this.mode !== "MODE_ROLL-UP") {
        this.displayedMemory.nrRollUpRows = null;
        this.nonDisplayedMemory.nrRollUpRows = null;
      }

      this.mode = newMode;
    },
    insertChars: function insertChars(chars) {
      for (var i = 0; i < chars.length; i++) {
        this.writeScreen.insertChar(chars[i]);
      }

      var screen = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
      logger.log("INFO", screen + ": " + this.writeScreen.getDisplayText(true));

      if (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") {
        logger.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(true));
        this.outputDataUpdate();
      }
    },
    cc_RCL: function cc_RCL() {
      // Resume Caption Loading (switch mode to Pop On)
      logger.log("INFO", "RCL - Resume Caption Loading");
      this.setMode("MODE_POP-ON");
    },
    cc_BS: function cc_BS() {
      // BackSpace
      logger.log("INFO", "BS - BackSpace");

      if (this.mode === "MODE_TEXT") {
        return;
      }

      this.writeScreen.backSpace();

      if (this.writeScreen === this.displayedMemory) {
        this.outputDataUpdate();
      }
    },
    cc_AOF: function cc_AOF() {
      // Reserved (formerly Alarm Off)
      return;
    },
    cc_AON: function cc_AON() {
      // Reserved (formerly Alarm On)
      return;
    },
    cc_DER: function cc_DER() {
      // Delete to End of Row
      logger.log("INFO", "DER- Delete to End of Row");
      this.writeScreen.clearToEndOfRow();
      this.outputDataUpdate();
    },
    cc_RU: function cc_RU(nrRows) {
      //Roll-Up Captions-2,3,or 4 Rows
      logger.log("INFO", "RU(" + nrRows + ") - Roll Up");
      this.writeScreen = this.displayedMemory;
      this.setMode("MODE_ROLL-UP");
      this.writeScreen.setRollUpRows(nrRows);
    },
    cc_FON: function cc_FON() {
      //Flash On
      logger.log("INFO", "FON - Flash On");
      this.writeScreen.setPen({
        flash: true
      });
    },
    cc_RDC: function cc_RDC() {
      // Resume Direct Captioning (switch mode to PaintOn)
      logger.log("INFO", "RDC - Resume Direct Captioning");
      this.setMode("MODE_PAINT-ON");
    },
    cc_TR: function cc_TR() {
      // Text Restart in text mode (not supported, however)
      logger.log("INFO", "TR");
      this.setMode("MODE_TEXT");
    },
    cc_RTD: function cc_RTD() {
      // Resume Text Display in Text mode (not supported, however)
      logger.log("INFO", "RTD");
      this.setMode("MODE_TEXT");
    },
    cc_EDM: function cc_EDM() {
      // Erase Displayed Memory
      logger.log("INFO", "EDM - Erase Displayed Memory");
      this.displayedMemory.reset();
      this.outputDataUpdate();
    },
    cc_CR: function cc_CR() {
      // Carriage Return
      logger.log("CR - Carriage Return");
      this.writeScreen.rollUp();
      this.outputDataUpdate();
    },
    cc_ENM: function cc_ENM() {
      //Erase Non-Displayed Memory
      logger.log("INFO", "ENM - Erase Non-displayed Memory");
      this.nonDisplayedMemory.reset();
    },
    cc_EOC: function cc_EOC() {
      //End of Caption (Flip Memories)
      logger.log("INFO", "EOC - End Of Caption");

      if (this.mode === "MODE_POP-ON") {
        var tmp = this.displayedMemory;
        this.displayedMemory = this.nonDisplayedMemory;
        this.nonDisplayedMemory = tmp;
        this.writeScreen = this.nonDisplayedMemory;
        logger.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
      }

      this.outputDataUpdate();
    },
    cc_TO: function cc_TO(nrCols) {
      // Tab Offset 1,2, or 3 columns
      logger.log("INFO", "TO(" + nrCols + ") - Tab Offset");
      this.writeScreen.moveCursor(nrCols);
    },
    cc_MIDROW: function cc_MIDROW(secondByte) {
      // Parse MIDROW command
      var styles = {
        flash: false
      };
      styles.underline = secondByte % 2 === 1;
      styles.italics = secondByte >= 0x2e;

      if (!styles.italics) {
        var colorIndex = Math.floor(secondByte / 2) - 0x10;
        var colors = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
        styles.foreground = colors[colorIndex];
      } else {
        styles.foreground = "white";
      }

      logger.log("INFO", "MIDROW: " + JSON.stringify(styles));
      this.writeScreen.setPen(styles);
    },
    outputDataUpdate: function outputDataUpdate() {
      var t = logger.time;

      if (t === null) {
        return;
      }

      if (this.outputFilter) {
        if (this.outputFilter.updateData) {
          this.outputFilter.updateData(t, this.displayedMemory);
        }

        if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
          // Start of a new cue
          this.cueStartTime = t;
        } else {
          if (!this.displayedMemory.equals(this.lastOutputScreen)) {
            if (this.outputFilter.newCue) {
              this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
            }

            this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
          }
        }

        this.lastOutputScreen.copy(this.displayedMemory);
      }
    },
    cueSplitAtTime: function cueSplitAtTime(t) {
      if (this.outputFilter) {
        if (!this.displayedMemory.isEmpty()) {
          if (this.outputFilter.newCue) {
            this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
          }

          this.cueStartTime = t;
        }
      }
    }
  };
  /**
   * Parse CEA-608 data and send decoded data to out1 and out2.
   * @constructor
   * @param {Number} field  CEA-608 field (1 or 2)
   * @param {CueHandler} out1 Output from channel1 newCue(startTime, endTime, captionScreen)
   * @param {CueHandler} out2 Output from channel2 newCue(startTime, endTime, captionScreen)
   */

  var Cea608Parser = function Cea608Parser(field, out1, out2) {
    this.field = field || 1;
    this.outputs = [out1, out2];
    this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
    this.currChNr = -1; // Will be 1 or 2

    this.lastCmdA = null; // First byte of last command

    this.lastCmdB = null; // Second byte of last command

    this.bufferedData = [];
    this.startTime = null;
    this.lastTime = null;
    this.dataCounters = {
      'padding': 0,
      'char': 0,
      'cmd': 0,
      'other': 0
    };
  };

  Cea608Parser.prototype = {
    getHandler: function getHandler(index) {
      return this.channels[index].getHandler();
    },
    setHandler: function setHandler(index, newHandler) {
      this.channels[index].setHandler(newHandler);
    },

    /**
     * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
     */
    addData: function addData(t, byteList) {
      var cmdFound,
          a,
          b,
          charsFound = false;
      this.lastTime = t;
      logger.setTime(t);

      for (var i = 0; i < byteList.length; i += 2) {
        a = byteList[i] & 0x7f;
        b = byteList[i + 1] & 0x7f;

        if (a >= 0x10 && a <= 0x1f && a === this.lastCmdA && b === this.lastCmdB) {
          this.lastCmdA = null;
          this.lastCmdB = null;
          logger.log("DEBUG", "Repeated command (" + numArrayToHexArray([a, b]) + ") is dropped");
          continue; // Repeated commands are dropped (once)
        }

        if (a === 0 && b === 0) {
          this.dataCounters.padding += 2;
          continue;
        } else {
          logger.log("DATA", "[" + numArrayToHexArray([byteList[i], byteList[i + 1]]) + "] -> (" + numArrayToHexArray([a, b]) + ")");
        }

        cmdFound = this.parseCmd(a, b);

        if (!cmdFound) {
          cmdFound = this.parseMidrow(a, b);
        }

        if (!cmdFound) {
          cmdFound = this.parsePAC(a, b);
        }

        if (!cmdFound) {
          cmdFound = this.parseBackgroundAttributes(a, b);
        }

        if (!cmdFound) {
          charsFound = this.parseChars(a, b);

          if (charsFound) {
            if (this.currChNr && this.currChNr >= 0) {
              var channel = this.channels[this.currChNr - 1];
              channel.insertChars(charsFound);
            } else {
              logger.log("WARNING", "No channel found yet. TEXT-MODE?");
            }
          }
        }

        if (cmdFound) {
          this.dataCounters.cmd += 2;
        } else if (charsFound) {
          this.dataCounters["char"] += 2;
        } else {
          this.dataCounters.other += 2;
          logger.log("WARNING", "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + " orig: " + numArrayToHexArray([byteList[i], byteList[i + 1]]));
        }
      }
    },

    /**
     * Parse Command.
     * @returns {Boolean} Tells if a command was found
     */
    parseCmd: function parseCmd(a, b) {
      var chNr = null;
      var cond1 = (a === 0x14 || a === 0x15 || a === 0x1C || a === 0x1D) && 0x20 <= b && b <= 0x2F;
      var cond2 = (a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;

      if (!(cond1 || cond2)) {
        return false;
      }

      if (a === 0x14 || a === 0x15 || a === 0x17) {
        chNr = 1;
      } else {
        chNr = 2; // (a === 0x1C || a === 0x1D || a=== 0x1f)
      }

      var channel = this.channels[chNr - 1];

      if (a === 0x14 || a === 0x15 || a === 0x1C || a === 0x1D) {
        if (b === 0x20) {
          channel.cc_RCL();
        } else if (b === 0x21) {
          channel.cc_BS();
        } else if (b === 0x22) {
          channel.cc_AOF();
        } else if (b === 0x23) {
          channel.cc_AON();
        } else if (b === 0x24) {
          channel.cc_DER();
        } else if (b === 0x25) {
          channel.cc_RU(2);
        } else if (b === 0x26) {
          channel.cc_RU(3);
        } else if (b === 0x27) {
          channel.cc_RU(4);
        } else if (b === 0x28) {
          channel.cc_FON();
        } else if (b === 0x29) {
          channel.cc_RDC();
        } else if (b === 0x2A) {
          channel.cc_TR();
        } else if (b === 0x2B) {
          channel.cc_RTD();
        } else if (b === 0x2C) {
          channel.cc_EDM();
        } else if (b === 0x2D) {
          channel.cc_CR();
        } else if (b === 0x2E) {
          channel.cc_ENM();
        } else if (b === 0x2F) {
          channel.cc_EOC();
        }
      } else {
        //a == 0x17 || a == 0x1F
        channel.cc_TO(b - 0x20);
      }

      this.lastCmdA = a;
      this.lastCmdB = b;
      this.currChNr = chNr;
      return true;
    },

    /**
     * Parse midrow styling command
     * @returns {Boolean}
     */
    parseMidrow: function parseMidrow(a, b) {
      var chNr = null;

      if ((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f) {
        if (a === 0x11) {
          chNr = 1;
        } else {
          chNr = 2;
        }

        if (chNr !== this.currChNr) {
          logger.log("ERROR", "Mismatch channel in midrow parsing");
          return false;
        }

        var channel = this.channels[chNr - 1]; // cea608 spec says midrow codes should inject a space

        channel.insertChars([0x20]);
        channel.cc_MIDROW(b);
        logger.log("DEBUG", "MIDROW (" + numArrayToHexArray([a, b]) + ")");
        this.lastCmdA = a;
        this.lastCmdB = b;
        return true;
      }

      return false;
    },

    /**
     * Parse Preable Access Codes (Table 53).
     * @returns {Boolean} Tells if PAC found
     */
    parsePAC: function parsePAC(a, b) {
      var chNr = null;
      var row = null;
      var case1 = (0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;
      var case2 = (a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;

      if (!(case1 || case2)) {
        return false;
      }

      chNr = a <= 0x17 ? 1 : 2;

      if (0x40 <= b && b <= 0x5F) {
        row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
      } else {
        // 0x60 <= b <= 0x7F
        row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
      }

      var pacData = this.interpretPAC(row, b);
      var channel = this.channels[chNr - 1];
      channel.setPAC(pacData);
      this.lastCmdA = a;
      this.lastCmdB = b;
      this.currChNr = chNr;
      return true;
    },

    /**
     * Interpret the second byte of the pac, and return the information.
     * @returns {Object} pacData with style parameters.
     */
    interpretPAC: function interpretPAC(row, _byte3) {
      var pacIndex = _byte3;
      var pacData = {
        color: null,
        italics: false,
        indent: null,
        underline: false,
        row: row
      };

      if (_byte3 > 0x5F) {
        pacIndex = _byte3 - 0x60;
      } else {
        pacIndex = _byte3 - 0x40;
      }

      pacData.underline = (pacIndex & 1) === 1;

      if (pacIndex <= 0xd) {
        pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
      } else if (pacIndex <= 0xf) {
        pacData.italics = true;
        pacData.color = 'white';
      } else {
        pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
      }

      return pacData; // Note that row has zero offset. The spec uses 1.
    },

    /**
     * Parse characters.
     * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
     */
    parseChars: function parseChars(a, b) {
      var channelNr = null,
          charCodes = null,
          charCode1 = null,
          charCode2 = null;

      if (a >= 0x19) {
        channelNr = 2;
        charCode1 = a - 8;
      } else {
        channelNr = 1;
        charCode1 = a;
      }

      if (0x11 <= charCode1 && charCode1 <= 0x13) {
        // Special character
        var oneCode = b;

        if (charCode1 === 0x11) {
          oneCode = b + 0x50;
        } else if (charCode1 === 0x12) {
          oneCode = b + 0x70;
        } else {
          oneCode = b + 0x90;
        }

        logger.log("INFO", "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
        charCodes = [oneCode];
        this.lastCmdA = a;
        this.lastCmdB = b;
      } else if (0x20 <= a && a <= 0x7f) {
        charCodes = b === 0 ? [a] : [a, b];
        this.lastCmdA = null;
        this.lastCmdB = null;
      }

      if (charCodes) {
        var hexCodes = numArrayToHexArray(charCodes);
        logger.log("DEBUG", "Char codes =  " + hexCodes.join(","));
      }

      return charCodes;
    },

    /**
    * Parse extended background attributes as well as new foreground color black.
    * @returns{Boolean} Tells if background attributes are found
    */
    parseBackgroundAttributes: function parseBackgroundAttributes(a, b) {
      var bkgData, index, chNr, channel;
      var case1 = (a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;
      var case2 = (a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;

      if (!(case1 || case2)) {
        return false;
      }

      bkgData = {};

      if (a === 0x10 || a === 0x18) {
        index = Math.floor((b - 0x20) / 2);
        bkgData.background = backgroundColors[index];

        if (b % 2 === 1) {
          bkgData.background = bkgData.background + "_semi";
        }
      } else if (b === 0x2d) {
        bkgData.background = "transparent";
      } else {
        bkgData.foreground = "black";

        if (b === 0x2f) {
          bkgData.underline = true;
        }
      }

      chNr = a < 0x18 ? 1 : 2;
      channel = this.channels[chNr - 1];
      channel.setBkgData(bkgData);
      this.lastCmdA = a;
      this.lastCmdB = b;
      return true;
    },

    /**
     * Reset state of parser and its channels.
     */
    reset: function reset() {
      for (var i = 0; i < this.channels.length; i++) {
        if (this.channels[i]) {
          this.channels[i].reset();
        }
      }

      this.lastCmdA = null;
      this.lastCmdB = null;
    },

    /**
     * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
     */
    cueSplitAtTime: function cueSplitAtTime(t) {
      for (var i = 0; i < this.channels.length; i++) {
        if (this.channels[i]) {
          this.channels[i].cueSplitAtTime(t);
        }
      }
    }
  };
  /**
   * Find ranges corresponding to SEA CEA-608 NALUS in sizeprepended NALU array.
   * @param {raw} dataView of binary data
   * @param {startPos} start position in raw
   * @param {size} total size of data in raw to consider
   * @returns 
   */

  var findCea608Nalus = function findCea608Nalus(raw, startPos, size) {
    var nalSize = 0,
        cursor = startPos,
        nalType = 0,
        cea608NaluRanges = [],
        // Check SEI data according to ANSI-SCTE 128
    isCEA608SEI = function isCEA608SEI(payloadType, payloadSize, raw, pos) {
      if (payloadType !== 4 || payloadSize < 8) {
        return null;
      }

      var countryCode = raw.getUint8(pos);
      var providerCode = raw.getUint16(pos + 1);
      var userIdentifier = raw.getUint32(pos + 3);
      var userDataTypeCode = raw.getUint8(pos + 7);
      return countryCode == 0xB5 && providerCode == 0x31 && userIdentifier == 0x47413934 && userDataTypeCode == 0x3;
    };

    while (cursor < startPos + size) {
      nalSize = raw.getUint32(cursor);
      nalType = raw.getUint8(cursor + 4) & 0x1F; //console.log(time + "  NAL " + nalType);

      if (nalType === 6) {
        // SEI NAL Unit. The NAL header is the first byte
        //console.log("SEI NALU of size " + nalSize + " at time " + time);
        var pos = cursor + 5;
        var payloadType = -1;

        while (pos < cursor + 4 + nalSize - 1) {
          // The last byte should be rbsp_trailing_bits
          payloadType = 0;
          var b = 0xFF;

          while (b === 0xFF) {
            b = raw.getUint8(pos);
            payloadType += b;
            pos++;
          }

          var payloadSize = 0;
          b = 0xFF;

          while (b === 0xFF) {
            b = raw.getUint8(pos);
            payloadSize += b;
            pos++;
          }

          if (isCEA608SEI(payloadType, payloadSize, raw, pos)) {
            //console.log("CEA608 SEI " + time + " " + payloadSize);
            cea608NaluRanges.push([pos, payloadSize]);
          }

          pos += payloadSize;
        }
      }

      cursor += nalSize + 4;
    }

    return cea608NaluRanges;
  };

  var extractCea608DataFromRange = function extractCea608DataFromRange(raw, cea608Range) {
    var pos = cea608Range[0];
    var fieldData = [[], []];
    pos += 8; // Skip the identifier up to userDataTypeCode

    var ccCount = raw.getUint8(pos) & 0x1f;
    pos += 2; // Advance 1 and skip reserved byte

    for (var i = 0; i < ccCount; i++) {
      var _byte4 = raw.getUint8(pos);

      var ccValid = _byte4 & 0x4;
      var ccType = _byte4 & 0x3;
      pos++;
      var ccData1 = raw.getUint8(pos); // Keep parity bit

      pos++;
      var ccData2 = raw.getUint8(pos); // Keep parity bit

      pos++;

      if (ccValid && (ccData1 & 0x7f) + (ccData2 & 0x7f) !== 0) {
        //Check validity and non-empty data
        if (ccType === 0) {
          fieldData[0].push(ccData1);
          fieldData[0].push(ccData2);
        } else if (ccType === 1) {
          fieldData[1].push(ccData1);
          fieldData[1].push(ccData2);
        }
      }
    }

    return fieldData;
  };

  exports.logger = logger;
  exports.PenState = PenState;
  exports.CaptionScreen = CaptionScreen;
  exports.Cea608Parser = Cea608Parser;
  exports.findCea608Nalus = findCea608Nalus;
  exports.extractCea608DataFromRange = extractCea608DataFromRange;
})(  false ? 0 : exports);

/***/ }),

/***/ "./externals/xml2json.js":
/*!*******************************!*\
  !*** ./externals/xml2json.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_51384__) {

"use strict";
__nested_webpack_require_51384__.r(__webpack_exports__);
/*
 Copyright 2011-2013 Abdulla Abdurakhmanov
 Original sources are available at https://code.google.com/p/x2js/

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/*
  Further modified for dashjs to:
  - keep track of children nodes in order in attribute __children.
  - add type conversion matchers
  - re-add ignoreRoot
  - allow zero-length attributePrefix
  - don't add white-space text nodes
  - remove explicit RequireJS support
*/
function X2JS(config) {
  'use strict';

  var VERSION = "1.2.0";
  config = config || {};
  initConfigDefaults();
  initRequiredPolyfills();

  function initConfigDefaults() {
    if (config.escapeMode === undefined) {
      config.escapeMode = true;
    }

    if (config.attributePrefix === undefined) {
      config.attributePrefix = "_";
    }

    config.arrayAccessForm = config.arrayAccessForm || "none";
    config.emptyNodeForm = config.emptyNodeForm || "text";

    if (config.enableToStringFunc === undefined) {
      config.enableToStringFunc = true;
    }

    config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];

    if (config.skipEmptyTextNodesForObj === undefined) {
      config.skipEmptyTextNodesForObj = true;
    }

    if (config.stripWhitespaces === undefined) {
      config.stripWhitespaces = true;
    }

    config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];

    if (config.useDoubleQuotes === undefined) {
      config.useDoubleQuotes = false;
    }

    config.xmlElementsFilter = config.xmlElementsFilter || [];
    config.jsonPropertiesFilter = config.jsonPropertiesFilter || [];

    if (config.keepCData === undefined) {
      config.keepCData = false;
    }

    if (config.ignoreRoot === undefined) {
      config.ignoreRoot = false;
    }
  }

  var DOMNodeTypes = {
    ELEMENT_NODE: 1,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9
  };

  function initRequiredPolyfills() {}

  function getNodeLocalName(node) {
    var nodeLocalName = node.localName;
    if (nodeLocalName == null) // Yeah, this is IE!!
      nodeLocalName = node.baseName;
    if (nodeLocalName == null || nodeLocalName == "") // =="" is IE too
      nodeLocalName = node.nodeName;
    return nodeLocalName;
  }

  function getNodePrefix(node) {
    return node.prefix;
  }

  function escapeXmlChars(str) {
    if (typeof str == "string") return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');else return str;
  }

  function unescapeXmlChars(str) {
    return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');
  }

  function checkInStdFiltersArrayForm(stdFiltersArrayForm, obj, name, path) {
    var idx = 0;

    for (; idx < stdFiltersArrayForm.length; idx++) {
      var filterPath = stdFiltersArrayForm[idx];

      if (typeof filterPath === "string") {
        if (filterPath == path) break;
      } else if (filterPath instanceof RegExp) {
        if (filterPath.test(path)) break;
      } else if (typeof filterPath === "function") {
        if (filterPath(obj, name, path)) break;
      }
    }

    return idx != stdFiltersArrayForm.length;
  }

  function toArrayAccessForm(obj, childName, path) {
    switch (config.arrayAccessForm) {
      case "property":
        if (!(obj[childName] instanceof Array)) obj[childName + "_asArray"] = [obj[childName]];else obj[childName + "_asArray"] = obj[childName];
        break;

      /*case "none":
          break;*/
    }

    if (!(obj[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {
      if (checkInStdFiltersArrayForm(config.arrayAccessFormPaths, obj, childName, path)) {
        obj[childName] = [obj[childName]];
      }
    }
  }

  function fromXmlDateTime(prop) {
    // Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object
    // Improved to support full spec and optional parts
    var bits = prop.split(/[-T:+Z]/g);
    var d = new Date(bits[0], bits[1] - 1, bits[2]);
    var secondBits = bits[5].split("\.");
    d.setHours(bits[3], bits[4], secondBits[0]);
    if (secondBits.length > 1) d.setMilliseconds(secondBits[1]); // Get supplied time zone offset in minutes

    if (bits[6] && bits[7]) {
      var offsetMinutes = bits[6] * 60 + Number(bits[7]);
      var sign = /\d\d-\d\d:\d\d$/.test(prop) ? '-' : '+'; // Apply the sign

      offsetMinutes = 0 + (sign == '-' ? -1 * offsetMinutes : offsetMinutes); // Apply offset and local timezone

      d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());
    } else if (prop.indexOf("Z", prop.length - 1) !== -1) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
    } // d is now a local time equivalent to the supplied time


    return d;
  }

  function checkFromXmlDateTimePaths(value, childName, fullPath) {
    if (config.datetimeAccessFormPaths.length > 0) {
      var path = fullPath.split("\.#")[0];

      if (checkInStdFiltersArrayForm(config.datetimeAccessFormPaths, value, childName, path)) {
        return fromXmlDateTime(value);
      } else return value;
    } else return value;
  }

  function checkXmlElementsFilter(obj, childType, childName, childPath) {
    if (childType == DOMNodeTypes.ELEMENT_NODE && config.xmlElementsFilter.length > 0) {
      return checkInStdFiltersArrayForm(config.xmlElementsFilter, obj, childName, childPath);
    } else return true;
  }

  function parseDOMChildren(node, path) {
    if (node.nodeType == DOMNodeTypes.DOCUMENT_NODE) {
      var result = new Object();
      var nodeChildren = node.childNodes; // Alternative for firstElementChild which is not supported in some environments

      for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
        var child = nodeChildren[cidx];

        if (child.nodeType == DOMNodeTypes.ELEMENT_NODE) {
          if (config.ignoreRoot) {
            result = parseDOMChildren(child);
          } else {
            result = {};
            var childName = getNodeLocalName(child);
            result[childName] = parseDOMChildren(child);
          }
        }
      }

      return result;
    } else if (node.nodeType == DOMNodeTypes.ELEMENT_NODE) {
      var result = new Object();
      result.__cnt = 0;
      var children = [];
      var nodeChildren = node.childNodes; // Children nodes

      for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
        var child = nodeChildren[cidx];
        var childName = getNodeLocalName(child);

        if (child.nodeType != DOMNodeTypes.COMMENT_NODE) {
          var childPath = path + "." + childName;

          if (checkXmlElementsFilter(result, child.nodeType, childName, childPath)) {
            result.__cnt++;

            if (result[childName] == null) {
              var c = parseDOMChildren(child, childPath);

              if (childName != "#text" || /[^\s]/.test(c)) {
                var o = {};
                o[childName] = c;
                children.push(o);
              }

              result[childName] = c;
              toArrayAccessForm(result, childName, childPath);
            } else {
              if (result[childName] != null) {
                if (!(result[childName] instanceof Array)) {
                  result[childName] = [result[childName]];
                  toArrayAccessForm(result, childName, childPath);
                }
              }

              var c = parseDOMChildren(child, childPath);

              if (childName != "#text" || /[^\s]/.test(c)) {
                // Don't add white-space text nodes
                var o = {};
                o[childName] = c;
                children.push(o);
              }

              result[childName][result[childName].length] = c;
            }
          }
        }
      }

      result.__children = children; // Attributes

      var nodeLocalName = getNodeLocalName(node);

      for (var aidx = 0; aidx < node.attributes.length; aidx++) {
        var attr = node.attributes[aidx];
        result.__cnt++;
        var value2 = attr.value;

        for (var m = 0, ml = config.matchers.length; m < ml; m++) {
          var matchobj = config.matchers[m];
          if (matchobj.test(attr, nodeLocalName)) value2 = matchobj.converter(attr.value);
        }

        result[config.attributePrefix + attr.name] = value2;
      } // Node namespace prefix


      var nodePrefix = getNodePrefix(node);

      if (nodePrefix != null && nodePrefix != "") {
        result.__cnt++;
        result.__prefix = nodePrefix;
      }

      if (result["#text"] != null) {
        result.__text = result["#text"];

        if (result.__text instanceof Array) {
          result.__text = result.__text.join("\n");
        } //if(config.escapeMode)
        //	result.__text = unescapeXmlChars(result.__text);


        if (config.stripWhitespaces) result.__text = result.__text.trim();
        delete result["#text"];
        if (config.arrayAccessForm == "property") delete result["#text_asArray"];
        result.__text = checkFromXmlDateTimePaths(result.__text, childName, path + "." + childName);
      }

      if (result["#cdata-section"] != null) {
        result.__cdata = result["#cdata-section"];
        delete result["#cdata-section"];
        if (config.arrayAccessForm == "property") delete result["#cdata-section_asArray"];
      }

      if (result.__cnt == 0 && config.emptyNodeForm == "text") {
        result = '';
      } else if (result.__cnt == 1 && result.__text != null) {
        result = result.__text;
      } else if (result.__cnt == 1 && result.__cdata != null && !config.keepCData) {
        result = result.__cdata;
      } else if (result.__cnt > 1 && result.__text != null && config.skipEmptyTextNodesForObj) {
        if (config.stripWhitespaces && result.__text == "" || result.__text.trim() == "") {
          delete result.__text;
        }
      }

      delete result.__cnt;

      if (config.enableToStringFunc && (result.__text != null || result.__cdata != null)) {
        result.toString = function () {
          return (this.__text != null ? this.__text : '') + (this.__cdata != null ? this.__cdata : '');
        };
      }

      return result;
    } else if (node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE) {
      return node.nodeValue;
    }
  }

  function startTag(jsonObj, element, attrList, closed) {
    var resultStr = "<" + (jsonObj != null && jsonObj.__prefix != null ? jsonObj.__prefix + ":" : "") + element;

    if (attrList != null) {
      for (var aidx = 0; aidx < attrList.length; aidx++) {
        var attrName = attrList[aidx];
        var attrVal = jsonObj[attrName];
        if (config.escapeMode) attrVal = escapeXmlChars(attrVal);
        resultStr += " " + attrName.substr(config.attributePrefix.length) + "=";
        if (config.useDoubleQuotes) resultStr += '"' + attrVal + '"';else resultStr += "'" + attrVal + "'";
      }
    }

    if (!closed) resultStr += ">";else resultStr += "/>";
    return resultStr;
  }

  function endTag(jsonObj, elementName) {
    return "</" + (jsonObj.__prefix != null ? jsonObj.__prefix + ":" : "") + elementName + ">";
  }

  function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  function jsonXmlSpecialElem(jsonObj, jsonObjField) {
    if (config.arrayAccessForm == "property" && endsWith(jsonObjField.toString(), "_asArray") || jsonObjField.toString().indexOf(config.attributePrefix) == 0 || jsonObjField.toString().indexOf("__") == 0 || jsonObj[jsonObjField] instanceof Function) return true;else return false;
  }

  function jsonXmlElemCount(jsonObj) {
    var elementsCnt = 0;

    if (jsonObj instanceof Object) {
      for (var it in jsonObj) {
        if (jsonXmlSpecialElem(jsonObj, it)) continue;
        elementsCnt++;
      }
    }

    return elementsCnt;
  }

  function checkJsonObjPropertiesFilter(jsonObj, propertyName, jsonObjPath) {
    return config.jsonPropertiesFilter.length == 0 || jsonObjPath == "" || checkInStdFiltersArrayForm(config.jsonPropertiesFilter, jsonObj, propertyName, jsonObjPath);
  }

  function parseJSONAttributes(jsonObj) {
    var attrList = [];

    if (jsonObj instanceof Object) {
      for (var ait in jsonObj) {
        if (ait.toString().indexOf("__") == -1 && ait.toString().indexOf(config.attributePrefix) == 0) {
          attrList.push(ait);
        }
      }
    }

    return attrList;
  }

  function parseJSONTextAttrs(jsonTxtObj) {
    var result = "";

    if (jsonTxtObj.__cdata != null) {
      result += "<![CDATA[" + jsonTxtObj.__cdata + "]]>";
    }

    if (jsonTxtObj.__text != null) {
      if (config.escapeMode) result += escapeXmlChars(jsonTxtObj.__text);else result += jsonTxtObj.__text;
    }

    return result;
  }

  function parseJSONTextObject(jsonTxtObj) {
    var result = "";

    if (jsonTxtObj instanceof Object) {
      result += parseJSONTextAttrs(jsonTxtObj);
    } else if (jsonTxtObj != null) {
      if (config.escapeMode) result += escapeXmlChars(jsonTxtObj);else result += jsonTxtObj;
    }

    return result;
  }

  function getJsonPropertyPath(jsonObjPath, jsonPropName) {
    if (jsonObjPath === "") {
      return jsonPropName;
    } else return jsonObjPath + "." + jsonPropName;
  }

  function parseJSONArray(jsonArrRoot, jsonArrObj, attrList, jsonObjPath) {
    var result = "";

    if (jsonArrRoot.length == 0) {
      result += startTag(jsonArrRoot, jsonArrObj, attrList, true);
    } else {
      for (var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
        result += startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
        result += parseJSONObject(jsonArrRoot[arIdx], getJsonPropertyPath(jsonObjPath, jsonArrObj));
        result += endTag(jsonArrRoot[arIdx], jsonArrObj);
      }
    }

    return result;
  }

  function parseJSONObject(jsonObj, jsonObjPath) {
    var result = "";
    var elementsCnt = jsonXmlElemCount(jsonObj);

    if (elementsCnt > 0) {
      for (var it in jsonObj) {
        if (jsonXmlSpecialElem(jsonObj, it) || jsonObjPath != "" && !checkJsonObjPropertiesFilter(jsonObj, it, getJsonPropertyPath(jsonObjPath, it))) continue;
        var subObj = jsonObj[it];
        var attrList = parseJSONAttributes(subObj);

        if (subObj == null || subObj == undefined) {
          result += startTag(subObj, it, attrList, true);
        } else if (subObj instanceof Object) {
          if (subObj instanceof Array) {
            result += parseJSONArray(subObj, it, attrList, jsonObjPath);
          } else if (subObj instanceof Date) {
            result += startTag(subObj, it, attrList, false);
            result += subObj.toISOString();
            result += endTag(subObj, it);
          } else {
            var subObjElementsCnt = jsonXmlElemCount(subObj);

            if (subObjElementsCnt > 0 || subObj.__text != null || subObj.__cdata != null) {
              result += startTag(subObj, it, attrList, false);
              result += parseJSONObject(subObj, getJsonPropertyPath(jsonObjPath, it));
              result += endTag(subObj, it);
            } else {
              result += startTag(subObj, it, attrList, true);
            }
          }
        } else {
          result += startTag(subObj, it, attrList, false);
          result += parseJSONTextObject(subObj);
          result += endTag(subObj, it);
        }
      }
    }

    result += parseJSONTextObject(jsonObj);
    return result;
  }

  this.parseXmlString = function (xmlDocStr) {
    var isIEParser = window.ActiveXObject || "ActiveXObject" in window;

    if (xmlDocStr === undefined) {
      return null;
    }

    var xmlDoc;

    if (window.DOMParser) {
      var parser = new window.DOMParser();
      var parsererrorNS = null;

      try {
        xmlDoc = parser.parseFromString(xmlDocStr, "text/xml");

        if (xmlDoc.getElementsByTagNameNS("*", "parsererror").length > 0) {
          xmlDoc = null;
        }
      } catch (err) {
        xmlDoc = null;
      }
    } else {
      // IE :(
      if (xmlDocStr.indexOf("<?") == 0) {
        xmlDocStr = xmlDocStr.substr(xmlDocStr.indexOf("?>") + 2);
      }

      xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
      xmlDoc.async = "false";
      xmlDoc.loadXML(xmlDocStr);
    }

    return xmlDoc;
  };

  this.asArray = function (prop) {
    if (prop === undefined || prop == null) return [];else if (prop instanceof Array) return prop;else return [prop];
  };

  this.toXmlDateTime = function (dt) {
    if (dt instanceof Date) return dt.toISOString();else if (typeof dt === 'number') return new Date(dt).toISOString();else return null;
  };

  this.asDateTime = function (prop) {
    if (typeof prop == "string") {
      return fromXmlDateTime(prop);
    } else return prop;
  };

  this.xml2json = function (xmlDoc) {
    return parseDOMChildren(xmlDoc);
  };

  this.xml_str2json = function (xmlDocStr) {
    var xmlDoc = this.parseXmlString(xmlDocStr);
    if (xmlDoc != null) return this.xml2json(xmlDoc);else return null;
  };

  this.json2xml_str = function (jsonObj) {
    return parseJSONObject(jsonObj, "");
  };

  this.json2xml = function (jsonObj) {
    var xmlDocStr = this.json2xml_str(jsonObj);
    return this.parseXmlString(xmlDocStr);
  };

  this.getVersion = function () {
    return VERSION;
  };
}

/* harmony default export */ __webpack_exports__["default"] = (X2JS);

/***/ }),

/***/ "./index.js":
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! exports provided: default, MediaPlayer, Protection, MetricsReporting, MediaPlayerFactory, Debug, supportsMediaSource */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_70341__) {

"use strict";
__nested_webpack_require_70341__.r(__webpack_exports__);
/* harmony import */ var _index_mediaplayerOnly__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_70341__(/*! ./index_mediaplayerOnly */ "./index_mediaplayerOnly.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "MediaPlayer", function() { return _index_mediaplayerOnly__WEBPACK_IMPORTED_MODULE_0__["MediaPlayer"]; });

/* harmony import */ var _src_streaming_utils_Capabilities__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_70341__(/*! ./src/streaming/utils/Capabilities */ "./src/streaming/utils/Capabilities.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "supportsMediaSource", function() { return _src_streaming_utils_Capabilities__WEBPACK_IMPORTED_MODULE_1__["supportsMediaSource"]; });

/* harmony import */ var _src_streaming_metrics_MetricsReporting__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_70341__(/*! ./src/streaming/metrics/MetricsReporting */ "./src/streaming/metrics/MetricsReporting.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "MetricsReporting", function() { return _src_streaming_metrics_MetricsReporting__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _src_streaming_protection_Protection__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_70341__(/*! ./src/streaming/protection/Protection */ "./src/streaming/protection/Protection.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "Protection", function() { return _src_streaming_protection_Protection__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _src_streaming_MediaPlayerFactory__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_70341__(/*! ./src/streaming/MediaPlayerFactory */ "./src/streaming/MediaPlayerFactory.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "MediaPlayerFactory", function() { return _src_streaming_MediaPlayerFactory__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _src_core_Debug__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_70341__(/*! ./src/core/Debug */ "./src/core/Debug.js");
/* harmony reexport (safe) */ __nested_webpack_require_70341__.d(__webpack_exports__, "Debug", function() { return _src_core_Debug__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






dashjs.Protection = _src_streaming_protection_Protection__WEBPACK_IMPORTED_MODULE_3__["default"];
dashjs.MetricsReporting = _src_streaming_metrics_MetricsReporting__WEBPACK_IMPORTED_MODULE_2__["default"];
dashjs.MediaPlayerFactory = _src_streaming_MediaPlayerFactory__WEBPACK_IMPORTED_MODULE_4__["default"];
dashjs.Debug = _src_core_Debug__WEBPACK_IMPORTED_MODULE_5__["default"];
dashjs.supportsMediaSource = _src_streaming_utils_Capabilities__WEBPACK_IMPORTED_MODULE_1__["supportsMediaSource"];
/* harmony default export */ __webpack_exports__["default"] = (dashjs);


/***/ }),

/***/ "./index_mediaplayerOnly.js":
/*!**********************************!*\
  !*** ./index_mediaplayerOnly.js ***!
  \**********************************/
/*! exports provided: default, MediaPlayer, FactoryMaker, Debug */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_75425__) {

"use strict";
__nested_webpack_require_75425__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _src_streaming_MediaPlayer__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_75425__(/*! ./src/streaming/MediaPlayer */ "./src/streaming/MediaPlayer.js");
/* harmony reexport (safe) */ __nested_webpack_require_75425__.d(__webpack_exports__, "MediaPlayer", function() { return _src_streaming_MediaPlayer__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _src_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_75425__(/*! ./src/core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony reexport (safe) */ __nested_webpack_require_75425__.d(__webpack_exports__, "FactoryMaker", function() { return _src_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _src_core_Debug__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_75425__(/*! ./src/core/Debug */ "./src/core/Debug.js");
/* harmony reexport (safe) */ __nested_webpack_require_75425__.d(__webpack_exports__, "Debug", function() { return _src_core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _src_core_Version__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_75425__(/*! ./src/core/Version */ "./src/core/Version.js");
/* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_75425__(/*! es6-promise/auto */ "./node_modules/es6-promise/auto.js");
/* harmony import */ var es6_promise_auto__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__nested_webpack_require_75425__.n(es6_promise_auto__WEBPACK_IMPORTED_MODULE_4__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




 // Shove both of these into the global scope

var context = typeof window !== 'undefined' && window || global;
var dashjs = context.dashjs;

if (!dashjs) {
  dashjs = context.dashjs = {};
}

dashjs.MediaPlayer = _src_streaming_MediaPlayer__WEBPACK_IMPORTED_MODULE_0__["default"];
dashjs.FactoryMaker = _src_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"];
dashjs.Debug = _src_core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"];
dashjs.Version = Object(_src_core_Version__WEBPACK_IMPORTED_MODULE_3__["getVersionString"])();
/* harmony default export */ __webpack_exports__["default"] = (dashjs);

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_75425__(/*! ./node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/codem-isoboxer/dist/iso_boxer.js":
/*!*******************************************************!*\
  !*** ./node_modules/codem-isoboxer/dist/iso_boxer.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! codem-isoboxer v0.3.6 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
var ISOBoxer = {};

ISOBoxer.parseBuffer = function(arrayBuffer) {
  return new ISOFile(arrayBuffer).parse();
};

ISOBoxer.addBoxProcessor = function(type, parser) {
  if (typeof type !== 'string' || typeof parser !== 'function') {
    return;
  }
  ISOBox.prototype._boxProcessors[type] = parser;
};

ISOBoxer.createFile = function() {
  return new ISOFile();
};

// See ISOBoxer.append() for 'pos' parameter syntax
ISOBoxer.createBox = function(type, parent, pos) {
  var newBox = ISOBox.create(type);
  if (parent) {
    parent.append(newBox, pos);
  }
  return newBox;
};

// See ISOBoxer.append() for 'pos' parameter syntax
ISOBoxer.createFullBox = function(type, parent, pos) {
  var newBox = ISOBoxer.createBox(type, parent, pos);
  newBox.version = 0;
  newBox.flags = 0;
  return newBox;
};

ISOBoxer.Utils = {};
ISOBoxer.Utils.dataViewToString = function(dataView, encoding) {
  var impliedEncoding = encoding || 'utf-8';
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder(impliedEncoding).decode(dataView);
  }
  var a = [];
  var i = 0;

  if (impliedEncoding === 'utf-8') {
    /* The following algorithm is essentially a rewrite of the UTF8.decode at
    http://bannister.us/weblog/2007/simple-base64-encodedecode-javascript/
    */

    while (i < dataView.byteLength) {
      var c = dataView.getUint8(i++);
      if (c < 0x80) {
        // 1-byte character (7 bits)
      } else if (c < 0xe0) {
        // 2-byte character (11 bits)
        c = (c & 0x1f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      } else if (c < 0xf0) {
        // 3-byte character (16 bits)
        c = (c & 0xf) << 12;
        c |= (dataView.getUint8(i++) & 0x3f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      } else {
        // 4-byte character (21 bits)
        c = (c & 0x7) << 18;
        c |= (dataView.getUint8(i++) & 0x3f) << 12;
        c |= (dataView.getUint8(i++) & 0x3f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      }
      a.push(String.fromCharCode(c));
    }
  } else { // Just map byte-by-byte (probably wrong)
    while (i < dataView.byteLength) {
      a.push(String.fromCharCode(dataView.getUint8(i++)));
    }
  }
  return a.join('');
};

ISOBoxer.Utils.utf8ToByteArray = function(string) {
  // Only UTF-8 encoding is supported by TextEncoder
  var u, i;
  if (typeof TextEncoder !== 'undefined') {
    u = new TextEncoder().encode(string);
  } else {
    u = [];
    for (i = 0; i < string.length; ++i) {
      var c = string.charCodeAt(i);
      if (c < 0x80) {
        u.push(c);
      } else if (c < 0x800) {
        u.push(0xC0 | (c >> 6));
        u.push(0x80 | (63 & c));
      } else if (c < 0x10000) {
        u.push(0xE0 | (c >> 12));
        u.push(0x80 | (63 & (c >> 6)));
        u.push(0x80 | (63 & c));
      } else {
        u.push(0xF0 | (c >> 18));
        u.push(0x80 | (63 & (c >> 12)));
        u.push(0x80 | (63 & (c >> 6)));
        u.push(0x80 | (63 & c));
      }
    }
  }
  return u;
};

// Method to append a box in the list of child boxes
// The 'pos' parameter can be either:
//   - (number) a position index at which to insert the new box
//   - (string) the type of the box after which to insert the new box
//   - (object) the box after which to insert the new box
ISOBoxer.Utils.appendBox = function(parent, box, pos) {
  box._offset = parent._cursor.offset;
  box._root = (parent._root ? parent._root : parent);
  box._raw = parent._raw;
  box._parent = parent;

  if (pos === -1) {
    // The new box is a sub-box of the parent but not added in boxes array,
    // for example when the new box is set as an entry (see dref and stsd for example)
    return;
  }

  if (pos === undefined || pos === null) {
    parent.boxes.push(box);
    return;
  }

  var index = -1,
      type;

  if (typeof pos === "number") {
    index = pos;
  } else {
    if (typeof pos === "string") {
      type = pos;
    } else if (typeof pos === "object" && pos.type) {
      type = pos.type;
    } else {
      parent.boxes.push(box);
      return;
    }

    for (var i = 0; i < parent.boxes.length; i++) {
      if (type === parent.boxes[i].type) {
        index = i + 1;
        break;
      }
    }
  }
  parent.boxes.splice(index, 0, box);
};

if (true) {
  exports.parseBuffer     = ISOBoxer.parseBuffer;
  exports.addBoxProcessor = ISOBoxer.addBoxProcessor;
  exports.createFile      = ISOBoxer.createFile;
  exports.createBox       = ISOBoxer.createBox;
  exports.createFullBox   = ISOBoxer.createFullBox;
  exports.Utils           = ISOBoxer.Utils;
}

ISOBoxer.Cursor = function(initialOffset) {
  this.offset = (typeof initialOffset == 'undefined' ? 0 : initialOffset);
};

var ISOFile = function(arrayBuffer) {
  this._cursor = new ISOBoxer.Cursor();
  this.boxes = [];
  if (arrayBuffer) {
    this._raw = new DataView(arrayBuffer);
  }
};

ISOFile.prototype.fetch = function(type) {
  var result = this.fetchAll(type, true);
  return (result.length ? result[0] : null);
};

ISOFile.prototype.fetchAll = function(type, returnEarly) {
  var result = [];
  ISOFile._sweep.call(this, type, result, returnEarly);
  return result;
};

ISOFile.prototype.parse = function() {
  this._cursor.offset = 0;
  this.boxes = [];
  while (this._cursor.offset < this._raw.byteLength) {
    var box = ISOBox.parse(this);

    // Box could not be parsed
    if (typeof box.type === 'undefined') break;

    this.boxes.push(box);
  }
  return this;
};

ISOFile._sweep = function(type, result, returnEarly) {
  if (this.type && this.type == type) result.push(this);
  for (var box in this.boxes) {
    if (result.length && returnEarly) return;
    ISOFile._sweep.call(this.boxes[box], type, result, returnEarly);
  }
};

ISOFile.prototype.write = function() {

  var length = 0,
      i;

  for (i = 0; i < this.boxes.length; i++) {
    length += this.boxes[i].getLength(false);
  }

  var bytes = new Uint8Array(length);
  this._rawo = new DataView(bytes.buffer);
  this.bytes = bytes;
  this._cursor.offset = 0;

  for (i = 0; i < this.boxes.length; i++) {
    this.boxes[i].write();
  }

  return bytes.buffer;
};

ISOFile.prototype.append = function(box, pos) {
  ISOBoxer.Utils.appendBox(this, box, pos);
};
var ISOBox = function() {
  this._cursor = new ISOBoxer.Cursor();
};

ISOBox.parse = function(parent) {
  var newBox = new ISOBox();
  newBox._offset = parent._cursor.offset;
  newBox._root = (parent._root ? parent._root : parent);
  newBox._raw = parent._raw;
  newBox._parent = parent;
  newBox._parseBox();
  parent._cursor.offset = newBox._raw.byteOffset + newBox._raw.byteLength;
  return newBox;
};

ISOBox.create = function(type) {
  var newBox = new ISOBox();
  newBox.type = type;
  newBox.boxes = [];
  return newBox;
};

ISOBox.prototype._boxContainers = ['dinf', 'edts', 'mdia', 'meco', 'mfra', 'minf', 'moof', 'moov', 'mvex', 'stbl', 'strk', 'traf', 'trak', 'tref', 'udta', 'vttc', 'sinf', 'schi', 'encv', 'enca'];

ISOBox.prototype._boxProcessors = {};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Generic read/write functions

ISOBox.prototype._procField = function (name, type, size) {
  if (this._parsing) {
    this[name] = this._readField(type, size);
  }
  else {
    this._writeField(type, size, this[name]);
  }
};

ISOBox.prototype._procFieldArray = function (name, length, type, size) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name][i] = this._readField(type, size);
    }
  }
  else {
    for (i = 0; i < this[name].length; i++) {
      this._writeField(type, size, this[name][i]);
    }
  }
};

ISOBox.prototype._procFullBox = function() {
  this._procField('version', 'uint', 8);
  this._procField('flags', 'uint', 24);
};

ISOBox.prototype._procEntries = function(name, length, fn) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name].push({});
      fn.call(this, this[name][i]);
    }
  }
  else {
    for (i = 0; i < length; i++) {
      fn.call(this, this[name][i]);
    }
  }
};

ISOBox.prototype._procSubEntries = function(entry, name, length, fn) {
  var i;
  if (this._parsing) {
    entry[name] = [];
    for (i = 0; i < length; i++) {
      entry[name].push({});
      fn.call(this, entry[name][i]);
    }
  }
  else {
    for (i = 0; i < length; i++) {
      fn.call(this, entry[name][i]);
    }
  }
};

ISOBox.prototype._procEntryField = function (entry, name, type, size) {
  if (this._parsing) {
    entry[name] = this._readField(type, size);
  }
  else {
    this._writeField(type, size, entry[name]);
  }
};

ISOBox.prototype._procSubBoxes = function(name, length) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name].push(ISOBox.parse(this));
    }
  }
  else {
    for (i = 0; i < length; i++) {
      if (this._rawo) {
        this[name][i].write();
      } else {
        this.size += this[name][i].getLength();
      }
    }
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Read/parse functions

ISOBox.prototype._readField = function(type, size) {
  switch (type) {
    case 'uint':
      return this._readUint(size);
    case 'int':
      return this._readInt(size);
    case 'template':
      return this._readTemplate(size);
    case 'string':
      return (size === -1) ? this._readTerminatedString() : this._readString(size);
    case 'data':
      return this._readData(size);
    case 'utf8':
      return this._readUTF8String();
    default:
      return -1;
  }
};

ISOBox.prototype._readInt = function(size) {
  var result = null,
      offset = this._cursor.offset - this._raw.byteOffset;
  switch(size) {
  case 8:
    result = this._raw.getInt8(offset);
    break;
  case 16:
    result = this._raw.getInt16(offset);
    break;
  case 32:
    result = this._raw.getInt32(offset);
    break;
  case 64:
    // Warning: JavaScript cannot handle 64-bit integers natively.
    // This will give unexpected results for integers >= 2^53
    var s1 = this._raw.getInt32(offset);
    var s2 = this._raw.getInt32(offset + 4);
    result = (s1 * Math.pow(2,32)) + s2;
    break;
  }
  this._cursor.offset += (size >> 3);
  return result;
};

ISOBox.prototype._readUint = function(size) {
  var result = null,
      offset = this._cursor.offset - this._raw.byteOffset,
      s1, s2;
  switch(size) {
  case 8:
    result = this._raw.getUint8(offset);
    break;
  case 16:
    result = this._raw.getUint16(offset);
    break;
  case 24:
    s1 = this._raw.getUint16(offset);
    s2 = this._raw.getUint8(offset + 2);
    result = (s1 << 8) + s2;
    break;
  case 32:
    result = this._raw.getUint32(offset);
    break;
  case 64:
    // Warning: JavaScript cannot handle 64-bit integers natively.
    // This will give unexpected results for integers >= 2^53
    s1 = this._raw.getUint32(offset);
    s2 = this._raw.getUint32(offset + 4);
    result = (s1 * Math.pow(2,32)) + s2;
    break;
  }
  this._cursor.offset += (size >> 3);
  return result;
};

ISOBox.prototype._readString = function(length) {
  var str = '';
  for (var c = 0; c < length; c++) {
    var char = this._readUint(8);
    str += String.fromCharCode(char);
  }
  return str;
};

ISOBox.prototype._readTemplate = function(size) {
  var pre = this._readUint(size / 2);
  var post = this._readUint(size / 2);
  return pre + (post / Math.pow(2, size / 2));
};

ISOBox.prototype._readTerminatedString = function() {
  var str = '';
  while (this._cursor.offset - this._offset < this._raw.byteLength) {
    var char = this._readUint(8);
    if (char === 0) break;
    str += String.fromCharCode(char);
  }
  return str;
};

ISOBox.prototype._readData = function(size) {
  var length = (size > 0) ? size : (this._raw.byteLength - (this._cursor.offset - this._offset));
  if (length > 0) {
    var data = new Uint8Array(this._raw.buffer, this._cursor.offset, length);

    this._cursor.offset += length;
    return data;
  }
  else {
    return null;
  }
};

ISOBox.prototype._readUTF8String = function() {
  var length = this._raw.byteLength - (this._cursor.offset - this._offset);
  var data = null;
  if (length > 0) {
    data = new DataView(this._raw.buffer, this._cursor.offset, length);
    this._cursor.offset += length;
  }
 
  return data ? ISOBoxer.Utils.dataViewToString(data) : data;
};

ISOBox.prototype._parseBox = function() {
  this._parsing = true;
  this._cursor.offset = this._offset;

  // return immediately if there are not enough bytes to read the header
  if (this._offset + 8 > this._raw.buffer.byteLength) {
    this._root._incomplete = true;
    return;
  }

  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  switch(this.size) {
  case 0:
    this._raw = new DataView(this._raw.buffer, this._offset, (this._raw.byteLength - this._cursor.offset + 8));
    break;
  case 1:
    if (this._offset + this.size > this._raw.buffer.byteLength) {
      this._incomplete = true;
      this._root._incomplete = true;
    } else {
      this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
    }
    break;
  default:
    if (this._offset + this.size > this._raw.buffer.byteLength) {
      this._incomplete = true;
      this._root._incomplete = true;
    } else {
      this._raw = new DataView(this._raw.buffer, this._offset, this.size);
    }
  }

  // additional parsing
  if (!this._incomplete) {
    if (this._boxProcessors[this.type]) {
      this._boxProcessors[this.type].call(this);
    }
    if (this._boxContainers.indexOf(this.type) !== -1) {
      this._parseContainerBox();
    } else{
      // Unknown box => read and store box content
      this._data = this._readData();
    }
  }
};

ISOBox.prototype._parseFullBox = function() {
  this.version = this._readUint(8);
  this.flags = this._readUint(24);
};

ISOBox.prototype._parseContainerBox = function() {
  this.boxes = [];
  while (this._cursor.offset - this._raw.byteOffset < this._raw.byteLength) {
    this.boxes.push(ISOBox.parse(this));
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Write functions

ISOBox.prototype.append = function(box, pos) {
  ISOBoxer.Utils.appendBox(this, box, pos);
};

ISOBox.prototype.getLength = function() {
  this._parsing = false;
  this._rawo = null;

  this.size = 0;
  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  if (this._boxProcessors[this.type]) {
    this._boxProcessors[this.type].call(this);
  }

  if (this._boxContainers.indexOf(this.type) !== -1) {
    for (var i = 0; i < this.boxes.length; i++) {
      this.size += this.boxes[i].getLength();
    }
  } 

  if (this._data) {
    this._writeData(this._data);
  }

  return this.size;
};

ISOBox.prototype.write = function() {
  this._parsing = false;
  this._cursor.offset = this._parent._cursor.offset;

  switch(this.size) {
  case 0:
    this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, (this.parent._rawo.byteLength - this._cursor.offset));
    break;
  case 1:
      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
    break;
  default:
      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
  }

  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  if (this._boxProcessors[this.type]) {
    this._boxProcessors[this.type].call(this);
  }

  if (this._boxContainers.indexOf(this.type) !== -1) {
    for (var i = 0; i < this.boxes.length; i++) {
      this.boxes[i].write();
    }
  } 

  if (this._data) {
    this._writeData(this._data);
  }

  this._parent._cursor.offset += this.size;

  return this.size;
};

ISOBox.prototype._writeInt = function(size, value) {
  if (this._rawo) {
    var offset = this._cursor.offset - this._rawo.byteOffset;
    switch(size) {
    case 8:
      this._rawo.setInt8(offset, value);
      break;
    case 16:
      this._rawo.setInt16(offset, value);
      break;
    case 32:
      this._rawo.setInt32(offset, value);
      break;
    case 64:
      // Warning: JavaScript cannot handle 64-bit integers natively.
      // This will give unexpected results for integers >= 2^53
      var s1 = Math.floor(value / Math.pow(2,32));
      var s2 = value - (s1 * Math.pow(2,32));
      this._rawo.setUint32(offset, s1);
      this._rawo.setUint32(offset + 4, s2);
      break;
    }
    this._cursor.offset += (size >> 3);
  } else {
    this.size += (size >> 3);
  }
};

ISOBox.prototype._writeUint = function(size, value) {

  if (this._rawo) {
    var offset = this._cursor.offset - this._rawo.byteOffset,
        s1, s2;
    switch(size) {
    case 8:
      this._rawo.setUint8(offset, value);
      break;
    case 16:
      this._rawo.setUint16(offset, value);
      break;
    case 24:
      s1 = (value & 0xFFFF00) >> 8;
      s2 = (value & 0x0000FF);
      this._rawo.setUint16(offset, s1);
      this._rawo.setUint8(offset + 2, s2);
      break;
    case 32:
      this._rawo.setUint32(offset, value);
      break;
    case 64:
      // Warning: JavaScript cannot handle 64-bit integers natively.
      // This will give unexpected results for integers >= 2^53
      s1 = Math.floor(value / Math.pow(2,32));
      s2 = value - (s1 * Math.pow(2,32));
      this._rawo.setUint32(offset, s1);
      this._rawo.setUint32(offset + 4, s2);
      break;
    }
    this._cursor.offset += (size >> 3);
  } else {
    this.size += (size >> 3);
  }
};

ISOBox.prototype._writeString = function(size, str) {
  for (var c = 0; c < size; c++) {
    this._writeUint(8, str.charCodeAt(c));
  }
};

ISOBox.prototype._writeTerminatedString = function(str) {
  if (str.length === 0) {
    return;
  }
  for (var c = 0; c < str.length; c++) {
    this._writeUint(8, str.charCodeAt(c));
  }
  this._writeUint(8, 0);
};

ISOBox.prototype._writeTemplate = function(size, value) {
  var pre = Math.floor(value);
  var post = (value - pre) * Math.pow(2, size / 2);
  this._writeUint(size / 2, pre);
  this._writeUint(size / 2, post);
};

ISOBox.prototype._writeData = function(data) {
  var i;
  //data to copy
  if (data) {
    if (this._rawo) {
      //Array and Uint8Array has also to be managed
      if (data instanceof Array) {
        var offset = this._cursor.offset - this._rawo.byteOffset;
        for (var i = 0; i < data.length; i++) {
          this._rawo.setInt8(offset + i, data[i]);
        }
        this._cursor.offset += data.length;
      } 

      if (data instanceof Uint8Array) {
        this._root.bytes.set(data, this._cursor.offset);
        this._cursor.offset += data.length;
      }

    } else {
      //nothing to copy only size to compute
      this.size += data.length;
    }
  }
};

ISOBox.prototype._writeUTF8String = function(string) {
  var u = ISOBoxer.Utils.utf8ToByteArray(string);
  if (this._rawo) {
    var dataView = new DataView(this._rawo.buffer, this._cursor.offset, u.length);
    for (var i = 0; i < u.length; i++) {
      dataView.setUint8(i, u[i]);
    }
  } else {
    this.size += u.length;
  }
};

ISOBox.prototype._writeField = function(type, size, value) {
  switch (type) {
  case 'uint':
    this._writeUint(size, value);
    break;
  case 'int':
    this._writeInt(size, value);
    break;
  case 'template':
    this._writeTemplate(size, value);
    break;
  case 'string':
      if (size == -1) {
        this._writeTerminatedString(value);
      } else {
        this._writeString(size, value);
      }
      break;
  case 'data':
    this._writeData(value);
    break;
  case 'utf8':
    this._writeUTF8String(value);
    break;
  default:
    break;
  }
};

// ISO/IEC 14496-15:2014 - avc1 box
ISOBox.prototype._boxProcessors['avc1'] = ISOBox.prototype._boxProcessors['encv'] = function() {
  // SampleEntry fields
  this._procFieldArray('reserved1', 6,    'uint', 8);
  this._procField('data_reference_index', 'uint', 16);
  // VisualSampleEntry fields
  this._procField('pre_defined1',         'uint',     16);
  this._procField('reserved2',            'uint',     16);
  this._procFieldArray('pre_defined2', 3, 'uint',     32);
  this._procField('width',                'uint',     16);
  this._procField('height',               'uint',     16);
  this._procField('horizresolution',      'template', 32);
  this._procField('vertresolution',       'template', 32);
  this._procField('reserved3',            'uint',     32);
  this._procField('frame_count',          'uint',     16);
  this._procFieldArray('compressorname', 32,'uint',    8);
  this._procField('depth',                'uint',     16);
  this._procField('pre_defined3',         'int',      16);
  // AVCSampleEntry fields
  this._procField('config', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
ISOBox.prototype._boxProcessors['dref'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procSubBoxes('entries', this.entry_count);
};

// ISO/IEC 14496-12:2012 - 8.6.6 Edit List Box
ISOBox.prototype._boxProcessors['elst'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procEntries('entries', this.entry_count, function(entry) {
    this._procEntryField(entry, 'segment_duration',     'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'media_time',           'int',  (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'media_rate_integer',   'int',  16);
    this._procEntryField(entry, 'media_rate_fraction',  'int',  16);
  });
};

// ISO/IEC 23009-1:2014 - 5.10.3.3 Event Message Box
ISOBox.prototype._boxProcessors['emsg'] = function() {
  this._procFullBox();
  if (this.version == 1) {
    this._procField('timescale',                'uint',   32);
    this._procField('presentation_time',        'uint',   64);
    this._procField('event_duration',           'uint',   32);
    this._procField('id',                       'uint',   32);
    this._procField('scheme_id_uri',            'string', -1);
    this._procField('value',                    'string', -1);
  } else {
    this._procField('scheme_id_uri',            'string', -1);
    this._procField('value',                    'string', -1);
    this._procField('timescale',                'uint',   32);
    this._procField('presentation_time_delta',  'uint',   32);
    this._procField('event_duration',           'uint',   32);
    this._procField('id',                       'uint',   32);
  }
  this._procField('message_data',             'data',   -1);
};
// ISO/IEC 14496-12:2012 - 8.1.2 Free Space Box
ISOBox.prototype._boxProcessors['free'] = ISOBox.prototype._boxProcessors['skip'] = function() {
  this._procField('data', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.12.2 Original Format Box
ISOBox.prototype._boxProcessors['frma'] = function() {
  this._procField('data_format', 'uint', 32);
};
// ISO/IEC 14496-12:2012 - 4.3 File Type Box / 8.16.2 Segment Type Box
ISOBox.prototype._boxProcessors['ftyp'] =
ISOBox.prototype._boxProcessors['styp'] = function() {
  this._procField('major_brand', 'string', 4);
  this._procField('minor_version', 'uint', 32);
  var nbCompatibleBrands = -1;
  if (this._parsing) {
    nbCompatibleBrands = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4;
  }
  this._procFieldArray('compatible_brands', nbCompatibleBrands, 'string', 4);
};

// ISO/IEC 14496-12:2012 - 8.4.3 Handler Reference Box
ISOBox.prototype._boxProcessors['hdlr'] = function() {
  this._procFullBox();
  this._procField('pre_defined',      'uint',   32);
  this._procField('handler_type',     'string', 4);
  this._procFieldArray('reserved', 3, 'uint', 32);
  this._procField('name',             'string', -1);
};

// ISO/IEC 14496-12:2012 - 8.1.1 Media Data Box
ISOBox.prototype._boxProcessors['mdat'] = function() {
  this._procField('data', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.4.2 Media Header Box
ISOBox.prototype._boxProcessors['mdhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint', (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint', (this.version == 1) ? 64 : 32);
  this._procField('timescale',          'uint', 32);
  this._procField('duration',           'uint', (this.version == 1) ? 64 : 32);
  if (!this._parsing && typeof this.language === 'string') {
    // In case of writing and language has been set as a string, then convert it into char codes array
    this.language = ((this.language.charCodeAt(0) - 0x60) << 10) |
                    ((this.language.charCodeAt(1) - 0x60) << 5) |
                    ((this.language.charCodeAt(2) - 0x60));
  }
  this._procField('language',           'uint', 16);
  if (this._parsing) {
    this.language = String.fromCharCode(((this.language >> 10) & 0x1F) + 0x60,
                                        ((this.language >> 5) & 0x1F) + 0x60,
                                        (this.language & 0x1F) + 0x60);
  }
  this._procField('pre_defined',        'uint', 16);
};

// ISO/IEC 14496-12:2012 - 8.8.2 Movie Extends Header Box
ISOBox.prototype._boxProcessors['mehd'] = function() {
  this._procFullBox();
  this._procField('fragment_duration', 'uint', (this.version == 1) ? 64 : 32);
};

// ISO/IEC 14496-12:2012 - 8.8.5 Movie Fragment Header Box
ISOBox.prototype._boxProcessors['mfhd'] = function() {
  this._procFullBox();
  this._procField('sequence_number', 'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.11 Movie Fragment Random Access Box
ISOBox.prototype._boxProcessors['mfro'] = function() {
  this._procFullBox();
  this._procField('mfra_size', 'uint', 32); // Called mfra_size to distinguish from the normal "size" attribute of a box
};


// ISO/IEC 14496-12:2012 - 8.5.2.2 mp4a box (use AudioSampleEntry definition and naming)
ISOBox.prototype._boxProcessors['mp4a'] = ISOBox.prototype._boxProcessors['enca'] = function() {
  // SampleEntry fields
  this._procFieldArray('reserved1', 6,    'uint', 8);
  this._procField('data_reference_index', 'uint', 16);
  // AudioSampleEntry fields
  this._procFieldArray('reserved2', 2,    'uint', 32);
  this._procField('channelcount',         'uint', 16);
  this._procField('samplesize',           'uint', 16);
  this._procField('pre_defined',          'uint', 16);
  this._procField('reserved3',            'uint', 16);
  this._procField('samplerate',           'template', 32);
  // ESDescriptor fields
  this._procField('esds',                 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.2.2 Movie Header Box
ISOBox.prototype._boxProcessors['mvhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
  this._procField('timescale',          'uint',     32);
  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
  this._procField('rate',               'template', 32);
  this._procField('volume',             'template', 16);
  this._procField('reserved1',          'uint',  16);
  this._procFieldArray('reserved2', 2,  'uint',     32);
  this._procFieldArray('matrix', 9,     'template', 32);
  this._procFieldArray('pre_defined', 6,'uint',   32);
  this._procField('next_track_ID',      'uint',     32);
};

// ISO/IEC 14496-30:2014 - WebVTT Cue Payload Box.
ISOBox.prototype._boxProcessors['payl'] = function() {
  this._procField('cue_text', 'utf8');
};

//ISO/IEC 23001-7:2011 - 8.1 Protection System Specific Header Box
ISOBox.prototype._boxProcessors['pssh'] = function() {
  this._procFullBox();
  
  this._procFieldArray('SystemID', 16, 'uint', 8);
  this._procField('DataSize', 'uint', 32);
  this._procFieldArray('Data', this.DataSize, 'uint', 8);
};
// ISO/IEC 14496-12:2012 - 8.12.5 Scheme Type Box
ISOBox.prototype._boxProcessors['schm'] = function() {
    this._procFullBox();
    
    this._procField('scheme_type', 'uint', 32);
    this._procField('scheme_version', 'uint', 32);

    if (this.flags & 0x000001) {
        this._procField('scheme_uri', 'string', -1);
    }
};
// ISO/IEC 14496-12:2012 - 8.6.4.1 sdtp box 
ISOBox.prototype._boxProcessors['sdtp'] = function() {
  this._procFullBox();

  var sample_count = -1;
  if (this._parsing) {
    sample_count = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset));
  }

  this._procFieldArray('sample_dependency_table', sample_count, 'uint', 8);
};

// ISO/IEC 14496-12:2012 - 8.16.3 Segment Index Box
ISOBox.prototype._boxProcessors['sidx'] = function() {
  this._procFullBox();
  this._procField('reference_ID', 'uint', 32);
  this._procField('timescale', 'uint', 32);
  this._procField('earliest_presentation_time', 'uint', (this.version == 1) ? 64 : 32);
  this._procField('first_offset', 'uint', (this.version == 1) ? 64 : 32);
  this._procField('reserved', 'uint', 16);
  this._procField('reference_count', 'uint', 16);
  this._procEntries('references', this.reference_count, function(entry) {
    if (!this._parsing) {
      entry.reference  = (entry.reference_type  & 0x00000001) << 31;
      entry.reference |= (entry.referenced_size & 0x7FFFFFFF);
      entry.sap  = (entry.starts_with_SAP & 0x00000001) << 31;
      entry.sap |= (entry.SAP_type        & 0x00000003) << 28;
      entry.sap |= (entry.SAP_delta_time  & 0x0FFFFFFF);
    }
    this._procEntryField(entry, 'reference', 'uint', 32);
    this._procEntryField(entry, 'subsegment_duration', 'uint', 32);
    this._procEntryField(entry, 'sap', 'uint', 32);
    if (this._parsing) {
      entry.reference_type = (entry.reference >> 31) & 0x00000001;
      entry.referenced_size = entry.reference & 0x7FFFFFFF;
      entry.starts_with_SAP  = (entry.sap >> 31) & 0x00000001;
      entry.SAP_type = (entry.sap >> 28) & 0x00000007;
      entry.SAP_delta_time = (entry.sap  & 0x0FFFFFFF);
    }
  });
};

// ISO/IEC 14496-12:2012 - 8.4.5.3 Sound Media Header Box
ISOBox.prototype._boxProcessors['smhd'] = function() {
  this._procFullBox();
  this._procField('balance',  'uint', 16);
  this._procField('reserved', 'uint', 16);
};

// ISO/IEC 14496-12:2012 - 8.16.4 Subsegment Index Box
ISOBox.prototype._boxProcessors['ssix'] = function() {
  this._procFullBox();
  this._procField('subsegment_count', 'uint', 32);
  this._procEntries('subsegments', this.subsegment_count, function(subsegment) {
    this._procEntryField(subsegment, 'ranges_count', 'uint', 32);
    this._procSubEntries(subsegment, 'ranges', subsegment.ranges_count, function(range) {
      this._procEntryField(range, 'level', 'uint', 8);
      this._procEntryField(range, 'range_size', 'uint', 24);
    });
  });
};

// ISO/IEC 14496-12:2012 - 8.5.2 Sample Description Box
ISOBox.prototype._boxProcessors['stsd'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procSubBoxes('entries', this.entry_count);
};

// ISO/IEC 14496-12:2015 - 8.7.7 Sub-Sample Information Box
ISOBox.prototype._boxProcessors['subs'] = function () {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procEntries('entries', this.entry_count, function(entry) {
    this._procEntryField(entry, 'sample_delta', 'uint', 32);
    this._procEntryField(entry, 'subsample_count', 'uint', 16);
    this._procSubEntries(entry, 'subsamples', entry.subsample_count, function(subsample) {
      this._procEntryField(subsample, 'subsample_size', 'uint', (this.version === 1) ? 32 : 16);
      this._procEntryField(subsample, 'subsample_priority', 'uint', 8);
      this._procEntryField(subsample, 'discardable', 'uint', 8);
      this._procEntryField(subsample, 'codec_specific_parameters', 'uint', 32);
    });
  });
};

//ISO/IEC 23001-7:2011 - 8.2 Track Encryption Box
ISOBox.prototype._boxProcessors['tenc'] = function() {
    this._procFullBox();

    this._procField('default_IsEncrypted', 'uint', 24);
    this._procField('default_IV_size', 'uint', 8);
    this._procFieldArray('default_KID', 16,    'uint', 8);
 };

// ISO/IEC 14496-12:2012 - 8.8.12 Track Fragmnent Decode Time
ISOBox.prototype._boxProcessors['tfdt'] = function() {
  this._procFullBox();
  this._procField('baseMediaDecodeTime', 'uint', (this.version == 1) ? 64 : 32);
};

// ISO/IEC 14496-12:2012 - 8.8.7 Track Fragment Header Box
ISOBox.prototype._boxProcessors['tfhd'] = function() {
  this._procFullBox();
  this._procField('track_ID', 'uint', 32);
  if (this.flags & 0x01) this._procField('base_data_offset',          'uint', 64);
  if (this.flags & 0x02) this._procField('sample_description_offset', 'uint', 32);
  if (this.flags & 0x08) this._procField('default_sample_duration',   'uint', 32);
  if (this.flags & 0x10) this._procField('default_sample_size',       'uint', 32);
  if (this.flags & 0x20) this._procField('default_sample_flags',      'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.10 Track Fragment Random Access Box
ISOBox.prototype._boxProcessors['tfra'] = function() {
  this._procFullBox();
  this._procField('track_ID', 'uint', 32);
  if (!this._parsing) {
    this.reserved = 0;
    this.reserved |= (this.length_size_of_traf_num  & 0x00000030) << 4;
    this.reserved |= (this.length_size_of_trun_num  & 0x0000000C) << 2;
    this.reserved |= (this.length_size_of_sample_num  & 0x00000003);
  }
  this._procField('reserved', 'uint', 32);
  if (this._parsing) {
    this.length_size_of_traf_num = (this.reserved & 0x00000030) >> 4;
    this.length_size_of_trun_num = (this.reserved & 0x0000000C) >> 2;
    this.length_size_of_sample_num = (this.reserved & 0x00000003);
  }
  this._procField('number_of_entry', 'uint', 32);
  this._procEntries('entries', this.number_of_entry, function(entry) {
    this._procEntryField(entry, 'time', 'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'moof_offset', 'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'traf_number', 'uint', (this.length_size_of_traf_num + 1) * 8);
    this._procEntryField(entry, 'trun_number', 'uint', (this.length_size_of_trun_num + 1) * 8);
    this._procEntryField(entry, 'sample_number', 'uint', (this.length_size_of_sample_num + 1) * 8);
  });
};

// ISO/IEC 14496-12:2012 - 8.3.2 Track Header Box
ISOBox.prototype._boxProcessors['tkhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
  this._procField('track_ID',           'uint',     32);
  this._procField('reserved1',          'uint',     32);
  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
  this._procFieldArray('reserved2', 2,  'uint',     32);
  this._procField('layer',              'uint',     16);
  this._procField('alternate_group',    'uint',     16);
  this._procField('volume',             'template', 16);
  this._procField('reserved3',          'uint',     16);
  this._procFieldArray('matrix', 9,     'template', 32);
  this._procField('width',              'template', 32);
  this._procField('height',             'template', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.3 Track Extends Box
ISOBox.prototype._boxProcessors['trex'] = function() {
  this._procFullBox();
  this._procField('track_ID',                         'uint', 32);
  this._procField('default_sample_description_index', 'uint', 32);
  this._procField('default_sample_duration',          'uint', 32);
  this._procField('default_sample_size',              'uint', 32);
  this._procField('default_sample_flags',             'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.8 Track Run Box
// Note: the 'trun' box has a direct relation to the 'tfhd' box for defaults.
// These defaults are not set explicitly here, but are left to resolve for the user.
ISOBox.prototype._boxProcessors['trun'] = function() {
  this._procFullBox();
  this._procField('sample_count', 'uint', 32);
  if (this.flags & 0x1) this._procField('data_offset', 'int', 32);
  if (this.flags & 0x4) this._procField('first_sample_flags', 'uint', 32);
  this._procEntries('samples', this.sample_count, function(sample) {
    if (this.flags & 0x100) this._procEntryField(sample, 'sample_duration', 'uint', 32);
    if (this.flags & 0x200) this._procEntryField(sample, 'sample_size', 'uint', 32);
    if (this.flags & 0x400) this._procEntryField(sample, 'sample_flags', 'uint', 32);
    if (this.flags & 0x800) this._procEntryField(sample, 'sample_composition_time_offset', (this.version === 1) ? 'int' : 'uint',  32);
  });
};

// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
ISOBox.prototype._boxProcessors['url '] = ISOBox.prototype._boxProcessors['urn '] = function() {
  this._procFullBox();
  if (this.type === 'urn ') {
    this._procField('name', 'string', -1);
  }
  this._procField('location', 'string', -1);
};

// ISO/IEC 14496-30:2014 - WebVTT Source Label Box
ISOBox.prototype._boxProcessors['vlab'] = function() {
  this._procField('source_label', 'utf8');
};

// ISO/IEC 14496-12:2012 - 8.4.5.2 Video Media Header Box
ISOBox.prototype._boxProcessors['vmhd'] = function() {
  this._procFullBox();
  this._procField('graphicsmode', 'uint', 16);
  this._procFieldArray('opcolor', 3, 'uint', 16);
};

// ISO/IEC 14496-30:2014 - WebVTT Configuration Box
ISOBox.prototype._boxProcessors['vttC'] = function() {
  this._procField('config', 'utf8');
};

// ISO/IEC 14496-30:2014 - WebVTT Empty Sample Box
ISOBox.prototype._boxProcessors['vtte'] = function() {
  // Nothing should happen here.
};


/***/ }),

/***/ "./node_modules/core-util-is/lib/util.js":
/*!***********************************************!*\
  !*** ./node_modules/core-util-is/lib/util.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_123976__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_123976__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/es6-promise/auto.js":
/*!******************************************!*\
  !*** ./node_modules/es6-promise/auto.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_127646__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __nested_webpack_require_127646__(/*! ./ */ "./node_modules/es6-promise/dist/es6-promise.js").polyfill();


/***/ }),

/***/ "./node_modules/es6-promise/dist/es6-promise.js":
/*!******************************************************!*\
  !*** ./node_modules/es6-promise/dist/es6-promise.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_128244__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	  true ? module.exports = factory() :
	0;
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_128244__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js"), __nested_webpack_require_128244__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/fast-deep-equal/index.js":
/*!***********************************************!*\
  !*** ./node_modules/fast-deep-equal/index.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/imsc/src/main/js/doc.js":
/*!**********************************************!*\
  !*** ./node_modules/imsc/src/main/js/doc.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_163130__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscDoc
 */

;
(function (imscDoc, sax, imscNames, imscStyles, imscUtils) {


    /**
     * Allows a client to provide callbacks to handle children of the <metadata> element
     * @typedef {Object} MetadataHandler
     * @property {?OpenTagCallBack} onOpenTag
     * @property {?CloseTagCallBack} onCloseTag
     * @property {?TextCallBack} onText
     */

    /**
     * Called when the opening tag of an element node is encountered.
     * @callback OpenTagCallBack
     * @param {string} ns Namespace URI of the element
     * @param {string} name Local name of the element
     * @param {Object[]} attributes List of attributes, each consisting of a
     *                              `uri`, `name` and `value`
     */

    /**
     * Called when the closing tag of an element node is encountered.
     * @callback CloseTagCallBack
     */

    /**
     * Called when a text node is encountered.
     * @callback TextCallBack
     * @param {string} contents Contents of the text node
     */

    /**
     * Parses an IMSC1 document into an opaque in-memory representation that exposes
     * a single method <pre>getMediaTimeEvents()</pre> that returns a list of time
     * offsets (in seconds) of the ISD, i.e. the points in time where the visual
     * representation of the document change. `metadataHandler` allows the caller to
     * be called back when nodes are present in <metadata> elements. 
     * 
     * @param {string} xmlstring XML document
     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
     * @param {?MetadataHandler} metadataHandler Callback for <Metadata> elements
     * @returns {Object} Opaque in-memory representation of an IMSC1 document
     */

    imscDoc.fromXML = function (xmlstring, errorHandler, metadataHandler) {
        var p = sax.parser(true, {xmlns: true});
        var estack = [];
        var xmllangstack = [];
        var xmlspacestack = [];
        var metadata_depth = 0;
        var doc = null;

        p.onclosetag = function (node) {

            if (estack[0] instanceof Styling) {

                /* flatten chained referential styling */

                for (var sid in estack[0].styles) {

                    mergeChainedStyles(estack[0], estack[0].styles[sid], errorHandler);

                }

            } else if (estack[0] instanceof P || estack[0] instanceof Span) {

                /* merge anonymous spans */

                if (estack[0].contents.length > 1) {

                    var cs = [estack[0].contents[0]];

                    var c;

                    for (c = 1; c < estack[0].contents.length; c++) {

                        if (estack[0].contents[c] instanceof AnonymousSpan &&
                                cs[cs.length - 1] instanceof AnonymousSpan) {

                            cs[cs.length - 1].text += estack[0].contents[c].text;

                        } else {

                            cs.push(estack[0].contents[c]);

                        }

                    }

                    estack[0].contents = cs;

                }

                // remove redundant nested anonymous spans (9.3.3(1)(c))

                if (estack[0] instanceof Span &&
                        estack[0].contents.length === 1 &&
                        estack[0].contents[0] instanceof AnonymousSpan) {

                    estack[0].text = estack[0].contents[0].text;
                    delete estack[0].contents;

                }

            } else if (estack[0] instanceof ForeignElement) {

                if (estack[0].node.uri === imscNames.ns_tt &&
                        estack[0].node.local === 'metadata') {

                    /* leave the metadata element */

                    metadata_depth--;

                } else if (metadata_depth > 0 &&
                        metadataHandler &&
                        'onCloseTag' in metadataHandler) {

                    /* end of child of metadata element */

                    metadataHandler.onCloseTag();

                }

            }

            // TODO: delete stylerefs?

            // maintain the xml:space stack

            xmlspacestack.shift();

            // maintain the xml:lang stack

            xmllangstack.shift();

            // prepare for the next element

            estack.shift();
        };

        p.ontext = function (str) {

            if (estack[0] === undefined) {

                /* ignoring text outside of elements */

            } else if (estack[0] instanceof Span || estack[0] instanceof P) {

                /* create an anonymous span */

                var s = new AnonymousSpan();

                s.initFromText(doc, estack[0], str, xmlspacestack[0], errorHandler);

                estack[0].contents.push(s);

            } else if (estack[0] instanceof ForeignElement &&
                    metadata_depth > 0 &&
                    metadataHandler &&
                    'onText' in metadataHandler) {

                /* text node within a child of metadata element */

                metadataHandler.onText(str);

            }

        };


        p.onopentag = function (node) {

            // maintain the xml:space stack

            var xmlspace = node.attributes["xml:space"];

            if (xmlspace) {

                xmlspacestack.unshift(xmlspace.value);

            } else {

                if (xmlspacestack.length === 0) {

                    xmlspacestack.unshift("default");

                } else {

                    xmlspacestack.unshift(xmlspacestack[0]);

                }

            }

            /* maintain the xml:lang stack */


            var xmllang = node.attributes["xml:lang"];

            if (xmllang) {

                xmllangstack.unshift(xmllang.value);

            } else {

                if (xmllangstack.length === 0) {

                    xmllangstack.unshift("");

                } else {

                    xmllangstack.unshift(xmllangstack[0]);

                }

            }


            /* process the element */

            if (node.uri === imscNames.ns_tt) {

                if (node.local === 'tt') {

                    if (doc !== null) {

                        reportFatal(errorHandler, "Two <tt> elements at (" + this.line + "," + this.column + ")");

                    }

                    doc = new TT();

                    doc.initFromNode(node, errorHandler);

                    estack.unshift(doc);

                } else if (node.local === 'head') {

                    if (!(estack[0] instanceof TT)) {
                        reportFatal(errorHandler, "Parent of <head> element is not <tt> at (" + this.line + "," + this.column + ")");
                    }

                    if (doc.head !== null) {
                        reportFatal("Second <head> element at (" + this.line + "," + this.column + ")");
                    }

                    doc.head = new Head();

                    estack.unshift(doc.head);

                } else if (node.local === 'styling') {

                    if (!(estack[0] instanceof Head)) {
                        reportFatal(errorHandler, "Parent of <styling> element is not <head> at (" + this.line + "," + this.column + ")");
                    }

                    if (doc.head.styling !== null) {
                        reportFatal("Second <styling> element at (" + this.line + "," + this.column + ")");
                    }

                    doc.head.styling = new Styling();

                    estack.unshift(doc.head.styling);

                } else if (node.local === 'style') {

                    var s;

                    if (estack[0] instanceof Styling) {

                        s = new Style();

                        s.initFromNode(node, errorHandler);

                        /* ignore <style> element missing @id */

                        if (!s.id) {

                            reportError(errorHandler, "<style> element missing @id attribute");

                        } else {

                            doc.head.styling.styles[s.id] = s;

                        }

                        estack.unshift(s);

                    } else if (estack[0] instanceof Region) {

                        /* nested styles can be merged with specified styles
                         * immediately, with lower priority
                         * (see 8.4.4.2(3) at TTML1 )
                         */

                        s = new Style();

                        s.initFromNode(node, errorHandler);

                        mergeStylesIfNotPresent(s.styleAttrs, estack[0].styleAttrs);

                        estack.unshift(s);

                    } else {

                        reportFatal(errorHandler, "Parent of <style> element is not <styling> or <region> at (" + this.line + "," + this.column + ")");

                    }

                } else if (node.local === 'layout') {

                    if (!(estack[0] instanceof Head)) {

                        reportFatal(errorHandler, "Parent of <layout> element is not <head> at " + this.line + "," + this.column + ")");

                    }

                    if (doc.head.layout !== null) {

                        reportFatal(errorHandler, "Second <layout> element at " + this.line + "," + this.column + ")");

                    }

                    doc.head.layout = new Layout();

                    estack.unshift(doc.head.layout);

                } else if (node.local === 'region') {

                    if (!(estack[0] instanceof Layout)) {
                        reportFatal(errorHandler, "Parent of <region> element is not <layout> at " + this.line + "," + this.column + ")");
                    }

                    var r = new Region();

                    r.initFromNode(doc, node, errorHandler);

                    if (!r.id || r.id in doc.head.layout.regions) {

                        reportError(errorHandler, "Ignoring <region> with duplicate or missing @id at " + this.line + "," + this.column + ")");

                    } else {

                        doc.head.layout.regions[r.id] = r;

                    }

                    estack.unshift(r);

                } else if (node.local === 'body') {

                    if (!(estack[0] instanceof TT)) {

                        reportFatal(errorHandler, "Parent of <body> element is not <tt> at " + this.line + "," + this.column + ")");

                    }

                    if (doc.body !== null) {

                        reportFatal(errorHandler, "Second <body> element at " + this.line + "," + this.column + ")");

                    }

                    var b = new Body();

                    b.initFromNode(doc, node, errorHandler);

                    doc.body = b;

                    estack.unshift(b);

                } else if (node.local === 'div') {

                    if (!(estack[0] instanceof Div || estack[0] instanceof Body)) {

                        reportFatal(errorHandler, "Parent of <div> element is not <body> or <div> at " + this.line + "," + this.column + ")");

                    }

                    var d = new Div();

                    d.initFromNode(doc, estack[0], node, errorHandler);

                    estack[0].contents.push(d);

                    estack.unshift(d);

                } else if (node.local === 'p') {

                    if (!(estack[0] instanceof Div)) {

                        reportFatal(errorHandler, "Parent of <p> element is not <div> at " + this.line + "," + this.column + ")");

                    }

                    var p = new P();

                    p.initFromNode(doc, estack[0], node, errorHandler);

                    estack[0].contents.push(p);

                    estack.unshift(p);

                } else if (node.local === 'span') {

                    if (!(estack[0] instanceof Span || estack[0] instanceof P)) {

                        reportFatal(errorHandler, "Parent of <span> element is not <span> or <p> at " + this.line + "," + this.column + ")");

                    }

                    var ns = new Span();

                    ns.initFromNode(doc, estack[0], node, xmlspacestack[0], errorHandler);

                    estack[0].contents.push(ns);

                    estack.unshift(ns);

                } else if (node.local === 'br') {

                    if (!(estack[0] instanceof Span || estack[0] instanceof P)) {

                        reportFatal(errorHandler, "Parent of <br> element is not <span> or <p> at " + this.line + "," + this.column + ")");

                    }

                    var nb = new Br();

                    nb.initFromNode(doc, estack[0], node, errorHandler);

                    estack[0].contents.push(nb);

                    estack.unshift(nb);

                } else if (node.local === 'set') {

                    if (!(estack[0] instanceof Span ||
                            estack[0] instanceof P ||
                            estack[0] instanceof Div ||
                            estack[0] instanceof Body ||
                            estack[0] instanceof Region ||
                            estack[0] instanceof Br)) {

                        reportFatal(errorHandler, "Parent of <set> element is not a content element or a region at " + this.line + "," + this.column + ")");

                    }

                    var st = new Set();

                    st.initFromNode(doc, estack[0], node, errorHandler);

                    estack[0].sets.push(st);

                    estack.unshift(st);

                } else {

                    /* element in the TT namespace, but not a content element */

                    estack.unshift(new ForeignElement(node));
                }

            } else {

                /* ignore elements not in the TTML namespace unless in metadata element */

                estack.unshift(new ForeignElement(node));

            }

            /* handle metadata callbacks */

            if (estack[0] instanceof ForeignElement) {

                if (node.uri === imscNames.ns_tt &&
                        node.local === 'metadata') {

                    /* enter the metadata element */

                    metadata_depth++;

                } else if (
                        metadata_depth > 0 &&
                        metadataHandler &&
                        'onOpenTag' in metadataHandler
                        ) {

                    /* start of child of metadata element */

                    var attrs = [];

                    for (var a in node.attributes) {
                        attrs[node.attributes[a].uri + " " + node.attributes[a].local] =
                                {
                                    uri: node.attributes[a].uri,
                                    local: node.attributes[a].local,
                                    value: node.attributes[a].value
                                };
                    }

                    metadataHandler.onOpenTag(node.uri, node.local, attrs);

                }

            }

        };

        // parse the document

        p.write(xmlstring).close();

        // all referential styling has been flatten, so delete the styling elements if there is a head
        // otherwise create an empty head

        if (doc.head !== null) {
            delete doc.head.styling;
        } else {
            doc.head = new Head();
        }

        // create default region if no regions specified

        if (doc.head.layout === null) {

            doc.head.layout = new Layout();

        }

        var hasRegions = false;

        /* AFAIK the only way to determine whether an object has members */

        for (var i in doc.head.layout.regions) {

            hasRegions = true;

            break;

        }

        if (!hasRegions) {

            /* create default region */

            var dr = Region.prototype.createDefaultRegion();

            doc.head.layout.regions[dr.id] = dr;

        }

        /* resolve desired timing for regions */

        for (var region_i in doc.head.layout.regions) {

            resolveTiming(doc, doc.head.layout.regions[region_i], null, null);

        }

        /* resolve desired timing for content elements */

        if (doc.body) {
            resolveTiming(doc, doc.body, null, null);
        }

        return doc;
    };

    function resolveTiming(doc, element, prev_sibling, parent) {

        /* are we in a seq container? */

        var isinseq = parent && parent.timeContainer === "seq";

        /* determine implicit begin */

        var implicit_begin = 0; /* default */

        if (parent) {

            if (isinseq && prev_sibling) {

                /*
                 * if seq time container, offset from the previous sibling end
                 */

                implicit_begin = prev_sibling.end;


            } else {

                implicit_begin = parent.begin;

            }

        }

        /* compute desired begin */

        element.begin = element.explicit_begin ? element.explicit_begin + implicit_begin : implicit_begin;


        /* determine implicit end */

        var implicit_end = element.begin;

        var s = null;

        for (var set_i in element.sets) {

            resolveTiming(doc, element.sets[set_i], s, element);

            if (element.timeContainer === "seq") {

                implicit_end = element.sets[set_i].end;

            } else {

                implicit_end = Math.max(implicit_end, element.sets[set_i].end);

            }

            s = element.sets[set_i];

        }

        if (!('contents' in element)) {

            /* anonymous spans and regions and <set> and <br>s and spans with only children text nodes */

            if (isinseq) {

                /* in seq container, implicit duration is zero */

                implicit_end = element.begin;

            } else {

                /* in par container, implicit duration is indefinite */

                implicit_end = Number.POSITIVE_INFINITY;

            }

        } else {

            for (var content_i in element.contents) {

                resolveTiming(doc, element.contents[content_i], s, element);

                if (element.timeContainer === "seq") {

                    implicit_end = element.contents[content_i].end;

                } else {

                    implicit_end = Math.max(implicit_end, element.contents[content_i].end);

                }

                s = element.contents[content_i];

            }

        }

        /* determine desired end */
        /* it is never made really clear in SMIL that the explicit end is offset by the implicit begin */

        if (element.explicit_end !== null && element.explicit_dur !== null) {

            element.end = Math.min(element.begin + element.explicit_dur, implicit_begin + element.explicit_end);

        } else if (element.explicit_end === null && element.explicit_dur !== null) {

            element.end = element.begin + element.explicit_dur;

        } else if (element.explicit_end !== null && element.explicit_dur === null) {

            element.end = implicit_begin + element.explicit_end;

        } else {

            element.end = implicit_end;
        }

        delete element.explicit_begin;
        delete element.explicit_dur;
        delete element.explicit_end;

        doc._registerEvent(element);

    }

    function ForeignElement(node) {
        this.node = node;
    }

    function TT() {
        this.events = [];
        this.head = null;
        this.body = null;
    }

    TT.prototype.initFromNode = function (node, errorHandler) {

        /* compute cell resolution */

        this.cellResolution = extractCellResolution(node, errorHandler);

        /* extract frame rate and tick rate */

        var frtr = extractFrameAndTickRate(node, errorHandler);

        this.effectiveFrameRate = frtr.effectiveFrameRate;

        this.tickRate = frtr.tickRate;

        /* extract aspect ratio */

        this.aspectRatio = extractAspectRatio(node, errorHandler);

        /* check timebase */

        var attr = findAttribute(node, imscNames.ns_ttp, "timeBase");

        if (attr !== null && attr !== "media") {

            reportFatal(errorHandler, "Unsupported time base");

        }

        /* retrieve extent */

        var e = extractExtent(node, errorHandler);

        if (e === null) {

            /* TODO: remove once unit tests are ready */

            this.pxDimensions = {'h': 480, 'w': 640};

        } else {

            if (e.h.unit !== "px" || e.w.unit !== "px") {
                reportFatal(errorHandler, "Extent on TT must be in px or absent");
            }

            this.pxDimensions = {'h': e.h.value, 'w': e.w.value};
        }

    };

    /* register a temporal events */
    TT.prototype._registerEvent = function (elem) {

        /* skip if begin is not < then end */

        if (elem.end <= elem.begin)
            return;

        /* index the begin time of the event */

        var b_i = indexOf(this.events, elem.begin);

        if (!b_i.found) {
            this.events.splice(b_i.index, 0, elem.begin);
        }

        /* index the end time of the event */

        if (elem.end !== Number.POSITIVE_INFINITY) {

            var e_i = indexOf(this.events, elem.end);

            if (!e_i.found) {
                this.events.splice(e_i.index, 0, elem.end);
            }

        }

    };


    /*
     * Retrieves the range of ISD times covered by the document
     * 
     * @returns {Array} Array of two elements: min_begin_time and max_begin_time
     * 
     */
    TT.prototype.getMediaTimeRange = function () {

        return [this.events[0], this.events[this.events.length - 1]];
    };

    /*
     * Returns list of ISD begin times  
     * 
     * @returns {Array}
     */
    TT.prototype.getMediaTimeEvents = function () {

        return this.events;
    };

    /*
     * Represents a TTML Head element
     */

    function Head() {
        this.styling = null;
        this.layout = null;
    }

    /*
     * Represents a TTML Styling element
     */

    function Styling() {
        this.styles = {};
    }

    /*
     * Represents a TTML Style element
     */

    function Style() {
        this.id = null;
        this.styleAttrs = null;
        this.styleRefs = null;
    }

    Style.prototype.initFromNode = function (node, errorHandler) {
        this.id = elementGetXMLID(node);
        this.styleAttrs = elementGetStyles(node, errorHandler);
        this.styleRefs = elementGetStyleRefs(node);
    };

    /*
     * Represents a TTML Layout element
     * 
     */

    function Layout() {
        this.regions = {};
    }

    /*
     * TTML element utility functions
     * 
     */

    function ContentElement(kind) {
        this.kind = kind;
    }

    function IdentifiedElement(id) {
        this.id = id;
    }

    IdentifiedElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        this.id = elementGetXMLID(node);
    };

    function LayoutElement(id) {
        this.regionID = id;
    }

    LayoutElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        this.regionID = elementGetRegionID(node);
    };

    function StyledElement(styleAttrs) {
        this.styleAttrs = styleAttrs;
    }

    StyledElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {

        this.styleAttrs = elementGetStyles(node, errorHandler);

        if (doc.head !== null && doc.head.styling !== null) {
            mergeReferencedStyles(doc.head.styling, elementGetStyleRefs(node), this.styleAttrs, errorHandler);
        }

    };

    function AnimatedElement(sets) {
        this.sets = sets;
    }

    AnimatedElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        this.sets = [];
    };

    function ContainerElement(contents) {
        this.contents = contents;
    }

    ContainerElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        this.contents = [];
    };

    function TimedElement(explicit_begin, explicit_end, explicit_dur) {
        this.explicit_begin = explicit_begin;
        this.explicit_end = explicit_end;
        this.explicit_dur = explicit_dur;
    }

    TimedElement.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        var t = processTiming(doc, parent, node, errorHandler);
        this.explicit_begin = t.explicit_begin;
        this.explicit_end = t.explicit_end;
        this.explicit_dur = t.explicit_dur;

        this.timeContainer = elementGetTimeContainer(node, errorHandler);
    };


    /*
     * Represents a TTML body element
     */



    function Body() {
        ContentElement.call(this, 'body');
    }


    Body.prototype.initFromNode = function (doc, node, errorHandler) {
        StyledElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        AnimatedElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        LayoutElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        ContainerElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
    };

    /*
     * Represents a TTML div element
     */

    function Div() {
        ContentElement.call(this, 'div');
    }

    Div.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        StyledElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        AnimatedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        LayoutElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        ContainerElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
    };

    /*
     * Represents a TTML p element
     */

    function P() {
        ContentElement.call(this, 'p');
    }

    P.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        StyledElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        AnimatedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        LayoutElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        ContainerElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
    };

    /*
     * Represents a TTML span element
     */

    function Span() {
        ContentElement.call(this, 'span');
    }

    Span.prototype.initFromNode = function (doc, parent, node, xmlspace, errorHandler) {
        StyledElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        AnimatedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        LayoutElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        ContainerElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);

        this.space = xmlspace;
    };

    /*
     * Represents a TTML anonymous span element
     */

    function AnonymousSpan() {
        ContentElement.call(this, 'span');
    }

    AnonymousSpan.prototype.initFromText = function (doc, parent, text, xmlspace, errorHandler) {
        TimedElement.prototype.initFromNode.call(this, doc, parent, null, errorHandler);

        this.text = text;
        this.space = xmlspace;
    };

    /*
     * Represents a TTML br element
     */

    function Br() {
        ContentElement.call(this, 'br');
    }

    Br.prototype.initFromNode = function (doc, parent, node, errorHandler) {
        LayoutElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);
    };

    /*
     * Represents a TTML Region element
     * 
     */

    function Region() {
    }

    Region.prototype.createDefaultRegion = function () {
        var r = new Region();

        IdentifiedElement.call(r, '');
        StyledElement.call(r, {});
        AnimatedElement.call(r, []);
        TimedElement.call(r, 0, Number.POSITIVE_INFINITY, null);

        return r;
    };

    Region.prototype.initFromNode = function (doc, node, errorHandler) {
        IdentifiedElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        StyledElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        TimedElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);
        AnimatedElement.prototype.initFromNode.call(this, doc, null, node, errorHandler);

        /* immediately merge referenced styles */

        if (doc.head !== null && doc.head.styling !== null) {
            mergeReferencedStyles(doc.head.styling, elementGetStyleRefs(node), this.styleAttrs, errorHandler);
        }

    };

    /*
     * Represents a TTML Set element
     * 
     */

    function Set() {
    }

    Set.prototype.initFromNode = function (doc, parent, node, errorHandler) {

        TimedElement.prototype.initFromNode.call(this, doc, parent, node, errorHandler);

        var styles = elementGetStyles(node, errorHandler);

        this.qname = null;
        this.value = null;

        for (var qname in styles) {

            if (this.qname) {

                reportError(errorHandler, "More than one style specified on set");
                break;

            }

            this.qname = qname;
            this.value = styles[qname];

        }

    };

    /*
     * Utility functions
     * 
     */


    function elementGetXMLID(node) {
        return node && 'xml:id' in node.attributes ? node.attributes['xml:id'].value || null : null;
    }

    function elementGetRegionID(node) {
        return node && 'region' in node.attributes ? node.attributes.region.value : '';
    }

    function elementGetTimeContainer(node, errorHandler) {

        var tc = node && 'timeContainer' in node.attributes ? node.attributes.timeContainer.value : null;

        if ((!tc) || tc === "par") {

            return "par";

        } else if (tc === "seq") {

            return "seq";

        } else {

            reportError(errorHandler, "Illegal value of timeContainer (assuming 'par')");

            return "par";

        }

    }

    function elementGetStyleRefs(node) {

        return node && 'style' in node.attributes ? node.attributes.style.value.split(" ") : [];

    }

    function elementGetStyles(node, errorHandler) {

        var s = {};

        if (node !== null) {

            for (var i in node.attributes) {

                var qname = node.attributes[i].uri + " " + node.attributes[i].local;

                var sa = imscStyles.byQName[qname];

                if (sa !== undefined) {

                    var val = sa.parse(node.attributes[i].value);

                    if (val !== null) {

                        s[qname] = val;

                        /* TODO: consider refactoring errorHandler into parse and compute routines */

                        if (sa === imscStyles.byName.zIndex) {
                            reportWarning(errorHandler, "zIndex attribute present but not used by IMSC1 since regions do not overlap");
                        }

                    } else {

                        reportError(errorHandler, "Cannot parse styling attribute " + qname + " --> " + node.attributes[i].value);

                    }

                }

            }

        }

        return s;
    }

    function findAttribute(node, ns, name) {
        for (var i in node.attributes) {

            if (node.attributes[i].uri === ns &&
                    node.attributes[i].local === name) {

                return node.attributes[i].value;
            }
        }

        return null;
    }

    function extractAspectRatio(node, errorHandler) {

        var ar = findAttribute(node, imscNames.ns_ittp, "aspectRatio");

        var rslt = null;

        if (ar !== null) {

            var ASPECT_RATIO_RE = /(\d+) (\d+)/;

            var m = ASPECT_RATIO_RE.exec(ar);

            if (m !== null) {

                var w = parseInt(m[1]);

                var h = parseInt(m[2]);

                if (w !== 0 && h !== 0) {

                    rslt = w / h;

                } else {

                    reportError(errorHandler, "Illegal aspectRatio values (ignoring)");
                }

            } else {

                reportError(errorHandler, "Malformed aspectRatio attribute (ignoring)");
            }

        }

        return rslt;

    }

    /*
     * Returns the cellResolution attribute from a node
     * 
     */
    function extractCellResolution(node, errorHandler) {

        var cr = findAttribute(node, imscNames.ns_ttp, "cellResolution");

        // initial value

        var h = 15;
        var w = 32;

        if (cr !== null) {

            var CELL_RESOLUTION_RE = /(\d+) (\d+)/;

            var m = CELL_RESOLUTION_RE.exec(cr);

            if (m !== null) {

                w = parseInt(m[1]);

                h = parseInt(m[2]);

            } else {

                reportWarning(errorHandler, "Malformed cellResolution value (using initial value instead)");

            }

        }

        return {'w': w, 'h': h};

    }


    function extractFrameAndTickRate(node, errorHandler) {

        // subFrameRate is ignored per IMSC1 specification

        // extract frame rate

        var fps_attr = findAttribute(node, imscNames.ns_ttp, "frameRate");

        // initial value

        var fps = 30;

        // match variable

        var m;

        if (fps_attr !== null) {

            var FRAME_RATE_RE = /(\d+)/;

            m = FRAME_RATE_RE.exec(fps_attr);

            if (m !== null) {

                fps = parseInt(m[1]);

            } else {

                reportWarning(errorHandler, "Malformed frame rate attribute (using initial value instead)");
            }

        }

        // extract frame rate multiplier

        var frm_attr = findAttribute(node, imscNames.ns_ttp, "frameRateMultiplier");

        // initial value

        var frm = 1;

        if (frm_attr !== null) {

            var FRAME_RATE_MULT_RE = /(\d+) (\d+)/;

            m = FRAME_RATE_MULT_RE.exec(frm_attr);

            if (m !== null) {

                frm = parseInt(m[1]) / parseInt(m[2]);

            } else {

                reportWarning(errorHandler, "Malformed frame rate multiplier attribute (using initial value instead)");
            }

        }

        var efps = frm * fps;

        // extract tick rate

        var tr = 1;

        var trattr = findAttribute(node, imscNames.ns_ttp, "tickRate");

        if (trattr === null) {

            if (fps_attr !== null)
                tr = efps;

        } else {

            var TICK_RATE_RE = /(\d+)/;

            m = TICK_RATE_RE.exec(trattr);

            if (m !== null) {

                tr = parseInt(m[1]);

            } else {

                reportWarning(errorHandler, "Malformed tick rate attribute (using initial value instead)");
            }

        }

        return {effectiveFrameRate: efps, tickRate: tr};

    }

    function extractExtent(node, errorHandler) {

        var attr = findAttribute(node, imscNames.ns_tts, "extent");

        if (attr === null)
            return null;

        var s = attr.split(" ");

        if (s.length !== 2) {

            reportWarning(errorHandler, "Malformed extent (ignoring)");

            return null;
        }

        var w = imscUtils.parseLength(s[0]);

        var h = imscUtils.parseLength(s[1]);

        if (!h || !w) {

            reportWarning(errorHandler, "Malformed extent values (ignoring)");

            return null;
        }

        return {'h': h, 'w': w};

    }

    function parseTimeExpression(tickRate, effectiveFrameRate, str) {

        var CLOCK_TIME_FRACTION_RE = /^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/;
        var CLOCK_TIME_FRAMES_RE = /^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/;
        var OFFSET_FRAME_RE = /^(\d+(?:\.\d+)?)f$/;
        var OFFSET_TICK_RE = /^(\d+(?:\.\d+)?)t$/;
        var OFFSET_MS_RE = /^(\d+(?:\.\d+)?)ms$/;
        var OFFSET_S_RE = /^(\d+(?:\.\d+)?)s$/;
        var OFFSET_H_RE = /^(\d+(?:\.\d+)?)h$/;
        var OFFSET_M_RE = /^(\d+(?:\.\d+)?)m$/;
        var m;
        var r = null;
        if ((m = OFFSET_FRAME_RE.exec(str)) !== null) {

            if (effectiveFrameRate !== null) {

                r = parseFloat(m[1]) / effectiveFrameRate;
            }

        } else if ((m = OFFSET_TICK_RE.exec(str)) !== null) {

            if (tickRate !== null) {

                r = parseFloat(m[1]) / tickRate;
            }

        } else if ((m = OFFSET_MS_RE.exec(str)) !== null) {

            r = parseFloat(m[1]) / 1000.0;

        } else if ((m = OFFSET_S_RE.exec(str)) !== null) {

            r = parseFloat(m[1]);

        } else if ((m = OFFSET_H_RE.exec(str)) !== null) {

            r = parseFloat(m[1]) * 3600.0;

        } else if ((m = OFFSET_M_RE.exec(str)) !== null) {

            r = parseFloat(m[1]) * 60.0;

        } else if ((m = CLOCK_TIME_FRACTION_RE.exec(str)) !== null) {

            r = parseInt(m[1]) * 3600 +
                    parseInt(m[2]) * 60 +
                    parseFloat(m[3]);

        } else if ((m = CLOCK_TIME_FRAMES_RE.exec(str)) !== null) {

            /* this assumes that HH:MM:SS is a clock-time-with-fraction */

            if (effectiveFrameRate !== null) {

                r = parseInt(m[1]) * 3600 +
                        parseInt(m[2]) * 60 +
                        parseInt(m[3]) +
                        (m[4] === null ? 0 : parseInt(m[4]) / effectiveFrameRate);
            }

        }

        return r;
    }

    function processTiming(doc, parent, node, errorHandler) {

        /* determine explicit begin */

        var explicit_begin = null;

        if (node && 'begin' in node.attributes) {

            explicit_begin = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.begin.value);

            if (explicit_begin === null) {

                reportWarning(errorHandler, "Malformed begin value " + node.attributes.begin.value + " (using 0)");

            }

        }

        /* determine explicit duration */

        var explicit_dur = null;

        if (node && 'dur' in node.attributes) {

            explicit_dur = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.dur.value);

            if (explicit_dur === null) {

                reportWarning(errorHandler, "Malformed dur value " + node.attributes.dur.value + " (ignoring)");

            }

        }

        /* determine explicit end */

        var explicit_end = null;

        if (node && 'end' in node.attributes) {

            explicit_end = parseTimeExpression(doc.tickRate, doc.effectiveFrameRate, node.attributes.end.value);

            if (explicit_end === null) {

                reportWarning(errorHandler, "Malformed end value (ignoring)");

            }

        }

        return {explicit_begin: explicit_begin,
            explicit_end: explicit_end,
            explicit_dur: explicit_dur};

    }



    function mergeChainedStyles(styling, style, errorHandler) {

        while (style.styleRefs.length > 0) {

            var sref = style.styleRefs.pop();

            if (!(sref in styling.styles)) {
                reportError(errorHandler, "Non-existant style id referenced");
                continue;
            }

            mergeChainedStyles(styling, styling.styles[sref], errorHandler);

            mergeStylesIfNotPresent(styling.styles[sref].styleAttrs, style.styleAttrs);

        }

    }

    function mergeReferencedStyles(styling, stylerefs, styleattrs, errorHandler) {

        for (var i = stylerefs.length - 1; i >= 0; i--) {

            var sref = stylerefs[i];

            if (!(sref in styling.styles)) {
                reportError(errorHandler, "Non-existant style id referenced");
                continue;
            }

            mergeStylesIfNotPresent(styling.styles[sref].styleAttrs, styleattrs);

        }

    }

    function mergeStylesIfNotPresent(from_styles, into_styles) {

        for (var sname in from_styles) {

            if (sname in into_styles)
                continue;

            into_styles[sname] = from_styles[sname];

        }

    }

    /* TODO: validate style format at parsing */


    /*
     * ERROR HANDLING UTILITY FUNCTIONS
     * 
     */

    function reportInfo(errorHandler, msg) {

        if (errorHandler && errorHandler.info && errorHandler.info(msg))
            throw msg;

    }

    function reportWarning(errorHandler, msg) {

        if (errorHandler && errorHandler.warn && errorHandler.warn(msg))
            throw msg;

    }

    function reportError(errorHandler, msg) {

        if (errorHandler && errorHandler.error && errorHandler.error(msg))
            throw msg;

    }

    function reportFatal(errorHandler, msg) {

        if (errorHandler && errorHandler.fatal)
            errorHandler.fatal(msg);

        throw msg;

    }

    /*
     * Binary search utility function
     * 
     * @typedef {Object} BinarySearchResult
     * @property {boolean} found Was an exact match found?
     * @property {number} index Position of the exact match or insert position
     * 
     * @returns {BinarySearchResult}
     */

    function indexOf(arr, searchval) {

        var min = 0;
        var max = arr.length - 1;
        var cur;

        while (min <= max) {

            cur = Math.floor((min + max) / 2);

            var curval = arr[cur];

            if (curval < searchval) {

                min = cur + 1;

            } else if (curval > searchval) {

                max = cur - 1;

            } else {

                return {found: true, index: cur};

            }

        }

        return {found: false, index: min};
    }


})(  false ? 0 : exports,
        typeof sax === 'undefined' ? __nested_webpack_require_163130__(/*! sax */ "./node_modules/sax/lib/sax.js") : sax,
        typeof imscNames === 'undefined' ? __nested_webpack_require_163130__(/*! ./names */ "./node_modules/imsc/src/main/js/names.js") : imscNames,
        typeof imscStyles === 'undefined' ? __nested_webpack_require_163130__(/*! ./styles */ "./node_modules/imsc/src/main/js/styles.js") : imscStyles,
        typeof imscUtils === 'undefined' ? __nested_webpack_require_163130__(/*! ./utils */ "./node_modules/imsc/src/main/js/utils.js") : imscUtils);


/***/ }),

/***/ "./node_modules/imsc/src/main/js/html.js":
/*!***********************************************!*\
  !*** ./node_modules/imsc/src/main/js/html.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_209430__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscHTML
 */

;
(function (imscHTML, imscNames, imscStyles) {

    /**
     * Function that maps <pre>smpte:background</pre> URIs to URLs resolving to image resource
     * @callback IMGResolver
     * @param {string} <pre>smpte:background</pre> URI
     * @return {string} PNG resource URL
     */


    /**
     * Renders an ISD object (returned by <pre>generateISD()</pre>) into a 
     * parent element, that must be attached to the DOM. The ISD will be rendered
     * into a child <pre>div</pre>
     * with heigh and width equal to the clientHeight and clientWidth of the element,
     * unless explicitly specified otherwise by the caller. Images URIs specified 
     * by <pre>smpte:background</pre> attributes are mapped to image resource URLs
     * by an <pre>imgResolver</pre> function. The latter takes the value of <code>smpte:background</code>
     * attribute and an <code>img</code> DOM element as input, and is expected to
     * set the <code>src</code> attribute of the <code>img</code> to the absolute URI of the image.
     * <pre>displayForcedOnlyMode</pre> sets the (boolean)
     * value of the IMSC1 displayForcedOnlyMode parameter. The function returns
     * an opaque object that should passed in <code>previousISDState</code> when this function
     * is called for the next ISD, otherwise <code>previousISDState</code> should be set to 
     * <code>null</code>.
     * 
     * @param {Object} isd ISD to be rendered
     * @param {Object} element Element into which the ISD is rendered
     * @param {?IMGResolver} imgResolver Resolve <pre>smpte:background</pre> URIs into URLs.
     * @param {?number} eheight Height (in pixel) of the child <div>div</div> or null 
     *                  to use clientHeight of the parent element
     * @param {?number} ewidth Width (in pixel) of the child <div>div</div> or null
     *                  to use clientWidth of the parent element
     * @param {?boolean} displayForcedOnlyMode Value of the IMSC1 displayForcedOnlyMode parameter,
     *                   or false if null         
     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
     * @param {Object} previousISDState State saved during processing of the previous ISD, or null if initial call
     * @param {?boolean} enableRollUp Enables roll-up animations (see CEA 708)
     * @return {Object} ISD state to be provided when this funtion is called for the next ISD
     */

    imscHTML.render = function (isd,
        element,
        imgResolver,
        eheight,
        ewidth,
        displayForcedOnlyMode,
        errorHandler,
        previousISDState,
        enableRollUp
        ) {

        /* maintain aspect ratio if specified */

        var height = eheight || element.clientHeight;
        var width = ewidth || element.clientWidth;

        if (isd.aspectRatio !== null) {

            var twidth = height * isd.aspectRatio;

            if (twidth > width) {

                height = Math.round(width / isd.aspectRatio);

            } else {

                width = twidth;

            }

        }

        var rootcontainer = document.createElement("div");

        rootcontainer.style.position = "relative";
        rootcontainer.style.width = width + "px";
        rootcontainer.style.height = height + "px";
        rootcontainer.style.margin = "auto";
        rootcontainer.style.top = 0;
        rootcontainer.style.bottom = 0;
        rootcontainer.style.left = 0;
        rootcontainer.style.right = 0;
        rootcontainer.style.zIndex = 0;

        var context = {
            h: height,
            w: width,
            regionH: null,
            regionW: null,
            imgResolver: imgResolver,
            displayForcedOnlyMode: displayForcedOnlyMode || false,
            isd: isd,
            errorHandler: errorHandler,
            previousISDState: previousISDState,
            enableRollUp: enableRollUp || false,
            currentISDState: {},
            flg: null, /* current fillLineGap value if active, null otherwise */
            lp: null, /* current linePadding value if active, null otherwise */
            mra: null, /* current multiRowAlign value if active, null otherwise */
            ipd: null, /* inline progression direction (lr, rl, tb) */
            bpd: null /* block progression direction (lr, rl, tb) */
        };

        element.appendChild(rootcontainer);

        for (var i in isd.contents) {

            processElement(context, rootcontainer, isd.contents[i]);

        }

        return context.currentISDState;

    };

    function processElement(context, dom_parent, isd_element) {

        var e;

        if (isd_element.kind === 'region') {

            e = document.createElement("div");
            e.style.position = "absolute";

        } else if (isd_element.kind === 'body') {

            e = document.createElement("div");

        } else if (isd_element.kind === 'div') {

            e = document.createElement("div");

        } else if (isd_element.kind === 'p') {

            e = document.createElement("p");

        } else if (isd_element.kind === 'span') {

            e = document.createElement("span");

            //e.textContent = isd_element.text;

        } else if (isd_element.kind === 'br') {

            e = document.createElement("br");

        }

        if (!e) {

            reportError(context.errorHandler, "Error processing ISD element kind: " + isd_element.kind);

            return;

        }

        /* override UA default margin */
        /* TODO: should apply to <p> only */

        e.style.margin = "0";

        /* tranform TTML styles to CSS styles */

        for (var i in STYLING_MAP_DEFS) {

            var sm = STYLING_MAP_DEFS[i];

            var attr = isd_element.styleAttrs[sm.qname];

            if (attr !== undefined && sm.map !== null) {

                sm.map(context, e, isd_element, attr);

            }

        }

        var proc_e = e;

        /* remember writing direction */

        if (isd_element.kind === "region") {

            var wdir = isd_element.styleAttrs[imscStyles.byName.writingMode.qname];

            if (wdir === "lrtb" || wdir === "lr") {

                context.ipd = "lr";
                context.bpd = "tb";

            } else if (wdir === "rltb" || wdir === "rl") {

                context.ipd = "rl";
                context.bpd = "tb";

            } else if (wdir === "tblr") {

                context.ipd = "tb";
                context.bpd = "lr";

            } else if (wdir === "tbrl" || wdir === "tb") {

                context.ipd = "tb";
                context.bpd = "rl";

            }

        }

        /* do we have linePadding ? */

        var lp = isd_element.styleAttrs[imscStyles.byName.linePadding.qname];

        if (lp && lp > 0) {

            /* apply padding to the <p> so that line padding does not cause line wraps */

            var padmeasure = Math.ceil(lp * context.h) + "px";

            if (context.bpd === "tb") {

                proc_e.style.paddingLeft = padmeasure;
                proc_e.style.paddingRight = padmeasure;

            } else {

                proc_e.style.paddingTop = padmeasure;
                proc_e.style.paddingBottom = padmeasure;

            }

            context.lp = lp;
        }

        // do we have multiRowAlign?

        var mra = isd_element.styleAttrs[imscStyles.byName.multiRowAlign.qname];

        if (mra && mra !== "auto") {

            /* create inline block to handle multirowAlign */

            var s = document.createElement("span");

            s.style.display = "inline-block";

            s.style.textAlign = mra;

            e.appendChild(s);

            proc_e = s;

            context.mra = mra;

        }

        /* remember we are filling line gaps */

        if (isd_element.styleAttrs[imscStyles.byName.fillLineGap.qname]) {
            context.flg = true;
        }


        if (isd_element.kind === "span" && isd_element.text) {

            if (context.lp || context.mra || context.flg) {

                // wrap characters in spans to find the line wrap locations

                var cbuf = '';

                for (var j = 0; j < isd_element.text.length; j++) {

                    cbuf += isd_element.text.charAt(j);

                    var cc = isd_element.text.charCodeAt(j);

                    if (cc < 0xD800 || cc > 0xDBFF || j === isd_element.text.length) {

                        /* wrap the character(s) in a span unless it is a high surrogate */

                        var span = document.createElement("span");

                        span.textContent = cbuf;
    
                        e.appendChild(span);

                        cbuf = '';

                    }

                }

            } else {

                e.textContent = isd_element.text;

            }
        }

        dom_parent.appendChild(e);

        /* process the children of the ISD element */

        for (var k in isd_element.contents) {

            processElement(context, proc_e, isd_element.contents[k]);

        }

        /* list of lines */

        var linelist = [];


        /* paragraph processing */
        /* TODO: linePadding only supported for horizontal scripts */

        if ((context.lp || context.mra || context.flg) && isd_element.kind === "p") {

            constructLineList(context, proc_e, linelist, null);

            /* insert line breaks for multirowalign */

            if (context.mra) {

                applyMultiRowAlign(linelist);

                context.mra = null;

            }

            /* add linepadding */

            if (context.lp) {

                applyLinePadding(linelist, context.lp * context.h, context);

                context.lp = null;

            }

            /* fill line gaps linepadding */

            if (context.flg) {

                var par_edges = rect2edges(proc_e.getBoundingClientRect(), context);

                applyFillLineGap(linelist, par_edges.before, par_edges.after, context);

                context.flg = null;

            }

        }


        /* region processing */

        if (isd_element.kind === "region") {

            /* build line list */

            constructLineList(context, proc_e, linelist);

            /* perform roll up if needed */

            if ((context.bpd === "tb") &&
                context.enableRollUp &&
                isd_element.contents.length > 0 &&
                isd_element.styleAttrs[imscStyles.byName.displayAlign.qname] === 'after') {

                /* horrible hack, perhaps default region id should be underscore everywhere? */

                var rid = isd_element.id === '' ? '_' : isd_element.id;

                var rb = new RegionPBuffer(rid, linelist);

                context.currentISDState[rb.id] = rb;

                if (context.previousISDState &&
                    rb.id in context.previousISDState &&
                    context.previousISDState[rb.id].plist.length > 0 &&
                    rb.plist.length > 1 &&
                    rb.plist[rb.plist.length - 2].text ===
                    context.previousISDState[rb.id].plist[context.previousISDState[rb.id].plist.length - 1].text) {

                    var body_elem = e.firstElementChild;
                    
                    var h = rb.plist[rb.plist.length - 1].after - rb.plist[rb.plist.length - 1].before;

                    body_elem.style.bottom = "-" + h + "px";
                    body_elem.style.transition = "transform 0.4s";
                    body_elem.style.position = "relative";
                    body_elem.style.transform = "translateY(-" + h + "px)";

                }

            }

            /* TODO: clean-up the spans ? */

        }
    }

    function applyLinePadding(lineList, lp, context) {

        for (var i in lineList) {

            var l = lineList[i].elements.length;

            var se = lineList[i].elements[lineList[i].start_elem];

            var ee = lineList[i].elements[lineList[i].end_elem];

            var pospadpxlen = Math.ceil(lp) + "px";

            var negpadpxlen = "-" + Math.ceil(lp) + "px";

            if (l !== 0) {

                if (context.ipd === "lr") {

                    se.node.style.borderLeftColor = se.bgcolor || "#00000000";
                    se.node.style.borderLeftStyle = "solid";
                    se.node.style.borderLeftWidth = pospadpxlen;
                    se.node.style.marginLeft = negpadpxlen;

                } else if (context.ipd === "rl") {

                    se.node.style.borderRightColor = se.bgcolor || "#00000000";
                    se.node.style.borderRightStyle = "solid";
                    se.node.style.borderRightWidth = pospadpxlen;
                    se.node.style.marginRight = negpadpxlen;

                } else if (context.ipd === "tb") {

                    se.node.style.borderTopColor = se.bgcolor || "#00000000";
                    se.node.style.borderTopStyle = "solid";
                    se.node.style.borderTopWidth = pospadpxlen;
                    se.node.style.marginTop = negpadpxlen;

                }

                if (context.ipd === "lr") {

                    ee.node.style.borderRightColor = ee.bgcolor  || "#00000000";
                    ee.node.style.borderRightStyle = "solid";
                    ee.node.style.borderRightWidth = pospadpxlen;
                    ee.node.style.marginRight = negpadpxlen;

                } else if (context.ipd === "rl") {

                    ee.node.style.borderLeftColor = ee.bgcolor || "#00000000";
                    ee.node.style.borderLeftStyle = "solid";
                    ee.node.style.borderLeftWidth = pospadpxlen;
                    ee.node.style.marginLeft = negpadpxlen;

                } else if (context.ipd === "tb") {

                    ee.node.style.borderBottomColor = ee.bgcolor || "#00000000";
                    ee.node.style.borderBottomStyle = "solid";
                    ee.node.style.borderBottomWidth = pospadpxlen;
                    ee.node.style.marginBottom = negpadpxlen;

                }

            }

        }

    }

    function applyMultiRowAlign(lineList) {

        /* apply an explicit br to all but the last line */

        for (var i = 0; i < lineList.length - 1; i++) {

            var l = lineList[i].elements.length;

            if (l !== 0 && lineList[i].br === false) {
                var br = document.createElement("br");

                var lastnode = lineList[i].elements[l - 1].node;

                lastnode.parentElement.insertBefore(br, lastnode.nextSibling);
            }

        }

    }

    function applyFillLineGap(lineList, par_before, par_after, context) {

        /* positive for BPD = lr and tb, negative for BPD = rl */
        var s = Math.sign(par_after - par_before);

        for (var i = 0; i <= lineList.length; i++) {

            /* compute frontier between lines */

            var frontier;

            if (i === 0) {

                frontier = par_before;

            } else if (i === lineList.length) {

                frontier = par_after;

            } else {

                frontier = (lineList[i].before + lineList[i - 1].after) / 2;

            }

            /* padding amount */

            var pad;

            /* current element */

            var e;

            /* before line */

            if (i > 0) {

                for (var j = 0; j < lineList[i - 1].elements.length; j++) {

                    if (lineList[i - 1].elements[j].bgcolor === null) continue;

                    e = lineList[i - 1].elements[j];

                    if (s * (e.after - frontier) < 0) {

                        pad = Math.ceil(Math.abs(frontier - e.after)) + "px";

                        e.node.style.backgroundColor = e.bgcolor;

                        if (context.bpd === "lr") {

                            e.node.style.paddingRight = pad;


                        } else if (context.bpd === "rl") {

                            e.node.style.paddingLeft = pad;

                        } else if (context.bpd === "tb") {

                            e.node.style.paddingBottom = pad;

                        }

                    }

                }

            }

            /* after line */

            if (i < lineList.length) {

                for (var k = 0; k < lineList[i].elements.length; k++) {

                    e = lineList[i].elements[k];

                    if (e.bgcolor === null) continue;

                    if (s * (e.before - frontier) > 0) {

                        pad = Math.ceil(Math.abs(e.before - frontier)) + "px";

                        e.node.style.backgroundColor = e.bgcolor;

                        if (context.bpd === "lr") {

                            e.node.style.paddingLeft = pad;


                        } else if (context.bpd === "rl") {

                            e.node.style.paddingRight = pad;


                        } else if (context.bpd === "tb") {

                            e.node.style.paddingTop = pad;

                        }

                    }

                }

            }

        }

    }

    function RegionPBuffer(id, lineList) {

        this.id = id;

        this.plist = lineList;

    }

    function pruneEmptySpans(element) {

        var child = element.firstChild;

        while (child) {

            var nchild = child.nextSibling;

            if (child.nodeType === Node.ELEMENT_NODE &&
                child.localName === 'span') {

                pruneEmptySpans(child);

                if (child.childElementCount === 0 &&
                    child.textContent.length === 0) {

                    element.removeChild(child);

                }
            }

            child = nchild;
        }

    }

    function rect2edges(rect, context) {

        var edges = {before: null, after: null, start: null, end: null};

        if (context.bpd === "tb") {

            edges.before = rect.top;
            edges.after = rect.bottom;

            if (context.ipd === "lr") {

                edges.start = rect.left;
                edges.end = rect.right;

            } else {

                edges.start = rect.right;
                edges.end = rect.left;
            }

        } else if (context.bpd === "lr") {

            edges.before = rect.left;
            edges.after = rect.right;
            edges.start = rect.top;
            edges.end = rect.bottom;

        } else if (context.bpd === "rl") {

            edges.before = rect.right;
            edges.after = rect.left;
            edges.start = rect.top;
            edges.end = rect.bottom;

        }

        return edges;

    }

    function constructLineList(context, element, llist, bgcolor) {

        var curbgcolor = element.style.backgroundColor || bgcolor;

        if (element.childElementCount === 0) {

            if (element.localName === 'span') {

                var r = element.getBoundingClientRect();

                /* skip if span is not displayed */

                if (r.height === 0 || r.width === 0) return;

                var edges = rect2edges(r, context);

                if (llist.length === 0 ||
                    (!isSameLine(edges.before, edges.after, llist[llist.length - 1].before, llist[llist.length - 1].after))
                    ) {

                    llist.push({
                        before: edges.before,
                        after: edges.after,
                        start: edges.start,
                        end: edges.end,
                        start_elem: 0,
                        end_elem: 0,
                        elements: [],
                        text: "",
                        br: false
                    });

                } else {

                    /* positive for BPD = lr and tb, negative for BPD = rl */
                    var bpd_dir = Math.sign(edges.after - edges.before);

                    /* positive for IPD = lr and tb, negative for IPD = rl */
                    var ipd_dir = Math.sign(edges.end - edges.start);

                    /* check if the line height has increased */

                    if (bpd_dir * (edges.before - llist[llist.length - 1].before) < 0) {
                        llist[llist.length - 1].before = edges.before;
                    }

                    if (bpd_dir * (edges.after - llist[llist.length - 1].after) > 0) {
                        llist[llist.length - 1].after = edges.after;
                    }

                    if (ipd_dir * (edges.start - llist[llist.length - 1].start) < 0) {
                        llist[llist.length - 1].start = edges.start;
                        llist[llist.length - 1].start_elem = llist[llist.length - 1].elements.length;
                    }

                    if (ipd_dir * (edges.end - llist[llist.length - 1].end) > 0) {
                        llist[llist.length - 1].end = edges.end;
                        llist[llist.length - 1].end_elem = llist[llist.length - 1].elements.length;
                    }

                }

                llist[llist.length - 1].text += element.textContent;

                llist[llist.length - 1].elements.push(
                    {
                        node: element,
                        bgcolor: curbgcolor,
                        before: edges.before,
                        after: edges.after
                    }
                );

            } else if (element.localName === 'br' && llist.length !== 0) {

                llist[llist.length - 1].br = true;

            }

        } else {

            var child = element.firstChild;

            while (child) {

                if (child.nodeType === Node.ELEMENT_NODE) {

                    constructLineList(context, child, llist, curbgcolor);

                }

                child = child.nextSibling;
            }
        }

    }

    function isSameLine(before1, after1, before2, after2) {

        return ((after1 < after2) && (before1 > before2)) || ((after2 <= after1) && (before2 >= before1));

    }

    function HTMLStylingMapDefintion(qName, mapFunc) {
        this.qname = qName;
        this.map = mapFunc;
    }

    var STYLING_MAP_DEFS = [

        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling backgroundColor",
            function (context, dom_element, isd_element, attr) {

                /* skip if transparent */
                if (attr[3] === 0) return;

                dom_element.style.backgroundColor = "rgba(" +
                    attr[0].toString() + "," +
                    attr[1].toString() + "," +
                    attr[2].toString() + "," +
                    (attr[3] / 255).toString() +
                    ")";
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling color",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.color = "rgba(" +
                    attr[0].toString() + "," +
                    attr[1].toString() + "," +
                    attr[2].toString() + "," +
                    (attr[3] / 255).toString() +
                    ")";
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling direction",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.direction = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling display",
            function (context, dom_element, isd_element, attr) {}
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling displayAlign",
            function (context, dom_element, isd_element, attr) {

                /* see https://css-tricks.com/snippets/css/a-guide-to-flexbox/ */

                /* TODO: is this affected by writing direction? */

                dom_element.style.display = "flex";
                dom_element.style.flexDirection = "column";


                if (attr === "before") {

                    dom_element.style.justifyContent = "flex-start";

                } else if (attr === "center") {

                    dom_element.style.justifyContent = "center";

                } else if (attr === "after") {

                    dom_element.style.justifyContent = "flex-end";
                }

            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling extent",
            function (context, dom_element, isd_element, attr) {
                /* TODO: this is super ugly */

                context.regionH = (attr.h * context.h);
                context.regionW = (attr.w * context.w);

                /* 
                 * CSS height/width are measured against the content rectangle,
                 * whereas TTML height/width include padding
                 */

                var hdelta = 0;
                var wdelta = 0;

                var p = isd_element.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];

                if (!p) {

                    /* error */

                } else {

                    hdelta = (p[0] + p[2]) * context.h;
                    wdelta = (p[1] + p[3]) * context.w;

                }

                dom_element.style.height = (context.regionH - hdelta) + "px";
                dom_element.style.width = (context.regionW - wdelta) + "px";

            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling fontFamily",
            function (context, dom_element, isd_element, attr) {

                var rslt = [];

                /* per IMSC1 */

                for (var i in attr) {

                    if (attr[i] === "monospaceSerif") {

                        rslt.push("Courier New");
                        rslt.push('"Liberation Mono"');
                        rslt.push("Courier");
                        rslt.push("monospace");

                    } else if (attr[i] === "proportionalSansSerif") {

                        rslt.push("Arial");
                        rslt.push("Helvetica");
                        rslt.push('"Liberation Sans"');
                        rslt.push("sans-serif");

                    } else if (attr[i] === "monospace") {

                        rslt.push("monospace");

                    } else if (attr[i] === "sansSerif") {

                        rslt.push("sans-serif");

                    } else if (attr[i] === "serif") {

                        rslt.push("serif");

                    } else if (attr[i] === "monospaceSansSerif") {

                        rslt.push("Consolas");
                        rslt.push("monospace");

                    } else if (attr[i] === "proportionalSerif") {

                        rslt.push("serif");

                    } else {

                        rslt.push(attr[i]);

                    }

                }

                dom_element.style.fontFamily = rslt.join(",");
            }
        ),

        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling fontSize",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.fontSize = (attr * context.h) + "px";
            }
        ),

        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling fontStyle",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.fontStyle = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling fontWeight",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.fontWeight = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling lineHeight",
            function (context, dom_element, isd_element, attr) {
                if (attr === "normal") {

                    dom_element.style.lineHeight = "normal";

                } else {

                    dom_element.style.lineHeight = (attr * context.h) + "px";
                }
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling opacity",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.opacity = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling origin",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.top = (attr.h * context.h) + "px";
                dom_element.style.left = (attr.w * context.w) + "px";
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling overflow",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.overflow = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling padding",
            function (context, dom_element, isd_element, attr) {

                /* attr: top,left,bottom,right*/

                /* style: top right bottom left*/

                var rslt = [];

                rslt[0] = (attr[0] * context.h) + "px";
                rslt[1] = (attr[3] * context.w) + "px";
                rslt[2] = (attr[2] * context.h) + "px";
                rslt[3] = (attr[1] * context.w) + "px";

                dom_element.style.padding = rslt.join(" ");
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling showBackground",
            null
            ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling textAlign",
            function (context, dom_element, isd_element, attr) {

                var ta;
                var dir = isd_element.styleAttrs[imscStyles.byName.direction.qname];

                /* handle UAs that do not understand start or end */

                if (attr === "start") {

                    ta = (dir === "rtl") ? "right" : "left";

                } else if (attr === "end") {

                    ta = (dir === "rtl") ? "left" : "right";

                } else {

                    ta = attr;

                }

                dom_element.style.textAlign = ta;

            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling textDecoration",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.textDecoration = attr.join(" ").replace("lineThrough", "line-through");
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling textOutline",
            function (context, dom_element, isd_element, attr) {

                if (attr === "none") {

                    dom_element.style.textShadow = "";

                } else {

                    dom_element.style.textShadow = "rgba(" +
                        attr.color[0].toString() + "," +
                        attr.color[1].toString() + "," +
                        attr.color[2].toString() + "," +
                        (attr.color[3] / 255).toString() +
                        ")" + " 0px 0px " +
                        (attr.thickness * context.h) + "px";

                }
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling unicodeBidi",
            function (context, dom_element, isd_element, attr) {

                var ub;

                if (attr === 'bidiOverride') {
                    ub = "bidi-override";
                } else {
                    ub = attr;
                }

                dom_element.style.unicodeBidi = ub;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling visibility",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.visibility = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling wrapOption",
            function (context, dom_element, isd_element, attr) {

                if (attr === "wrap") {

                    if (isd_element.space === "preserve") {
                        dom_element.style.whiteSpace = "pre-wrap";
                    } else {
                        dom_element.style.whiteSpace = "normal";
                    }

                } else {

                    if (isd_element.space === "preserve") {

                        dom_element.style.whiteSpace = "pre";

                    } else {
                        dom_element.style.whiteSpace = "noWrap";
                    }

                }

            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling writingMode",
            function (context, dom_element, isd_element, attr) {
                if (attr === "lrtb" || attr === "lr") {

                    dom_element.style.writingMode = "horizontal-tb";

                } else if (attr === "rltb" || attr === "rl") {

                    dom_element.style.writingMode = "horizontal-tb";

                } else if (attr === "tblr") {

                    dom_element.style.writingMode = "vertical-lr";

                } else if (attr === "tbrl" || attr === "tb") {

                    dom_element.style.writingMode = "vertical-rl";

                }
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml#styling zIndex",
            function (context, dom_element, isd_element, attr) {
                dom_element.style.zIndex = attr;
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage",
            function (context, dom_element, isd_element, attr) {

                if (context.imgResolver !== null && attr !== null) {

                    var img = document.createElement("img");

                    var uri = context.imgResolver(attr, img);

                    if (uri)
                        img.src = uri;

                    img.height = context.regionH;
                    img.width = context.regionW;

                    dom_element.appendChild(img);
                }
            }
        ),
        new HTMLStylingMapDefintion(
            "http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay",
            function (context, dom_element, isd_element, attr) {

                if (context.displayForcedOnlyMode && attr === false) {
                    dom_element.style.visibility = "hidden";
                }

            }
        )
    ];

    var STYLMAP_BY_QNAME = {};

    for (var i in STYLING_MAP_DEFS) {

        STYLMAP_BY_QNAME[STYLING_MAP_DEFS[i].qname] = STYLING_MAP_DEFS[i];
    }

    function reportError(errorHandler, msg) {

        if (errorHandler && errorHandler.error && errorHandler.error(msg))
            throw msg;

    }

})(  false ? 0 : exports,
    typeof imscNames === 'undefined' ? __nested_webpack_require_209430__(/*! ./names */ "./node_modules/imsc/src/main/js/names.js") : imscNames,
    typeof imscStyles === 'undefined' ? __nested_webpack_require_209430__(/*! ./styles */ "./node_modules/imsc/src/main/js/styles.js") : imscStyles);

/***/ }),

/***/ "./node_modules/imsc/src/main/js/isd.js":
/*!**********************************************!*\
  !*** ./node_modules/imsc/src/main/js/isd.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_247961__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscISD
 */


;
(function (imscISD, imscNames, imscStyles) { // wrapper for non-node envs

    /** 
     * Creates a canonical representation of an IMSC1 document returned by <pre>imscDoc.fromXML()</pre>
     * at a given absolute offset in seconds. This offset does not have to be one of the values returned
     * by <pre>getMediaTimeEvents()</pre>.
     * 
     * @param {Object} tt IMSC1 document
     * @param {number} offset Absolute offset (in seconds)
     * @param {?module:imscUtils.ErrorHandler} errorHandler Error callback
     * @returns {Object} Opaque in-memory representation of an ISD
     */

    imscISD.generateISD = function (tt, offset, errorHandler) {

        /* TODO check for tt and offset validity */

        /* create the ISD object from the IMSC1 doc */

        var isd = new ISD(tt);
        
        /* context */
        
        var context = {
          
            /* empty for now */
            
        };

        /* process regions */

        for (var r in tt.head.layout.regions) {

            /* post-order traversal of the body tree per [construct intermediate document] */

            var c = isdProcessContentElement(tt, offset, tt.head.layout.regions[r], tt.body, null, '', tt.head.layout.regions[r], errorHandler, context);

            if (c !== null) {

                /* add the region to the ISD */

                isd.contents.push(c.element);
            }


        }

        return isd;
    };

    function isdProcessContentElement(doc, offset, region, body, parent, inherited_region_id, elem, errorHandler, context) {

        /* prune if temporally inactive */

        if (offset < elem.begin || offset >= elem.end) {
            return null;
        }

        /* 
         * set the associated region as specified by the regionID attribute, or the 
         * inherited associated region otherwise
         */

        var associated_region_id = 'regionID' in elem && elem.regionID !== '' ? elem.regionID : inherited_region_id;

        /* prune the element if either:
         * - the element is not terminal and the associated region is neither the default
         *   region nor the parent region (this allows children to be associated with a 
         *   region later on)
         * - the element is terminal and the associated region is not the parent region
         */
        
        /* TODO: improve detection of terminal elements since <region> has no contents */

        if (parent !== null /* are we in the region element */ &&
            associated_region_id !== region.id &&
                (
                    (! ('contents' in elem)) ||
                    ('contents' in elem && elem.contents.length === 0) ||
                    associated_region_id !== ''
                )
             )
            return null;

        /* create an ISD element, including applying specified styles */

        var isd_element = new ISDContentElement(elem);

        /* apply set (animation) styling */

        for (var i in elem.sets) {

            if (offset < elem.sets[i].begin || offset >= elem.sets[i].end)
                continue;

            isd_element.styleAttrs[elem.sets[i].qname] = elem.sets[i].value;

        }

        /* 
         * keep track of specified styling attributes so that we
         * can compute them later
         */

        var spec_attr = {};

        for (var qname in isd_element.styleAttrs) {

            spec_attr[qname] = true;

            /* special rule for tts:writingMode (section 7.29.1 of XSL)
             * direction is set consistently with writingMode only
             * if writingMode sets inline-direction to LTR or RTL  
             */

            if (qname === imscStyles.byName.writingMode.qname &&
                !(imscStyles.byName.direction.qname in isd_element.styleAttrs)) {

                var wm = isd_element.styleAttrs[qname];

                if (wm === "lrtb" || wm === "lr") {

                    isd_element.styleAttrs[imscStyles.byName.direction.qname] = "ltr";

                } else if (wm === "rltb" || wm === "rl") {

                    isd_element.styleAttrs[imscStyles.byName.direction.qname] = "rtl";

                }

            }
        }

        /* inherited styling */

        if (parent !== null) {

            for (var j in imscStyles.all) {

                var sa = imscStyles.all[j];

                /* textDecoration has special inheritance rules */

                if (sa.qname === imscStyles.byName.textDecoration.qname) {

                    /* handle both textDecoration inheritance and specification */

                    var ps = parent.styleAttrs[sa.qname];
                    var es = isd_element.styleAttrs[sa.qname];
                    var outs = [];

                    if (es === undefined) {

                        outs = ps;

                    } else if (es.indexOf("none") === -1) {

                        if ((es.indexOf("noUnderline") === -1 &&
                            ps.indexOf("underline") !== -1) ||
                            es.indexOf("underline") !== -1) {

                            outs.push("underline");

                        }

                        if ((es.indexOf("noLineThrough") === -1 &&
                            ps.indexOf("lineThrough") !== -1) ||
                            es.indexOf("lineThrough") !== -1) {

                            outs.push("lineThrough");

                        }

                        if ((es.indexOf("noOverline") === -1 &&
                            ps.indexOf("overline") !== -1) ||
                            es.indexOf("overline") !== -1) {

                            outs.push("overline");

                        }

                    } else {

                        outs.push("none");

                    }

                    isd_element.styleAttrs[sa.qname] = outs;

                } else if (sa.inherit &&
                    (sa.qname in parent.styleAttrs) &&
                    !(sa.qname in isd_element.styleAttrs)) {

                    isd_element.styleAttrs[sa.qname] = parent.styleAttrs[sa.qname];

                }

            }

        }

        /* initial value styling */

        for (var k in imscStyles.all) {

            var ivs = imscStyles.all[k];

            /* skip if value is already specified */

            if (ivs.qname in isd_element.styleAttrs) continue;

            /* apply initial value to elements other than region only if non-inherited */

            if (isd_element.kind === 'region' || (ivs.inherit === false && ivs.initial !== null)) {

                isd_element.styleAttrs[ivs.qname] = ivs.parse(ivs.initial);

                /* keep track of the style as specified */

                spec_attr[ivs.qname] = true;

            }

        }

        /* compute styles (only for non-inherited styles) */
        /* TODO: get rid of spec_attr */

        for (var z in imscStyles.all) {

            var cs = imscStyles.all[z];

            if (!(cs.qname in spec_attr)) continue;

            if (cs.compute !== null) {

                var cstyle = cs.compute(
                    /*doc, parent, element, attr, context*/
                    doc,
                    parent,
                    isd_element,
                    isd_element.styleAttrs[cs.qname],
                    context
                    );

                if (cstyle !== null) {
                    isd_element.styleAttrs[cs.qname] = cstyle;
                } else {
                    reportError(errorHandler, "Style '" + cs.qname + "' on element '" + isd_element.kind + "' cannot be computed");
                }
            }

        }

        /* prune if tts:display is none */

        if (isd_element.styleAttrs[imscStyles.byName.display.qname] === "none")
            return null;

        /* process contents of the element */

        var contents;

        if (parent === null) {

            /* we are processing the region */

            if (body === null) {

                /* if there is no body, still process the region but with empty content */

                contents = [];

            } else {

                /*use the body element as contents */

                contents = [body];

            }

        } else if ('contents' in elem) {

            contents = elem.contents;

        }

        for (var x in contents) {

            var c = isdProcessContentElement(doc, offset, region, body, isd_element, associated_region_id, contents[x], errorHandler, context);

            /* 
             * keep child element only if they are non-null and their region match 
             * the region of this element
             */

            if (c !== null) {

                isd_element.contents.push(c.element);

            }

        }

        /* compute used value of lineHeight="normal" */

        /*        if (isd_element.styleAttrs[imscStyles.byName.lineHeight.qname] === "normal"  ) {
         
         isd_element.styleAttrs[imscStyles.byName.lineHeight.qname] =
         isd_element.styleAttrs[imscStyles.byName.fontSize.qname] * 1.2;
         
         }
         */

        /* remove styles that are not applicable */

        for (var qnameb in isd_element.styleAttrs) {
            var da = imscStyles.byQName[qnameb];

            if (da.applies.indexOf(isd_element.kind) === -1) {
                delete isd_element.styleAttrs[qnameb];
            }
        }

        /* collapse white space if space is "default" */

        if (isd_element.kind === 'span' && isd_element.text && isd_element.space === "default") {

            var trimmedspan = isd_element.text.replace(/\s+/g, ' ');

            isd_element.text = trimmedspan;

        }

        /* trim whitespace around explicit line breaks */

        if (isd_element.kind === 'p') {

            var elist = [];

            constructSpanList(isd_element, elist);

            var l = 0;

            var state = "after_br";
            var br_pos = 0;

            while (true) {

                if (state === "after_br") {

                    if (l >= elist.length || elist[l].kind === "br") {

                        state = "before_br";
                        br_pos = l;
                        l--;

                    } else {

                        if (elist[l].space !== "preserve") {

                            elist[l].text = elist[l].text.replace(/^\s+/g, '');

                        }

                        if (elist[l].text.length > 0) {

                            state = "looking_br";
                            l++;

                        } else {

                            elist.splice(l, 1);

                        }

                    }

                } else if (state === "before_br") {

                    if (l < 0 || elist[l].kind === "br") {

                        state = "after_br";
                        l = br_pos + 1;

                        if (l >= elist.length) break;

                    } else {

                        if (elist[l].space !== "preserve") {

                            elist[l].text = elist[l].text.replace(/\s+$/g, '');

                        }

                        if (elist[l].text.length > 0) {

                            state = "after_br";
                            l = br_pos + 1;

                            if (l >= elist.length) break;

                        } else {

                            elist.splice(l, 1);
                            l--;

                        }

                    }

                } else {

                    if (l >= elist.length || elist[l].kind === "br") {

                        state = "before_br";
                        br_pos = l;
                        l--;

                    } else {

                        l++;

                    }

                }

            }
            
            pruneEmptySpans(isd_element);

        }

        /* keep element if:
         * * contains a background image
         * * <br/>
         * * if there are children
         * * if <span> and has text
         * * if region and showBackground = always
         */

        if ((isd_element.kind === 'div' && imscStyles.byName.backgroundImage.qname in isd_element.styleAttrs) ||
            isd_element.kind === 'br' ||
            ('contents' in isd_element && isd_element.contents.length > 0) ||
            (isd_element.kind === 'span' && isd_element.text !== null) ||
            (isd_element.kind === 'region' &&
                isd_element.styleAttrs[imscStyles.byName.showBackground.qname] === 'always')) {

            return {
                region_id: associated_region_id,
                element: isd_element
            };
        }

        return null;
    }

    function constructSpanList(element, elist) {

        if ('contents' in element) {

            for (var i in element.contents) {
                constructSpanList(element.contents[i], elist);
            }

        } else {

            elist.push(element);

        }

    }

    function pruneEmptySpans(element) {

        if (element.kind === 'br') {
            
            return false;
            
        } else if ('text' in element) {
            
            return  element.text.length === 0;
            
        } else if ('contents' in element) {
            
            var i = element.contents.length;

            while (i--) {
                
                if (pruneEmptySpans(element.contents[i])) {
                    element.contents.splice(i, 1);
                }
                
            }
            
            return element.contents.length === 0;

        }
    }

    function ISD(tt) {
        this.contents = [];
        this.aspectRatio = tt.aspectRatio;
    }

    function ISDContentElement(ttelem) {

        /* assume the element is a region if it does not have a kind */

        this.kind = ttelem.kind || 'region';
        
        /* copy id */
        
        if (ttelem.id) {
            this.id = ttelem.id;
        }

        /* deep copy of style attributes */
        this.styleAttrs = {};

        for (var sname in ttelem.styleAttrs) {

            this.styleAttrs[sname] =
                ttelem.styleAttrs[sname];
        }

        /* TODO: clean this! */

        if ('text' in ttelem) {

            this.text = ttelem.text;

        } else if (ttelem.kind !== 'br') {
            
            this.contents = [];
        }

        if ('space' in ttelem) {

            this.space = ttelem.space;
        }
    }


    /*
     * ERROR HANDLING UTILITY FUNCTIONS
     * 
     */

    function reportInfo(errorHandler, msg) {

        if (errorHandler && errorHandler.info && errorHandler.info(msg))
            throw msg;

    }

    function reportWarning(errorHandler, msg) {

        if (errorHandler && errorHandler.warn && errorHandler.warn(msg))
            throw msg;

    }

    function reportError(errorHandler, msg) {

        if (errorHandler && errorHandler.error && errorHandler.error(msg))
            throw msg;

    }

    function reportFatal(errorHandler, msg) {

        if (errorHandler && errorHandler.fatal)
            errorHandler.fatal(msg);

        throw msg;

    }


})(  false ? 0 : exports,
    typeof imscNames === 'undefined' ? __nested_webpack_require_247961__(/*! ./names */ "./node_modules/imsc/src/main/js/names.js") : imscNames,
    typeof imscStyles === 'undefined' ? __nested_webpack_require_247961__(/*! ./styles */ "./node_modules/imsc/src/main/js/styles.js") : imscStyles
    );


/***/ }),

/***/ "./node_modules/imsc/src/main/js/main.js":
/*!***********************************************!*\
  !*** ./node_modules/imsc/src/main/js/main.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_265869__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

exports.generateISD = __nested_webpack_require_265869__(/*! ./isd */ "./node_modules/imsc/src/main/js/isd.js").generateISD;
exports.fromXML = __nested_webpack_require_265869__(/*! ./doc */ "./node_modules/imsc/src/main/js/doc.js").fromXML;
exports.renderHTML = __nested_webpack_require_265869__(/*! ./html */ "./node_modules/imsc/src/main/js/html.js").render;

/***/ }),

/***/ "./node_modules/imsc/src/main/js/names.js":
/*!************************************************!*\
  !*** ./node_modules/imsc/src/main/js/names.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscNames
 */

;
(function (imscNames) { // wrapper for non-node envs

    imscNames.ns_tt = "http://www.w3.org/ns/ttml";
    imscNames.ns_tts = "http://www.w3.org/ns/ttml#styling";
    imscNames.ns_ttp = "http://www.w3.org/ns/ttml#parameter";
    imscNames.ns_xml = "http://www.w3.org/XML/1998/namespace";
    imscNames.ns_itts = "http://www.w3.org/ns/ttml/profile/imsc1#styling";
    imscNames.ns_ittp = "http://www.w3.org/ns/ttml/profile/imsc1#parameter";
    imscNames.ns_smpte = "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt";
    imscNames.ns_ebutts = "urn:ebu:tt:style";
    
})(  false ? 0 : exports);






/***/ }),

/***/ "./node_modules/imsc/src/main/js/styles.js":
/*!*************************************************!*\
  !*** ./node_modules/imsc/src/main/js/styles.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_270351__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscStyles
 */

;
(function (imscStyles, imscNames, imscUtils) { // wrapper for non-node envs

    function StylingAttributeDefinition(ns, name, initialValue, appliesTo, isInherit, isAnimatable, parseFunc, computeFunc) {
        this.name = name;
        this.ns = ns;
        this.qname = ns + " " + name;
        this.inherit = isInherit;
        this.animatable = isAnimatable;
        this.initial = initialValue;
        this.applies = appliesTo;
        this.parse = parseFunc;
        this.compute = computeFunc;
    }

    imscStyles.all = [

        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "backgroundColor",
                "transparent",
                ['body', 'div', 'p', 'region', 'span'],
                false,
                true,
                imscUtils.parseColor,
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "color",
                "white",
                ['span'],
                true,
                true,
                imscUtils.parseColor,
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "direction",
                "ltr",
                ['p', 'span'],
                true,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "display",
                "auto",
                ['body', 'div', 'p', 'region', 'span'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "displayAlign",
                "before",
                ['region'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "extent",
                "auto",
                ['tt', 'region'],
                false,
                true,
                function (str) {

                    if (str === "auto") {

                        return str;

                    } else {

                        var s = str.split(" ");
                        if (s.length !== 2) return null;
                        var w = imscUtils.parseLength(s[0]);
                        var h = imscUtils.parseLength(s[1]);
                        if (!h || !w) return null;
                        return {'h': h, 'w': w};
                    }

                },
                function (doc, parent, element, attr, context) {

                    var h;
                    var w;

                    if (attr === "auto") {

                        h = 1;

                    } else if (attr.h.unit === "%") {

                        h = attr.h.value / 100;

                    } else if (attr.h.unit === "px") {

                        h = attr.h.value / doc.pxDimensions.h;

                    } else {

                        return null;

                    }

                    if (attr === "auto") {

                        w = 1;

                    } else if (attr.w.unit === "%") {

                        w = attr.w.value / 100;

                    } else if (attr.w.unit === "px") {

                        w = attr.w.value / doc.pxDimensions.w;

                    } else {

                        return null;

                    }

                    return {'h': h, 'w': w};
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "fontFamily",
                "default",
                ['span'],
                true,
                true,
                function (str) {
                    var ffs = str.split(",");
                    var rslt = [];

                    for (var i in ffs) {

                        if (ffs[i].charAt(0) !== "'" && ffs[i].charAt(0) !== '"') {

                            if (ffs[i] === "default") {

                                /* per IMSC1 */

                                rslt.push("monospaceSerif");

                            } else {

                                rslt.push(ffs[i]);

                            }

                        } else {

                            rslt.push(ffs[i]);

                        }

                    }

                    return rslt;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "fontSize",
                "1c",
                ['span'],
                true,
                true,
                imscUtils.parseLength,
                function (doc, parent, element, attr, context) {

                    var fs;

                    if (attr.unit === "%") {

                        if (parent !== null) {

                            fs = parent.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value / 100;

                        } else {

                            /* region, so percent of 1c */

                            fs = attr.value / 100 / doc.cellResolution.h;

                        }

                    } else if (attr.unit === "em") {

                        if (parent !== null) {

                            fs = parent.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value;

                        } else {

                            /* region, so percent of 1c */

                            fs = attr.value / doc.cellResolution.h;

                        }

                    } else if (attr.unit === "c") {

                        fs = attr.value / doc.cellResolution.h;

                    } else if (attr.unit === "px") {

                        fs = attr.value / doc.pxDimensions.h;

                    } else {

                        return null;

                    }

                    return fs;
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "fontStyle",
                "normal",
                ['span'],
                true,
                true,
                function (str) {
                    /* TODO: handle font style */

                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "fontWeight",
                "normal",
                ['span'],
                true,
                true,
                function (str) {
                    /* TODO: handle font weight */

                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "lineHeight",
                "normal",
                ['p'],
                true,
                true,
                function (str) {
                    if (str === "normal") {
                        return str;
                    } else {
                        return imscUtils.parseLength(str);
                    }
                },
                function (doc, parent, element, attr, context) {

                    var lh;

                    if (attr === "normal") {

                        /* inherit normal per https://github.com/w3c/ttml1/issues/220 */

                        lh = attr;

                    } else if (attr.unit === "%") {

                        lh = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value / 100;

                    } else if (attr.unit === "em") {

                        lh = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.value;

                    } else if (attr.unit === "c") {

                        lh = attr.value / doc.cellResolution.h;

                    } else if (attr.unit === "px") {

                        /* TODO: handle error if no px dimensions are provided */

                        lh = attr.value / doc.pxDimensions.h;

                    } else {

                        return null;

                    }

                    /* TODO: create a Length constructor */

                    return lh;
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "opacity",
                1.0,
                ['region'],
                false,
                true,
                parseFloat,
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "origin",
                "auto",
                ['region'],
                false,
                true,
                function (str) {

                    if (str === "auto") {

                        return str;

                    } else {

                        var s = str.split(" ");
                        if (s.length !== 2) return null;
                        var w = imscUtils.parseLength(s[0]);
                        var h = imscUtils.parseLength(s[1]);
                        if (!h || !w) return null;
                        return {'h': h, 'w': w};
                    }

                },
                function (doc, parent, element, attr, context) {

                    var h;
                    var w;

                    if (attr === "auto") {

                        h = 0;

                    } else if (attr.h.unit === "%") {

                        h = attr.h.value / 100;

                    } else if (attr.h.unit === "px") {

                        h = attr.h.value / doc.pxDimensions.h;

                    } else {

                        return null;

                    }

                    if (attr === "auto") {

                        w = 0;

                    } else if (attr.w.unit === "%") {

                        w = attr.w.value / 100;

                    } else if (attr.w.unit === "px") {

                        w = attr.w.value / doc.pxDimensions.w;

                    } else {

                        return null;

                    }

                    return {'h': h, 'w': w};
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "overflow",
                "hidden",
                ['region'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "padding",
                "0px",
                ['region'],
                false,
                true,
                function (str) {

                    var s = str.split(" ");
                    if (s.length > 4) return null;
                    var r = [];
                    for (var i in s) {

                        var l = imscUtils.parseLength(s[i]);
                        if (!l) return null;
                        r.push(l);
                    }

                    return r;
                },
                function (doc, parent, element, attr, context) {

                    var padding;

                    /* TODO: make sure we are in region */

                    /*
                     * expand padding shortcuts to 
                     * [before, end, after, start]
                     * 
                     */

                    if (attr.length === 1) {

                        padding = [attr[0], attr[0], attr[0], attr[0]];

                    } else if (attr.length === 2) {

                        padding = [attr[0], attr[1], attr[0], attr[1]];

                    } else if (attr.length === 3) {

                        padding = [attr[0], attr[1], attr[2], attr[1]];

                    } else if (attr.length === 4) {

                        padding = [attr[0], attr[1], attr[2], attr[3]];

                    } else {

                        return null;

                    }

                    /* TODO: take into account tts:direction */

                    /* 
                     * transform [before, end, after, start] according to writingMode to 
                     * [top,left,bottom,right]
                     * 
                     */

                    var dir = element.styleAttrs[imscStyles.byName.writingMode.qname];

                    if (dir === "lrtb" || dir === "lr") {

                        padding = [padding[0], padding[3], padding[2], padding[1]];

                    } else if (dir === "rltb" || dir === "rl") {

                        padding = [padding[0], padding[1], padding[2], padding[3]];

                    } else if (dir === "tblr") {

                        padding = [padding[3], padding[0], padding[1], padding[2]];

                    } else if (dir === "tbrl" || dir === "tb") {

                        padding = [padding[3], padding[2], padding[1], padding[0]];

                    } else {

                        return null;

                    }

                    var out = [];

                    for (var i in padding) {

                        if (padding[i].value === 0) {

                            out[i] = 0;

                        } else if (padding[i].unit === "%") {

                            if (i === "0" || i === "2") {

                                out[i] = element.styleAttrs[imscStyles.byName.extent.qname].h * padding[i].value / 100;

                            } else {

                                out[i] = element.styleAttrs[imscStyles.byName.extent.qname].w * padding[i].value / 100;
                            }

                        } else if (padding[i].unit === "em") {

                            out[i] = element.styleAttrs[imscStyles.byName.fontSize.qname] * padding[i].value;

                        } else if (padding[i].unit === "c") {

                            out[i] = padding[i].value / doc.cellResolution.h;

                        } else if (padding[i].unit === "px") {
                            
                            if (i === "0" || i === "2") {

                                out[i] = padding[i].value / doc.pxDimensions.h;

                            } else {

                                out[i] = padding[i].value / doc.pxDimensions.w;
                            }
                            
                        } else {

                            return null;

                        }
                    }


                    return out;
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "showBackground",
                "always",
                ['region'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "textAlign",
                "start",
                ['p'],
                true,
                true,
                function (str) {
                    return str;
                },
                function (doc, parent, element, attr, context) {
                    
                    /* Section 7.16.9 of XSL */
                    
                    if (attr === "left") {
                        
                        return "start";
                        
                    } else if (attr === "right") {
                        
                        return "end";
                        
                    } else {
                        
                        return attr;
                        
                    }
                }
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "textDecoration",
                "none",
                ['span'],
                true,
                true,
                function (str) {
                    return str.split(" ");
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "textOutline",
                "none",
                ['span'],
                true,
                true,
                function (str) {

                    /*
                     * returns {c: <color>?, thichness: <length>} | "none"
                     * 
                     */

                    if (str === "none") {

                        return str;

                    } else {

                        var r = {};
                        var s = str.split(" ");
                        if (s.length === 0 || s.length > 2) return null;
                        var c = imscUtils.parseColor(s[0]);
                       
                        r.color = c;
                        
                        if (c !== null) s.shift();

                        if (s.length !== 1) return null;

                        var l = imscUtils.parseLength(s[0]);

                        if (!l) return null;

                        r.thickness = l;

                        return r;
                    }

                },
                function (doc, parent, element, attr, context) {

                    /*
                     * returns {color: <color>, thickness: <norm length>}
                     * 
                     */

                    if (attr === "none") return attr;

                    var rslt = {};

                    if (attr.color === null) {
                        
                        rslt.color = element.styleAttrs[imscStyles.byName.color.qname];
                        
                    } else {
                        
                        rslt.color = attr.color;

                    }

                    if (attr.thickness.unit === "%") {

                        rslt.thickness = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.thickness.value / 100;

                    } else if (attr.thickness.unit === "em") {

                        rslt.thickness = element.styleAttrs[imscStyles.byName.fontSize.qname] * attr.thickness.value;

                    } else if (attr.thickness.unit === "c") {

                        rslt.thickness = attr.thickness.value / doc.cellResolution.h;

                    } else if (attr.thickness.unit === "px") {

                        rslt.thickness = attr.thickness.value / doc.pxDimensions.h;

                    } else {

                        return null;

                    }


                    return rslt;
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "unicodeBidi",
                "normal",
                ['span', 'p'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "visibility",
                "visible",
                ['body', 'div', 'p', 'region', 'span'],
                true,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "wrapOption",
                "wrap",
                ['span'],
                true,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "writingMode",
                "lrtb",
                ['region'],
                false,
                true,
                function (str) {
                    return str;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_tts,
                "zIndex",
                "auto",
                ['region'],
                false,
                true,
                function (str) {
                    
                    var rslt;
                    
                    if (str === 'auto') {
                        
                        rslt = str;
                        
                    } else {
                        
                        rslt = parseInt(str);
                        
                        if (isNaN(rslt)) {
                            rslt = null;
                        }
                        
                    }
                    
                    return rslt;
                },
                null
                ),
        new StylingAttributeDefinition(
                imscNames.ns_ebutts,
                "linePadding",
                "0c",
                ['p'],
                true,
                false,
                imscUtils.parseLength,
                function (doc, parent, element, attr, context) {
                    if (attr.unit === "c") {

                        return attr.value / doc.cellResolution.h;

                    } else {

                        return null;

                    }
                }
        ),
        new StylingAttributeDefinition(
                imscNames.ns_ebutts,
                "multiRowAlign",
                "auto",
                ['p'],
                true,
                false,
                function (str) {
                    return str;
                },
                null
                ),

        new StylingAttributeDefinition(
                imscNames.ns_smpte,
                "backgroundImage",
                null,
                ['div'],
                false,
                false,
                function (str) {
                    return str;
                },
                null
                ),

        new StylingAttributeDefinition(
                imscNames.ns_itts,
                "forcedDisplay",
                "false",
                ['body', 'div', 'p', 'region', 'span'],
                true,
                true,
                function (str) {
                    return str === 'true' ? true : false;
                },
                null
                ),

        new StylingAttributeDefinition(
                imscNames.ns_itts,
                "fillLineGap",
                "false",
                ['p'],
                true,
                true,
                function (str) {
                    return str === 'true' ? true : false;
                },
                null
                )
    ];

    /* TODO: allow null parse function */

    imscStyles.byQName = {};
    for (var i in imscStyles.all) {

        imscStyles.byQName[imscStyles.all[i].qname] = imscStyles.all[i];
    }

    imscStyles.byName = {};
    for (var j in imscStyles.all) {

        imscStyles.byName[imscStyles.all[j].name] = imscStyles.all[j];
    }

})(  false ? 0 : exports,
        typeof imscNames === 'undefined' ? __nested_webpack_require_270351__(/*! ./names */ "./node_modules/imsc/src/main/js/names.js") : imscNames,
        typeof imscUtils === 'undefined' ? __nested_webpack_require_270351__(/*! ./utils */ "./node_modules/imsc/src/main/js/utils.js") : imscUtils);


/***/ }),

/***/ "./node_modules/imsc/src/main/js/utils.js":
/*!************************************************!*\
  !*** ./node_modules/imsc/src/main/js/utils.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* 
 * Copyright (c) 2016, Pierre-Anthony Lemieux <pal@sandflow.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module imscUtils
 */

;
(function (imscUtils) { // wrapper for non-node envs
    
    /* Documents the error handler interface */
    
    /**
     * @classdesc Generic interface for handling events. The interface exposes four
     * methods:
     * * <pre>info</pre>: unusual event that does not result in an inconsistent state
     * * <pre>warn</pre>: unexpected event that should not result in an inconsistent state
     * * <pre>error</pre>: unexpected event that may result in an inconsistent state
     * * <pre>fatal</pre>: unexpected event that results in an inconsistent state
     *   and termination of processing
     * Each method takes a single <pre>string</pre> describing the event as argument,
     * and returns a single <pre>boolean</pre>, which terminates processing if <pre>true</pre>.
     *
     * @name ErrorHandler
     * @class
     */


    /*
     * Parses a TTML color expression
     * 
     */

    var HEX_COLOR_RE = /#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/;
    var DEC_COLOR_RE = /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/;
    var DEC_COLORA_RE = /rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/;
    var NAMED_COLOR = {
        transparent: [0, 0, 0, 0],
        black: [0, 0, 0, 255],
        silver: [192, 192, 192, 255],
        gray: [128, 128, 128, 255],
        white: [255, 255, 255, 255],
        maroon: [128, 0, 0, 255],
        red: [255, 0, 0, 255],
        purple: [128, 0, 128, 255],
        fuchsia: [255, 0, 255, 255],
        magenta: [255, 0, 255, 255],
        green: [0, 128, 0, 255],
        lime: [0, 255, 0, 255],
        olive: [128, 128, 0, 255],
        yellow: [255, 255, 0, 255],
        navy: [0, 0, 128, 255],
        blue: [0, 0, 255, 255],
        teal: [0, 128, 128, 255],
        aqua: [0, 255, 255, 255],
        cyan: [0, 255, 255, 255]
    };

    imscUtils.parseColor = function (str) {

        var m;
        
        var r = null;
        
        var nc = NAMED_COLOR[str.toLowerCase()];
        
        if (nc !== undefined) {

            r = nc;

        } else if ((m = HEX_COLOR_RE.exec(str)) !== null) {

            r = [parseInt(m[1], 16),
                parseInt(m[2], 16),
                parseInt(m[3], 16),
                (m[4] !== undefined ? parseInt(m[4], 16) : 255)];
            
        } else if ((m = DEC_COLOR_RE.exec(str)) !== null) {

            r = [parseInt(m[1]),
                parseInt(m[2]),
                parseInt(m[3]),
                255];
            
        } else if ((m = DEC_COLORA_RE.exec(str)) !== null) {

            r = [parseInt(m[1]),
                parseInt(m[2]),
                parseInt(m[3]),
                parseInt(m[4])];
            
        }

        return r;
    };

    var LENGTH_RE = /^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;

    imscUtils.parseLength = function (str) {

        var m;

        var r = null;

        if ((m = LENGTH_RE.exec(str)) !== null) {

            r = {value: parseFloat(m[1]), unit: m[2]};
        }

        return r;
    };

})(  false ? 0 : exports);


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/*!***************************************************!*\
  !*** ./node_modules/inherits/inherits_browser.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/buffer/index.js":
/*!*********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/buffer/index.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_303195__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __nested_webpack_require_303195__(/*! base64-js */ "./node_modules/base64-js/index.js")
var ieee754 = __nested_webpack_require_303195__(/*! ieee754 */ "./node_modules/ieee754/index.js")
var isArray = __nested_webpack_require_303195__(/*! isarray */ "./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_303195__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/events/events.js":
/*!**********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/events/events.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/timers-browserify/main.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_370176__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__nested_webpack_require_370176__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_370176__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/path-browserify/index.js":
/*!***********************************************!*\
  !*** ./node_modules/path-browserify/index.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_372840__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr =  true
    ? function (str, start, len) { return str.substr(start, len) }
    : 0
;

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_372840__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/process-nextick-args/index.js":
/*!****************************************************!*\
  !*** ./node_modules/process-nextick-args/index.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_382401__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_382401__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/readable-stream/duplex-browser.js":
/*!********************************************************!*\
  !*** ./node_modules/readable-stream/duplex-browser.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_389901__) {

module.exports = __nested_webpack_require_389901__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js");


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_duplex.js":
/*!************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_duplex.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_390398__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __nested_webpack_require_390398__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __nested_webpack_require_390398__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __nested_webpack_require_390398__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __nested_webpack_require_390398__(/*! ./_stream_readable */ "./node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __nested_webpack_require_390398__(/*! ./_stream_writable */ "./node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_passthrough.js":
/*!*****************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_395255__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __nested_webpack_require_395255__(/*! ./_stream_transform */ "./node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = __nested_webpack_require_395255__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __nested_webpack_require_395255__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_readable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_readable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_397617__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __nested_webpack_require_397617__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __nested_webpack_require_397617__(/*! isarray */ "./node_modules/isarray/index.js");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __nested_webpack_require_397617__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __nested_webpack_require_397617__(/*! ./internal/streams/stream */ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __nested_webpack_require_397617__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __nested_webpack_require_397617__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __nested_webpack_require_397617__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __nested_webpack_require_397617__(/*! util */ 0);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __nested_webpack_require_397617__(/*! ./internal/streams/BufferList */ "./node_modules/readable-stream/lib/internal/streams/BufferList.js");
var destroyImpl = __nested_webpack_require_397617__(/*! ./internal/streams/destroy */ "./node_modules/readable-stream/lib/internal/streams/destroy.js");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __nested_webpack_require_397617__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __nested_webpack_require_397617__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __nested_webpack_require_397617__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __nested_webpack_require_397617__(/*! string_decoder/ */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_397617__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __nested_webpack_require_397617__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_transform.js":
/*!***************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_transform.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_431559__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __nested_webpack_require_431559__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = __nested_webpack_require_431559__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __nested_webpack_require_431559__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_writable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_writable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_440074__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __nested_webpack_require_440074__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __nested_webpack_require_440074__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __nested_webpack_require_440074__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __nested_webpack_require_440074__(/*! util-deprecate */ "./node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __nested_webpack_require_440074__(/*! ./internal/streams/stream */ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/

var Buffer = __nested_webpack_require_440074__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __nested_webpack_require_440074__(/*! ./internal/streams/destroy */ "./node_modules/readable-stream/lib/internal/streams/destroy.js");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __nested_webpack_require_440074__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __nested_webpack_require_440074__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_440074__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js"), __nested_webpack_require_440074__(/*! ./../../node-libs-browser/node_modules/timers-browserify/main.js */ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js").setImmediate, __nested_webpack_require_440074__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/BufferList.js":
/*!*************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/BufferList.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_462593__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __nested_webpack_require_462593__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
var util = __nested_webpack_require_462593__(/*! util */ 1);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/destroy.js":
/*!**********************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/destroy.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_465217__) {

"use strict";


/*<replacement>*/

var pna = __nested_webpack_require_465217__(/*! process-nextick-args */ "./node_modules/process-nextick-args/index.js");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "./node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/readable-stream/lib/internal/streams/stream-browser.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_467644__) {

module.exports = __nested_webpack_require_467644__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "./node_modules/readable-stream/passthrough.js":
/*!*****************************************************!*\
  !*** ./node_modules/readable-stream/passthrough.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_468119__) {

module.exports = __nested_webpack_require_468119__(/*! ./readable */ "./node_modules/readable-stream/readable-browser.js").PassThrough


/***/ }),

/***/ "./node_modules/readable-stream/readable-browser.js":
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/readable-browser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_468604__) {

exports = module.exports = __nested_webpack_require_468604__(/*! ./lib/_stream_readable.js */ "./node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __nested_webpack_require_468604__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __nested_webpack_require_468604__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __nested_webpack_require_468604__(/*! ./lib/_stream_transform.js */ "./node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __nested_webpack_require_468604__(/*! ./lib/_stream_passthrough.js */ "./node_modules/readable-stream/lib/_stream_passthrough.js");


/***/ }),

/***/ "./node_modules/readable-stream/transform.js":
/*!***************************************************!*\
  !*** ./node_modules/readable-stream/transform.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_469669__) {

module.exports = __nested_webpack_require_469669__(/*! ./readable */ "./node_modules/readable-stream/readable-browser.js").Transform


/***/ }),

/***/ "./node_modules/readable-stream/writable-browser.js":
/*!**********************************************************!*\
  !*** ./node_modules/readable-stream/writable-browser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_470152__) {

module.exports = __nested_webpack_require_470152__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js");


/***/ }),

/***/ "./node_modules/safe-buffer/index.js":
/*!*******************************************!*\
  !*** ./node_modules/safe-buffer/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_470585__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __nested_webpack_require_470585__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/sax/lib/sax.js":
/*!*************************************!*\
  !*** ./node_modules/sax/lib/sax.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_472536__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = __nested_webpack_require_472536__(/*! stream */ "./node_modules/stream-browserify/index.js").Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = __nested_webpack_require_472536__(/*! string_decoder */ "./node_modules/string_decoder/lib/string_decoder.js").StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // character classes and tokens
  var whitespace = '\r\n\t '

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var number = '0124356789'
  var letter = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

  // (Letter | "_" | ":")
  var quote = '\'"'
  var attribEnd = whitespace + '>'
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // turn all the string character sets into character class objects.
  whitespace = charClass(whitespace)
  number = charClass(number)
  letter = charClass(letter)

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/

  quote = charClass(quote)
  attribEnd = charClass(attribEnd)

  function charClass (str) {
    return str.split('').reduce(function (s, c) {
      s[c] = true
      return s
    }, {})
  }

  function isRegExp (c) {
    return Object.prototype.toString.call(c) === '[object RegExp]'
  }

  function is (charclass, c) {
    return isRegExp(charclass) ? !!c.match(charclass) : charclass[c]
  }

  function not (charclass, c) {
    return !is(charclass, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (not(whitespace, c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c
      if (!c) {
        break
      }
      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }
      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (is(whitespace, c)) {
            // wait for it...
          } else if (is(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (is(quote, c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (is(quote, c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (is(quote, c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (is(whitespace, c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && is(whitespace, c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (is(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (not(whitespace, c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (is(whitespace, c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (is(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (is(whitespace, c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (is(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (is(whitespace, c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (is(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (is(whitespace, c)) {
            continue
          } else if (is(quote, c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (is(whitespace, c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (is(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (not(attribEnd, c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (is(whitespace, c)) {
              continue
            } else if (not(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (is(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (not(whitespace, c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (is(whitespace, c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (is(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})(  false ? 0 : exports)

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_472536__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_518754__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_518754__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __nested_webpack_require_518754__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/stream-browserify/index.js":
/*!*************************************************!*\
  !*** ./node_modules/stream-browserify/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_526029__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __nested_webpack_require_526029__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;
var inherits = __nested_webpack_require_526029__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __nested_webpack_require_526029__(/*! readable-stream/readable.js */ "./node_modules/readable-stream/readable-browser.js");
Stream.Writable = __nested_webpack_require_526029__(/*! readable-stream/writable.js */ "./node_modules/readable-stream/writable-browser.js");
Stream.Duplex = __nested_webpack_require_526029__(/*! readable-stream/duplex.js */ "./node_modules/readable-stream/duplex-browser.js");
Stream.Transform = __nested_webpack_require_526029__(/*! readable-stream/transform.js */ "./node_modules/readable-stream/transform.js");
Stream.PassThrough = __nested_webpack_require_526029__(/*! readable-stream/passthrough.js */ "./node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "./node_modules/string_decoder/lib/string_decoder.js":
/*!***********************************************************!*\
  !*** ./node_modules/string_decoder/lib/string_decoder.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_530631__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __nested_webpack_require_530631__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "./node_modules/util-deprecate/browser.js":
/*!************************************************!*\
  !*** ./node_modules/util-deprecate/browser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_540771__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_540771__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/core/Debug.js":
/*!***************************!*\
  !*** ./src/core/Debug.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_543651__) {

"use strict";
__nested_webpack_require_543651__.r(__webpack_exports__);
/* harmony import */ var _EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_543651__(/*! ./EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_543651__(/*! ./events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_543651__(/*! ./FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



var LOG_LEVEL_NONE = 0;
var LOG_LEVEL_FATAL = 1;
var LOG_LEVEL_ERROR = 2;
var LOG_LEVEL_WARNING = 3;
var LOG_LEVEL_INFO = 4;
var LOG_LEVEL_DEBUG = 5;
/**
 * @module Debug
 * @param {object} config
 * @ignore
 */

function Debug(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var settings = config.settings;
  var logFn = [];
  var instance, showLogTimestamp, showCalleeName, startTime;

  function setup() {
    showLogTimestamp = true;
    showCalleeName = true;
    startTime = new Date().getTime();

    if (typeof window !== 'undefined' && window.console) {
      logFn[LOG_LEVEL_FATAL] = getLogFn(window.console.error);
      logFn[LOG_LEVEL_ERROR] = getLogFn(window.console.error);
      logFn[LOG_LEVEL_WARNING] = getLogFn(window.console.warn);
      logFn[LOG_LEVEL_INFO] = getLogFn(window.console.info);
      logFn[LOG_LEVEL_DEBUG] = getLogFn(window.console.debug);
    }
  }

  function getLogFn(fn) {
    if (fn && fn.bind) {
      return fn.bind(window.console);
    } // if not define, return the default function for reporting logs


    return window.console.log.bind(window.console);
  }
  /**
   * Retrieves a logger which can be used to write logging information in browser console.
   * @param {object} instance Object for which the logger is created. It is used
   * to include calle object information in log messages.
   * @memberof module:Debug
   * @returns {Logger}
   * @instance
   */


  function getLogger(instance) {
    return {
      fatal: fatal.bind(instance),
      error: error.bind(instance),
      warn: warn.bind(instance),
      info: info.bind(instance),
      debug: debug.bind(instance)
    };
  }
  /**
   * Prepends a timestamp in milliseconds to each log message.
   * @param {boolean} value Set to true if you want to see a timestamp in each log message.
   * @default LOG_LEVEL_WARNING
   * @memberof module:Debug
   * @instance
   */


  function setLogTimestampVisible(value) {
    showLogTimestamp = value;
  }
  /**
   * Prepends the callee object name, and media type if available, to each log message.
   * @param {boolean} value Set to true if you want to see the callee object name and media type in each log message.
   * @default true
   * @memberof module:Debug
   * @instance
   */


  function setCalleeNameVisible(value) {
    showCalleeName = value;
  }

  function fatal() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    doLog.apply(void 0, [LOG_LEVEL_FATAL, this].concat(params));
  }

  function error() {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    doLog.apply(void 0, [LOG_LEVEL_ERROR, this].concat(params));
  }

  function warn() {
    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    doLog.apply(void 0, [LOG_LEVEL_WARNING, this].concat(params));
  }

  function info() {
    for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      params[_key4] = arguments[_key4];
    }

    doLog.apply(void 0, [LOG_LEVEL_INFO, this].concat(params));
  }

  function debug() {
    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    doLog.apply(void 0, [LOG_LEVEL_DEBUG, this].concat(params));
  }

  function doLog(level, _this) {
    var message = '';
    var logTime = null;

    if (showLogTimestamp) {
      logTime = new Date().getTime();
      message += '[' + (logTime - startTime) + ']';
    }

    if (showCalleeName && _this && _this.getClassName) {
      message += '[' + _this.getClassName() + ']';

      if (_this.getType) {
        message += '[' + _this.getType() + ']';
      }
    }

    if (message.length > 0) {
      message += ' ';
    }

    for (var _len6 = arguments.length, params = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
      params[_key6 - 2] = arguments[_key6];
    }

    Array.apply(null, params).forEach(function (item) {
      message += item + ' ';
    }); // log to console if the log level is high enough

    if (logFn[level] && settings.get().debug.logLevel >= level) {
      logFn[level](message);
    } // send log event regardless of log level


    if (settings && settings.get().debug.dispatchEvent) {
      eventBus.trigger(_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].LOG, {
        message: message,
        level: level
      });
    }
  }

  instance = {
    getLogger: getLogger,
    setLogTimestampVisible: setLogTimestampVisible,
    setCalleeNameVisible: setCalleeNameVisible
  };
  setup();
  return instance;
}

Debug.__dashjs_factory_name = 'Debug';
var factory = _FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(Debug);
factory.LOG_LEVEL_NONE = LOG_LEVEL_NONE;
factory.LOG_LEVEL_FATAL = LOG_LEVEL_FATAL;
factory.LOG_LEVEL_ERROR = LOG_LEVEL_ERROR;
factory.LOG_LEVEL_WARNING = LOG_LEVEL_WARNING;
factory.LOG_LEVEL_INFO = LOG_LEVEL_INFO;
factory.LOG_LEVEL_DEBUG = LOG_LEVEL_DEBUG;
_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].updateSingletonFactory(Debug.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/core/EventBus.js":
/*!******************************!*\
  !*** ./src/core/EventBus.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_551985__) {

"use strict";
__nested_webpack_require_551985__.r(__webpack_exports__);
/* harmony import */ var _FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_551985__(/*! ./FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_551985__(/*! ../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var EVENT_PRIORITY_LOW = 0;
var EVENT_PRIORITY_HIGH = 5000;

function EventBus() {
  var handlers = {};

  function on(type, listener, scope) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (!type) {
      throw new Error('event type cannot be null or undefined');
    }

    if (!listener || typeof listener !== 'function') {
      throw new Error('listener must be a function: ' + listener);
    }

    var priority = options.priority || EVENT_PRIORITY_LOW;
    if (getHandlerIdx(type, listener, scope) >= 0) return;
    handlers[type] = handlers[type] || [];
    var handler = {
      callback: listener,
      scope: scope,
      priority: priority
    };

    if (scope && scope.getStreamId) {
      handler.streamId = scope.getStreamId();
    }

    if (scope && scope.getType) {
      handler.mediaType = scope.getType();
    }

    if (options && options.mode) {
      handler.mode = options.mode;
    }

    var inserted = handlers[type].some(function (item, idx) {
      if (item && priority > item.priority) {
        handlers[type].splice(idx, 0, handler);
        return true;
      }
    });

    if (!inserted) {
      handlers[type].push(handler);
    }
  }

  function off(type, listener, scope) {
    if (!type || !listener || !handlers[type]) return;
    var idx = getHandlerIdx(type, listener, scope);
    if (idx < 0) return;
    handlers[type][idx] = null;
  }

  function trigger(type) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!type || !handlers[type]) return;
    payload = payload || {};
    if (payload.hasOwnProperty('type')) throw new Error('\'type\' is a reserved word for event dispatching');
    payload.type = type;

    if (filters.streamId) {
      payload.streamId = filters.streamId;
    }

    if (filters.mediaType) {
      payload.mediaType = filters.mediaType;
    }

    handlers[type].filter(function (handler) {
      if (!handler) {
        return false;
      }

      if (filters.streamId && handler.streamId && handler.streamId !== filters.streamId) {
        return false;
      }

      if (filters.mediaType && handler.mediaType && handler.mediaType !== filters.mediaType) {
        return false;
      } // This is used for dispatching DASH events. By default we use the onStart mode. Consequently we filter everything that has a non matching mode and the onReceive events for handlers that did not specify a mode.


      if (filters.mode && handler.mode && handler.mode !== filters.mode || !handler.mode && filters.mode && filters.mode === _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].EVENT_MODE_ON_RECEIVE) {
        return false;
      }

      return true;
    }).forEach(function (handler) {
      return handler && handler.callback.call(handler.scope, payload);
    });
  }

  function getHandlerIdx(type, listener, scope) {
    var idx = -1;
    if (!handlers[type]) return idx;
    handlers[type].some(function (item, index) {
      if (item && item.callback === listener && (!scope || scope === item.scope)) {
        idx = index;
        return true;
      }
    });
    return idx;
  }

  function reset() {
    handlers = {};
  }

  var instance = {
    on: on,
    off: off,
    trigger: trigger,
    reset: reset
  };
  return instance;
}

EventBus.__dashjs_factory_name = 'EventBus';
var factory = _FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(EventBus);
factory.EVENT_PRIORITY_LOW = EVENT_PRIORITY_LOW;
factory.EVENT_PRIORITY_HIGH = EVENT_PRIORITY_HIGH;
_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].updateSingletonFactory(EventBus.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/core/FactoryMaker.js":
/*!**********************************!*\
  !*** ./src/core/FactoryMaker.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_558516__) {

"use strict";
__nested_webpack_require_558516__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module FactoryMaker
 * @ignore
 */
var FactoryMaker = function () {
  var instance;
  var singletonContexts = [];
  var singletonFactories = {};
  var classFactories = {};

  function extend(name, childInstance, override, context) {
    if (!context[name] && childInstance) {
      context[name] = {
        instance: childInstance,
        override: override
      };
    }
  }
  /**
   * Use this method from your extended object.  this.factory is injected into your object.
   * this.factory.getSingletonInstance(this.context, 'VideoModel')
   * will return the video model for use in the extended object.
   *
   * @param {Object} context - injected into extended object as this.context
   * @param {string} className - string name found in all dash.js objects
   * with name __dashjs_factory_name Will be at the bottom. Will be the same as the object's name.
   * @returns {*} Context aware instance of specified singleton name.
   * @memberof module:FactoryMaker
   * @instance
   */


  function getSingletonInstance(context, className) {
    for (var i in singletonContexts) {
      var obj = singletonContexts[i];

      if (obj.context === context && obj.name === className) {
        return obj.instance;
      }
    }

    return null;
  }
  /**
   * Use this method to add an singleton instance to the system.  Useful for unit testing to mock objects etc.
   *
   * @param {Object} context
   * @param {string} className
   * @param {Object} instance
   * @memberof module:FactoryMaker
   * @instance
   */


  function setSingletonInstance(context, className, instance) {
    for (var i in singletonContexts) {
      var obj = singletonContexts[i];

      if (obj.context === context && obj.name === className) {
        singletonContexts[i].instance = instance;
        return;
      }
    }

    singletonContexts.push({
      name: className,
      context: context,
      instance: instance
    });
  }
  /**
   * Use this method to remove all singleton instances associated with a particular context.
   *
   * @param {Object} context
   * @memberof module:FactoryMaker
   * @instance
   */


  function deleteSingletonInstances(context) {
    singletonContexts = singletonContexts.filter(function (x) {
      return x.context !== context;
    });
  }
  /*------------------------------------------------------------------------------------------*/
  // Factories storage Management

  /*------------------------------------------------------------------------------------------*/


  function getFactoryByName(name, factoriesArray) {
    return factoriesArray[name];
  }

  function updateFactory(name, factory, factoriesArray) {
    if (name in factoriesArray) {
      factoriesArray[name] = factory;
    }
  }
  /*------------------------------------------------------------------------------------------*/
  // Class Factories Management

  /*------------------------------------------------------------------------------------------*/


  function updateClassFactory(name, factory) {
    updateFactory(name, factory, classFactories);
  }

  function getClassFactoryByName(name) {
    return getFactoryByName(name, classFactories);
  }

  function getClassFactory(classConstructor) {
    var factory = getFactoryByName(classConstructor.__dashjs_factory_name, classFactories);

    if (!factory) {
      factory = function factory(context) {
        if (context === undefined) {
          context = {};
        }

        return {
          create: function create() {
            return merge(classConstructor, context, arguments);
          }
        };
      };

      classFactories[classConstructor.__dashjs_factory_name] = factory; // store factory
    }

    return factory;
  }
  /*------------------------------------------------------------------------------------------*/
  // Singleton Factory MAangement

  /*------------------------------------------------------------------------------------------*/


  function updateSingletonFactory(name, factory) {
    updateFactory(name, factory, singletonFactories);
  }

  function getSingletonFactoryByName(name) {
    return getFactoryByName(name, singletonFactories);
  }

  function getSingletonFactory(classConstructor) {
    var factory = getFactoryByName(classConstructor.__dashjs_factory_name, singletonFactories);

    if (!factory) {
      factory = function factory(context) {
        var instance;

        if (context === undefined) {
          context = {};
        }

        return {
          getInstance: function getInstance() {
            // If we don't have an instance yet check for one on the context
            if (!instance) {
              instance = getSingletonInstance(context, classConstructor.__dashjs_factory_name);
            } // If there's no instance on the context then create one


            if (!instance) {
              instance = merge(classConstructor, context, arguments);
              singletonContexts.push({
                name: classConstructor.__dashjs_factory_name,
                context: context,
                instance: instance
              });
            }

            return instance;
          }
        };
      };

      singletonFactories[classConstructor.__dashjs_factory_name] = factory; // store factory
    }

    return factory;
  }

  function merge(classConstructor, context, args) {
    var classInstance;
    var className = classConstructor.__dashjs_factory_name;
    var extensionObject = context[className];

    if (extensionObject) {
      var extension = extensionObject.instance;

      if (extensionObject.override) {
        //Override public methods in parent but keep parent.
        classInstance = classConstructor.apply({
          context: context
        }, args);
        extension = extension.apply({
          context: context,
          factory: instance,
          parent: classInstance
        }, args);

        for (var prop in extension) {
          if (classInstance.hasOwnProperty(prop)) {
            classInstance[prop] = extension[prop];
          }
        }
      } else {
        //replace parent object completely with new object. Same as dijon.
        return extension.apply({
          context: context,
          factory: instance
        }, args);
      }
    } else {
      // Create new instance of the class
      classInstance = classConstructor.apply({
        context: context
      }, args);
    } // Add getClassName function to class instance prototype (used by Debug)


    classInstance.getClassName = function () {
      return className;
    };

    return classInstance;
  }

  instance = {
    extend: extend,
    getSingletonInstance: getSingletonInstance,
    setSingletonInstance: setSingletonInstance,
    deleteSingletonInstances: deleteSingletonInstances,
    getSingletonFactory: getSingletonFactory,
    getSingletonFactoryByName: getSingletonFactoryByName,
    updateSingletonFactory: updateSingletonFactory,
    getClassFactory: getClassFactory,
    getClassFactoryByName: getClassFactoryByName,
    updateClassFactory: updateClassFactory
  };
  return instance;
}();

/* harmony default export */ __webpack_exports__["default"] = (FactoryMaker);

/***/ }),

/***/ "./src/core/Settings.js":
/*!******************************!*\
  !*** ./src/core/Settings.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_568133__) {

"use strict";
__nested_webpack_require_568133__.r(__webpack_exports__);
/* harmony import */ var _FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_568133__(/*! ./FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _Utils_js__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_568133__(/*! ./Utils.js */ "./src/core/Utils.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_568133__(/*! ../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_568133__(/*! ../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_568133__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _EventBus__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_568133__(/*! ./EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _events_Events__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_568133__(/*! ./events/Events */ "./src/core/events/Events.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







/** @module Settings
 * @description Define the configuration parameters of Dash.js MediaPlayer.
 * @see {@link module:Settings~PlayerSettings PlayerSettings} for further information about the supported configuration properties.
 */

/**
 * @typedef {Object} PlayerSettings
 * @property {module:Settings~DebugSettings} [debug]
 * Debug related settings.
 * @property {module:Settings~ErrorSettings} [errors]
 * Error related settings
 * @property {module:Settings~StreamingSettings} [streaming]
 * Streaming related settings.
 * @example
 *
 * // Full settings object
 * settings = {
 *        debug: {
 *            logLevel: Debug.LOG_LEVEL_WARNING,
 *            dispatchEvent: false
 *        },
 *        streaming: {
 *            abandonLoadTimeout: 10000,
 *            wallclockTimeUpdateInterval: 100,
 *            manifestUpdateRetryInterval: 100,
 *            cacheInitSegments: true,
 *            applyServiceDescription: true,
 *            applyProducerReferenceTime: true,
 *            eventControllerRefreshDelay: 100,
 *            capabilities: {
 *               filterUnsupportedEssentialProperties: true,
 *               useMediaCapabilitiesApi: false
 *            },
 *            timeShiftBuffer: {
 *                calcFromSegmentTimeline: false,
 *                fallbackToSegmentTimeline: true
 *            },
 *            metrics: {
 *              maxListDepth: 100
 *            },
 *            delay: {
 *                liveDelayFragmentCount: NaN,
 *                liveDelay: NaN,
 *                useSuggestedPresentationDelay: true
 *            },
 *            protection: {
 *                keepProtectionMediaKeys: false,
 *                ignoreEmeEncryptedEvent: false,
 *                detectPlayreadyMessageFormat: true,
 *            },
 *            buffer: {
 *                enableSeekDecorrelationFix: true,
 *                fastSwitchEnabled: true,
 *                flushBufferAtTrackSwitch: false,
 *                reuseExistingSourceBuffers: true,
 *                bufferPruningInterval: 10,
 *                bufferToKeep: 20,
 *                bufferTimeAtTopQuality: 30,
 *                bufferTimeAtTopQualityLongForm: 60,
 *                initialBufferLevel: NaN,
 *                stableBufferTime: 12,
 *                longFormContentDurationThreshold: 600,
 *                stallThreshold: 0.5,
 *                useAppendWindow: true,
 *                setStallState: true
 *            },
 *            gaps: {
 *                jumpGaps: true,
 *                jumpLargeGaps: true,
 *                smallGapLimit: 1.5,
 *                threshold: 0.3,
 *                enableSeekFix: true,
 *                enableStallFix: false,
 *                stallSeek: 0.1
 *            },
 *            utcSynchronization: {
 *                enabled: true,
 *                useManifestDateHeaderTimeSource: true,
 *                backgroundAttempts: 2,
 *                timeBetweenSyncAttempts: 30,
 *                maximumTimeBetweenSyncAttempts: 600,
 *                minimumTimeBetweenSyncAttempts: 2,
 *                timeBetweenSyncAttemptsAdjustmentFactor: 2,
 *                maximumAllowedDrift: 100,
 *                enableBackgroundSyncAfterSegmentDownloadError: true,
 *                defaultTimingSource: {
 *                    scheme: 'urn:mpeg:dash:utc:http-xsdate:2014',
 *                    value: 'http://time.akamai.com/?iso&ms'
 *                }
 *            },
 *            scheduling: {
 *                defaultTimeout: 300,
 *                lowLatencyTimeout: 100,
 *                scheduleWhilePaused: true
 *            },
 *            text: {
 *                defaultEnabled: true
 *            },
 *            liveCatchup: {
 *                maxDrift: NaN,
 *                playbackRate: NaN,
 *                playbackBufferMin: 0.5,
 *                latencyThreshold: 60,
 *                enabled: false,
 *                mode: Constants.LIVE_CATCHUP_MODE_DEFAULT
 *            },
 *            lastBitrateCachingInfo: { enabled: true, ttl: 360000 },
 *            lastMediaSettingsCachingInfo: { enabled: true, ttl: 360000 },
 *            cacheLoadThresholds: { video: 50, audio: 5 },
 *            trackSwitchMode: {
 *                audio: Constants.TRACK_SWITCH_MODE_ALWAYS_REPLACE,
 *                video: Constants.TRACK_SWITCH_MODE_NEVER_REPLACE
 *            },
 *            selectionModeForInitialTrack: Constants.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,
 *            fragmentRequestTimeout: 0,
 *            retryIntervals: {
 *                [HTTPRequest.MPD_TYPE]: 500,
 *                [HTTPRequest.XLINK_EXPANSION_TYPE]: 500,
 *                [HTTPRequest.MEDIA_SEGMENT_TYPE]: 1000,
 *                [HTTPRequest.INIT_SEGMENT_TYPE]: 1000,
 *                [HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE]: 1000,
 *                [HTTPRequest.INDEX_SEGMENT_TYPE]: 1000,
 *                [HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE]: 1000,
 *                [HTTPRequest.LICENSE]: 1000,
 *                [HTTPRequest.OTHER_TYPE]: 1000,
 *                lowLatencyReductionFactor: 10
 *            },
 *            retryAttempts: {
 *                [HTTPRequest.MPD_TYPE]: 3,
 *                [HTTPRequest.XLINK_EXPANSION_TYPE]: 1,
 *                [HTTPRequest.MEDIA_SEGMENT_TYPE]: 3,
 *                [HTTPRequest.INIT_SEGMENT_TYPE]: 3,
 *                [HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE]: 3,
 *                [HTTPRequest.INDEX_SEGMENT_TYPE]: 3,
 *                [HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE]: 3,
 *                [HTTPRequest.LICENSE]: 3,
 *                [HTTPRequest.OTHER_TYPE]: 3,
 *                lowLatencyMultiplyFactor: 5
 *            },
 *            abr: {
 *                movingAverageMethod: Constants.MOVING_AVERAGE_SLIDING_WINDOW,
 *                ABRStrategy: Constants.ABR_STRATEGY_DYNAMIC,
 *                additionalAbrRules: {
 *                   insufficientBufferRule: false,
 *                   switchHistoryRule: true,
 *                   droppedFramesRule: true,
 *                   abandonRequestsRule: false
 *                },
 *                bandwidthSafetyFactor: 0.9,
 *                useDefaultABRRules: true,
 *                useDeadTimeLatency: true,
 *                limitBitrateByPortal: false,
 *                usePixelRatioInLimitBitrateByPortal: false,
 *                maxBitrate: { audio: -1, video: -1 },
 *                minBitrate: { audio: -1, video: -1 },
 *                maxRepresentationRatio: { audio: 1, video: 1 },
 *                initialBitrate: { audio: -1, video: -1 },
 *                initialRepresentationRatio: { audio: -1, video: -1 },
 *                autoSwitchBitrate: { audio: true, video: true },
 *                fetchThroughputCalculationMode: Constants.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA
 *            },
 *            cmcd: {
 *                enabled: false,
 *                sid: null,
 *                cid: null,
 *                rtp: null,
 *                rtpSafetyFactor: 5,
 *                mode: Constants.CMCD_MODE_QUERY,
 *                enabledKeys: ['br', 'd', 'ot', 'tb' , 'bl', 'dl', 'mtp', 'nor', 'nrr', 'su' , 'bs', 'rtp' , 'cid', 'pr', 'sf', 'sid', 'st', 'v']
 *            }
 *          },
 *          errors: {
 *            recoverAttempts: {
 *                mediaErrorDecode: 5
 *             }
 *          }
 * }
 */

/**
 * @typedef {Object} TimeShiftBuffer
 * @property {boolean} [calcFromSegmentTimeline=false]
 * Enable calculation of the DVR window for SegmentTimeline manifests based on the entries in \<SegmentTimeline\>.
 *  * @property {boolean} [fallbackToSegmentTimeline=true]
 * In case the MPD uses \<SegmentTimeline\ and no segment is found within the DVR window the DVR window is calculated based on the entries in \<SegmentTimeline\>.
 */

/**
 * @typedef {Object} LiveDelay
 * @property {number} [liveDelayFragmentCount=NaN]
 * Changing this value will lower or increase live stream latency.
 *
 * The detected segment duration will be multiplied by this value to define a time in seconds to delay a live stream from the live edge.
 *
 * Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.
 * @property {number} [liveDelay]
 * Equivalent in seconds of setLiveDelayFragmentCount.
 *
 * Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.
 *
 * This value should be less than the manifest duration by a couple of segment durations to avoid playback issues.
 *
 * If set, this parameter will take precedence over setLiveDelayFragmentCount and manifest info.
 * @property {boolean} [useSuggestedPresentationDelay=true]
 * Set to true if you would like to overwrite the default live delay and honor the SuggestedPresentationDelay attribute in by the manifest.
 */

/**
 * @typedef {Object} Buffer
 * @property {boolean} [enableSeekDecorrelationFix=false]
 * Enables a workaround for playback start on some devices, e.g. WebOS 4.9.
 * It is necessary because some browsers do not support setting currentTime on video element to a value that is outside of current buffer.
 *
 * If you experience unexpected seeking triggered by BufferController, you can try setting this value to false.

 * @property {boolean} [fastSwitchEnabled=true]
 * When enabled, after an ABR up-switch in quality, instead of requesting and appending the next fragment at the end of the current buffer range it is requested and appended closer to the current time.
 *
 * When enabled, The maximum time to render a higher quality is current time + (1.5 * fragment duration).
 *
 * Note, When ABR down-switch is detected, we appended the lower quality at the end of the buffer range to preserve the
 * higher quality media for as long as possible.
 *
 * If enabled, it should be noted there are a few cases when the client will not replace inside buffer range but rather just append at the end.
 * 1. When the buffer level is less than one fragment duration.
 * 2. The client is in an Abandonment State due to recent fragment abandonment event.
 *
 * Known issues:
 * 1. In IE11 with auto switching off, if a user switches to a quality they can not download in time the fragment may be appended in the same range as the playhead or even in the past, in IE11 it may cause a stutter or stall in playback.
 * @property {boolean} [flushBufferAtTrackSwitch=false]
 * When enabled, after a track switch and in case buffer is being replaced, the video element is flushed (seek at current playback time) once a segment of the new track is appended in buffer in order to force video decoder to play new track.
 *
 * This can be required on some devices like GoogleCast devices to make track switching functional.
 *
 * Otherwise track switching will be effective only once after previous buffered track is fully consumed.
 * @property {boolean} [reuseExistingSourceBuffers=true]
 * Enable reuse of existing MediaSource Sourcebuffers during period transition.
 * @property {number} [bufferPruningInterval=10]
 * The interval of pruning buffer in seconds.
 * @property {number} [bufferToKeep=20]
 * This value influences the buffer pruning logic.
 *
 * Allows you to modify the buffer that is kept in source buffer in seconds.
 * 0|-----------bufferToPrune-----------|-----bufferToKeep-----|currentTime|
 * @property {number} [bufferTimeAtTopQuality=30]
 * The time that the internal buffer target will be set to once playing the top quality.
 *
 * If there are multiple bitrates in your adaptation, and the media is playing at the highest bitrate, then we try to build a larger buffer at the top quality to increase stability and to maintain media quality.
 * @property {number} [bufferTimeAtTopQualityLongForm=60]
 * The time that the internal buffer target will be set to once playing the top quality for long form content.
 * @property {number} [longFormContentDurationThreshold=600]
 * The threshold which defines if the media is considered long form content.
 *
 * This will directly affect the buffer targets when playing back at the top quality.
 * @property {number} [initialBufferLevel=NaN]
 * Initial buffer level before playback starts
 * @property {number} [stableBufferTime=12]
 * The time that the internal buffer target will be set to post startup/seeks (NOT top quality).
 *
 * When the time is set higher than the default you will have to wait longer to see automatic bitrate switches but will have a larger buffer which will increase stability.
 * @property {number} [stallThreshold=0.3]
 * Stall threshold used in BufferController.js to determine whether a track should still be changed and which buffer range to prune.
 * @property {boolean} [useAppendWindow=true]
 * Specifies if the appendWindow attributes of the MSE SourceBuffers should be set according to content duration from manifest.
 * @property {boolean} [setStallState=true]
 * Specifies if we fire manual waiting events once the stall threshold is reached
 */

/**
 * @typedef {Object} module:Settings~AudioVideoSettings
 * @property {number|boolean|string} [audio]
 * Configuration for audio media type of tracks.
 * @property {number|boolean|string} [video]
 * Configuration for video media type of tracks.
 */

/**
 * @typedef {Object} DebugSettings
 * @property {number} [logLevel=dashjs.Debug.LOG_LEVEL_WARNING]
 * Sets up the log level. The levels are cumulative.
 *
 * For example, if you set the log level to dashjs.Debug.LOG_LEVEL_WARNING all warnings, errors and fatals will be logged.
 *
 * Possible values.
 *
 * - dashjs.Debug.LOG_LEVEL_NONE
 * No message is written in the browser console.
 *
 * - dashjs.Debug.LOG_LEVEL_FATAL
 * Log fatal errors.
 * An error is considered fatal when it causes playback to fail completely.
 *
 * - dashjs.Debug.LOG_LEVEL_ERROR
 * Log error messages.
 *
 * - dashjs.Debug.LOG_LEVEL_WARNING
 * Log warning messages.
 *
 * - dashjs.Debug.LOG_LEVEL_INFO
 * Log info messages.
 *
 * - dashjs.Debug.LOG_LEVEL_DEBUG
 * Log debug messages.
 * @property {boolean} [dispatchEvent=false]
 * Enable to trigger a Events.LOG event whenever log output is generated.
 *
 * Note this will be dispatched regardless of log level.
 */

/**
 * @typedef {Object} module:Settings~ErrorSettings
 * @property {object} [recoverAttempts={mediaErrorDecode: 5}]
 * Defines the maximum number of recover attempts for specific media errors.
 *
 * For mediaErrorDecode the player will reset the MSE and skip the blacklisted segment that caused the decode error. The resulting gap will be handled by the GapController.
 */

/**
 * @typedef {Object} CachingInfoSettings
 * @property {boolean} [enable]
 * Enable or disable the caching feature.
 * @property {number} [ttl]
 * Time to live.
 *
 * A value defined in milliseconds representing how log to cache the settings for.
 */

/**
 * @typedef {Object} Gaps
 * @property {boolean} [jumpGaps=true]
 * Sets whether player should jump small gaps (discontinuities) in the buffer.
 * @property {boolean} [jumpLargeGaps=true]
 * Sets whether player should jump large gaps (discontinuities) in the buffer.
 * @property {number} [smallGapLimit=1.5]
 * Time in seconds for a gap to be considered small.
 * @property {number} [threshold=0.3]
 * Threshold at which the gap handling is executed. If currentRangeEnd - currentTime < threshold the gap jump will be triggered.
 * For live stream the jump might be delayed to keep a consistent live edge.
 * Note that the amount of buffer at which platforms automatically stall might differ.
 * @property {boolean} [enableSeekFix=true]
 * Enables the adjustment of the seek target once no valid segment request could be generated for a specific seek time. This can happen if the user seeks to a position for which there is a gap in the timeline.
 * @property {boolean} [enableStallFix=false]
 * If playback stalled in a buffered range this fix will perform a seek by the value defined in stallSeek to trigger playback again.
 * @property {number} [stallSeek=0.1]
 * Value to be used in case enableStallFix is set to true
 */

/**
 * @typedef {Object} UtcSynchronizationSettings
 * @property {boolean} [enabled=true]
 * Enables or disables the UTC clock synchronization
 * @property {boolean} [useManifestDateHeaderTimeSource=true]
 * Allows you to enable the use of the Date Header, if exposed with CORS, as a timing source for live edge detection.
 *
 * The use of the date header will happen only after the other timing source that take precedence fail or are omitted as described.
 * @property {number} [backgroundAttempts=2]
 * Number of synchronization attempts to perform in the background after an initial synchronization request has been done. This is used to verify that the derived client-server offset is correct.
 *
 * The background requests are async and done in parallel to the start of the playback.
 *
 * This value is also used to perform a resync after 404 errors on segments.
 * @property {number} [timeBetweenSyncAttempts=30]
 * The time in seconds between two consecutive sync attempts.
 *
 * Note: This value is used as an initial starting value. The internal value of the TimeSyncController is adjusted during playback based on the drift between two consecutive synchronization attempts.
 *
 * Note: A sync is only performed after an MPD update. In case the @minimumUpdatePeriod is larger than this value the sync will be delayed until the next MPD update.
 * @property {number} [maximumTimeBetweenSyncAttempts=600]
 * The maximum time in seconds between two consecutive sync attempts.
 *
 * @property {number} [minimumTimeBetweenSyncAttempts=2]
 * The minimum time in seconds between two consecutive sync attempts.
 *
 * @property {number} [timeBetweenSyncAttemptsAdjustmentFactor=2]
 * The factor used to multiply or divide the timeBetweenSyncAttempts parameter after a sync. The maximumAllowedDrift defines whether this value is used as a factor or a dividend.
 *
 * @property {number} [maximumAllowedDrift=100]
 * The maximum allowed drift specified in milliseconds between two consecutive synchronization attempts.
 *
 * @property {boolean} [enableBackgroundSyncAfterSegmentDownloadError=true]
 * Enables or disables the background sync after the player ran into a segment download error.
 *
 * @property {object} [defaultTimingSource={scheme:'urn:mpeg:dash:utc:http-xsdate:2014',value: 'http://time.akamai.com/?iso&ms'}]
 * The default timing source to be used. The timing sources in the MPD take precedence over this one.
 */

/**
 * @typedef {Object} Scheduling
 * @property {number} [defaultTimeout=300]
 * Default timeout between two consecutive segment scheduling attempts
 * @property {number} [lowLatencyTimeout]
 * Default timeout between two consecutive low-latency segment scheduling attempts
 * @property {boolean} [scheduleWhilePaused=true]
 * Set to true if you would like dash.js to keep downloading fragments in the background when the video element is paused.
 */

/**
 * @typedef {Object} Text
 * @property {number} [defaultEnabled=true]
 * Enable/disable subtitle rendering by default.
 */

/**
 * @typedef {Object} LiveCatchupSettings
 * @property {number} [maxDrift=NaN]
 * Use this method to set the maximum latency deviation allowed before dash.js to do a seeking to live position.
 *
 * In low latency mode, when the difference between the measured latency and the target one, as an absolute number, is higher than the one sets with this method, then dash.js does a seek to live edge position minus the target live delay.
 *
 * LowLatencyMaxDriftBeforeSeeking should be provided in seconds.
 *
 * If 0, then seeking operations won't be used for fixing latency deviations.
 *
 * Note: Catch-up mechanism is only applied when playing low latency live streams.
 * @property {number} [playbackRate=NaN]
 * Use this parameter to set the maximum catch up rate, as a percentage, for low latency live streams.
 *
 * In low latency mode, when measured latency is higher/lower than the target one, dash.js increases/decreases playback rate respectively up to (+/-) the percentage defined with this method until target is reached.
 *
 * Valid values for catch up rate are in range 0-0.5 (0-50%).
 *
 * Set it to 0 to turn off live catch up feature.
 *
 * Note: Catch-up mechanism is only applied when playing low latency live streams.
 * @property {number} [latencyThreshold=60]
 * Use this parameter to set the maximum threshold for which live catch up is applied.
 *
 * For instance, if this value is set to 8 seconds, then live catchup is only applied if the current live latency is equal or below 8 seconds.
 *
 * The reason behind this parameter is to avoid an increase of the playback rate if the user seeks within the DVR window.
 *
 * If no value is specified catchup mode will always be applied
 *
 * @property {number} [playbackBufferMin=NaN]
 * Use this parameter to specify the minimum buffer which is used for LoL+ based playback rate reduction.
 *
 *
 * @property {boolean} [enabled=false]
 * Use this parameter to enable the catchup mode for non low-latency streams.
 *
 * @property {string} [mode="liveCatchupModeDefault"]
 * Use this parameter to switch between different catchup modes.
 *
 * Options: "liveCatchupModeDefault" or "liveCatchupModeLOLP".
 *
 * Note: Catch-up mechanism is automatically applied when playing low latency live streams.
 */

/**
 * @typedef {Object} RequestTypeSettings
 * @property {number} [MPD]
 * Manifest type of requests.
 * @property {number} [XLinkExpansion]
 * XLink expansion type of requests.
 * @property {number} [InitializationSegment]
 * Request to retrieve an initialization segment.
 * @property {number} [IndexSegment]
 * Request to retrieve an index segment (SegmentBase).
 * @property {number} [MediaSegment]
 * Request to retrieve a media segment (video/audio/image/text chunk).
 * @property {number} [BitstreamSwitchingSegment]
 * Bitrate stream switching type of request.
 * @property {number} [FragmentInfoSegment]
 * Request to retrieve a FragmentInfo segment (specific to Smooth Streaming live streams).
 * @property {number} [other]
 * Other type of request.
 * @property {number} [lowLatencyReductionFactor]
 * For low latency mode, values of type of request are divided by lowLatencyReductionFactor.
 *
 * Note: It's not type of request.
 * @property {number} [lowLatencyMultiplyFactor]
 * For low latency mode, values of type of request are multiplied by lowLatencyMultiplyFactor.
 *
 * Note: It's not type of request.
 */

/**
 * @typedef {Object} Protection
 * @property {boolean} [keepProtectionMediaKeys=false]
 * Set the value for the ProtectionController and MediaKeys life cycle.
 *
 * If true, the ProtectionController and then created MediaKeys and MediaKeySessions will be preserved during the MediaPlayer lifetime.
 * @property {boolean} ignoreEmeEncryptedEvent
 * If set to true the player will ignore "encrypted" and "needkey" events thrown by the EME.
 *
 * @property {boolean} detectPlayreadyMessageFormat
 * If set to true the player will use the raw unwrapped message from the Playready CDM
 */

/**
 * @typedef {Object} Capabilities
 * @property {boolean} [filterUnsupportedEssentialProperties=true]
 * Enable to filter all the AdaptationSets and Representations which contain an unsupported \<EssentialProperty\> element.
 * @property {boolean} [useMediaCapabilitiesApi=false]
 * Enable to use the MediaCapabilities API to check whether codecs are supported. If disabled MSE.isTypeSupported will be used instead.
 */

/**
 * @typedef {Object} AbrSettings
 * @property {string} [movingAverageMethod="slidingWindow"]
 * Sets the moving average method used for smoothing throughput estimates.
 *
 * Valid methods are "slidingWindow" and "ewma".
 *
 * The call has no effect if an invalid method is passed.
 *
 * The sliding window moving average method computes the average throughput using the last four segments downloaded.
 *
 * If the stream is live (as opposed to VOD), then only the last three segments are used.
 *
 * If wide variations in throughput are detected, the number of segments can be dynamically increased to avoid oscillations.
 *
 * The exponentially weighted moving average (EWMA) method computes the average using exponential smoothing.
 *
 * Two separate estimates are maintained, a fast one with a three-second half life and a slow one with an eight-second half life.
 *
 * The throughput estimate at any time is the minimum of the fast and slow estimates.
 *
 * This allows a fast reaction to a bandwidth drop and prevents oscillations on bandwidth spikes.
 * @property {string} [ABRStrategy="abrDynamic"]
 * Returns the current ABR strategy being used: "abrDynamic", "abrBola" or "abrThroughput".
 * @property {object} [trackSwitchMode={video: "neverReplace", audio: "alwaysReplace"}]
 * @property {object} [additionalAbrRules={insufficientBufferRule: false,switchHistoryRule: true,droppedFramesRule: true,abandonRequestsRule: false}]
 * Enable/Disable additional ABR rules in case ABRStrategy is set to "abrDynamic", "abrBola" or "abrThroughput".
 * @property {number} [bandwidthSafetyFactor=0.9]
 * Standard ABR throughput rules multiply the throughput by this value.
 *
 * It should be between 0 and 1, with lower values giving less rebuffering (but also lower quality).
 * @property {boolean} [useDefaultABRRules=true]
 * Should the default ABR rules be used, or the custom ones added.
 * @property {boolean} [useDeadTimeLatency=true]
 * If true, only the download portion will be considered part of the download bitrate and latency will be regarded as static.
 *
 * If false, the reciprocal of the whole transfer time will be used.
 * @property {boolean} [limitBitrateByPortal=false]
 * If true, the size of the video portal will limit the max chosen video resolution.
 * @property {boolean} [usePixelRatioInLimitBitrateByPortal=false]
 * Sets whether to take into account the device's pixel ratio when defining the portal dimensions.
 *
 * Useful on, for example, retina displays.
 * @property {module:Settings~AudioVideoSettings} [maxBitrate={audio: -1, video: -1}]
 * The maximum bitrate that the ABR algorithms will choose. This value is specified in kbps.
 *
 * Use -1 for no limit.
 * @property {module:Settings~AudioVideoSettings} [minBitrate={audio: -1, video: -1}]
 * The minimum bitrate that the ABR algorithms will choose. This value is specified in kbps.
 *
 * Use -1 for no limit.
 * @property {module:Settings~AudioVideoSettings} [maxRepresentationRatio={audio: 1, video: 1}]
 * When switching multi-bitrate content (auto or manual mode) this property specifies the maximum representation allowed, as a proportion of the size of the representation set.
 *
 * You can set or remove this cap at anytime before or during playback.
 *
 * To clear this setting you set the value to 1.
 *
 * If both this and maxAllowedBitrate are defined, maxAllowedBitrate is evaluated first, then maxAllowedRepresentation, i.e. the lowest value from executing these rules is used.
 *
 * This feature is typically used to reserve higher representations for playback only when connected over a fast connection.
 * @property {module:Settings~AudioVideoSettings} [initialBitrate={audio: -1, video: -1}]
 * Explicitly set the starting bitrate for audio or video. This value is specified in kbps.
 *
 * Use -1 to let the player decide.
 * @property {module:Settings~AudioVideoSettings} [initialRepresentationRatio={audio: -1, video: -1}]
 * Explicitly set the initial representation ratio.
 *
 * If initalBitrate is specified, this is ignored.
 * @property {module:Settings~AudioVideoSettings} [autoSwitchBitrate={audio: true, video: true}]
 * Indicates whether the player should enable ABR algorithms to switch the bitrate.
 *
 * @property {string} [fetchThroughputCalculationMode="abrFetchThroughputCalculationDownloadedData"]
 * Algorithm to determine the throughput in case the Fetch API is used for low latency streaming.
 *
 * For details please check the samples section and FetchLoader.js.
 */

/**
 * @typedef {Object} module:Settings~CmcdSettings
 * @property {boolean} [enable=false]
 * Enable or disable the CMCD reporting.
 * @property {string} [sid]
 * GUID identifying the current playback session.
 *
 * Should be in UUID format.
 *
 * If not specified a UUID will be automatically generated.
 * @property {string} [cid]
 * A unique string to identify the current content.
 *
 * If not specified it will be a hash of the MPD url.
 * @property {number} [rtp]
 * The requested maximum throughput that the client considers sufficient for delivery of the asset.
 *
 * If not specified this value will be dynamically calculated in the CMCDModel based on the current buffer level.
 * @property {number} [rtpSafetyFactor]
 * This value is used as a factor for the rtp value calculation: rtp = minBandwidth * rtpSafetyFactor
 *
 * If not specified this value defaults to 5. Note that this value is only used when no static rtp value is defined.
 * @property {number} [mode]
 * The method to use to attach cmcd metrics to the requests. 'query' to use query parameters, 'header' to use http headers.
 *
 * If not specified this value defaults to 'query'.
 * @property {Array.<string>} [enabledKeys]
 * This value is used to specify the desired CMCD parameters. Parameters not included in this list are not reported.
 */

/**
 * @typedef {Object} Metrics
 * @property {number} [metricsMaxListDepth=100]
 * Maximum number of metrics that are persisted per type.
 */

/**
 * @typedef {Object} StreamingSettings
 * @property {number} [abandonLoadTimeout=10000]
 * A timeout value in seconds, which during the ABRController will block switch-up events.
 *
 * This will only take effect after an abandoned fragment event occurs.
 * @property {number} [wallclockTimeUpdateInterval=50]
 * How frequently the wallclockTimeUpdated internal event is triggered (in milliseconds).
 * @property {number} [manifestUpdateRetryInterval=100]
 * For live streams, set the interval-frequency in milliseconds at which dash.js will check if the current manifest is still processed before downloading the next manifest once the minimumUpdatePeriod time has.
 * @property {boolean} [cacheInitSegments=true]
 * Enables the caching of init segments to avoid requesting the init segments before each representation switch.
 * @property {boolean} [applyServiceDescription=true]
 * Set to true if dash.js should use the parameters defined in ServiceDescription elements
 * @property {boolean} [applyProducerReferenceTime=true]
 * Set to true if dash.js should use the parameters defined in ProducerReferenceTime elements in combination with ServiceDescription elements.
 * @property {number} [eventControllerRefreshDelay=100]
 * Defines the delay in milliseconds between two consecutive checks for events to be fired.
 * @property {module:Settings~Metrics} metrics Metric settings
 * @property {module:Settings~LiveDelay} delay Live Delay settings
 * @property {module:Settings~TimeShiftBuffer} timeShiftBuffer TimeShiftBuffer settings
 * @property {module:Settings~Protection} protection DRM related settings
 * @property {module:Settings~Capabilities} capabilities Capability related settings
 * @property {module:Settings~Buffer}  buffer Buffer related settings
 * @property {module:Settings~Gaps}  gaps Gap related settings
 * @property {module:Settings~UtcSynchronizationSettings} utcSynchronization Settings related to UTC clock synchronization
 * @property {module:Settings~Scheduling} scheduling Settings related to segment scheduling
 * @property {module:Settings~Text} text Settings related to Subtitles and captions
 * @property {module:Settings~LiveCatchupSettings} liveCatchup  Settings related to live catchup.
 * @property {module:Settings~CachingInfoSettings} [lastBitrateCachingInfo={enabled: true, ttl: 360000}]
 * Set to false if you would like to disable the last known bit rate from being stored during playback and used to set the initial bit rate for subsequent playback within the expiration window.
 *
 * The default expiration is one hour, defined in milliseconds.
 *
 * If expired, the default initial bit rate (closest to 1000 kbps) will be used for that session and a new bit rate will be stored during that session.
 * @property {module:Settings~AudioVideoSettings} [cacheLoadThresholds={video: 50, audio: 5}]
 * For a given media type, the threshold which defines if the response to a fragment request is coming from browser cache or not.
 * @property {module:Settings~AudioVideoSettings} [trackSwitchMode={video: "neverReplace", audio: "alwaysReplace"}]
 * For a given media type defines if existing segments in the buffer should be overwritten once the track is switched. For instance if the user switches the audio language the existing segments in the audio buffer will be replaced when setting this value to "alwaysReplace".
 *
 * Possible values
 *
 * - Constants.TRACK_SWITCH_MODE_ALWAYS_REPLACE
 * Replace existing segments in the buffer
 *
 * - Constants.TRACK_SWITCH_MODE_NEVER_REPLACE
 * Do not replace existing segments in the buffer
 *
 * @property {string} [selectionModeForInitialTrack="highestBitrate"]
 * Sets the selection mode for the initial track. This mode defines how the initial track will be selected if no initial media settings are set. If initial media settings are set this parameter will be ignored. Available options are:
 *
 * Possible values
 *
 * - Constants.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY
 * This mode makes the player select the track with the highest selectionPriority as defined in the manifest. If not selectionPriority is given we fallback to TRACK_SELECTION_MODE_HIGHEST_BITRATE. This mode is a default mode.
 *
 * - Constants.TRACK_SELECTION_MODE_HIGHEST_BITRATE
 * This mode makes the player select the track with a highest bitrate.
 *
 * - Constants.TRACK_SELECTION_MODE_FIRST_TRACK
 * This mode makes the player select the first track found in the manifest.
 *
 * - Constants.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY
 * This mode makes the player select the track with the lowest bitrate per pixel average.
 *
 * - Constants.TRACK_SELECTION_MODE_WIDEST_RANGE
 * This mode makes the player select the track with a widest range of bitrates.
 *
 *
 * @property {number} [fragmentRequestTimeout=0]
 * Time in milliseconds before timing out on loading a media fragment.
 *
 * Fragments that timeout are retried as if they failed.
 * @property {module:Settings~RequestTypeSettings} [retryIntervals]
 * Time in milliseconds of which to reload a failed file load attempt.
 *
 * For low latency mode these values are divided by lowLatencyReductionFactor.
 * @property {module:Settings~RequestTypeSettings} [retryAttempts]
 * Total number of retry attempts that will occur on a file load before it fails.
 *
 * For low latency mode these values are multiplied by lowLatencyMultiplyFactor.
 * @property {module:Settings~AbrSettings} abr
 * Adaptive Bitrate algorithm related settings.
 * @property {module:Settings~CmcdSettings} cmcd
 * Settings related to Common Media Client Data reporting.
 */

/**
 * @class
 * @ignore
 */

function Settings() {
  var _retryIntervals, _retryAttempts;

  var instance;
  var context = this.context;
  var eventBus = Object(_EventBus__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var DISPATCH_KEY_MAP = {
    'streaming.delay.liveDelay': _events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SETTING_UPDATED_LIVE_DELAY,
    'streaming.delay.liveDelayFragmentCount': _events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,
    'streaming.liveCatchup.enabled': _events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SETTING_UPDATED_CATCHUP_ENABLED
  };
  /**
   * @const {PlayerSettings} defaultSettings
   * @ignore
   */

  var defaultSettings = {
    debug: {
      logLevel: _core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"].LOG_LEVEL_WARNING,
      dispatchEvent: false
    },
    streaming: {
      abandonLoadTimeout: 10000,
      wallclockTimeUpdateInterval: 100,
      manifestUpdateRetryInterval: 100,
      cacheInitSegments: false,
      applyServiceDescription: true,
      applyProducerReferenceTime: true,
      eventControllerRefreshDelay: 150,
      capabilities: {
        filterUnsupportedEssentialProperties: true,
        useMediaCapabilitiesApi: false
      },
      timeShiftBuffer: {
        calcFromSegmentTimeline: false,
        fallbackToSegmentTimeline: true
      },
      metrics: {
        maxListDepth: 100
      },
      delay: {
        liveDelayFragmentCount: NaN,
        liveDelay: NaN,
        useSuggestedPresentationDelay: true
      },
      protection: {
        keepProtectionMediaKeys: false,
        ignoreEmeEncryptedEvent: false,
        detectPlayreadyMessageFormat: true
      },
      buffer: {
        enableSeekDecorrelationFix: false,
        fastSwitchEnabled: true,
        flushBufferAtTrackSwitch: false,
        reuseExistingSourceBuffers: true,
        bufferPruningInterval: 10,
        bufferToKeep: 20,
        bufferTimeAtTopQuality: 30,
        bufferTimeAtTopQualityLongForm: 60,
        initialBufferLevel: NaN,
        stableBufferTime: 12,
        longFormContentDurationThreshold: 600,
        stallThreshold: 0.3,
        useAppendWindow: true,
        setStallState: true
      },
      gaps: {
        jumpGaps: true,
        jumpLargeGaps: true,
        smallGapLimit: 1.5,
        threshold: 0.3,
        enableSeekFix: true,
        enableStallFix: false,
        stallSeek: 0.1
      },
      utcSynchronization: {
        enabled: true,
        useManifestDateHeaderTimeSource: true,
        backgroundAttempts: 2,
        timeBetweenSyncAttempts: 30,
        maximumTimeBetweenSyncAttempts: 600,
        minimumTimeBetweenSyncAttempts: 2,
        timeBetweenSyncAttemptsAdjustmentFactor: 2,
        maximumAllowedDrift: 100,
        enableBackgroundSyncAfterSegmentDownloadError: true,
        defaultTimingSource: {
          scheme: 'urn:mpeg:dash:utc:http-xsdate:2014',
          value: 'https://time.akamai.com/?iso&ms'
        }
      },
      scheduling: {
        defaultTimeout: 500,
        lowLatencyTimeout: 0,
        scheduleWhilePaused: true
      },
      text: {
        defaultEnabled: true
      },
      liveCatchup: {
        maxDrift: NaN,
        playbackRate: NaN,
        playbackBufferMin: 0.5,
        enabled: null,
        latencyThreshold: 60,
        mode: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_DEFAULT
      },
      lastBitrateCachingInfo: {
        enabled: true,
        ttl: 360000
      },
      lastMediaSettingsCachingInfo: {
        enabled: true,
        ttl: 360000
      },
      cacheLoadThresholds: {
        video: 50,
        audio: 5
      },
      trackSwitchMode: {
        audio: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].TRACK_SWITCH_MODE_ALWAYS_REPLACE,
        video: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].TRACK_SWITCH_MODE_NEVER_REPLACE
      },
      selectionModeForInitialTrack: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,
      fragmentRequestTimeout: 20000,
      retryIntervals: (_retryIntervals = {}, _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MPD_TYPE, 500), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].XLINK_EXPANSION_TYPE, 500), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MEDIA_SEGMENT_TYPE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].INIT_SEGMENT_TYPE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].BITSTREAM_SWITCHING_SEGMENT_TYPE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].INDEX_SEGMENT_TYPE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].LICENSE, 1000), _defineProperty(_retryIntervals, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].OTHER_TYPE, 1000), _defineProperty(_retryIntervals, "lowLatencyReductionFactor", 10), _retryIntervals),
      retryAttempts: (_retryAttempts = {}, _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MPD_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].XLINK_EXPANSION_TYPE, 1), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MEDIA_SEGMENT_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].INIT_SEGMENT_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].BITSTREAM_SWITCHING_SEGMENT_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].INDEX_SEGMENT_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].LICENSE, 3), _defineProperty(_retryAttempts, _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_4__["HTTPRequest"].OTHER_TYPE, 3), _defineProperty(_retryAttempts, "lowLatencyMultiplyFactor", 5), _retryAttempts),
      abr: {
        movingAverageMethod: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].MOVING_AVERAGE_SLIDING_WINDOW,
        ABRStrategy: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].ABR_STRATEGY_DYNAMIC,
        additionalAbrRules: {
          insufficientBufferRule: true,
          switchHistoryRule: true,
          droppedFramesRule: true,
          abandonRequestsRule: true
        },
        bandwidthSafetyFactor: 0.9,
        useDefaultABRRules: true,
        useDeadTimeLatency: true,
        limitBitrateByPortal: false,
        usePixelRatioInLimitBitrateByPortal: false,
        maxBitrate: {
          audio: -1,
          video: -1
        },
        minBitrate: {
          audio: -1,
          video: -1
        },
        maxRepresentationRatio: {
          audio: 1,
          video: 1
        },
        initialBitrate: {
          audio: -1,
          video: -1
        },
        initialRepresentationRatio: {
          audio: -1,
          video: -1
        },
        autoSwitchBitrate: {
          audio: true,
          video: true
        },
        fetchThroughputCalculationMode: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING
      },
      cmcd: {
        enabled: false,
        sid: null,
        cid: null,
        rtp: null,
        rtpSafetyFactor: 5,
        mode: _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].CMCD_MODE_QUERY,
        enabledKeys: ['br', 'd', 'ot', 'tb', 'bl', 'dl', 'mtp', 'nor', 'nrr', 'su', 'bs', 'rtp', 'cid', 'pr', 'sf', 'sid', 'st', 'v']
      }
    },
    errors: {
      recoverAttempts: {
        mediaErrorDecode: 5
      }
    }
  };
  var settings = _Utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(defaultSettings); //Merge in the settings. If something exists in the new config that doesn't match the schema of the default config,
  //regard it as an error and log it.

  function mixinSettings(source, dest, path) {
    for (var n in source) {
      if (source.hasOwnProperty(n)) {
        if (dest.hasOwnProperty(n)) {
          if (_typeof(source[n]) === 'object' && !(source[n] instanceof Array) && source[n] !== null) {
            mixinSettings(source[n], dest[n], path.slice() + n + '.');
          } else {
            dest[n] = _Utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(source[n]);

            if (DISPATCH_KEY_MAP[path + n]) {
              eventBus.trigger(DISPATCH_KEY_MAP[path + n]);
            }
          }
        } else {
          console.error('Settings parameter ' + path + n + ' is not supported');
        }
      }
    }
  }
  /**
   * Return the settings object. Don't copy/store this object, you won't get updates.
   * @func
   * @instance
   */


  function get() {
    return settings;
  }
  /**
   * @func
   * @instance
   * @param {object} settingsObj - This should be a partial object of the Settings.Schema type. That is, fields defined should match the path (e.g.
   * settingsObj.streaming.abr.autoSwitchBitrate.audio -> defaultSettings.streaming.abr.autoSwitchBitrate.audio). Where an element's path does
   * not match it is ignored, and a warning is logged.
   *
   * Use to change the settings object. Any new values defined will overwrite the settings and anything undefined will not change.
   * Implementers of new settings should add it in an approriate namespace to the defaultSettings object and give it a default value (that is not undefined).
   *
   */


  function update(settingsObj) {
    if (_typeof(settingsObj) === 'object') {
      mixinSettings(settingsObj, settings, '');
    }
  }
  /**
   * Resets the settings object. Everything is set to its default value.
   * @func
   * @instance
   *
   */


  function reset() {
    settings = _Utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].clone(defaultSettings);
  }

  instance = {
    get: get,
    update: update,
    reset: reset
  };
  return instance;
}

Settings.__dashjs_factory_name = 'Settings';
var factory = _FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(Settings);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/core/Utils.js":
/*!***************************!*\
  !*** ./src/core/Utils.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_619166__) {

"use strict";
__nested_webpack_require_619166__.r(__webpack_exports__);
/* harmony import */ var path_browserify__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_619166__(/*! path-browserify */ "./node_modules/path-browserify/index.js");
/* harmony import */ var path_browserify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_619166__.n(path_browserify__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */


var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: "mixin",
    value: function mixin(dest, source, copy) {
      var s;
      var empty = {};

      if (dest) {
        for (var name in source) {
          if (source.hasOwnProperty(name)) {
            s = source[name];

            if (!(name in dest) || dest[name] !== s && (!(name in empty) || empty[name] !== s)) {
              if (_typeof(dest[name]) === 'object' && dest[name] !== null) {
                dest[name] = Utils.mixin(dest[name], s, copy);
              } else {
                dest[name] = copy(s);
              }
            }
          }
        }
      }

      return dest;
    }
  }, {
    key: "clone",
    value: function clone(src) {
      if (!src || _typeof(src) !== 'object') {
        return src; // anything
      }

      var r;

      if (src instanceof Array) {
        // array
        r = [];

        for (var i = 0, l = src.length; i < l; ++i) {
          if (i in src) {
            r.push(Utils.clone(src[i]));
          }
        }
      } else {
        r = {};
      }

      return Utils.mixin(r, src, Utils.clone);
    }
  }, {
    key: "addAditionalQueryParameterToUrl",
    value: function addAditionalQueryParameterToUrl(url, params) {
      try {
        if (!params || params.length === 0) {
          return url;
        }

        var modifiedUrl = new URL(url);
        params.forEach(function (param) {
          if (param.key && param.value) {
            modifiedUrl.searchParams.set(param.key, param.value);
          }
        });
        return modifiedUrl.href;
      } catch (e) {
        return url;
      }
    }
  }, {
    key: "parseHttpHeaders",
    value: function parseHttpHeaders(headerStr) {
      var headers = {};

      if (!headerStr) {
        return headers;
      } // Trim headerStr to fix a MS Edge bug with xhr.getAllResponseHeaders method
      // which send a string starting with a "\n" character


      var headerPairs = headerStr.trim().split("\r\n");

      for (var i = 0, ilen = headerPairs.length; i < ilen; i++) {
        var headerPair = headerPairs[i];
        var index = headerPair.indexOf(": ");

        if (index > 0) {
          headers[headerPair.substring(0, index)] = headerPair.substring(index + 2);
        }
      }

      return headers;
    }
  }, {
    key: "generateUuid",
    value: function generateUuid() {
      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
  }, {
    key: "generateHashCode",
    value: function generateHashCode(string) {
      var hash = 0;

      if (string.length === 0) {
        return hash;
      }

      for (var i = 0; i < string.length; i++) {
        var chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }

      return hash;
    }
    /**
     * Compares both urls and returns a relative url (target relative to original)
     * @param {string} original
     * @param {string} target
     * @return {string|*}
     */

  }, {
    key: "getRelativeUrl",
    value: function getRelativeUrl(originalUrl, targetUrl) {
      try {
        var original = new URL(originalUrl);
        var target = new URL(targetUrl); // Unify the protocol to compare the origins

        original.protocol = target.protocol;

        if (original.origin !== target.origin) {
          return targetUrl;
        } // Use the relative path implementation of the path library. We need to cut off the actual filename in the end to get the relative path


        var relativePath = path_browserify__WEBPACK_IMPORTED_MODULE_0___default.a.relative(original.pathname.substr(0, original.pathname.lastIndexOf('/')), target.pathname.substr(0, target.pathname.lastIndexOf('/'))); // In case the relative path is empty (both path are equal) return the filename only. Otherwise add a slash in front of the filename

        var startIndexOffset = relativePath.length === 0 ? 1 : 0;
        relativePath += target.pathname.substr(target.pathname.lastIndexOf('/') + startIndexOffset, target.pathname.length - 1); // Build the other candidate, e.g. the 'host relative' path that starts with "/", and return the shortest of the two candidates.

        if (target.pathname.length < relativePath.length) {
          return target.pathname;
        }

        return relativePath;
      } catch (e) {
        return targetUrl;
      }
    }
  }]);

  return Utils;
}();

/* harmony default export */ __webpack_exports__["default"] = (Utils);

/***/ }),

/***/ "./src/core/Version.js":
/*!*****************************!*\
  !*** ./src/core/Version.js ***!
  \*****************************/
/*! exports provided: getVersionString */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_627752__) {

"use strict";
__nested_webpack_require_627752__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_627752__.d(__webpack_exports__, "getVersionString", function() { return getVersionString; });
var VERSION = '4.4.1';
function getVersionString() {
  return VERSION;
}

/***/ }),

/***/ "./src/core/errors/Errors.js":
/*!***********************************!*\
  !*** ./src/core/errors/Errors.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_628309__) {

"use strict";
__nested_webpack_require_628309__.r(__webpack_exports__);
/* harmony import */ var _ErrorsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_628309__(/*! ./ErrorsBase */ "./src/core/errors/ErrorsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Errors declaration
 * @class
 */

var Errors = /*#__PURE__*/function (_ErrorsBase) {
  _inherits(Errors, _ErrorsBase);

  var _super = _createSuper(Errors);

  function Errors() {
    var _this;

    _classCallCheck(this, Errors);

    _this = _super.call(this);
    /**
     * Error code returned when a manifest parsing error occurs
     */

    _this.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE = 10;
    /**
     * Error code returned when a manifest loading error occurs
     */

    _this.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE = 11;
    /**
     * Error code returned when a xlink loading error occurs
     */

    _this.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE = 12;
    /**
     * Error code returned when no segment ranges could be determined from the sidx box
     */

    _this.SEGMENT_BASE_LOADER_ERROR_CODE = 15;
    /**
     * Error code returned when the time synchronization failed
     */

    _this.TIME_SYNC_FAILED_ERROR_CODE = 16;
    /**
     * Error code returned when loading a fragment failed
     */

    _this.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE = 17;
    /**
     * Error code returned when the FragmentLoader did not receive a request object
     */

    _this.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE = 18;
    /**
     * Error code returned when the BaseUrl resolution failed
     */

    _this.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 19;
    /**
     * Error code returned when the append operation in the SourceBuffer failed
     */

    _this.APPEND_ERROR_CODE = 20;
    /**
     * Error code returned when the remove operation in the SourceBuffer failed
     */

    _this.REMOVE_ERROR_CODE = 21;
    /**
     * Error code returned when updating the internal objects after loading an MPD failed
     */

    _this.DATA_UPDATE_FAILED_ERROR_CODE = 22;
    /**
     * Error code returned when MediaSource is not supported by the browser
     */

    _this.CAPABILITY_MEDIASOURCE_ERROR_CODE = 23;
    /**
     * Error code returned when Protected contents are not supported
     */

    _this.CAPABILITY_MEDIAKEYS_ERROR_CODE = 24;
    /**
     * Error code returned when loading the manifest failed
     */

    _this.DOWNLOAD_ERROR_ID_MANIFEST_CODE = 25;
    /**
     * Error code returned when loading the sidx failed
     */

    _this.DOWNLOAD_ERROR_ID_SIDX_CODE = 26;
    /**
     * Error code returned when loading the media content failed
     */

    _this.DOWNLOAD_ERROR_ID_CONTENT_CODE = 27;
    /**
     * Error code returned when loading the init segment failed
     */

    _this.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE = 28;
    /**
     * Error code returned when loading the XLink content failed
     */

    _this.DOWNLOAD_ERROR_ID_XLINK_CODE = 29;
    /**
     * Error code returned when parsing the MPD resulted in a logical error
     */

    _this.MANIFEST_ERROR_ID_PARSE_CODE = 31;
    /**
     * Error code returned when no stream (period) has been detected in the manifest
     */

    _this.MANIFEST_ERROR_ID_NOSTREAMS_CODE = 32;
    /**
     * Error code returned when something wrong has happened during parsing and appending subtitles (TTML or VTT)
     */

    _this.TIMED_TEXT_ERROR_ID_PARSE_CODE = 33;
    /**
     * Error code returned when a 'muxed' media type has been detected in the manifest. This type is not supported
     */

    _this.MANIFEST_ERROR_ID_MULTIPLEXED_CODE = 34;
    /**
     * Error code returned when a media source type is not supported
     */

    _this.MEDIASOURCE_TYPE_UNSUPPORTED_CODE = 35;
    _this.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE = 'parsing failed for ';
    _this.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE = 'Failed loading manifest: ';
    _this.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE = 'Failed loading Xlink element: ';
    _this.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE = 'Segments update failed';
    _this.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE = 'no segments are available yet';
    _this.SEGMENT_BASE_LOADER_ERROR_MESSAGE = 'error loading segment ranges from sidx';
    _this.TIME_SYNC_FAILED_ERROR_MESSAGE = 'Failed to synchronize client and server time';
    _this.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE = 'request is null';
    _this.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = 'Failed to resolve a valid URL';
    _this.APPEND_ERROR_MESSAGE = 'chunk is not defined';
    _this.REMOVE_ERROR_MESSAGE = 'Removing data from the SourceBuffer';
    _this.DATA_UPDATE_FAILED_ERROR_MESSAGE = 'Data update failed';
    _this.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE = 'mediasource is not supported';
    _this.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE = 'mediakeys is not supported';
    _this.TIMED_TEXT_ERROR_MESSAGE_PARSE = 'parsing error :';
    _this.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE = 'Error creating source buffer of type : ';
    return _this;
  }

  return Errors;
}(_ErrorsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var errors = new Errors();
/* harmony default export */ __webpack_exports__["default"] = (errors);

/***/ }),

/***/ "./src/core/errors/ErrorsBase.js":
/*!***************************************!*\
  !*** ./src/core/errors/ErrorsBase.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_638215__) {

"use strict";
__nested_webpack_require_638215__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var ErrorsBase = /*#__PURE__*/function () {
  function ErrorsBase() {
    _classCallCheck(this, ErrorsBase);
  }

  _createClass(ErrorsBase, [{
    key: "extend",
    value: function extend(errors, config) {
      if (!errors) return;
      var override = config ? config.override : false;
      var publicOnly = config ? config.publicOnly : false;

      for (var err in errors) {
        if (!errors.hasOwnProperty(err) || this[err] && !override) continue;
        if (publicOnly && errors[err].indexOf('public_') === -1) continue;
        this[err] = errors[err];
      }
    }
  }]);

  return ErrorsBase;
}();

/* harmony default export */ __webpack_exports__["default"] = (ErrorsBase);

/***/ }),

/***/ "./src/core/events/CoreEvents.js":
/*!***************************************!*\
  !*** ./src/core/events/CoreEvents.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_641886__) {

"use strict";
__nested_webpack_require_641886__.r(__webpack_exports__);
/* harmony import */ var _EventsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_641886__(/*! ./EventsBase */ "./src/core/events/EventsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * These are internal events that should not be needed at the player level.
 * If you find and event in here that you would like access to from MediaPlayer level
 * please add an issue at https://github.com/Dash-Industry-Forum/dash.js/issues/new
 * @class
 * @ignore
 */

var CoreEvents = /*#__PURE__*/function (_EventsBase) {
  _inherits(CoreEvents, _EventsBase);

  var _super = _createSuper(CoreEvents);

  function CoreEvents() {
    var _this;

    _classCallCheck(this, CoreEvents);

    _this = _super.call(this);
    _this.ATTEMPT_BACKGROUND_SYNC = 'attemptBackgroundSync';
    _this.BUFFERING_COMPLETED = 'bufferingCompleted';
    _this.BUFFER_CLEARED = 'bufferCleared';
    _this.BYTES_APPENDED_END_FRAGMENT = 'bytesAppendedEndFragment';
    _this.BUFFER_REPLACEMENT_STARTED = 'bufferReplacementStarted';
    _this.CHECK_FOR_EXISTENCE_COMPLETED = 'checkForExistenceCompleted';
    _this.CURRENT_TRACK_CHANGED = 'currentTrackChanged';
    _this.DATA_UPDATE_COMPLETED = 'dataUpdateCompleted';
    _this.INBAND_EVENTS = 'inbandEvents';
    _this.INITIAL_STREAM_SWITCH = 'initialStreamSwitch';
    _this.INIT_FRAGMENT_LOADED = 'initFragmentLoaded';
    _this.INIT_FRAGMENT_NEEDED = 'initFragmentNeeded';
    _this.INTERNAL_MANIFEST_LOADED = 'internalManifestLoaded';
    _this.ORIGINAL_MANIFEST_LOADED = 'originalManifestLoaded';
    _this.LOADING_COMPLETED = 'loadingCompleted';
    _this.LOADING_PROGRESS = 'loadingProgress';
    _this.LOADING_DATA_PROGRESS = 'loadingDataProgress';
    _this.LOADING_ABANDONED = 'loadingAborted';
    _this.MANIFEST_UPDATED = 'manifestUpdated';
    _this.MEDIA_FRAGMENT_LOADED = 'mediaFragmentLoaded';
    _this.MEDIA_FRAGMENT_NEEDED = 'mediaFragmentNeeded';
    _this.QUOTA_EXCEEDED = 'quotaExceeded';
    _this.SEGMENT_LOCATION_BLACKLIST_ADD = 'segmentLocationBlacklistAdd';
    _this.SEGMENT_LOCATION_BLACKLIST_CHANGED = 'segmentLocationBlacklistChanged';
    _this.SERVICE_LOCATION_BLACKLIST_ADD = 'serviceLocationBlacklistAdd';
    _this.SERVICE_LOCATION_BLACKLIST_CHANGED = 'serviceLocationBlacklistChanged';
    _this.SET_FRAGMENTED_TEXT_AFTER_DISABLED = 'setFragmentedTextAfterDisabled';
    _this.SET_NON_FRAGMENTED_TEXT = 'setNonFragmentedText';
    _this.SOURCE_BUFFER_ERROR = 'sourceBufferError';
    _this.STREAMS_COMPOSED = 'streamsComposed';
    _this.STREAM_BUFFERING_COMPLETED = 'streamBufferingCompleted';
    _this.STREAM_REQUESTING_COMPLETED = 'streamRequestingCompleted';
    _this.TEXT_TRACKS_QUEUE_INITIALIZED = 'textTracksQueueInitialized';
    _this.TIME_SYNCHRONIZATION_COMPLETED = 'timeSynchronizationComplete';
    _this.UPDATE_TIME_SYNC_OFFSET = 'updateTimeSyncOffset';
    _this.URL_RESOLUTION_FAILED = 'urlResolutionFailed';
    _this.VIDEO_CHUNK_RECEIVED = 'videoChunkReceived';
    _this.WALLCLOCK_TIME_UPDATED = 'wallclockTimeUpdated';
    _this.XLINK_ELEMENT_LOADED = 'xlinkElementLoaded';
    _this.XLINK_READY = 'xlinkReady';
    _this.SEEK_TARGET = 'seekTarget';
    _this.SETTING_UPDATED_LIVE_DELAY = 'settingUpdatedLiveDelay';
    _this.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT = 'settingUpdatedLiveDelayFragmentCount';
    _this.SETTING_UPDATED_CATCHUP_ENABLED = 'settingUpdatedCatchupEnabled';
    return _this;
  }

  return CoreEvents;
}(_EventsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (CoreEvents);

/***/ }),

/***/ "./src/core/events/Events.js":
/*!***********************************!*\
  !*** ./src/core/events/Events.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_650094__) {

"use strict";
__nested_webpack_require_650094__.r(__webpack_exports__);
/* harmony import */ var _CoreEvents__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_650094__(/*! ./CoreEvents */ "./src/core/events/CoreEvents.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */


var Events = /*#__PURE__*/function (_CoreEvents) {
  _inherits(Events, _CoreEvents);

  var _super = _createSuper(Events);

  function Events() {
    _classCallCheck(this, Events);

    return _super.apply(this, arguments);
  }

  return Events;
}(_CoreEvents__WEBPACK_IMPORTED_MODULE_0__["default"]);

var events = new Events();
/* harmony default export */ __webpack_exports__["default"] = (events);

/***/ }),

/***/ "./src/core/events/EventsBase.js":
/*!***************************************!*\
  !*** ./src/core/events/EventsBase.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_655343__) {

"use strict";
__nested_webpack_require_655343__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var EventsBase = /*#__PURE__*/function () {
  function EventsBase() {
    _classCallCheck(this, EventsBase);
  }

  _createClass(EventsBase, [{
    key: "extend",
    value: function extend(events, config) {
      if (!events) return;
      var override = config ? config.override : false;
      var publicOnly = config ? config.publicOnly : false;

      for (var evt in events) {
        if (!events.hasOwnProperty(evt) || this[evt] && !override) continue;
        if (publicOnly && events[evt].indexOf('public_') === -1) continue;
        this[evt] = events[evt];
      }
    }
  }]);

  return EventsBase;
}();

/* harmony default export */ __webpack_exports__["default"] = (EventsBase);

/***/ }),

/***/ "./src/dash/DashAdapter.js":
/*!*********************************!*\
  !*** ./src/dash/DashAdapter.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_658990__) {

"use strict";
__nested_webpack_require_658990__.r(__webpack_exports__);
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_658990__(/*! ./constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _vo_RepresentationInfo__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_658990__(/*! ./vo/RepresentationInfo */ "./src/dash/vo/RepresentationInfo.js");
/* harmony import */ var _vo_MediaInfo__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_658990__(/*! ./vo/MediaInfo */ "./src/dash/vo/MediaInfo.js");
/* harmony import */ var _vo_StreamInfo__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_658990__(/*! ./vo/StreamInfo */ "./src/dash/vo/StreamInfo.js");
/* harmony import */ var _vo_ManifestInfo__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_658990__(/*! ./vo/ManifestInfo */ "./src/dash/vo/ManifestInfo.js");
/* harmony import */ var _vo_Event__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_658990__(/*! ./vo/Event */ "./src/dash/vo/Event.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_658990__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _models_DashManifestModel__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_658990__(/*! ./models/DashManifestModel */ "./src/dash/models/DashManifestModel.js");
/* harmony import */ var _models_PatchManifestModel__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_658990__(/*! ./models/PatchManifestModel */ "./src/dash/models/PatchManifestModel.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









/**
 * @module DashAdapter
 * @description The DashAdapter module can be accessed using the MediaPlayer API getDashAdapter()
 */

function DashAdapter() {
  var instance, dashManifestModel, patchManifestModel, voPeriods, currentMediaInfo, constants, cea608parser;
  var context = this.context;
  var PROFILE_DVB = 'urn:dvb:dash:profile:dvb-dash:2014';

  function setup() {
    dashManifestModel = Object(_models_DashManifestModel__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
    patchManifestModel = Object(_models_PatchManifestModel__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
    reset();
  } // #region PUBLIC FUNCTIONS
  // --------------------------------------------------


  function setConfig(config) {
    if (!config) return;

    if (config.constants) {
      constants = config.constants;
    }

    if (config.cea608parser) {
      cea608parser = config.cea608parser;
    }

    if (config.errHandler) {
      dashManifestModel.setConfig({
        errHandler: config.errHandler
      });
    }

    if (config.BASE64) {
      dashManifestModel.setConfig({
        BASE64: config.BASE64
      });
    }
  }
  /**
   * Creates an instance of RepresentationInfo based on a representation value object
   * @param {object} voRepresentation
   * @returns {RepresentationInfo|null} representationInfo
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function convertRepresentationToRepresentationInfo(voRepresentation) {
    if (voRepresentation) {
      var representationInfo = new _vo_RepresentationInfo__WEBPACK_IMPORTED_MODULE_1__["default"]();
      var realAdaptation = voRepresentation.adaptation.period.mpd.manifest.Period_asArray[voRepresentation.adaptation.period.index].AdaptationSet_asArray[voRepresentation.adaptation.index];
      var realRepresentation = dashManifestModel.getRepresentationFor(voRepresentation.index, realAdaptation);
      representationInfo.id = voRepresentation.id;
      representationInfo.quality = voRepresentation.index;
      representationInfo.bandwidth = dashManifestModel.getBandwidth(realRepresentation);
      representationInfo.fragmentDuration = voRepresentation.segmentDuration || (voRepresentation.segments && voRepresentation.segments.length > 0 ? voRepresentation.segments[0].duration : NaN);
      representationInfo.MSETimeOffset = voRepresentation.MSETimeOffset;
      representationInfo.mediaInfo = convertAdaptationToMediaInfo(voRepresentation.adaptation);
      return representationInfo;
    } else {
      return null;
    }
  }
  /**
   * Returns a MediaInfo object for a given media type and the corresponding streamInfo.
   * @param {object} streamInfo
   * @param {MediaType }type
   * @returns {null|MediaInfo} mediaInfo
   * @memberOf module:DashAdapter
   * @instance
   */


  function getMediaInfoForType(streamInfo, type) {
    if (voPeriods.length === 0 || !streamInfo) {
      return null;
    }

    var selectedVoPeriod = getPeriodForStreamInfo(streamInfo, voPeriods);
    if (!selectedVoPeriod) return null;
    var voAdaptations = dashManifestModel.getAdaptationsForPeriod(selectedVoPeriod);
    var realAdaptation = getAdaptationForType(streamInfo.index, type, streamInfo);
    if (!realAdaptation) return null;
    var idx = dashManifestModel.getIndexForAdaptation(realAdaptation, voPeriods[0].mpd.manifest, streamInfo.index);
    return convertAdaptationToMediaInfo(voAdaptations[idx]);
  }
  /**
   * Checks if the role of the specified AdaptationSet is set to main
   * @param {object} adaptation
   * @returns {boolean}
   * @memberOf module:DashAdapter
   * @instance
   */


  function getIsMain(adaptation) {
    return dashManifestModel.getRolesForAdaptation(adaptation).filter(function (role) {
      return role.value === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].MAIN;
    })[0];
  }
  /**
   * Returns the AdaptationSet for a given period index and a given mediaType.
   * @param {number} periodIndex
   * @param {MediaType} type
   * @param {object} streamInfo
   * @returns {null|object} adaptation
   * @memberOf module:DashAdapter
   * @instance
   */


  function getAdaptationForType(periodIndex, type, streamInfo) {
    var adaptations = dashManifestModel.getAdaptationsForType(voPeriods[0].mpd.manifest, periodIndex, type);
    if (!adaptations || adaptations.length === 0) return null;

    if (adaptations.length > 1 && streamInfo) {
      var allMediaInfoForType = getAllMediaInfoForType(streamInfo, type);

      if (currentMediaInfo[streamInfo.id] && currentMediaInfo[streamInfo.id][type]) {
        for (var i = 0, ln = adaptations.length; i < ln; i++) {
          if (areMediaInfosEqual(currentMediaInfo[streamInfo.id][type], allMediaInfoForType[i])) {
            return adaptations[i];
          }
        }
      }

      for (var _i = 0, _ln = adaptations.length; _i < _ln; _i++) {
        if (getIsMain(adaptations[_i])) {
          return adaptations[_i];
        }
      }
    }

    return adaptations[0];
  }
  /**
   * Compares two mediaInfo objects
   * @param {MediaInfo} mInfoOne
   * @param {MediaInfo} mInfoTwo
   * @returns {boolean}
   */


  function areMediaInfosEqual(mInfoOne, mInfoTwo) {
    if (!mInfoOne || !mInfoTwo) {
      return false;
    }

    var sameId = mInfoOne.id === mInfoTwo.id;
    var sameCodec = mInfoOne.codec === mInfoTwo.codec;
    var sameViewpoint = mInfoOne.viewpoint === mInfoTwo.viewpoint;
    var sameLang = mInfoOne.lang === mInfoTwo.lang;
    var sameRoles = mInfoOne.roles.toString() === mInfoTwo.roles.toString();
    var sameAccessibility = mInfoOne.accessibility.toString() === mInfoTwo.accessibility.toString();
    var sameAudioChannelConfiguration = mInfoOne.audioChannelConfiguration.toString() === mInfoTwo.audioChannelConfiguration.toString();
    return sameId && sameCodec && sameViewpoint && sameLang && sameRoles && sameAccessibility && sameAudioChannelConfiguration;
  }

  function _getAllMediaInfo(manifest, period, streamInfo, adaptations, type, embeddedText) {
    var mediaArr = [];
    var data, media, idx, i, j, ln;

    if (!adaptations || adaptations.length === 0) {
      return [];
    }

    var voAdaptations = dashManifestModel.getAdaptationsForPeriod(period);

    for (i = 0, ln = adaptations.length; i < ln; i++) {
      data = adaptations[i];
      idx = dashManifestModel.getIndexForAdaptation(data, manifest, streamInfo.index);
      media = convertAdaptationToMediaInfo(voAdaptations[idx]);

      if (embeddedText) {
        var accessibilityLength = media.accessibility.length;

        for (j = 0; j < accessibilityLength; j++) {
          if (!media) {
            continue;
          }

          var accessibility = media.accessibility[j];

          if (accessibility.indexOf('cea-608:') === 0) {
            var value = accessibility.substring(8);
            var parts = value.split(';');

            if (parts[0].substring(0, 2) === 'CC') {
              for (j = 0; j < parts.length; j++) {
                if (!media) {
                  media = convertAdaptationToMediaInfo.call(this, voAdaptations[idx]);
                }

                convertVideoInfoToEmbeddedTextInfo(media, parts[j].substring(0, 3), parts[j].substring(4));
                mediaArr.push(media);
                media = null;
              }
            } else {
              for (j = 0; j < parts.length; j++) {
                // Only languages for CC1, CC2, ...
                if (!media) {
                  media = convertAdaptationToMediaInfo.call(this, voAdaptations[idx]);
                }

                convertVideoInfoToEmbeddedTextInfo(media, 'CC' + (j + 1), parts[j]);
                mediaArr.push(media);
                media = null;
              }
            }
          } else if (accessibility.indexOf('cea-608') === 0) {
            // Nothing known. We interpret it as CC1=eng
            convertVideoInfoToEmbeddedTextInfo(media, constants.CC1, 'eng');
            mediaArr.push(media);
            media = null;
          }
        }
      } else if (type === constants.IMAGE) {
        convertVideoInfoToThumbnailInfo(media);
        mediaArr.push(media);
        media = null;
      } else if (media) {
        mediaArr.push(media);
      }
    }

    return mediaArr;
  }
  /**
   * Returns all the mediaInfos for a given mediaType and the corresponding streamInfo.
   * @param {object} streamInfo
   * @param {MediaType} type
   * @param {object} externalManifest Set to null or undefined if no external manifest is to be used
   * @returns {Array} mediaArr
   * @memberOf module:DashAdapter
   * @instance
   */


  function getAllMediaInfoForType(streamInfo, type, externalManifest) {
    var voLocalPeriods = voPeriods;
    var manifest = externalManifest;
    var mediaArr = [];

    if (manifest) {
      checkConfig();
      voLocalPeriods = getRegularPeriods(manifest);
    } else {
      if (voPeriods.length > 0) {
        manifest = voPeriods[0].mpd.manifest;
      } else {
        return mediaArr;
      }
    }

    var selectedVoPeriod = getPeriodForStreamInfo(streamInfo, voLocalPeriods);
    var adaptationsForType = dashManifestModel.getAdaptationsForType(manifest, streamInfo ? streamInfo.index : null, type);
    mediaArr = _getAllMediaInfo(manifest, selectedVoPeriod, streamInfo, adaptationsForType, type); // Search for embedded text in video track

    if (type === constants.TEXT) {
      adaptationsForType = dashManifestModel.getAdaptationsForType(manifest, streamInfo ? streamInfo.index : null, constants.VIDEO);
      mediaArr = mediaArr.concat(_getAllMediaInfo(manifest, selectedVoPeriod, streamInfo, adaptationsForType, type, true));
    }

    return mediaArr;
  }
  /**
   * Update the internal voPeriods array with the information from the new manifest
   * @param {object} newManifest
   * @returns {*}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function updatePeriods(newManifest) {
    if (!newManifest) return null;
    checkConfig();
    voPeriods = getRegularPeriods(newManifest);
  }
  /**
   * Returns an array of streamInfo objects
   * @param {object} externalManifest
   * @param {number} maxStreamsInfo
   * @returns {Array} streams
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getStreamsInfo(externalManifest, maxStreamsInfo) {
    var streams = [];
    var voLocalPeriods = voPeriods; //if manifest is defined, getStreamsInfo is for an outside manifest, not the current one

    if (externalManifest) {
      checkConfig();
      voLocalPeriods = getRegularPeriods(externalManifest);
    }

    if (voLocalPeriods.length > 0) {
      if (!maxStreamsInfo || maxStreamsInfo > voLocalPeriods.length) {
        maxStreamsInfo = voLocalPeriods.length;
      }

      for (var i = 0; i < maxStreamsInfo; i++) {
        streams.push(convertPeriodToStreamInfo(voLocalPeriods[i]));
      }
    }

    return streams;
  }
  /**
   * Returns the AdaptationSet as saved in the DashManifestModel
   * @param {object} streamInfo
   * @param {object} mediaInfo
   * @returns {object} realAdaptation
   * @memberOf module:DashAdapter
   * @instance
   */


  function getRealAdaptation(streamInfo, mediaInfo) {
    var id, realAdaptation;
    var selectedVoPeriod = getPeriodForStreamInfo(streamInfo, voPeriods);
    id = mediaInfo ? mediaInfo.id : null;

    if (voPeriods.length > 0 && selectedVoPeriod) {
      realAdaptation = id ? dashManifestModel.getAdaptationForId(id, voPeriods[0].mpd.manifest, selectedVoPeriod.index) : dashManifestModel.getAdaptationForIndex(mediaInfo ? mediaInfo.index : null, voPeriods[0].mpd.manifest, selectedVoPeriod.index);
    }

    return realAdaptation;
  }
  /**
   * Returns the ProducerReferenceTimes as saved in the DashManifestModel if present
   * @param {object} streamInfo
   * @param {object} mediaInfo
   * @returns {object} producerReferenceTimes
   * @memberOf module:DashAdapter
   * @instance
   */


  function getProducerReferenceTimes(streamInfo, mediaInfo) {
    var id, realAdaptation;
    var selectedVoPeriod = getPeriodForStreamInfo(streamInfo, voPeriods);
    id = mediaInfo ? mediaInfo.id : null;

    if (voPeriods.length > 0 && selectedVoPeriod) {
      realAdaptation = id ? dashManifestModel.getAdaptationForId(id, voPeriods[0].mpd.manifest, selectedVoPeriod.index) : dashManifestModel.getAdaptationForIndex(mediaInfo ? mediaInfo.index : null, voPeriods[0].mpd.manifest, selectedVoPeriod.index);
    }

    if (!realAdaptation) return [];
    return dashManifestModel.getProducerReferenceTimesForAdaptation(realAdaptation);
  }
  /**
   * Return all EssentialProperties of a Representation
   * @param {object} representation
   * @return {array}
   */


  function getEssentialPropertiesForRepresentation(representation) {
    try {
      return dashManifestModel.getEssentialPropertiesForRepresentation(representation);
    } catch (e) {
      return [];
    }
  }
  /**
   * Returns the period as defined in the DashManifestModel for a given index
   * @param {number} index
   * @return {object}
   */


  function getRealPeriodByIndex(index) {
    return dashManifestModel.getRealPeriodForIndex(index, voPeriods[0].mpd.manifest);
  }
  /**
   * Returns all voRepresentations for a given mediaInfo
   * @param {object} mediaInfo
   * @returns {Array} voReps
   * @memberOf module:DashAdapter
   * @instance
   */


  function getVoRepresentations(mediaInfo) {
    var voReps;
    var voAdaptation = getAdaptationForMediaInfo(mediaInfo);
    voReps = dashManifestModel.getRepresentationsForAdaptation(voAdaptation);
    return voReps;
  }
  /**
   * Returns the event for the given parameters.
   * @param {object} eventBox
   * @param {object} eventStreams
   * @param {number} mediaStartTime
   * @param {object} voRepresentation
   * @returns {null|Event}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getEvent(eventBox, eventStreams, mediaStartTime, voRepresentation) {
    try {
      if (!eventBox || !eventStreams || isNaN(mediaStartTime) || !voRepresentation) {
        return null;
      }

      var schemeIdUri = eventBox.scheme_id_uri;
      var value = eventBox.value;

      if (!eventStreams[schemeIdUri + '/' + value]) {
        return null;
      }

      var event = new _vo_Event__WEBPACK_IMPORTED_MODULE_5__["default"]();
      var timescale = eventBox.timescale || 1;
      var periodStart = voRepresentation.adaptation.period.start;
      var eventStream = eventStreams[schemeIdUri + '/' + value];
      var presentationTimeOffset = !isNaN(voRepresentation.presentationTimeOffset) ? voRepresentation.presentationTimeOffset : !isNaN(eventStream.presentationTimeOffset) ? eventStream.presentationTimeOffset : 0;
      var presentationTimeDelta = eventBox.presentation_time_delta / timescale; // In case of version 1 events the presentation_time is parsed as presentation_time_delta

      var calculatedPresentationTime;

      if (eventBox.version === 0) {
        calculatedPresentationTime = periodStart + mediaStartTime - presentationTimeOffset + presentationTimeDelta;
      } else {
        calculatedPresentationTime = periodStart - presentationTimeOffset + presentationTimeDelta;
      }

      var duration = eventBox.event_duration;
      var id = eventBox.id;
      var messageData = eventBox.message_data;
      event.eventStream = eventStream;
      event.eventStream.value = value;
      event.eventStream.timescale = timescale;
      event.duration = duration;
      event.id = id;
      event.calculatedPresentationTime = calculatedPresentationTime;
      event.messageData = messageData;
      event.presentationTimeDelta = presentationTimeDelta;
      return event;
    } catch (e) {
      return null;
    }
  }
  /**
   * Returns the events for the given info object. info can either be an instance of StreamInfo, MediaInfo or RepresentationInfo
   * @param {object} info
   * @param {object} voRepresentation
   * @returns {Array}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getEventsFor(info, voRepresentation) {
    var events = [];

    if (voPeriods.length > 0) {
      var manifest = voPeriods[0].mpd.manifest;

      if (info instanceof _vo_StreamInfo__WEBPACK_IMPORTED_MODULE_3__["default"]) {
        events = dashManifestModel.getEventsForPeriod(getPeriodForStreamInfo(info, voPeriods));
      } else if (info instanceof _vo_MediaInfo__WEBPACK_IMPORTED_MODULE_2__["default"]) {
        events = dashManifestModel.getEventStreamForAdaptationSet(manifest, getAdaptationForMediaInfo(info));
      } else if (info instanceof _vo_RepresentationInfo__WEBPACK_IMPORTED_MODULE_1__["default"]) {
        events = dashManifestModel.getEventStreamForRepresentation(manifest, voRepresentation);
      }
    }

    return events;
  }
  /**
   * Sets the current active mediaInfo for a given streamId and a given mediaType
   * @param {number} streamId
   * @param {MediaType} type
   * @param {object} mediaInfo
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function setCurrentMediaInfo(streamId, type, mediaInfo) {
    currentMediaInfo[streamId] = currentMediaInfo[streamId] || {};
    currentMediaInfo[streamId][type] = currentMediaInfo[streamId][type] || {};
    currentMediaInfo[streamId][type] = mediaInfo;
  }
  /**
   * Check if the given type is a text track
   * @param {object} adaptation
   * @returns {boolean}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getIsTextTrack(adaptation) {
    return dashManifestModel.getIsText(adaptation);
  }
  /**
   * Returns the UTC Timing Sources specified in the manifest
   * @returns {Array} utcTimingSources
   * @memberOf module:DashAdapter
   * @instance
   */


  function getUTCTimingSources() {
    var manifest = getManifest();
    return dashManifestModel.getUTCTimingSources(manifest);
  }
  /**
   * Returns the suggestedPresentationDelay as specified in the manifest
   * @returns {String} suggestedPresentationDelay
   * @memberOf module:DashAdapter
   * @instance
   */


  function getSuggestedPresentationDelay() {
    var mpd = voPeriods.length > 0 ? voPeriods[0].mpd : null;
    return dashManifestModel.getSuggestedPresentationDelay(mpd);
  }
  /**
   * Returns the availabilityStartTime as specified in the manifest
   * @param {object} externalManifest Omit this value if no external manifest should be used
   * @returns {string} availabilityStartTime
   * @memberOf module:DashAdapter
   * @instance
   */


  function getAvailabilityStartTime(externalManifest) {
    var mpd = getMpd(externalManifest);
    return dashManifestModel.getAvailabilityStartTime(mpd);
  }
  /**
   * Returns a boolean indicating if the manifest is dynamic or not
   * @param {object} externalManifest Omit this value if no external manifest should be used
   * @returns {boolean}
   * @memberOf module:DashAdapter
   * @instance
   */


  function getIsDynamic(externalManifest) {
    var manifest = getManifest(externalManifest);
    return dashManifestModel.getIsDynamic(manifest);
  }
  /**
   * Returns the duration of the MPD
   * @param {object} externalManifest Omit this value if no external manifest should be used
   * @returns {number} duration
   * @memberOf module:DashAdapter
   * @instance
   */


  function getDuration(externalManifest) {
    var manifest = getManifest(externalManifest);
    return dashManifestModel.getDuration(manifest);
  }
  /**
   * Returns all periods of the MPD
   * @param {object} externalManifest Omit this value if no external manifest should be used
   * @returns {Array} periods
   * @memberOf module:DashAdapter
   * @instance
   */


  function getRegularPeriods(externalManifest) {
    var mpd = getMpd(externalManifest);
    return dashManifestModel.getRegularPeriods(mpd);
  }
  /**
   * Returns an MPD object
   * @param {object} externalManifest Omit this value if no external manifest should be used
   * @returns {object} MPD
   * @memberOf module:DashAdapter
   * @instance
   */


  function getMpd(externalManifest) {
    var manifest = getManifest(externalManifest);
    return dashManifestModel.getMpd(manifest);
  }
  /**
   * Returns the location element of the MPD
   * @param {object} manifest
   * @returns {String} location
   * @memberOf module:DashAdapter
   * @instance
   */


  function getLocation(manifest) {
    return dashManifestModel.getLocation(manifest);
  }
  /**
   * Returns the manifest update period used for dynamic manifests
   * @param {object} manifest
   * @param {number} latencyOfLastUpdate
   * @returns {NaN|number} manifestUpdatePeriod
   * @memberOf module:DashAdapter
   * @instance
   */


  function getManifestUpdatePeriod(manifest) {
    var latencyOfLastUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return dashManifestModel.getManifestUpdatePeriod(manifest, latencyOfLastUpdate);
  }
  /**
   * Returns the publish time from the manifest
   * @param {object} manifest
   * @returns {Date|null} publishTime
   * @memberOf module:DashAdapter
   * @instance
   */


  function getPublishTime(manifest) {
    return dashManifestModel.getPublishTime(manifest);
  }
  /**
   * Returns the patch location of the MPD if one exists and it is still valid
   * @param {object} manifest
   * @returns {(String|null)} patch location
   * @memberOf module:DashAdapter
   * @instance
   */


  function getPatchLocation(manifest) {
    var patchLocation = dashManifestModel.getPatchLocation(manifest);
    var publishTime = dashManifestModel.getPublishTime(manifest); // short-circuit when no patch location or publish time exists

    if (!patchLocation || !publishTime) {
      return null;
    } // if a ttl is provided, ensure patch location has not expired


    if (patchLocation.hasOwnProperty('ttl') && publishTime) {
      // attribute describes number of seconds as a double
      var ttl = parseFloat(patchLocation.ttl) * 1000; // check if the patch location has expired, if so do not consider it

      if (publishTime.getTime() + ttl <= new Date().getTime()) {
        return null;
      }
    } // the patch location exists and, if a ttl applies, has not expired


    return patchLocation.__text;
  }
  /**
   * Checks if the manifest has a DVB profile
   * @param {object} manifest
   * @returns {boolean}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getIsDVB(manifest) {
    return dashManifestModel.hasProfile(manifest, PROFILE_DVB);
  }
  /**
   * Checks if the manifest is actually just a patch manifest
   * @param  {object} manifest
   * @return {boolean}
   */


  function getIsPatch(manifest) {
    return patchManifestModel.getIsPatch(manifest);
  }
  /**
   * Returns the base urls for a given element
   * @param {object} node
   * @returns {Array}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getBaseURLsFromElement(node) {
    return dashManifestModel.getBaseURLsFromElement(node);
  }
  /**
   * Returns the function to sort the Representations
   * @returns {*}
   * @memberOf module:DashAdapter
   * @instance
   * @ignore
   */


  function getRepresentationSortFunction() {
    return dashManifestModel.getRepresentationSortFunction();
  }
  /**
   * Returns the codec for a given adaptation set and a given representation id.
   * @param {object} adaptation
   * @param {number} representationId
   * @param {boolean} addResolutionInfo Defines whether to include resolution information in the output
   * @returns {String} codec
   * @memberOf module:DashAdapter
   * @instance
   */


  function getCodec(adaptation, representationId, addResolutionInfo) {
    return dashManifestModel.getCodec(adaptation, representationId, addResolutionInfo);
  }
  /**
   * Returns the bandwidth for a given representation id and the corresponding period index
   * @param {number} representationId
   * @param {number} periodIdx
   * @returns {number} bandwidth
   * @memberOf module:DashAdapter
   * @instance
   */


  function getBandwidthForRepresentation(representationId, periodIdx) {
    var representation;
    var period = getPeriod(periodIdx);
    representation = findRepresentation(period, representationId);
    return representation ? representation.bandwidth : null;
  }
  /**
   * Returns the index for a given representation id
   * @param {string} representationId
   * @param {number} periodIdx
   * @returns {number} index
   * @memberOf module:DashAdapter
   * @instance
   */


  function getIndexForRepresentation(representationId, periodIdx) {
    var period = getPeriod(periodIdx);
    return findRepresentationIndex(period, representationId);
  }
  /**
   * This method returns the current max index based on what is defined in the MPD.
   * @param {string} bufferType - String 'audio' or 'video',
   * @param {number} periodIdx - Make sure this is the period index not id
   * @return {number}
   * @memberof module:DashAdapter
   * @instance
   */


  function getMaxIndexForBufferType(bufferType, periodIdx) {
    var period = getPeriod(periodIdx);
    return findMaxBufferIndex(period, bufferType);
  }
  /**
   * Returns the voPeriod object for a given id
   * @param {String} id
   * @returns {object|null}
   */


  function getPeriodById(id) {
    if (!id || voPeriods.length === 0) {
      return null;
    }

    var periods = voPeriods.filter(function (p) {
      return p.id === id;
    });

    if (periods && periods.length > 0) {
      return periods[0];
    }

    return null;
  }
  /**
   * Checks if the given AdaptationSet is from the given media type
   * @param {object} adaptation
   * @param {string} type
   * @return {boolean}
   */


  function getIsTypeOf(adaptation, type) {
    return dashManifestModel.getIsTypeOf(adaptation, type);
  }

  function reset() {
    voPeriods = [];
    currentMediaInfo = {};
  }
  /**
   * Checks if the supplied manifest is compatible for application of the supplied patch
   * @param  {object}  manifest
   * @param  {object}  patch
   * @return {boolean}
   */


  function isPatchValid(manifest, patch) {
    var manifestId = dashManifestModel.getId(manifest);
    var patchManifestId = patchManifestModel.getMpdId(patch);
    var manifestPublishTime = dashManifestModel.getPublishTime(manifest);
    var patchPublishTime = patchManifestModel.getPublishTime(patch);
    var originalManifestPublishTime = patchManifestModel.getOriginalPublishTime(patch); // Patches are considered compatible if the following are true
    // - MPD@id == Patch@mpdId
    // - MPD@publishTime == Patch@originalPublishTime
    // - MPD@publishTime < Patch@publishTime
    // - All values in comparison exist

    return !!(manifestId && patchManifestId && manifestId == patchManifestId && manifestPublishTime && originalManifestPublishTime && manifestPublishTime.getTime() == originalManifestPublishTime.getTime() && patchPublishTime && manifestPublishTime.getTime() < patchPublishTime.getTime());
  }
  /**
   * Takes a given patch and applies it to the provided manifest, assumes patch is valid for manifest
   * @param  {object} manifest
   * @param  {object} patch
   */


  function applyPatchToManifest(manifest, patch) {
    // get all operations from the patch and apply them in document order
    patchManifestModel.getPatchOperations(patch).forEach(function (operation) {
      var result = operation.getMpdTarget(manifest); // operation supplies a path that doesn't match mpd, skip

      if (result === null) {
        return;
      }

      var name = result.name,
          target = result.target,
          leaf = result.leaf; // short circuit for attribute selectors

      if (operation.xpath.findsAttribute()) {
        switch (operation.action) {
          case 'add':
          case 'replace':
            // add and replace are just setting the value
            target[name] = operation.value;
            break;

          case 'remove':
            // remove is deleting the value
            delete target[name];
            break;
        }

        return;
      } // determine the relative insert position prior to possible removal


      var relativePosition = (target[name + '_asArray'] || []).indexOf(leaf);
      var insertBefore = operation.position === 'prepend' || operation.position === 'before'; // perform removal operation first, we have already capture the appropriate relative position

      if (operation.action === 'remove' || operation.action === 'replace') {
        // note that we ignore the 'ws' attribute of patch operations as it does not effect parsed mpd operations
        // purge the directly named entity
        delete target[name]; // if we did have a positional reference we need to purge from array set and restore X2JS proper semantics

        if (relativePosition != -1) {
          var targetArray = target[name + '_asArray'];
          targetArray.splice(relativePosition, 1);

          if (targetArray.length > 1) {
            target[name] = targetArray;
          } else if (targetArray.length == 1) {
            // xml parsing semantics, singular asArray must be non-array in the unsuffixed key
            target[name] = targetArray[0];
          } else {
            // all nodes of this type deleted, remove entry
            delete target[name + '_asArray'];
          }
        }
      } // Perform any add/replace operations now, technically RFC5261 only allows a single element to take the
      // place of a replaced element while the add case allows an arbitrary number of children.
      // Due to the both operations requiring the same insertion logic they have been combined here and we will
      // not enforce single child operations for replace, assertions should be made at patch parse time if necessary


      if (operation.action === 'add' || operation.action === 'replace') {
        // value will be an object with element name keys pointing to arrays of objects
        Object.keys(operation.value).forEach(function (insert) {
          var insertNodes = operation.value[insert];
          var updatedNodes = target[insert + '_asArray'] || [];

          if (updatedNodes.length === 0 && target[insert]) {
            updatedNodes.push(target[insert]);
          }

          if (updatedNodes.length === 0) {
            // no original nodes for this element type
            updatedNodes = insertNodes;
          } else {
            // compute the position we need to insert at, default to end of set
            var position = updatedNodes.length;

            if (insert == name && relativePosition != -1) {
              // if the inserted element matches the operation target (not leaf) and there is a relative position we
              // want the inserted position to be set such that our insertion is relative to original position
              // since replace has modified the array length we reduce the insert point by 1
              position = relativePosition + (insertBefore ? 0 : 1) + (operation.action == 'replace' ? -1 : 0);
            } else {
              // otherwise we are in an add append/prepend case or replace case that removed the target name completely
              position = insertBefore ? 0 : updatedNodes.length;
            } // we dont have to perform element removal for the replace case as that was done above


            updatedNodes.splice.apply(updatedNodes, [position, 0].concat(insertNodes));
          } // now we properly reset the element keys on the target to match parsing semantics


          target[insert + '_asArray'] = updatedNodes;
          target[insert] = updatedNodes.length == 1 ? updatedNodes[0] : updatedNodes;
        });
      }
    });
  } // #endregion PUBLIC FUNCTIONS
  // #region PRIVATE FUNCTIONS
  // --------------------------------------------------


  function getManifest(externalManifest) {
    return externalManifest ? externalManifest : voPeriods.length > 0 ? voPeriods[0].mpd.manifest : null;
  }

  function getAdaptationForMediaInfo(mediaInfo) {
    try {
      var selectedVoPeriod = getPeriodForStreamInfo(mediaInfo.streamInfo, voPeriods);
      var voAdaptations = dashManifestModel.getAdaptationsForPeriod(selectedVoPeriod);
      if (!mediaInfo || !mediaInfo.streamInfo || mediaInfo.streamInfo.id === undefined || !voAdaptations) return null;
      return voAdaptations[mediaInfo.index];
    } catch (e) {
      return null;
    }
  }

  function getPeriodForStreamInfo(streamInfo, voPeriodsArray) {
    var ln = voPeriodsArray.length;

    for (var i = 0; i < ln; i++) {
      var voPeriod = voPeriodsArray[i];
      if (streamInfo && streamInfo.id === voPeriod.id) return voPeriod;
    }

    return null;
  }

  function convertAdaptationToMediaInfo(adaptation) {
    if (!adaptation) {
      return null;
    }

    var mediaInfo = new _vo_MediaInfo__WEBPACK_IMPORTED_MODULE_2__["default"]();
    var realAdaptation = adaptation.period.mpd.manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index];
    var viewpoint;
    mediaInfo.id = adaptation.id;
    mediaInfo.index = adaptation.index;
    mediaInfo.type = adaptation.type;
    mediaInfo.streamInfo = convertPeriodToStreamInfo(adaptation.period);
    mediaInfo.representationCount = dashManifestModel.getRepresentationCount(realAdaptation);
    mediaInfo.labels = dashManifestModel.getLabelsForAdaptation(realAdaptation);
    mediaInfo.lang = dashManifestModel.getLanguageForAdaptation(realAdaptation);
    viewpoint = dashManifestModel.getViewpointForAdaptation(realAdaptation);
    mediaInfo.viewpoint = viewpoint ? viewpoint.value : undefined;
    mediaInfo.accessibility = dashManifestModel.getAccessibilityForAdaptation(realAdaptation).map(function (accessibility) {
      var accessibilityValue = accessibility.value;
      var accessibilityData = accessibilityValue;

      if (accessibility.schemeIdUri && accessibility.schemeIdUri.search('cea-608') >= 0 && typeof cea608parser !== 'undefined') {
        if (accessibilityValue) {
          accessibilityData = 'cea-608:' + accessibilityValue;
        } else {
          accessibilityData = 'cea-608';
        }

        mediaInfo.embeddedCaptions = true;
      }

      return accessibilityData;
    });
    mediaInfo.audioChannelConfiguration = dashManifestModel.getAudioChannelConfigurationForAdaptation(realAdaptation).map(function (audioChannelConfiguration) {
      return audioChannelConfiguration.value;
    });

    if (mediaInfo.audioChannelConfiguration.length === 0 && Array.isArray(realAdaptation.Representation_asArray) && realAdaptation.Representation_asArray.length > 0) {
      mediaInfo.audioChannelConfiguration = dashManifestModel.getAudioChannelConfigurationForRepresentation(realAdaptation.Representation_asArray[0]).map(function (audioChannelConfiguration) {
        return audioChannelConfiguration.value;
      });
    }

    mediaInfo.roles = dashManifestModel.getRolesForAdaptation(realAdaptation).map(function (role) {
      return role.value;
    });
    mediaInfo.codec = dashManifestModel.getCodec(realAdaptation);
    mediaInfo.mimeType = dashManifestModel.getMimeType(realAdaptation);
    mediaInfo.contentProtection = dashManifestModel.getContentProtectionData(realAdaptation);
    mediaInfo.bitrateList = dashManifestModel.getBitrateListForAdaptation(realAdaptation);
    mediaInfo.selectionPriority = dashManifestModel.getSelectionPriority(realAdaptation);

    if (mediaInfo.contentProtection) {
      // Get the default key ID and apply it to all key systems
      var keyIds = mediaInfo.contentProtection.map(function (cp) {
        return dashManifestModel.getKID(cp);
      }).filter(function (kid) {
        return kid !== null;
      });

      if (keyIds.length) {
        var keyId = keyIds[0];
        mediaInfo.contentProtection.forEach(function (cp) {
          cp.keyId = keyId;
        });
      }
    }

    mediaInfo.isText = dashManifestModel.getIsText(realAdaptation);
    mediaInfo.supplementalProperties = dashManifestModel.getSupplementalProperties(realAdaptation);
    mediaInfo.isFragmented = dashManifestModel.getIsFragmented(realAdaptation);
    mediaInfo.isEmbedded = false;
    return mediaInfo;
  }

  function convertVideoInfoToEmbeddedTextInfo(mediaInfo, channel, lang) {
    mediaInfo.id = channel; // CC1, CC2, CC3, or CC4

    mediaInfo.index = 100 + parseInt(channel.substring(2, 3));
    mediaInfo.type = constants.TEXT;
    mediaInfo.codec = 'cea-608-in-SEI';
    mediaInfo.isEmbedded = true;
    mediaInfo.isFragmented = false;
    mediaInfo.lang = lang;
    mediaInfo.roles = ['caption'];
  }

  function convertVideoInfoToThumbnailInfo(mediaInfo) {
    mediaInfo.type = constants.IMAGE;
  }

  function convertPeriodToStreamInfo(period) {
    var streamInfo = new _vo_StreamInfo__WEBPACK_IMPORTED_MODULE_3__["default"]();
    var THRESHOLD = 1;
    streamInfo.id = period.id;
    streamInfo.index = period.index;
    streamInfo.start = period.start;
    streamInfo.duration = period.duration;
    streamInfo.manifestInfo = convertMpdToManifestInfo(period.mpd);
    streamInfo.isLast = period.mpd.manifest.Period_asArray.length === 1 || Math.abs(streamInfo.start + streamInfo.duration - streamInfo.manifestInfo.duration) < THRESHOLD;
    return streamInfo;
  }

  function convertMpdToManifestInfo(mpd) {
    var manifestInfo = new _vo_ManifestInfo__WEBPACK_IMPORTED_MODULE_4__["default"]();
    manifestInfo.dvrWindowSize = mpd.timeShiftBufferDepth;
    manifestInfo.loadedTime = mpd.manifest.loadedTime;
    manifestInfo.availableFrom = mpd.availabilityStartTime;
    manifestInfo.minBufferTime = mpd.manifest.minBufferTime;
    manifestInfo.maxFragmentDuration = mpd.maxSegmentDuration;
    manifestInfo.duration = dashManifestModel.getDuration(mpd.manifest);
    manifestInfo.isDynamic = dashManifestModel.getIsDynamic(mpd.manifest);
    manifestInfo.serviceDescriptions = dashManifestModel.getServiceDescriptions(mpd.manifest);
    manifestInfo.protocol = mpd.manifest.protocol;
    return manifestInfo;
  }

  function checkConfig() {
    if (!constants) {
      throw new Error('setConfig function has to be called previously');
    }
  }

  function getPeriod(periodIdx) {
    return voPeriods.length > 0 ? voPeriods[0].mpd.manifest.Period_asArray[periodIdx] : null;
  }

  function findRepresentationIndex(period, representationId) {
    var index = findRepresentation(period, representationId, true);
    return index !== null ? index : -1;
  }

  function findRepresentation(period, representationId, returnIndex) {
    var adaptationSet, adaptationSetArray, representation, representationArray, adaptationSetArrayIndex, representationArrayIndex;

    if (period) {
      adaptationSetArray = period.AdaptationSet_asArray;

      for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
        adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
        representationArray = adaptationSet.Representation_asArray;

        for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
          representation = representationArray[representationArrayIndex];

          if (representationId === representation.id) {
            if (returnIndex) {
              return representationArrayIndex;
            } else {
              return representation;
            }
          }
        }
      }
    }

    return null;
  }

  function findMaxBufferIndex(period, bufferType) {
    var adaptationSet, adaptationSetArray, representationArray, adaptationSetArrayIndex;
    if (!period || !bufferType) return -1;
    adaptationSetArray = period.AdaptationSet_asArray;

    for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
      adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
      representationArray = adaptationSet.Representation_asArray;

      if (dashManifestModel.getIsTypeOf(adaptationSet, bufferType)) {
        return representationArray.length;
      }
    }

    return -1;
  } // #endregion PRIVATE FUNCTIONS


  instance = {
    getBandwidthForRepresentation: getBandwidthForRepresentation,
    getIndexForRepresentation: getIndexForRepresentation,
    getMaxIndexForBufferType: getMaxIndexForBufferType,
    convertRepresentationToRepresentationInfo: convertRepresentationToRepresentationInfo,
    getStreamsInfo: getStreamsInfo,
    getMediaInfoForType: getMediaInfoForType,
    getAllMediaInfoForType: getAllMediaInfoForType,
    getAdaptationForType: getAdaptationForType,
    getRealAdaptation: getRealAdaptation,
    getProducerReferenceTimes: getProducerReferenceTimes,
    getRealPeriodByIndex: getRealPeriodByIndex,
    getEssentialPropertiesForRepresentation: getEssentialPropertiesForRepresentation,
    getVoRepresentations: getVoRepresentations,
    getEventsFor: getEventsFor,
    getEvent: getEvent,
    getMpd: getMpd,
    setConfig: setConfig,
    updatePeriods: updatePeriods,
    getIsTextTrack: getIsTextTrack,
    getUTCTimingSources: getUTCTimingSources,
    getSuggestedPresentationDelay: getSuggestedPresentationDelay,
    getAvailabilityStartTime: getAvailabilityStartTime,
    getIsTypeOf: getIsTypeOf,
    getIsDynamic: getIsDynamic,
    getDuration: getDuration,
    getRegularPeriods: getRegularPeriods,
    getLocation: getLocation,
    getPatchLocation: getPatchLocation,
    getManifestUpdatePeriod: getManifestUpdatePeriod,
    getPublishTime: getPublishTime,
    getIsDVB: getIsDVB,
    getIsPatch: getIsPatch,
    getBaseURLsFromElement: getBaseURLsFromElement,
    getRepresentationSortFunction: getRepresentationSortFunction,
    getCodec: getCodec,
    getPeriodById: getPeriodById,
    setCurrentMediaInfo: setCurrentMediaInfo,
    isPatchValid: isPatchValid,
    applyPatchToManifest: applyPatchToManifest,
    areMediaInfosEqual: areMediaInfosEqual,
    reset: reset
  };
  setup();
  return instance;
}

DashAdapter.__dashjs_factory_name = 'DashAdapter';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__["default"].getSingletonFactory(DashAdapter));

/***/ }),

/***/ "./src/dash/DashHandler.js":
/*!*********************************!*\
  !*** ./src/dash/DashHandler.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_706116__) {

"use strict";
__nested_webpack_require_706116__.r(__webpack_exports__);
/* harmony import */ var _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_706116__(/*! ../streaming/vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_706116__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_706116__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_706116__(/*! ../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_706116__(/*! ./utils/SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_706116__(/*! ./constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






var DEFAULT_ADJUST_SEEK_TIME_THRESHOLD = 0.5;

function DashHandler(config) {
  config = config || {};
  var eventBus = config.eventBus;
  var debug = config.debug;
  var urlUtils = config.urlUtils;
  var type = config.type;
  var streamInfo = config.streamInfo;
  var segmentsController = config.segmentsController;
  var timelineConverter = config.timelineConverter;
  var baseURLController = config.baseURLController;
  var instance, logger, lastSegment, isDynamicManifest, mediaHasFinished;

  function setup() {
    logger = debug.getLogger(instance);
    resetInitialSettings();
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].DYNAMIC_TO_STATIC, _onDynamicToStatic, instance);
  }

  function initialize(isDynamic) {
    isDynamicManifest = isDynamic;
    mediaHasFinished = false;
    segmentsController.initialize(isDynamic);
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getType() {
    return type;
  }

  function getStreamInfo() {
    return streamInfo;
  }

  function resetInitialSettings() {
    lastSegment = null;
  }

  function reset() {
    resetInitialSettings();
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].DYNAMIC_TO_STATIC, _onDynamicToStatic, instance);
  }

  function _setRequestUrl(request, destination, representation) {
    var baseURL = baseURLController.resolve(representation.path);
    var url, serviceLocation;

    if (!baseURL || destination === baseURL.url || !urlUtils.isRelative(destination)) {
      url = destination;
    } else {
      url = baseURL.url;
      serviceLocation = baseURL.serviceLocation;

      if (destination) {
        url = urlUtils.resolve(destination, url);
      }
    }

    if (urlUtils.isRelative(url)) {
      return false;
    }

    request.url = url;
    request.serviceLocation = serviceLocation;
    return true;
  }

  function getInitRequest(mediaInfo, representation) {
    if (!representation) return null;
    return _generateInitRequest(mediaInfo, representation, getType());
  }

  function _generateInitRequest(mediaInfo, representation, mediaType) {
    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__["default"]();
    var period = representation.adaptation.period;
    var presentationStartTime = period.start;
    request.mediaType = mediaType;
    request.type = _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].INIT_SEGMENT_TYPE;
    request.range = representation.range;
    request.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime, representation, isDynamicManifest);
    request.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration, representation, isDynamicManifest);
    request.quality = representation.index;
    request.mediaInfo = mediaInfo;
    request.representationId = representation.id;

    if (_setRequestUrl(request, representation.initialization, representation)) {
      request.url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["replaceTokenForTemplate"])(request.url, 'Bandwidth', representation.bandwidth);
      return request;
    }
  }

  function _getRequestForSegment(mediaInfo, segment) {
    if (segment === null || segment === undefined) {
      return null;
    }

    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__["default"]();
    var representation = segment.representation;
    var bandwidth = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].bandwidth;
    var url = segment.media;
    url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["replaceTokenForTemplate"])(url, 'Number', segment.replacementNumber);
    url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["replaceTokenForTemplate"])(url, 'Time', segment.replacementTime);
    url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["replaceTokenForTemplate"])(url, 'Bandwidth', bandwidth);
    url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["replaceIDForTemplate"])(url, representation.id);
    url = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_4__["unescapeDollarsInTemplate"])(url);
    request.mediaType = getType();
    request.type = _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].MEDIA_SEGMENT_TYPE;
    request.range = segment.mediaRange;
    request.startTime = segment.presentationStartTime;
    request.mediaStartTime = segment.mediaStartTime;
    request.duration = segment.duration;
    request.timescale = representation.timescale;
    request.availabilityStartTime = segment.availabilityStartTime;
    request.availabilityEndTime = segment.availabilityEndTime;
    request.availabilityTimeComplete = representation.availabilityTimeComplete;
    request.wallStartTime = segment.wallStartTime;
    request.quality = representation.index;
    request.index = segment.index;
    request.mediaInfo = mediaInfo;
    request.adaptationIndex = representation.adaptation.index;
    request.representationId = representation.id;

    if (_setRequestUrl(request, url, representation)) {
      return request;
    }
  }

  function isLastSegmentRequested(representation, bufferingTime) {
    if (!representation || !lastSegment) {
      return false;
    } // Either transition from dynamic to static was done or no next static segment found


    if (mediaHasFinished) {
      return true;
    } // Period is endless


    if (!isFinite(representation.adaptation.period.duration)) {
      return false;
    } // we are replacing existing stuff in the buffer for instance after a track switch


    if (lastSegment.presentationStartTime + lastSegment.duration > bufferingTime) {
      return false;
    } // Additional segment references may be added to the last period.
    // Additional periods may be added to the end of the MPD.
    // Segment references SHALL NOT be added to any period other than the last period.
    // An MPD update MAY combine adding segment references to the last period with adding of new periods. An MPD update that adds content MAY be combined with an MPD update that removes content.
    // The index of the last requested segment is higher than the number of available segments.
    // For SegmentTimeline and SegmentTemplate the index does not include the startNumber.
    // For SegmentList the index includes the startnumber which is why the numberOfSegments includes this as well


    if (representation.mediaFinishedInformation && !isNaN(representation.mediaFinishedInformation.numberOfSegments) && !isNaN(lastSegment.index) && lastSegment.index >= representation.mediaFinishedInformation.numberOfSegments - 1) {
      // For static manifests and Template addressing we can compare the index against the number of available segments
      if (!isDynamicManifest || representation.segmentInfoType === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_5__["default"].SEGMENT_TEMPLATE) {
        return true;
      } // For SegmentList we need to check if the next period is signaled
      else if (isDynamicManifest && representation.segmentInfoType === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_5__["default"].SEGMENT_LIST && representation.adaptation.period.nextPeriodId) {
          return true;
        }
    } // For dynamic SegmentTimeline manifests we need to check if the next period is already signaled and the segment we fetched before is the last one that is signaled.
    // We can not simply use the index, as numberOfSegments might have decreased after an MPD update


    return !!(isDynamicManifest && representation.adaptation.period.nextPeriodId && representation.segmentInfoType === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_5__["default"].SEGMENT_TIMELINE && representation.mediaFinishedInformation && !isNaN(representation.mediaFinishedInformation.mediaTimeOfLastSignaledSegment) && lastSegment && !isNaN(lastSegment.mediaStartTime) && !isNaN(lastSegment.duration) && lastSegment.mediaStartTime + lastSegment.duration >= representation.mediaFinishedInformation.mediaTimeOfLastSignaledSegment - 0.05);
  }

  function getSegmentRequestForTime(mediaInfo, representation, time) {
    var request = null;

    if (!representation || !representation.segmentInfoType) {
      return request;
    }

    var segment = segmentsController.getSegmentByTime(representation, time);

    if (segment) {
      lastSegment = segment;
      logger.debug('Index for time ' + time + ' is ' + segment.index);
      request = _getRequestForSegment(mediaInfo, segment);
    }

    return request;
  }
  /**
   * This function returns the next segment request without modifying any internal variables. Any class (e.g CMCD Model) that needs information about the upcoming request should use this method.
   * @param {object} mediaInfo
   * @param {object} representation
   * @return {FragmentRequest|null}
   */


  function getNextSegmentRequestIdempotent(mediaInfo, representation) {
    var request = null;
    var indexToRequest = lastSegment ? lastSegment.index + 1 : 0;
    var segment = segmentsController.getSegmentByIndex(representation, indexToRequest, lastSegment ? lastSegment.mediaStartTime : -1);
    if (!segment) return null;
    request = _getRequestForSegment(mediaInfo, segment);
    return request;
  }
  /**
   * Main function to get the next segment request.
   * @param {object} mediaInfo
   * @param {object} representation
   * @return {FragmentRequest|null}
   */


  function getNextSegmentRequest(mediaInfo, representation) {
    var request = null;

    if (!representation || !representation.segmentInfoType) {
      return null;
    }

    var indexToRequest = lastSegment ? lastSegment.index + 1 : 0;
    var segment = segmentsController.getSegmentByIndex(representation, indexToRequest, lastSegment ? lastSegment.mediaStartTime : -1); // No segment found

    if (!segment) {
      // Dynamic manifest there might be something available in the next iteration
      if (isDynamicManifest && !mediaHasFinished) {
        logger.debug(getType() + ' No segment found at index: ' + indexToRequest + '. Wait for next loop');
        return null;
      } else {
        mediaHasFinished = true;
      }
    } else {
      request = _getRequestForSegment(mediaInfo, segment);
      lastSegment = segment;
    }

    return request;
  }
  /**
   * This function returns a time for which we can generate a request. It is supposed to be as close as possible to the target time.
   * This is useful in scenarios in which the user seeks into a gap. We will not find a valid request then and need to adjust the seektime.
   * @param {number} time
   * @param {object} mediaInfo
   * @param {object} representation
   * @param {number} targetThreshold
   */


  function getValidTimeCloseToTargetTime(time, mediaInfo, representation, targetThreshold) {
    try {
      if (isNaN(time) || !mediaInfo || !representation) {
        return NaN;
      }

      if (time < 0) {
        time = 0;
      }

      if (isNaN(targetThreshold)) {
        targetThreshold = DEFAULT_ADJUST_SEEK_TIME_THRESHOLD;
      }

      if (getSegmentRequestForTime(mediaInfo, representation, time)) {
        return time;
      }

      var start = representation.adaptation.period.start;
      var end = representation.adaptation.period.start + representation.adaptation.period.duration;
      var currentUpperTime = Math.min(time + targetThreshold, end);
      var currentLowerTime = Math.max(time - targetThreshold, start);
      var adjustedTime = NaN;
      var targetRequest = null;

      while (currentUpperTime <= end || currentLowerTime >= start) {
        var upperRequest = null;
        var lowerRequest = null;

        if (currentUpperTime <= end) {
          upperRequest = getSegmentRequestForTime(mediaInfo, representation, currentUpperTime);
        }

        if (currentLowerTime >= start) {
          lowerRequest = getSegmentRequestForTime(mediaInfo, representation, currentLowerTime);
        }

        if (lowerRequest) {
          adjustedTime = currentLowerTime;
          targetRequest = lowerRequest;
          break;
        } else if (upperRequest) {
          adjustedTime = currentUpperTime;
          targetRequest = upperRequest;
          break;
        }

        currentUpperTime += targetThreshold;
        currentLowerTime -= targetThreshold;
      }

      if (targetRequest) {
        var requestEndTime = targetRequest.startTime + targetRequest.duration; // Keep the original start time in case it is covered by a segment

        if (time >= targetRequest.startTime && requestEndTime - time > targetThreshold) {
          return time;
        } // If target time is before the start of the request use request starttime


        if (time < targetRequest.startTime) {
          return targetRequest.startTime;
        }

        return Math.min(requestEndTime - targetThreshold, adjustedTime);
      }

      return adjustedTime;
    } catch (e) {
      return NaN;
    }
  }
  /**
   * This function returns a time larger than the current time for which we can generate a request.
   * This is useful in scenarios in which the user seeks into a gap in a dynamic Timeline manifest. We will not find a valid request then and need to adjust the seektime.
   * @param {number} time
   * @param {object} mediaInfo
   * @param {object} representation
   * @param {number} targetThreshold
   */


  function getValidTimeAheadOfTargetTime(time, mediaInfo, representation, targetThreshold) {
    try {
      if (isNaN(time) || !mediaInfo || !representation) {
        return NaN;
      }

      if (time < 0) {
        time = 0;
      }

      if (isNaN(targetThreshold)) {
        targetThreshold = DEFAULT_ADJUST_SEEK_TIME_THRESHOLD;
      }

      if (getSegmentRequestForTime(mediaInfo, representation, time)) {
        return time;
      }

      if (representation.adaptation.period.start + representation.adaptation.period.duration < time) {
        return NaN;
      } // Only look 30 seconds ahead


      var end = Math.min(representation.adaptation.period.start + representation.adaptation.period.duration, time + 30);
      var currentUpperTime = Math.min(time + targetThreshold, end);
      var adjustedTime = NaN;
      var targetRequest = null;

      while (currentUpperTime <= end) {
        var upperRequest = null;

        if (currentUpperTime <= end) {
          upperRequest = getSegmentRequestForTime(mediaInfo, representation, currentUpperTime);
        }

        if (upperRequest) {
          adjustedTime = currentUpperTime;
          targetRequest = upperRequest;
          break;
        }

        currentUpperTime += targetThreshold;
      }

      if (targetRequest) {
        var requestEndTime = targetRequest.startTime + targetRequest.duration; // Keep the original start time in case it is covered by a segment

        if (time >= targetRequest.startTime && requestEndTime - time > targetThreshold) {
          return time;
        } // If target time is before the start of the request use request starttime


        if (time < targetRequest.startTime) {
          return targetRequest.startTime;
        }

        return Math.min(requestEndTime - targetThreshold, adjustedTime);
      }

      return adjustedTime;
    } catch (e) {
      return NaN;
    }
  }

  function getCurrentIndex() {
    return lastSegment ? lastSegment.index : -1;
  }

  function _onDynamicToStatic() {
    logger.debug('Dynamic stream complete');
    mediaHasFinished = true;
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    getType: getType,
    getStreamInfo: getStreamInfo,
    getInitRequest: getInitRequest,
    getSegmentRequestForTime: getSegmentRequestForTime,
    getCurrentIndex: getCurrentIndex,
    getNextSegmentRequest: getNextSegmentRequest,
    isLastSegmentRequested: isLastSegmentRequested,
    reset: reset,
    getNextSegmentRequestIdempotent: getNextSegmentRequestIdempotent,
    getValidTimeCloseToTargetTime: getValidTimeCloseToTargetTime,
    getValidTimeAheadOfTargetTime: getValidTimeAheadOfTargetTime
  };
  setup();
  return instance;
}

DashHandler.__dashjs_factory_name = 'DashHandler';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(DashHandler));

/***/ }),

/***/ "./src/dash/DashMetrics.js":
/*!*********************************!*\
  !*** ./src/dash/DashMetrics.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_726392__) {

"use strict";
__nested_webpack_require_726392__.r(__webpack_exports__);
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_726392__(/*! ../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_726392__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_726392__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_726392__(/*! ../streaming/constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _utils_Round10__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_726392__(/*! ./utils/Round10 */ "./src/dash/utils/Round10.js");
/* harmony import */ var _streaming_models_MetricsModel__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_726392__(/*! ../streaming/models/MetricsModel */ "./src/streaming/models/MetricsModel.js");
/* harmony import */ var _core_Utils__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_726392__(/*! ../core/Utils */ "./src/core/Utils.js");
/* harmony import */ var _streaming_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_726392__(/*! ../streaming/vo/metrics/PlayList */ "./src/streaming/vo/metrics/PlayList.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








/**
 * @module DashMetrics
 * @description The DashMetrics module can be accessed using the MediaPlayer API getDashMetrics()
 * @param {object} config
 */

function DashMetrics(config) {
  config = config || {};
  var context = this.context;
  var instance, playListTraceMetricsClosed, playListTraceMetrics, playListMetrics;
  var metricsModel = config.metricsModel;

  function setup() {
    metricsModel = metricsModel || Object(_streaming_models_MetricsModel__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance({
      settings: config.settings
    });
    resetInitialSettings();
  }

  function resetInitialSettings() {
    playListTraceMetricsClosed = true;
    playListTraceMetrics = null;
    playListMetrics = null;
  }
  /**
   * Returns the latest Representation switch for a given media type
   * @param {MediaType} mediaType
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentRepresentationSwitch(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);
    return getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].TRACK_SWITCH);
  }
  /**
   * @param {MediaType} mediaType
   * @param {Date} t time of the switch event
   * @param {Date} mt media presentation time
   * @param {string} to id of representation
   * @param {string} lto if present, subrepresentation reference
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addRepresentationSwitch(mediaType, t, mt, to, lto) {
    metricsModel.addRepresentationSwitch(mediaType, t, mt, to, lto);
  }
  /**
   * Returns the current buffer state for a given media type
   * @param {MediaType} mediaType
   * @returns {number}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentBufferState(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);
    return getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].BUFFER_STATE);
  }
  /**
   * Returns the current buffer level for a given media type
   * @param {MediaType} mediaType
   * @returns {number}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentBufferLevel(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);
    var metric = getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].BUFFER_LEVEL);

    if (metric) {
      return _utils_Round10__WEBPACK_IMPORTED_MODULE_4__["default"].round10(metric.level / 1000, -3);
    }

    return 0;
  }
  /**
   * @param {MediaType} mediaType
   * @param {number} t
   * @param {number} level
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addBufferLevel(mediaType, t, level) {
    metricsModel.addBufferLevel(mediaType, t, level);
  }
  /**
   * @param {MediaType} mediaType
   * @param {string} state
   * @param {number} target
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addBufferState(mediaType, state, target) {
    metricsModel.addBufferState(mediaType, state, target);
  }
  /**
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function clearAllCurrentMetrics() {
    metricsModel.clearAllCurrentMetrics();
  }
  /**
   * Returns the latest HTTP request for a given media type
   * @param {MediaType} mediaType
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentHttpRequest(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);

    if (!metrics) {
      return null;
    }

    var httpList = metrics.HttpList;
    var currentHttpList = null;
    var httpListLastIndex;

    if (!httpList || httpList.length <= 0) {
      return null;
    }

    httpListLastIndex = httpList.length - 1;

    while (httpListLastIndex >= 0) {
      if (httpList[httpListLastIndex].responsecode) {
        currentHttpList = httpList[httpListLastIndex];
        break;
      }

      httpListLastIndex--;
    }

    return currentHttpList;
  }
  /**
   * Returns all HTTP requests for a given media type
   * @param {MediaType} mediaType
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getHttpRequests(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);

    if (!metrics) {
      return [];
    }

    return !!metrics.HttpList ? metrics.HttpList : [];
  }
  /**
   * @param {MediaType} mediaType
   * @param {Array} loadingRequests
   * @param {Array} executedRequests
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addRequestsQueue(mediaType, loadingRequests, executedRequests) {
    metricsModel.addRequestsQueue(mediaType, loadingRequests, executedRequests);
  }
  /**
   * Returns the latest metrics for a given metric list and specific metric name
   * @param {MetricsList} metrics
   * @param {string} metricName
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrent(metrics, metricName) {
    if (!metrics) {
      return null;
    }

    var list = metrics[metricName];
    return !list || list.length === 0 ? null : list[list.length - 1];
  }
  /**
   * Returns the number of dropped frames
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentDroppedFrames() {
    var metrics = metricsModel.getMetricsFor(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, true);
    return getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].DROPPED_FRAMES);
  }
  /**
   * @param {number} quality
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addDroppedFrames(quality) {
    metricsModel.addDroppedFrames(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, quality);
  }
  /**
   * Returns the current scheduling info for a given media type
   * @param {MediaType} mediaType
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentSchedulingInfo(mediaType) {
    var metrics = metricsModel.getMetricsFor(mediaType, true);
    return getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].SCHEDULING_INFO);
  }
  /**
   * @param {object} request
   * @param {string} state
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addSchedulingInfo(request, state) {
    metricsModel.addSchedulingInfo(request.mediaType, new Date(), request.type, request.startTime, request.availabilityStartTime, request.duration, request.quality, request.range, state);
  }
  /**
   * Returns the current manifest update information
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentManifestUpdate() {
    var streamMetrics = metricsModel.getMetricsFor(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM);
    return getCurrent(streamMetrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].MANIFEST_UPDATE);
  }
  /**
   * @param {object} updatedFields fields to be updated
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function updateManifestUpdateInfo(updatedFields) {
    var manifestUpdate = this.getCurrentManifestUpdate();
    metricsModel.updateManifestUpdateInfo(manifestUpdate, updatedFields);
  }
  /**
   * @param {object} streamInfo
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addManifestUpdateStreamInfo(streamInfo) {
    if (streamInfo) {
      var manifestUpdate = this.getCurrentManifestUpdate();
      metricsModel.addManifestUpdateStreamInfo(manifestUpdate, streamInfo.id, streamInfo.index, streamInfo.start, streamInfo.duration);
    }
  }
  /**
   * @param {object} request
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addManifestUpdate(request) {
    metricsModel.addManifestUpdate(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM, request.type, request.requestStartDate, request.requestEndDate);
  }
  /**
   * @param {object} request
   * @param {string} responseURL
   * @param {number} responseStatus
   * @param {object} responseHeaders
   * @param {object} traces
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addHttpRequest(request, responseURL, responseStatus, responseHeaders, traces) {
    metricsModel.addHttpRequest(request.mediaType, null, request.type, request.url, request.quality, responseURL, request.serviceLocation || null, request.range || null, request.requestStartDate, request.firstByteDate, request.requestEndDate, responseStatus, request.duration, responseHeaders, traces, request.fileLoaderType);
  }
  /**
   * @param {object} representation
   * @param {MediaType} mediaType
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addManifestUpdateRepresentationInfo(representation, mediaType) {
    if (representation) {
      var manifestUpdateInfo = this.getCurrentManifestUpdate();
      metricsModel.addManifestUpdateRepresentationInfo(manifestUpdateInfo, representation.id, representation.index, representation.streamIndex, mediaType, representation.presentationTimeOffset, representation.startNumber, representation.fragmentInfoType);
    }
  }
  /**
   * Returns the current DVR window
   * @param {MediaType} mediaType
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getCurrentDVRInfo(mediaType) {
    var metrics = mediaType ? metricsModel.getMetricsFor(mediaType, true) : metricsModel.getMetricsFor(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, true) || metricsModel.getMetricsFor(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO, true);
    return getCurrent(metrics, _streaming_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].DVR_INFO);
  }
  /**
   * @param {MediaType} mediaType
   * @param {Date} currentTime time of the switch event
   * @param {object} mpd mpd reference
   * @param {object} range range of the dvr info
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addDVRInfo(mediaType, currentTime, mpd, range) {
    metricsModel.addDVRInfo(mediaType, currentTime, mpd, range);
  }
  /**
   * Returns the value for a specific request headers used in the latest MPD request
   * @param {string} id
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getLatestMPDRequestHeaderValueByID(id) {
    if (!id) {
      return null;
    }

    var headers = {};
    var httpRequestList, httpRequest, i;
    httpRequestList = getHttpRequests(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM);

    for (i = httpRequestList.length - 1; i >= 0; i--) {
      httpRequest = httpRequestList[i];

      if (httpRequest.type === _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].MPD_TYPE) {
        headers = _core_Utils__WEBPACK_IMPORTED_MODULE_6__["default"].parseHttpHeaders(httpRequest._responseHeaders);
        break;
      }
    }

    var value = headers[id.toLowerCase()];
    return value === undefined ? null : value;
  }
  /**
   * Returns the value for a specific request headers used in the latest fragment request
   * @param {MediaType} mediaType
   * @param {string} id
   * @returns {*}
   * @memberof module:DashMetrics
   * @instance
   */


  function getLatestFragmentRequestHeaderValueByID(mediaType, id) {
    if (!id) {
      return null;
    }

    var headers = {};
    var httpRequest = getCurrentHttpRequest(mediaType);

    if (httpRequest) {
      headers = _core_Utils__WEBPACK_IMPORTED_MODULE_6__["default"].parseHttpHeaders(httpRequest._responseHeaders);
    }

    var value = headers[id.toLowerCase()];
    return value === undefined ? null : value;
  }
  /**
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addPlayList() {
    if (playListMetrics) {
      metricsModel.addPlayList(playListMetrics);
      playListMetrics = null;
    }
  }
  /**
   * Create a new playlist metric
   * @param {number} mediaStartTime
   * @param {string} startReason
   * @ignore
   */


  function createPlaylistMetrics(mediaStartTime, startReason) {
    playListMetrics = new _streaming_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayList"]();
    playListMetrics.start = new Date();
    playListMetrics.mstart = mediaStartTime;
    playListMetrics.starttype = startReason;
  }
  /**
   * Create a playlist trace metric
   * @param {number} representationId
   * @param {number} mediaStartTime
   * @param {number} speed
   * @ignore
   */


  function createPlaylistTraceMetrics(representationId, mediaStartTime, speed) {
    if (playListTraceMetricsClosed === true) {
      playListTraceMetricsClosed = false;
      playListTraceMetrics = new _streaming_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"]();
      playListTraceMetrics.representationid = representationId;
      playListTraceMetrics.start = new Date();
      playListTraceMetrics.mstart = mediaStartTime;
      playListTraceMetrics.playbackspeed = speed !== null ? speed.toString() : null;
    }
  }
  /**
   * Update existing playlist trace metric
   * @param {object} traceToUpdate
   * @ignore
   */


  function updatePlayListTraceMetrics(traceToUpdate) {
    if (playListTraceMetrics) {
      for (var field in playListTraceMetrics) {
        playListTraceMetrics[field] = traceToUpdate[field];
      }
    }
  }
  /**
   * Push a new playlist trace metric
   * @param endTime
   * @param reason
   * @ignore
   */


  function pushPlayListTraceMetrics(endTime, reason) {
    if (playListTraceMetricsClosed === false && playListMetrics && playListTraceMetrics && playListTraceMetrics.start) {
      var startTime = playListTraceMetrics.start;
      var duration = endTime.getTime() - startTime.getTime();
      playListTraceMetrics.duration = duration;
      playListTraceMetrics.stopreason = reason;
      playListMetrics.trace.push(playListTraceMetrics);
      playListTraceMetricsClosed = true;
    }
  }
  /**
   * @param {object} errors
   * @memberof module:DashMetrics
   * @instance
   * @ignore
   */


  function addDVBErrors(errors) {
    metricsModel.addDVBErrors(errors);
  }

  instance = {
    getCurrentRepresentationSwitch: getCurrentRepresentationSwitch,
    getCurrentBufferState: getCurrentBufferState,
    getCurrentBufferLevel: getCurrentBufferLevel,
    getCurrentHttpRequest: getCurrentHttpRequest,
    getHttpRequests: getHttpRequests,
    getCurrentDroppedFrames: getCurrentDroppedFrames,
    getCurrentSchedulingInfo: getCurrentSchedulingInfo,
    getCurrentDVRInfo: getCurrentDVRInfo,
    getCurrentManifestUpdate: getCurrentManifestUpdate,
    getLatestFragmentRequestHeaderValueByID: getLatestFragmentRequestHeaderValueByID,
    getLatestMPDRequestHeaderValueByID: getLatestMPDRequestHeaderValueByID,
    addRepresentationSwitch: addRepresentationSwitch,
    addDVRInfo: addDVRInfo,
    updateManifestUpdateInfo: updateManifestUpdateInfo,
    addManifestUpdateStreamInfo: addManifestUpdateStreamInfo,
    addManifestUpdateRepresentationInfo: addManifestUpdateRepresentationInfo,
    addManifestUpdate: addManifestUpdate,
    addHttpRequest: addHttpRequest,
    addSchedulingInfo: addSchedulingInfo,
    addRequestsQueue: addRequestsQueue,
    addBufferLevel: addBufferLevel,
    addBufferState: addBufferState,
    addDroppedFrames: addDroppedFrames,
    addPlayList: addPlayList,
    addDVBErrors: addDVBErrors,
    createPlaylistMetrics: createPlaylistMetrics,
    createPlaylistTraceMetrics: createPlaylistTraceMetrics,
    updatePlayListTraceMetrics: updatePlayListTraceMetrics,
    pushPlayListTraceMetrics: pushPlayListTraceMetrics,
    clearAllCurrentMetrics: clearAllCurrentMetrics
  };
  setup();
  return instance;
}

DashMetrics.__dashjs_factory_name = 'DashMetrics';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(DashMetrics));

/***/ }),

/***/ "./src/dash/SegmentBaseLoader.js":
/*!***************************************!*\
  !*** ./src/dash/SegmentBaseLoader.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_746849__) {

"use strict";
__nested_webpack_require_746849__.r(__webpack_exports__);
/* harmony import */ var _vo_Segment__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_746849__(/*! ./vo/Segment */ "./src/dash/vo/Segment.js");
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_746849__(/*! ../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_746849__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_746849__(/*! ../streaming/vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/* harmony import */ var _streaming_net_URLLoader__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_746849__(/*! ../streaming/net/URLLoader */ "./src/streaming/net/URLLoader.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function SegmentBaseLoader() {
  var context = this.context;
  var instance, logger, errHandler, boxParser, requestModifier, dashMetrics, mediaPlayerModel, urlLoader, errors, constants, dashConstants, urlUtils, baseURLController;

  function setup() {}

  function initialize() {
    urlLoader = Object(_streaming_net_URLLoader__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
      errHandler: errHandler,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      requestModifier: requestModifier,
      boxParser: boxParser,
      errors: errors,
      urlUtils: urlUtils,
      constants: constants,
      dashConstants: dashConstants
    });
  }

  function setConfig(config) {
    if (config.baseURLController) {
      baseURLController = config.baseURLController;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.mediaPlayerModel) {
      mediaPlayerModel = config.mediaPlayerModel;
    }

    if (config.errHandler) {
      errHandler = config.errHandler;
    }

    if (config.boxParser) {
      boxParser = config.boxParser;
    }

    if (config.debug) {
      logger = config.debug.getLogger(instance);
    }

    if (config.requestModifier) {
      requestModifier = config.requestModifier;
    }

    if (config.errors) {
      errors = config.errors;
    }

    if (config.urlUtils) {
      urlUtils = config.urlUtils;
    }

    if (config.constants) {
      constants = config.constants;
    }

    if (config.dashConstants) {
      dashConstants = config.dashConstants;
    }
  }

  function loadInitialization(representation, mediaType) {
    return new Promise(function (resolve) {
      _loadInitializationRecursively(representation, mediaType, resolve);
    });
  }

  function _loadInitializationRecursively(representation, mediaType, resolve, loadingInfo) {
    var initRange = null;
    var baseUrl = representation ? baseURLController.resolve(representation.path) : null;
    var info = loadingInfo || {
      init: true,
      url: baseUrl ? baseUrl.url : undefined,
      range: {
        start: 0,
        end: 1500
      },
      searching: false,
      bytesLoaded: 0,
      bytesToLoad: 1500,
      mediaType: mediaType
    };
    logger.debug('Start searching for initialization.');
    var request = getFragmentRequest(info);

    var onload = function onload(response) {
      info.bytesLoaded = info.range.end;
      initRange = boxParser.findInitRange(response);

      if (initRange) {
        representation.range = initRange; // note that we don't explicitly set rep.initialization as this
        // will be computed when all BaseURLs are resolved later

        resolve(representation);
      } else {
        info.range.end = info.bytesLoaded + info.bytesToLoad;
        return _loadInitializationRecursively(representation, mediaType, resolve, info);
      }
    };

    var onerror = function onerror() {
      resolve(representation);
    };

    urlLoader.load({
      request: request,
      success: onload,
      error: onerror
    });
    logger.debug('Perform init search: ' + info.url);
  }

  function loadSegments(representation, mediaType, range) {
    return new Promise(function (resolve) {
      _loadSegmentsRecursively(representation, mediaType, range, resolve);
    });
  }

  function _loadSegmentsRecursively(representation, mediaType, range, resolve, callback, loadingInfo) {
    if (range && (range.start === undefined || range.end === undefined)) {
      var parts = range ? range.toString().split('-') : null;
      range = parts ? {
        start: parseFloat(parts[0]),
        end: parseFloat(parts[1])
      } : null;
    }

    callback = !callback ? onLoaded : callback;
    var isoFile = null;
    var sidx = null;
    var hasRange = !!range;
    var baseUrl = representation ? baseURLController.resolve(representation.path) : null;
    var info = {
      init: false,
      url: baseUrl ? baseUrl.url : undefined,
      range: hasRange ? range : {
        start: 0,
        end: 1500
      },
      searching: !hasRange,
      bytesLoaded: loadingInfo ? loadingInfo.bytesLoaded : 0,
      bytesToLoad: 1500,
      mediaType: mediaType
    };
    var request = getFragmentRequest(info);

    var onload = function onload(response) {
      var extraBytes = info.bytesToLoad;
      var loadedLength = response.byteLength;
      info.bytesLoaded = info.range.end - info.range.start;
      isoFile = boxParser.parse(response);
      sidx = isoFile.getBox('sidx');

      if (!sidx || !sidx.isComplete) {
        if (sidx) {
          info.range.start = sidx.offset || info.range.start;
          info.range.end = info.range.start + (sidx.size || extraBytes);
        } else if (loadedLength < info.bytesLoaded) {
          // if we have reached a search limit or if we have reached the end of the file we have to stop trying to find sidx
          callback(null, representation, resolve);
          return;
        } else {
          var lastBox = isoFile.getLastBox();

          if (lastBox && lastBox.size) {
            info.range.start = lastBox.offset + lastBox.size;
            info.range.end = info.range.start + extraBytes;
          } else {
            info.range.end += extraBytes;
          }
        }

        _loadSegmentsRecursively(representation, mediaType, info.range, resolve, null, info);
      } else {
        var ref = sidx.references;
        var loadMultiSidx, segments;

        if (ref !== null && ref !== undefined && ref.length > 0) {
          loadMultiSidx = ref[0].reference_type === 1;
        }

        if (loadMultiSidx) {
          logger.debug('Initiate multiple SIDX load.');
          info.range.end = info.range.start + sidx.size;
          var j, len, ss, se, r;
          var segs = [];
          var count = 0;
          var offset = (sidx.offset || info.range.start) + sidx.size;

          var tmpCallback = function tmpCallback(result) {
            if (result) {
              segs = segs.concat(result);
              count++;

              if (count >= len) {
                // http requests can be processed in a wrong order, so, we have to reorder segments with an ascending start Time order
                segs.sort(function (a, b) {
                  return a.startTime - b.startTime < 0 ? -1 : 0;
                });
                callback(segs, representation, resolve);
              }
            } else {
              callback(null, representation, resolve);
            }
          };

          for (j = 0, len = ref.length; j < len; j++) {
            ss = offset;
            se = offset + ref[j].referenced_size - 1;
            offset = offset + ref[j].referenced_size;
            r = {
              start: ss,
              end: se
            };

            _loadSegmentsRecursively(representation, mediaType, r, resolve, tmpCallback, info);
          }
        } else {
          logger.debug('Parsing segments from SIDX. representation ' + mediaType + ' - id: ' + representation.id + ' for range : ' + info.range.start + ' - ' + info.range.end);
          segments = getSegmentsForSidx(sidx, info);
          callback(segments, representation, resolve);
        }
      }
    };

    var onerror = function onerror() {
      callback(null, representation, resolve);
    };

    urlLoader.load({
      request: request,
      success: onload,
      error: onerror
    });
    logger.debug("Perform SIDX load for type ".concat(mediaType, " : ").concat(info.url, " with range ").concat(info.range.start, " - ").concat(info.range.end));
  }

  function onLoaded(segments, representation, resolve) {
    resolve({
      segments: segments,
      representation: representation,
      error: segments ? undefined : new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__["default"](errors.SEGMENT_BASE_LOADER_ERROR_CODE, errors.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
    });
  }

  function reset() {
    if (urlLoader) {
      urlLoader.abort();
      urlLoader = null;
    }
  }

  function getSegmentsForSidx(sidx, info) {
    var refs = sidx.references;
    var len = refs.length;
    var timescale = sidx.timescale;
    var time = sidx.earliest_presentation_time;
    var start = info.range.start + sidx.offset + sidx.first_offset + sidx.size;
    var segments = [];
    var segment, end, duration, size;

    for (var i = 0; i < len; i++) {
      duration = refs[i].subsegment_duration;
      size = refs[i].referenced_size;
      segment = new _vo_Segment__WEBPACK_IMPORTED_MODULE_0__["default"](); // note that we don't explicitly set segment.media as this will be
      // computed when all BaseURLs are resolved later

      segment.duration = duration;
      segment.startTime = time;
      segment.timescale = timescale;
      end = start + size - 1;
      segment.mediaRange = start + '-' + end;
      segments.push(segment);
      time += duration;
      start += size;
    }

    return segments;
  }

  function getFragmentRequest(info) {
    if (!info.url) {
      return;
    }

    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_3__["default"]();
    request.setInfo(info);
    return request;
  }

  instance = {
    setConfig: setConfig,
    initialize: initialize,
    loadInitialization: loadInitialization,
    loadSegments: loadSegments,
    reset: reset
  };
  setup();
  return instance;
}

SegmentBaseLoader.__dashjs_factory_name = 'SegmentBaseLoader';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(SegmentBaseLoader));

/***/ }),

/***/ "./src/dash/WebmSegmentBaseLoader.js":
/*!*******************************************!*\
  !*** ./src/dash/WebmSegmentBaseLoader.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_759833__) {

"use strict";
__nested_webpack_require_759833__.r(__webpack_exports__);
/* harmony import */ var _streaming_utils_EBMLParser__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_759833__(/*! ../streaming/utils/EBMLParser */ "./src/streaming/utils/EBMLParser.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_759833__(/*! ../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_759833__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_Segment__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_759833__(/*! ./vo/Segment */ "./src/dash/vo/Segment.js");
/* harmony import */ var _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_759833__(/*! ../streaming/vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/* harmony import */ var _streaming_net_URLLoader__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_759833__(/*! ../streaming/net/URLLoader */ "./src/streaming/net/URLLoader.js");
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_759833__(/*! ../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");








function WebmSegmentBaseLoader() {
  var context = this.context;
  var instance, logger, WebM, errHandler, requestModifier, dashMetrics, mediaPlayerModel, urlLoader, errors, baseURLController;

  function setup() {
    WebM = {
      EBML: {
        tag: 0x1A45DFA3,
        required: true
      },
      Segment: {
        tag: 0x18538067,
        required: true,
        SeekHead: {
          tag: 0x114D9B74,
          required: true
        },
        Info: {
          tag: 0x1549A966,
          required: true,
          TimecodeScale: {
            tag: 0x2AD7B1,
            required: true,
            parse: 'getMatroskaUint'
          },
          Duration: {
            tag: 0x4489,
            required: true,
            parse: 'getMatroskaFloat'
          }
        },
        Tracks: {
          tag: 0x1654AE6B,
          required: true
        },
        Cues: {
          tag: 0x1C53BB6B,
          required: true,
          CuePoint: {
            tag: 0xBB,
            required: true,
            CueTime: {
              tag: 0xB3,
              required: true,
              parse: 'getMatroskaUint'
            },
            CueTrackPositions: {
              tag: 0xB7,
              required: true,
              CueTrack: {
                tag: 0xF7,
                required: true,
                parse: 'getMatroskaUint'
              },
              CueClusterPosition: {
                tag: 0xF1,
                required: true,
                parse: 'getMatroskaUint'
              }
            }
          }
        }
      },
      Void: {
        tag: 0xEC,
        required: true
      }
    };
  }

  function initialize() {
    urlLoader = Object(_streaming_net_URLLoader__WEBPACK_IMPORTED_MODULE_5__["default"])(context).create({
      errHandler: errHandler,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      requestModifier: requestModifier,
      errors: errors
    });
  }

  function setConfig(config) {
    if (!config.baseURLController || !config.dashMetrics || !config.mediaPlayerModel || !config.errHandler) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }

    baseURLController = config.baseURLController;
    dashMetrics = config.dashMetrics;
    mediaPlayerModel = config.mediaPlayerModel;
    errHandler = config.errHandler;
    errors = config.errors;
    logger = config.debug.getLogger(instance);
    requestModifier = config.requestModifier;
  }

  function parseCues(ab) {
    var cues = [];
    var ebmlParser = Object(_streaming_utils_EBMLParser__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
      data: ab
    });
    var cue, cueTrack;
    ebmlParser.consumeTagAndSize(WebM.Segment.Cues);

    while (ebmlParser.moreData() && ebmlParser.consumeTagAndSize(WebM.Segment.Cues.CuePoint, true)) {
      cue = {};
      cue.CueTime = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTime);
      cue.CueTracks = [];

      while (ebmlParser.moreData() && ebmlParser.consumeTag(WebM.Segment.Cues.CuePoint.CueTrackPositions, true)) {
        var cueTrackPositionSize = ebmlParser.getMatroskaCodedNum();
        var startPos = ebmlParser.getPos();
        cueTrack = {};
        cueTrack.Track = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueTrack);

        if (cueTrack.Track === 0) {
          throw new Error('Cue track cannot be 0');
        }

        cueTrack.ClusterPosition = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition);
        cue.CueTracks.push(cueTrack); // we're not interested any other elements - skip remaining bytes

        ebmlParser.setPos(startPos + cueTrackPositionSize);
      }

      if (cue.CueTracks.length === 0) {
        throw new Error('Mandatory cuetrack not found');
      }

      cues.push(cue);
    }

    if (cues.length === 0) {
      throw new Error('mandatory cuepoint not found');
    }

    return cues;
  }

  function parseSegments(data, segmentStart, segmentEnd, segmentDuration) {
    var duration, parsed, segments, segment, i, len, start, end;
    parsed = parseCues(data);
    segments = []; // we are assuming one cue track per cue point
    // both duration and media range require the i + 1 segment
    // the final segment has to use global segment parameters

    for (i = 0, len = parsed.length; i < len; i += 1) {
      segment = new _vo_Segment__WEBPACK_IMPORTED_MODULE_3__["default"]();
      duration = 0;

      if (i < parsed.length - 1) {
        duration = parsed[i + 1].CueTime - parsed[i].CueTime;
      } else {
        duration = segmentDuration - parsed[i].CueTime;
      } // note that we don't explicitly set segment.media as this will be
      // computed when all BaseURLs are resolved later


      segment.duration = duration;
      segment.startTime = parsed[i].CueTime;
      segment.timescale = 1000; // hardcoded for ms

      start = parsed[i].CueTracks[0].ClusterPosition + segmentStart;

      if (i < parsed.length - 1) {
        end = parsed[i + 1].CueTracks[0].ClusterPosition + segmentStart - 1;
      } else {
        end = segmentEnd - 1;
      }

      segment.mediaRange = start + '-' + end;
      segments.push(segment);
    }

    logger.debug('Parsed cues: ' + segments.length + ' cues.');
    return segments;
  }

  function parseEbmlHeader(data, media, theRange, callback) {
    if (!data || data.byteLength === 0) {
      callback(null);
      return;
    }

    var ebmlParser = Object(_streaming_utils_EBMLParser__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
      data: data
    });
    var duration, segments, segmentEnd, segmentStart;
    var parts = theRange ? theRange.split('-') : null;
    var request = null;
    var info = {
      url: media,
      range: {
        start: parts ? parseFloat(parts[0]) : null,
        end: parts ? parseFloat(parts[1]) : null
      },
      request: request
    };
    logger.debug('Parse EBML header: ' + info.url); // skip over the header itself

    ebmlParser.skipOverElement(WebM.EBML);
    ebmlParser.consumeTag(WebM.Segment); // segments start here

    segmentEnd = ebmlParser.getMatroskaCodedNum();
    segmentEnd += ebmlParser.getPos();
    segmentStart = ebmlParser.getPos(); // skip over any top level elements to get to the segment info

    while (ebmlParser.moreData() && !ebmlParser.consumeTagAndSize(WebM.Segment.Info, true)) {
      if (!(ebmlParser.skipOverElement(WebM.Segment.SeekHead, true) || ebmlParser.skipOverElement(WebM.Segment.Tracks, true) || ebmlParser.skipOverElement(WebM.Segment.Cues, true) || ebmlParser.skipOverElement(WebM.Void, true))) {
        throw new Error('no valid top level element found');
      }
    } // we only need one thing in segment info, duration


    while (duration === undefined) {
      var infoTag = ebmlParser.getMatroskaCodedNum(true);
      var infoElementSize = ebmlParser.getMatroskaCodedNum();

      switch (infoTag) {
        case WebM.Segment.Info.Duration.tag:
          duration = ebmlParser[WebM.Segment.Info.Duration.parse](infoElementSize);
          break;

        default:
          ebmlParser.setPos(ebmlParser.getPos() + infoElementSize);
          break;
      }
    } // once we have what we need from segment info, we jump right to the
    // cues


    request = _getFragmentRequest(info);

    var onload = function onload(response) {
      segments = parseSegments(response, segmentStart, segmentEnd, duration);
      callback(segments);
    };

    var onloadend = function onloadend() {
      logger.error('Download Error: Cues ' + info.url);
      callback(null);
    };

    urlLoader.load({
      request: request,
      success: onload,
      error: onloadend
    });
    logger.debug('Perform cues load: ' + info.url + ' bytes=' + info.range.start + '-' + info.range.end);
  }

  function loadInitialization(representation, mediaType) {
    return new Promise(function (resolve) {
      var request = null;
      var baseUrl = representation ? baseURLController.resolve(representation.path) : null;
      var initRange = representation ? representation.range.split('-') : null;
      var info = {
        range: {
          start: initRange ? parseFloat(initRange[0]) : null,
          end: initRange ? parseFloat(initRange[1]) : null
        },
        request: request,
        url: baseUrl ? baseUrl.url : undefined,
        init: true,
        mediaType: mediaType
      };
      logger.info('Start loading initialization.');
      request = _getFragmentRequest(info);

      var onload = function onload() {
        // note that we don't explicitly set rep.initialization as this
        // will be computed when all BaseURLs are resolved later
        resolve(representation);
      };

      var onloadend = function onloadend() {
        resolve(representation);
      };

      urlLoader.load({
        request: request,
        success: onload,
        error: onloadend
      });
      logger.debug('Perform init load: ' + info.url);
    });
  }

  function loadSegments(representation, mediaType, theRange) {
    return new Promise(function (resolve) {
      var request = null;
      var baseUrl = representation ? baseURLController.resolve(representation.path) : null;
      var media = baseUrl ? baseUrl.url : undefined;
      var bytesToLoad = 8192;
      var info = {
        bytesLoaded: 0,
        bytesToLoad: bytesToLoad,
        range: {
          start: 0,
          end: bytesToLoad
        },
        request: request,
        url: media,
        init: false,
        mediaType: mediaType
      };
      request = _getFragmentRequest(info); // first load the header, but preserve the manifest range so we can
      // load the cues after parsing the header
      // NOTE: we expect segment info to appear in the first 8192 bytes

      logger.debug('Parsing ebml header');

      var onload = function onload(response) {
        parseEbmlHeader(response, media, theRange, function (segments) {
          resolve({
            segments: segments,
            representation: representation,
            error: segments ? undefined : new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](errors.SEGMENT_BASE_LOADER_ERROR_CODE, errors.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
          });
        });
      };

      var onloadend = function onloadend() {
        resolve({
          representation: representation,
          error: new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](errors.SEGMENT_BASE_LOADER_ERROR_CODE, errors.SEGMENT_BASE_LOADER_ERROR_MESSAGE)
        });
      };

      urlLoader.load({
        request: request,
        success: onload,
        error: onloadend
      });
    });
  }

  function _getFragmentRequest(info) {
    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_4__["default"]();
    request.setInfo(info);
    return request;
  }

  function reset() {
    if (urlLoader) {
      urlLoader.abort();
      urlLoader = null;
    }
  }

  instance = {
    setConfig: setConfig,
    initialize: initialize,
    loadInitialization: loadInitialization,
    loadSegments: loadSegments,
    reset: reset
  };
  setup();
  return instance;
}

WebmSegmentBaseLoader.__dashjs_factory_name = 'WebmSegmentBaseLoader';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(WebmSegmentBaseLoader));

/***/ }),

/***/ "./src/dash/constants/DashConstants.js":
/*!*********************************************!*\
  !*** ./src/dash/constants/DashConstants.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_773273__) {

"use strict";
__nested_webpack_require_773273__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Dash constants declaration
 * @class
 * @ignore
 */
var DashConstants = /*#__PURE__*/function () {
  function DashConstants() {
    _classCallCheck(this, DashConstants);

    this.init();
  }

  _createClass(DashConstants, [{
    key: "init",
    value: function init() {
      this.BASE_URL = 'BaseURL';
      this.SEGMENT_BASE = 'SegmentBase';
      this.SEGMENT_TEMPLATE = 'SegmentTemplate';
      this.SEGMENT_LIST = 'SegmentList';
      this.SEGMENT_URL = 'SegmentURL';
      this.SEGMENT_TIMELINE = 'SegmentTimeline';
      this.SEGMENT_PROFILES = 'segmentProfiles';
      this.ADAPTATION_SET = 'AdaptationSet';
      this.REPRESENTATION = 'Representation';
      this.REPRESENTATION_INDEX = 'RepresentationIndex';
      this.SUB_REPRESENTATION = 'SubRepresentation';
      this.INITIALIZATION = 'Initialization';
      this.INITIALIZATION_MINUS = 'initialization';
      this.MPD = 'MPD';
      this.PERIOD = 'Period';
      this.ASSET_IDENTIFIER = 'AssetIdentifier';
      this.EVENT_STREAM = 'EventStream';
      this.ID = 'id';
      this.PROFILES = 'profiles';
      this.SERVICE_LOCATION = 'serviceLocation';
      this.RANGE = 'range';
      this.INDEX = 'index';
      this.MEDIA = 'media';
      this.BYTE_RANGE = 'byteRange';
      this.INDEX_RANGE = 'indexRange';
      this.MEDIA_RANGE = 'mediaRange';
      this.VALUE = 'value';
      this.CONTENT_TYPE = 'contentType';
      this.MIME_TYPE = 'mimeType';
      this.BITSTREAM_SWITCHING = 'BitstreamSwitching';
      this.BITSTREAM_SWITCHING_MINUS = 'bitstreamSwitching';
      this.CODECS = 'codecs';
      this.DEPENDENCY_ID = 'dependencyId';
      this.MEDIA_STREAM_STRUCTURE_ID = 'mediaStreamStructureId';
      this.METRICS = 'Metrics';
      this.METRICS_MINUS = 'metrics';
      this.REPORTING = 'Reporting';
      this.WIDTH = 'width';
      this.HEIGHT = 'height';
      this.SAR = 'sar';
      this.FRAMERATE = 'frameRate';
      this.AUDIO_SAMPLING_RATE = 'audioSamplingRate';
      this.MAXIMUM_SAP_PERIOD = 'maximumSAPPeriod';
      this.START_WITH_SAP = 'startWithSAP';
      this.MAX_PLAYOUT_RATE = 'maxPlayoutRate';
      this.CODING_DEPENDENCY = 'codingDependency';
      this.SCAN_TYPE = 'scanType';
      this.FRAME_PACKING = 'FramePacking';
      this.AUDIO_CHANNEL_CONFIGURATION = 'AudioChannelConfiguration';
      this.CONTENT_PROTECTION = 'ContentProtection';
      this.ESSENTIAL_PROPERTY = 'EssentialProperty';
      this.SUPPLEMENTAL_PROPERTY = 'SupplementalProperty';
      this.INBAND_EVENT_STREAM = 'InbandEventStream';
      this.PRODUCER_REFERENCE_TIME = 'ProducerReferenceTime';
      this.ACCESSIBILITY = 'Accessibility';
      this.ROLE = 'Role';
      this.RATING = 'Rating';
      this.CONTENT_COMPONENT = 'ContentComponent';
      this.SUBSET = 'Subset';
      this.LANG = 'lang';
      this.VIEWPOINT = 'Viewpoint';
      this.ROLE_ASARRAY = 'Role_asArray';
      this.REPRESENTATION_ASARRAY = 'Representation_asArray';
      this.PRODUCERREFERENCETIME_ASARRAY = 'ProducerReferenceTime_asArray';
      this.ACCESSIBILITY_ASARRAY = 'Accessibility_asArray';
      this.AUDIOCHANNELCONFIGURATION_ASARRAY = 'AudioChannelConfiguration_asArray';
      this.CONTENTPROTECTION_ASARRAY = 'ContentProtection_asArray';
      this.MAIN = 'main';
      this.DYNAMIC = 'dynamic';
      this.STATIC = 'static';
      this.MEDIA_PRESENTATION_DURATION = 'mediaPresentationDuration';
      this.MINIMUM_UPDATE_PERIOD = 'minimumUpdatePeriod';
      this.CODEC_PRIVATE_DATA = 'codecPrivateData';
      this.BANDWITH = 'bandwidth';
      this.SOURCE_URL = 'sourceURL';
      this.TIMESCALE = 'timescale';
      this.DURATION = 'duration';
      this.START_NUMBER = 'startNumber';
      this.PRESENTATION_TIME_OFFSET = 'presentationTimeOffset';
      this.AVAILABILITY_START_TIME = 'availabilityStartTime';
      this.AVAILABILITY_END_TIME = 'availabilityEndTime';
      this.TIMESHIFT_BUFFER_DEPTH = 'timeShiftBufferDepth';
      this.MAX_SEGMENT_DURATION = 'maxSegmentDuration';
      this.PRESENTATION_TIME = 'presentationTime';
      this.MIN_BUFFER_TIME = 'minBufferTime';
      this.MAX_SUBSEGMENT_DURATION = 'maxSubsegmentDuration';
      this.START = 'start';
      this.AVAILABILITY_TIME_OFFSET = 'availabilityTimeOffset';
      this.AVAILABILITY_TIME_COMPLETE = 'availabilityTimeComplete';
      this.CENC_DEFAULT_KID = 'cenc:default_KID';
      this.DVB_PRIORITY = 'dvb:priority';
      this.DVB_WEIGHT = 'dvb:weight';
      this.SUGGESTED_PRESENTATION_DELAY = 'suggestedPresentationDelay';
      this.SERVICE_DESCRIPTION = 'ServiceDescription';
      this.SERVICE_DESCRIPTION_SCOPE = 'Scope';
      this.SERVICE_DESCRIPTION_LATENCY = 'Latency';
      this.SERVICE_DESCRIPTION_PLAYBACK_RATE = 'PlaybackRate';
      this.SERVICE_DESCRIPTION_OPERATING_QUALITY = 'OperatingQuality';
      this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH = 'OperatingBandwidth';
      this.PATCH_LOCATION = 'PatchLocation';
      this.PUBLISH_TIME = 'publishTime';
      this.ORIGINAL_PUBLISH_TIME = 'originalPublishTime';
      this.ORIGINAL_MPD_ID = 'mpdId';
      this.WALL_CLOCK_TIME = 'wallClockTime';
      this.PRESENTATION_TIME = 'presentationTime';
    }
  }]);

  return DashConstants;
}();

var constants = new DashConstants();
/* harmony default export */ __webpack_exports__["default"] = (constants);

/***/ }),

/***/ "./src/dash/controllers/RepresentationController.js":
/*!**********************************************************!*\
  !*** ./src/dash/controllers/RepresentationController.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_781692__) {

"use strict";
__nested_webpack_require_781692__.r(__webpack_exports__);
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_781692__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_781692__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_781692__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_781692__(/*! ../utils/SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */





function RepresentationController(config) {
  config = config || {};
  var eventBus = config.eventBus;
  var events = config.events;
  var abrController = config.abrController;
  var dashMetrics = config.dashMetrics;
  var playbackController = config.playbackController;
  var timelineConverter = config.timelineConverter;
  var type = config.type;
  var streamInfo = config.streamInfo;
  var dashConstants = config.dashConstants;
  var segmentsController = config.segmentsController;
  var isDynamic = config.isDynamic;
  var instance, realAdaptation, updating, voAvailableRepresentations, currentVoRepresentation;

  function setup() {
    resetInitialSettings();
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].MANIFEST_VALIDITY_CHANGED, onManifestValidityChanged, instance);
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getType() {
    return type;
  }

  function checkConfig() {
    if (!abrController || !dashMetrics || !playbackController || !timelineConverter) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getData() {
    return realAdaptation;
  }

  function isUpdating() {
    return updating;
  }

  function getCurrentRepresentation() {
    return currentVoRepresentation;
  }

  function resetInitialSettings() {
    realAdaptation = null;
    updating = true;
    voAvailableRepresentations = [];
  }

  function reset() {
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].MANIFEST_VALIDITY_CHANGED, onManifestValidityChanged, instance);
    resetInitialSettings();
  }

  function updateData(newRealAdaptation, availableRepresentations, type, isFragmented, quality) {
    checkConfig();
    updating = true;
    voAvailableRepresentations = availableRepresentations;
    var rep = getRepresentationForQuality(quality);

    _setCurrentVoRepresentation(rep);

    realAdaptation = newRealAdaptation;

    if (type !== _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO && type !== _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && (type !== _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || !isFragmented)) {
      endDataUpdate();
      return Promise.resolve();
    }

    var promises = [];

    for (var i = 0, ln = voAvailableRepresentations.length; i < ln; i++) {
      var currentRep = voAvailableRepresentations[i];
      promises.push(_updateRepresentation(currentRep));
    }

    return Promise.all(promises);
  }

  function _updateRepresentation(currentRep) {
    return new Promise(function (resolve, reject) {
      var hasInitialization = currentRep.hasInitialization();
      var hasSegments = currentRep.hasSegments(); // If representation has initialization and segments information we are done
      // otherwise, it means that a request has to be made to get initialization and/or segments information

      var promises = [];
      promises.push(segmentsController.updateInitData(currentRep, hasInitialization));
      promises.push(segmentsController.updateSegmentData(currentRep, hasSegments));
      Promise.all(promises).then(function (data) {
        if (data[0] && !data[0].error) {
          currentRep = _onInitLoaded(currentRep, data[0]);
        }

        if (data[1] && !data[1].error) {
          currentRep = _onSegmentsLoaded(currentRep, data[1]);
        }

        _setMediaFinishedInformation(currentRep);

        _onRepresentationUpdated(currentRep);

        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function _setMediaFinishedInformation(representation) {
    representation.mediaFinishedInformation = segmentsController.getMediaFinishedInformation(representation);
  }

  function _onInitLoaded(representation, e) {
    if (!e || e.error || !e.representation) {
      return representation;
    }

    return e.representation;
  }

  function _onSegmentsLoaded(representation, e) {
    if (!e || e.error) return;
    var fragments = e.segments;
    var segments = [];
    var count = 0;
    var i, len, s, seg;

    for (i = 0, len = fragments ? fragments.length : 0; i < len; i++) {
      s = fragments[i];
      seg = Object(_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_3__["getTimeBasedSegment"])(timelineConverter, isDynamic, representation, s.startTime, s.duration, s.timescale, s.media, s.mediaRange, count);

      if (seg) {
        segments.push(seg);
        seg = null;
        count++;
      }
    }

    if (segments.length > 0) {
      representation.segments = segments;
    }

    return representation;
  }

  function _addRepresentationSwitch() {
    checkConfig();
    var now = new Date();
    var currentRepresentation = getCurrentRepresentation();
    var currentVideoTimeMs = playbackController.getTime() * 1000;

    if (currentRepresentation) {
      dashMetrics.addRepresentationSwitch(currentRepresentation.adaptation.type, now, currentVideoTimeMs, currentRepresentation.id);
    }

    eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].REPRESENTATION_SWITCH, {
      mediaType: type,
      streamId: streamInfo.id,
      currentRepresentation: currentRepresentation,
      numberOfRepresentations: voAvailableRepresentations.length
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function getRepresentationForQuality(quality) {
    return quality === null || quality === undefined || quality >= voAvailableRepresentations.length ? null : voAvailableRepresentations[quality];
  }

  function getQualityForRepresentation(voRepresentation) {
    return voAvailableRepresentations.indexOf(voRepresentation);
  }

  function isAllRepresentationsUpdated() {
    for (var i = 0, ln = voAvailableRepresentations.length; i < ln; i++) {
      var segmentInfoType = voAvailableRepresentations[i].segmentInfoType;

      if (!voAvailableRepresentations[i].hasInitialization() || (segmentInfoType === dashConstants.SEGMENT_BASE || segmentInfoType === dashConstants.BASE_URL) && !voAvailableRepresentations[i].segments) {
        return false;
      }
    }

    return true;
  }

  function endDataUpdate(error) {
    updating = false;
    eventBus.trigger(events.DATA_UPDATE_COMPLETED, {
      data: realAdaptation,
      currentRepresentation: currentVoRepresentation,
      error: error
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function _onRepresentationUpdated(r) {
    if (!isUpdating()) return;
    var manifestUpdateInfo = dashMetrics.getCurrentManifestUpdate();
    var alreadyAdded = false;
    var repInfo, repSwitch;

    if (manifestUpdateInfo) {
      for (var i = 0; i < manifestUpdateInfo.representationInfo.length; i++) {
        repInfo = manifestUpdateInfo.representationInfo[i];

        if (repInfo.index === r.index && repInfo.mediaType === getType()) {
          alreadyAdded = true;
          break;
        }
      }

      if (!alreadyAdded) {
        dashMetrics.addManifestUpdateRepresentationInfo(r, getType());
      }
    }

    if (isAllRepresentationsUpdated()) {
      abrController.setPlaybackQuality(type, streamInfo, getQualityForRepresentation(currentVoRepresentation));
      var dvrInfo = dashMetrics.getCurrentDVRInfo(type);

      if (dvrInfo) {
        dashMetrics.updateManifestUpdateInfo({
          latency: dvrInfo.range.end - playbackController.getTime()
        });
      }

      repSwitch = dashMetrics.getCurrentRepresentationSwitch(getCurrentRepresentation().adaptation.type);

      if (!repSwitch) {
        _addRepresentationSwitch();
      }

      endDataUpdate();
    }
  }

  function prepareQualityChange(newQuality) {
    var newRep = getRepresentationForQuality(newQuality);

    _setCurrentVoRepresentation(newRep);

    _addRepresentationSwitch();
  }

  function _setCurrentVoRepresentation(value) {
    currentVoRepresentation = value;
  }

  function onManifestValidityChanged(e) {
    if (e.newDuration) {
      var representation = getCurrentRepresentation();

      if (representation && representation.adaptation.period) {
        var period = representation.adaptation.period;
        period.duration = e.newDuration;
      }
    }
  }

  instance = {
    getStreamId: getStreamId,
    getType: getType,
    getData: getData,
    isUpdating: isUpdating,
    updateData: updateData,
    getCurrentRepresentation: getCurrentRepresentation,
    getRepresentationForQuality: getRepresentationForQuality,
    prepareQualityChange: prepareQualityChange,
    reset: reset
  };
  setup();
  return instance;
}

RepresentationController.__dashjs_factory_name = 'RepresentationController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(RepresentationController));

/***/ }),

/***/ "./src/dash/controllers/SegmentBaseController.js":
/*!*******************************************************!*\
  !*** ./src/dash/controllers/SegmentBaseController.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_793902__) {

"use strict";
__nested_webpack_require_793902__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_793902__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _SegmentBaseLoader__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_793902__(/*! ../SegmentBaseLoader */ "./src/dash/SegmentBaseLoader.js");
/* harmony import */ var _WebmSegmentBaseLoader__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_793902__(/*! ../WebmSegmentBaseLoader */ "./src/dash/WebmSegmentBaseLoader.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function SegmentBaseController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus;
  var events = config.events;
  var dashMetrics = config.dashMetrics;
  var mediaPlayerModel = config.mediaPlayerModel;
  var errHandler = config.errHandler;
  var baseURLController = config.baseURLController;
  var debug = config.debug;
  var boxParser = config.boxParser;
  var requestModifier = config.requestModifier;
  var errors = config.errors;
  var instance, segmentBaseLoader, webmSegmentBaseLoader;

  function setup() {
    segmentBaseLoader = Object(_SegmentBaseLoader__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
    webmSegmentBaseLoader = Object(_WebmSegmentBaseLoader__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
    segmentBaseLoader.setConfig({
      baseURLController: baseURLController,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      errHandler: errHandler,
      eventBus: eventBus,
      events: events,
      errors: errors,
      debug: debug,
      boxParser: boxParser,
      requestModifier: requestModifier
    });
    webmSegmentBaseLoader.setConfig({
      baseURLController: baseURLController,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      errHandler: errHandler,
      eventBus: eventBus,
      events: events,
      errors: errors,
      debug: debug,
      requestModifier: requestModifier
    });
  }

  function isWebM(mimeType) {
    var type = mimeType ? mimeType.split('/')[1] : '';
    return 'webm' === type.toLowerCase();
  }

  function initialize() {
    segmentBaseLoader.initialize();
    webmSegmentBaseLoader.initialize();
  }

  function getSegmentBaseInitSegment(data) {
    if (isWebM(data.representation.mimeType)) {
      return webmSegmentBaseLoader.loadInitialization(data.representation, data.mediaType);
    } else {
      return segmentBaseLoader.loadInitialization(data.representation, data.mediaType);
    }
  }

  function getSegmentList(e) {
    if (isWebM(e.mimeType)) {
      return webmSegmentBaseLoader.loadSegments(e.representation, e.mediaType, e.representation ? e.representation.indexRange : null);
    } else {
      return segmentBaseLoader.loadSegments(e.representation, e.mediaType, e.representation ? e.representation.indexRange : null);
    }
  }

  function reset() {
    segmentBaseLoader.reset();
    webmSegmentBaseLoader.reset();
  }

  instance = {
    initialize: initialize,
    getSegmentBaseInitSegment: getSegmentBaseInitSegment,
    getSegmentList: getSegmentList,
    reset: reset
  };
  setup();
  return instance;
}

SegmentBaseController.__dashjs_factory_name = 'SegmentBaseController';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(SegmentBaseController);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/controllers/SegmentsController.js":
/*!****************************************************!*\
  !*** ./src/dash/controllers/SegmentsController.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_799669__) {

"use strict";
__nested_webpack_require_799669__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_799669__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _utils_TimelineSegmentsGetter__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_799669__(/*! ../utils/TimelineSegmentsGetter */ "./src/dash/utils/TimelineSegmentsGetter.js");
/* harmony import */ var _utils_TemplateSegmentsGetter__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_799669__(/*! ../utils/TemplateSegmentsGetter */ "./src/dash/utils/TemplateSegmentsGetter.js");
/* harmony import */ var _utils_ListSegmentsGetter__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_799669__(/*! ../utils/ListSegmentsGetter */ "./src/dash/utils/ListSegmentsGetter.js");
/* harmony import */ var _utils_SegmentBaseGetter__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_799669__(/*! ../utils/SegmentBaseGetter */ "./src/dash/utils/SegmentBaseGetter.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function SegmentsController(config) {
  config = config || {};
  var context = this.context;
  var dashConstants = config.dashConstants;
  var type = config.type;
  var segmentBaseController = config.segmentBaseController;
  var instance, getters;

  function setup() {
    getters = {};
  }

  function initialize(isDynamic) {
    getters[dashConstants.SEGMENT_TIMELINE] = Object(_utils_TimelineSegmentsGetter__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create(config, isDynamic);
    getters[dashConstants.SEGMENT_TEMPLATE] = Object(_utils_TemplateSegmentsGetter__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create(config, isDynamic);
    getters[dashConstants.SEGMENT_LIST] = Object(_utils_ListSegmentsGetter__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create(config, isDynamic);
    getters[dashConstants.SEGMENT_BASE] = Object(_utils_SegmentBaseGetter__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create(config, isDynamic);
  }

  function updateInitData(voRepresentation, hasInitialization) {
    if (hasInitialization) {
      return Promise.resolve();
    }

    return segmentBaseController.getSegmentBaseInitSegment({
      representation: voRepresentation,
      mediaType: type
    });
  }

  function updateSegmentData(voRepresentation, hasSegments) {
    if (hasSegments) {
      return Promise.resolve();
    }

    return segmentBaseController.getSegmentList({
      mimeType: voRepresentation.mimeType,
      representation: voRepresentation,
      mediaType: type
    });
  }

  function getSegmentsGetter(representation) {
    return representation ? representation.segments ? getters[dashConstants.SEGMENT_BASE] : getters[representation.segmentInfoType] : null;
  }

  function getSegmentByIndex(representation, index, lastSegmentTime) {
    var getter = getSegmentsGetter(representation);
    return getter ? getter.getSegmentByIndex(representation, index, lastSegmentTime) : null;
  }

  function getSegmentByTime(representation, time) {
    var getter = getSegmentsGetter(representation);
    return getter ? getter.getSegmentByTime(representation, time) : null;
  }

  function getMediaFinishedInformation(representation) {
    var getter = getSegmentsGetter(representation);
    return getter ? getter.getMediaFinishedInformation(representation) : {
      numberOfSegments: 0,
      mediaTimeOfLastSignaledSegment: NaN
    };
  }

  instance = {
    initialize: initialize,
    updateInitData: updateInitData,
    updateSegmentData: updateSegmentData,
    getSegmentByIndex: getSegmentByIndex,
    getSegmentByTime: getSegmentByTime,
    getMediaFinishedInformation: getMediaFinishedInformation
  };
  setup();
  return instance;
}

SegmentsController.__dashjs_factory_name = 'SegmentsController';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(SegmentsController);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/models/DashManifestModel.js":
/*!**********************************************!*\
  !*** ./src/dash/models/DashManifestModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_805842__) {

"use strict";
__nested_webpack_require_805842__.r(__webpack_exports__);
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_805842__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_805842__(/*! ../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _vo_Representation__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_805842__(/*! ../vo/Representation */ "./src/dash/vo/Representation.js");
/* harmony import */ var _vo_AdaptationSet__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_805842__(/*! ../vo/AdaptationSet */ "./src/dash/vo/AdaptationSet.js");
/* harmony import */ var _vo_Period__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_805842__(/*! ../vo/Period */ "./src/dash/vo/Period.js");
/* harmony import */ var _vo_Mpd__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_805842__(/*! ../vo/Mpd */ "./src/dash/vo/Mpd.js");
/* harmony import */ var _vo_UTCTiming__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_805842__(/*! ../vo/UTCTiming */ "./src/dash/vo/UTCTiming.js");
/* harmony import */ var _vo_Event__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_805842__(/*! ../vo/Event */ "./src/dash/vo/Event.js");
/* harmony import */ var _vo_BaseURL__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_805842__(/*! ../vo/BaseURL */ "./src/dash/vo/BaseURL.js");
/* harmony import */ var _vo_EventStream__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_805842__(/*! ../vo/EventStream */ "./src/dash/vo/EventStream.js");
/* harmony import */ var _vo_ProducerReferenceTime__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_805842__(/*! ../vo/ProducerReferenceTime */ "./src/dash/vo/ProducerReferenceTime.js");
/* harmony import */ var _streaming_utils_ObjectUtils__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_805842__(/*! ../../streaming/utils/ObjectUtils */ "./src/streaming/utils/ObjectUtils.js");
/* harmony import */ var _streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_805842__(/*! ../../streaming/utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_805842__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_805842__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_15__ = __nested_webpack_require_805842__(/*! ../../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_16__ = __nested_webpack_require_805842__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _streaming_thumbnail_ThumbnailTracks__WEBPACK_IMPORTED_MODULE_17__ = __nested_webpack_require_805842__(/*! ../../streaming/thumbnail/ThumbnailTracks */ "./src/streaming/thumbnail/ThumbnailTracks.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



















function DashManifestModel() {
  var instance, logger, errHandler, BASE64;
  var context = this.context;
  var urlUtils = Object(_streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_12__["default"])(context).getInstance();

  var isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_14__["default"])(context).getInstance().getLogger(instance);
  }

  function getIsTypeOf(adaptation, type) {
    if (!adaptation) {
      throw new Error('adaptation is not defined');
    }

    if (!type) {
      throw new Error('type is not defined');
    } // Check for thumbnail images


    if (adaptation.Representation_asArray && adaptation.Representation_asArray.length) {
      var essentialProperties = getEssentialPropertiesForRepresentation(adaptation.Representation_asArray[0]);

      if (essentialProperties && essentialProperties.length > 0 && _streaming_thumbnail_ThumbnailTracks__WEBPACK_IMPORTED_MODULE_17__["THUMBNAILS_SCHEME_ID_URIS"].indexOf(essentialProperties[0].schemeIdUri) >= 0) {
        return type === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE;
      }
    } // Check ContentComponent.contentType


    if (adaptation.ContentComponent_asArray && adaptation.ContentComponent_asArray.length > 0) {
      if (adaptation.ContentComponent_asArray.length > 1) {
        return type === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MUXED;
      } else if (adaptation.ContentComponent_asArray[0].contentType === type) {
        return true;
      }
    }

    var mimeTypeRegEx = type === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT ? new RegExp('(ttml|vtt|wvtt|stpp)') : new RegExp(type); // Check codecs

    if (adaptation.Representation_asArray && adaptation.Representation_asArray.length) {
      var codecs = adaptation.Representation_asArray[0].codecs;

      if (mimeTypeRegEx.test(codecs)) {
        return true;
      }
    } // Check Adaptation's mimeType


    if (adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE)) {
      return mimeTypeRegEx.test(adaptation.mimeType);
    } // Check Representation's mimeType


    if (adaptation.Representation_asArray) {
      var representation;

      for (var i = 0; i < adaptation.Representation_asArray.length; i++) {
        representation = adaptation.Representation_asArray[i];

        if (representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE)) {
          return mimeTypeRegEx.test(representation.mimeType);
        }
      }
    }

    return false;
  }

  function getIsFragmented(adaptation) {
    if (!adaptation) {
      throw new Error('adaptation is not defined');
    }

    if (adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE) || adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE) || adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST) || adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE)) {
      return true;
    }

    if (adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0) {
      var representation = adaptation.Representation_asArray[0];

      if (representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE) || representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE) || representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST) || representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE)) {
        return true;
      }
    }

    return false;
  }

  function getIsAudio(adaptation) {
    return getIsTypeOf(adaptation, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO);
  }

  function getIsVideo(adaptation) {
    return getIsTypeOf(adaptation, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO);
  }

  function getIsText(adaptation) {
    return getIsTypeOf(adaptation, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
  }

  function getIsMuxed(adaptation) {
    return getIsTypeOf(adaptation, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MUXED);
  }

  function getIsImage(adaptation) {
    return getIsTypeOf(adaptation, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE);
  }

  function getProducerReferenceTimesForAdaptation(adaptation) {
    var prtArray = adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRODUCERREFERENCETIME_ASARRAY) ? adaptation[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRODUCERREFERENCETIME_ASARRAY] : []; // ProducerReferenceTime elements can also be contained in Representations

    var representationsArray = adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION_ASARRAY) ? adaptation[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION_ASARRAY] : [];
    representationsArray.forEach(function (rep) {
      if (rep.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRODUCERREFERENCETIME_ASARRAY)) {
        prtArray.push.apply(prtArray, _toConsumableArray(rep[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRODUCERREFERENCETIME_ASARRAY]));
      }
    });
    var prtsForAdaptation = []; // Unlikely to have multiple ProducerReferenceTimes.

    prtArray.forEach(function (prt) {
      var entry = new _vo_ProducerReferenceTime__WEBPACK_IMPORTED_MODULE_10__["default"]();

      if (prt.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID)) {
        entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID] = prt[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID];
      } else {
        // Ignore. Missing mandatory attribute
        return;
      }

      if (prt.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WALL_CLOCK_TIME)) {
        entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WALL_CLOCK_TIME] = prt[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WALL_CLOCK_TIME];
      } else {
        // Ignore. Missing mandatory attribute
        return;
      }

      if (prt.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME)) {
        entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME] = prt[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME];
      } else {
        // Ignore. Missing mandatory attribute
        return;
      } // Not interested in other attributes for now
      // UTC element contained must be same as that in the MPD


      prtsForAdaptation.push(entry);
    });
    return prtsForAdaptation;
  }

  function getLanguageForAdaptation(adaptation) {
    var lang = '';

    if (adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].LANG)) {
      //Filter out any other characters not allowed according to RFC5646
      lang = adaptation.lang.replace(/[^A-Za-z0-9-]/g, '');
    }

    return lang;
  }

  function getViewpointForAdaptation(adaptation) {
    return adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VIEWPOINT) ? adaptation.Viewpoint : null;
  }

  function getRolesForAdaptation(adaptation) {
    return adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ROLE_ASARRAY) ? adaptation.Role_asArray : [];
  }

  function getAccessibilityForAdaptation(adaptation) {
    return adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ACCESSIBILITY_ASARRAY) ? adaptation.Accessibility_asArray : [];
  }

  function getAudioChannelConfigurationForAdaptation(adaptation) {
    return adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIOCHANNELCONFIGURATION_ASARRAY) ? adaptation.AudioChannelConfiguration_asArray : [];
  }

  function getAudioChannelConfigurationForRepresentation(representation) {
    return representation && representation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIOCHANNELCONFIGURATION_ASARRAY) ? representation.AudioChannelConfiguration_asArray : [];
  }

  function getRepresentationSortFunction() {
    return function (a, b) {
      return a.bandwidth - b.bandwidth;
    };
  }

  function processAdaptation(realAdaptation) {
    if (realAdaptation && Array.isArray(realAdaptation.Representation_asArray)) {
      realAdaptation.Representation_asArray.sort(getRepresentationSortFunction());
    }

    return realAdaptation;
  }

  function getRealAdaptations(manifest, periodIndex) {
    return manifest && manifest.Period_asArray && isInteger(periodIndex) ? manifest.Period_asArray[periodIndex] ? manifest.Period_asArray[periodIndex].AdaptationSet_asArray : [] : [];
  }

  function getRealPeriods(manifest) {
    return manifest && manifest.Period_asArray ? manifest.Period_asArray : [];
  }

  function getRealPeriodForIndex(index, manifest) {
    var realPeriods = getRealPeriods(manifest);

    if (realPeriods.length > 0 && isInteger(index)) {
      return realPeriods[index];
    } else {
      return null;
    }
  }

  function getAdaptationForId(id, manifest, periodIndex) {
    var realAdaptations = getRealAdaptations(manifest, periodIndex);
    var i, len;

    for (i = 0, len = realAdaptations.length; i < len; i++) {
      if (realAdaptations[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID) && realAdaptations[i].id === id) {
        return realAdaptations[i];
      }
    }

    return null;
  }

  function getAdaptationForIndex(index, manifest, periodIndex) {
    var realAdaptations = getRealAdaptations(manifest, periodIndex);

    if (realAdaptations.length > 0 && isInteger(index)) {
      return realAdaptations[index];
    } else {
      return null;
    }
  }

  function getIndexForAdaptation(realAdaptation, manifest, periodIndex) {
    if (!realAdaptation) {
      return -1;
    }

    var realAdaptations = getRealAdaptations(manifest, periodIndex);

    for (var i = 0; i < realAdaptations.length; i++) {
      var objectUtils = Object(_streaming_utils_ObjectUtils__WEBPACK_IMPORTED_MODULE_11__["default"])(context).getInstance();

      if (objectUtils.areEqual(realAdaptations[i], realAdaptation)) {
        return i;
      }
    }

    return -1;
  }

  function getAdaptationsForType(manifest, periodIndex, type) {
    var realAdaptations = getRealAdaptations(manifest, periodIndex);
    var i, len;
    var adaptations = [];

    for (i = 0, len = realAdaptations.length; i < len; i++) {
      if (getIsTypeOf(realAdaptations[i], type)) {
        adaptations.push(processAdaptation(realAdaptations[i]));
      }
    }

    return adaptations;
  }

  function getCodec(adaptation, representationId, addResolutionInfo) {
    var codec = null;

    if (adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0) {
      var representation = isInteger(representationId) && representationId >= 0 && representationId < adaptation.Representation_asArray.length ? adaptation.Representation_asArray[representationId] : adaptation.Representation_asArray[0];

      if (representation) {
        codec = representation.mimeType + ';codecs="' + representation.codecs + '"';

        if (addResolutionInfo && representation.width !== undefined) {
          codec += ';width="' + representation.width + '";height="' + representation.height + '"';
        }
      }
    } // If the codec contains a profiles parameter we remove it. Otherwise it will cause problems when checking for codec capabilities of the platform


    if (codec) {
      codec = codec.replace(/\sprofiles=[^;]*/g, '');
    }

    return codec;
  }

  function getMimeType(adaptation) {
    return adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0 ? adaptation.Representation_asArray[0].mimeType : null;
  }

  function getKID(adaptation) {
    if (!adaptation || !adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CENC_DEFAULT_KID)) {
      return null;
    }

    return adaptation[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CENC_DEFAULT_KID];
  }

  function getLabelsForAdaptation(adaptation) {
    if (!adaptation || !Array.isArray(adaptation.Label_asArray)) {
      return [];
    }

    var labelArray = [];

    for (var i = 0; i < adaptation.Label_asArray.length; i++) {
      labelArray.push({
        lang: adaptation.Label_asArray[i].lang,
        text: adaptation.Label_asArray[i].__text || adaptation.Label_asArray[i]
      });
    }

    return labelArray;
  }

  function getContentProtectionData(adaptation) {
    if (!adaptation || !adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENTPROTECTION_ASARRAY) || adaptation.ContentProtection_asArray.length === 0) {
      return null;
    }

    return adaptation.ContentProtection_asArray;
  }

  function getIsDynamic(manifest) {
    var isDynamic = false;

    if (manifest && manifest.hasOwnProperty('type')) {
      isDynamic = manifest.type === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DYNAMIC;
    }

    return isDynamic;
  }

  function getId(manifest) {
    return manifest && manifest[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID] || null;
  }

  function hasProfile(manifest, profile) {
    var has = false;

    if (manifest && manifest.profiles && manifest.profiles.length > 0) {
      has = manifest.profiles.indexOf(profile) !== -1;
    }

    return has;
  }

  function getDuration(manifest) {
    var mpdDuration; //@mediaPresentationDuration specifies the duration of the entire Media Presentation.
    //If the attribute is not present, the duration of the Media Presentation is unknown.

    if (manifest && manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA_PRESENTATION_DURATION)) {
      mpdDuration = manifest.mediaPresentationDuration;
    } else if (manifest && manifest.type == 'dynamic') {
      mpdDuration = Number.POSITIVE_INFINITY;
    } else {
      mpdDuration = Number.MAX_SAFE_INTEGER || Number.MAX_VALUE;
    }

    return mpdDuration;
  }

  function getBandwidth(representation) {
    return representation && representation.bandwidth ? representation.bandwidth : NaN;
  }

  function getManifestUpdatePeriod(manifest) {
    var latencyOfLastUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var delay = NaN;

    if (manifest && manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MINIMUM_UPDATE_PERIOD)) {
      delay = manifest.minimumUpdatePeriod;
    }

    return isNaN(delay) ? delay : Math.max(delay - latencyOfLastUpdate, 1);
  }

  function getPublishTime(manifest) {
    return manifest && manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PUBLISH_TIME) ? new Date(manifest[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PUBLISH_TIME]) : null;
  }

  function getRepresentationCount(adaptation) {
    return adaptation && Array.isArray(adaptation.Representation_asArray) ? adaptation.Representation_asArray.length : 0;
  }

  function getBitrateListForAdaptation(realAdaptation) {
    var processedRealAdaptation = processAdaptation(realAdaptation);
    var realRepresentations = processedRealAdaptation && Array.isArray(processedRealAdaptation.Representation_asArray) ? processedRealAdaptation.Representation_asArray : [];
    return realRepresentations.map(function (realRepresentation) {
      return {
        bandwidth: realRepresentation.bandwidth,
        width: realRepresentation.width || 0,
        height: realRepresentation.height || 0,
        scanType: realRepresentation.scanType || null,
        id: realRepresentation.id || null
      };
    });
  }

  function getSelectionPriority(realAdaption) {
    try {
      var priority = realAdaption && typeof realAdaption.selectionPriority !== 'undefined' ? parseInt(realAdaption.selectionPriority) : 1;
      return isNaN(priority) ? 1 : priority;
    } catch (e) {
      return 1;
    }
  }

  function getEssentialPropertiesForRepresentation(realRepresentation) {
    if (!realRepresentation || !realRepresentation.EssentialProperty_asArray || !realRepresentation.EssentialProperty_asArray.length) return null;
    return realRepresentation.EssentialProperty_asArray.map(function (prop) {
      return {
        schemeIdUri: prop.schemeIdUri,
        value: prop.value
      };
    });
  }

  function getRepresentationFor(index, adaptation) {
    return adaptation && adaptation.Representation_asArray && adaptation.Representation_asArray.length > 0 && isInteger(index) ? adaptation.Representation_asArray[index] : null;
  }

  function getRealAdaptationFor(voAdaptation) {
    if (voAdaptation && voAdaptation.period && isInteger(voAdaptation.period.index)) {
      var periodArray = voAdaptation.period.mpd.manifest.Period_asArray[voAdaptation.period.index];

      if (periodArray && periodArray.AdaptationSet_asArray && isInteger(voAdaptation.index)) {
        return processAdaptation(periodArray.AdaptationSet_asArray[voAdaptation.index]);
      }
    }
  }

  function getRepresentationsForAdaptation(voAdaptation) {
    var voRepresentations = [];
    var processedRealAdaptation = getRealAdaptationFor(voAdaptation);
    var segmentInfo, baseUrl;

    if (processedRealAdaptation && processedRealAdaptation.Representation_asArray) {
      // TODO: TO BE REMOVED. We should get just the baseUrl elements that affects to the representations
      // that we are processing. Making it works properly will require much further changes and given
      // parsing base Urls parameters is needed for our ultra low latency examples, we will
      // keep this "tricky" code until the real (and good) solution comes
      if (voAdaptation && voAdaptation.period && isInteger(voAdaptation.period.index)) {
        var baseUrls = getBaseURLsFromElement(voAdaptation.period.mpd.manifest);

        if (baseUrls) {
          baseUrl = baseUrls[0];
        }
      }

      for (var i = 0, len = processedRealAdaptation.Representation_asArray.length; i < len; ++i) {
        var realRepresentation = processedRealAdaptation.Representation_asArray[i];
        var voRepresentation = new _vo_Representation__WEBPACK_IMPORTED_MODULE_2__["default"]();
        voRepresentation.index = i;
        voRepresentation.adaptation = voAdaptation;

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID)) {
          voRepresentation.id = realRepresentation.id;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CODECS)) {
          voRepresentation.codecs = realRepresentation.codecs;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE)) {
          voRepresentation.mimeType = realRepresentation[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE];
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CODEC_PRIVATE_DATA)) {
          voRepresentation.codecPrivateData = realRepresentation.codecPrivateData;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BANDWITH)) {
          voRepresentation.bandwidth = realRepresentation.bandwidth;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WIDTH)) {
          voRepresentation.width = realRepresentation.width;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].HEIGHT)) {
          voRepresentation.height = realRepresentation.height;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SCAN_TYPE)) {
          voRepresentation.scanType = realRepresentation.scanType;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_PLAYOUT_RATE)) {
          voRepresentation.maxPlayoutRate = realRepresentation.maxPlayoutRate;
        }

        if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE)) {
          segmentInfo = realRepresentation.SegmentBase;
          voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE;
        } else if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST)) {
          segmentInfo = realRepresentation.SegmentList;

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE)) {
            voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE;
          } else {
            voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST;
          }
        } else if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE)) {
          segmentInfo = realRepresentation.SegmentTemplate;

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE)) {
            voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE;
          } else {
            voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INITIALIZATION_MINUS)) {
            voRepresentation.initialization = segmentInfo.initialization.split('$Bandwidth$').join(realRepresentation.bandwidth).split('$RepresentationID$').join(realRepresentation.id);
          }
        } else {
          voRepresentation.segmentInfoType = _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BASE_URL;
        }

        voRepresentation.essentialProperties = getEssentialPropertiesForRepresentation(realRepresentation);

        if (segmentInfo) {
          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INITIALIZATION)) {
            var initialization = segmentInfo.Initialization;

            if (initialization.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SOURCE_URL)) {
              voRepresentation.initialization = initialization.sourceURL;
            }

            if (initialization.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].RANGE)) {
              voRepresentation.range = initialization.range; // initialization source url will be determined from
              // BaseURL when resolved at load time.
            }
          } else if (getIsText(processedRealAdaptation) && getIsFragmented(processedRealAdaptation) && processedRealAdaptation.mimeType && processedRealAdaptation.mimeType.indexOf('application/mp4') === -1) {
            voRepresentation.range = 0;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TIMESCALE)) {
            voRepresentation.timescale = segmentInfo.timescale;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DURATION)) {
            // TODO according to the spec @maxSegmentDuration specifies the maximum duration of any Segment in any Representation in the Media Presentation
            // It is also said that for a SegmentTimeline any @d value shall not exceed the value of MPD@maxSegmentDuration, but nothing is said about
            // SegmentTemplate @duration attribute. We need to find out if @maxSegmentDuration should be used instead of calculated duration if the the duration
            // exceeds @maxSegmentDuration
            voRepresentation.segmentDuration = segmentInfo.duration / voRepresentation.timescale;
          } else if (realRepresentation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE)) {
            segmentInfo = realRepresentation.SegmentTemplate;

            if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE)) {
              voRepresentation.segmentDuration = calcSegmentDuration(segmentInfo.SegmentTimeline) / voRepresentation.timescale;
            }
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA)) {
            voRepresentation.media = segmentInfo.media;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].START_NUMBER)) {
            voRepresentation.startNumber = segmentInfo.startNumber;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX_RANGE)) {
            voRepresentation.indexRange = segmentInfo.indexRange;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME_OFFSET)) {
            voRepresentation.presentationTimeOffset = segmentInfo.presentationTimeOffset / voRepresentation.timescale;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_OFFSET)) {
            voRepresentation.availabilityTimeOffset = segmentInfo.availabilityTimeOffset;
          } else if (baseUrl && baseUrl.availabilityTimeOffset !== undefined) {
            voRepresentation.availabilityTimeOffset = baseUrl.availabilityTimeOffset;
          }

          if (segmentInfo.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_COMPLETE)) {
            voRepresentation.availabilityTimeComplete = segmentInfo.availabilityTimeComplete !== 'false';
          } else if (baseUrl && baseUrl.availabilityTimeComplete !== undefined) {
            voRepresentation.availabilityTimeComplete = baseUrl.availabilityTimeComplete;
          }
        }

        voRepresentation.MSETimeOffset = calcMSETimeOffset(voRepresentation);
        voRepresentation.path = [voAdaptation.period.index, voAdaptation.index, i];
        voRepresentations.push(voRepresentation);
      }
    }

    return voRepresentations;
  }

  function calcSegmentDuration(segmentTimeline) {
    if (!segmentTimeline || !segmentTimeline.S_asArray) {
      return NaN;
    }

    var s0 = segmentTimeline.S_asArray[0];
    var s1 = segmentTimeline.S_asArray[1];
    return s0.hasOwnProperty('d') ? s0.d : s1.t - s0.t;
  }

  function calcMSETimeOffset(representation) {
    // The MSEOffset is offset from AST for media. It is Period@start - presentationTimeOffset
    var presentationOffset = representation.presentationTimeOffset;
    var periodStart = representation.adaptation.period.start;
    return periodStart - presentationOffset;
  }

  function getAdaptationsForPeriod(voPeriod) {
    var realPeriod = voPeriod && isInteger(voPeriod.index) ? voPeriod.mpd.manifest.Period_asArray[voPeriod.index] : null;
    var voAdaptations = [];
    var voAdaptationSet, realAdaptationSet, i;

    if (realPeriod && realPeriod.AdaptationSet_asArray) {
      for (i = 0; i < realPeriod.AdaptationSet_asArray.length; i++) {
        realAdaptationSet = realPeriod.AdaptationSet_asArray[i];
        voAdaptationSet = new _vo_AdaptationSet__WEBPACK_IMPORTED_MODULE_3__["default"]();

        if (realAdaptationSet.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID)) {
          voAdaptationSet.id = realAdaptationSet.id;
        }

        voAdaptationSet.index = i;
        voAdaptationSet.period = voPeriod;

        if (getIsMuxed(realAdaptationSet)) {
          voAdaptationSet.type = _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MUXED;
        } else if (getIsAudio(realAdaptationSet)) {
          voAdaptationSet.type = _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO;
        } else if (getIsVideo(realAdaptationSet)) {
          voAdaptationSet.type = _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO;
        } else if (getIsText(realAdaptationSet)) {
          voAdaptationSet.type = _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT;
        } else if (getIsImage(realAdaptationSet)) {
          voAdaptationSet.type = _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE;
        } else {
          logger.warn('Unknown Adaptation stream type');
        }

        voAdaptations.push(voAdaptationSet);
      }
    }

    return voAdaptations;
  }

  function getRegularPeriods(mpd) {
    var isDynamic = mpd ? getIsDynamic(mpd.manifest) : false;
    var voPeriods = [];
    var realPreviousPeriod = null;
    var realPeriod = null;
    var voPreviousPeriod = null;
    var voPeriod = null;
    var len, i;

    for (i = 0, len = mpd && mpd.manifest && mpd.manifest.Period_asArray ? mpd.manifest.Period_asArray.length : 0; i < len; i++) {
      realPeriod = mpd.manifest.Period_asArray[i]; // If the attribute @start is present in the Period, then the
      // Period is a regular Period and the PeriodStart is equal
      // to the value of this attribute.

      if (realPeriod.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].START)) {
        voPeriod = new _vo_Period__WEBPACK_IMPORTED_MODULE_4__["default"]();
        voPeriod.start = realPeriod.start;
      } // If the @start attribute is absent, but the previous Period
      // element contains a @duration attribute then then this new
      // Period is also a regular Period. The start time of the new
      // Period PeriodStart is the sum of the start time of the previous
      // Period PeriodStart and the value of the attribute @duration
      // of the previous Period.
      else if (realPreviousPeriod !== null && realPreviousPeriod.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DURATION) && voPreviousPeriod !== null) {
          voPeriod = new _vo_Period__WEBPACK_IMPORTED_MODULE_4__["default"]();
          voPeriod.start = parseFloat((voPreviousPeriod.start + voPreviousPeriod.duration).toFixed(5));
        } // If (i) @start attribute is absent, and (ii) the Period element
        // is the first in the MPD, and (iii) the MPD@type is 'static',
        // then the PeriodStart time shall be set to zero.
        else if (i === 0 && !isDynamic) {
            voPeriod = new _vo_Period__WEBPACK_IMPORTED_MODULE_4__["default"]();
            voPeriod.start = 0;
          } // The Period extends until the PeriodStart of the next Period.
      // The difference between the PeriodStart time of a Period and
      // the PeriodStart time of the following Period.


      if (voPreviousPeriod !== null && isNaN(voPreviousPeriod.duration)) {
        if (voPeriod !== null) {
          voPreviousPeriod.duration = parseFloat((voPeriod.start - voPreviousPeriod.start).toFixed(5));
        } else {
          logger.warn('First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback');
        }
      }

      if (voPeriod !== null) {
        voPeriod.id = getPeriodId(realPeriod, i);
        voPeriod.index = i;
        voPeriod.mpd = mpd;

        if (realPeriod.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DURATION)) {
          voPeriod.duration = realPeriod.duration;
        }

        if (voPreviousPeriod) {
          voPreviousPeriod.nextPeriodId = voPeriod.id;
        }

        voPeriods.push(voPeriod);
        realPreviousPeriod = realPeriod;
        voPreviousPeriod = voPeriod;
      }

      realPeriod = null;
      voPeriod = null;
    }

    if (voPeriods.length === 0) {
      return voPeriods;
    } // The last Period extends until the end of the Media Presentation.
    // The difference between the PeriodStart time of the last Period
    // and the mpd duration


    if (voPreviousPeriod !== null && isNaN(voPreviousPeriod.duration)) {
      voPreviousPeriod.duration = parseFloat((getEndTimeForLastPeriod(voPreviousPeriod) - voPreviousPeriod.start).toFixed(5));
    }

    return voPeriods;
  }

  function getPeriodId(realPeriod, i) {
    if (!realPeriod) {
      throw new Error('Period cannot be null or undefined');
    }

    var id = _vo_Period__WEBPACK_IMPORTED_MODULE_4__["default"].DEFAULT_ID + '_' + i;

    if (realPeriod.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID) && realPeriod.id.length > 0 && realPeriod.id !== '__proto__') {
      id = realPeriod.id;
    }

    return id;
  }

  function getMpd(manifest) {
    var mpd = new _vo_Mpd__WEBPACK_IMPORTED_MODULE_5__["default"]();

    if (manifest) {
      mpd.manifest = manifest;

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_START_TIME)) {
        mpd.availabilityStartTime = new Date(manifest.availabilityStartTime.getTime());
      } else {
        if (manifest.loadedTime) {
          mpd.availabilityStartTime = new Date(manifest.loadedTime.getTime());
        }
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_END_TIME)) {
        mpd.availabilityEndTime = new Date(manifest.availabilityEndTime.getTime());
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MINIMUM_UPDATE_PERIOD)) {
        mpd.minimumUpdatePeriod = manifest.minimumUpdatePeriod;
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA_PRESENTATION_DURATION)) {
        mpd.mediaPresentationDuration = manifest.mediaPresentationDuration;
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUGGESTED_PRESENTATION_DELAY)) {
        mpd.suggestedPresentationDelay = manifest.suggestedPresentationDelay;
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TIMESHIFT_BUFFER_DEPTH)) {
        mpd.timeShiftBufferDepth = manifest.timeShiftBufferDepth;
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_SEGMENT_DURATION)) {
        mpd.maxSegmentDuration = manifest.maxSegmentDuration;
      }

      if (manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PUBLISH_TIME)) {
        mpd.publishTime = new Date(manifest.publishTime);
      }
    }

    return mpd;
  }

  function checkConfig() {
    if (!errHandler || !errHandler.hasOwnProperty('error')) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getEndTimeForLastPeriod(voPeriod) {
    checkConfig();
    var isDynamic = getIsDynamic(voPeriod.mpd.manifest);
    var periodEnd;

    if (voPeriod.mpd.manifest.mediaPresentationDuration) {
      periodEnd = voPeriod.mpd.manifest.mediaPresentationDuration;
    } else if (voPeriod.duration) {
      periodEnd = voPeriod.duration;
    } else if (isDynamic) {
      periodEnd = Number.POSITIVE_INFINITY;
    } else {
      errHandler.error(new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_15__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_16__["default"].MANIFEST_ERROR_ID_PARSE_CODE, 'Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.', voPeriod));
    }

    return periodEnd;
  }

  function getEventsForPeriod(period) {
    var manifest = period && period.mpd && period.mpd.manifest ? period.mpd.manifest : null;
    var periodArray = manifest ? manifest.Period_asArray : null;
    var eventStreams = periodArray && period && isInteger(period.index) ? periodArray[period.index].EventStream_asArray : null;
    var events = [];
    var i, j;

    if (eventStreams) {
      for (i = 0; i < eventStreams.length; i++) {
        var eventStream = new _vo_EventStream__WEBPACK_IMPORTED_MODULE_9__["default"]();
        eventStream.period = period;
        eventStream.timescale = 1;

        if (eventStreams[i].hasOwnProperty(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI)) {
          eventStream.schemeIdUri = eventStreams[i][_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI];
        } else {
          throw new Error('Invalid EventStream. SchemeIdUri has to be set');
        }

        if (eventStreams[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TIMESCALE)) {
          eventStream.timescale = eventStreams[i][_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TIMESCALE];
        }

        if (eventStreams[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE)) {
          eventStream.value = eventStreams[i][_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE];
        }

        if (eventStreams[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME_OFFSET)) {
          eventStream.presentationTimeOffset = eventStreams[i][_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME_OFFSET];
        }

        for (j = 0; eventStreams[i].Event_asArray && j < eventStreams[i].Event_asArray.length; j++) {
          var currentMpdEvent = eventStreams[i].Event_asArray[j];
          var event = new _vo_Event__WEBPACK_IMPORTED_MODULE_7__["default"]();
          event.presentationTime = 0;
          event.eventStream = eventStream;

          if (currentMpdEvent.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PRESENTATION_TIME)) {
            event.presentationTime = currentMpdEvent.presentationTime;
          }

          var presentationTimeOffset = eventStream.presentationTimeOffset ? eventStream.presentationTimeOffset / eventStream.timescale : 0;
          event.calculatedPresentationTime = event.presentationTime / eventStream.timescale + period.start - presentationTimeOffset;

          if (currentMpdEvent.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DURATION)) {
            event.duration = currentMpdEvent.duration / eventStream.timescale;
          }

          if (currentMpdEvent.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID)) {
            event.id = currentMpdEvent.id;
          } else {
            event.id = null;
          }

          if (currentMpdEvent.Signal && currentMpdEvent.Signal.Binary) {
            // toString is used to manage both regular and namespaced tags
            event.messageData = BASE64.decodeArray(currentMpdEvent.Signal.Binary.toString());
          } else {
            // From Cor.1: 'NOTE: this attribute is an alternative
            // to specifying a complete XML element(s) in the Event.
            // It is useful when an event leans itself to a compact
            // string representation'.
            event.messageData = currentMpdEvent.messageData || currentMpdEvent.__cdata || currentMpdEvent.__text;
          }

          events.push(event);
        }
      }
    }

    return events;
  }

  function getEventStreams(inbandStreams, representation) {
    var eventStreams = [];
    var i;
    if (!inbandStreams) return eventStreams;

    for (i = 0; i < inbandStreams.length; i++) {
      var eventStream = new _vo_EventStream__WEBPACK_IMPORTED_MODULE_9__["default"]();
      eventStream.timescale = 1;
      eventStream.representation = representation;

      if (inbandStreams[i].hasOwnProperty(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI)) {
        eventStream.schemeIdUri = inbandStreams[i].schemeIdUri;
      } else {
        throw new Error('Invalid EventStream. SchemeIdUri has to be set');
      }

      if (inbandStreams[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TIMESCALE)) {
        eventStream.timescale = inbandStreams[i].timescale;
      }

      if (inbandStreams[i].hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE)) {
        eventStream.value = inbandStreams[i].value;
      }

      eventStreams.push(eventStream);
    }

    return eventStreams;
  }

  function getEventStreamForAdaptationSet(manifest, adaptation) {
    var inbandStreams, periodArray, adaptationArray;

    if (manifest && manifest.Period_asArray && adaptation && adaptation.period && isInteger(adaptation.period.index)) {
      periodArray = manifest.Period_asArray[adaptation.period.index];

      if (periodArray && periodArray.AdaptationSet_asArray && isInteger(adaptation.index)) {
        adaptationArray = periodArray.AdaptationSet_asArray[adaptation.index];

        if (adaptationArray) {
          inbandStreams = adaptationArray.InbandEventStream_asArray;
        }
      }
    }

    return getEventStreams(inbandStreams, null);
  }

  function getEventStreamForRepresentation(manifest, representation) {
    var inbandStreams, periodArray, adaptationArray, representationArray;

    if (manifest && manifest.Period_asArray && representation && representation.adaptation && representation.adaptation.period && isInteger(representation.adaptation.period.index)) {
      periodArray = manifest.Period_asArray[representation.adaptation.period.index];

      if (periodArray && periodArray.AdaptationSet_asArray && isInteger(representation.adaptation.index)) {
        adaptationArray = periodArray.AdaptationSet_asArray[representation.adaptation.index];

        if (adaptationArray && adaptationArray.Representation_asArray && isInteger(representation.index)) {
          representationArray = adaptationArray.Representation_asArray[representation.index];

          if (representationArray) {
            inbandStreams = representationArray.InbandEventStream_asArray;
          }
        }
      }
    }

    return getEventStreams(inbandStreams, representation);
  }

  function getUTCTimingSources(manifest) {
    var isDynamic = getIsDynamic(manifest);
    var hasAST = manifest ? manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_START_TIME) : false;
    var utcTimingsArray = manifest ? manifest.UTCTiming_asArray : null;
    var utcTimingEntries = []; // do not bother synchronizing the clock unless MPD is live,
    // or it is static and has availabilityStartTime attribute

    if (isDynamic || hasAST) {
      if (utcTimingsArray) {
        // the order is important here - 23009-1 states that the order
        // in the manifest "indicates relative preference, first having
        // the highest, and the last the lowest priority".
        utcTimingsArray.forEach(function (utcTiming) {
          var entry = new _vo_UTCTiming__WEBPACK_IMPORTED_MODULE_6__["default"]();

          if (utcTiming.hasOwnProperty(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI)) {
            entry.schemeIdUri = utcTiming.schemeIdUri;
          } else {
            // entries of type DescriptorType with no schemeIdUri
            // are meaningless. let's just ignore this entry and
            // move on.
            return;
          } // this is (incorrectly) interpreted as a number - schema
          // defines it as a string


          if (utcTiming.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE)) {
            entry.value = utcTiming.value.toString();
          } else {
            // without a value, there's not a lot we can do with
            // this entry. let's just ignore this one and move on
            return;
          } // we're not interested in the optional id or any other
          // attributes which might be attached to the entry


          utcTimingEntries.push(entry);
        });
      }
    }

    return utcTimingEntries;
  }

  function getBaseURLsFromElement(node) {
    var baseUrls = []; // if node.BaseURL_asArray and node.baseUri are undefined entries
    // will be [undefined] which entries.some will just skip

    var entries = node.BaseURL_asArray || [node.baseUri];
    var earlyReturn = false;
    entries.some(function (entry) {
      if (entry) {
        var baseUrl = new _vo_BaseURL__WEBPACK_IMPORTED_MODULE_8__["default"]();
        var text = entry.__text || entry;

        if (urlUtils.isRelative(text)) {
          // it doesn't really make sense to have relative and
          // absolute URLs at the same level, or multiple
          // relative URLs at the same level, so assume we are
          // done from this level of the MPD
          earlyReturn = true; // deal with the specific case where the MPD@BaseURL
          // is specified and is relative. when no MPD@BaseURL
          // entries exist, that case is handled by the
          // [node.baseUri] in the entries definition.

          if (node.baseUri) {
            text = urlUtils.resolve(text, node.baseUri);
          }
        }

        baseUrl.url = text; // serviceLocation is optional, but we need it in order
        // to blacklist correctly. if it's not available, use
        // anything unique since there's no relationship to any
        // other BaseURL and, in theory, the url should be
        // unique so use this instead.

        if (entry.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_LOCATION) && entry.serviceLocation.length) {
          baseUrl.serviceLocation = entry.serviceLocation;
        } else {
          baseUrl.serviceLocation = text;
        }

        if (entry.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVB_PRIORITY)) {
          baseUrl.dvb_priority = entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVB_PRIORITY];
        }

        if (entry.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVB_WEIGHT)) {
          baseUrl.dvb_weight = entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVB_WEIGHT];
        }

        if (entry.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_OFFSET)) {
          baseUrl.availabilityTimeOffset = entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_OFFSET];
        }

        if (entry.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_COMPLETE)) {
          baseUrl.availabilityTimeComplete = entry[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_TIME_COMPLETE] !== 'false';
        }
        /* NOTE: byteRange currently unused
         */


        baseUrls.push(baseUrl);
        return earlyReturn;
      }
    });
    return baseUrls;
  }

  function getLocation(manifest) {
    if (manifest && manifest.hasOwnProperty(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].LOCATION)) {
      // for now, do not support multiple Locations -
      // just set Location to the first Location.
      manifest.Location = manifest.Location_asArray[0];
      return manifest.Location;
    } // may well be undefined


    return undefined;
  }

  function getPatchLocation(manifest) {
    if (manifest && manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PATCH_LOCATION)) {
      // only include support for single patch location currently
      manifest.PatchLocation = manifest.PatchLocation_asArray[0];
      return manifest.PatchLocation;
    } // no patch location provided


    return undefined;
  }

  function getSuggestedPresentationDelay(mpd) {
    return mpd && mpd.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUGGESTED_PRESENTATION_DELAY) ? mpd.suggestedPresentationDelay : null;
  }

  function getAvailabilityStartTime(mpd) {
    return mpd && mpd.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AVAILABILITY_START_TIME) && mpd.availabilityStartTime !== null ? mpd.availabilityStartTime.getTime() : null;
  }

  function getServiceDescriptions(manifest) {
    var serviceDescriptions = [];

    if (manifest && manifest.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION)) {
      var _iterator = _createForOfIteratorHelper(manifest.ServiceDescription_asArray),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var sd = _step.value;
          // Convert each of the properties defined in
          var id = null,
              schemeIdUri = null,
              latency = null,
              playbackRate = null,
              operatingQuality = null,
              operatingBandwidth = null;

          for (var prop in sd) {
            if (sd.hasOwnProperty(prop)) {
              if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID) {
                id = sd[prop];
              } else if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION_SCOPE) {
                schemeIdUri = sd[prop].schemeIdUri;
              } else if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION_LATENCY) {
                latency = {
                  target: parseInt(sd[prop].target),
                  max: parseInt(sd[prop].max),
                  min: parseInt(sd[prop].min),
                  referenceId: parseInt(sd[prop].referenceId)
                };
              } else if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION_PLAYBACK_RATE) {
                playbackRate = {
                  max: parseFloat(sd[prop].max),
                  min: parseFloat(sd[prop].min)
                };
              } else if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION_OPERATING_QUALITY) {
                operatingQuality = {
                  mediaType: sd[prop].mediaType,
                  max: parseInt(sd[prop].max),
                  min: parseInt(sd[prop].min),
                  target: parseInt(sd[prop].target),
                  type: sd[prop].type,
                  maxQualityDifference: parseInt(sd[prop].maxQualityDifference)
                };
              } else if (prop === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_DESCRIPTION_OPERATING_BANDWIDTH) {
                operatingBandwidth = {
                  mediaType: sd[prop].mediaType,
                  max: parseInt(sd[prop].max),
                  min: parseInt(sd[prop].min),
                  target: parseInt(sd[prop].target)
                };
              }
            }
          }

          serviceDescriptions.push({
            id: id,
            schemeIdUri: schemeIdUri,
            latency: latency,
            playbackRate: playbackRate,
            operatingQuality: operatingQuality,
            operatingBandwidth: operatingBandwidth
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return serviceDescriptions;
  }

  function getSupplementalProperties(adaptation) {
    var supplementalProperties = {};

    if (adaptation && adaptation.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUPPLEMENTAL_PROPERTY)) {
      var _iterator2 = _createForOfIteratorHelper(adaptation.SupplementalProperty_asArray),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var sp = _step2.value;

          if (sp.hasOwnProperty(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI) && sp.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE)) {
            supplementalProperties[sp[_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SCHEME_ID_URI]] = sp[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return supplementalProperties;
  }

  function setConfig(config) {
    if (!config) return;

    if (config.errHandler) {
      errHandler = config.errHandler;
    }

    if (config.BASE64) {
      BASE64 = config.BASE64;
    }
  }

  instance = {
    getIsTypeOf: getIsTypeOf,
    getIsText: getIsText,
    getIsFragmented: getIsFragmented,
    getProducerReferenceTimesForAdaptation: getProducerReferenceTimesForAdaptation,
    getLanguageForAdaptation: getLanguageForAdaptation,
    getViewpointForAdaptation: getViewpointForAdaptation,
    getRolesForAdaptation: getRolesForAdaptation,
    getAccessibilityForAdaptation: getAccessibilityForAdaptation,
    getAudioChannelConfigurationForAdaptation: getAudioChannelConfigurationForAdaptation,
    getAudioChannelConfigurationForRepresentation: getAudioChannelConfigurationForRepresentation,
    getAdaptationForIndex: getAdaptationForIndex,
    getIndexForAdaptation: getIndexForAdaptation,
    getAdaptationForId: getAdaptationForId,
    getAdaptationsForType: getAdaptationsForType,
    getRealPeriods: getRealPeriods,
    getRealPeriodForIndex: getRealPeriodForIndex,
    getCodec: getCodec,
    getSelectionPriority: getSelectionPriority,
    getMimeType: getMimeType,
    getKID: getKID,
    getLabelsForAdaptation: getLabelsForAdaptation,
    getContentProtectionData: getContentProtectionData,
    getIsDynamic: getIsDynamic,
    getId: getId,
    hasProfile: hasProfile,
    getDuration: getDuration,
    getBandwidth: getBandwidth,
    getManifestUpdatePeriod: getManifestUpdatePeriod,
    getPublishTime: getPublishTime,
    getRepresentationCount: getRepresentationCount,
    getBitrateListForAdaptation: getBitrateListForAdaptation,
    getRepresentationFor: getRepresentationFor,
    getRepresentationsForAdaptation: getRepresentationsForAdaptation,
    getAdaptationsForPeriod: getAdaptationsForPeriod,
    getRegularPeriods: getRegularPeriods,
    getMpd: getMpd,
    getEventsForPeriod: getEventsForPeriod,
    getEssentialPropertiesForRepresentation: getEssentialPropertiesForRepresentation,
    getEventStreamForAdaptationSet: getEventStreamForAdaptationSet,
    getEventStreamForRepresentation: getEventStreamForRepresentation,
    getUTCTimingSources: getUTCTimingSources,
    getBaseURLsFromElement: getBaseURLsFromElement,
    getRepresentationSortFunction: getRepresentationSortFunction,
    getLocation: getLocation,
    getPatchLocation: getPatchLocation,
    getSuggestedPresentationDelay: getSuggestedPresentationDelay,
    getAvailabilityStartTime: getAvailabilityStartTime,
    getServiceDescriptions: getServiceDescriptions,
    getSupplementalProperties: getSupplementalProperties,
    setConfig: setConfig
  };
  setup();
  return instance;
}

DashManifestModel.__dashjs_factory_name = 'DashManifestModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_13__["default"].getSingletonFactory(DashManifestModel));

/***/ }),

/***/ "./src/dash/models/PatchManifestModel.js":
/*!***********************************************!*\
  !*** ./src/dash/models/PatchManifestModel.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_871437__) {

"use strict";
__nested_webpack_require_871437__.r(__webpack_exports__);
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_871437__(/*! ../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_871437__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_871437__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _vo_SimpleXPath__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_871437__(/*! ../vo/SimpleXPath */ "./src/dash/vo/SimpleXPath.js");
/* harmony import */ var _vo_PatchOperation__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_871437__(/*! ../vo/PatchOperation */ "./src/dash/vo/PatchOperation.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function PatchManifestModel() {
  var instance, logger;
  var context = this.context;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance().getLogger(instance);
  }

  function getIsPatch(patch) {
    return patch && patch.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].ORIGINAL_MPD_ID) || false;
  }

  function getPublishTime(patch) {
    return patch && patch.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].PUBLISH_TIME) ? new Date(patch[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].PUBLISH_TIME]) : null;
  }

  function getOriginalPublishTime(patch) {
    return patch && patch.hasOwnProperty(_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].ORIGINAL_PUBLISH_TIME) ? new Date(patch[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].ORIGINAL_PUBLISH_TIME]) : null;
  }

  function getMpdId(patch) {
    return patch && patch[_constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].ORIGINAL_MPD_ID] || null;
  }

  function getPatchOperations(patch) {
    if (!patch) {
      return [];
    } // Go through the patch operations in order and parse their actions out for usage


    return (patch.__children || []).map(function (nodeContainer) {
      var action = Object.keys(nodeContainer)[0]; // we only look add add/remove/replace actions

      if (action !== 'add' && action !== 'remove' && action !== 'replace') {
        logger.warn("Ignoring node of invalid action: ".concat(action));
        return null;
      }

      var node = nodeContainer[action];
      var selector = node.sel; // add action can have special targeting via the 'type' attribute

      if (action === 'add' && node.type) {
        if (!node.type.startsWith('@')) {
          logger.warn("Ignoring add action for prefixed namespace declaration: ".concat(node.type, "=").concat(node.__text));
          return null;
        } // for our purposes adding/replacing attribute are equivalent and we can normalize
        // our processing logic by appending the attribute to the selector path


        selector = "".concat(selector, "/").concat(node.type);
      }

      var xpath = new _vo_SimpleXPath__WEBPACK_IMPORTED_MODULE_3__["default"](selector);

      if (!xpath.isValid()) {
        logger.warn("Ignoring action with invalid selector: ".concat(action, " - ").concat(selector));
        return null;
      }

      var value = null;

      if (xpath.findsAttribute()) {
        value = node.__text || '';
      } else if (action !== 'remove') {
        value = node.__children.reduce(function (groups, child) {
          // note that this is informed by xml2js parse structure for the __children array
          // which will be something like this for each child:
          // {
          //     "<node-name>": { <xml2js-node-object> }
          // }
          var key = Object.keys(child)[0]; // we also ignore

          if (key !== '#text') {
            groups[key] = groups[key] || [];
            groups[key].push(child[key]);
          }

          return groups;
        }, {});
      }

      var operation = new _vo_PatchOperation__WEBPACK_IMPORTED_MODULE_4__["default"](action, xpath, value);

      if (action === 'add') {
        operation.position = node.pos;
      }

      return operation;
    }).filter(function (operation) {
      return !!operation;
    });
  }

  instance = {
    getIsPatch: getIsPatch,
    getPublishTime: getPublishTime,
    getOriginalPublishTime: getOriginalPublishTime,
    getMpdId: getMpdId,
    getPatchOperations: getPatchOperations
  };
  setup();
  return instance;
}

PatchManifestModel.__dashjs_factory_name = 'PatchManifestModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getSingletonFactory(PatchManifestModel));

/***/ }),

/***/ "./src/dash/parser/DashParser.js":
/*!***************************************!*\
  !*** ./src/dash/parser/DashParser.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_878489__) {

"use strict";
__nested_webpack_require_878489__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_878489__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _objectiron__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_878489__(/*! ./objectiron */ "./src/dash/parser/objectiron.js");
/* harmony import */ var _externals_xml2json__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_878489__(/*! ../../../externals/xml2json */ "./externals/xml2json.js");
/* harmony import */ var _matchers_StringMatcher__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_878489__(/*! ./matchers/StringMatcher */ "./src/dash/parser/matchers/StringMatcher.js");
/* harmony import */ var _matchers_DurationMatcher__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_878489__(/*! ./matchers/DurationMatcher */ "./src/dash/parser/matchers/DurationMatcher.js");
/* harmony import */ var _matchers_DateTimeMatcher__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_878489__(/*! ./matchers/DateTimeMatcher */ "./src/dash/parser/matchers/DateTimeMatcher.js");
/* harmony import */ var _matchers_NumericMatcher__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_878489__(/*! ./matchers/NumericMatcher */ "./src/dash/parser/matchers/NumericMatcher.js");
/* harmony import */ var _maps_RepresentationBaseValuesMap__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_878489__(/*! ./maps/RepresentationBaseValuesMap */ "./src/dash/parser/maps/RepresentationBaseValuesMap.js");
/* harmony import */ var _maps_SegmentValuesMap__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_878489__(/*! ./maps/SegmentValuesMap */ "./src/dash/parser/maps/SegmentValuesMap.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */










function DashParser(config) {
  config = config || {};
  var context = this.context;
  var debug = config.debug;
  var instance, logger, matchers, converter, objectIron;

  function setup() {
    logger = debug.getLogger(instance);
    matchers = [new _matchers_DurationMatcher__WEBPACK_IMPORTED_MODULE_4__["default"](), new _matchers_DateTimeMatcher__WEBPACK_IMPORTED_MODULE_5__["default"](), new _matchers_NumericMatcher__WEBPACK_IMPORTED_MODULE_6__["default"](), new _matchers_StringMatcher__WEBPACK_IMPORTED_MODULE_3__["default"]() // last in list to take precedence over NumericMatcher
    ];
    converter = new _externals_xml2json__WEBPACK_IMPORTED_MODULE_2__["default"]({
      escapeMode: false,
      attributePrefix: '',
      arrayAccessForm: 'property',
      emptyNodeForm: 'object',
      stripWhitespaces: false,
      enableToStringFunc: true,
      ignoreRoot: false,
      matchers: matchers
    });
    objectIron = Object(_objectiron__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
      adaptationset: new _maps_RepresentationBaseValuesMap__WEBPACK_IMPORTED_MODULE_7__["default"](),
      period: new _maps_SegmentValuesMap__WEBPACK_IMPORTED_MODULE_8__["default"]()
    });
  }

  function getMatchers() {
    return matchers;
  }

  function getIron() {
    return objectIron;
  }

  function parse(data) {
    var manifest;
    var startTime = window.performance.now();
    manifest = converter.xml_str2json(data);

    if (!manifest) {
      throw new Error('parsing the manifest failed');
    }

    var jsonTime = window.performance.now(); // handle full MPD and Patch ironing separately

    if (manifest.Patch) {
      manifest = manifest.Patch; // drop root reference
      // apply iron to patch operations individually

      if (manifest.add_asArray) {
        manifest.add_asArray.forEach(function (operand) {
          return objectIron.run(operand);
        });
      }

      if (manifest.replace_asArray) {
        manifest.replace_asArray.forEach(function (operand) {
          return objectIron.run(operand);
        });
      } // note that we don't need to iron remove as they contain no children

    } else {
      manifest = manifest.MPD; // drop root reference

      objectIron.run(manifest);
    }

    var ironedTime = window.performance.now();
    logger.info('Parsing complete: ( xml2json: ' + (jsonTime - startTime).toPrecision(3) + 'ms, objectiron: ' + (ironedTime - jsonTime).toPrecision(3) + 'ms, total: ' + ((ironedTime - startTime) / 1000).toPrecision(3) + 's)');
    manifest.protocol = 'DASH';
    return manifest;
  }

  instance = {
    parse: parse,
    getMatchers: getMatchers,
    getIron: getIron
  };
  setup();
  return instance;
}

DashParser.__dashjs_factory_name = 'DashParser';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(DashParser));

/***/ }),

/***/ "./src/dash/parser/maps/CommonProperty.js":
/*!************************************************!*\
  !*** ./src/dash/parser/maps/CommonProperty.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_885356__) {

"use strict";
__nested_webpack_require_885356__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a property belonging to a MapNode
 * @ignore
 */
var CommonProperty = /*#__PURE__*/function () {
  function CommonProperty(name) {
    _classCallCheck(this, CommonProperty);

    var getDefaultMergeForName = function getDefaultMergeForName(n) {
      return n && n.length && n.charAt(0) === n.charAt(0).toUpperCase();
    };

    this._name = name;
    this._merge = getDefaultMergeForName(name);
  }

  _createClass(CommonProperty, [{
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "merge",
    get: function get() {
      return this._merge;
    }
  }]);

  return CommonProperty;
}();

/* harmony default export */ __webpack_exports__["default"] = (CommonProperty);

/***/ }),

/***/ "./src/dash/parser/maps/MapNode.js":
/*!*****************************************!*\
  !*** ./src/dash/parser/maps/MapNode.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_889048__) {

"use strict";
__nested_webpack_require_889048__.r(__webpack_exports__);
/* harmony import */ var _CommonProperty__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_889048__(/*! ./CommonProperty */ "./src/dash/parser/maps/CommonProperty.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a node at some level in a ValueMap
 */


var MapNode = /*#__PURE__*/function () {
  function MapNode(name, properties, children) {
    var _this = this;

    _classCallCheck(this, MapNode);

    this._name = name || '';
    this._properties = [];
    this._children = children || [];

    if (Array.isArray(properties)) {
      properties.forEach(function (p) {
        _this._properties.push(new _CommonProperty__WEBPACK_IMPORTED_MODULE_0__["default"](p));
      });
    }
  }

  _createClass(MapNode, [{
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "children",
    get: function get() {
      return this._children;
    }
  }, {
    key: "properties",
    get: function get() {
      return this._properties;
    }
  }]);

  return MapNode;
}();

/* harmony default export */ __webpack_exports__["default"] = (MapNode);

/***/ }),

/***/ "./src/dash/parser/maps/RepresentationBaseValuesMap.js":
/*!*************************************************************!*\
  !*** ./src/dash/parser/maps/RepresentationBaseValuesMap.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_893148__) {

"use strict";
__nested_webpack_require_893148__.r(__webpack_exports__);
/* harmony import */ var _MapNode__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_893148__(/*! ./MapNode */ "./src/dash/parser/maps/MapNode.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_893148__(/*! ../../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a RepresentationBaseValuesMap type for input to objectiron
 */



var RepresentationBaseValuesMap = /*#__PURE__*/function (_MapNode) {
  _inherits(RepresentationBaseValuesMap, _MapNode);

  var _super = _createSuper(RepresentationBaseValuesMap);

  function RepresentationBaseValuesMap() {
    _classCallCheck(this, RepresentationBaseValuesMap);

    var commonProperties = [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PROFILES, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WIDTH, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].HEIGHT, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SAR, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].FRAMERATE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO_SAMPLING_RATE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_PROFILES, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CODECS, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MAXIMUM_SAP_PERIOD, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].START_WITH_SAP, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_PLAYOUT_RATE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CODING_DEPENDENCY, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SCAN_TYPE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].FRAME_PACKING, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO_CHANNEL_CONFIGURATION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENT_PROTECTION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ESSENTIAL_PROPERTY, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUPPLEMENTAL_PROPERTY, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INBAND_EVENT_STREAM];
    return _super.call(this, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ADAPTATION_SET, commonProperties, [new _MapNode__WEBPACK_IMPORTED_MODULE_0__["default"](_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION, commonProperties, [new _MapNode__WEBPACK_IMPORTED_MODULE_0__["default"](_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUB_REPRESENTATION, commonProperties)])]);
  }

  return RepresentationBaseValuesMap;
}(_MapNode__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (RepresentationBaseValuesMap);

/***/ }),

/***/ "./src/dash/parser/maps/SegmentValuesMap.js":
/*!**************************************************!*\
  !*** ./src/dash/parser/maps/SegmentValuesMap.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_900823__) {

"use strict";
__nested_webpack_require_900823__.r(__webpack_exports__);
/* harmony import */ var _MapNode__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_900823__(/*! ./MapNode */ "./src/dash/parser/maps/MapNode.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_900823__(/*! ../../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a SegmentValuesMap type for input to objectiron
 */



var SegmentValuesMap = /*#__PURE__*/function (_MapNode) {
  _inherits(SegmentValuesMap, _MapNode);

  var _super = _createSuper(SegmentValuesMap);

  function SegmentValuesMap() {
    _classCallCheck(this, SegmentValuesMap);

    var commonProperties = [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST];
    return _super.call(this, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PERIOD, commonProperties, [new _MapNode__WEBPACK_IMPORTED_MODULE_0__["default"](_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ADAPTATION_SET, commonProperties, [new _MapNode__WEBPACK_IMPORTED_MODULE_0__["default"](_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION, commonProperties)])]);
  }

  return SegmentValuesMap;
}(_MapNode__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (SegmentValuesMap);

/***/ }),

/***/ "./src/dash/parser/matchers/BaseMatcher.js":
/*!*************************************************!*\
  !*** ./src/dash/parser/matchers/BaseMatcher.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_907024__) {

"use strict";
__nested_webpack_require_907024__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a base type for matching and converting types in manifest to
 * something more useful
 * @ignore
 */
var BaseMatcher = /*#__PURE__*/function () {
  function BaseMatcher(test, converter) {
    _classCallCheck(this, BaseMatcher);

    this._test = test;
    this._converter = converter;
  }

  _createClass(BaseMatcher, [{
    key: "test",
    get: function get() {
      return this._test;
    }
  }, {
    key: "converter",
    get: function get() {
      return this._converter;
    }
  }]);

  return BaseMatcher;
}();

/* harmony default export */ __webpack_exports__["default"] = (BaseMatcher);

/***/ }),

/***/ "./src/dash/parser/matchers/DateTimeMatcher.js":
/*!*****************************************************!*\
  !*** ./src/dash/parser/matchers/DateTimeMatcher.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_910648__) {

"use strict";
__nested_webpack_require_910648__.r(__webpack_exports__);
/* harmony import */ var _BaseMatcher__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_910648__(/*! ./BaseMatcher */ "./src/dash/parser/matchers/BaseMatcher.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc matches and converts xs:datetime to Date
 */

var SECONDS_IN_MIN = 60;
var MINUTES_IN_HOUR = 60;
var MILLISECONDS_IN_SECONDS = 1000;
var datetimeRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/;

var DateTimeMatcher = /*#__PURE__*/function (_BaseMatcher) {
  _inherits(DateTimeMatcher, _BaseMatcher);

  var _super = _createSuper(DateTimeMatcher);

  function DateTimeMatcher() {
    _classCallCheck(this, DateTimeMatcher);

    return _super.call(this, function (attr) {
      return datetimeRegex.test(attr.value);
    }, function (str) {
      var match = datetimeRegex.exec(str);
      var utcDate; // If the string does not contain a timezone offset different browsers can interpret it either
      // as UTC or as a local time so we have to parse the string manually to normalize the given date value for
      // all browsers

      utcDate = Date.UTC(parseInt(match[1], 10), parseInt(match[2], 10) - 1, // months start from zero
      parseInt(match[3], 10), parseInt(match[4], 10), parseInt(match[5], 10), match[6] && parseInt(match[6], 10) || 0, match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0); // If the date has timezone offset take it into account as well

      if (match[9] && match[10]) {
        var timezoneOffset = parseInt(match[9], 10) * MINUTES_IN_HOUR + parseInt(match[10], 10);
        utcDate += (match[8] === '+' ? -1 : +1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;
      }

      return new Date(utcDate);
    });
  }

  return DateTimeMatcher;
}(_BaseMatcher__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (DateTimeMatcher);

/***/ }),

/***/ "./src/dash/parser/matchers/DurationMatcher.js":
/*!*****************************************************!*\
  !*** ./src/dash/parser/matchers/DurationMatcher.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_917295__) {

"use strict";
__nested_webpack_require_917295__.r(__webpack_exports__);
/* harmony import */ var _BaseMatcher__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_917295__(/*! ./BaseMatcher */ "./src/dash/parser/matchers/BaseMatcher.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_917295__(/*! ../../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_917295__(/*! ../../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc matches and converts xs:duration to seconds
 */



var durationRegex = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/;
var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
var SECONDS_IN_DAY = 24 * 60 * 60;
var SECONDS_IN_HOUR = 60 * 60;
var SECONDS_IN_MIN = 60;

var DurationMatcher = /*#__PURE__*/function (_BaseMatcher) {
  _inherits(DurationMatcher, _BaseMatcher);

  var _super = _createSuper(DurationMatcher);

  function DurationMatcher() {
    _classCallCheck(this, DurationMatcher);

    return _super.call(this, function (attr) {
      var attributeList = [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].MIN_BUFFER_TIME, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].MEDIA_PRESENTATION_DURATION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].MINIMUM_UPDATE_PERIOD, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].TIMESHIFT_BUFFER_DEPTH, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].MAX_SEGMENT_DURATION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].MAX_SUBSEGMENT_DURATION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].SUGGESTED_PRESENTATION_DELAY, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].START, _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].START_TIME, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"].DURATION];
      var len = attributeList.length;

      for (var i = 0; i < len; i++) {
        if (attr.nodeName === attributeList[i]) {
          return durationRegex.test(attr.value);
        }
      }

      return false;
    }, function (str) {
      //str = "P10Y10M10DT10H10M10.1S";
      var match = durationRegex.exec(str);
      var result = parseFloat(match[3] || 0) * SECONDS_IN_YEAR + parseFloat(match[5] || 0) * SECONDS_IN_MONTH + parseFloat(match[7] || 0) * SECONDS_IN_DAY + parseFloat(match[9] || 0) * SECONDS_IN_HOUR + parseFloat(match[11] || 0) * SECONDS_IN_MIN + parseFloat(match[13] || 0);

      if (match[1] !== undefined) {
        result = -result;
      }

      return result;
    });
  }

  return DurationMatcher;
}(_BaseMatcher__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (DurationMatcher);

/***/ }),

/***/ "./src/dash/parser/matchers/NumericMatcher.js":
/*!****************************************************!*\
  !*** ./src/dash/parser/matchers/NumericMatcher.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_924960__) {

"use strict";
__nested_webpack_require_924960__.r(__webpack_exports__);
/* harmony import */ var _BaseMatcher__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_924960__(/*! ./BaseMatcher */ "./src/dash/parser/matchers/BaseMatcher.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Matches and converts xs:numeric to float
 */

var numericRegex = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/;

var NumericMatcher = /*#__PURE__*/function (_BaseMatcher) {
  _inherits(NumericMatcher, _BaseMatcher);

  var _super = _createSuper(NumericMatcher);

  function NumericMatcher() {
    _classCallCheck(this, NumericMatcher);

    return _super.call(this, function (attr) {
      return numericRegex.test(attr.value);
    }, function (str) {
      return parseFloat(str);
    });
  }

  return NumericMatcher;
}(_BaseMatcher__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (NumericMatcher);

/***/ }),

/***/ "./src/dash/parser/matchers/StringMatcher.js":
/*!***************************************************!*\
  !*** ./src/dash/parser/matchers/StringMatcher.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_930513__) {

"use strict";
__nested_webpack_require_930513__.r(__webpack_exports__);
/* harmony import */ var _BaseMatcher__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_930513__(/*! ./BaseMatcher */ "./src/dash/parser/matchers/BaseMatcher.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_930513__(/*! ../../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Matches and converts xs:string to string, but only for specific attributes on specific nodes
 */



var StringMatcher = /*#__PURE__*/function (_BaseMatcher) {
  _inherits(StringMatcher, _BaseMatcher);

  var _super = _createSuper(StringMatcher);

  function StringMatcher() {
    _classCallCheck(this, StringMatcher);

    return _super.call(this, function (attr, nodeName) {
      var _stringAttrsInElement;

      var stringAttrsInElements = (_stringAttrsInElement = {}, _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MPD, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PROFILES]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PERIOD, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BASE_URL, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SERVICE_LOCATION, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BYTE_RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX_RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INITIALIZATION, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION_INDEX, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_LIST, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX_RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BITSTREAM_SWITCHING, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_URL, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA_RANGE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX_RANGE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX_RANGE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INDEX, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INITIALIZATION_MINUS, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BITSTREAM_SWITCHING_MINUS]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ASSET_IDENTIFIER, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].EVENT_STREAM, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ADAPTATION_SET, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PROFILES, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MIME_TYPE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_PROFILES, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CODECS, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENT_TYPE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].FRAME_PACKING, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO_CHANNEL_CONFIGURATION, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENT_PROTECTION, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ESSENTIAL_PROPERTY, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUPPLEMENTAL_PROPERTY, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].INBAND_EVENT_STREAM, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ACCESSIBILITY, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ROLE, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].RATING, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VIEWPOINT, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENT_COMPONENT, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].CONTENT_TYPE]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPRESENTATION, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DEPENDENCY_ID, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MEDIA_STREAM_STRUCTURE_ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SUBSET, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].METRICS, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].METRICS_MINUS]), _defineProperty(_stringAttrsInElement, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REPORTING, [_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].VALUE, _constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].ID]), _stringAttrsInElement);

      if (stringAttrsInElements.hasOwnProperty(nodeName)) {
        var attrNames = stringAttrsInElements[nodeName];

        if (attrNames !== undefined) {
          return attrNames.indexOf(attr.name) >= 0;
        } else {
          return false;
        }
      }

      return false;
    }, function (str) {
      return String(str);
    });
  }

  return StringMatcher;
}(_BaseMatcher__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (StringMatcher);

/***/ }),

/***/ "./src/dash/parser/objectiron.js":
/*!***************************************!*\
  !*** ./src/dash/parser/objectiron.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_944118__) {

"use strict";
__nested_webpack_require_944118__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_944118__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function ObjectIron(mappers) {
  function mergeValues(parentItem, childItem) {
    for (var name in parentItem) {
      if (!childItem.hasOwnProperty(name)) {
        childItem[name] = parentItem[name];
      }
    }
  }

  function mapProperties(properties, parent, child) {
    for (var i = 0, len = properties.length; i < len; ++i) {
      var property = properties[i];

      if (parent[property.name]) {
        if (child[property.name]) {
          // check to see if we should merge
          if (property.merge) {
            var parentValue = parent[property.name];
            var childValue = child[property.name]; // complex objects; merge properties

            if (_typeof(parentValue) === 'object' && _typeof(childValue) === 'object') {
              mergeValues(parentValue, childValue);
            } // simple objects; merge them together
            else {
                child[property.name] = parentValue + childValue;
              }
          }
        } else {
          // just add the property
          child[property.name] = parent[property.name];
        }
      }
    }
  }

  function mapItem(item, node) {
    for (var i = 0, len = item.children.length; i < len; ++i) {
      var childItem = item.children[i];
      var array = node[childItem.name + '_asArray'];

      if (array) {
        for (var v = 0, len2 = array.length; v < len2; ++v) {
          var childNode = array[v];
          mapProperties(item.properties, node, childNode);
          mapItem(childItem, childNode);
        }
      }
    }
  }

  function run(source) {
    if (source === null || _typeof(source) !== 'object') {
      return source;
    }

    if (source.Period_asArray && 'period' in mappers) {
      var periodMapper = mappers.period;
      var periods = source.Period_asArray;

      for (var i = 0, len = periods.length; i < len; ++i) {
        var period = periods[i];
        mapItem(periodMapper, period);

        if ('adaptationset' in mappers) {
          var adaptationSets = period.AdaptationSet_asArray;

          if (adaptationSets) {
            var adaptationSetMapper = mappers.adaptationset;

            for (var _i = 0, _len = adaptationSets.length; _i < _len; ++_i) {
              mapItem(adaptationSetMapper, adaptationSets[_i]);
            }
          }
        }
      }
    }

    return source;
  }

  return {
    run: run
  };
}

ObjectIron.__dashjs_factory_name = 'ObjectIron';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(ObjectIron);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/utils/ListSegmentsGetter.js":
/*!**********************************************!*\
  !*** ./src/dash/utils/ListSegmentsGetter.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_949602__) {

"use strict";
__nested_webpack_require_949602__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_949602__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_949602__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_949602__(/*! ./SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function ListSegmentsGetter(config, isDynamic) {
  config = config || {};
  var timelineConverter = config.timelineConverter;
  var instance;

  function checkConfig() {
    if (!timelineConverter || !timelineConverter.hasOwnProperty('calcPeriodRelativeTimeFromMpdRelativeTime')) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getMediaFinishedInformation(representation) {
    var mediaFinishedInformation = {
      numberOfSegments: 0,
      mediaTimeOfLastSignaledSegment: NaN
    };

    if (!representation) {
      return mediaFinishedInformation;
    }

    var list = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
    var startNumber = representation && !isNaN(representation.startNumber) ? representation.startNumber : 1;
    var offset = Math.max(startNumber - 1, 0);
    mediaFinishedInformation.numberOfSegments = offset + list.SegmentURL_asArray.length;
    return mediaFinishedInformation;
  }

  function getSegmentByIndex(representation, index) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var list = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
    var len = list.SegmentURL_asArray.length;
    var startNumber = representation && !isNaN(representation.startNumber) ? representation.startNumber : 1;
    var offsetToSubtract = Math.max(startNumber - 1, 0);
    var relativeIndex = Math.max(index - offsetToSubtract, 0);
    var segment = null;

    if (relativeIndex < len) {
      var s = list.SegmentURL_asArray[relativeIndex];
      segment = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["getIndexBasedSegment"])(timelineConverter, isDynamic, representation, index);

      if (segment) {
        segment.replacementTime = (startNumber + index - 1) * representation.segmentDuration;
        segment.media = s.media ? s.media : '';
        segment.mediaRange = s.mediaRange;
        segment.indexRange = s.indexRange;
      }
    }

    return segment;
  }

  function getSegmentByTime(representation, requestedTime) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var duration = representation.segmentDuration;

    if (isNaN(duration)) {
      return null;
    }

    var periodTime = timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, requestedTime);
    var index = Math.floor(periodTime / duration);
    return getSegmentByIndex(representation, index);
  }

  instance = {
    getSegmentByIndex: getSegmentByIndex,
    getSegmentByTime: getSegmentByTime,
    getMediaFinishedInformation: getMediaFinishedInformation
  };
  return instance;
}

ListSegmentsGetter.__dashjs_factory_name = 'ListSegmentsGetter';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(ListSegmentsGetter);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/utils/Round10.js":
/*!***********************************!*\
  !*** ./src/dash/utils/Round10.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_955648__) {

"use strict";
__nested_webpack_require_955648__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_955648__.d(__webpack_exports__, "default", function() { return Round10; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Static methods for rounding decimals
 *
 * Modified version of the CC0-licenced example at:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round
 *
 * @export
 * @class Round10
 * @ignore
 */
var Round10 = /*#__PURE__*/function () {
  function Round10() {
    _classCallCheck(this, Round10);
  }

  _createClass(Round10, null, [{
    key: "round10",
    value:
    /**
    * Decimal round.
    *
    * @param {Number}  value The number.
    * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
    * @returns {Number} The adjusted value.
    * @ignore
    */
    function round10(value, exp) {
      return _decimalAdjust('round', value, exp);
    }
  }]);

  return Round10;
}();
/**
 * Decimal adjustment of a number.
 *
 * @param {String}  type  The type of adjustment.
 * @param {Number}  value The number.
 * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
 * @returns {Number} The adjusted value.
 * @ignore
 */




function _decimalAdjust(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }

  value = +value;
  exp = +exp; // If the value is not a number or the exp is not an integer...

  if (value === null || isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  } // Shift


  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp))); // Shift back

  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
}

/***/ }),

/***/ "./src/dash/utils/SegmentBaseGetter.js":
/*!*********************************************!*\
  !*** ./src/dash/utils/SegmentBaseGetter.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_960432__) {

"use strict";
__nested_webpack_require_960432__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_960432__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_960432__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function SegmentBaseGetter(config) {
  config = config || {};
  var timelineConverter = config.timelineConverter;
  var instance;

  function checkConfig() {
    if (!timelineConverter || !timelineConverter.hasOwnProperty('calcPeriodRelativeTimeFromMpdRelativeTime')) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getMediaFinishedInformation(representation) {
    var mediaFinishedInformation = {
      numberOfSegments: 0,
      mediaTimeOfLastSignaledSegment: NaN
    };

    if (!representation || !representation.segments) {
      return mediaFinishedInformation;
    }

    mediaFinishedInformation.numberOfSegments = representation.segments.length;
    return mediaFinishedInformation;
  }

  function getSegmentByIndex(representation, index) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var len = representation.segments ? representation.segments.length : -1;
    var seg;

    if (index < len) {
      seg = representation.segments[index];

      if (seg && seg.index === index) {
        return seg;
      }
    }

    for (var i = 0; i < len; i++) {
      seg = representation.segments[i];

      if (seg && seg.index === index) {
        return seg;
      }
    }

    return null;
  }

  function getSegmentByTime(representation, requestedTime) {
    checkConfig();
    var index = getIndexByTime(representation, requestedTime);
    return getSegmentByIndex(representation, index);
  }

  function getIndexByTime(representation, time) {
    if (!representation) {
      return -1;
    }

    var segments = representation.segments;
    var ln = segments ? segments.length : null;
    var idx = -1;
    var epsilon, seg, ft, fd, i;

    if (segments && ln > 0) {
      for (i = 0; i < ln; i++) {
        seg = segments[i];
        ft = seg.presentationStartTime;
        fd = seg.duration;
        epsilon = fd / 2;

        if (time + epsilon >= ft && time - epsilon < ft + fd) {
          idx = seg.index;
          break;
        }
      }
    }

    return idx;
  }

  instance = {
    getSegmentByIndex: getSegmentByIndex,
    getSegmentByTime: getSegmentByTime,
    getMediaFinishedInformation: getMediaFinishedInformation
  };
  return instance;
}

SegmentBaseGetter.__dashjs_factory_name = 'SegmentBaseGetter';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(SegmentBaseGetter);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/utils/SegmentsUtils.js":
/*!*****************************************!*\
  !*** ./src/dash/utils/SegmentsUtils.js ***!
  \*****************************************/
/*! exports provided: unescapeDollarsInTemplate, replaceIDForTemplate, replaceTokenForTemplate, getIndexBasedSegment, getTimeBasedSegment */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_965767__) {

"use strict";
__nested_webpack_require_965767__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_965767__.d(__webpack_exports__, "unescapeDollarsInTemplate", function() { return unescapeDollarsInTemplate; });
/* harmony export (binding) */ __nested_webpack_require_965767__.d(__webpack_exports__, "replaceIDForTemplate", function() { return replaceIDForTemplate; });
/* harmony export (binding) */ __nested_webpack_require_965767__.d(__webpack_exports__, "replaceTokenForTemplate", function() { return replaceTokenForTemplate; });
/* harmony export (binding) */ __nested_webpack_require_965767__.d(__webpack_exports__, "getIndexBasedSegment", function() { return getIndexBasedSegment; });
/* harmony export (binding) */ __nested_webpack_require_965767__.d(__webpack_exports__, "getTimeBasedSegment", function() { return getTimeBasedSegment; });
/* harmony import */ var _vo_Segment__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_965767__(/*! ./../vo/Segment */ "./src/dash/vo/Segment.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function zeroPadToLength(numStr, minStrLength) {
  while (numStr.length < minStrLength) {
    numStr = '0' + numStr;
  }

  return numStr;
}

function getNumberForSegment(segment, segmentIndex) {
  return segment.representation.startNumber + segmentIndex;
}

function unescapeDollarsInTemplate(url) {
  return url ? url.split('$$').join('$') : url;
}
function replaceIDForTemplate(url, value) {
  if (!value || !url || url.indexOf('$RepresentationID$') === -1) {
    return url;
  }

  var v = value.toString();
  return url.split('$RepresentationID$').join(v);
}
function replaceTokenForTemplate(url, token, value) {
  var formatTag = '%0';
  var startPos, endPos, formatTagPos, specifier, width, paddedValue;
  var tokenLen = token.length;
  var formatTagLen = formatTag.length;

  if (!url) {
    return url;
  } // keep looping round until all instances of <token> have been
  // replaced. once that has happened, startPos below will be -1
  // and the completed url will be returned.


  while (true) {
    // check if there is a valid $<token>...$ identifier
    // if not, return the url as is.
    startPos = url.indexOf('$' + token);

    if (startPos < 0) {
      return url;
    } // the next '$' must be the end of the identifier
    // if there isn't one, return the url as is.


    endPos = url.indexOf('$', startPos + tokenLen);

    if (endPos < 0) {
      return url;
    } // now see if there is an additional format tag suffixed to
    // the identifier within the enclosing '$' characters


    formatTagPos = url.indexOf(formatTag, startPos + tokenLen);

    if (formatTagPos > startPos && formatTagPos < endPos) {
      specifier = url.charAt(endPos - 1);
      width = parseInt(url.substring(formatTagPos + formatTagLen, endPos - 1), 10); // support the minimum specifiers required by IEEE 1003.1
      // (d, i , o, u, x, and X) for completeness

      switch (specifier) {
        // treat all int types as uint,
        // hence deliberate fallthrough
        case 'd':
        case 'i':
        case 'u':
          paddedValue = zeroPadToLength(value.toString(), width);
          break;

        case 'x':
          paddedValue = zeroPadToLength(value.toString(16), width);
          break;

        case 'X':
          paddedValue = zeroPadToLength(value.toString(16), width).toUpperCase();
          break;

        case 'o':
          paddedValue = zeroPadToLength(value.toString(8), width);
          break;

        default:
          return url;
      }
    } else {
      paddedValue = value;
    }

    url = url.substring(0, startPos) + paddedValue + url.substring(endPos + 1);
  }
}

function getSegment(representation, duration, presentationStartTime, mediaStartTime, timelineConverter, presentationEndTime, isDynamic, index) {
  var seg = new _vo_Segment__WEBPACK_IMPORTED_MODULE_0__["default"]();
  seg.representation = representation;
  seg.duration = duration;
  seg.presentationStartTime = presentationStartTime;
  seg.mediaStartTime = mediaStartTime;
  seg.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationEndTime, representation, isDynamic);
  seg.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime + duration, representation, isDynamic);
  seg.wallStartTime = timelineConverter.calcWallTimeForSegment(seg, isDynamic);
  seg.replacementNumber = getNumberForSegment(seg, index);
  seg.index = index;
  return seg;
}

function isSegmentAvailable(timelineConverter, representation, segment, isDynamic) {
  var voPeriod = representation.adaptation.period; // Avoid requesting segments that overlap the period boundary

  if (isFinite(voPeriod.duration) && voPeriod.start + voPeriod.duration <= segment.presentationStartTime) {
    return false;
  }

  if (isDynamic) {
    if (representation.availabilityTimeOffset === 'INF') {
      return true;
    } // For dynamic manifests we check if the presentation start time + duration is included in the availability window
    // SAST = Period@start + seg@presentationStartTime + seg@duration
    // ASAST = SAST - ATO
    // SAET = SAST + TSBD + seg@duration
    // refTime serves as an anchor time to compare the availability time of the segments against.


    var refTime = timelineConverter.getClientReferenceTime();
    return segment.availabilityStartTime.getTime() <= refTime && (!isFinite(segment.availabilityEndTime) || segment.availabilityEndTime.getTime() >= refTime);
  }

  return true;
}

function getIndexBasedSegment(timelineConverter, isDynamic, representation, index) {
  var duration, presentationStartTime, presentationEndTime;
  duration = representation.segmentDuration;
  /*
   * From spec - If neither @duration attribute nor SegmentTimeline element is present, then the Representation
   * shall contain exactly one Media Segment. The MPD start time is 0 and the MPD duration is obtained
   * in the same way as for the last Media Segment in the Representation.
   */

  if (isNaN(duration)) {
    duration = representation.adaptation.period.duration;
  }

  presentationStartTime = parseFloat((representation.adaptation.period.start + index * duration).toFixed(5));
  presentationEndTime = parseFloat((presentationStartTime + duration).toFixed(5));
  var mediaTime = timelineConverter.calcMediaTimeFromPresentationTime(presentationStartTime, representation);
  var segment = getSegment(representation, duration, presentationStartTime, mediaTime, timelineConverter, presentationEndTime, isDynamic, index);

  if (!isSegmentAvailable(timelineConverter, representation, segment, isDynamic)) {
    return null;
  }

  return segment;
}
function getTimeBasedSegment(timelineConverter, isDynamic, representation, time, duration, fTimescale, url, range, index, tManifest) {
  var scaledTime = time / fTimescale;
  var scaledDuration = duration / fTimescale;
  var presentationStartTime, presentationEndTime, seg;
  presentationStartTime = timelineConverter.calcPresentationTimeFromMediaTime(scaledTime, representation);
  presentationEndTime = presentationStartTime + scaledDuration;
  seg = getSegment(representation, scaledDuration, presentationStartTime, scaledTime, timelineConverter, presentationEndTime, isDynamic, index);

  if (!isSegmentAvailable(timelineConverter, representation, seg, isDynamic)) {
    return null;
  }

  seg.replacementTime = tManifest ? tManifest : time;
  url = replaceTokenForTemplate(url, 'Number', seg.replacementNumber);
  url = replaceTokenForTemplate(url, 'Time', seg.replacementTime);
  seg.media = url;
  seg.mediaRange = range;
  return seg;
}

/***/ }),

/***/ "./src/dash/utils/TemplateSegmentsGetter.js":
/*!**************************************************!*\
  !*** ./src/dash/utils/TemplateSegmentsGetter.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_975690__) {

"use strict";
__nested_webpack_require_975690__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_975690__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_975690__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_975690__(/*! ./SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function TemplateSegmentsGetter(config, isDynamic) {
  config = config || {};
  var timelineConverter = config.timelineConverter;
  var instance;

  function checkConfig() {
    if (!timelineConverter || !timelineConverter.hasOwnProperty('calcPeriodRelativeTimeFromMpdRelativeTime')) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getMediaFinishedInformation(representation) {
    var mediaFinishedInformation = {
      numberOfSegments: 0,
      mediaTimeOfLastSignaledSegment: NaN
    };

    if (!representation) {
      return mediaFinishedInformation;
    }

    var duration = representation.segmentDuration;

    if (isNaN(duration)) {
      mediaFinishedInformation.numberOfSegments = 1;
    } else {
      mediaFinishedInformation.numberOfSegments = Math.ceil(representation.adaptation.period.duration / duration);
    }

    return mediaFinishedInformation;
  }

  function getSegmentByIndex(representation, index) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var template = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate; // This is the index without @startNumber

    index = Math.max(index, 0);
    var seg = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["getIndexBasedSegment"])(timelineConverter, isDynamic, representation, index);

    if (seg) {
      seg.replacementTime = Math.round((index - 1) * representation.segmentDuration * representation.timescale, 10);
      var url = template.media;
      url = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["replaceTokenForTemplate"])(url, 'Number', seg.replacementNumber);
      url = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["replaceTokenForTemplate"])(url, 'Time', seg.replacementTime);
      seg.media = url;
    }

    return seg;
  }

  function getSegmentByTime(representation, requestedTime) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var duration = representation.segmentDuration;

    if (isNaN(duration)) {
      return null;
    } // Calculate the relative time for the requested time in this period


    var periodTime = timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, requestedTime);
    var index = Math.floor(periodTime / duration);
    return getSegmentByIndex(representation, index);
  }

  instance = {
    getSegmentByIndex: getSegmentByIndex,
    getSegmentByTime: getSegmentByTime,
    getMediaFinishedInformation: getMediaFinishedInformation
  };
  return instance;
}

TemplateSegmentsGetter.__dashjs_factory_name = 'TemplateSegmentsGetter';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(TemplateSegmentsGetter);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/utils/TimelineConverter.js":
/*!*********************************************!*\
  !*** ./src/dash/utils/TimelineConverter.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_981532__) {

"use strict";
__nested_webpack_require_981532__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_981532__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_981532__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_981532__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_981532__(/*! ../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _models_DashManifestModel__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_981532__(/*! ../models/DashManifestModel */ "./src/dash/models/DashManifestModel.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_981532__(/*! ../../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_981532__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_981532__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _streaming_constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_981532__(/*! ../../streaming/constants/ConformanceViolationConstants */ "./src/streaming/constants/ConformanceViolationConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */










function TimelineConverter() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var instance, dashManifestModel, timelineAnchorAvailabilityOffset, // In case we calculate the TSBD using _calcTimeShiftBufferWindowForDynamicTimelineManifest we use the segments as anchor times. We apply this offset when calculating if a segment is available or not.
  clientServerTimeShift;

  function setup() {
    dashManifestModel = Object(_models_DashManifestModel__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
    reset();
  }

  function initialize() {
    resetInitialSettings();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].UPDATE_TIME_SYNC_OFFSET, _onUpdateTimeSyncOffset, this);
  }

  function getClientTimeOffset() {
    return clientServerTimeShift;
  }

  function setClientTimeOffset(value) {
    clientServerTimeShift = value;
  }
  /**
   * Returns a "now" reference time for the client to compare the availability time of a segment against.
   * Takes the client/server drift into account
   */


  function getClientReferenceTime() {
    return Date.now() - timelineAnchorAvailabilityOffset * 1000 + clientServerTimeShift * 1000;
  }

  function _calcAvailabilityTimeFromPresentationTime(presentationEndTime, representation, isDynamic, calculateAvailabilityEndTime) {
    var availabilityTime;
    var mpd = representation.adaptation.period.mpd;
    var availabilityStartTime = mpd.availabilityStartTime;

    if (calculateAvailabilityEndTime) {
      //@timeShiftBufferDepth specifies the duration of the time shifting buffer that is guaranteed
      // to be available for a Media Presentation with type 'dynamic'.
      // When not present, the value is infinite.
      if (isDynamic && mpd.timeShiftBufferDepth !== Number.POSITIVE_INFINITY) {
        // SAET = SAST + TSBD + seg@duration
        availabilityTime = new Date(availabilityStartTime.getTime() + (presentationEndTime + mpd.timeShiftBufferDepth) * 1000);
      } else {
        availabilityTime = mpd.availabilityEndTime;
      }
    } else {
      if (isDynamic) {
        // SAST = Period@start + seg@presentationStartTime + seg@duration
        // ASAST = SAST - ATO
        var availabilityTimeOffset = representation.availabilityTimeOffset; // presentationEndTime = Period@start + seg@presentationStartTime + Segment@duration

        availabilityTime = new Date(availabilityStartTime.getTime() + (presentationEndTime - availabilityTimeOffset) * 1000);
      } else {
        // in static mpd, all segments are available at the same time
        availabilityTime = availabilityStartTime;
      }
    }

    return availabilityTime;
  }

  function calcAvailabilityStartTimeFromPresentationTime(presentationEndTime, representation, isDynamic) {
    return _calcAvailabilityTimeFromPresentationTime(presentationEndTime, representation, isDynamic);
  }

  function calcAvailabilityEndTimeFromPresentationTime(presentationEndTime, representation, isDynamic) {
    return _calcAvailabilityTimeFromPresentationTime(presentationEndTime, representation, isDynamic, true);
  }

  function calcPresentationTimeFromWallTime(wallTime, period) {
    return (wallTime.getTime() - period.mpd.availabilityStartTime.getTime() + clientServerTimeShift * 1000) / 1000;
  }

  function calcPresentationTimeFromMediaTime(mediaTime, representation) {
    var periodStart = representation.adaptation.period.start;
    var presentationOffset = representation.presentationTimeOffset;
    return mediaTime + (periodStart - presentationOffset);
  }

  function calcMediaTimeFromPresentationTime(presentationTime, representation) {
    var periodStart = representation.adaptation.period.start;
    var presentationOffset = representation.presentationTimeOffset;
    return presentationTime - periodStart + presentationOffset;
  }

  function calcWallTimeForSegment(segment, isDynamic) {
    var suggestedPresentationDelay, displayStartTime, wallTime;

    if (isDynamic) {
      suggestedPresentationDelay = segment.representation.adaptation.period.mpd.suggestedPresentationDelay;
      displayStartTime = segment.presentationStartTime + suggestedPresentationDelay;
      wallTime = new Date(segment.availabilityStartTime.getTime() + displayStartTime * 1000);
    }

    return wallTime;
  }
  /**
   * Calculates the timeshiftbuffer range. This range might overlap multiple periods and is not limited to period boundaries. However, we make sure that the range is potentially covered by period.
   * @param {Array} streams
   * @param {boolean} isDynamic
   * @return {}
   */


  function calcTimeShiftBufferWindow(streams, isDynamic) {
    // Static manifests. The availability window is equal to the DVR window
    if (!isDynamic) {
      return _calcTimeshiftBufferForStaticManifest(streams);
    } // Specific use case of SegmentTimeline


    if (settings.get().streaming.timeShiftBuffer.calcFromSegmentTimeline) {
      var data = _calcTimeShiftBufferWindowForDynamicTimelineManifest(streams);

      _adjustTimelineAnchorAvailabilityOffset(data.now, data.range);

      return data.range;
    }

    return _calcTimeShiftBufferWindowForDynamicManifest(streams);
  }

  function _calcTimeshiftBufferForStaticManifest(streams) {
    // Static Range Finder. We iterate over all periods and return the total duration
    var range = {
      start: NaN,
      end: NaN
    };
    var duration = 0;
    var start = NaN;
    streams.forEach(function (stream) {
      var streamInfo = stream.getStreamInfo();
      duration += streamInfo.duration;

      if (isNaN(start) || streamInfo.start < start) {
        start = streamInfo.start;
      }
    });
    range.start = start;
    range.end = start + duration;
    return range;
  }

  function _calcTimeShiftBufferWindowForDynamicManifest(streams) {
    var range = {
      start: NaN,
      end: NaN
    };

    if (!streams || streams.length === 0) {
      return range;
    }

    var voPeriod = streams[0].getAdapter().getRegularPeriods()[0];
    var now = calcPresentationTimeFromWallTime(new Date(), voPeriod);
    var timeShiftBufferDepth = voPeriod.mpd.timeShiftBufferDepth;
    var start = !isNaN(timeShiftBufferDepth) ? now - timeShiftBufferDepth : 0; // check if we find a suitable period for that starttime. Otherwise we use the time closest to that

    range.start = _adjustTimeBasedOnPeriodRanges(streams, start);
    range.end = !isNaN(range.start) && now < range.start ? now : _adjustTimeBasedOnPeriodRanges(streams, now, true);

    if (!isNaN(timeShiftBufferDepth) && range.end < now - timeShiftBufferDepth) {
      range.end = NaN;
    } // If we have SegmentTimeline as a reference we can verify that the calculated DVR window is at least partially included in the DVR window exposed by the timeline.
    // If that is not the case we stick to the DVR window defined by SegmentTimeline


    if (settings.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline) {
      var timelineRefData = _calcTimeShiftBufferWindowForDynamicTimelineManifest(streams);

      if (timelineRefData.range.end < range.start) {
        eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].CONFORMANCE_VIOLATION, {
          level: _streaming_constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_8__["default"].LEVELS.WARNING,
          event: _streaming_constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_8__["default"].EVENTS.INVALID_DVR_WINDOW
        });

        _adjustTimelineAnchorAvailabilityOffset(timelineRefData.now, timelineRefData.range);

        return timelineRefData.range;
      }
    }

    return range;
  }

  function _calcTimeShiftBufferWindowForDynamicTimelineManifest(streams) {
    var range = {
      start: NaN,
      end: NaN
    };
    var voPeriod = streams[0].getAdapter().getRegularPeriods()[0];
    var now = calcPresentationTimeFromWallTime(new Date(), voPeriod);

    if (!streams || streams.length === 0) {
      return {
        range: range,
        now: now
      };
    }

    streams.forEach(function (stream) {
      var adapter = stream.getAdapter();
      var mediaInfo = adapter.getMediaInfoForType(stream.getStreamInfo(), _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_6__["default"].VIDEO) || adapter.getMediaInfoForType(stream.getStreamInfo(), _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_6__["default"].AUDIO);
      var voRepresentations = adapter.getVoRepresentations(mediaInfo);
      var voRepresentation = voRepresentations[0];
      var periodRange = {
        start: NaN,
        end: NaN
      };

      if (voRepresentation) {
        if (voRepresentation.segmentInfoType === _constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].SEGMENT_TIMELINE) {
          periodRange = _calcRangeForTimeline(voRepresentation);
        } else {
          var currentVoPeriod = voRepresentation.adaptation.period;
          periodRange.start = currentVoPeriod.start;
          periodRange.end = Math.max(now, currentVoPeriod.start + currentVoPeriod.duration);
        }
      }

      if (!isNaN(periodRange.start) && (isNaN(range.start) || range.start > periodRange.start)) {
        range.start = periodRange.start;
      }

      if (!isNaN(periodRange.end) && (isNaN(range.end) || range.end < periodRange.end)) {
        range.end = periodRange.end;
      }
    });
    range.end = Math.min(now, range.end);

    var adjustedEndTime = _adjustTimeBasedOnPeriodRanges(streams, range.end, true); // if range is NaN all periods are in the future. we should return range.start > range.end in this case


    range.end = isNaN(adjustedEndTime) ? range.end : adjustedEndTime;
    range.start = voPeriod && voPeriod.mpd && voPeriod.mpd.timeShiftBufferDepth && !isNaN(voPeriod.mpd.timeShiftBufferDepth) && !isNaN(range.end) ? Math.max(range.end - voPeriod.mpd.timeShiftBufferDepth, range.start) : range.start;
    range.start = _adjustTimeBasedOnPeriodRanges(streams, range.start);
    return {
      range: range,
      now: now
    };
  }

  function _adjustTimelineAnchorAvailabilityOffset(now, range) {
    timelineAnchorAvailabilityOffset = now - range.end;
  }

  function _adjustTimeBasedOnPeriodRanges(streams, time) {
    var isEndOfDvrWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    try {
      var i = 0;
      var found = false;
      var adjustedTime = NaN;

      while (!found && i < streams.length) {
        var streamInfo = streams[i].getStreamInfo(); // We found a period which contains the target time.

        if (streamInfo.start <= time && (!isFinite(streamInfo.duration) || streamInfo.start + streamInfo.duration >= time)) {
          adjustedTime = time;
          found = true;
        } // Adjust the time for the start of the DVR window. The current period starts after the target time. We use the starttime of this period as adjusted time
        else if (!isEndOfDvrWindow && streamInfo.start > time && (isNaN(adjustedTime) || streamInfo.start < adjustedTime)) {
            adjustedTime = streamInfo.start;
          } // Adjust the time for the end of the DVR window. The current period ends before the targettime. We use the end time of this period as the adjusted time
          else if (isEndOfDvrWindow && streamInfo.start + streamInfo.duration < time && (isNaN(adjustedTime) || streamInfo.start + streamInfo.duration > adjustedTime)) {
              adjustedTime = streamInfo.start + streamInfo.duration;
            }

        i += 1;
      }

      return adjustedTime;
    } catch (e) {
      return time;
    }
  }

  function _calcRangeForTimeline(voRepresentation) {
    var adaptation = voRepresentation.adaptation.period.mpd.manifest.Period_asArray[voRepresentation.adaptation.period.index].AdaptationSet_asArray[voRepresentation.adaptation.index];
    var representation = dashManifestModel.getRepresentationFor(voRepresentation.index, adaptation);
    var timeline = representation.SegmentTemplate.SegmentTimeline;
    var timescale = representation.SegmentTemplate.timescale;
    var segments = timeline.S_asArray;
    var range = {
      start: 0,
      end: 0
    };
    var d = 0;
    var segment, repeat, i, len;
    range.start = calcPresentationTimeFromMediaTime(segments[0].t / timescale, voRepresentation);

    for (i = 0, len = segments.length; i < len; i++) {
      segment = segments[i];
      repeat = 0;

      if (segment.hasOwnProperty('r')) {
        repeat = segment.r;
      }

      d += segment.d * (1 + repeat);
    }

    range.end = calcPresentationTimeFromMediaTime((segments[0].t + d) / timescale, voRepresentation);
    return range;
  }

  function calcPeriodRelativeTimeFromMpdRelativeTime(representation, mpdRelativeTime) {
    var periodStartTime = representation.adaptation.period.start;
    return mpdRelativeTime - periodStartTime;
  }

  function _onUpdateTimeSyncOffset(e) {
    if (e.offset !== undefined && !isNaN(e.offset)) {
      setClientTimeOffset(e.offset / 1000);
    }
  }

  function resetInitialSettings() {
    clientServerTimeShift = 0;
    timelineAnchorAvailabilityOffset = 0;
  }

  function reset() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].UPDATE_TIME_SYNC_OFFSET, _onUpdateTimeSyncOffset, this);
    resetInitialSettings();
  }

  instance = {
    initialize: initialize,
    getClientTimeOffset: getClientTimeOffset,
    setClientTimeOffset: setClientTimeOffset,
    getClientReferenceTime: getClientReferenceTime,
    calcAvailabilityStartTimeFromPresentationTime: calcAvailabilityStartTimeFromPresentationTime,
    calcAvailabilityEndTimeFromPresentationTime: calcAvailabilityEndTimeFromPresentationTime,
    calcPresentationTimeFromWallTime: calcPresentationTimeFromWallTime,
    calcPresentationTimeFromMediaTime: calcPresentationTimeFromMediaTime,
    calcPeriodRelativeTimeFromMpdRelativeTime: calcPeriodRelativeTimeFromMpdRelativeTime,
    calcMediaTimeFromPresentationTime: calcMediaTimeFromPresentationTime,
    calcWallTimeForSegment: calcWallTimeForSegment,
    calcTimeShiftBufferWindow: calcTimeShiftBufferWindow,
    reset: reset
  };
  setup();
  return instance;
}

TimelineConverter.__dashjs_factory_name = 'TimelineConverter';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(TimelineConverter));

/***/ }),

/***/ "./src/dash/utils/TimelineSegmentsGetter.js":
/*!**************************************************!*\
  !*** ./src/dash/utils/TimelineSegmentsGetter.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1000339__) {

"use strict";
__nested_webpack_require_1000339__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1000339__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1000339__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1000339__(/*! ./SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function TimelineSegmentsGetter(config, isDynamic) {
  config = config || {};
  var timelineConverter = config.timelineConverter;
  var dashMetrics = config.dashMetrics;
  var instance;

  function checkConfig() {
    if (!timelineConverter) {
      throw new Error(_streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getMediaFinishedInformation(representation) {
    if (!representation) {
      return 0;
    }

    var base = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate || representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
    var timeline = base.SegmentTimeline;
    var time = 0;
    var scaledTime = 0;
    var availableSegments = 0;
    var fragments, frag, i, len, j, repeat, fTimescale;
    fTimescale = representation.timescale;
    fragments = timeline.S_asArray;
    len = fragments.length;

    for (i = 0; i < len; i++) {
      frag = fragments[i];
      repeat = 0;

      if (frag.hasOwnProperty('r')) {
        repeat = frag.r;
      } // For a repeated S element, t belongs only to the first segment


      if (frag.hasOwnProperty('t')) {
        time = frag.t;
        scaledTime = time / fTimescale;
      } // This is a special case: "A negative value of the @r attribute of the S element indicates that the duration indicated in @d attribute repeats until the start of the next S element, the end of the Period or until the
      // next MPD update."


      if (repeat < 0) {
        var nextFrag = fragments[i + 1];
        repeat = _calculateRepeatCountForNegativeR(representation, nextFrag, frag, fTimescale, scaledTime);
      }

      for (j = 0; j <= repeat; j++) {
        availableSegments++;
        time += frag.d;
        scaledTime = time / fTimescale;
      }
    } // We need to account for the index of the segments starting at 0. We subtract 1


    return {
      numberOfSegments: availableSegments,
      mediaTimeOfLastSignaledSegment: scaledTime
    };
  }

  function iterateSegments(representation, iterFunc) {
    var base = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate || representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
    var timeline = base.SegmentTimeline;
    var list = base.SegmentURL_asArray;
    var time = 0;
    var relativeIdx = -1;
    var fragments, frag, i, len, j, repeat, fTimescale;
    fTimescale = representation.timescale;
    fragments = timeline.S_asArray;
    var breakIterator = false;

    for (i = 0, len = fragments.length; i < len && !breakIterator; i++) {
      frag = fragments[i];
      repeat = 0;

      if (frag.hasOwnProperty('r')) {
        repeat = frag.r;
      } // For a repeated S element, t belongs only to the first segment


      if (frag.hasOwnProperty('t')) {
        time = frag.t;
      } // This is a special case: "A negative value of the @r attribute of the S element indicates that the duration indicated in @d attribute repeats until the start of the next S element, the end of the Period or until the
      // next MPD update."


      if (repeat < 0) {
        var nextFrag = fragments[i + 1];
        repeat = _calculateRepeatCountForNegativeR(representation, nextFrag, frag, fTimescale, time / fTimescale);
      }

      for (j = 0; j <= repeat && !breakIterator; j++) {
        relativeIdx++;
        breakIterator = iterFunc(time, base, list, frag, fTimescale, relativeIdx, i);

        if (breakIterator) {
          representation.segmentDuration = frag.d / fTimescale;
        }

        time += frag.d;
      }
    }
  }

  function _calculateRepeatCountForNegativeR(representation, nextFrag, frag, fTimescale, scaledTime) {
    var repeatEndTime;

    if (nextFrag && nextFrag.hasOwnProperty('t')) {
      repeatEndTime = nextFrag.t / fTimescale;
    } else {
      try {
        var availabilityEnd = 0;

        if (!isNaN(representation.adaptation.period.start) && !isNaN(representation.adaptation.period.duration) && isFinite(representation.adaptation.period.duration)) {
          // use end of the Period
          availabilityEnd = representation.adaptation.period.start + representation.adaptation.period.duration;
        } else {
          // use DVR window
          var dvrWindow = dashMetrics.getCurrentDVRInfo();
          availabilityEnd = !isNaN(dvrWindow.end) ? dvrWindow.end : 0;
        }

        repeatEndTime = timelineConverter.calcMediaTimeFromPresentationTime(availabilityEnd, representation);
        representation.segmentDuration = frag.d / fTimescale;
      } catch (e) {
        repeatEndTime = 0;
      }
    }

    return Math.max(Math.ceil((repeatEndTime - scaledTime) / (frag.d / fTimescale)) - 1, 0);
  }

  function getSegmentByIndex(representation, index, lastSegmentTime) {
    checkConfig();

    if (!representation) {
      return null;
    }

    var segment = null;
    var found = false;
    iterateSegments(representation, function (time, base, list, frag, fTimescale, relativeIdx, i) {
      if (found || lastSegmentTime < 0) {
        var media = base.media;
        var mediaRange = frag.mediaRange;

        if (list) {
          media = list[i].media || '';
          mediaRange = list[i].mediaRange;
        }

        segment = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["getTimeBasedSegment"])(timelineConverter, isDynamic, representation, time, frag.d, fTimescale, media, mediaRange, relativeIdx, frag.tManifest);
        return true;
      } else if (time >= lastSegmentTime * fTimescale - frag.d * 0.5) {
        // same logic, if deviation is
        // 50% of segment duration, segment is found if time is greater than or equal to (startTime of previous segment - half of the previous segment duration)
        found = true;
      }

      return false;
    });
    return segment;
  }

  function getSegmentByTime(representation, requestedTime) {
    checkConfig();

    if (!representation) {
      return null;
    }

    if (requestedTime === undefined) {
      requestedTime = null;
    }

    var segment = null;
    var requiredMediaTime = timelineConverter.calcMediaTimeFromPresentationTime(requestedTime, representation);
    iterateSegments(representation, function (time, base, list, frag, fTimescale, relativeIdx, i) {
      // In some cases when requiredMediaTime = actual end time of the last segment
      // it is possible that this time a bit exceeds the declared end time of the last segment.
      // in this case we still need to include the last segment in the segment list.
      var scaledMediaTime = precisionRound(requiredMediaTime * fTimescale);

      if (scaledMediaTime < time + frag.d && scaledMediaTime >= time) {
        var media = base.media;
        var mediaRange = frag.mediaRange;

        if (list) {
          media = list[i].media || '';
          mediaRange = list[i].mediaRange;
        }

        segment = Object(_SegmentsUtils__WEBPACK_IMPORTED_MODULE_2__["getTimeBasedSegment"])(timelineConverter, isDynamic, representation, time, frag.d, fTimescale, media, mediaRange, relativeIdx, frag.tManifest);
        return true;
      }

      return false;
    });
    return segment;
  }

  function precisionRound(number) {
    return parseFloat(number.toPrecision(15));
  }

  instance = {
    getSegmentByIndex: getSegmentByIndex,
    getSegmentByTime: getSegmentByTime,
    getMediaFinishedInformation: getMediaFinishedInformation
  };
  return instance;
}

TimelineSegmentsGetter.__dashjs_factory_name = 'TimelineSegmentsGetter';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(TimelineSegmentsGetter);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/dash/vo/AdaptationSet.js":
/*!**************************************!*\
  !*** ./src/dash/vo/AdaptationSet.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1011573__) {

"use strict";
__nested_webpack_require_1011573__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var AdaptationSet = function AdaptationSet() {
  _classCallCheck(this, AdaptationSet);

  this.period = null;
  this.index = -1;
  this.type = null;
};

/* harmony default export */ __webpack_exports__["default"] = (AdaptationSet);

/***/ }),

/***/ "./src/dash/vo/BaseURL.js":
/*!********************************!*\
  !*** ./src/dash/vo/BaseURL.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1014201__) {

"use strict";
__nested_webpack_require_1014201__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DEFAULT_DVB_PRIORITY = 1;
var DEFAULT_DVB_WEIGHT = 1;

var BaseURL = function BaseURL(url, serviceLocation, priority, weight) {
  _classCallCheck(this, BaseURL);

  this.url = url || '';
  this.serviceLocation = serviceLocation || url || ''; // DVB extensions

  this.dvb_priority = priority || DEFAULT_DVB_PRIORITY;
  this.dvb_weight = weight || DEFAULT_DVB_WEIGHT;
  this.availabilityTimeOffset = 0;
  this.availabilityTimeComplete = true;
  /* currently unused:
   * byteRange,
   */
};

BaseURL.DEFAULT_DVB_PRIORITY = DEFAULT_DVB_PRIORITY;
BaseURL.DEFAULT_DVB_WEIGHT = DEFAULT_DVB_WEIGHT;
/* harmony default export */ __webpack_exports__["default"] = (BaseURL);

/***/ }),

/***/ "./src/dash/vo/Event.js":
/*!******************************!*\
  !*** ./src/dash/vo/Event.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1017271__) {

"use strict";
__nested_webpack_require_1017271__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Event = function Event() {
  _classCallCheck(this, Event);

  this.duration = NaN;
  this.presentationTime = NaN;
  this.id = NaN;
  this.messageData = '';
  this.eventStream = null;
  this.presentationTimeDelta = NaN; // Specific EMSG Box parameter
};

/* harmony default export */ __webpack_exports__["default"] = (Event);

/***/ }),

/***/ "./src/dash/vo/EventStream.js":
/*!************************************!*\
  !*** ./src/dash/vo/EventStream.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1020015__) {

"use strict";
__nested_webpack_require_1020015__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var EventStream = function EventStream() {
  _classCallCheck(this, EventStream);

  this.adaptionSet = null;
  this.representation = null;
  this.period = null;
  this.timescale = 1;
  this.value = '';
  this.schemeIdUri = '';
  this.presentationTimeOffset = 0;
};

/* harmony default export */ __webpack_exports__["default"] = (EventStream);

/***/ }),

/***/ "./src/dash/vo/ManifestInfo.js":
/*!*************************************!*\
  !*** ./src/dash/vo/ManifestInfo.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1022778__) {

"use strict";
__nested_webpack_require_1022778__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var ManifestInfo = function ManifestInfo() {
  _classCallCheck(this, ManifestInfo);

  this.dvrWindowSize = NaN;
  this.loadedTime = null;
  this.availableFrom = null;
  this.minBufferTime = NaN;
  this.duration = NaN;
  this.isDynamic = false;
  this.maxFragmentDuration = null;
};

/* harmony default export */ __webpack_exports__["default"] = (ManifestInfo);

/***/ }),

/***/ "./src/dash/vo/MediaInfo.js":
/*!**********************************!*\
  !*** ./src/dash/vo/MediaInfo.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1025548__) {

"use strict";
__nested_webpack_require_1025548__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var MediaInfo = function MediaInfo() {
  _classCallCheck(this, MediaInfo);

  this.id = null;
  this.index = null;
  this.type = null;
  this.streamInfo = null;
  this.representationCount = 0;
  this.labels = null;
  this.lang = null;
  this.viewpoint = null;
  this.accessibility = null;
  this.audioChannelConfiguration = null;
  this.roles = null;
  this.codec = null;
  this.mimeType = null;
  this.contentProtection = null;
  this.KID = null;
  this.bitrateList = null;
  this.isFragmented = null;
  this.isEmbedded = null;
  this.selectionPriority = 1;
};

/* harmony default export */ __webpack_exports__["default"] = (MediaInfo);

/***/ }),

/***/ "./src/dash/vo/Mpd.js":
/*!****************************!*\
  !*** ./src/dash/vo/Mpd.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1028582__) {

"use strict";
__nested_webpack_require_1028582__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Mpd = function Mpd() {
  _classCallCheck(this, Mpd);

  this.manifest = null;
  this.suggestedPresentationDelay = 0;
  this.availabilityStartTime = null;
  this.availabilityEndTime = Number.POSITIVE_INFINITY;
  this.timeShiftBufferDepth = Number.POSITIVE_INFINITY;
  this.maxSegmentDuration = Number.POSITIVE_INFINITY;
  this.publishTime = null;
  this.minimumUpdatePeriod = NaN;
  this.mediaPresentationDuration = NaN;
};

/* harmony default export */ __webpack_exports__["default"] = (Mpd);

/***/ }),

/***/ "./src/dash/vo/PatchOperation.js":
/*!***************************************!*\
  !*** ./src/dash/vo/PatchOperation.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1031509__) {

"use strict";
__nested_webpack_require_1031509__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var PatchOperation = /*#__PURE__*/function () {
  function PatchOperation(action, xpath, value) {
    _classCallCheck(this, PatchOperation);

    this.action = action;
    this.xpath = xpath;
    this.value = value;
    this.position = null;
  }

  _createClass(PatchOperation, [{
    key: "getMpdTarget",
    value: function getMpdTarget(root) {
      var isSiblingOperation = this.action === 'remove' || this.action === 'replace' || this.position === 'before' || this.position === 'after';
      return this.xpath.getMpdTarget(root, isSiblingOperation);
    }
  }]);

  return PatchOperation;
}();

/* harmony default export */ __webpack_exports__["default"] = (PatchOperation);

/***/ }),

/***/ "./src/dash/vo/Period.js":
/*!*******************************!*\
  !*** ./src/dash/vo/Period.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1035135__) {

"use strict";
__nested_webpack_require_1035135__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Period = function Period() {
  _classCallCheck(this, Period);

  this.id = null;
  this.index = -1;
  this.duration = NaN;
  this.start = NaN;
  this.mpd = null;
  this.nextPeriodId = null;
};

Period.DEFAULT_ID = 'defaultId';
/* harmony default export */ __webpack_exports__["default"] = (Period);

/***/ }),

/***/ "./src/dash/vo/ProducerReferenceTime.js":
/*!**********************************************!*\
  !*** ./src/dash/vo/ProducerReferenceTime.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1037894__) {

"use strict";
__nested_webpack_require_1037894__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var ProducerReferenceTime = function ProducerReferenceTime() {
  _classCallCheck(this, ProducerReferenceTime);

  this.id = null;
  this.inband = false;
  this.type = 'encoder';
  this.applicationScheme = null;
  this.wallClockTime = null;
  this.presentationTime = NaN;
  this.UTCTiming = null;
};

/* harmony default export */ __webpack_exports__["default"] = (ProducerReferenceTime);

/***/ }),

/***/ "./src/dash/vo/Representation.js":
/*!***************************************!*\
  !*** ./src/dash/vo/Representation.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1040709__) {

"use strict";
__nested_webpack_require_1040709__.r(__webpack_exports__);
/* harmony import */ var _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1040709__(/*! ../constants/DashConstants */ "./src/dash/constants/DashConstants.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */


var Representation = /*#__PURE__*/function () {
  function Representation() {
    _classCallCheck(this, Representation);

    this.id = null;
    this.index = -1;
    this.adaptation = null;
    this.segmentInfoType = null;
    this.initialization = null;
    this.codecs = null;
    this.mimeType = null;
    this.codecPrivateData = null;
    this.segmentDuration = NaN;
    this.timescale = 1;
    this.startNumber = 1;
    this.indexRange = null;
    this.range = null;
    this.presentationTimeOffset = 0; // Set the source buffer timeOffset to this

    this.MSETimeOffset = NaN; // The information we need in the DashHandler to determine whether the last segment has been loaded

    this.mediaFinishedInformation = {
      numberOfSegments: 0,
      mediaTimeOfLastSignaledSegment: NaN
    };
    this.bandwidth = NaN;
    this.width = NaN;
    this.height = NaN;
    this.scanType = null;
    this.maxPlayoutRate = NaN;
    this.availabilityTimeOffset = 0;
    this.availabilityTimeComplete = true;
  }

  _createClass(Representation, [{
    key: "hasInitialization",
    value: function hasInitialization() {
      return this.initialization !== null || this.range !== null;
    }
  }, {
    key: "hasSegments",
    value: function hasSegments() {
      return this.segmentInfoType !== _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].BASE_URL && this.segmentInfoType !== _constants_DashConstants__WEBPACK_IMPORTED_MODULE_0__["default"].SEGMENT_BASE && !this.indexRange;
    }
  }]);

  return Representation;
}();

/* harmony default export */ __webpack_exports__["default"] = (Representation);

/***/ }),

/***/ "./src/dash/vo/RepresentationInfo.js":
/*!*******************************************!*\
  !*** ./src/dash/vo/RepresentationInfo.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1045533__) {

"use strict";
__nested_webpack_require_1045533__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var RepresentationInfo = function RepresentationInfo() {
  _classCallCheck(this, RepresentationInfo);

  this.id = null;
  this.quality = null;
  this.fragmentDuration = null;
  this.mediaInfo = null;
  this.MSETimeOffset = null;
};

/* harmony default export */ __webpack_exports__["default"] = (RepresentationInfo);

/***/ }),

/***/ "./src/dash/vo/Segment.js":
/*!********************************!*\
  !*** ./src/dash/vo/Segment.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1048249__) {

"use strict";
__nested_webpack_require_1048249__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Segment = function Segment() {
  _classCallCheck(this, Segment);

  this.indexRange = null; // The index of the segment in the list of segments. We start at 0

  this.index = null;
  this.mediaRange = null;
  this.media = null;
  this.duration = NaN; // this is the time that should be inserted into the media url

  this.replacementTime = null; // this is the number that should be inserted into the media url

  this.replacementNumber = NaN; // This is supposed to match the time encoded in the media Segment

  this.mediaStartTime = NaN; // When the source buffer timeOffset is set to MSETimeOffset this is the
  // time that will match the seekTarget and video.currentTime

  this.presentationStartTime = NaN; // Do not schedule this segment until

  this.availabilityStartTime = NaN; // Ignore and  discard this segment after

  this.availabilityEndTime = NaN; // For dynamic mpd's, this is the wall clock time that the video
  // element currentTime should be presentationStartTime

  this.wallStartTime = NaN;
  this.representation = null;
};

/* harmony default export */ __webpack_exports__["default"] = (Segment);

/***/ }),

/***/ "./src/dash/vo/SimpleXPath.js":
/*!************************************!*\
  !*** ./src/dash/vo/SimpleXPath.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1051809__) {

"use strict";
__nested_webpack_require_1051809__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var SimpleXPath = /*#__PURE__*/function () {
  function SimpleXPath(selector) {
    var _this = this;

    _classCallCheck(this, SimpleXPath);

    // establish validation of the path, to catch unsupported cases
    this.valid = selector[0] == '/'; // first check, we only support absolute addressing
    // establish parsed path, example:
    // /MPD/Period[@id="foobar"]/AdaptationSet[@id="2"]/SegmentTemplate/SegmentTimeline

    this.path = selector.split('/').filter(function (component) {
      return component.length !== 0;
    }) // remove excess empty components
    .map(function (component) {
      var parsed = {
        name: component
      };
      var qualifierPoint = component.indexOf('[');

      if (qualifierPoint != -1) {
        parsed.name = component.substring(0, qualifierPoint);
        var qualifier = component.substring(qualifierPoint + 1, component.length - 1); // quick sanity check are there additional qualifiers making this invalid

        _this.valid = _this.valid && qualifier.indexOf('[') == -1;
        var equalityPoint = qualifier.indexOf('=');

        if (equalityPoint != -1) {
          parsed.attribute = {
            name: qualifier.substring(1, equalityPoint),
            // skip the @
            value: qualifier.substring(equalityPoint + 1)
          }; // check for single and double quoted attribute values

          if (['\'', '"'].indexOf(parsed.attribute.value[0]) != -1) {
            parsed.attribute.value = parsed.attribute.value.substring(1, parsed.attribute.value.length - 1);
          }
        } else {
          // positional access in xpath is 1-based index
          // internal processes will assume 0-based so we normalize that here
          parsed.position = parseInt(qualifier, 10) - 1;
        }
      }

      return parsed;
    });
  }

  _createClass(SimpleXPath, [{
    key: "isValid",
    value: function isValid() {
      return this.valid;
    }
  }, {
    key: "findsElement",
    value: function findsElement() {
      return !this.findsAttribute();
    }
  }, {
    key: "findsAttribute",
    value: function findsAttribute() {
      return this.path[this.path.length - 1].name.startsWith('@');
    }
  }, {
    key: "getMpdTarget",
    value: function getMpdTarget(root, isSiblingOperation) {
      var parent = null;
      var leaf = root; // assume root is MPD and we start at next level match

      var level = 1;
      var name = 'MPD';

      while (level < this.path.length && leaf !== null) {
        // set parent to current
        parent = leaf; // select next leaf based on component

        var component = this.path[level];
        name = component.name; // stop one early if this is the last element and an attribute

        if (level !== this.path.length - 1 || !name.startsWith('@')) {
          var children = parent[name + '_asArray'] || [];

          if (children.length === 0 && parent[name]) {
            children.push(parent[name]);
          }

          if (component.position) {
            leaf = children[component.position] || null;
          } else if (component.attribute) {
            (function () {
              var attr = component.attribute;
              leaf = children.filter(function (elm) {
                return elm[attr.name] == attr.value;
              })[0] || null;
            })();
          } else {
            // default case, select first
            leaf = children[0] || null;
          }
        }

        level++;
      }

      if (leaf === null) {
        // given path not found in root
        return null;
      } // attributes the target is the leaf node, the name is the attribute


      if (name.startsWith('@')) {
        return {
          name: name.substring(1),
          leaf: leaf,
          target: leaf
        };
      } // otherwise we target the parent for sibling operations and leaf for child operations


      return {
        name: name,
        leaf: leaf,
        target: isSiblingOperation ? parent : leaf
      };
    }
  }]);

  return SimpleXPath;
}();

/* harmony default export */ __webpack_exports__["default"] = (SimpleXPath);

/***/ }),

/***/ "./src/dash/vo/StreamInfo.js":
/*!***********************************!*\
  !*** ./src/dash/vo/StreamInfo.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1058996__) {

"use strict";
__nested_webpack_require_1058996__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var StreamInfo = function StreamInfo() {
  _classCallCheck(this, StreamInfo);

  this.id = null;
  this.index = null;
  this.start = NaN;
  this.duration = NaN;
  this.manifestInfo = null;
  this.isLast = true;
};

/* harmony default export */ __webpack_exports__["default"] = (StreamInfo);

/***/ }),

/***/ "./src/dash/vo/UTCTiming.js":
/*!**********************************!*\
  !*** ./src/dash/vo/UTCTiming.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1061694__) {

"use strict";
__nested_webpack_require_1061694__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var UTCTiming = function UTCTiming() {
  _classCallCheck(this, UTCTiming);

  // UTCTiming is a DescriptorType and doesn't have any additional fields
  this.schemeIdUri = '';
  this.value = '';
};

/* harmony default export */ __webpack_exports__["default"] = (UTCTiming);

/***/ }),

/***/ "./src/streaming/FragmentLoader.js":
/*!*****************************************!*\
  !*** ./src/streaming/FragmentLoader.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1064399__) {

"use strict";
__nested_webpack_require_1064399__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1064399__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _net_URLLoader__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1064399__(/*! ./net/URLLoader */ "./src/streaming/net/URLLoader.js");
/* harmony import */ var _vo_HeadRequest__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1064399__(/*! ./vo/HeadRequest */ "./src/streaming/vo/HeadRequest.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1064399__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1064399__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function FragmentLoader(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus;
  var events = config.events;
  var urlUtils = config.urlUtils;
  var errors = config.errors;
  var streamId = config.streamId;
  var instance, urlLoader;

  function setup() {
    urlLoader = Object(_net_URLLoader__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
      errHandler: config.errHandler,
      errors: errors,
      dashMetrics: config.dashMetrics,
      mediaPlayerModel: config.mediaPlayerModel,
      requestModifier: config.requestModifier,
      urlUtils: urlUtils,
      constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"],
      boxParser: config.boxParser,
      dashConstants: config.dashConstants,
      requestTimeout: config.settings.get().streaming.fragmentRequestTimeout
    });
  }

  function checkForExistence(request) {
    var report = function report(success) {
      eventBus.trigger(events.CHECK_FOR_EXISTENCE_COMPLETED, {
        request: request,
        exists: success
      });
    };

    if (request) {
      var headRequest = new _vo_HeadRequest__WEBPACK_IMPORTED_MODULE_2__["default"](request.url);
      urlLoader.load({
        request: headRequest,
        success: function success() {
          report(true);
        },
        error: function error() {
          report(false);
        }
      });
    } else {
      report(false);
    }
  }

  function load(request) {
    var report = function report(data, error) {
      eventBus.trigger(events.LOADING_COMPLETED, {
        request: request,
        response: data || null,
        error: error || null,
        sender: instance
      });
    };

    if (request) {
      urlLoader.load({
        request: request,
        progress: function progress(event) {
          eventBus.trigger(events.LOADING_PROGRESS, {
            request: request,
            stream: event.stream,
            streamId: streamId
          });

          if (event.data) {
            eventBus.trigger(events.LOADING_DATA_PROGRESS, {
              request: request,
              response: event.data || null,
              error: null,
              sender: instance
            });
          }
        },
        success: function success(data) {
          report(data);
        },
        error: function error(request, statusText, errorText) {
          report(undefined, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](errors.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE, errorText, statusText));
        },
        abort: function abort(request) {
          if (request) {
            eventBus.trigger(events.LOADING_ABANDONED, {
              mediaType: request.mediaType,
              request: request,
              sender: instance
            });
          }
        }
      });
    } else {
      report(undefined, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](errors.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE, errors.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE));
    }
  }

  function abort() {
    if (urlLoader) {
      urlLoader.abort();
    }
  }

  function reset() {
    if (urlLoader) {
      urlLoader.abort();
      urlLoader = null;
    }
  }

  instance = {
    checkForExistence: checkForExistence,
    load: load,
    abort: abort,
    reset: reset
  };
  setup();
  return instance;
}

FragmentLoader.__dashjs_factory_name = 'FragmentLoader';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__["default"].getClassFactory(FragmentLoader));

/***/ }),

/***/ "./src/streaming/ManifestLoader.js":
/*!*****************************************!*\
  !*** ./src/streaming/ManifestLoader.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1071137__) {

"use strict";
__nested_webpack_require_1071137__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1071137__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1071137__(/*! ../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _controllers_XlinkController__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1071137__(/*! ./controllers/XlinkController */ "./src/streaming/controllers/XlinkController.js");
/* harmony import */ var _net_URLLoader__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1071137__(/*! ./net/URLLoader */ "./src/streaming/net/URLLoader.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1071137__(/*! ./utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _vo_TextRequest__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1071137__(/*! ./vo/TextRequest */ "./src/streaming/vo/TextRequest.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1071137__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1071137__(/*! ./vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1071137__(/*! ../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1071137__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1071137__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1071137__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _dash_parser_DashParser__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1071137__(/*! ../dash/parser/DashParser */ "./src/dash/parser/DashParser.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */














function ManifestLoader(config) {
  config = config || {};
  var context = this.context;
  var debug = config.debug;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var instance, logger, urlLoader, xlinkController, parser;
  var mssHandler = config.mssHandler;
  var errHandler = config.errHandler;

  function setup() {
    logger = debug.getLogger(instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].XLINK_READY, onXlinkReady, instance);
    urlLoader = Object(_net_URLLoader__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
      errHandler: config.errHandler,
      dashMetrics: config.dashMetrics,
      mediaPlayerModel: config.mediaPlayerModel,
      requestModifier: config.requestModifier,
      urlUtils: urlUtils,
      constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"],
      dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
      errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"]
    });
    xlinkController = Object(_controllers_XlinkController__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
      errHandler: errHandler,
      dashMetrics: config.dashMetrics,
      mediaPlayerModel: config.mediaPlayerModel,
      requestModifier: config.requestModifier,
      settings: config.settings
    });
    parser = null;
  }

  function onXlinkReady(event) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
      manifest: event.manifest
    });
  }

  function createParser(data) {
    var parser = null; // Analyze manifest content to detect protocol and select appropriate parser

    if (data.indexOf('SmoothStreamingMedia') > -1) {
      //do some business to transform it into a Dash Manifest
      if (mssHandler) {
        parser = mssHandler.createMssParser();
        mssHandler.registerEvents();
      }

      return parser;
    } else if (data.indexOf('MPD') > -1 || data.indexOf('Patch') > -1) {
      return Object(_dash_parser_DashParser__WEBPACK_IMPORTED_MODULE_12__["default"])(context).create({
        debug: debug
      });
    } else {
      return parser;
    }
  }

  function load(url) {
    var request = new _vo_TextRequest__WEBPACK_IMPORTED_MODULE_5__["default"](url, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].MPD_TYPE);
    urlLoader.load({
      request: request,
      success: function success(data, textStatus, responseURL) {
        // Manage situations in which success is called after calling reset
        if (!xlinkController) return;
        var actualUrl, baseUri, manifest; // Handle redirects for the MPD - as per RFC3986 Section 5.1.3
        // also handily resolves relative MPD URLs to absolute

        if (responseURL && responseURL !== url) {
          baseUri = urlUtils.parseBaseUrl(responseURL);
          actualUrl = responseURL;
        } else {
          // usually this case will be caught and resolved by
          // responseURL above but it is not available for IE11 and Edge/12 and Edge/13
          // baseUri must be absolute for BaseURL resolution later
          if (urlUtils.isRelative(url)) {
            url = urlUtils.resolve(url, window.location.href);
          }

          baseUri = urlUtils.parseBaseUrl(url);
        } // A response of no content implies in-memory is properly up to date


        if (textStatus == 'No Content') {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
            manifest: null
          });
          return;
        } // Create parser according to manifest type


        if (parser === null) {
          parser = createParser(data);
        }

        if (parser === null) {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
            manifest: null,
            error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(url))
          });
          return;
        } // init xlinkcontroller with matchers and iron object from created parser


        xlinkController.setMatchers(parser.getMatchers());
        xlinkController.setIron(parser.getIron());

        try {
          manifest = parser.parse(data);
        } catch (e) {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
            manifest: null,
            error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(url))
          });
          return;
        }

        if (manifest) {
          manifest.url = actualUrl || url; // URL from which the MPD was originally retrieved (MPD updates will not change this value)

          if (!manifest.originalUrl) {
            manifest.originalUrl = manifest.url;
          } // In the following, we only use the first Location entry even if many are available
          // Compare with ManifestUpdater/DashManifestModel


          if (manifest.hasOwnProperty(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].LOCATION)) {
            baseUri = urlUtils.parseBaseUrl(manifest.Location_asArray[0]);
            logger.debug('BaseURI set by Location to: ' + baseUri);
          }

          manifest.baseUri = baseUri;
          manifest.loadedTime = new Date();
          xlinkController.resolveManifestOnLoad(manifest);
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].ORIGINAL_MANIFEST_LOADED, {
            originalManifest: data
          });
        } else {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
            manifest: null,
            error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE + "".concat(url))
          });
        }
      },
      error: function error(request, statusText, errorText) {
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].INTERNAL_MANIFEST_LOADED, {
          manifest: null,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE + "".concat(url, ", ").concat(errorText))
        });
      }
    });
  }

  function reset() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].XLINK_READY, onXlinkReady, instance);

    if (mssHandler) {
      mssHandler.reset();
    }

    if (xlinkController) {
      xlinkController.reset();
      xlinkController = null;
    }

    if (urlLoader) {
      urlLoader.abort();
      urlLoader = null;
    }
  }

  instance = {
    load: load,
    reset: reset
  };
  setup();
  return instance;
}

ManifestLoader.__dashjs_factory_name = 'ManifestLoader';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_11__["default"].getClassFactory(ManifestLoader);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/ManifestUpdater.js":
/*!******************************************!*\
  !*** ./src/streaming/ManifestUpdater.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1083651__) {

"use strict";
__nested_webpack_require_1083651__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1083651__(/*! ../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1083651__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1083651__(/*! ../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1083651__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1083651__(/*! ../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1083651__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1083651__(/*! ../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1083651__(/*! ./utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









function ManifestUpdater() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
  var instance, logger, refreshDelay, refreshTimer, isPaused, isStopped, isUpdating, manifestLoader, manifestModel, adapter, errHandler, settings;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance().getLogger(instance);
  }

  function setConfig(config) {
    if (!config) return;

    if (config.manifestModel) {
      manifestModel = config.manifestModel;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }

    if (config.manifestLoader) {
      manifestLoader = config.manifestLoader;
    }

    if (config.errHandler) {
      errHandler = config.errHandler;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }

  function initialize() {
    resetInitialSettings();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].STREAMS_COMPOSED, onStreamsComposed, this);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_STARTED, onPlaybackStarted, this);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PAUSED, onPlaybackPaused, this);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].INTERNAL_MANIFEST_LOADED, onManifestLoaded, this);
  }

  function setManifest(manifest) {
    update(manifest);
  }

  function resetInitialSettings() {
    refreshDelay = NaN;
    isUpdating = false;
    isPaused = true;
    isStopped = false;
    stopManifestRefreshTimer();
  }

  function reset() {
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_STARTED, onPlaybackStarted, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PAUSED, onPlaybackPaused, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].STREAMS_COMPOSED, onStreamsComposed, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].INTERNAL_MANIFEST_LOADED, onManifestLoaded, this);
    resetInitialSettings();
  }

  function stopManifestRefreshTimer() {
    if (refreshTimer !== null) {
      clearTimeout(refreshTimer);
      refreshTimer = null;
    }
  }

  function startManifestRefreshTimer(delay) {
    stopManifestRefreshTimer();

    if (isStopped) {
      return;
    }

    if (isNaN(delay) && !isNaN(refreshDelay)) {
      delay = refreshDelay * 1000;
    }

    if (!isNaN(delay)) {
      logger.debug('Refresh manifest in ' + delay + ' milliseconds.');
      refreshTimer = setTimeout(onRefreshTimer, delay);
    }
  }

  function refreshManifest() {
    var ignorePatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    isUpdating = true;
    var manifest = manifestModel.getValue(); // default to the original url in the manifest

    var url = manifest.url; // Check for PatchLocation and Location alternatives

    var patchLocation = adapter.getPatchLocation(manifest);
    var location = adapter.getLocation(manifest);

    if (patchLocation && !ignorePatch) {
      url = patchLocation;
    } else if (location) {
      url = location;
    } // if one of the alternatives was relative, convert to absolute


    if (urlUtils.isRelative(url)) {
      url = urlUtils.resolve(url, manifest.url);
    }

    manifestLoader.load(url);
  }

  function update(manifest) {
    if (!manifest) {
      // successful update with no content implies existing manifest remains valid
      manifest = manifestModel.getValue(); // override load time to avoid invalid latency tracking and ensure update cadence

      manifest.loadedTime = new Date();
    } else if (adapter.getIsPatch(manifest)) {
      // with patches the in-memory manifest is our base
      var patch = manifest;
      manifest = manifestModel.getValue(); // check for patch validity

      var isPatchValid = adapter.isPatchValid(manifest, patch);
      var patchSuccessful = isPatchValid;

      if (isPatchValid) {
        // grab publish time before update
        var publishTime = adapter.getPublishTime(manifest); // apply validated patch to manifest

        patchSuccessful = adapter.applyPatchToManifest(manifest, patch); // get the updated publish time

        var updatedPublishTime = adapter.getPublishTime(manifest); // ensure the patch properly updated the in-memory publish time

        patchSuccessful = publishTime.getTime() != updatedPublishTime.getTime();
      } // if the patch failed to apply, force a full manifest refresh


      if (!patchSuccessful) {
        logger.debug('Patch provided is invalid, performing full manifest refresh');
        refreshManifest(true);
        return;
      } // override load time to avoid invalid latency tracking and ensure update cadence


      manifest.loadedTime = new Date();
    } // See DASH-IF IOP v4.3 section 4.6.4 "Transition Phase between Live and On-Demand"
    // Stop manifest update, ignore static manifest and signal end of dynamic stream to detect end of stream


    if (manifestModel.getValue() && manifestModel.getValue().type === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].DYNAMIC && manifest.type === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].STATIC) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].DYNAMIC_TO_STATIC);
      isUpdating = false;
      isStopped = true;
      return;
    }

    manifestModel.setValue(manifest);
    var date = new Date();
    var latencyOfLastUpdate = (date.getTime() - manifest.loadedTime.getTime()) / 1000;
    refreshDelay = adapter.getManifestUpdatePeriod(manifest, latencyOfLastUpdate); // setTimeout uses a 32 bit number to store the delay. Any number greater than it
    // will cause event associated with setTimeout to trigger immediately

    if (refreshDelay * 1000 > 0x7FFFFFFF) {
      refreshDelay = 0x7FFFFFFF / 1000;
    }

    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATED, {
      manifest: manifest
    });
    logger.info('Manifest has been refreshed at ' + date + '[' + date.getTime() / 1000 + '] ');

    if (!isPaused) {
      startManifestRefreshTimer();
    }
  }

  function onRefreshTimer() {
    if (isPaused) {
      return;
    }

    if (isUpdating) {
      startManifestRefreshTimer(settings.get().streaming.manifestUpdateRetryInterval);
      return;
    }

    refreshManifest();
  }

  function onManifestLoaded(e) {
    if (!e.error) {
      update(e.manifest);
    } else if (e.error.code === _core_errors_Errors__WEBPACK_IMPORTED_MODULE_5__["default"].MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE) {
      errHandler.error(e.error);
    }
  }

  function onPlaybackStarted()
  /*e*/
  {
    isPaused = false;
    startManifestRefreshTimer();
  }

  function onPlaybackPaused()
  /*e*/
  {
    isPaused = !settings.get().streaming.scheduling.scheduleWhilePaused;

    if (isPaused) {
      stopManifestRefreshTimer();
    }
  }

  function onStreamsComposed()
  /*e*/
  {
    // When streams are ready we can consider manifest update completed. Resolve the update promise.
    isUpdating = false;
  }

  function getIsUpdating() {
    return isUpdating;
  }

  instance = {
    initialize: initialize,
    setManifest: setManifest,
    refreshManifest: refreshManifest,
    getIsUpdating: getIsUpdating,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

ManifestUpdater.__dashjs_factory_name = 'ManifestUpdater';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getClassFactory(ManifestUpdater));

/***/ }),

/***/ "./src/streaming/MediaPlayer.js":
/*!**************************************!*\
  !*** ./src/streaming/MediaPlayer.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1095335__) {

"use strict";
__nested_webpack_require_1095335__.r(__webpack_exports__);
/* harmony import */ var _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1095335__(/*! ../../externals/cea608-parser */ "./externals/cea608-parser.js");
/* harmony import */ var _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_1095335__.n(_externals_cea608_parser__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1095335__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1095335__(/*! ../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1095335__(/*! ./constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _controllers_PlaybackController__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1095335__(/*! ./controllers/PlaybackController */ "./src/streaming/controllers/PlaybackController.js");
/* harmony import */ var _controllers_StreamController__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1095335__(/*! ./controllers/StreamController */ "./src/streaming/controllers/StreamController.js");
/* harmony import */ var _controllers_GapController__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1095335__(/*! ./controllers/GapController */ "./src/streaming/controllers/GapController.js");
/* harmony import */ var _controllers_CatchupController__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1095335__(/*! ./controllers/CatchupController */ "./src/streaming/controllers/CatchupController.js");
/* harmony import */ var _controllers_ServiceDescriptionController__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1095335__(/*! ./controllers/ServiceDescriptionController */ "./src/streaming/controllers/ServiceDescriptionController.js");
/* harmony import */ var _controllers_MediaController__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1095335__(/*! ./controllers/MediaController */ "./src/streaming/controllers/MediaController.js");
/* harmony import */ var _controllers_BaseURLController__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1095335__(/*! ./controllers/BaseURLController */ "./src/streaming/controllers/BaseURLController.js");
/* harmony import */ var _ManifestLoader__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1095335__(/*! ./ManifestLoader */ "./src/streaming/ManifestLoader.js");
/* harmony import */ var _utils_ErrorHandler__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1095335__(/*! ./utils/ErrorHandler */ "./src/streaming/utils/ErrorHandler.js");
/* harmony import */ var _utils_Capabilities__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1095335__(/*! ./utils/Capabilities */ "./src/streaming/utils/Capabilities.js");
/* harmony import */ var _utils_CapabilitiesFilter__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_1095335__(/*! ./utils/CapabilitiesFilter */ "./src/streaming/utils/CapabilitiesFilter.js");
/* harmony import */ var _utils_RequestModifier__WEBPACK_IMPORTED_MODULE_15__ = __nested_webpack_require_1095335__(/*! ./utils/RequestModifier */ "./src/streaming/utils/RequestModifier.js");
/* harmony import */ var _models_URIFragmentModel__WEBPACK_IMPORTED_MODULE_16__ = __nested_webpack_require_1095335__(/*! ./models/URIFragmentModel */ "./src/streaming/models/URIFragmentModel.js");
/* harmony import */ var _models_ManifestModel__WEBPACK_IMPORTED_MODULE_17__ = __nested_webpack_require_1095335__(/*! ./models/ManifestModel */ "./src/streaming/models/ManifestModel.js");
/* harmony import */ var _models_MediaPlayerModel__WEBPACK_IMPORTED_MODULE_18__ = __nested_webpack_require_1095335__(/*! ./models/MediaPlayerModel */ "./src/streaming/models/MediaPlayerModel.js");
/* harmony import */ var _controllers_AbrController__WEBPACK_IMPORTED_MODULE_19__ = __nested_webpack_require_1095335__(/*! ./controllers/AbrController */ "./src/streaming/controllers/AbrController.js");
/* harmony import */ var _net_SchemeLoaderFactory__WEBPACK_IMPORTED_MODULE_20__ = __nested_webpack_require_1095335__(/*! ./net/SchemeLoaderFactory */ "./src/streaming/net/SchemeLoaderFactory.js");
/* harmony import */ var _models_VideoModel__WEBPACK_IMPORTED_MODULE_21__ = __nested_webpack_require_1095335__(/*! ./models/VideoModel */ "./src/streaming/models/VideoModel.js");
/* harmony import */ var _models_CmcdModel__WEBPACK_IMPORTED_MODULE_22__ = __nested_webpack_require_1095335__(/*! ./models/CmcdModel */ "./src/streaming/models/CmcdModel.js");
/* harmony import */ var _utils_DOMStorage__WEBPACK_IMPORTED_MODULE_23__ = __nested_webpack_require_1095335__(/*! ./utils/DOMStorage */ "./src/streaming/utils/DOMStorage.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_24__ = __nested_webpack_require_1095335__(/*! ./../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__ = __nested_webpack_require_1095335__(/*! ./../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_26__ = __nested_webpack_require_1095335__(/*! ./../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_27__ = __nested_webpack_require_1095335__(/*! ./../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_28__ = __nested_webpack_require_1095335__(/*! ./MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_29__ = __nested_webpack_require_1095335__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_30__ = __nested_webpack_require_1095335__(/*! ../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _core_Version__WEBPACK_IMPORTED_MODULE_31__ = __nested_webpack_require_1095335__(/*! ../core/Version */ "./src/core/Version.js");
/* harmony import */ var _dash_controllers_SegmentBaseController__WEBPACK_IMPORTED_MODULE_32__ = __nested_webpack_require_1095335__(/*! ../dash/controllers/SegmentBaseController */ "./src/dash/controllers/SegmentBaseController.js");
/* harmony import */ var _dash_DashAdapter__WEBPACK_IMPORTED_MODULE_33__ = __nested_webpack_require_1095335__(/*! ../dash/DashAdapter */ "./src/dash/DashAdapter.js");
/* harmony import */ var _dash_DashMetrics__WEBPACK_IMPORTED_MODULE_34__ = __nested_webpack_require_1095335__(/*! ../dash/DashMetrics */ "./src/dash/DashMetrics.js");
/* harmony import */ var _dash_utils_TimelineConverter__WEBPACK_IMPORTED_MODULE_35__ = __nested_webpack_require_1095335__(/*! ../dash/utils/TimelineConverter */ "./src/dash/utils/TimelineConverter.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_36__ = __nested_webpack_require_1095335__(/*! ./vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _externals_base64__WEBPACK_IMPORTED_MODULE_37__ = __nested_webpack_require_1095335__(/*! ../../externals/base64 */ "./externals/base64.js");
/* harmony import */ var _externals_base64__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__nested_webpack_require_1095335__.n(_externals_base64__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_38__ = __nested_webpack_require_1095335__(/*! codem-isoboxer */ "./node_modules/codem-isoboxer/dist/iso_boxer.js");
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__nested_webpack_require_1095335__.n(codem_isoboxer__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_39__ = __nested_webpack_require_1095335__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_40__ = __nested_webpack_require_1095335__(/*! ./utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/* harmony import */ var _ManifestUpdater__WEBPACK_IMPORTED_MODULE_41__ = __nested_webpack_require_1095335__(/*! ./ManifestUpdater */ "./src/streaming/ManifestUpdater.js");
/* harmony import */ var _streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_42__ = __nested_webpack_require_1095335__(/*! ../streaming/utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _utils_BoxParser__WEBPACK_IMPORTED_MODULE_43__ = __nested_webpack_require_1095335__(/*! ./utils/BoxParser */ "./src/streaming/utils/BoxParser.js");
/* harmony import */ var _text_TextController__WEBPACK_IMPORTED_MODULE_44__ = __nested_webpack_require_1095335__(/*! ./text/TextController */ "./src/streaming/text/TextController.js");
/* harmony import */ var _models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_45__ = __nested_webpack_require_1095335__(/*! ./models/CustomParametersModel */ "./src/streaming/models/CustomParametersModel.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */































 //Dash















/**
 * The media types
 * @typedef {("video" | "audio" | "text" | "image")} MediaType
 */

/**
 * @module MediaPlayer
 * @description The MediaPlayer is the primary dash.js Module and a Facade to build your player around.
 * It will allow you access to all the important dash.js properties/methods via the public API and all the
 * events to build a robust DASH media player.
 */

function MediaPlayer() {
  /**
   * @constant {string} STREAMING_NOT_INITIALIZED_ERROR error string thrown when a function is called before the dash.js has been fully initialized
   * @inner
   */
  var STREAMING_NOT_INITIALIZED_ERROR = 'You must first call initialize() and set a source before calling this method';
  /**
   * @constant {string} PLAYBACK_NOT_INITIALIZED_ERROR error string thrown when a function is called before the dash.js has been fully initialized
   * @inner
   */

  var PLAYBACK_NOT_INITIALIZED_ERROR = 'You must first call initialize() and set a valid source and view before calling this method';
  /**
   * @constant {string} ELEMENT_NOT_ATTACHED_ERROR error string thrown when a function is called before the dash.js has received a reference of an HTML5 video element
   * @inner
   */

  var ELEMENT_NOT_ATTACHED_ERROR = 'You must first call attachView() to set the video element before calling this method';
  /**
   * @constant {string} SOURCE_NOT_ATTACHED_ERROR error string thrown when a function is called before the dash.js has received a valid source stream.
   * @inner
   */

  var SOURCE_NOT_ATTACHED_ERROR = 'You must first call attachSource() with a valid source before calling this method';
  /**
   * @constant {string} MEDIA_PLAYER_NOT_INITIALIZED_ERROR error string thrown when a function is called before the dash.js has been fully initialized.
   * @inner
   */

  var MEDIA_PLAYER_NOT_INITIALIZED_ERROR = 'MediaPlayer not initialized!';
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_26__["default"])(context).getInstance();
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_30__["default"])(context).getInstance();
  var debug = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_24__["default"])(context).getInstance({
    settings: settings
  });
  var instance, logger, source, protectionData, mediaPlayerInitialized, streamingInitialized, playbackInitialized, autoPlay, abrController, schemeLoaderFactory, timelineConverter, mediaController, protectionController, metricsReportingController, mssHandler, offlineController, adapter, mediaPlayerModel, customParametersModel, errHandler, baseURLController, capabilities, capabilitiesFilter, streamController, textController, gapController, playbackController, serviceDescriptionController, catchupController, dashMetrics, manifestModel, cmcdModel, videoModel, uriFragmentModel, domStorage, segmentBaseController;
  /*
  ---------------------------------------------------------------------------
       INIT FUNCTIONS
   ---------------------------------------------------------------------------
  */

  function setup() {
    logger = debug.getLogger(instance);
    mediaPlayerInitialized = false;
    playbackInitialized = false;
    streamingInitialized = false;
    autoPlay = true;
    protectionController = null;
    offlineController = null;
    protectionData = null;
    adapter = null;
    segmentBaseController = null;
    _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"].extend(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_28__["default"]);
    mediaPlayerModel = Object(_models_MediaPlayerModel__WEBPACK_IMPORTED_MODULE_18__["default"])(context).getInstance();
    customParametersModel = Object(_models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_45__["default"])(context).getInstance();
    videoModel = Object(_models_VideoModel__WEBPACK_IMPORTED_MODULE_21__["default"])(context).getInstance();
    uriFragmentModel = Object(_models_URIFragmentModel__WEBPACK_IMPORTED_MODULE_16__["default"])(context).getInstance();
  }
  /**
   * Configure media player with customs controllers. Helpful for tests
   *
   * @param {object=} config controllers configuration
   * @memberof module:MediaPlayer
   * @instance
   */


  function setConfig(config) {
    if (!config) {
      return;
    }

    if (config.capabilities) {
      capabilities = config.capabilities;
    }

    if (config.capabilitiesFilter) {
      capabilitiesFilter = config.capabilitiesFilter;
    }

    if (config.streamController) {
      streamController = config.streamController;
    }

    if (config.textController) {
      textController = config.textController;
    }

    if (config.gapController) {
      gapController = config.gapController;
    }

    if (config.playbackController) {
      playbackController = config.playbackController;
    }

    if (config.serviceDescriptionController) {
      serviceDescriptionController = config.serviceDescriptionController;
    }

    if (config.catchupController) {
      catchupController = config.catchupController;
    }

    if (config.mediaPlayerModel) {
      mediaPlayerModel = config.mediaPlayerModel;
    }

    if (config.customParametersModel) {
      customParametersModel = config.customParametersModel;
    }

    if (config.abrController) {
      abrController = config.abrController;
    }

    if (config.schemeLoaderFactory) {
      schemeLoaderFactory = config.schemeLoaderFactory;
    }

    if (config.mediaController) {
      mediaController = config.mediaController;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }
  /**
   * Upon creating the MediaPlayer you must call initialize before you call anything else.
   * There is one exception to this rule. It is crucial to call {@link module:MediaPlayer#extend extend()}
   * with all your extensions prior to calling initialize.
   *
   * ALL arguments are optional and there are individual methods to set each argument later on.
   * The args in this method are just for convenience and should only be used for a simple player setup.
   *
   * @param {HTML5MediaElement=} view - Optional arg to set the video element. {@link module:MediaPlayer#attachView attachView()}
   * @param {string=} source - Optional arg to set the media source. {@link module:MediaPlayer#attachSource attachSource()}
   * @param {boolean=} AutoPlay - Optional arg to set auto play. {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
   * @see {@link module:MediaPlayer#attachView attachView()}
   * @see {@link module:MediaPlayer#attachSource attachSource()}
   * @see {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
   * @memberof module:MediaPlayer
   * @instance
   */


  function initialize(view, source, AutoPlay) {
    if (!capabilities) {
      capabilities = Object(_utils_Capabilities__WEBPACK_IMPORTED_MODULE_13__["default"])(context).getInstance();
      capabilities.setConfig({
        settings: settings
      });
    }

    if (!errHandler) {
      errHandler = Object(_utils_ErrorHandler__WEBPACK_IMPORTED_MODULE_12__["default"])(context).getInstance();
    }

    if (!capabilities.supportsMediaSource()) {
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_39__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"].CAPABILITY_MEDIASOURCE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"].CAPABILITY_MEDIASOURCE_ERROR_MESSAGE));
      return;
    }

    if (!mediaPlayerInitialized) {
      mediaPlayerInitialized = true; // init some controllers and models

      timelineConverter = Object(_dash_utils_TimelineConverter__WEBPACK_IMPORTED_MODULE_35__["default"])(context).getInstance();

      if (!abrController) {
        abrController = Object(_controllers_AbrController__WEBPACK_IMPORTED_MODULE_19__["default"])(context).getInstance();
        abrController.setConfig({
          settings: settings
        });
      }

      if (!schemeLoaderFactory) {
        schemeLoaderFactory = Object(_net_SchemeLoaderFactory__WEBPACK_IMPORTED_MODULE_20__["default"])(context).getInstance();
      }

      if (!playbackController) {
        playbackController = Object(_controllers_PlaybackController__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
      }

      if (!mediaController) {
        mediaController = Object(_controllers_MediaController__WEBPACK_IMPORTED_MODULE_9__["default"])(context).getInstance();
      }

      if (!streamController) {
        streamController = Object(_controllers_StreamController__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
      }

      if (!gapController) {
        gapController = Object(_controllers_GapController__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance();
      }

      if (!catchupController) {
        catchupController = Object(_controllers_CatchupController__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
      }

      if (!serviceDescriptionController) {
        serviceDescriptionController = Object(_controllers_ServiceDescriptionController__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
      }

      if (!capabilitiesFilter) {
        capabilitiesFilter = Object(_utils_CapabilitiesFilter__WEBPACK_IMPORTED_MODULE_14__["default"])(context).getInstance();
      }

      adapter = Object(_dash_DashAdapter__WEBPACK_IMPORTED_MODULE_33__["default"])(context).getInstance();
      manifestModel = Object(_models_ManifestModel__WEBPACK_IMPORTED_MODULE_17__["default"])(context).getInstance();
      cmcdModel = Object(_models_CmcdModel__WEBPACK_IMPORTED_MODULE_22__["default"])(context).getInstance();
      dashMetrics = Object(_dash_DashMetrics__WEBPACK_IMPORTED_MODULE_34__["default"])(context).getInstance({
        settings: settings
      });
      domStorage = Object(_utils_DOMStorage__WEBPACK_IMPORTED_MODULE_23__["default"])(context).getInstance({
        settings: settings
      });
      adapter.setConfig({
        constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"],
        cea608parser: _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_0___default.a,
        errHandler: errHandler,
        BASE64: _externals_base64__WEBPACK_IMPORTED_MODULE_37___default.a
      });

      if (!baseURLController) {
        baseURLController = Object(_controllers_BaseURLController__WEBPACK_IMPORTED_MODULE_10__["default"])(context).create();
      }

      baseURLController.setConfig({
        adapter: adapter
      });
      serviceDescriptionController.setConfig({
        adapter: adapter
      });

      if (!segmentBaseController) {
        segmentBaseController = Object(_dash_controllers_SegmentBaseController__WEBPACK_IMPORTED_MODULE_32__["default"])(context).getInstance({
          dashMetrics: dashMetrics,
          mediaPlayerModel: mediaPlayerModel,
          errHandler: errHandler,
          baseURLController: baseURLController,
          events: _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"],
          eventBus: eventBus,
          debug: debug,
          boxParser: Object(_utils_BoxParser__WEBPACK_IMPORTED_MODULE_43__["default"])(context).getInstance(),
          requestModifier: Object(_utils_RequestModifier__WEBPACK_IMPORTED_MODULE_15__["default"])(context).getInstance(),
          errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"]
        });
      } // configure controllers


      mediaController.setConfig({
        domStorage: domStorage,
        settings: settings,
        customParametersModel: customParametersModel
      });
      mediaPlayerModel.setConfig({
        playbackController: playbackController,
        serviceDescriptionController: serviceDescriptionController
      });
      restoreDefaultUTCTimingSources();
      setAutoPlay(AutoPlay !== undefined ? AutoPlay : true); // Detect and initialize offline module to support offline contents playback

      _detectOffline();
    }

    if (view) {
      attachView(view);
    }

    if (source) {
      attachSource(source);
    }

    logger.info('[dash.js ' + getVersion() + '] ' + 'MediaPlayer has been initialized');
  }
  /**
   * Sets the MPD source and the video element to null. You can also reset the MediaPlayer by
   * calling attachSource with a new source file.
   *
   * This call does not destroy the MediaPlayer. To destroy the MediaPlayer and free all of its
   * memory, call destroy().
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function reset() {
    attachSource(null);
    attachView(null);
    protectionData = null;

    if (protectionController) {
      protectionController.reset();
      protectionController = null;
    }

    if (metricsReportingController) {
      metricsReportingController.reset();
      metricsReportingController = null;
    }

    if (customParametersModel) {
      customParametersModel.reset();
      customParametersModel = null;
    }

    settings.reset();

    if (offlineController) {
      offlineController.reset();
      offlineController = null;
    }
  }
  /**
   * Completely destroys the media player and frees all memory.
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function destroy() {
    reset();
    _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_29__["default"].deleteSingletonInstances(context);
  }
  /**
   * The ready state of the MediaPlayer based on both the video element and MPD source being defined.
   *
   * @returns {boolean} The current ready state of the MediaPlayer
   * @see {@link module:MediaPlayer#attachView attachView()}
   * @see {@link module:MediaPlayer#attachSource attachSource()}
   * @memberof module:MediaPlayer
   * @instance
   */


  function isReady() {
    return !!source && !!videoModel.getElement();
  }
  /**
   * Use the on method to listen for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
   *
   * @param {string} type - {@link MediaPlayerEvents}
   * @param {Function} listener - callback method when the event fires.
   * @param {Object} scope - context of the listener so it can be removed properly.
   * @param {Object} options - object to define various options such as priority and mode
   * @memberof module:MediaPlayer
   * @instance
   */


  function on(type, listener, scope, options) {
    eventBus.on(type, listener, scope, options);
  }
  /**
   * Use the off method to remove listeners for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
   *
   * @param {string} type - {@link MediaPlayerEvents}
   * @param {Function} listener - callback method when the event fires.
   * @param {Object} scope - context of the listener so it can be removed properly.
   * @memberof module:MediaPlayer
   * @instance
   */


  function off(type, listener, scope) {
    eventBus.off(type, listener, scope);
  }
  /**
   * Current version of Dash.js
   * @returns {string} the current dash.js version string.
   * @memberof module:MediaPlayer
   * @instance
   */


  function getVersion() {
    return Object(_core_Version__WEBPACK_IMPORTED_MODULE_31__["getVersionString"])();
  }
  /**
   * Use this method to access the dash.js logging class.
   *
   * @returns {Debug}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getDebug() {
    return debug;
  }
  /*
  ---------------------------------------------------------------------------
       PLAYBACK FUNCTIONS
   ---------------------------------------------------------------------------
  */

  /**
   * The play method initiates playback of the media defined by the {@link module:MediaPlayer#attachSource attachSource()} method.
   * This method will call play on the native Video Element.
   *
   * @see {@link module:MediaPlayer#attachSource attachSource()}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function play() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    if (!autoPlay || isPaused() && playbackInitialized) {
      playbackController.play();
    }
  }
  /**
   * This method will call pause on the native Video Element.
   *
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function pause() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    playbackController.pause();
  }
  /**
   * Returns a Boolean that indicates whether the Video Element is paused.
   * @return {boolean}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function isPaused() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return playbackController.isPaused();
  }
  /**
   * Sets the currentTime property of the attached video element.  If it is a live stream with a
   * timeShiftBufferLength, then the DVR window offset will be automatically calculated.
   *
   * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected
   * @see {@link module:MediaPlayer#getDVRSeekOffset getDVRSeekOffset()}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with an invalid argument, not number type or is NaN.
   * @memberof module:MediaPlayer
   * @instance
   */


  function seek(value) {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_40__["checkParameterType"])(value, 'number');

    if (isNaN(value)) {
      throw _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].BAD_ARGUMENT_ERROR;
    }

    var s = playbackController.getIsDynamic() ? getDVRSeekOffset(value) : value;
    playbackController.seek(s);
  }
  /**
   * Returns a Boolean that indicates whether the media is in the process of seeking to a new position.
   * @return {boolean}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function isSeeking() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return playbackController.isSeeking();
  }
  /**
   * Returns a Boolean that indicates whether the media is in the process of dynamic.
   * @return {boolean}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function isDynamic() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return playbackController.getIsDynamic();
  }
  /**
   * Returns a boolean that indicates whether the player is operating in low latency mode.
   * @return {boolean}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getLowLatencyModeEnabled() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return playbackController.getLowLatencyModeEnabled();
  }
  /**
   * Use this method to set the native Video Element's playback rate.
   * @param {number} value
   * @memberof module:MediaPlayer
   * @instance
   */


  function setPlaybackRate(value) {
    getVideoElement().playbackRate = value;
  }
  /**
   * Returns the current playback rate.
   * @returns {number}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getPlaybackRate() {
    return getVideoElement().playbackRate;
  }
  /**
   * Use this method to set the native Video Element's muted state. Takes a Boolean that determines whether audio is muted. true if the audio is muted and false otherwise.
   * @param {boolean} value
   * @memberof module:MediaPlayer
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with an invalid argument, not boolean type.
   * @instance
   */


  function setMute(value) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_40__["checkParameterType"])(value, 'boolean');
    getVideoElement().muted = value;
  }
  /**
   * A Boolean that determines whether audio is muted.
   * @returns {boolean}
   * @memberof module:MediaPlayer
   * @instance
   */


  function isMuted() {
    return getVideoElement().muted;
  }
  /**
   * A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
   * @param {number} value
   * @memberof module:MediaPlayer
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with an invalid argument, not number type, or is NaN or not between 0 and 1.
   * @instance
   */


  function setVolume(value) {
    if (typeof value !== 'number' || isNaN(value) || value < 0.0 || value > 1.0) {
      throw _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].BAD_ARGUMENT_ERROR;
    }

    getVideoElement().volume = value;
  }
  /**
   * Returns the current audio volume, from 0.0 (silent) to 1.0 (loudest).
   * @returns {number}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getVolume() {
    return getVideoElement().volume;
  }
  /**
   * The length of the buffer for a given media type, in seconds. Valid media
   * types are "video", "audio" and "text". If no type is passed
   * in, then the minimum of video, audio and text buffer length is
   * returned. NaN is returned if an invalid type is requested, the
   * presentation does not contain that type, or if no arguments are passed
   * and the presentation does not include any adaption sets of valid media
   * type.
   *
   * @param {MediaType} type - 'video', 'audio' or 'text'
   * @returns {number} The length of the buffer for the given media type, in
   *  seconds, or NaN
   * @memberof module:MediaPlayer
   * @instance
   */


  function getBufferLength(type) {
    var types = [_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO, _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO, _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].TEXT];

    if (!type) {
      var buffer = types.map(function (t) {
        return getTracksFor(t).length > 0 ? getDashMetrics().getCurrentBufferLevel(t) : Number.MAX_VALUE;
      }).reduce(function (p, c) {
        return Math.min(p, c);
      });
      return buffer === Number.MAX_VALUE ? NaN : buffer;
    } else {
      if (types.indexOf(type) !== -1) {
        var _buffer = getDashMetrics().getCurrentBufferLevel(type);

        return _buffer ? _buffer : NaN;
      } else {
        logger.warn('getBufferLength requested for invalid type');
        return NaN;
      }
    }
  }
  /**
   * The timeShiftBufferLength (DVR Window), in seconds.
   *
   * @returns {number} The window of allowable play time behind the live point of a live stream as defined in the manifest.
   * @memberof module:MediaPlayer
   * @instance
   */


  function getDVRWindowSize() {
    var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO;
    var metric = dashMetrics.getCurrentDVRInfo(type);

    if (!metric) {
      return 0;
    }

    return metric.manifestInfo.dvrWindowSize;
  }
  /**
   * This method should only be used with a live stream that has a valid timeShiftBufferLength (DVR Window).
   * NOTE - If you do not need the raw offset value (i.e. media analytics, tracking, etc) consider using the {@link module:MediaPlayer#seek seek()} method
   * which will calculate this value for you and set the video element's currentTime property all in one simple call.
   *
   * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected.
   * @returns {number} A value that is relative the available range within the timeShiftBufferLength (DVR Window).
   * @see {@link module:MediaPlayer#seek seek()}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getDVRSeekOffset(value) {
    var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO;
    var metric = dashMetrics.getCurrentDVRInfo(type);

    if (!metric) {
      return 0;
    }

    var liveDelay = playbackController.getLiveDelay();
    var val = metric.range.start + value;

    if (val > metric.range.end - liveDelay) {
      val = metric.range.end - liveDelay;
    }

    return val;
  }
  /**
   * Returns the target live delay
   * @returns {number} The target live delay
   * @memberof module:MediaPlayer
   * @instance
   */


  function getTargetLiveDelay() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return playbackController.getLiveDelay();
  }
  /**
   * Current time of the playhead, in seconds.
   *
   * If called with no arguments then the returned time value is time elapsed since the start point of the first stream, or if it is a live stream, then the time will be based on the return value of the {@link module:MediaPlayer#duration duration()} method.
   * However if a stream ID is supplied then time is relative to the start of that stream, or is null if there is no such stream id in the manifest.
   *
   * @param {string} streamId - The ID of a stream that the returned playhead time must be relative to the start of. If undefined, then playhead time is relative to the first stream.
   * @returns {number} The current playhead time of the media, or null.
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function time(streamId) {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    var t = getVideoElement().currentTime;

    if (streamId !== undefined) {
      t = streamController.getTimeRelativeToStreamId(t, streamId);
    } else if (playbackController.getIsDynamic()) {
      var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO;
      var metric = dashMetrics.getCurrentDVRInfo(type);
      t = metric === null || t === 0 ? 0 : Math.max(0, t - metric.range.start);
    }

    return t;
  }
  /**
   * Duration of the media's playback, in seconds.
   *
   * @returns {number} The current duration of the media. For a dynamic stream this will return DVRWindow.end - DVRWindow.start
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function duration() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    var d = getVideoElement().duration;

    if (playbackController.getIsDynamic()) {
      var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO;
      var metric = dashMetrics.getCurrentDVRInfo(type);
      d = metric ? metric.range.end - metric.range.start : 0;
    }

    return d;
  }
  /**
   * Use this method to get the current playhead time as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
   * Note - this property only has meaning for live streams. If called before play() has begun, it will return a value of NaN.
   *
   * @returns {number} The current playhead time as UTC timestamp.
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function timeAsUTC() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    if (time() < 0) {
      return NaN;
    }

    return _getAsUTC(time());
  }
  /**
   * Use this method to get the current duration as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
   * Note - this property only has meaning for live streams.
   *
   * @returns {number} The current duration as UTC timestamp.
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function durationAsUTC() {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    return _getAsUTC(duration());
  }
  /*
  ---------------------------------------------------------------------------
       AUTO BITRATE
   ---------------------------------------------------------------------------
  */

  /**
   * Gets the top quality BitrateInfo checking portal limit and max allowed.
   * It calls getMaxAllowedIndexFor internally
   *
   * @param {MediaType} type - 'video' or 'audio'
   * @memberof module:MediaPlayer
   * @returns {BitrateInfo | null}
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getTopBitrateInfoFor(type) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    return abrController.getTopBitrateInfoFor(type);
  }
  /**
   * Gets the current download quality for media type video, audio or images. For video and audio types the ABR
   * rules update this value before every new download unless autoSwitchBitrate is set to false. For 'image'
   * type, thumbnails, there is no ABR algorithm and quality is set manually.
   *
   * @param {MediaType} type - 'video', 'audio' or 'image' (thumbnails)
   * @returns {number} the quality index, 0 corresponding to the lowest bitrate
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#setQualityFor setQualityFor()}
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getQualityFor(type) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].IMAGE) {
      var activeStream = getActiveStream();

      if (!activeStream) {
        return -1;
      }

      var thumbnailController = activeStream.getThumbnailController();
      return !thumbnailController ? -1 : thumbnailController.getCurrentTrackIndex();
    }

    return abrController.getQualityFor(type);
  }
  /**
   * Sets the current quality for media type instead of letting the ABR Heuristics automatically selecting it.
   * This value will be overwritten by the ABR rules unless autoSwitchBitrate is set to false.
   *
   * @param {MediaType} type - 'video', 'audio' or 'image'
   * @param {number} value - the quality index, 0 corresponding to the lowest bitrate
   * @param {boolean} forceReplace - true if segments have to be replaced by segments of the new quality
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#getQualityFor getQualityFor()}
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function setQualityFor(type, value) {
    var forceReplace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].IMAGE) {
      var activeStream = getActiveStream();

      if (!activeStream) {
        return;
      }

      var thumbnailController = activeStream.getThumbnailController();

      if (thumbnailController) {
        thumbnailController.setTrackByIndex(value);
      }
    }

    abrController.setPlaybackQuality(type, streamController.getActiveStreamInfo(), value, {
      forceReplace: forceReplace
    });
  }
  /**
   * Update the video element size variables
   * Should be called on window resize (or any other time player is resized). Fullscreen does trigger a window resize event.
   *
   * Once windowResizeEventCalled = true, abrController.checkPortalSize() will use element size variables rather than querying clientWidth every time.
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function updatePortalSize() {
    abrController.setElementSize();
    abrController.setWindowResizeEventCalled(true);
  }
  /*
  ---------------------------------------------------------------------------
       MEDIA PLAYER CONFIGURATION
   ---------------------------------------------------------------------------
  */

  /**
   * <p>Set to false to prevent stream from auto-playing when the view is attached.</p>
   *
   * @param {boolean} value
   * @default true
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#attachView attachView()}
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with an invalid argument, not boolean type.
   * @instance
   *
   */


  function setAutoPlay(value) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_40__["checkParameterType"])(value, 'boolean');
    autoPlay = value;
  }
  /**
   * @returns {boolean} The current autoPlay state.
   * @memberof module:MediaPlayer
   * @instance
   */


  function getAutoPlay() {
    return autoPlay;
  }
  /**
   * @memberof module:MediaPlayer
   * @instance
   * @returns {number|NaN} Current live stream latency in seconds. It is the difference between now time and time position at the playback head.
   * @throws {@link module:MediaPlayer~MEDIA_PLAYER_NOT_INITIALIZED_ERROR MEDIA_PLAYER_NOT_INITIALIZED_ERROR} if called before initialize function
   */


  function getCurrentLiveLatency() {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    if (!playbackInitialized) {
      return NaN;
    }

    return playbackController.getCurrentLiveLatency();
  }
  /**
   * Add a custom ABR Rule
   * Rule will be apply on next stream if a stream is being played
   *
   * @param {string} type - rule type (one of ['qualitySwitchRules','abandonFragmentRules'])
   * @param {string} rulename - name of rule (used to identify custom rule). If one rule of same name has been added, then existing rule will be updated
   * @param {object} rule - the rule object instance
   * @memberof module:MediaPlayer
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with invalid arguments.
   * @instance
   */


  function addABRCustomRule(type, rulename, rule) {
    customParametersModel.addAbrCustomRule(type, rulename, rule);
  }
  /**
   * Remove a custom ABR Rule
   *
   * @param {string} rulename - name of the rule to be removed
   * @memberof module:MediaPlayer
   * @instance
   */


  function removeABRCustomRule(rulename) {
    customParametersModel.removeAbrCustomRule(rulename);
  }
  /**
   * Remove all ABR custom rules
   * @memberof module:MediaPlayer
   * @instance
   */


  function removeAllABRCustomRule() {
    customParametersModel.removeAllAbrCustomRule();
  }
  /**
   * Returns all ABR custom rules
   * @return {Array}
   */


  function getABRCustomRules() {
    return customParametersModel.getAbrCustomRules();
  }
  /**
   * <p>Allows you to set a scheme and server source for UTC live edge detection for dynamic streams.
   * If UTCTiming is defined in the manifest, it will take precedence over any time source manually added.</p>
   * <p>If you have exposed the Date header, use the method {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}.
   * This will allow the date header on the manifest to be used instead of a time server</p>
   * @param {string} schemeIdUri - <ul>
   * <li>urn:mpeg:dash:utc:http-head:2014</li>
   * <li>urn:mpeg:dash:utc:http-xsdate:2014</li>
   * <li>urn:mpeg:dash:utc:http-iso:2014</li>
   * <li>urn:mpeg:dash:utc:direct:2014</li>
   * </ul>
   * <p>Some specs referencing early ISO23009-1 drafts incorrectly use
   * 2012 in the URI, rather than 2014. support these for now.</p>
   * <ul>
   * <li>urn:mpeg:dash:utc:http-head:2012</li>
   * <li>urn:mpeg:dash:utc:http-xsdate:2012</li>
   * <li>urn:mpeg:dash:utc:http-iso:2012</li>
   * <li>urn:mpeg:dash:utc:direct:2012</li>
   * </ul>
   * @param {string} value - Path to a time source.
   * @default
   * <ul>
   *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
   *     <li>value:http://time.akamai.com/?iso&ms/li>
   * </ul>
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#removeUTCTimingSource removeUTCTimingSource()}
   * @instance
   */


  function addUTCTimingSource(schemeIdUri, value) {
    customParametersModel.addUTCTimingSource(schemeIdUri, value);
  }
  /**
   * <p>Allows you to remove a UTC time source. Both schemeIdUri and value need to match the Dash.vo.UTCTiming properties in order for the
   * entry to be removed from the array</p>
   * @param {string} schemeIdUri - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
   * @param {string} value - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with invalid arguments, schemeIdUri and value are not string type.
   * @instance
   */


  function removeUTCTimingSource(schemeIdUri, value) {
    customParametersModel.removeUTCTimingSource(schemeIdUri, value);
  }
  /**
   * <p>Allows you to clear the stored array of time sources.</p>
   * <p>Example use: If you have exposed the Date header, calling this method
   * will allow the date header on the manifest to be used instead of the time server.</p>
   * <p>Example use: Calling this method, assuming there is not an exposed date header on the manifest,  will default back
   * to using a binary search to discover the live edge</p>
   *
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#restoreDefaultUTCTimingSources restoreDefaultUTCTimingSources()}
   * @instance
   */


  function clearDefaultUTCTimingSources() {
    customParametersModel.clearDefaultUTCTimingSources();
  }
  /**
   * <p>Allows you to restore the default time sources after calling {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}</p>
   *
   * @default
   * <ul>
   *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
   *     <li>value:http://time.akamai.com/?iso&ms</li>
   * </ul>
   *
   * @memberof module:MediaPlayer
   * @see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
   * @instance
   */


  function restoreDefaultUTCTimingSources() {
    customParametersModel.restoreDefaultUTCTimingSources();
  }
  /**
   * Returns the average throughput computed in the ABR logic
   *
   * @param {MediaType} type
   * @return {number} value
   * @memberof module:MediaPlayer
   * @instance
   */


  function getAverageThroughput(type) {
    var throughputHistory = abrController.getThroughputHistory();
    var isDynamic = playbackController.getIsDynamic();
    return throughputHistory ? throughputHistory.getAverageThroughput(type, isDynamic) : 0;
  }
  /**
   * Sets whether withCredentials on XHR requests for a particular request
   * type is true or false
   *
   * @default false
   * @param {string} type - one of HTTPRequest.*_TYPE
   * @param {boolean} value
   * @memberof module:MediaPlayer
   * @instance
   */


  function setXHRWithCredentialsForType(type, value) {
    customParametersModel.setXHRWithCredentialsForType(type, value);
  }
  /**
   * Gets whether withCredentials on XHR requests for a particular request
   * type is true or false
   *
   * @param {string} type - one of HTTPRequest.*_TYPE
   * @return {boolean}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getXHRWithCredentialsForType(type) {
    return customParametersModel.getXHRWithCredentialsForType(type);
  }
  /*
  ---------------------------------------------------------------------------
       OFFLINE
   ---------------------------------------------------------------------------
  */

  /**
   * Detects if Offline is included and returns an instance of OfflineController.js
   * @memberof module:MediaPlayer
   * @instance
   */


  function getOfflineController() {
    return _detectOffline();
  }
  /*
  ---------------------------------------------------------------------------
       METRICS
   ---------------------------------------------------------------------------
  */

  /**
   * Returns the DashMetrics.js Module. You use this Module to get access to all the public metrics
   * stored in dash.js
   *
   * @see {@link module:DashMetrics}
   * @returns {Object}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getDashMetrics() {
    return dashMetrics;
  }
  /*
  ---------------------------------------------------------------------------
       TEXT MANAGEMENT
   ---------------------------------------------------------------------------
  */

  /**
   * Enable/disable text
   * When enabling text, dash will choose the previous selected text track
   *
   * @param {boolean} enable - true to enable text, false otherwise (same as setTextTrack(-1))
   * @memberof module:MediaPlayer
   * @instance
   */


  function enableText(enable) {
    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!activeStreamInfo || !textController) {
      return false;
    }

    return textController.enableText(activeStreamInfo.id, enable);
  }
  /**
   * Enable/disable text
   * When enabling dash will keep downloading and process fragmented text tracks even if all tracks are in mode "hidden"
   *
   * @param {boolean} enable - true to enable text streaming even if all text tracks are hidden.
   * @memberof module:MediaPlayer
   * @instance
   */


  function enableForcedTextStreaming(enable) {
    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!activeStreamInfo || !textController) {
      return false;
    }

    return textController.enableForcedTextStreaming(enable);
  }
  /**
   * Return if text is enabled
   *
   * @return {boolean} return true if text is enabled, false otherwise
   * @memberof module:MediaPlayer
   * @instance
   */


  function isTextEnabled() {
    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!activeStreamInfo || !textController) {
      return false;
    }

    return textController.isTextEnabled(activeStreamInfo);
  }
  /**
   * Use this method to change the current text track for both external time text files and fragmented text tracks. There is no need to
   * set the track mode on the video object to switch a track when using this method.
   * @param {number} idx - Index of track based on the order of the order the tracks are added Use -1 to disable all tracks. (turn captions off).  Use module:MediaPlayer#dashjs.MediaPlayer.events.TEXT_TRACK_ADDED.
   * @see {@link MediaPlayerEvents#event:TEXT_TRACK_ADDED dashjs.MediaPlayer.events.TEXT_TRACK_ADDED}
   * @throws {@link module:MediaPlayer~PLAYBACK_NOT_INITIALIZED_ERROR PLAYBACK_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function setTextTrack(idx) {
    if (!playbackInitialized) {
      throw PLAYBACK_NOT_INITIALIZED_ERROR;
    }

    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!activeStreamInfo || !textController) {
      return;
    }

    textController.setTextTrack(activeStreamInfo.id, idx);
  }

  function getCurrentTextTrackIndex() {
    var idx = NaN;
    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!activeStreamInfo || !textController) {
      return;
    }

    idx = textController.getCurrentTrackIdx(activeStreamInfo.id);
    return idx;
  }
  /*
  ---------------------------------------------------------------------------
       VIDEO ELEMENT MANAGEMENT
   ---------------------------------------------------------------------------
  */

  /**
   * Returns instance of Video Element that was attached by calling attachView()
   * @returns {Object}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~ELEMENT_NOT_ATTACHED_ERROR ELEMENT_NOT_ATTACHED_ERROR} if called before attachView function
   * @instance
   */


  function getVideoElement() {
    if (!videoModel.getElement()) {
      throw ELEMENT_NOT_ATTACHED_ERROR;
    }

    return videoModel.getElement();
  }
  /**
   * Use this method to attach an HTML5 VideoElement for dash.js to operate upon.
   *
   * @param {Object} element - An HTMLMediaElement that has already been defined in the DOM (or equivalent stub).
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~MEDIA_PLAYER_NOT_INITIALIZED_ERROR MEDIA_PLAYER_NOT_INITIALIZED_ERROR} if called before initialize function
   * @instance
   */


  function attachView(element) {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    videoModel.setElement(element);

    if (element) {
      _detectProtection();

      _detectMetricsReporting();

      _detectMss();

      if (streamController) {
        streamController.switchToVideoElement();
      }
    }

    if (playbackInitialized) {
      //Reset if we have been playing before, so this is a new element.
      _resetPlaybackControllers();
    }

    _initializePlayback();
  }
  /**
   * Returns instance of Div that was attached by calling attachTTMLRenderingDiv()
   * @returns {Object}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getTTMLRenderingDiv() {
    return videoModel ? videoModel.getTTMLRenderingDiv() : null;
  }
  /**
   * Use this method to attach an HTML5 div for dash.js to render rich TTML subtitles.
   *
   * @param {HTMLDivElement} div - An unstyled div placed after the video element. It will be styled to match the video size and overlay z-order.
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~ELEMENT_NOT_ATTACHED_ERROR ELEMENT_NOT_ATTACHED_ERROR} if called before attachView function
   * @instance
   */


  function attachTTMLRenderingDiv(div) {
    if (!videoModel.getElement()) {
      throw ELEMENT_NOT_ATTACHED_ERROR;
    }

    videoModel.setTTMLRenderingDiv(div);
  }
  /*
  ---------------------------------------------------------------------------
       STREAM AND TRACK MANAGEMENT
   ---------------------------------------------------------------------------
  */

  /**
   * @param {MediaType} type
   * @returns {Array}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getBitrateInfoListFor(type) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    var stream = getActiveStream();
    return stream ? stream.getBitrateListFor(type) : [];
  }
  /**
   * This method returns the list of all available streams from a given manifest
   * @param {Object} manifest
   * @returns {Array} list of {@link StreamInfo}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getStreamsFromManifest(manifest) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    return adapter.getStreamsInfo(manifest);
  }
  /**
   * This method returns the list of all available tracks for a given media type
   * @param {MediaType} type
   * @returns {Array} list of {@link MediaInfo}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getTracksFor(type) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    var streamInfo = streamController.getActiveStreamInfo();

    if (!streamInfo) {
      return [];
    }

    return mediaController.getTracksFor(type, streamInfo.id);
  }
  /**
   * This method returns the list of all available tracks for a given media type and streamInfo from a given manifest
   * @param {MediaType} type
   * @param {Object} manifest
   * @param {Object} streamInfo
   * @returns {Array}  list of {@link MediaInfo}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getTracksForTypeFromManifest(type, manifest, streamInfo) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    streamInfo = streamInfo || adapter.getStreamsInfo(manifest, 1)[0];
    return streamInfo ? adapter.getAllMediaInfoForType(streamInfo, type, manifest) : [];
  }
  /**
   * @param {MediaType} type
   * @returns {Object|null} {@link MediaInfo}
   *
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function getCurrentTrackFor(type) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    var streamInfo = streamController.getActiveStreamInfo();
    return mediaController.getCurrentTrackFor(type, streamInfo.id);
  }
  /**
   * This method allows to set media settings that will be used to pick the initial track. Format of the settings
   * is following: <br />
   * {lang: langValue (can be either a string or a regex to match),
   *  index: indexValue,
   *  viewpoint: viewpointValue,
   *  audioChannelConfiguration: audioChannelConfigurationValue,
   *  accessibility: accessibilityValue,
   *  role: roleValue}
   *
   * @param {MediaType} type
   * @param {Object} value
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~MEDIA_PLAYER_NOT_INITIALIZED_ERROR MEDIA_PLAYER_NOT_INITIALIZED_ERROR} if called before initialize function
   * @instance
   */


  function setInitialMediaSettingsFor(type, value) {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    mediaController.setInitialSettings(type, value);
  }
  /**
   * This method returns media settings that is used to pick the initial track. Format of the settings
   * is following:
   * {lang: langValue,
   *  index: indexValue,
   *  viewpoint: viewpointValue,
   *  audioChannelConfiguration: audioChannelConfigurationValue,
   *  accessibility: accessibilityValue,
   *  role: roleValue}
   * @param {MediaType} type
   * @returns {Object}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~MEDIA_PLAYER_NOT_INITIALIZED_ERROR MEDIA_PLAYER_NOT_INITIALIZED_ERROR} if called before initialize function
   * @instance
   */


  function getInitialMediaSettingsFor(type) {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    return mediaController.getInitialSettings(type);
  }
  /**
   * @param {MediaInfo} track - instance of {@link MediaInfo}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @instance
   */


  function setCurrentTrack(track) {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    mediaController.setTrack(track);
  }
  /*
  ---------------------------------------------------------------------------
       Custom filter and callback functions
   ---------------------------------------------------------------------------
  */

  /**
   * Registers a custom capabilities filter. This enables application to filter representations to use.
   * The provided callback function shall return a boolean based on whether or not to use the representation.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the custom capabilities filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function registerCustomCapabilitiesFilter(filter) {
    customParametersModel.registerCustomCapabilitiesFilter(filter);
  }
  /**
   * Unregisters a custom capabilities filter.
   * @param {function} filter - the custom capabilities filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function unregisterCustomCapabilitiesFilter(filter) {
    customParametersModel.unregisterCustomCapabilitiesFilter(filter);
  }
  /**
   * Registers a custom initial track selection function. Only one function is allowed. Calling this method will overwrite a potentially existing function.
   * @param {function} customFunc - the custom function that returns the initial track
   */


  function setCustomInitialTrackSelectionFunction(customFunc) {
    customParametersModel.setCustomInitialTrackSelectionFunction(customFunc);
  }
  /**
   * Resets the custom initial track selection
   */


  function resetCustomInitialTrackSelectionFunction() {
    customParametersModel.resetCustomInitialTrackSelectionFunction(null);
  }
  /**
   * Registers a license request filter. This enables application to manipulate/overwrite any request parameter and/or request data.
   * The provided callback function shall return a promise that shall be resolved once the filter process is completed.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the license request filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function registerLicenseRequestFilter(filter) {
    customParametersModel.registerLicenseRequestFilter(filter);
  }
  /**
   * Registers a license response filter. This enables application to manipulate/overwrite the response data
   * The provided callback function shall return a promise that shall be resolved once the filter process is completed.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the license response filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function registerLicenseResponseFilter(filter) {
    customParametersModel.registerLicenseResponseFilter(filter);
  }
  /**
   * Unregisters a license request filter.
   * @param {function} filter - the license request filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function unregisterLicenseRequestFilter(filter) {
    customParametersModel.unregisterLicenseRequestFilter(filter);
  }
  /**
   * Unregisters a license response filter.
   * @param {function} filter - the license response filter callback
   * @memberof module:MediaPlayer
   * @instance
   */


  function unregisterLicenseResponseFilter(filter) {
    customParametersModel.unregisterLicenseResponseFilter(filter);
  }
  /*
  ---------------------------------------------------------------------------
       PROTECTION MANAGEMENT
   ---------------------------------------------------------------------------
  */

  /**
   * Detects if Protection is included and returns an instance of ProtectionController.js
   * @memberof module:MediaPlayer
   * @instance
   */


  function getProtectionController() {
    return _detectProtection();
  }
  /**
   * Will override dash.js protection controller.
   * @param {ProtectionController} value - valid protection controller instance.
   * @memberof module:MediaPlayer
   * @instance
   */


  function attachProtectionController(value) {
    protectionController = value;
  }
  /**
   * Sets Protection Data required to setup the Protection Module (DRM). Protection Data must
   * be set before initializing MediaPlayer or, once initialized, before PROTECTION_CREATED event is fired.
   * @see {@link module:MediaPlayer#initialize initialize()}
   * @see {@link ProtectionEvents#event:PROTECTION_CREATED dashjs.Protection.events.PROTECTION_CREATED}
   * @param {ProtectionDataSet} value - object containing
   * property names corresponding to key system name strings and associated
   * values being instances of.
   * @memberof module:MediaPlayer
   * @instance
   */


  function setProtectionData(value) {
    protectionData = value; // Propagate changes in case StreamController is already created

    if (streamController) {
      streamController.setProtectionData(protectionData);
    }
  }
  /*
  ---------------------------------------------------------------------------
       THUMBNAILS MANAGEMENT
   ---------------------------------------------------------------------------
  */

  /**
   * Provide the thumbnail at time position. This can be asynchronous, so you must provide a callback ro retrieve thumbnails informations
   * @param {number} time - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected
   * @param {function} callback - A Callback function provided when retrieving thumbnail the given time position. Thumbnail object is null in case there are is not a thumbnails representation or
   * if it doesn't contain a thumbnail for the given time position.
   * @memberof module:MediaPlayer
   * @instance
   */


  function provideThumbnail(time, callback) {
    if (typeof callback !== 'function') {
      return;
    }

    if (time < 0) {
      callback(null);
      return;
    }

    var s = playbackController.getIsDynamic() ? getDVRSeekOffset(time) : time;
    var stream = streamController.getStreamForTime(s);

    if (stream === null) {
      callback(null);
      return;
    }

    var thumbnailController = stream.getThumbnailController();

    if (!thumbnailController) {
      callback(null);
      return;
    }

    return thumbnailController.provide(s, callback);
  }
  /*
  ---------------------------------------------------------------------------
       TOOLS AND OTHERS FUNCTIONS
   ---------------------------------------------------------------------------
  */

  /**
   * Allows application to retrieve a manifest.  Manifest loading is asynchro
   * nous and
   * requires the app-provided callback function
   *
   * @param {string} url - url the manifest url
   * @param {function} callback - A Callback function provided when retrieving manifests
   * @memberof module:MediaPlayer
   * @instance
   */


  function retrieveManifest(url, callback) {
    var manifestLoader = _createManifestLoader();

    var self = this;

    var handler = function handler(e) {
      if (!e.error) {
        callback(e.manifest);
      } else {
        callback(null, e.error);
      }

      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"].INTERNAL_MANIFEST_LOADED, handler, self);
      manifestLoader.reset();
    };

    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"].INTERNAL_MANIFEST_LOADED, handler, self);
    uriFragmentModel.initialize(url);
    manifestLoader.load(url);
  }
  /**
   * Returns the source string or manifest that was attached by calling attachSource()
   * @returns {string | manifest}
   * @memberof module:MediaPlayer
   * @throws {@link module:MediaPlayer~SOURCE_NOT_ATTACHED_ERROR SOURCE_NOT_ATTACHED_ERROR} if called before attachSource function
   * @instance
   */


  function getSource() {
    if (!source) {
      throw SOURCE_NOT_ATTACHED_ERROR;
    }

    return source;
  }
  /**
   * Sets the source to a new manifest URL or object without reloading
   * Useful for updating CDN tokens
   * @param urlOrManifest
   */


  function updateSource(urlOrManifest) {
    source = urlOrManifest;
    streamController.load(source);
  }
  /**
   * Use this method to set a source URL to a valid MPD manifest file OR
   * a previously downloaded and parsed manifest object.  Optionally, can
   * also provide protection information
   *
   * @param {string|Object} urlOrManifest - A URL to a valid MPD manifest file, or a
   * parsed manifest object.
   *
   *
   * @throws {@link module:MediaPlayer~MEDIA_PLAYER_NOT_INITIALIZED_ERROR MEDIA_PLAYER_NOT_INITIALIZED_ERROR} if called before initialize function
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function attachSource(urlOrManifest) {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    if (typeof urlOrManifest === 'string') {
      uriFragmentModel.initialize(urlOrManifest);
    }

    source = urlOrManifest;

    if (streamingInitialized || playbackInitialized) {
      _resetPlaybackControllers();
    }

    if (isReady()) {
      _initializePlayback();
    }
  }
  /**
   * Get the current settings object being used on the player.
   * @returns {PlayerSettings} The settings object being used.
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function getSettings() {
    return settings.get();
  }
  /**
   * @summary Update the current settings object being used on the player. Anything left unspecified is not modified.
   * @param {PlayerSettings} settingsObj - An object corresponding to the settings definition.
   * @description This function does not update the entire object, only properties in the passed in object are updated.
   *
   * This means that updateSettings({a: x}) and updateSettings({b: y}) are functionally equivalent to
   * updateSettings({a: x, b: y}). If the default values are required again, @see{@link resetSettings}.
   * @example
   * player.updateSettings({
   *      streaming: {
   *          lowLatencyEnabled: false,
   *          abr: {
   *              maxBitrate: { audio: 100, video: 1000 }
   *          }
   *      }
   *  });
   * @memberof module:MediaPlayer
   * @instance
   */


  function updateSettings(settingsObj) {
    settings.update(settingsObj);
  }
  /**
   * Resets the settings object back to the default.
   *
   * @memberof module:MediaPlayer
   * @instance
   */


  function resetSettings() {
    settings.reset();
  }
  /**
   * A utility methods which converts UTC timestamp value into a valid time and date string.
   *
   * @param {number} time - UTC timestamp to be converted into date and time.
   * @param {string} locales - a region identifier (i.e. en_US).
   * @param {boolean} hour12 - 12 vs 24 hour. Set to true for 12 hour time formatting.
   * @param {boolean} withDate - default is false. Set to true to append current date to UTC time format.
   * @returns {string} A formatted time and date string.
   * @memberof module:MediaPlayer
   * @instance
   */


  function formatUTC(time, locales, hour12) {
    var withDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var dt = new Date(time * 1000);
    var d = dt.toLocaleDateString(locales);
    var t = dt.toLocaleTimeString(locales, {
      hour12: hour12
    });
    return withDate ? t + ' ' + d : t;
  }
  /**
   * A utility method which converts seconds into TimeCode (i.e. 300 --> 05:00).
   *
   * @param {number} value - A number in seconds to be converted into a formatted time code.
   * @returns {string} A formatted time code string.
   * @memberof module:MediaPlayer
   * @instance
   */


  function convertToTimeCode(value) {
    value = Math.max(value, 0);
    var h = Math.floor(value / 3600);
    var m = Math.floor(value % 3600 / 60);
    var s = Math.floor(value % 3600 % 60);
    return (h === 0 ? '' : h < 10 ? '0' + h.toString() + ':' : h.toString() + ':') + (m < 10 ? '0' + m.toString() : m.toString()) + ':' + (s < 10 ? '0' + s.toString() : s.toString());
  }
  /**
   * This method should be used to extend or replace internal dash.js objects.
   * There are two ways to extend dash.js (determined by the override argument):
   * <ol>
   * <li>If you set override to true any public method or property in your custom object will
   * override the dash.js parent object's property(ies) and will be used instead but the
   * dash.js parent module will still be created.</li>
   *
   * <li>If you set override to false your object will completely replace the dash.js object.
   * (Note: This is how it was in 1.x of Dash.js with Dijon).</li>
   * </ol>
   * <b>When you extend you get access to this.context, this.factory and this.parent to operate with in your custom object.</b>
   * <ul>
   * <li><b>this.context</b> - can be used to pass context for singleton access.</li>
   * <li><b>this.factory</b> - can be used to call factory.getSingletonInstance().</li>
   * <li><b>this.parent</b> - is the reference of the parent object to call other public methods. (this.parent is excluded if you extend with override set to false or option 2)</li>
   * </ul>
   * <b>You must call extend before you call initialize</b>
   * @see {@link module:MediaPlayer#initialize initialize()}
   * @param {string} parentNameString - name of parent module
   * @param {Object} childInstance - overriding object
   * @param {boolean} override - replace only some methods (true) or the whole object (false)
   * @memberof module:MediaPlayer
   * @instance
   */


  function extend(parentNameString, childInstance, override) {
    _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_29__["default"].extend(parentNameString, childInstance, override, context);
  }
  /**
   * This method returns the active stream
   *
   * @throws {@link module:MediaPlayer~STREAMING_NOT_INITIALIZED_ERROR STREAMING_NOT_INITIALIZED_ERROR} if called before initializePlayback function
   * @memberof module:MediaPlayer
   * @instance
   */


  function getActiveStream() {
    if (!streamingInitialized) {
      throw STREAMING_NOT_INITIALIZED_ERROR;
    }

    var streamInfo = streamController.getActiveStreamInfo();
    return streamInfo ? streamController.getStreamById(streamInfo.id) : null;
  }
  /**
   * Returns the DashAdapter.js Module.
   *
   * @see {@link module:DashAdapter}
   * @returns {Object}
   * @memberof module:MediaPlayer
   * @instance
   */


  function getDashAdapter() {
    return adapter;
  } //***********************************
  // PRIVATE METHODS
  //***********************************


  function _resetPlaybackControllers() {
    playbackInitialized = false;
    streamingInitialized = false;
    adapter.reset();
    streamController.reset();
    gapController.reset();
    catchupController.reset();
    playbackController.reset();
    serviceDescriptionController.reset();
    abrController.reset();
    mediaController.reset();
    segmentBaseController.reset();

    if (protectionController) {
      if (settings.get().streaming.protection.keepProtectionMediaKeys) {
        protectionController.stop();
      } else {
        protectionController.reset();
        protectionController = null;

        _detectProtection();
      }
    }

    textController.reset();
    cmcdModel.reset();
  }

  function _createPlaybackControllers() {
    // creates or get objects instances
    var manifestLoader = _createManifestLoader();

    if (!streamController) {
      streamController = Object(_controllers_StreamController__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
    }

    if (!textController) {
      textController = Object(_text_TextController__WEBPACK_IMPORTED_MODULE_44__["default"])(context).create({
        errHandler: errHandler,
        manifestModel: manifestModel,
        adapter: adapter,
        mediaController: mediaController,
        videoModel: videoModel,
        settings: settings
      });
    }

    capabilitiesFilter.setConfig({
      capabilities: capabilities,
      customParametersModel: customParametersModel,
      adapter: adapter,
      settings: settings,
      manifestModel: manifestModel,
      errHandler: errHandler
    });
    streamController.setConfig({
      capabilities: capabilities,
      capabilitiesFilter: capabilitiesFilter,
      manifestLoader: manifestLoader,
      manifestModel: manifestModel,
      mediaPlayerModel: mediaPlayerModel,
      customParametersModel: customParametersModel,
      protectionController: protectionController,
      textController: textController,
      adapter: adapter,
      dashMetrics: dashMetrics,
      errHandler: errHandler,
      timelineConverter: timelineConverter,
      videoModel: videoModel,
      playbackController: playbackController,
      serviceDescriptionController: serviceDescriptionController,
      abrController: abrController,
      mediaController: mediaController,
      settings: settings,
      baseURLController: baseURLController,
      uriFragmentModel: uriFragmentModel,
      segmentBaseController: segmentBaseController
    });
    gapController.setConfig({
      settings: settings,
      playbackController: playbackController,
      streamController: streamController,
      videoModel: videoModel,
      timelineConverter: timelineConverter,
      adapter: adapter
    });
    playbackController.setConfig({
      streamController: streamController,
      serviceDescriptionController: serviceDescriptionController,
      dashMetrics: dashMetrics,
      adapter: adapter,
      videoModel: videoModel,
      timelineConverter: timelineConverter,
      settings: settings
    });
    catchupController.setConfig({
      streamController: streamController,
      playbackController: playbackController,
      mediaPlayerModel: mediaPlayerModel,
      dashMetrics: dashMetrics,
      videoModel: videoModel,
      settings: settings
    });
    abrController.setConfig({
      streamController: streamController,
      domStorage: domStorage,
      mediaPlayerModel: mediaPlayerModel,
      customParametersModel: customParametersModel,
      dashMetrics: dashMetrics,
      adapter: adapter,
      videoModel: videoModel,
      settings: settings
    });
    cmcdModel.setConfig({
      abrController: abrController,
      dashMetrics: dashMetrics,
      playbackController: playbackController
    }); // initialises controller

    abrController.initialize();
    streamController.initialize(autoPlay, protectionData);
    textController.initialize();
    gapController.initialize();
    catchupController.initialize();
    cmcdModel.initialize();
    segmentBaseController.initialize();
  }

  function _createManifestLoader() {
    return Object(_ManifestLoader__WEBPACK_IMPORTED_MODULE_11__["default"])(context).create({
      debug: debug,
      errHandler: errHandler,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      requestModifier: Object(_utils_RequestModifier__WEBPACK_IMPORTED_MODULE_15__["default"])(context).getInstance(),
      mssHandler: mssHandler,
      settings: settings
    });
  }

  function _detectProtection() {
    if (protectionController) {
      return protectionController;
    } // do not require Protection as dependencies as this is optional and intended to be loaded separately


    var Protection = dashjs.Protection;
    /* jshint ignore:line */

    if (typeof Protection === 'function') {
      //TODO need a better way to register/detect plugin components
      var protection = Protection(context).create();
      _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"].extend(Protection.events);
      _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_28__["default"].extend(Protection.events, {
        publicOnly: true
      });
      _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"].extend(Protection.errors);

      if (!capabilities) {
        capabilities = Object(_utils_Capabilities__WEBPACK_IMPORTED_MODULE_13__["default"])(context).getInstance();
      }

      protectionController = protection.createProtectionSystem({
        debug: debug,
        errHandler: errHandler,
        videoModel: videoModel,
        customParametersModel: customParametersModel,
        capabilities: capabilities,
        eventBus: eventBus,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"],
        BASE64: _externals_base64__WEBPACK_IMPORTED_MODULE_37___default.a,
        constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"],
        cmcdModel: cmcdModel,
        settings: settings
      });
      return protectionController;
    }

    return null;
  }

  function _detectMetricsReporting() {
    if (metricsReportingController) {
      return;
    } // do not require MetricsReporting as dependencies as this is optional and intended to be loaded separately


    var MetricsReporting = dashjs.MetricsReporting;
    /* jshint ignore:line */

    if (typeof MetricsReporting === 'function') {
      //TODO need a better way to register/detect plugin components
      var metricsReporting = MetricsReporting(context).create();
      metricsReportingController = metricsReporting.createMetricsReporting({
        debug: debug,
        eventBus: eventBus,
        mediaElement: getVideoElement(),
        adapter: adapter,
        dashMetrics: dashMetrics,
        mediaPlayerModel: mediaPlayerModel,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"],
        constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"],
        metricsConstants: _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"]
      });
    }
  }

  function _detectMss() {
    if (mssHandler) {
      return;
    } // do not require MssHandler as dependencies as this is optional and intended to be loaded separately


    var MssHandler = dashjs.MssHandler;
    /* jshint ignore:line */

    if (typeof MssHandler === 'function') {
      //TODO need a better way to register/detect plugin components
      _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"].extend(MssHandler.errors);
      mssHandler = MssHandler(context).create({
        eventBus: eventBus,
        mediaPlayerModel: mediaPlayerModel,
        dashMetrics: dashMetrics,
        manifestModel: manifestModel,
        playbackController: playbackController,
        streamController: streamController,
        protectionController: protectionController,
        baseURLController: baseURLController,
        errHandler: errHandler,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"],
        constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"],
        debug: debug,
        initSegmentType: _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_36__["HTTPRequest"].INIT_SEGMENT_TYPE,
        BASE64: _externals_base64__WEBPACK_IMPORTED_MODULE_37___default.a,
        ISOBoxer: codem_isoboxer__WEBPACK_IMPORTED_MODULE_38___default.a,
        settings: settings
      });
    }
  }

  function _detectOffline() {
    if (!mediaPlayerInitialized) {
      throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
    }

    if (offlineController) {
      return offlineController;
    } // do not require Offline as dependencies as this is optional and intended to be loaded separately


    var OfflineController = dashjs.OfflineController;
    /* jshint ignore:line */

    if (typeof OfflineController === 'function') {
      //TODO need a better way to register/detect plugin components
      _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"].extend(OfflineController.events);
      _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_28__["default"].extend(OfflineController.events, {
        publicOnly: true
      });
      _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"].extend(OfflineController.errors);

      var manifestLoader = _createManifestLoader();

      var manifestUpdater = Object(_ManifestUpdater__WEBPACK_IMPORTED_MODULE_41__["default"])(context).create();
      manifestUpdater.setConfig({
        manifestModel: manifestModel,
        adapter: adapter,
        manifestLoader: manifestLoader,
        errHandler: errHandler
      });
      offlineController = OfflineController(context).create({
        debug: debug,
        manifestUpdater: manifestUpdater,
        baseURLController: baseURLController,
        manifestLoader: manifestLoader,
        manifestModel: manifestModel,
        mediaPlayerModel: mediaPlayerModel,
        abrController: abrController,
        playbackController: playbackController,
        adapter: adapter,
        errHandler: errHandler,
        dashMetrics: dashMetrics,
        timelineConverter: timelineConverter,
        segmentBaseController: segmentBaseController,
        schemeLoaderFactory: schemeLoaderFactory,
        eventBus: eventBus,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_27__["default"],
        errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"],
        constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"],
        settings: settings,
        dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_2__["default"],
        urlUtils: Object(_streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_42__["default"])(context).getInstance()
      });
      return offlineController;
    }

    return null;
  }

  function _getAsUTC(valToConvert) {
    var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO;
    var metric = dashMetrics.getCurrentDVRInfo(type);
    var availableFrom, utcValue;

    if (!metric) {
      return 0;
    }

    availableFrom = metric.manifestInfo.availableFrom.getTime() / 1000;
    utcValue = valToConvert + (availableFrom + metric.range.start);
    return utcValue;
  }

  function _initializePlayback() {
    if (offlineController) {
      offlineController.resetRecords();
    }

    if (!streamingInitialized && source) {
      streamingInitialized = true;
      logger.info('Streaming Initialized');

      _createPlaybackControllers();

      if (typeof source === 'string') {
        streamController.load(source);
      } else {
        streamController.loadWithManifest(source);
      }
    }

    if (!playbackInitialized && isReady()) {
      playbackInitialized = true;
      logger.info('Playback Initialized');
    }
  }

  instance = {
    initialize: initialize,
    setConfig: setConfig,
    on: on,
    off: off,
    extend: extend,
    attachView: attachView,
    attachSource: attachSource,
    isReady: isReady,
    play: play,
    isPaused: isPaused,
    pause: pause,
    isSeeking: isSeeking,
    isDynamic: isDynamic,
    getLowLatencyModeEnabled: getLowLatencyModeEnabled,
    seek: seek,
    setPlaybackRate: setPlaybackRate,
    getPlaybackRate: getPlaybackRate,
    setMute: setMute,
    isMuted: isMuted,
    setVolume: setVolume,
    getVolume: getVolume,
    time: time,
    duration: duration,
    timeAsUTC: timeAsUTC,
    durationAsUTC: durationAsUTC,
    getActiveStream: getActiveStream,
    getDVRWindowSize: getDVRWindowSize,
    getDVRSeekOffset: getDVRSeekOffset,
    getTargetLiveDelay: getTargetLiveDelay,
    convertToTimeCode: convertToTimeCode,
    formatUTC: formatUTC,
    getVersion: getVersion,
    getDebug: getDebug,
    getBufferLength: getBufferLength,
    getTTMLRenderingDiv: getTTMLRenderingDiv,
    getVideoElement: getVideoElement,
    getSource: getSource,
    updateSource: updateSource,
    getCurrentLiveLatency: getCurrentLiveLatency,
    getTopBitrateInfoFor: getTopBitrateInfoFor,
    setAutoPlay: setAutoPlay,
    getAutoPlay: getAutoPlay,
    getDashMetrics: getDashMetrics,
    getQualityFor: getQualityFor,
    setQualityFor: setQualityFor,
    updatePortalSize: updatePortalSize,
    enableText: enableText,
    enableForcedTextStreaming: enableForcedTextStreaming,
    isTextEnabled: isTextEnabled,
    setTextTrack: setTextTrack,
    getBitrateInfoListFor: getBitrateInfoListFor,
    getStreamsFromManifest: getStreamsFromManifest,
    getTracksFor: getTracksFor,
    getTracksForTypeFromManifest: getTracksForTypeFromManifest,
    getCurrentTrackFor: getCurrentTrackFor,
    setInitialMediaSettingsFor: setInitialMediaSettingsFor,
    getInitialMediaSettingsFor: getInitialMediaSettingsFor,
    setCurrentTrack: setCurrentTrack,
    addABRCustomRule: addABRCustomRule,
    removeABRCustomRule: removeABRCustomRule,
    removeAllABRCustomRule: removeAllABRCustomRule,
    getABRCustomRules: getABRCustomRules,
    getAverageThroughput: getAverageThroughput,
    retrieveManifest: retrieveManifest,
    addUTCTimingSource: addUTCTimingSource,
    removeUTCTimingSource: removeUTCTimingSource,
    clearDefaultUTCTimingSources: clearDefaultUTCTimingSources,
    restoreDefaultUTCTimingSources: restoreDefaultUTCTimingSources,
    setXHRWithCredentialsForType: setXHRWithCredentialsForType,
    getXHRWithCredentialsForType: getXHRWithCredentialsForType,
    getProtectionController: getProtectionController,
    attachProtectionController: attachProtectionController,
    setProtectionData: setProtectionData,
    registerLicenseRequestFilter: registerLicenseRequestFilter,
    registerLicenseResponseFilter: registerLicenseResponseFilter,
    unregisterLicenseRequestFilter: unregisterLicenseRequestFilter,
    unregisterLicenseResponseFilter: unregisterLicenseResponseFilter,
    registerCustomCapabilitiesFilter: registerCustomCapabilitiesFilter,
    unregisterCustomCapabilitiesFilter: unregisterCustomCapabilitiesFilter,
    setCustomInitialTrackSelectionFunction: setCustomInitialTrackSelectionFunction,
    resetCustomInitialTrackSelectionFunction: resetCustomInitialTrackSelectionFunction,
    attachTTMLRenderingDiv: attachTTMLRenderingDiv,
    getCurrentTextTrackIndex: getCurrentTextTrackIndex,
    provideThumbnail: provideThumbnail,
    getDashAdapter: getDashAdapter,
    getOfflineController: getOfflineController,
    getSettings: getSettings,
    updateSettings: updateSettings,
    resetSettings: resetSettings,
    reset: reset,
    destroy: destroy
  };
  setup();
  return instance;
}

MediaPlayer.__dashjs_factory_name = 'MediaPlayer';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_29__["default"].getClassFactory(MediaPlayer);
factory.events = _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_28__["default"];
factory.errors = _core_errors_Errors__WEBPACK_IMPORTED_MODULE_25__["default"];
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_29__["default"].updateClassFactory(MediaPlayer.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/MediaPlayerEvents.js":
/*!********************************************!*\
  !*** ./src/streaming/MediaPlayerEvents.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1191840__) {

"use strict";
__nested_webpack_require_1191840__.r(__webpack_exports__);
/* harmony import */ var _core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1191840__(/*! ../core/events/EventsBase */ "./src/core/events/EventsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @implements EventsBase
 */

var MediaPlayerEvents = /*#__PURE__*/function (_EventsBase) {
  _inherits(MediaPlayerEvents, _EventsBase);

  var _super = _createSuper(MediaPlayerEvents);

  /**
   * @description Public facing external events to be used when developing a player that implements dash.js.
   */
  function MediaPlayerEvents() {
    var _this;

    _classCallCheck(this, MediaPlayerEvents);

    _this = _super.call(this);
    /**
     * Triggered when playback will not start yet
     * as the MPD's availabilityStartTime is in the future.
     * Check delay property in payload to determine time before playback will start.
     * @event MediaPlayerEvents#AST_IN_FUTURE
     */

    _this.AST_IN_FUTURE = 'astInFuture';
    /**
     * Triggered when the video element's buffer state changes to stalled.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_EMPTY
     */

    _this.BUFFER_EMPTY = 'bufferStalled';
    /**
     * Triggered when the video element's buffer state changes to loaded.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_LOADED
     */

    _this.BUFFER_LOADED = 'bufferLoaded';
    /**
     * Triggered when the video element's buffer state changes, either stalled or loaded. Check payload for state.
     * @event MediaPlayerEvents#BUFFER_LEVEL_STATE_CHANGED
     */

    _this.BUFFER_LEVEL_STATE_CHANGED = 'bufferStateChanged';
    /**
     * Triggered when the buffer level of a media type has been updated
     * @event MediaPlayerEvents#BUFFER_LEVEL_UPDATED
     */

    _this.BUFFER_LEVEL_UPDATED = 'bufferLevelUpdated';
    /**
     * Triggered when a dynamic stream changed to static (transition phase between Live and On-Demand).
     * @event MediaPlayerEvents#DYNAMIC_TO_STATIC
     */

    _this.DYNAMIC_TO_STATIC = 'dynamicToStatic';
    /**
     * Triggered when there is an error from the element or MSE source buffer.
     * @event MediaPlayerEvents#ERROR
     */

    _this.ERROR = 'error';
    /**
     * Triggered when a fragment download has completed.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_COMPLETED
     */

    _this.FRAGMENT_LOADING_COMPLETED = 'fragmentLoadingCompleted';
    /**
     * Triggered when a partial fragment download has completed.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_PROGRESS
     */

    _this.FRAGMENT_LOADING_PROGRESS = 'fragmentLoadingProgress';
    /**
     * Triggered when a fragment download has started.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_STARTED
     */

    _this.FRAGMENT_LOADING_STARTED = 'fragmentLoadingStarted';
    /**
     * Triggered when a fragment download is abandoned due to detection of slow download base on the ABR abandon rule..
     * @event MediaPlayerEvents#FRAGMENT_LOADING_ABANDONED
     */

    _this.FRAGMENT_LOADING_ABANDONED = 'fragmentLoadingAbandoned';
    /**
     * Triggered when {@link module:Debug} logger methods are called.
     * @event MediaPlayerEvents#LOG
     */

    _this.LOG = 'log';
    /**
     * Triggered when the manifest load is complete
     * @event MediaPlayerEvents#MANIFEST_LOADED
     */

    _this.MANIFEST_LOADED = 'manifestLoaded';
    /**
     * Triggered anytime there is a change to the overall metrics.
     * @event MediaPlayerEvents#METRICS_CHANGED
     */

    _this.METRICS_CHANGED = 'metricsChanged';
    /**
     * Triggered when an individual metric is added, updated or cleared.
     * @event MediaPlayerEvents#METRIC_CHANGED
     */

    _this.METRIC_CHANGED = 'metricChanged';
    /**
     * Triggered every time a new metric is added.
     * @event MediaPlayerEvents#METRIC_ADDED
     */

    _this.METRIC_ADDED = 'metricAdded';
    /**
     * Triggered every time a metric is updated.
     * @event MediaPlayerEvents#METRIC_UPDATED
     */

    _this.METRIC_UPDATED = 'metricUpdated';
    /**
     * Triggered when a new stream (period) starts.
     * @event MediaPlayerEvents#PERIOD_SWITCH_STARTED
     */

    _this.PERIOD_SWITCH_STARTED = 'periodSwitchStarted';
    /**
     * Triggered at the stream end of a period.
     * @event MediaPlayerEvents#PERIOD_SWITCH_COMPLETED
     */

    _this.PERIOD_SWITCH_COMPLETED = 'periodSwitchCompleted';
    /**
     * Triggered when an ABR up /down switch is initiated; either by user in manual mode or auto mode via ABR rules.
     * @event MediaPlayerEvents#QUALITY_CHANGE_REQUESTED
     */

    _this.QUALITY_CHANGE_REQUESTED = 'qualityChangeRequested';
    /**
     * Triggered when the new ABR quality is being rendered on-screen.
     * @event MediaPlayerEvents#QUALITY_CHANGE_RENDERED
     */

    _this.QUALITY_CHANGE_RENDERED = 'qualityChangeRendered';
    /**
     * Triggered when the new track is being rendered.
     * @event MediaPlayerEvents#TRACK_CHANGE_RENDERED
     */

    _this.TRACK_CHANGE_RENDERED = 'trackChangeRendered';
    /**
     * Triggered when a stream (period) is being loaded
     * @event MediaPlayerEvents#STREAM_INITIALIZING
     */

    _this.STREAM_INITIALIZING = 'streamInitializing';
    /**
     * Triggered when a stream (period) is loaded
     * @event MediaPlayerEvents#STREAM_UPDATED
     */

    _this.STREAM_UPDATED = 'streamUpdated';
    /**
     * Triggered when a stream (period) is activated
     * @event MediaPlayerEvents#STREAM_ACTIVATED
     */

    _this.STREAM_ACTIVATED = 'streamActivated';
    /**
     * Triggered when a stream (period) is deactivated
     * @event MediaPlayerEvents#STREAM_DEACTIVATED
     */

    _this.STREAM_DEACTIVATED = 'streamDeactivated';
    /**
     * Triggered when a stream (period) is activated
     * @event MediaPlayerEvents#STREAM_INITIALIZED
     */

    _this.STREAM_INITIALIZED = 'streamInitialized';
    /**
     * Triggered when the player has been reset.
     * @event MediaPlayerEvents#STREAM_TEARDOWN_COMPLETE
     */

    _this.STREAM_TEARDOWN_COMPLETE = 'streamTeardownComplete';
    /**
     * Triggered once all text tracks detected in the MPD are added to the video element.
     * @event MediaPlayerEvents#TEXT_TRACKS_ADDED
     */

    _this.TEXT_TRACKS_ADDED = 'allTextTracksAdded';
    /**
     * Triggered when a text track is added to the video element's TextTrackList
     * @event MediaPlayerEvents#TEXT_TRACK_ADDED
     */

    _this.TEXT_TRACK_ADDED = 'textTrackAdded';
    /**
     * Triggered when a ttml chunk is parsed.
     * @event MediaPlayerEvents#TTML_PARSED
     */

    _this.TTML_PARSED = 'ttmlParsed';
    /**
     * Triggered when a ttml chunk has to be parsed.
     * @event MediaPlayerEvents#TTML_TO_PARSE
     */

    _this.TTML_TO_PARSE = 'ttmlToParse';
    /**
     * Triggered when a caption is rendered.
     * @event MediaPlayerEvents#CAPTION_RENDERED
     */

    _this.CAPTION_RENDERED = 'captionRendered';
    /**
     * Triggered when the caption container is resized.
     * @event MediaPlayerEvents#CAPTION_CONTAINER_RESIZE
     */

    _this.CAPTION_CONTAINER_RESIZE = 'captionContainerResize';
    /**
     * Sent when enough data is available that the media can be played,
     * at least for a couple of frames.  This corresponds to the
     * HAVE_ENOUGH_DATA readyState.
     * @event MediaPlayerEvents#CAN_PLAY
     */

    _this.CAN_PLAY = 'canPlay';
    /**
     * This corresponds to the CAN_PLAY_THROUGH readyState.
     * @event MediaPlayerEvents#CAN_PLAY_THROUGH
     */

    _this.CAN_PLAY_THROUGH = 'canPlayThrough';
    /**
     * Sent when playback completes.
     * @event MediaPlayerEvents#PLAYBACK_ENDED
     */

    _this.PLAYBACK_ENDED = 'playbackEnded';
    /**
     * Sent when an error occurs.  The element's error
     * attribute contains more information.
     * @event MediaPlayerEvents#PLAYBACK_ERROR
     */

    _this.PLAYBACK_ERROR = 'playbackError';
    /**
     * Sent when playback is not allowed (for example if user gesture is needed).
     * @event MediaPlayerEvents#PLAYBACK_NOT_ALLOWED
     */

    _this.PLAYBACK_NOT_ALLOWED = 'playbackNotAllowed';
    /**
     * The media's metadata has finished loading; all attributes now
     * contain as much useful information as they're going to.
     * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
     */

    _this.PLAYBACK_METADATA_LOADED = 'playbackMetaDataLoaded';
    /**
     * The media's metadata has finished loading; all attributes now
     * contain as much useful information as they're going to.
     * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
     */

    _this.PLAYBACK_LOADED_DATA = 'playbackLoadedData';
    /**
     * Sent when playback is paused.
     * @event MediaPlayerEvents#PLAYBACK_PAUSED
     */

    _this.PLAYBACK_PAUSED = 'playbackPaused';
    /**
     * Sent when the media begins to play (either for the first time, after having been paused,
     * or after ending and then restarting).
     *
     * @event MediaPlayerEvents#PLAYBACK_PLAYING
     */

    _this.PLAYBACK_PLAYING = 'playbackPlaying';
    /**
     * Sent periodically to inform interested parties of progress downloading
     * the media. Information about the current amount of the media that has
     * been downloaded is available in the media element's buffered attribute.
     * @event MediaPlayerEvents#PLAYBACK_PROGRESS
     */

    _this.PLAYBACK_PROGRESS = 'playbackProgress';
    /**
     * Sent when the playback speed changes.
     * @event MediaPlayerEvents#PLAYBACK_RATE_CHANGED
     */

    _this.PLAYBACK_RATE_CHANGED = 'playbackRateChanged';
    /**
     * Sent when a seek operation completes.
     * @event MediaPlayerEvents#PLAYBACK_SEEKED
     */

    _this.PLAYBACK_SEEKED = 'playbackSeeked';
    /**
     * Sent when a seek operation begins.
     * @event MediaPlayerEvents#PLAYBACK_SEEKING
     */

    _this.PLAYBACK_SEEKING = 'playbackSeeking';
    /**
     * Sent when the video element reports stalled
     * @event MediaPlayerEvents#PLAYBACK_STALLED
     */

    _this.PLAYBACK_STALLED = 'playbackStalled';
    /**
     * Sent when playback of the media starts after having been paused;
     * that is, when playback is resumed after a prior pause event.
     *
     * @event MediaPlayerEvents#PLAYBACK_STARTED
     */

    _this.PLAYBACK_STARTED = 'playbackStarted';
    /**
     * The time indicated by the element's currentTime attribute has changed.
     * @event MediaPlayerEvents#PLAYBACK_TIME_UPDATED
     */

    _this.PLAYBACK_TIME_UPDATED = 'playbackTimeUpdated';
    /**
     * Sent when the media playback has stopped because of a temporary lack of data.
     *
     * @event MediaPlayerEvents#PLAYBACK_WAITING
     */

    _this.PLAYBACK_WAITING = 'playbackWaiting';
    /**
     * Manifest validity changed - As a result of an MPD validity expiration event.
     * @event MediaPlayerEvents#MANIFEST_VALIDITY_CHANGED
     */

    _this.MANIFEST_VALIDITY_CHANGED = 'manifestValidityChanged';
    /**
     * Dash events are triggered at their respective start points on the timeline.
     * @event MediaPlayerEvents#EVENT_MODE_ON_START
     */

    _this.EVENT_MODE_ON_START = 'eventModeOnStart';
    /**
     * Dash events are triggered as soon as they were parsed.
     * @event MediaPlayerEvents#EVENT_MODE_ON_RECEIVE
     */

    _this.EVENT_MODE_ON_RECEIVE = 'eventModeOnReceive';
    /**
     * Event that is dispatched whenever the player encounters a potential conformance validation that might lead to unexpected/not optimal behavior
     * @event MediaPlayerEvents#CONFORMANCE_VIOLATION
     */

    _this.CONFORMANCE_VIOLATION = 'conformanceViolation';
    /**
     * Event that is dispatched whenever the player switches to a different representation
     * @event MediaPlayerEvents#REPRESENTATION_SWITCH
     */

    _this.REPRESENTATION_SWITCH = 'representationSwitch';
    /**
     * Event that is dispatched whenever an adaptation set is removed due to all representations not being supported.
     * @event MediaPlayerEvents#ADAPTATION_SET_REMOVED_NO_CAPABILITIES
     */

    _this.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = 'adaptationSetRemovedNoCapabilities';
    return _this;
  }

  return MediaPlayerEvents;
}(_core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var mediaPlayerEvents = new MediaPlayerEvents();
/* harmony default export */ __webpack_exports__["default"] = (mediaPlayerEvents);

/***/ }),

/***/ "./src/streaming/MediaPlayerFactory.js":
/*!*********************************************!*\
  !*** ./src/streaming/MediaPlayerFactory.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1209381__) {

"use strict";
__nested_webpack_require_1209381__.r(__webpack_exports__);
/* harmony import */ var _MediaPlayer__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1209381__(/*! ./MediaPlayer */ "./src/streaming/MediaPlayer.js");


function MediaPlayerFactory() {
  /**
   * mime-type identifier for any source content to be accepted as a dash manifest by the create() method.
   * @type {string}
   */
  var SUPPORTED_MIME_TYPE = 'application/dash+xml';
  var logger;
  /**
   *  A new MediaPlayer is instantiated for the supplied videoElement and optional source and context.  If no context is provided,
   *  a default DashContext is used. If no source is provided, the videoElement is interrogated to extract the first source whose
   *  type is application/dash+xml.
   * The autoplay property of the videoElement is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
   * @param {HTMLMediaElement} video
   * @param {HTMLSourceElement} source
   * @param {Object} context
   * @returns {MediaPlayer|null}
   */

  function create(video, source, context) {
    if (!video || !/^VIDEO$/i.test(video.nodeName)) return null;
    if (video._dashjs_player) return video._dashjs_player;
    var player;
    var videoID = video.id || video.name || 'video element';
    source = source || [].slice.call(video.querySelectorAll('source')).filter(function (s) {
      return s.type == SUPPORTED_MIME_TYPE;
    })[0];

    if (!source && video.src) {
      source = document.createElement('source');
      source.src = video.src;
    } else if (!source && !video.src) {
      return null;
    }

    context = context || {};
    player = Object(_MediaPlayer__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create();
    player.initialize(video, source.src, video.autoplay);

    if (!logger) {
      logger = player.getDebug().getLogger();
    }

    logger.debug('Converted ' + videoID + ' to dash.js player and added content: ' + source.src); // Store a reference to the player on the video element so it can be gotten at for debugging and so we know its
    // already been setup.

    video._dashjs_player = player;
    return player;
  }
  /**
   * Searches the provided scope for all instances of the indicated selector. If no scope is provided, document is used. If no selector is
   * specified, [data-dashjs-player] is used. The declarative setup also looks for source elements with the type attribute set to 'application/dash+xml'.
   * It then looks for those video elements which have a source element defined with a type matching 'application/dash+xml'.
   * A new MediaPlayer is instantiated for each matching video element and the appropriate source is assigned.
   * The autoplay property of the video element is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
   * Returns an array holding all the MediaPlayer instances that were added by this method.
   * @param {string} selector - CSS selector
   * @param {Object} scope
   * @returns {Array} an array of MediaPlayer objects
   */


  function createAll(selector, scope) {
    var aPlayers = [];
    selector = selector || '[data-dashjs-player]';
    scope = scope || document;
    var videos = scope.querySelectorAll(selector);

    for (var i = 0; i < videos.length; i++) {
      var player = create(videos[i], null);
      aPlayers.push(player);
    }

    var sources = scope.querySelectorAll('source[type="' + SUPPORTED_MIME_TYPE + '"]');

    for (var _i = 0; _i < sources.length; _i++) {
      var video = findVideo(sources[_i]);

      var _player = create(video, null);

      aPlayers.push(_player);
    }

    return aPlayers;
  }

  function findVideo(el) {
    if (/^VIDEO$/i.test(el.nodeName)) {
      return el;
    } else {
      return findVideo(el.parentNode);
    }
  }

  return {
    create: create,
    createAll: createAll
  };
}

var instance = MediaPlayerFactory();
var loadInterval;

function loadHandler() {
  window.removeEventListener('load', loadHandler);
  instance.createAll();
}

function loadIntervalHandler() {
  if (window.dashjs) {
    window.clearInterval(loadInterval);
    instance.createAll();
  }
}

var avoidAutoCreate = typeof window !== 'undefined' && window && window.dashjs && window.dashjs.skipAutoCreate;

if (!avoidAutoCreate && typeof window !== 'undefined' && window && window.addEventListener) {
  if (window.document.readyState === 'complete') {
    if (window.dashjs) {
      instance.createAll();
    } else {
      // If loaded asynchronously, window.readyState may be 'complete' even if dashjs hasn't loaded yet
      loadInterval = window.setInterval(loadIntervalHandler, 500);
    }
  } else {
    window.addEventListener('load', loadHandler);
  }
}

/* harmony default export */ __webpack_exports__["default"] = (instance);

/***/ }),

/***/ "./src/streaming/SourceBufferSink.js":
/*!*******************************************!*\
  !*** ./src/streaming/SourceBufferSink.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1214689__) {

"use strict";
__nested_webpack_require_1214689__.r(__webpack_exports__);
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1214689__(/*! ../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1214689__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1214689__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1214689__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1214689__(/*! ../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1214689__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1214689__(/*! ./vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1214689__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








var APPEND_WINDOW_START_OFFSET = 0.1;
var APPEND_WINDOW_END_OFFSET = 0.01;
/**
 * @class SourceBufferSink
 * @ignore
 * @implements FragmentSink
 */

var CHECK_INTERVAL = 50;

function SourceBufferSink(config) {
  var context = this.context;
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var textController = config.textController;
  var eventBus = config.eventBus;
  var instance, type, logger, buffer, mediaInfo, intervalId;
  var callbacks = [];
  var appendQueue = [];
  var isAppendingInProgress = false;
  var mediaSource = config.mediaSource;
  var lastRequestAppended = null;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance().getLogger(instance);
  }

  function initializeForStreamSwitch(mInfo, selectedRepresentation, oldSourceBufferSink) {
    mediaInfo = mInfo;
    type = mediaInfo.type;
    var codec = mediaInfo.codec;

    _copyPreviousSinkData(oldSourceBufferSink);

    _addEventListeners();

    var promises = [];
    promises.push(_abortBeforeAppend);
    promises.push(updateAppendWindow(mediaInfo.streamInfo));
    promises.push(changeType(codec));

    if (selectedRepresentation && selectedRepresentation.MSETimeOffset !== undefined) {
      promises.push(updateTimestampOffset(selectedRepresentation.MSETimeOffset));
    }

    return Promise.all(promises);
  }

  function changeType(codec) {
    return new Promise(function (resolve) {
      _waitForUpdateEnd(function () {
        if (buffer.changeType) {
          buffer.changeType(codec);
        }

        resolve();
      });
    });
  }

  function _copyPreviousSinkData(oldSourceBufferSink) {
    buffer = oldSourceBufferSink.getBuffer();
  }

  function initializeForFirstUse(streamInfo, mInfo, selectedRepresentation) {
    mediaInfo = mInfo;
    type = mediaInfo.type;
    var codec = mediaInfo.codec;

    try {
      // Safari claims to support anything starting 'application/mp4'.
      // it definitely doesn't understand 'application/mp4;codecs="stpp"'
      // - currently no browser does, so check for it and use our own
      // implementation. The same is true for codecs="wvtt".
      if (codec.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) {
        return _initializeForText(streamInfo);
      }

      buffer = mediaSource.addSourceBuffer(codec);

      _addEventListeners();

      var promises = [];
      promises.push(updateAppendWindow(mediaInfo.streamInfo));

      if (selectedRepresentation && selectedRepresentation.MSETimeOffset !== undefined) {
        promises.push(updateTimestampOffset(selectedRepresentation.MSETimeOffset));
      }

      return Promise.all(promises);
    } catch (e) {
      // Note that in the following, the quotes are open to allow for extra text after stpp and wvtt
      if (mediaInfo.type == _constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].TEXT && !mediaInfo.isFragmented || codec.indexOf('codecs="stpp') !== -1 || codec.indexOf('codecs="vtt') !== -1) {
        return _initializeForText(streamInfo);
      }

      return Promise.reject(e);
    }
  }

  function _initializeForText(streamInfo) {
    buffer = textController.getTextSourceBuffer(streamInfo);
    return Promise.resolve();
  }

  function _addEventListeners() {
    // use updateend event if possible
    if (typeof buffer.addEventListener === 'function') {
      try {
        buffer.addEventListener('updateend', _updateEndHandler, false);
        buffer.addEventListener('error', _errHandler, false);
        buffer.addEventListener('abort', _errHandler, false);
      } catch (err) {
        // use setInterval to periodically check if updating has been completed
        intervalId = setInterval(_updateEndHandler, CHECK_INTERVAL);
      }
    } else {
      // use setInterval to periodically check if updating has been completed
      intervalId = setInterval(_updateEndHandler, CHECK_INTERVAL);
    }
  }

  function getType() {
    return type;
  }

  function _removeEventListeners() {
    try {
      if (typeof buffer.removeEventListener === 'function') {
        buffer.removeEventListener('updateend', _updateEndHandler, false);
        buffer.removeEventListener('error', _errHandler, false);
        buffer.removeEventListener('abort', _errHandler, false);
      }

      clearInterval(intervalId);
    } catch (e) {
      logger.error(e);
    }
  }

  function updateAppendWindow(sInfo) {
    return new Promise(function (resolve) {
      if (!buffer || !settings.get().streaming.buffer.useAppendWindow) {
        resolve();
        return;
      }

      _waitForUpdateEnd(function () {
        try {
          if (!buffer) {
            resolve();
            return;
          }

          var appendWindowEnd = mediaSource.duration;
          var appendWindowStart = 0;

          if (sInfo && !isNaN(sInfo.start) && !isNaN(sInfo.duration) && isFinite(sInfo.duration)) {
            appendWindowEnd = sInfo.start + sInfo.duration;
          }

          if (sInfo && !isNaN(sInfo.start)) {
            appendWindowStart = sInfo.start;
          }

          if (buffer.appendWindowEnd !== appendWindowEnd || buffer.appendWindowStart !== appendWindowStart) {
            buffer.appendWindowStart = 0;
            buffer.appendWindowEnd = appendWindowEnd + APPEND_WINDOW_END_OFFSET;
            buffer.appendWindowStart = Math.max(appendWindowStart - APPEND_WINDOW_START_OFFSET, 0);
            logger.debug("Updated append window for ".concat(mediaInfo.type, ". Set start to ").concat(buffer.appendWindowStart, " and end to ").concat(buffer.appendWindowEnd));
          }

          resolve();
        } catch (e) {
          logger.warn("Failed to set append window");
          resolve();
        }
      });
    });
  }

  function updateTimestampOffset(MSETimeOffset) {
    return new Promise(function (resolve) {
      if (!buffer) {
        resolve();
        return;
      }

      _waitForUpdateEnd(function () {
        try {
          if (buffer.timestampOffset !== MSETimeOffset && !isNaN(MSETimeOffset)) {
            buffer.timestampOffset = MSETimeOffset;
            logger.debug("Set MSE timestamp offset to ".concat(MSETimeOffset));
          }

          resolve();
        } catch (e) {
          resolve();
        }
      });
    });
  }

  function reset() {
    if (buffer) {
      try {
        callbacks = [];

        _removeEventListeners();

        isAppendingInProgress = false;
        appendQueue = [];

        if (!buffer.getClassName || buffer.getClassName() !== 'TextSourceBuffer') {
          logger.debug("Removing sourcebuffer from media source");
          mediaSource.removeSourceBuffer(buffer);
        }
      } catch (e) {}

      buffer = null;
    }

    lastRequestAppended = null;
  }

  function getBuffer() {
    return buffer;
  }

  function getAllBufferRanges() {
    try {
      return buffer.buffered;
    } catch (e) {
      logger.error('getAllBufferRanges exception: ' + e.message);
      return null;
    }
  }

  function append(chunk) {
    var _this = this;

    var request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return new Promise(function (resolve, reject) {
      if (!chunk) {
        reject({
          chunk: chunk,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_3__["default"].APPEND_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_3__["default"].APPEND_ERROR_MESSAGE)
        });
        return;
      }

      appendQueue.push({
        data: chunk,
        promise: {
          resolve: resolve,
          reject: reject
        },
        request: request
      });

      _waitForUpdateEnd(_appendNextInQueue.bind(_this));
    });
  }

  function _abortBeforeAppend() {
    return new Promise(function (resolve) {
      _waitForUpdateEnd(function () {
        // Save the append window, which is reset on abort().
        var appendWindowStart = buffer.appendWindowStart;
        var appendWindowEnd = buffer.appendWindowEnd;

        if (buffer) {
          buffer.abort();
          buffer.appendWindowStart = appendWindowStart;
          buffer.appendWindowEnd = appendWindowEnd;
        }

        resolve();
      });
    });
  }

  function remove(range) {
    return new Promise(function (resolve, reject) {
      var start = range.start;
      var end = range.end; // make sure that the given time range is correct. Otherwise we will get InvalidAccessError

      if (!(start >= 0 && end > start)) {
        resolve();
        return;
      }

      _waitForUpdateEnd(function () {
        try {
          buffer.remove(start, end); // updating is in progress, we should wait for it to complete before signaling that this operation is done

          _waitForUpdateEnd(function () {
            resolve({
              from: start,
              to: end,
              unintended: false
            });

            if (range.resolve) {
              range.resolve();
            }
          });
        } catch (err) {
          reject({
            from: start,
            to: end,
            unintended: false,
            error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_3__["default"].REMOVE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_3__["default"].REMOVE_ERROR_MESSAGE)
          });

          if (range.reject) {
            range.reject(err);
          }
        }
      });
    });
  }

  function _appendNextInQueue() {
    if (isAppendingInProgress) {
      return;
    }

    if (appendQueue.length > 0) {
      isAppendingInProgress = true;
      var nextChunk = appendQueue[0];
      appendQueue.splice(0, 1);

      var afterSuccess = function afterSuccess() {
        isAppendingInProgress = false;

        if (appendQueue.length > 0) {
          _appendNextInQueue.call(this);
        } // Init segments are cached. In any other case we dont need the chunk bytes anymore and can free the memory


        if (nextChunk && nextChunk.data && nextChunk.data.segmentType && nextChunk.data.segmentType !== _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].INIT_SEGMENT_TYPE) {
          delete nextChunk.data.bytes;
        }

        nextChunk.promise.resolve({
          chunk: nextChunk.data
        });
      };

      try {
        lastRequestAppended = nextChunk.request;

        if (nextChunk.data.bytes.byteLength === 0) {
          afterSuccess.call(this);
        } else {
          if (buffer.appendBuffer) {
            buffer.appendBuffer(nextChunk.data.bytes);
          } else {
            buffer.append(nextChunk.data.bytes, nextChunk.data);
          } // updating is in progress, we should wait for it to complete before signaling that this operation is done


          _waitForUpdateEnd(afterSuccess.bind(this));
        }
      } catch (err) {
        logger.fatal('SourceBuffer append failed "' + err + '"');

        if (appendQueue.length > 0) {
          _appendNextInQueue();
        } else {
          isAppendingInProgress = false;
        }

        delete nextChunk.data.bytes;
        nextChunk.promise.reject({
          chunk: nextChunk.data,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_1__["default"](err.code, err.message)
        });
      }
    }
  }

  function abort() {
    return new Promise(function (resolve) {
      try {
        appendQueue = [];

        if (mediaSource.readyState === 'open') {
          _waitForUpdateEnd(function () {
            try {
              if (buffer) {
                buffer.abort();
              }

              resolve();
            } catch (e) {
              resolve();
            }
          });
        } else if (buffer && buffer.setTextTrack && mediaSource.readyState === 'ended') {
          buffer.abort(); //The cues need to be removed from the TextSourceBuffer via a call to abort()

          resolve();
        } else {
          resolve();
        }
      } catch (e) {
        resolve();
      }
    });
  }

  function _executeCallback() {
    if (callbacks.length > 0) {
      if (!buffer.updating) {
        var cb = callbacks.shift();
        cb(); // Try to execute next callback if still not updating

        _executeCallback();
      }
    }
  }

  function _updateEndHandler() {
    // if updating is still in progress do nothing and wait for the next check again.
    if (buffer.updating) {
      return;
    } // updating is completed, now we can stop checking and resolve the promise


    _executeCallback();
  }

  function _errHandler(e) {
    var error = e.target || {};

    _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].SOURCE_BUFFER_ERROR, {
      error: error,
      lastRequestAppended: lastRequestAppended
    });
  }

  function _triggerEvent(eventType, data) {
    var payload = data || {};
    eventBus.trigger(eventType, payload, {
      streamId: mediaInfo.streamInfo.id,
      mediaType: type
    });
  }

  function _waitForUpdateEnd(callback) {
    callbacks.push(callback);

    if (!buffer.updating) {
      _executeCallback();
    }
  }

  instance = {
    getType: getType,
    getAllBufferRanges: getAllBufferRanges,
    getBuffer: getBuffer,
    append: append,
    remove: remove,
    abort: abort,
    reset: reset,
    updateTimestampOffset: updateTimestampOffset,
    initializeForStreamSwitch: initializeForStreamSwitch,
    initializeForFirstUse: initializeForFirstUse,
    updateAppendWindow: updateAppendWindow,
    changeType: changeType
  };
  setup();
  return instance;
}

SourceBufferSink.__dashjs_factory_name = 'SourceBufferSink';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(SourceBufferSink);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/Stream.js":
/*!*********************************!*\
  !*** ./src/streaming/Stream.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1232541__) {

"use strict";
__nested_webpack_require_1232541__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1232541__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1232541__(/*! ../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _StreamProcessor__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1232541__(/*! ./StreamProcessor */ "./src/streaming/StreamProcessor.js");
/* harmony import */ var _controllers_FragmentController__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1232541__(/*! ./controllers/FragmentController */ "./src/streaming/controllers/FragmentController.js");
/* harmony import */ var _thumbnail_ThumbnailController__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1232541__(/*! ./thumbnail/ThumbnailController */ "./src/streaming/thumbnail/ThumbnailController.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1232541__(/*! ../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1232541__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1232541__(/*! ../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1232541__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1232541__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1232541__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _utils_BoxParser__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1232541__(/*! ./utils/BoxParser */ "./src/streaming/utils/BoxParser.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1232541__(/*! ./utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _controllers_BlacklistController__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1232541__(/*! ./controllers/BlacklistController */ "./src/streaming/controllers/BlacklistController.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */














var MEDIA_TYPES = [_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MUXED, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE];

function Stream(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_12__["default"])(context).getInstance();
  var manifestModel = config.manifestModel;
  var mediaPlayerModel = config.mediaPlayerModel;
  var dashMetrics = config.dashMetrics;
  var manifestUpdater = config.manifestUpdater;
  var adapter = config.adapter;
  var timelineConverter = config.timelineConverter;
  var capabilities = config.capabilities;
  var errHandler = config.errHandler;
  var abrController = config.abrController;
  var playbackController = config.playbackController;
  var eventController = config.eventController;
  var mediaController = config.mediaController;
  var protectionController = config.protectionController;
  var textController = config.textController;
  var videoModel = config.videoModel;
  var streamInfo = config.streamInfo;
  var settings = config.settings;
  var instance, logger, streamProcessors, isInitialized, isActive, hasFinishedBuffering, hasVideoTrack, hasAudioTrack, updateError, isUpdating, fragmentController, thumbnailController, segmentBlacklistController, preloaded, boxParser, debug, isEndedEventSignaled, trackChangedEvents;
  /**
   * Setup the stream
   */

  function setup() {
    try {
      debug = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
      logger = debug.getLogger(instance);
      resetInitialSettings();
      boxParser = Object(_utils_BoxParser__WEBPACK_IMPORTED_MODULE_11__["default"])(context).getInstance();
      segmentBlacklistController = Object(_controllers_BlacklistController__WEBPACK_IMPORTED_MODULE_13__["default"])(context).create({
        updateEventName: _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SEGMENT_LOCATION_BLACKLIST_CHANGED,
        addBlacklistEventName: _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SEGMENT_LOCATION_BLACKLIST_ADD
      });
      fragmentController = Object(_controllers_FragmentController__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
        streamInfo: streamInfo,
        mediaPlayerModel: mediaPlayerModel,
        dashMetrics: dashMetrics,
        errHandler: errHandler,
        settings: settings,
        boxParser: boxParser,
        dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
        urlUtils: urlUtils
      });
    } catch (e) {
      throw e;
    }
  }
  /**
   * Initialize the events
   */


  function initialize() {
    registerEvents();
    registerProtectionEvents();
    textController.initializeForStream(streamInfo);
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_UPDATED, {
      streamInfo: streamInfo
    });
  }
  /**
   * Register the streaming events
   */


  function registerEvents() {
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFERING_COMPLETED, onBufferingCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].INBAND_EVENTS, onInbandEvents, instance);
  }
  /**
   * Unregister the streaming events
   */


  function unRegisterEvents() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFERING_COMPLETED, onBufferingCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].INBAND_EVENTS, onInbandEvents, instance);
  }
  /**
   * Register the protection events
   */


  function registerProtectionEvents() {
    if (protectionController) {
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_ERROR, onProtectionError, instance);
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SERVER_CERTIFICATE_UPDATED, onProtectionError, instance);
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].LICENSE_REQUEST_COMPLETE, onProtectionError, instance);
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_SYSTEM_SELECTED, onProtectionError, instance);
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_SESSION_CREATED, onProtectionError, instance);
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_STATUSES_CHANGED, onProtectionError, instance);
    }
  }
  /**
   * Unregister the protection events
   */


  function unRegisterProtectionEvents() {
    if (protectionController) {
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_ERROR, onProtectionError, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SERVER_CERTIFICATE_UPDATED, onProtectionError, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].LICENSE_REQUEST_COMPLETE, onProtectionError, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_SYSTEM_SELECTED, onProtectionError, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_SESSION_CREATED, onProtectionError, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].KEY_STATUSES_CHANGED, onProtectionError, instance);
    }
  }
  /**
   * Returns the stream id
   * @return {*|null}
   */


  function getStreamId() {
    return streamInfo ? streamInfo.id : null;
  }
  /**
   * Activates Stream by re-initializing some of its components
   * @param {MediaSource} mediaSource
   * @param {array} previousBufferSinks
   * @memberof Stream#
   */


  function activate(mediaSource, previousBufferSinks) {
    return new Promise(function (resolve, reject) {
      if (isActive) {
        resolve(previousBufferSinks);
        return;
      }

      if (getPreloaded()) {
        isActive = true;
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_ACTIVATED, {
          streamInfo: streamInfo
        });
        resolve(previousBufferSinks);
        return;
      }

      _initializeMedia(mediaSource, previousBufferSinks).then(function (bufferSinks) {
        isActive = true;
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_ACTIVATED, {
          streamInfo: streamInfo
        });
        resolve(bufferSinks);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   *
   * @param {object} mediaSource
   * @param {array} previousBufferSinks
   * @return {Promise<Array>}
   * @private
   */


  function _initializeMedia(mediaSource, previousBufferSinks) {
    return _commonMediaInitialization(mediaSource, previousBufferSinks);
  }

  function startPreloading(mediaSource, previousBuffers) {
    return new Promise(function (resolve, reject) {
      if (getPreloaded()) {
        reject();
        return;
      }

      logger.info("[startPreloading] Preloading next stream with id ".concat(getId()));
      setPreloaded(true);

      _commonMediaInitialization(mediaSource, previousBuffers).then(function () {
        for (var i = 0; i < streamProcessors.length && streamProcessors[i]; i++) {
          streamProcessors[i].setExplicitBufferingTime(getStartTime());
          streamProcessors[i].getScheduleController().startScheduleTimer();
        }

        resolve();
      })["catch"](function () {
        setPreloaded(false);
        reject();
      });
    });
  }
  /**
   *
   * @param {object} mediaSource
   * @param {array} previousBufferSinks
   * @return {Promise<array>}
   * @private
   */


  function _commonMediaInitialization(mediaSource, previousBufferSinks) {
    return new Promise(function (resolve, reject) {
      checkConfig();
      isUpdating = true;
      addInlineEvents();
      var element = videoModel.getElement();
      MEDIA_TYPES.forEach(function (mediaType) {
        if (mediaType !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || !element || element && /^VIDEO$/i.test(element.nodeName)) {
          _initializeMediaForType(mediaType, mediaSource);
        }
      });

      _createBufferSinks(previousBufferSinks).then(function (bufferSinks) {
        isUpdating = false;

        if (streamProcessors.length === 0) {
          var msg = 'No streams to play.';
          errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].MANIFEST_ERROR_ID_NOSTREAMS_CODE, msg, manifestModel.getValue()));
          logger.fatal(msg);
        } else {
          _checkIfInitializationCompleted();
        } // All mediaInfos for texttracks are added to the TextSourceBuffer by now. We can start creating the tracks


        textController.createTracks(streamInfo);
        resolve(bufferSinks);
      })["catch"](function (e) {
        reject(e);
      });
    });
  }
  /**
   * Initialize for a given media type. Creates a corresponding StreamProcessor
   * @param {string} type
   * @param {object} mediaSource
   * @private
   */


  function _initializeMediaForType(type, mediaSource) {
    var allMediaForType = adapter.getAllMediaInfoForType(streamInfo, type);
    var embeddedMediaInfos = [];
    var mediaInfo = null;
    var initialMediaInfo;

    if (!allMediaForType || allMediaForType.length === 0) {
      logger.info('No ' + type + ' data.');
      return;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
      hasVideoTrack = true;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO) {
      hasAudioTrack = true;
    }

    for (var i = 0, ln = allMediaForType.length; i < ln; i++) {
      mediaInfo = allMediaForType[i];

      if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && !!mediaInfo.isEmbedded) {
        textController.addEmbeddedTrack(streamInfo, mediaInfo);
        embeddedMediaInfos.push(mediaInfo);
      }

      if (_isMediaSupported(mediaInfo)) {
        mediaController.addTrack(mediaInfo);
      }
    }

    if (embeddedMediaInfos.length > 0) {
      mediaController.setInitialMediaSettingsForType(type, streamInfo);
      textController.setInitialSettings(mediaController.getInitialSettings(type));
      textController.addMediaInfosToBuffer(streamInfo, type, embeddedMediaInfos);
    } // Filter out embedded text track before creating StreamProcessor


    allMediaForType = allMediaForType.filter(function (mediaInfo) {
      return !mediaInfo.isEmbedded;
    });

    if (allMediaForType.length === 0) {
      return;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE) {
      thumbnailController = Object(_thumbnail_ThumbnailController__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
        streamInfo: streamInfo,
        adapter: adapter,
        baseURLController: config.baseURLController,
        timelineConverter: config.timelineConverter,
        debug: debug,
        eventBus: eventBus,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"],
        dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
        dashMetrics: config.dashMetrics,
        segmentBaseController: config.segmentBaseController
      });
      thumbnailController.initialize();
      return;
    }

    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_INITIALIZING, {
      streamInfo: streamInfo,
      mediaInfo: mediaInfo
    });
    mediaController.setInitialMediaSettingsForType(type, streamInfo);

    var streamProcessor = _createStreamProcessor(allMediaForType, mediaSource);

    initialMediaInfo = mediaController.getCurrentTrackFor(type, streamInfo.id);

    if (initialMediaInfo) {
      abrController.updateTopQualityIndex(initialMediaInfo); // In case of mixed fragmented and embedded text tracks, check if initial selected text track is not an embedded track

      streamProcessor.selectMediaInfo(type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || !initialMediaInfo.isEmbedded ? initialMediaInfo : allMediaForType[0]);
    }
  }

  function _isMediaSupported(mediaInfo) {
    var type = mediaInfo ? mediaInfo.type : null;
    var msg;

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MUXED) {
      msg = 'Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines';
      logger.fatal(msg);
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].MANIFEST_ERROR_ID_MULTIPLEXED_CODE, msg, manifestModel.getValue()));
      return false;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE) {
      return true;
    }

    if (!!mediaInfo.contentProtection && !capabilities.supportsEncryptedMedia()) {
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].CAPABILITY_MEDIAKEYS_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].CAPABILITY_MEDIAKEYS_ERROR_MESSAGE));
      return false;
    }

    return true;
  }
  /**
   * Creates the StreamProcessor for a given media type.
   * @param {object} initialMediaInfo
   * @param {array} allMediaForType
   * @param {object} mediaSource
   * @private
   */


  function _createStreamProcessor(allMediaForType, mediaSource) {
    var mediaInfo = allMediaForType && allMediaForType.length > 0 ? allMediaForType[0] : null;
    var fragmentModel = fragmentController.getModel(mediaInfo ? mediaInfo.type : null);
    var type = mediaInfo ? mediaInfo.type : null;
    var mimeType = mediaInfo ? mediaInfo.mimeType : null;
    var isFragmented = mediaInfo ? mediaInfo.isFragmented : null;
    var streamProcessor = Object(_StreamProcessor__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
      streamInfo: streamInfo,
      type: type,
      mimeType: mimeType,
      timelineConverter: timelineConverter,
      adapter: adapter,
      manifestModel: manifestModel,
      mediaPlayerModel: mediaPlayerModel,
      fragmentModel: fragmentModel,
      dashMetrics: config.dashMetrics,
      baseURLController: config.baseURLController,
      segmentBaseController: config.segmentBaseController,
      abrController: abrController,
      playbackController: playbackController,
      mediaController: mediaController,
      textController: textController,
      errHandler: errHandler,
      settings: settings,
      boxParser: boxParser,
      segmentBlacklistController: segmentBlacklistController
    });
    streamProcessor.initialize(mediaSource, hasVideoTrack, isFragmented);
    streamProcessors.push(streamProcessor);

    for (var i = 0; i < allMediaForType.length; i++) {
      streamProcessor.addMediaInfo(allMediaForType[i]);
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
      textController.addMediaInfosToBuffer(streamInfo, type, allMediaForType, fragmentModel);
    }

    return streamProcessor;
  }
  /**
   * Creates the SourceBufferSink objects for all StreamProcessors
   * @param {array} previousBuffersSinks
   * @return {Promise<object>}
   * @private
   */


  function _createBufferSinks(previousBuffersSinks) {
    return new Promise(function (resolve) {
      var buffers = {};
      var promises = streamProcessors.map(function (sp) {
        return sp.createBufferSinks(previousBuffersSinks);
      });
      Promise.all(promises).then(function (bufferSinks) {
        bufferSinks.forEach(function (sink) {
          if (sink) {
            buffers[sink.getType()] = sink;
          }
        });
        resolve(buffers);
      })["catch"](function () {
        resolve(buffers);
      });
    });
  }
  /**
   * Partially resets some of the Stream elements. This function is called when preloading of streams is canceled or a stream switch occurs.
   * @memberof Stream#
   * @param {boolean} keepBuffers
   */


  function deactivate(keepBuffers) {
    var ln = streamProcessors ? streamProcessors.length : 0;
    var errored = false;

    for (var i = 0; i < ln; i++) {
      var fragmentModel = streamProcessors[i].getFragmentModel();
      fragmentModel.abortRequests();
      fragmentModel.resetInitialSettings();
      streamProcessors[i].reset(errored, keepBuffers);
    }

    if (textController) {
      textController.deactivateStream(streamInfo);
    }

    streamProcessors = [];
    isActive = false;
    hasFinishedBuffering = false;
    setPreloaded(false);
    setIsEndedEventSignaled(false);
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_DEACTIVATED, {
      streamInfo: streamInfo
    });
  }

  function getIsActive() {
    return isActive;
  }

  function setMediaSource(mediaSource) {
    for (var i = 0; i < streamProcessors.length;) {
      if (_isMediaSupported(streamProcessors[i].getMediaInfo())) {
        streamProcessors[i].setMediaSource(mediaSource);
        i++;
      } else {
        streamProcessors[i].reset();
        streamProcessors.splice(i, 1);
      }
    }

    if (streamProcessors.length === 0) {
      var msg = 'No streams to play.';
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].MANIFEST_ERROR_ID_NOSTREAMS_CODE, msg + 'nostreams', manifestModel.getValue()));
      logger.fatal(msg);
    }
  }

  function resetInitialSettings(keepBuffers) {
    deactivate(keepBuffers);
    isInitialized = false;
    hasVideoTrack = false;
    hasAudioTrack = false;
    updateError = {};
    isUpdating = false;
    isEndedEventSignaled = false;
    trackChangedEvents = [];
  }

  function reset(keepBuffers) {
    if (fragmentController) {
      fragmentController.reset();
      fragmentController = null;
    }

    if (abrController && streamInfo) {
      abrController.clearDataForStream(streamInfo.id);
    }

    if (segmentBlacklistController) {
      segmentBlacklistController.reset();
      segmentBlacklistController = null;
    }

    resetInitialSettings(keepBuffers);
    streamInfo = null;
    unRegisterEvents();
    unRegisterProtectionEvents();
  }

  function getDuration() {
    return streamInfo ? streamInfo.duration : NaN;
  }

  function getIsEndedEventSignaled() {
    return isEndedEventSignaled;
  }

  function setIsEndedEventSignaled(value) {
    isEndedEventSignaled = value;
  }

  function getStartTime() {
    return streamInfo ? streamInfo.start : NaN;
  }

  function getId() {
    return streamInfo ? streamInfo.id : null;
  }

  function getStreamInfo() {
    return streamInfo;
  }

  function getHasAudioTrack() {
    return hasAudioTrack;
  }

  function getHasVideoTrack() {
    return hasVideoTrack;
  }

  function getThumbnailController() {
    return thumbnailController;
  }

  function checkConfig() {
    if (!videoModel || !abrController) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MISSING_CONFIG_ERROR);
    }
  }
  /**
   * @param {string} type
   * @returns {Array}
   * @memberof Stream#
   */


  function getBitrateListFor(type) {
    checkConfig();

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE) {
      if (!thumbnailController) {
        return [];
      }

      return thumbnailController.getBitrateList();
    }

    var mediaInfo = getMediaInfo(type);
    return abrController.getBitrateList(mediaInfo);
  }

  function onProtectionError(event) {
    if (event.error) {
      errHandler.error(event.error);
      logger.fatal(event.error.message);
    }
  }

  function prepareTrackChange(e) {
    if (!isActive || !streamInfo) {
      return;
    }

    hasFinishedBuffering = false;
    var mediaInfo = e.newMediaInfo;
    var manifest = manifestModel.getValue();
    adapter.setCurrentMediaInfo(streamInfo.id, mediaInfo.type, mediaInfo);
    var processor = getProcessorForMediaInfo(mediaInfo);
    if (!processor) return;
    var currentTime = playbackController.getTime();
    logger.info('Stream -  Process track changed at current time ' + currentTime); // Applies only for MSS streams

    if (manifest.refreshManifestOnSwitchTrack) {
      trackChangedEvents.push(e);

      if (!manifestUpdater.getIsUpdating()) {
        logger.debug('Stream -  Refreshing manifest for switch track');
        manifestUpdater.refreshManifest();
      }
    } else {
      processor.selectMediaInfo(mediaInfo).then(function () {
        if (mediaInfo.type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || mediaInfo.type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO) {
          abrController.updateTopQualityIndex(mediaInfo);
        }

        processor.prepareTrackSwitch();
      });
    }
  }

  function prepareQualityChange(e) {
    var processor = _getProcessorByType(e.mediaType);

    if (processor) {
      processor.prepareQualityChange(e);
    }
  }

  function addInlineEvents() {
    if (eventController) {
      var events = adapter.getEventsFor(streamInfo);
      eventController.addInlineEvents(events);
    }
  }

  function _checkIfInitializationCompleted() {
    var ln = streamProcessors.length;
    var hasError = !!updateError.audio || !!updateError.video;
    var error = hasError ? new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_10__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].DATA_UPDATE_FAILED_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"].DATA_UPDATE_FAILED_ERROR_MESSAGE) : null;

    for (var i = 0; i < ln; i++) {
      if (streamProcessors[i].isUpdating() || isUpdating) {
        return;
      }
    }

    if (protectionController) {
      // Need to check if streamProcessors exists because streamProcessors
      // could be cleared in case an error is detected while initializing DRM keysystem
      protectionController.clearMediaInfoArray();

      for (var _i = 0; _i < ln && streamProcessors[_i]; _i++) {
        var type = streamProcessors[_i].getType();

        var mediaInfo = streamProcessors[_i].getMediaInfo();

        if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && mediaInfo.isFragmented) {
          var _mediaInfo = streamProcessors[_i].getMediaInfo();

          if (_mediaInfo) {
            protectionController.initializeForMedia(_mediaInfo);
          }
        }
      }
    }

    if (error) {
      errHandler.error(error);
    } else if (!isInitialized) {
      isInitialized = true;
      videoModel.waitForReadyState(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function () {
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_INITIALIZED, {
          streamInfo: streamInfo
        });
      });
    }
  }

  function getMediaInfo(type) {
    var streamProcessor = null;

    for (var i = 0; i < streamProcessors.length; i++) {
      streamProcessor = streamProcessors[i];

      if (streamProcessor.getType() === type) {
        return streamProcessor.getMediaInfo();
      }
    }

    return null;
  }

  function onBufferingCompleted() {
    var processors = getProcessors();
    var ln = processors.length;

    if (ln === 0) {
      logger.warn('onBufferingCompleted - can\'t trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined');
      return;
    } // if there is at least one buffer controller that has not completed buffering yet do nothing


    for (var i = 0; i < ln; i++) {
      //if audio or video buffer is not buffering completed state, do not send STREAM_BUFFERING_COMPLETED
      if (!processors[i].isBufferingCompleted() && (processors[i].getType() === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO || processors[i].getType() === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO)) {
        logger.debug('onBufferingCompleted - One streamProcessor has finished but', processors[i].getType(), 'one is not buffering completed');
        return;
      }
    }

    logger.debug('onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED');
    hasFinishedBuffering = true;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_BUFFERING_COMPLETED, {
      streamInfo: streamInfo
    }, {
      streamInfo: streamInfo
    });
  }

  function onDataUpdateCompleted(e) {
    updateError[e.mediaType] = e.error;

    _checkIfInitializationCompleted();
  }

  function onInbandEvents(e) {
    if (eventController) {
      eventController.addInbandEvents(e.events);
    }
  }

  function getProcessorForMediaInfo(mediaInfo) {
    if (!mediaInfo || !mediaInfo.type) {
      return null;
    }

    return _getProcessorByType(mediaInfo.type);
  }

  function _getProcessorByType(type) {
    if (!type) {
      return null;
    }

    var processors = getProcessors();
    return processors.filter(function (processor) {
      return processor.getType() === type;
    })[0];
  }

  function getProcessors() {
    var arr = [];
    var type, streamProcessor;

    for (var i = 0; i < streamProcessors.length; i++) {
      streamProcessor = streamProcessors[i];
      type = streamProcessor.getType();

      if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
        arr.push(streamProcessor);
      }
    }

    return arr;
  }

  function startScheduleControllers() {
    var ln = streamProcessors.length;

    for (var i = 0; i < ln && streamProcessors[i]; i++) {
      streamProcessors[i].getScheduleController().startScheduleTimer();
    }
  }

  function updateData(updatedStreamInfo) {
    return new Promise(function (resolve) {
      isUpdating = true;
      streamInfo = updatedStreamInfo;

      if (eventController) {
        addInlineEvents();
      }

      var promises = [];

      for (var i = 0, ln = streamProcessors.length; i < ln; i++) {
        var streamProcessor = streamProcessors[i];
        var currentMediaInfo = streamProcessor.getMediaInfo();
        promises.push(streamProcessor.updateStreamInfo(streamInfo));
        var allMediaForType = adapter.getAllMediaInfoForType(streamInfo, streamProcessor.getType()); // Check if AdaptationSet has not been removed in MPD update

        if (allMediaForType) {
          // Remove the current mediaInfo objects before adding the updated ones
          streamProcessor.clearMediaInfoArray();

          for (var j = 0; j < allMediaForType.length; j++) {
            var mInfo = allMediaForType[j];
            streamProcessor.addMediaInfo(allMediaForType[j]);

            if (adapter.areMediaInfosEqual(currentMediaInfo, mInfo)) {
              abrController.updateTopQualityIndex(mInfo);
              promises.push(streamProcessor.selectMediaInfo(mInfo));
            }
          }
        }
      }

      Promise.all(promises).then(function () {
        promises = [];

        while (trackChangedEvents.length > 0) {
          var trackChangedEvent = trackChangedEvents.pop();
          var mediaInfo = trackChangedEvent.newMediaInfo;
          var processor = getProcessorForMediaInfo(trackChangedEvent.oldMediaInfo);
          if (!processor) return;
          promises.push(processor.prepareTrackSwitch());
          processor.selectMediaInfo(mediaInfo);
        }

        return Promise.all(promises);
      }).then(function () {
        isUpdating = false;

        _checkIfInitializationCompleted();

        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].STREAM_UPDATED, {
          streamInfo: streamInfo
        });
        resolve();
      });
    });
  }

  function isMediaCodecCompatible(newStream) {
    var previousStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return compareCodecs(newStream, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, previousStream) && compareCodecs(newStream, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO, previousStream);
  }

  function isProtectionCompatible(newStream) {
    if (!newStream) {
      return true;
    }

    return _compareProtectionConfig(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, newStream) && _compareProtectionConfig(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO, newStream);
  }

  function _compareProtectionConfig(type, newStream) {
    var currentStreamInfo = getStreamInfo();
    var newStreamInfo = newStream.getStreamInfo();

    if (!newStreamInfo || !currentStreamInfo) {
      return true;
    }

    var newAdaptation = adapter.getAdaptationForType(newStreamInfo.index, type, newStreamInfo);
    var currentAdaptation = adapter.getAdaptationForType(currentStreamInfo.index, type, currentStreamInfo);

    if (!newAdaptation || !currentAdaptation) {
      // If there is no adaptation for neither the old or the new stream they're compatible
      return !newAdaptation && !currentAdaptation;
    } // If the current period is unencrypted and the upcoming one is encrypted we need to reset sourcebuffers.


    return !(!_isAdaptationDrmProtected(currentAdaptation) && _isAdaptationDrmProtected(newAdaptation));
  }

  function _isAdaptationDrmProtected(adaptation) {
    if (!adaptation) {
      // If there is no adaptation for neither the old or the new stream they're compatible
      return false;
    } // If the current period is unencrypted and the upcoming one is encrypted we need to reset sourcebuffers.


    return !!(adaptation.ContentProtection || adaptation.Representation && adaptation.Representation.length > 0 && adaptation.Representation[0].ContentProtection);
  }

  function compareCodecs(newStream, type) {
    var previousStream = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!newStream || !newStream.hasOwnProperty('getStreamInfo')) {
      return false;
    }

    var newStreamInfo = newStream.getStreamInfo();
    var currentStreamInfo = previousStream ? previousStream.getStreamInfo() : getStreamInfo();

    if (!newStreamInfo || !currentStreamInfo) {
      return false;
    }

    var newAdaptation = adapter.getAdaptationForType(newStreamInfo.index, type, newStreamInfo);
    var currentAdaptation = adapter.getAdaptationForType(currentStreamInfo.index, type, currentStreamInfo);

    if (!newAdaptation || !currentAdaptation) {
      // If there is no adaptation for neither the old or the new stream they're compatible
      return !newAdaptation && !currentAdaptation;
    }

    var sameMimeType = newAdaptation && currentAdaptation && newAdaptation.mimeType === currentAdaptation.mimeType;
    var oldCodecs = currentAdaptation.Representation_asArray.map(function (representation) {
      return representation.codecs;
    });
    var newCodecs = newAdaptation.Representation_asArray.map(function (representation) {
      return representation.codecs;
    });
    var codecMatch = newCodecs.some(function (newCodec) {
      return oldCodecs.indexOf(newCodec) > -1;
    });
    var partialCodecMatch = newCodecs.some(function (newCodec) {
      return oldCodecs.some(function (oldCodec) {
        return capabilities.codecRootCompatibleWithCodec(oldCodec, newCodec);
      });
    });
    return codecMatch || partialCodecMatch && sameMimeType;
  }

  function setPreloaded(value) {
    preloaded = value;
  }

  function getPreloaded() {
    return preloaded;
  }

  function getHasFinishedBuffering() {
    return hasFinishedBuffering;
  }

  function getAdapter() {
    return adapter;
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    activate: activate,
    deactivate: deactivate,
    getIsActive: getIsActive,
    getDuration: getDuration,
    getStartTime: getStartTime,
    getId: getId,
    getStreamInfo: getStreamInfo,
    getHasAudioTrack: getHasAudioTrack,
    getHasVideoTrack: getHasVideoTrack,
    startPreloading: startPreloading,
    getThumbnailController: getThumbnailController,
    getBitrateListFor: getBitrateListFor,
    updateData: updateData,
    reset: reset,
    getProcessors: getProcessors,
    setMediaSource: setMediaSource,
    isMediaCodecCompatible: isMediaCodecCompatible,
    isProtectionCompatible: isProtectionCompatible,
    getPreloaded: getPreloaded,
    getIsEndedEventSignaled: getIsEndedEventSignaled,
    setIsEndedEventSignaled: setIsEndedEventSignaled,
    getAdapter: getAdapter,
    getHasFinishedBuffering: getHasFinishedBuffering,
    setPreloaded: setPreloaded,
    startScheduleControllers: startScheduleControllers,
    prepareTrackChange: prepareTrackChange,
    prepareQualityChange: prepareQualityChange
  };
  setup();
  return instance;
}

Stream.__dashjs_factory_name = 'Stream';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_9__["default"].getClassFactory(Stream));

/***/ }),

/***/ "./src/streaming/StreamProcessor.js":
/*!******************************************!*\
  !*** ./src/streaming/StreamProcessor.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1272274__) {

"use strict";
__nested_webpack_require_1272274__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1272274__(/*! ./constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1272274__(/*! ../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1272274__(/*! ./constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _models_FragmentModel__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1272274__(/*! ./models/FragmentModel */ "./src/streaming/models/FragmentModel.js");
/* harmony import */ var _controllers_BufferController__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1272274__(/*! ./controllers/BufferController */ "./src/streaming/controllers/BufferController.js");
/* harmony import */ var _text_NotFragmentedTextBufferController__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1272274__(/*! ./text/NotFragmentedTextBufferController */ "./src/streaming/text/NotFragmentedTextBufferController.js");
/* harmony import */ var _controllers_ScheduleController__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1272274__(/*! ./controllers/ScheduleController */ "./src/streaming/controllers/ScheduleController.js");
/* harmony import */ var _dash_controllers_RepresentationController__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1272274__(/*! ../dash/controllers/RepresentationController */ "./src/dash/controllers/RepresentationController.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1272274__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1272274__(/*! ./utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1272274__(/*! ../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1272274__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _dash_DashHandler__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1272274__(/*! ../dash/DashHandler */ "./src/dash/DashHandler.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1272274__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_1272274__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_15__ = __nested_webpack_require_1272274__(/*! ../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _utils_RequestModifier__WEBPACK_IMPORTED_MODULE_16__ = __nested_webpack_require_1272274__(/*! ./utils/RequestModifier */ "./src/streaming/utils/RequestModifier.js");
/* harmony import */ var _streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_17__ = __nested_webpack_require_1272274__(/*! ../streaming/utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _utils_BoxParser__WEBPACK_IMPORTED_MODULE_18__ = __nested_webpack_require_1272274__(/*! ./utils/BoxParser */ "./src/streaming/utils/BoxParser.js");
/* harmony import */ var _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_19__ = __nested_webpack_require_1272274__(/*! ./vo/metrics/PlayList */ "./src/streaming/vo/metrics/PlayList.js");
/* harmony import */ var _dash_controllers_SegmentsController__WEBPACK_IMPORTED_MODULE_20__ = __nested_webpack_require_1272274__(/*! ../dash/controllers/SegmentsController */ "./src/dash/controllers/SegmentsController.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_21__ = __nested_webpack_require_1272274__(/*! ./vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */























function StreamProcessor(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_10__["default"])(context).getInstance();
  var streamInfo = config.streamInfo;
  var type = config.type;
  var errHandler = config.errHandler;
  var mimeType = config.mimeType;
  var timelineConverter = config.timelineConverter;
  var adapter = config.adapter;
  var manifestModel = config.manifestModel;
  var mediaPlayerModel = config.mediaPlayerModel;
  var fragmentModel = config.fragmentModel;
  var abrController = config.abrController;
  var playbackController = config.playbackController;
  var mediaController = config.mediaController;
  var textController = config.textController;
  var dashMetrics = config.dashMetrics;
  var settings = config.settings;
  var boxParser = config.boxParser;
  var segmentBlacklistController = config.segmentBlacklistController;
  var instance, logger, isDynamic, mediaInfo, mediaInfoArr, bufferController, scheduleController, representationController, shouldUseExplicitTimeForRequest, qualityChangeInProgress, dashHandler, segmentsController, bufferingTime;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_15__["default"])(context).getInstance().getLogger(instance);
    resetInitialSettings();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].DATA_UPDATE_COMPLETED, _onDataUpdateCompleted, instance, {
      priority: _core_EventBus__WEBPACK_IMPORTED_MODULE_10__["default"].EVENT_PRIORITY_HIGH
    }); // High priority to be notified before Stream

    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].INIT_FRAGMENT_NEEDED, _onInitFragmentNeeded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].MEDIA_FRAGMENT_NEEDED, _onMediaFragmentNeeded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_CLEARED, _onBufferCleared, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SEEK_TARGET, _onSeekTarget, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].FRAGMENT_LOADING_ABANDONED, _onFragmentLoadingAbandoned, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].FRAGMENT_LOADING_COMPLETED, _onFragmentLoadingCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].QUOTA_EXCEEDED, _onQuotaExceeded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SET_FRAGMENTED_TEXT_AFTER_DISABLED, _onSetFragmentedTextAfterDisabled, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SET_NON_FRAGMENTED_TEXT, _onSetNonFragmentedText, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SOURCE_BUFFER_ERROR, _onSourceBufferError, instance);
  }

  function initialize(mediaSource, hasVideoTrack, isFragmented) {
    segmentsController = Object(_dash_controllers_SegmentsController__WEBPACK_IMPORTED_MODULE_20__["default"])(context).create({
      events: _core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"],
      eventBus: eventBus,
      streamInfo: streamInfo,
      timelineConverter: timelineConverter,
      dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
      segmentBaseController: config.segmentBaseController,
      type: type
    });
    dashHandler = Object(_dash_DashHandler__WEBPACK_IMPORTED_MODULE_12__["default"])(context).create({
      streamInfo: streamInfo,
      type: type,
      timelineConverter: timelineConverter,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      baseURLController: config.baseURLController,
      errHandler: errHandler,
      segmentsController: segmentsController,
      settings: settings,
      boxParser: boxParser,
      events: _core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"],
      eventBus: eventBus,
      errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"],
      debug: Object(_core_Debug__WEBPACK_IMPORTED_MODULE_15__["default"])(context).getInstance(),
      requestModifier: Object(_utils_RequestModifier__WEBPACK_IMPORTED_MODULE_16__["default"])(context).getInstance(),
      dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
      constants: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"],
      urlUtils: Object(_streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_17__["default"])(context).getInstance()
    });
    isDynamic = streamInfo.manifestInfo.isDynamic; // Create/initialize controllers

    dashHandler.initialize(isDynamic);
    abrController.registerStreamType(type, instance);
    representationController = Object(_dash_controllers_RepresentationController__WEBPACK_IMPORTED_MODULE_7__["default"])(context).create({
      streamInfo: streamInfo,
      type: type,
      abrController: abrController,
      dashMetrics: dashMetrics,
      playbackController: playbackController,
      timelineConverter: timelineConverter,
      dashConstants: _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"],
      events: _core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"],
      eventBus: eventBus,
      errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"],
      isDynamic: isDynamic,
      segmentsController: segmentsController
    });
    bufferController = _createBufferControllerForType(type, isFragmented);

    if (bufferController) {
      bufferController.initialize(mediaSource);
    }

    scheduleController = Object(_controllers_ScheduleController__WEBPACK_IMPORTED_MODULE_6__["default"])(context).create({
      streamInfo: streamInfo,
      type: type,
      mimeType: mimeType,
      adapter: adapter,
      dashMetrics: dashMetrics,
      mediaPlayerModel: mediaPlayerModel,
      fragmentModel: fragmentModel,
      abrController: abrController,
      playbackController: playbackController,
      textController: textController,
      mediaController: mediaController,
      bufferController: bufferController,
      settings: settings
    });
    scheduleController.initialize(hasVideoTrack);
    bufferingTime = 0;
    shouldUseExplicitTimeForRequest = false;
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getType() {
    return type;
  }

  function getIsTextTrack() {
    return adapter.getIsTextTrack(representationController.getData());
  }

  function resetInitialSettings() {
    mediaInfoArr = [];
    mediaInfo = null;
    bufferingTime = 0;
    shouldUseExplicitTimeForRequest = false;
    qualityChangeInProgress = false;
  }

  function reset(errored, keepBuffers) {
    if (dashHandler) {
      dashHandler.reset();
    }

    if (bufferController) {
      bufferController.reset(errored, keepBuffers);
      bufferController = null;
    }

    if (scheduleController) {
      scheduleController.reset();
      scheduleController = null;
    }

    if (representationController) {
      representationController.reset();
      representationController = null;
    }

    if (segmentsController) {
      segmentsController = null;
    }

    if (abrController) {
      abrController.unRegisterStreamType(getStreamId(), type);
    }

    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].DATA_UPDATE_COMPLETED, _onDataUpdateCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].INIT_FRAGMENT_NEEDED, _onInitFragmentNeeded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].MEDIA_FRAGMENT_NEEDED, _onMediaFragmentNeeded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_CLEARED, _onBufferCleared, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SEEK_TARGET, _onSeekTarget, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].FRAGMENT_LOADING_ABANDONED, _onFragmentLoadingAbandoned, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].FRAGMENT_LOADING_COMPLETED, _onFragmentLoadingCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SET_FRAGMENTED_TEXT_AFTER_DISABLED, _onSetFragmentedTextAfterDisabled, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SET_NON_FRAGMENTED_TEXT, _onSetNonFragmentedText, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].QUOTA_EXCEEDED, _onQuotaExceeded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].SOURCE_BUFFER_ERROR, _onSourceBufferError, instance);
    resetInitialSettings();
    type = null;
    streamInfo = null;
  }

  function isUpdating() {
    return representationController ? representationController.isUpdating() : false;
  }
  /**
   * When a seek within the corresponding period occurs this function initiates the clearing of the buffer and sets the correct buffering time.
   * @param {object} e
   * @private
   */


  function prepareInnerPeriodPlaybackSeeking(e) {
    return new Promise(function (resolve) {
      // Stop segment requests until we have figured out for which time we need to request a segment. We don't want to replace existing segments.
      scheduleController.clearScheduleTimer();
      fragmentModel.abortRequests(); // Abort operations to the SourceBuffer Sink and reset the BufferControllers isBufferingCompleted state.

      bufferController.prepareForPlaybackSeek().then(function () {
        // Clear the buffer. We need to prune everything which is not in the target interval.
        var clearRanges = bufferController.getAllRangesWithSafetyFactor(e.seekTime); // When everything has been pruned go on

        return bufferController.clearBuffers(clearRanges);
      }).then(function () {
        // Figure out the correct segment request time.
        var continuousBufferTime = bufferController.getContinuousBufferTimeForTargetTime(e.seekTime); // If the buffer is continuous and exceeds the duration of the period we are still done buffering. We need to trigger the buffering completed event in order to start prebuffering upcoming periods again

        if (!isNaN(continuousBufferTime) && !isNaN(streamInfo.duration) && isFinite(streamInfo.duration) && continuousBufferTime >= streamInfo.start + streamInfo.duration) {
          bufferController.setIsBufferingCompleted(true);
          resolve();
        } else {
          var targetTime = isNaN(continuousBufferTime) ? e.seekTime : continuousBufferTime;
          setExplicitBufferingTime(targetTime);
          bufferController.setSeekTarget(targetTime);
          var promises = []; // append window has been reset by abort() operation. Set the correct values again

          promises.push(bufferController.updateAppendWindow()); // Timestamp offset couldve been changed by preloading period

          var representationInfo = getRepresentationInfo();
          promises.push(bufferController.updateBufferTimestampOffset(representationInfo));
          Promise.all(promises).then(function () {
            // We might have aborted the append operation of an init segment. Append init segment again.
            scheduleController.setInitSegmentRequired(true); // Right after a seek we should not immediately check the playback quality

            scheduleController.setCheckPlaybackQuality(false);
            scheduleController.startScheduleTimer();
            resolve();
          });
        }
      })["catch"](function (e) {
        logger.error(e);
      });
    });
  }
  /**
   * Seek outside of the current period.
   * @return {Promise<unknown>}
   */


  function prepareOuterPeriodPlaybackSeeking() {
    return new Promise(function (resolve, reject) {
      try {
        // Stop scheduling
        scheduleController.clearScheduleTimer(); // Abort all ongoing requests

        fragmentModel.abortRequests(); // buffering not complete anymore and abort current append operation to SourceBuffer

        bufferController.prepareForPlaybackSeek().then(function () {
          // Clear the buffers completely.
          return bufferController.pruneAllSafely();
        }).then(function () {
          resolve();
        });
      } catch (e) {
        reject(e);
      }
    });
  }
  /**
   * ScheduleController indicates that an init segment needs to be fetched.
   * @param {object} e
   * @param {boolean} rescheduleIfNoRequest - Defines whether we reschedule in case no valid request could be generated
   * @private
   */


  function _onInitFragmentNeeded(e) {
    var rescheduleIfNoRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // Event propagation may have been stopped (see MssHandler)
    if (!e.sender) return;

    if (playbackController.getIsManifestUpdateInProgress()) {
      _noValidRequest();

      return;
    }

    if (getIsTextTrack() && !textController.isTextEnabled()) return;

    if (bufferController && e.representationId) {
      if (!bufferController.appendInitSegmentFromCache(e.representationId)) {
        var rep = representationController.getCurrentRepresentation(); // Dummy init segment (fragmented tracks without initialization segment)

        if (rep.range === 0) {
          _onMediaFragmentNeeded();

          return;
        } // Init segment not in cache, send new request


        var request = dashHandler ? dashHandler.getInitRequest(mediaInfo, rep) : null;

        if (request) {
          fragmentModel.executeRequest(request);
        } else if (rescheduleIfNoRequest) {
          scheduleController.setInitSegmentRequired(true);

          _noValidRequest();
        }
      }
    }
  }
  /**
   * ScheduleController indicates that a media segment is needed
   * @param {boolean} rescheduleIfNoRequest -  Defines whether we reschedule in case no valid request could be generated
   * @private
   */


  function _onMediaFragmentNeeded(e) {
    var rescheduleIfNoRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    // Don't schedule next fragments while updating manifest or pruning to avoid buffer inconsistencies
    if (playbackController.getIsManifestUpdateInProgress() || bufferController.getIsPruningInProgress()) {
      _noValidRequest();

      return;
    }

    var request = _getFragmentRequest();

    if (request) {
      shouldUseExplicitTimeForRequest = false;

      _mediaRequestGenerated(request);
    } else {
      _noMediaRequestGenerated(rescheduleIfNoRequest);
    }
  }
  /**
   * If we generated a valid media request we can execute the request. In some cases the segment might be blacklisted.
   * @param {object} request
   * @private
   */


  function _mediaRequestGenerated(request) {
    if (!isNaN(request.startTime + request.duration)) {
      bufferingTime = request.startTime + request.duration;
    }

    request.delayLoadingTime = new Date().getTime() + scheduleController.getTimeToLoadDelay();
    scheduleController.setTimeToLoadDelay(0);

    if (!_shouldIgnoreRequest(request)) {
      logger.debug("Next fragment request url for stream id ".concat(streamInfo.id, " and media type ").concat(type, " is ").concat(request.url));
      fragmentModel.executeRequest(request);
    } else {
      logger.warn("Fragment request url ".concat(request.url, " for stream id ").concat(streamInfo.id, " and media type ").concat(type, " is on the ignore list and will be skipped"));

      _noValidRequest();
    }
  }
  /**
   * We could not generate a valid request. Check if the media is finished, we are stuck in a gap or simply need to wait for the next segment to be available.
   * @param {boolean} rescheduleIfNoRequest
   * @private
   */


  function _noMediaRequestGenerated(rescheduleIfNoRequest) {
    var representation = representationController.getCurrentRepresentation(); // If  this statement is true we might be stuck. A static manifest does not change and we did not find a valid request for the target time
    // There is no point in trying again. We need to adjust the time in order to find a valid request. This can happen if the user/app seeked into a gap.
    // For dynamic manifests this can also happen especially if we jump over the gap in the previous period and are using SegmentTimeline and in case there is a positive eptDelta at the beginning of the period we are stuck.

    if (settings.get().streaming.gaps.enableSeekFix && (shouldUseExplicitTimeForRequest || playbackController.getTime() === 0)) {
      var adjustedTime;

      if (!isDynamic) {
        adjustedTime = dashHandler.getValidTimeAheadOfTargetTime(bufferingTime, mediaInfo, representation, settings.get().streaming.gaps.threshold);
      } else if (isDynamic && representation.segmentInfoType === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE) {
        // If we find a valid request ahead of the current time then we are in a gap. Segments are only added at the end of the timeline
        adjustedTime = dashHandler.getValidTimeAheadOfTargetTime(bufferingTime, mediaInfo, representation, settings.get().streaming.gaps.threshold);
      }

      if (!isNaN(adjustedTime) && adjustedTime !== bufferingTime) {
        if (playbackController.isSeeking() || playbackController.getTime() === 0) {
          // If we are seeking then playback is stalled. Do a seek to get out of this situation
          logger.warn("Adjusting playback time ".concat(adjustedTime, " because of gap in the manifest. Seeking by ").concat(adjustedTime - bufferingTime));
          playbackController.seek(adjustedTime, false, false);
        } else {
          // If we are not seeking we should still be playing but we cant find anything to buffer. So we adjust the buffering time and leave the gap jump to the GapController
          logger.warn("Adjusting buffering time ".concat(adjustedTime, " because of gap in the manifest. Adjusting time by ").concat(adjustedTime - bufferingTime));
          setExplicitBufferingTime(adjustedTime);

          if (rescheduleIfNoRequest) {
            _noValidRequest();
          }
        }

        return;
      }
    } // Check if the media is finished. If so, no need to schedule another request


    var isLastSegmentRequested = dashHandler.isLastSegmentRequested(representation, bufferingTime);

    if (isLastSegmentRequested) {
      var segmentIndex = dashHandler.getCurrentIndex();
      logger.debug("Segment requesting for stream ".concat(streamInfo.id, " has finished"));
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].STREAM_REQUESTING_COMPLETED, {
        segmentIndex: segmentIndex
      }, {
        streamId: streamInfo.id,
        mediaType: type
      });
      bufferController.segmentRequestingCompleted(segmentIndex);
      scheduleController.clearScheduleTimer();
      return;
    }

    if (rescheduleIfNoRequest) {
      _noValidRequest();
    }
  }
  /**
   * In certain situations we need to ignore a request. For instance, if a segment is blacklisted because it caused an MSE error.
   * @private
   */


  function _shouldIgnoreRequest(request) {
    var blacklistUrl = request.url;

    if (request.range) {
      blacklistUrl = blacklistUrl.concat('_', request.range);
    }

    return segmentBlacklistController.contains(blacklistUrl);
  }
  /**
   * Get the init or media segment request using the DashHandler.
   * @return {null|FragmentRequest|null}
   * @private
   */


  function _getFragmentRequest() {
    var representationInfo = getRepresentationInfo();
    var request;

    if (isNaN(bufferingTime) || getType() === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && !textController.isTextEnabled()) {
      return null;
    } // Use time just whenever is strictly needed


    var useTime = shouldUseExplicitTimeForRequest;

    if (dashHandler) {
      var representation = representationController && representationInfo ? representationController.getRepresentationForQuality(representationInfo.quality) : null;

      if (useTime) {
        request = dashHandler.getSegmentRequestForTime(mediaInfo, representation, bufferingTime);
      } else {
        request = dashHandler.getNextSegmentRequest(mediaInfo, representation);
      }
    }

    return request;
  }
  /**
   * Whenever we can not generate a valid request we restart scheduling according to the timeouts defined in the settings.
   * @private
   */


  function _noValidRequest() {
    scheduleController.startScheduleTimer(playbackController.getLowLatencyModeEnabled() ? settings.get().streaming.scheduling.lowLatencyTimeout : settings.get().streaming.scheduling.defaultTimeout);
  }

  function _onDataUpdateCompleted(e) {
    if (!e.error) {
      // Update representation if no error
      scheduleController.setCurrentRepresentation(adapter.convertRepresentationToRepresentationInfo(e.currentRepresentation));

      if (!bufferController.getIsBufferingCompleted()) {
        bufferController.updateBufferTimestampOffset(e.currentRepresentation);
      }
    }
  }

  function _onBufferLevelStateChanged(e) {
    dashMetrics.addBufferState(type, e.state, scheduleController.getBufferTarget());

    if (e.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].BUFFER_EMPTY && !playbackController.isSeeking()) {
      logger.info('Buffer is empty! Stalling!');
      dashMetrics.pushPlayListTraceMetrics(new Date(), _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_19__["PlayListTrace"].REBUFFERING_REASON);
    }
  }

  function _onBufferCleared(e) {
    // Remove executed requests not buffered anymore
    fragmentModel.syncExecutedRequestsWithBufferedRange(bufferController.getBuffer().getAllBufferRanges(), streamInfo.duration); // If buffer removed ahead current time (QuotaExceededError or automatic buffer pruning) then adjust current index handler time

    if (e.quotaExceeded && e.from > playbackController.getTime()) {
      setExplicitBufferingTime(e.from);
    } // (Re)start schedule once buffer has been pruned after a QuotaExceededError


    if (e.hasEnoughSpaceToAppend && e.quotaExceeded) {
      scheduleController.startScheduleTimer();
    }
  }
  /**
   * This function is called when the corresponding SourceBuffer encountered an error.
   * We blacklist the last segment assuming it caused the error
   * @param {object} e
   * @private
   */


  function _onSourceBufferError(e) {
    if (!e || !e.lastRequestAppended || !e.lastRequestAppended.url) {
      return;
    }

    var blacklistUrl = e.lastRequestAppended.url;

    if (e.lastRequestAppended.range) {
      blacklistUrl = blacklistUrl.concat('_', e.lastRequestAppended.range);
    }

    logger.warn("Blacklisting segment with url ".concat(blacklistUrl));
    segmentBlacklistController.add(blacklistUrl);
  }
  /**
   * The quality has changed which means we have switched to a different representation.
   * If we want to aggressively replace existing parts in the buffer we need to make sure that the new quality is higher than the already buffered one.
   * @param {object} e
   * @private
   */


  function prepareQualityChange(e) {
    logger.debug("Preparing quality switch for type ".concat(type));
    var newQuality = e.newQuality;
    qualityChangeInProgress = true; // Stop scheduling until we are done with preparing the quality switch

    scheduleController.clearScheduleTimer();
    var representationInfo = getRepresentationInfo(newQuality);
    scheduleController.setCurrentRepresentation(representationInfo);
    representationController.prepareQualityChange(newQuality); // Abort the current request to avoid inconsistencies and in case a rule such as AbandonRequestRule has forced a quality switch. A quality switch can also be triggered manually by the application.
    // If we update the buffer values now, or initialize a request to the new init segment, the currently downloading media segment might "work" with wrong values.
    // Everything that is already in the buffer queue is ok and will be handled by the corresponding function below depending on the switch mode.

    fragmentModel.abortRequests(); // In any case we need to update the MSE.timeOffset

    bufferController.updateBufferTimestampOffset(representationInfo).then(function () {
      // If the switch should occur immediately we need to replace existing stuff in the buffer
      if (e.reason && e.reason.forceReplace) {
        _prepareReplacementQualitySwitch();
      } // If fast switch is enabled we check if we are supposed to replace existing stuff in the buffer
      else if (settings.get().streaming.buffer.fastSwitchEnabled) {
          _prepareForFastQualitySwitch(representationInfo);
        } // Default quality switch. We append the new quality to the already buffered stuff
        else {
            _prepareForDefaultQualitySwitch();
          }

      dashMetrics.pushPlayListTraceMetrics(new Date(), _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_19__["PlayListTrace"].REPRESENTATION_SWITCH_STOP_REASON);
      dashMetrics.createPlaylistTraceMetrics(representationInfo.id, playbackController.getTime() * 1000, playbackController.getPlaybackRate());
    });
  }

  function _prepareReplacementQualitySwitch() {
    // Inform other classes like the GapController that we are replacing existing stuff
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_REPLACEMENT_STARTED, {
      mediaType: type,
      streamId: streamInfo.id
    }, {
      mediaType: type,
      streamId: streamInfo.id
    }); // Abort appending segments to the buffer. Also adjust the appendWindow as we might have been in the progress of prebuffering stuff.

    bufferController.prepareForReplacementQualitySwitch().then(function () {
      _bufferClearedForReplacement();

      qualityChangeInProgress = false;
    })["catch"](function () {
      _bufferClearedForReplacement();

      qualityChangeInProgress = false;
    });
  }

  function _prepareForFastQualitySwitch(representationInfo) {
    // if we switch up in quality and need to replace existing parts in the buffer we need to adjust the buffer target
    var time = playbackController.getTime();
    var safeBufferLevel = 1.5;
    var request = fragmentModel.getRequests({
      state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_3__["default"].FRAGMENT_MODEL_EXECUTED,
      time: time + safeBufferLevel,
      threshold: 0
    })[0];

    if (request && !getIsTextTrack()) {
      var bufferLevel = bufferController.getBufferLevel();
      var abandonmentState = abrController.getAbandonmentStateFor(streamInfo.id, type); // The quality we originally requested was lower than the new quality

      if (request.quality < representationInfo.quality && bufferLevel >= safeBufferLevel && abandonmentState !== _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].ABANDON_LOAD) {
        var targetTime = time + safeBufferLevel;
        setExplicitBufferingTime(targetTime);
        scheduleController.setCheckPlaybackQuality(false);
        scheduleController.startScheduleTimer();
      } else {
        _prepareForDefaultQualitySwitch();
      }
    } else {
      scheduleController.startScheduleTimer();
    }

    qualityChangeInProgress = false;
  }

  function _prepareForDefaultQualitySwitch() {
    // We might have aborted the current request. We need to set an explicit buffer time based on what we already have in the buffer.
    _bufferClearedForNonReplacement();

    qualityChangeInProgress = false;
  }
  /**
   * We have canceled the download of a fragment and need to adjust the buffer time or reload an init segment
   * @param {object} e
   */


  function _onFragmentLoadingAbandoned(e) {
    logger.info('onFragmentLoadingAbandoned request: ' + e.request.url + ' has been aborted'); // we only need to handle this if we are not seeking, not switching the tracks and not switching the quality

    if (!playbackController.isSeeking() && !scheduleController.getSwitchStrack() && !qualityChangeInProgress) {
      logger.info('onFragmentLoadingAbandoned request: ' + e.request.url + ' has to be downloaded again, origin is not seeking process or switch track call'); // in case of an init segment we force the download of an init segment

      if (e.request && e.request.isInitializationRequest()) {
        scheduleController.setInitSegmentRequired(true);
      } // in case of a media segment we reset the buffering time
      else {
          setExplicitBufferingTime(e.request.startTime + e.request.duration / 2);
        } // In case of a seek the schedule controller was stopped and will be started once the buffer has been pruned.


      scheduleController.startScheduleTimer(0);
    }
  }
  /**
   * When a fragment has been loaded we need to start the schedule timer again in case of an error.
   * @param {object} e
   */


  function _onFragmentLoadingCompleted(e) {
    logger.info('OnFragmentLoadingCompleted for stream id ' + streamInfo.id + ' and media type ' + type + ' - Url:', e.request ? e.request.url : 'undefined', e.request.range ? ', Range:' + e.request.range : '');

    if (getIsTextTrack()) {
      scheduleController.startScheduleTimer(0);
    }

    if (e.error && e.request.serviceLocation) {
      _handleFragmentLoadingError(e);
    }
  }
  /**
   * If we encountered an error when loading the fragment we need to handle it according to the segment type
   * @private
   */


  function _handleFragmentLoadingError(e) {
    logger.info("Fragment loading completed with an error");

    if (!e || !e.request || !e.request.type) {
      return;
    } // In case there are baseUrls that can still be tried a valid request can be generated. If no valid request can be generated we ran out of baseUrls.
    // Consequently, we need to signal that we dont want to retry in case no valid request could be generated otherwise we keep trying with the same url infinitely.
    // Init segment could not be loaded. If we have multiple baseUrls we still have a chance to get a valid segment.


    if (e.request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_21__["HTTPRequest"].INIT_SEGMENT_TYPE) {
      _onInitFragmentNeeded({
        representationId: e.request.representationId,
        sender: {}
      }, false);
    } // Media segment could not be loaded
    else if (e.request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_21__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
        setExplicitBufferingTime(e.request.startTime + e.request.duration / 2);

        _onMediaFragmentNeeded({}, false);
      }
  }
  /**
   * Callback function triggered by the TextController whenever a track is changed for fragmented text. Will only be triggered if textracks have previously been disabled.
   * @private
   */


  function _onSetFragmentedTextAfterDisabled() {
    setExplicitBufferingTime(playbackController.getTime());
    getScheduleController().startScheduleTimer();
  }
  /**
   * Callback function triggered by the TextController whenever a track is changed for non fragmented text
   * @param {object} e
   * @private
   */


  function _onSetNonFragmentedText(e) {
    var currentTrackInfo = e.currentTrackInfo;

    if (!currentTrackInfo) {
      return;
    }

    var mInfo = mediaInfoArr.find(function (info) {
      return info.index === currentTrackInfo.index && info.lang === currentTrackInfo.lang;
    });

    if (mInfo) {
      selectMediaInfo(mInfo).then(function () {
        bufferController.setIsBufferingCompleted(false);
        setExplicitBufferingTime(playbackController.getTime());
        scheduleController.setInitSegmentRequired(true);
        scheduleController.startScheduleTimer();
      });
    }
  }

  function _onQuotaExceeded(e) {
    // Stop scheduler (will be restarted once buffer is pruned)
    setExplicitBufferingTime(e.quotaExceededTime);
    scheduleController.clearScheduleTimer();
  }

  function getRepresentationController() {
    return representationController;
  }

  function getBuffer() {
    return bufferController ? bufferController.getBuffer() : null;
  }

  function getBufferController() {
    return bufferController;
  }

  function getFragmentModel() {
    return fragmentModel;
  }

  function updateStreamInfo(newStreamInfo) {
    streamInfo = newStreamInfo;

    if (!isBufferingCompleted()) {
      return bufferController.updateAppendWindow();
    }

    return Promise.resolve();
  }

  function getStreamInfo() {
    return streamInfo;
  }
  /**
   * Called once the StreamProcessor is initialized and when the track is switched. We only have one StreamProcessor per media type. So we need to adjust the mediaInfo once we switch/select a track.
   * @param {object} newMediaInfo
   */


  function selectMediaInfo(newMediaInfo) {
    if (newMediaInfo !== mediaInfo && (!newMediaInfo || !mediaInfo || newMediaInfo.type === mediaInfo.type)) {
      mediaInfo = newMediaInfo;
    }

    var newRealAdaptation = adapter.getRealAdaptation(streamInfo, mediaInfo);
    var voRepresentations = adapter.getVoRepresentations(mediaInfo);

    if (representationController) {
      var realAdaptation = representationController.getData();
      var maxQuality = abrController.getMaxAllowedIndexFor(type, streamInfo.id);
      var minIdx = abrController.getMinAllowedIndexFor(type, streamInfo.id);
      var quality, averageThroughput;
      var bitrate = null;

      if ((realAdaptation === null || realAdaptation.id !== newRealAdaptation.id) && type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
        averageThroughput = abrController.getThroughputHistory().getAverageThroughput(type, isDynamic);
        bitrate = averageThroughput || abrController.getInitialBitrateFor(type, streamInfo.id);
        quality = abrController.getQualityForBitrate(mediaInfo, bitrate, streamInfo.id);
      } else {
        quality = abrController.getQualityFor(type, streamInfo.id);
      }

      if (minIdx !== undefined && quality < minIdx) {
        quality = minIdx;
      }

      if (quality > maxQuality) {
        quality = maxQuality;
      }

      return representationController.updateData(newRealAdaptation, voRepresentations, type, mediaInfo.isFragmented, quality);
    } else {
      return Promise.resolve();
    }
  }

  function addMediaInfo(newMediaInfo) {
    if (mediaInfoArr.indexOf(newMediaInfo) === -1) {
      mediaInfoArr.push(newMediaInfo);
    }
  }

  function clearMediaInfoArray() {
    mediaInfoArr = [];
  }

  function getMediaInfo() {
    return mediaInfo;
  }

  function getMediaSource() {
    return bufferController.getMediaSource();
  }

  function setMediaSource(mediaSource) {
    bufferController.setMediaSource(mediaSource);
  }

  function getScheduleController() {
    return scheduleController;
  }
  /**
   * Get a specific voRepresentation. If quality parameter is defined, this function will return the voRepresentation for this quality.
   * Otherwise, this function will return the current voRepresentation used by the representationController.
   * @param {number} quality - quality index of the voRepresentaion expected.
   */


  function getRepresentationInfo(quality) {
    var voRepresentation;

    if (quality !== undefined) {
      Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_9__["checkInteger"])(quality);
      voRepresentation = representationController ? representationController.getRepresentationForQuality(quality) : null;
    } else {
      voRepresentation = representationController ? representationController.getCurrentRepresentation() : null;
    }

    return adapter.convertRepresentationToRepresentationInfo(voRepresentation);
  }

  function isBufferingCompleted() {
    return bufferController ? bufferController.getIsBufferingCompleted() : false;
  }

  function getBufferLevel() {
    return bufferController ? bufferController.getBufferLevel() : 0;
  }
  /**
   * Probe the next request. This is used in the CMCD model to get information about the upcoming request. Note: No actual request is performed here.
   * @return {FragmentRequest|null}
   */


  function probeNextRequest() {
    var representationInfo = getRepresentationInfo();
    var representation = representationController && representationInfo ? representationController.getRepresentationForQuality(representationInfo.quality) : null;
    var request = dashHandler.getNextSegmentRequestIdempotent(mediaInfo, representation);
    return request;
  }

  function _onMediaFragmentLoaded(e) {
    var chunk = e.chunk;
    var bytes = chunk.bytes;
    var quality = chunk.quality;
    var currentRepresentation = getRepresentationInfo(quality);
    var voRepresentation = representationController && currentRepresentation ? representationController.getRepresentationForQuality(currentRepresentation.quality) : null; // If we switch tracks this event might be fired after the representations in the RepresentationController have been updated according to the new MediaInfo.
    // In this case there will be no currentRepresentation and voRepresentation matching the "old" quality

    if (currentRepresentation && voRepresentation) {
      var eventStreamMedia = adapter.getEventsFor(currentRepresentation.mediaInfo);
      var eventStreamTrack = adapter.getEventsFor(currentRepresentation, voRepresentation);

      if (eventStreamMedia && eventStreamMedia.length > 0 || eventStreamTrack && eventStreamTrack.length > 0) {
        var request = fragmentModel.getRequests({
          state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_3__["default"].FRAGMENT_MODEL_EXECUTED,
          quality: quality,
          index: chunk.index
        })[0];

        var events = _handleInbandEvents(bytes, request, eventStreamMedia, eventStreamTrack);

        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].INBAND_EVENTS, {
          events: events
        }, {
          streamId: streamInfo.id
        });
      }
    }
  }

  function _handleInbandEvents(data, request, mediaInbandEvents, trackInbandEvents) {
    try {
      var eventStreams = {};
      var events = [];
      /* Extract the possible schemeIdUri : If a DASH client detects an event message box with a scheme that is not defined in MPD, the client is expected to ignore it */

      var inbandEvents = mediaInbandEvents.concat(trackInbandEvents);

      for (var i = 0, ln = inbandEvents.length; i < ln; i++) {
        eventStreams[inbandEvents[i].schemeIdUri + '/' + inbandEvents[i].value] = inbandEvents[i];
      }

      var isoFile = Object(_utils_BoxParser__WEBPACK_IMPORTED_MODULE_18__["default"])(context).getInstance().parse(data);
      var eventBoxes = isoFile.getBoxes('emsg');

      if (!eventBoxes || eventBoxes.length === 0) {
        return events;
      }

      var sidx = isoFile.getBox('sidx');
      var mediaAnchorTime = sidx && !isNaN(sidx.earliest_presentation_time) && !isNaN(sidx.timescale) ? sidx.earliest_presentation_time / sidx.timescale : request && !isNaN(request.mediaStartTime) ? request.mediaStartTime : 0;
      var fragmentMediaStartTime = Math.max(mediaAnchorTime, 0);
      var voRepresentation = representationController.getCurrentRepresentation();

      for (var _i = 0, _ln = eventBoxes.length; _i < _ln; _i++) {
        var event = adapter.getEvent(eventBoxes[_i], eventStreams, fragmentMediaStartTime, voRepresentation);

        if (event) {
          events.push(event);
        }
      }

      return events;
    } catch (e) {
      return [];
    }
  }

  function createBufferSinks(previousBufferSinks) {
    var buffer = getBuffer();

    if (buffer) {
      return Promise.resolve(buffer);
    }

    return bufferController ? bufferController.createBufferSink(mediaInfo, previousBufferSinks) : Promise.resolve(null);
  }

  function prepareTrackSwitch() {
    return new Promise(function (resolve) {
      logger.debug("Preparing track switch for type ".concat(type));
      var shouldReplace = type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || settings.get().streaming.trackSwitchMode[type] === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SWITCH_MODE_ALWAYS_REPLACE && playbackController.getTimeToStreamEnd(streamInfo) > settings.get().streaming.buffer.stallThreshold; // when buffering is completed and we are not supposed to replace anything do nothing.
      // Still we need to trigger preloading again and call change type in case user seeks back before transitioning to next period

      if (bufferController.getIsBufferingCompleted() && !shouldReplace) {
        bufferController.prepareForNonReplacementTrackSwitch(mediaInfo.codec).then(function () {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFERING_COMPLETED, {}, {
            streamId: streamInfo.id,
            mediaType: type
          });
        })["catch"](function () {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFERING_COMPLETED, {}, {
            streamId: streamInfo.id,
            mediaType: type
          });
        });
        resolve();
        return;
      } // We stop the schedule controller and signal a track switch. That way we request a new init segment next


      scheduleController.clearScheduleTimer();
      scheduleController.setSwitchTrack(true); // when we are supposed to replace it does not matter if buffering is already completed

      if (shouldReplace) {
        // Inform other classes like the GapController that we are replacing existing stuff
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_REPLACEMENT_STARTED, {
          mediaType: type,
          streamId: streamInfo.id
        }, {
          mediaType: type,
          streamId: streamInfo.id
        }); // Abort the current request it will be removed from the buffer anyways

        fragmentModel.abortRequests(); // Abort appending segments to the buffer. Also adjust the appendWindow as we might have been in the progress of prebuffering stuff.

        bufferController.prepareForReplacementTrackSwitch(mediaInfo.codec).then(function () {
          // Timestamp offset couldve been changed by preloading period
          var representationInfo = getRepresentationInfo();
          return bufferController.updateBufferTimestampOffset(representationInfo);
        }).then(function () {
          _bufferClearedForReplacement();

          resolve();
        })["catch"](function () {
          _bufferClearedForReplacement();

          resolve();
        });
      } else {
        // We do not replace anything that is already in the buffer. Still we need to prepare the buffer for the track switch
        bufferController.prepareForNonReplacementTrackSwitch(mediaInfo.codec).then(function () {
          _bufferClearedForNonReplacement();

          resolve();
        })["catch"](function () {
          _bufferClearedForNonReplacement();

          resolve();
        });
      }
    });
  }
  /**
   * For an instant track switch we need to adjust the buffering time after the buffer has been pruned.
   * @private
   */


  function _bufferClearedForReplacement() {
    var targetTime = playbackController.getTime();

    if (settings.get().streaming.buffer.flushBufferAtTrackSwitch) {
      // For some devices (like chromecast) it is necessary to seek the video element to reset the internal decoding buffer,
      // otherwise audio track switch will be effective only once after previous buffered track is consumed
      playbackController.seek(targetTime + 0.001, false, true);
    }

    setExplicitBufferingTime(targetTime);
    bufferController.setSeekTarget(targetTime);
    scheduleController.startScheduleTimer();
  }

  function _bufferClearedForNonReplacement() {
    var time = playbackController.getTime();
    var continuousBufferTime = bufferController.getContinuousBufferTimeForTargetTime(time);
    var targetTime = isNaN(continuousBufferTime) ? time : continuousBufferTime;
    setExplicitBufferingTime(targetTime);
    scheduleController.startScheduleTimer();
  }

  function _createBufferControllerForType(type, isFragmented) {
    var controller = null;

    if (!type) {
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_14__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + 'not properly defined'));
      return null;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && !isFragmented) {
      controller = Object(_text_NotFragmentedTextBufferController__WEBPACK_IMPORTED_MODULE_5__["default"])(context).create({
        streamInfo: streamInfo,
        type: type,
        mimeType: mimeType,
        fragmentModel: fragmentModel,
        textController: textController,
        errHandler: errHandler,
        settings: settings
      });
    } else {
      controller = Object(_controllers_BufferController__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
        streamInfo: streamInfo,
        type: type,
        mediaPlayerModel: mediaPlayerModel,
        manifestModel: manifestModel,
        fragmentModel: fragmentModel,
        errHandler: errHandler,
        mediaController: mediaController,
        representationController: representationController,
        adapter: adapter,
        textController: textController,
        abrController: abrController,
        playbackController: playbackController,
        settings: settings
      });
    }

    return controller;
  }

  function _onSeekTarget(e) {
    if (e && !isNaN(e.time)) {
      setExplicitBufferingTime(e.time);
      bufferController.setSeekTarget(e.time);
    }
  }

  function setExplicitBufferingTime(value) {
    bufferingTime = value;
    shouldUseExplicitTimeForRequest = true;
  }

  function finalisePlayList(time, reason) {
    dashMetrics.pushPlayListTraceMetrics(time, reason);
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    getType: getType,
    isUpdating: isUpdating,
    getBufferController: getBufferController,
    getFragmentModel: getFragmentModel,
    getScheduleController: getScheduleController,
    getRepresentationController: getRepresentationController,
    getRepresentationInfo: getRepresentationInfo,
    getBufferLevel: getBufferLevel,
    isBufferingCompleted: isBufferingCompleted,
    createBufferSinks: createBufferSinks,
    updateStreamInfo: updateStreamInfo,
    getStreamInfo: getStreamInfo,
    selectMediaInfo: selectMediaInfo,
    clearMediaInfoArray: clearMediaInfoArray,
    addMediaInfo: addMediaInfo,
    prepareTrackSwitch: prepareTrackSwitch,
    prepareQualityChange: prepareQualityChange,
    getMediaInfo: getMediaInfo,
    getMediaSource: getMediaSource,
    setMediaSource: setMediaSource,
    getBuffer: getBuffer,
    setExplicitBufferingTime: setExplicitBufferingTime,
    finalisePlayList: finalisePlayList,
    probeNextRequest: probeNextRequest,
    prepareInnerPeriodPlaybackSeeking: prepareInnerPeriodPlaybackSeeking,
    prepareOuterPeriodPlaybackSeeking: prepareOuterPeriodPlaybackSeeking,
    reset: reset
  };
  setup();
  return instance;
}

StreamProcessor.__dashjs_factory_name = 'StreamProcessor';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_8__["default"].getClassFactory(StreamProcessor));

/***/ }),

/***/ "./src/streaming/XlinkLoader.js":
/*!**************************************!*\
  !*** ./src/streaming/XlinkLoader.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1327866__) {

"use strict";
__nested_webpack_require_1327866__.r(__webpack_exports__);
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1327866__(/*! ./vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _net_URLLoader__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1327866__(/*! ./net/URLLoader */ "./src/streaming/net/URLLoader.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1327866__(/*! ./vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _vo_TextRequest__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1327866__(/*! ./vo/TextRequest */ "./src/streaming/vo/TextRequest.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1327866__(/*! ../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1327866__(/*! ../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1327866__(/*! ../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1327866__(/*! ../core/errors/Errors */ "./src/core/errors/Errors.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









function XlinkLoader(config) {
  config = config || {};
  var RESOLVE_TO_ZERO = 'urn:mpeg:dash:resolve-to-zero:2013';
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var urlLoader = Object(_net_URLLoader__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
    errHandler: config.errHandler,
    dashMetrics: config.dashMetrics,
    mediaPlayerModel: config.mediaPlayerModel,
    requestModifier: config.requestModifier,
    errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_7__["default"]
  });
  var instance;

  function load(url, element, resolveObject) {
    var report = function report(content, resolveToZero) {
      element.resolved = true;
      element.resolvedContent = content ? content : null;
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].XLINK_ELEMENT_LOADED, {
        element: element,
        resolveObject: resolveObject,
        error: content || resolveToZero ? null : new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_7__["default"].XLINK_LOADER_LOADING_FAILURE_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_7__["default"].XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE + url)
      });
    };

    if (url === RESOLVE_TO_ZERO) {
      report(null, true);
    } else {
      var request = new _vo_TextRequest__WEBPACK_IMPORTED_MODULE_3__["default"](url, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].XLINK_EXPANSION_TYPE);
      urlLoader.load({
        request: request,
        success: function success(data) {
          report(data);
        },
        error: function error() {
          report(null);
        }
      });
    }
  }

  function reset() {
    if (urlLoader) {
      urlLoader.abort();
      urlLoader = null;
    }
  }

  instance = {
    load: load,
    reset: reset
  };
  return instance;
}

XlinkLoader.__dashjs_factory_name = 'XlinkLoader';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__["default"].getClassFactory(XlinkLoader));

/***/ }),

/***/ "./src/streaming/constants/ConformanceViolationConstants.js":
/*!******************************************************************!*\
  !*** ./src/streaming/constants/ConformanceViolationConstants.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1333687__) {

"use strict";
__nested_webpack_require_1333687__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  LEVELS: {
    SUGGESTION: 'Suggestion',
    WARNING: 'Warning',
    ERROR: 'Error'
  },
  EVENTS: {
    NO_UTC_TIMING_ELEMENT: {
      key: 'NO_UTC_TIMING_ELEMENT',
      message: 'No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/'
    },
    NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE: {
      key: 'NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE',
      message: 'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"'
    },
    INVALID_DVR_WINDOW: {
      key: 'INVALID_DVR_WINDOW',
      message: 'No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback.'
    }
  }
});

/***/ }),

/***/ "./src/streaming/constants/Constants.js":
/*!**********************************************!*\
  !*** ./src/streaming/constants/Constants.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1336795__) {

"use strict";
__nested_webpack_require_1336795__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Constants declaration
 * @class
 * @ignore
 * @hideconstructor
 */
var Constants = /*#__PURE__*/function () {
  function Constants() {
    _classCallCheck(this, Constants);

    this.init();
  }

  _createClass(Constants, [{
    key: "init",
    value: function init() {
      /**
       *  @constant {string} STREAM Stream media type. Mainly used to report metrics relative to the full stream
       *  @memberof Constants#
       *  @static
       */
      this.STREAM = 'stream';
      /**
       *  @constant {string} VIDEO Video media type
       *  @memberof Constants#
       *  @static
       */

      this.VIDEO = 'video';
      /**
       *  @constant {string} AUDIO Audio media type
       *  @memberof Constants#
       *  @static
       */

      this.AUDIO = 'audio';
      /**
       *  @constant {string} TEXT Text media type
       *  @memberof Constants#
       *  @static
       */

      this.TEXT = 'text';
      /**
       *  @constant {string} MUXED Muxed (video/audio in the same chunk) media type
       *  @memberof Constants#
       *  @static
       */

      this.MUXED = 'muxed';
      /**
       *  @constant {string} IMAGE Image media type
       *  @memberof Constants#
       *  @static
       */

      this.IMAGE = 'image';
      /**
       *  @constant {string} STPP STTP Subtitles format
       *  @memberof Constants#
       *  @static
       */

      this.STPP = 'stpp';
      /**
       *  @constant {string} TTML STTP Subtitles format
       *  @memberof Constants#
       *  @static
       */

      this.TTML = 'ttml';
      /**
       *  @constant {string} VTT STTP Subtitles format
       *  @memberof Constants#
       *  @static
       */

      this.VTT = 'vtt';
      /**
       *  @constant {string} WVTT STTP Subtitles format
       *  @memberof Constants#
       *  @static
       */

      this.WVTT = 'wvtt';
      /**
       *  @constant {string} ABR_STRATEGY_DYNAMIC Dynamic Adaptive bitrate algorithm
       *  @memberof Constants#
       *  @static
       */

      this.ABR_STRATEGY_DYNAMIC = 'abrDynamic';
      /**
       *  @constant {string} ABR_STRATEGY_BOLA Adaptive bitrate algorithm based on Bola (buffer level)
       *  @memberof Constants#
       *  @static
       */

      this.ABR_STRATEGY_BOLA = 'abrBola';
      /**
       *  @constant {string} ABR_STRATEGY_L2A Adaptive bitrate algorithm based on L2A (online learning)
       *  @memberof Constants#
       *  @static
       */

      this.ABR_STRATEGY_L2A = 'abrL2A';
      /**
       *  @constant {string} ABR_STRATEGY_LoLP Adaptive bitrate algorithm based on LoL+
       *  @memberof Constants#
       *  @static
       */

      this.ABR_STRATEGY_LoLP = 'abrLoLP';
      /**
       *  @constant {string} ABR_STRATEGY_THROUGHPUT Adaptive bitrate algorithm based on throughput
       *  @memberof Constants#
       *  @static
       */

      this.ABR_STRATEGY_THROUGHPUT = 'abrThroughput';
      /**
       *  @constant {string} ABR_FETCH_THROUGHPUT_CALUCUALTION_DOWNLOADED_DATA Throughput calculation based on downloaded data array
       *  @memberof Constants#
       *  @static
       */

      this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA = 'abrFetchThroughputCalculationDownloadedData';
      /**
       *  @constant {string} ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING Throughput calculation based on moof parsing
       *  @memberof Constants#
       *  @static
       */

      this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING = 'abrFetchThroughputCalculationMoofParsing';
      /**
      *  @constant {string} ABR_FETCH_THROUGHPUT_CALCULATION_AAST Throughput calculation based on adjusted availability start time in low latency mode
      *  @memberof Constants#
      *  @static
      */

      this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST = 'abrFetchThroughputCalculationAAST';
      /**
       *  @constant {string} LIVE_CATCHUP_MODE_DEFAULT Throughput calculation based on moof parsing
       *  @memberof Constants#
       *  @static
       */

      this.LIVE_CATCHUP_MODE_DEFAULT = 'liveCatchupModeDefault';
      /**
       *  @constant {string} LIVE_CATCHUP_MODE_LOLP Throughput calculation based on moof parsing
       *  @memberof Constants#
       *  @static
       */

      this.LIVE_CATCHUP_MODE_LOLP = 'liveCatchupModeLoLP';
      /**
       *  @constant {string} MOVING_AVERAGE_SLIDING_WINDOW Moving average sliding window
       *  @memberof Constants#
       *  @static
       */

      this.MOVING_AVERAGE_SLIDING_WINDOW = 'slidingWindow';
      /**
       *  @constant {string} EWMA Exponential moving average
       *  @memberof Constants#
       *  @static
       */

      this.MOVING_AVERAGE_EWMA = 'ewma';
      /**
       *  @constant {string} BAD_ARGUMENT_ERROR Invalid Arguments type of error
       *  @memberof Constants#
       *  @static
       */

      this.BAD_ARGUMENT_ERROR = 'Invalid Arguments';
      /**
       *  @constant {string} MISSING_CONFIG_ERROR Missing configuration parameters type of error
       *  @memberof Constants#
       *  @static
       */

      this.MISSING_CONFIG_ERROR = 'Missing config parameter(s)';
      /**
       *  @constant {string} TRACK_SWITCH_MODE_ALWAYS_REPLACE used to clear the buffered data (prior to current playback position) after track switch. Default for audio
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SWITCH_MODE_ALWAYS_REPLACE = 'alwaysReplace';
      /**
       *  @constant {string} TRACK_SWITCH_MODE_NEVER_REPLACE used to forbid clearing the buffered data (prior to current playback position) after track switch. Defers to fastSwitchEnabled for placement of new data. Default for video
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SWITCH_MODE_NEVER_REPLACE = 'neverReplace';
      /**
       *  @constant {string} TRACK_SELECTION_MODE_FIRST_TRACK makes the player select the first track found in the manifest.
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SELECTION_MODE_FIRST_TRACK = 'firstTrack';
      /**
       *  @constant {string} TRACK_SELECTION_MODE_HIGHEST_BITRATE makes the player select the track with a highest bitrate. This mode is a default mode.
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SELECTION_MODE_HIGHEST_BITRATE = 'highestBitrate';
      /**
       *  @constant {string} TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY makes the player select the track with the lowest bitrate per pixel average.
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY = 'highestEfficiency';
      /**
       *  @constant {string} TRACK_SELECTION_MODE_WIDEST_RANGE makes the player select the track with a widest range of bitrates.
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SELECTION_MODE_WIDEST_RANGE = 'widestRange';
      /**
       *  @constant {string} TRACK_SELECTION_MODE_WIDEST_RANGE makes the player select the track with the highest selectionPriority as defined in the manifest
       *  @memberof Constants#
       *  @static
       */

      this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY = 'highestSelectionPriority';
      /**
       *  @constant {string} CMCD_MODE_QUERY specifies to attach CMCD metrics as query parameters.
       *  @memberof Constants#
       *  @static
       */

      this.CMCD_MODE_QUERY = 'query';
      /**
       *  @constant {string} CMCD_MODE_HEADER specifies to attach CMCD metrics as HTTP headers.
       *  @memberof Constants#
       *  @static
       */

      this.CMCD_MODE_HEADER = 'header';
      this.LOCATION = 'Location';
      this.INITIALIZE = 'initialize';
      this.TEXT_SHOWING = 'showing';
      this.TEXT_HIDDEN = 'hidden';
      this.CC1 = 'CC1';
      this.CC3 = 'CC3';
      this.UTF8 = 'utf-8';
      this.SCHEME_ID_URI = 'schemeIdUri';
      this.START_TIME = 'starttime';
      this.SERVICE_DESCRIPTION_DVB_LL_SCHEME = 'urn:dvb:dash:lowlatency:scope:2019';
      this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME = 'urn:dvb:dash:lowlatency:critical:2019';
      this.XML = 'XML';
      this.ARRAY_BUFFER = 'ArrayBuffer';
      this.DVB_REPORTING_URL = 'dvb:reportingUrl';
      this.DVB_PROBABILITY = 'dvb:probability';
      this.VIDEO_ELEMENT_READY_STATES = {
        HAVE_NOTHING: 0,
        HAVE_METADATA: 1,
        HAVE_CURRENT_DATA: 2,
        HAVE_FUTURE_DATA: 3,
        HAVE_ENOUGH_DATA: 4
      };
      this.FILE_LOADER_TYPES = {
        FETCH: 'fetch_loader',
        XHR: 'xhr_loader'
      };
    }
  }]);

  return Constants;
}();

var constants = new Constants();
/* harmony default export */ __webpack_exports__["default"] = (constants);

/***/ }),

/***/ "./src/streaming/constants/MetricsConstants.js":
/*!*****************************************************!*\
  !*** ./src/streaming/constants/MetricsConstants.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1348748__) {

"use strict";
__nested_webpack_require_1348748__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Metrics Constants declaration
 * @class
 * @ignore
 */
var MetricsConstants = /*#__PURE__*/function () {
  function MetricsConstants() {
    _classCallCheck(this, MetricsConstants);

    this.init();
  }

  _createClass(MetricsConstants, [{
    key: "init",
    value: function init() {
      this.TCP_CONNECTION = 'TcpList';
      this.HTTP_REQUEST = 'HttpList';
      this.TRACK_SWITCH = 'RepSwitchList';
      this.BUFFER_LEVEL = 'BufferLevel';
      this.BUFFER_LOADED = 'bufferLoaded';
      this.ABANDON_LOAD = 'abandonload';
      this.ALLOW_LOAD = 'allowload';
      this.BUFFER_EMPTY = 'bufferStalled';
      this.BUFFER_STATE = 'BufferState';
      this.DVR_INFO = 'DVRInfo';
      this.DROPPED_FRAMES = 'DroppedFrames';
      this.SCHEDULING_INFO = 'SchedulingInfo';
      this.REQUESTS_QUEUE = 'RequestsQueue';
      this.MANIFEST_UPDATE = 'ManifestUpdate';
      this.MANIFEST_UPDATE_STREAM_INFO = 'ManifestUpdatePeriodInfo';
      this.MANIFEST_UPDATE_TRACK_INFO = 'ManifestUpdateRepresentationInfo';
      this.PLAY_LIST = 'PlayList';
      this.DVB_ERRORS = 'DVBErrors';
      this.HTTP_REQUEST_DVB_REPORTING_TYPE = 'DVBReporting';
    }
  }]);

  return MetricsConstants;
}();

var constants = new MetricsConstants();
/* harmony default export */ __webpack_exports__["default"] = (constants);

/***/ }),

/***/ "./src/streaming/constants/ProtectionConstants.js":
/*!********************************************************!*\
  !*** ./src/streaming/constants/ProtectionConstants.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1353097__) {

"use strict";
__nested_webpack_require_1353097__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Protection Constants declaration
 * @class
 * @ignore
 */
var ProtectionConstants = /*#__PURE__*/function () {
  function ProtectionConstants() {
    _classCallCheck(this, ProtectionConstants);

    this.init();
  }

  _createClass(ProtectionConstants, [{
    key: "init",
    value: function init() {
      this.CLEARKEY_KEYSTEM_STRING = 'org.w3.clearkey';
      this.WIDEVINE_KEYSTEM_STRING = 'com.widevine.alpha';
      this.PLAYREADY_KEYSTEM_STRING = 'com.microsoft.playready';
      this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING = 'com.microsoft.playready.recommendation';
      this.INITIALIZATION_DATA_TYPE_CENC = 'cenc';
      this.INITIALIZATION_DATA_TYPE_KEYIDS = 'keyids';
      this.INITIALIZATION_DATA_TYPE_WEBM = 'webm';
    }
  }]);

  return ProtectionConstants;
}();

var constants = new ProtectionConstants();
/* harmony default export */ __webpack_exports__["default"] = (constants);

/***/ }),

/***/ "./src/streaming/controllers/AbrController.js":
/*!****************************************************!*\
  !*** ./src/streaming/controllers/AbrController.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1357010__) {

"use strict";
__nested_webpack_require_1357010__.r(__webpack_exports__);
/* harmony import */ var _rules_abr_ABRRulesCollection__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1357010__(/*! ../rules/abr/ABRRulesCollection */ "./src/streaming/rules/abr/ABRRulesCollection.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1357010__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1357010__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _vo_BitrateInfo__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1357010__(/*! ../vo/BitrateInfo */ "./src/streaming/vo/BitrateInfo.js");
/* harmony import */ var _models_FragmentModel__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1357010__(/*! ../models/FragmentModel */ "./src/streaming/models/FragmentModel.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1357010__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1357010__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1357010__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _rules_RulesContext__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1357010__(/*! ../rules/RulesContext */ "./src/streaming/rules/RulesContext.js");
/* harmony import */ var _rules_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1357010__(/*! ../rules/SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _rules_SwitchRequestHistory__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1357010__(/*! ../rules/SwitchRequestHistory */ "./src/streaming/rules/SwitchRequestHistory.js");
/* harmony import */ var _rules_DroppedFramesHistory__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1357010__(/*! ../rules/DroppedFramesHistory */ "./src/streaming/rules/DroppedFramesHistory.js");
/* harmony import */ var _rules_ThroughputHistory__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1357010__(/*! ../rules/ThroughputHistory */ "./src/streaming/rules/ThroughputHistory.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1357010__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_1357010__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_15__ = __nested_webpack_require_1357010__(/*! ../utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_16__ = __nested_webpack_require_1357010__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

















var DEFAULT_VIDEO_BITRATE = 1000;
var DEFAULT_AUDIO_BITRATE = 100;
var QUALITY_DEFAULT = 0;

function AbrController() {
  var context = this.context;
  var debug = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_13__["default"])(context).getInstance();
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var instance, logger, abrRulesCollection, streamController, topQualities, qualityDict, streamProcessorDict, abandonmentStateDict, abandonmentTimeout, windowResizeEventCalled, elementWidth, elementHeight, adapter, videoModel, mediaPlayerModel, customParametersModel, domStorage, playbackIndex, switchHistoryDict, droppedFramesHistory, throughputHistory, isUsingBufferOccupancyAbrDict, isUsingL2AAbrDict, isUsingLoLPAbrDict, dashMetrics, settings;

  function setup() {
    logger = debug.getLogger(instance);
    resetInitialSettings();
  }
  /**
   * Initialize everything that is not Stream specific. We only have one instance of the ABR Controller for all periods.
   */


  function initialize() {
    droppedFramesHistory = Object(_rules_DroppedFramesHistory__WEBPACK_IMPORTED_MODULE_11__["default"])(context).create();
    throughputHistory = Object(_rules_ThroughputHistory__WEBPACK_IMPORTED_MODULE_12__["default"])(context).create({
      settings: settings
    });
    abrRulesCollection = Object(_rules_abr_ABRRulesCollection__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
      dashMetrics: dashMetrics,
      customParametersModel: customParametersModel,
      mediaPlayerModel: mediaPlayerModel,
      settings: settings
    });
    abrRulesCollection.initialize();
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_16__["default"].QUALITY_CHANGE_RENDERED, _onQualityChangeRendered, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_16__["default"].METRIC_ADDED, _onMetricAdded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].LOADING_PROGRESS, _onFragmentLoadProgress, instance);
  }
  /**
   * Whenever a StreamProcessor is created it is added to the list of streamProcessorDict
   * In addition, the corresponding objects for this object and its stream id are created
   * @param {object} type
   * @param {object} streamProcessor
   */


  function registerStreamType(type, streamProcessor) {
    var streamId = streamProcessor.getStreamInfo().id;

    if (!streamProcessorDict[streamId]) {
      streamProcessorDict[streamId] = {};
    }

    if (!switchHistoryDict[streamId]) {
      switchHistoryDict[streamId] = {};
    }

    if (!abandonmentStateDict[streamId]) {
      abandonmentStateDict[streamId] = {};
    }

    switchHistoryDict[streamId][type] = Object(_rules_SwitchRequestHistory__WEBPACK_IMPORTED_MODULE_10__["default"])(context).create();
    streamProcessorDict[streamId][type] = streamProcessor;
    abandonmentStateDict[streamId][type] = {};
    abandonmentStateDict[streamId][type].state = _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].ALLOW_LOAD;

    _initializeAbrStrategy(type);

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO) {
      setElementSize();
    }
  }

  function _initializeAbrStrategy(type) {
    var strategy = settings.get().streaming.abr.ABRStrategy;

    if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_L2A) {
      isUsingBufferOccupancyAbrDict[type] = false;
      isUsingLoLPAbrDict[type] = false;
      isUsingL2AAbrDict[type] = true;
    } else if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_LoLP) {
      isUsingBufferOccupancyAbrDict[type] = false;
      isUsingLoLPAbrDict[type] = true;
      isUsingL2AAbrDict[type] = false;
    } else if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_BOLA) {
      isUsingBufferOccupancyAbrDict[type] = true;
      isUsingLoLPAbrDict[type] = false;
      isUsingL2AAbrDict[type] = false;
    } else if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_THROUGHPUT) {
      isUsingBufferOccupancyAbrDict[type] = false;
      isUsingLoLPAbrDict[type] = false;
      isUsingL2AAbrDict[type] = false;
    } else if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_DYNAMIC) {
      isUsingBufferOccupancyAbrDict[type] = isUsingBufferOccupancyAbrDict && isUsingBufferOccupancyAbrDict[type] ? isUsingBufferOccupancyAbrDict[type] : false;
      isUsingLoLPAbrDict[type] = false;
      isUsingL2AAbrDict[type] = false;
    }
  }

  function unRegisterStreamType(streamId, type) {
    try {
      if (streamProcessorDict[streamId] && streamProcessorDict[streamId][type]) {
        delete streamProcessorDict[streamId][type];
      }

      if (switchHistoryDict[streamId] && switchHistoryDict[streamId][type]) {
        delete switchHistoryDict[streamId][type];
      }

      if (abandonmentStateDict[streamId] && abandonmentStateDict[streamId][type]) {
        delete abandonmentStateDict[streamId][type];
      }
    } catch (e) {}
  }

  function resetInitialSettings() {
    topQualities = {};
    qualityDict = {};
    abandonmentStateDict = {};
    streamProcessorDict = {};
    switchHistoryDict = {};
    isUsingBufferOccupancyAbrDict = {};
    isUsingL2AAbrDict = {};
    isUsingLoLPAbrDict = {};

    if (windowResizeEventCalled === undefined) {
      windowResizeEventCalled = false;
    }

    if (droppedFramesHistory) {
      droppedFramesHistory.reset();
    }

    playbackIndex = undefined;
    droppedFramesHistory = undefined;
    throughputHistory = undefined;
    clearTimeout(abandonmentTimeout);
    abandonmentTimeout = null;
  }

  function reset() {
    resetInitialSettings();
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].LOADING_PROGRESS, _onFragmentLoadProgress, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_16__["default"].QUALITY_CHANGE_RENDERED, _onQualityChangeRendered, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_16__["default"].METRIC_ADDED, _onMetricAdded, instance);

    if (abrRulesCollection) {
      abrRulesCollection.reset();
    }
  }

  function setConfig(config) {
    if (!config) return;

    if (config.streamController) {
      streamController = config.streamController;
    }

    if (config.domStorage) {
      domStorage = config.domStorage;
    }

    if (config.mediaPlayerModel) {
      mediaPlayerModel = config.mediaPlayerModel;
    }

    if (config.customParametersModel) {
      customParametersModel = config.customParametersModel;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }

    if (config.videoModel) {
      videoModel = config.videoModel;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }

  function checkConfig() {
    if (!domStorage || !domStorage.hasOwnProperty('getSavedBitrateSettings')) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].MISSING_CONFIG_ERROR);
    }
  }
  /**
   * While fragment loading is in progress we check if we might need to abort the request
   * @param {object} e
   * @private
   */


  function _onFragmentLoadProgress(e) {
    var type = e.request.mediaType;
    var streamId = e.streamId;

    if (!type || !streamId || !streamProcessorDict[streamId] || !settings.get().streaming.abr.autoSwitchBitrate[type]) {
      return;
    }

    var streamProcessor = streamProcessorDict[streamId][type];

    if (!streamProcessor) {
      return;
    }

    var rulesContext = Object(_rules_RulesContext__WEBPACK_IMPORTED_MODULE_8__["default"])(context).create({
      abrController: instance,
      streamProcessor: streamProcessor,
      currentRequest: e.request,
      useBufferOccupancyABR: isUsingBufferOccupancyAbrDict[type],
      useL2AABR: isUsingL2AAbrDict[type],
      useLoLPABR: isUsingLoLPAbrDict[type],
      videoModel: videoModel
    });
    var switchRequest = abrRulesCollection.shouldAbandonFragment(rulesContext, streamId);

    if (switchRequest.quality > _rules_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE) {
      var fragmentModel = streamProcessor.getFragmentModel();
      var request = fragmentModel.getRequests({
        state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_4__["default"].FRAGMENT_MODEL_LOADING,
        index: e.request.index
      })[0];

      if (request) {
        abandonmentStateDict[streamId][type].state = _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].ABANDON_LOAD;
        switchHistoryDict[streamId][type].reset();
        switchHistoryDict[streamId][type].push({
          oldValue: getQualityFor(type, streamId),
          newValue: switchRequest.quality,
          confidence: 1,
          reason: switchRequest.reason
        });
        setPlaybackQuality(type, streamController.getActiveStreamInfo(), switchRequest.quality, switchRequest.reason);
        clearTimeout(abandonmentTimeout);
        abandonmentTimeout = setTimeout(function () {
          abandonmentStateDict[streamId][type].state = _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].ALLOW_LOAD;
          abandonmentTimeout = null;
        }, settings.get().streaming.abandonLoadTimeout);
      }
    }
  }
  /**
   * Update dropped frames history when the quality was changed
   * @param {object} e
   * @private
   */


  function _onQualityChangeRendered(e) {
    if (e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO) {
      if (playbackIndex !== undefined) {
        droppedFramesHistory.push(e.streamId, playbackIndex, videoModel.getPlaybackQuality());
      }

      playbackIndex = e.newQuality;
    }
  }
  /**
   * When the buffer level is updated we check if we need to change the ABR strategy
   * @param e
   * @private
   */


  function _onMetricAdded(e) {
    if (e.metric === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].HTTP_REQUEST && e.value && e.value.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_14__["HTTPRequest"].MEDIA_SEGMENT_TYPE && (e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO || e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO)) {
      throughputHistory.push(e.mediaType, e.value, settings.get().streaming.abr.useDeadTimeLatency);
    }

    if (e.metric === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].BUFFER_LEVEL && (e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO || e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO)) {
      _updateAbrStrategy(e.mediaType, 0.001 * e.value.level);
    }
  }
  /**
   * Returns the highest possible index taking limitations like maxBitrate, representationRatio and portal size into account.
   * @param {string} type
   * @param {string} streamId
   * @return {number}
   */


  function getMaxAllowedIndexFor(type, streamId) {
    try {
      var idx;
      topQualities[streamId] = topQualities[streamId] || {};

      if (!topQualities[streamId].hasOwnProperty(type)) {
        topQualities[streamId][type] = 0;
      }

      idx = _checkMaxBitrate(type, streamId);
      idx = _checkMaxRepresentationRatio(idx, type, streamId);
      idx = _checkPortalSize(idx, type, streamId);
      return idx;
    } catch (e) {
      return undefined;
    }
  }
  /**
   * Returns the minimum allowed index. We consider thresholds defined in the settings, i.e. minBitrate for the corresponding media type.
   * @param {string} type
   * @param {string} streamId
   * @return {undefined|number}
   */


  function getMinAllowedIndexFor(type, streamId) {
    try {
      return _getMinIndexBasedOnBitrateFor(type, streamId);
    } catch (e) {
      return undefined;
    }
  }
  /**
   * Returns the maximum allowed index.
   * @param {string} type
   * @param {string} streamId
   * @return {undefined|number}
   */


  function _getMaxIndexBasedOnBitrateFor(type, streamId) {
    try {
      var maxBitrate = mediaPlayerModel.getAbrBitrateParameter('maxBitrate', type);

      if (maxBitrate > -1) {
        return getQualityForBitrate(streamProcessorDict[streamId][type].getMediaInfo(), maxBitrate, streamId);
      } else {
        return undefined;
      }
    } catch (e) {
      return undefined;
    }
  }
  /**
   * Returns the minimum allowed index.
   * @param {string} type
   * @param {string} streamId
   * @return {undefined|number}
   */


  function _getMinIndexBasedOnBitrateFor(type, streamId) {
    try {
      var minBitrate = mediaPlayerModel.getAbrBitrateParameter('minBitrate', type);

      if (minBitrate > -1) {
        var mediaInfo = streamProcessorDict[streamId][type].getMediaInfo();
        var bitrateList = getBitrateList(mediaInfo); // This returns the quality index <= for the given bitrate

        var minIdx = getQualityForBitrate(mediaInfo, minBitrate, streamId);

        if (bitrateList[minIdx] && minIdx < bitrateList.length - 1 && bitrateList[minIdx].bitrate < minBitrate * 1000) {
          minIdx++; // Go to the next bitrate
        }

        return minIdx;
      } else {
        return undefined;
      }
    } catch (e) {
      return undefined;
    }
  }
  /**
   * Returns the maximum possible index
   * @param type
   * @param streamId
   * @return {number|*}
   */


  function _checkMaxBitrate(type, streamId) {
    var idx = topQualities[streamId][type];
    var newIdx = idx;

    if (!streamProcessorDict[streamId] || !streamProcessorDict[streamId][type]) {
      return newIdx;
    }

    var minIdx = getMinAllowedIndexFor(type, streamId);

    if (minIdx !== undefined) {
      newIdx = Math.max(idx, minIdx);
    }

    var maxIdx = _getMaxIndexBasedOnBitrateFor(type, streamId);

    if (maxIdx !== undefined) {
      newIdx = Math.min(newIdx, maxIdx);
    }

    return newIdx;
  }
  /**
   * Returns the maximum index according to maximum representation ratio
   * @param idx
   * @param type
   * @param streamId
   * @return {number|*}
   * @private
   */


  function _checkMaxRepresentationRatio(idx, type, streamId) {
    var maxIdx = topQualities[streamId][type];
    var maxRepresentationRatio = settings.get().streaming.abr.maxRepresentationRatio[type];

    if (isNaN(maxRepresentationRatio) || maxRepresentationRatio >= 1 || maxRepresentationRatio < 0) {
      return idx;
    }

    return Math.min(idx, Math.round(maxIdx * maxRepresentationRatio));
  }
  /**
   * Returns the maximum index according to the portal size
   * @param idx
   * @param type
   * @param streamId
   * @return {number|*}
   * @private
   */


  function _checkPortalSize(idx, type, streamId) {
    if (type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO || !settings.get().streaming.abr.limitBitrateByPortal || !streamProcessorDict[streamId] || !streamProcessorDict[streamId][type]) {
      return idx;
    }

    if (!windowResizeEventCalled) {
      setElementSize();
    }

    var streamInfo = streamProcessorDict[streamId][type].getStreamInfo();
    var representation = adapter.getAdaptationForType(streamInfo.index, type, streamInfo).Representation;
    var newIdx = idx;

    if (elementWidth > 0 && elementHeight > 0) {
      while (newIdx > 0 && representation[newIdx] && elementWidth < representation[newIdx].width && elementWidth - representation[newIdx - 1].width < representation[newIdx].width - elementWidth) {
        newIdx = newIdx - 1;
      } // Make sure that in case of multiple representation elements have same
      // resolution, every such element is included


      while (newIdx < representation.length - 1 && representation[newIdx].width === representation[newIdx + 1].width) {
        newIdx = newIdx + 1;
      }
    }

    return newIdx;
  }
  /**
   * Gets top BitrateInfo for the player
   * @param {string} type - 'video' or 'audio' are the type options.
   * @param {string} streamId - Id of the stream
   * @returns {BitrateInfo | null}
   */


  function getTopBitrateInfoFor(type) {
    var streamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!streamId) {
      streamId = streamController.getActiveStreamInfo().id;
    }

    if (type && streamProcessorDict && streamProcessorDict[streamId] && streamProcessorDict[streamId][type]) {
      var idx = getMaxAllowedIndexFor(type, streamId);
      var bitrates = getBitrateList(streamProcessorDict[streamId][type].getMediaInfo());
      return bitrates[idx] ? bitrates[idx] : null;
    }

    return null;
  }
  /**
   * Returns the initial bitrate for a specific media type and stream id
   * @param {string} type
   * @param {string} streamId
   * @returns {number} A value of the initial bitrate, kbps
   * @memberof AbrController#
   */


  function getInitialBitrateFor(type, streamId) {
    checkConfig();

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].TEXT) {
      return NaN;
    }

    var savedBitrate = domStorage.getSavedBitrateSettings(type);
    var configBitrate = mediaPlayerModel.getAbrBitrateParameter('initialBitrate', type);
    var configRatio = settings.get().streaming.abr.initialRepresentationRatio[type];

    if (configBitrate === -1) {
      if (configRatio > -1) {
        var streamInfo = streamProcessorDict[streamId][type].getStreamInfo();
        var representation = adapter.getAdaptationForType(streamInfo.index, type, streamInfo).Representation;

        if (Array.isArray(representation)) {
          var repIdx = Math.max(Math.round(representation.length * configRatio) - 1, 0);
          configBitrate = representation[repIdx].bandwidth / 1000;
        } else {
          configBitrate = 0;
        }
      } else if (!isNaN(savedBitrate)) {
        configBitrate = savedBitrate;
      } else {
        configBitrate = type === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO ? DEFAULT_VIDEO_BITRATE : DEFAULT_AUDIO_BITRATE;
      }
    }

    return configBitrate;
  }
  /**
   * This function is called by the scheduleControllers to check if the quality should be changed.
   * Consider this the main entry point for the ABR decision logic
   * @param {string} type
   * @param {string} streamId
   */


  function checkPlaybackQuality(type, streamId) {
    try {
      if (!type || !streamProcessorDict || !streamProcessorDict[streamId] || !streamProcessorDict[streamId][type]) {
        return false;
      }

      if (droppedFramesHistory) {
        var playbackQuality = videoModel.getPlaybackQuality();

        if (playbackQuality) {
          droppedFramesHistory.push(streamId, playbackIndex, playbackQuality);
        }
      } // ABR is turned off, do nothing


      if (!settings.get().streaming.abr.autoSwitchBitrate[type]) {
        return false;
      }

      var oldQuality = getQualityFor(type, streamId);
      var rulesContext = Object(_rules_RulesContext__WEBPACK_IMPORTED_MODULE_8__["default"])(context).create({
        abrController: instance,
        switchHistory: switchHistoryDict[streamId][type],
        droppedFramesHistory: droppedFramesHistory,
        streamProcessor: streamProcessorDict[streamId][type],
        currentValue: oldQuality,
        useBufferOccupancyABR: isUsingBufferOccupancyAbrDict[type],
        useL2AABR: isUsingL2AAbrDict[type],
        useLoLPABR: isUsingLoLPAbrDict[type],
        videoModel: videoModel
      });
      var minIdx = getMinAllowedIndexFor(type, streamId);
      var maxIdx = getMaxAllowedIndexFor(type, streamId);
      var switchRequest = abrRulesCollection.getMaxQuality(rulesContext);
      var newQuality = switchRequest.quality;

      if (minIdx !== undefined && (newQuality > _rules_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE ? newQuality : oldQuality) < minIdx) {
        newQuality = minIdx;
      }

      if (newQuality > maxIdx) {
        newQuality = maxIdx;
      }

      switchHistoryDict[streamId][type].push({
        oldValue: oldQuality,
        newValue: newQuality
      });

      if (newQuality > _rules_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE && newQuality !== oldQuality && (abandonmentStateDict[streamId][type].state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_2__["default"].ALLOW_LOAD || newQuality < oldQuality)) {
        _changeQuality(type, oldQuality, newQuality, maxIdx, switchRequest.reason, streamId);

        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }
  /**
   * Returns the current quality for a specific media type and a specific streamId
   * @param {string} type
   * @param {string} streamId
   * @return {number|*}
   */


  function getQualityFor(type) {
    var streamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    try {
      if (!streamId) {
        streamId = streamController.getActiveStreamInfo().id;
      }

      if (type && streamProcessorDict[streamId] && streamProcessorDict[streamId][type]) {
        var quality;

        if (streamId) {
          qualityDict[streamId] = qualityDict[streamId] || {};

          if (!qualityDict[streamId].hasOwnProperty(type)) {
            qualityDict[streamId][type] = QUALITY_DEFAULT;
          }

          quality = qualityDict[streamId][type];
          return quality;
        }
      }

      return QUALITY_DEFAULT;
    } catch (e) {
      return QUALITY_DEFAULT;
    }
  }
  /**
   * Sets the new playback quality. Starts from index 0.
   * If the index of the new quality is the same as the old one changeQuality will not be called.
   * @param {string} type
   * @param {object} streamInfo
   * @param {number} newQuality
   * @param {string} reason
   */


  function setPlaybackQuality(type, streamInfo, newQuality) {
    var reason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!streamInfo || !streamInfo.id || !type) {
      return;
    }

    var streamId = streamInfo.id;
    var oldQuality = getQualityFor(type, streamId);
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_15__["checkInteger"])(newQuality);
    var topQualityIdx = getMaxAllowedIndexFor(type, streamId);

    if (newQuality !== oldQuality && newQuality >= 0 && newQuality <= topQualityIdx) {
      _changeQuality(type, oldQuality, newQuality, topQualityIdx, reason, streamId);
    }
  }
  /**
   *
   * @param {string} streamId
   * @param {type} type
   * @return {*|null}
   */


  function getAbandonmentStateFor(streamId, type) {
    return abandonmentStateDict[streamId] && abandonmentStateDict[streamId][type] ? abandonmentStateDict[streamId][type].state : null;
  }
  /**
   * Changes the internal qualityDict values according to the new quality
   * @param {string} type
   * @param {number} oldQuality
   * @param {number} newQuality
   * @param {number} maxIdx
   * @param {string} reason
   * @param {object} streamId
   * @private
   */


  function _changeQuality(type, oldQuality, newQuality, maxIdx, reason, streamId) {
    if (type && streamProcessorDict[streamId] && streamProcessorDict[streamId][type]) {
      var streamInfo = streamProcessorDict[streamId][type].getStreamInfo();
      var isDynamic = streamInfo && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic;
      var bufferLevel = dashMetrics.getCurrentBufferLevel(type);
      logger.info('Stream ID: ' + streamId + ' [' + type + '] switch from ' + oldQuality + ' to ' + newQuality + '/' + maxIdx + ' (buffer: ' + bufferLevel + ') ' + (reason ? JSON.stringify(reason) : '.'));
      qualityDict[streamId] = qualityDict[streamId] || {};
      qualityDict[streamId][type] = newQuality;

      var bitrateInfo = _getBitrateInfoForQuality(streamId, type, newQuality);

      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].QUALITY_CHANGE_REQUESTED, {
        oldQuality: oldQuality,
        newQuality: newQuality,
        reason: reason,
        streamInfo: streamInfo,
        bitrateInfo: bitrateInfo,
        maxIdx: maxIdx,
        mediaType: type
      }, {
        streamId: streamInfo.id,
        mediaType: type
      });
      var bitrate = throughputHistory.getAverageThroughput(type, isDynamic);

      if (!isNaN(bitrate)) {
        domStorage.setSavedBitrateSettings(type, bitrate);
      }
    }
  }

  function _getBitrateInfoForQuality(streamId, type, idx) {
    if (type && streamProcessorDict && streamProcessorDict[streamId] && streamProcessorDict[streamId][type]) {
      var bitrates = getBitrateList(streamProcessorDict[streamId][type].getMediaInfo());
      return bitrates[idx] ? bitrates[idx] : null;
    }

    return null;
  }
  /**
   * @param {MediaInfo} mediaInfo
   * @param {number} bitrate A bitrate value, kbps
   * @param {String} streamId Period ID
   * @param {number|null} latency Expected latency of connection, ms
   * @returns {number} A quality index <= for the given bitrate
   * @memberof AbrController#
   */


  function getQualityForBitrate(mediaInfo, bitrate, streamId) {
    var latency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var voRepresentation = mediaInfo && mediaInfo.type ? streamProcessorDict[streamId][mediaInfo.type].getRepresentationInfo() : null;

    if (settings.get().streaming.abr.useDeadTimeLatency && latency && voRepresentation && voRepresentation.fragmentDuration) {
      latency = latency / 1000;
      var fragmentDuration = voRepresentation.fragmentDuration;

      if (latency > fragmentDuration) {
        return 0;
      } else {
        var deadTimeRatio = latency / fragmentDuration;
        bitrate = bitrate * (1 - deadTimeRatio);
      }
    }

    var bitrateList = getBitrateList(mediaInfo);

    for (var i = bitrateList.length - 1; i >= 0; i--) {
      var bitrateInfo = bitrateList[i];

      if (bitrate * 1000 >= bitrateInfo.bitrate) {
        return i;
      }
    }

    return QUALITY_DEFAULT;
  }
  /**
   * @param {MediaInfo} mediaInfo
   * @returns {Array|null} A list of {@link BitrateInfo} objects
   * @memberof AbrController#
   */


  function getBitrateList(mediaInfo) {
    var infoList = [];
    if (!mediaInfo || !mediaInfo.bitrateList) return infoList;
    var bitrateList = mediaInfo.bitrateList;
    var type = mediaInfo.type;
    var bitrateInfo;

    for (var i = 0, ln = bitrateList.length; i < ln; i++) {
      bitrateInfo = new _vo_BitrateInfo__WEBPACK_IMPORTED_MODULE_3__["default"]();
      bitrateInfo.mediaType = type;
      bitrateInfo.qualityIndex = i;
      bitrateInfo.bitrate = bitrateList[i].bandwidth;
      bitrateInfo.width = bitrateList[i].width;
      bitrateInfo.height = bitrateList[i].height;
      bitrateInfo.scanType = bitrateList[i].scanType;
      infoList.push(bitrateInfo);
    }

    return infoList;
  }

  function _updateAbrStrategy(mediaType, bufferLevel) {
    // else ABR_STRATEGY_DYNAMIC
    var strategy = settings.get().streaming.abr.ABRStrategy;

    if (strategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].ABR_STRATEGY_DYNAMIC) {
      _updateDynamicAbrStrategy(mediaType, bufferLevel);
    }
  }

  function _updateDynamicAbrStrategy(mediaType, bufferLevel) {
    try {
      var stableBufferTime = mediaPlayerModel.getStableBufferTime();
      var switchOnThreshold = stableBufferTime;
      var switchOffThreshold = 0.5 * stableBufferTime;
      var useBufferABR = isUsingBufferOccupancyAbrDict[mediaType];
      var newUseBufferABR = bufferLevel > (useBufferABR ? switchOffThreshold : switchOnThreshold); // use hysteresis to avoid oscillating rules

      isUsingBufferOccupancyAbrDict[mediaType] = newUseBufferABR;

      if (newUseBufferABR !== useBufferABR) {
        if (newUseBufferABR) {
          logger.info('[' + mediaType + '] switching from throughput to buffer occupancy ABR rule (buffer: ' + bufferLevel.toFixed(3) + ').');
        } else {
          logger.info('[' + mediaType + '] switching from buffer occupancy to throughput ABR rule (buffer: ' + bufferLevel.toFixed(3) + ').');
        }
      }
    } catch (e) {
      logger.error(e);
    }
  }

  function getThroughputHistory() {
    return throughputHistory;
  }

  function updateTopQualityIndex(mediaInfo) {
    var type = mediaInfo.type;
    var streamId = mediaInfo.streamInfo.id;
    var max = mediaInfo.representationCount - 1;
    topQualities[streamId] = topQualities[streamId] || {};
    topQualities[streamId][type] = max;
    return max;
  }

  function isPlayingAtTopQuality(streamInfo) {
    var streamId = streamInfo ? streamInfo.id : null;
    var audioQuality = getQualityFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO, streamId);
    var videoQuality = getQualityFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO, streamId);
    var isAtTop = audioQuality === getMaxAllowedIndexFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].AUDIO, streamId) && videoQuality === getMaxAllowedIndexFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].VIDEO, streamId);
    return isAtTop;
  }

  function setWindowResizeEventCalled(value) {
    windowResizeEventCalled = value;
  }

  function setElementSize() {
    if (videoModel) {
      var hasPixelRatio = settings.get().streaming.abr.usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty('devicePixelRatio');
      var pixelRatio = hasPixelRatio ? window.devicePixelRatio : 1;
      elementWidth = videoModel.getClientWidth() * pixelRatio;
      elementHeight = videoModel.getClientHeight() * pixelRatio;
    }
  }

  function clearDataForStream(streamId) {
    if (droppedFramesHistory) {
      droppedFramesHistory.clearForStream(streamId);
    }

    if (streamProcessorDict[streamId]) {
      delete streamProcessorDict[streamId];
    }

    if (switchHistoryDict[streamId]) {
      delete switchHistoryDict[streamId];
    }

    if (abandonmentStateDict[streamId]) {
      delete abandonmentStateDict[streamId];
    }
  }

  instance = {
    initialize: initialize,
    isPlayingAtTopQuality: isPlayingAtTopQuality,
    updateTopQualityIndex: updateTopQualityIndex,
    clearDataForStream: clearDataForStream,
    getThroughputHistory: getThroughputHistory,
    getBitrateList: getBitrateList,
    getQualityForBitrate: getQualityForBitrate,
    getTopBitrateInfoFor: getTopBitrateInfoFor,
    getMinAllowedIndexFor: getMinAllowedIndexFor,
    getMaxAllowedIndexFor: getMaxAllowedIndexFor,
    getInitialBitrateFor: getInitialBitrateFor,
    getQualityFor: getQualityFor,
    getAbandonmentStateFor: getAbandonmentStateFor,
    setPlaybackQuality: setPlaybackQuality,
    checkPlaybackQuality: checkPlaybackQuality,
    setElementSize: setElementSize,
    setWindowResizeEventCalled: setWindowResizeEventCalled,
    registerStreamType: registerStreamType,
    unRegisterStreamType: unRegisterStreamType,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

AbrController.__dashjs_factory_name = 'AbrController';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_7__["default"].getSingletonFactory(AbrController);
factory.QUALITY_DEFAULT = QUALITY_DEFAULT;
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_7__["default"].updateSingletonFactory(AbrController.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/controllers/BaseURLController.js":
/*!********************************************************!*\
  !*** ./src/streaming/controllers/BaseURLController.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1394672__) {

"use strict";
__nested_webpack_require_1394672__.r(__webpack_exports__);
/* harmony import */ var _models_BaseURLTreeModel__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1394672__(/*! ../models/BaseURLTreeModel */ "./src/streaming/models/BaseURLTreeModel.js");
/* harmony import */ var _utils_BaseURLSelector__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1394672__(/*! ../utils/BaseURLSelector */ "./src/streaming/utils/BaseURLSelector.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1394672__(/*! ../utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _dash_vo_BaseURL__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1394672__(/*! ../../dash/vo/BaseURL */ "./src/dash/vo/BaseURL.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1394672__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1394672__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1394672__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








function BaseURLController() {
  var instance, adapter;
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var baseURLTreeModel, baseURLSelector;

  function onBlackListChanged(e) {
    baseURLTreeModel.invalidateSelectedIndexes(e.entry);
  }

  function setup() {
    baseURLTreeModel = Object(_models_BaseURLTreeModel__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create();
    baseURLSelector = Object(_utils_BaseURLSelector__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SERVICE_LOCATION_BLACKLIST_CHANGED, onBlackListChanged, instance);
  }

  function setConfig(config) {
    if (config.baseURLTreeModel) {
      baseURLTreeModel = config.baseURLTreeModel;
    }

    if (config.baseURLSelector) {
      baseURLSelector = config.baseURLSelector;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }
  }

  function update(manifest) {
    baseURLTreeModel.update(manifest);
    baseURLSelector.chooseSelector(adapter.getIsDVB(manifest));
  }

  function resolve(path) {
    var baseUrls = baseURLTreeModel.getForPath(path);
    var baseUrl = baseUrls.reduce(function (p, c) {
      var b = baseURLSelector.select(c);

      if (b) {
        if (!urlUtils.isRelative(b.url)) {
          p.url = b.url;
          p.serviceLocation = b.serviceLocation;
        } else {
          p.url = urlUtils.resolve(b.url, p.url);
        }

        p.availabilityTimeOffset = b.availabilityTimeOffset;
        p.availabilityTimeComplete = b.availabilityTimeComplete;
      } else {
        return new _dash_vo_BaseURL__WEBPACK_IMPORTED_MODULE_3__["default"]();
      }

      return p;
    }, new _dash_vo_BaseURL__WEBPACK_IMPORTED_MODULE_3__["default"]());

    if (!urlUtils.isRelative(baseUrl.url)) {
      return baseUrl;
    }
  }

  function reset() {
    baseURLTreeModel.reset();
    baseURLSelector.reset();
  }

  function initialize(data) {
    // report config to baseURLTreeModel and baseURLSelector
    baseURLTreeModel.setConfig({
      adapter: adapter
    });
    update(data);
  }

  instance = {
    reset: reset,
    initialize: initialize,
    resolve: resolve,
    setConfig: setConfig
  };
  setup();
  return instance;
}

BaseURLController.__dashjs_factory_name = 'BaseURLController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__["default"].getClassFactory(BaseURLController));

/***/ }),

/***/ "./src/streaming/controllers/BlacklistController.js":
/*!**********************************************************!*\
  !*** ./src/streaming/controllers/BlacklistController.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1400869__) {

"use strict";
__nested_webpack_require_1400869__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1400869__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1400869__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function BlackListController(config) {
  config = config || {};
  var instance;
  var blacklist = [];
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(this.context).getInstance();
  var updateEventName = config.updateEventName;
  var addBlacklistEventName = config.addBlacklistEventName;

  function contains(query) {
    if (!blacklist.length || !query || !query.length) {
      return false;
    }

    return blacklist.indexOf(query) !== -1;
  }

  function add(entry) {
    if (blacklist.indexOf(entry) !== -1) {
      return;
    }

    blacklist.push(entry);
    eventBus.trigger(updateEventName, {
      entry: entry
    });
  }

  function onAddBlackList(e) {
    add(e.entry);
  }

  function setup() {
    if (addBlacklistEventName) {
      eventBus.on(addBlacklistEventName, onAddBlackList, instance);
    }
  }

  function reset() {
    blacklist = [];
  }

  instance = {
    add: add,
    contains: contains,
    reset: reset
  };
  setup();
  return instance;
}

BlackListController.__dashjs_factory_name = 'BlackListController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(BlackListController));

/***/ }),

/***/ "./src/streaming/controllers/BufferController.js":
/*!*******************************************************!*\
  !*** ./src/streaming/controllers/BufferController.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1404755__) {

"use strict";
__nested_webpack_require_1404755__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1404755__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1404755__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1404755__(/*! ../models/FragmentModel */ "./src/streaming/models/FragmentModel.js");
/* harmony import */ var _SourceBufferSink__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1404755__(/*! ../SourceBufferSink */ "./src/streaming/SourceBufferSink.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1404755__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1404755__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1404755__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1404755__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _utils_InitCache__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1404755__(/*! ../utils/InitCache */ "./src/streaming/utils/InitCache.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1404755__(/*! ../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1404755__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1404755__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1404755__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */













var BUFFER_END_THRESHOLD = 0.5;
var BUFFER_RANGE_CALCULATION_THRESHOLD = 0.01;
var QUOTA_EXCEEDED_ERROR_CODE = 22;
var BUFFER_CONTROLLER_TYPE = 'BufferController';

function BufferController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var errHandler = config.errHandler;
  var fragmentModel = config.fragmentModel;
  var representationController = config.representationController;
  var adapter = config.adapter;
  var textController = config.textController;
  var abrController = config.abrController;
  var playbackController = config.playbackController;
  var streamInfo = config.streamInfo;
  var type = config.type;
  var settings = config.settings;
  var instance, logger, isBufferingCompleted, bufferLevel, criticalBufferLevel, mediaSource, maxAppendedIndex, maximumIndex, sourceBufferSink, bufferState, appendedBytesInfo, wallclockTicked, isPruningInProgress, isQuotaExceeded, initCache, pendingPruningRanges, replacingBuffer, seekTarget;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance().getLogger(instance);
    initCache = Object(_utils_InitCache__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
    resetInitialSettings();
  }
  /**
   * Initialize the BufferController. Sets the media source and registers the event handlers.
   * @param {object} mediaSource
   */


  function initialize(mediaSource) {
    setMediaSource(mediaSource);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].INIT_FRAGMENT_LOADED, _onInitFragmentLoaded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].WALLCLOCK_TIME_UPDATED, _onWallclockTimeUpdated, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_PLAYING, _onPlaybackPlaying, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_PROGRESS, _onPlaybackProgression, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackProgression, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_STALLED, _onPlaybackStalled, instance);
  }
  /**
   * Returns the stream id
   * @return {string}
   */


  function getStreamId() {
    return streamInfo.id;
  }
  /**
   * Returns the media type
   * @return {type}
   */


  function getType() {
    return type;
  }
  /**
   * Returns the type of the BufferController. We distinguish between standard buffer controllers and buffer controllers related to texttracks.
   * @return {string}
   */


  function getBufferControllerType() {
    return BUFFER_CONTROLLER_TYPE;
  }
  /**
   * Sets the mediasource.
   * @param {object} value
   */


  function setMediaSource(value) {
    mediaSource = value;
  }
  /**
   * Get the RepresentationInfo for a certain quality.
   * @param {number} quality
   * @return {object}
   * @private
   */


  function _getRepresentationInfo(quality) {
    return adapter.convertRepresentationToRepresentationInfo(representationController.getRepresentationForQuality(quality));
  }
  /**
   * Creates a SourceBufferSink object
   * @param {object} mediaInfo
   * @param {array} oldBufferSinks
   * @return {object|null} SourceBufferSink
   */


  function createBufferSink(mediaInfo) {
    var oldBufferSinks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return new Promise(function (resolve, reject) {
      if (!initCache || !mediaInfo || !mediaSource) {
        resolve(null);
        return;
      }

      var requiredQuality = abrController.getQualityFor(type, streamInfo.id);
      sourceBufferSink = Object(_SourceBufferSink__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
        mediaSource: mediaSource,
        textController: textController,
        eventBus: eventBus
      });

      _initializeSink(mediaInfo, oldBufferSinks, requiredQuality).then(function () {
        return updateBufferTimestampOffset(_getRepresentationInfo(requiredQuality));
      }).then(function () {
        resolve(sourceBufferSink);
      })["catch"](function (e) {
        logger.fatal('Caught error on create SourceBuffer: ' + e);
        errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_9__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_10__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + type));
        reject(e);
      });
    });
  }

  function _initializeSink(mediaInfo, oldBufferSinks, requiredQuality) {
    var selectedRepresentation = _getRepresentationInfo(requiredQuality);

    if (oldBufferSinks && oldBufferSinks[type] && (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO)) {
      return sourceBufferSink.initializeForStreamSwitch(mediaInfo, selectedRepresentation, oldBufferSinks[type]);
    } else {
      return sourceBufferSink.initializeForFirstUse(streamInfo, mediaInfo, selectedRepresentation);
    }
  }
  /**
   * Callback handler when init segment has been loaded. Based on settings, the init segment is saved to the cache, and appended to the buffer.
   * @param {object} e
   * @private
   */


  function _onInitFragmentLoaded(e) {
    if (settings.get().streaming.cacheInitSegments) {
      logger.info('Init fragment finished loading saving to', type + '\'s init cache');
      initCache.save(e.chunk);
    }

    logger.debug('Append Init fragment', type, ' with representationId:', e.chunk.representationId, ' and quality:', e.chunk.quality, ', data size:', e.chunk.bytes.byteLength);

    _appendToBuffer(e.chunk);
  }
  /**
   * Append the init segment for a certain representation to the buffer. If the init segment is cached we take the one from the cache. Otherwise the function returns false and the segment has to be requested again.
   * @param {string} representationId
   * @return {boolean}
   */


  function appendInitSegmentFromCache(representationId) {
    // Get init segment from cache
    var chunk = initCache.extract(streamInfo.id, representationId);

    if (!chunk) {
      // Init segment not in cache, shall be requested
      return false;
    } // Append init segment into buffer


    logger.info('Append Init fragment', type, ' with representationId:', chunk.representationId, ' and quality:', chunk.quality, ', data size:', chunk.bytes.byteLength);

    _appendToBuffer(chunk);

    return true;
  }
  /**
   * Calls the _appendToBuffer function to append the segment to the buffer. In case of a track switch the buffer might be cleared.
   * @param {object} e
   */


  function _onMediaFragmentLoaded(e) {
    _appendToBuffer(e.chunk, e.request);
  }
  /**
   * Append data to the MSE buffer using the SourceBufferSink
   * @param {object} chunk
   * @private
   */


  function _appendToBuffer(chunk) {
    var request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    sourceBufferSink.append(chunk, request).then(function (e) {
      _onAppended(e);
    })["catch"](function (e) {
      _onAppended(e);
    });

    if (chunk.mediaInfo.type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].VIDEO_CHUNK_RECEIVED, {
        chunk: chunk
      });
    }
  }

  function _showBufferRanges(ranges) {
    if (ranges && ranges.length > 0) {
      for (var i = 0, len = ranges.length; i < len; i++) {
        logger.debug('Buffered range: ' + ranges.start(i) + ' - ' + ranges.end(i) + ', currentTime = ', playbackController.getTime());
      }
    }
  }

  function _onAppended(e) {
    if (e.error) {
      // If we receive a QUOTA_EXCEEDED_ERROR_CODE we should adjust the target buffer times to avoid this error in the future.
      if (e.error.code === QUOTA_EXCEEDED_ERROR_CODE) {
        _handleQuotaExceededError();
      }

      if (e.error.code === QUOTA_EXCEEDED_ERROR_CODE || !hasEnoughSpaceToAppend()) {
        logger.warn('Clearing playback buffer to overcome quota exceed situation'); // Notify ScheduleController to stop scheduling until buffer has been pruned

        _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].QUOTA_EXCEEDED, {
          criticalBufferLevel: criticalBufferLevel,
          quotaExceededTime: e.chunk.start
        });

        clearBuffers(getClearRanges());
      }

      return;
    } // Check if session has not been stopped in the meantime (while last segment was being appended)


    if (!sourceBufferSink) return;

    _updateBufferLevel();

    isQuotaExceeded = false;
    appendedBytesInfo = e.chunk;

    if (!appendedBytesInfo || !appendedBytesInfo.endFragment) {
      return;
    }

    if (appendedBytesInfo && !isNaN(appendedBytesInfo.index)) {
      maxAppendedIndex = Math.max(appendedBytesInfo.index, maxAppendedIndex);

      _checkIfBufferingCompleted();
    }

    var ranges = sourceBufferSink.getAllBufferRanges();

    if (appendedBytesInfo.segmentType === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_11__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
      _showBufferRanges(ranges);

      _onPlaybackProgression();

      _adjustSeekTarget();
    }

    if (appendedBytesInfo) {
      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BYTES_APPENDED_END_FRAGMENT, {
        quality: appendedBytesInfo.quality,
        startTime: appendedBytesInfo.start,
        index: appendedBytesInfo.index,
        bufferedRanges: ranges,
        segmentType: appendedBytesInfo.segmentType,
        mediaType: type
      });
    }
  }
  /**
   * In some cases the segment we requested might start at a different time than we initially aimed for. segments timeline/template tolerance.
   * We might need to do an internal seek if there is drift.
   * @private
   */


  function _adjustSeekTarget() {
    if (isNaN(seekTarget)) return; // Check buffered data only for audio and video

    if (type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
      seekTarget = NaN;
      return;
    } // Check if current buffered range already contains seek target (and current video element time)


    var currentTime = playbackController.getTime();
    var rangeAtCurrenTime = getRangeAt(currentTime, 0);
    var rangeAtSeekTarget = getRangeAt(seekTarget, 0);

    if (rangeAtCurrenTime && rangeAtSeekTarget && rangeAtCurrenTime.start === rangeAtSeekTarget.start) {
      seekTarget = NaN;
      return;
    } // Get buffered range corresponding to the seek target


    var segmentDuration = representationController.getCurrentRepresentation().segmentDuration;
    var range = getRangeAt(seekTarget, segmentDuration);
    if (!range) return;

    if (settings.get().streaming.buffer.enableSeekDecorrelationFix && Math.abs(currentTime - seekTarget) > segmentDuration) {
      // If current video model time is decorrelated from seek target (and appended buffer) then seek video element
      // (in case of live streams on some browsers/devices for which we can't set video element time at unavalaible range)
      // Check if appended segment is not anterior from seek target (segments timeline/template tolerance)
      if (seekTarget <= range.end) {
        // Seek video element to seek target or range start if appended buffer starts after seek target (segments timeline/template tolerance)
        playbackController.seek(Math.max(seekTarget, range.start), false, true);
      }
    } else if (currentTime < range.start) {
      // If appended buffer starts after seek target (segments timeline/template tolerance) then seek to range start
      playbackController.seek(range.start, false, true);
    }
  }

  function _handleQuotaExceededError() {
    isQuotaExceeded = true;
    criticalBufferLevel = getTotalBufferedTime() * 0.8;
    logger.warn('Quota exceeded, Critical Buffer: ' + criticalBufferLevel);

    if (criticalBufferLevel > 0) {
      // recalculate buffer lengths according to criticalBufferLevel
      var bufferToKeep = Math.max(0.2 * criticalBufferLevel, 1);
      var bufferAhead = criticalBufferLevel - bufferToKeep;
      var bufferTimeAtTopQuality = Math.min(settings.get().streaming.buffer.bufferTimeAtTopQuality, bufferAhead * 0.9);
      var bufferTimeAtTopQualityLongForm = Math.min(settings.get().streaming.buffer.bufferTimeAtTopQualityLongForm, bufferAhead * 0.9);
      var s = {
        streaming: {
          buffer: {
            bufferToKeep: parseFloat(bufferToKeep.toFixed(5)),
            bufferTimeAtTopQuality: parseFloat(bufferTimeAtTopQuality.toFixed(5)),
            bufferTimeAtTopQualityLongForm: parseFloat(bufferTimeAtTopQualityLongForm.toFixed(5))
          }
        }
      };
      settings.update(s);
    }
  } //**********************************************************************
  // START Buffer Level, State & Sufficiency Handling.
  //**********************************************************************


  function prepareForPlaybackSeek() {
    if (isBufferingCompleted) {
      setIsBufferingCompleted(false);
    } // Abort the current request and empty all possible segments to be appended


    return sourceBufferSink.abort();
  }

  function prepareForReplacementTrackSwitch(codec) {
    return new Promise(function (resolve, reject) {
      sourceBufferSink.abort().then(function () {
        return updateAppendWindow();
      }).then(function () {
        return sourceBufferSink.changeType(codec);
      }).then(function () {
        return pruneAllSafely();
      }).then(function () {
        setIsBufferingCompleted(false);
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function prepareForReplacementQualitySwitch() {
    return new Promise(function (resolve, reject) {
      sourceBufferSink.abort().then(function () {
        return updateAppendWindow();
      }).then(function () {
        return pruneAllSafely();
      }).then(function () {
        setIsBufferingCompleted(false);
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function prepareForNonReplacementTrackSwitch(codec) {
    return new Promise(function (resolve, reject) {
      updateAppendWindow().then(function () {
        return sourceBufferSink.changeType(codec);
      }).then(function () {
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function pruneAllSafely() {
    return new Promise(function (resolve, reject) {
      var ranges = getAllRangesWithSafetyFactor();

      if (!ranges || ranges.length === 0) {
        _onPlaybackProgression();

        resolve();
        return;
      }

      clearBuffers(ranges).then(function () {
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function getAllRangesWithSafetyFactor(seekTime) {
    var clearRanges = [];
    var ranges = sourceBufferSink.getAllBufferRanges(); // no valid ranges

    if (!ranges || ranges.length === 0) {
      return clearRanges;
    } // if no target time is provided we clear everyhing


    if (!seekTime && seekTime !== 0 || isNaN(seekTime)) {
      clearRanges.push({
        start: ranges.start(0),
        end: ranges.end(ranges.length - 1) + BUFFER_END_THRESHOLD
      });
    } // otherwise we need to calculate the correct pruning range
    else {
        var behindPruningRange = _getRangeBehindForPruning(seekTime, ranges);

        var aheadPruningRange = _getRangeAheadForPruning(seekTime, ranges);

        if (behindPruningRange) {
          clearRanges.push(behindPruningRange);
        }

        if (aheadPruningRange) {
          clearRanges.push(aheadPruningRange);
        }
      }

    return clearRanges;
  }

  function _getRangeBehindForPruning(targetTime, ranges) {
    var bufferToKeepBehind = settings.get().streaming.buffer.bufferToKeep;
    var startOfBuffer = ranges.start(0); // if we do a seek ahead of the current play position we do need to prune behind the new play position

    var behindDiff = targetTime - startOfBuffer;

    if (behindDiff > bufferToKeepBehind) {
      var rangeEnd = Math.max(0, targetTime - bufferToKeepBehind); // Ensure we keep full range of current fragment

      var currentTimeRequest = fragmentModel.getRequests({
        state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__["default"].FRAGMENT_MODEL_EXECUTED,
        time: targetTime,
        threshold: BUFFER_RANGE_CALCULATION_THRESHOLD
      })[0];

      if (currentTimeRequest) {
        rangeEnd = Math.min(currentTimeRequest.startTime, rangeEnd);
      }

      if (rangeEnd > 0) {
        return {
          start: startOfBuffer,
          end: rangeEnd
        };
      }
    }

    return null;
  }

  function _getRangeAheadForPruning(targetTime, ranges) {
    // if we do a seek behind the current play position we do need to prune ahead of the new play position
    var endOfBuffer = ranges.end(ranges.length - 1) + BUFFER_END_THRESHOLD;
    var isLongFormContent = streamInfo.manifestInfo.duration >= settings.get().streaming.buffer.longFormContentDurationThreshold;
    var bufferToKeepAhead = isLongFormContent ? settings.get().streaming.buffer.bufferTimeAtTopQualityLongForm : settings.get().streaming.buffer.bufferTimeAtTopQuality;
    var aheadDiff = endOfBuffer - targetTime;

    if (aheadDiff > bufferToKeepAhead) {
      var rangeStart = targetTime + bufferToKeepAhead; // Ensure we keep full range of current fragment

      var currentTimeRequest = fragmentModel.getRequests({
        state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__["default"].FRAGMENT_MODEL_EXECUTED,
        time: targetTime,
        threshold: BUFFER_RANGE_CALCULATION_THRESHOLD
      })[0];

      if (currentTimeRequest) {
        rangeStart = Math.max(currentTimeRequest.startTime + currentTimeRequest.duration, rangeStart);
      }

      if (rangeStart < endOfBuffer) {
        return {
          start: rangeStart,
          end: endOfBuffer
        };
      }
    }

    return null;
  }

  function _onPlaybackProgression() {
    if (!replacingBuffer || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && textController.isTextEnabled()) {
      _updateBufferLevel();
    }
  }

  function _onPlaybackStalled() {
    checkIfSufficientBuffer();
  }

  function _onPlaybackPlaying() {
    checkIfSufficientBuffer();
    seekTarget = NaN;
  }

  function getRangeAt(time, tolerance) {
    var ranges = sourceBufferSink.getAllBufferRanges();
    var start = 0;
    var end = 0;
    var firstStart = null;
    var lastEnd = null;
    var gap = 0;
    var len, i;
    var toler = !isNaN(tolerance) ? tolerance : 0.15;

    if (ranges !== null && ranges !== undefined) {
      for (i = 0, len = ranges.length; i < len; i++) {
        start = ranges.start(i);
        end = ranges.end(i);

        if (firstStart === null) {
          gap = Math.abs(start - time);

          if (time >= start && time < end) {
            // start the range
            firstStart = start;
            lastEnd = end;
          } else if (gap <= toler) {
            // start the range even though the buffer does not contain time 0
            firstStart = start;
            lastEnd = end;
          }
        } else {
          gap = start - lastEnd;

          if (gap <= toler) {
            // the discontinuity is smaller than the tolerance, combine the ranges
            lastEnd = end;
          } else {
            break;
          }
        }
      }

      if (firstStart !== null) {
        return {
          start: firstStart,
          end: lastEnd
        };
      }
    }

    return null;
  }

  function getBufferLength(time, tolerance) {
    var range, length; // Consider gap/discontinuity limit as tolerance

    if (settings.get().streaming.gaps.jumpGaps) {
      tolerance = settings.get().streaming.gaps.smallGapLimit;
    }

    range = getRangeAt(time, tolerance);

    if (range === null) {
      length = 0;
    } else {
      length = range.end - time;
    }

    return length;
  }

  function _updateBufferLevel() {
    if (playbackController) {
      var tolerance = settings.get().streaming.gaps.jumpGaps && !isNaN(settings.get().streaming.gaps.smallGapLimit) ? settings.get().streaming.gaps.smallGapLimit : NaN;
      bufferLevel = Math.max(getBufferLength(playbackController.getTime() || 0, tolerance), 0);

      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_LEVEL_UPDATED, {
        mediaType: type,
        bufferLevel: bufferLevel
      });

      checkIfSufficientBuffer();
    }
  }

  function _checkIfBufferingCompleted() {
    var isLastIdxAppended = maxAppendedIndex >= maximumIndex - 1; // Handles 0 and non 0 based request index

    var periodBuffered = playbackController.getTimeToStreamEnd(streamInfo) - bufferLevel <= 0;

    if ((isLastIdxAppended || periodBuffered) && !isBufferingCompleted) {
      setIsBufferingCompleted(true);
      logger.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(streamInfo.id, " and type ").concat(type));
    }
  }

  function checkIfSufficientBuffer() {
    // No need to check buffer if type is not audio or video (for example if several errors occur during text parsing, so that the buffer cannot be filled, no error must occur on video playback)
    if (type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) return; // When the player is working in low latency mode, the buffer is often below STALL_THRESHOLD.
    // So, when in low latency mode, change dash.js behavior so it notifies a stall just when
    // buffer reach 0 seconds

    if ((!playbackController.getLowLatencyModeEnabled() && bufferLevel < settings.get().streaming.buffer.stallThreshold || bufferLevel === 0) && !isBufferingCompleted) {
      _notifyBufferStateChanged(_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_EMPTY);
    } else {
      if (isBufferingCompleted || bufferLevel >= settings.get().streaming.buffer.stallThreshold || playbackController.getLowLatencyModeEnabled() && bufferLevel > 0) {
        _notifyBufferStateChanged(_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LOADED);
      }
    }
  }

  function _notifyBufferStateChanged(state) {
    if (bufferState === state || state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_EMPTY && playbackController.getTime() === 0 || // Don't trigger BUFFER_EMPTY if it's initial loading
    type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && !textController.isTextEnabled()) {
      return;
    }

    bufferState = state;

    _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_LEVEL_STATE_CHANGED, {
      state: state
    });

    _triggerEvent(state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LOADED ? _core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_LOADED : _core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_EMPTY);

    logger.debug(state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LOADED ? 'Got enough buffer to start' : 'Waiting for more buffer before starting playback');
  }
  /* prune buffer on our own in background to avoid browsers pruning buffer silently */


  function pruneBuffer() {
    if (!sourceBufferSink || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
      return;
    }

    if (!isBufferingCompleted) {
      clearBuffers(getClearRanges());
    }
  }

  function getClearRanges() {
    var clearRanges = [];
    var ranges = sourceBufferSink.getAllBufferRanges();

    if (!ranges || ranges.length === 0) {
      return clearRanges;
    }

    var currentTime = playbackController.getTime();
    var startRangeToKeep = Math.max(0, currentTime - settings.get().streaming.buffer.bufferToKeep);
    var currentTimeRequest = fragmentModel.getRequests({
      state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__["default"].FRAGMENT_MODEL_EXECUTED,
      time: currentTime,
      threshold: BUFFER_RANGE_CALCULATION_THRESHOLD
    })[0]; // Ensure we keep full range of current fragment

    if (currentTimeRequest) {
      startRangeToKeep = Math.min(currentTimeRequest.startTime, startRangeToKeep);
    } else if (currentTime === 0 && playbackController.getIsDynamic()) {
      // Don't prune before the live stream starts, it messes with low latency
      return [];
    }

    if (ranges.start(0) <= startRangeToKeep) {
      var behindRange = {
        start: 0,
        end: startRangeToKeep
      };

      for (var i = 0; i < ranges.length && ranges.end(i) <= startRangeToKeep; i++) {
        behindRange.end = ranges.end(i);
      }

      if (behindRange.start < behindRange.end) {
        clearRanges.push(behindRange);
      }
    }

    return clearRanges;
  }

  function clearBuffers(ranges) {
    return new Promise(function (resolve, reject) {
      if (!ranges || !sourceBufferSink || ranges.length === 0) {
        resolve();
        return;
      }

      var promises = [];
      ranges.forEach(function (range) {
        promises.push(_addClearRangeWithPromise(range));
      });

      if (!isPruningInProgress) {
        clearNextRange();
      }

      Promise.all(promises).then(function () {
        resolve();
      })["catch"](function (e) {
        reject(e);
      });
    });
  }

  function _addClearRangeWithPromise(range) {
    return new Promise(function (resolve, reject) {
      range.resolve = resolve;
      range.reject = reject;
      pendingPruningRanges.push(range);
    });
  }

  function clearNextRange() {
    try {
      // If there's nothing to prune reset state
      if (pendingPruningRanges.length === 0 || !sourceBufferSink) {
        logger.debug('Nothing to prune, halt pruning');
        pendingPruningRanges = [];
        isPruningInProgress = false;
        return;
      }

      var sourceBuffer = sourceBufferSink.getBuffer(); // If there's nothing buffered any pruning is invalid, so reset our state

      if (!sourceBuffer || !sourceBuffer.buffered || sourceBuffer.buffered.length === 0) {
        logger.debug('SourceBuffer is empty (or does not exist), halt pruning');
        pendingPruningRanges = [];
        isPruningInProgress = false;
        return;
      }

      var range = pendingPruningRanges.shift();
      logger.debug("".concat(type, ": Removing buffer from: ").concat(range.start, " to ").concat(range.end));
      isPruningInProgress = true; // If removing buffer ahead current playback position, update maxAppendedIndex

      var currentTime = playbackController.getTime();

      if (currentTime < range.end) {
        setIsBufferingCompleted(false);
      }

      sourceBufferSink.remove(range).then(function (e) {
        _onRemoved(e);
      })["catch"](function (e) {
        _onRemoved(e);
      });
    } catch (e) {
      isPruningInProgress = false;
    }
  }

  function _onRemoved(e) {
    logger.debug('onRemoved buffer from:', e.from, 'to', e.to);
    var ranges = sourceBufferSink.getAllBufferRanges();

    _showBufferRanges(ranges);

    if (pendingPruningRanges.length === 0) {
      isPruningInProgress = false;

      _updateBufferLevel();
    }

    if (e.unintended) {
      logger.warn('Detected unintended removal from:', e.from, 'to', e.to, 'setting streamprocessor time to', e.from);

      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SEEK_TARGET, {
        time: e.from
      });
    }

    if (isPruningInProgress) {
      clearNextRange();
    } else {
      if (!replacingBuffer) {
        _updateBufferLevel();
      } else {
        replacingBuffer = false;
      }

      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_CLEARED, {
        from: e.from,
        to: e.to,
        unintended: e.unintended,
        hasEnoughSpaceToAppend: hasEnoughSpaceToAppend(),
        quotaExceeded: isQuotaExceeded
      });
    }
  }

  function updateBufferTimestampOffset(representationInfo) {
    return new Promise(function (resolve) {
      if (!representationInfo || representationInfo.MSETimeOffset === undefined || !sourceBufferSink || !sourceBufferSink.updateTimestampOffset) {
        resolve();
        return;
      } // Each track can have its own @presentationTimeOffset, so we should set the offset
      // if it has changed after switching the quality or updating an mpd


      sourceBufferSink.updateTimestampOffset(representationInfo.MSETimeOffset).then(function () {
        resolve();
      })["catch"](function () {
        resolve();
      });
    });
  }

  function updateAppendWindow() {
    if (sourceBufferSink && !isBufferingCompleted) {
      return sourceBufferSink.updateAppendWindow(streamInfo);
    }

    return Promise.resolve();
  }

  function segmentRequestingCompleted(segmentIndex) {
    if (!isNaN(segmentIndex)) {
      maximumIndex = segmentIndex;

      _checkIfBufferingCompleted();
    }
  }

  function _onWallclockTimeUpdated() {
    wallclockTicked++;
    var secondsElapsed = wallclockTicked * (settings.get().streaming.wallclockTimeUpdateInterval / 1000);

    if (secondsElapsed >= settings.get().streaming.buffer.bufferPruningInterval) {
      wallclockTicked = 0;
      pruneBuffer();
    }
  }

  function _onPlaybackRateChanged() {
    checkIfSufficientBuffer();
  }

  function getBuffer() {
    return sourceBufferSink;
  }

  function getBufferLevel() {
    return bufferLevel;
  }

  function getMediaSource() {
    return mediaSource;
  }

  function getIsBufferingCompleted() {
    return isBufferingCompleted;
  }

  function setIsBufferingCompleted(value) {
    if (isBufferingCompleted === value) {
      return;
    }

    isBufferingCompleted = value;

    if (isBufferingCompleted) {
      _triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFERING_COMPLETED);
    } else {
      maximumIndex = Number.POSITIVE_INFINITY;
    }
  }

  function getIsPruningInProgress() {
    return isPruningInProgress;
  }

  function getTotalBufferedTime() {
    try {
      var ranges = sourceBufferSink.getAllBufferRanges();
      var totalBufferedTime = 0;
      var ln, i;
      if (!ranges) return totalBufferedTime;

      for (i = 0, ln = ranges.length; i < ln; i++) {
        totalBufferedTime += ranges.end(i) - ranges.start(i);
      }

      return totalBufferedTime;
    } catch (e) {
      return 0;
    }
  }
  /**
   * This function returns the maximum time for which the buffer is continuous starting from a target time.
   * As soon as there is a gap we return the time before the gap starts
   * @param {number} targetTime
   */


  function getContinuousBufferTimeForTargetTime(targetTime) {
    try {
      var adjustedTime = targetTime;
      var ranges = sourceBufferSink.getAllBufferRanges();

      if (!ranges || ranges.length === 0) {
        return NaN;
      }

      var i = 0;

      while (adjustedTime === targetTime && i < ranges.length) {
        var start = ranges.start(i);
        var end = ranges.end(i);

        if (adjustedTime >= start && adjustedTime <= end) {
          adjustedTime = end;
        }

        i += 1;
      }

      return adjustedTime === targetTime ? NaN : adjustedTime;
    } catch (e) {}
  }

  function hasEnoughSpaceToAppend() {
    var totalBufferedTime = getTotalBufferedTime();
    return isNaN(totalBufferedTime) || totalBufferedTime < criticalBufferLevel;
  }

  function setSeekTarget(value) {
    seekTarget = value;
  }

  function _triggerEvent(eventType, data) {
    var payload = data || {};
    eventBus.trigger(eventType, payload, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function resetInitialSettings(errored, keepBuffers) {
    criticalBufferLevel = Number.POSITIVE_INFINITY;
    bufferState = undefined;
    maximumIndex = Number.POSITIVE_INFINITY;
    maxAppendedIndex = 0;
    appendedBytesInfo = null;
    isBufferingCompleted = false;
    isPruningInProgress = false;
    isQuotaExceeded = false;
    bufferLevel = 0;
    wallclockTicked = 0;
    pendingPruningRanges = [];
    seekTarget = NaN;

    if (sourceBufferSink) {
      var tmpSourceBufferSinkToReset = sourceBufferSink;
      sourceBufferSink = null;

      if (!errored && !keepBuffers) {
        tmpSourceBufferSinkToReset.abort().then(function () {
          tmpSourceBufferSinkToReset.reset(keepBuffers);
          tmpSourceBufferSinkToReset = null;
        });
      }
    }

    replacingBuffer = false;
  }

  function reset(errored, keepBuffers) {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].INIT_FRAGMENT_LOADED, _onInitFragmentLoaded, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].WALLCLOCK_TIME_UPDATED, _onWallclockTimeUpdated, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_PLAYING, _onPlaybackPlaying, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_PROGRESS, _onPlaybackProgression, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackProgression, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, this);
    eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_12__["default"].PLAYBACK_STALLED, _onPlaybackStalled, this);
    resetInitialSettings(errored, keepBuffers);
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    getType: getType,
    getBufferControllerType: getBufferControllerType,
    createBufferSink: createBufferSink,
    getBuffer: getBuffer,
    getBufferLevel: getBufferLevel,
    getRangeAt: getRangeAt,
    setMediaSource: setMediaSource,
    getMediaSource: getMediaSource,
    appendInitSegmentFromCache: appendInitSegmentFromCache,
    getIsBufferingCompleted: getIsBufferingCompleted,
    setIsBufferingCompleted: setIsBufferingCompleted,
    getIsPruningInProgress: getIsPruningInProgress,
    reset: reset,
    prepareForPlaybackSeek: prepareForPlaybackSeek,
    prepareForReplacementTrackSwitch: prepareForReplacementTrackSwitch,
    prepareForNonReplacementTrackSwitch: prepareForNonReplacementTrackSwitch,
    prepareForReplacementQualitySwitch: prepareForReplacementQualitySwitch,
    updateAppendWindow: updateAppendWindow,
    getAllRangesWithSafetyFactor: getAllRangesWithSafetyFactor,
    getContinuousBufferTimeForTargetTime: getContinuousBufferTimeForTargetTime,
    clearBuffers: clearBuffers,
    pruneAllSafely: pruneAllSafely,
    updateBufferTimestampOffset: updateBufferTimestampOffset,
    setSeekTarget: setSeekTarget,
    segmentRequestingCompleted: segmentRequestingCompleted
  };
  setup();
  return instance;
}

BufferController.__dashjs_factory_name = BUFFER_CONTROLLER_TYPE;
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__["default"].getClassFactory(BufferController));

/***/ }),

/***/ "./src/streaming/controllers/CatchupController.js":
/*!********************************************************!*\
  !*** ./src/streaming/controllers/CatchupController.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1446344__) {

"use strict";
__nested_webpack_require_1446344__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1446344__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1446344__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1446344__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1446344__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1446344__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1446344__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1446344__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








function CatchupController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var instance, isCatchupSeekInProgress, minPlaybackRateChange, videoModel, settings, streamController, playbackController, mediaPlayerModel, dashMetrics, playbackStalled, logger;

  function initialize() {
    _registerEvents();
  }

  function setConfig(config) {
    if (!config) {
      return;
    }

    if (config.settings) {
      settings = config.settings;
    }

    if (config.videoModel) {
      videoModel = config.videoModel;
    }

    if (config.streamController) {
      streamController = config.streamController;
    }

    if (config.playbackController) {
      playbackController = config.playbackController;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.mediaPlayerModel) {
      mediaPlayerModel = config.mediaPlayerModel;
    }
  }

  function _registerEvents() {
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].BUFFER_LEVEL_UPDATED, _onBufferLevelUpdated, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_PROGRESS, _onPlaybackProgression, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackProgression, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_SEEKED, _onPlaybackSeeked, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_CATCHUP_ENABLED, _onCatchupSettingUpdated, instance);
  }

  function _unregisterEvents() {
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].BUFFER_LEVEL_UPDATED, _onBufferLevelUpdated, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_PROGRESS, _onPlaybackProgression, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackProgression, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_4__["default"].PLAYBACK_SEEKED, _onPlaybackProgression, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_CATCHUP_ENABLED, _onCatchupSettingUpdated, instance);
  }

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);

    _resetInitialSettings();
  }

  function reset() {
    _unregisterEvents();

    _resetInitialSettings();

    videoModel.setPlaybackRate(1.0, true);
  }

  function _resetInitialSettings() {
    isCatchupSeekInProgress = false; // Detect safari browser (special behavior for low latency streams)

    var ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
    var isSafari = /safari/.test(ua) && !/chrome/.test(ua);
    minPlaybackRateChange = isSafari ? 0.25 : 0.02;
  }

  function _onPlaybackSeeked() {
    isCatchupSeekInProgress = false;
  }
  /**
   * When the buffer level updated we check if we can remove the stalled state
   * @param {object} e
   * @private
   */


  function _onBufferLevelUpdated(e) {
    // do not stop when getting an event from Stream that is not active
    if (e.streamId !== streamController.getActiveStreamInfo().id || !playbackStalled) {
      return;
    } // we remove the stalled state once we reach a certain buffer level


    var liveDelay = playbackController.getLiveDelay();
    var bufferLevel = playbackController.getBufferLevel();

    if (bufferLevel > liveDelay / 2) {
      playbackStalled = false;
    }
  }
  /**
   * When the buffer state changed to BUFFER_EMPTY we update the stalled state
   * @param {object} e
   * @private
   */


  function _onBufferLevelStateChanged(e) {
    // do not stop when getting an event from Stream that is not active
    if (e.streamId !== streamController.getActiveStreamInfo().id) {
      return;
    }

    playbackStalled = e.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFER_EMPTY;
  }
  /**
   * If the catchup mode is disabled in the settings we reset playback rate to 1.0
   * @private
   */


  function _onCatchupSettingUpdated() {
    if (!mediaPlayerModel.getCatchupModeEnabled()) {
      videoModel.setPlaybackRate(1.0);
    }
  }
  /**
   * While playback is progressing we check if we need to start or stop the catchup mechanism to reach the target latency
   * @private
   */


  function _onPlaybackProgression() {
    if (playbackController.getIsDynamic() && mediaPlayerModel.getCatchupModeEnabled() && mediaPlayerModel.getCatchupPlaybackRate() > 0 && !playbackController.isPaused() && !playbackController.isSeeking() && _shouldStartCatchUp()) {
      _startPlaybackCatchUp();
    }
  }
  /**
   * Apply catchup mode. We either seek back to the target live edge or increase the playback rate.
   */


  function _startPlaybackCatchUp() {
    // we are seeking dont do anything for now
    if (isCatchupSeekInProgress) {
      return;
    }

    if (videoModel) {
      var newRate;
      var currentPlaybackRate = videoModel.getPlaybackRate();
      var liveCatchupPlaybackRate = mediaPlayerModel.getCatchupPlaybackRate();
      var bufferLevel = playbackController.getBufferLevel();

      var deltaLatency = _getLatencyDrift(); // we reached the maxDrift. Do a seek


      var maxDrift = mediaPlayerModel.getCatchupMaxDrift();

      if (!isNaN(maxDrift) && maxDrift > 0 && deltaLatency > maxDrift) {
        logger.info('[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point');
        isCatchupSeekInProgress = true;

        _seekToLive();
      } // try to reach the target latency by adjusting the playback rate
      else {
          var currentLiveLatency = playbackController.getCurrentLiveLatency();
          var targetLiveDelay = playbackController.getLiveDelay();

          if (_getCatchupMode() === _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_LOLP) {
            // Custom playback control: Based on buffer level
            var playbackBufferMin = settings.get().streaming.liveCatchup.playbackBufferMin;
            newRate = _calculateNewPlaybackRateLolP(liveCatchupPlaybackRate, currentLiveLatency, targetLiveDelay, playbackBufferMin, bufferLevel, currentPlaybackRate);
          } else {
            // Default playback control: Based on target and current latency
            newRate = _calculateNewPlaybackRateDefault(liveCatchupPlaybackRate, currentLiveLatency, targetLiveDelay, bufferLevel, currentPlaybackRate);
          } // Obtain newRate and apply to video model


          if (newRate) {
            // non-null
            logger.debug("[CatchupController]: Setting playback rate to ".concat(newRate));
            videoModel.setPlaybackRate(newRate);
          }
        }
    }
  }
  /**
   * Calculates the drift between the current latency and the target latency
   * @return {number}
   * @private
   */


  function _getLatencyDrift() {
    var currentLiveLatency = playbackController.getCurrentLiveLatency();
    var targetLiveDelay = playbackController.getLiveDelay();
    return currentLiveLatency - targetLiveDelay;
  }
  /**
   * Checks whether the catchup mechanism should be enabled. We use different subfunctions here depending on the catchup mode.
   * @return {boolean}
   */


  function _shouldStartCatchUp() {
    try {
      var latencyThreshold = mediaPlayerModel.getLiveCatchupLatencyThreshold();

      if (!playbackController.getTime() > 0 || isCatchupSeekInProgress || !isNaN(latencyThreshold) && playbackController.getCurrentLiveLatency() >= latencyThreshold) {
        return false;
      }

      var catchupMode = _getCatchupMode();

      if (catchupMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_LOLP) {
        var currentBuffer = playbackController.getBufferLevel();
        var playbackBufferMin = settings.get().streaming.liveCatchup.playbackBufferMin;
        return _lolpNeedToCatchUpCustom(currentBuffer, playbackBufferMin);
      } else {
        return _defaultNeedToCatchUp();
      }
    } catch (e) {
      return false;
    }
  }
  /**
   * Returns the mode for live playback catchup.
   * @return {String}
   * @private
   */


  function _getCatchupMode() {
    var playbackBufferMin = settings.get().streaming.liveCatchup.playbackBufferMin;
    return settings.get().streaming.liveCatchup.mode === _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_LOLP && playbackBufferMin !== null && !isNaN(playbackBufferMin) ? _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_LOLP : _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].LIVE_CATCHUP_MODE_DEFAULT;
  }
  /**
   * Default algorithm to determine if catchup mode should be enabled
   * @return {boolean}
   * @private
   */


  function _defaultNeedToCatchUp() {
    try {
      var latencyDrift = Math.abs(_getLatencyDrift());
      return latencyDrift > 0;
    } catch (e) {
      return false;
    }
  }
  /**
   * LoL+ logic to determine if catchup mode should be enabled
   * @param {number} currentBuffer
   * @param {number} playbackBufferMin
   * @return {boolean}
   * @private
   */


  function _lolpNeedToCatchUpCustom(currentBuffer, playbackBufferMin) {
    try {
      var latencyDrift = Math.abs(_getLatencyDrift());
      return latencyDrift > 0 || currentBuffer < playbackBufferMin;
    } catch (e) {
      return false;
    }
  }
  /**
   * Default algorithm to calculate the new playback rate
   * @param {number} liveCatchUpPlaybackRate
   * @param {number} currentLiveLatency
   * @param {number} liveDelay
   * @param {number} bufferLevel
   * @param {number} currentPlaybackRate
   * @return {number}
   * @private
   */


  function _calculateNewPlaybackRateDefault(liveCatchUpPlaybackRate, currentLiveLatency, liveDelay, bufferLevel, currentPlaybackRate) {
    // if we recently ran into an empty buffer we wait for the buffer to recover before applying a new rate
    if (playbackStalled) {
      return 1.0;
    }

    var cpr = liveCatchUpPlaybackRate;
    var deltaLatency = currentLiveLatency - liveDelay;
    var d = deltaLatency * 5; // Playback rate must be between (1 - cpr) - (1 + cpr)
    // ex: if cpr is 0.5, it can have values between 0.5 - 1.5

    var s = cpr * 2 / (1 + Math.pow(Math.E, -d));
    var newRate = 1 - cpr + s; // take into account situations in which there are buffer stalls,
    // in which increasing playbackRate to reach target latency will
    // just cause more and more stall situations

    if (playbackController.getPlaybackStalled()) {
      if (bufferLevel <= liveDelay / 2 && deltaLatency > 0) {
        newRate = 1.0;
      }
    } // don't change playbackrate for small variations (don't overload element with playbackrate changes)


    if (Math.abs(currentPlaybackRate - newRate) <= minPlaybackRateChange) {
      newRate = null;
    }

    return newRate;
  }
  /**
   * Lol+ algorithm to calculate the new playback rate
   * @param {number} liveCatchUpPlaybackRate
   * @param {number} currentLiveLatency
   * @param {number} liveDelay
   * @param {number} playbackBufferMin
   * @param {number} bufferLevel
   * @param {number} currentPlaybackRate
   * @return {number}
   * @private
   */


  function _calculateNewPlaybackRateLolP(liveCatchUpPlaybackRate, currentLiveLatency, liveDelay, playbackBufferMin, bufferLevel, currentPlaybackRate) {
    var cpr = liveCatchUpPlaybackRate;
    var newRate; // Hybrid: Buffer-based

    if (bufferLevel < playbackBufferMin) {
      // Buffer in danger, slow down
      var deltaBuffer = bufferLevel - playbackBufferMin; // -ve value

      var d = deltaBuffer * 5; // Playback rate must be between (1 - cpr) - (1 + cpr)
      // ex: if cpr is 0.5, it can have values between 0.5 - 1.5

      var s = cpr * 2 / (1 + Math.pow(Math.E, -d));
      newRate = 1 - cpr + s;
      logger.debug('[LoL+ playback control_buffer-based] bufferLevel: ' + bufferLevel + ', newRate: ' + newRate);
    } else {
      // Hybrid: Latency-based
      // Buffer is safe, vary playback rate based on latency
      // Check if latency is within range of target latency
      var minDifference = 0.02;

      if (Math.abs(currentLiveLatency - liveDelay) <= minDifference * liveDelay) {
        newRate = 1;
      } else {
        var deltaLatency = currentLiveLatency - liveDelay;

        var _d = deltaLatency * 5; // Playback rate must be between (1 - cpr) - (1 + cpr)
        // ex: if cpr is 0.5, it can have values between 0.5 - 1.5


        var _s = cpr * 2 / (1 + Math.pow(Math.E, -_d));

        newRate = 1 - cpr + _s;
      }

      logger.debug('[LoL+ playback control_latency-based] latency: ' + currentLiveLatency + ', newRate: ' + newRate);
    } // don't change playbackrate for small variations (don't overload element with playbackrate changes)


    if (Math.abs(currentPlaybackRate - newRate) <= minPlaybackRateChange) {
      newRate = null;
    }

    return newRate;
  }
  /**
   * Seek to live edge
   */


  function _seekToLive() {
    var type = streamController && streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_3__["default"].AUDIO;
    var DVRMetrics = dashMetrics.getCurrentDVRInfo(type);
    var DVRWindow = DVRMetrics ? DVRMetrics.range : null;

    if (DVRWindow && !isNaN(DVRWindow.end)) {
      playbackController.seek(DVRWindow.end - playbackController.getLiveDelay(), true, false);
    }
  }

  instance = {
    reset: reset,
    setConfig: setConfig,
    initialize: initialize
  };
  setup();
  return instance;
}

CatchupController.__dashjs_factory_name = 'CatchupController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(CatchupController));

/***/ }),

/***/ "./src/streaming/controllers/EventController.js":
/*!******************************************************!*\
  !*** ./src/streaming/controllers/EventController.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1464543__) {

"use strict";
__nested_webpack_require_1464543__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1464543__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1464543__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1464543__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1464543__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _net_XHRLoader__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1464543__(/*! ../net/XHRLoader */ "./src/streaming/net/XHRLoader.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function EventController() {
  var MPD_RELOAD_SCHEME = 'urn:mpeg:dash:event:2012';
  var MPD_RELOAD_VALUE = 1;
  var MPD_CALLBACK_SCHEME = 'urn:mpeg:dash:event:callback:2015';
  var MPD_CALLBACK_VALUE = 1;
  var REMAINING_EVENTS_THRESHOLD = 300;
  var EVENT_HANDLED_STATES = {
    DISCARDED: 'discarded',
    UPDATED: 'updated',
    ADDED: 'added'
  };
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var instance, logger, inlineEvents, // Holds all Inline Events not triggered yet
  inbandEvents, // Holds all Inband Events not triggered yet
  eventInterval, // variable holding the setInterval
  lastEventTimerCall, manifestUpdater, playbackController, settings, eventHandlingInProgress, isStarted;
  /**
   * Internal setup when class is instanced
   */

  function _setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);

    _resetInitialSettings();
  }
  /**
   * Checks if the provded configuration is valid
   */


  function checkConfig() {
    if (!manifestUpdater || !playbackController) {
      throw new Error('setConfig function has to be called previously');
    }
  }
  /**
   * Reset to initial settings
   */


  function _resetInitialSettings() {
    isStarted = false;
    inlineEvents = {}; // Format inlineEvents[schemeIdUri]

    inbandEvents = {}; // Format inlineEvents[schemeIdUri]

    eventInterval = null;
    eventHandlingInProgress = false;
    lastEventTimerCall = Date.now() / 1000;
  }
  /**
   * Stops the EventController by clearing the event interval
   */


  function _stop() {
    try {
      if (eventInterval !== null && isStarted) {
        clearInterval(eventInterval);
        eventInterval = null;
        isStarted = false;

        _onStopEventController();
      }
    } catch (e) {
      throw e;
    }
  }
  /**
   * Starts the interval function of the EventController
   */


  function start() {
    try {
      checkConfig();
      logger.debug('Start Event Controller');
      var refreshDelay = settings.get().streaming.eventControllerRefreshDelay;

      if (!isStarted && !isNaN(refreshDelay)) {
        isStarted = true;
        eventInterval = setInterval(_onEventTimer, refreshDelay);
      }
    } catch (e) {
      throw e;
    }
  }
  /**
   * Add MPD events to the list of events.
   * Events that are not in the MPD anymore but not triggered yet will still be deleted.
   * Existing events might get updated.
   * @param {Array.<Object>} values
   */


  function addInlineEvents(values) {
    try {
      checkConfig();

      if (values) {
        for (var i = 0; i < values.length; i++) {
          var event = values[i];

          var result = _addOrUpdateEvent(event, inlineEvents, true);

          if (result === EVENT_HANDLED_STATES.ADDED) {
            logger.debug("Added inline event with id ".concat(event.id)); // If we see the event for the first time we trigger it in onReceive mode

            _startEvent(event, values, _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_RECEIVE);
          } else if (result === EVENT_HANDLED_STATES.UPDATED) {
            logger.debug("Updated inline event with id ".concat(event.id));
          }
        }
      }
    } catch (e) {
      throw e;
    }
  }
  /**
   * Add EMSG events to the list of events
   * Messages with the same id within the scope of the same scheme_id_uri and value pair are equivalent , i.e. processing of any one event message box with the same id is sufficient.
   * @param {Array.<Object>} values
   */


  function addInbandEvents(values) {
    try {
      checkConfig();

      for (var i = 0; i < values.length; i++) {
        var event = values[i];

        var result = _addOrUpdateEvent(event, inbandEvents, false);

        if (result === EVENT_HANDLED_STATES.ADDED) {
          if (event.eventStream.schemeIdUri === MPD_RELOAD_SCHEME && inbandEvents[event.id] === undefined) {
            _handleManifestReloadEvent(event);
          }

          logger.debug('Added inband event with id ' + event.id);

          _startEvent(event, values, _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_RECEIVE);
        } else {
          logger.debug("Inband event with scheme_id_uri ".concat(event.eventStream.schemeIdUri, ", value ").concat(event.eventStream.value, " and id ").concat(event.id, " was ignored because it has been added before."));
        }
      }

      _onEventTimer();
    } catch (e) {
      throw e;
    }
  }
  /**
   * Adds or updates an event to/in the list of events
   * @param {object} event
   * @param {object} events
   * @param {boolean} shouldOverwriteExistingEvents
   * @return {string}
   * @private
   */


  function _addOrUpdateEvent(event, events) {
    var shouldOverwriteExistingEvents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var schemeIdUri = event.eventStream.schemeIdUri;
    var value = event.eventStream.value;
    var id = event.id;
    var eventState = EVENT_HANDLED_STATES.DISCARDED;

    if (!events[schemeIdUri]) {
      events[schemeIdUri] = [];
    }

    var indexOfExistingEvent = events[schemeIdUri].findIndex(function (e) {
      return (!value || e.eventStream.value && e.eventStream.value === value) && e.id === id;
    });

    if (indexOfExistingEvent === -1) {
      events[schemeIdUri].push(event);
      eventState = EVENT_HANDLED_STATES.ADDED;
    } else if (shouldOverwriteExistingEvents) {
      events[schemeIdUri][indexOfExistingEvent] = event;
      eventState = EVENT_HANDLED_STATES.UPDATED;
    }

    return eventState;
  }
  /**
   * Triggers an MPD reload
   * @param {object} event
   * @private
   */


  function _handleManifestReloadEvent(event) {
    try {
      if (event.eventStream.value == MPD_RELOAD_VALUE) {
        var validUntil = event.calculatedPresentationTime;
        var newDuration;

        if (event.calculatedPresentationTime == 0xFFFFFFFF) {
          //0xFF... means remaining duration unknown
          newDuration = NaN;
        } else {
          newDuration = event.calculatedPresentationTime + event.duration;
        } //logger.info('Manifest validity changed: Valid until: ' + validUntil + '; remaining duration: ' + newDuration);


        eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].MANIFEST_VALIDITY_CHANGED, {
          id: event.id,
          validUntil: validUntil,
          newDuration: newDuration,
          newManifestValidAfter: NaN //event.message_data - this is an arraybuffer with a timestring in it, but not used yet

        }, {
          mode: _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_START
        });
      }
    } catch (e) {}
  }
  /**
   * Iterate through the eventList and trigger the events
   */


  function _onEventTimer() {
    try {
      if (!eventHandlingInProgress) {
        eventHandlingInProgress = true;
        var currentVideoTime = playbackController.getTime();
        var presentationTimeThreshold = currentVideoTime - lastEventTimerCall; // For dynamic streams lastEventTimeCall will be large in the first iteration. Avoid firing all events at once.

        presentationTimeThreshold = lastEventTimerCall > 0 ? Math.max(0, presentationTimeThreshold) : 0;

        _triggerEvents(inbandEvents, presentationTimeThreshold, currentVideoTime);

        _triggerEvents(inlineEvents, presentationTimeThreshold, currentVideoTime);

        lastEventTimerCall = currentVideoTime;
        eventHandlingInProgress = false;
      }
    } catch (e) {
      eventHandlingInProgress = false;
    }
  }
  /**
   * When the EventController is stopped this callback is triggered. Starts the remaining events.
   * @private
   */


  function _onStopEventController() {
    try {
      // EventController might be stopped before the period is over. Before we stop the event controller we check for events that needs to be triggered at the period boundary.
      _triggerRemainingEvents(inbandEvents);

      _triggerRemainingEvents(inlineEvents);
    } catch (e) {}
  }
  /**
   * Iterate over a list of events and trigger the ones for which the presentation time is within the current timing interval
   * @param {object} events
   * @param {number} presentationTimeThreshold
   * @param {number} currentVideoTime
   * @private
   */


  function _triggerEvents(events, presentationTimeThreshold, currentVideoTime) {
    try {
      var callback = function callback(event) {
        if (event !== undefined) {
          var duration = !isNaN(event.duration) ? event.duration : 0; // The event is either about to start or has already been started and we are within its duration

          if (event.calculatedPresentationTime <= currentVideoTime && event.calculatedPresentationTime + presentationTimeThreshold + duration >= currentVideoTime) {
            _startEvent(event, events, _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_START);
          } else if (_eventHasExpired(currentVideoTime, duration + presentationTimeThreshold, event.calculatedPresentationTime) || _eventIsInvalid(event)) {
            logger.debug("Deleting event ".concat(event.id, " as it is expired or invalid"));

            _removeEvent(events, event);
          }
        }
      };

      _iterateAndTriggerCallback(events, callback);
    } catch (e) {}
  }
  /**
   * Triggers the remaining events after the EventController has been stopped
   * @param {object} events
   * @private
   */


  function _triggerRemainingEvents(events) {
    try {
      var currentTime = playbackController.getTime();

      var callback = function callback(event) {
        var periodDuration = event.eventStream && event.eventStream.period && !isNaN(event.eventStream.period.duration) ? event.eventStream.period.duration : NaN;
        var periodStart = event.eventStream && event.eventStream.period && !isNaN(event.eventStream.period.start) ? event.eventStream.period.start : NaN;

        if (isNaN(periodDuration) || isNaN(periodStart)) {
          return;
        }

        var calculatedPresentationTimeInSeconds = event.calculatedPresentationTime;

        if (Math.abs(calculatedPresentationTimeInSeconds - currentTime) < REMAINING_EVENTS_THRESHOLD) {
          _startEvent(event, events, _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_START);
        }
      };

      _iterateAndTriggerCallback(events, callback);
    } catch (e) {}
  }
  /**
   * Iterates over the inline/inband event object and triggers a callback for each event
   * @param {object} events
   * @param {function} callback
   * @private
   */


  function _iterateAndTriggerCallback(events, callback) {
    try {
      if (events) {
        var schemeIdUris = Object.keys(events);

        for (var i = 0; i < schemeIdUris.length; i++) {
          var schemeIdEvents = events[schemeIdUris[i]];
          schemeIdEvents.forEach(function (event) {
            if (event !== undefined) {
              callback(event);
            }
          });
        }
      }
    } catch (e) {}
  }
  /**
   * Checks if an event is expired. For instance if the presentationTime + the duration of an event are smaller than the current video time.
   * @param {number} currentVideoTime
   * @param {number} threshold
   * @param {number} calculatedPresentationTimeInSeconds
   * @return {boolean}
   * @private
   */


  function _eventHasExpired(currentVideoTime, threshold, calculatedPresentationTimeInSeconds) {
    try {
      return currentVideoTime - threshold > calculatedPresentationTimeInSeconds;
    } catch (e) {
      return false;
    }
  }
  /**
   * Checks if an event is invalid. This is the case if the end time of the parent period is smaller than the presentation time of the event.
   * @param {object} event
   * @return {boolean}
   * @private
   */


  function _eventIsInvalid(event) {
    try {
      var periodEndTime = event.eventStream.period.start + event.eventStream.period.duration;
      return event.calculatedPresentationTime > periodEndTime;
    } catch (e) {
      return false;
    }
  }
  /**
   * Starts an event. Depending on the schemeIdUri we distinguis between
   * - MPD Reload events
   * - MPD Callback events
   * - Events to be dispatched to the application
   * Events should be removed from the list before beeing triggered. Otherwise the event handler might cause an error and the remove function will not be called.
   * @param {object} event
   * @param {object} events
   * @param {String} mode
   * @private
   */


  function _startEvent(event, events, mode) {
    try {
      var currentVideoTime = playbackController.getTime();
      var eventId = event.id;

      if (mode === _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].EVENT_MODE_ON_RECEIVE) {
        logger.debug("Received event ".concat(eventId));
        eventBus.trigger(event.eventStream.schemeIdUri, {
          event: event
        }, {
          mode: mode
        });
        return;
      }

      if (event.eventStream.schemeIdUri === MPD_RELOAD_SCHEME && event.eventStream.value == MPD_RELOAD_VALUE) {
        if (event.duration !== 0 || event.presentationTimeDelta !== 0) {
          //If both are set to zero, it indicates the media is over at this point. Don't reload the manifest.
          logger.debug("Starting manifest refresh event ".concat(eventId, " at ").concat(currentVideoTime));

          _removeEvent(events, event);

          _refreshManifest();
        }
      } else if (event.eventStream.schemeIdUri === MPD_CALLBACK_SCHEME && event.eventStream.value == MPD_CALLBACK_VALUE) {
        logger.debug("Starting callback event ".concat(eventId, " at ").concat(currentVideoTime));

        _removeEvent(events, event);

        _sendCallbackRequest(event.messageData);
      } else {
        logger.debug("Starting event ".concat(eventId, " at ").concat(currentVideoTime));

        _removeEvent(events, event);

        eventBus.trigger(event.eventStream.schemeIdUri, {
          event: event
        }, {
          mode: mode
        });
      }
    } catch (e) {}
  }
  /**
   * Removes an event from the list. If this is the last event of type "schemeIdUri"  the corresponding schemeIdUri Object in the list of events is deleted.
   * @param {object} events
   * @param {object} event
   * @private
   */


  function _removeEvent(events, event) {
    var schemeIdUri = event.eventStream.schemeIdUri;
    var value = event.eventStream.value;
    var id = event.id;
    events[schemeIdUri] = events[schemeIdUri].filter(function (e) {
      return value && e.eventStream.value && e.eventStream.value !== value || e.id !== id;
    });

    if (events[schemeIdUri].length === 0) {
      delete events[schemeIdUri];
    }
  }
  /**
   * Refresh the manifest
   * @private
   */


  function _refreshManifest() {
    try {
      checkConfig();
      manifestUpdater.refreshManifest();
    } catch (e) {}
  }
  /**
   * Send a callback request
   * @param {String} url
   * @private
   */


  function _sendCallbackRequest(url) {
    try {
      var loader = Object(_net_XHRLoader__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({});
      loader.load({
        method: 'get',
        url: url,
        request: {
          responseType: 'arraybuffer'
        }
      });
    } catch (e) {
      throw e;
    }
  }
  /**
   * Set the config of the EventController
   * @param {object} config
   */


  function setConfig(config) {
    try {
      if (!config) {
        return;
      }

      if (config.manifestUpdater) {
        manifestUpdater = config.manifestUpdater;
      }

      if (config.playbackController) {
        playbackController = config.playbackController;
      }

      if (config.settings) {
        settings = config.settings;
      }
    } catch (e) {
      throw e;
    }
  }
  /**
   * Returns all inline events that have not been triggered yet
   * @return {object}
   */


  function getInlineEvents() {
    return inlineEvents;
  }
  /**
   * Returns all inband events that have not been triggered yet
   * @return {object}
   */


  function getInbandEvents() {
    return inbandEvents;
  }
  /**
   * Stop the EventController and reset all initial settings
   */


  function reset() {
    _stop();

    _resetInitialSettings();
  }

  instance = {
    addInlineEvents: addInlineEvents,
    addInbandEvents: addInbandEvents,
    getInbandEvents: getInbandEvents,
    getInlineEvents: getInlineEvents,
    start: start,
    setConfig: setConfig,
    reset: reset
  };

  _setup();

  return instance;
}

EventController.__dashjs_factory_name = 'EventController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(EventController));

/***/ }),

/***/ "./src/streaming/controllers/FragmentController.js":
/*!*********************************************************!*\
  !*** ./src/streaming/controllers/FragmentController.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1485148__) {

"use strict";
__nested_webpack_require_1485148__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1485148__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _vo_DataChunk__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1485148__(/*! ../vo/DataChunk */ "./src/streaming/vo/DataChunk.js");
/* harmony import */ var _models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1485148__(/*! ../models/FragmentModel */ "./src/streaming/models/FragmentModel.js");
/* harmony import */ var _FragmentLoader__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1485148__(/*! ../FragmentLoader */ "./src/streaming/FragmentLoader.js");
/* harmony import */ var _utils_RequestModifier__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1485148__(/*! ../utils/RequestModifier */ "./src/streaming/utils/RequestModifier.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1485148__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1485148__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1485148__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1485148__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1485148__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1485148__(/*! ../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */












function FragmentController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var errHandler = config.errHandler;
  var mediaPlayerModel = config.mediaPlayerModel;
  var dashMetrics = config.dashMetrics;
  var debug = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_10__["default"])(context).getInstance();
  var streamInfo = config.streamInfo;
  var instance, logger, fragmentModels;

  function setup() {
    logger = debug.getLogger(instance);
    resetInitialSettings();
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_PROGRESS, onFragmentLoadingCompleted, instance);
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getModel(type) {
    var model = fragmentModels[type];

    if (!model) {
      model = Object(_models_FragmentModel__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
        streamInfo: streamInfo,
        type: type,
        dashMetrics: dashMetrics,
        fragmentLoader: Object(_FragmentLoader__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
          dashMetrics: dashMetrics,
          mediaPlayerModel: mediaPlayerModel,
          errHandler: errHandler,
          requestModifier: Object(_utils_RequestModifier__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance(),
          settings: config.settings,
          boxParser: config.boxParser,
          eventBus: eventBus,
          events: _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"],
          errors: _core_errors_Errors__WEBPACK_IMPORTED_MODULE_8__["default"],
          dashConstants: config.dashConstants,
          urlUtils: config.urlUtils,
          streamId: getStreamId()
        }),
        debug: debug,
        eventBus: eventBus,
        events: _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"]
      });
      fragmentModels[type] = model;
    }

    return model;
  }

  function resetInitialSettings() {
    for (var model in fragmentModels) {
      fragmentModels[model].reset();
    }

    fragmentModels = {};
  }

  function reset() {
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, this);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_PROGRESS, onFragmentLoadingCompleted, this);
    resetInitialSettings();
  }

  function createDataChunk(bytes, request, streamId, endFragment) {
    var chunk = new _vo_DataChunk__WEBPACK_IMPORTED_MODULE_1__["default"]();
    chunk.streamId = streamId;
    chunk.mediaInfo = request.mediaInfo;
    chunk.segmentType = request.type;
    chunk.start = request.startTime;
    chunk.duration = request.duration;
    chunk.end = chunk.start + chunk.duration;
    chunk.bytes = bytes;
    chunk.index = request.index;
    chunk.quality = request.quality;
    chunk.representationId = request.representationId;
    chunk.endFragment = endFragment;
    return chunk;
  }

  function onFragmentLoadingCompleted(e) {
    // Event propagation may have been stopped (see MssHandler)
    if (!e.sender) return;
    var request = e.request;
    var bytes = e.response;
    var isInit = request.isInitializationRequest();
    var strInfo = request.mediaInfo.streamInfo;

    if (e.error) {
      if (request.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO || request.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || request.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && request.mediaInfo.isFragmented) {
        // add service location to blacklist controller - only for audio or video. text should not set errors
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].SERVICE_LOCATION_BLACKLIST_ADD, {
          entry: e.request.serviceLocation
        });
      }
    }

    if (!bytes || !strInfo) {
      logger.warn('No ' + request.mediaType + ' bytes to push or stream is inactive.');
      return;
    }

    var chunk = createDataChunk(bytes, request, streamInfo.id, e.type !== _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].FRAGMENT_LOADING_PROGRESS);
    eventBus.trigger(isInit ? _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].INIT_FRAGMENT_LOADED : _core_events_Events__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_FRAGMENT_LOADED, {
      chunk: chunk,
      request: request
    }, {
      streamId: strInfo.id,
      mediaType: request.mediaType
    });
  }

  instance = {
    getStreamId: getStreamId,
    getModel: getModel,
    reset: reset
  };
  setup();
  return instance;
}

FragmentController.__dashjs_factory_name = 'FragmentController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_9__["default"].getClassFactory(FragmentController));

/***/ }),

/***/ "./src/streaming/controllers/GapController.js":
/*!****************************************************!*\
  !*** ./src/streaming/controllers/GapController.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1494455__) {

"use strict";
__nested_webpack_require_1494455__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1494455__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1494455__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1494455__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1494455__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




var GAP_HANDLER_INTERVAL = 100;
var THRESHOLD_TO_STALLS = 10;
var GAP_JUMP_WAITING_TIME_OFFSET = 0.1;

function GapController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance();
  var instance, lastPlaybackTime, settings, wallclockTicked, gapHandlerInterval, lastGapJumpPosition, playbackController, streamController, videoModel, jumpTimeoutHandler, trackSwitchByMediaType, logger;

  function initialize() {
    _registerEvents();
  }

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
    reset();
  }

  function reset() {
    _stopGapHandler();

    _unregisterEvents();

    resetInitialSettings();
  }

  function resetInitialSettings() {
    gapHandlerInterval = null;
    lastGapJumpPosition = NaN;
    wallclockTicked = 0;
    jumpTimeoutHandler = null;
    trackSwitchByMediaType = {};
  }

  function setConfig(config) {
    if (!config) {
      return;
    }

    if (config.settings) {
      settings = config.settings;
    }

    if (config.playbackController) {
      playbackController = config.playbackController;
    }

    if (config.streamController) {
      streamController = config.streamController;
    }

    if (config.videoModel) {
      videoModel = config.videoModel;
    }
  }

  function _registerEvents() {
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].WALLCLOCK_TIME_UPDATED, _onWallclockTimeUpdated, this);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].INITIAL_STREAM_SWITCH, _onInitialStreamSwitch, this);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, this);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].BUFFER_REPLACEMENT_STARTED, _onBufferReplacementStarted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].TRACK_CHANGE_RENDERED, _onBufferReplacementEnded, instance);
  }

  function _unregisterEvents() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].WALLCLOCK_TIME_UPDATED, _onWallclockTimeUpdated, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].INITIAL_STREAM_SWITCH, _onInitialStreamSwitch, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, this);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].BUFFER_REPLACEMENT_STARTED, _onBufferReplacementStarted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].TRACK_CHANGE_RENDERED, _onBufferReplacementEnded, instance);
  }
  /**
   * Clear scheduled gap jump when seeking
   * @private
   */


  function _onPlaybackSeeking() {
    if (jumpTimeoutHandler) {
      clearTimeout(jumpTimeoutHandler);
      jumpTimeoutHandler = null;
    }
  }
  /**
   *  If the track was changed in the current active period and the player might aggressively replace segments the buffer will be empty for a short period of time. Avoid gap jumping at that time.
   *  We wait until the next media fragment of the target type has been appended before activating again
   * @param {object} e
   * @private
   */


  function _onBufferReplacementStarted(e) {
    try {
      if (e.streamId !== streamController.getActiveStreamInfo().id || !e.mediaType) {
        return;
      }

      if (e.streamId === streamController.getActiveStreamInfo().id) {
        trackSwitchByMediaType[e.mediaType] = true;
      }
    } catch (e) {
      logger.error(e);
    }
  }
  /**
   * Activate gap jumping again once segment of target type has been appended
   * @param {object} e
   * @private
   */


  function _onBufferReplacementEnded(e) {
    if (!e || !e.mediaType) {
      return;
    }

    trackSwitchByMediaType[e.mediaType] = false;
  }
  /**
   * Activate the gap handler after the first stream switch
   * @private
   */


  function _onInitialStreamSwitch() {
    if (!gapHandlerInterval) {
      _startGapHandler();
    }
  }
  /**
   * Callback handler for when the wallclock time has been updated
   * @private
   */


  function _onWallclockTimeUpdated()
  /*e*/
  {
    if (!_shouldCheckForGaps(settings.get().streaming.gaps.enableSeekFix)) {
      return;
    }

    wallclockTicked++;

    if (wallclockTicked >= THRESHOLD_TO_STALLS) {
      var currentTime = playbackController.getTime();

      if (lastPlaybackTime === currentTime) {
        _jumpGap(currentTime, true);
      } else {
        lastPlaybackTime = currentTime;
        lastGapJumpPosition = NaN;
      }

      wallclockTicked = 0;
    }
  }
  /**
   * Returns if we are supposed to check for gaps
   * @param {boolean} checkSeekingState - Usually we are not checking for gaps in the videolement is in seeking state. If this flag is set to true we check for a potential exceptions of this rule.
   * @return {boolean}
   * @private
   */


  function _shouldCheckForGaps() {
    var checkSeekingState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!streamController.getActiveStream()) {
      return false;
    }

    var trackSwitchInProgress = Object.keys(trackSwitchByMediaType).some(function (key) {
      return trackSwitchByMediaType[key];
    });
    var shouldIgnoreSeekingState = checkSeekingState ? _shouldIgnoreSeekingState() : false;
    return !trackSwitchInProgress && settings.get().streaming.gaps.jumpGaps && streamController.getActiveStreamProcessors().length > 0 && (!playbackController.isSeeking() || shouldIgnoreSeekingState) && !playbackController.isPaused() && !streamController.getIsStreamSwitchInProgress() && !streamController.getHasMediaOrInitialisationError();
  }
  /**
   * There are cases in which we never transition out of the seeking state and still need to jump a gap. For instance if the user seeks right before a gap and video element will not transition out of the seeking state.
   * For now limit this to period boundaries. In this case the current period is completely buffered and we are right before the end of the period.
   * @private
   */


  function _shouldIgnoreSeekingState() {
    var activeStream = streamController.getActiveStream();
    var streamEnd = parseFloat((activeStream.getStartTime() + activeStream.getDuration()).toFixed(5));
    return playbackController.getTime() + settings.get().streaming.gaps.threshold >= streamEnd;
  }
  /**
   * Returns the index of the range object that comes after the current time
   * @param {object} ranges
   * @param {number} currentTime
   * @private
   * @return {null|number}
   */


  function _getNextRangeIndex(ranges, currentTime) {
    try {
      if (!ranges || ranges.length <= 1 && currentTime > 0) {
        return NaN;
      }

      var nextRangeIndex = NaN;
      var j = 0;

      while (isNaN(nextRangeIndex) && j < ranges.length) {
        var rangeEnd = j > 0 ? ranges.end(j - 1) : 0;

        if (currentTime < ranges.start(j) && rangeEnd - currentTime < settings.get().streaming.gaps.threshold) {
          nextRangeIndex = j;
        }

        j += 1;
      }

      return nextRangeIndex;
    } catch (e) {
      return null;
    }
  }
  /**
   * Check if the currentTime exist within the buffered range
   * @param {object} ranges
   * @param {number} currentTime
   * @private
   * @return {boolean}
   */


  function _isTimeBuffered(ranges, currentTime) {
    for (var i = 0, len = ranges.length; i < len; i++) {
      if (currentTime >= ranges.start(i) && currentTime <= ranges.end(i)) {
        return true;
      }
    }

    return false;
  }
  /**
   * Starts the interval that checks for gaps
   * @private
   */


  function _startGapHandler() {
    try {
      if (!gapHandlerInterval) {
        logger.debug('Starting the gap controller');
        gapHandlerInterval = setInterval(function () {
          if (!_shouldCheckForGaps()) {
            return;
          }

          var currentTime = playbackController.getTime();

          _jumpGap(currentTime);
        }, GAP_HANDLER_INTERVAL);
      }
    } catch (e) {}
  }
  /**
   * Clears the gap interval handler
   * @private
   */


  function _stopGapHandler() {
    logger.debug('Stopping the gap controller');

    if (gapHandlerInterval) {
      clearInterval(gapHandlerInterval);
      gapHandlerInterval = null;
    }
  }
  /**
   * Jump a gap
   * @param {number} currentTime
   * @param {boolean} playbackStalled
   * @private
   */


  function _jumpGap(currentTime) {
    var playbackStalled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var enableStallFix = settings.get().streaming.gaps.enableStallFix;
    var stallSeek = settings.get().streaming.gaps.stallSeek;
    var smallGapLimit = settings.get().streaming.gaps.smallGapLimit;
    var jumpLargeGaps = settings.get().streaming.gaps.jumpLargeGaps;
    var ranges = videoModel.getBufferRange();
    var nextRangeIndex;
    var seekToPosition = NaN;
    var jumpToStreamEnd = false; // Get the range just after current time position

    nextRangeIndex = _getNextRangeIndex(ranges, currentTime);

    if (!isNaN(nextRangeIndex)) {
      var start = ranges.start(nextRangeIndex);
      var gap = start - currentTime;

      if (gap > 0 && (gap <= smallGapLimit || jumpLargeGaps)) {
        seekToPosition = start;
      }
    } // Playback has stalled before period end. We seek to the end of the period


    var timeToStreamEnd = playbackController.getTimeToStreamEnd();

    if (isNaN(seekToPosition) && playbackStalled && isFinite(timeToStreamEnd) && !isNaN(timeToStreamEnd) && timeToStreamEnd < smallGapLimit) {
      seekToPosition = parseFloat(playbackController.getStreamEndTime().toFixed(5));
      jumpToStreamEnd = true;
    }

    if (enableStallFix && isNaN(seekToPosition) && playbackStalled && isNaN(nextRangeIndex) && _isTimeBuffered(ranges, currentTime)) {
      if (stallSeek === 0) {
        logger.warn("Toggle play pause to break stall");
        videoModel.pause();
        videoModel.play();
      } else {
        logger.warn("Jumping ".concat(stallSeek, "s to break stall"));
        seekToPosition = currentTime + stallSeek;
      }
    }

    if (seekToPosition > 0 && lastGapJumpPosition !== seekToPosition && seekToPosition > currentTime && !jumpTimeoutHandler) {
      var timeUntilGapEnd = seekToPosition - currentTime;

      if (jumpToStreamEnd) {
        var nextStream = streamController.getStreamForTime(seekToPosition);
        var internalSeek = nextStream && !!nextStream.getPreloaded();
        logger.warn("Jumping to end of stream because of gap from ".concat(currentTime, " to ").concat(seekToPosition, ". Gap duration: ").concat(timeUntilGapEnd));
        playbackController.seek(seekToPosition, true, internalSeek);
      } else {
        var isDynamic = playbackController.getIsDynamic();

        var _start = nextRangeIndex > 0 ? ranges.end(nextRangeIndex - 1) : currentTime;

        var timeToWait = !isDynamic ? 0 : Math.max(0, timeUntilGapEnd - GAP_JUMP_WAITING_TIME_OFFSET) * 1000;
        jumpTimeoutHandler = window.setTimeout(function () {
          playbackController.seek(seekToPosition, true, true);
          logger.warn("Jumping gap occuring in period ".concat(streamController.getActiveStream().getStreamId(), " starting at ").concat(_start, " and ending at ").concat(seekToPosition, ". Jumping by: ").concat(seekToPosition - _start));
          jumpTimeoutHandler = null;
        }, timeToWait);
      }

      lastGapJumpPosition = seekToPosition;
    }
  }

  instance = {
    reset: reset,
    setConfig: setConfig,
    initialize: initialize
  };
  setup();
  return instance;
}

GapController.__dashjs_factory_name = 'GapController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(GapController));

/***/ }),

/***/ "./src/streaming/controllers/MediaController.js":
/*!******************************************************!*\
  !*** ./src/streaming/controllers/MediaController.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1509718__) {

"use strict";
__nested_webpack_require_1509718__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1509718__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1509718__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1509718__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1509718__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1509718__(/*! ../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function MediaController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var instance, logger, tracks, settings, initialSettings, lastSelectedTracks, customParametersModel, domStorage;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance().getLogger(instance);
    reset();
  }
  /**
   * @param {string} type
   * @param {StreamInfo} streamInfo
   * @memberof MediaController#
   */


  function setInitialMediaSettingsForType(type, streamInfo) {
    var settings = lastSelectedTracks[type] || getInitialSettings(type);
    var tracksForType = getTracksFor(type, streamInfo.id);
    var tracks = [];

    if (!settings) {
      settings = domStorage.getSavedMediaSettings(type);
      setInitialSettings(type, settings);
    }

    if (!tracksForType || tracksForType.length === 0) return;

    if (settings) {
      tracksForType.forEach(function (track) {
        if (matchSettings(settings, track, !!lastSelectedTracks[type])) {
          tracks.push(track);
        }
      });
    }

    if (tracks.length === 0) {
      setTrack(selectInitialTrack(type, tracksForType), true);
    } else {
      if (tracks.length > 1) {
        setTrack(selectInitialTrack(type, tracks, !!lastSelectedTracks[type]));
      } else {
        setTrack(tracks[0]);
      }
    }
  }
  /**
   * @param {MediaInfo} track
   * @memberof MediaController#
   */


  function addTrack(track) {
    if (!track) return;
    var mediaType = track.type;
    if (!_isMultiTrackSupportedByType(mediaType)) return;
    var streamId = track.streamInfo.id;

    if (!tracks[streamId]) {
      tracks[streamId] = createTrackInfo();
    }

    var mediaTracks = tracks[streamId][mediaType].list;

    for (var i = 0, len = mediaTracks.length; i < len; ++i) {
      //track is already set.
      if (isTracksEqual(mediaTracks[i], track)) {
        return;
      }
    }

    mediaTracks.push(track);
  }
  /**
   * @param {string} type
   * @param {string} streamId
   * @returns {Array}
   * @memberof MediaController#
   */


  function getTracksFor(type, streamId) {
    if (!type) return [];
    if (!tracks[streamId] || !tracks[streamId][type]) return [];
    return tracks[streamId][type].list;
  }
  /**
   * @param {string} type
   * @param {string} streamId
   * @returns {Object|null}
   * @memberof MediaController#
   */


  function getCurrentTrackFor(type, streamId) {
    if (!type || !tracks[streamId] || !tracks[streamId][type]) return null;
    return tracks[streamId][type].current;
  }
  /**
   * @param {MediaInfo} track
   * @returns {boolean}
   * @memberof MediaController#
   */


  function isCurrentTrack(track) {
    if (!track) {
      return false;
    }

    var type = track.type;
    var id = track.streamInfo.id;
    return tracks[id] && tracks[id][type] && isTracksEqual(tracks[id][type].current, track);
  }
  /**
   * @param {MediaInfo} track
   * @param {boolean} noSettingsSave specify if settings must be not be saved
   * @memberof MediaController#
   */


  function setTrack(track) {
    var noSettingsSave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!track || !track.streamInfo) return;
    var type = track.type;
    var streamInfo = track.streamInfo;
    var id = streamInfo.id;
    var current = getCurrentTrackFor(type, id);
    if (!tracks[id] || !tracks[id][type] || isTracksEqual(track, current)) return;
    tracks[id][type].current = track;

    if (tracks[id][type].current && (type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && track.isFragmented)) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].CURRENT_TRACK_CHANGED, {
        oldMediaInfo: current,
        newMediaInfo: track,
        switchMode: settings.get().streaming.trackSwitchMode[type]
      }, {
        streamId: id
      });
    }

    if (!noSettingsSave) {
      var _settings = extractSettings(track);

      if (!_settings || !tracks[id][type].storeLastSettings) return;

      if (_settings.roles) {
        _settings.role = _settings.roles[0];
        delete _settings.roles;
      }

      if (_settings.accessibility) {
        _settings.accessibility = _settings.accessibility[0];
      }

      if (_settings.audioChannelConfiguration) {
        _settings.audioChannelConfiguration = _settings.audioChannelConfiguration[0];
      }

      lastSelectedTracks[type] = _settings;
      domStorage.setSavedMediaSettings(type, _settings);
    }
  }
  /**
   * @param {string} type
   * @param {Object} value
   * @memberof MediaController#
   */


  function setInitialSettings(type, value) {
    if (!type || !value) return;
    initialSettings[type] = value;
  }
  /**
   * @param {string} type
   * @returns {Object|null}
   * @memberof MediaController#
   */


  function getInitialSettings(type) {
    if (!type) return null;
    return initialSettings[type];
  }
  /**
   * @memberof MediaController#
   */


  function saveTextSettingsDisabled() {
    domStorage.setSavedMediaSettings(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT, null);
  }
  /**
   * @param {string} type
   * @returns {boolean}
   * @memberof MediaController#
   */


  function _isMultiTrackSupportedByType(type) {
    return type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE;
  }
  /**
   * @param {MediaInfo} t1 - first track to compare
   * @param {MediaInfo} t2 - second track to compare
   * @returns {boolean}
   * @memberof MediaController#
   */


  function isTracksEqual(t1, t2) {
    if (!t1 && !t2) {
      return true;
    }

    if (!t1 || !t2) {
      return false;
    }

    var sameId = t1.id === t2.id;
    var sameViewpoint = t1.viewpoint === t2.viewpoint;
    var sameLang = t1.lang === t2.lang;
    var sameCodec = t1.codec === t2.codec;
    var sameRoles = t1.roles.toString() === t2.roles.toString();
    var sameAccessibility = t1.accessibility.toString() === t2.accessibility.toString();
    var sameAudioChannelConfiguration = t1.audioChannelConfiguration.toString() === t2.audioChannelConfiguration.toString();
    return sameId && sameCodec && sameViewpoint && sameLang && sameRoles && sameAccessibility && sameAudioChannelConfiguration;
  }

  function setConfig(config) {
    if (!config) return;

    if (config.domStorage) {
      domStorage = config.domStorage;
    }

    if (config.settings) {
      settings = config.settings;
    }

    if (config.customParametersModel) {
      customParametersModel = config.customParametersModel;
    }
  }
  /**
   * @memberof MediaController#
   */


  function reset() {
    tracks = {};
    lastSelectedTracks = {};
    resetInitialSettings();
  }

  function extractSettings(mediaInfo) {
    var settings = {
      lang: mediaInfo.lang,
      viewpoint: mediaInfo.viewpoint,
      roles: mediaInfo.roles,
      accessibility: mediaInfo.accessibility,
      audioChannelConfiguration: mediaInfo.audioChannelConfiguration
    };
    var notEmpty = settings.lang || settings.viewpoint || settings.role && settings.role.length > 0 || settings.accessibility && settings.accessibility.length > 0 || settings.audioChannelConfiguration && settings.audioChannelConfiguration.length > 0;
    return notEmpty ? settings : null;
  }

  function matchSettings(settings, track) {
    var isTrackActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var matchLang = !settings.lang || track.lang.match(settings.lang);
    var matchIndex = settings.index === undefined || settings.index === null || track.index === settings.index;
    var matchViewPoint = !settings.viewpoint || settings.viewpoint === track.viewpoint;
    var matchRole = !settings.role || !!track.roles.filter(function (item) {
      return item === settings.role;
    })[0];
    var matchAccessibility = !settings.accessibility || !!track.accessibility.filter(function (item) {
      return item === settings.accessibility;
    })[0];
    var matchAudioChannelConfiguration = !settings.audioChannelConfiguration || !!track.audioChannelConfiguration.filter(function (item) {
      return item === settings.audioChannelConfiguration;
    })[0];
    return matchLang && matchIndex && matchViewPoint && (matchRole || track.type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && isTrackActive) && matchAccessibility && matchAudioChannelConfiguration;
  }

  function resetInitialSettings() {
    initialSettings = {
      audio: null,
      video: null,
      text: null
    };
  }

  function getTracksWithHighestSelectionPriority(trackArr) {
    var max = 0;
    var result = [];
    trackArr.forEach(function (track) {
      if (!isNaN(track.selectionPriority)) {
        // Higher max value. Reset list and add new entry
        if (track.selectionPriority > max) {
          max = track.selectionPriority;
          result = [track];
        } // Same max value add to list
        else if (track.selectionPriority === max) {
            result.push(track);
          }
      }
    });
    return result;
  }

  function getTracksWithHighestBitrate(trackArr) {
    var max = 0;
    var result = [];
    var tmp;
    trackArr.forEach(function (track) {
      tmp = Math.max.apply(Math, track.bitrateList.map(function (obj) {
        return obj.bandwidth;
      }));

      if (tmp > max) {
        max = tmp;
        result = [track];
      } else if (tmp === max) {
        result.push(track);
      }
    });
    return result;
  }

  function getTracksWithHighestEfficiency(trackArr) {
    var min = Infinity;
    var result = [];
    var tmp;
    trackArr.forEach(function (track) {
      var sum = track.bitrateList.reduce(function (acc, obj) {
        var resolution = Math.max(1, obj.width * obj.height);
        var efficiency = obj.bandwidth / resolution;
        return acc + efficiency;
      }, 0);
      tmp = sum / track.bitrateList.length;

      if (tmp < min) {
        min = tmp;
        result = [track];
      } else if (tmp === min) {
        result.push(track);
      }
    });
    return result;
  }

  function getTracksWithWidestRange(trackArr) {
    var max = 0;
    var result = [];
    var tmp;
    trackArr.forEach(function (track) {
      tmp = track.representationCount;

      if (tmp > max) {
        max = tmp;
        result = [track];
      } else if (tmp === max) {
        result.push(track);
      }
    });
    return result;
  }

  function selectInitialTrack(type, tracks) {
    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) return tracks[0];
    var mode = settings.get().streaming.selectionModeForInitialTrack;
    var tmpArr;
    var customInitialTrackSelectionFunction = customParametersModel.getCustomInitialTrackSelectionFunction();

    if (customInitialTrackSelectionFunction && typeof customInitialTrackSelectionFunction === 'function') {
      tmpArr = customInitialTrackSelectionFunction(tracks);
    } else {
      switch (mode) {
        case _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:
          tmpArr = _trackSelectionModeHighestSelectionPriority(tracks);
          break;

        case _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SELECTION_MODE_HIGHEST_BITRATE:
          tmpArr = _trackSelectionModeHighestBitrate(tracks);
          break;

        case _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SELECTION_MODE_FIRST_TRACK:
          tmpArr = _trackSelectionModeFirstTrack(tracks);
          break;

        case _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:
          tmpArr = _trackSelectionModeHighestEfficiency(tracks);
          break;

        case _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TRACK_SELECTION_MODE_WIDEST_RANGE:
          tmpArr = _trackSelectionModeWidestRange(tracks);
          break;

        default:
          logger.warn("Track selection mode ".concat(mode, " is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK"));
          tmpArr = _trackSelectionModeFirstTrack(tracks);
          break;
      }
    }

    return tmpArr.length > 0 ? tmpArr[0] : tracks[0];
  }

  function _trackSelectionModeHighestSelectionPriority(tracks) {
    var tmpArr = getTracksWithHighestSelectionPriority(tracks);

    if (tmpArr.length > 1) {
      tmpArr = getTracksWithHighestBitrate(tmpArr);
    }

    if (tmpArr.length > 1) {
      tmpArr = getTracksWithWidestRange(tmpArr);
    }

    return tmpArr;
  }

  function _trackSelectionModeHighestBitrate(tracks) {
    var tmpArr = getTracksWithHighestBitrate(tracks);

    if (tmpArr.length > 1) {
      tmpArr = getTracksWithWidestRange(tmpArr);
    }

    return tmpArr;
  }

  function _trackSelectionModeFirstTrack(tracks) {
    return tracks[0];
  }

  function _trackSelectionModeHighestEfficiency(tracks) {
    var tmpArr = getTracksWithHighestEfficiency(tracks);

    if (tmpArr.length > 1) {
      tmpArr = getTracksWithHighestBitrate(tmpArr);
    }

    return tmpArr;
  }

  function _trackSelectionModeWidestRange(tracks) {
    var tmpArr = getTracksWithWidestRange(tracks);

    if (tmpArr.length > 1) {
      tmpArr = getTracksWithHighestBitrate(tracks);
    }

    return tmpArr;
  }

  function createTrackInfo() {
    return {
      audio: {
        list: [],
        storeLastSettings: true,
        current: null
      },
      video: {
        list: [],
        storeLastSettings: true,
        current: null
      },
      text: {
        list: [],
        storeLastSettings: true,
        current: null
      },
      image: {
        list: [],
        storeLastSettings: true,
        current: null
      }
    };
  }

  instance = {
    setInitialMediaSettingsForType: setInitialMediaSettingsForType,
    addTrack: addTrack,
    getTracksFor: getTracksFor,
    getCurrentTrackFor: getCurrentTrackFor,
    isCurrentTrack: isCurrentTrack,
    setTrack: setTrack,
    selectInitialTrack: selectInitialTrack,
    setInitialSettings: setInitialSettings,
    getInitialSettings: getInitialSettings,
    getTracksWithHighestBitrate: getTracksWithHighestBitrate,
    getTracksWithHighestEfficiency: getTracksWithHighestEfficiency,
    getTracksWithWidestRange: getTracksWithWidestRange,
    isTracksEqual: isTracksEqual,
    matchSettings: matchSettings,
    saveTextSettingsDisabled: saveTextSettingsDisabled,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

MediaController.__dashjs_factory_name = 'MediaController';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getSingletonFactory(MediaController);
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].updateSingletonFactory(MediaController.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/controllers/MediaSourceController.js":
/*!************************************************************!*\
  !*** ./src/streaming/controllers/MediaSourceController.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1528641__) {

"use strict";
__nested_webpack_require_1528641__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1528641__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1528641__(/*! ../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function MediaSourceController() {
  var instance, mediaSource, logger;
  var context = this.context;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
  }

  function createMediaSource() {
    var hasWebKit = ('WebKitMediaSource' in window);
    var hasMediaSource = ('MediaSource' in window);

    if (hasMediaSource) {
      mediaSource = new MediaSource();
    } else if (hasWebKit) {
      mediaSource = new WebKitMediaSource();
    }

    return mediaSource;
  }

  function attachMediaSource(videoModel) {
    var objectURL = window.URL.createObjectURL(mediaSource);
    videoModel.setSource(objectURL);
    return objectURL;
  }

  function detachMediaSource(videoModel) {
    videoModel.setSource(null);
  }

  function setDuration(value) {
    if (!mediaSource || mediaSource.readyState !== 'open') return;
    if (value === null && isNaN(value)) return;
    if (mediaSource.duration === value) return;

    if (!isBufferUpdating(mediaSource)) {
      logger.info('Set MediaSource duration:' + value);
      mediaSource.duration = value;
    } else {
      setTimeout(setDuration.bind(null, value), 50);
    }
  }

  function setSeekable(start, end) {
    if (mediaSource && typeof mediaSource.setLiveSeekableRange === 'function' && typeof mediaSource.clearLiveSeekableRange === 'function' && mediaSource.readyState === 'open' && start >= 0 && start < end) {
      mediaSource.clearLiveSeekableRange();
      mediaSource.setLiveSeekableRange(start, end);
    }
  }

  function signalEndOfStream(source) {
    if (!source || source.readyState !== 'open') {
      return;
    }

    var buffers = source.sourceBuffers;

    for (var i = 0; i < buffers.length; i++) {
      if (buffers[i].updating) {
        return;
      }

      if (buffers[i].buffered.length === 0) {
        return;
      }
    }

    logger.info('call to mediaSource endOfStream');
    source.endOfStream();
  }

  function isBufferUpdating(source) {
    var buffers = source.sourceBuffers;

    for (var i = 0; i < buffers.length; i++) {
      if (buffers[i].updating) {
        return true;
      }
    }

    return false;
  }

  instance = {
    createMediaSource: createMediaSource,
    attachMediaSource: attachMediaSource,
    detachMediaSource: detachMediaSource,
    setDuration: setDuration,
    setSeekable: setSeekable,
    signalEndOfStream: signalEndOfStream
  };
  setup();
  return instance;
}

MediaSourceController.__dashjs_factory_name = 'MediaSourceController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(MediaSourceController));

/***/ }),

/***/ "./src/streaming/controllers/PlaybackController.js":
/*!*********************************************************!*\
  !*** ./src/streaming/controllers/PlaybackController.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1534053__) {

"use strict";
__nested_webpack_require_1534053__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1534053__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1534053__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1534053__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1534053__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1534053__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1534053__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1534053__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







var LIVE_UPDATE_PLAYBACK_TIME_INTERVAL_MS = 500;

function PlaybackController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var instance, logger, streamController, serviceDescriptionController, dashMetrics, adapter, videoModel, timelineConverter, wallclockTimeIntervalId, liveDelay, streamInfo, isDynamic, playOnceInitialized, lastLivePlaybackTime, availabilityStartTime, availabilityTimeComplete, lowLatencyModeEnabled, seekTarget, internalSeek, playbackStalled, manifestUpdateInProgress, initialCatchupModeActivated, settings;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance().getLogger(instance);
    reset();
  }
  /**
   * Reset all settings
   */


  function reset() {
    pause();
    playOnceInitialized = false;
    liveDelay = 0;
    availabilityStartTime = 0;
    manifestUpdateInProgress = false;
    availabilityTimeComplete = true;
    lowLatencyModeEnabled = false;
    initialCatchupModeActivated = false;
    seekTarget = NaN;

    if (videoModel) {
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].DATA_UPDATE_COMPLETED, _onDataUpdateCompleted, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING_PROGRESS, _onFragmentLoadProgress, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].MANIFEST_UPDATED, _onManifestUpdated, instance);
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].STREAMS_COMPOSED, _onStreamsComposed, instance);
      eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].PLAYBACK_ENDED, _onPlaybackEnded, instance);
      eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].STREAM_INITIALIZING, _onStreamInitializing, instance);
      eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].REPRESENTATION_SWITCH, _onRepresentationSwitch, instance);
      eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
      stopUpdatingWallclockTime();
      removeAllListeners();
    }

    wallclockTimeIntervalId = null;
    videoModel = null;
    streamInfo = null;
    isDynamic = null;
  }
  /**
   * Initializes the PlaybackController. This function is called whenever the stream is switched.
   * @param {object} sInfo
   * @param {boolean} periodSwitch
   */


  function initialize(sInfo, periodSwitch) {
    streamInfo = sInfo;

    if (periodSwitch !== true) {
      _initializeForFirstStream();
    }
  }
  /**
   * Initializes the PlaybackController when the first stream is to be played.
   * @private
   */


  function _initializeForFirstStream() {
    addAllListeners();
    isDynamic = streamInfo.manifestInfo.isDynamic;
    playbackStalled = false;
    internalSeek = false;
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].DATA_UPDATE_COMPLETED, _onDataUpdateCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING_PROGRESS, _onFragmentLoadProgress, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].MANIFEST_UPDATED, _onManifestUpdated, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].STREAMS_COMPOSED, _onStreamsComposed, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].PLAYBACK_ENDED, _onPlaybackEnded, instance, {
      priority: _core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"].EVENT_PRIORITY_HIGH
    });
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].STREAM_INITIALIZING, _onStreamInitializing, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].REPRESENTATION_SWITCH, _onRepresentationSwitch, instance);
    eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);

    if (playOnceInitialized) {
      playOnceInitialized = false;
      play();
    }
  }
  /**
   * Returns stalled state
   * @return {boolean}
   */


  function getPlaybackStalled() {
    return playbackStalled;
  }
  /**
   * Returns remaining duration of a period
   * @param {object} sInfo
   * @return {number}
   */


  function getTimeToStreamEnd() {
    var sInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return parseFloat((getStreamEndTime(sInfo) - getTime()).toFixed(5));
  }
  /**
   * Returns end time of a period
   * @param {object} sInfo
   * @return {number}
   */


  function getStreamEndTime(sInfo) {
    var refInfo = sInfo ? sInfo : streamInfo;
    return refInfo.start + refInfo.duration;
  }
  /**
   * Triggers play() on the video element
   */


  function play() {
    if (streamInfo && videoModel && videoModel.getElement()) {
      videoModel.play();
    } else {
      playOnceInitialized = true;
    }
  }
  /**
   * Triggers pause() on the video element
   */


  function pause() {
    if (streamInfo && videoModel) {
      videoModel.pause();
    }
  }
  /**
   * Triggers a seek to the specified media time. If internal is enabled there will be now "seeked" event dispatched
   * @param {number} time
   * @param {boolean} stickToBuffered
   * @param {boolean} internal
   */


  function seek(time, stickToBuffered, internal) {
    if (!streamInfo || !videoModel) return;
    var currentTime = !isNaN(seekTarget) ? seekTarget : videoModel.getTime();
    if (time === currentTime) return;
    internalSeek = internal === true;

    if (!internalSeek) {
      seekTarget = time;
    }

    logger.info('Requesting seek to time: ' + time + (internalSeek ? ' (internal)' : ''));
    videoModel.setCurrentTime(time, stickToBuffered);
  }
  /**
   * Returns current time of video element
   * @return {number|null}
   */


  function getTime() {
    return streamInfo && videoModel ? videoModel.getTime() : null;
  }
  /**
   * Returns paused state of the video element
   * @return {boolean|null}
   */


  function isPaused() {
    return streamInfo && videoModel ? videoModel.isPaused() : null;
  }
  /**
   * Returns seeking state of the video element
   * @return {boolean|null}
   */


  function isSeeking() {
    return streamInfo && videoModel ? videoModel.isSeeking() : null;
  }
  /**
   * Returns stalled state of the video element
   * @return {boolean|null}
   */


  function isStalled() {
    return streamInfo && videoModel ? videoModel.isStalled() : null;
  }
  /**
   * Returns current playback rate of the video element
   * @return {number|null}
   */


  function getPlaybackRate() {
    return streamInfo && videoModel ? videoModel.getPlaybackRate() : null;
  }
  /**
   * Returns the played ranges of the video element
   * @return {array}
   */


  function getPlayedRanges() {
    return streamInfo && videoModel ? videoModel.getPlayedRanges() : null;
  }
  /**
   * Returns ended attribute of the video element
   * @return {boolean|null}
   */


  function getEnded() {
    return streamInfo && videoModel ? videoModel.getEnded() : null;
  }
  /**
   * Returns whether a stream is type dynamic or not
   * @return {boolean}
   */


  function getIsDynamic() {
    return isDynamic;
  }
  /**
   * Returns the StreamController
   * @return {object}
   */


  function getStreamController() {
    return streamController;
  }
  /**
   * Returns whether a manifest update is in progress
   * @return {boolean}
   */


  function getIsManifestUpdateInProgress() {
    return manifestUpdateInProgress;
  }
  /**
   * Returns the availabilityStartTime
   * @return {number}
   */


  function getAvailabilityStartTime() {
    return availabilityStartTime;
  }
  /**
   * Returns the computed live delay
   * @return {number}
   */


  function getLiveDelay() {
    return liveDelay;
  }
  /**
   * Returns the current live latency
   * @return {number}
   */


  function getCurrentLiveLatency() {
    if (!isDynamic || isNaN(availabilityStartTime)) {
      return NaN;
    }

    var currentTime = getTime();

    if (isNaN(currentTime) || currentTime === 0) {
      return 0;
    }

    var now = new Date().getTime() + timelineConverter.getClientTimeOffset() * 1000;
    return Math.max(((now - availabilityStartTime - currentTime * 1000) / 1000).toFixed(3), 0);
  }
  /**
   * Computes the desirable delay for the live edge to avoid a risk of getting 404 when playing at the bleeding edge
   * @param {number} fragmentDuration - seconds?
   * @param {object} manifestInfo
   * @returns {number} object
   * @memberof PlaybackController#
   */


  function computeAndSetLiveDelay(fragmentDuration, manifestInfo) {
    var delay, ret, startTime;
    var MIN_BUFFER_TIME_FACTOR = 4;
    var FRAGMENT_DURATION_FACTOR = 4;
    var adjustedFragmentDuration = !isNaN(fragmentDuration) && isFinite(fragmentDuration) ? fragmentDuration : NaN;
    var suggestedPresentationDelay = adapter.getSuggestedPresentationDelay();
    var serviceDescriptionSettings = serviceDescriptionController.getServiceDescriptionSettings(); // Live delay specified by the user

    if (!isNaN(settings.get().streaming.delay.liveDelay)) {
      delay = settings.get().streaming.delay.liveDelay;
    } // Live delay fragment count specified by the user
    else if (settings.get().streaming.delay.liveDelayFragmentCount !== null && !isNaN(settings.get().streaming.delay.liveDelayFragmentCount) && !isNaN(adjustedFragmentDuration)) {
        delay = adjustedFragmentDuration * settings.get().streaming.delay.liveDelayFragmentCount;
      } // Live delay set via ServiceDescription element
      else if (serviceDescriptionSettings && !isNaN(serviceDescriptionSettings.liveDelay) && serviceDescriptionSettings.liveDelay > 0) {
          delay = serviceDescriptionSettings.liveDelay;
        } // Live delay set in the manifest using @suggestedPresentation Delay
        else if (settings.get().streaming.delay.useSuggestedPresentationDelay === true && suggestedPresentationDelay !== null && !isNaN(suggestedPresentationDelay) && suggestedPresentationDelay > 0) {
            delay = suggestedPresentationDelay;
          } // We found a fragment duration, use that to calculcate live delay
          else if (!isNaN(adjustedFragmentDuration)) {
              delay = adjustedFragmentDuration * FRAGMENT_DURATION_FACTOR;
            } // Fall back to @minBufferTime to calculate the live delay
            else {
                delay = manifestInfo && !isNaN(manifestInfo.minBufferTime) ? manifestInfo.minBufferTime * MIN_BUFFER_TIME_FACTOR : streamInfo.manifestInfo.minBufferTime * MIN_BUFFER_TIME_FACTOR;
              }

    startTime = adapter.getAvailabilityStartTime();

    if (startTime !== null) {
      availabilityStartTime = startTime;
    }

    if (manifestInfo && manifestInfo.dvrWindowSize > 0) {
      // Latency can not be higher than DVR window size
      ret = Math.min(delay, manifestInfo.dvrWindowSize);
    } else {
      ret = delay;
    }

    liveDelay = ret;
    return ret;
  }

  function setConfig(config) {
    if (!config) return;

    if (config.streamController) {
      streamController = config.streamController;
    }

    if (config.serviceDescriptionController) {
      serviceDescriptionController = config.serviceDescriptionController;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }

    if (config.videoModel) {
      videoModel = config.videoModel;
    }

    if (config.timelineConverter) {
      timelineConverter = config.timelineConverter;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }
  /**
   * Compare the current time of the video against the DVR window. If we are out of the DVR window we need to seek.
   * @param {object} mediaType
   */


  function updateCurrentTime() {
    var mediaType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isPaused() || !isDynamic || videoModel.getReadyState() === 0 || isSeeking() || manifestUpdateInProgress) return; // Note: In some cases we filter certain media types completely (for instance due to an unsupported video codec). This happens after the first entry to the DVR metric has been added.
    // Now the DVR window for the filtered media type is not updated anymore. Consequently, always use a mediaType that is available to get a valid DVR window.

    if (!mediaType) {
      mediaType = streamController.hasVideoTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO : _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO;
    } // Compare the current time of the video element against the range defined in the DVR window.


    var currentTime = getTime();

    var actualTime = _getAdjustedPresentationTime(currentTime, mediaType);

    var timeChanged = !isNaN(actualTime) && actualTime !== currentTime;

    if (timeChanged && !isSeeking() && (isStalled() || playbackStalled || videoModel.getReadyState() === 1)) {
      logger.debug("UpdateCurrentTime: Seek to actual time: ".concat(actualTime, " from currentTime: ").concat(currentTime));
      seek(actualTime, false, false);
    }
  }
  /**
   * Adjust the presentation time based on the DVR window. If we are out of the DVR window we return a corrected time
   * @param {number} currentTime
   * @param {string} mediatype
   * @return {number}
   * @private
   */


  function _getAdjustedPresentationTime(currentTime, mediatype) {
    var DVRMetrics = dashMetrics.getCurrentDVRInfo(mediatype);
    var DVRWindow = DVRMetrics ? DVRMetrics.range : null;
    var actualTime;

    if (!DVRWindow) {
      return NaN;
    }

    if (currentTime > DVRWindow.end) {
      actualTime = Math.max(DVRWindow.end - liveDelay, DVRWindow.start);
    } else if (currentTime > 0 && currentTime + 0.250 < DVRWindow.start && Math.abs(currentTime - DVRWindow.start) < 315360000) {
      // Checking currentTime plus 250ms as the 'timeupdate' is fired with a frequency between 4Hz and 66Hz
      // https://developer.mozilla.org/en-US/docs/Web/Events/timeupdate
      // http://w3c.github.io/html/single-page.html#offsets-into-the-media-resource
      // Checking also duration of the DVR makes sense. We detected temporary situations in which currentTime
      // is bad reported by the browser which causes playback to jump to start (315360000 = 1 year)
      if (lowLatencyModeEnabled) {
        actualTime = Math.max(DVRWindow.end - liveDelay, DVRWindow.start);
      } else {
        actualTime = DVRWindow.start;
      }
    } else {
      actualTime = currentTime;
    }

    return actualTime;
  }
  /**
   * Start interval handler for wallclock time update
   */


  function startUpdatingWallclockTime() {
    if (wallclockTimeIntervalId !== null) return;
    wallclockTimeIntervalId = setInterval(function () {
      _onWallclockTime();
    }, settings.get().streaming.wallclockTimeUpdateInterval);
  }
  /**
   * Stop the interval handler for the wallclock time update
   */


  function stopUpdatingWallclockTime() {
    clearInterval(wallclockTimeIntervalId);
    wallclockTimeIntervalId = null;
  }

  function _onDataUpdateCompleted(e) {
    var representationInfo = adapter.convertRepresentationToRepresentationInfo(e.currentRepresentation);
    var info = representationInfo ? representationInfo.mediaInfo.streamInfo : null;
    if (info === null || streamInfo.id !== info.id) return;
    streamInfo = info;
  }

  function _onCanPlay() {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].CAN_PLAY);
  }

  function _onCanPlayThrough() {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].CAN_PLAY_THROUGH);
  }

  function _onBufferLevelStateChanged(e) {
    // do not stall playback when get an event from Stream that is not active
    if (e.streamId !== streamController.getActiveStreamInfo().id) {
      return;
    }

    playbackStalled = e.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFER_EMPTY;

    if (settings.get().streaming.buffer.setStallState) {
      videoModel.setStallState(e.mediaType, e.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFER_EMPTY);
    }
  }

  function _onPlaybackStart() {
    logger.info('Native video element event: play');
    updateCurrentTime();
    startUpdatingWallclockTime();
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_STARTED, {
      startTime: getTime()
    });
  }

  function _onPlaybackWaiting() {
    logger.info('Native video element event: waiting');
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_WAITING, {
      playingTime: getTime()
    });
  }

  function _onPlaybackPlaying() {
    logger.info('Native video element event: playing');
    internalSeek = false;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PLAYING, {
      playingTime: getTime()
    });
  }

  function _onPlaybackPaused() {
    logger.info('Native video element event: pause');
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PAUSED, {
      ended: getEnded()
    });
  }

  function _onPlaybackSeeking() {
    // Check if internal seeking to be ignored
    if (internalSeek) {
      return;
    }

    var seekTime = getTime(); // On some browsers/devices, in case of live streams, setting current time on video element fails when there is no buffered data at requested time
    // Then re-set seek target time and video element will be seeked afterwhile once data is buffered (see BufferContoller)

    if (!isNaN(seekTarget) && seekTarget !== seekTime) {
      seekTime = seekTarget;
    }

    seekTarget = NaN;
    logger.info('Seeking to: ' + seekTime);
    startUpdatingWallclockTime();
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_SEEKING, {
      seekTime: seekTime,
      streamId: streamInfo.id
    });
  }

  function _onPlaybackSeeked() {
    logger.info('Native video element event: seeked');
    internalSeek = false;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_SEEKED);
  }

  function _onPlaybackTimeUpdated() {
    if (streamInfo) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_TIME_UPDATED, {
        timeToEnd: getTimeToStreamEnd(),
        time: getTime(),
        streamId: streamInfo.id
      });
    }
  }

  function _onPlaybackProgress() {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PROGRESS, {
      streamId: streamInfo.id
    });
  }

  function _onPlaybackRateChanged() {
    var rate = getPlaybackRate();
    logger.info('Native video element event: ratechange: ', rate);
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_RATE_CHANGED, {
      playbackRate: rate
    });
  }

  function _onPlaybackMetaDataLoaded() {
    logger.info('Native video element event: loadedmetadata');
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_METADATA_LOADED);
    startUpdatingWallclockTime();
  }

  function _onPlaybackLoadedData() {
    logger.info('Native video element event: loadeddata');
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_LOADED_DATA);
  } // Event to handle the native video element ended event


  function _onNativePlaybackEnded() {
    logger.info('Native video element event: ended');
    pause();
    stopUpdatingWallclockTime();
    var streamInfo = streamController ? streamController.getActiveStreamInfo() : null;
    if (!streamInfo) return;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_ENDED, {
      'isLast': streamInfo.isLast
    });
  } // Handle DASH PLAYBACK_ENDED event


  function _onPlaybackEnded(e) {
    if (wallclockTimeIntervalId && e.isLast) {
      // PLAYBACK_ENDED was triggered elsewhere, react.
      logger.info('onPlaybackEnded -- PLAYBACK_ENDED but native video element didn\'t fire ended');
      var seekTime = e.seekTime ? e.seekTime : getStreamEndTime();
      videoModel.setCurrentTime(seekTime);
      pause();
      stopUpdatingWallclockTime();
    }
  }

  function _onPlaybackError(event) {
    var target = event.target || event.srcElement;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_ERROR, {
      error: target.error
    });
  }

  function _onWallclockTime() {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].WALLCLOCK_TIME_UPDATED, {
      isDynamic: isDynamic,
      time: new Date()
    }); // Updates playback time for paused dynamic streams
    // (video element doesn't call timeupdate when the playback is paused)

    if (getIsDynamic()) {
      streamController.addDVRMetric();

      if (isPaused()) {
        _updateLivePlaybackTime();
      } else {
        updateCurrentTime();
      }
    }
  }

  function _updateLivePlaybackTime() {
    var now = Date.now();

    if (!lastLivePlaybackTime || now > lastLivePlaybackTime + LIVE_UPDATE_PLAYBACK_TIME_INTERVAL_MS) {
      lastLivePlaybackTime = now;

      _onPlaybackTimeUpdated();
    }
  }
  /**
   * Returns the combined minimum buffer level of all StreamProcessors. If a filter list is provided the types specified in the filter list are excluded.
   * @param {array} filterList StreamProcessor types to exclude
   * @return {null}
   */


  function getBufferLevel() {
    var filterList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var bufferLevel = null;
    streamController.getActiveStreamProcessors().forEach(function (p) {
      if (!filterList || filterList.length === 0 || filterList.indexOf(p.getType()) === -1) {
        var bl = p.getBufferLevel();

        if (bufferLevel === null) {
          bufferLevel = bl;
        } else {
          bufferLevel = Math.min(bufferLevel, bl);
        }
      }
    });
    return bufferLevel;
  }
  /**
   * Returns the value of lowLatencyModeEnabled
   * @return {boolean} lowLatencyModeEnabled
   */


  function getLowLatencyModeEnabled() {
    return lowLatencyModeEnabled;
  }

  function _onFragmentLoadProgress(e) {
    // If using fetch and stream mode is not available, readjust live latency so it is 20% higher than segment duration
    if (e.stream === false && lowLatencyModeEnabled && !isNaN(e.request.duration)) {
      var minDelay = 1.2 * e.request.duration;

      if (minDelay > liveDelay) {
        logger.warn('Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:', minDelay.toFixed(2));
        liveDelay = minDelay;
      }
    }
  }

  function onPlaybackStalled(e) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_STALLED, {
      e: e
    });
  }

  function _onStreamInitializing(e) {
    _checkEnableLowLatency(e.mediaInfo);
  }
  /**
   * We enable low latency playback if for the current representation availabilityTimeComplete is set to false
   * @param e
   * @private
   */


  function _onRepresentationSwitch(e) {
    var activeStreamInfo = streamController.getActiveStreamInfo();

    if (!e || !activeStreamInfo || !e.currentRepresentation || !e.streamId || e.streamId !== activeStreamInfo.id || !e.mediaType || e.mediaType !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO && e.mediaType !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO) {
      return;
    }

    availabilityTimeComplete = e.currentRepresentation.availabilityTimeComplete;
    lowLatencyModeEnabled = !availabilityTimeComplete; // If we enable low latency mode for the first time we also enable the catchup mechanism. This can be deactivated again for instance if the user seeks within the DVR window. We leave deactivation up to the application but also do not activate automatically again.

    if (lowLatencyModeEnabled && !initialCatchupModeActivated) {
      initialCatchupModeActivated = true;
    }
  }

  function getInitialCatchupModeActivated() {
    return initialCatchupModeActivated;
  }
  /**
   * A new manifest has been loaded, updating is still in progress.
   * @private
   */


  function _onManifestUpdated() {
    manifestUpdateInProgress = true;
  }
  /**
   * Manifest update was completed
   * @private
   */


  function _onStreamsComposed() {
    manifestUpdateInProgress = false;
  }

  function _checkEnableLowLatency(mediaInfo) {
    if (mediaInfo && mediaInfo.supplementalProperties && mediaInfo.supplementalProperties[_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME] === 'true') {
      logger.debug('Low Latency critical SupplementalProperty set: Enabling low Latency');
      lowLatencyModeEnabled = true;
    }
  }

  function addAllListeners() {
    videoModel.addEventListener('canplay', _onCanPlay);
    videoModel.addEventListener('canplaythrough', _onCanPlayThrough);
    videoModel.addEventListener('play', _onPlaybackStart);
    videoModel.addEventListener('waiting', _onPlaybackWaiting);
    videoModel.addEventListener('playing', _onPlaybackPlaying);
    videoModel.addEventListener('pause', _onPlaybackPaused);
    videoModel.addEventListener('error', _onPlaybackError);
    videoModel.addEventListener('seeking', _onPlaybackSeeking);
    videoModel.addEventListener('seeked', _onPlaybackSeeked);
    videoModel.addEventListener('timeupdate', _onPlaybackTimeUpdated);
    videoModel.addEventListener('progress', _onPlaybackProgress);
    videoModel.addEventListener('ratechange', _onPlaybackRateChanged);
    videoModel.addEventListener('loadedmetadata', _onPlaybackMetaDataLoaded);
    videoModel.addEventListener('loadeddata', _onPlaybackLoadedData);
    videoModel.addEventListener('stalled', onPlaybackStalled);
    videoModel.addEventListener('ended', _onNativePlaybackEnded);
  }

  function removeAllListeners() {
    videoModel.removeEventListener('canplay', _onCanPlay);
    videoModel.removeEventListener('canplaythrough', _onCanPlayThrough);
    videoModel.removeEventListener('play', _onPlaybackStart);
    videoModel.removeEventListener('waiting', _onPlaybackWaiting);
    videoModel.removeEventListener('playing', _onPlaybackPlaying);
    videoModel.removeEventListener('pause', _onPlaybackPaused);
    videoModel.removeEventListener('error', _onPlaybackError);
    videoModel.removeEventListener('seeking', _onPlaybackSeeking);
    videoModel.removeEventListener('seeked', _onPlaybackSeeked);
    videoModel.removeEventListener('timeupdate', _onPlaybackTimeUpdated);
    videoModel.removeEventListener('progress', _onPlaybackProgress);
    videoModel.removeEventListener('ratechange', _onPlaybackRateChanged);
    videoModel.removeEventListener('loadedmetadata', _onPlaybackMetaDataLoaded);
    videoModel.removeEventListener('loadeddata', _onPlaybackLoadedData);
    videoModel.removeEventListener('stalled', onPlaybackStalled);
    videoModel.removeEventListener('ended', _onNativePlaybackEnded);
  }

  instance = {
    initialize: initialize,
    setConfig: setConfig,
    getTimeToStreamEnd: getTimeToStreamEnd,
    getBufferLevel: getBufferLevel,
    getPlaybackStalled: getPlaybackStalled,
    getTime: getTime,
    getLowLatencyModeEnabled: getLowLatencyModeEnabled,
    getInitialCatchupModeActivated: getInitialCatchupModeActivated,
    getIsManifestUpdateInProgress: getIsManifestUpdateInProgress,
    getPlaybackRate: getPlaybackRate,
    getPlayedRanges: getPlayedRanges,
    getEnded: getEnded,
    getIsDynamic: getIsDynamic,
    getStreamController: getStreamController,
    computeAndSetLiveDelay: computeAndSetLiveDelay,
    getLiveDelay: getLiveDelay,
    getCurrentLiveLatency: getCurrentLiveLatency,
    play: play,
    isPaused: isPaused,
    isStalled: isStalled,
    pause: pause,
    isSeeking: isSeeking,
    getStreamEndTime: getStreamEndTime,
    seek: seek,
    reset: reset,
    updateCurrentTime: updateCurrentTime,
    getAvailabilityStartTime: getAvailabilityStartTime
  };
  setup();
  return instance;
}

PlaybackController.__dashjs_factory_name = 'PlaybackController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getSingletonFactory(PlaybackController));

/***/ }),

/***/ "./src/streaming/controllers/ScheduleController.js":
/*!*********************************************************!*\
  !*** ./src/streaming/controllers/ScheduleController.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1567093__) {

"use strict";
__nested_webpack_require_1567093__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1567093__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _models_FragmentModel__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1567093__(/*! ../models/FragmentModel */ "./src/streaming/models/FragmentModel.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1567093__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1567093__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1567093__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1567093__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1567093__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1567093__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









function ScheduleController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var dashMetrics = config.dashMetrics;
  var mediaPlayerModel = config.mediaPlayerModel;
  var fragmentModel = config.fragmentModel;
  var abrController = config.abrController;
  var playbackController = config.playbackController;
  var textController = config.textController;
  var type = config.type;
  var bufferController = config.bufferController;
  var settings = config.settings;
  var instance, streamInfo, logger, currentRepresentationInfo, timeToLoadDelay, scheduleTimeout, hasVideoTrack, lastFragmentRequest, topQualityIndex, lastInitializedQuality, switchTrack, initSegmentRequired, checkPlaybackQuality;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance().getLogger(instance);
    resetInitialSettings();
    streamInfo = config.streamInfo;
  }

  function initialize(_hasVideoTrack) {
    hasVideoTrack = _hasVideoTrack;
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].BYTES_APPENDED_END_FRAGMENT, _onBytesAppended, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].URL_RESOLUTION_FAILED, _onURLResolutionFailed, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_STARTED, _onPlaybackStarted, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackTimeUpdated, instance);
  }

  function getType() {
    return type;
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function setCurrentRepresentation(representationInfo) {
    currentRepresentationInfo = representationInfo;
  }

  function startScheduleTimer(value) {
    if (bufferController.getIsBufferingCompleted()) return;
    clearScheduleTimer();
    var timeoutValue = !isNaN(value) ? value : 0;
    scheduleTimeout = setTimeout(schedule, timeoutValue);
  }

  function clearScheduleTimer() {
    if (scheduleTimeout) {
      clearTimeout(scheduleTimeout);
      scheduleTimeout = null;
    }
  }

  function hasTopQualityChanged() {
    var streamId = streamInfo.id;
    var newTopQualityIndex = abrController.getMaxAllowedIndexFor(type, streamId);

    if (isNaN(topQualityIndex) || topQualityIndex != newTopQualityIndex) {
      logger.info('Top quality ' + type + ' index has changed from ' + topQualityIndex + ' to ' + newTopQualityIndex);
      topQualityIndex = newTopQualityIndex;
      return true;
    }

    return false;
  }
  /**
   * Schedule the request for an init or a media segment
   */


  function schedule() {
    try {
      // Check if we are supposed to stop scheduling
      if (_shouldClearScheduleTimer()) {
        clearScheduleTimer();
        return;
      }

      if (_shouldScheduleNextRequest()) {
        var qualityChange = false;

        if (checkPlaybackQuality) {
          // in case the playback quality is supposed to be changed, the corresponding StreamProcessor will update the currentRepresentation.
          // The StreamProcessor will also start the schedule timer again once the quality switch has beeen prepared. Consequently, we only call _getNextFragment if the quality is not changed.
          qualityChange = abrController.checkPlaybackQuality(type, streamInfo.id);
        }

        if (!qualityChange) {
          _getNextFragment();
        }
      } else {
        startScheduleTimer(playbackController.getLowLatencyModeEnabled() ? settings.get().streaming.scheduling.lowLatencyTimeout : settings.get().streaming.scheduling.defaultTimeout);
      }
    } catch (e) {
      startScheduleTimer(playbackController.getLowLatencyModeEnabled() ? settings.get().streaming.scheduling.lowLatencyTimeout : settings.get().streaming.scheduling.defaultTimeout);
    }
  }
  /**
   * Triggers the events to start requesting an init or a media segment. This will be picked up by the corresponding StreamProcessor.
   * @private
   */


  function _getNextFragment() {
    // A quality changed occured or we are switching the AdaptationSet. In that case we need to load a new init segment
    if (initSegmentRequired || currentRepresentationInfo.quality !== lastInitializedQuality || switchTrack) {
      if (switchTrack) {
        logger.debug('Switch track for ' + type + ', representation id = ' + currentRepresentationInfo.id);
        switchTrack = false;
      } else {
        logger.debug('Quality has changed, get init request for representationid = ' + currentRepresentationInfo.id);
      }

      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].INIT_FRAGMENT_NEEDED, {
        representationId: currentRepresentationInfo.id,
        sender: instance
      }, {
        streamId: streamInfo.id,
        mediaType: type
      });
      checkPlaybackQuality = false;
      initSegmentRequired = false;
    } // Request a media segment instead
    else {
        logger.debug("Media segment needed for ".concat(type, " and stream id ").concat(streamInfo.id));
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_FRAGMENT_NEEDED, {}, {
          streamId: streamInfo.id,
          mediaType: type
        });
        checkPlaybackQuality = true;
      }
  }
  /**
   * Check if we need to stop scheduling for now.
   * @return {boolean}
   * @private
   */


  function _shouldClearScheduleTimer() {
    try {
      return type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && !textController.isTextEnabled() || playbackController.isPaused() && (!playbackController.getStreamController().getInitialPlayback() || !playbackController.getStreamController().getAutoPlay()) && !settings.get().streaming.scheduling.scheduleWhilePaused;
    } catch (e) {
      return false;
    }
  }
  /**
   * Check if we can start scheduling the next request
   * @return {boolean}
   * @private
   */


  function _shouldScheduleNextRequest() {
    try {
      return currentRepresentationInfo && (isNaN(lastInitializedQuality) || switchTrack || hasTopQualityChanged() || _shouldBuffer());
    } catch (e) {
      return false;
    }
  }
  /**
   * Check if the current buffer level is below our buffer target.
   * @return {boolean}
   * @private
   */


  function _shouldBuffer() {
    if (!type || !currentRepresentationInfo) {
      return true;
    }

    var bufferLevel = dashMetrics.getCurrentBufferLevel(type);
    return bufferLevel < getBufferTarget();
  }
  /**
   * Determine the buffer target depending on the type and whether we have audio and video AdaptationSets available
   * @return {number}
   */


  function getBufferTarget() {
    var bufferTarget = NaN;

    if (!type || !currentRepresentationInfo) {
      return bufferTarget;
    }

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
      bufferTarget = _getBufferTargetForFragmentedText();
    } else if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && hasVideoTrack) {
      bufferTarget = _getBufferTargetForAudio();
    } else {
      bufferTarget = _getGenericBufferTarget();
    }

    return bufferTarget;
  }
  /**
   * Returns the buffer target for fragmented text tracks
   * @return {number}
   * @private
   */


  function _getBufferTargetForFragmentedText() {
    try {
      if (textController.isTextEnabled()) {
        if (isNaN(currentRepresentationInfo.fragmentDuration)) {
          //fragmentDuration of currentRepresentationInfo is not defined,
          // call metrics function to have data in the latest scheduling info...
          // if no metric, returns 0. In this case, rule will return false.
          var schedulingInfo = dashMetrics.getCurrentSchedulingInfo(_constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__["default"].SCHEDULING_INFO);
          return schedulingInfo ? schedulingInfo.duration : 0;
        } else {
          return currentRepresentationInfo.fragmentDuration;
        }
      } else {
        // text is disabled, rule will return false
        return 0;
      }
    } catch (e) {
      return 0;
    }
  }
  /**
   * Returns the buffer target for audio tracks in case we have a video track available as well
   * @return {number}
   * @private
   */


  function _getBufferTargetForAudio() {
    try {
      var videoBufferLevel = dashMetrics.getCurrentBufferLevel(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO); // For multiperiod we need to consider that audio and video segments might have different durations.
      // This can lead to scenarios in which we completely buffered the video segments and the video buffer level for the current period is not changing anymore. However we might still need a small audio segment to finish buffering audio as well.
      // If we set the buffer time of audio equal to the video buffer time scheduling for the remaining audio segment will only be triggered when audio fragmentDuration > videoBufferLevel. That will delay preloading of the upcoming period.
      // Should find a better solution than just adding 1

      if (isNaN(currentRepresentationInfo.fragmentDuration)) {
        return videoBufferLevel + 1;
      } else {
        return Math.max(videoBufferLevel + 1, currentRepresentationInfo.fragmentDuration);
      }
    } catch (e) {
      return 0;
    }
  }
  /**
   * Determines the generic buffer target, for instance for video tracks
   * @return {number}
   * @private
   */


  function _getGenericBufferTarget() {
    try {
      var _streamInfo = currentRepresentationInfo.mediaInfo.streamInfo;

      if (abrController.isPlayingAtTopQuality(_streamInfo)) {
        var isLongFormContent = _streamInfo.manifestInfo.duration >= settings.get().streaming.buffer.longFormContentDurationThreshold;
        return isLongFormContent ? settings.get().streaming.buffer.bufferTimeAtTopQualityLongForm : settings.get().streaming.buffer.bufferTimeAtTopQuality;
      } else {
        return mediaPlayerModel.getStableBufferTime();
      }
    } catch (e) {
      return mediaPlayerModel.getStableBufferTime();
    }
  }

  function setSwitchTrack(value) {
    switchTrack = value;
  }

  function getSwitchStrack() {
    return switchTrack;
  }

  function _onPlaybackTimeUpdated() {
    _completeQualityChange(true);
  }

  function _completeQualityChange(trigger) {
    if (playbackController && fragmentModel) {
      var item = fragmentModel.getRequests({
        state: _models_FragmentModel__WEBPACK_IMPORTED_MODULE_1__["default"].FRAGMENT_MODEL_EXECUTED,
        time: playbackController.getTime(),
        threshold: 0
      })[0];

      if (item && playbackController.getTime() >= item.startTime) {
        if ((!lastFragmentRequest.mediaInfo || item.mediaInfo.type === lastFragmentRequest.mediaInfo.type && item.mediaInfo.id !== lastFragmentRequest.mediaInfo.id) && trigger) {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].TRACK_CHANGE_RENDERED, {
            mediaType: type,
            oldMediaInfo: lastFragmentRequest.mediaInfo,
            newMediaInfo: item.mediaInfo,
            streamId: streamInfo.id
          });
        }

        if ((item.quality !== lastFragmentRequest.quality || item.adaptationIndex !== lastFragmentRequest.adaptationIndex) && trigger) {
          logger.debug("Quality change rendered for streamId ".concat(streamInfo.id, " and type ").concat(type));
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].QUALITY_CHANGE_RENDERED, {
            mediaType: type,
            oldQuality: lastFragmentRequest.quality,
            newQuality: item.quality,
            streamId: streamInfo.id
          });
        }

        lastFragmentRequest = {
          mediaInfo: item.mediaInfo,
          quality: item.quality,
          adaptationIndex: item.adaptationIndex
        };
      }
    }
  }

  function _onBytesAppended(e) {
    logger.debug("Appended bytes for ".concat(e.mediaType, " and stream id ").concat(streamInfo.id)); // we save the last initialized quality. That way we make sure that the media fragments we are about to append match the init segment

    if (isNaN(e.index) || isNaN(lastInitializedQuality)) {
      lastInitializedQuality = e.quality;
      logger.info('[' + type + '] ' + 'lastInitializedRepresentationInfo changed to ' + e.quality);
    }

    startScheduleTimer(0);
  }

  function _onURLResolutionFailed() {
    fragmentModel.abortRequests();
    clearScheduleTimer();
  }

  function _onPlaybackStarted() {
    if (!settings.get().streaming.scheduling.scheduleWhilePaused) {
      startScheduleTimer();
    }
  }

  function _onPlaybackRateChanged(e) {
    dashMetrics.updatePlayListTraceMetrics({
      playbackspeed: e.playbackRate.toString()
    });
  }

  function setTimeToLoadDelay(value) {
    timeToLoadDelay = value;
  }

  function getTimeToLoadDelay() {
    return timeToLoadDelay;
  }

  function setCheckPlaybackQuality(value) {
    checkPlaybackQuality = value;
  }

  function setInitSegmentRequired(value) {
    initSegmentRequired = value;
  }

  function resetInitialSettings() {
    checkPlaybackQuality = true;
    timeToLoadDelay = 0;
    lastInitializedQuality = NaN;
    lastFragmentRequest = {
      mediaInfo: undefined,
      quality: NaN,
      adaptationIndex: NaN
    };
    topQualityIndex = NaN;
    switchTrack = false;
    initSegmentRequired = false;
  }

  function reset() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].BYTES_APPENDED_END_FRAGMENT, _onBytesAppended, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].URL_RESOLUTION_FAILED, _onURLResolutionFailed, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_STARTED, _onPlaybackStarted, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackTimeUpdated, instance);
    clearScheduleTimer();

    _completeQualityChange(false);

    resetInitialSettings();
    streamInfo = null;
  }

  function getPlaybackController() {
    return playbackController;
  }

  instance = {
    initialize: initialize,
    getType: getType,
    getStreamId: getStreamId,
    setCurrentRepresentation: setCurrentRepresentation,
    setTimeToLoadDelay: setTimeToLoadDelay,
    getTimeToLoadDelay: getTimeToLoadDelay,
    setSwitchTrack: setSwitchTrack,
    getSwitchStrack: getSwitchStrack,
    startScheduleTimer: startScheduleTimer,
    clearScheduleTimer: clearScheduleTimer,
    reset: reset,
    getBufferTarget: getBufferTarget,
    getPlaybackController: getPlaybackController,
    setCheckPlaybackQuality: setCheckPlaybackQuality,
    setInitSegmentRequired: setInitSegmentRequired
  };
  setup();
  return instance;
}

ScheduleController.__dashjs_factory_name = 'ScheduleController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__["default"].getClassFactory(ScheduleController));

/***/ }),

/***/ "./src/streaming/controllers/ServiceDescriptionController.js":
/*!*******************************************************************!*\
  !*** ./src/streaming/controllers/ServiceDescriptionController.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1586635__) {

"use strict";
__nested_webpack_require_1586635__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1586635__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1586635__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1586635__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1586635__(/*! ../../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




var SUPPORTED_SCHEMES = [_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].SERVICE_DESCRIPTION_DVB_LL_SCHEME];
var MEDIA_TYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  ANY: 'any',
  ALL: 'all'
};

function ServiceDescriptionController() {
  var context = this.context;
  var instance, serviceDescriptionSettings, prftOffsets, logger, adapter;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);

    _resetInitialSettings();
  }

  function setConfig(config) {
    if (!config) return;

    if (config.adapter) {
      adapter = config.adapter;
    }
  }

  function reset() {
    _resetInitialSettings();
  }

  function _resetInitialSettings() {
    serviceDescriptionSettings = {
      liveDelay: NaN,
      liveCatchup: {
        maxDrift: NaN,
        playbackRate: NaN
      },
      minBitrate: {},
      maxBitrate: {},
      initialBitrate: {}
    };
    prftOffsets = [];
  }
  /**
   * Returns the service description settings for latency, catchup and bandwidth
   */


  function getServiceDescriptionSettings() {
    return serviceDescriptionSettings;
  }
  /**
   * Check for potential ServiceDescriptor elements in the MPD and update the settings accordingly
   * @param {object} manifestInfo
   * @private
   */


  function applyServiceDescription(manifestInfo) {
    if (!manifestInfo || !manifestInfo.serviceDescriptions) {
      return;
    }

    var supportedServiceDescriptions = manifestInfo.serviceDescriptions.filter(function (sd) {
      return SUPPORTED_SCHEMES.includes(sd.schemeIdUri);
    });
    var allClientsServiceDescriptions = manifestInfo.serviceDescriptions.filter(function (sd) {
      return sd.schemeIdUri == null;
    });
    var sd = supportedServiceDescriptions.length > 0 ? supportedServiceDescriptions[supportedServiceDescriptions.length - 1] : allClientsServiceDescriptions[allClientsServiceDescriptions.length - 1];
    if (!sd) return;

    if (sd.latency && sd.latency.target > 0) {
      _applyServiceDescriptionLatency(sd);
    }

    if (sd.playbackRate && sd.playbackRate.max > 1.0) {
      _applyServiceDescriptionPlaybackRate(sd);
    }

    if (sd.operatingQuality) {
      _applyServiceDescriptionOperatingQuality(sd);
    }

    if (sd.operatingBandwidth) {
      _applyServiceDescriptionOperatingBandwidth(sd);
    }
  }
  /**
   * Adjust the latency targets for the service.
   * @param {object} sd - service description element
   * @private
   */


  function _applyServiceDescriptionLatency(sd) {
    var params;

    if (sd.schemeIdUri === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].SERVICE_DESCRIPTION_DVB_LL_SCHEME) {
      params = _getDvbServiceDescriptionLatencyParameters(sd);
    } else {
      params = _getStandardServiceDescriptionLatencyParameters(sd);
    }

    if (prftOffsets.length > 0) {
      var _calculateTimeOffset2 = _calculateTimeOffset(params),
          to = _calculateTimeOffset2.to,
          id = _calculateTimeOffset2.id; // TS 103 285 Clause 10.20.4. 3) Subtract calculated offset from Latency@target converted from milliseconds
      // liveLatency does not consider ST@availabilityTimeOffset so leave out that step
      // Since maxDrift is a difference rather than absolute it does not need offset applied


      serviceDescriptionSettings.liveDelay = params.liveDelay - to;
      serviceDescriptionSettings.liveCatchup.maxDrift = params.maxDrift;
      logger.debug("\n                Found latency properties coming from service description. Applied time offset of ".concat(to, " from ProducerReferenceTime element with id ").concat(id, ".\n                Live Delay: ").concat(params.liveDelay - to, ", Live catchup max drift: ").concat(params.maxDrift, "\n            "));
    } else {
      serviceDescriptionSettings.liveDelay = params.liveDelay;
      serviceDescriptionSettings.liveCatchup.maxDrift = params.maxDrift;
      logger.debug("Found latency properties coming from service description: Live Delay: ".concat(params.liveDelay, ", Live catchup max drift: ").concat(params.maxDrift));
    }
  }
  /**
   * Get default parameters for liveDelay,maxDrift
   * @param {object} sd
   * @return {{maxDrift: (number|undefined), liveDelay: number, referenceId: (number|undefined)}}
   * @private
   */


  function _getStandardServiceDescriptionLatencyParameters(sd) {
    var liveDelay = sd.latency.target / 1000;
    var maxDrift = !isNaN(sd.latency.max) && sd.latency.max > sd.latency.target ? (sd.latency.max - sd.latency.target + 500) / 1000 : NaN;
    var referenceId = sd.latency.referenceId || NaN;
    return {
      liveDelay: liveDelay,
      maxDrift: maxDrift,
      referenceId: referenceId
    };
  }
  /**
   * Get DVB DASH parameters for liveDelay,maxDrift
   * @param sd
   * @return {{maxDrift: (number|undefined), liveDelay: number, referenceId: (number|undefined)}}
   * @private
   */


  function _getDvbServiceDescriptionLatencyParameters(sd) {
    var liveDelay = sd.latency.target / 1000;
    var maxDrift = !isNaN(sd.latency.max) && sd.latency.max > sd.latency.target ? (sd.latency.max - sd.latency.target + 500) / 1000 : NaN;
    var referenceId = sd.latency.referenceId || NaN;
    return {
      liveDelay: liveDelay,
      maxDrift: maxDrift,
      referenceId: referenceId
    };
  }
  /**
   * Adjust the playback rate targets for the service
   * @param {object} sd
   * @private
   */


  function _applyServiceDescriptionPlaybackRate(sd) {
    var playbackRate = Math.round((sd.playbackRate.max - 1.0) * 1000) / 1000;
    serviceDescriptionSettings.liveCatchup.playbackRate = playbackRate;
    logger.debug("Found latency properties coming from service description: Live catchup playback rate: ".concat(playbackRate));
  }
  /**
   * Used to specify a quality ranking. We do not support this yet.
   * @private
   */


  function _applyServiceDescriptionOperatingQuality() {
    return;
  }
  /**
   * Adjust the operating quality targets for the service
   * @param {object} sd
   * @private
   */


  function _applyServiceDescriptionOperatingBandwidth(sd) {
    // Aggregation of media types is not supported yet
    if (!sd || !sd.operatingBandwidth || !sd.operatingBandwidth.mediaType || sd.operatingBandwidth.mediaType === MEDIA_TYPES.ALL) {
      return;
    }

    var params = {};
    params.minBandwidth = sd.operatingBandwidth.min;
    params.maxBandwidth = sd.operatingBandwidth.max;
    params.targetBandwidth = sd.operatingBandwidth.target;
    var mediaTypesToApply = [];

    if (sd.operatingBandwidth.mediaType === MEDIA_TYPES.VIDEO || sd.operatingBandwidth.mediaType === MEDIA_TYPES.AUDIO) {
      mediaTypesToApply.push(sd.operatingBandwidth.mediaType);
    } else if (sd.operatingBandwidth.mediaType === MEDIA_TYPES.ANY) {
      mediaTypesToApply.push(MEDIA_TYPES.AUDIO);
      mediaTypesToApply.push(MEDIA_TYPES.VIDEO);
    }

    mediaTypesToApply.forEach(function (mediaType) {
      if (!isNaN(params.minBandwidth)) {
        _updateBandwidthSetting('minBitrate', mediaType, params.minBandwidth);
      }

      if (!isNaN(params.maxBandwidth)) {
        _updateBandwidthSetting('maxBitrate', mediaType, params.maxBandwidth);
      }

      if (!isNaN(params.targetBandwidth)) {
        _updateBandwidthSetting('initialBitrate', mediaType, params.targetBandwidth);
      }
    });
  }
  /**
   * Update the bandwidth settings vor a specific field and media type
   * @param {string} field
   * @param {string} mediaType
   * @param {number} value
   * @private
   */


  function _updateBandwidthSetting(field, mediaType, value) {
    try {
      // Service description values are specified in bps. Settings expect the value in kbps
      serviceDescriptionSettings[field][mediaType] = value / 1000;
    } catch (e) {
      logger.error(e);
    }
  }
  /**
   * Returns the current calculated time offsets based on ProducerReferenceTime elements
   * @returns {array}
   */


  function getProducerReferenceTimeOffsets() {
    return prftOffsets;
  }
  /**
   * Calculates an array of time offsets each with matching ProducerReferenceTime id.
   * Call before applyServiceDescription if producer reference time elements should be considered.
   * @param {array} streamInfos
   * @returns {array}
   * @private
   */


  function calculateProducerReferenceTimeOffsets(streamInfos) {
    try {
      var timeOffsets = [];

      if (streamInfos && streamInfos.length > 0) {
        var mediaTypes = [_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].VIDEO, _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].AUDIO, _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].TEXT];
        var astInSeconds = adapter.getAvailabilityStartTime() / 1000;
        streamInfos.forEach(function (streamInfo) {
          var offsets = mediaTypes.reduce(function (acc, mediaType) {
            acc = acc.concat(adapter.getAllMediaInfoForType(streamInfo, mediaType));
            return acc;
          }, []).reduce(function (acc, mediaInfo) {
            var prts = adapter.getProducerReferenceTimes(streamInfo, mediaInfo);
            prts.forEach(function (prt) {
              var voRepresentations = adapter.getVoRepresentations(mediaInfo);

              if (voRepresentations && voRepresentations.length > 0 && voRepresentations[0].adaptation && voRepresentations[0].segmentInfoType === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].SEGMENT_TEMPLATE) {
                var voRep = voRepresentations[0];
                var d = new Date(prt[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].WALL_CLOCK_TIME]);
                var wallClockTime = d.getTime() / 1000; // TS 103 285 Clause 10.20.4
                // 1) Calculate PRT0
                // i) take the PRT@presentationTime and subtract any ST@presentationTimeOffset
                // ii) convert this time to seconds by dividing by ST@timescale
                // iii) Add this to start time of period that contains PRT.
                // N.B presentationTimeOffset is already divided by timescale at this point

                var prt0 = wallClockTime - (prt[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].PRESENTATION_TIME] / voRep[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].TIMESCALE] - voRep[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].PRESENTATION_TIME_OFFSET] + streamInfo.start); // 2) Calculate TO between PRT at the start of MPD timeline and the AST

                var to = astInSeconds - prt0; // 3) Not applicable as liveLatency does not consider ST@availabilityTimeOffset

                acc.push({
                  id: prt[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_3__["default"].ID],
                  to: to
                });
              }
            });
            return acc;
          }, []);
          timeOffsets = timeOffsets.concat(offsets);
        });
      }

      prftOffsets = timeOffsets;
    } catch (e) {
      logger.error(e);
      prftOffsets = [];
    }
  }

  ;
  /**
   * Calculates offset to apply to live delay as described in TS 103 285 Clause 10.20.4
   * @param {object} sdLatency - service description latency element
   * @returns {number}
   * @private
   */

  function _calculateTimeOffset(sdLatency) {
    var to = 0,
        id;
    var offset = prftOffsets.filter(function (prt) {
      return prt.id === sdLatency.referenceId;
    }); // If only one ProducerReferenceTime to generate one TO, then use that regardless of matching ids

    if (offset.length === 0) {
      to = prftOffsets.length > 0 ? prftOffsets[0].to : 0;
      id = prftOffsets[0].id || NaN;
    } else {
      // If multiple id matches, use the first but this should be invalid
      to = offset[0].to || 0;
      id = offset[0].id || NaN;
    }

    return {
      to: to,
      id: id
    };
  }

  instance = {
    getServiceDescriptionSettings: getServiceDescriptionSettings,
    getProducerReferenceTimeOffsets: getProducerReferenceTimeOffsets,
    calculateProducerReferenceTimeOffsets: calculateProducerReferenceTimeOffsets,
    applyServiceDescription: applyServiceDescription,
    reset: reset,
    setConfig: setConfig
  };
  setup();
  return instance;
}

ServiceDescriptionController.__dashjs_factory_name = 'ServiceDescriptionController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(ServiceDescriptionController));

/***/ }),

/***/ "./src/streaming/controllers/StreamController.js":
/*!*******************************************************!*\
  !*** ./src/streaming/controllers/StreamController.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1602489__) {

"use strict";
__nested_webpack_require_1602489__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1602489__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1602489__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _Stream__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1602489__(/*! ../Stream */ "./src/streaming/Stream.js");
/* harmony import */ var _ManifestUpdater__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1602489__(/*! ../ManifestUpdater */ "./src/streaming/ManifestUpdater.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1602489__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1602489__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1602489__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1602489__(/*! ../vo/metrics/PlayList */ "./src/streaming/vo/metrics/PlayList.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1602489__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _utils_InitCache__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1602489__(/*! ../utils/InitCache */ "./src/streaming/utils/InitCache.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1602489__(/*! ../utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1602489__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _TimeSyncController__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1602489__(/*! ./TimeSyncController */ "./src/streaming/controllers/TimeSyncController.js");
/* harmony import */ var _MediaSourceController__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1602489__(/*! ./MediaSourceController */ "./src/streaming/controllers/MediaSourceController.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_1602489__(/*! ../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_15__ = __nested_webpack_require_1602489__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _EventController__WEBPACK_IMPORTED_MODULE_16__ = __nested_webpack_require_1602489__(/*! ./EventController */ "./src/streaming/controllers/EventController.js");
/* harmony import */ var _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_17__ = __nested_webpack_require_1602489__(/*! ../constants/ConformanceViolationConstants */ "./src/streaming/constants/ConformanceViolationConstants.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


















var PLAYBACK_ENDED_TIMER_INTERVAL = 200;
var DVR_WAITING_OFFSET = 2;

function StreamController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var instance, logger, capabilities, capabilitiesFilter, manifestUpdater, manifestLoader, manifestModel, adapter, dashMetrics, mediaSourceController, timeSyncController, baseURLController, segmentBaseController, uriFragmentModel, abrController, mediaController, eventController, initCache, urlUtils, errHandler, timelineConverter, streams, activeStream, protectionController, textController, protectionData, autoPlay, isStreamSwitchingInProgress, hasMediaError, hasInitialisationError, mediaSource, videoModel, playbackController, serviceDescriptionController, mediaPlayerModel, customParametersModel, isPaused, initialPlayback, playbackEndedTimerInterval, bufferSinks, preloadingStreams, supportsChangeType, settings, firstLicenseIsFetched, waitForPlaybackStartTimeout, errorInformation;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance().getLogger(instance);
    timeSyncController = Object(_TimeSyncController__WEBPACK_IMPORTED_MODULE_12__["default"])(context).getInstance();
    mediaSourceController = Object(_MediaSourceController__WEBPACK_IMPORTED_MODULE_13__["default"])(context).getInstance();
    initCache = Object(_utils_InitCache__WEBPACK_IMPORTED_MODULE_9__["default"])(context).getInstance();
    urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_10__["default"])(context).getInstance();
    resetInitialSettings();
  }

  function initialize(autoPl, protData) {
    _checkConfig();

    autoPlay = autoPl;
    protectionData = protData;
    timelineConverter.initialize();
    manifestUpdater = Object(_ManifestUpdater__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create();
    manifestUpdater.setConfig({
      manifestModel: manifestModel,
      adapter: adapter,
      manifestLoader: manifestLoader,
      errHandler: errHandler,
      settings: settings
    });
    manifestUpdater.initialize();
    eventController = Object(_EventController__WEBPACK_IMPORTED_MODULE_16__["default"])(context).getInstance();
    eventController.setConfig({
      manifestUpdater: manifestUpdater,
      playbackController: playbackController,
      settings: settings
    });
    eventController.start();
    timeSyncController.setConfig({
      dashMetrics: dashMetrics,
      baseURLController: baseURLController,
      errHandler: errHandler,
      settings: settings
    });
    timeSyncController.initialize();

    if (protectionController) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PROTECTION_CREATED, {
        controller: protectionController
      });
      protectionController.setMediaElement(videoModel.getElement());

      if (protectionData) {
        protectionController.setProtectionData(protectionData);
      }
    }

    registerEvents();
  }

  function registerEvents() {
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackTimeUpdated, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_ERROR, _onPlaybackError, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_STARTED, _onPlaybackStarted, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_PAUSED, _onPlaybackPaused, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_ENDED, _onPlaybackEnded, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].METRIC_ADDED, _onMetricAdded, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].MANIFEST_VALIDITY_CHANGED, _onManifestValidityChanged, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_LEVEL_UPDATED, _onBufferLevelUpdated, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].QUALITY_CHANGE_REQUESTED, _onQualityChanged, instance);

    if (_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].KEY_SESSION_UPDATED) {
      eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].KEY_SESSION_UPDATED, _onKeySessionUpdated, instance);
    }

    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MANIFEST_UPDATED, _onManifestUpdated, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].STREAM_BUFFERING_COMPLETED, _onStreamBufferingCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].TIME_SYNCHRONIZATION_COMPLETED, _onTimeSyncCompleted, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].CURRENT_TRACK_CHANGED, _onCurrentTrackChanged, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_LIVE_DELAY, _onLiveDelaySettingUpdated, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, _onLiveDelaySettingUpdated, instance);
  }

  function unRegisterEvents() {
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_TIME_UPDATED, _onPlaybackTimeUpdated, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_ERROR, _onPlaybackError, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_STARTED, _onPlaybackStarted, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_PAUSED, _onPlaybackPaused, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].PLAYBACK_ENDED, _onPlaybackEnded, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].METRIC_ADDED, _onMetricAdded, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].MANIFEST_VALIDITY_CHANGED, _onManifestValidityChanged, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_LEVEL_UPDATED, _onBufferLevelUpdated, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].QUALITY_CHANGE_REQUESTED, _onQualityChanged, instance);

    if (_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].KEY_SESSION_UPDATED) {
      eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].KEY_SESSION_UPDATED, _onKeySessionUpdated, instance);
    }

    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MANIFEST_UPDATED, _onManifestUpdated, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].STREAM_BUFFERING_COMPLETED, _onStreamBufferingCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].TIME_SYNCHRONIZATION_COMPLETED, _onTimeSyncCompleted, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].CURRENT_TRACK_CHANGED, _onCurrentTrackChanged, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_LIVE_DELAY, _onLiveDelaySettingUpdated, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT, _onLiveDelaySettingUpdated, instance);
  }
  /**
   * When the UTC snychronization is completed we can compose the streams
   * @private
   */


  function _onTimeSyncCompleted()
  /*e*/
  {
    _composeStreams();
  }
  /**
   *
   * @private
   */


  function _onKeySessionUpdated() {
    firstLicenseIsFetched = true;
  }
  /**
   * Setup the stream objects after the stream start and each MPD reload. This function is called after the UTC sync has been done (TIME_SYNCHRONIZATION_COMPLETED)
   * @private
   */


  function _composeStreams() {
    try {
      var streamsInfo = adapter.getStreamsInfo();

      if (!activeStream && streamsInfo.length === 0) {
        throw new Error('There are no periods in the MPD');
      }

      if (activeStream && streamsInfo.length > 0) {
        dashMetrics.updateManifestUpdateInfo({
          currentTime: playbackController.getTime(),
          buffered: videoModel.getBufferRange(),
          presentationStartTime: streamsInfo[0].start,
          clientTimeOffset: timelineConverter.getClientTimeOffset()
        });
      } // Filter streams that are outdated and not included in the MPD anymore


      if (streams.length > 0) {
        _filterOutdatedStreams(streamsInfo);
      }

      var promises = [];

      for (var i = 0, ln = streamsInfo.length; i < ln; i++) {
        var streamInfo = streamsInfo[i];
        promises.push(_initializeOrUpdateStream(streamInfo));
        dashMetrics.addManifestUpdateStreamInfo(streamInfo);
      }

      Promise.all(promises).then(function () {
        if (!activeStream) {
          _initializeForFirstStream(streamsInfo);
        }

        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].STREAMS_COMPOSED); // Additional periods might have been added after an MPD update. Check again if we can start prebuffering.

        _checkIfPrebufferingCanStart();
      })["catch"](function (e) {
        throw e;
      });
    } catch (e) {
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_14__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_15__["default"].MANIFEST_ERROR_ID_NOSTREAMS_CODE, e.message + ' nostreamscomposed', manifestModel.getValue()));
      hasInitialisationError = true;
      reset();
    }
  }
  /**
   * Called for each stream when composition is performed. Either a new instance of Stream is created or the existing one is updated.
   * @param {object} streamInfo
   * @private
   */


  function _initializeOrUpdateStream(streamInfo) {
    var stream = getStreamById(streamInfo.id); // If the Stream object does not exist we probably loaded the manifest the first time or it was
    // introduced in the updated manifest, so we need to create a new Stream and perform all the initialization operations

    if (!stream) {
      stream = Object(_Stream__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
        manifestModel: manifestModel,
        mediaPlayerModel: mediaPlayerModel,
        dashMetrics: dashMetrics,
        manifestUpdater: manifestUpdater,
        adapter: adapter,
        timelineConverter: timelineConverter,
        capabilities: capabilities,
        capabilitiesFilter: capabilitiesFilter,
        errHandler: errHandler,
        baseURLController: baseURLController,
        segmentBaseController: segmentBaseController,
        textController: textController,
        abrController: abrController,
        playbackController: playbackController,
        eventController: eventController,
        mediaController: mediaController,
        protectionController: protectionController,
        videoModel: videoModel,
        streamInfo: streamInfo,
        settings: settings
      });
      streams.push(stream);
      stream.initialize();
      return Promise.resolve();
    } else {
      return stream.updateData(streamInfo);
    }
  }
  /**
   * Initialize playback for the first period.
   * @param {array} streamsInfo
   * @private
   */


  function _initializeForFirstStream(streamsInfo) {
    // Add the DVR window so we can calculate the right starting point
    addDVRMetric(); // If the start is in the future we need to wait

    var dvrRange = dashMetrics.getCurrentDVRInfo().range;

    if (dvrRange.end < dvrRange.start) {
      if (waitForPlaybackStartTimeout) {
        clearTimeout(waitForPlaybackStartTimeout);
      }

      var waitingTime = Math.min(((dvrRange.end - dvrRange.start) * -1 + DVR_WAITING_OFFSET) * 1000, 2147483647);
      logger.debug("Waiting for ".concat(waitingTime, " ms before playback can start"));
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].AST_IN_FUTURE, {
        delay: waitingTime
      });
      waitForPlaybackStartTimeout = setTimeout(function () {
        _initializeForFirstStream(streamsInfo);
      }, waitingTime);
      return;
    } // Apply Service description parameters.


    if (settings.get().streaming.applyProducerReferenceTime) {
      serviceDescriptionController.calculateProducerReferenceTimeOffsets(streamsInfo);
    }

    ;
    var manifestInfo = streamsInfo[0].manifestInfo;

    if (settings.get().streaming.applyServiceDescription) {
      serviceDescriptionController.applyServiceDescription(manifestInfo);
    } // Compute and set the live delay


    if (adapter.getIsDynamic()) {
      var fragmentDuration = _getFragmentDurationForLiveDelayCalculation(streamsInfo, manifestInfo);

      playbackController.computeAndSetLiveDelay(fragmentDuration, manifestInfo);
    } // Figure out the correct start time and the correct start period


    var startTime = _getInitialStartTime();

    var initialStream = getStreamForTime(startTime);
    var startStream = initialStream !== null ? initialStream : streams[0];
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].INITIAL_STREAM_SWITCH, {
      startTime: startTime
    });

    _switchStream(startStream, null, startTime);

    _startPlaybackEndedTimerInterval();
  }
  /**
   * Switch from the current stream (period) to the next stream (period).
   * @param {object} stream
   * @param {object} previousStream
   * @param {number} seekTime
   * @private
   */


  function _switchStream(stream, previousStream, seekTime) {
    try {
      if (isStreamSwitchingInProgress || !stream || previousStream === stream && stream.getIsActive()) {
        return;
      }

      isStreamSwitchingInProgress = true;
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PERIOD_SWITCH_STARTED, {
        fromStreamInfo: previousStream ? previousStream.getStreamInfo() : null,
        toStreamInfo: stream.getStreamInfo()
      });
      var keepBuffers = false;
      activeStream = stream;

      if (previousStream) {
        keepBuffers = _canSourceBuffersBeReused(stream, previousStream);
        previousStream.deactivate(keepBuffers);
      } // Determine seek time when switching to new period
      // - seek at given seek time
      // - or seek at period start if upcoming period is not prebuffered


      seekTime = !isNaN(seekTime) ? seekTime : !keepBuffers && previousStream ? stream.getStreamInfo().start : NaN;
      logger.info("Switch to stream ".concat(stream.getId(), ". Seektime is ").concat(seekTime, ", current playback time is ").concat(playbackController.getTime(), ". Seamless period switch is set to ").concat(keepBuffers));
      preloadingStreams = preloadingStreams.filter(function (s) {
        return s.getId() !== activeStream.getId();
      });
      playbackController.initialize(getActiveStreamInfo(), !!previousStream);

      if (videoModel.getElement()) {
        _openMediaSource(seekTime, keepBuffers);
      }
    } catch (e) {
      isStreamSwitchingInProgress = false;
    }
  }
  /**
   * Setup the Media Source. Open MSE and attach event listeners
   * @param {number} seekTime
   * @param {boolean} keepBuffers
   * @private
   */


  function _openMediaSource(seekTime, keepBuffers) {
    var sourceUrl;

    function _onMediaSourceOpen() {
      // Manage situations in which a call to reset happens while MediaSource is being opened
      if (!mediaSource || mediaSource.readyState !== 'open') return;
      logger.debug('MediaSource is open!');
      window.URL.revokeObjectURL(sourceUrl);
      mediaSource.removeEventListener('sourceopen', _onMediaSourceOpen);
      mediaSource.removeEventListener('webkitsourceopen', _onMediaSourceOpen);

      _setMediaDuration();

      var dvrInfo = dashMetrics.getCurrentDVRInfo();
      mediaSourceController.setSeekable(dvrInfo.range.start, dvrInfo.range.end);

      _activateStream(seekTime, keepBuffers);
    }

    function _open() {
      mediaSource.addEventListener('sourceopen', _onMediaSourceOpen, false);
      mediaSource.addEventListener('webkitsourceopen', _onMediaSourceOpen, false);
      sourceUrl = mediaSourceController.attachMediaSource(videoModel);
      logger.debug('MediaSource attached to element.  Waiting on open...');
    }

    if (!mediaSource) {
      mediaSource = mediaSourceController.createMediaSource();

      _open();
    } else {
      if (keepBuffers) {
        _activateStream(seekTime, keepBuffers);
      } else {
        mediaSourceController.detachMediaSource(videoModel);

        _open();
      }
    }
  }
  /**
   * Activates a new stream.
   * @param {number} seekTime
   * @param {boolean} keepBuffers
   */


  function _activateStream(seekTime, keepBuffers) {
    activeStream.activate(mediaSource, keepBuffers ? bufferSinks : undefined, seekTime).then(function (sinks) {
      // check if change type is supported by the browser
      if (sinks) {
        var keys = Object.keys(sinks);

        if (keys.length > 0 && sinks[keys[0]].getBuffer().changeType) {
          supportsChangeType = true;
        }

        bufferSinks = sinks;
      } // Set the initial time for this stream in the StreamProcessor


      if (!isNaN(seekTime)) {
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].SEEK_TARGET, {
          time: seekTime
        }, {
          streamId: activeStream.getId()
        });
        playbackController.seek(seekTime, false, true);
        activeStream.startScheduleControllers();
      }

      isStreamSwitchingInProgress = false;
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PERIOD_SWITCH_COMPLETED, {
        toStreamInfo: getActiveStreamInfo()
      });
    });
  }
  /**
   * A playback seeking event was triggered. We need to disable the preloading streams and call the respective seeking handler.
   * We distinguish between inner period seeks and outer period seeks
   * @param {object} e
   * @private
   */


  function _onPlaybackSeeking(e) {
    var oldTime = playbackController.getTime();
    var newTime = e.seekTime;
    var seekToStream = getStreamForTime(newTime);

    if (!seekToStream || seekToStream === activeStream) {
      _cancelPreloading(oldTime, newTime);

      _handleInnerPeriodSeek(e);
    } else if (seekToStream && seekToStream !== activeStream) {
      _cancelPreloading(oldTime, newTime, seekToStream);

      _handleOuterPeriodSeek(e, seekToStream);
    }

    _createPlaylistMetrics(_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayList"].SEEK_START_REASON);
  }
  /**
   * Cancels the preloading of certain streams based on the position we are seeking to.
   * @param {number} oldTime
   * @param {number} newTime
   * @param {boolean} isInnerPeriodSeek
   * @private
   */


  function _cancelPreloading(oldTime, newTime) {
    var seekToStream = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    // Inner period seek forward
    if (oldTime <= newTime && !seekToStream) {
      _deactivateAllPreloadingStreams();
    } // Inner period seek: If we seek backwards we might need to prune the period(s) that are currently being prebuffered. For now deactivate everything
    else if (oldTime > newTime && !seekToStream) {
        _deactivateAllPreloadingStreams();
      } // Outer period seek: Deactivate everything for now
      else {
          _deactivateAllPreloadingStreams();
        }
  }
  /**
   * Deactivates all preloading streams
   * @private
   */


  function _deactivateAllPreloadingStreams() {
    if (preloadingStreams && preloadingStreams.length > 0) {
      preloadingStreams.forEach(function (s) {
        s.deactivate(true);
      });
      preloadingStreams = [];
    }
  }
  /**
   * Handle an inner period seek. Prepare all StreamProcessors for the seek.
   * @param {object} e
   * @private
   */


  function _handleInnerPeriodSeek(e) {
    var streamProcessors = activeStream.getProcessors();
    streamProcessors.forEach(function (sp) {
      return sp.prepareInnerPeriodPlaybackSeeking(e);
    });

    _flushPlaylistMetrics(_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].USER_REQUEST_STOP_REASON);
  }
  /**
   * Handle an outer period seek. Dispatch the corresponding event to be handled in the BufferControllers and the ScheduleControllers
   * @param {object} e
   * @param {object} seekToStream
   * @private
   */


  function _handleOuterPeriodSeek(e, seekToStream) {
    // Stop segment requests
    var seekTime = e && !isNaN(e.seekTime) ? e.seekTime : NaN;
    var streamProcessors = activeStream.getProcessors();
    var promises = streamProcessors.map(function (sp) {
      // Cancel everything in case the active stream is still buffering
      return sp.prepareOuterPeriodPlaybackSeeking(e);
    });
    Promise.all(promises).then(function () {
      _switchStream(seekToStream, activeStream, seekTime);
    })["catch"](function (e) {
      errHandler.error(e);
    });
  }
  /**
   * A track change occured. We deactivate the preloading streams
   * @param {object} e
   * @private
   */


  function _onCurrentTrackChanged(e) {
    // Track was changed in non active stream. No need to do anything, this only happens when a stream starts preloading
    if (e.newMediaInfo.streamInfo.id !== activeStream.getId()) {
      return;
    } // If the track was changed in the active stream we need to stop preloading and remove the already prebuffered stuff. Since we do not support preloading specific handling of specific AdaptationSets yet.


    _deactivateAllPreloadingStreams();

    activeStream.prepareTrackChange(e);
  }
  /**
   * If the source buffer can be reused we can potentially start buffering the next period
   * @param {object} nextStream
   * @param {object} previousStream
   * @return {boolean}
   * @private
   */


  function _canSourceBuffersBeReused(nextStream, previousStream) {
    try {
      // Seamless period switch allowed only if:
      // - none of the periods uses contentProtection.
      // - AND changeType method implemented by browser or periods use the same codec.
      return settings.get().streaming.buffer.reuseExistingSourceBuffers && (previousStream.isProtectionCompatible(nextStream) || firstLicenseIsFetched) && (supportsChangeType || previousStream.isMediaCodecCompatible(nextStream, previousStream));
    } catch (e) {
      return false;
    }
  }
  /**
   * Initiate the preloading of the next stream
   * @param {object} nextStream
   * @param {object} previousStream
   * @private
   */


  function _onStreamCanLoadNext(nextStream) {
    var previousStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (mediaSource && !nextStream.getPreloaded()) {
      var seamlessPeriodSwitch = _canSourceBuffersBeReused(nextStream, previousStream);

      if (seamlessPeriodSwitch) {
        nextStream.startPreloading(mediaSource, bufferSinks).then(function () {
          preloadingStreams.push(nextStream);
        });
      }
    }
  }
  /**
   * Returns the corresponding stream object for a specific presentation time.
   * @param {number} time
   * @return {null|object}
   */


  function getStreamForTime(time) {
    if (isNaN(time)) {
      return null;
    }

    var ln = streams.length;

    for (var i = 0; i < ln; i++) {
      var stream = streams[i];
      var streamEnd = parseFloat((stream.getStartTime() + stream.getDuration()).toFixed(5));

      if (time < streamEnd) {
        return stream;
      }
    }

    return null;
  }
  /**
   * Add the DVR window to the metric list. We need the DVR window to restrict the seeking and calculate the right start time.
   */


  function addDVRMetric() {
    try {
      var isDynamic = adapter.getIsDynamic();
      var streamsInfo = adapter.getStreamsInfo();
      var manifestInfo = streamsInfo[0].manifestInfo;
      var time = playbackController.getTime();
      var range = timelineConverter.calcTimeShiftBufferWindow(streams, isDynamic);
      var activeStreamProcessors = getActiveStreamProcessors();

      if (typeof range.start === 'undefined' || typeof range.end === 'undefined') {
        return;
      }

      if (!activeStreamProcessors || activeStreamProcessors.length === 0) {
        dashMetrics.addDVRInfo(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, time, manifestInfo, range);
      } else {
        activeStreamProcessors.forEach(function (sp) {
          dashMetrics.addDVRInfo(sp.getType(), time, manifestInfo, range);
        });
      }
    } catch (e) {}
  }
  /**
   * The buffer level for a certain media type has been updated. If this is the initial playback and we want to autoplay the content we check if we can start playback now.
   * For livestreams we might have a drift of the target live delay compared to the current live delay because reaching the initial buffer level took time.
   * @param {object} e
   * @private
   */


  function _onBufferLevelUpdated(e) {
    // check if this is the initial playback and we reached the buffer target. If autoplay is true we start playback
    if (initialPlayback && autoPlay) {
      var initialBufferLevel = mediaPlayerModel.getInitialBufferLevel();
      var excludedStreamProcessors = [_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT];

      if (isNaN(initialBufferLevel) || initialBufferLevel <= playbackController.getBufferLevel(excludedStreamProcessors) || adapter.getIsDynamic() && initialBufferLevel > playbackController.getLiveDelay()) {
        initialPlayback = false;

        _createPlaylistMetrics(_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayList"].INITIAL_PLAYOUT_START_REASON);

        playbackController.play();
      }
    }

    if (e && e.mediaType) {
      dashMetrics.addBufferLevel(e.mediaType, new Date(), e.bufferLevel * 1000);
    }
  }
  /**
   * When the quality is changed in the currently active stream and we do an aggressive replacement we must stop prebuffering. This is similar to a replacing track switch
   * Otherwise preloading can go on.
   * @param e
   * @private
   */


  function _onQualityChanged(e) {
    if (e.streamInfo.id === activeStream.getId() && e.reason && e.reason.forceReplace) {
      _deactivateAllPreloadingStreams();
    }

    var stream = getStreamById(e.streamInfo.id);
    stream.prepareQualityChange(e);
  }
  /**
   * A setting related to the live delay was updated. Check if one of the latency values changed. If so, recalculate the live delay.
   * @private
   */


  function _onLiveDelaySettingUpdated() {
    if (adapter.getIsDynamic() && playbackController.getLiveDelay() !== 0) {
      var streamsInfo = adapter.getStreamsInfo();

      if (streamsInfo.length > 0) {
        var manifestInfo = streamsInfo[0].manifestInfo;

        var fragmentDuration = _getFragmentDurationForLiveDelayCalculation(streamsInfo, manifestInfo);

        playbackController.computeAndSetLiveDelay(fragmentDuration, manifestInfo);
      }
    }
  }
  /**
   * When the playback time is updated we add the droppedFrames metric to the dash metric object
   * @private
   */


  function _onPlaybackTimeUpdated()
  /*e*/
  {
    if (hasVideoTrack()) {
      var playbackQuality = videoModel.getPlaybackQuality();

      if (playbackQuality) {
        dashMetrics.addDroppedFrames(playbackQuality);
      }
    }
  }
  /**
   * Once playback starts add playlist metrics depending on whether this was the first playback or playback resumed after pause
   * @private
   */


  function _onPlaybackStarted()
  /*e*/
  {
    logger.debug('[onPlaybackStarted]');

    if (!initialPlayback && isPaused) {
      _createPlaylistMetrics(_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayList"].RESUME_FROM_PAUSE_START_REASON);
    }

    if (initialPlayback) {
      initialPlayback = false;
    }

    isPaused = false;
  }
  /**
   * Once playback is paused flush metrics
   * @param {object} e
   * @private
   */


  function _onPlaybackPaused(e) {
    logger.debug('[onPlaybackPaused]');

    if (!e.ended) {
      isPaused = true;

      _flushPlaylistMetrics(_vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].USER_REQUEST_STOP_REASON);
    }
  }
  /**
   * Callback once a stream/period is completely buffered. We can either signal the end of the stream or start prebuffering the next period.
   * @param {object} e
   * @private
   */


  function _onStreamBufferingCompleted(e) {
    logger.debug("Stream with id ".concat(e.streamInfo.id, " finished buffering"));
    var isLast = e.streamInfo.isLast;

    if (mediaSource && isLast) {
      logger.info('[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController.');
      mediaSourceController.signalEndOfStream(mediaSource);
    } else {
      _checkIfPrebufferingCanStart();
    }
  }
  /**
   * Check if we can start prebuffering the next period.
   * @private
   */


  function _checkIfPrebufferingCanStart() {
    // In multiperiod situations, we can start buffering the next stream
    if (!activeStream || !activeStream.getHasFinishedBuffering()) {
      return;
    }

    var upcomingStreams = _getNextStreams(activeStream);

    var i = 0;

    while (i < upcomingStreams.length) {
      var stream = upcomingStreams[i];
      var previousStream = i === 0 ? activeStream : upcomingStreams[i - 1]; // If the preloading for the current stream is not scheduled, but its predecessor has finished buffering we can start prebuffering this stream

      if (!stream.getPreloaded() && previousStream.getHasFinishedBuffering()) {
        if (mediaSource) {
          _onStreamCanLoadNext(stream, previousStream);
        }
      }

      i += 1;
    }
  }
  /**
   * In some cases we need to fire the playback ended event manually
   * @private
   */


  function _startPlaybackEndedTimerInterval() {
    if (!playbackEndedTimerInterval) {
      playbackEndedTimerInterval = setInterval(function () {
        if (!isStreamSwitchingInProgress && playbackController.getTimeToStreamEnd() <= 0 && !playbackController.isSeeking()) {
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PLAYBACK_ENDED, {
            'isLast': getActiveStreamInfo().isLast
          });
        }
      }, PLAYBACK_ENDED_TIMER_INTERVAL);
    }
  }
  /**
   * Stop the check if the playback has ended
   * @private
   */


  function _stopPlaybackEndedTimerInterval() {
    if (playbackEndedTimerInterval) {
      clearInterval(playbackEndedTimerInterval);
      playbackEndedTimerInterval = null;
    }
  }
  /**
   * Returns a playhead time, in seconds, converted to be relative
   * to the start of an identified stream/period or null if no such stream
   * @param {number} time
   * @param {string} id
   * @returns {number|null}
   */


  function getTimeRelativeToStreamId(time, id) {
    var stream = null;
    var baseStart = 0;
    var streamStart = 0;
    var streamDur = null;

    for (var i = 0; i < streams.length; i++) {
      stream = streams[i];
      streamStart = stream.getStartTime();
      streamDur = stream.getDuration(); // use start time, if not undefined or NaN or similar

      if (Number.isFinite(streamStart)) {
        baseStart = streamStart;
      }

      if (stream.getId() === id) {
        return time - baseStart;
      } else {
        // use duration if not undefined or NaN or similar
        if (Number.isFinite(streamDur)) {
          baseStart += streamDur;
        }
      }
    }

    return null;
  }
  /**
   * Returns the streamProcessors of the active stream.
   * @return {array}
   */


  function getActiveStreamProcessors() {
    return activeStream ? activeStream.getProcessors() : [];
  }
  /**
   * Once playback has ended we switch to the next stream
   * @param {object} e
   */


  function _onPlaybackEnded(e) {
    if (activeStream && !activeStream.getIsEndedEventSignaled()) {
      activeStream.setIsEndedEventSignaled(true);

      var nextStream = _getNextStream();

      if (nextStream) {
        logger.debug("StreamController onEnded, found next stream with id ".concat(nextStream.getStreamInfo().id, ". Switching from ").concat(activeStream.getStreamInfo().id, " to ").concat(nextStream.getStreamInfo().id));

        _switchStream(nextStream, activeStream, NaN);
      } else {
        logger.debug('StreamController no next stream found');
        activeStream.setIsEndedEventSignaled(false);
      }

      _flushPlaylistMetrics(nextStream ? _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].END_OF_PERIOD_STOP_REASON : _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].END_OF_CONTENT_STOP_REASON);
    }

    if (e && e.isLast) {
      _stopPlaybackEndedTimerInterval();
    }
  }
  /**
   * Returns the next stream to be played relative to the stream provided. If no stream is provided we use the active stream.
   * In order to avoid rounding issues we should not use the duration of the periods. Instead find the stream with starttime closest to startTime of the previous stream.
   * @param {object} stream
   * @return {null|object}
   */


  function _getNextStream() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var refStream = stream ? stream : activeStream ? activeStream : null;

    if (!refStream) {
      return null;
    }

    var refStreamInfo = refStream.getStreamInfo();
    var start = refStreamInfo.start;
    var i = 0;
    var targetIndex = -1;
    var lastDiff = NaN;

    while (i < streams.length) {
      var s = streams[i];
      var sInfo = s.getStreamInfo();
      var diff = sInfo.start - start;

      if (diff > 0 && (isNaN(lastDiff) || diff < lastDiff) && refStreamInfo.id !== sInfo.id) {
        lastDiff = diff;
        targetIndex = i;
      }

      i += 1;
    }

    if (targetIndex >= 0) {
      return streams[targetIndex];
    }

    return null;
  }
  /**
   * Returns all upcoming streams relative to the provided stream. If no stream is provided we use the active stream.
   * @param {object} stream
   * @return {array}
   */


  function _getNextStreams() {
    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    try {
      var refStream = stream ? stream : activeStream ? activeStream : null;

      if (refStream) {
        var refStreamInfo = refStream.getStreamInfo();
        return streams.filter(function (stream) {
          var sInfo = stream.getStreamInfo();
          return sInfo.start > refStreamInfo.start && refStreamInfo.id !== sInfo.id;
        });
      }
    } catch (e) {
      return [];
    }
  }
  /**
   * Sets the duration attribute of the MediaSource using the MediaSourceController.
   * @param {number} duration
   * @private
   */


  function _setMediaDuration(duration) {
    var manifestDuration = duration ? duration : getActiveStreamInfo().manifestInfo.duration;
    mediaSourceController.setDuration(manifestDuration);
  }
  /**
   * Returns the active stream
   * @return {object}
   */


  function getActiveStream() {
    return activeStream;
  }
  /**
   * Initial playback indicates if we have called play() for the first time yet.
   * @return {*}
   */


  function getInitialPlayback() {
    return initialPlayback;
  }
  /**
   * Auto Play indicates if the stream starts automatically as soon as it is initialized.
   * @return {boolean}
   */


  function getAutoPlay() {
    return autoPlay;
  }
  /**
   * Called once the first stream has been initialized. We only use this function to seek to the right start time.
   * @return {number}
   * @private
   */


  function _getInitialStartTime() {
    // Seek new stream in priority order:
    // - at start time provided in URI parameters
    // - at stream/period start time (for static streams) or live start time (for dynamic streams)
    var startTime;

    if (adapter.getIsDynamic()) {
      // For dynamic stream, start by default at (live edge - live delay)
      var dvrInfo = dashMetrics.getCurrentDVRInfo();
      var liveEdge = dvrInfo && dvrInfo.range ? dvrInfo.range.end : 0; // we are already in the right start period. so time should not be smaller than period@start and should not be larger than period@end

      startTime = liveEdge - playbackController.getLiveDelay(); // If start time in URI, take min value between live edge time and time from URI (capped by DVR window range)

      var dvrWindow = dvrInfo ? dvrInfo.range : null;

      if (dvrWindow) {
        // #t shall be relative to period start
        var startTimeFromUri = _getStartTimeFromUriParameters(true);

        if (!isNaN(startTimeFromUri)) {
          logger.info('Start time from URI parameters: ' + startTimeFromUri); // If calcFromSegmentTimeline is enabled we saw problems caused by the MSE.seekableRange when starting at dvrWindow.start. Apply a small offset to avoid this problem.

          var offset = settings.get().streaming.timeShiftBuffer.calcFromSegmentTimeline ? 0.1 : 0;
          startTime = Math.max(Math.min(startTime, startTimeFromUri), dvrWindow.start + offset);
        }
      }
    } else {
      // For static stream, start by default at period start
      var _streams = getStreams();

      var streamInfo = _streams[0].getStreamInfo();

      startTime = streamInfo.start; // If start time in URI, take max value between period start and time from URI (if in period range)

      var _startTimeFromUri = _getStartTimeFromUriParameters(false);

      if (!isNaN(_startTimeFromUri)) {
        logger.info('Start time from URI parameters: ' + _startTimeFromUri);
        startTime = Math.max(startTime, _startTimeFromUri);
      }
    }

    return startTime;
  }
  /**
   * 23009-1 Annex C.4 defines MPD anchors to use URI fragment syntax to start a presentation at a given time and a given state
   * @param {boolean} isDynamic
   * @return {number}
   * @private
   */


  function _getStartTimeFromUriParameters(isDynamic) {
    var fragData = uriFragmentModel.getURIFragmentData();

    if (!fragData || !fragData.t) {
      return NaN;
    }

    var refStream = getStreams()[0];
    var refStreamStartTime = refStream.getStreamInfo().start; // Consider only start time of MediaRange
    // TODO: consider end time of MediaRange to stop playback at provided end time

    fragData.t = fragData.t.split(',')[0]; // "t=<time>" : time is relative to 1st period start
    // "t=posix:<time>" : time is absolute start time as number of seconds since 01-01-1970

    var posix = fragData.t.indexOf('posix:') !== -1 ? fragData.t.substring(6) === 'now' ? Date.now() / 1000 : parseInt(fragData.t.substring(6)) : NaN;
    var startTime = isDynamic && !isNaN(posix) ? posix - playbackController.getAvailabilityStartTime() / 1000 : parseInt(fragData.t) + refStreamStartTime;
    return startTime;
  }
  /**
   * Streams that are no longer in the manifest can be filtered
   * @param {object} streamsInfo
   * @private
   */


  function _filterOutdatedStreams(streamsInfo) {
    if (streamsInfo.length === 0) {
      logger.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");
      return;
    }

    streams = streams.filter(function (stream) {
      var isStillIncluded = streamsInfo.filter(function (sInfo) {
        return sInfo.id === stream.getId();
      }).length > 0;
      var shouldKeepStream = isStillIncluded || stream.getId() === activeStream.getId();

      if (!shouldKeepStream) {
        logger.debug("Removing stream ".concat(stream.getId()));
        stream.reset(true);
      }

      return shouldKeepStream;
    });
  }
  /**
   * In order to calculate the initial live delay we might required the duration of the segments.
   * @param {array} streamInfos
   * @param {object} manifestInfo
   * @return {number}
   * @private
   */


  function _getFragmentDurationForLiveDelayCalculation(streamInfos, manifestInfo) {
    try {
      var fragmentDuration = NaN; //  We use the maxFragmentDuration attribute if present

      if (manifestInfo && !isNaN(manifestInfo.maxFragmentDuration) && isFinite(manifestInfo.maxFragmentDuration)) {
        return manifestInfo.maxFragmentDuration;
      } // For single period manifests we can iterate over all AS and use the maximum segment length


      if (streamInfos && streamInfos.length === 1) {
        var streamInfo = streamInfos[0];
        var mediaTypes = [_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT];
        var fragmentDurations = mediaTypes.reduce(function (acc, mediaType) {
          var mediaInfo = adapter.getMediaInfoForType(streamInfo, mediaType);

          if (mediaInfo && mediaInfo.isFragmented !== false) {
            acc.push(mediaInfo);
          }

          return acc;
        }, []).reduce(function (acc, mediaInfo) {
          var voRepresentations = adapter.getVoRepresentations(mediaInfo);

          if (voRepresentations && voRepresentations.length > 0) {
            voRepresentations.forEach(function (voRepresentation) {
              if (voRepresentation) {
                acc.push(voRepresentation);
              }
            });
          }

          return acc;
        }, []).reduce(function (acc, voRepresentation) {
          var representation = adapter.convertRepresentationToRepresentationInfo(voRepresentation);

          if (representation && representation.fragmentDuration && !isNaN(representation.fragmentDuration)) {
            acc.push(representation.fragmentDuration);
          }

          return acc;
        }, []);
        fragmentDuration = Math.max.apply(Math, _toConsumableArray(fragmentDurations));
      }

      return isFinite(fragmentDuration) ? fragmentDuration : NaN;
    } catch (e) {
      return NaN;
    }
  }
  /**
   * Callback handler after the manifest has been updated. Trigger an update in the adapter and filter unsupported stuff.
   * Finally attempt UTC sync
   * @param {object} e
   * @private
   */


  function _onManifestUpdated(e) {
    if (!e.error) {
      logger.info('Manifest updated... updating data system wide.'); //Since streams are not composed yet , need to manually look up useCalculatedLiveEdgeTime to detect if stream
      //is SegmentTimeline to avoid using time source

      var manifest = e.manifest;
      adapter.updatePeriods(manifest);
      var manifestUTCTimingSources = adapter.getUTCTimingSources();

      if (adapter.getIsDynamic() && (!manifestUTCTimingSources || manifestUTCTimingSources.length === 0)) {
        eventBus.trigger(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_11__["default"].CONFORMANCE_VIOLATION, {
          level: _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_17__["default"].LEVELS.WARNING,
          event: _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_17__["default"].EVENTS.NO_UTC_TIMING_ELEMENT
        });
      }

      var allUTCTimingSources = !adapter.getIsDynamic() ? manifestUTCTimingSources : manifestUTCTimingSources.concat(customParametersModel.getUTCTimingSources());
      var isHTTPS = urlUtils.isHTTPS(e.manifest.url); //If https is detected on manifest then lets apply that protocol to only the default time source(s). In the future we may find the need to apply this to more then just default so left code at this level instead of in MediaPlayer.

      allUTCTimingSources.forEach(function (item) {
        if (item.value.replace(/.*?:\/\//g, '') === settings.get().streaming.utcSynchronization.defaultTimingSource.value.replace(/.*?:\/\//g, '')) {
          item.value = item.value.replace(isHTTPS ? new RegExp(/^(http:)?\/\//i) : new RegExp(/^(https:)?\/\//i), isHTTPS ? 'https://' : 'http://');
          logger.debug('Matching default timing source protocol to manifest protocol: ', item.value);
        }
      }); // It is important to filter before initializing the baseUrlController. Otherwise we might end up with wrong references in case we remove AdaptationSets.

      capabilitiesFilter.filterUnsupportedFeatures(manifest).then(function () {
        baseURLController.initialize(manifest);
        timeSyncController.attemptSync(allUTCTimingSources, adapter.getIsDynamic());
      });
    } else {
      hasInitialisationError = true;
      reset();
    }
  }
  /**
   * Check if the stream has a video track
   * @return {boolean}
   */


  function hasVideoTrack() {
    return activeStream ? activeStream.getHasVideoTrack() : false;
  }
  /**
   * Check if the stream has an audio track
   * @return {boolean}
   */


  function hasAudioTrack() {
    return activeStream ? activeStream.getHasAudioTrack() : false;
  }

  function switchToVideoElement(seekTime) {
    if (activeStream) {
      playbackController.initialize(getActiveStreamInfo());

      _openMediaSource(seekTime, false);
    }
  }

  function _flushPlaylistMetrics(reason, time) {
    time = time || new Date();
    getActiveStreamProcessors().forEach(function (p) {
      p.finalisePlayList(time, reason);
    });
    dashMetrics.addPlayList();
  }

  function _createPlaylistMetrics(startReason) {
    dashMetrics.createPlaylistMetrics(playbackController.getTime() * 1000, startReason);
  }

  function _onPlaybackError(e) {
    if (!e.error) return;
    var msg = '';

    switch (e.error.code) {
      case 1:
        msg = 'MEDIA_ERR_ABORTED';
        break;

      case 2:
        msg = 'MEDIA_ERR_NETWORK';
        break;

      case 3:
        msg = 'MEDIA_ERR_DECODE';
        errorInformation.counts.mediaErrorDecode += 1;
        break;

      case 4:
        msg = 'MEDIA_ERR_SRC_NOT_SUPPORTED';
        break;

      case 5:
        msg = 'MEDIA_ERR_ENCRYPTED';
        break;

      default:
        msg = 'UNKNOWN';
        break;
    }

    if (msg === 'MEDIA_ERR_DECODE' && settings.get().errors.recoverAttempts.mediaErrorDecode >= errorInformation.counts.mediaErrorDecode) {
      _handleMediaErrorDecode();

      return;
    }

    hasMediaError = true;

    if (e.error.message) {
      msg += ' (' + e.error.message + ')';
    }

    if (e.error.msExtendedCode) {
      msg += ' (0x' + (e.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ')';
    }

    logger.fatal('Video Element Error: ' + msg);

    if (e.error) {
      logger.fatal(e.error);
    }

    errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_14__["default"](e.error.code, msg));
    reset();
  }
  /**
   * Handles mediaError
   * @private
   */


  function _handleMediaErrorDecode() {
    logger.warn('A MEDIA_ERR_DECODE occured: Resetting the MediaSource');
    var time = playbackController.getTime(); // Deactivate the current stream.

    activeStream.deactivate(false); // Reset MSE

    logger.warn("MediaSource has been resetted. Resuming playback from time ".concat(time));

    _openMediaSource(time, false);
  }

  function getActiveStreamInfo() {
    return activeStream ? activeStream.getStreamInfo() : null;
  }

  function getIsStreamSwitchInProgress() {
    return isStreamSwitchingInProgress;
  }

  function getHasMediaOrInitialisationError() {
    return hasMediaError || hasInitialisationError;
  }

  function getStreamById(id) {
    for (var i = 0, ln = streams.length; i < ln; i++) {
      if (streams[i].getId() === id) {
        return streams[i];
      }
    }

    return null;
  }

  function _checkConfig() {
    if (!manifestLoader || !manifestLoader.hasOwnProperty('load') || !timelineConverter || !timelineConverter.hasOwnProperty('initialize') || !timelineConverter.hasOwnProperty('reset') || !timelineConverter.hasOwnProperty('getClientTimeOffset') || !manifestModel || !errHandler || !dashMetrics || !playbackController) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function _checkInitialize() {
    if (!manifestUpdater || !manifestUpdater.hasOwnProperty('setManifest')) {
      throw new Error('initialize function has to be called previously');
    }
  }

  function load(url) {
    _checkConfig();

    manifestLoader.load(url);
  }

  function loadWithManifest(manifest) {
    _checkInitialize();

    manifestUpdater.setManifest(manifest);
  }

  function _onManifestValidityChanged(e) {
    if (!isNaN(e.newDuration)) {
      _setMediaDuration(e.newDuration);
    }
  }

  function setConfig(config) {
    if (!config) return;

    if (config.capabilities) {
      capabilities = config.capabilities;
    }

    if (config.capabilitiesFilter) {
      capabilitiesFilter = config.capabilitiesFilter;
    }

    if (config.manifestLoader) {
      manifestLoader = config.manifestLoader;
    }

    if (config.manifestModel) {
      manifestModel = config.manifestModel;
    }

    if (config.mediaPlayerModel) {
      mediaPlayerModel = config.mediaPlayerModel;
    }

    if (config.customParametersModel) {
      customParametersModel = config.customParametersModel;
    }

    if (config.protectionController) {
      protectionController = config.protectionController;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.errHandler) {
      errHandler = config.errHandler;
    }

    if (config.timelineConverter) {
      timelineConverter = config.timelineConverter;
    }

    if (config.videoModel) {
      videoModel = config.videoModel;
    }

    if (config.playbackController) {
      playbackController = config.playbackController;
    }

    if (config.serviceDescriptionController) {
      serviceDescriptionController = config.serviceDescriptionController;
    }

    if (config.textController) {
      textController = config.textController;
    }

    if (config.abrController) {
      abrController = config.abrController;
    }

    if (config.mediaController) {
      mediaController = config.mediaController;
    }

    if (config.settings) {
      settings = config.settings;
    }

    if (config.baseURLController) {
      baseURLController = config.baseURLController;
    }

    if (config.uriFragmentModel) {
      uriFragmentModel = config.uriFragmentModel;
    }

    if (config.segmentBaseController) {
      segmentBaseController = config.segmentBaseController;
    }
  }

  function setProtectionData(protData) {
    protectionData = protData;

    if (protectionController) {
      protectionController.setProtectionData(protectionData);
    }
  }

  function resetInitialSettings() {
    streams = [];
    protectionController = null;
    isStreamSwitchingInProgress = false;
    activeStream = null;
    hasMediaError = false;
    hasInitialisationError = false;
    initialPlayback = true;
    isPaused = false;
    autoPlay = true;
    playbackEndedTimerInterval = null;
    firstLicenseIsFetched = false;
    supportsChangeType = false;
    preloadingStreams = [];
    waitForPlaybackStartTimeout = null;
    errorInformation = {
      counts: {
        mediaErrorDecode: 0
      }
    };
  }

  function reset() {
    _checkConfig();

    timeSyncController.reset();

    _flushPlaylistMetrics(hasMediaError || hasInitialisationError ? _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].FAILURE_STOP_REASON : _vo_metrics_PlayList__WEBPACK_IMPORTED_MODULE_7__["PlayListTrace"].USER_REQUEST_STOP_REASON);

    for (var i = 0, ln = streams ? streams.length : 0; i < ln; i++) {
      var stream = streams[i];
      stream.reset(hasMediaError);
    }

    unRegisterEvents();
    baseURLController.reset();
    manifestUpdater.reset();
    eventController.reset();
    dashMetrics.clearAllCurrentMetrics();
    manifestModel.setValue(null);
    manifestLoader.reset();
    timelineConverter.reset();
    initCache.reset();

    if (mediaSource) {
      mediaSourceController.detachMediaSource(videoModel);
      mediaSource = null;
    }

    videoModel = null;

    if (protectionController) {
      protectionController = null;
      protectionData = null;

      if (manifestModel.getValue()) {
        eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PROTECTION_DESTROYED, {
          data: manifestModel.getValue().url
        });
      }
    }

    _stopPlaybackEndedTimerInterval();

    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].STREAM_TEARDOWN_COMPLETE);
    resetInitialSettings();
  }

  function _onMetricAdded(e) {
    if (e.metric === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVR_INFO) {
      //Match media type? How can DVR window be different for media types?
      //Should we normalize and union the two?
      var targetMediaType = hasAudioTrack() ? _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO : _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO;

      if (e.mediaType === targetMediaType) {
        mediaSourceController.setSeekable(e.value.range.start, e.value.range.end);
      }
    }
  }

  function getStreams() {
    return streams;
  }

  instance = {
    initialize: initialize,
    getActiveStreamInfo: getActiveStreamInfo,
    addDVRMetric: addDVRMetric,
    hasVideoTrack: hasVideoTrack,
    hasAudioTrack: hasAudioTrack,
    getStreamById: getStreamById,
    getStreamForTime: getStreamForTime,
    getTimeRelativeToStreamId: getTimeRelativeToStreamId,
    load: load,
    loadWithManifest: loadWithManifest,
    getActiveStreamProcessors: getActiveStreamProcessors,
    setConfig: setConfig,
    setProtectionData: setProtectionData,
    getIsStreamSwitchInProgress: getIsStreamSwitchInProgress,
    switchToVideoElement: switchToVideoElement,
    getHasMediaOrInitialisationError: getHasMediaOrInitialisationError,
    getStreams: getStreams,
    getActiveStream: getActiveStream,
    getInitialPlayback: getInitialPlayback,
    getAutoPlay: getAutoPlay,
    reset: reset
  };
  setup();
  return instance;
}

StreamController.__dashjs_factory_name = 'StreamController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__["default"].getSingletonFactory(StreamController));

/***/ }),

/***/ "./src/streaming/controllers/TimeSyncController.js":
/*!*********************************************************!*\
  !*** ./src/streaming/controllers/TimeSyncController.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1665201__) {

"use strict";
__nested_webpack_require_1665201__.r(__webpack_exports__);
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1665201__(/*! ./../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1665201__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1665201__(/*! ./../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1665201__(/*! ./../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1665201__(/*! ./../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1665201__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1665201__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1665201__(/*! ../utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








var HTTP_TIMEOUT_MS = 5000;
var DEFAULT_MAXIMUM_ALLOWED_DRIFT = 100;
var DEFAULT_TIME_BETWEEN_SYNC_ATTEMPTS_ADJUSTMENT_FACTOR = 2;
var DEFAULT_BACKGROUND_ATTEMPTS = 2;
var DEFAULT_TIME_BETWEEN_SYNC_ATTEMPTS = 30;
var DEFAULT_MINIMUM_TIME_BETWEEN_BACKGROUND_SYNC_ATTEMPTS = 30;
var DEFAULT_MAXIMUM_TIME_BETWEEN_SYNC = 600;
var DEFAULT_MINIMUM_TIME_BETWEEN_SYNC = 2;

function TimeSyncController() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
  var instance, logger, isSynchronizing, isBackgroundSynchronizing, settings, handlers, dashMetrics, backgroundSyncTimeOffsets, timingSources, timeOfLastSync, timeOfLastBackgroundSync, lastOffset, lastTimingSource, internalTimeBetweenSyncAttempts, errHandler, baseURLController;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance().getLogger(instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].ATTEMPT_BACKGROUND_SYNC, _onAttemptBackgroundSync, instance);
  }

  function setConfig(config) {
    if (!config) return;

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.baseURLController) {
      baseURLController = config.baseURLController;
    }

    if (config.errHandler) {
      errHandler = config.errHandler;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }

  function _resetInitialSettings() {
    backgroundSyncTimeOffsets = [];
    timingSources = [];
    timeOfLastSync = null;
    timeOfLastBackgroundSync = null;
    lastTimingSource = null;
    lastOffset = NaN;
    isSynchronizing = false;
    isBackgroundSynchronizing = false;
    internalTimeBetweenSyncAttempts = settings.get().streaming.utcSynchronization.timeBetweenSyncAttempts;
  }
  /**
   * Register the timing handler depending on the schemeIdUris. This method is called once when the StreamController is initialized
   */


  function initialize() {
    _resetInitialSettings(); // a list of known schemeIdUris and a method to call with @value


    handlers = {
      'urn:mpeg:dash:utc:http-head:2014': _httpHeadHandler,
      'urn:mpeg:dash:utc:http-xsdate:2014': _httpHandler.bind(null, _xsdatetimeDecoder),
      'urn:mpeg:dash:utc:http-iso:2014': _httpHandler.bind(null, _iso8601Decoder),
      'urn:mpeg:dash:utc:direct:2014': _directHandler,
      // some specs referencing early ISO23009-1 drafts incorrectly use
      // 2012 in the URI, rather than 2014. support these for now.
      'urn:mpeg:dash:utc:http-head:2012': _httpHeadHandler,
      'urn:mpeg:dash:utc:http-xsdate:2012': _httpHandler.bind(null, _xsdatetimeDecoder),
      'urn:mpeg:dash:utc:http-iso:2012': _httpHandler.bind(null, _iso8601Decoder),
      'urn:mpeg:dash:utc:direct:2012': _directHandler,
      // it isn't clear how the data returned would be formatted, and
      // no public examples available so http-ntp not supported for now.
      // presumably you would do an arraybuffer type xhr and decode the
      // binary data returned but I would want to see a sample first.
      'urn:mpeg:dash:utc:http-ntp:2014': _notSupportedHandler,
      // not clear how this would be supported in javascript (in browser)
      'urn:mpeg:dash:utc:ntp:2014': _notSupportedHandler,
      'urn:mpeg:dash:utc:sntp:2014': _notSupportedHandler
    };
  }
  /**
   * Sync against a timing source. T
   * @param {array} tSources
   * @param {boolean} isDynamic
   */


  function attemptSync(tSources, isDynamic) {
    timingSources = tSources; // Stop if we are already synchronizing

    if (isSynchronizing) {
      return;
    } // No synchronization required we can signal the completion immediately


    if (!_shouldPerformSynchronization(isDynamic)) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].TIME_SYNCHRONIZATION_COMPLETED);
      return;
    }

    isSynchronizing = true;

    _attemptRecursiveSync();
  }
  /**
   * Does a synchronization in the background in case the last offset should be verified or a 404 occurs
   */


  function _onAttemptBackgroundSync() {
    if (!settings.get().streaming.utcSynchronization.enabled || isSynchronizing || isBackgroundSynchronizing || !lastTimingSource || !lastTimingSource.value || !lastTimingSource.schemeIdUri || isNaN(lastOffset) || isNaN(settings.get().streaming.utcSynchronization.backgroundAttempts)) {
      return;
    }

    if (timeOfLastBackgroundSync && (Date.now() - timeOfLastBackgroundSync) / 1000 < DEFAULT_MINIMUM_TIME_BETWEEN_BACKGROUND_SYNC_ATTEMPTS) {
      return;
    }

    backgroundSyncTimeOffsets = [];
    isBackgroundSynchronizing = true;
    var backgroundAttempts = !isNaN(settings.get().streaming.utcSynchronization.backgroundAttempts) ? settings.get().streaming.utcSynchronization.backgroundAttempts : DEFAULT_BACKGROUND_ATTEMPTS;

    _attemptBackgroundSync(backgroundAttempts);
  }
  /**
   * Perform a defined number of background attempts
   * @param {number} attempts
   * @private
   */


  function _attemptBackgroundSync(attempts) {
    try {
      if (attempts <= 0) {
        _completeBackgroundTimeSyncSequence();

        return;
      }

      var deviceTimeBeforeSync = Date.now();
      handlers[lastTimingSource.schemeIdUri](lastTimingSource.value, function (serverTime) {
        // the timing source returned something useful
        var deviceTimeAfterSync = Date.now();

        var offset = _calculateOffset(deviceTimeBeforeSync, deviceTimeAfterSync, serverTime);

        backgroundSyncTimeOffsets.push(offset);

        _attemptBackgroundSync(attempts - 1);
      }, function () {
        _completeBackgroundTimeSyncSequence();
      });
    } catch (e) {
      _completeBackgroundTimeSyncSequence();
    }
  }
  /**
   * Sync against a timing source. This method is called recursively if the time sync for the first entry in timingSources fails.
   * @param {number} sourceIndex
   */


  function _attemptRecursiveSync() {
    var sourceIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    // if called with no sourceIndex, use zero (highest priority)
    var index = sourceIndex || 0; // the sources should be ordered in priority from the manifest.
    // try each in turn, from the top, until either something
    // sensible happens, or we run out of sources to try.

    if (!timingSources || timingSources.length === 0 || index >= timingSources.length) {
      _onComplete();

      return;
    }

    var source = timingSources[index];

    if (source) {
      // check if there is a handler for this @schemeIdUri
      if (handlers.hasOwnProperty(source.schemeIdUri)) {
        // if so, call it with its @value
        var deviceTimeBeforeSync = new Date().getTime();
        handlers[source.schemeIdUri](source.value, function (serverTime) {
          // the timing source returned something useful
          var deviceTimeAfterSync = new Date().getTime();

          var offset = _calculateOffset(deviceTimeBeforeSync, deviceTimeAfterSync, serverTime);

          lastTimingSource = source;

          _onComplete(offset);
        }, function () {
          // the timing source was probably uncontactable
          // or returned something we can't use - try again
          // with the remaining sources
          _attemptRecursiveSync(index + 1);
        });
      } else {
        // an unknown schemeIdUri must have been found
        // try again with the remaining sources
        _attemptRecursiveSync(index + 1);
      }
    } else {
      // no valid time source could be found, just use device time
      _onComplete();
    }
  }
  /**
   * Calculate the offset between client and server. Account for the roundtrip time
   * @param {number} deviceTimeBeforeSync
   * @param {number} deviceTimeAfterSync
   * @param {number} serverTime
   * @return {number}
   * @private
   */


  function _calculateOffset(deviceTimeBeforeSync, deviceTimeAfterSync, serverTime) {
    var deviceReferenceTime = deviceTimeAfterSync - (deviceTimeAfterSync - deviceTimeBeforeSync) / 2;
    return serverTime - deviceReferenceTime;
  }
  /**
   * Checks if a synchronization is required
   * @param {boolean} isDynamic
   * @return {boolean}
   * @private
   */


  function _shouldPerformSynchronization(isDynamic) {
    try {
      if (!isDynamic || !settings.get().streaming.utcSynchronization.enabled) {
        return false;
      }

      var timeBetweenSyncAttempts = !isNaN(internalTimeBetweenSyncAttempts) ? internalTimeBetweenSyncAttempts : DEFAULT_TIME_BETWEEN_SYNC_ATTEMPTS;

      if (!timeOfLastSync || !timeBetweenSyncAttempts || isNaN(timeBetweenSyncAttempts)) {
        return true;
      }

      return (Date.now() - timeOfLastSync) / 1000 >= timeBetweenSyncAttempts;
    } catch (e) {
      return true;
    }
  }
  /**
   * Callback after sync has been completed
   * @param {number} offset
   * @private
   */


  function _onComplete() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NaN;
    var failed = isNaN(offset);

    if (failed && settings.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource) {
      //Before falling back to binary search , check if date header exists on MPD. if so, use for a time source.
      _checkForDateHeader();
    } else {
      _completeTimeSyncSequence(failed, offset);
    }
  }
  /**
   * Takes xsdatetime and returns milliseconds since UNIX epoch. May not be necessary as xsdatetime is very similar to ISO 8601 which is natively understood by javascript Date parser
   * @param {string} xsdatetimeStr
   * @return {number}
   * @private
   */


  function _alternateXsdatetimeDecoder(xsdatetimeStr) {
    // taken from DashParser - should probably refactor both uses
    var SECONDS_IN_MIN = 60;
    var MINUTES_IN_HOUR = 60;
    var MILLISECONDS_IN_SECONDS = 1000;
    var datetimeRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/;
    var utcDate, timezoneOffset;
    var match = datetimeRegex.exec(xsdatetimeStr); // If the string does not contain a timezone offset different browsers can interpret it either
    // as UTC or as a local time so we have to parse the string manually to normalize the given date value for
    // all browsers

    utcDate = Date.UTC(parseInt(match[1], 10), parseInt(match[2], 10) - 1, // months start from zero
    parseInt(match[3], 10), parseInt(match[4], 10), parseInt(match[5], 10), match[6] && (parseInt(match[6], 10) || 0), match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0); // If the date has timezone offset take it into account as well

    if (match[9] && match[10]) {
      timezoneOffset = parseInt(match[9], 10) * MINUTES_IN_HOUR + parseInt(match[10], 10);
      utcDate += (match[8] === '+' ? -1 : +1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;
    }

    return new Date(utcDate).getTime();
  }
  /**
   * Try to use the built in parser, since xsdate is a constrained ISO8601 which is supported natively by Date.parse. if that fails, try a regex-based version used elsewhere in this application.
   * @param {string} xsdatetimeStr
   * @return {number}
   */


  function _xsdatetimeDecoder(xsdatetimeStr) {
    var parsedDate = Date.parse(xsdatetimeStr);

    if (isNaN(parsedDate)) {
      parsedDate = _alternateXsdatetimeDecoder(xsdatetimeStr);
    }

    return parsedDate;
  }
  /**
   * Takes ISO 8601 timestamp and returns milliseconds since UNIX epoch
   * @param {string} isoStr
   * @return {number}
   */


  function _iso8601Decoder(isoStr) {
    return Date.parse(isoStr);
  }
  /**
   * Takes RFC 1123 timestamp (which is same as ISO8601) and returns milliseconds since UNIX epoch
   * @param {string} dateStr
   * @return {number}
   */


  function _rfc1123Decoder(dateStr) {
    return Date.parse(dateStr);
  }
  /**
   * Handler for unsupported scheme ids.
   * @param {string} url
   * @param {function} onSuccessCB
   * @param {function} onFailureCB
   * @private
   */


  function _notSupportedHandler(url, onSuccessCB, onFailureCB) {
    onFailureCB();
  }
  /**
   * Direct handler
   * @param {string} xsdatetimeStr
   * @param {function} onSuccessCB
   * @param {function} onFailureCB
   */


  function _directHandler(xsdatetimeStr, onSuccessCB, onFailureCB) {
    var time = _xsdatetimeDecoder(xsdatetimeStr);

    if (!isNaN(time)) {
      onSuccessCB(time);
      return;
    }

    onFailureCB();
  }
  /**
   * Generic http handler
   * @param {function} decoder
   * @param {string} url
   * @param {function} onSuccessCB
   * @param {function} onFailureCB
   * @param {boolean} isHeadRequest
   * @private
   */


  function _httpHandler(decoder, url, onSuccessCB, onFailureCB, isHeadRequest) {
    var oncomplete, onload;
    var complete = false;
    var req = new XMLHttpRequest();
    var verb = isHeadRequest ? _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].HEAD : _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].GET;
    var urls = url.match(/\S+/g); // according to ISO 23009-1, url could be a white-space
    // separated list of URLs. just handle one at a time.

    url = urls.shift();

    oncomplete = function oncomplete() {
      if (complete) {
        return;
      } // we only want to pass through here once per xhr,
      // regardless of whether the load was successful.


      complete = true; // if there are more urls to try, call self.

      if (urls.length) {
        _httpHandler(decoder, urls.join(' '), onSuccessCB, onFailureCB, isHeadRequest);
      } else {
        onFailureCB();
      }
    };

    onload = function onload() {
      var time, result;

      if (req.status === 200) {
        time = isHeadRequest ? req.getResponseHeader('Date') : req.response;
        result = decoder(time); // decoder returns NaN if non-standard input

        if (!isNaN(result)) {
          onSuccessCB(result);
          complete = true;
        }
      }
    };

    if (urlUtils.isRelative(url)) {
      // passing no path to resolve will return just MPD BaseURL/baseUri
      var baseUrl = baseURLController.resolve();

      if (baseUrl) {
        url = urlUtils.resolve(url, baseUrl.url);
      }
    }

    req.open(verb, url);
    req.timeout = HTTP_TIMEOUT_MS || 0;
    req.onload = onload;
    req.onloadend = oncomplete;
    req.send();
  }
  /**
   * Handler for http-head schemeIdUri
   * @param {string} url
   * @param {function} onSuccessCB
   * @param {function} onFailureCB
   * @private
   */


  function _httpHeadHandler(url, onSuccessCB, onFailureCB) {
    _httpHandler(_rfc1123Decoder, url, onSuccessCB, onFailureCB, true);
  }
  /**
   * Checks if a date header is present in the MPD response and calculates the offset based on the header
   * @private
   */


  function _checkForDateHeader() {
    var dateHeaderValue = dashMetrics.getLatestMPDRequestHeaderValueByID('Date');
    var dateHeaderTime = dateHeaderValue !== null ? new Date(dateHeaderValue).getTime() : Number.NaN;

    if (!isNaN(dateHeaderTime)) {
      var offsetToDeviceTimeMs = dateHeaderTime - Date.now();

      _completeTimeSyncSequence(false, offsetToDeviceTimeMs);
    } else {
      _completeTimeSyncSequence(true);
    }
  }
  /**
   * Triggers the event to signal that the time synchronization was completed
   * @param {boolean} failed
   * @param {number} offset
   * @private
   */


  function _completeTimeSyncSequence(failed, offset) {
    // Adjust the time of the next sync based on the drift between current offset and last offset
    if (!isNaN(lastOffset) && !isNaN(offset) && !failed) {
      _adjustTimeBetweenSyncAttempts(offset);
    } // Update the internal data


    if (!failed && !isNaN(offset)) {
      timeOfLastSync = Date.now();
      isSynchronizing = false; // if this is the first sync we are doing perform background syncs as well to confirm current offset

      var shouldAttemptBackgroundSync = isNaN(lastOffset);
      lastOffset = offset;

      if (shouldAttemptBackgroundSync) {
        _onAttemptBackgroundSync();
      }

      logger.debug("Completed UTC sync. Setting client - server offset to ".concat(offset));
    }

    if (failed) {
      lastTimingSource = null;
      isSynchronizing = false;
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_4__["default"].TIME_SYNC_FAILED_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_4__["default"].TIME_SYNC_FAILED_ERROR_MESSAGE));
    } // Notify other classes


    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].UPDATE_TIME_SYNC_OFFSET, {
      offset: offset
    });
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].TIME_SYNCHRONIZATION_COMPLETED);
  }

  function _adjustTimeBetweenSyncAttempts(offset) {
    try {
      var isOffsetDriftWithinThreshold = _isOffsetDriftWithinThreshold(offset);

      var timeBetweenSyncAttempts = !isNaN(internalTimeBetweenSyncAttempts) ? internalTimeBetweenSyncAttempts : DEFAULT_TIME_BETWEEN_SYNC_ATTEMPTS;
      var timeBetweenSyncAttemptsAdjustmentFactor = !isNaN(settings.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor) ? settings.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor : DEFAULT_TIME_BETWEEN_SYNC_ATTEMPTS_ADJUSTMENT_FACTOR;
      var maximumTimeBetweenSyncAttempts = !isNaN(settings.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts) ? settings.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts : DEFAULT_MAXIMUM_TIME_BETWEEN_SYNC;
      var minimumTimeBetweenSyncAttempts = !isNaN(settings.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts) ? settings.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts : DEFAULT_MINIMUM_TIME_BETWEEN_SYNC;
      var adjustedTimeBetweenSyncAttempts;

      if (isOffsetDriftWithinThreshold) {
        // The drift between the current offset and the last offset is within the allowed threshold. Increase sync time
        adjustedTimeBetweenSyncAttempts = Math.min(timeBetweenSyncAttempts * timeBetweenSyncAttemptsAdjustmentFactor, maximumTimeBetweenSyncAttempts);
        logger.debug("Increasing timeBetweenSyncAttempts to ".concat(adjustedTimeBetweenSyncAttempts));
      } else {
        // Drift between the current offset and the last offset is not within the allowed threshold. Decrease sync time
        adjustedTimeBetweenSyncAttempts = Math.max(timeBetweenSyncAttempts / timeBetweenSyncAttemptsAdjustmentFactor, minimumTimeBetweenSyncAttempts);
        logger.debug("Decreasing timeBetweenSyncAttempts to ".concat(adjustedTimeBetweenSyncAttempts));
      }

      internalTimeBetweenSyncAttempts = adjustedTimeBetweenSyncAttempts;
    } catch (e) {}
  }
  /**
   * Callback after all background syncs have been completed.
   * @private
   */


  function _completeBackgroundTimeSyncSequence() {
    if (!backgroundSyncTimeOffsets || backgroundSyncTimeOffsets.length === 0) {
      return;
    }

    var averageOffset = backgroundSyncTimeOffsets.reduce(function (acc, curr) {
      return acc + curr;
    }, 0) / backgroundSyncTimeOffsets.length;

    if (!_isOffsetDriftWithinThreshold(averageOffset)) {
      logger.debug("Completed background UTC sync. Setting client - server offset to ".concat(averageOffset));
      lastOffset = averageOffset;
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].UPDATE_TIME_SYNC_OFFSET, {
        offset: lastOffset
      });
    } else {
      logger.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted.");
    }

    isBackgroundSynchronizing = false;
    timeOfLastBackgroundSync = Date.now();
  }

  function _isOffsetDriftWithinThreshold(offset) {
    try {
      if (isNaN(lastOffset)) {
        return true;
      }

      var maxAllowedDrift = settings.get().streaming.utcSynchronization.maximumAllowedDrift && !isNaN(settings.get().streaming.utcSynchronization.maximumAllowedDrift) ? settings.get().streaming.utcSynchronization.maximumAllowedDrift : DEFAULT_MAXIMUM_ALLOWED_DRIFT;
      var lowerBound = lastOffset - maxAllowedDrift;
      var upperBound = lastOffset + maxAllowedDrift;
      return offset >= lowerBound && offset <= upperBound;
    } catch (e) {
      return true;
    }
  }

  function reset() {
    _resetInitialSettings();

    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].ATTEMPT_BACKGROUND_SYNC, _onAttemptBackgroundSync, instance);
  }

  instance = {
    initialize: initialize,
    attemptSync: attemptSync,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

TimeSyncController.__dashjs_factory_name = 'TimeSyncController';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_5__["default"].getSingletonFactory(TimeSyncController);
factory.HTTP_TIMEOUT_MS = HTTP_TIMEOUT_MS;
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_5__["default"].updateSingletonFactory(TimeSyncController.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/controllers/XlinkController.js":
/*!******************************************************!*\
  !*** ./src/streaming/controllers/XlinkController.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1690708__) {

"use strict";
__nested_webpack_require_1690708__.r(__webpack_exports__);
/* harmony import */ var _XlinkLoader__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1690708__(/*! ../XlinkLoader */ "./src/streaming/XlinkLoader.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1690708__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1690708__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1690708__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _externals_xml2json__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1690708__(/*! ../../../externals/xml2json */ "./externals/xml2json.js");
/* harmony import */ var _utils_URLUtils__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1690708__(/*! ../utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1690708__(/*! ../../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







var RESOLVE_TYPE_ONLOAD = 'onLoad';
var RESOLVE_TYPE_ONACTUATE = 'onActuate';
var RESOLVE_TO_ZERO = 'urn:mpeg:dash:resolve-to-zero:2013';

function XlinkController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var urlUtils = Object(_utils_URLUtils__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
  var instance, matchers, iron, manifest, converter, xlinkLoader;

  function setup() {
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].XLINK_ELEMENT_LOADED, onXlinkElementLoaded, instance);
    xlinkLoader = Object(_XlinkLoader__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
      errHandler: config.errHandler,
      dashMetrics: config.dashMetrics,
      mediaPlayerModel: config.mediaPlayerModel,
      requestModifier: config.requestModifier,
      settings: config.settings
    });
  }

  function setMatchers(value) {
    if (value) {
      matchers = value;
    }
  }

  function setIron(value) {
    if (value) {
      iron = value;
    }
  }
  /**
   * <p>Triggers the resolution of the xlink.onLoad attributes in the manifest file </p>
   * @param {Object} mpd - the manifest
   */


  function resolveManifestOnLoad(mpd) {
    var elements; // First resolve all periods, so unnecessary requests inside onLoad Periods with Default content are avoided

    converter = new _externals_xml2json__WEBPACK_IMPORTED_MODULE_4__["default"]({
      escapeMode: false,
      attributePrefix: '',
      arrayAccessForm: 'property',
      emptyNodeForm: 'object',
      stripWhitespaces: false,
      enableToStringFunc: false,
      ignoreRoot: true,
      matchers: matchers
    });
    manifest = mpd;

    if (manifest.Period_asArray) {
      elements = getElementsToResolve(manifest.Period_asArray, manifest, _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PERIOD, RESOLVE_TYPE_ONLOAD);
      resolve(elements, _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PERIOD, RESOLVE_TYPE_ONLOAD);
    } else {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].XLINK_READY, {
        manifest: manifest
      });
    }
  }

  function reset() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].XLINK_ELEMENT_LOADED, onXlinkElementLoaded, instance);

    if (xlinkLoader) {
      xlinkLoader.reset();
      xlinkLoader = null;
    }
  }

  function resolve(elements, type, resolveType) {
    var resolveObject = {};
    var element, url;
    resolveObject.elements = elements;
    resolveObject.type = type;
    resolveObject.resolveType = resolveType; // If nothing to resolve, directly call allElementsLoaded

    if (resolveObject.elements.length === 0) {
      onXlinkAllElementsLoaded(resolveObject);
    }

    for (var i = 0; i < resolveObject.elements.length; i++) {
      element = resolveObject.elements[i];

      if (urlUtils.isHTTPURL(element.url)) {
        url = element.url;
      } else {
        url = element.originalContent.BaseURL + element.url;
      }

      xlinkLoader.load(url, element, resolveObject);
    }
  }

  function onXlinkElementLoaded(event) {
    var element, resolveObject;
    var openingTag = '<response>';
    var closingTag = '</response>';
    var mergedContent = '';
    element = event.element;
    resolveObject = event.resolveObject; // if the element resolved into content parse the content

    if (element.resolvedContent) {
      var index = 0; // we add a parent elements so the converter is able to parse multiple elements of the same type which are not wrapped inside a container

      if (element.resolvedContent.indexOf('<?xml') === 0) {
        index = element.resolvedContent.indexOf('?>') + 2; //find the closing position of the xml declaration, if it exists.
      }

      mergedContent = element.resolvedContent.substr(0, index) + openingTag + element.resolvedContent.substr(index) + closingTag;
      element.resolvedContent = converter.xml_str2json(mergedContent);
    }

    if (isResolvingFinished(resolveObject)) {
      onXlinkAllElementsLoaded(resolveObject);
    }
  } // We got to wait till all elements of the current queue are resolved before merging back


  function onXlinkAllElementsLoaded(resolveObject) {
    var elements = [];
    var i, obj;
    mergeElementsBack(resolveObject);

    if (resolveObject.resolveType === RESOLVE_TYPE_ONACTUATE) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].XLINK_READY, {
        manifest: manifest
      });
    }

    if (resolveObject.resolveType === RESOLVE_TYPE_ONLOAD) {
      switch (resolveObject.type) {
        // Start resolving the other elements. We can do Adaptation Set and EventStream in parallel
        case _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PERIOD:
          for (i = 0; i < manifest[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PERIOD + '_asArray'].length; i++) {
            obj = manifest[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PERIOD + '_asArray'][i];

            if (obj.hasOwnProperty(_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].ADAPTATION_SET + '_asArray')) {
              elements = elements.concat(getElementsToResolve(obj[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].ADAPTATION_SET + '_asArray'], obj, _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].ADAPTATION_SET, RESOLVE_TYPE_ONLOAD));
            }

            if (obj.hasOwnProperty(_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].EVENT_STREAM + '_asArray')) {
              elements = elements.concat(getElementsToResolve(obj[_dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].EVENT_STREAM + '_asArray'], obj, _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].EVENT_STREAM, RESOLVE_TYPE_ONLOAD));
            }
          }

          resolve(elements, _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].ADAPTATION_SET, RESOLVE_TYPE_ONLOAD);
          break;

        case _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_6__["default"].ADAPTATION_SET:
          // TODO: Resolve SegmentList here
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].XLINK_READY, {
            manifest: manifest
          });
          break;
      }
    }
  } // Returns the elements with the specific resolve Type


  function getElementsToResolve(elements, parentElement, type, resolveType) {
    var toResolve = [];
    var element, i, xlinkObject; // first remove all the resolve-to-zero elements

    for (i = elements.length - 1; i >= 0; i--) {
      element = elements[i];

      if (element.hasOwnProperty('xlink:href') && element['xlink:href'] === RESOLVE_TO_ZERO) {
        elements.splice(i, 1);
      }
    } // now get the elements with the right resolve type


    for (i = 0; i < elements.length; i++) {
      element = elements[i];

      if (element.hasOwnProperty('xlink:href') && element.hasOwnProperty('xlink:actuate') && element['xlink:actuate'] === resolveType) {
        xlinkObject = createXlinkObject(element['xlink:href'], parentElement, type, i, resolveType, element);
        toResolve.push(xlinkObject);
      }
    }

    return toResolve;
  }

  function mergeElementsBack(resolveObject) {
    var resolvedElements = [];
    var element, type, obj, i, j, k; // Start merging back from the end because of index shifting. Note that the elements with the same parent have to be ordered by index ascending

    for (i = resolveObject.elements.length - 1; i >= 0; i--) {
      element = resolveObject.elements[i];
      type = element.type + '_asArray'; // Element couldn't be resolved or is TODO Inappropriate target: Remove all Xlink attributes

      if (!element.resolvedContent || isInappropriateTarget()) {
        delete element.originalContent['xlink:actuate'];
        delete element.originalContent['xlink:href'];
        resolvedElements.push(element.originalContent);
      } // Element was successfully resolved
      else if (element.resolvedContent) {
          for (j = 0; j < element.resolvedContent[type].length; j++) {
            //TODO Contains another Xlink attribute with xlink:actuate set to onload. Remove all xLink attributes
            obj = element.resolvedContent[type][j];
            resolvedElements.push(obj);
          }
        } // Replace the old elements in the parent with the resolved ones


      element.parentElement[type].splice(element.index, 1);

      for (k = 0; k < resolvedElements.length; k++) {
        element.parentElement[type].splice(element.index + k, 0, resolvedElements[k]);
      }

      resolvedElements = [];
    }

    if (resolveObject.elements.length > 0) {
      iron.run(manifest);
    }
  }

  function createXlinkObject(url, parentElement, type, index, resolveType, originalContent) {
    return {
      url: url,
      parentElement: parentElement,
      type: type,
      index: index,
      resolveType: resolveType,
      originalContent: originalContent,
      resolvedContent: null,
      resolved: false
    };
  } // Check if all pending requests are finished


  function isResolvingFinished(elementsToResolve) {
    var i, obj;

    for (i = 0; i < elementsToResolve.elements.length; i++) {
      obj = elementsToResolve.elements[i];

      if (obj.resolved === false) {
        return false;
      }
    }

    return true;
  } // TODO : Do some syntax check here if the target is valid or not


  function isInappropriateTarget() {
    return false;
  }

  instance = {
    resolveManifestOnLoad: resolveManifestOnLoad,
    setMatchers: setMatchers,
    setIron: setIron,
    reset: reset
  };
  setup();
  return instance;
}

XlinkController.__dashjs_factory_name = 'XlinkController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getClassFactory(XlinkController));

/***/ }),

/***/ "./src/streaming/metrics/MetricsReporting.js":
/*!***************************************************!*\
  !*** ./src/streaming/metrics/MetricsReporting.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1704521__) {

"use strict";
__nested_webpack_require_1704521__.r(__webpack_exports__);
/* harmony import */ var _utils_DVBErrorsTranslator__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1704521__(/*! ./utils/DVBErrorsTranslator */ "./src/streaming/metrics/utils/DVBErrorsTranslator.js");
/* harmony import */ var _MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1704521__(/*! ./MetricsReportingEvents */ "./src/streaming/metrics/MetricsReportingEvents.js");
/* harmony import */ var _controllers_MetricsCollectionController__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1704521__(/*! ./controllers/MetricsCollectionController */ "./src/streaming/metrics/controllers/MetricsCollectionController.js");
/* harmony import */ var _metrics_MetricsHandlerFactory__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1704521__(/*! ./metrics/MetricsHandlerFactory */ "./src/streaming/metrics/metrics/MetricsHandlerFactory.js");
/* harmony import */ var _reporting_ReportingFactory__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1704521__(/*! ./reporting/ReportingFactory */ "./src/streaming/metrics/reporting/ReportingFactory.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function MetricsReporting() {
  var context = this.context;
  var instance, dvbErrorsTranslator;
  /**
   * Create a MetricsCollectionController, and a DVBErrorsTranslator
   * @param {Object} config - dependancies from owner
   * @return {MetricsCollectionController} Metrics Collection Controller
   */

  function createMetricsReporting(config) {
    dvbErrorsTranslator = Object(_utils_DVBErrorsTranslator__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance({
      eventBus: config.eventBus,
      dashMetrics: config.dashMetrics,
      metricsConstants: config.metricsConstants,
      events: config.events
    });
    dvbErrorsTranslator.initialise();
    return Object(_controllers_MetricsCollectionController__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create(config);
  }
  /**
   * Get the ReportingFactory to allow new reporters to be registered
   * @return {ReportingFactory} Reporting Factory
   */


  function getReportingFactory() {
    return Object(_reporting_ReportingFactory__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  }
  /**
   * Get the MetricsHandlerFactory to allow new handlers to be registered
   * @return {MetricsHandlerFactory} Metrics Handler Factory
   */


  function getMetricsHandlerFactory() {
    return Object(_metrics_MetricsHandlerFactory__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance();
  }

  instance = {
    createMetricsReporting: createMetricsReporting,
    getReportingFactory: getReportingFactory,
    getMetricsHandlerFactory: getMetricsHandlerFactory
  };
  return instance;
}

MetricsReporting.__dashjs_factory_name = 'MetricsReporting';
var factory = dashjs.FactoryMaker.getClassFactory(MetricsReporting);
/* jshint ignore:line */

factory.events = _MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_1__["default"];
dashjs.FactoryMaker.updateClassFactory(MetricsReporting.__dashjs_factory_name, factory);
/* jshint ignore:line */

/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/metrics/MetricsReportingEvents.js":
/*!*********************************************************!*\
  !*** ./src/streaming/metrics/MetricsReportingEvents.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1709922__) {

"use strict";
__nested_webpack_require_1709922__.r(__webpack_exports__);
/* harmony import */ var _core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1709922__(/*! ../../core/events/EventsBase */ "./src/core/events/EventsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @implements EventsBase
 */

var MetricsReportingEvents = /*#__PURE__*/function (_EventsBase) {
  _inherits(MetricsReportingEvents, _EventsBase);

  var _super = _createSuper(MetricsReportingEvents);

  function MetricsReportingEvents() {
    var _this;

    _classCallCheck(this, MetricsReportingEvents);

    _this = _super.call(this);
    _this.METRICS_INITIALISATION_COMPLETE = 'internal_metricsReportingInitialized';
    _this.BECAME_REPORTING_PLAYER = 'internal_becameReportingPlayer';
    /**
     * Triggered when CMCD data was generated for a HTTP request
     * @event MetricsReportingEvents#CMCD_DATA_GENERATED
     */

    _this.CMCD_DATA_GENERATED = 'cmcdDataGenerated';
    return _this;
  }

  return MetricsReportingEvents;
}(_core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var metricsReportingEvents = new MetricsReportingEvents();
/* harmony default export */ __webpack_exports__["default"] = (metricsReportingEvents);

/***/ }),

/***/ "./src/streaming/metrics/controllers/MetricsCollectionController.js":
/*!**************************************************************************!*\
  !*** ./src/streaming/metrics/controllers/MetricsCollectionController.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1715888__) {

"use strict";
__nested_webpack_require_1715888__.r(__webpack_exports__);
/* harmony import */ var _MetricsController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1715888__(/*! ./MetricsController */ "./src/streaming/metrics/controllers/MetricsController.js");
/* harmony import */ var _utils_ManifestParsing__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1715888__(/*! ../utils/ManifestParsing */ "./src/streaming/metrics/utils/ManifestParsing.js");
/* harmony import */ var _MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1715888__(/*! ../MetricsReportingEvents */ "./src/streaming/metrics/MetricsReportingEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function MetricsCollectionController(config) {
  config = config || {};
  var instance;
  var metricsControllers = {};
  var context = this.context;
  var eventBus = config.eventBus;
  var events = config.events;

  function update(e) {
    if (e.error) {
      return;
    } // start by assuming all existing controllers need removing


    var controllersToRemove = Object.keys(metricsControllers);
    var metrics = Object(_utils_ManifestParsing__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance({
      adapter: config.adapter,
      constants: config.constants
    }).getMetrics(e.manifest);
    metrics.forEach(function (m) {
      var key = JSON.stringify(m);

      if (!metricsControllers.hasOwnProperty(key)) {
        try {
          var controller = Object(_MetricsController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create(config);
          controller.initialize(m);
          metricsControllers[key] = controller;
        } catch (e) {// fail quietly
        }
      } else {
        // we still need this controller - delete from removal list
        controllersToRemove.splice(key, 1);
      }
    }); // now remove the unwanted controllers

    controllersToRemove.forEach(function (c) {
      metricsControllers[c].reset();
      delete metricsControllers[c];
    });
    eventBus.trigger(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_2__["default"].METRICS_INITIALISATION_COMPLETE);
  }

  function resetMetricsControllers() {
    Object.keys(metricsControllers).forEach(function (key) {
      metricsControllers[key].reset();
    });
    metricsControllers = {};
  }

  function setup() {
    eventBus.on(events.MANIFEST_UPDATED, update, instance);
    eventBus.on(events.STREAM_TEARDOWN_COMPLETE, resetMetricsControllers, instance);
  }

  function reset() {
    eventBus.off(events.MANIFEST_UPDATED, update, instance);
    eventBus.off(events.STREAM_TEARDOWN_COMPLETE, resetMetricsControllers, instance);
  }

  instance = {
    reset: reset
  };
  setup();
  return instance;
}

MetricsCollectionController.__dashjs_factory_name = 'MetricsCollectionController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MetricsCollectionController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/controllers/MetricsController.js":
/*!****************************************************************!*\
  !*** ./src/streaming/metrics/controllers/MetricsController.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1721110__) {

"use strict";
__nested_webpack_require_1721110__.r(__webpack_exports__);
/* harmony import */ var _RangeController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1721110__(/*! ./RangeController */ "./src/streaming/metrics/controllers/RangeController.js");
/* harmony import */ var _ReportingController__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1721110__(/*! ./ReportingController */ "./src/streaming/metrics/controllers/ReportingController.js");
/* harmony import */ var _MetricsHandlersController__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1721110__(/*! ./MetricsHandlersController */ "./src/streaming/metrics/controllers/MetricsHandlersController.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function MetricsController(config) {
  config = config || {};
  var metricsHandlersController, reportingController, rangeController, instance;
  var context = this.context;

  function initialize(metricsEntry) {
    try {
      rangeController = Object(_RangeController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
        mediaElement: config.mediaElement
      });
      rangeController.initialize(metricsEntry.Range);
      reportingController = Object(_ReportingController__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
        debug: config.debug,
        metricsConstants: config.metricsConstants,
        mediaPlayerModel: config.mediaPlayerModel
      });
      reportingController.initialize(metricsEntry.Reporting, rangeController);
      metricsHandlersController = Object(_MetricsHandlersController__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
        debug: config.debug,
        eventBus: config.eventBus,
        metricsConstants: config.metricsConstants,
        events: config.events
      });
      metricsHandlersController.initialize(metricsEntry.metrics, reportingController);
    } catch (e) {
      reset();
      throw e;
    }
  }

  function reset() {
    if (metricsHandlersController) {
      metricsHandlersController.reset();
    }

    if (reportingController) {
      reportingController.reset();
    }

    if (rangeController) {
      rangeController.reset();
    }
  }

  instance = {
    initialize: initialize,
    reset: reset
  };
  return instance;
}

MetricsController.__dashjs_factory_name = 'MetricsController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MetricsController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/controllers/MetricsHandlersController.js":
/*!************************************************************************!*\
  !*** ./src/streaming/metrics/controllers/MetricsHandlersController.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1725843__) {

"use strict";
__nested_webpack_require_1725843__.r(__webpack_exports__);
/* harmony import */ var _metrics_MetricsHandlerFactory__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1725843__(/*! ../metrics/MetricsHandlerFactory */ "./src/streaming/metrics/metrics/MetricsHandlerFactory.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function MetricsHandlersController(config) {
  config = config || {};
  var handlers = [];
  var instance;
  var context = this.context;
  var eventBus = config.eventBus;
  var Events = config.events;
  var metricsHandlerFactory = Object(_metrics_MetricsHandlerFactory__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance({
    debug: config.debug,
    eventBus: config.eventBus,
    metricsConstants: config.metricsConstants
  });

  function handle(e) {
    handlers.forEach(function (handler) {
      handler.handleNewMetric(e.metric, e.value, e.mediaType);
    });
  }

  function initialize(metrics, reportingController) {
    metrics.split(',').forEach(function (m, midx, ms) {
      var handler; // there is a bug in ISO23009-1 where the metrics attribute
      // is a comma-separated list but HttpList key can contain a
      // comma enclosed by ().

      if (m.indexOf('(') !== -1 && m.indexOf(')') === -1) {
        var nextm = ms[midx + 1];

        if (nextm && nextm.indexOf('(') === -1 && nextm.indexOf(')') !== -1) {
          m += ',' + nextm; // delete the next metric so forEach does not visit.

          delete ms[midx + 1];
        }
      }

      handler = metricsHandlerFactory.create(m, reportingController);

      if (handler) {
        handlers.push(handler);
      }
    });
    eventBus.on(Events.METRIC_ADDED, handle, instance);
    eventBus.on(Events.METRIC_UPDATED, handle, instance);
  }

  function reset() {
    eventBus.off(Events.METRIC_ADDED, handle, instance);
    eventBus.off(Events.METRIC_UPDATED, handle, instance);
    handlers.forEach(function (handler) {
      return handler.reset();
    });
    handlers = [];
  }

  instance = {
    initialize: initialize,
    reset: reset
  };
  return instance;
}

MetricsHandlersController.__dashjs_factory_name = 'MetricsHandlersController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MetricsHandlersController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/controllers/RangeController.js":
/*!**************************************************************!*\
  !*** ./src/streaming/metrics/controllers/RangeController.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1730430__) {

"use strict";
__nested_webpack_require_1730430__.r(__webpack_exports__);
/* harmony import */ var _utils_CustomTimeRanges__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1730430__(/*! ../../utils/CustomTimeRanges */ "./src/streaming/utils/CustomTimeRanges.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function RangeController(config) {
  config = config || {};
  var useWallClockTime = false;
  var context = this.context;
  var instance, ranges;
  var mediaElement = config.mediaElement;

  function initialize(rs) {
    if (rs && rs.length) {
      rs.forEach(function (r) {
        var start = r.starttime;
        var end = start + r.duration;
        ranges.add(start, end);
      });
      useWallClockTime = !!rs[0]._useWallClockTime;
    }
  }

  function reset() {
    ranges.clear();
  }

  function setup() {
    ranges = Object(_utils_CustomTimeRanges__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create();
  }

  function isEnabled() {
    var numRanges = ranges.length;
    var time;

    if (!numRanges) {
      return true;
    } // When not present, DASH Metrics reporting is requested
    // for the whole duration of the content.


    time = useWallClockTime ? new Date().getTime() / 1000 : mediaElement.currentTime;

    for (var i = 0; i < numRanges; i += 1) {
      var start = ranges.start(i);
      var end = ranges.end(i);

      if (start <= time && time < end) {
        return true;
      }
    }

    return false;
  }

  instance = {
    initialize: initialize,
    reset: reset,
    isEnabled: isEnabled
  };
  setup();
  return instance;
}

RangeController.__dashjs_factory_name = 'RangeController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(RangeController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/controllers/ReportingController.js":
/*!******************************************************************!*\
  !*** ./src/streaming/metrics/controllers/ReportingController.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1734490__) {

"use strict";
__nested_webpack_require_1734490__.r(__webpack_exports__);
/* harmony import */ var _reporting_ReportingFactory__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1734490__(/*! ../reporting/ReportingFactory */ "./src/streaming/metrics/reporting/ReportingFactory.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function ReportingController(config) {
  var reporters = [];
  var instance;
  var reportingFactory = Object(_reporting_ReportingFactory__WEBPACK_IMPORTED_MODULE_0__["default"])(this.context).getInstance(config);

  function initialize(reporting, rangeController) {
    // "if multiple Reporting elements are present, it is expected that
    // the client processes one of the recognized reporting schemes."
    // to ignore this, and support multiple Reporting per Metric,
    // simply change the 'some' below to 'forEach'
    reporting.some(function (r) {
      var reporter = reportingFactory.create(r, rangeController);

      if (reporter) {
        reporters.push(reporter);
        return true;
      }
    });
  }

  function reset() {
    reporters.forEach(function (r) {
      return r.reset();
    });
    reporters = [];
  }

  function report(type, vos) {
    reporters.forEach(function (r) {
      return r.report(type, vos);
    });
  }

  instance = {
    initialize: initialize,
    reset: reset,
    report: report
  };
  return instance;
}

ReportingController.__dashjs_factory_name = 'ReportingController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(ReportingController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/metrics/MetricsHandlerFactory.js":
/*!****************************************************************!*\
  !*** ./src/streaming/metrics/metrics/MetricsHandlerFactory.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1738336__) {

"use strict";
__nested_webpack_require_1738336__.r(__webpack_exports__);
/* harmony import */ var _handlers_BufferLevelHandler__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1738336__(/*! ./handlers/BufferLevelHandler */ "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js");
/* harmony import */ var _handlers_DVBErrorsHandler__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1738336__(/*! ./handlers/DVBErrorsHandler */ "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js");
/* harmony import */ var _handlers_HttpListHandler__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1738336__(/*! ./handlers/HttpListHandler */ "./src/streaming/metrics/metrics/handlers/HttpListHandler.js");
/* harmony import */ var _handlers_GenericMetricHandler__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1738336__(/*! ./handlers/GenericMetricHandler */ "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */





function MetricsHandlerFactory(config) {
  config = config || {};
  var instance;
  var logger = config.debug ? config.debug.getLogger(instance) : {}; // group 1: key, [group 3: n [, group 5: type]]

  var keyRegex = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/;
  var context = this.context;
  var knownFactoryProducts = {
    BufferLevel: _handlers_BufferLevelHandler__WEBPACK_IMPORTED_MODULE_0__["default"],
    DVBErrors: _handlers_DVBErrorsHandler__WEBPACK_IMPORTED_MODULE_1__["default"],
    HttpList: _handlers_HttpListHandler__WEBPACK_IMPORTED_MODULE_2__["default"],
    PlayList: _handlers_GenericMetricHandler__WEBPACK_IMPORTED_MODULE_3__["default"],
    RepSwitchList: _handlers_GenericMetricHandler__WEBPACK_IMPORTED_MODULE_3__["default"],
    TcpList: _handlers_GenericMetricHandler__WEBPACK_IMPORTED_MODULE_3__["default"]
  };

  function create(listType, reportingController) {
    var matches = listType.match(keyRegex);
    var handler;

    if (!matches) {
      return;
    }

    try {
      handler = knownFactoryProducts[matches[1]](context).create({
        eventBus: config.eventBus,
        metricsConstants: config.metricsConstants
      });
      handler.initialize(matches[1], reportingController, matches[3], matches[5]);
    } catch (e) {
      handler = null;
      logger.error("MetricsHandlerFactory: Could not create handler for type ".concat(matches[1], " with args ").concat(matches[3], ", ").concat(matches[5], " (").concat(e.message, ")"));
    }

    return handler;
  }

  function register(key, handler) {
    knownFactoryProducts[key] = handler;
  }

  function unregister(key) {
    delete knownFactoryProducts[key];
  }

  instance = {
    create: create,
    register: register,
    unregister: unregister
  };
  return instance;
}

MetricsHandlerFactory.__dashjs_factory_name = 'MetricsHandlerFactory';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(MetricsHandlerFactory));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js":
/*!**********************************************************************!*\
  !*** ./src/streaming/metrics/metrics/handlers/BufferLevelHandler.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1743586__) {

"use strict";
__nested_webpack_require_1743586__.r(__webpack_exports__);
/* harmony import */ var _utils_HandlerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1743586__(/*! ../../utils/HandlerHelpers */ "./src/streaming/metrics/utils/HandlerHelpers.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function BufferLevelHandler(config) {
  config = config || {};
  var instance, reportingController, n, name, interval, lastReportedTime;
  var context = this.context;
  var handlerHelpers = Object(_utils_HandlerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var storedVOs = [];
  var metricsConstants = config.metricsConstants;

  function getLowestBufferLevelVO() {
    try {
      return Object.keys(storedVOs).map(function (key) {
        return storedVOs[key];
      }).reduce(function (a, b) {
        return a.level < b.level ? a : b;
      });
    } catch (e) {
      return;
    }
  }

  function intervalCallback() {
    var vo = getLowestBufferLevelVO();

    if (vo) {
      if (lastReportedTime !== vo.t) {
        lastReportedTime = vo.t;
        reportingController.report(name, vo);
      }
    }
  }

  function initialize(basename, rc, n_ms) {
    if (rc) {
      // this will throw if n is invalid, to be
      // caught by the initialize caller.
      n = handlerHelpers.validateN(n_ms);
      reportingController = rc;
      name = handlerHelpers.reconstructFullMetricName(basename, n_ms);
      interval = setInterval(intervalCallback, n);
    }
  }

  function reset() {
    clearInterval(interval);
    interval = null;
    n = 0;
    reportingController = null;
    lastReportedTime = null;
  }

  function handleNewMetric(metric, vo, type) {
    if (metric === metricsConstants.BUFFER_LEVEL) {
      storedVOs[type] = vo;
    }
  }

  instance = {
    initialize: initialize,
    reset: reset,
    handleNewMetric: handleNewMetric
  };
  return instance;
}

BufferLevelHandler.__dashjs_factory_name = 'BufferLevelHandler';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(BufferLevelHandler));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js":
/*!********************************************************************!*\
  !*** ./src/streaming/metrics/metrics/handlers/DVBErrorsHandler.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1748003__) {

"use strict";
__nested_webpack_require_1748003__.r(__webpack_exports__);
/* harmony import */ var _MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1748003__(/*! ../../MetricsReportingEvents */ "./src/streaming/metrics/MetricsReportingEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function DVBErrorsHandler(config) {
  config = config || {};
  var instance, reportingController;
  var eventBus = config.eventBus;
  var metricsConstants = config.metricsConstants;

  function onInitialisationComplete() {
    // we only want to report this once per call to initialize
    eventBus.off(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_0__["default"].METRICS_INITIALISATION_COMPLETE, onInitialisationComplete, this); // Note: A Player becoming a reporting Player is itself
    // something which is recorded by the DVBErrors metric.

    eventBus.trigger(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_0__["default"].BECAME_REPORTING_PLAYER);
  }

  function initialize(unused, rc) {
    if (rc) {
      reportingController = rc;
      eventBus.on(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_0__["default"].METRICS_INITIALISATION_COMPLETE, onInitialisationComplete, this);
    }
  }

  function reset() {
    reportingController = null;
  }

  function handleNewMetric(metric, vo) {
    // simply pass metric straight through
    if (metric === metricsConstants.DVB_ERRORS) {
      if (reportingController) {
        reportingController.report(metric, vo);
      }
    }
  }

  instance = {
    initialize: initialize,
    reset: reset,
    handleNewMetric: handleNewMetric
  };
  return instance;
}

/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(DVBErrorsHandler));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js":
/*!************************************************************************!*\
  !*** ./src/streaming/metrics/metrics/handlers/GenericMetricHandler.js ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1752065__) {

"use strict";
__nested_webpack_require_1752065__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @ignore
 */
function GenericMetricHandler() {
  var instance, metricName, reportingController;

  function initialize(name, rc) {
    metricName = name;
    reportingController = rc;
  }

  function reset() {
    reportingController = null;
    metricName = undefined;
  }

  function handleNewMetric(metric, vo) {
    // simply pass metric straight through
    if (metric === metricName) {
      if (reportingController) {
        reportingController.report(metricName, vo);
      }
    }
  }

  instance = {
    initialize: initialize,
    reset: reset,
    handleNewMetric: handleNewMetric
  };
  return instance;
}

GenericMetricHandler.__dashjs_factory_name = 'GenericMetricHandler';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(GenericMetricHandler));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/metrics/handlers/HttpListHandler.js":
/*!*******************************************************************!*\
  !*** ./src/streaming/metrics/metrics/handlers/HttpListHandler.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1755282__) {

"use strict";
__nested_webpack_require_1755282__.r(__webpack_exports__);
/* harmony import */ var _utils_HandlerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1755282__(/*! ../../utils/HandlerHelpers */ "./src/streaming/metrics/utils/HandlerHelpers.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function HttpListHandler(config) {
  config = config || {};
  var instance, reportingController, n, type, name, interval;
  var storedVos = [];
  var handlerHelpers = Object(_utils_HandlerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(this.context).getInstance();
  var metricsConstants = config.metricsConstants;

  function intervalCallback() {
    var vos = storedVos;

    if (vos.length) {
      if (reportingController) {
        reportingController.report(name, vos);
      }
    }

    storedVos = [];
  }

  function initialize(basename, rc, n_ms, requestType) {
    if (rc) {
      // this will throw if n is invalid, to be
      // caught by the initialize caller.
      n = handlerHelpers.validateN(n_ms);
      reportingController = rc;

      if (requestType && requestType.length) {
        type = requestType;
      }

      name = handlerHelpers.reconstructFullMetricName(basename, n_ms, requestType);
      interval = setInterval(intervalCallback, n);
    }
  }

  function reset() {
    clearInterval(interval);
    interval = null;
    n = null;
    type = null;
    storedVos = [];
    reportingController = null;
  }

  function handleNewMetric(metric, vo) {
    if (metric === metricsConstants.HTTP_REQUEST) {
      if (!type || type === vo.type) {
        storedVos.push(vo);
      }
    }
  }

  instance = {
    initialize: initialize,
    reset: reset,
    handleNewMetric: handleNewMetric
  };
  return instance;
}

HttpListHandler.__dashjs_factory_name = 'HttpListHandler';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(HttpListHandler));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/reporting/ReportingFactory.js":
/*!*************************************************************!*\
  !*** ./src/streaming/metrics/reporting/ReportingFactory.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1759493__) {

"use strict";
__nested_webpack_require_1759493__.r(__webpack_exports__);
/* harmony import */ var _reporters_DVBReporting__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1759493__(/*! ./reporters/DVBReporting */ "./src/streaming/metrics/reporting/reporters/DVBReporting.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function ReportingFactory(config) {
  config = config || {};
  var knownReportingSchemeIdUris = {
    'urn:dvb:dash:reporting:2014': _reporters_DVBReporting__WEBPACK_IMPORTED_MODULE_0__["default"]
  };
  var context = this.context;
  var instance;
  var logger = config.debug ? config.debug.getLogger(instance) : {};
  var metricsConstants = config.metricsConstants;
  var mediaPlayerModel = config.mediaPlayerModel || {};

  function create(entry, rangeController) {
    var reporting;

    try {
      reporting = knownReportingSchemeIdUris[entry.schemeIdUri](context).create({
        metricsConstants: metricsConstants,
        mediaPlayerModel: mediaPlayerModel
      });
      reporting.initialize(entry, rangeController);
    } catch (e) {
      reporting = null;
      logger.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(entry.schemeIdUri, " (").concat(e.message, ")"));
    }

    return reporting;
  }

  function register(schemeIdUri, moduleName) {
    knownReportingSchemeIdUris[schemeIdUri] = moduleName;
  }

  function unregister(schemeIdUri) {
    delete knownReportingSchemeIdUris[schemeIdUri];
  }

  instance = {
    create: create,
    register: register,
    unregister: unregister
  };
  return instance;
}

ReportingFactory.__dashjs_factory_name = 'ReportingFactory';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(ReportingFactory));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/reporting/reporters/DVBReporting.js":
/*!*******************************************************************!*\
  !*** ./src/streaming/metrics/reporting/reporters/DVBReporting.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1763548__) {

"use strict";
__nested_webpack_require_1763548__.r(__webpack_exports__);
/* harmony import */ var _utils_MetricSerialiser__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1763548__(/*! ../../utils/MetricSerialiser */ "./src/streaming/metrics/utils/MetricSerialiser.js");
/* harmony import */ var _utils_RNG__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1763548__(/*! ../../utils/RNG */ "./src/streaming/metrics/utils/RNG.js");
/* harmony import */ var _models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1763548__(/*! ../../../models/CustomParametersModel */ "./src/streaming/models/CustomParametersModel.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function DVBReporting(config) {
  config = config || {};
  var instance;
  var context = this.context;
  var metricSerialiser, customParametersModel, randomNumberGenerator, reportingPlayerStatusDecided, isReportingPlayer, reportingUrl, rangeController;
  var USE_DRAFT_DVB_SPEC = true;
  var allowPendingRequestsToCompleteOnReset = true;
  var pendingRequests = [];
  var metricsConstants = config.metricsConstants;

  function setup() {
    metricSerialiser = Object(_utils_MetricSerialiser__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
    randomNumberGenerator = Object(_utils_RNG__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
    customParametersModel = Object(_models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
    resetInitialSettings();
  }

  function doGetRequest(url, successCB, failureCB) {
    var req = new XMLHttpRequest();
    req.withCredentials = customParametersModel.getXHRWithCredentialsForType(metricsConstants.HTTP_REQUEST_DVB_REPORTING_TYPE);

    var oncomplete = function oncomplete() {
      var reqIndex = pendingRequests.indexOf(req);

      if (reqIndex === -1) {
        return;
      } else {
        pendingRequests.splice(reqIndex, 1);
      }

      if (req.status >= 200 && req.status < 300) {
        if (successCB) {
          successCB();
        }
      } else {
        if (failureCB) {
          failureCB();
        }
      }
    };

    pendingRequests.push(req);

    try {
      req.open('GET', url);
      req.onloadend = oncomplete;
      req.onerror = oncomplete;
      req.send();
    } catch (e) {
      req.onerror();
    }
  }

  function report(type, vos) {
    if (!Array.isArray(vos)) {
      vos = [vos];
    } // If the Player is not a reporting Player, then the Player shall
    // not report any errors.
    // ... In addition to any time restrictions specified by a Range
    // element within the Metrics element.


    if (isReportingPlayer && rangeController.isEnabled()) {
      // This reporting mechanism operates by creating one HTTP GET
      // request for every entry in the top level list of the metric.
      vos.forEach(function (vo) {
        var url = metricSerialiser.serialise(vo); // this has been proposed for errata

        if (USE_DRAFT_DVB_SPEC && type !== metricsConstants.DVB_ERRORS) {
          url = "metricname=".concat(type, "&").concat(url);
        } // Take the value of the @reportingUrl attribute, append a
        // question mark ('?') character and then append the string
        // created in the previous step.


        url = "".concat(reportingUrl, "?").concat(url); // Make an HTTP GET request to the URL contained within the
        // string created in the previous step.

        doGetRequest(url, null, function () {
          // If the Player is unable to make the report, for
          // example because the @reportingUrl is invalid, the
          // host cannot be reached, or an HTTP status code other
          // than one in the 200 series is received, the Player
          // shall cease being a reporting Player for the
          // duration of the MPD.
          isReportingPlayer = false;
        });
      });
    }
  }

  function initialize(entry, rc) {
    var probability;
    rangeController = rc;
    reportingUrl = entry.dvb_reportingUrl; // If a required attribute is missing, the Reporting descriptor may
    // be ignored by the Player

    if (!reportingUrl) {
      throw new Error('required parameter missing (dvb:reportingUrl)');
    } // A Player's status, as a reporting Player or not, shall remain
    // static for the duration of the MPD, regardless of MPD updates.
    // (i.e. only calling reset (or failure) changes this state)


    if (!reportingPlayerStatusDecided) {
      probability = entry.dvb_probability; // TS 103 285 Clause 10.12.3.4
      // If the @probability attribute is set to 1000, it shall be a reporting Player.
      // If the @probability attribute is absent it will take the default value of 1000.
      // For any other value of the @probability attribute, it shall decide at random whether to be a
      // reporting Player, such that the probability of being one is @probability/1000.

      if (probability && (probability === 1000 || probability / 1000 >= randomNumberGenerator.random())) {
        isReportingPlayer = true;
      }

      reportingPlayerStatusDecided = true;
    }
  }

  function resetInitialSettings() {
    reportingPlayerStatusDecided = false;
    isReportingPlayer = false;
    reportingUrl = null;
    rangeController = null;
  }

  function reset() {
    if (!allowPendingRequestsToCompleteOnReset) {
      pendingRequests.forEach(function (req) {
        return req.abort();
      });
      pendingRequests = [];
    }

    resetInitialSettings();
  }

  instance = {
    report: report,
    initialize: initialize,
    reset: reset
  };
  setup();
  return instance;
}

DVBReporting.__dashjs_factory_name = 'DVBReporting';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(DVBReporting));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/utils/DVBErrorsTranslator.js":
/*!************************************************************!*\
  !*** ./src/streaming/metrics/utils/DVBErrorsTranslator.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1771699__) {

"use strict";
__nested_webpack_require_1771699__.r(__webpack_exports__);
/* harmony import */ var _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1771699__(/*! ../vo/DVBErrors */ "./src/streaming/metrics/vo/DVBErrors.js");
/* harmony import */ var _MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1771699__(/*! ../MetricsReportingEvents */ "./src/streaming/metrics/MetricsReportingEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function DVBErrorsTranslator(config) {
  config = config || {};
  var instance, mpd;
  var eventBus = config.eventBus;
  var dashMetrics = config.dashMetrics;
  var metricsConstants = config.metricsConstants; //MediaPlayerEvents have been added to Events in MediaPlayer class

  var Events = config.events;

  function report(vo) {
    var o = new _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"]();

    if (!mpd) {
      return;
    }

    for (var key in vo) {
      if (vo.hasOwnProperty(key)) {
        o[key] = vo[key];
      }
    }

    if (!o.mpdurl) {
      o.mpdurl = mpd.originalUrl || mpd.url;
    }

    if (!o.terror) {
      o.terror = new Date();
    }

    dashMetrics.addDVBErrors(o);
  }

  function onManifestUpdate(e) {
    if (e.error) {
      return;
    }

    mpd = e.manifest;
  }

  function onServiceLocationChanged(e) {
    report({
      errorcode: _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"].BASE_URL_CHANGED,
      servicelocation: e.entry
    });
  }

  function onBecameReporter() {
    report({
      errorcode: _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"].BECAME_REPORTER
    });
  }

  function handleHttpMetric(vo) {
    if (vo.responsecode === 0 || // connection failure - unknown
    vo.responsecode == null || // Generated on .catch() and when uninitialised
    vo.responsecode >= 400 || // HTTP error status code
    vo.responsecode < 100 || // unknown status codes
    vo.responsecode >= 600) {
      // unknown status codes
      report({
        errorcode: vo.responsecode || _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"].CONNECTION_ERROR,
        url: vo.url,
        terror: vo.tresponse,
        servicelocation: vo._serviceLocation
      });
    }
  }

  function onMetricEvent(e) {
    switch (e.metric) {
      case metricsConstants.HTTP_REQUEST:
        handleHttpMetric(e.value);
        break;

      default:
        break;
    }
  }

  function onPlaybackError(e) {
    var reason = e.error ? e.error.code : 0;
    var errorcode;

    switch (reason) {
      case MediaError.MEDIA_ERR_NETWORK:
        errorcode = _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"].CONNECTION_ERROR;
        break;

      case MediaError.MEDIA_ERR_DECODE:
        errorcode = _vo_DVBErrors__WEBPACK_IMPORTED_MODULE_0__["default"].CORRUPT_MEDIA_OTHER;
        break;

      default:
        return;
    }

    report({
      errorcode: errorcode
    });
  }

  function initialise() {
    eventBus.on(Events.MANIFEST_UPDATED, onManifestUpdate, instance);
    eventBus.on(Events.SERVICE_LOCATION_BLACKLIST_CHANGED, onServiceLocationChanged, instance);
    eventBus.on(Events.METRIC_ADDED, onMetricEvent, instance);
    eventBus.on(Events.METRIC_UPDATED, onMetricEvent, instance);
    eventBus.on(Events.PLAYBACK_ERROR, onPlaybackError, instance);
    eventBus.on(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_1__["default"].BECAME_REPORTING_PLAYER, onBecameReporter, instance);
  }

  function reset() {
    eventBus.off(Events.MANIFEST_UPDATED, onManifestUpdate, instance);
    eventBus.off(Events.SERVICE_LOCATION_BLACKLIST_CHANGED, onServiceLocationChanged, instance);
    eventBus.off(Events.METRIC_ADDED, onMetricEvent, instance);
    eventBus.off(Events.METRIC_UPDATED, onMetricEvent, instance);
    eventBus.off(Events.PLAYBACK_ERROR, onPlaybackError, instance);
    eventBus.off(_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_1__["default"].BECAME_REPORTING_PLAYER, onBecameReporter, instance);
  }

  instance = {
    initialise: initialise,
    reset: reset
  };
  return instance;
}

DVBErrorsTranslator.__dashjs_factory_name = 'DVBErrorsTranslator';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(DVBErrorsTranslator));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/utils/HandlerHelpers.js":
/*!*******************************************************!*\
  !*** ./src/streaming/metrics/utils/HandlerHelpers.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1778260__) {

"use strict";
__nested_webpack_require_1778260__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @ignore
 */
function HandlerHelpers() {
  return {
    reconstructFullMetricName: function reconstructFullMetricName(key, n, type) {
      var mn = key;

      if (n) {
        mn += '(' + n;

        if (type && type.length) {
          mn += ',' + type;
        }

        mn += ')';
      }

      return mn;
    },
    validateN: function validateN(n_ms) {
      if (!n_ms) {
        throw new Error('missing n');
      }

      if (isNaN(n_ms)) {
        throw new Error('n is NaN');
      } // n is a positive integer is defined to refer to the metric
      // in which the buffer level is recorded every n ms.


      if (n_ms < 0) {
        throw new Error('n must be positive');
      }

      return n_ms;
    }
  };
}

HandlerHelpers.__dashjs_factory_name = 'HandlerHelpers';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(HandlerHelpers));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/utils/ManifestParsing.js":
/*!********************************************************!*\
  !*** ./src/streaming/metrics/utils/ManifestParsing.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1781536__) {

"use strict";
__nested_webpack_require_1781536__.r(__webpack_exports__);
/* harmony import */ var _vo_Metrics__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1781536__(/*! ../vo/Metrics */ "./src/streaming/metrics/vo/Metrics.js");
/* harmony import */ var _vo_Range__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1781536__(/*! ../vo/Range */ "./src/streaming/metrics/vo/Range.js");
/* harmony import */ var _vo_Reporting__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1781536__(/*! ../vo/Reporting */ "./src/streaming/metrics/vo/Reporting.js");




function ManifestParsing(config) {
  config = config || {};
  var instance;
  var adapter = config.adapter;
  var constants = config.constants;

  function getMetricsRangeStartTime(manifest, dynamic, range) {
    var voPeriods, reportingStartTime;
    var presentationStartTime = 0;

    if (dynamic) {
      // For services with MPD@type='dynamic', the start time is
      // indicated in wall clock time by adding the value of this
      // attribute to the value of the MPD@availabilityStartTime
      // attribute.
      presentationStartTime = adapter.getAvailabilityStartTime(manifest) / 1000;
    } else {
      // For services with MPD@type='static', the start time is indicated
      // in Media Presentation time and is relative to the PeriodStart
      // time of the first Period in this MPD.
      voPeriods = adapter.getRegularPeriods(manifest);

      if (voPeriods.length) {
        presentationStartTime = voPeriods[0].start;
      }
    } // When not present, DASH Metrics collection is
    // requested from the beginning of content
    // consumption.


    reportingStartTime = presentationStartTime;

    if (range && range.hasOwnProperty(constants.START_TIME)) {
      reportingStartTime += range.starttime;
    }

    return reportingStartTime;
  }

  function getMetrics(manifest) {
    var metrics = [];

    if (manifest && manifest.Metrics_asArray) {
      manifest.Metrics_asArray.forEach(function (metric) {
        var metricEntry = new _vo_Metrics__WEBPACK_IMPORTED_MODULE_0__["default"]();
        var isDynamic = adapter.getIsDynamic(manifest);

        if (metric.hasOwnProperty('metrics')) {
          metricEntry.metrics = metric.metrics;
        } else {
          return;
        }

        if (metric.Range_asArray) {
          metric.Range_asArray.forEach(function (range) {
            var rangeEntry = new _vo_Range__WEBPACK_IMPORTED_MODULE_1__["default"]();
            rangeEntry.starttime = getMetricsRangeStartTime(manifest, isDynamic, range);

            if (range.hasOwnProperty('duration')) {
              rangeEntry.duration = range.duration;
            } else {
              // if not present, the value is identical to the
              // Media Presentation duration.
              rangeEntry.duration = adapter.getDuration(manifest);
            }

            rangeEntry._useWallClockTime = isDynamic;
            metricEntry.Range.push(rangeEntry);
          });
        }

        if (metric.Reporting_asArray) {
          metric.Reporting_asArray.forEach(function (reporting) {
            var reportingEntry = new _vo_Reporting__WEBPACK_IMPORTED_MODULE_2__["default"]();

            if (reporting.hasOwnProperty(constants.SCHEME_ID_URI)) {
              reportingEntry.schemeIdUri = reporting.schemeIdUri;
            } else {
              // Invalid Reporting. schemeIdUri must be set. Ignore.
              return;
            }

            if (reporting.hasOwnProperty('value')) {
              reportingEntry.value = reporting.value;
            }

            if (reporting.hasOwnProperty(constants.DVB_REPORTING_URL)) {
              reportingEntry.dvb_reportingUrl = reporting[constants.DVB_REPORTING_URL];
            }

            if (reporting.hasOwnProperty(constants.DVB_PROBABILITY)) {
              reportingEntry.dvb_probability = reporting[constants.DVB_PROBABILITY];
            }

            metricEntry.Reporting.push(reportingEntry);
          });
        } else {
          // Invalid Metrics. At least one reporting must be present. Ignore
          return;
        }

        metrics.push(metricEntry);
      });
    }

    return metrics;
  }

  instance = {
    getMetrics: getMetrics
  };
  return instance;
}

ManifestParsing.__dashjs_factory_name = 'ManifestParsing';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(ManifestParsing));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/utils/MetricSerialiser.js":
/*!*********************************************************!*\
  !*** ./src/streaming/metrics/utils/MetricSerialiser.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1786460__) {

"use strict";
__nested_webpack_require_1786460__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @ignore
 */
function MetricSerialiser() {
  // For each entry in the top level list within the metric (in the case
  // of the DVBErrors metric each entry corresponds to an "error event"
  // described in clause 10.8.4) the Player shall:
  function serialise(metric) {
    var pairs = [];
    var obj = [];
    var key, value; // Take each (key, value) pair from the metric entry and create a
    // string consisting of the name of the key, followed by an equals
    // ('=') character, followed by the string representation of the
    // value. The string representation of the value is created based
    // on the type of the value following the instructions in Table 22.

    for (key in metric) {
      if (metric.hasOwnProperty(key) && key.indexOf('_') !== 0) {
        value = metric[key]; // we want to ensure that keys still end up in the report
        // even if there is no value

        if (value === undefined || value === null) {
          value = '';
        } // DVB A168 10.12.4 Table 22


        if (Array.isArray(value)) {
          // if trace or similar is null, do not include in output
          if (!value.length) {
            continue;
          }

          obj = [];
          value.forEach(function (v) {
            var isBuiltIn = Object.prototype.toString.call(v).slice(8, -1) !== 'Object';
            obj.push(isBuiltIn ? v : serialise(v));
          });
          value = obj.map(encodeURIComponent).join(',');
        } else if (typeof value === 'string') {
          value = encodeURIComponent(value);
        } else if (value instanceof Date) {
          value = value.toISOString();
        } else if (typeof value === 'number') {
          value = Math.round(value);
        }

        pairs.push(key + '=' + value);
      }
    } // Concatenate the strings created in the previous step with an
    // ampersand ('&') character between each one.


    return pairs.join('&');
  }

  return {
    serialise: serialise
  };
}

MetricSerialiser.__dashjs_factory_name = 'MetricSerialiser';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(MetricSerialiser));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/utils/RNG.js":
/*!********************************************!*\
  !*** ./src/streaming/metrics/utils/RNG.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1790952__) {

"use strict";
__nested_webpack_require_1790952__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @ignore
 */
function RNG() {
  // check whether secure random numbers are available. if not, revert to
  // using Math.random
  var crypto = window.crypto || window.msCrypto; // could just as easily use any other array type by changing line below

  var ArrayType = Uint32Array;
  var MAX_VALUE = Math.pow(2, ArrayType.BYTES_PER_ELEMENT * 8) - 1; // currently there is only one client for this code, and that only uses
  // a single random number per initialisation. may want to increase this
  // number if more consumers in the future

  var NUM_RANDOM_NUMBERS = 10;
  var randomNumbers, index, instance;

  function initialise() {
    if (crypto) {
      if (!randomNumbers) {
        randomNumbers = new ArrayType(NUM_RANDOM_NUMBERS);
      }

      crypto.getRandomValues(randomNumbers);
      index = 0;
    }
  }

  function rand(min, max) {
    var r;

    if (!min) {
      min = 0;
    }

    if (!max) {
      max = 1;
    }

    if (crypto) {
      if (index === randomNumbers.length) {
        initialise();
      }

      r = randomNumbers[index] / MAX_VALUE;
      index += 1;
    } else {
      r = Math.random();
    }

    return r * (max - min) + min;
  }

  instance = {
    random: rand
  };
  initialise();
  return instance;
}

RNG.__dashjs_factory_name = 'RNG';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(RNG));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/metrics/vo/DVBErrors.js":
/*!***********************************************!*\
  !*** ./src/streaming/metrics/vo/DVBErrors.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1794699__) {

"use strict";
__nested_webpack_require_1794699__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DVBErrors = function DVBErrors() {
  _classCallCheck(this, DVBErrors);

  this.mpdurl = null; // String - Absolute URL from which the MPD was originally
  // retrieved (MPD updates will not change this value).

  this.errorcode = null; // String - The value of errorcode depends upon the type
  // of error being reported. For an error listed in the
  // ErrorType column below the value is as described in the
  // Value column.
  //
  // ErrorType                                            Value
  // ---------                                            -----
  // HTTP error status code                               HTTP status code
  // Unknown HTTP status code                             HTTP status code
  // SSL connection failed                                "SSL" followed by SSL alert value
  // DNS resolution failed                                "C00"
  // Host unreachable                                     "C01"
  // Connection refused                                   "C02"
  // Connection error – Not otherwise specified           "C03"
  // Corrupt media – ISO BMFF container cannot be parsed  "M00"
  // Corrupt media – Not otherwise specified              "M01"
  // Changing Base URL in use due to errors               "F00"
  // Becoming an error reporting Player                   "S00"

  this.terror = null; // Real-Time - Date and time at which error occurred in UTC,
  // formatted as a combined date and time according to ISO 8601.

  this.url = null; // String - Absolute URL from which data was being requested
  // when this error occurred. If the error report is in relation
  // to corrupt media or changing BaseURL, this may be a null
  // string if the URL from which the media was obtained or
  // which led to the change of BaseURL is no longer known.

  this.ipaddress = null; // String - IP Address which the host name in "url" resolved to.
  // If the error report is in relation to corrupt media or
  // changing BaseURL, this may be a null string if the URL
  // from which the media was obtained or which led to the
  // change of BaseURL is no longer known.

  this.servicelocation = null; // String - The value of the serviceLocation field in the
  // BaseURL being used. In the event of this report indicating
  // a change of BaseURL this is the value from the BaseURL
  // being moved from.
};

DVBErrors.SSL_CONNECTION_FAILED_PREFIX = 'SSL';
DVBErrors.DNS_RESOLUTION_FAILED = 'C00';
DVBErrors.HOST_UNREACHABLE = 'C01';
DVBErrors.CONNECTION_REFUSED = 'C02';
DVBErrors.CONNECTION_ERROR = 'C03';
DVBErrors.CORRUPT_MEDIA_ISOBMFF = 'M00';
DVBErrors.CORRUPT_MEDIA_OTHER = 'M01';
DVBErrors.BASE_URL_CHANGED = 'F00';
DVBErrors.BECAME_REPORTER = 'S00';
/* harmony default export */ __webpack_exports__["default"] = (DVBErrors);

/***/ }),

/***/ "./src/streaming/metrics/vo/Metrics.js":
/*!*********************************************!*\
  !*** ./src/streaming/metrics/vo/Metrics.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1799973__) {

"use strict";
__nested_webpack_require_1799973__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Metrics = function Metrics() {
  _classCallCheck(this, Metrics);

  this.metrics = '';
  this.Range = [];
  this.Reporting = [];
};

/* harmony default export */ __webpack_exports__["default"] = (Metrics);

/***/ }),

/***/ "./src/streaming/metrics/vo/Range.js":
/*!*******************************************!*\
  !*** ./src/streaming/metrics/vo/Range.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1802623__) {

"use strict";
__nested_webpack_require_1802623__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Range = function Range() {
  _classCallCheck(this, Range);

  // as defined in ISO23009-1
  this.starttime = 0;
  this.duration = Infinity; // for internal use

  this._useWallClockTime = false;
};

/* harmony default export */ __webpack_exports__["default"] = (Range);

/***/ }),

/***/ "./src/streaming/metrics/vo/Reporting.js":
/*!***********************************************!*\
  !*** ./src/streaming/metrics/vo/Reporting.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1805355__) {

"use strict";
__nested_webpack_require_1805355__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
// TS 103 285 Clause 10.12.3.3
var DEFAULT_DVB_PROBABILITY = 1000;

var Reporting = function Reporting() {
  _classCallCheck(this, Reporting);

  this.schemeIdUri = '';
  this.value = ''; // DVB Extensions

  this.dvb_reportingUrl = '';
  this.dvb_probability = DEFAULT_DVB_PROBABILITY;
};

/* harmony default export */ __webpack_exports__["default"] = (Reporting);

/***/ }),

/***/ "./src/streaming/models/BaseURLTreeModel.js":
/*!**************************************************!*\
  !*** ./src/streaming/models/BaseURLTreeModel.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1808194__) {

"use strict";
__nested_webpack_require_1808194__.r(__webpack_exports__);
/* harmony import */ var _utils_ObjectUtils__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1808194__(/*! ../utils/ObjectUtils */ "./src/streaming/utils/ObjectUtils.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1808194__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var DEFAULT_INDEX = NaN;

var Node = function Node(_baseUrls, _selectedIdx) {
  _classCallCheck(this, Node);

  this.data = {
    baseUrls: _baseUrls || null,
    selectedIdx: _selectedIdx || DEFAULT_INDEX
  };
  this.children = [];
};

function BaseURLTreeModel() {
  var instance, root, adapter;
  var context = this.context;
  var objectUtils = Object(_utils_ObjectUtils__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();

  function setup() {
    reset();
  }

  function setConfig(config) {
    if (config.adapter) {
      adapter = config.adapter;
    }
  }

  function checkConfig() {
    if (!adapter || !adapter.hasOwnProperty('getBaseURLsFromElement') || !adapter.hasOwnProperty('getRepresentationSortFunction')) {
      throw new Error('setConfig function has to be called previously');
    }
  }

  function updateChildData(node, index, element) {
    var baseUrls = adapter.getBaseURLsFromElement(element);

    if (!node[index]) {
      node[index] = new Node(baseUrls);
    } else {
      if (!objectUtils.areEqual(baseUrls, node[index].data.baseUrls)) {
        node[index].data.baseUrls = baseUrls;
        node[index].data.selectedIdx = DEFAULT_INDEX;
      }
    }
  }

  function getBaseURLCollectionsFromManifest(manifest) {
    checkConfig();
    var baseUrls = adapter.getBaseURLsFromElement(manifest);

    if (!objectUtils.areEqual(baseUrls, root.data.baseUrls)) {
      root.data.baseUrls = baseUrls;
      root.data.selectedIdx = DEFAULT_INDEX;
    }

    if (manifest && manifest.Period_asArray) {
      manifest.Period_asArray.forEach(function (p, pi) {
        updateChildData(root.children, pi, p);

        if (p.AdaptationSet_asArray) {
          p.AdaptationSet_asArray.forEach(function (a, ai) {
            updateChildData(root.children[pi].children, ai, a);

            if (a.Representation_asArray) {
              a.Representation_asArray.sort(adapter.getRepresentationSortFunction()).forEach(function (r, ri) {
                updateChildData(root.children[pi].children[ai].children, ri, r);
              });
            }
          });
        }
      });
    }
  }

  function walk(callback, node) {
    var target = node || root;
    callback(target.data);

    if (target.children) {
      target.children.forEach(function (child) {
        return walk(callback, child);
      });
    }
  }

  function invalidateSelectedIndexes(serviceLocation) {
    walk(function (data) {
      if (!isNaN(data.selectedIdx)) {
        if (serviceLocation === data.baseUrls[data.selectedIdx].serviceLocation) {
          data.selectedIdx = DEFAULT_INDEX;
        }
      }
    });
  }

  function update(manifest) {
    getBaseURLCollectionsFromManifest(manifest);
  }

  function reset() {
    root = new Node();
  }

  function getForPath(path) {
    var target = root;
    var nodes = [target.data];

    if (path) {
      path.forEach(function (p) {
        target = target.children[p];

        if (target) {
          nodes.push(target.data);
        }
      });
    }

    return nodes.filter(function (n) {
      return n.baseUrls.length;
    });
  }

  instance = {
    reset: reset,
    update: update,
    getForPath: getForPath,
    invalidateSelectedIndexes: invalidateSelectedIndexes,
    setConfig: setConfig
  };
  setup();
  return instance;
}

BaseURLTreeModel.__dashjs_factory_name = 'BaseURLTreeModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(BaseURLTreeModel));

/***/ }),

/***/ "./src/streaming/models/CmcdModel.js":
/*!*******************************************!*\
  !*** ./src/streaming/models/CmcdModel.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1814578__) {

"use strict";
__nested_webpack_require_1814578__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1814578__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1814578__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _metrics_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1814578__(/*! ../metrics/MetricsReportingEvents */ "./src/streaming/metrics/MetricsReportingEvents.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1814578__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1814578__(/*! ../../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1814578__(/*! ../../streaming/constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1814578__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _dash_models_DashManifestModel__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1814578__(/*! ../../dash/models/DashManifestModel */ "./src/dash/models/DashManifestModel.js");
/* harmony import */ var _core_Utils__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1814578__(/*! ../../core/Utils */ "./src/core/Utils.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









var CMCD_REQUEST_FIELD_NAME = 'CMCD';
var CMCD_VERSION = 1;
var OBJECT_TYPES = {
  MANIFEST: 'm',
  AUDIO: 'a',
  VIDEO: 'v',
  INIT: 'i',
  CAPTION: 'c',
  ISOBMFF_TEXT_TRACK: 'tt',
  ENCRYPTION_KEY: 'k',
  OTHER: 'o'
};
var STREAMING_FORMATS = {
  DASH: 'd',
  MSS: 's'
};
var STREAM_TYPES = {
  VOD: 'v',
  LIVE: 'l'
};
var RTP_SAFETY_FACTOR = 5;

function CmcdModel() {
  var dashManifestModel, instance, internalData, abrController, dashMetrics, playbackController, streamProcessors, _isStartup, _bufferLevelStarved, _initialMediaRequestsDone;

  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();

  function setup() {
    dashManifestModel = Object(_dash_models_DashManifestModel__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();

    _resetInitialSettings();
  }

  function initialize() {
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_LOADED, _onManifestLoaded, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].PLAYBACK_SEEKED, _onPlaybackSeeked, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].PERIOD_SWITCH_COMPLETED, _onPeriodSwitchComplete, instance);
  }

  function setConfig(config) {
    if (!config) return;

    if (config.abrController) {
      abrController = config.abrController;
    }

    if (config.dashMetrics) {
      dashMetrics = config.dashMetrics;
    }

    if (config.playbackController) {
      playbackController = config.playbackController;
    }
  }

  function _resetInitialSettings() {
    internalData = {
      pr: 1,
      nor: null,
      st: null,
      sf: null,
      sid: "".concat(_core_Utils__WEBPACK_IMPORTED_MODULE_8__["default"].generateUuid()),
      cid: null
    };
    _bufferLevelStarved = {};
    _isStartup = {};
    _initialMediaRequestsDone = {};

    _updateStreamProcessors();
  }

  function _onPeriodSwitchComplete() {
    _updateStreamProcessors();
  }

  function _updateStreamProcessors() {
    if (!playbackController) return;
    var streamController = playbackController.getStreamController();
    if (!streamController) return;
    if (typeof streamController.getActiveStream !== 'function') return;
    var activeStream = streamController.getActiveStream();
    if (!activeStream) return;
    streamProcessors = activeStream.getProcessors();
  }

  function getQueryParameter(request) {
    try {
      if (settings.get().streaming.cmcd && settings.get().streaming.cmcd.enabled) {
        var cmcdData = _getCmcdData(request);

        var filteredCmcdData = _applyWhitelist(cmcdData);

        var finalPayloadString = _buildFinalString(filteredCmcdData);

        eventBus.trigger(_metrics_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_2__["default"].CMCD_DATA_GENERATED, {
          url: request.url,
          mediaType: request.mediaType,
          cmcdData: cmcdData,
          cmcdString: finalPayloadString
        });
        return {
          key: CMCD_REQUEST_FIELD_NAME,
          value: finalPayloadString
        };
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function _applyWhitelist(cmcdData) {
    try {
      var enabledCMCDKeys = settings.get().streaming.cmcd.enabledKeys;
      return Object.keys(cmcdData).filter(function (key) {
        return enabledCMCDKeys.includes(key);
      }).reduce(function (obj, key) {
        obj[key] = cmcdData[key];
        return obj;
      }, {});
    } catch (e) {
      return cmcdData;
    }
  }

  function _copyParameters(data, parameterNames) {
    var copiedData = {};

    var _iterator = _createForOfIteratorHelper(parameterNames),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var name = _step.value;

        if (data[name]) {
          copiedData[name] = data[name];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return copiedData;
  }

  function getHeaderParameters(request) {
    try {
      if (settings.get().streaming.cmcd && settings.get().streaming.cmcd.enabled) {
        var cmcdData = _getCmcdData(request);

        var cmcdObjectHeader = _copyParameters(cmcdData, _applyWhitelistByKeys(['br', 'd', 'ot', 'tb']));

        var cmcdRequestHeader = _copyParameters(cmcdData, _applyWhitelistByKeys(['bl', 'dl', 'mtp', 'nor', 'nrr', 'su']));

        var cmcdStatusHeader = _copyParameters(cmcdData, _applyWhitelistByKeys(['bs', 'rtp']));

        var cmcdSessionHeader = _copyParameters(cmcdData, _applyWhitelistByKeys(['cid', 'pr', 'sf', 'sid', 'st', 'v']));

        var headers = {
          'CMCD-Object': _buildFinalString(cmcdObjectHeader),
          'CMCD-Request': _buildFinalString(cmcdRequestHeader),
          'CMCD-Status': _buildFinalString(cmcdStatusHeader),
          'CMCD-Session': _buildFinalString(cmcdSessionHeader)
        };
        eventBus.trigger(_metrics_MetricsReportingEvents__WEBPACK_IMPORTED_MODULE_2__["default"].CMCD_DATA_GENERATED, {
          url: request.url,
          mediaType: request.mediaType,
          cmcdData: cmcdData,
          headers: headers
        });
        return headers;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function _applyWhitelistByKeys(keys) {
    var enabledCMCDKeys = settings.get().streaming.cmcd.enabledKeys;
    return keys.filter(function (key) {
      return enabledCMCDKeys.includes(key);
    });
  }

  function _getCmcdData(request) {
    try {
      var cmcdData = null;

      if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].MPD_TYPE) {
        return _getCmcdDataForMpd(request);
      } else if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
        _initForMediaType(request.mediaType);

        return _getCmcdDataForMediaSegment(request);
      } else if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].INIT_SEGMENT_TYPE) {
        return _getCmcdDataForInitSegment(request);
      } else if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].OTHER_TYPE || request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].XLINK_EXPANSION_TYPE) {
        return _getCmcdDataForOther(request);
      } else if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_6__["HTTPRequest"].LICENSE) {
        return _getCmcdDataForLicense(request);
      }

      return cmcdData;
    } catch (e) {
      return null;
    }
  }

  function _getCmcdDataForLicense(request) {
    var data = _getGenericCmcdData(request);

    data.ot = OBJECT_TYPES.ENCRYPTION_KEY;
    return data;
  }

  function _getCmcdDataForMpd() {
    var data = _getGenericCmcdData();

    data.ot = OBJECT_TYPES.MANIFEST;
    return data;
  }

  function _getCmcdDataForMediaSegment(request) {
    var data = _getGenericCmcdData();

    var encodedBitrate = _getBitrateByRequest(request);

    var d = _getObjectDurationByRequest(request);

    var mtp = _getMeasuredThroughputByType(request.mediaType);

    var dl = _getDeadlineByType(request.mediaType);

    var bl = _getBufferLevelByType(request.mediaType);

    var tb = _getTopBitrateByType(request.mediaType);

    var pr = internalData.pr;

    var nextRequest = _probeNextRequest(request.mediaType);

    var ot;
    if (request.mediaType === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].VIDEO) ot = OBJECT_TYPES.VIDEO;
    if (request.mediaType === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].AUDIO) ot = OBJECT_TYPES.AUDIO;

    if (request.mediaType === _streaming_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].TEXT) {
      if (request.mediaInfo.mimeType === 'application/mp4') {
        ot = OBJECT_TYPES.ISOBMFF_TEXT_TRACK;
      } else {
        ot = OBJECT_TYPES.CAPTION;
      }
    }

    var rtp = settings.get().streaming.cmcd.rtp;

    if (!rtp) {
      rtp = _calculateRtp(request);
    }

    data.rtp = rtp;

    if (nextRequest) {
      if (request.url !== nextRequest.url) {
        data.nor = encodeURIComponent(_core_Utils__WEBPACK_IMPORTED_MODULE_8__["default"].getRelativeUrl(request.url, nextRequest.url));
      } else if (nextRequest.range) {
        data.nrr = nextRequest.range;
      }
    }

    if (encodedBitrate) {
      data.br = encodedBitrate;
    }

    if (ot) {
      data.ot = ot;
    }

    if (!isNaN(d)) {
      data.d = d;
    }

    if (!isNaN(mtp)) {
      data.mtp = mtp;
    }

    if (!isNaN(dl)) {
      data.dl = dl;
    }

    if (!isNaN(bl)) {
      data.bl = bl;
    }

    if (!isNaN(tb)) {
      data.tb = tb;
    }

    if (!isNaN(pr) && pr !== 1) {
      data.pr = pr;
    }

    if (_bufferLevelStarved[request.mediaType]) {
      data.bs = true;
      _bufferLevelStarved[request.mediaType] = false;
    }

    if (_isStartup[request.mediaType] || !_initialMediaRequestsDone[request.mediaType]) {
      data.su = true;
      _isStartup[request.mediaType] = false;
      _initialMediaRequestsDone[request.mediaType] = true;
    }

    return data;
  }

  function _initForMediaType(mediaType) {
    if (!_initialMediaRequestsDone.hasOwnProperty(mediaType)) {
      _initialMediaRequestsDone[mediaType] = false;
    }

    if (!_isStartup.hasOwnProperty(mediaType)) {
      _isStartup[mediaType] = false;
    }

    if (!_bufferLevelStarved.hasOwnProperty(mediaType)) {
      _bufferLevelStarved[mediaType] = false;
    }
  }

  function _getCmcdDataForInitSegment() {
    var data = _getGenericCmcdData();

    data.ot = OBJECT_TYPES.INIT;
    data.su = true;
    return data;
  }

  function _getCmcdDataForOther() {
    var data = _getGenericCmcdData();

    data.ot = OBJECT_TYPES.OTHER;
    return data;
  }

  function _getGenericCmcdData() {
    var data = {};
    var cid = settings.get().streaming.cmcd.cid ? settings.get().streaming.cmcd.cid : internalData.cid;
    data.v = CMCD_VERSION;
    data.sid = settings.get().streaming.cmcd.sid ? settings.get().streaming.cmcd.sid : internalData.sid;
    data.sid = "".concat(data.sid);

    if (cid) {
      data.cid = "".concat(cid);
    }

    if (!isNaN(internalData.pr) && internalData.pr !== 1 && internalData.pr !== null) {
      data.pr = internalData.pr;
    }

    if (internalData.st) {
      data.st = internalData.st;
    }

    if (internalData.sf) {
      data.sf = internalData.sf;
    }

    return data;
  }

  function _getBitrateByRequest(request) {
    try {
      var quality = request.quality;
      var bitrateList = request.mediaInfo.bitrateList;
      return parseInt(bitrateList[quality].bandwidth / 1000);
    } catch (e) {
      return null;
    }
  }

  function _getTopBitrateByType(mediaType) {
    try {
      var info = abrController.getTopBitrateInfoFor(mediaType);
      return Math.round(info.bitrate / 1000);
    } catch (e) {
      return null;
    }
  }

  function _getObjectDurationByRequest(request) {
    try {
      return !isNaN(request.duration) ? Math.round(request.duration * 1000) : null;
    } catch (e) {
      return null;
    }
  }

  function _getMeasuredThroughputByType(mediaType) {
    try {
      return parseInt(abrController.getThroughputHistory().getSafeAverageThroughput(mediaType) / 100) * 100;
    } catch (e) {
      return null;
    }
  }

  function _getDeadlineByType(mediaType) {
    try {
      var playbackRate = internalData.pr;
      var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);

      if (!isNaN(playbackRate) && !isNaN(bufferLevel)) {
        return parseInt(bufferLevel / playbackRate * 10) * 100;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function _getBufferLevelByType(mediaType) {
    try {
      var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);

      if (!isNaN(bufferLevel)) {
        return parseInt(bufferLevel * 10) * 100;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function _onPlaybackRateChanged(data) {
    try {
      internalData.pr = data.playbackRate;
    } catch (e) {}
  }

  function _onManifestLoaded(data) {
    try {
      var isDynamic = dashManifestModel.getIsDynamic(data.data);
      var st = isDynamic ? STREAM_TYPES.LIVE : STREAM_TYPES.VOD;
      var sf = data.protocol && data.protocol === 'MSS' ? STREAMING_FORMATS.MSS : STREAMING_FORMATS.DASH;
      internalData.st = "".concat(st);
      internalData.sf = "".concat(sf);
    } catch (e) {}
  }

  function _onBufferLevelStateChanged(data) {
    try {
      if (data.state && data.mediaType) {
        if (data.state === _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_EMPTY) {
          if (!_bufferLevelStarved[data.mediaType]) {
            _bufferLevelStarved[data.mediaType] = true;
          }

          if (!_isStartup[data.mediaType]) {
            _isStartup[data.mediaType] = true;
          }
        }
      }
    } catch (e) {}
  }

  function _onPlaybackSeeked() {
    for (var key in _bufferLevelStarved) {
      if (_bufferLevelStarved.hasOwnProperty(key)) {
        _bufferLevelStarved[key] = true;
      }
    }

    for (var _key in _isStartup) {
      if (_isStartup.hasOwnProperty(_key)) {
        _isStartup[_key] = true;
      }
    }
  }

  function _buildFinalString(cmcdData) {
    try {
      if (!cmcdData) {
        return null;
      }

      var keys = Object.keys(cmcdData).sort(function (a, b) {
        return a.localeCompare(b);
      });
      var length = keys.length;
      var cmcdString = keys.reduce(function (acc, key, index) {
        if (key === 'v' && cmcdData[key] === 1) return acc; // Version key should only be reported if it is != 1

        if (typeof cmcdData[key] === 'string' && key !== 'ot' && key !== 'sf' && key !== 'st') {
          acc += "".concat(key, "=").concat(JSON.stringify(cmcdData[key]));
        } else {
          acc += "".concat(key, "=").concat(cmcdData[key]);
        }

        if (index < length - 1) {
          acc += ',';
        }

        return acc;
      }, '');
      cmcdString = cmcdString.replace(/=true/g, ''); // Remove last comma at the end

      cmcdString = cmcdString.replace(/,\s*$/, '');
      return cmcdString;
    } catch (e) {
      return null;
    }
  }

  function _probeNextRequest(mediaType) {
    if (!streamProcessors || streamProcessors.length === 0) return;

    var _iterator2 = _createForOfIteratorHelper(streamProcessors),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var streamProcessor = _step2.value;

        if (streamProcessor.getType() === mediaType) {
          return streamProcessor.probeNextRequest();
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  function _calculateRtp(request) {
    // Get the values we need
    var playbackRate = playbackController.getPlaybackRate();
    if (!playbackRate) playbackRate = 1;
    var quality = request.quality,
        mediaType = request.mediaType,
        mediaInfo = request.mediaInfo,
        duration = request.duration;

    var currentBufferLevel = _getBufferLevelByType(mediaType);

    if (currentBufferLevel === 0) currentBufferLevel = 500;
    var bitrate = mediaInfo.bitrateList[quality].bandwidth; // Calculate RTP

    var segmentSize = bitrate * duration / 1000; // Calculate file size in kilobits

    var timeToLoad = currentBufferLevel / playbackRate / 1000; // Calculate time available to load file in seconds

    var minBandwidth = segmentSize / timeToLoad; // Calculate the exact bandwidth required

    var rtpSafetyFactor = settings.get().streaming.cmcd.rtpSafetyFactor && !isNaN(settings.get().streaming.cmcd.rtpSafetyFactor) ? settings.get().streaming.cmcd.rtpSafetyFactor : RTP_SAFETY_FACTOR;
    var maxBandwidth = minBandwidth * rtpSafetyFactor; // Include a safety buffer

    var rtp = (parseInt(maxBandwidth / 100) + 1) * 100; // Round to the next multiple of 100

    return rtp;
  }

  function reset() {
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].PLAYBACK_RATE_CHANGED, _onPlaybackRateChanged, this);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_LOADED, _onManifestLoaded, this);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LEVEL_STATE_CHANGED, _onBufferLevelStateChanged, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_1__["default"].PLAYBACK_SEEKED, _onPlaybackSeeked, instance);

    _resetInitialSettings();
  }

  instance = {
    getQueryParameter: getQueryParameter,
    getHeaderParameters: getHeaderParameters,
    setConfig: setConfig,
    reset: reset,
    initialize: initialize
  };
  setup();
  return instance;
}

CmcdModel.__dashjs_factory_name = 'CmcdModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getSingletonFactory(CmcdModel));

/***/ }),

/***/ "./src/streaming/models/CustomParametersModel.js":
/*!*******************************************************!*\
  !*** ./src/streaming/models/CustomParametersModel.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1838091__) {

"use strict";
__nested_webpack_require_1838091__.r(__webpack_exports__);
/* harmony import */ var _dash_vo_UTCTiming__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1838091__(/*! ../../dash/vo/UTCTiming */ "./src/dash/vo/UTCTiming.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1838091__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1838091__(/*! ../../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1838091__(/*! ../utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/* harmony import */ var _rules_abr_ABRRulesCollection__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1838091__(/*! ../rules/abr/ABRRulesCollection */ "./src/streaming/rules/abr/ABRRulesCollection.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1838091__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






var DEFAULT_XHR_WITH_CREDENTIALS = false;

function CustomParametersModel() {
  var instance, utcTimingSources, xhrWithCredentials, licenseRequestFilters, licenseResponseFilters, customCapabilitiesFilters, customInitialTrackSelectionFunction, customAbrRules;
  var context = this.context;
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();

  function setup() {
    xhrWithCredentials = {
      "default": DEFAULT_XHR_WITH_CREDENTIALS
    };

    _resetInitialSettings();
  }

  function _resetInitialSettings() {
    licenseRequestFilters = [];
    licenseResponseFilters = [];
    customCapabilitiesFilters = [];
    customAbrRules = [];
    customInitialTrackSelectionFunction = null;
    utcTimingSources = [];
  }

  function reset() {
    _resetInitialSettings();
  }

  function setConfig() {}
  /**
   * Registers a custom initial track selection function. Only one function is allowed. Calling this method will overwrite a potentially existing function.
   * @param {function} customFunc - the custom function that returns the initial track
   */


  function setCustomInitialTrackSelectionFunction(customFunc) {
    customInitialTrackSelectionFunction = customFunc;
  }
  /**
   * Resets the custom initial track selection
   */


  function resetCustomInitialTrackSelectionFunction() {
    customInitialTrackSelectionFunction = null;
  }
  /**
   * Returns the initial track selection function
   * @return {function}
   */


  function getCustomInitialTrackSelectionFunction() {
    return customInitialTrackSelectionFunction;
  }
  /**
   * Returns all license request filters
   * @return {array}
   */


  function getLicenseRequestFilters() {
    return licenseRequestFilters;
  }
  /**
   * Returns all license response filters
   * @return {array}
   */


  function getLicenseResponseFilters() {
    return licenseResponseFilters;
  }
  /**
   * Registers a license request filter. This enables application to manipulate/overwrite any request parameter and/or request data.
   * The provided callback function shall return a promise that shall be resolved once the filter process is completed.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the license request filter callback
   */


  function registerLicenseRequestFilter(filter) {
    licenseRequestFilters.push(filter);
  }
  /**
   * Registers a license response filter. This enables application to manipulate/overwrite the response data
   * The provided callback function shall return a promise that shall be resolved once the filter process is completed.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the license response filter callback
   */


  function registerLicenseResponseFilter(filter) {
    licenseResponseFilters.push(filter);
  }
  /**
   * Unregisters a license request filter.
   * @param {function} filter - the license request filter callback
   */


  function unregisterLicenseRequestFilter(filter) {
    _unregisterFilter(licenseRequestFilters, filter);
  }
  /**
   * Unregisters a license response filter.
   * @param {function} filter - the license response filter callback
   */


  function unregisterLicenseResponseFilter(filter) {
    _unregisterFilter(licenseResponseFilters, filter);
  }
  /**
   * Returns all custom capabilities filter
   * @return {array}
   */


  function getCustomCapabilitiesFilters() {
    return customCapabilitiesFilters;
  }
  /**
   * Registers a custom capabilities filter. This enables application to filter representations to use.
   * The provided callback function shall return a boolean based on whether or not to use the representation.
   * The filters are applied in the order they are registered.
   * @param {function} filter - the custom capabilities filter callback
   */


  function registerCustomCapabilitiesFilter(filter) {
    customCapabilitiesFilters.push(filter);
  }
  /**
   * Unregisters a custom capabilities filter.
   * @param {function} filter - the custom capabilities filter callback
   */


  function unregisterCustomCapabilitiesFilter(filter) {
    _unregisterFilter(customCapabilitiesFilters, filter);
  }
  /**
   * Unregister a filter from the list of existing filers.
   * @param {array} filters
   * @param {function} filter
   * @private
   */


  function _unregisterFilter(filters, filter) {
    var index = -1;
    filters.some(function (item, i) {
      if (item === filter) {
        index = i;
        return true;
      }
    });
    if (index < 0) return;
    filters.splice(index, 1);
  }
  /**
   * Iterate through the list of custom ABR rules and find the right rule by name
   * @param {string} rulename
   * @return {number} rule number
   */


  function _findAbrCustomRuleIndex(rulename) {
    var i;

    for (i = 0; i < customAbrRules.length; i++) {
      if (customAbrRules[i].rulename === rulename) {
        return i;
      }
    }

    return -1;
  }
  /**
   * Add a custom ABR Rule
   * Rule will be apply on next stream if a stream is being played
   *
   * @param {string} type - rule type (one of ['qualitySwitchRules','abandonFragmentRules'])
   * @param {string} rulename - name of rule (used to identify custom rule). If one rule of same name has been added, then existing rule will be updated
   * @param {object} rule - the rule object instance
   * @throws {@link Constants#BAD_ARGUMENT_ERROR BAD_ARGUMENT_ERROR} if called with invalid arguments.
   */


  function addAbrCustomRule(type, rulename, rule) {
    if (typeof type !== 'string' || type !== _rules_abr_ABRRulesCollection__WEBPACK_IMPORTED_MODULE_4__["default"].ABANDON_FRAGMENT_RULES && type !== _rules_abr_ABRRulesCollection__WEBPACK_IMPORTED_MODULE_4__["default"].QUALITY_SWITCH_RULES || typeof rulename !== 'string') {
      throw _constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].BAD_ARGUMENT_ERROR;
    }

    var index = _findAbrCustomRuleIndex(rulename);

    if (index === -1) {
      // add rule
      customAbrRules.push({
        type: type,
        rulename: rulename,
        rule: rule
      });
    } else {
      // update rule
      customAbrRules[index].type = type;
      customAbrRules[index].rule = rule;
    }
  }
  /**
   * Remove a custom ABR Rule
   *
   * @param {string} rulename - name of the rule to be removed
   */


  function removeAbrCustomRule(rulename) {
    if (rulename) {
      var index = _findAbrCustomRuleIndex(rulename); //if no rulename custom rule has been found, do nothing


      if (index !== -1) {
        // remove rule
        customAbrRules.splice(index, 1);
      }
    } else {
      //if no rulename is defined, remove all ABR custome rules
      customAbrRules = [];
    }
  }
  /**
   * Remove all custom rules
   */


  function removeAllAbrCustomRule() {
    customAbrRules = [];
  }
  /**
   * Return all ABR custom rules
   * @return {array}
   */


  function getAbrCustomRules() {
    return customAbrRules;
  }
  /**
   * Add a UTC timing source at the top of the list
   * @param {string} schemeIdUri
   * @param {string} value
   */


  function addUTCTimingSource(schemeIdUri, value) {
    removeUTCTimingSource(schemeIdUri, value); //check if it already exists and remove if so.

    var vo = new _dash_vo_UTCTiming__WEBPACK_IMPORTED_MODULE_0__["default"]();
    vo.schemeIdUri = schemeIdUri;
    vo.value = value;
    utcTimingSources.push(vo);
  }
  /**
   * Return all UTC timing sources
   * @return {array}
   */


  function getUTCTimingSources() {
    return utcTimingSources;
  }
  /**
   * Remove a specific timing source from the array
   * @param {string} schemeIdUri
   * @param {string} value
   */


  function removeUTCTimingSource(schemeIdUri, value) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_3__["checkParameterType"])(schemeIdUri, 'string');
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_3__["checkParameterType"])(value, 'string');
    utcTimingSources.forEach(function (obj, idx) {
      if (obj.schemeIdUri === schemeIdUri && obj.value === value) {
        utcTimingSources.splice(idx, 1);
      }
    });
  }
  /**
   * Remove all timing sources
   */


  function clearDefaultUTCTimingSources() {
    utcTimingSources = [];
  }
  /**
   * Add the default timing source to the list
   */


  function restoreDefaultUTCTimingSources() {
    var defaultUtcTimingSource = settings.get().streaming.utcSynchronization.defaultTimingSource;
    addUTCTimingSource(defaultUtcTimingSource.scheme, defaultUtcTimingSource.value);
  }

  function setXHRWithCredentialsForType(type, value) {
    if (!type) {
      Object.keys(xhrWithCredentials).forEach(function (key) {
        setXHRWithCredentialsForType(key, value);
      });
    } else {
      xhrWithCredentials[type] = !!value;
    }
  }

  function getXHRWithCredentialsForType(type) {
    var useCreds = xhrWithCredentials[type];
    return useCreds === undefined ? xhrWithCredentials["default"] : useCreds;
  }

  instance = {
    getCustomInitialTrackSelectionFunction: getCustomInitialTrackSelectionFunction,
    setCustomInitialTrackSelectionFunction: setCustomInitialTrackSelectionFunction,
    resetCustomInitialTrackSelectionFunction: resetCustomInitialTrackSelectionFunction,
    getLicenseResponseFilters: getLicenseResponseFilters,
    getLicenseRequestFilters: getLicenseRequestFilters,
    getCustomCapabilitiesFilters: getCustomCapabilitiesFilters,
    registerCustomCapabilitiesFilter: registerCustomCapabilitiesFilter,
    registerLicenseResponseFilter: registerLicenseResponseFilter,
    registerLicenseRequestFilter: registerLicenseRequestFilter,
    unregisterCustomCapabilitiesFilter: unregisterCustomCapabilitiesFilter,
    unregisterLicenseResponseFilter: unregisterLicenseResponseFilter,
    unregisterLicenseRequestFilter: unregisterLicenseRequestFilter,
    addAbrCustomRule: addAbrCustomRule,
    removeAllAbrCustomRule: removeAllAbrCustomRule,
    removeAbrCustomRule: removeAbrCustomRule,
    getAbrCustomRules: getAbrCustomRules,
    addUTCTimingSource: addUTCTimingSource,
    removeUTCTimingSource: removeUTCTimingSource,
    getUTCTimingSources: getUTCTimingSources,
    clearDefaultUTCTimingSources: clearDefaultUTCTimingSources,
    restoreDefaultUTCTimingSources: restoreDefaultUTCTimingSources,
    setXHRWithCredentialsForType: setXHRWithCredentialsForType,
    getXHRWithCredentialsForType: getXHRWithCredentialsForType,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

CustomParametersModel.__dashjs_factory_name = 'CustomParametersModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getSingletonFactory(CustomParametersModel));

/***/ }),

/***/ "./src/streaming/models/FragmentModel.js":
/*!***********************************************!*\
  !*** ./src/streaming/models/FragmentModel.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1852496__) {

"use strict";
__nested_webpack_require_1852496__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1852496__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1852496__(/*! ../vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var FRAGMENT_MODEL_LOADING = 'loading';
var FRAGMENT_MODEL_EXECUTED = 'executed';
var FRAGMENT_MODEL_CANCELED = 'canceled';
var FRAGMENT_MODEL_FAILED = 'failed';

function FragmentModel(config) {
  config = config || {};
  var eventBus = config.eventBus;
  var events = config.events;
  var dashMetrics = config.dashMetrics;
  var fragmentLoader = config.fragmentLoader;
  var debug = config.debug;
  var streamInfo = config.streamInfo;
  var type = config.type;
  var instance, logger, executedRequests, loadingRequests;

  function setup() {
    logger = debug.getLogger(instance);
    resetInitialSettings();
    eventBus.on(events.LOADING_COMPLETED, onLoadingCompleted, instance);
    eventBus.on(events.LOADING_DATA_PROGRESS, onLoadingInProgress, instance);
    eventBus.on(events.LOADING_ABANDONED, onLoadingAborted, instance);
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getType() {
    return type;
  }

  function isFragmentLoaded(request) {
    var isEqualComplete = function isEqualComplete(req1, req2) {
      return req1.action === _vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__["default"].ACTION_COMPLETE && req1.action === req2.action;
    };

    var isEqualMedia = function isEqualMedia(req1, req2) {
      return !isNaN(req1.index) && req1.startTime === req2.startTime && req1.adaptationIndex === req2.adaptationIndex && req1.type === req2.type;
    };

    var isEqualInit = function isEqualInit(req1, req2) {
      return isNaN(req1.index) && isNaN(req2.index) && req1.quality === req2.quality;
    };

    var check = function check(requests) {
      var isLoaded = false;
      requests.some(function (req) {
        if (isEqualMedia(request, req) || isEqualInit(request, req) || isEqualComplete(request, req)) {
          isLoaded = true;
          return isLoaded;
        }
      });
      return isLoaded;
    };

    if (!request) {
      return false;
    }

    return check(executedRequests);
  }

  function isFragmentLoadedOrPending(request) {
    var isLoaded = false;
    var i = 0;
    var req; // First, check if the fragment has already been loaded

    isLoaded = isFragmentLoaded(request); // Then, check if the fragment is about to be loeaded

    if (!isLoaded) {
      for (i = 0; i < loadingRequests.length; i++) {
        req = loadingRequests[i];

        if (request.url === req.url && request.startTime === req.startTime) {
          isLoaded = true;
        }
      }
    }

    return isLoaded;
  }
  /**
   *
   * Gets an array of {@link FragmentRequest} objects
   *
   * @param {Object} filter The object with properties by which the method filters the requests to be returned.
   *  the only mandatory property is state, which must be a value from
   *  other properties should match the properties of {@link FragmentRequest}. E.g.:
   *  getRequests({state: FragmentModel.FRAGMENT_MODEL_EXECUTED, quality: 0}) - returns
   *  all the requests from executedRequests array where requests.quality = filter.quality
   *
   * @returns {Array}
   * @memberof FragmentModel#
   */


  function getRequests(filter) {
    var states = filter ? filter.state instanceof Array ? filter.state : [filter.state] : [];
    var filteredRequests = [];
    states.forEach(function (state) {
      var requests = getRequestsForState(state);
      filteredRequests = filteredRequests.concat(filterRequests(requests, filter));
    });
    return filteredRequests;
  }

  function getRequestThreshold(req) {
    return isNaN(req.duration) ? 0.25 : Math.min(req.duration / 8, 0.5);
  }

  function removeExecutedRequestsBeforeTime(time) {
    executedRequests = executedRequests.filter(function (req) {
      var threshold = getRequestThreshold(req);
      return isNaN(req.startTime) || (time !== undefined ? req.startTime >= time - threshold : false);
    });
  }

  function removeExecutedRequestsAfterTime(time) {
    executedRequests = executedRequests.filter(function (req) {
      return isNaN(req.startTime) || (time !== undefined ? req.startTime < time : false);
    });
  }

  function removeExecutedRequestsInTimeRange(start, end) {
    if (end <= start + 0.5) {
      return;
    }

    executedRequests = executedRequests.filter(function (req) {
      var threshold = getRequestThreshold(req);
      return isNaN(req.startTime) || req.startTime >= end - threshold || isNaN(req.duration) || req.startTime + req.duration <= start + threshold;
    });
  } // Remove requests that are not "represented" by any of buffered ranges


  function syncExecutedRequestsWithBufferedRange(bufferedRanges, streamDuration) {
    if (!bufferedRanges || bufferedRanges.length === 0) {
      removeExecutedRequestsBeforeTime();
      return;
    }

    var start = 0;

    for (var i = 0, ln = bufferedRanges.length; i < ln; i++) {
      removeExecutedRequestsInTimeRange(start, bufferedRanges.start(i));
      start = bufferedRanges.end(i);
    }

    if (streamDuration > 0) {
      removeExecutedRequestsInTimeRange(start, streamDuration);
    }
  }

  function abortRequests() {
    logger.debug('abort requests');
    fragmentLoader.abort();
    loadingRequests = [];
  }

  function executeRequest(request) {
    switch (request.action) {
      case _vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__["default"].ACTION_DOWNLOAD:
        addSchedulingInfoMetrics(request, FRAGMENT_MODEL_LOADING);
        loadingRequests.push(request);
        loadCurrentFragment(request);
        break;

      default:
        logger.warn('Unknown request action.');
    }
  }

  function loadCurrentFragment(request) {
    eventBus.trigger(events.FRAGMENT_LOADING_STARTED, {
      request: request
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
    fragmentLoader.load(request);
  }

  function getRequestForTime(arr, time, threshold) {
    // loop through the executed requests and pick the one for which the playback interval matches the given time
    var lastIdx = arr.length - 1;

    for (var i = lastIdx; i >= 0; i--) {
      var req = arr[i];
      var start = req.startTime;
      var end = start + req.duration;
      threshold = !isNaN(threshold) ? threshold : getRequestThreshold(req);

      if (!isNaN(start) && !isNaN(end) && time + threshold >= start && time - threshold < end || isNaN(start) && isNaN(time)) {
        return req;
      }
    }

    return null;
  }

  function filterRequests(arr, filter) {
    // for time use a specific filtration function
    if (filter.hasOwnProperty('time')) {
      return [getRequestForTime(arr, filter.time, filter.threshold)];
    }

    return arr.filter(function (request) {
      for (var prop in filter) {
        if (prop === 'state') continue;
        if (filter.hasOwnProperty(prop) && request[prop] != filter[prop]) return false;
      }

      return true;
    });
  }

  function getRequestsForState(state) {
    var requests;

    switch (state) {
      case FRAGMENT_MODEL_LOADING:
        requests = loadingRequests;
        break;

      case FRAGMENT_MODEL_EXECUTED:
        requests = executedRequests;
        break;

      default:
        requests = [];
    }

    return requests;
  }

  function addSchedulingInfoMetrics(request, state) {
    dashMetrics.addSchedulingInfo(request, state);
    dashMetrics.addRequestsQueue(request.mediaType, loadingRequests, executedRequests);
  }

  function onLoadingCompleted(e) {
    if (e.sender !== fragmentLoader) return;
    loadingRequests.splice(loadingRequests.indexOf(e.request), 1);

    if (e.response && !e.error) {
      executedRequests.push(e.request);
    }

    addSchedulingInfoMetrics(e.request, e.error ? FRAGMENT_MODEL_FAILED : FRAGMENT_MODEL_EXECUTED);
    eventBus.trigger(events.FRAGMENT_LOADING_COMPLETED, {
      request: e.request,
      response: e.response,
      error: e.error,
      sender: this
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function onLoadingInProgress(e) {
    if (e.sender !== fragmentLoader) return;
    eventBus.trigger(events.FRAGMENT_LOADING_PROGRESS, {
      request: e.request,
      response: e.response,
      error: e.error,
      sender: this
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function onLoadingAborted(e) {
    if (e.sender !== fragmentLoader) return;
    eventBus.trigger(events.FRAGMENT_LOADING_ABANDONED, {
      request: e.request
    }, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  function resetInitialSettings() {
    executedRequests = [];
    loadingRequests = [];
  }

  function reset() {
    eventBus.off(events.LOADING_COMPLETED, onLoadingCompleted, this);
    eventBus.off(events.LOADING_DATA_PROGRESS, onLoadingInProgress, this);
    eventBus.off(events.LOADING_ABANDONED, onLoadingAborted, this);

    if (fragmentLoader) {
      fragmentLoader.reset();
    }

    resetInitialSettings();
  }

  function addExecutedRequest(request) {
    executedRequests.push(request);
  }

  instance = {
    getStreamId: getStreamId,
    getType: getType,
    getRequests: getRequests,
    isFragmentLoaded: isFragmentLoaded,
    isFragmentLoadedOrPending: isFragmentLoadedOrPending,
    removeExecutedRequestsBeforeTime: removeExecutedRequestsBeforeTime,
    removeExecutedRequestsAfterTime: removeExecutedRequestsAfterTime,
    syncExecutedRequestsWithBufferedRange: syncExecutedRequestsWithBufferedRange,
    abortRequests: abortRequests,
    executeRequest: executeRequest,
    reset: reset,
    resetInitialSettings: resetInitialSettings,
    addExecutedRequest: addExecutedRequest
  };
  setup();
  return instance;
}

FragmentModel.__dashjs_factory_name = 'FragmentModel';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(FragmentModel);
factory.FRAGMENT_MODEL_LOADING = FRAGMENT_MODEL_LOADING;
factory.FRAGMENT_MODEL_EXECUTED = FRAGMENT_MODEL_EXECUTED;
factory.FRAGMENT_MODEL_CANCELED = FRAGMENT_MODEL_CANCELED;
factory.FRAGMENT_MODEL_FAILED = FRAGMENT_MODEL_FAILED;
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].updateClassFactory(FragmentModel.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/models/LowLatencyThroughputModel.js":
/*!***********************************************************!*\
  !*** ./src/streaming/models/LowLatencyThroughputModel.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1865627__) {

"use strict";
__nested_webpack_require_1865627__.r(__webpack_exports__);
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1865627__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1865627__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function LowLatencyThroughputModel() {
  var LLTM_MAX_MEASUREMENTS = 10; // factor (<1) is used to reduce the real needed download time when at very bleeding live edge

  var LLTM_SEMI_OPTIMISTIC_ESTIMATE_FACTOR = 0.8;
  var LLTM_OPTIMISTIC_ESTIMATE_FACTOR = 0.6;
  var LLTM_SLOW_SEGMENT_DOWNLOAD_TOLERANCE = 1.05;
  var LLTM_MAX_DELAY_MS = 250;
  var context = this.context;
  var instance;
  var logger;
  var measurements = {};

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance().getLogger(instance);
  }
  /**
   * Linear regression with least squares method to get a trend function for buffer lavel at chunk receive timestamps
   * @param {*} chunkMeasurements
   * @returns linear trend function
   */


  function createBufferLevelTrendFunction(chunkMeasurements) {
    var result = {};
    var sumX = 0;
    var sumY = 0;
    var sumXY = 0;
    var sumXSq = 0;
    var N = chunkMeasurements.length;

    for (var i = 0; i < N; ++i) {
      sumX += chunkMeasurements[i].chunkDownloadTimeRelativeMS;
      sumY += chunkMeasurements[i].bufferLevel;
      sumXY += chunkMeasurements[i].chunkDownloadTimeRelativeMS * chunkMeasurements[i].bufferLevel;
      sumXSq += chunkMeasurements[i].chunkDownloadTimeRelativeMS * chunkMeasurements[i].chunkDownloadTimeRelativeMS;
    }

    result.m = (sumXY - sumX * sumY / N) / (sumXSq - sumX * sumX / N);
    result.b = sumY / N - result.m * sumX / N;
    return function (x) {
      return result.m * x + result.b;
    };
  }

  function isBufferSafeAndStable(lastMeasurements) {
    var isBufferSafeAndStable = true;
    var lastBitrate;
    var aveBufferLevelLastSegements = lastMeasurements.reduce(function (prev, curr) {
      return prev + curr.bufferLevelAtSegmentEnd;
    }, 0) / lastMeasurements.length;
    lastMeasurements.forEach(function (m) {
      // inner segment buffer stability
      if (Math.abs(m.bufferLevelAtSegmentEnd / m.bufferLevelAtSegmentStart) < 0.95) {
        isBufferSafeAndStable = false;
      } // inter segment buffer stability


      if (m.bufferLevelAtSegmentEnd / aveBufferLevelLastSegements < 0.8) {
        isBufferSafeAndStable = false;
      } // representation bitrate remained at least constant


      if (!lastBitrate) {
        lastBitrate = m.bitrate;
      } else if (lastBitrate > m.bitrate) {
        isBufferSafeAndStable = false;
      }
    });
    return isBufferSafeAndStable;
  }
  /**
   * Based on the MPD, timing and buffer information of the last recent segments and their chunks
   * the most stable download time (in milliseconds) is calculated.
   * @param {*} request HTTPLoader request object
   * @returns download time in milliseconds of last fetched segment
   */


  function getEstimatedDownloadDurationMS(request) {
    var lastMeasurement = measurements[request.mediaType].slice(-1).pop();
    var lastThreeMeasurements = measurements[request.mediaType].slice(-3); // calculate and remember the buffer level trend during the last fetched segment

    var lastChunkRelativeTimeMS = lastMeasurement.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;
    lastMeasurement.bufferLevelAtSegmentStart = lastMeasurement.getEstimatedBufferLevel(lastChunkRelativeTimeMS / 2);
    lastMeasurement.bufferLevelAtSegmentEnd = lastMeasurement.getEstimatedBufferLevel(lastChunkRelativeTimeMS);
    var isBufferStable = isBufferSafeAndStable(lastThreeMeasurements);
    var selectedOptimisticFactor = isBufferStable ? LLTM_OPTIMISTIC_ESTIMATE_FACTOR : LLTM_SEMI_OPTIMISTIC_ESTIMATE_FACTOR; // fetch duration was longer than segment duration, but buffer was stable

    if (lastMeasurement.isBufferStable && lastMeasurement.segDurationMS * LLTM_SLOW_SEGMENT_DOWNLOAD_TOLERANCE < lastMeasurement.fetchDownloadDurationMS) {
      return lastMeasurement.fetchDownloadDurationMS;
    } // buffer is drying or fetch took too long


    if (!isBufferStable || lastMeasurement.segDurationMS < lastMeasurement.fetchDownloadDurationMS) {
      return lastMeasurement.fetchDownloadDurationMS * LLTM_SEMI_OPTIMISTIC_ESTIMATE_FACTOR;
    } // did we requested a fully available segment? -> most accurate throughput calculation
    // we use adjusted availability start time to decide
    // Note: this "download mode" usually happens at startup and if requests are delayed artificially


    if (lastMeasurement.adjustedAvailabilityStartTimeMS <= lastMeasurement.requestTimeMS + lastMeasurement.throughputCapacityDelayMS - lastMeasurement.segDurationMS) {
      return lastMeasurement.fetchDownloadDurationMS * LLTM_SEMI_OPTIMISTIC_ESTIMATE_FACTOR;
    } // get all chunks that have been downloaded before fetch reached bleeding live edge
    // the remaining chunks loaded at production rate we will approximated


    var chunkAvailablePeriod = lastMeasurement.requestTimeMS + lastMeasurement.throughputCapacityDelayMS - lastMeasurement.adjustedAvailabilityStartTimeMS;
    var chunkBytesBBLE = 0; // BBLE -> Before bleeding live edge

    var chunkDownloadtimeMSBBLE = 0;
    var chunkCount = 0;

    for (var index = 0; index < lastMeasurement.chunkMeasurements.length; index++) {
      var chunk = lastMeasurement.chunkMeasurements[index];

      if (chunkAvailablePeriod < chunkDownloadtimeMSBBLE + chunk.chunkDownloadDurationMS) {
        break;
      }

      chunkDownloadtimeMSBBLE += chunk.chunkDownloadDurationMS;
      chunkBytesBBLE += chunk.chunkBytes;
      chunkCount++;
    }

    if (chunkAvailablePeriod < 0) {
      logger.warn('request time was before adjusted availibitly start time');
    } // there have to be some chunks available (20% of max count)
    // otherwise we are at bleeding live edge and the few chunks are insufficient to estimate correctly


    if (chunkBytesBBLE && chunkDownloadtimeMSBBLE && chunkCount > lastMeasurement.chunkMeasurements.length * 0.2) {
      var downloadThroughput = chunkBytesBBLE / chunkDownloadtimeMSBBLE; // bytes per millesecond

      var estimatedDownloadtimeMS = lastMeasurement.segmentBytes / downloadThroughput; // if real download was shorter then report this incl. semi optimistical estimate factor

      if (lastMeasurement.fetchDownloadDurationMS < estimatedDownloadtimeMS) {
        return lastMeasurement.fetchDownloadDurationMS * selectedOptimisticFactor;
      }

      return estimatedDownloadtimeMS * selectedOptimisticFactor;
    } // when we are to tight at live edge and it's stable then
    // we start to optimistically estimate download time
    // in such a way that a switch to next rep will be possible
    // optimistical estimate: assume download was fast enough for next higher rendition


    var nextHigherBitrate = lastMeasurement.bitrate;
    lastMeasurement.bitrateList.some(function (b) {
      if (b.bandwidth > lastMeasurement.bitrate) {
        nextHigherBitrate = b.bandwidth;
        return true;
      }
    }); // already highest bitrate?

    if (nextHigherBitrate === lastMeasurement.bitrate) {
      return lastMeasurement.fetchDownloadDurationMS * selectedOptimisticFactor;
    }

    return selectedOptimisticFactor * lastMeasurement.segmentBytes * 8 * 1000 / nextHigherBitrate;
  }
  /**
   * Get calculated value for a safe artificial delay of the next request to allow to accumulate some chunks.
   * This allows better line throughput measurement.
   * @param {*} request
   * @param {*} currentBufferLevel current buffer level in milliseconds
   * @returns delay in milliseconds
   */


  function getThroughputCapacityDelayMS(request, currentBufferLevelMS) {
    var lastThreeMeasurements = measurements[request.mediaType] && measurements[request.mediaType].slice(-3);

    if (!lastThreeMeasurements || lastThreeMeasurements.length < 3) {
      return 0;
    } // in case not stable buffer, no artificially delay for the next request


    if (!isBufferSafeAndStable(lastThreeMeasurements)) {
      return 0;
    } // allowed artificial delay is the min of quater of buffer level in milliseconds and LLTM_MAX_DELAY_MS


    return currentBufferLevelMS / 4 > LLTM_MAX_DELAY_MS ? LLTM_MAX_DELAY_MS : currentBufferLevelMS / 4;
  }
  /**
   * Add some measurement data for bookkeeping and being able to derive decisions on estimated throughput.
   * @param {*} request HTTPLoader object to get MPD and media info from
   * @param {*} fetchDownloadDurationMS Duration how long the fetch actually took
   * @param {*} chunkMeasurements Array containing chunk timings and buffer levels
   * @param {*} requestTimeMS Timestamp at which the fetch was initiated
   * @param {*} throughputCapacityDelayMS An artificial delay that was used for this request
   */


  function addMeasurement(request, fetchDownloadDurationMS, chunkMeasurements, requestTimeMS, throughputCapacityDelayMS) {
    if (request && request.mediaType && !measurements[request.mediaType]) {
      measurements[request.mediaType] = [];
    }

    var bitrateEntry = request.mediaInfo.bitrateList.find(function (item) {
      return item.id === request.representationId;
    });
    measurements[request.mediaType].push({
      index: request.index,
      repId: request.representationId,
      mediaType: request.mediaType,
      requestTimeMS: requestTimeMS,
      adjustedAvailabilityStartTimeMS: request.availabilityStartTime.getTime(),
      segDurationMS: request.duration * 1000,
      chunksDurationMS: chunkMeasurements.reduce(function (prev, curr) {
        return prev + curr.chunkDownloadDurationMS;
      }, 0),
      segmentBytes: chunkMeasurements.reduce(function (prev, curr) {
        return prev + curr.chunkBytes;
      }, 0),
      bitrate: bitrateEntry && bitrateEntry.bandwidth,
      bitrateList: request.mediaInfo.bitrateList,
      chunkMeasurements: chunkMeasurements,
      fetchDownloadDurationMS: fetchDownloadDurationMS,
      throughputCapacityDelayMS: throughputCapacityDelayMS,
      getEstimatedBufferLevel: createBufferLevelTrendFunction(chunkMeasurements.slice(1)) // don't use first chunk's buffer level

    }); // maintain only a maximum amount of most recent measurements

    if (measurements[request.mediaType].length > LLTM_MAX_MEASUREMENTS) {
      measurements[request.mediaType].shift();
    }
  }

  instance = {
    setup: setup,
    addMeasurement: addMeasurement,
    getThroughputCapacityDelayMS: getThroughputCapacityDelayMS,
    getEstimatedDownloadDurationMS: getEstimatedDownloadDurationMS
  };
  setup();
  return instance;
}

LowLatencyThroughputModel.__dashjs_factory_name = 'LowLatencyThroughputModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getSingletonFactory(LowLatencyThroughputModel));

/***/ }),

/***/ "./src/streaming/models/ManifestModel.js":
/*!***********************************************!*\
  !*** ./src/streaming/models/ManifestModel.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1879103__) {

"use strict";
__nested_webpack_require_1879103__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1879103__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1879103__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1879103__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function ManifestModel() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var instance, manifest;

  function getValue() {
    return manifest;
  }

  function setValue(value) {
    manifest = value;

    if (value) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_LOADED, {
        data: value
      });
    }
  }

  instance = {
    getValue: getValue,
    setValue: setValue
  };
  return instance;
}

ManifestModel.__dashjs_factory_name = 'ManifestModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(ManifestModel));

/***/ }),

/***/ "./src/streaming/models/MediaPlayerModel.js":
/*!**************************************************!*\
  !*** ./src/streaming/models/MediaPlayerModel.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1882624__) {

"use strict";
__nested_webpack_require_1882624__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1882624__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1882624__(/*! ../../core/Settings */ "./src/core/Settings.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var DEFAULT_MIN_BUFFER_TIME = 12;
var DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH = 20;
var LOW_LATENCY_REDUCTION_FACTOR = 10;
var LOW_LATENCY_MULTIPLY_FACTOR = 5;
var DEFAULT_CATCHUP_MAX_DRIFT = 12;
var DEFAULT_CATCHUP_PLAYBACK_RATE = 0.5;
/**
 * We use this model as a wrapper/proxy between Settings.js and classes that are using parameters from Settings.js.
 * In some cases we require additional logic to be applied and the settings might need to be adjusted before being used.
 * @class
 * @constructor
 */

function MediaPlayerModel() {
  var instance, playbackController, serviceDescriptionController;
  var context = this.context;
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();

  function setup() {}

  function setConfig(config) {
    if (config.playbackController) {
      playbackController = config.playbackController;
    }

    if (config.serviceDescriptionController) {
      serviceDescriptionController = config.serviceDescriptionController;
    }
  }
  /**
   * Returns the maximum drift allowed before applying a seek back to the live edge when the catchup mode is enabled
   * @return {number}
   */


  function getCatchupMaxDrift() {
    if (!isNaN(settings.get().streaming.liveCatchup.maxDrift) && settings.get().streaming.liveCatchup.maxDrift > 0) {
      return settings.get().streaming.liveCatchup.maxDrift;
    }

    var serviceDescriptionSettings = serviceDescriptionController.getServiceDescriptionSettings();

    if (serviceDescriptionSettings && serviceDescriptionSettings.liveCatchup && !isNaN(serviceDescriptionSettings.liveCatchup.maxDrift) && serviceDescriptionSettings.liveCatchup.maxDrift > 0) {
      return serviceDescriptionSettings.liveCatchup.maxDrift;
    }

    return DEFAULT_CATCHUP_MAX_DRIFT;
  }
  /**
   * Returns the maximum playback rate to be used when applying the catchup mechanism
   * @return {number}
   */


  function getCatchupPlaybackRate() {
    if (!isNaN(settings.get().streaming.liveCatchup.playbackRate) && settings.get().streaming.liveCatchup.playbackRate > 0) {
      return settings.get().streaming.liveCatchup.playbackRate;
    }

    var serviceDescriptionSettings = serviceDescriptionController.getServiceDescriptionSettings();

    if (serviceDescriptionSettings && serviceDescriptionSettings.liveCatchup && !isNaN(serviceDescriptionSettings.liveCatchup.playbackRate) && serviceDescriptionSettings.liveCatchup.playbackRate > 0) {
      return serviceDescriptionSettings.liveCatchup.playbackRate;
    }

    return DEFAULT_CATCHUP_PLAYBACK_RATE;
  }
  /**
   * Returns whether the catchup mode is activated via the settings or internally in the PlaybackController
   * @return {boolean}
   */


  function getCatchupModeEnabled() {
    if (settings.get().streaming.liveCatchup.enabled !== null) {
      return settings.get().streaming.liveCatchup.enabled;
    }

    return playbackController.getInitialCatchupModeActivated();
  }
  /**
   * Returns the threshold for which to apply the catchup logic
   * @return {number}
   */


  function getLiveCatchupLatencyThreshold() {
    try {
      var liveCatchupLatencyThreshold = settings.get().streaming.liveCatchup.latencyThreshold;
      var liveDelay = playbackController.getLiveDelay();

      if (liveCatchupLatencyThreshold !== null && !isNaN(liveCatchupLatencyThreshold)) {
        return Math.max(liveCatchupLatencyThreshold, liveDelay);
      }

      return NaN;
    } catch (e) {
      return NaN;
    }
  }
  /**
   * Returns the min,max or initial bitrate for a specific media type.
   * @param {string} field
   * @param {string} mediaType
   */


  function getAbrBitrateParameter(field, mediaType) {
    try {
      var setting = settings.get().streaming.abr[field][mediaType];

      if (!isNaN(setting) && setting !== -1) {
        return setting;
      }

      var serviceDescriptionSettings = serviceDescriptionController.getServiceDescriptionSettings();

      if (serviceDescriptionSettings && serviceDescriptionSettings[field] && !isNaN(serviceDescriptionSettings[field][mediaType])) {
        return serviceDescriptionSettings[field][mediaType];
      }

      return -1;
    } catch (e) {
      return -1;
    }
  }
  /**
   * Returns the initial buffer level taking the stable buffer time into account
   * @return {number}
   */


  function getInitialBufferLevel() {
    var initialBufferLevel = settings.get().streaming.buffer.initialBufferLevel;

    if (isNaN(initialBufferLevel) || initialBufferLevel < 0) {
      return 0;
    }

    return Math.min(getStableBufferTime(), initialBufferLevel);
  }
  /**
   * Returns the stable buffer time taking the live delay into account
   * @return {number}
   */


  function getStableBufferTime() {
    var stableBufferTime = settings.get().streaming.buffer.stableBufferTime > 0 ? settings.get().streaming.buffer.stableBufferTime : settings.get().streaming.buffer.fastSwitchEnabled ? DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH : DEFAULT_MIN_BUFFER_TIME;
    var liveDelay = playbackController.getLiveDelay();
    return !isNaN(liveDelay) && liveDelay > 0 ? Math.min(stableBufferTime, liveDelay) : stableBufferTime;
  }
  /**
   * Returns the number of retry attempts for a specific media type
   * @param type
   * @return {number}
   */


  function getRetryAttemptsForType(type) {
    var lowLatencyMultiplyFactor = !isNaN(settings.get().streaming.retryAttempts.lowLatencyMultiplyFactor) ? settings.get().streaming.retryAttempts.lowLatencyMultiplyFactor : LOW_LATENCY_MULTIPLY_FACTOR;
    return playbackController.getLowLatencyModeEnabled() ? settings.get().streaming.retryAttempts[type] * lowLatencyMultiplyFactor : settings.get().streaming.retryAttempts[type];
  }
  /**
   * Returns the retry interbal for a specific media type
   * @param type
   * @return {number}
   */


  function getRetryIntervalsForType(type) {
    var lowLatencyReductionFactor = !isNaN(settings.get().streaming.retryIntervals.lowLatencyReductionFactor) ? settings.get().streaming.retryIntervals.lowLatencyReductionFactor : LOW_LATENCY_REDUCTION_FACTOR;
    return playbackController.getLowLatencyModeEnabled() ? settings.get().streaming.retryIntervals[type] / lowLatencyReductionFactor : settings.get().streaming.retryIntervals[type];
  }

  function reset() {}

  instance = {
    getCatchupMaxDrift: getCatchupMaxDrift,
    getCatchupModeEnabled: getCatchupModeEnabled,
    getLiveCatchupLatencyThreshold: getLiveCatchupLatencyThreshold,
    getStableBufferTime: getStableBufferTime,
    getInitialBufferLevel: getInitialBufferLevel,
    getRetryAttemptsForType: getRetryAttemptsForType,
    getRetryIntervalsForType: getRetryIntervalsForType,
    getCatchupPlaybackRate: getCatchupPlaybackRate,
    getAbrBitrateParameter: getAbrBitrateParameter,
    setConfig: setConfig,
    reset: reset
  };
  setup();
  return instance;
}

MediaPlayerModel.__dashjs_factory_name = 'MediaPlayerModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(MediaPlayerModel));

/***/ }),

/***/ "./src/streaming/models/MetricsModel.js":
/*!**********************************************!*\
  !*** ./src/streaming/models/MetricsModel.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1892455__) {

"use strict";
__nested_webpack_require_1892455__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1892455__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1892455__(/*! ../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _vo_MetricsList__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1892455__(/*! ../vo/MetricsList */ "./src/streaming/vo/MetricsList.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _vo_metrics_RepresentationSwitch__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/RepresentationSwitch */ "./src/streaming/vo/metrics/RepresentationSwitch.js");
/* harmony import */ var _vo_metrics_BufferLevel__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/BufferLevel */ "./src/streaming/vo/metrics/BufferLevel.js");
/* harmony import */ var _vo_metrics_BufferState__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/BufferState */ "./src/streaming/vo/metrics/BufferState.js");
/* harmony import */ var _vo_metrics_DVRInfo__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/DVRInfo */ "./src/streaming/vo/metrics/DVRInfo.js");
/* harmony import */ var _vo_metrics_DroppedFrames__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/DroppedFrames */ "./src/streaming/vo/metrics/DroppedFrames.js");
/* harmony import */ var _vo_metrics_ManifestUpdate__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/ManifestUpdate */ "./src/streaming/vo/metrics/ManifestUpdate.js");
/* harmony import */ var _vo_metrics_SchedulingInfo__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/SchedulingInfo */ "./src/streaming/vo/metrics/SchedulingInfo.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1892455__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _vo_metrics_RequestsQueue__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1892455__(/*! ../vo/metrics/RequestsQueue */ "./src/streaming/vo/metrics/RequestsQueue.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1892455__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_14__ = __nested_webpack_require_1892455__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
















function MetricsModel(config) {
  config = config || {};
  var settings = config.settings;
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_11__["default"])(context).getInstance();
  var instance, streamMetrics;

  function setup() {
    streamMetrics = {};
  }

  function metricsChanged() {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_13__["default"].METRICS_CHANGED);
  }

  function metricChanged(mediaType) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_13__["default"].METRIC_CHANGED, {
      mediaType: mediaType
    });
    metricsChanged();
  }

  function metricUpdated(mediaType, metricType, vo) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_13__["default"].METRIC_UPDATED, {
      mediaType: mediaType,
      metric: metricType,
      value: vo
    });
    metricChanged(mediaType);
  }

  function metricAdded(mediaType, metricType, vo) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_13__["default"].METRIC_ADDED, {
      mediaType: mediaType,
      metric: metricType,
      value: vo
    });
    metricChanged(mediaType);
  }

  function clearCurrentMetricsForType(type) {
    delete streamMetrics[type];
    metricChanged(type);
  }

  function clearAllCurrentMetrics() {
    streamMetrics = {};
    metricsChanged();
  }

  function getMetricsFor(type, readOnly) {
    var metrics = null;

    if (!type) {
      return metrics;
    }

    if (streamMetrics.hasOwnProperty(type)) {
      metrics = streamMetrics[type];
    } else if (!readOnly) {
      metrics = new _vo_MetricsList__WEBPACK_IMPORTED_MODULE_2__["default"]();
      streamMetrics[type] = metrics;
    }

    return metrics;
  }

  function pushMetrics(type, list, value) {
    var metrics = getMetricsFor(type);

    if (metrics !== null) {
      metrics[list].push(value);

      if (metrics[list].length > settings.get().streaming.metrics.maxListDepth) {
        metrics[list].shift();
      }
    }
  }

  function appendHttpTrace(httpRequest, s, d, b, t) {
    var vo = new _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__["HTTPRequestTrace"]();
    vo.s = s;
    vo.d = d;
    vo.b = b;
    vo._t = t;
    httpRequest.trace.push(vo);

    if (!httpRequest.interval) {
      httpRequest.interval = 0;
    }

    httpRequest.interval += d;
    return vo;
  }

  function addHttpRequest(mediaType, tcpid, type, url, quality, actualurl, serviceLocation, range, trequest, tresponse, tfinish, responsecode, mediaduration, responseHeaders, traces, fileLoaderType) {
    var vo = new _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__["HTTPRequest"](); // ISO 23009-1 D.4.3 NOTE 2:
    // All entries for a given object will have the same URL and range
    // and so can easily be correlated. If there were redirects or
    // failures there will be one entry for each redirect/failure.
    // The redirect-to URL or alternative url (where multiple have been
    // provided in the MPD) will appear as the actualurl of the next
    // entry with the same url value.

    if (actualurl && actualurl !== url) {
      // given the above, add an entry for the original request
      addHttpRequest(mediaType, null, type, url, quality, null, null, range, trequest, null, // unknown
      null, // unknown
      null, // unknown, probably a 302
      mediaduration, null, null, fileLoaderType);
      vo.actualurl = actualurl;
    }

    vo.tcpid = tcpid;
    vo.type = type;
    vo.url = url;
    vo.range = range;
    vo.trequest = trequest;
    vo.tresponse = tresponse;
    vo.responsecode = responsecode;
    vo._tfinish = tfinish;
    vo._stream = mediaType;
    vo._mediaduration = mediaduration;
    vo._quality = quality;
    vo._responseHeaders = responseHeaders;
    vo._serviceLocation = serviceLocation;
    vo._fileLoaderType = fileLoaderType;

    if (traces) {
      traces.forEach(function (trace) {
        appendHttpTrace(vo, trace.s, trace.d, trace.b, trace.t);
      });
    } else {
      // The interval and trace shall be absent for redirect and failure records.
      delete vo.interval;
      delete vo.trace;
    }

    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].HTTP_REQUEST, vo);
  }

  function addRepresentationSwitch(mediaType, t, mt, to, lto) {
    var vo = new _vo_metrics_RepresentationSwitch__WEBPACK_IMPORTED_MODULE_4__["default"]();
    vo.t = t;
    vo.mt = mt;
    vo.to = to;

    if (lto) {
      vo.lto = lto;
    } else {
      delete vo.lto;
    }

    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].TRACK_SWITCH, vo);
  }

  function pushAndNotify(mediaType, metricType, metricObject) {
    pushMetrics(mediaType, metricType, metricObject);
    metricAdded(mediaType, metricType, metricObject);
  }

  function addBufferLevel(mediaType, t, level) {
    var vo = new _vo_metrics_BufferLevel__WEBPACK_IMPORTED_MODULE_5__["default"]();
    vo.t = t;
    vo.level = level;
    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_LEVEL, vo);
  }

  function addBufferState(mediaType, state, target) {
    var vo = new _vo_metrics_BufferState__WEBPACK_IMPORTED_MODULE_6__["default"]();
    vo.target = target;
    vo.state = state;
    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFER_STATE, vo);
  }

  function addDVRInfo(mediaType, currentTime, mpd, range) {
    var vo = new _vo_metrics_DVRInfo__WEBPACK_IMPORTED_MODULE_7__["default"]();
    vo.time = currentTime;
    vo.range = range;
    vo.manifestInfo = mpd;
    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVR_INFO, vo);
  }

  function addDroppedFrames(mediaType, quality) {
    var vo = new _vo_metrics_DroppedFrames__WEBPACK_IMPORTED_MODULE_8__["default"]();
    var list = getMetricsFor(mediaType).DroppedFrames;

    if (!quality) {
      return;
    }

    vo.time = quality.creationTime;
    vo.droppedFrames = quality.droppedVideoFrames;

    if (list.length > 0 && list[list.length - 1] == vo) {
      return;
    }

    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DROPPED_FRAMES, vo);
  }

  function addSchedulingInfo(mediaType, t, type, startTime, availabilityStartTime, duration, quality, range, state) {
    var vo = new _vo_metrics_SchedulingInfo__WEBPACK_IMPORTED_MODULE_10__["default"]();
    vo.mediaType = mediaType;
    vo.t = t;
    vo.type = type;
    vo.startTime = startTime;
    vo.availabilityStartTime = availabilityStartTime;
    vo.duration = duration;
    vo.quality = quality;
    vo.range = range;
    vo.state = state;
    pushAndNotify(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SCHEDULING_INFO, vo);
  }

  function addRequestsQueue(mediaType, loadingRequests, executedRequests) {
    var vo = new _vo_metrics_RequestsQueue__WEBPACK_IMPORTED_MODULE_12__["default"]();
    vo.loadingRequests = loadingRequests;
    vo.executedRequests = executedRequests;
    getMetricsFor(mediaType).RequestsQueue = vo;
    metricAdded(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].REQUESTS_QUEUE, vo);
  }

  function addManifestUpdate(mediaType, type, requestTime, fetchTime, availabilityStartTime, presentationStartTime, clientTimeOffset, currentTime, buffered, latency) {
    var vo = new _vo_metrics_ManifestUpdate__WEBPACK_IMPORTED_MODULE_9__["ManifestUpdate"]();
    vo.mediaType = mediaType;
    vo.type = type;
    vo.requestTime = requestTime; // when this manifest update was requested

    vo.fetchTime = fetchTime; // when this manifest update was received

    vo.availabilityStartTime = availabilityStartTime;
    vo.presentationStartTime = presentationStartTime; // the seek point (liveEdge for dynamic, Stream[0].startTime for static)

    vo.clientTimeOffset = clientTimeOffset; // the calculated difference between the server and client wall clock time

    vo.currentTime = currentTime; // actual element.currentTime

    vo.buffered = buffered; // actual element.ranges

    vo.latency = latency; // (static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - currentTime)

    pushMetrics(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATE, vo);
    metricAdded(mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATE, vo);
  }

  function updateManifestUpdateInfo(manifestUpdate, updatedFields) {
    if (manifestUpdate) {
      for (var field in updatedFields) {
        manifestUpdate[field] = updatedFields[field];
      }

      metricUpdated(manifestUpdate.mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATE, manifestUpdate);
    }
  }

  function addManifestUpdateStreamInfo(manifestUpdate, id, index, start, duration) {
    if (manifestUpdate) {
      var vo = new _vo_metrics_ManifestUpdate__WEBPACK_IMPORTED_MODULE_9__["ManifestUpdateStreamInfo"]();
      vo.id = id;
      vo.index = index;
      vo.start = start;
      vo.duration = duration;
      manifestUpdate.streamInfo.push(vo);
      metricUpdated(manifestUpdate.mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATE_STREAM_INFO, manifestUpdate);
    }
  }

  function addManifestUpdateRepresentationInfo(manifestUpdate, id, index, streamIndex, mediaType, presentationTimeOffset, startNumber, fragmentInfoType) {
    if (manifestUpdate && manifestUpdate.representationInfo) {
      var vo = new _vo_metrics_ManifestUpdate__WEBPACK_IMPORTED_MODULE_9__["ManifestUpdateRepresentationInfo"]();
      vo.id = id;
      vo.index = index;
      vo.streamIndex = streamIndex;
      vo.mediaType = mediaType;
      vo.startNumber = startNumber;
      vo.fragmentInfoType = fragmentInfoType;
      vo.presentationTimeOffset = presentationTimeOffset;
      manifestUpdate.representationInfo.push(vo);
      metricUpdated(manifestUpdate.mediaType, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].MANIFEST_UPDATE_TRACK_INFO, manifestUpdate);
    }
  }

  function addPlayList(vo) {
    if (vo.trace && Array.isArray(vo.trace)) {
      vo.trace.forEach(function (trace) {
        if (trace.hasOwnProperty('subreplevel') && !trace.subreplevel) {
          delete trace.subreplevel;
        }
      });
    } else {
      delete vo.trace;
    }

    pushAndNotify(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PLAY_LIST, vo);
  }

  function addDVBErrors(vo) {
    pushAndNotify(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM, _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_1__["default"].DVB_ERRORS, vo);
  }

  instance = {
    clearCurrentMetricsForType: clearCurrentMetricsForType,
    clearAllCurrentMetrics: clearAllCurrentMetrics,
    getMetricsFor: getMetricsFor,
    addHttpRequest: addHttpRequest,
    addRepresentationSwitch: addRepresentationSwitch,
    addBufferLevel: addBufferLevel,
    addBufferState: addBufferState,
    addDVRInfo: addDVRInfo,
    addDroppedFrames: addDroppedFrames,
    addSchedulingInfo: addSchedulingInfo,
    addRequestsQueue: addRequestsQueue,
    addManifestUpdate: addManifestUpdate,
    updateManifestUpdateInfo: updateManifestUpdateInfo,
    addManifestUpdateStreamInfo: addManifestUpdateStreamInfo,
    addManifestUpdateRepresentationInfo: addManifestUpdateRepresentationInfo,
    addPlayList: addPlayList,
    addDVBErrors: addDVBErrors
  };
  setup();
  return instance;
}

MetricsModel.__dashjs_factory_name = 'MetricsModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_14__["default"].getSingletonFactory(MetricsModel));

/***/ }),

/***/ "./src/streaming/models/URIFragmentModel.js":
/*!**************************************************!*\
  !*** ./src/streaming/models/URIFragmentModel.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1909720__) {

"use strict";
__nested_webpack_require_1909720__.r(__webpack_exports__);
/* harmony import */ var _vo_URIFragmentData__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1909720__(/*! ../vo/URIFragmentData */ "./src/streaming/vo/URIFragmentData.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1909720__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * Model class managing URI fragments.
 * @ignore
 */

function URIFragmentModel() {
  var instance, URIFragmentDataVO;
  /**
   * @param {string} uri The URI to parse for fragment extraction
   * @memberof module:URIFragmentModel
   * @instance
   */

  function initialize(uri) {
    URIFragmentDataVO = new _vo_URIFragmentData__WEBPACK_IMPORTED_MODULE_0__["default"]();
    if (!uri) return null;
    var hashIndex = uri.indexOf('#');

    if (hashIndex !== -1) {
      var fragments = uri.substr(hashIndex + 1).split('&');

      for (var i = 0, len = fragments.length; i < len; ++i) {
        var fragment = fragments[i];
        var equalIndex = fragment.indexOf('=');

        if (equalIndex !== -1) {
          var key = fragment.substring(0, equalIndex);

          if (URIFragmentDataVO.hasOwnProperty(key)) {
            URIFragmentDataVO[key] = fragment.substr(equalIndex + 1);
          }
        }
      }
    }
  }
  /**
   * @returns {URIFragmentData} Object containing supported URI fragments
   * @memberof module:URIFragmentModel
   * @instance
   */


  function getURIFragmentData() {
    return URIFragmentDataVO;
  }

  instance = {
    initialize: initialize,
    getURIFragmentData: getURIFragmentData
  };
  return instance;
}

URIFragmentModel.__dashjs_factory_name = 'URIFragmentModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getSingletonFactory(URIFragmentModel));

/***/ }),

/***/ "./src/streaming/models/VideoModel.js":
/*!********************************************!*\
  !*** ./src/streaming/models/VideoModel.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1913829__) {

"use strict";
__nested_webpack_require_1913829__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1913829__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1913829__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1913829__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1913829__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1913829__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */





var READY_STATES_TO_EVENT_NAMES = new Map([[_constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, 'loadedmetadata'], [_constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA, 'loadeddata'], [_constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA, 'canplay'], [_constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA, 'canplaythrough']]);

function VideoModel() {
  var instance, logger, element, _currentTime, TTMLRenderingDiv, previousPlaybackRate;

  var VIDEO_MODEL_WRONG_ELEMENT_TYPE = 'element is not video or audio DOM type!';
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var stalledStreams = [];

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance().getLogger(instance);
    _currentTime = NaN;
  }

  function initialize() {
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PLAYING, onPlaying, this);
  }

  function reset() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_PLAYING, onPlaying, this);
  }

  function onPlaybackCanPlay() {
    if (element) {
      element.playbackRate = previousPlaybackRate || 1;
      element.removeEventListener('canplay', onPlaybackCanPlay);
    }
  }

  function setPlaybackRate(value) {
    var ignoreReadyState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!element) return;

    if (!ignoreReadyState && element.readyState <= 2 && value > 0) {
      // If media element hasn't loaded enough data to play yet, wait until it has
      element.addEventListener('canplay', onPlaybackCanPlay);
    } else {
      element.playbackRate = value;
    }
  } //TODO Move the DVR window calculations from MediaPlayer to Here.


  function setCurrentTime(currentTime, stickToBuffered) {
    _currentTime = currentTime;
    waitForReadyState(_constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_METADATA, function () {
      if (element) {
        // We don't set the same currentTime because it can cause firing unexpected Pause event in IE11
        // providing playbackRate property equals to zero.
        if (element.currentTime === _currentTime) {
          _currentTime = NaN;
          return;
        } // TODO Despite the fact that MediaSource 'open' event has been fired IE11 cannot set videoElement.currentTime
        // immediately (it throws InvalidStateError). It seems that this is related to videoElement.readyState property
        // Initially it is 0, but soon after 'open' event it goes to 1 and setting currentTime is allowed. Chrome allows to
        // set currentTime even if readyState = 0.
        // setTimeout is used to workaround InvalidStateError in IE11


        try {
          _currentTime = stickToBuffered ? stickTimeToBuffered(_currentTime) : _currentTime;
          element.currentTime = _currentTime;
          _currentTime = NaN;
        } catch (e) {
          if (element.readyState === 0 && e.code === e.INVALID_STATE_ERR) {
            setTimeout(function () {
              element.currentTime = _currentTime;
              _currentTime = NaN;
            }, 400);
          }
        }
      }
    });
  }

  function stickTimeToBuffered(time) {
    var buffered = getBufferRange();
    var closestTime = time;
    var closestDistance = 9999999999;

    if (buffered) {
      for (var i = 0; i < buffered.length; i++) {
        var start = buffered.start(i);
        var end = buffered.end(i);
        var distanceToStart = Math.abs(start - time);
        var distanceToEnd = Math.abs(end - time);

        if (time >= start && time <= end) {
          return time;
        }

        if (distanceToStart < closestDistance) {
          closestDistance = distanceToStart;
          closestTime = start;
        }

        if (distanceToEnd < closestDistance) {
          closestDistance = distanceToEnd;
          closestTime = end;
        }
      }
    }

    return closestTime;
  }

  function getElement() {
    return element;
  }

  function setElement(value) {
    //add check of value type
    if (value === null || value === undefined || value && /^(VIDEO|AUDIO)$/i.test(value.nodeName)) {
      element = value; // Workaround to force Firefox to fire the canplay event.

      if (element) {
        element.preload = 'auto';
      }
    } else {
      throw VIDEO_MODEL_WRONG_ELEMENT_TYPE;
    }
  }

  function setSource(source) {
    if (element) {
      if (source) {
        element.src = source;
      } else {
        element.removeAttribute('src');
        element.load();
      }
    }
  }

  function getSource() {
    return element ? element.src : null;
  }

  function getTTMLRenderingDiv() {
    return TTMLRenderingDiv;
  }

  function setTTMLRenderingDiv(div) {
    TTMLRenderingDiv = div; // The styling will allow the captions to match the video window size and position.

    TTMLRenderingDiv.style.position = 'absolute';
    TTMLRenderingDiv.style.display = 'flex';
    TTMLRenderingDiv.style.overflow = 'hidden';
    TTMLRenderingDiv.style.pointerEvents = 'none';
    TTMLRenderingDiv.style.top = 0;
    TTMLRenderingDiv.style.left = 0;
  }

  function setStallState(type, state) {
    stallStream(type, state);
  }

  function isStalled() {
    return stalledStreams.length > 0;
  }

  function addStalledStream(type) {
    if (type === null || !element || element.seeking || stalledStreams.indexOf(type) !== -1) {
      return;
    }

    stalledStreams.push(type);
  }

  function removeStalledStream(type) {
    var index = stalledStreams.indexOf(type);

    if (type === null) {
      return;
    }

    if (index !== -1) {
      stalledStreams.splice(index, 1);
    }
  }

  function stallStream(type, isStalled) {
    if (isStalled) {
      addStalledStream(type);
    } else {
      removeStalledStream(type);
    }
  } //Calling play on the element will emit playing - even if the stream is stalled. If the stream is stalled, emit a waiting event.


  function onPlaying() {
    if (element && isStalled() && element.playbackRate === 0) {
      var event = document.createEvent('Event');
      event.initEvent('waiting', true, false);
      element.dispatchEvent(event);
    }
  }

  function getPlaybackQuality() {
    if (!element) {
      return null;
    }

    var hasWebKit = 'webkitDroppedFrameCount' in element && 'webkitDecodedFrameCount' in element;
    var hasQuality = ('getVideoPlaybackQuality' in element);
    var result = null;

    if (hasQuality) {
      result = element.getVideoPlaybackQuality();
    } else if (hasWebKit) {
      result = {
        droppedVideoFrames: element.webkitDroppedFrameCount,
        totalVideoFrames: element.webkitDroppedFrameCount + element.webkitDecodedFrameCount,
        creationTime: new Date()
      };
    }

    return result;
  }

  function play() {
    if (element) {
      element.autoplay = true;
      var p = element.play();

      if (p && p["catch"] && typeof Promise !== 'undefined') {
        p["catch"](function (e) {
          if (e.name === 'NotAllowedError') {
            eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].PLAYBACK_NOT_ALLOWED);
          }

          logger.warn("Caught pending play exception - continuing (".concat(e, ")"));
        });
      }
    }
  }

  function isPaused() {
    return element ? element.paused : null;
  }

  function pause() {
    if (element) {
      element.pause();
      element.autoplay = false;
    }
  }

  function isSeeking() {
    return element ? element.seeking || !isNaN(_currentTime) : null;
  }

  function getTime() {
    return element ? !isNaN(_currentTime) ? _currentTime : element.currentTime : null;
  }

  function getPlaybackRate() {
    return element ? element.playbackRate : null;
  }

  function getPlayedRanges() {
    return element ? element.played : null;
  }

  function getEnded() {
    return element ? element.ended : null;
  }

  function addEventListener(eventName, eventCallBack) {
    if (element) {
      element.addEventListener(eventName, eventCallBack);
    }
  }

  function removeEventListener(eventName, eventCallBack) {
    if (element) {
      element.removeEventListener(eventName, eventCallBack);
    }
  }

  function getReadyState() {
    return element ? element.readyState : NaN;
  }

  function getBufferRange() {
    return element ? element.buffered : null;
  }

  function getClientWidth() {
    return element ? element.clientWidth : NaN;
  }

  function getClientHeight() {
    return element ? element.clientHeight : NaN;
  }

  function getVideoWidth() {
    return element ? element.videoWidth : NaN;
  }

  function getVideoHeight() {
    return element ? element.videoHeight : NaN;
  }

  function getVideoRelativeOffsetTop() {
    var parentElement = element.parentNode.host || element.parentNode;
    return parentElement ? element.getBoundingClientRect().top - parentElement.getBoundingClientRect().top : NaN;
  }

  function getVideoRelativeOffsetLeft() {
    var parentElement = element.parentNode.host || element.parentNode;
    return parentElement ? element.getBoundingClientRect().left - parentElement.getBoundingClientRect().left : NaN;
  }

  function getTextTracks() {
    return element ? element.textTracks : [];
  }

  function getTextTrack(kind, label, lang, isTTML, isEmbedded) {
    if (element) {
      for (var i = 0; i < element.textTracks.length; i++) {
        //label parameter could be a number (due to adaptationSet), but label, the attribute of textTrack, is a string => to modify...
        //label could also be undefined (due to adaptationSet)
        if (element.textTracks[i].kind === kind && (label ? element.textTracks[i].label == label : true) && element.textTracks[i].language === lang && element.textTracks[i].isTTML === isTTML && element.textTracks[i].isEmbedded === isEmbedded) {
          return element.textTracks[i];
        }
      }
    }

    return null;
  }

  function addTextTrack(kind, label, lang, isTTML, isEmbedded) {
    if (!element) {
      return null;
    } // check if track of same type has not been already created for previous stream
    // then use it (no way to remove existing text track from video element)


    var track = getTextTrack(kind, label, lang, isTTML, isEmbedded);

    if (!track) {
      track = element.addTextTrack(kind, label, lang);
      track.isEmbedded = isEmbedded;
      track.isTTML = isTTML;
    }

    return track;
  }

  function appendChild(childElement) {
    if (element) {
      element.appendChild(childElement); //in Chrome, we need to differenciate textTrack with same lang, kind and label but different format (vtt, ttml, etc...)

      if (childElement.isTTML !== undefined) {
        element.textTracks[element.textTracks.length - 1].isTTML = childElement.isTTML;
        element.textTracks[element.textTracks.length - 1].isEmbedded = childElement.isEmbedded;
      }
    }
  }

  function removeChild(childElement) {
    if (element) {
      element.removeChild(childElement);
    }
  }

  function waitForReadyState(targetReadyState, callback) {
    if (targetReadyState === _constants_Constants__WEBPACK_IMPORTED_MODULE_4__["default"].VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING || getReadyState() >= targetReadyState) {
      callback();
    } else {
      // wait for the appropriate callback before checking again
      var event = READY_STATES_TO_EVENT_NAMES.get(targetReadyState);

      _listenOnce(event, callback);
    }
  }

  function _listenOnce(event, callback) {
    var func = function func() {
      // Stop listening to this event.
      removeEventListener(event, func); // Call the original listener.

      callback(event);
    };

    addEventListener(event, func);
  }

  instance = {
    initialize: initialize,
    setCurrentTime: setCurrentTime,
    play: play,
    isPaused: isPaused,
    pause: pause,
    isStalled: isStalled,
    isSeeking: isSeeking,
    getTime: getTime,
    getPlaybackRate: getPlaybackRate,
    setPlaybackRate: setPlaybackRate,
    getPlayedRanges: getPlayedRanges,
    getEnded: getEnded,
    setStallState: setStallState,
    getElement: getElement,
    setElement: setElement,
    setSource: setSource,
    getSource: getSource,
    getTTMLRenderingDiv: getTTMLRenderingDiv,
    setTTMLRenderingDiv: setTTMLRenderingDiv,
    getPlaybackQuality: getPlaybackQuality,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener,
    getReadyState: getReadyState,
    getBufferRange: getBufferRange,
    getClientWidth: getClientWidth,
    getClientHeight: getClientHeight,
    getTextTracks: getTextTracks,
    getTextTrack: getTextTrack,
    addTextTrack: addTextTrack,
    appendChild: appendChild,
    removeChild: removeChild,
    getVideoWidth: getVideoWidth,
    getVideoHeight: getVideoHeight,
    getVideoRelativeOffsetTop: getVideoRelativeOffsetTop,
    getVideoRelativeOffsetLeft: getVideoRelativeOffsetLeft,
    waitForReadyState: waitForReadyState,
    reset: reset
  };
  setup();
  return instance;
}

VideoModel.__dashjs_factory_name = 'VideoModel';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(VideoModel));

/***/ }),

/***/ "./src/streaming/net/FetchLoader.js":
/*!******************************************!*\
  !*** ./src/streaming/net/FetchLoader.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1930820__) {

"use strict";
__nested_webpack_require_1930820__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1930820__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1930820__(/*! ../../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1930820__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



/**
 * @module FetchLoader
 * @ignore
 * @description Manages download of resources via HTTP using fetch.
 * @param {Object} cfg - dependencies from parent
 */

function FetchLoader(cfg) {
  cfg = cfg || {};
  var context = this.context;
  var requestModifier = cfg.requestModifier;
  var lowLatencyThroughputModel = cfg.lowLatencyThroughputModel;
  var boxParser = cfg.boxParser;
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var instance, dashMetrics;

  function setup(cfg) {
    dashMetrics = cfg.dashMetrics;
  }

  function load(httpRequest) {
    // Variables will be used in the callback functions
    var requestStartTime = new Date();
    var request = httpRequest.request;
    var headers = new Headers();
    /*jshint ignore:line*/

    if (request.range) {
      headers.append('Range', 'bytes=' + request.range);
    }

    if (httpRequest.headers) {
      for (var header in httpRequest.headers) {
        var value = httpRequest.headers[header];

        if (value) {
          headers.append(header, value);
        }
      }
    }

    if (!request.requestStartDate) {
      request.requestStartDate = requestStartTime;
    }

    if (requestModifier) {
      // modifyRequestHeader expects a XMLHttpRequest object so,
      // to keep backward compatibility, we should expose a setRequestHeader method
      // TODO: Remove RequestModifier dependency on XMLHttpRequest object and define
      // a more generic way to intercept/modify requests
      requestModifier.modifyRequestHeader({
        setRequestHeader: function setRequestHeader(header, value) {
          headers.append(header, value);
        }
      });
    }

    var abortController;

    if (typeof window.AbortController === 'function') {
      abortController = new AbortController();
      /*jshint ignore:line*/

      httpRequest.abortController = abortController;
      abortController.signal.onabort = httpRequest.onabort;
    }

    var reqOptions = {
      method: httpRequest.method,
      headers: headers,
      credentials: httpRequest.withCredentials ? 'include' : undefined,
      signal: abortController ? abortController.signal : undefined
    };
    var calculationMode = settings.get().streaming.abr.fetchThroughputCalculationMode;
    var requestTime = Date.now();
    var throughputCapacityDelayMS = 0;
    new Promise(function (resolve) {
      if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_AAST && lowLatencyThroughputModel) {
        throughputCapacityDelayMS = lowLatencyThroughputModel.getThroughputCapacityDelayMS(request, dashMetrics.getCurrentBufferLevel(request.mediaType) * 1000);

        if (throughputCapacityDelayMS) {
          // safely delay the "fetch" call a bit to be able to meassure the throughput capacity of the line.
          // this will lead to first few chunks downloaded at max network speed
          return setTimeout(resolve, throughputCapacityDelayMS);
        }
      }

      resolve();
    }).then(function () {
      var markBeforeFetch = Date.now();
      fetch(httpRequest.url, reqOptions).then(function (response) {
        if (!httpRequest.response) {
          httpRequest.response = {};
        }

        httpRequest.response.status = response.status;
        httpRequest.response.statusText = response.statusText;
        httpRequest.response.responseURL = response.url;

        if (!response.ok) {
          httpRequest.onerror();
        }

        var responseHeaders = '';

        var _iterator = _createForOfIteratorHelper(response.headers.keys()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            responseHeaders += key + ': ' + response.headers.get(key) + '\r\n';
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        httpRequest.response.responseHeaders = responseHeaders;

        if (!response.body) {
          // Fetch returning a ReadableStream response body is not currently supported by all browsers.
          // Browser compatibility: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
          // If it is not supported, returning the whole segment when it's ready (as xhr)
          return response.arrayBuffer().then(function (buffer) {
            httpRequest.response.response = buffer;
            var event = {
              loaded: buffer.byteLength,
              total: buffer.byteLength,
              stream: false
            };
            httpRequest.progress(event);
            httpRequest.onload();
            httpRequest.onend();
            return;
          });
        }

        var totalBytes = parseInt(response.headers.get('Content-Length'), 10);
        var bytesReceived = 0;
        var signaledFirstByte = false;
        var remaining = new Uint8Array();
        var offset = 0;

        if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_AAST && lowLatencyThroughputModel) {
          var fetchMeassurement = function fetchMeassurement(stream) {
            var reader = stream.getReader();
            var measurement = [];
            reader.read().then(function processFetch(args) {
              var value = args.value;
              var done = args.done;
              markB = Date.now();

              if (value && value.length) {
                var chunkDownloadDurationMS = markB - markA;
                var chunkBytes = value.length;
                measurement.push({
                  chunkDownloadTimeRelativeMS: markB - markBeforeFetch,
                  chunkDownloadDurationMS: chunkDownloadDurationMS,
                  chunkBytes: chunkBytes,
                  kbps: Math.round(8 * chunkBytes / (chunkDownloadDurationMS / 1000)),
                  bufferLevel: dashMetrics.getCurrentBufferLevel(request.mediaType)
                });
              }

              if (done) {
                var fetchDuration = markB - markBeforeFetch;
                var bytesAllChunks = measurement.reduce(function (prev, curr) {
                  return prev + curr.chunkBytes;
                }, 0);
                lowLatencyThroughputModel.addMeasurement(request, fetchDuration, measurement, requestTime, throughputCapacityDelayMS, responseHeaders);
                httpRequest.progress({
                  loaded: bytesAllChunks,
                  total: bytesAllChunks,
                  lengthComputable: true,
                  time: lowLatencyThroughputModel.getEstimatedDownloadDurationMS(request),
                  stream: true
                });
                return;
              }

              markA = Date.now();
              return reader.read().then(processFetch);
            });
          }; // tee'ing streams is supported by all current major browsers
          // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/tee


          var markA = markBeforeFetch;
          var markB = 0;

          var _response$body$tee = response.body.tee(),
              _response$body$tee2 = _slicedToArray(_response$body$tee, 2),
              forMeasure = _response$body$tee2[0],
              forConsumer = _response$body$tee2[1];

          fetchMeassurement(forMeasure);
          httpRequest.reader = forConsumer.getReader();
        } else {
          httpRequest.reader = response.body.getReader();
        }

        var downloadedData = [];
        var startTimeData = [];
        var endTimeData = [];
        var lastChunkWasFinished = true;

        var processResult = function processResult(_ref) {
          var value = _ref.value,
              done = _ref.done;

          // Bug fix Parse whenever data is coming [value] better than 1ms looking that increase CPU
          if (done) {
            if (remaining) {
              if (calculationMode !== _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_AAST) {
                // If there is pending data, call progress so network metrics
                // are correctly generated
                // Same structure as https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequestEventTarget/
                var calculatedThroughput = null;

                if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING) {
                  calculatedThroughput = calculateThroughputByChunkData(startTimeData, endTimeData);
                }

                httpRequest.progress({
                  loaded: bytesReceived,
                  total: isNaN(totalBytes) ? bytesReceived : totalBytes,
                  lengthComputable: true,
                  time: calculateDownloadedTime(downloadedData, bytesReceived),
                  throughput: calculatedThroughput,
                  stream: true
                });
              }

              httpRequest.response.response = remaining.buffer;
            }

            httpRequest.onload();
            httpRequest.onend();
            return;
          }

          if (value && value.length > 0) {
            remaining = concatTypedArray(remaining, value);
            bytesReceived += value.length;
            downloadedData.push({
              ts: Date.now(),
              bytes: value.length
            });

            if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && lastChunkWasFinished) {
              // Parse the payload and capture the the 'moof' box
              var _boxesInfo = boxParser.findLastTopIsoBoxCompleted(['moof'], remaining, offset);

              if (_boxesInfo.found) {
                // Store the beginning time of each chunk download in array StartTimeData
                lastChunkWasFinished = false;
                startTimeData.push({
                  ts: performance.now(),

                  /* jshint ignore:line */
                  bytes: value.length
                });
              }
            }

            var boxesInfo = boxParser.findLastTopIsoBoxCompleted(['moov', 'mdat'], remaining, offset);

            if (boxesInfo.found) {
              var end = boxesInfo.lastCompletedOffset + boxesInfo.size; // Store the end time of each chunk download  with its size in array EndTimeData

              if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING && !lastChunkWasFinished) {
                lastChunkWasFinished = true;
                endTimeData.push({
                  ts: performance.now(),

                  /* jshint ignore:line */
                  bytes: remaining.length
                });
              } // If we are going to pass full buffer, avoid copying it and pass
              // complete buffer. Otherwise clone the part of the buffer that is completed
              // and adjust remaining buffer. A clone is needed because ArrayBuffer of a typed-array
              // keeps a reference to the original data


              var data;

              if (end === remaining.length) {
                data = remaining;
                remaining = new Uint8Array();
              } else {
                data = new Uint8Array(remaining.subarray(0, end));
                remaining = remaining.subarray(end);
              } // Announce progress but don't track traces. Throughput measures are quite unstable
              // when they are based in small amount of data


              httpRequest.progress({
                data: data.buffer,
                lengthComputable: false,
                noTrace: true
              });
              offset = 0;
            } else {
              offset = boxesInfo.lastCompletedOffset; // Call progress so it generates traces that will be later used to know when the first byte
              // were received

              if (!signaledFirstByte) {
                httpRequest.progress({
                  lengthComputable: false,
                  noTrace: true
                });
                signaledFirstByte = true;
              }
            }
          }

          read(httpRequest, processResult);
        };

        read(httpRequest, processResult);
      })["catch"](function (e) {
        if (httpRequest.onerror) {
          httpRequest.onerror(e);
        }
      });
    });
  }

  function read(httpRequest, processResult) {
    httpRequest.reader.read().then(processResult)["catch"](function (e) {
      if (httpRequest.onerror && httpRequest.response.status === 200) {
        // Error, but response code is 200, trigger error
        httpRequest.onerror(e);
      }
    });
  }

  function concatTypedArray(remaining, data) {
    if (remaining.length === 0) {
      return data;
    }

    var result = new Uint8Array(remaining.length + data.length);
    result.set(remaining);
    result.set(data, remaining.length);
    return result;
  }

  function abort(request) {
    if (request.abortController) {
      // For firefox and edge
      request.abortController.abort();
    } else if (request.reader) {
      // For Chrome
      try {
        request.reader.cancel();
        request.onabort();
      } catch (e) {// throw exceptions (TypeError) when reader was previously closed,
        // for example, because a network issue
      }
    }
  }

  function calculateDownloadedTime(downloadedData, bytesReceived) {
    try {
      downloadedData = downloadedData.filter(function (data) {
        return data.bytes > bytesReceived / 4 / downloadedData.length;
      });

      if (downloadedData.length > 1) {
        var time = 0;
        var avgTimeDistance = (downloadedData[downloadedData.length - 1].ts - downloadedData[0].ts) / downloadedData.length;
        downloadedData.forEach(function (data, index) {
          // To be counted the data has to be over a threshold
          var next = downloadedData[index + 1];

          if (next) {
            var distance = next.ts - data.ts;
            time += distance < avgTimeDistance ? distance : 0;
          }
        });
        return time;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function calculateThroughputByChunkData(startTimeData, endTimeData) {
    try {
      var datum, datumE; // Filter the last chunks in a segment in both arrays [StartTimeData and EndTimeData]

      datum = startTimeData.filter(function (data, i) {
        return i < startTimeData.length - 1;
      });
      datumE = endTimeData.filter(function (dataE, i) {
        return i < endTimeData.length - 1;
      });
      var chunkThroughputs = []; // Compute the average throughput of the filtered chunk data

      if (datum.length > 1) {
        var shortDurationBytesReceived = 0;
        var shortDurationStartTime = 0;

        for (var i = 0; i < datum.length; i++) {
          if (datum[i] && datumE[i]) {
            var chunkDownloadTime = datumE[i].ts - datum[i].ts;

            if (chunkDownloadTime > 1) {
              chunkThroughputs.push(8 * datumE[i].bytes / chunkDownloadTime);
            } else {
              if (shortDurationStartTime === 0) {
                shortDurationStartTime = datum[i].ts;
              }

              var cumulatedChunkDownloadTime = datumE[i].ts - shortDurationStartTime;

              if (cumulatedChunkDownloadTime > 1) {
                chunkThroughputs.push(8 * shortDurationBytesReceived / cumulatedChunkDownloadTime);
                shortDurationBytesReceived = 0;
                shortDurationStartTime = 0;
              } else {
                // continue cumulating short duration data
                shortDurationBytesReceived += datumE[i].bytes;
              }
            }
          }
        }

        if (chunkThroughputs.length > 0) {
          var sumOfChunkThroughputs = chunkThroughputs.reduce(function (a, b) {
            return a + b;
          }, 0);
          return sumOfChunkThroughputs / chunkThroughputs.length;
        }
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  instance = {
    load: load,
    abort: abort,
    calculateDownloadedTime: calculateDownloadedTime,
    setup: setup
  };
  return instance;
}

FetchLoader.__dashjs_factory_name = 'FetchLoader';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(FetchLoader);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/net/HTTPLoader.js":
/*!*****************************************!*\
  !*** ./src/streaming/net/HTTPLoader.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1953151__) {

"use strict";
__nested_webpack_require_1953151__.r(__webpack_exports__);
/* harmony import */ var _XHRLoader__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1953151__(/*! ./XHRLoader */ "./src/streaming/net/XHRLoader.js");
/* harmony import */ var _FetchLoader__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1953151__(/*! ./FetchLoader */ "./src/streaming/net/FetchLoader.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1953151__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1953151__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1953151__(/*! ../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _models_CmcdModel__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1953151__(/*! ../models/CmcdModel */ "./src/streaming/models/CmcdModel.js");
/* harmony import */ var _core_Utils__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1953151__(/*! ../../core/Utils */ "./src/core/Utils.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_1953151__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_1953151__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_1953151__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_Settings__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_1953151__(/*! ../../core/Settings */ "./src/core/Settings.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_1953151__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _models_LowLatencyThroughputModel__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_1953151__(/*! ../models/LowLatencyThroughputModel */ "./src/streaming/models/LowLatencyThroughputModel.js");
/* harmony import */ var _models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_1953151__(/*! ../models/CustomParametersModel */ "./src/streaming/models/CustomParametersModel.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */














/**
 * @module HTTPLoader
 * @ignore
 * @description Manages download of resources via HTTP.
 * @param {Object} cfg - dependencies from parent
 */

function HTTPLoader(cfg) {
  cfg = cfg || {};
  var context = this.context;
  var errHandler = cfg.errHandler;
  var dashMetrics = cfg.dashMetrics;
  var mediaPlayerModel = cfg.mediaPlayerModel;
  var requestModifier = cfg.requestModifier;
  var boxParser = cfg.boxParser;
  var errors = cfg.errors;
  var requestTimeout = cfg.requestTimeout || 0;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
  var settings = Object(_core_Settings__WEBPACK_IMPORTED_MODULE_10__["default"])(context).getInstance();
  var instance, requests, delayedRequests, retryRequests, downloadErrorToRequestTypeMap, cmcdModel, customParametersModel, lowLatencyThroughputModel, logger;

  function setup() {
    var _downloadErrorToReque;

    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance().getLogger(instance);
    requests = [];
    delayedRequests = [];
    retryRequests = [];
    cmcdModel = Object(_models_CmcdModel__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
    lowLatencyThroughputModel = Object(_models_LowLatencyThroughputModel__WEBPACK_IMPORTED_MODULE_12__["default"])(context).getInstance();
    customParametersModel = Object(_models_CustomParametersModel__WEBPACK_IMPORTED_MODULE_13__["default"])(context).getInstance();
    downloadErrorToRequestTypeMap = (_downloadErrorToReque = {}, _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MPD_TYPE, errors.DOWNLOAD_ERROR_ID_MANIFEST_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].XLINK_EXPANSION_TYPE, errors.DOWNLOAD_ERROR_ID_XLINK_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].INIT_SEGMENT_TYPE, errors.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MEDIA_SEGMENT_TYPE, errors.DOWNLOAD_ERROR_ID_CONTENT_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].INDEX_SEGMENT_TYPE, errors.DOWNLOAD_ERROR_ID_CONTENT_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].BITSTREAM_SWITCHING_SEGMENT_TYPE, errors.DOWNLOAD_ERROR_ID_CONTENT_CODE), _defineProperty(_downloadErrorToReque, _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].OTHER_TYPE, errors.DOWNLOAD_ERROR_ID_CONTENT_CODE), _downloadErrorToReque);
  }

  function internalLoad(config, remainingAttempts) {
    var request = config.request;
    var traces = [];
    var firstProgress = true;
    var needFailureReport = true;
    var requestStartTime = new Date();
    var lastTraceTime = requestStartTime;
    var lastTraceReceivedCount = 0;
    var fileLoaderType = null;
    var httpRequest;

    if (!requestModifier || !dashMetrics || !errHandler) {
      throw new Error('config object is not correct or missing');
    }

    var handleLoaded = function handleLoaded(success) {
      needFailureReport = false;
      request.requestStartDate = requestStartTime;
      request.requestEndDate = new Date();
      request.firstByteDate = request.firstByteDate || requestStartTime;
      request.fileLoaderType = fileLoaderType;

      if (!request.checkExistenceOnly) {
        var responseUrl = httpRequest.response ? httpRequest.response.responseURL : null;
        var responseStatus = httpRequest.response ? httpRequest.response.status : null;
        var responseHeaders = httpRequest.response && httpRequest.response.getAllResponseHeaders ? httpRequest.response.getAllResponseHeaders() : httpRequest.response ? httpRequest.response.responseHeaders : [];
        dashMetrics.addHttpRequest(request, responseUrl, responseStatus, responseHeaders, success ? traces : null);

        if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MPD_TYPE) {
          dashMetrics.addManifestUpdate(request);
        }
      }
    };

    var onloadend = function onloadend() {
      if (requests.indexOf(httpRequest) === -1) {
        return;
      } else {
        requests.splice(requests.indexOf(httpRequest), 1);
      }

      if (needFailureReport) {
        handleLoaded(false);

        if (remainingAttempts > 0) {
          // If we get a 404 to a media segment we should check the client clock again and perform a UTC sync in the background.
          try {
            if (settings.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError && request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
              // Only trigger a sync if the loading failed for the first time
              var initialNumberOfAttempts = mediaPlayerModel.getRetryAttemptsForType(_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MEDIA_SEGMENT_TYPE);

              if (initialNumberOfAttempts === remainingAttempts) {
                eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_9__["default"].ATTEMPT_BACKGROUND_SYNC);
              }
            }
          } catch (e) {}

          remainingAttempts--;
          var retryRequest = {
            config: config
          };
          retryRequests.push(retryRequest);
          retryRequest.timeout = setTimeout(function () {
            if (retryRequests.indexOf(retryRequest) === -1) {
              return;
            } else {
              retryRequests.splice(retryRequests.indexOf(retryRequest), 1);
            }

            internalLoad(config, remainingAttempts);
          }, mediaPlayerModel.getRetryIntervalsForType(request.type));
        } else {
          if (request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE) {
            return;
          }

          errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](downloadErrorToRequestTypeMap[request.type], request.url + ' is not available', {
            request: request,
            response: httpRequest.response
          }));

          if (config.error) {
            config.error(request, 'error', httpRequest.response.statusText);
          }

          if (config.complete) {
            config.complete(request, httpRequest.response.statusText);
          }
        }
      }
    };

    var progress = function progress(event) {
      var currentTime = new Date();

      if (firstProgress) {
        firstProgress = false;

        if (!event.lengthComputable || event.lengthComputable && event.total !== event.loaded) {
          request.firstByteDate = currentTime;
        }
      }

      if (event.lengthComputable) {
        request.bytesLoaded = event.loaded;
        request.bytesTotal = event.total;
      }

      if (!event.noTrace) {
        traces.push({
          s: lastTraceTime,
          d: event.time ? event.time : currentTime.getTime() - lastTraceTime.getTime(),
          b: [event.loaded ? event.loaded - lastTraceReceivedCount : 0],
          t: event.throughput
        });
        lastTraceTime = currentTime;
        lastTraceReceivedCount = event.loaded;
      }

      if (config.progress && event) {
        config.progress(event);
      }
    };

    var onload = function onload() {
      if (httpRequest.response.status >= 200 && httpRequest.response.status <= 299) {
        handleLoaded(true);

        if (config.success) {
          config.success(httpRequest.response.response, httpRequest.response.statusText, httpRequest.response.responseURL);
        }

        if (config.complete) {
          config.complete(request, httpRequest.response.statusText);
        }
      }
    };

    var onabort = function onabort() {
      if (config.abort) {
        config.abort(request);
      }
    };

    var ontimeout = function ontimeout(event) {
      var timeoutMessage;

      if (event.lengthComputable) {
        var percentageComplete = event.loaded / event.total * 100;
        timeoutMessage = 'Request timeout: loaded: ' + event.loaded + ', out of: ' + event.total + ' : ' + percentageComplete.toFixed(3) + '% Completed';
      } else {
        timeoutMessage = 'Request timeout: non-computable download size';
      }

      logger.warn(timeoutMessage);
    };

    var loader;

    if (request.hasOwnProperty('availabilityTimeComplete') && request.availabilityTimeComplete === false && window.fetch && request.responseType === 'arraybuffer' && request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
      loader = Object(_FetchLoader__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
        requestModifier: requestModifier,
        lowLatencyThroughputModel: lowLatencyThroughputModel,
        boxParser: boxParser
      });
      loader.setup({
        dashMetrics: dashMetrics
      });
      fileLoaderType = _constants_Constants__WEBPACK_IMPORTED_MODULE_11__["default"].FILE_LOADER_TYPES.FETCH;
    } else {
      loader = Object(_XHRLoader__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
        requestModifier: requestModifier
      });
      fileLoaderType = _constants_Constants__WEBPACK_IMPORTED_MODULE_11__["default"].FILE_LOADER_TYPES.XHR;
    }

    var headers = null;
    var modifiedUrl = requestModifier.modifyRequestURL(request.url);

    if (settings.get().streaming.cmcd && settings.get().streaming.cmcd.enabled) {
      var cmcdMode = settings.get().streaming.cmcd.mode;

      if (cmcdMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_11__["default"].CMCD_MODE_QUERY) {
        var additionalQueryParameter = _getAdditionalQueryParameter(request);

        modifiedUrl = _core_Utils__WEBPACK_IMPORTED_MODULE_6__["default"].addAditionalQueryParameterToUrl(modifiedUrl, additionalQueryParameter);
      } else if (cmcdMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_11__["default"].CMCD_MODE_HEADER) {
        headers = cmcdModel.getHeaderParameters(request);
      }
    }

    request.url = modifiedUrl;
    var verb = request.checkExistenceOnly ? _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].HEAD : _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].GET;
    var withCredentials = customParametersModel.getXHRWithCredentialsForType(request.type);
    httpRequest = {
      url: modifiedUrl,
      method: verb,
      withCredentials: withCredentials,
      request: request,
      onload: onload,
      onend: onloadend,
      onerror: onloadend,
      progress: progress,
      onabort: onabort,
      ontimeout: ontimeout,
      loader: loader,
      timeout: requestTimeout,
      headers: headers
    }; // Adds the ability to delay single fragment loading time to control buffer.

    var now = new Date().getTime();

    if (isNaN(request.delayLoadingTime) || now >= request.delayLoadingTime) {
      // no delay - just send
      requests.push(httpRequest);
      loader.load(httpRequest);
    } else {
      // delay
      var delayedRequest = {
        httpRequest: httpRequest
      };
      delayedRequests.push(delayedRequest);
      delayedRequest.delayTimeout = setTimeout(function () {
        if (delayedRequests.indexOf(delayedRequest) === -1) {
          return;
        } else {
          delayedRequests.splice(delayedRequests.indexOf(delayedRequest), 1);
        }

        try {
          requestStartTime = new Date();
          lastTraceTime = requestStartTime;
          requests.push(delayedRequest.httpRequest);
          loader.load(delayedRequest.httpRequest);
        } catch (e) {
          delayedRequest.httpRequest.onerror();
        }
      }, request.delayLoadingTime - now);
    }
  }

  function _getAdditionalQueryParameter(request) {
    try {
      var additionalQueryParameter = [];
      var cmcdQueryParameter = cmcdModel.getQueryParameter(request);

      if (cmcdQueryParameter) {
        additionalQueryParameter.push(cmcdQueryParameter);
      }

      return additionalQueryParameter;
    } catch (e) {
      return [];
    }
  }
  /**
   * Initiates a download of the resource described by config.request
   * @param {Object} config - contains request (FragmentRequest or derived type), and callbacks
   * @memberof module:HTTPLoader
   * @instance
   */


  function load(config) {
    if (config.request) {
      internalLoad(config, mediaPlayerModel.getRetryAttemptsForType(config.request.type));
    } else {
      if (config.error) {
        config.error(config.request, 'error');
      }
    }
  }
  /**
   * Aborts any inflight downloads
   * @memberof module:HTTPLoader
   * @instance
   */


  function abort() {
    retryRequests.forEach(function (t) {
      clearTimeout(t.timeout); // abort request in order to trigger LOADING_ABANDONED event

      if (t.config.request && t.config.abort) {
        t.config.abort(t.config.request);
      }
    });
    retryRequests = [];
    delayedRequests.forEach(function (x) {
      return clearTimeout(x.delayTimeout);
    });
    delayedRequests = [];
    requests.forEach(function (x) {
      // MSS patch: ignore FragmentInfo requests
      if (x.request.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE) {
        return;
      } // abort will trigger onloadend which we don't want
      // when deliberately aborting inflight requests -
      // set them to undefined so they are not called


      x.onloadend = x.onerror = x.onprogress = undefined;
      x.loader.abort(x);
    });
    requests = [];
  }

  instance = {
    load: load,
    abort: abort
  };
  setup();
  return instance;
}

HTTPLoader.__dashjs_factory_name = 'HTTPLoader';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_3__["default"].getClassFactory(HTTPLoader);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/net/SchemeLoaderFactory.js":
/*!**************************************************!*\
  !*** ./src/streaming/net/SchemeLoaderFactory.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1972397__) {

"use strict";
__nested_webpack_require_1972397__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1972397__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_net_HTTPLoader__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1972397__(/*! ../../streaming/net/HTTPLoader */ "./src/streaming/net/HTTPLoader.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * @module
 * @description Choose right url loader for scheme
 * @ignore
 */

function SchemeLoaderFactory() {
  var instance;
  var schemeLoaderMap;

  function registerLoader(scheme, loader) {
    schemeLoaderMap[scheme] = loader;
  }

  function unregisterLoader(scheme) {
    if (schemeLoaderMap[scheme]) {
      delete schemeLoaderMap[scheme];
    }
  }

  function unregisterAllLoader() {
    schemeLoaderMap = {};
  }

  function getLoader(url) {
    // iterates through schemeLoaderMap to find a loader for the scheme
    for (var scheme in schemeLoaderMap) {
      if (schemeLoaderMap.hasOwnProperty(scheme) && url.startsWith(scheme)) {
        return schemeLoaderMap[scheme];
      }
    }

    return _streaming_net_HTTPLoader__WEBPACK_IMPORTED_MODULE_1__["default"];
  }

  function reset() {
    unregisterAllLoader();
  }

  function setup() {
    reset();
  }

  setup();
  instance = {
    getLoader: getLoader,
    registerLoader: registerLoader,
    unregisterLoader: unregisterLoader,
    unregisterAllLoader: unregisterAllLoader,
    reset: reset
  };
  return instance;
}

SchemeLoaderFactory.__dashjs_factory_name = 'SchemeLoaderFactory';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(SchemeLoaderFactory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/net/URLLoader.js":
/*!****************************************!*\
  !*** ./src/streaming/net/URLLoader.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1976375__) {

"use strict";
__nested_webpack_require_1976375__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1976375__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _streaming_net_SchemeLoaderFactory__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1976375__(/*! ../../streaming/net/SchemeLoaderFactory */ "./src/streaming/net/SchemeLoaderFactory.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * @class URLLoader
 * @description  Call Offline Loader or Online Loader depending on URL
 * @param {Object} cfg - dependencies
 * @ignore
*/

function URLLoader(cfg) {
  cfg = cfg || {};
  var context = this.context;
  var instance, schemeLoaderFactory, loader;
  schemeLoaderFactory = Object(_streaming_net_SchemeLoaderFactory__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();

  function load(config) {
    if (!loader) {
      var loaderFactory = schemeLoaderFactory.getLoader(config && config.request ? config.request.url : null);
      loader = loaderFactory(context).create({
        errHandler: cfg.errHandler,
        mediaPlayerModel: cfg.mediaPlayerModel,
        requestModifier: cfg.requestModifier,
        dashMetrics: cfg.dashMetrics,
        boxParser: cfg.boxParser ? cfg.boxParser : null,
        constants: cfg.constants ? cfg.constants : null,
        dashConstants: cfg.dashConstants ? cfg.dashConstants : null,
        urlUtils: cfg.urlUtils ? cfg.urlUtils : null,
        requestTimeout: !isNaN(cfg.requestTimeout) ? cfg.requestTimeout : 0,
        errors: cfg.errors
      });
    }

    loader.load(config);
  }

  function abort() {
    if (loader) {
      loader.abort();
    }
  }

  instance = {
    load: load,
    abort: abort
  };
  return instance;
}

URLLoader.__dashjs_factory_name = 'URLLoader';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(URLLoader);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/net/XHRLoader.js":
/*!****************************************!*\
  !*** ./src/streaming/net/XHRLoader.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1980546__) {

"use strict";
__nested_webpack_require_1980546__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1980546__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module XHRLoader
 * @ignore
 * @description Manages download of resources via HTTP.
 * @param {Object} cfg - dependencies from parent
 */

function XHRLoader(cfg) {
  cfg = cfg || {};
  var requestModifier = cfg.requestModifier;
  var instance;

  function load(httpRequest) {
    // Variables will be used in the callback functions
    var requestStartTime = new Date();
    var request = httpRequest.request;
    var xhr = new XMLHttpRequest();
    xhr.open(httpRequest.method, httpRequest.url, true);

    if (request.responseType) {
      xhr.responseType = request.responseType;
    }

    if (request.range) {
      xhr.setRequestHeader('Range', 'bytes=' + request.range);
    }

    if (!request.requestStartDate) {
      request.requestStartDate = requestStartTime;
    }

    if (requestModifier) {
      xhr = requestModifier.modifyRequestHeader(xhr);
    }

    if (httpRequest.headers) {
      for (var header in httpRequest.headers) {
        var value = httpRequest.headers[header];

        if (value) {
          xhr.setRequestHeader(header, value);
        }
      }
    }

    xhr.withCredentials = httpRequest.withCredentials;
    xhr.onload = httpRequest.onload;
    xhr.onloadend = httpRequest.onend;
    xhr.onerror = httpRequest.onerror;
    xhr.onprogress = httpRequest.progress;
    xhr.onabort = httpRequest.onabort;
    xhr.ontimeout = httpRequest.ontimeout;
    xhr.timeout = httpRequest.timeout;
    xhr.send();
    httpRequest.response = xhr;
  }

  function abort(request) {
    var x = request.response;
    x.onloadend = x.onerror = x.onprogress = undefined; //Ignore events from aborted requests.

    x.abort();
  }

  instance = {
    load: load,
    abort: abort
  };
  return instance;
}

XHRLoader.__dashjs_factory_name = 'XHRLoader';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(XHRLoader);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/protection/CommonEncryption.js":
/*!******************************************************!*\
  !*** ./src/streaming/protection/CommonEncryption.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1985019__) {

"use strict";
__nested_webpack_require_1985019__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
var LICENSE_SERVER_MANIFEST_CONFIGURATIONS = {
  attributes: ['Laurl', 'laurl'],
  prefixes: ['clearkey', 'dashif']
};
/**
 * @class
 * @ignore
 */

var CommonEncryption = /*#__PURE__*/function () {
  function CommonEncryption() {
    _classCallCheck(this, CommonEncryption);
  }

  _createClass(CommonEncryption, null, [{
    key: "findCencContentProtection",
    value:
    /**
     * Find and return the ContentProtection element in the given array
     * that indicates support for MPEG Common Encryption
     *
     * @param {Array} cpArray array of content protection elements
     * @returns {Object|null} the Common Encryption content protection element or
     * null if one was not found
     */
    function findCencContentProtection(cpArray) {
      var retVal = null;

      for (var i = 0; i < cpArray.length; ++i) {
        var cp = cpArray[i];
        if (cp.schemeIdUri.toLowerCase() === 'urn:mpeg:dash:mp4protection:2011' && (cp.value.toLowerCase() === 'cenc' || cp.value.toLowerCase() === 'cbcs')) retVal = cp;
      }

      return retVal;
    }
    /**
     * Returns just the data portion of a single PSSH
     *
     * @param {ArrayBuffer} pssh - the PSSH
     * @return {ArrayBuffer} data portion of the PSSH
     */

  }, {
    key: "getPSSHData",
    value: function getPSSHData(pssh) {
      var offset = 8; // Box size and type fields

      var view = new DataView(pssh); // Read version

      var version = view.getUint8(offset);
      offset += 20; // Version (1), flags (3), system ID (16)

      if (version > 0) {
        offset += 4 + 16 * view.getUint32(offset); // Key ID count (4) and All key IDs (16*count)
      }

      offset += 4; // Data size

      return pssh.slice(offset);
    }
    /**
     * Returns the PSSH associated with the given key system from the concatenated
     * list of PSSH boxes in the given initData
     *
     * @param {KeySystem} keySystem the desired
     * key system
     * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
     * @returns {ArrayBuffer|null} The PSSH box data corresponding to the given key system, null if not found
     * or null if a valid association could not be found.
     */

  }, {
    key: "getPSSHForKeySystem",
    value: function getPSSHForKeySystem(keySystem, initData) {
      var psshList = CommonEncryption.parsePSSHList(initData);

      if (keySystem && psshList.hasOwnProperty(keySystem.uuid.toLowerCase())) {
        return psshList[keySystem.uuid.toLowerCase()];
      }

      return null;
    }
    /**
     * Parse a standard common encryption PSSH which contains a simple
     * base64-encoding of the init data
     *
     * @param {Object} cpData the ContentProtection element
     * @param {BASE64} BASE64 reference
     * @returns {ArrayBuffer|null} the init data or null if not found
     */

  }, {
    key: "parseInitDataFromContentProtection",
    value: function parseInitDataFromContentProtection(cpData, BASE64) {
      if ('pssh' in cpData) {
        // Remove whitespaces and newlines from pssh text
        cpData.pssh.__text = cpData.pssh.__text.replace(/\r?\n|\r/g, '').replace(/\s+/g, '');
        return BASE64.decodeArray(cpData.pssh.__text).buffer;
      }

      return null;
    }
    /**
     * Parses list of PSSH boxes into keysystem-specific PSSH data
     *
     * @param {ArrayBuffer} data - the concatenated list of PSSH boxes as provided by
     * CDM as initialization data when CommonEncryption content is detected
     * @returns {Object|Array} an object that has a property named according to each of
     * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
     * and a ArrayBuffer (the entire PSSH box) as the property value
     */

  }, {
    key: "parsePSSHList",
    value: function parsePSSHList(data) {
      if (data === null || data === undefined) return [];
      var dv = new DataView(data.buffer || data); // data.buffer first for Uint8Array support

      var done = false;
      var pssh = {}; // TODO: Need to check every data read for end of buffer

      var byteCursor = 0;

      while (!done) {
        var size = void 0,
            nextBox = void 0,
            version = void 0,
            systemID = void 0;
        var boxStart = byteCursor;
        if (byteCursor >= dv.buffer.byteLength) break;
        /* Box size */

        size = dv.getUint32(byteCursor);
        nextBox = byteCursor + size;
        byteCursor += 4;
        /* Verify PSSH */

        if (dv.getUint32(byteCursor) !== 0x70737368) {
          byteCursor = nextBox;
          continue;
        }

        byteCursor += 4;
        /* Version must be 0 or 1 */

        version = dv.getUint8(byteCursor);

        if (version !== 0 && version !== 1) {
          byteCursor = nextBox;
          continue;
        }

        byteCursor++;
        byteCursor += 3;
        /* skip flags */
        // 16-byte UUID/SystemID

        systemID = '';
        var i = void 0,
            val = void 0;

        for (i = 0; i < 4; i++) {
          val = dv.getUint8(byteCursor + i).toString(16);
          systemID += val.length === 1 ? '0' + val : val;
        }

        byteCursor += 4;
        systemID += '-';

        for (i = 0; i < 2; i++) {
          val = dv.getUint8(byteCursor + i).toString(16);
          systemID += val.length === 1 ? '0' + val : val;
        }

        byteCursor += 2;
        systemID += '-';

        for (i = 0; i < 2; i++) {
          val = dv.getUint8(byteCursor + i).toString(16);
          systemID += val.length === 1 ? '0' + val : val;
        }

        byteCursor += 2;
        systemID += '-';

        for (i = 0; i < 2; i++) {
          val = dv.getUint8(byteCursor + i).toString(16);
          systemID += val.length === 1 ? '0' + val : val;
        }

        byteCursor += 2;
        systemID += '-';

        for (i = 0; i < 6; i++) {
          val = dv.getUint8(byteCursor + i).toString(16);
          systemID += val.length === 1 ? '0' + val : val;
        }

        byteCursor += 6;
        systemID = systemID.toLowerCase();
        /* PSSH Data Size */

        byteCursor += 4;
        /* PSSH Data */

        pssh[systemID] = dv.buffer.slice(boxStart, nextBox);
        byteCursor = nextBox;
      }

      return pssh;
    }
  }, {
    key: "getLicenseServerUrlFromMediaInfo",
    value: function getLicenseServerUrlFromMediaInfo(mediaInfo, schemeIdUri) {
      try {
        if (!mediaInfo || mediaInfo.length === 0) {
          return null;
        }

        var i = 0;
        var licenseServer = null;

        while (i < mediaInfo.length && !licenseServer) {
          var info = mediaInfo[i];

          if (info && info.contentProtection && info.contentProtection.length > 0) {
            var targetProtectionData = info.contentProtection.filter(function (cp) {
              return cp.schemeIdUri && cp.schemeIdUri === schemeIdUri;
            });

            if (targetProtectionData && targetProtectionData.length > 0) {
              var j = 0;

              while (j < targetProtectionData.length && !licenseServer) {
                var ckData = targetProtectionData[j];
                var k = 0;

                while (k < LICENSE_SERVER_MANIFEST_CONFIGURATIONS.attributes.length && !licenseServer) {
                  var l = 0;
                  var attribute = LICENSE_SERVER_MANIFEST_CONFIGURATIONS.attributes[k];

                  while (l < LICENSE_SERVER_MANIFEST_CONFIGURATIONS.prefixes.length && !licenseServer) {
                    var prefix = LICENSE_SERVER_MANIFEST_CONFIGURATIONS.prefixes[l];

                    if (ckData[attribute] && ckData[attribute].__prefix && ckData[attribute].__prefix === prefix && ckData[attribute].__text) {
                      licenseServer = ckData[attribute].__text;
                    }

                    l += 1;
                  }

                  k += 1;
                }

                j += 1;
              }
            }
          }

          i += 1;
        }

        return licenseServer;
      } catch (e) {
        return null;
      }
    }
  }]);

  return CommonEncryption;
}();

/* harmony default export */ __webpack_exports__["default"] = (CommonEncryption);

/***/ }),

/***/ "./src/streaming/protection/Protection.js":
/*!************************************************!*\
  !*** ./src/streaming/protection/Protection.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_1996464__) {

"use strict";
__nested_webpack_require_1996464__.r(__webpack_exports__);
/* harmony import */ var _controllers_ProtectionController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_1996464__(/*! ./controllers/ProtectionController */ "./src/streaming/protection/controllers/ProtectionController.js");
/* harmony import */ var _controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_1996464__(/*! ./controllers/ProtectionKeyController */ "./src/streaming/protection/controllers/ProtectionKeyController.js");
/* harmony import */ var _ProtectionEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_1996464__(/*! ./ProtectionEvents */ "./src/streaming/protection/ProtectionEvents.js");
/* harmony import */ var _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_1996464__(/*! ./errors/ProtectionErrors */ "./src/streaming/protection/errors/ProtectionErrors.js");
/* harmony import */ var _models_ProtectionModel_21Jan2015__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_1996464__(/*! ./models/ProtectionModel_21Jan2015 */ "./src/streaming/protection/models/ProtectionModel_21Jan2015.js");
/* harmony import */ var _models_ProtectionModel_3Feb2014__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_1996464__(/*! ./models/ProtectionModel_3Feb2014 */ "./src/streaming/protection/models/ProtectionModel_3Feb2014.js");
/* harmony import */ var _models_ProtectionModel_01b__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_1996464__(/*! ./models/ProtectionModel_01b */ "./src/streaming/protection/models/ProtectionModel_01b.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







var APIS_ProtectionModel_01b = [// Un-prefixed as per spec
{
  // Video Element
  generateKeyRequest: 'generateKeyRequest',
  addKey: 'addKey',
  cancelKeyRequest: 'cancelKeyRequest',
  // Events
  needkey: 'needkey',
  keyerror: 'keyerror',
  keyadded: 'keyadded',
  keymessage: 'keymessage'
}, // Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
{
  // Video Element
  generateKeyRequest: 'webkitGenerateKeyRequest',
  addKey: 'webkitAddKey',
  cancelKeyRequest: 'webkitCancelKeyRequest',
  // Events
  needkey: 'webkitneedkey',
  keyerror: 'webkitkeyerror',
  keyadded: 'webkitkeyadded',
  keymessage: 'webkitkeymessage'
}];
var APIS_ProtectionModel_3Feb2014 = [// Un-prefixed as per spec
// Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
{
  // Video Element
  setMediaKeys: 'setMediaKeys',
  // MediaKeys
  MediaKeys: 'MediaKeys',
  // MediaKeySession
  release: 'close',
  // Events
  needkey: 'needkey',
  error: 'keyerror',
  message: 'keymessage',
  ready: 'keyadded',
  close: 'keyclose'
}, // MS-prefixed (IE11, Windows 8.1)
{
  // Video Element
  setMediaKeys: 'msSetMediaKeys',
  // MediaKeys
  MediaKeys: 'MSMediaKeys',
  // MediaKeySession
  release: 'close',
  // Events
  needkey: 'msneedkey',
  error: 'mskeyerror',
  message: 'mskeymessage',
  ready: 'mskeyadded',
  close: 'mskeyclose'
}];

function Protection() {
  var instance;
  var context = this.context;
  /**
   * Create a ProtectionController and associated ProtectionModel for use with
   * a single piece of content.
   *
   * @param {Object} config
   * @return {ProtectionController} protection controller
   *
   */

  function createProtectionSystem(config) {
    var controller = null;
    var protectionKeyController = Object(_controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
    protectionKeyController.setConfig({
      debug: config.debug,
      BASE64: config.BASE64,
      settings: config.settings
    });
    protectionKeyController.initialize();

    var protectionModel = _getProtectionModel(config);

    if (!controller && protectionModel) {
      //TODO add ability to set external controller if still needed at all?
      controller = Object(_controllers_ProtectionController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
        protectionModel: protectionModel,
        protectionKeyController: protectionKeyController,
        eventBus: config.eventBus,
        debug: config.debug,
        events: config.events,
        BASE64: config.BASE64,
        constants: config.constants,
        cmcdModel: config.cmcdModel,
        customParametersModel: config.customParametersModel,
        settings: config.settings
      });
      config.capabilities.setEncryptedMediaSupported(true);
    }

    return controller;
  }

  function _getProtectionModel(config) {
    var debug = config.debug;
    var logger = debug.getLogger(instance);
    var eventBus = config.eventBus;
    var errHandler = config.errHandler;
    var videoElement = config.videoModel ? config.videoModel.getElement() : null;

    if ((!videoElement || videoElement.onencrypted !== undefined) && (!videoElement || videoElement.mediaKeys !== undefined)) {
      logger.info('EME detected on this user agent! (ProtectionModel_21Jan2015)');
      return Object(_models_ProtectionModel_21Jan2015__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
        debug: debug,
        eventBus: eventBus,
        events: config.events
      });
    } else if (_getAPI(videoElement, APIS_ProtectionModel_3Feb2014)) {
      logger.info('EME detected on this user agent! (ProtectionModel_3Feb2014)');
      return Object(_models_ProtectionModel_3Feb2014__WEBPACK_IMPORTED_MODULE_5__["default"])(context).create({
        debug: debug,
        eventBus: eventBus,
        events: config.events,
        api: _getAPI(videoElement, APIS_ProtectionModel_3Feb2014)
      });
    } else if (_getAPI(videoElement, APIS_ProtectionModel_01b)) {
      logger.info('EME detected on this user agent! (ProtectionModel_01b)');
      return Object(_models_ProtectionModel_01b__WEBPACK_IMPORTED_MODULE_6__["default"])(context).create({
        debug: debug,
        eventBus: eventBus,
        errHandler: errHandler,
        events: config.events,
        api: _getAPI(videoElement, APIS_ProtectionModel_01b)
      });
    } else {
      logger.warn('No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!');
      return null;
    }
  }

  function _getAPI(videoElement, apis) {
    for (var i = 0; i < apis.length; i++) {
      var api = apis[i]; // detect if api is supported by browser
      // check only first function in api -> should be fine

      if (typeof videoElement[api[Object.keys(api)[0]]] !== 'function') {
        continue;
      }

      return api;
    }

    return null;
  }

  instance = {
    createProtectionSystem: createProtectionSystem
  };
  return instance;
}

Protection.__dashjs_factory_name = 'Protection';
var factory = dashjs.FactoryMaker.getClassFactory(Protection);
/* jshint ignore:line */

factory.events = _ProtectionEvents__WEBPACK_IMPORTED_MODULE_2__["default"];
factory.errors = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"];
dashjs.FactoryMaker.updateClassFactory(Protection.__dashjs_factory_name, factory);
/* jshint ignore:line */

/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/protection/ProtectionEvents.js":
/*!******************************************************!*\
  !*** ./src/streaming/protection/ProtectionEvents.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2005902__) {

"use strict";
__nested_webpack_require_2005902__.r(__webpack_exports__);
/* harmony import */ var _core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2005902__(/*! ../../core/events/EventsBase */ "./src/core/events/EventsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
  */

var ProtectionEvents = /*#__PURE__*/function (_EventsBase) {
  _inherits(ProtectionEvents, _EventsBase);

  var _super = _createSuper(ProtectionEvents);

  /**
   * @description Public facing external events to be used when including protection package.
   * All public events will be aggregated into the MediaPlayerEvents Class and can be accessed
   * via MediaPlayer.events.  public_ is the prefix that we use to move event names to MediaPlayerEvents.
   */
  function ProtectionEvents() {
    var _this;

    _classCallCheck(this, ProtectionEvents);

    _this = _super.call(this);
    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     *
     * @ignore
     */

    _this.INTERNAL_KEY_MESSAGE = 'internalKeyMessage';
    /**
     * Event ID for events delivered when the status of one decryption keys has changed
     * @ignore
     */

    _this.INTERNAL_KEY_STATUS_CHANGED = 'internalkeyStatusChanged';
    /**
     * Event ID for events delivered when a new key has been added
     *
     * @constant
     * @deprecated The latest versions of the EME specification no longer
     * use this event.  {@MediaPlayer.models.protectionModel.eventList.KEY_STATUSES_CHANGED}
     * is preferred.
     * @event ProtectionEvents#KEY_ADDED
     */

    _this.KEY_ADDED = 'public_keyAdded';
    /**
     * Event ID for events delivered when an error is encountered by the CDM
     * while processing a license server response message
     * @event ProtectionEvents#KEY_ERROR
     */

    _this.KEY_ERROR = 'public_keyError';
    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     * @event ProtectionEvents#KEY_MESSAGE
     */

    _this.KEY_MESSAGE = 'public_keyMessage';
    /**
     * Event ID for events delivered when a key session close
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_CLOSED
     */

    _this.KEY_SESSION_CLOSED = 'public_keySessionClosed';
    /**
     * Event ID for events delivered when a new key sessions creation
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_CREATED
     */

    _this.KEY_SESSION_CREATED = 'public_keySessionCreated';
    /**
     * Event ID for events delivered when a key session removal
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_REMOVED
     */

    _this.KEY_SESSION_REMOVED = 'public_keySessionRemoved';
    /**
     * Event ID for events delivered when the status of one or more
     * decryption keys has changed
     * @event ProtectionEvents#KEY_STATUSES_CHANGED
     */

    _this.KEY_STATUSES_CHANGED = 'public_keyStatusesChanged';
    /**
     * Event ID for events delivered when a key system access procedure
     * has completed
     * @ignore
     */

    _this.KEY_SYSTEM_ACCESS_COMPLETE = 'public_keySystemAccessComplete';
    /**
     * Event ID for events delivered when a key system selection procedure
     * completes
     * @event ProtectionEvents#KEY_SYSTEM_SELECTED
     */

    _this.KEY_SYSTEM_SELECTED = 'public_keySystemSelected';
    /**
     * Event ID for events delivered when a license request procedure
     * has completed
     * @event ProtectionEvents#LICENSE_REQUEST_COMPLETE
     */

    _this.LICENSE_REQUEST_COMPLETE = 'public_licenseRequestComplete';
    /**
     * Sending a license rquest
     * @event ProtectionEvents#LICENSE_REQUEST_SENDING
     */

    _this.LICENSE_REQUEST_SENDING = 'public_licenseRequestSending';
    /**
     * Event ID for needkey/encrypted events
     * @ignore
     */

    _this.NEED_KEY = 'needkey';
    /**
     * Event ID for events delivered when the Protection system is detected and created.
     * @event ProtectionEvents#PROTECTION_CREATED
     */

    _this.PROTECTION_CREATED = 'public_protectioncreated';
    /**
     * Event ID for events delivered when the Protection system is destroyed.
     * @event ProtectionEvents#PROTECTION_DESTROYED
     */

    _this.PROTECTION_DESTROYED = 'public_protectiondestroyed';
    /**
     * Event ID for events delivered when a new server certificate has
     * been delivered to the CDM
     * @ignore
     */

    _this.SERVER_CERTIFICATE_UPDATED = 'serverCertificateUpdated';
    /**
     * Event ID for events delivered when the process of shutting down
     * a protection set has completed
     * @ignore
     */

    _this.TEARDOWN_COMPLETE = 'protectionTeardownComplete';
    /**
     * Event ID for events delivered when a HTMLMediaElement has been
     * associated with the protection set
     * @ignore
     */

    _this.VIDEO_ELEMENT_SELECTED = 'videoElementSelected';
    /**
     * Triggered when the key session has been updated successfully
     * @ignore
     */

    _this.KEY_SESSION_UPDATED = 'public_keySessionUpdated';
    return _this;
  }

  return ProtectionEvents;
}(_core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var protectionEvents = new ProtectionEvents();
/* harmony default export */ __webpack_exports__["default"] = (protectionEvents);

/***/ }),

/***/ "./src/streaming/protection/controllers/ProtectionController.js":
/*!**********************************************************************!*\
  !*** ./src/streaming/protection/controllers/ProtectionController.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2016099__) {

"use strict";
__nested_webpack_require_2016099__.r(__webpack_exports__);
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2016099__(/*! ../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _vo_MediaCapability__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2016099__(/*! ../vo/MediaCapability */ "./src/streaming/protection/vo/MediaCapability.js");
/* harmony import */ var _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2016099__(/*! ../vo/KeySystemConfiguration */ "./src/streaming/protection/vo/KeySystemConfiguration.js");
/* harmony import */ var _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2016099__(/*! ../errors/ProtectionErrors */ "./src/streaming/protection/errors/ProtectionErrors.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2016099__(/*! ../../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _vo_LicenseRequest__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2016099__(/*! ../vo/LicenseRequest */ "./src/streaming/protection/vo/LicenseRequest.js");
/* harmony import */ var _vo_LicenseResponse__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2016099__(/*! ../vo/LicenseResponse */ "./src/streaming/protection/vo/LicenseResponse.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2016099__(/*! ../../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_Utils__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2016099__(/*! ../../../core/Utils */ "./src/core/Utils.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2016099__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_2016099__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */











var NEEDKEY_BEFORE_INITIALIZE_RETRIES = 5;
var NEEDKEY_BEFORE_INITIALIZE_TIMEOUT = 500;
var LICENSE_SERVER_REQUEST_RETRIES = 3;
var LICENSE_SERVER_REQUEST_RETRY_INTERVAL = 1000;
var LICENSE_SERVER_REQUEST_DEFAULT_TIMEOUT = 8000;
/**
 * @module ProtectionController
 * @description Provides access to media protection information and functionality.  Each
 * ProtectionController manages a single {@link MediaPlayer.models.ProtectionModel}
 * which encapsulates a set of protection information (EME APIs, selected key system,
 * key sessions).  The APIs of ProtectionController mostly align with the latest EME
 * APIs.  Key system selection is mostly automated when combined with app-overrideable
 * functionality provided in {@link ProtectionKeyController}.
 * @todo ProtectionController does almost all of its tasks automatically after init() is
 * called.  Applications might want more control over this process and want to go through
 * each step manually (key system selection, session creation, session maintenance).
 * This module can be accessed using the MediaPlayer API getProtectionController()
 * @param {Object} config
 */

function ProtectionController(config) {
  config = config || {};
  var protectionKeyController = config.protectionKeyController;
  var protectionModel = config.protectionModel;
  var eventBus = config.eventBus;
  var events = config.events;
  var debug = config.debug;
  var BASE64 = config.BASE64;
  var constants = config.constants;
  var needkeyRetries = [];
  var cmcdModel = config.cmcdModel;
  var settings = config.settings;
  var customParametersModel = config.customParametersModel;
  var instance, logger, pendingKeySystemData, mediaInfoArr, protDataSet, sessionType, robustnessLevel, selectedKeySystem, keySystemSelectionInProgress, licenseXhrRequest, licenseRequestRetryTimeout;

  function setup() {
    logger = debug.getLogger(instance);
    pendingKeySystemData = [];
    mediaInfoArr = [];
    sessionType = 'temporary';
    robustnessLevel = '';
    licenseXhrRequest = null;
    licenseRequestRetryTimeout = null;
    eventBus.on(events.INTERNAL_KEY_MESSAGE, _onKeyMessage, instance);
    eventBus.on(events.INTERNAL_KEY_STATUS_CHANGED, _onKeyStatusChanged, instance);
  }

  function checkConfig() {
    if (!eventBus || !eventBus.hasOwnProperty('on') || !protectionKeyController || !protectionKeyController.hasOwnProperty('getSupportedKeySystemsFromContentProtection')) {
      throw new Error('Missing config parameter(s)');
    }
  }
  /**
   * Initialize this protection system for a given media type.
   *
   * @param {StreamInfo} [mediaInfo] Media information
   * @memberof module:ProtectionController
   * @instance
   */


  function initializeForMedia(mediaInfo) {
    // Not checking here if a session for similar KS/KID combination is already created
    // because still don't know which keysystem will be selected.
    // Once Keysystem is selected and before creating the session, we will do that check
    // so we create the strictly necessary DRM sessions
    if (!mediaInfo) {
      throw new Error('mediaInfo can not be null or undefined');
    }

    checkConfig();
    mediaInfoArr.push(mediaInfo); // ContentProtection elements are specified at the AdaptationSet level, so the CP for audio
    // and video will be the same. Just use one valid MediaInfo object

    var supportedKS = protectionKeyController.getSupportedKeySystemsFromContentProtection(mediaInfo.contentProtection, protDataSet, sessionType);

    if (supportedKS && supportedKS.length > 0) {
      _selectKeySystem(supportedKS, true);
    }
  }
  /**
   * Selects a key system if we dont have any one yet. Otherwise we use the existing key system and trigger a new license request if the initdata has changed
   * @param {array} supportedKS
   * @param {boolean} fromManifest
   * @private
   */


  function _selectKeySystem(supportedKS, fromManifest) {
    // We are in the process of selecting a key system, so just save the data which might be coming from additional AdaptationSets.
    if (keySystemSelectionInProgress) {
      pendingKeySystemData.push(supportedKS);
    } // First time, so we need to select a key system
    else if (!selectedKeySystem) {
        _selectInitialKeySystem(supportedKS, fromManifest);
      } // We already selected a key system. We only need to trigger a new license exchange if the init data has changed
      else if (selectedKeySystem) {
          _initiateWithExistingKeySystem(supportedKS);
        }
  }
  /**
   * We do not have a key system yet. Select one
   * @param {array} supportedKS
   * @param {boolean} fromManifest
   * @private
   */


  function _selectInitialKeySystem(supportedKS, fromManifest) {
    keySystemSelectionInProgress = true;
    var requestedKeySystems = []; // Reorder key systems according to priority order provided in protectionData

    supportedKS = supportedKS.sort(function (ksA, ksB) {
      var indexA = protDataSet && protDataSet[ksA.ks.systemString] && protDataSet[ksA.ks.systemString].priority >= 0 ? protDataSet[ksA.ks.systemString].priority : supportedKS.length;
      var indexB = protDataSet && protDataSet[ksB.ks.systemString] && protDataSet[ksB.ks.systemString].priority >= 0 ? protDataSet[ksB.ks.systemString].priority : supportedKS.length;
      return indexA - indexB;
    });
    pendingKeySystemData.push(supportedKS); // Add all key systems to our request list since we have yet to select a key system

    for (var i = 0; i < supportedKS.length; i++) {
      var keySystemConfiguration = _getKeySystemConfiguration(supportedKS[i]);

      requestedKeySystems.push({
        ks: supportedKS[i].ks,
        configs: [keySystemConfiguration],
        protData: supportedKS[i].protData
      });
    }

    var keySystemAccess;
    protectionModel.requestKeySystemAccess(requestedKeySystems).then(function (event) {
      keySystemAccess = event.data;
      var selectedSystemString = keySystemAccess.mksa && keySystemAccess.mksa.selectedSystemString ? keySystemAccess.mksa.selectedSystemString : keySystemAccess.keySystem.systemString;
      logger.info('DRM: KeySystem Access Granted for system string (' + selectedSystemString + ')!  Selecting key system...');
      return protectionModel.selectKeySystem(keySystemAccess);
    }).then(function (keySystem) {
      selectedKeySystem = keySystem;
      keySystemSelectionInProgress = false;

      if (!protectionModel) {
        return;
      }

      eventBus.trigger(events.KEY_SYSTEM_SELECTED, {
        data: keySystemAccess
      }); // Set server certificate from protData

      var protData = _getProtDataForKeySystem(selectedKeySystem);

      if (protData && protData.serverCertificate && protData.serverCertificate.length > 0) {
        protectionModel.setServerCertificate(BASE64.decodeArray(protData.serverCertificate).buffer);
      } // Create key sessions for the different AdaptationSets


      var ksIdx;

      for (var _i = 0; _i < pendingKeySystemData.length; _i++) {
        for (ksIdx = 0; ksIdx < pendingKeySystemData[_i].length; ksIdx++) {
          if (selectedKeySystem === pendingKeySystemData[_i][ksIdx].ks) {
            var current = pendingKeySystemData[_i][ksIdx];

            _loadOrCreateKeySession(current);

            break;
          }
        }
      }
    })["catch"](function (event) {
      selectedKeySystem = null;
      keySystemSelectionInProgress = false;

      if (!fromManifest) {
        eventBus.trigger(events.KEY_SYSTEM_SELECTED, {
          data: null,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE + 'Error selecting key system! -- ' + event.error)
        });
      }
    });
  }
  /**
   * If we have already selected a keysytem we only need to create a new key session and issue a new license request if the init data has changed.
   * @param {array} supportedKS
   * @private
   */


  function _initiateWithExistingKeySystem(supportedKS) {
    var ksIdx = supportedKS.findIndex(function (entry) {
      return entry.ks === selectedKeySystem;
    });
    var current = supportedKS[ksIdx];

    if (ksIdx === -1 || !current.initData) {
      return;
    }

    _loadOrCreateKeySession(current);
  }
  /**
   * Loads an existing key session if we already have a session id. Otherwise we create a new key session
   * @param {object} keySystemInfo
   * @private
   */


  function _loadOrCreateKeySession(keySystemInfo) {
    // Clearkey
    if (protectionKeyController.isClearKey(selectedKeySystem)) {
      // For Clearkey: if parameters for generating init data was provided by the user, use them for generating
      // initData and overwrite possible initData indicated in encrypted event (EME)
      if (keySystemInfo.protData && keySystemInfo.protData.hasOwnProperty('clearkeys') && Object.keys(keySystemInfo.protData.clearkeys).length !== 0) {
        var initData = {
          kids: Object.keys(keySystemInfo.protData.clearkeys)
        };
        keySystemInfo.initData = new TextEncoder().encode(JSON.stringify(initData));
      }
    } // Reuse existing KeySession


    if (keySystemInfo.sessionId) {
      // Load MediaKeySession with sessionId
      loadKeySession(keySystemInfo);
    } // Create a new KeySession
    else if (keySystemInfo.initData !== null) {
        // Create new MediaKeySession with initData
        createKeySession(keySystemInfo);
      }
  }
  /**
   * Loads a key session with the given session ID from persistent storage.  This essentially creates a new key session
   *
   * @param {object} ksInfo
   * @memberof module:ProtectionController
   * @instance
   * @fires ProtectionController#KeySessionCreated
   * @ignore
   */


  function loadKeySession(keySystemInfo) {
    checkConfig();
    protectionModel.loadKeySession(keySystemInfo);
  }
  /**
   * Create a new key session associated with the given initialization data from the MPD or from the PSSH box in the media
   * For the latest version of the EME a request is generated. Once this request is ready we get notified via the INTERNAL_KEY_MESSAGE event
   * @param {ArrayBuffer} initData the initialization data
   * @param {Uint8Array} cdmData the custom data to provide to licenser
   * @memberof module:ProtectionController
   * @instance
   * @fires ProtectionController#KeySessionCreated
   * @ignore
   */


  function createKeySession(keySystemInfo) {
    var initDataForKS = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].getPSSHForKeySystem(selectedKeySystem, keySystemInfo ? keySystemInfo.initData : null);

    if (initDataForKS) {
      // Check for duplicate key id
      if (_isKeyIdDuplicate(keySystemInfo.keyId)) {
        return;
      } // Check for duplicate initData


      if (_isInitDataDuplicate(initDataForKS)) {
        return;
      }

      try {
        keySystemInfo.initData = initDataForKS;
        protectionModel.createKeySession(keySystemInfo);
      } catch (error) {
        eventBus.trigger(events.KEY_SESSION_CREATED, {
          data: null,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SESSION_CREATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SESSION_CREATED_ERROR_MESSAGE + error.message)
        });
      }
    } else if (keySystemInfo && keySystemInfo.initData) {
      protectionModel.createKeySession(keySystemInfo);
    } else {
      eventBus.trigger(events.KEY_SESSION_CREATED, {
        data: null,
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SESSION_CREATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].KEY_SESSION_CREATED_ERROR_MESSAGE + 'Selected key system is ' + (selectedKeySystem ? selectedKeySystem.systemString : null) + '.  needkey/encrypted event contains no initData corresponding to that key system!')
      });
    }
  }
  /**
   * Returns the protectionData for a specific keysystem as specified by the application.
   * @param {object} keySystem
   * @return {object | null}
   * @private
   */


  function _getProtDataForKeySystem(keySystem) {
    if (keySystem) {
      var keySystemString = keySystem.systemString;

      if (protDataSet) {
        return keySystemString in protDataSet ? protDataSet[keySystemString] : null;
      }
    }

    return null;
  }
  /**
   * Removes all entries from the mediaInfoArr
   */


  function clearMediaInfoArray() {
    mediaInfoArr = [];
  }
  /**
   * Returns a set of supported key systems and CENC initialization data
   * from the given array of ContentProtection elements.  Only
   * key systems that are supported by this player will be returned.
   * Key systems are returned in priority order (highest first).
   *
   * @param {Array.<Object>} cps - array of content protection elements parsed
   * from the manifest
   * @returns {Array.<Object>} array of objects indicating which supported key
   * systems were found.  Empty array is returned if no
   * supported key systems were found
   * @memberof module:ProtectionKeyController
   * @instance
   * @ignore
   */


  function getSupportedKeySystemsFromContentProtection(cps) {
    checkConfig();
    return protectionKeyController.getSupportedKeySystemsFromContentProtection(cps, protDataSet, sessionType);
  }
  /**
   * Checks if a session has already created for the provided key id
   * @param {string} keyId
   * @return {boolean}
   * @private
   */


  function _isKeyIdDuplicate(keyId) {
    if (!keyId) {
      return false;
    }

    try {
      var sessions = protectionModel.getSessions();

      for (var i = 0; i < sessions.length; i++) {
        if (sessions[i].getKeyId() === keyId) {
          return true;
        }
      }

      return false;
    } catch (e) {
      return false;
    }
  }
  /**
   * Checks if the provided init data is equal to one of the existing init data values
   * @param {any} initDataForKS
   * @return {boolean}
   * @private
   */


  function _isInitDataDuplicate(initDataForKS) {
    if (!initDataForKS) {
      return false;
    }

    try {
      var currentInitData = protectionModel.getAllInitData();

      for (var i = 0; i < currentInitData.length; i++) {
        if (protectionKeyController.initDataEquals(initDataForKS, currentInitData[i])) {
          logger.debug('DRM: Ignoring initData because we have already seen it!');
          return true;
        }
      }

      return false;
    } catch (e) {
      return false;
    }
  }
  /**
   * Removes the given key session from persistent storage and closes the session
   * as if {@link ProtectionController#closeKeySession}
   * was called
   *
   * @param {SessionToken} sessionToken the session
   * token
   * @memberof module:ProtectionController
   * @instance
   * @fires ProtectionController#KeySessionRemoved
   * @fires ProtectionController#KeySessionClosed
   * @ignore
   */


  function removeKeySession(sessionToken) {
    checkConfig();
    protectionModel.removeKeySession(sessionToken);
  }
  /**
   * Closes the key session and releases all associated decryption keys.  These
   * keys will no longer be available for decrypting media
   *
   * @param {SessionToken} sessionToken the session
   * token
   * @memberof module:ProtectionController
   * @instance
   * @fires ProtectionController#KeySessionClosed
   * @ignore
   */


  function closeKeySession(sessionToken) {
    checkConfig();
    protectionModel.closeKeySession(sessionToken);
  }
  /**
   * Sets a server certificate for use by the CDM when signing key messages
   * intended for a particular license server.  This will fire
   * an error event if a key system has not yet been selected.
   *
   * @param {ArrayBuffer} serverCertificate a CDM-specific license server
   * certificate
   * @memberof module:ProtectionController
   * @instance
   * @fires ProtectionController#ServerCertificateUpdated
   */


  function setServerCertificate(serverCertificate) {
    checkConfig();
    protectionModel.setServerCertificate(serverCertificate);
  }
  /**
   * Associate this protection system with the given HTMLMediaElement.  This
   * causes the system to register for needkey/encrypted events from the given
   * element and provides a destination for setting of MediaKeys
   *
   * @param {HTMLMediaElement} element the media element to which the protection
   * system should be associated
   * @memberof module:ProtectionController
   * @instance
   */


  function setMediaElement(element) {
    checkConfig();

    if (element) {
      protectionModel.setMediaElement(element);
      eventBus.on(events.NEED_KEY, _onNeedKey, instance);
    } else if (element === null) {
      protectionModel.setMediaElement(element);
      eventBus.off(events.NEED_KEY, _onNeedKey, instance);
    }
  }
  /**
   * Sets the session type to use when creating key sessions.  Either "temporary" or
   * "persistent-license".  Default is "temporary".
   *
   * @param {string} value the session type
   * @memberof module:ProtectionController
   * @instance
   */


  function setSessionType(value) {
    sessionType = value;
  }
  /**
   * Sets the robustness level for video and audio capabilities. Optional to remove Chrome warnings.
   * Possible values are SW_SECURE_CRYPTO, SW_SECURE_DECODE, HW_SECURE_CRYPTO, HW_SECURE_CRYPTO, HW_SECURE_DECODE, HW_SECURE_ALL.
   *
   * @param {string} level the robustness level
   * @memberof module:ProtectionController
   * @instance
   */


  function setRobustnessLevel(level) {
    robustnessLevel = level;
  }
  /**
   * Attach KeySystem-specific data to use for license acquisition with EME
   *
   * @param {Object} data an object containing property names corresponding to
   * key system name strings (e.g. "org.w3.clearkey") and associated values
   * being instances of {@link ProtectionData}
   * @memberof module:ProtectionController
   * @instance
   * @ignore
   */


  function setProtectionData(data) {
    protDataSet = data;
    protectionKeyController.setProtectionData(data);
  }
  /**
   * Stop method is called when current playback is stopped/resetted.
   *
   * @memberof module:ProtectionController
   * @instance
   */


  function stop() {
    _abortLicenseRequest();

    if (protectionModel) {
      protectionModel.stop();
    }
  }
  /**
   * Destroys all protection data associated with this protection set.  This includes
   * deleting all key sessions. In the case of persistent key sessions, the sessions
   * will simply be unloaded and not deleted.  Additionally, if this protection set is
   * associated with a HTMLMediaElement, it will be detached from that element.
   *
   * @memberof module:ProtectionController
   * @instance
   * @ignore
   */


  function reset() {
    eventBus.off(events.INTERNAL_KEY_MESSAGE, _onKeyMessage, instance);
    eventBus.off(events.INTERNAL_KEY_STATUS_CHANGED, _onKeyStatusChanged, instance);
    checkConfig();

    _abortLicenseRequest();

    setMediaElement(null);
    selectedKeySystem = null;
    keySystemSelectionInProgress = false;

    if (protectionModel) {
      protectionModel.reset();
      protectionModel = null;
    }

    needkeyRetries.forEach(function (retryTimeout) {
      return clearTimeout(retryTimeout);
    });
    needkeyRetries = [];
    mediaInfoArr = [];
    pendingKeySystemData = [];
  }
  /**
   * Returns an object corresponding to the EME MediaKeySystemConfiguration dictionary
   * @param {object} keySystem
   * @return {KeySystemConfiguration}
   * @private
   */


  function _getKeySystemConfiguration(keySystemData) {
    var protData = keySystemData.protData;
    var audioCapabilities = [];
    var videoCapabilities = [];
    var audioRobustness = protData && protData.audioRobustness && protData.audioRobustness.length > 0 ? protData.audioRobustness : robustnessLevel;
    var videoRobustness = protData && protData.videoRobustness && protData.videoRobustness.length > 0 ? protData.videoRobustness : robustnessLevel;
    var ksSessionType = keySystemData.sessionType;
    var distinctiveIdentifier = protData && protData.distinctiveIdentifier ? protData.distinctiveIdentifier : 'optional';
    var persistentState = protData && protData.persistentState ? protData.persistentState : ksSessionType === 'temporary' ? 'optional' : 'required';
    mediaInfoArr.forEach(function (media) {
      if (media.type === constants.AUDIO) {
        audioCapabilities.push(new _vo_MediaCapability__WEBPACK_IMPORTED_MODULE_1__["default"](media.codec, audioRobustness));
      } else if (media.type === constants.VIDEO) {
        videoCapabilities.push(new _vo_MediaCapability__WEBPACK_IMPORTED_MODULE_1__["default"](media.codec, videoRobustness));
      }
    });
    return new _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_2__["default"](audioCapabilities, videoCapabilities, distinctiveIdentifier, persistentState, [ksSessionType]);
  }
  /**
   * Event handler for when the status of the key has changed
   * @param {object} e
   * @private
   */


  function _onKeyStatusChanged(e) {
    if (e.error) {
      eventBus.trigger(events.KEY_STATUSES_CHANGED, {
        data: null,
        error: e.error
      });
    } else {
      logger.debug('DRM: key status = ' + e.status);
    }
  }
  /**
   * Event handler for the key message event. Once we have a key message we can issue a license request
   * @param {object} e
   * @private
   */


  function _onKeyMessage(e) {
    logger.debug('DRM: onKeyMessage'); // Dispatch event to applications indicating we received a key message

    var keyMessage = e.data;
    eventBus.trigger(events.KEY_MESSAGE, {
      data: keyMessage
    });
    var messageType = keyMessage.messageType ? keyMessage.messageType : 'license-request';
    var message = keyMessage.message;
    var sessionToken = keyMessage.sessionToken;

    var protData = _getProtDataForKeySystem(selectedKeySystem);

    var licenseServerModelInstance = protectionKeyController.getLicenseServerModelInstance(selectedKeySystem, protData, messageType);
    var eventData = {
      sessionToken: sessionToken,
      messageType: messageType
    }; // Ensure message from CDM is not empty

    if (!message || message.byteLength === 0) {
      _sendLicenseRequestCompleteEvent(eventData, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE));

      return;
    } // Message not destined for license server


    if (!licenseServerModelInstance) {
      logger.debug('DRM: License server request not required for this message (type = ' + e.data.messageType + ').  Session ID = ' + sessionToken.getSessionId());

      _sendLicenseRequestCompleteEvent(eventData);

      return;
    } // Perform any special handling for ClearKey


    if (protectionKeyController.isClearKey(selectedKeySystem)) {
      var clearkeys = protectionKeyController.processClearKeyLicenseRequest(selectedKeySystem, protData, message);

      if (clearkeys && clearkeys.keyPairs && clearkeys.keyPairs.length > 0) {
        logger.debug('DRM: ClearKey license request handled by application!');

        _sendLicenseRequestCompleteEvent(eventData);

        protectionModel.updateKeySession(sessionToken, clearkeys);
        return;
      }
    } // In all other cases we have to make a license request


    _issueLicenseRequest(keyMessage, licenseServerModelInstance, protData);
  }
  /**
   * Notify other classes that the license request was completed
   * @param {object} data
   * @param {object} error
   * @private
   */


  function _sendLicenseRequestCompleteEvent(data, error) {
    eventBus.trigger(events.LICENSE_REQUEST_COMPLETE, {
      data: data,
      error: error
    });
  }
  /**
   * Start issuing a license request
   * @param {object} keyMessage
   * @param {object} licenseServerData
   * @param {object} protData
   * @private
   */


  function _issueLicenseRequest(keyMessage, licenseServerData, protData) {
    var sessionToken = keyMessage.sessionToken;
    var messageType = keyMessage.messageType ? keyMessage.messageType : 'license-request';
    var eventData = {
      sessionToken: sessionToken,
      messageType: messageType
    };
    var keySystemString = selectedKeySystem ? selectedKeySystem.systemString : null; // Determine license server URL

    var url = _getLicenseServerUrl(protData, messageType, sessionToken, keyMessage, licenseServerData); // Ensure valid license server URL


    if (!url) {
      _sendLicenseRequestCompleteEvent(eventData, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));

      return;
    } // Set optional XMLHttpRequest headers from protection data and message


    var reqHeaders = {};
    var withCredentials = false;

    if (protData) {
      _updateHeaders(reqHeaders, protData.httpRequestHeaders);
    }

    var message = keyMessage.message;
    var headersFromMessage = selectedKeySystem.getRequestHeadersFromMessage(message);

    _updateHeaders(reqHeaders, headersFromMessage);

    Object.keys(reqHeaders).forEach(function (key) {
      if ('authorization' === key.toLowerCase()) {
        withCredentials = true;
      }
    }); // Overwrite withCredentials property from protData if present

    if (protData && typeof protData.withCredentials == 'boolean') {
      withCredentials = protData.withCredentials;
    }

    var onLoad = function onLoad(xhr) {
      if (!protectionModel) {
        return;
      }

      if (xhr.status >= 200 && xhr.status <= 299) {
        var responseHeaders = _core_Utils__WEBPACK_IMPORTED_MODULE_8__["default"].parseHttpHeaders(xhr.getAllResponseHeaders ? xhr.getAllResponseHeaders() : null);
        var licenseResponse = new _vo_LicenseResponse__WEBPACK_IMPORTED_MODULE_6__["default"](xhr.responseURL, responseHeaders, xhr.response);
        var licenseResponseFilters = customParametersModel.getLicenseResponseFilters();

        _applyFilters(licenseResponseFilters, licenseResponse).then(function () {
          var licenseMessage = licenseServerData.getLicenseMessage(licenseResponse.data, keySystemString, messageType);

          if (licenseMessage !== null) {
            _sendLicenseRequestCompleteEvent(eventData);

            protectionModel.updateKeySession(sessionToken, licenseMessage);
          } else {
            _reportError(xhr, eventData, keySystemString, messageType, licenseServerData);
          }
        });
      } else {
        _reportError(xhr, eventData, keySystemString, messageType, licenseServerData);
      }
    };

    var onAbort = function onAbort(xhr) {
      _sendLicenseRequestCompleteEvent(eventData, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + keySystemString + ' update, XHR aborted. status is "' + xhr.statusText + '" (' + xhr.status + '), readyState is ' + xhr.readyState));
    };

    var onError = function onError(xhr) {
      _sendLicenseRequestCompleteEvent(eventData, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + keySystemString + ' update, XHR error. status is "' + xhr.statusText + '" (' + xhr.status + '), readyState is ' + xhr.readyState));
    };

    var reqPayload = selectedKeySystem.getLicenseRequestFromMessage(message);
    var reqMethod = licenseServerData.getHTTPMethod(messageType);
    var responseType = licenseServerData.getResponseType(keySystemString, messageType);
    var timeout = protData && !isNaN(protData.httpTimeout) ? protData.httpTimeout : LICENSE_SERVER_REQUEST_DEFAULT_TIMEOUT;
    var sessionId = sessionToken.getSessionId() || null;
    var licenseRequest = new _vo_LicenseRequest__WEBPACK_IMPORTED_MODULE_5__["default"](url, reqMethod, responseType, reqHeaders, withCredentials, messageType, sessionId, reqPayload);
    var retryAttempts = !isNaN(settings.get().streaming.retryAttempts[_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE]) ? settings.get().streaming.retryAttempts[_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE] : LICENSE_SERVER_REQUEST_RETRIES;
    var licenseRequestFilters = customParametersModel.getLicenseRequestFilters();

    _applyFilters(licenseRequestFilters, licenseRequest).then(function () {
      _doLicenseRequest(licenseRequest, retryAttempts, timeout, onLoad, onAbort, onError);
    });
  }
  /**
   * Implement license requests with a retry mechanism to avoid temporary network issues to affect playback experience
   * @param {object} request
   * @param {number} retriesCount
   * @param {number} timeout
   * @param {function} onLoad
   * @param {function} onAbort
   * @param {function} onError
   * @private
   */


  function _doLicenseRequest(request, retriesCount, timeout, onLoad, onAbort, onError) {
    var xhr = new XMLHttpRequest();

    if (settings.get().streaming.cmcd && settings.get().streaming.cmcd.enabled) {
      var cmcdMode = settings.get().streaming.cmcd.mode;

      if (cmcdMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_9__["default"].CMCD_MODE_QUERY) {
        var cmcdParams = cmcdModel.getQueryParameter({
          url: request.url,
          type: _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE
        });

        if (cmcdParams) {
          request.url = _core_Utils__WEBPACK_IMPORTED_MODULE_8__["default"].addAditionalQueryParameterToUrl(request.url, [cmcdParams]);
        }
      }
    }

    xhr.open(request.method, request.url, true);
    xhr.responseType = request.responseType;
    xhr.withCredentials = request.withCredentials;

    if (timeout > 0) {
      xhr.timeout = timeout;
    }

    for (var key in request.headers) {
      xhr.setRequestHeader(key, request.headers[key]);
    }

    if (settings.get().streaming.cmcd && settings.get().streaming.cmcd.enabled) {
      var _cmcdMode = settings.get().streaming.cmcd.mode;

      if (_cmcdMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_9__["default"].CMCD_MODE_HEADER) {
        var cmcdHeaders = cmcdModel.getHeaderParameters({
          url: request.url,
          type: _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE
        });

        if (cmcdHeaders) {
          for (var header in cmcdHeaders) {
            var value = cmcdHeaders[header];

            if (value) {
              xhr.setRequestHeader(header, value);
            }
          }
        }
      }
    }

    var _retryRequest = function _retryRequest() {
      // fail silently and retry
      retriesCount--;
      var retryInterval = !isNaN(settings.get().streaming.retryIntervals[_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE]) ? settings.get().streaming.retryIntervals[_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].LICENSE] : LICENSE_SERVER_REQUEST_RETRY_INTERVAL;
      licenseRequestRetryTimeout = setTimeout(function () {
        _doLicenseRequest(request, retriesCount, timeout, onLoad, onAbort, onError);
      }, retryInterval);
    };

    xhr.onload = function () {
      licenseXhrRequest = null;

      if (this.status >= 200 && this.status <= 299 || retriesCount <= 0) {
        onLoad(this);
      } else {
        logger.warn('License request failed (' + this.status + '). Retrying it... Pending retries: ' + retriesCount);

        _retryRequest();
      }
    };

    xhr.ontimeout = xhr.onerror = function () {
      licenseXhrRequest = null;

      if (retriesCount <= 0) {
        onError(this);
      } else {
        logger.warn('License request network request failed . Retrying it... Pending retries: ' + retriesCount);

        _retryRequest();
      }
    };

    xhr.onabort = function () {
      onAbort(this);
    }; // deprecated, to be removed


    eventBus.trigger(events.LICENSE_REQUEST_SENDING, {
      url: request.url,
      headers: request.headers,
      payload: request.data,
      sessionId: request.sessionId
    });
    licenseXhrRequest = xhr;
    xhr.send(request.data);
  }
  /**
   * Aborts license request
   * @private
   */


  function _abortLicenseRequest() {
    if (licenseXhrRequest) {
      licenseXhrRequest.onloadend = licenseXhrRequest.onerror = licenseXhrRequest.onprogress = undefined; //Ignore events from aborted requests.

      licenseXhrRequest.abort();
      licenseXhrRequest = null;
    }

    if (licenseRequestRetryTimeout) {
      clearTimeout(licenseRequestRetryTimeout);
      licenseRequestRetryTimeout = null;
    }
  }
  /**
   * Returns the url of the license server
   * @param {object} protData
   * @param {string} messageType
   * @param {object} sessionToken
   * @param {object} keyMessage
   * @param {object} licenseServerData
   * @return {*}
   * @private
   */


  function _getLicenseServerUrl(protData, messageType, sessionToken, keyMessage, licenseServerData) {
    var url = null;
    var message = keyMessage.message; // Check if the url is defined by the application

    if (protData && protData.serverURL) {
      var serverURL = protData.serverURL;

      if (typeof serverURL === 'string' && serverURL !== '') {
        url = serverURL;
      } else if (_typeof(serverURL) === 'object' && serverURL.hasOwnProperty(messageType)) {
        url = serverURL[messageType];
      }
    } // This is the old way of providing the url
    else if (protData && protData.laURL && protData.laURL !== '') {
        url = protData.laURL;
      } // No url provided by the app. Check the manifest and the pssh
      else {
          // Check for url defined in the manifest
          url = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].getLicenseServerUrlFromMediaInfo(mediaInfoArr, selectedKeySystem.schemeIdURI); // In case we are not using Clearky we can still get a url from the pssh.

          if (!url && !protectionKeyController.isClearKey(selectedKeySystem)) {
            var psshData = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].getPSSHData(sessionToken.initData);
            url = selectedKeySystem.getLicenseServerURLFromInitData(psshData); // Still no url, check the keymessage

            if (!url) {
              url = keyMessage.laURL;
            }
          }
        } // Possibly update or override the URL based on the message


    url = licenseServerData.getServerURLFromMessage(url, message, messageType);
    return url;
  }
  /**
   * Add new headers to the existing ones
   * @param {array} reqHeaders
   * @param {object} headers
   * @private
   */


  function _updateHeaders(reqHeaders, headers) {
    if (headers) {
      for (var key in headers) {
        reqHeaders[key] = headers[key];
      }
    }
  }
  /**
   * Reports an error that might have occured during the license request
   * @param {object} xhr
   * @param {object} eventData
   * @param {string} keySystemString
   * @param {string} messageType
   * @param {object} licenseServerData
   * @private
   */


  function _reportError(xhr, eventData, keySystemString, messageType, licenseServerData) {
    var errorMsg = xhr.response ? licenseServerData.getErrorResponse(xhr.response, keySystemString, messageType) : 'NONE';

    _sendLicenseRequestCompleteEvent(eventData, new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_4__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE + keySystemString + ' update, XHR complete. status is "' + xhr.statusText + '" (' + xhr.status + '), readyState is ' + xhr.readyState + '.  Response is ' + errorMsg));
  }
  /**
   * Applies custom filters defined by the application
   * @param {array} filters
   * @param {object} param
   * @return {Promise<void>|*}
   * @private
   */


  function _applyFilters(filters, param) {
    if (!filters) return Promise.resolve();
    return filters.reduce(function (prev, next) {
      return prev.then(function () {
        return next(param);
      });
    }, Promise.resolve());
  }
  /**
   * Event handler for "needkey" and "encrypted" events
   * @param {object} event
   * @param {number} retry
   */


  function _onNeedKey(event, retry) {
    if (!settings.get().streaming.protection.ignoreEmeEncryptedEvent) {
      logger.debug('DRM: onNeedKey'); // Ignore non-cenc initData

      if (event.key.initDataType !== 'cenc') {
        logger.warn('DRM:  Only \'cenc\' initData is supported!  Ignoring initData of type: ' + event.key.initDataType);
        return;
      }

      if (mediaInfoArr.length === 0) {
        logger.warn('DRM: onNeedKey called before initializeForMedia, wait until initialized');
        retry = typeof retry === 'undefined' ? 1 : retry + 1;

        if (retry < NEEDKEY_BEFORE_INITIALIZE_RETRIES) {
          needkeyRetries.push(setTimeout(function () {
            _onNeedKey(event, retry);
          }, NEEDKEY_BEFORE_INITIALIZE_TIMEOUT));
          return;
        }
      } // Some browsers return initData as Uint8Array (IE), some as ArrayBuffer (Chrome).
      // Convert to ArrayBuffer


      var abInitData = event.key.initData;

      if (ArrayBuffer.isView(abInitData)) {
        abInitData = abInitData.buffer;
      } // If key system has already been selected and initData already seen, then do nothing


      if (selectedKeySystem) {
        var initDataForKS = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].getPSSHForKeySystem(selectedKeySystem, abInitData);

        if (initDataForKS) {
          // Check for duplicate initData
          if (_isInitDataDuplicate(initDataForKS)) {
            return;
          }
        }
      }

      logger.debug('DRM: initData:', String.fromCharCode.apply(null, new Uint8Array(abInitData)));
      var supportedKS = protectionKeyController.getSupportedKeySystemsFromSegmentPssh(abInitData, protDataSet, sessionType);

      if (supportedKS.length === 0) {
        logger.debug('DRM: Received needkey event with initData, but we don\'t support any of the key systems!');
        return;
      }

      _selectKeySystem(supportedKS, false);
    }
  }
  /**
   * Returns all available key systems
   * @return {array}
   */


  function getKeySystems() {
    return protectionKeyController ? protectionKeyController.getKeySystems() : [];
  }
  /**
   * Sets all available key systems
   * @param {array} keySystems
   */


  function setKeySystems(keySystems) {
    if (protectionKeyController) {
      protectionKeyController.setKeySystems(keySystems);
    }
  }

  instance = {
    initializeForMedia: initializeForMedia,
    clearMediaInfoArray: clearMediaInfoArray,
    createKeySession: createKeySession,
    loadKeySession: loadKeySession,
    removeKeySession: removeKeySession,
    closeKeySession: closeKeySession,
    setServerCertificate: setServerCertificate,
    setMediaElement: setMediaElement,
    setSessionType: setSessionType,
    setRobustnessLevel: setRobustnessLevel,
    setProtectionData: setProtectionData,
    getSupportedKeySystemsFromContentProtection: getSupportedKeySystemsFromContentProtection,
    getKeySystems: getKeySystems,
    setKeySystems: setKeySystems,
    stop: stop,
    reset: reset
  };
  setup();
  return instance;
}

ProtectionController.__dashjs_factory_name = 'ProtectionController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_10__["default"].getClassFactory(ProtectionController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/controllers/ProtectionKeyController.js":
/*!*************************************************************************!*\
  !*** ./src/streaming/protection/controllers/ProtectionKeyController.js ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2062281__) {

"use strict";
__nested_webpack_require_2062281__.r(__webpack_exports__);
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2062281__(/*! ./../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _drm_KeySystemClearKey__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2062281__(/*! ./../drm/KeySystemClearKey */ "./src/streaming/protection/drm/KeySystemClearKey.js");
/* harmony import */ var _drm_KeySystemW3CClearKey__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2062281__(/*! ./../drm/KeySystemW3CClearKey */ "./src/streaming/protection/drm/KeySystemW3CClearKey.js");
/* harmony import */ var _drm_KeySystemWidevine__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2062281__(/*! ./../drm/KeySystemWidevine */ "./src/streaming/protection/drm/KeySystemWidevine.js");
/* harmony import */ var _drm_KeySystemPlayReady__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2062281__(/*! ./../drm/KeySystemPlayReady */ "./src/streaming/protection/drm/KeySystemPlayReady.js");
/* harmony import */ var _servers_DRMToday__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2062281__(/*! ./../servers/DRMToday */ "./src/streaming/protection/servers/DRMToday.js");
/* harmony import */ var _servers_PlayReady__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2062281__(/*! ./../servers/PlayReady */ "./src/streaming/protection/servers/PlayReady.js");
/* harmony import */ var _servers_Widevine__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2062281__(/*! ./../servers/Widevine */ "./src/streaming/protection/servers/Widevine.js");
/* harmony import */ var _servers_ClearKey__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2062281__(/*! ./../servers/ClearKey */ "./src/streaming/protection/servers/ClearKey.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2062281__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */










/**
 * @module ProtectionKeyController
 * @ignore
 * @description Media protection key system functionality that can be modified/overridden by applications
 */

function ProtectionKeyController() {
  var context = this.context;
  var instance, debug, logger, keySystems, BASE64, settings, clearkeyKeySystem, clearkeyW3CKeySystem;

  function setConfig(config) {
    if (!config) return;

    if (config.debug) {
      debug = config.debug;
      logger = debug.getLogger(instance);
    }

    if (config.BASE64) {
      BASE64 = config.BASE64;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }

  function initialize() {
    keySystems = [];
    var keySystem; // PlayReady

    keySystem = Object(_drm_KeySystemPlayReady__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance({
      BASE64: BASE64,
      settings: settings
    });
    keySystems.push(keySystem); // Widevine

    keySystem = Object(_drm_KeySystemWidevine__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance({
      BASE64: BASE64
    });
    keySystems.push(keySystem); // ClearKey

    keySystem = Object(_drm_KeySystemClearKey__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance({
      BASE64: BASE64
    });
    keySystems.push(keySystem);
    clearkeyKeySystem = keySystem; // W3C ClearKey

    keySystem = Object(_drm_KeySystemW3CClearKey__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance({
      BASE64: BASE64,
      debug: debug
    });
    keySystems.push(keySystem);
    clearkeyW3CKeySystem = keySystem;
  }
  /**
   * Returns a prioritized list of key systems supported
   * by this player (not necessarily those supported by the
   * user agent)
   *
   * @returns {Array.<KeySystem>} a prioritized
   * list of key systems
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function getKeySystems() {
    return keySystems;
  }
  /**
   * Sets the prioritized list of key systems to be supported
   * by this player.
   *
   * @param {Array.<KeySystem>} newKeySystems the new prioritized
   * list of key systems
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function setKeySystems(newKeySystems) {
    keySystems = newKeySystems;
  }
  /**
   * Returns the key system associated with the given key system string
   * name (i.e. 'org.w3.clearkey')
   *
   * @param {string} systemString the system string
   * @returns {KeySystem|null} the key system
   * or null if no supported key system is associated with the given key
   * system string
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function getKeySystemBySystemString(systemString) {
    for (var i = 0; i < keySystems.length; i++) {
      if (keySystems[i].systemString === systemString) {
        return keySystems[i];
      }
    }

    return null;
  }
  /**
   * Determines whether the given key system is ClearKey.  This is
   * necessary because the EME spec defines ClearKey and its method
   * for providing keys to the key session; and this method has changed
   * between the various API versions.  Our EME-specific ProtectionModels
   * must know if the system is ClearKey so that it can format the keys
   * according to the particular spec version.
   *
   * @param {Object} keySystem the key
   * @returns {boolean} true if this is the ClearKey key system, false
   * otherwise
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function isClearKey(keySystem) {
    return keySystem === clearkeyKeySystem || keySystem === clearkeyW3CKeySystem;
  }
  /**
   * Check equality of initData array buffers.
   *
   * @param {ArrayBuffer} initData1 - first initData
   * @param {ArrayBuffer} initData2 - second initData
   * @returns {boolean} true if the initData arrays are equal in size and
   * contents, false otherwise
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function initDataEquals(initData1, initData2) {
    if (initData1.byteLength === initData2.byteLength) {
      var data1 = new Uint8Array(initData1);
      var data2 = new Uint8Array(initData2);

      for (var j = 0; j < data1.length; j++) {
        if (data1[j] !== data2[j]) {
          return false;
        }
      }

      return true;
    }

    return false;
  }
  /**
   * Returns a set of supported key systems and CENC initialization data
   * from the given array of ContentProtection elements.  Only
   * key systems that are supported by this player will be returned.
   * Key systems are returned in priority order (highest first).
   *
   * @param {Array.<Object>} cps - array of content protection elements parsed
   * from the manifest
   * @param {ProtectionData} protDataSet user specified protection data - license server url etc
   * supported by the content
   * @param {string} default session type
   * @returns {Array.<Object>} array of objects indicating which supported key
   * systems were found.  Empty array is returned if no
   * supported key systems were found
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function getSupportedKeySystemsFromContentProtection(cps, protDataSet, sessionType) {
    var cp, ks, ksIdx, cpIdx;
    var supportedKS = [];

    if (cps) {
      var cencContentProtection = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].findCencContentProtection(cps);

      for (ksIdx = 0; ksIdx < keySystems.length; ++ksIdx) {
        ks = keySystems[ksIdx]; // Get protection data that applies for current key system

        var protData = _getProtDataForKeySystem(ks.systemString, protDataSet);

        for (cpIdx = 0; cpIdx < cps.length; ++cpIdx) {
          cp = cps[cpIdx];

          if (cp.schemeIdUri.toLowerCase() === ks.schemeIdURI) {
            // Look for DRM-specific ContentProtection
            var initData = ks.getInitData(cp, cencContentProtection);
            supportedKS.push({
              ks: keySystems[ksIdx],
              keyId: cp.keyId,
              initData: initData,
              protData: protData,
              cdmData: ks.getCDMData(protData ? protData.cdmData : null),
              sessionId: _getSessionId(protData, cp),
              sessionType: _getSessionType(protData, sessionType)
            });
          }
        }
      }
    }

    return supportedKS;
  }
  /**
   * Returns key systems supported by this player for the given PSSH
   * initializationData. Key systems are returned in priority order
   * (highest priority first)
   *
   * @param {ArrayBuffer} initData Concatenated PSSH data for all DRMs
   * supported by the content
   * @param {ProtectionData} protDataSet user specified protection data - license server url etc
   * supported by the content
   * @param {string} default session type
   * @returns {Array.<Object>} array of objects indicating which supported key
   * systems were found.  Empty array is returned if no
   * supported key systems were found
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function getSupportedKeySystemsFromSegmentPssh(initData, protDataSet, sessionType) {
    var supportedKS = [];
    var pssh = _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].parsePSSHList(initData);
    var ks, keySystemString;

    for (var ksIdx = 0; ksIdx < keySystems.length; ++ksIdx) {
      ks = keySystems[ksIdx];
      keySystemString = ks.systemString; // Get protection data that applies for current key system

      var protData = _getProtDataForKeySystem(keySystemString, protDataSet);

      if (ks.uuid in pssh) {
        supportedKS.push({
          ks: ks,
          initData: pssh[ks.uuid],
          protData: protData,
          cdmData: ks.getCDMData(protData ? protData.cdmData : null),
          sessionId: _getSessionId(protData),
          sessionType: _getSessionType(protData, sessionType)
        });
      }
    }

    return supportedKS;
  }
  /**
   * Returns the license server implementation data that should be used for this request.
   *
   * @param {KeySystem} keySystem the key system
   * associated with this license request
   * @param {ProtectionData} protData protection data to use for the
   * request
   * @param {string} [messageType="license-request"] the message type associated with this
   * request.  Supported message types can be found
   * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
   * @returns {LicenseServer|null} the license server
   * implementation that should be used for this request or null if the player should not
   * pass messages of the given type to a license server
   * @memberof module:ProtectionKeyController
   * @instance
   *
   */


  function getLicenseServerModelInstance(keySystem, protData, messageType) {
    // Our default server implementations do not do anything with "license-release" or
    // "individualization-request" messages, so we just send a success event
    if (messageType === 'license-release' || messageType === 'individualization-request') {
      return null;
    }

    var licenseServerData = null;

    if (protData && protData.hasOwnProperty('drmtoday')) {
      licenseServerData = Object(_servers_DRMToday__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance({
        BASE64: BASE64
      });
    } else if (keySystem.systemString === _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_9__["default"].WIDEVINE_KEYSTEM_STRING) {
      licenseServerData = Object(_servers_Widevine__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
    } else if (keySystem.systemString === _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_9__["default"].PLAYREADY_KEYSTEM_STRING) {
      licenseServerData = Object(_servers_PlayReady__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance();
    } else if (keySystem.systemString === _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_9__["default"].CLEARKEY_KEYSTEM_STRING) {
      licenseServerData = Object(_servers_ClearKey__WEBPACK_IMPORTED_MODULE_8__["default"])(context).getInstance();
    }

    return licenseServerData;
  }
  /**
   * Allows application-specific retrieval of ClearKey keys.
   *
   * @param {KeySystem} clearkeyKeySystem They exact ClearKey System to be used
   * @param {ProtectionData} protData protection data to use for the
   * request
   * @param {ArrayBuffer} message the key message from the CDM
   * @return {ClearKeyKeySet|null} the clear keys associated with
   * the request or null if no keys can be returned by this function
   * @memberof module:ProtectionKeyController
   * @instance
   */


  function processClearKeyLicenseRequest(clearkeyKeySystem, protData, message) {
    try {
      return clearkeyKeySystem.getClearKeysFromProtectionData(protData, message);
    } catch (error) {
      logger.error('Failed to retrieve clearkeys from ProtectionData');
      return null;
    }
  }

  function setProtectionData(protectionDataSet) {
    var getProtectionData = function getProtectionData(keySystemString) {
      var protData = null;

      if (protectionDataSet) {
        protData = keySystemString in protectionDataSet ? protectionDataSet[keySystemString] : null;
      }

      return protData;
    };

    for (var i = 0; i < keySystems.length; i++) {
      var keySystem = keySystems[i];

      if (keySystem.hasOwnProperty('init')) {
        keySystem.init(getProtectionData(keySystem.systemString));
      }
    }
  }

  function _getProtDataForKeySystem(systemString, protDataSet) {
    if (!protDataSet) return null;
    return systemString in protDataSet ? protDataSet[systemString] : null;
  }

  function _getSessionId(protData, cp) {
    // Get sessionId from protectionData or from manifest (ContentProtection)
    if (protData && protData.sessionId) {
      return protData.sessionId;
    } else if (cp && cp.sessionId) {
      return cp.sessionId;
    }

    return null;
  }

  function _getSessionType(protData, sessionType) {
    return protData && protData.sessionType ? protData.sessionType : sessionType;
  }

  instance = {
    initialize: initialize,
    setProtectionData: setProtectionData,
    isClearKey: isClearKey,
    initDataEquals: initDataEquals,
    getKeySystems: getKeySystems,
    setKeySystems: setKeySystems,
    getKeySystemBySystemString: getKeySystemBySystemString,
    getSupportedKeySystemsFromContentProtection: getSupportedKeySystemsFromContentProtection,
    getSupportedKeySystemsFromSegmentPssh: getSupportedKeySystemsFromSegmentPssh,
    getLicenseServerModelInstance: getLicenseServerModelInstance,
    processClearKeyLicenseRequest: processClearKeyLicenseRequest,
    setConfig: setConfig
  };
  return instance;
}

ProtectionKeyController.__dashjs_factory_name = 'ProtectionKeyController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(ProtectionKeyController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/drm/KeySystemClearKey.js":
/*!***********************************************************!*\
  !*** ./src/streaming/protection/drm/KeySystemClearKey.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2079711__) {

"use strict";
__nested_webpack_require_2079711__.r(__webpack_exports__);
/* harmony import */ var _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2079711__(/*! ../vo/KeyPair */ "./src/streaming/protection/vo/KeyPair.js");
/* harmony import */ var _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2079711__(/*! ../vo/ClearKeyKeySet */ "./src/streaming/protection/vo/ClearKeyKeySet.js");
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2079711__(/*! ../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2079711__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




var uuid = 'e2719d58-a985-b3c9-781a-b030af78d30e';
var systemString = _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_3__["default"].CLEARKEY_KEYSTEM_STRING;
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemClearKey(config) {
  config = config || {};
  var instance;
  var BASE64 = config.BASE64;
  /**
   * Returns desired clearkeys (as specified in the CDM message) from protection data
   *
   * @param {ProtectionData} protectionData the protection data
   * @param {ArrayBuffer} message the ClearKey CDM message
   * @returns {ClearKeyKeySet} the key set or null if none found
   * @throws {Error} if a keyID specified in the CDM message was not found in the
   * protection data
   * @memberof KeySystemClearKey
   */

  function getClearKeysFromProtectionData(protectionData, message) {
    var clearkeySet = null;

    if (protectionData) {
      // ClearKey is the only system that does not require a license server URL, so we
      // handle it here when keys are specified in protection data
      var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message)));
      var keyPairs = [];

      for (var i = 0; i < jsonMsg.kids.length; i++) {
        var clearkeyID = jsonMsg.kids[i];
        var clearkey = protectionData.clearkeys && protectionData.clearkeys.hasOwnProperty(clearkeyID) ? protectionData.clearkeys[clearkeyID] : null;

        if (!clearkey) {
          throw new Error('DRM: ClearKey keyID (' + clearkeyID + ') is not known!');
        } // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded


        keyPairs.push(new _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__["default"](clearkeyID, clearkey));
      }

      clearkeySet = new _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__["default"](keyPairs);
    }

    return clearkeySet;
  }

  function getInitData(cp, cencContentProtection) {
    try {
      var initData = _CommonEncryption__WEBPACK_IMPORTED_MODULE_2__["default"].parseInitDataFromContentProtection(cp, BASE64);

      if (!initData && cencContentProtection) {
        var cencDefaultKid = cencDefaultKidToBase64Representation(cencContentProtection['cenc:default_KID']);
        var data = {
          kids: [cencDefaultKid]
        };
        initData = new TextEncoder().encode(JSON.stringify(data));
      }

      return initData;
    } catch (e) {
      return null;
    }
  }

  function cencDefaultKidToBase64Representation(cencDefaultKid) {
    try {
      var kid = cencDefaultKid.replace(/-/g, '');
      kid = btoa(kid.match(/\w{2}/g).map(function (a) {
        return String.fromCharCode(parseInt(a, 16));
      }).join(''));
      return kid.replace(/=/g, '');
    } catch (e) {
      return null;
    }
  }

  function getRequestHeadersFromMessage()
  /*message*/
  {
    // Set content type to application/json by default
    return {
      'Content-Type': 'application/json'
    };
  }

  function getLicenseRequestFromMessage(message) {
    return JSON.stringify(JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message))));
  }

  function getLicenseServerURLFromInitData()
  /*initData*/
  {
    return null;
  }

  function getCDMData()
  /*cdmData*/
  {
    return null;
  }

  instance = {
    uuid: uuid,
    schemeIdURI: schemeIdURI,
    systemString: systemString,
    getInitData: getInitData,
    getRequestHeadersFromMessage: getRequestHeadersFromMessage,
    getLicenseRequestFromMessage: getLicenseRequestFromMessage,
    getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
    getCDMData: getCDMData,
    getClearKeysFromProtectionData: getClearKeysFromProtectionData
  };
  return instance;
}

KeySystemClearKey.__dashjs_factory_name = 'KeySystemClearKey';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(KeySystemClearKey));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/drm/KeySystemPlayReady.js":
/*!************************************************************!*\
  !*** ./src/streaming/protection/drm/KeySystemPlayReady.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2086708__) {

"use strict";
__nested_webpack_require_2086708__.r(__webpack_exports__);
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2086708__(/*! ../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2086708__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Microsoft PlayReady DRM
 *
 * @class
 * @implements KeySystem
 */


var uuid = '9a04f079-9840-4286-ab92-e65be0885f95';
var systemString = _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_1__["default"].PLAYREADY_KEYSTEM_STRING;
var schemeIdURI = 'urn:uuid:' + uuid;
var PRCDMData = '<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>';

function KeySystemPlayReady(config) {
  config = config || {};
  var instance;
  var messageFormat = 'utf-16';
  var BASE64 = config.BASE64;
  var settings = config.settings;

  function checkConfig() {
    if (!BASE64 || !BASE64.hasOwnProperty('decodeArray') || !BASE64.hasOwnProperty('decodeArray')) {
      throw new Error('Missing config parameter(s)');
    }
  }

  function getRequestHeadersFromMessage(message) {
    var msg, xmlDoc;
    var headers = {};
    var parser = new DOMParser();

    if (settings && settings.get().streaming.protection.detectPlayreadyMessageFormat) {
      // If message format configured/defaulted to utf-16 AND number of bytes is odd, assume 'unwrapped' raw CDM message.
      if (messageFormat === 'utf-16' && message && message.byteLength % 2 === 1) {
        headers['Content-Type'] = 'text/xml; charset=utf-8';
        return headers;
      }
    }

    var dataview = messageFormat === 'utf-16' ? new Uint16Array(message) : new Uint8Array(message);
    msg = String.fromCharCode.apply(null, dataview);
    xmlDoc = parser.parseFromString(msg, 'application/xml');
    var headerNameList = xmlDoc.getElementsByTagName('name');
    var headerValueList = xmlDoc.getElementsByTagName('value');

    for (var i = 0; i < headerNameList.length; i++) {
      headers[headerNameList[i].childNodes[0].nodeValue] = headerValueList[i].childNodes[0].nodeValue;
    } // Some versions of the PlayReady CDM return 'Content' instead of 'Content-Type'.
    // this is NOT w3c conform and license servers may reject the request!
    // -> rename it to proper w3c definition!


    if (headers.hasOwnProperty('Content')) {
      headers['Content-Type'] = headers.Content;
      delete headers.Content;
    } // Set Content-Type header by default if not provided in the the CDM message (<PlayReadyKeyMessage/>)
    // or if the message contains directly the challenge itself (Ex: LG SmartTVs)


    if (!headers.hasOwnProperty('Content-Type')) {
      headers['Content-Type'] = 'text/xml; charset=utf-8';
    }

    return headers;
  }

  function getLicenseRequestFromMessage(message) {
    var licenseRequest = null;
    var parser = new DOMParser();

    if (settings && settings.get().streaming.protection.detectPlayreadyMessageFormat) {
      // If message format configured/defaulted to utf-16 AND number of bytes is odd, assume 'unwrapped' raw CDM message.
      if (messageFormat === 'utf-16' && message && message.byteLength % 2 === 1) {
        return message;
      }
    }

    var dataview = messageFormat === 'utf-16' ? new Uint16Array(message) : new Uint8Array(message);
    checkConfig();
    var msg = String.fromCharCode.apply(null, dataview);
    var xmlDoc = parser.parseFromString(msg, 'application/xml');

    if (xmlDoc.getElementsByTagName('PlayReadyKeyMessage')[0]) {
      var Challenge = xmlDoc.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue;

      if (Challenge) {
        licenseRequest = BASE64.decode(Challenge);
      }
    } else {
      // The message from CDM is not a wrapped message as on IE11 and Edge,
      // thus it contains direclty the challenge itself
      // (note that the xmlDoc at this point may be unreadable since it may have been interpreted as UTF-16)
      return message;
    }

    return licenseRequest;
  }

  function getLicenseServerURLFromInitData(initData) {
    if (initData) {
      var data = new DataView(initData);
      var numRecords = data.getUint16(4, true);
      var offset = 6;
      var parser = new DOMParser();

      for (var i = 0; i < numRecords; i++) {
        // Parse the PlayReady Record header
        var recordType = data.getUint16(offset, true);
        offset += 2;
        var recordLength = data.getUint16(offset, true);
        offset += 2;

        if (recordType !== 0x0001) {
          offset += recordLength;
          continue;
        }

        var recordData = initData.slice(offset, offset + recordLength);
        var record = String.fromCharCode.apply(null, new Uint16Array(recordData));
        var xmlDoc = parser.parseFromString(record, 'application/xml'); // First try <LA_URL>

        if (xmlDoc.getElementsByTagName('LA_URL')[0]) {
          var laurl = xmlDoc.getElementsByTagName('LA_URL')[0].childNodes[0].nodeValue;

          if (laurl) {
            return laurl;
          }
        } // Optionally, try <LUI_URL>


        if (xmlDoc.getElementsByTagName('LUI_URL')[0]) {
          var luiurl = xmlDoc.getElementsByTagName('LUI_URL')[0].childNodes[0].nodeValue;

          if (luiurl) {
            return luiurl;
          }
        }
      }
    }

    return null;
  }

  function getInitData(cpData) {
    // * desc@ getInitData
    // *   generate PSSH data from PROHeader defined in MPD file
    // *   PSSH format:
    // *   size (4)
    // *   box type(PSSH) (8)
    // *   Protection SystemID (16)
    // *   protection system data size (4) - length of decoded PROHeader
    // *   decoded PROHeader data from MPD file
    var PSSHBoxType = new Uint8Array([0x70, 0x73, 0x73, 0x68, 0x00, 0x00, 0x00, 0x00]); //'PSSH' 8 bytes

    var playreadySystemID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);
    var byteCursor = 0;
    var uint8arraydecodedPROHeader = null;
    var PROSize, PSSHSize, PSSHBoxBuffer, PSSHBox, PSSHData;
    checkConfig();

    if (!cpData) {
      return null;
    } // Handle common encryption PSSH


    if ('pssh' in cpData) {
      return _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].parseInitDataFromContentProtection(cpData, BASE64);
    } // Handle native MS PlayReady ContentProtection elements


    if ('pro' in cpData) {
      uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.pro.__text);
    } else if ('prheader' in cpData) {
      uint8arraydecodedPROHeader = BASE64.decodeArray(cpData.prheader.__text);
    } else {
      return null;
    }

    PROSize = uint8arraydecodedPROHeader.length;
    PSSHSize = 0x4 + PSSHBoxType.length + playreadySystemID.length + 0x4 + PROSize;
    PSSHBoxBuffer = new ArrayBuffer(PSSHSize);
    PSSHBox = new Uint8Array(PSSHBoxBuffer);
    PSSHData = new DataView(PSSHBoxBuffer);
    PSSHData.setUint32(byteCursor, PSSHSize);
    byteCursor += 0x4;
    PSSHBox.set(PSSHBoxType, byteCursor);
    byteCursor += PSSHBoxType.length;
    PSSHBox.set(playreadySystemID, byteCursor);
    byteCursor += playreadySystemID.length;
    PSSHData.setUint32(byteCursor, PROSize);
    byteCursor += 0x4;
    PSSHBox.set(uint8arraydecodedPROHeader, byteCursor);
    byteCursor += PROSize;
    return PSSHBox.buffer;
  }
  /**
   * It seems that some PlayReady implementations return their XML-based CDM
   * messages using UTF16, while others return them as UTF8.  Use this function
   * to modify the message format to expect when parsing CDM messages.
   *
   * @param {string} format the expected message format.  Either "utf-8" or "utf-16".
   * @throws {Error} Specified message format is not one of "utf8" or "utf16"
   */


  function setPlayReadyMessageFormat(format) {
    if (format !== 'utf-8' && format !== 'utf-16') {
      throw new Error('Specified message format is not one of "utf-8" or "utf-16"');
    }

    messageFormat = format;
  }
  /**
   * Get Playready Custom data
   */


  function getCDMData(_cdmData) {
    var customData, cdmData, cdmDataBytes, i;
    checkConfig();
    if (!_cdmData) return null; // Convert custom data into multibyte string

    customData = [];

    for (i = 0; i < _cdmData.length; ++i) {
      customData.push(_cdmData.charCodeAt(i));
      customData.push(0);
    }

    customData = String.fromCharCode.apply(null, customData); // Encode in Base 64 the custom data string

    customData = BASE64.encode(customData); // Initialize CDM data with Base 64 encoded custom data
    // (see https://msdn.microsoft.com/en-us/library/dn457361.aspx)

    cdmData = PRCDMData.replace('%CUSTOMDATA%', customData); // Convert CDM data into multibyte characters

    cdmDataBytes = [];

    for (i = 0; i < cdmData.length; ++i) {
      cdmDataBytes.push(cdmData.charCodeAt(i));
      cdmDataBytes.push(0);
    }

    return new Uint8Array(cdmDataBytes).buffer;
  }

  instance = {
    uuid: uuid,
    schemeIdURI: schemeIdURI,
    systemString: systemString,
    getInitData: getInitData,
    getRequestHeadersFromMessage: getRequestHeadersFromMessage,
    getLicenseRequestFromMessage: getLicenseRequestFromMessage,
    getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
    getCDMData: getCDMData,
    setPlayReadyMessageFormat: setPlayReadyMessageFormat
  };
  return instance;
}

KeySystemPlayReady.__dashjs_factory_name = 'KeySystemPlayReady';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(KeySystemPlayReady));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/drm/KeySystemW3CClearKey.js":
/*!**************************************************************!*\
  !*** ./src/streaming/protection/drm/KeySystemW3CClearKey.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2099028__) {

"use strict";
__nested_webpack_require_2099028__.r(__webpack_exports__);
/* harmony import */ var _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2099028__(/*! ../vo/KeyPair */ "./src/streaming/protection/vo/KeyPair.js");
/* harmony import */ var _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2099028__(/*! ../vo/ClearKeyKeySet */ "./src/streaming/protection/vo/ClearKeyKeySet.js");
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2099028__(/*! ../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2099028__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




var uuid = '1077efec-c0b2-4d02-ace3-3c1e52e2fb4b';
var systemString = _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_3__["default"].CLEARKEY_KEYSTEM_STRING;
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemW3CClearKey(config) {
  var instance;
  var BASE64 = config.BASE64;
  var logger = config.debug.getLogger(instance);
  /**
   * Returns desired clearkeys (as specified in the CDM message) from protection data
   *
   * @param {ProtectionDataSet} protectionData the protection data
   * @param {ArrayBuffer} message the ClearKey CDM message
   * @returns {ClearKeyKeySet} the key set or null if none found
   * @throws {Error} if a keyID specified in the CDM message was not found in the
   * protection data
   * @memberof KeySystemClearKey
   */

  function getClearKeysFromProtectionData(protectionData, message) {
    var clearkeySet = null;

    if (protectionData) {
      // ClearKey is the only system that does not require a license server URL, so we
      // handle it here when keys are specified in protection data
      var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message)));
      var keyPairs = [];

      for (var i = 0; i < jsonMsg.kids.length; i++) {
        var clearkeyID = jsonMsg.kids[i];
        var clearkey = protectionData.clearkeys && protectionData.clearkeys.hasOwnProperty(clearkeyID) ? protectionData.clearkeys[clearkeyID] : null;

        if (!clearkey) {
          throw new Error('DRM: ClearKey keyID (' + clearkeyID + ') is not known!');
        } // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded


        keyPairs.push(new _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__["default"](clearkeyID, clearkey));
      }

      clearkeySet = new _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__["default"](keyPairs);
      logger.warn('ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4');
    }

    return clearkeySet;
  }

  function getInitData(cp) {
    return _CommonEncryption__WEBPACK_IMPORTED_MODULE_2__["default"].parseInitDataFromContentProtection(cp, BASE64);
  }

  function getRequestHeadersFromMessage()
  /*message*/
  {
    return null;
  }

  function getLicenseRequestFromMessage(message) {
    return new Uint8Array(message);
  }

  function getLicenseServerURLFromInitData()
  /*initData*/
  {
    return null;
  }

  function getCDMData()
  /*cdmData*/
  {
    return null;
  }

  instance = {
    uuid: uuid,
    schemeIdURI: schemeIdURI,
    systemString: systemString,
    getInitData: getInitData,
    getRequestHeadersFromMessage: getRequestHeadersFromMessage,
    getLicenseRequestFromMessage: getLicenseRequestFromMessage,
    getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
    getCDMData: getCDMData,
    getClearKeysFromProtectionData: getClearKeysFromProtectionData
  };
  return instance;
}

KeySystemW3CClearKey.__dashjs_factory_name = 'KeySystemW3CClearKey';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(KeySystemW3CClearKey));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/drm/KeySystemWidevine.js":
/*!***********************************************************!*\
  !*** ./src/streaming/protection/drm/KeySystemWidevine.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2105300__) {

"use strict";
__nested_webpack_require_2105300__.r(__webpack_exports__);
/* harmony import */ var _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2105300__(/*! ../CommonEncryption */ "./src/streaming/protection/CommonEncryption.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2105300__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Google Widevine DRM
 *
 * @class
 * @implements MediaPlayer.dependencies.protection.KeySystem
 */


var uuid = 'edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
var systemString = _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_1__["default"].WIDEVINE_KEYSTEM_STRING;
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemWidevine(config) {
  config = config || {};
  var instance;
  var BASE64 = config.BASE64;

  function getInitData(cp) {
    return _CommonEncryption__WEBPACK_IMPORTED_MODULE_0__["default"].parseInitDataFromContentProtection(cp, BASE64);
  }

  function getRequestHeadersFromMessage()
  /*message*/
  {
    return null;
  }

  function getLicenseRequestFromMessage(message) {
    return new Uint8Array(message);
  }

  function getLicenseServerURLFromInitData()
  /*initData*/
  {
    return null;
  }

  function getCDMData()
  /*cdmData*/
  {
    return null;
  }

  instance = {
    uuid: uuid,
    schemeIdURI: schemeIdURI,
    systemString: systemString,
    getInitData: getInitData,
    getRequestHeadersFromMessage: getRequestHeadersFromMessage,
    getLicenseRequestFromMessage: getLicenseRequestFromMessage,
    getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
    getCDMData: getCDMData
  };
  return instance;
}

KeySystemWidevine.__dashjs_factory_name = 'KeySystemWidevine';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(KeySystemWidevine));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/errors/ProtectionErrors.js":
/*!*************************************************************!*\
  !*** ./src/streaming/protection/errors/ProtectionErrors.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2109532__) {

"use strict";
__nested_webpack_require_2109532__.r(__webpack_exports__);
/* harmony import */ var _core_errors_ErrorsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2109532__(/*! ../../../core/errors/ErrorsBase */ "./src/core/errors/ErrorsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 */

var ProtectionErrors = /*#__PURE__*/function (_ErrorsBase) {
  _inherits(ProtectionErrors, _ErrorsBase);

  var _super = _createSuper(ProtectionErrors);

  function ProtectionErrors() {
    var _this;

    _classCallCheck(this, ProtectionErrors);

    _this = _super.call(this);
    /**
     *  Generid key Error code
     */

    _this.MEDIA_KEYERR_CODE = 100;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_UNKNOWN_CODE = 101;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_CLIENT_CODE = 102;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_SERVICE_CODE = 103;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_OUTPUT_CODE = 104;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_HARDWARECHANGE_CODE = 105;
    /**
     *  Error code returned by keyerror api for ProtectionModel_01b
     */

    _this.MEDIA_KEYERR_DOMAIN_CODE = 106;
    /**
     *  Error code returned when an error occured in keymessage event for ProtectionModel_01b
     */

    _this.MEDIA_KEY_MESSAGE_ERROR_CODE = 107;
    /**
     *  Error code returned when challenge is invalid in keymessage event (event triggered by CDM)
     */

    _this.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE = 108;
    /**
     *  Error code returned when License server certificate has not been successfully updated
     */

    _this.SERVER_CERTIFICATE_UPDATED_ERROR_CODE = 109;
    /**
     *  Error code returned when license validity has expired
     */

    _this.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE = 110;
    /**
     *  Error code returned when no licenser url is defined
     */

    _this.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE = 111;
    /**
     *  Error code returned when key system access is denied
     */

    _this.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE = 112;
    /**
     *  Error code returned when key session has not been successfully created
     */

    _this.KEY_SESSION_CREATED_ERROR_CODE = 113;
    /**
     *  Error code returned when license request failed after a keymessage event has been triggered
     */

    _this.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE = 114;
    _this.MEDIA_KEYERR_UNKNOWN_MESSAGE = 'An unspecified error occurred. This value is used for errors that don\'t match any of the other codes.';
    _this.MEDIA_KEYERR_CLIENT_MESSAGE = 'The Key System could not be installed or updated.';
    _this.MEDIA_KEYERR_SERVICE_MESSAGE = 'The message passed into update indicated an error from the license service.';
    _this.MEDIA_KEYERR_OUTPUT_MESSAGE = 'There is no available output device with the required characteristics for the content protection system.';
    _this.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE = 'A hardware configuration change caused a content protection error.';
    _this.MEDIA_KEYERR_DOMAIN_MESSAGE = 'An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.';
    _this.MEDIA_KEY_MESSAGE_ERROR_MESSAGE = 'Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!';
    _this.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE = 'DRM: Empty key message from CDM';
    _this.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE = 'Error updating server certificate -- ';
    _this.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE = 'DRM: KeyStatusChange error! -- License has expired';
    _this.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE = 'DRM: No license server URL specified!';
    _this.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE = 'DRM: KeySystem Access Denied! -- ';
    _this.KEY_SESSION_CREATED_ERROR_MESSAGE = 'DRM: unable to create session! --';
    _this.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE = 'DRM: licenser error! --';
    return _this;
  }

  return ProtectionErrors;
}(_core_errors_ErrorsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var protectionErrors = new ProtectionErrors();
/* harmony default export */ __webpack_exports__["default"] = (protectionErrors);

/***/ }),

/***/ "./src/streaming/protection/models/ProtectionModel_01b.js":
/*!****************************************************************!*\
  !*** ./src/streaming/protection/models/ProtectionModel_01b.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2118802__) {

"use strict";
__nested_webpack_require_2118802__.r(__webpack_exports__);
/* harmony import */ var _controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2118802__(/*! ../controllers/ProtectionKeyController */ "./src/streaming/protection/controllers/ProtectionKeyController.js");
/* harmony import */ var _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2118802__(/*! ../vo/NeedKey */ "./src/streaming/protection/vo/NeedKey.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2118802__(/*! ../../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2118802__(/*! ../vo/KeyMessage */ "./src/streaming/protection/vo/KeyMessage.js");
/* harmony import */ var _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2118802__(/*! ../vo/KeySystemConfiguration */ "./src/streaming/protection/vo/KeySystemConfiguration.js");
/* harmony import */ var _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2118802__(/*! ../vo/KeySystemAccess */ "./src/streaming/protection/vo/KeySystemAccess.js");
/* harmony import */ var _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2118802__(/*! ../errors/ProtectionErrors */ "./src/streaming/protection/errors/ProtectionErrors.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Initial implementation of EME
 *
 * Implemented by Google Chrome prior to v36
 *
 * @implements ProtectionModel
 * @class
 */








function ProtectionModel_01b(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module

  var events = config.events;
  var debug = config.debug;
  var api = config.api;
  var errHandler = config.errHandler;
  var instance, logger, videoElement, keySystem, protectionKeyController, // With this version of the EME APIs, sessionIds are not assigned to
  // sessions until the first key message is received.  We are assuming
  // that in the case of multiple sessions, key messages will be received
  // in the order that generateKeyRequest() is called.
  // Holding spot for newly-created sessions until we determine whether or
  // not the CDM supports sessionIds
  pendingSessions, // List of sessions that have been initialized.  Only the first position will
  // be used in the case that the CDM does not support sessionIds
  sessions, // Not all CDMs support the notion of sessionIds.  Without sessionIds
  // there is no way for us to differentiate between sessions, therefore
  // we must only allow a single session.  Once we receive the first key
  // message we can set this flag to determine if more sessions are allowed
  moreSessionsAllowed, // This is our main event handler for all desired HTMLMediaElement events
  // related to EME.  These events are translated into our API-independent
  // versions of the same events
  eventHandler;

  function setup() {
    logger = debug.getLogger(instance);
    videoElement = null;
    keySystem = null;
    pendingSessions = [];
    sessions = [];
    protectionKeyController = Object(_controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
    eventHandler = createEventHandler();
  }

  function reset() {
    if (videoElement) {
      removeEventListeners();
    }

    for (var i = 0; i < sessions.length; i++) {
      closeKeySession(sessions[i]);
    }

    eventBus.trigger(events.TEARDOWN_COMPLETE);
  }

  function getAllInitData() {
    var retVal = [];

    for (var i = 0; i < pendingSessions.length; i++) {
      retVal.push(pendingSessions[i].initData);
    }

    for (var _i = 0; _i < sessions.length; _i++) {
      retVal.push(sessions[_i].initData);
    }

    return retVal;
  }

  function getSessions() {
    return sessions.concat(pendingSessions);
  }

  function requestKeySystemAccess(ksConfigurations) {
    return new Promise(function (resolve, reject) {
      var ve = videoElement;

      if (!ve) {
        // Must have a video element to do this capability tests
        ve = document.createElement('video');
      } // Try key systems in order, first one with supported key system configuration
      // is used


      var found = false;

      for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
        var systemString = ksConfigurations[ksIdx].ks.systemString;
        var configs = ksConfigurations[ksIdx].configs;
        var supportedAudio = null;
        var supportedVideo = null; // Try key system configs in order, first one with supported audio/video
        // is used

        for (var configIdx = 0; configIdx < configs.length; configIdx++) {
          //let audios = configs[configIdx].audioCapabilities;
          var videos = configs[configIdx].videoCapabilities; // Look for supported video container/codecs

          if (videos && videos.length !== 0) {
            supportedVideo = []; // Indicates that we have a requested video config

            for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
              if (ve.canPlayType(videos[videoIdx].contentType, systemString) !== '') {
                supportedVideo.push(videos[videoIdx]);
              }
            }
          } // No supported audio or video in this configuration OR we have
          // requested audio or video configuration that is not supported


          if (!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0) {
            continue;
          } // This configuration is supported


          found = true;
          var ksConfig = new _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_4__["default"](supportedAudio, supportedVideo);
          var ks = protectionKeyController.getKeySystemBySystemString(systemString);
          var keySystemAccess = new _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_5__["default"](ks, ksConfig);
          eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
            data: keySystemAccess
          });
          resolve({
            data: keySystemAccess
          });
          break;
        }
      }

      if (!found) {
        var errorMessage = 'Key system access denied! -- No valid audio/video content configurations detected!';
        eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
          error: errorMessage
        });
        reject({
          error: errorMessage
        });
      }
    });
  }

  function selectKeySystem(keySystemAccess) {
    keySystem = keySystemAccess.keySystem;
    return Promise.resolve(keySystem);
  }

  function setMediaElement(mediaElement) {
    if (videoElement === mediaElement) {
      return;
    } // Replacing the previous element


    if (videoElement) {
      removeEventListeners(); // Close any open sessions - avoids memory leak on LG webOS 2016/2017 TVs

      for (var i = 0; i < sessions.length; i++) {
        closeKeySession(sessions[i]);
      }

      sessions = [];
    }

    videoElement = mediaElement; // Only if we are not detaching from the existing element

    if (videoElement) {
      videoElement.addEventListener(api.keyerror, eventHandler);
      videoElement.addEventListener(api.needkey, eventHandler);
      videoElement.addEventListener(api.keymessage, eventHandler);
      videoElement.addEventListener(api.keyadded, eventHandler);
      eventBus.trigger(events.VIDEO_ELEMENT_SELECTED);
    }
  }

  function createKeySession(ksInfo) {
    if (!keySystem) {
      throw new Error('Can not create sessions until you have selected a key system');
    } // Determine if creating a new session is allowed


    if (moreSessionsAllowed || sessions.length === 0) {
      var newSession = {
        // Implements SessionToken
        sessionId: null,
        keyId: ksInfo.keyId,
        initData: ksInfo.initData,
        getKeyId: function getKeyId() {
          return this.keyId;
        },
        getSessionId: function getSessionId() {
          return this.sessionId;
        },
        getExpirationTime: function getExpirationTime() {
          return NaN;
        },
        getSessionType: function getSessionType() {
          return 'temporary';
        }
      };
      pendingSessions.push(newSession); // Send our request to the CDM

      videoElement[api.generateKeyRequest](keySystem.systemString, new Uint8Array(ksInfo.initData));
      return newSession;
    } else {
      throw new Error('Multiple sessions not allowed!');
    }
  }

  function updateKeySession(sessionToken, message) {
    var sessionId = sessionToken.sessionId;

    if (!protectionKeyController.isClearKey(keySystem)) {
      // Send our request to the CDM
      videoElement[api.addKey](keySystem.systemString, new Uint8Array(message), new Uint8Array(sessionToken.initData), sessionId);
    } else {
      // For clearkey, message is a ClearKeyKeySet
      for (var i = 0; i < message.keyPairs.length; i++) {
        videoElement[api.addKey](keySystem.systemString, message.keyPairs[i].key, message.keyPairs[i].keyID, sessionId);
      }
    }

    eventBus.trigger(events.KEY_SESSION_UPDATED);
  }

  function closeKeySession(sessionToken) {
    // Send our request to the CDM
    try {
      videoElement[api.cancelKeyRequest](keySystem.systemString, sessionToken.sessionId);
    } catch (error) {
      eventBus.trigger(events.KEY_SESSION_CLOSED, {
        data: null,
        error: 'Error closing session (' + sessionToken.sessionId + ') ' + error.message
      });
    }
  }

  function setServerCertificate()
  /*serverCertificate*/
  {
    /* Not supported */
  }

  function loadKeySession()
  /*ksInfo*/
  {
    /* Not supported */
  }

  function removeKeySession()
  /*sessionToken*/
  {
    /* Not supported */
  }

  function createEventHandler() {
    return {
      handleEvent: function handleEvent(event) {
        var sessionToken = null;

        switch (event.type) {
          case api.needkey:
            var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
            eventBus.trigger(events.NEED_KEY, {
              key: new _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__["default"](initData, 'cenc')
            });
            break;

          case api.keyerror:
            sessionToken = findSessionByID(sessions, event.sessionId);

            if (!sessionToken) {
              sessionToken = findSessionByID(pendingSessions, event.sessionId);
            }

            if (sessionToken) {
              var code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_CODE;
              var msg = '';

              switch (event.errorCode.code) {
                case 1:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_UNKNOWN_CODE;
                  msg += 'MEDIA_KEYERR_UNKNOWN - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_UNKNOWN_MESSAGE;
                  break;

                case 2:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_CLIENT_CODE;
                  msg += 'MEDIA_KEYERR_CLIENT - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_CLIENT_MESSAGE;
                  break;

                case 3:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_SERVICE_CODE;
                  msg += 'MEDIA_KEYERR_SERVICE - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_SERVICE_MESSAGE;
                  break;

                case 4:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_OUTPUT_CODE;
                  msg += 'MEDIA_KEYERR_OUTPUT - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_OUTPUT_MESSAGE;
                  break;

                case 5:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_HARDWARECHANGE_CODE;
                  msg += 'MEDIA_KEYERR_HARDWARECHANGE - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;
                  break;

                case 6:
                  code = _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_DOMAIN_CODE;
                  msg += 'MEDIA_KEYERR_DOMAIN - ' + _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEYERR_DOMAIN_MESSAGE;
                  break;
              }

              msg += '  System Code = ' + event.systemCode; // TODO: Build error string based on key error

              eventBus.trigger(events.KEY_ERROR, {
                error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_2__["default"](code, msg, sessionToken)
              });
            } else {
              logger.error('No session token found for key error');
            }

            break;

          case api.keyadded:
            sessionToken = findSessionByID(sessions, event.sessionId);

            if (!sessionToken) {
              sessionToken = findSessionByID(pendingSessions, event.sessionId);
            }

            if (sessionToken) {
              logger.debug('DRM: Key added.');
              eventBus.trigger(events.KEY_ADDED, {
                data: sessionToken
              }); //TODO not sure anything is using sessionToken? why there?
            } else {
              logger.debug('No session token found for key added');
            }

            break;

          case api.keymessage:
            // If this CDM does not support session IDs, we will be limited
            // to a single session
            moreSessionsAllowed = event.sessionId !== null && event.sessionId !== undefined; // SessionIDs supported

            if (moreSessionsAllowed) {
              // Attempt to find an uninitialized token with this sessionId
              sessionToken = findSessionByID(sessions, event.sessionId);

              if (!sessionToken && pendingSessions.length > 0) {
                // This is the first message for our latest session, so set the
                // sessionId and add it to our list
                sessionToken = pendingSessions.shift();
                sessions.push(sessionToken);
                sessionToken.sessionId = event.sessionId;
                eventBus.trigger(events.KEY_SESSION_CREATED, {
                  data: sessionToken
                });
              }
            } else if (pendingSessions.length > 0) {
              // SessionIDs not supported
              sessionToken = pendingSessions.shift();
              sessions.push(sessionToken);

              if (pendingSessions.length !== 0) {
                errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_2__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEY_MESSAGE_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIA_KEY_MESSAGE_ERROR_MESSAGE));
              }
            }

            if (sessionToken) {
              var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message; // For ClearKey, the spec mandates that you pass this message to the
              // addKey method, so we always save it to the token since there is no
              // way to tell which key system is in use

              sessionToken.keyMessage = message;
              eventBus.trigger(events.INTERNAL_KEY_MESSAGE, {
                data: new _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_3__["default"](sessionToken, message, event.defaultURL)
              });
            } else {
              logger.warn('No session token found for key message');
            }

            break;
        }
      }
    };
  }
  /**
   * Helper function to retrieve the stored session token based on a given
   * sessionId value
   *
   * @param {Array} sessionArray - the array of sessions to search
   * @param {*} sessionId - the sessionId to search for
   * @returns {*} the session token with the given sessionId
   */


  function findSessionByID(sessionArray, sessionId) {
    if (!sessionId || !sessionArray) {
      return null;
    } else {
      var len = sessionArray.length;

      for (var i = 0; i < len; i++) {
        if (sessionArray[i].sessionId == sessionId) {
          return sessionArray[i];
        }
      }

      return null;
    }
  }

  function removeEventListeners() {
    videoElement.removeEventListener(api.keyerror, eventHandler);
    videoElement.removeEventListener(api.needkey, eventHandler);
    videoElement.removeEventListener(api.keymessage, eventHandler);
    videoElement.removeEventListener(api.keyadded, eventHandler);
  }

  instance = {
    getAllInitData: getAllInitData,
    getSessions: getSessions,
    requestKeySystemAccess: requestKeySystemAccess,
    selectKeySystem: selectKeySystem,
    setMediaElement: setMediaElement,
    createKeySession: createKeySession,
    updateKeySession: updateKeySession,
    closeKeySession: closeKeySession,
    setServerCertificate: setServerCertificate,
    loadKeySession: loadKeySession,
    removeKeySession: removeKeySession,
    stop: reset,
    reset: reset
  };
  setup();
  return instance;
}

ProtectionModel_01b.__dashjs_factory_name = 'ProtectionModel_01b';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(ProtectionModel_01b));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/models/ProtectionModel_21Jan2015.js":
/*!**********************************************************************!*\
  !*** ./src/streaming/protection/models/ProtectionModel_21Jan2015.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2139110__) {

"use strict";
__nested_webpack_require_2139110__.r(__webpack_exports__);
/* harmony import */ var _controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2139110__(/*! ../controllers/ProtectionKeyController */ "./src/streaming/protection/controllers/ProtectionKeyController.js");
/* harmony import */ var _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2139110__(/*! ../vo/NeedKey */ "./src/streaming/protection/vo/NeedKey.js");
/* harmony import */ var _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2139110__(/*! ../errors/ProtectionErrors */ "./src/streaming/protection/errors/ProtectionErrors.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2139110__(/*! ../../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2139110__(/*! ../vo/KeyMessage */ "./src/streaming/protection/vo/KeyMessage.js");
/* harmony import */ var _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2139110__(/*! ../vo/KeySystemAccess */ "./src/streaming/protection/vo/KeySystemAccess.js");
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2139110__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Most recent EME implementation
 *
 * Implemented by Google Chrome v36+ (Windows, OSX, Linux)
 *
 * @implements ProtectionModel
 * @class
 */







var SYSTEM_STRING_PRIORITY = {};
SYSTEM_STRING_PRIORITY[_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PLAYREADY_KEYSTEM_STRING] = [_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PLAYREADY_KEYSTEM_STRING, _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].PLAYREADY_RECOMMENDATION_KEYSTEM_STRING];
SYSTEM_STRING_PRIORITY[_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].WIDEVINE_KEYSTEM_STRING] = [_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].WIDEVINE_KEYSTEM_STRING];
SYSTEM_STRING_PRIORITY[_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].CLEARKEY_KEYSTEM_STRING] = [_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].CLEARKEY_KEYSTEM_STRING];

function ProtectionModel_21Jan2015(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module

  var events = config.events;
  var debug = config.debug;
  var instance, logger, keySystem, videoElement, mediaKeys, sessions, eventHandler, protectionKeyController;

  function setup() {
    logger = debug.getLogger(instance);
    keySystem = null;
    videoElement = null;
    mediaKeys = null;
    sessions = [];
    protectionKeyController = Object(_controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
    eventHandler = createEventHandler();
  }

  function reset() {
    var numSessions = sessions.length;
    var session;

    if (numSessions !== 0) {
      (function () {
        // Called when we are done closing a session.  Success or fail
        var done = function done(session) {
          removeSession(session);

          if (sessions.length === 0) {
            if (videoElement) {
              videoElement.removeEventListener('encrypted', eventHandler);
              videoElement.setMediaKeys(null).then(function () {
                eventBus.trigger(events.TEARDOWN_COMPLETE);
              });
            } else {
              eventBus.trigger(events.TEARDOWN_COMPLETE);
            }
          }
        };

        for (var i = 0; i < numSessions; i++) {
          session = sessions[i];

          (function (s) {
            // Override closed promise resolver
            session.session.closed.then(function () {
              done(s);
            }); // Close the session and handle errors, otherwise promise
            // resolver above will be called

            _closeKeySessionInternal(session)["catch"](function () {
              done(s);
            });
          })(session);
        }
      })();
    } else {
      eventBus.trigger(events.TEARDOWN_COMPLETE);
    }
  }

  function stop() {
    // Close and remove not usable sessions
    var session;

    for (var i = 0; i < sessions.length; i++) {
      session = sessions[i];

      if (!session.getUsable()) {
        _closeKeySessionInternal(session)["catch"](function () {
          removeSession(session);
        });
      }
    }
  }

  function getAllInitData() {
    var retVal = [];

    for (var i = 0; i < sessions.length; i++) {
      if (sessions[i].initData) {
        retVal.push(sessions[i].initData);
      }
    }

    return retVal;
  }

  function getSessions() {
    return sessions;
  }

  function requestKeySystemAccess(ksConfigurations) {
    return new Promise(function (resolve, reject) {
      _requestKeySystemAccessInternal(ksConfigurations, 0, resolve, reject);
    });
  }
  /**
   * Initializes access to a key system. Once we found a valid configuration we get a mediaKeySystemAccess object
   * @param ksConfigurations
   * @param idx
   * @param resolve
   * @param reject
   * @private
   */


  function _requestKeySystemAccessInternal(ksConfigurations, idx, resolve, reject) {
    // In case requestMediaKeySystemAccess is not available we can not proceed and dispatch an error
    if (navigator.requestMediaKeySystemAccess === undefined || typeof navigator.requestMediaKeySystemAccess !== 'function') {
      var msg = 'Insecure origins are not allowed';
      eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
        error: msg
      });
      reject({
        error: msg
      });
      return;
    } // If a systemStringPriority is defined by the application we use these values. Otherwise we use the default system string
    // This is useful for DRM systems such as Playready for which multiple system strings are possible for instance com.microsoft.playready and com.microsoft.playready.recommendation


    var protDataSystemStringPriority = ksConfigurations[idx].protData && ksConfigurations[idx].protData.systemStringPriority ? ksConfigurations[idx].protData.systemStringPriority : null;
    var configs = ksConfigurations[idx].configs;
    var currentKeySystem = ksConfigurations[idx].ks;
    var systemString = currentKeySystem.systemString; // Use the default values in case no values are provided by the application

    var systemStringsToApply = protDataSystemStringPriority ? protDataSystemStringPriority : SYSTEM_STRING_PRIORITY[systemString] ? SYSTEM_STRING_PRIORITY[systemString] : [systemString]; // Check all the available system strings and the available configurations for support

    _checkAccessForKeySystem(systemStringsToApply, configs).then(function (mediaKeySystemAccess) {
      var configuration = typeof mediaKeySystemAccess.getConfiguration === 'function' ? mediaKeySystemAccess.getConfiguration() : null;
      var keySystemAccess = new _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_5__["default"](currentKeySystem, configuration);
      keySystemAccess.mksa = mediaKeySystemAccess;
      eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
        data: keySystemAccess
      });
      resolve({
        data: keySystemAccess
      });
    })["catch"](function (e) {
      if (idx + 1 < ksConfigurations.length) {
        _requestKeySystemAccessInternal(ksConfigurations, idx + 1, resolve, reject);
      } else {
        var errorMessage = 'Key system access denied! ';
        eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
          error: errorMessage + e.message
        });
        reject({
          error: errorMessage + e.message
        });
      }
    });
  }
  /**
   * For a specific key system: Iterate over the possible system strings and resolve once a valid configuration was found
   * @param {array} systemStringsToApply
   * @param {object} configs
   * @return {Promise}
   * @private
   */


  function _checkAccessForKeySystem(systemStringsToApply, configs) {
    return new Promise(function (resolve, reject) {
      _checkAccessForSystemStrings(systemStringsToApply, configs, 0, resolve, reject);
    });
  }
  /**
   * Recursively iterate over the possible system strings until a supported configuration is found or we ran out of options
   * @param {array} systemStringsToApply
   * @param {object} configs
   * @param {number} idx
   * @param {function} resolve
   * @param {function} reject
   * @private
   */


  function _checkAccessForSystemStrings(systemStringsToApply, configs, idx, resolve, reject) {
    var systemString = systemStringsToApply[idx];
    logger.debug("Requesting key system access for system string ".concat(systemString));
    navigator.requestMediaKeySystemAccess(systemString, configs).then(function (mediaKeySystemAccess) {
      mediaKeySystemAccess.selectedSystemString = systemString;
      resolve(mediaKeySystemAccess);
    })["catch"](function (e) {
      if (idx + 1 < systemStringsToApply.length) {
        _checkAccessForSystemStrings(systemStringsToApply, configs, idx + 1, resolve, reject);
      } else {
        reject(e);
      }
    });
  }
  /**
   * Selects a key system by creating the mediaKeys and adding them to the video element
   * @param keySystemAccess
   * @return {Promise<unknown>}
   */


  function selectKeySystem(keySystemAccess) {
    return new Promise(function (resolve, reject) {
      keySystemAccess.mksa.createMediaKeys().then(function (mkeys) {
        keySystem = keySystemAccess.keySystem;
        mediaKeys = mkeys;

        if (videoElement) {
          return videoElement.setMediaKeys(mediaKeys);
        } else {
          return Promise.resolve();
        }
      }).then(function () {
        resolve(keySystem);
      })["catch"](function () {
        reject({
          error: 'Error selecting keys system (' + keySystemAccess.keySystem.systemString + ')! Could not create MediaKeys -- TODO'
        });
      });
    });
  }

  function setMediaElement(mediaElement) {
    if (videoElement === mediaElement) return; // Replacing the previous element

    if (videoElement) {
      videoElement.removeEventListener('encrypted', eventHandler);

      if (videoElement.setMediaKeys) {
        videoElement.setMediaKeys(null);
      }
    }

    videoElement = mediaElement; // Only if we are not detaching from the existing element

    if (videoElement) {
      videoElement.addEventListener('encrypted', eventHandler);

      if (videoElement.setMediaKeys && mediaKeys) {
        videoElement.setMediaKeys(mediaKeys);
      }
    }
  }

  function setServerCertificate(serverCertificate) {
    if (!keySystem || !mediaKeys) {
      throw new Error('Can not set server certificate until you have selected a key system');
    }

    mediaKeys.setServerCertificate(serverCertificate).then(function () {
      logger.info('DRM: License server certificate successfully updated.');
      eventBus.trigger(events.SERVER_CERTIFICATE_UPDATED);
    })["catch"](function (error) {
      eventBus.trigger(events.SERVER_CERTIFICATE_UPDATED, {
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].SERVER_CERTIFICATE_UPDATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE + error.name)
      });
    });
  }
  /**
   * Create a key session, a session token and initialize a request by calling generateRequest
   * @param ksInfo
   */


  function createKeySession(ksInfo) {
    if (!keySystem || !mediaKeys) {
      throw new Error('Can not create sessions until you have selected a key system');
    }

    var session = mediaKeys.createSession(ksInfo.sessionType);
    var sessionToken = createSessionToken(session, ksInfo); // The "keyids" type is used for Clearkey when keys are provided directly in the protection data and a request to a license server is not needed

    var dataType = keySystem.systemString === _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].CLEARKEY_KEYSTEM_STRING && (ksInfo.initData || ksInfo.protData && ksInfo.protData.clearkeys) ? _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].INITIALIZATION_DATA_TYPE_KEYIDS : _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_6__["default"].INITIALIZATION_DATA_TYPE_CENC;
    session.generateRequest(dataType, ksInfo.initData).then(function () {
      logger.debug('DRM: Session created.  SessionID = ' + sessionToken.getSessionId());
      eventBus.trigger(events.KEY_SESSION_CREATED, {
        data: sessionToken
      });
    })["catch"](function (error) {
      removeSession(sessionToken);
      eventBus.trigger(events.KEY_SESSION_CREATED, {
        data: null,
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_MESSAGE + 'Error generating key request -- ' + error.name)
      });
    });
  }

  function updateKeySession(sessionToken, message) {
    var session = sessionToken.session; // Send our request to the key session

    if (protectionKeyController.isClearKey(keySystem)) {
      message = message.toJWK();
    }

    session.update(message).then(function () {
      eventBus.trigger(events.KEY_SESSION_UPDATED);
    })["catch"](function (error) {
      eventBus.trigger(events.KEY_ERROR, {
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].MEDIA_KEYERR_CODE, 'Error sending update() message! ' + error.name, sessionToken)
      });
    });
  }

  function loadKeySession(ksInfo) {
    if (!keySystem || !mediaKeys) {
      throw new Error('Can not load sessions until you have selected a key system');
    }

    var sessionId = ksInfo.sessionId; // Check if session Id is not already loaded or loading

    for (var i = 0; i < sessions.length; i++) {
      if (sessionId === sessions[i].sessionId) {
        logger.warn('DRM: Ignoring session ID because we have already seen it!');
        return;
      }
    }

    var session = mediaKeys.createSession(ksInfo.sessionType);
    var sessionToken = createSessionToken(session, ksInfo); // Load persisted session data into our newly created session object

    session.load(sessionId).then(function (success) {
      if (success) {
        logger.debug('DRM: Session loaded.  SessionID = ' + sessionToken.getSessionId());
        eventBus.trigger(events.KEY_SESSION_CREATED, {
          data: sessionToken
        });
      } else {
        removeSession(sessionToken);
        eventBus.trigger(events.KEY_SESSION_CREATED, {
          data: null,
          error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_MESSAGE + 'Could not load session! Invalid Session ID (' + sessionId + ')')
        });
      }
    })["catch"](function (error) {
      removeSession(sessionToken);
      eventBus.trigger(events.KEY_SESSION_CREATED, {
        data: null,
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_SESSION_CREATED_ERROR_MESSAGE + 'Could not load session (' + sessionId + ')! ' + error.name)
      });
    });
  }

  function removeKeySession(sessionToken) {
    var session = sessionToken.session;
    session.remove().then(function () {
      logger.debug('DRM: Session removed.  SessionID = ' + sessionToken.getSessionId());
      eventBus.trigger(events.KEY_SESSION_REMOVED, {
        data: sessionToken.getSessionId()
      });
    }, function (error) {
      eventBus.trigger(events.KEY_SESSION_REMOVED, {
        data: null,
        error: 'Error removing session (' + sessionToken.getSessionId() + '). ' + error.name
      });
    });
  }

  function closeKeySession(sessionToken) {
    // Send our request to the key session
    _closeKeySessionInternal(sessionToken)["catch"](function (error) {
      removeSession(sessionToken);
      eventBus.trigger(events.KEY_SESSION_CLOSED, {
        data: null,
        error: 'Error closing session (' + sessionToken.getSessionId() + ') ' + error.name
      });
    });
  }

  function _closeKeySessionInternal(sessionToken) {
    var session = sessionToken.session; // Remove event listeners

    session.removeEventListener('keystatuseschange', sessionToken);
    session.removeEventListener('message', sessionToken); // Send our request to the key session

    return session.close();
  } // This is our main event handler for all desired HTMLMediaElement events
  // related to EME.  These events are translated into our API-independent
  // versions of the same events


  function createEventHandler() {
    return {
      handleEvent: function handleEvent(event) {
        switch (event.type) {
          case 'encrypted':
            if (event.initData) {
              var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
              eventBus.trigger(events.NEED_KEY, {
                key: new _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__["default"](initData, event.initDataType)
              });
            }

            break;
        }
      }
    };
  }

  function removeSession(token) {
    // Remove from our session list
    for (var i = 0; i < sessions.length; i++) {
      if (sessions[i] === token) {
        sessions.splice(i, 1);
        break;
      }
    }
  }

  function parseKeyStatus(args) {
    // Edge and Chrome implement different version of keystatues, param are not on same order
    var status, keyId;

    if (args && args.length > 0) {
      if (args[0]) {
        if (typeof args[0] === 'string') {
          status = args[0];
        } else {
          keyId = args[0];
        }
      }

      if (args[1]) {
        if (typeof args[1] === 'string') {
          status = args[1];
        } else {
          keyId = args[1];
        }
      }
    }

    return {
      status: status,
      keyId: keyId
    };
  } // Function to create our session token objects which manage the EME
  // MediaKeySession and session-specific event handler


  function createSessionToken(session, ksInfo) {
    var token = {
      // Implements SessionToken
      session: session,
      keyId: ksInfo.keyId,
      initData: ksInfo.initData,
      sessionId: ksInfo.sessionId,
      sessionType: ksInfo.sessionType,
      // This is our main event handler for all desired MediaKeySession events
      // These events are translated into our API-independent versions of the
      // same events
      handleEvent: function handleEvent(event) {
        switch (event.type) {
          case 'keystatuseschange':
            eventBus.trigger(events.KEY_STATUSES_CHANGED, {
              data: this
            });
            event.target.keyStatuses.forEach(function () {
              var keyStatus = parseKeyStatus(arguments);

              switch (keyStatus.status) {
                case 'expired':
                  eventBus.trigger(events.INTERNAL_KEY_STATUS_CHANGED, {
                    error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_3__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE, _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_2__["default"].KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE)
                  });
                  break;

                default:
                  eventBus.trigger(events.INTERNAL_KEY_STATUS_CHANGED, keyStatus);
                  break;
              }
            });
            break;

          case 'message':
            var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
            eventBus.trigger(events.INTERNAL_KEY_MESSAGE, {
              data: new _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_4__["default"](this, message, undefined, event.messageType)
            });
            break;
        }
      },
      getKeyId: function getKeyId() {
        return this.keyId;
      },
      getSessionId: function getSessionId() {
        return session.sessionId;
      },
      getSessionType: function getSessionType() {
        return this.sessionType;
      },
      getExpirationTime: function getExpirationTime() {
        return session.expiration;
      },
      getKeyStatuses: function getKeyStatuses() {
        return session.keyStatuses;
      },
      getUsable: function getUsable() {
        var usable = false;
        session.keyStatuses.forEach(function () {
          var keyStatus = parseKeyStatus(arguments);

          if (keyStatus.status === 'usable') {
            usable = true;
          }
        });
        return usable;
      }
    }; // Add all event listeners

    session.addEventListener('keystatuseschange', token);
    session.addEventListener('message', token); // Register callback for session closed Promise

    session.closed.then(function () {
      removeSession(token);
      logger.debug('DRM: Session closed.  SessionID = ' + token.getSessionId());
      eventBus.trigger(events.KEY_SESSION_CLOSED, {
        data: token.getSessionId()
      });
    }); // Add to our session list

    sessions.push(token);
    return token;
  }

  instance = {
    getAllInitData: getAllInitData,
    getSessions: getSessions,
    requestKeySystemAccess: requestKeySystemAccess,
    selectKeySystem: selectKeySystem,
    setMediaElement: setMediaElement,
    setServerCertificate: setServerCertificate,
    createKeySession: createKeySession,
    updateKeySession: updateKeySession,
    loadKeySession: loadKeySession,
    removeKeySession: removeKeySession,
    closeKeySession: closeKeySession,
    stop: stop,
    reset: reset
  };
  setup();
  return instance;
}

ProtectionModel_21Jan2015.__dashjs_factory_name = 'ProtectionModel_21Jan2015';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(ProtectionModel_21Jan2015));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/models/ProtectionModel_3Feb2014.js":
/*!*********************************************************************!*\
  !*** ./src/streaming/protection/models/ProtectionModel_3Feb2014.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2164462__) {

"use strict";
__nested_webpack_require_2164462__.r(__webpack_exports__);
/* harmony import */ var _controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2164462__(/*! ../controllers/ProtectionKeyController */ "./src/streaming/protection/controllers/ProtectionKeyController.js");
/* harmony import */ var _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2164462__(/*! ../vo/NeedKey */ "./src/streaming/protection/vo/NeedKey.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2164462__(/*! ../../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2164462__(/*! ../errors/ProtectionErrors */ "./src/streaming/protection/errors/ProtectionErrors.js");
/* harmony import */ var _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2164462__(/*! ../vo/KeyMessage */ "./src/streaming/protection/vo/KeyMessage.js");
/* harmony import */ var _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2164462__(/*! ../vo/KeySystemConfiguration */ "./src/streaming/protection/vo/KeySystemConfiguration.js");
/* harmony import */ var _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2164462__(/*! ../vo/KeySystemAccess */ "./src/streaming/protection/vo/KeySystemAccess.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Implementation of the EME APIs as of the 3 Feb 2014 state of the specification.
 *
 * Implemented by Internet Explorer 11 (Windows 8.1)
 *
 * @implements ProtectionModel
 * @class
 */








function ProtectionModel_3Feb2014(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module

  var events = config.events;
  var debug = config.debug;
  var api = config.api;
  var instance, logger, videoElement, keySystem, mediaKeys, keySystemAccess, sessions, eventHandler, protectionKeyController;

  function setup() {
    logger = debug.getLogger(instance);
    videoElement = null;
    keySystem = null;
    mediaKeys = null;
    keySystemAccess = null;
    sessions = [];
    protectionKeyController = Object(_controllers_ProtectionKeyController__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
    eventHandler = createEventHandler();
  }

  function reset() {
    try {
      for (var i = 0; i < sessions.length; i++) {
        closeKeySession(sessions[i]);
      }

      if (videoElement) {
        videoElement.removeEventListener(api.needkey, eventHandler);
      }

      eventBus.trigger(events.TEARDOWN_COMPLETE);
    } catch (error) {
      eventBus.trigger(events.TEARDOWN_COMPLETE, {
        error: 'Error tearing down key sessions and MediaKeys! -- ' + error.message
      });
    }
  }

  function getAllInitData() {
    var retVal = [];

    for (var i = 0; i < sessions.length; i++) {
      retVal.push(sessions[i].initData);
    }

    return retVal;
  }

  function getSessions() {
    return sessions;
  }

  function requestKeySystemAccess(ksConfigurations) {
    return new Promise(function (resolve, reject) {
      // Try key systems in order, first one with supported key system configuration
      // is used
      var found = false;

      for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
        var systemString = ksConfigurations[ksIdx].ks.systemString;
        var configs = ksConfigurations[ksIdx].configs;
        var supportedAudio = null;
        var supportedVideo = null; // Try key system configs in order, first one with supported audio/video
        // is used

        for (var configIdx = 0; configIdx < configs.length; configIdx++) {
          var audios = configs[configIdx].audioCapabilities;
          var videos = configs[configIdx].videoCapabilities; // Look for supported audio container/codecs

          if (audios && audios.length !== 0) {
            supportedAudio = []; // Indicates that we have a requested audio config

            for (var audioIdx = 0; audioIdx < audios.length; audioIdx++) {
              if (window[api.MediaKeys].isTypeSupported(systemString, audios[audioIdx].contentType)) {
                supportedAudio.push(audios[audioIdx]);
              }
            }
          } // Look for supported video container/codecs


          if (videos && videos.length !== 0) {
            supportedVideo = []; // Indicates that we have a requested video config

            for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
              if (window[api.MediaKeys].isTypeSupported(systemString, videos[videoIdx].contentType)) {
                supportedVideo.push(videos[videoIdx]);
              }
            }
          } // No supported audio or video in this configuration OR we have
          // requested audio or video configuration that is not supported


          if (!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0) {
            continue;
          } // This configuration is supported


          found = true;
          var ksConfig = new _vo_KeySystemConfiguration__WEBPACK_IMPORTED_MODULE_5__["default"](supportedAudio, supportedVideo);
          var ks = protectionKeyController.getKeySystemBySystemString(systemString);

          var _keySystemAccess = new _vo_KeySystemAccess__WEBPACK_IMPORTED_MODULE_6__["default"](ks, ksConfig);

          eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
            data: _keySystemAccess
          });
          resolve({
            data: _keySystemAccess
          });
          break;
        }
      }

      if (!found) {
        var errorMessage = 'Key system access denied! -- No valid audio/video content configurations detected!';
        eventBus.trigger(events.KEY_SYSTEM_ACCESS_COMPLETE, {
          error: errorMessage
        });
        reject({
          error: errorMessage
        });
      }
    });
  }

  function selectKeySystem(ksAccess) {
    return new Promise(function (resolve, reject) {
      try {
        mediaKeys = ksAccess.mediaKeys = new window[api.MediaKeys](ksAccess.keySystem.systemString);
        keySystem = ksAccess.keySystem;
        keySystemAccess = ksAccess;

        if (videoElement) {
          setMediaKeys();
        }

        resolve(keySystem);
      } catch (error) {
        reject({
          error: 'Error selecting keys system (' + keySystem.systemString + ')! Could not create MediaKeys -- TODO'
        });
      }
    });
  }

  function setMediaElement(mediaElement) {
    if (videoElement === mediaElement) return; // Replacing the previous element

    if (videoElement) {
      videoElement.removeEventListener(api.needkey, eventHandler);
    }

    videoElement = mediaElement; // Only if we are not detaching from the existing element

    if (videoElement) {
      videoElement.addEventListener(api.needkey, eventHandler);

      if (mediaKeys) {
        setMediaKeys();
      }
    }
  }

  function createKeySession(ksInfo) {
    if (!keySystem || !mediaKeys || !keySystemAccess) {
      throw new Error('Can not create sessions until you have selected a key system');
    } // Use the first video capability for the contentType.
    // TODO:  Not sure if there is a way to concatenate all capability data into a RFC6386-compatible format
    // If player is trying to playback Audio only stream - don't error out.


    var capabilities = null;

    if (keySystemAccess.ksConfiguration.videoCapabilities && keySystemAccess.ksConfiguration.videoCapabilities.length > 0) {
      capabilities = keySystemAccess.ksConfiguration.videoCapabilities[0];
    }

    if (capabilities === null && keySystemAccess.ksConfiguration.audioCapabilities && keySystemAccess.ksConfiguration.audioCapabilities.length > 0) {
      capabilities = keySystemAccess.ksConfiguration.audioCapabilities[0];
    }

    if (capabilities === null) {
      throw new Error('Can not create sessions for unknown content types.');
    }

    var contentType = capabilities.contentType;
    var session = mediaKeys.createSession(contentType, new Uint8Array(ksInfo.initData), ksInfo.cdmData ? new Uint8Array(ksInfo.cdmData) : null);
    var sessionToken = createSessionToken(session, ksInfo); // Add all event listeners

    session.addEventListener(api.error, sessionToken);
    session.addEventListener(api.message, sessionToken);
    session.addEventListener(api.ready, sessionToken);
    session.addEventListener(api.close, sessionToken); // Add to our session list

    sessions.push(sessionToken);
    logger.debug('DRM: Session created.  SessionID = ' + sessionToken.getSessionId());
    eventBus.trigger(events.KEY_SESSION_CREATED, {
      data: sessionToken
    });
  }

  function updateKeySession(sessionToken, message) {
    var session = sessionToken.session;

    if (!protectionKeyController.isClearKey(keySystem)) {
      // Send our request to the key session
      session.update(new Uint8Array(message));
    } else {
      // For clearkey, message is a ClearKeyKeySet
      session.update(new Uint8Array(message.toJWK()));
    }

    eventBus.trigger(events.KEY_SESSION_UPDATED);
  }
  /**
   * Close the given session and release all associated keys.  Following
   * this call, the sessionToken becomes invalid
   *
   * @param {Object} sessionToken - the session token
   */


  function closeKeySession(sessionToken) {
    var session = sessionToken.session; // Remove event listeners

    session.removeEventListener(api.error, sessionToken);
    session.removeEventListener(api.message, sessionToken);
    session.removeEventListener(api.ready, sessionToken);
    session.removeEventListener(api.close, sessionToken); // Remove from our session list

    for (var i = 0; i < sessions.length; i++) {
      if (sessions[i] === sessionToken) {
        sessions.splice(i, 1);
        break;
      }
    } // Send our request to the key session


    session[api.release]();
  }

  function setServerCertificate()
  /*serverCertificate*/
  {
    /* Not supported */
  }

  function loadKeySession()
  /*ksInfo*/
  {
    /* Not supported */
  }

  function removeKeySession()
  /*sessionToken*/
  {
    /* Not supported */
  }

  function createEventHandler() {
    return {
      handleEvent: function handleEvent(event) {
        switch (event.type) {
          case api.needkey:
            if (event.initData) {
              var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
              eventBus.trigger(events.NEED_KEY, {
                key: new _vo_NeedKey__WEBPACK_IMPORTED_MODULE_1__["default"](initData, 'cenc')
              });
            }

            break;
        }
      }
    };
  } // IE11 does not let you set MediaKeys until it has entered a certain
  // readyState, so we need this logic to ensure we don't set the keys
  // too early


  function setMediaKeys() {
    var boundDoSetKeys = null;

    var doSetKeys = function doSetKeys() {
      videoElement.removeEventListener('loadedmetadata', boundDoSetKeys);
      videoElement[api.setMediaKeys](mediaKeys);
      eventBus.trigger(events.VIDEO_ELEMENT_SELECTED);
    };

    if (videoElement.readyState >= 1) {
      doSetKeys();
    } else {
      boundDoSetKeys = doSetKeys.bind(this);
      videoElement.addEventListener('loadedmetadata', boundDoSetKeys);
    }
  } // Function to create our session token objects which manage the EME
  // MediaKeySession and session-specific event handler


  function createSessionToken(keySession, ksInfo) {
    return {
      // Implements SessionToken
      session: keySession,
      keyId: ksInfo.keyId,
      initData: ksInfo.initData,
      getKeyId: function getKeyId() {
        return this.keyId;
      },
      getSessionId: function getSessionId() {
        return this.session.sessionId;
      },
      getExpirationTime: function getExpirationTime() {
        return NaN;
      },
      getSessionType: function getSessionType() {
        return 'temporary';
      },
      // This is our main event handler for all desired MediaKeySession events
      // These events are translated into our API-independent versions of the
      // same events
      handleEvent: function handleEvent(event) {
        switch (event.type) {
          case api.error:
            var errorStr = 'KeyError'; // TODO: Make better string from event

            eventBus.trigger(events.KEY_ERROR, {
              error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_2__["default"](_errors_ProtectionErrors__WEBPACK_IMPORTED_MODULE_3__["default"].MEDIA_KEYERR_CODE, errorStr, this)
            });
            break;

          case api.message:
            var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
            eventBus.trigger(events.INTERNAL_KEY_MESSAGE, {
              data: new _vo_KeyMessage__WEBPACK_IMPORTED_MODULE_4__["default"](this, message, event.destinationURL)
            });
            break;

          case api.ready:
            logger.debug('DRM: Key added.');
            eventBus.trigger(events.KEY_ADDED);
            break;

          case api.close:
            logger.debug('DRM: Session closed.  SessionID = ' + this.getSessionId());
            eventBus.trigger(events.KEY_SESSION_CLOSED, {
              data: this.getSessionId()
            });
            break;
        }
      }
    };
  }

  instance = {
    getAllInitData: getAllInitData,
    getSessions: getSessions,
    requestKeySystemAccess: requestKeySystemAccess,
    selectKeySystem: selectKeySystem,
    setMediaElement: setMediaElement,
    createKeySession: createKeySession,
    updateKeySession: updateKeySession,
    closeKeySession: closeKeySession,
    setServerCertificate: setServerCertificate,
    loadKeySession: loadKeySession,
    removeKeySession: removeKeySession,
    stop: reset,
    reset: reset
  };
  setup();
  return instance;
}

ProtectionModel_3Feb2014.__dashjs_factory_name = 'ProtectionModel_3Feb2014';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(ProtectionModel_3Feb2014));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/servers/ClearKey.js":
/*!******************************************************!*\
  !*** ./src/streaming/protection/servers/ClearKey.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2181239__) {

"use strict";
__nested_webpack_require_2181239__.r(__webpack_exports__);
/* harmony import */ var _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2181239__(/*! ../vo/KeyPair */ "./src/streaming/protection/vo/KeyPair.js");
/* harmony import */ var _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2181239__(/*! ../vo/ClearKeyKeySet */ "./src/streaming/protection/vo/ClearKeyKeySet.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CableLabs ClearKey license server implementation
 *
 * For testing purposes and evaluating potential uses for ClearKey, we have developed
 * a dirt-simple API for requesting ClearKey licenses from a remote server.
 *
 * @implements LicenseServer
 * @class
 */



function ClearKey() {
  var instance;

  function getServerURLFromMessage(url
  /* message, messageType*/
  ) {
    return url;
  }

  function getHTTPMethod()
  /*messageType*/
  {
    return 'POST';
  }

  function getResponseType()
  /*keySystemStr*/
  {
    return 'json';
  }

  function getLicenseMessage(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    if (!serverResponse.hasOwnProperty('keys')) {
      return null;
    }

    var keyPairs = [];

    for (var i = 0; i < serverResponse.keys.length; i++) {
      var keypair = serverResponse.keys[i];
      var keyid = keypair.kid.replace(/=/g, '');
      var key = keypair.k.replace(/=/g, '');
      keyPairs.push(new _vo_KeyPair__WEBPACK_IMPORTED_MODULE_0__["default"](keyid, key));
    }

    return new _vo_ClearKeyKeySet__WEBPACK_IMPORTED_MODULE_1__["default"](keyPairs);
  }

  function getErrorResponse(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    return String.fromCharCode.apply(null, new Uint8Array(serverResponse));
  }

  instance = {
    getServerURLFromMessage: getServerURLFromMessage,
    getHTTPMethod: getHTTPMethod,
    getResponseType: getResponseType,
    getLicenseMessage: getLicenseMessage,
    getErrorResponse: getErrorResponse
  };
  return instance;
}

ClearKey.__dashjs_factory_name = 'ClearKey';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(ClearKey));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/servers/DRMToday.js":
/*!******************************************************!*\
  !*** ./src/streaming/protection/servers/DRMToday.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2185644__) {

"use strict";
__nested_webpack_require_2185644__.r(__webpack_exports__);
/* harmony import */ var _constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2185644__(/*! ../../constants/ProtectionConstants */ "./src/streaming/constants/ProtectionConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CastLabs DRMToday License Server implementation
 *
 * @implements LicenseServer
 * @class
 */


function DRMToday(config) {
  config = config || {};
  var BASE64 = config.BASE64;
  var keySystems = {};
  keySystems[_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_0__["default"].WIDEVINE_KEYSTEM_STRING] = {
    responseType: 'json',
    getLicenseMessage: function getLicenseMessage(response) {
      return BASE64.decodeArray(response.license);
    },
    getErrorResponse: function getErrorResponse(response) {
      return response;
    }
  };
  keySystems[_constants_ProtectionConstants__WEBPACK_IMPORTED_MODULE_0__["default"].PLAYREADY_KEYSTEM_STRING] = {
    responseType: 'arraybuffer',
    getLicenseMessage: function getLicenseMessage(response) {
      return response;
    },
    getErrorResponse: function getErrorResponse(response) {
      return String.fromCharCode.apply(null, new Uint8Array(response));
    }
  };
  var instance;

  function checkConfig() {
    if (!BASE64 || !BASE64.hasOwnProperty('decodeArray')) {
      throw new Error('Missing config parameter(s)');
    }
  }

  function getServerURLFromMessage(url
  /*, message, messageType*/
  ) {
    return url;
  }

  function getHTTPMethod()
  /*messageType*/
  {
    return 'POST';
  }

  function getResponseType(keySystemStr
  /*, messageType*/
  ) {
    return keySystems[keySystemStr].responseType;
  }

  function getLicenseMessage(serverResponse, keySystemStr
  /*, messageType*/
  ) {
    checkConfig();
    return keySystems[keySystemStr].getLicenseMessage(serverResponse);
  }

  function getErrorResponse(serverResponse, keySystemStr
  /*, messageType*/
  ) {
    return keySystems[keySystemStr].getErrorResponse(serverResponse);
  }

  instance = {
    getServerURLFromMessage: getServerURLFromMessage,
    getHTTPMethod: getHTTPMethod,
    getResponseType: getResponseType,
    getLicenseMessage: getLicenseMessage,
    getErrorResponse: getErrorResponse
  };
  return instance;
}

DRMToday.__dashjs_factory_name = 'DRMToday';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(DRMToday));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/servers/PlayReady.js":
/*!*******************************************************!*\
  !*** ./src/streaming/protection/servers/PlayReady.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2190392__) {

"use strict";
__nested_webpack_require_2190392__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/* global escape: true */

/**
 * Microsoft PlayReady Test License Server
 *
 * For testing content that uses the PlayReady test server at
 *
 * @implements LicenseServer
 * @class
 * @ignore
 */
function PlayReady() {
  var instance;
  var soap = 'http://schemas.xmlsoap.org/soap/envelope/';

  function uintToString(arrayBuffer) {
    var encodedString = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
    var decodedString = decodeURIComponent(escape(encodedString));
    return decodedString;
  }

  function parseServerResponse(serverResponse) {
    if (window.DOMParser) {
      var stringResponse = uintToString(serverResponse);
      var parser = new window.DOMParser();
      var xmlDoc = parser.parseFromString(stringResponse, 'text/xml');
      var envelope = xmlDoc ? xmlDoc.getElementsByTagNameNS(soap, 'Envelope')[0] : null;
      var body = envelope ? envelope.getElementsByTagNameNS(soap, 'Body')[0] : null;
      var fault = body ? body.getElementsByTagNameNS(soap, 'Fault')[0] : null;

      if (fault) {
        return null;
      }
    }

    return serverResponse;
  }

  function parseErrorResponse(serverResponse) {
    var faultstring = '';
    var statusCode = '';
    var message = '';
    var idStart = -1;
    var idEnd = -1;

    if (window.DOMParser) {
      var stringResponse = uintToString(serverResponse);
      var parser = new window.DOMParser();
      var xmlDoc = parser.parseFromString(stringResponse, 'text/xml');
      var envelope = xmlDoc ? xmlDoc.getElementsByTagNameNS(soap, 'Envelope')[0] : null;
      var body = envelope ? envelope.getElementsByTagNameNS(soap, 'Body')[0] : null;
      var fault = body ? body.getElementsByTagNameNS(soap, 'Fault')[0] : null;
      var detail = fault ? fault.getElementsByTagName('detail')[0] : null;
      var exception = detail ? detail.getElementsByTagName('Exception')[0] : null;
      var node = null;

      if (fault === null) {
        return stringResponse;
      }

      node = fault.getElementsByTagName('faultstring')[0].firstChild;
      faultstring = node ? node.nodeValue : null;

      if (exception !== null) {
        node = exception.getElementsByTagName('StatusCode')[0];
        statusCode = node ? node.firstChild.nodeValue : null;
        node = exception.getElementsByTagName('Message')[0];
        message = node ? node.firstChild.nodeValue : null;
        idStart = message ? message.lastIndexOf('[') + 1 : -1;
        idEnd = message ? message.indexOf(']') : -1;
        message = message ? message.substring(idStart, idEnd) : '';
      }
    }

    var errorString = "code: ".concat(statusCode, ", name: ").concat(faultstring);

    if (message) {
      errorString += ", message: ".concat(message);
    }

    return errorString;
  }

  function getServerURLFromMessage(url
  /*, message, messageType*/
  ) {
    return url;
  }

  function getHTTPMethod()
  /*messageType*/
  {
    return 'POST';
  }

  function getResponseType()
  /*keySystemStr, messageType*/
  {
    return 'arraybuffer';
  }

  function getLicenseMessage(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    return parseServerResponse.call(this, serverResponse);
  }

  function getErrorResponse(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    return parseErrorResponse.call(this, serverResponse);
  }

  instance = {
    getServerURLFromMessage: getServerURLFromMessage,
    getHTTPMethod: getHTTPMethod,
    getResponseType: getResponseType,
    getLicenseMessage: getLicenseMessage,
    getErrorResponse: getErrorResponse
  };
  return instance;
}

PlayReady.__dashjs_factory_name = 'PlayReady';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(PlayReady));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/servers/Widevine.js":
/*!******************************************************!*\
  !*** ./src/streaming/protection/servers/Widevine.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2196559__) {

"use strict";
__nested_webpack_require_2196559__.r(__webpack_exports__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @ignore
 */
function Widevine() {
  var instance;

  function getServerURLFromMessage(url
  /*, message, messageType*/
  ) {
    return url;
  }

  function getHTTPMethod()
  /*messageType*/
  {
    return 'POST';
  }

  function getResponseType()
  /*keySystemStr, messageType*/
  {
    return 'arraybuffer';
  }

  function getLicenseMessage(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    return serverResponse;
  }

  function getErrorResponse(serverResponse
  /*, keySystemStr, messageType*/
  ) {
    return String.fromCharCode.apply(null, new Uint8Array(serverResponse));
  }

  instance = {
    getServerURLFromMessage: getServerURLFromMessage,
    getHTTPMethod: getHTTPMethod,
    getResponseType: getResponseType,
    getLicenseMessage: getLicenseMessage,
    getErrorResponse: getErrorResponse
  };
  return instance;
}

Widevine.__dashjs_factory_name = 'Widevine';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getSingletonFactory(Widevine));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/protection/vo/ClearKeyKeySet.js":
/*!*******************************************************!*\
  !*** ./src/streaming/protection/vo/ClearKeyKeySet.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2199933__) {

"use strict";
__nested_webpack_require_2199933__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc A collection of ClearKey encryption keys with an (optional) associated
 *  type
 * @ignore
 */
var ClearKeyKeySet = /*#__PURE__*/function () {
  /**
   * @param {Array.<KeyPair>} keyPairs
   * @param {string} type the type of keys in this set.  One of either 'persistent'
   * or 'temporary'.  Can also be null or undefined.
   * @class
   * @ignore
   */
  function ClearKeyKeySet(keyPairs, type) {
    _classCallCheck(this, ClearKeyKeySet);

    if (type && type !== 'persistent' && type !== 'temporary') throw new Error('Invalid ClearKey key set type!  Must be one of \'persistent\' or \'temporary\'');
    this.keyPairs = keyPairs;
    this.type = type;
  }
  /**
   * Convert this key set to its JSON Web Key (JWK) representation
   *
   * @return {ArrayBuffer} JWK object UTF-8 encoded as ArrayBuffer
   */


  _createClass(ClearKeyKeySet, [{
    key: "toJWK",
    value: function toJWK() {
      var i;
      var numKeys = this.keyPairs.length;
      var jwk = {
        keys: []
      };

      for (i = 0; i < numKeys; i++) {
        var key = {
          kty: 'oct',
          alg: 'A128KW',
          kid: this.keyPairs[i].keyID,
          k: this.keyPairs[i].key
        };
        jwk.keys.push(key);
      }

      if (this.type) {
        jwk.type = this.type;
      }

      var jwkString = JSON.stringify(jwk);
      var len = jwkString.length; // Convert JSON string to ArrayBuffer

      var buf = new ArrayBuffer(len);
      var bView = new Uint8Array(buf);

      for (i = 0; i < len; i++) {
        bView[i] = jwkString.charCodeAt(i);
      }

      return buf;
    }
  }]);

  return ClearKeyKeySet;
}();

/* harmony default export */ __webpack_exports__["default"] = (ClearKeyKeySet);

/***/ }),

/***/ "./src/streaming/protection/vo/KeyMessage.js":
/*!***************************************************!*\
  !*** ./src/streaming/protection/vo/KeyMessage.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2204698__) {

"use strict";
__nested_webpack_require_2204698__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc EME-independent KeyMessage
 * @ignore
 */
var KeyMessage =
/**
 * @param {SessionToken} sessionToken the session
 * to which the key message is associated
 * @param {ArrayBuffer} message the key message
 * @param {string} defaultURL license acquisition URL provided by the CDM
 * @param {string} messageType Supported message types can be found
 * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @class
 */
function KeyMessage(sessionToken, message, defaultURL, messageType) {
  _classCallCheck(this, KeyMessage);

  this.sessionToken = sessionToken;
  this.message = message;
  this.defaultURL = defaultURL;
  this.messageType = messageType ? messageType : 'license-request';
};

/* harmony default export */ __webpack_exports__["default"] = (KeyMessage);

/***/ }),

/***/ "./src/streaming/protection/vo/KeyPair.js":
/*!************************************************!*\
  !*** ./src/streaming/protection/vo/KeyPair.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2207951__) {

"use strict";
__nested_webpack_require_2207951__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Represents a 128-bit keyID and 128-bit encryption key
 * @ignore
 */
var KeyPair =
/**
 * @param {string} keyID 128-bit key ID, base64 encoded, with no padding
 * @param {string} key 128-bit encryption key, base64 encoded, with no padding
 * @class
 * @ignore
 */
function KeyPair(keyID, key) {
  _classCallCheck(this, KeyPair);

  this.keyID = keyID;
  this.key = key;
};

/* harmony default export */ __webpack_exports__["default"] = (KeyPair);

/***/ }),

/***/ "./src/streaming/protection/vo/KeySystemAccess.js":
/*!********************************************************!*\
  !*** ./src/streaming/protection/vo/KeySystemAccess.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2210885__) {

"use strict";
__nested_webpack_require_2210885__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Creates a new key system access token.  Represents a valid key system for
 * given piece of content and key system requirements.  Used to initialize license
 * acquisition operations.
 * @ignore
 */
var KeySystemAccess =
/**
 * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
 * @param {KeySystemConfiguration} ksConfiguration the
 * subset of configurations passed to the key system access request that are supported
 * by this user agent
 * @class
 * @ignore
 */
function KeySystemAccess(keySystem, ksConfiguration) {
  _classCallCheck(this, KeySystemAccess);

  this.keySystem = keySystem;
  this.ksConfiguration = ksConfiguration;
};

/* harmony default export */ __webpack_exports__["default"] = (KeySystemAccess);

/***/ }),

/***/ "./src/streaming/protection/vo/KeySystemConfiguration.js":
/*!***************************************************************!*\
  !*** ./src/streaming/protection/vo/KeySystemConfiguration.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2214156__) {

"use strict";
__nested_webpack_require_2214156__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Represents a set of configurations that describe the capabilities desired for
 *  support by a given CDM
 * @ignore
 */
var KeySystemConfiguration =
/**
 * @param {Array.<MediaCapability>} audioCapabilities array of
 * desired audio capabilities.  Higher preference capabilities should be placed earlier
 * in the array.
 * @param {Array.<MediaCapability>} videoCapabilities array of
 * desired video capabilities.  Higher preference capabilities should be placed earlier
 * in the array.
 * @param {string} distinctiveIdentifier desired use of distinctive identifiers.
 * One of "required", "optional", or "not-allowed"
 * @param {string} persistentState desired support for persistent storage of
 * key systems.  One of "required", "optional", or "not-allowed"
 * @param {Array.<string>} sessionTypes List of session types that must
 * be supported by the key system
 * @class
 */
function KeySystemConfiguration(audioCapabilities, videoCapabilities, distinctiveIdentifier, persistentState, sessionTypes) {
  _classCallCheck(this, KeySystemConfiguration);

  this.initDataTypes = ['cenc'];

  if (audioCapabilities && audioCapabilities.length) {
    this.audioCapabilities = audioCapabilities;
  }

  if (videoCapabilities && videoCapabilities.length) {
    this.videoCapabilities = videoCapabilities;
  }

  this.distinctiveIdentifier = distinctiveIdentifier;
  this.persistentState = persistentState;
  this.sessionTypes = sessionTypes;
};

/* harmony default export */ __webpack_exports__["default"] = (KeySystemConfiguration);

/***/ }),

/***/ "./src/streaming/protection/vo/LicenseRequest.js":
/*!*******************************************************!*\
  !*** ./src/streaming/protection/vo/LicenseRequest.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2218193__) {

"use strict";
__nested_webpack_require_2218193__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Defines a license request
 * @ignore
 */
var LicenseRequest =
/**
 * Defines a license request
 *
 * @class
 */
function LicenseRequest(url, method, responseType, headers, withCredentials, messageType, sessionId, data) {
  _classCallCheck(this, LicenseRequest);

  /**
   * The license request url
   */
  this.url = url;
  /**
   * The HTTP method
   */

  this.method = method;
  /**
   * The HTTP response type
   */

  this.responseType = responseType;
  /**
   * The HTP request headers
   */

  this.headers = headers;
  /**
   * Wether request is done using credentials (cross-site cookies)
   */

  this.withCredentials = withCredentials;
  /**
   * The license request message type (see https://www.w3.org/TR/encrypted-media/#dom-mediakeymessagetype)
   */

  this.messageType = messageType;
  /**
   * The corresponding EME session ID
   */

  this.sessionId = sessionId;
  /**
   * The license request data
   */

  this.data = data;
};

/* harmony default export */ __webpack_exports__["default"] = (LicenseRequest);

/***/ }),

/***/ "./src/streaming/protection/vo/LicenseResponse.js":
/*!********************************************************!*\
  !*** ./src/streaming/protection/vo/LicenseResponse.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2221745__) {

"use strict";
__nested_webpack_require_2221745__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Defines a license response
 */
var LicenseResponse =
/**
 * Defines a license request
 *
 * @class
 * @ignore
 */
function LicenseResponse(url, headers, data) {
  _classCallCheck(this, LicenseResponse);

  /**
   * The url that was loaded, that can be redirected from original request url
   */
  this.url = url;
  /**
   * The HTP response headers
   */

  this.headers = headers;
  /**
   * The license response data
   */

  this.data = data;
};

/* harmony default export */ __webpack_exports__["default"] = (LicenseResponse);

/***/ }),

/***/ "./src/streaming/protection/vo/MediaCapability.js":
/*!********************************************************!*\
  !*** ./src/streaming/protection/vo/MediaCapability.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2224774__) {

"use strict";
__nested_webpack_require_2224774__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc A media capability
 * @ignore
 */
var MediaCapability =
/**
 * @param {string} contentType MIME type and codecs (RFC6386)
 * @param {string} robustness
 * @class
 * @ignore
 */
function MediaCapability(contentType, robustness) {
  _classCallCheck(this, MediaCapability);

  this.contentType = contentType;
  this.robustness = robustness;
};

/* harmony default export */ __webpack_exports__["default"] = (MediaCapability);

/***/ }),

/***/ "./src/streaming/protection/vo/NeedKey.js":
/*!************************************************!*\
  !*** ./src/streaming/protection/vo/NeedKey.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2227652__) {

"use strict";
__nested_webpack_require_2227652__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc NeedKey
 * @ignore
 */
var NeedKey =
/**
 * @param {ArrayBuffer} initData the initialization data
 * @param {string} initDataType initialization data type
 * @class
 */
function NeedKey(initData, initDataType) {
  _classCallCheck(this, NeedKey);

  this.initData = initData;
  this.initDataType = initDataType;
};

/* harmony default export */ __webpack_exports__["default"] = (NeedKey);

/***/ }),

/***/ "./src/streaming/rules/DroppedFramesHistory.js":
/*!*****************************************************!*\
  !*** ./src/streaming/rules/DroppedFramesHistory.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2230514__) {

"use strict";
__nested_webpack_require_2230514__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2230514__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");


function DroppedFramesHistory() {
  var values = {};
  var lastDroppedFrames = {};
  var lastTotalFrames = {};

  function push(streamId, index, playbackQuality) {
    if (!index) {
      return;
    }

    if (!values[streamId]) {
      values[streamId] = [];
      lastDroppedFrames[streamId] = 0;
      lastTotalFrames[streamId] = 0;
    }

    var droppedVideoFrames = playbackQuality && playbackQuality.droppedVideoFrames ? playbackQuality.droppedVideoFrames : 0;
    var totalVideoFrames = playbackQuality && playbackQuality.totalVideoFrames ? playbackQuality.totalVideoFrames : 0;
    var intervalDroppedFrames = droppedVideoFrames - lastDroppedFrames;
    lastDroppedFrames[streamId] = droppedVideoFrames;
    var intervalTotalFrames = totalVideoFrames - lastTotalFrames;
    lastTotalFrames[streamId] = totalVideoFrames;
    var current = values[streamId];

    if (!isNaN(index)) {
      if (!current[index]) {
        current[index] = {
          droppedVideoFrames: intervalDroppedFrames,
          totalVideoFrames: intervalTotalFrames
        };
      } else {
        current[index].droppedVideoFrames += intervalDroppedFrames;
        current[index].totalVideoFrames += intervalTotalFrames;
      }
    }
  }

  function getFrameHistory(streamId) {
    return values[streamId];
  }

  function clearForStream(streamId) {
    try {
      delete values[streamId];
      delete lastDroppedFrames[streamId];
      delete lastTotalFrames[streamId];
    } catch (e) {}
  }

  function reset() {
    values = {};
    lastDroppedFrames = {};
    lastTotalFrames = {};
  }

  return {
    push: push,
    getFrameHistory: getFrameHistory,
    clearForStream: clearForStream,
    reset: reset
  };
}

DroppedFramesHistory.__dashjs_factory_name = 'DroppedFramesHistory';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(DroppedFramesHistory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/rules/RulesContext.js":
/*!*********************************************!*\
  !*** ./src/streaming/rules/RulesContext.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2233086__) {

"use strict";
__nested_webpack_require_2233086__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2233086__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function RulesContext(config) {
  config = config || {};
  var instance;
  var abrController = config.abrController;
  var switchHistory = config.switchHistory;
  var droppedFramesHistory = config.droppedFramesHistory;
  var currentRequest = config.currentRequest;
  var bufferOccupancyABR = config.useBufferOccupancyABR;
  var l2AABR = config.useL2AABR;
  var loLP = config.useLoLPABR;
  var scheduleController = config.streamProcessor ? config.streamProcessor.getScheduleController() : null;
  var representationInfo = config.streamProcessor ? config.streamProcessor.getRepresentationInfo() : null;
  var videoModel = config.videoModel ? config.videoModel : null;

  function getMediaType() {
    var mediaInfo = getMediaInfo();
    return mediaInfo ? mediaInfo.type : null;
  }

  function getStreamInfo() {
    var mediaInfo = getMediaInfo();
    return mediaInfo ? mediaInfo.streamInfo : null;
  }

  function getMediaInfo() {
    return representationInfo ? representationInfo.mediaInfo : null;
  }

  function getRepresentationInfo() {
    return representationInfo;
  }

  function getScheduleController() {
    return scheduleController;
  }

  function getAbrController() {
    return abrController;
  }

  function getSwitchHistory() {
    return switchHistory;
  }

  function getVideoModel() {
    return videoModel;
  }

  function getDroppedFramesHistory() {
    return droppedFramesHistory;
  }

  function getCurrentRequest() {
    return currentRequest;
  }

  function useBufferOccupancyABR() {
    return bufferOccupancyABR;
  }

  function useL2AABR() {
    return l2AABR;
  }

  function useLoLPABR() {
    return loLP;
  }

  instance = {
    getMediaType: getMediaType,
    getMediaInfo: getMediaInfo,
    getDroppedFramesHistory: getDroppedFramesHistory,
    getCurrentRequest: getCurrentRequest,
    getSwitchHistory: getSwitchHistory,
    getStreamInfo: getStreamInfo,
    getScheduleController: getScheduleController,
    getAbrController: getAbrController,
    getRepresentationInfo: getRepresentationInfo,
    useBufferOccupancyABR: useBufferOccupancyABR,
    useL2AABR: useL2AABR,
    useLoLPABR: useLoLPABR,
    getVideoModel: getVideoModel
  };
  return instance;
}

RulesContext.__dashjs_factory_name = 'RulesContext';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(RulesContext));

/***/ }),

/***/ "./src/streaming/rules/SwitchRequest.js":
/*!**********************************************!*\
  !*** ./src/streaming/rules/SwitchRequest.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2237994__) {

"use strict";
__nested_webpack_require_2237994__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2237994__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

var NO_CHANGE = -1;
var PRIORITY = {
  DEFAULT: 0.5,
  STRONG: 1,
  WEAK: 0
};

function SwitchRequest(q, r, p) {
  //TODO refactor all the calls to this to use config to be like everything else.
  var instance, quality, priority, reason; // check priority value

  function getPriority(p) {
    var ret = PRIORITY.DEFAULT; // check that p is one of declared priority value

    if (p === PRIORITY.DEFAULT || p === PRIORITY.STRONG || p === PRIORITY.WEAK) {
      ret = p;
    }

    return ret;
  } // init attributes


  quality = q === undefined ? NO_CHANGE : q;
  priority = getPriority(p);
  reason = r === undefined ? null : r;
  instance = {
    quality: quality,
    reason: reason,
    priority: priority
  };
  return instance;
}

SwitchRequest.__dashjs_factory_name = 'SwitchRequest';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(SwitchRequest);
factory.NO_CHANGE = NO_CHANGE;
factory.PRIORITY = PRIORITY;
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].updateClassFactory(SwitchRequest.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/rules/SwitchRequestHistory.js":
/*!*****************************************************!*\
  !*** ./src/streaming/rules/SwitchRequestHistory.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2241630__) {

"use strict";
__nested_webpack_require_2241630__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2241630__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2241630__(/*! ./SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var SWITCH_REQUEST_HISTORY_DEPTH = 8; // must be > SwitchHistoryRule SAMPLE_SIZE to enable rule

function SwitchRequestHistory() {
  var switchRequests = []; // running total

  var srHistory = []; // history of each switch

  function push(switchRequest) {
    if (switchRequest.newValue === _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"].NO_CHANGE) {
      switchRequest.newValue = switchRequest.oldValue;
    }

    if (!switchRequests[switchRequest.oldValue]) {
      switchRequests[switchRequest.oldValue] = {
        noDrops: 0,
        drops: 0,
        dropSize: 0
      };
    } // Set switch details


    var indexDiff = switchRequest.newValue - switchRequest.oldValue;
    var drop = indexDiff < 0 ? 1 : 0;
    var dropSize = drop ? -indexDiff : 0;
    var noDrop = drop ? 0 : 1; // Update running totals

    switchRequests[switchRequest.oldValue].drops += drop;
    switchRequests[switchRequest.oldValue].dropSize += dropSize;
    switchRequests[switchRequest.oldValue].noDrops += noDrop; // Save to history

    srHistory.push({
      idx: switchRequest.oldValue,
      noDrop: noDrop,
      drop: drop,
      dropSize: dropSize
    }); // Shift earliest switch off srHistory and readjust to keep depth of running totals constant

    if (srHistory.length > SWITCH_REQUEST_HISTORY_DEPTH) {
      var srHistoryFirst = srHistory.shift();
      switchRequests[srHistoryFirst.idx].drops -= srHistoryFirst.drop;
      switchRequests[srHistoryFirst.idx].dropSize -= srHistoryFirst.dropSize;
      switchRequests[srHistoryFirst.idx].noDrops -= srHistoryFirst.noDrop;
    }
  }

  function getSwitchRequests() {
    return switchRequests;
  }

  function reset() {
    switchRequests = [];
    srHistory = [];
  }

  return {
    push: push,
    getSwitchRequests: getSwitchRequests,
    reset: reset
  };
}

SwitchRequestHistory.__dashjs_factory_name = 'SwitchRequestHistory';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(SwitchRequestHistory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/rules/ThroughputHistory.js":
/*!**************************************************!*\
  !*** ./src/streaming/rules/ThroughputHistory.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2246359__) {

"use strict";
__nested_webpack_require_2246359__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2246359__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2246359__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2017, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

 // throughput generally stored in kbit/s
// latency generally stored in ms

function ThroughputHistory(config) {
  config = config || {}; // sliding window constants

  var MAX_MEASUREMENTS_TO_KEEP = 20;
  var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE = 3;
  var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD = 4;
  var AVERAGE_LATENCY_SAMPLE_AMOUNT = 4;
  var THROUGHPUT_DECREASE_SCALE = 1.3;
  var THROUGHPUT_INCREASE_SCALE = 1.3; // EWMA constants

  var EWMA_THROUGHPUT_SLOW_HALF_LIFE_SECONDS = 8;
  var EWMA_THROUGHPUT_FAST_HALF_LIFE_SECONDS = 3;
  var EWMA_LATENCY_SLOW_HALF_LIFE_COUNT = 2;
  var EWMA_LATENCY_FAST_HALF_LIFE_COUNT = 1;
  var settings = config.settings;
  var throughputDict, latencyDict, ewmaThroughputDict, ewmaLatencyDict, ewmaHalfLife;

  function setup() {
    ewmaHalfLife = {
      throughputHalfLife: {
        fast: EWMA_THROUGHPUT_FAST_HALF_LIFE_SECONDS,
        slow: EWMA_THROUGHPUT_SLOW_HALF_LIFE_SECONDS
      },
      latencyHalfLife: {
        fast: EWMA_LATENCY_FAST_HALF_LIFE_COUNT,
        slow: EWMA_LATENCY_SLOW_HALF_LIFE_COUNT
      }
    };
    reset();
  }

  function isCachedResponse(mediaType, latencyMs, downloadTimeMs) {
    if (mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
      return downloadTimeMs < settings.get().streaming.cacheLoadThresholds[_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO];
    } else if (mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO) {
      return downloadTimeMs < settings.get().streaming.cacheLoadThresholds[_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO];
    }
  }

  function push(mediaType, httpRequest, useDeadTimeLatency) {
    if (!httpRequest.trace || !httpRequest.trace.length) {
      return;
    }

    var latencyTimeInMilliseconds = httpRequest.tresponse.getTime() - httpRequest.trequest.getTime() || 1;
    var downloadTimeInMilliseconds = httpRequest._tfinish.getTime() - httpRequest.tresponse.getTime() || 1; //Make sure never 0 we divide by this value. Avoid infinity!

    var downloadBytes = httpRequest.trace.reduce(function (a, b) {
      return a + b.b[0];
    }, 0);
    var throughputMeasureTime = 0,
        throughput = 0;

    if (httpRequest._fileLoaderType && httpRequest._fileLoaderType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].FILE_LOADER_TYPES.FETCH) {
      var calculationMode = settings.get().streaming.abr.fetchThroughputCalculationMode;

      if (calculationMode === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING) {
        var sumOfThroughputValues = httpRequest.trace.reduce(function (a, b) {
          return a + b._t;
        }, 0);
        throughput = Math.round(sumOfThroughputValues / httpRequest.trace.length);
      }

      if (throughput === 0) {
        throughputMeasureTime = httpRequest.trace.reduce(function (a, b) {
          return a + b.d;
        }, 0);
      }
    } else {
      throughputMeasureTime = useDeadTimeLatency ? downloadTimeInMilliseconds : latencyTimeInMilliseconds + downloadTimeInMilliseconds;
    }

    if (throughputMeasureTime !== 0) {
      throughput = Math.round(8 * downloadBytes / throughputMeasureTime); // bits/ms = kbits/s
    }

    checkSettingsForMediaType(mediaType);

    if (isCachedResponse(mediaType, latencyTimeInMilliseconds, downloadTimeInMilliseconds)) {
      if (throughputDict[mediaType].length > 0 && !throughputDict[mediaType].hasCachedEntries) {
        // already have some entries which are not cached entries
        // prevent cached fragment loads from skewing the average values
        return;
      } else {
        // have no entries || have cached entries
        // no uncached entries yet, rely on cached entries because ABR rules need something to go by
        throughputDict[mediaType].hasCachedEntries = true;
      }
    } else if (throughputDict[mediaType] && throughputDict[mediaType].hasCachedEntries) {
      // if we are here then we have some entries already, but they are cached, and now we have a new uncached entry
      clearSettingsForMediaType(mediaType);
    }

    throughputDict[mediaType].push(throughput);

    if (throughputDict[mediaType].length > MAX_MEASUREMENTS_TO_KEEP) {
      throughputDict[mediaType].shift();
    }

    latencyDict[mediaType].push(latencyTimeInMilliseconds);

    if (latencyDict[mediaType].length > MAX_MEASUREMENTS_TO_KEEP) {
      latencyDict[mediaType].shift();
    }

    updateEwmaEstimate(ewmaThroughputDict[mediaType], throughput, 0.001 * downloadTimeInMilliseconds, ewmaHalfLife.throughputHalfLife);
    updateEwmaEstimate(ewmaLatencyDict[mediaType], latencyTimeInMilliseconds, 1, ewmaHalfLife.latencyHalfLife);
  }

  function updateEwmaEstimate(ewmaObj, value, weight, halfLife) {
    // Note about startup:
    // Estimates start at 0, so early values are underestimated.
    // This effect is countered in getAverageEwma() by dividing the estimates by:
    //     1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife)
    var fastAlpha = Math.pow(0.5, weight / halfLife.fast);
    ewmaObj.fastEstimate = (1 - fastAlpha) * value + fastAlpha * ewmaObj.fastEstimate;
    var slowAlpha = Math.pow(0.5, weight / halfLife.slow);
    ewmaObj.slowEstimate = (1 - slowAlpha) * value + slowAlpha * ewmaObj.slowEstimate;
    ewmaObj.totalWeight += weight;
  }

  function getSampleSize(isThroughput, mediaType, isDynamic) {
    var arr, sampleSize;

    if (isThroughput) {
      arr = throughputDict[mediaType];
      sampleSize = isDynamic ? AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE : AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD;
    } else {
      arr = latencyDict[mediaType];
      sampleSize = AVERAGE_LATENCY_SAMPLE_AMOUNT;
    }

    if (!arr) {
      sampleSize = 0;
    } else if (sampleSize >= arr.length) {
      sampleSize = arr.length;
    } else if (isThroughput) {
      // if throughput samples vary a lot, average over a wider sample
      for (var i = 1; i < sampleSize; ++i) {
        var ratio = arr[arr.length - i] / arr[arr.length - i - 1];

        if (ratio >= THROUGHPUT_INCREASE_SCALE || ratio <= 1 / THROUGHPUT_DECREASE_SCALE) {
          sampleSize += 1;

          if (sampleSize === arr.length) {
            // cannot increase sampleSize beyond arr.length
            break;
          }
        }
      }
    }

    return sampleSize;
  }

  function getAverage(isThroughput, mediaType, isDynamic) {
    // only two moving average methods defined at the moment
    return settings.get().streaming.abr.movingAverageMethod !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].MOVING_AVERAGE_SLIDING_WINDOW ? getAverageEwma(isThroughput, mediaType) : getAverageSlidingWindow(isThroughput, mediaType, isDynamic);
  }

  function getAverageSlidingWindow(isThroughput, mediaType, isDynamic) {
    var sampleSize = getSampleSize(isThroughput, mediaType, isDynamic);
    var dict = isThroughput ? throughputDict : latencyDict;
    var arr = dict[mediaType];

    if (sampleSize === 0 || !arr || arr.length === 0) {
      return NaN;
    }

    arr = arr.slice(-sampleSize); // still works if sampleSize too large
    // arr.length >= 1

    return arr.reduce(function (total, elem) {
      return total + elem;
    }) / arr.length;
  }

  function getAverageEwma(isThroughput, mediaType) {
    var halfLife = isThroughput ? ewmaHalfLife.throughputHalfLife : ewmaHalfLife.latencyHalfLife;
    var ewmaObj = isThroughput ? ewmaThroughputDict[mediaType] : ewmaLatencyDict[mediaType];

    if (!ewmaObj || ewmaObj.totalWeight <= 0) {
      return NaN;
    } // to correct for startup, divide by zero factor = 1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife)


    var fastEstimate = ewmaObj.fastEstimate / (1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife.fast));
    var slowEstimate = ewmaObj.slowEstimate / (1 - Math.pow(0.5, ewmaObj.totalWeight / halfLife.slow));
    return isThroughput ? Math.min(fastEstimate, slowEstimate) : Math.max(fastEstimate, slowEstimate);
  }

  function getAverageThroughput(mediaType, isDynamic) {
    return getAverage(true, mediaType, isDynamic);
  }

  function getSafeAverageThroughput(mediaType, isDynamic) {
    var average = getAverageThroughput(mediaType, isDynamic);

    if (!isNaN(average)) {
      average *= settings.get().streaming.abr.bandwidthSafetyFactor;
    }

    return average;
  }

  function getAverageLatency(mediaType) {
    return getAverage(false, mediaType);
  }

  function checkSettingsForMediaType(mediaType) {
    throughputDict[mediaType] = throughputDict[mediaType] || [];
    latencyDict[mediaType] = latencyDict[mediaType] || [];
    ewmaThroughputDict[mediaType] = ewmaThroughputDict[mediaType] || {
      fastEstimate: 0,
      slowEstimate: 0,
      totalWeight: 0
    };
    ewmaLatencyDict[mediaType] = ewmaLatencyDict[mediaType] || {
      fastEstimate: 0,
      slowEstimate: 0,
      totalWeight: 0
    };
  }

  function clearSettingsForMediaType(mediaType) {
    delete throughputDict[mediaType];
    delete latencyDict[mediaType];
    delete ewmaThroughputDict[mediaType];
    delete ewmaLatencyDict[mediaType];
    checkSettingsForMediaType(mediaType);
  }

  function reset() {
    throughputDict = {};
    latencyDict = {};
    ewmaThroughputDict = {};
    ewmaLatencyDict = {};
  }

  var instance = {
    push: push,
    getAverageThroughput: getAverageThroughput,
    getSafeAverageThroughput: getSafeAverageThroughput,
    getAverageLatency: getAverageLatency,
    reset: reset
  };
  setup();
  return instance;
}

ThroughputHistory.__dashjs_factory_name = 'ThroughputHistory';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(ThroughputHistory));

/***/ }),

/***/ "./src/streaming/rules/abr/ABRRulesCollection.js":
/*!*******************************************************!*\
  !*** ./src/streaming/rules/abr/ABRRulesCollection.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2259014__) {

"use strict";
__nested_webpack_require_2259014__.r(__webpack_exports__);
/* harmony import */ var _ThroughputRule__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2259014__(/*! ./ThroughputRule */ "./src/streaming/rules/abr/ThroughputRule.js");
/* harmony import */ var _InsufficientBufferRule__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2259014__(/*! ./InsufficientBufferRule */ "./src/streaming/rules/abr/InsufficientBufferRule.js");
/* harmony import */ var _AbandonRequestsRule__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2259014__(/*! ./AbandonRequestsRule */ "./src/streaming/rules/abr/AbandonRequestsRule.js");
/* harmony import */ var _DroppedFramesRule__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2259014__(/*! ./DroppedFramesRule */ "./src/streaming/rules/abr/DroppedFramesRule.js");
/* harmony import */ var _SwitchHistoryRule__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2259014__(/*! ./SwitchHistoryRule */ "./src/streaming/rules/abr/SwitchHistoryRule.js");
/* harmony import */ var _BolaRule__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2259014__(/*! ./BolaRule */ "./src/streaming/rules/abr/BolaRule.js");
/* harmony import */ var _L2ARule_js__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2259014__(/*! ./L2ARule.js */ "./src/streaming/rules/abr/L2ARule.js");
/* harmony import */ var _lolp_LoLpRule_js__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2259014__(/*! ./lolp/LoLpRule.js */ "./src/streaming/rules/abr/lolp/LoLpRule.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2259014__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2259014__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_2259014__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */











var QUALITY_SWITCH_RULES = 'qualitySwitchRules';
var ABANDON_FRAGMENT_RULES = 'abandonFragmentRules';

function ABRRulesCollection(config) {
  config = config || {};
  var context = this.context;
  var mediaPlayerModel = config.mediaPlayerModel;
  var customParametersModel = config.customParametersModel;
  var dashMetrics = config.dashMetrics;
  var settings = config.settings;
  var instance, qualitySwitchRules, abandonFragmentRules;

  function initialize() {
    qualitySwitchRules = [];
    abandonFragmentRules = [];

    if (settings.get().streaming.abr.useDefaultABRRules) {
      // If L2A is used we only need this one rule
      if (settings.get().streaming.abr.ABRStrategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_10__["default"].ABR_STRATEGY_L2A) {
        qualitySwitchRules.push(Object(_L2ARule_js__WEBPACK_IMPORTED_MODULE_6__["default"])(context).create({
          dashMetrics: dashMetrics,
          settings: settings
        }));
      } // If LoLP is used we only need this one rule
      else if (settings.get().streaming.abr.ABRStrategy === _constants_Constants__WEBPACK_IMPORTED_MODULE_10__["default"].ABR_STRATEGY_LoLP) {
          qualitySwitchRules.push(Object(_lolp_LoLpRule_js__WEBPACK_IMPORTED_MODULE_7__["default"])(context).create({
            dashMetrics: dashMetrics
          }));
        } else {
          // Only one of BolaRule and ThroughputRule will give a switchRequest.quality !== SwitchRequest.NO_CHANGE.
          // This is controlled by useBufferOccupancyABR mechanism in AbrController.
          qualitySwitchRules.push(Object(_BolaRule__WEBPACK_IMPORTED_MODULE_5__["default"])(context).create({
            dashMetrics: dashMetrics,
            mediaPlayerModel: mediaPlayerModel,
            settings: settings
          }));
          qualitySwitchRules.push(Object(_ThroughputRule__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
            dashMetrics: dashMetrics
          }));

          if (settings.get().streaming.abr.additionalAbrRules.insufficientBufferRule) {
            qualitySwitchRules.push(Object(_InsufficientBufferRule__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
              dashMetrics: dashMetrics,
              settings: settings
            }));
          }

          if (settings.get().streaming.abr.additionalAbrRules.switchHistoryRule) {
            qualitySwitchRules.push(Object(_SwitchHistoryRule__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create());
          }

          if (settings.get().streaming.abr.additionalAbrRules.droppedFramesRule) {
            qualitySwitchRules.push(Object(_DroppedFramesRule__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create());
          }

          if (settings.get().streaming.abr.additionalAbrRules.abandonRequestsRule) {
            abandonFragmentRules.push(Object(_AbandonRequestsRule__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
              dashMetrics: dashMetrics,
              mediaPlayerModel: mediaPlayerModel,
              settings: settings
            }));
          }
        }
    } // add custom ABR rules if any


    var customRules = customParametersModel.getAbrCustomRules();
    customRules.forEach(function (rule) {
      if (rule.type === QUALITY_SWITCH_RULES) {
        qualitySwitchRules.push(rule.rule(context).create());
      }

      if (rule.type === ABANDON_FRAGMENT_RULES) {
        abandonFragmentRules.push(rule.rule(context).create());
      }
    });
  }

  function _getRulesWithChange(srArray) {
    return srArray.filter(function (sr) {
      return sr.quality > _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE;
    });
  }
  /**
   *
   * @param {array} srArray
   * @return {object} SwitchRequest
   */


  function getMinSwitchRequest(srArray) {
    var values = {};
    var newSwitchReq = null;
    var i, len, req, quality, reason;

    if (srArray.length === 0) {
      return;
    }

    values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.STRONG] = {
      quality: _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE,
      reason: null
    };
    values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.WEAK] = {
      quality: _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE,
      reason: null
    };
    values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.DEFAULT] = {
      quality: _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE,
      reason: null
    };

    for (i = 0, len = srArray.length; i < len; i += 1) {
      req = srArray[i];

      if (req.quality !== _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE) {
        // We only use the new quality in case it is lower than the already saved one or if no new quality has been selected for the respective priority
        if (values[req.priority].quality === _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE || values[req.priority].quality > req.quality) {
          values[req.priority].quality = req.quality;
          values[req.priority].reason = req.reason || null;
        }
      }
    }

    if (values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.WEAK].quality !== _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE) {
      newSwitchReq = values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.WEAK];
    }

    if (values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.DEFAULT].quality !== _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE) {
      newSwitchReq = values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.DEFAULT];
    }

    if (values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.STRONG].quality !== _SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].NO_CHANGE) {
      newSwitchReq = values[_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"].PRIORITY.STRONG];
    }

    if (newSwitchReq) {
      quality = newSwitchReq.quality;
      reason = newSwitchReq.reason;
    }

    return Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"])(context).create(quality, reason);
  }

  function getMaxQuality(rulesContext) {
    var switchRequestArray = qualitySwitchRules.map(function (rule) {
      return rule.getMaxIndex(rulesContext);
    });

    var activeRules = _getRulesWithChange(switchRequestArray);

    var maxQuality = getMinSwitchRequest(activeRules);
    return maxQuality || Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"])(context).create();
  }

  function shouldAbandonFragment(rulesContext, streamId) {
    var abandonRequestArray = abandonFragmentRules.map(function (rule) {
      return rule.shouldAbandon(rulesContext, streamId);
    });

    var activeRules = _getRulesWithChange(abandonRequestArray);

    var shouldAbandon = getMinSwitchRequest(activeRules);
    return shouldAbandon || Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_9__["default"])(context).create();
  }

  function reset() {
    [qualitySwitchRules, abandonFragmentRules].forEach(function (rules) {
      if (rules && rules.length) {
        rules.forEach(function (rule) {
          return rule.reset && rule.reset();
        });
      }
    });
    qualitySwitchRules = [];
    abandonFragmentRules = [];
  }

  function getQualitySwitchRules() {
    return qualitySwitchRules;
  }

  instance = {
    initialize: initialize,
    reset: reset,
    getMaxQuality: getMaxQuality,
    getMinSwitchRequest: getMinSwitchRequest,
    shouldAbandonFragment: shouldAbandonFragment,
    getQualitySwitchRules: getQualitySwitchRules
  };
  return instance;
}

ABRRulesCollection.__dashjs_factory_name = 'ABRRulesCollection';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_8__["default"].getClassFactory(ABRRulesCollection);
factory.QUALITY_SWITCH_RULES = QUALITY_SWITCH_RULES;
factory.ABANDON_FRAGMENT_RULES = ABANDON_FRAGMENT_RULES;
_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_8__["default"].updateSingletonFactory(ABRRulesCollection.__dashjs_factory_name, factory);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/rules/abr/AbandonRequestsRule.js":
/*!********************************************************!*\
  !*** ./src/streaming/rules/abr/AbandonRequestsRule.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2271529__) {

"use strict";
__nested_webpack_require_2271529__.r(__webpack_exports__);
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2271529__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2271529__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2271529__(/*! ../../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */




function AbandonRequestsRule(config) {
  config = config || {};
  var ABANDON_MULTIPLIER = 1.8;
  var GRACE_TIME_THRESHOLD = 500;
  var MIN_LENGTH_TO_AVERAGE = 5;
  var context = this.context;
  var mediaPlayerModel = config.mediaPlayerModel;
  var dashMetrics = config.dashMetrics;
  var settings = config.settings;
  var instance, logger, fragmentDict, abandonDict, throughputArray;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance().getLogger(instance);
    reset();
  }

  function setFragmentRequestDict(type, id) {
    fragmentDict[type] = fragmentDict[type] || {};
    fragmentDict[type][id] = fragmentDict[type][id] || {};
  }

  function storeLastRequestThroughputByType(type, throughput) {
    throughputArray[type] = throughputArray[type] || [];
    throughputArray[type].push(throughput);
  }

  function shouldAbandon(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create(_SwitchRequest__WEBPACK_IMPORTED_MODULE_0__["default"].NO_CHANGE, {
      name: AbandonRequestsRule.__dashjs_factory_name
    });

    if (!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('getCurrentRequest') || !rulesContext.hasOwnProperty('getRepresentationInfo') || !rulesContext.hasOwnProperty('getAbrController')) {
      return switchRequest;
    }

    var mediaInfo = rulesContext.getMediaInfo();
    var mediaType = rulesContext.getMediaType();
    var streamInfo = rulesContext.getStreamInfo();
    var streamId = streamInfo ? streamInfo.id : null;
    var req = rulesContext.getCurrentRequest();

    if (!isNaN(req.index)) {
      setFragmentRequestDict(mediaType, req.index);
      var stableBufferTime = mediaPlayerModel.getStableBufferTime();
      var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);

      if (bufferLevel > stableBufferTime) {
        return switchRequest;
      }

      var fragmentInfo = fragmentDict[mediaType][req.index];

      if (fragmentInfo === null || req.firstByteDate === null || abandonDict.hasOwnProperty(fragmentInfo.id)) {
        return switchRequest;
      } //setup some init info based on first progress event


      if (fragmentInfo.firstByteTime === undefined) {
        throughputArray[mediaType] = [];
        fragmentInfo.firstByteTime = req.firstByteDate.getTime();
        fragmentInfo.segmentDuration = req.duration;
        fragmentInfo.bytesTotal = req.bytesTotal;
        fragmentInfo.id = req.index;
      }

      fragmentInfo.bytesLoaded = req.bytesLoaded;
      fragmentInfo.elapsedTime = new Date().getTime() - fragmentInfo.firstByteTime;

      if (fragmentInfo.bytesLoaded > 0 && fragmentInfo.elapsedTime > 0) {
        storeLastRequestThroughputByType(mediaType, Math.round(fragmentInfo.bytesLoaded * 8 / fragmentInfo.elapsedTime));
      }

      if (throughputArray[mediaType].length >= MIN_LENGTH_TO_AVERAGE && fragmentInfo.elapsedTime > GRACE_TIME_THRESHOLD && fragmentInfo.bytesLoaded < fragmentInfo.bytesTotal) {
        var totalSampledValue = throughputArray[mediaType].reduce(function (a, b) {
          return a + b;
        }, 0);
        fragmentInfo.measuredBandwidthInKbps = Math.round(totalSampledValue / throughputArray[mediaType].length);
        fragmentInfo.estimatedTimeOfDownload = +(fragmentInfo.bytesTotal * 8 / fragmentInfo.measuredBandwidthInKbps / 1000).toFixed(2);

        if (fragmentInfo.estimatedTimeOfDownload < fragmentInfo.segmentDuration * ABANDON_MULTIPLIER || rulesContext.getRepresentationInfo().quality === 0) {
          return switchRequest;
        } else if (!abandonDict.hasOwnProperty(fragmentInfo.id)) {
          var abrController = rulesContext.getAbrController();
          var bytesRemaining = fragmentInfo.bytesTotal - fragmentInfo.bytesLoaded;
          var bitrateList = abrController.getBitrateList(mediaInfo);
          var quality = abrController.getQualityForBitrate(mediaInfo, fragmentInfo.measuredBandwidthInKbps * settings.get().streaming.abr.bandwidthSafetyFactor, streamId);
          var minQuality = abrController.getMinAllowedIndexFor(mediaType, streamId);
          var newQuality = minQuality !== undefined ? Math.max(minQuality, quality) : quality;
          var estimateOtherBytesTotal = fragmentInfo.bytesTotal * bitrateList[newQuality].bitrate / bitrateList[abrController.getQualityFor(mediaType, streamId)].bitrate;

          if (bytesRemaining > estimateOtherBytesTotal) {
            switchRequest.quality = newQuality;
            switchRequest.reason.throughput = fragmentInfo.measuredBandwidthInKbps;
            switchRequest.reason.fragmentID = fragmentInfo.id;
            abandonDict[fragmentInfo.id] = fragmentInfo;
            logger.debug('[' + mediaType + '] frag id', fragmentInfo.id, ' is asking to abandon and switch to quality to ', newQuality, ' measured bandwidth was', fragmentInfo.measuredBandwidthInKbps);
            delete fragmentDict[mediaType][fragmentInfo.id];
          }
        }
      } else if (fragmentInfo.bytesLoaded === fragmentInfo.bytesTotal) {
        delete fragmentDict[mediaType][fragmentInfo.id];
      }
    }

    return switchRequest;
  }

  function reset() {
    fragmentDict = {};
    abandonDict = {};
    throughputArray = [];
  }

  instance = {
    shouldAbandon: shouldAbandon,
    reset: reset
  };
  setup();
  return instance;
}

AbandonRequestsRule.__dashjs_factory_name = 'AbandonRequestsRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(AbandonRequestsRule));

/***/ }),

/***/ "./src/streaming/rules/abr/BolaRule.js":
/*!*********************************************!*\
  !*** ./src/streaming/rules/abr/BolaRule.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2280053__) {

"use strict";
__nested_webpack_require_2280053__.r(__webpack_exports__);
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2280053__(/*! ../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2280053__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2280053__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2280053__(/*! ../../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2280053__(/*! ../../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2280053__(/*! ../../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2280053__(/*! ../../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2280053__(/*! ../../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2280053__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2016, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
// For a description of the BOLA adaptive bitrate (ABR) algorithm, see http://arxiv.org/abs/1601.06748








 // BOLA_STATE_ONE_BITRATE   : If there is only one bitrate (or initialization failed), always return NO_CHANGE.
// BOLA_STATE_STARTUP       : Set placeholder buffer such that we download fragments at most recently measured throughput.
// BOLA_STATE_STEADY        : Buffer primed, we switch to steady operation.
// TODO: add BOLA_STATE_SEEK and tune BOLA behavior on seeking

var BOLA_STATE_ONE_BITRATE = 0;
var BOLA_STATE_STARTUP = 1;
var BOLA_STATE_STEADY = 2;
var MINIMUM_BUFFER_S = 10; // BOLA should never add artificial delays if buffer is less than MINIMUM_BUFFER_S.

var MINIMUM_BUFFER_PER_BITRATE_LEVEL_S = 2; // E.g. if there are 5 bitrates, BOLA switches to top bitrate at buffer = 10 + 5 * 2 = 20s.
// If Schedule Controller does not allow buffer to reach that level, it can be achieved through the placeholder buffer level.

var PLACEHOLDER_BUFFER_DECAY = 0.99; // Make sure placeholder buffer does not stick around too long.

function BolaRule(config) {
  config = config || {};
  var context = this.context;
  var dashMetrics = config.dashMetrics;
  var mediaPlayerModel = config.mediaPlayerModel;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var instance, logger, bolaStateDict;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance().getLogger(instance);
    resetInitialSettings();
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].BUFFER_EMPTY, onBufferEmpty, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].METRIC_ADDED, onMetricAdded, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].QUALITY_CHANGE_REQUESTED, onQualityChangeRequested, instance);
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_ABANDONED, onFragmentLoadingAbandoned, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, instance);
  }

  function utilitiesFromBitrates(bitrates) {
    return bitrates.map(function (b) {
      return Math.log(b);
    }); // no need to worry about offset, utilities will be offset (uniformly) anyway later
  } // NOTE: in live streaming, the real buffer level can drop below minimumBufferS, but bola should not stick to lowest bitrate by using a placeholder buffer level


  function calculateBolaParameters(stableBufferTime, bitrates, utilities) {
    var highestUtilityIndex = utilities.reduce(function (highestIndex, u, uIndex) {
      return u > utilities[highestIndex] ? uIndex : highestIndex;
    }, 0);

    if (highestUtilityIndex === 0) {
      // if highestUtilityIndex === 0, then always use lowest bitrate
      return null;
    }

    var bufferTime = Math.max(stableBufferTime, MINIMUM_BUFFER_S + MINIMUM_BUFFER_PER_BITRATE_LEVEL_S * bitrates.length); // TODO: Investigate if following can be better if utilities are not the default Math.log utilities.
    // If using Math.log utilities, we can choose Vp and gp to always prefer bitrates[0] at minimumBufferS and bitrates[max] at bufferTarget.
    // (Vp * (utility + gp) - bufferLevel) / bitrate has the maxima described when:
    // Vp * (utilities[0] + gp - 1) === minimumBufferS and Vp * (utilities[max] + gp - 1) === bufferTarget
    // giving:

    var gp = (utilities[highestUtilityIndex] - 1) / (bufferTime / MINIMUM_BUFFER_S - 1);
    var Vp = MINIMUM_BUFFER_S / gp; // note that expressions for gp and Vp assume utilities[0] === 1, which is true because of normalization

    return {
      gp: gp,
      Vp: Vp
    };
  }

  function getInitialBolaState(rulesContext) {
    var initialState = {};
    var mediaInfo = rulesContext.getMediaInfo();
    var bitrates = mediaInfo.bitrateList.map(function (b) {
      return b.bandwidth;
    });
    var utilities = utilitiesFromBitrates(bitrates);
    utilities = utilities.map(function (u) {
      return u - utilities[0] + 1;
    }); // normalize

    var stableBufferTime = mediaPlayerModel.getStableBufferTime();
    var params = calculateBolaParameters(stableBufferTime, bitrates, utilities);

    if (!params) {
      // only happens when there is only one bitrate level
      initialState.state = BOLA_STATE_ONE_BITRATE;
    } else {
      initialState.state = BOLA_STATE_STARTUP;
      initialState.bitrates = bitrates;
      initialState.utilities = utilities;
      initialState.stableBufferTime = stableBufferTime;
      initialState.Vp = params.Vp;
      initialState.gp = params.gp;
      initialState.lastQuality = 0;
      clearBolaStateOnSeek(initialState);
    }

    return initialState;
  }

  function clearBolaStateOnSeek(bolaState) {
    bolaState.placeholderBuffer = 0;
    bolaState.mostAdvancedSegmentStart = NaN;
    bolaState.lastSegmentWasReplacement = false;
    bolaState.lastSegmentStart = NaN;
    bolaState.lastSegmentDurationS = NaN;
    bolaState.lastSegmentRequestTimeMs = NaN;
    bolaState.lastSegmentFinishTimeMs = NaN;
  } // If the buffer target is changed (can this happen mid-stream?), then adjust BOLA parameters accordingly.


  function checkBolaStateStableBufferTime(bolaState, mediaType) {
    var stableBufferTime = mediaPlayerModel.getStableBufferTime();

    if (bolaState.stableBufferTime !== stableBufferTime) {
      var params = calculateBolaParameters(stableBufferTime, bolaState.bitrates, bolaState.utilities);

      if (params.Vp !== bolaState.Vp || params.gp !== bolaState.gp) {
        // correct placeholder buffer using two criteria:
        // 1. do not change effective buffer level at effectiveBufferLevel === MINIMUM_BUFFER_S ( === Vp * gp )
        // 2. scale placeholder buffer by Vp subject to offset indicated in 1.
        var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);
        var effectiveBufferLevel = bufferLevel + bolaState.placeholderBuffer;
        effectiveBufferLevel -= MINIMUM_BUFFER_S;
        effectiveBufferLevel *= params.Vp / bolaState.Vp;
        effectiveBufferLevel += MINIMUM_BUFFER_S;
        bolaState.stableBufferTime = stableBufferTime;
        bolaState.Vp = params.Vp;
        bolaState.gp = params.gp;
        bolaState.placeholderBuffer = Math.max(0, effectiveBufferLevel - bufferLevel);
      }
    }
  }

  function getBolaState(rulesContext) {
    var mediaType = rulesContext.getMediaType();
    var bolaState = bolaStateDict[mediaType];

    if (!bolaState) {
      bolaState = getInitialBolaState(rulesContext);
      bolaStateDict[mediaType] = bolaState;
    } else if (bolaState.state !== BOLA_STATE_ONE_BITRATE) {
      checkBolaStateStableBufferTime(bolaState, mediaType);
    }

    return bolaState;
  } // The core idea of BOLA.


  function getQualityFromBufferLevel(bolaState, bufferLevel) {
    var bitrateCount = bolaState.bitrates.length;
    var quality = NaN;
    var score = NaN;

    for (var i = 0; i < bitrateCount; ++i) {
      var s = (bolaState.Vp * (bolaState.utilities[i] + bolaState.gp) - bufferLevel) / bolaState.bitrates[i];

      if (isNaN(score) || s >= score) {
        score = s;
        quality = i;
      }
    }

    return quality;
  } // maximum buffer level which prefers to download at quality rather than wait


  function maxBufferLevelForQuality(bolaState, quality) {
    return bolaState.Vp * (bolaState.utilities[quality] + bolaState.gp);
  } // the minimum buffer level that would cause BOLA to choose quality rather than a lower bitrate


  function minBufferLevelForQuality(bolaState, quality) {
    var qBitrate = bolaState.bitrates[quality];
    var qUtility = bolaState.utilities[quality];
    var min = 0;

    for (var i = quality - 1; i >= 0; --i) {
      // for each bitrate less than bitrates[quality], BOLA should prefer quality (unless other bitrate has higher utility)
      if (bolaState.utilities[i] < bolaState.utilities[quality]) {
        var iBitrate = bolaState.bitrates[i];
        var iUtility = bolaState.utilities[i];
        var level = bolaState.Vp * (bolaState.gp + (qBitrate * iUtility - iBitrate * qUtility) / (qBitrate - iBitrate));
        min = Math.max(min, level); // we want min to be small but at least level(i) for all i
      }
    }

    return min;
  }
  /*
   * The placeholder buffer increases the effective buffer that is used to calculate the bitrate.
   * There are two main reasons we might want to increase the placeholder buffer:
   *
   * 1. When a segment finishes downloading, we would expect to get a call on getMaxIndex() regarding the quality for
   *    the next segment. However, there might be a delay before the next call. E.g. when streaming live content, the
   *    next segment might not be available yet. If the call to getMaxIndex() does happens after a delay, we don't
   *    want the delay to change the BOLA decision - we only want to factor download time to decide on bitrate level.
   *
   * 2. It is possible to get a call to getMaxIndex() without having a segment download. The buffer target in dash.js
   *    is different for top-quality segments and lower-quality segments. If getMaxIndex() returns a lower-than-top
   *    quality, then the buffer controller might decide not to download a segment. When dash.js is ready for the next
   *    segment, getMaxIndex() will be called again. We don't want this extra delay to factor in the bitrate decision.
   */


  function updatePlaceholderBuffer(bolaState, mediaType) {
    var nowMs = Date.now();

    if (!isNaN(bolaState.lastSegmentFinishTimeMs)) {
      // compensate for non-bandwidth-derived delays, e.g., live streaming availability, buffer controller
      var delay = 0.001 * (nowMs - bolaState.lastSegmentFinishTimeMs);
      bolaState.placeholderBuffer += Math.max(0, delay);
    } else if (!isNaN(bolaState.lastCallTimeMs)) {
      // no download after last call, compensate for delay between calls
      var _delay = 0.001 * (nowMs - bolaState.lastCallTimeMs);

      bolaState.placeholderBuffer += Math.max(0, _delay);
    }

    bolaState.lastCallTimeMs = nowMs;
    bolaState.lastSegmentStart = NaN;
    bolaState.lastSegmentRequestTimeMs = NaN;
    bolaState.lastSegmentFinishTimeMs = NaN;
    checkBolaStateStableBufferTime(bolaState, mediaType);
  }

  function onBufferEmpty(e) {
    // if we rebuffer, we don't want the placeholder buffer to artificially raise BOLA quality
    var mediaType = e.mediaType; // if audio buffer runs empty (due to track switch for example) then reset placeholder buffer only for audio (to avoid decrease video BOLA quality)

    var stateDict = mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_8__["default"].AUDIO ? [_constants_Constants__WEBPACK_IMPORTED_MODULE_8__["default"].AUDIO] : bolaStateDict;

    for (var _mediaType in stateDict) {
      if (bolaStateDict.hasOwnProperty(_mediaType) && bolaStateDict[_mediaType].state === BOLA_STATE_STEADY) {
        bolaStateDict[_mediaType].placeholderBuffer = 0;
      }
    }
  }

  function onPlaybackSeeking() {
    // TODO: 1. Verify what happens if we seek mid-fragment.
    // TODO: 2. If e.g. we have 10s fragments and seek, we might want to download the first fragment at a lower quality to restart playback quickly.
    for (var mediaType in bolaStateDict) {
      if (bolaStateDict.hasOwnProperty(mediaType)) {
        var bolaState = bolaStateDict[mediaType];

        if (bolaState.state !== BOLA_STATE_ONE_BITRATE) {
          bolaState.state = BOLA_STATE_STARTUP; // TODO: BOLA_STATE_SEEK?

          clearBolaStateOnSeek(bolaState);
        }
      }
    }
  }

  function onMediaFragmentLoaded(e) {
    if (e && e.chunk && e.chunk.mediaInfo) {
      var bolaState = bolaStateDict[e.chunk.mediaInfo.type];

      if (bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE) {
        var start = e.chunk.start;

        if (isNaN(bolaState.mostAdvancedSegmentStart) || start > bolaState.mostAdvancedSegmentStart) {
          bolaState.mostAdvancedSegmentStart = start;
          bolaState.lastSegmentWasReplacement = false;
        } else {
          bolaState.lastSegmentWasReplacement = true;
        }

        bolaState.lastSegmentStart = start;
        bolaState.lastSegmentDurationS = e.chunk.duration;
        bolaState.lastQuality = e.chunk.quality;
        checkNewSegment(bolaState, e.chunk.mediaInfo.type);
      }
    }
  }

  function onMetricAdded(e) {
    if (e && e.metric === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__["default"].HTTP_REQUEST && e.value && e.value.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__["HTTPRequest"].MEDIA_SEGMENT_TYPE && e.value.trace && e.value.trace.length) {
      var bolaState = bolaStateDict[e.mediaType];

      if (bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE) {
        bolaState.lastSegmentRequestTimeMs = e.value.trequest.getTime();
        bolaState.lastSegmentFinishTimeMs = e.value._tfinish.getTime();
        checkNewSegment(bolaState, e.mediaType);
      }
    }
  }
  /*
   * When a new segment is downloaded, we get two notifications: onMediaFragmentLoaded() and onMetricAdded(). It is
   * possible that the quality for the downloaded segment was lower (not higher) than the quality indicated by BOLA.
   * This might happen because of other rules such as the DroppedFramesRule. When this happens, we trim the
   * placeholder buffer to make BOLA more stable. This mechanism also avoids inflating the buffer when BOLA itself
   * decides not to increase the quality to avoid oscillations.
   *
   * We should also check for replacement segments (fast switching). In this case, a segment is downloaded but does
   * not grow the actual buffer. Fast switching might cause the buffer to deplete, causing BOLA to drop the bitrate.
   * We avoid this by growing the placeholder buffer.
   */


  function checkNewSegment(bolaState, mediaType) {
    if (!isNaN(bolaState.lastSegmentStart) && !isNaN(bolaState.lastSegmentRequestTimeMs) && !isNaN(bolaState.placeholderBuffer)) {
      bolaState.placeholderBuffer *= PLACEHOLDER_BUFFER_DECAY; // Find what maximum buffer corresponding to last segment was, and ensure placeholder is not relatively larger.

      if (!isNaN(bolaState.lastSegmentFinishTimeMs)) {
        var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);
        var bufferAtLastSegmentRequest = bufferLevel + 0.001 * (bolaState.lastSegmentFinishTimeMs - bolaState.lastSegmentRequestTimeMs); // estimate

        var maxEffectiveBufferForLastSegment = maxBufferLevelForQuality(bolaState, bolaState.lastQuality);
        var maxPlaceholderBuffer = Math.max(0, maxEffectiveBufferForLastSegment - bufferAtLastSegmentRequest);
        bolaState.placeholderBuffer = Math.min(maxPlaceholderBuffer, bolaState.placeholderBuffer);
      } // then see if we should grow placeholder buffer


      if (bolaState.lastSegmentWasReplacement && !isNaN(bolaState.lastSegmentDurationS)) {
        // compensate for segments that were downloaded but did not grow the buffer
        bolaState.placeholderBuffer += bolaState.lastSegmentDurationS;
      }

      bolaState.lastSegmentStart = NaN;
      bolaState.lastSegmentRequestTimeMs = NaN;
    }
  }

  function onQualityChangeRequested(e) {
    // Useful to store change requests when abandoning a download.
    if (e) {
      var bolaState = bolaStateDict[e.mediaType];

      if (bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE) {
        bolaState.abrQuality = e.newQuality;
      }
    }
  }

  function onFragmentLoadingAbandoned(e) {
    if (e) {
      var bolaState = bolaStateDict[e.mediaType];

      if (bolaState && bolaState.state !== BOLA_STATE_ONE_BITRATE) {
        // deflate placeholderBuffer - note that we want to be conservative when abandoning
        var bufferLevel = dashMetrics.getCurrentBufferLevel(e.mediaType);
        var wantEffectiveBufferLevel;

        if (bolaState.abrQuality > 0) {
          // deflate to point where BOLA just chooses newQuality over newQuality-1
          wantEffectiveBufferLevel = minBufferLevelForQuality(bolaState, bolaState.abrQuality);
        } else {
          wantEffectiveBufferLevel = MINIMUM_BUFFER_S;
        }

        var maxPlaceholderBuffer = Math.max(0, wantEffectiveBufferLevel - bufferLevel);
        bolaState.placeholderBuffer = Math.min(bolaState.placeholderBuffer, maxPlaceholderBuffer);
      }
    }
  }

  function getMaxIndex(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();

    if (!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('getScheduleController') || !rulesContext.hasOwnProperty('getStreamInfo') || !rulesContext.hasOwnProperty('getAbrController') || !rulesContext.hasOwnProperty('useBufferOccupancyABR')) {
      return switchRequest;
    }

    var mediaInfo = rulesContext.getMediaInfo();
    var mediaType = rulesContext.getMediaType();
    var scheduleController = rulesContext.getScheduleController();
    var streamInfo = rulesContext.getStreamInfo();
    var abrController = rulesContext.getAbrController();
    var throughputHistory = abrController.getThroughputHistory();
    var streamId = streamInfo ? streamInfo.id : null;
    var isDynamic = streamInfo && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic;
    var useBufferOccupancyABR = rulesContext.useBufferOccupancyABR();
    switchRequest.reason = switchRequest.reason || {};

    if (!useBufferOccupancyABR) {
      return switchRequest;
    }

    scheduleController.setTimeToLoadDelay(0);
    var bolaState = getBolaState(rulesContext);

    if (bolaState.state === BOLA_STATE_ONE_BITRATE) {
      // shouldn't even have been called
      return switchRequest;
    }

    var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);
    var throughput = throughputHistory.getAverageThroughput(mediaType, isDynamic);
    var safeThroughput = throughputHistory.getSafeAverageThroughput(mediaType, isDynamic);
    var latency = throughputHistory.getAverageLatency(mediaType);
    var quality;
    switchRequest.reason.state = bolaState.state;
    switchRequest.reason.throughput = throughput;
    switchRequest.reason.latency = latency;

    if (isNaN(throughput)) {
      // isNaN(throughput) === isNaN(safeThroughput) === isNaN(latency)
      // still starting up - not enough information
      return switchRequest;
    }

    switch (bolaState.state) {
      case BOLA_STATE_STARTUP:
        quality = abrController.getQualityForBitrate(mediaInfo, safeThroughput, streamId, latency);
        switchRequest.quality = quality;
        switchRequest.reason.throughput = safeThroughput;
        bolaState.placeholderBuffer = Math.max(0, minBufferLevelForQuality(bolaState, quality) - bufferLevel);
        bolaState.lastQuality = quality;

        if (!isNaN(bolaState.lastSegmentDurationS) && bufferLevel >= bolaState.lastSegmentDurationS) {
          bolaState.state = BOLA_STATE_STEADY;
        }

        break;
      // BOLA_STATE_STARTUP

      case BOLA_STATE_STEADY:
        // NB: The placeholder buffer is added to bufferLevel to come up with a bitrate.
        //     This might lead BOLA to be too optimistic and to choose a bitrate that would lead to rebuffering -
        //     if the real buffer bufferLevel runs out, the placeholder buffer cannot prevent rebuffering.
        //     However, the InsufficientBufferRule takes care of this scenario.
        updatePlaceholderBuffer(bolaState, mediaType);
        quality = getQualityFromBufferLevel(bolaState, bufferLevel + bolaState.placeholderBuffer); // we want to avoid oscillations
        // We implement the "BOLA-O" variant: when network bandwidth lies between two encoded bitrate levels, stick to the lowest level.

        var qualityForThroughput = abrController.getQualityForBitrate(mediaInfo, safeThroughput, streamId, latency);

        if (quality > bolaState.lastQuality && quality > qualityForThroughput) {
          // only intervene if we are trying to *increase* quality to an *unsustainable* level
          // we are only avoid oscillations - do not drop below last quality
          quality = Math.max(qualityForThroughput, bolaState.lastQuality);
        } // We do not want to overfill buffer with low quality chunks.
        // Note that there will be no delay if buffer level is below MINIMUM_BUFFER_S, probably even with some margin higher than MINIMUM_BUFFER_S.


        var delayS = Math.max(0, bufferLevel + bolaState.placeholderBuffer - maxBufferLevelForQuality(bolaState, quality)); // First reduce placeholder buffer, then tell schedule controller to pause.

        if (delayS <= bolaState.placeholderBuffer) {
          bolaState.placeholderBuffer -= delayS;
          delayS = 0;
        } else {
          delayS -= bolaState.placeholderBuffer;
          bolaState.placeholderBuffer = 0;

          if (quality < abrController.getMaxAllowedIndexFor(mediaType, streamId)) {
            // At top quality, allow schedule controller to decide how far to fill buffer.
            scheduleController.setTimeToLoadDelay(1000 * delayS);
          } else {
            delayS = 0;
          }
        }

        switchRequest.quality = quality;
        switchRequest.reason.throughput = throughput;
        switchRequest.reason.latency = latency;
        switchRequest.reason.bufferLevel = bufferLevel;
        switchRequest.reason.placeholderBuffer = bolaState.placeholderBuffer;
        switchRequest.reason.delay = delayS;
        bolaState.lastQuality = quality; // keep bolaState.state === BOLA_STATE_STEADY

        break;
      // BOLA_STATE_STEADY

      default:
        logger.debug('BOLA ABR rule invoked in bad state.'); // should not arrive here, try to recover

        switchRequest.quality = abrController.getQualityForBitrate(mediaInfo, safeThroughput, streamId, latency);
        switchRequest.reason.state = bolaState.state;
        switchRequest.reason.throughput = safeThroughput;
        switchRequest.reason.latency = latency;
        bolaState.state = BOLA_STATE_STARTUP;
        clearBolaStateOnSeek(bolaState);
    }

    return switchRequest;
  }

  function resetInitialSettings() {
    bolaStateDict = {};
  }

  function reset() {
    resetInitialSettings();
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].BUFFER_EMPTY, onBufferEmpty, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].METRIC_ADDED, onMetricAdded, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].QUALITY_CHANGE_REQUESTED, onQualityChangeRequested, instance);
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].FRAGMENT_LOADING_ABANDONED, onFragmentLoadingAbandoned, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, instance);
  }

  instance = {
    getMaxIndex: getMaxIndex,
    reset: reset
  };
  setup();
  return instance;
}

BolaRule.__dashjs_factory_name = 'BolaRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(BolaRule));

/***/ }),

/***/ "./src/streaming/rules/abr/DroppedFramesRule.js":
/*!******************************************************!*\
  !*** ./src/streaming/rules/abr/DroppedFramesRule.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2307948__) {

"use strict";
__nested_webpack_require_2307948__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2307948__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2307948__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2307948__(/*! ../../../core/Debug */ "./src/core/Debug.js");




function DroppedFramesRule() {
  var context = this.context;
  var instance, logger;
  var DROPPED_PERCENTAGE_FORBID = 0.15;
  var GOOD_SAMPLE_SIZE = 375; //Don't apply the rule until this many frames have been rendered(and counted under those indices).

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance().getLogger(instance);
  }

  function getMaxIndex(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();

    if (!rulesContext || !rulesContext.hasOwnProperty('getDroppedFramesHistory')) {
      return switchRequest;
    }

    var droppedFramesHistory = rulesContext.getDroppedFramesHistory();
    var streamId = rulesContext.getStreamInfo().id;

    if (droppedFramesHistory) {
      var dfh = droppedFramesHistory.getFrameHistory(streamId);

      if (!dfh || dfh.length === 0) {
        return switchRequest;
      }

      var droppedFrames = 0;
      var totalFrames = 0;
      var maxIndex = _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"].NO_CHANGE; //No point in measuring dropped frames for the zeroeth index.

      for (var i = 1; i < dfh.length; i++) {
        if (dfh[i]) {
          droppedFrames = dfh[i].droppedVideoFrames;
          totalFrames = dfh[i].totalVideoFrames;

          if (totalFrames > GOOD_SAMPLE_SIZE && droppedFrames / totalFrames > DROPPED_PERCENTAGE_FORBID) {
            maxIndex = i - 1;
            logger.debug('index: ' + maxIndex + ' Dropped Frames: ' + droppedFrames + ' Total Frames: ' + totalFrames);
            break;
          }
        }
      }

      return Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create(maxIndex, {
        droppedFrames: droppedFrames
      });
    }

    return switchRequest;
  }

  instance = {
    getMaxIndex: getMaxIndex
  };
  setup();
  return instance;
}

DroppedFramesRule.__dashjs_factory_name = 'DroppedFramesRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(DroppedFramesRule));

/***/ }),

/***/ "./src/streaming/rules/abr/InsufficientBufferRule.js":
/*!***********************************************************!*\
  !*** ./src/streaming/rules/abr/InsufficientBufferRule.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2311053__) {

"use strict";
__nested_webpack_require_2311053__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2311053__(/*! ../../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2311053__(/*! ../../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2311053__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2311053__(/*! ../../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2311053__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2311053__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2311053__(/*! ../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2311053__(/*! ../../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









function InsufficientBufferRule(config) {
  config = config || {};
  var INSUFFICIENT_BUFFER_SAFETY_FACTOR = 0.5;
  var SEGMENT_IGNORE_COUNT = 2;
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var dashMetrics = config.dashMetrics;
  var instance, logger, bufferStateDict;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance().getLogger(instance);
    resetInitialSettings();
    eventBus.on(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].BYTES_APPENDED_END_FRAGMENT, _onBytesAppended, instance);
  }

  function checkConfig() {
    if (!dashMetrics || !dashMetrics.hasOwnProperty('getCurrentBufferLevel') || !dashMetrics.hasOwnProperty('getCurrentBufferState')) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].MISSING_CONFIG_ERROR);
    }
  }
  /**
   * If a BUFFER_EMPTY event happens, then InsufficientBufferRule returns switchRequest.quality=0 until BUFFER_LOADED happens.
   * Otherwise InsufficientBufferRule gives a maximum bitrate depending on throughput and bufferLevel such that
   * a whole fragment can be downloaded before the buffer runs out, subject to a conservative safety factor of 0.5.
   * If the bufferLevel is low, then InsufficientBufferRule avoids rebuffering risk.
   * If the bufferLevel is high, then InsufficientBufferRule give a high MaxIndex allowing other rules to take over.
   * @param rulesContext
   * @return {object}
   */


  function getMaxIndex(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create();

    if (!rulesContext || !rulesContext.hasOwnProperty('getMediaType')) {
      return switchRequest;
    }

    checkConfig();
    var mediaType = rulesContext.getMediaType();
    var currentBufferState = dashMetrics.getCurrentBufferState(mediaType);
    var representationInfo = rulesContext.getRepresentationInfo();
    var fragmentDuration = representationInfo.fragmentDuration;
    var streamInfo = rulesContext.getStreamInfo();
    var streamId = streamInfo ? streamInfo.id : null;
    var scheduleController = rulesContext.getScheduleController();
    var isDynamic = streamInfo && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic;
    var playbackController = scheduleController.getPlaybackController(); // Don't ask for a bitrate change if there is not info about buffer state or if fragmentDuration is not defined

    var lowLatencyEnabled = playbackController.getLowLatencyModeEnabled();

    if (shouldIgnore(lowLatencyEnabled, mediaType) || !fragmentDuration) {
      return switchRequest;
    }

    if (currentBufferState && currentBufferState.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_6__["default"].BUFFER_EMPTY) {
      logger.debug('[' + mediaType + '] Switch to index 0; buffer is empty.');
      switchRequest.quality = 0;
      switchRequest.reason = 'InsufficientBufferRule: Buffer is empty';
    } else {
      var mediaInfo = rulesContext.getMediaInfo();
      var abrController = rulesContext.getAbrController();
      var throughputHistory = abrController.getThroughputHistory();
      var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType);
      var throughput = throughputHistory.getAverageThroughput(mediaType, isDynamic);
      var latency = throughputHistory.getAverageLatency(mediaType);
      var bitrate = throughput * (bufferLevel / fragmentDuration) * INSUFFICIENT_BUFFER_SAFETY_FACTOR;
      switchRequest.quality = abrController.getQualityForBitrate(mediaInfo, bitrate, streamId, latency);
      switchRequest.reason = 'InsufficientBufferRule: being conservative to avoid immediate rebuffering';
    }

    return switchRequest;
  }

  function shouldIgnore(lowLatencyEnabled, mediaType) {
    return !lowLatencyEnabled && bufferStateDict[mediaType].ignoreCount > 0;
  }

  function resetInitialSettings() {
    bufferStateDict = {};
    bufferStateDict[_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].VIDEO] = {
      ignoreCount: SEGMENT_IGNORE_COUNT
    };
    bufferStateDict[_constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].AUDIO] = {
      ignoreCount: SEGMENT_IGNORE_COUNT
    };
  }

  function _onPlaybackSeeking() {
    resetInitialSettings();
  }

  function _onBytesAppended(e) {
    if (!isNaN(e.startTime) && (e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].AUDIO || e.mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_5__["default"].VIDEO)) {
      if (bufferStateDict[e.mediaType].ignoreCount > 0) {
        bufferStateDict[e.mediaType].ignoreCount--;
      }
    }
  }

  function reset() {
    resetInitialSettings();
    eventBus.off(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_7__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].BYTES_APPENDED_END_FRAGMENT, _onBytesAppended, instance);
  }

  instance = {
    getMaxIndex: getMaxIndex,
    reset: reset
  };
  setup();
  return instance;
}

InsufficientBufferRule.__dashjs_factory_name = 'InsufficientBufferRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(InsufficientBufferRule));

/***/ }),

/***/ "./src/streaming/rules/abr/L2ARule.js":
/*!********************************************!*\
  !*** ./src/streaming/rules/abr/L2ARule.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2320258__) {

"use strict";
__nested_webpack_require_2320258__.r(__webpack_exports__);
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2320258__(/*! ../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2320258__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2320258__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2320258__(/*! ../../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2320258__(/*! ../../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2320258__(/*! ../../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2320258__(/*! ../../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2320258__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2020, Unified Streaming.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
// For a description of the Learn2Adapt-LowLatency (L2A-LL) bitrate adaptation algorithm, see https://github.com/unifiedstreaming/Learn2Adapt-LowLatency/blob/master/Online_learning_for_bitrate_adaptation_in_low_latency_live_streaming_CR.pdf








var L2A_STATE_ONE_BITRATE = 0; // If there is only one bitrate (or initialization failed), always return NO_CHANGE.

var L2A_STATE_STARTUP = 1; // Set placeholder buffer such that we download fragments at most recently measured throughput.

var L2A_STATE_STEADY = 2; // Buffer primed, we switch to steady operation.

function L2ARule(config) {
  config = config || {};
  var context = this.context;
  var dashMetrics = config.dashMetrics;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var instance, l2AStateDict, l2AParameterDict, logger;
  /**
   * Setup function to initialize L2ARule
   */

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance().getLogger(instance);

    _resetInitialSettings();

    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].METRIC_ADDED, _onMetricAdded, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].QUALITY_CHANGE_REQUESTED, _onQualityChangeRequested, instance);
  }
  /**
   * Sets the initial state of the algorithm. Calls the initialize function for the paramteters.
   * @param {object} rulesContext
   * @return {object} initialState
   * @private
   */


  function _getInitialL2AState(rulesContext) {
    var initialState = {};
    var mediaInfo = rulesContext.getMediaInfo();
    var bitrates = mediaInfo.bitrateList.map(function (b) {
      return b.bandwidth / 1000;
    });
    initialState.state = L2A_STATE_STARTUP;
    initialState.bitrates = bitrates;
    initialState.lastQuality = 0;

    _initializeL2AParameters(mediaInfo);

    _clearL2AStateOnSeek(initialState);

    return initialState;
  }
  /**
   * Initializes the parameters of the algorithm. This will be done once for each media type.
   * @param {object} mediaInfo
   * @private
   */


  function _initializeL2AParameters(mediaInfo) {
    if (!mediaInfo || !mediaInfo.type) {
      return;
    }

    l2AParameterDict[mediaInfo.type] = {};
    l2AParameterDict[mediaInfo.type].w = []; //Vector of probabilities associated with bitrate decisions

    l2AParameterDict[mediaInfo.type].prev_w = []; //Vector of probabilities associated with bitrate decisions calculated in the previous step

    l2AParameterDict[mediaInfo.type].Q = 0; //Initialization of Lagrangian multiplier (This keeps track of the buffer displacement)

    l2AParameterDict[mediaInfo.type].segment_request_start_s = 0;
    l2AParameterDict[mediaInfo.type].segment_download_finish_s = 0;
    l2AParameterDict[mediaInfo.type].B_target = 1.5; //Target buffer level
  }
  /**
   * Clears the state object
   * @param {object} l2AState
   * @private
   */


  function _clearL2AStateOnSeek(l2AState) {
    l2AState.placeholderBuffer = 0;
    l2AState.mostAdvancedSegmentStart = NaN;
    l2AState.lastSegmentWasReplacement = false;
    l2AState.lastSegmentStart = NaN;
    l2AState.lastSegmentDurationS = NaN;
    l2AState.lastSegmentRequestTimeMs = NaN;
    l2AState.lastSegmentFinishTimeMs = NaN;
  }
  /**
   * Returns the state object for a fiven media type. If the state object is not yet defined _getInitialL2AState is called
   * @param {object} rulesContext
   * @return {object} l2AState
   * @private
   */


  function _getL2AState(rulesContext) {
    var mediaType = rulesContext.getMediaType();
    var l2AState = l2AStateDict[mediaType];

    if (!l2AState) {
      l2AState = _getInitialL2AState(rulesContext);
      l2AStateDict[mediaType] = l2AState;
    }

    return l2AState;
  }
  /**
   * Event handler for the seeking event.
   * @private
   */


  function _onPlaybackSeeking() {
    for (var mediaType in l2AStateDict) {
      if (l2AStateDict.hasOwnProperty(mediaType)) {
        var l2aState = l2AStateDict[mediaType];

        if (l2aState.state !== L2A_STATE_ONE_BITRATE) {
          l2aState.state = L2A_STATE_STARTUP;

          _clearL2AStateOnSeek(l2aState);
        }
      }
    }
  }
  /**
   * Event handler for the mediaFragmentLoaded event
   * @param {object} e
   * @private
   */


  function _onMediaFragmentLoaded(e) {
    if (e && e.chunk && e.chunk.mediaInfo) {
      var l2AState = l2AStateDict[e.chunk.mediaInfo.type];
      var l2AParameters = l2AParameterDict[e.chunk.mediaInfo.type];

      if (l2AState && l2AState.state !== L2A_STATE_ONE_BITRATE) {
        var start = e.chunk.start;

        if (isNaN(l2AState.mostAdvancedSegmentStart) || start > l2AState.mostAdvancedSegmentStart) {
          l2AState.mostAdvancedSegmentStart = start;
          l2AState.lastSegmentWasReplacement = false;
        } else {
          l2AState.lastSegmentWasReplacement = true;
        }

        l2AState.lastSegmentStart = start;
        l2AState.lastSegmentDurationS = e.chunk.duration;
        l2AState.lastQuality = e.chunk.quality;

        _checkNewSegment(l2AState, l2AParameters);
      }
    }
  }
  /**
   * Event handler for the metricAdded event
   * @param {object} e
   * @private
   */


  function _onMetricAdded(e) {
    if (e && e.metric === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__["default"].HTTP_REQUEST && e.value && e.value.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_3__["HTTPRequest"].MEDIA_SEGMENT_TYPE && e.value.trace && e.value.trace.length) {
      var l2AState = l2AStateDict[e.mediaType];
      var l2AParameters = l2AParameterDict[e.mediaType];

      if (l2AState && l2AState.state !== L2A_STATE_ONE_BITRATE) {
        l2AState.lastSegmentRequestTimeMs = e.value.trequest.getTime();
        l2AState.lastSegmentFinishTimeMs = e.value._tfinish.getTime();

        _checkNewSegment(l2AState, l2AParameters);
      }
    }
  }
  /**
   * When a new metric has been added or a media fragment has been loaded the state is adjusted accordingly
   * @param {object} L2AState
   * @param {object} l2AParameters
   * @private
   */


  function _checkNewSegment(L2AState, l2AParameters) {
    if (!isNaN(L2AState.lastSegmentStart) && !isNaN(L2AState.lastSegmentRequestTimeMs)) {
      l2AParameters.segment_request_start_s = 0.001 * L2AState.lastSegmentRequestTimeMs;
      l2AParameters.segment_download_finish_s = 0.001 * L2AState.lastSegmentFinishTimeMs;
      L2AState.lastSegmentStart = NaN;
      L2AState.lastSegmentRequestTimeMs = NaN;
    }
  }
  /**
   * Event handler for the qualityChangeRequested event
   * @param {object} e
   * @private
   */


  function _onQualityChangeRequested(e) {
    // Useful to store change requests when abandoning a download.
    if (e && e.mediaType) {
      var L2AState = l2AStateDict[e.mediaType];

      if (L2AState && L2AState.state !== L2A_STATE_ONE_BITRATE) {
        L2AState.abrQuality = e.newQuality;
      }
    }
  }
  /**
   * Dot multiplication of two arrays
   * @param {array} arr1
   * @param {array} arr2
   * @return {number} sumdot
   * @private
   */


  function _dotmultiplication(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return -1;
    }

    var sumdot = 0;

    for (var i = 0; i < arr1.length; i++) {
      sumdot = sumdot + arr1[i] * arr2[i];
    }

    return sumdot;
  }
  /**
   * Project an n-dim vector y to the simplex Dn
   * Dn = { x : x n-dim, 1 >= x >= 0, sum(x) = 1}
   * Algorithm is explained at http://arxiv.org/abs/1101.6081
   * @param {array} arr
   * @return {array}
   */


  function euclideanProjection(arr) {
    var m = arr.length;
    var bget = false;
    var arr2 = [];

    for (var ii = 0; ii < m; ++ii) {
      arr2[ii] = arr[ii];
    }

    var s = arr.sort(function (a, b) {
      return b - a;
    });
    var tmpsum = 0;
    var tmax = 0;
    var x = [];

    for (var _ii = 0; _ii < m - 1; ++_ii) {
      tmpsum = tmpsum + s[_ii];
      tmax = (tmpsum - 1) / (_ii + 1);

      if (tmax >= s[_ii + 1]) {
        bget = true;
        break;
      }
    }

    if (!bget) {
      tmax = (tmpsum + s[m - 1] - 1) / m;
    }

    for (var _ii2 = 0; _ii2 < m; ++_ii2) {
      x[_ii2] = Math.max(arr2[_ii2] - tmax, 0);
    }

    return x;
  }
  /**
   * Returns a switch request object indicating which quality is to be played
   * @param {object} rulesContext
   * @return {object}
   */


  function getMaxIndex(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();
    var horizon = 4; // Optimization horizon (The amount of steps required to achieve convergence)

    var vl = Math.pow(horizon, 0.99); // Cautiousness parameter, used to control aggressiveness of the bitrate decision process.

    var alpha = Math.max(Math.pow(horizon, 1), vl * Math.sqrt(horizon)); // Step size, used for gradient descent exploration granularity

    var mediaInfo = rulesContext.getMediaInfo();
    var mediaType = rulesContext.getMediaType();
    var bitrates = mediaInfo.bitrateList.map(function (b) {
      return b.bandwidth;
    });
    var bitrateCount = bitrates.length;
    var scheduleController = rulesContext.getScheduleController();
    var streamInfo = rulesContext.getStreamInfo();
    var abrController = rulesContext.getAbrController();
    var throughputHistory = abrController.getThroughputHistory();
    var isDynamic = streamInfo && streamInfo.manifestInfo && streamInfo.manifestInfo.isDynamic;
    var useL2AABR = rulesContext.useL2AABR();
    var bufferLevel = dashMetrics.getCurrentBufferLevel(mediaType, true);
    var safeThroughput = throughputHistory.getSafeAverageThroughput(mediaType, isDynamic);
    var throughput = throughputHistory.getAverageThroughput(mediaType, isDynamic); // In kbits/s

    var react = 2; // Reactiveness to volatility (abrupt throughput drops), used to re-calibrate Lagrangian multiplier Q

    var latency = throughputHistory.getAverageLatency(mediaType);
    var videoModel = rulesContext.getVideoModel();
    var quality;
    var currentPlaybackRate = videoModel.getPlaybackRate();

    if (!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('getScheduleController') || !rulesContext.hasOwnProperty('getStreamInfo') || !rulesContext.hasOwnProperty('getAbrController') || !rulesContext.hasOwnProperty('useL2AABR')) {
      return switchRequest;
    }

    switchRequest.reason = switchRequest.reason || {};

    if (!useL2AABR || mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_7__["default"].AUDIO) {
      // L2A decides bitrate only for video. Audio to be included in decision process in a later stage
      return switchRequest;
    }

    scheduleController.setTimeToLoadDelay(0);

    var l2AState = _getL2AState(rulesContext);

    if (l2AState.state === L2A_STATE_ONE_BITRATE) {
      // shouldn't even have been called
      return switchRequest;
    }

    var l2AParameter = l2AParameterDict[mediaType];

    if (!l2AParameter) {
      return switchRequest;
    }

    switchRequest.reason.state = l2AState.state;
    switchRequest.reason.throughput = throughput;
    switchRequest.reason.latency = latency;

    if (isNaN(throughput)) {
      // still starting up - not enough information
      return switchRequest;
    }

    switch (l2AState.state) {
      case L2A_STATE_STARTUP:
        quality = abrController.getQualityForBitrate(mediaInfo, safeThroughput, streamInfo.id, latency); //During strat-up phase abr.controller is responsible for bitrate decisions.

        switchRequest.quality = quality;
        switchRequest.reason.throughput = safeThroughput;
        l2AState.lastQuality = quality;

        if (!isNaN(l2AState.lastSegmentDurationS) && bufferLevel >= l2AParameter.B_target) {
          l2AState.state = L2A_STATE_STEADY;
          l2AParameter.Q = vl; // Initialization of Q langrangian multiplier
          // Update of probability vector w, to be used in main adaptation logic of L2A below (steady state)

          for (var i = 0; i < bitrateCount; ++i) {
            if (i === l2AState.lastQuality) {
              l2AParameter.prev_w[i] = 1;
            } else {
              l2AParameter.prev_w[i] = 0;
            }
          }
        }

        break;
      // L2A_STATE_STARTUP

      case L2A_STATE_STEADY:
        var diff1 = []; //Used to calculate the difference between consecutive decisions (w-w_prev)
        // Manual calculation of latency and throughput during previous request

        var throughputMeasureTime = dashMetrics.getCurrentHttpRequest(mediaType).trace.reduce(function (a, b) {
          return a + b.d;
        }, 0);
        var downloadBytes = dashMetrics.getCurrentHttpRequest(mediaType).trace.reduce(function (a, b) {
          return a + b.b[0];
        }, 0);
        var lastthroughput = Math.round(8 * downloadBytes / throughputMeasureTime); // bits/ms = kbits/s

        if (lastthroughput < 1) {
          lastthroughput = 1;
        } //To avoid division with 0 (avoid infinity) in case of an absolute network outage


        var V = l2AState.lastSegmentDurationS;
        var sign = 1; //Main adaptation logic of L2A-LL

        for (var _i = 0; _i < bitrateCount; ++_i) {
          bitrates[_i] = bitrates[_i] / 1000; // Originally in bps, now in Kbps

          if (currentPlaybackRate * bitrates[_i] > lastthroughput) {
            // In this case buffer would deplete, leading to a stall, which increases latency and thus the particular probability of selsection of bitrate[i] should be decreased.
            sign = -1;
          } // The objective of L2A is to minimize the overall latency=request-response time + buffer length after download+ potential stalling (if buffer less than chunk downlad time)


          l2AParameter.w[_i] = l2AParameter.prev_w[_i] + sign * (V / (2 * alpha)) * ((l2AParameter.Q + vl) * (currentPlaybackRate * bitrates[_i] / lastthroughput)); //Lagrangian descent
        } // Apply euclidean projection on w to ensure w expresses a probability distribution


        l2AParameter.w = euclideanProjection(l2AParameter.w);

        for (var _i2 = 0; _i2 < bitrateCount; ++_i2) {
          diff1[_i2] = l2AParameter.w[_i2] - l2AParameter.prev_w[_i2];
          l2AParameter.prev_w[_i2] = l2AParameter.w[_i2];
        } // Lagrangian multiplier Q calculation:


        l2AParameter.Q = Math.max(0, l2AParameter.Q - V + V * currentPlaybackRate * ((_dotmultiplication(bitrates, l2AParameter.prev_w) + _dotmultiplication(bitrates, diff1)) / lastthroughput)); // Quality is calculated as argmin of the absolute difference between available bitrates (bitrates[i]) and bitrate estimation (dotmultiplication(w,bitrates)).

        var temp = [];

        for (var _i3 = 0; _i3 < bitrateCount; ++_i3) {
          temp[_i3] = Math.abs(bitrates[_i3] - _dotmultiplication(l2AParameter.w, bitrates));
        } // Quality is calculated based on the probability distribution w (the output of L2A)


        quality = temp.indexOf(Math.min.apply(Math, temp)); // We employ a cautious -stepwise- ascent

        if (quality > l2AState.lastQuality) {
          if (bitrates[l2AState.lastQuality + 1] <= lastthroughput) {
            quality = l2AState.lastQuality + 1;
          }
        } // Provision against bitrate over-estimation, by re-calibrating the Lagrangian multiplier Q, to be taken into account for the next chunk


        if (bitrates[quality] >= lastthroughput) {
          l2AParameter.Q = react * Math.max(vl, l2AParameter.Q);
        }

        switchRequest.quality = quality;
        switchRequest.reason.throughput = throughput;
        switchRequest.reason.latency = latency;
        switchRequest.reason.bufferLevel = bufferLevel;
        l2AState.lastQuality = switchRequest.quality;
        break;

      default:
        // should not arrive here, try to recover
        logger.debug('L2A ABR rule invoked in bad state.');
        switchRequest.quality = abrController.getQualityForBitrate(mediaInfo, safeThroughput, streamInfo.id, latency);
        switchRequest.reason.state = l2AState.state;
        switchRequest.reason.throughput = safeThroughput;
        switchRequest.reason.latency = latency;
        l2AState.state = L2A_STATE_STARTUP;

        _clearL2AStateOnSeek(l2AState);

    }

    return switchRequest;
  }
  /**
   * Reset objects to their initial state
   * @private
   */


  function _resetInitialSettings() {
    l2AStateDict = {};
    l2AParameterDict = {};
  }
  /**
   * Reset the rule
   */


  function reset() {
    _resetInitialSettings();

    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].PLAYBACK_SEEKING, _onPlaybackSeeking, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].MEDIA_FRAGMENT_LOADED, _onMediaFragmentLoaded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].METRIC_ADDED, _onMetricAdded, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_5__["default"].QUALITY_CHANGE_REQUESTED, _onQualityChangeRequested, instance);
  }

  instance = {
    getMaxIndex: getMaxIndex,
    reset: reset
  };
  setup();
  return instance;
}

L2ARule.__dashjs_factory_name = 'L2ARule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(L2ARule));

/***/ }),

/***/ "./src/streaming/rules/abr/SwitchHistoryRule.js":
/*!******************************************************!*\
  !*** ./src/streaming/rules/abr/SwitchHistoryRule.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2342082__) {

"use strict";
__nested_webpack_require_2342082__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2342082__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2342082__(/*! ../../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2342082__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");




function SwitchHistoryRule() {
  var context = this.context;
  var instance, logger; //MAX_SWITCH is the number of drops made. It doesn't consider the size of the drop.

  var MAX_SWITCH = 0.075; //Before this number of switch requests(no switch or actual), don't apply the rule.
  //must be < SwitchRequestHistory SWITCH_REQUEST_HISTORY_DEPTH to enable rule

  var SAMPLE_SIZE = 6;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
  }

  function getMaxIndex(rulesContext) {
    var switchRequestHistory = rulesContext ? rulesContext.getSwitchHistory() : null;
    var switchRequests = switchRequestHistory ? switchRequestHistory.getSwitchRequests() : [];
    var drops = 0;
    var noDrops = 0;
    var dropSize = 0;
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create();

    for (var i = 0; i < switchRequests.length; i++) {
      if (switchRequests[i] !== undefined) {
        drops += switchRequests[i].drops;
        noDrops += switchRequests[i].noDrops;
        dropSize += switchRequests[i].dropSize;

        if (drops + noDrops >= SAMPLE_SIZE && drops / noDrops > MAX_SWITCH) {
          switchRequest.quality = i > 0 && switchRequests[i].drops > 0 ? i - 1 : i;
          switchRequest.reason = {
            index: switchRequest.quality,
            drops: drops,
            noDrops: noDrops,
            dropSize: dropSize
          };
          logger.debug('Switch history rule index: ' + switchRequest.quality + ' samples: ' + (drops + noDrops) + ' drops: ' + drops);
          break;
        }
      }
    }

    return switchRequest;
  }

  instance = {
    getMaxIndex: getMaxIndex
  };
  setup();
  return instance;
}

SwitchHistoryRule.__dashjs_factory_name = 'SwitchHistoryRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(SwitchHistoryRule));

/***/ }),

/***/ "./src/streaming/rules/abr/ThroughputRule.js":
/*!***************************************************!*\
  !*** ./src/streaming/rules/abr/ThroughputRule.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2345013__) {

"use strict";
__nested_webpack_require_2345013__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2345013__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2345013__(/*! ../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2345013__(/*! ../../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2345013__(/*! ../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */





function ThroughputRule(config) {
  config = config || {};
  var context = this.context;
  var dashMetrics = config.dashMetrics;
  var instance;

  function setup() {}

  function checkConfig() {
    if (!dashMetrics || !dashMetrics.hasOwnProperty('getCurrentBufferState')) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getMaxIndex(rulesContext) {
    var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();

    if (!rulesContext || !rulesContext.hasOwnProperty('getMediaInfo') || !rulesContext.hasOwnProperty('getMediaType') || !rulesContext.hasOwnProperty('useBufferOccupancyABR') || !rulesContext.hasOwnProperty('getAbrController') || !rulesContext.hasOwnProperty('getScheduleController')) {
      return switchRequest;
    }

    checkConfig();
    var mediaInfo = rulesContext.getMediaInfo();
    var mediaType = rulesContext.getMediaType();
    var currentBufferState = dashMetrics.getCurrentBufferState(mediaType);
    var scheduleController = rulesContext.getScheduleController();
    var abrController = rulesContext.getAbrController();
    var streamInfo = rulesContext.getStreamInfo();
    var streamId = streamInfo ? streamInfo.id : null;
    var isDynamic = streamInfo && streamInfo.manifestInfo ? streamInfo.manifestInfo.isDynamic : null;
    var throughputHistory = abrController.getThroughputHistory();
    var throughput = throughputHistory.getSafeAverageThroughput(mediaType, isDynamic);
    var latency = throughputHistory.getAverageLatency(mediaType);
    var useBufferOccupancyABR = rulesContext.useBufferOccupancyABR();

    if (isNaN(throughput) || !currentBufferState || useBufferOccupancyABR) {
      return switchRequest;
    }

    if (abrController.getAbandonmentStateFor(streamId, mediaType) !== _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].ABANDON_LOAD) {
      if (currentBufferState.state === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_3__["default"].BUFFER_LOADED || isDynamic) {
        switchRequest.quality = abrController.getQualityForBitrate(mediaInfo, throughput, streamId, latency);
        scheduleController.setTimeToLoadDelay(0);
        switchRequest.reason = {
          throughput: throughput,
          latency: latency
        };
      }
    }

    return switchRequest;
  }

  function reset() {// no persistent information to reset
  }

  instance = {
    getMaxIndex: getMaxIndex,
    reset: reset
  };
  setup();
  return instance;
}

ThroughputRule.__dashjs_factory_name = 'ThroughputRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(ThroughputRule));

/***/ }),

/***/ "./src/streaming/rules/abr/lolp/LearningAbrController.js":
/*!***************************************************************!*\
  !*** ./src/streaming/rules/abr/lolp/LearningAbrController.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2350861__) {

"use strict";
__nested_webpack_require_2350861__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2350861__(/*! ../../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2350861__(/*! ../../../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Authors:
 * Abdelhak Bentaleb | National University of Singapore | bentaleb@comp.nus.edu.sg
 * Mehmet N. Akcay | Ozyegin University | necmettin.akcay@ozu.edu.tr
 * May Lim | National University of Singapore | maylim@comp.nus.edu.sg
 */


var WEIGHT_SELECTION_MODES = {
  MANUAL: 'manual_weight_selection',
  RANDOM: 'random_weight_selection',
  DYNAMIC: 'dynamic_weight_selection'
};

function LearningAbrController() {
  var context = this.context;
  var instance, logger, somBitrateNeurons, bitrateNormalizationFactor, latencyNormalizationFactor, minBitrate, weights, sortedCenters, weightSelectionMode;
  /**
   * Setup the class
   */

  function _setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);

    _resetInitialSettings();
  }
  /**
   * Reset all values
   */


  function reset() {
    _resetInitialSettings();
  }
  /**
   * Reset to initial settings
   * @private
   */


  function _resetInitialSettings() {
    somBitrateNeurons = null;
    bitrateNormalizationFactor = 1;
    latencyNormalizationFactor = 100;
    minBitrate = 0;
    weights = null;
    sortedCenters = null;
    weightSelectionMode = WEIGHT_SELECTION_MODES.DYNAMIC;
  }
  /**
   * Returns the maximum throughput
   * @return {number}
   * @private
   */


  function _getMaxThroughput() {
    var maxThroughput = 0;

    if (somBitrateNeurons) {
      for (var i = 0; i < somBitrateNeurons.length; i++) {
        var neuron = somBitrateNeurons[i];

        if (neuron.state.throughput > maxThroughput) {
          maxThroughput = neuron.state.throughput;
        }
      }
    }

    return maxThroughput;
  }
  /**
   *
   * @param {array} w
   * @return {number}
   * @private
   */


  function _getMagnitude(w) {
    var magnitude = w.map(function (x) {
      return Math.pow(x, 2);
    }).reduce(function (sum, now) {
      return sum + now;
    });
    return Math.sqrt(magnitude);
  }
  /**
   *
   * @param {array} a
   * @param {array} b
   * @param {array} w
   * @return {number}
   * @private
   */


  function _getDistance(a, b, w) {
    var sum = a.map(function (x, i) {
      return w[i] * Math.pow(x - b[i], 2);
    }) // square the difference*w
    .reduce(function (sum, now) {
      return sum + now;
    }); // sum

    var sign = sum < 0 ? -1 : 1;
    return sign * Math.sqrt(Math.abs(sum));
  }
  /**
   *
   * @param {object} a
   * @param {object} b
   * @return {number}
   * @private
   */


  function _getNeuronDistance(a, b) {
    var aState = [a.state.throughput, a.state.latency, a.state.rebuffer, a.state["switch"]];
    var bState = [b.state.throughput, b.state.latency, b.state.rebuffer, b.state["switch"]];
    return _getDistance(aState, bState, [1, 1, 1, 1]);
  }
  /**
   *
   * @param {object} winnerNeuron
   * @param {array} somElements
   * @param {array} x
   * @private
   */


  function _updateNeurons(winnerNeuron, somElements, x) {
    for (var i = 0; i < somElements.length; i++) {
      var somNeuron = somElements[i];
      var sigma = 0.1;

      var neuronDistance = _getNeuronDistance(somNeuron, winnerNeuron);

      var neighbourHood = Math.exp(-1 * Math.pow(neuronDistance, 2) / (2 * Math.pow(sigma, 2)));

      _updateNeuronState(somNeuron, x, neighbourHood);
    }
  }
  /**
   *
   * @param {object} neuron
   * @param {array} x
   * @param {object} neighbourHood
   * @private
   */


  function _updateNeuronState(neuron, x, neighbourHood) {
    var state = neuron.state;
    var w = [0.01, 0.01, 0.01, 0.01]; // learning rate

    state.throughput = state.throughput + (x[0] - state.throughput) * w[0] * neighbourHood;
    state.latency = state.latency + (x[1] - state.latency) * w[1] * neighbourHood;
    state.rebuffer = state.rebuffer + (x[2] - state.rebuffer) * w[2] * neighbourHood;
    state["switch"] = state["switch"] + (x[3] - state["switch"]) * w[3] * neighbourHood;
  }
  /**
   *
   * @param {object} currentNeuron
   * @param {number} currentThroughput
   * @return {object}
   * @private
   */


  function _getDownShiftNeuron(currentNeuron, currentThroughput) {
    var maxSuitableBitrate = 0;
    var result = currentNeuron;

    if (somBitrateNeurons) {
      for (var i = 0; i < somBitrateNeurons.length; i++) {
        var n = somBitrateNeurons[i];

        if (n.bitrate < currentNeuron.bitrate && n.bitrate > maxSuitableBitrate && currentThroughput > n.bitrate) {
          // possible downshiftable neuron
          maxSuitableBitrate = n.bitrate;
          result = n;
        }
      }
    }

    return result;
  }
  /**
   *
   * @param {object} mediaInfo
   * @param {number} throughput
   * @param {number} latency
   * @param {number} bufferSize
   * @param {number} playbackRate
   * @param {number} currentQualityIndex
   * @param {object} dynamicWeightsSelector
   * @return {null|*}
   */


  function getNextQuality(mediaInfo, throughput, latency, bufferSize, playbackRate, currentQualityIndex, dynamicWeightsSelector) {
    // For Dynamic Weights Selector
    var currentLatency = latency;
    var currentBuffer = bufferSize;
    var currentThroughput = throughput;

    var somElements = _getSomBitrateNeurons(mediaInfo); // normalize throughput


    var throughputNormalized = throughput / bitrateNormalizationFactor; // saturate values higher than 1

    if (throughputNormalized > 1) {
      throughputNormalized = _getMaxThroughput();
    } // normalize latency


    latency = latency / latencyNormalizationFactor;
    var targetLatency = 0;
    var targetRebufferLevel = 0;
    var targetSwitch = 0; // 10K + video encoding is the recommended throughput

    var throughputDelta = 10000;
    logger.debug("getNextQuality called throughput:".concat(throughputNormalized, " latency:").concat(latency, " bufferSize:").concat(bufferSize, " currentQualityIndex:").concat(currentQualityIndex, " playbackRate:").concat(playbackRate));
    var currentNeuron = somElements[currentQualityIndex];
    var downloadTime = currentNeuron.bitrate * dynamicWeightsSelector.getSegmentDuration() / currentThroughput;
    var rebuffer = Math.max(0, downloadTime - currentBuffer); // check buffer for possible stall

    if (currentBuffer - downloadTime < dynamicWeightsSelector.getMinBuffer()) {
      logger.debug("Buffer is low for bitrate= ".concat(currentNeuron.bitrate, " downloadTime=").concat(downloadTime, " currentBuffer=").concat(currentBuffer, " rebuffer=").concat(rebuffer));
      return _getDownShiftNeuron(currentNeuron, currentThroughput).qualityIndex;
    }

    switch (weightSelectionMode) {
      case WEIGHT_SELECTION_MODES.MANUAL:
        _manualWeightSelection();

        break;

      case WEIGHT_SELECTION_MODES.RANDOM:
        _randomWeightSelection(somElements);

        break;

      case WEIGHT_SELECTION_MODES.DYNAMIC:
        _dynamicWeightSelection(dynamicWeightsSelector, somElements, currentLatency, currentBuffer, rebuffer, currentThroughput, playbackRate);

        break;

      default:
        _dynamicWeightSelection(dynamicWeightsSelector, somElements, currentLatency, currentBuffer, rebuffer, currentThroughput, playbackRate);

    }

    var minDistance = null;
    var minIndex = null;
    var winnerNeuron = null;

    for (var i = 0; i < somElements.length; i++) {
      var somNeuron = somElements[i];
      var somNeuronState = somNeuron.state;
      var somData = [somNeuronState.throughput, somNeuronState.latency, somNeuronState.rebuffer, somNeuronState["switch"]];
      var distanceWeights = weights.slice();
      var nextBuffer = dynamicWeightsSelector.getNextBufferWithBitrate(somNeuron.bitrate, currentBuffer, currentThroughput);
      var isBufferLow = nextBuffer < dynamicWeightsSelector.getMinBuffer();

      if (isBufferLow) {
        logger.debug("Buffer is low for bitrate=".concat(somNeuron.bitrate, " downloadTime=").concat(downloadTime, " currentBuffer=").concat(currentBuffer, " nextBuffer=").concat(nextBuffer));
      } // special condition downshift immediately


      if (somNeuron.bitrate > throughput - throughputDelta || isBufferLow) {
        if (somNeuron.bitrate !== minBitrate) {
          // encourage to pick smaller bitrates throughputWeight=100
          distanceWeights[0] = 100;
        }
      } // calculate the distance with the target


      var distance = _getDistance(somData, [throughputNormalized, targetLatency, targetRebufferLevel, targetSwitch], distanceWeights);

      if (minDistance === null || distance < minDistance) {
        minDistance = distance;
        minIndex = somNeuron.qualityIndex;
        winnerNeuron = somNeuron;
      }
    } // update current neuron and the neighbourhood with the calculated QoE
    // will punish current if it is not picked


    var bitrateSwitch = Math.abs(currentNeuron.bitrate - winnerNeuron.bitrate) / bitrateNormalizationFactor;

    _updateNeurons(currentNeuron, somElements, [throughputNormalized, latency, rebuffer, bitrateSwitch]); // update bmu and  neighbours with targetQoE=1, targetLatency=0


    _updateNeurons(winnerNeuron, somElements, [throughputNormalized, targetLatency, targetRebufferLevel, bitrateSwitch]);

    return minIndex;
  }
  /**
   * Option 1: Manual weights
   * @private
   */


  function _manualWeightSelection() {
    var throughputWeight = 0.4;
    var latencyWeight = 0.4;
    var bufferWeight = 0.4;
    var switchWeight = 0.4;
    weights = [throughputWeight, latencyWeight, bufferWeight, switchWeight]; // throughput, latency, buffer, switch
  }
  /**
   * Option 2: Random (Xavier) weights
   * @param {array} somElements
   * @private
   */


  function _randomWeightSelection(somElements) {
    weights = _getXavierWeights(somElements.length, 4);
  }
  /**
   * Dynamic Weight Selector weights
   * @param {object} dynamicWeightsSelector
   * @param {array} somElements
   * @param {number} currentLatency
   * @param {number} currentBuffer
   * @param {number} rebuffer
   * @param {number} currentThroughput
   * @param {number} playbackRate
   * @private
   */


  function _dynamicWeightSelection(dynamicWeightsSelector, somElements, currentLatency, currentBuffer, rebuffer, currentThroughput, playbackRate) {
    if (!weights) {
      weights = sortedCenters[sortedCenters.length - 1];
    } // Dynamic Weights Selector (step 2/2: find weights)


    var weightVector = dynamicWeightsSelector.findWeightVector(somElements, currentLatency, currentBuffer, rebuffer, currentThroughput, playbackRate);

    if (weightVector !== null && weightVector !== -1) {
      // null: something went wrong, -1: constraints not met
      weights = weightVector;
    }
  }
  /**
   *
   * @param {number }neuronCount
   * @param {number }weightCount
   * @return {array}
   * @private
   */


  function _getXavierWeights(neuronCount, weightCount) {
    var W = [];
    var upperBound = Math.sqrt(2 / neuronCount);

    for (var i = 0; i < weightCount; i++) {
      W.push(Math.random() * upperBound);
    }

    weights = W;
    return weights;
  }
  /**
   *
   * @param {object} mediaInfo
   * @return {array}
   * @private
   */


  function _getSomBitrateNeurons(mediaInfo) {
    if (!somBitrateNeurons) {
      somBitrateNeurons = [];
      var bitrateList = mediaInfo.bitrateList;
      var bitrateVector = [];
      minBitrate = bitrateList[0].bandwidth;
      bitrateList.forEach(function (element) {
        bitrateVector.push(element.bandwidth);

        if (element.bandwidth < minBitrate) {
          minBitrate = element.bandwidth;
        }
      });
      bitrateNormalizationFactor = _getMagnitude(bitrateVector);

      for (var i = 0; i < bitrateList.length; i++) {
        var neuron = {
          qualityIndex: i,
          bitrate: bitrateList[i].bandwidth,
          state: {
            // normalize throughputs
            throughput: bitrateList[i].bandwidth / bitrateNormalizationFactor,
            latency: 0,
            rebuffer: 0,
            "switch": 0
          }
        };
        somBitrateNeurons.push(neuron);
      }

      sortedCenters = _getInitialKmeansPlusPlusCenters(somBitrateNeurons);
    }

    return somBitrateNeurons;
  }
  /**
   *
   * @param {number} size
   * @return {array}
   * @private
   */


  function _getRandomData(size) {
    var dataArray = [];

    for (var i = 0; i < size; i++) {
      var data = [Math.random() * _getMaxThroughput(), //throughput
      Math.random(), //latency
      Math.random(), //buffersize
      Math.random() //switch
      ];
      dataArray.push(data);
    }

    return dataArray;
  }
  /**
   *
   * @param {array} somElements
   * @return {array}
   * @private
   */


  function _getInitialKmeansPlusPlusCenters(somElements) {
    var centers = [];

    var randomDataSet = _getRandomData(Math.pow(somElements.length, 2));

    centers.push(randomDataSet[0]);
    var distanceWeights = [1, 1, 1, 1];

    for (var k = 1; k < somElements.length; k++) {
      var nextPoint = null;
      var _maxDistance = null;

      for (var i = 0; i < randomDataSet.length; i++) {
        var currentPoint = randomDataSet[i];
        var minDistance = null;

        for (var j = 0; j < centers.length; j++) {
          var distance = _getDistance(currentPoint, centers[j], distanceWeights);

          if (minDistance === null || distance < minDistance) {
            minDistance = distance;
          }
        }

        if (_maxDistance === null || minDistance > _maxDistance) {
          nextPoint = currentPoint;
          _maxDistance = minDistance;
        }
      }

      centers.push(nextPoint);
    } // find the least similar center


    var maxDistance = null;
    var leastSimilarIndex = null;

    for (var _i = 0; _i < centers.length; _i++) {
      var _distance = 0;

      for (var _j = 0; _j < centers.length; _j++) {
        if (_i === _j) continue;
        _distance += _getDistance(centers[_i], centers[_j], distanceWeights);
      }

      if (maxDistance === null || _distance > maxDistance) {
        maxDistance = _distance;
        leastSimilarIndex = _i;
      }
    } // move centers to sortedCenters


    var sortedCenters = [];
    sortedCenters.push(centers[leastSimilarIndex]);
    centers.splice(leastSimilarIndex, 1);

    while (centers.length > 0) {
      var _minDistance = null;
      var minIndex = null;

      for (var _i2 = 0; _i2 < centers.length; _i2++) {
        var _distance2 = _getDistance(sortedCenters[0], centers[_i2], distanceWeights);

        if (_minDistance === null || _distance2 < _minDistance) {
          _minDistance = _distance2;
          minIndex = _i2;
        }
      }

      sortedCenters.push(centers[minIndex]);
      centers.splice(minIndex, 1);
    }

    return sortedCenters;
  }

  instance = {
    getNextQuality: getNextQuality,
    reset: reset
  };

  _setup();

  return instance;
}

LearningAbrController.__dashjs_factory_name = 'LearningAbrController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(LearningAbrController));

/***/ }),

/***/ "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js":
/*!**********************************************************!*\
  !*** ./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2369020__) {

"use strict";
__nested_webpack_require_2369020__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2369020__(/*! ../../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _QoeInfo__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2369020__(/*! ./QoeInfo */ "./src/streaming/rules/abr/lolp/QoeInfo.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Authors:
 * Abdelhak Bentaleb | National University of Singapore | bentaleb@comp.nus.edu.sg
 * Mehmet N. Akcay | Ozyegin University | necmettin.akcay@ozu.edu.tr
 * May Lim | National University of Singapore | maylim@comp.nus.edu.sg
 */



function LoLpQoeEvaluator() {
  var instance, voPerSegmentQoeInfo, segmentDuration, maxBitrateKbps, minBitrateKbps;

  function _setup() {
    _resetInitialSettings();
  }

  function _resetInitialSettings() {
    voPerSegmentQoeInfo = null;
    segmentDuration = null;
    maxBitrateKbps = null;
    minBitrateKbps = null;
  }

  function setupPerSegmentQoe(sDuration, maxBrKbps, minBrKbps) {
    // Set up Per Segment QoeInfo
    voPerSegmentQoeInfo = _createQoeInfo('segment', sDuration, maxBrKbps, minBrKbps);
    segmentDuration = sDuration;
    maxBitrateKbps = maxBrKbps;
    minBitrateKbps = minBrKbps;
  }

  function _createQoeInfo(fragmentType, fragmentDuration, maxBitrateKbps, minBitrateKbps) {
    /*
     * [Weights][Source: Abdelhak Bentaleb, 2020 (last updated: 30 Mar 2020)]
     * bitrateReward:           segment duration, e.g. 0.5s
     * bitrateSwitchPenalty:    0.02s or 1s if the bitrate switch is too important
     * rebufferPenalty:         max encoding bitrate, e.g. 1000kbps
     * latencyPenalty:          if L ≤ 1.1 seconds then = min encoding bitrate * 0.05, otherwise = max encoding bitrate * 0.1
     * playbackSpeedPenalty:    min encoding bitrate, e.g. 200kbps
     */
    // Create new QoeInfo object
    var qoeInfo = new _QoeInfo__WEBPACK_IMPORTED_MODULE_1__["default"]();
    qoeInfo.type = fragmentType; // Set weight: bitrateReward
    // set some safe value, else consider throwing error

    if (!fragmentDuration) {
      qoeInfo.weights.bitrateReward = 1;
    } else {
      qoeInfo.weights.bitrateReward = fragmentDuration;
    } // Set weight: bitrateSwitchPenalty
    // qoeInfo.weights.bitrateSwitchPenalty = 0.02;


    qoeInfo.weights.bitrateSwitchPenalty = 1; // Set weight: rebufferPenalty
    // set some safe value, else consider throwing error

    if (!maxBitrateKbps) {
      qoeInfo.weights.rebufferPenalty = 1000;
    } else {
      qoeInfo.weights.rebufferPenalty = maxBitrateKbps;
    } // Set weight: latencyPenalty


    qoeInfo.weights.latencyPenalty = [];
    qoeInfo.weights.latencyPenalty.push({
      threshold: 1.1,
      penalty: minBitrateKbps * 0.05
    });
    qoeInfo.weights.latencyPenalty.push({
      threshold: 100000000,
      penalty: maxBitrateKbps * 0.1
    }); // Set weight: playbackSpeedPenalty

    if (!minBitrateKbps) qoeInfo.weights.playbackSpeedPenalty = 200; // set some safe value, else consider throwing error
    else qoeInfo.weights.playbackSpeedPenalty = minBitrateKbps;
    return qoeInfo;
  }

  function logSegmentMetrics(segmentBitrate, segmentRebufferTime, currentLatency, currentPlaybackSpeed) {
    if (voPerSegmentQoeInfo) {
      _logMetricsInQoeInfo(segmentBitrate, segmentRebufferTime, currentLatency, currentPlaybackSpeed, voPerSegmentQoeInfo);
    }
  }

  function _logMetricsInQoeInfo(bitrate, rebufferTime, latency, playbackSpeed, qoeInfo) {
    // Update: bitrate Weighted Sum value
    qoeInfo.bitrateWSum += qoeInfo.weights.bitrateReward * bitrate; // Update: bitrateSwitch Weighted Sum value

    if (qoeInfo.lastBitrate) {
      qoeInfo.bitrateSwitchWSum += qoeInfo.weights.bitrateSwitchPenalty * Math.abs(bitrate - qoeInfo.lastBitrate);
    }

    qoeInfo.lastBitrate = bitrate; // Update: rebuffer Weighted Sum value

    qoeInfo.rebufferWSum += qoeInfo.weights.rebufferPenalty * rebufferTime; // Update: latency Weighted Sum value

    for (var i = 0; i < qoeInfo.weights.latencyPenalty.length; i++) {
      var latencyRange = qoeInfo.weights.latencyPenalty[i];

      if (latency <= latencyRange.threshold) {
        qoeInfo.latencyWSum += latencyRange.penalty * latency;
        break;
      }
    } // Update: playbackSpeed Weighted Sum value


    qoeInfo.playbackSpeedWSum += qoeInfo.weights.playbackSpeedPenalty * Math.abs(1 - playbackSpeed); // Update: Total Qoe value

    qoeInfo.totalQoe = qoeInfo.bitrateWSum - qoeInfo.bitrateSwitchWSum - qoeInfo.rebufferWSum - qoeInfo.latencyWSum - qoeInfo.playbackSpeedWSum;
  } // Returns current Per Segment QoeInfo


  function getPerSegmentQoe() {
    return voPerSegmentQoeInfo;
  } // For one-time use only
  // Returns totalQoe based on a single set of metrics.


  function calculateSingleUseQoe(segmentBitrate, segmentRebufferTime, currentLatency, currentPlaybackSpeed) {
    var singleUseQoeInfo = null;

    if (segmentDuration && maxBitrateKbps && minBitrateKbps) {
      singleUseQoeInfo = _createQoeInfo('segment', segmentDuration, maxBitrateKbps, minBitrateKbps);
    }

    if (singleUseQoeInfo) {
      _logMetricsInQoeInfo(segmentBitrate, segmentRebufferTime, currentLatency, currentPlaybackSpeed, singleUseQoeInfo);

      return singleUseQoeInfo.totalQoe;
    } else {
      // Something went wrong..
      return 0;
    }
  }

  function reset() {
    _resetInitialSettings();
  }

  instance = {
    setupPerSegmentQoe: setupPerSegmentQoe,
    logSegmentMetrics: logSegmentMetrics,
    getPerSegmentQoe: getPerSegmentQoe,
    calculateSingleUseQoe: calculateSingleUseQoe,
    reset: reset
  };

  _setup();

  return instance;
}

LoLpQoeEvaluator.__dashjs_factory_name = 'LoLpQoeEvaluator';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(LoLpQoeEvaluator));

/***/ }),

/***/ "./src/streaming/rules/abr/lolp/LoLpRule.js":
/*!**************************************************!*\
  !*** ./src/streaming/rules/abr/lolp/LoLpRule.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2377242__) {

"use strict";
__nested_webpack_require_2377242__.r(__webpack_exports__);
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2377242__(/*! ../../../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2377242__(/*! ../../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _LearningAbrController__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2377242__(/*! ./LearningAbrController */ "./src/streaming/rules/abr/lolp/LearningAbrController.js");
/* harmony import */ var _LoLpQoEEvaluator__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2377242__(/*! ./LoLpQoEEvaluator */ "./src/streaming/rules/abr/lolp/LoLpQoEEvaluator.js");
/* harmony import */ var _SwitchRequest__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2377242__(/*! ../../SwitchRequest */ "./src/streaming/rules/SwitchRequest.js");
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2377242__(/*! ../../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
/* harmony import */ var _LoLpWeightSelector__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2377242__(/*! ./LoLpWeightSelector */ "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2377242__(/*! ../../../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Authors:
 * Abdelhak Bentaleb | National University of Singapore | bentaleb@comp.nus.edu.sg
 * Mehmet N. Akcay | Ozyegin University | necmettin.akcay@ozu.edu.tr
 * May Lim | National University of Singapore | maylim@comp.nus.edu.sg
 */








var DWS_TARGET_LATENCY = 1.5;
var DWS_BUFFER_MIN = 0.3;

function LoLPRule(config) {
  config = config || {};
  var dashMetrics = config.dashMetrics;
  var context = this.context;
  var logger, instance, learningController, qoeEvaluator;

  function _setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance().getLogger(instance);
    learningController = Object(_LearningAbrController__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create();
    qoeEvaluator = Object(_LoLpQoEEvaluator__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create();
  }

  function getMaxIndex(rulesContext) {
    try {
      var switchRequest = Object(_SwitchRequest__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create();
      var mediaType = rulesContext.getMediaInfo().type;
      var abrController = rulesContext.getAbrController();
      var streamInfo = rulesContext.getStreamInfo();
      var currentQuality = abrController.getQualityFor(mediaType, streamInfo.id);
      var mediaInfo = rulesContext.getMediaInfo();
      var bufferStateVO = dashMetrics.getCurrentBufferState(mediaType);
      var scheduleController = rulesContext.getScheduleController();
      var currentBufferLevel = dashMetrics.getCurrentBufferLevel(mediaType, true);
      var isDynamic = streamInfo && streamInfo.manifestInfo ? streamInfo.manifestInfo.isDynamic : null;
      var playbackController = scheduleController.getPlaybackController();
      var latency = playbackController.getCurrentLiveLatency();

      if (!rulesContext.useLoLPABR() || mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_7__["default"].AUDIO) {
        return switchRequest;
      }

      if (!latency) {
        latency = 0;
      }

      var playbackRate = playbackController.getPlaybackRate();
      var throughputHistory = abrController.getThroughputHistory();
      var throughput = throughputHistory.getSafeAverageThroughput(mediaType, isDynamic);
      logger.debug("Throughput ".concat(Math.round(throughput), " kbps"));

      if (isNaN(throughput) || !bufferStateVO) {
        return switchRequest;
      }

      if (abrController.getAbandonmentStateFor(streamInfo.id, mediaType) === _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_5__["default"].ABANDON_LOAD) {
        return switchRequest;
      } // QoE parameters


      var bitrateList = mediaInfo.bitrateList; // [{bandwidth: 200000, width: 640, height: 360}, ...]

      var segmentDuration = rulesContext.getRepresentationInfo().fragmentDuration;
      var minBitrateKbps = bitrateList[0].bandwidth / 1000.0; // min bitrate level

      var maxBitrateKbps = bitrateList[bitrateList.length - 1].bandwidth / 1000.0; // max bitrate level

      for (var i = 0; i < bitrateList.length; i++) {
        // in case bitrateList is not sorted as expected
        var b = bitrateList[i].bandwidth / 1000.0;
        if (b > maxBitrateKbps) maxBitrateKbps = b;else if (b < minBitrateKbps) {
          minBitrateKbps = b;
        }
      } // Learning rule pre-calculations


      var currentBitrate = bitrateList[currentQuality].bandwidth;
      var currentBitrateKbps = currentBitrate / 1000.0;
      var httpRequest = dashMetrics.getCurrentHttpRequest(mediaType, true);
      var lastFragmentDownloadTime = (httpRequest.tresponse.getTime() - httpRequest.trequest.getTime()) / 1000;
      var segmentRebufferTime = lastFragmentDownloadTime > segmentDuration ? lastFragmentDownloadTime - segmentDuration : 0;
      qoeEvaluator.setupPerSegmentQoe(segmentDuration, maxBitrateKbps, minBitrateKbps);
      qoeEvaluator.logSegmentMetrics(currentBitrateKbps, segmentRebufferTime, latency, playbackRate);
      /*
      * Dynamic Weights Selector (step 1/2: initialization)
      */

      var dynamicWeightsSelector = Object(_LoLpWeightSelector__WEBPACK_IMPORTED_MODULE_6__["default"])(context).create({
        targetLatency: DWS_TARGET_LATENCY,
        bufferMin: DWS_BUFFER_MIN,
        segmentDuration: segmentDuration,
        qoeEvaluator: qoeEvaluator
      });
      /*
       * Select next quality
       */

      switchRequest.quality = learningController.getNextQuality(mediaInfo, throughput * 1000, latency, currentBufferLevel, playbackRate, currentQuality, dynamicWeightsSelector);
      switchRequest.reason = {
        throughput: throughput,
        latency: latency
      };
      switchRequest.priority = _SwitchRequest__WEBPACK_IMPORTED_MODULE_4__["default"].PRIORITY.STRONG;
      scheduleController.setTimeToLoadDelay(0);

      if (switchRequest.quality !== currentQuality) {
        console.log('[TgcLearningRule][' + mediaType + '] requesting switch to index: ', switchRequest.quality, 'Average throughput', Math.round(throughput), 'kbps');
      }

      return switchRequest;
    } catch (e) {
      throw e;
    }
  }
  /**
   * Reset objects to their initial state
   * @private
   */


  function _resetInitialSettings() {
    learningController.reset();
    qoeEvaluator.reset();
  }
  /**
   * Reset the rule
   */


  function reset() {
    _resetInitialSettings();
  }

  instance = {
    getMaxIndex: getMaxIndex,
    reset: reset
  };

  _setup();

  return instance;
}

LoLPRule.__dashjs_factory_name = 'LoLPRule';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(LoLPRule));

/***/ }),

/***/ "./src/streaming/rules/abr/lolp/LoLpWeightSelector.js":
/*!************************************************************!*\
  !*** ./src/streaming/rules/abr/lolp/LoLpWeightSelector.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2386717__) {

"use strict";
__nested_webpack_require_2386717__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2386717__(/*! ../../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Authors:
 * Abdelhak Bentaleb | National University of Singapore | bentaleb@comp.nus.edu.sg
 * Mehmet N. Akcay | Ozyegin University | necmettin.akcay@ozu.edu.tr
 * May Lim | National University of Singapore | maylim@comp.nus.edu.sg
 */


function LoLpWeightSelector(config) {
  var targetLatency = config.targetLatency;
  var bufferMin = config.bufferMin;
  var segmentDuration = config.segmentDuration;
  var qoeEvaluator = config.qoeEvaluator;
  var instance, valueList, weightTypeCount, weightOptions, previousLatency;
  /**
   *
   * @private
   */

  function _setup() {
    _resetInitialSettings();
  }
  /**
   *
   * @private
   */


  function _resetInitialSettings() {
    valueList = [0.2, 0.4, 0.6, 0.8, 1];
    weightTypeCount = 4;
    weightOptions = _getPermutations(valueList, weightTypeCount);
    previousLatency = 0;
  }
  /**
   * Next, at each segment boundary, ABR to input current neurons and target state (only used in Method II) to find the desired weight vector
   * @param {array} neurons
   * @param {number} currentLatency
   * @param {number} currentBuffer
   * @param {number} currentRebuffer
   * @param {number} currentThroughput
   * @param {number} playbackRate
   * @return {null}
   * @private
   */


  function findWeightVector(neurons, currentLatency, currentBuffer, currentRebuffer, currentThroughput, playbackRate) {
    var maxQoE = null;
    var winnerWeights = null;
    var winnerBitrate = null;
    var deltaLatency = Math.abs(currentLatency - previousLatency); // For each neuron, m

    neurons.forEach(function (neuron) {
      // For each possible weight vector, z
      // E.g. For [ throughput, latency, buffer, playbackRate, QoE ]
      //      Possible weightVector = [ 0.2, 0.4, 0.2, 0, 0.2 ]
      weightOptions.forEach(function (weightVector) {
        // Apply weightVector to neuron, compute utility and determine winnerWeights
        // Method I: Utility based on QoE given current state
        var weightsObj = {
          throughput: weightVector[0],
          latency: weightVector[1],
          buffer: weightVector[2],
          "switch": weightVector[3]
        };
        var downloadTime = neuron.bitrate * segmentDuration / currentThroughput;
        var nextBuffer = getNextBuffer(currentBuffer, downloadTime);
        var rebuffer = Math.max(0.00001, downloadTime - nextBuffer);
        var wt;

        if (weightsObj.buffer === 0) {
          wt = 10;
        } else {
          wt = 1 / weightsObj.buffer;
        }

        var weightedRebuffer = wt * rebuffer;

        if (weightsObj.latency === 0) {
          wt = 10;
        } else {
          wt = 1 / weightsObj.latency; // inverse the weight because wt and latency should have positive relationship, i.e., higher latency = higher wt
        }

        var weightedLatency = wt * neuron.state.latency;
        var totalQoE = qoeEvaluator.calculateSingleUseQoe(neuron.bitrate, weightedRebuffer, weightedLatency, playbackRate);

        if ((maxQoE === null || totalQoE > maxQoE) && _checkConstraints(currentLatency, nextBuffer, deltaLatency)) {
          maxQoE = totalQoE;
          winnerWeights = weightVector;
          winnerBitrate = neuron.bitrate;
        }
      });
    }); // winnerWeights was found, check if constraints are satisfied

    if (winnerWeights === null && winnerBitrate === null) {
      winnerWeights = -1;
    }

    previousLatency = currentLatency;
    return winnerWeights;
  }
  /**
   *
   * @param {number} nextLatency
   * @param {number} nextBuffer
   * @param {number} deltaLatency
   * @return {boolean}
   * @private
   */


  function _checkConstraints(nextLatency, nextBuffer, deltaLatency) {
    // A1
    // disabled till we find a better way of estimating latency
    // fails for all with current value
    if (nextLatency > targetLatency + deltaLatency) {
      return false;
    }

    return nextBuffer >= bufferMin;
  }
  /**
   *
   * @param {array} list
   * @param {number} length
   * @return {*}
   * @private
   */


  function _getPermutations(list, length) {
    // Copy initial values as arrays
    var perm = list.map(function (val) {
      return [val];
    }); // Our permutation generator

    var generate = function generate(perm, length, currLen) {
      // Reached desired length
      if (currLen === length) {
        return perm;
      } // For each existing permutation


      var len = perm.length;

      for (var i = 0; i < len; i++) {
        var currPerm = perm.shift(); // Create new permutation

        for (var k = 0; k < list.length; k++) {
          perm.push(currPerm.concat(list[k]));
        }
      } // Recurse


      return generate(perm, length, currLen + 1);
    }; // Start with size 1 because of initial values


    return generate(perm, length, 1);
  }
  /**
   *
   * @return {number}
   */


  function getMinBuffer() {
    return bufferMin;
  }
  /**
   *
   * @return {number}
   */


  function getSegmentDuration() {
    return segmentDuration;
  }
  /**
   *
   * @param {number} bitrateToDownload
   * @param {number} currentBuffer
   * @param {number} currentThroughput
   * @return {number}
   */


  function getNextBufferWithBitrate(bitrateToDownload, currentBuffer, currentThroughput) {
    var downloadTime = bitrateToDownload * segmentDuration / currentThroughput;
    return getNextBuffer(currentBuffer, downloadTime);
  }
  /**
   *
   * @param {number} currentBuffer
   * @param {number} downloadTime
   * @return {number}
   */


  function getNextBuffer(currentBuffer, downloadTime) {
    var segmentDuration = getSegmentDuration();
    var nextBuffer;

    if (downloadTime > segmentDuration) {
      nextBuffer = currentBuffer - segmentDuration;
    } else {
      nextBuffer = currentBuffer + segmentDuration - downloadTime;
    }

    return nextBuffer;
  }

  instance = {
    getMinBuffer: getMinBuffer,
    getSegmentDuration: getSegmentDuration,
    getNextBufferWithBitrate: getNextBufferWithBitrate,
    getNextBuffer: getNextBuffer,
    findWeightVector: findWeightVector
  };

  _setup();

  return instance;
}

LoLpWeightSelector.__dashjs_factory_name = 'LoLpWeightSelector';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(LoLpWeightSelector));

/***/ }),

/***/ "./src/streaming/rules/abr/lolp/QoeInfo.js":
/*!*************************************************!*\
  !*** ./src/streaming/rules/abr/lolp/QoeInfo.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2395680__) {

"use strict";
__nested_webpack_require_2395680__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var QoeInfo = function QoeInfo() {
  _classCallCheck(this, QoeInfo);

  // Type e.g. 'segment'
  this.type = null; // Store lastBitrate for calculation of bitrateSwitchWSum

  this.lastBitrate = null; // Weights for each Qoe factor

  this.weights = {};
  this.weights.bitrateReward = null;
  this.weights.bitrateSwitchPenalty = null;
  this.weights.rebufferPenalty = null;
  this.weights.latencyPenalty = null;
  this.weights.playbackSpeedPenalty = null; // Weighted Sum for each Qoe factor

  this.bitrateWSum = 0; // kbps

  this.bitrateSwitchWSum = 0; // kbps

  this.rebufferWSum = 0; // seconds

  this.latencyWSum = 0; // seconds

  this.playbackSpeedWSum = 0; // e.g. 0.95, 1.0, 1.05
  // Store total Qoe value based on current Weighted Sum values

  this.totalQoe = 0;
};

/* harmony default export */ __webpack_exports__["default"] = (QoeInfo);

/***/ }),

/***/ "./src/streaming/text/EmbeddedTextHtmlRender.js":
/*!******************************************************!*\
  !*** ./src/streaming/text/EmbeddedTextHtmlRender.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2399040__) {

"use strict";
__nested_webpack_require_2399040__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2399040__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function EmbeddedTextHtmlRender() {
  var captionId = 0;
  var instance;
  /* HTML Rendering functions */

  function checkIndent(chars) {
    var line = '';

    for (var c = 0; c < chars.length; ++c) {
      var uc = chars[c];
      line += uc.uchar;
    }

    var l = line.length;
    var ll = line.replace(/^\s+/, '').length;
    return l - ll;
  }

  function getRegionProperties(region) {
    return 'left: ' + region.x * 3.125 + '%; top: ' + region.y1 * 6.66 + '%; width: ' + (100 - region.x * 3.125) + '%; height: ' + Math.max(region.y2 - 1 - region.y1, 1) * 6.66 + '%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;';
  }

  function createRGB(color) {
    if (color === 'red') {
      return 'rgb(255, 0, 0)';
    } else if (color === 'green') {
      return 'rgb(0, 255, 0)';
    } else if (color === 'blue') {
      return 'rgb(0, 0, 255)';
    } else if (color === 'cyan') {
      return 'rgb(0, 255, 255)';
    } else if (color === 'magenta') {
      return 'rgb(255, 0, 255)';
    } else if (color === 'yellow') {
      return 'rgb(255, 255, 0)';
    } else if (color === 'white') {
      return 'rgb(255, 255, 255)';
    } else if (color === 'black') {
      return 'rgb(0, 0, 0)';
    }

    return color;
  }

  function getStyle(videoElement, style) {
    var fontSize = videoElement.videoHeight / 15.0;

    if (style) {
      return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; color: ' + (style.foreground ? createRGB(style.foreground) : 'rgb(255, 255, 255)') + '; font-style: ' + (style.italics ? 'italic' : 'normal') + '; text-decoration: ' + (style.underline ? 'underline' : 'none') + '; white-space: pre; background-color: ' + (style.background ? createRGB(style.background) : 'transparent') + ';';
    } else {
      return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;';
    }
  }

  function ltrim(s) {
    return s.replace(/^\s+/g, '');
  }

  function rtrim(s) {
    return s.replace(/\s+$/g, '');
  }

  function createHTMLCaptionsFromScreen(videoElement, startTime, endTime, captionScreen) {
    var currRegion = null;
    var existingRegion = null;
    var lastRowHasText = false;
    var lastRowIndentL = -1;
    var currP = {
      start: startTime,
      end: endTime,
      spans: []
    };
    var currentStyle = 'style_cea608_white_black';
    var seenRegions = {};
    var styleStates = {};
    var regions = [];
    var r, s;

    for (r = 0; r < 15; ++r) {
      var row = captionScreen.rows[r];
      var line = '';
      var prevPenState = null;

      if (false === row.isEmpty()) {
        /* Row is not empty */

        /* Get indentation of this row */
        var rowIndent = checkIndent(row.chars);
        /* Create a new region is there is none */

        if (currRegion === null) {
          currRegion = {
            x: rowIndent,
            y1: r,
            y2: r + 1,
            p: []
          };
        }
        /* Check if indentation has changed and we had text of last row */


        if (rowIndent !== lastRowIndentL && lastRowHasText) {
          currRegion.p.push(currP);
          currP = {
            start: startTime,
            end: endTime,
            spans: []
          };
          currRegion.y2 = r;
          currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;

          if (false === seenRegions.hasOwnProperty(currRegion.name)) {
            regions.push(currRegion);
            seenRegions[currRegion.name] = currRegion;
          } else {
            existingRegion = seenRegions[currRegion.name];
            existingRegion.p.contat(currRegion.p);
          }

          currRegion = {
            x: rowIndent,
            y1: r,
            y2: r + 1,
            p: []
          };
        }

        for (var c = 0; c < row.chars.length; ++c) {
          var uc = row.chars[c];
          var currPenState = uc.penState;

          if (prevPenState === null || !currPenState.equals(prevPenState)) {
            if (line.trim().length > 0) {
              currP.spans.push({
                name: currentStyle,
                line: line,
                row: r
              });
              line = '';
            }

            var currPenStateString = 'style_cea608_' + currPenState.foreground + '_' + currPenState.background;

            if (currPenState.underline) {
              currPenStateString += '_underline';
            }

            if (currPenState.italics) {
              currPenStateString += '_italics';
            }

            if (!styleStates.hasOwnProperty(currPenStateString)) {
              styleStates[currPenStateString] = JSON.parse(JSON.stringify(currPenState));
            }

            prevPenState = currPenState;
            currentStyle = currPenStateString;
          }

          line += uc.uchar;
        }

        if (line.trim().length > 0) {
          currP.spans.push({
            name: currentStyle,
            line: line,
            row: r
          });
        }

        lastRowHasText = true;
        lastRowIndentL = rowIndent;
      } else {
        /* Row is empty */
        lastRowHasText = false;
        lastRowIndentL = -1;

        if (currRegion) {
          currRegion.p.push(currP);
          currP = {
            start: startTime,
            end: endTime,
            spans: []
          };
          currRegion.y2 = r;
          currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;

          if (false === seenRegions.hasOwnProperty(currRegion.name)) {
            regions.push(currRegion);
            seenRegions[currRegion.name] = currRegion;
          } else {
            existingRegion = seenRegions[currRegion.name];
            existingRegion.p.contat(currRegion.p);
          }

          currRegion = null;
        }
      }
    }

    if (currRegion) {
      currRegion.p.push(currP);
      currRegion.y2 = r + 1;
      currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;

      if (false === seenRegions.hasOwnProperty(currRegion.name)) {
        regions.push(currRegion);
        seenRegions[currRegion.name] = currRegion;
      } else {
        existingRegion = seenRegions[currRegion.name];
        existingRegion.p.contat(currRegion.p);
      }

      currRegion = null;
    }

    var captionsArray = [];
    /* Loop thru regions */

    for (r = 0; r < regions.length; ++r) {
      var region = regions[r];
      var cueID = 'sub_cea608_' + captionId++;
      var finalDiv = document.createElement('div');
      finalDiv.id = cueID;
      var cueRegionProperties = getRegionProperties(region);
      finalDiv.style.cssText = 'position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;' + cueRegionProperties;
      var bodyDiv = document.createElement('div');
      bodyDiv.className = 'paragraph bodyStyle';
      bodyDiv.style.cssText = getStyle(videoElement);
      var cueUniWrapper = document.createElement('div');
      cueUniWrapper.className = 'cueUniWrapper';
      cueUniWrapper.style.cssText = 'unicode-bidi: normal; direction: ltr;';

      for (var p = 0; p < region.p.length; ++p) {
        var ptag = region.p[p];
        var lastSpanRow = 0;

        for (s = 0; s < ptag.spans.length; ++s) {
          var span = ptag.spans[s];

          if (span.line.length > 0) {
            if (s !== 0 && lastSpanRow != span.row) {
              var brElement = document.createElement('br');
              brElement.className = 'lineBreak';
              cueUniWrapper.appendChild(brElement);
            }

            var sameRow = false;

            if (lastSpanRow === span.row) {
              sameRow = true;
            }

            lastSpanRow = span.row;
            var spanStyle = styleStates[span.name];
            var spanElement = document.createElement('span');
            spanElement.className = 'spanPadding ' + span.name + ' customSpanColor';
            spanElement.style.cssText = getStyle(videoElement, spanStyle);
            /* If this is not the first span, and it's on the same
             * row as the last one */

            if (s !== 0 && sameRow) {
              /* and it's the last span on this row */
              if (s === ptag.spans.length - 1) {
                /* trim only the right side */
                spanElement.textContent = rtrim(span.line);
              } else {
                /* don't trim at all */
                spanElement.textContent = span.line;
              }
            } else {
              /* if there is more than 1 span and this isn't the last span */
              if (ptag.spans.length > 1 && s < ptag.spans.length - 1) {
                /* Check if next text is on same row */
                if (span.row === ptag.spans[s + 1].row) {
                  /* Next element on same row, trim start */
                  spanElement.textContent = ltrim(span.line);
                } else {
                  /* Different rows, trim both */
                  spanElement.textContent = span.line.trim();
                }
              } else {
                spanElement.textContent = span.line.trim();
              }
            }

            cueUniWrapper.appendChild(spanElement);
          }
        }
      }

      bodyDiv.appendChild(cueUniWrapper);
      finalDiv.appendChild(bodyDiv);
      var fontSize = {
        'bodyStyle': ['%', 90]
      };

      for (var _s in styleStates) {
        if (styleStates.hasOwnProperty(_s)) {
          fontSize[_s] = ['%', 90];
        }
      }

      captionsArray.push({
        type: 'html',
        start: startTime,
        end: endTime,
        cueHTMLElement: finalDiv,
        cueID: cueID,
        cellResolution: [32, 15],
        isFromCEA608: true,
        fontSize: fontSize,
        lineHeight: {},
        linePadding: {}
      });
    }

    return captionsArray;
  }

  instance = {
    createHTMLCaptionsFromScreen: createHTMLCaptionsFromScreen
  };
  return instance;
}

EmbeddedTextHtmlRender.__dashjs_factory_name = 'EmbeddedTextHtmlRender';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(EmbeddedTextHtmlRender));

/***/ }),

/***/ "./src/streaming/text/NotFragmentedTextBufferController.js":
/*!*****************************************************************!*\
  !*** ./src/streaming/text/NotFragmentedTextBufferController.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2412377__) {

"use strict";
__nested_webpack_require_2412377__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2412377__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2412377__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2412377__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _utils_InitCache__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2412377__(/*! ../utils/InitCache */ "./src/streaming/utils/InitCache.js");
/* harmony import */ var _SourceBufferSink__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2412377__(/*! ../SourceBufferSink */ "./src/streaming/SourceBufferSink.js");
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2412377__(/*! ../../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2412377__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







var BUFFER_CONTROLLER_TYPE = 'NotFragmentedTextBufferController';

function NotFragmentedTextBufferController(config) {
  config = config || {};
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  var textController = config.textController;
  var errHandler = config.errHandler;
  var streamInfo = config.streamInfo;
  var type = config.type;
  var instance, isBufferingCompleted, initialized, mediaSource, sourceBufferSink, initCache;

  function setup() {
    initialized = false;
    mediaSource = null;
    isBufferingCompleted = false;
    initCache = Object(_utils_InitCache__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].INIT_FRAGMENT_LOADED, _onInitFragmentLoaded, instance);
  }

  function getBufferControllerType() {
    return BUFFER_CONTROLLER_TYPE;
  }

  function initialize(source) {
    setMediaSource(source);
  }

  function createBufferSink(mediaInfo) {
    return new Promise(function (resolve, reject) {
      try {
        sourceBufferSink = Object(_SourceBufferSink__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
          mediaSource: mediaSource,
          textController: textController,
          eventBus: eventBus
        });
        sourceBufferSink.initializeForFirstUse(streamInfo, mediaInfo);

        if (!initialized) {
          if (sourceBufferSink.getBuffer() && typeof sourceBufferSink.getBuffer().initialize === 'function') {
            sourceBufferSink.getBuffer().initialize();
          }

          initialized = true;
        }

        resolve(sourceBufferSink);
      } catch (e) {
        errHandler.error(new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_5__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_6__["default"].MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE + type));
        reject(e);
      }
    });
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function getType() {
    return type;
  }

  function getBuffer() {
    return sourceBufferSink;
  }

  function setMediaSource(value) {
    mediaSource = value;
  }

  function getMediaSource() {
    return mediaSource;
  }

  function getIsPruningInProgress() {
    return false;
  }

  function getBufferLevel() {
    return 0;
  }

  function getIsBufferingCompleted() {
    return isBufferingCompleted;
  }

  function setIsBufferingCompleted(value) {
    if (isBufferingCompleted === value) {
      return;
    }

    isBufferingCompleted = value;

    if (isBufferingCompleted) {
      triggerEvent(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].BUFFERING_COMPLETED);
    }
  }

  function reset(errored) {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].INIT_FRAGMENT_LOADED, _onInitFragmentLoaded, instance);

    if (!errored && sourceBufferSink) {
      sourceBufferSink.abort();
      sourceBufferSink.reset();
      sourceBufferSink = null;
    }
  }

  function appendInitSegmentFromCache(representationId) {
    // If text data file already in cache then no need to append it again
    return initCache.extract(streamInfo.id, representationId) !== null;
  }

  function _onInitFragmentLoaded(e) {
    if (!e.chunk.bytes || isBufferingCompleted) return;
    initCache.save(e.chunk);
    sourceBufferSink.append(e.chunk);
    setIsBufferingCompleted(true);
  }

  function getRangeAt() {
    return null;
  }

  function getAllRangesWithSafetyFactor() {
    return [];
  }

  function getContinuousBufferTimeForTargetTime() {
    return Number.POSITIVE_INFINITY;
  }

  function clearBuffers() {
    return Promise.resolve();
  }

  function updateBufferTimestampOffset() {
    return Promise.resolve();
  }

  function prepareForPlaybackSeek() {
    return Promise.resolve();
  }

  function prepareForReplacementTrackSwitch() {
    isBufferingCompleted = false;
    return Promise.resolve();
  }

  function updateAppendWindow() {
    return Promise.resolve();
  }

  function setSeekTarget() {}

  function segmentRequestingCompleted() {}

  function pruneAllSafely() {
    return Promise.resolve();
  }

  function triggerEvent(eventType, data) {
    var payload = data || {};
    eventBus.trigger(eventType, payload, {
      streamId: streamInfo.id,
      mediaType: type
    });
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    getType: getType,
    getBufferControllerType: getBufferControllerType,
    createBufferSink: createBufferSink,
    getBuffer: getBuffer,
    getBufferLevel: getBufferLevel,
    getRangeAt: getRangeAt,
    getAllRangesWithSafetyFactor: getAllRangesWithSafetyFactor,
    getContinuousBufferTimeForTargetTime: getContinuousBufferTimeForTargetTime,
    setMediaSource: setMediaSource,
    getMediaSource: getMediaSource,
    appendInitSegmentFromCache: appendInitSegmentFromCache,
    getIsBufferingCompleted: getIsBufferingCompleted,
    setIsBufferingCompleted: setIsBufferingCompleted,
    getIsPruningInProgress: getIsPruningInProgress,
    reset: reset,
    clearBuffers: clearBuffers,
    prepareForPlaybackSeek: prepareForPlaybackSeek,
    prepareForReplacementTrackSwitch: prepareForReplacementTrackSwitch,
    setSeekTarget: setSeekTarget,
    updateAppendWindow: updateAppendWindow,
    pruneAllSafely: pruneAllSafely,
    updateBufferTimestampOffset: updateBufferTimestampOffset,
    segmentRequestingCompleted: segmentRequestingCompleted
  };
  setup();
  return instance;
}

NotFragmentedTextBufferController.__dashjs_factory_name = BUFFER_CONTROLLER_TYPE;
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(NotFragmentedTextBufferController));

/***/ }),

/***/ "./src/streaming/text/TextController.js":
/*!**********************************************!*\
  !*** ./src/streaming/text/TextController.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2421852__) {

"use strict";
__nested_webpack_require_2421852__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2421852__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2421852__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _TextSourceBuffer__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2421852__(/*! ./TextSourceBuffer */ "./src/streaming/text/TextSourceBuffer.js");
/* harmony import */ var _TextTracks__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2421852__(/*! ./TextTracks */ "./src/streaming/text/TextTracks.js");
/* harmony import */ var _utils_VTTParser__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2421852__(/*! ../utils/VTTParser */ "./src/streaming/utils/VTTParser.js");
/* harmony import */ var _utils_TTMLParser__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2421852__(/*! ../utils/TTMLParser */ "./src/streaming/utils/TTMLParser.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2421852__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2421852__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2421852__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2421852__(/*! ../utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */











function TextController(config) {
  var context = this.context;
  var adapter = config.adapter;
  var errHandler = config.errHandler;
  var manifestModel = config.manifestModel;
  var mediaController = config.mediaController;
  var videoModel = config.videoModel;
  var settings = config.settings;
  var instance, streamData, textSourceBuffers, textTracks, vttParser, ttmlParser, eventBus, defaultSettings, initialSettingsSet, allTracksAreDisabled, forceTextStreaming, textTracksAdded, disableTextBeforeTextTracksAdded;

  function setup() {
    defaultSettings = null;
    forceTextStreaming = false;
    textTracksAdded = false;
    initialSettingsSet = false;
    disableTextBeforeTextTracksAdded = false;
    vttParser = Object(_utils_VTTParser__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
    ttmlParser = Object(_utils_TTMLParser__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance();
    eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance();
    resetInitialSettings();
  }

  function initialize() {
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].CURRENT_TRACK_CHANGED, _onCurrentTrackChanged, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].TEXT_TRACKS_QUEUE_INITIALIZED, _onTextTracksAdded, instance);
  }

  function initializeForStream(streamInfo) {
    var streamId = streamInfo.id;
    var tracks = Object(_TextTracks__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
      videoModel: videoModel,
      streamInfo: streamInfo
    });
    tracks.initialize();
    textTracks[streamId] = tracks;
    var textSourceBuffer = Object(_TextSourceBuffer__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
      errHandler: errHandler,
      adapter: adapter,
      manifestModel: manifestModel,
      mediaController: mediaController,
      videoModel: videoModel,
      textTracks: tracks,
      vttParser: vttParser,
      ttmlParser: ttmlParser,
      streamInfo: streamInfo
    });
    textSourceBuffer.initialize();
    textSourceBuffers[streamId] = textSourceBuffer;
    streamData[streamId] = {};
    streamData[streamId].lastEnabledIndex = -1;
  }
  /**
   * All media infos have been added. Start creating the track objects
   * @param {object} streamInfo
   */


  function createTracks(streamInfo) {
    var streamId = streamInfo.id;

    if (!textTracks[streamId]) {
      return;
    }

    textTracks[streamId].createTracks();
  }
  /**
   * Adds the new mediaInfo objects to the textSourceBuffer.
   * @param {object} streamInfo
   * @param {array} mInfos
   * @param {string|null} mimeType
   * @param {object} fragmentModel
   */


  function addMediaInfosToBuffer(streamInfo, type, mInfos) {
    var fragmentModel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var streamId = streamInfo.id;

    if (!textSourceBuffers[streamId]) {
      return;
    }

    textSourceBuffers[streamId].addMediaInfos(type, mInfos, fragmentModel);
  }

  function getTextSourceBuffer(streamInfo) {
    var streamId = streamInfo.id;

    if (textSourceBuffers && textSourceBuffers[streamId]) {
      return textSourceBuffers[streamId];
    }
  }

  function getAllTracksAreDisabled() {
    return allTracksAreDisabled;
  }

  function addEmbeddedTrack(streamInfo, mediaInfo) {
    var streamId = streamInfo.id;

    if (!textSourceBuffers[streamId]) {
      return;
    }

    textSourceBuffers[streamId].addEmbeddedTrack(mediaInfo);
  }

  function setInitialSettings(settings) {
    defaultSettings = settings;
    initialSettingsSet = true;
  }

  function _onTextTracksAdded(e) {
    var tracks = e.tracks;
    var index = e.index;
    var streamId = e.streamId;
    var textDefaultEnabled = settings.get().streaming.text.defaultEnabled;

    if (textDefaultEnabled === false && !isTextEnabled() || disableTextBeforeTextTracksAdded) {
      // disable text at startup if explicitly configured with setTextDefaultEnabled(false) or if there is no defaultSettings (configuration or from domStorage)
      setTextTrack(streamId, -1);
    } else {
      if (defaultSettings) {
        tracks.some(function (item, idx) {
          // matchSettings is compatible with setTextDefaultLanguage and setInitialSettings
          if (mediaController.matchSettings(defaultSettings, item)) {
            setTextTrack(streamId, idx);
            index = idx;
            return true;
          }
        });
      }

      allTracksAreDisabled = false;
    }

    streamData[streamId].lastEnabledIndex = index;
    eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_8__["default"].TEXT_TRACKS_ADDED, {
      enabled: isTextEnabled(),
      index: index,
      tracks: tracks,
      streamId: streamId
    });
    textTracksAdded = true;
  }

  function _onCurrentTrackChanged(event) {
    if (!initialSettingsSet && event && event.newMediaInfo) {
      var mediaInfo = event.newMediaInfo;

      if (mediaInfo.type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
        defaultSettings = {
          lang: mediaInfo.lang,
          role: mediaInfo.roles[0],
          index: mediaInfo.index,
          codec: mediaInfo.codec,
          accessibility: mediaInfo.accessibility[0]
        };
      }
    }
  }

  function enableText(streamId, enable) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_9__["checkParameterType"])(enable, 'boolean');

    if (isTextEnabled() !== enable) {
      // change track selection
      if (enable) {
        // apply last enabled track
        setTextTrack(streamId, streamData[streamId].lastEnabledIndex);
      }

      if (!enable) {
        // keep last index and disable text track
        streamData[streamId].lastEnabledIndex = getCurrentTrackIdx(streamId);

        if (!textTracksAdded) {
          disableTextBeforeTextTracksAdded = true;
        } else {
          setTextTrack(streamId, -1);
        }
      }
    }
  }

  function isTextEnabled() {
    var enabled = true;

    if (allTracksAreDisabled && !forceTextStreaming) {
      enabled = false;
    }

    return enabled;
  } // when set to true ScheduleController will allow schedule of chunks even if tracks are all disabled. Allowing streaming to hidden track for external players to work with.


  function enableForcedTextStreaming(enable) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_9__["checkParameterType"])(enable, 'boolean');
    forceTextStreaming = enable;
  }

  function setTextTrack(streamId, idx) {
    // For external time text file, the only action needed to change a track is marking the track mode to showing.
    // Fragmented text tracks need the additional step of calling TextController.setTextTrack();
    allTracksAreDisabled = idx === -1;

    if (allTracksAreDisabled && mediaController) {
      mediaController.saveTextSettingsDisabled();
    }

    var oldTrackIdx = getCurrentTrackIdx(streamId); // No change, no action required

    if (oldTrackIdx === idx || !textTracks[streamId]) {
      return;
    }

    textTracks[streamId].setModeForTrackIdx(oldTrackIdx, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_HIDDEN);
    textTracks[streamId].setCurrentTrackIdx(idx);
    textTracks[streamId].setModeForTrackIdx(idx, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_SHOWING);
    var currentTrackInfo = textTracks[streamId].getCurrentTrackInfo();

    if (currentTrackInfo && currentTrackInfo.isFragmented && !currentTrackInfo.isEmbedded) {
      _setFragmentedTextTrack(streamId, currentTrackInfo, oldTrackIdx);
    } else if (currentTrackInfo && !currentTrackInfo.isFragmented) {
      _setNonFragmentedTextTrack(streamId, currentTrackInfo);
    }

    mediaController.setTrack(currentTrackInfo);
  }

  function _setFragmentedTextTrack(streamId, currentTrackInfo, oldTrackIdx) {
    if (!textSourceBuffers[streamId]) {
      return;
    }

    var config = textSourceBuffers[streamId].getConfig();
    var fragmentedTracks = config.fragmentedTracks;

    for (var i = 0; i < fragmentedTracks.length; i++) {
      var mediaInfo = fragmentedTracks[i];

      if (currentTrackInfo.lang === mediaInfo.lang && (mediaInfo.id ? currentTrackInfo.id === mediaInfo.id : currentTrackInfo.index === mediaInfo.index)) {
        var currentFragTrack = mediaController.getCurrentTrackFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT, streamId);

        if (mediaInfo.id ? currentFragTrack.id !== mediaInfo.id : currentFragTrack.index !== mediaInfo.index) {
          textTracks[streamId].deleteCuesFromTrackIdx(oldTrackIdx);
          textSourceBuffers[streamId].setCurrentFragmentedTrackIdx(i);
        } else if (oldTrackIdx === -1) {
          // in fragmented use case, if the user selects the older track (the one selected before disabled text track)
          // no CURRENT_TRACK_CHANGED event will be triggered because the mediaInfo in the StreamProcessor is equal to the one we are selecting
          // For that reason we reactivate the StreamProcessor and the ScheduleController
          eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].SET_FRAGMENTED_TEXT_AFTER_DISABLED, {}, {
            streamId: streamId,
            mediaType: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT
          });
        }
      }
    }
  }

  function _setNonFragmentedTextTrack(streamId, currentTrackInfo) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].SET_NON_FRAGMENTED_TEXT, {
      currentTrackInfo: currentTrackInfo
    }, {
      streamId: streamId,
      mediaType: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT
    });
  }

  function getCurrentTrackIdx(streamId) {
    return textTracks[streamId].getCurrentTrackIdx();
  }

  function deactivateStream(streamInfo) {
    if (!streamInfo) {
      return;
    }

    var streamId = streamInfo.id;

    if (textSourceBuffers[streamId]) {
      textSourceBuffers[streamId].resetMediaInfos();
    }

    if (textTracks[streamId]) {
      textTracks[streamId].deleteAllTextTracks();
    }
  }

  function resetInitialSettings() {
    textSourceBuffers = {};
    textTracks = {};
    streamData = {};
    allTracksAreDisabled = true;
    textTracksAdded = false;
    disableTextBeforeTextTracksAdded = false;
  }

  function reset() {
    resetInitialSettings();
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].CURRENT_TRACK_CHANGED, _onCurrentTrackChanged, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_7__["default"].TEXT_TRACKS_QUEUE_INITIALIZED, _onTextTracksAdded, instance);
    Object.keys(textSourceBuffers).forEach(function (key) {
      textSourceBuffers[key].resetEmbedded();
      textSourceBuffers[key].reset();
    });
  }

  instance = {
    deactivateStream: deactivateStream,
    initialize: initialize,
    initializeForStream: initializeForStream,
    createTracks: createTracks,
    getTextSourceBuffer: getTextSourceBuffer,
    getAllTracksAreDisabled: getAllTracksAreDisabled,
    addEmbeddedTrack: addEmbeddedTrack,
    setInitialSettings: setInitialSettings,
    enableText: enableText,
    isTextEnabled: isTextEnabled,
    setTextTrack: setTextTrack,
    getCurrentTrackIdx: getCurrentTrackIdx,
    enableForcedTextStreaming: enableForcedTextStreaming,
    addMediaInfosToBuffer: addMediaInfosToBuffer,
    reset: reset
  };
  setup();
  return instance;
}

TextController.__dashjs_factory_name = 'TextController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(TextController));

/***/ }),

/***/ "./src/streaming/text/TextSourceBuffer.js":
/*!************************************************!*\
  !*** ./src/streaming/text/TextSourceBuffer.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2437848__) {

"use strict";
__nested_webpack_require_2437848__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2437848__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2437848__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/* harmony import */ var _vo_TextTrackInfo__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2437848__(/*! ../vo/TextTrackInfo */ "./src/streaming/vo/TextTrackInfo.js");
/* harmony import */ var _utils_BoxParser__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2437848__(/*! ../utils/BoxParser */ "./src/streaming/utils/BoxParser.js");
/* harmony import */ var _utils_CustomTimeRanges__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2437848__(/*! ../utils/CustomTimeRanges */ "./src/streaming/utils/CustomTimeRanges.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2437848__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2437848__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _EmbeddedTextHtmlRender__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2437848__(/*! ./EmbeddedTextHtmlRender */ "./src/streaming/text/EmbeddedTextHtmlRender.js");
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2437848__(/*! codem-isoboxer */ "./node_modules/codem-isoboxer/dist/iso_boxer.js");
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__nested_webpack_require_2437848__.n(codem_isoboxer__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2437848__(/*! ../../../externals/cea608-parser */ "./externals/cea608-parser.js");
/* harmony import */ var _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__nested_webpack_require_2437848__.n(_externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_10__ = __nested_webpack_require_2437848__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_11__ = __nested_webpack_require_2437848__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_12__ = __nested_webpack_require_2437848__(/*! ../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__ = __nested_webpack_require_2437848__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */















function TextSourceBuffer(config) {
  var errHandler = config.errHandler;
  var manifestModel = config.manifestModel;
  var mediaController = config.mediaController;
  var videoModel = config.videoModel;
  var textTracks = config.textTracks;
  var vttParser = config.vttParser;
  var ttmlParser = config.ttmlParser;
  var streamInfo = config.streamInfo;
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_10__["default"])(context).getInstance();
  var embeddedInitialized = false;
  var instance, logger, boxParser, parser, mediaInfos, fragmentModel, initializationSegmentReceived, timescale, fragmentedTracks, firstFragmentedSubtitleStart, currFragmentedTrackIdx, embeddedTracks, embeddedTimescale, embeddedLastSequenceNumber, embeddedCea608FieldParsers, embeddedTextHtmlRender;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance().getLogger(instance);
    boxParser = Object(_utils_BoxParser__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance();
    resetInitialSettings();
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function _resetFragmented() {
    fragmentModel = null;
    timescale = NaN;
    fragmentedTracks = [];
    firstFragmentedSubtitleStart = null;
    initializationSegmentReceived = false;
  }

  function resetInitialSettings() {
    _resetFragmented();

    mediaInfos = [];
    parser = null;
  }

  function initialize() {
    if (!embeddedInitialized) {
      _initEmbedded();
    }
  }
  /**
   * There might be media infos of different types. For instance text and fragmentedText.
   * @param {string} type
   * @param {array} mInfos
   * @param {object} fModel
   */


  function addMediaInfos(type, mInfos, fModel) {
    mediaInfos = mediaInfos.concat(mInfos);

    if (type === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT && mInfos[0].isFragmented && !mInfos[0].isEmbedded) {
      fragmentModel = fModel;
      instance.buffered = Object(_utils_CustomTimeRanges__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create();
      fragmentedTracks = mediaController.getTracksFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT, streamInfo.id).filter(function (track) {
        return track.isFragmented;
      });
      var currFragTrack = mediaController.getCurrentTrackFor(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT, streamInfo.id);

      for (var i = 0; i < fragmentedTracks.length; i++) {
        if (fragmentedTracks[i] === currFragTrack) {
          setCurrentFragmentedTrackIdx(i);
          break;
        }
      }
    }

    for (var _i = 0; _i < mInfos.length; _i++) {
      _createTextTrackFromMediaInfo(mInfos[_i]);
    }
  }
  /**
   * Create a new track based on the mediaInfo information
   * @param {object} mediaInfo
   * @private
   */


  function _createTextTrackFromMediaInfo(mediaInfo) {
    var textTrackInfo = new _vo_TextTrackInfo__WEBPACK_IMPORTED_MODULE_2__["default"]();
    var trackKindMap = {
      subtitle: 'subtitles',
      caption: 'captions'
    }; //Dash Spec has no "s" on end of KIND but HTML needs plural.

    for (var key in mediaInfo) {
      textTrackInfo[key] = mediaInfo[key];
    }

    textTrackInfo.labels = mediaInfo.labels;
    textTrackInfo.defaultTrack = getIsDefault(mediaInfo);
    textTrackInfo.isFragmented = mediaInfo.isFragmented;
    textTrackInfo.isEmbedded = !!mediaInfo.isEmbedded;
    textTrackInfo.isTTML = _checkTtml(mediaInfo);
    textTrackInfo.kind = _getKind(mediaInfo, trackKindMap);
    textTracks.addTextTrack(textTrackInfo);
  }

  function abort() {}

  function reset() {
    resetInitialSettings();
    mediaInfos = [];
    boxParser = null;
  }

  function _onVideoChunkReceived(e) {
    var chunk = e.chunk;

    if (chunk.mediaInfo.embeddedCaptions) {
      append(chunk.bytes, chunk);
    }
  }

  function _initEmbedded() {
    embeddedTracks = [];
    currFragmentedTrackIdx = null;
    embeddedTimescale = 0;
    embeddedCea608FieldParsers = [];
    embeddedLastSequenceNumber = null;
    embeddedInitialized = true;
    embeddedTextHtmlRender = Object(_EmbeddedTextHtmlRender__WEBPACK_IMPORTED_MODULE_7__["default"])(context).getInstance();
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].VIDEO_CHUNK_RECEIVED, _onVideoChunkReceived, instance);
    eventBus.on(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_CLEARED, onVideoBufferCleared, instance);
  }

  function resetEmbedded() {
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].VIDEO_CHUNK_RECEIVED, _onVideoChunkReceived, instance);
    eventBus.off(_core_events_Events__WEBPACK_IMPORTED_MODULE_11__["default"].BUFFER_CLEARED, onVideoBufferCleared, instance);

    if (textTracks) {
      textTracks.deleteAllTextTracks();
    }

    embeddedInitialized = false;
    embeddedTracks = [];
    embeddedCea608FieldParsers = [null, null];
    embeddedLastSequenceNumber = null;
  }

  function addEmbeddedTrack(mediaInfo) {
    if (!embeddedInitialized) {
      return;
    }

    if (mediaInfo) {
      if (mediaInfo.id === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].CC1 || mediaInfo.id === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].CC3) {
        for (var i = 0; i < embeddedTracks.length; i++) {
          if (embeddedTracks[i].id === mediaInfo.id) {
            return;
          }
        }

        embeddedTracks.push(mediaInfo);
      } else {
        logger.warn('Embedded track ' + mediaInfo.id + ' not supported!');
      }
    }
  }

  function getConfig() {
    var config = {
      fragmentModel: fragmentModel,
      fragmentedTracks: fragmentedTracks,
      videoModel: videoModel
    };
    return config;
  }

  function setCurrentFragmentedTrackIdx(idx) {
    currFragmentedTrackIdx = idx;
  }

  function _checkTtml(mediaInfo) {
    return mediaInfo.codec && mediaInfo.codec.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STPP) >= 0 || mediaInfo.mimeType && mediaInfo.mimeType.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TTML) >= 0;
  }

  function _getKind(mediaInfo, trackKindMap) {
    var kind = mediaInfo.roles && mediaInfo.roles.length > 0 ? trackKindMap[mediaInfo.roles[0]] : trackKindMap.caption;
    kind = kind === trackKindMap.caption || kind === trackKindMap.subtitle ? kind : trackKindMap.caption;
    return kind;
  }

  function append(bytes, chunk) {
    var mediaInfo = chunk.mediaInfo;
    var mediaType = mediaInfo.type;
    var mimeType = mediaInfo.mimeType;
    var codecType = mediaInfo.codec || mimeType;

    if (!codecType) {
      logger.error('No text type defined');
      return;
    }

    if (mediaInfo.codec.indexOf('application/mp4') !== -1) {
      _appendFragmentedText(bytes, chunk, codecType);
    } else if (mediaType === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
      _appendEmbeddedText(bytes, chunk);
    } else {
      _appendText(bytes, chunk, codecType);
    }
  }

  function _appendFragmentedText(bytes, chunk, codecType) {
    var sampleList, samplesInfo;

    if (chunk.segmentType === 'InitializationSegment') {
      initializationSegmentReceived = true;
      timescale = boxParser.getMediaTimescaleFromMoov(bytes);
    } else {
      if (!initializationSegmentReceived) {
        return;
      }

      samplesInfo = boxParser.getSamplesInfo(bytes);
      sampleList = samplesInfo.sampleList;

      if (sampleList.length > 0) {
        firstFragmentedSubtitleStart = sampleList[0].cts - chunk.start * timescale;
      }

      if (codecType.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STPP) >= 0) {
        _appendFragmentedSttp(bytes, sampleList, codecType);
      } else {
        _appendFragmentedWebVtt(bytes, sampleList);
      }
    }
  }

  function _appendFragmentedSttp(bytes, sampleList, codecType) {
    var i, j;
    parser = parser !== null ? parser : getParser(codecType);

    for (i = 0; i < sampleList.length; i++) {
      var sample = sampleList[i];
      var sampleStart = sample.cts;

      var timestampOffset = _getTimestampOffset();

      var start = timestampOffset + sampleStart / timescale;
      var end = start + sample.duration / timescale;
      instance.buffered.add(start, end);
      var dataView = new DataView(bytes, sample.offset, sample.subSizes[0]);
      var ccContent = codem_isoboxer__WEBPACK_IMPORTED_MODULE_8___default.a.Utils.dataViewToString(dataView, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].UTF8);
      var images = [];
      var subOffset = sample.offset + sample.subSizes[0];

      for (j = 1; j < sample.subSizes.length; j++) {
        var inData = new Uint8Array(bytes, subOffset, sample.subSizes[j]);
        var raw = String.fromCharCode.apply(null, inData);
        images.push(raw);
        subOffset += sample.subSizes[j];
      }

      try {
        var manifest = manifestModel.getValue(); // Only used for Miscrosoft Smooth Streaming support - caption time is relative to sample time. In this case, we apply an offset.

        var offsetTime = manifest.ttmlTimeIsRelative ? sampleStart / timescale : 0;
        var result = parser.parse(ccContent, offsetTime, sampleStart / timescale, (sampleStart + sample.duration) / timescale, images);
        textTracks.addCaptions(currFragmentedTrackIdx, timestampOffset, result);
      } catch (e) {
        fragmentModel.removeExecutedRequestsBeforeTime();
        this.remove();
        logger.error('TTML parser error: ' + e.message);
      }
    }
  }

  function _appendFragmentedWebVtt(bytes, sampleList) {
    var i, j, k;
    var captionArray = [];

    for (i = 0; i < sampleList.length; i++) {
      var sample = sampleList[i];
      sample.cts -= firstFragmentedSubtitleStart;

      var timestampOffset = _getTimestampOffset();

      var start = timestampOffset + sample.cts / timescale;
      var end = start + sample.duration / timescale;
      instance.buffered.add(start, end);
      var sampleData = bytes.slice(sample.offset, sample.offset + sample.size); // There are boxes inside the sampleData, so we need a ISOBoxer to get at it.

      var sampleBoxes = codem_isoboxer__WEBPACK_IMPORTED_MODULE_8___default.a.parseBuffer(sampleData);

      for (j = 0; j < sampleBoxes.boxes.length; j++) {
        var box1 = sampleBoxes.boxes[j];
        logger.debug('VTT box1: ' + box1.type);

        if (box1.type === 'vtte') {
          continue; //Empty box
        }

        if (box1.type === 'vttc') {
          logger.debug('VTT vttc boxes.length = ' + box1.boxes.length);

          for (k = 0; k < box1.boxes.length; k++) {
            var box2 = box1.boxes[k];
            logger.debug('VTT box2: ' + box2.type);

            if (box2.type === 'payl') {
              var cue_text = box2.cue_text;
              logger.debug('VTT cue_text = ' + cue_text);
              var start_time = sample.cts / timescale;
              var end_time = (sample.cts + sample.duration) / timescale;
              captionArray.push({
                start: start_time,
                end: end_time,
                data: cue_text,
                styles: {}
              });
              logger.debug('VTT ' + start_time + '-' + end_time + ' : ' + cue_text);
            }
          }
        }
      }
    }

    if (captionArray.length > 0) {
      textTracks.addCaptions(currFragmentedTrackIdx, 0, captionArray);
    }
  }

  function _appendText(bytes, chunk, codecType) {
    var result, ccContent;
    var dataView = new DataView(bytes, 0, bytes.byteLength);
    ccContent = codem_isoboxer__WEBPACK_IMPORTED_MODULE_8___default.a.Utils.dataViewToString(dataView, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].UTF8);

    try {
      result = getParser(codecType).parse(ccContent, 0);
      textTracks.addCaptions(textTracks.getCurrentTrackIdx(), 0, result);

      if (instance.buffered) {
        instance.buffered.add(chunk.start, chunk.end);
      }
    } catch (e) {
      errHandler.error(new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_12__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"].TIMED_TEXT_ERROR_ID_PARSE_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_13__["default"].TIMED_TEXT_ERROR_MESSAGE_PARSE + e.message, ccContent));
    }
  }

  function _appendEmbeddedText(bytes, chunk) {
    var i, samplesInfo; // Init segment

    if (chunk.segmentType === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].INIT_SEGMENT_TYPE) {
      if (embeddedTimescale === 0) {
        embeddedTimescale = boxParser.getMediaTimescaleFromMoov(bytes);
      }
    } // MediaSegment
    else if (chunk.segmentType === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].MEDIA_SEGMENT_TYPE) {
        if (embeddedTimescale === 0) {
          logger.warn('CEA-608: No timescale for embeddedTextTrack yet');
          return;
        }

        samplesInfo = boxParser.getSamplesInfo(bytes);
        var sequenceNumber = samplesInfo.lastSequenceNumber;

        if (!embeddedCea608FieldParsers[0] && !embeddedCea608FieldParsers[1]) {
          _setupCeaParser();
        }

        if (embeddedTimescale) {
          if (embeddedLastSequenceNumber !== null && sequenceNumber !== embeddedLastSequenceNumber + samplesInfo.numSequences) {
            for (i = 0; i < embeddedCea608FieldParsers.length; i++) {
              if (embeddedCea608FieldParsers[i]) {
                embeddedCea608FieldParsers[i].reset();
              }
            }
          }

          var allCcData = _extractCea608Data(bytes, samplesInfo.sampleList);

          for (var fieldNr = 0; fieldNr < embeddedCea608FieldParsers.length; fieldNr++) {
            var ccData = allCcData.fields[fieldNr];
            var fieldParser = embeddedCea608FieldParsers[fieldNr];

            if (fieldParser) {
              for (i = 0; i < ccData.length; i++) {
                fieldParser.addData(ccData[i][0] / embeddedTimescale, ccData[i][1]);
              }
            }
          }

          embeddedLastSequenceNumber = sequenceNumber;
        }
      }
  }

  function _setupCeaParser() {
    // Time to setup the CEA-608 parsing
    var trackIdx;

    for (var i = 0; i < embeddedTracks.length; i++) {
      trackIdx = textTracks.getTrackIdxForId(embeddedTracks[i].id);

      if (trackIdx === -1) {
        logger.warn('CEA-608: data before track is ready.');
        return;
      }

      var handler = _makeCueAdderForIndex(trackIdx);

      embeddedCea608FieldParsers[i] = new _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9___default.a.Cea608Parser(i + 1, {
        newCue: handler
      }, null);
    }
  }

  function _makeCueAdderForIndex(trackIndex) {
    function newCue(startTime, endTime, captionScreen) {
      var captionsArray;

      if (videoModel.getTTMLRenderingDiv()) {
        captionsArray = embeddedTextHtmlRender.createHTMLCaptionsFromScreen(videoModel.getElement(), startTime, endTime, captionScreen);
      } else {
        var text = captionScreen.getDisplayText();
        captionsArray = [{
          start: startTime,
          end: endTime,
          data: text,
          styles: {}
        }];
      }

      if (captionsArray) {
        textTracks.addCaptions(trackIndex, 0, captionsArray);
      }
    }

    return newCue;
  }
  /**
   * Extract CEA-608 data from a buffer of data.
   * @param {ArrayBuffer} data
   * @param {Array} samples cue information
   * @returns {Object|null} ccData corresponding to one segment.
   */


  function _extractCea608Data(data, samples) {
    if (samples.length === 0) {
      return null;
    }

    var allCcData = {
      splits: [],
      fields: [[], []]
    };
    var raw = new DataView(data);

    for (var i = 0; i < samples.length; i++) {
      var sample = samples[i];
      var cea608Ranges = _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9___default.a.findCea608Nalus(raw, sample.offset, sample.size);
      var lastSampleTime = null;
      var idx = 0;

      for (var j = 0; j < cea608Ranges.length; j++) {
        var ccData = _externals_cea608_parser__WEBPACK_IMPORTED_MODULE_9___default.a.extractCea608DataFromRange(raw, cea608Ranges[j]);

        for (var k = 0; k < 2; k++) {
          if (ccData[k].length > 0) {
            if (sample.cts !== lastSampleTime) {
              idx = 0;
            } else {
              idx += 1;
            }

            var timestampOffset = _getTimestampOffset();

            allCcData.fields[k].push([sample.cts + timestampOffset * embeddedTimescale, ccData[k], idx]);
            lastSampleTime = sample.cts;
          }
        }
      }
    } // Sort by sampleTime ascending order
    // If two packets have the same sampleTime, use them in the order
    // they were received


    allCcData.fields.forEach(function sortField(field) {
      field.sort(function (a, b) {
        if (a[0] === b[0]) {
          return a[2] - b[2];
        }

        return a[0] - b[0];
      });
    });
    return allCcData;
  }

  function _getTimestampOffset() {
    return !isNaN(instance.timestampOffset) ? instance.timestampOffset : 0;
  }

  function getIsDefault(mediaInfo) {
    //TODO How to tag default. currently same order as listed in manifest.
    // Is there a way to mark a text adaptation set as the default one? DASHIF meeting talk about using role which is being used for track KIND
    // Eg subtitles etc. You can have multiple role tags per adaptation Not defined in the spec yet.
    var isDefault = false;

    if (embeddedTracks.length > 1 && mediaInfo.isEmbedded) {
      isDefault = mediaInfo.id && mediaInfo.id === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].CC1; // CC1 if both CC1 and CC3 exist
    } else if (embeddedTracks.length === 1) {
      if (mediaInfo.id && typeof mediaInfo.id === 'string' && mediaInfo.id.substring(0, 2) === 'CC') {
        // Either CC1 or CC3
        isDefault = true;
      }
    } else if (embeddedTracks.length === 0) {
      isDefault = mediaInfo.index === mediaInfos[0].index;
    }

    return isDefault;
  }

  function getParser(codecType) {
    var parser;

    if (codecType.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VTT) >= 0) {
      parser = vttParser;
    } else if (codecType.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TTML) >= 0 || codecType.search(_constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STPP) >= 0) {
      parser = ttmlParser;
    }

    return parser;
  }

  function remove(start, end) {
    //if start and end are not defined, remove all
    if (start === undefined && start === end) {
      start = instance.buffered.start(0);
      end = instance.buffered.end(instance.buffered.length - 1);
    }

    instance.buffered.remove(start, end);
    textTracks.deleteCuesFromTrackIdx(currFragmentedTrackIdx, start, end);
  }

  function onVideoBufferCleared(e) {
    embeddedTracks.forEach(function (track) {
      var trackIdx = textTracks.getTrackIdxForId(track.id);

      if (trackIdx >= 0) {
        textTracks.deleteCuesFromTrackIdx(trackIdx, e.from, e.to);
      }
    });
  }

  function resetMediaInfos() {
    mediaInfos = [];
  }

  instance = {
    initialize: initialize,
    addMediaInfos: addMediaInfos,
    resetMediaInfos: resetMediaInfos,
    getStreamId: getStreamId,
    append: append,
    abort: abort,
    addEmbeddedTrack: addEmbeddedTrack,
    resetEmbedded: resetEmbedded,
    getConfig: getConfig,
    setCurrentFragmentedTrackIdx: setCurrentFragmentedTrackIdx,
    remove: remove,
    reset: reset
  };
  setup();
  return instance;
}

TextSourceBuffer.__dashjs_factory_name = 'TextSourceBuffer';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_5__["default"].getClassFactory(TextSourceBuffer));

/***/ }),

/***/ "./src/streaming/text/TextTracks.js":
/*!******************************************!*\
  !*** ./src/streaming/text/TextTracks.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2463247__) {

"use strict";
__nested_webpack_require_2463247__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2463247__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2463247__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2463247__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2463247__(/*! ../../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2463247__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2463247__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var imsc__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2463247__(/*! imsc */ "./node_modules/imsc/src/main/js/main.js");
/* harmony import */ var imsc__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__nested_webpack_require_2463247__.n(imsc__WEBPACK_IMPORTED_MODULE_6__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








function TextTracks(config) {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var videoModel = config.videoModel;
  var streamInfo = config.streamInfo;
  var instance, logger, Cue, textTrackQueue, nativeTrackElementArr, currentTrackIdx, actualVideoLeft, actualVideoTop, actualVideoWidth, actualVideoHeight, captionContainer, videoSizeCheckInterval, fullscreenAttribute, displayCCOnTop, previousISDState, topZIndex, resizeObserver;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_5__["default"])(context).getInstance().getLogger(instance);
  }

  function initialize() {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return;
    }

    Cue = window.VTTCue || window.TextTrackCue;
    textTrackQueue = [];
    nativeTrackElementArr = [];
    currentTrackIdx = -1;
    actualVideoLeft = 0;
    actualVideoTop = 0;
    actualVideoWidth = 0;
    actualVideoHeight = 0;
    captionContainer = null;
    videoSizeCheckInterval = null;
    displayCCOnTop = false;
    topZIndex = 2147483647;
    previousISDState = null;

    if (document.fullscreenElement !== undefined) {
      fullscreenAttribute = 'fullscreenElement'; // Standard and Edge
    } else if (document.webkitIsFullScreen !== undefined) {
      fullscreenAttribute = 'webkitIsFullScreen'; // Chrome and Safari (and Edge)
    } else if (document.msFullscreenElement) {
      // IE11
      fullscreenAttribute = 'msFullscreenElement';
    } else if (document.mozFullScreen) {
      // Firefox
      fullscreenAttribute = 'mozFullScreen';
    }
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function _createTrackForUserAgent(element) {
    var kind = element.kind;
    var label = element.id !== undefined ? element.id : element.lang;
    var lang = element.lang;
    var isTTML = element.isTTML;
    var isEmbedded = element.isEmbedded;
    var track = videoModel.addTextTrack(kind, label, lang, isTTML, isEmbedded);
    return track;
  }

  function addTextTrack(textTrackInfoVO) {
    textTrackQueue.push(textTrackInfoVO);
  }

  function createTracks() {
    //Sort in same order as in manifest
    textTrackQueue.sort(function (a, b) {
      return a.index - b.index;
    });
    captionContainer = videoModel.getTTMLRenderingDiv();
    var defaultIndex = -1;

    for (var i = 0; i < textTrackQueue.length; i++) {
      var track = _createTrackForUserAgent(textTrackQueue[i]); //used to remove tracks from video element when added manually


      nativeTrackElementArr.push(track);

      if (textTrackQueue[i].defaultTrack) {
        // track.default is an object property identifier that is a reserved word
        // The following jshint directive is used to suppressed the warning "Expected an identifier and instead saw 'default' (a reserved word)"

        /*jshint -W024 */
        track["default"] = true;
        defaultIndex = i;
      }

      var textTrack = getTrackByIdx(i);

      if (textTrack) {
        //each time a track is created, its mode should be showing by default
        //sometime, it's not on Chrome
        textTrack.mode = _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_SHOWING;

        if (captionContainer && (textTrackQueue[i].isTTML || textTrackQueue[i].isEmbedded)) {
          textTrack.renderingType = 'html';
        } else {
          textTrack.renderingType = 'default';
        }
      }

      addCaptions(i, 0, textTrackQueue[i].captionData);
      eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].TEXT_TRACK_ADDED);
    } //set current track index in textTrackQueue array


    setCurrentTrackIdx.call(this, defaultIndex);

    if (defaultIndex >= 0) {
      var onMetadataLoaded = function onMetadataLoaded() {
        var track = getTrackByIdx(defaultIndex);

        if (track && track.renderingType === 'html') {
          checkVideoSize.call(this, track, true);
        }

        eventBus.off(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].PLAYBACK_METADATA_LOADED, onMetadataLoaded, this);
      };

      eventBus.on(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].PLAYBACK_METADATA_LOADED, onMetadataLoaded, this);

      for (var idx = 0; idx < textTrackQueue.length; idx++) {
        var videoTextTrack = getTrackByIdx(idx);

        if (videoTextTrack) {
          videoTextTrack.mode = idx === defaultIndex ? _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_SHOWING : _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_HIDDEN;
        }
      }
    }

    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].TEXT_TRACKS_QUEUE_INITIALIZED, {
      index: currentTrackIdx,
      tracks: textTrackQueue,
      streamId: streamInfo.id
    });
  }

  function getVideoVisibleVideoSize(viewWidth, viewHeight, videoWidth, videoHeight, aspectRatio, use80Percent) {
    var viewAspectRatio = viewWidth / viewHeight;
    var videoAspectRatio = videoWidth / videoHeight;
    var videoPictureWidth = 0;
    var videoPictureHeight = 0;

    if (viewAspectRatio > videoAspectRatio) {
      videoPictureHeight = viewHeight;
      videoPictureWidth = videoPictureHeight / videoHeight * videoWidth;
    } else {
      videoPictureWidth = viewWidth;
      videoPictureHeight = videoPictureWidth / videoWidth * videoHeight;
    }

    var videoPictureXAspect = 0;
    var videoPictureYAspect = 0;
    var videoPictureWidthAspect = 0;
    var videoPictureHeightAspect = 0;
    var videoPictureAspect = videoPictureWidth / videoPictureHeight;

    if (videoPictureAspect > aspectRatio) {
      videoPictureHeightAspect = videoPictureHeight;
      videoPictureWidthAspect = videoPictureHeight * aspectRatio;
    } else {
      videoPictureWidthAspect = videoPictureWidth;
      videoPictureHeightAspect = videoPictureWidth / aspectRatio;
    }

    videoPictureXAspect = (viewWidth - videoPictureWidthAspect) / 2;
    videoPictureYAspect = (viewHeight - videoPictureHeightAspect) / 2;

    if (use80Percent) {
      return {
        x: videoPictureXAspect + videoPictureWidthAspect * 0.1,
        y: videoPictureYAspect + videoPictureHeightAspect * 0.1,
        w: videoPictureWidthAspect * 0.8,
        h: videoPictureHeightAspect * 0.8
      };
      /* Maximal picture size in videos aspect ratio */
    } else {
      return {
        x: videoPictureXAspect,
        y: videoPictureYAspect,
        w: videoPictureWidthAspect,
        h: videoPictureHeightAspect
      };
      /* Maximal picture size in videos aspect ratio */
    }
  }

  function checkVideoSize(track, forceDrawing) {
    var clientWidth = videoModel.getClientWidth();
    var clientHeight = videoModel.getClientHeight();
    var videoWidth = videoModel.getVideoWidth();
    var videoHeight = videoModel.getVideoHeight();
    var videoOffsetTop = videoModel.getVideoRelativeOffsetTop();
    var videoOffsetLeft = videoModel.getVideoRelativeOffsetLeft();

    if (videoWidth !== 0 && videoHeight !== 0) {
      var aspectRatio = videoWidth / videoHeight;
      var use80Percent = false;

      if (track.isFromCEA608) {
        // If this is CEA608 then use predefined aspect ratio
        aspectRatio = 3.5 / 3.0;
        use80Percent = true;
      }

      var realVideoSize = getVideoVisibleVideoSize.call(this, clientWidth, clientHeight, videoWidth, videoHeight, aspectRatio, use80Percent);
      var newVideoWidth = realVideoSize.w;
      var newVideoHeight = realVideoSize.h;
      var newVideoLeft = realVideoSize.x;
      var newVideoTop = realVideoSize.y;

      if (newVideoWidth != actualVideoWidth || newVideoHeight != actualVideoHeight || newVideoLeft != actualVideoLeft || newVideoTop != actualVideoTop || forceDrawing) {
        actualVideoLeft = newVideoLeft + videoOffsetLeft;
        actualVideoTop = newVideoTop + videoOffsetTop;
        actualVideoWidth = newVideoWidth;
        actualVideoHeight = newVideoHeight;

        if (captionContainer) {
          var containerStyle = captionContainer.style;

          if (containerStyle) {
            containerStyle.left = actualVideoLeft + 'px';
            containerStyle.top = actualVideoTop + 'px';
            containerStyle.width = actualVideoWidth + 'px';
            containerStyle.height = actualVideoHeight + 'px';
            containerStyle.zIndex = fullscreenAttribute && document[fullscreenAttribute] || displayCCOnTop ? topZIndex : null;
            eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].CAPTION_CONTAINER_RESIZE);
          }
        } // Video view has changed size, so resize any active cues


        var activeCues = track.activeCues;

        if (activeCues) {
          var len = activeCues.length;

          for (var i = 0; i < len; ++i) {
            var cue = activeCues[i];
            cue.scaleCue(cue);
          }
        }
      }
    }
  }

  function scaleCue(activeCue) {
    var videoWidth = actualVideoWidth;
    var videoHeight = actualVideoHeight;
    var key, replaceValue, valueFontSize, valueLineHeight, elements;

    if (activeCue.cellResolution) {
      var cellUnit = [videoWidth / activeCue.cellResolution[0], videoHeight / activeCue.cellResolution[1]];

      if (activeCue.linePadding) {
        for (key in activeCue.linePadding) {
          if (activeCue.linePadding.hasOwnProperty(key)) {
            var valueLinePadding = activeCue.linePadding[key];
            replaceValue = (valueLinePadding * cellUnit[0]).toString(); // Compute the CellResolution unit in order to process properties using sizing (fontSize, linePadding, etc).

            var elementsSpan = document.getElementsByClassName('spanPadding');

            for (var i = 0; i < elementsSpan.length; i++) {
              elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
              elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
            }
          }
        }
      }

      if (activeCue.fontSize) {
        for (key in activeCue.fontSize) {
          if (activeCue.fontSize.hasOwnProperty(key)) {
            if (activeCue.fontSize[key][0] === '%') {
              valueFontSize = activeCue.fontSize[key][1] / 100;
            } else if (activeCue.fontSize[key][0] === 'c') {
              valueFontSize = activeCue.fontSize[key][1];
            }

            replaceValue = (valueFontSize * cellUnit[1]).toString();

            if (key !== 'defaultFontSize') {
              elements = document.getElementsByClassName(key);
            } else {
              elements = document.getElementsByClassName('paragraph');
            }

            for (var j = 0; j < elements.length; j++) {
              elements[j].style.cssText = elements[j].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
            }
          }
        }

        if (activeCue.lineHeight) {
          for (key in activeCue.lineHeight) {
            if (activeCue.lineHeight.hasOwnProperty(key)) {
              if (activeCue.lineHeight[key][0] === '%') {
                valueLineHeight = activeCue.lineHeight[key][1] / 100;
              } else if (activeCue.fontSize[key][0] === 'c') {
                valueLineHeight = activeCue.lineHeight[key][1];
              }

              replaceValue = (valueLineHeight * cellUnit[1]).toString();
              elements = document.getElementsByClassName(key);

              for (var k = 0; k < elements.length; k++) {
                elements[k].style.cssText = elements[k].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
              }
            }
          }
        }
      }
    }

    if (activeCue.isd) {
      var htmlCaptionDiv = document.getElementById(activeCue.cueID);

      if (htmlCaptionDiv) {
        captionContainer.removeChild(htmlCaptionDiv);
      }

      renderCaption(activeCue);
    }
  }

  function renderCaption(cue) {
    if (captionContainer) {
      var finalCue = document.createElement('div');
      captionContainer.appendChild(finalCue);
      previousISDState = Object(imsc__WEBPACK_IMPORTED_MODULE_6__["renderHTML"])(cue.isd, finalCue, function (uri) {
        var imsc1ImgUrnTester = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/;
        var smpteImgUrnTester = /^#(.*)$/;

        if (imsc1ImgUrnTester.test(uri)) {
          var match = imsc1ImgUrnTester.exec(uri);
          var imageId = parseInt(match[4], 10) - 1;
          var imageData = btoa(cue.images[imageId]);
          var dataUrl = 'data:image/png;base64,' + imageData;
          return dataUrl;
        } else if (smpteImgUrnTester.test(uri)) {
          var _match = smpteImgUrnTester.exec(uri);

          var _imageId = _match[1];

          var _dataUrl = 'data:image/png;base64,' + cue.embeddedImages[_imageId];

          return _dataUrl;
        } else {
          return null;
        }
      }, captionContainer.clientHeight, captionContainer.clientWidth, false
      /*displayForcedOnlyMode*/
      , function (err) {
        logger.info('renderCaption :', err); //TODO add ErrorHandler management
      }, previousISDState, true
      /*enableRollUp*/
      );
      finalCue.id = cue.cueID;
      eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].CAPTION_RENDERED, {
        captionDiv: finalCue,
        currentTrackIdx: currentTrackIdx
      });
    }
  }
  /*
   * Add captions to track, store for later adding, or add captions added before
   */


  function addCaptions(trackIdx, timeOffset, captionData) {
    var track = getTrackByIdx(trackIdx);
    var self = this;

    if (!track) {
      return;
    }

    if (!Array.isArray(captionData) || captionData.length === 0) {
      return;
    }

    for (var item = 0; item < captionData.length; item++) {
      var cue = void 0;
      var currentItem = captionData[item];
      track.cellResolution = currentItem.cellResolution;
      track.isFromCEA608 = currentItem.isFromCEA608;

      if (currentItem.type === 'html' && captionContainer && !isNaN(currentItem.start) && !isNaN(currentItem.end)) {
        cue = new Cue(currentItem.start + timeOffset, currentItem.end + timeOffset, '');
        cue.cueHTMLElement = currentItem.cueHTMLElement;
        cue.isd = currentItem.isd;
        cue.images = currentItem.images;
        cue.embeddedImages = currentItem.embeddedImages;
        cue.cueID = currentItem.cueID;
        cue.scaleCue = scaleCue.bind(self); //useful parameters for cea608 subtitles, not for TTML one.

        cue.cellResolution = currentItem.cellResolution;
        cue.lineHeight = currentItem.lineHeight;
        cue.linePadding = currentItem.linePadding;
        cue.fontSize = currentItem.fontSize;
        captionContainer.style.left = actualVideoLeft + 'px';
        captionContainer.style.top = actualVideoTop + 'px';
        captionContainer.style.width = actualVideoWidth + 'px';
        captionContainer.style.height = actualVideoHeight + 'px';

        cue.onenter = function () {
          if (track.mode === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_SHOWING) {
            if (this.isd) {
              renderCaption(this);
              logger.debug('Cue enter id:' + this.cueID);
            } else {
              captionContainer.appendChild(this.cueHTMLElement);
              scaleCue.call(self, this);
              eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].CAPTION_RENDERED, {
                captionDiv: this.cueHTMLElement,
                currentTrackIdx: currentTrackIdx
              });
            }
          }
        };

        cue.onexit = function () {
          if (captionContainer) {
            var divs = captionContainer.childNodes;

            for (var i = 0; i < divs.length; ++i) {
              if (divs[i].id === this.cueID) {
                logger.debug('Cue exit id:' + divs[i].id);
                captionContainer.removeChild(divs[i]);
                --i;
              }
            }
          }
        };
      } else {
        if (currentItem.data && !isNaN(currentItem.start) && !isNaN(currentItem.end)) {
          cue = new Cue(currentItem.start - timeOffset, currentItem.end - timeOffset, currentItem.data);

          if (currentItem.styles) {
            if (currentItem.styles.align !== undefined && 'align' in cue) {
              cue.align = currentItem.styles.align;
            }

            if (currentItem.styles.line !== undefined && 'line' in cue) {
              cue.line = currentItem.styles.line;
            }

            if (currentItem.styles.position !== undefined && 'position' in cue) {
              cue.position = currentItem.styles.position;
            }

            if (currentItem.styles.size !== undefined && 'size' in cue) {
              cue.size = currentItem.styles.size;
            }
          }

          cue.onenter = function () {
            if (track.mode === _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT_SHOWING) {
              eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_3__["default"].CAPTION_RENDERED, {
                currentTrackIdx: currentTrackIdx
              });
            }
          };
        }
      }

      try {
        if (cue) {
          if (!cueInTrack(track, cue)) {
            track.addCue(cue);
          }
        } else {
          logger.error('impossible to display subtitles.');
        }
      } catch (e) {
        // Edge crash, delete everything and start adding again
        // @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11979877/
        deleteTrackCues(track);
        track.addCue(cue);
        throw e;
      }
    }
  }

  function getTrackByIdx(idx) {
    return idx >= 0 && textTrackQueue[idx] ? videoModel.getTextTrack(textTrackQueue[idx].kind, textTrackQueue[idx].id, textTrackQueue[idx].lang, textTrackQueue[idx].isTTML, textTrackQueue[idx].isEmbedded) : null;
  }

  function getCurrentTrackIdx() {
    return currentTrackIdx;
  }

  function getTrackIdxForId(trackId) {
    var idx = -1;

    for (var i = 0; i < textTrackQueue.length; i++) {
      if (textTrackQueue[i].id === trackId) {
        idx = i;
        break;
      }
    }

    return idx;
  }

  function setCurrentTrackIdx(idx) {
    var _this = this;

    if (idx === currentTrackIdx) {
      return;
    }

    currentTrackIdx = idx;
    var track = getTrackByIdx(currentTrackIdx);
    setCueStyleOnTrack.call(this, track);

    if (videoSizeCheckInterval) {
      clearInterval(videoSizeCheckInterval);
      videoSizeCheckInterval = null;
    }

    if (track && track.renderingType === 'html') {
      checkVideoSize.call(this, track, true);

      if (window.ResizeObserver) {
        resizeObserver = new window.ResizeObserver(function () {
          checkVideoSize.call(_this, track, true);
        });
        resizeObserver.observe(videoModel.getElement());
      } else {
        videoSizeCheckInterval = setInterval(checkVideoSize.bind(this, track), 500);
      }
    }
  }

  function setCueStyleOnTrack(track) {
    clearCaptionContainer.call(this);

    if (track) {
      if (track.renderingType === 'html') {
        setNativeCueStyle.call(this);
      } else {
        removeNativeCueStyle.call(this);
      }
    } else {
      removeNativeCueStyle.call(this);
    }
  }

  function cueInTrack(track, cue) {
    if (!track.cues) return false;

    for (var i = 0; i < track.cues.length; i++) {
      if (track.cues[i].startTime === cue.startTime && track.cues[i].endTime === cue.endTime) {
        return true;
      }
    }

    return false;
  }

  function cueInRange(cue, start, end) {
    var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return (isNaN(start) || (strict ? cue.startTime : cue.endTime) >= start) && (isNaN(end) || (strict ? cue.endTime : cue.startTime) <= end);
  }

  function deleteTrackCues(track, start, end) {
    var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (track.cues) {
      var cues = track.cues;
      var lastIdx = cues.length - 1;

      for (var r = lastIdx; r >= 0; r--) {
        if (cueInRange(cues[r], start, end, strict)) {
          if (cues[r].onexit) {
            cues[r].onexit();
          }

          track.removeCue(cues[r]);
        }
      }
    }
  }

  function deleteCuesFromTrackIdx(trackIdx, start, end) {
    var track = getTrackByIdx(trackIdx);

    if (track) {
      deleteTrackCues(track, start, end);
    }
  }

  function deleteAllTextTracks() {
    var ln = nativeTrackElementArr ? nativeTrackElementArr.length : 0;

    for (var i = 0; i < ln; i++) {
      var track = getTrackByIdx(i);

      if (track) {
        deleteTrackCues.call(this, track, streamInfo.start, streamInfo.start + streamInfo.duration, false);
      }
    }

    nativeTrackElementArr = [];
    textTrackQueue = [];

    if (videoSizeCheckInterval) {
      clearInterval(videoSizeCheckInterval);
      videoSizeCheckInterval = null;
    }

    if (resizeObserver && videoModel) {
      resizeObserver.unobserve(videoModel.getElement());
      resizeObserver = null;
    }

    currentTrackIdx = -1;
    clearCaptionContainer.call(this);
  }

  function deleteTextTrack(idx) {
    videoModel.removeChild(nativeTrackElementArr[idx]);
    nativeTrackElementArr.splice(idx, 1);
  }
  /* Set native cue style to transparent background to avoid it being displayed. */


  function setNativeCueStyle() {
    var styleElement = document.getElementById('native-cue-style');

    if (styleElement) {
      return; //Already set
    }

    styleElement = document.createElement('style');
    styleElement.id = 'native-cue-style';
    document.head.appendChild(styleElement);
    var stylesheet = styleElement.sheet;
    var video = videoModel.getElement();

    try {
      if (video) {
        if (video.id) {
          stylesheet.insertRule('#' + video.id + '::cue {background: transparent}', 0);
        } else if (video.classList.length !== 0) {
          stylesheet.insertRule('.' + video.className + '::cue {background: transparent}', 0);
        } else {
          stylesheet.insertRule('video::cue {background: transparent}', 0);
        }
      }
    } catch (e) {
      logger.info('' + e.message);
    }
  }
  /* Remove the extra cue style with transparent background for native cues. */


  function removeNativeCueStyle() {
    var styleElement = document.getElementById('native-cue-style');

    if (styleElement) {
      document.head.removeChild(styleElement);
    }
  }

  function clearCaptionContainer() {
    if (captionContainer) {
      while (captionContainer.firstChild) {
        captionContainer.removeChild(captionContainer.firstChild);
      }
    }
  }

  function setModeForTrackIdx(idx, mode) {
    var track = getTrackByIdx(idx);

    if (track && track.mode !== mode) {
      track.mode = mode;
    }
  }

  function getCurrentTrackInfo() {
    return textTrackQueue[currentTrackIdx];
  }

  instance = {
    initialize: initialize,
    getStreamId: getStreamId,
    addTextTrack: addTextTrack,
    addCaptions: addCaptions,
    createTracks: createTracks,
    getCurrentTrackIdx: getCurrentTrackIdx,
    setCurrentTrackIdx: setCurrentTrackIdx,
    getTrackIdxForId: getTrackIdxForId,
    getCurrentTrackInfo: getCurrentTrackInfo,
    setModeForTrackIdx: setModeForTrackIdx,
    deleteCuesFromTrackIdx: deleteCuesFromTrackIdx,
    deleteAllTextTracks: deleteAllTextTracks,
    deleteTextTrack: deleteTextTrack
  };
  setup();
  return instance;
}

TextTracks.__dashjs_factory_name = 'TextTracks';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_4__["default"].getClassFactory(TextTracks));

/***/ }),

/***/ "./src/streaming/thumbnail/ThumbnailController.js":
/*!********************************************************!*\
  !*** ./src/streaming/thumbnail/ThumbnailController.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2491541__) {

"use strict";
__nested_webpack_require_2491541__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2491541__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2491541__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _vo_Thumbnail__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2491541__(/*! ../vo/Thumbnail */ "./src/streaming/vo/Thumbnail.js");
/* harmony import */ var _ThumbnailTracks__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2491541__(/*! ./ThumbnailTracks */ "./src/streaming/thumbnail/ThumbnailTracks.js");
/* harmony import */ var _vo_BitrateInfo__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2491541__(/*! ../vo/BitrateInfo */ "./src/streaming/vo/BitrateInfo.js");
/* harmony import */ var _dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2491541__(/*! ../../dash/utils/SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */







function ThumbnailController(config) {
  var context = this.context;
  var streamInfo = config.streamInfo;
  var instance, thumbnailTracks;

  function setup() {
    reset();
    thumbnailTracks = Object(_ThumbnailTracks__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
      streamInfo: streamInfo,
      adapter: config.adapter,
      baseURLController: config.baseURLController,
      timelineConverter: config.timelineConverter,
      debug: config.debug,
      eventBus: config.eventBus,
      events: config.events,
      dashConstants: config.dashConstants,
      dashMetrics: config.dashMetrics,
      segmentBaseController: config.segmentBaseController
    });
  }

  function initialize() {
    thumbnailTracks.addTracks();
    var tracks = thumbnailTracks.getTracks();

    if (tracks && tracks.length > 0) {
      setTrackByIndex(0);
    }
  }

  function getStreamId() {
    return streamInfo.id;
  }

  function provide(time, callback) {
    if (typeof callback !== 'function') {
      return;
    }

    var track = thumbnailTracks.getCurrentTrack();
    var offset, request;

    if (!track || track.segmentDuration <= 0 || time === undefined || time === null) {
      callback(null);
      return;
    }

    request = thumbnailTracks.getThumbnailRequestForTime(time);

    if (request) {
      track.segmentDuration = request.duration;
    }

    offset = time % track.segmentDuration;
    var thumbIndex = Math.floor(offset * track.tilesHor * track.tilesVert / track.segmentDuration); // Create and return the thumbnail

    var thumbnail = new _vo_Thumbnail__WEBPACK_IMPORTED_MODULE_2__["default"]();
    thumbnail.width = Math.floor(track.widthPerTile);
    thumbnail.height = Math.floor(track.heightPerTile);
    thumbnail.x = Math.floor(thumbIndex % track.tilesHor) * track.widthPerTile;
    thumbnail.y = Math.floor(thumbIndex / track.tilesHor) * track.heightPerTile;

    if ('readThumbnail' in track) {
      return track.readThumbnail(time, function (url) {
        thumbnail.url = url;
        callback(thumbnail);
      });
    } else {
      if (!request) {
        var seq = Math.floor(time / track.segmentDuration);
        thumbnail.url = _buildUrlFromTemplate(track, seq);
      } else {
        thumbnail.url = request.url;
        track.segmentDuration = NaN;
      }

      callback(thumbnail);
    }
  }

  function _buildUrlFromTemplate(track, seq) {
    var seqIdx = seq + track.startNumber;
    var url = Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["replaceTokenForTemplate"])(track.templateUrl, 'Number', seqIdx);
    url = Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["replaceTokenForTemplate"])(url, 'Time', (seqIdx - 1) * track.segmentDuration * track.timescale);
    url = Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["replaceTokenForTemplate"])(url, 'Bandwidth', track.bandwidth);
    return Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["unescapeDollarsInTemplate"])(url);
  }

  function setTrackByIndex(index) {
    thumbnailTracks.setTrackByIndex(index);
  }

  function getCurrentTrackIndex() {
    return thumbnailTracks.getCurrentTrackIndex();
  }

  function getBitrateList() {
    var tracks = thumbnailTracks.getTracks();
    var i = 0;
    return tracks.map(function (t) {
      var bitrateInfo = new _vo_BitrateInfo__WEBPACK_IMPORTED_MODULE_4__["default"]();
      bitrateInfo.mediaType = _constants_Constants__WEBPACK_IMPORTED_MODULE_1__["default"].IMAGE;
      bitrateInfo.qualityIndex = i++;
      bitrateInfo.bitrate = t.bitrate;
      bitrateInfo.width = t.width;
      bitrateInfo.height = t.height;
      return bitrateInfo;
    });
  }

  function reset() {
    if (thumbnailTracks) {
      thumbnailTracks.reset();
    }
  }

  instance = {
    getStreamId: getStreamId,
    initialize: initialize,
    provide: provide,
    setTrackByIndex: setTrackByIndex,
    getCurrentTrackIndex: getCurrentTrackIndex,
    getBitrateList: getBitrateList,
    reset: reset
  };
  setup();
  return instance;
}

ThumbnailController.__dashjs_factory_name = 'ThumbnailController';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(ThumbnailController));

/***/ }),

/***/ "./src/streaming/thumbnail/ThumbnailTracks.js":
/*!****************************************************!*\
  !*** ./src/streaming/thumbnail/ThumbnailTracks.js ***!
  \****************************************************/
/*! exports provided: THUMBNAILS_SCHEME_ID_URIS, default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2499242__) {

"use strict";
__nested_webpack_require_2499242__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2499242__.d(__webpack_exports__, "THUMBNAILS_SCHEME_ID_URIS", function() { return THUMBNAILS_SCHEME_ID_URIS; });
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2499242__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2499242__(/*! ../../dash/constants/DashConstants */ "./src/dash/constants/DashConstants.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2499242__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_ThumbnailTrackInfo__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2499242__(/*! ../vo/ThumbnailTrackInfo */ "./src/streaming/vo/ThumbnailTrackInfo.js");
/* harmony import */ var _streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2499242__(/*! ../../streaming/utils/URLUtils */ "./src/streaming/utils/URLUtils.js");
/* harmony import */ var _dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2499242__(/*! ../../dash/utils/SegmentsUtils */ "./src/dash/utils/SegmentsUtils.js");
/* harmony import */ var _streaming_utils_BoxParser__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2499242__(/*! ../../streaming/utils/BoxParser */ "./src/streaming/utils/BoxParser.js");
/* harmony import */ var _streaming_net_XHRLoader__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2499242__(/*! ../../streaming/net/XHRLoader */ "./src/streaming/net/XHRLoader.js");
/* harmony import */ var _dash_DashHandler__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2499242__(/*! ../../dash/DashHandler */ "./src/dash/DashHandler.js");
/* harmony import */ var _dash_controllers_SegmentsController__WEBPACK_IMPORTED_MODULE_9__ = __nested_webpack_require_2499242__(/*! ../../dash/controllers/SegmentsController */ "./src/dash/controllers/SegmentsController.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */










var THUMBNAILS_SCHEME_ID_URIS = ['http://dashif.org/thumbnail_tile', 'http://dashif.org/guidelines/thumbnail_tile'];

function ThumbnailTracks(config) {
  var context = this.context;
  var adapter = config.adapter;
  var baseURLController = config.baseURLController;
  var streamInfo = config.streamInfo;
  var timelineConverter = config.timelineConverter;
  var debug = config.debug;
  var eventBus = config.eventBus;
  var events = config.events;
  var dashConstants = config.dashConstants;
  var urlUtils = Object(_streaming_utils_URLUtils__WEBPACK_IMPORTED_MODULE_4__["default"])(context).getInstance();
  var instance, tracks, dashHandler, currentTrackIndex, mediaInfo, segmentsController, loader, boxParser;

  function setup() {
    reset();
    loader = Object(_streaming_net_XHRLoader__WEBPACK_IMPORTED_MODULE_7__["default"])(context).create({});
    boxParser = Object(_streaming_utils_BoxParser__WEBPACK_IMPORTED_MODULE_6__["default"])(context).getInstance();
    segmentsController = Object(_dash_controllers_SegmentsController__WEBPACK_IMPORTED_MODULE_9__["default"])(context).create({
      events: events,
      eventBus: eventBus,
      streamInfo: streamInfo,
      timelineConverter: timelineConverter,
      dashConstants: dashConstants,
      dashMetrics: config.dashMetrics,
      segmentBaseController: config.segmentBaseController,
      type: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE
    });
    dashHandler = Object(_dash_DashHandler__WEBPACK_IMPORTED_MODULE_8__["default"])(context).create({
      streamInfo: streamInfo,
      type: _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE,
      timelineConverter: timelineConverter,
      segmentsController: segmentsController,
      baseURLController: baseURLController,
      debug: debug,
      eventBus: eventBus,
      events: events,
      dashConstants: dashConstants,
      urlUtils: urlUtils
    }); // initialize controllers

    dashHandler.initialize(adapter ? adapter.getIsDynamic() : false);
  }

  function addTracks() {
    if (!streamInfo || !adapter) {
      return;
    } // Extract thumbnail tracks


    mediaInfo = adapter.getMediaInfoForType(streamInfo, _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE);

    if (!mediaInfo) {
      return;
    }

    var voReps = adapter.getVoRepresentations(mediaInfo);

    if (voReps && voReps.length > 0) {
      voReps.forEach(function (rep) {
        if (rep.segmentInfoType === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TEMPLATE && rep.segmentDuration > 0 && rep.media || rep.segmentInfoType === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_TIMELINE) {
          _createTrack(rep);
        }

        if (rep.segmentInfoType === _dash_constants_DashConstants__WEBPACK_IMPORTED_MODULE_1__["default"].SEGMENT_BASE) {
          _createTrack(rep, true);
        }
      });
    }

    if (tracks.length > 0) {
      // Sort bitrates and select the lowest bitrate rendition
      tracks.sort(function (a, b) {
        return a.bitrate - b.bitrate;
      });
    }
  }

  function _createTrack(representation, useSegmentBase) {
    var track = new _vo_ThumbnailTrackInfo__WEBPACK_IMPORTED_MODULE_3__["default"]();
    track.id = representation.id;
    track.bitrate = representation.bandwidth;
    track.width = representation.width;
    track.height = representation.height;
    track.tilesHor = 1;
    track.tilesVert = 1;

    if (representation.essentialProperties) {
      representation.essentialProperties.forEach(function (p) {
        if (THUMBNAILS_SCHEME_ID_URIS.indexOf(p.schemeIdUri) >= 0 && p.value) {
          var vars = p.value.split('x');

          if (vars.length === 2 && !isNaN(vars[0]) && !isNaN(vars[1])) {
            track.tilesHor = parseInt(vars[0], 10);
            track.tilesVert = parseInt(vars[1], 10);
          }
        }
      });
    }

    if (useSegmentBase) {
      segmentsController.updateSegmentData(representation).then(function (data) {
        _handleUpdatedSegmentData(track, representation, data);
      });
    } else {
      track.startNumber = representation.startNumber;
      track.segmentDuration = representation.segmentDuration;
      track.timescale = representation.timescale;
      track.templateUrl = buildTemplateUrl(representation);
    }

    if (track.tilesHor > 0 && track.tilesVert > 0) {
      // Precalculate width and heigth per tile for perf reasons
      track.widthPerTile = track.width / track.tilesHor;
      track.heightPerTile = track.height / track.tilesVert;
      tracks.push(track);
    }
  }

  function _handleUpdatedSegmentData(track, representation, data) {
    var cache = [];

    var segments = _normalizeSegments(data, representation);

    representation.segments = segments;
    track.segmentDuration = representation.segments[0].duration; //assume all segments have the same duration

    track.readThumbnail = function (time, callback) {
      var cached = null;
      cache.some(function (el) {
        if (el.start <= time && el.end > time) {
          cached = el.url;
          return true;
        }
      });

      if (cached) {
        callback(cached);
      } else {
        representation.segments.some(function (ss) {
          if (ss.mediaStartTime <= time && ss.mediaStartTime + ss.duration > time) {
            var baseURL = baseURLController.resolve(representation.path);
            loader.load({
              method: 'get',
              url: baseURL.url,
              request: {
                range: ss.mediaRange,
                responseType: 'arraybuffer'
              },
              onload: function onload(e) {
                var info = boxParser.getSamplesInfo(e.target.response);
                var blob = new Blob([e.target.response.slice(info.sampleList[0].offset, info.sampleList[0].offset + info.sampleList[0].size)], {
                  type: 'image/jpeg'
                });
                var imageUrl = window.URL.createObjectURL(blob);
                cache.push({
                  start: ss.mediaStartTime,
                  end: ss.mediaStartTime + ss.duration,
                  url: imageUrl
                });
                if (callback) callback(imageUrl);
              }
            });
            return true;
          }
        });
      }
    };
  }

  function _normalizeSegments(data, representation) {
    var segments = [];
    var count = 0;
    var i, len, s, seg;

    for (i = 0, len = data.segments.length; i < len; i++) {
      s = data.segments[i];
      seg = Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["getTimeBasedSegment"])(timelineConverter, adapter.getIsDynamic(), representation, s.startTime, s.duration, s.timescale, s.media, s.mediaRange, count);

      if (seg) {
        segments.push(seg);
        seg = null;
        count++;
      }
    }

    return segments;
  }

  function buildTemplateUrl(representation) {
    var templateUrl = urlUtils.isRelative(representation.media) ? urlUtils.resolve(representation.media, baseURLController.resolve(representation.path).url) : representation.media;

    if (!templateUrl) {
      return '';
    }

    return Object(_dash_utils_SegmentsUtils__WEBPACK_IMPORTED_MODULE_5__["replaceIDForTemplate"])(templateUrl, representation.id);
  }

  function getTracks() {
    return tracks;
  }

  function getCurrentTrackIndex() {
    return currentTrackIndex;
  }

  function getCurrentTrack() {
    if (currentTrackIndex < 0) {
      return null;
    }

    return tracks[currentTrackIndex];
  }

  function setTrackByIndex(index) {
    if (!tracks || tracks.length === 0) {
      return;
    } // select highest bitrate in case selected index is higher than bitrate list length


    if (index >= tracks.length) {
      index = tracks.length - 1;
    }

    currentTrackIndex = index;
  }

  function getThumbnailRequestForTime(time) {
    var currentVoRep;
    var voReps = adapter.getVoRepresentations(mediaInfo);

    for (var i = 0; i < voReps.length; i++) {
      if (tracks[currentTrackIndex].id === voReps[i].id) {
        currentVoRep = voReps[i];
        break;
      }
    }

    return dashHandler.getSegmentRequestForTime(mediaInfo, currentVoRep, time);
  }

  function reset() {
    tracks = [];
    currentTrackIndex = -1;
    mediaInfo = null;
  }

  instance = {
    getTracks: getTracks,
    addTracks: addTracks,
    reset: reset,
    setTrackByIndex: setTrackByIndex,
    getCurrentTrack: getCurrentTrack,
    getCurrentTrackIndex: getCurrentTrackIndex,
    getThumbnailRequestForTime: getThumbnailRequestForTime
  };
  setup();
  return instance;
}

ThumbnailTracks.__dashjs_factory_name = 'ThumbnailTracks';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getClassFactory(ThumbnailTracks));

/***/ }),

/***/ "./src/streaming/utils/BaseURLSelector.js":
/*!************************************************!*\
  !*** ./src/streaming/utils/BaseURLSelector.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2512604__) {

"use strict";
__nested_webpack_require_2512604__.r(__webpack_exports__);
/* harmony import */ var _core_errors_Errors__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2512604__(/*! ../../core/errors/Errors */ "./src/core/errors/Errors.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2512604__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2512604__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _controllers_BlacklistController__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2512604__(/*! ../controllers/BlacklistController */ "./src/streaming/controllers/BlacklistController.js");
/* harmony import */ var _baseUrlResolution_DVBSelector__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2512604__(/*! ./baseUrlResolution/DVBSelector */ "./src/streaming/utils/baseUrlResolution/DVBSelector.js");
/* harmony import */ var _baseUrlResolution_BasicSelector__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2512604__(/*! ./baseUrlResolution/BasicSelector */ "./src/streaming/utils/baseUrlResolution/BasicSelector.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2512604__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _vo_DashJSError__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_2512604__(/*! ../vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_8__ = __nested_webpack_require_2512604__(/*! ../utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */










function BaseURLSelector() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  var instance, serviceLocationBlacklistController, basicSelector, dvbSelector, selector;

  function setup() {
    serviceLocationBlacklistController = Object(_controllers_BlacklistController__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
      updateEventName: _core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].SERVICE_LOCATION_BLACKLIST_CHANGED,
      addBlacklistEventName: _core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].SERVICE_LOCATION_BLACKLIST_ADD
    });
    basicSelector = Object(_baseUrlResolution_BasicSelector__WEBPACK_IMPORTED_MODULE_5__["default"])(context).create({
      blacklistController: serviceLocationBlacklistController
    });
    dvbSelector = Object(_baseUrlResolution_DVBSelector__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create({
      blacklistController: serviceLocationBlacklistController
    });
    selector = basicSelector;
  }

  function setConfig(config) {
    if (config.selector) {
      selector = config.selector;
    }
  }

  function chooseSelector(isDVB) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_8__["checkParameterType"])(isDVB, 'boolean');
    selector = isDVB ? dvbSelector : basicSelector;
  }

  function select(data) {
    if (!data) {
      return;
    }

    var baseUrls = data.baseUrls;
    var selectedIdx = data.selectedIdx; // Once a random selection has been carried out amongst a group of BaseURLs with the same
    // @priority attribute value, then that choice should be re-used if the selection needs to be made again
    // unless the blacklist has been modified or the available BaseURLs have changed.

    if (!isNaN(selectedIdx)) {
      return baseUrls[selectedIdx];
    }

    var selectedBaseUrl = selector.select(baseUrls);

    if (!selectedBaseUrl) {
      eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_2__["default"].URL_RESOLUTION_FAILED, {
        error: new _vo_DashJSError__WEBPACK_IMPORTED_MODULE_7__["default"](_core_errors_Errors__WEBPACK_IMPORTED_MODULE_0__["default"].URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, _core_errors_Errors__WEBPACK_IMPORTED_MODULE_0__["default"].URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)
      });

      if (selector === basicSelector) {
        reset();
      }

      return;
    }

    data.selectedIdx = baseUrls.indexOf(selectedBaseUrl);
    return selectedBaseUrl;
  }

  function reset() {
    serviceLocationBlacklistController.reset();
  }

  instance = {
    chooseSelector: chooseSelector,
    select: select,
    reset: reset,
    setConfig: setConfig
  };
  setup();
  return instance;
}

BaseURLSelector.__dashjs_factory_name = 'BaseURLSelector';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_6__["default"].getClassFactory(BaseURLSelector));

/***/ }),

/***/ "./src/streaming/utils/BoxParser.js":
/*!******************************************!*\
  !*** ./src/streaming/utils/BoxParser.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2519493__) {

"use strict";
__nested_webpack_require_2519493__.r(__webpack_exports__);
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2519493__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _IsoFile__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2519493__(/*! ./IsoFile */ "./src/streaming/utils/IsoFile.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2519493__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2519493__(/*! codem-isoboxer */ "./node_modules/codem-isoboxer/dist/iso_boxer.js");
/* harmony import */ var codem_isoboxer__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__nested_webpack_require_2519493__.n(codem_isoboxer__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2519493__(/*! ../vo/IsoBoxSearchInfo */ "./src/streaming/vo/IsoBoxSearchInfo.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */






function BoxParser()
/*config*/
{
  var logger, instance;
  var context = this.context;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance().getLogger(instance);
  }
  /**
   * @param {ArrayBuffer} data
   * @returns {IsoFile|null}
   * @memberof BoxParser#
   */


  function parse(data) {
    if (!data) return null;

    if (data.fileStart === undefined) {
      data.fileStart = 0;
    }

    var parsedFile = codem_isoboxer__WEBPACK_IMPORTED_MODULE_3___default.a.parseBuffer(data);
    var dashIsoFile = Object(_IsoFile__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create();
    dashIsoFile.setData(parsedFile);
    return dashIsoFile;
  }
  /**
   * From the list of type boxes to look for, returns the latest one that is fully completed (header + payload). This
   * method only looks into the list of top boxes and doesn't analyze nested boxes.
   * @param {string[]} types
   * @param {ArrayBuffer|uint8Array} buffer
   * @param {number} offset
   * @returns {IsoBoxSearchInfo}
   * @memberof BoxParser#
   */


  function findLastTopIsoBoxCompleted(types, buffer, offset) {
    if (offset === undefined) {
      offset = 0;
    } // 8 = size (uint32) + type (4 characters)


    if (!buffer || offset + 8 >= buffer.byteLength) {
      return new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](0, false);
    }

    var data = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer;
    var boxInfo;
    var lastCompletedOffset = 0;

    while (offset < data.byteLength) {
      var boxSize = parseUint32(data, offset);
      var boxType = parseIsoBoxType(data, offset + 4);

      if (boxSize === 0) {
        break;
      }

      if (offset + boxSize <= data.byteLength) {
        if (types.indexOf(boxType) >= 0) {
          boxInfo = new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](offset, true, boxSize);
        } else {
          lastCompletedOffset = offset + boxSize;
        }
      }

      offset += boxSize;
    }

    if (!boxInfo) {
      return new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](lastCompletedOffset, false);
    }

    return boxInfo;
  }

  function getSamplesInfo(ab) {
    if (!ab || ab.byteLength === 0) {
      return {
        sampleList: [],
        lastSequenceNumber: NaN,
        totalDuration: NaN,
        numSequences: NaN
      };
    }

    var isoFile = parse(ab); // zero or more moofs

    var moofBoxes = isoFile.getBoxes('moof'); // exactly one mfhd per moof

    var mfhdBoxes = isoFile.getBoxes('mfhd');
    var sampleDuration, sampleCompositionTimeOffset, sampleCount, sampleSize, sampleDts, sampleList, sample, i, j, k, l, m, n, dataOffset, lastSequenceNumber, numSequences, totalDuration;
    numSequences = isoFile.getBoxes('moof').length;
    lastSequenceNumber = mfhdBoxes[mfhdBoxes.length - 1].sequence_number;
    sampleCount = 0;
    sampleList = [];
    var subsIndex = -1;
    var nextSubsSample = -1;

    for (l = 0; l < moofBoxes.length; l++) {
      var moofBox = moofBoxes[l]; // zero or more trafs per moof

      var trafBoxes = moofBox.getChildBoxes('traf');

      for (j = 0; j < trafBoxes.length; j++) {
        var trafBox = trafBoxes[j]; // exactly one tfhd per traf

        var tfhdBox = trafBox.getChildBox('tfhd'); // zero or one tfdt per traf

        var tfdtBox = trafBox.getChildBox('tfdt');
        sampleDts = tfdtBox.baseMediaDecodeTime; // zero or more truns per traf

        var trunBoxes = trafBox.getChildBoxes('trun'); // zero or more subs per traf

        var subsBoxes = trafBox.getChildBoxes('subs');

        for (k = 0; k < trunBoxes.length; k++) {
          var trunBox = trunBoxes[k];
          sampleCount = trunBox.sample_count;
          dataOffset = (tfhdBox.base_data_offset || 0) + (trunBox.data_offset || 0);

          for (i = 0; i < sampleCount; i++) {
            sample = trunBox.samples[i];
            sampleDuration = sample.sample_duration !== undefined ? sample.sample_duration : tfhdBox.default_sample_duration;
            sampleSize = sample.sample_size !== undefined ? sample.sample_size : tfhdBox.default_sample_size;
            sampleCompositionTimeOffset = sample.sample_composition_time_offset !== undefined ? sample.sample_composition_time_offset : 0;
            var sampleData = {
              'dts': sampleDts,
              'cts': sampleDts + sampleCompositionTimeOffset,
              'duration': sampleDuration,
              'offset': moofBox.offset + dataOffset,
              'size': sampleSize,
              'subSizes': [sampleSize]
            };

            if (subsBoxes) {
              for (m = 0; m < subsBoxes.length; m++) {
                var subsBox = subsBoxes[m];

                if (subsIndex < subsBox.entry_count - 1 && i > nextSubsSample) {
                  subsIndex++;
                  nextSubsSample += subsBox.entries[subsIndex].sample_delta;
                }

                if (i == nextSubsSample) {
                  sampleData.subSizes = [];
                  var entry = subsBox.entries[subsIndex];

                  for (n = 0; n < entry.subsample_count; n++) {
                    sampleData.subSizes.push(entry.subsamples[n].subsample_size);
                  }
                }
              }
            }

            sampleList.push(sampleData);
            dataOffset += sampleSize;
            sampleDts += sampleDuration;
          }
        }

        totalDuration = sampleDts - tfdtBox.baseMediaDecodeTime;
      }
    }

    return {
      sampleList: sampleList,
      lastSequenceNumber: lastSequenceNumber,
      totalDuration: totalDuration,
      numSequences: numSequences
    };
  }

  function getMediaTimescaleFromMoov(ab) {
    var isoFile = parse(ab);
    var mdhdBox = isoFile ? isoFile.getBox('mdhd') : undefined;
    return mdhdBox ? mdhdBox.timescale : NaN;
  }

  function parseUint32(data, offset) {
    return data[offset + 3] >>> 0 | data[offset + 2] << 8 >>> 0 | data[offset + 1] << 16 >>> 0 | data[offset] << 24 >>> 0;
  }

  function parseIsoBoxType(data, offset) {
    return String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset++]) + String.fromCharCode(data[offset]);
  }

  function findInitRange(data) {
    var initRange = null;
    var start, end;
    var isoFile = parse(data);

    if (!isoFile) {
      return initRange;
    }

    var ftyp = isoFile.getBox('ftyp');
    var moov = isoFile.getBox('moov');
    logger.debug('Searching for initialization.');

    if (moov && moov.isComplete) {
      start = ftyp ? ftyp.offset : moov.offset;
      end = moov.offset + moov.size - 1;
      initRange = start + '-' + end;
      logger.debug('Found the initialization.  Range: ' + initRange);
    }

    return initRange;
  }
  /**
   * Real-time parsing (whenever data is loaded in the buffer payload) of the payload to capture the moof of a chunk
   * @param {array} types
   * @param {ArrayBuffer} buffer
   * @param {number} offset
   * @return {IsoBoxSearchInfo}
   */


  function parsePayload(types, buffer, offset) {
    if (offset === undefined) {
      offset = 0;
    }

    if (!buffer || offset + 8 >= buffer.byteLength) {
      return new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](0, false);
    }

    var data = buffer instanceof ArrayBuffer ? new Uint8Array(buffer) : buffer;
    var boxInfo;
    var lastCompletedOffset = 0;

    while (offset < data.byteLength) {
      var boxSize = parseUint32(data, offset);
      var boxType = parseIsoBoxType(data, offset + 4);

      if (boxSize === 0) {
        break;
      }

      if (offset + boxSize <= data.byteLength) {
        if (types.indexOf(boxType) >= 0) {
          boxInfo = new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](offset, true, boxSize, boxType);
        } else {
          lastCompletedOffset = offset + boxSize;
        }
      }

      offset += boxSize;
    }

    if (!boxInfo) {
      return new _vo_IsoBoxSearchInfo__WEBPACK_IMPORTED_MODULE_4__["default"](lastCompletedOffset, false);
    }

    return boxInfo;
  }

  instance = {
    parse: parse,
    findLastTopIsoBoxCompleted: findLastTopIsoBoxCompleted,
    getMediaTimescaleFromMoov: getMediaTimescaleFromMoov,
    getSamplesInfo: getSamplesInfo,
    findInitRange: findInitRange,
    parsePayload: parsePayload
  };
  setup();
  return instance;
}

BoxParser.__dashjs_factory_name = 'BoxParser';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(BoxParser));

/***/ }),

/***/ "./src/streaming/utils/Capabilities.js":
/*!*********************************************!*\
  !*** ./src/streaming/utils/Capabilities.js ***!
  \*********************************************/
/*! exports provided: supportsMediaSource, default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2531624__) {

"use strict";
__nested_webpack_require_2531624__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2531624__.d(__webpack_exports__, "supportsMediaSource", function() { return supportsMediaSource; });
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2531624__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _thumbnail_ThumbnailTracks__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2531624__(/*! ../thumbnail/ThumbnailTracks */ "./src/streaming/thumbnail/ThumbnailTracks.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2531624__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



var codecCompatibilityTable = [{
  'codec': 'avc1',
  'compatibleCodecs': ['avc3']
}, {
  'codec': 'avc3',
  'compatibleCodecs': ['avc1']
}];
function supportsMediaSource() {
  var hasWebKit = ('WebKitMediaSource' in window);
  var hasMediaSource = ('MediaSource' in window);
  return hasWebKit || hasMediaSource;
}

function Capabilities() {
  var instance, settings, encryptedMediaSupported;

  function setup() {
    encryptedMediaSupported = false;
  }

  function setConfig(config) {
    if (!config) {
      return;
    }

    if (config.settings) {
      settings = config.settings;
    }
  }
  /**
   * Returns whether Encrypted Media Extensions are supported on this
   * user agent
   *
   * @return {boolean} true if EME is supported, false otherwise
   */


  function supportsEncryptedMedia() {
    return encryptedMediaSupported;
  }
  /**
   *
   * @param {boolean} value
   */


  function setEncryptedMediaSupported(value) {
    encryptedMediaSupported = value;
  }
  /**
   * Check if a codec is supported by the MediaSource. We use the MediaCapabilities API or the MSE to check.
   * @param {object} config
   * @param {string} type
   * @return {Promise<boolean>}
   */


  function supportsCodec(config, type) {
    if (type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].AUDIO && type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].VIDEO) {
      return Promise.resolve(true);
    }

    if (_canUseMediaCapabilitiesApi(config, type)) {
      return _checkCodecWithMediaCapabilities(config, type);
    }

    return _checkCodecWithMse(config);
  }
  /**
   * MediaCapabilitiesAPI throws an error if one of the attribute is missing. We only use it if we have all required information.
   * @param {object} config
   * @param {string} type
   * @return {*|boolean|boolean}
   * @private
   */


  function _canUseMediaCapabilitiesApi(config, type) {
    return settings.get().streaming.capabilities.useMediaCapabilitiesApi && navigator.mediaCapabilities && navigator.mediaCapabilities.decodingInfo && (config.codec && type === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].AUDIO || type === _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].VIDEO && config.codec && config.width && config.height && config.bitrate && config.framerate);
  }
  /**
   * Check codec support using the MSE
   * @param {object} config
   * @return {Promise<void> | Promise<boolean>}
   * @private
   */


  function _checkCodecWithMse(config) {
    return new Promise(function (resolve) {
      if (!config || !config.codec) {
        resolve(false);
        return;
      }

      var codec = config.codec;

      if (config.width && config.height) {
        codec += ';width="' + config.width + '";height="' + config.height + '"';
      }

      if ('MediaSource' in window && MediaSource.isTypeSupported(codec)) {
        resolve(true);
        return;
      } else if ('WebKitMediaSource' in window && WebKitMediaSource.isTypeSupported(codec)) {
        resolve(true);
        return;
      }

      resolve(false);
    });
  }
  /**
   * Check codec support using the MediaCapabilities API
   * @param {object} config
   * @param {string} type
   * @return {Promise<boolean>}
   * @private
   */


  function _checkCodecWithMediaCapabilities(config, type) {
    return new Promise(function (resolve) {
      if (!config || !config.codec) {
        resolve(false);
        return;
      }

      var configuration = {
        type: 'media-source'
      };
      configuration[type] = {};
      configuration[type].contentType = config.codec;
      configuration[type].width = config.width;
      configuration[type].height = config.height;
      configuration[type].bitrate = parseInt(config.bitrate);
      configuration[type].framerate = parseFloat(config.framerate);
      navigator.mediaCapabilities.decodingInfo(configuration).then(function (result) {
        resolve(result.supported);
      })["catch"](function () {
        resolve(false);
      });
    });
  }
  /**
   * Check if a specific EssentialProperty is supported
   * @param {object} ep
   * @return {boolean}
   */


  function supportsEssentialProperty(ep) {
    try {
      return _thumbnail_ThumbnailTracks__WEBPACK_IMPORTED_MODULE_1__["THUMBNAILS_SCHEME_ID_URIS"].indexOf(ep.schemeIdUri) !== -1;
    } catch (e) {
      return true;
    }
  }
  /**
   * Check if the root of the old codec is the same as the new one, or if it's declared as compatible in the compat table
   * @param {string} codec1
   * @param {string} codec2
   * @return {boolean}
   */


  function codecRootCompatibleWithCodec(codec1, codec2) {
    var codecRoot = codec1.split('.')[0];
    var rootCompatible = codec2.indexOf(codecRoot) === 0;
    var compatTableCodec;

    for (var i = 0; i < codecCompatibilityTable.length; i++) {
      if (codecCompatibilityTable[i].codec === codecRoot) {
        compatTableCodec = codecCompatibilityTable[i];
        break;
      }
    }

    if (compatTableCodec) {
      return rootCompatible || compatTableCodec.compatibleCodecs.some(function (compatibleCodec) {
        return codec2.indexOf(compatibleCodec) === 0;
      });
    }

    return rootCompatible;
  }

  instance = {
    setConfig: setConfig,
    supportsMediaSource: supportsMediaSource,
    supportsEncryptedMedia: supportsEncryptedMedia,
    supportsCodec: supportsCodec,
    setEncryptedMediaSupported: setEncryptedMediaSupported,
    supportsEssentialProperty: supportsEssentialProperty,
    codecRootCompatibleWithCodec: codecRootCompatibleWithCodec
  };
  setup();
  return instance;
}

Capabilities.__dashjs_factory_name = 'Capabilities';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(Capabilities));

/***/ }),

/***/ "./src/streaming/utils/CapabilitiesFilter.js":
/*!***************************************************!*\
  !*** ./src/streaming/utils/CapabilitiesFilter.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2540586__) {

"use strict";
__nested_webpack_require_2540586__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2540586__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2540586__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2540586__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2540586__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2540586__(/*! ../../core/events/Events */ "./src/core/events/Events.js");






function CapabilitiesFilter() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_3__["default"])(context).getInstance();
  var instance, adapter, capabilities, settings, customParametersModel, logger;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
  }

  function setConfig(config) {
    if (!config) {
      return;
    }

    if (config.adapter) {
      adapter = config.adapter;
    }

    if (config.capabilities) {
      capabilities = config.capabilities;
    }

    if (config.settings) {
      settings = config.settings;
    }

    if (config.customParametersModel) {
      customParametersModel = config.customParametersModel;
    }
  }

  function filterUnsupportedFeatures(manifest) {
    return new Promise(function (resolve) {
      var promises = [];
      promises.push(_filterUnsupportedCodecs(_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].VIDEO, manifest));
      promises.push(_filterUnsupportedCodecs(_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].AUDIO, manifest));
      Promise.all(promises).then(function () {
        if (settings.get().streaming.capabilities.filterUnsupportedEssentialProperties) {
          _filterUnsupportedEssentialProperties(manifest);
        }

        _applyCustomFilters(manifest);

        resolve();
      })["catch"](function () {
        resolve();
      });
    });
  }

  function _filterUnsupportedCodecs(type, manifest) {
    if (!manifest || !manifest.Period_asArray || manifest.Period_asArray.length === 0) {
      return Promise.resolve();
    }

    var promises = [];
    manifest.Period_asArray.forEach(function (period) {
      promises.push(_filterUnsupportedAdaptationSetsOfPeriod(period, type));
    });
    return Promise.all(promises);
  }

  function _filterUnsupportedAdaptationSetsOfPeriod(period, type) {
    return new Promise(function (resolve) {
      if (!period || !period.AdaptationSet_asArray || period.AdaptationSet_asArray.length === 0) {
        resolve();
        return;
      }

      var promises = [];
      period.AdaptationSet_asArray.forEach(function (as) {
        if (adapter.getIsTypeOf(as, type)) {
          promises.push(_filterUnsupportedRepresentationsOfAdaptation(as, type));
        }
      });
      Promise.all(promises).then(function () {
        period.AdaptationSet_asArray = period.AdaptationSet_asArray.filter(function (as) {
          var supported = as.Representation_asArray && as.Representation_asArray.length > 0;

          if (!supported) {
            eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_4__["default"].ADAPTATION_SET_REMOVED_NO_CAPABILITIES, {
              adaptationSet: as
            });
            logger.warn("AdaptationSet has been removed because of no supported Representation");
          }

          return supported;
        });
        resolve();
      })["catch"](function () {
        resolve();
      });
    });
  }

  function _filterUnsupportedRepresentationsOfAdaptation(as, type) {
    return new Promise(function (resolve) {
      if (!as.Representation_asArray || as.Representation_asArray.length === 0) {
        resolve();
        return;
      }

      var promises = [];
      var configurations = [];
      as.Representation_asArray.forEach(function (rep, i) {
        var codec = adapter.getCodec(as, i, false);

        var config = _createConfiguration(type, rep, codec);

        configurations.push(config);
        promises.push(capabilities.supportsCodec(config, type));
      });
      Promise.all(promises).then(function (supported) {
        as.Representation_asArray = as.Representation_asArray.filter(function (_, i) {
          if (!supported[i]) {
            logger.debug("[Stream] Codec ".concat(configurations[i].codec, " not supported "));
          }

          return supported[i];
        });
        resolve();
      })["catch"](function () {
        resolve();
      });
    });
  }

  function _createConfiguration(type, rep, codec) {
    switch (type) {
      case _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].VIDEO:
        return _createVideoConfiguration(rep, codec);

      case _constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].AUDIO:
        return _createAudioConfiguration(rep, codec);

      default:
        return null;
    }
  }

  function _createVideoConfiguration(rep, codec) {
    var width = rep.width || null;
    var height = rep.height || null;
    var framerate = rep.frameRate || null;
    var bitrate = rep.bandwidth || null;
    return {
      codec: codec,
      width: width,
      height: height,
      framerate: framerate,
      bitrate: bitrate
    };
  }

  function _createAudioConfiguration(rep, codec) {
    var samplerate = rep.audioSamplingRate || null;
    var bitrate = rep.bandwidth || null;
    return {
      codec: codec,
      bitrate: bitrate,
      samplerate: samplerate
    };
  }

  function _filterUnsupportedEssentialProperties(manifest) {
    if (!manifest || !manifest.Period_asArray || manifest.Period_asArray.length === 0) {
      return;
    }

    manifest.Period_asArray.forEach(function (period) {
      period.AdaptationSet_asArray = period.AdaptationSet_asArray.filter(function (as) {
        if (!as.Representation_asArray || as.Representation_asArray.length === 0) {
          return true;
        }

        as.Representation_asArray = as.Representation_asArray.filter(function (rep) {
          var essentialProperties = adapter.getEssentialPropertiesForRepresentation(rep);

          if (essentialProperties && essentialProperties.length > 0) {
            var i = 0;

            while (i < essentialProperties.length) {
              if (!capabilities.supportsEssentialProperty(essentialProperties[i])) {
                logger.debug('[Stream] EssentialProperty not supported: ' + essentialProperties[i].schemeIdUri);
                return false;
              }

              i += 1;
            }
          }

          return true;
        });
        return as.Representation_asArray && as.Representation_asArray.length > 0;
      });
    });
  }

  function _applyCustomFilters(manifest) {
    var customCapabilitiesFilters = customParametersModel.getCustomCapabilitiesFilters();

    if (!customCapabilitiesFilters || customCapabilitiesFilters.length === 0 || !manifest || !manifest.Period_asArray || manifest.Period_asArray.length === 0) {
      return;
    }

    manifest.Period_asArray.forEach(function (period) {
      period.AdaptationSet_asArray = period.AdaptationSet_asArray.filter(function (as) {
        if (!as.Representation_asArray || as.Representation_asArray.length === 0) {
          return true;
        }

        as.Representation_asArray = as.Representation_asArray.filter(function (representation) {
          return !customCapabilitiesFilters.some(function (customFilter) {
            return !customFilter(representation);
          });
        });
        return as.Representation_asArray && as.Representation_asArray.length > 0;
      });
    });
  }

  instance = {
    setConfig: setConfig,
    filterUnsupportedFeatures: filterUnsupportedFeatures
  };
  setup();
  return instance;
}

CapabilitiesFilter.__dashjs_factory_name = 'CapabilitiesFilter';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(CapabilitiesFilter));

/***/ }),

/***/ "./src/streaming/utils/CustomTimeRanges.js":
/*!*************************************************!*\
  !*** ./src/streaming/utils/CustomTimeRanges.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2549513__) {

"use strict";
__nested_webpack_require_2549513__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2549513__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2549513__(/*! ../utils/SupervisorTools */ "./src/streaming/utils/SupervisorTools.js");
/**
* The copyright in this software is being made available under the BSD License,
* included below. This software may be subject to other third party and contributor
* rights, including patent rights, and no such rights are granted under this license.
*
* Copyright (c) 2013, Dash Industry Forum.
* All rights reserved.
*
* Redistribution and use in source and binary forms, with or without modification,
* are permitted provided that the following conditions are met:
*  * Redistributions of source code must retain the above copyright notice, this
*  list of conditions and the following disclaimer.
*  * Redistributions in binary form must reproduce the above copyright notice,
*  this list of conditions and the following disclaimer in the documentation and/or
*  other materials provided with the distribution.
*  * Neither the name of Dash Industry Forum nor the names of its
*  contributors may be used to endorse or promote products derived from this software
*  without specific prior written permission.
*
*  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
*  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
*  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
*  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
*  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
*  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
*  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
*  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
*  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
*  POSSIBILITY OF SUCH DAMAGE.
*/



function CustomTimeRanges()
/*config*/
{
  var customTimeRangeArray = [];
  var length = 0;

  function add(start, end) {
    var i = 0;

    for (i = 0; i < this.customTimeRangeArray.length && start > this.customTimeRangeArray[i].start; i++) {
      ;
    }

    this.customTimeRangeArray.splice(i, 0, {
      start: start,
      end: end
    });

    for (i = 0; i < this.customTimeRangeArray.length - 1; i++) {
      if (this.mergeRanges(i, i + 1)) {
        i--;
      }
    }

    this.length = this.customTimeRangeArray.length;
  }

  function clear() {
    this.customTimeRangeArray = [];
    this.length = 0;
  }

  function remove(start, end) {
    for (var i = 0; i < this.customTimeRangeArray.length; i++) {
      if (start <= this.customTimeRangeArray[i].start && end >= this.customTimeRangeArray[i].end) {
        //      |--------------Range i-------|
        //|---------------Range to remove ---------------|
        //    or
        //|--------------Range i-------|
        //|--------------Range to remove ---------------|
        //    or
        //                 |--------------Range i-------|
        //|--------------Range to remove ---------------|
        this.customTimeRangeArray.splice(i, 1);
        i--;
      } else if (start > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end) {
        //|-----------------Range i----------------|
        //        |-------Range to remove -----|
        this.customTimeRangeArray.splice(i + 1, 0, {
          start: end,
          end: this.customTimeRangeArray[i].end
        });
        this.customTimeRangeArray[i].end = start;
        break;
      } else if (start > this.customTimeRangeArray[i].start && start < this.customTimeRangeArray[i].end) {
        //|-----------Range i----------|
        //                    |---------Range to remove --------|
        //    or
        //|-----------------Range i----------------|
        //            |-------Range to remove -----|
        this.customTimeRangeArray[i].end = start;
      } else if (end > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end) {
        //                     |-----------Range i----------|
        //|---------Range to remove --------|
        //            or
        //|-----------------Range i----------------|
        //|-------Range to remove -----|
        this.customTimeRangeArray[i].start = end;
      }
    }

    this.length = this.customTimeRangeArray.length;
  }

  function mergeRanges(rangeIndex1, rangeIndex2) {
    var range1 = this.customTimeRangeArray[rangeIndex1];
    var range2 = this.customTimeRangeArray[rangeIndex2];

    if (range1.start <= range2.start && range2.start <= range1.end && range1.end <= range2.end) {
      //|-----------Range1----------|
      //                    |-----------Range2----------|
      range1.end = range2.end;
      this.customTimeRangeArray.splice(rangeIndex2, 1);
      return true;
    } else if (range2.start <= range1.start && range1.start <= range2.end && range2.end <= range1.end) {
      //                |-----------Range1----------|
      //|-----------Range2----------|
      range1.start = range2.start;
      this.customTimeRangeArray.splice(rangeIndex2, 1);
      return true;
    } else if (range2.start <= range1.start && range1.start <= range2.end && range1.end <= range2.end) {
      //      |--------Range1-------|
      //|---------------Range2--------------|
      this.customTimeRangeArray.splice(rangeIndex1, 1);
      return true;
    } else if (range1.start <= range2.start && range2.start <= range1.end && range2.end <= range1.end) {
      //|-----------------Range1--------------|
      //        |-----------Range2----------|
      this.customTimeRangeArray.splice(rangeIndex2, 1);
      return true;
    }

    return false;
  }

  function start(index) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_1__["checkInteger"])(index);

    if (index >= this.customTimeRangeArray.length || index < 0) {
      return NaN;
    }

    return this.customTimeRangeArray[index].start;
  }

  function end(index) {
    Object(_utils_SupervisorTools__WEBPACK_IMPORTED_MODULE_1__["checkInteger"])(index);

    if (index >= this.customTimeRangeArray.length || index < 0) {
      return NaN;
    }

    return this.customTimeRangeArray[index].end;
  }

  return {
    customTimeRangeArray: customTimeRangeArray,
    length: length,
    add: add,
    clear: clear,
    remove: remove,
    mergeRanges: mergeRanges,
    start: start,
    end: end
  };
}

CustomTimeRanges.__dashjs_factory_name = 'CustomTimeRanges';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(CustomTimeRanges));

/***/ }),

/***/ "./src/streaming/utils/DOMStorage.js":
/*!*******************************************!*\
  !*** ./src/streaming/utils/DOMStorage.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2556964__) {

"use strict";
__nested_webpack_require_2556964__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2556964__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2556964__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2556964__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



var legacyKeysAndReplacements = [{
  oldKey: 'dashjs_vbitrate',
  newKey: 'dashjs_video_bitrate'
}, {
  oldKey: 'dashjs_abitrate',
  newKey: 'dashjs_audio_bitrate'
}, {
  oldKey: 'dashjs_vsettings',
  newKey: 'dashjs_video_settings'
}, {
  oldKey: 'dashjs_asettings',
  newKey: 'dashjs_audio_settings'
}];
var LOCAL_STORAGE_BITRATE_KEY_TEMPLATE = 'dashjs_?_bitrate';
var LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE = 'dashjs_?_settings';
var STORAGE_TYPE_LOCAL = 'localStorage';
var STORAGE_TYPE_SESSION = 'sessionStorage';
var LAST_BITRATE = 'lastBitrate';
var LAST_MEDIA_SETTINGS = 'lastMediaSettings';

function DOMStorage(config) {
  config = config || {};
  var context = this.context;
  var settings = config.settings;
  var instance, logger, supported;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
    translateLegacyKeys();
  } //type can be local, session


  function isSupported(type) {
    if (supported !== undefined) return supported;
    supported = false;
    var testKey = '1';
    var testValue = '1';
    var storage;

    try {
      if (typeof window !== 'undefined') {
        storage = window[type];
      }
    } catch (error) {
      logger.warn('DOMStorage access denied: ' + error.message);
      return supported;
    }

    if (!storage || type !== STORAGE_TYPE_LOCAL && type !== STORAGE_TYPE_SESSION) {
      return supported;
    }
    /* When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage is available, but trying to call setItem throws an exception.
     http://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
      Check if the storage can be used
     */


    try {
      storage.setItem(testKey, testValue);
      storage.removeItem(testKey);
      supported = true;
    } catch (error) {
      logger.warn('DOMStorage is supported, but cannot be used: ' + error.message);
    }

    return supported;
  }

  function translateLegacyKeys() {
    if (isSupported(STORAGE_TYPE_LOCAL)) {
      legacyKeysAndReplacements.forEach(function (entry) {
        var value = localStorage.getItem(entry.oldKey);

        if (value) {
          localStorage.removeItem(entry.oldKey);

          try {
            localStorage.setItem(entry.newKey, value);
          } catch (e) {
            logger.error(e.message);
          }
        }
      });
    }
  } // Return current epoch time, ms, rounded to the nearest 10m to avoid fingerprinting user


  function getTimestamp() {
    var ten_minutes_ms = 60 * 1000 * 10;
    return Math.round(new Date().getTime() / ten_minutes_ms) * ten_minutes_ms;
  }

  function canStore(storageType, key) {
    return isSupported(storageType) && settings.get().streaming[key + 'CachingInfo'].enabled;
  }

  function checkConfig() {
    if (!settings) {
      throw new Error(_constants_Constants__WEBPACK_IMPORTED_MODULE_2__["default"].MISSING_CONFIG_ERROR);
    }
  }

  function getSavedMediaSettings(type) {
    var mediaSettings = null;
    checkConfig(); //Checks local storage to see if there is valid, non-expired media settings

    if (canStore(STORAGE_TYPE_LOCAL, LAST_MEDIA_SETTINGS)) {
      var key = LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/, type);

      try {
        var obj = JSON.parse(localStorage.getItem(key)) || {};
        var isExpired = new Date().getTime() - parseInt(obj.timestamp, 10) >= settings.get().streaming.lastMediaSettingsCachingInfo.ttl || false;
        mediaSettings = obj.settings;

        if (isExpired) {
          localStorage.removeItem(key);
          mediaSettings = null;
        }
      } catch (e) {
        return null;
      }
    }

    return mediaSettings;
  }

  function getSavedBitrateSettings(type) {
    var savedBitrate = NaN;
    checkConfig(); //Checks local storage to see if there is valid, non-expired bit rate
    //hinting from the last play session to use as a starting bit rate.

    if (canStore(STORAGE_TYPE_LOCAL, LAST_BITRATE)) {
      var key = LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/, type);

      try {
        var obj = JSON.parse(localStorage.getItem(key)) || {};
        var isExpired = new Date().getTime() - parseInt(obj.timestamp, 10) >= settings.get().streaming.lastBitrateCachingInfo.ttl || false;
        var bitrate = parseFloat(obj.bitrate);

        if (!isNaN(bitrate) && !isExpired) {
          savedBitrate = bitrate;
          logger.debug('Last saved bitrate for ' + type + ' was ' + bitrate);
        } else if (isExpired) {
          localStorage.removeItem(key);
        }
      } catch (e) {
        return null;
      }
    }

    return savedBitrate;
  }

  function setSavedMediaSettings(type, value) {
    if (canStore(STORAGE_TYPE_LOCAL, LAST_MEDIA_SETTINGS)) {
      var key = LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/, type);

      try {
        localStorage.setItem(key, JSON.stringify({
          settings: value,
          timestamp: getTimestamp()
        }));
      } catch (e) {
        logger.error(e.message);
      }
    }
  }

  function setSavedBitrateSettings(type, bitrate) {
    if (canStore(STORAGE_TYPE_LOCAL, LAST_BITRATE) && bitrate) {
      var key = LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/, type);

      try {
        localStorage.setItem(key, JSON.stringify({
          bitrate: bitrate.toFixed(3),
          timestamp: getTimestamp()
        }));
      } catch (e) {
        logger.error(e.message);
      }
    }
  }

  instance = {
    getSavedBitrateSettings: getSavedBitrateSettings,
    setSavedBitrateSettings: setSavedBitrateSettings,
    getSavedMediaSettings: getSavedMediaSettings,
    setSavedMediaSettings: setSavedMediaSettings
  };
  setup();
  return instance;
}

DOMStorage.__dashjs_factory_name = 'DOMStorage';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(DOMStorage);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/utils/DefaultURLUtils.js":
/*!************************************************!*\
  !*** ./src/streaming/utils/DefaultURLUtils.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2565911__) {

"use strict";
__nested_webpack_require_2565911__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2565911__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module DefaultURLUtils
 * @description Provides utility functions for operating on URLs.
 * Initially this is simply a method to determine the Base URL of a URL, but
 * should probably include other things provided all over the place such as
 * determining whether a URL is relative/absolute, resolving two paths etc.
 * @ignore
 */

function DefaultURLUtils() {
  var resolveFunction;
  var schemeRegex = /^[a-z][a-z0-9+\-_.]*:/i;
  var httpUrlRegex = /^https?:\/\//i;
  var httpsUrlRegex = /^https:\/\//i;
  var originRegex = /^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i;
  /**
   * Resolves a url given an optional base url
   * Uses window.URL to do the resolution.
   *
   * @param {string} url
   * @param {string} [baseUrl]
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   * @private
   */

  var nativeURLResolver = function nativeURLResolver(url, baseUrl) {
    try {
      return new window.URL(url, baseUrl).toString();
    } catch (e) {
      return url;
    }
  };
  /**
   * Resolves a url given an optional base url
   * Does not resolve ./, ../ etc but will do enough to construct something
   * which will satisfy XHR etc when window.URL is not available ie
   * IE11/node etc.
   *
   * @param {string} url
   * @param {string} [baseUrl]
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   * @private
   */


  var dumbURLResolver = function dumbURLResolver(url, baseUrl) {
    var baseUrlParseFunc = parseBaseUrl;

    if (!baseUrl) {
      return url;
    }

    if (!isRelative(url)) {
      return url;
    }

    if (isPathAbsolute(url)) {
      baseUrlParseFunc = parseOrigin;
    }

    if (isSchemeRelative(url)) {
      baseUrlParseFunc = parseScheme;
    }

    var base = baseUrlParseFunc(baseUrl);
    var joinChar = base.charAt(base.length - 1) !== '/' && url.charAt(0) !== '/' ? '/' : '';
    return [base, url].join(joinChar);
  };

  function setup() {
    try {
      var u = new window.URL('x', 'http://y'); // eslint-disable-line

      resolveFunction = nativeURLResolver;
    } catch (e) {// must be IE11/Node etc
    } finally {
      resolveFunction = resolveFunction || dumbURLResolver;
    }
  }
  /**
   * Returns a string that contains the Base URL of a URL, if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function parseBaseUrl(url) {
    var slashIndex = url.indexOf('/');
    var lastSlashIndex = url.lastIndexOf('/');

    if (slashIndex !== -1) {
      // if there is only '//'
      if (lastSlashIndex === slashIndex + 1) {
        return url;
      }

      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'));
      }

      return url.substring(0, lastSlashIndex + 1);
    }

    return '';
  }
  /**
   * Returns a string that contains the scheme and origin of a URL,
   * if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function parseOrigin(url) {
    var matches = url.match(originRegex);

    if (matches) {
      return matches[1];
    }

    return '';
  }
  /**
   * Returns a string that contains the fragment of a URL without scheme,
   * if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function removeHostname(url) {
    var urlParts = /^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(url); //[1] = host / [2] = path

    return urlParts[2].substring(1);
  }
  /**
   * Returns a string that contains the scheme of a URL, if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function parseScheme(url) {
    var matches = url.match(schemeRegex);

    if (matches) {
      return matches[0];
    }

    return '';
  }
  /**
   * Determines whether the url is relative.
   * @return {boolean}
   * @param {string} url
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function isRelative(url) {
    return !schemeRegex.test(url);
  }
  /**
   * Determines whether the url is path-absolute.
   * @return {bool}
   * @param {string} url
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function isPathAbsolute(url) {
    return isRelative(url) && url.charAt(0) === '/';
  }
  /**
   * Determines whether the url is scheme-relative.
   * @return {bool}
   * @param {string} url
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function isSchemeRelative(url) {
    return url.indexOf('//') === 0;
  }
  /**
   * Determines whether the url is an HTTP-URL as defined in ISO/IEC
   * 23009-1:2014 3.1.15. ie URL with a fixed scheme of http or https
   * @return {bool}
   * @param {string} url
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function isHTTPURL(url) {
    return httpUrlRegex.test(url);
  }
  /**
   * Determines whether the supplied url has https scheme
   * @return {bool}
   * @param {string} url
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function isHTTPS(url) {
    return httpsUrlRegex.test(url);
  }
  /**
   * Resolves a url given an optional base url
   * @return {string}
   * @param {string} url
   * @param {string} [baseUrl]
   * @memberof module:DefaultURLUtils
   * @instance
   */


  function resolve(url, baseUrl) {
    return resolveFunction(url, baseUrl);
  }

  setup();
  var instance = {
    parseBaseUrl: parseBaseUrl,
    parseOrigin: parseOrigin,
    parseScheme: parseScheme,
    isRelative: isRelative,
    isPathAbsolute: isPathAbsolute,
    isSchemeRelative: isSchemeRelative,
    isHTTPURL: isHTTPURL,
    isHTTPS: isHTTPS,
    removeHostname: removeHostname,
    resolve: resolve
  };
  return instance;
}

DefaultURLUtils.__dashjs_factory_name = 'DefaultURLUtils';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(DefaultURLUtils));

/***/ }),

/***/ "./src/streaming/utils/EBMLParser.js":
/*!*******************************************!*\
  !*** ./src/streaming/utils/EBMLParser.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2574599__) {

"use strict";
__nested_webpack_require_2574599__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2574599__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");

/**
 * Creates an instance of an EBMLParser class which implements a large subset
 * of the functionality required to parse Matroska EBML
 *
 * @param {Object} config object with data member which is the buffer to parse
 * @ignore
 */

function EBMLParser(config) {
  config = config || {};
  var instance;
  var data = new DataView(config.data);
  var pos = 0;

  function getPos() {
    return pos;
  }

  function setPos(value) {
    pos = value;
  }
  /**
   * Consumes an EBML tag from the data stream.
   *
   * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
   * {boolean} required flag.
   * @param {boolean} test whether or not the function should throw if a required
   * tag is not found
   * @return {boolean} whether or not the tag was found
   * @throws will throw an exception if a required tag is not found and test
   * param is false or undefined, or if the stream is malformed.
   * @memberof EBMLParser
   */


  function consumeTag(tag, test) {
    var found = true;
    var bytesConsumed = 0;
    var p1, p2;

    if (test === undefined) {
      test = false;
    }

    if (tag.tag > 0xFFFFFF) {
      if (data.getUint32(pos) !== tag.tag) {
        found = false;
      }

      bytesConsumed = 4;
    } else if (tag.tag > 0xFFFF) {
      // 3 bytes
      p1 = data.getUint16(pos);
      p2 = data.getUint8(pos + 2); // shift p1 over a byte and add p2

      if (p1 * 256 + p2 !== tag.tag) {
        found = false;
      }

      bytesConsumed = 3;
    } else if (tag.tag > 0xFF) {
      if (data.getUint16(pos) !== tag.tag) {
        found = false;
      }

      bytesConsumed = 2;
    } else {
      if (data.getUint8(pos) !== tag.tag) {
        found = false;
      }

      bytesConsumed = 1;
    }

    if (!found && tag.required && !test) {
      throw new Error('required tag not found');
    }

    if (found) {
      pos += bytesConsumed;
    }

    return found;
  }
  /**
   * Consumes an EBML tag from the data stream.   If the tag is found then this
   * function will also remove the size field which follows the tag from the
   * data stream.
   *
   * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
   * {boolean} required flag.
   * @param {boolean} test whether or not the function should throw if a required
   * tag is not found
   * @return {boolean} whether or not the tag was found
   * @throws will throw an exception if a required tag is not found and test
   * param is false or undefined, or if the stream is malformedata.
   * @memberof EBMLParser
   */


  function consumeTagAndSize(tag, test) {
    var found = consumeTag(tag, test);

    if (found) {
      getMatroskaCodedNum();
    }

    return found;
  }
  /**
   * Consumes an EBML tag from the data stream.   If the tag is found then this
   * function will also remove the size field which follows the tag from the
   * data stream.  It will use the value of the size field to parse a binary
   * field, using a parser defined in the tag itself
   *
   * @param {Object} tag to parse, A tag is an object with at least a {number} tag,
   * {boolean} required flag, and a parse function which takes a size parameter
   * @return {boolean} whether or not the tag was found
   * @throws will throw an exception if a required tag is not found,
   * or if the stream is malformed
   * @memberof EBMLParser
   */


  function parseTag(tag) {
    var size;
    consumeTag(tag);
    size = getMatroskaCodedNum();
    return instance[tag.parse](size);
  }
  /**
   * Consumes an EBML tag from the data stream.   If the tag is found then this
   * function will also remove the size field which follows the tag from the
   * data stream.  It will use the value of the size field to skip over the
   * entire section of EBML encapsulated by the tag.
   *
   * @param {Object} tag to parse, A tag is an object with at least a {number} tag, and
   * {boolean} required flag
   * @param {boolean} test a flag to indicate if an exception should be thrown
   * if a required tag is not found
   * @return {boolean} whether or not the tag was found
   * @throws will throw an exception if a required tag is not found and test is
   * false or undefined or if the stream is malformed
   * @memberof EBMLParser
   */


  function skipOverElement(tag, test) {
    var found = consumeTag(tag, test);
    var headerSize;

    if (found) {
      headerSize = getMatroskaCodedNum();
      pos += headerSize;
    }

    return found;
  }
  /**
   * Returns and consumes a number encoded according to the Matroska EBML
   * specification from the bitstream.
   *
   * @param {boolean} retainMSB whether or not to retain the Most Significant Bit (the
   * first 1). this is usually true when reading Tag IDs.
   * @return {number} the decoded number
   * @throws will throw an exception if the bit stream is malformed or there is
   * not enough data
   * @memberof EBMLParser
   */


  function getMatroskaCodedNum(retainMSB) {
    var bytesUsed = 1;
    var mask = 0x80;
    var maxBytes = 8;
    var extraBytes = -1;
    var num = 0;
    var ch = data.getUint8(pos);
    var i = 0;

    for (i = 0; i < maxBytes; i += 1) {
      if ((ch & mask) === mask) {
        num = retainMSB === undefined ? ch & ~mask : ch;
        extraBytes = i;
        break;
      }

      mask >>= 1;
    }

    for (i = 0; i < extraBytes; i += 1, bytesUsed += 1) {
      num = num << 8 | 0xff & data.getUint8(pos + bytesUsed);
    }

    pos += bytesUsed;
    return num;
  }
  /**
   * Returns and consumes a float from the bitstream.
   *
   * @param {number} size 4 or 8 byte floats are supported
   * @return {number} the decoded number
   * @throws will throw an exception if the bit stream is malformed or there is
   * not enough data
   * @memberof EBMLParser
   */


  function getMatroskaFloat(size) {
    var outFloat;

    switch (size) {
      case 4:
        outFloat = data.getFloat32(pos);
        pos += 4;
        break;

      case 8:
        outFloat = data.getFloat64(pos);
        pos += 8;
        break;
    }

    return outFloat;
  }
  /**
   * Consumes and returns an unsigned int from the bitstream.
   *
   * @param {number} size 1 to 8 bytes
   * @return {number} the decoded number
   * @throws will throw an exception if the bit stream is malformed or there is
   * not enough data
   * @memberof EBMLParser
   */


  function getMatroskaUint(size) {
    var val = 0;

    for (var i = 0; i < size; i += 1) {
      val <<= 8;
      val |= data.getUint8(pos + i) & 0xff;
    }

    pos += size;
    return val;
  }
  /**
   * Tests whether there is more data in the bitstream for parsing
   *
   * @return {boolean} whether there is more data to parse
   * @memberof EBMLParser
   */


  function moreData() {
    return pos < data.byteLength;
  }

  instance = {
    getPos: getPos,
    setPos: setPos,
    consumeTag: consumeTag,
    consumeTagAndSize: consumeTagAndSize,
    parseTag: parseTag,
    skipOverElement: skipOverElement,
    getMatroskaCodedNum: getMatroskaCodedNum,
    getMatroskaFloat: getMatroskaFloat,
    getMatroskaUint: getMatroskaUint,
    moreData: moreData
  };
  return instance;
}

EBMLParser.__dashjs_factory_name = 'EBMLParser';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(EBMLParser));

/***/ }),

/***/ "./src/streaming/utils/ErrorHandler.js":
/*!*********************************************!*\
  !*** ./src/streaming/utils/ErrorHandler.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2582798__) {

"use strict";
__nested_webpack_require_2582798__.r(__webpack_exports__);
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2582798__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2582798__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2582798__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



/**
 * @module ErrorHandler
 * @ignore
 */

function ErrorHandler() {
  var instance;
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_0__["default"])(context).getInstance();
  /**
   * @param {object} err DashJSError with code, message and data attributes
   * @memberof module:ErrorHandler
   */

  function error(err) {
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR, {
      error: err
    });
  }

  instance = {
    error: error
  };
  return instance;
}

ErrorHandler.__dashjs_factory_name = 'ErrorHandler';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_2__["default"].getSingletonFactory(ErrorHandler));

/***/ }),

/***/ "./src/streaming/utils/InitCache.js":
/*!******************************************!*\
  !*** ./src/streaming/utils/InitCache.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2586290__) {

"use strict";
__nested_webpack_require_2586290__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2586290__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Represents data structure to keep and drive {DataChunk}
 */


function InitCache() {
  var data = {};

  function save(chunk) {
    var id = chunk.streamId;
    var representationId = chunk.representationId;
    data[id] = data[id] || {};
    data[id][representationId] = chunk;
  }

  function extract(streamId, representationId) {
    if (data && data[streamId] && data[streamId][representationId]) {
      return data[streamId][representationId];
    } else {
      return null;
    }
  }

  function reset() {
    data = {};
  }

  var instance = {
    save: save,
    extract: extract,
    reset: reset
  };
  return instance;
}

InitCache.__dashjs_factory_name = 'InitCache';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(InitCache));

/***/ }),

/***/ "./src/streaming/utils/IsoFile.js":
/*!****************************************!*\
  !*** ./src/streaming/utils/IsoFile.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2589558__) {

"use strict";
__nested_webpack_require_2589558__.r(__webpack_exports__);
/* harmony import */ var _vo_IsoBox__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2589558__(/*! ../vo/IsoBox */ "./src/streaming/vo/IsoBox.js");
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2589558__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function IsoFile() {
  var instance, parsedIsoFile;
  /**
  * @param {string} type
  * @returns {IsoBox|null}
  * @memberof IsoFile#
  */

  function getBox(type) {
    if (!type || !parsedIsoFile || !parsedIsoFile.boxes || parsedIsoFile.boxes.length === 0 || typeof parsedIsoFile.fetch !== 'function') return null;
    return convertToDashIsoBox(parsedIsoFile.fetch(type));
  }
  /**
  * @param {string} type
  * @returns {Array|null} array of {@link IsoBox}
  * @memberof IsoFile#
  */


  function getBoxes(type) {
    var boxes = [];

    if (!type || !parsedIsoFile || typeof parsedIsoFile.fetchAll !== 'function') {
      return boxes;
    }

    var boxData = parsedIsoFile.fetchAll(type);
    var box;

    for (var i = 0, ln = boxData.length; i < ln; i++) {
      box = convertToDashIsoBox(boxData[i]);

      if (box) {
        boxes.push(box);
      }
    }

    return boxes;
  }
  /**
  * @param {string} value
  * @memberof IsoFile#
  */


  function setData(value) {
    parsedIsoFile = value;
  }
  /**
  * @returns {IsoBox|null}
  * @memberof IsoFile#
  */


  function getLastBox() {
    if (!parsedIsoFile || !parsedIsoFile.boxes || !parsedIsoFile.boxes.length) return null;
    var type = parsedIsoFile.boxes[parsedIsoFile.boxes.length - 1].type;
    var boxes = getBoxes(type);
    return boxes.length > 0 ? boxes[boxes.length - 1] : null;
  }

  function convertToDashIsoBox(boxData) {
    if (!boxData) return null;
    var box = new _vo_IsoBox__WEBPACK_IMPORTED_MODULE_0__["default"](boxData);

    if (boxData.hasOwnProperty('_incomplete')) {
      box.isComplete = !boxData._incomplete;
    }

    return box;
  }

  instance = {
    getBox: getBox,
    getBoxes: getBoxes,
    setData: setData,
    getLastBox: getLastBox
  };
  return instance;
}

IsoFile.__dashjs_factory_name = 'IsoFile';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_1__["default"].getClassFactory(IsoFile));

/***/ }),

/***/ "./src/streaming/utils/ObjectUtils.js":
/*!********************************************!*\
  !*** ./src/streaming/utils/ObjectUtils.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2594157__) {

"use strict";
__nested_webpack_require_2594157__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2594157__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2594157__(/*! fast-deep-equal */ "./node_modules/fast-deep-equal/index.js");
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__nested_webpack_require_2594157__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * @module ObjectUtils
 * @ignore
 * @description Provides utility functions for objects
 */

function ObjectUtils() {
  var instance;
  /**
   * Returns true if objects are equal
   * @return {boolean}
   * @param {object} obj1
   * @param {object} obj2
   * @memberof module:ObjectUtils
   * @instance
   */

  function areEqual(obj1, obj2) {
    return fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(obj1, obj2);
  }

  instance = {
    areEqual: areEqual
  };
  return instance;
}

ObjectUtils.__dashjs_factory_name = 'ObjectUtils';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(ObjectUtils));

/***/ }),

/***/ "./src/streaming/utils/RequestModifier.js":
/*!************************************************!*\
  !*** ./src/streaming/utils/RequestModifier.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2597636__) {

"use strict";
__nested_webpack_require_2597636__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2597636__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function RequestModifier() {
  var instance;

  function modifyRequestURL(url) {
    return url;
  }

  function modifyRequestHeader(request) {
    return request;
  }

  instance = {
    modifyRequestURL: modifyRequestURL,
    modifyRequestHeader: modifyRequestHeader
  };
  return instance;
}

RequestModifier.__dashjs_factory_name = 'RequestModifier';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(RequestModifier));

/***/ }),

/***/ "./src/streaming/utils/SupervisorTools.js":
/*!************************************************!*\
  !*** ./src/streaming/utils/SupervisorTools.js ***!
  \************************************************/
/*! exports provided: checkParameterType, checkInteger, checkRange, checkIsVideoOrAudioType */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2600655__) {

"use strict";
__nested_webpack_require_2600655__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2600655__.d(__webpack_exports__, "checkParameterType", function() { return checkParameterType; });
/* harmony export (binding) */ __nested_webpack_require_2600655__.d(__webpack_exports__, "checkInteger", function() { return checkInteger; });
/* harmony export (binding) */ __nested_webpack_require_2600655__.d(__webpack_exports__, "checkRange", function() { return checkRange; });
/* harmony export (binding) */ __nested_webpack_require_2600655__.d(__webpack_exports__, "checkIsVideoOrAudioType", function() { return checkIsVideoOrAudioType; });
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2600655__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

function checkParameterType(parameter, type) {
  if (_typeof(parameter) !== type) {
    throw _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].BAD_ARGUMENT_ERROR;
  }
}
function checkInteger(parameter) {
  var isInt = parameter !== null && !isNaN(parameter) && parameter % 1 === 0;

  if (!isInt) {
    throw _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].BAD_ARGUMENT_ERROR + ' : argument is not an integer';
  }
}
function checkRange(parameter, min, max) {
  if (parameter < min || parameter > max) {
    throw _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].BAD_ARGUMENT_ERROR + ' : argument out of range';
  }
}
function checkIsVideoOrAudioType(type) {
  if (typeof type !== 'string' || type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].AUDIO && type !== _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].VIDEO) {
    throw _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].BAD_ARGUMENT_ERROR;
  }
}

/***/ }),

/***/ "./src/streaming/utils/TTMLParser.js":
/*!*******************************************!*\
  !*** ./src/streaming/utils/TTMLParser.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2605002__) {

"use strict";
__nested_webpack_require_2605002__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2605002__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2605002__(/*! ../../core/Debug */ "./src/core/Debug.js");
/* harmony import */ var _core_EventBus__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_2605002__(/*! ../../core/EventBus */ "./src/core/EventBus.js");
/* harmony import */ var _core_events_Events__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_2605002__(/*! ../../core/events/Events */ "./src/core/events/Events.js");
/* harmony import */ var imsc__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_2605002__(/*! imsc */ "./node_modules/imsc/src/main/js/main.js");
/* harmony import */ var imsc__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__nested_webpack_require_2605002__.n(imsc__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_2605002__(/*! ../MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/* harmony import */ var _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_2605002__(/*! ../constants/ConformanceViolationConstants */ "./src/streaming/constants/ConformanceViolationConstants.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */








function TTMLParser() {
  var context = this.context;
  var eventBus = Object(_core_EventBus__WEBPACK_IMPORTED_MODULE_2__["default"])(context).getInstance();
  /*
   * This TTML parser follows "EBU-TT-D SUBTITLING DISTRIBUTION FORMAT - tech3380" spec - https://tech.ebu.ch/docs/tech/tech3380.pdf.
   * */

  var instance, logger;
  var cueCounter = 0; // Used to give every cue a unique ID.

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
  }

  function getCueID() {
    var id = 'cue_TTML_' + cueCounter;
    cueCounter++;
    return id;
  }
  /**
   * Parse the raw data and process it to return the HTML element representing the cue.
   * Return the region to be processed and controlled (hide/show) by the caption controller.
   * @param {string} data - raw data received from the TextSourceBuffer
   * @param {number} offsetTime - offset time to apply to cue time
   * @param {integer} startTimeSegment - startTime for the current segment
   * @param {integer} endTimeSegment - endTime for the current segment
   * @param {Array} images - images array referenced by subs MP4 box
   */


  function parse(data, offsetTime, startTimeSegment, endTimeSegment, images) {
    var errorMsg = '';
    var captionArray = [];
    var startTime, endTime, i;
    var content = {};
    var embeddedImages = {};
    var currentImageId = '';
    var accumulated_image_data = '';
    var metadataHandler = {
      onOpenTag: function onOpenTag(ns, name, attrs) {
        // cope with existing non-compliant content
        if (attrs[' imagetype'] && !attrs[' imageType']) {
          eventBus.trigger(_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_5__["default"].CONFORMANCE_VIOLATION, {
            level: _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_6__["default"].LEVELS.ERROR,
            event: _constants_ConformanceViolationConstants__WEBPACK_IMPORTED_MODULE_6__["default"].EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE
          });
          attrs[' imageType'] = attrs[' imagetype'];
        }

        if (name === 'image' && (ns === 'http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt' || ns === 'http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt')) {
          if (!attrs[' imageType'] || attrs[' imageType'].value !== 'PNG') {
            logger.warn('smpte-tt imageType != PNG. Discarded');
            return;
          }

          currentImageId = attrs['http://www.w3.org/XML/1998/namespace id'].value;
        }
      },
      onCloseTag: function onCloseTag() {
        if (currentImageId) {
          embeddedImages[currentImageId] = accumulated_image_data.trim();
        }

        accumulated_image_data = '';
        currentImageId = '';
      },
      onText: function onText(contents) {
        if (currentImageId) {
          accumulated_image_data = accumulated_image_data + contents;
        }
      }
    };

    if (!data) {
      errorMsg = 'no ttml data to parse';
      throw new Error(errorMsg);
    }

    content.data = data;
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].TTML_TO_PARSE, content);
    var imsc1doc = Object(imsc__WEBPACK_IMPORTED_MODULE_4__["fromXML"])(content.data, function (msg) {
      errorMsg = msg;
    }, metadataHandler);
    eventBus.trigger(_core_events_Events__WEBPACK_IMPORTED_MODULE_3__["default"].TTML_PARSED, {
      ttmlString: content.data,
      ttmlDoc: imsc1doc
    });
    var mediaTimeEvents = imsc1doc.getMediaTimeEvents();

    for (i = 0; i < mediaTimeEvents.length; i++) {
      var isd = Object(imsc__WEBPACK_IMPORTED_MODULE_4__["generateISD"])(imsc1doc, mediaTimeEvents[i], function (error) {
        errorMsg = error;
      });

      if (isd.contents.some(function (topLevelContents) {
        return topLevelContents.contents.length;
      })) {
        //be sure that mediaTimeEvents values are in the mp4 segment time ranges.
        startTime = mediaTimeEvents[i] + offsetTime < startTimeSegment ? startTimeSegment : mediaTimeEvents[i] + offsetTime;
        endTime = mediaTimeEvents[i + 1] + offsetTime > endTimeSegment ? endTimeSegment : mediaTimeEvents[i + 1] + offsetTime;

        if (startTime < endTime) {
          captionArray.push({
            start: startTime,
            end: endTime,
            type: 'html',
            cueID: getCueID(),
            isd: isd,
            images: images,
            embeddedImages: embeddedImages
          });
        }
      }
    }

    if (errorMsg !== '') {
      logger.error(errorMsg);
      throw new Error(errorMsg);
    }

    return captionArray;
  }

  instance = {
    parse: parse
  };
  setup();
  return instance;
}

TTMLParser.__dashjs_factory_name = 'TTMLParser';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(TTMLParser));

/***/ }),

/***/ "./src/streaming/utils/URLUtils.js":
/*!*****************************************!*\
  !*** ./src/streaming/utils/URLUtils.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2613574__) {

"use strict";
__nested_webpack_require_2613574__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2613574__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _DefaultURLUtils__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2613574__(/*! ./DefaultURLUtils */ "./src/streaming/utils/DefaultURLUtils.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


/**
 * @module URLUtils
 * @ignore
 * @description Provides utility functions for operating on URLs.
 * Initially this is simply a method to determine the Base URL of a URL, but
 * should probably include other things provided all over the place such as
 * determining whether a URL is relative/absolute, resolving two paths etc.
 */

function URLUtils() {
  var instance;
  var defaultURLUtils;
  var regexUtils = [];
  var context = this.context;

  function getUtils(url) {
    var i;

    for (i = 0; i < regexUtils.length; i++) {
      var regex = regexUtils[i].regex;

      if (regex.test(url)) {
        return regexUtils[i].utils;
      }
    }

    return defaultURLUtils;
  }

  function setup() {
    defaultURLUtils = Object(_DefaultURLUtils__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance();
  }
  /**
   * Register a module to handle specific url.
   * @param {regex} regex - url regex
   * @param {object} utils - object that handles the regex
   * @memberof module:URLUtils
   * @instance
   */


  function registerUrlRegex(regex, utils) {
    regexUtils.push({
      regex: regex,
      utils: utils
    });
  }

  function internalCall(functionName, url, baseUrl) {
    var utils = getUtils(baseUrl || url);
    return utils && typeof utils[functionName] === 'function' ? utils[functionName](url, baseUrl) : defaultURLUtils[functionName](url, baseUrl);
  }
  /**
   * Returns a string that contains the Base URL of a URL, if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:URLUtils
   * @instance
   */


  function parseBaseUrl(url) {
    return internalCall('parseBaseUrl', url);
  }
  /**
   * Returns a string that contains the scheme and origin of a URL,
   * if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:URLUtils
   * @instance
   */


  function parseOrigin(url) {
    return internalCall('parseOrigin', url);
  }
  /**
   * Returns a string that contains the fragment of a URL without scheme,
   * if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:URLUtils
   * @instance
   */


  function removeHostname(url) {
    return internalCall('removeHostname', url);
  }
  /**
   * Returns a string that contains the scheme of a URL, if determinable.
   * @param {string} url - full url
   * @return {string}
   * @memberof module:URLUtils
   * @instance
   */


  function parseScheme(url) {
    return internalCall('parseScheme', url);
  }
  /**
   * Determines whether the url is relative.
   * @return {boolean}
   * @param {string} url
   * @memberof module:URLUtils
   * @instance
   */


  function isRelative(url) {
    return internalCall('isRelative', url);
  }
  /**
   * Determines whether the url is path-absolute.
   * @return {bool}
   * @param {string} url
   * @memberof module:URLUtils
   * @instance
   */


  function isPathAbsolute(url) {
    return internalCall('isPathAbsolute', url);
  }
  /**
   * Determines whether the url is scheme-relative.
   * @return {bool}
   * @param {string} url
   * @memberof module:URLUtils
   * @instance
   */


  function isSchemeRelative(url) {
    return internalCall('isSchemeRelative', url);
  }
  /**
   * Determines whether the url is an HTTP-URL as defined in ISO/IEC
   * 23009-1:2014 3.1.15. ie URL with a fixed scheme of http or https
   * @return {bool}
   * @param {string} url
   * @memberof module:URLUtils
   * @instance
   */


  function isHTTPURL(url) {
    return internalCall('isHTTPURL', url);
  }
  /**
   * Determines whether the supplied url has https scheme
   * @return {bool}
   * @param {string} url
   * @memberof module:URLUtils
   * @instance
   */


  function isHTTPS(url) {
    return internalCall('isHTTPS', url);
  }
  /**
   * Resolves a url given an optional base url
   * @return {string}
   * @param {string} url
   * @param {string} [baseUrl]
   * @memberof module:URLUtils
   * @instance
   */


  function resolve(url, baseUrl) {
    return internalCall('resolve', url, baseUrl);
  }

  setup();
  instance = {
    registerUrlRegex: registerUrlRegex,
    parseBaseUrl: parseBaseUrl,
    parseOrigin: parseOrigin,
    parseScheme: parseScheme,
    isRelative: isRelative,
    isPathAbsolute: isPathAbsolute,
    isSchemeRelative: isSchemeRelative,
    isHTTPURL: isHTTPURL,
    isHTTPS: isHTTPS,
    removeHostname: removeHostname,
    resolve: resolve
  };
  return instance;
}

URLUtils.__dashjs_factory_name = 'URLUtils';
var factory = _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(URLUtils);
/* harmony default export */ __webpack_exports__["default"] = (factory);

/***/ }),

/***/ "./src/streaming/utils/VTTParser.js":
/*!******************************************!*\
  !*** ./src/streaming/utils/VTTParser.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2621015__) {

"use strict";
__nested_webpack_require_2621015__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2621015__(/*! ../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/* harmony import */ var _core_Debug__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2621015__(/*! ../../core/Debug */ "./src/core/Debug.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


var WEBVTT = 'WEBVTT';

function VTTParser() {
  var context = this.context;
  var instance, logger, regExNewLine, regExToken, regExWhiteSpace, regExWhiteSpaceWordBoundary;

  function setup() {
    logger = Object(_core_Debug__WEBPACK_IMPORTED_MODULE_1__["default"])(context).getInstance().getLogger(instance);
    regExNewLine = /(?:\r\n|\r|\n)/gm;
    regExToken = /-->/;
    regExWhiteSpace = /(^[\s]+|[\s]+$)/g;
    regExWhiteSpaceWordBoundary = /\s\b/g;
  }

  function parse(data) {
    var captionArray = [];
    var len, lastStartTime;

    if (!data) {
      return captionArray;
    }

    data = data.split(regExNewLine);
    len = data.length;
    lastStartTime = -1;

    for (var i = 0; i < len; i++) {
      var item = data[i];

      if (item.length > 0 && item !== WEBVTT) {
        if (item.match(regExToken)) {
          var attributes = parseItemAttributes(item);
          var cuePoints = attributes.cuePoints;
          var styles = attributes.styles;
          var text = getSublines(data, i + 1);
          var startTime = convertCuePointTimes(cuePoints[0].replace(regExWhiteSpace, ''));
          var endTime = convertCuePointTimes(cuePoints[1].replace(regExWhiteSpace, ''));

          if (!isNaN(startTime) && !isNaN(endTime) && startTime >= lastStartTime && endTime > startTime) {
            if (text !== '') {
              lastStartTime = startTime; //TODO Make VO external so other parsers can use.

              captionArray.push({
                start: startTime,
                end: endTime,
                data: text,
                styles: styles
              });
            } else {
              logger.error('Skipping cue due to empty/malformed cue text');
            }
          } else {
            logger.error('Skipping cue due to incorrect cue timing');
          }
        }
      }
    }

    return captionArray;
  }

  function convertCuePointTimes(time) {
    var timeArray = time.split(':');
    var len = timeArray.length - 1;
    time = parseInt(timeArray[len - 1], 10) * 60 + parseFloat(timeArray[len]);

    if (len === 2) {
      time += parseInt(timeArray[0], 10) * 3600;
    }

    return time;
  }

  function parseItemAttributes(data) {
    var vttCuePoints = data.split(regExToken);
    var arr = vttCuePoints[1].split(regExWhiteSpaceWordBoundary);
    arr.shift(); //remove first array index it is empty...

    vttCuePoints[1] = arr[0];
    arr.shift();
    return {
      cuePoints: vttCuePoints,
      styles: getCaptionStyles(arr)
    };
  }

  function getCaptionStyles(arr) {
    var styleObject = {};
    arr.forEach(function (element) {
      if (element.split(/:/).length > 1) {
        var val = element.split(/:/)[1];

        if (val && val.search(/%/) != -1) {
          val = parseInt(val.replace(/%/, ''), 10);
        }

        if (element.match(/align/) || element.match(/A/)) {
          styleObject.align = val;
        }

        if (element.match(/line/) || element.match(/L/)) {
          styleObject.line = val;
        }

        if (element.match(/position/) || element.match(/P/)) {
          styleObject.position = val;
        }

        if (element.match(/size/) || element.match(/S/)) {
          styleObject.size = val;
        }
      }
    });
    return styleObject;
  }
  /*
  * VTT can have multiple lines to display per cuepoint.
  */


  function getSublines(data, idx) {
    var i = idx;
    var subline = '';
    var lineData = '';
    var lineCount;

    while (data[i] !== '' && i < data.length) {
      i++;
    }

    lineCount = i - idx;

    if (lineCount > 1) {
      for (var j = 0; j < lineCount; j++) {
        lineData = data[idx + j];

        if (!lineData.match(regExToken)) {
          subline += lineData;

          if (j !== lineCount - 1) {
            subline += '\n';
          }
        } else {
          // caption text should not have '-->' in it
          subline = '';
          break;
        }
      }
    } else {
      lineData = data[idx];
      if (!lineData.match(regExToken)) subline = lineData;
    }

    return subline;
  }

  instance = {
    parse: parse
  };
  setup();
  return instance;
}

VTTParser.__dashjs_factory_name = 'VTTParser';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getSingletonFactory(VTTParser));

/***/ }),

/***/ "./src/streaming/utils/baseUrlResolution/BasicSelector.js":
/*!****************************************************************!*\
  !*** ./src/streaming/utils/baseUrlResolution/BasicSelector.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2628149__) {

"use strict";
__nested_webpack_require_2628149__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2628149__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function BasicSelector(config) {
  config = config || {};
  var instance;
  var blacklistController = config.blacklistController;

  function select(baseUrls) {
    var index = 0;
    var selectedBaseUrl;

    if (baseUrls && baseUrls.some(function (baseUrl, idx) {
      index = idx;
      return !blacklistController.contains(baseUrl.serviceLocation);
    })) {
      selectedBaseUrl = baseUrls[index];
    }

    return selectedBaseUrl;
  }

  instance = {
    select: select
  };
  return instance;
}

BasicSelector.__dashjs_factory_name = 'BasicSelector';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(BasicSelector));

/***/ }),

/***/ "./src/streaming/utils/baseUrlResolution/DVBSelector.js":
/*!**************************************************************!*\
  !*** ./src/streaming/utils/baseUrlResolution/DVBSelector.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2631372__) {

"use strict";
__nested_webpack_require_2631372__.r(__webpack_exports__);
/* harmony import */ var _core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2631372__(/*! ../../../core/FactoryMaker */ "./src/core/FactoryMaker.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


function DVBSelector(config) {
  config = config || {};
  var instance;
  var blacklistController = config.blacklistController;

  function getNonBlacklistedBaseUrls(urls) {
    var removedPriorities = [];

    var samePrioritiesFilter = function samePrioritiesFilter(el) {
      if (removedPriorities.length) {
        if (el.dvb_priority && removedPriorities.indexOf(el.dvb_priority) !== -1) {
          return false;
        }
      }

      return true;
    };

    var serviceLocationFilter = function serviceLocationFilter(baseUrl) {
      if (blacklistController.contains(baseUrl.serviceLocation)) {
        // whenever a BaseURL is removed from the available list of
        // BaseURLs, any other BaseURL with the same @priority
        // value as the BaseURL being removed shall also be removed
        if (baseUrl.dvb_priority) {
          removedPriorities.push(baseUrl.dvb_priority);
        } // all URLs in the list which have a @serviceLocation
        // attribute matching an entry in the blacklist shall be
        // removed from the available list of BaseURLs


        return false;
      }

      return true;
    };

    return urls.filter(serviceLocationFilter).filter(samePrioritiesFilter);
  }

  function selectByWeight(availableUrls) {
    var prioritySorter = function prioritySorter(a, b) {
      var diff = a.dvb_priority - b.dvb_priority;
      return isNaN(diff) ? 0 : diff;
    };

    var topPriorityFilter = function topPriorityFilter(baseUrl, idx, arr) {
      return !idx || arr[0].dvb_priority && baseUrl.dvb_priority && arr[0].dvb_priority === baseUrl.dvb_priority;
    };

    var totalWeight = 0;
    var cumulWeights = [];
    var idx = 0;
    var rn, urls; // It shall begin by taking the set of resolved BaseURLs present or inherited at the current
    // position in the MPD, resolved and filtered as described in 10.8.2.1, that have the lowest
    // @priority attribute value.

    urls = availableUrls.sort(prioritySorter).filter(topPriorityFilter);

    if (urls.length) {
      if (urls.length > 1) {
        // If there is more than one BaseURL with this lowest @priority attribute value then the Player
        // shall select one of them at random such that the probability of each BaseURL being chosen
        // is proportional to the value of its @weight attribute. The method described in RFC 2782
        // [26] or picking from a number of weighted entries is suitable for this, but there may be other
        // algorithms which achieve the same effect.
        // add all the weights together, storing the accumulated weight per entry
        urls.forEach(function (baseUrl) {
          totalWeight += baseUrl.dvb_weight;
          cumulWeights.push(totalWeight);
        }); // pick a random number between zero and totalWeight

        rn = Math.floor(Math.random() * (totalWeight - 1)); // select the index for the range rn falls within

        cumulWeights.every(function (limit, index) {
          idx = index;

          if (rn < limit) {
            return false;
          }

          return true;
        });
      }

      return urls[idx];
    }
  }

  function select(baseUrls) {
    return baseUrls && selectByWeight(getNonBlacklistedBaseUrls(baseUrls));
  }

  instance = {
    select: select
  };
  return instance;
}

DVBSelector.__dashjs_factory_name = 'DVBSelector';
/* harmony default export */ __webpack_exports__["default"] = (_core_FactoryMaker__WEBPACK_IMPORTED_MODULE_0__["default"].getClassFactory(DVBSelector));

/***/ }),

/***/ "./src/streaming/vo/BitrateInfo.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/BitrateInfo.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2637372__) {

"use strict";
__nested_webpack_require_2637372__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var BitrateInfo = function BitrateInfo() {
  _classCallCheck(this, BitrateInfo);

  this.mediaType = null;
  this.bitrate = null;
  this.width = null;
  this.height = null;
  this.scanType = null;
  this.qualityIndex = NaN;
};

/* harmony default export */ __webpack_exports__["default"] = (BitrateInfo);

/***/ }),

/***/ "./src/streaming/vo/DashJSError.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/DashJSError.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2640112__) {

"use strict";
__nested_webpack_require_2640112__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DashJSError = function DashJSError(code, message, data) {
  _classCallCheck(this, DashJSError);

  this.code = code || null;
  this.message = message || null;
  this.data = data || null;
};

/* harmony default export */ __webpack_exports__["default"] = (DashJSError);

/***/ }),

/***/ "./src/streaming/vo/DataChunk.js":
/*!***************************************!*\
  !*** ./src/streaming/vo/DataChunk.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2642808__) {

"use strict";
__nested_webpack_require_2642808__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DataChunk = //Represents a data structure that keep all the necessary info about a single init/media segment
function DataChunk() {
  _classCallCheck(this, DataChunk);

  this.streamId = null;
  this.mediaInfo = null;
  this.segmentType = null;
  this.quality = NaN;
  this.index = NaN;
  this.bytes = null;
  this.start = NaN;
  this.end = NaN;
  this.duration = NaN;
  this.representationId = null;
  this.endFragment = null;
};

/* harmony default export */ __webpack_exports__["default"] = (DataChunk);

/***/ }),

/***/ "./src/streaming/vo/FragmentRequest.js":
/*!*********************************************!*\
  !*** ./src/streaming/vo/FragmentRequest.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2645776__) {

"use strict";
__nested_webpack_require_2645776__.r(__webpack_exports__);
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2645776__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */

var FragmentRequest = /*#__PURE__*/function () {
  function FragmentRequest(url) {
    _classCallCheck(this, FragmentRequest);

    this.action = FragmentRequest.ACTION_DOWNLOAD;
    this.startTime = NaN;
    this.mediaStartTime = NaN;
    this.mediaType = null;
    this.mediaInfo = null;
    this.type = null;
    this.duration = NaN;
    this.timescale = NaN;
    this.range = null;
    this.url = url || null;
    this.serviceLocation = null;
    this.requestStartDate = null;
    this.firstByteDate = null;
    this.requestEndDate = null;
    this.quality = NaN;
    this.index = NaN;
    this.availabilityStartTime = null;
    this.availabilityEndTime = null;
    this.wallStartTime = null;
    this.bytesLoaded = NaN;
    this.bytesTotal = NaN;
    this.delayLoadingTime = NaN;
    this.responseType = 'arraybuffer';
    this.representationId = null;
  }

  _createClass(FragmentRequest, [{
    key: "isInitializationRequest",
    value: function isInitializationRequest() {
      return this.type && this.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].INIT_SEGMENT_TYPE;
    }
  }, {
    key: "setInfo",
    value: function setInfo(info) {
      this.type = info && info.init ? _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].INIT_SEGMENT_TYPE : _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].MEDIA_SEGMENT_TYPE;
      this.url = info && info.url ? info.url : null;
      this.range = info && info.range ? info.range.start + '-' + info.range.end : null;
      this.mediaType = info && info.mediaType ? info.mediaType : null;
    }
  }]);

  return FragmentRequest;
}();

FragmentRequest.ACTION_DOWNLOAD = 'download';
FragmentRequest.ACTION_COMPLETE = 'complete';
/* harmony default export */ __webpack_exports__["default"] = (FragmentRequest);

/***/ }),

/***/ "./src/streaming/vo/HeadRequest.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/HeadRequest.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2650795__) {

"use strict";
__nested_webpack_require_2650795__.r(__webpack_exports__);
/* harmony import */ var _FragmentRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2650795__(/*! ./FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */


var HeadRequest = /*#__PURE__*/function (_FragmentRequest) {
  _inherits(HeadRequest, _FragmentRequest);

  var _super = _createSuper(HeadRequest);

  function HeadRequest(url) {
    var _this;

    _classCallCheck(this, HeadRequest);

    _this = _super.call(this, url);
    _this.checkForExistenceOnly = true;
    return _this;
  }

  return HeadRequest;
}(_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (HeadRequest);

/***/ }),

/***/ "./src/streaming/vo/IsoBox.js":
/*!************************************!*\
  !*** ./src/streaming/vo/IsoBox.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2656145__) {

"use strict";
__nested_webpack_require_2656145__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var IsoBox = /*#__PURE__*/function () {
  function IsoBox(boxData) {
    _classCallCheck(this, IsoBox);

    this.offset = boxData._offset;
    this.type = boxData.type;
    this.size = boxData.size;
    this.boxes = [];

    if (boxData.boxes) {
      for (var i = 0; i < boxData.boxes.length; i++) {
        this.boxes.push(new IsoBox(boxData.boxes[i]));
      }
    }

    this.isComplete = true;

    switch (boxData.type) {
      case 'sidx':
        this.timescale = boxData.timescale;
        this.earliest_presentation_time = boxData.earliest_presentation_time;
        this.first_offset = boxData.first_offset;
        this.references = boxData.references;

        if (boxData.references) {
          this.references = [];

          for (var _i = 0; _i < boxData.references.length; _i++) {
            var reference = {
              reference_type: boxData.references[_i].reference_type,
              referenced_size: boxData.references[_i].referenced_size,
              subsegment_duration: boxData.references[_i].subsegment_duration
            };
            this.references.push(reference);
          }
        }

        break;

      case 'emsg':
        this.id = boxData.id;
        this.version = boxData.version === 1 ? 1 : 0;
        this.value = boxData.value;
        this.timescale = boxData.timescale;
        this.scheme_id_uri = boxData.scheme_id_uri;
        this.presentation_time_delta = boxData.version === 1 ? boxData.presentation_time : boxData.presentation_time_delta;
        this.event_duration = boxData.event_duration;
        this.message_data = boxData.message_data;
        break;

      case 'mdhd':
        this.timescale = boxData.timescale;
        break;

      case 'mfhd':
        this.sequence_number = boxData.sequence_number;
        break;

      case 'subs':
        this.entry_count = boxData.entry_count;
        this.entries = boxData.entries;
        break;

      case 'tfhd':
        this.base_data_offset = boxData.base_data_offset;
        this.sample_description_index = boxData.sample_description_index;
        this.default_sample_duration = boxData.default_sample_duration;
        this.default_sample_size = boxData.default_sample_size;
        this.default_sample_flags = boxData.default_sample_flags;
        this.flags = boxData.flags;
        break;

      case 'tfdt':
        this.version = boxData.version;
        this.baseMediaDecodeTime = boxData.baseMediaDecodeTime;
        this.flags = boxData.flags;
        break;

      case 'trun':
        this.sample_count = boxData.sample_count;
        this.first_sample_flags = boxData.first_sample_flags;
        this.data_offset = boxData.data_offset;
        this.flags = boxData.flags;
        this.samples = boxData.samples;

        if (boxData.samples) {
          this.samples = [];

          for (var _i2 = 0, ln = boxData.samples.length; _i2 < ln; _i2++) {
            var sample = {
              sample_size: boxData.samples[_i2].sample_size,
              sample_duration: boxData.samples[_i2].sample_duration,
              sample_composition_time_offset: boxData.samples[_i2].sample_composition_time_offset
            };
            this.samples.push(sample);
          }
        }

        break;
    }
  }

  _createClass(IsoBox, [{
    key: "getChildBox",
    value: function getChildBox(type) {
      for (var i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].type === type) {
          return this.boxes[i];
        }
      }
    }
  }, {
    key: "getChildBoxes",
    value: function getChildBoxes(type) {
      var boxes = [];

      for (var i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].type === type) {
          boxes.push(this.boxes[i]);
        }
      }

      return boxes;
    }
  }]);

  return IsoBox;
}();

/* harmony default export */ __webpack_exports__["default"] = (IsoBox);

/***/ }),

/***/ "./src/streaming/vo/IsoBoxSearchInfo.js":
/*!**********************************************!*\
  !*** ./src/streaming/vo/IsoBoxSearchInfo.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2663128__) {

"use strict";
__nested_webpack_require_2663128__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var IsoBoxSearchInfo = function IsoBoxSearchInfo(lastCompletedOffset, found, size) {
  _classCallCheck(this, IsoBoxSearchInfo);

  this.lastCompletedOffset = lastCompletedOffset;
  this.found = found;
  this.size = size;
};

/* harmony default export */ __webpack_exports__["default"] = (IsoBoxSearchInfo);

/***/ }),

/***/ "./src/streaming/vo/MetricsList.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/MetricsList.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2665867__) {

"use strict";
__nested_webpack_require_2665867__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var MetricsList = function MetricsList() {
  _classCallCheck(this, MetricsList);

  this.TcpList = [];
  this.HttpList = [];
  this.RepSwitchList = [];
  this.BufferLevel = [];
  this.BufferState = [];
  this.PlayList = [];
  this.DroppedFrames = [];
  this.SchedulingInfo = [];
  this.DVRInfo = [];
  this.ManifestUpdate = [];
  this.RequestsQueue = null;
  this.DVBErrors = [];
};

/* harmony default export */ __webpack_exports__["default"] = (MetricsList);

/***/ }),

/***/ "./src/streaming/vo/TextRequest.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/TextRequest.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2668769__) {

"use strict";
__nested_webpack_require_2668769__.r(__webpack_exports__);
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2668769__(/*! ../constants/Constants */ "./src/streaming/constants/Constants.js");
/* harmony import */ var _FragmentRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_2668769__(/*! ./FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */



var TextRequest = /*#__PURE__*/function (_FragmentRequest) {
  _inherits(TextRequest, _FragmentRequest);

  var _super = _createSuper(TextRequest);

  function TextRequest(url, type) {
    var _this;

    _classCallCheck(this, TextRequest);

    _this = _super.call(this);
    _this.url = url || null;
    _this.type = type || null;
    _this.mediaType = _constants_Constants__WEBPACK_IMPORTED_MODULE_0__["default"].STREAM;
    _this.responseType = ''; //'text' value returns a bad encoding response in Firefox

    return _this;
  }

  return TextRequest;
}(_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (TextRequest);

/***/ }),

/***/ "./src/streaming/vo/TextTrackInfo.js":
/*!*******************************************!*\
  !*** ./src/streaming/vo/TextTrackInfo.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2674524__) {

"use strict";
__nested_webpack_require_2674524__.r(__webpack_exports__);
/* harmony import */ var _dash_vo_MediaInfo__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2674524__(/*! ./../../dash/vo/MediaInfo */ "./src/dash/vo/MediaInfo.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */

var TextTrackInfo = /*#__PURE__*/function (_MediaInfo) {
  _inherits(TextTrackInfo, _MediaInfo);

  var _super = _createSuper(TextTrackInfo);

  function TextTrackInfo() {
    var _this;

    _classCallCheck(this, TextTrackInfo);

    _this = _super.call(this);
    _this.captionData = null;
    _this.label = null;
    _this.defaultTrack = false;
    _this.kind = null;
    _this.isFragmented = false;
    _this.isEmbedded = false;
    _this.isTTML = null;
    return _this;
  }

  return TextTrackInfo;
}(_dash_vo_MediaInfo__WEBPACK_IMPORTED_MODULE_0__["default"]);

/* harmony default export */ __webpack_exports__["default"] = (TextTrackInfo);

/***/ }),

/***/ "./src/streaming/vo/Thumbnail.js":
/*!***************************************!*\
  !*** ./src/streaming/vo/Thumbnail.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2680041__) {

"use strict";
__nested_webpack_require_2680041__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var Thumbnail = function Thumbnail() {
  _classCallCheck(this, Thumbnail);

  this.url = null;
  this.width = null;
  this.height = null;
  this.x = null;
  this.y = null;
};

/* harmony default export */ __webpack_exports__["default"] = (Thumbnail);

/***/ }),

/***/ "./src/streaming/vo/ThumbnailTrackInfo.js":
/*!************************************************!*\
  !*** ./src/streaming/vo/ThumbnailTrackInfo.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2682754__) {

"use strict";
__nested_webpack_require_2682754__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var ThumbnailTrackInfo = function ThumbnailTrackInfo() {
  _classCallCheck(this, ThumbnailTrackInfo);

  this.bitrate = 0;
  this.width = 0;
  this.height = 0;
  this.tilesHor = 0;
  this.tilesVert = 0;
  this.widthPerTile = 0;
  this.heightPerTile = 0;
  this.startNumber = 0;
  this.segmentDuration = 0;
  this.timescale = 0;
  this.templateUrl = '';
  this.id = '';
};

/* harmony default export */ __webpack_exports__["default"] = (ThumbnailTrackInfo);

/***/ }),

/***/ "./src/streaming/vo/URIFragmentData.js":
/*!*********************************************!*\
  !*** ./src/streaming/vo/URIFragmentData.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2685668__) {

"use strict";
__nested_webpack_require_2685668__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var URIFragmentData = function URIFragmentData() {
  _classCallCheck(this, URIFragmentData);

  this.t = null;
  this.xywh = null;
  this.track = null;
  this.id = null;
  this.s = null;
  this.r = null;
};

/* harmony default export */ __webpack_exports__["default"] = (URIFragmentData);
/*
    From Spec http://www.w3.org/TR/media-frags/

    temporal (t)     - This dimension denotes a specific time range in the original media, such as "starting at second 10, continuing until second 20";
    spatial  (xywh)  - this dimension denotes a specific range of pixels in the original media, such as "a rectangle with size (100,100) with its top-left at coordinate (10,10)";
                       Media fragments support also addressing the media along two additional dimensions (in the advanced version defined in Media Fragments 1.0 URI (advanced)):
    track    (track) - this dimension denotes one or more tracks in the original media, such as "the english audio and the video track";
    id       (id)    - this dimension denotes a named temporal fragment within the original media, such as "chapter 2", and can be seen as a convenient way of specifying a temporal fragment.


    ## Note
    Akamai is purposing to add #s=X to the ISO standard.
        - (X) Value would be a start time to seek to at startup instead of starting at 0 or live edge
        - Allows for seeking back before the start time unlike a temporal clipping.
*/

/***/ }),

/***/ "./src/streaming/vo/metrics/BufferLevel.js":
/*!*************************************************!*\
  !*** ./src/streaming/vo/metrics/BufferLevel.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2689588__) {

"use strict";
__nested_webpack_require_2689588__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var BufferLevel =
/**
 * @description This Object holds reference to the current buffer level and the time it was recorded.
 */
function BufferLevel() {
  _classCallCheck(this, BufferLevel);

  /**
   * Real-Time | Time of the measurement of the buffer level.
   * @public
   */
  this.t = null;
  /**
   * Level of the buffer in milliseconds. Indicates the playout duration for which
   * media data of all active media components is available starting from the
   * current playout time.
   * @public
   */

  this.level = null;
};

/* harmony default export */ __webpack_exports__["default"] = (BufferLevel);

/***/ }),

/***/ "./src/streaming/vo/metrics/BufferState.js":
/*!*************************************************!*\
  !*** ./src/streaming/vo/metrics/BufferState.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2692678__) {

"use strict";
__nested_webpack_require_2692678__.r(__webpack_exports__);
/* harmony import */ var _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_2692678__(/*! ../../constants/MetricsConstants */ "./src/streaming/constants/MetricsConstants.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */

var BufferState =
/**
 * @description This Object holds reference to the current buffer state of the video element.
 */
function BufferState() {
  _classCallCheck(this, BufferState);

  /**
   * The Buffer Level Target determined by the BufferLevelRule.
   * @public
   */
  this.target = null;
  /**
   * Current buffer state. Will be MetricsConstants.BUFFER_EMPTY or MetricsConstants.BUFFER_LOADED.
   * @public
   */

  this.state = _constants_MetricsConstants__WEBPACK_IMPORTED_MODULE_0__["default"].BUFFER_EMPTY;
};

/* harmony default export */ __webpack_exports__["default"] = (BufferState);

/***/ }),

/***/ "./src/streaming/vo/metrics/DVRInfo.js":
/*!*********************************************!*\
  !*** ./src/streaming/vo/metrics/DVRInfo.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2695934__) {

"use strict";
__nested_webpack_require_2695934__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DVRInfo =
/**
 * @description This Object holds reference to DVR availability window information.
 */
function DVRInfo() {
  _classCallCheck(this, DVRInfo);

  /**
   * The current time of the video element when this was created.
   * @public
   */
  this.time = null;
  /**
   * The current Segment Availability Range as an object with start and end properties.
   * It's delta defined by the timeShiftBufferDepth MPD attribute.
   * @public
   */

  this.range = null;
  /**
   * Reference to the internal ManifestInfo.js VO.
   * @public
   */

  this.manifestInfo = null;
};

/* harmony default export */ __webpack_exports__["default"] = (DVRInfo);

/***/ }),

/***/ "./src/streaming/vo/metrics/DroppedFrames.js":
/*!***************************************************!*\
  !*** ./src/streaming/vo/metrics/DroppedFrames.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2699082__) {

"use strict";
__nested_webpack_require_2699082__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DroppedFrames =
/**
 * @description This Object holds reference to DroppedFrames count and the time it was recorded.
 */
function DroppedFrames() {
  _classCallCheck(this, DroppedFrames);

  /**
   * Real-Time | Time of the measurement of the dropped frames.
   * @public
   */
  this.time = null;
  /**
   * Number of dropped frames
   * @public
   */

  this.droppedFrames = null;
};

/* harmony default export */ __webpack_exports__["default"] = (DroppedFrames);

/***/ }),

/***/ "./src/streaming/vo/metrics/HTTPRequest.js":
/*!*************************************************!*\
  !*** ./src/streaming/vo/metrics/HTTPRequest.js ***!
  \*************************************************/
/*! exports provided: HTTPRequest, HTTPRequestTrace */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2702050__) {

"use strict";
__nested_webpack_require_2702050__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2702050__.d(__webpack_exports__, "HTTPRequest", function() { return HTTPRequest; });
/* harmony export (binding) */ __nested_webpack_require_2702050__.d(__webpack_exports__, "HTTPRequestTrace", function() { return HTTPRequestTrace; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc This Object holds reference to the HTTPRequest for manifest, fragment and xlink loading.
 * Members which are not defined in ISO23009-1 Annex D should be prefixed by a _ so that they are ignored
 * by Metrics Reporting code.
 * @ignore
 */
var HTTPRequest =
/**
 * @class
 */
function HTTPRequest() {
  _classCallCheck(this, HTTPRequest);

  /**
   * Identifier of the TCP connection on which the HTTP request was sent.
   * @public
   */
  this.tcpid = null;
  /**
   * This is an optional parameter and should not be included in HTTP request/response transactions for progressive download.
   * The type of the request:
   * - MPD
   * - XLink expansion
   * - Initialization Fragment
   * - Index Fragment
   * - Media Fragment
   * - Bitstream Switching Fragment
   * - other
   * @public
   */

  this.type = null;
  /**
   * The original URL (before any redirects or failures)
   * @public
   */

  this.url = null;
  /**
   * The actual URL requested, if different from above
   * @public
   */

  this.actualurl = null;
  /**
   * The contents of the byte-range-spec part of the HTTP Range header.
   * @public
   */

  this.range = null;
  /**
   * Real-Time | The real time at which the request was sent.
   * @public
   */

  this.trequest = null;
  /**
   * Real-Time | The real time at which the first byte of the response was received.
   * @public
   */

  this.tresponse = null;
  /**
   * The HTTP response code.
   * @public
   */

  this.responsecode = null;
  /**
   * The duration of the throughput trace intervals (ms), for successful requests only.
   * @public
   */

  this.interval = null;
  /**
   * Throughput traces, for successful requests only.
   * @public
   */

  this.trace = [];
  /**
   * Type of stream ("audio" | "video" etc..)
   * @public
   */

  this._stream = null;
  /**
   * Real-Time | The real time at which the request finished.
   * @public
   */

  this._tfinish = null;
  /**
   * The duration of the media requests, if available, in seconds.
   * @public
   */

  this._mediaduration = null;
  /**
   * The media segment quality
   * @public
   */

  this._quality = null;
  /**
   * all the response headers from request.
   * @public
   */

  this._responseHeaders = null;
  /**
   * The selected service location for the request. string.
   * @public
   */

  this._serviceLocation = null;
  /**
   * The type of the loader that was used. Distinguish between fetch loader and xhr loader
   */

  this._fileLoaderType = null;
};
/**
 * @classdesc This Object holds reference to the progress of the HTTPRequest.
 * @ignore
 */


var HTTPRequestTrace =
/**
 * @class
 */
function HTTPRequestTrace() {
  _classCallCheck(this, HTTPRequestTrace);

  /**
   * Real-Time | Measurement stream start.
   * @public
   */
  this.s = null;
  /**
   * Measurement stream duration (ms).
   * @public
   */

  this.d = null;
  /**
   * List of integers counting the bytes received in each trace interval within the measurement stream.
   * @public
   */

  this.b = [];
  /**
   * Measurement throughput in kbits/s
   * @public
   */

  this._t = null;
};

HTTPRequest.GET = 'GET';
HTTPRequest.HEAD = 'HEAD';
HTTPRequest.MPD_TYPE = 'MPD';
HTTPRequest.XLINK_EXPANSION_TYPE = 'XLinkExpansion';
HTTPRequest.INIT_SEGMENT_TYPE = 'InitializationSegment';
HTTPRequest.INDEX_SEGMENT_TYPE = 'IndexSegment';
HTTPRequest.MEDIA_SEGMENT_TYPE = 'MediaSegment';
HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE = 'BitstreamSwitchingSegment';
HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE = 'FragmentInfoSegment';
HTTPRequest.DVB_REPORTING_TYPE = 'DVBReporting';
HTTPRequest.LICENSE = 'license';
HTTPRequest.OTHER_TYPE = 'other';


/***/ }),

/***/ "./src/streaming/vo/metrics/ManifestUpdate.js":
/*!****************************************************!*\
  !*** ./src/streaming/vo/metrics/ManifestUpdate.js ***!
  \****************************************************/
/*! exports provided: ManifestUpdate, ManifestUpdateStreamInfo, ManifestUpdateRepresentationInfo */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2708654__) {

"use strict";
__nested_webpack_require_2708654__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2708654__.d(__webpack_exports__, "ManifestUpdate", function() { return ManifestUpdate; });
/* harmony export (binding) */ __nested_webpack_require_2708654__.d(__webpack_exports__, "ManifestUpdateStreamInfo", function() { return ManifestUpdateStreamInfo; });
/* harmony export (binding) */ __nested_webpack_require_2708654__.d(__webpack_exports__, "ManifestUpdateRepresentationInfo", function() { return ManifestUpdateRepresentationInfo; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc This Object holds reference to the manifest update information.
 * @ignore
 */
var ManifestUpdate =
/**
 * @class
 */
function ManifestUpdate() {
  _classCallCheck(this, ManifestUpdate);

  /**
   * Media Type Video | Audio | FragmentedText
   * @public
   */
  this.mediaType = null;
  /**
   * MPD Type static | dynamic
   * @public
   */

  this.type = null;
  /**
   * When this manifest update was requested
   * @public
   */

  this.requestTime = null;
  /**
   * When this manifest update was received
   * @public
   */

  this.fetchTime = null;
  /**
   * Calculated Availability Start time of the stream.
   * @public
   */

  this.availabilityStartTime = null;
  /**
   * the seek point (liveEdge for dynamic, Stream[0].startTime for static)
   * @public
   */

  this.presentationStartTime = 0;
  /**
   * The calculated difference between the server and client wall clock time
   * @public
   */

  this.clientTimeOffset = 0;
  /**
   * Actual element.currentTime
   * @public
   */

  this.currentTime = null;
  /**
   * Actual element.ranges
   * @public
   */

  this.buffered = null;
  /**
   * Static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - elementCurrentTime)
   * @public
   */

  this.latency = 0;
  /**
   * Array holding list of StreamInfo VO Objects
   * @public
   */

  this.streamInfo = [];
  /**
   * Array holding list of RepresentationInfo VO Objects
   * @public
   */

  this.representationInfo = [];
};
/**
 * @classdesc This Object holds reference to the current period's stream information when the manifest was updated.
 * @ignore
 */


var ManifestUpdateStreamInfo =
/**
 * @class
 */
function ManifestUpdateStreamInfo() {
  _classCallCheck(this, ManifestUpdateStreamInfo);

  /**
   * Stream@id
   * @public
   */
  this.id = null;
  /**
   * Period Index
   * @public
   */

  this.index = null;
  /**
   * Stream@start
   * @public
   */

  this.start = null;
  /**
   * Stream@duration
   * @public
   */

  this.duration = null;
};
/**
 * @classdesc This Object holds reference to the current representation's info when the manifest was updated.
 * @ignore
 */


var ManifestUpdateRepresentationInfo =
/**
 * @class
 */
function ManifestUpdateRepresentationInfo() {
  _classCallCheck(this, ManifestUpdateRepresentationInfo);

  /**
   * Track@id
   * @public
   */
  this.id = null;
  /**
   * Representation Index
   * @public
   */

  this.index = null;
  /**
   * Media Type Video | Audio | FragmentedText
   * @public
   */

  this.mediaType = null;
  /**
   * Which representation
   * @public
   */

  this.streamIndex = null;
  /**
   * Holds reference to @presentationTimeOffset
   * @public
   */

  this.presentationTimeOffset = null;
  /**
   * Holds reference to @startNumber
   * @public
   */

  this.startNumber = null;
  /**
   * list|template|timeline
   * @public
   */

  this.fragmentInfoType = null;
};



/***/ }),

/***/ "./src/streaming/vo/metrics/PlayList.js":
/*!**********************************************!*\
  !*** ./src/streaming/vo/metrics/PlayList.js ***!
  \**********************************************/
/*! exports provided: PlayList, PlayListTrace */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2714633__) {

"use strict";
__nested_webpack_require_2714633__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_2714633__.d(__webpack_exports__, "PlayList", function() { return PlayList; });
/* harmony export (binding) */ __nested_webpack_require_2714633__.d(__webpack_exports__, "PlayListTrace", function() { return PlayListTrace; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc a PlayList from ISO23009-1 Annex D, this Object holds reference to the playback session information
 * @ignore
 */
var PlayList =
/**
 * @class
 */
function PlayList() {
  _classCallCheck(this, PlayList);

  /**
   * Timestamp of the user action that starts the playback stream...
   * @public
   */
  this.start = null;
  /**
   * Presentation time at which playout was requested by the user...
   * @public
   */

  this.mstart = null;
  /**
   * Type of user action which triggered playout
   * - New playout request (e.g. initial playout or seeking)
   * - Resume from pause
   * - Other user request (e.g. user-requested quality change)
   * - Start of a metrics collection stream (hence earlier entries in the play list not collected)
   * @public
   */

  this.starttype = null;
  /**
   * List of streams of continuous rendering of decoded samples.
   * @public
   */

  this.trace = [];
};
/* Public Static Constants */


PlayList.INITIAL_PLAYOUT_START_REASON = 'initial_playout';
PlayList.SEEK_START_REASON = 'seek';
PlayList.RESUME_FROM_PAUSE_START_REASON = 'resume';
PlayList.METRICS_COLLECTION_START_REASON = 'metrics_collection_start';
/**
 * @classdesc a PlayList.Trace from ISO23009-1 Annex D
 * @ignore
 */

var PlayListTrace =
/**
 * @class
 */
function PlayListTrace() {
  _classCallCheck(this, PlayListTrace);

  /**
   * The value of the Representation@id of the Representation from which the samples were taken.
   * @type {string}
   * @public
   */
  this.representationid = null;
  /**
   * If not present, this metrics concerns the Representation as a whole.
   * If present, subreplevel indicates the greatest value of any
   * Subrepresentation@level being rendered.
   * @type {number}
   * @public
   */

  this.subreplevel = null;
  /**
   * The time at which the first sample was rendered
   * @type {number}
   * @public
   */

  this.start = null;
  /**
   * The presentation time of the first sample rendered.
   * @type {number}
   * @public
   */

  this.mstart = null;
  /**
   * The duration of the continuously presented samples (which is the same in real time and media time). "Continuously presented" means that the media clock continued to advance at the playout speed throughout the interval. NOTE: the spec does not call out the units, but all other durations etc are in ms, and we use ms too.
   * @type {number}
   * @public
   */

  this.duration = null;
  /**
   * The playback speed relative to normal playback speed (i.e.normal forward playback speed is 1.0).
   * @type {number}
   * @public
   */

  this.playbackspeed = null;
  /**
   * The reason why continuous presentation of this Representation was stopped.
   * representation switch
   * rebuffering
   * user request
   * end of Period
   * end of Stream
   * end of content
   * end of a metrics collection period
   *
   * @type {string}
   * @public
   */

  this.stopreason = null;
};

PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON = 'representation_switch';
PlayListTrace.REBUFFERING_REASON = 'rebuffering';
PlayListTrace.USER_REQUEST_STOP_REASON = 'user_request';
PlayListTrace.END_OF_PERIOD_STOP_REASON = 'end_of_period';
PlayListTrace.END_OF_CONTENT_STOP_REASON = 'end_of_content';
PlayListTrace.METRICS_COLLECTION_STOP_REASON = 'metrics_collection_end';
PlayListTrace.FAILURE_STOP_REASON = 'failure';


/***/ }),

/***/ "./src/streaming/vo/metrics/RepresentationSwitch.js":
/*!**********************************************************!*\
  !*** ./src/streaming/vo/metrics/RepresentationSwitch.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2720811__) {

"use strict";
__nested_webpack_require_2720811__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var RepresentationSwitch =
/**
 * @description This Object holds reference to the info at quality switch between two representations.
 */
function RepresentationSwitch() {
  _classCallCheck(this, RepresentationSwitch);

  /**
   * Time of the switch event.
   * @public
   */
  this.t = null;
  /**
   * The media presentation time of the earliest access unit
   * (out of all media content components) played out from
   * the Representation.
   *
   * @public
   */

  this.mt = null;
  /**
   * Value of Representation@id identifying the switch-to Representation.
   * @public
   */

  this.to = null;
  /**
   * If not present, this metrics concerns the Representation as a whole.
   * If present, lto indicates the value of SubRepresentation@level within
   * Representation identifying the switch-to level of the Representation.
   *
   * @public
   */

  this.lto = null;
};

/* harmony default export */ __webpack_exports__["default"] = (RepresentationSwitch);

/***/ }),

/***/ "./src/streaming/vo/metrics/RequestsQueue.js":
/*!***************************************************!*\
  !*** ./src/streaming/vo/metrics/RequestsQueue.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2724282__) {

"use strict";
__nested_webpack_require_2724282__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var RequestsQueue =
/**
 * @description This Object holds reference to Fragment Model's request queues
 */
function RequestsQueue() {
  _classCallCheck(this, RequestsQueue);

  /**
   * Array of all of the requests that have begun to load
   * This request may not make it into the executed queue if it is abandon due to ABR rules for example.
   * @public
   */
  this.loadingRequests = [];
  /**
   * Array of the The requests that have completed
   * @public
   */

  this.executedRequests = [];
};

/* harmony default export */ __webpack_exports__["default"] = (RequestsQueue);

/***/ }),

/***/ "./src/streaming/vo/metrics/SchedulingInfo.js":
/*!****************************************************!*\
  !*** ./src/streaming/vo/metrics/SchedulingInfo.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_2727353__) {

"use strict";
__nested_webpack_require_2727353__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var SchedulingInfo =
/**
 * @description This Object holds reference to the index handling of the current fragment being loaded or executed.
 */
function SchedulingInfo() {
  _classCallCheck(this, SchedulingInfo);

  /**
   * Type of stream Audio | Video | FragmentedText
   * @public
   */
  this.mediaType = null;
  /**
   * Time of the scheduling event.
   * @public
   */

  this.t = null;
  /**
   * Type of fragment (initialization | media)
   * @public
   */

  this.type = null;
  /**
   * Presentation start time of fragment
   * @public
   */

  this.startTime = null;
  /**
   * Availability start time of fragment
   * @public
   */

  this.availabilityStartTime = null;
  /**
   * Duration of fragment
   * @public
   */

  this.duration = null;
  /**
   * Bit Rate Quality of fragment
   * @public
   */

  this.quality = null;
  /**
   * Range of fragment
   * @public
   */

  this.range = null;
  /**
   * Current state of fragment
   * @public
   */

  this.state = null;
};

/* harmony default export */ __webpack_exports__["default"] = (SchedulingInfo);

/***/ }),

/***/ 0:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ })["default"];
});
//# sourceMappingURL=dash.all.debug.js.map

/***/ }),

/***/ 46:
/***/ ((module) => {

!function(e,t){ true?module.exports=t():0}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(r,i,function(t){return e[t]}.bind(null,i));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="/dist/",n(n.s=108)}([function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.init()}var t,n,i;return t=e,(n=[{key:"init",value:function(){this.BASE_URL="BaseURL",this.SEGMENT_BASE="SegmentBase",this.SEGMENT_TEMPLATE="SegmentTemplate",this.SEGMENT_LIST="SegmentList",this.SEGMENT_URL="SegmentURL",this.SEGMENT_TIMELINE="SegmentTimeline",this.SEGMENT_PROFILES="segmentProfiles",this.ADAPTATION_SET="AdaptationSet",this.REPRESENTATION="Representation",this.REPRESENTATION_INDEX="RepresentationIndex",this.SUB_REPRESENTATION="SubRepresentation",this.INITIALIZATION="Initialization",this.INITIALIZATION_MINUS="initialization",this.MPD="MPD",this.PERIOD="Period",this.ASSET_IDENTIFIER="AssetIdentifier",this.EVENT_STREAM="EventStream",this.ID="id",this.PROFILES="profiles",this.SERVICE_LOCATION="serviceLocation",this.RANGE="range",this.INDEX="index",this.MEDIA="media",this.BYTE_RANGE="byteRange",this.INDEX_RANGE="indexRange",this.MEDIA_RANGE="mediaRange",this.VALUE="value",this.CONTENT_TYPE="contentType",this.MIME_TYPE="mimeType",this.BITSTREAM_SWITCHING="BitstreamSwitching",this.BITSTREAM_SWITCHING_MINUS="bitstreamSwitching",this.CODECS="codecs",this.DEPENDENCY_ID="dependencyId",this.MEDIA_STREAM_STRUCTURE_ID="mediaStreamStructureId",this.METRICS="Metrics",this.METRICS_MINUS="metrics",this.REPORTING="Reporting",this.WIDTH="width",this.HEIGHT="height",this.SAR="sar",this.FRAMERATE="frameRate",this.AUDIO_SAMPLING_RATE="audioSamplingRate",this.MAXIMUM_SAP_PERIOD="maximumSAPPeriod",this.START_WITH_SAP="startWithSAP",this.MAX_PLAYOUT_RATE="maxPlayoutRate",this.CODING_DEPENDENCY="codingDependency",this.SCAN_TYPE="scanType",this.FRAME_PACKING="FramePacking",this.AUDIO_CHANNEL_CONFIGURATION="AudioChannelConfiguration",this.CONTENT_PROTECTION="ContentProtection",this.ESSENTIAL_PROPERTY="EssentialProperty",this.SUPPLEMENTAL_PROPERTY="SupplementalProperty",this.INBAND_EVENT_STREAM="InbandEventStream",this.PRODUCER_REFERENCE_TIME="ProducerReferenceTime",this.ACCESSIBILITY="Accessibility",this.ROLE="Role",this.RATING="Rating",this.CONTENT_COMPONENT="ContentComponent",this.SUBSET="Subset",this.LANG="lang",this.VIEWPOINT="Viewpoint",this.ROLE_ASARRAY="Role_asArray",this.REPRESENTATION_ASARRAY="Representation_asArray",this.PRODUCERREFERENCETIME_ASARRAY="ProducerReferenceTime_asArray",this.ACCESSIBILITY_ASARRAY="Accessibility_asArray",this.AUDIOCHANNELCONFIGURATION_ASARRAY="AudioChannelConfiguration_asArray",this.CONTENTPROTECTION_ASARRAY="ContentProtection_asArray",this.MAIN="main",this.DYNAMIC="dynamic",this.STATIC="static",this.MEDIA_PRESENTATION_DURATION="mediaPresentationDuration",this.MINIMUM_UPDATE_PERIOD="minimumUpdatePeriod",this.CODEC_PRIVATE_DATA="codecPrivateData",this.BANDWITH="bandwidth",this.SOURCE_URL="sourceURL",this.TIMESCALE="timescale",this.DURATION="duration",this.START_NUMBER="startNumber",this.PRESENTATION_TIME_OFFSET="presentationTimeOffset",this.AVAILABILITY_START_TIME="availabilityStartTime",this.AVAILABILITY_END_TIME="availabilityEndTime",this.TIMESHIFT_BUFFER_DEPTH="timeShiftBufferDepth",this.MAX_SEGMENT_DURATION="maxSegmentDuration",this.PRESENTATION_TIME="presentationTime",this.MIN_BUFFER_TIME="minBufferTime",this.MAX_SUBSEGMENT_DURATION="maxSubsegmentDuration",this.START="start",this.AVAILABILITY_TIME_OFFSET="availabilityTimeOffset",this.AVAILABILITY_TIME_COMPLETE="availabilityTimeComplete",this.CENC_DEFAULT_KID="cenc:default_KID",this.DVB_PRIORITY="dvb:priority",this.DVB_WEIGHT="dvb:weight",this.SUGGESTED_PRESENTATION_DELAY="suggestedPresentationDelay",this.SERVICE_DESCRIPTION="ServiceDescription",this.SERVICE_DESCRIPTION_SCOPE="Scope",this.SERVICE_DESCRIPTION_LATENCY="Latency",this.SERVICE_DESCRIPTION_PLAYBACK_RATE="PlaybackRate",this.SERVICE_DESCRIPTION_OPERATING_QUALITY="OperatingQuality",this.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH="OperatingBandwidth",this.PATCH_LOCATION="PatchLocation",this.PUBLISH_TIME="publishTime",this.ORIGINAL_PUBLISH_TIME="originalPublishTime",this.ORIGINAL_MPD_ID="mpdId",this.WALL_CLOCK_TIME="wallClockTime",this.PRESENTATION_TIME="presentationTime"}}])&&r(t.prototype,n),i&&r(t,i),e}());t.a=i},function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.init()}var t,n,i;return t=e,(n=[{key:"init",value:function(){this.STREAM="stream",this.VIDEO="video",this.AUDIO="audio",this.TEXT="text",this.MUXED="muxed",this.IMAGE="image",this.STPP="stpp",this.TTML="ttml",this.VTT="vtt",this.WVTT="wvtt",this.ABR_STRATEGY_DYNAMIC="abrDynamic",this.ABR_STRATEGY_BOLA="abrBola",this.ABR_STRATEGY_L2A="abrL2A",this.ABR_STRATEGY_LoLP="abrLoLP",this.ABR_STRATEGY_THROUGHPUT="abrThroughput",this.ABR_FETCH_THROUGHPUT_CALCULATION_DOWNLOADED_DATA="abrFetchThroughputCalculationDownloadedData",this.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING="abrFetchThroughputCalculationMoofParsing",this.ABR_FETCH_THROUGHPUT_CALCULATION_AAST="abrFetchThroughputCalculationAAST",this.LIVE_CATCHUP_MODE_DEFAULT="liveCatchupModeDefault",this.LIVE_CATCHUP_MODE_LOLP="liveCatchupModeLoLP",this.MOVING_AVERAGE_SLIDING_WINDOW="slidingWindow",this.MOVING_AVERAGE_EWMA="ewma",this.BAD_ARGUMENT_ERROR="Invalid Arguments",this.MISSING_CONFIG_ERROR="Missing config parameter(s)",this.TRACK_SWITCH_MODE_ALWAYS_REPLACE="alwaysReplace",this.TRACK_SWITCH_MODE_NEVER_REPLACE="neverReplace",this.TRACK_SELECTION_MODE_FIRST_TRACK="firstTrack",this.TRACK_SELECTION_MODE_HIGHEST_BITRATE="highestBitrate",this.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY="highestEfficiency",this.TRACK_SELECTION_MODE_WIDEST_RANGE="widestRange",this.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY="highestSelectionPriority",this.CMCD_MODE_QUERY="query",this.CMCD_MODE_HEADER="header",this.LOCATION="Location",this.INITIALIZE="initialize",this.TEXT_SHOWING="showing",this.TEXT_HIDDEN="hidden",this.CC1="CC1",this.CC3="CC3",this.UTF8="utf-8",this.SCHEME_ID_URI="schemeIdUri",this.START_TIME="starttime",this.SERVICE_DESCRIPTION_DVB_LL_SCHEME="urn:dvb:dash:lowlatency:scope:2019",this.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME="urn:dvb:dash:lowlatency:critical:2019",this.XML="XML",this.ARRAY_BUFFER="ArrayBuffer",this.DVB_REPORTING_URL="dvb:reportingUrl",this.DVB_PROBABILITY="dvb:probability",this.VIDEO_ELEMENT_READY_STATES={HAVE_NOTHING:0,HAVE_METADATA:1,HAVE_CURRENT_DATA:2,HAVE_FUTURE_DATA:3,HAVE_ENOUGH_DATA:4},this.FILE_LOADER_TYPES={FETCH:"fetch_loader",XHR:"xhr_loader"}}}])&&r(t.prototype,n),i&&r(t,i),e}());t.a=i},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){return(i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function a(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var i=s(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return o(this,n)}}function o(e,t){return!t||"object"!==r(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function s(e){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function f(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=h(e);if(t){var i=h(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return d(this,n)}}function d(e,t){return!t||"object"!==u(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function h(e){return(h=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var p=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&c(e,t)}(n,e);var t=f(n);function n(){return l(this,n),t.apply(this,arguments)}return n}(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&i(e,t)}(n,e);var t=a(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).ATTEMPT_BACKGROUND_SYNC="attemptBackgroundSync",e.BUFFERING_COMPLETED="bufferingCompleted",e.BUFFER_CLEARED="bufferCleared",e.BYTES_APPENDED_END_FRAGMENT="bytesAppendedEndFragment",e.BUFFER_REPLACEMENT_STARTED="bufferReplacementStarted",e.CHECK_FOR_EXISTENCE_COMPLETED="checkForExistenceCompleted",e.CURRENT_TRACK_CHANGED="currentTrackChanged",e.DATA_UPDATE_COMPLETED="dataUpdateCompleted",e.INBAND_EVENTS="inbandEvents",e.INITIAL_STREAM_SWITCH="initialStreamSwitch",e.INIT_FRAGMENT_LOADED="initFragmentLoaded",e.INIT_FRAGMENT_NEEDED="initFragmentNeeded",e.INTERNAL_MANIFEST_LOADED="internalManifestLoaded",e.ORIGINAL_MANIFEST_LOADED="originalManifestLoaded",e.LOADING_COMPLETED="loadingCompleted",e.LOADING_PROGRESS="loadingProgress",e.LOADING_DATA_PROGRESS="loadingDataProgress",e.LOADING_ABANDONED="loadingAborted",e.MANIFEST_UPDATED="manifestUpdated",e.MEDIA_FRAGMENT_LOADED="mediaFragmentLoaded",e.MEDIA_FRAGMENT_NEEDED="mediaFragmentNeeded",e.QUOTA_EXCEEDED="quotaExceeded",e.SEGMENT_LOCATION_BLACKLIST_ADD="segmentLocationBlacklistAdd",e.SEGMENT_LOCATION_BLACKLIST_CHANGED="segmentLocationBlacklistChanged",e.SERVICE_LOCATION_BLACKLIST_ADD="serviceLocationBlacklistAdd",e.SERVICE_LOCATION_BLACKLIST_CHANGED="serviceLocationBlacklistChanged",e.SET_FRAGMENTED_TEXT_AFTER_DISABLED="setFragmentedTextAfterDisabled",e.SET_NON_FRAGMENTED_TEXT="setNonFragmentedText",e.SOURCE_BUFFER_ERROR="sourceBufferError",e.STREAMS_COMPOSED="streamsComposed",e.STREAM_BUFFERING_COMPLETED="streamBufferingCompleted",e.STREAM_REQUESTING_COMPLETED="streamRequestingCompleted",e.TEXT_TRACKS_QUEUE_INITIALIZED="textTracksQueueInitialized",e.TIME_SYNCHRONIZATION_COMPLETED="timeSynchronizationComplete",e.UPDATE_TIME_SYNC_OFFSET="updateTimeSyncOffset",e.URL_RESOLUTION_FAILED="urlResolutionFailed",e.VIDEO_CHUNK_RECEIVED="videoChunkReceived",e.WALLCLOCK_TIME_UPDATED="wallclockTimeUpdated",e.XLINK_ELEMENT_LOADED="xlinkElementLoaded",e.XLINK_READY="xlinkReady",e.SEEK_TARGET="seekTarget",e.SETTING_UPDATED_LIVE_DELAY="settingUpdatedLiveDelay",e.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT="settingUpdatedLiveDelayFragmentCount",e.SETTING_UPDATED_CATCHUP_ENABLED="settingUpdatedCatchupEnabled",e}return n}(n(18).a)));t.a=p},function(e,t,n){"use strict";var r=function(){var e,t=[],n={},r={};function i(e,n){for(var r in t){var i=t[r];if(i.context===e&&i.name===n)return i.instance}return null}function a(e,t){return t[e]}function o(e,t,n){e in n&&(n[e]=t)}function s(t,n,r){var i,a=t.__dashjs_factory_name,o=n[a];if(o){var s=o.instance;if(!o.override)return s.apply({context:n,factory:e},r);for(var u in i=t.apply({context:n},r),s=s.apply({context:n,factory:e,parent:i},r))i.hasOwnProperty(u)&&(i[u]=s[u])}else i=t.apply({context:n},r);return i.getClassName=function(){return a},i}return e={extend:function(e,t,n,r){!r[e]&&t&&(r[e]={instance:t,override:n})},getSingletonInstance:i,setSingletonInstance:function(e,n,r){for(var i in t){var a=t[i];if(a.context===e&&a.name===n)return void(t[i].instance=r)}t.push({name:n,context:e,instance:r})},deleteSingletonInstances:function(e){t=t.filter((function(t){return t.context!==e}))},getSingletonFactory:function(e){var r=a(e.__dashjs_factory_name,n);return r||(r=function(n){var r;return void 0===n&&(n={}),{getInstance:function(){return r||(r=i(n,e.__dashjs_factory_name)),r||(r=s(e,n,arguments),t.push({name:e.__dashjs_factory_name,context:n,instance:r})),r}}},n[e.__dashjs_factory_name]=r),r},getSingletonFactoryByName:function(e){return a(e,n)},updateSingletonFactory:function(e,t){o(e,t,n)},getClassFactory:function(e){var t=a(e.__dashjs_factory_name,r);return t||(t=function(t){return void 0===t&&(t={}),{create:function(){return s(e,t,arguments)}}},r[e.__dashjs_factory_name]=t),t},getClassFactoryByName:function(e){return a(e,r)},updateClassFactory:function(e,t){o(e,t,r)}}}();t.a=r},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){return(i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function a(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var i=s(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return o(this,n)}}function o(e,t){return!t||"object"!==r(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function s(e){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var u=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&i(e,t)}(n,e);var t=a(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).AST_IN_FUTURE="astInFuture",e.BUFFER_EMPTY="bufferStalled",e.BUFFER_LOADED="bufferLoaded",e.BUFFER_LEVEL_STATE_CHANGED="bufferStateChanged",e.BUFFER_LEVEL_UPDATED="bufferLevelUpdated",e.DYNAMIC_TO_STATIC="dynamicToStatic",e.ERROR="error",e.FRAGMENT_LOADING_COMPLETED="fragmentLoadingCompleted",e.FRAGMENT_LOADING_PROGRESS="fragmentLoadingProgress",e.FRAGMENT_LOADING_STARTED="fragmentLoadingStarted",e.FRAGMENT_LOADING_ABANDONED="fragmentLoadingAbandoned",e.LOG="log",e.MANIFEST_LOADED="manifestLoaded",e.METRICS_CHANGED="metricsChanged",e.METRIC_CHANGED="metricChanged",e.METRIC_ADDED="metricAdded",e.METRIC_UPDATED="metricUpdated",e.PERIOD_SWITCH_STARTED="periodSwitchStarted",e.PERIOD_SWITCH_COMPLETED="periodSwitchCompleted",e.QUALITY_CHANGE_REQUESTED="qualityChangeRequested",e.QUALITY_CHANGE_RENDERED="qualityChangeRendered",e.TRACK_CHANGE_RENDERED="trackChangeRendered",e.STREAM_INITIALIZING="streamInitializing",e.STREAM_UPDATED="streamUpdated",e.STREAM_ACTIVATED="streamActivated",e.STREAM_DEACTIVATED="streamDeactivated",e.STREAM_INITIALIZED="streamInitialized",e.STREAM_TEARDOWN_COMPLETE="streamTeardownComplete",e.TEXT_TRACKS_ADDED="allTextTracksAdded",e.TEXT_TRACK_ADDED="textTrackAdded",e.TTML_PARSED="ttmlParsed",e.TTML_TO_PARSE="ttmlToParse",e.CAPTION_RENDERED="captionRendered",e.CAPTION_CONTAINER_RESIZE="captionContainerResize",e.CAN_PLAY="canPlay",e.CAN_PLAY_THROUGH="canPlayThrough",e.PLAYBACK_ENDED="playbackEnded",e.PLAYBACK_ERROR="playbackError",e.PLAYBACK_NOT_ALLOWED="playbackNotAllowed",e.PLAYBACK_METADATA_LOADED="playbackMetaDataLoaded",e.PLAYBACK_LOADED_DATA="playbackLoadedData",e.PLAYBACK_PAUSED="playbackPaused",e.PLAYBACK_PLAYING="playbackPlaying",e.PLAYBACK_PROGRESS="playbackProgress",e.PLAYBACK_RATE_CHANGED="playbackRateChanged",e.PLAYBACK_SEEKED="playbackSeeked",e.PLAYBACK_SEEKING="playbackSeeking",e.PLAYBACK_STALLED="playbackStalled",e.PLAYBACK_STARTED="playbackStarted",e.PLAYBACK_TIME_UPDATED="playbackTimeUpdated",e.PLAYBACK_WAITING="playbackWaiting",e.MANIFEST_VALIDITY_CHANGED="manifestValidityChanged",e.EVENT_MODE_ON_START="eventModeOnStart",e.EVENT_MODE_ON_RECEIVE="eventModeOnReceive",e.CONFORMANCE_VIOLATION="conformanceViolation",e.REPRESENTATION_SWITCH="representationSwitch",e.ADAPTATION_SET_REMOVED_NO_CAPABILITIES="adaptationSetRemovedNoCapabilities",e}return n}(n(18).a));t.a=u},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return a}));var i=function e(){r(this,e),this.tcpid=null,this.type=null,this.url=null,this.actualurl=null,this.range=null,this.trequest=null,this.tresponse=null,this.responsecode=null,this.interval=null,this.trace=[],this._stream=null,this._tfinish=null,this._mediaduration=null,this._quality=null,this._responseHeaders=null,this._serviceLocation=null,this._fileLoaderType=null},a=function e(){r(this,e),this.s=null,this.d=null,this.b=[],this._t=null};i.GET="GET",i.HEAD="HEAD",i.MPD_TYPE="MPD",i.XLINK_EXPANSION_TYPE="XLinkExpansion",i.INIT_SEGMENT_TYPE="InitializationSegment",i.INDEX_SEGMENT_TYPE="IndexSegment",i.MEDIA_SEGMENT_TYPE="MediaSegment",i.BITSTREAM_SWITCHING_SEGMENT_TYPE="BitstreamSwitchingSegment",i.MSS_FRAGMENT_INFO_SEGMENT_TYPE="FragmentInfoSegment",i.DVB_REPORTING_TYPE="DVBReporting",i.LICENSE="license",i.OTHER_TYPE="other"},function(e,t,n){"use strict";var r=n(7),i=n(2),a=n(3),o=1,s=2,u=3,l=4,c=5;function f(e){e=e||{};var t,n,a,f,d=this.context,h=Object(r.a)(d).getInstance(),p=e.settings,g=[];function m(e){return e&&e.bind?e.bind(window.console):window.console.log.bind(window.console)}function y(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];S.apply(void 0,[o,this].concat(t))}function E(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];S.apply(void 0,[s,this].concat(t))}function _(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];S.apply(void 0,[u,this].concat(t))}function T(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];S.apply(void 0,[l,this].concat(t))}function v(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];S.apply(void 0,[c,this].concat(t))}function S(e,t){var r="",o=null;n&&(o=(new Date).getTime(),r+="["+(o-f)+"]"),a&&t&&t.getClassName&&(r+="["+t.getClassName()+"]",t.getType&&(r+="["+t.getType()+"]")),r.length>0&&(r+=" ");for(var s=arguments.length,u=new Array(s>2?s-2:0),l=2;l<s;l++)u[l-2]=arguments[l];Array.apply(null,u).forEach((function(e){r+=e+" "})),g[e]&&p.get().debug.logLevel>=e&&g[e](r),p&&p.get().debug.dispatchEvent&&h.trigger(i.a.LOG,{message:r,level:e})}return t={getLogger:function(e){return{fatal:y.bind(e),error:E.bind(e),warn:_.bind(e),info:T.bind(e),debug:v.bind(e)}},setLogTimestampVisible:function(e){n=e},setCalleeNameVisible:function(e){a=e}},n=!0,a=!0,f=(new Date).getTime(),"undefined"!=typeof window&&window.console&&(g[o]=m(window.console.error),g[s]=m(window.console.error),g[u]=m(window.console.warn),g[l]=m(window.console.info),g[c]=m(window.console.debug)),t}f.__dashjs_factory_name="Debug";var d=a.a.getSingletonFactory(f);d.LOG_LEVEL_NONE=0,d.LOG_LEVEL_FATAL=o,d.LOG_LEVEL_ERROR=s,d.LOG_LEVEL_WARNING=u,d.LOG_LEVEL_INFO=l,d.LOG_LEVEL_DEBUG=c,a.a.updateSingletonFactory(f.__dashjs_factory_name,d),t.a=d},function(e,t,n){"use strict";var r=n(3),i=n(4);function a(){var e={};function t(t,n,r){var i=-1;return e[t]?(e[t].some((function(e,t){if(e&&e.callback===n&&(!r||r===e.scope))return i=t,!0})),i):i}return{on:function(n,r,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(!n)throw new Error("event type cannot be null or undefined");if(!r||"function"!=typeof r)throw new Error("listener must be a function: "+r);var o=a.priority||0;if(!(t(n,r,i)>=0)){e[n]=e[n]||[];var s={callback:r,scope:i,priority:o};i&&i.getStreamId&&(s.streamId=i.getStreamId()),i&&i.getType&&(s.mediaType=i.getType()),a&&a.mode&&(s.mode=a.mode);var u=e[n].some((function(t,r){if(t&&o>t.priority)return e[n].splice(r,0,s),!0}));u||e[n].push(s)}},off:function(n,r,i){if(n&&r&&e[n]){var a=t(n,r,i);a<0||(e[n][a]=null)}},trigger:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(t&&e[t]){if((n=n||{}).hasOwnProperty("type"))throw new Error("'type' is a reserved word for event dispatching");n.type=t,r.streamId&&(n.streamId=r.streamId),r.mediaType&&(n.mediaType=r.mediaType),e[t].filter((function(e){return!!e&&((!r.streamId||!e.streamId||e.streamId===r.streamId)&&((!r.mediaType||!e.mediaType||e.mediaType===r.mediaType)&&!(r.mode&&e.mode&&e.mode!==r.mode||!e.mode&&r.mode&&r.mode===i.a.EVENT_MODE_ON_RECEIVE)))})).forEach((function(e){return e&&e.callback.call(e.scope,n)}))}},reset:function(){e={}}}}a.__dashjs_factory_name="EventBus";var o=r.a.getSingletonFactory(a);o.EVENT_PRIORITY_LOW=0,o.EVENT_PRIORITY_HIGH=5e3,r.a.updateSingletonFactory(a.__dashjs_factory_name,o),t.a=o},function(e,t,n){"use strict";var r=n(3),i={DEFAULT:.5,STRONG:1,WEAK:0};function a(e,t,n){return{quality:void 0===e?-1:e,reason:void 0===t?null:t,priority:function(e){var t=i.DEFAULT;return e!==i.DEFAULT&&e!==i.STRONG&&e!==i.WEAK||(t=e),t}(n)}}a.__dashjs_factory_name="SwitchRequest";var o=r.a.getClassFactory(a);o.NO_CHANGE=-1,o.PRIORITY=i,r.a.updateClassFactory(a.__dashjs_factory_name,o),t.a=o},function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.init()}var t,n,i;return t=e,(n=[{key:"init",value:function(){this.TCP_CONNECTION="TcpList",this.HTTP_REQUEST="HttpList",this.TRACK_SWITCH="RepSwitchList",this.BUFFER_LEVEL="BufferLevel",this.BUFFER_LOADED="bufferLoaded",this.ABANDON_LOAD="abandonload",this.ALLOW_LOAD="allowload",this.BUFFER_EMPTY="bufferStalled",this.BUFFER_STATE="BufferState",this.DVR_INFO="DVRInfo",this.DROPPED_FRAMES="DroppedFrames",this.SCHEDULING_INFO="SchedulingInfo",this.REQUESTS_QUEUE="RequestsQueue",this.MANIFEST_UPDATE="ManifestUpdate",this.MANIFEST_UPDATE_STREAM_INFO="ManifestUpdatePeriodInfo",this.MANIFEST_UPDATE_TRACK_INFO="ManifestUpdateRepresentationInfo",this.PLAY_LIST="PlayList",this.DVB_ERRORS="DVBErrors",this.HTTP_REQUEST_DVB_REPORTING_TYPE="DVBReporting"}}])&&r(t.prototype,n),i&&r(t,i),e}());t.a=i},function(e,t,n){"use strict";t.a=function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.code=t||null,this.message=n||null,this.data=r||null}},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){return(i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function a(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var i=s(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return o(this,n)}}function o(e,t){return!t||"object"!==r(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function s(e){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var u=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&i(e,t)}(n,e);var t=a(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE=10,e.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE=11,e.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE=12,e.SEGMENT_BASE_LOADER_ERROR_CODE=15,e.TIME_SYNC_FAILED_ERROR_CODE=16,e.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE=17,e.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE=18,e.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE=19,e.APPEND_ERROR_CODE=20,e.REMOVE_ERROR_CODE=21,e.DATA_UPDATE_FAILED_ERROR_CODE=22,e.CAPABILITY_MEDIASOURCE_ERROR_CODE=23,e.CAPABILITY_MEDIAKEYS_ERROR_CODE=24,e.DOWNLOAD_ERROR_ID_MANIFEST_CODE=25,e.DOWNLOAD_ERROR_ID_SIDX_CODE=26,e.DOWNLOAD_ERROR_ID_CONTENT_CODE=27,e.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE=28,e.DOWNLOAD_ERROR_ID_XLINK_CODE=29,e.MANIFEST_ERROR_ID_PARSE_CODE=31,e.MANIFEST_ERROR_ID_NOSTREAMS_CODE=32,e.TIMED_TEXT_ERROR_ID_PARSE_CODE=33,e.MANIFEST_ERROR_ID_MULTIPLEXED_CODE=34,e.MEDIASOURCE_TYPE_UNSUPPORTED_CODE=35,e.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE="parsing failed for ",e.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE="Failed loading manifest: ",e.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE="Failed loading Xlink element: ",e.SEGMENTS_UPDATE_FAILED_ERROR_MESSAGE="Segments update failed",e.SEGMENTS_UNAVAILABLE_ERROR_MESSAGE="no segments are available yet",e.SEGMENT_BASE_LOADER_ERROR_MESSAGE="error loading segment ranges from sidx",e.TIME_SYNC_FAILED_ERROR_MESSAGE="Failed to synchronize client and server time",e.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE="request is null",e.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE="Failed to resolve a valid URL",e.APPEND_ERROR_MESSAGE="chunk is not defined",e.REMOVE_ERROR_MESSAGE="Removing data from the SourceBuffer",e.DATA_UPDATE_FAILED_ERROR_MESSAGE="Data update failed",e.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE="mediasource is not supported",e.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE="mediakeys is not supported",e.TIMED_TEXT_ERROR_MESSAGE_PARSE="parsing error :",e.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE="Error creating source buffer of type : ",e}return n}(n(28).a));t.a=u},function(e,t,n){"use strict";n.d(t,"e",(function(){return a})),n.d(t,"c",(function(){return o})),n.d(t,"d",(function(){return s})),n.d(t,"a",(function(){return c})),n.d(t,"b",(function(){return f}));var r=n(32);function i(e,t){for(;e.length<t;)e="0"+e;return e}function a(e){return e?e.split("$$").join("$"):e}function o(e,t){if(!t||!e||-1===e.indexOf("$RepresentationID$"))return e;var n=t.toString();return e.split("$RepresentationID$").join(n)}function s(e,t,n){var r,a,o,s,u,l,c=t.length,f="%0".length;if(!e)return e;for(;;){if((r=e.indexOf("$"+t))<0)return e;if((a=e.indexOf("$",r+c))<0)return e;if((o=e.indexOf("%0",r+c))>r&&o<a)switch(s=e.charAt(a-1),u=parseInt(e.substring(o+f,a-1),10),s){case"d":case"i":case"u":l=i(n.toString(),u);break;case"x":l=i(n.toString(16),u);break;case"X":l=i(n.toString(16),u).toUpperCase();break;case"o":l=i(n.toString(8),u);break;default:return e}else l=n;e=e.substring(0,r)+l+e.substring(a+1)}}function u(e,t,n,i,a,o,s,u){var l,c=new r.a;return c.representation=e,c.duration=t,c.presentationStartTime=n,c.mediaStartTime=i,c.availabilityStartTime=a.calcAvailabilityStartTimeFromPresentationTime(o,e,s),c.availabilityEndTime=a.calcAvailabilityEndTimeFromPresentationTime(o+t,e,s),c.wallStartTime=a.calcWallTimeForSegment(c,s),c.replacementNumber=(l=u,c.representation.startNumber+l),c.index=u,c}function l(e,t,n,r){var i=t.adaptation.period;if(isFinite(i.duration)&&i.start+i.duration<=n.presentationStartTime)return!1;if(r){if("INF"===t.availabilityTimeOffset)return!0;var a=e.getClientReferenceTime();return n.availabilityStartTime.getTime()<=a&&(!isFinite(n.availabilityEndTime)||n.availabilityEndTime.getTime()>=a)}return!0}function c(e,t,n,r){var i,a,o;i=n.segmentDuration,isNaN(i)&&(i=n.adaptation.period.duration),a=parseFloat((n.adaptation.period.start+r*i).toFixed(5)),o=parseFloat((a+i).toFixed(5));var s=u(n,i,a,e.calcMediaTimeFromPresentationTime(a,n),e,o,t,r);return l(e,n,s,t)?s:null}function f(e,t,n,r,i,a,o,c,f,d){var h,p,g=r/a,m=i/a;return h=e.calcPresentationTimeFromMediaTime(g,n),l(e,n,p=u(n,m,h,g,e,h+m,t,f),t)?(p.replacementTime=d||r,o=s(o,"Number",p.replacementNumber),o=s(o,"Time",p.replacementTime),p.media=o,p.mediaRange=c,p):null}},function(e,t,n){"use strict";var r=n(3);function i(){var e,t=/^[a-z][a-z0-9+\-_.]*:/i,n=/^https?:\/\//i,r=/^https:\/\//i,i=/^([a-z][a-z0-9+\-_.]*:\/\/[^\/]+)\/?/i,a=function(e,t){try{return new window.URL(e,t).toString()}catch(t){return e}},o=function(e,t){var n=s;if(!t)return e;if(!c(e))return e;f(e)&&(n=u),d(e)&&(n=l);var r=n(t),i="/"!==r.charAt(r.length-1)&&"/"!==e.charAt(0)?"/":"";return[r,e].join(i)};function s(e){var t=e.indexOf("/"),n=e.lastIndexOf("/");return-1!==t?n===t+1?e:(-1!==e.indexOf("?")&&(e=e.substring(0,e.indexOf("?"))),e.substring(0,n+1)):""}function u(e){var t=e.match(i);return t?t[1]:""}function l(e){var n=e.match(t);return n?n[0]:""}function c(e){return!t.test(e)}function f(e){return c(e)&&"/"===e.charAt(0)}function d(e){return 0===e.indexOf("//")}return function(){try{new window.URL("x","http://y");e=a}catch(e){}finally{e=e||o}}(),{parseBaseUrl:s,parseOrigin:u,parseScheme:l,isRelative:c,isPathAbsolute:f,isSchemeRelative:d,isHTTPURL:function(e){return n.test(e)},isHTTPS:function(e){return r.test(e)},removeHostname:function(e){return/^(?:\w+\:\/\/)?([^\/]+)(.*)$/.exec(e)[2].substring(1)},resolve:function(t,n){return e(t,n)}}}i.__dashjs_factory_name="DefaultURLUtils";var a=r.a.getSingletonFactory(i);function o(){var e,t=[],n=this.context;function r(n,r,i){var a=function(n){var r;for(r=0;r<t.length;r++){if(t[r].regex.test(n))return t[r].utils}return e}(i||r);return a&&"function"==typeof a[n]?a[n](r,i):e[n](r,i)}return e=a(n).getInstance(),{registerUrlRegex:function(e,n){t.push({regex:e,utils:n})},parseBaseUrl:function(e){return r("parseBaseUrl",e)},parseOrigin:function(e){return r("parseOrigin",e)},parseScheme:function(e){return r("parseScheme",e)},isRelative:function(e){return r("isRelative",e)},isPathAbsolute:function(e){return r("isPathAbsolute",e)},isSchemeRelative:function(e){return r("isSchemeRelative",e)},isHTTPURL:function(e){return r("isHTTPURL",e)},isHTTPS:function(e){return r("isHTTPS",e)},removeHostname:function(e){return r("removeHostname",e)},resolve:function(e,t){return r("resolve",e,t)}}}o.__dashjs_factory_name="URLUtils";var s=r.a.getSingletonFactory(o);t.a=s},function(e,t,n){"use strict";n.d(t,"b",(function(){return a})),n.d(t,"a",(function(){return o}));var r=n(1);function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function a(e,t){if(i(e)!==t)throw r.a.BAD_ARGUMENT_ERROR}function o(e){if(!(null!==e&&!isNaN(e)&&e%1==0))throw r.a.BAD_ARGUMENT_ERROR+" : argument is not an integer"}},function(e,t,n){"use strict";var r=n(36),i=n.n(r);function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var s=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n,r;return t=e,r=[{key:"mixin",value:function(t,n,r){var i,o={};if(t)for(var s in n)n.hasOwnProperty(s)&&(i=n[s],s in t&&(t[s]===i||s in o&&o[s]===i)||("object"===a(t[s])&&null!==t[s]?t[s]=e.mixin(t[s],i,r):t[s]=r(i)));return t}},{key:"clone",value:function(t){if(!t||"object"!==a(t))return t;var n;if(t instanceof Array){n=[];for(var r=0,i=t.length;r<i;++r)r in t&&n.push(e.clone(t[r]))}else n={};return e.mixin(n,t,e.clone)}},{key:"addAditionalQueryParameterToUrl",value:function(e,t){try{if(!t||0===t.length)return e;var n=new URL(e);return t.forEach((function(e){e.key&&e.value&&n.searchParams.set(e.key,e.value)})),n.href}catch(t){return e}}},{key:"parseHttpHeaders",value:function(e){var t={};if(!e)return t;for(var n=e.trim().split("\r\n"),r=0,i=n.length;r<i;r++){var a=n[r],o=a.indexOf(": ");o>0&&(t[a.substring(0,o)]=a.substring(o+2))}return t}},{key:"generateUuid",value:function(){var e=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(t){var n=(e+16*Math.random())%16|0;return e=Math.floor(e/16),("x"==t?n:3&n|8).toString(16)}))}},{key:"generateHashCode",value:function(e){var t=0;if(0===e.length)return t;for(var n=0;n<e.length;n++)t=(t<<5)-t+e.charCodeAt(n),t|=0;return t}},{key:"getRelativeUrl",value:function(e,t){try{var n=new URL(e),r=new URL(t);if(n.protocol=r.protocol,n.origin!==r.origin)return t;var a=i.a.relative(n.pathname.substr(0,n.pathname.lastIndexOf("/")),r.pathname.substr(0,r.pathname.lastIndexOf("/"))),o=0===a.length?1:0;return a+=r.pathname.substr(r.pathname.lastIndexOf("/")+o,r.pathname.length-1),r.pathname.length<a.length?r.pathname:a}catch(e){return t}}}],(n=null)&&o(t.prototype,n),r&&o(t,r),e}();t.a=s},function(e,t,n){"use strict";var r=n(3),i=n(15),a=n(6),o=n(1),s=n(5),u=n(7),l=n(2);function c(e){return(c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function f(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function d(){var e,t,n=this.context,r=Object(u.a)(n).getInstance(),d={"streaming.delay.liveDelay":l.a.SETTING_UPDATED_LIVE_DELAY,"streaming.delay.liveDelayFragmentCount":l.a.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,"streaming.liveCatchup.enabled":l.a.SETTING_UPDATED_CATCHUP_ENABLED},h={debug:{logLevel:a.a.LOG_LEVEL_WARNING,dispatchEvent:!1},streaming:{abandonLoadTimeout:1e4,wallclockTimeUpdateInterval:100,manifestUpdateRetryInterval:100,cacheInitSegments:!1,applyServiceDescription:!0,applyProducerReferenceTime:!0,eventControllerRefreshDelay:150,capabilities:{filterUnsupportedEssentialProperties:!0,useMediaCapabilitiesApi:!1},timeShiftBuffer:{calcFromSegmentTimeline:!1,fallbackToSegmentTimeline:!0},metrics:{maxListDepth:100},delay:{liveDelayFragmentCount:NaN,liveDelay:NaN,useSuggestedPresentationDelay:!0},protection:{keepProtectionMediaKeys:!1,ignoreEmeEncryptedEvent:!1,detectPlayreadyMessageFormat:!0},buffer:{enableSeekDecorrelationFix:!1,fastSwitchEnabled:!0,flushBufferAtTrackSwitch:!1,reuseExistingSourceBuffers:!0,bufferPruningInterval:10,bufferToKeep:20,bufferTimeAtTopQuality:30,bufferTimeAtTopQualityLongForm:60,initialBufferLevel:NaN,stableBufferTime:12,longFormContentDurationThreshold:600,stallThreshold:.3,useAppendWindow:!0,setStallState:!0},gaps:{jumpGaps:!0,jumpLargeGaps:!0,smallGapLimit:1.5,threshold:.3,enableSeekFix:!0,enableStallFix:!1,stallSeek:.1},utcSynchronization:{enabled:!0,useManifestDateHeaderTimeSource:!0,backgroundAttempts:2,timeBetweenSyncAttempts:30,maximumTimeBetweenSyncAttempts:600,minimumTimeBetweenSyncAttempts:2,timeBetweenSyncAttemptsAdjustmentFactor:2,maximumAllowedDrift:100,enableBackgroundSyncAfterSegmentDownloadError:!0,defaultTimingSource:{scheme:"urn:mpeg:dash:utc:http-xsdate:2014",value:"https://time.akamai.com/?iso&ms"}},scheduling:{defaultTimeout:500,lowLatencyTimeout:0,scheduleWhilePaused:!0},text:{defaultEnabled:!0},liveCatchup:{maxDrift:NaN,playbackRate:NaN,playbackBufferMin:.5,enabled:null,latencyThreshold:60,mode:o.a.LIVE_CATCHUP_MODE_DEFAULT},lastBitrateCachingInfo:{enabled:!0,ttl:36e4},lastMediaSettingsCachingInfo:{enabled:!0,ttl:36e4},cacheLoadThresholds:{video:50,audio:5},trackSwitchMode:{audio:o.a.TRACK_SWITCH_MODE_ALWAYS_REPLACE,video:o.a.TRACK_SWITCH_MODE_NEVER_REPLACE},selectionModeForInitialTrack:o.a.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY,fragmentRequestTimeout:1e4,retryIntervals:(e={},f(e,s.a.MPD_TYPE,500),f(e,s.a.XLINK_EXPANSION_TYPE,500),f(e,s.a.MEDIA_SEGMENT_TYPE,1e3),f(e,s.a.INIT_SEGMENT_TYPE,1e3),f(e,s.a.BITSTREAM_SWITCHING_SEGMENT_TYPE,1e3),f(e,s.a.INDEX_SEGMENT_TYPE,1e3),f(e,s.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE,1e3),f(e,s.a.LICENSE,1e3),f(e,s.a.OTHER_TYPE,1e3),f(e,"lowLatencyReductionFactor",10),e),retryAttempts:(t={},f(t,s.a.MPD_TYPE,3),f(t,s.a.XLINK_EXPANSION_TYPE,1),f(t,s.a.MEDIA_SEGMENT_TYPE,3),f(t,s.a.INIT_SEGMENT_TYPE,3),f(t,s.a.BITSTREAM_SWITCHING_SEGMENT_TYPE,3),f(t,s.a.INDEX_SEGMENT_TYPE,3),f(t,s.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE,3),f(t,s.a.LICENSE,3),f(t,s.a.OTHER_TYPE,3),f(t,"lowLatencyMultiplyFactor",5),t),abr:{movingAverageMethod:o.a.MOVING_AVERAGE_SLIDING_WINDOW,ABRStrategy:o.a.ABR_STRATEGY_DYNAMIC,additionalAbrRules:{insufficientBufferRule:!0,switchHistoryRule:!0,droppedFramesRule:!0,abandonRequestsRule:!1},bandwidthSafetyFactor:.9,useDefaultABRRules:!0,useDeadTimeLatency:!0,limitBitrateByPortal:!1,usePixelRatioInLimitBitrateByPortal:!1,maxBitrate:{audio:-1,video:-1},minBitrate:{audio:-1,video:-1},maxRepresentationRatio:{audio:1,video:1},initialBitrate:{audio:-1,video:-1},initialRepresentationRatio:{audio:-1,video:-1},autoSwitchBitrate:{audio:!0,video:!0},fetchThroughputCalculationMode:o.a.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING},cmcd:{enabled:!1,sid:null,cid:null,rtp:null,rtpSafetyFactor:5,mode:o.a.CMCD_MODE_QUERY,enabledKeys:["br","d","ot","tb","bl","dl","mtp","nor","nrr","su","bs","rtp","cid","pr","sf","sid","st","v"]}},errors:{recoverAttempts:{mediaErrorDecode:5}}},p=i.a.clone(h);return{get:function(){return p},update:function(e){"object"===c(e)&&function e(t,n,a){for(var o in t)t.hasOwnProperty(o)&&(n.hasOwnProperty(o)?"object"!==c(t[o])||t[o]instanceof Array||null===t[o]?(n[o]=i.a.clone(t[o]),d[a+o]&&r.trigger(d[a+o])):e(t[o],n[o],a.slice()+o+"."):console.error("Settings parameter "+a+o+" is not supported"))}(e,p,"")},reset:function(){p=i.a.clone(h)}}}d.__dashjs_factory_name="Settings";var h=r.a.getSingletonFactory(d);t.a=h},function(e,t,n){"use strict";var r=n(5);function i(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var a=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.action=e.ACTION_DOWNLOAD,this.startTime=NaN,this.mediaStartTime=NaN,this.mediaType=null,this.mediaInfo=null,this.type=null,this.duration=NaN,this.timescale=NaN,this.range=null,this.url=t||null,this.serviceLocation=null,this.requestStartDate=null,this.firstByteDate=null,this.requestEndDate=null,this.quality=NaN,this.index=NaN,this.availabilityStartTime=null,this.availabilityEndTime=null,this.wallStartTime=null,this.bytesLoaded=NaN,this.bytesTotal=NaN,this.delayLoadingTime=NaN,this.responseType="arraybuffer",this.representationId=null}var t,n,a;return t=e,(n=[{key:"isInitializationRequest",value:function(){return this.type&&this.type===r.a.INIT_SEGMENT_TYPE}},{key:"setInfo",value:function(e){this.type=e&&e.init?r.a.INIT_SEGMENT_TYPE:r.a.MEDIA_SEGMENT_TYPE,this.url=e&&e.url?e.url:null,this.range=e&&e.range?e.range.start+"-"+e.range.end:null,this.mediaType=e&&e.mediaType?e.mediaType:null}}])&&i(t.prototype,n),a&&i(t,a),e}();a.ACTION_DOWNLOAD="download",a.ACTION_COMPLETE="complete",t.a=a},function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n,i;return t=e,(n=[{key:"extend",value:function(e,t){if(e){var n=!!t&&t.override,r=!!t&&t.publicOnly;for(var i in e)!e.hasOwnProperty(i)||this[i]&&!n||r&&-1===e[i].indexOf("public_")||(this[i]=e[i])}}}])&&r(t.prototype,n),i&&r(t,i),e}();t.a=i},function(e,t,n){"use strict";function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){return(i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function a(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=s(e);if(t){var i=s(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return o(this,n)}}function o(e,t){return!t||"object"!==r(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function s(e){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var u=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&i(e,t)}(n,e);var t=a(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).METRICS_INITIALISATION_COMPLETE="internal_metricsReportingInitialized",e.BECAME_REPORTING_PLAYER="internal_becameReportingPlayer",e.CMCD_DATA_GENERATED="cmcdDataGenerated",e}return n}(n(18).a));t.a=u},function(e,t,n){"use strict";var r=n(3),i=n(17);function a(e){var t,n,r,a,o=(e=e||{}).eventBus,s=e.events,u=e.dashMetrics,l=e.fragmentLoader,c=e.debug,f=e.streamInfo,d=e.type;function h(e){var t;return!!e&&(t=!1,r.some((function(n){if(r=e,a=n,!isNaN(r.index)&&r.startTime===a.startTime&&r.adaptationIndex===a.adaptationIndex&&r.type===a.type||function(e,t){return isNaN(e.index)&&isNaN(t.index)&&e.quality===t.quality}(e,n)||function(e,t){return e.action===i.a.ACTION_COMPLETE&&e.action===t.action}(e,n))return t=!0;var r,a})),t)}function p(e){return isNaN(e.duration)?.25:Math.min(e.duration/8,.5)}function g(e){r=r.filter((function(t){var n=p(t);return isNaN(t.startTime)||void 0!==e&&t.startTime>=e-n}))}function m(e,t){t<=e+.5||(r=r.filter((function(n){var r=p(n);return isNaN(n.startTime)||n.startTime>=t-r||isNaN(n.duration)||n.startTime+n.duration<=e+r})))}function y(e,t,n){for(var r=e.length-1;r>=0;r--){var i=e[r],a=i.startTime,o=a+i.duration;if(n=isNaN(n)?p(i):n,!isNaN(a)&&!isNaN(o)&&t+n>=a&&t-n<o||isNaN(a)&&isNaN(t))return i}return null}function E(e,t){u.addSchedulingInfo(e,t),u.addRequestsQueue(e.mediaType,a,r)}function _(e){e.sender===l&&(a.splice(a.indexOf(e.request),1),e.response&&!e.error&&r.push(e.request),E(e.request,e.error?"failed":"executed"),o.trigger(s.FRAGMENT_LOADING_COMPLETED,{request:e.request,response:e.response,error:e.error,sender:this},{streamId:f.id,mediaType:d}))}function T(e){e.sender===l&&o.trigger(s.FRAGMENT_LOADING_PROGRESS,{request:e.request,response:e.response,error:e.error,sender:this},{streamId:f.id,mediaType:d})}function v(e){e.sender===l&&o.trigger(s.FRAGMENT_LOADING_ABANDONED,{request:e.request},{streamId:f.id,mediaType:d})}function S(){r=[],a=[]}return t={getStreamId:function(){return f.id},getType:function(){return d},getRequests:function(e){var t=e?e.state instanceof Array?e.state:[e.state]:[],n=[];return t.forEach((function(t){var i=function(e){var t;switch(e){case"loading":t=a;break;case"executed":t=r;break;default:t=[]}return t}(t);n=n.concat(function(e,t){if(t.hasOwnProperty("time"))return[y(e,t.time,t.threshold)];return e.filter((function(e){for(var n in t)if("state"!==n&&t.hasOwnProperty(n)&&e[n]!=t[n])return!1;return!0}))}(i,e))})),n},isFragmentLoaded:h,isFragmentLoadedOrPending:function(e){var t,n=!1,r=0;if(!(n=h(e)))for(r=0;r<a.length;r++)t=a[r],e.url===t.url&&e.startTime===t.startTime&&(n=!0);return n},removeExecutedRequestsBeforeTime:g,removeExecutedRequestsAfterTime:function(e){r=r.filter((function(t){return isNaN(t.startTime)||void 0!==e&&t.startTime<e}))},syncExecutedRequestsWithBufferedRange:function(e,t){if(e&&0!==e.length){for(var n=0,r=0,i=e.length;r<i;r++)m(n,e.start(r)),n=e.end(r);t>0&&m(n,t)}else g()},abortRequests:function(){n.debug("abort requests"),l.abort(),a=[]},executeRequest:function(e){switch(e.action){case i.a.ACTION_DOWNLOAD:E(e,"loading"),a.push(e),function(e){o.trigger(s.FRAGMENT_LOADING_STARTED,{request:e},{streamId:f.id,mediaType:d}),l.load(e)}(e);break;default:n.warn("Unknown request action.")}},reset:function(){o.off(s.LOADING_COMPLETED,_,this),o.off(s.LOADING_DATA_PROGRESS,T,this),o.off(s.LOADING_ABANDONED,v,this),l&&l.reset(),S()},resetInitialSettings:S,addExecutedRequest:function(e){r.push(e)}},n=c.getLogger(t),S(),o.on(s.LOADING_COMPLETED,_,t),o.on(s.LOADING_DATA_PROGRESS,T,t),o.on(s.LOADING_ABANDONED,v,t),t}a.__dashjs_factory_name="FragmentModel";var o=r.a.getClassFactory(a);o.FRAGMENT_MODEL_LOADING="loading",o.FRAGMENT_MODEL_EXECUTED="executed",o.FRAGMENT_MODEL_CANCELED="canceled",o.FRAGMENT_MODEL_FAILED="failed",r.a.updateClassFactory(a.__dashjs_factory_name,o),t.a=o},function(e,t,n){"use strict";var r=n(3),i=n(46);function a(e){e=e||{};var t,n,r=this.context;return t=Object(i.a)(r).getInstance(),{load:function(i){if(!n){var a=t.getLoader(i&&i.request?i.request.url:null);n=a(r).create({errHandler:e.errHandler,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,dashMetrics:e.dashMetrics,boxParser:e.boxParser?e.boxParser:null,constants:e.constants?e.constants:null,dashConstants:e.dashConstants?e.dashConstants:null,urlUtils:e.urlUtils?e.urlUtils:null,requestTimeout:isNaN(e.requestTimeout)?0:e.requestTimeout,errors:e.errors})}n.load(i)},abort:function(){n&&n.abort()}}}a.__dashjs_factory_name="URLLoader";var o=r.a.getClassFactory(a);t.a=o},function(e,t,n){"use strict";var r=n(6);function i(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var a=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.offset=t._offset,this.type=t.type,this.size=t.size,this.boxes=[],t.boxes)for(var n=0;n<t.boxes.length;n++)this.boxes.push(new e(t.boxes[n]));switch(this.isComplete=!0,t.type){case"sidx":if(this.timescale=t.timescale,this.earliest_presentation_time=t.earliest_presentation_time,this.first_offset=t.first_offset,this.references=t.references,t.references){this.references=[];for(var r=0;r<t.references.length;r++){var i={reference_type:t.references[r].reference_type,referenced_size:t.references[r].referenced_size,subsegment_duration:t.references[r].subsegment_duration};this.references.push(i)}}break;case"emsg":this.id=t.id,this.version=1===t.version?1:0,this.value=t.value,this.timescale=t.timescale,this.scheme_id_uri=t.scheme_id_uri,this.presentation_time_delta=1===t.version?t.presentation_time:t.presentation_time_delta,this.event_duration=t.event_duration,this.message_data=t.message_data;break;case"mdhd":this.timescale=t.timescale;break;case"mfhd":this.sequence_number=t.sequence_number;break;case"subs":this.entry_count=t.entry_count,this.entries=t.entries;break;case"tfhd":this.base_data_offset=t.base_data_offset,this.sample_description_index=t.sample_description_index,this.default_sample_duration=t.default_sample_duration,this.default_sample_size=t.default_sample_size,this.default_sample_flags=t.default_sample_flags,this.flags=t.flags;break;case"tfdt":this.version=t.version,this.baseMediaDecodeTime=t.baseMediaDecodeTime,this.flags=t.flags;break;case"trun":if(this.sample_count=t.sample_count,this.first_sample_flags=t.first_sample_flags,this.data_offset=t.data_offset,this.flags=t.flags,this.samples=t.samples,t.samples){this.samples=[];for(var a=0,o=t.samples.length;a<o;a++){var s={sample_size:t.samples[a].sample_size,sample_duration:t.samples[a].sample_duration,sample_composition_time_offset:t.samples[a].sample_composition_time_offset};this.samples.push(s)}}}}var t,n,r;return t=e,(n=[{key:"getChildBox",value:function(e){for(var t=0;t<this.boxes.length;t++)if(this.boxes[t].type===e)return this.boxes[t]}},{key:"getChildBoxes",value:function(e){for(var t=[],n=0;n<this.boxes.length;n++)this.boxes[n].type===e&&t.push(this.boxes[n]);return t}}])&&i(t.prototype,n),r&&i(t,r),e}(),o=n(3);function s(){var e;function t(t){var r=[];if(!t||!e||"function"!=typeof e.fetchAll)return r;for(var i,a=e.fetchAll(t),o=0,s=a.length;o<s;o++)(i=n(a[o]))&&r.push(i);return r}function n(e){if(!e)return null;var t=new a(e);return e.hasOwnProperty("_incomplete")&&(t.isComplete=!e._incomplete),t}return{getBox:function(t){return t&&e&&e.boxes&&0!==e.boxes.length&&"function"==typeof e.fetch?n(e.fetch(t)):null},getBoxes:t,setData:function(t){e=t},getLastBox:function(){if(!e||!e.boxes||!e.boxes.length)return null;var n=t(e.boxes[e.boxes.length-1].type);return n.length>0?n[n.length-1]:null}}}s.__dashjs_factory_name="IsoFile";var u=o.a.getClassFactory(s),l=n(24),c=n.n(l);var f=function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.lastCompletedOffset=t,this.found=n,this.size=r};function d(){var e,t,n=this.context;function i(e){if(!e)return null;void 0===e.fileStart&&(e.fileStart=0);var t=c.a.parseBuffer(e),r=u(n).create();return r.setData(t),r}function a(e,t){return e[t+3]>>>0|e[t+2]<<8>>>0|e[t+1]<<16>>>0|e[t]<<24>>>0}function o(e,t){return String.fromCharCode(e[t++])+String.fromCharCode(e[t++])+String.fromCharCode(e[t++])+String.fromCharCode(e[t])}return t={parse:i,findLastTopIsoBoxCompleted:function(e,t,n){if(void 0===n&&(n=0),!t||n+8>=t.byteLength)return new f(0,!1);for(var r,i=t instanceof ArrayBuffer?new Uint8Array(t):t,s=0;n<i.byteLength;){var u=a(i,n),l=o(i,n+4);if(0===u)break;n+u<=i.byteLength&&(e.indexOf(l)>=0?r=new f(n,!0,u):s=n+u),n+=u}return r||new f(s,!1)},getMediaTimescaleFromMoov:function(e){var t=i(e),n=t?t.getBox("mdhd"):void 0;return n?n.timescale:NaN},getSamplesInfo:function(e){if(!e||0===e.byteLength)return{sampleList:[],lastSequenceNumber:NaN,totalDuration:NaN,numSequences:NaN};var t,n,r,a,o,s,u,l,c,f,d,h,p,g,m,y,E=i(e),_=E.getBoxes("moof"),T=E.getBoxes("mfhd");m=E.getBoxes("moof").length,g=T[T.length-1].sequence_number,n=0,o=[];var v=-1,S=-1;for(f=0;f<_.length;f++){var A=_[f],b=A.getChildBoxes("traf");for(l=0;l<b.length;l++){var I=b[l],R=I.getChildBox("tfhd"),N=I.getChildBox("tfdt");a=N.baseMediaDecodeTime;var C=I.getChildBoxes("trun"),w=I.getChildBoxes("subs");for(c=0;c<C.length;c++){var D=C[c];for(n=D.sample_count,p=(R.base_data_offset||0)+(D.data_offset||0),u=0;u<n;u++){t=void 0!==(s=D.samples[u]).sample_duration?s.sample_duration:R.default_sample_duration,r=void 0!==s.sample_size?s.sample_size:R.default_sample_size;var O={dts:a,cts:a+(void 0!==s.sample_composition_time_offset?s.sample_composition_time_offset:0),duration:t,offset:A.offset+p,size:r,subSizes:[r]};if(w)for(d=0;d<w.length;d++){var M=w[d];if(v<M.entry_count-1&&u>S&&(v++,S+=M.entries[v].sample_delta),u==S){O.subSizes=[];var P=M.entries[v];for(h=0;h<P.subsample_count;h++)O.subSizes.push(P.subsamples[h].subsample_size)}}o.push(O),p+=r,a+=t}}y=a-N.baseMediaDecodeTime}}return{sampleList:o,lastSequenceNumber:g,totalDuration:y,numSequences:m}},findInitRange:function(t){var n=null,r=i(t);if(!r)return n;var a=r.getBox("ftyp"),o=r.getBox("moov");return e.debug("Searching for initialization."),o&&o.isComplete&&(n=(a?a.offset:o.offset)+"-"+(o.offset+o.size-1),e.debug("Found the initialization.  Range: "+n)),n},parsePayload:function(e,t,n){if(void 0===n&&(n=0),!t||n+8>=t.byteLength)return new f(0,!1);for(var r,i=t instanceof ArrayBuffer?new Uint8Array(t):t,s=0;n<i.byteLength;){var u=a(i,n),l=o(i,n+4);if(0===u)break;n+u<=i.byteLength&&(e.indexOf(l)>=0?r=new f(n,!0,u,l):s=n+u),n+=u}return r||new f(s,!1)}},e=Object(r.a)(n).getInstance().getLogger(t),t}d.__dashjs_factory_name="BoxParser";t.a=o.a.getSingletonFactory(d)},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){
/*! codem-isoboxer v0.3.6 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
var r={parseBuffer:function(e){return new i(e).parse()},addBoxProcessor:function(e,t){"string"==typeof e&&"function"==typeof t&&(a.prototype._boxProcessors[e]=t)},createFile:function(){return new i},createBox:function(e,t,n){var r=a.create(e);return t&&t.append(r,n),r},createFullBox:function(e,t,n){var i=r.createBox(e,t,n);return i.version=0,i.flags=0,i},Utils:{}};r.Utils.dataViewToString=function(e,t){var n=t||"utf-8";if("undefined"!=typeof TextDecoder)return new TextDecoder(n).decode(e);var r=[],i=0;if("utf-8"===n)for(;i<e.byteLength;){var a=e.getUint8(i++);a<128||(a<224?(a=(31&a)<<6,a|=63&e.getUint8(i++)):a<240?(a=(15&a)<<12,a|=(63&e.getUint8(i++))<<6,a|=63&e.getUint8(i++)):(a=(7&a)<<18,a|=(63&e.getUint8(i++))<<12,a|=(63&e.getUint8(i++))<<6,a|=63&e.getUint8(i++))),r.push(String.fromCharCode(a))}else for(;i<e.byteLength;)r.push(String.fromCharCode(e.getUint8(i++)));return r.join("")},r.Utils.utf8ToByteArray=function(e){var t,n;if("undefined"!=typeof TextEncoder)t=(new TextEncoder).encode(e);else for(t=[],n=0;n<e.length;++n){var r=e.charCodeAt(n);r<128?t.push(r):r<2048?(t.push(192|r>>6),t.push(128|63&r)):r<65536?(t.push(224|r>>12),t.push(128|63&r>>6),t.push(128|63&r)):(t.push(240|r>>18),t.push(128|63&r>>12),t.push(128|63&r>>6),t.push(128|63&r))}return t},r.Utils.appendBox=function(e,t,n){if(t._offset=e._cursor.offset,t._root=e._root?e._root:e,t._raw=e._raw,t._parent=e,-1!==n)if(null!=n){var r,i=-1;if("number"==typeof n)i=n;else{if("string"==typeof n)r=n;else{if("object"!=typeof n||!n.type)return void e.boxes.push(t);r=n.type}for(var a=0;a<e.boxes.length;a++)if(r===e.boxes[a].type){i=a+1;break}}e.boxes.splice(i,0,t)}else e.boxes.push(t)},t.parseBuffer=r.parseBuffer,t.addBoxProcessor=r.addBoxProcessor,t.createFile=r.createFile,t.createBox=r.createBox,t.createFullBox=r.createFullBox,t.Utils=r.Utils,r.Cursor=function(e){this.offset=void 0===e?0:e};var i=function(e){this._cursor=new r.Cursor,this.boxes=[],e&&(this._raw=new DataView(e))};i.prototype.fetch=function(e){var t=this.fetchAll(e,!0);return t.length?t[0]:null},i.prototype.fetchAll=function(e,t){var n=[];return i._sweep.call(this,e,n,t),n},i.prototype.parse=function(){for(this._cursor.offset=0,this.boxes=[];this._cursor.offset<this._raw.byteLength;){var e=a.parse(this);if(void 0===e.type)break;this.boxes.push(e)}return this},i._sweep=function(e,t,n){for(var r in this.type&&this.type==e&&t.push(this),this.boxes){if(t.length&&n)return;i._sweep.call(this.boxes[r],e,t,n)}},i.prototype.write=function(){var e,t=0;for(e=0;e<this.boxes.length;e++)t+=this.boxes[e].getLength(!1);var n=new Uint8Array(t);for(this._rawo=new DataView(n.buffer),this.bytes=n,this._cursor.offset=0,e=0;e<this.boxes.length;e++)this.boxes[e].write();return n.buffer},i.prototype.append=function(e,t){r.Utils.appendBox(this,e,t)};var a=function(){this._cursor=new r.Cursor};a.parse=function(e){var t=new a;return t._offset=e._cursor.offset,t._root=e._root?e._root:e,t._raw=e._raw,t._parent=e,t._parseBox(),e._cursor.offset=t._raw.byteOffset+t._raw.byteLength,t},a.create=function(e){var t=new a;return t.type=e,t.boxes=[],t},a.prototype._boxContainers=["dinf","edts","mdia","meco","mfra","minf","moof","moov","mvex","stbl","strk","traf","trak","tref","udta","vttc","sinf","schi","encv","enca"],a.prototype._boxProcessors={},a.prototype._procField=function(e,t,n){this._parsing?this[e]=this._readField(t,n):this._writeField(t,n,this[e])},a.prototype._procFieldArray=function(e,t,n,r){var i;if(this._parsing)for(this[e]=[],i=0;i<t;i++)this[e][i]=this._readField(n,r);else for(i=0;i<this[e].length;i++)this._writeField(n,r,this[e][i])},a.prototype._procFullBox=function(){this._procField("version","uint",8),this._procField("flags","uint",24)},a.prototype._procEntries=function(e,t,n){var r;if(this._parsing)for(this[e]=[],r=0;r<t;r++)this[e].push({}),n.call(this,this[e][r]);else for(r=0;r<t;r++)n.call(this,this[e][r])},a.prototype._procSubEntries=function(e,t,n,r){var i;if(this._parsing)for(e[t]=[],i=0;i<n;i++)e[t].push({}),r.call(this,e[t][i]);else for(i=0;i<n;i++)r.call(this,e[t][i])},a.prototype._procEntryField=function(e,t,n,r){this._parsing?e[t]=this._readField(n,r):this._writeField(n,r,e[t])},a.prototype._procSubBoxes=function(e,t){var n;if(this._parsing)for(this[e]=[],n=0;n<t;n++)this[e].push(a.parse(this));else for(n=0;n<t;n++)this._rawo?this[e][n].write():this.size+=this[e][n].getLength()},a.prototype._readField=function(e,t){switch(e){case"uint":return this._readUint(t);case"int":return this._readInt(t);case"template":return this._readTemplate(t);case"string":return-1===t?this._readTerminatedString():this._readString(t);case"data":return this._readData(t);case"utf8":return this._readUTF8String();default:return-1}},a.prototype._readInt=function(e){var t=null,n=this._cursor.offset-this._raw.byteOffset;switch(e){case 8:t=this._raw.getInt8(n);break;case 16:t=this._raw.getInt16(n);break;case 32:t=this._raw.getInt32(n);break;case 64:var r=this._raw.getInt32(n),i=this._raw.getInt32(n+4);t=r*Math.pow(2,32)+i}return this._cursor.offset+=e>>3,t},a.prototype._readUint=function(e){var t,n,r=null,i=this._cursor.offset-this._raw.byteOffset;switch(e){case 8:r=this._raw.getUint8(i);break;case 16:r=this._raw.getUint16(i);break;case 24:r=((t=this._raw.getUint16(i))<<8)+(n=this._raw.getUint8(i+2));break;case 32:r=this._raw.getUint32(i);break;case 64:t=this._raw.getUint32(i),n=this._raw.getUint32(i+4),r=t*Math.pow(2,32)+n}return this._cursor.offset+=e>>3,r},a.prototype._readString=function(e){for(var t="",n=0;n<e;n++){var r=this._readUint(8);t+=String.fromCharCode(r)}return t},a.prototype._readTemplate=function(e){return this._readUint(e/2)+this._readUint(e/2)/Math.pow(2,e/2)},a.prototype._readTerminatedString=function(){for(var e="";this._cursor.offset-this._offset<this._raw.byteLength;){var t=this._readUint(8);if(0===t)break;e+=String.fromCharCode(t)}return e},a.prototype._readData=function(e){var t=e>0?e:this._raw.byteLength-(this._cursor.offset-this._offset);if(t>0){var n=new Uint8Array(this._raw.buffer,this._cursor.offset,t);return this._cursor.offset+=t,n}return null},a.prototype._readUTF8String=function(){var e=this._raw.byteLength-(this._cursor.offset-this._offset),t=null;return e>0&&(t=new DataView(this._raw.buffer,this._cursor.offset,e),this._cursor.offset+=e),t?r.Utils.dataViewToString(t):t},a.prototype._parseBox=function(){if(this._parsing=!0,this._cursor.offset=this._offset,this._offset+8>this._raw.buffer.byteLength)this._root._incomplete=!0;else{switch(this._procField("size","uint",32),this._procField("type","string",4),1===this.size&&this._procField("largesize","uint",64),"uuid"===this.type&&this._procFieldArray("usertype",16,"uint",8),this.size){case 0:this._raw=new DataView(this._raw.buffer,this._offset,this._raw.byteLength-this._cursor.offset+8);break;case 1:this._offset+this.size>this._raw.buffer.byteLength?(this._incomplete=!0,this._root._incomplete=!0):this._raw=new DataView(this._raw.buffer,this._offset,this.largesize);break;default:this._offset+this.size>this._raw.buffer.byteLength?(this._incomplete=!0,this._root._incomplete=!0):this._raw=new DataView(this._raw.buffer,this._offset,this.size)}this._incomplete||(this._boxProcessors[this.type]&&this._boxProcessors[this.type].call(this),-1!==this._boxContainers.indexOf(this.type)?this._parseContainerBox():this._data=this._readData())}},a.prototype._parseFullBox=function(){this.version=this._readUint(8),this.flags=this._readUint(24)},a.prototype._parseContainerBox=function(){for(this.boxes=[];this._cursor.offset-this._raw.byteOffset<this._raw.byteLength;)this.boxes.push(a.parse(this))},a.prototype.append=function(e,t){r.Utils.appendBox(this,e,t)},a.prototype.getLength=function(){if(this._parsing=!1,this._rawo=null,this.size=0,this._procField("size","uint",32),this._procField("type","string",4),1===this.size&&this._procField("largesize","uint",64),"uuid"===this.type&&this._procFieldArray("usertype",16,"uint",8),this._boxProcessors[this.type]&&this._boxProcessors[this.type].call(this),-1!==this._boxContainers.indexOf(this.type))for(var e=0;e<this.boxes.length;e++)this.size+=this.boxes[e].getLength();return this._data&&this._writeData(this._data),this.size},a.prototype.write=function(){switch(this._parsing=!1,this._cursor.offset=this._parent._cursor.offset,this.size){case 0:this._rawo=new DataView(this._parent._rawo.buffer,this._cursor.offset,this.parent._rawo.byteLength-this._cursor.offset);break;case 1:this._rawo=new DataView(this._parent._rawo.buffer,this._cursor.offset,this.largesize);break;default:this._rawo=new DataView(this._parent._rawo.buffer,this._cursor.offset,this.size)}if(this._procField("size","uint",32),this._procField("type","string",4),1===this.size&&this._procField("largesize","uint",64),"uuid"===this.type&&this._procFieldArray("usertype",16,"uint",8),this._boxProcessors[this.type]&&this._boxProcessors[this.type].call(this),-1!==this._boxContainers.indexOf(this.type))for(var e=0;e<this.boxes.length;e++)this.boxes[e].write();return this._data&&this._writeData(this._data),this._parent._cursor.offset+=this.size,this.size},a.prototype._writeInt=function(e,t){if(this._rawo){var n=this._cursor.offset-this._rawo.byteOffset;switch(e){case 8:this._rawo.setInt8(n,t);break;case 16:this._rawo.setInt16(n,t);break;case 32:this._rawo.setInt32(n,t);break;case 64:var r=Math.floor(t/Math.pow(2,32)),i=t-r*Math.pow(2,32);this._rawo.setUint32(n,r),this._rawo.setUint32(n+4,i)}this._cursor.offset+=e>>3}else this.size+=e>>3},a.prototype._writeUint=function(e,t){if(this._rawo){var n,r,i=this._cursor.offset-this._rawo.byteOffset;switch(e){case 8:this._rawo.setUint8(i,t);break;case 16:this._rawo.setUint16(i,t);break;case 24:n=(16776960&t)>>8,r=255&t,this._rawo.setUint16(i,n),this._rawo.setUint8(i+2,r);break;case 32:this._rawo.setUint32(i,t);break;case 64:r=t-(n=Math.floor(t/Math.pow(2,32)))*Math.pow(2,32),this._rawo.setUint32(i,n),this._rawo.setUint32(i+4,r)}this._cursor.offset+=e>>3}else this.size+=e>>3},a.prototype._writeString=function(e,t){for(var n=0;n<e;n++)this._writeUint(8,t.charCodeAt(n))},a.prototype._writeTerminatedString=function(e){if(0!==e.length){for(var t=0;t<e.length;t++)this._writeUint(8,e.charCodeAt(t));this._writeUint(8,0)}},a.prototype._writeTemplate=function(e,t){var n=Math.floor(t),r=(t-n)*Math.pow(2,e/2);this._writeUint(e/2,n),this._writeUint(e/2,r)},a.prototype._writeData=function(e){if(e)if(this._rawo){if(e instanceof Array){for(var t=this._cursor.offset-this._rawo.byteOffset,n=0;n<e.length;n++)this._rawo.setInt8(t+n,e[n]);this._cursor.offset+=e.length}e instanceof Uint8Array&&(this._root.bytes.set(e,this._cursor.offset),this._cursor.offset+=e.length)}else this.size+=e.length},a.prototype._writeUTF8String=function(e){var t=r.Utils.utf8ToByteArray(e);if(this._rawo)for(var n=new DataView(this._rawo.buffer,this._cursor.offset,t.length),i=0;i<t.length;i++)n.setUint8(i,t[i]);else this.size+=t.length},a.prototype._writeField=function(e,t,n){switch(e){case"uint":this._writeUint(t,n);break;case"int":this._writeInt(t,n);break;case"template":this._writeTemplate(t,n);break;case"string":-1==t?this._writeTerminatedString(n):this._writeString(t,n);break;case"data":this._writeData(n);break;case"utf8":this._writeUTF8String(n)}},a.prototype._boxProcessors.avc1=a.prototype._boxProcessors.encv=function(){this._procFieldArray("reserved1",6,"uint",8),this._procField("data_reference_index","uint",16),this._procField("pre_defined1","uint",16),this._procField("reserved2","uint",16),this._procFieldArray("pre_defined2",3,"uint",32),this._procField("width","uint",16),this._procField("height","uint",16),this._procField("horizresolution","template",32),this._procField("vertresolution","template",32),this._procField("reserved3","uint",32),this._procField("frame_count","uint",16),this._procFieldArray("compressorname",32,"uint",8),this._procField("depth","uint",16),this._procField("pre_defined3","int",16),this._procField("config","data",-1)},a.prototype._boxProcessors.dref=function(){this._procFullBox(),this._procField("entry_count","uint",32),this._procSubBoxes("entries",this.entry_count)},a.prototype._boxProcessors.elst=function(){this._procFullBox(),this._procField("entry_count","uint",32),this._procEntries("entries",this.entry_count,(function(e){this._procEntryField(e,"segment_duration","uint",1===this.version?64:32),this._procEntryField(e,"media_time","int",1===this.version?64:32),this._procEntryField(e,"media_rate_integer","int",16),this._procEntryField(e,"media_rate_fraction","int",16)}))},a.prototype._boxProcessors.emsg=function(){this._procFullBox(),1==this.version?(this._procField("timescale","uint",32),this._procField("presentation_time","uint",64),this._procField("event_duration","uint",32),this._procField("id","uint",32),this._procField("scheme_id_uri","string",-1),this._procField("value","string",-1)):(this._procField("scheme_id_uri","string",-1),this._procField("value","string",-1),this._procField("timescale","uint",32),this._procField("presentation_time_delta","uint",32),this._procField("event_duration","uint",32),this._procField("id","uint",32)),this._procField("message_data","data",-1)},a.prototype._boxProcessors.free=a.prototype._boxProcessors.skip=function(){this._procField("data","data",-1)},a.prototype._boxProcessors.frma=function(){this._procField("data_format","uint",32)},a.prototype._boxProcessors.ftyp=a.prototype._boxProcessors.styp=function(){this._procField("major_brand","string",4),this._procField("minor_version","uint",32);var e=-1;this._parsing&&(e=(this._raw.byteLength-(this._cursor.offset-this._raw.byteOffset))/4),this._procFieldArray("compatible_brands",e,"string",4)},a.prototype._boxProcessors.hdlr=function(){this._procFullBox(),this._procField("pre_defined","uint",32),this._procField("handler_type","string",4),this._procFieldArray("reserved",3,"uint",32),this._procField("name","string",-1)},a.prototype._boxProcessors.mdat=function(){this._procField("data","data",-1)},a.prototype._boxProcessors.mdhd=function(){this._procFullBox(),this._procField("creation_time","uint",1==this.version?64:32),this._procField("modification_time","uint",1==this.version?64:32),this._procField("timescale","uint",32),this._procField("duration","uint",1==this.version?64:32),this._parsing||"string"!=typeof this.language||(this.language=this.language.charCodeAt(0)-96<<10|this.language.charCodeAt(1)-96<<5|this.language.charCodeAt(2)-96),this._procField("language","uint",16),this._parsing&&(this.language=String.fromCharCode(96+(this.language>>10&31),96+(this.language>>5&31),96+(31&this.language))),this._procField("pre_defined","uint",16)},a.prototype._boxProcessors.mehd=function(){this._procFullBox(),this._procField("fragment_duration","uint",1==this.version?64:32)},a.prototype._boxProcessors.mfhd=function(){this._procFullBox(),this._procField("sequence_number","uint",32)},a.prototype._boxProcessors.mfro=function(){this._procFullBox(),this._procField("mfra_size","uint",32)},a.prototype._boxProcessors.mp4a=a.prototype._boxProcessors.enca=function(){this._procFieldArray("reserved1",6,"uint",8),this._procField("data_reference_index","uint",16),this._procFieldArray("reserved2",2,"uint",32),this._procField("channelcount","uint",16),this._procField("samplesize","uint",16),this._procField("pre_defined","uint",16),this._procField("reserved3","uint",16),this._procField("samplerate","template",32),this._procField("esds","data",-1)},a.prototype._boxProcessors.mvhd=function(){this._procFullBox(),this._procField("creation_time","uint",1==this.version?64:32),this._procField("modification_time","uint",1==this.version?64:32),this._procField("timescale","uint",32),this._procField("duration","uint",1==this.version?64:32),this._procField("rate","template",32),this._procField("volume","template",16),this._procField("reserved1","uint",16),this._procFieldArray("reserved2",2,"uint",32),this._procFieldArray("matrix",9,"template",32),this._procFieldArray("pre_defined",6,"uint",32),this._procField("next_track_ID","uint",32)},a.prototype._boxProcessors.payl=function(){this._procField("cue_text","utf8")},a.prototype._boxProcessors.pssh=function(){this._procFullBox(),this._procFieldArray("SystemID",16,"uint",8),this._procField("DataSize","uint",32),this._procFieldArray("Data",this.DataSize,"uint",8)},a.prototype._boxProcessors.schm=function(){this._procFullBox(),this._procField("scheme_type","uint",32),this._procField("scheme_version","uint",32),1&this.flags&&this._procField("scheme_uri","string",-1)},a.prototype._boxProcessors.sdtp=function(){this._procFullBox();var e=-1;this._parsing&&(e=this._raw.byteLength-(this._cursor.offset-this._raw.byteOffset)),this._procFieldArray("sample_dependency_table",e,"uint",8)},a.prototype._boxProcessors.sidx=function(){this._procFullBox(),this._procField("reference_ID","uint",32),this._procField("timescale","uint",32),this._procField("earliest_presentation_time","uint",1==this.version?64:32),this._procField("first_offset","uint",1==this.version?64:32),this._procField("reserved","uint",16),this._procField("reference_count","uint",16),this._procEntries("references",this.reference_count,(function(e){this._parsing||(e.reference=(1&e.reference_type)<<31,e.reference|=2147483647&e.referenced_size,e.sap=(1&e.starts_with_SAP)<<31,e.sap|=(3&e.SAP_type)<<28,e.sap|=268435455&e.SAP_delta_time),this._procEntryField(e,"reference","uint",32),this._procEntryField(e,"subsegment_duration","uint",32),this._procEntryField(e,"sap","uint",32),this._parsing&&(e.reference_type=e.reference>>31&1,e.referenced_size=2147483647&e.reference,e.starts_with_SAP=e.sap>>31&1,e.SAP_type=e.sap>>28&7,e.SAP_delta_time=268435455&e.sap)}))},a.prototype._boxProcessors.smhd=function(){this._procFullBox(),this._procField("balance","uint",16),this._procField("reserved","uint",16)},a.prototype._boxProcessors.ssix=function(){this._procFullBox(),this._procField("subsegment_count","uint",32),this._procEntries("subsegments",this.subsegment_count,(function(e){this._procEntryField(e,"ranges_count","uint",32),this._procSubEntries(e,"ranges",e.ranges_count,(function(e){this._procEntryField(e,"level","uint",8),this._procEntryField(e,"range_size","uint",24)}))}))},a.prototype._boxProcessors.stsd=function(){this._procFullBox(),this._procField("entry_count","uint",32),this._procSubBoxes("entries",this.entry_count)},a.prototype._boxProcessors.subs=function(){this._procFullBox(),this._procField("entry_count","uint",32),this._procEntries("entries",this.entry_count,(function(e){this._procEntryField(e,"sample_delta","uint",32),this._procEntryField(e,"subsample_count","uint",16),this._procSubEntries(e,"subsamples",e.subsample_count,(function(e){this._procEntryField(e,"subsample_size","uint",1===this.version?32:16),this._procEntryField(e,"subsample_priority","uint",8),this._procEntryField(e,"discardable","uint",8),this._procEntryField(e,"codec_specific_parameters","uint",32)}))}))},a.prototype._boxProcessors.tenc=function(){this._procFullBox(),this._procField("default_IsEncrypted","uint",24),this._procField("default_IV_size","uint",8),this._procFieldArray("default_KID",16,"uint",8)},a.prototype._boxProcessors.tfdt=function(){this._procFullBox(),this._procField("baseMediaDecodeTime","uint",1==this.version?64:32)},a.prototype._boxProcessors.tfhd=function(){this._procFullBox(),this._procField("track_ID","uint",32),1&this.flags&&this._procField("base_data_offset","uint",64),2&this.flags&&this._procField("sample_description_offset","uint",32),8&this.flags&&this._procField("default_sample_duration","uint",32),16&this.flags&&this._procField("default_sample_size","uint",32),32&this.flags&&this._procField("default_sample_flags","uint",32)},a.prototype._boxProcessors.tfra=function(){this._procFullBox(),this._procField("track_ID","uint",32),this._parsing||(this.reserved=0,this.reserved|=(48&this.length_size_of_traf_num)<<4,this.reserved|=(12&this.length_size_of_trun_num)<<2,this.reserved|=3&this.length_size_of_sample_num),this._procField("reserved","uint",32),this._parsing&&(this.length_size_of_traf_num=(48&this.reserved)>>4,this.length_size_of_trun_num=(12&this.reserved)>>2,this.length_size_of_sample_num=3&this.reserved),this._procField("number_of_entry","uint",32),this._procEntries("entries",this.number_of_entry,(function(e){this._procEntryField(e,"time","uint",1===this.version?64:32),this._procEntryField(e,"moof_offset","uint",1===this.version?64:32),this._procEntryField(e,"traf_number","uint",8*(this.length_size_of_traf_num+1)),this._procEntryField(e,"trun_number","uint",8*(this.length_size_of_trun_num+1)),this._procEntryField(e,"sample_number","uint",8*(this.length_size_of_sample_num+1))}))},a.prototype._boxProcessors.tkhd=function(){this._procFullBox(),this._procField("creation_time","uint",1==this.version?64:32),this._procField("modification_time","uint",1==this.version?64:32),this._procField("track_ID","uint",32),this._procField("reserved1","uint",32),this._procField("duration","uint",1==this.version?64:32),this._procFieldArray("reserved2",2,"uint",32),this._procField("layer","uint",16),this._procField("alternate_group","uint",16),this._procField("volume","template",16),this._procField("reserved3","uint",16),this._procFieldArray("matrix",9,"template",32),this._procField("width","template",32),this._procField("height","template",32)},a.prototype._boxProcessors.trex=function(){this._procFullBox(),this._procField("track_ID","uint",32),this._procField("default_sample_description_index","uint",32),this._procField("default_sample_duration","uint",32),this._procField("default_sample_size","uint",32),this._procField("default_sample_flags","uint",32)},a.prototype._boxProcessors.trun=function(){this._procFullBox(),this._procField("sample_count","uint",32),1&this.flags&&this._procField("data_offset","int",32),4&this.flags&&this._procField("first_sample_flags","uint",32),this._procEntries("samples",this.sample_count,(function(e){256&this.flags&&this._procEntryField(e,"sample_duration","uint",32),512&this.flags&&this._procEntryField(e,"sample_size","uint",32),1024&this.flags&&this._procEntryField(e,"sample_flags","uint",32),2048&this.flags&&this._procEntryField(e,"sample_composition_time_offset",1===this.version?"int":"uint",32)}))},a.prototype._boxProcessors["url "]=a.prototype._boxProcessors["urn "]=function(){this._procFullBox(),"urn "===this.type&&this._procField("name","string",-1),this._procField("location","string",-1)},a.prototype._boxProcessors.vlab=function(){this._procField("source_label","utf8")},a.prototype._boxProcessors.vmhd=function(){this._procFullBox(),this._procField("graphicsmode","uint",16),this._procFieldArray("opcolor",3,"uint",16)},a.prototype._boxProcessors.vttC=function(){this._procField("config","utf8")},a.prototype._boxProcessors.vtte=function(){}},function(e,t){var n,r,i=e.exports={};function a(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function s(e){if(n===setTimeout)return setTimeout(e,0);if((n===a||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:a}catch(e){n=a}try{r="function"==typeof clearTimeout?clearTimeout:o}catch(e){r=o}}();var u,l=[],c=!1,f=-1;function d(){c&&u&&(c=!1,u.length?l=u.concat(l):f=-1,l.length&&h())}function h(){if(!c){var e=s(d);c=!0;for(var t=l.length;t;){for(u=l,l=[];++f<t;)u&&u[f].run();f=-1,t=l.length}u=null,c=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===o||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function p(e,t){this.fun=e,this.array=t}function g(){}i.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];l.push(new p(e,t)),1!==l.length||c||s(h)},p.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=g,i.addListener=g,i.once=g,i.off=g,i.removeListener=g,i.removeAllListeners=g,i.emit=g,i.prependListener=g,i.prependOnceListener=g,i.listeners=function(e){return[]},i.binding=function(e){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(e){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(e,t,n){"use strict";var r=n(3);function i(){return{modifyRequestURL:function(e){return e},modifyRequestHeader:function(e){return e}}}i.__dashjs_factory_name="RequestModifier",t.a=r.a.getSingletonFactory(i)},function(e,t,n){"use strict";var r=n(3),i=n(8),a=n(1),o=n(9);function s(e){e=e||{};var t=this.context,n=e.dashMetrics;return{getMaxIndex:function(e){var r=Object(i.a)(t).create();if(!(e&&e.hasOwnProperty("getMediaInfo")&&e.hasOwnProperty("getMediaType")&&e.hasOwnProperty("useBufferOccupancyABR")&&e.hasOwnProperty("getAbrController")&&e.hasOwnProperty("getScheduleController")))return r;!function(){if(!n||!n.hasOwnProperty("getCurrentBufferState"))throw new Error(a.a.MISSING_CONFIG_ERROR)}();var s=e.getMediaInfo(),u=e.getMediaType(),l=n.getCurrentBufferState(u),c=e.getScheduleController(),f=e.getAbrController(),d=e.getStreamInfo(),h=d?d.id:null,p=d&&d.manifestInfo?d.manifestInfo.isDynamic:null,g=f.getThroughputHistory(),m=g.getSafeAverageThroughput(u,p),y=g.getAverageLatency(u),E=e.useBufferOccupancyABR();return isNaN(m)||!l||E||f.getAbandonmentStateFor(h,u)!==o.a.ABANDON_LOAD&&(l.state===o.a.BUFFER_LOADED||p)&&(r.quality=f.getQualityForBitrate(s,m,h,y),c.setTimeToLoadDelay(0),r.reason={throughput:m,latency:y}),r},reset:function(){}}}s.__dashjs_factory_name="ThroughputRule";var u=r.a.getClassFactory(s),l=n(7),c=n(2),f=n(6),d=n(4);function h(e){e=e||{};var t,n,r,s=this.context,u=Object(l.a)(s).getInstance(),h=e.dashMetrics;function p(){(r={})[a.a.VIDEO]={ignoreCount:2},r[a.a.AUDIO]={ignoreCount:2}}function g(){p()}function m(e){isNaN(e.startTime)||e.mediaType!==a.a.AUDIO&&e.mediaType!==a.a.VIDEO||r[e.mediaType].ignoreCount>0&&r[e.mediaType].ignoreCount--}return t={getMaxIndex:function(e){var t=Object(i.a)(s).create();if(!e||!e.hasOwnProperty("getMediaType"))return t;!function(){if(!h||!h.hasOwnProperty("getCurrentBufferLevel")||!h.hasOwnProperty("getCurrentBufferState"))throw new Error(a.a.MISSING_CONFIG_ERROR)}();var u=e.getMediaType(),l=h.getCurrentBufferState(u),c=e.getRepresentationInfo().fragmentDuration,f=e.getStreamInfo(),d=f?f.id:null,p=e.getScheduleController(),g=f&&f.manifestInfo&&f.manifestInfo.isDynamic;if(function(e,t){return!e&&r[t].ignoreCount>0}(p.getPlaybackController().getLowLatencyModeEnabled(),u)||!c)return t;if(l&&l.state===o.a.BUFFER_EMPTY)n.debug("["+u+"] Switch to index 0; buffer is empty."),t.quality=0,t.reason="InsufficientBufferRule: Buffer is empty";else{var m=e.getMediaInfo(),y=e.getAbrController(),E=y.getThroughputHistory(),_=h.getCurrentBufferLevel(u),T=E.getAverageThroughput(u,g),v=E.getAverageLatency(u),S=T*(_/c)*.5;t.quality=y.getQualityForBitrate(m,S,d,v),t.reason="InsufficientBufferRule: being conservative to avoid immediate rebuffering"}return t},reset:function(){p(),u.off(d.a.PLAYBACK_SEEKING,g,t),u.off(c.a.BYTES_APPENDED_END_FRAGMENT,m,t)}},n=Object(f.a)(s).getInstance().getLogger(t),p(),u.on(d.a.PLAYBACK_SEEKING,g,t),u.on(c.a.BYTES_APPENDED_END_FRAGMENT,m,t),t}h.__dashjs_factory_name="InsufficientBufferRule";var p=r.a.getClassFactory(h);function g(e){e=e||{};var t,n,r,a,o,s=this.context,u=e.mediaPlayerModel,l=e.dashMetrics,c=e.settings;function d(){r={},a={},o=[]}return t={shouldAbandon:function(e){var t=Object(i.a)(s).create(i.a.NO_CHANGE,{name:g.__dashjs_factory_name});if(!(e&&e.hasOwnProperty("getMediaInfo")&&e.hasOwnProperty("getMediaType")&&e.hasOwnProperty("getCurrentRequest")&&e.hasOwnProperty("getRepresentationInfo")&&e.hasOwnProperty("getAbrController")))return t;var f,d,h=e.getMediaInfo(),p=e.getMediaType(),m=e.getStreamInfo(),y=m?m.id:null,E=e.getCurrentRequest();if(!isNaN(E.index)){f=p,d=E.index,r[f]=r[f]||{},r[f][d]=r[f][d]||{};var _=u.getStableBufferTime();if(l.getCurrentBufferLevel(p)>_)return t;var T=r[p][E.index];if(null===T||null===E.firstByteDate||a.hasOwnProperty(T.id))return t;if(void 0===T.firstByteTime&&(o[p]=[],T.firstByteTime=E.firstByteDate.getTime(),T.segmentDuration=E.duration,T.bytesTotal=E.bytesTotal,T.id=E.index),T.bytesLoaded=E.bytesLoaded,T.elapsedTime=(new Date).getTime()-T.firstByteTime,T.bytesLoaded>0&&T.elapsedTime>0&&function(e,t){o[e]=o[e]||[],o[e].push(t)}(p,Math.round(8*T.bytesLoaded/T.elapsedTime)),o[p].length>=5&&T.elapsedTime>500&&T.bytesLoaded<T.bytesTotal){var v=o[p].reduce((function(e,t){return e+t}),0);if(T.measuredBandwidthInKbps=Math.round(v/o[p].length),T.estimatedTimeOfDownload=+(8*T.bytesTotal/T.measuredBandwidthInKbps/1e3).toFixed(2),T.estimatedTimeOfDownload<1.8*T.segmentDuration||0===e.getRepresentationInfo().quality)return t;if(!a.hasOwnProperty(T.id)){var S=e.getAbrController(),A=T.bytesTotal-T.bytesLoaded,b=S.getBitrateList(h),I=S.getQualityForBitrate(h,T.measuredBandwidthInKbps*c.get().streaming.abr.bandwidthSafetyFactor,y),R=S.getMinAllowedIndexFor(p,y),N=void 0!==R?Math.max(R,I):I;A>T.bytesTotal*b[N].bitrate/b[S.getQualityFor(p,y)].bitrate&&(t.quality=N,t.reason.throughput=T.measuredBandwidthInKbps,t.reason.fragmentID=T.id,a[T.id]=T,n.debug("["+p+"] frag id",T.id," is asking to abandon and switch to quality to ",N," measured bandwidth was",T.measuredBandwidthInKbps),delete r[p][T.id])}}else T.bytesLoaded===T.bytesTotal&&delete r[p][T.id]}return t},reset:d},n=Object(f.a)(s).getInstance().getLogger(t),d(),t}g.__dashjs_factory_name="AbandonRequestsRule";var m=r.a.getClassFactory(g);function y(){var e,t,n=this.context;return e={getMaxIndex:function(e){var r=Object(i.a)(n).create();if(!e||!e.hasOwnProperty("getDroppedFramesHistory"))return r;var a=e.getDroppedFramesHistory(),o=e.getStreamInfo().id;if(a){var s=a.getFrameHistory(o);if(!s||0===s.length)return r;for(var u=0,l=0,c=i.a.NO_CHANGE,f=1;f<s.length;f++)if(s[f]&&(u=s[f].droppedVideoFrames,(l=s[f].totalVideoFrames)>375&&u/l>.15)){c=f-1,t.debug("index: "+c+" Dropped Frames: "+u+" Total Frames: "+l);break}return Object(i.a)(n).create(c,{droppedFrames:u})}return r}},t=Object(f.a)(n).getInstance().getLogger(e),e}y.__dashjs_factory_name="DroppedFramesRule";var E=r.a.getClassFactory(y);function _(){var e,t,n=this.context;return e={getMaxIndex:function(e){for(var r=e?e.getSwitchHistory():null,a=r?r.getSwitchRequests():[],o=0,s=0,u=0,l=Object(i.a)(n).create(),c=0;c<a.length;c++)if(void 0!==a[c]&&(o+=a[c].drops,s+=a[c].noDrops,u+=a[c].dropSize,o+s>=6&&o/s>.075)){l.quality=c>0&&a[c].drops>0?c-1:c,l.reason={index:l.quality,drops:o,noDrops:s,dropSize:u},t.debug("Switch history rule index: "+l.quality+" samples: "+(o+s)+" drops: "+o);break}return l}},t=Object(f.a)(n).getInstance().getLogger(e),e}_.__dashjs_factory_name="SwitchHistoryRule";var T=r.a.getClassFactory(_),v=n(5);function S(e){e=e||{};var t,n,r,s=this.context,u=e.dashMetrics,h=e.mediaPlayerModel,p=Object(l.a)(s).getInstance();function g(e,t,n){var r=n.reduce((function(e,t,r){return t>n[e]?r:e}),0);if(0===r)return null;var i=Math.max(e,10+2*t.length),a=(n[r]-1)/(i/10-1);return{gp:a,Vp:10/a}}function m(e){var t={},n=e.getMediaInfo().bitrateList.map((function(e){return e.bandwidth})),r=function(e){return e.map((function(e){return Math.log(e)}))}(n);r=r.map((function(e){return e-r[0]+1}));var i=h.getStableBufferTime(),a=g(i,n,r);return a?(t.state=1,t.bitrates=n,t.utilities=r,t.stableBufferTime=i,t.Vp=a.Vp,t.gp=a.gp,t.lastQuality=0,y(t)):t.state=0,t}function y(e){e.placeholderBuffer=0,e.mostAdvancedSegmentStart=NaN,e.lastSegmentWasReplacement=!1,e.lastSegmentStart=NaN,e.lastSegmentDurationS=NaN,e.lastSegmentRequestTimeMs=NaN,e.lastSegmentFinishTimeMs=NaN}function E(e,t){var n=h.getStableBufferTime();if(e.stableBufferTime!==n){var r=g(n,e.bitrates,e.utilities);if(r.Vp!==e.Vp||r.gp!==e.gp){var i=u.getCurrentBufferLevel(t),a=i+e.placeholderBuffer;a-=10,a*=r.Vp/e.Vp,a+=10,e.stableBufferTime=n,e.Vp=r.Vp,e.gp=r.gp,e.placeholderBuffer=Math.max(0,a-i)}}}function _(e,t){return e.Vp*(e.utilities[t]+e.gp)}function T(e,t){for(var n=e.bitrates[t],r=e.utilities[t],i=0,a=t-1;a>=0;--a)if(e.utilities[a]<e.utilities[t]){var o=e.bitrates[a],s=e.utilities[a],u=e.Vp*(e.gp+(n*s-o*r)/(n-o));i=Math.max(i,u)}return i}function S(e){var t=e.mediaType===a.a.AUDIO?[a.a.AUDIO]:r;for(var n in t)r.hasOwnProperty(n)&&2===r[n].state&&(r[n].placeholderBuffer=0)}function A(){for(var e in r)if(r.hasOwnProperty(e)){var t=r[e];0!==t.state&&(t.state=1,y(t))}}function b(e){if(e&&e.chunk&&e.chunk.mediaInfo){var t=r[e.chunk.mediaInfo.type];if(t&&0!==t.state){var n=e.chunk.start;isNaN(t.mostAdvancedSegmentStart)||n>t.mostAdvancedSegmentStart?(t.mostAdvancedSegmentStart=n,t.lastSegmentWasReplacement=!1):t.lastSegmentWasReplacement=!0,t.lastSegmentStart=n,t.lastSegmentDurationS=e.chunk.duration,t.lastQuality=e.chunk.quality,R(t,e.chunk.mediaInfo.type)}}}function I(e){if(e&&e.metric===o.a.HTTP_REQUEST&&e.value&&e.value.type===v.a.MEDIA_SEGMENT_TYPE&&e.value.trace&&e.value.trace.length){var t=r[e.mediaType];t&&0!==t.state&&(t.lastSegmentRequestTimeMs=e.value.trequest.getTime(),t.lastSegmentFinishTimeMs=e.value._tfinish.getTime(),R(t,e.mediaType))}}function R(e,t){if(!isNaN(e.lastSegmentStart)&&!isNaN(e.lastSegmentRequestTimeMs)&&!isNaN(e.placeholderBuffer)){if(e.placeholderBuffer*=.99,!isNaN(e.lastSegmentFinishTimeMs)){var n=u.getCurrentBufferLevel(t)+.001*(e.lastSegmentFinishTimeMs-e.lastSegmentRequestTimeMs),r=_(e,e.lastQuality),i=Math.max(0,r-n);e.placeholderBuffer=Math.min(i,e.placeholderBuffer)}e.lastSegmentWasReplacement&&!isNaN(e.lastSegmentDurationS)&&(e.placeholderBuffer+=e.lastSegmentDurationS),e.lastSegmentStart=NaN,e.lastSegmentRequestTimeMs=NaN}}function N(e){if(e){var t=r[e.mediaType];t&&0!==t.state&&(t.abrQuality=e.newQuality)}}function C(e){if(e){var t=r[e.mediaType];if(t&&0!==t.state){var n,i=u.getCurrentBufferLevel(e.mediaType);n=t.abrQuality>0?T(t,t.abrQuality):10;var a=Math.max(0,n-i);t.placeholderBuffer=Math.min(t.placeholderBuffer,a)}}}function w(){r={}}return t={getMaxIndex:function(e){var t=Object(i.a)(s).create();if(!(e&&e.hasOwnProperty("getMediaInfo")&&e.hasOwnProperty("getMediaType")&&e.hasOwnProperty("getScheduleController")&&e.hasOwnProperty("getStreamInfo")&&e.hasOwnProperty("getAbrController")&&e.hasOwnProperty("useBufferOccupancyABR")))return t;var a=e.getMediaInfo(),o=e.getMediaType(),l=e.getScheduleController(),c=e.getStreamInfo(),f=e.getAbrController(),d=f.getThroughputHistory(),h=c?c.id:null,p=c&&c.manifestInfo&&c.manifestInfo.isDynamic,g=e.useBufferOccupancyABR();if(t.reason=t.reason||{},!g)return t;l.setTimeToLoadDelay(0);var v=function(e){var t=e.getMediaType(),n=r[t];return n?0!==n.state&&E(n,t):(n=m(e),r[t]=n),n}(e);if(0===v.state)return t;var S,A=u.getCurrentBufferLevel(o),b=d.getAverageThroughput(o,p),I=d.getSafeAverageThroughput(o,p),R=d.getAverageLatency(o);if(t.reason.state=v.state,t.reason.throughput=b,t.reason.latency=R,isNaN(b))return t;switch(v.state){case 1:S=f.getQualityForBitrate(a,I,h,R),t.quality=S,t.reason.throughput=I,v.placeholderBuffer=Math.max(0,T(v,S)-A),v.lastQuality=S,!isNaN(v.lastSegmentDurationS)&&A>=v.lastSegmentDurationS&&(v.state=2);break;case 2:!function(e,t){var n=Date.now();if(isNaN(e.lastSegmentFinishTimeMs)){if(!isNaN(e.lastCallTimeMs)){var r=.001*(n-e.lastCallTimeMs);e.placeholderBuffer+=Math.max(0,r)}}else{var i=.001*(n-e.lastSegmentFinishTimeMs);e.placeholderBuffer+=Math.max(0,i)}e.lastCallTimeMs=n,e.lastSegmentStart=NaN,e.lastSegmentRequestTimeMs=NaN,e.lastSegmentFinishTimeMs=NaN,E(e,t)}(v,o),S=function(e,t){for(var n=e.bitrates.length,r=NaN,i=NaN,a=0;a<n;++a){var o=(e.Vp*(e.utilities[a]+e.gp)-t)/e.bitrates[a];(isNaN(i)||o>=i)&&(i=o,r=a)}return r}(v,A+v.placeholderBuffer);var N=f.getQualityForBitrate(a,I,h,R);S>v.lastQuality&&S>N&&(S=Math.max(N,v.lastQuality));var C=Math.max(0,A+v.placeholderBuffer-_(v,S));C<=v.placeholderBuffer?(v.placeholderBuffer-=C,C=0):(C-=v.placeholderBuffer,v.placeholderBuffer=0,S<f.getMaxAllowedIndexFor(o,h)?l.setTimeToLoadDelay(1e3*C):C=0),t.quality=S,t.reason.throughput=b,t.reason.latency=R,t.reason.bufferLevel=A,t.reason.placeholderBuffer=v.placeholderBuffer,t.reason.delay=C,v.lastQuality=S;break;default:n.debug("BOLA ABR rule invoked in bad state."),t.quality=f.getQualityForBitrate(a,I,h,R),t.reason.state=v.state,t.reason.throughput=I,t.reason.latency=R,v.state=1,y(v)}return t},reset:function(){w(),p.off(d.a.BUFFER_EMPTY,S,t),p.off(d.a.PLAYBACK_SEEKING,A,t),p.off(d.a.METRIC_ADDED,I,t),p.off(d.a.QUALITY_CHANGE_REQUESTED,N,t),p.off(d.a.FRAGMENT_LOADING_ABANDONED,C,t),p.off(c.a.MEDIA_FRAGMENT_LOADED,b,t)}},n=Object(f.a)(s).getInstance().getLogger(t),w(),p.on(d.a.BUFFER_EMPTY,S,t),p.on(d.a.PLAYBACK_SEEKING,A,t),p.on(d.a.METRIC_ADDED,I,t),p.on(d.a.QUALITY_CHANGE_REQUESTED,N,t),p.on(d.a.FRAGMENT_LOADING_ABANDONED,C,t),p.on(c.a.MEDIA_FRAGMENT_LOADED,b,t),t}S.__dashjs_factory_name="BolaRule";var A=r.a.getClassFactory(S);function b(e){e=e||{};var t,n,r,s,u=this.context,d=e.dashMetrics,h=Object(l.a)(u).getInstance();function p(e){var t={},n=e.getMediaInfo(),i=n.bitrateList.map((function(e){return e.bandwidth/1e3}));return t.state=1,t.bitrates=i,t.lastQuality=0,function(e){if(!e||!e.type)return;r[e.type]={},r[e.type].w=[],r[e.type].prev_w=[],r[e.type].Q=0,r[e.type].segment_request_start_s=0,r[e.type].segment_download_finish_s=0,r[e.type].B_target=1.5}(n),g(t),t}function g(e){e.placeholderBuffer=0,e.mostAdvancedSegmentStart=NaN,e.lastSegmentWasReplacement=!1,e.lastSegmentStart=NaN,e.lastSegmentDurationS=NaN,e.lastSegmentRequestTimeMs=NaN,e.lastSegmentFinishTimeMs=NaN}function m(){for(var e in n)if(n.hasOwnProperty(e)){var t=n[e];0!==t.state&&(t.state=1,g(t))}}function y(e){if(e&&e.chunk&&e.chunk.mediaInfo){var t=n[e.chunk.mediaInfo.type],i=r[e.chunk.mediaInfo.type];if(t&&0!==t.state){var a=e.chunk.start;isNaN(t.mostAdvancedSegmentStart)||a>t.mostAdvancedSegmentStart?(t.mostAdvancedSegmentStart=a,t.lastSegmentWasReplacement=!1):t.lastSegmentWasReplacement=!0,t.lastSegmentStart=a,t.lastSegmentDurationS=e.chunk.duration,t.lastQuality=e.chunk.quality,_(t,i)}}}function E(e){if(e&&e.metric===o.a.HTTP_REQUEST&&e.value&&e.value.type===v.a.MEDIA_SEGMENT_TYPE&&e.value.trace&&e.value.trace.length){var t=n[e.mediaType],i=r[e.mediaType];t&&0!==t.state&&(t.lastSegmentRequestTimeMs=e.value.trequest.getTime(),t.lastSegmentFinishTimeMs=e.value._tfinish.getTime(),_(t,i))}}function _(e,t){isNaN(e.lastSegmentStart)||isNaN(e.lastSegmentRequestTimeMs)||(t.segment_request_start_s=.001*e.lastSegmentRequestTimeMs,t.segment_download_finish_s=.001*e.lastSegmentFinishTimeMs,e.lastSegmentStart=NaN,e.lastSegmentRequestTimeMs=NaN)}function T(e){if(e&&e.mediaType){var t=n[e.mediaType];t&&0!==t.state&&(t.abrQuality=e.newQuality)}}function S(e,t){if(e.length!==t.length)return-1;for(var n=0,r=0;r<e.length;r++)n+=e[r]*t[r];return n}function A(){n={},r={}}return t={getMaxIndex:function(e){var t,o=Object(i.a)(u).create(),l=Math.pow(4,.99),c=Math.max(Math.pow(4,1),l*Math.sqrt(4)),f=e.getMediaInfo(),h=e.getMediaType(),m=f.bitrateList.map((function(e){return e.bandwidth})),y=m.length,E=e.getScheduleController(),_=e.getStreamInfo(),T=e.getAbrController(),v=T.getThroughputHistory(),A=_&&_.manifestInfo&&_.manifestInfo.isDynamic,b=e.useL2AABR(),I=d.getCurrentBufferLevel(h,!0),R=v.getSafeAverageThroughput(h,A),N=v.getAverageThroughput(h,A),C=v.getAverageLatency(h),w=e.getVideoModel().getPlaybackRate();if(!(e&&e.hasOwnProperty("getMediaInfo")&&e.hasOwnProperty("getMediaType")&&e.hasOwnProperty("getScheduleController")&&e.hasOwnProperty("getStreamInfo")&&e.hasOwnProperty("getAbrController")&&e.hasOwnProperty("useL2AABR")))return o;if(o.reason=o.reason||{},!b||h===a.a.AUDIO)return o;E.setTimeToLoadDelay(0);var D=function(e){var t=e.getMediaType(),r=n[t];return r||(r=p(e),n[t]=r),r}(e);if(0===D.state)return o;var O=r[h];if(!O)return o;if(o.reason.state=D.state,o.reason.throughput=N,o.reason.latency=C,isNaN(N))return o;switch(D.state){case 1:if(t=T.getQualityForBitrate(f,R,_.id,C),o.quality=t,o.reason.throughput=R,D.lastQuality=t,!isNaN(D.lastSegmentDurationS)&&I>=O.B_target){D.state=2,O.Q=l;for(var M=0;M<y;++M)M===D.lastQuality?O.prev_w[M]=1:O.prev_w[M]=0}break;case 2:var P=[],L=d.getCurrentHttpRequest(h).trace.reduce((function(e,t){return e+t.d}),0),F=d.getCurrentHttpRequest(h).trace.reduce((function(e,t){return e+t.b[0]}),0),x=Math.round(8*F/L);x<1&&(x=1);for(var U=D.lastSegmentDurationS,B=1,k=0;k<y;++k)m[k]=m[k]/1e3,w*m[k]>x&&(B=-1),O.w[k]=O.prev_w[k]+B*(U/(2*c))*((O.Q+l)*(w*m[k]/x));O.w=function(e){for(var t=e.length,n=!1,r=[],i=0;i<t;++i)r[i]=e[i];for(var a=e.sort((function(e,t){return t-e})),o=0,s=0,u=[],l=0;l<t-1;++l)if((s=((o+=a[l])-1)/(l+1))>=a[l+1]){n=!0;break}n||(s=(o+a[t-1]-1)/t);for(var c=0;c<t;++c)u[c]=Math.max(r[c]-s,0);return u}(O.w);for(var G=0;G<y;++G)P[G]=O.w[G]-O.prev_w[G],O.prev_w[G]=O.w[G];O.Q=Math.max(0,O.Q-U+U*w*((S(m,O.prev_w)+S(m,P))/x));for(var j=[],Y=0;Y<y;++Y)j[Y]=Math.abs(m[Y]-S(O.w,m));(t=j.indexOf(Math.min.apply(Math,j)))>D.lastQuality&&m[D.lastQuality+1]<=x&&(t=D.lastQuality+1),m[t]>=x&&(O.Q=2*Math.max(l,O.Q)),o.quality=t,o.reason.throughput=N,o.reason.latency=C,o.reason.bufferLevel=I,D.lastQuality=o.quality;break;default:s.debug("L2A ABR rule invoked in bad state."),o.quality=T.getQualityForBitrate(f,R,_.id,C),o.reason.state=D.state,o.reason.throughput=R,o.reason.latency=C,D.state=1,g(D)}return o},reset:function(){A(),h.off(c.a.PLAYBACK_SEEKING,m,t),h.off(c.a.MEDIA_FRAGMENT_LOADED,y,t),h.off(c.a.METRIC_ADDED,E,t),h.off(c.a.QUALITY_CHANGE_REQUESTED,T,t)}},s=Object(f.a)(u).getInstance().getLogger(t),A(),h.on(c.a.PLAYBACK_SEEKING,m,t),h.on(c.a.MEDIA_FRAGMENT_LOADED,y,t),h.on(c.a.METRIC_ADDED,E,t),h.on(c.a.QUALITY_CHANGE_REQUESTED,T,t),t}b.__dashjs_factory_name="L2ARule";var I=r.a.getClassFactory(b),R="manual_weight_selection",N="random_weight_selection",C="dynamic_weight_selection";function w(){var e,t,n,r,i,a,o,s,u,l=this.context;function c(){n=null,r=1,i=100,a=0,o=null,s=null,u=C}function d(){var e=0;if(n)for(var t=0;t<n.length;t++){var r=n[t];r.state.throughput>e&&(e=r.state.throughput)}return e}function h(e,t,n){var r=e.map((function(e,r){return n[r]*Math.pow(e-t[r],2)})).reduce((function(e,t){return e+t}));return(r<0?-1:1)*Math.sqrt(Math.abs(r))}function p(e,t){return h([e.state.throughput,e.state.latency,e.state.rebuffer,e.state.switch],[t.state.throughput,t.state.latency,t.state.rebuffer,t.state.switch],[1,1,1,1])}function g(e,t,n){for(var r=0;r<t.length;r++){var i=t[r],a=p(i,e);m(i,n,Math.exp(-1*Math.pow(a,2)/(2*Math.pow(.1,2))))}}function m(e,t,n){var r=e.state,i=[.01,.01,.01,.01];r.throughput=r.throughput+(t[0]-r.throughput)*i[0]*n,r.latency=r.latency+(t[1]-r.latency)*i[1]*n,r.rebuffer=r.rebuffer+(t[2]-r.rebuffer)*i[2]*n,r.switch=r.switch+(t[3]-r.switch)*i[3]*n}function y(e,t,n,r,i,a,u){o||(o=s[s.length-1]);var l=e.findWeightVector(t,n,r,i,a,u);null!==l&&-1!==l&&(o=l)}return e={getNextQuality:function(e,l,c,f,p,m,E){var _=c,T=f,v=l,S=function(e){if(!n){n=[];var t=e.bitrateList,i=[];a=t[0].bandwidth,t.forEach((function(e){i.push(e.bandwidth),e.bandwidth<a&&(a=e.bandwidth)})),l=i.map((function(e){return Math.pow(e,2)})).reduce((function(e,t){return e+t})),r=Math.sqrt(l);for(var o=0;o<t.length;o++){var u={qualityIndex:o,bitrate:t[o].bandwidth,state:{throughput:t[o].bandwidth/r,latency:0,rebuffer:0,switch:0}};n.push(u)}s=function(e){var t=[],n=function(e){for(var t=[],n=0;n<e;n++){var r=[Math.random()*d(),Math.random(),Math.random(),Math.random()];t.push(r)}return t}(Math.pow(e.length,2));t.push(n[0]);for(var r=[1,1,1,1],i=1;i<e.length;i++){for(var a=null,o=null,s=0;s<n.length;s++){for(var u=n[s],l=null,c=0;c<t.length;c++){var f=h(u,t[c],r);(null===l||f<l)&&(l=f)}(null===o||l>o)&&(a=u,o=l)}t.push(a)}for(var p=null,g=null,m=0;m<t.length;m++){for(var y=0,E=0;E<t.length;E++)m!==E&&(y+=h(t[m],t[E],r));(null===p||y>p)&&(p=y,g=m)}var _=[];_.push(t[g]),t.splice(g,1);for(;t.length>0;){for(var T=null,v=null,S=0;S<t.length;S++){var A=h(_[0],t[S],r);(null===T||A<T)&&(T=A,v=S)}_.push(t[v]),t.splice(v,1)}return _}(n)}var l;return n}(e),A=l/r;A>1&&(A=d()),c/=i,t.debug("getNextQuality called throughput:".concat(A," latency:").concat(c," bufferSize:").concat(f," currentQualityIndex:").concat(m," playbackRate:").concat(p));var b=S[m],I=b.bitrate*E.getSegmentDuration()/v,w=Math.max(0,I-T);if(T-I<E.getMinBuffer())return t.debug("Buffer is low for bitrate= ".concat(b.bitrate," downloadTime=").concat(I," currentBuffer=").concat(T," rebuffer=").concat(w)),function(e,t){var r=0,i=e;if(n)for(var a=0;a<n.length;a++){var o=n[a];o.bitrate<e.bitrate&&o.bitrate>r&&t>o.bitrate&&(r=o.bitrate,i=o)}return i}(b,v).qualityIndex;switch(u){case R:o=[.4,.4,.4,.4];break;case N:!function(e){o=function(e,t){for(var n=[],r=Math.sqrt(2/e),i=0;i<t;i++)n.push(Math.random()*r);return o=n}(e.length,4)}(S);break;case C:y(E,S,_,T,w,v,p);break;default:y(E,S,_,T,w,v,p)}for(var D=null,O=null,M=null,P=0;P<S.length;P++){var L=S[P],F=L.state,x=[F.throughput,F.latency,F.rebuffer,F.switch],U=o.slice(),B=E.getNextBufferWithBitrate(L.bitrate,T,v),k=B<E.getMinBuffer();k&&t.debug("Buffer is low for bitrate=".concat(L.bitrate," downloadTime=").concat(I," currentBuffer=").concat(T," nextBuffer=").concat(B)),(L.bitrate>l-1e4||k)&&L.bitrate!==a&&(U[0]=100);var G=h(x,[A,0,0,0],U);(null===D||G<D)&&(D=G,O=L.qualityIndex,M=L)}var j=Math.abs(b.bitrate-M.bitrate)/r;return g(b,S,[A,c,w,j]),g(M,S,[A,0,0,j]),O},reset:function(){c()}},t=Object(f.a)(l).getInstance().getLogger(e),c(),e}w.__dashjs_factory_name="LearningAbrController";var D=r.a.getClassFactory(w);var O=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.type=null,this.lastBitrate=null,this.weights={},this.weights.bitrateReward=null,this.weights.bitrateSwitchPenalty=null,this.weights.rebufferPenalty=null,this.weights.latencyPenalty=null,this.weights.playbackSpeedPenalty=null,this.bitrateWSum=0,this.bitrateSwitchWSum=0,this.rebufferWSum=0,this.latencyWSum=0,this.playbackSpeedWSum=0,this.totalQoe=0};function M(){var e,t,n,r,i;function a(){t=null,n=null,r=null,i=null}function o(e,t,n,r){var i=new O;return i.type=e,i.weights.bitrateReward=t||1,i.weights.bitrateSwitchPenalty=1,i.weights.rebufferPenalty=n||1e3,i.weights.latencyPenalty=[],i.weights.latencyPenalty.push({threshold:1.1,penalty:.05*r}),i.weights.latencyPenalty.push({threshold:1e8,penalty:.1*n}),i.weights.playbackSpeedPenalty=r||200,i}function s(e,t,n,r,i){i.bitrateWSum+=i.weights.bitrateReward*e,i.lastBitrate&&(i.bitrateSwitchWSum+=i.weights.bitrateSwitchPenalty*Math.abs(e-i.lastBitrate)),i.lastBitrate=e,i.rebufferWSum+=i.weights.rebufferPenalty*t;for(var a=0;a<i.weights.latencyPenalty.length;a++){var o=i.weights.latencyPenalty[a];if(n<=o.threshold){i.latencyWSum+=o.penalty*n;break}}i.playbackSpeedWSum+=i.weights.playbackSpeedPenalty*Math.abs(1-r),i.totalQoe=i.bitrateWSum-i.bitrateSwitchWSum-i.rebufferWSum-i.latencyWSum-i.playbackSpeedWSum}return e={setupPerSegmentQoe:function(e,a,s){t=o("segment",e,a,s),n=e,r=a,i=s},logSegmentMetrics:function(e,n,r,i){t&&s(e,n,r,i,t)},getPerSegmentQoe:function(){return t},calculateSingleUseQoe:function(e,t,a,u){var l=null;return n&&r&&i&&(l=o("segment",n,r,i)),l?(s(e,t,a,u,l),l.totalQoe):0},reset:function(){a()}},a(),e}M.__dashjs_factory_name="LoLpQoeEvaluator";var P=r.a.getClassFactory(M);function L(e){var t,n,r,i,a,o=e.targetLatency,s=e.bufferMin,u=e.segmentDuration,l=e.qoeEvaluator;function c(){return u}function f(e,t){var n=c();return t>n?e-n:e+n-t}return t={getMinBuffer:function(){return s},getSegmentDuration:c,getNextBufferWithBitrate:function(e,t,n){return f(t,e*u/n)},getNextBuffer:f,findWeightVector:function(e,t,i,a,c,d){var h=null,p=null,g=null,m=Math.abs(t-r);return e.forEach((function(e){n.forEach((function(n){n[0];var r=n[1],a=n[2],y=(n[3],e.bitrate*u/c),E=f(i,y),_=(0===a?10:1/a)*Math.max(1e-5,y-E),T=(0===r?10:1/r)*e.state.latency,v=l.calculateSingleUseQoe(e.bitrate,_,T,d);(null===h||v>h)&&function(e,t,n){if(e>o+n)return!1;return t>=s}(t,E,m)&&(h=v,p=n,g=e.bitrate)}))})),null===p&&null===g&&(p=-1),r=t,p}},i=[.2,.4,.6,.8,1],a=4,n=function e(t,n,r){if(r===n)return t;for(var a=t.length,o=0;o<a;o++)for(var s=t.shift(),u=0;u<i.length;u++)t.push(s.concat(i[u]));return e(t,n,r+1)}(i.map((function(e){return[e]})),a,1),r=0,t}L.__dashjs_factory_name="LoLpWeightSelector";var F=r.a.getClassFactory(L);function x(e){var t,n,r,s,u=(e=e||{}).dashMetrics,l=this.context;return n={getMaxIndex:function(e){try{var n=Object(i.a)(l).create(),c=e.getMediaInfo().type,f=e.getAbrController(),d=e.getStreamInfo(),h=f.getQualityFor(c,d.id),p=e.getMediaInfo(),g=u.getCurrentBufferState(c),m=e.getScheduleController(),y=u.getCurrentBufferLevel(c,!0),E=d&&d.manifestInfo?d.manifestInfo.isDynamic:null,_=m.getPlaybackController(),T=_.getCurrentLiveLatency();if(!e.useLoLPABR()||c===a.a.AUDIO)return n;T||(T=0);var v=_.getPlaybackRate(),S=f.getThroughputHistory().getSafeAverageThroughput(c,E);if(t.debug("Throughput ".concat(Math.round(S)," kbps")),isNaN(S)||!g)return n;if(f.getAbandonmentStateFor(d.id,c)===o.a.ABANDON_LOAD)return n;for(var A=p.bitrateList,b=e.getRepresentationInfo().fragmentDuration,I=A[0].bandwidth/1e3,R=A[A.length-1].bandwidth/1e3,N=0;N<A.length;N++){var C=A[N].bandwidth/1e3;C>R?R=C:C<I&&(I=C)}var w=A[h].bandwidth/1e3,D=u.getCurrentHttpRequest(c,!0),O=(D.tresponse.getTime()-D.trequest.getTime())/1e3,M=O>b?O-b:0;s.setupPerSegmentQoe(b,R,I),s.logSegmentMetrics(w,M,T,v);var P=F(l).create({targetLatency:1.5,bufferMin:.3,segmentDuration:b,qoeEvaluator:s});return n.quality=r.getNextQuality(p,1e3*S,T,y,v,h,P),n.reason={throughput:S,latency:T},n.priority=i.a.PRIORITY.STRONG,m.setTimeToLoadDelay(0),n.quality!==h&&console.log("[TgcLearningRule]["+c+"] requesting switch to index: ",n.quality,"Average throughput",Math.round(S),"kbps"),n}catch(e){throw e}},reset:function(){r.reset(),s.reset()}},t=Object(f.a)(l).getInstance().getLogger(n),r=D(l).create(),s=P(l).create(),n}x.__dashjs_factory_name="LoLPRule";var U=r.a.getClassFactory(x);function B(e){e=e||{};var t,n,r=this.context,o=e.mediaPlayerModel,s=e.customParametersModel,l=e.dashMetrics,c=e.settings;function f(e){return e.filter((function(e){return e.quality>i.a.NO_CHANGE}))}function d(e){var t,n,a,o,s,u={},l=null;if(0!==e.length){for(u[i.a.PRIORITY.STRONG]={quality:i.a.NO_CHANGE,reason:null},u[i.a.PRIORITY.WEAK]={quality:i.a.NO_CHANGE,reason:null},u[i.a.PRIORITY.DEFAULT]={quality:i.a.NO_CHANGE,reason:null},t=0,n=e.length;t<n;t+=1)(a=e[t]).quality!==i.a.NO_CHANGE&&(u[a.priority].quality===i.a.NO_CHANGE||u[a.priority].quality>a.quality)&&(u[a.priority].quality=a.quality,u[a.priority].reason=a.reason||null);return u[i.a.PRIORITY.WEAK].quality!==i.a.NO_CHANGE&&(l=u[i.a.PRIORITY.WEAK]),u[i.a.PRIORITY.DEFAULT].quality!==i.a.NO_CHANGE&&(l=u[i.a.PRIORITY.DEFAULT]),u[i.a.PRIORITY.STRONG].quality!==i.a.NO_CHANGE&&(l=u[i.a.PRIORITY.STRONG]),l&&(o=l.quality,s=l.reason),Object(i.a)(r).create(o,s)}}return{initialize:function(){t=[],n=[],c.get().streaming.abr.useDefaultABRRules&&(c.get().streaming.abr.ABRStrategy===a.a.ABR_STRATEGY_L2A?t.push(I(r).create({dashMetrics:l,settings:c})):c.get().streaming.abr.ABRStrategy===a.a.ABR_STRATEGY_LoLP?t.push(U(r).create({dashMetrics:l})):(t.push(A(r).create({dashMetrics:l,mediaPlayerModel:o,settings:c})),t.push(u(r).create({dashMetrics:l})),c.get().streaming.abr.additionalAbrRules.insufficientBufferRule&&t.push(p(r).create({dashMetrics:l,settings:c})),c.get().streaming.abr.additionalAbrRules.switchHistoryRule&&t.push(T(r).create()),c.get().streaming.abr.additionalAbrRules.droppedFramesRule&&t.push(E(r).create()),c.get().streaming.abr.additionalAbrRules.abandonRequestsRule&&n.push(m(r).create({dashMetrics:l,mediaPlayerModel:o,settings:c})))),s.getAbrCustomRules().forEach((function(e){"qualitySwitchRules"===e.type&&t.push(e.rule(r).create()),"abandonFragmentRules"===e.type&&n.push(e.rule(r).create())}))},reset:function(){[t,n].forEach((function(e){e&&e.length&&e.forEach((function(e){return e.reset&&e.reset()}))})),t=[],n=[]},getMaxQuality:function(e){return d(f(t.map((function(t){return t.getMaxIndex(e)}))))||Object(i.a)(r).create()},getMinSwitchRequest:d,shouldAbandonFragment:function(e,t){return d(f(n.map((function(n){return n.shouldAbandon(e,t)}))))||Object(i.a)(r).create()},getQualitySwitchRules:function(){return t}}}B.__dashjs_factory_name="ABRRulesCollection";var k=r.a.getClassFactory(B);k.QUALITY_SWITCH_RULES="qualitySwitchRules",k.ABANDON_FRAGMENT_RULES="abandonFragmentRules",r.a.updateSingletonFactory(B.__dashjs_factory_name,k);t.a=k},function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n,i;return t=e,(n=[{key:"extend",value:function(e,t){if(e){var n=!!t&&t.override,r=!!t&&t.publicOnly;for(var i in e)!e.hasOwnProperty(i)||this[i]&&!n||r&&-1===e[i].indexOf("public_")||(this[i]=e[i])}}}])&&r(t.prototype,n),i&&r(t,i),e}();t.a=i},function(e,t,n){"use strict";var r=n(3);function i(e){var t=(e=e||{}).requestModifier;return{load:function(e){var n=new Date,r=e.request,i=new XMLHttpRequest;if(i.open(e.method,e.url,!0),r.responseType&&(i.responseType=r.responseType),r.range&&i.setRequestHeader("Range","bytes="+r.range),r.requestStartDate||(r.requestStartDate=n),t&&(i=t.modifyRequestHeader(i)),e.headers)for(var a in e.headers){var o=e.headers[a];o&&i.setRequestHeader(a,o)}i.withCredentials=e.withCredentials,i.onload=e.onload,i.onloadend=e.onend,i.onerror=e.onerror,i.onprogress=e.progress,i.onabort=e.onabort,i.ontimeout=e.ontimeout,i.timeout=e.timeout,i.send(),e.response=i},abort:function(e){var t=e.response;t.onloadend=t.onerror=t.onprogress=void 0,t.abort()}}}i.__dashjs_factory_name="XHRLoader";var a=r.a.getClassFactory(i);t.a=a},function(e,t,n){"use strict";t.a=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.schemeIdUri="",this.value=""}},function(e,t,n){"use strict";var r=n(30),i=n(3),a=n(16),o=n(14),s=n(27),u=n(1);function l(){var e,t,n,i,l,c,f,d,h=this.context,p=Object(a.a)(h).getInstance();function g(){i=[],l=[],c=[],d=[],f=null,t=[]}function m(e,t){var n=-1;e.some((function(e,r){if(e===t)return n=r,!0})),n<0||e.splice(n,1)}function y(e){var t;for(t=0;t<d.length;t++)if(d[t].rulename===e)return t;return-1}function E(e,n){_(e,n);var i=new r.a;i.schemeIdUri=e,i.value=n,t.push(i)}function _(e,n){Object(o.b)(e,"string"),Object(o.b)(n,"string"),t.forEach((function(r,i){r.schemeIdUri===e&&r.value===n&&t.splice(i,1)}))}return e={getCustomInitialTrackSelectionFunction:function(){return f},setCustomInitialTrackSelectionFunction:function(e){f=e},resetCustomInitialTrackSelectionFunction:function(){f=null},getLicenseResponseFilters:function(){return l},getLicenseRequestFilters:function(){return i},getCustomCapabilitiesFilters:function(){return c},registerCustomCapabilitiesFilter:function(e){c.push(e)},registerLicenseResponseFilter:function(e){l.push(e)},registerLicenseRequestFilter:function(e){i.push(e)},unregisterCustomCapabilitiesFilter:function(e){m(c,e)},unregisterLicenseResponseFilter:function(e){m(l,e)},unregisterLicenseRequestFilter:function(e){m(i,e)},addAbrCustomRule:function(e,t,n){if("string"!=typeof e||e!==s.a.ABANDON_FRAGMENT_RULES&&e!==s.a.QUALITY_SWITCH_RULES||"string"!=typeof t)throw u.a.BAD_ARGUMENT_ERROR;var r=y(t);-1===r?d.push({type:e,rulename:t,rule:n}):(d[r].type=e,d[r].rule=n)},removeAllAbrCustomRule:function(){d=[]},removeAbrCustomRule:function(e){if(e){var t=y(e);-1!==t&&d.splice(t,1)}else d=[]},getAbrCustomRules:function(){return d},addUTCTimingSource:E,removeUTCTimingSource:_,getUTCTimingSources:function(){return t},clearDefaultUTCTimingSources:function(){t=[]},restoreDefaultUTCTimingSources:function(){var e=p.get().streaming.utcSynchronization.defaultTimingSource;E(e.scheme,e.value)},setXHRWithCredentialsForType:function e(t,r){t?n[t]=!!r:Object.keys(n).forEach((function(t){e(t,r)}))},getXHRWithCredentialsForType:function(e){var t=n[e];return void 0===t?n.default:t},setConfig:function(){},reset:function(){g()}},n={default:!1},g(),e}l.__dashjs_factory_name="CustomParametersModel",t.a=i.a.getSingletonFactory(l)},function(e,t,n){"use strict";t.a=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.indexRange=null,this.index=null,this.mediaRange=null,this.media=null,this.duration=NaN,this.replacementTime=null,this.replacementNumber=NaN,this.mediaStartTime=NaN,this.presentationStartTime=NaN,this.availabilityStartTime=NaN,this.availabilityEndTime=NaN,this.wallStartTime=NaN,this.representation=null}},function(e,t,n){"use strict";var r=n(1),i=n(0);function a(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var o=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.index=-1,this.adaptation=null,this.segmentInfoType=null,this.initialization=null,this.codecs=null,this.mimeType=null,this.codecPrivateData=null,this.segmentDuration=NaN,this.timescale=1,this.startNumber=1,this.indexRange=null,this.range=null,this.presentationTimeOffset=0,this.MSETimeOffset=NaN,this.mediaFinishedInformation={numberOfSegments:0,mediaTimeOfLastSignaledSegment:NaN},this.bandwidth=NaN,this.width=NaN,this.height=NaN,this.scanType=null,this.maxPlayoutRate=NaN,this.availabilityTimeOffset=0,this.availabilityTimeComplete=!0}var t,n,r;return t=e,(n=[{key:"hasInitialization",value:function(){return null!==this.initialization||null!==this.range}},{key:"hasSegments",value:function(){return this.segmentInfoType!==i.a.BASE_URL&&this.segmentInfoType!==i.a.SEGMENT_BASE&&!this.indexRange}}])&&a(t.prototype,n),r&&a(t,r),e}();var s=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.period=null,this.index=-1,this.type=null};var u=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.index=-1,this.duration=NaN,this.start=NaN,this.mpd=null,this.nextPeriodId=null};u.DEFAULT_ID="defaultId";var l=u;var c=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.manifest=null,this.suggestedPresentationDelay=0,this.availabilityStartTime=null,this.availabilityEndTime=Number.POSITIVE_INFINITY,this.timeShiftBufferDepth=Number.POSITIVE_INFINITY,this.maxSegmentDuration=Number.POSITIVE_INFINITY,this.publishTime=null,this.minimumUpdatePeriod=NaN,this.mediaPresentationDuration=NaN},f=n(30),d=n(43),h=n(39);var p=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.adaptionSet=null,this.representation=null,this.period=null,this.timescale=1,this.value="",this.schemeIdUri="",this.presentationTimeOffset=0};var g=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.inband=!1,this.type="encoder",this.applicationScheme=null,this.wallClockTime=null,this.presentationTime=NaN,this.UTCTiming=null},m=n(44),y=n(13),E=n(3),_=n(6),T=n(10),v=n(11),S=n(34);function A(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=I(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,i=function(){};return{s:i,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,o=!0,s=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return o=e.done,e},e:function(e){s=!0,a=e},f:function(){try{o||null==n.return||n.return()}finally{if(s)throw a}}}}function b(e){return function(e){if(Array.isArray(e))return R(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||I(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function I(e,t){if(e){if("string"==typeof e)return R(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?R(e,t):void 0}}function R(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function N(){var e,t,n,a,u=this.context,E=Object(y.a)(u).getInstance(),I=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e};function R(e,t){if(!e)throw new Error("adaptation is not defined");if(!t)throw new Error("type is not defined");if(e.Representation_asArray&&e.Representation_asArray.length){var n=U(e.Representation_asArray[0]);if(n&&n.length>0&&S.a.indexOf(n[0].schemeIdUri)>=0)return t===r.a.IMAGE}if(e.ContentComponent_asArray&&e.ContentComponent_asArray.length>0){if(e.ContentComponent_asArray.length>1)return t===r.a.MUXED;if(e.ContentComponent_asArray[0].contentType===t)return!0}var a=t===r.a.TEXT?new RegExp("(ttml|vtt|wvtt|stpp)"):new RegExp(t);if(e.Representation_asArray&&e.Representation_asArray.length){var o=e.Representation_asArray[0].codecs;if(a.test(o))return!0}if(e.hasOwnProperty(i.a.MIME_TYPE))return a.test(e.mimeType);if(e.Representation_asArray)for(var s,u=0;u<e.Representation_asArray.length;u++)if((s=e.Representation_asArray[u]).hasOwnProperty(i.a.MIME_TYPE))return a.test(s.mimeType);return!1}function N(e){if(!e)throw new Error("adaptation is not defined");if(e.hasOwnProperty(i.a.SEGMENT_TEMPLATE)||e.hasOwnProperty(i.a.SEGMENT_TIMELINE)||e.hasOwnProperty(i.a.SEGMENT_LIST)||e.hasOwnProperty(i.a.SEGMENT_BASE))return!0;if(e.Representation_asArray&&e.Representation_asArray.length>0){var t=e.Representation_asArray[0];if(t.hasOwnProperty(i.a.SEGMENT_TEMPLATE)||t.hasOwnProperty(i.a.SEGMENT_TIMELINE)||t.hasOwnProperty(i.a.SEGMENT_LIST)||t.hasOwnProperty(i.a.SEGMENT_BASE))return!0}return!1}function C(e){return R(e,r.a.AUDIO)}function w(e){return R(e,r.a.VIDEO)}function D(e){return R(e,r.a.TEXT)}function O(e){return R(e,r.a.IMAGE)}function M(){return function(e,t){return e.bandwidth-t.bandwidth}}function P(e){return e&&Array.isArray(e.Representation_asArray)&&e.Representation_asArray.sort((function(e,t){return e.bandwidth-t.bandwidth})),e}function L(e,t){return e&&e.Period_asArray&&I(t)&&e.Period_asArray[t]?e.Period_asArray[t].AdaptationSet_asArray:[]}function F(e){return e&&e.Period_asArray?e.Period_asArray:[]}function x(e){var t=!1;return e&&e.hasOwnProperty("type")&&(t=e.type===i.a.DYNAMIC),t}function U(e){return e&&e.EssentialProperty_asArray&&e.EssentialProperty_asArray.length?e.EssentialProperty_asArray.map((function(e){return{schemeIdUri:e.schemeIdUri,value:e.value}})):null}function B(e){if(!e||!e.S_asArray)return NaN;var t=e.S_asArray[0],n=e.S_asArray[1];return t.hasOwnProperty("d")?t.d:n.t-t.t}function k(e,t){if(!e)throw new Error("Period cannot be null or undefined");var n=l.DEFAULT_ID+"_"+t;return e.hasOwnProperty(i.a.ID)&&e.id.length>0&&"__proto__"!==e.id&&(n=e.id),n}function G(e,t){var n,a=[];if(!e)return a;for(n=0;n<e.length;n++){var o=new p;if(o.timescale=1,o.representation=t,!e[n].hasOwnProperty(r.a.SCHEME_ID_URI))throw new Error("Invalid EventStream. SchemeIdUri has to be set");o.schemeIdUri=e[n].schemeIdUri,e[n].hasOwnProperty(i.a.TIMESCALE)&&(o.timescale=e[n].timescale),e[n].hasOwnProperty(i.a.VALUE)&&(o.value=e[n].value),a.push(o)}return a}function j(e){var t=[],n=e.BaseURL_asArray||[e.baseUri],r=!1;return n.some((function(n){if(n){var a=new h.a,o=n.__text||n;return E.isRelative(o)&&(r=!0,e.baseUri&&(o=E.resolve(o,e.baseUri))),a.url=o,n.hasOwnProperty(i.a.SERVICE_LOCATION)&&n.serviceLocation.length?a.serviceLocation=n.serviceLocation:a.serviceLocation=o,n.hasOwnProperty(i.a.DVB_PRIORITY)&&(a.dvb_priority=n[i.a.DVB_PRIORITY]),n.hasOwnProperty(i.a.DVB_WEIGHT)&&(a.dvb_weight=n[i.a.DVB_WEIGHT]),n.hasOwnProperty(i.a.AVAILABILITY_TIME_OFFSET)&&(a.availabilityTimeOffset=n[i.a.AVAILABILITY_TIME_OFFSET]),n.hasOwnProperty(i.a.AVAILABILITY_TIME_COMPLETE)&&(a.availabilityTimeComplete="false"!==n[i.a.AVAILABILITY_TIME_COMPLETE]),t.push(a),r}})),t}return e={getIsTypeOf:R,getIsText:D,getIsFragmented:N,getProducerReferenceTimesForAdaptation:function(e){var t=e&&e.hasOwnProperty(i.a.PRODUCERREFERENCETIME_ASARRAY)?e[i.a.PRODUCERREFERENCETIME_ASARRAY]:[];(e&&e.hasOwnProperty(i.a.REPRESENTATION_ASARRAY)?e[i.a.REPRESENTATION_ASARRAY]:[]).forEach((function(e){e.hasOwnProperty(i.a.PRODUCERREFERENCETIME_ASARRAY)&&t.push.apply(t,b(e[i.a.PRODUCERREFERENCETIME_ASARRAY]))}));var n=[];return t.forEach((function(e){var t=new g;e.hasOwnProperty(i.a.ID)&&(t[i.a.ID]=e[i.a.ID],e.hasOwnProperty(i.a.WALL_CLOCK_TIME)&&(t[i.a.WALL_CLOCK_TIME]=e[i.a.WALL_CLOCK_TIME],e.hasOwnProperty(i.a.PRESENTATION_TIME)&&(t[i.a.PRESENTATION_TIME]=e[i.a.PRESENTATION_TIME],n.push(t))))})),n},getLanguageForAdaptation:function(e){var t="";return e&&e.hasOwnProperty(i.a.LANG)&&(t=e.lang.replace(/[^A-Za-z0-9-]/g,"")),t},getViewpointForAdaptation:function(e){return e&&e.hasOwnProperty(i.a.VIEWPOINT)?e.Viewpoint:null},getRolesForAdaptation:function(e){return e&&e.hasOwnProperty(i.a.ROLE_ASARRAY)?e.Role_asArray:[]},getAccessibilityForAdaptation:function(e){return e&&e.hasOwnProperty(i.a.ACCESSIBILITY_ASARRAY)?e.Accessibility_asArray:[]},getAudioChannelConfigurationForAdaptation:function(e){return e&&e.hasOwnProperty(i.a.AUDIOCHANNELCONFIGURATION_ASARRAY)?e.AudioChannelConfiguration_asArray:[]},getAudioChannelConfigurationForRepresentation:function(e){return e&&e.hasOwnProperty(i.a.AUDIOCHANNELCONFIGURATION_ASARRAY)?e.AudioChannelConfiguration_asArray:[]},getAdaptationForIndex:function(e,t,n){var r=L(t,n);return r.length>0&&I(e)?r[e]:null},getIndexForAdaptation:function(e,t,n){if(!e)return-1;for(var r=L(t,n),i=0;i<r.length;i++){if(Object(m.a)(u).getInstance().areEqual(r[i],e))return i}return-1},getAdaptationForId:function(e,t,n){var r,a,o=L(t,n);for(r=0,a=o.length;r<a;r++)if(o[r].hasOwnProperty(i.a.ID)&&o[r].id===e)return o[r];return null},getAdaptationsForType:function(e,t,n){var r,i,a=L(e,t),o=[];for(r=0,i=a.length;r<i;r++)R(a[r],n)&&o.push(P(a[r]));return o},getRealPeriods:F,getRealPeriodForIndex:function(e,t){var n=F(t);return n.length>0&&I(e)?n[e]:null},getCodec:function(e,t,n){var r=null;if(e&&e.Representation_asArray&&e.Representation_asArray.length>0){var i=I(t)&&t>=0&&t<e.Representation_asArray.length?e.Representation_asArray[t]:e.Representation_asArray[0];i&&(r=i.mimeType+';codecs="'+i.codecs+'"',n&&void 0!==i.width&&(r+=';width="'+i.width+'";height="'+i.height+'"'))}return r&&(r=r.replace(/\sprofiles=[^;]*/g,"")),r},getSelectionPriority:function(e){try{var t=e&&void 0!==e.selectionPriority?parseInt(e.selectionPriority):1;return isNaN(t)?1:t}catch(e){return 1}},getMimeType:function(e){return e&&e.Representation_asArray&&e.Representation_asArray.length>0?e.Representation_asArray[0].mimeType:null},getKID:function(e){return e&&e.hasOwnProperty(i.a.CENC_DEFAULT_KID)?e[i.a.CENC_DEFAULT_KID]:null},getLabelsForAdaptation:function(e){if(!e||!Array.isArray(e.Label_asArray))return[];for(var t=[],n=0;n<e.Label_asArray.length;n++)t.push({lang:e.Label_asArray[n].lang,text:e.Label_asArray[n].__text||e.Label_asArray[n]});return t},getContentProtectionData:function(e){return e&&e.hasOwnProperty(i.a.CONTENTPROTECTION_ASARRAY)&&0!==e.ContentProtection_asArray.length?e.ContentProtection_asArray:null},getIsDynamic:x,getId:function(e){return e&&e[i.a.ID]||null},hasProfile:function(e,t){var n=!1;return e&&e.profiles&&e.profiles.length>0&&(n=-1!==e.profiles.indexOf(t)),n},getDuration:function(e){return e&&e.hasOwnProperty(i.a.MEDIA_PRESENTATION_DURATION)?e.mediaPresentationDuration:e&&"dynamic"==e.type?Number.POSITIVE_INFINITY:Number.MAX_SAFE_INTEGER||Number.MAX_VALUE},getBandwidth:function(e){return e&&e.bandwidth?e.bandwidth:NaN},getManifestUpdatePeriod:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=NaN;return e&&e.hasOwnProperty(i.a.MINIMUM_UPDATE_PERIOD)&&(n=e.minimumUpdatePeriod),isNaN(n)?n:Math.max(n-t,1)},getPublishTime:function(e){return e&&e.hasOwnProperty(i.a.PUBLISH_TIME)?new Date(e[i.a.PUBLISH_TIME]):null},getRepresentationCount:function(e){return e&&Array.isArray(e.Representation_asArray)?e.Representation_asArray.length:0},getBitrateListForAdaptation:function(e){var t=P(e);return(t&&Array.isArray(t.Representation_asArray)?t.Representation_asArray:[]).map((function(e){return{bandwidth:e.bandwidth,width:e.width||0,height:e.height||0,scanType:e.scanType||null,id:e.id||null}}))},getRepresentationFor:function(e,t){return t&&t.Representation_asArray&&t.Representation_asArray.length>0&&I(e)?t.Representation_asArray[e]:null},getRepresentationsForAdaptation:function(e){var t,n,r,a,s=[],u=function(e){if(e&&e.period&&I(e.period.index)){var t=e.period.mpd.manifest.Period_asArray[e.period.index];if(t&&t.AdaptationSet_asArray&&I(e.index))return P(t.AdaptationSet_asArray[e.index])}}(e);if(u&&u.Representation_asArray){if(e&&e.period&&I(e.period.index)){var l=j(e.period.mpd.manifest);l&&(n=l[0])}for(var c=0,f=u.Representation_asArray.length;c<f;++c){var d=u.Representation_asArray[c],h=new o;if(h.index=c,h.adaptation=e,d.hasOwnProperty(i.a.ID)&&(h.id=d.id),d.hasOwnProperty(i.a.CODECS)&&(h.codecs=d.codecs),d.hasOwnProperty(i.a.MIME_TYPE)&&(h.mimeType=d[i.a.MIME_TYPE]),d.hasOwnProperty(i.a.CODEC_PRIVATE_DATA)&&(h.codecPrivateData=d.codecPrivateData),d.hasOwnProperty(i.a.BANDWITH)&&(h.bandwidth=d.bandwidth),d.hasOwnProperty(i.a.WIDTH)&&(h.width=d.width),d.hasOwnProperty(i.a.HEIGHT)&&(h.height=d.height),d.hasOwnProperty(i.a.SCAN_TYPE)&&(h.scanType=d.scanType),d.hasOwnProperty(i.a.MAX_PLAYOUT_RATE)&&(h.maxPlayoutRate=d.maxPlayoutRate),d.hasOwnProperty(i.a.SEGMENT_BASE)?(t=d.SegmentBase,h.segmentInfoType=i.a.SEGMENT_BASE):d.hasOwnProperty(i.a.SEGMENT_LIST)?(t=d.SegmentList).hasOwnProperty(i.a.SEGMENT_TIMELINE)?h.segmentInfoType=i.a.SEGMENT_TIMELINE:h.segmentInfoType=i.a.SEGMENT_LIST:d.hasOwnProperty(i.a.SEGMENT_TEMPLATE)?((t=d.SegmentTemplate).hasOwnProperty(i.a.SEGMENT_TIMELINE)?h.segmentInfoType=i.a.SEGMENT_TIMELINE:h.segmentInfoType=i.a.SEGMENT_TEMPLATE,t.hasOwnProperty(i.a.INITIALIZATION_MINUS)&&(h.initialization=t.initialization.split("$Bandwidth$").join(d.bandwidth).split("$RepresentationID$").join(d.id))):h.segmentInfoType=i.a.BASE_URL,h.essentialProperties=U(d),t){if(t.hasOwnProperty(i.a.INITIALIZATION)){var p=t.Initialization;p.hasOwnProperty(i.a.SOURCE_URL)&&(h.initialization=p.sourceURL),p.hasOwnProperty(i.a.RANGE)&&(h.range=p.range)}else D(u)&&N(u)&&u.mimeType&&-1===u.mimeType.indexOf("application/mp4")&&(h.range=0);t.hasOwnProperty(i.a.TIMESCALE)&&(h.timescale=t.timescale),t.hasOwnProperty(i.a.DURATION)?h.segmentDuration=t.duration/h.timescale:d.hasOwnProperty(i.a.SEGMENT_TEMPLATE)&&(t=d.SegmentTemplate).hasOwnProperty(i.a.SEGMENT_TIMELINE)&&(h.segmentDuration=B(t.SegmentTimeline)/h.timescale),t.hasOwnProperty(i.a.MEDIA)&&(h.media=t.media),t.hasOwnProperty(i.a.START_NUMBER)&&(h.startNumber=t.startNumber),t.hasOwnProperty(i.a.INDEX_RANGE)&&(h.indexRange=t.indexRange),t.hasOwnProperty(i.a.PRESENTATION_TIME_OFFSET)&&(h.presentationTimeOffset=t.presentationTimeOffset/h.timescale),t.hasOwnProperty(i.a.AVAILABILITY_TIME_OFFSET)?h.availabilityTimeOffset=t.availabilityTimeOffset:n&&void 0!==n.availabilityTimeOffset&&(h.availabilityTimeOffset=n.availabilityTimeOffset),t.hasOwnProperty(i.a.AVAILABILITY_TIME_COMPLETE)?h.availabilityTimeComplete="false"!==t.availabilityTimeComplete:n&&void 0!==n.availabilityTimeComplete&&(h.availabilityTimeComplete=n.availabilityTimeComplete)}h.MSETimeOffset=(a=void 0,void 0,a=(r=h).presentationTimeOffset,r.adaptation.period.start-a),h.path=[e.period.index,e.index,c],s.push(h)}}return s},getAdaptationsForPeriod:function(e){var n,a,o,u=e&&I(e.index)?e.mpd.manifest.Period_asArray[e.index]:null,l=[];if(u&&u.AdaptationSet_asArray)for(o=0;o<u.AdaptationSet_asArray.length;o++)a=u.AdaptationSet_asArray[o],n=new s,a.hasOwnProperty(i.a.ID)&&(n.id=a.id),n.index=o,n.period=e,R(a,r.a.MUXED)?n.type=r.a.MUXED:C(a)?n.type=r.a.AUDIO:w(a)?n.type=r.a.VIDEO:D(a)?n.type=r.a.TEXT:O(a)?n.type=r.a.IMAGE:t.warn("Unknown Adaptation stream type"),l.push(n);return l},getRegularPeriods:function(e){var a,o,s=!!e&&x(e.manifest),u=[],c=null,f=null,d=null,h=null;for(o=0,a=e&&e.manifest&&e.manifest.Period_asArray?e.manifest.Period_asArray.length:0;o<a;o++)(f=e.manifest.Period_asArray[o]).hasOwnProperty(i.a.START)?(h=new l).start=f.start:null!==c&&c.hasOwnProperty(i.a.DURATION)&&null!==d?(h=new l).start=parseFloat((d.start+d.duration).toFixed(5)):0!==o||s||((h=new l).start=0),null!==d&&isNaN(d.duration)&&(null!==h?d.duration=parseFloat((h.start-d.start).toFixed(5)):t.warn("First period duration could not be calculated because lack of start and duration period properties. This will cause timing issues during playback")),null!==h&&(h.id=k(f,o),h.index=o,h.mpd=e,f.hasOwnProperty(i.a.DURATION)&&(h.duration=f.duration),d&&(d.nextPeriodId=h.id),u.push(h),c=f,d=h),f=null,h=null;return 0===u.length||null!==d&&isNaN(d.duration)&&(d.duration=parseFloat((function(e){!function(){if(!n||!n.hasOwnProperty("error"))throw new Error(r.a.MISSING_CONFIG_ERROR)}();var t,i=x(e.mpd.manifest);e.mpd.manifest.mediaPresentationDuration?t=e.mpd.manifest.mediaPresentationDuration:e.duration?t=e.duration:i?t=Number.POSITIVE_INFINITY:n.error(new T.a(v.a.MANIFEST_ERROR_ID_PARSE_CODE,"Must have @mediaPresentationDuration on MPD or an explicit @duration on the last period.",e));return t}(d)-d.start).toFixed(5))),u},getMpd:function(e){var t=new c;return e&&(t.manifest=e,e.hasOwnProperty(i.a.AVAILABILITY_START_TIME)?t.availabilityStartTime=new Date(e.availabilityStartTime.getTime()):e.loadedTime&&(t.availabilityStartTime=new Date(e.loadedTime.getTime())),e.hasOwnProperty(i.a.AVAILABILITY_END_TIME)&&(t.availabilityEndTime=new Date(e.availabilityEndTime.getTime())),e.hasOwnProperty(i.a.MINIMUM_UPDATE_PERIOD)&&(t.minimumUpdatePeriod=e.minimumUpdatePeriod),e.hasOwnProperty(i.a.MEDIA_PRESENTATION_DURATION)&&(t.mediaPresentationDuration=e.mediaPresentationDuration),e.hasOwnProperty(i.a.SUGGESTED_PRESENTATION_DELAY)&&(t.suggestedPresentationDelay=e.suggestedPresentationDelay),e.hasOwnProperty(i.a.TIMESHIFT_BUFFER_DEPTH)&&(t.timeShiftBufferDepth=e.timeShiftBufferDepth),e.hasOwnProperty(i.a.MAX_SEGMENT_DURATION)&&(t.maxSegmentDuration=e.maxSegmentDuration),e.hasOwnProperty(i.a.PUBLISH_TIME)&&(t.publishTime=new Date(e.publishTime))),t},getEventsForPeriod:function(e){var t,n,o=e&&e.mpd&&e.mpd.manifest?e.mpd.manifest:null,s=o?o.Period_asArray:null,u=s&&e&&I(e.index)?s[e.index].EventStream_asArray:null,l=[];if(u)for(t=0;t<u.length;t++){var c=new p;if(c.period=e,c.timescale=1,!u[t].hasOwnProperty(r.a.SCHEME_ID_URI))throw new Error("Invalid EventStream. SchemeIdUri has to be set");for(c.schemeIdUri=u[t][r.a.SCHEME_ID_URI],u[t].hasOwnProperty(i.a.TIMESCALE)&&(c.timescale=u[t][i.a.TIMESCALE]),u[t].hasOwnProperty(i.a.VALUE)&&(c.value=u[t][i.a.VALUE]),u[t].hasOwnProperty(i.a.PRESENTATION_TIME_OFFSET)&&(c.presentationTimeOffset=u[t][i.a.PRESENTATION_TIME_OFFSET]),n=0;u[t].Event_asArray&&n<u[t].Event_asArray.length;n++){var f=u[t].Event_asArray[n],h=new d.a;h.presentationTime=0,h.eventStream=c,f.hasOwnProperty(i.a.PRESENTATION_TIME)&&(h.presentationTime=f.presentationTime);var g=c.presentationTimeOffset?c.presentationTimeOffset/c.timescale:0;h.calculatedPresentationTime=h.presentationTime/c.timescale+e.start-g,f.hasOwnProperty(i.a.DURATION)&&(h.duration=f.duration/c.timescale),f.hasOwnProperty(i.a.ID)?h.id=f.id:h.id=null,f.Signal&&f.Signal.Binary?h.messageData=a.decodeArray(f.Signal.Binary.toString()):h.messageData=f.messageData||f.__cdata||f.__text,l.push(h)}}return l},getEssentialPropertiesForRepresentation:U,getEventStreamForAdaptationSet:function(e,t){var n,r,i;return e&&e.Period_asArray&&t&&t.period&&I(t.period.index)&&(r=e.Period_asArray[t.period.index])&&r.AdaptationSet_asArray&&I(t.index)&&(i=r.AdaptationSet_asArray[t.index])&&(n=i.InbandEventStream_asArray),G(n,null)},getEventStreamForRepresentation:function(e,t){var n,r,i,a;return e&&e.Period_asArray&&t&&t.adaptation&&t.adaptation.period&&I(t.adaptation.period.index)&&(r=e.Period_asArray[t.adaptation.period.index])&&r.AdaptationSet_asArray&&I(t.adaptation.index)&&(i=r.AdaptationSet_asArray[t.adaptation.index])&&i.Representation_asArray&&I(t.index)&&(a=i.Representation_asArray[t.index])&&(n=a.InbandEventStream_asArray),G(n,t)},getUTCTimingSources:function(e){var t=x(e),n=!!e&&e.hasOwnProperty(i.a.AVAILABILITY_START_TIME),a=e?e.UTCTiming_asArray:null,o=[];return(t||n)&&a&&a.forEach((function(e){var t=new f.a;e.hasOwnProperty(r.a.SCHEME_ID_URI)&&(t.schemeIdUri=e.schemeIdUri,e.hasOwnProperty(i.a.VALUE)&&(t.value=e.value.toString(),o.push(t)))})),o},getBaseURLsFromElement:j,getRepresentationSortFunction:M,getLocation:function(e){if(e&&e.hasOwnProperty(r.a.LOCATION))return e.Location=e.Location_asArray[0],e.Location},getPatchLocation:function(e){if(e&&e.hasOwnProperty(i.a.PATCH_LOCATION))return e.PatchLocation=e.PatchLocation_asArray[0],e.PatchLocation},getSuggestedPresentationDelay:function(e){return e&&e.hasOwnProperty(i.a.SUGGESTED_PRESENTATION_DELAY)?e.suggestedPresentationDelay:null},getAvailabilityStartTime:function(e){return e&&e.hasOwnProperty(i.a.AVAILABILITY_START_TIME)&&null!==e.availabilityStartTime?e.availabilityStartTime.getTime():null},getServiceDescriptions:function(e){var t=[];if(e&&e.hasOwnProperty(i.a.SERVICE_DESCRIPTION)){var n,r=A(e.ServiceDescription_asArray);try{for(r.s();!(n=r.n()).done;){var a=n.value,o=null,s=null,u=null,l=null,c=null,f=null;for(var d in a)a.hasOwnProperty(d)&&(d===i.a.ID?o=a[d]:d===i.a.SERVICE_DESCRIPTION_SCOPE?s=a[d].schemeIdUri:d===i.a.SERVICE_DESCRIPTION_LATENCY?u={target:parseInt(a[d].target),max:parseInt(a[d].max),min:parseInt(a[d].min),referenceId:parseInt(a[d].referenceId)}:d===i.a.SERVICE_DESCRIPTION_PLAYBACK_RATE?l={max:parseFloat(a[d].max),min:parseFloat(a[d].min)}:d===i.a.SERVICE_DESCRIPTION_OPERATING_QUALITY?c={mediaType:a[d].mediaType,max:parseInt(a[d].max),min:parseInt(a[d].min),target:parseInt(a[d].target),type:a[d].type,maxQualityDifference:parseInt(a[d].maxQualityDifference)}:d===i.a.SERVICE_DESCRIPTION_OPERATING_BANDWIDTH&&(f={mediaType:a[d].mediaType,max:parseInt(a[d].max),min:parseInt(a[d].min),target:parseInt(a[d].target)}));t.push({id:o,schemeIdUri:s,latency:u,playbackRate:l,operatingQuality:c,operatingBandwidth:f})}}catch(e){r.e(e)}finally{r.f()}}return t},getSupplementalProperties:function(e){var t={};if(e&&e.hasOwnProperty(i.a.SUPPLEMENTAL_PROPERTY)){var n,a=A(e.SupplementalProperty_asArray);try{for(a.s();!(n=a.n()).done;){var o=n.value;o.hasOwnProperty(r.a.SCHEME_ID_URI)&&o.hasOwnProperty(i.a.VALUE)&&(t[o[r.a.SCHEME_ID_URI]]=o[i.a.VALUE])}}catch(e){a.e(e)}finally{a.f()}}return t},setConfig:function(e){e&&(e.errHandler&&(n=e.errHandler),e.BASE64&&(a=e.BASE64))}},t=Object(_.a)(u).getInstance().getLogger(e),e}N.__dashjs_factory_name="DashManifestModel";t.a=E.a.getSingletonFactory(N)},function(e,t,n){"use strict";n.d(t,"a",(function(){return h}));var r=n(1),i=n(0),a=n(3);var o=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.bitrate=0,this.width=0,this.height=0,this.tilesHor=0,this.tilesVert=0,this.widthPerTile=0,this.heightPerTile=0,this.startNumber=0,this.segmentDuration=0,this.timescale=0,this.templateUrl="",this.id=""},s=n(13),u=n(12),l=n(22),c=n(29),f=n(37),d=n(38),h=["http://dashif.org/thumbnail_tile","http://dashif.org/guidelines/thumbnail_tile"];function p(e){var t,n,a,p,g,m,y,E,_=this.context,T=e.adapter,v=e.baseURLController,S=e.streamInfo,A=e.timelineConverter,b=e.debug,I=e.eventBus,R=e.events,N=e.dashConstants,C=Object(s.a)(_).getInstance();function w(e,t){var r=new o;r.id=e.id,r.bitrate=e.bandwidth,r.width=e.width,r.height=e.height,r.tilesHor=1,r.tilesVert=1,e.essentialProperties&&e.essentialProperties.forEach((function(e){if(h.indexOf(e.schemeIdUri)>=0&&e.value){var t=e.value.split("x");2!==t.length||isNaN(t[0])||isNaN(t[1])||(r.tilesHor=parseInt(t[0],10),r.tilesVert=parseInt(t[1],10))}})),t?m.updateSegmentData(e).then((function(t){!function(e,t,n){var r=[],i=function(e,t){var n,r,i,a,o=[],s=0;for(n=0,r=e.segments.length;n<r;n++)i=e.segments[n],(a=Object(u.b)(A,T.getIsDynamic(),t,i.startTime,i.duration,i.timescale,i.media,i.mediaRange,s))&&(o.push(a),a=null,s++);return o}(n,t);t.segments=i,e.segmentDuration=t.segments[0].duration,e.readThumbnail=function(e,n){var i=null;r.some((function(t){if(t.start<=e&&t.end>e)return i=t.url,!0})),i?n(i):t.segments.some((function(i){if(i.mediaStartTime<=e&&i.mediaStartTime+i.duration>e){var a=v.resolve(t.path);return y.load({method:"get",url:a.url,request:{range:i.mediaRange,responseType:"arraybuffer"},onload:function(e){var t=E.getSamplesInfo(e.target.response),a=new Blob([e.target.response.slice(t.sampleList[0].offset,t.sampleList[0].offset+t.sampleList[0].size)],{type:"image/jpeg"}),o=window.URL.createObjectURL(a);r.push({start:i.mediaStartTime,end:i.mediaStartTime+i.duration,url:o}),n&&n(o)}}),!0}}))}}(r,e,t)})):(r.startNumber=e.startNumber,r.segmentDuration=e.segmentDuration,r.timescale=e.timescale,r.templateUrl=function(e){var t=C.isRelative(e.media)?C.resolve(e.media,v.resolve(e.path).url):e.media;if(!t)return"";return Object(u.c)(t,e.id)}(e)),r.tilesHor>0&&r.tilesVert>0&&(r.widthPerTile=r.width/r.tilesHor,r.heightPerTile=r.height/r.tilesVert,n.push(r))}function D(){n=[],p=-1,g=null}return t={getTracks:function(){return n},addTracks:function(){if(S&&T&&(g=T.getMediaInfoForType(S,r.a.IMAGE))){var e=T.getVoRepresentations(g);e&&e.length>0&&e.forEach((function(e){(e.segmentInfoType===i.a.SEGMENT_TEMPLATE&&e.segmentDuration>0&&e.media||e.segmentInfoType===i.a.SEGMENT_TIMELINE)&&w(e),e.segmentInfoType===i.a.SEGMENT_BASE&&w(e,!0)})),n.length>0&&n.sort((function(e,t){return e.bitrate-t.bitrate}))}},reset:D,setTrackByIndex:function(e){n&&0!==n.length&&(e>=n.length&&(e=n.length-1),p=e)},getCurrentTrack:function(){return p<0?null:n[p]},getCurrentTrackIndex:function(){return p},getThumbnailRequestForTime:function(e){for(var t,r=T.getVoRepresentations(g),i=0;i<r.length;i++)if(n[p].id===r[i].id){t=r[i];break}return a.getSegmentRequestForTime(g,t,e)}},D(),y=Object(c.a)(_).create({}),E=Object(l.a)(_).getInstance(),m=Object(d.a)(_).create({events:R,eventBus:I,streamInfo:S,timelineConverter:A,dashConstants:N,dashMetrics:e.dashMetrics,segmentBaseController:e.segmentBaseController,type:r.a.IMAGE}),(a=Object(f.a)(_).create({streamInfo:S,type:r.a.IMAGE,timelineConverter:A,segmentsController:m,baseURLController:v,debug:b,eventBus:I,events:R,dashConstants:N,urlUtils:C})).initialize(!!T&&T.getIsDynamic()),t}p.__dashjs_factory_name="ThumbnailTracks";t.b=a.a.getClassFactory(p)},function(e,t,n){"use strict";var r=n(52),i=Object.keys||function(e){var t=[];for(var n in e)t.push(n);return t};e.exports=f;var a=n(47);a.inherits=n(40);var o=n(71),s=n(67);a.inherits(f,o);for(var u=i(s.prototype),l=0;l<u.length;l++){var c=u[l];f.prototype[c]||(f.prototype[c]=s.prototype[c])}function f(e){if(!(this instanceof f))return new f(e);o.call(this,e),s.call(this,e),e&&!1===e.readable&&(this.readable=!1),e&&!1===e.writable&&(this.writable=!1),this.allowHalfOpen=!0,e&&!1===e.allowHalfOpen&&(this.allowHalfOpen=!1),this.once("end",d)}function d(){this.allowHalfOpen||this._writableState.ended||r.nextTick(h,this)}function h(e){e.end()}Object.defineProperty(f.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(f.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(e){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=e,this._writableState.destroyed=e)}}),f.prototype._destroy=function(e,t){this.push(null),this.end(),r.nextTick(t,e)}},function(e,t,n){(function(e){function n(e,t){for(var n=0,r=e.length-1;r>=0;r--){var i=e[r];"."===i?e.splice(r,1):".."===i?(e.splice(r,1),n++):n&&(e.splice(r,1),n--)}if(t)for(;n--;n)e.unshift("..");return e}function r(e,t){if(e.filter)return e.filter(t);for(var n=[],r=0;r<e.length;r++)t(e[r],r,e)&&n.push(e[r]);return n}t.resolve=function(){for(var t="",i=!1,a=arguments.length-1;a>=-1&&!i;a--){var o=a>=0?arguments[a]:e.cwd();if("string"!=typeof o)throw new TypeError("Arguments to path.resolve must be strings");o&&(t=o+"/"+t,i="/"===o.charAt(0))}return(i?"/":"")+(t=n(r(t.split("/"),(function(e){return!!e})),!i).join("/"))||"."},t.normalize=function(e){var a=t.isAbsolute(e),o="/"===i(e,-1);return(e=n(r(e.split("/"),(function(e){return!!e})),!a).join("/"))||a||(e="."),e&&o&&(e+="/"),(a?"/":"")+e},t.isAbsolute=function(e){return"/"===e.charAt(0)},t.join=function(){var e=Array.prototype.slice.call(arguments,0);return t.normalize(r(e,(function(e,t){if("string"!=typeof e)throw new TypeError("Arguments to path.join must be strings");return e})).join("/"))},t.relative=function(e,n){function r(e){for(var t=0;t<e.length&&""===e[t];t++);for(var n=e.length-1;n>=0&&""===e[n];n--);return t>n?[]:e.slice(t,n-t+1)}e=t.resolve(e).substr(1),n=t.resolve(n).substr(1);for(var i=r(e.split("/")),a=r(n.split("/")),o=Math.min(i.length,a.length),s=o,u=0;u<o;u++)if(i[u]!==a[u]){s=u;break}var l=[];for(u=s;u<i.length;u++)l.push("..");return(l=l.concat(a.slice(s))).join("/")},t.sep="/",t.delimiter=":",t.dirname=function(e){if("string"!=typeof e&&(e+=""),0===e.length)return".";for(var t=e.charCodeAt(0),n=47===t,r=-1,i=!0,a=e.length-1;a>=1;--a)if(47===(t=e.charCodeAt(a))){if(!i){r=a;break}}else i=!1;return-1===r?n?"/":".":n&&1===r?"/":e.slice(0,r)},t.basename=function(e,t){var n=function(e){"string"!=typeof e&&(e+="");var t,n=0,r=-1,i=!0;for(t=e.length-1;t>=0;--t)if(47===e.charCodeAt(t)){if(!i){n=t+1;break}}else-1===r&&(i=!1,r=t+1);return-1===r?"":e.slice(n,r)}(e);return t&&n.substr(-1*t.length)===t&&(n=n.substr(0,n.length-t.length)),n},t.extname=function(e){"string"!=typeof e&&(e+="");for(var t=-1,n=0,r=-1,i=!0,a=0,o=e.length-1;o>=0;--o){var s=e.charCodeAt(o);if(47!==s)-1===r&&(i=!1,r=o+1),46===s?-1===t?t=o:1!==a&&(a=1):-1!==t&&(a=-1);else if(!i){n=o+1;break}}return-1===t||-1===r||0===a||1===a&&t===r-1&&t===n+1?"":e.slice(t,r)};var i= true?function(e,t,n){return e.substr(t,n)}:0}).call(this,n(25))},function(e,t,n){"use strict";var r=n(17),i=n(5),a=n(3),o=n(4),s=n(12),u=n(0);function l(e){var t,n,a,l,c,f=(e=e||{}).eventBus,d=e.debug,h=e.urlUtils,p=e.type,g=e.streamInfo,m=e.segmentsController,y=e.timelineConverter,E=e.baseURLController;function _(){return p}function T(){a=null}function v(e,t,n){var r,i,a=E.resolve(n.path);return a&&t!==a.url&&h.isRelative(t)?(r=a.url,i=a.serviceLocation,t&&(r=h.resolve(t,r))):r=t,!h.isRelative(r)&&(e.url=r,e.serviceLocation=i,!0)}function S(e,t){if(null==t)return null;var n=new r.a,a=t.representation,o=a.adaptation.period.mpd.manifest.Period_asArray[a.adaptation.period.index].AdaptationSet_asArray[a.adaptation.index].Representation_asArray[a.index].bandwidth,u=t.media;return u=Object(s.d)(u,"Number",t.replacementNumber),u=Object(s.d)(u,"Time",t.replacementTime),u=Object(s.d)(u,"Bandwidth",o),u=Object(s.c)(u,a.id),u=Object(s.e)(u),n.mediaType=_(),n.type=i.a.MEDIA_SEGMENT_TYPE,n.range=t.mediaRange,n.startTime=t.presentationStartTime,n.mediaStartTime=t.mediaStartTime,n.duration=t.duration,n.timescale=a.timescale,n.availabilityStartTime=t.availabilityStartTime,n.availabilityEndTime=t.availabilityEndTime,n.availabilityTimeComplete=a.availabilityTimeComplete,n.wallStartTime=t.wallStartTime,n.quality=a.index,n.index=t.index,n.mediaInfo=e,n.adaptationIndex=a.adaptation.index,n.representationId=a.id,v(n,u,a)?n:void 0}function A(e,t,r){var i=null;if(!t||!t.segmentInfoType)return i;var o=m.getSegmentByTime(t,r);return o&&(a=o,n.debug("Index for time "+r+" is "+o.index),i=S(e,o)),i}function b(){n.debug("Dynamic stream complete"),c=!0}return t={initialize:function(e){l=e,c=!1,m.initialize(e)},getStreamId:function(){return g.id},getType:_,getStreamInfo:function(){return g},getInitRequest:function(e,t){return t?function(e,t,n){var a=new r.a,o=t.adaptation.period,u=o.start;if(a.mediaType=n,a.type=i.a.INIT_SEGMENT_TYPE,a.range=t.range,a.availabilityStartTime=y.calcAvailabilityStartTimeFromPresentationTime(u,t,l),a.availabilityEndTime=y.calcAvailabilityEndTimeFromPresentationTime(u+o.duration,t,l),a.quality=t.index,a.mediaInfo=e,a.representationId=t.id,v(a,t.initialization,t))return a.url=Object(s.d)(a.url,"Bandwidth",t.bandwidth),a}(e,t,_()):null},getSegmentRequestForTime:A,getCurrentIndex:function(){return a?a.index:-1},getNextSegmentRequest:function(e,t){var r=null;if(!t||!t.segmentInfoType)return null;var i=a?a.index+1:0,o=m.getSegmentByIndex(t,i,a?a.mediaStartTime:-1);if(o)r=S(e,o),a=o;else{if(l&&!c)return n.debug(_()+" No segment found at index: "+i+". Wait for next loop"),null;c=!0}return r},isLastSegmentRequested:function(e,t){if(!e||!a)return!1;if(c)return!0;if(!isFinite(e.adaptation.period.duration))return!1;if(a.presentationStartTime+a.duration>t)return!1;if(e.mediaFinishedInformation&&!isNaN(e.mediaFinishedInformation.numberOfSegments)&&!isNaN(a.index)&&a.index>=e.mediaFinishedInformation.numberOfSegments-1){if(!l||e.segmentInfoType===u.a.SEGMENT_TEMPLATE)return!0;if(l&&e.segmentInfoType===u.a.SEGMENT_LIST&&e.adaptation.period.nextPeriodId)return!0}return!!(l&&e.adaptation.period.nextPeriodId&&e.segmentInfoType===u.a.SEGMENT_TIMELINE&&e.mediaFinishedInformation&&!isNaN(e.mediaFinishedInformation.mediaTimeOfLastSignaledSegment)&&a&&!isNaN(a.mediaStartTime)&&!isNaN(a.duration)&&a.mediaStartTime+a.duration>=e.mediaFinishedInformation.mediaTimeOfLastSignaledSegment-.05)},reset:function(){T(),f.off(o.a.DYNAMIC_TO_STATIC,b,t)},getNextSegmentRequestIdempotent:function(e,t){var n=a?a.index+1:0,r=m.getSegmentByIndex(t,n,a?a.mediaStartTime:-1);return r?S(e,r):null},getValidTimeCloseToTargetTime:function(e,t,n,r){try{if(isNaN(e)||!t||!n)return NaN;if(e<0&&(e=0),isNaN(r)&&(r=.5),A(t,n,e))return e;for(var i=n.adaptation.period.start,a=n.adaptation.period.start+n.adaptation.period.duration,o=Math.min(e+r,a),s=Math.max(e-r,i),u=NaN,l=null;o<=a||s>=i;){var c=null,f=null;if(o<=a&&(c=A(t,n,o)),s>=i&&(f=A(t,n,s)),f){u=s,l=f;break}if(c){u=o,l=c;break}o+=r,s-=r}if(l){var d=l.startTime+l.duration;return e>=l.startTime&&d-e>r?e:e<l.startTime?l.startTime:Math.min(d-r,u)}return u}catch(e){return NaN}},getValidTimeAheadOfTargetTime:function(e,t,n,r){try{if(isNaN(e)||!t||!n)return NaN;if(e<0&&(e=0),isNaN(r)&&(r=.5),A(t,n,e))return e;if(n.adaptation.period.start+n.adaptation.period.duration<e)return NaN;for(var i=Math.min(n.adaptation.period.start+n.adaptation.period.duration,e+30),a=Math.min(e+r,i),o=NaN,s=null;a<=i;){var u=null;if(a<=i&&(u=A(t,n,a)),u){o=a,s=u;break}a+=r}if(s){var l=s.startTime+s.duration;return e>=s.startTime&&l-e>r?e:e<s.startTime?s.startTime:Math.min(l-r,o)}return o}catch(e){return NaN}}},n=d.getLogger(t),T(),f.on(o.a.DYNAMIC_TO_STATIC,b,t),t}l.__dashjs_factory_name="DashHandler",t.a=a.a.getClassFactory(l)},function(e,t,n){"use strict";var r=n(3),i=n(1),a=n(12);function o(e,t){var n=(e=e||{}).timelineConverter,r=e.dashMetrics;function o(){if(!n)throw new Error(i.a.MISSING_CONFIG_ERROR)}function s(e,t){var n,r,i,a,o,s,l,c=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate||e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList,f=c.SegmentTimeline,d=c.SegmentURL_asArray,h=0,p=0,g=-1;l=e.timescale;var m=!1;for(i=0,a=(n=f.S_asArray).length;i<a&&!m;i++){if(s=0,(r=n[i]).hasOwnProperty("r")&&(s=r.r),r.hasOwnProperty("t")&&(p=(h=r.t)/l),s<0)s=u(e,n[i+1],r,l,p);for(o=0;o<=s&&!m;o++)(m=t(h,p,c,d,r,l,++g,i))&&(e.segmentDuration=r.d/l),p=(h+=r.d)/l}}function u(e,t,i,a,o){var s;if(t&&t.hasOwnProperty("t"))s=t.t/a;else try{var u=0;if(isNaN(e.adaptation.period.start)||isNaN(e.adaptation.period.duration)||!isFinite(e.adaptation.period.duration)){var l=r.getCurrentDVRInfo();u=isNaN(l.end)?0:l.end}else u=e.adaptation.period.start+e.adaptation.period.duration;s=n.calcMediaTimeFromPresentationTime(u,e),e.segmentDuration=i.d/a}catch(e){s=0}return Math.max(Math.ceil((s-o)/(i.d/a))-1,0)}return{getSegmentByIndex:function(e,r,i){if(o(),!e)return null;var u=null,l=!1;return s(e,(function(r,o,s,c,f,d,h,p){if(l||i<0){var g=s.media,m=f.mediaRange;return c&&(g=c[p].media||"",m=c[p].mediaRange),u=Object(a.b)(n,t,e,r,f.d,d,g,m,h,f.tManifest),!0}return o>=i-.5*f.d/d&&(l=!0),!1})),u},getSegmentByTime:function(e,r){if(o(),!e)return null;void 0===r&&(r=null);var i=null,u=n.calcMediaTimeFromPresentationTime(r,e);return s(e,(function(r,o,s,l,c,f,d,h){if(u<o+c.d/f&&u>=o){var p=s.media,g=c.mediaRange;return l&&(p=l[h].media||"",g=l[h].mediaRange),i=Object(a.b)(n,t,e,r,c.d,f,p,g,d,c.tManifest),!0}return!1})),i},getMediaFinishedInformation:function(e){if(!e)return 0;var t,n,r,i,a,o,s,l=(e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate||e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList).SegmentTimeline,c=0,f=0,d=0;for(s=e.timescale,i=(t=l.S_asArray).length,r=0;r<i;r++){if(o=0,(n=t[r]).hasOwnProperty("r")&&(o=n.r),n.hasOwnProperty("t")&&(f=(c=n.t)/s),o<0)o=u(e,t[r+1],n,s,f);for(a=0;a<=o;a++)d++,f=(c+=n.d)/s}return{numberOfSegments:d,mediaTimeOfLastSignaledSegment:f}}}}o.__dashjs_factory_name="TimelineSegmentsGetter";var s=r.a.getClassFactory(o);function u(e,t){var n=(e=e||{}).timelineConverter;function r(){if(!n||!n.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))throw new Error(i.a.MISSING_CONFIG_ERROR)}function o(e,i){if(r(),!e)return null;var o=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentTemplate;i=Math.max(i,0);var s=Object(a.a)(n,t,e,i);if(s){s.replacementTime=Math.round((i-1)*e.segmentDuration*e.timescale,10);var u=o.media;u=Object(a.d)(u,"Number",s.replacementNumber),u=Object(a.d)(u,"Time",s.replacementTime),s.media=u}return s}return{getSegmentByIndex:o,getSegmentByTime:function(e,t){if(r(),!e)return null;var i=e.segmentDuration;if(isNaN(i))return null;var a=n.calcPeriodRelativeTimeFromMpdRelativeTime(e,t);return o(e,Math.floor(a/i))},getMediaFinishedInformation:function(e){var t={numberOfSegments:0,mediaTimeOfLastSignaledSegment:NaN};if(!e)return t;var n=e.segmentDuration;return isNaN(n)?t.numberOfSegments=1:t.numberOfSegments=Math.ceil(e.adaptation.period.duration/n),t}}}u.__dashjs_factory_name="TemplateSegmentsGetter";var l=r.a.getClassFactory(u);function c(e,t){var n=(e=e||{}).timelineConverter;function r(){if(!n||!n.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))throw new Error(i.a.MISSING_CONFIG_ERROR)}function o(e,i){if(r(),!e)return null;var o=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList,s=o.SegmentURL_asArray.length,u=e&&!isNaN(e.startNumber)?e.startNumber:1,l=Math.max(u-1,0),c=Math.max(i-l,0),f=null;if(c<s){var d=o.SegmentURL_asArray[c];(f=Object(a.a)(n,t,e,i))&&(f.replacementTime=(u+i-1)*e.segmentDuration,f.media=d.media?d.media:"",f.mediaRange=d.mediaRange,f.indexRange=d.indexRange)}return f}return{getSegmentByIndex:o,getSegmentByTime:function(e,t){if(r(),!e)return null;var i=e.segmentDuration;if(isNaN(i))return null;var a=n.calcPeriodRelativeTimeFromMpdRelativeTime(e,t);return o(e,Math.floor(a/i))},getMediaFinishedInformation:function(e){var t={numberOfSegments:0,mediaTimeOfLastSignaledSegment:NaN};if(!e)return t;var n=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index].Representation_asArray[e.index].SegmentList,r=e&&!isNaN(e.startNumber)?e.startNumber:1,i=Math.max(r-1,0);return t.numberOfSegments=i+n.SegmentURL_asArray.length,t}}}c.__dashjs_factory_name="ListSegmentsGetter";var f=r.a.getClassFactory(c);function d(e){var t=(e=e||{}).timelineConverter;function n(){if(!t||!t.hasOwnProperty("calcPeriodRelativeTimeFromMpdRelativeTime"))throw new Error(i.a.MISSING_CONFIG_ERROR)}function r(e,t){if(n(),!e)return null;var r,i=e.segments?e.segments.length:-1;if(t<i&&(r=e.segments[t])&&r.index===t)return r;for(var a=0;a<i;a++)if((r=e.segments[a])&&r.index===t)return r;return null}return{getSegmentByIndex:r,getSegmentByTime:function(e,t){return n(),r(e,function(e,t){if(!e)return-1;var n,r,i,a,o,s=e.segments,u=s?s.length:null,l=-1;if(s&&u>0)for(o=0;o<u;o++)if(r=s[o],i=r.presentationStartTime,a=r.duration,t+(n=a/2)>=i&&t-n<i+a){l=r.index;break}return l}(e,t))},getMediaFinishedInformation:function(e){var t={numberOfSegments:0,mediaTimeOfLastSignaledSegment:NaN};return e&&e.segments?(t.numberOfSegments=e.segments.length,t):t}}}d.__dashjs_factory_name="SegmentBaseGetter";var h=r.a.getClassFactory(d);function p(e){e=e||{};var t,n,r=this.context,i=e.dashConstants,a=e.type,o=e.segmentBaseController;function u(e){return e?e.segments?n[i.SEGMENT_BASE]:n[e.segmentInfoType]:null}return t={initialize:function(t){n[i.SEGMENT_TIMELINE]=s(r).create(e,t),n[i.SEGMENT_TEMPLATE]=l(r).create(e,t),n[i.SEGMENT_LIST]=f(r).create(e,t),n[i.SEGMENT_BASE]=h(r).create(e,t)},updateInitData:function(e,t){return t?Promise.resolve():o.getSegmentBaseInitSegment({representation:e,mediaType:a})},updateSegmentData:function(e,t){return t?Promise.resolve():o.getSegmentList({mimeType:e.mimeType,representation:e,mediaType:a})},getSegmentByIndex:function(e,t,n){var r=u(e);return r?r.getSegmentByIndex(e,t,n):null},getSegmentByTime:function(e,t){var n=u(e);return n?n.getSegmentByTime(e,t):null},getMediaFinishedInformation:function(e){var t=u(e);return t?t.getMediaFinishedInformation(e):{numberOfSegments:0,mediaTimeOfLastSignaledSegment:NaN}}},n={},t}p.__dashjs_factory_name="SegmentsController";var g=r.a.getClassFactory(p);t.a=g},function(e,t,n){"use strict";var r=function e(t,n,r,i){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.url=t||"",this.serviceLocation=n||t||"",this.dvb_priority=r||1,this.dvb_weight=i||1,this.availabilityTimeOffset=0,this.availabilityTimeComplete=!0};r.DEFAULT_DVB_PRIORITY=1,r.DEFAULT_DVB_WEIGHT=1,t.a=r},function(e,t){"function"==typeof Object.create?e.exports=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e}},function(e,t,n){!function(e){"use strict";var t={42:225,92:233,94:237,95:243,96:250,123:231,124:247,125:209,126:241,127:9608,128:174,129:176,130:189,131:191,132:8482,133:162,134:163,135:9834,136:224,137:32,138:232,139:226,140:234,141:238,142:244,143:251,144:193,145:201,146:211,147:218,148:220,149:252,150:8216,151:161,152:42,153:8217,154:9473,155:169,156:8480,157:8226,158:8220,159:8221,160:192,161:194,162:199,163:200,164:202,165:203,166:235,167:206,168:207,169:239,170:212,171:217,172:249,173:219,174:171,175:187,176:195,177:227,178:205,179:204,180:236,181:210,182:242,183:213,184:245,185:123,186:125,187:92,188:94,189:95,190:124,191:8764,192:196,193:228,194:214,195:246,196:223,197:165,198:164,199:9475,200:197,201:229,202:216,203:248,204:9487,205:9491,206:9495,207:9499},n=function(e){var n=e;return t.hasOwnProperty(e)&&(n=t[e]),String.fromCharCode(n)},r={17:1,18:3,21:5,22:7,23:9,16:11,19:12,20:14},i={17:2,18:4,21:6,22:8,23:10,19:13,20:15},a={25:1,26:3,29:5,30:7,31:9,24:11,27:12,28:14},o={25:2,26:4,29:6,30:8,31:10,27:13,28:15},s=["white","green","blue","cyan","red","yellow","magenta","black","transparent"],u={verboseFilter:{DATA:3,DEBUG:3,INFO:2,WARNING:2,TEXT:1,ERROR:0},time:null,verboseLevel:0,setTime:function(e){this.time=e},log:function(e,t){var n=this.verboseFilter[e];this.verboseLevel>=n&&console.log(this.time+" ["+e+"] "+t)}},l=function(e){for(var t=[],n=0;n<e.length;n++)t.push(e[n].toString(16));return t},c=function(e,t,n,r,i){this.foreground=e||"white",this.underline=t||!1,this.italics=n||!1,this.background=r||"black",this.flash=i||!1};c.prototype={reset:function(){this.foreground="white",this.underline=!1,this.italics=!1,this.background="black",this.flash=!1},setStyles:function(e){for(var t=["foreground","underline","italics","background","flash"],n=0;n<t.length;n++){var r=t[n];e.hasOwnProperty(r)&&(this[r]=e[r])}},isDefault:function(){return"white"===this.foreground&&!this.underline&&!this.italics&&"black"===this.background&&!this.flash},equals:function(e){return this.foreground===e.foreground&&this.underline===e.underline&&this.italics===e.italics&&this.background===e.background&&this.flash===e.flash},copy:function(e){this.foreground=e.foreground,this.underline=e.underline,this.italics=e.italics,this.background=e.background,this.flash=e.flash},toString:function(){return"color="+this.foreground+", underline="+this.underline+", italics="+this.italics+", background="+this.background+", flash="+this.flash}};var f=function(e,t,n,r,i,a){this.uchar=e||" ",this.penState=new c(t,n,r,i,a)};f.prototype={reset:function(){this.uchar=" ",this.penState.reset()},setChar:function(e,t){this.uchar=e,this.penState.copy(t)},setPenState:function(e){this.penState.copy(e)},equals:function(e){return this.uchar===e.uchar&&this.penState.equals(e.penState)},copy:function(e){this.uchar=e.uchar,this.penState.copy(e.penState)},isEmpty:function(){return" "===this.uchar&&this.penState.isDefault()}};var d=function(){this.chars=[];for(var e=0;e<32;e++)this.chars.push(new f);this.pos=0,this.currPenState=new c};d.prototype={equals:function(e){for(var t=!0,n=0;n<32;n++)if(!this.chars[n].equals(e.chars[n])){t=!1;break}return t},copy:function(e){for(var t=0;t<32;t++)this.chars[t].copy(e.chars[t])},isEmpty:function(){for(var e=!0,t=0;t<32;t++)if(!this.chars[t].isEmpty()){e=!1;break}return e},setCursor:function(e){this.pos!==e&&(this.pos=e),this.pos<0?(u.log("ERROR","Negative cursor position "+this.pos),this.pos=0):this.pos>32&&(u.log("ERROR","Too large cursor position "+this.pos),this.pos=32)},moveCursor:function(e){var t=this.pos+e;if(e>1)for(var n=this.pos+1;n<t+1;n++)this.chars[n].setPenState(this.currPenState);this.setCursor(t)},backSpace:function(){this.moveCursor(-1),this.chars[this.pos].setChar(" ",this.currPenState)},insertChar:function(e){e>=144&&this.backSpace();var t=n(e);this.pos>=32?u.log("ERROR","Cannot insert "+e.toString(16)+" ("+t+") at position "+this.pos+". Skipping it!"):(this.chars[this.pos].setChar(t,this.currPenState),this.moveCursor(1))},clearFromPos:function(e){var t;for(t=e;t<32;t++)this.chars[t].reset()},clear:function(){this.clearFromPos(0),this.pos=0,this.currPenState.reset()},clearToEndOfRow:function(){this.clearFromPos(this.pos)},getTextString:function(){for(var e=[],t=!0,n=0;n<32;n++){var r=this.chars[n].uchar;" "!==r&&(t=!1),e.push(r)}return t?"":e.join("")},setPenStyles:function(e){this.currPenState.setStyles(e),this.chars[this.pos].setPenState(this.currPenState)}};var h=function(){this.rows=[];for(var e=0;e<15;e++)this.rows.push(new d);this.currRow=14,this.nrRollUpRows=null,this.reset()};h.prototype={reset:function(){for(var e=0;e<15;e++)this.rows[e].clear();this.currRow=14},equals:function(e){for(var t=!0,n=0;n<15;n++)if(!this.rows[n].equals(e.rows[n])){t=!1;break}return t},copy:function(e){for(var t=0;t<15;t++)this.rows[t].copy(e.rows[t])},isEmpty:function(){for(var e=!0,t=0;t<15;t++)if(!this.rows[t].isEmpty()){e=!1;break}return e},backSpace:function(){this.rows[this.currRow].backSpace()},clearToEndOfRow:function(){this.rows[this.currRow].clearToEndOfRow()},insertChar:function(e){this.rows[this.currRow].insertChar(e)},setPen:function(e){this.rows[this.currRow].setPenStyles(e)},moveCursor:function(e){this.rows[this.currRow].moveCursor(e)},setCursor:function(e){u.log("INFO","setCursor: "+e),this.rows[this.currRow].setCursor(e)},setPAC:function(e){u.log("INFO","pacData = "+JSON.stringify(e));var t=e.row-1;this.nrRollUpRows&&t<this.nrRollUpRows-1&&(t=this.nrRollUpRows-1),this.currRow=t;var n=this.rows[this.currRow];if(null!==e.indent){var r=e.indent,i=Math.max(r-1,0);n.setCursor(e.indent),e.color=n.chars[i].penState.foreground}var a={foreground:e.color,underline:e.underline,italics:e.italics,background:"black",flash:!1};this.setPen(a)},setBkgData:function(e){u.log("INFO","bkgData = "+JSON.stringify(e)),this.backSpace(),this.setPen(e),this.insertChar(32)},setRollUpRows:function(e){this.nrRollUpRows=e},rollUp:function(){if(null!==this.nrRollUpRows){u.log("TEXT",this.getDisplayText());var e=this.currRow+1-this.nrRollUpRows,t=this.rows.splice(e,1)[0];t.clear(),this.rows.splice(this.currRow,0,t),u.log("INFO","Rolling up")}else u.log("DEBUG","roll_up but nrRollUpRows not set yet")},getDisplayText:function(e){e=e||!1;for(var t=[],n="",r=-1,i=0;i<15;i++){var a=this.rows[i].getTextString();a&&(r=i+1,e?t.push("Row "+r+': "'+a+'"'):t.push(a.trim()))}return t.length>0&&(n=e?"["+t.join(" | ")+"]":t.join("\n")),n},getTextAndFormat:function(){return this.rows}};var p=function(e,t){this.chNr=e,this.outputFilter=t,this.mode=null,this.verbose=0,this.displayedMemory=new h,this.nonDisplayedMemory=new h,this.lastOutputScreen=new h,this.currRollUpRow=this.displayedMemory.rows[14],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null};p.prototype={modes:["MODE_ROLL-UP","MODE_POP-ON","MODE_PAINT-ON","MODE_TEXT"],reset:function(){this.mode=null,this.displayedMemory.reset(),this.nonDisplayedMemory.reset(),this.lastOutputScreen.reset(),this.currRollUpRow=this.displayedMemory.rows[14],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null,this.lastCueEndTime=null},getHandler:function(){return this.outputFilter},setHandler:function(e){this.outputFilter=e},setPAC:function(e){this.writeScreen.setPAC(e)},setBkgData:function(e){this.writeScreen.setBkgData(e)},setMode:function(e){e!==this.mode&&(this.mode=e,u.log("INFO","MODE="+e),"MODE_POP-ON"==this.mode?this.writeScreen=this.nonDisplayedMemory:(this.writeScreen=this.displayedMemory,this.writeScreen.reset()),"MODE_ROLL-UP"!==this.mode&&(this.displayedMemory.nrRollUpRows=null,this.nonDisplayedMemory.nrRollUpRows=null),this.mode=e)},insertChars:function(e){for(var t=0;t<e.length;t++)this.writeScreen.insertChar(e[t]);var n=this.writeScreen===this.displayedMemory?"DISP":"NON_DISP";u.log("INFO",n+": "+this.writeScreen.getDisplayText(!0)),"MODE_PAINT-ON"!==this.mode&&"MODE_ROLL-UP"!==this.mode||(u.log("TEXT","DISPLAYED: "+this.displayedMemory.getDisplayText(!0)),this.outputDataUpdate())},cc_RCL:function(){u.log("INFO","RCL - Resume Caption Loading"),this.setMode("MODE_POP-ON")},cc_BS:function(){u.log("INFO","BS - BackSpace"),"MODE_TEXT"!==this.mode&&(this.writeScreen.backSpace(),this.writeScreen===this.displayedMemory&&this.outputDataUpdate())},cc_AOF:function(){},cc_AON:function(){},cc_DER:function(){u.log("INFO","DER- Delete to End of Row"),this.writeScreen.clearToEndOfRow(),this.outputDataUpdate()},cc_RU:function(e){u.log("INFO","RU("+e+") - Roll Up"),this.writeScreen=this.displayedMemory,this.setMode("MODE_ROLL-UP"),this.writeScreen.setRollUpRows(e)},cc_FON:function(){u.log("INFO","FON - Flash On"),this.writeScreen.setPen({flash:!0})},cc_RDC:function(){u.log("INFO","RDC - Resume Direct Captioning"),this.setMode("MODE_PAINT-ON")},cc_TR:function(){u.log("INFO","TR"),this.setMode("MODE_TEXT")},cc_RTD:function(){u.log("INFO","RTD"),this.setMode("MODE_TEXT")},cc_EDM:function(){u.log("INFO","EDM - Erase Displayed Memory"),this.displayedMemory.reset(),this.outputDataUpdate()},cc_CR:function(){u.log("CR - Carriage Return"),this.writeScreen.rollUp(),this.outputDataUpdate()},cc_ENM:function(){u.log("INFO","ENM - Erase Non-displayed Memory"),this.nonDisplayedMemory.reset()},cc_EOC:function(){if(u.log("INFO","EOC - End Of Caption"),"MODE_POP-ON"===this.mode){var e=this.displayedMemory;this.displayedMemory=this.nonDisplayedMemory,this.nonDisplayedMemory=e,this.writeScreen=this.nonDisplayedMemory,u.log("TEXT","DISP: "+this.displayedMemory.getDisplayText())}this.outputDataUpdate()},cc_TO:function(e){u.log("INFO","TO("+e+") - Tab Offset"),this.writeScreen.moveCursor(e)},cc_MIDROW:function(e){var t={flash:!1};if(t.underline=e%2==1,t.italics=e>=46,t.italics)t.foreground="white";else{var n=Math.floor(e/2)-16;t.foreground=["white","green","blue","cyan","red","yellow","magenta"][n]}u.log("INFO","MIDROW: "+JSON.stringify(t)),this.writeScreen.setPen(t)},outputDataUpdate:function(){var e=u.time;null!==e&&this.outputFilter&&(this.outputFilter.updateData&&this.outputFilter.updateData(e,this.displayedMemory),null!==this.cueStartTime||this.displayedMemory.isEmpty()?this.displayedMemory.equals(this.lastOutputScreen)||(this.outputFilter.newCue&&this.outputFilter.newCue(this.cueStartTime,e,this.lastOutputScreen),this.cueStartTime=this.displayedMemory.isEmpty()?null:e):this.cueStartTime=e,this.lastOutputScreen.copy(this.displayedMemory))},cueSplitAtTime:function(e){this.outputFilter&&(this.displayedMemory.isEmpty()||(this.outputFilter.newCue&&this.outputFilter.newCue(this.cueStartTime,e,this.displayedMemory),this.cueStartTime=e))}};var g=function(e,t,n){this.field=e||1,this.outputs=[t,n],this.channels=[new p(1,t),new p(2,n)],this.currChNr=-1,this.lastCmdA=null,this.lastCmdB=null,this.bufferedData=[],this.startTime=null,this.lastTime=null,this.dataCounters={padding:0,char:0,cmd:0,other:0}};g.prototype={getHandler:function(e){return this.channels[e].getHandler()},setHandler:function(e,t){this.channels[e].setHandler(t)},addData:function(e,t){var n,r,i,a=!1;this.lastTime=e,u.setTime(e);for(var o=0;o<t.length;o+=2)if(r=127&t[o],i=127&t[o+1],r>=16&&r<=31&&r===this.lastCmdA&&i===this.lastCmdB)this.lastCmdA=null,this.lastCmdB=null,u.log("DEBUG","Repeated command ("+l([r,i])+") is dropped");else if(0!==r||0!==i){if(u.log("DATA","["+l([t[o],t[o+1]])+"] -> ("+l([r,i])+")"),(n=this.parseCmd(r,i))||(n=this.parseMidrow(r,i)),n||(n=this.parsePAC(r,i)),n||(n=this.parseBackgroundAttributes(r,i)),!n)if(a=this.parseChars(r,i))if(this.currChNr&&this.currChNr>=0)this.channels[this.currChNr-1].insertChars(a);else u.log("WARNING","No channel found yet. TEXT-MODE?");n?this.dataCounters.cmd+=2:a?this.dataCounters.char+=2:(this.dataCounters.other+=2,u.log("WARNING","Couldn't parse cleaned data "+l([r,i])+" orig: "+l([t[o],t[o+1]])))}else this.dataCounters.padding+=2},parseCmd:function(e,t){var n=null;if(!((20===e||21===e||28===e||29===e)&&32<=t&&t<=47)&&!((23===e||31===e)&&33<=t&&t<=35))return!1;n=20===e||21===e||23===e?1:2;var r=this.channels[n-1];return 20===e||21===e||28===e||29===e?32===t?r.cc_RCL():33===t?r.cc_BS():34===t?r.cc_AOF():35===t?r.cc_AON():36===t?r.cc_DER():37===t?r.cc_RU(2):38===t?r.cc_RU(3):39===t?r.cc_RU(4):40===t?r.cc_FON():41===t?r.cc_RDC():42===t?r.cc_TR():43===t?r.cc_RTD():44===t?r.cc_EDM():45===t?r.cc_CR():46===t?r.cc_ENM():47===t&&r.cc_EOC():r.cc_TO(t-32),this.lastCmdA=e,this.lastCmdB=t,this.currChNr=n,!0},parseMidrow:function(e,t){var n=null;if((17===e||25===e)&&32<=t&&t<=47){if((n=17===e?1:2)!==this.currChNr)return u.log("ERROR","Mismatch channel in midrow parsing"),!1;var r=this.channels[n-1];return r.insertChars([32]),r.cc_MIDROW(t),u.log("DEBUG","MIDROW ("+l([e,t])+")"),this.lastCmdA=e,this.lastCmdB=t,!0}return!1},parsePAC:function(e,t){var n,s=null;if(!((17<=e&&e<=23||25<=e&&e<=31)&&64<=t&&t<=127)&&!((16===e||24===e)&&64<=t&&t<=95))return!1;n=e<=23?1:2,s=64<=t&&t<=95?1===n?r[e]:a[e]:1===n?i[e]:o[e];var u=this.interpretPAC(s,t);return this.channels[n-1].setPAC(u),this.lastCmdA=e,this.lastCmdB=t,this.currChNr=n,!0},interpretPAC:function(e,t){var n=t,r={color:null,italics:!1,indent:null,underline:!1,row:e};return n=t>95?t-96:t-64,r.underline=1==(1&n),n<=13?r.color=["white","green","blue","cyan","red","yellow","magenta","white"][Math.floor(n/2)]:n<=15?(r.italics=!0,r.color="white"):r.indent=4*Math.floor((n-16)/2),r},parseChars:function(e,t){var r=null,i=null,a=null;if(e>=25?(r=2,a=e-8):(r=1,a=e),17<=a&&a<=19){var o=t;o=17===a?t+80:18===a?t+112:t+144,u.log("INFO","Special char '"+n(o)+"' in channel "+r),i=[o],this.lastCmdA=e,this.lastCmdB=t}else 32<=e&&e<=127&&(i=0===t?[e]:[e,t],this.lastCmdA=null,this.lastCmdB=null);if(i){var s=l(i);u.log("DEBUG","Char codes =  "+s.join(","))}return i},parseBackgroundAttributes:function(e,t){var n,r,i;return((16===e||24===e)&&32<=t&&t<=47||(23===e||31===e)&&45<=t&&t<=47)&&(n={},16===e||24===e?(r=Math.floor((t-32)/2),n.background=s[r],t%2==1&&(n.background=n.background+"_semi")):45===t?n.background="transparent":(n.foreground="black",47===t&&(n.underline=!0)),i=e<24?1:2,this.channels[i-1].setBkgData(n),this.lastCmdA=e,this.lastCmdB=t,!0)},reset:function(){for(var e=0;e<this.channels.length;e++)this.channels[e]&&this.channels[e].reset();this.lastCmdA=null,this.lastCmdB=null},cueSplitAtTime:function(e){for(var t=0;t<this.channels.length;t++)this.channels[t]&&this.channels[t].cueSplitAtTime(e)}};e.logger=u,e.PenState=c,e.CaptionScreen=h,e.Cea608Parser=g,e.findCea608Nalus=function(e,t,n){for(var r=0,i=t,a=[],o=function(e,t,n,r){if(4!==e||t<8)return null;var i=n.getUint8(r),a=n.getUint16(r+1),o=n.getUint32(r+3),s=n.getUint8(r+7);return 181==i&&49==a&&1195456820==o&&3==s};i<t+n;){if(r=e.getUint32(i),6===(31&e.getUint8(i+4)))for(var s=i+5,u=-1;s<i+4+r-1;){u=0;for(var l=255;255===l;)u+=l=e.getUint8(s),s++;var c=0;for(l=255;255===l;)c+=l=e.getUint8(s),s++;o(u,c,e,s)&&a.push([s,c]),s+=c}i+=r+4}return a},e.extractCea608DataFromRange=function(e,t){var n=t[0],r=[[],[]];n+=8;var i=31&e.getUint8(n);n+=2;for(var a=0;a<i;a++){var o=e.getUint8(n),s=4&o,u=3&o;n++;var l=e.getUint8(n);n++;var c=e.getUint8(n);n++,s&&(127&l)+(127&c)!=0&&(0===u?(r[0].push(l),r[0].push(c)):1===u&&(r[1].push(l),r[1].push(c)))}return r}}(t)},function(e,t,n){"use strict";var r=n(7),i=n(4),a=n(19),o=n(3),s=n(16),u=n(1),l=n(5),c=n(33),f=n(15);function d(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=function(e,t){if(!e)return;if("string"==typeof e)return h(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return h(e,t)}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,i=function(){};return{s:i,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,o=!0,s=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return o=e.done,e},e:function(e){s=!0,a=e},f:function(){try{o||null==n.return||n.return()}finally{if(s)throw a}}}}function h(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var p="m",g="a",m="v",y="i",E="c",_="tt",T="k",v="o",S="d",A="s",b="v",I="l";function R(){var e,t,n,o,h,R,N,C,w,D,O=this.context,M=Object(r.a)(O).getInstance(),P=Object(s.a)(O).getInstance();function L(){n={pr:1,nor:null,st:null,sf:null,sid:"".concat(f.a.generateUuid()),cid:null},w={},C={},D={},x()}function F(){x()}function x(){if(R){var e=R.getStreamController();if(e&&"function"==typeof e.getActiveStream){var t=e.getActiveStream();t&&(N=t.getProcessors())}}}function U(e,t){var n,r={},i=d(t);try{for(i.s();!(n=i.n()).done;){var a=n.value;e[a]&&(r[a]=e[a])}}catch(e){i.e(e)}finally{i.f()}return r}function B(e){var t=P.get().streaming.cmcd.enabledKeys;return e.filter((function(e){return t.includes(e)}))}function k(e){try{return e.type===l.a.MPD_TYPE?((t=G()).ot=p,t):e.type===l.a.MEDIA_SEGMENT_TYPE?(function(e){D.hasOwnProperty(e)||(D[e]=!1);C.hasOwnProperty(e)||(C[e]=!1);w.hasOwnProperty(e)||(w[e]=!1)}(e.mediaType),function(e){var t,r=G(),i=function(e){try{var t=e.quality,n=e.mediaInfo.bitrateList;return parseInt(n[t].bandwidth/1e3)}catch(e){return null}}(e),a=function(e){try{return isNaN(e.duration)?null:Math.round(1e3*e.duration)}catch(e){return null}}(e),s=function(e){try{return 100*parseInt(o.getThroughputHistory().getSafeAverageThroughput(e)/100)}catch(e){return null}}(e.mediaType),l=function(e){try{var t=n.pr,r=h.getCurrentBufferLevel(e);return isNaN(t)||isNaN(r)?null:100*parseInt(r/t*10)}catch(e){return null}}(e.mediaType),c=j(e.mediaType),p=function(e){try{var t=o.getTopBitrateInfoFor(e);return Math.round(t.bitrate/1e3)}catch(e){return null}}(e.mediaType),y=n.pr,T=function(e){if(!N||0===N.length)return;var t,n=d(N);try{for(n.s();!(t=n.n()).done;){var r=t.value;if(r.getType()===e)return r.probeNextRequest()}}catch(e){n.e(e)}finally{n.f()}}(e.mediaType);e.mediaType===u.a.VIDEO&&(t=m);e.mediaType===u.a.AUDIO&&(t=g);e.mediaType===u.a.TEXT&&(t="application/mp4"===e.mediaInfo.mimeType?_:E);var v=P.get().streaming.cmcd.rtp;v||(v=function(e){var t=R.getPlaybackRate();t||(t=1);var n=e.quality,r=e.mediaType,i=e.mediaInfo,a=e.duration,o=j(r);0===o&&(o=500);var s=i.bitrateList[n].bandwidth*a/1e3/(o/t/1e3),u=P.get().streaming.cmcd.rtpSafetyFactor&&!isNaN(P.get().streaming.cmcd.rtpSafetyFactor)?P.get().streaming.cmcd.rtpSafetyFactor:5;return 100*(parseInt(s*u/100)+1)}(e));r.rtp=v,T&&(e.url!==T.url?r.nor=encodeURIComponent(f.a.getRelativeUrl(e.url,T.url)):T.range&&(r.nrr=T.range));i&&(r.br=i);t&&(r.ot=t);isNaN(a)||(r.d=a);isNaN(s)||(r.mtp=s);isNaN(l)||(r.dl=l);isNaN(c)||(r.bl=c);isNaN(p)||(r.tb=p);isNaN(y)||1===y||(r.pr=y);w[e.mediaType]&&(r.bs=!0,w[e.mediaType]=!1);!C[e.mediaType]&&D[e.mediaType]||(r.su=!0,C[e.mediaType]=!1,D[e.mediaType]=!0);return r}(e)):e.type===l.a.INIT_SEGMENT_TYPE?function(){var e=G();return e.ot=y,e.su=!0,e}():e.type===l.a.OTHER_TYPE||e.type===l.a.XLINK_EXPANSION_TYPE?function(){var e=G();return e.ot=v,e}():e.type===l.a.LICENSE?function(e){var t=G();return t.ot=T,t}():null}catch(e){return null}var t}function G(){var e={},t=P.get().streaming.cmcd.cid?P.get().streaming.cmcd.cid:n.cid;return e.v=1,e.sid=P.get().streaming.cmcd.sid?P.get().streaming.cmcd.sid:n.sid,e.sid="".concat(e.sid),t&&(e.cid="".concat(t)),isNaN(n.pr)||1===n.pr||null===n.pr||(e.pr=n.pr),n.st&&(e.st=n.st),n.sf&&(e.sf=n.sf),e}function j(e){try{var t=h.getCurrentBufferLevel(e);return isNaN(t)?null:100*parseInt(10*t)}catch(e){return null}}function Y(e){try{n.pr=e.playbackRate}catch(e){}}function H(t){try{var r=e.getIsDynamic(t.data)?I:b,i=t.protocol&&"MSS"===t.protocol?A:S;n.st="".concat(r),n.sf="".concat(i)}catch(e){}}function V(e){try{e.state&&e.mediaType&&e.state===i.a.BUFFER_EMPTY&&(w[e.mediaType]||(w[e.mediaType]=!0),C[e.mediaType]||(C[e.mediaType]=!0))}catch(e){}}function K(){for(var e in w)w.hasOwnProperty(e)&&(w[e]=!0);for(var t in C)C.hasOwnProperty(t)&&(C[t]=!0)}function q(e){try{if(!e)return null;var t=Object.keys(e).sort((function(e,t){return e.localeCompare(t)})),n=t.length,r=t.reduce((function(t,r,i){return"v"===r&&1===e[r]||("string"==typeof e[r]&&"ot"!==r&&"sf"!==r&&"st"!==r?t+="".concat(r,"=").concat(JSON.stringify(e[r])):t+="".concat(r,"=").concat(e[r]),i<n-1&&(t+=",")),t}),"");return r=(r=r.replace(/=true/g,"")).replace(/,\s*$/,"")}catch(e){return null}}return t={getQueryParameter:function(e){try{if(P.get().streaming.cmcd&&P.get().streaming.cmcd.enabled){var t=k(e),n=q(function(e){try{var t=P.get().streaming.cmcd.enabledKeys;return Object.keys(e).filter((function(e){return t.includes(e)})).reduce((function(t,n){return t[n]=e[n],t}),{})}catch(t){return e}}(t));return M.trigger(a.a.CMCD_DATA_GENERATED,{url:e.url,mediaType:e.mediaType,cmcdData:t,cmcdString:n}),{key:"CMCD",value:n}}return null}catch(e){return null}},getHeaderParameters:function(e){try{if(P.get().streaming.cmcd&&P.get().streaming.cmcd.enabled){var t=k(e),n=U(t,B(["br","d","ot","tb"])),r=U(t,B(["bl","dl","mtp","nor","nrr","su"])),i=U(t,B(["bs","rtp"])),o=U(t,B(["cid","pr","sf","sid","st","v"])),s={"CMCD-Object":q(n),"CMCD-Request":q(r),"CMCD-Status":q(i),"CMCD-Session":q(o)};return M.trigger(a.a.CMCD_DATA_GENERATED,{url:e.url,mediaType:e.mediaType,cmcdData:t,headers:s}),s}return null}catch(e){return null}},setConfig:function(e){e&&(e.abrController&&(o=e.abrController),e.dashMetrics&&(h=e.dashMetrics),e.playbackController&&(R=e.playbackController))},reset:function(){M.off(i.a.PLAYBACK_RATE_CHANGED,Y,this),M.off(i.a.MANIFEST_LOADED,H,this),M.off(i.a.BUFFER_LEVEL_STATE_CHANGED,V,t),M.off(i.a.PLAYBACK_SEEKED,K,t),L()},initialize:function(){M.on(i.a.PLAYBACK_RATE_CHANGED,Y,t),M.on(i.a.MANIFEST_LOADED,H,t),M.on(i.a.BUFFER_LEVEL_STATE_CHANGED,V,t),M.on(i.a.PLAYBACK_SEEKED,K,t),M.on(i.a.PERIOD_SWITCH_COMPLETED,F,t)}},e=Object(c.a)(O).getInstance(),L(),t}R.__dashjs_factory_name="CmcdModel",t.a=o.a.getSingletonFactory(R)},function(e,t,n){"use strict";t.a=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.duration=NaN,this.presentationTime=NaN,this.id=NaN,this.messageData="",this.eventStream=null,this.presentationTimeDelta=NaN}},function(e,t,n){"use strict";var r=n(3),i=n(60),a=n.n(i);function o(){return{areEqual:function(e,t){return a()(e,t)}}}o.__dashjs_factory_name="ObjectUtils",t.a=r.a.getSingletonFactory(o)},function(e,t,n){"use strict";t.a=function(e){e=e||{},function(){void 0===e.escapeMode&&(e.escapeMode=!0);void 0===e.attributePrefix&&(e.attributePrefix="_");e.arrayAccessForm=e.arrayAccessForm||"none",e.emptyNodeForm=e.emptyNodeForm||"text",void 0===e.enableToStringFunc&&(e.enableToStringFunc=!0);e.arrayAccessFormPaths=e.arrayAccessFormPaths||[],void 0===e.skipEmptyTextNodesForObj&&(e.skipEmptyTextNodesForObj=!0);void 0===e.stripWhitespaces&&(e.stripWhitespaces=!0);e.datetimeAccessFormPaths=e.datetimeAccessFormPaths||[],void 0===e.useDoubleQuotes&&(e.useDoubleQuotes=!1);e.xmlElementsFilter=e.xmlElementsFilter||[],e.jsonPropertiesFilter=e.jsonPropertiesFilter||[],void 0===e.keepCData&&(e.keepCData=!1);void 0===e.ignoreRoot&&(e.ignoreRoot=!1)}();var t=1,n=3,r=4,i=8,a=9;function o(e){var t=e.localName;return null==t&&(t=e.baseName),null!=t&&""!=t||(t=e.nodeName),t}function s(e){return"string"==typeof e?e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;"):e}function u(e,t,n,r){for(var i=0;i<e.length;i++){var a=e[i];if("string"==typeof a){if(a==r)break}else if(a instanceof RegExp){if(a.test(r))break}else if("function"==typeof a&&a(t,n,r))break}return i!=e.length}function l(t,n,r){switch(e.arrayAccessForm){case"property":t[n]instanceof Array?t[n+"_asArray"]=t[n]:t[n+"_asArray"]=[t[n]]}!(t[n]instanceof Array)&&e.arrayAccessFormPaths.length>0&&u(e.arrayAccessFormPaths,t,n,r)&&(t[n]=[t[n]])}function c(e){var t=e.split(/[-T:+Z]/g),n=new Date(t[0],t[1]-1,t[2]),r=t[5].split(".");if(n.setHours(t[3],t[4],r[0]),r.length>1&&n.setMilliseconds(r[1]),t[6]&&t[7]){var i=60*t[6]+Number(t[7]);i=0+("-"==(/\d\d-\d\d:\d\d$/.test(e)?"-":"+")?-1*i:i),n.setMinutes(n.getMinutes()-i-n.getTimezoneOffset())}else-1!==e.indexOf("Z",e.length-1)&&(n=new Date(Date.UTC(n.getFullYear(),n.getMonth(),n.getDate(),n.getHours(),n.getMinutes(),n.getSeconds(),n.getMilliseconds())));return n}function f(n,r,i,a){return!(r==t&&e.xmlElementsFilter.length>0)||u(e.xmlElementsFilter,n,i,a)}function d(s,h){if(s.nodeType==a){for(var p=new Object,g=s.childNodes,m=0;m<g.length;m++){if((E=g[m]).nodeType==t)if(e.ignoreRoot)p=d(E);else(p={})[_=o(E)]=d(E)}return p}if(s.nodeType==t){(p=new Object).__cnt=0;var y=[];for(g=s.childNodes,m=0;m<g.length;m++){var E,_=o(E=g[m]);if(E.nodeType!=i){var T=h+"."+_;if(f(p,E.nodeType,_,T))if(p.__cnt++,null==p[_]){var v=d(E,T);if("#text"!=_||/[^\s]/.test(v))(S={})[_]=v,y.push(S);p[_]=v,l(p,_,T)}else{null!=p[_]&&(p[_]instanceof Array||(p[_]=[p[_]],l(p,_,T)));var S;v=d(E,T);if("#text"!=_||/[^\s]/.test(v))(S={})[_]=v,y.push(S);p[_][p[_].length]=v}}}p.__children=y;for(var A=o(s),b=0;b<s.attributes.length;b++){var I=s.attributes[b];p.__cnt++;for(var R=I.value,N=0,C=e.matchers.length;N<C;N++){var w=e.matchers[N];w.test(I,A)&&(R=w.converter(I.value))}p[e.attributePrefix+I.name]=R}var D=function(e){return e.prefix}(s);return null!=D&&""!=D&&(p.__cnt++,p.__prefix=D),null!=p["#text"]&&(p.__text=p["#text"],p.__text instanceof Array&&(p.__text=p.__text.join("\n")),e.stripWhitespaces&&(p.__text=p.__text.trim()),delete p["#text"],"property"==e.arrayAccessForm&&delete p["#text_asArray"],p.__text=function(t,n,r){if(e.datetimeAccessFormPaths.length>0){var i=r.split(".#")[0];return u(e.datetimeAccessFormPaths,t,n,i)?c(t):t}return t}(p.__text,_,h+"."+_)),null!=p["#cdata-section"]&&(p.__cdata=p["#cdata-section"],delete p["#cdata-section"],"property"==e.arrayAccessForm&&delete p["#cdata-section_asArray"]),0==p.__cnt&&"text"==e.emptyNodeForm?p="":1==p.__cnt&&null!=p.__text?p=p.__text:1!=p.__cnt||null==p.__cdata||e.keepCData?p.__cnt>1&&null!=p.__text&&e.skipEmptyTextNodesForObj&&(e.stripWhitespaces&&""==p.__text||""==p.__text.trim())&&delete p.__text:p=p.__cdata,delete p.__cnt,!e.enableToStringFunc||null==p.__text&&null==p.__cdata||(p.toString=function(){return(null!=this.__text?this.__text:"")+(null!=this.__cdata?this.__cdata:"")}),p}if(s.nodeType==n||s.nodeType==r)return s.nodeValue}function h(t,n,r,i){var a="<"+(null!=t&&null!=t.__prefix?t.__prefix+":":"")+n;if(null!=r)for(var o=0;o<r.length;o++){var u=r[o],l=t[u];e.escapeMode&&(l=s(l)),a+=" "+u.substr(e.attributePrefix.length)+"=",e.useDoubleQuotes?a+='"'+l+'"':a+="'"+l+"'"}return a+=i?"/>":">"}function p(e,t){return"</"+(null!=e.__prefix?e.__prefix+":":"")+t+">"}function g(t,n){return"property"==e.arrayAccessForm&&(r=n.toString(),i="_asArray",-1!==r.indexOf(i,r.length-i.length))||0==n.toString().indexOf(e.attributePrefix)||0==n.toString().indexOf("__")||t[n]instanceof Function;var r,i}function m(e){var t=0;if(e instanceof Object)for(var n in e)g(e,n)||t++;return t}function y(t,n,r){return 0==e.jsonPropertiesFilter.length||""==r||u(e.jsonPropertiesFilter,t,n,r)}function E(t){var n=[];if(t instanceof Object)for(var r in t)-1==r.toString().indexOf("__")&&0==r.toString().indexOf(e.attributePrefix)&&n.push(r);return n}function _(t){var n="";return t instanceof Object?n+=function(t){var n="";return null!=t.__cdata&&(n+="<![CDATA["+t.__cdata+"]]>"),null!=t.__text&&(e.escapeMode?n+=s(t.__text):n+=t.__text),n}(t):null!=t&&(e.escapeMode?n+=s(t):n+=t),n}function T(e,t){return""===e?t:e+"."+t}function v(e,t,n,r){var i="";if(0==e.length)i+=h(e,t,n,!0);else for(var a=0;a<e.length;a++)i+=h(e[a],t,E(e[a]),!1),i+=S(e[a],T(r,t)),i+=p(e[a],t);return i}function S(e,t){var n="";if(m(e)>0)for(var r in e)if(!g(e,r)&&(""==t||y(e,r,T(t,r)))){var i=e[r],a=E(i);if(null==i||null==i)n+=h(i,r,a,!0);else if(i instanceof Object)if(i instanceof Array)n+=v(i,r,a,t);else if(i instanceof Date)n+=h(i,r,a,!1),n+=i.toISOString(),n+=p(i,r);else{m(i)>0||null!=i.__text||null!=i.__cdata?(n+=h(i,r,a,!1),n+=S(i,T(t,r)),n+=p(i,r)):n+=h(i,r,a,!0)}else n+=h(i,r,a,!1),n+=_(i),n+=p(i,r)}return n+=_(e)}this.parseXmlString=function(e){var t;window.ActiveXObject||window;if(void 0===e)return null;if(window.DOMParser){var n=new window.DOMParser;try{(t=n.parseFromString(e,"text/xml")).getElementsByTagNameNS("*","parsererror").length>0&&(t=null)}catch(e){t=null}}else 0==e.indexOf("<?")&&(e=e.substr(e.indexOf("?>")+2)),(t=new ActiveXObject("Microsoft.XMLDOM")).async="false",t.loadXML(e);return t},this.asArray=function(e){return void 0===e||null==e?[]:e instanceof Array?e:[e]},this.toXmlDateTime=function(e){return e instanceof Date?e.toISOString():"number"==typeof e?new Date(e).toISOString():null},this.asDateTime=function(e){return"string"==typeof e?c(e):e},this.xml2json=function(e){return d(e)},this.xml_str2json=function(e){var t=this.parseXmlString(e);return null!=t?this.xml2json(t):null},this.json2xml_str=function(e){return S(e,"")},this.json2xml=function(e){var t=this.json2xml_str(e);return this.parseXmlString(t)},this.getVersion=function(){return"1.2.0"}}},function(e,t,n){"use strict";var r=n(3),i=n(29),a=n(16),o=n(1);function s(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(e)))return;var n=[],r=!0,i=!1,a=void 0;try{for(var o,s=e[Symbol.iterator]();!(r=(o=s.next()).done)&&(n.push(o.value),!t||n.length!==t);r=!0);}catch(e){i=!0,a=e}finally{try{r||null==s.return||s.return()}finally{if(i)throw a}}return n}(e,t)||u(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(e,t){if(e){if("string"==typeof e)return l(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?l(e,t):void 0}}function l(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function c(e){e=e||{};var t,n=this.context,r=e.requestModifier,i=e.lowLatencyThroughputModel,l=e.boxParser,c=Object(a.a)(n).getInstance();function f(e,t){e.reader.read().then(t).catch((function(t){e.onerror&&200===e.response.status&&e.onerror(t)}))}function d(e,t){try{if((e=e.filter((function(n){return n.bytes>t/4/e.length}))).length>1){var n=0,r=(e[e.length-1].ts-e[0].ts)/e.length;return e.forEach((function(t,i){var a=e[i+1];if(a){var o=a.ts-t.ts;n+=o<r?o:0}})),n}return null}catch(e){return null}}return{load:function(e){var n,a=new Date,h=e.request,p=new Headers;if(h.range&&p.append("Range","bytes="+h.range),e.headers)for(var g in e.headers){var m=e.headers[g];m&&p.append(g,m)}h.requestStartDate||(h.requestStartDate=a),r&&r.modifyRequestHeader({setRequestHeader:function(e,t){p.append(e,t)}}),"function"==typeof window.AbortController&&(n=new AbortController,e.abortController=n,n.signal.onabort=e.onabort);var y={method:e.method,headers:p,credentials:e.withCredentials?"include":void 0,signal:n?n.signal:void 0},E=c.get().streaming.abr.fetchThroughputCalculationMode,_=Date.now(),T=0;new Promise((function(e){if(E===o.a.ABR_FETCH_THROUGHPUT_CALCULATION_AAST&&i&&(T=i.getThroughputCapacityDelayMS(h,1e3*t.getCurrentBufferLevel(h.mediaType))))return setTimeout(e,T);e()})).then((function(){var n=Date.now();fetch(e.url,y).then((function(r){e.response||(e.response={}),e.response.status=r.status,e.response.statusText=r.statusText,e.response.responseURL=r.url,r.ok||e.onerror();var a,c="",p=function(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=u(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,i=function(){};return{s:i,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,o=!0,s=!1;return{s:function(){n=e[Symbol.iterator]()},n:function(){var e=n.next();return o=e.done,e},e:function(e){s=!0,a=e},f:function(){try{o||null==n.return||n.return()}finally{if(s)throw a}}}}(r.headers.keys());try{for(p.s();!(a=p.n()).done;){var g=a.value;c+=g+": "+r.headers.get(g)+"\r\n"}}catch(e){p.e(e)}finally{p.f()}if(e.response.responseHeaders=c,!r.body)return r.arrayBuffer().then((function(t){e.response.response=t;var n={loaded:t.byteLength,total:t.byteLength,stream:!1};e.progress(n),e.onload(),e.onend()}));var m,y,v=parseInt(r.headers.get("Content-Length"),10),S=0,A=!1,b=new Uint8Array,I=0;if(E===o.a.ABR_FETCH_THROUGHPUT_CALCULATION_AAST&&i){var R=n,N=0,C=s(r.body.tee(),2),w=C[0],D=C[1];m=w.getReader(),y=[],m.read().then((function r(a){var o=a.value,s=a.done;if(N=Date.now(),o&&o.length){var u=N-R,l=o.length;y.push({chunkDownloadTimeRelativeMS:N-n,chunkDownloadDurationMS:u,chunkBytes:l,kbps:Math.round(8*l/(u/1e3)),bufferLevel:t.getCurrentBufferLevel(h.mediaType)})}if(s){var f=N-n,d=y.reduce((function(e,t){return e+t.chunkBytes}),0);return i.addMeasurement(h,f,y,_,T,c),void e.progress({loaded:d,total:d,lengthComputable:!0,time:i.getEstimatedDownloadDurationMS(h),stream:!0})}return R=Date.now(),m.read().then(r)})),e.reader=D.getReader()}else e.reader=r.body.getReader();var O=[],M=[],P=[],L=!0;f(e,(function t(n){var r=n.value;if(n.done){if(b){if(E!==o.a.ABR_FETCH_THROUGHPUT_CALCULATION_AAST){var i=null;E===o.a.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING&&(i=function(e,t){try{var n,r;n=e.filter((function(t,n){return n<e.length-1})),r=t.filter((function(e,n){return n<t.length-1}));var i=[];if(n.length>1){for(var a=0,o=0,s=0;s<n.length;s++)if(n[s]&&r[s]){var u=r[s].ts-n[s].ts;if(u>1)i.push(8*r[s].bytes/u);else{0===o&&(o=n[s].ts);var l=r[s].ts-o;l>1?(i.push(8*a/l),a=0,o=0):a+=r[s].bytes}}if(i.length>0)return i.reduce((function(e,t){return e+t}),0)/i.length}return null}catch(e){return null}}(M,P)),e.progress({loaded:S,total:isNaN(v)?S:v,lengthComputable:!0,time:d(O,S),throughput:i,stream:!0})}e.response.response=b.buffer}return e.onload(),void e.onend()}if(r&&r.length>0){if(b=function(e,t){if(0===e.length)return t;var n=new Uint8Array(e.length+t.length);return n.set(e),n.set(t,e.length),n}(b,r),S+=r.length,O.push({ts:Date.now(),bytes:r.length}),E===o.a.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING&&L)l.findLastTopIsoBoxCompleted(["moof"],b,I).found&&(L=!1,M.push({ts:performance.now(),bytes:r.length}));var a=l.findLastTopIsoBoxCompleted(["moov","mdat"],b,I);if(a.found){var s,u=a.lastCompletedOffset+a.size;E!==o.a.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING||L||(L=!0,P.push({ts:performance.now(),bytes:b.length})),u===b.length?(s=b,b=new Uint8Array):(s=new Uint8Array(b.subarray(0,u)),b=b.subarray(u)),e.progress({data:s.buffer,lengthComputable:!1,noTrace:!0}),I=0}else I=a.lastCompletedOffset,A||(e.progress({lengthComputable:!1,noTrace:!0}),A=!0)}f(e,t)}))})).catch((function(t){e.onerror&&e.onerror(t)}))}))},abort:function(e){if(e.abortController)e.abortController.abort();else if(e.reader)try{e.reader.cancel(),e.onabort()}catch(e){}},calculateDownloadedTime:d,setup:function(e){t=e.dashMetrics}}}c.__dashjs_factory_name="FetchLoader";var f=r.a.getClassFactory(c),d=n(5),h=n(10),p=n(42),g=n(15),m=n(6),y=n(7),E=n(2);function _(){var e,t,n=this.context,r={};function i(){t=Object(m.a)(n).getInstance().getLogger(e)}function a(e){for(var t={},n=0,r=0,i=0,a=0,o=e.length,s=0;s<o;++s)n+=e[s].chunkDownloadTimeRelativeMS,r+=e[s].bufferLevel,i+=e[s].chunkDownloadTimeRelativeMS*e[s].bufferLevel,a+=e[s].chunkDownloadTimeRelativeMS*e[s].chunkDownloadTimeRelativeMS;return t.m=(i-n*r/o)/(a-n*n/o),t.b=r/o-t.m*n/o,function(e){return t.m*e+t.b}}function o(e){var t,n=!0,r=e.reduce((function(e,t){return e+t.bufferLevelAtSegmentEnd}),0)/e.length;return e.forEach((function(e){Math.abs(e.bufferLevelAtSegmentEnd/e.bufferLevelAtSegmentStart)<.95&&(n=!1),e.bufferLevelAtSegmentEnd/r<.8&&(n=!1),t?t>e.bitrate&&(n=!1):t=e.bitrate})),n}return e={setup:i,addMeasurement:function(e,t,n,i,o){e&&e.mediaType&&!r[e.mediaType]&&(r[e.mediaType]=[]);var s=e.mediaInfo.bitrateList.find((function(t){return t.id===e.representationId}));r[e.mediaType].push({index:e.index,repId:e.representationId,mediaType:e.mediaType,requestTimeMS:i,adjustedAvailabilityStartTimeMS:e.availabilityStartTime.getTime(),segDurationMS:1e3*e.duration,chunksDurationMS:n.reduce((function(e,t){return e+t.chunkDownloadDurationMS}),0),segmentBytes:n.reduce((function(e,t){return e+t.chunkBytes}),0),bitrate:s&&s.bandwidth,bitrateList:e.mediaInfo.bitrateList,chunkMeasurements:n,fetchDownloadDurationMS:t,throughputCapacityDelayMS:o,getEstimatedBufferLevel:a(n.slice(1))}),r[e.mediaType].length>10&&r[e.mediaType].shift()},getThroughputCapacityDelayMS:function(e,t){var n=r[e.mediaType]&&r[e.mediaType].slice(-3);return!n||n.length<3?0:o(n)?t/4>250?250:t/4:0},getEstimatedDownloadDurationMS:function(e){var n=r[e.mediaType].slice(-1).pop(),i=r[e.mediaType].slice(-3),a=n.chunkMeasurements.slice(-1).pop().chunkDownloadTimeRelativeMS;n.bufferLevelAtSegmentStart=n.getEstimatedBufferLevel(a/2),n.bufferLevelAtSegmentEnd=n.getEstimatedBufferLevel(a);var s=o(i),u=s?.6:.8;if(n.isBufferStable&&1.05*n.segDurationMS<n.fetchDownloadDurationMS)return n.fetchDownloadDurationMS;if(!s||n.segDurationMS<n.fetchDownloadDurationMS)return.8*n.fetchDownloadDurationMS;if(n.adjustedAvailabilityStartTimeMS<=n.requestTimeMS+n.throughputCapacityDelayMS-n.segDurationMS)return.8*n.fetchDownloadDurationMS;for(var l=n.requestTimeMS+n.throughputCapacityDelayMS-n.adjustedAvailabilityStartTimeMS,c=0,f=0,d=0,h=0;h<n.chunkMeasurements.length;h++){var p=n.chunkMeasurements[h];if(l<f+p.chunkDownloadDurationMS)break;f+=p.chunkDownloadDurationMS,c+=p.chunkBytes,d++}if(l<0&&t.warn("request time was before adjusted availibitly start time"),c&&f&&d>.2*n.chunkMeasurements.length){var g=c/f,m=n.segmentBytes/g;return n.fetchDownloadDurationMS<m?n.fetchDownloadDurationMS*u:m*u}var y=n.bitrate;return n.bitrateList.some((function(e){if(e.bandwidth>n.bitrate)return y=e.bandwidth,!0})),y===n.bitrate?n.fetchDownloadDurationMS*u:u*n.segmentBytes*8*1e3/y}},i(),e}_.__dashjs_factory_name="LowLatencyThroughputModel";var T=r.a.getSingletonFactory(_),v=n(31);function S(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function A(e){e=e||{};var t,n,r,s,u,l,c,_,A,b,I=this.context,R=e.errHandler,N=e.dashMetrics,C=e.mediaPlayerModel,w=e.requestModifier,D=e.boxParser,O=e.errors,M=e.requestTimeout||0,P=Object(y.a)(I).getInstance(),L=Object(a.a)(I).getInstance();function F(e,t){var a,p=e.request,m=[],y=!0,T=!0,v=new Date,S=v,b=0,O=null;if(!w||!N||!R)throw new Error("config object is not correct or missing");var x,U=function(e){if(T=!1,p.requestStartDate=v,p.requestEndDate=new Date,p.firstByteDate=p.firstByteDate||v,p.fileLoaderType=O,!p.checkExistenceOnly){var t=a.response?a.response.responseURL:null,n=a.response?a.response.status:null,r=a.response&&a.response.getAllResponseHeaders?a.response.getAllResponseHeaders():a.response?a.response.responseHeaders:[];N.addHttpRequest(p,t,n,r,e?m:null),p.type===d.a.MPD_TYPE&&N.addManifestUpdate(p)}},B=function(){if(-1!==n.indexOf(a)&&(n.splice(n.indexOf(a),1),T))if(U(!1),t>0){try{if(L.get().streaming.utcSynchronization.enableBackgroundSyncAfterSegmentDownloadError&&p.type===d.a.MEDIA_SEGMENT_TYPE)C.getRetryAttemptsForType(d.a.MEDIA_SEGMENT_TYPE)===t&&P.trigger(E.a.ATTEMPT_BACKGROUND_SYNC)}catch(e){}t--;var r={config:e};s.push(r),r.timeout=setTimeout((function(){-1!==s.indexOf(r)&&(s.splice(s.indexOf(r),1),F(e,t))}),C.getRetryIntervalsForType(p.type))}else{if(p.type===d.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE)return;R.error(new h.a(u[p.type],p.url+" is not available",{request:p,response:a.response})),e.error&&e.error(p,"error",a.response.statusText),e.complete&&e.complete(p,a.response.statusText)}};p.hasOwnProperty("availabilityTimeComplete")&&!1===p.availabilityTimeComplete&&window.fetch&&"arraybuffer"===p.responseType&&p.type===d.a.MEDIA_SEGMENT_TYPE?((x=f(I).create({requestModifier:w,lowLatencyThroughputModel:_,boxParser:D})).setup({dashMetrics:N}),O=o.a.FILE_LOADER_TYPES.FETCH):(x=Object(i.a)(I).create({requestModifier:w}),O=o.a.FILE_LOADER_TYPES.XHR);var k=null,G=w.modifyRequestURL(p.url);if(L.get().streaming.cmcd&&L.get().streaming.cmcd.enabled){var j=L.get().streaming.cmcd.mode;if(j===o.a.CMCD_MODE_QUERY){var Y=function(e){try{var t=[],n=l.getQueryParameter(e);return n&&t.push(n),t}catch(e){return[]}}(p);G=g.a.addAditionalQueryParameterToUrl(G,Y)}else j===o.a.CMCD_MODE_HEADER&&(k=l.getHeaderParameters(p))}p.url=G;var H=p.checkExistenceOnly?d.a.HEAD:d.a.GET,V=c.getXHRWithCredentialsForType(p.type);a={url:G,method:H,withCredentials:V,request:p,onload:function(){a.response.status>=200&&a.response.status<=299&&(U(!0),e.success&&e.success(a.response.response,a.response.statusText,a.response.responseURL),e.complete&&e.complete(p,a.response.statusText))},onend:B,onerror:B,progress:function(t){var n=new Date;y&&(y=!1,(!t.lengthComputable||t.lengthComputable&&t.total!==t.loaded)&&(p.firstByteDate=n)),t.lengthComputable&&(p.bytesLoaded=t.loaded,p.bytesTotal=t.total),t.noTrace||(m.push({s:S,d:t.time?t.time:n.getTime()-S.getTime(),b:[t.loaded?t.loaded-b:0],t:t.throughput}),S=n,b=t.loaded),e.progress&&t&&e.progress(t)},onabort:function(){e.abort&&e.abort(p)},ontimeout:function(e){var t;if(e.lengthComputable){var n=e.loaded/e.total*100;t="Request timeout: loaded: "+e.loaded+", out of: "+e.total+" : "+n.toFixed(3)+"% Completed"}else t="Request timeout: non-computable download size";A.warn(t)},loader:x,timeout:M,headers:k};var K=(new Date).getTime();if(isNaN(p.delayLoadingTime)||K>=p.delayLoadingTime)n.push(a),x.load(a);else{var q={httpRequest:a};r.push(q),q.delayTimeout=setTimeout((function(){if(-1!==r.indexOf(q)){r.splice(r.indexOf(q),1);try{v=new Date,S=v,n.push(q.httpRequest),x.load(q.httpRequest)}catch(e){q.httpRequest.onerror()}}}),p.delayLoadingTime-K)}}return t={load:function(e){e.request?F(e,C.getRetryAttemptsForType(e.request.type)):e.error&&e.error(e.request,"error")},abort:function(){s.forEach((function(e){clearTimeout(e.timeout),e.config.request&&e.config.abort&&e.config.abort(e.config.request)})),s=[],r.forEach((function(e){return clearTimeout(e.delayTimeout)})),r=[],n.forEach((function(e){e.request.type!==d.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE&&(e.onloadend=e.onerror=e.onprogress=void 0,e.loader.abort(e))})),n=[]}},A=Object(m.a)(I).getInstance().getLogger(t),n=[],r=[],s=[],l=Object(p.a)(I).getInstance(),_=T(I).getInstance(),c=Object(v.a)(I).getInstance(),S(b={},d.a.MPD_TYPE,O.DOWNLOAD_ERROR_ID_MANIFEST_CODE),S(b,d.a.XLINK_EXPANSION_TYPE,O.DOWNLOAD_ERROR_ID_XLINK_CODE),S(b,d.a.INIT_SEGMENT_TYPE,O.DOWNLOAD_ERROR_ID_INITIALIZATION_CODE),S(b,d.a.MEDIA_SEGMENT_TYPE,O.DOWNLOAD_ERROR_ID_CONTENT_CODE),S(b,d.a.INDEX_SEGMENT_TYPE,O.DOWNLOAD_ERROR_ID_CONTENT_CODE),S(b,d.a.BITSTREAM_SWITCHING_SEGMENT_TYPE,O.DOWNLOAD_ERROR_ID_CONTENT_CODE),S(b,d.a.OTHER_TYPE,O.DOWNLOAD_ERROR_ID_CONTENT_CODE),u=b,t}A.__dashjs_factory_name="HTTPLoader";var b=r.a.getClassFactory(A);function I(){var e;function t(){e={}}function n(){t()}return n(),{getLoader:function(t){for(var n in e)if(e.hasOwnProperty(n)&&t.startsWith(n))return e[n];return b},registerLoader:function(t,n){e[t]=n},unregisterLoader:function(t){e[t]&&delete e[t]},unregisterAllLoader:t,reset:n}}I.__dashjs_factory_name="SchemeLoaderFactory";var R=r.a.getSingletonFactory(I);t.a=R},function(e,t,n){(function(e){function n(e){return Object.prototype.toString.call(e)}t.isArray=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===n(e)},t.isBoolean=function(e){return"boolean"==typeof e},t.isNull=function(e){return null===e},t.isNullOrUndefined=function(e){return null==e},t.isNumber=function(e){return"number"==typeof e},t.isString=function(e){return"string"==typeof e},t.isSymbol=function(e){return"symbol"==typeof e},t.isUndefined=function(e){return void 0===e},t.isRegExp=function(e){return"[object RegExp]"===n(e)},t.isObject=function(e){return"object"==typeof e&&null!==e},t.isDate=function(e){return"[object Date]"===n(e)},t.isError=function(e){return"[object Error]"===n(e)||e instanceof Error},t.isFunction=function(e){return"function"==typeof e},t.isPrimitive=function(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e},t.isBuffer=e.isBuffer}).call(this,n(64).Buffer)},function(e,t,n){t.generateISD=n(78).generateISD,t.fromXML=n(79).fromXML,t.renderHTML=n(95).render},function(e,t,n){"use strict";var r=n(3),i=n(14);function a(){return{customTimeRangeArray:[],length:0,add:function(e,t){var n=0;for(n=0;n<this.customTimeRangeArray.length&&e>this.customTimeRangeArray[n].start;n++);for(this.customTimeRangeArray.splice(n,0,{start:e,end:t}),n=0;n<this.customTimeRangeArray.length-1;n++)this.mergeRanges(n,n+1)&&n--;this.length=this.customTimeRangeArray.length},clear:function(){this.customTimeRangeArray=[],this.length=0},remove:function(e,t){for(var n=0;n<this.customTimeRangeArray.length;n++)if(e<=this.customTimeRangeArray[n].start&&t>=this.customTimeRangeArray[n].end)this.customTimeRangeArray.splice(n,1),n--;else{if(e>this.customTimeRangeArray[n].start&&t<this.customTimeRangeArray[n].end){this.customTimeRangeArray.splice(n+1,0,{start:t,end:this.customTimeRangeArray[n].end}),this.customTimeRangeArray[n].end=e;break}e>this.customTimeRangeArray[n].start&&e<this.customTimeRangeArray[n].end?this.customTimeRangeArray[n].end=e:t>this.customTimeRangeArray[n].start&&t<this.customTimeRangeArray[n].end&&(this.customTimeRangeArray[n].start=t)}this.length=this.customTimeRangeArray.length},mergeRanges:function(e,t){var n=this.customTimeRangeArray[e],r=this.customTimeRangeArray[t];return n.start<=r.start&&r.start<=n.end&&n.end<=r.end?(n.end=r.end,this.customTimeRangeArray.splice(t,1),!0):r.start<=n.start&&n.start<=r.end&&r.end<=n.end?(n.start=r.start,this.customTimeRangeArray.splice(t,1),!0):r.start<=n.start&&n.start<=r.end&&n.end<=r.end?(this.customTimeRangeArray.splice(e,1),!0):n.start<=r.start&&r.start<=n.end&&r.end<=n.end&&(this.customTimeRangeArray.splice(t,1),!0)},start:function(e){return Object(i.a)(e),e>=this.customTimeRangeArray.length||e<0?NaN:this.customTimeRangeArray[e].start},end:function(e){return Object(i.a)(e),e>=this.customTimeRangeArray.length||e<0?NaN:this.customTimeRangeArray[e].end}}}a.__dashjs_factory_name="CustomTimeRanges",t.a=r.a.getClassFactory(a)},function(e,t,n){"use strict";n.d(t,"b",(function(){return s}));var r=n(3),i=n(34),a=n(1),o=[{codec:"avc1",compatibleCodecs:["avc3"]},{codec:"avc3",compatibleCodecs:["avc1"]}];function s(){var e="WebKitMediaSource"in window,t="MediaSource"in window;return e||t}function u(){var e,t,n;return e={setConfig:function(e){e&&e.settings&&(t=e.settings)},supportsMediaSource:s,supportsEncryptedMedia:function(){return n},supportsCodec:function(e,n){return n!==a.a.AUDIO&&n!==a.a.VIDEO?Promise.resolve(!0):function(e,n){return t.get().streaming.capabilities.useMediaCapabilitiesApi&&navigator.mediaCapabilities&&navigator.mediaCapabilities.decodingInfo&&(e.codec&&n===a.a.AUDIO||n===a.a.VIDEO&&e.codec&&e.width&&e.height&&e.bitrate&&e.framerate)}(e,n)?function(e,t){return new Promise((function(n){if(e&&e.codec){var r={type:"media-source"};r[t]={},r[t].contentType=e.codec,r[t].width=e.width,r[t].height=e.height,r[t].bitrate=parseInt(e.bitrate),r[t].framerate=parseFloat(e.framerate),navigator.mediaCapabilities.decodingInfo(r).then((function(e){n(e.supported)})).catch((function(){n(!1)}))}else n(!1)}))}(e,n):function(e){return new Promise((function(t){if(e&&e.codec){var n=e.codec;e.width&&e.height&&(n+=';width="'+e.width+'";height="'+e.height+'"'),"MediaSource"in window&&MediaSource.isTypeSupported(n)||"WebKitMediaSource"in window&&WebKitMediaSource.isTypeSupported(n)?t(!0):t(!1)}else t(!1)}))}(e)},setEncryptedMediaSupported:function(e){n=e},supportsEssentialProperty:function(e){try{return-1!==i.a.indexOf(e.schemeIdUri)}catch(e){return!0}},codecRootCompatibleWithCodec:function(e,t){for(var n,r=e.split(".")[0],i=0===t.indexOf(r),a=0;a<o.length;a++)if(o[a].codec===r){n=o[a];break}return n?i||n.compatibleCodecs.some((function(e){return 0===t.indexOf(e)})):i}},n=!1,e}u.__dashjs_factory_name="Capabilities",t.a=r.a.getSingletonFactory(u)},function(e,t,n){!function(e){e.ns_tt="http://www.w3.org/ns/ttml",e.ns_tts="http://www.w3.org/ns/ttml#styling",e.ns_ttp="http://www.w3.org/ns/ttml#parameter",e.ns_xml="http://www.w3.org/XML/1998/namespace",e.ns_itts="http://www.w3.org/ns/ttml/profile/imsc1#styling",e.ns_ittp="http://www.w3.org/ns/ttml/profile/imsc1#parameter",e.ns_smpte="http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt",e.ns_ebutts="urn:ebu:tt:style"}(t)},function(e,t,n){"use strict";(function(t){!t.version||0===t.version.indexOf("v0.")||0===t.version.indexOf("v1.")&&0!==t.version.indexOf("v1.8.")?e.exports={nextTick:function(e,n,r,i){if("function"!=typeof e)throw new TypeError('"callback" argument must be a function');var a,o,s=arguments.length;switch(s){case 0:case 1:return t.nextTick(e);case 2:return t.nextTick((function(){e.call(null,n)}));case 3:return t.nextTick((function(){e.call(null,n,r)}));case 4:return t.nextTick((function(){e.call(null,n,r,i)}));default:for(a=new Array(s-1),o=0;o<a.length;)a[o++]=arguments[o];return t.nextTick((function(){e.apply(null,a)}))}}}:e.exports=t}).call(this,n(25))},function(e,t,n){var r=n(64),i=r.Buffer;function a(e,t){for(var n in e)t[n]=e[n]}function o(e,t,n){return i(e,t,n)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?e.exports=r:(a(r,t),t.Buffer=o),a(i,o),o.from=function(e,t,n){if("number"==typeof e)throw new TypeError("Argument must not be a number");return i(e,t,n)},o.alloc=function(e,t,n){if("number"!=typeof e)throw new TypeError("Argument must be a number");var r=i(e);return void 0!==t?"string"==typeof n?r.fill(t,n):r.fill(t):r.fill(0),r},o.allocUnsafe=function(e){if("number"!=typeof e)throw new TypeError("Argument must be a number");return i(e)},o.allocUnsafeSlow=function(e){if("number"!=typeof e)throw new TypeError("Argument must be a number");return r.SlowBuffer(e)}},function(e,t,n){"use strict";var r=n(41),i=n.n(r),a=n(1),o=n(0),s=n(9),u=n(7),l=n(2),c=n(3),f=n(6),d=n(4);function h(){var e,t,n,r,i,o,c,h,p,g,m,y,E,_,T,v,S,A,b,I,R,N,C,w=this.context,D=Object(u.a)(w).getInstance();function O(){F(),E=!1,g=0,T=0,R=!1,v=!0,S=!1,N=!1,A=NaN,c&&(D.off(l.a.DATA_UPDATE_COMPLETED,z,e),D.off(l.a.LOADING_PROGRESS,de,e),D.off(l.a.MANIFEST_UPDATED,me,e),D.off(l.a.STREAMS_COMPOSED,ye,e),D.off(d.a.PLAYBACK_ENDED,ce,e),D.off(d.a.STREAM_INITIALIZING,pe,e),D.off(d.a.REPRESENTATION_SWITCH,ge,e),D.off(d.a.BUFFER_LEVEL_STATE_CHANGED,$,e),W(),c.removeEventListener("canplay",X),c.removeEventListener("canplaythrough",Q),c.removeEventListener("play",Z),c.removeEventListener("waiting",J),c.removeEventListener("playing",ee),c.removeEventListener("pause",te),c.removeEventListener("error",fe),c.removeEventListener("seeking",ne),c.removeEventListener("seeked",re),c.removeEventListener("timeupdate",ie),c.removeEventListener("progress",ae),c.removeEventListener("ratechange",oe),c.removeEventListener("loadedmetadata",se),c.removeEventListener("loadeddata",ue),c.removeEventListener("stalled",he),c.removeEventListener("ended",le)),p=null,c=null,m=null,y=null}function M(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return parseFloat((P(e)-U()).toFixed(5))}function P(e){var t=e||m;return t.start+t.duration}function L(){m&&c&&c.getElement()?c.play():E=!0}function F(){m&&c&&c.pause()}function x(e,n,r){m&&c&&(e!==(isNaN(A)?c.getTime():A)&&((b=!0===r)||(A=e),t.info("Requesting seek to time: "+e+(b?" (internal)":"")),c.setCurrentTime(e,n)))}function U(){return m&&c?c.getTime():null}function B(){return m&&c?c.isPaused():null}function k(){return m&&c?c.isSeeking():null}function G(){return m&&c?c.isStalled():null}function j(){return m&&c?c.getPlaybackRate():null}function Y(){return m&&c?c.getEnded():null}function H(){return y}function V(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(!B()&&y&&0!==c.getReadyState()&&!k()&&!R){e||(e=n.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO);var r=U(),i=K(r,e),o=!isNaN(i)&&i!==r;o&&!k()&&(G()||I||1===c.getReadyState())&&(t.debug("UpdateCurrentTime: Seek to actual time: ".concat(i," from currentTime: ").concat(r)),x(i,!1,!1))}}function K(e,t){var n=i.getCurrentDVRInfo(t),r=n?n.range:null;return r?e>r.end?Math.max(r.end-g,r.start):e>0&&e+.25<r.start&&Math.abs(e-r.start)<31536e4?S?Math.max(r.end-g,r.start):r.start:e:NaN}function q(){null===p&&(p=setInterval((function(){var e;D.trigger(l.a.WALLCLOCK_TIME_UPDATED,{isDynamic:y,time:new Date}),H()&&(n.addDVRMetric(),B()?(e=Date.now(),(!_||e>_+500)&&(_=e,ie())):V())}),C.get().streaming.wallclockTimeUpdateInterval))}function W(){clearInterval(p),p=null}function z(e){var t=o.convertRepresentationToRepresentationInfo(e.currentRepresentation),n=t?t.mediaInfo.streamInfo:null;null!==n&&m.id===n.id&&(m=n)}function X(){D.trigger(l.a.CAN_PLAY)}function Q(){D.trigger(l.a.CAN_PLAY_THROUGH)}function $(e){e.streamId===n.getActiveStreamInfo().id&&(I=e.state===s.a.BUFFER_EMPTY,C.get().streaming.buffer.setStallState&&c.setStallState(e.mediaType,e.state===s.a.BUFFER_EMPTY))}function Z(){t.info("Native video element event: play"),V(),q(),D.trigger(l.a.PLAYBACK_STARTED,{startTime:U()})}function J(){t.info("Native video element event: waiting"),D.trigger(l.a.PLAYBACK_WAITING,{playingTime:U()})}function ee(){t.info("Native video element event: playing"),b=!1,D.trigger(l.a.PLAYBACK_PLAYING,{playingTime:U()})}function te(){t.info("Native video element event: pause"),D.trigger(l.a.PLAYBACK_PAUSED,{ended:Y()})}function ne(){if(!b){var e=U();isNaN(A)||A===e||(e=A),A=NaN,t.info("Seeking to: "+e),q(),D.trigger(l.a.PLAYBACK_SEEKING,{seekTime:e,streamId:m.id})}}function re(){t.info("Native video element event: seeked"),b=!1,D.trigger(l.a.PLAYBACK_SEEKED)}function ie(){m&&D.trigger(l.a.PLAYBACK_TIME_UPDATED,{timeToEnd:M(),time:U(),streamId:m.id})}function ae(){D.trigger(l.a.PLAYBACK_PROGRESS,{streamId:m.id})}function oe(){var e=j();t.info("Native video element event: ratechange: ",e),D.trigger(l.a.PLAYBACK_RATE_CHANGED,{playbackRate:e})}function se(){t.info("Native video element event: loadedmetadata"),D.trigger(l.a.PLAYBACK_METADATA_LOADED),q()}function ue(){t.info("Native video element event: loadeddata"),D.trigger(l.a.PLAYBACK_LOADED_DATA)}function le(){t.info("Native video element event: ended"),F(),W();var e=n?n.getActiveStreamInfo():null;e&&D.trigger(l.a.PLAYBACK_ENDED,{isLast:e.isLast})}function ce(e){if(p&&e.isLast){t.info("onPlaybackEnded -- PLAYBACK_ENDED but native video element didn't fire ended");var n=e.seekTime?e.seekTime:P();c.setCurrentTime(n),F(),W()}}function fe(e){var t=e.target||e.srcElement;D.trigger(l.a.PLAYBACK_ERROR,{error:t.error})}function de(e){if(!1===e.stream&&S&&!isNaN(e.request.duration)){var n=1.2*e.request.duration;n>g&&(t.warn("Browser does not support fetch API with StreamReader. Increasing live delay to be 20% higher than segment duration:",n.toFixed(2)),g=n)}}function he(e){D.trigger(l.a.PLAYBACK_STALLED,{e:e})}function pe(e){var n;(n=e.mediaInfo)&&n.supplementalProperties&&"true"===n.supplementalProperties[a.a.SUPPLEMENTAL_PROPERTY_DVB_LL_SCHEME]&&(t.debug("Low Latency critical SupplementalProperty set: Enabling low Latency"),S=!0)}function ge(e){var t=n.getActiveStreamInfo();e&&t&&e.currentRepresentation&&e.streamId&&e.streamId===t.id&&e.mediaType&&(e.mediaType===a.a.VIDEO||e.mediaType===a.a.AUDIO)&&(v=e.currentRepresentation.availabilityTimeComplete,(S=!v)&&!N&&(N=!0))}function me(){R=!0}function ye(){R=!1}return e={initialize:function(t,n){m=t,!0!==n&&(c.addEventListener("canplay",X),c.addEventListener("canplaythrough",Q),c.addEventListener("play",Z),c.addEventListener("waiting",J),c.addEventListener("playing",ee),c.addEventListener("pause",te),c.addEventListener("error",fe),c.addEventListener("seeking",ne),c.addEventListener("seeked",re),c.addEventListener("timeupdate",ie),c.addEventListener("progress",ae),c.addEventListener("ratechange",oe),c.addEventListener("loadedmetadata",se),c.addEventListener("loadeddata",ue),c.addEventListener("stalled",he),c.addEventListener("ended",le),y=m.manifestInfo.isDynamic,I=!1,b=!1,D.on(l.a.DATA_UPDATE_COMPLETED,z,e),D.on(l.a.LOADING_PROGRESS,de,e),D.on(l.a.MANIFEST_UPDATED,me,e),D.on(l.a.STREAMS_COMPOSED,ye,e),D.on(d.a.PLAYBACK_ENDED,ce,e,{priority:u.a.EVENT_PRIORITY_HIGH}),D.on(d.a.STREAM_INITIALIZING,pe,e),D.on(d.a.REPRESENTATION_SWITCH,ge,e),D.on(d.a.BUFFER_LEVEL_STATE_CHANGED,$,e),E&&(E=!1,L()))},setConfig:function(e){e&&(e.streamController&&(n=e.streamController),e.serviceDescriptionController&&(r=e.serviceDescriptionController),e.dashMetrics&&(i=e.dashMetrics),e.adapter&&(o=e.adapter),e.videoModel&&(c=e.videoModel),e.timelineConverter&&(h=e.timelineConverter),e.settings&&(C=e.settings))},getTimeToStreamEnd:M,getBufferLevel:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=null;return n.getActiveStreamProcessors().forEach((function(n){if(!e||0===e.length||-1===e.indexOf(n.getType())){var r=n.getBufferLevel();t=null===t?r:Math.min(t,r)}})),t},getPlaybackStalled:function(){return I},getTime:U,getLowLatencyModeEnabled:function(){return S},getInitialCatchupModeActivated:function(){return N},getIsManifestUpdateInProgress:function(){return R},getPlaybackRate:j,getPlayedRanges:function(){return m&&c?c.getPlayedRanges():null},getEnded:Y,getIsDynamic:H,getStreamController:function(){return n},computeAndSetLiveDelay:function(e,t){var n,i,a,s=!isNaN(e)&&isFinite(e)?e:NaN,u=o.getSuggestedPresentationDelay(),l=r.getServiceDescriptionSettings();return n=isNaN(C.get().streaming.delay.liveDelay)?null===C.get().streaming.delay.liveDelayFragmentCount||isNaN(C.get().streaming.delay.liveDelayFragmentCount)||isNaN(s)?l&&!isNaN(l.liveDelay)&&l.liveDelay>0?l.liveDelay:!0===C.get().streaming.delay.useSuggestedPresentationDelay&&null!==u&&!isNaN(u)&&u>0?u:isNaN(s)?t&&!isNaN(t.minBufferTime)?4*t.minBufferTime:4*m.manifestInfo.minBufferTime:4*s:s*C.get().streaming.delay.liveDelayFragmentCount:C.get().streaming.delay.liveDelay,null!==(a=o.getAvailabilityStartTime())&&(T=a),i=t&&t.dvrWindowSize>0?Math.min(n,t.dvrWindowSize):n,g=i,i},getLiveDelay:function(){return g},getCurrentLiveLatency:function(){if(!y||isNaN(T))return NaN;var e=U();if(isNaN(e)||0===e)return 0;var t=(new Date).getTime()+1e3*h.getClientTimeOffset();return Math.max(((t-T-1e3*e)/1e3).toFixed(3),0)},play:L,isPaused:B,isStalled:G,pause:F,isSeeking:k,getStreamEndTime:P,seek:x,reset:O,updateCurrentTime:V,getAvailabilityStartTime:function(){return T}},t=Object(f.a)(w).getInstance().getLogger(e),O(),e}h.__dashjs_factory_name="PlaybackController";var p=c.a.getSingletonFactory(h),g=n(20),m=n(10),y=n(11),E=n(16),_=n(5);function T(e){var t,n,r,i,o,s,u=this.context,c=Object(E.a)(u).getInstance(),d=e.textController,h=e.eventBus,p=[],g=[],T=!1,v=e.mediaSource,S=null;function A(e){return new Promise((function(t){P((function(){i.changeType&&i.changeType(e),t()}))}))}function b(e){return i=d.getTextSourceBuffer(e),Promise.resolve()}function I(){if("function"==typeof i.addEventListener)try{i.addEventListener("updateend",O,!1),i.addEventListener("error",M,!1),i.addEventListener("abort",M,!1)}catch(e){s=setInterval(O,50)}else s=setInterval(O,50)}function R(e){return new Promise((function(t){i&&c.get().streaming.buffer.useAppendWindow?P((function(){try{if(!i)return void t();var n=v.duration,a=0;e&&!isNaN(e.start)&&!isNaN(e.duration)&&isFinite(e.duration)&&(n=e.start+e.duration),e&&!isNaN(e.start)&&(a=e.start),i.appendWindowEnd===n&&i.appendWindowStart===a||(i.appendWindowStart=0,i.appendWindowEnd=n+.01,i.appendWindowStart=Math.max(a-.1,0),r.debug("Updated append window for ".concat(o.type,". Set start to ").concat(i.appendWindowStart," and end to ").concat(i.appendWindowEnd))),t()}catch(e){r.warn("Failed to set append window"),t()}})):t()}))}function N(e){return new Promise((function(t){i?P((function(){try{i.timestampOffset===e||isNaN(e)||(i.timestampOffset=e,r.debug("Set MSE timestamp offset to ".concat(e))),t()}catch(e){t()}})):t()}))}function C(){return new Promise((function(e){P((function(){var t=i.appendWindowStart,n=i.appendWindowEnd;i&&(i.abort(),i.appendWindowStart=t,i.appendWindowEnd=n),e()}))}))}function w(){if(!T&&g.length>0){T=!0;var e=g[0];g.splice(0,1);var t=function(){T=!1,g.length>0&&w.call(this),e&&e.data&&e.data.segmentType&&e.data.segmentType!==_.a.INIT_SEGMENT_TYPE&&delete e.data.bytes,e.promise.resolve({chunk:e.data})};try{S=e.request,0===e.data.bytes.byteLength?t.call(this):(i.appendBuffer?i.appendBuffer(e.data.bytes):i.append(e.data.bytes,e.data),P(t.bind(this)))}catch(t){r.fatal('SourceBuffer append failed "'+t+'"'),g.length>0?w():T=!1,delete e.data.bytes,e.promise.reject({chunk:e.data,error:new m.a(t.code,t.message)})}}}function D(){p.length>0&&(i.updating||(p.shift()(),D()))}function O(){i.updating||D()}function M(e){var t,r,i=e.target||{};t=l.a.SOURCE_BUFFER_ERROR,r={error:i,lastRequestAppended:S}||{},h.trigger(t,r,{streamId:o.streamInfo.id,mediaType:n})}function P(e){p.push(e),i.updating||D()}return t={getType:function(){return n},getAllBufferRanges:function(){try{return i.buffered}catch(e){return r.error("getAllBufferRanges exception: "+e.message),null}},getBuffer:function(){return i},append:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return new Promise((function(r,i){e?(g.push({data:e,promise:{resolve:r,reject:i},request:n}),P(w.bind(t))):i({chunk:e,error:new m.a(y.a.APPEND_ERROR_CODE,y.a.APPEND_ERROR_MESSAGE)})}))},remove:function(e){return new Promise((function(t,n){var r=e.start,a=e.end;r>=0&&a>r?P((function(){try{i.remove(r,a),P((function(){t({from:r,to:a,unintended:!1}),e.resolve&&e.resolve()}))}catch(t){n({from:r,to:a,unintended:!1,error:new m.a(y.a.REMOVE_ERROR_CODE,y.a.REMOVE_ERROR_MESSAGE)}),e.reject&&e.reject(t)}})):t()}))},abort:function(){return new Promise((function(e){try{g=[],"open"===v.readyState?P((function(){try{i&&i.abort(),e()}catch(t){e()}})):i&&i.setTextTrack&&"ended"===v.readyState?(i.abort(),e()):e()}catch(t){e()}}))},reset:function(){if(i){try{p=[],function(){try{"function"==typeof i.removeEventListener&&(i.removeEventListener("updateend",O,!1),i.removeEventListener("error",M,!1),i.removeEventListener("abort",M,!1)),clearInterval(s)}catch(e){r.error(e)}}(),T=!1,g=[],i.getClassName&&"TextSourceBuffer"===i.getClassName()||(r.debug("Removing sourcebuffer from media source"),v.removeSourceBuffer(i))}catch(e){}i=null}S=null},updateTimestampOffset:N,initializeForStreamSwitch:function(e,t,r){n=(o=e).type;var a=o.codec;!function(e){i=e.getBuffer()}(r),I();var s=[];return s.push(C),s.push(R(o.streamInfo)),s.push(A(a)),t&&void 0!==t.MSETimeOffset&&s.push(N(t.MSETimeOffset)),Promise.all(s)},initializeForFirstUse:function(e,t,r){n=(o=t).type;var s=o.codec;try{if(s.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i))return b(e);i=v.addSourceBuffer(s),I();var u=[];return u.push(R(o.streamInfo)),r&&void 0!==r.MSETimeOffset&&u.push(N(r.MSETimeOffset)),Promise.all(u)}catch(t){return o.type==a.a.TEXT&&!o.isFragmented||-1!==s.indexOf('codecs="stpp')||-1!==s.indexOf('codecs="vtt')?b(e):Promise.reject(t)}},updateAppendWindow:R,changeType:A},r=Object(f.a)(u).getInstance().getLogger(t),t}T.__dashjs_factory_name="SourceBufferSink";var v=c.a.getClassFactory(T);function S(){var e={};return{save:function(t){var n=t.streamId,r=t.representationId;e[n]=e[n]||{},e[n][r]=t},extract:function(t,n){return e&&e[t]&&e[t][n]?e[t][n]:null},reset:function(){e={}}}}S.__dashjs_factory_name="InitCache";var A=c.a.getSingletonFactory(S);function b(e){e=e||{};var t,n,r,i,o,c,h,p,E,T,S,b,I,R,N,C,w,D,O=this.context,M=Object(u.a)(O).getInstance(),P=e.errHandler,L=e.fragmentModel,F=e.representationController,x=e.adapter,U=e.textController,B=e.abrController,k=e.playbackController,G=e.streamInfo,j=e.type,Y=e.settings;function H(e){c=e}function V(e){return x.convertRepresentationToRepresentationInfo(F.getRepresentationForQuality(e))}function K(e,t,n){var r=V(n);return t&&t[j]&&(j===a.a.VIDEO||j===a.a.AUDIO)?E.initializeForStreamSwitch(e,r,t[j]):E.initializeForFirstUse(G,e,r)}function q(e){Y.get().streaming.cacheInitSegments&&(n.info("Init fragment finished loading saving to",j+"'s init cache"),N.save(e.chunk)),n.debug("Append Init fragment",j," with representationId:",e.chunk.representationId," and quality:",e.chunk.quality,", data size:",e.chunk.bytes.byteLength),z(e.chunk)}function W(e){z(e.chunk,e.request)}function z(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;E.append(e,t).then((function(e){Q(e)})).catch((function(e){Q(e)})),e.mediaInfo.type===a.a.VIDEO&&Ee(l.a.VIDEO_CHUNK_RECEIVED,{chunk:e})}function X(e){if(e&&e.length>0)for(var t=0,r=e.length;t<r;t++)n.debug("Buffered range: "+e.start(t)+" - "+e.end(t)+", currentTime = ",k.getTime())}function Q(e){if(e.error)return 22===e.error.code&&function(){if(R=!0,o=.8*me(),n.warn("Quota exceeded, Critical Buffer: "+o),o>0){var e=Math.max(.2*o,1),t=o-e,r=Math.min(Y.get().streaming.buffer.bufferTimeAtTopQuality,.9*t),i=Math.min(Y.get().streaming.buffer.bufferTimeAtTopQualityLongForm,.9*t),a={streaming:{buffer:{bufferToKeep:parseFloat(e.toFixed(5)),bufferTimeAtTopQuality:parseFloat(r.toFixed(5)),bufferTimeAtTopQualityLongForm:parseFloat(i.toFixed(5))}}};Y.update(a)}}(),void(22!==e.error.code&&ye()||(n.warn("Clearing playback buffer to overcome quota exceed situation"),Ee(l.a.QUOTA_EXCEEDED,{criticalBufferLevel:o,quotaExceededTime:e.chunk.start}),ue(se())));if(E&&(re(),R=!1,(S=e.chunk)&&S.endFragment)){S&&!isNaN(S.index)&&(h=Math.max(S.index,h),ie());var t=E.getAllBufferRanges();S.segmentType===_.a.MEDIA_SEGMENT_TYPE&&(X(t),J(),function(){if(isNaN(D))return;if(j!==a.a.AUDIO&&j!==a.a.VIDEO)return void(D=NaN);var e=k.getTime(),t=ne(e,0),n=ne(D,0);if(t&&n&&t.start===n.start)return void(D=NaN);var r=F.getCurrentRepresentation().segmentDuration,i=ne(D,r);if(!i)return;Y.get().streaming.buffer.enableSeekDecorrelationFix&&Math.abs(e-D)>r?D<=i.end&&k.seek(Math.max(D,i.start),!1,!0):e<i.start&&k.seek(i.start,!1,!0)}()),S&&Ee(l.a.BYTES_APPENDED_END_FRAGMENT,{quality:S.quality,startTime:S.start,index:S.index,bufferedRanges:t,segmentType:S.segmentType,mediaType:j})}}function $(){return new Promise((function(e,t){var n=Z();if(!n||0===n.length)return J(),void e();ue(n).then((function(){e()})).catch((function(e){t(e)}))}))}function Z(e){var t=[],n=E.getAllBufferRanges();if(!n||0===n.length)return t;if(!e&&0!==e||isNaN(e))t.push({start:n.start(0),end:n.end(n.length-1)+.5});else{var r=function(e,t){var n=Y.get().streaming.buffer.bufferToKeep,r=t.start(0);if(e-r>n){var i=Math.max(0,e-n),a=L.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,time:e,threshold:.01})[0];if(a&&(i=Math.min(a.startTime,i)),i>0)return{start:r,end:i}}return null}(e,n),i=function(e,t){var n=t.end(t.length-1)+.5,r=G.manifestInfo.duration>=Y.get().streaming.buffer.longFormContentDurationThreshold?Y.get().streaming.buffer.bufferTimeAtTopQualityLongForm:Y.get().streaming.buffer.bufferTimeAtTopQuality;if(n-e>r){var i=e+r,a=L.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,time:e,threshold:.01})[0];if(a&&(i=Math.max(a.startTime+a.duration,i)),i<n)return{start:i,end:n}}return null}(e,n);r&&t.push(r),i&&t.push(i)}return t}function J(){(!w||j===a.a.TEXT&&U.isTextEnabled())&&re()}function ee(){ae()}function te(){ae(),D=NaN}function ne(e,t){var n,r,i=E.getAllBufferRanges(),a=0,o=0,s=null,u=null,l=0,c=isNaN(t)?.15:t;if(null!=i){for(r=0,n=i.length;r<n;r++)if(a=i.start(r),o=i.end(r),null===s)l=Math.abs(a-e),(e>=a&&e<o||l<=c)&&(s=a,u=o);else{if(!((l=a-u)<=c))break;u=o}if(null!==s)return{start:s,end:u}}return null}function re(){if(k){var e=Y.get().streaming.gaps.jumpGaps&&!isNaN(Y.get().streaming.gaps.smallGapLimit)?Y.get().streaming.gaps.smallGapLimit:NaN;i=Math.max(function(e,t){var n;return Y.get().streaming.gaps.jumpGaps&&(t=Y.get().streaming.gaps.smallGapLimit),null===(n=ne(e,t))?0:n.end-e}(k.getTime()||0,e),0),Ee(l.a.BUFFER_LEVEL_UPDATED,{mediaType:j,bufferLevel:i}),ae()}}function ie(){var e=h>=p-1,t=k.getTimeToStreamEnd(G)-i<=0;!e&&!t||r||(ge(!0),n.debug("checkIfBufferingCompleted trigger BUFFERING_COMPLETED for stream id ".concat(G.id," and type ").concat(j)))}function ae(){j!==a.a.AUDIO&&j!==a.a.VIDEO||((!k.getLowLatencyModeEnabled()&&i<Y.get().streaming.buffer.stallThreshold||0===i)&&!r?oe(s.a.BUFFER_EMPTY):(r||i>=Y.get().streaming.buffer.stallThreshold||k.getLowLatencyModeEnabled()&&i>0)&&oe(s.a.BUFFER_LOADED))}function oe(e){T===e||e===s.a.BUFFER_EMPTY&&0===k.getTime()||j===a.a.TEXT&&!U.isTextEnabled()||(T=e,Ee(l.a.BUFFER_LEVEL_STATE_CHANGED,{state:e}),Ee(e===s.a.BUFFER_LOADED?l.a.BUFFER_LOADED:l.a.BUFFER_EMPTY),n.debug(e===s.a.BUFFER_LOADED?"Got enough buffer to start":"Waiting for more buffer before starting playback"))}function se(){var e=[],t=E.getAllBufferRanges();if(!t||0===t.length)return e;var n=k.getTime(),r=Math.max(0,n-Y.get().streaming.buffer.bufferToKeep),i=L.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,time:n,threshold:.01})[0];if(i)r=Math.min(i.startTime,r);else if(0===n&&k.getIsDynamic())return[];if(t.start(0)<=r){for(var a={start:0,end:r},o=0;o<t.length&&t.end(o)<=r;o++)a.end=t.end(o);a.start<a.end&&e.push(a)}return e}function ue(e){return new Promise((function(t,n){if(e&&E&&0!==e.length){var r=[];e.forEach((function(e){r.push(function(e){return new Promise((function(t,n){e.resolve=t,e.reject=n,C.push(e)}))}(e))})),I||le(),Promise.all(r).then((function(){t()})).catch((function(e){n(e)}))}else t()}))}function le(){try{if(0===C.length||!E)return n.debug("Nothing to prune, halt pruning"),C=[],void(I=!1);var e=E.getBuffer();if(!e||!e.buffered||0===e.buffered.length)return n.debug("SourceBuffer is empty (or does not exist), halt pruning"),C=[],void(I=!1);var t=C.shift();n.debug("".concat(j,": Removing buffer from: ").concat(t.start," to ").concat(t.end)),I=!0,k.getTime()<t.end&&ge(!1),E.remove(t).then((function(e){ce(e)})).catch((function(e){ce(e)}))}catch(e){I=!1}}function ce(e){n.debug("onRemoved buffer from:",e.from,"to",e.to),X(E.getAllBufferRanges()),0===C.length&&(I=!1,re()),e.unintended&&(n.warn("Detected unintended removal from:",e.from,"to",e.to,"setting streamprocessor time to",e.from),Ee(l.a.SEEK_TARGET,{time:e.from})),I?le():(w?w=!1:re(),Ee(l.a.BUFFER_CLEARED,{from:e.from,to:e.to,unintended:e.unintended,hasEnoughSpaceToAppend:ye(),quotaExceeded:R}))}function fe(e){return new Promise((function(t){e&&void 0!==e.MSETimeOffset&&E&&E.updateTimestampOffset?E.updateTimestampOffset(e.MSETimeOffset).then((function(){t()})).catch((function(){t()})):t()}))}function de(){return E&&!r?E.updateAppendWindow(G):Promise.resolve()}function he(){++b*(Y.get().streaming.wallclockTimeUpdateInterval/1e3)>=Y.get().streaming.buffer.bufferPruningInterval&&(b=0,E&&j!==a.a.TEXT&&(r||ue(se())))}function pe(){ae()}function ge(e){r!==e&&((r=e)?Ee(l.a.BUFFERING_COMPLETED):p=Number.POSITIVE_INFINITY)}function me(){try{var e,t,n=E.getAllBufferRanges(),r=0;if(!n)return r;for(t=0,e=n.length;t<e;t++)r+=n.end(t)-n.start(t);return r}catch(e){return 0}}function ye(){var e=me();return isNaN(e)||e<o}function Ee(e,t){var n=t||{};M.trigger(e,n,{streamId:G.id,mediaType:j})}function _e(e,t){if(o=Number.POSITIVE_INFINITY,T=void 0,p=Number.POSITIVE_INFINITY,h=0,S=null,r=!1,I=!1,R=!1,i=0,b=0,C=[],D=NaN,E){var n=E;E=null,e||t||n.abort().then((function(){n.reset(t),n=null}))}w=!1}return t={initialize:function(e){H(e),M.on(l.a.INIT_FRAGMENT_LOADED,q,t),M.on(l.a.MEDIA_FRAGMENT_LOADED,W,t),M.on(l.a.WALLCLOCK_TIME_UPDATED,he,t),M.on(d.a.PLAYBACK_PLAYING,te,t),M.on(d.a.PLAYBACK_PROGRESS,J,t),M.on(d.a.PLAYBACK_TIME_UPDATED,J,t),M.on(d.a.PLAYBACK_RATE_CHANGED,pe,t),M.on(d.a.PLAYBACK_STALLED,ee,t)},getStreamId:function(){return G.id},getType:function(){return j},getBufferControllerType:function(){return"BufferController"},createBufferSink:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];return new Promise((function(r,i){if(N&&e&&c){var a=B.getQualityFor(j,G.id);E=v(O).create({mediaSource:c,textController:U,eventBus:M}),K(e,t,a).then((function(){return fe(V(a))})).then((function(){r(E)})).catch((function(e){n.fatal("Caught error on create SourceBuffer: "+e),P.error(new m.a(y.a.MEDIASOURCE_TYPE_UNSUPPORTED_CODE,y.a.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE+j)),i(e)}))}else r(null)}))},getBuffer:function(){return E},getBufferLevel:function(){return i},getRangeAt:ne,setMediaSource:H,getMediaSource:function(){return c},appendInitSegmentFromCache:function(e){var t=N.extract(G.id,e);return!!t&&(n.info("Append Init fragment",j," with representationId:",t.representationId," and quality:",t.quality,", data size:",t.bytes.byteLength),z(t),!0)},getIsBufferingCompleted:function(){return r},setIsBufferingCompleted:ge,getIsPruningInProgress:function(){return I},reset:function(e,t){M.off(l.a.INIT_FRAGMENT_LOADED,q,this),M.off(l.a.MEDIA_FRAGMENT_LOADED,W,this),M.off(l.a.WALLCLOCK_TIME_UPDATED,he,this),M.off(d.a.PLAYBACK_PLAYING,te,this),M.off(d.a.PLAYBACK_PROGRESS,J,this),M.off(d.a.PLAYBACK_TIME_UPDATED,J,this),M.off(d.a.PLAYBACK_RATE_CHANGED,pe,this),M.off(d.a.PLAYBACK_STALLED,ee,this),_e(e,t)},prepareForPlaybackSeek:function(){return r&&ge(!1),E.abort()},prepareForReplacementTrackSwitch:function(e){return new Promise((function(t,n){E.abort().then((function(){return de()})).then((function(){return E.changeType(e)})).then((function(){return $()})).then((function(){ge(!1),t()})).catch((function(e){n(e)}))}))},prepareForNonReplacementTrackSwitch:function(e){return new Promise((function(t,n){de().then((function(){return E.changeType(e)})).then((function(){t()})).catch((function(e){n(e)}))}))},prepareForReplacementQualitySwitch:function(){return new Promise((function(e,t){E.abort().then((function(){return de()})).then((function(){return $()})).then((function(){ge(!1),e()})).catch((function(e){t(e)}))}))},updateAppendWindow:de,getAllRangesWithSafetyFactor:Z,getContinuousBufferTimeForTargetTime:function(e){try{var t=e,n=E.getAllBufferRanges();if(!n||0===n.length)return NaN;for(var r=0;t===e&&r<n.length;){var i=n.start(r),a=n.end(r);t>=i&&t<=a&&(t=a),r+=1}return t===e?NaN:t}catch(e){}},clearBuffers:ue,pruneAllSafely:$,updateBufferTimestampOffset:fe,setSeekTarget:function(e){D=e},segmentRequestingCompleted:function(e){isNaN(e)||(p=e,ie())}},n=Object(f.a)(O).getInstance().getLogger(t),N=A(O).getInstance(),_e(),t}b.__dashjs_factory_name="BufferController";var I=c.a.getClassFactory(b);function R(e){e=e||{};var t,n,r,i,a,o,s=this.context,c=Object(u.a)(s).getInstance(),f=e.textController,d=e.errHandler,h=e.streamInfo,p=e.type;function g(e){i=e}function E(e){var t,r,i;n!==e&&((n=e)&&(t=l.a.BUFFERING_COMPLETED,i=r||{},c.trigger(t,i,{streamId:h.id,mediaType:p})))}function _(e){e.chunk.bytes&&!n&&(o.save(e.chunk),a.append(e.chunk),E(!0))}return t={initialize:function(e){g(e)},getStreamId:function(){return h.id},getType:function(){return p},getBufferControllerType:function(){return"NotFragmentedTextBufferController"},createBufferSink:function(e){return new Promise((function(t,n){try{(a=v(s).create({mediaSource:i,textController:f,eventBus:c})).initializeForFirstUse(h,e),r||(a.getBuffer()&&"function"==typeof a.getBuffer().initialize&&a.getBuffer().initialize(),r=!0),t(a)}catch(e){d.error(new m.a(y.a.MEDIASOURCE_TYPE_UNSUPPORTED_CODE,y.a.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE+p)),n(e)}}))},getBuffer:function(){return a},getBufferLevel:function(){return 0},getRangeAt:function(){return null},getAllRangesWithSafetyFactor:function(){return[]},getContinuousBufferTimeForTargetTime:function(){return Number.POSITIVE_INFINITY},setMediaSource:g,getMediaSource:function(){return i},appendInitSegmentFromCache:function(e){return null!==o.extract(h.id,e)},getIsBufferingCompleted:function(){return n},setIsBufferingCompleted:E,getIsPruningInProgress:function(){return!1},reset:function(e){c.off(l.a.INIT_FRAGMENT_LOADED,_,t),!e&&a&&(a.abort(),a.reset(),a=null)},clearBuffers:function(){return Promise.resolve()},prepareForPlaybackSeek:function(){return Promise.resolve()},prepareForReplacementTrackSwitch:function(){return n=!1,Promise.resolve()},setSeekTarget:function(){},updateAppendWindow:function(){return Promise.resolve()},pruneAllSafely:function(){return Promise.resolve()},updateBufferTimestampOffset:function(){return Promise.resolve()},segmentRequestingCompleted:function(){}},r=!1,i=null,n=!1,o=A(s).getInstance(),c.on(l.a.INIT_FRAGMENT_LOADED,_,t),t}R.__dashjs_factory_name="NotFragmentedTextBufferController";var N=c.a.getClassFactory(R);function C(e){e=e||{};var t,n,r,i,o,c,h,p,m,y,E,_,T,v=this.context,S=Object(u.a)(v).getInstance(),A=e.dashMetrics,b=e.mediaPlayerModel,I=e.fragmentModel,R=e.abrController,N=e.playbackController,C=e.textController,w=e.type,D=e.bufferController,O=e.settings;function M(e){if(!D.getIsBufferingCompleted()){P();var t=isNaN(e)?0:e;c=setTimeout(L,t)}}function P(){c&&(clearTimeout(c),c=null)}function L(){try{if(function(){try{return w===a.a.TEXT&&!C.isTextEnabled()||N.isPaused()&&(!N.getStreamController().getInitialPlayback()||!N.getStreamController().getAutoPlay())&&!O.get().streaming.scheduling.scheduleWhilePaused}catch(e){return!1}}())return void P();if(function(){try{return i&&(isNaN(y)||E||(e=n.id,t=R.getMaxAllowedIndexFor(w,e),!(!isNaN(m)&&m==t||(r.info("Top quality "+w+" index has changed from "+m+" to "+t),m=t,0)))||function(){if(!w||!i)return!0;return A.getCurrentBufferLevel(w)<F()}())}catch(e){return!1}var e,t}()){var e=!1;T&&(e=R.checkPlaybackQuality(w,n.id)),e||(_||i.quality!==y||E?(E?(r.debug("Switch track for "+w+", representation id = "+i.id),E=!1):r.debug("Quality has changed, get init request for representationid = "+i.id),S.trigger(l.a.INIT_FRAGMENT_NEEDED,{representationId:i.id,sender:t},{streamId:n.id,mediaType:w}),T=!1,_=!1):(r.debug("Media segment needed for ".concat(w," and stream id ").concat(n.id)),S.trigger(l.a.MEDIA_FRAGMENT_NEEDED,{},{streamId:n.id,mediaType:w}),T=!0))}else M(N.getLowLatencyModeEnabled()?O.get().streaming.scheduling.lowLatencyTimeout:O.get().streaming.scheduling.defaultTimeout)}catch(e){M(N.getLowLatencyModeEnabled()?O.get().streaming.scheduling.lowLatencyTimeout:O.get().streaming.scheduling.defaultTimeout)}}function F(){var e=NaN;return w&&i?e=w===a.a.TEXT?function(){try{if(C.isTextEnabled()){if(isNaN(i.fragmentDuration)){var e=A.getCurrentSchedulingInfo(s.a.SCHEDULING_INFO);return e?e.duration:0}return i.fragmentDuration}return 0}catch(e){return 0}}():w===a.a.AUDIO&&h?function(){try{var e=A.getCurrentBufferLevel(a.a.VIDEO);return isNaN(i.fragmentDuration)?e+1:Math.max(e+1,i.fragmentDuration)}catch(e){return 0}}():function(){try{var e=i.mediaInfo.streamInfo;return R.isPlayingAtTopQuality(e)?e.manifestInfo.duration>=O.get().streaming.buffer.longFormContentDurationThreshold?O.get().streaming.buffer.bufferTimeAtTopQualityLongForm:O.get().streaming.buffer.bufferTimeAtTopQuality:b.getStableBufferTime()}catch(e){return b.getStableBufferTime()}}():e}function x(){U(!0)}function U(e){if(N&&I){var t=I.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,time:N.getTime(),threshold:0})[0];t&&N.getTime()>=t.startTime&&((!p.mediaInfo||t.mediaInfo.type===p.mediaInfo.type&&t.mediaInfo.id!==p.mediaInfo.id)&&e&&S.trigger(l.a.TRACK_CHANGE_RENDERED,{mediaType:w,oldMediaInfo:p.mediaInfo,newMediaInfo:t.mediaInfo,streamId:n.id}),t.quality===p.quality&&t.adaptationIndex===p.adaptationIndex||!e||(r.debug("Quality change rendered for streamId ".concat(n.id," and type ").concat(w)),S.trigger(l.a.QUALITY_CHANGE_RENDERED,{mediaType:w,oldQuality:p.quality,newQuality:t.quality,streamId:n.id})),p={mediaInfo:t.mediaInfo,quality:t.quality,adaptationIndex:t.adaptationIndex})}}function B(e){r.debug("Appended bytes for ".concat(e.mediaType," and stream id ").concat(n.id)),(isNaN(e.index)||isNaN(y))&&(y=e.quality,r.info("["+w+"] lastInitializedRepresentationInfo changed to "+e.quality)),M(0)}function k(){I.abortRequests(),P()}function G(){O.get().streaming.scheduling.scheduleWhilePaused||M()}function j(e){A.updatePlayListTraceMetrics({playbackspeed:e.playbackRate.toString()})}function Y(){T=!0,o=0,y=NaN,p={mediaInfo:void 0,quality:NaN,adaptationIndex:NaN},m=NaN,E=!1,_=!1}return t={initialize:function(e){h=e,S.on(l.a.BYTES_APPENDED_END_FRAGMENT,B,t),S.on(l.a.URL_RESOLUTION_FAILED,k,t),S.on(d.a.PLAYBACK_STARTED,G,t),S.on(d.a.PLAYBACK_RATE_CHANGED,j,t),S.on(d.a.PLAYBACK_TIME_UPDATED,x,t)},getType:function(){return w},getStreamId:function(){return n.id},setCurrentRepresentation:function(e){i=e},setTimeToLoadDelay:function(e){o=e},getTimeToLoadDelay:function(){return o},setSwitchTrack:function(e){E=e},getSwitchStrack:function(){return E},startScheduleTimer:M,clearScheduleTimer:P,reset:function(){S.off(l.a.BYTES_APPENDED_END_FRAGMENT,B,t),S.off(l.a.URL_RESOLUTION_FAILED,k,t),S.off(d.a.PLAYBACK_STARTED,G,t),S.off(d.a.PLAYBACK_RATE_CHANGED,j,t),S.off(d.a.PLAYBACK_TIME_UPDATED,x,t),P(),U(!1),Y(),n=null},getBufferTarget:F,getPlaybackController:function(){return N},setCheckPlaybackQuality:function(e){T=e},setInitSegmentRequired:function(e){_=e}},r=Object(f.a)(v).getInstance().getLogger(t),Y(),n=e.streamInfo,t}C.__dashjs_factory_name="ScheduleController";var w=c.a.getClassFactory(C),D=n(58),O=n(14),M=n(37),P=n(26),L=n(13),F=n(22);function x(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var U=function e(){x(this,e),this.start=null,this.mstart=null,this.starttype=null,this.trace=[]};U.INITIAL_PLAYOUT_START_REASON="initial_playout",U.SEEK_START_REASON="seek",U.RESUME_FROM_PAUSE_START_REASON="resume",U.METRICS_COLLECTION_START_REASON="metrics_collection_start";var B=function e(){x(this,e),this.representationid=null,this.subreplevel=null,this.start=null,this.mstart=null,this.duration=null,this.playbackspeed=null,this.stopreason=null};B.REPRESENTATION_SWITCH_STOP_REASON="representation_switch",B.REBUFFERING_REASON="rebuffering",B.USER_REQUEST_STOP_REASON="user_request",B.END_OF_PERIOD_STOP_REASON="end_of_period",B.END_OF_CONTENT_STOP_REASON="end_of_content",B.METRICS_COLLECTION_STOP_REASON="metrics_collection_end",B.FAILURE_STOP_REASON="failure";var k=n(38);function G(e){e=e||{};var t,n,r,i,c,d,h,p,E,T,v,S,A,b=this.context,R=Object(u.a)(b).getInstance(),C=e.streamInfo,x=e.type,U=e.errHandler,G=e.mimeType,j=e.timelineConverter,Y=e.adapter,H=e.manifestModel,V=e.mediaPlayerModel,K=e.fragmentModel,q=e.abrController,W=e.playbackController,z=e.mediaController,X=e.textController,Q=e.dashMetrics,$=e.settings,Z=e.boxParser,J=e.segmentBlacklistController;function ee(){return C.id}function te(){return x}function ne(){return Y.getIsTextTrack(p.getData())}function re(){c=[],i=null,A=0,E=!1,T=!1}function ie(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(e.sender)if(W.getIsManifestUpdateInProgress())le();else if((!ne()||X.isTextEnabled())&&d&&e.representationId&&!d.appendInitSegmentFromCache(e.representationId)){var n=p.getCurrentRepresentation();if(0===n.range)return void ae();var r=v?v.getInitRequest(i,n):null;r?K.executeRequest(r):t&&(h.setInitSegmentRequired(!0),le())}}function ae(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(W.getIsManifestUpdateInProgress()||d.getIsPruningInProgress())le();else{var n=ue();n?(E=!1,oe(n)):se(t)}}function oe(e){isNaN(e.startTime+e.duration)||(A=e.startTime+e.duration),e.delayLoadingTime=(new Date).getTime()+h.getTimeToLoadDelay(),h.setTimeToLoadDelay(0),!function(e){var t=e.url;e.range&&(t=t.concat("_",e.range));return J.contains(t)}(e)?(n.debug("Next fragment request url for stream id ".concat(C.id," and media type ").concat(x," is ").concat(e.url)),K.executeRequest(e)):(n.warn("Fragment request url ".concat(e.url," for stream id ").concat(C.id," and media type ").concat(x," is on the ignore list and will be skipped")),le())}function se(e){var t,a=p.getCurrentRepresentation();if($.get().streaming.gaps.enableSeekFix&&(E||0===W.getTime())&&(r?r&&a.segmentInfoType===o.a.SEGMENT_TIMELINE&&(t=v.getValidTimeAheadOfTargetTime(A,i,a,$.get().streaming.gaps.threshold)):t=v.getValidTimeAheadOfTargetTime(A,i,a,$.get().streaming.gaps.threshold),!isNaN(t)&&t!==A))return void(W.isSeeking()||0===W.getTime()?(n.warn("Adjusting playback time ".concat(t," because of gap in the manifest. Seeking by ").concat(t-A)),W.seek(t,!1,!1)):(n.warn("Adjusting buffering time ".concat(t," because of gap in the manifest. Adjusting time by ").concat(t-A)),we(t),e&&le()));if(v.isLastSegmentRequested(a,A)){var s=v.getCurrentIndex();return n.debug("Segment requesting for stream ".concat(C.id," has finished")),R.trigger(l.a.STREAM_REQUESTING_COMPLETED,{segmentIndex:s},{streamId:C.id,mediaType:x}),d.segmentRequestingCompleted(s),void h.clearScheduleTimer()}e&&le()}function ue(){var e,t=Ae();if(isNaN(A)||te()===a.a.TEXT&&!X.isTextEnabled())return null;var n=E;if(v){var r=p&&t?p.getRepresentationForQuality(t.quality):null;e=n?v.getSegmentRequestForTime(i,r,A):v.getNextSegmentRequest(i,r)}return e}function le(){h.startScheduleTimer(W.getLowLatencyModeEnabled()?$.get().streaming.scheduling.lowLatencyTimeout:$.get().streaming.scheduling.defaultTimeout)}function ce(e){e.error||(h.setCurrentRepresentation(Y.convertRepresentationToRepresentationInfo(e.currentRepresentation)),d.getIsBufferingCompleted()||d.updateBufferTimestampOffset(e.currentRepresentation))}function fe(e){Q.addBufferState(x,e.state,h.getBufferTarget()),e.state!==s.a.BUFFER_EMPTY||W.isSeeking()||(n.info("Buffer is empty! Stalling!"),Q.pushPlayListTraceMetrics(new Date,B.REBUFFERING_REASON))}function de(e){K.syncExecutedRequestsWithBufferedRange(d.getBuffer().getAllBufferRanges(),C.duration),e.quotaExceeded&&e.from>W.getTime()&&we(e.from),e.hasEnoughSpaceToAppend&&e.quotaExceeded&&h.startScheduleTimer()}function he(e){if(e&&e.lastRequestAppended&&e.lastRequestAppended.url){var t=e.lastRequestAppended.url;e.lastRequestAppended.range&&(t=t.concat("_",e.lastRequestAppended.range)),n.warn("Blacklisting segment with url ".concat(t)),J.add(t)}}function pe(){Ne(),T=!1}function ge(e){n.info("onFragmentLoadingAbandoned request: "+e.request.url+" has been aborted"),W.isSeeking()||h.getSwitchStrack()||T||(n.info("onFragmentLoadingAbandoned request: "+e.request.url+" has to be downloaded again, origin is not seeking process or switch track call"),e.request&&e.request.isInitializationRequest()?h.setInitSegmentRequired(!0):we(e.request.startTime+e.request.duration/2),h.startScheduleTimer(0))}function me(e){n.info("OnFragmentLoadingCompleted for stream id "+C.id+" and media type "+x+" - Url:",e.request?e.request.url:"undefined",e.request.range?", Range:"+e.request.range:""),ne()&&h.startScheduleTimer(0),e.error&&e.request.serviceLocation&&function(e){if(n.info("Fragment loading completed with an error"),!e||!e.request||!e.request.type)return;e.request.type===_.a.INIT_SEGMENT_TYPE?ie({representationId:e.request.representationId,sender:{}},!1):e.request.type===_.a.MEDIA_SEGMENT_TYPE&&(we(e.request.startTime+e.request.duration/2),ae({},!1))}(e)}function ye(){we(W.getTime()),Se().startScheduleTimer()}function Ee(e){var t=e.currentTrackInfo;if(t){var n=c.find((function(e){return e.index===t.index&&e.lang===t.lang}));n&&ve(n).then((function(){d.setIsBufferingCompleted(!1),we(W.getTime()),h.setInitSegmentRequired(!0),h.startScheduleTimer()}))}}function _e(e){we(e.quotaExceededTime),h.clearScheduleTimer()}function Te(){return d?d.getBuffer():null}function ve(e){e===i||e&&i&&e.type!==i.type||(i=e);var t=Y.getRealAdaptation(C,i),n=Y.getVoRepresentations(i);if(p){var o,s=p.getData(),u=q.getMaxAllowedIndexFor(x,C.id),l=q.getMinAllowedIndexFor(x,C.id),c=null;return null!==s&&s.id===t.id||x===a.a.TEXT?o=q.getQualityFor(x,C.id):(c=q.getThroughputHistory().getAverageThroughput(x,r)||q.getInitialBitrateFor(x,C.id),o=q.getQualityForBitrate(i,c,C.id)),void 0!==l&&o<l&&(o=l),o>u&&(o=u),p.updateData(t,n,x,i.isFragmented,o)}return Promise.resolve()}function Se(){return h}function Ae(e){var t;return void 0!==e?(Object(O.a)(e),t=p?p.getRepresentationForQuality(e):null):t=p?p.getCurrentRepresentation():null,Y.convertRepresentationToRepresentationInfo(t)}function be(){return!!d&&d.getIsBufferingCompleted()}function Ie(e){var t=e.chunk,n=t.bytes,r=t.quality,i=Ae(r),a=p&&i?p.getRepresentationForQuality(i.quality):null;if(i&&a){var o=Y.getEventsFor(i.mediaInfo),s=Y.getEventsFor(i,a);if(o&&o.length>0||s&&s.length>0){var u=function(e,t,n,r){try{for(var i={},a=[],o=n.concat(r),s=0,u=o.length;s<u;s++)i[o[s].schemeIdUri+"/"+o[s].value]=o[s];var l=Object(F.a)(b).getInstance().parse(e),c=l.getBoxes("emsg");if(!c||0===c.length)return a;for(var f=l.getBox("sidx"),d=!f||isNaN(f.earliest_presentation_time)||isNaN(f.timescale)?t&&!isNaN(t.mediaStartTime)?t.mediaStartTime:0:f.earliest_presentation_time/f.timescale,h=Math.max(d,0),g=p.getCurrentRepresentation(),m=0,y=c.length;m<y;m++){var E=Y.getEvent(c[m],i,h,g);E&&a.push(E)}return a}catch(e){return[]}}(n,K.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,quality:r,index:t.index})[0],o,s);R.trigger(l.a.INBAND_EVENTS,{events:u},{streamId:C.id})}}}function Re(){var e=W.getTime();$.get().streaming.buffer.flushBufferAtTrackSwitch&&W.seek(e+.001,!1,!0),we(e),d.setSeekTarget(e),h.startScheduleTimer()}function Ne(){var e=W.getTime(),t=d.getContinuousBufferTimeForTargetTime(e);we(isNaN(t)?e:t),h.startScheduleTimer()}function Ce(e){e&&!isNaN(e.time)&&(we(e.time),d.setSeekTarget(e.time))}function we(e){A=e,E=!0}return t={initialize:function(n,i,s){S=Object(k.a)(b).create({events:l.a,eventBus:R,streamInfo:C,timelineConverter:j,dashConstants:o.a,segmentBaseController:e.segmentBaseController,type:x}),v=Object(M.a)(b).create({streamInfo:C,type:x,timelineConverter:j,dashMetrics:Q,mediaPlayerModel:V,baseURLController:e.baseURLController,errHandler:U,segmentsController:S,settings:$,boxParser:Z,events:l.a,eventBus:R,errors:y.a,debug:Object(f.a)(b).getInstance(),requestModifier:Object(P.a)(b).getInstance(),dashConstants:o.a,constants:a.a,urlUtils:Object(L.a)(b).getInstance()}),r=C.manifestInfo.isDynamic,v.initialize(r),q.registerStreamType(x,t),p=Object(D.a)(b).create({streamInfo:C,type:x,abrController:q,dashMetrics:Q,playbackController:W,timelineConverter:j,dashConstants:o.a,events:l.a,eventBus:R,errors:y.a,isDynamic:r,segmentsController:S}),(d=function(e,t){var n=null;if(!e)return U.error(new m.a(y.a.MEDIASOURCE_TYPE_UNSUPPORTED_CODE,y.a.MEDIASOURCE_TYPE_UNSUPPORTED_MESSAGE+"not properly defined")),null;n=e!==a.a.TEXT||t?I(b).create({streamInfo:C,type:e,mediaPlayerModel:V,manifestModel:H,fragmentModel:K,errHandler:U,mediaController:z,representationController:p,adapter:Y,textController:X,abrController:q,playbackController:W,settings:$}):N(b).create({streamInfo:C,type:e,mimeType:G,fragmentModel:K,textController:X,errHandler:U,settings:$});return n}(x,s))&&d.initialize(n),(h=w(b).create({streamInfo:C,type:x,mimeType:G,adapter:Y,dashMetrics:Q,mediaPlayerModel:V,fragmentModel:K,abrController:q,playbackController:W,textController:X,mediaController:z,bufferController:d,settings:$})).initialize(i),A=0,E=!1},getStreamId:ee,getType:te,isUpdating:function(){return!!p&&p.isUpdating()},getBufferController:function(){return d},getFragmentModel:function(){return K},getScheduleController:Se,getRepresentationController:function(){return p},getRepresentationInfo:Ae,getBufferLevel:function(){return d?d.getBufferLevel():0},isBufferingCompleted:be,createBufferSinks:function(e){var t=Te();return t?Promise.resolve(t):d?d.createBufferSink(i,e):Promise.resolve(null)},updateStreamInfo:function(e){return C=e,be()?Promise.resolve():d.updateAppendWindow()},getStreamInfo:function(){return C},selectMediaInfo:ve,clearMediaInfoArray:function(){c=[]},addMediaInfo:function(e){-1===c.indexOf(e)&&c.push(e)},prepareTrackSwitch:function(){return new Promise((function(e){n.debug("Preparing track switch for type ".concat(x));var t=x===a.a.TEXT||$.get().streaming.trackSwitchMode[x]===a.a.TRACK_SWITCH_MODE_ALWAYS_REPLACE&&W.getTimeToStreamEnd(C)>$.get().streaming.buffer.stallThreshold;if(d.getIsBufferingCompleted()&&!t)return d.prepareForNonReplacementTrackSwitch(i.codec).then((function(){R.trigger(l.a.BUFFERING_COMPLETED,{},{streamId:C.id,mediaType:x})})).catch((function(){R.trigger(l.a.BUFFERING_COMPLETED,{},{streamId:C.id,mediaType:x})})),void e();h.clearScheduleTimer(),h.setSwitchTrack(!0),t?(R.trigger(l.a.BUFFER_REPLACEMENT_STARTED,{mediaType:x,streamId:C.id},{mediaType:x,streamId:C.id}),K.abortRequests(),d.prepareForReplacementTrackSwitch(i.codec).then((function(){var e=Ae();return d.updateBufferTimestampOffset(e)})).then((function(){Re(),e()})).catch((function(){Re(),e()}))):d.prepareForNonReplacementTrackSwitch(i.codec).then((function(){Ne(),e()})).catch((function(){Ne(),e()}))}))},prepareQualityChange:function(e){n.debug("Preparing quality switch for type ".concat(x));var t=e.newQuality;T=!0,h.clearScheduleTimer();var r=Ae(t);h.setCurrentRepresentation(r),p.prepareQualityChange(t),K.abortRequests(),d.updateBufferTimestampOffset(r).then((function(){e.reason&&e.reason.forceReplace?(R.trigger(l.a.BUFFER_REPLACEMENT_STARTED,{mediaType:x,streamId:C.id},{mediaType:x,streamId:C.id}),d.prepareForReplacementQualitySwitch().then((function(){Re(),T=!1})).catch((function(){Re(),T=!1}))):$.get().streaming.buffer.fastSwitchEnabled?function(e){var t=W.getTime(),n=K.getRequests({state:g.a.FRAGMENT_MODEL_EXECUTED,time:t+1.5,threshold:0})[0];if(n&&!ne()){var r=d.getBufferLevel(),i=q.getAbandonmentStateFor(C.id,x);if(n.quality<e.quality&&r>=1.5&&i!==s.a.ABANDON_LOAD)we(t+1.5),h.setCheckPlaybackQuality(!1),h.startScheduleTimer();else pe()}else h.startScheduleTimer();T=!1}(r):pe(),Q.pushPlayListTraceMetrics(new Date,B.REPRESENTATION_SWITCH_STOP_REASON),Q.createPlaylistTraceMetrics(r.id,1e3*W.getTime(),W.getPlaybackRate())}))},getMediaInfo:function(){return i},getMediaSource:function(){return d.getMediaSource()},setMediaSource:function(e){d.setMediaSource(e)},getBuffer:Te,setExplicitBufferingTime:we,finalisePlayList:function(e,t){Q.pushPlayListTraceMetrics(e,t)},probeNextRequest:function(){var e=Ae(),t=p&&e?p.getRepresentationForQuality(e.quality):null;return v.getNextSegmentRequestIdempotent(i,t)},prepareInnerPeriodPlaybackSeeking:function(e){return new Promise((function(t){h.clearScheduleTimer(),K.abortRequests(),d.prepareForPlaybackSeek().then((function(){var t=d.getAllRangesWithSafetyFactor(e.seekTime);return d.clearBuffers(t)})).then((function(){var n=d.getContinuousBufferTimeForTargetTime(e.seekTime);if(!isNaN(n)&&!isNaN(C.duration)&&isFinite(C.duration)&&n>=C.start+C.duration)d.setIsBufferingCompleted(!0),t();else{var r=isNaN(n)?e.seekTime:n;we(r),d.setSeekTarget(r);var i=[];i.push(d.updateAppendWindow());var a=Ae();i.push(d.updateBufferTimestampOffset(a)),Promise.all(i).then((function(){h.setInitSegmentRequired(!0),h.setCheckPlaybackQuality(!1),h.startScheduleTimer(),t()}))}})).catch((function(e){n.error(e)}))}))},prepareOuterPeriodPlaybackSeeking:function(){return new Promise((function(e,t){try{h.clearScheduleTimer(),K.abortRequests(),d.prepareForPlaybackSeek().then((function(){return d.pruneAllSafely()})).then((function(){e()}))}catch(e){t(e)}}))},reset:function(e,n){v&&v.reset(),d&&(d.reset(e,n),d=null),h&&(h.reset(),h=null),p&&(p.reset(),p=null),S&&(S=null),q&&q.unRegisterStreamType(ee(),x),R.off(l.a.DATA_UPDATE_COMPLETED,ce,t),R.off(l.a.INIT_FRAGMENT_NEEDED,ie,t),R.off(l.a.MEDIA_FRAGMENT_NEEDED,ae,t),R.off(l.a.MEDIA_FRAGMENT_LOADED,Ie,t),R.off(l.a.BUFFER_LEVEL_STATE_CHANGED,fe,t),R.off(l.a.BUFFER_CLEARED,de,t),R.off(l.a.SEEK_TARGET,Ce,t),R.off(l.a.FRAGMENT_LOADING_ABANDONED,ge,t),R.off(l.a.FRAGMENT_LOADING_COMPLETED,me,t),R.off(l.a.SET_FRAGMENTED_TEXT_AFTER_DISABLED,ye,t),R.off(l.a.SET_NON_FRAGMENTED_TEXT,Ee,t),R.off(l.a.QUOTA_EXCEEDED,_e,t),R.off(l.a.SOURCE_BUFFER_ERROR,he,t),re(),x=null,C=null}},n=Object(f.a)(b).getInstance().getLogger(t),re(),R.on(l.a.DATA_UPDATE_COMPLETED,ce,t,{priority:u.a.EVENT_PRIORITY_HIGH}),R.on(l.a.INIT_FRAGMENT_NEEDED,ie,t),R.on(l.a.MEDIA_FRAGMENT_NEEDED,ae,t),R.on(l.a.MEDIA_FRAGMENT_LOADED,Ie,t),R.on(l.a.BUFFER_LEVEL_STATE_CHANGED,fe,t),R.on(l.a.BUFFER_CLEARED,de,t),R.on(l.a.SEEK_TARGET,Ce,t),R.on(l.a.FRAGMENT_LOADING_ABANDONED,ge,t),R.on(l.a.FRAGMENT_LOADING_COMPLETED,me,t),R.on(l.a.QUOTA_EXCEEDED,_e,t),R.on(l.a.SET_FRAGMENTED_TEXT_AFTER_DISABLED,ye,t),R.on(l.a.SET_NON_FRAGMENTED_TEXT,Ee,t),R.on(l.a.SOURCE_BUFFER_ERROR,he,t),t}G.__dashjs_factory_name="StreamProcessor";var j=c.a.getClassFactory(G),Y=n(59),H=n(62);function V(e){e=e||{};var t,n,r,i=this.context,o=Object(u.a)(i).getInstance(),s=e.errHandler,c=e.mediaPlayerModel,h=e.dashMetrics,p=Object(f.a)(i).getInstance(),m=e.streamInfo;function E(){return m.id}function _(){for(var e in r)r[e].reset();r={}}function T(e){if(e.sender){var t=e.request,r=e.response,i=t.isInitializationRequest(),s=t.mediaInfo.streamInfo;if(e.error&&(t.mediaType===a.a.AUDIO||t.mediaType===a.a.VIDEO||t.mediaType===a.a.TEXT&&t.mediaInfo.isFragmented)&&o.trigger(l.a.SERVICE_LOCATION_BLACKLIST_ADD,{entry:e.request.serviceLocation}),r&&s){var u=function(e,t,n,r){var i=new Y.a;return i.streamId=n,i.mediaInfo=t.mediaInfo,i.segmentType=t.type,i.start=t.startTime,i.duration=t.duration,i.end=i.start+i.duration,i.bytes=e,i.index=t.index,i.quality=t.quality,i.representationId=t.representationId,i.endFragment=r,i}(r,t,m.id,e.type!==l.a.FRAGMENT_LOADING_PROGRESS);o.trigger(i?l.a.INIT_FRAGMENT_LOADED:l.a.MEDIA_FRAGMENT_LOADED,{chunk:u,request:t},{streamId:s.id,mediaType:t.mediaType})}else n.warn("No "+t.mediaType+" bytes to push or stream is inactive.")}}return t={getStreamId:E,getModel:function(t){var n=r[t];return n||(n=Object(g.a)(i).create({streamInfo:m,type:t,dashMetrics:h,fragmentLoader:Object(H.a)(i).create({dashMetrics:h,mediaPlayerModel:c,errHandler:s,requestModifier:Object(P.a)(i).getInstance(),settings:e.settings,boxParser:e.boxParser,eventBus:o,events:l.a,errors:y.a,dashConstants:e.dashConstants,urlUtils:e.urlUtils,streamId:E()}),debug:p,eventBus:o,events:l.a}),r[t]=n),n},reset:function(){o.off(d.a.FRAGMENT_LOADING_COMPLETED,T,this),o.off(d.a.FRAGMENT_LOADING_PROGRESS,T,this),_()}},n=p.getLogger(t),_(),o.on(d.a.FRAGMENT_LOADING_COMPLETED,T,t),o.on(d.a.FRAGMENT_LOADING_PROGRESS,T,t),t}V.__dashjs_factory_name="FragmentController";var K=c.a.getClassFactory(V);var q=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.url=null,this.width=null,this.height=null,this.x=null,this.y=null},W=n(34);var z=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.mediaType=null,this.bitrate=null,this.width=null,this.height=null,this.scanType=null,this.qualityIndex=NaN},X=n(12);function Q(e){var t,n,r=this.context,i=e.streamInfo;function o(e){n.setTrackByIndex(e)}function s(){n&&n.reset()}return t={getStreamId:function(){return i.id},initialize:function(){n.addTracks();var e=n.getTracks();e&&e.length>0&&o(0)},provide:function(e,t){if("function"==typeof t){var r,i,a=n.getCurrentTrack();if(!a||a.segmentDuration<=0||null==e)t(null);else{(i=n.getThumbnailRequestForTime(e))&&(a.segmentDuration=i.duration),r=e%a.segmentDuration;var o=Math.floor(r*a.tilesHor*a.tilesVert/a.segmentDuration),s=new q;if(s.width=Math.floor(a.widthPerTile),s.height=Math.floor(a.heightPerTile),s.x=Math.floor(o%a.tilesHor)*a.widthPerTile,s.y=Math.floor(o/a.tilesHor)*a.heightPerTile,"readThumbnail"in a)return a.readThumbnail(e,(function(e){s.url=e,t(s)}));if(i)s.url=i.url,a.segmentDuration=NaN;else{var u=Math.floor(e/a.segmentDuration);s.url=function(e,t){var n=t+e.startNumber,r=Object(X.d)(e.templateUrl,"Number",n);return r=Object(X.d)(r,"Time",(n-1)*e.segmentDuration*e.timescale),r=Object(X.d)(r,"Bandwidth",e.bandwidth),Object(X.e)(r)}(a,u)}t(s)}}},setTrackByIndex:o,getCurrentTrackIndex:function(){return n.getCurrentTrackIndex()},getBitrateList:function(){var e=n.getTracks(),t=0;return e.map((function(e){var n=new z;return n.mediaType=a.a.IMAGE,n.qualityIndex=t++,n.bitrate=e.bitrate,n.width=e.width,n.height=e.height,n}))},reset:s},s(),n=Object(W.b)(r).create({streamInfo:i,adapter:e.adapter,baseURLController:e.baseURLController,timelineConverter:e.timelineConverter,debug:e.debug,eventBus:e.eventBus,events:e.events,dashConstants:e.dashConstants,dashMetrics:e.dashMetrics,segmentBaseController:e.segmentBaseController}),t}Q.__dashjs_factory_name="ThumbnailController";var $=c.a.getClassFactory(Q);function Z(e){var t;e=e||{};var n=[],r=Object(u.a)(this.context).getInstance(),i=e.updateEventName,a=e.addBlacklistEventName;function o(e){-1===n.indexOf(e)&&(n.push(e),r.trigger(i,{entry:e}))}function s(e){o(e.entry)}return t={add:o,contains:function(e){return!!(n.length&&e&&e.length)&&-1!==n.indexOf(e)},reset:function(){n=[]}},a&&r.on(a,s,t),t}Z.__dashjs_factory_name="BlackListController";var J=c.a.getClassFactory(Z),ee=[a.a.VIDEO,a.a.AUDIO,a.a.TEXT,a.a.MUXED,a.a.IMAGE];function te(e){e=e||{};var t,n,r,i,s,c,d,h,p,g,E,_,T,v,S,A,b,I,R=this.context,N=Object(u.a)(R).getInstance(),C=Object(L.a)(R).getInstance(),w=e.manifestModel,D=e.mediaPlayerModel,O=e.dashMetrics,M=e.manifestUpdater,P=e.adapter,x=e.timelineConverter,U=e.capabilities,B=e.errHandler,k=e.abrController,G=e.playbackController,Y=e.eventController,H=e.mediaController,V=e.protectionController,q=e.textController,W=e.videoModel,z=e.streamInfo,X=e.settings;function Q(t,i){return new Promise((function(s,u){se(),g=!0,le();var c,f=W.getElement();ee.forEach((function(i){(i!==a.a.VIDEO||!f||f&&/^VIDEO$/i.test(f.nodeName))&&function(t,i){var s,u=P.getAllMediaInfoForType(z,t),c=[],f=null;if(!u||0===u.length)return void n.info("No "+t+" data.");t===a.a.VIDEO&&(d=!0);t===a.a.AUDIO&&(h=!0);for(var p=0,g=u.length;p<g;p++)f=u[p],t===a.a.TEXT&&f.isEmbedded&&(q.addEmbeddedTrack(z,f),c.push(f)),Z(f)&&H.addTrack(f);c.length>0&&(H.setInitialMediaSettingsForType(t,z),q.setInitialSettings(H.getInitialSettings(t)),q.addMediaInfosToBuffer(z,t,c));if(0===(u=u.filter((function(e){return!e.isEmbedded}))).length)return;if(t===a.a.IMAGE)return void(_=$(R).create({streamInfo:z,adapter:P,baseURLController:e.baseURLController,timelineConverter:e.timelineConverter,debug:A,eventBus:N,events:l.a,dashConstants:o.a,dashMetrics:e.dashMetrics,segmentBaseController:e.segmentBaseController})).initialize();N.trigger(l.a.STREAM_INITIALIZING,{streamInfo:z,mediaInfo:f}),H.setInitialMediaSettingsForType(t,z);var m=function(t,n){var i=t&&t.length>0?t[0]:null,o=E.getModel(i?i.type:null),s=i?i.type:null,u=i?i.mimeType:null,l=i?i.isFragmented:null,c=j(R).create({streamInfo:z,type:s,mimeType:u,timelineConverter:x,adapter:P,manifestModel:w,mediaPlayerModel:D,fragmentModel:o,dashMetrics:e.dashMetrics,baseURLController:e.baseURLController,segmentBaseController:e.segmentBaseController,abrController:k,playbackController:G,mediaController:H,textController:q,errHandler:B,settings:X,boxParser:S,segmentBlacklistController:T});c.initialize(n,d,l),r.push(c);for(var f=0;f<t.length;f++)c.addMediaInfo(t[f]);s===a.a.TEXT&&q.addMediaInfosToBuffer(z,s,t,o);return c}(u,i);(s=H.getCurrentTrackFor(t,z.id))&&(k.updateTopQualityIndex(s),m.selectMediaInfo(t===a.a.TEXT&&s.isEmbedded?u[0]:s))}(i,t)})),(c=i,new Promise((function(e){var t={},n=r.map((function(e){return e.createBufferSinks(c)}));Promise.all(n).then((function(n){n.forEach((function(e){e&&(t[e.getType()]=e)})),e(t)})).catch((function(){e(t)}))}))).then((function(e){if(g=!1,0===r.length){var t="No streams to play.";B.error(new m.a(y.a.MANIFEST_ERROR_ID_NOSTREAMS_CODE,t,w.getValue())),n.fatal(t)}else ce();q.createTracks(z),s(e)})).catch((function(e){u(e)}))}))}function Z(e){var t,r=e?e.type:null;return r===a.a.MUXED?(t="Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines",n.fatal(t),B.error(new m.a(y.a.MANIFEST_ERROR_ID_MULTIPLEXED_CODE,t,w.getValue())),!1):r===a.a.TEXT||r===a.a.IMAGE||(!(e.contentProtection&&!U.supportsEncryptedMedia())||(B.error(new m.a(y.a.CAPABILITY_MEDIAKEYS_ERROR_CODE,y.a.CAPABILITY_MEDIAKEYS_ERROR_MESSAGE)),!1))}function te(e){for(var t=r?r.length:0,n=0;n<t;n++){var i=r[n].getFragmentModel();i.abortRequests(),i.resetInitialSettings(),r[n].reset(!1,e)}q&&q.deactivateStream(z),r=[],s=!1,c=!1,Te(!1),re(!1),N.trigger(l.a.STREAM_DEACTIVATED,{streamInfo:z})}function ne(e){te(e),i=!1,d=!1,h=!1,p={},g=!1,b=!1,I=[]}function re(e){b=e}function ie(){return z?z.start:NaN}function ae(){return z?z.id:null}function oe(){return z}function se(){if(!W||!k)throw new Error(a.a.MISSING_CONFIG_ERROR)}function ue(e){e.error&&(B.error(e.error),n.fatal(e.error.message))}function le(){if(Y){var e=P.getEventsFor(z);Y.addInlineEvents(e)}}function ce(){for(var e=r.length,t=!!p.audio||!!p.video?new m.a(y.a.DATA_UPDATE_FAILED_ERROR_CODE,y.a.DATA_UPDATE_FAILED_ERROR_MESSAGE):null,n=0;n<e;n++)if(r[n].isUpdating()||g)return;if(V){V.clearMediaInfoArray();for(var o=0;o<e&&r[o];o++){var s=r[o].getType(),u=r[o].getMediaInfo();if(s===a.a.AUDIO||s===a.a.VIDEO||s===a.a.TEXT&&u.isFragmented){var c=r[o].getMediaInfo();c&&V.initializeForMedia(c)}}}t?B.error(t):i||(i=!0,W.waitForReadyState(a.a.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA,(function(){N.trigger(l.a.STREAM_INITIALIZED,{streamInfo:z})})))}function fe(){var e=me(),t=e.length;if(0!==t){for(var r=0;r<t;r++)if(!e[r].isBufferingCompleted()&&(e[r].getType()===a.a.AUDIO||e[r].getType()===a.a.VIDEO))return void n.debug("onBufferingCompleted - One streamProcessor has finished but",e[r].getType(),"one is not buffering completed");n.debug("onBufferingCompleted - trigger STREAM_BUFFERING_COMPLETED"),c=!0,N.trigger(l.a.STREAM_BUFFERING_COMPLETED,{streamInfo:z},{streamInfo:z})}else n.warn("onBufferingCompleted - can't trigger STREAM_BUFFERING_COMPLETED because no streamProcessor is defined")}function de(e){p[e.mediaType]=e.error,ce()}function he(e){Y&&Y.addInbandEvents(e.events)}function pe(e){return e&&e.type?ge(e.type):null}function ge(e){return e?me().filter((function(t){return t.getType()===e}))[0]:null}function me(){for(var e,t,n=[],i=0;i<r.length;i++)(e=(t=r[i]).getType())!==a.a.AUDIO&&e!==a.a.VIDEO&&e!==a.a.TEXT||n.push(t);return n}function ye(e,t){var n=oe(),r=t.getStreamInfo();if(!r||!n)return!0;var i=P.getAdaptationForType(r.index,e,r),a=P.getAdaptationForType(n.index,e,n);return i&&a?!(!Ee(a)&&Ee(i)):!i&&!a}function Ee(e){return!!e&&!!(e.ContentProtection||e.Representation&&e.Representation.length>0&&e.Representation[0].ContentProtection)}function _e(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;if(!e||!e.hasOwnProperty("getStreamInfo"))return!1;var r=e.getStreamInfo(),i=n?n.getStreamInfo():oe();if(!r||!i)return!1;var a=P.getAdaptationForType(r.index,t,r),o=P.getAdaptationForType(i.index,t,i);if(!a||!o)return!a&&!o;var s=a&&o&&a.mimeType===o.mimeType,u=o.Representation_asArray.map((function(e){return e.codecs})),l=a.Representation_asArray.map((function(e){return e.codecs})),c=l.some((function(e){return u.indexOf(e)>-1})),f=l.some((function(e){return u.some((function(t){return U.codecRootCompatibleWithCodec(t,e)}))}));return c||f&&s}function Te(e){v=e}function ve(){return v}return t={initialize:function(){N.on(l.a.BUFFERING_COMPLETED,fe,t),N.on(l.a.DATA_UPDATE_COMPLETED,de,t),N.on(l.a.INBAND_EVENTS,he,t),V&&(N.on(l.a.KEY_ERROR,ue,t),N.on(l.a.SERVER_CERTIFICATE_UPDATED,ue,t),N.on(l.a.LICENSE_REQUEST_COMPLETE,ue,t),N.on(l.a.KEY_SYSTEM_SELECTED,ue,t),N.on(l.a.KEY_SESSION_CREATED,ue,t),N.on(l.a.KEY_STATUSES_CHANGED,ue,t)),q.initializeForStream(z),N.trigger(l.a.STREAM_UPDATED,{streamInfo:z})},getStreamId:function(){return z?z.id:null},activate:function(e,t){return new Promise((function(n,r){if(!s)return ve()?(s=!0,N.trigger(l.a.STREAM_ACTIVATED,{streamInfo:z}),void n(t)):void function(e,t){return Q(e,t)}(e,t).then((function(e){s=!0,N.trigger(l.a.STREAM_ACTIVATED,{streamInfo:z}),n(e)})).catch((function(e){r(e)}));n(t)}))},deactivate:te,getIsActive:function(){return s},getDuration:function(){return z?z.duration:NaN},getStartTime:ie,getId:ae,getStreamInfo:oe,getHasAudioTrack:function(){return h},getHasVideoTrack:function(){return d},startPreloading:function(e,t){return new Promise((function(i,a){ve()?a():(n.info("[startPreloading] Preloading next stream with id ".concat(ae())),Te(!0),Q(e,t).then((function(){for(var e=0;e<r.length&&r[e];e++)r[e].setExplicitBufferingTime(ie()),r[e].getScheduleController().startScheduleTimer();i()})).catch((function(){Te(!1),a()})))}))},getThumbnailController:function(){return _},getBitrateListFor:function(e){if(se(),e===a.a.IMAGE)return _?_.getBitrateList():[];var t=function(e){for(var t=null,n=0;n<r.length;n++)if((t=r[n]).getType()===e)return t.getMediaInfo();return null}(e);return k.getBitrateList(t)},updateData:function(e){return new Promise((function(t){g=!0,z=e,Y&&le();for(var n=[],i=0,a=r.length;i<a;i++){var o=r[i],s=o.getMediaInfo();n.push(o.updateStreamInfo(z));var u=P.getAllMediaInfoForType(z,o.getType());if(u){o.clearMediaInfoArray();for(var c=0;c<u.length;c++){var f=u[c];o.addMediaInfo(u[c]),P.areMediaInfosEqual(s,f)&&(k.updateTopQualityIndex(f),n.push(o.selectMediaInfo(f)))}}}Promise.all(n).then((function(){for(n=[];I.length>0;){var e=I.pop(),t=e.newMediaInfo,r=pe(e.oldMediaInfo);if(!r)return;n.push(r.prepareTrackSwitch()),r.selectMediaInfo(t)}return Promise.all(n)})).then((function(){g=!1,ce(),N.trigger(l.a.STREAM_UPDATED,{streamInfo:z}),t()}))}))},reset:function(e){E&&(E.reset(),E=null),k&&z&&k.clearDataForStream(z.id),T&&(T.reset(),T=null),ne(e),z=null,N.off(l.a.DATA_UPDATE_COMPLETED,de,t),N.off(l.a.BUFFERING_COMPLETED,fe,t),N.off(l.a.INBAND_EVENTS,he,t),V&&(N.off(l.a.KEY_ERROR,ue,t),N.off(l.a.SERVER_CERTIFICATE_UPDATED,ue,t),N.off(l.a.LICENSE_REQUEST_COMPLETE,ue,t),N.off(l.a.KEY_SYSTEM_SELECTED,ue,t),N.off(l.a.KEY_SESSION_CREATED,ue,t),N.off(l.a.KEY_STATUSES_CHANGED,ue,t))},getProcessors:me,setMediaSource:function(e){for(var t=0;t<r.length;)Z(r[t].getMediaInfo())?(r[t].setMediaSource(e),t++):(r[t].reset(),r.splice(t,1));if(0===r.length){var i="No streams to play.";B.error(new m.a(y.a.MANIFEST_ERROR_ID_NOSTREAMS_CODE,i+"nostreams",w.getValue())),n.fatal(i)}},isMediaCodecCompatible:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return _e(e,a.a.VIDEO,t)&&_e(e,a.a.AUDIO,t)},isProtectionCompatible:function(e){return!e||ye(a.a.VIDEO,e)&&ye(a.a.AUDIO,e)},getPreloaded:ve,getIsEndedEventSignaled:function(){return b},setIsEndedEventSignaled:re,getAdapter:function(){return P},getHasFinishedBuffering:function(){return c},setPreloaded:Te,startScheduleControllers:function(){for(var e=r.length,t=0;t<e&&r[t];t++)r[t].getScheduleController().startScheduleTimer()},prepareTrackChange:function(e){if(s&&z){c=!1;var t=e.newMediaInfo,r=w.getValue();P.setCurrentMediaInfo(z.id,t.type,t);var i=pe(t);if(i){var o=G.getTime();n.info("Stream -  Process track changed at current time "+o),r.refreshManifestOnSwitchTrack?(I.push(e),M.getIsUpdating()||(n.debug("Stream -  Refreshing manifest for switch track"),M.refreshManifest())):i.selectMediaInfo(t).then((function(){t.type!==a.a.VIDEO&&t.type!==a.a.AUDIO||k.updateTopQualityIndex(t),i.prepareTrackSwitch()}))}}},prepareQualityChange:function(e){var t=ge(e.mediaType);t&&t.prepareQualityChange(e)}},function(){try{A=Object(f.a)(R).getInstance(),n=A.getLogger(t),ne(),S=Object(F.a)(R).getInstance(),T=J(R).create({updateEventName:l.a.SEGMENT_LOCATION_BLACKLIST_CHANGED,addBlacklistEventName:l.a.SEGMENT_LOCATION_BLACKLIST_ADD}),E=K(R).create({streamInfo:z,mediaPlayerModel:D,dashMetrics:O,errHandler:B,settings:X,boxParser:S,dashConstants:o.a,urlUtils:C})}catch(e){throw e}}(),t}te.__dashjs_factory_name="Stream";var ne=c.a.getClassFactory(te);function re(){var e,t,n,r,i,a,s,c,h,p,g,m,E=this.context,_=Object(u.a)(E).getInstance(),T=Object(L.a)(E).getInstance();function v(){n=NaN,s=!1,i=!0,a=!1,S()}function S(){null!==r&&(clearTimeout(r),r=null)}function A(e){S(),a||(isNaN(e)&&!isNaN(n)&&(e=1e3*n),isNaN(e)||(t.debug("Refresh manifest in "+e+" milliseconds."),r=setTimeout(R,e)))}function b(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];s=!0;var t=h.getValue(),n=t.url,r=p.getPatchLocation(t),i=p.getLocation(t);r&&!e?n=r:i&&(n=i),T.isRelative(n)&&(n=T.resolve(n,t.url)),c.load(n)}function I(e){if(e){if(p.getIsPatch(e)){var r=e;e=h.getValue();var u=p.isPatchValid(e,r),c=u;if(u){var f=p.getPublishTime(e);c=p.applyPatchToManifest(e,r);var d=p.getPublishTime(e);c=f.getTime()!=d.getTime()}if(!c)return t.debug("Patch provided is invalid, performing full manifest refresh"),void b(!0);e.loadedTime=new Date}}else(e=h.getValue()).loadedTime=new Date;if(h.getValue()&&h.getValue().type===o.a.DYNAMIC&&e.type===o.a.STATIC)return _.trigger(l.a.DYNAMIC_TO_STATIC),s=!1,void(a=!0);h.setValue(e);var g=new Date,m=(g.getTime()-e.loadedTime.getTime())/1e3;1e3*(n=p.getManifestUpdatePeriod(e,m))>2147483647&&(n=2147483.647),_.trigger(l.a.MANIFEST_UPDATED,{manifest:e}),t.info("Manifest has been refreshed at "+g+"["+g.getTime()/1e3+"] "),i||A()}function R(){i||(s?A(m.get().streaming.manifestUpdateRetryInterval):b())}function N(e){e.error?e.error.code===y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE&&g.error(e.error):I(e.manifest)}function C(){i=!1,A()}function w(){(i=!m.get().streaming.scheduling.scheduleWhilePaused)&&S()}function D(){s=!1}return e={initialize:function(){v(),_.on(l.a.STREAMS_COMPOSED,D,this),_.on(d.a.PLAYBACK_STARTED,C,this),_.on(d.a.PLAYBACK_PAUSED,w,this),_.on(l.a.INTERNAL_MANIFEST_LOADED,N,this)},setManifest:function(e){I(e)},refreshManifest:b,getIsUpdating:function(){return s},setConfig:function(e){e&&(e.manifestModel&&(h=e.manifestModel),e.adapter&&(p=e.adapter),e.manifestLoader&&(c=e.manifestLoader),e.errHandler&&(g=e.errHandler),e.settings&&(m=e.settings))},reset:function(){_.off(d.a.PLAYBACK_STARTED,C,this),_.off(d.a.PLAYBACK_PAUSED,w,this),_.off(l.a.STREAMS_COMPOSED,D,this),_.off(l.a.INTERNAL_MANIFEST_LOADED,N,this),v()}},t=Object(f.a)(E).getInstance().getLogger(e),e}re.__dashjs_factory_name="ManifestUpdater";var ie=c.a.getClassFactory(re);function ae(){var e,t,n,r,i,a,o,s,c,d,h,p,g,E,T,v,S=this.context,A=Object(u.a)(S).getInstance(),b=Object(L.a)(S).getInstance();function I(){s=[],c=[],d=null,h=null,g=null,p=NaN,n=!1,r=!1,E=i.get().streaming.utcSynchronization.timeBetweenSyncAttempts}function R(){i.get().streaming.utcSynchronization.enabled&&!n&&!r&&g&&g.value&&g.schemeIdUri&&!isNaN(p)&&!isNaN(i.get().streaming.utcSynchronization.backgroundAttempts)&&(h&&(Date.now()-h)/1e3<30||(s=[],r=!0,function e(t){try{if(t<=0)return void k();var n=Date.now();a[g.schemeIdUri](g.value,(function(r){var i=Date.now(),a=N(n,i,r);s.push(a),e(t-1)}),(function(){k()}))}catch(e){k()}}(isNaN(i.get().streaming.utcSynchronization.backgroundAttempts)?2:i.get().streaming.utcSynchronization.backgroundAttempts)))}function N(e,t,n){return n-(t-(t-e)/2)}function C(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:NaN,t=isNaN(e);t&&i.get().streaming.utcSynchronization.useManifestDateHeaderTimeSource?U():B(t,e)}function w(e){var t=Date.parse(e);return isNaN(t)&&(t=function(e){var t,n,r=/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/.exec(e);return t=Date.UTC(parseInt(r[1],10),parseInt(r[2],10)-1,parseInt(r[3],10),parseInt(r[4],10),parseInt(r[5],10),r[6]&&(parseInt(r[6],10)||0),r[7]&&1e3*parseFloat(r[7])||0),r[9]&&r[10]&&(n=60*parseInt(r[9],10)+parseInt(r[10],10),t+=("+"===r[8]?-1:1)*n*60*1e3),new Date(t).getTime()}(e)),t}function D(e){return Date.parse(e)}function O(e){return Date.parse(e)}function M(e,t,n){n()}function P(e,t,n){var r=w(e);isNaN(r)?n():t(r)}function F(e,t,n,r,i){var a,o,s=!1,u=new XMLHttpRequest,l=i?_.a.HEAD:_.a.GET,c=t.match(/\S+/g);if(t=c.shift(),a=function(){s||(s=!0,c.length?F(e,c.join(" "),n,r,i):r())},o=function(){var t,r;200===u.status&&(t=i?u.getResponseHeader("Date"):u.response,r=e(t),isNaN(r)||(n(r),s=!0))},b.isRelative(t)){var f=v.resolve();f&&(t=b.resolve(t,f.url))}u.open(l,t),u.timeout=5e3,u.onload=o,u.onloadend=a,u.send()}function x(e,t,n){F(O,e,t,n,!0)}function U(){var e=o.getLatestMPDRequestHeaderValueByID("Date"),t=null!==e?new Date(e).getTime():Number.NaN;isNaN(t)?B(!0):B(!1,t-Date.now())}function B(e,r){if(isNaN(p)||isNaN(r)||e||function(e){try{var n,r=G(e),a=isNaN(E)?30:E,o=isNaN(i.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor)?2:i.get().streaming.utcSynchronization.timeBetweenSyncAttemptsAdjustmentFactor,s=isNaN(i.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts)?600:i.get().streaming.utcSynchronization.maximumTimeBetweenSyncAttempts,u=isNaN(i.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts)?2:i.get().streaming.utcSynchronization.minimumTimeBetweenSyncAttempts;r?(n=Math.min(a*o,s),t.debug("Increasing timeBetweenSyncAttempts to ".concat(n))):(n=Math.max(a/o,u),t.debug("Decreasing timeBetweenSyncAttempts to ".concat(n))),E=n}catch(e){}}(r),!e&&!isNaN(r)){d=Date.now(),n=!1;var a=isNaN(p);p=r,a&&R(),t.debug("Completed UTC sync. Setting client - server offset to ".concat(r))}e&&(g=null,n=!1,T.error(new m.a(y.a.TIME_SYNC_FAILED_ERROR_CODE,y.a.TIME_SYNC_FAILED_ERROR_MESSAGE))),A.trigger(l.a.UPDATE_TIME_SYNC_OFFSET,{offset:r}),A.trigger(l.a.TIME_SYNCHRONIZATION_COMPLETED)}function k(){if(s&&0!==s.length){var e=s.reduce((function(e,t){return e+t}),0)/s.length;G(e)?t.debug("Completed background UTC sync. Offset is within allowed threshold and is not adjusted."):(t.debug("Completed background UTC sync. Setting client - server offset to ".concat(e)),p=e,A.trigger(l.a.UPDATE_TIME_SYNC_OFFSET,{offset:p})),r=!1,h=Date.now()}}function G(e){try{if(isNaN(p))return!0;var t=i.get().streaming.utcSynchronization.maximumAllowedDrift&&!isNaN(i.get().streaming.utcSynchronization.maximumAllowedDrift)?i.get().streaming.utcSynchronization.maximumAllowedDrift:100;return e>=p-t&&e<=p+t}catch(e){return!0}}return e={initialize:function(){I(),a={"urn:mpeg:dash:utc:http-head:2014":x,"urn:mpeg:dash:utc:http-xsdate:2014":F.bind(null,w),"urn:mpeg:dash:utc:http-iso:2014":F.bind(null,D),"urn:mpeg:dash:utc:direct:2014":P,"urn:mpeg:dash:utc:http-head:2012":x,"urn:mpeg:dash:utc:http-xsdate:2012":F.bind(null,w),"urn:mpeg:dash:utc:http-iso:2012":F.bind(null,D),"urn:mpeg:dash:utc:direct:2012":P,"urn:mpeg:dash:utc:http-ntp:2014":M,"urn:mpeg:dash:utc:ntp:2014":M,"urn:mpeg:dash:utc:sntp:2014":M}},attemptSync:function(e,t){c=e,n||(!function(e){try{if(!e||!i.get().streaming.utcSynchronization.enabled)return!1;var t=isNaN(E)?30:E;return!(d&&t&&!isNaN(t))||(Date.now()-d)/1e3>=t}catch(e){return!0}}(t)?A.trigger(l.a.TIME_SYNCHRONIZATION_COMPLETED):(n=!0,function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,n=t||0;if(!c||0===c.length||n>=c.length)return void C();var r=c[n];if(r)if(a.hasOwnProperty(r.schemeIdUri)){var i=(new Date).getTime();a[r.schemeIdUri](r.value,(function(e){var t=(new Date).getTime(),n=N(i,t,e);g=r,C(n)}),(function(){e(n+1)}))}else e(n+1);else C()}()))},setConfig:function(e){e&&(e.dashMetrics&&(o=e.dashMetrics),e.baseURLController&&(v=e.baseURLController),e.errHandler&&(T=e.errHandler),e.settings&&(i=e.settings))},reset:function(){I(),A.off(l.a.ATTEMPT_BACKGROUND_SYNC,R,e)}},t=Object(f.a)(S).getInstance().getLogger(e),A.on(l.a.ATTEMPT_BACKGROUND_SYNC,R,e),e}ae.__dashjs_factory_name="TimeSyncController";var oe=c.a.getSingletonFactory(ae);oe.HTTP_TIMEOUT_MS=5e3,c.a.updateSingletonFactory(ae.__dashjs_factory_name,oe);var se=oe;function ue(){var e,t,n,r=this.context;return e={createMediaSource:function(){var e="WebKitMediaSource"in window;return"MediaSource"in window?t=new MediaSource:e&&(t=new WebKitMediaSource),t},attachMediaSource:function(e){var n=window.URL.createObjectURL(t);return e.setSource(n),n},detachMediaSource:function(e){e.setSource(null)},setDuration:function e(r){t&&"open"===t.readyState&&(null===r&&isNaN(r)||t.duration!==r&&(!function(e){for(var t=e.sourceBuffers,n=0;n<t.length;n++)if(t[n].updating)return!0;return!1}(t)?(n.info("Set MediaSource duration:"+r),t.duration=r):setTimeout(e.bind(null,r),50)))},setSeekable:function(e,n){t&&"function"==typeof t.setLiveSeekableRange&&"function"==typeof t.clearLiveSeekableRange&&"open"===t.readyState&&e>=0&&e<n&&(t.clearLiveSeekableRange(),t.setLiveSeekableRange(e,n))},signalEndOfStream:function(e){if(e&&"open"===e.readyState){for(var t=e.sourceBuffers,r=0;r<t.length;r++){if(t[r].updating)return;if(0===t[r].buffered.length)return}n.info("call to mediaSource endOfStream"),e.endOfStream()}}},n=Object(f.a)(r).getInstance().getLogger(e),e}ue.__dashjs_factory_name="MediaSourceController";var le=c.a.getSingletonFactory(ue),ce=n(29);function fe(){var e,t,n,r,i,a,o,s,l,c,h,p="discarded",g="updated",m="added",y=this.context,E=Object(u.a)(y).getInstance();function _(){if(!o||!s)throw new Error("setConfig function has to be called previously")}function T(){h=!1,n={},r={},i=null,c=!1,a=Date.now()/1e3}function v(){try{null!==i&&h&&(clearInterval(i),i=null,h=!1,function(){try{R(r),R(n)}catch(e){}}())}catch(e){throw e}}function S(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=e.eventStream.schemeIdUri,i=e.eventStream.value,a=e.id,o=p;t[r]||(t[r]=[]);var s=t[r].findIndex((function(e){return(!i||e.eventStream.value&&e.eventStream.value===i)&&e.id===a}));return-1===s?(t[r].push(e),o=m):n&&(t[r][s]=e,o=g),o}function A(e){try{if(1==e.eventStream.value){var t,n=e.calculatedPresentationTime;t=4294967295==e.calculatedPresentationTime?NaN:e.calculatedPresentationTime+e.duration,E.trigger(d.a.MANIFEST_VALIDITY_CHANGED,{id:e.id,validUntil:n,newDuration:t,newManifestValidAfter:NaN},{mode:d.a.EVENT_MODE_ON_START})}}catch(e){}}function b(){try{if(!c){c=!0;var e=s.getTime(),t=e-a;t=a>0?Math.max(0,t):0,I(r,t,e),I(n,t,e),a=e,c=!1}}catch(e){c=!1}}function I(e,n,r){try{N(e,(function(i){if(void 0!==i){var a=isNaN(i.duration)?0:i.duration;i.calculatedPresentationTime<=r&&i.calculatedPresentationTime+n+a>=r?C(i,e,d.a.EVENT_MODE_ON_START):(function(e,t,n){try{return e-t>n}catch(e){return!1}}(r,a+n,i.calculatedPresentationTime)||function(e){try{var t=e.eventStream.period.start+e.eventStream.period.duration;return e.calculatedPresentationTime>t}catch(e){return!1}}(i))&&(t.debug("Deleting event ".concat(i.id," as it is expired or invalid")),w(e,i))}}))}catch(e){}}function R(e){try{var t=s.getTime();N(e,(function(n){var r=n.eventStream&&n.eventStream.period&&!isNaN(n.eventStream.period.duration)?n.eventStream.period.duration:NaN,i=n.eventStream&&n.eventStream.period&&!isNaN(n.eventStream.period.start)?n.eventStream.period.start:NaN;if(!isNaN(r)&&!isNaN(i)){var a=n.calculatedPresentationTime;Math.abs(a-t)<300&&C(n,e,d.a.EVENT_MODE_ON_START)}}))}catch(e){}}function N(e,t){try{if(e)for(var n=Object.keys(e),r=0;r<n.length;r++){e[n[r]].forEach((function(e){void 0!==e&&t(e)}))}}catch(e){}}function C(e,n,r){try{var i=s.getTime(),a=e.id;if(r===d.a.EVENT_MODE_ON_RECEIVE)return t.debug("Received event ".concat(a)),void E.trigger(e.eventStream.schemeIdUri,{event:e},{mode:r});"urn:mpeg:dash:event:2012"===e.eventStream.schemeIdUri&&1==e.eventStream.value?0===e.duration&&0===e.presentationTimeDelta||(t.debug("Starting manifest refresh event ".concat(a," at ").concat(i)),w(n,e),function(){try{_(),o.refreshManifest()}catch(e){}}()):"urn:mpeg:dash:event:callback:2015"===e.eventStream.schemeIdUri&&1==e.eventStream.value?(t.debug("Starting callback event ".concat(a," at ").concat(i)),w(n,e),function(e){try{Object(ce.a)(y).create({}).load({method:"get",url:e,request:{responseType:"arraybuffer"}})}catch(e){throw e}}(e.messageData)):(t.debug("Starting event ".concat(a," at ").concat(i)),w(n,e),E.trigger(e.eventStream.schemeIdUri,{event:e},{mode:r}))}catch(e){}}function w(e,t){var n=t.eventStream.schemeIdUri,r=t.eventStream.value,i=t.id;e[n]=e[n].filter((function(e){return r&&e.eventStream.value&&e.eventStream.value!==r||e.id!==i})),0===e[n].length&&delete e[n]}return e={addInlineEvents:function(e){try{if(_(),e)for(var r=0;r<e.length;r++){var i=e[r],a=S(i,n,!0);a===m?(t.debug("Added inline event with id ".concat(i.id)),C(i,e,d.a.EVENT_MODE_ON_RECEIVE)):a===g&&t.debug("Updated inline event with id ".concat(i.id))}}catch(e){throw e}},addInbandEvents:function(e){try{_();for(var n=0;n<e.length;n++){var i=e[n];S(i,r,!1)===m?("urn:mpeg:dash:event:2012"===i.eventStream.schemeIdUri&&void 0===r[i.id]&&A(i),t.debug("Added inband event with id "+i.id),C(i,e,d.a.EVENT_MODE_ON_RECEIVE)):t.debug("Inband event with scheme_id_uri ".concat(i.eventStream.schemeIdUri,", value ").concat(i.eventStream.value," and id ").concat(i.id," was ignored because it has been added before."))}b()}catch(e){throw e}},getInbandEvents:function(){return r},getInlineEvents:function(){return n},start:function(){try{_(),t.debug("Start Event Controller");var e=l.get().streaming.eventControllerRefreshDelay;h||isNaN(e)||(h=!0,i=setInterval(b,e))}catch(e){throw e}},setConfig:function(e){try{if(!e)return;e.manifestUpdater&&(o=e.manifestUpdater),e.playbackController&&(s=e.playbackController),e.settings&&(l=e.settings)}catch(e){throw e}},reset:function(){v(),T()}},t=Object(f.a)(y).getInstance().getLogger(e),T(),e}fe.__dashjs_factory_name="EventController";var de=c.a.getSingletonFactory(fe),he={LEVELS:{SUGGESTION:"Suggestion",WARNING:"Warning",ERROR:"Error"},EVENTS:{NO_UTC_TIMING_ELEMENT:{key:"NO_UTC_TIMING_ELEMENT",message:"No UTCTiming element is present in the manifest. You may experience playback failures. For a detailed validation use https://conformance.dashif.org/"},NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE:{key:"NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE",message:'SMPTE 2052-1:2013 defines the attribute name as "imageType" and does not define "imagetype"'},INVALID_DVR_WINDOW:{key:"INVALID_DVR_WINDOW",message:"No valid segment found when applying a specification compliant DVR window calculation. Using SegmentTimeline entries as a fallback."}}};function pe(e){return function(e){if(Array.isArray(e))return ge(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return ge(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return ge(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function ge(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function me(){var e,t,n,r,i,o,c,h,p,g,E,_,T,v,S,b,I,R,N,C,w,D,O,M,P,F,x,k,G,j,Y,H,V,K,q,W,z,X,Q,$,Z,J,ee,te,re,ae,oe=this.context,ue=Object(u.a)(oe).getInstance();function ce(){!function(){try{var e=h.getStreamsInfo();if(!O&&0===e.length)throw new Error("There are no periods in the MPD");O&&e.length>0&&p.updateManifestUpdateInfo({currentTime:V.getTime(),buffered:H.getBufferRange(),presentationStartTime:e[0].start,clientTimeOffset:w.getClientTimeOffset()}),D.length>0&&function(e){if(0===e.length)return void t.warn("No periods included in the current manifest. Skipping the filtering of outdated stream objects.");D=D.filter((function(n){var r=e.filter((function(e){return e.id===n.getId()})).length>0||n.getId()===O.getId();return r||(t.debug("Removing stream ".concat(n.getId())),n.reset(!0)),r}))}(e);for(var n=[],r=0,i=e.length;r<i;r++){var a=e[r];n.push(ge(a)),p.addManifestUpdateStreamInfo(a)}Promise.all(n).then((function(){O||function e(n){Re();var r=p.getCurrentDVRInfo().range;if(r.end<r.start){re&&clearTimeout(re);var i=Math.min(1e3*(-1*(r.end-r.start)+2),2147483647);return t.debug("Waiting for ".concat(i," ms before playback can start")),ue.trigger(l.a.AST_IN_FUTURE,{delay:i}),void(re=setTimeout((function(){e(n)}),i))}ee.get().streaming.applyProducerReferenceTime&&K.calculateProducerReferenceTimeOffsets(n);var a=n[0].manifestInfo;ee.get().streaming.applyServiceDescription&&K.applyServiceDescription(a);if(h.getIsDynamic()){var o=Ge(n,a);V.computeAndSetLiveDelay(o,a)}var s=function(){var e;if(h.getIsDynamic()){var n=p.getCurrentDVRInfo(),r=n&&n.range?n.range.end:0;e=r-V.getLiveDelay();var i=n?n.range:null;if(i){var a=ke(!0);if(!isNaN(a)){t.info("Start time from URI parameters: "+a);var o=ee.get().streaming.timeShiftBuffer.calcFromSegmentTimeline?.1:0;e=Math.max(Math.min(e,a),i.start+o)}}}else{var s=et()[0].getStreamInfo();e=s.start;var u=ke(!1);isNaN(u)||(t.info("Start time from URI parameters: "+u),e=Math.max(e,u))}return e}(),u=Ie(s),c=null!==u?u:D[0];ue.trigger(l.a.INITIAL_STREAM_SWITCH,{startTime:s}),me(c,null,s),Q||(Q=setInterval((function(){!k&&V.getTimeToStreamEnd()<=0&&!V.isSeeking()&&ue.trigger(l.a.PLAYBACK_ENDED,{isLast:We().isLast})}),200))}(e),ue.trigger(l.a.STREAMS_COMPOSED),Le()})).catch((function(e){throw e}))}catch(e){C.error(new m.a(y.a.MANIFEST_ERROR_ID_NOSTREAMS_CODE,e.message+" nostreamscomposed",c.getValue())),j=!0,Ze()}}()}function fe(){te=!0}function ge(e){var t=ze(e.id);return t?t.updateData(e):(t=ne(oe).create({manifestModel:c,mediaPlayerModel:q,dashMetrics:p,manifestUpdater:i,adapter:h,timelineConverter:w,capabilities:n,capabilitiesFilter:r,errHandler:C,baseURLController:_,segmentBaseController:T,textController:P,abrController:S,playbackController:V,eventController:I,mediaController:b,protectionController:M,videoModel:H,streamInfo:e,settings:ee}),D.push(t),t.initialize(),Promise.resolve())}function me(e,n,r){try{if(k||!e||n===e&&e.getIsActive())return;k=!0,ue.trigger(l.a.PERIOD_SWITCH_STARTED,{fromStreamInfo:n?n.getStreamInfo():null,toStreamInfo:e.getStreamInfo()});var i=!1;O=e,n&&(i=Ae(e,n),n.deactivate(i)),r=isNaN(r)?!i&&n?e.getStreamInfo().start:NaN:r,t.info("Switch to stream ".concat(e.getId(),". Seektime is ").concat(r,", current playback time is ").concat(V.getTime(),". Seamless period switch is set to ").concat(i)),Z=Z.filter((function(e){return e.getId()!==O.getId()})),V.initialize(We(),!!n),H.getElement()&&ye(r,i)}catch(e){k=!1}}function ye(e,n){var r;function i(){if(Y&&"open"===Y.readyState){t.debug("MediaSource is open!"),window.URL.revokeObjectURL(r),Y.removeEventListener("sourceopen",i),Y.removeEventListener("webkitsourceopen",i),Be();var a=p.getCurrentDVRInfo();g.setSeekable(a.range.start,a.range.end),Ee(e,n)}}function a(){Y.addEventListener("sourceopen",i,!1),Y.addEventListener("webkitsourceopen",i,!1),r=g.attachMediaSource(H),t.debug("MediaSource attached to element.  Waiting on open...")}Y?n?Ee(e,n):(g.detachMediaSource(H),a()):(Y=g.createMediaSource(),a())}function Ee(e,t){O.activate(Y,t?$:void 0,e).then((function(t){if(t){var n=Object.keys(t);n.length>0&&t[n[0]].getBuffer().changeType&&(J=!0),$=t}isNaN(e)||(ue.trigger(l.a.SEEK_TARGET,{time:e},{streamId:O.getId()}),V.seek(e,!1,!0),O.startScheduleControllers()),k=!1,ue.trigger(l.a.PERIOD_SWITCH_COMPLETED,{toStreamInfo:We()})}))}function _e(e){var t=V.getTime(),n=e.seekTime,r=Ie(n);r&&r!==O?r&&r!==O&&(Te(t,n,r),function(e,t){var n=e&&!isNaN(e.seekTime)?e.seekTime:NaN,r=O.getProcessors().map((function(t){return t.prepareOuterPeriodPlaybackSeeking(e)}));Promise.all(r).then((function(){me(t,O,n)})).catch((function(e){C.error(e)}))}(e,r)):(Te(t,n),function(e){O.getProcessors().forEach((function(t){return t.prepareInnerPeriodPlaybackSeeking(e)})),Ve(B.USER_REQUEST_STOP_REASON)}(e)),Ke(U.SEEK_START_REASON)}function Te(e,t){ve()}function ve(){Z&&Z.length>0&&(Z.forEach((function(e){e.deactivate(!0)})),Z=[])}function Se(e){e.newMediaInfo.streamInfo.id===O.getId()&&(ve(),O.prepareTrackChange(e))}function Ae(e,t){try{return ee.get().streaming.buffer.reuseExistingSourceBuffers&&(t.isProtectionCompatible(e)||te)&&(J||t.isMediaCodecCompatible(e,t))}catch(e){return!1}}function be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(Y&&!e.getPreloaded()){var n=Ae(e,t);n&&e.startPreloading(Y,$).then((function(){Z.push(e)}))}}function Ie(e){if(isNaN(e))return null;for(var t=D.length,n=0;n<t;n++){var r=D[n];if(e<parseFloat((r.getStartTime()+r.getDuration()).toFixed(5)))return r}return null}function Re(){try{var e=h.getIsDynamic(),t=h.getStreamsInfo()[0].manifestInfo,n=V.getTime(),r=w.calcTimeShiftBufferWindow(D,e),i=xe();if(void 0===r.start||void 0===r.end)return;i&&0!==i.length?i.forEach((function(e){p.addDVRInfo(e.getType(),n,t,r)})):p.addDVRInfo(a.a.VIDEO,n,t,r)}catch(e){}}function Ne(e){if(X&&x){var t=q.getInitialBufferLevel(),n=[a.a.TEXT];(isNaN(t)||t<=V.getBufferLevel(n)||h.getIsDynamic()&&t>V.getLiveDelay())&&(X=!1,Ke(U.INITIAL_PLAYOUT_START_REASON),V.play())}e&&e.mediaType&&p.addBufferLevel(e.mediaType,new Date,1e3*e.bufferLevel)}function Ce(e){e.streamInfo.id===O.getId()&&e.reason&&e.reason.forceReplace&&ve(),ze(e.streamInfo.id).prepareQualityChange(e)}function we(){if(h.getIsDynamic()&&0!==V.getLiveDelay()){var e=h.getStreamsInfo();if(e.length>0){var t=e[0].manifestInfo,n=Ge(e,t);V.computeAndSetLiveDelay(n,t)}}}function De(){if(Ye()){var e=H.getPlaybackQuality();e&&p.addDroppedFrames(e)}}function Oe(){t.debug("[onPlaybackStarted]"),!X&&z&&Ke(U.RESUME_FROM_PAUSE_START_REASON),X&&(X=!1),z=!1}function Me(e){t.debug("[onPlaybackPaused]"),e.ended||(z=!0,Ve(B.USER_REQUEST_STOP_REASON))}function Pe(e){t.debug("Stream with id ".concat(e.streamInfo.id," finished buffering"));var n=e.streamInfo.isLast;Y&&n?(t.info("[onStreamBufferingCompleted] calls signalEndOfStream of mediaSourceController."),g.signalEndOfStream(Y)):Le()}function Le(){if(O&&O.getHasFinishedBuffering())for(var e=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;try{var t=e||(O||null);if(t){var n=t.getStreamInfo();return D.filter((function(e){var t=e.getStreamInfo();return t.start>n.start&&n.id!==t.id}))}}catch(e){return[]}}(O),t=0;t<e.length;){var n=e[t],r=0===t?O:e[t-1];!n.getPreloaded()&&r.getHasFinishedBuffering()&&Y&&be(n,r),t+=1}}function Fe(){Q&&(clearInterval(Q),Q=null)}function xe(){return O?O.getProcessors():[]}function Ue(e){if(O&&!O.getIsEndedEventSignaled()){O.setIsEndedEventSignaled(!0);var n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=e||(O||null);if(!t)return null;var n=t.getStreamInfo(),r=n.start,i=0,a=-1,o=NaN;for(;i<D.length;){var s=D[i],u=s.getStreamInfo(),l=u.start-r;l>0&&(isNaN(o)||l<o)&&n.id!==u.id&&(o=l,a=i),i+=1}if(a>=0)return D[a];return null}();n?(t.debug("StreamController onEnded, found next stream with id ".concat(n.getStreamInfo().id,". Switching from ").concat(O.getStreamInfo().id," to ").concat(n.getStreamInfo().id)),me(n,O,NaN)):(t.debug("StreamController no next stream found"),O.setIsEndedEventSignaled(!1)),Ve(n?B.END_OF_PERIOD_STOP_REASON:B.END_OF_CONTENT_STOP_REASON)}e&&e.isLast&&Fe()}function Be(e){var t=e||We().manifestInfo.duration;g.setDuration(t)}function ke(e){var t=v.getURIFragmentData();if(!t||!t.t)return NaN;var n=et()[0].getStreamInfo().start;t.t=t.t.split(",")[0];var r=-1!==t.t.indexOf("posix:")?"now"===t.t.substring(6)?Date.now()/1e3:parseInt(t.t.substring(6)):NaN;return e&&!isNaN(r)?r-V.getAvailabilityStartTime()/1e3:parseInt(t.t)+n}function Ge(e,t){try{var n=NaN;if(t&&!isNaN(t.maxFragmentDuration)&&isFinite(t.maxFragmentDuration))return t.maxFragmentDuration;if(e&&1===e.length){var r=e[0],i=[a.a.VIDEO,a.a.AUDIO,a.a.TEXT].reduce((function(e,t){var n=h.getMediaInfoForType(r,t);return n&&!1!==n.isFragmented&&e.push(n),e}),[]).reduce((function(e,t){var n=h.getVoRepresentations(t);return n&&n.length>0&&n.forEach((function(t){t&&e.push(t)})),e}),[]).reduce((function(e,t){var n=h.convertRepresentationToRepresentationInfo(t);return n&&n.fragmentDuration&&!isNaN(n.fragmentDuration)&&e.push(n.fragmentDuration),e}),[]);n=Math.max.apply(Math,pe(i))}return isFinite(n)?n:NaN}catch(e){return NaN}}function je(e){if(e.error)j=!0,Ze();else{t.info("Manifest updated... updating data system wide.");var n=e.manifest;h.updatePeriods(n);var i=h.getUTCTimingSources();!h.getIsDynamic()||i&&0!==i.length||ue.trigger(d.a.CONFORMANCE_VIOLATION,{level:he.LEVELS.WARNING,event:he.EVENTS.NO_UTC_TIMING_ELEMENT});var a=h.getIsDynamic()?i.concat(W.getUTCTimingSources()):i,o=N.isHTTPS(e.manifest.url);a.forEach((function(e){e.value.replace(/.*?:\/\//g,"")===ee.get().streaming.utcSynchronization.defaultTimingSource.value.replace(/.*?:\/\//g,"")&&(e.value=e.value.replace(o?new RegExp(/^(http:)?\/\//i):new RegExp(/^(https:)?\/\//i),o?"https://":"http://"),t.debug("Matching default timing source protocol to manifest protocol: ",e.value))})),r.filterUnsupportedFeatures(n).then((function(){_.initialize(n),E.attemptSync(a,h.getIsDynamic())}))}}function Ye(){return!!O&&O.getHasVideoTrack()}function He(){return!!O&&O.getHasAudioTrack()}function Ve(e,t){t=t||new Date,xe().forEach((function(n){n.finalisePlayList(t,e)})),p.addPlayList()}function Ke(e){p.createPlaylistMetrics(1e3*V.getTime(),e)}function qe(e){if(e.error){var n="";switch(e.error.code){case 1:n="MEDIA_ERR_ABORTED";break;case 2:n="MEDIA_ERR_NETWORK";break;case 3:n="MEDIA_ERR_DECODE",ae.counts.mediaErrorDecode+=1;break;case 4:n="MEDIA_ERR_SRC_NOT_SUPPORTED";break;case 5:n="MEDIA_ERR_ENCRYPTED";break;default:n="UNKNOWN"}"MEDIA_ERR_DECODE"===n&&ee.get().errors.recoverAttempts.mediaErrorDecode>=ae.counts.mediaErrorDecode?function(){t.warn("A MEDIA_ERR_DECODE occured: Resetting the MediaSource");var e=V.getTime();O.deactivate(!1),t.warn("MediaSource has been resetted. Resuming playback from time ".concat(e)),ye(e,!1)}():(G=!0,e.error.message&&(n+=" ("+e.error.message+")"),e.error.msExtendedCode&&(n+=" (0x"+(e.error.msExtendedCode>>>0).toString(16).toUpperCase()+")"),t.fatal("Video Element Error: "+n),e.error&&t.fatal(e.error),C.error(new m.a(e.error.code,n)),Ze())}}function We(){return O?O.getStreamInfo():null}function ze(e){for(var t=0,n=D.length;t<n;t++)if(D[t].getId()===e)return D[t];return null}function Xe(){if(!(o&&o.hasOwnProperty("load")&&w&&w.hasOwnProperty("initialize")&&w.hasOwnProperty("reset")&&w.hasOwnProperty("getClientTimeOffset")&&c&&C&&p&&V))throw new Error(a.a.MISSING_CONFIG_ERROR)}function Qe(e){isNaN(e.newDuration)||Be(e.newDuration)}function $e(){D=[],M=null,k=!1,O=null,G=!1,j=!1,X=!0,z=!1,x=!0,Q=null,te=!1,J=!1,Z=[],re=null,ae={counts:{mediaErrorDecode:0}}}function Ze(){Xe(),E.reset(),Ve(G||j?B.FAILURE_STOP_REASON:B.USER_REQUEST_STOP_REASON);for(var t=0,n=D?D.length:0;t<n;t++){D[t].reset(G)}ue.off(d.a.PLAYBACK_TIME_UPDATED,De,e),ue.off(d.a.PLAYBACK_SEEKING,_e,e),ue.off(d.a.PLAYBACK_ERROR,qe,e),ue.off(d.a.PLAYBACK_STARTED,Oe,e),ue.off(d.a.PLAYBACK_PAUSED,Me,e),ue.off(d.a.PLAYBACK_ENDED,Ue,e),ue.off(d.a.METRIC_ADDED,Je,e),ue.off(d.a.MANIFEST_VALIDITY_CHANGED,Qe,e),ue.off(d.a.BUFFER_LEVEL_UPDATED,Ne,e),ue.off(d.a.QUALITY_CHANGE_REQUESTED,Ce,e),l.a.KEY_SESSION_UPDATED&&ue.off(l.a.KEY_SESSION_UPDATED,fe,e),ue.off(l.a.MANIFEST_UPDATED,je,e),ue.off(l.a.STREAM_BUFFERING_COMPLETED,Pe,e),ue.off(l.a.TIME_SYNCHRONIZATION_COMPLETED,ce,e),ue.off(l.a.CURRENT_TRACK_CHANGED,Se,e),ue.off(l.a.SETTING_UPDATED_LIVE_DELAY,we,e),ue.off(l.a.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,we,e),_.reset(),i.reset(),I.reset(),p.clearAllCurrentMetrics(),c.setValue(null),o.reset(),w.reset(),R.reset(),Y&&(g.detachMediaSource(H),Y=null),H=null,M&&(M=null,F=null,c.getValue()&&ue.trigger(l.a.PROTECTION_DESTROYED,{data:c.getValue().url})),Fe(),ue.trigger(l.a.STREAM_TEARDOWN_COMPLETE),$e()}function Je(e){if(e.metric===s.a.DVR_INFO){var t=He()?a.a.AUDIO:a.a.VIDEO;e.mediaType===t&&g.setSeekable(e.value.range.start,e.value.range.end)}}function et(){return D}return e={initialize:function(t,n){Xe(),x=t,F=n,w.initialize(),(i=ie(oe).create()).setConfig({manifestModel:c,adapter:h,manifestLoader:o,errHandler:C,settings:ee}),i.initialize(),(I=de(oe).getInstance()).setConfig({manifestUpdater:i,playbackController:V,settings:ee}),I.start(),E.setConfig({dashMetrics:p,baseURLController:_,errHandler:C,settings:ee}),E.initialize(),M&&(ue.trigger(l.a.PROTECTION_CREATED,{controller:M}),M.setMediaElement(H.getElement()),F&&M.setProtectionData(F)),function(){ue.on(d.a.PLAYBACK_TIME_UPDATED,De,e),ue.on(d.a.PLAYBACK_SEEKING,_e,e),ue.on(d.a.PLAYBACK_ERROR,qe,e),ue.on(d.a.PLAYBACK_STARTED,Oe,e),ue.on(d.a.PLAYBACK_PAUSED,Me,e),ue.on(d.a.PLAYBACK_ENDED,Ue,e),ue.on(d.a.METRIC_ADDED,Je,e),ue.on(d.a.MANIFEST_VALIDITY_CHANGED,Qe,e),ue.on(d.a.BUFFER_LEVEL_UPDATED,Ne,e),ue.on(d.a.QUALITY_CHANGE_REQUESTED,Ce,e),l.a.KEY_SESSION_UPDATED&&ue.on(l.a.KEY_SESSION_UPDATED,fe,e);ue.on(l.a.MANIFEST_UPDATED,je,e),ue.on(l.a.STREAM_BUFFERING_COMPLETED,Pe,e),ue.on(l.a.TIME_SYNCHRONIZATION_COMPLETED,ce,e),ue.on(l.a.CURRENT_TRACK_CHANGED,Se,e),ue.on(l.a.SETTING_UPDATED_LIVE_DELAY,we,e),ue.on(l.a.SETTING_UPDATED_LIVE_DELAY_FRAGMENT_COUNT,we,e)}()},getActiveStreamInfo:We,addDVRMetric:Re,hasVideoTrack:Ye,hasAudioTrack:He,getStreamById:ze,getStreamForTime:Ie,getTimeRelativeToStreamId:function(e,t){for(var n=null,r=0,i=0,a=null,o=0;o<D.length;o++){if(i=(n=D[o]).getStartTime(),a=n.getDuration(),Number.isFinite(i)&&(r=i),n.getId()===t)return e-r;Number.isFinite(a)&&(r+=a)}return null},load:function(e){Xe(),o.load(e)},loadWithManifest:function(e){!function(){if(!i||!i.hasOwnProperty("setManifest"))throw new Error("initialize function has to be called previously")}(),i.setManifest(e)},getActiveStreamProcessors:xe,setConfig:function(e){e&&(e.capabilities&&(n=e.capabilities),e.capabilitiesFilter&&(r=e.capabilitiesFilter),e.manifestLoader&&(o=e.manifestLoader),e.manifestModel&&(c=e.manifestModel),e.mediaPlayerModel&&(q=e.mediaPlayerModel),e.customParametersModel&&(W=e.customParametersModel),e.protectionController&&(M=e.protectionController),e.adapter&&(h=e.adapter),e.dashMetrics&&(p=e.dashMetrics),e.errHandler&&(C=e.errHandler),e.timelineConverter&&(w=e.timelineConverter),e.videoModel&&(H=e.videoModel),e.playbackController&&(V=e.playbackController),e.serviceDescriptionController&&(K=e.serviceDescriptionController),e.textController&&(P=e.textController),e.abrController&&(S=e.abrController),e.mediaController&&(b=e.mediaController),e.settings&&(ee=e.settings),e.baseURLController&&(_=e.baseURLController),e.uriFragmentModel&&(v=e.uriFragmentModel),e.segmentBaseController&&(T=e.segmentBaseController))},setProtectionData:function(e){F=e,M&&M.setProtectionData(F)},getIsStreamSwitchInProgress:function(){return k},switchToVideoElement:function(e){O&&(V.initialize(We()),ye(e,!1))},getHasMediaOrInitialisationError:function(){return G||j},getStreams:et,getActiveStream:function(){return O},getInitialPlayback:function(){return X},getAutoPlay:function(){return x},reset:Ze},t=Object(f.a)(oe).getInstance().getLogger(e),E=se(oe).getInstance(),g=le(oe).getInstance(),R=A(oe).getInstance(),N=Object(L.a)(oe).getInstance(),$e(),e}me.__dashjs_factory_name="StreamController";var ye=c.a.getSingletonFactory(me);function Ee(){var e,t,n,r,i,a,o,s,c,d,h,p,g=this.context,m=Object(u.a)(g).getInstance();function y(){p.debug("Stopping the gap controller"),i&&(clearInterval(i),i=null),function(){m.off(l.a.WALLCLOCK_TIME_UPDATED,S,this),m.off(l.a.INITIAL_STREAM_SWITCH,v,this),m.off(l.a.PLAYBACK_SEEKING,E,this),m.off(l.a.BUFFER_REPLACEMENT_STARTED,_,e),m.off(l.a.TRACK_CHANGE_RENDERED,T,e)}(),i=null,a=NaN,r=0,d=null,h={}}function E(){d&&(clearTimeout(d),d=null)}function _(e){try{if(e.streamId!==s.getActiveStreamInfo().id||!e.mediaType)return;e.streamId===s.getActiveStreamInfo().id&&(h[e.mediaType]=!0)}catch(e){p.error(e)}}function T(e){e&&e.mediaType&&(h[e.mediaType]=!1)}function v(){i||function(){try{i||(p.debug("Starting the gap controller"),i=setInterval((function(){A()&&N(o.getTime())}),100))}catch(e){}}()}function S(){if(A(n.get().streaming.gaps.enableSeekFix)&&++r>=10){var e=o.getTime();t===e?N(e,!0):(t=e,a=NaN),r=0}}function A(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(!s.getActiveStream())return!1;var t=Object.keys(h).some((function(e){return h[e]})),r=!!e&&b();return!t&&n.get().streaming.gaps.jumpGaps&&s.getActiveStreamProcessors().length>0&&(!o.isSeeking()||r)&&!o.isPaused()&&!s.getIsStreamSwitchInProgress()&&!s.getHasMediaOrInitialisationError()}function b(){var e=s.getActiveStream(),t=parseFloat((e.getStartTime()+e.getDuration()).toFixed(5));return o.getTime()+n.get().streaming.gaps.threshold>=t}function I(e,t){try{if(!e||e.length<=1&&t>0)return NaN;for(var r=NaN,i=0;isNaN(r)&&i<e.length;){var a=i>0?e.end(i-1):0;t<e.start(i)&&a-t<n.get().streaming.gaps.threshold&&(r=i),i+=1}return r}catch(e){return null}}function R(e,t){for(var n=0,r=e.length;n<r;n++)if(t>=e.start(n)&&t<=e.end(n))return!0;return!1}function N(e){var t,r=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=n.get().streaming.gaps.enableStallFix,u=n.get().streaming.gaps.stallSeek,l=n.get().streaming.gaps.smallGapLimit,f=n.get().streaming.gaps.jumpLargeGaps,h=c.getBufferRange(),g=NaN,m=!1;if(t=I(h,e),!isNaN(t)){var y=h.start(t),E=y-e;E>0&&(E<=l||f)&&(g=y)}var _=o.getTimeToStreamEnd();if(isNaN(g)&&r&&isFinite(_)&&!isNaN(_)&&_<l&&(g=parseFloat(o.getStreamEndTime().toFixed(5)),m=!0),i&&isNaN(g)&&r&&isNaN(t)&&R(h,e)&&(0===u?(p.warn("Toggle play pause to break stall"),c.pause(),c.play()):(p.warn("Jumping ".concat(u,"s to break stall")),g=e+u)),g>0&&a!==g&&g>e&&!d){var T=g-e;if(m){var v=s.getStreamForTime(g),S=v&&!!v.getPreloaded();p.warn("Jumping to end of stream because of gap from ".concat(e," to ").concat(g,". Gap duration: ").concat(T)),o.seek(g,!0,S)}else{var A=o.getIsDynamic(),b=t>0?h.end(t-1):e,N=A?1e3*Math.max(0,T-.1):0;d=window.setTimeout((function(){o.seek(g,!0,!0),p.warn("Jumping gap occuring in period ".concat(s.getActiveStream().getStreamId()," starting at ").concat(b," and ending at ").concat(g,". Jumping by: ").concat(g-b)),d=null}),N)}a=g}}return e={reset:y,setConfig:function(e){e&&(e.settings&&(n=e.settings),e.playbackController&&(o=e.playbackController),e.streamController&&(s=e.streamController),e.videoModel&&(c=e.videoModel))},initialize:function(){!function(){m.on(l.a.WALLCLOCK_TIME_UPDATED,S,this),m.on(l.a.INITIAL_STREAM_SWITCH,v,this),m.on(l.a.PLAYBACK_SEEKING,E,this),m.on(l.a.BUFFER_REPLACEMENT_STARTED,_,e),m.on(l.a.TRACK_CHANGE_RENDERED,T,e)}()}},p=Object(f.a)(g).getInstance().getLogger(e),y(),e}Ee.__dashjs_factory_name="GapController";var _e=c.a.getSingletonFactory(Ee);function Te(){var e,t,n,r,i,o,c,h,p,g,m,y=this.context,E=Object(u.a)(y).getInstance();function _(){t=!1;var e="undefined"!=typeof navigator?navigator.userAgent.toLowerCase():"",r=/safari/.test(e)&&!/chrome/.test(e);n=r?.25:.02}function T(){t=!1}function v(e){if(e.streamId===o.getActiveStreamInfo().id&&g){var t=c.getLiveDelay();c.getBufferLevel()>t/2&&(g=!1)}}function S(e){e.streamId===o.getActiveStreamInfo().id&&(g=e.state===s.a.BUFFER_EMPTY)}function A(){h.getCatchupModeEnabled()||r.setPlaybackRate(1)}function b(){c.getIsDynamic()&&h.getCatchupModeEnabled()&&h.getCatchupPlaybackRate()>0&&!c.isPaused()&&!c.isSeeking()&&function(){try{var e=h.getLiveCatchupLatencyThreshold();if(!c.getTime()>0||t||!isNaN(e)&&c.getCurrentLiveLatency()>=e)return!1;if(R()===a.a.LIVE_CATCHUP_MODE_LOLP){var n=c.getBufferLevel(),r=i.get().streaming.liveCatchup.playbackBufferMin;return function(e,t){try{return Math.abs(I())>0||e<t}catch(e){return!1}}(n,r)}return function(){try{return Math.abs(I())>0}catch(e){return!1}}()}catch(e){return!1}}()&&function(){if(t)return;if(r){var e,s=r.getPlaybackRate(),u=h.getCatchupPlaybackRate(),l=c.getBufferLevel(),f=I(),d=h.getCatchupMaxDrift();if(!isNaN(d)&&d>0&&f>d)m.info("[CatchupController]: Low Latency catchup mechanism. Latency too high, doing a seek to live point"),t=!0,T=o&&o.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,v=p.getCurrentDVRInfo(T),(S=v?v.range:null)&&!isNaN(S.end)&&c.seek(S.end-c.getLiveDelay(),!0,!1);else{var y=c.getCurrentLiveLatency(),E=c.getLiveDelay();if(R()===a.a.LIVE_CATCHUP_MODE_LOLP){var _=i.get().streaming.liveCatchup.playbackBufferMin;e=function(e,t,r,i,a,o){var s,u=e;if(a<i){var l=5*(a-i),c=2*u/(1+Math.pow(Math.E,-l));s=1-u+c,m.debug("[LoL+ playback control_buffer-based] bufferLevel: "+a+", newRate: "+s)}else{if(Math.abs(t-r)<=.02*r)s=1;else{var f=5*(t-r),d=2*u/(1+Math.pow(Math.E,-f));s=1-u+d}m.debug("[LoL+ playback control_latency-based] latency: "+t+", newRate: "+s)}Math.abs(o-s)<=n&&(s=null);return s}(u,y,E,_,l,s)}else e=function(e,t,r,i,a){if(g)return 1;var o=e,s=t-r,u=5*s,l=2*o/(1+Math.pow(Math.E,-u)),f=1-o+l;c.getPlaybackStalled()&&i<=r/2&&s>0&&(f=1);Math.abs(a-f)<=n&&(f=null);return f}(u,y,E,l,s);e&&(m.debug("[CatchupController]: Setting playback rate to ".concat(e)),r.setPlaybackRate(e))}}var T,v,S}()}function I(){return c.getCurrentLiveLatency()-c.getLiveDelay()}function R(){var e=i.get().streaming.liveCatchup.playbackBufferMin;return i.get().streaming.liveCatchup.mode!==a.a.LIVE_CATCHUP_MODE_LOLP||null===e||isNaN(e)?a.a.LIVE_CATCHUP_MODE_DEFAULT:a.a.LIVE_CATCHUP_MODE_LOLP}return e={reset:function(){E.off(d.a.BUFFER_LEVEL_UPDATED,v,e),E.off(d.a.BUFFER_LEVEL_STATE_CHANGED,S,e),E.off(d.a.PLAYBACK_PROGRESS,b,e),E.off(d.a.PLAYBACK_TIME_UPDATED,b,e),E.off(d.a.PLAYBACK_SEEKED,b,e),E.off(l.a.SETTING_UPDATED_CATCHUP_ENABLED,A,e),_(),r.setPlaybackRate(1,!0)},setConfig:function(e){e&&(e.settings&&(i=e.settings),e.videoModel&&(r=e.videoModel),e.streamController&&(o=e.streamController),e.playbackController&&(c=e.playbackController),e.dashMetrics&&(p=e.dashMetrics),e.mediaPlayerModel&&(h=e.mediaPlayerModel))},initialize:function(){E.on(d.a.BUFFER_LEVEL_UPDATED,v,e),E.on(d.a.BUFFER_LEVEL_STATE_CHANGED,S,e),E.on(d.a.PLAYBACK_PROGRESS,b,e),E.on(d.a.PLAYBACK_TIME_UPDATED,b,e),E.on(d.a.PLAYBACK_SEEKED,T,e),E.on(l.a.SETTING_UPDATED_CATCHUP_ENABLED,A,e)}},m=Object(f.a)(y).getInstance().getLogger(e),_(),e}Te.__dashjs_factory_name="CatchupController";var ve=c.a.getSingletonFactory(Te),Se=[a.a.SERVICE_DESCRIPTION_DVB_LL_SCHEME],Ae="video",be="audio",Ie="any",Re="all";function Ne(){var e,t,n,r,i,s=this.context;function u(){t={liveDelay:NaN,liveCatchup:{maxDrift:NaN,playbackRate:NaN},minBitrate:{},maxBitrate:{},initialBitrate:{}},n=[]}function l(e,n,i){try{t[e][n]=i/1e3}catch(e){r.error(e)}}return e={getServiceDescriptionSettings:function(){return t},getProducerReferenceTimeOffsets:function(){return n},calculateProducerReferenceTimeOffsets:function(e){try{var t=[];if(e&&e.length>0){var s=[a.a.VIDEO,a.a.AUDIO,a.a.TEXT],u=i.getAvailabilityStartTime()/1e3;e.forEach((function(e){var n=s.reduce((function(t,n){return t=t.concat(i.getAllMediaInfoForType(e,n))}),[]).reduce((function(t,n){return i.getProducerReferenceTimes(e,n).forEach((function(r){var a=i.getVoRepresentations(n);if(a&&a.length>0&&a[0].adaptation&&a[0].segmentInfoType===o.a.SEGMENT_TEMPLATE){var s=a[0],l=new Date(r[o.a.WALL_CLOCK_TIME]).getTime()/1e3-(r[o.a.PRESENTATION_TIME]/s[o.a.TIMESCALE]-s[o.a.PRESENTATION_TIME_OFFSET]+e.start),c=u-l;t.push({id:r[o.a.ID],to:c})}})),t}),[]);t=t.concat(n)}))}n=t}catch(e){r.error(e),n=[]}},applyServiceDescription:function(e){if(e&&e.serviceDescriptions){var i=e.serviceDescriptions.filter((function(e){return Se.includes(e.schemeIdUri)})),o=e.serviceDescriptions.filter((function(e){return null==e.schemeIdUri})),s=i.length>0?i[i.length-1]:o[o.length-1];s&&(s.latency&&s.latency.target>0&&function(e){var i;i=e.schemeIdUri===a.a.SERVICE_DESCRIPTION_DVB_LL_SCHEME?function(e){var t=e.latency.target/1e3,n=!isNaN(e.latency.max)&&e.latency.max>e.latency.target?(e.latency.max-e.latency.target+500)/1e3:NaN,r=e.latency.referenceId||NaN;return{liveDelay:t,maxDrift:n,referenceId:r}}(e):function(e){var t=e.latency.target/1e3,n=!isNaN(e.latency.max)&&e.latency.max>e.latency.target?(e.latency.max-e.latency.target+500)/1e3:NaN,r=e.latency.referenceId||NaN;return{liveDelay:t,maxDrift:n,referenceId:r}}(e);if(n.length>0){var o=function(e){var t,r=0,i=n.filter((function(t){return t.id===e.referenceId}));0===i.length?(r=n.length>0?n[0].to:0,t=n[0].id||NaN):(r=i[0].to||0,t=i[0].id||NaN);return{to:r,id:t}}(i),s=o.to,u=o.id;t.liveDelay=i.liveDelay-s,t.liveCatchup.maxDrift=i.maxDrift,r.debug("\n                Found latency properties coming from service description. Applied time offset of ".concat(s," from ProducerReferenceTime element with id ").concat(u,".\n                Live Delay: ").concat(i.liveDelay-s,", Live catchup max drift: ").concat(i.maxDrift,"\n            "))}else t.liveDelay=i.liveDelay,t.liveCatchup.maxDrift=i.maxDrift,r.debug("Found latency properties coming from service description: Live Delay: ".concat(i.liveDelay,", Live catchup max drift: ").concat(i.maxDrift))}(s),s.playbackRate&&s.playbackRate.max>1&&function(e){var n=Math.round(1e3*(e.playbackRate.max-1))/1e3;t.liveCatchup.playbackRate=n,r.debug("Found latency properties coming from service description: Live catchup playback rate: ".concat(n))}(s),s.operatingQuality,s.operatingBandwidth&&function(e){if(!e||!e.operatingBandwidth||!e.operatingBandwidth.mediaType||e.operatingBandwidth.mediaType===Re)return;var t={};t.minBandwidth=e.operatingBandwidth.min,t.maxBandwidth=e.operatingBandwidth.max,t.targetBandwidth=e.operatingBandwidth.target;var n=[];e.operatingBandwidth.mediaType===Ae||e.operatingBandwidth.mediaType===be?n.push(e.operatingBandwidth.mediaType):e.operatingBandwidth.mediaType===Ie&&(n.push(be),n.push(Ae));n.forEach((function(e){isNaN(t.minBandwidth)||l("minBitrate",e,t.minBandwidth),isNaN(t.maxBandwidth)||l("maxBitrate",e,t.maxBandwidth),isNaN(t.targetBandwidth)||l("initialBitrate",e,t.targetBandwidth)}))}(s))}},reset:function(){u()},setConfig:function(e){e&&e.adapter&&(i=e.adapter)}},r=Object(f.a)(s).getInstance().getLogger(e),u(),e}Ne.__dashjs_factory_name="ServiceDescriptionController";var Ce=c.a.getSingletonFactory(Ne);function we(){var e,t,n,r,i,o,s,c,d=this.context,h=Object(u.a)(d).getInstance();function p(e,t){return e&&n[t]&&n[t][e]?n[t][e].list:[]}function g(e,t){return e&&n[t]&&n[t][e]?n[t][e].current:null}function m(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(e&&e.streamInfo){var i=e.type,s=e.streamInfo,u=s.id,f=g(i,u);if(n[u]&&n[u][i]&&!_(e,f)&&(n[u][i].current=e,n[u][i].current&&(i!==a.a.TEXT||i===a.a.TEXT&&e.isFragmented)&&h.trigger(l.a.CURRENT_TRACK_CHANGED,{oldMediaInfo:f,newMediaInfo:e,switchMode:r.get().streaming.trackSwitchMode[i]},{streamId:u}),!t)){var d=v(e);if(!d||!n[u][i].storeLastSettings)return;d.roles&&(d.role=d.roles[0],delete d.roles),d.accessibility&&(d.accessibility=d.accessibility[0]),d.audioChannelConfiguration&&(d.audioChannelConfiguration=d.audioChannelConfiguration[0]),o[i]=d,c.setSavedMediaSettings(i,d)}}}function y(e,t){e&&t&&(i[e]=t)}function E(e){return e?i[e]:null}function _(e,t){if(!e&&!t)return!0;if(!e||!t)return!1;var n=e.id===t.id,r=e.viewpoint===t.viewpoint,i=e.lang===t.lang,a=e.codec===t.codec,o=e.roles.toString()===t.roles.toString(),s=e.accessibility.toString()===t.accessibility.toString(),u=e.audioChannelConfiguration.toString()===t.audioChannelConfiguration.toString();return n&&a&&r&&i&&o&&s&&u}function T(){n={},o={},i={audio:null,video:null,text:null}}function v(e){var t={lang:e.lang,viewpoint:e.viewpoint,roles:e.roles,accessibility:e.accessibility,audioChannelConfiguration:e.audioChannelConfiguration};return t.lang||t.viewpoint||t.role&&t.role.length>0||t.accessibility&&t.accessibility.length>0||t.audioChannelConfiguration&&t.audioChannelConfiguration.length>0?t:null}function S(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=!e.lang||t.lang.match(e.lang),i=void 0===e.index||null===e.index||t.index===e.index,o=!e.viewpoint||e.viewpoint===t.viewpoint,s=!e.role||!!t.roles.filter((function(t){return t===e.role}))[0],u=!e.accessibility||!!t.accessibility.filter((function(t){return t===e.accessibility}))[0],l=!e.audioChannelConfiguration||!!t.audioChannelConfiguration.filter((function(t){return t===e.audioChannelConfiguration}))[0];return r&&i&&o&&(s||t.type===a.a.AUDIO&&n)&&u&&l}function A(e){var t,n=0,r=[];return e.forEach((function(e){(t=Math.max.apply(Math,e.bitrateList.map((function(e){return e.bandwidth}))))>n?(n=t,r=[e]):t===n&&r.push(e)})),r}function b(e){var t,n=1/0,r=[];return e.forEach((function(e){var i=e.bitrateList.reduce((function(e,t){var n=Math.max(1,t.width*t.height);return e+t.bandwidth/n}),0);(t=i/e.bitrateList.length)<n?(n=t,r=[e]):t===n&&r.push(e)})),r}function I(e){var t,n=0,r=[];return e.forEach((function(e){(t=e.representationCount)>n?(n=t,r=[e]):t===n&&r.push(e)})),r}function R(e,n){if(e===a.a.TEXT)return n[0];var i,o=r.get().streaming.selectionModeForInitialTrack,u=s.getCustomInitialTrackSelectionFunction();if(u&&"function"==typeof u)i=u(n);else switch(o){case a.a.TRACK_SELECTION_MODE_HIGHEST_SELECTION_PRIORITY:i=function(e){var t=(n=e,r=0,i=[],n.forEach((function(e){isNaN(e.selectionPriority)||(e.selectionPriority>r?(r=e.selectionPriority,i=[e]):e.selectionPriority===r&&i.push(e))})),i);var n,r,i;t.length>1&&(t=A(t));t.length>1&&(t=I(t));return t}(n);break;case a.a.TRACK_SELECTION_MODE_HIGHEST_BITRATE:i=function(e){var t=A(e);t.length>1&&(t=I(t));return t}(n);break;case a.a.TRACK_SELECTION_MODE_FIRST_TRACK:i=N(n);break;case a.a.TRACK_SELECTION_MODE_HIGHEST_EFFICIENCY:i=function(e){var t=b(e);t.length>1&&(t=A(t));return t}(n);break;case a.a.TRACK_SELECTION_MODE_WIDEST_RANGE:i=function(e){var t=I(e);t.length>1&&(t=A(e));return t}(n);break;default:t.warn("Track selection mode ".concat(o," is not supported. Falling back to TRACK_SELECTION_MODE_FIRST_TRACK")),i=N(n)}return i.length>0?i[0]:n[0]}function N(e){return e[0]}return e={setInitialMediaSettingsForType:function(e,t){var n=o[e]||E(e),r=p(e,t.id),i=[];n||(n=c.getSavedMediaSettings(e),y(e,n)),r&&0!==r.length&&(n&&r.forEach((function(t){S(n,t,!!o[e])&&i.push(t)})),0===i.length?m(R(e,r),!0):i.length>1?m(R(e,i,o[e])):m(i[0]))},addTrack:function(e){if(e){var t=e.type;if((r=t)===a.a.AUDIO||r===a.a.VIDEO||r===a.a.TEXT||r===a.a.IMAGE){var r,i=e.streamInfo.id;n[i]||(n[i]={audio:{list:[],storeLastSettings:!0,current:null},video:{list:[],storeLastSettings:!0,current:null},text:{list:[],storeLastSettings:!0,current:null},image:{list:[],storeLastSettings:!0,current:null}});for(var o=n[i][t].list,s=0,u=o.length;s<u;++s)if(_(o[s],e))return;o.push(e)}}},getTracksFor:p,getCurrentTrackFor:g,isCurrentTrack:function(e){if(!e)return!1;var t=e.type,r=e.streamInfo.id;return n[r]&&n[r][t]&&_(n[r][t].current,e)},setTrack:m,selectInitialTrack:R,setInitialSettings:y,getInitialSettings:E,getTracksWithHighestBitrate:A,getTracksWithHighestEfficiency:b,getTracksWithWidestRange:I,isTracksEqual:_,matchSettings:S,saveTextSettingsDisabled:function(){c.setSavedMediaSettings(a.a.TEXT,null)},setConfig:function(e){e&&(e.domStorage&&(c=e.domStorage),e.settings&&(r=e.settings),e.customParametersModel&&(s=e.customParametersModel))},reset:T},t=Object(f.a)(d).getInstance().getLogger(e),T(),e}we.__dashjs_factory_name="MediaController";var De=c.a.getSingletonFactory(we);c.a.updateSingletonFactory(we.__dashjs_factory_name,De);var Oe=De,Me=n(44);var Pe=function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.data={baseUrls:t||null,selectedIdx:n||NaN},this.children=[]};function Le(){var e,t,n,r=this.context,i=Object(Me.a)(r).getInstance();function a(e,t,r){var a=n.getBaseURLsFromElement(r);e[t]?i.areEqual(a,e[t].data.baseUrls)||(e[t].data.baseUrls=a,e[t].data.selectedIdx=NaN):e[t]=new Pe(a)}function o(e){!function(){if(!n||!n.hasOwnProperty("getBaseURLsFromElement")||!n.hasOwnProperty("getRepresentationSortFunction"))throw new Error("setConfig function has to be called previously")}();var r=n.getBaseURLsFromElement(e);i.areEqual(r,t.data.baseUrls)||(t.data.baseUrls=r,t.data.selectedIdx=NaN),e&&e.Period_asArray&&e.Period_asArray.forEach((function(e,r){a(t.children,r,e),e.AdaptationSet_asArray&&e.AdaptationSet_asArray.forEach((function(e,i){a(t.children[r].children,i,e),e.Representation_asArray&&e.Representation_asArray.sort(n.getRepresentationSortFunction()).forEach((function(e,n){a(t.children[r].children[i].children,n,e)}))}))}))}function s(){t=new Pe}return e={reset:s,update:function(e){o(e)},getForPath:function(e){var n=t,r=[n.data];return e&&e.forEach((function(e){(n=n.children[e])&&r.push(n.data)})),r.filter((function(e){return e.baseUrls.length}))},invalidateSelectedIndexes:function(e){!function e(n,r){var i=r||t;n(i.data),i.children&&i.children.forEach((function(t){return e(n,t)}))}((function(t){isNaN(t.selectedIdx)||e===t.baseUrls[t.selectedIdx].serviceLocation&&(t.selectedIdx=NaN)}))},setConfig:function(e){e.adapter&&(n=e.adapter)}},s(),e}Le.__dashjs_factory_name="BaseURLTreeModel";var Fe=c.a.getClassFactory(Le);function xe(e){var t=(e=e||{}).blacklistController;return{select:function(e){return e&&function(e){var t,n,r=0,i=[],a=0;if((n=e.sort((function(e,t){var n=e.dvb_priority-t.dvb_priority;return isNaN(n)?0:n})).filter((function(e,t,n){return!t||n[0].dvb_priority&&e.dvb_priority&&n[0].dvb_priority===e.dvb_priority}))).length)return n.length>1&&(n.forEach((function(e){r+=e.dvb_weight,i.push(r)})),t=Math.floor(Math.random()*(r-1)),i.every((function(e,n){return a=n,!(t<e)}))),n[a]}((n=[],e.filter((function(e){return!t.contains(e.serviceLocation)||(e.dvb_priority&&n.push(e.dvb_priority),!1)})).filter((function(e){return!n.length||!e.dvb_priority||-1===n.indexOf(e.dvb_priority)}))));var n}}}xe.__dashjs_factory_name="DVBSelector";var Ue=c.a.getClassFactory(xe);function Be(e){var t=(e=e||{}).blacklistController;return{select:function(e){var n,r=0;return e&&e.some((function(e,n){return r=n,!t.contains(e.serviceLocation)}))&&(n=e[r]),n}}}Be.__dashjs_factory_name="BasicSelector";var ke=c.a.getClassFactory(Be);function Ge(){var e,t,n,r,i,a=this.context,o=Object(u.a)(a).getInstance();function s(){t.reset()}return e={chooseSelector:function(e){Object(O.b)(e,"boolean"),i=e?r:n},select:function(e){if(e){var t=e.baseUrls,r=e.selectedIdx;if(!isNaN(r))return t[r];var a=i.select(t);return a?(e.selectedIdx=t.indexOf(a),a):(o.trigger(l.a.URL_RESOLUTION_FAILED,{error:new m.a(y.a.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE,y.a.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)}),void(i===n&&s()))}},reset:s,setConfig:function(e){e.selector&&(i=e.selector)}},t=J(a).create({updateEventName:l.a.SERVICE_LOCATION_BLACKLIST_CHANGED,addBlacklistEventName:l.a.SERVICE_LOCATION_BLACKLIST_ADD}),n=ke(a).create({blacklistController:t}),r=Ue(a).create({blacklistController:t}),i=n,e}Ge.__dashjs_factory_name="BaseURLSelector";var je=c.a.getClassFactory(Ge),Ye=n(39);function He(){var e,t,n,r,i=this.context,a=Object(u.a)(i).getInstance(),o=Object(L.a)(i).getInstance();function s(e){n.invalidateSelectedIndexes(e.entry)}return e={reset:function(){n.reset(),r.reset()},initialize:function(e){var i;n.setConfig({adapter:t}),i=e,n.update(i),r.chooseSelector(t.getIsDVB(i))},resolve:function(e){var t=n.getForPath(e).reduce((function(e,t){var n=r.select(t);return n?(o.isRelative(n.url)?e.url=o.resolve(n.url,e.url):(e.url=n.url,e.serviceLocation=n.serviceLocation),e.availabilityTimeOffset=n.availabilityTimeOffset,e.availabilityTimeComplete=n.availabilityTimeComplete,e):new Ye.a}),new Ye.a);if(!o.isRelative(t.url))return t},setConfig:function(e){e.baseURLTreeModel&&(n=e.baseURLTreeModel),e.baseURLSelector&&(r=e.baseURLSelector),e.adapter&&(t=e.adapter)}},n=Fe(i).create(),r=je(i).create(),a.on(l.a.SERVICE_LOCATION_BLACKLIST_CHANGED,s,e),e}He.__dashjs_factory_name="BaseURLController";var Ve=c.a.getClassFactory(He),Ke=n(21),qe=n(17);function We(e){return(We="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ze(e,t){return(ze=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Xe(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=$e(e);if(t){var i=$e(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return Qe(this,n)}}function Qe(e,t){return!t||"object"!==We(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function $e(e){return($e=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var Ze=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ze(e,t)}(n,e);var t=Xe(n);function n(e,r){var i;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(i=t.call(this)).url=e||null,i.type=r||null,i.mediaType=a.a.STREAM,i.responseType="",i}return n}(qe.a);function Je(e){e=e||{};var t=this.context,n=Object(u.a)(t).getInstance(),r=Object(Ke.a)(t).create({errHandler:e.errHandler,dashMetrics:e.dashMetrics,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,errors:y.a});return{load:function(e,t,i){var a=function(r,a){t.resolved=!0,t.resolvedContent=r||null,n.trigger(l.a.XLINK_ELEMENT_LOADED,{element:t,resolveObject:i,error:r||a?null:new m.a(y.a.XLINK_LOADER_LOADING_FAILURE_ERROR_CODE,y.a.XLINK_LOADER_LOADING_FAILURE_ERROR_MESSAGE+e)})};if("urn:mpeg:dash:resolve-to-zero:2013"===e)a(null,!0);else{var o=new Ze(e,_.a.XLINK_EXPANSION_TYPE);r.load({request:o,success:function(e){a(e)},error:function(){a(null)}})}},reset:function(){r&&(r.abort(),r=null)}}}Je.__dashjs_factory_name="XlinkLoader";var et=c.a.getClassFactory(Je),tt=n(45);function nt(e){e=e||{};var t,n,r,i,a,s,c=this.context,f=Object(u.a)(c).getInstance(),d=Object(L.a)(c).getInstance();function h(e,t,n){var r,i,a={};a.elements=e,a.type=t,a.resolveType=n,0===a.elements.length&&g(a);for(var o=0;o<a.elements.length;o++)r=a.elements[o],i=d.isHTTPURL(r.url)?r.url:r.originalContent.BaseURL+r.url,s.load(i,r,a)}function p(e){var t,n,r="";if(t=e.element,n=e.resolveObject,t.resolvedContent){var i=0;0===t.resolvedContent.indexOf("<?xml")&&(i=t.resolvedContent.indexOf("?>")+2),r=t.resolvedContent.substr(0,i)+"<response>"+t.resolvedContent.substr(i)+"</response>",t.resolvedContent=a.xml_str2json(r)}(function(e){var t;for(t=0;t<e.elements.length;t++)if(!1===e.elements[t].resolved)return!1;return!0})(n)&&g(n)}function g(e){var t,n,a=[];if(function(e){var t,n,a,o,s,u,l=[];for(o=e.elements.length-1;o>=0;o--){if(t=e.elements[o],n=t.type+"_asArray",t.resolvedContent){if(t.resolvedContent)for(s=0;s<t.resolvedContent[n].length;s++)a=t.resolvedContent[n][s],l.push(a)}else delete t.originalContent["xlink:actuate"],delete t.originalContent["xlink:href"],l.push(t.originalContent);for(t.parentElement[n].splice(t.index,1),u=0;u<l.length;u++)t.parentElement[n].splice(t.index+u,0,l[u]);l=[]}e.elements.length>0&&r.run(i)}(e),"onActuate"===e.resolveType&&f.trigger(l.a.XLINK_READY,{manifest:i}),"onLoad"===e.resolveType)switch(e.type){case o.a.PERIOD:for(t=0;t<i[o.a.PERIOD+"_asArray"].length;t++)(n=i[o.a.PERIOD+"_asArray"][t]).hasOwnProperty(o.a.ADAPTATION_SET+"_asArray")&&(a=a.concat(m(n[o.a.ADAPTATION_SET+"_asArray"],n,o.a.ADAPTATION_SET,"onLoad"))),n.hasOwnProperty(o.a.EVENT_STREAM+"_asArray")&&(a=a.concat(m(n[o.a.EVENT_STREAM+"_asArray"],n,o.a.EVENT_STREAM,"onLoad")));h(a,o.a.ADAPTATION_SET,"onLoad");break;case o.a.ADAPTATION_SET:f.trigger(l.a.XLINK_READY,{manifest:i})}}function m(e,t,n,r){var i,a,o,s=[];for(a=e.length-1;a>=0;a--)(i=e[a]).hasOwnProperty("xlink:href")&&"urn:mpeg:dash:resolve-to-zero:2013"===i["xlink:href"]&&e.splice(a,1);for(a=0;a<e.length;a++)(i=e[a]).hasOwnProperty("xlink:href")&&i.hasOwnProperty("xlink:actuate")&&i["xlink:actuate"]===r&&(o=y(i["xlink:href"],t,n,a,r,i),s.push(o));return s}function y(e,t,n,r,i,a){return{url:e,parentElement:t,type:n,index:r,resolveType:i,originalContent:a,resolvedContent:null,resolved:!1}}return t={resolveManifestOnLoad:function(e){a=new tt.a({escapeMode:!1,attributePrefix:"",arrayAccessForm:"property",emptyNodeForm:"object",stripWhitespaces:!1,enableToStringFunc:!1,ignoreRoot:!0,matchers:n}),(i=e).Period_asArray?h(m(i.Period_asArray,i,o.a.PERIOD,"onLoad"),o.a.PERIOD,"onLoad"):f.trigger(l.a.XLINK_READY,{manifest:i})},setMatchers:function(e){e&&(n=e)},setIron:function(e){e&&(r=e)},reset:function(){f.off(l.a.XLINK_ELEMENT_LOADED,p,t),s&&(s.reset(),s=null)}},f.on(l.a.XLINK_ELEMENT_LOADED,p,t),s=et(c).create({errHandler:e.errHandler,dashMetrics:e.dashMetrics,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,settings:e.settings}),t}nt.__dashjs_factory_name="XlinkController";var rt=c.a.getClassFactory(nt),it=n(61);function at(e){e=e||{};var t,n,r,i,s,c=this.context,f=e.debug,d=Object(u.a)(c).getInstance(),h=Object(L.a)(c).getInstance(),p=e.mssHandler,g=e.errHandler;function E(e){d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:e.manifest})}return t={load:function(e){var t=new Ze(e,_.a.MPD_TYPE);r.load({request:t,success:function(t,r,o){var u,g,E;if(i)if(o&&o!==e?(g=h.parseBaseUrl(o),u=o):(h.isRelative(e)&&(e=h.resolve(e,window.location.href)),g=h.parseBaseUrl(e)),"No Content"!=r)if(null===s&&(s=function(e){var t=null;return e.indexOf("SmoothStreamingMedia")>-1?(p&&(t=p.createMssParser(),p.registerEvents()),t):e.indexOf("MPD")>-1||e.indexOf("Patch")>-1?Object(it.a)(c).create({debug:f}):t}(t)),null!==s){i.setMatchers(s.getMatchers()),i.setIron(s.getIron());try{E=s.parse(t)}catch(t){return void d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:null,error:new m.a(y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE,y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE+"".concat(e))})}E?(E.url=u||e,E.originalUrl||(E.originalUrl=E.url),E.hasOwnProperty(a.a.LOCATION)&&(g=h.parseBaseUrl(E.Location_asArray[0]),n.debug("BaseURI set by Location to: "+g)),E.baseUri=g,E.loadedTime=new Date,i.resolveManifestOnLoad(E),d.trigger(l.a.ORIGINAL_MANIFEST_LOADED,{originalManifest:t})):d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:null,error:new m.a(y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE,y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE+"".concat(e))})}else d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:null,error:new m.a(y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_CODE,y.a.MANIFEST_LOADER_PARSING_FAILURE_ERROR_MESSAGE+"".concat(e))});else d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:null})},error:function(t,n,r){d.trigger(l.a.INTERNAL_MANIFEST_LOADED,{manifest:null,error:new m.a(y.a.MANIFEST_LOADER_LOADING_FAILURE_ERROR_CODE,y.a.MANIFEST_LOADER_LOADING_FAILURE_ERROR_MESSAGE+"".concat(e,", ").concat(r))})}})},reset:function(){d.off(l.a.XLINK_READY,E,t),p&&p.reset(),i&&(i.reset(),i=null),r&&(r.abort(),r=null)}},n=f.getLogger(t),d.on(l.a.XLINK_READY,E,t),r=Object(Ke.a)(c).create({errHandler:e.errHandler,dashMetrics:e.dashMetrics,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,urlUtils:h,constants:a.a,dashConstants:o.a,errors:y.a}),i=rt(c).create({errHandler:g,dashMetrics:e.dashMetrics,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,settings:e.settings}),s=null,t}at.__dashjs_factory_name="ManifestLoader";var ot=c.a.getClassFactory(at);function st(){var e=this.context,t=Object(u.a)(e).getInstance();return{error:function(e){t.trigger(l.a.ERROR,{error:e})}}}st.__dashjs_factory_name="ErrorHandler";var ut=c.a.getSingletonFactory(st),lt=n(50);function ct(){var e,t,n,r,i,o,s=this.context,c=Object(u.a)(s).getInstance();function d(e,r){if(!r||!r.Period_asArray||0===r.Period_asArray.length)return Promise.resolve();var i=[];return r.Period_asArray.forEach((function(r){i.push(function(e,r){return new Promise((function(i){if(e&&e.AdaptationSet_asArray&&0!==e.AdaptationSet_asArray.length){var s=[];e.AdaptationSet_asArray.forEach((function(e){t.getIsTypeOf(e,r)&&s.push(function(e,r){return new Promise((function(i){if(e.Representation_asArray&&0!==e.Representation_asArray.length){var s=[],u=[];e.Representation_asArray.forEach((function(i,o){var l=t.getCodec(e,o,!1),c=function(e,t,n){switch(e){case a.a.VIDEO:return function(e,t){var n=e.width||null,r=e.height||null,i=e.frameRate||null,a=e.bandwidth||null;return{codec:t,width:n,height:r,framerate:i,bitrate:a}}(t,n);case a.a.AUDIO:return function(e,t){var n=e.audioSamplingRate||null,r=e.bandwidth||null;return{codec:t,bitrate:r,samplerate:n}}(t,n);default:return null}}(r,i,l);u.push(c),s.push(n.supportsCodec(c,r))})),Promise.all(s).then((function(t){e.Representation_asArray=e.Representation_asArray.filter((function(e,n){return t[n]||o.debug("[Stream] Codec ".concat(u[n].codec," not supported ")),t[n]})),i()})).catch((function(){i()}))}else i()}))}(e,r))})),Promise.all(s).then((function(){e.AdaptationSet_asArray=e.AdaptationSet_asArray.filter((function(e){var t=e.Representation_asArray&&e.Representation_asArray.length>0;return t||(c.trigger(l.a.ADAPTATION_SET_REMOVED_NO_CAPABILITIES,{adaptationSet:e}),o.warn("AdaptationSet has been removed because of no supported Representation")),t})),i()})).catch((function(){i()}))}else i()}))}(r,e))})),Promise.all(i)}return e={setConfig:function(e){e&&(e.adapter&&(t=e.adapter),e.capabilities&&(n=e.capabilities),e.settings&&(r=e.settings),e.customParametersModel&&(i=e.customParametersModel))},filterUnsupportedFeatures:function(e){return new Promise((function(s){var u=[];u.push(d(a.a.VIDEO,e)),u.push(d(a.a.AUDIO,e)),Promise.all(u).then((function(){r.get().streaming.capabilities.filterUnsupportedEssentialProperties&&function(e){if(!e||!e.Period_asArray||0===e.Period_asArray.length)return;e.Period_asArray.forEach((function(e){e.AdaptationSet_asArray=e.AdaptationSet_asArray.filter((function(e){return!e.Representation_asArray||0===e.Representation_asArray.length||(e.Representation_asArray=e.Representation_asArray.filter((function(e){var r=t.getEssentialPropertiesForRepresentation(e);if(r&&r.length>0)for(var i=0;i<r.length;){if(!n.supportsEssentialProperty(r[i]))return o.debug("[Stream] EssentialProperty not supported: "+r[i].schemeIdUri),!1;i+=1}return!0})),e.Representation_asArray&&e.Representation_asArray.length>0)}))}))}(e),function(e){var t=i.getCustomCapabilitiesFilters();if(!t||0===t.length||!e||!e.Period_asArray||0===e.Period_asArray.length)return;e.Period_asArray.forEach((function(e){e.AdaptationSet_asArray=e.AdaptationSet_asArray.filter((function(e){return!e.Representation_asArray||0===e.Representation_asArray.length||(e.Representation_asArray=e.Representation_asArray.filter((function(e){return!t.some((function(t){return!t(e)}))})),e.Representation_asArray&&e.Representation_asArray.length>0)}))}))}(e),s()})).catch((function(){s()}))}))}},o=Object(f.a)(s).getInstance().getLogger(e),e}ct.__dashjs_factory_name="CapabilitiesFilter";var ft=c.a.getSingletonFactory(ct);var dt=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.t=null,this.xywh=null,this.track=null,this.id=null,this.s=null,this.r=null};function ht(){var e;return{initialize:function(t){if(e=new dt,!t)return null;var n=t.indexOf("#");if(-1!==n)for(var r=t.substr(n+1).split("&"),i=0,a=r.length;i<a;++i){var o=r[i],s=o.indexOf("=");if(-1!==s){var u=o.substring(0,s);e.hasOwnProperty(u)&&(e[u]=o.substr(s+1))}}},getURIFragmentData:function(){return e}}}ht.__dashjs_factory_name="URIFragmentModel";var pt=c.a.getSingletonFactory(ht);function gt(){var e,t=this.context,n=Object(u.a)(t).getInstance();return{getValue:function(){return e},setValue:function(t){e=t,t&&n.trigger(l.a.MANIFEST_LOADED,{data:t})}}}gt.__dashjs_factory_name="ManifestModel";var mt=c.a.getSingletonFactory(gt);function yt(){var e,t,n=this.context,r=Object(E.a)(n).getInstance();function i(){var t=r.get().streaming.buffer.stableBufferTime>0?r.get().streaming.buffer.stableBufferTime:r.get().streaming.buffer.fastSwitchEnabled?20:12,n=e.getLiveDelay();return!isNaN(n)&&n>0?Math.min(t,n):t}return{getCatchupMaxDrift:function(){if(!isNaN(r.get().streaming.liveCatchup.maxDrift)&&r.get().streaming.liveCatchup.maxDrift>0)return r.get().streaming.liveCatchup.maxDrift;var e=t.getServiceDescriptionSettings();return e&&e.liveCatchup&&!isNaN(e.liveCatchup.maxDrift)&&e.liveCatchup.maxDrift>0?e.liveCatchup.maxDrift:12},getCatchupModeEnabled:function(){return null!==r.get().streaming.liveCatchup.enabled?r.get().streaming.liveCatchup.enabled:e.getInitialCatchupModeActivated()},getLiveCatchupLatencyThreshold:function(){try{var t=r.get().streaming.liveCatchup.latencyThreshold,n=e.getLiveDelay();return null===t||isNaN(t)?NaN:Math.max(t,n)}catch(e){return NaN}},getStableBufferTime:i,getInitialBufferLevel:function(){var e=r.get().streaming.buffer.initialBufferLevel;return isNaN(e)||e<0?0:Math.min(i(),e)},getRetryAttemptsForType:function(t){var n=isNaN(r.get().streaming.retryAttempts.lowLatencyMultiplyFactor)?5:r.get().streaming.retryAttempts.lowLatencyMultiplyFactor;return e.getLowLatencyModeEnabled()?r.get().streaming.retryAttempts[t]*n:r.get().streaming.retryAttempts[t]},getRetryIntervalsForType:function(t){var n=isNaN(r.get().streaming.retryIntervals.lowLatencyReductionFactor)?10:r.get().streaming.retryIntervals.lowLatencyReductionFactor;return e.getLowLatencyModeEnabled()?r.get().streaming.retryIntervals[t]/n:r.get().streaming.retryIntervals[t]},getCatchupPlaybackRate:function(){if(!isNaN(r.get().streaming.liveCatchup.playbackRate)&&r.get().streaming.liveCatchup.playbackRate>0)return r.get().streaming.liveCatchup.playbackRate;var e=t.getServiceDescriptionSettings();return e&&e.liveCatchup&&!isNaN(e.liveCatchup.playbackRate)&&e.liveCatchup.playbackRate>0?e.liveCatchup.playbackRate:.5},getAbrBitrateParameter:function(e,n){try{var i=r.get().streaming.abr[e][n];if(!isNaN(i)&&-1!==i)return i;var a=t.getServiceDescriptionSettings();return a&&a[e]&&!isNaN(a[e][n])?a[e][n]:-1}catch(e){return-1}},setConfig:function(n){n.playbackController&&(e=n.playbackController),n.serviceDescriptionController&&(t=n.serviceDescriptionController)},reset:function(){}}}yt.__dashjs_factory_name="MediaPlayerModel";var Et=c.a.getSingletonFactory(yt),_t=n(27);function Tt(e){var t=(e=e||{}).abrController,n=e.switchHistory,r=e.droppedFramesHistory,i=e.currentRequest,a=e.useBufferOccupancyABR,o=e.useL2AABR,s=e.useLoLPABR,u=e.streamProcessor?e.streamProcessor.getScheduleController():null,l=e.streamProcessor?e.streamProcessor.getRepresentationInfo():null,c=e.videoModel?e.videoModel:null;function f(){return l?l.mediaInfo:null}return{getMediaType:function(){var e=f();return e?e.type:null},getMediaInfo:f,getDroppedFramesHistory:function(){return r},getCurrentRequest:function(){return i},getSwitchHistory:function(){return n},getStreamInfo:function(){var e=f();return e?e.streamInfo:null},getScheduleController:function(){return u},getAbrController:function(){return t},getRepresentationInfo:function(){return l},useBufferOccupancyABR:function(){return a},useL2AABR:function(){return o},useLoLPABR:function(){return s},getVideoModel:function(){return c}}}Tt.__dashjs_factory_name="RulesContext";var vt=c.a.getClassFactory(Tt),St=n(8);function At(){var e=[],t=[];return{push:function(n){n.newValue===St.a.NO_CHANGE&&(n.newValue=n.oldValue),e[n.oldValue]||(e[n.oldValue]={noDrops:0,drops:0,dropSize:0});var r=n.newValue-n.oldValue,i=r<0?1:0,a=i?-r:0,o=i?0:1;if(e[n.oldValue].drops+=i,e[n.oldValue].dropSize+=a,e[n.oldValue].noDrops+=o,t.push({idx:n.oldValue,noDrop:o,drop:i,dropSize:a}),t.length>8){var s=t.shift();e[s.idx].drops-=s.drop,e[s.idx].dropSize-=s.dropSize,e[s.idx].noDrops-=s.noDrop}},getSwitchRequests:function(){return e},reset:function(){e=[],t=[]}}}At.__dashjs_factory_name="SwitchRequestHistory";var bt=c.a.getClassFactory(At);function It(){var e={},t={},n={};return{push:function(r,i,a){if(i){e[r]||(e[r]=[],t[r]=0,n[r]=0);var o=a&&a.droppedVideoFrames?a.droppedVideoFrames:0,s=a&&a.totalVideoFrames?a.totalVideoFrames:0,u=o-t;t[r]=o;var l=s-n;n[r]=s;var c=e[r];isNaN(i)||(c[i]?(c[i].droppedVideoFrames+=u,c[i].totalVideoFrames+=l):c[i]={droppedVideoFrames:u,totalVideoFrames:l})}},getFrameHistory:function(t){return e[t]},clearForStream:function(r){try{delete e[r],delete t[r],delete n[r]}catch(e){}},reset:function(){e={},t={},n={}}}}It.__dashjs_factory_name="DroppedFramesHistory";var Rt=c.a.getClassFactory(It);function Nt(e){var t,n,r,i,o,s=(e=e||{}).settings;function u(e,t,n,r){var i=Math.pow(.5,n/r.fast);e.fastEstimate=(1-i)*t+i*e.fastEstimate;var a=Math.pow(.5,n/r.slow);e.slowEstimate=(1-a)*t+a*e.slowEstimate,e.totalWeight+=n}function l(e,u,l){return s.get().streaming.abr.movingAverageMethod!==a.a.MOVING_AVERAGE_SLIDING_WINDOW?function(e,t){var n=e?o.throughputHalfLife:o.latencyHalfLife,a=e?r[t]:i[t];if(!a||a.totalWeight<=0)return NaN;var s=a.fastEstimate/(1-Math.pow(.5,a.totalWeight/n.fast)),u=a.slowEstimate/(1-Math.pow(.5,a.totalWeight/n.slow));return e?Math.min(s,u):Math.max(s,u)}(e,u):function(e,r,i){var a=function(e,r,i){var a,o;if(e?(a=t[r],o=i?3:4):(a=n[r],o=4),a){if(o>=a.length)o=a.length;else if(e)for(var s=1;s<o;++s){var u=a[a.length-s]/a[a.length-s-1];if((u>=1.3||u<=1/1.3)&&(o+=1)===a.length)break}}else o=0;return o}(e,r,i),o=(e?t:n)[r];if(0===a||!o||0===o.length)return NaN;return(o=o.slice(-a)).reduce((function(e,t){return e+t}))/o.length}(e,u,l)}function c(e,t){return l(!0,e,t)}function f(e){t[e]=t[e]||[],n[e]=n[e]||[],r[e]=r[e]||{fastEstimate:0,slowEstimate:0,totalWeight:0},i[e]=i[e]||{fastEstimate:0,slowEstimate:0,totalWeight:0}}function d(){t={},n={},r={},i={}}var h={push:function(e,l,c){if(l.trace&&l.trace.length){var d=l.tresponse.getTime()-l.trequest.getTime()||1,h=l._tfinish.getTime()-l.tresponse.getTime()||1,p=l.trace.reduce((function(e,t){return e+t.b[0]}),0),g=0,m=0;if(l._fileLoaderType&&l._fileLoaderType===a.a.FILE_LOADER_TYPES.FETCH){if(s.get().streaming.abr.fetchThroughputCalculationMode===a.a.ABR_FETCH_THROUGHPUT_CALCULATION_MOOF_PARSING){var y=l.trace.reduce((function(e,t){return e+t._t}),0);m=Math.round(y/l.trace.length)}0===m&&(g=l.trace.reduce((function(e,t){return e+t.d}),0))}else g=c?h:d+h;if(0!==g&&(m=Math.round(8*p/g)),f(e),function(e,t,n){return e===a.a.VIDEO?n<s.get().streaming.cacheLoadThresholds[a.a.VIDEO]:e===a.a.AUDIO?n<s.get().streaming.cacheLoadThresholds[a.a.AUDIO]:void 0}(e,0,h)){if(t[e].length>0&&!t[e].hasCachedEntries)return;t[e].hasCachedEntries=!0}else t[e]&&t[e].hasCachedEntries&&function(e){delete t[e],delete n[e],delete r[e],delete i[e],f(e)}(e);t[e].push(m),t[e].length>20&&t[e].shift(),n[e].push(d),n[e].length>20&&n[e].shift(),u(r[e],m,.001*h,o.throughputHalfLife),u(i[e],d,1,o.latencyHalfLife)}},getAverageThroughput:c,getSafeAverageThroughput:function(e,t){var n=c(e,t);return isNaN(n)||(n*=s.get().streaming.abr.bandwidthSafetyFactor),n},getAverageLatency:function(e){return l(!1,e)},reset:d};return o={throughputHalfLife:{fast:3,slow:8},latencyHalfLife:{fast:1,slow:2}},d(),h}Nt.__dashjs_factory_name="ThroughputHistory";var Ct=c.a.getClassFactory(Nt);function wt(){var e,t,n,r,i,o,c,h,p,m,y,E,T,v,S,A,b,I,R,N,C,w,D,M,P,L,F=this.context,x=Object(f.a)(F).getInstance(),U=Object(u.a)(F).getInstance();function B(){i={},o={},h={},c={},R={},w={},D={},M={},void 0===m&&(m=!1),N&&N.reset(),I=void 0,N=void 0,C=void 0,clearTimeout(p),p=null}function k(t){var i=t.request.mediaType,a=t.streamId;if(i&&a&&c[a]&&L.get().streaming.abr.autoSwitchBitrate[i]){var o=c[a][i];if(o){var u=vt(F).create({abrController:e,streamProcessor:o,currentRequest:t.request,useBufferOccupancyABR:w[i],useL2AABR:D[i],useLoLPABR:M[i],videoModel:v}),l=n.shouldAbandonFragment(u,a);if(l.quality>St.a.NO_CHANGE){var f=o.getFragmentModel();f.getRequests({state:g.a.FRAGMENT_MODEL_LOADING,index:t.request.index})[0]&&(f.abortRequests(),h[a][i].state=s.a.ABANDON_LOAD,R[a][i].reset(),R[a][i].push({oldValue:V(i,a),newValue:l.quality,confidence:1,reason:l.reason}),K(i,r.getActiveStreamInfo(),l.quality,l.reason),clearTimeout(p),p=setTimeout((function(){h[a][i].state=s.a.ALLOW_LOAD,p=null}),L.get().streaming.abandonLoadTimeout))}}}}function G(e){e.mediaType===a.a.VIDEO&&(void 0!==I&&N.push(e.streamId,I,v.getPlaybackQuality()),I=e.newQuality)}function j(e){var n,r;e.metric!==s.a.HTTP_REQUEST||!e.value||e.value.type!==_.a.MEDIA_SEGMENT_TYPE||e.mediaType!==a.a.AUDIO&&e.mediaType!==a.a.VIDEO||C.push(e.mediaType,e.value,L.get().streaming.abr.useDeadTimeLatency),e.metric!==s.a.BUFFER_LEVEL||e.mediaType!==a.a.AUDIO&&e.mediaType!==a.a.VIDEO||(n=e.mediaType,r=.001*e.value.level,L.get().streaming.abr.ABRStrategy===a.a.ABR_STRATEGY_DYNAMIC&&function(e,n){try{var r=S.getStableBufferTime(),i=r,a=.5*r,o=w[e],s=n>(o?a:i);w[e]=s,s!==o&&(s?t.info("["+e+"] switching from throughput to buffer occupancy ABR rule (buffer: "+n.toFixed(3)+")."):t.info("["+e+"] switching from buffer occupancy to throughput ABR rule (buffer: "+n.toFixed(3)+")."))}catch(e){t.error(e)}}(n,r))}function Y(e,t){try{return i[t]=i[t]||{},i[t].hasOwnProperty(e)||(i[t][e]=0),function(e,t,n){if(t!==a.a.VIDEO||!L.get().streaming.abr.limitBitrateByPortal||!c[n]||!c[n][t])return e;m||Q();var r=c[n][t].getStreamInfo(),i=T.getAdaptationForType(r.index,t,r).Representation,o=e;if(y>0&&E>0){for(;o>0&&i[o]&&y<i[o].width&&y-i[o-1].width<i[o].width-y;)o-=1;for(;o<i.length-1&&i[o].width===i[o+1].width;)o+=1}return o}(function(e,t,n){var r=i[n][t],a=L.get().streaming.abr.maxRepresentationRatio[t];if(isNaN(a)||a>=1||a<0)return e;return Math.min(e,Math.round(r*a))}(function(e,t){var n=i[t][e],r=n;if(!c[t]||!c[t][e])return r;var a=H(e,t);void 0!==a&&(r=Math.max(n,a));var o=function(e,t){try{var n=S.getAbrBitrateParameter("maxBitrate",e);return n>-1?W(c[t][e].getMediaInfo(),n,t):void 0}catch(e){return}}(e,t);void 0!==o&&(r=Math.min(r,o));return r}(e,t),e,t),e,t)}catch(e){return}}function H(e,t){try{return function(e,t){try{var n=S.getAbrBitrateParameter("minBitrate",e);if(n>-1){var r=c[t][e].getMediaInfo(),i=X(r),a=W(r,n,t);return i[a]&&a<i.length-1&&i[a].bitrate<1e3*n&&a++,a}return}catch(e){return}}(e,t)}catch(e){return}}function V(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;try{if(t||(t=r.getActiveStreamInfo().id),e&&c[t]&&c[t][e])if(t)return o[t]=o[t]||{},o[t].hasOwnProperty(e)||(o[t][e]=0),o[t][e];return 0}catch(e){return 0}}function K(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;if(t&&t.id&&e){var i=t.id,a=V(e,i);Object(O.a)(n);var o=Y(e,i);n!==a&&n>=0&&n<=o&&q(e,a,n,o,r,i)}}function q(e,n,r,i,a,s){if(e&&c[s]&&c[s][e]){var u=c[s][e].getStreamInfo(),f=u&&u.manifestInfo&&u.manifestInfo.isDynamic,d=P.getCurrentBufferLevel(e);t.info("Stream ID: "+s+" ["+e+"] switch from "+n+" to "+r+"/"+i+" (buffer: "+d+") "+(a?JSON.stringify(a):".")),o[s]=o[s]||{},o[s][e]=r;var h=function(e,t,n){if(t&&c&&c[e]&&c[e][t]){var r=X(c[e][t].getMediaInfo());return r[n]?r[n]:null}return null}(s,e,r);U.trigger(l.a.QUALITY_CHANGE_REQUESTED,{oldQuality:n,newQuality:r,reason:a,streamInfo:u,bitrateInfo:h,maxIdx:i,mediaType:e},{streamId:u.id,mediaType:e});var p=C.getAverageThroughput(e,f);isNaN(p)||b.setSavedBitrateSettings(e,p)}}function W(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,i=e&&e.type?c[n][e.type].getRepresentationInfo():null;if(L.get().streaming.abr.useDeadTimeLatency&&r&&i&&i.fragmentDuration){r/=1e3;var a=i.fragmentDuration;if(r>a)return 0;var o=r/a;t*=1-o}for(var s=X(e),u=s.length-1;u>=0;u--){var l=s[u];if(1e3*t>=l.bitrate)return u}return 0}function X(e){var t=[];if(!e||!e.bitrateList)return t;for(var n,r=e.bitrateList,i=e.type,a=0,o=r.length;a<o;a++)(n=new z).mediaType=i,n.qualityIndex=a,n.bitrate=r[a].bandwidth,n.width=r[a].width,n.height=r[a].height,n.scanType=r[a].scanType,t.push(n);return t}function Q(){if(v){var e=L.get().streaming.abr.usePixelRatioInLimitBitrateByPortal&&window.hasOwnProperty("devicePixelRatio")?window.devicePixelRatio:1;y=v.getClientWidth()*e,E=v.getClientHeight()*e}}return e={initialize:function(){N=Rt(F).create(),C=Ct(F).create({settings:L}),(n=Object(_t.a)(F).create({dashMetrics:P,customParametersModel:A,mediaPlayerModel:S,settings:L})).initialize(),U.on(d.a.QUALITY_CHANGE_RENDERED,G,e),U.on(d.a.METRIC_ADDED,j,e),U.on(l.a.LOADING_PROGRESS,k,e)},isPlayingAtTopQuality:function(e){var t=e?e.id:null,n=V(a.a.AUDIO,t),r=V(a.a.VIDEO,t);return n===Y(a.a.AUDIO,t)&&r===Y(a.a.VIDEO,t)},updateTopQualityIndex:function(e){var t=e.type,n=e.streamInfo.id,r=e.representationCount-1;return i[n]=i[n]||{},i[n][t]=r,r},clearDataForStream:function(e){N&&N.clearForStream(e),c[e]&&delete c[e],R[e]&&delete R[e],h[e]&&delete h[e]},getThroughputHistory:function(){return C},getBitrateList:X,getQualityForBitrate:W,getTopBitrateInfoFor:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(t||(t=r.getActiveStreamInfo().id),e&&c&&c[t]&&c[t][e]){var n=Y(e,t),i=X(c[t][e].getMediaInfo());return i[n]?i[n]:null}return null},getMinAllowedIndexFor:H,getMaxAllowedIndexFor:Y,getInitialBitrateFor:function(e,t){if(function(){if(!b||!b.hasOwnProperty("getSavedBitrateSettings"))throw new Error(a.a.MISSING_CONFIG_ERROR)}(),e===a.a.TEXT)return NaN;var n=b.getSavedBitrateSettings(e),r=S.getAbrBitrateParameter("initialBitrate",e),i=L.get().streaming.abr.initialRepresentationRatio[e];if(-1===r)if(i>-1){var o=c[t][e].getStreamInfo(),s=T.getAdaptationForType(o.index,e,o).Representation;if(Array.isArray(s))r=s[Math.max(Math.round(s.length*i)-1,0)].bandwidth/1e3;else r=0}else r=isNaN(n)?e===a.a.VIDEO?1e3:100:n;return r},getQualityFor:V,getAbandonmentStateFor:function(e,t){return h[e]&&h[e][t]?h[e][t].state:null},setPlaybackQuality:K,checkPlaybackQuality:function(t,r){try{if(!(t&&c&&c[r]&&c[r][t]))return!1;if(N){var i=v.getPlaybackQuality();i&&N.push(r,I,i)}if(!L.get().streaming.abr.autoSwitchBitrate[t])return!1;var a=V(t,r),o=vt(F).create({abrController:e,switchHistory:R[r][t],droppedFramesHistory:N,streamProcessor:c[r][t],currentValue:a,useBufferOccupancyABR:w[t],useL2AABR:D[t],useLoLPABR:M[t],videoModel:v}),u=H(t,r),l=Y(t,r),f=n.getMaxQuality(o),d=f.quality;return void 0!==u&&(d>St.a.NO_CHANGE?d:a)<u&&(d=u),d>l&&(d=l),R[r][t].push({oldValue:a,newValue:d}),d>St.a.NO_CHANGE&&d!==a&&(h[r][t].state===s.a.ALLOW_LOAD||d>a)&&(q(t,a,d,l,f.reason,r),!0)}catch(e){return!1}},setElementSize:Q,setWindowResizeEventCalled:function(e){m=e},registerStreamType:function(e,t){var n=t.getStreamInfo().id;c[n]||(c[n]={}),R[n]||(R[n]={}),h[n]||(h[n]={}),R[n][e]=bt(F).create(),c[n][e]=t,h[n][e]={},h[n][e].state=s.a.ALLOW_LOAD,function(e){var t=L.get().streaming.abr.ABRStrategy;t===a.a.ABR_STRATEGY_L2A?(w[e]=!1,M[e]=!1,D[e]=!0):t===a.a.ABR_STRATEGY_LoLP?(w[e]=!1,M[e]=!0,D[e]=!1):t===a.a.ABR_STRATEGY_BOLA?(w[e]=!0,M[e]=!1,D[e]=!1):t===a.a.ABR_STRATEGY_THROUGHPUT?(w[e]=!1,M[e]=!1,D[e]=!1):t===a.a.ABR_STRATEGY_DYNAMIC&&(w[e]=!(!w||!w[e])&&w[e],M[e]=!1,D[e]=!1)}(e),e===a.a.VIDEO&&Q()},unRegisterStreamType:function(e,t){try{c[e]&&c[e][t]&&delete c[e][t],R[e]&&R[e][t]&&delete R[e][t],h[e]&&h[e][t]&&delete h[e][t]}catch(e){}},setConfig:function(e){e&&(e.streamController&&(r=e.streamController),e.domStorage&&(b=e.domStorage),e.mediaPlayerModel&&(S=e.mediaPlayerModel),e.customParametersModel&&(A=e.customParametersModel),e.dashMetrics&&(P=e.dashMetrics),e.adapter&&(T=e.adapter),e.videoModel&&(v=e.videoModel),e.settings&&(L=e.settings))},reset:function(){B(),U.off(l.a.LOADING_PROGRESS,k,e),U.off(d.a.QUALITY_CHANGE_RENDERED,G,e),U.off(d.a.METRIC_ADDED,j,e),n&&n.reset()}},t=x.getLogger(e),B(),e}wt.__dashjs_factory_name="AbrController";var Dt=c.a.getSingletonFactory(wt);Dt.QUALITY_DEFAULT=0,c.a.updateSingletonFactory(wt.__dashjs_factory_name,Dt);var Ot=Dt,Mt=n(46),Pt=new Map([[a.a.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA,"loadedmetadata"],[a.a.VIDEO_ELEMENT_READY_STATES.HAVE_CURRENT_DATA,"loadeddata"],[a.a.VIDEO_ELEMENT_READY_STATES.HAVE_FUTURE_DATA,"canplay"],[a.a.VIDEO_ELEMENT_READY_STATES.HAVE_ENOUGH_DATA,"canplaythrough"]]);function Lt(){var e,t,n,r,i,o=this.context,s=Object(u.a)(o).getInstance(),c=[];function d(){n&&(n.playbackRate=1,n.removeEventListener("canplay",d))}function h(){return c.length>0}function p(){if(n&&h()&&0===n.playbackRate){var e=document.createEvent("Event");e.initEvent("waiting",!0,!1),n.dispatchEvent(e)}}function g(e,t){n&&n.addEventListener(e,t)}function m(e,t){n&&n.removeEventListener(e,t)}function y(){return n?n.readyState:NaN}function E(){return n?n.buffered:null}function _(e,t,r,i,a){if(n)for(var o=0;o<n.textTracks.length;o++)if(n.textTracks[o].kind===e&&(!t||n.textTracks[o].label==t)&&n.textTracks[o].language===r&&n.textTracks[o].isTTML===i&&n.textTracks[o].isEmbedded===a)return n.textTracks[o];return null}function T(e,t){e===a.a.VIDEO_ELEMENT_READY_STATES.HAVE_NOTHING||y()>=e?t():function(e,t){g(e,(function n(){m(e,n),t(e)}))}(Pt.get(e),t)}return e={initialize:function(){s.on(l.a.PLAYBACK_PLAYING,p,this)},setCurrentTime:function(e,t){r=e,T(a.a.VIDEO_ELEMENT_READY_STATES.HAVE_METADATA,(function(){if(n){if(n.currentTime===r)return void(r=NaN);try{r=t?function(e){var t=E(),n=e,r=9999999999;if(t)for(var i=0;i<t.length;i++){var a=t.start(i),o=t.end(i),s=Math.abs(a-e),u=Math.abs(o-e);if(e>=a&&e<=o)return e;s<r&&(r=s,n=a),u<r&&(r=u,n=o)}return n}(r):r,n.currentTime=r,r=NaN}catch(e){0===n.readyState&&e.code===e.INVALID_STATE_ERR&&setTimeout((function(){n.currentTime=r,r=NaN}),400)}}}))},play:function(){if(n){n.autoplay=!0;var e=n.play();e&&e.catch&&"undefined"!=typeof Promise&&e.catch((function(e){"NotAllowedError"===e.name&&s.trigger(l.a.PLAYBACK_NOT_ALLOWED),t.warn("Caught pending play exception - continuing (".concat(e,")"))}))}},isPaused:function(){return n?n.paused:null},pause:function(){n&&(n.pause(),n.autoplay=!1)},isStalled:h,isSeeking:function(){return n?n.seeking||!isNaN(r):null},getTime:function(){return n?isNaN(r)?n.currentTime:r:null},getPlaybackRate:function(){return n?n.playbackRate:null},setPlaybackRate:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];n&&(!t&&n.readyState<=2&&e>0?n.addEventListener("canplay",d):n.playbackRate=e)},getPlayedRanges:function(){return n?n.played:null},getEnded:function(){return n?n.ended:null},setStallState:function(e,t){!function(e,t){t?function(e){if(null===e||!n||n.seeking||-1!==c.indexOf(e))return;c.push(e)}(e):function(e){var t=c.indexOf(e);if(null===e)return;-1!==t&&c.splice(t,1)}(e)}(e,t)},getElement:function(){return n},setElement:function(e){if(!(null==e||e&&/^(VIDEO|AUDIO)$/i.test(e.nodeName)))throw"element is not video or audio DOM type!";(n=e)&&(n.preload="auto")},setSource:function(e){n&&(e?n.src=e:(n.removeAttribute("src"),n.load()))},getSource:function(){return n?n.src:null},getTTMLRenderingDiv:function(){return i},setTTMLRenderingDiv:function(e){(i=e).style.position="absolute",i.style.display="flex",i.style.overflow="hidden",i.style.pointerEvents="none",i.style.top=0,i.style.left=0},getPlaybackQuality:function(){if(!n)return null;var e="webkitDroppedFrameCount"in n&&"webkitDecodedFrameCount"in n,t=null;return"getVideoPlaybackQuality"in n?t=n.getVideoPlaybackQuality():e&&(t={droppedVideoFrames:n.webkitDroppedFrameCount,totalVideoFrames:n.webkitDroppedFrameCount+n.webkitDecodedFrameCount,creationTime:new Date}),t},addEventListener:g,removeEventListener:m,getReadyState:y,getBufferRange:E,getClientWidth:function(){return n?n.clientWidth:NaN},getClientHeight:function(){return n?n.clientHeight:NaN},getTextTracks:function(){return n?n.textTracks:[]},getTextTrack:_,addTextTrack:function(e,t,r,i,a){if(!n)return null;var o=_(e,t,r,i,a);return o||((o=n.addTextTrack(e,t,r)).isEmbedded=a,o.isTTML=i),o},appendChild:function(e){n&&(n.appendChild(e),void 0!==e.isTTML&&(n.textTracks[n.textTracks.length-1].isTTML=e.isTTML,n.textTracks[n.textTracks.length-1].isEmbedded=e.isEmbedded))},removeChild:function(e){n&&n.removeChild(e)},getVideoWidth:function(){return n?n.videoWidth:NaN},getVideoHeight:function(){return n?n.videoHeight:NaN},getVideoRelativeOffsetTop:function(){var e=n.parentNode.host||n.parentNode;return e?n.getBoundingClientRect().top-e.getBoundingClientRect().top:NaN},getVideoRelativeOffsetLeft:function(){var e=n.parentNode.host||n.parentNode;return e?n.getBoundingClientRect().left-e.getBoundingClientRect().left:NaN},waitForReadyState:T,reset:function(){s.off(l.a.PLAYBACK_PLAYING,p,this)}},t=Object(f.a)(o).getInstance().getLogger(e),r=NaN,e}Lt.__dashjs_factory_name="VideoModel";var Ft=c.a.getSingletonFactory(Lt),xt=n(42),Ut=[{oldKey:"dashjs_vbitrate",newKey:"dashjs_video_bitrate"},{oldKey:"dashjs_abitrate",newKey:"dashjs_audio_bitrate"},{oldKey:"dashjs_vsettings",newKey:"dashjs_video_settings"},{oldKey:"dashjs_asettings",newKey:"dashjs_audio_settings"}];function Bt(e){e=e||{};var t,n,r,i=this.context,o=e.settings;function s(e){if(void 0!==r)return r;r=!1;var t;try{"undefined"!=typeof window&&(t=window[e])}catch(e){return n.warn("DOMStorage access denied: "+e.message),r}if(!t||"localStorage"!==e&&"sessionStorage"!==e)return r;try{t.setItem("1","1"),t.removeItem("1"),r=!0}catch(e){n.warn("DOMStorage is supported, but cannot be used: "+e.message)}return r}function u(){return 6e5*Math.round((new Date).getTime()/6e5)}function l(e,t){return s(e)&&o.get().streaming[t+"CachingInfo"].enabled}function c(){if(!o)throw new Error(a.a.MISSING_CONFIG_ERROR)}return t={getSavedBitrateSettings:function(e){var t=NaN;if(c(),l("localStorage","lastBitrate")){var r="dashjs_?_bitrate".replace(/\?/,e);try{var i=JSON.parse(localStorage.getItem(r))||{},a=(new Date).getTime()-parseInt(i.timestamp,10)>=o.get().streaming.lastBitrateCachingInfo.ttl||!1,s=parseFloat(i.bitrate);isNaN(s)||a?a&&localStorage.removeItem(r):(t=s,n.debug("Last saved bitrate for "+e+" was "+s))}catch(e){return null}}return t},setSavedBitrateSettings:function(e,t){if(l("localStorage","lastBitrate")&&t){var r="dashjs_?_bitrate".replace(/\?/,e);try{localStorage.setItem(r,JSON.stringify({bitrate:t.toFixed(3),timestamp:u()}))}catch(e){n.error(e.message)}}},getSavedMediaSettings:function(e){var t=null;if(c(),l("localStorage","lastMediaSettings")){var n="dashjs_?_settings".replace(/\?/,e);try{var r=JSON.parse(localStorage.getItem(n))||{},i=(new Date).getTime()-parseInt(r.timestamp,10)>=o.get().streaming.lastMediaSettingsCachingInfo.ttl||!1;t=r.settings,i&&(localStorage.removeItem(n),t=null)}catch(e){return null}}return t},setSavedMediaSettings:function(e,t){if(l("localStorage","lastMediaSettings")){var r="dashjs_?_settings".replace(/\?/,e);try{localStorage.setItem(r,JSON.stringify({settings:t,timestamp:u()}))}catch(e){n.error(e.message)}}}},n=Object(f.a)(i).getInstance().getLogger(t),s("localStorage")&&Ut.forEach((function(e){var t=localStorage.getItem(e.oldKey);if(t){localStorage.removeItem(e.oldKey);try{localStorage.setItem(e.newKey,t)}catch(e){n.error(e.message)}}})),t}Bt.__dashjs_factory_name="DOMStorage";var kt=c.a.getSingletonFactory(Bt),Gt=n(55),jt=n(32);function Yt(){var e,t,n,r,i,a,o,s,u,l,c,f,d,h=this.context;function p(e,t,n){n({segments:e,representation:t,error:e?void 0:new m.a(u.SEGMENT_BASE_LOADER_ERROR_CODE,u.SEGMENT_BASE_LOADER_ERROR_MESSAGE)})}function g(e){if(e.url){var t=new qe.a;return t.setInfo(e),t}}return e={setConfig:function(s){s.baseURLController&&(d=s.baseURLController),s.dashMetrics&&(a=s.dashMetrics),s.mediaPlayerModel&&(o=s.mediaPlayerModel),s.errHandler&&(n=s.errHandler),s.boxParser&&(r=s.boxParser),s.debug&&(t=s.debug.getLogger(e)),s.requestModifier&&(i=s.requestModifier),s.errors&&(u=s.errors),s.urlUtils&&(f=s.urlUtils),s.constants&&(l=s.constants),s.dashConstants&&(c=s.dashConstants)},initialize:function(){s=Object(Ke.a)(h).create({errHandler:n,dashMetrics:a,mediaPlayerModel:o,requestModifier:i,boxParser:r,errors:u,urlUtils:f,constants:l,dashConstants:c})},loadInitialization:function(e,n){return new Promise((function(i){!function e(n,i,a,o){var u=null,l=n?d.resolve(n.path):null,c=o||{init:!0,url:l?l.url:void 0,range:{start:0,end:1500},searching:!1,bytesLoaded:0,bytesToLoad:1500,mediaType:i};t.debug("Start searching for initialization.");var f=g(c),h=function(t){if(c.bytesLoaded=c.range.end,!(u=r.findInitRange(t)))return c.range.end=c.bytesLoaded+c.bytesToLoad,e(n,i,a,c);n.range=u,a(n)};s.load({request:f,success:h,error:function(){a(n)}}),t.debug("Perform init search: "+c.url)}(e,n,i)}))},loadSegments:function(e,n,i){return new Promise((function(a){!function e(n,i,a,o,u,l){if(a&&(void 0===a.start||void 0===a.end)){var c=a?a.toString().split("-"):null;a=c?{start:parseFloat(c[0]),end:parseFloat(c[1])}:null}u=u||p;var f=null,h=null,m=!!a,y=n?d.resolve(n.path):null,E={init:!1,url:y?y.url:void 0,range:m?a:{start:0,end:1500},searching:!m,bytesLoaded:l?l.bytesLoaded:0,bytesToLoad:1500,mediaType:i},_=g(E),T=function(a){var s=E.bytesToLoad,l=a.byteLength;if(E.bytesLoaded=E.range.end-E.range.start,f=r.parse(a),(h=f.getBox("sidx"))&&h.isComplete){var c,d,p=h.references;if(null!=p&&p.length>0&&(c=1===p[0].reference_type),c){var g,m,y,_;t.debug("Initiate multiple SIDX load."),E.range.end=E.range.start+h.size;var T=[],v=0,S=(h.offset||E.range.start)+h.size,A=function(e){e?(T=T.concat(e),++v>=m&&(T.sort((function(e,t){return e.startTime-t.startTime<0?-1:0})),u(T,n,o))):u(null,n,o)};for(g=0,m=p.length;g<m;g++)y=S,_=S+p[g].referenced_size-1,S+=p[g].referenced_size,e(n,i,{start:y,end:_},o,A,E)}else t.debug("Parsing segments from SIDX. representation "+i+" - id: "+n.id+" for range : "+E.range.start+" - "+E.range.end),d=function(e,t){for(var n,r,i,a,o=e.references,s=o.length,u=e.timescale,l=e.earliest_presentation_time,c=t.range.start+e.offset+e.first_offset+e.size,f=[],d=0;d<s;d++)i=o[d].subsegment_duration,a=o[d].referenced_size,(n=new jt.a).duration=i,n.startTime=l,n.timescale=u,r=c+a-1,n.mediaRange=c+"-"+r,f.push(n),l+=i,c+=a;return f}(h,E),u(d,n,o)}else{if(h)E.range.start=h.offset||E.range.start,E.range.end=E.range.start+(h.size||s);else{if(l<E.bytesLoaded)return void u(null,n,o);var b=f.getLastBox();b&&b.size?(E.range.start=b.offset+b.size,E.range.end=E.range.start+s):E.range.end+=s}e(n,i,E.range,o,null,E)}};s.load({request:_,success:T,error:function(){u(null,n,o)}}),t.debug("Perform SIDX load for type ".concat(i," : ").concat(E.url," with range ").concat(E.range.start," - ").concat(E.range.end))}(e,n,i,a)}))},reset:function(){s&&(s.abort(),s=null)}}}Yt.__dashjs_factory_name="SegmentBaseLoader";var Ht=c.a.getSingletonFactory(Yt);function Vt(e){var t;e=e||{};var n=new DataView(e.data),r=0;function i(e,t){var i=!0,a=0;if(void 0===t&&(t=!1),e.tag>16777215?(n.getUint32(r)!==e.tag&&(i=!1),a=4):e.tag>65535?(256*n.getUint16(r)+n.getUint8(r+2)!==e.tag&&(i=!1),a=3):e.tag>255?(n.getUint16(r)!==e.tag&&(i=!1),a=2):(n.getUint8(r)!==e.tag&&(i=!1),a=1),!i&&e.required&&!t)throw new Error("required tag not found");return i&&(r+=a),i}function a(e){var t=1,i=128,a=-1,o=0,s=n.getUint8(r),u=0;for(u=0;u<8;u+=1){if((s&i)===i){o=void 0===e?s&~i:s,a=u;break}i>>=1}for(u=0;u<a;u+=1,t+=1)o=o<<8|255&n.getUint8(r+t);return r+=t,o}return t={getPos:function(){return r},setPos:function(e){r=e},consumeTag:i,consumeTagAndSize:function(e,t){var n=i(e,t);return n&&a(),n},parseTag:function(e){var n;return i(e),n=a(),t[e.parse](n)},skipOverElement:function(e,t){var n,o=i(e,t);return o&&(n=a(),r+=n),o},getMatroskaCodedNum:a,getMatroskaFloat:function(e){var t;switch(e){case 4:t=n.getFloat32(r),r+=4;break;case 8:t=n.getFloat64(r),r+=8}return t},getMatroskaUint:function(e){for(var t=0,i=0;i<e;i+=1)t<<=8,t|=255&n.getUint8(r+i);return r+=e,t},moreData:function(){return r<n.byteLength}}}Vt.__dashjs_factory_name="EBMLParser";var Kt=c.a.getClassFactory(Vt);function qt(){var e,t,n,r,i,o,s,u,l,c,f=this.context;function d(e,r,i,a){var o,s,u,l,c,d,h,p;for(u=[],c=0,d=(s=function(e){var t,r,i=[],a=Kt(f).create({data:e});for(a.consumeTagAndSize(n.Segment.Cues);a.moreData()&&a.consumeTagAndSize(n.Segment.Cues.CuePoint,!0);){for((t={}).CueTime=a.parseTag(n.Segment.Cues.CuePoint.CueTime),t.CueTracks=[];a.moreData()&&a.consumeTag(n.Segment.Cues.CuePoint.CueTrackPositions,!0);){var o=a.getMatroskaCodedNum(),s=a.getPos();if((r={}).Track=a.parseTag(n.Segment.Cues.CuePoint.CueTrackPositions.CueTrack),0===r.Track)throw new Error("Cue track cannot be 0");r.ClusterPosition=a.parseTag(n.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition),t.CueTracks.push(r),a.setPos(s+o)}if(0===t.CueTracks.length)throw new Error("Mandatory cuetrack not found");i.push(t)}if(0===i.length)throw new Error("mandatory cuepoint not found");return i}(e)).length;c<d;c+=1)l=new jt.a,o=0,o=c<s.length-1?s[c+1].CueTime-s[c].CueTime:a-s[c].CueTime,l.duration=o,l.startTime=s[c].CueTime,l.timescale=1e3,h=s[c].CueTracks[0].ClusterPosition+r,p=c<s.length-1?s[c+1].CueTracks[0].ClusterPosition+r-1:i-1,l.mediaRange=h+"-"+p,u.push(l);return t.debug("Parsed cues: "+u.length+" cues."),u}function h(e){var t=new qe.a;return t.setInfo(e),t}return e={setConfig:function(n){if(!(n.baseURLController&&n.dashMetrics&&n.mediaPlayerModel&&n.errHandler))throw new Error(a.a.MISSING_CONFIG_ERROR);c=n.baseURLController,o=n.dashMetrics,s=n.mediaPlayerModel,r=n.errHandler,l=n.errors,t=n.debug.getLogger(e),i=n.requestModifier},initialize:function(){u=Object(Ke.a)(f).create({errHandler:r,dashMetrics:o,mediaPlayerModel:s,requestModifier:i,errors:l})},loadInitialization:function(e,n){return new Promise((function(r){var i=null,a=e?c.resolve(e.path):null,o=e?e.range.split("-"):null,s={range:{start:o?parseFloat(o[0]):null,end:o?parseFloat(o[1]):null},request:i,url:a?a.url:void 0,init:!0,mediaType:n};t.info("Start loading initialization."),i=h(s);u.load({request:i,success:function(){r(e)},error:function(){r(e)}}),t.debug("Perform init load: "+s.url)}))},loadSegments:function(e,r,i){return new Promise((function(a){var o=null,s=e?c.resolve(e.path):null,p=s?s.url:void 0;o=h({bytesLoaded:0,bytesToLoad:8192,range:{start:0,end:8192},request:o,url:p,init:!1,mediaType:r}),t.debug("Parsing ebml header");u.load({request:o,success:function(r){!function(e,r,i,a){if(e&&0!==e.byteLength){var o,s,l,c,p=Kt(f).create({data:e}),g=i?i.split("-"):null,m=null,y={url:r,range:{start:g?parseFloat(g[0]):null,end:g?parseFloat(g[1]):null},request:m};for(t.debug("Parse EBML header: "+y.url),p.skipOverElement(n.EBML),p.consumeTag(n.Segment),l=p.getMatroskaCodedNum(),l+=p.getPos(),c=p.getPos();p.moreData()&&!p.consumeTagAndSize(n.Segment.Info,!0);)if(!(p.skipOverElement(n.Segment.SeekHead,!0)||p.skipOverElement(n.Segment.Tracks,!0)||p.skipOverElement(n.Segment.Cues,!0)||p.skipOverElement(n.Void,!0)))throw new Error("no valid top level element found");for(;void 0===o;){var E=p.getMatroskaCodedNum(!0),_=p.getMatroskaCodedNum();switch(E){case n.Segment.Info.Duration.tag:o=p[n.Segment.Info.Duration.parse](_);break;default:p.setPos(p.getPos()+_)}}m=h(y);u.load({request:m,success:function(e){s=d(e,c,l,o),a(s)},error:function(){t.error("Download Error: Cues "+y.url),a(null)}}),t.debug("Perform cues load: "+y.url+" bytes="+y.range.start+"-"+y.range.end)}else a(null)}(r,p,i,(function(t){a({segments:t,representation:e,error:t?void 0:new m.a(l.SEGMENT_BASE_LOADER_ERROR_CODE,l.SEGMENT_BASE_LOADER_ERROR_MESSAGE)})}))},error:function(){a({representation:e,error:new m.a(l.SEGMENT_BASE_LOADER_ERROR_CODE,l.SEGMENT_BASE_LOADER_ERROR_MESSAGE)})}})}))},reset:function(){u&&(u.abort(),u=null)}},n={EBML:{tag:440786851,required:!0},Segment:{tag:408125543,required:!0,SeekHead:{tag:290298740,required:!0},Info:{tag:357149030,required:!0,TimecodeScale:{tag:2807729,required:!0,parse:"getMatroskaUint"},Duration:{tag:17545,required:!0,parse:"getMatroskaFloat"}},Tracks:{tag:374648427,required:!0},Cues:{tag:475249515,required:!0,CuePoint:{tag:187,required:!0,CueTime:{tag:179,required:!0,parse:"getMatroskaUint"},CueTrackPositions:{tag:183,required:!0,CueTrack:{tag:247,required:!0,parse:"getMatroskaUint"},CueClusterPosition:{tag:241,required:!0,parse:"getMatroskaUint"}}}}},Void:{tag:236,required:!0}},e}qt.__dashjs_factory_name="WebmSegmentBaseLoader";var Wt=c.a.getSingletonFactory(qt);function zt(e){e=e||{};var t,n,r,i=this.context,a=e.eventBus,o=e.events,s=e.dashMetrics,u=e.mediaPlayerModel,l=e.errHandler,c=e.baseURLController,f=e.debug,d=e.boxParser,h=e.requestModifier,p=e.errors;function g(e){return"webm"===(e?e.split("/")[1]:"").toLowerCase()}return t={initialize:function(){n.initialize(),r.initialize()},getSegmentBaseInitSegment:function(e){return g(e.representation.mimeType)?r.loadInitialization(e.representation,e.mediaType):n.loadInitialization(e.representation,e.mediaType)},getSegmentList:function(e){return g(e.mimeType)?r.loadSegments(e.representation,e.mediaType,e.representation?e.representation.indexRange:null):n.loadSegments(e.representation,e.mediaType,e.representation?e.representation.indexRange:null)},reset:function(){n.reset(),r.reset()}},n=Ht(i).getInstance(),r=Wt(i).getInstance(),n.setConfig({baseURLController:c,dashMetrics:s,mediaPlayerModel:u,errHandler:l,eventBus:a,events:o,errors:p,debug:f,boxParser:d,requestModifier:h}),r.setConfig({baseURLController:c,dashMetrics:s,mediaPlayerModel:u,errHandler:l,eventBus:a,events:o,errors:p,debug:f,requestModifier:h}),t}zt.__dashjs_factory_name="SegmentBaseController";var Xt=c.a.getSingletonFactory(zt);var Qt=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.quality=null,this.fragmentDuration=null,this.mediaInfo=null,this.MSETimeOffset=null};var $t=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.index=null,this.type=null,this.streamInfo=null,this.representationCount=0,this.labels=null,this.lang=null,this.viewpoint=null,this.accessibility=null,this.audioChannelConfiguration=null,this.roles=null,this.codec=null,this.mimeType=null,this.contentProtection=null,this.KID=null,this.bitrateList=null,this.isFragmented=null,this.isEmbedded=null,this.selectionPriority=1};var Zt=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.id=null,this.index=null,this.start=NaN,this.duration=NaN,this.manifestInfo=null,this.isLast=!0};var Jt=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.dvrWindowSize=NaN,this.loadedTime=null,this.availableFrom=null,this.minBufferTime=NaN,this.duration=NaN,this.isDynamic=!1,this.maxFragmentDuration=null},en=n(43),tn=n(33);function nn(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var rn=function(){function e(t){var n=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.valid="/"==t[0],this.path=t.split("/").filter((function(e){return 0!==e.length})).map((function(e){var t={name:e},r=e.indexOf("[");if(-1!=r){t.name=e.substring(0,r);var i=e.substring(r+1,e.length-1);n.valid=n.valid&&-1==i.indexOf("[");var a=i.indexOf("=");-1!=a?(t.attribute={name:i.substring(1,a),value:i.substring(a+1)},-1!=["'",'"'].indexOf(t.attribute.value[0])&&(t.attribute.value=t.attribute.value.substring(1,t.attribute.value.length-1))):t.position=parseInt(i,10)-1}return t}))}var t,n,r;return t=e,(n=[{key:"isValid",value:function(){return this.valid}},{key:"findsElement",value:function(){return!this.findsAttribute()}},{key:"findsAttribute",value:function(){return this.path[this.path.length-1].name.startsWith("@")}},{key:"getMpdTarget",value:function(e,t){for(var n=null,r=e,i=1,a="MPD";i<this.path.length&&null!==r;){n=r;var o=this.path[i];if(a=o.name,i!==this.path.length-1||!a.startsWith("@")){var s=n[a+"_asArray"]||[];0===s.length&&n[a]&&s.push(n[a]),o.position?r=s[o.position]||null:o.attribute?function(){var e=o.attribute;r=s.filter((function(t){return t[e.name]==e.value}))[0]||null}():r=s[0]||null}i++}return null===r?null:a.startsWith("@")?{name:a.substring(1),leaf:r,target:r}:{name:a,leaf:r,target:t?n:r}}}])&&nn(t.prototype,n),r&&nn(t,r),e}();function an(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var on=function(){function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.action=t,this.xpath=n,this.value=r,this.position=null}var t,n,r;return t=e,(n=[{key:"getMpdTarget",value:function(e){var t="remove"===this.action||"replace"===this.action||"before"===this.position||"after"===this.position;return this.xpath.getMpdTarget(e,t)}}])&&an(t.prototype,n),r&&an(t,r),e}();function sn(){var e,t,n=this.context;return e={getIsPatch:function(e){return e&&e.hasOwnProperty(o.a.ORIGINAL_MPD_ID)||!1},getPublishTime:function(e){return e&&e.hasOwnProperty(o.a.PUBLISH_TIME)?new Date(e[o.a.PUBLISH_TIME]):null},getOriginalPublishTime:function(e){return e&&e.hasOwnProperty(o.a.ORIGINAL_PUBLISH_TIME)?new Date(e[o.a.ORIGINAL_PUBLISH_TIME]):null},getMpdId:function(e){return e&&e[o.a.ORIGINAL_MPD_ID]||null},getPatchOperations:function(e){return e?(e.__children||[]).map((function(e){var n=Object.keys(e)[0];if("add"!==n&&"remove"!==n&&"replace"!==n)return t.warn("Ignoring node of invalid action: ".concat(n)),null;var r=e[n],i=r.sel;if("add"===n&&r.type){if(!r.type.startsWith("@"))return t.warn("Ignoring add action for prefixed namespace declaration: ".concat(r.type,"=").concat(r.__text)),null;i="".concat(i,"/").concat(r.type)}var a=new rn(i);if(!a.isValid())return t.warn("Ignoring action with invalid selector: ".concat(n," - ").concat(i)),null;var o=null;a.findsAttribute()?o=r.__text||"":"remove"!==n&&(o=r.__children.reduce((function(e,t){var n=Object.keys(t)[0];return"#text"!==n&&(e[n]=e[n]||[],e[n].push(t[n])),e}),{}));var s=new on(n,a,o);return"add"===n&&(s.position=r.pos),s})).filter((function(e){return!!e})):[]}},t=Object(f.a)(n).getInstance().getLogger(e),e}sn.__dashjs_factory_name="PatchManifestModel";var un=c.a.getSingletonFactory(sn);function ln(){var e,t,n,r,i,a,s,u=this.context;function l(e,n,a){var s,u=t.getAdaptationsForType(r[0].mpd.manifest,e,n);if(!u||0===u.length)return null;if(u.length>1&&a){var l=d(a,n);if(i[a.id]&&i[a.id][n])for(var f=0,h=u.length;f<h;f++)if(c(i[a.id][n],l[f]))return u[f];for(var p=0,g=u.length;p<g;p++)if(s=u[p],t.getRolesForAdaptation(s).filter((function(e){return e.value===o.a.MAIN}))[0])return u[p]}return u[0]}function c(e,t){if(!e||!t)return!1;var n=e.id===t.id,r=e.codec===t.codec,i=e.viewpoint===t.viewpoint,a=e.lang===t.lang,o=e.roles.toString()===t.roles.toString(),s=e.accessibility.toString()===t.accessibility.toString(),u=e.audioChannelConfiguration.toString()===t.audioChannelConfiguration.toString();return n&&r&&i&&a&&o&&s&&u}function f(e,n,r,i,o,s){var u,l,c,f,d,h,p=[];if(!i||0===i.length)return[];var g=t.getAdaptationsForPeriod(n);for(f=0,h=i.length;f<h;f++)if(u=i[f],l=_(g[c=t.getIndexForAdaptation(u,e,r.index)]),s){var m=l.accessibility.length;for(d=0;d<m;d++)if(l){var y=l.accessibility[d];if(0===y.indexOf("cea-608:")){var E=y.substring(8).split(";");if("CC"===E[0].substring(0,2))for(d=0;d<E.length;d++)l||(l=_.call(this,g[c])),T(l,E[d].substring(0,3),E[d].substring(4)),p.push(l),l=null;else for(d=0;d<E.length;d++)l||(l=_.call(this,g[c])),T(l,"CC"+(d+1),E[d]),p.push(l),l=null}else 0===y.indexOf("cea-608")&&(T(l,a.CC1,"eng"),p.push(l),l=null)}}else o===a.IMAGE?(l.type=a.IMAGE,p.push(l),l=null):l&&p.push(l);return p}function d(e,n,i){var o=r,s=i,u=[];if(s)S(),o=h(s);else{if(!(r.length>0))return u;s=r[0].mpd.manifest}var l=E(e,o),c=t.getAdaptationsForType(s,e?e.index:null,n);return u=f(s,l,e,c,n),n===a.TEXT&&(c=t.getAdaptationsForType(s,e?e.index:null,a.VIDEO),u=u.concat(f(s,l,e,c,n,!0))),u}function h(e){var n=p(e);return t.getRegularPeriods(n)}function p(e){var n=m(e);return t.getMpd(n)}function g(){r=[],i={}}function m(e){return e||(r.length>0?r[0].mpd.manifest:null)}function y(e){try{var n=E(e.streamInfo,r),i=t.getAdaptationsForPeriod(n);return e&&e.streamInfo&&void 0!==e.streamInfo.id&&i?i[e.index]:null}catch(e){return null}}function E(e,t){for(var n=t.length,r=0;r<n;r++){var i=t[r];if(e&&e.id===i.id)return i}return null}function _(e){if(!e)return null;var n,r=new $t,i=e.period.mpd.manifest.Period_asArray[e.period.index].AdaptationSet_asArray[e.index];if(r.id=e.id,r.index=e.index,r.type=e.type,r.streamInfo=v(e.period),r.representationCount=t.getRepresentationCount(i),r.labels=t.getLabelsForAdaptation(i),r.lang=t.getLanguageForAdaptation(i),n=t.getViewpointForAdaptation(i),r.viewpoint=n?n.value:void 0,r.accessibility=t.getAccessibilityForAdaptation(i).map((function(e){var t=e.value,n=t;return e.schemeIdUri&&e.schemeIdUri.search("cea-608")>=0&&void 0!==s&&(n=t?"cea-608:"+t:"cea-608",r.embeddedCaptions=!0),n})),r.audioChannelConfiguration=t.getAudioChannelConfigurationForAdaptation(i).map((function(e){return e.value})),0===r.audioChannelConfiguration.length&&Array.isArray(i.Representation_asArray)&&i.Representation_asArray.length>0&&(r.audioChannelConfiguration=t.getAudioChannelConfigurationForRepresentation(i.Representation_asArray[0]).map((function(e){return e.value}))),r.roles=t.getRolesForAdaptation(i).map((function(e){return e.value})),r.codec=t.getCodec(i),r.mimeType=t.getMimeType(i),r.contentProtection=t.getContentProtectionData(i),r.bitrateList=t.getBitrateListForAdaptation(i),r.selectionPriority=t.getSelectionPriority(i),r.contentProtection){var a=r.contentProtection.map((function(e){return t.getKID(e)})).filter((function(e){return null!==e}));if(a.length){var o=a[0];r.contentProtection.forEach((function(e){e.keyId=o}))}}return r.isText=t.getIsText(i),r.supplementalProperties=t.getSupplementalProperties(i),r.isFragmented=t.getIsFragmented(i),r.isEmbedded=!1,r}function T(e,t,n){e.id=t,e.index=100+parseInt(t.substring(2,3)),e.type=a.TEXT,e.codec="cea-608-in-SEI",e.isEmbedded=!0,e.isFragmented=!1,e.lang=n,e.roles=["caption"]}function v(e){var n,r,i=new Zt;return i.id=e.id,i.index=e.index,i.start=e.start,i.duration=e.duration,i.manifestInfo=(n=e.mpd,(r=new Jt).dvrWindowSize=n.timeShiftBufferDepth,r.loadedTime=n.manifest.loadedTime,r.availableFrom=n.availabilityStartTime,r.minBufferTime=n.manifest.minBufferTime,r.maxFragmentDuration=n.maxSegmentDuration,r.duration=t.getDuration(n.manifest),r.isDynamic=t.getIsDynamic(n.manifest),r.serviceDescriptions=t.getServiceDescriptions(n.manifest),r.protocol=n.manifest.protocol,r),i.isLast=1===e.mpd.manifest.Period_asArray.length||Math.abs(i.start+i.duration-i.manifestInfo.duration)<1,i}function S(){if(!a)throw new Error("setConfig function has to be called previously")}function A(e){return r.length>0?r[0].mpd.manifest.Period_asArray[e]:null}function b(e,t,n){var r,i,a,o,s;if(e)for(r=e.AdaptationSet_asArray,o=0;o<r.length;o+=1)for(a=r[o].Representation_asArray,s=0;s<a.length;s+=1)if(t===(i=a[s]).id)return n?s:i;return null}return e={getBandwidthForRepresentation:function(e,t){var n;return(n=b(A(t),e))?n.bandwidth:null},getIndexForRepresentation:function(e,t){return function(e,t){var n=b(e,t,!0);return null!==n?n:-1}(A(t),e)},getMaxIndexForBufferType:function(e,n){return function(e,n){var r,i,a,o;if(!e||!n)return-1;for(i=e.AdaptationSet_asArray,o=0;o<i.length;o+=1)if(r=i[o],a=r.Representation_asArray,t.getIsTypeOf(r,n))return a.length;return-1}(A(n),e)},convertRepresentationToRepresentationInfo:function(e){if(e){var n=new Qt,r=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index],i=t.getRepresentationFor(e.index,r);return n.id=e.id,n.quality=e.index,n.bandwidth=t.getBandwidth(i),n.fragmentDuration=e.segmentDuration||(e.segments&&e.segments.length>0?e.segments[0].duration:NaN),n.MSETimeOffset=e.MSETimeOffset,n.mediaInfo=_(e.adaptation),n}return null},getStreamsInfo:function(e,t){var n=[],i=r;if(e&&(S(),i=h(e)),i.length>0){(!t||t>i.length)&&(t=i.length);for(var a=0;a<t;a++)n.push(v(i[a]))}return n},getMediaInfoForType:function(e,n){if(0===r.length||!e)return null;var i=E(e,r);if(!i)return null;var a=t.getAdaptationsForPeriod(i),o=l(e.index,n,e);return o?_(a[t.getIndexForAdaptation(o,r[0].mpd.manifest,e.index)]):null},getAllMediaInfoForType:d,getAdaptationForType:l,getRealAdaptation:function(e,n){var i,a,o=E(e,r);return i=n?n.id:null,r.length>0&&o&&(a=i?t.getAdaptationForId(i,r[0].mpd.manifest,o.index):t.getAdaptationForIndex(n?n.index:null,r[0].mpd.manifest,o.index)),a},getProducerReferenceTimes:function(e,n){var i,a,o=E(e,r);return i=n?n.id:null,r.length>0&&o&&(a=i?t.getAdaptationForId(i,r[0].mpd.manifest,o.index):t.getAdaptationForIndex(n?n.index:null,r[0].mpd.manifest,o.index)),a?t.getProducerReferenceTimesForAdaptation(a):[]},getRealPeriodByIndex:function(e){return t.getRealPeriodForIndex(e,r[0].mpd.manifest)},getEssentialPropertiesForRepresentation:function(e){try{return t.getEssentialPropertiesForRepresentation(e)}catch(e){return[]}},getVoRepresentations:function(e){var n=y(e);return t.getRepresentationsForAdaptation(n)},getEventsFor:function(e,n){var i=[];if(r.length>0){var a=r[0].mpd.manifest;e instanceof Zt?i=t.getEventsForPeriod(E(e,r)):e instanceof $t?i=t.getEventStreamForAdaptationSet(a,y(e)):e instanceof Qt&&(i=t.getEventStreamForRepresentation(a,n))}return i},getEvent:function(e,t,n,r){try{if(!e||!t||isNaN(n)||!r)return null;var i=e.scheme_id_uri,a=e.value;if(!t[i+"/"+a])return null;var o,s=new en.a,u=e.timescale||1,l=r.adaptation.period.start,c=t[i+"/"+a],f=isNaN(r.presentationTimeOffset)?isNaN(c.presentationTimeOffset)?0:c.presentationTimeOffset:r.presentationTimeOffset,d=e.presentation_time_delta/u;o=0===e.version?l+n-f+d:l-f+d;var h=e.event_duration,p=e.id,g=e.message_data;return s.eventStream=c,s.eventStream.value=a,s.eventStream.timescale=u,s.duration=h,s.id=p,s.calculatedPresentationTime=o,s.messageData=g,s.presentationTimeDelta=d,s}catch(e){return null}},getMpd:p,setConfig:function(e){e&&(e.constants&&(a=e.constants),e.cea608parser&&(s=e.cea608parser),e.errHandler&&t.setConfig({errHandler:e.errHandler}),e.BASE64&&t.setConfig({BASE64:e.BASE64}))},updatePeriods:function(e){if(!e)return null;S(),r=h(e)},getIsTextTrack:function(e){return t.getIsText(e)},getUTCTimingSources:function(){var e=m();return t.getUTCTimingSources(e)},getSuggestedPresentationDelay:function(){var e=r.length>0?r[0].mpd:null;return t.getSuggestedPresentationDelay(e)},getAvailabilityStartTime:function(e){var n=p(e);return t.getAvailabilityStartTime(n)},getIsTypeOf:function(e,n){return t.getIsTypeOf(e,n)},getIsDynamic:function(e){var n=m(e);return t.getIsDynamic(n)},getDuration:function(e){var n=m(e);return t.getDuration(n)},getRegularPeriods:h,getLocation:function(e){return t.getLocation(e)},getPatchLocation:function(e){var n=t.getPatchLocation(e),r=t.getPublishTime(e);if(!n||!r)return null;if(n.hasOwnProperty("ttl")&&r){var i=1e3*parseFloat(n.ttl);if(r.getTime()+i<=(new Date).getTime())return null}return n.__text},getManifestUpdatePeriod:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return t.getManifestUpdatePeriod(e,n)},getPublishTime:function(e){return t.getPublishTime(e)},getIsDVB:function(e){return t.hasProfile(e,"urn:dvb:dash:profile:dvb-dash:2014")},getIsPatch:function(e){return n.getIsPatch(e)},getBaseURLsFromElement:function(e){return t.getBaseURLsFromElement(e)},getRepresentationSortFunction:function(){return t.getRepresentationSortFunction()},getCodec:function(e,n,r){return t.getCodec(e,n,r)},getPeriodById:function(e){if(!e||0===r.length)return null;var t=r.filter((function(t){return t.id===e}));return t&&t.length>0?t[0]:null},setCurrentMediaInfo:function(e,t,n){i[e]=i[e]||{},i[e][t]=i[e][t]||{},i[e][t]=n},isPatchValid:function(e,r){var i=t.getId(e),a=n.getMpdId(r),o=t.getPublishTime(e),s=n.getPublishTime(r),u=n.getOriginalPublishTime(r);return!!(i&&a&&i==a&&o&&u&&o.getTime()==u.getTime()&&s&&o.getTime()<s.getTime())},applyPatchToManifest:function(e,t){n.getPatchOperations(t).forEach((function(t){var n=t.getMpdTarget(e);if(null!==n){var r=n.name,i=n.target,a=n.leaf;if(t.xpath.findsAttribute())switch(t.action){case"add":case"replace":i[r]=t.value;break;case"remove":delete i[r]}else{var o=(i[r+"_asArray"]||[]).indexOf(a),s="prepend"===t.position||"before"===t.position;if(("remove"===t.action||"replace"===t.action)&&(delete i[r],-1!=o)){var u=i[r+"_asArray"];u.splice(o,1),u.length>1?i[r]=u:1==u.length?i[r]=u[0]:delete i[r+"_asArray"]}"add"!==t.action&&"replace"!==t.action||Object.keys(t.value).forEach((function(e){var n=t.value[e],a=i[e+"_asArray"]||[];if(0===a.length&&i[e]&&a.push(i[e]),0===a.length)a=n;else{var u=a.length;u=e==r&&-1!=o?o+(s?0:1)+("replace"==t.action?-1:0):s?0:a.length,a.splice.apply(a,[u,0].concat(n))}i[e+"_asArray"]=a,i[e]=1==a.length?a[0]:a}))}}}))},areMediaInfosEqual:c,reset:g},t=Object(tn.a)(u).getInstance(),n=un(u).getInstance(),g(),e}ln.__dashjs_factory_name="DashAdapter";var cn=c.a.getSingletonFactory(ln);function fn(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var dn=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n,r;return t=e,r=[{key:"round10",value:function(e,t){return function(e,t,n){return void 0===n||0==+n?Math[e](t):(n=+n,null===(t=+t)||isNaN(t)||"number"!=typeof n||n%1!=0?NaN:(t=t.toString().split("e"),+((t=(t=Math[e](+(t[0]+"e"+(t[1]?+t[1]-n:-n)))).toString().split("e"))[0]+"e"+(t[1]?+t[1]+n:n))))}("round",e,t)}}],(n=null)&&fn(t.prototype,n),r&&fn(t,r),e}();var hn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.TcpList=[],this.HttpList=[],this.RepSwitchList=[],this.BufferLevel=[],this.BufferState=[],this.PlayList=[],this.DroppedFrames=[],this.SchedulingInfo=[],this.DVRInfo=[],this.ManifestUpdate=[],this.RequestsQueue=null,this.DVBErrors=[]};var pn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.t=null,this.mt=null,this.to=null,this.lto=null};var gn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.t=null,this.level=null};var mn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.target=null,this.state=s.a.BUFFER_EMPTY};var yn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.time=null,this.range=null,this.manifestInfo=null};var En=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.time=null,this.droppedFrames=null};function _n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var Tn=function e(){_n(this,e),this.mediaType=null,this.type=null,this.requestTime=null,this.fetchTime=null,this.availabilityStartTime=null,this.presentationStartTime=0,this.clientTimeOffset=0,this.currentTime=null,this.buffered=null,this.latency=0,this.streamInfo=[],this.representationInfo=[]},vn=function e(){_n(this,e),this.id=null,this.index=null,this.start=null,this.duration=null},Sn=function e(){_n(this,e),this.id=null,this.index=null,this.mediaType=null,this.streamIndex=null,this.presentationTimeOffset=null,this.startNumber=null,this.fragmentInfoType=null};var An=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.mediaType=null,this.t=null,this.type=null,this.startTime=null,this.availabilityStartTime=null,this.duration=null,this.quality=null,this.range=null,this.state=null};var bn=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.loadingRequests=[],this.executedRequests=[]};function In(e){var t,n,r=(e=e||{}).settings,i=this.context,o=Object(u.a)(i).getInstance();function c(){o.trigger(l.a.METRICS_CHANGED)}function f(e){o.trigger(l.a.METRIC_CHANGED,{mediaType:e}),c()}function d(e,t,n){o.trigger(l.a.METRIC_UPDATED,{mediaType:e,metric:t,value:n}),f(e)}function h(e,t,n){o.trigger(l.a.METRIC_ADDED,{mediaType:e,metric:t,value:n}),f(e)}function p(e,t){var r=null;return e?(n.hasOwnProperty(e)?r=n[e]:t||(r=new hn,n[e]=r),r):r}function g(e,t,n){var i=p(e);null!==i&&(i[t].push(n),i[t].length>r.get().streaming.metrics.maxListDepth&&i[t].shift())}function m(e,t,n){g(e,t,n),h(e,t,n)}return t={clearCurrentMetricsForType:function(e){delete n[e],f(e)},clearAllCurrentMetrics:function(){n={},c()},getMetricsFor:p,addHttpRequest:function e(t,n,r,i,a,o,u,l,c,f,d,h,p,g,y,E){var T=new _.a;o&&o!==i&&(e(t,null,r,i,a,null,null,l,c,null,null,null,p,null,null,E),T.actualurl=o),T.tcpid=n,T.type=r,T.url=i,T.range=l,T.trequest=c,T.tresponse=f,T.responsecode=h,T._tfinish=d,T._stream=t,T._mediaduration=p,T._quality=a,T._responseHeaders=g,T._serviceLocation=u,T._fileLoaderType=E,y?y.forEach((function(e){!function(e,t,n,r,i){var a=new _.b;a.s=t,a.d=n,a.b=r,a._t=i,e.trace.push(a),e.interval||(e.interval=0),e.interval+=n}(T,e.s,e.d,e.b,e.t)})):(delete T.interval,delete T.trace),m(t,s.a.HTTP_REQUEST,T)},addRepresentationSwitch:function(e,t,n,r,i){var a=new pn;a.t=t,a.mt=n,a.to=r,i?a.lto=i:delete a.lto,m(e,s.a.TRACK_SWITCH,a)},addBufferLevel:function(e,t,n){var r=new gn;r.t=t,r.level=n,m(e,s.a.BUFFER_LEVEL,r)},addBufferState:function(e,t,n){var r=new mn;r.target=n,r.state=t,m(e,s.a.BUFFER_STATE,r)},addDVRInfo:function(e,t,n,r){var i=new yn;i.time=t,i.range=r,i.manifestInfo=n,m(e,s.a.DVR_INFO,i)},addDroppedFrames:function(e,t){var n=new En,r=p(e).DroppedFrames;t&&(n.time=t.creationTime,n.droppedFrames=t.droppedVideoFrames,r.length>0&&r[r.length-1]==n||m(e,s.a.DROPPED_FRAMES,n))},addSchedulingInfo:function(e,t,n,r,i,a,o,u,l){var c=new An;c.mediaType=e,c.t=t,c.type=n,c.startTime=r,c.availabilityStartTime=i,c.duration=a,c.quality=o,c.range=u,c.state=l,m(e,s.a.SCHEDULING_INFO,c)},addRequestsQueue:function(e,t,n){var r=new bn;r.loadingRequests=t,r.executedRequests=n,p(e).RequestsQueue=r,h(e,s.a.REQUESTS_QUEUE,r)},addManifestUpdate:function(e,t,n,r,i,o,u,l,c,f){var d=new Tn;d.mediaType=e,d.type=t,d.requestTime=n,d.fetchTime=r,d.availabilityStartTime=i,d.presentationStartTime=o,d.clientTimeOffset=u,d.currentTime=l,d.buffered=c,d.latency=f,g(a.a.STREAM,s.a.MANIFEST_UPDATE,d),h(e,s.a.MANIFEST_UPDATE,d)},updateManifestUpdateInfo:function(e,t){if(e){for(var n in t)e[n]=t[n];d(e.mediaType,s.a.MANIFEST_UPDATE,e)}},addManifestUpdateStreamInfo:function(e,t,n,r,i){if(e){var a=new vn;a.id=t,a.index=n,a.start=r,a.duration=i,e.streamInfo.push(a),d(e.mediaType,s.a.MANIFEST_UPDATE_STREAM_INFO,e)}},addManifestUpdateRepresentationInfo:function(e,t,n,r,i,a,o,u){if(e&&e.representationInfo){var l=new Sn;l.id=t,l.index=n,l.streamIndex=r,l.mediaType=i,l.startNumber=o,l.fragmentInfoType=u,l.presentationTimeOffset=a,e.representationInfo.push(l),d(e.mediaType,s.a.MANIFEST_UPDATE_TRACK_INFO,e)}},addPlayList:function(e){e.trace&&Array.isArray(e.trace)?e.trace.forEach((function(e){e.hasOwnProperty("subreplevel")&&!e.subreplevel&&delete e.subreplevel})):delete e.trace,m(a.a.STREAM,s.a.PLAY_LIST,e)},addDVBErrors:function(e){m(a.a.STREAM,s.a.DVB_ERRORS,e)}},n={},t}In.__dashjs_factory_name="MetricsModel";var Rn=c.a.getSingletonFactory(In),Nn=n(15);function Cn(e){e=e||{};var t,n,r,i,o=this.context,u=e.metricsModel;function l(e){var t=u.getMetricsFor(e,!0);if(!t)return null;var n,r=t.HttpList,i=null;if(!r||r.length<=0)return null;for(n=r.length-1;n>=0;){if(r[n].responsecode){i=r[n];break}n--}return i}function c(e){var t=u.getMetricsFor(e,!0);return t&&t.HttpList?t.HttpList:[]}function f(e,t){if(!e)return null;var n=e[t];return n&&0!==n.length?n[n.length-1]:null}return t={getCurrentRepresentationSwitch:function(e){return f(u.getMetricsFor(e,!0),s.a.TRACK_SWITCH)},getCurrentBufferState:function(e){return f(u.getMetricsFor(e,!0),s.a.BUFFER_STATE)},getCurrentBufferLevel:function(e){var t=f(u.getMetricsFor(e,!0),s.a.BUFFER_LEVEL);return t?dn.round10(t.level/1e3,-3):0},getCurrentHttpRequest:l,getHttpRequests:c,getCurrentDroppedFrames:function(){return f(u.getMetricsFor(a.a.VIDEO,!0),s.a.DROPPED_FRAMES)},getCurrentSchedulingInfo:function(e){return f(u.getMetricsFor(e,!0),s.a.SCHEDULING_INFO)},getCurrentDVRInfo:function(e){return f(e?u.getMetricsFor(e,!0):u.getMetricsFor(a.a.VIDEO,!0)||u.getMetricsFor(a.a.AUDIO,!0),s.a.DVR_INFO)},getCurrentManifestUpdate:function(){return f(u.getMetricsFor(a.a.STREAM),s.a.MANIFEST_UPDATE)},getLatestFragmentRequestHeaderValueByID:function(e,t){if(!t)return null;var n={},r=l(e);r&&(n=Nn.a.parseHttpHeaders(r._responseHeaders));var i=n[t.toLowerCase()];return void 0===i?null:i},getLatestMPDRequestHeaderValueByID:function(e){if(!e)return null;var t,n,r,i={};for(r=(t=c(a.a.STREAM)).length-1;r>=0;r--)if((n=t[r]).type===_.a.MPD_TYPE){i=Nn.a.parseHttpHeaders(n._responseHeaders);break}var o=i[e.toLowerCase()];return void 0===o?null:o},addRepresentationSwitch:function(e,t,n,r,i){u.addRepresentationSwitch(e,t,n,r,i)},addDVRInfo:function(e,t,n,r){u.addDVRInfo(e,t,n,r)},updateManifestUpdateInfo:function(e){var t=this.getCurrentManifestUpdate();u.updateManifestUpdateInfo(t,e)},addManifestUpdateStreamInfo:function(e){if(e){var t=this.getCurrentManifestUpdate();u.addManifestUpdateStreamInfo(t,e.id,e.index,e.start,e.duration)}},addManifestUpdateRepresentationInfo:function(e,t){if(e){var n=this.getCurrentManifestUpdate();u.addManifestUpdateRepresentationInfo(n,e.id,e.index,e.streamIndex,t,e.presentationTimeOffset,e.startNumber,e.fragmentInfoType)}},addManifestUpdate:function(e){u.addManifestUpdate(a.a.STREAM,e.type,e.requestStartDate,e.requestEndDate)},addHttpRequest:function(e,t,n,r,i){u.addHttpRequest(e.mediaType,null,e.type,e.url,e.quality,t,e.serviceLocation||null,e.range||null,e.requestStartDate,e.firstByteDate,e.requestEndDate,n,e.duration,r,i,e.fileLoaderType)},addSchedulingInfo:function(e,t){u.addSchedulingInfo(e.mediaType,new Date,e.type,e.startTime,e.availabilityStartTime,e.duration,e.quality,e.range,t)},addRequestsQueue:function(e,t,n){u.addRequestsQueue(e,t,n)},addBufferLevel:function(e,t,n){u.addBufferLevel(e,t,n)},addBufferState:function(e,t,n){u.addBufferState(e,t,n)},addDroppedFrames:function(e){u.addDroppedFrames(a.a.VIDEO,e)},addPlayList:function(){i&&(u.addPlayList(i),i=null)},addDVBErrors:function(e){u.addDVBErrors(e)},createPlaylistMetrics:function(e,t){(i=new U).start=new Date,i.mstart=e,i.starttype=t},createPlaylistTraceMetrics:function(e,t,i){!0===n&&(n=!1,(r=new B).representationid=e,r.start=new Date,r.mstart=t,r.playbackspeed=null!==i?i.toString():null)},updatePlayListTraceMetrics:function(e){if(r)for(var t in r)r[t]=e[t]},pushPlayListTraceMetrics:function(e,t){if(!1===n&&i&&r&&r.start){var a=r.start,o=e.getTime()-a.getTime();r.duration=o,r.stopreason=t,i.trace.push(r),n=!0}},clearAllCurrentMetrics:function(){u.clearAllCurrentMetrics()}},u=u||Rn(o).getInstance({settings:e.settings}),n=!0,r=null,i=null,t}Cn.__dashjs_factory_name="DashMetrics";var wn=c.a.getSingletonFactory(Cn);function Dn(){var e,t,n,r,i=this.context,s=Object(u.a)(i).getInstance(),c=Object(E.a)(i).getInstance();function f(e){r=e}function h(e,t,n,r){var i,a=t.adaptation.period.mpd,o=a.availabilityStartTime;if(r)i=n&&a.timeShiftBufferDepth!==Number.POSITIVE_INFINITY?new Date(o.getTime()+1e3*(e+a.timeShiftBufferDepth)):a.availabilityEndTime;else if(n){var s=t.availabilityTimeOffset;i=new Date(o.getTime()+1e3*(e-s))}else i=o;return i}function p(e,t){return(e.getTime()-t.mpd.availabilityStartTime.getTime()+1e3*r)/1e3}function g(e,t){return e+(t.adaptation.period.start-t.presentationTimeOffset)}function m(e){var n={start:NaN,end:NaN},r=e[0].getAdapter().getRegularPeriods()[0],i=p(new Date,r);if(!e||0===e.length)return{range:n,now:i};e.forEach((function(e){var r=e.getAdapter(),s=r.getMediaInfoForType(e.getStreamInfo(),a.a.VIDEO)||r.getMediaInfoForType(e.getStreamInfo(),a.a.AUDIO),u=r.getVoRepresentations(s)[0],l={start:NaN,end:NaN};if(u)if(u.segmentInfoType===o.a.SEGMENT_TIMELINE)l=function(e){var n,r,i,a,o=e.adaptation.period.mpd.manifest.Period_asArray[e.adaptation.period.index].AdaptationSet_asArray[e.adaptation.index],s=t.getRepresentationFor(e.index,o),u=s.SegmentTemplate.SegmentTimeline,l=s.SegmentTemplate.timescale,c=u.S_asArray,f={start:0,end:0},d=0;for(f.start=g(c[0].t/l,e),i=0,a=c.length;i<a;i++)n=c[i],r=0,n.hasOwnProperty("r")&&(r=n.r),d+=n.d/l*(1+r);return f.end=f.start+d,f}(u);else{var c=u.adaptation.period;l.start=c.start,l.end=Math.max(i,c.start+c.duration)}!isNaN(l.start)&&(isNaN(n.start)||n.start>l.start)&&(n.start=l.start),!isNaN(l.end)&&(isNaN(n.end)||n.end<l.end)&&(n.end=l.end)})),n.end=Math.min(i,n.end);var s=_(e,n.end,!0);return n.end=isNaN(s)?n.end:s,n.start=r&&r.mpd&&r.mpd.timeShiftBufferDepth&&!isNaN(r.mpd.timeShiftBufferDepth)&&!isNaN(n.end)?Math.max(n.end-r.mpd.timeShiftBufferDepth,n.start):n.start,n.start=_(e,n.start),{range:n,now:i}}function y(e,t){n=e-t.end}function _(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];try{for(var r=0,i=!1,a=NaN;!i&&r<e.length;){var o=e[r].getStreamInfo();o.start<=t&&(!isFinite(o.duration)||o.start+o.duration>=t)?(a=t,i=!0):!n&&o.start>t&&(isNaN(a)||o.start<a)?a=o.start:n&&o.start+o.duration<t&&(isNaN(a)||o.start+o.duration>a)&&(a=o.start+o.duration),r+=1}return a}catch(e){return t}}function T(e){void 0===e.offset||isNaN(e.offset)||f(e.offset/1e3)}function v(){r=0,n=0}function S(){s.off(l.a.UPDATE_TIME_SYNC_OFFSET,T,this),v()}return e={initialize:function(){v(),s.on(l.a.UPDATE_TIME_SYNC_OFFSET,T,this)},getClientTimeOffset:function(){return r},setClientTimeOffset:f,getClientReferenceTime:function(){return Date.now()-1e3*n+1e3*r},calcAvailabilityStartTimeFromPresentationTime:function(e,t,n){return h(e,t,n)},calcAvailabilityEndTimeFromPresentationTime:function(e,t,n){return h(e,t,n,!0)},calcPresentationTimeFromWallTime:p,calcPresentationTimeFromMediaTime:g,calcPeriodRelativeTimeFromMpdRelativeTime:function(e,t){return t-e.adaptation.period.start},calcMediaTimeFromPresentationTime:function(e,t){return e-t.adaptation.period.start+t.presentationTimeOffset},calcWallTimeForSegment:function(e,t){var n,r,i;return t&&(n=e.representation.adaptation.period.mpd.suggestedPresentationDelay,r=e.presentationStartTime+n,i=new Date(e.availabilityStartTime.getTime()+1e3*r)),i},calcTimeShiftBufferWindow:function(e,t){if(!t)return function(e){var t={start:NaN,end:NaN},n=0,r=NaN;return e.forEach((function(e){var t=e.getStreamInfo();n+=t.duration,(isNaN(r)||t.start<r)&&(r=t.start)})),t.start=r,t.end=r+n,t}(e);if(c.get().streaming.timeShiftBuffer.calcFromSegmentTimeline){var n=m(e);return y(n.now,n.range),n.range}return function(e){var t={start:NaN,end:NaN};if(!e||0===e.length)return t;var n=e[0].getAdapter().getRegularPeriods()[0],r=p(new Date,n),i=n.mpd.timeShiftBufferDepth,a=isNaN(i)?0:r-i;t.start=_(e,a),t.end=!isNaN(t.start)&&r<t.start?r:_(e,r,!0),!isNaN(i)&&t.end<r-i&&(t.end=NaN);if(c.get().streaming.timeShiftBuffer.fallbackToSegmentTimeline){var o=m(e);if(o.range.end<t.start)return s.trigger(d.a.CONFORMANCE_VIOLATION,{level:he.LEVELS.WARNING,event:he.EVENTS.INVALID_DVR_WINDOW}),y(o.now,o.range),o.range}return t}(e)},reset:S},t=Object(tn.a)(i).getInstance(),S(),e}Dn.__dashjs_factory_name="TimelineConverter";var On=c.a.getSingletonFactory(Dn),Mn=n(56),Pn=n.n(Mn),Ln=n(24),Fn=n.n(Ln);function xn(e){return(xn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function Un(e,t){return(Un=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Bn(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=Gn(e);if(t){var i=Gn(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return kn(this,n)}}function kn(e,t){return!t||"object"!==xn(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function Gn(e){return(Gn=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var jn=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&Un(e,t)}(n,e);var t=Bn(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).captionData=null,e.label=null,e.defaultTrack=!1,e.kind=null,e.isFragmented=!1,e.isEmbedded=!1,e.isTTML=null,e}return n}($t),Yn=n(49);function Hn(){var e=0;function t(e){for(var t="",n=0;n<e.length;++n){t+=e[n].uchar}return t.length-t.replace(/^\s+/,"").length}function n(e){return"left: "+3.125*e.x+"%; top: "+6.66*e.y1+"%; width: "+(100-3.125*e.x)+"%; height: "+6.66*Math.max(e.y2-1-e.y1,1)+"%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;"}function r(e){return"red"===e?"rgb(255, 0, 0)":"green"===e?"rgb(0, 255, 0)":"blue"===e?"rgb(0, 0, 255)":"cyan"===e?"rgb(0, 255, 255)":"magenta"===e?"rgb(255, 0, 255)":"yellow"===e?"rgb(255, 255, 0)":"white"===e?"rgb(255, 255, 255)":"black"===e?"rgb(0, 0, 0)":e}function i(e,t){var n=e.videoHeight/15;return t?"font-size: "+n+"px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; color: "+(t.foreground?r(t.foreground):"rgb(255, 255, 255)")+"; font-style: "+(t.italics?"italic":"normal")+"; text-decoration: "+(t.underline?"underline":"none")+"; white-space: pre; background-color: "+(t.background?r(t.background):"transparent")+";":"font-size: "+n+"px; font-family: Menlo, Consolas, 'Cutive Mono', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;"}function a(e){return e.replace(/^\s+/g,"")}function o(e){return e.replace(/\s+$/g,"")}return{createHTMLCaptionsFromScreen:function(r,s,u,l){var c,f,d=null,h=!1,p=-1,g={start:s,end:u,spans:[]},m="style_cea608_white_black",y={},E={},_=[];for(c=0;c<15;++c){var T=l.rows[c],v="",S=null;if(!1===T.isEmpty()){var A=t(T.chars);null===d&&(d={x:A,y1:c,y2:c+1,p:[]}),A!==p&&h&&(d.p.push(g),g={start:s,end:u,spans:[]},d.y2=c,d.name="region_"+d.x+"_"+d.y1+"_"+d.y2,!1===y.hasOwnProperty(d.name)?(_.push(d),y[d.name]=d):y[d.name].p.contat(d.p),d={x:A,y1:c,y2:c+1,p:[]});for(var b=0;b<T.chars.length;++b){var I=T.chars[b],R=I.penState;if(null===S||!R.equals(S)){v.trim().length>0&&(g.spans.push({name:m,line:v,row:c}),v="");var N="style_cea608_"+R.foreground+"_"+R.background;R.underline&&(N+="_underline"),R.italics&&(N+="_italics"),E.hasOwnProperty(N)||(E[N]=JSON.parse(JSON.stringify(R))),S=R,m=N}v+=I.uchar}v.trim().length>0&&g.spans.push({name:m,line:v,row:c}),h=!0,p=A}else h=!1,p=-1,d&&(d.p.push(g),g={start:s,end:u,spans:[]},d.y2=c,d.name="region_"+d.x+"_"+d.y1+"_"+d.y2,!1===y.hasOwnProperty(d.name)?(_.push(d),y[d.name]=d):y[d.name].p.contat(d.p),d=null)}d&&(d.p.push(g),d.y2=c+1,d.name="region_"+d.x+"_"+d.y1+"_"+d.y2,!1===y.hasOwnProperty(d.name)?(_.push(d),y[d.name]=d):y[d.name].p.contat(d.p),d=null);var C=[];for(c=0;c<_.length;++c){var w=_[c],D="sub_cea608_"+e++,O=document.createElement("div");O.id=D;var M=n(w);O.style.cssText="position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;"+M;var P=document.createElement("div");P.className="paragraph bodyStyle",P.style.cssText=i(r);var L=document.createElement("div");L.className="cueUniWrapper",L.style.cssText="unicode-bidi: normal; direction: ltr;";for(var F=0;F<w.p.length;++F){var x=w.p[F],U=0;for(f=0;f<x.spans.length;++f){var B=x.spans[f];if(B.line.length>0){if(0!==f&&U!=B.row){var k=document.createElement("br");k.className="lineBreak",L.appendChild(k)}var G=!1;U===B.row&&(G=!0),U=B.row;var j=E[B.name],Y=document.createElement("span");Y.className="spanPadding "+B.name+" customSpanColor",Y.style.cssText=i(r,j),0!==f&&G?f===x.spans.length-1?Y.textContent=o(B.line):Y.textContent=B.line:x.spans.length>1&&f<x.spans.length-1&&B.row===x.spans[f+1].row?Y.textContent=a(B.line):Y.textContent=B.line.trim(),L.appendChild(Y)}}}P.appendChild(L),O.appendChild(P);var H={bodyStyle:["%",90]};for(var V in E)E.hasOwnProperty(V)&&(H[V]=["%",90]);C.push({type:"html",start:s,end:u,cueHTMLElement:O,cueID:D,cellResolution:[32,15],isFromCEA608:!0,fontSize:H,lineHeight:{},linePadding:{}})}return C}}}Hn.__dashjs_factory_name="EmbeddedTextHtmlRender";var Vn=c.a.getSingletonFactory(Hn);function Kn(e){var t,n,r,o,s,c,d,h,p,g,E,T,v,S,A,b,I=e.errHandler,R=e.manifestModel,N=e.mediaController,C=e.videoModel,w=e.textTracks,D=e.vttParser,O=e.ttmlParser,M=e.streamInfo,P=this.context,L=Object(u.a)(P).getInstance(),x=!1;function U(){c=null,h=NaN,p=[],g=null,d=!1,s=[],o=null}function B(e){var t=new jn;for(var n in e)t[n]=e[n];t.labels=e.labels,t.defaultTrack=function(e){var t=!1;T.length>1&&e.isEmbedded?t=e.id&&e.id===a.a.CC1:1===T.length?e.id&&"string"==typeof e.id&&"CC"===e.id.substring(0,2)&&(t=!0):0===T.length&&(t=e.index===s[0].index);return t}(e),t.isFragmented=e.isFragmented,t.isEmbedded=!!e.isEmbedded,t.isTTML=function(e){return e.codec&&e.codec.search(a.a.STPP)>=0||e.mimeType&&e.mimeType.search(a.a.TTML)>=0}(e),t.kind=function(e,t){var n=e.roles&&e.roles.length>0?t[e.roles[0]]:t.caption;return n=n===t.caption||n===t.subtitle?n:t.caption}(e,{subtitle:"subtitles",caption:"captions"}),w.addTextTrack(t)}function k(e){var t=e.chunk;t.mediaInfo.embeddedCaptions&&j(t.bytes,t)}function G(e){E=e}function j(e,s){var u=s.mediaInfo,l=u.type,f=u.mimeType,p=u.codec||f;p?-1!==u.codec.indexOf("application/mp4")?function(e,i,s){var u,l;if("InitializationSegment"===i.segmentType)d=!0,h=r.getMediaTimescaleFromMoov(e);else{if(!d)return;l=r.getSamplesInfo(e),(u=l.sampleList).length>0&&(g=u[0].cts-i.start*h),s.search(a.a.STPP)>=0?function(e,r,i){var s,u;for(o=null!==o?o:V(i),s=0;s<r.length;s++){var l=r[s],f=l.cts,d=H(),p=d+f/h,g=p+l.duration/h;t.buffered.add(p,g);var m=new DataView(e,l.offset,l.subSizes[0]),y=Fn.a.Utils.dataViewToString(m,a.a.UTF8),_=[],T=l.offset+l.subSizes[0];for(u=1;u<l.subSizes.length;u++){var v=new Uint8Array(e,T,l.subSizes[u]),S=String.fromCharCode.apply(null,v);_.push(S),T+=l.subSizes[u]}try{var A=R.getValue().ttmlTimeIsRelative?f/h:0,b=o.parse(y,A,f/h,(f+l.duration)/h,_);w.addCaptions(E,d,b)}catch(e){c.removeExecutedRequestsBeforeTime(),this.remove(),n.error("TTML parser error: "+e.message)}}}(e,u,s):function(e,r){var i,a,o,s=[];for(i=0;i<r.length;i++){var u=r[i];u.cts-=g;var l=H()+u.cts/h,c=l+u.duration/h;t.buffered.add(l,c);var f=e.slice(u.offset,u.offset+u.size),d=Fn.a.parseBuffer(f);for(a=0;a<d.boxes.length;a++){var p=d.boxes[a];if(n.debug("VTT box1: "+p.type),"vtte"!==p.type&&"vttc"===p.type)for(n.debug("VTT vttc boxes.length = "+p.boxes.length),o=0;o<p.boxes.length;o++){var m=p.boxes[o];if(n.debug("VTT box2: "+m.type),"payl"===m.type){var y=m.cue_text;n.debug("VTT cue_text = "+y);var _=u.cts/h,T=(u.cts+u.duration)/h;s.push({start:_,end:T,data:y,styles:{}}),n.debug("VTT "+_+"-"+T+" : "+y)}}}}s.length>0&&w.addCaptions(E,0,s)}(e,u)}}(e,s,p):l===a.a.VIDEO?function(e,t){var a,o;if(t.segmentType===_.a.INIT_SEGMENT_TYPE)0===v&&(v=r.getMediaTimescaleFromMoov(e));else if(t.segmentType===_.a.MEDIA_SEGMENT_TYPE){if(0===v)return void n.warn("CEA-608: No timescale for embeddedTextTrack yet");var s=(o=r.getSamplesInfo(e)).lastSequenceNumber;if(A[0]||A[1]||function(){for(var e,t=0;t<T.length;t++){if(-1===(e=w.getTrackIdxForId(T[t].id)))return void n.warn("CEA-608: data before track is ready.");var r=Y(e);A[t]=new i.a.Cea608Parser(t+1,{newCue:r},null)}}(),v){if(null!==S&&s!==S+o.numSequences)for(a=0;a<A.length;a++)A[a]&&A[a].reset();for(var u=function(e,t){if(0===t.length)return null;for(var n={splits:[],fields:[[],[]]},r=new DataView(e),a=0;a<t.length;a++)for(var o=t[a],s=i.a.findCea608Nalus(r,o.offset,o.size),u=null,l=0,c=0;c<s.length;c++)for(var f=i.a.extractCea608DataFromRange(r,s[c]),d=0;d<2;d++)if(f[d].length>0){o.cts!==u?l=0:l+=1;var h=H();n.fields[d].push([o.cts+h*v,f[d],l]),u=o.cts}return n.fields.forEach((function(e){e.sort((function(e,t){return e[0]===t[0]?e[2]-t[2]:e[0]-t[0]}))})),n}(e,o.sampleList),l=0;l<A.length;l++){var c=u.fields[l],f=A[l];if(f)for(a=0;a<c.length;a++)f.addData(c[a][0]/v,c[a][1])}S=s}}}(e,s):function(e,n,r){var i,o,s=new DataView(e,0,e.byteLength);o=Fn.a.Utils.dataViewToString(s,a.a.UTF8);try{i=V(r).parse(o,0),w.addCaptions(w.getCurrentTrackIdx(),0,i),t.buffered&&t.buffered.add(n.start,n.end)}catch(e){I.error(new m.a(y.a.TIMED_TEXT_ERROR_ID_PARSE_CODE,y.a.TIMED_TEXT_ERROR_MESSAGE_PARSE+e.message,o))}}(e,s,p):n.error("No text type defined")}function Y(e){return function(t,n,r){var i;i=C.getTTMLRenderingDiv()?b.createHTMLCaptionsFromScreen(C.getElement(),t,n,r):[{start:t,end:n,data:r.getDisplayText(),styles:{}}],i&&w.addCaptions(e,0,i)}}function H(){return isNaN(t.timestampOffset)?0:t.timestampOffset}function V(e){var t;return e.search(a.a.VTT)>=0?t=D:(e.search(a.a.TTML)>=0||e.search(a.a.STPP)>=0)&&(t=O),t}function K(e){T.forEach((function(t){var n=w.getTrackIdxForId(t.id);n>=0&&w.deleteCuesFromTrackIdx(n,e.from,e.to)}))}return t={initialize:function(){x||(T=[],E=null,v=0,A=[],S=null,x=!0,b=Vn(P).getInstance(),L.on(l.a.VIDEO_CHUNK_RECEIVED,k,t),L.on(l.a.BUFFER_CLEARED,K,t))},addMediaInfos:function(e,n,r){if(s=s.concat(n),e===a.a.TEXT&&n[0].isFragmented&&!n[0].isEmbedded){c=r,t.buffered=Object(Yn.a)(P).create(),p=N.getTracksFor(a.a.TEXT,M.id).filter((function(e){return e.isFragmented}));for(var i=N.getCurrentTrackFor(a.a.TEXT,M.id),o=0;o<p.length;o++)if(p[o]===i){G(o);break}}for(var u=0;u<n.length;u++)B(n[u])},resetMediaInfos:function(){s=[]},getStreamId:function(){return M.id},append:j,abort:function(){},addEmbeddedTrack:function(e){if(x&&e)if(e.id===a.a.CC1||e.id===a.a.CC3){for(var t=0;t<T.length;t++)if(T[t].id===e.id)return;T.push(e)}else n.warn("Embedded track "+e.id+" not supported!")},resetEmbedded:function(){L.off(l.a.VIDEO_CHUNK_RECEIVED,k,t),L.off(l.a.BUFFER_CLEARED,K,t),w&&w.deleteAllTextTracks(),x=!1,T=[],A=[null,null],S=null},getConfig:function(){return{fragmentModel:c,fragmentedTracks:p,videoModel:C}},setCurrentFragmentedTrackIdx:G,remove:function(e,n){void 0===e&&e===n&&(e=t.buffered.start(0),n=t.buffered.end(t.buffered.length-1)),t.buffered.remove(e,n),w.deleteCuesFromTrackIdx(E,e,n)},reset:function(){U(),s=[],r=null}},n=Object(f.a)(P).getInstance().getLogger(t),r=Object(F.a)(P).getInstance(),U(),t}Kn.__dashjs_factory_name="TextSourceBuffer";var qn=c.a.getClassFactory(Kn),Wn=n(48);function zn(e){var t,n,r,i,o,s,c,h,p,g,m,y,E,_,T,v,S,A=this.context,b=Object(u.a)(A).getInstance(),I=e.videoModel,R=e.streamInfo;function N(e,t,n,r,i,a){var o=0,s=0;e/t>n/r?o=(s=t)/r*n:s=(o=e)/n*r;var u,l,c=0,f=0;return o/s>i?(f=s,c=s*i):(c=o,f=o/i),u=(e-c)/2,l=(t-f)/2,a?{x:u+.1*c,y:l+.1*f,w:.8*c,h:.8*f}:{x:u,y:l,w:c,h:f}}function C(e,t){var n=I.getClientWidth(),r=I.getClientHeight(),i=I.getVideoWidth(),a=I.getVideoHeight(),o=I.getVideoRelativeOffsetTop(),s=I.getVideoRelativeOffsetLeft();if(0!==i&&0!==a){var u=i/a,l=!1;e.isFromCEA608&&(u=3.5/3,l=!0);var f=N.call(this,n,r,i,a,u,l),y=f.w,T=f.h,S=f.x,A=f.y;if(y!=p||T!=g||S!=c||A!=h||t){if(c=S+s,h=A+o,p=y,g=T,m){var R=m.style;R&&(R.left=c+"px",R.top=h+"px",R.width=p+"px",R.height=g+"px",R.zIndex=E&&document[E]||_?v:null,b.trigger(d.a.CAPTION_CONTAINER_RESIZE))}var C=e.activeCues;if(C)for(var w=C.length,D=0;D<w;++D){var O=C[D];O.scaleCue(O)}}}}function w(e){var t,n,r,i,a,o=p,s=g;if(e.cellResolution){var u=[o/e.cellResolution[0],s/e.cellResolution[1]];if(e.linePadding)for(t in e.linePadding)if(e.linePadding.hasOwnProperty(t)){n=(e.linePadding[t]*u[0]).toString();for(var l=document.getElementsByClassName("spanPadding"),c=0;c<l.length;c++)l[c].style.cssText=l[c].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi,"$1"+n),l[c].style.cssText=l[c].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi,"$1"+n)}if(e.fontSize){for(t in e.fontSize)if(e.fontSize.hasOwnProperty(t)){"%"===e.fontSize[t][0]?r=e.fontSize[t][1]/100:"c"===e.fontSize[t][0]&&(r=e.fontSize[t][1]),n=(r*u[1]).toString(),a="defaultFontSize"!==t?document.getElementsByClassName(t):document.getElementsByClassName("paragraph");for(var f=0;f<a.length;f++)a[f].style.cssText=a[f].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi,"$1"+n)}if(e.lineHeight)for(t in e.lineHeight)if(e.lineHeight.hasOwnProperty(t)){"%"===e.lineHeight[t][0]?i=e.lineHeight[t][1]/100:"c"===e.fontSize[t][0]&&(i=e.lineHeight[t][1]),n=(i*u[1]).toString(),a=document.getElementsByClassName(t);for(var d=0;d<a.length;d++)a[d].style.cssText=a[d].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi,"$1"+n)}}}if(e.isd){var h=document.getElementById(e.cueID);h&&m.removeChild(h),D(e)}}function D(e){if(m){var t=document.createElement("div");m.appendChild(t),T=Object(Wn.renderHTML)(e.isd,t,(function(t){var n=/^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/,r=/^#(.*)$/;if(n.test(t)){var i=n.exec(t),a=parseInt(i[4],10)-1;return"data:image/png;base64,"+btoa(e.images[a])}if(r.test(t)){var o=r.exec(t)[1];return"data:image/png;base64,"+e.embeddedImages[o]}return null}),m.clientHeight,m.clientWidth,!1,(function(e){n.info("renderCaption :",e)}),T,!0),t.id=e.cueID,b.trigger(d.a.CAPTION_RENDERED,{captionDiv:t,currentTrackIdx:s})}}function O(e,t,i){var o=M(e),u=this;if(o&&Array.isArray(i)&&0!==i.length)for(var l=0;l<i.length;l++){var f=void 0,y=i[l];o.cellResolution=y.cellResolution,o.isFromCEA608=y.isFromCEA608,"html"!==y.type||!m||isNaN(y.start)||isNaN(y.end)?!y.data||isNaN(y.start)||isNaN(y.end)||(f=new r(y.start-t,y.end-t,y.data),y.styles&&(void 0!==y.styles.align&&"align"in f&&(f.align=y.styles.align),void 0!==y.styles.line&&"line"in f&&(f.line=y.styles.line),void 0!==y.styles.position&&"position"in f&&(f.position=y.styles.position),void 0!==y.styles.size&&"size"in f&&(f.size=y.styles.size)),f.onenter=function(){o.mode===a.a.TEXT_SHOWING&&b.trigger(d.a.CAPTION_RENDERED,{currentTrackIdx:s})}):((f=new r(y.start+t,y.end+t,"")).cueHTMLElement=y.cueHTMLElement,f.isd=y.isd,f.images=y.images,f.embeddedImages=y.embeddedImages,f.cueID=y.cueID,f.scaleCue=w.bind(u),f.cellResolution=y.cellResolution,f.lineHeight=y.lineHeight,f.linePadding=y.linePadding,f.fontSize=y.fontSize,m.style.left=c+"px",m.style.top=h+"px",m.style.width=p+"px",m.style.height=g+"px",f.onenter=function(){o.mode===a.a.TEXT_SHOWING&&(this.isd?(D(this),n.debug("Cue enter id:"+this.cueID)):(m.appendChild(this.cueHTMLElement),w.call(u,this),b.trigger(d.a.CAPTION_RENDERED,{captionDiv:this.cueHTMLElement,currentTrackIdx:s})))},f.onexit=function(){if(m)for(var e=m.childNodes,t=0;t<e.length;++t)e[t].id===this.cueID&&(n.debug("Cue exit id:"+e[t].id),m.removeChild(e[t]),--t)});try{f?F(o,f)||o.addCue(f):n.error("impossible to display subtitles.")}catch(e){throw U(o),o.addCue(f),e}}}function M(e){return e>=0&&i[e]?I.getTextTrack(i[e].kind,i[e].id,i[e].lang,i[e].isTTML,i[e].isEmbedded):null}function P(e){var t=this;if(e!==s){var n=M(s=e);L.call(this,n),y&&(clearInterval(y),y=null),n&&"html"===n.renderingType&&(C.call(this,n,!0),window.ResizeObserver?(S=new window.ResizeObserver((function(){C.call(t,n,!0)}))).observe(I.getElement()):y=setInterval(C.bind(this,n),500))}}function L(e){G.call(this),e&&"html"===e.renderingType?B.call(this):k.call(this)}function F(e,t){if(!e.cues)return!1;for(var n=0;n<e.cues.length;n++)if(e.cues[n].startTime===t.startTime&&e.cues[n].endTime===t.endTime)return!0;return!1}function x(e,t,n){var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return(isNaN(t)||(r?e.startTime:e.endTime)>=t)&&(isNaN(n)||(r?e.endTime:e.startTime)<=n)}function U(e,t,n){var r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];if(e.cues)for(var i=e.cues,a=i.length-1,o=a;o>=0;o--)x(i[o],t,n,r)&&(i[o].onexit&&i[o].onexit(),e.removeCue(i[o]))}function B(){var e=document.getElementById("native-cue-style");if(!e){(e=document.createElement("style")).id="native-cue-style",document.head.appendChild(e);var t=e.sheet,r=I.getElement();try{r&&(r.id?t.insertRule("#"+r.id+"::cue {background: transparent}",0):0!==r.classList.length?t.insertRule("."+r.className+"::cue {background: transparent}",0):t.insertRule("video::cue {background: transparent}",0))}catch(e){n.info(""+e.message)}}}function k(){var e=document.getElementById("native-cue-style");e&&document.head.removeChild(e)}function G(){if(m)for(;m.firstChild;)m.removeChild(m.firstChild)}return t={initialize:function(){"undefined"!=typeof window&&"undefined"!=typeof navigator&&(r=window.VTTCue||window.TextTrackCue,i=[],o=[],s=-1,c=0,h=0,p=0,g=0,m=null,y=null,_=!1,v=2147483647,T=null,void 0!==document.fullscreenElement?E="fullscreenElement":void 0!==document.webkitIsFullScreen?E="webkitIsFullScreen":document.msFullscreenElement?E="msFullscreenElement":document.mozFullScreen&&(E="mozFullScreen"))},getStreamId:function(){return R.id},addTextTrack:function(e){i.push(e)},addCaptions:O,createTracks:function(){i.sort((function(e,t){return e.index-t.index})),m=I.getTTMLRenderingDiv();for(var e,t,n,r,u,c,f=-1,h=0;h<i.length;h++){var p=(e=i[h],t=void 0,n=void 0,r=void 0,u=void 0,c=void 0,t=e.kind,n=void 0!==e.id?e.id:e.lang,r=e.lang,u=e.isTTML,c=e.isEmbedded,I.addTextTrack(t,n,r,u,c));o.push(p),i[h].defaultTrack&&(p.default=!0,f=h);var g=M(h);g&&(g.mode=a.a.TEXT_SHOWING,m&&(i[h].isTTML||i[h].isEmbedded)?g.renderingType="html":g.renderingType="default"),O(h,0,i[h].captionData),b.trigger(d.a.TEXT_TRACK_ADDED)}if(P.call(this,f),f>=0){b.on(d.a.PLAYBACK_METADATA_LOADED,(function e(){var t=M(f);t&&"html"===t.renderingType&&C.call(this,t,!0),b.off(d.a.PLAYBACK_METADATA_LOADED,e,this)}),this);for(var y=0;y<i.length;y++){var E=M(y);E&&(E.mode=y===f?a.a.TEXT_SHOWING:a.a.TEXT_HIDDEN)}}b.trigger(l.a.TEXT_TRACKS_QUEUE_INITIALIZED,{index:s,tracks:i,streamId:R.id})},getCurrentTrackIdx:function(){return s},setCurrentTrackIdx:P,getTrackIdxForId:function(e){for(var t=-1,n=0;n<i.length;n++)if(i[n].id===e){t=n;break}return t},getCurrentTrackInfo:function(){return i[s]},setModeForTrackIdx:function(e,t){var n=M(e);n&&n.mode!==t&&(n.mode=t)},deleteCuesFromTrackIdx:function(e,t,n){var r=M(e);r&&U(r,t,n)},deleteAllTextTracks:function(){for(var e=o?o.length:0,t=0;t<e;t++){var n=M(t);n&&U.call(this,n,R.start,R.start+R.duration,!1)}o=[],i=[],y&&(clearInterval(y),y=null),S&&I&&(S.unobserve(I.getElement()),S=null),s=-1,G.call(this)},deleteTextTrack:function(e){I.removeChild(o[e]),o.splice(e,1)}},n=Object(f.a)(A).getInstance().getLogger(t),t}zn.__dashjs_factory_name="TextTracks";var Xn=c.a.getClassFactory(zn);function Qn(){var e,t,n,r,i,a,o=this.context;function s(e){var t=e.split(":"),n=t.length-1;return e=60*parseInt(t[n-1],10)+parseFloat(t[n]),2===n&&(e+=3600*parseInt(t[0],10)),e}function u(e){var t=e.split(r),n=t[1].split(a);return n.shift(),t[1]=n[0],n.shift(),{cuePoints:t,styles:l(n)}}function l(e){var t={};return e.forEach((function(e){if(e.split(/:/).length>1){var n=e.split(/:/)[1];n&&-1!=n.search(/%/)&&(n=parseInt(n.replace(/%/,""),10)),(e.match(/align/)||e.match(/A/))&&(t.align=n),(e.match(/line/)||e.match(/L/))&&(t.line=n),(e.match(/position/)||e.match(/P/))&&(t.position=n),(e.match(/size/)||e.match(/S/))&&(t.size=n)}})),t}function c(e,t){for(var n,i=t,a="",o="";""!==e[i]&&i<e.length;)i++;if((n=i-t)>1)for(var s=0;s<n;s++){if((o=e[t+s]).match(r)){a="";break}a+=o,s!==n-1&&(a+="\n")}else(o=e[t]).match(r)||(a=o);return a}return e={parse:function(e){var a,o,l=[];if(!e)return l;a=(e=e.split(n)).length,o=-1;for(var f=0;f<a;f++){var d=e[f];if(d.length>0&&"WEBVTT"!==d&&d.match(r)){var h=u(d),p=h.cuePoints,g=h.styles,m=c(e,f+1),y=s(p[0].replace(i,"")),E=s(p[1].replace(i,""));!isNaN(y)&&!isNaN(E)&&y>=o&&E>y?""!==m?(o=y,l.push({start:y,end:E,data:m,styles:g})):t.error("Skipping cue due to empty/malformed cue text"):t.error("Skipping cue due to incorrect cue timing")}}return l}},t=Object(f.a)(o).getInstance().getLogger(e),n=/(?:\r\n|\r|\n)/gm,r=/-->/,i=/(^[\s]+|[\s]+$)/g,a=/\s\b/g,e}Qn.__dashjs_factory_name="VTTParser";var $n=c.a.getSingletonFactory(Qn);function Zn(){var e,t,n=this.context,r=Object(u.a)(n).getInstance(),i=0;return e={parse:function(e,n,a,o,s){var u,c,f,h="",p=[],g={},m={},y="",E="",_={onOpenTag:function(e,n,i){if(i[" imagetype"]&&!i[" imageType"]&&(r.trigger(d.a.CONFORMANCE_VIOLATION,{level:he.LEVELS.ERROR,event:he.EVENTS.NON_COMPLIANT_SMPTE_IMAGE_ATTRIBUTE}),i[" imageType"]=i[" imagetype"]),"image"===n&&("http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt"===e||"http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"===e)){if(!i[" imageType"]||"PNG"!==i[" imageType"].value)return void t.warn("smpte-tt imageType != PNG. Discarded");y=i["http://www.w3.org/XML/1998/namespace id"].value}},onCloseTag:function(){y&&(m[y]=E.trim()),E="",y=""},onText:function(e){y&&(E+=e)}};if(!e)throw h="no ttml data to parse",new Error(h);g.data=e,r.trigger(l.a.TTML_TO_PARSE,g);var T=Object(Wn.fromXML)(g.data,(function(e){h=e}),_);r.trigger(l.a.TTML_PARSED,{ttmlString:g.data,ttmlDoc:T});var v,S=T.getMediaTimeEvents();for(f=0;f<S.length;f++){var A=Object(Wn.generateISD)(T,S[f],(function(e){h=e}));A.contents.some((function(e){return e.contents.length}))&&(u=S[f]+n<a?a:S[f]+n)<(c=S[f+1]+n>o?o:S[f+1]+n)&&p.push({start:u,end:c,type:"html",cueID:(v=void 0,v="cue_TTML_"+i,i++,v),isd:A,images:s,embeddedImages:m})}if(""!==h)throw t.error(h),new Error(h);return p}},t=Object(f.a)(n).getInstance().getLogger(e),e}Zn.__dashjs_factory_name="TTMLParser";var Jn=c.a.getSingletonFactory(Zn);function er(e){var t,n,r,i,o,s,c,f,h,p,g,m,y,E=this.context,_=e.adapter,T=e.errHandler,v=e.manifestModel,S=e.mediaController,A=e.videoModel,b=e.settings;function I(e){var t=e.tracks,r=e.index,i=e.streamId;!1===b.get().streaming.text.defaultEnabled&&!N()||y?C(i,-1):(f&&t.some((function(e,t){if(S.matchSettings(f,e))return C(i,t),r=t,!0})),p=!1),n[i].lastEnabledIndex=r,c.trigger(d.a.TEXT_TRACKS_ADDED,{enabled:N(),index:r,tracks:t,streamId:i}),m=!0}function R(e){if(!h&&e&&e.newMediaInfo){var t=e.newMediaInfo;t.type===a.a.TEXT&&(f={lang:t.lang,role:t.roles[0],index:t.index,codec:t.codec,accessibility:t.accessibility[0]})}}function N(){var e=!0;return p&&!g&&(e=!1),e}function C(e,t){(p=-1===t)&&S&&S.saveTextSettingsDisabled();var n=w(e);if(n!==t&&i[e]){i[e].setModeForTrackIdx(n,a.a.TEXT_HIDDEN),i[e].setCurrentTrackIdx(t),i[e].setModeForTrackIdx(t,a.a.TEXT_SHOWING);var o=i[e].getCurrentTrackInfo();o&&o.isFragmented&&!o.isEmbedded?function(e,t,n){if(!r[e])return;for(var o=r[e].getConfig().fragmentedTracks,s=0;s<o.length;s++){var u=o[s];if(t.lang===u.lang&&(u.id?t.id===u.id:t.index===u.index)){var f=S.getCurrentTrackFor(a.a.TEXT,e);(u.id?f.id!==u.id:f.index!==u.index)?(i[e].deleteCuesFromTrackIdx(n),r[e].setCurrentFragmentedTrackIdx(s)):-1===n&&c.trigger(l.a.SET_FRAGMENTED_TEXT_AFTER_DISABLED,{},{streamId:e,mediaType:a.a.TEXT})}}}(e,o,n):o&&!o.isFragmented&&function(e,t){c.trigger(l.a.SET_NON_FRAGMENTED_TEXT,{currentTrackInfo:t},{streamId:e,mediaType:a.a.TEXT})}(e,o),S.setTrack(o)}}function w(e){return i[e].getCurrentTrackIdx()}function D(){r={},i={},n={},p=!0,m=!1,y=!1}return t={deactivateStream:function(e){if(e){var t=e.id;r[t]&&r[t].resetMediaInfos(),i[t]&&i[t].deleteAllTextTracks()}},initialize:function(){c.on(l.a.CURRENT_TRACK_CHANGED,R,t),c.on(l.a.TEXT_TRACKS_QUEUE_INITIALIZED,I,t)},initializeForStream:function(e){var t=e.id,a=Xn(E).create({videoModel:A,streamInfo:e});a.initialize(),i[t]=a;var u=qn(E).create({errHandler:T,adapter:_,manifestModel:v,mediaController:S,videoModel:A,textTracks:a,vttParser:o,ttmlParser:s,streamInfo:e});u.initialize(),r[t]=u,n[t]={},n[t].lastEnabledIndex=-1},createTracks:function(e){var t=e.id;i[t]&&i[t].createTracks()},getTextSourceBuffer:function(e){var t=e.id;if(r&&r[t])return r[t]},getAllTracksAreDisabled:function(){return p},addEmbeddedTrack:function(e,t){var n=e.id;r[n]&&r[n].addEmbeddedTrack(t)},setInitialSettings:function(e){f=e,h=!0},enableText:function(e,t){Object(O.b)(t,"boolean"),N()!==t&&(t&&C(e,n[e].lastEnabledIndex),t||(n[e].lastEnabledIndex=w(e),m?C(e,-1):y=!0))},isTextEnabled:N,setTextTrack:C,getCurrentTrackIdx:w,enableForcedTextStreaming:function(e){Object(O.b)(e,"boolean"),g=e},addMediaInfosToBuffer:function(e,t,n){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,a=e.id;r[a]&&r[a].addMediaInfos(t,n,i)},reset:function(){D(),c.off(l.a.CURRENT_TRACK_CHANGED,R,t),c.off(l.a.TEXT_TRACKS_QUEUE_INITIALIZED,I,t),Object.keys(r).forEach((function(e){r[e].resetEmbedded(),r[e].reset()}))}},f=null,g=!1,m=!1,h=!1,y=!1,o=$n(E).getInstance(),s=Jn(E).getInstance(),c=Object(u.a)(E).getInstance(),D(),t}er.__dashjs_factory_name="TextController";var tr=c.a.getClassFactory(er),nr=n(31);function rr(){var e,t,n,r,h,g,T,v,S,A,b,I,R,N,C,w,D,M,x,U,B,k,G,j,Y,H,V,K,q,W,z,X,Q,$,Z,J,ee="You must first call initialize() and set a source before calling this method",te="You must first call initialize() and set a valid source and view before calling this method",ne="You must first call attachView() to set the video element before calling this method",re=this.context,ae=Object(u.a)(re).getInstance(),oe=Object(E.a)(re).getInstance(),se=Object(f.a)(re).getInstance({settings:oe});function ue(){be(null),Se(null),r=null,R&&(R.reset(),R=null),N&&(N.reset(),N=null),x&&(x.reset(),x=null),oe.reset(),w&&(w.reset(),w=null)}function le(){return!!n&&!!Q.getElement()}function ce(){return Object(Gt.a)()}function fe(){if(!T)throw te;return V.isPaused()}function de(e){var t=j&&j.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,n=W.getCurrentDVRInfo(t);if(!n)return 0;var r=V.getLiveDelay(),i=n.range.start+e;return i>n.range.end-r&&(i=n.range.end-r),i}function he(e){if(!T)throw te;var t=Te().currentTime;if(void 0!==e)t=j.getTimeRelativeToStreamId(t,e);else if(V.getIsDynamic()){var n=j&&j.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,r=W.getCurrentDVRInfo(n);t=null===r||0===t?0:Math.max(0,t-r.range.start)}return t}function pe(){if(!T)throw te;var e=Te().duration;if(V.getIsDynamic()){var t=j&&j.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,n=W.getCurrentDVRInfo(t);e=n?n.range.end-n.range.start:0}return e}function ge(e){Object(O.b)(e,"boolean"),v=e}function me(){x.restoreDefaultUTCTimingSources()}function Ee(){return W}function Te(){if(!Q.getElement())throw ne;return Q.getElement()}function Se(e){if(!h)throw"MediaPlayer not initialized!";Q.setElement(e),e&&(we(),function(){if(N)return;var e=dashjs.MetricsReporting;if("function"==typeof e){var t=e(re).create();N=t.createMetricsReporting({debug:se,eventBus:ae,mediaElement:Te(),adapter:D,dashMetrics:W,mediaPlayerModel:M,events:l.a,constants:a.a,metricsConstants:s.a})}}(),function(){if(C)return;var e=dashjs.MssHandler;"function"==typeof e&&(y.a.extend(e.errors),C=e(re).create({eventBus:ae,mediaPlayerModel:M,dashMetrics:W,manifestModel:z,playbackController:V,streamController:j,protectionController:R,baseURLController:B,errHandler:U,events:l.a,constants:a.a,debug:se,initSegmentType:_.a.INIT_SEGMENT_TYPE,BASE64:Pn.a,ISOBoxer:Fn.a,settings:oe}))}(),j&&j.switchToVideoElement()),T&&Re(),Pe()}function Ae(e){if(!g)throw ee;var t=j.getActiveStreamInfo();return t?I.getTracksFor(e,t.id):[]}function be(e){if(!h)throw"MediaPlayer not initialized!";"string"==typeof e&&$.initialize(e),n=e,(g||T)&&Re(),le()&&Pe()}function Ie(){if(!g)throw ee;var e=j.getActiveStreamInfo();return e?j.getStreamById(e.id):null}function Re(){T=!1,g=!1,D.reset(),j.reset(),H.reset(),q.reset(),V.reset(),K.reset(),S.reset(),I.reset(),J.reset(),R&&(oe.get().streaming.protection.keepProtectionMediaKeys?R.stop():(R.reset(),R=null,we())),Y.reset(),X.reset()}function Ne(){return ot(re).create({debug:se,errHandler:U,dashMetrics:W,mediaPlayerModel:M,requestModifier:Object(P.a)(re).getInstance(),mssHandler:C,settings:oe})}function we(){if(R)return R;var e=dashjs.Protection;if("function"==typeof e){var t=e(re).create();return l.a.extend(e.events),d.a.extend(e.events,{publicOnly:!0}),y.a.extend(e.errors),k||(k=Object(lt.a)(re).getInstance()),R=t.createProtectionSystem({debug:se,errHandler:U,videoModel:Q,customParametersModel:x,capabilities:k,eventBus:ae,events:l.a,BASE64:Pn.a,constants:a.a,cmcdModel:X,settings:oe})}return null}function De(){if(!h)throw"MediaPlayer not initialized!";if(w)return w;var e=dashjs.OfflineController;if("function"==typeof e){l.a.extend(e.events),d.a.extend(e.events,{publicOnly:!0}),y.a.extend(e.errors);var t=Ne(),n=ie(re).create();return n.setConfig({manifestModel:z,adapter:D,manifestLoader:t,errHandler:U}),w=e(re).create({debug:se,manifestUpdater:n,baseURLController:B,manifestLoader:t,manifestModel:z,mediaPlayerModel:M,abrController:S,playbackController:V,adapter:D,errHandler:U,dashMetrics:W,timelineConverter:b,segmentBaseController:J,schemeLoaderFactory:A,eventBus:ae,events:l.a,errors:y.a,constants:a.a,settings:oe,dashConstants:o.a,urlUtils:Object(L.a)(re).getInstance()})}return null}function Me(e){var t=j&&j.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,n=W.getCurrentDVRInfo(t);return n?e+(n.manifestInfo.availableFrom.getTime()/1e3+n.range.start):0}function Pe(){var e;w&&w.resetRecords(),!g&&n&&(g=!0,t.info("Streaming Initialized"),e=Ne(),j||(j=ye(re).getInstance()),Y||(Y=tr(re).create({errHandler:U,manifestModel:z,adapter:D,mediaController:I,videoModel:Q,settings:oe})),G.setConfig({capabilities:k,customParametersModel:x,adapter:D,settings:oe,manifestModel:z,errHandler:U}),j.setConfig({capabilities:k,capabilitiesFilter:G,manifestLoader:e,manifestModel:z,mediaPlayerModel:M,customParametersModel:x,protectionController:R,textController:Y,adapter:D,dashMetrics:W,errHandler:U,timelineConverter:b,videoModel:Q,playbackController:V,serviceDescriptionController:K,abrController:S,mediaController:I,settings:oe,baseURLController:B,uriFragmentModel:$,segmentBaseController:J}),H.setConfig({settings:oe,playbackController:V,streamController:j,videoModel:Q,timelineConverter:b,adapter:D}),V.setConfig({streamController:j,serviceDescriptionController:K,dashMetrics:W,adapter:D,videoModel:Q,timelineConverter:b,settings:oe}),q.setConfig({streamController:j,playbackController:V,mediaPlayerModel:M,dashMetrics:W,videoModel:Q,settings:oe}),S.setConfig({streamController:j,domStorage:Z,mediaPlayerModel:M,customParametersModel:x,dashMetrics:W,adapter:D,videoModel:Q,settings:oe}),X.setConfig({abrController:S,dashMetrics:W,playbackController:V}),S.initialize(),j.initialize(v,r),Y.initialize(),H.initialize(),q.initialize(),X.initialize(),J.initialize(),"string"==typeof n?j.load(n):j.loadWithManifest(n)),!T&&le()&&(T=!0,t.info("Playback Initialized"))}return e={initialize:function(e,n,r){k||(k=Object(lt.a)(re).getInstance()).setConfig({settings:oe}),U||(U=ut(re).getInstance()),k.supportsMediaSource()?(h||(h=!0,b=On(re).getInstance(),S||(S=Ot(re).getInstance()).setConfig({settings:oe}),A||(A=Object(Mt.a)(re).getInstance()),V||(V=p(re).getInstance()),I||(I=Oe(re).getInstance()),j||(j=ye(re).getInstance()),H||(H=_e(re).getInstance()),q||(q=ve(re).getInstance()),K||(K=Ce(re).getInstance()),G||(G=ft(re).getInstance()),D=cn(re).getInstance(),z=mt(re).getInstance(),X=Object(xt.a)(re).getInstance(),W=wn(re).getInstance({settings:oe}),Z=kt(re).getInstance({settings:oe}),D.setConfig({constants:a.a,cea608parser:i.a,errHandler:U,BASE64:Pn.a}),B||(B=Ve(re).create()),B.setConfig({adapter:D}),K.setConfig({adapter:D}),J||(J=Xt(re).getInstance({dashMetrics:W,mediaPlayerModel:M,errHandler:U,baseURLController:B,events:l.a,eventBus:ae,debug:se,boxParser:Object(F.a)(re).getInstance(),requestModifier:Object(P.a)(re).getInstance(),errors:y.a})),I.setConfig({domStorage:Z,settings:oe,customParametersModel:x}),M.setConfig({playbackController:V,serviceDescriptionController:K}),me(),ge(void 0===r||r),De()),e&&Se(e),n&&be(n),t.info("[dash.js "+ce()+"] MediaPlayer has been initialized")):U.error(new m.a(y.a.CAPABILITY_MEDIASOURCE_ERROR_CODE,y.a.CAPABILITY_MEDIASOURCE_ERROR_MESSAGE))},setConfig:function(e){e&&(e.capabilities&&(k=e.capabilities),e.capabilitiesFilter&&(G=e.capabilitiesFilter),e.streamController&&(j=e.streamController),e.textController&&(Y=e.textController),e.gapController&&(H=e.gapController),e.playbackController&&(V=e.playbackController),e.serviceDescriptionController&&(K=e.serviceDescriptionController),e.catchupController&&(q=e.catchupController),e.mediaPlayerModel&&(M=e.mediaPlayerModel),e.customParametersModel&&(x=e.customParametersModel),e.abrController&&(S=e.abrController),e.schemeLoaderFactory&&(A=e.schemeLoaderFactory),e.mediaController&&(I=e.mediaController),e.settings&&(oe=e.settings))},on:function(e,t,n,r){ae.on(e,t,n,r)},off:function(e,t,n){ae.off(e,t,n)},extend:function(e,t,n){c.a.extend(e,t,n,re)},attachView:Se,attachSource:be,isReady:le,play:function(){if(!T)throw te;(!v||fe()&&T)&&V.play()},isPaused:fe,pause:function(){if(!T)throw te;V.pause()},isSeeking:function(){if(!T)throw te;return V.isSeeking()},isDynamic:function(){if(!T)throw te;return V.getIsDynamic()},getLowLatencyModeEnabled:function(){if(!T)throw te;return V.getLowLatencyModeEnabled()},seek:function(e){if(!T)throw te;if(Object(O.b)(e,"number"),isNaN(e))throw a.a.BAD_ARGUMENT_ERROR;var t=V.getIsDynamic()?de(e):e;V.seek(t)},setPlaybackRate:function(e){Te().playbackRate=e},getPlaybackRate:function(){return Te().playbackRate},setMute:function(e){Object(O.b)(e,"boolean"),Te().muted=e},isMuted:function(){return Te().muted},setVolume:function(e){if("number"!=typeof e||isNaN(e)||e<0||e>1)throw a.a.BAD_ARGUMENT_ERROR;Te().volume=e},getVolume:function(){return Te().volume},time:he,duration:pe,timeAsUTC:function(){if(!T)throw te;return he()<0?NaN:Me(he())},durationAsUTC:function(){if(!T)throw te;return Me(pe())},getActiveStream:Ie,getDVRWindowSize:function(){var e=j&&j.hasVideoTrack()?a.a.VIDEO:a.a.AUDIO,t=W.getCurrentDVRInfo(e);return t?t.manifestInfo.dvrWindowSize:0},getDVRSeekOffset:de,getTargetLiveDelay:function(){if(!T)throw te;return V.getLiveDelay()},convertToTimeCode:function(e){e=Math.max(e,0);var t=Math.floor(e/3600),n=Math.floor(e%3600/60),r=Math.floor(e%3600%60);return(0===t?"":t<10?"0"+t.toString()+":":t.toString()+":")+(n<10?"0"+n.toString():n.toString())+":"+(r<10?"0"+r.toString():r.toString())},formatUTC:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3],i=new Date(1e3*e),a=i.toLocaleDateString(t),o=i.toLocaleTimeString(t,{hour12:n});return r?o+" "+a:o},getVersion:ce,getDebug:function(){return se},getBufferLength:function(e){var n=[a.a.VIDEO,a.a.AUDIO,a.a.TEXT];if(e){if(-1!==n.indexOf(e)){var r=Ee().getCurrentBufferLevel(e);return r||NaN}return t.warn("getBufferLength requested for invalid type"),NaN}var i=n.map((function(e){return Ae(e).length>0?Ee().getCurrentBufferLevel(e):Number.MAX_VALUE})).reduce((function(e,t){return Math.min(e,t)}));return i===Number.MAX_VALUE?NaN:i},getTTMLRenderingDiv:function(){return Q?Q.getTTMLRenderingDiv():null},getVideoElement:Te,getSource:function(){if(!n)throw"You must first call attachSource() with a valid source before calling this method";return n},updateSource:function(e){n=e,j.load(n)},getCurrentLiveLatency:function(){if(!h)throw"MediaPlayer not initialized!";return T?V.getCurrentLiveLatency():NaN},getTopBitrateInfoFor:function(e){if(!g)throw ee;return S.getTopBitrateInfoFor(e)},setAutoPlay:ge,getAutoPlay:function(){return v},getDashMetrics:Ee,getQualityFor:function(e){if(!g)throw ee;if(e===a.a.IMAGE){var t=Ie();if(!t)return-1;var n=t.getThumbnailController();return n?n.getCurrentTrackIndex():-1}return S.getQualityFor(e)},setQualityFor:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!g)throw ee;if(e===a.a.IMAGE){var r=Ie();if(!r)return;var i=r.getThumbnailController();i&&i.setTrackByIndex(t)}S.setPlaybackQuality(e,j.getActiveStreamInfo(),t,{forceReplace:n})},updatePortalSize:function(){S.setElementSize(),S.setWindowResizeEventCalled(!0)},enableText:function(e){var t=j.getActiveStreamInfo();return!(!t||!Y)&&Y.enableText(t.id,e)},enableForcedTextStreaming:function(e){return!(!j.getActiveStreamInfo()||!Y)&&Y.enableForcedTextStreaming(e)},isTextEnabled:function(){var e=j.getActiveStreamInfo();return!(!e||!Y)&&Y.isTextEnabled(e)},setTextTrack:function(e){if(!T)throw te;var t=j.getActiveStreamInfo();t&&Y&&Y.setTextTrack(t.id,e)},getBitrateInfoListFor:function(e){if(!g)throw ee;var t=Ie();return t?t.getBitrateListFor(e):[]},getStreamsFromManifest:function(e){if(!g)throw ee;return D.getStreamsInfo(e)},getTracksFor:Ae,getTracksForTypeFromManifest:function(e,t,n){if(!g)throw ee;return(n=n||D.getStreamsInfo(t,1)[0])?D.getAllMediaInfoForType(n,e,t):[]},getCurrentTrackFor:function(e){if(!g)throw ee;var t=j.getActiveStreamInfo();return I.getCurrentTrackFor(e,t.id)},setInitialMediaSettingsFor:function(e,t){if(!h)throw"MediaPlayer not initialized!";I.setInitialSettings(e,t)},getInitialMediaSettingsFor:function(e){if(!h)throw"MediaPlayer not initialized!";return I.getInitialSettings(e)},setCurrentTrack:function(e){if(!g)throw ee;I.setTrack(e)},addABRCustomRule:function(e,t,n){x.addAbrCustomRule(e,t,n)},removeABRCustomRule:function(e){x.removeAbrCustomRule(e)},removeAllABRCustomRule:function(){x.removeAllAbrCustomRule()},getABRCustomRules:function(){return x.getAbrCustomRules()},getAverageThroughput:function(e){var t=S.getThroughputHistory(),n=V.getIsDynamic();return t?t.getAverageThroughput(e,n):0},retrieveManifest:function(e,t){var n=Ne(),r=this;ae.on(l.a.INTERNAL_MANIFEST_LOADED,(function e(i){i.error?t(null,i.error):t(i.manifest),ae.off(l.a.INTERNAL_MANIFEST_LOADED,e,r),n.reset()}),r),$.initialize(e),n.load(e)},addUTCTimingSource:function(e,t){x.addUTCTimingSource(e,t)},removeUTCTimingSource:function(e,t){x.removeUTCTimingSource(e,t)},clearDefaultUTCTimingSources:function(){x.clearDefaultUTCTimingSources()},restoreDefaultUTCTimingSources:me,setXHRWithCredentialsForType:function(e,t){x.setXHRWithCredentialsForType(e,t)},getXHRWithCredentialsForType:function(e){return x.getXHRWithCredentialsForType(e)},getProtectionController:function(){return we()},attachProtectionController:function(e){R=e},setProtectionData:function(e){r=e,j&&j.setProtectionData(r)},registerLicenseRequestFilter:function(e){x.registerLicenseRequestFilter(e)},registerLicenseResponseFilter:function(e){x.registerLicenseResponseFilter(e)},unregisterLicenseRequestFilter:function(e){x.unregisterLicenseRequestFilter(e)},unregisterLicenseResponseFilter:function(e){x.unregisterLicenseResponseFilter(e)},registerCustomCapabilitiesFilter:function(e){x.registerCustomCapabilitiesFilter(e)},unregisterCustomCapabilitiesFilter:function(e){x.unregisterCustomCapabilitiesFilter(e)},setCustomInitialTrackSelectionFunction:function(e){x.setCustomInitialTrackSelectionFunction(e)},resetCustomInitialTrackSelectionFunction:function(){x.resetCustomInitialTrackSelectionFunction(null)},attachTTMLRenderingDiv:function(e){if(!Q.getElement())throw ne;Q.setTTMLRenderingDiv(e)},getCurrentTextTrackIndex:function(){var e=j.getActiveStreamInfo();if(e&&Y)return Y.getCurrentTrackIdx(e.id)},provideThumbnail:function(e,t){if("function"==typeof t)if(e<0)t(null);else{var n=V.getIsDynamic()?de(e):e,r=j.getStreamForTime(n);if(null!==r){var i=r.getThumbnailController();if(i)return i.provide(n,t);t(null)}else t(null)}},getDashAdapter:function(){return D},getOfflineController:function(){return De()},getSettings:function(){return oe.get()},updateSettings:function(e){oe.update(e)},resetSettings:function(){oe.reset()},reset:ue,destroy:function(){ue(),c.a.deleteSingletonInstances(re)}},t=se.getLogger(e),h=!1,T=!1,g=!1,v=!0,R=null,w=null,r=null,D=null,J=null,l.a.extend(d.a),M=Et(re).getInstance(),x=Object(nr.a)(re).getInstance(),Q=Ft(re).getInstance(),$=pt(re).getInstance(),e}rr.__dashjs_factory_name="MediaPlayer";var ir=c.a.getClassFactory(rr);ir.events=d.a,ir.errors=y.a,c.a.updateClassFactory(rr.__dashjs_factory_name,ir);t.a=ir},function(e,t,n){"use strict";n.d(t,"a",(function(){return r}));function r(){return"4.4.0"}},function(e,t,n){var r,i,o,u,l,c={encode:function(e){for(var t=[],n=0;n<e.length;++n){var r=e.charCodeAt(n);r<128?t.push(r):r<2048?(t.push(192|r>>6),t.push(128|63&r)):r<65536?(t.push(224|r>>12),t.push(128|63&r>>6),t.push(128|63&r)):(t.push(240|r>>18),t.push(128|63&r>>12),t.push(128|63&r>>6),t.push(128|63&r))}return t},decode:function(e){for(var t=[],n=0;n<e.length;){var r=e[n++];r<128||(r<224?(r=(31&r)<<6,r|=63&e[n++]):r<240?(r=(15&r)<<12,r|=(63&e[n++])<<6,r|=63&e[n++]):(r=(7&r)<<18,r|=(63&e[n++])<<12,r|=(63&e[n++])<<6,r|=63&e[n++])),t.push(String.fromCharCode(r))}return t.join("")}},f={};r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=function(e){for(var t=0,n=[],i=0|e.length/3;0<i--;){var a=(e[t]<<16)+(e[t+1]<<8)+e[t+2];t+=3,n.push(r.charAt(63&a>>18)),n.push(r.charAt(63&a>>12)),n.push(r.charAt(63&a>>6)),n.push(r.charAt(63&a))}return 2==e.length-t?(a=(e[t]<<16)+(e[t+1]<<8),n.push(r.charAt(63&a>>18)),n.push(r.charAt(63&a>>12)),n.push(r.charAt(63&a>>6)),n.push("=")):1==e.length-t&&(a=e[t]<<16,n.push(r.charAt(63&a>>18)),n.push(r.charAt(63&a>>12)),n.push("==")),n.join("")},o=function(){for(var e=[],t=0;t<r.length;++t)e[r.charCodeAt(t)]=t;return e["=".charCodeAt(0)]=0,e}(),u=function(e){for(var t=0,n=[],r=0|e.length/4;0<r--;){var i=(o[e.charCodeAt(t)]<<18)+(o[e.charCodeAt(t+1)]<<12)+(o[e.charCodeAt(t+2)]<<6)+o[e.charCodeAt(t+3)];n.push(255&i>>16),n.push(255&i>>8),n.push(255&i),t+=4}return n&&("="==e.charAt(t-2)?(n.pop(),n.pop()):"="==e.charAt(t-1)&&n.pop()),n},l={encode:function(e){for(var t=[],n=0;n<e.length;++n)t.push(e.charCodeAt(n));return t},decode:function(e){for(var t=0;t<s.length;++t)a[t]=String.fromCharCode(a[t]);return a.join("")}},f.decodeArray=function(e){var t=u(e);return new Uint8Array(t)},f.encodeASCII=function(e){var t=l.encode(e);return i(t)},f.decodeASCII=function(e){var t=u(e);return l.decode(t)},f.encode=function(e){var t=c.encode(e);return i(t)},f.decode=function(e){var t=u(e);return c.decode(t)},t.decode=f.decode,t.decodeArray=f.decodeArray,t.encode=f.encode,t.encodeASCII=f.encodeASCII},,function(e,t,n){"use strict";var r=n(1),i=n(3),a=n(4),o=n(12);function s(e){var t,n,i,s,u,l=(e=e||{}).eventBus,c=e.events,f=e.abrController,d=e.dashMetrics,h=e.playbackController,p=e.timelineConverter,g=e.type,m=e.streamInfo,y=e.dashConstants,E=e.segmentsController,_=e.isDynamic;function T(){return g}function v(){if(!(f&&d&&h&&p))throw new Error(r.a.MISSING_CONFIG_ERROR)}function S(){return i}function A(){return u}function b(){n=null,i=!0,s=[]}function I(e){return new Promise((function(t,n){var r=e.hasInitialization(),i=e.hasSegments(),a=[];a.push(E.updateInitData(e,r)),a.push(E.updateSegmentData(e,i)),Promise.all(a).then((function(n){var r;n[0]&&!n[0].error&&(e=function(e,t){if(!t||t.error||!t.representation)return e;return t.representation}(e,n[0])),n[1]&&!n[1].error&&(e=function(e,t){if(!t||t.error)return;var n,r,i,a,s=t.segments,u=[],l=0;for(n=0,r=s?s.length:0;n<r;n++)i=s[n],(a=Object(o.b)(p,_,e,i.startTime,i.duration,i.timescale,i.media,i.mediaRange,l))&&(u.push(a),a=null,l++);u.length>0&&(e.segments=u);return e}(e,n[1])),(r=e).mediaFinishedInformation=E.getMediaFinishedInformation(r),function(e){if(!S())return;var t,n=d.getCurrentManifestUpdate(),r=!1;if(n){for(var i=0;i<n.representationInfo.length;i++)if((t=n.representationInfo[i]).index===e.index&&t.mediaType===T()){r=!0;break}r||d.addManifestUpdateRepresentationInfo(e,T())}if(function(){for(var e=0,t=s.length;e<t;e++){var n=s[e].segmentInfoType;if(!s[e].hasInitialization()||(n===y.SEGMENT_BASE||n===y.BASE_URL)&&!s[e].segments)return!1}return!0}()){f.setPlaybackQuality(g,m,(o=u,s.indexOf(o)));var a=d.getCurrentDVRInfo(g);a&&d.updateManifestUpdateInfo({latency:a.range.end-h.getTime()}),d.getCurrentRepresentationSwitch(A().adaptation.type)||R(),C()}var o}(e),t()})).catch((function(e){n(e)}))}))}function R(){v();var e=new Date,t=A(),n=1e3*h.getTime();t&&d.addRepresentationSwitch(t.adaptation.type,e,n,t.id),l.trigger(a.a.REPRESENTATION_SWITCH,{mediaType:g,streamId:m.id,currentRepresentation:t,numberOfRepresentations:s.length},{streamId:m.id,mediaType:g})}function N(e){return null==e||e>=s.length?null:s[e]}function C(e){i=!1,l.trigger(c.DATA_UPDATE_COMPLETED,{data:n,currentRepresentation:u,error:e},{streamId:m.id,mediaType:g})}function w(e){u=e}function D(e){if(e.newDuration){var t=A();if(t&&t.adaptation.period)t.adaptation.period.duration=e.newDuration}}return t={getStreamId:function(){return m.id},getType:T,getData:function(){return n},isUpdating:S,updateData:function(e,t,a,o,u){if(v(),i=!0,s=t,w(N(u)),n=e,a!==r.a.VIDEO&&a!==r.a.AUDIO&&(a!==r.a.TEXT||!o))return C(),Promise.resolve();for(var l=[],c=0,f=s.length;c<f;c++){var d=s[c];l.push(I(d))}return Promise.all(l)},getCurrentRepresentation:A,getRepresentationForQuality:N,prepareQualityChange:function(e){w(N(e)),R()},reset:function(){l.off(a.a.MANIFEST_VALIDITY_CHANGED,D,t),b()}},b(),l.on(a.a.MANIFEST_VALIDITY_CHANGED,D,t),t}s.__dashjs_factory_name="RepresentationController",t.a=i.a.getClassFactory(s)},function(e,t,n){"use strict";t.a=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.streamId=null,this.mediaInfo=null,this.segmentType=null,this.quality=NaN,this.index=NaN,this.bytes=null,this.start=NaN,this.end=NaN,this.duration=NaN,this.representationId=null,this.endFragment=null}},function(e,t,n){"use strict";var r=Array.isArray,i=Object.keys,a=Object.prototype.hasOwnProperty;e.exports=function e(t,n){if(t===n)return!0;if(t&&n&&"object"==typeof t&&"object"==typeof n){var o,s,u,l=r(t),c=r(n);if(l&&c){if((s=t.length)!=n.length)return!1;for(o=s;0!=o--;)if(!e(t[o],n[o]))return!1;return!0}if(l!=c)return!1;var f=t instanceof Date,d=n instanceof Date;if(f!=d)return!1;if(f&&d)return t.getTime()==n.getTime();var h=t instanceof RegExp,p=n instanceof RegExp;if(h!=p)return!1;if(h&&p)return t.toString()==n.toString();var g=i(t);if((s=g.length)!==i(n).length)return!1;for(o=s;0!=o--;)if(!a.call(n,g[o]))return!1;for(o=s;0!=o--;)if(!e(t[u=g[o]],n[u]))return!1;return!0}return t!=t&&n!=n}},function(e,t,n){"use strict";var r=n(3);function i(e){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function a(e){function t(e,t){for(var n in e)t.hasOwnProperty(n)||(t[n]=e[n])}function n(e,n,r){for(var a=0,o=e.length;a<o;++a){var s=e[a];if(n[s.name])if(r[s.name]){if(s.merge){var u=n[s.name],l=r[s.name];"object"===i(u)&&"object"===i(l)?t(u,l):r[s.name]=u+l}}else r[s.name]=n[s.name]}}function r(e,t){for(var i=0,a=e.children.length;i<a;++i){var o=e.children[i],s=t[o.name+"_asArray"];if(s)for(var u=0,l=s.length;u<l;++u){var c=s[u];n(e.properties,t,c),r(o,c)}}}return{run:function(t){if(null===t||"object"!==i(t))return t;if(t.Period_asArray&&"period"in e)for(var n=e.period,a=t.Period_asArray,o=0,s=a.length;o<s;++o){var u=a[o];if(r(n,u),"adaptationset"in e){var l=u.AdaptationSet_asArray;if(l)for(var c=e.adaptationset,f=0,d=l.length;f<d;++f)r(c,l[f])}}return t}}}a.__dashjs_factory_name="ObjectIron";var o=r.a.getClassFactory(a),s=n(45);function u(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var l=function(){function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._test=t,this._converter=n}var t,n,r;return t=e,(n=[{key:"test",get:function(){return this._test}},{key:"converter",get:function(){return this._converter}}])&&u(t.prototype,n),r&&u(t,r),e}(),c=n(0);function f(e){return(f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function d(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function h(e,t){return(h=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function p(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=m(e);if(t){var i=m(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return g(this,n)}}function g(e,t){return!t||"object"!==f(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function m(e){return(m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var y=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&h(e,t)}(n,e);var t=p(n);function n(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),t.call(this,(function(e,t){var n,r=(d(n={},c.a.MPD,[c.a.ID,c.a.PROFILES]),d(n,c.a.PERIOD,[c.a.ID]),d(n,c.a.BASE_URL,[c.a.SERVICE_LOCATION,c.a.BYTE_RANGE]),d(n,c.a.SEGMENT_BASE,[c.a.INDEX_RANGE]),d(n,c.a.INITIALIZATION,[c.a.RANGE]),d(n,c.a.REPRESENTATION_INDEX,[c.a.RANGE]),d(n,c.a.SEGMENT_LIST,[c.a.INDEX_RANGE]),d(n,c.a.BITSTREAM_SWITCHING,[c.a.RANGE]),d(n,c.a.SEGMENT_URL,[c.a.MEDIA_RANGE,c.a.INDEX_RANGE]),d(n,c.a.SEGMENT_TEMPLATE,[c.a.INDEX_RANGE,c.a.MEDIA,c.a.INDEX,c.a.INITIALIZATION_MINUS,c.a.BITSTREAM_SWITCHING_MINUS]),d(n,c.a.ASSET_IDENTIFIER,[c.a.VALUE,c.a.ID]),d(n,c.a.EVENT_STREAM,[c.a.VALUE]),d(n,c.a.ADAPTATION_SET,[c.a.PROFILES,c.a.MIME_TYPE,c.a.SEGMENT_PROFILES,c.a.CODECS,c.a.CONTENT_TYPE]),d(n,c.a.FRAME_PACKING,[c.a.VALUE,c.a.ID]),d(n,c.a.AUDIO_CHANNEL_CONFIGURATION,[c.a.VALUE,c.a.ID]),d(n,c.a.CONTENT_PROTECTION,[c.a.VALUE,c.a.ID]),d(n,c.a.ESSENTIAL_PROPERTY,[c.a.VALUE,c.a.ID]),d(n,c.a.SUPPLEMENTAL_PROPERTY,[c.a.VALUE,c.a.ID]),d(n,c.a.INBAND_EVENT_STREAM,[c.a.VALUE,c.a.ID]),d(n,c.a.ACCESSIBILITY,[c.a.VALUE,c.a.ID]),d(n,c.a.ROLE,[c.a.VALUE,c.a.ID]),d(n,c.a.RATING,[c.a.VALUE,c.a.ID]),d(n,c.a.VIEWPOINT,[c.a.VALUE,c.a.ID]),d(n,c.a.CONTENT_COMPONENT,[c.a.CONTENT_TYPE]),d(n,c.a.REPRESENTATION,[c.a.ID,c.a.DEPENDENCY_ID,c.a.MEDIA_STREAM_STRUCTURE_ID]),d(n,c.a.SUBSET,[c.a.ID]),d(n,c.a.METRICS,[c.a.METRICS_MINUS]),d(n,c.a.REPORTING,[c.a.VALUE,c.a.ID]),n);if(r.hasOwnProperty(t)){var i=r[t];return void 0!==i&&i.indexOf(e.name)>=0}return!1}),(function(e){return String(e)}))}return n}(l),E=n(1);function _(e){return(_="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function T(e,t){return(T=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function v(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=A(e);if(t){var i=A(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return S(this,n)}}function S(e,t){return!t||"object"!==_(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function A(e){return(A=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var b=/^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/,I=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&T(e,t)}(n,e);var t=v(n);function n(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),t.call(this,(function(e){for(var t=[c.a.MIN_BUFFER_TIME,c.a.MEDIA_PRESENTATION_DURATION,c.a.MINIMUM_UPDATE_PERIOD,c.a.TIMESHIFT_BUFFER_DEPTH,c.a.MAX_SEGMENT_DURATION,c.a.MAX_SUBSEGMENT_DURATION,c.a.SUGGESTED_PRESENTATION_DELAY,c.a.START,E.a.START_TIME,c.a.DURATION],n=t.length,r=0;r<n;r++)if(e.nodeName===t[r])return b.test(e.value);return!1}),(function(e){var t=b.exec(e),n=31536e3*parseFloat(t[3]||0)+2592e3*parseFloat(t[5]||0)+86400*parseFloat(t[7]||0)+3600*parseFloat(t[9]||0)+60*parseFloat(t[11]||0)+parseFloat(t[13]||0);return void 0!==t[1]&&(n=-n),n}))}return n}(l);function R(e){return(R="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function N(e,t){return(N=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function C(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=D(e);if(t){var i=D(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return w(this,n)}}function w(e,t){return!t||"object"!==R(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function D(e){return(D=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var O=/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/,M=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&N(e,t)}(n,e);var t=C(n);function n(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),t.call(this,(function(e){return O.test(e.value)}),(function(e){var t,n=O.exec(e);if(t=Date.UTC(parseInt(n[1],10),parseInt(n[2],10)-1,parseInt(n[3],10),parseInt(n[4],10),parseInt(n[5],10),n[6]&&parseInt(n[6],10)||0,n[7]&&1e3*parseFloat(n[7])||0),n[9]&&n[10]){var r=60*parseInt(n[9],10)+parseInt(n[10],10);t+=("+"===n[8]?-1:1)*r*60*1e3}return new Date(t)}))}return n}(l);function P(e){return(P="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function L(e,t){return(L=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function F(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=U(e);if(t){var i=U(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return x(this,n)}}function x(e,t){return!t||"object"!==P(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function U(e){return(U=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var B=/^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/,k=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&L(e,t)}(n,e);var t=F(n);function n(){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),t.call(this,(function(e){return B.test(e.value)}),(function(e){return parseFloat(e)}))}return n}(l);function G(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var j=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e);var n;this._name=t,this._merge=(n=t)&&n.length&&n.charAt(0)===n.charAt(0).toUpperCase()}var t,n,r;return t=e,(n=[{key:"name",get:function(){return this._name}},{key:"merge",get:function(){return this._merge}}])&&G(t.prototype,n),r&&G(t,r),e}();function Y(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var H=function(){function e(t,n,r){var i=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this._name=t||"",this._properties=[],this._children=r||[],Array.isArray(n)&&n.forEach((function(e){i._properties.push(new j(e))}))}var t,n,r;return t=e,(n=[{key:"name",get:function(){return this._name}},{key:"children",get:function(){return this._children}},{key:"properties",get:function(){return this._properties}}])&&Y(t.prototype,n),r&&Y(t,r),e}();function V(e){return(V="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function K(e,t){return(K=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function q(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=z(e);if(t){var i=z(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return W(this,n)}}function W(e,t){return!t||"object"!==V(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function z(e){return(z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var X=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&K(e,t)}(n,e);var t=q(n);function n(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n);var e=[c.a.PROFILES,c.a.WIDTH,c.a.HEIGHT,c.a.SAR,c.a.FRAMERATE,c.a.AUDIO_SAMPLING_RATE,c.a.MIME_TYPE,c.a.SEGMENT_PROFILES,c.a.CODECS,c.a.MAXIMUM_SAP_PERIOD,c.a.START_WITH_SAP,c.a.MAX_PLAYOUT_RATE,c.a.CODING_DEPENDENCY,c.a.SCAN_TYPE,c.a.FRAME_PACKING,c.a.AUDIO_CHANNEL_CONFIGURATION,c.a.CONTENT_PROTECTION,c.a.ESSENTIAL_PROPERTY,c.a.SUPPLEMENTAL_PROPERTY,c.a.INBAND_EVENT_STREAM];return t.call(this,c.a.ADAPTATION_SET,e,[new H(c.a.REPRESENTATION,e,[new H(c.a.SUB_REPRESENTATION,e)])])}return n}(H);function Q(e){return(Q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function $(e,t){return($=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Z(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=ee(e);if(t){var i=ee(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return J(this,n)}}function J(e,t){return!t||"object"!==Q(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function ee(e){return(ee=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var te=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&$(e,t)}(n,e);var t=Z(n);function n(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n);var e=[c.a.SEGMENT_BASE,c.a.SEGMENT_TEMPLATE,c.a.SEGMENT_LIST];return t.call(this,c.a.PERIOD,e,[new H(c.a.ADAPTATION_SET,e,[new H(c.a.REPRESENTATION,e)])])}return n}(H);function ne(e){e=e||{};var t,n,r,i,a,u=this.context,l=e.debug;return t={parse:function(e){var t,r=window.performance.now();if(!(t=i.xml_str2json(e)))throw new Error("parsing the manifest failed");var o=window.performance.now();t.Patch?((t=t.Patch).add_asArray&&t.add_asArray.forEach((function(e){return a.run(e)})),t.replace_asArray&&t.replace_asArray.forEach((function(e){return a.run(e)}))):(t=t.MPD,a.run(t));var s=window.performance.now();return n.info("Parsing complete: ( xml2json: "+(o-r).toPrecision(3)+"ms, objectiron: "+(s-o).toPrecision(3)+"ms, total: "+((s-r)/1e3).toPrecision(3)+"s)"),t.protocol="DASH",t},getMatchers:function(){return r},getIron:function(){return a}},n=l.getLogger(t),r=[new I,new M,new k,new y],i=new s.a({escapeMode:!1,attributePrefix:"",arrayAccessForm:"property",emptyNodeForm:"object",stripWhitespaces:!1,enableToStringFunc:!0,ignoreRoot:!1,matchers:r}),a=o(u).create({adaptationset:new X,period:new te}),t}ne.__dashjs_factory_name="DashParser";t.a=r.a.getClassFactory(ne)},function(e,t,n){"use strict";var r=n(1),i=n(21);function a(e){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){return(o=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function s(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=l(e);if(t){var i=l(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return u(this,n)}}function u(e,t){return!t||"object"!==a(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function l(e){return(l=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var c=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&o(e,t)}(n,e);var t=s(n);function n(e){var r;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(r=t.call(this,e)).checkForExistenceOnly=!0,r}return n}(n(17).a),f=n(10),d=n(3);function h(e){e=e||{};var t,n,a=this.context,o=e.eventBus,s=e.events,u=e.urlUtils,l=e.errors,d=e.streamId;return t={checkForExistence:function(e){var t=function(t){o.trigger(s.CHECK_FOR_EXISTENCE_COMPLETED,{request:e,exists:t})};if(e){var r=new c(e.url);n.load({request:r,success:function(){t(!0)},error:function(){t(!1)}})}else t(!1)},load:function(e){var r=function(n,r){o.trigger(s.LOADING_COMPLETED,{request:e,response:n||null,error:r||null,sender:t})};e?n.load({request:e,progress:function(n){o.trigger(s.LOADING_PROGRESS,{request:e,stream:n.stream,streamId:d}),n.data&&o.trigger(s.LOADING_DATA_PROGRESS,{request:e,response:n.data||null,error:null,sender:t})},success:function(e){r(e)},error:function(e,t,n){r(void 0,new f.a(l.FRAGMENT_LOADER_LOADING_FAILURE_ERROR_CODE,n,t))},abort:function(e){e&&o.trigger(s.LOADING_ABANDONED,{mediaType:e.mediaType,request:e,sender:t})}}):r(void 0,new f.a(l.FRAGMENT_LOADER_NULL_REQUEST_ERROR_CODE,l.FRAGMENT_LOADER_NULL_REQUEST_ERROR_MESSAGE))},abort:function(){n&&n.abort()},reset:function(){n&&(n.abort(),n=null)}},n=Object(i.a)(a).create({errHandler:e.errHandler,errors:l,dashMetrics:e.dashMetrics,mediaPlayerModel:e.mediaPlayerModel,requestModifier:e.requestModifier,urlUtils:u,constants:r.a,boxParser:e.boxParser,dashConstants:e.dashConstants,requestTimeout:e.settings.get().streaming.fragmentRequestTimeout}),t}h.__dashjs_factory_name="FragmentLoader";t.a=d.a.getClassFactory(h)},function(e,t,n){!function(e,t,n){function r(e,t,n,r,i,a,o,s){this.name=t,this.ns=e,this.qname=e+" "+t,this.inherit=i,this.animatable=a,this.initial=n,this.applies=r,this.parse=o,this.compute=s}for(var i in e.all=[new r(t.ns_tts,"backgroundColor","transparent",["body","div","p","region","span"],!1,!0,n.parseColor,null),new r(t.ns_tts,"color","white",["span"],!0,!0,n.parseColor,null),new r(t.ns_tts,"direction","ltr",["p","span"],!0,!0,(function(e){return e}),null),new r(t.ns_tts,"display","auto",["body","div","p","region","span"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"displayAlign","before",["region"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"extent","auto",["tt","region"],!1,!0,(function(e){if("auto"===e)return e;var t=e.split(" ");if(2!==t.length)return null;var r=n.parseLength(t[0]),i=n.parseLength(t[1]);return i&&r?{h:i,w:r}:null}),(function(e,t,n,r,i){var a,o;if("auto"===r)a=1;else if("%"===r.h.unit)a=r.h.value/100;else{if("px"!==r.h.unit)return null;a=r.h.value/e.pxDimensions.h}if("auto"===r)o=1;else if("%"===r.w.unit)o=r.w.value/100;else{if("px"!==r.w.unit)return null;o=r.w.value/e.pxDimensions.w}return{h:a,w:o}})),new r(t.ns_tts,"fontFamily","default",["span"],!0,!0,(function(e){var t=e.split(","),n=[];for(var r in t)"'"!==t[r].charAt(0)&&'"'!==t[r].charAt(0)&&"default"===t[r]?n.push("monospaceSerif"):n.push(t[r]);return n}),null),new r(t.ns_tts,"fontSize","1c",["span"],!0,!0,n.parseLength,(function(t,n,r,i,a){var o;if("%"===i.unit)o=null!==n?n.styleAttrs[e.byName.fontSize.qname]*i.value/100:i.value/100/t.cellResolution.h;else if("em"===i.unit)o=null!==n?n.styleAttrs[e.byName.fontSize.qname]*i.value:i.value/t.cellResolution.h;else if("c"===i.unit)o=i.value/t.cellResolution.h;else{if("px"!==i.unit)return null;o=i.value/t.pxDimensions.h}return o})),new r(t.ns_tts,"fontStyle","normal",["span"],!0,!0,(function(e){return e}),null),new r(t.ns_tts,"fontWeight","normal",["span"],!0,!0,(function(e){return e}),null),new r(t.ns_tts,"lineHeight","normal",["p"],!0,!0,(function(e){return"normal"===e?e:n.parseLength(e)}),(function(t,n,r,i,a){var o;if("normal"===i)o=i;else if("%"===i.unit)o=r.styleAttrs[e.byName.fontSize.qname]*i.value/100;else if("em"===i.unit)o=r.styleAttrs[e.byName.fontSize.qname]*i.value;else if("c"===i.unit)o=i.value/t.cellResolution.h;else{if("px"!==i.unit)return null;o=i.value/t.pxDimensions.h}return o})),new r(t.ns_tts,"opacity",1,["region"],!1,!0,parseFloat,null),new r(t.ns_tts,"origin","auto",["region"],!1,!0,(function(e){if("auto"===e)return e;var t=e.split(" ");if(2!==t.length)return null;var r=n.parseLength(t[0]),i=n.parseLength(t[1]);return i&&r?{h:i,w:r}:null}),(function(e,t,n,r,i){var a,o;if("auto"===r)a=0;else if("%"===r.h.unit)a=r.h.value/100;else{if("px"!==r.h.unit)return null;a=r.h.value/e.pxDimensions.h}if("auto"===r)o=0;else if("%"===r.w.unit)o=r.w.value/100;else{if("px"!==r.w.unit)return null;o=r.w.value/e.pxDimensions.w}return{h:a,w:o}})),new r(t.ns_tts,"overflow","hidden",["region"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"padding","0px",["region"],!1,!0,(function(e){var t=e.split(" ");if(t.length>4)return null;var r=[];for(var i in t){var a=n.parseLength(t[i]);if(!a)return null;r.push(a)}return r}),(function(t,n,r,i,a){var o;if(1===i.length)o=[i[0],i[0],i[0],i[0]];else if(2===i.length)o=[i[0],i[1],i[0],i[1]];else if(3===i.length)o=[i[0],i[1],i[2],i[1]];else{if(4!==i.length)return null;o=[i[0],i[1],i[2],i[3]]}var s=r.styleAttrs[e.byName.writingMode.qname];if("lrtb"===s||"lr"===s)o=[o[0],o[3],o[2],o[1]];else if("rltb"===s||"rl"===s)o=[o[0],o[1],o[2],o[3]];else if("tblr"===s)o=[o[3],o[0],o[1],o[2]];else{if("tbrl"!==s&&"tb"!==s)return null;o=[o[3],o[2],o[1],o[0]]}var u=[];for(var l in o)if(0===o[l].value)u[l]=0;else if("%"===o[l].unit)u[l]="0"===l||"2"===l?r.styleAttrs[e.byName.extent.qname].h*o[l].value/100:r.styleAttrs[e.byName.extent.qname].w*o[l].value/100;else if("em"===o[l].unit)u[l]=r.styleAttrs[e.byName.fontSize.qname]*o[l].value;else if("c"===o[l].unit)u[l]=o[l].value/t.cellResolution.h;else{if("px"!==o[l].unit)return null;u[l]="0"===l||"2"===l?o[l].value/t.pxDimensions.h:o[l].value/t.pxDimensions.w}return u})),new r(t.ns_tts,"showBackground","always",["region"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"textAlign","start",["p"],!0,!0,(function(e){return e}),(function(e,t,n,r,i){return"left"===r?"start":"right"===r?"end":r})),new r(t.ns_tts,"textDecoration","none",["span"],!0,!0,(function(e){return e.split(" ")}),null),new r(t.ns_tts,"textOutline","none",["span"],!0,!0,(function(e){if("none"===e)return e;var t={},r=e.split(" ");if(0===r.length||r.length>2)return null;var i=n.parseColor(r[0]);if(t.color=i,null!==i&&r.shift(),1!==r.length)return null;var a=n.parseLength(r[0]);return a?(t.thickness=a,t):null}),(function(t,n,r,i,a){if("none"===i)return i;var o={};if(null===i.color?o.color=r.styleAttrs[e.byName.color.qname]:o.color=i.color,"%"===i.thickness.unit)o.thickness=r.styleAttrs[e.byName.fontSize.qname]*i.thickness.value/100;else if("em"===i.thickness.unit)o.thickness=r.styleAttrs[e.byName.fontSize.qname]*i.thickness.value;else if("c"===i.thickness.unit)o.thickness=i.thickness.value/t.cellResolution.h;else{if("px"!==i.thickness.unit)return null;o.thickness=i.thickness.value/t.pxDimensions.h}return o})),new r(t.ns_tts,"unicodeBidi","normal",["span","p"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"visibility","visible",["body","div","p","region","span"],!0,!0,(function(e){return e}),null),new r(t.ns_tts,"wrapOption","wrap",["span"],!0,!0,(function(e){return e}),null),new r(t.ns_tts,"writingMode","lrtb",["region"],!1,!0,(function(e){return e}),null),new r(t.ns_tts,"zIndex","auto",["region"],!1,!0,(function(e){var t;return"auto"===e?t=e:(t=parseInt(e),isNaN(t)&&(t=null)),t}),null),new r(t.ns_ebutts,"linePadding","0c",["p"],!0,!1,n.parseLength,(function(e,t,n,r,i){return"c"===r.unit?r.value/e.cellResolution.h:null})),new r(t.ns_ebutts,"multiRowAlign","auto",["p"],!0,!1,(function(e){return e}),null),new r(t.ns_smpte,"backgroundImage",null,["div"],!1,!1,(function(e){return e}),null),new r(t.ns_itts,"forcedDisplay","false",["body","div","p","region","span"],!0,!0,(function(e){return"true"===e}),null),new r(t.ns_itts,"fillLineGap","false",["p"],!0,!0,(function(e){return"true"===e}),null)],e.byQName={},e.all)e.byQName[e.all[i].qname]=e.all[i];for(var a in e.byName={},e.all)e.byName[e.all[a].name]=e.all[a]}(t,"undefined"==typeof imscNames?n(51):imscNames,"undefined"==typeof imscUtils?n(69):imscUtils)},function(e,t,n){"use strict";(function(e){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
var r=n(81),i=n(82),a=n(70);function o(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function s(e,t){if(o()<t)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=u.prototype:(null===e&&(e=new u(t)),e.length=t),e}function u(e,t,n){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return f(this,e)}return l(this,e,t,n)}function l(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r);u.TYPED_ARRAY_SUPPORT?(e=t).__proto__=u.prototype:e=d(e,t);return e}(e,t,n,r):"string"==typeof t?function(e,t,n){"string"==typeof n&&""!==n||(n="utf8");if(!u.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|p(t,n),i=(e=s(e,r)).write(t,n);i!==r&&(e=e.slice(0,i));return e}(e,t,n):function(e,t){if(u.isBuffer(t)){var n=0|h(t.length);return 0===(e=s(e,n)).length||t.copy(e,0,0,n),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(r=t.length)!=r?s(e,0):d(e,t);if("Buffer"===t.type&&a(t.data))return d(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function c(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function f(e,t){if(c(t),e=s(e,t<0?0:0|h(t)),!u.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function d(e,t){var n=t.length<0?0:0|h(t.length);e=s(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function h(e){if(e>=o())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+o().toString(16)+" bytes");return 0|e}function p(e,t){if(u.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=!1;;)switch(t){case"ascii":case"latin1":case"binary":return n;case"utf8":case"utf-8":case void 0:return G(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return j(e).length;default:if(r)return G(e).length;t=(""+t).toLowerCase(),r=!0}}function g(e,t,n){var r=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return"";if((n>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return w(this,t,n);case"utf8":case"utf-8":return R(this,t,n);case"ascii":return N(this,t,n);case"latin1":case"binary":return C(this,t,n);case"base64":return I(this,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return D(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=!0}}function m(e,t,n){var r=e[t];e[t]=e[n],e[n]=r}function y(e,t,n,r,i){if(0===e.length)return-1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(i)return-1;n=e.length-1}else if(n<0){if(!i)return-1;n=0}if("string"==typeof t&&(t=u.from(t,r)),u.isBuffer(t))return 0===t.length?-1:E(e,t,n,r,i);if("number"==typeof t)return t&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):E(e,[t],n,r,i);throw new TypeError("val must be string, number or Buffer")}function E(e,t,n,r,i){var a,o=1,s=e.length,u=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return-1;o=2,s/=2,u/=2,n/=2}function l(e,t){return 1===o?e[t]:e.readUInt16BE(t*o)}if(i){var c=-1;for(a=n;a<s;a++)if(l(e,a)===l(t,-1===c?0:a-c)){if(-1===c&&(c=a),a-c+1===u)return c*o}else-1!==c&&(a-=a-c),c=-1}else for(n+u>s&&(n=s-u),a=n;a>=0;a--){for(var f=!0,d=0;d<u;d++)if(l(e,a+d)!==l(t,d)){f=!1;break}if(f)return a}return-1}function _(e,t,n,r){n=Number(n)||0;var i=e.length-n;r?(r=Number(r))>i&&(r=i):r=i;var a=t.length;if(a%2!=0)throw new TypeError("Invalid hex string");r>a/2&&(r=a/2);for(var o=0;o<r;++o){var s=parseInt(t.substr(2*o,2),16);if(isNaN(s))return o;e[n+o]=s}return o}function T(e,t,n,r){return Y(G(t,e.length-n),e,n,r)}function v(e,t,n,r){return Y(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function S(e,t,n,r){return v(e,t,n,r)}function A(e,t,n,r){return Y(j(t),e,n,r)}function b(e,t,n,r){return Y(function(e,t){for(var n,r,i,a=[],o=0;o<e.length&&!((t-=2)<0);++o)n=e.charCodeAt(o),r=n>>8,i=n%256,a.push(i),a.push(r);return a}(t,e.length-n),e,n,r)}function I(e,t,n){return 0===t&&n===e.length?r.fromByteArray(e):r.fromByteArray(e.slice(t,n))}function R(e,t,n){n=Math.min(e.length,n);for(var r=[],i=t;i<n;){var a,o,s,u,l=e[i],c=null,f=l>239?4:l>223?3:l>191?2:1;if(i+f<=n)switch(f){case 1:l<128&&(c=l);break;case 2:128==(192&(a=e[i+1]))&&(u=(31&l)<<6|63&a)>127&&(c=u);break;case 3:a=e[i+1],o=e[i+2],128==(192&a)&&128==(192&o)&&(u=(15&l)<<12|(63&a)<<6|63&o)>2047&&(u<55296||u>57343)&&(c=u);break;case 4:a=e[i+1],o=e[i+2],s=e[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&(u=(15&l)<<18|(63&a)<<12|(63&o)<<6|63&s)>65535&&u<1114112&&(c=u)}null===c?(c=65533,f=1):c>65535&&(c-=65536,r.push(c>>>10&1023|55296),c=56320|1023&c),r.push(c),i+=f}return function(e){var t=e.length;if(t<=4096)return String.fromCharCode.apply(String,e);var n="",r=0;for(;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=4096));return n}(r)}t.Buffer=u,t.SlowBuffer=function(e){+e!=e&&(e=0);return u.alloc(+e)},t.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==e.TYPED_ARRAY_SUPPORT?e.TYPED_ARRAY_SUPPORT:function(){try{var e=new Uint8Array(1);return e.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(e){return!1}}(),t.kMaxLength=o(),u.poolSize=8192,u._augment=function(e){return e.__proto__=u.prototype,e},u.from=function(e,t,n){return l(null,e,t,n)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(e,t,n){return function(e,t,n,r){return c(t),t<=0?s(e,t):void 0!==n?"string"==typeof r?s(e,t).fill(n,r):s(e,t).fill(n):s(e,t)}(null,e,t,n)},u.allocUnsafe=function(e){return f(null,e)},u.allocUnsafeSlow=function(e){return f(null,e)},u.isBuffer=function(e){return!(null==e||!e._isBuffer)},u.compare=function(e,t){if(!u.isBuffer(e)||!u.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,i=0,a=Math.min(n,r);i<a;++i)if(e[i]!==t[i]){n=e[i],r=t[i];break}return n<r?-1:r<n?1:0},u.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function(e,t){if(!a(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return u.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=u.allocUnsafe(t),i=0;for(n=0;n<e.length;++n){var o=e[n];if(!u.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(r,i),i+=o.length}return r},u.byteLength=p,u.prototype._isBuffer=!0,u.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)m(this,t,t+1);return this},u.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)m(this,t,t+3),m(this,t+1,t+2);return this},u.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)m(this,t,t+7),m(this,t+1,t+6),m(this,t+2,t+5),m(this,t+3,t+4);return this},u.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?R(this,0,e):g.apply(this,arguments)},u.prototype.equals=function(e){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===u.compare(this,e)},u.prototype.inspect=function(){var e="",n=t.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(e+=" ... ")),"<Buffer "+e+">"},u.prototype.compare=function(e,t,n,r,i){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),t<0||n>e.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&t>=n)return 0;if(r>=i)return-1;if(t>=n)return 1;if(this===e)return 0;for(var a=(i>>>=0)-(r>>>=0),o=(n>>>=0)-(t>>>=0),s=Math.min(a,o),l=this.slice(r,i),c=e.slice(t,n),f=0;f<s;++f)if(l[f]!==c[f]){a=l[f],o=c[f];break}return a<o?-1:o<a?1:0},u.prototype.includes=function(e,t,n){return-1!==this.indexOf(e,t,n)},u.prototype.indexOf=function(e,t,n){return y(this,e,t,n,!0)},u.prototype.lastIndexOf=function(e,t,n){return y(this,e,t,n,!1)},u.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0)}var i=this.length-t;if((void 0===n||n>i)&&(n=i),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var a=!1;;)switch(r){case"hex":return _(this,e,t,n);case"utf8":case"utf-8":return T(this,e,t,n);case"ascii":return v(this,e,t,n);case"latin1":case"binary":return S(this,e,t,n);case"base64":return A(this,e,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return b(this,e,t,n);default:if(a)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),a=!0}},u.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};function N(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(127&e[i]);return r}function C(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(e[i]);return r}function w(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var i="",a=t;a<n;++a)i+=k(e[a]);return i}function D(e,t,n){for(var r=e.slice(t,n),i="",a=0;a<r.length;a+=2)i+=String.fromCharCode(r[a]+256*r[a+1]);return i}function O(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function M(e,t,n,r,i,a){if(!u.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<a)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function P(e,t,n,r){t<0&&(t=65535+t+1);for(var i=0,a=Math.min(e.length-n,2);i<a;++i)e[n+i]=(t&255<<8*(r?i:1-i))>>>8*(r?i:1-i)}function L(e,t,n,r){t<0&&(t=4294967295+t+1);for(var i=0,a=Math.min(e.length-n,4);i<a;++i)e[n+i]=t>>>8*(r?i:3-i)&255}function F(e,t,n,r,i,a){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function x(e,t,n,r,a){return a||F(e,0,n,4),i.write(e,t,n,r,23,4),n+4}function U(e,t,n,r,a){return a||F(e,0,n,8),i.write(e,t,n,r,52,8),n+8}u.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),u.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=u.prototype;else{var i=t-e;n=new u(i,void 0);for(var a=0;a<i;++a)n[a]=this[a+e]}return n},u.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||O(e,t,this.length);for(var r=this[e],i=1,a=0;++a<t&&(i*=256);)r+=this[e+a]*i;return r},u.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||O(e,t,this.length);for(var r=this[e+--t],i=1;t>0&&(i*=256);)r+=this[e+--t]*i;return r},u.prototype.readUInt8=function(e,t){return t||O(e,1,this.length),this[e]},u.prototype.readUInt16LE=function(e,t){return t||O(e,2,this.length),this[e]|this[e+1]<<8},u.prototype.readUInt16BE=function(e,t){return t||O(e,2,this.length),this[e]<<8|this[e+1]},u.prototype.readUInt32LE=function(e,t){return t||O(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},u.prototype.readUInt32BE=function(e,t){return t||O(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},u.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||O(e,t,this.length);for(var r=this[e],i=1,a=0;++a<t&&(i*=256);)r+=this[e+a]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*t)),r},u.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||O(e,t,this.length);for(var r=t,i=1,a=this[e+--r];r>0&&(i*=256);)a+=this[e+--r]*i;return a>=(i*=128)&&(a-=Math.pow(2,8*t)),a},u.prototype.readInt8=function(e,t){return t||O(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},u.prototype.readInt16LE=function(e,t){t||O(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt16BE=function(e,t){t||O(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt32LE=function(e,t){return t||O(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},u.prototype.readInt32BE=function(e,t){return t||O(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},u.prototype.readFloatLE=function(e,t){return t||O(e,4,this.length),i.read(this,e,!0,23,4)},u.prototype.readFloatBE=function(e,t){return t||O(e,4,this.length),i.read(this,e,!1,23,4)},u.prototype.readDoubleLE=function(e,t){return t||O(e,8,this.length),i.read(this,e,!0,52,8)},u.prototype.readDoubleBE=function(e,t){return t||O(e,8,this.length),i.read(this,e,!1,52,8)},u.prototype.writeUIntLE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||M(this,e,t,n,Math.pow(2,8*n)-1,0);var i=1,a=0;for(this[t]=255&e;++a<n&&(i*=256);)this[t+a]=e/i&255;return t+n},u.prototype.writeUIntBE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||M(this,e,t,n,Math.pow(2,8*n)-1,0);var i=n-1,a=1;for(this[t+i]=255&e;--i>=0&&(a*=256);)this[t+i]=e/a&255;return t+n},u.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,1,255,0),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},u.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):P(this,e,t,!0),t+2},u.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):P(this,e,t,!1),t+2},u.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):L(this,e,t,!0),t+4},u.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):L(this,e,t,!1),t+4},u.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);M(this,e,t,n,i-1,-i)}var a=0,o=1,s=0;for(this[t]=255&e;++a<n&&(o*=256);)e<0&&0===s&&0!==this[t+a-1]&&(s=1),this[t+a]=(e/o>>0)-s&255;return t+n},u.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);M(this,e,t,n,i-1,-i)}var a=n-1,o=1,s=0;for(this[t+a]=255&e;--a>=0&&(o*=256);)e<0&&0===s&&0!==this[t+a+1]&&(s=1),this[t+a]=(e/o>>0)-s&255;return t+n},u.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,1,127,-128),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},u.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):P(this,e,t,!0),t+2},u.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):P(this,e,t,!1),t+2},u.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):L(this,e,t,!0),t+4},u.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||M(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),u.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):L(this,e,t,!1),t+4},u.prototype.writeFloatLE=function(e,t,n){return x(this,e,t,!0,n)},u.prototype.writeFloatBE=function(e,t,n){return x(this,e,t,!1,n)},u.prototype.writeDoubleLE=function(e,t,n){return U(this,e,t,!0,n)},u.prototype.writeDoubleBE=function(e,t,n){return U(this,e,t,!1,n)},u.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var i,a=r-n;if(this===e&&n<t&&t<r)for(i=a-1;i>=0;--i)e[i+t]=this[i+n];else if(a<1e3||!u.TYPED_ARRAY_SUPPORT)for(i=0;i<a;++i)e[i+t]=this[i+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+a),t);return a},u.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!u.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var a;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(a=t;a<n;++a)this[a]=e;else{var o=u.isBuffer(e)?e:G(new u(e,r).toString()),s=o.length;for(a=0;a<n-t;++a)this[a+t]=o[a%s]}return this};var B=/[^+\/0-9A-Za-z-_]/g;function k(e){return e<16?"0"+e.toString(16):e.toString(16)}function G(e,t){var n;t=t||1/0;for(var r=e.length,i=null,a=[],o=0;o<r;++o){if((n=e.charCodeAt(o))>55295&&n<57344){if(!i){if(n>56319){(t-=3)>-1&&a.push(239,191,189);continue}if(o+1===r){(t-=3)>-1&&a.push(239,191,189);continue}i=n;continue}if(n<56320){(t-=3)>-1&&a.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320)}else i&&(t-=3)>-1&&a.push(239,191,189);if(i=null,n<128){if((t-=1)<0)break;a.push(n)}else if(n<2048){if((t-=2)<0)break;a.push(n>>6|192,63&n|128)}else if(n<65536){if((t-=3)<0)break;a.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;a.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return a}function j(e){return r.toByteArray(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(B,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function Y(e,t,n,r){for(var i=0;i<r&&!(i+n>=t.length||i>=e.length);++i)t[i+n]=e[i];return i}}).call(this,n(23))},function(e,t,n){"use strict";var r,i="object"==typeof Reflect?Reflect:null,a=i&&"function"==typeof i.apply?i.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};r=i&&"function"==typeof i.ownKeys?i.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var o=Number.isNaN||function(e){return e!=e};function s(){s.init.call(this)}e.exports=s,e.exports.once=function(e,t){return new Promise((function(n,r){function i(n){e.removeListener(t,a),r(n)}function a(){"function"==typeof e.removeListener&&e.removeListener("error",i),n([].slice.call(arguments))}y(e,t,a,{once:!0}),"error"!==t&&function(e,t,n){"function"==typeof e.on&&y(e,"error",t,n)}(e,i,{once:!0})}))},s.EventEmitter=s,s.prototype._events=void 0,s.prototype._eventsCount=0,s.prototype._maxListeners=void 0;var u=10;function l(e){if("function"!=typeof e)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}function c(e){return void 0===e._maxListeners?s.defaultMaxListeners:e._maxListeners}function f(e,t,n,r){var i,a,o,s;if(l(n),void 0===(a=e._events)?(a=e._events=Object.create(null),e._eventsCount=0):(void 0!==a.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),a=e._events),o=a[t]),void 0===o)o=a[t]=n,++e._eventsCount;else if("function"==typeof o?o=a[t]=r?[n,o]:[o,n]:r?o.unshift(n):o.push(n),(i=c(e))>0&&o.length>i&&!o.warned){o.warned=!0;var u=new Error("Possible EventEmitter memory leak detected. "+o.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");u.name="MaxListenersExceededWarning",u.emitter=e,u.type=t,u.count=o.length,s=u,console&&console.warn&&console.warn(s)}return e}function d(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function h(e,t,n){var r={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},i=d.bind(r);return i.listener=n,r.wrapFn=i,i}function p(e,t,n){var r=e._events;if(void 0===r)return[];var i=r[t];return void 0===i?[]:"function"==typeof i?n?[i.listener||i]:[i]:n?function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(i):m(i,i.length)}function g(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function m(e,t){for(var n=new Array(t),r=0;r<t;++r)n[r]=e[r];return n}function y(e,t,n,r){if("function"==typeof e.on)r.once?e.once(t,n):e.on(t,n);else{if("function"!=typeof e.addEventListener)throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof e);e.addEventListener(t,(function i(a){r.once&&e.removeEventListener(t,i),n(a)}))}}Object.defineProperty(s,"defaultMaxListeners",{enumerable:!0,get:function(){return u},set:function(e){if("number"!=typeof e||e<0||o(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");u=e}}),s.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},s.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||o(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},s.prototype.getMaxListeners=function(){return c(this)},s.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var r="error"===e,i=this._events;if(void 0!==i)r=r&&void 0===i.error;else if(!r)return!1;if(r){var o;if(t.length>0&&(o=t[0]),o instanceof Error)throw o;var s=new Error("Unhandled error."+(o?" ("+o.message+")":""));throw s.context=o,s}var u=i[e];if(void 0===u)return!1;if("function"==typeof u)a(u,this,t);else{var l=u.length,c=m(u,l);for(n=0;n<l;++n)a(c[n],this,t)}return!0},s.prototype.addListener=function(e,t){return f(this,e,t,!1)},s.prototype.on=s.prototype.addListener,s.prototype.prependListener=function(e,t){return f(this,e,t,!0)},s.prototype.once=function(e,t){return l(t),this.on(e,h(this,e,t)),this},s.prototype.prependOnceListener=function(e,t){return l(t),this.prependListener(e,h(this,e,t)),this},s.prototype.removeListener=function(e,t){var n,r,i,a,o;if(l(t),void 0===(r=this._events))return this;if(void 0===(n=r[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete r[e],r.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(i=-1,a=n.length-1;a>=0;a--)if(n[a]===t||n[a].listener===t){o=n[a].listener,i=a;break}if(i<0)return this;0===i?n.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}(n,i),1===n.length&&(r[e]=n[0]),void 0!==r.removeListener&&this.emit("removeListener",e,o||t)}return this},s.prototype.off=s.prototype.removeListener,s.prototype.removeAllListeners=function(e){var t,n,r;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var i,a=Object.keys(n);for(r=0;r<a.length;++r)"removeListener"!==(i=a[r])&&this.removeAllListeners(i);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(r=t.length-1;r>=0;r--)this.removeListener(e,t[r]);return this},s.prototype.listeners=function(e){return p(this,e,!0)},s.prototype.rawListeners=function(e){return p(this,e,!1)},s.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):g.call(e,t)},s.prototype.listenerCount=g,s.prototype.eventNames=function(){return this._eventsCount>0?r(this._events):[]}},function(e,t,n){(t=e.exports=n(71)).Stream=t,t.Readable=t,t.Writable=n(67),t.Duplex=n(35),t.Transform=n(74),t.PassThrough=n(90)},function(e,t,n){"use strict";(function(t,r,i){var a=n(52);function o(e){var t=this;this.next=null,this.entry=null,this.finish=function(){!function(e,t,n){var r=e.entry;e.entry=null;for(;r;){var i=r.callback;t.pendingcb--,i(n),r=r.next}t.corkedRequestsFree?t.corkedRequestsFree.next=e:t.corkedRequestsFree=e}(t,e)}}e.exports=E;var s,u=!t.browser&&["v0.10","v0.9."].indexOf(t.version.slice(0,5))>-1?r:a.nextTick;E.WritableState=y;var l=n(47);l.inherits=n(40);var c={deprecate:n(89)},f=n(72),d=n(53).Buffer,h=i.Uint8Array||function(){};var p,g=n(73);function m(){}function y(e,t){s=s||n(35),e=e||{};var r=t instanceof s;this.objectMode=!!e.objectMode,r&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var i=e.highWaterMark,l=e.writableHighWaterMark,c=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:r&&(l||0===l)?l:c,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var f=!1===e.decodeStrings;this.decodeStrings=!f,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(e){!function(e,t){var n=e._writableState,r=n.sync,i=n.writecb;if(function(e){e.writing=!1,e.writecb=null,e.length-=e.writelen,e.writelen=0}(n),t)!function(e,t,n,r,i){--t.pendingcb,n?(a.nextTick(i,r),a.nextTick(b,e,t),e._writableState.errorEmitted=!0,e.emit("error",r)):(i(r),e._writableState.errorEmitted=!0,e.emit("error",r),b(e,t))}(e,n,r,t,i);else{var o=S(n);o||n.corked||n.bufferProcessing||!n.bufferedRequest||v(e,n),r?u(T,e,n,o,i):T(e,n,o,i)}}(t,e)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new o(this)}function E(e){if(s=s||n(35),!(p.call(E,this)||this instanceof s))return new E(e);this._writableState=new y(e,this),this.writable=!0,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e.final&&(this._final=e.final)),f.call(this)}function _(e,t,n,r,i,a,o){t.writelen=r,t.writecb=o,t.writing=!0,t.sync=!0,n?e._writev(i,t.onwrite):e._write(i,a,t.onwrite),t.sync=!1}function T(e,t,n,r){n||function(e,t){0===t.length&&t.needDrain&&(t.needDrain=!1,e.emit("drain"))}(e,t),t.pendingcb--,r(),b(e,t)}function v(e,t){t.bufferProcessing=!0;var n=t.bufferedRequest;if(e._writev&&n&&n.next){var r=t.bufferedRequestCount,i=new Array(r),a=t.corkedRequestsFree;a.entry=n;for(var s=0,u=!0;n;)i[s]=n,n.isBuf||(u=!1),n=n.next,s+=1;i.allBuffers=u,_(e,t,!0,t.length,i,"",a.finish),t.pendingcb++,t.lastBufferedRequest=null,a.next?(t.corkedRequestsFree=a.next,a.next=null):t.corkedRequestsFree=new o(t),t.bufferedRequestCount=0}else{for(;n;){var l=n.chunk,c=n.encoding,f=n.callback;if(_(e,t,!1,t.objectMode?1:l.length,l,c,f),n=n.next,t.bufferedRequestCount--,t.writing)break}null===n&&(t.lastBufferedRequest=null)}t.bufferedRequest=n,t.bufferProcessing=!1}function S(e){return e.ending&&0===e.length&&null===e.bufferedRequest&&!e.finished&&!e.writing}function A(e,t){e._final((function(n){t.pendingcb--,n&&e.emit("error",n),t.prefinished=!0,e.emit("prefinish"),b(e,t)}))}function b(e,t){var n=S(t);return n&&(!function(e,t){t.prefinished||t.finalCalled||("function"==typeof e._final?(t.pendingcb++,t.finalCalled=!0,a.nextTick(A,e,t)):(t.prefinished=!0,e.emit("prefinish")))}(e,t),0===t.pendingcb&&(t.finished=!0,e.emit("finish"))),n}l.inherits(E,f),y.prototype.getBuffer=function(){for(var e=this.bufferedRequest,t=[];e;)t.push(e),e=e.next;return t},function(){try{Object.defineProperty(y.prototype,"buffer",{get:c.deprecate((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(e){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(p=Function.prototype[Symbol.hasInstance],Object.defineProperty(E,Symbol.hasInstance,{value:function(e){return!!p.call(this,e)||this===E&&(e&&e._writableState instanceof y)}})):p=function(e){return e instanceof this},E.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},E.prototype.write=function(e,t,n){var r,i=this._writableState,o=!1,s=!i.objectMode&&(r=e,d.isBuffer(r)||r instanceof h);return s&&!d.isBuffer(e)&&(e=function(e){return d.from(e)}(e)),"function"==typeof t&&(n=t,t=null),s?t="buffer":t||(t=i.defaultEncoding),"function"!=typeof n&&(n=m),i.ended?function(e,t){var n=new Error("write after end");e.emit("error",n),a.nextTick(t,n)}(this,n):(s||function(e,t,n,r){var i=!0,o=!1;return null===n?o=new TypeError("May not write null values to stream"):"string"==typeof n||void 0===n||t.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(e.emit("error",o),a.nextTick(r,o),i=!1),i}(this,i,e,n))&&(i.pendingcb++,o=function(e,t,n,r,i,a){if(!n){var o=function(e,t,n){e.objectMode||!1===e.decodeStrings||"string"!=typeof t||(t=d.from(t,n));return t}(t,r,i);r!==o&&(n=!0,i="buffer",r=o)}var s=t.objectMode?1:r.length;t.length+=s;var u=t.length<t.highWaterMark;u||(t.needDrain=!0);if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:r,encoding:i,isBuf:n,callback:a,next:null},l?l.next=t.lastBufferedRequest:t.bufferedRequest=t.lastBufferedRequest,t.bufferedRequestCount+=1}else _(e,t,!1,s,r,i,a);return u}(this,i,s,e,t,n)),o},E.prototype.cork=function(){this._writableState.corked++},E.prototype.uncork=function(){var e=this._writableState;e.corked&&(e.corked--,e.writing||e.corked||e.finished||e.bufferProcessing||!e.bufferedRequest||v(this,e))},E.prototype.setDefaultEncoding=function(e){if("string"==typeof e&&(e=e.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+e);return this._writableState.defaultEncoding=e,this},Object.defineProperty(E.prototype,"writableHighWaterMark",{enumerable:!1,get:function(){return this._writableState.highWaterMark}}),E.prototype._write=function(e,t,n){n(new Error("_write() is not implemented"))},E.prototype._writev=null,E.prototype.end=function(e,t,n){var r=this._writableState;"function"==typeof e?(n=e,e=null,t=null):"function"==typeof t&&(n=t,t=null),null!=e&&this.write(e,t),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||function(e,t,n){t.ending=!0,b(e,t),n&&(t.finished?a.nextTick(n):e.once("finish",n));t.ended=!0,e.writable=!1}(this,r,n)},Object.defineProperty(E.prototype,"destroyed",{get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(e){this._writableState&&(this._writableState.destroyed=e)}}),E.prototype.destroy=g.destroy,E.prototype._undestroy=g.undestroy,E.prototype._destroy=function(e,t){this.end(),t(e)}}).call(this,n(25),n(87).setImmediate,n(23))},function(e,t,n){"use strict";var r=n(53).Buffer,i=r.isEncoding||function(e){switch((e=""+e)&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};function a(e){var t;switch(this.encoding=function(e){var t=function(e){if(!e)return"utf8";for(var t;;)switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase(),t=!0}}(e);if("string"!=typeof t&&(r.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}(e),this.encoding){case"utf16le":this.text=u,this.end=l,t=4;break;case"utf8":this.fillLast=s,t=4;break;case"base64":this.text=c,this.end=f,t=3;break;default:return this.write=d,void(this.end=h)}this.lastNeed=0,this.lastTotal=0,this.lastChar=r.allocUnsafe(t)}function o(e){return e<=127?0:e>>5==6?2:e>>4==14?3:e>>3==30?4:e>>6==2?-1:-2}function s(e){var t=this.lastTotal-this.lastNeed,n=function(e,t,n){if(128!=(192&t[0]))return e.lastNeed=0,"�";if(e.lastNeed>1&&t.length>1){if(128!=(192&t[1]))return e.lastNeed=1,"�";if(e.lastNeed>2&&t.length>2&&128!=(192&t[2]))return e.lastNeed=2,"�"}}(this,e);return void 0!==n?n:this.lastNeed<=e.length?(e.copy(this.lastChar,t,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(e.copy(this.lastChar,t,0,e.length),void(this.lastNeed-=e.length))}function u(e,t){if((e.length-t)%2==0){var n=e.toString("utf16le",t);if(n){var r=n.charCodeAt(n.length-1);if(r>=55296&&r<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=e[e.length-2],this.lastChar[1]=e[e.length-1],n.slice(0,-1)}return n}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=e[e.length-1],e.toString("utf16le",t,e.length-1)}function l(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var n=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,n)}return t}function c(e,t){var n=(e.length-t)%3;return 0===n?e.toString("base64",t):(this.lastNeed=3-n,this.lastTotal=3,1===n?this.lastChar[0]=e[e.length-1]:(this.lastChar[0]=e[e.length-2],this.lastChar[1]=e[e.length-1]),e.toString("base64",t,e.length-n))}function f(e){var t=e&&e.length?this.write(e):"";return this.lastNeed?t+this.lastChar.toString("base64",0,3-this.lastNeed):t}function d(e){return e.toString(this.encoding)}function h(e){return e&&e.length?this.write(e):""}t.StringDecoder=a,a.prototype.write=function(e){if(0===e.length)return"";var t,n;if(this.lastNeed){if(void 0===(t=this.fillLast(e)))return"";n=this.lastNeed,this.lastNeed=0}else n=0;return n<e.length?t?t+this.text(e,n):this.text(e,n):t||""},a.prototype.end=function(e){var t=e&&e.length?this.write(e):"";return this.lastNeed?t+"�":t},a.prototype.text=function(e,t){var n=function(e,t,n){var r=t.length-1;if(r<n)return 0;var i=o(t[r]);if(i>=0)return i>0&&(e.lastNeed=i-1),i;if(--r<n||-2===i)return 0;if((i=o(t[r]))>=0)return i>0&&(e.lastNeed=i-2),i;if(--r<n||-2===i)return 0;if((i=o(t[r]))>=0)return i>0&&(2===i?i=0:e.lastNeed=i-3),i;return 0}(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=n;var r=e.length-(n-this.lastNeed);return e.copy(this.lastChar,0,r),e.toString("utf8",t,r)},a.prototype.fillLast=function(e){if(this.lastNeed<=e.length)return e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length),this.lastNeed-=e.length}},function(e,t,n){!function(e){var t=/#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?/,n=/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,r=/rgba\(\s*(\d+),\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,i={transparent:[0,0,0,0],black:[0,0,0,255],silver:[192,192,192,255],gray:[128,128,128,255],white:[255,255,255,255],maroon:[128,0,0,255],red:[255,0,0,255],purple:[128,0,128,255],fuchsia:[255,0,255,255],magenta:[255,0,255,255],green:[0,128,0,255],lime:[0,255,0,255],olive:[128,128,0,255],yellow:[255,255,0,255],navy:[0,0,128,255],blue:[0,0,255,255],teal:[0,128,128,255],aqua:[0,255,255,255],cyan:[0,255,255,255]};e.parseColor=function(e){var a,o=null,s=i[e.toLowerCase()];return void 0!==s?o=s:null!==(a=t.exec(e))?o=[parseInt(a[1],16),parseInt(a[2],16),parseInt(a[3],16),void 0!==a[4]?parseInt(a[4],16):255]:null!==(a=n.exec(e))?o=[parseInt(a[1]),parseInt(a[2]),parseInt(a[3]),255]:null!==(a=r.exec(e))&&(o=[parseInt(a[1]),parseInt(a[2]),parseInt(a[3]),parseInt(a[4])]),o};var a=/^((?:\+|\-)?\d*(?:\.\d+)?)(px|em|c|%)$/;e.parseLength=function(e){var t,n=null;return null!==(t=a.exec(e))&&(n={value:parseFloat(t[1]),unit:t[2]}),n}}(t)},function(e,t){var n={}.toString;e.exports=Array.isArray||function(e){return"[object Array]"==n.call(e)}},function(e,t,n){"use strict";(function(t,r){var i=n(52);e.exports=_;var a,o=n(70);_.ReadableState=E;n(65).EventEmitter;var s=function(e,t){return e.listeners(t).length},u=n(72),l=n(53).Buffer,c=t.Uint8Array||function(){};var f=n(47);f.inherits=n(40);var d=n(84),h=void 0;h=d&&d.debuglog?d.debuglog("stream"):function(){};var p,g=n(85),m=n(73);f.inherits(_,u);var y=["error","close","destroy","pause","resume"];function E(e,t){e=e||{};var r=t instanceof(a=a||n(35));this.objectMode=!!e.objectMode,r&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var i=e.highWaterMark,o=e.readableHighWaterMark,s=this.objectMode?16:16384;this.highWaterMark=i||0===i?i:r&&(o||0===o)?o:s,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new g,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(p||(p=n(68).StringDecoder),this.decoder=new p(e.encoding),this.encoding=e.encoding)}function _(e){if(a=a||n(35),!(this instanceof _))return new _(e);this._readableState=new E(e,this),this.readable=!0,e&&("function"==typeof e.read&&(this._read=e.read),"function"==typeof e.destroy&&(this._destroy=e.destroy)),u.call(this)}function T(e,t,n,r,i){var a,o=e._readableState;null===t?(o.reading=!1,function(e,t){if(t.ended)return;if(t.decoder){var n=t.decoder.end();n&&n.length&&(t.buffer.push(n),t.length+=t.objectMode?1:n.length)}t.ended=!0,A(e)}(e,o)):(i||(a=function(e,t){var n;r=t,l.isBuffer(r)||r instanceof c||"string"==typeof t||void 0===t||e.objectMode||(n=new TypeError("Invalid non-string/buffer chunk"));var r;return n}(o,t)),a?e.emit("error",a):o.objectMode||t&&t.length>0?("string"==typeof t||o.objectMode||Object.getPrototypeOf(t)===l.prototype||(t=function(e){return l.from(e)}(t)),r?o.endEmitted?e.emit("error",new Error("stream.unshift() after end event")):v(e,o,t,!0):o.ended?e.emit("error",new Error("stream.push() after EOF")):(o.reading=!1,o.decoder&&!n?(t=o.decoder.write(t),o.objectMode||0!==t.length?v(e,o,t,!1):I(e,o)):v(e,o,t,!1))):r||(o.reading=!1));return function(e){return!e.ended&&(e.needReadable||e.length<e.highWaterMark||0===e.length)}(o)}function v(e,t,n,r){t.flowing&&0===t.length&&!t.sync?(e.emit("data",n),e.read(0)):(t.length+=t.objectMode?1:n.length,r?t.buffer.unshift(n):t.buffer.push(n),t.needReadable&&A(e)),I(e,t)}Object.defineProperty(_.prototype,"destroyed",{get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(e){this._readableState&&(this._readableState.destroyed=e)}}),_.prototype.destroy=m.destroy,_.prototype._undestroy=m.undestroy,_.prototype._destroy=function(e,t){this.push(null),t(e)},_.prototype.push=function(e,t){var n,r=this._readableState;return r.objectMode?n=!0:"string"==typeof e&&((t=t||r.defaultEncoding)!==r.encoding&&(e=l.from(e,t),t=""),n=!0),T(this,e,t,!1,n)},_.prototype.unshift=function(e){return T(this,e,null,!0,!1)},_.prototype.isPaused=function(){return!1===this._readableState.flowing},_.prototype.setEncoding=function(e){return p||(p=n(68).StringDecoder),this._readableState.decoder=new p(e),this._readableState.encoding=e,this};function S(e,t){return e<=0||0===t.length&&t.ended?0:t.objectMode?1:e!=e?t.flowing&&t.length?t.buffer.head.data.length:t.length:(e>t.highWaterMark&&(t.highWaterMark=function(e){return e>=8388608?e=8388608:(e--,e|=e>>>1,e|=e>>>2,e|=e>>>4,e|=e>>>8,e|=e>>>16,e++),e}(e)),e<=t.length?e:t.ended?t.length:(t.needReadable=!0,0))}function A(e){var t=e._readableState;t.needReadable=!1,t.emittedReadable||(h("emitReadable",t.flowing),t.emittedReadable=!0,t.sync?i.nextTick(b,e):b(e))}function b(e){h("emit readable"),e.emit("readable"),w(e)}function I(e,t){t.readingMore||(t.readingMore=!0,i.nextTick(R,e,t))}function R(e,t){for(var n=t.length;!t.reading&&!t.flowing&&!t.ended&&t.length<t.highWaterMark&&(h("maybeReadMore read 0"),e.read(0),n!==t.length);)n=t.length;t.readingMore=!1}function N(e){h("readable nexttick read 0"),e.read(0)}function C(e,t){t.reading||(h("resume read 0"),e.read(0)),t.resumeScheduled=!1,t.awaitDrain=0,e.emit("resume"),w(e),t.flowing&&!t.reading&&e.read(0)}function w(e){var t=e._readableState;for(h("flow",t.flowing);t.flowing&&null!==e.read(););}function D(e,t){return 0===t.length?null:(t.objectMode?n=t.buffer.shift():!e||e>=t.length?(n=t.decoder?t.buffer.join(""):1===t.buffer.length?t.buffer.head.data:t.buffer.concat(t.length),t.buffer.clear()):n=function(e,t,n){var r;e<t.head.data.length?(r=t.head.data.slice(0,e),t.head.data=t.head.data.slice(e)):r=e===t.head.data.length?t.shift():n?function(e,t){var n=t.head,r=1,i=n.data;e-=i.length;for(;n=n.next;){var a=n.data,o=e>a.length?a.length:e;if(o===a.length?i+=a:i+=a.slice(0,e),0===(e-=o)){o===a.length?(++r,n.next?t.head=n.next:t.head=t.tail=null):(t.head=n,n.data=a.slice(o));break}++r}return t.length-=r,i}(e,t):function(e,t){var n=l.allocUnsafe(e),r=t.head,i=1;r.data.copy(n),e-=r.data.length;for(;r=r.next;){var a=r.data,o=e>a.length?a.length:e;if(a.copy(n,n.length-e,0,o),0===(e-=o)){o===a.length?(++i,r.next?t.head=r.next:t.head=t.tail=null):(t.head=r,r.data=a.slice(o));break}++i}return t.length-=i,n}(e,t);return r}(e,t.buffer,t.decoder),n);var n}function O(e){var t=e._readableState;if(t.length>0)throw new Error('"endReadable()" called on non-empty stream');t.endEmitted||(t.ended=!0,i.nextTick(M,t,e))}function M(e,t){e.endEmitted||0!==e.length||(e.endEmitted=!0,t.readable=!1,t.emit("end"))}function P(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1}_.prototype.read=function(e){h("read",e),e=parseInt(e,10);var t=this._readableState,n=e;if(0!==e&&(t.emittedReadable=!1),0===e&&t.needReadable&&(t.length>=t.highWaterMark||t.ended))return h("read: emitReadable",t.length,t.ended),0===t.length&&t.ended?O(this):A(this),null;if(0===(e=S(e,t))&&t.ended)return 0===t.length&&O(this),null;var r,i=t.needReadable;return h("need readable",i),(0===t.length||t.length-e<t.highWaterMark)&&h("length less than watermark",i=!0),t.ended||t.reading?h("reading or ended",i=!1):i&&(h("do read"),t.reading=!0,t.sync=!0,0===t.length&&(t.needReadable=!0),this._read(t.highWaterMark),t.sync=!1,t.reading||(e=S(n,t))),null===(r=e>0?D(e,t):null)?(t.needReadable=!0,e=0):t.length-=e,0===t.length&&(t.ended||(t.needReadable=!0),n!==e&&t.ended&&O(this)),null!==r&&this.emit("data",r),r},_.prototype._read=function(e){this.emit("error",new Error("_read() is not implemented"))},_.prototype.pipe=function(e,t){var n=this,a=this._readableState;switch(a.pipesCount){case 0:a.pipes=e;break;case 1:a.pipes=[a.pipes,e];break;default:a.pipes.push(e)}a.pipesCount+=1,h("pipe count=%d opts=%j",a.pipesCount,t);var u=(!t||!1!==t.end)&&e!==r.stdout&&e!==r.stderr?c:_;function l(t,r){h("onunpipe"),t===n&&r&&!1===r.hasUnpiped&&(r.hasUnpiped=!0,h("cleanup"),e.removeListener("close",y),e.removeListener("finish",E),e.removeListener("drain",f),e.removeListener("error",m),e.removeListener("unpipe",l),n.removeListener("end",c),n.removeListener("end",_),n.removeListener("data",g),d=!0,!a.awaitDrain||e._writableState&&!e._writableState.needDrain||f())}function c(){h("onend"),e.end()}a.endEmitted?i.nextTick(u):n.once("end",u),e.on("unpipe",l);var f=function(e){return function(){var t=e._readableState;h("pipeOnDrain",t.awaitDrain),t.awaitDrain&&t.awaitDrain--,0===t.awaitDrain&&s(e,"data")&&(t.flowing=!0,w(e))}}(n);e.on("drain",f);var d=!1;var p=!1;function g(t){h("ondata"),p=!1,!1!==e.write(t)||p||((1===a.pipesCount&&a.pipes===e||a.pipesCount>1&&-1!==P(a.pipes,e))&&!d&&(h("false write response, pause",n._readableState.awaitDrain),n._readableState.awaitDrain++,p=!0),n.pause())}function m(t){h("onerror",t),_(),e.removeListener("error",m),0===s(e,"error")&&e.emit("error",t)}function y(){e.removeListener("finish",E),_()}function E(){h("onfinish"),e.removeListener("close",y),_()}function _(){h("unpipe"),n.unpipe(e)}return n.on("data",g),function(e,t,n){if("function"==typeof e.prependListener)return e.prependListener(t,n);e._events&&e._events[t]?o(e._events[t])?e._events[t].unshift(n):e._events[t]=[n,e._events[t]]:e.on(t,n)}(e,"error",m),e.once("close",y),e.once("finish",E),e.emit("pipe",n),a.flowing||(h("pipe resume"),n.resume()),e},_.prototype.unpipe=function(e){var t=this._readableState,n={hasUnpiped:!1};if(0===t.pipesCount)return this;if(1===t.pipesCount)return e&&e!==t.pipes||(e||(e=t.pipes),t.pipes=null,t.pipesCount=0,t.flowing=!1,e&&e.emit("unpipe",this,n)),this;if(!e){var r=t.pipes,i=t.pipesCount;t.pipes=null,t.pipesCount=0,t.flowing=!1;for(var a=0;a<i;a++)r[a].emit("unpipe",this,n);return this}var o=P(t.pipes,e);return-1===o||(t.pipes.splice(o,1),t.pipesCount-=1,1===t.pipesCount&&(t.pipes=t.pipes[0]),e.emit("unpipe",this,n)),this},_.prototype.on=function(e,t){var n=u.prototype.on.call(this,e,t);if("data"===e)!1!==this._readableState.flowing&&this.resume();else if("readable"===e){var r=this._readableState;r.endEmitted||r.readableListening||(r.readableListening=r.needReadable=!0,r.emittedReadable=!1,r.reading?r.length&&A(this):i.nextTick(N,this))}return n},_.prototype.addListener=_.prototype.on,_.prototype.resume=function(){var e=this._readableState;return e.flowing||(h("resume"),e.flowing=!0,function(e,t){t.resumeScheduled||(t.resumeScheduled=!0,i.nextTick(C,e,t))}(this,e)),this},_.prototype.pause=function(){return h("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(h("pause"),this._readableState.flowing=!1,this.emit("pause")),this},_.prototype.wrap=function(e){var t=this,n=this._readableState,r=!1;for(var i in e.on("end",(function(){if(h("wrapped end"),n.decoder&&!n.ended){var e=n.decoder.end();e&&e.length&&t.push(e)}t.push(null)})),e.on("data",(function(i){(h("wrapped data"),n.decoder&&(i=n.decoder.write(i)),n.objectMode&&null==i)||(n.objectMode||i&&i.length)&&(t.push(i)||(r=!0,e.pause()))})),e)void 0===this[i]&&"function"==typeof e[i]&&(this[i]=function(t){return function(){return e[t].apply(e,arguments)}}(i));for(var a=0;a<y.length;a++)e.on(y[a],this.emit.bind(this,y[a]));return this._read=function(t){h("wrapped _read",t),r&&(r=!1,e.resume())},this},Object.defineProperty(_.prototype,"readableHighWaterMark",{enumerable:!1,get:function(){return this._readableState.highWaterMark}}),_._fromList=D}).call(this,n(23),n(25))},function(e,t,n){e.exports=n(65).EventEmitter},function(e,t,n){"use strict";var r=n(52);function i(e,t){e.emit("error",t)}e.exports={destroy:function(e,t){var n=this,a=this._readableState&&this._readableState.destroyed,o=this._writableState&&this._writableState.destroyed;return a||o?(t?t(e):!e||this._writableState&&this._writableState.errorEmitted||r.nextTick(i,this,e),this):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),this._destroy(e||null,(function(e){!t&&e?(r.nextTick(i,n,e),n._writableState&&(n._writableState.errorEmitted=!0)):t&&t(e)})),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}}},function(e,t,n){"use strict";e.exports=o;var r=n(35),i=n(47);function a(e,t){var n=this._transformState;n.transforming=!1;var r=n.writecb;if(!r)return this.emit("error",new Error("write callback called multiple times"));n.writechunk=null,n.writecb=null,null!=t&&this.push(t),r(e);var i=this._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}function o(e){if(!(this instanceof o))return new o(e);r.call(this,e),this._transformState={afterTransform:a.bind(this),needTransform:!1,transforming:!1,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=!0,this._readableState.sync=!1,e&&("function"==typeof e.transform&&(this._transform=e.transform),"function"==typeof e.flush&&(this._flush=e.flush)),this.on("prefinish",s)}function s(){var e=this;"function"==typeof this._flush?this._flush((function(t,n){u(e,t,n)})):u(this,null,null)}function u(e,t,n){if(t)return e.emit("error",t);if(null!=n&&e.push(n),e._writableState.length)throw new Error("Calling transform done when ws.length != 0");if(e._transformState.transforming)throw new Error("Calling transform done when still transforming");return e.push(null)}i.inherits=n(40),i.inherits(o,r),o.prototype.push=function(e,t){return this._transformState.needTransform=!1,r.prototype.push.call(this,e,t)},o.prototype._transform=function(e,t,n){throw new Error("_transform() is not implemented")},o.prototype._write=function(e,t,n){var r=this._transformState;if(r.writecb=n,r.writechunk=e,r.writeencoding=t,!r.transforming){var i=this._readableState;(r.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},o.prototype._read=function(e){var t=this._transformState;null!==t.writechunk&&t.writecb&&!t.transforming?(t.transforming=!0,this._transform(t.writechunk,t.writeencoding,t.afterTransform)):t.needTransform=!0},o.prototype._destroy=function(e,t){var n=this;r.prototype._destroy.call(this,e,(function(e){t(e),n.emit("close")}))}},function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}n.r(t);var i={attributes:["Laurl","laurl"],prefixes:["clearkey","dashif"]},a=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n,a;return t=e,a=[{key:"findCencContentProtection",value:function(e){for(var t=null,n=0;n<e.length;++n){var r=e[n];"urn:mpeg:dash:mp4protection:2011"!==r.schemeIdUri.toLowerCase()||"cenc"!==r.value.toLowerCase()&&"cbcs"!==r.value.toLowerCase()||(t=r)}return t}},{key:"getPSSHData",value:function(e){var t=8,n=new DataView(e),r=n.getUint8(t);return t+=20,r>0&&(t+=4+16*n.getUint32(t)),t+=4,e.slice(t)}},{key:"getPSSHForKeySystem",value:function(t,n){var r=e.parsePSSHList(n);return t&&r.hasOwnProperty(t.uuid.toLowerCase())?r[t.uuid.toLowerCase()]:null}},{key:"parseInitDataFromContentProtection",value:function(e,t){return"pssh"in e?(e.pssh.__text=e.pssh.__text.replace(/\r?\n|\r/g,"").replace(/\s+/g,""),t.decodeArray(e.pssh.__text).buffer):null}},{key:"parsePSSHList",value:function(e){if(null==e)return[];for(var t=new DataView(e.buffer||e),n={},r=0;;){var i,a,o=void 0,s=r;if(r>=t.buffer.byteLength)break;if(i=r+t.getUint32(r),r+=4,1886614376===t.getUint32(r))if(r+=4,0===(a=t.getUint8(r))||1===a){r++,r+=3,o="";var u=void 0,l=void 0;for(u=0;u<4;u++)o+=1===(l=t.getUint8(r+u).toString(16)).length?"0"+l:l;for(r+=4,o+="-",u=0;u<2;u++)o+=1===(l=t.getUint8(r+u).toString(16)).length?"0"+l:l;for(r+=2,o+="-",u=0;u<2;u++)o+=1===(l=t.getUint8(r+u).toString(16)).length?"0"+l:l;for(r+=2,o+="-",u=0;u<2;u++)o+=1===(l=t.getUint8(r+u).toString(16)).length?"0"+l:l;for(r+=2,o+="-",u=0;u<6;u++)o+=1===(l=t.getUint8(r+u).toString(16)).length?"0"+l:l;r+=6,r+=4,n[o=o.toLowerCase()]=t.buffer.slice(s,i),r=i}else r=i;else r=i}return n}},{key:"getLicenseServerUrlFromMediaInfo",value:function(e,t){try{if(!e||0===e.length)return null;for(var n=0,r=null;n<e.length&&!r;){var a=e[n];if(a&&a.contentProtection&&a.contentProtection.length>0){var o=a.contentProtection.filter((function(e){return e.schemeIdUri&&e.schemeIdUri===t}));if(o&&o.length>0)for(var s=0;s<o.length&&!r;){for(var u=o[s],l=0;l<i.attributes.length&&!r;){for(var c=0,f=i.attributes[l];c<i.prefixes.length&&!r;){var d=i.prefixes[c];u[f]&&u[f].__prefix&&u[f].__prefix===d&&u[f].__text&&(r=u[f].__text),c+=1}l+=1}s+=1}}n+=1}return r}catch(e){return null}}}],(n=null)&&r(t.prototype,n),a&&r(t,a),e}();var o=function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.contentType=t,this.robustness=n};var s=function e(t,n,r,i,a){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.initDataTypes=["cenc"],t&&t.length&&(this.audioCapabilities=t),n&&n.length&&(this.videoCapabilities=n),this.distinctiveIdentifier=r,this.persistentState=i,this.sessionTypes=a};function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){return(l=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function c(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=d(e);if(t){var i=d(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){return!t||"object"!==u(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function d(e){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var h=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&l(e,t)}(n,e);var t=c(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).MEDIA_KEYERR_CODE=100,e.MEDIA_KEYERR_UNKNOWN_CODE=101,e.MEDIA_KEYERR_CLIENT_CODE=102,e.MEDIA_KEYERR_SERVICE_CODE=103,e.MEDIA_KEYERR_OUTPUT_CODE=104,e.MEDIA_KEYERR_HARDWARECHANGE_CODE=105,e.MEDIA_KEYERR_DOMAIN_CODE=106,e.MEDIA_KEY_MESSAGE_ERROR_CODE=107,e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE=108,e.SERVER_CERTIFICATE_UPDATED_ERROR_CODE=109,e.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE=110,e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE=111,e.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE=112,e.KEY_SESSION_CREATED_ERROR_CODE=113,e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE=114,e.MEDIA_KEYERR_UNKNOWN_MESSAGE="An unspecified error occurred. This value is used for errors that don't match any of the other codes.",e.MEDIA_KEYERR_CLIENT_MESSAGE="The Key System could not be installed or updated.",e.MEDIA_KEYERR_SERVICE_MESSAGE="The message passed into update indicated an error from the license service.",e.MEDIA_KEYERR_OUTPUT_MESSAGE="There is no available output device with the required characteristics for the content protection system.",e.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE="A hardware configuration change caused a content protection error.",e.MEDIA_KEYERR_DOMAIN_MESSAGE="An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.",e.MEDIA_KEY_MESSAGE_ERROR_MESSAGE="Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!",e.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE="DRM: Empty key message from CDM",e.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE="Error updating server certificate -- ",e.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE="DRM: KeyStatusChange error! -- License has expired",e.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE="DRM: No license server URL specified!",e.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE="DRM: KeySystem Access Denied! -- ",e.KEY_SESSION_CREATED_ERROR_MESSAGE="DRM: unable to create session! --",e.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE="DRM: licenser error! --",e}return n}(n(28).a)),p=n(10);var g=function e(t,n,r,i,a,o,s,u){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.url=t,this.method=n,this.responseType=r,this.headers=i,this.withCredentials=a,this.messageType=o,this.sessionId=s,this.data=u};var m=function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.url=t,this.headers=n,this.data=r},y=n(5),E=n(15),_=n(1),T=n(3);function v(e){return(v="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function S(e){var t,n,r,i,u,l,c,f,d,T,S,A=(e=e||{}).protectionKeyController,b=e.protectionModel,I=e.eventBus,R=e.events,N=e.debug,C=e.BASE64,w=e.constants,D=[],O=e.cmcdModel,M=e.settings,P=e.customParametersModel;function L(){if(!(I&&I.hasOwnProperty("on")&&A&&A.hasOwnProperty("getSupportedKeySystemsFromContentProtection")))throw new Error("Missing config parameter(s)")}function F(e,t){d?r.push(e):f?f&&function(e){var t=e.findIndex((function(e){return e.ks===f})),n=e[t];if(-1===t||!n.initData)return;x(n)}(e):function(e,t){d=!0;var i,a=[];e=e.sort((function(t,n){return(u&&u[t.ks.systemString]&&u[t.ks.systemString].priority>=0?u[t.ks.systemString].priority:e.length)-(u&&u[n.ks.systemString]&&u[n.ks.systemString].priority>=0?u[n.ks.systemString].priority:e.length)})),r.push(e);for(var o=0;o<e.length;o++){var s=Y(e[o]);a.push({ks:e[o].ks,configs:[s],protData:e[o].protData})}b.requestKeySystemAccess(a).then((function(e){var t=(i=e.data).mksa&&i.mksa.selectedSystemString?i.mksa.selectedSystemString:i.keySystem.systemString;return n.info("DRM: KeySystem Access Granted for system string ("+t+")!  Selecting key system..."),b.selectKeySystem(i)})).then((function(e){if(f=e,d=!1,b){I.trigger(R.KEY_SYSTEM_SELECTED,{data:i});var t,n=k(f);n&&n.serverCertificate&&n.serverCertificate.length>0&&b.setServerCertificate(C.decodeArray(n.serverCertificate).buffer);for(var a=0;a<r.length;a++)for(t=0;t<r[a].length;t++)if(f===r[a][t].ks){x(r[a][t]);break}}})).catch((function(e){f=null,d=!1,t||I.trigger(R.KEY_SYSTEM_SELECTED,{data:null,error:new p.a(h.KEY_SYSTEM_ACCESS_DENIED_ERROR_CODE,h.KEY_SYSTEM_ACCESS_DENIED_ERROR_MESSAGE+"Error selecting key system! -- "+e.error)})}))}(e,t)}function x(e){if(A.isClearKey(f)&&e.protData&&e.protData.hasOwnProperty("clearkeys")){var t={kids:Object.keys(e.protData.clearkeys)};e.initData=(new TextEncoder).encode(JSON.stringify(t))}e.sessionId?U(e):null!==e.initData&&B(e)}function U(e){L(),b.loadKeySession(e)}function B(e){var t=a.getPSSHForKeySystem(f,e?e.initData:null);if(t){if(function(e){if(!e)return!1;try{for(var t=b.getSessions(),n=0;n<t.length;n++)if(t[n].getKeyId()===e)return!0;return!1}catch(e){return!1}}(e.keyId))return;if(G(t))return;try{e.initData=t,b.createKeySession(e)}catch(e){I.trigger(R.KEY_SESSION_CREATED,{data:null,error:new p.a(h.KEY_SESSION_CREATED_ERROR_CODE,h.KEY_SESSION_CREATED_ERROR_MESSAGE+e.message)})}}else e&&e.initData?b.createKeySession(e):I.trigger(R.KEY_SESSION_CREATED,{data:null,error:new p.a(h.KEY_SESSION_CREATED_ERROR_CODE,h.KEY_SESSION_CREATED_ERROR_MESSAGE+"Selected key system is "+(f?f.systemString:null)+".  needkey/encrypted event contains no initData corresponding to that key system!")})}function k(e){if(e){var t=e.systemString;if(u)return t in u?u[t]:null}return null}function G(e){if(!e)return!1;try{for(var t=b.getAllInitData(),r=0;r<t.length;r++)if(A.initDataEquals(e,t[r]))return n.debug("DRM: Ignoring initData because we have already seen it!"),!0;return!1}catch(e){return!1}}function j(e){L(),e?(b.setMediaElement(e),I.on(R.NEED_KEY,Q,t)):null===e&&(b.setMediaElement(e),I.off(R.NEED_KEY,Q,t))}function Y(e){var t=e.protData,n=[],r=[],a=t&&t.audioRobustness&&t.audioRobustness.length>0?t.audioRobustness:c,u=t&&t.videoRobustness&&t.videoRobustness.length>0?t.videoRobustness:c,l=e.sessionType,f=t&&t.distinctiveIdentifier?t.distinctiveIdentifier:"optional",d=t&&t.persistentState?t.persistentState:"temporary"===l?"optional":"required";return i.forEach((function(e){e.type===w.AUDIO?n.push(new o(e.codec,a)):e.type===w.VIDEO&&r.push(new o(e.codec,u))})),new s(n,r,f,d,[l])}function H(e){e.error?I.trigger(R.KEY_STATUSES_CHANGED,{data:null,error:e.error}):n.debug("DRM: key status = "+e.status)}function V(e){n.debug("DRM: onKeyMessage");var t=e.data;I.trigger(R.KEY_MESSAGE,{data:t});var r=t.messageType?t.messageType:"license-request",o=t.message,s=t.sessionToken,u=k(f),l=A.getLicenseServerModelInstance(f,u,r),c={sessionToken:s,messageType:r};if(o&&0!==o.byteLength){if(!l)return n.debug("DRM: License server request not required for this message (type = "+e.data.messageType+").  Session ID = "+s.getSessionId()),void K(c);if(A.isClearKey(f)){var d=A.processClearKeyLicenseRequest(f,u,o);if(d)return n.debug("DRM: ClearKey license request handled by application!"),K(c),void b.updateKeySession(s,d)}!function(e,t,r){var o=e.sessionToken,s=e.messageType?e.messageType:"license-request",u={sessionToken:o,messageType:s},l=f?f.systemString:null,c=function(e,t,n,r,o){var s=null,u=r.message;if(e&&e.serverURL){var l=e.serverURL;"string"==typeof l&&""!==l?s=l:"object"===v(l)&&l.hasOwnProperty(t)&&(s=l[t])}else if(e&&e.laURL&&""!==e.laURL)s=e.laURL;else if(!(s=a.getLicenseServerUrlFromMediaInfo(i,f.schemeIdURI))&&!A.isClearKey(f)){var c=a.getPSSHData(n.initData);(s=f.getLicenseServerURLFromInitData(c))||(s=r.laURL)}return s=o.getServerURLFromMessage(s,u,t)}(r,s,o,e,t);if(!c)return void K(u,new p.a(h.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_CODE,h.MEDIA_KEY_MESSAGE_NO_LICENSE_SERVER_URL_ERROR_MESSAGE));var d={},N=!1;r&&W(d,r.httpRequestHeaders);var C=e.message,w=f.getRequestHeadersFromMessage(C);W(d,w),Object.keys(d).forEach((function(e){"authorization"===e.toLowerCase()&&(N=!0)})),r&&"boolean"==typeof r.withCredentials&&(N=r.withCredentials);var D=function(e){if(b)if(e.status>=200&&e.status<=299){var n=E.a.parseHttpHeaders(e.getAllResponseHeaders?e.getAllResponseHeaders():null),r=new m(e.responseURL,n,e.response);X(P.getLicenseResponseFilters(),r).then((function(){var n=t.getLicenseMessage(r.data,l,s);null!==n?(K(u),b.updateKeySession(o,n)):z(e,u,l,s,t)}))}else z(e,u,l,s,t)},L=function(e){K(u,new p.a(h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE,h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE+l+' update, XHR aborted. status is "'+e.statusText+'" ('+e.status+"), readyState is "+e.readyState))},F=function(e){K(u,new p.a(h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE,h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE+l+' update, XHR error. status is "'+e.statusText+'" ('+e.status+"), readyState is "+e.readyState))},x=f.getLicenseRequestFromMessage(C),U=t.getHTTPMethod(s),B=t.getResponseType(l,s),k=r&&!isNaN(r.httpTimeout)?r.httpTimeout:8e3,G=o.getSessionId()||null,j=new g(c,U,B,d,N,s,G,x),Y=isNaN(M.get().streaming.retryAttempts[y.a.LICENSE])?3:M.get().streaming.retryAttempts[y.a.LICENSE];X(P.getLicenseRequestFilters(),j).then((function(){!function e(t,r,i,a,o,s){var u=new XMLHttpRequest;if(M.get().streaming.cmcd&&M.get().streaming.cmcd.enabled){if(M.get().streaming.cmcd.mode===_.a.CMCD_MODE_QUERY){var l=O.getQueryParameter({url:t.url,type:y.a.LICENSE});l&&(t.url=E.a.addAditionalQueryParameterToUrl(t.url,[l]))}}u.open(t.method,t.url,!0),u.responseType=t.responseType,u.withCredentials=t.withCredentials,i>0&&(u.timeout=i);for(var c in t.headers)u.setRequestHeader(c,t.headers[c]);if(M.get().streaming.cmcd&&M.get().streaming.cmcd.enabled){if(M.get().streaming.cmcd.mode===_.a.CMCD_MODE_HEADER){var f=O.getHeaderParameters({url:t.url,type:y.a.LICENSE});if(f)for(var d in f){var h=f[d];h&&u.setRequestHeader(d,h)}}}var p=function(){r--;var n=isNaN(M.get().streaming.retryIntervals[y.a.LICENSE])?1e3:M.get().streaming.retryIntervals[y.a.LICENSE];S=setTimeout((function(){e(t,r,i,a,o,s)}),n)};u.onload=function(){T=null,this.status>=200&&this.status<=299||r<=0?a(this):(n.warn("License request failed ("+this.status+"). Retrying it... Pending retries: "+r),p())},u.ontimeout=u.onerror=function(){T=null,r<=0?s(this):(n.warn("License request network request failed . Retrying it... Pending retries: "+r),p())},u.onabort=function(){o(this)},I.trigger(R.LICENSE_REQUEST_SENDING,{url:t.url,headers:t.headers,payload:t.data,sessionId:t.sessionId}),T=u,u.send(t.data)}(j,Y,k,D,L,F)}))}(t,l,u)}else K(c,new p.a(h.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_CODE,h.MEDIA_KEY_MESSAGE_NO_CHALLENGE_ERROR_MESSAGE))}function K(e,t){I.trigger(R.LICENSE_REQUEST_COMPLETE,{data:e,error:t})}function q(){T&&(T.onloadend=T.onerror=T.onprogress=void 0,T.abort(),T=null),S&&(clearTimeout(S),S=null)}function W(e,t){if(t)for(var n in t)e[n]=t[n]}function z(e,t,n,r,i){var a=e.response?i.getErrorResponse(e.response,n,r):"NONE";K(t,new p.a(h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_CODE,h.MEDIA_KEY_MESSAGE_LICENSER_ERROR_MESSAGE+n+' update, XHR complete. status is "'+e.statusText+'" ('+e.status+"), readyState is "+e.readyState+".  Response is "+a))}function X(e,t){return e?e.reduce((function(e,n){return e.then((function(){return n(t)}))}),Promise.resolve()):Promise.resolve()}function Q(e,t){if(!M.get().streaming.protection.ignoreEmeEncryptedEvent){if(n.debug("DRM: onNeedKey"),"cenc"!==e.key.initDataType)return void n.warn("DRM:  Only 'cenc' initData is supported!  Ignoring initData of type: "+e.key.initDataType);if(0===i.length&&(n.warn("DRM: onNeedKey called before initializeForMedia, wait until initialized"),(t=void 0===t?1:t+1)<5))return void D.push(setTimeout((function(){Q(e,t)}),500));var r=e.key.initData;if(ArrayBuffer.isView(r)&&(r=r.buffer),f){var o=a.getPSSHForKeySystem(f,r);if(o&&G(o))return}n.debug("DRM: initData:",String.fromCharCode.apply(null,new Uint8Array(r)));var s=A.getSupportedKeySystemsFromSegmentPssh(r,u,l);if(0===s.length)return void n.debug("DRM: Received needkey event with initData, but we don't support any of the key systems!");F(s,!1)}}return t={initializeForMedia:function(e){if(!e)throw new Error("mediaInfo can not be null or undefined");L(),i.push(e);var t=A.getSupportedKeySystemsFromContentProtection(e.contentProtection,u,l);t&&t.length>0&&F(t,!0)},clearMediaInfoArray:function(){i=[]},createKeySession:B,loadKeySession:U,removeKeySession:function(e){L(),b.removeKeySession(e)},closeKeySession:function(e){L(),b.closeKeySession(e)},setServerCertificate:function(e){L(),b.setServerCertificate(e)},setMediaElement:j,setSessionType:function(e){l=e},setRobustnessLevel:function(e){c=e},setProtectionData:function(e){u=e,A.setProtectionData(e)},getSupportedKeySystemsFromContentProtection:function(e){return L(),A.getSupportedKeySystemsFromContentProtection(e,u,l)},getKeySystems:function(){return A?A.getKeySystems():[]},setKeySystems:function(e){A&&A.setKeySystems(e)},stop:function(){q(),b&&b.stop()},reset:function(){I.off(R.INTERNAL_KEY_MESSAGE,V,t),I.off(R.INTERNAL_KEY_STATUS_CHANGED,H,t),L(),q(),j(null),f=null,d=!1,b&&(b.reset(),b=null),D.forEach((function(e){return clearTimeout(e)})),D=[],i=[],r=[]}},n=N.getLogger(t),r=[],i=[],l="temporary",c="",T=null,S=null,I.on(R.INTERNAL_KEY_MESSAGE,V,t),I.on(R.INTERNAL_KEY_STATUS_CHANGED,H,t),t}S.__dashjs_factory_name="ProtectionController";var A=T.a.getClassFactory(S);var b=function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.keyID=t,this.key=n};function I(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var R=function(){function e(t,n){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),n&&"persistent"!==n&&"temporary"!==n)throw new Error("Invalid ClearKey key set type!  Must be one of 'persistent' or 'temporary'");this.keyPairs=t,this.type=n}var t,n,r;return t=e,(n=[{key:"toJWK",value:function(){var e,t=this.keyPairs.length,n={keys:[]};for(e=0;e<t;e++){var r={kty:"oct",alg:"A128KW",kid:this.keyPairs[e].keyID,k:this.keyPairs[e].key};n.keys.push(r)}this.type&&(n.type=this.type);var i=JSON.stringify(n),a=i.length,o=new ArrayBuffer(a),s=new Uint8Array(o);for(e=0;e<a;e++)s[e]=i.charCodeAt(e);return o}}])&&I(t.prototype,n),r&&I(t,r),e}();function N(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var C=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.init()}var t,n,r;return t=e,(n=[{key:"init",value:function(){this.CLEARKEY_KEYSTEM_STRING="org.w3.clearkey",this.WIDEVINE_KEYSTEM_STRING="com.widevine.alpha",this.PLAYREADY_KEYSTEM_STRING="com.microsoft.playready",this.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING="com.microsoft.playready.recommendation",this.INITIALIZATION_DATA_TYPE_CENC="cenc",this.INITIALIZATION_DATA_TYPE_KEYIDS="keyids",this.INITIALIZATION_DATA_TYPE_WEBM="webm"}}])&&N(t.prototype,n),r&&N(t,r),e}()),w="e2719d58-a985-b3c9-781a-b030af78d30e",D=C.CLEARKEY_KEYSTEM_STRING;function O(e){var t=(e=e||{}).BASE64;return{uuid:w,schemeIdURI:"urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e",systemString:D,getInitData:function(e,n){try{var r=a.parseInitDataFromContentProtection(e,t);if(!r&&n){var i={kids:[function(e){try{var t=e.replace(/-/g,"");return(t=btoa(t.match(/\w{2}/g).map((function(e){return String.fromCharCode(parseInt(e,16))})).join(""))).replace(/=/g,"")}catch(e){return null}}(n["cenc:default_KID"])]};r=(new TextEncoder).encode(JSON.stringify(i))}return r}catch(e){return null}},getRequestHeadersFromMessage:function(){return{"Content-Type":"application/json"}},getLicenseRequestFromMessage:function(e){return JSON.stringify(JSON.parse(String.fromCharCode.apply(null,new Uint8Array(e))))},getLicenseServerURLFromInitData:function(){return null},getCDMData:function(){return null},getClearKeysFromProtectionData:function(e,t){var n=null;if(e){for(var r=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(t))),i=[],a=0;a<r.kids.length;a++){var o=r.kids[a],s=e.clearkeys&&e.clearkeys.hasOwnProperty(o)?e.clearkeys[o]:null;if(!s)throw new Error("DRM: ClearKey keyID ("+o+") is not known!");i.push(new b(o,s))}n=new R(i)}return n}}}O.__dashjs_factory_name="KeySystemClearKey";var M=dashjs.FactoryMaker.getSingletonFactory(O),P=C.CLEARKEY_KEYSTEM_STRING;function L(e){var t,n=e.BASE64,r=e.debug.getLogger(t);return t={uuid:"1077efec-c0b2-4d02-ace3-3c1e52e2fb4b",schemeIdURI:"urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b",systemString:P,getInitData:function(e){return a.parseInitDataFromContentProtection(e,n)},getRequestHeadersFromMessage:function(){return null},getLicenseRequestFromMessage:function(e){return new Uint8Array(e)},getLicenseServerURLFromInitData:function(){return null},getCDMData:function(){return null},getClearKeysFromProtectionData:function(e,t){var n=null;if(e){for(var i=JSON.parse(String.fromCharCode.apply(null,new Uint8Array(t))),a=[],o=0;o<i.kids.length;o++){var s=i.kids[o],u=e.clearkeys&&e.clearkeys.hasOwnProperty(s)?e.clearkeys[s]:null;if(!u)throw new Error("DRM: ClearKey keyID ("+s+") is not known!");a.push(new b(s,u))}n=new R(a),r.warn("ClearKey schemeIdURI is using W3C Common PSSH systemID (1077efec-c0b2-4d02-ace3-3c1e52e2fb4b) in Content Protection. See DASH-IF IOP v4.1 section 7.6.2.4")}return n}}}L.__dashjs_factory_name="KeySystemW3CClearKey";var F=dashjs.FactoryMaker.getSingletonFactory(L),x=C.WIDEVINE_KEYSTEM_STRING;function U(e){var t=(e=e||{}).BASE64;return{uuid:"edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",schemeIdURI:"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",systemString:x,getInitData:function(e){return a.parseInitDataFromContentProtection(e,t)},getRequestHeadersFromMessage:function(){return null},getLicenseRequestFromMessage:function(e){return new Uint8Array(e)},getLicenseServerURLFromInitData:function(){return null},getCDMData:function(){return null}}}U.__dashjs_factory_name="KeySystemWidevine";var B=dashjs.FactoryMaker.getSingletonFactory(U),k=C.PLAYREADY_KEYSTEM_STRING;function G(e){var t="utf-16",n=(e=e||{}).BASE64,r=e.settings;function i(){if(!n||!n.hasOwnProperty("decodeArray")||!n.hasOwnProperty("decodeArray"))throw new Error("Missing config parameter(s)")}return{uuid:"9a04f079-9840-4286-ab92-e65be0885f95",schemeIdURI:"urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95",systemString:k,getInitData:function(e){var t,r,o,s,u,l=new Uint8Array([112,115,115,104,0,0,0,0]),c=new Uint8Array([154,4,240,121,152,64,66,134,171,146,230,91,224,136,95,149]),f=0,d=null;if(i(),!e)return null;if("pssh"in e)return a.parseInitDataFromContentProtection(e,n);if("pro"in e)d=n.decodeArray(e.pro.__text);else{if(!("prheader"in e))return null;d=n.decodeArray(e.prheader.__text)}return t=d.length,r=4+l.length+c.length+4+t,o=new ArrayBuffer(r),s=new Uint8Array(o),(u=new DataView(o)).setUint32(f,r),f+=4,s.set(l,f),f+=l.length,s.set(c,f),f+=c.length,u.setUint32(f,t),f+=4,s.set(d,f),f+=t,s.buffer},getRequestHeadersFromMessage:function(e){var n,i,a={},o=new DOMParser;if(r&&r.get().streaming.protection.detectPlayreadyMessageFormat&&"utf-16"===t&&e&&e.byteLength%2==1)return a["Content-Type"]="text/xml; charset=utf-8",a;var s="utf-16"===t?new Uint16Array(e):new Uint8Array(e);n=String.fromCharCode.apply(null,s);for(var u=(i=o.parseFromString(n,"application/xml")).getElementsByTagName("name"),l=i.getElementsByTagName("value"),c=0;c<u.length;c++)a[u[c].childNodes[0].nodeValue]=l[c].childNodes[0].nodeValue;return a.hasOwnProperty("Content")&&(a["Content-Type"]=a.Content,delete a.Content),a.hasOwnProperty("Content-Type")||(a["Content-Type"]="text/xml; charset=utf-8"),a},getLicenseRequestFromMessage:function(e){var a=null,o=new DOMParser;if(r&&r.get().streaming.protection.detectPlayreadyMessageFormat&&"utf-16"===t&&e&&e.byteLength%2==1)return e;var s="utf-16"===t?new Uint16Array(e):new Uint8Array(e);i();var u=String.fromCharCode.apply(null,s),l=o.parseFromString(u,"application/xml");if(!l.getElementsByTagName("PlayReadyKeyMessage")[0])return e;var c=l.getElementsByTagName("Challenge")[0].childNodes[0].nodeValue;return c&&(a=n.decode(c)),a},getLicenseServerURLFromInitData:function(e){if(e)for(var t=new DataView(e),n=t.getUint16(4,!0),r=6,i=new DOMParser,a=0;a<n;a++){var o=t.getUint16(r,!0);r+=2;var s=t.getUint16(r,!0);if(r+=2,1===o){var u=e.slice(r,r+s),l=String.fromCharCode.apply(null,new Uint16Array(u)),c=i.parseFromString(l,"application/xml");if(c.getElementsByTagName("LA_URL")[0]){var f=c.getElementsByTagName("LA_URL")[0].childNodes[0].nodeValue;if(f)return f}if(c.getElementsByTagName("LUI_URL")[0]){var d=c.getElementsByTagName("LUI_URL")[0].childNodes[0].nodeValue;if(d)return d}}else r+=s}return null},getCDMData:function(e){var t,r,a,o;if(i(),!e)return null;for(t=[],o=0;o<e.length;++o)t.push(e.charCodeAt(o)),t.push(0);for(t=String.fromCharCode.apply(null,t),t=n.encode(t),r='<PlayReadyCDMData type="LicenseAcquisition"><LicenseAcquisition version="1.0" Proactive="false"><CustomData encoding="base64encoded">%CUSTOMDATA%</CustomData></LicenseAcquisition></PlayReadyCDMData>'.replace("%CUSTOMDATA%",t),a=[],o=0;o<r.length;++o)a.push(r.charCodeAt(o)),a.push(0);return new Uint8Array(a).buffer},setPlayReadyMessageFormat:function(e){if("utf-8"!==e&&"utf-16"!==e)throw new Error('Specified message format is not one of "utf-8" or "utf-16"');t=e}}}G.__dashjs_factory_name="KeySystemPlayReady";var j=dashjs.FactoryMaker.getSingletonFactory(G);function Y(e){var t=(e=e||{}).BASE64,n={};return n[C.WIDEVINE_KEYSTEM_STRING]={responseType:"json",getLicenseMessage:function(e){return t.decodeArray(e.license)},getErrorResponse:function(e){return e}},n[C.PLAYREADY_KEYSTEM_STRING]={responseType:"arraybuffer",getLicenseMessage:function(e){return e},getErrorResponse:function(e){return String.fromCharCode.apply(null,new Uint8Array(e))}},{getServerURLFromMessage:function(e){return e},getHTTPMethod:function(){return"POST"},getResponseType:function(e){return n[e].responseType},getLicenseMessage:function(e,r){return function(){if(!t||!t.hasOwnProperty("decodeArray"))throw new Error("Missing config parameter(s)")}(),n[r].getLicenseMessage(e)},getErrorResponse:function(e,t){return n[t].getErrorResponse(e)}}}Y.__dashjs_factory_name="DRMToday";var H=dashjs.FactoryMaker.getSingletonFactory(Y);function V(){var e="http://schemas.xmlsoap.org/soap/envelope/";function t(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return decodeURIComponent(escape(t))}function n(n){if(window.DOMParser){var r=t(n),i=(new window.DOMParser).parseFromString(r,"text/xml"),a=i?i.getElementsByTagNameNS(e,"Envelope")[0]:null,o=a?a.getElementsByTagNameNS(e,"Body")[0]:null;if(o?o.getElementsByTagNameNS(e,"Fault")[0]:null)return null}return n}function r(n){var r="",i="",a="",o=-1,s=-1;if(window.DOMParser){var u=t(n),l=(new window.DOMParser).parseFromString(u,"text/xml"),c=l?l.getElementsByTagNameNS(e,"Envelope")[0]:null,f=c?c.getElementsByTagNameNS(e,"Body")[0]:null,d=f?f.getElementsByTagNameNS(e,"Fault")[0]:null,h=d?d.getElementsByTagName("detail")[0]:null,p=h?h.getElementsByTagName("Exception")[0]:null,g=null;if(null===d)return u;r=(g=d.getElementsByTagName("faultstring")[0].firstChild)?g.nodeValue:null,null!==p&&(i=(g=p.getElementsByTagName("StatusCode")[0])?g.firstChild.nodeValue:null,o=(a=(g=p.getElementsByTagName("Message")[0])?g.firstChild.nodeValue:null)?a.lastIndexOf("[")+1:-1,s=a?a.indexOf("]"):-1,a=a?a.substring(o,s):"")}var m="code: ".concat(i,", name: ").concat(r);return a&&(m+=", message: ".concat(a)),m}return{getServerURLFromMessage:function(e){return e},getHTTPMethod:function(){return"POST"},getResponseType:function(){return"arraybuffer"},getLicenseMessage:function(e){return n.call(this,e)},getErrorResponse:function(e){return r.call(this,e)}}}V.__dashjs_factory_name="PlayReady";var K=dashjs.FactoryMaker.getSingletonFactory(V);function q(){return{getServerURLFromMessage:function(e){return e},getHTTPMethod:function(){return"POST"},getResponseType:function(){return"arraybuffer"},getLicenseMessage:function(e){return e},getErrorResponse:function(e){return String.fromCharCode.apply(null,new Uint8Array(e))}}}q.__dashjs_factory_name="Widevine";var W=dashjs.FactoryMaker.getSingletonFactory(q);function z(){return{getServerURLFromMessage:function(e){return e},getHTTPMethod:function(){return"POST"},getResponseType:function(){return"json"},getLicenseMessage:function(e){if(!e.hasOwnProperty("keys"))return null;for(var t=[],n=0;n<e.keys.length;n++){var r=e.keys[n],i=r.kid.replace(/=/g,""),a=r.k.replace(/=/g,"");t.push(new b(i,a))}return new R(t)},getErrorResponse:function(e){return String.fromCharCode.apply(null,new Uint8Array(e))}}}z.__dashjs_factory_name="ClearKey";var X=dashjs.FactoryMaker.getSingletonFactory(z);function Q(){var e,t,n,r,i,o,s,u,l=this.context;function c(e,t){return t&&e in t?t[e]:null}function f(e,t){return e&&e.sessionId?e.sessionId:t&&t.sessionId?t.sessionId:null}function d(e,t){return e&&e.sessionType?e.sessionType:t}return e={initialize:function(){var e;r=[],e=j(l).getInstance({BASE64:i,settings:o}),r.push(e),e=B(l).getInstance({BASE64:i}),r.push(e),e=M(l).getInstance({BASE64:i}),r.push(e),s=e,e=F(l).getInstance({BASE64:i,debug:t}),r.push(e),u=e},setProtectionData:function(e){for(var t,n,i=0;i<r.length;i++){var a=r[i];a.hasOwnProperty("init")&&a.init((t=a.systemString,n=void 0,n=null,e&&(n=t in e?e[t]:null),n))}},isClearKey:function(e){return e===s||e===u},initDataEquals:function(e,t){if(e.byteLength===t.byteLength){for(var n=new Uint8Array(e),r=new Uint8Array(t),i=0;i<n.length;i++)if(n[i]!==r[i])return!1;return!0}return!1},getKeySystems:function(){return r},setKeySystems:function(e){r=e},getKeySystemBySystemString:function(e){for(var t=0;t<r.length;t++)if(r[t].systemString===e)return r[t];return null},getSupportedKeySystemsFromContentProtection:function(e,t,n){var i,o,s,u,l=[];if(e){var h=a.findCencContentProtection(e);for(s=0;s<r.length;++s){var p=c((o=r[s]).systemString,t);for(u=0;u<e.length;++u)if((i=e[u]).schemeIdUri.toLowerCase()===o.schemeIdURI){var g=o.getInitData(i,h);l.push({ks:r[s],keyId:i.keyId,initData:g,protData:p,cdmData:o.getCDMData(p?p.cdmData:null),sessionId:f(p,i),sessionType:d(p,n)})}}}return l},getSupportedKeySystemsFromSegmentPssh:function(e,t,n){for(var i,o=[],s=a.parsePSSHList(e),u=0;u<r.length;++u){var l=c((i=r[u]).systemString,t);i.uuid in s&&o.push({ks:i,initData:s[i.uuid],protData:l,cdmData:i.getCDMData(l?l.cdmData:null),sessionId:f(l),sessionType:d(l,n)})}return o},getLicenseServerModelInstance:function(e,t,n){if("license-release"===n||"individualization-request"===n)return null;var r=null;return t&&t.hasOwnProperty("drmtoday")?r=H(l).getInstance({BASE64:i}):e.systemString===C.WIDEVINE_KEYSTEM_STRING?r=W(l).getInstance():e.systemString===C.PLAYREADY_KEYSTEM_STRING?r=K(l).getInstance():e.systemString===C.CLEARKEY_KEYSTEM_STRING&&(r=X(l).getInstance()),r},processClearKeyLicenseRequest:function(e,t,r){try{return e.getClearKeysFromProtectionData(t,r)}catch(e){return n.error("Failed to retrieve clearkeys from ProtectionData"),null}},setConfig:function(r){r&&(r.debug&&(t=r.debug,n=t.getLogger(e)),r.BASE64&&(i=r.BASE64),r.settings&&(o=r.settings))}}}Q.__dashjs_factory_name="ProtectionKeyController";var $=dashjs.FactoryMaker.getSingletonFactory(Q);function Z(e){return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function J(e,t){return(J=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ee(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,r=ne(e);if(t){var i=ne(this).constructor;n=Reflect.construct(r,arguments,i)}else n=r.apply(this,arguments);return te(this,n)}}function te(e,t){return!t||"object"!==Z(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}function ne(e){return(ne=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var re=new(function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&J(e,t)}(n,e);var t=ee(n);function n(){var e;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,n),(e=t.call(this)).INTERNAL_KEY_MESSAGE="internalKeyMessage",e.INTERNAL_KEY_STATUS_CHANGED="internalkeyStatusChanged",e.KEY_ADDED="public_keyAdded",e.KEY_ERROR="public_keyError",e.KEY_MESSAGE="public_keyMessage",e.KEY_SESSION_CLOSED="public_keySessionClosed",e.KEY_SESSION_CREATED="public_keySessionCreated",e.KEY_SESSION_REMOVED="public_keySessionRemoved",e.KEY_STATUSES_CHANGED="public_keyStatusesChanged",e.KEY_SYSTEM_ACCESS_COMPLETE="public_keySystemAccessComplete",e.KEY_SYSTEM_SELECTED="public_keySystemSelected",e.LICENSE_REQUEST_COMPLETE="public_licenseRequestComplete",e.LICENSE_REQUEST_SENDING="public_licenseRequestSending",e.NEED_KEY="needkey",e.PROTECTION_CREATED="public_protectioncreated",e.PROTECTION_DESTROYED="public_protectiondestroyed",e.SERVER_CERTIFICATE_UPDATED="serverCertificateUpdated",e.TEARDOWN_COMPLETE="protectionTeardownComplete",e.VIDEO_ELEMENT_SELECTED="videoElementSelected",e.KEY_SESSION_UPDATED="public_keySessionUpdated",e}return n}(n(18).a));var ie=function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.initData=t,this.initDataType=n};var ae=function e(t,n,r,i){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.sessionToken=t,this.message=n,this.defaultURL=r,this.messageType=i||"license-request"};var oe=function e(t,n){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.keySystem=t,this.ksConfiguration=n},se={};function ue(e){e=e||{};var t,n,r,i,a,o,s,u,l=this.context,c=e.eventBus,f=e.events,d=e.debug;function g(e){var t=e.session;return t.removeEventListener("keystatuseschange",e),t.removeEventListener("message",e),t.close()}function m(e){for(var t=0;t<o.length;t++)if(o[t]===e){o.splice(t,1);break}}function y(e){var t,n;return e&&e.length>0&&(e[0]&&("string"==typeof e[0]?t=e[0]:n=e[0]),e[1]&&("string"==typeof e[1]?t=e[1]:n=e[1])),{status:t,keyId:n}}function E(e,t){var r={session:e,keyId:t.keyId,initData:t.initData,sessionId:t.sessionId,sessionType:t.sessionType,handleEvent:function(e){switch(e.type){case"keystatuseschange":c.trigger(f.KEY_STATUSES_CHANGED,{data:this}),e.target.keyStatuses.forEach((function(){var e=y(arguments);switch(e.status){case"expired":c.trigger(f.INTERNAL_KEY_STATUS_CHANGED,{error:new p.a(h.KEY_STATUS_CHANGED_EXPIRED_ERROR_CODE,h.KEY_STATUS_CHANGED_EXPIRED_ERROR_MESSAGE)});break;default:c.trigger(f.INTERNAL_KEY_STATUS_CHANGED,e)}}));break;case"message":var t=ArrayBuffer.isView(e.message)?e.message.buffer:e.message;c.trigger(f.INTERNAL_KEY_MESSAGE,{data:new ae(this,t,void 0,e.messageType)})}},getKeyId:function(){return this.keyId},getSessionId:function(){return e.sessionId},getSessionType:function(){return this.sessionType},getExpirationTime:function(){return e.expiration},getKeyStatuses:function(){return e.keyStatuses},getUsable:function(){var t=!1;return e.keyStatuses.forEach((function(){var e=y(arguments);"usable"===e.status&&(t=!0)})),t}};return e.addEventListener("keystatuseschange",r),e.addEventListener("message",r),e.closed.then((function(){m(r),n.debug("DRM: Session closed.  SessionID = "+r.getSessionId()),c.trigger(f.KEY_SESSION_CLOSED,{data:r.getSessionId()})})),o.push(r),r}return t={getAllInitData:function(){for(var e=[],t=0;t<o.length;t++)o[t].initData&&e.push(o[t].initData);return e},getSessions:function(){return o},requestKeySystemAccess:function(e){return new Promise((function(t,r){!function e(t,r,i,a){if(void 0===navigator.requestMediaKeySystemAccess||"function"!=typeof navigator.requestMediaKeySystemAccess){var o="Insecure origins are not allowed";return c.trigger(f.KEY_SYSTEM_ACCESS_COMPLETE,{error:o}),void a({error:o})}var s=t[r].protData&&t[r].protData.systemStringPriority?t[r].protData.systemStringPriority:null,u=t[r].configs,l=t[r].ks,d=l.systemString;(function(e,t){return new Promise((function(r,i){!function e(t,r,i,a,o){var s=t[i];n.debug("Requesting key system access for system string ".concat(s)),navigator.requestMediaKeySystemAccess(s,r).then((function(e){e.selectedSystemString=s,a(e)})).catch((function(n){i+1<t.length?e(t,r,i+1,a,o):o(n)}))}(e,t,0,r,i)}))})(s||(se[d]?se[d]:[d]),u).then((function(e){var t="function"==typeof e.getConfiguration?e.getConfiguration():null,n=new oe(l,t);n.mksa=e,c.trigger(f.KEY_SYSTEM_ACCESS_COMPLETE,{data:n}),i({data:n})})).catch((function(n){if(r+1<t.length)e(t,r+1,i,a);else{c.trigger(f.KEY_SYSTEM_ACCESS_COMPLETE,{error:"Key system access denied! "+n.message}),a({error:"Key system access denied! "+n.message})}}))}(e,0,t,r)}))},selectKeySystem:function(e){return new Promise((function(t,n){e.mksa.createMediaKeys().then((function(t){return r=e.keySystem,a=t,i?i.setMediaKeys(a):Promise.resolve()})).then((function(){t(r)})).catch((function(){n({error:"Error selecting keys system ("+e.keySystem.systemString+")! Could not create MediaKeys -- TODO"})}))}))},setMediaElement:function(e){i!==e&&(i&&(i.removeEventListener("encrypted",s),i.setMediaKeys&&i.setMediaKeys(null)),(i=e)&&(i.addEventListener("encrypted",s),i.setMediaKeys&&a&&i.setMediaKeys(a)))},setServerCertificate:function(e){if(!r||!a)throw new Error("Can not set server certificate until you have selected a key system");a.setServerCertificate(e).then((function(){n.info("DRM: License server certificate successfully updated."),c.trigger(f.SERVER_CERTIFICATE_UPDATED)})).catch((function(e){c.trigger(f.SERVER_CERTIFICATE_UPDATED,{error:new p.a(h.SERVER_CERTIFICATE_UPDATED_ERROR_CODE,h.SERVER_CERTIFICATE_UPDATED_ERROR_MESSAGE+e.name)})}))},createKeySession:function(e){if(!r||!a)throw new Error("Can not create sessions until you have selected a key system");var t=a.createSession(e.sessionType),i=E(t,e),o=r.systemString===C.CLEARKEY_KEYSTEM_STRING&&(e.initData||e.protData&&e.protData.clearkeys)?C.INITIALIZATION_DATA_TYPE_KEYIDS:C.INITIALIZATION_DATA_TYPE_CENC;t.generateRequest(o,e.initData).then((function(){n.debug("DRM: Session created.  SessionID = "+i.getSessionId()),c.trigger(f.KEY_SESSION_CREATED,{data:i})})).catch((function(e){m(i),c.trigger(f.KEY_SESSION_CREATED,{data:null,error:new p.a(h.KEY_SESSION_CREATED_ERROR_CODE,h.KEY_SESSION_CREATED_ERROR_MESSAGE+"Error generating key request -- "+e.name)})}))},updateKeySession:function(e,t){var n=e.session;u.isClearKey(r)&&(t=t.toJWK()),n.update(t).then((function(){c.trigger(f.KEY_SESSION_UPDATED)})).catch((function(t){c.trigger(f.KEY_ERROR,{error:new p.a(h.MEDIA_KEYERR_CODE,"Error sending update() message! "+t.name,e)})}))},loadKeySession:function(e){if(!r||!a)throw new Error("Can not load sessions until you have selected a key system");for(var t=e.sessionId,i=0;i<o.length;i++)if(t===o[i].sessionId)return void n.warn("DRM: Ignoring session ID because we have already seen it!");var s=a.createSession(e.sessionType),u=E(s,e);s.load(t).then((function(e){e?(n.debug("DRM: Session loaded.  SessionID = "+u.getSessionId()),c.trigger(f.KEY_SESSION_CREATED,{data:u})):(m(u),c.trigger(f.KEY_SESSION_CREATED,{data:null,error:new p.a(h.KEY_SESSION_CREATED_ERROR_CODE,h.KEY_SESSION_CREATED_ERROR_MESSAGE+"Could not load session! Invalid Session ID ("+t+")")}))})).catch((function(e){m(u),c.trigger(f.KEY_SESSION_CREATED,{data:null,error:new p.a(h.KEY_SESSION_CREATED_ERROR_CODE,h.KEY_SESSION_CREATED_ERROR_MESSAGE+"Could not load session ("+t+")! "+e.name)})}))},removeKeySession:function(e){e.session.remove().then((function(){n.debug("DRM: Session removed.  SessionID = "+e.getSessionId()),c.trigger(f.KEY_SESSION_REMOVED,{data:e.getSessionId()})}),(function(t){c.trigger(f.KEY_SESSION_REMOVED,{data:null,error:"Error removing session ("+e.getSessionId()+"). "+t.name})}))},closeKeySession:function(e){g(e).catch((function(t){m(e),c.trigger(f.KEY_SESSION_CLOSED,{data:null,error:"Error closing session ("+e.getSessionId()+") "+t.name})}))},stop:function(){for(var e,t=0;t<o.length;t++)(e=o[t]).getUsable()||g(e).catch((function(){m(e)}))},reset:function(){var e,t=o.length;0!==t?function(){for(var n=function(e){m(e),0===o.length&&(i?(i.removeEventListener("encrypted",s),i.setMediaKeys(null).then((function(){c.trigger(f.TEARDOWN_COMPLETE)}))):c.trigger(f.TEARDOWN_COMPLETE))},r=0;r<t;r++)!function(t){e.session.closed.then((function(){n(t)})),g(e).catch((function(){n(t)}))}(e=o[r])}():c.trigger(f.TEARDOWN_COMPLETE)}},n=d.getLogger(t),r=null,i=null,a=null,o=[],u=$(l).getInstance(),s={handleEvent:function(e){switch(e.type){case"encrypted":if(e.initData){var t=ArrayBuffer.isView(e.initData)?e.initData.buffer:e.initData;c.trigger(f.NEED_KEY,{key:new ie(t,e.initDataType)})}}}},t}se[C.PLAYREADY_KEYSTEM_STRING]=[C.PLAYREADY_KEYSTEM_STRING,C.PLAYREADY_RECOMMENDATION_KEYSTEM_STRING],se[C.WIDEVINE_KEYSTEM_STRING]=[C.WIDEVINE_KEYSTEM_STRING],se[C.CLEARKEY_KEYSTEM_STRING]=[C.CLEARKEY_KEYSTEM_STRING],ue.__dashjs_factory_name="ProtectionModel_21Jan2015";var le=dashjs.FactoryMaker.getClassFactory(ue);function ce(e){e=e||{};var t,n,r,i,a,o,u,l,c,f=this.context,d=e.eventBus,g=e.events,m=e.debug,y=e.api;function E(){try{for(var e=0;e<u.length;e++)_(u[e]);r&&r.removeEventListener(y.needkey,l),d.trigger(g.TEARDOWN_COMPLETE)}catch(e){d.trigger(g.TEARDOWN_COMPLETE,{error:"Error tearing down key sessions and MediaKeys! -- "+e.message})}}function _(e){var t=e.session;t.removeEventListener(y.error,e),t.removeEventListener(y.message,e),t.removeEventListener(y.ready,e),t.removeEventListener(y.close,e);for(var n=0;n<u.length;n++)if(u[n]===e){u.splice(n,1);break}t[y.release]()}function T(){var e=null,t=function(){r.removeEventListener("loadedmetadata",e),r[y.setMediaKeys](a),d.trigger(g.VIDEO_ELEMENT_SELECTED)};r.readyState>=1?t():(e=t.bind(this),r.addEventListener("loadedmetadata",e))}return t={getAllInitData:function(){for(var e=[],t=0;t<u.length;t++)e.push(u[t].initData);return e},getSessions:function(){return u},requestKeySystemAccess:function(e){return new Promise((function(t,n){for(var r=!1,i=0;i<e.length;i++)for(var a=e[i].ks.systemString,o=e[i].configs,u=null,l=null,f=0;f<o.length;f++){var h=o[f].audioCapabilities,p=o[f].videoCapabilities;if(h&&0!==h.length){u=[];for(var m=0;m<h.length;m++)window[y.MediaKeys].isTypeSupported(a,h[m].contentType)&&u.push(h[m])}if(p&&0!==p.length){l=[];for(var E=0;E<p.length;E++)window[y.MediaKeys].isTypeSupported(a,p[E].contentType)&&l.push(p[E])}if(!(!u&&!l||u&&0===u.length||l&&0===l.length)){r=!0;var _=new s(u,l),T=c.getKeySystemBySystemString(a),v=new oe(T,_);d.trigger(g.KEY_SYSTEM_ACCESS_COMPLETE,{data:v}),t({data:v});break}}if(!r){var S="Key system access denied! -- No valid audio/video content configurations detected!";d.trigger(g.KEY_SYSTEM_ACCESS_COMPLETE,{error:S}),n({error:S})}}))},selectKeySystem:function(e){return new Promise((function(t,n){try{a=e.mediaKeys=new window[y.MediaKeys](e.keySystem.systemString),i=e.keySystem,o=e,r&&T(),t(i)}catch(e){n({error:"Error selecting keys system ("+i.systemString+")! Could not create MediaKeys -- TODO"})}}))},setMediaElement:function(e){r!==e&&(r&&r.removeEventListener(y.needkey,l),(r=e)&&(r.addEventListener(y.needkey,l),a&&T()))},createKeySession:function(e){if(!i||!a||!o)throw new Error("Can not create sessions until you have selected a key system");var t=null;if(o.ksConfiguration.videoCapabilities&&o.ksConfiguration.videoCapabilities.length>0&&(t=o.ksConfiguration.videoCapabilities[0]),null===t&&o.ksConfiguration.audioCapabilities&&o.ksConfiguration.audioCapabilities.length>0&&(t=o.ksConfiguration.audioCapabilities[0]),null===t)throw new Error("Can not create sessions for unknown content types.");var r=t.contentType,s=a.createSession(r,new Uint8Array(e.initData),e.cdmData?new Uint8Array(e.cdmData):null),l=function(e,t){return{session:e,keyId:t.keyId,initData:t.initData,getKeyId:function(){return this.keyId},getSessionId:function(){return this.session.sessionId},getExpirationTime:function(){return NaN},getSessionType:function(){return"temporary"},handleEvent:function(e){switch(e.type){case y.error:d.trigger(g.KEY_ERROR,{error:new p.a(h.MEDIA_KEYERR_CODE,"KeyError",this)});break;case y.message:var t=ArrayBuffer.isView(e.message)?e.message.buffer:e.message;d.trigger(g.INTERNAL_KEY_MESSAGE,{data:new ae(this,t,e.destinationURL)});break;case y.ready:n.debug("DRM: Key added."),d.trigger(g.KEY_ADDED);break;case y.close:n.debug("DRM: Session closed.  SessionID = "+this.getSessionId()),d.trigger(g.KEY_SESSION_CLOSED,{data:this.getSessionId()})}}}}(s,e);s.addEventListener(y.error,l),s.addEventListener(y.message,l),s.addEventListener(y.ready,l),s.addEventListener(y.close,l),u.push(l),n.debug("DRM: Session created.  SessionID = "+l.getSessionId()),d.trigger(g.KEY_SESSION_CREATED,{data:l})},updateKeySession:function(e,t){var n=e.session;c.isClearKey(i)?n.update(new Uint8Array(t.toJWK())):n.update(new Uint8Array(t)),d.trigger(g.KEY_SESSION_UPDATED)},closeKeySession:_,setServerCertificate:function(){},loadKeySession:function(){},removeKeySession:function(){},stop:E,reset:E},n=m.getLogger(t),r=null,i=null,a=null,o=null,u=[],c=$(f).getInstance(),l={handleEvent:function(e){switch(e.type){case y.needkey:if(e.initData){var t=ArrayBuffer.isView(e.initData)?e.initData.buffer:e.initData;d.trigger(g.NEED_KEY,{key:new ie(t,"cenc")})}}}},t}ce.__dashjs_factory_name="ProtectionModel_3Feb2014";var fe=dashjs.FactoryMaker.getClassFactory(ce);function de(e){e=e||{};var t,n,r,i,a,o,u,l,c,f=this.context,d=e.eventBus,g=e.events,m=e.debug,y=e.api,E=e.errHandler;function _(){r&&S();for(var e=0;e<u.length;e++)T(u[e]);d.trigger(g.TEARDOWN_COMPLETE)}function T(e){try{r[y.cancelKeyRequest](i.systemString,e.sessionId)}catch(t){d.trigger(g.KEY_SESSION_CLOSED,{data:null,error:"Error closing session ("+e.sessionId+") "+t.message})}}function v(e,t){if(t&&e){for(var n=e.length,r=0;r<n;r++)if(e[r].sessionId==t)return e[r];return null}return null}function S(){r.removeEventListener(y.keyerror,c),r.removeEventListener(y.needkey,c),r.removeEventListener(y.keymessage,c),r.removeEventListener(y.keyadded,c)}return t={getAllInitData:function(){for(var e=[],t=0;t<o.length;t++)e.push(o[t].initData);for(var n=0;n<u.length;n++)e.push(u[n].initData);return e},getSessions:function(){return u.concat(o)},requestKeySystemAccess:function(e){return new Promise((function(t,n){var i=r;i||(i=document.createElement("video"));for(var o=!1,u=0;u<e.length;u++)for(var l=e[u].ks.systemString,c=e[u].configs,f=null,h=0;h<c.length;h++){var p=c[h].videoCapabilities;if(p&&0!==p.length){f=[];for(var m=0;m<p.length;m++)""!==i.canPlayType(p[m].contentType,l)&&f.push(p[m])}if(f&&(!f||0!==f.length)){o=!0;var y=new s(null,f),E=a.getKeySystemBySystemString(l),_=new oe(E,y);d.trigger(g.KEY_SYSTEM_ACCESS_COMPLETE,{data:_}),t({data:_});break}}if(!o){var T="Key system access denied! -- No valid audio/video content configurations detected!";d.trigger(g.KEY_SYSTEM_ACCESS_COMPLETE,{error:T}),n({error:T})}}))},selectKeySystem:function(e){return i=e.keySystem,Promise.resolve(i)},setMediaElement:function(e){if(r!==e){if(r){S();for(var t=0;t<u.length;t++)T(u[t]);u=[]}(r=e)&&(r.addEventListener(y.keyerror,c),r.addEventListener(y.needkey,c),r.addEventListener(y.keymessage,c),r.addEventListener(y.keyadded,c),d.trigger(g.VIDEO_ELEMENT_SELECTED))}},createKeySession:function(e){if(!i)throw new Error("Can not create sessions until you have selected a key system");if(l||0===u.length){var t={sessionId:null,keyId:e.keyId,initData:e.initData,getKeyId:function(){return this.keyId},getSessionId:function(){return this.sessionId},getExpirationTime:function(){return NaN},getSessionType:function(){return"temporary"}};return o.push(t),r[y.generateKeyRequest](i.systemString,new Uint8Array(e.initData)),t}throw new Error("Multiple sessions not allowed!")},updateKeySession:function(e,t){var n=e.sessionId;if(a.isClearKey(i))for(var o=0;o<t.keyPairs.length;o++)r[y.addKey](i.systemString,t.keyPairs[o].key,t.keyPairs[o].keyID,n);else r[y.addKey](i.systemString,new Uint8Array(t),new Uint8Array(e.initData),n);d.trigger(g.KEY_SESSION_UPDATED)},closeKeySession:T,setServerCertificate:function(){},loadKeySession:function(){},removeKeySession:function(){},stop:_,reset:_},n=m.getLogger(t),r=null,i=null,o=[],u=[],a=$(f).getInstance(),c={handleEvent:function(e){var t=null;switch(e.type){case y.needkey:var r=ArrayBuffer.isView(e.initData)?e.initData.buffer:e.initData;d.trigger(g.NEED_KEY,{key:new ie(r,"cenc")});break;case y.keyerror:if((t=v(u,e.sessionId))||(t=v(o,e.sessionId)),t){var i=h.MEDIA_KEYERR_CODE,a="";switch(e.errorCode.code){case 1:i=h.MEDIA_KEYERR_UNKNOWN_CODE,a+="MEDIA_KEYERR_UNKNOWN - "+h.MEDIA_KEYERR_UNKNOWN_MESSAGE;break;case 2:i=h.MEDIA_KEYERR_CLIENT_CODE,a+="MEDIA_KEYERR_CLIENT - "+h.MEDIA_KEYERR_CLIENT_MESSAGE;break;case 3:i=h.MEDIA_KEYERR_SERVICE_CODE,a+="MEDIA_KEYERR_SERVICE - "+h.MEDIA_KEYERR_SERVICE_MESSAGE;break;case 4:i=h.MEDIA_KEYERR_OUTPUT_CODE,a+="MEDIA_KEYERR_OUTPUT - "+h.MEDIA_KEYERR_OUTPUT_MESSAGE;break;case 5:i=h.MEDIA_KEYERR_HARDWARECHANGE_CODE,a+="MEDIA_KEYERR_HARDWARECHANGE - "+h.MEDIA_KEYERR_HARDWARECHANGE_MESSAGE;break;case 6:i=h.MEDIA_KEYERR_DOMAIN_CODE,a+="MEDIA_KEYERR_DOMAIN - "+h.MEDIA_KEYERR_DOMAIN_MESSAGE}a+="  System Code = "+e.systemCode,d.trigger(g.KEY_ERROR,{error:new p.a(i,a,t)})}else n.error("No session token found for key error");break;case y.keyadded:(t=v(u,e.sessionId))||(t=v(o,e.sessionId)),t?(n.debug("DRM: Key added."),d.trigger(g.KEY_ADDED,{data:t})):n.debug("No session token found for key added");break;case y.keymessage:if((l=null!==e.sessionId&&void 0!==e.sessionId)?!(t=v(u,e.sessionId))&&o.length>0&&(t=o.shift(),u.push(t),t.sessionId=e.sessionId,d.trigger(g.KEY_SESSION_CREATED,{data:t})):o.length>0&&(t=o.shift(),u.push(t),0!==o.length&&E.error(new p.a(h.MEDIA_KEY_MESSAGE_ERROR_CODE,h.MEDIA_KEY_MESSAGE_ERROR_MESSAGE))),t){var s=ArrayBuffer.isView(e.message)?e.message.buffer:e.message;t.keyMessage=s,d.trigger(g.INTERNAL_KEY_MESSAGE,{data:new ae(t,s,e.defaultURL)})}else n.warn("No session token found for key message")}}},t}de.__dashjs_factory_name="ProtectionModel_01b";var he=dashjs.FactoryMaker.getClassFactory(de),pe=[{generateKeyRequest:"generateKeyRequest",addKey:"addKey",cancelKeyRequest:"cancelKeyRequest",needkey:"needkey",keyerror:"keyerror",keyadded:"keyadded",keymessage:"keymessage"},{generateKeyRequest:"webkitGenerateKeyRequest",addKey:"webkitAddKey",cancelKeyRequest:"webkitCancelKeyRequest",needkey:"webkitneedkey",keyerror:"webkitkeyerror",keyadded:"webkitkeyadded",keymessage:"webkitkeymessage"}],ge=[{setMediaKeys:"setMediaKeys",MediaKeys:"MediaKeys",release:"close",needkey:"needkey",error:"keyerror",message:"keymessage",ready:"keyadded",close:"keyclose"},{setMediaKeys:"msSetMediaKeys",MediaKeys:"MSMediaKeys",release:"close",needkey:"msneedkey",error:"mskeyerror",message:"mskeymessage",ready:"mskeyadded",close:"mskeyclose"}];function me(){var e,t=this.context;function n(e,t){for(var n=0;n<t.length;n++){var r=t[n];if("function"==typeof e[r[Object.keys(r)[0]]])return r}return null}return e={createProtectionSystem:function(r){var i=null,a=$(t).getInstance();a.setConfig({debug:r.debug,BASE64:r.BASE64,settings:r.settings}),a.initialize();var o=function(r){var i=r.debug,a=i.getLogger(e),o=r.eventBus,s=r.errHandler,u=r.videoModel?r.videoModel.getElement():null;return u&&void 0===u.onencrypted||u&&void 0===u.mediaKeys?n(u,ge)?(a.info("EME detected on this user agent! (ProtectionModel_3Feb2014)"),fe(t).create({debug:i,eventBus:o,events:r.events,api:n(u,ge)})):n(u,pe)?(a.info("EME detected on this user agent! (ProtectionModel_01b)"),he(t).create({debug:i,eventBus:o,errHandler:s,events:r.events,api:n(u,pe)})):(a.warn("No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!"),null):(a.info("EME detected on this user agent! (ProtectionModel_21Jan2015)"),le(t).create({debug:i,eventBus:o,events:r.events}))}(r);return!i&&o&&(i=A(t).create({protectionModel:o,protectionKeyController:a,eventBus:r.eventBus,debug:r.debug,events:r.events,BASE64:r.BASE64,constants:r.constants,cmcdModel:r.cmcdModel,customParametersModel:r.customParametersModel,settings:r.settings}),r.capabilities.setEncryptedMediaSupported(!0)),i}}}me.__dashjs_factory_name="Protection";var ye=dashjs.FactoryMaker.getClassFactory(me);ye.events=re,ye.errors=h,dashjs.FactoryMaker.updateClassFactory(me.__dashjs_factory_name,ye);t.default=ye},function(e,t,n){"use strict";n.r(t);var r=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.mpdurl=null,this.errorcode=null,this.terror=null,this.url=null,this.ipaddress=null,this.servicelocation=null};r.SSL_CONNECTION_FAILED_PREFIX="SSL",r.DNS_RESOLUTION_FAILED="C00",r.HOST_UNREACHABLE="C01",r.CONNECTION_REFUSED="C02",r.CONNECTION_ERROR="C03",r.CORRUPT_MEDIA_ISOBMFF="M00",r.CORRUPT_MEDIA_OTHER="M01",r.BASE_URL_CHANGED="F00",r.BECAME_REPORTER="S00";var i=r,a=n(19);function o(e){var t,n,r=(e=e||{}).eventBus,o=e.dashMetrics,s=e.metricsConstants,u=e.events;function l(e){var t=new i;if(n){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r]);t.mpdurl||(t.mpdurl=n.originalUrl||n.url),t.terror||(t.terror=new Date),o.addDVBErrors(t)}}function c(e){e.error||(n=e.manifest)}function f(e){l({errorcode:i.BASE_URL_CHANGED,servicelocation:e.entry})}function d(){l({errorcode:i.BECAME_REPORTER})}function h(e){switch(e.metric){case s.HTTP_REQUEST:(0===(t=e.value).responsecode||null==t.responsecode||t.responsecode>=400||t.responsecode<100||t.responsecode>=600)&&l({errorcode:t.responsecode||i.CONNECTION_ERROR,url:t.url,terror:t.tresponse,servicelocation:t._serviceLocation})}var t}function p(e){var t;switch(e.error?e.error.code:0){case MediaError.MEDIA_ERR_NETWORK:t=i.CONNECTION_ERROR;break;case MediaError.MEDIA_ERR_DECODE:t=i.CORRUPT_MEDIA_OTHER;break;default:return}l({errorcode:t})}return t={initialise:function(){r.on(u.MANIFEST_UPDATED,c,t),r.on(u.SERVICE_LOCATION_BLACKLIST_CHANGED,f,t),r.on(u.METRIC_ADDED,h,t),r.on(u.METRIC_UPDATED,h,t),r.on(u.PLAYBACK_ERROR,p,t),r.on(a.a.BECAME_REPORTING_PLAYER,d,t)},reset:function(){r.off(u.MANIFEST_UPDATED,c,t),r.off(u.SERVICE_LOCATION_BLACKLIST_CHANGED,f,t),r.off(u.METRIC_ADDED,h,t),r.off(u.METRIC_UPDATED,h,t),r.off(u.PLAYBACK_ERROR,p,t),r.off(a.a.BECAME_REPORTING_PLAYER,d,t)}}}o.__dashjs_factory_name="DVBErrorsTranslator";var s=dashjs.FactoryMaker.getSingletonFactory(o),u=n(49);function l(e){e=e||{};var t,n,r=!1,i=this.context,a=e.mediaElement;return t={initialize:function(e){e&&e.length&&(e.forEach((function(e){var t=e.starttime,r=t+e.duration;n.add(t,r)})),r=!!e[0]._useWallClockTime)},reset:function(){n.clear()},isEnabled:function(){var e,t=n.length;if(!t)return!0;e=r?(new Date).getTime()/1e3:a.currentTime;for(var i=0;i<t;i+=1){var o=n.start(i),s=n.end(i);if(o<=e&&e<s)return!0}return!1}},n=Object(u.a)(i).create(),t}l.__dashjs_factory_name="RangeController";var c=dashjs.FactoryMaker.getClassFactory(l);function f(){return{serialise:function e(t){var n,r,i=[],a=[];for(n in t)if(t.hasOwnProperty(n)&&0!==n.indexOf("_")){if(null==(r=t[n])&&(r=""),Array.isArray(r)){if(!r.length)continue;a=[],r.forEach((function(t){var n="Object"!==Object.prototype.toString.call(t).slice(8,-1);a.push(n?t:e(t))})),r=a.map(encodeURIComponent).join(",")}else"string"==typeof r?r=encodeURIComponent(r):r instanceof Date?r=r.toISOString():"number"==typeof r&&(r=Math.round(r));i.push(n+"="+r)}return i.join("&")}}}f.__dashjs_factory_name="MetricSerialiser";var d=dashjs.FactoryMaker.getSingletonFactory(f);function h(){var e,t,n,r=window.crypto||window.msCrypto,i=Uint32Array,a=Math.pow(2,8*i.BYTES_PER_ELEMENT)-1;function o(){r&&(e||(e=new i(10)),r.getRandomValues(e),t=0)}return n={random:function(n,i){var s;return n||(n=0),i||(i=1),r?(t===e.length&&o(),s=e[t]/a,t+=1):s=Math.random(),s*(i-n)+n}},o(),n}h.__dashjs_factory_name="RNG";var p=dashjs.FactoryMaker.getSingletonFactory(h),g=n(31);function m(e){var t;e=e||{};var n,r,i,a,o,s,u,l=this.context,c=[],f=e.metricsConstants;function h(){a=!1,o=!1,s=null,u=null}return t={report:function(e,t){Array.isArray(t)||(t=[t]),o&&u.isEnabled()&&t.forEach((function(t){var i=n.serialise(t);e!==f.DVB_ERRORS&&(i="metricname=".concat(e,"&").concat(i)),function(e,t,n){var i=new XMLHttpRequest;i.withCredentials=r.getXHRWithCredentialsForType(f.HTTP_REQUEST_DVB_REPORTING_TYPE);var a=function(){var e=c.indexOf(i);-1!==e&&(c.splice(e,1),i.status>=200&&i.status<300?t&&t():n&&n())};c.push(i);try{i.open("GET",e),i.onloadend=a,i.onerror=a,i.send()}catch(e){i.onerror()}}(i="".concat(s,"?").concat(i),null,(function(){o=!1}))}))},initialize:function(e,t){var n;if(u=t,!(s=e.dvb_reportingUrl))throw new Error("required parameter missing (dvb:reportingUrl)");a||((n=e.dvb_probability)&&(1e3===n||n/1e3>=i.random())&&(o=!0),a=!0)},reset:function(){h()}},n=d(l).getInstance(),i=p(l).getInstance(),r=Object(g.a)(l).getInstance(),h(),t}m.__dashjs_factory_name="DVBReporting";var y=dashjs.FactoryMaker.getClassFactory(m);function E(e){e=e||{};var t,n={"urn:dvb:dash:reporting:2014":y},r=this.context,i=e.debug?e.debug.getLogger(t):{},a=e.metricsConstants,o=e.mediaPlayerModel||{};return t={create:function(e,t){var s;try{(s=n[e.schemeIdUri](r).create({metricsConstants:a,mediaPlayerModel:o})).initialize(e,t)}catch(t){s=null,i.error("ReportingFactory: could not create Reporting with schemeIdUri ".concat(e.schemeIdUri," (").concat(t.message,")"))}return s},register:function(e,t){n[e]=t},unregister:function(e){delete n[e]}}}E.__dashjs_factory_name="ReportingFactory";var _=dashjs.FactoryMaker.getSingletonFactory(E);function T(e){var t=[],n=_(this.context).getInstance(e);return{initialize:function(e,r){e.some((function(e){var i=n.create(e,r);if(i)return t.push(i),!0}))},reset:function(){t.forEach((function(e){return e.reset()})),t=[]},report:function(e,n){t.forEach((function(t){return t.report(e,n)}))}}}T.__dashjs_factory_name="ReportingController";var v=dashjs.FactoryMaker.getClassFactory(T);function S(){return{reconstructFullMetricName:function(e,t,n){var r=e;return t&&(r+="("+t,n&&n.length&&(r+=","+n),r+=")"),r},validateN:function(e){if(!e)throw new Error("missing n");if(isNaN(e))throw new Error("n is NaN");if(e<0)throw new Error("n must be positive");return e}}}S.__dashjs_factory_name="HandlerHelpers";var A=dashjs.FactoryMaker.getSingletonFactory(S);function b(e){var t,n,r,i,a;e=e||{};var o=this.context,s=A(o).getInstance(),u=[],l=e.metricsConstants;function c(){var e=function(){try{return Object.keys(u).map((function(e){return u[e]})).reduce((function(e,t){return e.level<t.level?e:t}))}catch(e){return}}();e&&a!==e.t&&(a=e.t,t.report(r,e))}return{initialize:function(e,a,o){a&&(n=s.validateN(o),t=a,r=s.reconstructFullMetricName(e,o),i=setInterval(c,n))},reset:function(){clearInterval(i),i=null,n=0,t=null,a=null},handleNewMetric:function(e,t,n){e===l.BUFFER_LEVEL&&(u[n]=t)}}}b.__dashjs_factory_name="BufferLevelHandler";var I=dashjs.FactoryMaker.getClassFactory(b);var R=dashjs.FactoryMaker.getClassFactory((function(e){var t,n=(e=e||{}).eventBus,r=e.metricsConstants;function i(){n.off(a.a.METRICS_INITIALISATION_COMPLETE,i,this),n.trigger(a.a.BECAME_REPORTING_PLAYER)}return{initialize:function(e,r){r&&(t=r,n.on(a.a.METRICS_INITIALISATION_COMPLETE,i,this))},reset:function(){t=null},handleNewMetric:function(e,n){e===r.DVB_ERRORS&&t&&t.report(e,n)}}}));function N(e){var t,n,r,i,a;e=e||{};var o=[],s=A(this.context).getInstance(),u=e.metricsConstants;function l(){var e=o;e.length&&t&&t.report(i,e),o=[]}return{initialize:function(e,o,u,c){o&&(n=s.validateN(u),t=o,c&&c.length&&(r=c),i=s.reconstructFullMetricName(e,u,c),a=setInterval(l,n))},reset:function(){clearInterval(a),a=null,n=null,r=null,o=[],t=null},handleNewMetric:function(e,t){e===u.HTTP_REQUEST&&(r&&r!==t.type||o.push(t))}}}N.__dashjs_factory_name="HttpListHandler";var C=dashjs.FactoryMaker.getClassFactory(N);function w(){var e,t;return{initialize:function(n,r){e=n,t=r},reset:function(){t=null,e=void 0},handleNewMetric:function(n,r){n===e&&t&&t.report(e,r)}}}w.__dashjs_factory_name="GenericMetricHandler";var D=dashjs.FactoryMaker.getClassFactory(w);function O(e){var t,n=(e=e||{}).debug?e.debug.getLogger(t):{},r=/([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/,i=this.context,a={BufferLevel:I,DVBErrors:R,HttpList:C,PlayList:D,RepSwitchList:D,TcpList:D};return t={create:function(t,o){var s,u=t.match(r);if(u){try{(s=a[u[1]](i).create({eventBus:e.eventBus,metricsConstants:e.metricsConstants})).initialize(u[1],o,u[3],u[5])}catch(e){s=null,n.error("MetricsHandlerFactory: Could not create handler for type ".concat(u[1]," with args ").concat(u[3],", ").concat(u[5]," (").concat(e.message,")"))}return s}},register:function(e,t){a[e]=t},unregister:function(e){delete a[e]}}}O.__dashjs_factory_name="MetricsHandlerFactory";var M=dashjs.FactoryMaker.getSingletonFactory(O);function P(e){e=e||{};var t,n=[],r=this.context,i=e.eventBus,a=e.events,o=M(r).getInstance({debug:e.debug,eventBus:e.eventBus,metricsConstants:e.metricsConstants});function s(e){n.forEach((function(t){t.handleNewMetric(e.metric,e.value,e.mediaType)}))}return t={initialize:function(e,r){e.split(",").forEach((function(e,t,i){var a;if(-1!==e.indexOf("(")&&-1===e.indexOf(")")){var s=i[t+1];s&&-1===s.indexOf("(")&&-1!==s.indexOf(")")&&(e+=","+s,delete i[t+1])}(a=o.create(e,r))&&n.push(a)})),i.on(a.METRIC_ADDED,s,t),i.on(a.METRIC_UPDATED,s,t)},reset:function(){i.off(a.METRIC_ADDED,s,t),i.off(a.METRIC_UPDATED,s,t),n.forEach((function(e){return e.reset()})),n=[]}}}P.__dashjs_factory_name="MetricsHandlersController";var L=dashjs.FactoryMaker.getClassFactory(P);function F(e){var t,n,r;e=e||{};var i=this.context;function a(){t&&t.reset(),n&&n.reset(),r&&r.reset()}return{initialize:function(o){try{(r=c(i).create({mediaElement:e.mediaElement})).initialize(o.Range),(n=v(i).create({debug:e.debug,metricsConstants:e.metricsConstants,mediaPlayerModel:e.mediaPlayerModel})).initialize(o.Reporting,r),(t=L(i).create({debug:e.debug,eventBus:e.eventBus,metricsConstants:e.metricsConstants,events:e.events})).initialize(o.metrics,n)}catch(e){throw a(),e}},reset:a}}F.__dashjs_factory_name="MetricsController";var x=dashjs.FactoryMaker.getClassFactory(F);var U=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.metrics="",this.Range=[],this.Reporting=[]};var B=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.starttime=0,this.duration=1/0,this._useWallClockTime=!1};var k=function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.schemeIdUri="",this.value="",this.dvb_reportingUrl="",this.dvb_probability=1e3};function G(e){var t=(e=e||{}).adapter,n=e.constants;return{getMetrics:function(e){var r=[];return e&&e.Metrics_asArray&&e.Metrics_asArray.forEach((function(i){var a=new U,o=t.getIsDynamic(e);i.hasOwnProperty("metrics")&&(a.metrics=i.metrics,i.Range_asArray&&i.Range_asArray.forEach((function(r){var i=new B;i.starttime=function(e,r,i){var a,o,s=0;return r?s=t.getAvailabilityStartTime(e)/1e3:(a=t.getRegularPeriods(e)).length&&(s=a[0].start),o=s,i&&i.hasOwnProperty(n.START_TIME)&&(o+=i.starttime),o}(e,o,r),r.hasOwnProperty("duration")?i.duration=r.duration:i.duration=t.getDuration(e),i._useWallClockTime=o,a.Range.push(i)})),i.Reporting_asArray&&(i.Reporting_asArray.forEach((function(e){var t=new k;e.hasOwnProperty(n.SCHEME_ID_URI)&&(t.schemeIdUri=e.schemeIdUri,e.hasOwnProperty("value")&&(t.value=e.value),e.hasOwnProperty(n.DVB_REPORTING_URL)&&(t.dvb_reportingUrl=e[n.DVB_REPORTING_URL]),e.hasOwnProperty(n.DVB_PROBABILITY)&&(t.dvb_probability=e[n.DVB_PROBABILITY]),a.Reporting.push(t))})),r.push(a)))})),r}}}G.__dashjs_factory_name="ManifestParsing";var j=dashjs.FactoryMaker.getSingletonFactory(G);function Y(e){var t;e=e||{};var n={},r=this.context,i=e.eventBus,o=e.events;function s(t){if(!t.error){var o=Object.keys(n);j(r).getInstance({adapter:e.adapter,constants:e.constants}).getMetrics(t.manifest).forEach((function(t){var i=JSON.stringify(t);if(n.hasOwnProperty(i))o.splice(i,1);else try{var a=x(r).create(e);a.initialize(t),n[i]=a}catch(e){}})),o.forEach((function(e){n[e].reset(),delete n[e]})),i.trigger(a.a.METRICS_INITIALISATION_COMPLETE)}}function u(){Object.keys(n).forEach((function(e){n[e].reset()})),n={}}return t={reset:function(){i.off(o.MANIFEST_UPDATED,s,t),i.off(o.STREAM_TEARDOWN_COMPLETE,u,t)}},i.on(o.MANIFEST_UPDATED,s,t),i.on(o.STREAM_TEARDOWN_COMPLETE,u,t),t}Y.__dashjs_factory_name="MetricsCollectionController";var H=dashjs.FactoryMaker.getClassFactory(Y);function V(){var e=this.context;return{createMetricsReporting:function(t){return s(e).getInstance({eventBus:t.eventBus,dashMetrics:t.dashMetrics,metricsConstants:t.metricsConstants,events:t.events}).initialise(),H(e).create(t)},getReportingFactory:function(){return _(e).getInstance()},getMetricsHandlerFactory:function(){return M(e).getInstance()}}}V.__dashjs_factory_name="MetricsReporting";var K=dashjs.FactoryMaker.getClassFactory(V);K.events=a.a,dashjs.FactoryMaker.updateClassFactory(V.__dashjs_factory_name,K);t.default=K},function(e,t,n){"use strict";n.r(t),function(e){var r=n(54);n.d(t,"MediaPlayer",(function(){return r.a}));var i=n(3);n.d(t,"FactoryMaker",(function(){return i.a}));var a=n(6);n.d(t,"Debug",(function(){return a.a}));var o=n(55),s=(n(96),"undefined"!=typeof window&&window||e),u=s.dashjs;u||(u=s.dashjs={}),u.MediaPlayer=r.a,u.FactoryMaker=i.a,u.Debug=a.a,u.Version=Object(o.a)(),t.default=u}.call(this,n(23))},function(e,t,n){!function(e,t,n){function r(e,t,i,s,u,l,c,f,d){if(t<c.begin||t>=c.end)return null;var h="regionID"in c&&""!==c.regionID?c.regionID:l;if(null!==u&&h!==i.id&&(!("contents"in c)||"contents"in c&&0===c.contents.length||""!==h))return null;var p=new a(c);for(var g in c.sets)t<c.sets[g].begin||t>=c.sets[g].end||(p.styleAttrs[c.sets[g].qname]=c.sets[g].value);var m,y={};for(var E in p.styleAttrs)if(y[E]=!0,E===n.byName.writingMode.qname&&!(n.byName.direction.qname in p.styleAttrs)){var _=p.styleAttrs[E];"lrtb"===_||"lr"===_?p.styleAttrs[n.byName.direction.qname]="ltr":"rltb"!==_&&"rl"!==_||(p.styleAttrs[n.byName.direction.qname]="rtl")}if(null!==u)for(var T in n.all){var v=n.all[T];if(v.qname===n.byName.textDecoration.qname){var S=u.styleAttrs[v.qname],A=p.styleAttrs[v.qname],b=[];void 0===A?b=S:-1===A.indexOf("none")?((-1===A.indexOf("noUnderline")&&-1!==S.indexOf("underline")||-1!==A.indexOf("underline"))&&b.push("underline"),(-1===A.indexOf("noLineThrough")&&-1!==S.indexOf("lineThrough")||-1!==A.indexOf("lineThrough"))&&b.push("lineThrough"),(-1===A.indexOf("noOverline")&&-1!==S.indexOf("overline")||-1!==A.indexOf("overline"))&&b.push("overline")):b.push("none"),p.styleAttrs[v.qname]=b}else v.inherit&&v.qname in u.styleAttrs&&!(v.qname in p.styleAttrs)&&(p.styleAttrs[v.qname]=u.styleAttrs[v.qname])}for(var I in n.all){var R=n.all[I];R.qname in p.styleAttrs||("region"===p.kind||!1===R.inherit&&null!==R.initial)&&(p.styleAttrs[R.qname]=R.parse(R.initial),y[R.qname]=!0)}for(var N in n.all){var C=n.all[N];if(C.qname in y&&null!==C.compute){var w=C.compute(e,u,p,p.styleAttrs[C.qname],d);null!==w?p.styleAttrs[C.qname]=w:o(f,"Style '"+C.qname+"' on element '"+p.kind+"' cannot be computed")}}if("none"===p.styleAttrs[n.byName.display.qname])return null;for(var D in null===u?m=null===s?[]:[s]:"contents"in c&&(m=c.contents),m){var O=r(e,t,i,s,p,h,m[D],f,d);null!==O&&p.contents.push(O.element)}for(var M in p.styleAttrs){-1===n.byQName[M].applies.indexOf(p.kind)&&delete p.styleAttrs[M]}if("span"===p.kind&&p.text&&"default"===p.space){var P=p.text.replace(/\s+/g," ");p.text=P}if("p"===p.kind){var L=[];!function e(t,n){if("contents"in t)for(var r in t.contents)e(t.contents[r],n);else n.push(t)}(p,L);for(var F=0,x="after_br",U=0;;)if("after_br"===x)F>=L.length||"br"===L[F].kind?(x="before_br",U=F,F--):("preserve"!==L[F].space&&(L[F].text=L[F].text.replace(/^\s+/g,"")),L[F].text.length>0?(x="looking_br",F++):L.splice(F,1));else if("before_br"===x)if(F<0||"br"===L[F].kind){if(x="after_br",(F=U+1)>=L.length)break}else if("preserve"!==L[F].space&&(L[F].text=L[F].text.replace(/\s+$/g,"")),L[F].text.length>0){if(x="after_br",(F=U+1)>=L.length)break}else L.splice(F,1),F--;else F>=L.length||"br"===L[F].kind?(x="before_br",U=F,F--):F++;!function e(t){if("br"===t.kind)return!1;if("text"in t)return 0===t.text.length;if("contents"in t){for(var n=t.contents.length;n--;)e(t.contents[n])&&t.contents.splice(n,1);return 0===t.contents.length}}(p)}return"div"===p.kind&&n.byName.backgroundImage.qname in p.styleAttrs||"br"===p.kind||"contents"in p&&p.contents.length>0||"span"===p.kind&&null!==p.text||"region"===p.kind&&"always"===p.styleAttrs[n.byName.showBackground.qname]?{region_id:h,element:p}:null}function i(e){this.contents=[],this.aspectRatio=e.aspectRatio}function a(e){for(var t in this.kind=e.kind||"region",e.id&&(this.id=e.id),this.styleAttrs={},e.styleAttrs)this.styleAttrs[t]=e.styleAttrs[t];"text"in e?this.text=e.text:"br"!==e.kind&&(this.contents=[]),"space"in e&&(this.space=e.space)}function o(e,t){if(e&&e.error&&e.error(t))throw t}e.generateISD=function(e,t,n){var a=new i(e),o={};for(var s in e.head.layout.regions){var u=r(e,t,e.head.layout.regions[s],e.body,null,"",e.head.layout.regions[s],n,o);null!==u&&a.contents.push(u.element)}return a}}(t,"undefined"==typeof imscNames?n(51):imscNames,"undefined"==typeof imscStyles?n(63):imscStyles)},function(e,t,n){!function(e,t,n,r,i){function a(e,t,n,r){var i=r&&"seq"===r.timeContainer,o=0;r&&(o=i&&n?n.end:r.begin),t.begin=t.explicit_begin?t.explicit_begin+o:o;var s=t.begin,u=null;for(var l in t.sets)a(e,t.sets[l],u,t),s="seq"===t.timeContainer?t.sets[l].end:Math.max(s,t.sets[l].end),u=t.sets[l];if("contents"in t)for(var c in t.contents)a(e,t.contents[c],u,t),s="seq"===t.timeContainer?t.contents[c].end:Math.max(s,t.contents[c].end),u=t.contents[c];else s=i?t.begin:Number.POSITIVE_INFINITY;null!==t.explicit_end&&null!==t.explicit_dur?t.end=Math.min(t.begin+t.explicit_dur,o+t.explicit_end):null===t.explicit_end&&null!==t.explicit_dur?t.end=t.begin+t.explicit_dur:null!==t.explicit_end&&null===t.explicit_dur?t.end=o+t.explicit_end:t.end=s,delete t.explicit_begin,delete t.explicit_dur,delete t.explicit_end,e._registerEvent(t)}function o(e){this.node=e}function s(){this.events=[],this.head=null,this.body=null}function u(){this.styling=null,this.layout=null}function l(){this.styles={}}function c(){this.id=null,this.styleAttrs=null,this.styleRefs=null}function f(){this.regions={}}function d(e){this.kind=e}function h(e){this.id=e}function p(e){this.regionID=e}function g(e){this.styleAttrs=e}function m(e){this.sets=e}function y(e){this.contents=e}function E(e,t,n){this.explicit_begin=e,this.explicit_end=t,this.explicit_dur=n}function _(){d.call(this,"body")}function T(){d.call(this,"div")}function v(){d.call(this,"p")}function S(){d.call(this,"span")}function A(){d.call(this,"span")}function b(){d.call(this,"br")}function I(){}function R(){}function N(e){return e&&"xml:id"in e.attributes&&e.attributes["xml:id"].value||null}function C(e){return e&&"style"in e.attributes?e.attributes.style.value.split(" "):[]}function w(e,t){var n={};if(null!==e)for(var i in e.attributes){var a=e.attributes[i].uri+" "+e.attributes[i].local,o=r.byQName[a];if(void 0!==o){var s=o.parse(e.attributes[i].value);null!==s?(n[a]=s,o===r.byName.zIndex&&F(t,"zIndex attribute present but not used by IMSC1 since regions do not overlap")):x(t,"Cannot parse styling attribute "+a+" --\x3e "+e.attributes[i].value)}}return n}function D(e,t,n){for(var r in e.attributes)if(e.attributes[r].uri===t&&e.attributes[r].local===n)return e.attributes[r].value;return null}function O(e,t,n){var r,i=null;return null!==(r=/^(\d+(?:\.\d+)?)f$/.exec(n))?null!==t&&(i=parseFloat(r[1])/t):null!==(r=/^(\d+(?:\.\d+)?)t$/.exec(n))?null!==e&&(i=parseFloat(r[1])/e):null!==(r=/^(\d+(?:\.\d+)?)ms$/.exec(n))?i=parseFloat(r[1])/1e3:null!==(r=/^(\d+(?:\.\d+)?)s$/.exec(n))?i=parseFloat(r[1]):null!==(r=/^(\d+(?:\.\d+)?)h$/.exec(n))?i=3600*parseFloat(r[1]):null!==(r=/^(\d+(?:\.\d+)?)m$/.exec(n))?i=60*parseFloat(r[1]):null!==(r=/^(\d{2,}):(\d\d):(\d\d(?:\.\d+)?)$/.exec(n))?i=3600*parseInt(r[1])+60*parseInt(r[2])+parseFloat(r[3]):null!==(r=/^(\d{2,}):(\d\d):(\d\d)\:(\d{2,})$/.exec(n))&&null!==t&&(i=3600*parseInt(r[1])+60*parseInt(r[2])+parseInt(r[3])+(null===r[4]?0:parseInt(r[4])/t)),i}function M(e,t,n){for(;t.styleRefs.length>0;){var r=t.styleRefs.pop();r in e.styles?(M(e,e.styles[r],n),L(e.styles[r].styleAttrs,t.styleAttrs)):x(n,"Non-existant style id referenced")}}function P(e,t,n,r){for(var i=t.length-1;i>=0;i--){var a=t[i];a in e.styles?L(e.styles[a].styleAttrs,n):x(r,"Non-existant style id referenced")}}function L(e,t){for(var n in e)n in t||(t[n]=e[n])}function F(e,t){if(e&&e.warn&&e.warn(t))throw t}function x(e,t){if(e&&e.error&&e.error(t))throw t}function U(e,t){throw e&&e.fatal&&e.fatal(t),t}function B(e,t){for(var n,r=0,i=e.length-1;r<=i;){var a=e[n=Math.floor((r+i)/2)];if(a<t)r=n+1;else{if(!(a>t))return{found:!0,index:n};i=n-1}}return{found:!1,index:r}}e.fromXML=function(e,r,i){var d=t.parser(!0,{xmlns:!0}),h=[],p=[],g=[],m=0,y=null;d.onclosetag=function(e){if(h[0]instanceof l)for(var t in h[0].styles)M(h[0],h[0].styles[t],r);else if(h[0]instanceof v||h[0]instanceof S){if(h[0].contents.length>1){var a,s=[h[0].contents[0]];for(a=1;a<h[0].contents.length;a++)h[0].contents[a]instanceof A&&s[s.length-1]instanceof A?s[s.length-1].text+=h[0].contents[a].text:s.push(h[0].contents[a]);h[0].contents=s}h[0]instanceof S&&1===h[0].contents.length&&h[0].contents[0]instanceof A&&(h[0].text=h[0].contents[0].text,delete h[0].contents)}else h[0]instanceof o&&(h[0].node.uri===n.ns_tt&&"metadata"===h[0].node.local?m--:m>0&&i&&"onCloseTag"in i&&i.onCloseTag());g.shift(),p.shift(),h.shift()},d.ontext=function(e){if(void 0===h[0]);else if(h[0]instanceof S||h[0]instanceof v){var t=new A;t.initFromText(y,h[0],e,g[0],r),h[0].contents.push(t)}else h[0]instanceof o&&m>0&&i&&"onText"in i&&i.onText(e)},d.onopentag=function(e){var t=e.attributes["xml:space"];t?g.unshift(t.value):0===g.length?g.unshift("default"):g.unshift(g[0]);var a=e.attributes["xml:lang"];if(a?p.unshift(a.value):0===p.length?p.unshift(""):p.unshift(p[0]),e.uri===n.ns_tt)if("tt"===e.local)null!==y&&U(r,"Two <tt> elements at ("+this.line+","+this.column+")"),(y=new s).initFromNode(e,r),h.unshift(y);else if("head"===e.local)h[0]instanceof s||U(r,"Parent of <head> element is not <tt> at ("+this.line+","+this.column+")"),null!==y.head&&U("Second <head> element at ("+this.line+","+this.column+")"),y.head=new u,h.unshift(y.head);else if("styling"===e.local)h[0]instanceof u||U(r,"Parent of <styling> element is not <head> at ("+this.line+","+this.column+")"),null!==y.head.styling&&U("Second <styling> element at ("+this.line+","+this.column+")"),y.head.styling=new l,h.unshift(y.head.styling);else if("style"===e.local){var d;h[0]instanceof l?((d=new c).initFromNode(e,r),d.id?y.head.styling.styles[d.id]=d:x(r,"<style> element missing @id attribute"),h.unshift(d)):h[0]instanceof I?((d=new c).initFromNode(e,r),L(d.styleAttrs,h[0].styleAttrs),h.unshift(d)):U(r,"Parent of <style> element is not <styling> or <region> at ("+this.line+","+this.column+")")}else if("layout"===e.local)h[0]instanceof u||U(r,"Parent of <layout> element is not <head> at "+this.line+","+this.column+")"),null!==y.head.layout&&U(r,"Second <layout> element at "+this.line+","+this.column+")"),y.head.layout=new f,h.unshift(y.head.layout);else if("region"===e.local){h[0]instanceof f||U(r,"Parent of <region> element is not <layout> at "+this.line+","+this.column+")");var E=new I;E.initFromNode(y,e,r),!E.id||E.id in y.head.layout.regions?x(r,"Ignoring <region> with duplicate or missing @id at "+this.line+","+this.column+")"):y.head.layout.regions[E.id]=E,h.unshift(E)}else if("body"===e.local){h[0]instanceof s||U(r,"Parent of <body> element is not <tt> at "+this.line+","+this.column+")"),null!==y.body&&U(r,"Second <body> element at "+this.line+","+this.column+")");var A=new _;A.initFromNode(y,e,r),y.body=A,h.unshift(A)}else if("div"===e.local){h[0]instanceof T||h[0]instanceof _||U(r,"Parent of <div> element is not <body> or <div> at "+this.line+","+this.column+")");var N=new T;N.initFromNode(y,h[0],e,r),h[0].contents.push(N),h.unshift(N)}else if("p"===e.local){h[0]instanceof T||U(r,"Parent of <p> element is not <div> at "+this.line+","+this.column+")");var C=new v;C.initFromNode(y,h[0],e,r),h[0].contents.push(C),h.unshift(C)}else if("span"===e.local){h[0]instanceof S||h[0]instanceof v||U(r,"Parent of <span> element is not <span> or <p> at "+this.line+","+this.column+")");var w=new S;w.initFromNode(y,h[0],e,g[0],r),h[0].contents.push(w),h.unshift(w)}else if("br"===e.local){h[0]instanceof S||h[0]instanceof v||U(r,"Parent of <br> element is not <span> or <p> at "+this.line+","+this.column+")");var D=new b;D.initFromNode(y,h[0],e,r),h[0].contents.push(D),h.unshift(D)}else if("set"===e.local){h[0]instanceof S||h[0]instanceof v||h[0]instanceof T||h[0]instanceof _||h[0]instanceof I||h[0]instanceof b||U(r,"Parent of <set> element is not a content element or a region at "+this.line+","+this.column+")");var O=new R;O.initFromNode(y,h[0],e,r),h[0].sets.push(O),h.unshift(O)}else h.unshift(new o(e));else h.unshift(new o(e));if(h[0]instanceof o)if(e.uri===n.ns_tt&&"metadata"===e.local)m++;else if(m>0&&i&&"onOpenTag"in i){var M=[];for(var P in e.attributes)M[e.attributes[P].uri+" "+e.attributes[P].local]={uri:e.attributes[P].uri,local:e.attributes[P].local,value:e.attributes[P].value};i.onOpenTag(e.uri,e.local,M)}},d.write(e).close(),null!==y.head?delete y.head.styling:y.head=new u,null===y.head.layout&&(y.head.layout=new f);var E=!1;for(var N in y.head.layout.regions){E=!0;break}if(!E){var C=I.prototype.createDefaultRegion();y.head.layout.regions[C.id]=C}for(var w in y.head.layout.regions)a(y,y.head.layout.regions[w],null,null);return y.body&&a(y,y.body,null,null),y},s.prototype.initFromNode=function(e,t){this.cellResolution=function(e,t){var r=D(e,n.ns_ttp,"cellResolution"),i=15,a=32;if(null!==r){var o=/(\d+) (\d+)/.exec(r);null!==o?(a=parseInt(o[1]),i=parseInt(o[2])):F(t,"Malformed cellResolution value (using initial value instead)")}return{w:a,h:i}}(e,t);var r=function(e,t){var r,i=D(e,n.ns_ttp,"frameRate"),a=30;if(null!==i){null!==(r=/(\d+)/.exec(i))?a=parseInt(r[1]):F(t,"Malformed frame rate attribute (using initial value instead)")}var o=D(e,n.ns_ttp,"frameRateMultiplier"),s=1;if(null!==o){null!==(r=/(\d+) (\d+)/.exec(o))?s=parseInt(r[1])/parseInt(r[2]):F(t,"Malformed frame rate multiplier attribute (using initial value instead)")}var u=s*a,l=1,c=D(e,n.ns_ttp,"tickRate");if(null===c)null!==i&&(l=u);else{null!==(r=/(\d+)/.exec(c))?l=parseInt(r[1]):F(t,"Malformed tick rate attribute (using initial value instead)")}return{effectiveFrameRate:u,tickRate:l}}(e,t);this.effectiveFrameRate=r.effectiveFrameRate,this.tickRate=r.tickRate,this.aspectRatio=function(e,t){var r=D(e,n.ns_ittp,"aspectRatio"),i=null;if(null!==r){var a=/(\d+) (\d+)/.exec(r);if(null!==a){var o=parseInt(a[1]),s=parseInt(a[2]);0!==o&&0!==s?i=o/s:x(t,"Illegal aspectRatio values (ignoring)")}else x(t,"Malformed aspectRatio attribute (ignoring)")}return i}(e,t);var a=D(e,n.ns_ttp,"timeBase");null!==a&&"media"!==a&&U(t,"Unsupported time base");var o=function(e,t){var r=D(e,n.ns_tts,"extent");if(null===r)return null;var a=r.split(" ");if(2!==a.length)return F(t,"Malformed extent (ignoring)"),null;var o=i.parseLength(a[0]),s=i.parseLength(a[1]);if(!s||!o)return F(t,"Malformed extent values (ignoring)"),null;return{h:s,w:o}}(e,t);null===o?this.pxDimensions={h:480,w:640}:("px"===o.h.unit&&"px"===o.w.unit||U(t,"Extent on TT must be in px or absent"),this.pxDimensions={h:o.h.value,w:o.w.value})},s.prototype._registerEvent=function(e){if(!(e.end<=e.begin)){var t=B(this.events,e.begin);if(t.found||this.events.splice(t.index,0,e.begin),e.end!==Number.POSITIVE_INFINITY){var n=B(this.events,e.end);n.found||this.events.splice(n.index,0,e.end)}}},s.prototype.getMediaTimeRange=function(){return[this.events[0],this.events[this.events.length-1]]},s.prototype.getMediaTimeEvents=function(){return this.events},c.prototype.initFromNode=function(e,t){this.id=N(e),this.styleAttrs=w(e,t),this.styleRefs=C(e)},h.prototype.initFromNode=function(e,t,n,r){this.id=N(n)},p.prototype.initFromNode=function(e,t,n,r){this.regionID=function(e){return e&&"region"in e.attributes?e.attributes.region.value:""}(n)},g.prototype.initFromNode=function(e,t,n,r){this.styleAttrs=w(n,r),null!==e.head&&null!==e.head.styling&&P(e.head.styling,C(n),this.styleAttrs,r)},m.prototype.initFromNode=function(e,t,n,r){this.sets=[]},y.prototype.initFromNode=function(e,t,n,r){this.contents=[]},E.prototype.initFromNode=function(e,t,n,r){var i=function(e,t,n,r){var i=null;n&&"begin"in n.attributes&&null===(i=O(e.tickRate,e.effectiveFrameRate,n.attributes.begin.value))&&F(r,"Malformed begin value "+n.attributes.begin.value+" (using 0)");var a=null;n&&"dur"in n.attributes&&null===(a=O(e.tickRate,e.effectiveFrameRate,n.attributes.dur.value))&&F(r,"Malformed dur value "+n.attributes.dur.value+" (ignoring)");var o=null;n&&"end"in n.attributes&&null===(o=O(e.tickRate,e.effectiveFrameRate,n.attributes.end.value))&&F(r,"Malformed end value (ignoring)");return{explicit_begin:i,explicit_end:o,explicit_dur:a}}(e,0,n,r);this.explicit_begin=i.explicit_begin,this.explicit_end=i.explicit_end,this.explicit_dur=i.explicit_dur,this.timeContainer=function(e,t){var n=e&&"timeContainer"in e.attributes?e.attributes.timeContainer.value:null;return n&&"par"!==n?"seq"===n?"seq":(x(t,"Illegal value of timeContainer (assuming 'par')"),"par"):"par"}(n,r)},_.prototype.initFromNode=function(e,t,n){g.prototype.initFromNode.call(this,e,null,t,n),E.prototype.initFromNode.call(this,e,null,t,n),m.prototype.initFromNode.call(this,e,null,t,n),p.prototype.initFromNode.call(this,e,null,t,n),y.prototype.initFromNode.call(this,e,null,t,n)},T.prototype.initFromNode=function(e,t,n,r){g.prototype.initFromNode.call(this,e,t,n,r),E.prototype.initFromNode.call(this,e,t,n,r),m.prototype.initFromNode.call(this,e,t,n,r),p.prototype.initFromNode.call(this,e,t,n,r),y.prototype.initFromNode.call(this,e,t,n,r)},v.prototype.initFromNode=function(e,t,n,r){g.prototype.initFromNode.call(this,e,t,n,r),E.prototype.initFromNode.call(this,e,t,n,r),m.prototype.initFromNode.call(this,e,t,n,r),p.prototype.initFromNode.call(this,e,t,n,r),y.prototype.initFromNode.call(this,e,t,n,r)},S.prototype.initFromNode=function(e,t,n,r,i){g.prototype.initFromNode.call(this,e,t,n,i),E.prototype.initFromNode.call(this,e,t,n,i),m.prototype.initFromNode.call(this,e,t,n,i),p.prototype.initFromNode.call(this,e,t,n,i),y.prototype.initFromNode.call(this,e,t,n,i),this.space=r},A.prototype.initFromText=function(e,t,n,r,i){E.prototype.initFromNode.call(this,e,t,null,i),this.text=n,this.space=r},b.prototype.initFromNode=function(e,t,n,r){p.prototype.initFromNode.call(this,e,t,n,r),E.prototype.initFromNode.call(this,e,t,n,r)},I.prototype.createDefaultRegion=function(){var e=new I;return h.call(e,""),g.call(e,{}),m.call(e,[]),E.call(e,0,Number.POSITIVE_INFINITY,null),e},I.prototype.initFromNode=function(e,t,n){h.prototype.initFromNode.call(this,e,null,t,n),g.prototype.initFromNode.call(this,e,null,t,n),E.prototype.initFromNode.call(this,e,null,t,n),m.prototype.initFromNode.call(this,e,null,t,n),null!==e.head&&null!==e.head.styling&&P(e.head.styling,C(t),this.styleAttrs,n)},R.prototype.initFromNode=function(e,t,n,r){E.prototype.initFromNode.call(this,e,t,n,r);var i=w(n,r);for(var a in this.qname=null,this.value=null,i){if(this.qname){x(r,"More than one style specified on set");break}this.qname=a,this.value=i[a]}}}(t,"undefined"==typeof sax?n(80):sax,"undefined"==typeof imscNames?n(51):imscNames,"undefined"==typeof imscStyles?n(63):imscStyles,"undefined"==typeof imscUtils?n(69):imscUtils)},function(e,t,n){(function(e){!function(t){t.parser=function(e,t){return new a(e,t)},t.SAXParser=a,t.SAXStream=s,t.createStream=function(e,t){return new s(e,t)},t.MAX_BUFFER_LENGTH=65536;var r,i=["comment","sgmlDecl","textNode","tagName","doctype","procInstName","procInstBody","entity","attribName","attribValue","cdata","script"];function a(e,n){if(!(this instanceof a))return new a(e,n);!function(e){for(var t=0,n=i.length;t<n;t++)e[i[t]]=""}(this),this.q=this.c="",this.bufferCheckPosition=t.MAX_BUFFER_LENGTH,this.opt=n||{},this.opt.lowercase=this.opt.lowercase||this.opt.lowercasetags,this.looseCase=this.opt.lowercase?"toLowerCase":"toUpperCase",this.tags=[],this.closed=this.closedRoot=this.sawRoot=!1,this.tag=this.error=null,this.strict=!!e,this.noscript=!(!e&&!this.opt.noscript),this.state=I.BEGIN,this.strictEntities=this.opt.strictEntities,this.ENTITIES=this.strictEntities?Object.create(t.XML_ENTITIES):Object.create(t.ENTITIES),this.attribList=[],this.opt.xmlns&&(this.ns=Object.create(p)),this.trackPosition=!1!==this.opt.position,this.trackPosition&&(this.position=this.line=this.column=0),N(this,"onready")}t.EVENTS=["text","processinginstruction","sgmldeclaration","doctype","comment","opentagstart","attribute","opentag","closetag","opencdata","cdata","closecdata","error","end","ready","script","opennamespace","closenamespace"],Object.create||(Object.create=function(e){function t(){}return t.prototype=e,new t}),Object.keys||(Object.keys=function(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}),a.prototype={end:function(){M(this)},write:function(e){if(this.error)throw this.error;if(this.closed)return O(this,"Cannot write after close. Assign an onready handler.");if(null===e)return M(this);"object"==typeof e&&(e=e.toString());var n=0,r="";for(;r=j(e,n++),this.c=r,r;)switch(this.trackPosition&&(this.position++,"\n"===r?(this.line++,this.column=0):this.column++),this.state){case I.BEGIN:if(this.state=I.BEGIN_WHITESPACE,"\ufeff"===r)continue;G(this,r);continue;case I.BEGIN_WHITESPACE:G(this,r);continue;case I.TEXT:if(this.sawRoot&&!this.closedRoot){for(var a=n-1;r&&"<"!==r&&"&"!==r;)(r=j(e,n++))&&this.trackPosition&&(this.position++,"\n"===r?(this.line++,this.column=0):this.column++);this.textNode+=e.substring(a,n-1)}"<"!==r||this.sawRoot&&this.closedRoot&&!this.strict?(!v(u,r)||this.sawRoot&&!this.closedRoot||P(this,"Text data outside of root node."),"&"===r?this.state=I.TEXT_ENTITY:this.textNode+=r):(this.state=I.OPEN_WAKA,this.startTagPosition=this.position);continue;case I.SCRIPT:"<"===r?this.state=I.SCRIPT_ENDING:this.script+=r;continue;case I.SCRIPT_ENDING:"/"===r?this.state=I.CLOSE_TAG:(this.script+="<"+r,this.state=I.SCRIPT);continue;case I.OPEN_WAKA:if("!"===r)this.state=I.SGML_DECL,this.sgmlDecl="";else if(T(u,r));else if(T(g,r))this.state=I.OPEN_TAG,this.tagName=r;else if("/"===r)this.state=I.CLOSE_TAG,this.tagName="";else if("?"===r)this.state=I.PROC_INST,this.procInstName=this.procInstBody="";else{if(P(this,"Unencoded <"),this.startTagPosition+1<this.position){var o=this.position-this.startTagPosition;r=new Array(o).join(" ")+r}this.textNode+="<"+r,this.state=I.TEXT}continue;case I.SGML_DECL:"[CDATA["===(this.sgmlDecl+r).toUpperCase()?(C(this,"onopencdata"),this.state=I.CDATA,this.sgmlDecl="",this.cdata=""):this.sgmlDecl+r==="--"?(this.state=I.COMMENT,this.comment="",this.sgmlDecl=""):"DOCTYPE"===(this.sgmlDecl+r).toUpperCase()?(this.state=I.DOCTYPE,(this.doctype||this.sawRoot)&&P(this,"Inappropriately located doctype declaration"),this.doctype="",this.sgmlDecl=""):">"===r?(C(this,"onsgmldeclaration",this.sgmlDecl),this.sgmlDecl="",this.state=I.TEXT):T(f,r)?(this.state=I.SGML_DECL_QUOTED,this.sgmlDecl+=r):this.sgmlDecl+=r;continue;case I.SGML_DECL_QUOTED:r===this.q&&(this.state=I.SGML_DECL,this.q=""),this.sgmlDecl+=r;continue;case I.DOCTYPE:">"===r?(this.state=I.TEXT,C(this,"ondoctype",this.doctype),this.doctype=!0):(this.doctype+=r,"["===r?this.state=I.DOCTYPE_DTD:T(f,r)&&(this.state=I.DOCTYPE_QUOTED,this.q=r));continue;case I.DOCTYPE_QUOTED:this.doctype+=r,r===this.q&&(this.q="",this.state=I.DOCTYPE);continue;case I.DOCTYPE_DTD:this.doctype+=r,"]"===r?this.state=I.DOCTYPE:T(f,r)&&(this.state=I.DOCTYPE_DTD_QUOTED,this.q=r);continue;case I.DOCTYPE_DTD_QUOTED:this.doctype+=r,r===this.q&&(this.state=I.DOCTYPE_DTD,this.q="");continue;case I.COMMENT:"-"===r?this.state=I.COMMENT_ENDING:this.comment+=r;continue;case I.COMMENT_ENDING:"-"===r?(this.state=I.COMMENT_ENDED,this.comment=D(this.opt,this.comment),this.comment&&C(this,"oncomment",this.comment),this.comment=""):(this.comment+="-"+r,this.state=I.COMMENT);continue;case I.COMMENT_ENDED:">"!==r?(P(this,"Malformed comment"),this.comment+="--"+r,this.state=I.COMMENT):this.state=I.TEXT;continue;case I.CDATA:"]"===r?this.state=I.CDATA_ENDING:this.cdata+=r;continue;case I.CDATA_ENDING:"]"===r?this.state=I.CDATA_ENDING_2:(this.cdata+="]"+r,this.state=I.CDATA);continue;case I.CDATA_ENDING_2:">"===r?(this.cdata&&C(this,"oncdata",this.cdata),C(this,"onclosecdata"),this.cdata="",this.state=I.TEXT):"]"===r?this.cdata+="]":(this.cdata+="]]"+r,this.state=I.CDATA);continue;case I.PROC_INST:"?"===r?this.state=I.PROC_INST_ENDING:T(u,r)?this.state=I.PROC_INST_BODY:this.procInstName+=r;continue;case I.PROC_INST_BODY:if(!this.procInstBody&&T(u,r))continue;"?"===r?this.state=I.PROC_INST_ENDING:this.procInstBody+=r;continue;case I.PROC_INST_ENDING:">"===r?(C(this,"onprocessinginstruction",{name:this.procInstName,body:this.procInstBody}),this.procInstName=this.procInstBody="",this.state=I.TEXT):(this.procInstBody+="?"+r,this.state=I.PROC_INST_BODY);continue;case I.OPEN_TAG:T(m,r)?this.tagName+=r:(L(this),">"===r?U(this):"/"===r?this.state=I.OPEN_TAG_SLASH:(v(u,r)&&P(this,"Invalid character in tag name"),this.state=I.ATTRIB));continue;case I.OPEN_TAG_SLASH:">"===r?(U(this,!0),B(this)):(P(this,"Forward-slash in opening tag not followed by >"),this.state=I.ATTRIB);continue;case I.ATTRIB:if(T(u,r))continue;">"===r?U(this):"/"===r?this.state=I.OPEN_TAG_SLASH:T(g,r)?(this.attribName=r,this.attribValue="",this.state=I.ATTRIB_NAME):P(this,"Invalid attribute name");continue;case I.ATTRIB_NAME:"="===r?this.state=I.ATTRIB_VALUE:">"===r?(P(this,"Attribute without value"),this.attribValue=this.attribName,x(this),U(this)):T(u,r)?this.state=I.ATTRIB_NAME_SAW_WHITE:T(m,r)?this.attribName+=r:P(this,"Invalid attribute name");continue;case I.ATTRIB_NAME_SAW_WHITE:if("="===r)this.state=I.ATTRIB_VALUE;else{if(T(u,r))continue;P(this,"Attribute without value"),this.tag.attributes[this.attribName]="",this.attribValue="",C(this,"onattribute",{name:this.attribName,value:""}),this.attribName="",">"===r?U(this):T(g,r)?(this.attribName=r,this.state=I.ATTRIB_NAME):(P(this,"Invalid attribute name"),this.state=I.ATTRIB)}continue;case I.ATTRIB_VALUE:if(T(u,r))continue;T(f,r)?(this.q=r,this.state=I.ATTRIB_VALUE_QUOTED):(P(this,"Unquoted attribute value"),this.state=I.ATTRIB_VALUE_UNQUOTED,this.attribValue=r);continue;case I.ATTRIB_VALUE_QUOTED:if(r!==this.q){"&"===r?this.state=I.ATTRIB_VALUE_ENTITY_Q:this.attribValue+=r;continue}x(this),this.q="",this.state=I.ATTRIB_VALUE_CLOSED;continue;case I.ATTRIB_VALUE_CLOSED:T(u,r)?this.state=I.ATTRIB:">"===r?U(this):"/"===r?this.state=I.OPEN_TAG_SLASH:T(g,r)?(P(this,"No whitespace between attributes"),this.attribName=r,this.attribValue="",this.state=I.ATTRIB_NAME):P(this,"Invalid attribute name");continue;case I.ATTRIB_VALUE_UNQUOTED:if(v(d,r)){"&"===r?this.state=I.ATTRIB_VALUE_ENTITY_U:this.attribValue+=r;continue}x(this),">"===r?U(this):this.state=I.ATTRIB;continue;case I.CLOSE_TAG:if(this.tagName)">"===r?B(this):T(m,r)?this.tagName+=r:this.script?(this.script+="</"+this.tagName,this.tagName="",this.state=I.SCRIPT):(v(u,r)&&P(this,"Invalid tagname in closing tag"),this.state=I.CLOSE_TAG_SAW_WHITE);else{if(T(u,r))continue;v(g,r)?this.script?(this.script+="</"+r,this.state=I.SCRIPT):P(this,"Invalid tagname in closing tag."):this.tagName=r}continue;case I.CLOSE_TAG_SAW_WHITE:if(T(u,r))continue;">"===r?B(this):P(this,"Invalid characters in closing tag");continue;case I.TEXT_ENTITY:case I.ATTRIB_VALUE_ENTITY_Q:case I.ATTRIB_VALUE_ENTITY_U:var s,l;switch(this.state){case I.TEXT_ENTITY:s=I.TEXT,l="textNode";break;case I.ATTRIB_VALUE_ENTITY_Q:s=I.ATTRIB_VALUE_QUOTED,l="attribValue";break;case I.ATTRIB_VALUE_ENTITY_U:s=I.ATTRIB_VALUE_UNQUOTED,l="attribValue"}";"===r?(this[l]+=k(this),this.entity="",this.state=s):T(this.entity.length?E:y,r)?this.entity+=r:(P(this,"Invalid character in entity name"),this[l]+="&"+this.entity+r,this.entity="",this.state=s);continue;default:throw new Error(this,"Unknown state: "+this.state)}this.position>=this.bufferCheckPosition&&function(e){for(var n=Math.max(t.MAX_BUFFER_LENGTH,10),r=0,a=0,o=i.length;a<o;a++){var s=e[i[a]].length;if(s>n)switch(i[a]){case"textNode":w(e);break;case"cdata":C(e,"oncdata",e.cdata),e.cdata="";break;case"script":C(e,"onscript",e.script),e.script="";break;default:O(e,"Max buffer length exceeded: "+i[a])}r=Math.max(r,s)}var u=t.MAX_BUFFER_LENGTH-r;e.bufferCheckPosition=u+e.position}(this);return this}
/*! http://mths.be/fromcodepoint v0.1.0 by @mathias */,resume:function(){return this.error=null,this},close:function(){return this.write(null)},flush:function(){var e;w(e=this),""!==e.cdata&&(C(e,"oncdata",e.cdata),e.cdata=""),""!==e.script&&(C(e,"onscript",e.script),e.script="")}};try{r=n(83).Stream}catch(e){r=function(){}}var o=t.EVENTS.filter((function(e){return"error"!==e&&"end"!==e}));function s(e,t){if(!(this instanceof s))return new s(e,t);r.apply(this),this._parser=new a(e,t),this.writable=!0,this.readable=!0;var n=this;this._parser.onend=function(){n.emit("end")},this._parser.onerror=function(e){n.emit("error",e),n._parser.error=null},this._decoder=null,o.forEach((function(e){Object.defineProperty(n,"on"+e,{get:function(){return n._parser["on"+e]},set:function(t){if(!t)return n.removeAllListeners(e),n._parser["on"+e]=t,t;n.on(e,t)},enumerable:!0,configurable:!1})}))}s.prototype=Object.create(r.prototype,{constructor:{value:s}}),s.prototype.write=function(t){if("function"==typeof e&&"function"==typeof e.isBuffer&&e.isBuffer(t)){if(!this._decoder){var r=n(68).StringDecoder;this._decoder=new r("utf8")}t=this._decoder.write(t)}return this._parser.write(t.toString()),this.emit("data",t),!0},s.prototype.end=function(e){return e&&e.length&&this.write(e),this._parser.end(),!0},s.prototype.on=function(e,t){var n=this;return n._parser["on"+e]||-1===o.indexOf(e)||(n._parser["on"+e]=function(){var t=1===arguments.length?[arguments[0]]:Array.apply(null,arguments);t.splice(0,0,e),n.emit.apply(n,t)}),r.prototype.on.call(n,e,t)};var u="\r\n\t ",l="0124356789",c="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",f="'\"",d=u+">",h="http://www.w3.org/XML/1998/namespace",p={xml:h,xmlns:"http://www.w3.org/2000/xmlns/"};u=_(u),l=_(l),c=_(c);var g=/[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,m=/[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/,y=/[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,E=/[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;function _(e){return e.split("").reduce((function(e,t){return e[t]=!0,e}),{})}function T(e,t){return function(e){return"[object RegExp]"===Object.prototype.toString.call(e)}(e)?!!t.match(e):e[t]}function v(e,t){return!T(e,t)}f=_(f),d=_(d);var S,A,b,I=0;for(var R in t.STATE={BEGIN:I++,BEGIN_WHITESPACE:I++,TEXT:I++,TEXT_ENTITY:I++,OPEN_WAKA:I++,SGML_DECL:I++,SGML_DECL_QUOTED:I++,DOCTYPE:I++,DOCTYPE_QUOTED:I++,DOCTYPE_DTD:I++,DOCTYPE_DTD_QUOTED:I++,COMMENT_STARTING:I++,COMMENT:I++,COMMENT_ENDING:I++,COMMENT_ENDED:I++,CDATA:I++,CDATA_ENDING:I++,CDATA_ENDING_2:I++,PROC_INST:I++,PROC_INST_BODY:I++,PROC_INST_ENDING:I++,OPEN_TAG:I++,OPEN_TAG_SLASH:I++,ATTRIB:I++,ATTRIB_NAME:I++,ATTRIB_NAME_SAW_WHITE:I++,ATTRIB_VALUE:I++,ATTRIB_VALUE_QUOTED:I++,ATTRIB_VALUE_CLOSED:I++,ATTRIB_VALUE_UNQUOTED:I++,ATTRIB_VALUE_ENTITY_Q:I++,ATTRIB_VALUE_ENTITY_U:I++,CLOSE_TAG:I++,CLOSE_TAG_SAW_WHITE:I++,SCRIPT:I++,SCRIPT_ENDING:I++},t.XML_ENTITIES={amp:"&",gt:">",lt:"<",quot:'"',apos:"'"},t.ENTITIES={amp:"&",gt:">",lt:"<",quot:'"',apos:"'",AElig:198,Aacute:193,Acirc:194,Agrave:192,Aring:197,Atilde:195,Auml:196,Ccedil:199,ETH:208,Eacute:201,Ecirc:202,Egrave:200,Euml:203,Iacute:205,Icirc:206,Igrave:204,Iuml:207,Ntilde:209,Oacute:211,Ocirc:212,Ograve:210,Oslash:216,Otilde:213,Ouml:214,THORN:222,Uacute:218,Ucirc:219,Ugrave:217,Uuml:220,Yacute:221,aacute:225,acirc:226,aelig:230,agrave:224,aring:229,atilde:227,auml:228,ccedil:231,eacute:233,ecirc:234,egrave:232,eth:240,euml:235,iacute:237,icirc:238,igrave:236,iuml:239,ntilde:241,oacute:243,ocirc:244,ograve:242,oslash:248,otilde:245,ouml:246,szlig:223,thorn:254,uacute:250,ucirc:251,ugrave:249,uuml:252,yacute:253,yuml:255,copy:169,reg:174,nbsp:160,iexcl:161,cent:162,pound:163,curren:164,yen:165,brvbar:166,sect:167,uml:168,ordf:170,laquo:171,not:172,shy:173,macr:175,deg:176,plusmn:177,sup1:185,sup2:178,sup3:179,acute:180,micro:181,para:182,middot:183,cedil:184,ordm:186,raquo:187,frac14:188,frac12:189,frac34:190,iquest:191,times:215,divide:247,OElig:338,oelig:339,Scaron:352,scaron:353,Yuml:376,fnof:402,circ:710,tilde:732,Alpha:913,Beta:914,Gamma:915,Delta:916,Epsilon:917,Zeta:918,Eta:919,Theta:920,Iota:921,Kappa:922,Lambda:923,Mu:924,Nu:925,Xi:926,Omicron:927,Pi:928,Rho:929,Sigma:931,Tau:932,Upsilon:933,Phi:934,Chi:935,Psi:936,Omega:937,alpha:945,beta:946,gamma:947,delta:948,epsilon:949,zeta:950,eta:951,theta:952,iota:953,kappa:954,lambda:955,mu:956,nu:957,xi:958,omicron:959,pi:960,rho:961,sigmaf:962,sigma:963,tau:964,upsilon:965,phi:966,chi:967,psi:968,omega:969,thetasym:977,upsih:978,piv:982,ensp:8194,emsp:8195,thinsp:8201,zwnj:8204,zwj:8205,lrm:8206,rlm:8207,ndash:8211,mdash:8212,lsquo:8216,rsquo:8217,sbquo:8218,ldquo:8220,rdquo:8221,bdquo:8222,dagger:8224,Dagger:8225,bull:8226,hellip:8230,permil:8240,prime:8242,Prime:8243,lsaquo:8249,rsaquo:8250,oline:8254,frasl:8260,euro:8364,image:8465,weierp:8472,real:8476,trade:8482,alefsym:8501,larr:8592,uarr:8593,rarr:8594,darr:8595,harr:8596,crarr:8629,lArr:8656,uArr:8657,rArr:8658,dArr:8659,hArr:8660,forall:8704,part:8706,exist:8707,empty:8709,nabla:8711,isin:8712,notin:8713,ni:8715,prod:8719,sum:8721,minus:8722,lowast:8727,radic:8730,prop:8733,infin:8734,ang:8736,and:8743,or:8744,cap:8745,cup:8746,int:8747,there4:8756,sim:8764,cong:8773,asymp:8776,ne:8800,equiv:8801,le:8804,ge:8805,sub:8834,sup:8835,nsub:8836,sube:8838,supe:8839,oplus:8853,otimes:8855,perp:8869,sdot:8901,lceil:8968,rceil:8969,lfloor:8970,rfloor:8971,lang:9001,rang:9002,loz:9674,spades:9824,clubs:9827,hearts:9829,diams:9830},Object.keys(t.ENTITIES).forEach((function(e){var n=t.ENTITIES[e],r="number"==typeof n?String.fromCharCode(n):n;t.ENTITIES[e]=r})),t.STATE)t.STATE[t.STATE[R]]=R;function N(e,t,n){e[t]&&e[t](n)}function C(e,t,n){e.textNode&&w(e),N(e,t,n)}function w(e){e.textNode=D(e.opt,e.textNode),e.textNode&&N(e,"ontext",e.textNode),e.textNode=""}function D(e,t){return e.trim&&(t=t.trim()),e.normalize&&(t=t.replace(/\s+/g," ")),t}function O(e,t){return w(e),e.trackPosition&&(t+="\nLine: "+e.line+"\nColumn: "+e.column+"\nChar: "+e.c),t=new Error(t),e.error=t,N(e,"onerror",t),e}function M(e){return e.sawRoot&&!e.closedRoot&&P(e,"Unclosed root tag"),e.state!==I.BEGIN&&e.state!==I.BEGIN_WHITESPACE&&e.state!==I.TEXT&&O(e,"Unexpected end"),w(e),e.c="",e.closed=!0,N(e,"onend"),a.call(e,e.strict,e.opt),e}function P(e,t){if("object"!=typeof e||!(e instanceof a))throw new Error("bad call to strictFail");e.strict&&O(e,t)}function L(e){e.strict||(e.tagName=e.tagName[e.looseCase]());var t=e.tags[e.tags.length-1]||e,n=e.tag={name:e.tagName,attributes:{}};e.opt.xmlns&&(n.ns=t.ns),e.attribList.length=0,C(e,"onopentagstart",n)}function F(e,t){var n=e.indexOf(":")<0?["",e]:e.split(":"),r=n[0],i=n[1];return t&&"xmlns"===e&&(r="xmlns",i=""),{prefix:r,local:i}}function x(e){if(e.strict||(e.attribName=e.attribName[e.looseCase]()),-1!==e.attribList.indexOf(e.attribName)||e.tag.attributes.hasOwnProperty(e.attribName))e.attribName=e.attribValue="";else{if(e.opt.xmlns){var t=F(e.attribName,!0),n=t.prefix,r=t.local;if("xmlns"===n)if("xml"===r&&e.attribValue!==h)P(e,"xml: prefix must be bound to "+h+"\nActual: "+e.attribValue);else if("xmlns"===r&&"http://www.w3.org/2000/xmlns/"!==e.attribValue)P(e,"xmlns: prefix must be bound to http://www.w3.org/2000/xmlns/\nActual: "+e.attribValue);else{var i=e.tag,a=e.tags[e.tags.length-1]||e;i.ns===a.ns&&(i.ns=Object.create(a.ns)),i.ns[r]=e.attribValue}e.attribList.push([e.attribName,e.attribValue])}else e.tag.attributes[e.attribName]=e.attribValue,C(e,"onattribute",{name:e.attribName,value:e.attribValue});e.attribName=e.attribValue=""}}function U(e,t){if(e.opt.xmlns){var n=e.tag,r=F(e.tagName);n.prefix=r.prefix,n.local=r.local,n.uri=n.ns[r.prefix]||"",n.prefix&&!n.uri&&(P(e,"Unbound namespace prefix: "+JSON.stringify(e.tagName)),n.uri=r.prefix);var i=e.tags[e.tags.length-1]||e;n.ns&&i.ns!==n.ns&&Object.keys(n.ns).forEach((function(t){C(e,"onopennamespace",{prefix:t,uri:n.ns[t]})}));for(var a=0,o=e.attribList.length;a<o;a++){var s=e.attribList[a],u=s[0],l=s[1],c=F(u,!0),f=c.prefix,d=c.local,h=""===f?"":n.ns[f]||"",p={name:u,value:l,prefix:f,local:d,uri:h};f&&"xmlns"!==f&&!h&&(P(e,"Unbound namespace prefix: "+JSON.stringify(f)),p.uri=f),e.tag.attributes[u]=p,C(e,"onattribute",p)}e.attribList.length=0}e.tag.isSelfClosing=!!t,e.sawRoot=!0,e.tags.push(e.tag),C(e,"onopentag",e.tag),t||(e.noscript||"script"!==e.tagName.toLowerCase()?e.state=I.TEXT:e.state=I.SCRIPT,e.tag=null,e.tagName=""),e.attribName=e.attribValue="",e.attribList.length=0}function B(e){if(!e.tagName)return P(e,"Weird empty close tag."),e.textNode+="</>",void(e.state=I.TEXT);if(e.script){if("script"!==e.tagName)return e.script+="</"+e.tagName+">",e.tagName="",void(e.state=I.SCRIPT);C(e,"onscript",e.script),e.script=""}var t=e.tags.length,n=e.tagName;e.strict||(n=n[e.looseCase]());for(var r=n;t--;){if(e.tags[t].name===r)break;P(e,"Unexpected close tag")}if(t<0)return P(e,"Unmatched closing tag: "+e.tagName),e.textNode+="</"+e.tagName+">",void(e.state=I.TEXT);e.tagName=n;for(var i=e.tags.length;i-- >t;){var a=e.tag=e.tags.pop();e.tagName=e.tag.name,C(e,"onclosetag",e.tagName);var o={};for(var s in a.ns)o[s]=a.ns[s];var u=e.tags[e.tags.length-1]||e;e.opt.xmlns&&a.ns!==u.ns&&Object.keys(a.ns).forEach((function(t){var n=a.ns[t];C(e,"onclosenamespace",{prefix:t,uri:n})}))}0===t&&(e.closedRoot=!0),e.tagName=e.attribValue=e.attribName="",e.attribList.length=0,e.state=I.TEXT}function k(e){var t,n=e.entity,r=n.toLowerCase(),i="";return e.ENTITIES[n]?e.ENTITIES[n]:e.ENTITIES[r]?e.ENTITIES[r]:("#"===(n=r).charAt(0)&&("x"===n.charAt(1)?(n=n.slice(2),i=(t=parseInt(n,16)).toString(16)):(n=n.slice(1),i=(t=parseInt(n,10)).toString(10))),n=n.replace(/^0+/,""),i.toLowerCase()!==n?(P(e,"Invalid character entity"),"&"+e.entity+";"):String.fromCodePoint(t))}function G(e,t){"<"===t?(e.state=I.OPEN_WAKA,e.startTagPosition=e.position):v(u,t)&&(P(e,"Non-whitespace before first tag."),e.textNode=t,e.state=I.TEXT)}function j(e,t){var n="";return t<e.length&&(n=e.charAt(t)),n}I=t.STATE,String.fromCodePoint||(S=String.fromCharCode,A=Math.floor,b=function(){var e,t,n=16384,r=[],i=-1,a=arguments.length;if(!a)return"";for(var o="";++i<a;){var s=Number(arguments[i]);if(!isFinite(s)||s<0||s>1114111||A(s)!==s)throw RangeError("Invalid code point: "+s);s<=65535?r.push(s):(e=55296+((s-=65536)>>10),t=s%1024+56320,r.push(e,t)),(i+1===a||r.length>n)&&(o+=S.apply(null,r),r.length=0)}return o},Object.defineProperty?Object.defineProperty(String,"fromCodePoint",{value:b,configurable:!0,writable:!0}):String.fromCodePoint=b)}(t)}).call(this,n(64).Buffer)},function(e,t,n){"use strict";t.byteLength=function(e){var t=l(e),n=t[0],r=t[1];return 3*(n+r)/4-r},t.toByteArray=function(e){for(var t,n=l(e),r=n[0],o=n[1],s=new a(function(e,t,n){return 3*(t+n)/4-n}(0,r,o)),u=0,c=o>0?r-4:r,f=0;f<c;f+=4)t=i[e.charCodeAt(f)]<<18|i[e.charCodeAt(f+1)]<<12|i[e.charCodeAt(f+2)]<<6|i[e.charCodeAt(f+3)],s[u++]=t>>16&255,s[u++]=t>>8&255,s[u++]=255&t;2===o&&(t=i[e.charCodeAt(f)]<<2|i[e.charCodeAt(f+1)]>>4,s[u++]=255&t);1===o&&(t=i[e.charCodeAt(f)]<<10|i[e.charCodeAt(f+1)]<<4|i[e.charCodeAt(f+2)]>>2,s[u++]=t>>8&255,s[u++]=255&t);return s},t.fromByteArray=function(e){for(var t,n=e.length,i=n%3,a=[],o=0,s=n-i;o<s;o+=16383)a.push(c(e,o,o+16383>s?s:o+16383));1===i?(t=e[n-1],a.push(r[t>>2]+r[t<<4&63]+"==")):2===i&&(t=(e[n-2]<<8)+e[n-1],a.push(r[t>>10]+r[t>>4&63]+r[t<<2&63]+"="));return a.join("")};for(var r=[],i=[],a="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0,u=o.length;s<u;++s)r[s]=o[s],i[o.charCodeAt(s)]=s;function l(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function c(e,t,n){for(var i,a,o=[],s=t;s<n;s+=3)i=(e[s]<<16&16711680)+(e[s+1]<<8&65280)+(255&e[s+2]),o.push(r[(a=i)>>18&63]+r[a>>12&63]+r[a>>6&63]+r[63&a]);return o.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},function(e,t){t.read=function(e,t,n,r,i){var a,o,s=8*i-r-1,u=(1<<s)-1,l=u>>1,c=-7,f=n?i-1:0,d=n?-1:1,h=e[t+f];for(f+=d,a=h&(1<<-c)-1,h>>=-c,c+=s;c>0;a=256*a+e[t+f],f+=d,c-=8);for(o=a&(1<<-c)-1,a>>=-c,c+=r;c>0;o=256*o+e[t+f],f+=d,c-=8);if(0===a)a=1-l;else{if(a===u)return o?NaN:1/0*(h?-1:1);o+=Math.pow(2,r),a-=l}return(h?-1:1)*o*Math.pow(2,a-r)},t.write=function(e,t,n,r,i,a){var o,s,u,l=8*a-i-1,c=(1<<l)-1,f=c>>1,d=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,h=r?0:a-1,p=r?1:-1,g=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(s=isNaN(t)?1:0,o=c):(o=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-o))<1&&(o--,u*=2),(t+=o+f>=1?d/u:d*Math.pow(2,1-f))*u>=2&&(o++,u/=2),o+f>=c?(s=0,o=c):o+f>=1?(s=(t*u-1)*Math.pow(2,i),o+=f):(s=t*Math.pow(2,f-1)*Math.pow(2,i),o=0));i>=8;e[n+h]=255&s,h+=p,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;e[n+h]=255&o,h+=p,o/=256,l-=8);e[n+h-p]|=128*g}},function(e,t,n){e.exports=i;var r=n(65).EventEmitter;function i(){r.call(this)}n(40)(i,r),i.Readable=n(66),i.Writable=n(91),i.Duplex=n(92),i.Transform=n(93),i.PassThrough=n(94),i.Stream=i,i.prototype.pipe=function(e,t){var n=this;function i(t){e.writable&&!1===e.write(t)&&n.pause&&n.pause()}function a(){n.readable&&n.resume&&n.resume()}n.on("data",i),e.on("drain",a),e._isStdio||t&&!1===t.end||(n.on("end",s),n.on("close",u));var o=!1;function s(){o||(o=!0,e.end())}function u(){o||(o=!0,"function"==typeof e.destroy&&e.destroy())}function l(e){if(c(),0===r.listenerCount(this,"error"))throw e}function c(){n.removeListener("data",i),e.removeListener("drain",a),n.removeListener("end",s),n.removeListener("close",u),n.removeListener("error",l),e.removeListener("error",l),n.removeListener("end",c),n.removeListener("close",c),e.removeListener("close",c)}return n.on("error",l),e.on("error",l),n.on("end",c),n.on("close",c),e.on("close",c),e.emit("pipe",n),e}},function(e,t){},function(e,t,n){"use strict";var r=n(53).Buffer,i=n(86);e.exports=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.head=null,this.tail=null,this.length=0}return e.prototype.push=function(e){var t={data:e,next:null};this.length>0?this.tail.next=t:this.head=t,this.tail=t,++this.length},e.prototype.unshift=function(e){var t={data:e,next:this.head};0===this.length&&(this.tail=t),this.head=t,++this.length},e.prototype.shift=function(){if(0!==this.length){var e=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,e}},e.prototype.clear=function(){this.head=this.tail=null,this.length=0},e.prototype.join=function(e){if(0===this.length)return"";for(var t=this.head,n=""+t.data;t=t.next;)n+=e+t.data;return n},e.prototype.concat=function(e){if(0===this.length)return r.alloc(0);if(1===this.length)return this.head.data;for(var t,n,i,a=r.allocUnsafe(e>>>0),o=this.head,s=0;o;)t=o.data,n=a,i=s,t.copy(n,i),s+=o.data.length,o=o.next;return a},e}(),i&&i.inspect&&i.inspect.custom&&(e.exports.prototype[i.inspect.custom]=function(){var e=i.inspect({length:this.length});return this.constructor.name+" "+e})},function(e,t){},function(e,t,n){(function(e){var r=void 0!==e&&e||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function a(e,t){this._id=e,this._clearFn=t}t.setTimeout=function(){return new a(i.call(setTimeout,r,arguments),clearTimeout)},t.setInterval=function(){return new a(i.call(setInterval,r,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},a.prototype.unref=a.prototype.ref=function(){},a.prototype.close=function(){this._clearFn.call(r,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),t))},n(88),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,n(23))},function(e,t,n){(function(e,t){!function(e,n){"use strict";if(!e.setImmediate){var r,i,a,o,s,u=1,l={},c=!1,f=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?r=function(e){t.nextTick((function(){p(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?e.MessageChannel?((a=new MessageChannel).port1.onmessage=function(e){p(e.data)},r=function(e){a.port2.postMessage(e)}):f&&"onreadystatechange"in f.createElement("script")?(i=f.documentElement,r=function(e){var t=f.createElement("script");t.onreadystatechange=function(){p(e),t.onreadystatechange=null,i.removeChild(t),t=null},i.appendChild(t)}):r=function(e){setTimeout(p,0,e)}:(o="setImmediate$"+Math.random()+"$",s=function(t){t.source===e&&"string"==typeof t.data&&0===t.data.indexOf(o)&&p(+t.data.slice(o.length))},e.addEventListener?e.addEventListener("message",s,!1):e.attachEvent("onmessage",s),r=function(t){e.postMessage(o+t,"*")}),d.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var i={callback:e,args:t};return l[u]=i,r(u),u++},d.clearImmediate=h}function h(e){delete l[e]}function p(e){if(c)setTimeout(p,0,e);else{var t=l[e];if(t){c=!0;try{!function(e){var t=e.callback,n=e.args;switch(n.length){case 0:t();break;case 1:t(n[0]);break;case 2:t(n[0],n[1]);break;case 3:t(n[0],n[1],n[2]);break;default:t.apply(void 0,n)}}(t)}finally{h(e),c=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,n(23),n(25))},function(e,t,n){(function(t){function n(e){try{if(!t.localStorage)return!1}catch(e){return!1}var n=t.localStorage[e];return null!=n&&"true"===String(n).toLowerCase()}e.exports=function(e,t){if(n("noDeprecation"))return e;var r=!1;return function(){if(!r){if(n("throwDeprecation"))throw new Error(t);n("traceDeprecation")?console.trace(t):console.warn(t),r=!0}return e.apply(this,arguments)}}}).call(this,n(23))},function(e,t,n){"use strict";e.exports=a;var r=n(74),i=n(47);function a(e){if(!(this instanceof a))return new a(e);r.call(this,e)}i.inherits=n(40),i.inherits(a,r),a.prototype._transform=function(e,t,n){n(null,e)}},function(e,t,n){e.exports=n(67)},function(e,t,n){e.exports=n(35)},function(e,t,n){e.exports=n(66).Transform},function(e,t,n){e.exports=n(66).PassThrough},function(e,t,n){!function(e,t,n){function r(e,t,s){var l;if("region"===s.kind?(l=document.createElement("div")).style.position="absolute":"body"===s.kind||"div"===s.kind?l=document.createElement("div"):"p"===s.kind?l=document.createElement("p"):"span"===s.kind?l=document.createElement("span"):"br"===s.kind&&(l=document.createElement("br")),l){for(var c in l.style.margin="0",u){var f=u[c],d=s.styleAttrs[f.qname];void 0!==d&&null!==f.map&&f.map(e,l,s,d)}var h=l;if("region"===s.kind){var p=s.styleAttrs[n.byName.writingMode.qname];"lrtb"===p||"lr"===p?(e.ipd="lr",e.bpd="tb"):"rltb"===p||"rl"===p?(e.ipd="rl",e.bpd="tb"):"tblr"===p?(e.ipd="tb",e.bpd="lr"):"tbrl"!==p&&"tb"!==p||(e.ipd="tb",e.bpd="rl")}var g=s.styleAttrs[n.byName.linePadding.qname];if(g&&g>0){var m=Math.ceil(g*e.h)+"px";"tb"===e.bpd?(h.style.paddingLeft=m,h.style.paddingRight=m):(h.style.paddingTop=m,h.style.paddingBottom=m),e.lp=g}var y=s.styleAttrs[n.byName.multiRowAlign.qname];if(y&&"auto"!==y){var E=document.createElement("span");E.style.display="inline-block",E.style.textAlign=y,l.appendChild(E),h=E,e.mra=y}if(s.styleAttrs[n.byName.fillLineGap.qname]&&(e.flg=!0),"span"===s.kind&&s.text)if(e.lp||e.mra||e.flg)for(var _="",T=0;T<s.text.length;T++){_+=s.text.charAt(T);var v=s.text.charCodeAt(T);if(v<55296||v>56319||T===s.text.length){var S=document.createElement("span");S.textContent=_,l.appendChild(S),_=""}}else l.textContent=s.text;for(var A in t.appendChild(l),s.contents)r(e,h,s.contents[A]);var b=[];if((e.lp||e.mra||e.flg)&&"p"===s.kind&&(o(e,h,b,null),e.mra&&(!function(e){for(var t=0;t<e.length-1;t++){var n=e[t].elements.length;if(0!==n&&!1===e[t].br){var r=document.createElement("br"),i=e[t].elements[n-1].node;i.parentElement.insertBefore(r,i.nextSibling)}}}(b),e.mra=null),e.lp&&(!function(e,t,n){for(var r in e){var i=e[r].elements.length,a=e[r].elements[e[r].start_elem],o=e[r].elements[e[r].end_elem],s=Math.ceil(t)+"px",u="-"+Math.ceil(t)+"px";0!==i&&("lr"===n.ipd?(a.node.style.borderLeftColor=a.bgcolor||"#00000000",a.node.style.borderLeftStyle="solid",a.node.style.borderLeftWidth=s,a.node.style.marginLeft=u):"rl"===n.ipd?(a.node.style.borderRightColor=a.bgcolor||"#00000000",a.node.style.borderRightStyle="solid",a.node.style.borderRightWidth=s,a.node.style.marginRight=u):"tb"===n.ipd&&(a.node.style.borderTopColor=a.bgcolor||"#00000000",a.node.style.borderTopStyle="solid",a.node.style.borderTopWidth=s,a.node.style.marginTop=u),"lr"===n.ipd?(o.node.style.borderRightColor=o.bgcolor||"#00000000",o.node.style.borderRightStyle="solid",o.node.style.borderRightWidth=s,o.node.style.marginRight=u):"rl"===n.ipd?(o.node.style.borderLeftColor=o.bgcolor||"#00000000",o.node.style.borderLeftStyle="solid",o.node.style.borderLeftWidth=s,o.node.style.marginLeft=u):"tb"===n.ipd&&(o.node.style.borderBottomColor=o.bgcolor||"#00000000",o.node.style.borderBottomStyle="solid",o.node.style.borderBottomWidth=s,o.node.style.marginBottom=u))}}(b,e.lp*e.h,e),e.lp=null),e.flg)){var I=a(h.getBoundingClientRect(),e);!function(e,t,n,r){for(var i=Math.sign(n-t),a=0;a<=e.length;a++){var o,s,u;if(o=0===a?t:a===e.length?n:(e[a].before+e[a-1].after)/2,a>0)for(var l=0;l<e[a-1].elements.length;l++)null!==e[a-1].elements[l].bgcolor&&(u=e[a-1].elements[l],i*(u.after-o)<0&&(s=Math.ceil(Math.abs(o-u.after))+"px",u.node.style.backgroundColor=u.bgcolor,"lr"===r.bpd?u.node.style.paddingRight=s:"rl"===r.bpd?u.node.style.paddingLeft=s:"tb"===r.bpd&&(u.node.style.paddingBottom=s)));if(a<e.length)for(var c=0;c<e[a].elements.length;c++)null!==(u=e[a].elements[c]).bgcolor&&i*(u.before-o)>0&&(s=Math.ceil(Math.abs(u.before-o))+"px",u.node.style.backgroundColor=u.bgcolor,"lr"===r.bpd?u.node.style.paddingLeft=s:"rl"===r.bpd?u.node.style.paddingRight=s:"tb"===r.bpd&&(u.node.style.paddingTop=s))}}(b,I.before,I.after,e),e.flg=null}if("region"===s.kind&&(o(e,h,b),"tb"===e.bpd&&e.enableRollUp&&s.contents.length>0&&"after"===s.styleAttrs[n.byName.displayAlign.qname])){var R=new i(""===s.id?"_":s.id,b);if(e.currentISDState[R.id]=R,e.previousISDState&&R.id in e.previousISDState&&e.previousISDState[R.id].plist.length>0&&R.plist.length>1&&R.plist[R.plist.length-2].text===e.previousISDState[R.id].plist[e.previousISDState[R.id].plist.length-1].text){var N=l.firstElementChild,C=R.plist[R.plist.length-1].after-R.plist[R.plist.length-1].before;N.style.bottom="-"+C+"px",N.style.transition="transform 0.4s",N.style.position="relative",N.style.transform="translateY(-"+C+"px)"}}}else!function(e,t){if(e&&e.error&&e.error(t))throw t}(e.errorHandler,"Error processing ISD element kind: "+s.kind)}function i(e,t){this.id=e,this.plist=t}function a(e,t){var n={before:null,after:null,start:null,end:null};return"tb"===t.bpd?(n.before=e.top,n.after=e.bottom,"lr"===t.ipd?(n.start=e.left,n.end=e.right):(n.start=e.right,n.end=e.left)):"lr"===t.bpd?(n.before=e.left,n.after=e.right,n.start=e.top,n.end=e.bottom):"rl"===t.bpd&&(n.before=e.right,n.after=e.left,n.start=e.top,n.end=e.bottom),n}function o(e,t,n,r){var i,s,u,l,c=t.style.backgroundColor||r;if(0===t.childElementCount)if("span"===t.localName){var f=t.getBoundingClientRect();if(0===f.height||0===f.width)return;var d=a(f,e);if(0!==n.length&&(i=d.before,s=d.after,u=n[n.length-1].before,l=n[n.length-1].after,s<l&&i>u||l<=s&&u>=i)){var h=Math.sign(d.after-d.before),p=Math.sign(d.end-d.start);h*(d.before-n[n.length-1].before)<0&&(n[n.length-1].before=d.before),h*(d.after-n[n.length-1].after)>0&&(n[n.length-1].after=d.after),p*(d.start-n[n.length-1].start)<0&&(n[n.length-1].start=d.start,n[n.length-1].start_elem=n[n.length-1].elements.length),p*(d.end-n[n.length-1].end)>0&&(n[n.length-1].end=d.end,n[n.length-1].end_elem=n[n.length-1].elements.length)}else n.push({before:d.before,after:d.after,start:d.start,end:d.end,start_elem:0,end_elem:0,elements:[],text:"",br:!1});n[n.length-1].text+=t.textContent,n[n.length-1].elements.push({node:t,bgcolor:c,before:d.before,after:d.after})}else"br"===t.localName&&0!==n.length&&(n[n.length-1].br=!0);else for(var g=t.firstChild;g;)g.nodeType===Node.ELEMENT_NODE&&o(e,g,n,c),g=g.nextSibling}function s(e,t){this.qname=e,this.map=t}e.render=function(e,t,n,i,a,o,s,u,l){var c=i||t.clientHeight,f=a||t.clientWidth;if(null!==e.aspectRatio){var d=c*e.aspectRatio;d>f?c=Math.round(f/e.aspectRatio):f=d}var h=document.createElement("div");h.style.position="relative",h.style.width=f+"px",h.style.height=c+"px",h.style.margin="auto",h.style.top=0,h.style.bottom=0,h.style.left=0,h.style.right=0,h.style.zIndex=0;var p={h:c,w:f,regionH:null,regionW:null,imgResolver:n,displayForcedOnlyMode:o||!1,isd:e,errorHandler:s,previousISDState:u,enableRollUp:l||!1,currentISDState:{},flg:null,lp:null,mra:null,ipd:null,bpd:null};for(var g in t.appendChild(h),e.contents)r(p,h,e.contents[g]);return p.currentISDState};var u=[new s("http://www.w3.org/ns/ttml#styling backgroundColor",(function(e,t,n,r){0!==r[3]&&(t.style.backgroundColor="rgba("+r[0].toString()+","+r[1].toString()+","+r[2].toString()+","+(r[3]/255).toString()+")")})),new s("http://www.w3.org/ns/ttml#styling color",(function(e,t,n,r){t.style.color="rgba("+r[0].toString()+","+r[1].toString()+","+r[2].toString()+","+(r[3]/255).toString()+")"})),new s("http://www.w3.org/ns/ttml#styling direction",(function(e,t,n,r){t.style.direction=r})),new s("http://www.w3.org/ns/ttml#styling display",(function(e,t,n,r){})),new s("http://www.w3.org/ns/ttml#styling displayAlign",(function(e,t,n,r){t.style.display="flex",t.style.flexDirection="column","before"===r?t.style.justifyContent="flex-start":"center"===r?t.style.justifyContent="center":"after"===r&&(t.style.justifyContent="flex-end")})),new s("http://www.w3.org/ns/ttml#styling extent",(function(e,t,n,r){e.regionH=r.h*e.h,e.regionW=r.w*e.w;var i=0,a=0,o=n.styleAttrs["http://www.w3.org/ns/ttml#styling padding"];o&&(i=(o[0]+o[2])*e.h,a=(o[1]+o[3])*e.w),t.style.height=e.regionH-i+"px",t.style.width=e.regionW-a+"px"})),new s("http://www.w3.org/ns/ttml#styling fontFamily",(function(e,t,n,r){var i=[];for(var a in r)"monospaceSerif"===r[a]?(i.push("Courier New"),i.push('"Liberation Mono"'),i.push("Courier"),i.push("monospace")):"proportionalSansSerif"===r[a]?(i.push("Arial"),i.push("Helvetica"),i.push('"Liberation Sans"'),i.push("sans-serif")):"monospace"===r[a]?i.push("monospace"):"sansSerif"===r[a]?i.push("sans-serif"):"serif"===r[a]?i.push("serif"):"monospaceSansSerif"===r[a]?(i.push("Consolas"),i.push("monospace")):"proportionalSerif"===r[a]?i.push("serif"):i.push(r[a]);t.style.fontFamily=i.join(",")})),new s("http://www.w3.org/ns/ttml#styling fontSize",(function(e,t,n,r){t.style.fontSize=r*e.h+"px"})),new s("http://www.w3.org/ns/ttml#styling fontStyle",(function(e,t,n,r){t.style.fontStyle=r})),new s("http://www.w3.org/ns/ttml#styling fontWeight",(function(e,t,n,r){t.style.fontWeight=r})),new s("http://www.w3.org/ns/ttml#styling lineHeight",(function(e,t,n,r){t.style.lineHeight="normal"===r?"normal":r*e.h+"px"})),new s("http://www.w3.org/ns/ttml#styling opacity",(function(e,t,n,r){t.style.opacity=r})),new s("http://www.w3.org/ns/ttml#styling origin",(function(e,t,n,r){t.style.top=r.h*e.h+"px",t.style.left=r.w*e.w+"px"})),new s("http://www.w3.org/ns/ttml#styling overflow",(function(e,t,n,r){t.style.overflow=r})),new s("http://www.w3.org/ns/ttml#styling padding",(function(e,t,n,r){var i=[];i[0]=r[0]*e.h+"px",i[1]=r[3]*e.w+"px",i[2]=r[2]*e.h+"px",i[3]=r[1]*e.w+"px",t.style.padding=i.join(" ")})),new s("http://www.w3.org/ns/ttml#styling showBackground",null),new s("http://www.w3.org/ns/ttml#styling textAlign",(function(e,t,r,i){var a,o=r.styleAttrs[n.byName.direction.qname];a="start"===i?"rtl"===o?"right":"left":"end"===i?"rtl"===o?"left":"right":i,t.style.textAlign=a})),new s("http://www.w3.org/ns/ttml#styling textDecoration",(function(e,t,n,r){t.style.textDecoration=r.join(" ").replace("lineThrough","line-through")})),new s("http://www.w3.org/ns/ttml#styling textOutline",(function(e,t,n,r){t.style.textShadow="none"===r?"":"rgba("+r.color[0].toString()+","+r.color[1].toString()+","+r.color[2].toString()+","+(r.color[3]/255).toString()+") 0px 0px "+r.thickness*e.h+"px"})),new s("http://www.w3.org/ns/ttml#styling unicodeBidi",(function(e,t,n,r){var i;i="bidiOverride"===r?"bidi-override":r,t.style.unicodeBidi=i})),new s("http://www.w3.org/ns/ttml#styling visibility",(function(e,t,n,r){t.style.visibility=r})),new s("http://www.w3.org/ns/ttml#styling wrapOption",(function(e,t,n,r){"wrap"===r?"preserve"===n.space?t.style.whiteSpace="pre-wrap":t.style.whiteSpace="normal":"preserve"===n.space?t.style.whiteSpace="pre":t.style.whiteSpace="noWrap"})),new s("http://www.w3.org/ns/ttml#styling writingMode",(function(e,t,n,r){"lrtb"===r||"lr"===r||"rltb"===r||"rl"===r?t.style.writingMode="horizontal-tb":"tblr"===r?t.style.writingMode="vertical-lr":"tbrl"!==r&&"tb"!==r||(t.style.writingMode="vertical-rl")})),new s("http://www.w3.org/ns/ttml#styling zIndex",(function(e,t,n,r){t.style.zIndex=r})),new s("http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt backgroundImage",(function(e,t,n,r){if(null!==e.imgResolver&&null!==r){var i=document.createElement("img"),a=e.imgResolver(r,i);a&&(i.src=a),i.height=e.regionH,i.width=e.regionW,t.appendChild(i)}})),new s("http://www.w3.org/ns/ttml/profile/imsc1#styling forcedDisplay",(function(e,t,n,r){e.displayForcedOnlyMode&&!1===r&&(t.style.visibility="hidden")}))],l={};for(var c in u)l[u[c].qname]=u[c]}(t,"undefined"==typeof imscNames?n(51):imscNames,"undefined"==typeof imscStyles?n(63):imscStyles)},function(e,t,n){"use strict";e.exports=n(97).polyfill()},function(e,t,n){(function(t,n){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */var r;r=function(){"use strict";function e(e){return"function"==typeof e}var r=Array.isArray?Array.isArray:function(e){return"[object Array]"===Object.prototype.toString.call(e)},i=0,a=void 0,o=void 0,s=function(e,t){p[i]=e,p[i+1]=t,2===(i+=2)&&(o?o(g):T())},u="undefined"!=typeof window?window:void 0,l=u||{},c=l.MutationObserver||l.WebKitMutationObserver,f="undefined"==typeof self&&void 0!==t&&"[object process]"==={}.toString.call(t),d="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel;function h(){var e=setTimeout;return function(){return e(g,1)}}var p=new Array(1e3);function g(){for(var e=0;e<i;e+=2)(0,p[e])(p[e+1]),p[e]=void 0,p[e+1]=void 0;i=0}var m,y,E,_,T=void 0;function v(e,t){var n=this,r=new this.constructor(b);void 0===r[A]&&L(r);var i=n._state;if(i){var a=arguments[i-1];s((function(){return M(i,r,a,n._result)}))}else D(n,r,e,t);return r}function S(e){if(e&&"object"==typeof e&&e.constructor===this)return e;var t=new this(b);return R(t,e),t}f?T=function(){return t.nextTick(g)}:c?(y=0,E=new c(g),_=document.createTextNode(""),E.observe(_,{characterData:!0}),T=function(){_.data=y=++y%2}):d?((m=new MessageChannel).port1.onmessage=g,T=function(){return m.port2.postMessage(0)}):T=void 0===u?function(){try{var e=Function("return this")().require("vertx");return void 0!==(a=e.runOnLoop||e.runOnContext)?function(){a(g)}:h()}catch(e){return h()}}():h();var A=Math.random().toString(36).substring(2);function b(){}function I(t,n,r){n.constructor===t.constructor&&r===v&&n.constructor.resolve===S?function(e,t){1===t._state?C(e,t._result):2===t._state?w(e,t._result):D(t,void 0,(function(t){return R(e,t)}),(function(t){return w(e,t)}))}(t,n):void 0===r?C(t,n):e(r)?function(e,t,n){s((function(e){var r=!1,i=function(e,t,n,r){try{e.call(t,n,r)}catch(e){return e}}(n,t,(function(n){r||(r=!0,t!==n?R(e,n):C(e,n))}),(function(t){r||(r=!0,w(e,t))}),e._label);!r&&i&&(r=!0,w(e,i))}),e)}(t,n,r):C(t,n)}function R(e,t){if(e===t)w(e,new TypeError("You cannot resolve a promise with itself"));else if(i=typeof(r=t),null===r||"object"!==i&&"function"!==i)C(e,t);else{var n=void 0;try{n=t.then}catch(t){return void w(e,t)}I(e,t,n)}var r,i}function N(e){e._onerror&&e._onerror(e._result),O(e)}function C(e,t){void 0===e._state&&(e._result=t,e._state=1,0!==e._subscribers.length&&s(O,e))}function w(e,t){void 0===e._state&&(e._state=2,e._result=t,s(N,e))}function D(e,t,n,r){var i=e._subscribers,a=i.length;e._onerror=null,i[a]=t,i[a+1]=n,i[a+2]=r,0===a&&e._state&&s(O,e)}function O(e){var t=e._subscribers,n=e._state;if(0!==t.length){for(var r=void 0,i=void 0,a=e._result,o=0;o<t.length;o+=3)r=t[o],i=t[o+n],r?M(n,r,i,a):i(a);e._subscribers.length=0}}function M(t,n,r,i){var a=e(r),o=void 0,s=void 0,u=!0;if(a){try{o=r(i)}catch(e){u=!1,s=e}if(n===o)return void w(n,new TypeError("A promises callback cannot return that same promise."))}else o=i;void 0!==n._state||(a&&u?R(n,o):!1===u?w(n,s):1===t?C(n,o):2===t&&w(n,o))}var P=0;function L(e){e[A]=P++,e._state=void 0,e._result=void 0,e._subscribers=[]}var F=function(){function e(e,t){this._instanceConstructor=e,this.promise=new e(b),this.promise[A]||L(this.promise),r(t)?(this.length=t.length,this._remaining=t.length,this._result=new Array(this.length),0===this.length?C(this.promise,this._result):(this.length=this.length||0,this._enumerate(t),0===this._remaining&&C(this.promise,this._result))):w(this.promise,new Error("Array Methods must be provided an Array"))}return e.prototype._enumerate=function(e){for(var t=0;void 0===this._state&&t<e.length;t++)this._eachEntry(e[t],t)},e.prototype._eachEntry=function(e,t){var n=this._instanceConstructor,r=n.resolve;if(r===S){var i=void 0,a=void 0,o=!1;try{i=e.then}catch(e){o=!0,a=e}if(i===v&&void 0!==e._state)this._settledAt(e._state,t,e._result);else if("function"!=typeof i)this._remaining--,this._result[t]=e;else if(n===x){var s=new n(b);o?w(s,a):I(s,e,i),this._willSettleAt(s,t)}else this._willSettleAt(new n((function(t){return t(e)})),t)}else this._willSettleAt(r(e),t)},e.prototype._settledAt=function(e,t,n){var r=this.promise;void 0===r._state&&(this._remaining--,2===e?w(r,n):this._result[t]=n),0===this._remaining&&C(r,this._result)},e.prototype._willSettleAt=function(e,t){var n=this;D(e,void 0,(function(e){return n._settledAt(1,t,e)}),(function(e){return n._settledAt(2,t,e)}))},e}(),x=function(){function t(e){this[A]=P++,this._result=this._state=void 0,this._subscribers=[],b!==e&&("function"!=typeof e&&function(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}(),this instanceof t?function(e,t){try{t((function(t){R(e,t)}),(function(t){w(e,t)}))}catch(t){w(e,t)}}(this,e):function(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}())}return t.prototype.catch=function(e){return this.then(null,e)},t.prototype.finally=function(t){var n=this.constructor;return e(t)?this.then((function(e){return n.resolve(t()).then((function(){return e}))}),(function(e){return n.resolve(t()).then((function(){throw e}))})):this.then(t,t)},t}();return x.prototype.then=v,x.all=function(e){return new F(this,e).promise},x.race=function(e){var t=this;return r(e)?new t((function(n,r){for(var i=e.length,a=0;a<i;a++)t.resolve(e[a]).then(n,r)})):new t((function(e,t){return t(new TypeError("You must pass an array to race."))}))},x.resolve=S,x.reject=function(e){var t=new this(b);return w(t,e),t},x._setScheduler=function(e){o=e},x._setAsap=function(e){s=e},x._asap=s,x.polyfill=function(){var e=void 0;if(void 0!==n)e=n;else if("undefined"!=typeof self)e=self;else try{e=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var t=e.Promise;if(t){var r=null;try{r=Object.prototype.toString.call(t.resolve())}catch(e){}if("[object Promise]"===r&&!t.cast)return}e.Promise=x},x.Promise=x,x},e.exports=r()}).call(this,n(25),n(23))},,,,,,,,,,,function(e,t,n){"use strict";n.r(t),n.d(t,"MediaPlayer",(function(){return r.MediaPlayer})),n.d(t,"Protection",(function(){return o.default})),n.d(t,"MetricsReporting",(function(){return a.default})),n.d(t,"MediaPlayerFactory",(function(){return c})),n.d(t,"Debug",(function(){return f.a})),n.d(t,"supportsMediaSource",(function(){return i.b}));var r=n(77),i=n(50),a=n(76),o=n(75),s=n(54);var u,l=function(){var e;function t(t,n,r){if(!t||!/^VIDEO$/i.test(t.nodeName))return null;if(t._dashjs_player)return t._dashjs_player;var i,a=t.id||t.name||"video element";if(!(n=n||[].slice.call(t.querySelectorAll("source")).filter((function(e){return"application/dash+xml"==e.type}))[0])&&t.src)(n=document.createElement("source")).src=t.src;else if(!n&&!t.src)return null;return r=r||{},(i=Object(s.a)(r).create()).initialize(t,n.src,t.autoplay),e||(e=i.getDebug().getLogger()),e.debug("Converted "+a+" to dash.js player and added content: "+n.src),t._dashjs_player=i,i}function n(e){return/^VIDEO$/i.test(e.nodeName)?e:n(e.parentNode)}return{create:t,createAll:function(e,r){var i=[];e=e||"[data-dashjs-player]";for(var a=(r=r||document).querySelectorAll(e),o=0;o<a.length;o++){var s=t(a[o],null);i.push(s)}for(var u=r.querySelectorAll('source[type="application/dash+xml"]'),l=0;l<u.length;l++){var c=t(n(u[l]),null);i.push(c)}return i}}}();!("undefined"!=typeof window&&window&&window.dashjs&&window.dashjs.skipAutoCreate)&&"undefined"!=typeof window&&window&&window.addEventListener&&("complete"===window.document.readyState?window.dashjs?l.createAll():u=window.setInterval((function(){window.dashjs&&(window.clearInterval(u),l.createAll())}),500):window.addEventListener("load",(function e(){window.removeEventListener("load",e),l.createAll()})));var c=l,f=n(6);dashjs.Protection=o.default,dashjs.MetricsReporting=a.default,dashjs.MediaPlayerFactory=c,dashjs.Debug=f.a,dashjs.supportsMediaSource=i.b;t.default=dashjs}]).default}));
// # sourceMappingURL=dash.all.min.js.map

/***/ }),

/***/ 509:
/***/ ((module) => {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_552__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_552__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_552__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_552__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_552__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_552__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_552__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_552__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_552__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_552__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_552__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_552__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_552__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_552__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_552__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_552__(__nested_webpack_require_552__.s = "./src/mss/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./externals/BigInteger.js":
/*!*********************************!*\
  !*** ./externals/BigInteger.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __nested_webpack_require_4304__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var bigInt = function (undefined) {
  "use strict";

  var BASE = 1e7,
      LOG_BASE = 7,
      MAX_INT = 9007199254740992,
      MAX_INT_ARR = smallToArray(MAX_INT),
      DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
  var supportsNativeBigInt = typeof BigInt === "function";

  function Integer(v, radix, alphabet, caseSensitive) {
    if (typeof v === "undefined") return Integer[0];
    if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
    return parseValue(v);
  }

  function BigInteger(value, sign) {
    this.value = value;
    this.sign = sign;
    this.isSmall = false;
  }

  BigInteger.prototype = Object.create(Integer.prototype);

  function SmallInteger(value) {
    this.value = value;
    this.sign = value < 0;
    this.isSmall = true;
  }

  SmallInteger.prototype = Object.create(Integer.prototype);

  function NativeBigInt(value) {
    this.value = value;
  }

  NativeBigInt.prototype = Object.create(Integer.prototype);

  function isPrecise(n) {
    return -MAX_INT < n && n < MAX_INT;
  }

  function smallToArray(n) {
    if (n < 1e7) return [n];
    if (n < 1e14) return [n % 1e7, Math.floor(n / 1e7)];
    return [n % 1e7, Math.floor(n / 1e7) % 1e7, Math.floor(n / 1e14)];
  }

  function arrayToSmall(arr) {
    trim(arr);
    var length = arr.length;

    if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) {
      switch (length) {
        case 0:
          return 0;

        case 1:
          return arr[0];

        case 2:
          return arr[0] + arr[1] * BASE;

        default:
          return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
      }
    }

    return arr;
  }

  function trim(v) {
    var i = v.length;

    while (v[--i] === 0) {
      ;
    }

    v.length = i + 1;
  }

  function createArray(length) {
    var x = new Array(length);
    var i = -1;

    while (++i < length) {
      x[i] = 0;
    }

    return x;
  }

  function truncate(n) {
    if (n > 0) return Math.floor(n);
    return Math.ceil(n);
  }

  function add(a, b) {
    var l_a = a.length,
        l_b = b.length,
        r = new Array(l_a),
        carry = 0,
        base = BASE,
        sum,
        i;

    for (i = 0; i < l_b; i++) {
      sum = a[i] + b[i] + carry;
      carry = sum >= base ? 1 : 0;
      r[i] = sum - carry * base;
    }

    while (i < l_a) {
      sum = a[i] + carry;
      carry = sum === base ? 1 : 0;
      r[i++] = sum - carry * base;
    }

    if (carry > 0) r.push(carry);
    return r;
  }

  function addAny(a, b) {
    if (a.length >= b.length) return add(a, b);
    return add(b, a);
  }

  function addSmall(a, carry) {
    var l = a.length,
        r = new Array(l),
        base = BASE,
        sum,
        i;

    for (i = 0; i < l; i++) {
      sum = a[i] - base + carry;
      carry = Math.floor(sum / base);
      r[i] = sum - carry * base;
      carry += 1;
    }

    while (carry > 0) {
      r[i++] = carry % base;
      carry = Math.floor(carry / base);
    }

    return r;
  }

  BigInteger.prototype.add = function (v) {
    var n = parseValue(v);

    if (this.sign !== n.sign) {
      return this.subtract(n.negate());
    }

    var a = this.value,
        b = n.value;

    if (n.isSmall) {
      return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
    }

    return new BigInteger(addAny(a, b), this.sign);
  };

  BigInteger.prototype.plus = BigInteger.prototype.add;

  SmallInteger.prototype.add = function (v) {
    var n = parseValue(v);
    var a = this.value;

    if (a < 0 !== n.sign) {
      return this.subtract(n.negate());
    }

    var b = n.value;

    if (n.isSmall) {
      if (isPrecise(a + b)) return new SmallInteger(a + b);
      b = smallToArray(Math.abs(b));
    }

    return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
  };

  SmallInteger.prototype.plus = SmallInteger.prototype.add;

  NativeBigInt.prototype.add = function (v) {
    return new NativeBigInt(this.value + parseValue(v).value);
  };

  NativeBigInt.prototype.plus = NativeBigInt.prototype.add;

  function subtract(a, b) {
    var a_l = a.length,
        b_l = b.length,
        r = new Array(a_l),
        borrow = 0,
        base = BASE,
        i,
        difference;

    for (i = 0; i < b_l; i++) {
      difference = a[i] - borrow - b[i];

      if (difference < 0) {
        difference += base;
        borrow = 1;
      } else borrow = 0;

      r[i] = difference;
    }

    for (i = b_l; i < a_l; i++) {
      difference = a[i] - borrow;
      if (difference < 0) difference += base;else {
        r[i++] = difference;
        break;
      }
      r[i] = difference;
    }

    for (; i < a_l; i++) {
      r[i] = a[i];
    }

    trim(r);
    return r;
  }

  function subtractAny(a, b, sign) {
    var value;

    if (compareAbs(a, b) >= 0) {
      value = subtract(a, b);
    } else {
      value = subtract(b, a);
      sign = !sign;
    }

    value = arrayToSmall(value);

    if (typeof value === "number") {
      if (sign) value = -value;
      return new SmallInteger(value);
    }

    return new BigInteger(value, sign);
  }

  function subtractSmall(a, b, sign) {
    var l = a.length,
        r = new Array(l),
        carry = -b,
        base = BASE,
        i,
        difference;

    for (i = 0; i < l; i++) {
      difference = a[i] + carry;
      carry = Math.floor(difference / base);
      difference %= base;
      r[i] = difference < 0 ? difference + base : difference;
    }

    r = arrayToSmall(r);

    if (typeof r === "number") {
      if (sign) r = -r;
      return new SmallInteger(r);
    }

    return new BigInteger(r, sign);
  }

  BigInteger.prototype.subtract = function (v) {
    var n = parseValue(v);

    if (this.sign !== n.sign) {
      return this.add(n.negate());
    }

    var a = this.value,
        b = n.value;
    if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
    return subtractAny(a, b, this.sign);
  };

  BigInteger.prototype.minus = BigInteger.prototype.subtract;

  SmallInteger.prototype.subtract = function (v) {
    var n = parseValue(v);
    var a = this.value;

    if (a < 0 !== n.sign) {
      return this.add(n.negate());
    }

    var b = n.value;

    if (n.isSmall) {
      return new SmallInteger(a - b);
    }

    return subtractSmall(b, Math.abs(a), a >= 0);
  };

  SmallInteger.prototype.minus = SmallInteger.prototype.subtract;

  NativeBigInt.prototype.subtract = function (v) {
    return new NativeBigInt(this.value - parseValue(v).value);
  };

  NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;

  BigInteger.prototype.negate = function () {
    return new BigInteger(this.value, !this.sign);
  };

  SmallInteger.prototype.negate = function () {
    var sign = this.sign;
    var small = new SmallInteger(-this.value);
    small.sign = !sign;
    return small;
  };

  NativeBigInt.prototype.negate = function () {
    return new NativeBigInt(-this.value);
  };

  BigInteger.prototype.abs = function () {
    return new BigInteger(this.value, false);
  };

  SmallInteger.prototype.abs = function () {
    return new SmallInteger(Math.abs(this.value));
  };

  NativeBigInt.prototype.abs = function () {
    return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
  };

  function multiplyLong(a, b) {
    var a_l = a.length,
        b_l = b.length,
        l = a_l + b_l,
        r = createArray(l),
        base = BASE,
        product,
        carry,
        i,
        a_i,
        b_j;

    for (i = 0; i < a_l; ++i) {
      a_i = a[i];

      for (var j = 0; j < b_l; ++j) {
        b_j = b[j];
        product = a_i * b_j + r[i + j];
        carry = Math.floor(product / base);
        r[i + j] = product - carry * base;
        r[i + j + 1] += carry;
      }
    }

    trim(r);
    return r;
  }

  function multiplySmall(a, b) {
    var l = a.length,
        r = new Array(l),
        base = BASE,
        carry = 0,
        product,
        i;

    for (i = 0; i < l; i++) {
      product = a[i] * b + carry;
      carry = Math.floor(product / base);
      r[i] = product - carry * base;
    }

    while (carry > 0) {
      r[i++] = carry % base;
      carry = Math.floor(carry / base);
    }

    return r;
  }

  function shiftLeft(x, n) {
    var r = [];

    while (n-- > 0) {
      r.push(0);
    }

    return r.concat(x);
  }

  function multiplyKaratsuba(x, y) {
    var n = Math.max(x.length, y.length);
    if (n <= 30) return multiplyLong(x, y);
    n = Math.ceil(n / 2);
    var b = x.slice(n),
        a = x.slice(0, n),
        d = y.slice(n),
        c = y.slice(0, n);
    var ac = multiplyKaratsuba(a, c),
        bd = multiplyKaratsuba(b, d),
        abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
    var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
    trim(product);
    return product;
  }

  function useKaratsuba(l1, l2) {
    return -.012 * l1 - .012 * l2 + 15e-6 * l1 * l2 > 0;
  }

  BigInteger.prototype.multiply = function (v) {
    var n = parseValue(v),
        a = this.value,
        b = n.value,
        sign = this.sign !== n.sign,
        abs;

    if (n.isSmall) {
      if (b === 0) return Integer[0];
      if (b === 1) return this;
      if (b === -1) return this.negate();
      abs = Math.abs(b);

      if (abs < BASE) {
        return new BigInteger(multiplySmall(a, abs), sign);
      }

      b = smallToArray(abs);
    }

    if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
    return new BigInteger(multiplyLong(a, b), sign);
  };

  BigInteger.prototype.times = BigInteger.prototype.multiply;

  function multiplySmallAndArray(a, b, sign) {
    if (a < BASE) {
      return new BigInteger(multiplySmall(b, a), sign);
    }

    return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
  }

  SmallInteger.prototype._multiplyBySmall = function (a) {
    if (isPrecise(a.value * this.value)) {
      return new SmallInteger(a.value * this.value);
    }

    return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
  };

  BigInteger.prototype._multiplyBySmall = function (a) {
    if (a.value === 0) return Integer[0];
    if (a.value === 1) return this;
    if (a.value === -1) return this.negate();
    return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
  };

  SmallInteger.prototype.multiply = function (v) {
    return parseValue(v)._multiplyBySmall(this);
  };

  SmallInteger.prototype.times = SmallInteger.prototype.multiply;

  NativeBigInt.prototype.multiply = function (v) {
    return new NativeBigInt(this.value * parseValue(v).value);
  };

  NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;

  function square(a) {
    var l = a.length,
        r = createArray(l + l),
        base = BASE,
        product,
        carry,
        i,
        a_i,
        a_j;

    for (i = 0; i < l; i++) {
      a_i = a[i];
      carry = 0 - a_i * a_i;

      for (var j = i; j < l; j++) {
        a_j = a[j];
        product = 2 * (a_i * a_j) + r[i + j] + carry;
        carry = Math.floor(product / base);
        r[i + j] = product - carry * base;
      }

      r[i + l] = carry;
    }

    trim(r);
    return r;
  }

  BigInteger.prototype.square = function () {
    return new BigInteger(square(this.value), false);
  };

  SmallInteger.prototype.square = function () {
    var value = this.value * this.value;
    if (isPrecise(value)) return new SmallInteger(value);
    return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
  };

  NativeBigInt.prototype.square = function (v) {
    return new NativeBigInt(this.value * this.value);
  };

  function divMod1(a, b) {
    var a_l = a.length,
        b_l = b.length,
        base = BASE,
        result = createArray(b.length),
        divisorMostSignificantDigit = b[b_l - 1],
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)),
        remainder = multiplySmall(a, lambda),
        divisor = multiplySmall(b, lambda),
        quotientDigit,
        shift,
        carry,
        borrow,
        i,
        l,
        q;
    if (remainder.length <= a_l) remainder.push(0);
    divisor.push(0);
    divisorMostSignificantDigit = divisor[b_l - 1];

    for (shift = a_l - b_l; shift >= 0; shift--) {
      quotientDigit = base - 1;

      if (remainder[shift + b_l] !== divisorMostSignificantDigit) {
        quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
      }

      carry = 0;
      borrow = 0;
      l = divisor.length;

      for (i = 0; i < l; i++) {
        carry += quotientDigit * divisor[i];
        q = Math.floor(carry / base);
        borrow += remainder[shift + i] - (carry - q * base);
        carry = q;

        if (borrow < 0) {
          remainder[shift + i] = borrow + base;
          borrow = -1;
        } else {
          remainder[shift + i] = borrow;
          borrow = 0;
        }
      }

      while (borrow !== 0) {
        quotientDigit -= 1;
        carry = 0;

        for (i = 0; i < l; i++) {
          carry += remainder[shift + i] - base + divisor[i];

          if (carry < 0) {
            remainder[shift + i] = carry + base;
            carry = 0;
          } else {
            remainder[shift + i] = carry;
            carry = 1;
          }
        }

        borrow += carry;
      }

      result[shift] = quotientDigit;
    }

    remainder = divModSmall(remainder, lambda)[0];
    return [arrayToSmall(result), arrayToSmall(remainder)];
  }

  function divMod2(a, b) {
    var a_l = a.length,
        b_l = b.length,
        result = [],
        part = [],
        base = BASE,
        guess,
        xlen,
        highx,
        highy,
        check;

    while (a_l) {
      part.unshift(a[--a_l]);
      trim(part);

      if (compareAbs(part, b) < 0) {
        result.push(0);
        continue;
      }

      xlen = part.length;
      highx = part[xlen - 1] * base + part[xlen - 2];
      highy = b[b_l - 1] * base + b[b_l - 2];

      if (xlen > b_l) {
        highx = (highx + 1) * base;
      }

      guess = Math.ceil(highx / highy);

      do {
        check = multiplySmall(b, guess);
        if (compareAbs(check, part) <= 0) break;
        guess--;
      } while (guess);

      result.push(guess);
      part = subtract(part, check);
    }

    result.reverse();
    return [arrayToSmall(result), arrayToSmall(part)];
  }

  function divModSmall(value, lambda) {
    var length = value.length,
        quotient = createArray(length),
        base = BASE,
        i,
        q,
        remainder,
        divisor;
    remainder = 0;

    for (i = length - 1; i >= 0; --i) {
      divisor = remainder * base + value[i];
      q = truncate(divisor / lambda);
      remainder = divisor - q * lambda;
      quotient[i] = q | 0;
    }

    return [quotient, remainder | 0];
  }

  function divModAny(self, v) {
    var value,
        n = parseValue(v);

    if (supportsNativeBigInt) {
      return [new NativeBigInt(self.value / n.value), new NativeBigInt(self.value % n.value)];
    }

    var a = self.value,
        b = n.value;
    var quotient;
    if (b === 0) throw new Error("Cannot divide by zero");

    if (self.isSmall) {
      if (n.isSmall) {
        return [new SmallInteger(truncate(a / b)), new SmallInteger(a % b)];
      }

      return [Integer[0], self];
    }

    if (n.isSmall) {
      if (b === 1) return [self, Integer[0]];
      if (b == -1) return [self.negate(), Integer[0]];
      var abs = Math.abs(b);

      if (abs < BASE) {
        value = divModSmall(a, abs);
        quotient = arrayToSmall(value[0]);
        var remainder = value[1];
        if (self.sign) remainder = -remainder;

        if (typeof quotient === "number") {
          if (self.sign !== n.sign) quotient = -quotient;
          return [new SmallInteger(quotient), new SmallInteger(remainder)];
        }

        return [new BigInteger(quotient, self.sign !== n.sign), new SmallInteger(remainder)];
      }

      b = smallToArray(abs);
    }

    var comparison = compareAbs(a, b);
    if (comparison === -1) return [Integer[0], self];
    if (comparison === 0) return [Integer[self.sign === n.sign ? 1 : -1], Integer[0]];
    if (a.length + b.length <= 200) value = divMod1(a, b);else value = divMod2(a, b);
    quotient = value[0];
    var qSign = self.sign !== n.sign,
        mod = value[1],
        mSign = self.sign;

    if (typeof quotient === "number") {
      if (qSign) quotient = -quotient;
      quotient = new SmallInteger(quotient);
    } else quotient = new BigInteger(quotient, qSign);

    if (typeof mod === "number") {
      if (mSign) mod = -mod;
      mod = new SmallInteger(mod);
    } else mod = new BigInteger(mod, mSign);

    return [quotient, mod];
  }

  BigInteger.prototype.divmod = function (v) {
    var result = divModAny(this, v);
    return {
      quotient: result[0],
      remainder: result[1]
    };
  };

  NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;

  BigInteger.prototype.divide = function (v) {
    return divModAny(this, v)[0];
  };

  NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function (v) {
    return new NativeBigInt(this.value / parseValue(v).value);
  };

  SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;

  BigInteger.prototype.mod = function (v) {
    return divModAny(this, v)[1];
  };

  NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function (v) {
    return new NativeBigInt(this.value % parseValue(v).value);
  };

  SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;

  BigInteger.prototype.pow = function (v) {
    var n = parseValue(v),
        a = this.value,
        b = n.value,
        value,
        x,
        y;
    if (b === 0) return Integer[1];
    if (a === 0) return Integer[0];
    if (a === 1) return Integer[1];
    if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];

    if (n.sign) {
      return Integer[0];
    }

    if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");

    if (this.isSmall) {
      if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
    }

    x = this;
    y = Integer[1];

    while (true) {
      if (b & 1 === 1) {
        y = y.times(x);
        --b;
      }

      if (b === 0) break;
      b /= 2;
      x = x.square();
    }

    return y;
  };

  SmallInteger.prototype.pow = BigInteger.prototype.pow;

  NativeBigInt.prototype.pow = function (v) {
    var n = parseValue(v);
    var a = this.value,
        b = n.value;

    var _0 = BigInt(0),
        _1 = BigInt(1),
        _2 = BigInt(2);

    if (b === _0) return Integer[1];
    if (a === _0) return Integer[0];
    if (a === _1) return Integer[1];
    if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
    if (n.isNegative()) return new NativeBigInt(_0);
    var x = this;
    var y = Integer[1];

    while (true) {
      if ((b & _1) === _1) {
        y = y.times(x);
        --b;
      }

      if (b === _0) break;
      b /= _2;
      x = x.square();
    }

    return y;
  };

  BigInteger.prototype.modPow = function (exp, mod) {
    exp = parseValue(exp);
    mod = parseValue(mod);
    if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
    var r = Integer[1],
        base = this.mod(mod);

    while (exp.isPositive()) {
      if (base.isZero()) return Integer[0];
      if (exp.isOdd()) r = r.multiply(base).mod(mod);
      exp = exp.divide(2);
      base = base.square().mod(mod);
    }

    return r;
  };

  NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;

  function compareAbs(a, b) {
    if (a.length !== b.length) {
      return a.length > b.length ? 1 : -1;
    }

    for (var i = a.length - 1; i >= 0; i--) {
      if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
    }

    return 0;
  }

  BigInteger.prototype.compareAbs = function (v) {
    var n = parseValue(v),
        a = this.value,
        b = n.value;
    if (n.isSmall) return 1;
    return compareAbs(a, b);
  };

  SmallInteger.prototype.compareAbs = function (v) {
    var n = parseValue(v),
        a = Math.abs(this.value),
        b = n.value;

    if (n.isSmall) {
      b = Math.abs(b);
      return a === b ? 0 : a > b ? 1 : -1;
    }

    return -1;
  };

  NativeBigInt.prototype.compareAbs = function (v) {
    var a = this.value;
    var b = parseValue(v).value;
    a = a >= 0 ? a : -a;
    b = b >= 0 ? b : -b;
    return a === b ? 0 : a > b ? 1 : -1;
  };

  BigInteger.prototype.compare = function (v) {
    if (v === Infinity) {
      return -1;
    }

    if (v === -Infinity) {
      return 1;
    }

    var n = parseValue(v),
        a = this.value,
        b = n.value;

    if (this.sign !== n.sign) {
      return n.sign ? 1 : -1;
    }

    if (n.isSmall) {
      return this.sign ? -1 : 1;
    }

    return compareAbs(a, b) * (this.sign ? -1 : 1);
  };

  BigInteger.prototype.compareTo = BigInteger.prototype.compare;

  SmallInteger.prototype.compare = function (v) {
    if (v === Infinity) {
      return -1;
    }

    if (v === -Infinity) {
      return 1;
    }

    var n = parseValue(v),
        a = this.value,
        b = n.value;

    if (n.isSmall) {
      return a == b ? 0 : a > b ? 1 : -1;
    }

    if (a < 0 !== n.sign) {
      return a < 0 ? -1 : 1;
    }

    return a < 0 ? 1 : -1;
  };

  SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;

  NativeBigInt.prototype.compare = function (v) {
    if (v === Infinity) {
      return -1;
    }

    if (v === -Infinity) {
      return 1;
    }

    var a = this.value;
    var b = parseValue(v).value;
    return a === b ? 0 : a > b ? 1 : -1;
  };

  NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;

  BigInteger.prototype.equals = function (v) {
    return this.compare(v) === 0;
  };

  NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;

  BigInteger.prototype.notEquals = function (v) {
    return this.compare(v) !== 0;
  };

  NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;

  BigInteger.prototype.greater = function (v) {
    return this.compare(v) > 0;
  };

  NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;

  BigInteger.prototype.lesser = function (v) {
    return this.compare(v) < 0;
  };

  NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;

  BigInteger.prototype.greaterOrEquals = function (v) {
    return this.compare(v) >= 0;
  };

  NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;

  BigInteger.prototype.lesserOrEquals = function (v) {
    return this.compare(v) <= 0;
  };

  NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;

  BigInteger.prototype.isEven = function () {
    return (this.value[0] & 1) === 0;
  };

  SmallInteger.prototype.isEven = function () {
    return (this.value & 1) === 0;
  };

  NativeBigInt.prototype.isEven = function () {
    return (this.value & BigInt(1)) === BigInt(0);
  };

  BigInteger.prototype.isOdd = function () {
    return (this.value[0] & 1) === 1;
  };

  SmallInteger.prototype.isOdd = function () {
    return (this.value & 1) === 1;
  };

  NativeBigInt.prototype.isOdd = function () {
    return (this.value & BigInt(1)) === BigInt(1);
  };

  BigInteger.prototype.isPositive = function () {
    return !this.sign;
  };

  SmallInteger.prototype.isPositive = function () {
    return this.value > 0;
  };

  NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;

  BigInteger.prototype.isNegative = function () {
    return this.sign;
  };

  SmallInteger.prototype.isNegative = function () {
    return this.value < 0;
  };

  NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;

  BigInteger.prototype.isUnit = function () {
    return false;
  };

  SmallInteger.prototype.isUnit = function () {
    return Math.abs(this.value) === 1;
  };

  NativeBigInt.prototype.isUnit = function () {
    return this.abs().value === BigInt(1);
  };

  BigInteger.prototype.isZero = function () {
    return false;
  };

  SmallInteger.prototype.isZero = function () {
    return this.value === 0;
  };

  NativeBigInt.prototype.isZero = function () {
    return this.value === BigInt(0);
  };

  BigInteger.prototype.isDivisibleBy = function (v) {
    var n = parseValue(v);
    if (n.isZero()) return false;
    if (n.isUnit()) return true;
    if (n.compareAbs(2) === 0) return this.isEven();
    return this.mod(n).isZero();
  };

  NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;

  function isBasicPrime(v) {
    var n = v.abs();
    if (n.isUnit()) return false;
    if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
    if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
    if (n.lesser(49)) return true;
  }

  function millerRabinTest(n, a) {
    var nPrev = n.prev(),
        b = nPrev,
        r = 0,
        d,
        t,
        i,
        x;

    while (b.isEven()) {
      b = b.divide(2), r++;
    }

    next: for (i = 0; i < a.length; i++) {
      if (n.lesser(a[i])) continue;
      x = bigInt(a[i]).modPow(b, n);
      if (x.isUnit() || x.equals(nPrev)) continue;

      for (d = r - 1; d != 0; d--) {
        x = x.square().mod(n);
        if (x.isUnit()) return false;
        if (x.equals(nPrev)) continue next;
      }

      return false;
    }

    return true;
  }

  BigInteger.prototype.isPrime = function (strict) {
    var isPrime = isBasicPrime(this);
    if (isPrime !== undefined) return isPrime;
    var n = this.abs();
    var bits = n.bitLength();
    if (bits <= 64) return millerRabinTest(n, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
    var logN = Math.log(2) * bits.toJSNumber();
    var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);

    for (var a = [], i = 0; i < t; i++) {
      a.push(bigInt(i + 2));
    }

    return millerRabinTest(n, a);
  };

  NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;

  BigInteger.prototype.isProbablePrime = function (iterations) {
    var isPrime = isBasicPrime(this);
    if (isPrime !== undefined) return isPrime;
    var n = this.abs();
    var t = iterations === undefined ? 5 : iterations;

    for (var a = [], i = 0; i < t; i++) {
      a.push(bigInt.randBetween(2, n.minus(2)));
    }

    return millerRabinTest(n, a);
  };

  NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;

  BigInteger.prototype.modInv = function (n) {
    var t = bigInt.zero,
        newT = bigInt.one,
        r = parseValue(n),
        newR = this.abs(),
        q,
        lastT,
        lastR;

    while (!newR.isZero()) {
      q = r.divide(newR);
      lastT = t;
      lastR = r;
      t = newT;
      r = newR;
      newT = lastT.subtract(q.multiply(newT));
      newR = lastR.subtract(q.multiply(newR));
    }

    if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");

    if (t.compare(0) === -1) {
      t = t.add(n);
    }

    if (this.isNegative()) {
      return t.negate();
    }

    return t;
  };

  NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;

  BigInteger.prototype.next = function () {
    var value = this.value;

    if (this.sign) {
      return subtractSmall(value, 1, this.sign);
    }

    return new BigInteger(addSmall(value, 1), this.sign);
  };

  SmallInteger.prototype.next = function () {
    var value = this.value;
    if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
    return new BigInteger(MAX_INT_ARR, false);
  };

  NativeBigInt.prototype.next = function () {
    return new NativeBigInt(this.value + BigInt(1));
  };

  BigInteger.prototype.prev = function () {
    var value = this.value;

    if (this.sign) {
      return new BigInteger(addSmall(value, 1), true);
    }

    return subtractSmall(value, 1, this.sign);
  };

  SmallInteger.prototype.prev = function () {
    var value = this.value;
    if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
    return new BigInteger(MAX_INT_ARR, true);
  };

  NativeBigInt.prototype.prev = function () {
    return new NativeBigInt(this.value - BigInt(1));
  };

  var powersOfTwo = [1];

  while (2 * powersOfTwo[powersOfTwo.length - 1] <= BASE) {
    powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
  }

  var powers2Length = powersOfTwo.length,
      highestPower2 = powersOfTwo[powers2Length - 1];

  function shift_isSmall(n) {
    return Math.abs(n) <= BASE;
  }

  BigInteger.prototype.shiftLeft = function (v) {
    var n = parseValue(v).toJSNumber();

    if (!shift_isSmall(n)) {
      throw new Error(String(n) + " is too large for shifting.");
    }

    if (n < 0) return this.shiftRight(-n);
    var result = this;
    if (result.isZero()) return result;

    while (n >= powers2Length) {
      result = result.multiply(highestPower2);
      n -= powers2Length - 1;
    }

    return result.multiply(powersOfTwo[n]);
  };

  NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;

  BigInteger.prototype.shiftRight = function (v) {
    var remQuo;
    var n = parseValue(v).toJSNumber();

    if (!shift_isSmall(n)) {
      throw new Error(String(n) + " is too large for shifting.");
    }

    if (n < 0) return this.shiftLeft(-n);
    var result = this;

    while (n >= powers2Length) {
      if (result.isZero() || result.isNegative() && result.isUnit()) return result;
      remQuo = divModAny(result, highestPower2);
      result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
      n -= powers2Length - 1;
    }

    remQuo = divModAny(result, powersOfTwo[n]);
    return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
  };

  NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;

  function bitwise(x, y, fn) {
    y = parseValue(y);
    var xSign = x.isNegative(),
        ySign = y.isNegative();
    var xRem = xSign ? x.not() : x,
        yRem = ySign ? y.not() : y;
    var xDigit = 0,
        yDigit = 0;
    var xDivMod = null,
        yDivMod = null;
    var result = [];

    while (!xRem.isZero() || !yRem.isZero()) {
      xDivMod = divModAny(xRem, highestPower2);
      xDigit = xDivMod[1].toJSNumber();

      if (xSign) {
        xDigit = highestPower2 - 1 - xDigit;
      }

      yDivMod = divModAny(yRem, highestPower2);
      yDigit = yDivMod[1].toJSNumber();

      if (ySign) {
        yDigit = highestPower2 - 1 - yDigit;
      }

      xRem = xDivMod[0];
      yRem = yDivMod[0];
      result.push(fn(xDigit, yDigit));
    }

    var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);

    for (var i = result.length - 1; i >= 0; i -= 1) {
      sum = sum.multiply(highestPower2).add(bigInt(result[i]));
    }

    return sum;
  }

  BigInteger.prototype.not = function () {
    return this.negate().prev();
  };

  NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;

  BigInteger.prototype.and = function (n) {
    return bitwise(this, n, function (a, b) {
      return a & b;
    });
  };

  NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;

  BigInteger.prototype.or = function (n) {
    return bitwise(this, n, function (a, b) {
      return a | b;
    });
  };

  NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;

  BigInteger.prototype.xor = function (n) {
    return bitwise(this, n, function (a, b) {
      return a ^ b;
    });
  };

  NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
  var LOBMASK_I = 1 << 30,
      LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;

  function roughLOB(n) {
    var v = n.value,
        x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
    return x & -x;
  }

  function integerLogarithm(value, base) {
    if (base.compareTo(value) <= 0) {
      var tmp = integerLogarithm(value, base.square(base));
      var p = tmp.p;
      var e = tmp.e;
      var t = p.multiply(base);
      return t.compareTo(value) <= 0 ? {
        p: t,
        e: e * 2 + 1
      } : {
        p: p,
        e: e * 2
      };
    }

    return {
      p: bigInt(1),
      e: 0
    };
  }

  BigInteger.prototype.bitLength = function () {
    var n = this;

    if (n.compareTo(bigInt(0)) < 0) {
      n = n.negate().subtract(bigInt(1));
    }

    if (n.compareTo(bigInt(0)) === 0) {
      return bigInt(0);
    }

    return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
  };

  NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;

  function max(a, b) {
    a = parseValue(a);
    b = parseValue(b);
    return a.greater(b) ? a : b;
  }

  function min(a, b) {
    a = parseValue(a);
    b = parseValue(b);
    return a.lesser(b) ? a : b;
  }

  function gcd(a, b) {
    a = parseValue(a).abs();
    b = parseValue(b).abs();
    if (a.equals(b)) return a;
    if (a.isZero()) return b;
    if (b.isZero()) return a;
    var c = Integer[1],
        d,
        t;

    while (a.isEven() && b.isEven()) {
      d = min(roughLOB(a), roughLOB(b));
      a = a.divide(d);
      b = b.divide(d);
      c = c.multiply(d);
    }

    while (a.isEven()) {
      a = a.divide(roughLOB(a));
    }

    do {
      while (b.isEven()) {
        b = b.divide(roughLOB(b));
      }

      if (a.greater(b)) {
        t = b;
        b = a;
        a = t;
      }

      b = b.subtract(a);
    } while (!b.isZero());

    return c.isUnit() ? a : a.multiply(c);
  }

  function lcm(a, b) {
    a = parseValue(a).abs();
    b = parseValue(b).abs();
    return a.divide(gcd(a, b)).multiply(b);
  }

  function randBetween(a, b) {
    a = parseValue(a);
    b = parseValue(b);
    var low = min(a, b),
        high = max(a, b);
    var range = high.subtract(low).add(1);
    if (range.isSmall) return low.add(Math.floor(Math.random() * range));
    var digits = toBase(range, BASE).value;
    var result = [],
        restricted = true;

    for (var i = 0; i < digits.length; i++) {
      var top = restricted ? digits[i] : BASE;
      var digit = truncate(Math.random() * top);
      result.push(digit);
      if (digit < top) restricted = false;
    }

    return low.add(Integer.fromArray(result, BASE, false));
  }

  var parseBase = function parseBase(text, base, alphabet, caseSensitive) {
    alphabet = alphabet || DEFAULT_ALPHABET;
    text = String(text);

    if (!caseSensitive) {
      text = text.toLowerCase();
      alphabet = alphabet.toLowerCase();
    }

    var length = text.length;
    var i;
    var absBase = Math.abs(base);
    var alphabetValues = {};

    for (i = 0; i < alphabet.length; i++) {
      alphabetValues[alphabet[i]] = i;
    }

    for (i = 0; i < length; i++) {
      var c = text[i];
      if (c === "-") continue;

      if (c in alphabetValues) {
        if (alphabetValues[c] >= absBase) {
          if (c === "1" && absBase === 1) continue;
          throw new Error(c + " is not a valid digit in base " + base + ".");
        }
      }
    }

    base = parseValue(base);
    var digits = [];
    var isNegative = text[0] === "-";

    for (i = isNegative ? 1 : 0; i < text.length; i++) {
      var c = text[i];
      if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));else if (c === "<") {
        var start = i;

        do {
          i++;
        } while (text[i] !== ">" && i < text.length);

        digits.push(parseValue(text.slice(start + 1, i)));
      } else throw new Error(c + " is not a valid character");
    }

    return parseBaseFromArray(digits, base, isNegative);
  };

  function parseBaseFromArray(digits, base, isNegative) {
    var val = Integer[0],
        pow = Integer[1],
        i;

    for (i = digits.length - 1; i >= 0; i--) {
      val = val.add(digits[i].times(pow));
      pow = pow.times(base);
    }

    return isNegative ? val.negate() : val;
  }

  function stringify(digit, alphabet) {
    alphabet = alphabet || DEFAULT_ALPHABET;

    if (digit < alphabet.length) {
      return alphabet[digit];
    }

    return "<" + digit + ">";
  }

  function toBase(n, base) {
    base = bigInt(base);

    if (base.isZero()) {
      if (n.isZero()) return {
        value: [0],
        isNegative: false
      };
      throw new Error("Cannot convert nonzero numbers to base 0.");
    }

    if (base.equals(-1)) {
      if (n.isZero()) return {
        value: [0],
        isNegative: false
      };
      if (n.isNegative()) return {
        value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [1, 0])),
        isNegative: false
      };
      var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
      arr.unshift([1]);
      return {
        value: [].concat.apply([], arr),
        isNegative: false
      };
    }

    var neg = false;

    if (n.isNegative() && base.isPositive()) {
      neg = true;
      n = n.abs();
    }

    if (base.isUnit()) {
      if (n.isZero()) return {
        value: [0],
        isNegative: false
      };
      return {
        value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
        isNegative: neg
      };
    }

    var out = [];
    var left = n,
        divmod;

    while (left.isNegative() || left.compareAbs(base) >= 0) {
      divmod = left.divmod(base);
      left = divmod.quotient;
      var digit = divmod.remainder;

      if (digit.isNegative()) {
        digit = base.minus(digit).abs();
        left = left.next();
      }

      out.push(digit.toJSNumber());
    }

    out.push(left.toJSNumber());
    return {
      value: out.reverse(),
      isNegative: neg
    };
  }

  function toBaseString(n, base, alphabet) {
    var arr = toBase(n, base);
    return (arr.isNegative ? "-" : "") + arr.value.map(function (x) {
      return stringify(x, alphabet);
    }).join("");
  }

  BigInteger.prototype.toArray = function (radix) {
    return toBase(this, radix);
  };

  SmallInteger.prototype.toArray = function (radix) {
    return toBase(this, radix);
  };

  NativeBigInt.prototype.toArray = function (radix) {
    return toBase(this, radix);
  };

  BigInteger.prototype.toString = function (radix, alphabet) {
    if (radix === undefined) radix = 10;
    if (radix !== 10) return toBaseString(this, radix, alphabet);
    var v = this.value,
        l = v.length,
        str = String(v[--l]),
        zeros = "0000000",
        digit;

    while (--l >= 0) {
      digit = String(v[l]);
      str += zeros.slice(digit.length) + digit;
    }

    var sign = this.sign ? "-" : "";
    return sign + str;
  };

  SmallInteger.prototype.toString = function (radix, alphabet) {
    if (radix === undefined) radix = 10;
    if (radix != 10) return toBaseString(this, radix, alphabet);
    return String(this.value);
  };

  NativeBigInt.prototype.toString = SmallInteger.prototype.toString;

  NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function () {
    return this.toString();
  };

  BigInteger.prototype.valueOf = function () {
    return parseInt(this.toString(), 10);
  };

  BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;

  SmallInteger.prototype.valueOf = function () {
    return this.value;
  };

  SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;

  NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function () {
    return parseInt(this.toString(), 10);
  };

  function parseStringValue(v) {
    if (isPrecise(+v)) {
      var x = +v;
      if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
      throw new Error("Invalid integer: " + v);
    }

    var sign = v[0] === "-";
    if (sign) v = v.slice(1);
    var split = v.split(/e/i);
    if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));

    if (split.length === 2) {
      var exp = split[1];
      if (exp[0] === "+") exp = exp.slice(1);
      exp = +exp;
      if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
      var text = split[0];
      var decimalPlace = text.indexOf(".");

      if (decimalPlace >= 0) {
        exp -= text.length - decimalPlace - 1;
        text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
      }

      if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
      text += new Array(exp + 1).join("0");
      v = text;
    }

    var isValid = /^([0-9][0-9]*)$/.test(v);
    if (!isValid) throw new Error("Invalid integer: " + v);

    if (supportsNativeBigInt) {
      return new NativeBigInt(BigInt(sign ? "-" + v : v));
    }

    var r = [],
        max = v.length,
        l = LOG_BASE,
        min = max - l;

    while (max > 0) {
      r.push(+v.slice(min, max));
      min -= l;
      if (min < 0) min = 0;
      max -= l;
    }

    trim(r);
    return new BigInteger(r, sign);
  }

  function parseNumberValue(v) {
    if (supportsNativeBigInt) {
      return new NativeBigInt(BigInt(v));
    }

    if (isPrecise(v)) {
      if (v !== truncate(v)) throw new Error(v + " is not an integer.");
      return new SmallInteger(v);
    }

    return parseStringValue(v.toString());
  }

  function parseValue(v) {
    if (typeof v === "number") {
      return parseNumberValue(v);
    }

    if (typeof v === "string") {
      return parseStringValue(v);
    }

    if (typeof v === "bigint") {
      return new NativeBigInt(v);
    }

    return v;
  }

  for (var i = 0; i < 1e3; i++) {
    Integer[i] = parseValue(i);
    if (i > 0) Integer[-i] = parseValue(-i);
  }

  Integer.one = Integer[1];
  Integer.zero = Integer[0];
  Integer.minusOne = Integer[-1];
  Integer.max = max;
  Integer.min = min;
  Integer.gcd = gcd;
  Integer.lcm = lcm;

  Integer.isInstance = function (x) {
    return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
  };

  Integer.randBetween = randBetween;

  Integer.fromArray = function (digits, base, isNegative) {
    return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
  };

  return Integer;
}();

if (  true && module.hasOwnProperty("exports")) {
  module.exports = bigInt;
}

if (true) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return bigInt;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_4304__(/*! ./../node_modules/webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/core/errors/ErrorsBase.js":
/*!***************************************!*\
  !*** ./src/core/errors/ErrorsBase.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_52167__) {

"use strict";
__nested_webpack_require_52167__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var ErrorsBase = /*#__PURE__*/function () {
  function ErrorsBase() {
    _classCallCheck(this, ErrorsBase);
  }

  _createClass(ErrorsBase, [{
    key: "extend",
    value: function extend(errors, config) {
      if (!errors) return;
      var override = config ? config.override : false;
      var publicOnly = config ? config.publicOnly : false;

      for (var err in errors) {
        if (!errors.hasOwnProperty(err) || this[err] && !override) continue;
        if (publicOnly && errors[err].indexOf('public_') === -1) continue;
        this[err] = errors[err];
      }
    }
  }]);

  return ErrorsBase;
}();

/* harmony default export */ __webpack_exports__["default"] = (ErrorsBase);

/***/ }),

/***/ "./src/core/events/EventsBase.js":
/*!***************************************!*\
  !*** ./src/core/events/EventsBase.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_55838__) {

"use strict";
__nested_webpack_require_55838__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var EventsBase = /*#__PURE__*/function () {
  function EventsBase() {
    _classCallCheck(this, EventsBase);
  }

  _createClass(EventsBase, [{
    key: "extend",
    value: function extend(events, config) {
      if (!events) return;
      var override = config ? config.override : false;
      var publicOnly = config ? config.publicOnly : false;

      for (var evt in events) {
        if (!events.hasOwnProperty(evt) || this[evt] && !override) continue;
        if (publicOnly && events[evt].indexOf('public_') === -1) continue;
        this[evt] = events[evt];
      }
    }
  }]);

  return EventsBase;
}();

/* harmony default export */ __webpack_exports__["default"] = (EventsBase);

/***/ }),

/***/ "./src/mss/MssFragmentInfoController.js":
/*!**********************************************!*\
  !*** ./src/mss/MssFragmentInfoController.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_59537__) {

"use strict";
__nested_webpack_require_59537__.r(__webpack_exports__);
/* harmony import */ var _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_59537__(/*! ../streaming/vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_59537__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



function MssFragmentInfoController(config) {
  config = config || {};
  var instance, logger, fragmentModel, started, type, loadFragmentTimeout, startTime, startFragmentTime, index;
  var streamProcessor = config.streamProcessor;
  var baseURLController = config.baseURLController;
  var debug = config.debug;
  var controllerType = 'MssFragmentInfoController';

  function setup() {
    logger = debug.getLogger(instance);
  }

  function initialize() {
    type = streamProcessor.getType();
    fragmentModel = streamProcessor.getFragmentModel();
    started = false;
    startTime = null;
    startFragmentTime = null;
  }

  function start() {
    if (started) return;
    logger.debug('Start');
    started = true;
    index = 0;
    loadNextFragmentInfo();
  }

  function stop() {
    if (!started) return;
    logger.debug('Stop');
    clearTimeout(loadFragmentTimeout);
    started = false;
    startTime = null;
    startFragmentTime = null;
  }

  function reset() {
    stop();
  }

  function loadNextFragmentInfo() {
    if (!started) return; // Get last segment from SegmentTimeline

    var representation = getCurrentRepresentation();
    var manifest = representation.adaptation.period.mpd.manifest;
    var adaptation = manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index];
    var segments = adaptation.SegmentTemplate.SegmentTimeline.S_asArray;
    var segment = segments[segments.length - 1]; // logger.debug('Last fragment time: ' + (segment.t / adaptation.SegmentTemplate.timescale));
    // Generate segment request

    var request = getRequestForSegment(adaptation, representation, segment); // Send segment request

    requestFragment.call(this, request);
  }

  function getRequestForSegment(adaptation, representation, segment) {
    var timescale = adaptation.SegmentTemplate.timescale;
    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_0__["default"]();
    request.mediaType = type;
    request.type = _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_1__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE; // request.range = segment.mediaRange;

    request.startTime = segment.t / timescale;
    request.duration = segment.d / timescale;
    request.timescale = timescale; // request.availabilityStartTime = segment.availabilityStartTime;
    // request.availabilityEndTime = segment.availabilityEndTime;
    // request.wallStartTime = segment.wallStartTime;

    request.quality = representation.index;
    request.index = index++;
    request.mediaInfo = streamProcessor.getMediaInfo();
    request.adaptationIndex = representation.adaptation.index;
    request.representationId = representation.id;
    request.url = baseURLController.resolve(representation.path).url + adaptation.SegmentTemplate.media;
    request.url = request.url.replace('$Bandwidth$', representation.bandwidth);
    request.url = request.url.replace('$Time$', segment.tManifest ? segment.tManifest : segment.t);
    request.url = request.url.replace('/Fragments(', '/FragmentInfo(');
    return request;
  }

  function getCurrentRepresentation() {
    var representationController = streamProcessor.getRepresentationController();
    var representation = representationController.getCurrentRepresentation();
    return representation;
  }

  function requestFragment(request) {
    // logger.debug('Load FragmentInfo for time: ' + request.startTime);
    if (streamProcessor.getFragmentModel().isFragmentLoadedOrPending(request)) {
      // We may have reached end of timeline in case of start-over streams
      logger.debug('End of timeline');
      stop();
      return;
    }

    fragmentModel.executeRequest(request);
  }

  function fragmentInfoLoaded(e) {
    if (!started) return;
    var request = e.request;

    if (!e.response) {
      logger.error('Load error', request.url);
      return;
    }

    var deltaFragmentTime, deltaTime, delay; // logger.debug('FragmentInfo loaded: ', request.url);

    if (startTime === null) {
      startTime = new Date().getTime();
    }

    if (!startFragmentTime) {
      startFragmentTime = request.startTime;
    } // Determine delay before requesting next FragmentInfo


    deltaTime = (new Date().getTime() - startTime) / 1000;
    deltaFragmentTime = request.startTime + request.duration - startFragmentTime;
    delay = Math.max(0, deltaFragmentTime - deltaTime); // Set timeout for requesting next FragmentInfo

    clearTimeout(loadFragmentTimeout);
    loadFragmentTimeout = setTimeout(function () {
      loadFragmentTimeout = null;
      loadNextFragmentInfo();
    }, delay * 1000);
  }

  function getType() {
    return type;
  }

  instance = {
    initialize: initialize,
    controllerType: controllerType,
    start: start,
    fragmentInfoLoaded: fragmentInfoLoaded,
    getType: getType,
    reset: reset
  };
  setup();
  return instance;
}

MssFragmentInfoController.__dashjs_factory_name = 'MssFragmentInfoController';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MssFragmentInfoController));
/* jshint ignore:line */

/***/ }),

/***/ "./src/mss/MssFragmentMoofProcessor.js":
/*!*********************************************!*\
  !*** ./src/mss/MssFragmentMoofProcessor.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_67485__) {

"use strict";
__nested_webpack_require_67485__.r(__webpack_exports__);
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_67485__(/*! ../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _errors_MssErrors__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_67485__(/*! ./errors/MssErrors */ "./src/mss/errors/MssErrors.js");
/* harmony import */ var _streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_67485__(/*! ../streaming/MediaPlayerEvents */ "./src/streaming/MediaPlayerEvents.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



/**
 * @module MssFragmentMoofProcessor
 * @ignore
 * @param {Object} config object
 */

function MssFragmentMoofProcessor(config) {
  config = config || {};
  var instance, type, logger;
  var dashMetrics = config.dashMetrics;
  var playbackController = config.playbackController;
  var errorHandler = config.errHandler;
  var eventBus = config.eventBus;
  var ISOBoxer = config.ISOBoxer;
  var debug = config.debug;

  function setup() {
    logger = debug.getLogger(instance);
    type = '';
  }

  function processTfrf(request, tfrf, tfdt, streamProcessor) {
    var representationController = streamProcessor.getRepresentationController();
    var representation = representationController.getCurrentRepresentation();
    var manifest = representation.adaptation.period.mpd.manifest;
    var adaptation = manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index];
    var timescale = adaptation.SegmentTemplate.timescale;
    type = streamProcessor.getType(); // Process tfrf only for live streams or start-over static streams (timeShiftBufferDepth > 0)

    if (manifest.type !== 'dynamic' && !manifest.timeShiftBufferDepth) {
      return;
    }

    if (!tfrf) {
      errorHandler.error(new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_0__["default"](_errors_MssErrors__WEBPACK_IMPORTED_MODULE_1__["default"].MSS_NO_TFRF_CODE, _errors_MssErrors__WEBPACK_IMPORTED_MODULE_1__["default"].MSS_NO_TFRF_MESSAGE));
      return;
    } // Get adaptation's segment timeline (always a SegmentTimeline in Smooth Streaming use case)


    var segments = adaptation.SegmentTemplate.SegmentTimeline.S;
    var entries = tfrf.entry;
    var entry, segmentTime, range;
    var segment = null;
    var t = 0;
    var endTime;
    var availabilityStartTime = null;

    if (entries.length === 0) {
      return;
    } // Consider only first tfrf entry (to avoid pre-condition failure on fragment info requests)


    entry = entries[0]; // In case of start-over streams, check if we have reached end of original manifest duration (set in timeShiftBufferDepth)
    // => then do not update anymore timeline

    if (manifest.type === 'static') {
      // Get first segment time
      segmentTime = segments[0].tManifest ? parseFloat(segments[0].tManifest) : segments[0].t;

      if (entry.fragment_absolute_time > segmentTime + manifest.timeShiftBufferDepth * timescale) {
        return;
      }
    } // logger.debug('entry - t = ', (entry.fragment_absolute_time / timescale));
    // Get last segment time


    segmentTime = segments[segments.length - 1].tManifest ? parseFloat(segments[segments.length - 1].tManifest) : segments[segments.length - 1].t; // logger.debug('Last segment - t = ', (segmentTime / timescale));
    // Check if we have to append new segment to timeline

    if (entry.fragment_absolute_time <= segmentTime) {
      // Update DVR window range => set range end to end time of current segment
      range = {
        start: segments[0].t / timescale,
        end: tfdt.baseMediaDecodeTime / timescale + request.duration
      };
      updateDVR(request.mediaType, range, streamProcessor.getStreamInfo().manifestInfo);
      return;
    } // logger.debug('Add new segment - t = ', (entry.fragment_absolute_time / timescale));


    segment = {};
    segment.t = entry.fragment_absolute_time;
    segment.d = entry.fragment_duration; // If timestamps starts at 0 relative to 1st segment (dynamic to static) then update segment time

    if (segments[0].tManifest) {
      segment.t -= parseFloat(segments[0].tManifest) - segments[0].t;
      segment.tManifest = entry.fragment_absolute_time;
    } // Patch previous segment duration


    var lastSegment = segments[segments.length - 1];

    if (lastSegment.t + lastSegment.d !== segment.t) {
      logger.debug('Patch segment duration - t = ', lastSegment.t + ', d = ' + lastSegment.d + ' => ' + (segment.t - lastSegment.t));
      lastSegment.d = segment.t - lastSegment.t;
    }

    segments.push(segment); // In case of static start-over streams, update content duration

    if (manifest.type === 'static') {
      if (type === 'video') {
        segment = segments[segments.length - 1];
        endTime = (segment.t + segment.d) / timescale;

        if (endTime > representation.adaptation.period.duration) {
          eventBus.trigger(_streaming_MediaPlayerEvents__WEBPACK_IMPORTED_MODULE_2__["default"].MANIFEST_VALIDITY_CHANGED, {
            sender: this,
            newDuration: endTime
          });
        }
      }

      return;
    } else {
      // In case of live streams, update segment timeline according to DVR window
      if (manifest.timeShiftBufferDepth && manifest.timeShiftBufferDepth > 0) {
        // Get timestamp of the last segment
        segment = segments[segments.length - 1];
        t = segment.t; // Determine the segments' availability start time

        availabilityStartTime = (t - manifest.timeShiftBufferDepth * timescale) / timescale; // Remove segments prior to availability start time

        segment = segments[0];
        endTime = (segment.t + segment.d) / timescale;

        while (endTime < availabilityStartTime) {
          // Check if not currently playing the segment to be removed
          if (!playbackController.isPaused() && playbackController.getTime() < endTime) {
            break;
          } // logger.debug('Remove segment  - t = ' + (segment.t / timescale));


          segments.splice(0, 1);
          segment = segments[0];
          endTime = (segment.t + segment.d) / timescale;
        }
      } // Update DVR window range => set range end to end time of current segment


      range = {
        start: segments[0].t / timescale,
        end: tfdt.baseMediaDecodeTime / timescale + request.duration
      };
      updateDVR(type, range, streamProcessor.getStreamInfo().manifestInfo);
    }
  }

  function updateDVR(type, range, manifestInfo) {
    if (type !== 'video' && type !== 'audio') return;
    var dvrInfos = dashMetrics.getCurrentDVRInfo(type);

    if (!dvrInfos || range.end > dvrInfos.range.end) {
      logger.debug('Update DVR range: [' + range.start + ' - ' + range.end + ']');
      dashMetrics.addDVRInfo(type, playbackController.getTime(), manifestInfo, range);
      playbackController.updateCurrentTime(type);
    }
  } // This function returns the offset of the 1st byte of a child box within a container box


  function getBoxOffset(parent, type) {
    var offset = 8;
    var i = 0;

    for (i = 0; i < parent.boxes.length; i++) {
      if (parent.boxes[i].type === type) {
        return offset;
      }

      offset += parent.boxes[i].size;
    }

    return offset;
  }

  function convertFragment(e, streamProcessor) {
    var i; // e.request contains request description object
    // e.response contains fragment bytes

    var isoFile = ISOBoxer.parseBuffer(e.response); // Update track_Id in tfhd box

    var tfhd = isoFile.fetch('tfhd');
    tfhd.track_ID = e.request.mediaInfo.index + 1; // Add tfdt box

    var tfdt = isoFile.fetch('tfdt');
    var traf = isoFile.fetch('traf');

    if (tfdt === null) {
      tfdt = ISOBoxer.createFullBox('tfdt', traf, tfhd);
      tfdt.version = 1;
      tfdt.flags = 0;
      tfdt.baseMediaDecodeTime = Math.floor(e.request.startTime * e.request.timescale);
    }

    var trun = isoFile.fetch('trun'); // Process tfxd boxes
    // This box provide absolute timestamp but we take the segment start time for tfdt

    var tfxd = isoFile.fetch('tfxd');

    if (tfxd) {
      tfxd._parent.boxes.splice(tfxd._parent.boxes.indexOf(tfxd), 1);

      tfxd = null;
    }

    var tfrf = isoFile.fetch('tfrf');
    processTfrf(e.request, tfrf, tfdt, streamProcessor);

    if (tfrf) {
      tfrf._parent.boxes.splice(tfrf._parent.boxes.indexOf(tfrf), 1);

      tfrf = null;
    } // If protected content in PIFF1.1 format (sepiff box = Sample Encryption PIFF)
    // => convert sepiff box it into a senc box
    // => create saio and saiz boxes (if not already present)


    var sepiff = isoFile.fetch('sepiff');

    if (sepiff !== null) {
      sepiff.type = 'senc';
      sepiff.usertype = undefined;

      var _saio = isoFile.fetch('saio');

      if (_saio === null) {
        // Create Sample Auxiliary Information Offsets Box box (saio)
        _saio = ISOBoxer.createFullBox('saio', traf);
        _saio.version = 0;
        _saio.flags = 0;
        _saio.entry_count = 1;
        _saio.offset = [0];
        var saiz = ISOBoxer.createFullBox('saiz', traf);
        saiz.version = 0;
        saiz.flags = 0;
        saiz.sample_count = sepiff.sample_count;
        saiz.default_sample_info_size = 0;
        saiz.sample_info_size = [];

        if (sepiff.flags & 0x02) {
          // Sub-sample encryption => set sample_info_size for each sample
          for (i = 0; i < sepiff.sample_count; i += 1) {
            // 10 = 8 (InitializationVector field size) + 2 (subsample_count field size)
            // 6 = 2 (BytesOfClearData field size) + 4 (BytesOfEncryptedData field size)
            saiz.sample_info_size[i] = 10 + 6 * sepiff.entry[i].NumberOfEntries;
          }
        } else {
          // No sub-sample encryption => set default sample_info_size = InitializationVector field size (8)
          saiz.default_sample_info_size = 8;
        }
      }
    }

    tfhd.flags &= 0xFFFFFE; // set tfhd.base-data-offset-present to false

    tfhd.flags |= 0x020000; // set tfhd.default-base-is-moof to true

    trun.flags |= 0x000001; // set trun.data-offset-present to true
    // Update trun.data_offset field that corresponds to first data byte (inside mdat box)

    var moof = isoFile.fetch('moof');
    var length = moof.getLength();
    trun.data_offset = length + 8; // Update saio box offset field according to new senc box offset

    var saio = isoFile.fetch('saio');

    if (saio !== null) {
      var trafPosInMoof = getBoxOffset(moof, 'traf');
      var sencPosInTraf = getBoxOffset(traf, 'senc'); // Set offset from begin fragment to the first IV field in senc box

      saio.offset[0] = trafPosInMoof + sencPosInTraf + 16; // 16 = box header (12) + sample_count field size (4)
    } // Write transformed/processed fragment into request reponse data


    e.response = isoFile.write();
  }

  function updateSegmentList(e, streamProcessor) {
    // e.request contains request description object
    // e.response contains fragment bytes
    if (!e.response) {
      throw new Error('e.response parameter is missing');
    }

    var isoFile = ISOBoxer.parseBuffer(e.response); // Update track_Id in tfhd box

    var tfhd = isoFile.fetch('tfhd');
    tfhd.track_ID = e.request.mediaInfo.index + 1; // Add tfdt box

    var tfdt = isoFile.fetch('tfdt');
    var traf = isoFile.fetch('traf');

    if (tfdt === null) {
      tfdt = ISOBoxer.createFullBox('tfdt', traf, tfhd);
      tfdt.version = 1;
      tfdt.flags = 0;
      tfdt.baseMediaDecodeTime = Math.floor(e.request.startTime * e.request.timescale);
    }

    var tfrf = isoFile.fetch('tfrf');
    processTfrf(e.request, tfrf, tfdt, streamProcessor);

    if (tfrf) {
      tfrf._parent.boxes.splice(tfrf._parent.boxes.indexOf(tfrf), 1);

      tfrf = null;
    }
  }

  function getType() {
    return type;
  }

  instance = {
    convertFragment: convertFragment,
    updateSegmentList: updateSegmentList,
    getType: getType
  };
  setup();
  return instance;
}

MssFragmentMoofProcessor.__dashjs_factory_name = 'MssFragmentMoofProcessor';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MssFragmentMoofProcessor));
/* jshint ignore:line */

/***/ }),

/***/ "./src/mss/MssFragmentMoovProcessor.js":
/*!*********************************************!*\
  !*** ./src/mss/MssFragmentMoovProcessor.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_82257__) {

"use strict";
__nested_webpack_require_82257__.r(__webpack_exports__);
/* harmony import */ var _errors_MssErrors__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_82257__(/*! ./errors/MssErrors */ "./src/mss/errors/MssErrors.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module MssFragmentMoovProcessor
 * @ignore
 * @param {Object} config object
 */

function MssFragmentMoovProcessor(config) {
  config = config || {};
  var NALUTYPE_SPS = 7;
  var NALUTYPE_PPS = 8;
  var constants = config.constants;
  var ISOBoxer = config.ISOBoxer;
  var protectionController = config.protectionController;
  var instance, period, adaptationSet, representation, contentProtection, timescale, trackId;

  function createFtypBox(isoFile) {
    var ftyp = ISOBoxer.createBox('ftyp', isoFile);
    ftyp.major_brand = 'iso6';
    ftyp.minor_version = 1; // is an informative integer for the minor version of the major brand

    ftyp.compatible_brands = []; //is a list, to the end of the box, of brands isom, iso6 and msdh

    ftyp.compatible_brands[0] = 'isom'; // => decimal ASCII value for isom

    ftyp.compatible_brands[1] = 'iso6'; // => decimal ASCII value for iso6

    ftyp.compatible_brands[2] = 'msdh'; // => decimal ASCII value for msdh

    return ftyp;
  }

  function createMoovBox(isoFile) {
    // moov box
    var moov = ISOBoxer.createBox('moov', isoFile); // moov/mvhd

    createMvhdBox(moov); // moov/trak

    var trak = ISOBoxer.createBox('trak', moov); // moov/trak/tkhd

    createTkhdBox(trak); // moov/trak/mdia

    var mdia = ISOBoxer.createBox('mdia', trak); // moov/trak/mdia/mdhd

    createMdhdBox(mdia); // moov/trak/mdia/hdlr

    createHdlrBox(mdia); // moov/trak/mdia/minf

    var minf = ISOBoxer.createBox('minf', mdia);

    switch (adaptationSet.type) {
      case constants.VIDEO:
        // moov/trak/mdia/minf/vmhd
        createVmhdBox(minf);
        break;

      case constants.AUDIO:
        // moov/trak/mdia/minf/smhd
        createSmhdBox(minf);
        break;

      default:
        break;
    } // moov/trak/mdia/minf/dinf


    var dinf = ISOBoxer.createBox('dinf', minf); // moov/trak/mdia/minf/dinf/dref

    createDrefBox(dinf); // moov/trak/mdia/minf/stbl

    var stbl = ISOBoxer.createBox('stbl', minf); // Create empty stts, stsc, stco and stsz boxes
    // Use data field as for codem-isoboxer unknown boxes for setting fields value
    // moov/trak/mdia/minf/stbl/stts

    var stts = ISOBoxer.createFullBox('stts', stbl);
    stts._data = [0, 0, 0, 0, 0, 0, 0, 0]; // version = 0, flags = 0, entry_count = 0
    // moov/trak/mdia/minf/stbl/stsc

    var stsc = ISOBoxer.createFullBox('stsc', stbl);
    stsc._data = [0, 0, 0, 0, 0, 0, 0, 0]; // version = 0, flags = 0, entry_count = 0
    // moov/trak/mdia/minf/stbl/stco

    var stco = ISOBoxer.createFullBox('stco', stbl);
    stco._data = [0, 0, 0, 0, 0, 0, 0, 0]; // version = 0, flags = 0, entry_count = 0
    // moov/trak/mdia/minf/stbl/stsz

    var stsz = ISOBoxer.createFullBox('stsz', stbl);
    stsz._data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; // version = 0, flags = 0, sample_size = 0, sample_count = 0
    // moov/trak/mdia/minf/stbl/stsd

    createStsdBox(stbl); // moov/mvex

    var mvex = ISOBoxer.createBox('mvex', moov); // moov/mvex/trex

    createTrexBox(mvex);

    if (contentProtection && protectionController) {
      var supportedKS = protectionController.getSupportedKeySystemsFromContentProtection(contentProtection);
      createProtectionSystemSpecificHeaderBox(moov, supportedKS);
    }
  }

  function createMvhdBox(moov) {
    var mvhd = ISOBoxer.createFullBox('mvhd', moov);
    mvhd.version = 1; // version = 1  in order to have 64bits duration value

    mvhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)

    mvhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)

    mvhd.timescale = timescale; // the time-scale for the entire presentation => 10000000 for MSS

    mvhd.duration = period.duration === Infinity ? 0xFFFFFFFFFFFFFFFF : Math.round(period.duration * timescale); // the length of the presentation (in the indicated timescale) =>  take duration of period

    mvhd.rate = 1.0; // 16.16 number, '1.0' = normal playback

    mvhd.volume = 1.0; // 8.8 number, '1.0' = full volume

    mvhd.reserved1 = 0;
    mvhd.reserved2 = [0x0, 0x0];
    mvhd.matrix = [1, 0, 0, // provides a transformation matrix for the video;
    0, 1, 0, // (u,v,w) are restricted here to (0,0,1)
    0, 0, 16384];
    mvhd.pre_defined = [0, 0, 0, 0, 0, 0];
    mvhd.next_track_ID = trackId + 1; // indicates a value to use for the track ID of the next track to be added to this presentation

    return mvhd;
  }

  function createTkhdBox(trak) {
    var tkhd = ISOBoxer.createFullBox('tkhd', trak);
    tkhd.version = 1; // version = 1  in order to have 64bits duration value

    tkhd.flags = 0x1 | // Track_enabled (0x000001): Indicates that the track is enabled
    0x2 | // Track_in_movie (0x000002):  Indicates that the track is used in the presentation
    0x4; // Track_in_preview (0x000004):  Indicates that the track is used when previewing the presentation

    tkhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)

    tkhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)

    tkhd.track_ID = trackId; // uniquely identifies this track over the entire life-time of this presentation

    tkhd.reserved1 = 0;
    tkhd.duration = period.duration === Infinity ? 0xFFFFFFFFFFFFFFFF : Math.round(period.duration * timescale); // the duration of this track (in the timescale indicated in the Movie Header Box) =>  take duration of period

    tkhd.reserved2 = [0x0, 0x0];
    tkhd.layer = 0; // specifies the front-to-back ordering of video tracks; tracks with lower numbers are closer to the viewer => 0 since only one video track

    tkhd.alternate_group = 0; // specifies a group or collection of tracks => ignore

    tkhd.volume = 1.0; // '1.0' = full volume

    tkhd.reserved3 = 0;
    tkhd.matrix = [1, 0, 0, // provides a transformation matrix for the video;
    0, 1, 0, // (u,v,w) are restricted here to (0,0,1)
    0, 0, 16384];
    tkhd.width = representation.width; // visual presentation width

    tkhd.height = representation.height; // visual presentation height

    return tkhd;
  }

  function createMdhdBox(mdia) {
    var mdhd = ISOBoxer.createFullBox('mdhd', mdia);
    mdhd.version = 1; // version = 1  in order to have 64bits duration value

    mdhd.creation_time = 0; // the creation time of the presentation => ignore (set to 0)

    mdhd.modification_time = 0; // the most recent time the presentation was modified => ignore (set to 0)

    mdhd.timescale = timescale; // the time-scale for the entire presentation

    mdhd.duration = period.duration === Infinity ? 0xFFFFFFFFFFFFFFFF : Math.round(period.duration * timescale); // the duration of this media (in the scale of the timescale). If the duration cannot be determined then duration is set to all 1s.

    mdhd.language = adaptationSet.lang || 'und'; // declares the language code for this media

    mdhd.pre_defined = 0;
    return mdhd;
  }

  function createHdlrBox(mdia) {
    var hdlr = ISOBoxer.createFullBox('hdlr', mdia);
    hdlr.pre_defined = 0;

    switch (adaptationSet.type) {
      case constants.VIDEO:
        hdlr.handler_type = 'vide';
        break;

      case constants.AUDIO:
        hdlr.handler_type = 'soun';
        break;

      default:
        hdlr.handler_type = 'meta';
        break;
    }

    hdlr.name = representation.id;
    hdlr.reserved = [0, 0, 0];
    return hdlr;
  }

  function createVmhdBox(minf) {
    var vmhd = ISOBoxer.createFullBox('vmhd', minf);
    vmhd.flags = 1;
    vmhd.graphicsmode = 0; // specifies a composition mode for this video track, from the following enumerated set, which may be extended by derived specifications: copy = 0 copy over the existing image

    vmhd.opcolor = [0, 0, 0]; // is a set of 3 colour values (red, green, blue) available for use by graphics modes

    return vmhd;
  }

  function createSmhdBox(minf) {
    var smhd = ISOBoxer.createFullBox('smhd', minf);
    smhd.flags = 1;
    smhd.balance = 0; // is a fixed-point 8.8 number that places mono audio tracks in a stereo space; 0 is centre (the normal value); full left is -1.0 and full right is 1.0.

    smhd.reserved = 0;
    return smhd;
  }

  function createDrefBox(dinf) {
    var dref = ISOBoxer.createFullBox('dref', dinf);
    dref.entry_count = 1;
    dref.entries = [];
    var url = ISOBoxer.createFullBox('url ', dref, false);
    url.location = '';
    url.flags = 1;
    dref.entries.push(url);
    return dref;
  }

  function createStsdBox(stbl) {
    var stsd = ISOBoxer.createFullBox('stsd', stbl);
    stsd.entries = [];

    switch (adaptationSet.type) {
      case constants.VIDEO:
      case constants.AUDIO:
        stsd.entries.push(createSampleEntry(stsd));
        break;

      default:
        break;
    }

    stsd.entry_count = stsd.entries.length; // is an integer that counts the actual entries

    return stsd;
  }

  function createSampleEntry(stsd) {
    var codec = representation.codecs.substring(0, representation.codecs.indexOf('.'));

    switch (codec) {
      case 'avc1':
        return createAVCVisualSampleEntry(stsd, codec);

      case 'mp4a':
        return createMP4AudioSampleEntry(stsd, codec);

      default:
        throw {
          code: _errors_MssErrors__WEBPACK_IMPORTED_MODULE_0__["default"].MSS_UNSUPPORTED_CODEC_CODE,
          message: _errors_MssErrors__WEBPACK_IMPORTED_MODULE_0__["default"].MSS_UNSUPPORTED_CODEC_MESSAGE,
          data: {
            codec: codec
          }
        };
    }
  }

  function createAVCVisualSampleEntry(stsd, codec) {
    var avc1;

    if (contentProtection) {
      avc1 = ISOBoxer.createBox('encv', stsd, false);
    } else {
      avc1 = ISOBoxer.createBox('avc1', stsd, false);
    } // SampleEntry fields


    avc1.reserved1 = [0x0, 0x0, 0x0, 0x0, 0x0, 0x0];
    avc1.data_reference_index = 1; // VisualSampleEntry fields

    avc1.pre_defined1 = 0;
    avc1.reserved2 = 0;
    avc1.pre_defined2 = [0, 0, 0];
    avc1.height = representation.height;
    avc1.width = representation.width;
    avc1.horizresolution = 72; // 72 dpi

    avc1.vertresolution = 72; // 72 dpi

    avc1.reserved3 = 0;
    avc1.frame_count = 1; // 1 compressed video frame per sample

    avc1.compressorname = [0x0A, 0x41, 0x56, 0x43, 0x20, 0x43, 0x6F, 0x64, // = 'AVC Coding';
    0x69, 0x6E, 0x67, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00];
    avc1.depth = 0x0018; // 0x0018 – images are in colour with no alpha.

    avc1.pre_defined3 = 65535;
    avc1.config = createAVC1ConfigurationRecord();

    if (contentProtection) {
      // Create and add Protection Scheme Info Box
      var sinf = ISOBoxer.createBox('sinf', avc1); // Create and add Original Format Box => indicate codec type of the encrypted content

      createOriginalFormatBox(sinf, codec); // Create and add Scheme Type box

      createSchemeTypeBox(sinf); // Create and add Scheme Information Box

      createSchemeInformationBox(sinf);
    }

    return avc1;
  }

  function createAVC1ConfigurationRecord() {
    var avcC = null;
    var avcCLength = 15; // length = 15 by default (0 SPS and 0 PPS)
    // First get all SPS and PPS from codecPrivateData

    var sps = [];
    var pps = [];
    var AVCProfileIndication = 0;
    var AVCLevelIndication = 0;
    var profile_compatibility = 0;
    var nalus = representation.codecPrivateData.split('00000001').slice(1);
    var naluBytes, naluType;

    for (var _i = 0; _i < nalus.length; _i++) {
      naluBytes = hexStringtoBuffer(nalus[_i]);
      naluType = naluBytes[0] & 0x1F;

      switch (naluType) {
        case NALUTYPE_SPS:
          sps.push(naluBytes);
          avcCLength += naluBytes.length + 2; // 2 = sequenceParameterSetLength field length

          break;

        case NALUTYPE_PPS:
          pps.push(naluBytes);
          avcCLength += naluBytes.length + 2; // 2 = pictureParameterSetLength field length

          break;

        default:
          break;
      }
    } // Get profile and level from SPS


    if (sps.length > 0) {
      AVCProfileIndication = sps[0][1];
      profile_compatibility = sps[0][2];
      AVCLevelIndication = sps[0][3];
    } // Generate avcC buffer


    avcC = new Uint8Array(avcCLength);
    var i = 0; // length

    avcC[i++] = (avcCLength & 0xFF000000) >> 24;
    avcC[i++] = (avcCLength & 0x00FF0000) >> 16;
    avcC[i++] = (avcCLength & 0x0000FF00) >> 8;
    avcC[i++] = avcCLength & 0x000000FF;
    avcC.set([0x61, 0x76, 0x63, 0x43], i); // type = 'avcC'

    i += 4;
    avcC[i++] = 1; // configurationVersion = 1

    avcC[i++] = AVCProfileIndication;
    avcC[i++] = profile_compatibility;
    avcC[i++] = AVCLevelIndication;
    avcC[i++] = 0xFF; // '11111' + lengthSizeMinusOne = 3

    avcC[i++] = 0xE0 | sps.length; // '111' + numOfSequenceParameterSets

    for (var n = 0; n < sps.length; n++) {
      avcC[i++] = (sps[n].length & 0xFF00) >> 8;
      avcC[i++] = sps[n].length & 0x00FF;
      avcC.set(sps[n], i);
      i += sps[n].length;
    }

    avcC[i++] = pps.length; // numOfPictureParameterSets

    for (var _n = 0; _n < pps.length; _n++) {
      avcC[i++] = (pps[_n].length & 0xFF00) >> 8;
      avcC[i++] = pps[_n].length & 0x00FF;
      avcC.set(pps[_n], i);
      i += pps[_n].length;
    }

    return avcC;
  }

  function createMP4AudioSampleEntry(stsd, codec) {
    var mp4a;

    if (contentProtection) {
      mp4a = ISOBoxer.createBox('enca', stsd, false);
    } else {
      mp4a = ISOBoxer.createBox('mp4a', stsd, false);
    } // SampleEntry fields


    mp4a.reserved1 = [0x0, 0x0, 0x0, 0x0, 0x0, 0x0];
    mp4a.data_reference_index = 1; // AudioSampleEntry fields

    mp4a.reserved2 = [0x0, 0x0];
    mp4a.channelcount = representation.audioChannels;
    mp4a.samplesize = 16;
    mp4a.pre_defined = 0;
    mp4a.reserved_3 = 0;
    mp4a.samplerate = representation.audioSamplingRate << 16;
    mp4a.esds = createMPEG4AACESDescriptor();

    if (contentProtection) {
      // Create and add Protection Scheme Info Box
      var sinf = ISOBoxer.createBox('sinf', mp4a); // Create and add Original Format Box => indicate codec type of the encrypted content

      createOriginalFormatBox(sinf, codec); // Create and add Scheme Type box

      createSchemeTypeBox(sinf); // Create and add Scheme Information Box

      createSchemeInformationBox(sinf);
    }

    return mp4a;
  }

  function createMPEG4AACESDescriptor() {
    // AudioSpecificConfig (see ISO/IEC 14496-3, subpart 1) => corresponds to hex bytes contained in 'codecPrivateData' field
    var audioSpecificConfig = hexStringtoBuffer(representation.codecPrivateData); // ESDS length = esds box header length (= 12) +
    //               ES_Descriptor header length (= 5) +
    //               DecoderConfigDescriptor header length (= 15) +
    //               decoderSpecificInfo header length (= 2) +
    //               AudioSpecificConfig length (= codecPrivateData length)

    var esdsLength = 34 + audioSpecificConfig.length;
    var esds = new Uint8Array(esdsLength);
    var i = 0; // esds box

    esds[i++] = (esdsLength & 0xFF000000) >> 24; // esds box length

    esds[i++] = (esdsLength & 0x00FF0000) >> 16; // ''

    esds[i++] = (esdsLength & 0x0000FF00) >> 8; // ''

    esds[i++] = esdsLength & 0x000000FF; // ''

    esds.set([0x65, 0x73, 0x64, 0x73], i); // type = 'esds'

    i += 4;
    esds.set([0, 0, 0, 0], i); // version = 0, flags = 0

    i += 4; // ES_Descriptor (see ISO/IEC 14496-1 (Systems))

    esds[i++] = 0x03; // tag = 0x03 (ES_DescrTag)

    esds[i++] = 20 + audioSpecificConfig.length; // size

    esds[i++] = (trackId & 0xFF00) >> 8; // ES_ID = track_id

    esds[i++] = trackId & 0x00FF; // ''

    esds[i++] = 0; // flags and streamPriority
    // DecoderConfigDescriptor (see ISO/IEC 14496-1 (Systems))

    esds[i++] = 0x04; // tag = 0x04 (DecoderConfigDescrTag)

    esds[i++] = 15 + audioSpecificConfig.length; // size

    esds[i++] = 0x40; // objectTypeIndication = 0x40 (MPEG-4 AAC)

    esds[i] = 0x05 << 2; // streamType = 0x05 (Audiostream)

    esds[i] |= 0 << 1; // upStream = 0

    esds[i++] |= 1; // reserved = 1

    esds[i++] = 0xFF; // buffersizeDB = undefined

    esds[i++] = 0xFF; // ''

    esds[i++] = 0xFF; // ''

    esds[i++] = (representation.bandwidth & 0xFF000000) >> 24; // maxBitrate

    esds[i++] = (representation.bandwidth & 0x00FF0000) >> 16; // ''

    esds[i++] = (representation.bandwidth & 0x0000FF00) >> 8; // ''

    esds[i++] = representation.bandwidth & 0x000000FF; // ''

    esds[i++] = (representation.bandwidth & 0xFF000000) >> 24; // avgbitrate

    esds[i++] = (representation.bandwidth & 0x00FF0000) >> 16; // ''

    esds[i++] = (representation.bandwidth & 0x0000FF00) >> 8; // ''

    esds[i++] = representation.bandwidth & 0x000000FF; // ''
    // DecoderSpecificInfo (see ISO/IEC 14496-1 (Systems))

    esds[i++] = 0x05; // tag = 0x05 (DecSpecificInfoTag)

    esds[i++] = audioSpecificConfig.length; // size

    esds.set(audioSpecificConfig, i); // AudioSpecificConfig bytes

    return esds;
  }

  function createOriginalFormatBox(sinf, codec) {
    var frma = ISOBoxer.createBox('frma', sinf);
    frma.data_format = stringToCharCode(codec);
  }

  function createSchemeTypeBox(sinf) {
    var schm = ISOBoxer.createFullBox('schm', sinf);
    schm.flags = 0;
    schm.version = 0;
    schm.scheme_type = 0x63656E63; // 'cenc' => common encryption

    schm.scheme_version = 0x00010000; // version set to 0x00010000 (Major version 1, Minor version 0)
  }

  function createSchemeInformationBox(sinf) {
    var schi = ISOBoxer.createBox('schi', sinf); // Create and add Track Encryption Box

    createTrackEncryptionBox(schi);
  }

  function createProtectionSystemSpecificHeaderBox(moov, keySystems) {
    var pssh_bytes, pssh, i, parsedBuffer;

    for (i = 0; i < keySystems.length; i += 1) {
      pssh_bytes = keySystems[i].initData;

      if (pssh_bytes) {
        parsedBuffer = ISOBoxer.parseBuffer(pssh_bytes);
        pssh = parsedBuffer.fetch('pssh');

        if (pssh) {
          ISOBoxer.Utils.appendBox(moov, pssh);
        }
      }
    }
  }

  function createTrackEncryptionBox(schi) {
    var tenc = ISOBoxer.createFullBox('tenc', schi);
    tenc.flags = 0;
    tenc.version = 0;
    tenc.default_IsEncrypted = 0x1;
    tenc.default_IV_size = 8;
    tenc.default_KID = contentProtection && contentProtection.length > 0 && contentProtection[0]['cenc:default_KID'] ? contentProtection[0]['cenc:default_KID'] : [0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0, 0x0];
  }

  function createTrexBox(moov) {
    var trex = ISOBoxer.createFullBox('trex', moov);
    trex.track_ID = trackId;
    trex.default_sample_description_index = 1;
    trex.default_sample_duration = 0;
    trex.default_sample_size = 0;
    trex.default_sample_flags = 0;
    return trex;
  }

  function hexStringtoBuffer(str) {
    var buf = new Uint8Array(str.length / 2);
    var i;

    for (i = 0; i < str.length / 2; i += 1) {
      buf[i] = parseInt('' + str[i * 2] + str[i * 2 + 1], 16);
    }

    return buf;
  }

  function stringToCharCode(str) {
    var code = 0;
    var i;

    for (i = 0; i < str.length; i += 1) {
      code |= str.charCodeAt(i) << (str.length - i - 1) * 8;
    }

    return code;
  }

  function generateMoov(rep) {
    if (!rep || !rep.adaptation) {
      return;
    }

    var isoFile, arrayBuffer;
    representation = rep;
    adaptationSet = representation.adaptation;
    period = adaptationSet.period;
    trackId = adaptationSet.index + 1;
    contentProtection = period.mpd.manifest.Period_asArray[period.index].AdaptationSet_asArray[adaptationSet.index].ContentProtection;
    timescale = period.mpd.manifest.Period_asArray[period.index].AdaptationSet_asArray[adaptationSet.index].SegmentTemplate.timescale;
    isoFile = ISOBoxer.createFile();
    createFtypBox(isoFile);
    createMoovBox(isoFile);
    arrayBuffer = isoFile.write();
    return arrayBuffer;
  }

  instance = {
    generateMoov: generateMoov
  };
  return instance;
}

MssFragmentMoovProcessor.__dashjs_factory_name = 'MssFragmentMoovProcessor';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MssFragmentMoovProcessor));
/* jshint ignore:line */

/***/ }),

/***/ "./src/mss/MssFragmentProcessor.js":
/*!*****************************************!*\
  !*** ./src/mss/MssFragmentProcessor.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_105641__) {

"use strict";
__nested_webpack_require_105641__.r(__webpack_exports__);
/* harmony import */ var _MssFragmentMoofProcessor__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_105641__(/*! ./MssFragmentMoofProcessor */ "./src/mss/MssFragmentMoofProcessor.js");
/* harmony import */ var _MssFragmentMoovProcessor__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_105641__(/*! ./MssFragmentMoovProcessor */ "./src/mss/MssFragmentMoovProcessor.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_105641__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


 // Add specific box processors not provided by codem-isoboxer library

function arrayEqual(arr1, arr2) {
  return arr1.length === arr2.length && arr1.every(function (element, index) {
    return element === arr2[index];
  });
}

function saioProcessor() {
  this._procFullBox();

  if (this.flags & 1) {
    this._procField('aux_info_type', 'uint', 32);

    this._procField('aux_info_type_parameter', 'uint', 32);
  }

  this._procField('entry_count', 'uint', 32);

  this._procFieldArray('offset', this.entry_count, 'uint', this.version === 1 ? 64 : 32);
}

function saizProcessor() {
  this._procFullBox();

  if (this.flags & 1) {
    this._procField('aux_info_type', 'uint', 32);

    this._procField('aux_info_type_parameter', 'uint', 32);
  }

  this._procField('default_sample_info_size', 'uint', 8);

  this._procField('sample_count', 'uint', 32);

  if (this.default_sample_info_size === 0) {
    this._procFieldArray('sample_info_size', this.sample_count, 'uint', 8);
  }
}

function sencProcessor() {
  this._procFullBox();

  this._procField('sample_count', 'uint', 32);

  if (this.flags & 1) {
    this._procField('IV_size', 'uint', 8);
  }

  this._procEntries('entry', this.sample_count, function (entry) {
    this._procEntryField(entry, 'InitializationVector', 'data', 8);

    if (this.flags & 2) {
      this._procEntryField(entry, 'NumberOfEntries', 'uint', 16);

      this._procSubEntries(entry, 'clearAndCryptedData', entry.NumberOfEntries, function (clearAndCryptedData) {
        this._procEntryField(clearAndCryptedData, 'BytesOfClearData', 'uint', 16);

        this._procEntryField(clearAndCryptedData, 'BytesOfEncryptedData', 'uint', 32);
      });
    }
  });
}

function uuidProcessor() {
  var tfxdUserType = [0x6D, 0x1D, 0x9B, 0x05, 0x42, 0xD5, 0x44, 0xE6, 0x80, 0xE2, 0x14, 0x1D, 0xAF, 0xF7, 0x57, 0xB2];
  var tfrfUserType = [0xD4, 0x80, 0x7E, 0xF2, 0xCA, 0x39, 0x46, 0x95, 0x8E, 0x54, 0x26, 0xCB, 0x9E, 0x46, 0xA7, 0x9F];
  var sepiffUserType = [0xA2, 0x39, 0x4F, 0x52, 0x5A, 0x9B, 0x4f, 0x14, 0xA2, 0x44, 0x6C, 0x42, 0x7C, 0x64, 0x8D, 0xF4];

  if (arrayEqual(this.usertype, tfxdUserType)) {
    this._procFullBox();

    if (this._parsing) {
      this.type = 'tfxd';
    }

    this._procField('fragment_absolute_time', 'uint', this.version === 1 ? 64 : 32);

    this._procField('fragment_duration', 'uint', this.version === 1 ? 64 : 32);
  }

  if (arrayEqual(this.usertype, tfrfUserType)) {
    this._procFullBox();

    if (this._parsing) {
      this.type = 'tfrf';
    }

    this._procField('fragment_count', 'uint', 8);

    this._procEntries('entry', this.fragment_count, function (entry) {
      this._procEntryField(entry, 'fragment_absolute_time', 'uint', this.version === 1 ? 64 : 32);

      this._procEntryField(entry, 'fragment_duration', 'uint', this.version === 1 ? 64 : 32);
    });
  }

  if (arrayEqual(this.usertype, sepiffUserType)) {
    if (this._parsing) {
      this.type = 'sepiff';
    }

    sencProcessor.call(this);
  }
}

function MssFragmentProcessor(config) {
  config = config || {};
  var context = this.context;
  var dashMetrics = config.dashMetrics;
  var playbackController = config.playbackController;
  var eventBus = config.eventBus;
  var protectionController = config.protectionController;
  var ISOBoxer = config.ISOBoxer;
  var debug = config.debug;
  var mssFragmentMoovProcessor, mssFragmentMoofProcessor, instance;

  function setup() {
    ISOBoxer.addBoxProcessor('uuid', uuidProcessor);
    ISOBoxer.addBoxProcessor('saio', saioProcessor);
    ISOBoxer.addBoxProcessor('saiz', saizProcessor);
    ISOBoxer.addBoxProcessor('senc', sencProcessor);
    mssFragmentMoovProcessor = Object(_MssFragmentMoovProcessor__WEBPACK_IMPORTED_MODULE_1__["default"])(context).create({
      protectionController: protectionController,
      constants: config.constants,
      ISOBoxer: ISOBoxer
    });
    mssFragmentMoofProcessor = Object(_MssFragmentMoofProcessor__WEBPACK_IMPORTED_MODULE_0__["default"])(context).create({
      dashMetrics: dashMetrics,
      playbackController: playbackController,
      ISOBoxer: ISOBoxer,
      eventBus: eventBus,
      debug: debug,
      errHandler: config.errHandler
    });
  }

  function generateMoov(rep) {
    return mssFragmentMoovProcessor.generateMoov(rep);
  }

  function processFragment(e, streamProcessor) {
    if (!e || !e.request || !e.response) {
      throw new Error('e parameter is missing or malformed');
    }

    if (e.request.type === 'MediaSegment') {
      // MediaSegment => convert to Smooth Streaming moof format
      mssFragmentMoofProcessor.convertFragment(e, streamProcessor);
    } else if (e.request.type === _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_2__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE) {
      // FragmentInfo (live) => update segments list
      mssFragmentMoofProcessor.updateSegmentList(e, streamProcessor); // Stop event propagation (FragmentInfo must not be added to buffer)

      e.sender = null;
    }
  }

  instance = {
    generateMoov: generateMoov,
    processFragment: processFragment
  };
  setup();
  return instance;
}

MssFragmentProcessor.__dashjs_factory_name = 'MssFragmentProcessor';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MssFragmentProcessor));
/* jshint ignore:line */

/***/ }),

/***/ "./src/mss/MssHandler.js":
/*!*******************************!*\
  !*** ./src/mss/MssHandler.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_113909__) {

"use strict";
__nested_webpack_require_113909__.r(__webpack_exports__);
/* harmony import */ var _streaming_vo_DataChunk__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_113909__(/*! ../streaming/vo/DataChunk */ "./src/streaming/vo/DataChunk.js");
/* harmony import */ var _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__ = __nested_webpack_require_113909__(/*! ../streaming/vo/FragmentRequest */ "./src/streaming/vo/FragmentRequest.js");
/* harmony import */ var _MssFragmentInfoController__WEBPACK_IMPORTED_MODULE_2__ = __nested_webpack_require_113909__(/*! ./MssFragmentInfoController */ "./src/mss/MssFragmentInfoController.js");
/* harmony import */ var _MssFragmentProcessor__WEBPACK_IMPORTED_MODULE_3__ = __nested_webpack_require_113909__(/*! ./MssFragmentProcessor */ "./src/mss/MssFragmentProcessor.js");
/* harmony import */ var _parser_MssParser__WEBPACK_IMPORTED_MODULE_4__ = __nested_webpack_require_113909__(/*! ./parser/MssParser */ "./src/mss/parser/MssParser.js");
/* harmony import */ var _errors_MssErrors__WEBPACK_IMPORTED_MODULE_5__ = __nested_webpack_require_113909__(/*! ./errors/MssErrors */ "./src/mss/errors/MssErrors.js");
/* harmony import */ var _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__ = __nested_webpack_require_113909__(/*! ../streaming/vo/DashJSError */ "./src/streaming/vo/DashJSError.js");
/* harmony import */ var _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__ = __nested_webpack_require_113909__(/*! ../streaming/vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */









function MssHandler(config) {
  config = config || {};
  var context = this.context;
  var eventBus = config.eventBus;
  var events = config.events;
  var constants = config.constants;
  var initSegmentType = config.initSegmentType;
  var dashMetrics = config.dashMetrics;
  var playbackController = config.playbackController;
  var streamController = config.streamController;
  var protectionController = config.protectionController;
  var mssFragmentProcessor = Object(_MssFragmentProcessor__WEBPACK_IMPORTED_MODULE_3__["default"])(context).create({
    dashMetrics: dashMetrics,
    playbackController: playbackController,
    protectionController: protectionController,
    streamController: streamController,
    eventBus: eventBus,
    constants: constants,
    ISOBoxer: config.ISOBoxer,
    debug: config.debug,
    errHandler: config.errHandler
  });
  var mssParser, fragmentInfoControllers, instance;

  function setup() {
    fragmentInfoControllers = [];
  }

  function getStreamProcessor(type) {
    return streamController.getActiveStreamProcessors().filter(function (processor) {
      return processor.getType() === type;
    })[0];
  }

  function getFragmentInfoController(type) {
    return fragmentInfoControllers.filter(function (controller) {
      return controller.getType() === type;
    })[0];
  }

  function createDataChunk(request, streamId, endFragment) {
    var chunk = new _streaming_vo_DataChunk__WEBPACK_IMPORTED_MODULE_0__["default"]();
    chunk.streamId = streamId;
    chunk.mediaInfo = request.mediaInfo;
    chunk.segmentType = request.type;
    chunk.start = request.startTime;
    chunk.duration = request.duration;
    chunk.end = chunk.start + chunk.duration;
    chunk.index = request.index;
    chunk.quality = request.quality;
    chunk.representationId = request.representationId;
    chunk.endFragment = endFragment;
    return chunk;
  }

  function startFragmentInfoControllers() {
    // Create MssFragmentInfoControllers for each StreamProcessor of active stream (only for audio, video or text)
    var processors = streamController.getActiveStreamProcessors();
    processors.forEach(function (processor) {
      if (processor.getType() === constants.VIDEO || processor.getType() === constants.AUDIO || processor.getType() === constants.TEXT) {
        var fragmentInfoController = getFragmentInfoController(processor.getType());

        if (!fragmentInfoController) {
          fragmentInfoController = Object(_MssFragmentInfoController__WEBPACK_IMPORTED_MODULE_2__["default"])(context).create({
            streamProcessor: processor,
            baseURLController: config.baseURLController,
            debug: config.debug
          });
          fragmentInfoController.initialize();
          fragmentInfoControllers.push(fragmentInfoController);
        }

        fragmentInfoController.start();
      }
    });
  }

  function stopFragmentInfoControllers() {
    fragmentInfoControllers.forEach(function (c) {
      c.reset();
    });
    fragmentInfoControllers = [];
  }

  function onInitFragmentNeeded(e) {
    var streamProcessor = getStreamProcessor(e.mediaType);
    if (!streamProcessor) return; // Create init segment request

    var representationController = streamProcessor.getRepresentationController();
    var representation = representationController.getCurrentRepresentation();
    var mediaInfo = streamProcessor.getMediaInfo();
    var request = new _streaming_vo_FragmentRequest__WEBPACK_IMPORTED_MODULE_1__["default"]();
    request.mediaType = representation.adaptation.type;
    request.type = initSegmentType;
    request.range = representation.range;
    request.quality = representation.index;
    request.mediaInfo = mediaInfo;
    request.representationId = representation.id;
    var chunk = createDataChunk(request, mediaInfo.streamInfo.id, e.type !== events.FRAGMENT_LOADING_PROGRESS);

    try {
      // Generate init segment (moov)
      chunk.bytes = mssFragmentProcessor.generateMoov(representation); // Notify init segment has been loaded

      eventBus.trigger(events.INIT_FRAGMENT_LOADED, {
        chunk: chunk
      }, {
        streamId: mediaInfo.streamInfo.id,
        mediaType: representation.adaptation.type
      });
    } catch (e) {
      config.errHandler.error(new _streaming_vo_DashJSError__WEBPACK_IMPORTED_MODULE_6__["default"](e.code, e.message, e.data));
    } // Change the sender value to stop event to be propagated


    e.sender = null;
  }

  function onSegmentMediaLoaded(e) {
    if (e.error) return;
    var streamProcessor = getStreamProcessor(e.request.mediaType);
    if (!streamProcessor) return; // Process moof to transcode it from MSS to DASH (or to update segment timeline for SegmentInfo fragments)

    mssFragmentProcessor.processFragment(e, streamProcessor);

    if (e.request.type === _streaming_vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_7__["HTTPRequest"].MSS_FRAGMENT_INFO_SEGMENT_TYPE) {
      // If FragmentInfo loaded, then notify corresponding MssFragmentInfoController
      var fragmentInfoController = getFragmentInfoController(e.request.mediaType);

      if (fragmentInfoController) {
        fragmentInfoController.fragmentInfoLoaded(e);
      }
    } // Start MssFragmentInfoControllers in case of start-over streams


    var manifestInfo = e.request.mediaInfo.streamInfo.manifestInfo;

    if (!manifestInfo.isDynamic && manifestInfo.dvrWindowSize !== Infinity) {
      startFragmentInfoControllers();
    }
  }

  function onPlaybackPaused() {
    if (playbackController.getIsDynamic() && playbackController.getTime() !== 0) {
      startFragmentInfoControllers();
    }
  }

  function onPlaybackSeeking() {
    if (playbackController.getIsDynamic() && playbackController.getTime() !== 0) {
      startFragmentInfoControllers();
    }
  }

  function onTTMLPreProcess(ttmlSubtitles) {
    if (!ttmlSubtitles || !ttmlSubtitles.data) {
      return;
    }

    ttmlSubtitles.data = ttmlSubtitles.data.replace(/http:\/\/www.w3.org\/2006\/10\/ttaf1/gi, 'http://www.w3.org/ns/ttml');
  }

  function registerEvents() {
    eventBus.on(events.INIT_FRAGMENT_NEEDED, onInitFragmentNeeded, instance, {
      priority: dashjs.FactoryMaker.getSingletonFactoryByName(eventBus.getClassName()).EVENT_PRIORITY_HIGH
    });
    /* jshint ignore:line */

    eventBus.on(events.PLAYBACK_PAUSED, onPlaybackPaused, instance, {
      priority: dashjs.FactoryMaker.getSingletonFactoryByName(eventBus.getClassName()).EVENT_PRIORITY_HIGH
    });
    /* jshint ignore:line */

    eventBus.on(events.PLAYBACK_SEEKING, onPlaybackSeeking, instance, {
      priority: dashjs.FactoryMaker.getSingletonFactoryByName(eventBus.getClassName()).EVENT_PRIORITY_HIGH
    });
    /* jshint ignore:line */

    eventBus.on(events.FRAGMENT_LOADING_COMPLETED, onSegmentMediaLoaded, instance, {
      priority: dashjs.FactoryMaker.getSingletonFactoryByName(eventBus.getClassName()).EVENT_PRIORITY_HIGH
    });
    /* jshint ignore:line */

    eventBus.on(events.TTML_TO_PARSE, onTTMLPreProcess, instance);
  }

  function reset() {
    if (mssParser) {
      mssParser.reset();
      mssParser = undefined;
    }

    eventBus.off(events.INIT_FRAGMENT_NEEDED, onInitFragmentNeeded, this);
    eventBus.off(events.PLAYBACK_PAUSED, onPlaybackPaused, this);
    eventBus.off(events.PLAYBACK_SEEKING, onPlaybackSeeking, this);
    eventBus.off(events.FRAGMENT_LOADING_COMPLETED, onSegmentMediaLoaded, this);
    eventBus.off(events.TTML_TO_PARSE, onTTMLPreProcess, this); // Reset FragmentInfoControllers

    stopFragmentInfoControllers();
  }

  function createMssParser() {
    mssParser = Object(_parser_MssParser__WEBPACK_IMPORTED_MODULE_4__["default"])(context).create(config);
    return mssParser;
  }

  instance = {
    reset: reset,
    createMssParser: createMssParser,
    registerEvents: registerEvents
  };
  setup();
  return instance;
}

MssHandler.__dashjs_factory_name = 'MssHandler';
var factory = dashjs.FactoryMaker.getClassFactory(MssHandler);
/* jshint ignore:line */

factory.errors = _errors_MssErrors__WEBPACK_IMPORTED_MODULE_5__["default"];
dashjs.FactoryMaker.updateClassFactory(MssHandler.__dashjs_factory_name, factory);
/* jshint ignore:line */

/* harmony default export */ __webpack_exports__["default"] = (factory);
/* jshint ignore:line */

/***/ }),

/***/ "./src/mss/errors/MssErrors.js":
/*!*************************************!*\
  !*** ./src/mss/errors/MssErrors.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_126063__) {

"use strict";
__nested_webpack_require_126063__.r(__webpack_exports__);
/* harmony import */ var _core_errors_ErrorsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_126063__(/*! ../../core/errors/ErrorsBase */ "./src/core/errors/ErrorsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 *
 */

var MssErrors = /*#__PURE__*/function (_ErrorsBase) {
  _inherits(MssErrors, _ErrorsBase);

  var _super = _createSuper(MssErrors);

  function MssErrors() {
    var _this;

    _classCallCheck(this, MssErrors);

    _this = _super.call(this);
    /**
     * Error code returned when no tfrf box is detected in MSS live stream
     */

    _this.MSS_NO_TFRF_CODE = 200;
    /**
     * Error code returned when one of the codecs defined in the manifest is not supported
     */

    _this.MSS_UNSUPPORTED_CODEC_CODE = 201;
    _this.MSS_NO_TFRF_MESSAGE = 'Missing tfrf in live media segment';
    _this.MSS_UNSUPPORTED_CODEC_MESSAGE = 'Unsupported codec';
    return _this;
  }

  return MssErrors;
}(_core_errors_ErrorsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var mssErrors = new MssErrors();
/* harmony default export */ __webpack_exports__["default"] = (mssErrors);

/***/ }),

/***/ "./src/mss/index.js":
/*!**************************!*\
  !*** ./src/mss/index.js ***!
  \**************************/
/*! exports provided: default, MssHandler */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_131778__) {

"use strict";
__nested_webpack_require_131778__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _MssHandler__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_131778__(/*! ./MssHandler */ "./src/mss/MssHandler.js");
/* harmony reexport (safe) */ __nested_webpack_require_131778__.d(__webpack_exports__, "MssHandler", function() { return _MssHandler__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
 // Shove both of these into the global scope

var context = typeof window !== 'undefined' && window || global;
var dashjs = context.dashjs;

if (!dashjs) {
  dashjs = context.dashjs = {};
}

dashjs.MssHandler = _MssHandler__WEBPACK_IMPORTED_MODULE_0__["default"];
/* harmony default export */ __webpack_exports__["default"] = (dashjs);

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_131778__(/*! ./../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/mss/parser/MssParser.js":
/*!*************************************!*\
  !*** ./src/mss/parser/MssParser.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_134854__) {

"use strict";
__nested_webpack_require_134854__.r(__webpack_exports__);
/* harmony import */ var _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_134854__(/*! ../../../externals/BigInteger */ "./externals/BigInteger.js");
/* harmony import */ var _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_134854__.n(_externals_BigInteger__WEBPACK_IMPORTED_MODULE_0__);
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @module MssParser
 * @ignore
 * @param {Object} config object
 */


function MssParser(config) {
  config = config || {};
  var BASE64 = config.BASE64;
  var debug = config.debug;
  var constants = config.constants;
  var manifestModel = config.manifestModel;
  var settings = config.settings;
  var DEFAULT_TIME_SCALE = 10000000.0;
  var SUPPORTED_CODECS = ['AAC', 'AACL', 'AACH', 'AACP', 'AVC1', 'H264', 'TTML', 'DFXP']; // MPEG-DASH Role and accessibility mapping for text tracks according to ETSI TS 103 285 v1.1.1 (section 7.1.2)

  var ROLE = {
    'CAPT': 'main',
    'SUBT': 'alternate',
    'DESC': 'main'
  };
  var ACCESSIBILITY = {
    'DESC': '2'
  };
  var samplingFrequencyIndex = {
    96000: 0x0,
    88200: 0x1,
    64000: 0x2,
    48000: 0x3,
    44100: 0x4,
    32000: 0x5,
    24000: 0x6,
    22050: 0x7,
    16000: 0x8,
    12000: 0x9,
    11025: 0xA,
    8000: 0xB,
    7350: 0xC
  };
  var mimeTypeMap = {
    'video': 'video/mp4',
    'audio': 'audio/mp4',
    'text': 'application/mp4'
  };
  var instance, logger, initialBufferSettings;

  function setup() {
    logger = debug.getLogger(instance);
  }

  function getAttributeAsBoolean(node, attrName) {
    var value = node.getAttribute(attrName);
    if (!value) return false;
    return value.toLowerCase() === 'true';
  }

  function mapPeriod(smoothStreamingMedia, timescale) {
    var period = {};
    var streams, adaptation; // For each StreamIndex node, create an AdaptationSet element

    period.AdaptationSet_asArray = [];
    streams = smoothStreamingMedia.getElementsByTagName('StreamIndex');

    for (var i = 0; i < streams.length; i++) {
      adaptation = mapAdaptationSet(streams[i], timescale);

      if (adaptation !== null) {
        period.AdaptationSet_asArray.push(adaptation);
      }
    }

    if (period.AdaptationSet_asArray.length > 0) {
      period.AdaptationSet = period.AdaptationSet_asArray.length > 1 ? period.AdaptationSet_asArray : period.AdaptationSet_asArray[0];
    }

    return period;
  }

  function mapAdaptationSet(streamIndex, timescale) {
    var adaptationSet = {};
    var representations = [];
    var segmentTemplate;
    var qualityLevels, representation, i, index;
    var name = streamIndex.getAttribute('Name');
    var type = streamIndex.getAttribute('Type');
    var lang = streamIndex.getAttribute('Language');
    var fallBackId = lang ? type + '_' + lang : type;
    adaptationSet.id = name || fallBackId;
    adaptationSet.contentType = type;
    adaptationSet.lang = lang || 'und';
    adaptationSet.mimeType = mimeTypeMap[type];
    adaptationSet.subType = streamIndex.getAttribute('Subtype');
    adaptationSet.maxWidth = streamIndex.getAttribute('MaxWidth');
    adaptationSet.maxHeight = streamIndex.getAttribute('MaxHeight'); // Map text tracks subTypes to MPEG-DASH AdaptationSet role and accessibility (see ETSI TS 103 285 v1.1.1, section 7.1.2)

    if (adaptationSet.subType) {
      if (ROLE[adaptationSet.subType]) {
        var role = {
          schemeIdUri: 'urn:mpeg:dash:role:2011',
          value: ROLE[adaptationSet.subType]
        };
        adaptationSet.Role = role;
        adaptationSet.Role_asArray = [role];
      }

      if (ACCESSIBILITY[adaptationSet.subType]) {
        var accessibility = {
          schemeIdUri: 'urn:tva:metadata:cs:AudioPurposeCS:2007',
          value: ACCESSIBILITY[adaptationSet.subType]
        };
        adaptationSet.Accessibility = accessibility;
        adaptationSet.Accessibility_asArray = [accessibility];
      }
    } // Create a SegmentTemplate with a SegmentTimeline


    segmentTemplate = mapSegmentTemplate(streamIndex, timescale);
    qualityLevels = streamIndex.getElementsByTagName('QualityLevel'); // For each QualityLevel node, create a Representation element

    for (i = 0; i < qualityLevels.length; i++) {
      // Propagate BaseURL and mimeType
      qualityLevels[i].BaseURL = adaptationSet.BaseURL;
      qualityLevels[i].mimeType = adaptationSet.mimeType; // Set quality level id

      index = qualityLevels[i].getAttribute('Index');
      qualityLevels[i].Id = adaptationSet.id + (index !== null ? '_' + index : ''); // Map Representation to QualityLevel

      representation = mapRepresentation(qualityLevels[i], streamIndex);

      if (representation !== null) {
        // Copy SegmentTemplate into Representation
        representation.SegmentTemplate = segmentTemplate;
        representations.push(representation);
      }
    }

    if (representations.length === 0) {
      return null;
    }

    adaptationSet.Representation = representations.length > 1 ? representations : representations[0];
    adaptationSet.Representation_asArray = representations; // Set SegmentTemplate

    adaptationSet.SegmentTemplate = segmentTemplate;
    return adaptationSet;
  }

  function mapRepresentation(qualityLevel, streamIndex) {
    var representation = {};
    var type = streamIndex.getAttribute('Type');
    var fourCCValue = null;
    var width = null;
    var height = null;
    representation.id = qualityLevel.Id;
    representation.bandwidth = parseInt(qualityLevel.getAttribute('Bitrate'), 10);
    representation.mimeType = qualityLevel.mimeType;
    width = parseInt(qualityLevel.getAttribute('MaxWidth'), 10);
    height = parseInt(qualityLevel.getAttribute('MaxHeight'), 10);
    if (!isNaN(width)) representation.width = width;
    if (!isNaN(height)) representation.height = height;
    fourCCValue = qualityLevel.getAttribute('FourCC'); // If FourCC not defined at QualityLevel level, then get it from StreamIndex level

    if (fourCCValue === null || fourCCValue === '') {
      fourCCValue = streamIndex.getAttribute('FourCC');
    } // If still not defined (optionnal for audio stream, see https://msdn.microsoft.com/en-us/library/ff728116%28v=vs.95%29.aspx),
    // then we consider the stream is an audio AAC stream


    if (fourCCValue === null || fourCCValue === '') {
      if (type === constants.AUDIO) {
        fourCCValue = 'AAC';
      } else if (type === constants.VIDEO) {
        logger.debug('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"');
        return null;
      }
    } // Check if codec is supported


    if (SUPPORTED_CODECS.indexOf(fourCCValue.toUpperCase()) === -1) {
      // Do not send warning
      logger.warn('Codec not supported: ' + fourCCValue);
      return null;
    } // Get codecs value according to FourCC field


    if (fourCCValue === 'H264' || fourCCValue === 'AVC1') {
      representation.codecs = getH264Codec(qualityLevel);
    } else if (fourCCValue.indexOf('AAC') >= 0) {
      representation.codecs = getAACCodec(qualityLevel, fourCCValue);
      representation.audioSamplingRate = parseInt(qualityLevel.getAttribute('SamplingRate'), 10);
      representation.audioChannels = parseInt(qualityLevel.getAttribute('Channels'), 10);
    } else if (fourCCValue.indexOf('TTML') || fourCCValue.indexOf('DFXP')) {
      representation.codecs = constants.STPP;
    }

    representation.codecPrivateData = '' + qualityLevel.getAttribute('CodecPrivateData');
    representation.BaseURL = qualityLevel.BaseURL;
    return representation;
  }

  function getH264Codec(qualityLevel) {
    var codecPrivateData = qualityLevel.getAttribute('CodecPrivateData').toString();
    var nalHeader, avcoti; // Extract from the CodecPrivateData field the hexadecimal representation of the following
    // three bytes in the sequence parameter set NAL unit.
    // => Find the SPS nal header

    nalHeader = /00000001[0-9]7/.exec(codecPrivateData); // => Find the 6 characters after the SPS nalHeader (if it exists)

    avcoti = nalHeader && nalHeader[0] ? codecPrivateData.substr(codecPrivateData.indexOf(nalHeader[0]) + 10, 6) : undefined;
    return 'avc1.' + avcoti;
  }

  function getAACCodec(qualityLevel, fourCCValue) {
    var samplingRate = parseInt(qualityLevel.getAttribute('SamplingRate'), 10);
    var codecPrivateData = qualityLevel.getAttribute('CodecPrivateData').toString();
    var objectType = 0;
    var codecPrivateDataHex, arr16, indexFreq, extensionSamplingFrequencyIndex; //chrome problem, in implicit AAC HE definition, so when AACH is detected in FourCC
    //set objectType to 5 => strange, it should be 2

    if (fourCCValue === 'AACH') {
      objectType = 0x05;
    } //if codecPrivateData is empty, build it :


    if (codecPrivateData === undefined || codecPrivateData === '') {
      objectType = 0x02; //AAC Main Low Complexity => object Type = 2

      indexFreq = samplingFrequencyIndex[samplingRate];

      if (fourCCValue === 'AACH') {
        // 4 bytes :     XXXXX         XXXX          XXXX             XXXX                  XXXXX      XXX   XXXXXXX
        //           ' ObjectType' 'Freq Index' 'Channels value'   'Extens Sampl Freq'  'ObjectType'  'GAS' 'alignment = 0'
        objectType = 0x05; // High Efficiency AAC Profile = object Type = 5 SBR

        codecPrivateData = new Uint8Array(4);
        extensionSamplingFrequencyIndex = samplingFrequencyIndex[samplingRate * 2]; // in HE AAC Extension Sampling frequence
        // equals to SamplingRate*2
        //Freq Index is present for 3 bits in the first byte, last bit is in the second

        codecPrivateData[0] = objectType << 3 | indexFreq >> 1;
        codecPrivateData[1] = indexFreq << 7 | qualityLevel.Channels << 3 | extensionSamplingFrequencyIndex >> 1;
        codecPrivateData[2] = extensionSamplingFrequencyIndex << 7 | 0x02 << 2; // origin object type equals to 2 => AAC Main Low Complexity

        codecPrivateData[3] = 0x0; //alignment bits

        arr16 = new Uint16Array(2);
        arr16[0] = (codecPrivateData[0] << 8) + codecPrivateData[1];
        arr16[1] = (codecPrivateData[2] << 8) + codecPrivateData[3]; //convert decimal to hex value

        codecPrivateDataHex = arr16[0].toString(16);
        codecPrivateDataHex = arr16[0].toString(16) + arr16[1].toString(16);
      } else {
        // 2 bytes :     XXXXX         XXXX          XXXX              XXX
        //           ' ObjectType' 'Freq Index' 'Channels value'   'GAS = 000'
        codecPrivateData = new Uint8Array(2); //Freq Index is present for 3 bits in the first byte, last bit is in the second

        codecPrivateData[0] = objectType << 3 | indexFreq >> 1;
        codecPrivateData[1] = indexFreq << 7 | parseInt(qualityLevel.getAttribute('Channels'), 10) << 3; // put the 2 bytes in an 16 bits array

        arr16 = new Uint16Array(1);
        arr16[0] = (codecPrivateData[0] << 8) + codecPrivateData[1]; //convert decimal to hex value

        codecPrivateDataHex = arr16[0].toString(16);
      }

      codecPrivateData = '' + codecPrivateDataHex;
      codecPrivateData = codecPrivateData.toUpperCase();
      qualityLevel.setAttribute('CodecPrivateData', codecPrivateData);
    } else if (objectType === 0) {
      objectType = (parseInt(codecPrivateData.substr(0, 2), 16) & 0xF8) >> 3;
    }

    return 'mp4a.40.' + objectType;
  }

  function mapSegmentTemplate(streamIndex, timescale) {
    var segmentTemplate = {};
    var mediaUrl, streamIndexTimeScale, url;
    url = streamIndex.getAttribute('Url');
    mediaUrl = url ? url.replace('{bitrate}', '$Bandwidth$') : null;
    mediaUrl = mediaUrl ? mediaUrl.replace('{start time}', '$Time$') : null;
    streamIndexTimeScale = streamIndex.getAttribute('TimeScale');
    streamIndexTimeScale = streamIndexTimeScale ? parseFloat(streamIndexTimeScale) : timescale;
    segmentTemplate.media = mediaUrl;
    segmentTemplate.timescale = streamIndexTimeScale;
    segmentTemplate.SegmentTimeline = mapSegmentTimeline(streamIndex, segmentTemplate.timescale); // Patch: set availabilityTimeOffset to Infinity since segments are available as long as they are present in timeline

    segmentTemplate.availabilityTimeOffset = 'INF';
    return segmentTemplate;
  }

  function mapSegmentTimeline(streamIndex, timescale) {
    var segmentTimeline = {};
    var chunks = streamIndex.getElementsByTagName('c');
    var segments = [];
    var segment, prevSegment, tManifest, i, j, r;
    var duration = 0;

    for (i = 0; i < chunks.length; i++) {
      segment = {}; // Get time 't' attribute value

      tManifest = chunks[i].getAttribute('t'); // => segment.tManifest = original timestamp value as a string (for constructing the fragment request url, see DashHandler)
      // => segment.t = number value of timestamp (maybe rounded value, but only for 0.1 microsecond)

      if (tManifest && _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(tManifest).greater(_externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(Number.MAX_SAFE_INTEGER))) {
        segment.tManifest = tManifest;
      }

      segment.t = parseFloat(tManifest); // Get duration 'd' attribute value

      segment.d = parseFloat(chunks[i].getAttribute('d')); // If 't' not defined for first segment then t=0

      if (i === 0 && !segment.t) {
        segment.t = 0;
      }

      if (i > 0) {
        prevSegment = segments[segments.length - 1]; // Update previous segment duration if not defined

        if (!prevSegment.d) {
          if (prevSegment.tManifest) {
            prevSegment.d = _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(tManifest).subtract(_externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(prevSegment.tManifest)).toJSNumber();
          } else {
            prevSegment.d = segment.t - prevSegment.t;
          }

          duration += prevSegment.d;
        } // Set segment absolute timestamp if not set in manifest


        if (!segment.t) {
          if (prevSegment.tManifest) {
            segment.tManifest = _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(prevSegment.tManifest).add(_externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(prevSegment.d)).toString();
            segment.t = parseFloat(segment.tManifest);
          } else {
            segment.t = prevSegment.t + prevSegment.d;
          }
        }
      }

      if (segment.d) {
        duration += segment.d;
      } // Create new segment


      segments.push(segment); // Support for 'r' attribute (i.e. "repeat" as in MPEG-DASH)

      r = parseFloat(chunks[i].getAttribute('r'));

      if (r) {
        for (j = 0; j < r - 1; j++) {
          prevSegment = segments[segments.length - 1];
          segment = {};
          segment.t = prevSegment.t + prevSegment.d;
          segment.d = prevSegment.d;

          if (prevSegment.tManifest) {
            segment.tManifest = _externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(prevSegment.tManifest).add(_externals_BigInteger__WEBPACK_IMPORTED_MODULE_0___default()(prevSegment.d)).toString();
          }

          duration += segment.d;
          segments.push(segment);
        }
      }
    }

    segmentTimeline.S = segments;
    segmentTimeline.S_asArray = segments;
    segmentTimeline.duration = duration / timescale;
    return segmentTimeline;
  }

  function getKIDFromProtectionHeader(protectionHeader) {
    var prHeader, wrmHeader, xmlReader, KID; // Get PlayReady header as byte array (base64 decoded)

    prHeader = BASE64.decodeArray(protectionHeader.firstChild.data); // Get Right Management header (WRMHEADER) from PlayReady header

    wrmHeader = getWRMHeaderFromPRHeader(prHeader);

    if (wrmHeader) {
      // Convert from multi-byte to unicode
      wrmHeader = new Uint16Array(wrmHeader.buffer); // Convert to string

      wrmHeader = String.fromCharCode.apply(null, wrmHeader); // Parse <WRMHeader> to get KID field value

      xmlReader = new DOMParser().parseFromString(wrmHeader, 'application/xml');
      KID = xmlReader.querySelector('KID').textContent; // Get KID (base64 decoded) as byte array

      KID = BASE64.decodeArray(KID); // Convert UUID from little-endian to big-endian

      convertUuidEndianness(KID);
    }

    return KID;
  }

  function getWRMHeaderFromPRHeader(prHeader) {
    var length, recordCount, recordType, recordLength, recordValue;
    var i = 0; // Parse PlayReady header
    // Length - 32 bits (LE format)

    length = (prHeader[i + 3] << 24) + (prHeader[i + 2] << 16) + (prHeader[i + 1] << 8) + prHeader[i]; // eslint-disable-line

    i += 4; // Record count - 16 bits (LE format)

    recordCount = (prHeader[i + 1] << 8) + prHeader[i]; // eslint-disable-line

    i += 2; // Parse records

    while (i < prHeader.length) {
      // Record type - 16 bits (LE format)
      recordType = (prHeader[i + 1] << 8) + prHeader[i];
      i += 2; // Check if Rights Management header (record type = 0x01)

      if (recordType === 0x01) {
        // Record length - 16 bits (LE format)
        recordLength = (prHeader[i + 1] << 8) + prHeader[i];
        i += 2; // Record value => contains <WRMHEADER>

        recordValue = new Uint8Array(recordLength);
        recordValue.set(prHeader.subarray(i, i + recordLength));
        return recordValue;
      }
    }

    return null;
  }

  function convertUuidEndianness(uuid) {
    swapBytes(uuid, 0, 3);
    swapBytes(uuid, 1, 2);
    swapBytes(uuid, 4, 5);
    swapBytes(uuid, 6, 7);
  }

  function swapBytes(bytes, pos1, pos2) {
    var temp = bytes[pos1];
    bytes[pos1] = bytes[pos2];
    bytes[pos2] = temp;
  }

  function createPRContentProtection(protectionHeader) {
    var pro = {
      __text: protectionHeader.firstChild.data,
      __prefix: 'mspr'
    };
    return {
      schemeIdUri: 'urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95',
      value: 'com.microsoft.playready',
      pro: pro,
      pro_asArray: pro
    };
  }

  function createWidevineContentProtection(KID) {
    var widevineCP = {
      schemeIdUri: 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed',
      value: 'com.widevine.alpha'
    };
    if (!KID) return widevineCP; // Create Widevine CENC header (Protocol Buffer) with KID value

    var wvCencHeader = new Uint8Array(2 + KID.length);
    wvCencHeader[0] = 0x12;
    wvCencHeader[1] = 0x10;
    wvCencHeader.set(KID, 2); // Create a pssh box

    var length = 12
    /* box length, type, version and flags */
    + 16
    /* SystemID */
    + 4
    /* data length */
    + wvCencHeader.length;
    var pssh = new Uint8Array(length);
    var i = 0; // Set box length value

    pssh[i++] = (length & 0xFF000000) >> 24;
    pssh[i++] = (length & 0x00FF0000) >> 16;
    pssh[i++] = (length & 0x0000FF00) >> 8;
    pssh[i++] = length & 0x000000FF; // Set type ('pssh'), version (0) and flags (0)

    pssh.set([0x70, 0x73, 0x73, 0x68, 0x00, 0x00, 0x00, 0x00], i);
    i += 8; // Set SystemID ('edef8ba9-79d6-4ace-a3c8-27dcd51d21ed')

    pssh.set([0xed, 0xef, 0x8b, 0xa9, 0x79, 0xd6, 0x4a, 0xce, 0xa3, 0xc8, 0x27, 0xdc, 0xd5, 0x1d, 0x21, 0xed], i);
    i += 16; // Set data length value

    pssh[i++] = (wvCencHeader.length & 0xFF000000) >> 24;
    pssh[i++] = (wvCencHeader.length & 0x00FF0000) >> 16;
    pssh[i++] = (wvCencHeader.length & 0x0000FF00) >> 8;
    pssh[i++] = wvCencHeader.length & 0x000000FF; // Copy Widevine CENC header

    pssh.set(wvCencHeader, i); // Convert to BASE64 string

    pssh = String.fromCharCode.apply(null, pssh);
    pssh = BASE64.encodeASCII(pssh);
    widevineCP.pssh = {
      __text: pssh
    };
    return widevineCP;
  }

  function processManifest(xmlDoc) {
    var manifest = {};
    var contentProtections = [];
    var smoothStreamingMedia = xmlDoc.getElementsByTagName('SmoothStreamingMedia')[0];
    var protection = xmlDoc.getElementsByTagName('Protection')[0];
    var protectionHeader = null;
    var period, adaptations, contentProtection, KID, timestampOffset, startTime, segments, timescale, segmentDuration, i, j; // Set manifest node properties

    manifest.protocol = 'MSS';
    manifest.profiles = 'urn:mpeg:dash:profile:isoff-live:2011';
    manifest.type = getAttributeAsBoolean(smoothStreamingMedia, 'IsLive') ? 'dynamic' : 'static';
    timescale = smoothStreamingMedia.getAttribute('TimeScale');
    manifest.timescale = timescale ? parseFloat(timescale) : DEFAULT_TIME_SCALE;
    var dvrWindowLength = parseFloat(smoothStreamingMedia.getAttribute('DVRWindowLength')); // If the DVRWindowLength field is omitted for a live presentation or set to 0, the DVR window is effectively infinite

    if (manifest.type === 'dynamic' && (dvrWindowLength === 0 || isNaN(dvrWindowLength))) {
      dvrWindowLength = Infinity;
    } // Star-over


    if (dvrWindowLength === 0 && getAttributeAsBoolean(smoothStreamingMedia, 'CanSeek')) {
      dvrWindowLength = Infinity;
    }

    if (dvrWindowLength > 0) {
      manifest.timeShiftBufferDepth = dvrWindowLength / manifest.timescale;
    }

    var duration = parseFloat(smoothStreamingMedia.getAttribute('Duration'));
    manifest.mediaPresentationDuration = duration === 0 ? Infinity : duration / manifest.timescale; // By default, set minBufferTime to 2 sec. (but set below according to video segment duration)

    manifest.minBufferTime = 2;
    manifest.ttmlTimeIsRelative = true; // Live manifest with Duration = start-over

    if (manifest.type === 'dynamic' && duration > 0) {
      manifest.type = 'static'; // We set timeShiftBufferDepth to initial duration, to be used by MssFragmentController to update segment timeline

      manifest.timeShiftBufferDepth = duration / manifest.timescale; // Duration will be set according to current segment timeline duration (see below)
    }

    if (manifest.type === 'dynamic') {
      manifest.refreshManifestOnSwitchTrack = true; // Refresh manifest when switching tracks

      manifest.doNotUpdateDVRWindowOnBufferUpdated = true; // DVRWindow is update by MssFragmentMoofPocessor based on tfrf boxes

      manifest.ignorePostponeTimePeriod = true; // Never update manifest

      manifest.availabilityStartTime = new Date(null); // Returns 1970
    } // Map period node to manifest root node


    manifest.Period = mapPeriod(smoothStreamingMedia, manifest.timescale);
    manifest.Period_asArray = [manifest.Period]; // Initialize period start time

    period = manifest.Period;
    period.start = 0; // Uncomment to test live to static manifests
    // if (manifest.type !== 'static') {
    //     manifest.type = 'static';
    //     manifest.mediaPresentationDuration = manifest.timeShiftBufferDepth;
    //     manifest.timeShiftBufferDepth = null;
    // }
    // ContentProtection node

    if (protection !== undefined) {
      protectionHeader = xmlDoc.getElementsByTagName('ProtectionHeader')[0]; // Some packagers put newlines into the ProtectionHeader base64 string, which is not good
      // because this cannot be correctly parsed. Let's just filter out any newlines found in there.

      protectionHeader.firstChild.data = protectionHeader.firstChild.data.replace(/\n|\r/g, ''); // Get KID (in CENC format) from protection header

      KID = getKIDFromProtectionHeader(protectionHeader); // Create ContentProtection for PlayReady

      contentProtection = createPRContentProtection(protectionHeader);
      contentProtection['cenc:default_KID'] = KID;
      contentProtections.push(contentProtection); // Create ContentProtection for Widevine (as a CENC protection)

      contentProtection = createWidevineContentProtection(KID);
      contentProtection['cenc:default_KID'] = KID;
      contentProtections.push(contentProtection);
      manifest.ContentProtection = contentProtections;
      manifest.ContentProtection_asArray = contentProtections;
    }

    adaptations = period.AdaptationSet_asArray;

    for (i = 0; i < adaptations.length; i += 1) {
      adaptations[i].SegmentTemplate.initialization = '$Bandwidth$'; // Propagate content protection information into each adaptation

      if (manifest.ContentProtection !== undefined) {
        adaptations[i].ContentProtection = manifest.ContentProtection;
        adaptations[i].ContentProtection_asArray = manifest.ContentProtection_asArray;
      }

      if (adaptations[i].contentType === 'video') {
        // Get video segment duration
        segmentDuration = adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray[0].d / adaptations[i].SegmentTemplate.timescale; // Set minBufferTime to one segment duration

        manifest.minBufferTime = segmentDuration;

        if (manifest.type === 'dynamic') {
          // Match timeShiftBufferDepth to video segment timeline duration
          if (manifest.timeShiftBufferDepth > 0 && manifest.timeShiftBufferDepth !== Infinity && manifest.timeShiftBufferDepth > adaptations[i].SegmentTemplate.SegmentTimeline.duration) {
            manifest.timeShiftBufferDepth = adaptations[i].SegmentTemplate.SegmentTimeline.duration;
          }
        }
      }
    } // Cap minBufferTime to timeShiftBufferDepth


    manifest.minBufferTime = Math.min(manifest.minBufferTime, manifest.timeShiftBufferDepth ? manifest.timeShiftBufferDepth : Infinity); // In case of live streams:
    // 1- configure player buffering properties according to target live delay
    // 2- adapt live delay and then buffers length in case timeShiftBufferDepth is too small compared to target live delay (see PlaybackController.computeLiveDelay())
    // 3- Set retry attempts and intervals for FragmentInfo requests

    if (manifest.type === 'dynamic') {
      var targetLiveDelay = settings.get().streaming.delay.liveDelay;

      if (!targetLiveDelay) {
        var liveDelayFragmentCount = settings.get().streaming.delay.liveDelayFragmentCount !== null && !isNaN(settings.get().streaming.delay.liveDelayFragmentCount) ? settings.get().streaming.delay.liveDelayFragmentCount : 4;
        targetLiveDelay = segmentDuration * liveDelayFragmentCount;
      }

      var targetDelayCapping = Math.max(manifest.timeShiftBufferDepth - 10
      /*END_OF_PLAYLIST_PADDING*/
      , manifest.timeShiftBufferDepth / 2);
      var liveDelay = Math.min(targetDelayCapping, targetLiveDelay); // Consider a margin of more than one segment in order to avoid Precondition Failed errors (412), for example if audio and video are not correctly synchronized

      var bufferTime = liveDelay - segmentDuration * 1.5; // Store initial buffer settings

      initialBufferSettings = {
        'streaming': {
          'buffer': {
            'stableBufferTime': settings.get().streaming.buffer.stableBufferTime,
            'bufferTimeAtTopQuality': settings.get().streaming.buffer.bufferTimeAtTopQuality,
            'bufferTimeAtTopQualityLongForm': settings.get().streaming.buffer.bufferTimeAtTopQualityLongForm
          },
          'timeShiftBuffer': {
            calcFromSegmentTimeline: settings.get().streaming.timeShiftBuffer.calcFromSegmentTimeline
          },
          'delay': {
            'liveDelay': settings.get().streaming.delay.liveDelay
          }
        }
      };
      settings.update({
        'streaming': {
          'buffer': {
            'stableBufferTime': bufferTime,
            'bufferTimeAtTopQuality': bufferTime,
            'bufferTimeAtTopQualityLongForm': bufferTime
          },
          'timeShiftBuffer': {
            calcFromSegmentTimeline: true
          },
          'delay': {
            'liveDelay': liveDelay
          }
        }
      });
    } // Delete Content Protection under root manifest node


    delete manifest.ContentProtection;
    delete manifest.ContentProtection_asArray; // In case of VOD streams, check if start time is greater than 0
    // Then determine timestamp offset according to higher audio/video start time
    // (use case = live stream delinearization)

    if (manifest.type === 'static') {
      // In case of start-over stream and manifest reloading (due to track switch)
      // we consider previous timestampOffset to keep timelines synchronized
      var prevManifest = manifestModel.getValue();

      if (prevManifest && prevManifest.timestampOffset) {
        timestampOffset = prevManifest.timestampOffset;
      } else {
        for (i = 0; i < adaptations.length; i++) {
          if (adaptations[i].contentType === constants.AUDIO || adaptations[i].contentType === constants.VIDEO) {
            segments = adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray;
            startTime = segments[0].t;

            if (timestampOffset === undefined) {
              timestampOffset = startTime;
            }

            timestampOffset = Math.min(timestampOffset, startTime); // Correct content duration according to minimum adaptation's segment timeline duration
            // in order to force <video> element sending 'ended' event

            manifest.mediaPresentationDuration = Math.min(manifest.mediaPresentationDuration, adaptations[i].SegmentTemplate.SegmentTimeline.duration);
          }
        }
      }

      if (timestampOffset > 0) {
        // Patch segment templates timestamps and determine period start time (since audio/video should not be aligned to 0)
        manifest.timestampOffset = timestampOffset;

        for (i = 0; i < adaptations.length; i++) {
          segments = adaptations[i].SegmentTemplate.SegmentTimeline.S_asArray;

          for (j = 0; j < segments.length; j++) {
            if (!segments[j].tManifest) {
              segments[j].tManifest = segments[j].t.toString();
            }

            segments[j].t -= timestampOffset;
          }

          if (adaptations[i].contentType === constants.AUDIO || adaptations[i].contentType === constants.VIDEO) {
            period.start = Math.max(segments[0].t, period.start);
            adaptations[i].SegmentTemplate.presentationTimeOffset = period.start;
          }
        }

        period.start /= manifest.timescale;
      }
    } // Floor the duration to get around precision differences between segments timestamps and MSE buffer timestamps
    // and then avoid 'ended' event not being raised


    manifest.mediaPresentationDuration = Math.floor(manifest.mediaPresentationDuration * 1000) / 1000;
    period.duration = manifest.mediaPresentationDuration;
    return manifest;
  }

  function parseDOM(data) {
    var xmlDoc = null;

    if (window.DOMParser) {
      var parser = new window.DOMParser();
      xmlDoc = parser.parseFromString(data, 'text/xml');

      if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
        throw new Error('parsing the manifest failed');
      }
    }

    return xmlDoc;
  }

  function getMatchers() {
    return null;
  }

  function getIron() {
    return null;
  }

  function internalParse(data) {
    var xmlDoc = null;
    var manifest = null;
    var startTime = window.performance.now(); // Parse the MSS XML manifest

    xmlDoc = parseDOM(data);
    var xmlParseTime = window.performance.now();

    if (xmlDoc === null) {
      return null;
    } // Convert MSS manifest into DASH manifest


    manifest = processManifest(xmlDoc, new Date());
    var mss2dashTime = window.performance.now();
    logger.info('Parsing complete: (xmlParsing: ' + (xmlParseTime - startTime).toPrecision(3) + 'ms, mss2dash: ' + (mss2dashTime - xmlParseTime).toPrecision(3) + 'ms, total: ' + ((mss2dashTime - startTime) / 1000).toPrecision(3) + 's)');
    return manifest;
  }

  function reset() {
    // Restore initial buffer settings
    if (initialBufferSettings) {
      settings.update(initialBufferSettings);
    }
  }

  instance = {
    parse: internalParse,
    getMatchers: getMatchers,
    getIron: getIron,
    reset: reset
  };
  setup();
  return instance;
}

MssParser.__dashjs_factory_name = 'MssParser';
/* harmony default export */ __webpack_exports__["default"] = (dashjs.FactoryMaker.getClassFactory(MssParser));
/* jshint ignore:line */

/***/ }),

/***/ "./src/streaming/MediaPlayerEvents.js":
/*!********************************************!*\
  !*** ./src/streaming/MediaPlayerEvents.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_169763__) {

"use strict";
__nested_webpack_require_169763__.r(__webpack_exports__);
/* harmony import */ var _core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_169763__(/*! ../core/events/EventsBase */ "./src/core/events/EventsBase.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @implements EventsBase
 */

var MediaPlayerEvents = /*#__PURE__*/function (_EventsBase) {
  _inherits(MediaPlayerEvents, _EventsBase);

  var _super = _createSuper(MediaPlayerEvents);

  /**
   * @description Public facing external events to be used when developing a player that implements dash.js.
   */
  function MediaPlayerEvents() {
    var _this;

    _classCallCheck(this, MediaPlayerEvents);

    _this = _super.call(this);
    /**
     * Triggered when playback will not start yet
     * as the MPD's availabilityStartTime is in the future.
     * Check delay property in payload to determine time before playback will start.
     * @event MediaPlayerEvents#AST_IN_FUTURE
     */

    _this.AST_IN_FUTURE = 'astInFuture';
    /**
     * Triggered when the video element's buffer state changes to stalled.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_EMPTY
     */

    _this.BUFFER_EMPTY = 'bufferStalled';
    /**
     * Triggered when the video element's buffer state changes to loaded.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_LOADED
     */

    _this.BUFFER_LOADED = 'bufferLoaded';
    /**
     * Triggered when the video element's buffer state changes, either stalled or loaded. Check payload for state.
     * @event MediaPlayerEvents#BUFFER_LEVEL_STATE_CHANGED
     */

    _this.BUFFER_LEVEL_STATE_CHANGED = 'bufferStateChanged';
    /**
     * Triggered when the buffer level of a media type has been updated
     * @event MediaPlayerEvents#BUFFER_LEVEL_UPDATED
     */

    _this.BUFFER_LEVEL_UPDATED = 'bufferLevelUpdated';
    /**
     * Triggered when a dynamic stream changed to static (transition phase between Live and On-Demand).
     * @event MediaPlayerEvents#DYNAMIC_TO_STATIC
     */

    _this.DYNAMIC_TO_STATIC = 'dynamicToStatic';
    /**
     * Triggered when there is an error from the element or MSE source buffer.
     * @event MediaPlayerEvents#ERROR
     */

    _this.ERROR = 'error';
    /**
     * Triggered when a fragment download has completed.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_COMPLETED
     */

    _this.FRAGMENT_LOADING_COMPLETED = 'fragmentLoadingCompleted';
    /**
     * Triggered when a partial fragment download has completed.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_PROGRESS
     */

    _this.FRAGMENT_LOADING_PROGRESS = 'fragmentLoadingProgress';
    /**
     * Triggered when a fragment download has started.
     * @event MediaPlayerEvents#FRAGMENT_LOADING_STARTED
     */

    _this.FRAGMENT_LOADING_STARTED = 'fragmentLoadingStarted';
    /**
     * Triggered when a fragment download is abandoned due to detection of slow download base on the ABR abandon rule..
     * @event MediaPlayerEvents#FRAGMENT_LOADING_ABANDONED
     */

    _this.FRAGMENT_LOADING_ABANDONED = 'fragmentLoadingAbandoned';
    /**
     * Triggered when {@link module:Debug} logger methods are called.
     * @event MediaPlayerEvents#LOG
     */

    _this.LOG = 'log';
    /**
     * Triggered when the manifest load is complete
     * @event MediaPlayerEvents#MANIFEST_LOADED
     */

    _this.MANIFEST_LOADED = 'manifestLoaded';
    /**
     * Triggered anytime there is a change to the overall metrics.
     * @event MediaPlayerEvents#METRICS_CHANGED
     */

    _this.METRICS_CHANGED = 'metricsChanged';
    /**
     * Triggered when an individual metric is added, updated or cleared.
     * @event MediaPlayerEvents#METRIC_CHANGED
     */

    _this.METRIC_CHANGED = 'metricChanged';
    /**
     * Triggered every time a new metric is added.
     * @event MediaPlayerEvents#METRIC_ADDED
     */

    _this.METRIC_ADDED = 'metricAdded';
    /**
     * Triggered every time a metric is updated.
     * @event MediaPlayerEvents#METRIC_UPDATED
     */

    _this.METRIC_UPDATED = 'metricUpdated';
    /**
     * Triggered when a new stream (period) starts.
     * @event MediaPlayerEvents#PERIOD_SWITCH_STARTED
     */

    _this.PERIOD_SWITCH_STARTED = 'periodSwitchStarted';
    /**
     * Triggered at the stream end of a period.
     * @event MediaPlayerEvents#PERIOD_SWITCH_COMPLETED
     */

    _this.PERIOD_SWITCH_COMPLETED = 'periodSwitchCompleted';
    /**
     * Triggered when an ABR up /down switch is initiated; either by user in manual mode or auto mode via ABR rules.
     * @event MediaPlayerEvents#QUALITY_CHANGE_REQUESTED
     */

    _this.QUALITY_CHANGE_REQUESTED = 'qualityChangeRequested';
    /**
     * Triggered when the new ABR quality is being rendered on-screen.
     * @event MediaPlayerEvents#QUALITY_CHANGE_RENDERED
     */

    _this.QUALITY_CHANGE_RENDERED = 'qualityChangeRendered';
    /**
     * Triggered when the new track is being rendered.
     * @event MediaPlayerEvents#TRACK_CHANGE_RENDERED
     */

    _this.TRACK_CHANGE_RENDERED = 'trackChangeRendered';
    /**
     * Triggered when a stream (period) is being loaded
     * @event MediaPlayerEvents#STREAM_INITIALIZING
     */

    _this.STREAM_INITIALIZING = 'streamInitializing';
    /**
     * Triggered when a stream (period) is loaded
     * @event MediaPlayerEvents#STREAM_UPDATED
     */

    _this.STREAM_UPDATED = 'streamUpdated';
    /**
     * Triggered when a stream (period) is activated
     * @event MediaPlayerEvents#STREAM_ACTIVATED
     */

    _this.STREAM_ACTIVATED = 'streamActivated';
    /**
     * Triggered when a stream (period) is deactivated
     * @event MediaPlayerEvents#STREAM_DEACTIVATED
     */

    _this.STREAM_DEACTIVATED = 'streamDeactivated';
    /**
     * Triggered when a stream (period) is activated
     * @event MediaPlayerEvents#STREAM_INITIALIZED
     */

    _this.STREAM_INITIALIZED = 'streamInitialized';
    /**
     * Triggered when the player has been reset.
     * @event MediaPlayerEvents#STREAM_TEARDOWN_COMPLETE
     */

    _this.STREAM_TEARDOWN_COMPLETE = 'streamTeardownComplete';
    /**
     * Triggered once all text tracks detected in the MPD are added to the video element.
     * @event MediaPlayerEvents#TEXT_TRACKS_ADDED
     */

    _this.TEXT_TRACKS_ADDED = 'allTextTracksAdded';
    /**
     * Triggered when a text track is added to the video element's TextTrackList
     * @event MediaPlayerEvents#TEXT_TRACK_ADDED
     */

    _this.TEXT_TRACK_ADDED = 'textTrackAdded';
    /**
     * Triggered when a ttml chunk is parsed.
     * @event MediaPlayerEvents#TTML_PARSED
     */

    _this.TTML_PARSED = 'ttmlParsed';
    /**
     * Triggered when a ttml chunk has to be parsed.
     * @event MediaPlayerEvents#TTML_TO_PARSE
     */

    _this.TTML_TO_PARSE = 'ttmlToParse';
    /**
     * Triggered when a caption is rendered.
     * @event MediaPlayerEvents#CAPTION_RENDERED
     */

    _this.CAPTION_RENDERED = 'captionRendered';
    /**
     * Triggered when the caption container is resized.
     * @event MediaPlayerEvents#CAPTION_CONTAINER_RESIZE
     */

    _this.CAPTION_CONTAINER_RESIZE = 'captionContainerResize';
    /**
     * Sent when enough data is available that the media can be played,
     * at least for a couple of frames.  This corresponds to the
     * HAVE_ENOUGH_DATA readyState.
     * @event MediaPlayerEvents#CAN_PLAY
     */

    _this.CAN_PLAY = 'canPlay';
    /**
     * This corresponds to the CAN_PLAY_THROUGH readyState.
     * @event MediaPlayerEvents#CAN_PLAY_THROUGH
     */

    _this.CAN_PLAY_THROUGH = 'canPlayThrough';
    /**
     * Sent when playback completes.
     * @event MediaPlayerEvents#PLAYBACK_ENDED
     */

    _this.PLAYBACK_ENDED = 'playbackEnded';
    /**
     * Sent when an error occurs.  The element's error
     * attribute contains more information.
     * @event MediaPlayerEvents#PLAYBACK_ERROR
     */

    _this.PLAYBACK_ERROR = 'playbackError';
    /**
     * Sent when playback is not allowed (for example if user gesture is needed).
     * @event MediaPlayerEvents#PLAYBACK_NOT_ALLOWED
     */

    _this.PLAYBACK_NOT_ALLOWED = 'playbackNotAllowed';
    /**
     * The media's metadata has finished loading; all attributes now
     * contain as much useful information as they're going to.
     * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
     */

    _this.PLAYBACK_METADATA_LOADED = 'playbackMetaDataLoaded';
    /**
     * The media's metadata has finished loading; all attributes now
     * contain as much useful information as they're going to.
     * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
     */

    _this.PLAYBACK_LOADED_DATA = 'playbackLoadedData';
    /**
     * Sent when playback is paused.
     * @event MediaPlayerEvents#PLAYBACK_PAUSED
     */

    _this.PLAYBACK_PAUSED = 'playbackPaused';
    /**
     * Sent when the media begins to play (either for the first time, after having been paused,
     * or after ending and then restarting).
     *
     * @event MediaPlayerEvents#PLAYBACK_PLAYING
     */

    _this.PLAYBACK_PLAYING = 'playbackPlaying';
    /**
     * Sent periodically to inform interested parties of progress downloading
     * the media. Information about the current amount of the media that has
     * been downloaded is available in the media element's buffered attribute.
     * @event MediaPlayerEvents#PLAYBACK_PROGRESS
     */

    _this.PLAYBACK_PROGRESS = 'playbackProgress';
    /**
     * Sent when the playback speed changes.
     * @event MediaPlayerEvents#PLAYBACK_RATE_CHANGED
     */

    _this.PLAYBACK_RATE_CHANGED = 'playbackRateChanged';
    /**
     * Sent when a seek operation completes.
     * @event MediaPlayerEvents#PLAYBACK_SEEKED
     */

    _this.PLAYBACK_SEEKED = 'playbackSeeked';
    /**
     * Sent when a seek operation begins.
     * @event MediaPlayerEvents#PLAYBACK_SEEKING
     */

    _this.PLAYBACK_SEEKING = 'playbackSeeking';
    /**
     * Sent when the video element reports stalled
     * @event MediaPlayerEvents#PLAYBACK_STALLED
     */

    _this.PLAYBACK_STALLED = 'playbackStalled';
    /**
     * Sent when playback of the media starts after having been paused;
     * that is, when playback is resumed after a prior pause event.
     *
     * @event MediaPlayerEvents#PLAYBACK_STARTED
     */

    _this.PLAYBACK_STARTED = 'playbackStarted';
    /**
     * The time indicated by the element's currentTime attribute has changed.
     * @event MediaPlayerEvents#PLAYBACK_TIME_UPDATED
     */

    _this.PLAYBACK_TIME_UPDATED = 'playbackTimeUpdated';
    /**
     * Sent when the media playback has stopped because of a temporary lack of data.
     *
     * @event MediaPlayerEvents#PLAYBACK_WAITING
     */

    _this.PLAYBACK_WAITING = 'playbackWaiting';
    /**
     * Manifest validity changed - As a result of an MPD validity expiration event.
     * @event MediaPlayerEvents#MANIFEST_VALIDITY_CHANGED
     */

    _this.MANIFEST_VALIDITY_CHANGED = 'manifestValidityChanged';
    /**
     * Dash events are triggered at their respective start points on the timeline.
     * @event MediaPlayerEvents#EVENT_MODE_ON_START
     */

    _this.EVENT_MODE_ON_START = 'eventModeOnStart';
    /**
     * Dash events are triggered as soon as they were parsed.
     * @event MediaPlayerEvents#EVENT_MODE_ON_RECEIVE
     */

    _this.EVENT_MODE_ON_RECEIVE = 'eventModeOnReceive';
    /**
     * Event that is dispatched whenever the player encounters a potential conformance validation that might lead to unexpected/not optimal behavior
     * @event MediaPlayerEvents#CONFORMANCE_VIOLATION
     */

    _this.CONFORMANCE_VIOLATION = 'conformanceViolation';
    /**
     * Event that is dispatched whenever the player switches to a different representation
     * @event MediaPlayerEvents#REPRESENTATION_SWITCH
     */

    _this.REPRESENTATION_SWITCH = 'representationSwitch';
    /**
     * Event that is dispatched whenever an adaptation set is removed due to all representations not being supported.
     * @event MediaPlayerEvents#ADAPTATION_SET_REMOVED_NO_CAPABILITIES
     */

    _this.ADAPTATION_SET_REMOVED_NO_CAPABILITIES = 'adaptationSetRemovedNoCapabilities';
    return _this;
  }

  return MediaPlayerEvents;
}(_core_events_EventsBase__WEBPACK_IMPORTED_MODULE_0__["default"]);

var mediaPlayerEvents = new MediaPlayerEvents();
/* harmony default export */ __webpack_exports__["default"] = (mediaPlayerEvents);

/***/ }),

/***/ "./src/streaming/vo/DashJSError.js":
/*!*****************************************!*\
  !*** ./src/streaming/vo/DashJSError.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_187288__) {

"use strict";
__nested_webpack_require_187288__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DashJSError = function DashJSError(code, message, data) {
  _classCallCheck(this, DashJSError);

  this.code = code || null;
  this.message = message || null;
  this.data = data || null;
};

/* harmony default export */ __webpack_exports__["default"] = (DashJSError);

/***/ }),

/***/ "./src/streaming/vo/DataChunk.js":
/*!***************************************!*\
  !*** ./src/streaming/vo/DataChunk.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_189984__) {

"use strict";
__nested_webpack_require_189984__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */
var DataChunk = //Represents a data structure that keep all the necessary info about a single init/media segment
function DataChunk() {
  _classCallCheck(this, DataChunk);

  this.streamId = null;
  this.mediaInfo = null;
  this.segmentType = null;
  this.quality = NaN;
  this.index = NaN;
  this.bytes = null;
  this.start = NaN;
  this.end = NaN;
  this.duration = NaN;
  this.representationId = null;
  this.endFragment = null;
};

/* harmony default export */ __webpack_exports__["default"] = (DataChunk);

/***/ }),

/***/ "./src/streaming/vo/FragmentRequest.js":
/*!*********************************************!*\
  !*** ./src/streaming/vo/FragmentRequest.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_192952__) {

"use strict";
__nested_webpack_require_192952__.r(__webpack_exports__);
/* harmony import */ var _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_192952__(/*! ../vo/metrics/HTTPRequest */ "./src/streaming/vo/metrics/HTTPRequest.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */

var FragmentRequest = /*#__PURE__*/function () {
  function FragmentRequest(url) {
    _classCallCheck(this, FragmentRequest);

    this.action = FragmentRequest.ACTION_DOWNLOAD;
    this.startTime = NaN;
    this.mediaStartTime = NaN;
    this.mediaType = null;
    this.mediaInfo = null;
    this.type = null;
    this.duration = NaN;
    this.timescale = NaN;
    this.range = null;
    this.url = url || null;
    this.serviceLocation = null;
    this.requestStartDate = null;
    this.firstByteDate = null;
    this.requestEndDate = null;
    this.quality = NaN;
    this.index = NaN;
    this.availabilityStartTime = null;
    this.availabilityEndTime = null;
    this.wallStartTime = null;
    this.bytesLoaded = NaN;
    this.bytesTotal = NaN;
    this.delayLoadingTime = NaN;
    this.responseType = 'arraybuffer';
    this.representationId = null;
  }

  _createClass(FragmentRequest, [{
    key: "isInitializationRequest",
    value: function isInitializationRequest() {
      return this.type && this.type === _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].INIT_SEGMENT_TYPE;
    }
  }, {
    key: "setInfo",
    value: function setInfo(info) {
      this.type = info && info.init ? _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].INIT_SEGMENT_TYPE : _vo_metrics_HTTPRequest__WEBPACK_IMPORTED_MODULE_0__["HTTPRequest"].MEDIA_SEGMENT_TYPE;
      this.url = info && info.url ? info.url : null;
      this.range = info && info.range ? info.range.start + '-' + info.range.end : null;
      this.mediaType = info && info.mediaType ? info.mediaType : null;
    }
  }]);

  return FragmentRequest;
}();

FragmentRequest.ACTION_DOWNLOAD = 'download';
FragmentRequest.ACTION_COMPLETE = 'complete';
/* harmony default export */ __webpack_exports__["default"] = (FragmentRequest);

/***/ }),

/***/ "./src/streaming/vo/metrics/HTTPRequest.js":
/*!*************************************************!*\
  !*** ./src/streaming/vo/metrics/HTTPRequest.js ***!
  \*************************************************/
/*! exports provided: HTTPRequest, HTTPRequestTrace */
/***/ (function(module, __webpack_exports__, __nested_webpack_require_198025__) {

"use strict";
__nested_webpack_require_198025__.r(__webpack_exports__);
/* harmony export (binding) */ __nested_webpack_require_198025__.d(__webpack_exports__, "HTTPRequest", function() { return HTTPRequest; });
/* harmony export (binding) */ __nested_webpack_require_198025__.d(__webpack_exports__, "HTTPRequestTrace", function() { return HTTPRequestTrace; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc This Object holds reference to the HTTPRequest for manifest, fragment and xlink loading.
 * Members which are not defined in ISO23009-1 Annex D should be prefixed by a _ so that they are ignored
 * by Metrics Reporting code.
 * @ignore
 */
var HTTPRequest =
/**
 * @class
 */
function HTTPRequest() {
  _classCallCheck(this, HTTPRequest);

  /**
   * Identifier of the TCP connection on which the HTTP request was sent.
   * @public
   */
  this.tcpid = null;
  /**
   * This is an optional parameter and should not be included in HTTP request/response transactions for progressive download.
   * The type of the request:
   * - MPD
   * - XLink expansion
   * - Initialization Fragment
   * - Index Fragment
   * - Media Fragment
   * - Bitstream Switching Fragment
   * - other
   * @public
   */

  this.type = null;
  /**
   * The original URL (before any redirects or failures)
   * @public
   */

  this.url = null;
  /**
   * The actual URL requested, if different from above
   * @public
   */

  this.actualurl = null;
  /**
   * The contents of the byte-range-spec part of the HTTP Range header.
   * @public
   */

  this.range = null;
  /**
   * Real-Time | The real time at which the request was sent.
   * @public
   */

  this.trequest = null;
  /**
   * Real-Time | The real time at which the first byte of the response was received.
   * @public
   */

  this.tresponse = null;
  /**
   * The HTTP response code.
   * @public
   */

  this.responsecode = null;
  /**
   * The duration of the throughput trace intervals (ms), for successful requests only.
   * @public
   */

  this.interval = null;
  /**
   * Throughput traces, for successful requests only.
   * @public
   */

  this.trace = [];
  /**
   * Type of stream ("audio" | "video" etc..)
   * @public
   */

  this._stream = null;
  /**
   * Real-Time | The real time at which the request finished.
   * @public
   */

  this._tfinish = null;
  /**
   * The duration of the media requests, if available, in seconds.
   * @public
   */

  this._mediaduration = null;
  /**
   * The media segment quality
   * @public
   */

  this._quality = null;
  /**
   * all the response headers from request.
   * @public
   */

  this._responseHeaders = null;
  /**
   * The selected service location for the request. string.
   * @public
   */

  this._serviceLocation = null;
  /**
   * The type of the loader that was used. Distinguish between fetch loader and xhr loader
   */

  this._fileLoaderType = null;
};
/**
 * @classdesc This Object holds reference to the progress of the HTTPRequest.
 * @ignore
 */


var HTTPRequestTrace =
/**
 * @class
 */
function HTTPRequestTrace() {
  _classCallCheck(this, HTTPRequestTrace);

  /**
   * Real-Time | Measurement stream start.
   * @public
   */
  this.s = null;
  /**
   * Measurement stream duration (ms).
   * @public
   */

  this.d = null;
  /**
   * List of integers counting the bytes received in each trace interval within the measurement stream.
   * @public
   */

  this.b = [];
  /**
   * Measurement throughput in kbits/s
   * @public
   */

  this._t = null;
};

HTTPRequest.GET = 'GET';
HTTPRequest.HEAD = 'HEAD';
HTTPRequest.MPD_TYPE = 'MPD';
HTTPRequest.XLINK_EXPANSION_TYPE = 'XLinkExpansion';
HTTPRequest.INIT_SEGMENT_TYPE = 'InitializationSegment';
HTTPRequest.INDEX_SEGMENT_TYPE = 'IndexSegment';
HTTPRequest.MEDIA_SEGMENT_TYPE = 'MediaSegment';
HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE = 'BitstreamSwitchingSegment';
HTTPRequest.MSS_FRAGMENT_INFO_SEGMENT_TYPE = 'FragmentInfoSegment';
HTTPRequest.DVB_REPORTING_TYPE = 'DVBReporting';
HTTPRequest.LICENSE = 'license';
HTTPRequest.OTHER_TYPE = 'other';


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=dash.mss.debug.js.map

/***/ }),

/***/ 343:
/***/ ((module) => {

!function(t,e){ true?module.exports=e():0}(window,(function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="/dist/",r(r.s=102)}({10:function(t,e,r){"use strict";e.a=function t(e,r,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.code=e||null,this.message=r||null,this.data=n||null}},102:function(t,e,r){"use strict";r.r(e),function(t){var n=r(99);r.d(e,"MssHandler",(function(){return n.a}));var i="undefined"!=typeof window&&window||t,o=i.dashjs;o||(o=i.dashjs={}),o.MssHandler=n.a,e.default=o}.call(this,r(23))},103:function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},17:function(t,e,r){"use strict";var n=r(5);function i(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var o=function(){function t(e){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.action=t.ACTION_DOWNLOAD,this.startTime=NaN,this.mediaStartTime=NaN,this.mediaType=null,this.mediaInfo=null,this.type=null,this.duration=NaN,this.timescale=NaN,this.range=null,this.url=e||null,this.serviceLocation=null,this.requestStartDate=null,this.firstByteDate=null,this.requestEndDate=null,this.quality=NaN,this.index=NaN,this.availabilityStartTime=null,this.availabilityEndTime=null,this.wallStartTime=null,this.bytesLoaded=NaN,this.bytesTotal=NaN,this.delayLoadingTime=NaN,this.responseType="arraybuffer",this.representationId=null}var e,r,o;return e=t,(r=[{key:"isInitializationRequest",value:function(){return this.type&&this.type===n.a.INIT_SEGMENT_TYPE}},{key:"setInfo",value:function(t){this.type=t&&t.init?n.a.INIT_SEGMENT_TYPE:n.a.MEDIA_SEGMENT_TYPE,this.url=t&&t.url?t.url:null,this.range=t&&t.range?t.range.start+"-"+t.range.end:null,this.mediaType=t&&t.mediaType?t.mediaType:null}}])&&i(e.prototype,r),o&&i(e,o),t}();o.ACTION_DOWNLOAD="download",o.ACTION_COMPLETE="complete",e.a=o},18:function(t,e,r){"use strict";function n(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var i=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t)}var e,r,i;return e=t,(r=[{key:"extend",value:function(t,e){if(t){var r=!!e&&e.override,n=!!e&&e.publicOnly;for(var i in t)!t.hasOwnProperty(i)||this[i]&&!r||n&&-1===t[i].indexOf("public_")||(this[i]=t[i])}}}])&&n(e.prototype,r),i&&n(e,i),t}();e.a=i},23:function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},28:function(t,e,r){"use strict";function n(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var i=function(){function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t)}var e,r,i;return e=t,(r=[{key:"extend",value:function(t,e){if(t){var r=!!e&&e.override,n=!!e&&e.publicOnly;for(var i in t)!t.hasOwnProperty(i)||this[i]&&!r||n&&-1===t[i].indexOf("public_")||(this[i]=t[i])}}}])&&n(e.prototype,r),i&&n(e,i),t}();e.a=i},4:function(t,e,r){"use strict";function n(t){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function i(t,e){return(i=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function o(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var r,n=s(t);if(e){var i=s(this).constructor;r=Reflect.construct(n,arguments,i)}else r=n.apply(this,arguments);return a(this,r)}}function a(t,e){return!e||"object"!==n(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function s(t){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var u=new(function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&i(t,e)}(r,t);var e=o(r);function r(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(t=e.call(this)).AST_IN_FUTURE="astInFuture",t.BUFFER_EMPTY="bufferStalled",t.BUFFER_LOADED="bufferLoaded",t.BUFFER_LEVEL_STATE_CHANGED="bufferStateChanged",t.BUFFER_LEVEL_UPDATED="bufferLevelUpdated",t.DYNAMIC_TO_STATIC="dynamicToStatic",t.ERROR="error",t.FRAGMENT_LOADING_COMPLETED="fragmentLoadingCompleted",t.FRAGMENT_LOADING_PROGRESS="fragmentLoadingProgress",t.FRAGMENT_LOADING_STARTED="fragmentLoadingStarted",t.FRAGMENT_LOADING_ABANDONED="fragmentLoadingAbandoned",t.LOG="log",t.MANIFEST_LOADED="manifestLoaded",t.METRICS_CHANGED="metricsChanged",t.METRIC_CHANGED="metricChanged",t.METRIC_ADDED="metricAdded",t.METRIC_UPDATED="metricUpdated",t.PERIOD_SWITCH_STARTED="periodSwitchStarted",t.PERIOD_SWITCH_COMPLETED="periodSwitchCompleted",t.QUALITY_CHANGE_REQUESTED="qualityChangeRequested",t.QUALITY_CHANGE_RENDERED="qualityChangeRendered",t.TRACK_CHANGE_RENDERED="trackChangeRendered",t.STREAM_INITIALIZING="streamInitializing",t.STREAM_UPDATED="streamUpdated",t.STREAM_ACTIVATED="streamActivated",t.STREAM_DEACTIVATED="streamDeactivated",t.STREAM_INITIALIZED="streamInitialized",t.STREAM_TEARDOWN_COMPLETE="streamTeardownComplete",t.TEXT_TRACKS_ADDED="allTextTracksAdded",t.TEXT_TRACK_ADDED="textTrackAdded",t.TTML_PARSED="ttmlParsed",t.TTML_TO_PARSE="ttmlToParse",t.CAPTION_RENDERED="captionRendered",t.CAPTION_CONTAINER_RESIZE="captionContainerResize",t.CAN_PLAY="canPlay",t.CAN_PLAY_THROUGH="canPlayThrough",t.PLAYBACK_ENDED="playbackEnded",t.PLAYBACK_ERROR="playbackError",t.PLAYBACK_NOT_ALLOWED="playbackNotAllowed",t.PLAYBACK_METADATA_LOADED="playbackMetaDataLoaded",t.PLAYBACK_LOADED_DATA="playbackLoadedData",t.PLAYBACK_PAUSED="playbackPaused",t.PLAYBACK_PLAYING="playbackPlaying",t.PLAYBACK_PROGRESS="playbackProgress",t.PLAYBACK_RATE_CHANGED="playbackRateChanged",t.PLAYBACK_SEEKED="playbackSeeked",t.PLAYBACK_SEEKING="playbackSeeking",t.PLAYBACK_STALLED="playbackStalled",t.PLAYBACK_STARTED="playbackStarted",t.PLAYBACK_TIME_UPDATED="playbackTimeUpdated",t.PLAYBACK_WAITING="playbackWaiting",t.MANIFEST_VALIDITY_CHANGED="manifestValidityChanged",t.EVENT_MODE_ON_START="eventModeOnStart",t.EVENT_MODE_ON_RECEIVE="eventModeOnReceive",t.CONFORMANCE_VIOLATION="conformanceViolation",t.REPRESENTATION_SWITCH="representationSwitch",t.ADAPTATION_SET_REMOVED_NO_CAPABILITIES="adaptationSetRemovedNoCapabilities",t}return r}(r(18).a));e.a=u},5:function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}r.d(e,"a",(function(){return i})),r.d(e,"b",(function(){return o}));var i=function t(){n(this,t),this.tcpid=null,this.type=null,this.url=null,this.actualurl=null,this.range=null,this.trequest=null,this.tresponse=null,this.responsecode=null,this.interval=null,this.trace=[],this._stream=null,this._tfinish=null,this._mediaduration=null,this._quality=null,this._responseHeaders=null,this._serviceLocation=null,this._fileLoaderType=null},o=function t(){n(this,t),this.s=null,this.d=null,this.b=[],this._t=null};i.GET="GET",i.HEAD="HEAD",i.MPD_TYPE="MPD",i.XLINK_EXPANSION_TYPE="XLinkExpansion",i.INIT_SEGMENT_TYPE="InitializationSegment",i.INDEX_SEGMENT_TYPE="IndexSegment",i.MEDIA_SEGMENT_TYPE="MediaSegment",i.BITSTREAM_SWITCHING_SEGMENT_TYPE="BitstreamSwitchingSegment",i.MSS_FRAGMENT_INFO_SEGMENT_TYPE="FragmentInfoSegment",i.DVB_REPORTING_TYPE="DVBReporting",i.LICENSE="license",i.OTHER_TYPE="other"},57:function(t,e,r){(function(t){var r,n=function(t){"use strict";var e=1e7,r=9007199254740992,i=f(r),o="function"==typeof BigInt;function a(t,e,r,n){return void 0===t?a[0]:void 0!==e&&(10!=+e||r)?k(t,e,r,n):V(t)}function s(t,e){this.value=t,this.sign=e,this.isSmall=!1}function u(t){this.value=t,this.sign=t<0,this.isSmall=!0}function l(t){this.value=t}function p(t){return-r<t&&t<r}function f(t){return t<1e7?[t]:t<1e14?[t%1e7,Math.floor(t/1e7)]:[t%1e7,Math.floor(t/1e7)%1e7,Math.floor(t/1e14)]}function c(t){d(t);var r=t.length;if(r<4&&N(t,i)<0)switch(r){case 0:return 0;case 1:return t[0];case 2:return t[0]+t[1]*e;default:return t[0]+(t[1]+t[2]*e)*e}return t}function d(t){for(var e=t.length;0===t[--e];);t.length=e+1}function h(t){for(var e=new Array(t),r=-1;++r<t;)e[r]=0;return e}function y(t){return t>0?Math.floor(t):Math.ceil(t)}function m(t,r){var n,i,o=t.length,a=r.length,s=new Array(o),u=0,l=e;for(i=0;i<a;i++)u=(n=t[i]+r[i]+u)>=l?1:0,s[i]=n-u*l;for(;i<o;)u=(n=t[i]+u)===l?1:0,s[i++]=n-u*l;return u>0&&s.push(u),s}function g(t,e){return t.length>=e.length?m(t,e):m(e,t)}function v(t,r){var n,i,o=t.length,a=new Array(o),s=e;for(i=0;i<o;i++)n=t[i]-s+r,r=Math.floor(n/s),a[i]=n-r*s,r+=1;for(;r>0;)a[i++]=r%s,r=Math.floor(r/s);return a}function _(t,e){var r,n,i=t.length,o=e.length,a=new Array(i),s=0;for(r=0;r<o;r++)(n=t[r]-s-e[r])<0?(n+=1e7,s=1):s=0,a[r]=n;for(r=o;r<i;r++){if(!((n=t[r]-s)<0)){a[r++]=n;break}n+=1e7,a[r]=n}for(;r<i;r++)a[r]=t[r];return d(a),a}function b(t,e,r){var n,i,o=t.length,a=new Array(o),l=-e;for(n=0;n<o;n++)i=t[n]+l,l=Math.floor(i/1e7),i%=1e7,a[n]=i<0?i+1e7:i;return"number"==typeof(a=c(a))?(r&&(a=-a),new u(a)):new s(a,r)}function T(t,e){var r,n,i,o,a=t.length,s=e.length,u=h(a+s);for(i=0;i<a;++i){o=t[i];for(var l=0;l<s;++l)r=o*e[l]+u[i+l],n=Math.floor(r/1e7),u[i+l]=r-1e7*n,u[i+l+1]+=n}return d(u),u}function E(t,r){var n,i,o=t.length,a=new Array(o),s=e,u=0;for(i=0;i<o;i++)n=t[i]*r+u,u=Math.floor(n/s),a[i]=n-u*s;for(;u>0;)a[i++]=u%s,u=Math.floor(u/s);return a}function A(t,e){for(var r=[];e-- >0;)r.push(0);return r.concat(t)}function S(t,r,n){return new s(t<e?E(r,t):T(r,f(t)),n)}function w(t){var e,r,n,i,o=t.length,a=h(o+o);for(n=0;n<o;n++){r=0-(i=t[n])*i;for(var s=n;s<o;s++)e=i*t[s]*2+a[n+s]+r,r=Math.floor(e/1e7),a[n+s]=e-1e7*r;a[n+o]=r}return d(a),a}function I(t,e){var r,n,i,o,a=t.length,s=h(a);for(i=0,r=a-1;r>=0;--r)i=(o=1e7*i+t[r])-(n=y(o/e))*e,s[r]=0|n;return[s,0|i]}function M(t,r){var n,i=V(r);if(o)return[new l(t.value/i.value),new l(t.value%i.value)];var p,m=t.value,g=i.value;if(0===g)throw new Error("Cannot divide by zero");if(t.isSmall)return i.isSmall?[new u(y(m/g)),new u(m%g)]:[a[0],t];if(i.isSmall){if(1===g)return[t,a[0]];if(-1==g)return[t.negate(),a[0]];var v=Math.abs(g);if(v<e){p=c((n=I(m,v))[0]);var b=n[1];return t.sign&&(b=-b),"number"==typeof p?(t.sign!==i.sign&&(p=-p),[new u(p),new u(b)]):[new s(p,t.sign!==i.sign),new u(b)]}g=f(v)}var T=N(m,g);if(-1===T)return[a[0],t];if(0===T)return[a[t.sign===i.sign?1:-1],a[0]];p=(n=m.length+g.length<=200?function(t,r){var n,i,o,a,s,u,l,p=t.length,f=r.length,d=e,y=h(r.length),m=r[f-1],g=Math.ceil(d/(2*m)),v=E(t,g),_=E(r,g);for(v.length<=p&&v.push(0),_.push(0),m=_[f-1],i=p-f;i>=0;i--){for(n=d-1,v[i+f]!==m&&(n=Math.floor((v[i+f]*d+v[i+f-1])/m)),o=0,a=0,u=_.length,s=0;s<u;s++)o+=n*_[s],l=Math.floor(o/d),a+=v[i+s]-(o-l*d),o=l,a<0?(v[i+s]=a+d,a=-1):(v[i+s]=a,a=0);for(;0!==a;){for(n-=1,o=0,s=0;s<u;s++)(o+=v[i+s]-d+_[s])<0?(v[i+s]=o+d,o=0):(v[i+s]=o,o=1);a+=o}y[i]=n}return v=I(v,g)[0],[c(y),c(v)]}(m,g):function(t,e){for(var r,n,i,o,a,s=t.length,u=e.length,l=[],p=[];s;)if(p.unshift(t[--s]),d(p),N(p,e)<0)l.push(0);else{i=1e7*p[(n=p.length)-1]+p[n-2],o=1e7*e[u-1]+e[u-2],n>u&&(i=1e7*(i+1)),r=Math.ceil(i/o);do{if(N(a=E(e,r),p)<=0)break;r--}while(r);l.push(r),p=_(p,a)}return l.reverse(),[c(l),c(p)]}(m,g))[0];var A=t.sign!==i.sign,S=n[1],w=t.sign;return"number"==typeof p?(A&&(p=-p),p=new u(p)):p=new s(p,A),"number"==typeof S?(w&&(S=-S),S=new u(S)):S=new s(S,w),[p,S]}function N(t,e){if(t.length!==e.length)return t.length>e.length?1:-1;for(var r=t.length-1;r>=0;r--)if(t[r]!==e[r])return t[r]>e[r]?1:-1;return 0}function D(t){var e=t.abs();return!e.isUnit()&&(!!(e.equals(2)||e.equals(3)||e.equals(5))||!(e.isEven()||e.isDivisibleBy(3)||e.isDivisibleBy(5))&&(!!e.lesser(49)||void 0))}function P(t,e){for(var r,i,o,a=t.prev(),s=a,u=0;s.isEven();)s=s.divide(2),u++;t:for(i=0;i<e.length;i++)if(!t.lesser(e[i])&&!(o=n(e[i]).modPow(s,t)).isUnit()&&!o.equals(a)){for(r=u-1;0!=r;r--){if((o=o.square().mod(t)).isUnit())return!1;if(o.equals(a))continue t}return!1}return!0}s.prototype=Object.create(a.prototype),u.prototype=Object.create(a.prototype),l.prototype=Object.create(a.prototype),s.prototype.add=function(t){var e=V(t);if(this.sign!==e.sign)return this.subtract(e.negate());var r=this.value,n=e.value;return e.isSmall?new s(v(r,Math.abs(n)),this.sign):new s(g(r,n),this.sign)},s.prototype.plus=s.prototype.add,u.prototype.add=function(t){var e=V(t),r=this.value;if(r<0!==e.sign)return this.subtract(e.negate());var n=e.value;if(e.isSmall){if(p(r+n))return new u(r+n);n=f(Math.abs(n))}return new s(v(n,Math.abs(r)),r<0)},u.prototype.plus=u.prototype.add,l.prototype.add=function(t){return new l(this.value+V(t).value)},l.prototype.plus=l.prototype.add,s.prototype.subtract=function(t){var e=V(t);if(this.sign!==e.sign)return this.add(e.negate());var r=this.value,n=e.value;return e.isSmall?b(r,Math.abs(n),this.sign):function(t,e,r){var n;return N(t,e)>=0?n=_(t,e):(n=_(e,t),r=!r),"number"==typeof(n=c(n))?(r&&(n=-n),new u(n)):new s(n,r)}(r,n,this.sign)},s.prototype.minus=s.prototype.subtract,u.prototype.subtract=function(t){var e=V(t),r=this.value;if(r<0!==e.sign)return this.add(e.negate());var n=e.value;return e.isSmall?new u(r-n):b(n,Math.abs(r),r>=0)},u.prototype.minus=u.prototype.subtract,l.prototype.subtract=function(t){return new l(this.value-V(t).value)},l.prototype.minus=l.prototype.subtract,s.prototype.negate=function(){return new s(this.value,!this.sign)},u.prototype.negate=function(){var t=this.sign,e=new u(-this.value);return e.sign=!t,e},l.prototype.negate=function(){return new l(-this.value)},s.prototype.abs=function(){return new s(this.value,!1)},u.prototype.abs=function(){return new u(Math.abs(this.value))},l.prototype.abs=function(){return new l(this.value>=0?this.value:-this.value)},s.prototype.multiply=function(t){var r,n,i,o=V(t),u=this.value,l=o.value,p=this.sign!==o.sign;if(o.isSmall){if(0===l)return a[0];if(1===l)return this;if(-1===l)return this.negate();if((r=Math.abs(l))<e)return new s(E(u,r),p);l=f(r)}return n=u.length,i=l.length,new s(-.012*n-.012*i+15e-6*n*i>0?function t(e,r){var n=Math.max(e.length,r.length);if(n<=30)return T(e,r);n=Math.ceil(n/2);var i=e.slice(n),o=e.slice(0,n),a=r.slice(n),s=r.slice(0,n),u=t(o,s),l=t(i,a),p=t(g(o,i),g(s,a)),f=g(g(u,A(_(_(p,u),l),n)),A(l,2*n));return d(f),f}(u,l):T(u,l),p)},s.prototype.times=s.prototype.multiply,u.prototype._multiplyBySmall=function(t){return p(t.value*this.value)?new u(t.value*this.value):S(Math.abs(t.value),f(Math.abs(this.value)),this.sign!==t.sign)},s.prototype._multiplyBySmall=function(t){return 0===t.value?a[0]:1===t.value?this:-1===t.value?this.negate():S(Math.abs(t.value),this.value,this.sign!==t.sign)},u.prototype.multiply=function(t){return V(t)._multiplyBySmall(this)},u.prototype.times=u.prototype.multiply,l.prototype.multiply=function(t){return new l(this.value*V(t).value)},l.prototype.times=l.prototype.multiply,s.prototype.square=function(){return new s(w(this.value),!1)},u.prototype.square=function(){var t=this.value*this.value;return p(t)?new u(t):new s(w(f(Math.abs(this.value))),!1)},l.prototype.square=function(t){return new l(this.value*this.value)},s.prototype.divmod=function(t){var e=M(this,t);return{quotient:e[0],remainder:e[1]}},l.prototype.divmod=u.prototype.divmod=s.prototype.divmod,s.prototype.divide=function(t){return M(this,t)[0]},l.prototype.over=l.prototype.divide=function(t){return new l(this.value/V(t).value)},u.prototype.over=u.prototype.divide=s.prototype.over=s.prototype.divide,s.prototype.mod=function(t){return M(this,t)[1]},l.prototype.mod=l.prototype.remainder=function(t){return new l(this.value%V(t).value)},u.prototype.remainder=u.prototype.mod=s.prototype.remainder=s.prototype.mod,s.prototype.pow=function(t){var e,r,n,i=V(t),o=this.value,s=i.value;if(0===s)return a[1];if(0===o)return a[0];if(1===o)return a[1];if(-1===o)return i.isEven()?a[1]:a[-1];if(i.sign)return a[0];if(!i.isSmall)throw new Error("The exponent "+i.toString()+" is too large.");if(this.isSmall&&p(e=Math.pow(o,s)))return new u(y(e));for(r=this,n=a[1];!0&s&&(n=n.times(r),--s),0!==s;)s/=2,r=r.square();return n},u.prototype.pow=s.prototype.pow,l.prototype.pow=function(t){var e=V(t),r=this.value,n=e.value,i=BigInt(0),o=BigInt(1),s=BigInt(2);if(n===i)return a[1];if(r===i)return a[0];if(r===o)return a[1];if(r===BigInt(-1))return e.isEven()?a[1]:a[-1];if(e.isNegative())return new l(i);for(var u=this,p=a[1];(n&o)===o&&(p=p.times(u),--n),n!==i;)n/=s,u=u.square();return p},s.prototype.modPow=function(t,e){if(t=V(t),(e=V(e)).isZero())throw new Error("Cannot take modPow with modulus 0");for(var r=a[1],n=this.mod(e);t.isPositive();){if(n.isZero())return a[0];t.isOdd()&&(r=r.multiply(n).mod(e)),t=t.divide(2),n=n.square().mod(e)}return r},l.prototype.modPow=u.prototype.modPow=s.prototype.modPow,s.prototype.compareAbs=function(t){var e=V(t),r=this.value,n=e.value;return e.isSmall?1:N(r,n)},u.prototype.compareAbs=function(t){var e=V(t),r=Math.abs(this.value),n=e.value;return e.isSmall?r===(n=Math.abs(n))?0:r>n?1:-1:-1},l.prototype.compareAbs=function(t){var e=this.value,r=V(t).value;return(e=e>=0?e:-e)===(r=r>=0?r:-r)?0:e>r?1:-1},s.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=V(t),r=this.value,n=e.value;return this.sign!==e.sign?e.sign?1:-1:e.isSmall?this.sign?-1:1:N(r,n)*(this.sign?-1:1)},s.prototype.compareTo=s.prototype.compare,u.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=V(t),r=this.value,n=e.value;return e.isSmall?r==n?0:r>n?1:-1:r<0!==e.sign?r<0?-1:1:r<0?1:-1},u.prototype.compareTo=u.prototype.compare,l.prototype.compare=function(t){if(t===1/0)return-1;if(t===-1/0)return 1;var e=this.value,r=V(t).value;return e===r?0:e>r?1:-1},l.prototype.compareTo=l.prototype.compare,s.prototype.equals=function(t){return 0===this.compare(t)},l.prototype.eq=l.prototype.equals=u.prototype.eq=u.prototype.equals=s.prototype.eq=s.prototype.equals,s.prototype.notEquals=function(t){return 0!==this.compare(t)},l.prototype.neq=l.prototype.notEquals=u.prototype.neq=u.prototype.notEquals=s.prototype.neq=s.prototype.notEquals,s.prototype.greater=function(t){return this.compare(t)>0},l.prototype.gt=l.prototype.greater=u.prototype.gt=u.prototype.greater=s.prototype.gt=s.prototype.greater,s.prototype.lesser=function(t){return this.compare(t)<0},l.prototype.lt=l.prototype.lesser=u.prototype.lt=u.prototype.lesser=s.prototype.lt=s.prototype.lesser,s.prototype.greaterOrEquals=function(t){return this.compare(t)>=0},l.prototype.geq=l.prototype.greaterOrEquals=u.prototype.geq=u.prototype.greaterOrEquals=s.prototype.geq=s.prototype.greaterOrEquals,s.prototype.lesserOrEquals=function(t){return this.compare(t)<=0},l.prototype.leq=l.prototype.lesserOrEquals=u.prototype.leq=u.prototype.lesserOrEquals=s.prototype.leq=s.prototype.lesserOrEquals,s.prototype.isEven=function(){return 0==(1&this.value[0])},u.prototype.isEven=function(){return 0==(1&this.value)},l.prototype.isEven=function(){return(this.value&BigInt(1))===BigInt(0)},s.prototype.isOdd=function(){return 1==(1&this.value[0])},u.prototype.isOdd=function(){return 1==(1&this.value)},l.prototype.isOdd=function(){return(this.value&BigInt(1))===BigInt(1)},s.prototype.isPositive=function(){return!this.sign},u.prototype.isPositive=function(){return this.value>0},l.prototype.isPositive=u.prototype.isPositive,s.prototype.isNegative=function(){return this.sign},u.prototype.isNegative=function(){return this.value<0},l.prototype.isNegative=u.prototype.isNegative,s.prototype.isUnit=function(){return!1},u.prototype.isUnit=function(){return 1===Math.abs(this.value)},l.prototype.isUnit=function(){return this.abs().value===BigInt(1)},s.prototype.isZero=function(){return!1},u.prototype.isZero=function(){return 0===this.value},l.prototype.isZero=function(){return this.value===BigInt(0)},s.prototype.isDivisibleBy=function(t){var e=V(t);return!e.isZero()&&(!!e.isUnit()||(0===e.compareAbs(2)?this.isEven():this.mod(e).isZero()))},l.prototype.isDivisibleBy=u.prototype.isDivisibleBy=s.prototype.isDivisibleBy,s.prototype.isPrime=function(t){var e=D(this);if(void 0!==e)return e;var r=this.abs(),i=r.bitLength();if(i<=64)return P(r,[2,3,5,7,11,13,17,19,23,29,31,37]);for(var o=Math.log(2)*i.toJSNumber(),a=Math.ceil(!0===t?2*Math.pow(o,2):o),s=[],u=0;u<a;u++)s.push(n(u+2));return P(r,s)},l.prototype.isPrime=u.prototype.isPrime=s.prototype.isPrime,s.prototype.isProbablePrime=function(t){var e=D(this);if(void 0!==e)return e;for(var r=this.abs(),i=void 0===t?5:t,o=[],a=0;a<i;a++)o.push(n.randBetween(2,r.minus(2)));return P(r,o)},l.prototype.isProbablePrime=u.prototype.isProbablePrime=s.prototype.isProbablePrime,s.prototype.modInv=function(t){for(var e,r,i,o=n.zero,a=n.one,s=V(t),u=this.abs();!u.isZero();)e=s.divide(u),r=o,i=s,o=a,s=u,a=r.subtract(e.multiply(a)),u=i.subtract(e.multiply(u));if(!s.isUnit())throw new Error(this.toString()+" and "+t.toString()+" are not co-prime");return-1===o.compare(0)&&(o=o.add(t)),this.isNegative()?o.negate():o},l.prototype.modInv=u.prototype.modInv=s.prototype.modInv,s.prototype.next=function(){var t=this.value;return this.sign?b(t,1,this.sign):new s(v(t,1),this.sign)},u.prototype.next=function(){var t=this.value;return t+1<r?new u(t+1):new s(i,!1)},l.prototype.next=function(){return new l(this.value+BigInt(1))},s.prototype.prev=function(){var t=this.value;return this.sign?new s(v(t,1),!0):b(t,1,this.sign)},u.prototype.prev=function(){var t=this.value;return t-1>-r?new u(t-1):new s(i,!0)},l.prototype.prev=function(){return new l(this.value-BigInt(1))};for(var O=[1];2*O[O.length-1]<=e;)O.push(2*O[O.length-1]);var C=O.length,x=O[C-1];function B(t){return Math.abs(t)<=e}function F(t,e,r){e=V(e);for(var i=t.isNegative(),o=e.isNegative(),a=i?t.not():t,s=o?e.not():e,u=0,l=0,p=null,f=null,c=[];!a.isZero()||!s.isZero();)u=(p=M(a,x))[1].toJSNumber(),i&&(u=x-1-u),l=(f=M(s,x))[1].toJSNumber(),o&&(l=x-1-l),a=p[0],s=f[0],c.push(r(u,l));for(var d=0!==r(i?1:0,o?1:0)?n(-1):n(0),h=c.length-1;h>=0;h-=1)d=d.multiply(x).add(n(c[h]));return d}s.prototype.shiftLeft=function(t){var e=V(t).toJSNumber();if(!B(e))throw new Error(String(e)+" is too large for shifting.");if(e<0)return this.shiftRight(-e);var r=this;if(r.isZero())return r;for(;e>=C;)r=r.multiply(x),e-=C-1;return r.multiply(O[e])},l.prototype.shiftLeft=u.prototype.shiftLeft=s.prototype.shiftLeft,s.prototype.shiftRight=function(t){var e,r=V(t).toJSNumber();if(!B(r))throw new Error(String(r)+" is too large for shifting.");if(r<0)return this.shiftLeft(-r);for(var n=this;r>=C;){if(n.isZero()||n.isNegative()&&n.isUnit())return n;n=(e=M(n,x))[1].isNegative()?e[0].prev():e[0],r-=C-1}return(e=M(n,O[r]))[1].isNegative()?e[0].prev():e[0]},l.prototype.shiftRight=u.prototype.shiftRight=s.prototype.shiftRight,s.prototype.not=function(){return this.negate().prev()},l.prototype.not=u.prototype.not=s.prototype.not,s.prototype.and=function(t){return F(this,t,(function(t,e){return t&e}))},l.prototype.and=u.prototype.and=s.prototype.and,s.prototype.or=function(t){return F(this,t,(function(t,e){return t|e}))},l.prototype.or=u.prototype.or=s.prototype.or,s.prototype.xor=function(t){return F(this,t,(function(t,e){return t^e}))},l.prototype.xor=u.prototype.xor=s.prototype.xor;function R(t){var r=t.value,n="number"==typeof r?r|1<<30:"bigint"==typeof r?r|BigInt(1<<30):r[0]+r[1]*e|1073758208;return n&-n}function L(t,e){return t=V(t),e=V(e),t.greater(e)?t:e}function q(t,e){return t=V(t),e=V(e),t.lesser(e)?t:e}function U(t,e){if(t=V(t).abs(),e=V(e).abs(),t.equals(e))return t;if(t.isZero())return e;if(e.isZero())return t;for(var r,n,i=a[1];t.isEven()&&e.isEven();)r=q(R(t),R(e)),t=t.divide(r),e=e.divide(r),i=i.multiply(r);for(;t.isEven();)t=t.divide(R(t));do{for(;e.isEven();)e=e.divide(R(e));t.greater(e)&&(n=e,e=t,t=n),e=e.subtract(t)}while(!e.isZero());return i.isUnit()?t:t.multiply(i)}s.prototype.bitLength=function(){var t=this;return t.compareTo(n(0))<0&&(t=t.negate().subtract(n(1))),0===t.compareTo(n(0))?n(0):n(function t(e,r){if(r.compareTo(e)<=0){var i=t(e,r.square(r)),o=i.p,a=i.e,s=o.multiply(r);return s.compareTo(e)<=0?{p:s,e:2*a+1}:{p:o,e:2*a}}return{p:n(1),e:0}}(t,n(2)).e).add(n(1))},l.prototype.bitLength=u.prototype.bitLength=s.prototype.bitLength;var k=function(t,e,r,n){r=r||"0123456789abcdefghijklmnopqrstuvwxyz",t=String(t),n||(t=t.toLowerCase(),r=r.toLowerCase());var i,o=t.length,a=Math.abs(e),s={};for(i=0;i<r.length;i++)s[r[i]]=i;for(i=0;i<o;i++){if("-"!==(p=t[i])&&(p in s&&s[p]>=a)){if("1"===p&&1===a)continue;throw new Error(p+" is not a valid digit in base "+e+".")}}e=V(e);var u=[],l="-"===t[0];for(i=l?1:0;i<t.length;i++){var p;if((p=t[i])in s)u.push(V(s[p]));else{if("<"!==p)throw new Error(p+" is not a valid character");var f=i;do{i++}while(">"!==t[i]&&i<t.length);u.push(V(t.slice(f+1,i)))}}return G(u,e,l)};function G(t,e,r){var n,i=a[0],o=a[1];for(n=t.length-1;n>=0;n--)i=i.add(t[n].times(o)),o=o.times(e);return r?i.negate():i}function j(t,e){if((e=n(e)).isZero()){if(t.isZero())return{value:[0],isNegative:!1};throw new Error("Cannot convert nonzero numbers to base 0.")}if(e.equals(-1)){if(t.isZero())return{value:[0],isNegative:!1};if(t.isNegative())return{value:[].concat.apply([],Array.apply(null,Array(-t.toJSNumber())).map(Array.prototype.valueOf,[1,0])),isNegative:!1};var r=Array.apply(null,Array(t.toJSNumber()-1)).map(Array.prototype.valueOf,[0,1]);return r.unshift([1]),{value:[].concat.apply([],r),isNegative:!1}}var i=!1;if(t.isNegative()&&e.isPositive()&&(i=!0,t=t.abs()),e.isUnit())return t.isZero()?{value:[0],isNegative:!1}:{value:Array.apply(null,Array(t.toJSNumber())).map(Number.prototype.valueOf,1),isNegative:i};for(var o,a=[],s=t;s.isNegative()||s.compareAbs(e)>=0;){o=s.divmod(e),s=o.quotient;var u=o.remainder;u.isNegative()&&(u=e.minus(u).abs(),s=s.next()),a.push(u.toJSNumber())}return a.push(s.toJSNumber()),{value:a.reverse(),isNegative:i}}function Y(t,e,r){var n=j(t,e);return(n.isNegative?"-":"")+n.value.map((function(t){return function(t,e){return t<(e=e||"0123456789abcdefghijklmnopqrstuvwxyz").length?e[t]:"<"+t+">"}(t,r)})).join("")}function H(t){if(p(+t)){var e=+t;if(e===y(e))return o?new l(BigInt(e)):new u(e);throw new Error("Invalid integer: "+t)}var r="-"===t[0];r&&(t=t.slice(1));var n=t.split(/e/i);if(n.length>2)throw new Error("Invalid integer: "+n.join("e"));if(2===n.length){var i=n[1];if("+"===i[0]&&(i=i.slice(1)),(i=+i)!==y(i)||!p(i))throw new Error("Invalid integer: "+i+" is not a valid exponent.");var a=n[0],f=a.indexOf(".");if(f>=0&&(i-=a.length-f-1,a=a.slice(0,f)+a.slice(f+1)),i<0)throw new Error("Cannot include negative exponent part for integers");t=a+=new Array(i+1).join("0")}if(!/^([0-9][0-9]*)$/.test(t))throw new Error("Invalid integer: "+t);if(o)return new l(BigInt(r?"-"+t:t));for(var c=[],h=t.length,m=h-7;h>0;)c.push(+t.slice(m,h)),(m-=7)<0&&(m=0),h-=7;return d(c),new s(c,r)}function V(t){return"number"==typeof t?function(t){if(o)return new l(BigInt(t));if(p(t)){if(t!==y(t))throw new Error(t+" is not an integer.");return new u(t)}return H(t.toString())}(t):"string"==typeof t?H(t):"bigint"==typeof t?new l(t):t}s.prototype.toArray=function(t){return j(this,t)},u.prototype.toArray=function(t){return j(this,t)},l.prototype.toArray=function(t){return j(this,t)},s.prototype.toString=function(t,e){if(void 0===t&&(t=10),10!==t)return Y(this,t,e);for(var r,n=this.value,i=n.length,o=String(n[--i]);--i>=0;)r=String(n[i]),o+="0000000".slice(r.length)+r;return(this.sign?"-":"")+o},u.prototype.toString=function(t,e){return void 0===t&&(t=10),10!=t?Y(this,t,e):String(this.value)},l.prototype.toString=u.prototype.toString,l.prototype.toJSON=s.prototype.toJSON=u.prototype.toJSON=function(){return this.toString()},s.prototype.valueOf=function(){return parseInt(this.toString(),10)},s.prototype.toJSNumber=s.prototype.valueOf,u.prototype.valueOf=function(){return this.value},u.prototype.toJSNumber=u.prototype.valueOf,l.prototype.valueOf=l.prototype.toJSNumber=function(){return parseInt(this.toString(),10)};for(var K=0;K<1e3;K++)a[K]=V(K),K>0&&(a[-K]=V(-K));return a.one=a[1],a.zero=a[0],a.minusOne=a[-1],a.max=L,a.min=q,a.gcd=U,a.lcm=function(t,e){return t=V(t).abs(),e=V(e).abs(),t.divide(U(t,e)).multiply(e)},a.isInstance=function(t){return t instanceof s||t instanceof u||t instanceof l},a.randBetween=function(t,r){var n=q(t=V(t),r=V(r)),i=L(t,r).subtract(n).add(1);if(i.isSmall)return n.add(Math.floor(Math.random()*i));for(var o=j(i,e).value,s=[],u=!0,l=0;l<o.length;l++){var p=u?o[l]:e,f=y(Math.random()*p);s.push(f),f<p&&(u=!1)}return n.add(a.fromArray(s,e,!1))},a.fromArray=function(t,e,r){return G(t.map(V),V(e||10),r)},a}();t.hasOwnProperty("exports")&&(t.exports=n),void 0===(r=function(){return n}.apply(e,[]))||(t.exports=r)}).call(this,r(103)(t))},59:function(t,e,r){"use strict";e.a=function t(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.streamId=null,this.mediaInfo=null,this.segmentType=null,this.quality=NaN,this.index=NaN,this.bytes=null,this.start=NaN,this.end=NaN,this.duration=NaN,this.representationId=null,this.endFragment=null}},99:function(t,e,r){"use strict";var n=r(59),i=r(17),o=r(5);function a(t){var e,r,n,a,s,u,l,p,f,c=(t=t||{}).streamProcessor,d=t.baseURLController,h=t.debug;function y(){a&&(r.debug("Stop"),clearTimeout(u),a=!1,l=null,p=null)}function m(){if(a){var t=c.getRepresentationController().getCurrentRepresentation(),e=t.adaptation.period.mpd.manifest.Period_asArray[t.adaptation.period.index].AdaptationSet_asArray[t.adaptation.index],r=e.SegmentTemplate.SegmentTimeline.S_asArray,n=function(t,e,r){var n=t.SegmentTemplate.timescale,a=new i.a;return a.mediaType=s,a.type=o.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE,a.startTime=r.t/n,a.duration=r.d/n,a.timescale=n,a.quality=e.index,a.index=f++,a.mediaInfo=c.getMediaInfo(),a.adaptationIndex=e.adaptation.index,a.representationId=e.id,a.url=d.resolve(e.path).url+t.SegmentTemplate.media,a.url=a.url.replace("$Bandwidth$",e.bandwidth),a.url=a.url.replace("$Time$",r.tManifest?r.tManifest:r.t),a.url=a.url.replace("/Fragments(","/FragmentInfo("),a}(e,t,r[r.length-1]);g.call(this,n)}}function g(t){if(c.getFragmentModel().isFragmentLoadedOrPending(t))return r.debug("End of timeline"),void y();n.executeRequest(t)}return e={initialize:function(){s=c.getType(),n=c.getFragmentModel(),a=!1,l=null,p=null},controllerType:"MssFragmentInfoController",start:function(){a||(r.debug("Start"),a=!0,f=0,m())},fragmentInfoLoaded:function(t){if(a){var e,n,i,o=t.request;if(t.response)null===l&&(l=(new Date).getTime()),p||(p=o.startTime),n=((new Date).getTime()-l)/1e3,e=o.startTime+o.duration-p,i=Math.max(0,e-n),clearTimeout(u),u=setTimeout((function(){u=null,m()}),1e3*i);else r.error("Load error",o.url)}},getType:function(){return s},reset:function(){y()}},r=h.getLogger(e),e}a.__dashjs_factory_name="MssFragmentInfoController";var s=dashjs.FactoryMaker.getClassFactory(a),u=r(10);function l(t){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function p(t,e){return(p=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function f(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var r,n=d(t);if(e){var i=d(this).constructor;r=Reflect.construct(n,arguments,i)}else r=n.apply(this,arguments);return c(this,r)}}function c(t,e){return!e||"object"!==l(e)&&"function"!=typeof e?function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t):e}function d(t){return(d=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var h=new(function(t){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&p(t,e)}(r,t);var e=f(r);function r(){var t;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(t=e.call(this)).MSS_NO_TFRF_CODE=200,t.MSS_UNSUPPORTED_CODEC_CODE=201,t.MSS_NO_TFRF_MESSAGE="Missing tfrf in live media segment",t.MSS_UNSUPPORTED_CODEC_MESSAGE="Unsupported codec",t}return r}(r(28).a)),y=r(4);function m(t){var e,r,n,i=(t=t||{}).dashMetrics,o=t.playbackController,a=t.errHandler,s=t.eventBus,l=t.ISOBoxer,p=t.debug;function f(t,e,i,l){var p=l.getRepresentationController().getCurrentRepresentation(),f=p.adaptation.period.mpd.manifest,d=f.Period_asArray[p.adaptation.period.index].AdaptationSet_asArray[p.adaptation.index],m=d.SegmentTemplate.timescale;if(r=l.getType(),"dynamic"===f.type||f.timeShiftBufferDepth)if(e){var g,v,_,b,T=d.SegmentTemplate.SegmentTimeline.S,E=e.entry,A=null,S=null;if(0!==E.length&&(g=E[0],!("static"===f.type&&(v=T[0].tManifest?parseFloat(T[0].tManifest):T[0].t,g.fragment_absolute_time>v+f.timeShiftBufferDepth*m)))){if(v=T[T.length-1].tManifest?parseFloat(T[T.length-1].tManifest):T[T.length-1].t,g.fragment_absolute_time<=v)return _={start:T[0].t/m,end:i.baseMediaDecodeTime/m+t.duration},void c(t.mediaType,_,l.getStreamInfo().manifestInfo);(A={}).t=g.fragment_absolute_time,A.d=g.fragment_duration,T[0].tManifest&&(A.t-=parseFloat(T[0].tManifest)-T[0].t,A.tManifest=g.fragment_absolute_time);var w=T[T.length-1];if(w.t+w.d!==A.t&&(n.debug("Patch segment duration - t = ",w.t+", d = "+w.d+" => "+(A.t-w.t)),w.d=A.t-w.t),T.push(A),"static"!==f.type){if(f.timeShiftBufferDepth&&f.timeShiftBufferDepth>0)for(S=((A=T[T.length-1]).t-f.timeShiftBufferDepth*m)/m,b=((A=T[0]).t+A.d)/m;b<S&&(o.isPaused()||!(o.getTime()<b));)T.splice(0,1),b=((A=T[0]).t+A.d)/m;_={start:T[0].t/m,end:i.baseMediaDecodeTime/m+t.duration},c(r,_,l.getStreamInfo().manifestInfo)}else"video"===r&&(b=((A=T[T.length-1]).t+A.d)/m)>p.adaptation.period.duration&&s.trigger(y.a.MANIFEST_VALIDITY_CHANGED,{sender:this,newDuration:b})}}else a.error(new u.a(h.MSS_NO_TFRF_CODE,h.MSS_NO_TFRF_MESSAGE))}function c(t,e,r){if("video"===t||"audio"===t){var a=i.getCurrentDVRInfo(t);(!a||e.end>a.range.end)&&(n.debug("Update DVR range: ["+e.start+" - "+e.end+"]"),i.addDVRInfo(t,o.getTime(),r,e),o.updateCurrentTime(t))}}function d(t,e){var r=8,n=0;for(n=0;n<t.boxes.length;n++){if(t.boxes[n].type===e)return r;r+=t.boxes[n].size}return r}return e={convertFragment:function(t,e){var r,n=l.parseBuffer(t.response),i=n.fetch("tfhd");i.track_ID=t.request.mediaInfo.index+1;var o=n.fetch("tfdt"),a=n.fetch("traf");null===o&&((o=l.createFullBox("tfdt",a,i)).version=1,o.flags=0,o.baseMediaDecodeTime=Math.floor(t.request.startTime*t.request.timescale));var s=n.fetch("trun"),u=n.fetch("tfxd");u&&(u._parent.boxes.splice(u._parent.boxes.indexOf(u),1),u=null);var p=n.fetch("tfrf");f(t.request,p,o,e),p&&(p._parent.boxes.splice(p._parent.boxes.indexOf(p),1),p=null);var c=n.fetch("sepiff");if(null!==c){c.type="senc",c.usertype=void 0;var h=n.fetch("saio");if(null===h){(h=l.createFullBox("saio",a)).version=0,h.flags=0,h.entry_count=1,h.offset=[0];var y=l.createFullBox("saiz",a);if(y.version=0,y.flags=0,y.sample_count=c.sample_count,y.default_sample_info_size=0,y.sample_info_size=[],2&c.flags)for(r=0;r<c.sample_count;r+=1)y.sample_info_size[r]=10+6*c.entry[r].NumberOfEntries;else y.default_sample_info_size=8}}i.flags&=16777214,i.flags|=131072,s.flags|=1;var m=n.fetch("moof"),g=m.getLength();s.data_offset=g+8;var v=n.fetch("saio");if(null!==v){var _=d(m,"traf"),b=d(a,"senc");v.offset[0]=_+b+16}t.response=n.write()},updateSegmentList:function(t,e){if(!t.response)throw new Error("e.response parameter is missing");var r=l.parseBuffer(t.response),n=r.fetch("tfhd");n.track_ID=t.request.mediaInfo.index+1;var i=r.fetch("tfdt"),o=r.fetch("traf");null===i&&((i=l.createFullBox("tfdt",o,n)).version=1,i.flags=0,i.baseMediaDecodeTime=Math.floor(t.request.startTime*t.request.timescale));var a=r.fetch("tfrf");f(t.request,a,i,e),a&&(a._parent.boxes.splice(a._parent.boxes.indexOf(a),1),a=null)},getType:function(){return r}},n=p.getLogger(e),r="",e}m.__dashjs_factory_name="MssFragmentMoofProcessor";var g=dashjs.FactoryMaker.getClassFactory(m);function v(t){var e,r,n,i,o,a,s=(t=t||{}).constants,u=t.ISOBoxer,l=t.protectionController;function p(t){var p=u.createBox("moov",t);!function(t){var r=u.createFullBox("mvhd",t);r.version=1,r.creation_time=0,r.modification_time=0,r.timescale=o,r.duration=e.duration===1/0?0x10000000000000000:Math.round(e.duration*o),r.rate=1,r.volume=1,r.reserved1=0,r.reserved2=[0,0],r.matrix=[1,0,0,0,1,0,0,0,16384],r.pre_defined=[0,0,0,0,0,0],r.next_track_ID=a+1}(p);var m=u.createBox("trak",p);!function(t){var r=u.createFullBox("tkhd",t);r.version=1,r.flags=7,r.creation_time=0,r.modification_time=0,r.track_ID=a,r.reserved1=0,r.duration=e.duration===1/0?0x10000000000000000:Math.round(e.duration*o),r.reserved2=[0,0],r.layer=0,r.alternate_group=0,r.volume=1,r.reserved3=0,r.matrix=[1,0,0,0,1,0,0,0,16384],r.width=n.width,r.height=n.height}(m);var g=u.createBox("mdia",m);!function(t){var n=u.createFullBox("mdhd",t);n.version=1,n.creation_time=0,n.modification_time=0,n.timescale=o,n.duration=e.duration===1/0?0x10000000000000000:Math.round(e.duration*o),n.language=r.lang||"und",n.pre_defined=0}(g),function(t){var e=u.createFullBox("hdlr",t);switch(e.pre_defined=0,r.type){case s.VIDEO:e.handler_type="vide";break;case s.AUDIO:e.handler_type="soun";break;default:e.handler_type="meta"}e.name=n.id,e.reserved=[0,0,0]}(g);var v=u.createBox("minf",g);switch(r.type){case s.VIDEO:!function(t){var e=u.createFullBox("vmhd",t);e.flags=1,e.graphicsmode=0,e.opcolor=[0,0,0]}(v);break;case s.AUDIO:!function(t){var e=u.createFullBox("smhd",t);e.flags=1,e.balance=0,e.reserved=0}(v)}!function(t){var e=u.createFullBox("dref",t);e.entry_count=1,e.entries=[];var r=u.createFullBox("url ",e,!1);r.location="",r.flags=1,e.entries.push(r)}(u.createBox("dinf",v));var _=u.createBox("stbl",v);(u.createFullBox("stts",_)._data=[0,0,0,0,0,0,0,0],u.createFullBox("stsc",_)._data=[0,0,0,0,0,0,0,0],u.createFullBox("stco",_)._data=[0,0,0,0,0,0,0,0],u.createFullBox("stsz",_)._data=[0,0,0,0,0,0,0,0,0,0,0,0],function(t){var e=u.createFullBox("stsd",t);switch(e.entries=[],r.type){case s.VIDEO:case s.AUDIO:e.entries.push(function(t){var e=n.codecs.substring(0,n.codecs.indexOf("."));switch(e){case"avc1":return function(t,e){var r;r=i?u.createBox("encv",t,!1):u.createBox("avc1",t,!1);if(r.reserved1=[0,0,0,0,0,0],r.data_reference_index=1,r.pre_defined1=0,r.reserved2=0,r.pre_defined2=[0,0,0],r.height=n.height,r.width=n.width,r.horizresolution=72,r.vertresolution=72,r.reserved3=0,r.frame_count=1,r.compressorname=[10,65,86,67,32,67,111,100,105,110,103,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],r.depth=24,r.pre_defined3=65535,r.config=function(){for(var t,e=null,r=15,i=[],o=[],a=0,s=0,u=0,l=n.codecPrivateData.split("00000001").slice(1),p=0;p<l.length;p++)switch(t=y(l[p]),31&t[0]){case 7:i.push(t),r+=t.length+2;break;case 8:o.push(t),r+=t.length+2}i.length>0&&(a=i[0][1],u=i[0][2],s=i[0][3]);e=new Uint8Array(r);var f=0;e[f++]=(4278190080&r)>>24,e[f++]=(16711680&r)>>16,e[f++]=(65280&r)>>8,e[f++]=255&r,e.set([97,118,99,67],f),f+=4,e[f++]=1,e[f++]=a,e[f++]=u,e[f++]=s,e[f++]=255,e[f++]=224|i.length;for(var c=0;c<i.length;c++)e[f++]=(65280&i[c].length)>>8,e[f++]=255&i[c].length,e.set(i[c],f),f+=i[c].length;e[f++]=o.length;for(var d=0;d<o.length;d++)e[f++]=(65280&o[d].length)>>8,e[f++]=255&o[d].length,e.set(o[d],f),f+=o[d].length;return e}(),i){var o=u.createBox("sinf",r);f(o,e),c(o),d(o)}return r}(t,e);case"mp4a":return function(t,e){var r;r=i?u.createBox("enca",t,!1):u.createBox("mp4a",t,!1);if(r.reserved1=[0,0,0,0,0,0],r.data_reference_index=1,r.reserved2=[0,0],r.channelcount=n.audioChannels,r.samplesize=16,r.pre_defined=0,r.reserved_3=0,r.samplerate=n.audioSamplingRate<<16,r.esds=function(){var t=y(n.codecPrivateData),e=34+t.length,r=new Uint8Array(e),i=0;return r[i++]=(4278190080&e)>>24,r[i++]=(16711680&e)>>16,r[i++]=(65280&e)>>8,r[i++]=255&e,r.set([101,115,100,115],i),i+=4,r.set([0,0,0,0],i),i+=4,r[i++]=3,r[i++]=20+t.length,r[i++]=(65280&a)>>8,r[i++]=255&a,r[i++]=0,r[i++]=4,r[i++]=15+t.length,r[i++]=64,r[i]=20,r[i]|=0,r[i++]|=1,r[i++]=255,r[i++]=255,r[i++]=255,r[i++]=(4278190080&n.bandwidth)>>24,r[i++]=(16711680&n.bandwidth)>>16,r[i++]=(65280&n.bandwidth)>>8,r[i++]=255&n.bandwidth,r[i++]=(4278190080&n.bandwidth)>>24,r[i++]=(16711680&n.bandwidth)>>16,r[i++]=(65280&n.bandwidth)>>8,r[i++]=255&n.bandwidth,r[i++]=5,r[i++]=t.length,r.set(t,i),r}(),i){var o=u.createBox("sinf",r);f(o,e),c(o),d(o)}return r}(t,e);default:throw{code:h.MSS_UNSUPPORTED_CODEC_CODE,message:h.MSS_UNSUPPORTED_CODEC_MESSAGE,data:{codec:e}}}}(e))}e.entry_count=e.entries.length}(_),function(t){var e=u.createFullBox("trex",t);e.track_ID=a,e.default_sample_description_index=1,e.default_sample_duration=0,e.default_sample_size=0,e.default_sample_flags=0}(u.createBox("mvex",p)),i&&l)&&function(t,e){var r,n,i,o;for(i=0;i<e.length;i+=1)(r=e[i].initData)&&(o=u.parseBuffer(r),(n=o.fetch("pssh"))&&u.Utils.appendBox(t,n))}(p,l.getSupportedKeySystemsFromContentProtection(i))}function f(t,e){u.createBox("frma",t).data_format=function(t){var e,r=0;for(e=0;e<t.length;e+=1)r|=t.charCodeAt(e)<<8*(t.length-e-1);return r}(e)}function c(t){var e=u.createFullBox("schm",t);e.flags=0,e.version=0,e.scheme_type=1667591779,e.scheme_version=65536}function d(t){!function(t){var e=u.createFullBox("tenc",t);e.flags=0,e.version=0,e.default_IsEncrypted=1,e.default_IV_size=8,e.default_KID=i&&i.length>0&&i[0]["cenc:default_KID"]?i[0]["cenc:default_KID"]:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}(u.createBox("schi",t))}function y(t){var e,r=new Uint8Array(t.length/2);for(e=0;e<t.length/2;e+=1)r[e]=parseInt(""+t[2*e]+t[2*e+1],16);return r}return{generateMoov:function(t){var s;if(t&&t.adaptation)return r=(n=t).adaptation,e=r.period,a=r.index+1,i=e.mpd.manifest.Period_asArray[e.index].AdaptationSet_asArray[r.index].ContentProtection,o=e.mpd.manifest.Period_asArray[e.index].AdaptationSet_asArray[r.index].SegmentTemplate.timescale,function(t){var e=u.createBox("ftyp",t);e.major_brand="iso6",e.minor_version=1,e.compatible_brands=[],e.compatible_brands[0]="isom",e.compatible_brands[1]="iso6",e.compatible_brands[2]="msdh"}(s=u.createFile()),p(s),s.write()}}}v.__dashjs_factory_name="MssFragmentMoovProcessor";var _=dashjs.FactoryMaker.getClassFactory(v);function b(t,e){return t.length===e.length&&t.every((function(t,r){return t===e[r]}))}function T(){this._procFullBox(),1&this.flags&&(this._procField("aux_info_type","uint",32),this._procField("aux_info_type_parameter","uint",32)),this._procField("entry_count","uint",32),this._procFieldArray("offset",this.entry_count,"uint",1===this.version?64:32)}function E(){this._procFullBox(),1&this.flags&&(this._procField("aux_info_type","uint",32),this._procField("aux_info_type_parameter","uint",32)),this._procField("default_sample_info_size","uint",8),this._procField("sample_count","uint",32),0===this.default_sample_info_size&&this._procFieldArray("sample_info_size",this.sample_count,"uint",8)}function A(){this._procFullBox(),this._procField("sample_count","uint",32),1&this.flags&&this._procField("IV_size","uint",8),this._procEntries("entry",this.sample_count,(function(t){this._procEntryField(t,"InitializationVector","data",8),2&this.flags&&(this._procEntryField(t,"NumberOfEntries","uint",16),this._procSubEntries(t,"clearAndCryptedData",t.NumberOfEntries,(function(t){this._procEntryField(t,"BytesOfClearData","uint",16),this._procEntryField(t,"BytesOfEncryptedData","uint",32)})))}))}function S(){b(this.usertype,[109,29,155,5,66,213,68,230,128,226,20,29,175,247,87,178])&&(this._procFullBox(),this._parsing&&(this.type="tfxd"),this._procField("fragment_absolute_time","uint",1===this.version?64:32),this._procField("fragment_duration","uint",1===this.version?64:32)),b(this.usertype,[212,128,126,242,202,57,70,149,142,84,38,203,158,70,167,159])&&(this._procFullBox(),this._parsing&&(this.type="tfrf"),this._procField("fragment_count","uint",8),this._procEntries("entry",this.fragment_count,(function(t){this._procEntryField(t,"fragment_absolute_time","uint",1===this.version?64:32),this._procEntryField(t,"fragment_duration","uint",1===this.version?64:32)}))),b(this.usertype,[162,57,79,82,90,155,79,20,162,68,108,66,124,100,141,244])&&(this._parsing&&(this.type="sepiff"),A.call(this))}function w(t){t=t||{};var e,r,n,i=this.context,a=t.dashMetrics,s=t.playbackController,u=t.eventBus,l=t.protectionController,p=t.ISOBoxer,f=t.debug;return n={generateMoov:function(t){return e.generateMoov(t)},processFragment:function(t,e){if(!t||!t.request||!t.response)throw new Error("e parameter is missing or malformed");"MediaSegment"===t.request.type?r.convertFragment(t,e):t.request.type===o.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE&&(r.updateSegmentList(t,e),t.sender=null)}},p.addBoxProcessor("uuid",S),p.addBoxProcessor("saio",T),p.addBoxProcessor("saiz",E),p.addBoxProcessor("senc",A),e=_(i).create({protectionController:l,constants:t.constants,ISOBoxer:p}),r=g(i).create({dashMetrics:a,playbackController:s,ISOBoxer:p,eventBus:u,debug:f,errHandler:t.errHandler}),n}w.__dashjs_factory_name="MssFragmentProcessor";var I=dashjs.FactoryMaker.getClassFactory(w),M=r(57),N=r.n(M);function D(t){var e,r,n,i=(t=t||{}).BASE64,o=t.debug,a=t.constants,s=t.manifestModel,u=t.settings,l=["AAC","AACL","AACH","AACP","AVC1","H264","TTML","DFXP"],p={CAPT:"main",SUBT:"alternate",DESC:"main"},f={DESC:"2"},c={96e3:0,88200:1,64e3:2,48e3:3,44100:4,32e3:5,24e3:6,22050:7,16e3:8,12e3:9,11025:10,8e3:11,7350:12},d={video:"video/mp4",audio:"audio/mp4",text:"application/mp4"};function h(t,e){var r=t.getAttribute(e);return!!r&&"true"===r.toLowerCase()}function y(t,e){var r,n,i,o,a,s={},u=[],l=t.getAttribute("Name"),c=t.getAttribute("Type"),h=t.getAttribute("Language"),y=h?c+"_"+h:c;if(s.id=l||y,s.contentType=c,s.lang=h||"und",s.mimeType=d[c],s.subType=t.getAttribute("Subtype"),s.maxWidth=t.getAttribute("MaxWidth"),s.maxHeight=t.getAttribute("MaxHeight"),s.subType){if(p[s.subType]){var g={schemeIdUri:"urn:mpeg:dash:role:2011",value:p[s.subType]};s.Role=g,s.Role_asArray=[g]}if(f[s.subType]){var v={schemeIdUri:"urn:tva:metadata:cs:AudioPurposeCS:2007",value:f[s.subType]};s.Accessibility=v,s.Accessibility_asArray=[v]}}for(r=function(t,e){var r,n,i,o={};return i=t.getAttribute("Url"),r=(r=i?i.replace("{bitrate}","$Bandwidth$"):null)?r.replace("{start time}","$Time$"):null,n=(n=t.getAttribute("TimeScale"))?parseFloat(n):e,o.media=r,o.timescale=n,o.SegmentTimeline=function(t,e){var r,n,i,o,a,s,u={},l=t.getElementsByTagName("c"),p=[],f=0;for(o=0;o<l.length;o++)if(r={},(i=l[o].getAttribute("t"))&&N()(i).greater(N()(Number.MAX_SAFE_INTEGER))&&(r.tManifest=i),r.t=parseFloat(i),r.d=parseFloat(l[o].getAttribute("d")),0!==o||r.t||(r.t=0),o>0&&((n=p[p.length-1]).d||(n.tManifest?n.d=N()(i).subtract(N()(n.tManifest)).toJSNumber():n.d=r.t-n.t,f+=n.d),r.t||(n.tManifest?(r.tManifest=N()(n.tManifest).add(N()(n.d)).toString(),r.t=parseFloat(r.tManifest)):r.t=n.t+n.d)),r.d&&(f+=r.d),p.push(r),s=parseFloat(l[o].getAttribute("r")))for(a=0;a<s-1;a++)n=p[p.length-1],(r={}).t=n.t+n.d,r.d=n.d,n.tManifest&&(r.tManifest=N()(n.tManifest).add(N()(n.d)).toString()),f+=r.d,p.push(r);return u.S=p,u.S_asArray=p,u.duration=f/e,u}(t,o.timescale),o.availabilityTimeOffset="INF",o}(t,e),n=t.getElementsByTagName("QualityLevel"),o=0;o<n.length;o++)n[o].BaseURL=s.BaseURL,n[o].mimeType=s.mimeType,a=n[o].getAttribute("Index"),n[o].Id=s.id+(null!==a?"_"+a:""),null!==(i=m(n[o],t))&&(i.SegmentTemplate=r,u.push(i));return 0===u.length?null:(s.Representation=u.length>1?u:u[0],s.Representation_asArray=u,s.SegmentTemplate=r,s)}function m(t,e){var n,i,o={},s=e.getAttribute("Type"),u=null;if(o.id=t.Id,o.bandwidth=parseInt(t.getAttribute("Bitrate"),10),o.mimeType=t.mimeType,n=parseInt(t.getAttribute("MaxWidth"),10),i=parseInt(t.getAttribute("MaxHeight"),10),isNaN(n)||(o.width=n),isNaN(i)||(o.height=i),null!==(u=t.getAttribute("FourCC"))&&""!==u||(u=e.getAttribute("FourCC")),null===u||""===u)if(s===a.AUDIO)u="AAC";else if(s===a.VIDEO)return r.debug('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"'),null;return-1===l.indexOf(u.toUpperCase())?(r.warn("Codec not supported: "+u),null):("H264"===u||"AVC1"===u?o.codecs=function(t){var e,r=t.getAttribute("CodecPrivateData").toString();return e=/00000001[0-9]7/.exec(r),"avc1."+(e&&e[0]?r.substr(r.indexOf(e[0])+10,6):void 0)}(t):u.indexOf("AAC")>=0?(o.codecs=function(t,e){var r,n,i,o,a=parseInt(t.getAttribute("SamplingRate"),10),s=t.getAttribute("CodecPrivateData").toString(),u=0;"AACH"===e&&(u=5);void 0===s||""===s?(u=2,i=c[a],"AACH"===e?(u=5,s=new Uint8Array(4),o=c[2*a],s[0]=u<<3|i>>1,s[1]=i<<7|t.Channels<<3|o>>1,s[2]=o<<7|8,s[3]=0,(n=new Uint16Array(2))[0]=(s[0]<<8)+s[1],n[1]=(s[2]<<8)+s[3],r=n[0].toString(16),r=n[0].toString(16)+n[1].toString(16)):((s=new Uint8Array(2))[0]=u<<3|i>>1,s[1]=i<<7|parseInt(t.getAttribute("Channels"),10)<<3,(n=new Uint16Array(1))[0]=(s[0]<<8)+s[1],r=n[0].toString(16)),s=(s=""+r).toUpperCase(),t.setAttribute("CodecPrivateData",s)):0===u&&(u=(248&parseInt(s.substr(0,2),16))>>3);return"mp4a.40."+u}(t,u),o.audioSamplingRate=parseInt(t.getAttribute("SamplingRate"),10),o.audioChannels=parseInt(t.getAttribute("Channels"),10)):(u.indexOf("TTML")||u.indexOf("DFXP"))&&(o.codecs=a.STPP),o.codecPrivateData=""+t.getAttribute("CodecPrivateData"),o.BaseURL=t.BaseURL,o)}function g(t){var e,r,n;return(e=function(t){var e,r,n,i=0;(t[i+3]<<24)+(t[i+2]<<16)+(t[i+1]<<8)+t[i],(t[(i+=4)+1]<<8)+t[i],i+=2;for(;i<t.length;)if(e=(t[i+1]<<8)+t[i],i+=2,1===e)return r=(t[i+1]<<8)+t[i],i+=2,(n=new Uint8Array(r)).set(t.subarray(i,i+r)),n;return null}(i.decodeArray(t.firstChild.data)))&&(e=new Uint16Array(e.buffer),e=String.fromCharCode.apply(null,e),r=(new DOMParser).parseFromString(e,"application/xml").querySelector("KID").textContent,r=i.decodeArray(r),v(n=r,0,3),v(n,1,2),v(n,4,5),v(n,6,7)),r}function v(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function _(t){var e,r,o,l,p,f,c,d,m,v,_,b={},T=[],E=t.getElementsByTagName("SmoothStreamingMedia")[0],A=t.getElementsByTagName("Protection")[0],S=null;b.protocol="MSS",b.profiles="urn:mpeg:dash:profile:isoff-live:2011",b.type=h(E,"IsLive")?"dynamic":"static",d=E.getAttribute("TimeScale"),b.timescale=d?parseFloat(d):1e7;var w=parseFloat(E.getAttribute("DVRWindowLength"));"dynamic"!==b.type||0!==w&&!isNaN(w)||(w=1/0),0===w&&h(E,"CanSeek")&&(w=1/0),w>0&&(b.timeShiftBufferDepth=w/b.timescale);var I=parseFloat(E.getAttribute("Duration"));for(b.mediaPresentationDuration=0===I?1/0:I/b.timescale,b.minBufferTime=2,b.ttmlTimeIsRelative=!0,"dynamic"===b.type&&I>0&&(b.type="static",b.timeShiftBufferDepth=I/b.timescale),"dynamic"===b.type&&(b.refreshManifestOnSwitchTrack=!0,b.doNotUpdateDVRWindowOnBufferUpdated=!0,b.ignorePostponeTimePeriod=!0,b.availabilityStartTime=new Date(null)),b.Period=function(t,e){var r,n,i={AdaptationSet_asArray:[]};r=t.getElementsByTagName("StreamIndex");for(var o=0;o<r.length;o++)null!==(n=y(r[o],e))&&i.AdaptationSet_asArray.push(n);return i.AdaptationSet_asArray.length>0&&(i.AdaptationSet=i.AdaptationSet_asArray.length>1?i.AdaptationSet_asArray:i.AdaptationSet_asArray[0]),i}(E,b.timescale),b.Period_asArray=[b.Period],(e=b.Period).start=0,void 0!==A&&((S=t.getElementsByTagName("ProtectionHeader")[0]).firstChild.data=S.firstChild.data.replace(/\n|\r/g,""),l=g(S),(o=function(t){var e={__text:t.firstChild.data,__prefix:"mspr"};return{schemeIdUri:"urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95",value:"com.microsoft.playready",pro:e,pro_asArray:e}}(S))["cenc:default_KID"]=l,T.push(o),(o=function(t){var e={schemeIdUri:"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",value:"com.widevine.alpha"};if(!t)return e;var r=new Uint8Array(2+t.length);r[0]=18,r[1]=16,r.set(t,2);var n=32+r.length,o=new Uint8Array(n),a=0;return o[a++]=(4278190080&n)>>24,o[a++]=(16711680&n)>>16,o[a++]=(65280&n)>>8,o[a++]=255&n,o.set([112,115,115,104,0,0,0,0],a),a+=8,o.set([237,239,139,169,121,214,74,206,163,200,39,220,213,29,33,237],a),a+=16,o[a++]=(4278190080&r.length)>>24,o[a++]=(16711680&r.length)>>16,o[a++]=(65280&r.length)>>8,o[a++]=255&r.length,o.set(r,a),o=String.fromCharCode.apply(null,o),o=i.encodeASCII(o),e.pssh={__text:o},e}(l))["cenc:default_KID"]=l,T.push(o),b.ContentProtection=T,b.ContentProtection_asArray=T),r=e.AdaptationSet_asArray,v=0;v<r.length;v+=1)r[v].SegmentTemplate.initialization="$Bandwidth$",void 0!==b.ContentProtection&&(r[v].ContentProtection=b.ContentProtection,r[v].ContentProtection_asArray=b.ContentProtection_asArray),"video"===r[v].contentType&&(m=r[v].SegmentTemplate.SegmentTimeline.S_asArray[0].d/r[v].SegmentTemplate.timescale,b.minBufferTime=m,"dynamic"===b.type&&b.timeShiftBufferDepth>0&&b.timeShiftBufferDepth!==1/0&&b.timeShiftBufferDepth>r[v].SegmentTemplate.SegmentTimeline.duration&&(b.timeShiftBufferDepth=r[v].SegmentTemplate.SegmentTimeline.duration));if(b.minBufferTime=Math.min(b.minBufferTime,b.timeShiftBufferDepth?b.timeShiftBufferDepth:1/0),"dynamic"===b.type){var M=u.get().streaming.delay.liveDelay;if(!M)M=m*(null===u.get().streaming.delay.liveDelayFragmentCount||isNaN(u.get().streaming.delay.liveDelayFragmentCount)?4:u.get().streaming.delay.liveDelayFragmentCount);var N=Math.max(b.timeShiftBufferDepth-10,b.timeShiftBufferDepth/2),D=Math.min(N,M),P=D-1.5*m;n={streaming:{buffer:{stableBufferTime:u.get().streaming.buffer.stableBufferTime,bufferTimeAtTopQuality:u.get().streaming.buffer.bufferTimeAtTopQuality,bufferTimeAtTopQualityLongForm:u.get().streaming.buffer.bufferTimeAtTopQualityLongForm},timeShiftBuffer:{calcFromSegmentTimeline:u.get().streaming.timeShiftBuffer.calcFromSegmentTimeline},delay:{liveDelay:u.get().streaming.delay.liveDelay}}},u.update({streaming:{buffer:{stableBufferTime:P,bufferTimeAtTopQuality:P,bufferTimeAtTopQualityLongForm:P},timeShiftBuffer:{calcFromSegmentTimeline:!0},delay:{liveDelay:D}}})}if(delete b.ContentProtection,delete b.ContentProtection_asArray,"static"===b.type){var O=s.getValue();if(O&&O.timestampOffset)p=O.timestampOffset;else for(v=0;v<r.length;v++)r[v].contentType!==a.AUDIO&&r[v].contentType!==a.VIDEO||(f=(c=r[v].SegmentTemplate.SegmentTimeline.S_asArray)[0].t,void 0===p&&(p=f),p=Math.min(p,f),b.mediaPresentationDuration=Math.min(b.mediaPresentationDuration,r[v].SegmentTemplate.SegmentTimeline.duration));if(p>0){for(b.timestampOffset=p,v=0;v<r.length;v++){for(c=r[v].SegmentTemplate.SegmentTimeline.S_asArray,_=0;_<c.length;_++)c[_].tManifest||(c[_].tManifest=c[_].t.toString()),c[_].t-=p;r[v].contentType!==a.AUDIO&&r[v].contentType!==a.VIDEO||(e.start=Math.max(c[0].t,e.start),r[v].SegmentTemplate.presentationTimeOffset=e.start)}e.start/=b.timescale}}return b.mediaPresentationDuration=Math.floor(1e3*b.mediaPresentationDuration)/1e3,e.duration=b.mediaPresentationDuration,b}return e={parse:function(t){var e,n,i=window.performance.now();e=function(t){var e=null;if(window.DOMParser&&(e=(new window.DOMParser).parseFromString(t,"text/xml")).getElementsByTagName("parsererror").length>0)throw new Error("parsing the manifest failed");return e}(t);var o=window.performance.now();if(null===e)return null;n=_(e,new Date);var a=window.performance.now();return r.info("Parsing complete: (xmlParsing: "+(o-i).toPrecision(3)+"ms, mss2dash: "+(a-o).toPrecision(3)+"ms, total: "+((a-i)/1e3).toPrecision(3)+"s)"),n},getMatchers:function(){return null},getIron:function(){return null},reset:function(){n&&u.update(n)}},r=o.getLogger(e),e}D.__dashjs_factory_name="MssParser";var P=dashjs.FactoryMaker.getClassFactory(D);function O(t){t=t||{};var e,r,a,l=this.context,p=t.eventBus,f=t.events,c=t.constants,d=t.initSegmentType,h=t.dashMetrics,y=t.playbackController,m=t.streamController,g=t.protectionController,v=I(l).create({dashMetrics:h,playbackController:y,protectionController:g,streamController:m,eventBus:p,constants:c,ISOBoxer:t.ISOBoxer,debug:t.debug,errHandler:t.errHandler});function _(t){return m.getActiveStreamProcessors().filter((function(e){return e.getType()===t}))[0]}function b(t){return r.filter((function(e){return e.getType()===t}))[0]}function T(){m.getActiveStreamProcessors().forEach((function(e){if(e.getType()===c.VIDEO||e.getType()===c.AUDIO||e.getType()===c.TEXT){var n=b(e.getType());n||((n=s(l).create({streamProcessor:e,baseURLController:t.baseURLController,debug:t.debug})).initialize(),r.push(n)),n.start()}}))}function E(e){var r=_(e.mediaType);if(r){var o=r.getRepresentationController().getCurrentRepresentation(),a=r.getMediaInfo(),s=new i.a;s.mediaType=o.adaptation.type,s.type=d,s.range=o.range,s.quality=o.index,s.mediaInfo=a,s.representationId=o.id;var l=function(t,e,r){var i=new n.a;return i.streamId=e,i.mediaInfo=t.mediaInfo,i.segmentType=t.type,i.start=t.startTime,i.duration=t.duration,i.end=i.start+i.duration,i.index=t.index,i.quality=t.quality,i.representationId=t.representationId,i.endFragment=r,i}(s,a.streamInfo.id,e.type!==f.FRAGMENT_LOADING_PROGRESS);try{l.bytes=v.generateMoov(o),p.trigger(f.INIT_FRAGMENT_LOADED,{chunk:l},{streamId:a.streamInfo.id,mediaType:o.adaptation.type})}catch(e){t.errHandler.error(new u.a(e.code,e.message,e.data))}e.sender=null}}function A(t){if(!t.error){var e=_(t.request.mediaType);if(e){if(v.processFragment(t,e),t.request.type===o.a.MSS_FRAGMENT_INFO_SEGMENT_TYPE){var r=b(t.request.mediaType);r&&r.fragmentInfoLoaded(t)}var n=t.request.mediaInfo.streamInfo.manifestInfo;n.isDynamic||n.dvrWindowSize===1/0||T()}}}function S(){y.getIsDynamic()&&0!==y.getTime()&&T()}function w(){y.getIsDynamic()&&0!==y.getTime()&&T()}function M(t){t&&t.data&&(t.data=t.data.replace(/http:\/\/www.w3.org\/2006\/10\/ttaf1/gi,"http://www.w3.org/ns/ttml"))}return a={reset:function(){e&&(e.reset(),e=void 0),p.off(f.INIT_FRAGMENT_NEEDED,E,this),p.off(f.PLAYBACK_PAUSED,S,this),p.off(f.PLAYBACK_SEEKING,w,this),p.off(f.FRAGMENT_LOADING_COMPLETED,A,this),p.off(f.TTML_TO_PARSE,M,this),r.forEach((function(t){t.reset()})),r=[]},createMssParser:function(){return e=P(l).create(t)},registerEvents:function(){p.on(f.INIT_FRAGMENT_NEEDED,E,a,{priority:dashjs.FactoryMaker.getSingletonFactoryByName(p.getClassName()).EVENT_PRIORITY_HIGH}),p.on(f.PLAYBACK_PAUSED,S,a,{priority:dashjs.FactoryMaker.getSingletonFactoryByName(p.getClassName()).EVENT_PRIORITY_HIGH}),p.on(f.PLAYBACK_SEEKING,w,a,{priority:dashjs.FactoryMaker.getSingletonFactoryByName(p.getClassName()).EVENT_PRIORITY_HIGH}),p.on(f.FRAGMENT_LOADING_COMPLETED,A,a,{priority:dashjs.FactoryMaker.getSingletonFactoryByName(p.getClassName()).EVENT_PRIORITY_HIGH}),p.on(f.TTML_TO_PARSE,M,a)}},r=[],a}O.__dashjs_factory_name="MssHandler";var C=dashjs.FactoryMaker.getClassFactory(O);C.errors=h,dashjs.FactoryMaker.updateClassFactory(O.__dashjs_factory_name,C);e.a=C}}).default}));
//# sourceMappingURL=dash.mss.min.js.map

/***/ }),

/***/ 399:
/***/ (function(__unused_webpack_module, exports) {

!function(t,e){ true?e(exports):0}(this,(function(t){"use strict";
/*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */var e=function(){return e=Object.assign||function(t){for(var e,n=1,o=arguments.length;n<o;n++)for(var r in e=arguments[n])Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t},e.apply(this,arguments)};function n(t,e){var n="function"==typeof Symbol&&t[Symbol.iterator];if(!n)return t;var o,r,l=n.call(t),i=[];try{for(;(void 0===e||e-- >0)&&!(o=l.next()).done;)i.push(o.value)}catch(t){r={error:t}}finally{try{o&&!o.done&&(n=l.return)&&n.call(l)}finally{if(r)throw r.error}}return i}var o=function(t){return void 0===t||"auto"===t||"instant"===t||"smooth"===t};function r(t,e){this.scrollLeft=t,this.scrollTop=e}var l=function(t,e,n){return void 0===n&&(n="cannot convert to dictionary."),"Failed to execute '".concat(t,"' on '").concat(e,"': ").concat(n)},i=function(t,e,n){return l(t,e,"The provided value '".concat(n,"' is not a valid enum value of type ScrollBehavior."))},c=function(t,e,n){var o,r="__SEAMLESS.BACKUP$".concat(e);return t[r]||!t[e]||(null===(o=t[e])||void 0===o?void 0:o.__isPolyfill)||(t[r]=t[e]),t[r]||n},u=function(t){var e=typeof t;return null!==t&&("object"===e||"function"===e)},a=function(){return"scrollBehavior"in window.document.documentElement.style},f=function(t){Object.defineProperty(t,"__isPolyfill",{value:!0})},s=function(t,e){f(e),[HTMLElement.prototype,SVGElement.prototype,Element.prototype].forEach((function(n){c(n,t),n[t]=e}))},d=function(t){return t.ownerDocument.scrollingElement||t.ownerDocument.documentElement},v=function(t){return.5*(1-Math.cos(Math.PI*t))},w=function(){var t,e,n;return null!==(n=null===(e=null===(t=window.performance)||void 0===t?void 0:t.now)||void 0===e?void 0:e.call(t))&&void 0!==n?n:window.Date.now()},m=function(t){var e=(w()-t.timeStamp)/(t.duration||500);if(e>1)return t.method(t.targetX,t.targetY),void t.callback();var n=(t.timingFunc||v)(e),o=t.startX+(t.targetX-t.startX)*n,r=t.startY+(t.targetY-t.startY)*n;t.method(o,r),t.rafId=window.requestAnimationFrame((function(){m(t)}))},h=function(t){return isFinite(t)?Number(t):0},p=function(t){return function(a,f,s){var v,p=n((v=a).window===v?[d(a.document.documentElement),"Window"]:[a,"Element"],2),y=p[0],g=p[1],b=null!=f?f:{};if(!u(b))throw new TypeError(l(t,g));if(!o(b.behavior))throw new TypeError(i(t,g,b.behavior));"scrollBy"===t&&(b.left=h(b.left)+y.scrollLeft,b.top=h(b.top)+y.scrollTop),function(t,n,o){var l,i;if(function(t){var e;return null!==(e=t.isConnected)&&void 0!==e?e:!(t.ownerDocument&&1&t.ownerDocument.compareDocumentPosition(t))}(t)){var u=t.scrollLeft,a=t.scrollTop,f=h(null!==(l=n.left)&&void 0!==l?l:u),s=h(null!==(i=n.top)&&void 0!==i?i:a);if(f!==u||s!==a){var d=c(HTMLElement.prototype,"scroll",r),v=c(Object.getPrototypeOf(t),"scroll",d).bind(t);if("smooth"===n.behavior){var p=function(){window.removeEventListener("wheel",g),window.removeEventListener("touchmove",g)},y=e(e({},o),{timeStamp:w(),startX:u,startY:a,targetX:f,targetY:s,rafId:0,method:v,callback:p}),g=function(){window.cancelAnimationFrame(y.rafId),p()};window.addEventListener("wheel",g,{passive:!0,once:!0}),window.addEventListener("touchmove",g,{passive:!0,once:!0}),m(y)}else v(f,s)}}}(y,b,s)}},y=p("scroll"),g=p("scrollTo"),b=p("scrollBy"),T=y,E=g,S=b,P=y,L=g,B=b,V=function(t){switch(t){case"horizontal-tb":case"lr":case"lr-tb":case"rl":case"rl-tb":return 0;case"vertical-rl":case"tb":case"tb-rl":return 1;case"vertical-lr":case"tb-lr":return 2;case"sideways-rl":return 3;case"sideways-lr":return 4}return 0},M=function(t,e,o,r){var l,i=0;switch(e||(i^=2),t){case 0:i=i>>1|(1&i)<<1,o=(l=n([r,o],2))[0],r=l[1];break;case 1:case 3:i^=1;break;case 4:i^=2}return[i,o,r]},D=function(t){return 1==(1&M(V(t.writingMode),"rtl"!==t.direction,void 0,void 0)[0])},I=function(t,e,n,o,r,l,i){return 0!==t?t:r<e&&l>n||r>e&&l<n?null:r<=e&&i<=o||l>=n&&i>=o?2:l>n&&i<o||r<e&&i>o?3:null},W=function(t){return"visible"!==t&&"clip"!==t},H=function(t,e){return(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth)&&(W(e.overflowY)||W(e.overflowX)||t===d(t))},k=function(t){var e=t.parentNode,n=t.parentElement;if(null===n&&null!==e){if(11===e.nodeType)return e.host;if(9===e.nodeType)return function(t){var e;try{return(null===(e=t.ownerDocument.defaultView)||void 0===e?void 0:e.frameElement)||null}catch(t){return null}}(t)}return n},x=function(t,e,n){return t<e?e:t>n?n:t},_=function(t,e,n){switch(t){case 1:return(e+n)/2;case 3:return n;case 2:case 0:return e}},j=function(t,e){var o,r,l,i=null===(o=t.ownerDocument.defaultView)||void 0===o?void 0:o.visualViewport,c=n(t===d(t)?[0,0,null!==(r=null==i?void 0:i.width)&&void 0!==r?r:t.clientWidth,null!==(l=null==i?void 0:i.height)&&void 0!==l?l:t.clientHeight]:[e.left,e.top,t.clientWidth,t.clientHeight],4),u=c[0],a=c[1],f=c[2],s=c[3],v=u+t.clientLeft,w=a+t.clientTop;return[w,v+f,w+s,v]},C=function(t,e){var o=[],r=t.ownerDocument,l=r.defaultView;if(!l)return o;for(var i=window.getComputedStyle(t),c="rtl"!==i.direction,u=n(function(t,e,o){var r=n(M(e,o,t.block||"start",t.inline||"nearest"),3),l=r[0];return[r[1],r[2]].map((function(t,e){switch(t){case"center":return 1;case"nearest":return 0;default:return"start"===t==!(l>>e&1)?2:3}}))}(e,V(i.writingMode||i.getPropertyValue("-webkit-writing-mode")||i.getPropertyValue("-ms-writing-mode")),c),2),a=u[0],f=u[1],s=n(function(t,e,n){var o,r=e.top,l=e.right,i=e.bottom,c=e.left,u=(o=t.ownerDocument,["scroll-margin","scroll-snap-margin"].filter((function(t){return t in o.documentElement.style}))[0]);if(!u)return[r,l,i,c];var a=function(t){var e=n.getPropertyValue("".concat(u,"-").concat(t));return parseInt(e,10)||0};return[r-a("top"),l+a("right"),i+a("bottom"),c-a("left")]}(t,t.getBoundingClientRect(),i),4),d=s[0],v=s[1],w=s[2],m=s[3],h=k(t);null!==h;h=k(h)){if(r!==h.ownerDocument){if(!(l=(r=h.ownerDocument).defaultView))break;var p=h.getBoundingClientRect(),y=p.left,g=p.top;d+=g,v+=y,w+=g,m+=y}var b=l.getComputedStyle(h);if("fixed"===b.position)break;if(H(h,b)){var T=h.getBoundingClientRect(),E=n(j(h,T),4),S=E[0],P=E[1],L=E[2],B=E[3],W=I(a,B,P,h.clientWidth,m,v,v-m),C=I(f,S,L,h.clientHeight,d,w,w-d),O=null===W?0:_(W,m,v)-_(W,B,P),X=null===C?0:_(C,d,w)-_(C,S,L),Y=D(b)?x(O,-h.scrollWidth+h.clientWidth-h.scrollLeft,-h.scrollLeft):x(O,-h.scrollLeft,h.scrollWidth-h.clientWidth-h.scrollLeft),F=x(X,-h.scrollTop,h.scrollHeight-h.clientHeight-h.scrollTop);o.push([h,{left:h.scrollLeft+Y,top:h.scrollTop+F,behavior:e.behavior}]),d=Math.max(d-F,S),v=Math.min(v-Y,P),w=Math.min(w-F,L),m=Math.max(m-Y,B)}}return o},O=function(t,e,r){var l=e||{};if(!o(l.behavior))throw new TypeError(i("scrollIntoView","Element",l.behavior));C(t,l).forEach((function(t){var e=n(t,2),o=e[0],l=e[1];T(o,l,r)}))},X=O,Y=function(t,e){return function(n){if(!a()){var o={scroll:y,scrollTo:g,scrollBy:b}[t];e(t,(function(){var t=arguments;if(1!==arguments.length){var e=t[0],r=t[1];o(this,{left:e,top:r})}else o(this,t[0],n)}))}}},F=Y("scroll",s),A=Y("scrollTo",s),R=Y("scrollBy",s),N=function(t,e){f(e),c(window,t),window[t]=e},q=Y("scroll",N),z=Y("scrollTo",N),G=Y("scrollBy",N);function K(t){X(this,{block:null==t||t?"start":"end",inline:"nearest"})}var U=function(t){if(!a()){var e=c(window.HTMLElement.prototype,"scrollIntoView",K);s("scrollIntoView",(function(){var n=arguments,o=n[0];1===n.length&&u(o)?X(this,o,t):e.apply(this,n)}))}};t.elementScroll=T,t.elementScrollBy=S,t.elementScrollByPolyfill=R,t.elementScrollIntoView=X,t.elementScrollIntoViewPolyfill=U,t.elementScrollPolyfill=F,t.elementScrollTo=E,t.elementScrollToPolyfill=A,t.modifyWindow=N,t.polyfill=function(t){a()||(F(t),A(t),R(t),U(t),q(t),z(t),G(t))},t.scroll=y,t.scrollBy=b,t.scrollIntoView=O,t.scrollTo=g,t.windowScroll=P,t.windowScrollBy=B,t.windowScrollByPolyfill=G,t.windowScrollPolyfill=q,t.windowScrollTo=L,t.windowScrollToPolyfill=z,Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=bundle.min.js.map


/***/ }),

/***/ 629:
/***/ (function(module) {

"undefined"!=typeof window&&function(t,e){ true?module.exports=e():0}(this,(function(){return function(t){var e={};function r(i){if(e[i])return e[i].exports;var n=e[i]={i:i,l:!1,exports:{}};return t[i].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=t,r.c=e,r.d=function(t,e,i){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(r.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var n in t)r.d(i,n,function(e){return t[e]}.bind(null,n));return i},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="/dist/",r(r.s=21)}([function(t,e,r){"use strict";var i;r.d(e,"a",(function(){return i})),function(t){t.MEDIA_ATTACHING="hlsMediaAttaching",t.MEDIA_ATTACHED="hlsMediaAttached",t.MEDIA_DETACHING="hlsMediaDetaching",t.MEDIA_DETACHED="hlsMediaDetached",t.BUFFER_RESET="hlsBufferReset",t.BUFFER_CODECS="hlsBufferCodecs",t.BUFFER_CREATED="hlsBufferCreated",t.BUFFER_APPENDING="hlsBufferAppending",t.BUFFER_APPENDED="hlsBufferAppended",t.BUFFER_EOS="hlsBufferEos",t.BUFFER_FLUSHING="hlsBufferFlushing",t.BUFFER_FLUSHED="hlsBufferFlushed",t.MANIFEST_LOADING="hlsManifestLoading",t.MANIFEST_LOADED="hlsManifestLoaded",t.MANIFEST_PARSED="hlsManifestParsed",t.LEVEL_SWITCHING="hlsLevelSwitching",t.LEVEL_SWITCHED="hlsLevelSwitched",t.LEVEL_LOADING="hlsLevelLoading",t.LEVEL_LOADED="hlsLevelLoaded",t.LEVEL_UPDATED="hlsLevelUpdated",t.LEVEL_PTS_UPDATED="hlsLevelPtsUpdated",t.LEVELS_UPDATED="hlsLevelsUpdated",t.AUDIO_TRACKS_UPDATED="hlsAudioTracksUpdated",t.AUDIO_TRACK_SWITCHING="hlsAudioTrackSwitching",t.AUDIO_TRACK_SWITCHED="hlsAudioTrackSwitched",t.AUDIO_TRACK_LOADING="hlsAudioTrackLoading",t.AUDIO_TRACK_LOADED="hlsAudioTrackLoaded",t.SUBTITLE_TRACKS_UPDATED="hlsSubtitleTracksUpdated",t.SUBTITLE_TRACKS_CLEARED="hlsSubtitleTracksCleared",t.SUBTITLE_TRACK_SWITCH="hlsSubtitleTrackSwitch",t.SUBTITLE_TRACK_LOADING="hlsSubtitleTrackLoading",t.SUBTITLE_TRACK_LOADED="hlsSubtitleTrackLoaded",t.SUBTITLE_FRAG_PROCESSED="hlsSubtitleFragProcessed",t.CUES_PARSED="hlsCuesParsed",t.NON_NATIVE_TEXT_TRACKS_FOUND="hlsNonNativeTextTracksFound",t.INIT_PTS_FOUND="hlsInitPtsFound",t.FRAG_LOADING="hlsFragLoading",t.FRAG_LOAD_EMERGENCY_ABORTED="hlsFragLoadEmergencyAborted",t.FRAG_LOADED="hlsFragLoaded",t.FRAG_DECRYPTED="hlsFragDecrypted",t.FRAG_PARSING_INIT_SEGMENT="hlsFragParsingInitSegment",t.FRAG_PARSING_USERDATA="hlsFragParsingUserdata",t.FRAG_PARSING_METADATA="hlsFragParsingMetadata",t.FRAG_PARSED="hlsFragParsed",t.FRAG_BUFFERED="hlsFragBuffered",t.FRAG_CHANGED="hlsFragChanged",t.FPS_DROP="hlsFpsDrop",t.FPS_DROP_LEVEL_CAPPING="hlsFpsDropLevelCapping",t.ERROR="hlsError",t.DESTROYING="hlsDestroying",t.KEY_LOADING="hlsKeyLoading",t.KEY_LOADED="hlsKeyLoaded",t.LIVE_BACK_BUFFER_REACHED="hlsLiveBackBufferReached",t.BACK_BUFFER_REACHED="hlsBackBufferReached"}(i||(i={}))},function(t,e,r){"use strict";r.d(e,"a",(function(){return o})),r.d(e,"b",(function(){return l}));var i=function(){},n={trace:i,debug:i,log:i,warn:i,info:i,error:i},a=n;function s(t){var e=self.console[t];return e?e.bind(self.console,"["+t+"] >"):i}function o(t){if(self.console&&!0===t||"object"==typeof t){!function(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),i=1;i<e;i++)r[i-1]=arguments[i];r.forEach((function(e){a[e]=t[e]?t[e].bind(t):s(e)}))}(t,"debug","log","info","warn","error");try{a.log()}catch(t){a=n}}else a=n}var l=n},function(t,e,r){"use strict";var i,n;r.d(e,"b",(function(){return i})),r.d(e,"a",(function(){return n})),function(t){t.NETWORK_ERROR="networkError",t.MEDIA_ERROR="mediaError",t.KEY_SYSTEM_ERROR="keySystemError",t.MUX_ERROR="muxError",t.OTHER_ERROR="otherError"}(i||(i={})),function(t){t.KEY_SYSTEM_NO_KEYS="keySystemNoKeys",t.KEY_SYSTEM_NO_ACCESS="keySystemNoAccess",t.KEY_SYSTEM_NO_SESSION="keySystemNoSession",t.KEY_SYSTEM_LICENSE_REQUEST_FAILED="keySystemLicenseRequestFailed",t.KEY_SYSTEM_NO_INIT_DATA="keySystemNoInitData",t.MANIFEST_LOAD_ERROR="manifestLoadError",t.MANIFEST_LOAD_TIMEOUT="manifestLoadTimeOut",t.MANIFEST_PARSING_ERROR="manifestParsingError",t.MANIFEST_INCOMPATIBLE_CODECS_ERROR="manifestIncompatibleCodecsError",t.LEVEL_EMPTY_ERROR="levelEmptyError",t.LEVEL_LOAD_ERROR="levelLoadError",t.LEVEL_LOAD_TIMEOUT="levelLoadTimeOut",t.LEVEL_SWITCH_ERROR="levelSwitchError",t.AUDIO_TRACK_LOAD_ERROR="audioTrackLoadError",t.AUDIO_TRACK_LOAD_TIMEOUT="audioTrackLoadTimeOut",t.SUBTITLE_LOAD_ERROR="subtitleTrackLoadError",t.SUBTITLE_TRACK_LOAD_TIMEOUT="subtitleTrackLoadTimeOut",t.FRAG_LOAD_ERROR="fragLoadError",t.FRAG_LOAD_TIMEOUT="fragLoadTimeOut",t.FRAG_DECRYPT_ERROR="fragDecryptError",t.FRAG_PARSING_ERROR="fragParsingError",t.REMUX_ALLOC_ERROR="remuxAllocError",t.KEY_LOAD_ERROR="keyLoadError",t.KEY_LOAD_TIMEOUT="keyLoadTimeOut",t.BUFFER_ADD_CODEC_ERROR="bufferAddCodecError",t.BUFFER_INCOMPATIBLE_CODECS_ERROR="bufferIncompatibleCodecsError",t.BUFFER_APPEND_ERROR="bufferAppendError",t.BUFFER_APPENDING_ERROR="bufferAppendingError",t.BUFFER_STALLED_ERROR="bufferStalledError",t.BUFFER_FULL_ERROR="bufferFullError",t.BUFFER_SEEK_OVER_HOLE="bufferSeekOverHole",t.BUFFER_NUDGE_ON_STALL="bufferNudgeOnStall",t.INTERNAL_EXCEPTION="internalException",t.INTERNAL_ABORTED="aborted",t.UNKNOWN="unknown"}(n||(n={}))},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));var i=Number.isFinite||function(t){return"number"==typeof t&&isFinite(t)};Number.MAX_SAFE_INTEGER},function(t,e,r){"use strict";var i,n;r.d(e,"a",(function(){return i})),r.d(e,"b",(function(){return n})),function(t){t.MANIFEST="manifest",t.LEVEL="level",t.AUDIO_TRACK="audioTrack",t.SUBTITLE_TRACK="subtitleTrack"}(i||(i={})),function(t){t.MAIN="main",t.AUDIO="audio",t.SUBTITLE="subtitle"}(n||(n={}))},function(t,e,r){"use strict";r.d(e,"a",(function(){return l})),r.d(e,"c",(function(){return g})),r.d(e,"k",(function(){return v})),r.d(e,"h",(function(){return p})),r.d(e,"e",(function(){return m})),r.d(e,"d",(function(){return y})),r.d(e,"f",(function(){return b})),r.d(e,"l",(function(){return E})),r.d(e,"b",(function(){return S})),r.d(e,"j",(function(){return L})),r.d(e,"i",(function(){return D})),r.d(e,"g",(function(){return R}));var i=r(10),n=r(6),a=r(7),s=Math.pow(2,32)-1,o=[].push,l={video:1,audio:2,id3:3,text:4};function u(t){return String.fromCharCode.apply(null,t)}function h(t,e){var r=t[e]<<8|t[e+1];return r<0?65536+r:r}function d(t,e){var r=c(t,e);return r<0?4294967296+r:r}function c(t,e){return t[e]<<24|t[e+1]<<16|t[e+2]<<8|t[e+3]}function f(t,e,r){t[e]=r>>24,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=255&r}function g(t,e){var r=[];if(!e.length)return r;for(var i=t.byteLength,n=0;n<i;){var a=d(t,n),s=a>1?n+a:i;if(u(t.subarray(n+4,n+8))===e[0])if(1===e.length)r.push(t.subarray(n+8,s));else{var l=g(t.subarray(n+8,s),e.slice(1));l.length&&o.apply(r,l)}n=s}return r}function v(t){var e=g(t,["moov"])[0],r=e?e.length:null,i=g(t,["sidx"]);if(!i||!i[0])return null;var n=[],a=i[0],s=a[0],o=8,l=d(a,o);o+=4;o+=0===s?8:16,o+=2;var u=a.length+0,c=h(a,o);o+=2;for(var f=0;f<c;f++){var v=o,p=d(a,v);v+=4;var m=2147483647&p;if(1===(2147483648&p)>>>31)return console.warn("SIDX has hierarchical references (not supported)"),null;var y=d(a,v);v+=4,n.push({referenceSize:m,subsegmentDuration:y,info:{duration:y/l,start:u,end:u+m-1}}),u+=m,o=v+=4}return{earliestPresentationTime:0,timescale:l,version:s,referencesCount:c,references:n,moovEndOffset:r}}function p(t){for(var e=[],r=g(t,["moov","trak"]),i=0;i<r.length;i++){var a=r[i],s=g(a,["tkhd"])[0];if(s){var o=s[0],l=0===o?12:20,h=d(s,l),c=g(a,["mdia","mdhd"])[0];if(c){var f=d(c,l=0===(o=c[0])?12:20),v=g(a,["mdia","hdlr"])[0];if(v){var p=u(v.subarray(8,12)),m={soun:n.a.AUDIO,vide:n.a.VIDEO}[p];if(m){var y=g(a,["mdia","minf","stbl","stsd"])[0],T=void 0;y&&(T=u(y.subarray(12,16))),e[h]={timescale:f,type:m},e[m]={timescale:f,id:h,codec:T}}}}}}return g(t,["moov","mvex","trex"]).forEach((function(t){var r=d(t,4),i=e[r];i&&(i.default={duration:d(t,12),flags:d(t,20)})})),e}function m(t,e){return g(e,["moof","traf"]).reduce((function(e,r){var i=g(r,["tfdt"])[0],n=i[0],a=g(r,["tfhd"]).reduce((function(e,r){var a=d(r,4),s=t[a];if(s){var o=d(i,4);1===n&&(o*=Math.pow(2,32),o+=d(i,8));var l=o/(s.timescale||9e4);if(isFinite(l)&&(null===e||l<e))return l}return e}),null);return null!==a&&isFinite(a)&&(null===e||a<e)?a:e}),null)||0}function y(t,e){for(var r=0,i=0,a=0,s=g(t,["moof","traf"]),o=0;o<s.length;o++){var l=s[o],u=g(l,["tfhd"])[0],h=e[d(u,4)];if(h){var c=h.default,f=d(u,0)|(null==c?void 0:c.flags),p=null==c?void 0:c.duration;8&f&&(p=d(u,2&f?12:8));for(var m=h.timescale||9e4,y=g(l,["trun"]),b=0;b<y.length;b++){if(!(r=T(y[b]))&&p)r=p*d(y[b],4);h.type===n.a.VIDEO?i+=r/m:h.type===n.a.AUDIO&&(a+=r/m)}}}if(0===i&&0===a){var E=v(t);if(null!=E&&E.references)return E.references.reduce((function(t,e){return t+e.info.duration||0}),0)}return i||a}function T(t){var e=d(t,0),r=8;1&e&&(r+=4),4&e&&(r+=4);for(var i=0,n=d(t,4),a=0;a<n;a++){if(256&e)i+=d(t,r),r+=4;512&e&&(r+=4),1024&e&&(r+=4),2048&e&&(r+=4)}return i}function b(t,e,r){g(e,["moof","traf"]).forEach((function(e){g(e,["tfhd"]).forEach((function(i){var n=d(i,4),a=t[n];if(a){var o=a.timescale||9e4;g(e,["tfdt"]).forEach((function(t){var e=t[0],i=d(t,4);if(0===e)i-=r*o,f(t,4,i=Math.max(i,0));else{i*=Math.pow(2,32),i+=d(t,8),i-=r*o,i=Math.max(i,0);var n=Math.floor(i/(s+1)),a=Math.floor(i%(s+1));f(t,4,n),f(t,8,a)}}))}}))}))}function E(t){var e={valid:null,remainder:null},r=g(t,["moof"]);if(!r)return e;if(r.length<2)return e.remainder=t,e;var n=r[r.length-1];return e.valid=Object(i.a)(t,0,n.byteOffset-8),e.remainder=Object(i.a)(t,n.byteOffset-8),e}function S(t,e){var r=new Uint8Array(t.length+e.length);return r.set(t),r.set(e,t.length),r}function L(t,e){var r=[],i=e.samples,a=e.timescale,s=e.id,o=!1;return g(i,["moof"]).map((function(l){var u=l.byteOffset-8;g(l,["traf"]).map((function(l){var h=g(l,["tfdt"]).map((function(t){var e=t[0],r=d(t,4);return 1===e&&(r*=Math.pow(2,32),r+=d(t,8)),r/a}))[0];return void 0!==h&&(t=h),g(l,["tfhd"]).map((function(h){var f=d(h,4),v=16777215&d(h,0),p=0,m=0!=(16&v),y=0,T=0!=(32&v),b=8;f===s&&(0!=(1&v)&&(b+=8),0!=(2&v)&&(b+=4),0!=(8&v)&&(p=d(h,b),b+=4),m&&(y=d(h,b),b+=4),T&&(b+=4),"video"===e.type&&(o=function(t){if(!t)return!1;var e=t.indexOf("."),r=e<0?t:t.substring(0,e);return"hvc1"===r||"hev1"===r||"dvh1"===r||"dvhe"===r}(e.codec)),g(l,["trun"]).map((function(s){var l=s[0],h=16777215&d(s,0),f=0!=(1&h),g=0,v=0!=(4&h),m=0!=(256&h),T=0,b=0!=(512&h),E=0,S=0!=(1024&h),L=0!=(2048&h),R=0,k=d(s,4),_=8;f&&(g=d(s,_),_+=4),v&&(_+=4);for(var I=g+u,O=0;O<k;O++){if(m?(T=d(s,_),_+=4):T=p,b?(E=d(s,_),_+=4):E=y,S&&(_+=4),L&&(R=0===l?d(s,_):c(s,_),_+=4),e.type===n.a.VIDEO)for(var w=0;w<E;){var C=d(i,I),x=31&i[I+=4];if(A(o,x))D(i.subarray(I,I+C),t+R/a,r);I+=C,w+=C+4}t+=T/a}})))}))}))})),r}function A(t,e){return t?39===e||40===e:6===e}function D(t,e,r){var i=function(t){var e=t.byteLength,r=[],i=1;for(;i<e-2;)0===t[i]&&0===t[i+1]&&3===t[i+2]?(r.push(i+2),i+=2):i++;if(0===r.length)return t;var n=e-r.length,a=new Uint8Array(n),s=0;for(i=0;i<n;s++,i++)s===r[0]&&(s++,r.shift()),a[i]=t[s];return a}(t),n=0;n++;for(var s=0,o=0,l=!1,u=0;n<i.length;){s=0;do{if(n>=i.length)break;s+=u=i[n++]}while(255===u);o=0;do{if(n>=i.length)break;o+=u=i[n++]}while(255===u);var c=i.length-n;if(!l&&4===s&&n<i.length){if(l=!0,181===i[n++]){var f=h(i,n);if(n+=2,49===f){var g=d(i,n);if(n+=4,1195456820===g){var v=i[n++];if(3===v){var p=i[n++],m=64&p,y=m?2+3*(31&p):0,T=new Uint8Array(y);if(m){T[0]=p;for(var b=1;b<y;b++)T[b]=i[n++]}r.push({type:v,payloadType:s,pts:e,bytes:T})}}}}}else if(5===s&&o<c){if(l=!0,o>16){for(var E=[],S=0;S<16;S++){var L=i[n++].toString(16);E.push(1==L.length?"0"+L:L),3!==S&&5!==S&&7!==S&&9!==S||E.push("-")}for(var A=o-16,D=new Uint8Array(A),R=0;R<A;R++)D[R]=i[n++];r.push({payloadType:s,pts:e,uuid:E.join(""),userData:Object(a.f)(D),userDataBytes:D})}}else if(o<c)n+=o;else if(o>c)break}}function R(t){var e=t[0],r="",i="",n=0,a=0,s=0,o=0,l=0,h=0;if(0===e){for(;"\0"!==u(t.subarray(h,h+1));)r+=u(t.subarray(h,h+1)),h+=1;for(r+=u(t.subarray(h,h+1)),h+=1;"\0"!==u(t.subarray(h,h+1));)i+=u(t.subarray(h,h+1)),h+=1;i+=u(t.subarray(h,h+1)),h+=1,n=d(t,12),a=d(t,16),o=d(t,20),l=d(t,24),h=28}else if(1===e){n=d(t,h+=4);var c=d(t,h+=4),f=d(t,h+=4);for(h+=4,s=Math.pow(2,32)*c+f,Number.isSafeInteger(s)||(s=Number.MAX_SAFE_INTEGER,console.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")),o=d(t,h),l=d(t,h+=4),h+=4;"\0"!==u(t.subarray(h,h+1));)r+=u(t.subarray(h,h+1)),h+=1;for(r+=u(t.subarray(h,h+1)),h+=1;"\0"!==u(t.subarray(h,h+1));)i+=u(t.subarray(h,h+1)),h+=1;i+=u(t.subarray(h,h+1)),h+=1}return{schemeIdUri:r,value:i,timeScale:n,presentationTime:s,presentationTimeDelta:a,eventDuration:o,id:l,payload:t.subarray(h,t.byteLength)}}},function(t,e,r){"use strict";r.d(e,"a",(function(){return i})),r.d(e,"b",(function(){return g})),r.d(e,"c",(function(){return v}));var i,n=r(3),a=r(12),s=r(1),o=r(18),l=r(14);function u(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,h(t,e)}function h(t,e){return(h=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function d(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function c(t,e,r){return e&&d(t.prototype,e),r&&d(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}!function(t){t.AUDIO="audio",t.VIDEO="video",t.AUDIOVIDEO="audiovideo"}(i||(i={}));var f=function(){function t(t){var e;this._byteRange=null,this._url=null,this.baseurl=void 0,this.relurl=void 0,this.elementaryStreams=((e={})[i.AUDIO]=null,e[i.VIDEO]=null,e[i.AUDIOVIDEO]=null,e),this.baseurl=t}return t.prototype.setByteRange=function(t,e){var r=t.split("@",2),i=[];1===r.length?i[0]=e?e.byteRangeEndOffset:0:i[0]=parseInt(r[1]),i[1]=parseInt(r[0])+i[0],this._byteRange=i},c(t,[{key:"byteRange",get:function(){return this._byteRange?this._byteRange:[]}},{key:"byteRangeStartOffset",get:function(){return this.byteRange[0]}},{key:"byteRangeEndOffset",get:function(){return this.byteRange[1]}},{key:"url",get:function(){return!this._url&&this.baseurl&&this.relurl&&(this._url=Object(a.buildAbsoluteURL)(this.baseurl,this.relurl,{alwaysNormalize:!0})),this._url||""},set:function(t){this._url=t}}]),t}(),g=function(t){function e(e,r){var i;return(i=t.call(this,r)||this)._decryptdata=null,i.rawProgramDateTime=null,i.programDateTime=null,i.tagList=[],i.duration=0,i.sn=0,i.levelkey=void 0,i.type=void 0,i.loader=null,i.level=-1,i.cc=0,i.startPTS=void 0,i.endPTS=void 0,i.appendedPTS=void 0,i.startDTS=void 0,i.endDTS=void 0,i.start=0,i.deltaPTS=void 0,i.maxStartPTS=void 0,i.minEndPTS=void 0,i.stats=new l.a,i.urlId=0,i.data=void 0,i.bitrateTest=!1,i.title=null,i.initSegment=null,i.type=e,i}u(e,t);var r=e.prototype;return r.createInitializationVector=function(t){for(var e=new Uint8Array(16),r=12;r<16;r++)e[r]=t>>8*(15-r)&255;return e},r.setDecryptDataFromLevelKey=function(t,e){var r=t;return"AES-128"===(null==t?void 0:t.method)&&t.uri&&!t.iv&&((r=o.a.fromURI(t.uri)).method=t.method,r.iv=this.createInitializationVector(e),r.keyFormat="identity"),r},r.setElementaryStreamInfo=function(t,e,r,i,n,a){void 0===a&&(a=!1);var s=this.elementaryStreams,o=s[t];o?(o.startPTS=Math.min(o.startPTS,e),o.endPTS=Math.max(o.endPTS,r),o.startDTS=Math.min(o.startDTS,i),o.endDTS=Math.max(o.endDTS,n)):s[t]={startPTS:e,endPTS:r,startDTS:i,endDTS:n,partial:a}},r.clearElementaryStreamInfo=function(){var t=this.elementaryStreams;t[i.AUDIO]=null,t[i.VIDEO]=null,t[i.AUDIOVIDEO]=null},c(e,[{key:"decryptdata",get:function(){if(!this.levelkey&&!this._decryptdata)return null;if(!this._decryptdata&&this.levelkey){var t=this.sn;"number"!=typeof t&&(this.levelkey&&"AES-128"===this.levelkey.method&&!this.levelkey.iv&&s.b.warn('missing IV for initialization segment with method="'+this.levelkey.method+'" - compliance issue'),t=0),this._decryptdata=this.setDecryptDataFromLevelKey(this.levelkey,t)}return this._decryptdata}},{key:"end",get:function(){return this.start+this.duration}},{key:"endProgramDateTime",get:function(){if(null===this.programDateTime)return null;if(!Object(n.a)(this.programDateTime))return null;var t=Object(n.a)(this.duration)?this.duration:0;return this.programDateTime+1e3*t}},{key:"encrypted",get:function(){var t;return!(null===(t=this.decryptdata)||void 0===t||!t.keyFormat||!this.decryptdata.uri)}}]),e}(f),v=function(t){function e(e,r,i,n,a){var s;(s=t.call(this,i)||this).fragOffset=0,s.duration=0,s.gap=!1,s.independent=!1,s.relurl=void 0,s.fragment=void 0,s.index=void 0,s.stats=new l.a,s.duration=e.decimalFloatingPoint("DURATION"),s.gap=e.bool("GAP"),s.independent=e.bool("INDEPENDENT"),s.relurl=e.enumeratedString("URI"),s.fragment=r,s.index=n;var o=e.enumeratedString("BYTERANGE");return o&&s.setByteRange(o,a),a&&(s.fragOffset=a.fragOffset+a.duration),s}return u(e,t),c(e,[{key:"start",get:function(){return this.fragment.start+this.fragOffset}},{key:"end",get:function(){return this.start+this.duration}},{key:"loaded",get:function(){var t=this.elementaryStreams;return!!(t.audio||t.video||t.audiovideo)}}]),e}(f)},function(t,e,r){"use strict";r.d(e,"b",(function(){return s})),r.d(e,"a",(function(){return l})),r.d(e,"d",(function(){return u})),r.d(e,"e",(function(){return h})),r.d(e,"c",(function(){return c})),r.d(e,"f",(function(){return y}));var i,n=function(t,e){return e+10<=t.length&&73===t[e]&&68===t[e+1]&&51===t[e+2]&&t[e+3]<255&&t[e+4]<255&&t[e+6]<128&&t[e+7]<128&&t[e+8]<128&&t[e+9]<128},a=function(t,e){return e+10<=t.length&&51===t[e]&&68===t[e+1]&&73===t[e+2]&&t[e+3]<255&&t[e+4]<255&&t[e+6]<128&&t[e+7]<128&&t[e+8]<128&&t[e+9]<128},s=function(t,e){for(var r=e,i=0;n(t,e);){i+=10,i+=o(t,e+6),a(t,e+10)&&(i+=10),e+=i}if(i>0)return t.subarray(r,r+i)},o=function(t,e){var r=0;return r=(127&t[e])<<21,r|=(127&t[e+1])<<14,r|=(127&t[e+2])<<7,r|=127&t[e+3]},l=function(t,e){return n(t,e)&&o(t,e+6)+10<=t.length-e},u=function(t){for(var e=c(t),r=0;r<e.length;r++){var i=e[r];if(h(i))return m(i)}},h=function(t){return t&&"PRIV"===t.key&&"com.apple.streaming.transportStreamTimestamp"===t.info},d=function(t){var e=String.fromCharCode(t[0],t[1],t[2],t[3]),r=o(t,4);return{type:e,size:r,data:t.subarray(10,10+r)}},c=function(t){for(var e=0,r=[];n(t,e);){for(var i=o(t,e+6),s=(e+=10)+i;e+8<s;){var l=d(t.subarray(e)),u=f(l);u&&r.push(u),e+=l.size+10}a(t,e)&&(e+=10)}return r},f=function(t){return"PRIV"===t.type?g(t):"W"===t.type[0]?p(t):v(t)},g=function(t){if(!(t.size<2)){var e=y(t.data,!0),r=new Uint8Array(t.data.subarray(e.length+1));return{key:t.type,info:e,data:r.buffer}}},v=function(t){if(!(t.size<2)){if("TXXX"===t.type){var e=1,r=y(t.data.subarray(e),!0);e+=r.length+1;var i=y(t.data.subarray(e));return{key:t.type,info:r,data:i}}var n=y(t.data.subarray(1));return{key:t.type,data:n}}},p=function(t){if("WXXX"===t.type){if(t.size<2)return;var e=1,r=y(t.data.subarray(e),!0);e+=r.length+1;var i=y(t.data.subarray(e));return{key:t.type,info:r,data:i}}var n=y(t.data);return{key:t.type,data:n}},m=function(t){if(8===t.data.byteLength){var e=new Uint8Array(t.data),r=1&e[3],i=(e[4]<<23)+(e[5]<<15)+(e[6]<<7)+e[7];return i/=45,r&&(i+=47721858.84),Math.round(i)}},y=function(t,e){void 0===e&&(e=!1);var r=T();if(r){var i=r.decode(t);if(e){var n=i.indexOf("\0");return-1!==n?i.substring(0,n):i}return i.replace(/\0/g,"")}for(var a,s,o,l=t.length,u="",h=0;h<l;){if(0===(a=t[h++])&&e)return u;if(0!==a&&3!==a)switch(a>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:u+=String.fromCharCode(a);break;case 12:case 13:s=t[h++],u+=String.fromCharCode((31&a)<<6|63&s);break;case 14:s=t[h++],o=t[h++],u+=String.fromCharCode((15&a)<<12|(63&s)<<6|(63&o)<<0)}}return u};function T(){return i||void 0===self.TextDecoder||(i=new self.TextDecoder("utf-8")),i}},function(t,e,r){"use strict";var i;r.d(e,"a",(function(){return i})),function(t){t.audioId3="org.id3",t.dateRange="com.apple.quicktime.HLS",t.emsg="https://aomedia.org/emsg/ID3"}(i||(i={}))},function(t,e,r){"use strict";r.d(e,"c",(function(){return n})),r.d(e,"b",(function(){return a})),r.d(e,"a",(function(){return s}));function i(t,e,r,i){void 0===r&&(r=1),void 0===i&&(i=!1);var n=t*e*r;return i?Math.round(n):n}function n(t,e,r,n){return void 0===r&&(r=1),void 0===n&&(n=!1),i(t,e,1/r,n)}function a(t,e){return void 0===e&&(e=!1),i(t,1e3,1/9e4,e)}function s(t,e){return void 0===e&&(e=1),i(t,9e4,1/e)}},function(t,e,r){"use strict";function i(t,e,r){return Uint8Array.prototype.slice?t.slice(e,r):new Uint8Array(Array.prototype.slice.call(t,e,r))}r.d(e,"a",(function(){return i}))},function(t,e,r){"use strict";r.d(e,"c",(function(){return ht})),r.d(e,"d",(function(){return ct})),r.d(e,"a",(function(){return ft})),r.d(e,"b",(function(){return gt}));var i=r(0),n=r(2),a=r(17),s=r(3),o=r(7),l=r(8);function u(t,e){return void 0===t&&(t=""),void 0===e&&(e=9e4),{type:t,id:-1,pid:-1,inputTimeScale:e,sequenceNumber:-1,samples:[],dropped:0}}var h=r(5),d=r(10),c=function(){function t(){this._audioTrack=void 0,this._id3Track=void 0,this.frameIndex=0,this.cachedData=null,this.initPTS=null}var e=t.prototype;return e.resetInitSegment=function(t,e,r,i){this._id3Track={type:"id3",id:3,pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],dropped:0}},e.resetTimeStamp=function(){},e.resetContiguity=function(){},e.canParse=function(t,e){return!1},e.appendFrame=function(t,e,r){},e.demux=function(t,e){this.cachedData&&(t=Object(h.b)(this.cachedData,t),this.cachedData=null);var r,i,n=o.b(t,0),a=n?n.length:0,s=this._audioTrack,c=this._id3Track,g=n?o.d(n):void 0,v=t.length;for(0!==this.frameIndex&&null!==this.initPTS||(this.initPTS=f(g,e)),n&&n.length>0&&c.samples.push({pts:this.initPTS,dts:this.initPTS,data:n,type:l.a.audioId3}),i=this.initPTS;a<v;){if(this.canParse(t,a)){var p=this.appendFrame(s,t,a);p?(this.frameIndex++,i=p.sample.pts,r=a+=p.length):a=v}else o.a(t,a)?(n=o.b(t,a),c.samples.push({pts:i,dts:i,data:n,type:l.a.audioId3}),r=a+=n.length):a++;if(a===v&&r!==v){var m=Object(d.a)(t,r);this.cachedData?this.cachedData=Object(h.b)(this.cachedData,m):this.cachedData=m}}return{audioTrack:s,videoTrack:u(),id3Track:c,textTrack:u()}},e.demuxSampleAes=function(t,e,r){return Promise.reject(new Error("["+this+"] This demuxer does not support Sample-AES decryption"))},e.flush=function(t){var e=this.cachedData;return e&&(this.cachedData=null,this.demux(e,0)),this.frameIndex=0,{audioTrack:this._audioTrack,videoTrack:u(),id3Track:this._id3Track,textTrack:u()}},e.destroy=function(){},t}(),f=function(t,e){return Object(s.a)(t)?90*t:9e4*e},g=c,v=r(1);function p(t,e){return 255===t[e]&&240==(246&t[e+1])}function m(t,e){return 1&t[e+1]?7:9}function y(t,e){return(3&t[e+3])<<11|t[e+4]<<3|(224&t[e+5])>>>5}function T(t,e){return e+1<t.length&&p(t,e)}function b(t,e){if(T(t,e)){var r=m(t,e);if(e+r>=t.length)return!1;var i=y(t,e);if(i<=r)return!1;var n=e+i;return n===t.length||T(t,n)}return!1}function E(t,e,r,a,s){if(!t.samplerate){var o=function(t,e,r,a){var s,o,l,u,h=navigator.userAgent.toLowerCase(),d=a,c=[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350];s=1+((192&e[r+2])>>>6);var f=(60&e[r+2])>>>2;if(!(f>c.length-1))return l=(1&e[r+2])<<2,l|=(192&e[r+3])>>>6,v.b.log("manifest codec:"+a+", ADTS type:"+s+", samplingIndex:"+f),/firefox/i.test(h)?f>=6?(s=5,u=new Array(4),o=f-3):(s=2,u=new Array(2),o=f):-1!==h.indexOf("android")?(s=2,u=new Array(2),o=f):(s=5,u=new Array(4),a&&(-1!==a.indexOf("mp4a.40.29")||-1!==a.indexOf("mp4a.40.5"))||!a&&f>=6?o=f-3:((a&&-1!==a.indexOf("mp4a.40.2")&&(f>=6&&1===l||/vivaldi/i.test(h))||!a&&1===l)&&(s=2,u=new Array(2)),o=f)),u[0]=s<<3,u[0]|=(14&f)>>1,u[1]|=(1&f)<<7,u[1]|=l<<3,5===s&&(u[1]|=(14&o)>>1,u[2]=(1&o)<<7,u[2]|=8,u[3]=0),{config:u,samplerate:c[f],channelCount:l,codec:"mp4a.40."+s,manifestCodec:d};t.trigger(i.a.ERROR,{type:n.b.MEDIA_ERROR,details:n.a.FRAG_PARSING_ERROR,fatal:!0,reason:"invalid ADTS sampling index:"+f})}(e,r,a,s);if(!o)return;t.config=o.config,t.samplerate=o.samplerate,t.channelCount=o.channelCount,t.codec=o.codec,t.manifestCodec=o.manifestCodec,v.b.log("parsed codec:"+t.codec+", rate:"+o.samplerate+", channels:"+o.channelCount)}}function S(t){return 9216e4/t}function L(t,e,r,i,n){var a,s=i+n*S(t.samplerate),o=function(t,e){var r=m(t,e);if(e+r<=t.length){var i=y(t,e)-r;if(i>0)return{headerLength:r,frameLength:i}}}(e,r);if(o){var l=o.frameLength,u=o.headerLength,h=u+l,d=Math.max(0,r+h-e.length);d?(a=new Uint8Array(h-u)).set(e.subarray(r+u,e.length),0):a=e.subarray(r+u,r+h);var c={unit:a,pts:s};return d||t.samples.push(c),{sample:c,length:h,missing:d}}var f=e.length-r;return(a=new Uint8Array(f)).set(e.subarray(r,e.length),0),{sample:{unit:a,pts:s},length:f,missing:-1}}function A(t,e){return(A=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var D=function(t){var e,r;function i(e,r){var i;return(i=t.call(this)||this).observer=void 0,i.config=void 0,i.observer=e,i.config=r,i}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,A(e,r);var n=i.prototype;return n.resetInitSegment=function(e,r,i,n){t.prototype.resetInitSegment.call(this,e,r,i,n),this._audioTrack={container:"audio/adts",type:"audio",id:2,pid:-1,sequenceNumber:0,segmentCodec:"aac",samples:[],manifestCodec:r,duration:n,inputTimeScale:9e4,dropped:0}},i.probe=function(t){if(!t)return!1;for(var e=(o.b(t,0)||[]).length,r=t.length;e<r;e++)if(b(t,e))return v.b.log("ADTS sync word found !"),!0;return!1},n.canParse=function(t,e){return function(t,e){return function(t,e){return e+5<t.length}(t,e)&&p(t,e)&&y(t,e)<=t.length-e}(t,e)},n.appendFrame=function(t,e,r){E(t,this.observer,e,r,t.manifestCodec);var i=L(t,e,r,this.initPTS,this.frameIndex);if(i&&0===i.missing)return i},i}(g);D.minProbeByteLength=9;var R=D,k=/\/emsg[-/]ID3/i,_=function(){function t(t,e){this.remainderData=null,this.timeOffset=0,this.config=void 0,this.videoTrack=void 0,this.audioTrack=void 0,this.id3Track=void 0,this.txtTrack=void 0,this.config=e}var e=t.prototype;return e.resetTimeStamp=function(){},e.resetInitSegment=function(t,e,r,i){var n=Object(h.h)(t),a=this.videoTrack=u("video",1),s=this.audioTrack=u("audio",1),o=this.txtTrack=u("text",1);if(this.id3Track=u("id3",1),this.timeOffset=0,n.video){var l=n.video,d=l.id,c=l.timescale,f=l.codec;a.id=d,a.timescale=o.timescale=c,a.codec=f}if(n.audio){var g=n.audio,v=g.id,p=g.timescale,m=g.codec;s.id=v,s.timescale=p,s.codec=m}o.id=h.a.text,a.sampleDuration=0,a.duration=s.duration=i},e.resetContiguity=function(){},t.probe=function(t){return t=t.length>16384?t.subarray(0,16384):t,Object(h.c)(t,["moof"]).length>0},e.demux=function(t,e){this.timeOffset=e;var r=t,i=this.videoTrack,n=this.txtTrack;if(this.config.progressive){this.remainderData&&(r=Object(h.b)(this.remainderData,t));var a=Object(h.l)(r);this.remainderData=a.remainder,i.samples=a.valid||new Uint8Array}else i.samples=r;var s=this.extractID3Track(i,e);return n.samples=Object(h.j)(e,i),{videoTrack:i,audioTrack:this.audioTrack,id3Track:s,textTrack:this.txtTrack}},e.flush=function(){var t=this.timeOffset,e=this.videoTrack,r=this.txtTrack;e.samples=this.remainderData||new Uint8Array,this.remainderData=null;var i=this.extractID3Track(e,this.timeOffset);return r.samples=Object(h.j)(t,e),{videoTrack:e,audioTrack:u(),id3Track:i,textTrack:u()}},e.extractID3Track=function(t,e){var r=this.id3Track;if(t.samples.length){var i=Object(h.c)(t.samples,["emsg"]);i&&i.forEach((function(t){var i=Object(h.g)(t);if(k.test(i.schemeIdUri)){var n=Object(s.a)(i.presentationTime)?i.presentationTime/i.timeScale:e+i.presentationTimeDelta/i.timeScale,a=i.payload;r.samples.push({data:a,len:a.byteLength,dts:n,pts:n,type:l.a.emsg})}}))}return r},e.demuxSampleAes=function(t,e,r){return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"))},e.destroy=function(){},t}();_.minProbeByteLength=1024;var I=_,O=null,w=[32,64,96,128,160,192,224,256,288,320,352,384,416,448,32,48,56,64,80,96,112,128,160,192,224,256,320,384,32,40,48,56,64,80,96,112,128,160,192,224,256,320,32,48,56,64,80,96,112,128,144,160,176,192,224,256,8,16,24,32,40,48,56,64,80,96,112,128,144,160],C=[44100,48e3,32e3,22050,24e3,16e3,11025,12e3,8e3],x=[[0,72,144,12],[0,0,0,0],[0,72,144,12],[0,144,144,12]],P=[0,1,1,4];function M(t,e,r,i,n){if(!(r+24>e.length)){var a=F(e,r);if(a&&r+a.frameLength<=e.length){var s=i+n*(9e4*a.samplesPerFrame/a.sampleRate),o={unit:e.subarray(r,r+a.frameLength),pts:s,dts:s};return t.config=[],t.channelCount=a.channelCount,t.samplerate=a.sampleRate,t.samples.push(o),{sample:o,length:a.frameLength,missing:0}}}}function F(t,e){var r=t[e+1]>>3&3,i=t[e+1]>>1&3,n=t[e+2]>>4&15,a=t[e+2]>>2&3;if(1!==r&&0!==n&&15!==n&&3!==a){var s=t[e+2]>>1&1,o=t[e+3]>>6,l=1e3*w[14*(3===r?3-i:3===i?3:4)+n-1],u=C[3*(3===r?0:2===r?1:2)+a],h=3===o?1:2,d=x[r][i],c=P[i],f=8*d*c,g=Math.floor(d*l/u+s)*c;if(null===O){var v=(navigator.userAgent||"").match(/Chrome\/(\d+)/i);O=v?parseInt(v[1]):0}return!!O&&O<=87&&2===i&&l>=224e3&&0===o&&(t[e+3]=128|t[e+3]),{sampleRate:u,channelCount:h,frameLength:g,samplesPerFrame:f}}}function N(t,e){return 255===t[e]&&224==(224&t[e+1])&&0!=(6&t[e+1])}function U(t,e){return e+1<t.length&&N(t,e)}function B(t,e){if(e+1<t.length&&N(t,e)){var r=F(t,e),i=4;null!=r&&r.frameLength&&(i=r.frameLength);var n=e+i;return n===t.length||U(t,n)}return!1}var G=function(){function t(t){this.data=void 0,this.bytesAvailable=void 0,this.word=void 0,this.bitsAvailable=void 0,this.data=t,this.bytesAvailable=t.byteLength,this.word=0,this.bitsAvailable=0}var e=t.prototype;return e.loadWord=function(){var t=this.data,e=this.bytesAvailable,r=t.byteLength-e,i=new Uint8Array(4),n=Math.min(4,e);if(0===n)throw new Error("no bytes available");i.set(t.subarray(r,r+n)),this.word=new DataView(i.buffer).getUint32(0),this.bitsAvailable=8*n,this.bytesAvailable-=n},e.skipBits=function(t){var e;this.bitsAvailable>t?(this.word<<=t,this.bitsAvailable-=t):(t-=this.bitsAvailable,t-=(e=t>>3)>>3,this.bytesAvailable-=e,this.loadWord(),this.word<<=t,this.bitsAvailable-=t)},e.readBits=function(t){var e=Math.min(this.bitsAvailable,t),r=this.word>>>32-e;return t>32&&v.b.error("Cannot read more than 32 bits at a time"),this.bitsAvailable-=e,this.bitsAvailable>0?this.word<<=e:this.bytesAvailable>0&&this.loadWord(),(e=t-e)>0&&this.bitsAvailable?r<<e|this.readBits(e):r},e.skipLZ=function(){var t;for(t=0;t<this.bitsAvailable;++t)if(0!=(this.word&2147483648>>>t))return this.word<<=t,this.bitsAvailable-=t,t;return this.loadWord(),t+this.skipLZ()},e.skipUEG=function(){this.skipBits(1+this.skipLZ())},e.skipEG=function(){this.skipBits(1+this.skipLZ())},e.readUEG=function(){var t=this.skipLZ();return this.readBits(t+1)-1},e.readEG=function(){var t=this.readUEG();return 1&t?1+t>>>1:-1*(t>>>1)},e.readBoolean=function(){return 1===this.readBits(1)},e.readUByte=function(){return this.readBits(8)},e.readUShort=function(){return this.readBits(16)},e.readUInt=function(){return this.readBits(32)},e.skipScalingList=function(t){for(var e=8,r=8,i=0;i<t;i++)0!==r&&(r=(e+this.readEG()+256)%256),e=0===r?e:r},e.readSPS=function(){var t,e,r,i=0,n=0,a=0,s=0,o=this.readUByte.bind(this),l=this.readBits.bind(this),u=this.readUEG.bind(this),h=this.readBoolean.bind(this),d=this.skipBits.bind(this),c=this.skipEG.bind(this),f=this.skipUEG.bind(this),g=this.skipScalingList.bind(this);o();var v=o();if(l(5),d(3),o(),f(),100===v||110===v||122===v||244===v||44===v||83===v||86===v||118===v||128===v){var p=u();if(3===p&&d(1),f(),f(),d(1),h())for(e=3!==p?8:12,r=0;r<e;r++)h()&&g(r<6?16:64)}f();var m=u();if(0===m)u();else if(1===m)for(d(1),c(),c(),t=u(),r=0;r<t;r++)c();f(),d(1);var y=u(),T=u(),b=l(1);0===b&&d(1),d(1),h()&&(i=u(),n=u(),a=u(),s=u());var E=[1,1];if(h()&&h())switch(o()){case 1:E=[1,1];break;case 2:E=[12,11];break;case 3:E=[10,11];break;case 4:E=[16,11];break;case 5:E=[40,33];break;case 6:E=[24,11];break;case 7:E=[20,11];break;case 8:E=[32,11];break;case 9:E=[80,33];break;case 10:E=[18,11];break;case 11:E=[15,11];break;case 12:E=[64,33];break;case 13:E=[160,99];break;case 14:E=[4,3];break;case 15:E=[3,2];break;case 16:E=[2,1];break;case 255:E=[o()<<8|o(),o()<<8|o()]}return{width:Math.ceil(16*(y+1)-2*i-2*n),height:(2-b)*(T+1)*16-(b?2:4)*(a+s),pixelRatio:E}},e.readSliceType=function(){return this.readUByte(),this.readUEG(),this.readUEG()},t}(),j=function(){function t(t,e,r){this.keyData=void 0,this.decrypter=void 0,this.keyData=r,this.decrypter=new a.a(t,e,{removePKCS7Padding:!1})}var e=t.prototype;return e.decryptBuffer=function(t,e){this.decrypter.decrypt(t,this.keyData.key.buffer,this.keyData.iv.buffer,e)},e.decryptAacSample=function(t,e,r,i){var n=t[e].unit;if(!(n.length<=16)){var a=n.subarray(16,n.length-n.length%16),s=a.buffer.slice(a.byteOffset,a.byteOffset+a.length),o=this;this.decryptBuffer(s,(function(a){var s=new Uint8Array(a);n.set(s,16),i||o.decryptAacSamples(t,e+1,r)}))}},e.decryptAacSamples=function(t,e,r){for(;;e++){if(e>=t.length)return void r();if(!(t[e].unit.length<32)){var i=this.decrypter.isSync();if(this.decryptAacSample(t,e,r,i),!i)return}}},e.getAvcEncryptedData=function(t){for(var e=16*Math.floor((t.length-48)/160)+16,r=new Int8Array(e),i=0,n=32;n<t.length-16;n+=160,i+=16)r.set(t.subarray(n,n+16),i);return r},e.getAvcDecryptedUnit=function(t,e){for(var r=new Uint8Array(e),i=0,n=32;n<t.length-16;n+=160,i+=16)t.set(r.subarray(i,i+16),n);return t},e.decryptAvcSample=function(t,e,r,i,n,a){var s=X(n.data),o=this.getAvcEncryptedData(s),l=this;this.decryptBuffer(o.buffer,(function(o){n.data=l.getAvcDecryptedUnit(s,o),a||l.decryptAvcSamples(t,e,r+1,i)}))},e.decryptAvcSamples=function(t,e,r,i){if(t instanceof Uint8Array)throw new Error("Cannot decrypt samples of type Uint8Array");for(;;e++,r=0){if(e>=t.length)return void i();for(var n=t[e].units;!(r>=n.length);r++){var a=n[r];if(!(a.data.length<=48||1!==a.type&&5!==a.type)){var s=this.decrypter.isSync();if(this.decryptAvcSample(t,e,r,i,a,s),!s)return}}}},t}();function K(){return(K=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}var H=function(){function t(t,e,r){this.observer=void 0,this.config=void 0,this.typeSupported=void 0,this.sampleAes=null,this.pmtParsed=!1,this.audioCodec=void 0,this.videoCodec=void 0,this._duration=0,this._pmtId=-1,this._avcTrack=void 0,this._audioTrack=void 0,this._id3Track=void 0,this._txtTrack=void 0,this.aacOverFlow=null,this.avcSample=null,this.remainderData=null,this.observer=t,this.config=e,this.typeSupported=r}t.probe=function(e){var r=t.syncOffset(e);return!(r<0)&&(r&&v.b.warn("MPEG2-TS detected but first sync word found @ offset "+r+", junk ahead ?"),!0)},t.syncOffset=function(t){for(var e=Math.min(1e3,t.length-564),r=0;r<e;){if(71===t[r]&&71===t[r+188]&&71===t[r+376])return r;r++}return-1},t.createTrack=function(t,e){return{container:"video"===t||"audio"===t?"video/mp2t":void 0,type:t,id:h.a[t],pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],dropped:0,duration:"audio"===t?e:void 0}};var e=t.prototype;return e.resetInitSegment=function(e,r,i,n){this.pmtParsed=!1,this._pmtId=-1,this._avcTrack=t.createTrack("video"),this._audioTrack=t.createTrack("audio",n),this._id3Track=t.createTrack("id3"),this._txtTrack=t.createTrack("text"),this._audioTrack.segmentCodec="aac",this.aacOverFlow=null,this.avcSample=null,this.audioCodec=r,this.videoCodec=i,this._duration=n},e.resetTimeStamp=function(){},e.resetContiguity=function(){var t=this._audioTrack,e=this._avcTrack,r=this._id3Track;t&&(t.pesData=null),e&&(e.pesData=null),r&&(r.pesData=null),this.aacOverFlow=null},e.demux=function(e,r,a,s){var o;void 0===a&&(a=!1),void 0===s&&(s=!1),a||(this.sampleAes=null);var l=this._avcTrack,u=this._audioTrack,d=this._id3Track,c=this._txtTrack,f=l.pid,g=l.pesData,p=u.pid,m=d.pid,y=u.pesData,T=d.pesData,b=!1,E=this.pmtParsed,S=this._pmtId,L=e.length;if(this.remainderData&&(L=(e=Object(h.b)(this.remainderData,e)).length,this.remainderData=null),L<188&&!s)return this.remainderData=e,{audioTrack:u,videoTrack:l,id3Track:d,textTrack:c};var A=Math.max(0,t.syncOffset(e));(L-=(L+A)%188)<e.byteLength&&!s&&(this.remainderData=new Uint8Array(e.buffer,L,e.buffer.byteLength-L));for(var D=0,R=A;R<L;R+=188)if(71===e[R]){var k=!!(64&e[R+1]),_=((31&e[R+1])<<8)+e[R+2],I=void 0;if((48&e[R+3])>>4>1){if((I=R+5+e[R+4])===R+188)continue}else I=R+4;switch(_){case f:k&&(g&&(o=q(g))&&this.parseAVCPES(l,c,o,!1),g={data:[],size:0}),g&&(g.data.push(e.subarray(I,R+188)),g.size+=R+188-I);break;case p:if(k){if(y&&(o=q(y)))switch(u.segmentCodec){case"aac":this.parseAACPES(u,o);break;case"mp3":this.parseMPEGPES(u,o)}y={data:[],size:0}}y&&(y.data.push(e.subarray(I,R+188)),y.size+=R+188-I);break;case m:k&&(T&&(o=q(T))&&this.parseID3PES(d,o),T={data:[],size:0}),T&&(T.data.push(e.subarray(I,R+188)),T.size+=R+188-I);break;case 0:k&&(I+=e[I]+1),S=this._pmtId=W(e,I);break;case S:k&&(I+=e[I]+1);var O=Y(e,I,this.typeSupported,a);(f=O.avc)>0&&(l.pid=f),(p=O.audio)>0&&(u.pid=p,u.segmentCodec=O.segmentCodec),(m=O.id3)>0&&(d.pid=m),b&&!E&&(v.b.log("reparse from beginning"),b=!1,R=A-188),E=this.pmtParsed=!0;break;case 17:case 8191:break;default:b=!0}}else D++;D>0&&this.observer.emit(i.a.ERROR,i.a.ERROR,{type:n.b.MEDIA_ERROR,details:n.a.FRAG_PARSING_ERROR,fatal:!1,reason:"Found "+D+" TS packet/s that do not start with 0x47"}),l.pesData=g,u.pesData=y,d.pesData=T;var w={audioTrack:u,videoTrack:l,id3Track:d,textTrack:c};return s&&this.extractRemainingSamples(w),w},e.flush=function(){var t,e=this.remainderData;return this.remainderData=null,t=e?this.demux(e,-1,!1,!0):{videoTrack:this._avcTrack,audioTrack:this._audioTrack,id3Track:this._id3Track,textTrack:this._txtTrack},this.extractRemainingSamples(t),this.sampleAes?this.decrypt(t,this.sampleAes):t},e.extractRemainingSamples=function(t){var e,r=t.audioTrack,i=t.videoTrack,n=t.id3Track,a=t.textTrack,s=i.pesData,o=r.pesData,l=n.pesData;if(s&&(e=q(s))?(this.parseAVCPES(i,a,e,!0),i.pesData=null):i.pesData=s,o&&(e=q(o))){switch(r.segmentCodec){case"aac":this.parseAACPES(r,e);break;case"mp3":this.parseMPEGPES(r,e)}r.pesData=null}else null!=o&&o.size&&v.b.log("last AAC PES packet truncated,might overlap between fragments"),r.pesData=o;l&&(e=q(l))?(this.parseID3PES(n,e),n.pesData=null):n.pesData=l},e.demuxSampleAes=function(t,e,r){var i=this.demux(t,r,!0,!this.config.progressive),n=this.sampleAes=new j(this.observer,this.config,e);return this.decrypt(i,n)},e.decrypt=function(t,e){return new Promise((function(r){var i=t.audioTrack,n=t.videoTrack;i.samples&&"aac"===i.segmentCodec?e.decryptAacSamples(i.samples,0,(function(){n.samples?e.decryptAvcSamples(n.samples,0,0,(function(){r(t)})):r(t)})):n.samples&&e.decryptAvcSamples(n.samples,0,0,(function(){r(t)}))}))},e.destroy=function(){this._duration=0},e.parseAVCPES=function(t,e,r,i){var n,a=this,s=this.parseAVCNALu(t,r.data),o=this.avcSample,l=!1;r.data=null,o&&s.length&&!t.audFound&&(z(o,t),o=this.avcSample=V(!1,r.pts,r.dts,"")),s.forEach((function(i){switch(i.type){case 1:n=!0,o||(o=a.avcSample=V(!0,r.pts,r.dts,"")),o.frame=!0;var s=i.data;if(l&&s.length>4){var u=new G(s).readSliceType();2!==u&&4!==u&&7!==u&&9!==u||(o.key=!0)}break;case 5:n=!0,o||(o=a.avcSample=V(!0,r.pts,r.dts,"")),o.key=!0,o.frame=!0;break;case 6:n=!0,Object(h.i)(X(i.data),r.pts,e.samples);break;case 7:if(n=!0,l=!0,!t.sps){var d=new G(i.data).readSPS();t.width=d.width,t.height=d.height,t.pixelRatio=d.pixelRatio,t.sps=[i.data],t.duration=a._duration;for(var c=i.data.subarray(1,4),f="avc1.",g=0;g<3;g++){var v=c[g].toString(16);v.length<2&&(v="0"+v),f+=v}t.codec=f}break;case 8:n=!0,t.pps||(t.pps=[i.data]);break;case 9:n=!1,t.audFound=!0,o&&z(o,t),o=a.avcSample=V(!1,r.pts,r.dts,"");break;case 12:n=!0;break;default:n=!1,o&&(o.debug+="unknown NAL "+i.type+" ")}o&&n&&o.units.push(i)})),i&&o&&(z(o,t),this.avcSample=null)},e.getLastNalUnit=function(t){var e,r,i=this.avcSample;if(i&&0!==i.units.length||(i=t[t.length-1]),null!==(e=i)&&void 0!==e&&e.units){var n=i.units;r=n[n.length-1]}return r},e.parseAVCNALu=function(t,e){var r,i,n=e.byteLength,a=t.naluState||0,s=a,o=[],l=0,u=-1,h=0;for(-1===a&&(u=0,h=31&e[0],a=0,l=1);l<n;)if(r=e[l++],a)if(1!==a)if(r)if(1===r){if(u>=0){var d={data:e.subarray(u,l-a-1),type:h};o.push(d)}else{var c=this.getLastNalUnit(t.samples);if(c&&(s&&l<=4-s&&c.state&&(c.data=c.data.subarray(0,c.data.byteLength-s)),(i=l-a-1)>0)){var f=new Uint8Array(c.data.byteLength+i);f.set(c.data,0),f.set(e.subarray(0,i),c.data.byteLength),c.data=f,c.state=0}}l<n?(u=l,h=31&e[l],a=0):a=-1}else a=0;else a=3;else a=r?0:2;else a=r?0:1;if(u>=0&&a>=0){var g={data:e.subarray(u,n),type:h,state:a};o.push(g)}if(0===o.length){var v=this.getLastNalUnit(t.samples);if(v){var p=new Uint8Array(v.data.byteLength+e.byteLength);p.set(v.data,0),p.set(e,v.data.byteLength),v.data=p}}return t.naluState=a,o},e.parseAACPES=function(t,e){var r,a,s,o,l,u=0,h=this.aacOverFlow,d=e.data;if(h){this.aacOverFlow=null;var c=h.missing,f=h.sample.unit.byteLength;if(-1===c){var g=new Uint8Array(f+d.byteLength);g.set(h.sample.unit,0),g.set(d,f),d=g}else{var p=f-c;h.sample.unit.set(d.subarray(0,c),p),t.samples.push(h.sample),u=h.missing}}for(r=u,a=d.length;r<a-1&&!T(d,r);r++);if(r!==u&&(r<a-1?(s="AAC PES did not start with ADTS header,offset:"+r,o=!1):(s="no ADTS header found in AAC PES",o=!0),v.b.warn("parsing error:"+s),this.observer.emit(i.a.ERROR,i.a.ERROR,{type:n.b.MEDIA_ERROR,details:n.a.FRAG_PARSING_ERROR,fatal:o,reason:s}),o))return;if(E(t,this.observer,d,r,this.audioCodec),void 0!==e.pts)l=e.pts;else{if(!h)return void v.b.warn("[tsdemuxer]: AAC PES unknown PTS");var m=S(t.samplerate);l=h.sample.pts+m}for(var y,b=0;r<a;){if(r+=(y=L(t,d,r,l,b)).length,y.missing){this.aacOverFlow=y;break}for(b++;r<a-1&&!T(d,r);r++);}},e.parseMPEGPES=function(t,e){var r=e.data,i=r.length,n=0,a=0,s=e.pts;if(void 0!==s)for(;a<i;)if(U(r,a)){var o=M(t,r,a,s,n);if(!o)break;a+=o.length,n++}else a++;else v.b.warn("[tsdemuxer]: MPEG PES unknown PTS")},e.parseID3PES=function(t,e){if(void 0!==e.pts){var r=K({},e,{type:this._avcTrack?l.a.emsg:l.a.audioId3});t.samples.push(r)}else v.b.warn("[tsdemuxer]: ID3 PES unknown PTS")},t}();function V(t,e,r,i){return{key:t,frame:!1,pts:e,dts:r,units:[],debug:i,length:0}}function W(t,e){return(31&t[e+10])<<8|t[e+11]}function Y(t,e,r,i){var n={audio:-1,avc:-1,id3:-1,segmentCodec:"aac"},a=e+3+((15&t[e+1])<<8|t[e+2])-4;for(e+=12+((15&t[e+10])<<8|t[e+11]);e<a;){var s=(31&t[e+1])<<8|t[e+2];switch(t[e]){case 207:if(!i){v.b.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");break}case 15:-1===n.audio&&(n.audio=s);break;case 21:-1===n.id3&&(n.id3=s);break;case 219:if(!i){v.b.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");break}case 27:-1===n.avc&&(n.avc=s);break;case 3:case 4:!0!==r.mpeg&&!0!==r.mp3?v.b.log("MPEG audio found, not supported in this browser"):-1===n.audio&&(n.audio=s,n.segmentCodec="mp3");break;case 36:v.b.warn("Unsupported HEVC stream type found")}e+=5+((15&t[e+3])<<8|t[e+4])}return n}function q(t){var e,r,i,n,a,s=0,o=t.data;if(!t||0===t.size)return null;for(;o[0].length<19&&o.length>1;){var l=new Uint8Array(o[0].length+o[1].length);l.set(o[0]),l.set(o[1],o[0].length),o[0]=l,o.splice(1,1)}if(1===((e=o[0])[0]<<16)+(e[1]<<8)+e[2]){if((r=(e[4]<<8)+e[5])&&r>t.size-6)return null;var u=e[7];192&u&&(n=536870912*(14&e[9])+4194304*(255&e[10])+16384*(254&e[11])+128*(255&e[12])+(254&e[13])/2,64&u?n-(a=536870912*(14&e[14])+4194304*(255&e[15])+16384*(254&e[16])+128*(255&e[17])+(254&e[18])/2)>54e5&&(v.b.warn(Math.round((n-a)/9e4)+"s delta between PTS and DTS, align them"),n=a):a=n);var h=(i=e[8])+9;if(t.size<=h)return null;t.size-=h;for(var d=new Uint8Array(t.size),c=0,f=o.length;c<f;c++){var g=(e=o[c]).byteLength;if(h){if(h>g){h-=g;continue}e=e.subarray(h),g-=h,h=0}d.set(e,s),s+=g}return r&&(r-=i+3),{data:d,pts:n,dts:a,len:r}}return null}function z(t,e){if(t.units.length&&t.frame){if(void 0===t.pts){var r=e.samples,i=r.length;if(!i)return void e.dropped++;var n=r[i-1];t.pts=n.pts,t.dts=n.dts}e.samples.push(t)}t.debug.length&&v.b.log(t.pts+"/"+t.dts+":"+t.debug)}function X(t){for(var e=t.byteLength,r=[],i=1;i<e-2;)0===t[i]&&0===t[i+1]&&3===t[i+2]?(r.push(i+2),i+=2):i++;if(0===r.length)return t;var n=e-r.length,a=new Uint8Array(n),s=0;for(i=0;i<n;s++,i++)s===r[0]&&(s++,r.shift()),a[i]=t[s];return a}H.minProbeByteLength=188;var Q=H;function $(t,e){return($=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var J=function(t){var e,r;function i(){return t.apply(this,arguments)||this}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,$(e,r);var n=i.prototype;return n.resetInitSegment=function(e,r,i,n){t.prototype.resetInitSegment.call(this,e,r,i,n),this._audioTrack={container:"audio/mpeg",type:"audio",id:2,pid:-1,sequenceNumber:0,segmentCodec:"mp3",samples:[],manifestCodec:r,duration:n,inputTimeScale:9e4,dropped:0}},i.probe=function(t){if(!t)return!1;for(var e=(o.b(t,0)||[]).length,r=t.length;e<r;e++)if(B(t,e))return v.b.log("MPEG Audio sync word found !"),!0;return!1},n.canParse=function(t,e){return function(t,e){return N(t,e)&&4<=t.length-e}(t,e)},n.appendFrame=function(t,e,r){if(null!==this.initPTS)return M(t,e,r,this.initPTS,this.frameIndex)},i}(g);J.minProbeByteLength=4;var Z=J,tt=r(13),et=r(6),rt=function(){function t(){this.emitInitSegment=!1,this.audioCodec=void 0,this.videoCodec=void 0,this.initData=void 0,this.initPTS=void 0,this.initTracks=void 0,this.lastEndDTS=null}var e=t.prototype;return e.destroy=function(){},e.resetTimeStamp=function(t){this.initPTS=t,this.lastEndDTS=null},e.resetNextTimestamp=function(){this.lastEndDTS=null},e.resetInitSegment=function(t,e,r){this.audioCodec=e,this.videoCodec=r,this.generateInitSegment(t),this.emitInitSegment=!0},e.generateInitSegment=function(t){var e=this.audioCodec,r=this.videoCodec;if(!t||!t.byteLength)return this.initTracks=void 0,void(this.initData=void 0);var i=this.initData=Object(h.h)(t);e||(e=nt(i.audio,et.a.AUDIO)),r||(r=nt(i.video,et.a.VIDEO));var n={};i.audio&&i.video?n.audiovideo={container:"video/mp4",codec:e+","+r,initSegment:t,id:"main"}:i.audio?n.audio={container:"audio/mp4",codec:e,initSegment:t,id:"audio"}:i.video?n.video={container:"video/mp4",codec:r,initSegment:t,id:"main"}:v.b.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."),this.initTracks=n},e.remux=function(t,e,r,i,n){var a,o=this.initPTS,l=this.lastEndDTS,u={audio:void 0,video:void 0,text:i,id3:r,initSegment:void 0};Object(s.a)(l)||(l=this.lastEndDTS=n||0);var d=e.samples;if(!d||!d.length)return u;var c={initPTS:void 0,timescale:1},f=this.initData;if(f&&f.length||(this.generateInitSegment(d),f=this.initData),!f||!f.length)return v.b.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."),u;this.emitInitSegment&&(c.tracks=this.initTracks,this.emitInitSegment=!1),Object(s.a)(o)||(this.initPTS=c.initPTS=o=it(f,d,l));var g=Object(h.d)(d,f),p=l,m=g+p;Object(h.f)(f,d,o),g>0?this.lastEndDTS=m:(v.b.warn("Duration parsed from mp4 should be greater than zero"),this.resetNextTimestamp());var y=!!f.audio,T=!!f.video,b="";y&&(b+="audio"),T&&(b+="video");var E={data1:d,startPTS:p,startDTS:p,endPTS:m,endDTS:m,type:b,hasAudio:y,hasVideo:T,nb:1,dropped:0};u.audio="audio"===E.type?E:void 0,u.video="audio"!==E.type?E:void 0,u.initSegment=c;var S=null!=(a=this.initPTS)?a:0;return u.id3=Object(tt.b)(r,n,S,S),i.samples.length&&(u.text=Object(tt.c)(i,n,S)),u},t}(),it=function(t,e,r){return Object(h.e)(t,e)-r};function nt(t,e){var r=null==t?void 0:t.codec;return r&&r.length>4?r:"hvc1"===r||"hev1"===r?"hvc1.1.c.L120.90":"av01"===r?"av01.0.04M.08":"avc1"===r||e===et.a.VIDEO?"avc1.42e01e":"mp4a.40.5"}var at,st=rt,ot=r(15);try{at=self.performance.now.bind(self.performance)}catch(t){v.b.debug("Unable to use Performance API on this environment"),at=self.Date.now}var lt=[{demux:Q,remux:tt.a},{demux:I,remux:st},{demux:R,remux:tt.a},{demux:Z,remux:tt.a}],ut=1024;lt.forEach((function(t){var e=t.demux;ut=Math.max(ut,e.minProbeByteLength)}));var ht=function(){function t(t,e,r,i,n){this.observer=void 0,this.typeSupported=void 0,this.config=void 0,this.vendor=void 0,this.id=void 0,this.demuxer=void 0,this.remuxer=void 0,this.decrypter=void 0,this.probe=void 0,this.decryptionPromise=null,this.transmuxConfig=void 0,this.currentTransmuxState=void 0,this.cache=new ot.a,this.observer=t,this.typeSupported=e,this.config=r,this.vendor=i,this.id=n}var e=t.prototype;return e.configure=function(t){this.transmuxConfig=t,this.decrypter&&this.decrypter.reset()},e.push=function(t,e,r,i){var n=this,a=r.transmuxing;a.executeStart=at();var s=new Uint8Array(t),o=this.cache,l=this.config,u=this.currentTransmuxState,d=this.transmuxConfig;i&&(this.currentTransmuxState=i);var c=function(t,e){var r=null;t.byteLength>0&&null!=e&&null!=e.key&&null!==e.iv&&null!=e.method&&(r=e);return r}(s,e);if(c&&"AES-128"===c.method){var f=this.getDecrypter();if(!l.enableSoftwareAES)return this.decryptionPromise=f.webCryptoDecrypt(s,c.key.buffer,c.iv.buffer).then((function(t){var e=n.push(t,null,r);return n.decryptionPromise=null,e})),this.decryptionPromise;var g=f.softwareDecrypt(s,c.key.buffer,c.iv.buffer);if(!g)return a.executeEnd=at(),dt(r);s=new Uint8Array(g)}var v=i||u,p=v.contiguous,m=v.discontinuity,y=v.trackSwitch,T=v.accurateTimeOffset,b=v.timeOffset,E=v.initSegmentChange,S=d.audioCodec,L=d.videoCodec,A=d.defaultInitPts,D=d.duration,R=d.initSegmentData;if((m||y||E)&&this.resetInitSegment(R,S,L,D),(m||E)&&this.resetInitialTimestamp(A),p||this.resetContiguity(),this.needsProbing(s,m,y)){if(o.dataLength){var k=o.flush();s=Object(h.b)(k,s)}this.configureTransmuxer(s,d)}var _=this.transmux(s,c,b,T,r),I=this.currentTransmuxState;return I.contiguous=!0,I.discontinuity=!1,I.trackSwitch=!1,a.executeEnd=at(),_},e.flush=function(t){var e=this,r=t.transmuxing;r.executeStart=at();var a=this.decrypter,s=this.cache,o=this.currentTransmuxState,l=this.decryptionPromise;if(l)return l.then((function(){return e.flush(t)}));var u=[],h=o.timeOffset;if(a){var d=a.flush();d&&u.push(this.push(d,null,t))}var c=s.dataLength;s.reset();var f=this.demuxer,g=this.remuxer;if(!f||!g)return c>=ut&&this.observer.emit(i.a.ERROR,i.a.ERROR,{type:n.b.MEDIA_ERROR,details:n.a.FRAG_PARSING_ERROR,fatal:!0,reason:"no demux matching with content found"}),r.executeEnd=at(),[dt(t)];var v=f.flush(h);return ct(v)?v.then((function(r){return e.flushRemux(u,r,t),u})):(this.flushRemux(u,v,t),u)},e.flushRemux=function(t,e,r){var i=e.audioTrack,n=e.videoTrack,a=e.id3Track,s=e.textTrack,o=this.currentTransmuxState,l=o.accurateTimeOffset,u=o.timeOffset;v.b.log("[transmuxer.ts]: Flushed fragment "+r.sn+(r.part>-1?" p: "+r.part:"")+" of level "+r.level);var h=this.remuxer.remux(i,n,a,s,u,l,!0,this.id);t.push({remuxResult:h,chunkMeta:r}),r.transmuxing.executeEnd=at()},e.resetInitialTimestamp=function(t){var e=this.demuxer,r=this.remuxer;e&&r&&(e.resetTimeStamp(t),r.resetTimeStamp(t))},e.resetContiguity=function(){var t=this.demuxer,e=this.remuxer;t&&e&&(t.resetContiguity(),e.resetNextTimestamp())},e.resetInitSegment=function(t,e,r,i){var n=this.demuxer,a=this.remuxer;n&&a&&(n.resetInitSegment(t,e,r,i),a.resetInitSegment(t,e,r))},e.destroy=function(){this.demuxer&&(this.demuxer.destroy(),this.demuxer=void 0),this.remuxer&&(this.remuxer.destroy(),this.remuxer=void 0)},e.transmux=function(t,e,r,i,n){return e&&"SAMPLE-AES"===e.method?this.transmuxSampleAes(t,e,r,i,n):this.transmuxUnencrypted(t,r,i,n)},e.transmuxUnencrypted=function(t,e,r,i){var n=this.demuxer.demux(t,e,!1,!this.config.progressive),a=n.audioTrack,s=n.videoTrack,o=n.id3Track,l=n.textTrack;return{remuxResult:this.remuxer.remux(a,s,o,l,e,r,!1,this.id),chunkMeta:i}},e.transmuxSampleAes=function(t,e,r,i,n){var a=this;return this.demuxer.demuxSampleAes(t,e,r).then((function(t){return{remuxResult:a.remuxer.remux(t.audioTrack,t.videoTrack,t.id3Track,t.textTrack,r,i,!1,a.id),chunkMeta:n}}))},e.configureTransmuxer=function(t,e){for(var r,i=this.config,n=this.observer,a=this.typeSupported,s=this.vendor,o=e.audioCodec,l=e.defaultInitPts,u=e.duration,h=e.initSegmentData,d=e.videoCodec,c=0,f=lt.length;c<f;c++)if(lt[c].demux.probe(t)){r=lt[c];break}r||(v.b.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough"),r={demux:I,remux:st});var g=this.demuxer,p=this.remuxer,m=r.remux,y=r.demux;p&&p instanceof m||(this.remuxer=new m(n,i,a,s)),g&&g instanceof y||(this.demuxer=new y(n,i,a),this.probe=y.probe),this.resetInitSegment(h,o,d,u),this.resetInitialTimestamp(l)},e.needsProbing=function(t,e,r){return!this.demuxer||!this.remuxer||e||r},e.getDecrypter=function(){var t=this.decrypter;return t||(t=this.decrypter=new a.a(this.observer,this.config)),t},t}();var dt=function(t){return{remuxResult:{},chunkMeta:t}};function ct(t){return"then"in t&&t.then instanceof Function}var ft=function(t,e,r,i,n){this.audioCodec=void 0,this.videoCodec=void 0,this.initSegmentData=void 0,this.duration=void 0,this.defaultInitPts=void 0,this.audioCodec=t,this.videoCodec=e,this.initSegmentData=r,this.duration=i,this.defaultInitPts=n},gt=function(t,e,r,i,n,a){this.discontinuity=void 0,this.contiguous=void 0,this.accurateTimeOffset=void 0,this.trackSwitch=void 0,this.timeOffset=void 0,this.initSegmentChange=void 0,this.discontinuity=t,this.contiguous=e,this.accurateTimeOffset=r,this.trackSwitch=i,this.timeOffset=n,this.initSegmentChange=a}},function(t,e,r){var i,n,a,s,o;i=/^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/,n=/^(?=([^\/?#]*))\1([^]*)$/,a=/(?:\/|^)\.(?=\/)/g,s=/(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g,o={buildAbsoluteURL:function(t,e,r){if(r=r||{},t=t.trim(),!(e=e.trim())){if(!r.alwaysNormalize)return t;var i=o.parseURL(t);if(!i)throw new Error("Error trying to parse base URL.");return i.path=o.normalizePath(i.path),o.buildURLFromParts(i)}var a=o.parseURL(e);if(!a)throw new Error("Error trying to parse relative URL.");if(a.scheme)return r.alwaysNormalize?(a.path=o.normalizePath(a.path),o.buildURLFromParts(a)):e;var s=o.parseURL(t);if(!s)throw new Error("Error trying to parse base URL.");if(!s.netLoc&&s.path&&"/"!==s.path[0]){var l=n.exec(s.path);s.netLoc=l[1],s.path=l[2]}s.netLoc&&!s.path&&(s.path="/");var u={scheme:s.scheme,netLoc:a.netLoc,path:null,params:a.params,query:a.query,fragment:a.fragment};if(!a.netLoc&&(u.netLoc=s.netLoc,"/"!==a.path[0]))if(a.path){var h=s.path,d=h.substring(0,h.lastIndexOf("/")+1)+a.path;u.path=o.normalizePath(d)}else u.path=s.path,a.params||(u.params=s.params,a.query||(u.query=s.query));return null===u.path&&(u.path=r.alwaysNormalize?o.normalizePath(a.path):a.path),o.buildURLFromParts(u)},parseURL:function(t){var e=i.exec(t);return e?{scheme:e[1]||"",netLoc:e[2]||"",path:e[3]||"",params:e[4]||"",query:e[5]||"",fragment:e[6]||""}:null},normalizePath:function(t){for(t=t.split("").reverse().join("").replace(a,"");t.length!==(t=t.replace(s,"")).length;);return t.split("").reverse().join("")},buildURLFromParts:function(t){return t.scheme+t.netLoc+t.path+t.params+t.query+t.fragment}},t.exports=o},function(t,e,r){"use strict";r.d(e,"a",(function(){return m})),r.d(e,"d",(function(){return y})),r.d(e,"b",(function(){return T})),r.d(e,"c",(function(){return b}));var i=r(3),n=function(){function t(){}return t.getSilentFrame=function(t,e){switch(t){case"mp4a.40.2":if(1===e)return new Uint8Array([0,200,0,128,35,128]);if(2===e)return new Uint8Array([33,0,73,144,2,25,0,35,128]);if(3===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,142]);if(4===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,128,44,128,8,2,56]);if(5===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,56]);if(6===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,0,178,0,32,8,224]);break;default:if(1===e)return new Uint8Array([1,64,34,128,163,78,230,128,186,8,0,0,0,28,6,241,193,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(2===e)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(3===e)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94])}},t}(),a=Math.pow(2,32)-1,s=function(){function t(){}return t.init=function(){var e;for(e in t.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],".mp3":[],mvex:[],mvhd:[],pasp:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]},t.types)t.types.hasOwnProperty(e)&&(t.types[e]=[e.charCodeAt(0),e.charCodeAt(1),e.charCodeAt(2),e.charCodeAt(3)]);var r=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),i=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]);t.HDLR_TYPES={video:r,audio:i};var n=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),a=new Uint8Array([0,0,0,0,0,0,0,0]);t.STTS=t.STSC=t.STCO=a,t.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),t.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0]),t.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),t.STSD=new Uint8Array([0,0,0,0,0,0,0,1]);var s=new Uint8Array([105,115,111,109]),o=new Uint8Array([97,118,99,49]),l=new Uint8Array([0,0,0,1]);t.FTYP=t.box(t.types.ftyp,s,l,s,o),t.DINF=t.box(t.types.dinf,t.box(t.types.dref,n))},t.box=function(t){for(var e=8,r=arguments.length,i=new Array(r>1?r-1:0),n=1;n<r;n++)i[n-1]=arguments[n];for(var a=i.length,s=a;a--;)e+=i[a].byteLength;var o=new Uint8Array(e);for(o[0]=e>>24&255,o[1]=e>>16&255,o[2]=e>>8&255,o[3]=255&e,o.set(t,4),a=0,e=8;a<s;a++)o.set(i[a],e),e+=i[a].byteLength;return o},t.hdlr=function(e){return t.box(t.types.hdlr,t.HDLR_TYPES[e])},t.mdat=function(e){return t.box(t.types.mdat,e)},t.mdhd=function(e,r){r*=e;var i=Math.floor(r/(a+1)),n=Math.floor(r%(a+1));return t.box(t.types.mdhd,new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,e>>24&255,e>>16&255,e>>8&255,255&e,i>>24,i>>16&255,i>>8&255,255&i,n>>24,n>>16&255,n>>8&255,255&n,85,196,0,0]))},t.mdia=function(e){return t.box(t.types.mdia,t.mdhd(e.timescale,e.duration),t.hdlr(e.type),t.minf(e))},t.mfhd=function(e){return t.box(t.types.mfhd,new Uint8Array([0,0,0,0,e>>24,e>>16&255,e>>8&255,255&e]))},t.minf=function(e){return"audio"===e.type?t.box(t.types.minf,t.box(t.types.smhd,t.SMHD),t.DINF,t.stbl(e)):t.box(t.types.minf,t.box(t.types.vmhd,t.VMHD),t.DINF,t.stbl(e))},t.moof=function(e,r,i){return t.box(t.types.moof,t.mfhd(e),t.traf(i,r))},t.moov=function(e){for(var r=e.length,i=[];r--;)i[r]=t.trak(e[r]);return t.box.apply(null,[t.types.moov,t.mvhd(e[0].timescale,e[0].duration)].concat(i).concat(t.mvex(e)))},t.mvex=function(e){for(var r=e.length,i=[];r--;)i[r]=t.trex(e[r]);return t.box.apply(null,[t.types.mvex].concat(i))},t.mvhd=function(e,r){r*=e;var i=Math.floor(r/(a+1)),n=Math.floor(r%(a+1)),s=new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,e>>24&255,e>>16&255,e>>8&255,255&e,i>>24,i>>16&255,i>>8&255,255&i,n>>24,n>>16&255,n>>8&255,255&n,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]);return t.box(t.types.mvhd,s)},t.sdtp=function(e){var r,i,n=e.samples||[],a=new Uint8Array(4+n.length);for(r=0;r<n.length;r++)i=n[r].flags,a[r+4]=i.dependsOn<<4|i.isDependedOn<<2|i.hasRedundancy;return t.box(t.types.sdtp,a)},t.stbl=function(e){return t.box(t.types.stbl,t.stsd(e),t.box(t.types.stts,t.STTS),t.box(t.types.stsc,t.STSC),t.box(t.types.stsz,t.STSZ),t.box(t.types.stco,t.STCO))},t.avc1=function(e){var r,i,n,a=[],s=[];for(r=0;r<e.sps.length;r++)n=(i=e.sps[r]).byteLength,a.push(n>>>8&255),a.push(255&n),a=a.concat(Array.prototype.slice.call(i));for(r=0;r<e.pps.length;r++)n=(i=e.pps[r]).byteLength,s.push(n>>>8&255),s.push(255&n),s=s.concat(Array.prototype.slice.call(i));var o=t.box(t.types.avcC,new Uint8Array([1,a[3],a[4],a[5],255,224|e.sps.length].concat(a).concat([e.pps.length]).concat(s))),l=e.width,u=e.height,h=e.pixelRatio[0],d=e.pixelRatio[1];return t.box(t.types.avc1,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,l>>8&255,255&l,u>>8&255,255&u,0,72,0,0,0,72,0,0,0,0,0,0,0,1,18,100,97,105,108,121,109,111,116,105,111,110,47,104,108,115,46,106,115,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,17,17]),o,t.box(t.types.btrt,new Uint8Array([0,28,156,128,0,45,198,192,0,45,198,192])),t.box(t.types.pasp,new Uint8Array([h>>24,h>>16&255,h>>8&255,255&h,d>>24,d>>16&255,d>>8&255,255&d])))},t.esds=function(t){var e=t.config.length;return new Uint8Array([0,0,0,0,3,23+e,0,1,0,4,15+e,64,21,0,0,0,0,0,0,0,0,0,0,0,5].concat([e]).concat(t.config).concat([6,1,2]))},t.mp4a=function(e){var r=e.samplerate;return t.box(t.types.mp4a,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,e.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]),t.box(t.types.esds,t.esds(e)))},t.mp3=function(e){var r=e.samplerate;return t.box(t.types[".mp3"],new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,e.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]))},t.stsd=function(e){return"audio"===e.type?"mp3"===e.segmentCodec&&"mp3"===e.codec?t.box(t.types.stsd,t.STSD,t.mp3(e)):t.box(t.types.stsd,t.STSD,t.mp4a(e)):t.box(t.types.stsd,t.STSD,t.avc1(e))},t.tkhd=function(e){var r=e.id,i=e.duration*e.timescale,n=e.width,s=e.height,o=Math.floor(i/(a+1)),l=Math.floor(i%(a+1));return t.box(t.types.tkhd,new Uint8Array([1,0,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,r>>24&255,r>>16&255,r>>8&255,255&r,0,0,0,0,o>>24,o>>16&255,o>>8&255,255&o,l>>24,l>>16&255,l>>8&255,255&l,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,n>>8&255,255&n,0,0,s>>8&255,255&s,0,0]))},t.traf=function(e,r){var i=t.sdtp(e),n=e.id,s=Math.floor(r/(a+1)),o=Math.floor(r%(a+1));return t.box(t.types.traf,t.box(t.types.tfhd,new Uint8Array([0,0,0,0,n>>24,n>>16&255,n>>8&255,255&n])),t.box(t.types.tfdt,new Uint8Array([1,0,0,0,s>>24,s>>16&255,s>>8&255,255&s,o>>24,o>>16&255,o>>8&255,255&o])),t.trun(e,i.length+16+20+8+16+8+8),i)},t.trak=function(e){return e.duration=e.duration||4294967295,t.box(t.types.trak,t.tkhd(e),t.mdia(e))},t.trex=function(e){var r=e.id;return t.box(t.types.trex,new Uint8Array([0,0,0,0,r>>24,r>>16&255,r>>8&255,255&r,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]))},t.trun=function(e,r){var i,n,a,s,o,l,u=e.samples||[],h=u.length,d=12+16*h,c=new Uint8Array(d);for(r+=8+d,c.set([0,0,15,1,h>>>24&255,h>>>16&255,h>>>8&255,255&h,r>>>24&255,r>>>16&255,r>>>8&255,255&r],0),i=0;i<h;i++)a=(n=u[i]).duration,s=n.size,o=n.flags,l=n.cts,c.set([a>>>24&255,a>>>16&255,a>>>8&255,255&a,s>>>24&255,s>>>16&255,s>>>8&255,255&s,o.isLeading<<2|o.dependsOn,o.isDependedOn<<6|o.hasRedundancy<<4|o.paddingValue<<1|o.isNonSync,61440&o.degradPrio,15&o.degradPrio,l>>>24&255,l>>>16&255,l>>>8&255,255&l],12+16*i);return t.box(t.types.trun,c)},t.initSegment=function(e){t.types||t.init();var r=t.moov(e),i=new Uint8Array(t.FTYP.byteLength+r.byteLength);return i.set(t.FTYP),i.set(r,t.FTYP.byteLength),i},t}();s.types=void 0,s.HDLR_TYPES=void 0,s.STTS=void 0,s.STSC=void 0,s.STCO=void 0,s.STSZ=void 0,s.VMHD=void 0,s.SMHD=void 0,s.STSD=void 0,s.FTYP=void 0,s.DINF=void 0;var o=s,l=r(0),u=r(2),h=r(1),d=r(4),c=r(9);function f(){return(f=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}var g=null,v=null,p=!1,m=function(){function t(t,e,r,i){if(void 0===i&&(i=""),this.observer=void 0,this.config=void 0,this.typeSupported=void 0,this.ISGenerated=!1,this._initPTS=void 0,this._initDTS=void 0,this.nextAvcDts=null,this.nextAudioPts=null,this.videoSampleDuration=null,this.isAudioContiguous=!1,this.isVideoContiguous=!1,this.observer=t,this.config=e,this.typeSupported=r,this.ISGenerated=!1,null===g){var n=(navigator.userAgent||"").match(/Chrome\/(\d+)/i);g=n?parseInt(n[1]):0}if(null===v){var a=navigator.userAgent.match(/Safari\/(\d+)/i);v=a?parseInt(a[1]):0}p=!(g&&g>=75||v&&v>=600)}var e=t.prototype;return e.destroy=function(){},e.resetTimeStamp=function(t){h.b.log("[mp4-remuxer]: initPTS & initDTS reset"),this._initPTS=this._initDTS=t},e.resetNextTimestamp=function(){h.b.log("[mp4-remuxer]: reset next timestamp"),this.isVideoContiguous=!1,this.isAudioContiguous=!1},e.resetInitSegment=function(){h.b.log("[mp4-remuxer]: ISGenerated flag reset"),this.ISGenerated=!1},e.getVideoStartPts=function(t){var e=!1,r=t.reduce((function(t,r){var i=r.pts-t;return i<-4294967296?(e=!0,y(t,r.pts)):i>0?t:r.pts}),t[0].pts);return e&&h.b.debug("PTS rollover detected"),r},e.remux=function(t,e,r,i,n,a,s,o){var l,u,c,f,g,v,p=n,m=n,E=t.pid>-1,S=e.pid>-1,L=e.samples.length,A=t.samples.length>0,D=s&&L>0||L>1;if((!E||A)&&(!S||D)||this.ISGenerated||s){this.ISGenerated||(c=this.generateIS(t,e,n));var R,k=this.isVideoContiguous,_=-1;if(D&&(_=function(t){for(var e=0;e<t.length;e++)if(t[e].key)return e;return-1}(e.samples),!k&&this.config.forceKeyFrameOnDiscontinuity))if(v=!0,_>0){h.b.warn("[mp4-remuxer]: Dropped "+_+" out of "+L+" video samples due to a missing keyframe");var I=this.getVideoStartPts(e.samples);e.samples=e.samples.slice(_),e.dropped+=_,R=m+=(e.samples[0].pts-I)/e.inputTimeScale}else-1===_&&(h.b.warn("[mp4-remuxer]: No keyframe found out of "+L+" video samples"),v=!1);if(this.ISGenerated){if(A&&D){var O=this.getVideoStartPts(e.samples),w=(y(t.samples[0].pts,O)-O)/e.inputTimeScale;p+=Math.max(0,w),m+=Math.max(0,-w)}if(A){if(t.samplerate||(h.b.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"),c=this.generateIS(t,e,n)),u=this.remuxAudio(t,p,this.isAudioContiguous,a,S||D||o===d.b.AUDIO?m:void 0),D){var C=u?u.endPTS-u.startPTS:0;e.inputTimeScale||(h.b.warn("[mp4-remuxer]: regenerate InitSegment as video detected"),c=this.generateIS(t,e,n)),l=this.remuxVideo(e,m,k,C)}}else D&&(l=this.remuxVideo(e,m,k,0));l&&(l.firstKeyFrame=_,l.independent=-1!==_,l.firstKeyFramePTS=R)}}return this.ISGenerated&&(r.samples.length&&(g=T(r,n,this._initPTS,this._initDTS)),i.samples.length&&(f=b(i,n,this._initPTS))),{audio:u,video:l,initSegment:c,independent:v,text:f,id3:g}},e.generateIS=function(t,e,r){var n,a,s,l=t.samples,u=e.samples,h=this.typeSupported,d={},c=!Object(i.a)(this._initPTS),f="audio/mp4";if(c&&(n=a=1/0),t.config&&l.length){switch(t.timescale=t.samplerate,t.segmentCodec){case"mp3":h.mpeg?(f="audio/mpeg",t.codec=""):h.mp3&&(t.codec="mp3")}d.audio={id:"audio",container:f,codec:t.codec,initSegment:"mp3"===t.segmentCodec&&h.mpeg?new Uint8Array(0):o.initSegment([t]),metadata:{channelCount:t.channelCount}},c&&(s=t.inputTimeScale,n=a=l[0].pts-Math.round(s*r))}if(e.sps&&e.pps&&u.length&&(e.timescale=e.inputTimeScale,d.video={id:"main",container:"video/mp4",codec:e.codec,initSegment:o.initSegment([e]),metadata:{width:e.width,height:e.height}},c)){s=e.inputTimeScale;var g=this.getVideoStartPts(u),v=Math.round(s*r);a=Math.min(a,y(u[0].dts,g)-v),n=Math.min(n,g-v)}if(Object.keys(d).length)return this.ISGenerated=!0,c&&(this._initPTS=n,this._initDTS=a),{tracks:d,initPTS:n,timescale:s}},e.remuxVideo=function(t,e,r,i){var n,a,s=t.inputTimeScale,d=t.samples,v=[],m=d.length,T=this._initPTS,b=this.nextAvcDts,S=8,L=this.videoSampleDuration,A=Number.POSITIVE_INFINITY,D=Number.NEGATIVE_INFINITY,R=0,k=!1;r&&null!==b||(b=e*s-(d[0].pts-y(d[0].dts,d[0].pts)));for(var _=0;_<m;_++){var I=d[_];if(I.pts=y(I.pts-T,b),I.dts=y(I.dts-T,b),I.dts>I.pts){R=Math.max(Math.min(R,I.pts-I.dts),-18e3)}I.dts<d[_>0?_-1:_].dts&&(k=!0)}k&&d.sort((function(t,e){var r=t.dts-e.dts,i=t.pts-e.pts;return r||i})),n=d[0].dts;var O=(a=d[d.length-1].dts)-n,w=O?Math.round(O/(m-1)):L||t.inputTimeScale/30;if(R<0){if(R<-2*w){h.b.warn("PTS < DTS detected in video samples, offsetting DTS from PTS by "+Object(c.b)(-w,!0)+" ms");for(var C=R,x=0;x<m;x++)d[x].dts=C=Math.max(C,d[x].pts-w),d[x].pts=Math.max(C,d[x].pts)}else{h.b.warn("PTS < DTS detected in video samples, shifting DTS by "+Object(c.b)(R,!0)+" ms to overcome this issue");for(var P=0;P<m;P++)d[P].dts=d[P].dts+R}n=d[0].dts}if(r){var M=n-b,F=M>w;if(F||M<-1){F?h.b.warn("AVC: "+Object(c.b)(M,!0)+" ms ("+M+"dts) hole between fragments detected, filling it"):h.b.warn("AVC: "+Object(c.b)(-M,!0)+" ms ("+M+"dts) overlapping between fragments detected"),n=b;var N=d[0].pts-M;d[0].dts=n,d[0].pts=N,h.b.log("Video: First PTS/DTS adjusted: "+Object(c.b)(N,!0)+"/"+Object(c.b)(n,!0)+", delta: "+Object(c.b)(M,!0)+" ms")}}p&&(n=Math.max(0,n));for(var U=0,B=0,G=0;G<m;G++){for(var j=d[G],K=j.units,H=K.length,V=0,W=0;W<H;W++)V+=K[W].data.length;B+=V,U+=H,j.length=V,j.dts=Math.max(j.dts,n),j.pts=Math.max(j.pts,j.dts,0),A=Math.min(j.pts,A),D=Math.max(j.pts,D)}a=d[m-1].dts;var Y,q=B+4*U+8;try{Y=new Uint8Array(q)}catch(t){return void this.observer.emit(l.a.ERROR,l.a.ERROR,{type:u.b.MUX_ERROR,details:u.a.REMUX_ALLOC_ERROR,fatal:!1,bytes:q,reason:"fail allocating video mdat "+q})}var z=new DataView(Y.buffer);z.setUint32(0,q),Y.set(o.types.mdat,4);for(var X=!1,Q=0;Q<m;Q++){for(var $=d[Q],J=$.units,Z=0,tt=0,et=J.length;tt<et;tt++){var rt=J[tt],it=rt.data,nt=rt.data.byteLength;z.setUint32(S,nt),S+=4,Y.set(it,S),S+=nt,Z+=4+nt}if(Q<m-1)L=d[Q+1].dts-$.dts;else{var at=this.config,st=Q>0?$.dts-d[Q-1].dts:w;if(at.stretchShortVideoTrack&&null!==this.nextAudioPts){var ot=Math.floor(at.maxBufferHole*s),lt=(i?A+i*s:this.nextAudioPts)-$.pts;lt>ot?((L=lt-st)<0?L=st:X=!0,h.b.log("[mp4-remuxer]: It is approximately "+lt/90+" ms to the next segment; using duration "+L/90+" ms for the last video frame.")):L=st}else L=st}var ut=Math.round($.pts-$.dts);v.push(new E($.key,L,Z,ut))}if(v.length&&g&&g<70){var ht=v[0].flags;ht.dependsOn=2,ht.isNonSync=0}L=X||!L?w:L,this.nextAvcDts=b=a+L,this.videoSampleDuration=L,this.isVideoContiguous=!0;var dt={data1:o.moof(t.sequenceNumber++,n,f({},t,{samples:v})),data2:Y,startPTS:A/s,endPTS:(D+L)/s,startDTS:n/s,endDTS:b/s,type:"video",hasAudio:!1,hasVideo:!0,nb:v.length,dropped:t.dropped};return t.samples=[],t.dropped=0,dt},e.remuxAudio=function(t,e,r,i,a){var s=t.inputTimeScale,d=s/(t.samplerate?t.samplerate:s),c="aac"===t.segmentCodec?1024:1152,g=c*d,v=this._initPTS,p="mp3"===t.segmentCodec&&this.typeSupported.mpeg,m=[],T=void 0!==a,b=t.samples,S=p?0:8,L=this.nextAudioPts||-1,A=e*s;if(this.isAudioContiguous=r=r||b.length&&L>0&&(i&&Math.abs(A-L)<9e3||Math.abs(y(b[0].pts-v,A)-L)<20*g),b.forEach((function(t){t.pts=y(t.pts-v,A)})),!r||L<0){if(!(b=b.filter((function(t){return t.pts>=0}))).length)return;L=0===a?0:i&&!T?Math.max(0,A):b[0].pts}if("aac"===t.segmentCodec)for(var D=this.config.maxAudioFramesDrift,R=0,k=L;R<b.length;R++){var _=b[R],I=_.pts,O=I-k,w=Math.abs(1e3*O/s);if(O<=-D*g&&T)0===R&&(h.b.warn("Audio frame @ "+(I/s).toFixed(3)+"s overlaps nextAudioPts by "+Math.round(1e3*O/s)+" ms."),this.nextAudioPts=L=k=I);else if(O>=D*g&&w<1e4&&T){var C=Math.round(O/g);(k=I-C*g)<0&&(C--,k+=g),0===R&&(this.nextAudioPts=L=k),h.b.warn("[mp4-remuxer]: Injecting "+C+" audio frame @ "+(k/s).toFixed(3)+"s due to "+Math.round(1e3*O/s)+" ms gap.");for(var x=0;x<C;x++){var P=Math.max(k,0),M=n.getSilentFrame(t.manifestCodec||t.codec,t.channelCount);M||(h.b.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."),M=_.unit.subarray()),b.splice(R,0,{unit:M,pts:P}),k+=g,R++}}_.pts=k,k+=g}for(var F,N=null,U=null,B=0,G=b.length;G--;)B+=b[G].unit.byteLength;for(var j=0,K=b.length;j<K;j++){var H=b[j],V=H.unit,W=H.pts;if(null!==U){m[j-1].duration=Math.round((W-U)/d)}else{if(r&&"aac"===t.segmentCodec&&(W=L),N=W,!(B>0))return;B+=S;try{F=new Uint8Array(B)}catch(t){return void this.observer.emit(l.a.ERROR,l.a.ERROR,{type:u.b.MUX_ERROR,details:u.a.REMUX_ALLOC_ERROR,fatal:!1,bytes:B,reason:"fail allocating audio mdat "+B})}p||(new DataView(F.buffer).setUint32(0,B),F.set(o.types.mdat,4))}F.set(V,S);var Y=V.byteLength;S+=Y,m.push(new E(!0,c,Y,0)),U=W}var q=m.length;if(q){var z=m[m.length-1];this.nextAudioPts=L=U+d*z.duration;var X=p?new Uint8Array(0):o.moof(t.sequenceNumber++,N/d,f({},t,{samples:m}));t.samples=[];var Q=N/s,$=L/s,J={data1:X,data2:F,startPTS:Q,endPTS:$,startDTS:Q,endDTS:$,type:"audio",hasAudio:!0,hasVideo:!1,nb:q};return this.isAudioContiguous=!0,J}},e.remuxEmptyAudio=function(t,e,r,i){var a=t.inputTimeScale,s=a/(t.samplerate?t.samplerate:a),o=this.nextAudioPts,l=(null!==o?o:i.startDTS*a)+this._initDTS,u=i.endDTS*a+this._initDTS,d=1024*s,c=Math.ceil((u-l)/d),f=n.getSilentFrame(t.manifestCodec||t.codec,t.channelCount);if(h.b.warn("[mp4-remuxer]: remux empty Audio"),f){for(var g=[],v=0;v<c;v++){var p=l+v*d;g.push({unit:f,pts:p,dts:p})}return t.samples=g,this.remuxAudio(t,e,r,!1)}h.b.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec")},t}();function y(t,e){var r;if(null===e)return t;for(r=e<t?-8589934592:8589934592;Math.abs(t-e)>4294967296;)t+=r;return t}function T(t,e,r,i){var n=t.samples.length;if(n){for(var a=t.inputTimeScale,s=0;s<n;s++){var o=t.samples[s];o.pts=y(o.pts-r,e*a)/a,o.dts=y(o.dts-i,e*a)/a}var l=t.samples;return t.samples=[],{samples:l}}}function b(t,e,r){var i=t.samples.length;if(i){for(var n=t.inputTimeScale,a=0;a<i;a++){var s=t.samples[a];s.pts=y(s.pts-r,e*n)/n}t.samples.sort((function(t,e){return t.pts-e.pts}));var o=t.samples;return t.samples=[],{samples:o}}}var E=function(t,e,r,i){this.size=void 0,this.duration=void 0,this.cts=void 0,this.flags=void 0,this.duration=e,this.size=r,this.cts=i,this.flags=new S(t)},S=function(t){this.isLeading=0,this.isDependedOn=0,this.hasRedundancy=0,this.degradPrio=0,this.dependsOn=1,this.isNonSync=1,this.dependsOn=t?2:1,this.isNonSync=t?0:1}},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));var i=function(){this.aborted=!1,this.loaded=0,this.retry=0,this.total=0,this.chunkCount=0,this.bwEstimate=0,this.loading={start:0,first:0,end:0},this.parsing={start:0,end:0},this.buffering={start:0,first:0,end:0}}},function(t,e,r){"use strict";r.d(e,"a",(function(){return i}));var i=function(){function t(){this.chunks=[],this.dataLength=0}var e=t.prototype;return e.push=function(t){this.chunks.push(t),this.dataLength+=t.length},e.flush=function(){var t,e=this.chunks,r=this.dataLength;return e.length?(t=1===e.length?e[0]:function(t,e){for(var r=new Uint8Array(e),i=0,n=0;n<t.length;n++){var a=t[n];r.set(a,i),i+=a.length}return r}(e,r),this.reset(),t):new Uint8Array(0)},e.reset=function(){this.chunks.length=0,this.dataLength=0},t}()},function(t,e,r){"use strict";var i=Object.prototype.hasOwnProperty,n="~";function a(){}function s(t,e,r){this.fn=t,this.context=e,this.once=r||!1}function o(t,e,r,i,a){if("function"!=typeof r)throw new TypeError("The listener must be a function");var o=new s(r,i||t,a),l=n?n+e:e;return t._events[l]?t._events[l].fn?t._events[l]=[t._events[l],o]:t._events[l].push(o):(t._events[l]=o,t._eventsCount++),t}function l(t,e){0==--t._eventsCount?t._events=new a:delete t._events[e]}function u(){this._events=new a,this._eventsCount=0}Object.create&&(a.prototype=Object.create(null),(new a).__proto__||(n=!1)),u.prototype.eventNames=function(){var t,e,r=[];if(0===this._eventsCount)return r;for(e in t=this._events)i.call(t,e)&&r.push(n?e.slice(1):e);return Object.getOwnPropertySymbols?r.concat(Object.getOwnPropertySymbols(t)):r},u.prototype.listeners=function(t){var e=n?n+t:t,r=this._events[e];if(!r)return[];if(r.fn)return[r.fn];for(var i=0,a=r.length,s=new Array(a);i<a;i++)s[i]=r[i].fn;return s},u.prototype.listenerCount=function(t){var e=n?n+t:t,r=this._events[e];return r?r.fn?1:r.length:0},u.prototype.emit=function(t,e,r,i,a,s){var o=n?n+t:t;if(!this._events[o])return!1;var l,u,h=this._events[o],d=arguments.length;if(h.fn){switch(h.once&&this.removeListener(t,h.fn,void 0,!0),d){case 1:return h.fn.call(h.context),!0;case 2:return h.fn.call(h.context,e),!0;case 3:return h.fn.call(h.context,e,r),!0;case 4:return h.fn.call(h.context,e,r,i),!0;case 5:return h.fn.call(h.context,e,r,i,a),!0;case 6:return h.fn.call(h.context,e,r,i,a,s),!0}for(u=1,l=new Array(d-1);u<d;u++)l[u-1]=arguments[u];h.fn.apply(h.context,l)}else{var c,f=h.length;for(u=0;u<f;u++)switch(h[u].once&&this.removeListener(t,h[u].fn,void 0,!0),d){case 1:h[u].fn.call(h[u].context);break;case 2:h[u].fn.call(h[u].context,e);break;case 3:h[u].fn.call(h[u].context,e,r);break;case 4:h[u].fn.call(h[u].context,e,r,i);break;default:if(!l)for(c=1,l=new Array(d-1);c<d;c++)l[c-1]=arguments[c];h[u].fn.apply(h[u].context,l)}}return!0},u.prototype.on=function(t,e,r){return o(this,t,e,r,!1)},u.prototype.once=function(t,e,r){return o(this,t,e,r,!0)},u.prototype.removeListener=function(t,e,r,i){var a=n?n+t:t;if(!this._events[a])return this;if(!e)return l(this,a),this;var s=this._events[a];if(s.fn)s.fn!==e||i&&!s.once||r&&s.context!==r||l(this,a);else{for(var o=0,u=[],h=s.length;o<h;o++)(s[o].fn!==e||i&&!s[o].once||r&&s[o].context!==r)&&u.push(s[o]);u.length?this._events[a]=1===u.length?u[0]:u:l(this,a)}return this},u.prototype.removeAllListeners=function(t){var e;return t?(e=n?n+t:t,this._events[e]&&l(this,e)):(this._events=new a,this._eventsCount=0),this},u.prototype.off=u.prototype.removeListener,u.prototype.addListener=u.prototype.on,u.prefixed=n,u.EventEmitter=u,t.exports=u},function(t,e,r){"use strict";r.d(e,"a",(function(){return u}));var i=function(){function t(t,e){this.subtle=void 0,this.aesIV=void 0,this.subtle=t,this.aesIV=e}return t.prototype.decrypt=function(t,e){return this.subtle.decrypt({name:"AES-CBC",iv:this.aesIV},e,t)},t}(),n=function(){function t(t,e){this.subtle=void 0,this.key=void 0,this.subtle=t,this.key=e}return t.prototype.expandKey=function(){return this.subtle.importKey("raw",this.key,{name:"AES-CBC"},!1,["encrypt","decrypt"])},t}(),a=r(10);var s=function(){function t(){this.rcon=[0,1,2,4,8,16,32,64,128,27,54],this.subMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.invSubMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.sBox=new Uint32Array(256),this.invSBox=new Uint32Array(256),this.key=new Uint32Array(0),this.ksRows=0,this.keySize=0,this.keySchedule=void 0,this.invKeySchedule=void 0,this.initTable()}var e=t.prototype;return e.uint8ArrayToUint32Array_=function(t){for(var e=new DataView(t),r=new Uint32Array(4),i=0;i<4;i++)r[i]=e.getUint32(4*i);return r},e.initTable=function(){var t=this.sBox,e=this.invSBox,r=this.subMix,i=r[0],n=r[1],a=r[2],s=r[3],o=this.invSubMix,l=o[0],u=o[1],h=o[2],d=o[3],c=new Uint32Array(256),f=0,g=0,v=0;for(v=0;v<256;v++)c[v]=v<128?v<<1:v<<1^283;for(v=0;v<256;v++){var p=g^g<<1^g<<2^g<<3^g<<4;p=p>>>8^255&p^99,t[f]=p,e[p]=f;var m=c[f],y=c[m],T=c[y],b=257*c[p]^16843008*p;i[f]=b<<24|b>>>8,n[f]=b<<16|b>>>16,a[f]=b<<8|b>>>24,s[f]=b,b=16843009*T^65537*y^257*m^16843008*f,l[p]=b<<24|b>>>8,u[p]=b<<16|b>>>16,h[p]=b<<8|b>>>24,d[p]=b,f?(f=m^c[c[c[T^m]]],g^=c[c[g]]):f=g=1}},e.expandKey=function(t){for(var e=this.uint8ArrayToUint32Array_(t),r=!0,i=0;i<e.length&&r;)r=e[i]===this.key[i],i++;if(!r){this.key=e;var n=this.keySize=e.length;if(4!==n&&6!==n&&8!==n)throw new Error("Invalid aes key size="+n);var a,s,o,l,u=this.ksRows=4*(n+6+1),h=this.keySchedule=new Uint32Array(u),d=this.invKeySchedule=new Uint32Array(u),c=this.sBox,f=this.rcon,g=this.invSubMix,v=g[0],p=g[1],m=g[2],y=g[3];for(a=0;a<u;a++)a<n?o=h[a]=e[a]:(l=o,a%n==0?(l=c[(l=l<<8|l>>>24)>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l],l^=f[a/n|0]<<24):n>6&&a%n==4&&(l=c[l>>>24]<<24|c[l>>>16&255]<<16|c[l>>>8&255]<<8|c[255&l]),h[a]=o=(h[a-n]^l)>>>0);for(s=0;s<u;s++)a=u-s,l=3&s?h[a]:h[a-4],d[s]=s<4||a<=4?l:v[c[l>>>24]]^p[c[l>>>16&255]]^m[c[l>>>8&255]]^y[c[255&l]],d[s]=d[s]>>>0}},e.networkToHostOrderSwap=function(t){return t<<24|(65280&t)<<8|(16711680&t)>>8|t>>>24},e.decrypt=function(t,e,r){for(var i,n,a,s,o,l,u,h,d,c,f,g,v,p,m=this.keySize+6,y=this.invKeySchedule,T=this.invSBox,b=this.invSubMix,E=b[0],S=b[1],L=b[2],A=b[3],D=this.uint8ArrayToUint32Array_(r),R=D[0],k=D[1],_=D[2],I=D[3],O=new Int32Array(t),w=new Int32Array(O.length),C=this.networkToHostOrderSwap;e<O.length;){for(d=C(O[e]),c=C(O[e+1]),f=C(O[e+2]),g=C(O[e+3]),o=d^y[0],l=g^y[1],u=f^y[2],h=c^y[3],v=4,p=1;p<m;p++)i=E[o>>>24]^S[l>>16&255]^L[u>>8&255]^A[255&h]^y[v],n=E[l>>>24]^S[u>>16&255]^L[h>>8&255]^A[255&o]^y[v+1],a=E[u>>>24]^S[h>>16&255]^L[o>>8&255]^A[255&l]^y[v+2],s=E[h>>>24]^S[o>>16&255]^L[l>>8&255]^A[255&u]^y[v+3],o=i,l=n,u=a,h=s,v+=4;i=T[o>>>24]<<24^T[l>>16&255]<<16^T[u>>8&255]<<8^T[255&h]^y[v],n=T[l>>>24]<<24^T[u>>16&255]<<16^T[h>>8&255]<<8^T[255&o]^y[v+1],a=T[u>>>24]<<24^T[h>>16&255]<<16^T[o>>8&255]<<8^T[255&l]^y[v+2],s=T[h>>>24]<<24^T[o>>16&255]<<16^T[l>>8&255]<<8^T[255&u]^y[v+3],w[e]=C(i^R),w[e+1]=C(s^k),w[e+2]=C(a^_),w[e+3]=C(n^I),R=d,k=c,_=f,I=g,e+=4}return w.buffer},t}(),o=r(1),l=r(5),u=function(){function t(t,e,r){var i=(void 0===r?{}:r).removePKCS7Padding,n=void 0===i||i;if(this.logEnabled=!0,this.observer=void 0,this.config=void 0,this.removePKCS7Padding=void 0,this.subtle=null,this.softwareDecrypter=null,this.key=null,this.fastAesKey=null,this.remainderData=null,this.currentIV=null,this.currentResult=null,this.observer=t,this.config=e,this.removePKCS7Padding=n,n)try{var a=self.crypto;a&&(this.subtle=a.subtle||a.webkitSubtle)}catch(t){}null===this.subtle&&(this.config.enableSoftwareAES=!0)}var e=t.prototype;return e.destroy=function(){this.observer=null},e.isSync=function(){return this.config.enableSoftwareAES},e.flush=function(){var t=this.currentResult;if(t){var e,r,i,n=new Uint8Array(t);return this.reset(),this.removePKCS7Padding?(r=(e=n).byteLength,(i=r&&new DataView(e.buffer).getUint8(r-1))?Object(a.a)(e,0,r-i):e):n}this.reset()},e.reset=function(){this.currentResult=null,this.currentIV=null,this.remainderData=null,this.softwareDecrypter&&(this.softwareDecrypter=null)},e.decrypt=function(t,e,r,i){if(this.config.enableSoftwareAES){this.softwareDecrypt(new Uint8Array(t),e,r);var n=this.flush();n&&i(n.buffer)}else this.webCryptoDecrypt(new Uint8Array(t),e,r).then(i)},e.softwareDecrypt=function(t,e,r){var i=this.currentIV,n=this.currentResult,o=this.remainderData;this.logOnce("JS AES decrypt"),o&&(t=Object(l.b)(o,t),this.remainderData=null);var u=this.getValidChunk(t);if(!u.length)return null;i&&(r=i);var h=this.softwareDecrypter;h||(h=this.softwareDecrypter=new s),h.expandKey(e);var d=n;return this.currentResult=h.decrypt(u.buffer,0,r),this.currentIV=Object(a.a)(u,-16).buffer,d||null},e.webCryptoDecrypt=function(t,e,r){var a=this,s=this.subtle;return this.key===e&&this.fastAesKey||(this.key=e,this.fastAesKey=new n(s,e)),this.fastAesKey.expandKey().then((function(e){return s?new i(s,r).decrypt(t.buffer,e):Promise.reject(new Error("web crypto not initialized"))})).catch((function(i){return a.onWebCryptoError(i,t,e,r)}))},e.onWebCryptoError=function(t,e,r,i){return o.b.warn("[decrypter.ts]: WebCrypto Error, disable WebCrypto API:",t),this.config.enableSoftwareAES=!0,this.logEnabled=!0,this.softwareDecrypt(e,r,i)},e.getValidChunk=function(t){var e=t,r=t.length-t.length%16;return r!==t.length&&(e=Object(a.a)(t,0,r),this.remainderData=Object(a.a)(t,r)),e},e.logOnce=function(t){this.logEnabled&&(o.b.log("[decrypter.ts]: "+t),this.logEnabled=!1)},t}()},function(t,e,r){"use strict";r.d(e,"a",(function(){return a}));var i=r(12);function n(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var a=function(){function t(t,e){this._uri=null,this.method=null,this.keyFormat=null,this.keyFormatVersions=null,this.keyID=null,this.key=null,this.iv=null,this._uri=e?Object(i.buildAbsoluteURL)(t,e,{alwaysNormalize:!0}):t}var e,r,a;return t.fromURL=function(e,r){return new t(e,r)},t.fromURI=function(e){return new t(e)},e=t,(r=[{key:"uri",get:function(){return this._uri}}])&&n(e.prototype,r),a&&n(e,a),Object.defineProperty(e,"prototype",{writable:!1}),t}()},function(t,e,r){function i(t){var e={};function r(i){if(e[i])return e[i].exports;var n=e[i]={i:i,l:!1,exports:{}};return t[i].call(n.exports,n,n.exports,r),n.l=!0,n.exports}r.m=t,r.c=e,r.i=function(t){return t},r.d=function(t,e,i){r.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:i})},r.r=function(t){Object.defineProperty(t,"__esModule",{value:!0})},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="/",r.oe=function(t){throw console.error(t),t};var i=r(r.s=ENTRY_MODULE);return i.default||i}function n(t){return(t+"").replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}function a(t,e,i){var a={};a[i]=[];var s=e.toString(),o=s.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);if(!o)return a;for(var l,u=o[1],h=new RegExp("(\\\\n|\\W)"+n(u)+"\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)","g");l=h.exec(s);)"dll-reference"!==l[3]&&a[i].push(l[3]);for(h=new RegExp("\\("+n(u)+'\\("(dll-reference\\s([\\.|\\-|\\+|\\w|/|@]+))"\\)\\)\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)',"g");l=h.exec(s);)t[l[2]]||(a[i].push(l[1]),t[l[2]]=r(l[1]).m),a[l[2]]=a[l[2]]||[],a[l[2]].push(l[4]);for(var d,c=Object.keys(a),f=0;f<c.length;f++)for(var g=0;g<a[c[f]].length;g++)d=a[c[f]][g],isNaN(1*d)||(a[c[f]][g]=1*a[c[f]][g]);return a}function s(t){return Object.keys(t).reduce((function(e,r){return e||t[r].length>0}),!1)}t.exports=function(t,e){e=e||{};var n={main:r.m},o=e.all?{main:Object.keys(n.main)}:function(t,e){for(var r={main:[e]},i={main:[]},n={main:{}};s(r);)for(var o=Object.keys(r),l=0;l<o.length;l++){var u=o[l],h=r[u].pop();if(n[u]=n[u]||{},!n[u][h]&&t[u][h]){n[u][h]=!0,i[u]=i[u]||[],i[u].push(h);for(var d=a(t,t[u][h],u),c=Object.keys(d),f=0;f<c.length;f++)r[c[f]]=r[c[f]]||[],r[c[f]]=r[c[f]].concat(d[c[f]])}}return i}(n,t),l="";Object.keys(o).filter((function(t){return"main"!==t})).forEach((function(t){for(var e=0;o[t][e];)e++;o[t].push(e),n[t][e]="(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })",l=l+"var "+t+" = ("+i.toString().replace("ENTRY_MODULE",JSON.stringify(e))+")({"+o[t].map((function(e){return JSON.stringify(e)+": "+n[t][e].toString()})).join(",")+"});\n"})),l=l+"new (("+i.toString().replace("ENTRY_MODULE",JSON.stringify(t))+")({"+o.main.map((function(t){return JSON.stringify(t)+": "+n.main[t].toString()})).join(",")+"}))(self);";var u=new window.Blob([l],{type:"text/javascript"});if(e.bare)return u;var h=(window.URL||window.webkitURL||window.mozURL||window.msURL).createObjectURL(u),d=new window.Worker(h);return d.objectURL=h,d}},function(t,e,r){"use strict";r.r(e),r.d(e,"default",(function(){return o}));var i=r(11),n=r(0),a=r(1),s=r(16);function o(t){var e=new s.EventEmitter,r=function(e,r){t.postMessage({event:e,data:r})};e.on(n.a.FRAG_DECRYPTED,r),e.on(n.a.ERROR,r),t.addEventListener("message",(function(n){var s=n.data;switch(s.cmd){case"init":var o=JSON.parse(s.config);t.transmuxer=new i.c(e,s.typeSupported,o,s.vendor,s.id),Object(a.a)(o.debug),r("init",null);break;case"configure":t.transmuxer.configure(s.config);break;case"demux":var u=t.transmuxer.push(s.data,s.decryptdata,s.chunkMeta,s.state);Object(i.d)(u)?u.then((function(e){l(t,e)})):l(t,u);break;case"flush":var d=s.chunkMeta,c=t.transmuxer.flush(d);Object(i.d)(c)?c.then((function(e){h(t,e,d)})):h(t,c,d)}}))}function l(t,e){if(!((r=e.remuxResult).audio||r.video||r.text||r.id3||r.initSegment))return!1;var r,i=[],n=e.remuxResult,a=n.audio,s=n.video;return a&&u(i,a),s&&u(i,s),t.postMessage({event:"transmuxComplete",data:e},i),!0}function u(t,e){e.data1&&t.push(e.data1.buffer),e.data2&&t.push(e.data2.buffer)}function h(t,e,r){e.reduce((function(e,r){return l(t,r)||e}),!1)||t.postMessage({event:"transmuxComplete",data:e[0]}),t.postMessage({event:"flush",data:r})}},function(t,e,r){"use strict";r.r(e),r.d(e,"default",(function(){return hi}));var i,n=r(12),a=r(3),s=r(0),o=r(2),l=r(1),u=r(5),h=/^(\d+)x(\d+)$/,d=/\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,c=function(){function t(e){for(var r in"string"==typeof e&&(e=t.parseAttrList(e)),e)e.hasOwnProperty(r)&&(this[r]=e[r])}var e=t.prototype;return e.decimalInteger=function(t){var e=parseInt(this[t],10);return e>Number.MAX_SAFE_INTEGER?1/0:e},e.hexadecimalInteger=function(t){if(this[t]){var e=(this[t]||"0x").slice(2);e=(1&e.length?"0":"")+e;for(var r=new Uint8Array(e.length/2),i=0;i<e.length/2;i++)r[i]=parseInt(e.slice(2*i,2*i+2),16);return r}return null},e.hexadecimalIntegerAsNumber=function(t){var e=parseInt(this[t],16);return e>Number.MAX_SAFE_INTEGER?1/0:e},e.decimalFloatingPoint=function(t){return parseFloat(this[t])},e.optionalFloat=function(t,e){var r=this[t];return r?parseFloat(r):e},e.enumeratedString=function(t){return this[t]},e.bool=function(t){return"YES"===this[t]},e.decimalResolution=function(t){var e=h.exec(this[t]);if(null!==e)return{width:parseInt(e[1],10),height:parseInt(e[2],10)}},t.parseAttrList=function(t){var e,r={};for(d.lastIndex=0;null!==(e=d.exec(t));){var i=e[2];0===i.indexOf('"')&&i.lastIndexOf('"')===i.length-1&&(i=i.slice(1,-1)),r[e[1]]=i}return r},t}();function f(){return(f=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}function g(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}!function(t){t.ID="ID",t.CLASS="CLASS",t.START_DATE="START-DATE",t.DURATION="DURATION",t.END_DATE="END-DATE",t.END_ON_NEXT="END-ON-NEXT",t.PLANNED_DURATION="PLANNED-DURATION",t.SCTE35_OUT="SCTE35-OUT",t.SCTE35_IN="SCTE35-IN"}(i||(i={}));var v=function(){function t(t,e){if(this.attr=void 0,this._startDate=void 0,this._endDate=void 0,this._badValueForSameId=void 0,e){var r=e.attr;for(var n in r)if(Object.prototype.hasOwnProperty.call(t,n)&&t[n]!==r[n]){l.b.warn('DATERANGE tag attribute: "'+n+'" does not match for tags with ID: "'+t.ID+'"'),this._badValueForSameId=n;break}t=f(new c({}),r,t)}if(this.attr=t,this._startDate=new Date(t[i.START_DATE]),i.END_DATE in this.attr){var s=new Date(this.attr[i.END_DATE]);Object(a.a)(s.getTime())&&(this._endDate=s)}}var e,r,n;return e=t,(r=[{key:"id",get:function(){return this.attr.ID}},{key:"class",get:function(){return this.attr.CLASS}},{key:"startDate",get:function(){return this._startDate}},{key:"endDate",get:function(){if(this._endDate)return this._endDate;var t=this.duration;return null!==t?new Date(this._startDate.getTime()+1e3*t):null}},{key:"duration",get:function(){if(i.DURATION in this.attr){var t=this.attr.decimalFloatingPoint(i.DURATION);if(Object(a.a)(t))return t}else if(this._endDate)return(this._endDate.getTime()-this._startDate.getTime())/1e3;return null}},{key:"plannedDuration",get:function(){return i.PLANNED_DURATION in this.attr?this.attr.decimalFloatingPoint(i.PLANNED_DURATION):null}},{key:"endOnNext",get:function(){return this.attr.bool(i.END_ON_NEXT)}},{key:"isValid",get:function(){return!!this.id&&!this._badValueForSameId&&Object(a.a)(this.startDate.getTime())&&(null===this.duration||this.duration>=0)&&(!this.endOnNext||!!this.class)}}])&&g(e.prototype,r),n&&g(e,n),Object.defineProperty(e,"prototype",{writable:!1}),t}(),p=r(6);function m(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var y=function(){function t(t){this.PTSKnown=!1,this.alignedSliding=!1,this.averagetargetduration=void 0,this.endCC=0,this.endSN=0,this.fragments=void 0,this.fragmentHint=void 0,this.partList=null,this.dateRanges=void 0,this.live=!0,this.ageHeader=0,this.advancedDateTime=void 0,this.updated=!0,this.advanced=!0,this.availabilityDelay=void 0,this.misses=0,this.needSidxRanges=!1,this.startCC=0,this.startSN=0,this.startTimeOffset=null,this.targetduration=0,this.totalduration=0,this.type=null,this.url=void 0,this.m3u8="",this.version=null,this.canBlockReload=!1,this.canSkipUntil=0,this.canSkipDateRanges=!1,this.skippedSegments=0,this.recentlyRemovedDateranges=void 0,this.partHoldBack=0,this.holdBack=0,this.partTarget=0,this.preloadHint=void 0,this.renditionReports=void 0,this.tuneInGoal=0,this.deltaUpdateFailed=void 0,this.driftStartTime=0,this.driftEndTime=0,this.driftStart=0,this.driftEnd=0,this.fragments=[],this.dateRanges={},this.url=t}var e,r,i;return t.prototype.reloaded=function(t){if(!t)return this.advanced=!0,void(this.updated=!0);var e=this.lastPartSn-t.lastPartSn,r=this.lastPartIndex-t.lastPartIndex;this.updated=this.endSN!==t.endSN||!!r||!!e,this.advanced=this.endSN>t.endSN||e>0||0===e&&r>0,this.updated||this.advanced?this.misses=Math.floor(.6*t.misses):this.misses=t.misses+1,this.availabilityDelay=t.availabilityDelay},e=t,(r=[{key:"hasProgramDateTime",get:function(){return!!this.fragments.length&&Object(a.a)(this.fragments[this.fragments.length-1].programDateTime)}},{key:"levelTargetDuration",get:function(){return this.averagetargetduration||this.targetduration||10}},{key:"drift",get:function(){var t=this.driftEndTime-this.driftStartTime;return t>0?1e3*(this.driftEnd-this.driftStart)/t:1}},{key:"edge",get:function(){return this.partEnd||this.fragmentEnd}},{key:"partEnd",get:function(){var t;return null!==(t=this.partList)&&void 0!==t&&t.length?this.partList[this.partList.length-1].end:this.fragmentEnd}},{key:"fragmentEnd",get:function(){var t;return null!==(t=this.fragments)&&void 0!==t&&t.length?this.fragments[this.fragments.length-1].end:0}},{key:"age",get:function(){return this.advancedDateTime?Math.max(Date.now()-this.advancedDateTime,0)/1e3:0}},{key:"lastPartIndex",get:function(){var t;return null!==(t=this.partList)&&void 0!==t&&t.length?this.partList[this.partList.length-1].index:-1}},{key:"lastPartSn",get:function(){var t;return null!==(t=this.partList)&&void 0!==t&&t.length?this.partList[this.partList.length-1].fragment.sn:this.endSN}}])&&m(e.prototype,r),i&&m(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}(),T=r(18),b={audio:{a3ds:!0,"ac-3":!0,"ac-4":!0,alac:!0,alaw:!0,dra1:!0,"dts+":!0,"dts-":!0,dtsc:!0,dtse:!0,dtsh:!0,"ec-3":!0,enca:!0,g719:!0,g726:!0,m4ae:!0,mha1:!0,mha2:!0,mhm1:!0,mhm2:!0,mlpa:!0,mp4a:!0,"raw ":!0,Opus:!0,samr:!0,sawb:!0,sawp:!0,sevc:!0,sqcp:!0,ssmv:!0,twos:!0,ulaw:!0},video:{avc1:!0,avc2:!0,avc3:!0,avc4:!0,avcp:!0,av01:!0,drac:!0,dvav:!0,dvhe:!0,encv:!0,hev1:!0,hvc1:!0,mjp2:!0,mp4v:!0,mvc1:!0,mvc2:!0,mvc3:!0,mvc4:!0,resv:!0,rv60:!0,s263:!0,svc1:!0,svc2:!0,"vc-1":!0,vp08:!0,vp09:!0},text:{stpp:!0,wvtt:!0}};function E(t,e){return MediaSource.isTypeSupported((e||"video")+'/mp4;codecs="'+t+'"')}var S=/#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g,L=/#EXT-X-MEDIA:(.*)/g,A=new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,/(?!#) *(\S[\S ]*)/.source,/#EXT-X-BYTERANGE:*(.+)/.source,/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,/#.*/.source].join("|"),"g"),D=new RegExp([/#(EXTM3U)/.source,/#EXT-X-(DATERANGE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,/#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,/#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source,/(#)([^:]*):(.*)/.source,/(#)(.*)(?:.*)\r?\n?/.source].join("|")),R=/\.(mp4|m4s|m4v|m4a)$/i;var k=function(){function t(){}return t.findGroup=function(t,e){for(var r=0;r<t.length;r++){var i=t[r];if(i.id===e)return i}},t.convertAVC1ToAVCOTI=function(t){var e=t.split(".");if(e.length>2){var r=e.shift()+".";return r+=parseInt(e.shift()).toString(16),r+=("000"+parseInt(e.shift()).toString(16)).slice(-4)}return t},t.resolve=function(t,e){return n.buildAbsoluteURL(e,t,{alwaysNormalize:!0})},t.parseMasterPlaylist=function(e,r){var i,n=[],a={},s=!1;for(S.lastIndex=0;null!=(i=S.exec(e));)if(i[1]){var o=new c(i[1]),l={attrs:o,bitrate:o.decimalInteger("AVERAGE-BANDWIDTH")||o.decimalInteger("BANDWIDTH"),name:o.NAME,url:t.resolve(i[2],r)},u=o.decimalResolution("RESOLUTION");u&&(l.width=u.width,l.height=u.height),_((o.CODECS||"").split(/[ ,]+/).filter((function(t){return t})),l),l.videoCodec&&-1!==l.videoCodec.indexOf("avc1")&&(l.videoCodec=t.convertAVC1ToAVCOTI(l.videoCodec)),n.push(l)}else if(i[3]){var h=new c(i[3]);h["DATA-ID"]&&(s=!0,a[h["DATA-ID"]]=h)}return{levels:n,sessionData:s?a:null}},t.parseMasterPlaylistMedia=function(e,r,i,n){var a;void 0===n&&(n=[]);var s=[],o=0;for(L.lastIndex=0;null!==(a=L.exec(e));){var l=new c(a[1]);if(l.TYPE===i){var u={attrs:l,bitrate:0,id:o++,groupId:l["GROUP-ID"],instreamId:l["INSTREAM-ID"],name:l.NAME||l.LANGUAGE||"",type:i,default:l.bool("DEFAULT"),autoselect:l.bool("AUTOSELECT"),forced:l.bool("FORCED"),lang:l.LANGUAGE,url:l.URI?t.resolve(l.URI,r):""};if(n.length){var h=t.findGroup(n,u.groupId)||n[0];I(u,h,"audioCodec"),I(u,h,"textCodec")}s.push(u)}}return s},t.parseLevelPlaylist=function(t,e,r,i,s){var o,u,h,d=new y(e),f=d.fragments,g=null,m=0,b=0,E=0,S=0,L=null,k=new p.b(i,e),_=-1,I=!1;for(A.lastIndex=0,d.m3u8=t;null!==(o=A.exec(t));){I&&(I=!1,(k=new p.b(i,e)).start=E,k.sn=m,k.cc=S,k.level=r,g&&(k.initSegment=g,k.rawProgramDateTime=g.rawProgramDateTime,g.rawProgramDateTime=null));var C=o[1];if(C){k.duration=parseFloat(C);var x=(" "+o[2]).slice(1);k.title=x||null,k.tagList.push(x?["INF",C,x]:["INF",C])}else if(o[3])Object(a.a)(k.duration)&&(k.start=E,h&&(k.levelkey=h),k.sn=m,k.level=r,k.cc=S,k.urlId=s,f.push(k),k.relurl=(" "+o[3]).slice(1),O(k,L),L=k,E+=k.duration,m++,b=0,I=!0);else if(o[4]){var P=(" "+o[4]).slice(1);L?k.setByteRange(P,L):k.setByteRange(P)}else if(o[5])k.rawProgramDateTime=(" "+o[5]).slice(1),k.tagList.push(["PROGRAM-DATE-TIME",k.rawProgramDateTime]),-1===_&&(_=f.length);else{if(!(o=o[0].match(D))){l.b.warn("No matches on slow regex match for level playlist!");continue}for(u=1;u<o.length&&void 0===o[u];u++);var M=(" "+o[u]).slice(1),F=(" "+o[u+1]).slice(1),N=o[u+2]?(" "+o[u+2]).slice(1):"";switch(M){case"PLAYLIST-TYPE":d.type=F.toUpperCase();break;case"MEDIA-SEQUENCE":m=d.startSN=parseInt(F);break;case"SKIP":var U=new c(F),B=U.decimalInteger("SKIPPED-SEGMENTS");if(Object(a.a)(B)){d.skippedSegments=B;for(var G=B;G--;)f.unshift(null);m+=B}var j=U.enumeratedString("RECENTLY-REMOVED-DATERANGES");j&&(d.recentlyRemovedDateranges=j.split("\t"));break;case"TARGETDURATION":d.targetduration=parseFloat(F);break;case"VERSION":d.version=parseInt(F);break;case"EXTM3U":break;case"ENDLIST":d.live=!1;break;case"#":(F||N)&&k.tagList.push(N?[F,N]:[F]);break;case"DISCONTINUITY":S++,k.tagList.push(["DIS"]);break;case"GAP":k.tagList.push([M]);break;case"BITRATE":k.tagList.push([M,F]);break;case"DATERANGE":var K=new c(F),H=new v(K,d.dateRanges[K.ID]);H.isValid||d.skippedSegments?d.dateRanges[H.id]=H:l.b.warn('Ignoring invalid DATERANGE tag: "'+F+'"'),k.tagList.push(["EXT-X-DATERANGE",F]);break;case"DISCONTINUITY-SEQUENCE":S=parseInt(F);break;case"KEY":var V,W=new c(F),Y=W.enumeratedString("METHOD"),q=W.URI,z=W.hexadecimalInteger("IV"),X=W.enumeratedString("KEYFORMATVERSIONS"),Q=W.enumeratedString("KEYID"),$=null!=(V=W.enumeratedString("KEYFORMAT"))?V:"identity";if(["com.apple.streamingkeydelivery","com.microsoft.playready","urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed","com.widevine"].indexOf($)>-1){l.b.warn("Keyformat "+$+" is not supported from the manifest");continue}if("identity"!==$)continue;Y&&(h=T.a.fromURL(e,q),q&&["AES-128","SAMPLE-AES","SAMPLE-AES-CENC"].indexOf(Y)>=0&&(h.method=Y,h.keyFormat=$,Q&&(h.keyID=Q),X&&(h.keyFormatVersions=X),h.iv=z));break;case"START":var J=new c(F).decimalFloatingPoint("TIME-OFFSET");Object(a.a)(J)&&(d.startTimeOffset=J);break;case"MAP":var Z=new c(F);if(k.duration){var tt=new p.b(i,e);w(tt,Z,r,h),g=tt,k.initSegment=g,g.rawProgramDateTime&&!k.rawProgramDateTime&&(k.rawProgramDateTime=g.rawProgramDateTime)}else w(k,Z,r,h),g=k,I=!0;break;case"SERVER-CONTROL":var et=new c(F);d.canBlockReload=et.bool("CAN-BLOCK-RELOAD"),d.canSkipUntil=et.optionalFloat("CAN-SKIP-UNTIL",0),d.canSkipDateRanges=d.canSkipUntil>0&&et.bool("CAN-SKIP-DATERANGES"),d.partHoldBack=et.optionalFloat("PART-HOLD-BACK",0),d.holdBack=et.optionalFloat("HOLD-BACK",0);break;case"PART-INF":var rt=new c(F);d.partTarget=rt.decimalFloatingPoint("PART-TARGET");break;case"PART":var it=d.partList;it||(it=d.partList=[]);var nt=b>0?it[it.length-1]:void 0,at=b++,st=new p.c(new c(F),k,e,at,nt);it.push(st),k.duration+=st.duration;break;case"PRELOAD-HINT":var ot=new c(F);d.preloadHint=ot;break;case"RENDITION-REPORT":var lt=new c(F);d.renditionReports=d.renditionReports||[],d.renditionReports.push(lt);break;default:l.b.warn("line parsed but not handled: "+o)}}}L&&!L.relurl?(f.pop(),E-=L.duration,d.partList&&(d.fragmentHint=L)):d.partList&&(O(k,L),k.cc=S,d.fragmentHint=k);var ut=f.length,ht=f[0],dt=f[ut-1];if((E+=d.skippedSegments*d.targetduration)>0&&ut&&dt){d.averagetargetduration=E/ut;var ct=dt.sn;d.endSN="initSegment"!==ct?ct:0,ht&&(d.startCC=ht.cc,ht.initSegment||d.fragments.every((function(t){return t.relurl&&(e=t.relurl,R.test(null!=(r=null===(i=n.parseURL(e))||void 0===i?void 0:i.path)?r:""));var e,r,i}))&&(l.b.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"),(k=new p.b(i,e)).relurl=dt.relurl,k.level=r,k.sn="initSegment",ht.initSegment=k,d.needSidxRanges=!0))}else d.endSN=0,d.startCC=0;return d.fragmentHint&&(E+=d.fragmentHint.duration),d.totalduration=E,d.endCC=S,_>0&&function(t,e){for(var r=t[e],i=e;i--;){var n=t[i];if(!n)return;n.programDateTime=r.programDateTime-1e3*n.duration,r=n}}(f,_),d},t}();function _(t,e){["video","audio","text"].forEach((function(r){var i=t.filter((function(t){return function(t,e){var r=b[e];return!!r&&!0===r[t.slice(0,4)]}(t,r)}));if(i.length){var n=i.filter((function(t){return 0===t.lastIndexOf("avc1",0)||0===t.lastIndexOf("mp4a",0)}));e[r+"Codec"]=n.length>0?n[0]:i[0],t=t.filter((function(t){return-1===i.indexOf(t)}))}})),e.unknownCodecs=t}function I(t,e,r){var i=e[r];i&&(t[r]=i)}function O(t,e){t.rawProgramDateTime?t.programDateTime=Date.parse(t.rawProgramDateTime):null!=e&&e.programDateTime&&(t.programDateTime=e.endProgramDateTime),Object(a.a)(t.programDateTime)||(t.programDateTime=null,t.rawProgramDateTime=null)}function w(t,e,r,i){t.relurl=e.URI,e.BYTERANGE&&t.setByteRange(e.BYTERANGE),t.level=r,t.sn="initSegment",i&&(t.levelkey=i),t.initSegment=null}var C=r(4);function x(t,e){var r=t.url;return void 0!==r&&0!==r.indexOf("data:")||(r=e.url),r}var P=function(){function t(t){this.hls=void 0,this.loaders=Object.create(null),this.hls=t,this.registerListeners()}var e=t.prototype;return e.registerListeners=function(){var t=this.hls;t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.on(s.a.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this),t.on(s.a.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this)},e.unregisterListeners=function(){var t=this.hls;t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.off(s.a.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this),t.off(s.a.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this)},e.createInternalLoader=function(t){var e=this.hls.config,r=e.pLoader,i=e.loader,n=new(r||i)(e);return t.loader=n,this.loaders[t.type]=n,n},e.getInternalLoader=function(t){return this.loaders[t.type]},e.resetInternalLoader=function(t){this.loaders[t]&&delete this.loaders[t]},e.destroyInternalLoaders=function(){for(var t in this.loaders){var e=this.loaders[t];e&&e.destroy(),this.resetInternalLoader(t)}},e.destroy=function(){this.unregisterListeners(),this.destroyInternalLoaders()},e.onManifestLoading=function(t,e){var r=e.url;this.load({id:null,groupId:null,level:0,responseType:"text",type:C.a.MANIFEST,url:r,deliveryDirectives:null})},e.onLevelLoading=function(t,e){var r=e.id,i=e.level,n=e.url,a=e.deliveryDirectives;this.load({id:r,groupId:null,level:i,responseType:"text",type:C.a.LEVEL,url:n,deliveryDirectives:a})},e.onAudioTrackLoading=function(t,e){var r=e.id,i=e.groupId,n=e.url,a=e.deliveryDirectives;this.load({id:r,groupId:i,level:null,responseType:"text",type:C.a.AUDIO_TRACK,url:n,deliveryDirectives:a})},e.onSubtitleTrackLoading=function(t,e){var r=e.id,i=e.groupId,n=e.url,a=e.deliveryDirectives;this.load({id:r,groupId:i,level:null,responseType:"text",type:C.a.SUBTITLE_TRACK,url:n,deliveryDirectives:a})},e.load=function(t){var e,r,i,n,a,s,o=this.hls.config,u=this.getInternalLoader(t);if(u){var h=u.context;if(h&&h.url===t.url)return void l.b.trace("[playlist-loader]: playlist request ongoing");l.b.log("[playlist-loader]: aborting previous loader for type: "+t.type),u.abort()}switch(t.type){case C.a.MANIFEST:r=o.manifestLoadingMaxRetry,i=o.manifestLoadingTimeOut,n=o.manifestLoadingRetryDelay,a=o.manifestLoadingMaxRetryTimeout;break;case C.a.LEVEL:case C.a.AUDIO_TRACK:case C.a.SUBTITLE_TRACK:r=0,i=o.levelLoadingTimeOut;break;default:r=o.levelLoadingMaxRetry,i=o.levelLoadingTimeOut,n=o.levelLoadingRetryDelay,a=o.levelLoadingMaxRetryTimeout}if((u=this.createInternalLoader(t),null!==(e=t.deliveryDirectives)&&void 0!==e&&e.part)&&(t.type===C.a.LEVEL&&null!==t.level?s=this.hls.levels[t.level].details:t.type===C.a.AUDIO_TRACK&&null!==t.id?s=this.hls.audioTracks[t.id].details:t.type===C.a.SUBTITLE_TRACK&&null!==t.id&&(s=this.hls.subtitleTracks[t.id].details),s)){var d=s.partTarget,c=s.targetduration;d&&c&&(i=Math.min(1e3*Math.max(3*d,.8*c),i))}var f={timeout:i,maxRetry:r,retryDelay:n,maxRetryDelay:a,highWaterMark:0},g={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)};u.load(t,f,g)},e.loadsuccess=function(t,e,r,i){if(void 0===i&&(i=null),r.isSidxRequest)return this.handleSidxRequest(t,r),void this.handlePlaylistLoaded(t,e,r,i);this.resetInternalLoader(r.type);var n=t.data;0===n.indexOf("#EXTM3U")?(e.parsing.start=performance.now(),n.indexOf("#EXTINF:")>0||n.indexOf("#EXT-X-TARGETDURATION:")>0?this.handleTrackOrLevelPlaylist(t,e,r,i):this.handleMasterPlaylist(t,e,r,i)):this.handleManifestParsingError(t,r,"no EXTM3U delimiter",i)},e.loaderror=function(t,e,r){void 0===r&&(r=null),this.handleNetworkError(e,r,!1,t)},e.loadtimeout=function(t,e,r){void 0===r&&(r=null),this.handleNetworkError(e,r,!0)},e.handleMasterPlaylist=function(t,e,r,i){var n=this.hls,a=t.data,o=x(t,r),u=k.parseMasterPlaylist(a,o),h=u.levels,d=u.sessionData;if(h.length){var f=h.map((function(t){return{id:t.attrs.AUDIO,audioCodec:t.audioCodec}})),g=h.map((function(t){return{id:t.attrs.SUBTITLES,textCodec:t.textCodec}})),v=k.parseMasterPlaylistMedia(a,o,"AUDIO",f),p=k.parseMasterPlaylistMedia(a,o,"SUBTITLES",g),m=k.parseMasterPlaylistMedia(a,o,"CLOSED-CAPTIONS");if(v.length)v.some((function(t){return!t.url}))||!h[0].audioCodec||h[0].attrs.AUDIO||(l.b.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"),v.unshift({type:"main",name:"main",default:!1,autoselect:!1,forced:!1,id:-1,attrs:new c({}),bitrate:0,url:""}));n.trigger(s.a.MANIFEST_LOADED,{levels:h,audioTracks:v,subtitles:p,captions:m,url:o,stats:e,networkDetails:i,sessionData:d})}else this.handleManifestParsingError(t,r,"no level found in manifest",i)},e.handleTrackOrLevelPlaylist=function(t,e,r,i){var n=this.hls,l=r.id,u=r.level,h=r.type,d=x(t,r),f=Object(a.a)(l)?l:0,g=Object(a.a)(u)?u:f,v=function(t){switch(t.type){case C.a.AUDIO_TRACK:return C.b.AUDIO;case C.a.SUBTITLE_TRACK:return C.b.SUBTITLE;default:return C.b.MAIN}}(r),p=k.parseLevelPlaylist(t.data,d,g,v,f);if(p.fragments.length){if(h===C.a.MANIFEST){var m={attrs:new c({}),bitrate:0,details:p,name:"",url:d};n.trigger(s.a.MANIFEST_LOADED,{levels:[m],audioTracks:[],url:d,stats:e,networkDetails:i,sessionData:null})}if(e.parsing.end=performance.now(),p.needSidxRanges){var y,T=null===(y=p.fragments[0].initSegment)||void 0===y?void 0:y.url;this.load({url:T,isSidxRequest:!0,type:h,level:u,levelDetails:p,id:l,groupId:null,rangeStart:0,rangeEnd:2048,responseType:"arraybuffer",deliveryDirectives:null})}else r.levelDetails=p,this.handlePlaylistLoaded(t,e,r,i)}else n.trigger(s.a.ERROR,{type:o.b.NETWORK_ERROR,details:o.a.LEVEL_EMPTY_ERROR,fatal:!1,url:d,reason:"no fragments found in level",level:"number"==typeof r.level?r.level:void 0})},e.handleSidxRequest=function(t,e){var r=Object(u.k)(new Uint8Array(t.data));if(r){var i=r.references,n=e.levelDetails;i.forEach((function(t,e){var i=t.info,a=n.fragments[e];0===a.byteRange.length&&a.setByteRange(String(1+i.end-i.start)+"@"+String(i.start)),a.initSegment&&a.initSegment.setByteRange(String(r.moovEndOffset)+"@0")}))}},e.handleManifestParsingError=function(t,e,r,i){this.hls.trigger(s.a.ERROR,{type:o.b.NETWORK_ERROR,details:o.a.MANIFEST_PARSING_ERROR,fatal:e.type===C.a.MANIFEST,url:t.url,reason:r,response:t,context:e,networkDetails:i})},e.handleNetworkError=function(t,e,r,i){void 0===r&&(r=!1),l.b.warn("[playlist-loader]: A network "+(r?"timeout":"error")+" occurred while loading "+t.type+" level: "+t.level+" id: "+t.id+' group-id: "'+t.groupId+'"');var n=o.a.UNKNOWN,a=!1,u=this.getInternalLoader(t);switch(t.type){case C.a.MANIFEST:n=r?o.a.MANIFEST_LOAD_TIMEOUT:o.a.MANIFEST_LOAD_ERROR,a=!0;break;case C.a.LEVEL:n=r?o.a.LEVEL_LOAD_TIMEOUT:o.a.LEVEL_LOAD_ERROR,a=!1;break;case C.a.AUDIO_TRACK:n=r?o.a.AUDIO_TRACK_LOAD_TIMEOUT:o.a.AUDIO_TRACK_LOAD_ERROR,a=!1;break;case C.a.SUBTITLE_TRACK:n=r?o.a.SUBTITLE_TRACK_LOAD_TIMEOUT:o.a.SUBTITLE_LOAD_ERROR,a=!1}u&&this.resetInternalLoader(t.type);var h={type:o.b.NETWORK_ERROR,details:n,fatal:a,url:t.url,loader:u,context:t,networkDetails:e};i&&(h.response=i),this.hls.trigger(s.a.ERROR,h)},e.handlePlaylistLoaded=function(t,e,r,i){var n=r.type,a=r.level,o=r.id,l=r.groupId,u=r.loader,h=r.levelDetails,d=r.deliveryDirectives;if(null!=h&&h.targetduration){if(u)switch(h.live&&(u.getCacheAge&&(h.ageHeader=u.getCacheAge()||0),u.getCacheAge&&!isNaN(h.ageHeader)||(h.ageHeader=0)),n){case C.a.MANIFEST:case C.a.LEVEL:this.hls.trigger(s.a.LEVEL_LOADED,{details:h,level:a||0,id:o||0,stats:e,networkDetails:i,deliveryDirectives:d});break;case C.a.AUDIO_TRACK:this.hls.trigger(s.a.AUDIO_TRACK_LOADED,{details:h,id:o||0,groupId:l||"",stats:e,networkDetails:i,deliveryDirectives:d});break;case C.a.SUBTITLE_TRACK:this.hls.trigger(s.a.SUBTITLE_TRACK_LOADED,{details:h,id:o||0,groupId:l||"",stats:e,networkDetails:i,deliveryDirectives:d})}}else this.handleManifestParsingError(t,r,"invalid target duration",i)},t}(),M=function(){function t(t){this.hls=void 0,this.loaders={},this.decryptkey=null,this.decrypturl=null,this.hls=t,this._registerListeners()}var e=t.prototype;return e._registerListeners=function(){this.hls.on(s.a.KEY_LOADING,this.onKeyLoading,this)},e._unregisterListeners=function(){this.hls.off(s.a.KEY_LOADING,this.onKeyLoading)},e.destroy=function(){for(var t in this._unregisterListeners(),this.loaders){var e=this.loaders[t];e&&e.destroy()}this.loaders={}},e.onKeyLoading=function(t,e){var r=e.frag,i=r.type,n=this.loaders[i];if(r.decryptdata){var a=r.decryptdata.uri;if(a!==this.decrypturl||null===this.decryptkey){var o=this.hls.config;if(n&&(l.b.warn("abort previous key loader for type:"+i),n.abort()),!a)return void l.b.warn("key uri is falsy");var u=o.loader,h=r.loader=this.loaders[i]=new u(o);this.decrypturl=a,this.decryptkey=null;var d={url:a,frag:r,responseType:"arraybuffer"},c={timeout:o.fragLoadingTimeOut,maxRetry:0,retryDelay:o.fragLoadingRetryDelay,maxRetryDelay:o.fragLoadingMaxRetryTimeout,highWaterMark:0},f={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)};h.load(d,c,f)}else this.decryptkey&&(r.decryptdata.key=this.decryptkey,this.hls.trigger(s.a.KEY_LOADED,{frag:r}))}else l.b.warn("Missing decryption data on fragment in onKeyLoading")},e.loadsuccess=function(t,e,r){var i=r.frag;i.decryptdata?(this.decryptkey=i.decryptdata.key=new Uint8Array(t.data),i.loader=null,delete this.loaders[i.type],this.hls.trigger(s.a.KEY_LOADED,{frag:i})):l.b.error("after key load, decryptdata unset")},e.loaderror=function(t,e){var r=e.frag,i=r.loader;i&&i.abort(),delete this.loaders[r.type],this.hls.trigger(s.a.ERROR,{type:o.b.NETWORK_ERROR,details:o.a.KEY_LOAD_ERROR,fatal:!1,frag:r,response:t})},e.loadtimeout=function(t,e){var r=e.frag,i=r.loader;i&&i.abort(),delete this.loaders[r.type],this.hls.trigger(s.a.ERROR,{type:o.b.NETWORK_ERROR,details:o.a.KEY_LOAD_TIMEOUT,fatal:!1,frag:r})},t}();function F(t,e){var r;try{r=new Event("addtrack")}catch(t){(r=document.createEvent("Event")).initEvent("addtrack",!1,!1)}r.track=t,e.dispatchEvent(r)}function N(t,e){var r=t.mode;if("disabled"===r&&(t.mode="hidden"),t.cues&&!t.cues.getCueById(e.id))try{if(t.addCue(e),!t.cues.getCueById(e.id))throw new Error("addCue is failed for: "+e)}catch(r){l.b.debug("[texttrack-utils]: "+r);var i=new self.TextTrackCue(e.startTime,e.endTime,e.text);i.id=e.id,t.addCue(i)}"disabled"===r&&(t.mode=r)}function U(t){var e=t.mode;if("disabled"===e&&(t.mode="hidden"),t.cues)for(var r=t.cues.length;r--;)t.removeCue(t.cues[r]);"disabled"===e&&(t.mode=e)}function B(t,e,r,i){var n=t.mode;if("disabled"===n&&(t.mode="hidden"),t.cues&&t.cues.length>0)for(var a=function(t,e,r){var i=[],n=function(t,e){if(e<t[0].startTime)return 0;var r=t.length-1;if(e>t[r].endTime)return-1;var i=0,n=r;for(;i<=n;){var a=Math.floor((n+i)/2);if(e<t[a].startTime)n=a-1;else{if(!(e>t[a].startTime&&i<r))return a;i=a+1}}return t[i].startTime-e<e-t[n].startTime?i:n}(t,e);if(n>-1)for(var a=n,s=t.length;a<s;a++){var o=t[a];if(o.startTime>=e&&o.endTime<=r)i.push(o);else if(o.startTime>r)return i}return i}(t.cues,e,r),s=0;s<a.length;s++)i&&!i(a[s])||t.removeCue(a[s]);"disabled"===n&&(t.mode=n)}var G=r(7),j=r(8);function K(){return self.WebKitDataCue||self.VTTCue||self.TextTrackCue}function H(t,e){return t.getTime()/1e3-e}var V=function(){function t(t){this.hls=void 0,this.id3Track=null,this.media=null,this.dateRangeCuesAppended={},this.hls=t,this._registerListeners()}var e=t.prototype;return e.destroy=function(){this._unregisterListeners(),this.id3Track=null,this.media=null,this.dateRangeCuesAppended={},this.hls=null},e._registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this),t.on(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(s.a.LEVEL_UPDATED,this.onLevelUpdated,this)},e._unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this),t.off(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(s.a.LEVEL_UPDATED,this.onLevelUpdated,this)},e.onMediaAttached=function(t,e){this.media=e.media},e.onMediaDetaching=function(){this.id3Track&&(U(this.id3Track),this.id3Track=null,this.media=null,this.dateRangeCuesAppended={})},e.onManifestLoading=function(){this.dateRangeCuesAppended={}},e.createTrack=function(t){var e=this.getID3Track(t.textTracks);return e.mode="hidden",e},e.getID3Track=function(t){if(this.media){for(var e=0;e<t.length;e++){var r=t[e];if("metadata"===r.kind&&"id3"===r.label)return F(r,this.media),r}return this.media.addTextTrack("metadata","id3")}},e.onFragParsingMetadata=function(t,e){if(this.media){var r=this.hls.config,i=r.enableEmsgMetadataCues,n=r.enableID3MetadataCues;if(i||n){var a=e.frag,s=e.samples,o=e.details;this.id3Track||(this.id3Track=this.createTrack(this.media));for(var l=o.edge||a.end,u=K(),h=!1,d={},c=0;c<s.length;c++){var f=s[c].type;if((f!==j.a.emsg||i)&&n){var g=G.c(s[c].data);if(g){var v=s[c].pts,p=l;p-v<=0&&(p=v+.25);for(var m=0;m<g.length;m++){var y=g[m];if(!G.e(y)){var T=new u(v,p,"");T.value=y,f&&(T.type=f),this.id3Track.addCue(T),d[y.key]=null,h=!0}}}}}h&&this.updateId3CueEnds(d)}}},e.updateId3CueEnds=function(t){var e,r=null===(e=this.id3Track)||void 0===e?void 0:e.cues;if(r)for(var i=r.length;i--;){var n,a=r[i],s=null===(n=a.value)||void 0===n?void 0:n.key;if(s&&s in t){var o=t[s];o&&a.endTime!==o&&(a.endTime=o),t[s]=a.startTime}}},e.onBufferFlushing=function(t,e){var r=e.startOffset,i=e.endOffset,n=e.type,a=this.id3Track,s=this.hls;if(s){var o=s.config,l=o.enableEmsgMetadataCues,u=o.enableID3MetadataCues;if(a&&(l||u))B(a,r,i,"audio"===n?function(t){return t.type===j.a.audioId3&&u}:"video"===n?function(t){return t.type===j.a.emsg&&l}:function(t){return t.type===j.a.audioId3&&u||t.type===j.a.emsg&&l})}},e.onLevelUpdated=function(t,e){var r=this,n=e.details;if(this.media&&n.hasProgramDateTime&&this.hls.config.enableDateRangeMetadataCues){var s=this.dateRangeCuesAppended,o=this.id3Track,l=n.dateRanges,u=Object.keys(l);if(o)for(var h=Object.keys(s).filter((function(t){return!u.includes(t)})),d=function(t){var e=h[t];Object.keys(s[e].cues).forEach((function(t){o.removeCue(s[e].cues[t])})),delete s[e]},c=h.length;c--;)d(c);var f=n.fragments[n.fragments.length-1];if(0!==u.length&&Object(a.a)(null==f?void 0:f.programDateTime)){this.id3Track||(this.id3Track=this.createTrack(this.media));for(var g=f.programDateTime/1e3-f.start,v=n.edge||f.end,p=K(),m=function(t){var e=u[t],n=l[e],a=s[e],o=(null==a?void 0:a.cues)||{},h=(null==a?void 0:a.durationKnown)||!1,d=H(n.startDate,g),c=v,f=n.endDate;if(f)c=H(f,g),h=!0;else if(n.endOnNext&&!h){var m=u.reduce((function(t,e){var r=l[e];return r.class===n.class&&r.id!==e&&r.startDate>n.startDate&&t.push(r),t}),[]).sort((function(t,e){return t.startDate.getTime()-e.startDate.getTime()}))[0];m&&(c=H(m.startDate,g),h=!0)}for(var y,T=Object.keys(n.attr),b=0;b<T.length;b++){var E=T[b];if(E!==i.ID&&E!==i.CLASS&&E!==i.START_DATE&&E!==i.DURATION&&E!==i.END_DATE&&E!==i.END_ON_NEXT){var S=o[E];if(S)h&&!a.durationKnown&&(S.endTime=c);else{var L=n.attr[E];S=new p(d,c,""),E!==i.SCTE35_OUT&&E!==i.SCTE35_IN||(y=L,L=Uint8Array.from(y.replace(/^0x/,"").replace(/([\da-fA-F]{2}) ?/g,"0x$1 ").replace(/ +$/,"").split(" ")).buffer),S.value={key:E,data:L},S.type=j.a.dateRange,r.id3Track.addCue(S),o[E]=S}}}s[e]={cues:o,dateRange:n,durationKnown:h}},y=0;y<u.length;y++)m(y)}}},t}();function W(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var Y,q=function(){function t(t){var e=this;this.hls=void 0,this.config=void 0,this.media=null,this.levelDetails=null,this.currentTime=0,this.stallCount=0,this._latency=null,this.timeupdateHandler=function(){return e.timeupdate()},this.hls=t,this.config=t.config,this.registerListeners()}var e,r,i,n=t.prototype;return n.destroy=function(){this.unregisterListeners(),this.onMediaDetaching(),this.levelDetails=null,this.hls=this.timeupdateHandler=null},n.registerListeners=function(){this.hls.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),this.hls.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),this.hls.on(s.a.LEVEL_UPDATED,this.onLevelUpdated,this),this.hls.on(s.a.ERROR,this.onError,this)},n.unregisterListeners=function(){this.hls.off(s.a.MEDIA_ATTACHED,this.onMediaAttached),this.hls.off(s.a.MEDIA_DETACHING,this.onMediaDetaching),this.hls.off(s.a.MANIFEST_LOADING,this.onManifestLoading),this.hls.off(s.a.LEVEL_UPDATED,this.onLevelUpdated),this.hls.off(s.a.ERROR,this.onError)},n.onMediaAttached=function(t,e){this.media=e.media,this.media.addEventListener("timeupdate",this.timeupdateHandler)},n.onMediaDetaching=function(){this.media&&(this.media.removeEventListener("timeupdate",this.timeupdateHandler),this.media=null)},n.onManifestLoading=function(){this.levelDetails=null,this._latency=null,this.stallCount=0},n.onLevelUpdated=function(t,e){var r=e.details;this.levelDetails=r,r.advanced&&this.timeupdate(),!r.live&&this.media&&this.media.removeEventListener("timeupdate",this.timeupdateHandler)},n.onError=function(t,e){e.details===o.a.BUFFER_STALLED_ERROR&&(this.stallCount++,l.b.warn("[playback-rate-controller]: Stall detected, adjusting target latency"))},n.timeupdate=function(){var t=this.media,e=this.levelDetails;if(t&&e){this.currentTime=t.currentTime;var r=this.computeLatency();if(null!==r){this._latency=r;var i=this.config,n=i.lowLatencyMode,a=i.maxLiveSyncPlaybackRate;if(n&&1!==a){var s=this.targetLatency;if(null!==s){var o=r-s,l=o<Math.min(this.maxLatency,s+e.targetduration);if(e.live&&l&&o>.05&&this.forwardBufferLength>1){var u=Math.min(2,Math.max(1,a)),h=Math.round(2/(1+Math.exp(-.75*o-this.edgeStalled))*20)/20;t.playbackRate=Math.min(u,Math.max(1,h))}else 1!==t.playbackRate&&0!==t.playbackRate&&(t.playbackRate=1)}}}}},n.estimateLiveEdge=function(){var t=this.levelDetails;return null===t?null:t.edge+t.age},n.computeLatency=function(){var t=this.estimateLiveEdge();return null===t?null:t-this.currentTime},e=t,(r=[{key:"latency",get:function(){return this._latency||0}},{key:"maxLatency",get:function(){var t=this.config,e=this.levelDetails;return void 0!==t.liveMaxLatencyDuration?t.liveMaxLatencyDuration:e?t.liveMaxLatencyDurationCount*e.targetduration:0}},{key:"targetLatency",get:function(){var t=this.levelDetails;if(null===t)return null;var e=t.holdBack,r=t.partHoldBack,i=t.targetduration,n=this.config,a=n.liveSyncDuration,s=n.liveSyncDurationCount,o=n.lowLatencyMode,l=this.hls.userConfig,u=o&&r||e;(l.liveSyncDuration||l.liveSyncDurationCount||0===u)&&(u=void 0!==a?a:s*i);var h=i;return u+Math.min(1*this.stallCount,h)}},{key:"liveSyncPosition",get:function(){var t=this.estimateLiveEdge(),e=this.targetLatency,r=this.levelDetails;if(null===t||null===e||null===r)return null;var i=r.edge,n=t-e-this.edgeStalled,a=i-r.totalduration,s=i-(this.config.lowLatencyMode&&r.partTarget||r.targetduration);return Math.min(Math.max(a,n),s)}},{key:"drift",get:function(){var t=this.levelDetails;return null===t?1:t.drift}},{key:"edgeStalled",get:function(){var t=this.levelDetails;if(null===t)return 0;var e=3*(this.config.lowLatencyMode&&t.partTarget||t.targetduration);return Math.max(t.age-e,0)}},{key:"forwardBufferLength",get:function(){var t=this.media,e=this.levelDetails;if(!t||!e)return 0;var r=t.buffered.length;return(r?t.buffered.end(r-1):e.edge)-this.currentTime}}])&&W(e.prototype,r),i&&W(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}();function z(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}!function(t){t.No="",t.Yes="YES",t.v2="v2"}(Y||(Y={}));var X=function(){function t(t,e,r){this.msn=void 0,this.part=void 0,this.skip=void 0,this.msn=t,this.part=e,this.skip=r}return t.prototype.addDirectives=function(t){var e=new self.URL(t);return void 0!==this.msn&&e.searchParams.set("_HLS_msn",this.msn.toString()),void 0!==this.part&&e.searchParams.set("_HLS_part",this.part.toString()),this.skip&&e.searchParams.set("_HLS_skip",this.skip),e.toString()},t}(),Q=function(){function t(t){this.attrs=void 0,this.audioCodec=void 0,this.bitrate=void 0,this.codecSet=void 0,this.height=void 0,this.id=void 0,this.name=void 0,this.videoCodec=void 0,this.width=void 0,this.unknownCodecs=void 0,this.audioGroupIds=void 0,this.details=void 0,this.fragmentError=0,this.loadError=0,this.loaded=void 0,this.realBitrate=0,this.textGroupIds=void 0,this.url=void 0,this._urlId=0,this.url=[t.url],this.attrs=t.attrs,this.bitrate=t.bitrate,t.details&&(this.details=t.details),this.id=t.id||0,this.name=t.name,this.width=t.width||0,this.height=t.height||0,this.audioCodec=t.audioCodec,this.videoCodec=t.videoCodec,this.unknownCodecs=t.unknownCodecs,this.codecSet=[t.videoCodec,t.audioCodec].filter((function(t){return t})).join(",").replace(/\.[^.,]+/g,"")}var e,r,i;return e=t,(r=[{key:"maxBitrate",get:function(){return Math.max(this.realBitrate,this.bitrate)}},{key:"uri",get:function(){return this.url[this._urlId]||""}},{key:"urlId",get:function(){return this._urlId},set:function(t){var e=t%this.url.length;this._urlId!==e&&(this.details=void 0,this._urlId=e)}}])&&z(e.prototype,r),i&&z(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}();function $(){return($=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}function J(t,e,r){switch(e){case"audio":t.audioGroupIds||(t.audioGroupIds=[]),t.audioGroupIds.push(r);break;case"text":t.textGroupIds||(t.textGroupIds=[]),t.textGroupIds.push(r)}}function Z(t){var e={};t.forEach((function(t){var r=t.groupId||"";t.id=e[r]=e[r]||0,e[r]++}))}function tt(t,e){var r=e.startPTS;if(Object(a.a)(r)){var i,n=0;e.sn>t.sn?(n=r-t.start,i=t):(n=t.start-r,i=e),i.duration!==n&&(i.duration=n)}else if(e.sn>t.sn){t.cc===e.cc&&t.minEndPTS?e.start=t.start+(t.minEndPTS-t.start):e.start=t.start+t.duration}else e.start=Math.max(t.start-e.duration,0)}function et(t,e,r,i,n,s){i-r<=0&&(l.b.warn("Fragment should have a positive duration",e),i=r+e.duration,s=n+e.duration);var o=r,u=i,h=e.startPTS,d=e.endPTS;if(Object(a.a)(h)){var c=Math.abs(h-r);Object(a.a)(e.deltaPTS)?e.deltaPTS=Math.max(c,e.deltaPTS):e.deltaPTS=c,o=Math.max(r,h),r=Math.min(r,h),n=Math.min(n,e.startDTS),u=Math.min(i,d),i=Math.max(i,d),s=Math.max(s,e.endDTS)}e.duration=i-r;var f=r-e.start;e.appendedPTS=i,e.start=e.startPTS=r,e.maxStartPTS=o,e.startDTS=n,e.endPTS=i,e.minEndPTS=u,e.endDTS=s;var g,v=e.sn;if(!t||v<t.startSN||v>t.endSN)return 0;var p=v-t.startSN,m=t.fragments;for(m[p]=e,g=p;g>0;g--)tt(m[g],m[g-1]);for(g=p;g<m.length-1;g++)tt(m[g],m[g+1]);return t.fragmentHint&&tt(m[m.length-1],t.fragmentHint),t.PTSKnown=t.alignedSliding=!0,f}function rt(t,e){for(var r=null,i=t.fragments,n=i.length-1;n>=0;n--){var s=i[n].initSegment;if(s){r=s;break}}t.fragmentHint&&delete t.fragmentHint.endPTS;var o,u=0;(function(t,e,r){for(var i=e.skippedSegments,n=Math.max(t.startSN,e.startSN)-e.startSN,a=(t.fragmentHint?1:0)+(i?e.endSN:Math.min(t.endSN,e.endSN))-e.startSN,s=e.startSN-t.startSN,o=e.fragmentHint?e.fragments.concat(e.fragmentHint):e.fragments,l=t.fragmentHint?t.fragments.concat(t.fragmentHint):t.fragments,u=n;u<=a;u++){var h=l[s+u],d=o[u];i&&!d&&u<i&&(d=e.fragments[u]=h),h&&d&&r(h,d)}}(t,e,(function(t,i){t.relurl&&(u=t.cc-i.cc),Object(a.a)(t.startPTS)&&Object(a.a)(t.endPTS)&&(i.start=i.startPTS=t.startPTS,i.startDTS=t.startDTS,i.appendedPTS=t.appendedPTS,i.maxStartPTS=t.maxStartPTS,i.endPTS=t.endPTS,i.endDTS=t.endDTS,i.minEndPTS=t.minEndPTS,i.duration=t.endPTS-t.startPTS,i.duration&&(o=i),e.PTSKnown=e.alignedSliding=!0),i.elementaryStreams=t.elementaryStreams,i.loader=t.loader,i.stats=t.stats,i.urlId=t.urlId,t.initSegment&&(i.initSegment=t.initSegment,r=t.initSegment)})),r)&&(e.fragmentHint?e.fragments.concat(e.fragmentHint):e.fragments).forEach((function(t){var e;t.initSegment&&t.initSegment.relurl!==(null===(e=r)||void 0===e?void 0:e.relurl)||(t.initSegment=r)}));if(e.skippedSegments)if(e.deltaUpdateFailed=e.fragments.some((function(t){return!t})),e.deltaUpdateFailed){l.b.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");for(var h=e.skippedSegments;h--;)e.fragments.shift();e.startSN=e.fragments[0].sn,e.startCC=e.fragments[0].cc}else e.canSkipDateRanges&&(e.dateRanges=function(t,e,r){var i=$({},t);r&&r.forEach((function(t){delete i[t]}));return Object.keys(e).forEach((function(t){var r=new v(e[t].attr,i[t]);r.isValid?i[t]=r:l.b.warn('Ignoring invalid Playlist Delta Update DATERANGE tag: "'+JSON.stringify(e[t].attr)+'"')})),i}(t.dateRanges,e.dateRanges,e.recentlyRemovedDateranges));var d=e.fragments;if(u){l.b.warn("discontinuity sliding from playlist, take drift into account");for(var c=0;c<d.length;c++)d[c].cc+=u}e.skippedSegments&&(e.startCC=e.fragments[0].cc),function(t,e,r){if(t&&e)for(var i=0,n=0,a=t.length;n<=a;n++){var s=t[n],o=e[n+i];s&&o&&s.index===o.index&&s.fragment.sn===o.fragment.sn?r(s,o):i--}}(t.partList,e.partList,(function(t,e){e.elementaryStreams=t.elementaryStreams,e.stats=t.stats})),o?et(e,o,o.startPTS,o.endPTS,o.startDTS,o.endDTS):it(t,e),d.length&&(e.totalduration=e.edge-d[0].start),e.driftStartTime=t.driftStartTime,e.driftStart=t.driftStart;var f=e.advancedDateTime;if(e.advanced&&f){var g=e.edge;e.driftStart||(e.driftStartTime=f,e.driftStart=g),e.driftEndTime=f,e.driftEnd=g}else e.driftEndTime=t.driftEndTime,e.driftEnd=t.driftEnd,e.advancedDateTime=t.advancedDateTime}function it(t,e){var r=e.startSN+e.skippedSegments-t.startSN,i=t.fragments;r<0||r>=i.length||nt(e,i[r].start)}function nt(t,e){if(e){for(var r=t.fragments,i=t.skippedSegments;i<r.length;i++)r[i].start+=e;t.fragmentHint&&(t.fragmentHint.start+=e)}}var at=function(){function t(t,e){this.hls=void 0,this.timer=-1,this.canLoad=!1,this.retryCount=0,this.log=void 0,this.warn=void 0,this.log=l.b.log.bind(l.b,e+":"),this.warn=l.b.warn.bind(l.b,e+":"),this.hls=t}var e=t.prototype;return e.destroy=function(){this.clearTimer(),this.hls=this.log=this.warn=null},e.onError=function(t,e){e.fatal&&e.type===o.b.NETWORK_ERROR&&this.clearTimer()},e.clearTimer=function(){clearTimeout(this.timer),this.timer=-1},e.startLoad=function(){this.canLoad=!0,this.retryCount=0,this.loadPlaylist()},e.stopLoad=function(){this.canLoad=!1,this.clearTimer()},e.switchParams=function(t,e){var r=null==e?void 0:e.renditionReports;if(r)for(var i=0;i<r.length;i++){var n=r[i],s=""+n.URI;if(s===t.slice(-s.length)){var o=parseInt(n["LAST-MSN"]),l=parseInt(n["LAST-PART"]);if(e&&this.hls.config.lowLatencyMode){var u=Math.min(e.age-e.partTarget,e.targetduration);void 0!==l&&u>e.partTarget&&(l+=1)}if(Object(a.a)(o))return new X(o,Object(a.a)(l)?l:void 0,Y.No)}}},e.loadPlaylist=function(t){},e.shouldLoadTrack=function(t){return this.canLoad&&t&&!!t.url&&(!t.details||t.details.live)},e.playlistLoaded=function(t,e,r){var i=this,n=e.details,a=e.stats,s=a.loading.end?Math.max(0,self.performance.now()-a.loading.end):0;if(n.advancedDateTime=Date.now()-s,n.live||null!=r&&r.live){if(n.reloaded(r),r&&this.log("live playlist "+t+" "+(n.advanced?"REFRESHED "+n.lastPartSn+"-"+n.lastPartIndex:"MISSED")),r&&n.fragments.length>0&&rt(r,n),!this.canLoad||!n.live)return;var o,l=void 0,u=void 0;if(n.canBlockReload&&n.endSN&&n.advanced){var h=this.hls.config.lowLatencyMode,d=n.lastPartSn,c=n.endSN,f=n.lastPartIndex,g=d===c;-1!==f?(l=g?c+1:d,u=g?h?0:f:f+1):l=c+1;var v=n.age,p=v+n.ageHeader,m=Math.min(p-n.partTarget,1.5*n.targetduration);if(m>0){if(r&&m>r.tuneInGoal)this.warn("CDN Tune-in goal increased from: "+r.tuneInGoal+" to: "+m+" with playlist age: "+n.age),m=0;else{var y=Math.floor(m/n.targetduration);if(l+=y,void 0!==u)u+=Math.round(m%n.targetduration/n.partTarget);this.log("CDN Tune-in age: "+n.ageHeader+"s last advanced "+v.toFixed(2)+"s goal: "+m+" skip sn "+y+" to part "+u)}n.tuneInGoal=m}if(o=this.getDeliveryDirectives(n,e.deliveryDirectives,l,u),h||!g)return void this.loadPlaylist(o)}else o=this.getDeliveryDirectives(n,e.deliveryDirectives,l,u);var T=function(t,e){var r,i=1e3*t.levelTargetDuration,n=i/2,a=t.age,s=a>0&&a<3*i,o=e.loading.end-e.loading.start,l=t.availabilityDelay;if(!1===t.updated)if(s){var u=333*t.misses;r=Math.max(Math.min(n,2*o),u),t.availabilityDelay=(t.availabilityDelay||0)+r}else r=n;else s?(l=Math.min(l||i/2,a),t.availabilityDelay=l,r=l+i-a):r=i-o;return Math.round(r)}(n,a);void 0!==l&&n.canBlockReload&&(T-=n.partTarget||1),this.log("reload live playlist "+t+" in "+Math.round(T)+" ms"),this.timer=self.setTimeout((function(){return i.loadPlaylist(o)}),T)}else this.clearTimer()},e.getDeliveryDirectives=function(t,e,r,i){var n=function(t,e){var r=t.canSkipUntil,i=t.canSkipDateRanges,n=t.endSN;return r&&(void 0!==e?e-n:0)<r?i?Y.v2:Y.Yes:Y.No}(t,r);return null!=e&&e.skip&&t.deltaUpdateFailed&&(r=e.msn,i=e.part,n=Y.No),new X(r,i,n)},e.retryLoadingOrFail=function(t){var e,r=this,i=this.hls.config,n=this.retryCount<i.levelLoadingMaxRetry;if(n)if(this.retryCount++,t.details.indexOf("LoadTimeOut")>-1&&null!==(e=t.context)&&void 0!==e&&e.deliveryDirectives)this.warn("retry playlist loading #"+this.retryCount+' after "'+t.details+'"'),this.loadPlaylist();else{var a=Math.min(Math.pow(2,this.retryCount)*i.levelLoadingRetryDelay,i.levelLoadingMaxRetryTimeout);this.timer=self.setTimeout((function(){return r.loadPlaylist()}),a),this.warn("retry playlist loading #"+this.retryCount+" in "+a+' ms after "'+t.details+'"')}else this.warn('cannot recover from error "'+t.details+'"'),this.clearTimer(),t.fatal=!0;return n},t}();function st(){return(st=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}function ot(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function lt(t,e){return(lt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var ut,ht=/chrome|firefox/.test(navigator.userAgent.toLowerCase()),dt=function(t){var e,r;function i(e){var r;return(r=t.call(this,e,"[level-controller]")||this)._levels=[],r._firstLevel=-1,r._startLevel=void 0,r.currentLevelIndex=-1,r.manualLevelIndex=-1,r.onParsedComplete=void 0,r._registerListeners(),r}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,lt(e,r);var n,a,l,u=i.prototype;return u._registerListeners=function(){var t=this.hls;t.on(s.a.MANIFEST_LOADED,this.onManifestLoaded,this),t.on(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.on(s.a.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.on(s.a.FRAG_LOADED,this.onFragLoaded,this),t.on(s.a.ERROR,this.onError,this)},u._unregisterListeners=function(){var t=this.hls;t.off(s.a.MANIFEST_LOADED,this.onManifestLoaded,this),t.off(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.off(s.a.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.off(s.a.FRAG_LOADED,this.onFragLoaded,this),t.off(s.a.ERROR,this.onError,this)},u.destroy=function(){this._unregisterListeners(),this.manualLevelIndex=-1,this._levels.length=0,t.prototype.destroy.call(this)},u.startLoad=function(){this._levels.forEach((function(t){t.loadError=0})),t.prototype.startLoad.call(this)},u.onManifestLoaded=function(t,e){var r,i,n=[],a=[],l=[],u={},h=!1,d=!1,c=!1;if(e.levels.forEach((function(t){var e=t.attrs;h=h||!(!t.width||!t.height),d=d||!!t.videoCodec,c=c||!!t.audioCodec,ht&&t.audioCodec&&-1!==t.audioCodec.indexOf("mp4a.40.34")&&(t.audioCodec=void 0);var r=t.bitrate+"-"+t.attrs.RESOLUTION+"-"+t.attrs.CODECS;(i=u[r])?i.url.push(t.url):(i=new Q(t),u[r]=i,n.push(i)),e&&(e.AUDIO&&J(i,"audio",e.AUDIO),e.SUBTITLES&&J(i,"text",e.SUBTITLES))})),(h||d)&&c&&(n=n.filter((function(t){var e=t.videoCodec,r=t.width,i=t.height;return!!e||!(!r||!i)}))),n=n.filter((function(t){var e=t.audioCodec,r=t.videoCodec;return(!e||E(e,"audio"))&&(!r||E(r,"video"))})),e.audioTracks&&Z(a=e.audioTracks.filter((function(t){return!t.audioCodec||E(t.audioCodec,"audio")}))),e.subtitles&&Z(l=e.subtitles),n.length>0){r=n[0].bitrate,n.sort((function(t,e){return t.bitrate-e.bitrate})),this._levels=n;for(var f=0;f<n.length;f++)if(n[f].bitrate===r){this._firstLevel=f,this.log("manifest loaded, "+n.length+" level(s) found, first bitrate: "+r);break}var g=c&&!d,v={levels:n,audioTracks:a,subtitleTracks:l,firstLevel:this._firstLevel,stats:e.stats,audio:c,video:d,altAudio:!g&&a.some((function(t){return!!t.url}))};this.hls.trigger(s.a.MANIFEST_PARSED,v),(this.hls.config.autoStartLoad||this.hls.forceStartLoad)&&this.hls.startLoad(this.hls.config.startPosition)}else this.hls.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.MANIFEST_INCOMPATIBLE_CODECS_ERROR,fatal:!0,url:e.url,reason:"no level with compatible codecs found in manifest"})},u.onError=function(e,r){if(t.prototype.onError.call(this,e,r),!r.fatal){var i=r.context,n=this._levels[this.currentLevelIndex];if(i&&(i.type===C.a.AUDIO_TRACK&&n.audioGroupIds&&i.groupId===n.audioGroupIds[n.urlId]||i.type===C.a.SUBTITLE_TRACK&&n.textGroupIds&&i.groupId===n.textGroupIds[n.urlId]))this.redundantFailover(this.currentLevelIndex);else{var a,s=!1,l=!0;switch(r.details){case o.a.FRAG_LOAD_ERROR:case o.a.FRAG_LOAD_TIMEOUT:case o.a.KEY_LOAD_ERROR:case o.a.KEY_LOAD_TIMEOUT:if(r.frag){var u=this._levels[r.frag.level];u?(u.fragmentError++,u.fragmentError>this.hls.config.fragLoadingMaxRetry&&(a=r.frag.level)):a=r.frag.level}break;case o.a.LEVEL_LOAD_ERROR:case o.a.LEVEL_LOAD_TIMEOUT:i&&(i.deliveryDirectives&&(l=!1),a=i.level),s=!0;break;case o.a.REMUX_ALLOC_ERROR:a=r.level,s=!0}void 0!==a&&this.recoverLevel(r,a,s,l)}}},u.recoverLevel=function(t,e,r,i){var n=t.details,a=this._levels[e];if(a.loadError++,r){if(!this.retryLoadingOrFail(t))return void(this.currentLevelIndex=-1);t.levelRetry=!0}if(i){var s=a.url.length;if(s>1&&a.loadError<s)t.levelRetry=!0,this.redundantFailover(e);else if(-1===this.manualLevelIndex){var o=0===e?this._levels.length-1:e-1;this.currentLevelIndex!==o&&0===this._levels[o].loadError&&(this.warn(n+": switch to "+o),t.levelRetry=!0,this.hls.nextAutoLevel=o)}}},u.redundantFailover=function(t){var e=this._levels[t],r=e.url.length;if(r>1){var i=(e.urlId+1)%r;this.warn("Switching to redundant URL-id "+i),this._levels.forEach((function(t){t.urlId=i})),this.level=t}},u.onFragLoaded=function(t,e){var r=e.frag;if(void 0!==r&&r.type===C.b.MAIN){var i=this._levels[r.level];void 0!==i&&(i.fragmentError=0,i.loadError=0)}},u.onLevelLoaded=function(t,e){var r,i,n=e.level,a=e.details,s=this._levels[n];if(!s)return this.warn("Invalid level index "+n),void(null!==(i=e.deliveryDirectives)&&void 0!==i&&i.skip&&(a.deltaUpdateFailed=!0));n===this.currentLevelIndex?(0===s.fragmentError&&(s.loadError=0,this.retryCount=0),this.playlistLoaded(n,e,s.details)):null!==(r=e.deliveryDirectives)&&void 0!==r&&r.skip&&(a.deltaUpdateFailed=!0)},u.onAudioTrackSwitched=function(t,e){var r=this.hls.levels[this.currentLevelIndex];if(r&&r.audioGroupIds){for(var i=-1,n=this.hls.audioTracks[e.id].groupId,a=0;a<r.audioGroupIds.length;a++)if(r.audioGroupIds[a]===n){i=a;break}i!==r.urlId&&(r.urlId=i,this.startLoad())}},u.loadPlaylist=function(t){var e=this.currentLevelIndex,r=this._levels[e];if(this.canLoad&&r&&r.url.length>0){var i=r.urlId,n=r.url[i];if(t)try{n=t.addDirectives(n)}catch(t){this.warn("Could not construct new URL with HLS Delivery Directives: "+t)}this.log("Attempt loading level index "+e+(t?" at sn "+t.msn+" part "+t.part:"")+" with URL-id "+i+" "+n),this.clearTimer(),this.hls.trigger(s.a.LEVEL_LOADING,{url:n,level:e,id:i,deliveryDirectives:t||null})}},u.removeLevel=function(t,e){var r=function(t,r){return r!==e},i=this._levels.filter((function(i,n){return n!==t||i.url.length>1&&void 0!==e&&(i.url=i.url.filter(r),i.audioGroupIds&&(i.audioGroupIds=i.audioGroupIds.filter(r)),i.textGroupIds&&(i.textGroupIds=i.textGroupIds.filter(r)),i.urlId=0,!0)})).map((function(t,e){var r=t.details;return null!=r&&r.fragments&&r.fragments.forEach((function(t){t.level=e})),t}));this._levels=i,this.hls.trigger(s.a.LEVELS_UPDATED,{levels:i})},n=i,(a=[{key:"levels",get:function(){return 0===this._levels.length?null:this._levels}},{key:"level",get:function(){return this.currentLevelIndex},set:function(t){var e,r=this._levels;if(0!==r.length&&(this.currentLevelIndex!==t||null===(e=r[t])||void 0===e||!e.details)){if(t<0||t>=r.length){var i=t<0;if(this.hls.trigger(s.a.ERROR,{type:o.b.OTHER_ERROR,details:o.a.LEVEL_SWITCH_ERROR,level:t,fatal:i,reason:"invalid level idx"}),i)return;t=Math.min(t,r.length-1)}this.clearTimer();var n=this.currentLevelIndex,a=r[n],l=r[t];this.log("switching to level "+t+" from "+n),this.currentLevelIndex=t;var u=st({},l,{level:t,maxBitrate:l.maxBitrate,uri:l.uri,urlId:l.urlId});delete u._urlId,this.hls.trigger(s.a.LEVEL_SWITCHING,u);var h=l.details;if(!h||h.live){var d=this.switchParams(l.uri,null==a?void 0:a.details);this.loadPlaylist(d)}}}},{key:"manualLevel",get:function(){return this.manualLevelIndex},set:function(t){this.manualLevelIndex=t,void 0===this._startLevel&&(this._startLevel=t),-1!==t&&(this.level=t)}},{key:"firstLevel",get:function(){return this._firstLevel},set:function(t){this._firstLevel=t}},{key:"startLevel",get:function(){if(void 0===this._startLevel){var t=this.hls.config.startLevel;return void 0!==t?t:this._firstLevel}return this._startLevel},set:function(t){this._startLevel=t}},{key:"nextLoadLevel",get:function(){return-1!==this.manualLevelIndex?this.manualLevelIndex:this.hls.nextAutoLevel},set:function(t){this.level=t,-1===this.manualLevelIndex&&(this.hls.nextAutoLevel=t)}}])&&ot(n.prototype,a),l&&ot(n,l),Object.defineProperty(n,"prototype",{writable:!1}),i}(at);!function(t){t.NOT_LOADED="NOT_LOADED",t.APPENDING="APPENDING",t.PARTIAL="PARTIAL",t.OK="OK"}(ut||(ut={}));var ct=function(){function t(t){this.activeFragment=null,this.activeParts=null,this.fragments=Object.create(null),this.timeRanges=Object.create(null),this.bufferPadding=.2,this.hls=void 0,this.hls=t,this._registerListeners()}var e=t.prototype;return e._registerListeners=function(){var t=this.hls;t.on(s.a.BUFFER_APPENDED,this.onBufferAppended,this),t.on(s.a.FRAG_BUFFERED,this.onFragBuffered,this),t.on(s.a.FRAG_LOADED,this.onFragLoaded,this)},e._unregisterListeners=function(){var t=this.hls;t.off(s.a.BUFFER_APPENDED,this.onBufferAppended,this),t.off(s.a.FRAG_BUFFERED,this.onFragBuffered,this),t.off(s.a.FRAG_LOADED,this.onFragLoaded,this)},e.destroy=function(){this._unregisterListeners(),this.fragments=this.timeRanges=null},e.getAppendedFrag=function(t,e){if(e===C.b.MAIN){var r=this.activeFragment,i=this.activeParts;if(!r)return null;if(i)for(var n=i.length;n--;){var a=i[n],s=a?a.end:r.appendedPTS;if(a.start<=t&&void 0!==s&&t<=s)return n>9&&(this.activeParts=i.slice(n-9)),a}else if(r.start<=t&&void 0!==r.appendedPTS&&t<=r.appendedPTS)return r}return this.getBufferedFrag(t,e)},e.getBufferedFrag=function(t,e){for(var r=this.fragments,i=Object.keys(r),n=i.length;n--;){var a=r[i[n]];if((null==a?void 0:a.body.type)===e&&a.buffered){var s=a.body;if(s.start<=t&&t<=s.end)return s}}return null},e.detectEvictedFragments=function(t,e,r){var i=this;Object.keys(this.fragments).forEach((function(n){var a=i.fragments[n];if(a)if(a.buffered){var s=a.range[t];s&&s.time.some((function(t){var r=!i.isTimeBuffered(t.startPTS,t.endPTS,e);return r&&i.removeFragment(a.body),r}))}else a.body.type===r&&i.removeFragment(a.body)}))},e.detectPartialFragments=function(t){var e=this,r=this.timeRanges,i=t.frag,n=t.part;if(r&&"initSegment"!==i.sn){var a=gt(i),s=this.fragments[a];s&&(Object.keys(r).forEach((function(t){var a=i.elementaryStreams[t];if(a){var o=r[t],l=null!==n||!0===a.partial;s.range[t]=e.getBufferedTimes(i,n,l,o)}})),s.loaded=null,Object.keys(s.range).length?s.buffered=!0:this.removeFragment(s.body))}},e.fragBuffered=function(t){var e=gt(t),r=this.fragments[e];r&&(r.loaded=null,r.buffered=!0)},e.getBufferedTimes=function(t,e,r,i){for(var n={time:[],partial:r},a=e?e.start:t.start,s=e?e.end:t.end,o=t.minEndPTS||s,l=t.maxStartPTS||a,u=0;u<i.length;u++){var h=i.start(u)-this.bufferPadding,d=i.end(u)+this.bufferPadding;if(l>=h&&o<=d){n.time.push({startPTS:Math.max(a,i.start(u)),endPTS:Math.min(s,i.end(u))});break}if(a<d&&s>h)n.partial=!0,n.time.push({startPTS:Math.max(a,i.start(u)),endPTS:Math.min(s,i.end(u))});else if(s<=h)break}return n},e.getPartialFragment=function(t){var e,r,i,n=null,a=0,s=this.bufferPadding,o=this.fragments;return Object.keys(o).forEach((function(l){var u=o[l];u&&ft(u)&&(r=u.body.start-s,i=u.body.end+s,t>=r&&t<=i&&(e=Math.min(t-r,i-t),a<=e&&(n=u.body,a=e)))})),n},e.getState=function(t){var e=gt(t),r=this.fragments[e];return r?r.buffered?ft(r)?ut.PARTIAL:ut.OK:ut.APPENDING:ut.NOT_LOADED},e.isTimeBuffered=function(t,e,r){for(var i,n,a=0;a<r.length;a++){if(i=r.start(a)-this.bufferPadding,n=r.end(a)+this.bufferPadding,t>=i&&e<=n)return!0;if(e<=i)return!1}return!1},e.onFragLoaded=function(t,e){var r=e.frag,i=e.part;if("initSegment"!==r.sn&&!r.bitrateTest&&!i){var n=gt(r);this.fragments[n]={body:r,loaded:e,buffered:!1,range:Object.create(null)}}},e.onBufferAppended=function(t,e){var r=this,i=e.frag,n=e.part,a=e.timeRanges;if(i.type===C.b.MAIN)if(this.activeFragment=i,n){var s=this.activeParts;s||(this.activeParts=s=[]),s.push(n)}else this.activeParts=null;this.timeRanges=a,Object.keys(a).forEach((function(t){var e=a[t];if(r.detectEvictedFragments(t,e),!n)for(var s=0;s<e.length;s++)i.appendedPTS=Math.max(e.end(s),i.appendedPTS||0)}))},e.onFragBuffered=function(t,e){this.detectPartialFragments(e)},e.hasFragment=function(t){var e=gt(t);return!!this.fragments[e]},e.removeFragmentsInRange=function(t,e,r){var i=this;Object.keys(this.fragments).forEach((function(n){var a=i.fragments[n];if(a&&a.buffered){var s=a.body;s.type===r&&s.start<e&&s.end>t&&i.removeFragment(s)}}))},e.removeFragment=function(t){var e=gt(t);t.stats.loaded=0,t.clearElementaryStreamInfo(),delete this.fragments[e]},e.removeAllFragments=function(){this.fragments=Object.create(null),this.activeFragment=null,this.activeParts=null},t}();function ft(t){var e,r;return t.buffered&&((null===(e=t.range.video)||void 0===e?void 0:e.partial)||(null===(r=t.range.audio)||void 0===r?void 0:r.partial))}function gt(t){return t.type+"_"+t.level+"_"+t.urlId+"_"+t.sn}var vt=function(){function t(){this._boundTick=void 0,this._tickTimer=null,this._tickInterval=null,this._tickCallCount=0,this._boundTick=this.tick.bind(this)}var e=t.prototype;return e.destroy=function(){this.onHandlerDestroying(),this.onHandlerDestroyed()},e.onHandlerDestroying=function(){this.clearNextTick(),this.clearInterval()},e.onHandlerDestroyed=function(){},e.hasInterval=function(){return!!this._tickInterval},e.hasNextTick=function(){return!!this._tickTimer},e.setInterval=function(t){return!this._tickInterval&&(this._tickInterval=self.setInterval(this._boundTick,t),!0)},e.clearInterval=function(){return!!this._tickInterval&&(self.clearInterval(this._tickInterval),this._tickInterval=null,!0)},e.clearNextTick=function(){return!!this._tickTimer&&(self.clearTimeout(this._tickTimer),this._tickTimer=null,!0)},e.tick=function(){this._tickCallCount++,1===this._tickCallCount&&(this.doTick(),this._tickCallCount>1&&this.tickImmediate(),this._tickCallCount=0)},e.tickImmediate=function(){this.clearNextTick(),this._tickTimer=self.setTimeout(this._boundTick,0)},e.doTick=function(){},t}(),pt={length:0,start:function(){return 0},end:function(){return 0}},mt=function(){function t(){}return t.isBuffered=function(e,r){try{if(e)for(var i=t.getBuffered(e),n=0;n<i.length;n++)if(r>=i.start(n)&&r<=i.end(n))return!0}catch(t){}return!1},t.bufferInfo=function(e,r,i){try{if(e){var n,a=t.getBuffered(e),s=[];for(n=0;n<a.length;n++)s.push({start:a.start(n),end:a.end(n)});return this.bufferedInfo(s,r,i)}}catch(t){}return{len:0,start:r,end:r,nextStart:void 0}},t.bufferedInfo=function(t,e,r){e=Math.max(0,e),t.sort((function(t,e){var r=t.start-e.start;return r||e.end-t.end}));var i=[];if(r)for(var n=0;n<t.length;n++){var a=i.length;if(a){var s=i[a-1].end;t[n].start-s<r?t[n].end>s&&(i[a-1].end=t[n].end):i.push(t[n])}else i.push(t[n])}else i=t;for(var o,l=0,u=e,h=e,d=0;d<i.length;d++){var c=i[d].start,f=i[d].end;if(e+r>=c&&e<f)u=c,l=(h=f)-e;else if(e+r<c){o=c;break}}return{len:l,start:u||0,end:h||0,nextStart:o}},t.getBuffered=function(t){try{return t.buffered}catch(t){return l.b.log("failed to get media.buffered",t),pt}},t}(),yt=function(t,e,r,i,n,a){void 0===i&&(i=0),void 0===n&&(n=-1),void 0===a&&(a=!1),this.level=void 0,this.sn=void 0,this.part=void 0,this.id=void 0,this.size=void 0,this.partial=void 0,this.transmuxing={start:0,executeStart:0,executeEnd:0,end:0},this.buffering={audio:{start:0,executeStart:0,executeEnd:0,end:0},video:{start:0,executeStart:0,executeEnd:0,end:0},audiovideo:{start:0,executeStart:0,executeEnd:0,end:0}},this.level=t,this.sn=e,this.id=r,this.size=i,this.part=n,this.partial=a};function Tt(t,e){if(t){var r=t.start+e;t.start=t.startPTS=r,t.endPTS=r+t.duration}}function bt(t,e){for(var r=e.fragments,i=0,n=r.length;i<n;i++)Tt(r[i],t);e.fragmentHint&&Tt(e.fragmentHint,t),e.alignedSliding=!0}function Et(t,e,r){e&&(!function(t,e,r){if(function(t,e,r){return!(!e.details||!(r.endCC>r.startCC||t&&t.cc<r.startCC))}(t,r,e)){var i=function(t,e){var r=t.fragments,i=e.fragments;if(i.length&&r.length){var n=function(t,e){for(var r=null,i=0,n=t.length;i<n;i++){var a=t[i];if(a&&a.cc===e){r=a;break}}return r}(r,i[0].cc);if(n&&(!n||n.startPTS))return n;l.b.log("No frag in previous level to align on")}else l.b.log("No fragments to align")}(r.details,e);i&&Object(a.a)(i.start)&&(l.b.log("Adjusting PTS using last level due to CC increase within current level "+e.url),bt(i.start,e))}}(t,r,e),!r.alignedSliding&&e.details&&function(t,e){if(!e.fragments.length||!t.hasProgramDateTime||!e.hasProgramDateTime)return;var r=e.fragments[0].programDateTime,i=t.fragments[0].programDateTime,n=(i-r)/1e3+e.fragments[0].start;n&&Object(a.a)(n)&&(l.b.log("Adjusting PTS using programDateTime delta "+(i-r)+"ms, sliding:"+n.toFixed(3)+" "+t.url+" "),bt(n,t))}(r,e.details),r.alignedSliding||!e.details||r.skippedSegments||it(e.details,r))}function St(t,e){var r=t.programDateTime;if(r){var i=(r-e)/1e3;t.start=t.startPTS=i,t.endPTS=i+t.duration}}function Lt(t,e){if(e.fragments.length&&t.hasProgramDateTime&&e.hasProgramDateTime){var r=e.fragments[0].programDateTime-1e3*e.fragments[0].start;t.fragments.forEach((function(t){St(t,r)})),t.fragmentHint&&St(t.fragmentHint,r),t.alignedSliding=!0}}var At={search:function(t,e){for(var r=0,i=t.length-1,n=null,a=null;r<=i;){var s=e(a=t[n=(r+i)/2|0]);if(s>0)r=n+1;else{if(!(s<0))return a;i=n-1}}return null}};function Dt(t,e,r,i){void 0===r&&(r=0),void 0===i&&(i=0);var n=null;if(t?n=e[t.sn-e[0].sn+1]||null:0===r&&0===e[0].start&&(n=e[0]),n&&0===Rt(r,i,n))return n;var a=At.search(e,Rt.bind(null,r,i));return a||n}function Rt(t,e,r){void 0===t&&(t=0),void 0===e&&(e=0);var i=Math.min(e,r.duration+(r.deltaPTS?r.deltaPTS:0));return r.start+r.duration-i<=t?1:r.start-i>t&&r.start?-1:0}function kt(t,e,r){var i=1e3*Math.min(e,r.duration+(r.deltaPTS?r.deltaPTS:0));return(r.endProgramDateTime||0)-i>t}function _t(t){var e="function"==typeof Map?new Map:void 0;return(_t=function(t){if(null===t||(r=t,-1===Function.toString.call(r).indexOf("[native code]")))return t;var r;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==e){if(e.has(t))return e.get(t);e.set(t,i)}function i(){return It(t,arguments,Ct(this).constructor)}return i.prototype=Object.create(t.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),wt(i,t)})(t)}function It(t,e,r){return(It=Ot()?Reflect.construct.bind():function(t,e,r){var i=[null];i.push.apply(i,e);var n=new(Function.bind.apply(t,i));return r&&wt(n,r.prototype),n}).apply(null,arguments)}function Ot(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}function wt(t,e){return(wt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ct(t){return(Ct=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var xt=Math.pow(2,17),Pt=function(){function t(t){this.config=void 0,this.loader=null,this.partLoadTimeout=-1,this.config=t}var e=t.prototype;return e.destroy=function(){this.loader&&(this.loader.destroy(),this.loader=null)},e.abort=function(){this.loader&&this.loader.abort()},e.load=function(t,e){var r=this,i=t.url;if(!i)return Promise.reject(new Ft({type:o.b.NETWORK_ERROR,details:o.a.FRAG_LOAD_ERROR,fatal:!1,frag:t,networkDetails:null},"Fragment does not have a "+(i?"part list":"url")));this.abort();var n=this.config,a=n.fLoader,s=n.loader;return new Promise((function(i,l){r.loader&&r.loader.destroy();var u=r.loader=t.loader=a?new a(n):new s(n),h=Mt(t),d={timeout:n.fragLoadingTimeOut,maxRetry:0,retryDelay:0,maxRetryDelay:n.fragLoadingMaxRetryTimeout,highWaterMark:"initSegment"===t.sn?1/0:xt};t.stats=u.stats,u.load(h,d,{onSuccess:function(e,n,a,s){r.resetLoader(t,u),i({frag:t,part:null,payload:e.data,networkDetails:s})},onError:function(e,i,n){r.resetLoader(t,u),l(new Ft({type:o.b.NETWORK_ERROR,details:o.a.FRAG_LOAD_ERROR,fatal:!1,frag:t,response:e,networkDetails:n}))},onAbort:function(e,i,n){r.resetLoader(t,u),l(new Ft({type:o.b.NETWORK_ERROR,details:o.a.INTERNAL_ABORTED,fatal:!1,frag:t,networkDetails:n}))},onTimeout:function(e,i,n){r.resetLoader(t,u),l(new Ft({type:o.b.NETWORK_ERROR,details:o.a.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t,networkDetails:n}))},onProgress:function(r,i,n,a){e&&e({frag:t,part:null,payload:n,networkDetails:a})}})}))},e.loadPart=function(t,e,r){var i=this;this.abort();var n=this.config,a=n.fLoader,s=n.loader;return new Promise((function(l,u){i.loader&&i.loader.destroy();var h=i.loader=t.loader=a?new a(n):new s(n),d=Mt(t,e),c={timeout:n.fragLoadingTimeOut,maxRetry:0,retryDelay:0,maxRetryDelay:n.fragLoadingMaxRetryTimeout,highWaterMark:xt};e.stats=h.stats,h.load(d,c,{onSuccess:function(n,a,s,o){i.resetLoader(t,h),i.updateStatsFromPart(t,e);var u={frag:t,part:e,payload:n.data,networkDetails:o};r(u),l(u)},onError:function(r,n,a){i.resetLoader(t,h),u(new Ft({type:o.b.NETWORK_ERROR,details:o.a.FRAG_LOAD_ERROR,fatal:!1,frag:t,part:e,response:r,networkDetails:a}))},onAbort:function(r,n,a){t.stats.aborted=e.stats.aborted,i.resetLoader(t,h),u(new Ft({type:o.b.NETWORK_ERROR,details:o.a.INTERNAL_ABORTED,fatal:!1,frag:t,part:e,networkDetails:a}))},onTimeout:function(r,n,a){i.resetLoader(t,h),u(new Ft({type:o.b.NETWORK_ERROR,details:o.a.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t,part:e,networkDetails:a}))}})}))},e.updateStatsFromPart=function(t,e){var r=t.stats,i=e.stats,n=i.total;if(r.loaded+=i.loaded,n){var a=Math.round(t.duration/e.duration),s=Math.min(Math.round(r.loaded/n),a),o=(a-s)*Math.round(r.loaded/s);r.total=r.loaded+o}else r.total=Math.max(r.loaded,r.total);var l=r.loading,u=i.loading;l.start?l.first+=u.first-u.start:(l.start=u.start,l.first=u.first),l.end=u.end},e.resetLoader=function(t,e){t.loader=null,this.loader===e&&(self.clearTimeout(this.partLoadTimeout),this.loader=null),e.destroy()},t}();function Mt(t,e){void 0===e&&(e=null);var r=e||t,i={frag:t,part:e,responseType:"arraybuffer",url:r.url,headers:{},rangeStart:0,rangeEnd:0},n=r.byteRangeStartOffset,s=r.byteRangeEndOffset;return Object(a.a)(n)&&Object(a.a)(s)&&(i.rangeStart=n,i.rangeEnd=s),i}var Ft=function(t){var e,r;function i(e){for(var r,i=arguments.length,n=new Array(i>1?i-1:0),a=1;a<i;a++)n[a-1]=arguments[a];return(r=t.call.apply(t,[this].concat(n))||this).data=void 0,r.data=e,r}return r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,wt(e,r),i}(_t(Error)),Nt=r(17),Ut={toString:function(t){for(var e="",r=t.length,i=0;i<r;i++)e+="["+t.start(i).toFixed(3)+","+t.end(i).toFixed(3)+"]";return e}};function Bt(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Gt(t,e){return(Gt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var jt="STOPPED",Kt="IDLE",Ht="KEY_LOADING",Vt="FRAG_LOADING",Wt="FRAG_LOADING_WAITING_RETRY",Yt="WAITING_TRACK",qt="PARSING",zt="PARSED",Xt="ENDED",Qt="ERROR",$t="WAITING_INIT_PTS",Jt="WAITING_LEVEL",Zt=function(t){var e,r;function i(e,r,i){var n;return(n=t.call(this)||this).hls=void 0,n.fragPrevious=null,n.fragCurrent=null,n.fragmentTracker=void 0,n.transmuxer=null,n._state=jt,n.media=void 0,n.mediaBuffer=void 0,n.config=void 0,n.bitrateTest=!1,n.lastCurrentTime=0,n.nextLoadPosition=0,n.startPosition=0,n.loadedmetadata=!1,n.fragLoadError=0,n.retryDate=0,n.levels=null,n.fragmentLoader=void 0,n.levelLastLoaded=null,n.startFragRequested=!1,n.decrypter=void 0,n.initPTS=[],n.onvseeking=null,n.onvended=null,n.logPrefix="",n.log=void 0,n.warn=void 0,n.logPrefix=i,n.log=l.b.log.bind(l.b,i+":"),n.warn=l.b.warn.bind(l.b,i+":"),n.hls=e,n.fragmentLoader=new Pt(e.config),n.fragmentTracker=r,n.config=e.config,n.decrypter=new Nt.a(e,e.config),e.on(s.a.KEY_LOADED,n.onKeyLoaded,function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(n)),n}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,Gt(e,r);var n,h,d,c=i.prototype;return c.doTick=function(){this.onTickEnd()},c.onTickEnd=function(){},c.startLoad=function(t){},c.stopLoad=function(){this.fragmentLoader.abort();var t=this.fragCurrent;t&&this.fragmentTracker.removeFragment(t),this.resetTransmuxer(),this.fragCurrent=null,this.fragPrevious=null,this.clearInterval(),this.clearNextTick(),this.state=jt},c._streamEnded=function(t,e){var r=this.fragCurrent,i=this.fragmentTracker;if(!e.live&&r&&r.sn>=e.endSN&&!t.nextStart){var n=e.partList;if(null!=n&&n.length){var a=n[n.length-1];return mt.isBuffered(this.media,a.start+a.duration/2)}var s=i.getState(r);return s===ut.PARTIAL||s===ut.OK}return!1},c.onMediaAttached=function(t,e){var r=this.media=this.mediaBuffer=e.media;this.onvseeking=this.onMediaSeeking.bind(this),this.onvended=this.onMediaEnded.bind(this),r.addEventListener("seeking",this.onvseeking),r.addEventListener("ended",this.onvended);var i=this.config;this.levels&&i.autoStartLoad&&this.state===jt&&this.startLoad(i.startPosition)},c.onMediaDetaching=function(){var t=this.media;null!=t&&t.ended&&(this.log("MSE detaching and video ended, reset startPosition"),this.startPosition=this.lastCurrentTime=0),t&&(t.removeEventListener("seeking",this.onvseeking),t.removeEventListener("ended",this.onvended),this.onvseeking=this.onvended=null),this.media=this.mediaBuffer=null,this.loadedmetadata=!1,this.fragmentTracker.removeAllFragments(),this.stopLoad()},c.onMediaSeeking=function(){var t=this.config,e=this.fragCurrent,r=this.media,i=this.mediaBuffer,n=this.state,s=r?r.currentTime:0,o=mt.bufferInfo(i||r,s,t.maxBufferHole);if(this.log("media seeking to "+(Object(a.a)(s)?s.toFixed(3):s)+", state: "+n),n===Xt)this.resetLoadingState();else if(e&&!o.len){var l=t.maxFragLookUpTolerance,u=e.start-l,h=s>e.start+e.duration+l;(s<u||h)&&(h&&e.loader&&(this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"),e.loader.abort()),this.resetLoadingState())}r&&(this.lastCurrentTime=s),this.loadedmetadata||o.len||(this.nextLoadPosition=this.startPosition=s),this.tickImmediate()},c.onMediaEnded=function(){this.startPosition=this.lastCurrentTime=0},c.onKeyLoaded=function(t,e){if(this.state===Ht&&e.frag===this.fragCurrent&&this.levels){this.state=Kt;var r=this.levels[e.frag.level].details;r&&this.loadFragment(e.frag,r,e.frag.start)}},c.onHandlerDestroying=function(){this.stopLoad(),t.prototype.onHandlerDestroying.call(this)},c.onHandlerDestroyed=function(){this.state=jt,this.hls.off(s.a.KEY_LOADED,this.onKeyLoaded,this),this.fragmentLoader&&this.fragmentLoader.destroy(),this.decrypter&&this.decrypter.destroy(),this.hls=this.log=this.warn=this.decrypter=this.fragmentLoader=this.fragmentTracker=null,t.prototype.onHandlerDestroyed.call(this)},c.loadKey=function(t,e){this.log("Loading key for "+t.sn+" of ["+e.startSN+"-"+e.endSN+"], "+("[stream-controller]"===this.logPrefix?"level":"track")+" "+t.level),this.state=Ht,this.fragCurrent=t,this.hls.trigger(s.a.KEY_LOADING,{frag:t})},c.loadFragment=function(t,e,r){this._loadFragForPlayback(t,e,r)},c._loadFragForPlayback=function(t,e,r){var i=this;this._doFragLoad(t,e,r,(function(e){if(i.fragContextChanged(t))return i.warn("Fragment "+t.sn+(e.part?" p: "+e.part.index:"")+" of level "+t.level+" was dropped during download."),void i.fragmentTracker.removeFragment(t);t.stats.chunkCount++,i._handleFragmentLoadProgress(e)})).then((function(e){if(e){i.fragLoadError=0;var r=i.state;i.fragContextChanged(t)?(r===Vt||!i.fragCurrent&&r===qt)&&(i.fragmentTracker.removeFragment(t),i.state=Kt):("payload"in e&&(i.log("Loaded fragment "+t.sn+" of level "+t.level),i.hls.trigger(s.a.FRAG_LOADED,e)),i._handleFragmentLoadComplete(e))}})).catch((function(e){i.state!==jt&&(i.warn(e),i.resetFragmentLoading(t))}))},c.flushMainBuffer=function(t,e,r){if(void 0===r&&(r=null),t-e){var i={startOffset:t,endOffset:e,type:r};this.fragLoadError=0,this.hls.trigger(s.a.BUFFER_FLUSHING,i)}},c._loadInitSegment=function(t){var e=this;this._doFragLoad(t).then((function(r){if(!r||e.fragContextChanged(t)||!e.levels)throw new Error("init load aborted");return r})).then((function(r){var i=e.hls,n=r.payload,a=t.decryptdata;if(n&&n.byteLength>0&&a&&a.key&&a.iv&&"AES-128"===a.method){var o=self.performance.now();return e.decrypter.webCryptoDecrypt(new Uint8Array(n),a.key.buffer,a.iv.buffer).then((function(e){var n=self.performance.now();return i.trigger(s.a.FRAG_DECRYPTED,{frag:t,payload:e,stats:{tstart:o,tdecrypt:n}}),r.payload=e,r}))}return r})).then((function(r){var i=e.fragCurrent,n=e.hls,a=e.levels;if(!a)throw new Error("init load aborted, missing levels");a[t.level].details;var o=t.stats;e.state=Kt,e.fragLoadError=0,t.data=new Uint8Array(r.payload),o.parsing.start=o.buffering.start=self.performance.now(),o.parsing.end=o.buffering.end=self.performance.now(),r.frag===i&&n.trigger(s.a.FRAG_BUFFERED,{stats:o,frag:i,part:null,id:t.type}),e.tick()})).catch((function(r){e.warn(r),e.resetFragmentLoading(t)}))},c.fragContextChanged=function(t){var e=this.fragCurrent;return!t||!e||t.level!==e.level||t.sn!==e.sn||t.urlId!==e.urlId},c.fragBufferedComplete=function(t,e){var r=this.mediaBuffer?this.mediaBuffer:this.media;this.log("Buffered "+t.type+" sn: "+t.sn+(e?" part: "+e.index:"")+" of "+("[stream-controller]"===this.logPrefix?"level":"track")+" "+t.level+" "+Ut.toString(mt.getBuffered(r))),this.state=Kt,this.tick()},c._handleFragmentLoadComplete=function(t){var e=this.transmuxer;if(e){var r=t.frag,i=t.part,n=t.partsLoaded,a=!n||0===n.length||n.some((function(t){return!t})),s=new yt(r.level,r.sn,r.stats.chunkCount+1,0,i?i.index:-1,!a);e.flush(s)}},c._handleFragmentLoadProgress=function(t){},c._doFragLoad=function(t,e,r,i){var n=this;if(void 0===r&&(r=null),!this.levels)throw new Error("frag load aborted, missing levels");if(r=Math.max(t.start,r||0),this.config.lowLatencyMode&&e){var o=e.partList;if(o&&i){r>t.end&&e.fragmentHint&&(t=e.fragmentHint);var l=this.getNextPart(o,t,r);if(l>-1){var u=o[l];return this.log("Loading part sn: "+t.sn+" p: "+u.index+" cc: "+t.cc+" of playlist ["+e.startSN+"-"+e.endSN+"] parts [0-"+l+"-"+(o.length-1)+"] "+("[stream-controller]"===this.logPrefix?"level":"track")+": "+t.level+", target: "+parseFloat(r.toFixed(3))),this.nextLoadPosition=u.start+u.duration,this.state=Vt,this.hls.trigger(s.a.FRAG_LOADING,{frag:t,part:o[l],targetBufferTime:r}),this.doFragPartsLoad(t,o,l,i).catch((function(t){return n.handleFragLoadError(t)}))}if(!t.url||this.loadedEndOfParts(o,r))return Promise.resolve(null)}}return this.log("Loading fragment "+t.sn+" cc: "+t.cc+" "+(e?"of ["+e.startSN+"-"+e.endSN+"] ":"")+("[stream-controller]"===this.logPrefix?"level":"track")+": "+t.level+", target: "+parseFloat(r.toFixed(3))),Object(a.a)(t.sn)&&!this.bitrateTest&&(this.nextLoadPosition=t.start+t.duration),this.state=Vt,this.hls.trigger(s.a.FRAG_LOADING,{frag:t,targetBufferTime:r}),this.fragmentLoader.load(t,i).catch((function(t){return n.handleFragLoadError(t)}))},c.doFragPartsLoad=function(t,e,r,i){var n=this;return new Promise((function(a,o){var l=[];!function r(u){var h=e[u];n.fragmentLoader.loadPart(t,h,i).then((function(i){l[h.index]=i;var o=i.part;n.hls.trigger(s.a.FRAG_LOADED,i);var d=e[u+1];if(!d||d.fragment!==t)return a({frag:t,part:o,partsLoaded:l});r(u+1)})).catch(o)}(r)}))},c.handleFragLoadError=function(t){var e=t.data;return e&&e.details===o.a.INTERNAL_ABORTED?this.handleFragLoadAborted(e.frag,e.part):this.hls.trigger(s.a.ERROR,e),null},c._handleTransmuxerFlush=function(t){var e=this.getCurrentContext(t);if(e&&this.state===qt){var r=e.frag,i=e.part,n=e.level,a=self.performance.now();r.stats.parsing.end=a,i&&(i.stats.parsing.end=a),this.updateLevelTiming(r,i,n,t.partial)}else this.fragCurrent||(this.state=Kt)},c.getCurrentContext=function(t){var e=this.levels,r=t.level,i=t.sn,n=t.part;if(!e||!e[r])return this.warn("Levels object was unset while buffering fragment "+i+" of level "+r+". The current chunk will not be buffered."),null;var a=e[r],s=n>-1?function(t,e,r){if(!t||!t.details)return null;var i=t.details.partList;if(i)for(var n=i.length;n--;){var a=i[n];if(a.index===r&&a.fragment.sn===e)return a}return null}(a,i,n):null,o=s?s.fragment:function(t,e,r){if(!t||!t.details)return null;var i=t.details,n=i.fragments[e-i.startSN];return n||((n=i.fragmentHint)&&n.sn===e?n:e<i.startSN&&r&&r.sn===e?r:null)}(a,i,this.fragCurrent);return o?{frag:o,part:s,level:a}:null},c.bufferFragmentData=function(t,e,r,i){if(t&&this.state===qt){var n=t.data1,a=t.data2,o=n;if(n&&a&&(o=Object(u.b)(n,a)),o&&o.length){var l={type:t.type,frag:e,part:r,chunkMeta:i,parent:e.type,data:o};this.hls.trigger(s.a.BUFFER_APPENDING,l),t.dropped&&t.independent&&!r&&this.flushBufferGap(e)}}},c.flushBufferGap=function(t){var e=this.media;if(e)if(mt.isBuffered(e,e.currentTime)){var r=e.currentTime,i=mt.bufferInfo(e,r,0),n=t.duration,a=Math.min(2*this.config.maxFragLookUpTolerance,.25*n),s=Math.max(Math.min(t.start-a,i.end-a),r+a);t.start-s>a&&this.flushMainBuffer(s,t.start)}else this.flushMainBuffer(0,t.start)},c.getFwdBufferInfo=function(t,e){var r=this.config,i=this.getLoadPosition();if(!Object(a.a)(i))return null;var n=mt.bufferInfo(t,i,r.maxBufferHole);if(0===n.len&&void 0!==n.nextStart){var s=this.fragmentTracker.getBufferedFrag(i,e);if(s&&n.nextStart<s.end)return mt.bufferInfo(t,i,Math.max(n.nextStart,r.maxBufferHole))}return n},c.getMaxBufferLength=function(t){var e,r=this.config;return e=t?Math.max(8*r.maxBufferSize/t,r.maxBufferLength):r.maxBufferLength,Math.min(e,r.maxMaxBufferLength)},c.reduceMaxBufferLength=function(t){var e=this.config,r=t||e.maxBufferLength;return e.maxMaxBufferLength>=r&&(e.maxMaxBufferLength/=2,this.warn("Reduce max buffer length to "+e.maxMaxBufferLength+"s"),!0)},c.getNextFragment=function(t,e){var r,i,n=e.fragments,a=n.length;if(!a)return null;var s,o=this.config,l=n[0].start;if(e.live){var u=o.initialLiveManifestSize;if(a<u)return this.warn("Not enough fragments to start playback (have: "+a+", need: "+u+")"),null;e.PTSKnown||this.startFragRequested||-1!==this.startPosition||(s=this.getInitialLiveFragment(e,n),this.startPosition=s?this.hls.liveSyncPosition||s.start:t)}else t<=l&&(s=n[0]);if(!s){var h=o.lowLatencyMode?e.partEnd:e.fragmentEnd;s=this.getFragmentAtPosition(t,h,e)}return null===(r=s)||void 0===r||!r.initSegment||null!==(i=s)&&void 0!==i&&i.initSegment.data||this.bitrateTest||(s=s.initSegment),s},c.getNextPart=function(t,e,r){for(var i=-1,n=!1,a=!0,s=0,o=t.length;s<o;s++){var l=t[s];if(a=a&&!l.independent,i>-1&&r<l.start)break;var u=l.loaded;!u&&(n||l.independent||a)&&l.fragment===e&&(i=s),n=u}return i},c.loadedEndOfParts=function(t,e){var r=t[t.length-1];return r&&e>r.start&&r.loaded},c.getInitialLiveFragment=function(t,e){var r=this.fragPrevious,i=null;if(r){if(t.hasProgramDateTime&&(this.log("Live playlist, switching playlist, load frag with same PDT: "+r.programDateTime),i=function(t,e,r){if(null===e||!Array.isArray(t)||!t.length||!Object(a.a)(e))return null;if(e<(t[0].programDateTime||0))return null;if(e>=(t[t.length-1].endProgramDateTime||0))return null;r=r||0;for(var i=0;i<t.length;++i){var n=t[i];if(kt(e,r,n))return n}return null}(e,r.endProgramDateTime,this.config.maxFragLookUpTolerance)),!i){var n=r.sn+1;if(n>=t.startSN&&n<=t.endSN){var s=e[n-t.startSN];r.cc===s.cc&&(i=s,this.log("Live playlist, switching playlist, load frag with next SN: "+i.sn))}i||(i=function(t,e){return At.search(t,(function(t){return t.cc<e?1:t.cc>e?-1:0}))}(e,r.cc))&&this.log("Live playlist, switching playlist, load frag with same CC: "+i.sn)}}else{var o=this.hls.liveSyncPosition;null!==o&&(i=this.getFragmentAtPosition(o,this.bitrateTest?t.fragmentEnd:t.edge,t))}return i},c.getFragmentAtPosition=function(t,e,r){var i,n=this.config,a=this.fragPrevious,s=r.fragments,o=r.endSN,l=r.fragmentHint,u=n.maxFragLookUpTolerance,h=!!(n.lowLatencyMode&&r.partList&&l);(h&&l&&!this.bitrateTest&&(s=s.concat(l),o=l.sn),t<e)?i=Dt(a,s,t,t>e-u?0:u):i=s[s.length-1];if(i){var d=i.sn-r.startSN,c=a&&i.level===a.level,f=s[d+1];a&&i.sn===a.sn&&!h&&c&&(i.sn<o&&this.fragmentTracker.getState(f)!==ut.OK?(this.log("SN "+i.sn+" just loaded, load next one: "+f.sn),i=f):i=null)}return i},c.synchronizeToLiveEdge=function(t){var e=this.config,r=this.media;if(r){var i=this.hls.liveSyncPosition,n=r.currentTime,a=t.fragments[0].start,s=t.edge,o=n>=a-e.maxFragLookUpTolerance&&n<=s;if(null!==i&&r.duration>i&&(n<i||!o)){var l=void 0!==e.liveMaxLatencyDuration?e.liveMaxLatencyDuration:e.liveMaxLatencyDurationCount*t.targetduration;(!o&&r.readyState<4||n<s-l)&&(this.loadedmetadata||(this.nextLoadPosition=i),r.readyState&&(this.warn("Playback: "+n.toFixed(3)+" is located too far from the end of live sliding playlist: "+s+", reset currentTime to : "+i.toFixed(3)),r.currentTime=i))}}},c.alignPlaylists=function(t,e){var r=this.levels,i=this.levelLastLoaded,n=this.fragPrevious,s=null!==i?r[i]:null,o=t.fragments.length;if(!o)return this.warn("No fragments in live playlist"),0;var l=t.fragments[0].start,u=!e,h=t.alignedSliding&&Object(a.a)(l);if(u||!h&&!l){Et(n,s,t);var d=t.fragments[0].start;return this.log("Live playlist sliding: "+d.toFixed(2)+" start-sn: "+(e?e.startSN:"na")+"->"+t.startSN+" prev-sn: "+(n?n.sn:"na")+" fragments: "+o),d}return l},c.waitForCdnTuneIn=function(t){return t.live&&t.canBlockReload&&t.partTarget&&t.tuneInGoal>Math.max(t.partHoldBack,3*t.partTarget)},c.setStartPosition=function(t,e){var r=this.startPosition;if(r<e&&(r=-1),-1===r||-1===this.lastCurrentTime){var i=t.startTimeOffset;Object(a.a)(i)?(r=e+i,i<0&&(r+=t.totalduration),r=Math.min(Math.max(e,r),e+t.totalduration),this.log("Start time offset "+i+" found in playlist, adjust startPosition to "+r),this.startPosition=r):t.live?r=this.hls.liveSyncPosition||e:this.startPosition=r=0,this.lastCurrentTime=r}this.nextLoadPosition=r},c.getLoadPosition=function(){var t=this.media,e=0;return this.loadedmetadata&&t?e=t.currentTime:this.nextLoadPosition&&(e=this.nextLoadPosition),e},c.handleFragLoadAborted=function(t,e){this.transmuxer&&"initSegment"!==t.sn&&t.stats.aborted&&(this.warn("Fragment "+t.sn+(e?" part"+e.index:"")+" of level "+t.level+" was aborted"),this.resetFragmentLoading(t))},c.resetFragmentLoading=function(t){this.fragCurrent&&this.fragContextChanged(t)||(this.state=Kt)},c.onFragmentOrKeyLoadError=function(t,e){if(!e.fatal){var r=e.frag;if(r&&r.type===t){this.fragCurrent;var i=this.config;if(this.fragLoadError+1<=i.fragLoadingMaxRetry){if(this.resetLiveStartWhenNotLoaded(r.level))return;var n=Math.min(Math.pow(2,this.fragLoadError)*i.fragLoadingRetryDelay,i.fragLoadingMaxRetryTimeout);this.warn("Fragment "+r.sn+" of "+t+" "+r.level+" failed to load, retrying in "+n+"ms"),this.retryDate=self.performance.now()+n,this.fragLoadError++,this.state=Wt}else e.levelRetry?(t===C.b.AUDIO&&(this.fragCurrent=null),this.fragLoadError=0,this.state=Kt):(l.b.error(e.details+" reaches max retry, redispatch as fatal ..."),e.fatal=!0,this.hls.stopLoad(),this.state=Qt)}}},c.afterBufferFlushed=function(t,e,r){if(t){var i=mt.getBuffered(t);this.fragmentTracker.detectEvictedFragments(e,i,r),this.state===Xt&&this.resetLoadingState()}},c.resetLoadingState=function(){this.fragCurrent=null,this.fragPrevious=null,this.state=Kt},c.resetLiveStartWhenNotLoaded=function(t){if(!this.loadedmetadata){this.startFragRequested=!1;var e=this.levels?this.levels[t].details:null;if(null!=e&&e.live)return this.startPosition=-1,this.setStartPosition(e,0),this.resetLoadingState(),!0;this.nextLoadPosition=this.startPosition}return!1},c.updateLevelTiming=function(t,e,r,i){var n=this,a=r.details;Object.keys(t.elementaryStreams).reduce((function(e,o){var l=t.elementaryStreams[o];if(l){var u=l.endPTS-l.startPTS;if(u<=0)return n.warn("Could not parse fragment "+t.sn+" "+o+" duration reliably ("+u+")"),e||!1;var h=i?0:et(a,t,l.startPTS,l.endPTS,l.startDTS,l.endDTS);return n.hls.trigger(s.a.LEVEL_PTS_UPDATED,{details:a,level:r,drift:h,type:o,frag:t,start:l.startPTS,end:l.endPTS}),!0}return e}),!1)||(this.warn("Found no media in fragment "+t.sn+" of level "+r.id+" resetting transmuxer to fallback to playlist timing"),this.resetTransmuxer()),this.state=zt,this.hls.trigger(s.a.FRAG_PARSED,{frag:t,part:e})},c.resetTransmuxer=function(){this.transmuxer&&(this.transmuxer.destroy(),this.transmuxer=null)},n=i,(h=[{key:"state",get:function(){return this._state},set:function(t){var e=this._state;e!==t&&(this._state=t,this.log(e+"->"+t))}}])&&Bt(n.prototype,h),d&&Bt(n,d),Object.defineProperty(n,"prototype",{writable:!1}),i}(vt);function te(){return self.MediaSource||self.WebKitMediaSource}function ee(){return self.SourceBuffer||self.WebKitSourceBuffer}var re=r(19),ie=r(11),ne=r(16),ae=te()||{isTypeSupported:function(){return!1}},se=function(){function t(t,e,r,i){var n=this;this.hls=void 0,this.id=void 0,this.observer=void 0,this.frag=null,this.part=null,this.worker=void 0,this.onwmsg=void 0,this.transmuxer=null,this.onTransmuxComplete=void 0,this.onFlush=void 0,this.hls=t,this.id=e,this.onTransmuxComplete=r,this.onFlush=i;var a=t.config,u=function(e,r){(r=r||{}).frag=n.frag,r.id=n.id,t.trigger(e,r)};this.observer=new ne.EventEmitter,this.observer.on(s.a.FRAG_DECRYPTED,u),this.observer.on(s.a.ERROR,u);var h={mp4:ae.isTypeSupported("video/mp4"),mpeg:ae.isTypeSupported("audio/mpeg"),mp3:ae.isTypeSupported('audio/mp4; codecs="mp3"')},d=navigator.vendor;if(a.enableWorker&&"undefined"!=typeof Worker){var c;l.b.log("demuxing in webworker");try{c=this.worker=re(20),this.onwmsg=this.onWorkerMessage.bind(this),c.addEventListener("message",this.onwmsg),c.onerror=function(e){t.trigger(s.a.ERROR,{type:o.b.OTHER_ERROR,details:o.a.INTERNAL_EXCEPTION,fatal:!0,event:"demuxerWorker",error:new Error(e.message+"  ("+e.filename+":"+e.lineno+")")})},c.postMessage({cmd:"init",typeSupported:h,vendor:d,id:e,config:JSON.stringify(a)})}catch(t){l.b.warn("Error in worker:",t),l.b.error("Error while initializing DemuxerWorker, fallback to inline"),c&&self.URL.revokeObjectURL(c.objectURL),this.transmuxer=new ie.c(this.observer,h,a,d,e),this.worker=null}}else this.transmuxer=new ie.c(this.observer,h,a,d,e)}var e=t.prototype;return e.destroy=function(){var t=this.worker;if(t)t.removeEventListener("message",this.onwmsg),t.terminate(),this.worker=null,this.onwmsg=void 0;else{var e=this.transmuxer;e&&(e.destroy(),this.transmuxer=null)}var r=this.observer;r&&r.removeAllListeners(),this.frag=null,this.observer=null,this.hls=null},e.push=function(t,e,r,i,n,a,s,o,u,h){var d,c,f=this;u.transmuxing.start=self.performance.now();var g=this.transmuxer,v=this.worker,p=a?a.start:n.start,m=n.decryptdata,y=this.frag,T=!(y&&n.cc===y.cc),b=!(y&&u.level===y.level),E=y?u.sn-y.sn:-1,S=this.part?u.part-this.part.index:-1,L=!b&&(1===E||0===E&&1===S),A=self.performance.now();(b||E||0===n.stats.parsing.start)&&(n.stats.parsing.start=A),!a||!S&&L||(a.stats.parsing.start=A);var D=!(y&&(null===(d=n.initSegment)||void 0===d?void 0:d.url)===(null===(c=y.initSegment)||void 0===c?void 0:c.url)),R=new ie.b(T,L,o,b,p,D);if(!L||T||D){l.b.log("[transmuxer-interface, "+n.type+"]: Starting new transmux session for sn: "+u.sn+" p: "+u.part+" level: "+u.level+" id: "+u.id+"\n        discontinuity: "+T+"\n        trackSwitch: "+b+"\n        contiguous: "+L+"\n        accurateTimeOffset: "+o+"\n        timeOffset: "+p+"\n        initSegmentChange: "+D);var k=new ie.a(r,i,e,s,h);this.configureTransmuxer(k)}if(this.frag=n,this.part=a,v)v.postMessage({cmd:"demux",data:t,decryptdata:m,chunkMeta:u,state:R},t instanceof ArrayBuffer?[t]:[]);else if(g){var _=g.push(t,m,u,R);Object(ie.d)(_)?_.then((function(t){f.handleTransmuxComplete(t)})):this.handleTransmuxComplete(_)}},e.flush=function(t){var e=this;t.transmuxing.start=self.performance.now();var r=this.transmuxer,i=this.worker;if(i)i.postMessage({cmd:"flush",chunkMeta:t});else if(r){var n=r.flush(t);Object(ie.d)(n)?n.then((function(r){e.handleFlushResult(r,t)})):this.handleFlushResult(n,t)}},e.handleFlushResult=function(t,e){var r=this;t.forEach((function(t){r.handleTransmuxComplete(t)})),this.onFlush(e)},e.onWorkerMessage=function(t){var e=t.data,r=this.hls;switch(e.event){case"init":self.URL.revokeObjectURL(this.worker.objectURL);break;case"transmuxComplete":this.handleTransmuxComplete(e.data);break;case"flush":this.onFlush(e.data);break;default:e.data=e.data||{},e.data.frag=this.frag,e.data.id=this.id,r.trigger(e.event,e.data)}},e.configureTransmuxer=function(t){var e=this.worker,r=this.transmuxer;e?e.postMessage({cmd:"configure",config:t}):r&&r.configure(t)},e.handleTransmuxComplete=function(t){t.chunkMeta.transmuxing.end=self.performance.now(),this.onTransmuxComplete(t)},t}(),oe=function(){function t(t,e,r,i){this.config=void 0,this.media=null,this.fragmentTracker=void 0,this.hls=void 0,this.nudgeRetry=0,this.stallReported=!1,this.stalled=null,this.moved=!1,this.seeking=!1,this.config=t,this.media=e,this.fragmentTracker=r,this.hls=i}var e=t.prototype;return e.destroy=function(){this.media=null,this.hls=this.fragmentTracker=null},e.poll=function(t,e){var r=this.config,i=this.media,n=this.stalled;if(null!==i){var a=i.currentTime,s=i.seeking,o=this.seeking&&!s,u=!this.seeking&&s;if(this.seeking=s,a===t){if((u||o)&&(this.stalled=null),!(i.paused&&!s||i.ended||0===i.playbackRate)&&mt.getBuffered(i).length){var h=mt.bufferInfo(i,a,0),d=h.len>0,c=h.nextStart||0;if(d||c){if(s){var f=h.len>2,g=!c||e&&e.start<=a||c-a>2&&!this.fragmentTracker.getPartialFragment(a);if(f||g)return;this.moved=!1}if(!this.moved&&null!==this.stalled){var v,p=Math.max(c,h.start||0)-a,m=this.hls.levels?this.hls.levels[this.hls.currentLevel]:null,y=(null==m||null===(v=m.details)||void 0===v?void 0:v.live)?2*m.details.targetduration:2;if(p>0&&p<=y)return void this._trySkipBufferHole(null)}var T=self.performance.now();if(null!==n){var b=T-n;if(s||!(b>=250)||(this._reportStall(h),this.media)){var E=mt.bufferInfo(i,a,r.maxBufferHole);this._tryFixBufferStall(E,b)}}else this.stalled=T}}}else if(this.moved=!0,null!==n){if(this.stallReported){var S=self.performance.now()-n;l.b.warn("playback not stuck anymore @"+a+", after "+Math.round(S)+"ms"),this.stallReported=!1}this.stalled=null,this.nudgeRetry=0}}},e._tryFixBufferStall=function(t,e){var r=this.config,i=this.fragmentTracker,n=this.media;if(null!==n){var a=n.currentTime,s=i.getPartialFragment(a);if(s)if(this._trySkipBufferHole(s)||!this.media)return;t.len>r.maxBufferHole&&e>1e3*r.highBufferWatchdogPeriod&&(l.b.warn("Trying to nudge playhead over buffer-hole"),this.stalled=null,this._tryNudgeBuffer())}},e._reportStall=function(t){var e=this.hls,r=this.media;!this.stallReported&&r&&(this.stallReported=!0,l.b.warn("Playback stalling at @"+r.currentTime+" due to low buffer ("+JSON.stringify(t)+")"),e.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_STALLED_ERROR,fatal:!1,buffer:t.len}))},e._trySkipBufferHole=function(t){var e=this.config,r=this.hls,i=this.media;if(null===i)return 0;for(var n=i.currentTime,a=0,u=mt.getBuffered(i),h=0;h<u.length;h++){var d=u.start(h);if(n+e.maxBufferHole>=a&&n<d){var c=Math.max(d+.05,i.currentTime+.1);return l.b.warn("skipping hole, adjusting currentTime from "+n+" to "+c),this.moved=!0,this.stalled=null,i.currentTime=c,t&&r.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_SEEK_OVER_HOLE,fatal:!1,reason:"fragment loaded with buffer holes, seeking from "+n+" to "+c,frag:t}),c}a=u.end(h)}return 0},e._tryNudgeBuffer=function(){var t=this.config,e=this.hls,r=this.media,i=this.nudgeRetry;if(null!==r){var n=r.currentTime;if(this.nudgeRetry++,i<t.nudgeMaxRetry){var a=n+(i+1)*t.nudgeOffset;l.b.warn("Nudging 'currentTime' from "+n+" to "+a),r.currentTime=a,e.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_NUDGE_ON_STALL,fatal:!1})}else l.b.error("Playhead still not moving while enough data buffered @"+n+" after "+t.nudgeMaxRetry+" nudges"),e.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_STALLED_ERROR,fatal:!0})}},t}();function le(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function ue(t,e){return(ue=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var he=function(t){var e,r;function i(e,r){var i;return(i=t.call(this,e,r,"[stream-controller]")||this).audioCodecSwap=!1,i.gapController=null,i.level=-1,i._forceStartLoad=!1,i.altAudio=!1,i.audioOnly=!1,i.fragPlaying=null,i.onvplaying=null,i.onvseeked=null,i.fragLastKbps=0,i.stalled=!1,i.couldBacktrack=!1,i.backtrackFragment=null,i.audioCodecSwitch=!1,i.videoBuffer=null,i._registerListeners(),i}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,ue(e,r);var n,u,h,d=i.prototype;return d._registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.on(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.on(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.on(s.a.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this),t.on(s.a.ERROR,this.onError,this),t.on(s.a.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.on(s.a.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.on(s.a.BUFFER_CREATED,this.onBufferCreated,this),t.on(s.a.BUFFER_FLUSHED,this.onBufferFlushed,this),t.on(s.a.LEVELS_UPDATED,this.onLevelsUpdated,this),t.on(s.a.FRAG_BUFFERED,this.onFragBuffered,this)},d._unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.off(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.off(s.a.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this),t.off(s.a.ERROR,this.onError,this),t.off(s.a.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.off(s.a.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.off(s.a.BUFFER_CREATED,this.onBufferCreated,this),t.off(s.a.BUFFER_FLUSHED,this.onBufferFlushed,this),t.off(s.a.LEVELS_UPDATED,this.onLevelsUpdated,this),t.off(s.a.FRAG_BUFFERED,this.onFragBuffered,this)},d.onHandlerDestroying=function(){this._unregisterListeners(),this.onMediaDetaching()},d.startLoad=function(t){if(this.levels){var e=this.lastCurrentTime,r=this.hls;if(this.stopLoad(),this.setInterval(100),this.level=-1,this.fragLoadError=0,!this.startFragRequested){var i=r.startLevel;-1===i&&(r.config.testBandwidth?(i=0,this.bitrateTest=!0):i=r.nextAutoLevel),this.level=r.nextLoadLevel=i,this.loadedmetadata=!1}e>0&&-1===t&&(this.log("Override startPosition with lastCurrentTime @"+e.toFixed(3)),t=e),this.state=Kt,this.nextLoadPosition=this.startPosition=this.lastCurrentTime=t,this.tick()}else this._forceStartLoad=!0,this.state=jt},d.stopLoad=function(){this._forceStartLoad=!1,t.prototype.stopLoad.call(this)},d.doTick=function(){switch(this.state){case Kt:this.doTickIdle();break;case Jt:var t,e=this.levels,r=this.level,i=null==e||null===(t=e[r])||void 0===t?void 0:t.details;if(i&&(!i.live||this.levelLastLoaded===this.level)){if(this.waitForCdnTuneIn(i))break;this.state=Kt;break}break;case Wt:var n,a=self.performance.now(),s=this.retryDate;(!s||a>=s||null!==(n=this.media)&&void 0!==n&&n.seeking)&&(this.log("retryDate reached, switch back to IDLE state"),this.state=Kt)}this.onTickEnd()},d.onTickEnd=function(){t.prototype.onTickEnd.call(this),this.checkBuffer(),this.checkFragmentChanged()},d.doTickIdle=function(){var t,e,r=this.hls,i=this.levelLastLoaded,n=this.levels,a=this.media,o=r.config,l=r.nextLoadLevel;if(null!==i&&(a||!this.startFragRequested&&o.startFragPrefetch)&&(!this.altAudio||!this.audioOnly)&&n&&n[l]){var u=n[l];this.level=r.nextLoadLevel=l;var h=u.details;if(!h||this.state===Jt||h.live&&this.levelLastLoaded!==l)this.state=Jt;else{var d=this.getMainFwdBufferInfo();if(null!==d)if(!(d.len>=this.getMaxBufferLength(u.maxBitrate))){if(this._streamEnded(d,h)){var c={};return this.altAudio&&(c.type="video"),this.hls.trigger(s.a.BUFFER_EOS,c),void(this.state=Xt)}this.backtrackFragment&&this.backtrackFragment.start>d.end&&(this.backtrackFragment=null);var f=this.backtrackFragment?this.backtrackFragment.start:d.end,g=this.getNextFragment(f,h);if(this.couldBacktrack&&!this.fragPrevious&&g&&"initSegment"!==g.sn&&this.fragmentTracker.getState(g)!==ut.OK){var v,m=(null!=(v=this.backtrackFragment)?v:g).sn-h.startSN,y=h.fragments[m-1];y&&g.cc===y.cc&&(g=y,this.fragmentTracker.removeFragment(y))}else this.backtrackFragment&&d.len&&(this.backtrackFragment=null);if(g&&this.fragmentTracker.getState(g)===ut.OK&&this.nextLoadPosition>f){var T=this.audioOnly&&!this.altAudio?p.a.AUDIO:p.a.VIDEO;this.afterBufferFlushed(a,T,C.b.MAIN),g=this.getNextFragment(this.nextLoadPosition,h)}g&&(!g.initSegment||g.initSegment.data||this.bitrateTest||(g=g.initSegment),"identity"!==(null===(t=g.decryptdata)||void 0===t?void 0:t.keyFormat)||null!==(e=g.decryptdata)&&void 0!==e&&e.key?this.loadFragment(g,h,f):this.loadKey(g,h))}}}},d.loadFragment=function(e,r,i){var n,a=this.fragmentTracker.getState(e);this.fragCurrent=e,a===ut.NOT_LOADED||a===ut.PARTIAL?"initSegment"===e.sn?this._loadInitSegment(e):this.bitrateTest?(e.bitrateTest=!0,this.log("Fragment "+e.sn+" of level "+e.level+" is being downloaded to test bitrate and will not be buffered"),this._loadBitrateTestFrag(e)):(this.startFragRequested=!0,t.prototype.loadFragment.call(this,e,r,i)):a===ut.APPENDING?this.reduceMaxBufferLength(e.duration)&&this.fragmentTracker.removeFragment(e):0===(null===(n=this.media)||void 0===n?void 0:n.buffered.length)&&this.fragmentTracker.removeAllFragments()},d.getAppendedFrag=function(t){var e=this.fragmentTracker.getAppendedFrag(t,C.b.MAIN);return e&&"fragment"in e?e.fragment:e},d.getBufferedFrag=function(t){return this.fragmentTracker.getBufferedFrag(t,C.b.MAIN)},d.followingBufferedFrag=function(t){return t?this.getBufferedFrag(t.end+.5):null},d.immediateLevelSwitch=function(){this.abortCurrentFrag(),this.flushMainBuffer(0,Number.POSITIVE_INFINITY)},d.nextLevelSwitch=function(){var t=this.levels,e=this.media;if(null!=e&&e.readyState){var r,i=this.getAppendedFrag(e.currentTime);if(i&&i.start>1&&this.flushMainBuffer(0,i.start-1),!e.paused&&t){var n=t[this.hls.nextLoadLevel],a=this.fragLastKbps;r=a&&this.fragCurrent?this.fragCurrent.duration*n.maxBitrate/(1e3*a)+1:0}else r=0;var s=this.getBufferedFrag(e.currentTime+r);if(s){var o=this.followingBufferedFrag(s);if(o){this.abortCurrentFrag();var l=o.maxStartPTS?o.maxStartPTS:o.start,u=o.duration,h=Math.max(s.end,l+Math.min(Math.max(u-this.config.maxFragLookUpTolerance,.5*u),.75*u));this.flushMainBuffer(h,Number.POSITIVE_INFINITY)}}}},d.abortCurrentFrag=function(){var t=this.fragCurrent;switch(this.fragCurrent=null,this.backtrackFragment=null,null!=t&&t.loader&&t.loader.abort(),this.state){case Ht:case Vt:case Wt:case qt:case zt:this.state=Kt}this.nextLoadPosition=this.getLoadPosition()},d.flushMainBuffer=function(e,r){t.prototype.flushMainBuffer.call(this,e,r,this.altAudio?"video":null)},d.onMediaAttached=function(e,r){t.prototype.onMediaAttached.call(this,e,r);var i=r.media;this.onvplaying=this.onMediaPlaying.bind(this),this.onvseeked=this.onMediaSeeked.bind(this),i.addEventListener("playing",this.onvplaying),i.addEventListener("seeked",this.onvseeked),this.gapController=new oe(this.config,i,this.fragmentTracker,this.hls)},d.onMediaDetaching=function(){var e=this.media;e&&(e.removeEventListener("playing",this.onvplaying),e.removeEventListener("seeked",this.onvseeked),this.onvplaying=this.onvseeked=null,this.videoBuffer=null),this.fragPlaying=null,this.gapController&&(this.gapController.destroy(),this.gapController=null),t.prototype.onMediaDetaching.call(this)},d.onMediaPlaying=function(){this.tick()},d.onMediaSeeked=function(){var t=this.media,e=t?t.currentTime:null;Object(a.a)(e)&&this.log("Media seeked to "+e.toFixed(3)),this.tick()},d.onManifestLoading=function(){this.log("Trigger BUFFER_RESET"),this.hls.trigger(s.a.BUFFER_RESET,void 0),this.fragmentTracker.removeAllFragments(),this.couldBacktrack=this.stalled=!1,this.startPosition=this.lastCurrentTime=0,this.fragPlaying=null,this.backtrackFragment=null},d.onManifestParsed=function(t,e){var r,i,n,a=!1,s=!1;e.levels.forEach((function(t){(r=t.audioCodec)&&(-1!==r.indexOf("mp4a.40.2")&&(a=!0),-1!==r.indexOf("mp4a.40.5")&&(s=!0))})),this.audioCodecSwitch=a&&s&&!("function"==typeof(null==(n=ee())||null===(i=n.prototype)||void 0===i?void 0:i.changeType)),this.audioCodecSwitch&&this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"),this.levels=e.levels,this.startFragRequested=!1},d.onLevelLoading=function(t,e){var r=this.levels;if(r&&this.state===Kt){var i=r[e.level];(!i.details||i.details.live&&this.levelLastLoaded!==e.level||this.waitForCdnTuneIn(i.details))&&(this.state=Jt)}},d.onLevelLoaded=function(t,e){var r,i=this.levels,n=e.level,a=e.details,o=a.totalduration;if(i){this.log("Level "+n+" loaded ["+a.startSN+","+a.endSN+"], cc ["+a.startCC+", "+a.endCC+"] duration:"+o);var l=this.fragCurrent;!l||this.state!==Vt&&this.state!==Wt||l.level!==e.level&&l.loader&&(this.state=Kt,this.backtrackFragment=null,l.loader.abort());var u=i[n],h=0;if(a.live||null!==(r=u.details)&&void 0!==r&&r.live){if(a.fragments[0]||(a.deltaUpdateFailed=!0),a.deltaUpdateFailed)return;h=this.alignPlaylists(a,u.details)}if(u.details=a,this.levelLastLoaded=n,this.hls.trigger(s.a.LEVEL_UPDATED,{details:a,level:n}),this.state===Jt){if(this.waitForCdnTuneIn(a))return;this.state=Kt}this.startFragRequested?a.live&&this.synchronizeToLiveEdge(a):this.setStartPosition(a,h),this.tick()}else this.warn("Levels were reset while loading level "+n)},d._handleFragmentLoadProgress=function(t){var e,r=t.frag,i=t.part,n=t.payload,a=this.levels;if(a){var s=a[r.level],o=s.details;if(o){var l=s.videoCodec,u=o.PTSKnown||!o.live,h=null===(e=r.initSegment)||void 0===e?void 0:e.data,d=this._getAudioCodec(s),c=this.transmuxer=this.transmuxer||new se(this.hls,C.b.MAIN,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this)),f=i?i.index:-1,g=-1!==f,v=new yt(r.level,r.sn,r.stats.chunkCount,n.byteLength,f,g),p=this.initPTS[r.cc];c.push(n,h,d,l,r,i,o.totalduration,u,v,p)}else this.warn("Dropping fragment "+r.sn+" of level "+r.level+" after level details were reset")}else this.warn("Levels were reset while fragment load was in progress. Fragment "+r.sn+" of level "+r.level+" will not be buffered")},d.onAudioTrackSwitching=function(t,e){var r=this.altAudio,i=!!e.url,n=e.id;if(!i){if(this.mediaBuffer!==this.media){this.log("Switching on main audio, use media.buffered to schedule main fragment loading"),this.mediaBuffer=this.media;var a=this.fragCurrent;null!=a&&a.loader&&(this.log("Switching to main audio track, cancel main fragment load"),a.loader.abort()),this.resetTransmuxer(),this.resetLoadingState()}else this.audioOnly&&this.resetTransmuxer();var o=this.hls;r&&o.trigger(s.a.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:"audio"}),o.trigger(s.a.AUDIO_TRACK_SWITCHED,{id:n})}},d.onAudioTrackSwitched=function(t,e){var r=e.id,i=!!this.hls.audioTracks[r].url;if(i){var n=this.videoBuffer;n&&this.mediaBuffer!==n&&(this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"),this.mediaBuffer=n)}this.altAudio=i,this.tick()},d.onBufferCreated=function(t,e){var r,i,n=e.tracks,a=!1;for(var s in n){var o=n[s];if("main"===o.id){if(i=s,r=o,"video"===s){var l=n[s];l&&(this.videoBuffer=l.buffer)}}else a=!0}a&&r?(this.log("Alternate track found, use "+i+".buffered to schedule main fragment loading"),this.mediaBuffer=r.buffer):this.mediaBuffer=this.media},d.onFragBuffered=function(t,e){var r=e.frag,i=e.part;if(!r||r.type===C.b.MAIN){if(this.fragContextChanged(r))return this.warn("Fragment "+r.sn+(i?" p: "+i.index:"")+" of level "+r.level+" finished buffering, but was aborted. state: "+this.state),void(this.state===zt&&(this.state=Kt));var n=i?i.stats:r.stats;this.fragLastKbps=Math.round(8*n.total/(n.buffering.end-n.loading.first)),"initSegment"!==r.sn&&(this.fragPrevious=r),this.fragBufferedComplete(r,i)}},d.onError=function(t,e){switch(e.details){case o.a.FRAG_LOAD_ERROR:case o.a.FRAG_LOAD_TIMEOUT:case o.a.KEY_LOAD_ERROR:case o.a.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(C.b.MAIN,e);break;case o.a.LEVEL_LOAD_ERROR:case o.a.LEVEL_LOAD_TIMEOUT:this.state!==Qt&&(e.fatal?(this.warn(""+e.details),this.state=Qt):e.levelRetry||this.state!==Jt||(this.state=Kt));break;case o.a.BUFFER_FULL_ERROR:if("main"===e.parent&&(this.state===qt||this.state===zt)){var r=!0,i=this.getFwdBufferInfo(this.media,C.b.MAIN);i&&i.len>.5&&(r=!this.reduceMaxBufferLength(i.len)),r&&(this.warn("buffer full error also media.currentTime is not buffered, flush main"),this.immediateLevelSwitch()),this.resetLoadingState()}}},d.checkBuffer=function(){var t=this.media,e=this.gapController;if(t&&e&&t.readyState){var r=mt.getBuffered(t);if(!this.loadedmetadata&&r.length)this.loadedmetadata=!0,this.seekToStartPos();else{var i=this.state!==Kt?this.fragCurrent:null;e.poll(this.lastCurrentTime,i)}this.lastCurrentTime=t.currentTime}},d.onFragLoadEmergencyAborted=function(){this.state=Kt,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.tickImmediate()},d.onBufferFlushed=function(t,e){var r=e.type;if(r!==p.a.AUDIO||this.audioOnly&&!this.altAudio){var i=(r===p.a.VIDEO?this.videoBuffer:this.mediaBuffer)||this.media;this.afterBufferFlushed(i,r,C.b.MAIN)}},d.onLevelsUpdated=function(t,e){this.levels=e.levels},d.swapAudioCodec=function(){this.audioCodecSwap=!this.audioCodecSwap},d.seekToStartPos=function(){var t=this.media,e=t.currentTime,r=this.startPosition;if(r>=0&&e<r){if(t.seeking)return void l.b.log("could not seek to "+r+", already seeking at "+e);var i=mt.getBuffered(t),n=(i.length?i.start(0):0)-r;n>0&&(n<this.config.maxBufferHole||n<this.config.maxFragLookUpTolerance)&&(l.b.log("adjusting start position by "+n+" to match buffer start"),r+=n,this.startPosition=r),this.log("seek to target start position "+r+" from current time "+e),t.currentTime=r}},d._getAudioCodec=function(t){var e=this.config.defaultAudioCodec||t.audioCodec;return this.audioCodecSwap&&e&&(this.log("Swapping audio codec"),e=-1!==e.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5"),e},d._loadBitrateTestFrag=function(t){var e=this;this._doFragLoad(t).then((function(r){var i=e.hls;if(r&&!i.nextLoadLevel&&!e.fragContextChanged(t)){e.fragLoadError=0,e.state=Kt,e.startFragRequested=!1,e.bitrateTest=!1;var n=t.stats;n.parsing.start=n.parsing.end=n.buffering.start=n.buffering.end=self.performance.now(),i.trigger(s.a.FRAG_LOADED,r)}}))},d._handleTransmuxComplete=function(t){var e,r="main",i=this.hls,n=t.remuxResult,o=t.chunkMeta,l=this.getCurrentContext(o);if(!l)return this.warn("The loading context changed while buffering fragment "+o.sn+" of level "+o.level+". This chunk will not be buffered."),void this.resetLiveStartWhenNotLoaded(o.level);var u=l.frag,h=l.part,d=l.level,c=n.video,f=n.text,g=n.id3,v=n.initSegment,m=d.details,y=this.altAudio?void 0:n.audio;if(!this.fragContextChanged(u)){if(this.state=qt,v){v.tracks&&(this._bufferInitSegment(d,v.tracks,u,o),i.trigger(s.a.FRAG_PARSING_INIT_SEGMENT,{frag:u,id:r,tracks:v.tracks}));var T=v.initPTS,b=v.timescale;Object(a.a)(T)&&(this.initPTS[u.cc]=T,i.trigger(s.a.INIT_PTS_FOUND,{frag:u,id:r,initPTS:T,timescale:b}))}if(c&&!1!==n.independent){if(m){var E=c.startPTS,S=c.endPTS,L=c.startDTS,A=c.endDTS;if(h)h.elementaryStreams[c.type]={startPTS:E,endPTS:S,startDTS:L,endDTS:A};else if(c.firstKeyFrame&&c.independent&&(this.couldBacktrack=!0),c.dropped&&c.independent){var D=this.getMainFwdBufferInfo();if((D?D.end:this.getLoadPosition())+this.config.maxBufferHole<(c.firstKeyFramePTS?c.firstKeyFramePTS:E)-this.config.maxBufferHole)return void this.backtrack(u);u.setElementaryStreamInfo(c.type,u.start,S,u.start,A,!0)}u.setElementaryStreamInfo(c.type,E,S,L,A),this.backtrackFragment&&(this.backtrackFragment=u),this.bufferFragmentData(c,u,h,o)}}else if(!1===n.independent)return void this.backtrack(u);if(y){var R=y.startPTS,k=y.endPTS,_=y.startDTS,I=y.endDTS;h&&(h.elementaryStreams[p.a.AUDIO]={startPTS:R,endPTS:k,startDTS:_,endDTS:I}),u.setElementaryStreamInfo(p.a.AUDIO,R,k,_,I),this.bufferFragmentData(y,u,h,o)}if(m&&null!=g&&null!==(e=g.samples)&&void 0!==e&&e.length){var O={id:r,frag:u,details:m,samples:g.samples};i.trigger(s.a.FRAG_PARSING_METADATA,O)}if(m&&f){var w={id:r,frag:u,details:m,samples:f.samples};i.trigger(s.a.FRAG_PARSING_USERDATA,w)}}},d._bufferInitSegment=function(t,e,r,i){var n=this;if(this.state===qt){this.audioOnly=!!e.audio&&!e.video,this.altAudio&&!this.audioOnly&&delete e.audio;var a=e.audio,o=e.video,l=e.audiovideo;if(a){var u=t.audioCodec,h=navigator.userAgent.toLowerCase();this.audioCodecSwitch&&(u&&(u=-1!==u.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5"),1!==a.metadata.channelCount&&-1===h.indexOf("firefox")&&(u="mp4a.40.5")),-1!==h.indexOf("android")&&"audio/mpeg"!==a.container&&(u="mp4a.40.2",this.log("Android: force audio codec to "+u)),t.audioCodec&&t.audioCodec!==u&&this.log('Swapping manifest audio codec "'+t.audioCodec+'" for "'+u+'"'),a.levelCodec=u,a.id="main",this.log("Init audio buffer, container:"+a.container+", codecs[selected/level/parsed]=["+(u||"")+"/"+(t.audioCodec||"")+"/"+a.codec+"]")}o&&(o.levelCodec=t.videoCodec,o.id="main",this.log("Init video buffer, container:"+o.container+", codecs[level/parsed]=["+(t.videoCodec||"")+"/"+o.codec+"]")),l&&this.log("Init audiovideo buffer, container:"+l.container+", codecs[level/parsed]=["+(t.attrs.CODECS||"")+"/"+l.codec+"]"),this.hls.trigger(s.a.BUFFER_CODECS,e),Object.keys(e).forEach((function(t){var a=e[t].initSegment;null!=a&&a.byteLength&&n.hls.trigger(s.a.BUFFER_APPENDING,{type:t,data:a,frag:r,part:null,chunkMeta:i,parent:r.type})})),this.tick()}},d.getMainFwdBufferInfo=function(){return this.getFwdBufferInfo(this.mediaBuffer?this.mediaBuffer:this.media,C.b.MAIN)},d.backtrack=function(t){this.couldBacktrack=!0,this.backtrackFragment=t,this.resetTransmuxer(),this.flushBufferGap(t),this.fragmentTracker.removeFragment(t),this.fragPrevious=null,this.nextLoadPosition=t.start,this.state=Kt},d.checkFragmentChanged=function(){var t=this.media,e=null;if(t&&t.readyState>1&&!1===t.seeking){var r=t.currentTime;if(mt.isBuffered(t,r)?e=this.getAppendedFrag(r):mt.isBuffered(t,r+.1)&&(e=this.getAppendedFrag(r+.1)),e){this.backtrackFragment=null;var i=this.fragPlaying,n=e.level;i&&e.sn===i.sn&&i.level===n&&e.urlId===i.urlId||(this.hls.trigger(s.a.FRAG_CHANGED,{frag:e}),i&&i.level===n||this.hls.trigger(s.a.LEVEL_SWITCHED,{level:n}),this.fragPlaying=e)}}},n=i,(u=[{key:"nextLevel",get:function(){var t=this.nextBufferedFrag;return t?t.level:-1}},{key:"currentFrag",get:function(){var t=this.media;return t?this.fragPlaying||this.getAppendedFrag(t.currentTime):null}},{key:"currentProgramDateTime",get:function(){var t=this.media;if(t){var e=t.currentTime,r=this.currentFrag;if(r&&Object(a.a)(e)&&Object(a.a)(r.programDateTime)){var i=r.programDateTime+1e3*(e-r.start);return new Date(i)}}return null}},{key:"currentLevel",get:function(){var t=this.currentFrag;return t?t.level:-1}},{key:"nextBufferedFrag",get:function(){var t=this.currentFrag;return t?this.followingBufferedFrag(t):null}},{key:"forceStartLoad",get:function(){return this._forceStartLoad}}])&&le(n.prototype,u),h&&le(n,h),Object.defineProperty(n,"prototype",{writable:!1}),i}(Zt),de=function(){function t(t,e,r){void 0===e&&(e=0),void 0===r&&(r=0),this.halfLife=void 0,this.alpha_=void 0,this.estimate_=void 0,this.totalWeight_=void 0,this.halfLife=t,this.alpha_=t?Math.exp(Math.log(.5)/t):0,this.estimate_=e,this.totalWeight_=r}var e=t.prototype;return e.sample=function(t,e){var r=Math.pow(this.alpha_,t);this.estimate_=e*(1-r)+r*this.estimate_,this.totalWeight_+=t},e.getTotalWeight=function(){return this.totalWeight_},e.getEstimate=function(){if(this.alpha_){var t=1-Math.pow(this.alpha_,this.totalWeight_);if(t)return this.estimate_/t}return this.estimate_},t}(),ce=function(){function t(t,e,r){this.defaultEstimate_=void 0,this.minWeight_=void 0,this.minDelayMs_=void 0,this.slow_=void 0,this.fast_=void 0,this.defaultEstimate_=r,this.minWeight_=.001,this.minDelayMs_=50,this.slow_=new de(t),this.fast_=new de(e)}var e=t.prototype;return e.update=function(t,e){var r=this.slow_,i=this.fast_;this.slow_.halfLife!==t&&(this.slow_=new de(t,r.getEstimate(),r.getTotalWeight())),this.fast_.halfLife!==e&&(this.fast_=new de(e,i.getEstimate(),i.getTotalWeight()))},e.sample=function(t,e){var r=(t=Math.max(t,this.minDelayMs_))/1e3,i=8*e/r;this.fast_.sample(r,i),this.slow_.sample(r,i)},e.canEstimate=function(){var t=this.fast_;return t&&t.getTotalWeight()>=this.minWeight_},e.getEstimate=function(){return this.canEstimate()?Math.min(this.fast_.getEstimate(),this.slow_.getEstimate()):this.defaultEstimate_},e.destroy=function(){},t}();function fe(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var ge=function(){function t(t){this.hls=void 0,this.lastLoadedFragLevel=0,this._nextAutoLevel=-1,this.timer=void 0,this.onCheck=this._abandonRulesCheck.bind(this),this.fragCurrent=null,this.partCurrent=null,this.bitrateTestDelay=0,this.bwEstimator=void 0,this.hls=t;var e=t.config;this.bwEstimator=new ce(e.abrEwmaSlowVoD,e.abrEwmaFastVoD,e.abrEwmaDefaultEstimate),this.registerListeners()}var e,r,i,n=t.prototype;return n.registerListeners=function(){var t=this.hls;t.on(s.a.FRAG_LOADING,this.onFragLoading,this),t.on(s.a.FRAG_LOADED,this.onFragLoaded,this),t.on(s.a.FRAG_BUFFERED,this.onFragBuffered,this),t.on(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.on(s.a.ERROR,this.onError,this)},n.unregisterListeners=function(){var t=this.hls;t.off(s.a.FRAG_LOADING,this.onFragLoading,this),t.off(s.a.FRAG_LOADED,this.onFragLoaded,this),t.off(s.a.FRAG_BUFFERED,this.onFragBuffered,this),t.off(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.off(s.a.ERROR,this.onError,this)},n.destroy=function(){this.unregisterListeners(),this.clearTimer(),this.hls=this.onCheck=null,this.fragCurrent=this.partCurrent=null},n.onFragLoading=function(t,e){var r,i=e.frag;i.type===C.b.MAIN&&(this.timer||(this.fragCurrent=i,this.partCurrent=null!=(r=e.part)?r:null,this.timer=self.setInterval(this.onCheck,100)))},n.onLevelLoaded=function(t,e){var r=this.hls.config;e.details.live?this.bwEstimator.update(r.abrEwmaSlowLive,r.abrEwmaFastLive):this.bwEstimator.update(r.abrEwmaSlowVoD,r.abrEwmaFastVoD)},n._abandonRulesCheck=function(){var t=this.fragCurrent,e=this.partCurrent,r=this.hls,i=r.autoLevelEnabled,n=r.config,o=r.media;if(t&&o){var u=e?e.stats:t.stats,h=e?e.duration:t.duration;if(u.aborted)return l.b.warn("frag loader destroy or aborted, disarm abandonRules"),this.clearTimer(),void(this._nextAutoLevel=-1);if(i&&!o.paused&&o.playbackRate&&o.readyState){var d=performance.now()-u.loading.start,c=Math.abs(o.playbackRate);if(!(d<=500*h/c)){var f=r.levels,g=r.minAutoLevel,v=f[t.level],p=u.total||Math.max(u.loaded,Math.round(h*v.maxBitrate/8)),m=Math.max(1,u.bwEstimate?u.bwEstimate/8:1e3*u.loaded/d),y=(p-u.loaded)/m,T=o.currentTime,b=(mt.bufferInfo(o,T,n.maxBufferHole).end-T)/c;if(!(b>=2*h/c||y<=b)){var E,S=Number.POSITIVE_INFINITY;for(E=t.level-1;E>g;E--){if((S=h*f[E].maxBitrate/(6.4*m))<b)break}if(!(S>=y)){var L=this.bwEstimator.getEstimate();l.b.warn("Fragment "+t.sn+(e?" part "+e.index:"")+" of level "+t.level+" is loading too slowly and will cause an underbuffer; aborting and switching to level "+E+"\n      Current BW estimate: "+(Object(a.a)(L)?(L/1024).toFixed(3):"Unknown")+" Kb/s\n      Estimated load time for current fragment: "+y.toFixed(3)+" s\n      Estimated load time for the next fragment: "+S.toFixed(3)+" s\n      Time to underbuffer: "+b.toFixed(3)+" s"),r.nextLoadLevel=E,this.bwEstimator.sample(d,u.loaded),this.clearTimer(),t.loader&&(this.fragCurrent=this.partCurrent=null,t.loader.abort()),r.trigger(s.a.FRAG_LOAD_EMERGENCY_ABORTED,{frag:t,part:e,stats:u})}}}}}},n.onFragLoaded=function(t,e){var r=e.frag,i=e.part;if(r.type===C.b.MAIN&&Object(a.a)(r.sn)){var n=i?i.stats:r.stats,o=i?i.duration:r.duration;if(this.clearTimer(),this.lastLoadedFragLevel=r.level,this._nextAutoLevel=-1,this.hls.config.abrMaxWithRealBitrate){var l=this.hls.levels[r.level],u=(l.loaded?l.loaded.bytes:0)+n.loaded,h=(l.loaded?l.loaded.duration:0)+o;l.loaded={bytes:u,duration:h},l.realBitrate=Math.round(8*u/h)}if(r.bitrateTest){var d={stats:n,frag:r,part:i,id:r.type};this.onFragBuffered(s.a.FRAG_BUFFERED,d),r.bitrateTest=!1}}},n.onFragBuffered=function(t,e){var r=e.frag,i=e.part,n=i?i.stats:r.stats;if(!n.aborted&&r.type===C.b.MAIN&&"initSegment"!==r.sn){var a=n.parsing.end-n.loading.start;this.bwEstimator.sample(a,n.loaded),n.bwEstimate=this.bwEstimator.getEstimate(),r.bitrateTest?this.bitrateTestDelay=a/1e3:this.bitrateTestDelay=0}},n.onError=function(t,e){switch(e.details){case o.a.FRAG_LOAD_ERROR:case o.a.FRAG_LOAD_TIMEOUT:this.clearTimer()}},n.clearTimer=function(){self.clearInterval(this.timer),this.timer=void 0},n.getNextABRAutoLevel=function(){var t=this.fragCurrent,e=this.partCurrent,r=this.hls,i=r.maxAutoLevel,n=r.config,a=r.minAutoLevel,s=r.media,o=e?e.duration:t?t.duration:0,u=s?s.currentTime:0,h=s&&0!==s.playbackRate?Math.abs(s.playbackRate):1,d=this.bwEstimator?this.bwEstimator.getEstimate():n.abrEwmaDefaultEstimate,c=(mt.bufferInfo(s,u,n.maxBufferHole).end-u)/h,f=this.findBestLevel(d,a,i,c,n.abrBandWidthFactor,n.abrBandWidthUpFactor);if(f>=0)return f;l.b.trace((c?"rebuffering expected":"buffer is empty")+", finding optimal quality level");var g=o?Math.min(o,n.maxStarvationDelay):n.maxStarvationDelay,v=n.abrBandWidthFactor,p=n.abrBandWidthUpFactor;if(!c){var m=this.bitrateTestDelay;if(m)g=(o?Math.min(o,n.maxLoadingDelay):n.maxLoadingDelay)-m,l.b.trace("bitrate test took "+Math.round(1e3*m)+"ms, set first fragment max fetchDuration to "+Math.round(1e3*g)+" ms"),v=p=1}return f=this.findBestLevel(d,a,i,c+g,v,p),Math.max(f,0)},n.findBestLevel=function(t,e,r,i,n,a){for(var s,o=this.fragCurrent,u=this.partCurrent,h=this.lastLoadedFragLevel,d=this.hls.levels,c=d[h],f=!(null==c||null===(s=c.details)||void 0===s||!s.live),g=null==c?void 0:c.codecSet,v=u?u.duration:o?o.duration:0,p=r;p>=e;p--){var m=d[p];if(m&&(!g||m.codecSet===g)){var y=m.details,T=(u?null==y?void 0:y.partTarget:null==y?void 0:y.averagetargetduration)||v,b=void 0;b=p<=h?n*t:a*t;var E=d[p].maxBitrate,S=E*T/b;if(l.b.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: "+p+"/"+Math.round(b)+"/"+E+"/"+T+"/"+i+"/"+S),b>E&&(!S||f&&!this.bitrateTestDelay||S<i))return p}}return-1},e=t,(r=[{key:"nextAutoLevel",get:function(){var t=this._nextAutoLevel,e=this.bwEstimator;if(!(-1===t||e&&e.canEstimate()))return t;var r=this.getNextABRAutoLevel();return-1!==t&&(r=Math.min(t,r)),r},set:function(t){this._nextAutoLevel=t}}])&&fe(e.prototype,r),i&&fe(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}(),ve=r(15);function pe(){return(pe=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}function me(t,e){return(me=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var ye=function(t){var e,r;function i(e,r){var i;return(i=t.call(this,e,r,"[audio-stream-controller]")||this).videoBuffer=null,i.videoTrackCC=-1,i.waitingVideoCC=-1,i.audioSwitch=!1,i.trackId=-1,i.waitingData=null,i.mainDetails=null,i.bufferFlushed=!1,i.cachedTrackLoadedData=null,i._registerListeners(),i}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,me(e,r);var n=i.prototype;return n.onHandlerDestroying=function(){this._unregisterListeners(),this.mainDetails=null},n._registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.on(s.a.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this),t.on(s.a.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.on(s.a.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.on(s.a.ERROR,this.onError,this),t.on(s.a.BUFFER_RESET,this.onBufferReset,this),t.on(s.a.BUFFER_CREATED,this.onBufferCreated,this),t.on(s.a.BUFFER_FLUSHED,this.onBufferFlushed,this),t.on(s.a.INIT_PTS_FOUND,this.onInitPtsFound,this),t.on(s.a.FRAG_BUFFERED,this.onFragBuffered,this)},n._unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.off(s.a.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this),t.off(s.a.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.off(s.a.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.off(s.a.ERROR,this.onError,this),t.off(s.a.BUFFER_RESET,this.onBufferReset,this),t.off(s.a.BUFFER_CREATED,this.onBufferCreated,this),t.off(s.a.BUFFER_FLUSHED,this.onBufferFlushed,this),t.off(s.a.INIT_PTS_FOUND,this.onInitPtsFound,this),t.off(s.a.FRAG_BUFFERED,this.onFragBuffered,this)},n.onInitPtsFound=function(t,e){var r=e.frag,i=e.id,n=e.initPTS;if("main"===i){var a=r.cc;this.initPTS[r.cc]=n,this.log("InitPTS for cc: "+a+" found from main: "+n),this.videoTrackCC=a,this.state===$t&&this.tick()}},n.startLoad=function(t){if(!this.levels)return this.startPosition=t,void(this.state=jt);var e=this.lastCurrentTime;this.stopLoad(),this.setInterval(100),this.fragLoadError=0,e>0&&-1===t?(this.log("Override startPosition with lastCurrentTime @"+e.toFixed(3)),this.state=Kt):(this.loadedmetadata=!1,this.state=Yt),this.nextLoadPosition=this.startPosition=this.lastCurrentTime=t,this.tick()},n.doTick=function(){switch(this.state){case Kt:this.doTickIdle();break;case Yt:var e,r=this.levels,i=this.trackId,n=null==r||null===(e=r[i])||void 0===e?void 0:e.details;if(n){if(this.waitForCdnTuneIn(n))break;this.state=$t}break;case Wt:var a,s=performance.now(),o=this.retryDate;(!o||s>=o||null!==(a=this.media)&&void 0!==a&&a.seeking)&&(this.log("RetryDate reached, switch back to IDLE state"),this.state=Kt);break;case $t:var u=this.waitingData;if(u){var h=u.frag,d=u.part,c=u.cache,f=u.complete;if(void 0!==this.initPTS[h.cc]){this.waitingData=null,this.waitingVideoCC=-1,this.state=Vt;var g={frag:h,part:d,payload:c.flush(),networkDetails:null};this._handleFragmentLoadProgress(g),f&&t.prototype._handleFragmentLoadComplete.call(this,g)}else if(this.videoTrackCC!==this.waitingVideoCC)l.b.log("Waiting fragment cc ("+h.cc+") cancelled because video is at cc "+this.videoTrackCC),this.clearWaitingFragment();else{var v=this.getLoadPosition(),p=mt.bufferInfo(this.mediaBuffer,v,this.config.maxBufferHole);Rt(p.end,this.config.maxFragLookUpTolerance,h)<0&&(l.b.log("Waiting fragment cc ("+h.cc+") @ "+h.start+" cancelled because another fragment at "+p.end+" is needed"),this.clearWaitingFragment())}}else this.state=Kt}this.onTickEnd()},n.clearWaitingFragment=function(){var t=this.waitingData;t&&(this.fragmentTracker.removeFragment(t.frag),this.waitingData=null,this.waitingVideoCC=-1,this.state=Kt)},n.onTickEnd=function(){var t=this.media;if(t&&t.readyState){var e=(this.mediaBuffer?this.mediaBuffer:t).buffered;!this.loadedmetadata&&e.length&&(this.loadedmetadata=!0),this.lastCurrentTime=t.currentTime}},n.doTickIdle=function(){var t,e,r=this.hls,i=this.levels,n=this.media,a=this.trackId,o=r.config;if(i&&i[a]&&(n||!this.startFragRequested&&o.startFragPrefetch)){var l=i[a].details;if(!l||l.live&&this.levelLastLoaded!==a||this.waitForCdnTuneIn(l))this.state=Yt;else{this.bufferFlushed&&(this.bufferFlushed=!1,this.afterBufferFlushed(this.mediaBuffer?this.mediaBuffer:this.media,p.a.AUDIO,C.b.AUDIO));var u=this.getFwdBufferInfo(this.mediaBuffer?this.mediaBuffer:this.media,C.b.AUDIO);if(null!==u){var h=this.getFwdBufferInfo(this.videoBuffer?this.videoBuffer:this.media,C.b.MAIN),d=u.len,c=this.getMaxBufferLength(null==h?void 0:h.len),f=this.audioSwitch;if(!(d>=c)||f){if(!f&&this._streamEnded(u,l))return r.trigger(s.a.BUFFER_EOS,{type:"audio"}),void(this.state=Xt);var g=l.fragments[0].start,v=u.end;if(f){var m=this.getLoadPosition();v=m,l.PTSKnown&&m<g&&(u.end>g||u.nextStart)&&(this.log("Alt audio track ahead of main track, seek to start of alt audio track"),n.currentTime=g+.05)}if(!(h&&v>h.end+l.targetduration)&&(h&&h.len||!u.len)){var y=this.getNextFragment(v,l);y?"identity"!==(null===(t=y.decryptdata)||void 0===t?void 0:t.keyFormat)||null!==(e=y.decryptdata)&&void 0!==e&&e.key?this.loadFragment(y,l,v):this.loadKey(y,l):this.bufferFlushed=!0}}}}}},n.getMaxBufferLength=function(e){var r=t.prototype.getMaxBufferLength.call(this);return e?Math.max(r,e):r},n.onMediaDetaching=function(){this.videoBuffer=null,t.prototype.onMediaDetaching.call(this)},n.onAudioTracksUpdated=function(t,e){var r=e.audioTracks;this.resetTransmuxer(),this.levels=r.map((function(t){return new Q(t)}))},n.onAudioTrackSwitching=function(t,e){var r=!!e.url;this.trackId=e.id;var i=this.fragCurrent;null!=i&&i.loader&&i.loader.abort(),this.fragCurrent=null,this.clearWaitingFragment(),r?this.setInterval(100):this.resetTransmuxer(),r?(this.audioSwitch=!0,this.state=Kt):this.state=jt,this.tick()},n.onManifestLoading=function(){this.mainDetails=null,this.fragmentTracker.removeAllFragments(),this.startPosition=this.lastCurrentTime=0,this.bufferFlushed=!1},n.onLevelLoaded=function(t,e){this.mainDetails=e.details,null!==this.cachedTrackLoadedData&&(this.hls.trigger(s.a.AUDIO_TRACK_LOADED,this.cachedTrackLoadedData),this.cachedTrackLoadedData=null)},n.onAudioTrackLoaded=function(t,e){var r;if(null!=this.mainDetails){var i=this.levels,n=e.details,a=e.id;if(i){this.log("Track "+a+" loaded ["+n.startSN+","+n.endSN+"],duration:"+n.totalduration);var s=i[a],o=0;if(n.live||null!==(r=s.details)&&void 0!==r&&r.live){var l=this.mainDetails;if(n.fragments[0]||(n.deltaUpdateFailed=!0),n.deltaUpdateFailed||!l)return;!s.details&&n.hasProgramDateTime&&l.hasProgramDateTime?(Lt(n,l),o=n.fragments[0].start):o=this.alignPlaylists(n,s.details)}s.details=n,this.levelLastLoaded=a,this.startFragRequested||!this.mainDetails&&n.live||this.setStartPosition(s.details,o),this.state!==Yt||this.waitForCdnTuneIn(n)||(this.state=Kt),this.tick()}else this.warn("Audio tracks were reset while loading level "+a)}else this.cachedTrackLoadedData=e},n._handleFragmentLoadProgress=function(t){var e,r=t.frag,i=t.part,n=t.payload,a=this.config,s=this.trackId,o=this.levels;if(o){var u=o[s],h=u.details,d=a.defaultAudioCodec||u.audioCodec||"mp4a.40.2",c=this.transmuxer;c||(c=this.transmuxer=new se(this.hls,C.b.AUDIO,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this)));var f=this.initPTS[r.cc],g=null===(e=r.initSegment)||void 0===e?void 0:e.data;if(void 0!==f){var v=i?i.index:-1,p=-1!==v,m=new yt(r.level,r.sn,r.stats.chunkCount,n.byteLength,v,p);c.push(n,g,d,"",r,i,h.totalduration,!1,m,f)}else{l.b.log("Unknown video PTS for cc "+r.cc+", waiting for video PTS before demuxing audio frag "+r.sn+" of ["+h.startSN+" ,"+h.endSN+"],track "+s),(this.waitingData=this.waitingData||{frag:r,part:i,cache:new ve.a,complete:!1}).cache.push(new Uint8Array(n)),this.waitingVideoCC=this.videoTrackCC,this.state=$t}}else this.warn("Audio tracks were reset while fragment load was in progress. Fragment "+r.sn+" of level "+r.level+" will not be buffered")},n._handleFragmentLoadComplete=function(e){this.waitingData?this.waitingData.complete=!0:t.prototype._handleFragmentLoadComplete.call(this,e)},n.onBufferReset=function(){this.mediaBuffer=this.videoBuffer=null,this.loadedmetadata=!1},n.onBufferCreated=function(t,e){var r=e.tracks.audio;r&&(this.mediaBuffer=r.buffer),e.tracks.video&&(this.videoBuffer=e.tracks.video.buffer)},n.onFragBuffered=function(t,e){var r=e.frag,i=e.part;r.type===C.b.AUDIO&&(this.fragContextChanged(r)?this.warn("Fragment "+r.sn+(i?" p: "+i.index:"")+" of level "+r.level+" finished buffering, but was aborted. state: "+this.state+", audioSwitch: "+this.audioSwitch):("initSegment"!==r.sn&&(this.fragPrevious=r,this.audioSwitch&&(this.audioSwitch=!1,this.hls.trigger(s.a.AUDIO_TRACK_SWITCHED,{id:this.trackId}))),this.fragBufferedComplete(r,i)))},n.onError=function(e,r){switch(r.details){case o.a.FRAG_LOAD_ERROR:case o.a.FRAG_LOAD_TIMEOUT:case o.a.KEY_LOAD_ERROR:case o.a.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(C.b.AUDIO,r);break;case o.a.AUDIO_TRACK_LOAD_ERROR:case o.a.AUDIO_TRACK_LOAD_TIMEOUT:this.state!==Qt&&this.state!==jt&&(this.state=r.fatal?Qt:Kt,this.warn(r.details+" while loading frag, switching to "+this.state+" state"));break;case o.a.BUFFER_FULL_ERROR:if("audio"===r.parent&&(this.state===qt||this.state===zt)){var i=!0,n=this.getFwdBufferInfo(this.mediaBuffer,C.b.AUDIO);n&&n.len>.5&&(i=!this.reduceMaxBufferLength(n.len)),i&&(this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer"),this.fragCurrent=null,t.prototype.flushMainBuffer.call(this,0,Number.POSITIVE_INFINITY,"audio")),this.resetLoadingState()}}},n.onBufferFlushed=function(t,e){e.type===p.a.AUDIO&&(this.bufferFlushed=!0)},n._handleTransmuxComplete=function(t){var e,r="audio",i=this.hls,n=t.remuxResult,a=t.chunkMeta,o=this.getCurrentContext(a);if(!o)return this.warn("The loading context changed while buffering fragment "+a.sn+" of level "+a.level+". This chunk will not be buffered."),void this.resetLiveStartWhenNotLoaded(a.level);var l=o.frag,u=o.part,h=o.level.details,d=n.audio,c=n.text,f=n.id3,g=n.initSegment;if(!this.fragContextChanged(l)&&h){if(this.state=qt,this.audioSwitch&&d&&this.completeAudioSwitch(),null!=g&&g.tracks&&(this._bufferInitSegment(g.tracks,l,a),i.trigger(s.a.FRAG_PARSING_INIT_SEGMENT,{frag:l,id:r,tracks:g.tracks})),d){var v=d.startPTS,m=d.endPTS,y=d.startDTS,T=d.endDTS;u&&(u.elementaryStreams[p.a.AUDIO]={startPTS:v,endPTS:m,startDTS:y,endDTS:T}),l.setElementaryStreamInfo(p.a.AUDIO,v,m,y,T),this.bufferFragmentData(d,l,u,a)}if(null!=f&&null!==(e=f.samples)&&void 0!==e&&e.length){var b=pe({id:r,frag:l,details:h},f);i.trigger(s.a.FRAG_PARSING_METADATA,b)}if(c){var E=pe({id:r,frag:l,details:h},c);i.trigger(s.a.FRAG_PARSING_USERDATA,E)}}},n._bufferInitSegment=function(t,e,r){if(this.state===qt){t.video&&delete t.video;var i=t.audio;if(i){i.levelCodec=i.codec,i.id="audio",this.log("Init audio buffer, container:"+i.container+", codecs[parsed]=["+i.codec+"]"),this.hls.trigger(s.a.BUFFER_CODECS,t);var n=i.initSegment;if(null!=n&&n.byteLength){var a={type:"audio",frag:e,part:null,chunkMeta:r,parent:e.type,data:n};this.hls.trigger(s.a.BUFFER_APPENDING,a)}this.tick()}}},n.loadFragment=function(e,r,i){var n=this.fragmentTracker.getState(e);this.fragCurrent=e,(this.audioSwitch||n===ut.NOT_LOADED||n===ut.PARTIAL)&&("initSegment"===e.sn?this._loadInitSegment(e):r.live&&!Object(a.a)(this.initPTS[e.cc])?(this.log("Waiting for video PTS in continuity counter "+e.cc+" of live stream before loading audio fragment "+e.sn+" of level "+this.trackId),this.state=$t):(this.startFragRequested=!0,t.prototype.loadFragment.call(this,e,r,i)))},n.completeAudioSwitch=function(){var e=this.hls,r=this.media,i=this.trackId;r&&(this.log("Switching audio track : flushing all audio"),t.prototype.flushMainBuffer.call(this,0,Number.POSITIVE_INFINITY,"audio")),this.audioSwitch=!1,e.trigger(s.a.AUDIO_TRACK_SWITCHED,{id:i})},i}(Zt);function Te(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function be(t,e){return(be=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var Ee=function(t){var e,r;function i(e){var r;return(r=t.call(this,e,"[audio-track-controller]")||this).tracks=[],r.groupId=null,r.tracksInGroup=[],r.trackId=-1,r.trackName="",r.selectDefaultTrack=!0,r.registerListeners(),r}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,be(e,r);var n,a,l,u=i.prototype;return u.registerListeners=function(){var t=this.hls;t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.on(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.on(s.a.LEVEL_SWITCHING,this.onLevelSwitching,this),t.on(s.a.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.on(s.a.ERROR,this.onError,this)},u.unregisterListeners=function(){var t=this.hls;t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.off(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.off(s.a.LEVEL_SWITCHING,this.onLevelSwitching,this),t.off(s.a.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.off(s.a.ERROR,this.onError,this)},u.destroy=function(){this.unregisterListeners(),this.tracks.length=0,this.tracksInGroup.length=0,t.prototype.destroy.call(this)},u.onManifestLoading=function(){this.tracks=[],this.groupId=null,this.tracksInGroup=[],this.trackId=-1,this.trackName="",this.selectDefaultTrack=!0},u.onManifestParsed=function(t,e){this.tracks=e.audioTracks||[]},u.onAudioTrackLoaded=function(t,e){var r=e.id,i=e.details,n=this.tracksInGroup[r];if(n){var a=n.details;n.details=e.details,this.log("audioTrack "+r+" loaded ["+i.startSN+"-"+i.endSN+"]"),r===this.trackId&&(this.retryCount=0,this.playlistLoaded(r,e,a))}else this.warn("Invalid audio track id "+r)},u.onLevelLoading=function(t,e){this.switchLevel(e.level)},u.onLevelSwitching=function(t,e){this.switchLevel(e.level)},u.switchLevel=function(t){var e=this.hls.levels[t];if(null!=e&&e.audioGroupIds){var r=e.audioGroupIds[e.urlId];if(this.groupId!==r){this.groupId=r;var i=this.tracks.filter((function(t){return!r||t.groupId===r}));this.selectDefaultTrack&&!i.some((function(t){return t.default}))&&(this.selectDefaultTrack=!1),this.tracksInGroup=i;var n={audioTracks:i};this.log("Updating audio tracks, "+i.length+' track(s) found in "'+r+'" group-id'),this.hls.trigger(s.a.AUDIO_TRACKS_UPDATED,n),this.selectInitialTrack()}}},u.onError=function(e,r){t.prototype.onError.call(this,e,r),!r.fatal&&r.context&&r.context.type===C.a.AUDIO_TRACK&&r.context.id===this.trackId&&r.context.groupId===this.groupId&&this.retryLoadingOrFail(r)},u.setAudioTrack=function(t){var e=this.tracksInGroup;if(t<0||t>=e.length)this.warn("Invalid id passed to audio-track controller");else{this.clearTimer();var r=e[this.trackId];this.log("Now switching to audio-track index "+t);var i=e[t],n=i.id,a=i.groupId,o=void 0===a?"":a,l=i.name,u=i.type,h=i.url;if(this.trackId=t,this.trackName=l,this.selectDefaultTrack=!1,this.hls.trigger(s.a.AUDIO_TRACK_SWITCHING,{id:n,groupId:o,name:l,type:u,url:h}),!i.details||i.details.live){var d=this.switchParams(i.url,null==r?void 0:r.details);this.loadPlaylist(d)}}},u.selectInitialTrack=function(){this.tracksInGroup;var t=this.trackName,e=this.findTrackId(t)||this.findTrackId();-1!==e?this.setAudioTrack(e):(this.warn("No track found for running audio group-ID: "+this.groupId),this.hls.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.AUDIO_TRACK_LOAD_ERROR,fatal:!0}))},u.findTrackId=function(t){for(var e=this.tracksInGroup,r=0;r<e.length;r++){var i=e[r];if((!this.selectDefaultTrack||i.default)&&(!t||t===i.name))return i.id}return-1},u.loadPlaylist=function(t){var e=this.tracksInGroup[this.trackId];if(this.shouldLoadTrack(e)){var r=e.id,i=e.groupId,n=e.url;if(t)try{n=t.addDirectives(n)}catch(t){this.warn("Could not construct new URL with HLS Delivery Directives: "+t)}this.log("loading audio-track playlist for id: "+r),this.clearTimer(),this.hls.trigger(s.a.AUDIO_TRACK_LOADING,{url:n,id:r,groupId:i,deliveryDirectives:t||null})}},n=i,(a=[{key:"audioTracks",get:function(){return this.tracksInGroup}},{key:"audioTrack",get:function(){return this.trackId},set:function(t){this.selectDefaultTrack=!1,this.setAudioTrack(t)}}])&&Te(n.prototype,a),l&&Te(n,l),Object.defineProperty(n,"prototype",{writable:!1}),i}(at);function Se(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Le(t,e){return(Le=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}var Ae=function(t){var e,r;function i(e,r){var i;return(i=t.call(this,e,r,"[subtitle-stream-controller]")||this).levels=[],i.currentTrackId=-1,i.tracksBuffered=[],i.mainDetails=null,i._registerListeners(),i}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,Le(e,r);var n,a,o,l=i.prototype;return l.onHandlerDestroying=function(){this._unregisterListeners(),this.mainDetails=null},l._registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.on(s.a.ERROR,this.onError,this),t.on(s.a.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.on(s.a.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this),t.on(s.a.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.on(s.a.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this),t.on(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this)},l._unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.LEVEL_LOADED,this.onLevelLoaded,this),t.off(s.a.ERROR,this.onError,this),t.off(s.a.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.off(s.a.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this),t.off(s.a.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.off(s.a.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this),t.off(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this)},l.startLoad=function(){this.stopLoad(),this.state=Kt,this.setInterval(500),this.tick()},l.onManifestLoading=function(){this.mainDetails=null,this.fragmentTracker.removeAllFragments()},l.onLevelLoaded=function(t,e){this.mainDetails=e.details},l.onSubtitleFragProcessed=function(t,e){var r=e.frag,i=e.success;if(this.fragPrevious=r,this.state=Kt,i){var n=this.tracksBuffered[this.currentTrackId];if(n){for(var a,s=r.start,o=0;o<n.length;o++)if(s>=n[o].start&&s<=n[o].end){a=n[o];break}var l=r.start+r.duration;a?a.end=l:(a={start:s,end:l},n.push(a)),this.fragmentTracker.fragBuffered(r)}}},l.onBufferFlushing=function(t,e){var r=e.startOffset,i=e.endOffset;if(0===r&&i!==Number.POSITIVE_INFINITY){var n=this.currentTrackId,a=this.levels;if(!a.length||!a[n]||!a[n].details)return;var s=i-a[n].details.targetduration;if(s<=0)return;e.endOffsetSubtitles=Math.max(0,s),this.tracksBuffered.forEach((function(t){for(var e=0;e<t.length;)if(t[e].end<=s)t.shift();else{if(!(t[e].start<s))break;t[e].start=s,e++}})),this.fragmentTracker.removeFragmentsInRange(r,s,C.b.SUBTITLE)}},l.onError=function(t,e){var r,i=e.frag;i&&i.type===C.b.SUBTITLE&&(null!==(r=this.fragCurrent)&&void 0!==r&&r.loader&&this.fragCurrent.loader.abort(),this.state=Kt)},l.onSubtitleTracksUpdated=function(t,e){var r=this,i=e.subtitleTracks;this.tracksBuffered=[],this.levels=i.map((function(t){return new Q(t)})),this.fragmentTracker.removeAllFragments(),this.fragPrevious=null,this.levels.forEach((function(t){r.tracksBuffered[t.id]=[]})),this.mediaBuffer=null},l.onSubtitleTrackSwitch=function(t,e){if(this.currentTrackId=e.id,this.levels.length&&-1!==this.currentTrackId){var r=this.levels[this.currentTrackId];null!=r&&r.details?this.mediaBuffer=this.mediaBufferTimeRanges:this.mediaBuffer=null,r&&this.setInterval(500)}else this.clearInterval()},l.onSubtitleTrackLoaded=function(t,e){var r,i=e.details,n=e.id,a=this.currentTrackId,s=this.levels;if(s.length){var o=s[a];if(!(n>=s.length||n!==a)&&o){if(this.mediaBuffer=this.mediaBufferTimeRanges,i.live||null!==(r=o.details)&&void 0!==r&&r.live){var l=this.mainDetails;if(i.deltaUpdateFailed||!l)return;var u=l.fragments[0];if(o.details)0===this.alignPlaylists(i,o.details)&&u&&nt(i,u.start);else i.hasProgramDateTime&&l.hasProgramDateTime?Lt(i,l):u&&nt(i,u.start)}if(o.details=i,this.levelLastLoaded=n,this.tick(),i.live&&!this.fragCurrent&&this.media&&this.state===Kt)Dt(null,i.fragments,this.media.currentTime,0)||(this.warn("Subtitle playlist not aligned with playback"),o.details=void 0)}}},l._handleFragmentLoadComplete=function(t){var e=t.frag,r=t.payload,i=e.decryptdata,n=this.hls;if(!this.fragContextChanged(e)&&r&&r.byteLength>0&&i&&i.key&&i.iv&&"AES-128"===i.method){var a=performance.now();this.decrypter.webCryptoDecrypt(new Uint8Array(r),i.key.buffer,i.iv.buffer).then((function(t){var r=performance.now();n.trigger(s.a.FRAG_DECRYPTED,{frag:e,payload:t,stats:{tstart:a,tdecrypt:r}})}))}},l.doTick=function(){if(this.media){if(this.state===Kt){var t,e=this.currentTrackId,r=this.levels;if(!r.length||!r[e]||!r[e].details)return;var i=r[e].details,n=i.targetduration,a=this.config,s=this.media,o=mt.bufferedInfo(this.mediaBufferTimeRanges,s.currentTime-n,a.maxBufferHole),l=o.end;if(o.len>this.getMaxBufferLength()+n)return;var u,h=i.fragments,d=h.length,c=i.edge,f=this.fragPrevious;if(l<c){var g=a.maxFragLookUpTolerance;!(u=Dt(f,h,Math.max(h[0].start,l),g))&&f&&f.start<h[0].start&&(u=h[0])}else u=h[d-1];null!==(t=u)&&void 0!==t&&t.encrypted?this.loadKey(u,i):u&&this.fragmentTracker.getState(u)===ut.NOT_LOADED&&this.loadFragment(u,i,l)}}else this.state=Kt},l.loadFragment=function(e,r,i){this.fragCurrent=e,t.prototype.loadFragment.call(this,e,r,i)},n=i,(a=[{key:"mediaBufferTimeRanges",get:function(){return this.tracksBuffered[this.currentTrackId]||[]}}])&&Se(n.prototype,a),o&&Se(n,o),Object.defineProperty(n,"prototype",{writable:!1}),i}(Zt);function De(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Re(t,e){return(Re=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ke(t){for(var e=[],r=0;r<t.length;r++){var i=t[r];"subtitles"===i.kind&&i.label&&e.push(t[r])}return e}var _e,Ie=function(t){var e,r;function i(e){var r;return(r=t.call(this,e,"[subtitle-track-controller]")||this).media=null,r.tracks=[],r.groupId=null,r.tracksInGroup=[],r.trackId=-1,r.selectDefaultTrack=!0,r.queuedDefaultTrack=-1,r.trackChangeListener=function(){return r.onTextTracksChanged()},r.asyncPollTrackChange=function(){return r.pollTrackChange(0)},r.useTextTrackPolling=!1,r.subtitlePollingInterval=-1,r._subtitleDisplay=!0,r.registerListeners(),r}r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,Re(e,r);var n,a,o,l=i.prototype;return l.destroy=function(){this.unregisterListeners(),this.tracks.length=0,this.tracksInGroup.length=0,this.trackChangeListener=this.asyncPollTrackChange=null,t.prototype.destroy.call(this)},l.registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.on(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.on(s.a.LEVEL_SWITCHING,this.onLevelSwitching,this),t.on(s.a.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.on(s.a.ERROR,this.onError,this)},l.unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.off(s.a.LEVEL_LOADING,this.onLevelLoading,this),t.off(s.a.LEVEL_SWITCHING,this.onLevelSwitching,this),t.off(s.a.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.off(s.a.ERROR,this.onError,this)},l.onMediaAttached=function(t,e){this.media=e.media,this.media&&(this.queuedDefaultTrack>-1&&(this.subtitleTrack=this.queuedDefaultTrack,this.queuedDefaultTrack=-1),this.useTextTrackPolling=!(this.media.textTracks&&"onchange"in this.media.textTracks),this.useTextTrackPolling?this.pollTrackChange(500):this.media.textTracks.addEventListener("change",this.asyncPollTrackChange))},l.pollTrackChange=function(t){self.clearInterval(this.subtitlePollingInterval),this.subtitlePollingInterval=self.setInterval(this.trackChangeListener,t)},l.onMediaDetaching=function(){this.media&&(self.clearInterval(this.subtitlePollingInterval),this.useTextTrackPolling||this.media.textTracks.removeEventListener("change",this.asyncPollTrackChange),this.trackId>-1&&(this.queuedDefaultTrack=this.trackId),ke(this.media.textTracks).forEach((function(t){U(t)})),this.subtitleTrack=-1,this.media=null)},l.onManifestLoading=function(){this.tracks=[],this.groupId=null,this.tracksInGroup=[],this.trackId=-1,this.selectDefaultTrack=!0},l.onManifestParsed=function(t,e){this.tracks=e.subtitleTracks},l.onSubtitleTrackLoaded=function(t,e){var r=e.id,i=e.details,n=this.trackId,a=this.tracksInGroup[n];if(a){var s=a.details;a.details=e.details,this.log("subtitle track "+r+" loaded ["+i.startSN+"-"+i.endSN+"]"),r===this.trackId&&(this.retryCount=0,this.playlistLoaded(r,e,s))}else this.warn("Invalid subtitle track id "+r)},l.onLevelLoading=function(t,e){this.switchLevel(e.level)},l.onLevelSwitching=function(t,e){this.switchLevel(e.level)},l.switchLevel=function(t){var e=this.hls.levels[t];if(null!=e&&e.textGroupIds){var r=e.textGroupIds[e.urlId];if(this.groupId!==r){var i=this.tracksInGroup?this.tracksInGroup[this.trackId]:void 0,n=this.tracks.filter((function(t){return!r||t.groupId===r}));this.tracksInGroup=n;var a=this.findTrackId(null==i?void 0:i.name)||this.findTrackId();this.groupId=r;var o={subtitleTracks:n};this.log("Updating subtitle tracks, "+n.length+' track(s) found in "'+r+'" group-id'),this.hls.trigger(s.a.SUBTITLE_TRACKS_UPDATED,o),-1!==a&&this.setSubtitleTrack(a,i)}}},l.findTrackId=function(t){for(var e=this.tracksInGroup,r=0;r<e.length;r++){var i=e[r];if((!this.selectDefaultTrack||i.default)&&(!t||t===i.name))return i.id}return-1},l.onError=function(e,r){t.prototype.onError.call(this,e,r),!r.fatal&&r.context&&r.context.type===C.a.SUBTITLE_TRACK&&r.context.id===this.trackId&&r.context.groupId===this.groupId&&this.retryLoadingOrFail(r)},l.loadPlaylist=function(t){var e=this.tracksInGroup[this.trackId];if(this.shouldLoadTrack(e)){var r=e.id,i=e.groupId,n=e.url;if(t)try{n=t.addDirectives(n)}catch(t){this.warn("Could not construct new URL with HLS Delivery Directives: "+t)}this.log("Loading subtitle playlist for id "+r),this.hls.trigger(s.a.SUBTITLE_TRACK_LOADING,{url:n,id:r,groupId:i,deliveryDirectives:t||null})}},l.toggleTrackModes=function(t){var e=this,r=this.media,i=this.trackId;if(r){var n=ke(r.textTracks),a=n.filter((function(t){return t.groupId===e.groupId}));if(-1===t)[].slice.call(n).forEach((function(t){t.mode="disabled"}));else{var s=a[i];s&&(s.mode="disabled")}var o=a[t];o&&(o.mode=this.subtitleDisplay?"showing":"hidden")}},l.setSubtitleTrack=function(t,e){var r,i=this.tracksInGroup;if(this.media){if(this.trackId!==t&&this.toggleTrackModes(t),!(this.trackId===t&&(-1===t||null!==(r=i[t])&&void 0!==r&&r.details)||t<-1||t>=i.length)){this.clearTimer();var n=i[t];if(this.log("Switching to subtitle track "+t),this.trackId=t,n){var a=n.id,o=n.groupId,l=void 0===o?"":o,u=n.name,h=n.type,d=n.url;this.hls.trigger(s.a.SUBTITLE_TRACK_SWITCH,{id:a,groupId:l,name:u,type:h,url:d});var c=this.switchParams(n.url,null==e?void 0:e.details);this.loadPlaylist(c)}else this.hls.trigger(s.a.SUBTITLE_TRACK_SWITCH,{id:t})}}else this.queuedDefaultTrack=t},l.onTextTracksChanged=function(){if(this.useTextTrackPolling||self.clearInterval(this.subtitlePollingInterval),this.media&&this.hls.config.renderTextTracksNatively){for(var t=-1,e=ke(this.media.textTracks),r=0;r<e.length;r++)if("hidden"===e[r].mode)t=r;else if("showing"===e[r].mode){t=r;break}this.subtitleTrack!==t&&(this.subtitleTrack=t)}},n=i,(a=[{key:"subtitleDisplay",get:function(){return this._subtitleDisplay},set:function(t){this._subtitleDisplay=t,this.trackId>-1&&this.toggleTrackModes(this.trackId)}},{key:"subtitleTracks",get:function(){return this.tracksInGroup}},{key:"subtitleTrack",get:function(){return this.trackId},set:function(t){this.selectDefaultTrack=!1;var e=this.tracksInGroup?this.tracksInGroup[this.trackId]:void 0;this.setSubtitleTrack(t,e)}}])&&De(n.prototype,a),o&&De(n,o),Object.defineProperty(n,"prototype",{writable:!1}),i}(at),Oe=function(){function t(t){this.buffers=void 0,this.queues={video:[],audio:[],audiovideo:[]},this.buffers=t}var e=t.prototype;return e.append=function(t,e){var r=this.queues[e];r.push(t),1===r.length&&this.buffers[e]&&this.executeNext(e)},e.insertAbort=function(t,e){this.queues[e].unshift(t),this.executeNext(e)},e.appendBlocker=function(t){var e,r=new Promise((function(t){e=t})),i={execute:e,onStart:function(){},onComplete:function(){},onError:function(){}};return this.append(i,t),r},e.executeNext=function(t){var e=this.buffers,r=this.queues,i=e[t],n=r[t];if(n.length){var a=n[0];try{a.execute()}catch(e){l.b.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"),a.onError(e),i&&i.updating||(n.shift(),this.executeNext(t))}}},e.shiftAndExecuteNext=function(t){this.queues[t].shift(),this.executeNext(t)},e.current=function(t){return this.queues[t][0]},t}(),we=te(),Ce=/([ha]vc.)(?:\.[^.,]+)+/,xe=function(){function t(t){var e=this;this.details=null,this._objectUrl=null,this.operationQueue=void 0,this.listeners=void 0,this.hls=void 0,this.bufferCodecEventsExpected=0,this._bufferCodecEventsTotal=0,this.media=null,this.mediaSource=null,this.appendError=0,this.tracks={},this.pendingTracks={},this.sourceBuffer=void 0,this._onMediaSourceOpen=function(){var t=e.hls,r=e.media,i=e.mediaSource;l.b.log("[buffer-controller]: Media source opened"),r&&(e.updateMediaElementDuration(),t.trigger(s.a.MEDIA_ATTACHED,{media:r})),i&&i.removeEventListener("sourceopen",e._onMediaSourceOpen),e.checkPendingTracks()},this._onMediaSourceClose=function(){l.b.log("[buffer-controller]: Media source closed")},this._onMediaSourceEnded=function(){l.b.log("[buffer-controller]: Media source ended")},this.hls=t,this._initSourceBuffer(),this.registerListeners()}var e=t.prototype;return e.hasSourceTypes=function(){return this.getSourceBufferTypes().length>0||Object.keys(this.pendingTracks).length>0},e.destroy=function(){this.unregisterListeners(),this.details=null},e.registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.on(s.a.BUFFER_RESET,this.onBufferReset,this),t.on(s.a.BUFFER_APPENDING,this.onBufferAppending,this),t.on(s.a.BUFFER_CODECS,this.onBufferCodecs,this),t.on(s.a.BUFFER_EOS,this.onBufferEos,this),t.on(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(s.a.LEVEL_UPDATED,this.onLevelUpdated,this),t.on(s.a.FRAG_PARSED,this.onFragParsed,this),t.on(s.a.FRAG_CHANGED,this.onFragChanged,this)},e.unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.off(s.a.BUFFER_RESET,this.onBufferReset,this),t.off(s.a.BUFFER_APPENDING,this.onBufferAppending,this),t.off(s.a.BUFFER_CODECS,this.onBufferCodecs,this),t.off(s.a.BUFFER_EOS,this.onBufferEos,this),t.off(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(s.a.LEVEL_UPDATED,this.onLevelUpdated,this),t.off(s.a.FRAG_PARSED,this.onFragParsed,this),t.off(s.a.FRAG_CHANGED,this.onFragChanged,this)},e._initSourceBuffer=function(){this.sourceBuffer={},this.operationQueue=new Oe(this.sourceBuffer),this.listeners={audio:[],video:[],audiovideo:[]}},e.onManifestParsed=function(t,e){var r=2;(e.audio&&!e.video||!e.altAudio)&&(r=1),this.bufferCodecEventsExpected=this._bufferCodecEventsTotal=r,this.details=null,l.b.log(this.bufferCodecEventsExpected+" bufferCodec event(s) expected")},e.onMediaAttaching=function(t,e){var r=this.media=e.media;if(r&&we){var i=this.mediaSource=new we;i.addEventListener("sourceopen",this._onMediaSourceOpen),i.addEventListener("sourceended",this._onMediaSourceEnded),i.addEventListener("sourceclose",this._onMediaSourceClose),r.src=self.URL.createObjectURL(i),this._objectUrl=r.src}},e.onMediaDetaching=function(){var t=this.media,e=this.mediaSource,r=this._objectUrl;if(e){if(l.b.log("[buffer-controller]: media source detaching"),"open"===e.readyState)try{e.endOfStream()}catch(t){l.b.warn("[buffer-controller]: onMediaDetaching: "+t.message+" while calling endOfStream")}this.onBufferReset(),e.removeEventListener("sourceopen",this._onMediaSourceOpen),e.removeEventListener("sourceended",this._onMediaSourceEnded),e.removeEventListener("sourceclose",this._onMediaSourceClose),t&&(r&&self.URL.revokeObjectURL(r),t.src===r?(t.removeAttribute("src"),t.load()):l.b.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")),this.mediaSource=null,this.media=null,this._objectUrl=null,this.bufferCodecEventsExpected=this._bufferCodecEventsTotal,this.pendingTracks={},this.tracks={}}this.hls.trigger(s.a.MEDIA_DETACHED,void 0)},e.onBufferReset=function(){var t=this;this.getSourceBufferTypes().forEach((function(e){var r=t.sourceBuffer[e];try{r&&(t.removeBufferListeners(e),t.mediaSource&&t.mediaSource.removeSourceBuffer(r),t.sourceBuffer[e]=void 0)}catch(t){l.b.warn("[buffer-controller]: Failed to reset the "+e+" buffer",t)}})),this._initSourceBuffer()},e.onBufferCodecs=function(t,e){var r=this,i=this.getSourceBufferTypes().length;Object.keys(e).forEach((function(t){if(i){var n=r.tracks[t];if(n&&"function"==typeof n.buffer.changeType){var a=e[t],s=a.id,o=a.codec,u=a.levelCodec,h=a.container,d=a.metadata,c=(n.levelCodec||n.codec).replace(Ce,"$1"),f=(u||o).replace(Ce,"$1");if(c!==f){var g=h+";codecs="+(u||o);r.appendChangeType(t,g),l.b.log("[buffer-controller]: switching codec "+c+" to "+f),r.tracks[t]={buffer:n.buffer,codec:o,container:h,levelCodec:u,metadata:d,id:s}}}}else r.pendingTracks[t]=e[t]})),i||(this.bufferCodecEventsExpected=Math.max(this.bufferCodecEventsExpected-1,0),this.mediaSource&&"open"===this.mediaSource.readyState&&this.checkPendingTracks())},e.appendChangeType=function(t,e){var r=this,i=this.operationQueue,n={execute:function(){var n=r.sourceBuffer[t];n&&(l.b.log("[buffer-controller]: changing "+t+" sourceBuffer type to "+e),n.changeType(e)),i.shiftAndExecuteNext(t)},onStart:function(){},onComplete:function(){},onError:function(e){l.b.warn("[buffer-controller]: Failed to change "+t+" SourceBuffer type",e)}};i.append(n,t)},e.onBufferAppending=function(t,e){var r=this,i=this.hls,n=this.operationQueue,a=this.tracks,u=e.data,h=e.type,d=e.frag,c=e.part,f=e.chunkMeta,g=f.buffering[h],v=self.performance.now();g.start=v;var p=d.stats.buffering,m=c?c.stats.buffering:null;0===p.start&&(p.start=v),m&&0===m.start&&(m.start=v);var y=a.audio,T="audio"===h&&1===f.id&&"audio/mpeg"===(null==y?void 0:y.container),b={execute:function(){if(g.executeStart=self.performance.now(),T){var t=r.sourceBuffer[h];if(t){var e=d.start-t.timestampOffset;Math.abs(e)>=.1&&(l.b.log("[buffer-controller]: Updating audio SourceBuffer timestampOffset to "+d.start+" (delta: "+e+") sn: "+d.sn+")"),t.timestampOffset=d.start)}}r.appendExecutor(u,h)},onStart:function(){},onComplete:function(){var t=self.performance.now();g.executeEnd=g.end=t,0===p.first&&(p.first=t),m&&0===m.first&&(m.first=t);var e=r.sourceBuffer,i={};for(var n in e)i[n]=mt.getBuffered(e[n]);r.appendError=0,r.hls.trigger(s.a.BUFFER_APPENDED,{type:h,frag:d,part:c,chunkMeta:f,parent:d.type,timeRanges:i})},onError:function(t){l.b.error("[buffer-controller]: Error encountered while trying to append to the "+h+" SourceBuffer",t);var e={type:o.b.MEDIA_ERROR,parent:d.type,details:o.a.BUFFER_APPEND_ERROR,err:t,fatal:!1};t.code===DOMException.QUOTA_EXCEEDED_ERR?e.details=o.a.BUFFER_FULL_ERROR:(r.appendError++,e.details=o.a.BUFFER_APPEND_ERROR,r.appendError>i.config.appendErrorMaxRetry&&(l.b.error("[buffer-controller]: Failed "+i.config.appendErrorMaxRetry+" times to append segment in sourceBuffer"),e.fatal=!0)),i.trigger(s.a.ERROR,e)}};n.append(b,h)},e.onBufferFlushing=function(t,e){var r=this,i=this.operationQueue,n=function(t){return{execute:r.removeExecutor.bind(r,t,e.startOffset,e.endOffset),onStart:function(){},onComplete:function(){r.hls.trigger(s.a.BUFFER_FLUSHED,{type:t})},onError:function(e){l.b.warn("[buffer-controller]: Failed to remove from "+t+" SourceBuffer",e)}}};e.type?i.append(n(e.type),e.type):this.getSourceBufferTypes().forEach((function(t){i.append(n(t),t)}))},e.onFragParsed=function(t,e){var r=this,i=e.frag,n=e.part,a=[],o=n?n.elementaryStreams:i.elementaryStreams;o[p.a.AUDIOVIDEO]?a.push("audiovideo"):(o[p.a.AUDIO]&&a.push("audio"),o[p.a.VIDEO]&&a.push("video"));0===a.length&&l.b.warn("Fragments must have at least one ElementaryStreamType set. type: "+i.type+" level: "+i.level+" sn: "+i.sn),this.blockBuffers((function(){var t=self.performance.now();i.stats.buffering.end=t,n&&(n.stats.buffering.end=t);var e=n?n.stats:i.stats;r.hls.trigger(s.a.FRAG_BUFFERED,{frag:i,part:n,stats:e,id:i.type})}),a)},e.onFragChanged=function(t,e){this.flushBackBuffer()},e.onBufferEos=function(t,e){var r=this;this.getSourceBufferTypes().reduce((function(t,i){var n=r.sourceBuffer[i];return e.type&&e.type!==i||n&&!n.ended&&(n.ended=!0,l.b.log("[buffer-controller]: "+i+" sourceBuffer now EOS")),t&&!(n&&!n.ended)}),!0)&&this.blockBuffers((function(){var t=r.mediaSource;t&&"open"===t.readyState&&t.endOfStream()}))},e.onLevelUpdated=function(t,e){var r=e.details;r.fragments.length&&(this.details=r,this.getSourceBufferTypes().length?this.blockBuffers(this.updateMediaElementDuration.bind(this)):this.updateMediaElementDuration())},e.flushBackBuffer=function(){var t=this.hls,e=this.details,r=this.media,i=this.sourceBuffer;if(r&&null!==e){var n=this.getSourceBufferTypes();if(n.length){var o=e.live&&null!==t.config.liveBackBufferLength?t.config.liveBackBufferLength:t.config.backBufferLength;if(Object(a.a)(o)&&!(o<0)){var l=r.currentTime,u=e.levelTargetDuration,h=Math.max(o,u),d=Math.floor(l/u)*u-h;n.forEach((function(r){var n=i[r];if(n){var a=mt.getBuffered(n);a.length>0&&d>a.start(0)&&(t.trigger(s.a.BACK_BUFFER_REACHED,{bufferEnd:d}),e.live&&t.trigger(s.a.LIVE_BACK_BUFFER_REACHED,{bufferEnd:d}),t.trigger(s.a.BUFFER_FLUSHING,{startOffset:0,endOffset:d,type:r}))}}))}}}},e.updateMediaElementDuration=function(){if(this.details&&this.media&&this.mediaSource&&"open"===this.mediaSource.readyState){var t=this.details,e=this.hls,r=this.media,i=this.mediaSource,n=t.fragments[0].start+t.totalduration,s=r.duration,o=Object(a.a)(i.duration)?i.duration:0;t.live&&e.config.liveDurationInfinity?(l.b.log("[buffer-controller]: Media Source duration is set to Infinity"),i.duration=1/0,this.updateSeekableRange(t)):(n>o&&n>s||!Object(a.a)(s))&&(l.b.log("[buffer-controller]: Updating Media Source duration to "+n.toFixed(3)),i.duration=n)}},e.updateSeekableRange=function(t){var e=this.mediaSource,r=t.fragments;if(r.length&&t.live&&null!=e&&e.setLiveSeekableRange){var i=Math.max(0,r[0].start),n=Math.max(i,i+t.totalduration);e.setLiveSeekableRange(i,n)}},e.checkPendingTracks=function(){var t=this.bufferCodecEventsExpected,e=this.operationQueue,r=this.pendingTracks,i=Object.keys(r).length;if(i&&!t||2===i){this.createSourceBuffers(r),this.pendingTracks={};var n=this.getSourceBufferTypes();if(0===n.length)return void this.hls.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_INCOMPATIBLE_CODECS_ERROR,fatal:!0,reason:"could not create source buffer for media codec(s)"});n.forEach((function(t){e.executeNext(t)}))}},e.createSourceBuffers=function(t){var e=this.sourceBuffer,r=this.mediaSource;if(!r)throw Error("createSourceBuffers called when mediaSource was null");var i=0;for(var n in t)if(!e[n]){var a=t[n];if(!a)throw Error("source buffer exists for track "+n+", however track does not");var u=a.levelCodec||a.codec,h=a.container+";codecs="+u;l.b.log("[buffer-controller]: creating sourceBuffer("+h+")");try{var d=e[n]=r.addSourceBuffer(h),c=n;this.addBufferListener(c,"updatestart",this._onSBUpdateStart),this.addBufferListener(c,"updateend",this._onSBUpdateEnd),this.addBufferListener(c,"error",this._onSBUpdateError),this.tracks[n]={buffer:d,codec:u,container:a.container,levelCodec:a.levelCodec,metadata:a.metadata,id:a.id},i++}catch(t){l.b.error("[buffer-controller]: error while trying to add sourceBuffer: "+t.message),this.hls.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_ADD_CODEC_ERROR,fatal:!1,error:t,mimeType:h})}}i&&this.hls.trigger(s.a.BUFFER_CREATED,{tracks:this.tracks})},e._onSBUpdateStart=function(t){this.operationQueue.current(t).onStart()},e._onSBUpdateEnd=function(t){var e=this.operationQueue;e.current(t).onComplete(),e.shiftAndExecuteNext(t)},e._onSBUpdateError=function(t,e){l.b.error("[buffer-controller]: "+t+" SourceBuffer error",e),this.hls.trigger(s.a.ERROR,{type:o.b.MEDIA_ERROR,details:o.a.BUFFER_APPENDING_ERROR,fatal:!1});var r=this.operationQueue.current(t);r&&r.onError(e)},e.removeExecutor=function(t,e,r){var i=this.media,n=this.mediaSource,s=this.operationQueue,o=this.sourceBuffer[t];if(!i||!n||!o)return l.b.warn("[buffer-controller]: Attempting to remove from the "+t+" SourceBuffer, but it does not exist"),void s.shiftAndExecuteNext(t);var u=Object(a.a)(i.duration)?i.duration:1/0,h=Object(a.a)(n.duration)?n.duration:1/0,d=Math.max(0,e),c=Math.min(r,u,h);c>d?(l.b.log("[buffer-controller]: Removing ["+d+","+c+"] from the "+t+" SourceBuffer"),o.remove(d,c)):s.shiftAndExecuteNext(t)},e.appendExecutor=function(t,e){var r=this.operationQueue,i=this.sourceBuffer[e];if(!i)return l.b.warn("[buffer-controller]: Attempting to append to the "+e+" SourceBuffer, but it does not exist"),void r.shiftAndExecuteNext(e);i.ended=!1,i.appendBuffer(t)},e.blockBuffers=function(t,e){var r=this;if(void 0===e&&(e=this.getSourceBufferTypes()),!e.length)return l.b.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"),void Promise.resolve().then(t);var i=this.operationQueue,n=e.map((function(t){return i.appendBlocker(t)}));Promise.all(n).then((function(){t(),e.forEach((function(t){var e=r.sourceBuffer[t];e&&e.updating||i.shiftAndExecuteNext(t)}))}))},e.getSourceBufferTypes=function(){return Object.keys(this.sourceBuffer)},e.addBufferListener=function(t,e,r){var i=this.sourceBuffer[t];if(i){var n=r.bind(this,t);this.listeners[t].push({event:e,listener:n}),i.addEventListener(e,n)}},e.removeBufferListeners=function(t){var e=this.sourceBuffer[t];e&&this.listeners[t].forEach((function(t){e.removeEventListener(t.event,t.listener)}))},t}(),Pe={42:225,92:233,94:237,95:243,96:250,123:231,124:247,125:209,126:241,127:9608,128:174,129:176,130:189,131:191,132:8482,133:162,134:163,135:9834,136:224,137:32,138:232,139:226,140:234,141:238,142:244,143:251,144:193,145:201,146:211,147:218,148:220,149:252,150:8216,151:161,152:42,153:8217,154:9473,155:169,156:8480,157:8226,158:8220,159:8221,160:192,161:194,162:199,163:200,164:202,165:203,166:235,167:206,168:207,169:239,170:212,171:217,172:249,173:219,174:171,175:187,176:195,177:227,178:205,179:204,180:236,181:210,182:242,183:213,184:245,185:123,186:125,187:92,188:94,189:95,190:124,191:8764,192:196,193:228,194:214,195:246,196:223,197:165,198:164,199:9475,200:197,201:229,202:216,203:248,204:9487,205:9491,206:9495,207:9499},Me=function(t){var e=t;return Pe.hasOwnProperty(t)&&(e=Pe[t]),String.fromCharCode(e)},Fe={17:1,18:3,21:5,22:7,23:9,16:11,19:12,20:14},Ne={17:2,18:4,21:6,22:8,23:10,19:13,20:15},Ue={25:1,26:3,29:5,30:7,31:9,24:11,27:12,28:14},Be={25:2,26:4,29:6,30:8,31:10,27:13,28:15},Ge=["white","green","blue","cyan","red","yellow","magenta","black","transparent"];!function(t){t[t.ERROR=0]="ERROR",t[t.TEXT=1]="TEXT",t[t.WARNING=2]="WARNING",t[t.INFO=2]="INFO",t[t.DEBUG=3]="DEBUG",t[t.DATA=3]="DATA"}(_e||(_e={}));var je=function(){function t(){this.time=null,this.verboseLevel=_e.ERROR}return t.prototype.log=function(t,e){this.verboseLevel>=t&&l.b.log(this.time+" ["+t+"] "+e)},t}(),Ke=function(t){for(var e=[],r=0;r<t.length;r++)e.push(t[r].toString(16));return e},He=function(){function t(t,e,r,i,n){this.foreground=void 0,this.underline=void 0,this.italics=void 0,this.background=void 0,this.flash=void 0,this.foreground=t||"white",this.underline=e||!1,this.italics=r||!1,this.background=i||"black",this.flash=n||!1}var e=t.prototype;return e.reset=function(){this.foreground="white",this.underline=!1,this.italics=!1,this.background="black",this.flash=!1},e.setStyles=function(t){for(var e=["foreground","underline","italics","background","flash"],r=0;r<e.length;r++){var i=e[r];t.hasOwnProperty(i)&&(this[i]=t[i])}},e.isDefault=function(){return"white"===this.foreground&&!this.underline&&!this.italics&&"black"===this.background&&!this.flash},e.equals=function(t){return this.foreground===t.foreground&&this.underline===t.underline&&this.italics===t.italics&&this.background===t.background&&this.flash===t.flash},e.copy=function(t){this.foreground=t.foreground,this.underline=t.underline,this.italics=t.italics,this.background=t.background,this.flash=t.flash},e.toString=function(){return"color="+this.foreground+", underline="+this.underline+", italics="+this.italics+", background="+this.background+", flash="+this.flash},t}(),Ve=function(){function t(t,e,r,i,n,a){this.uchar=void 0,this.penState=void 0,this.uchar=t||" ",this.penState=new He(e,r,i,n,a)}var e=t.prototype;return e.reset=function(){this.uchar=" ",this.penState.reset()},e.setChar=function(t,e){this.uchar=t,this.penState.copy(e)},e.setPenState=function(t){this.penState.copy(t)},e.equals=function(t){return this.uchar===t.uchar&&this.penState.equals(t.penState)},e.copy=function(t){this.uchar=t.uchar,this.penState.copy(t.penState)},e.isEmpty=function(){return" "===this.uchar&&this.penState.isDefault()},t}(),We=function(){function t(t){this.chars=void 0,this.pos=void 0,this.currPenState=void 0,this.cueStartTime=void 0,this.logger=void 0,this.chars=[];for(var e=0;e<100;e++)this.chars.push(new Ve);this.logger=t,this.pos=0,this.currPenState=new He}var e=t.prototype;return e.equals=function(t){for(var e=!0,r=0;r<100;r++)if(!this.chars[r].equals(t.chars[r])){e=!1;break}return e},e.copy=function(t){for(var e=0;e<100;e++)this.chars[e].copy(t.chars[e])},e.isEmpty=function(){for(var t=!0,e=0;e<100;e++)if(!this.chars[e].isEmpty()){t=!1;break}return t},e.setCursor=function(t){this.pos!==t&&(this.pos=t),this.pos<0?(this.logger.log(_e.DEBUG,"Negative cursor position "+this.pos),this.pos=0):this.pos>100&&(this.logger.log(_e.DEBUG,"Too large cursor position "+this.pos),this.pos=100)},e.moveCursor=function(t){var e=this.pos+t;if(t>1)for(var r=this.pos+1;r<e+1;r++)this.chars[r].setPenState(this.currPenState);this.setCursor(e)},e.backSpace=function(){this.moveCursor(-1),this.chars[this.pos].setChar(" ",this.currPenState)},e.insertChar=function(t){t>=144&&this.backSpace();var e=Me(t);this.pos>=100?this.logger.log(_e.ERROR,"Cannot insert "+t.toString(16)+" ("+e+") at position "+this.pos+". Skipping it!"):(this.chars[this.pos].setChar(e,this.currPenState),this.moveCursor(1))},e.clearFromPos=function(t){var e;for(e=t;e<100;e++)this.chars[e].reset()},e.clear=function(){this.clearFromPos(0),this.pos=0,this.currPenState.reset()},e.clearToEndOfRow=function(){this.clearFromPos(this.pos)},e.getTextString=function(){for(var t=[],e=!0,r=0;r<100;r++){var i=this.chars[r].uchar;" "!==i&&(e=!1),t.push(i)}return e?"":t.join("")},e.setPenStyles=function(t){this.currPenState.setStyles(t),this.chars[this.pos].setPenState(this.currPenState)},t}(),Ye=function(){function t(t){this.rows=void 0,this.currRow=void 0,this.nrRollUpRows=void 0,this.lastOutputScreen=void 0,this.logger=void 0,this.rows=[];for(var e=0;e<15;e++)this.rows.push(new We(t));this.logger=t,this.currRow=14,this.nrRollUpRows=null,this.lastOutputScreen=null,this.reset()}var e=t.prototype;return e.reset=function(){for(var t=0;t<15;t++)this.rows[t].clear();this.currRow=14},e.equals=function(t){for(var e=!0,r=0;r<15;r++)if(!this.rows[r].equals(t.rows[r])){e=!1;break}return e},e.copy=function(t){for(var e=0;e<15;e++)this.rows[e].copy(t.rows[e])},e.isEmpty=function(){for(var t=!0,e=0;e<15;e++)if(!this.rows[e].isEmpty()){t=!1;break}return t},e.backSpace=function(){this.rows[this.currRow].backSpace()},e.clearToEndOfRow=function(){this.rows[this.currRow].clearToEndOfRow()},e.insertChar=function(t){this.rows[this.currRow].insertChar(t)},e.setPen=function(t){this.rows[this.currRow].setPenStyles(t)},e.moveCursor=function(t){this.rows[this.currRow].moveCursor(t)},e.setCursor=function(t){this.logger.log(_e.INFO,"setCursor: "+t),this.rows[this.currRow].setCursor(t)},e.setPAC=function(t){this.logger.log(_e.INFO,"pacData = "+JSON.stringify(t));var e=t.row-1;if(this.nrRollUpRows&&e<this.nrRollUpRows-1&&(e=this.nrRollUpRows-1),this.nrRollUpRows&&this.currRow!==e){for(var r=0;r<15;r++)this.rows[r].clear();var i=this.currRow+1-this.nrRollUpRows,n=this.lastOutputScreen;if(n){var a=n.rows[i].cueStartTime,s=this.logger.time;if(a&&null!==s&&a<s)for(var o=0;o<this.nrRollUpRows;o++)this.rows[e-this.nrRollUpRows+o+1].copy(n.rows[i+o])}}this.currRow=e;var l=this.rows[this.currRow];if(null!==t.indent){var u=t.indent,h=Math.max(u-1,0);l.setCursor(t.indent),t.color=l.chars[h].penState.foreground}var d={foreground:t.color,underline:t.underline,italics:t.italics,background:"black",flash:!1};this.setPen(d)},e.setBkgData=function(t){this.logger.log(_e.INFO,"bkgData = "+JSON.stringify(t)),this.backSpace(),this.setPen(t),this.insertChar(32)},e.setRollUpRows=function(t){this.nrRollUpRows=t},e.rollUp=function(){if(null!==this.nrRollUpRows){this.logger.log(_e.TEXT,this.getDisplayText());var t=this.currRow+1-this.nrRollUpRows,e=this.rows.splice(t,1)[0];e.clear(),this.rows.splice(this.currRow,0,e),this.logger.log(_e.INFO,"Rolling up")}else this.logger.log(_e.DEBUG,"roll_up but nrRollUpRows not set yet")},e.getDisplayText=function(t){t=t||!1;for(var e=[],r="",i=-1,n=0;n<15;n++){var a=this.rows[n].getTextString();a&&(i=n+1,t?e.push("Row "+i+": '"+a+"'"):e.push(a.trim()))}return e.length>0&&(r=t?"["+e.join(" | ")+"]":e.join("\n")),r},e.getTextAndFormat=function(){return this.rows},t}(),qe=function(){function t(t,e,r){this.chNr=void 0,this.outputFilter=void 0,this.mode=void 0,this.verbose=void 0,this.displayedMemory=void 0,this.nonDisplayedMemory=void 0,this.lastOutputScreen=void 0,this.currRollUpRow=void 0,this.writeScreen=void 0,this.cueStartTime=void 0,this.logger=void 0,this.chNr=t,this.outputFilter=e,this.mode=null,this.verbose=0,this.displayedMemory=new Ye(r),this.nonDisplayedMemory=new Ye(r),this.lastOutputScreen=new Ye(r),this.currRollUpRow=this.displayedMemory.rows[14],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null,this.logger=r}var e=t.prototype;return e.reset=function(){this.mode=null,this.displayedMemory.reset(),this.nonDisplayedMemory.reset(),this.lastOutputScreen.reset(),this.outputFilter.reset(),this.currRollUpRow=this.displayedMemory.rows[14],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null},e.getHandler=function(){return this.outputFilter},e.setHandler=function(t){this.outputFilter=t},e.setPAC=function(t){this.writeScreen.setPAC(t)},e.setBkgData=function(t){this.writeScreen.setBkgData(t)},e.setMode=function(t){t!==this.mode&&(this.mode=t,this.logger.log(_e.INFO,"MODE="+t),"MODE_POP-ON"===this.mode?this.writeScreen=this.nonDisplayedMemory:(this.writeScreen=this.displayedMemory,this.writeScreen.reset()),"MODE_ROLL-UP"!==this.mode&&(this.displayedMemory.nrRollUpRows=null,this.nonDisplayedMemory.nrRollUpRows=null),this.mode=t)},e.insertChars=function(t){for(var e=0;e<t.length;e++)this.writeScreen.insertChar(t[e]);var r=this.writeScreen===this.displayedMemory?"DISP":"NON_DISP";this.logger.log(_e.INFO,r+": "+this.writeScreen.getDisplayText(!0)),"MODE_PAINT-ON"!==this.mode&&"MODE_ROLL-UP"!==this.mode||(this.logger.log(_e.TEXT,"DISPLAYED: "+this.displayedMemory.getDisplayText(!0)),this.outputDataUpdate())},e.ccRCL=function(){this.logger.log(_e.INFO,"RCL - Resume Caption Loading"),this.setMode("MODE_POP-ON")},e.ccBS=function(){this.logger.log(_e.INFO,"BS - BackSpace"),"MODE_TEXT"!==this.mode&&(this.writeScreen.backSpace(),this.writeScreen===this.displayedMemory&&this.outputDataUpdate())},e.ccAOF=function(){},e.ccAON=function(){},e.ccDER=function(){this.logger.log(_e.INFO,"DER- Delete to End of Row"),this.writeScreen.clearToEndOfRow(),this.outputDataUpdate()},e.ccRU=function(t){this.logger.log(_e.INFO,"RU("+t+") - Roll Up"),this.writeScreen=this.displayedMemory,this.setMode("MODE_ROLL-UP"),this.writeScreen.setRollUpRows(t)},e.ccFON=function(){this.logger.log(_e.INFO,"FON - Flash On"),this.writeScreen.setPen({flash:!0})},e.ccRDC=function(){this.logger.log(_e.INFO,"RDC - Resume Direct Captioning"),this.setMode("MODE_PAINT-ON")},e.ccTR=function(){this.logger.log(_e.INFO,"TR"),this.setMode("MODE_TEXT")},e.ccRTD=function(){this.logger.log(_e.INFO,"RTD"),this.setMode("MODE_TEXT")},e.ccEDM=function(){this.logger.log(_e.INFO,"EDM - Erase Displayed Memory"),this.displayedMemory.reset(),this.outputDataUpdate(!0)},e.ccCR=function(){this.logger.log(_e.INFO,"CR - Carriage Return"),this.writeScreen.rollUp(),this.outputDataUpdate(!0)},e.ccENM=function(){this.logger.log(_e.INFO,"ENM - Erase Non-displayed Memory"),this.nonDisplayedMemory.reset()},e.ccEOC=function(){if(this.logger.log(_e.INFO,"EOC - End Of Caption"),"MODE_POP-ON"===this.mode){var t=this.displayedMemory;this.displayedMemory=this.nonDisplayedMemory,this.nonDisplayedMemory=t,this.writeScreen=this.nonDisplayedMemory,this.logger.log(_e.TEXT,"DISP: "+this.displayedMemory.getDisplayText())}this.outputDataUpdate(!0)},e.ccTO=function(t){this.logger.log(_e.INFO,"TO("+t+") - Tab Offset"),this.writeScreen.moveCursor(t)},e.ccMIDROW=function(t){var e={flash:!1};if(e.underline=t%2==1,e.italics=t>=46,e.italics)e.foreground="white";else{var r=Math.floor(t/2)-16;e.foreground=["white","green","blue","cyan","red","yellow","magenta"][r]}this.logger.log(_e.INFO,"MIDROW: "+JSON.stringify(e)),this.writeScreen.setPen(e)},e.outputDataUpdate=function(t){void 0===t&&(t=!1);var e=this.logger.time;null!==e&&this.outputFilter&&(null!==this.cueStartTime||this.displayedMemory.isEmpty()?this.displayedMemory.equals(this.lastOutputScreen)||(this.outputFilter.newCue(this.cueStartTime,e,this.lastOutputScreen),t&&this.outputFilter.dispatchCue&&this.outputFilter.dispatchCue(),this.cueStartTime=this.displayedMemory.isEmpty()?null:e):this.cueStartTime=e,this.lastOutputScreen.copy(this.displayedMemory))},e.cueSplitAtTime=function(t){this.outputFilter&&(this.displayedMemory.isEmpty()||(this.outputFilter.newCue&&this.outputFilter.newCue(this.cueStartTime,t,this.displayedMemory),this.cueStartTime=t))},t}();function ze(t,e,r){r.a=t,r.b=e}function Xe(t,e,r){return r.a===t&&r.b===e}var Qe=function(){function t(t,e,r){this.channels=void 0,this.currentChannel=0,this.cmdHistory=void 0,this.logger=void 0;var i=new je;this.channels=[null,new qe(t,e,i),new qe(t+1,r,i)],this.cmdHistory={a:null,b:null},this.logger=i}var e=t.prototype;return e.getHandler=function(t){return this.channels[t].getHandler()},e.setHandler=function(t,e){this.channels[t].setHandler(e)},e.addData=function(t,e){var r,i,n,a=!1;this.logger.time=t;for(var s=0;s<e.length;s+=2)if(i=127&e[s],n=127&e[s+1],0!==i||0!==n){if(this.logger.log(_e.DATA,"["+Ke([e[s],e[s+1]])+"] -> ("+Ke([i,n])+")"),(r=this.parseCmd(i,n))||(r=this.parseMidrow(i,n)),r||(r=this.parsePAC(i,n)),r||(r=this.parseBackgroundAttributes(i,n)),!r&&(a=this.parseChars(i,n))){var o=this.currentChannel;if(o&&o>0)this.channels[o].insertChars(a);else this.logger.log(_e.WARNING,"No channel found yet. TEXT-MODE?")}r||a||this.logger.log(_e.WARNING,"Couldn't parse cleaned data "+Ke([i,n])+" orig: "+Ke([e[s],e[s+1]]))}},e.parseCmd=function(t,e){var r=this.cmdHistory;if(!((20===t||28===t||21===t||29===t)&&e>=32&&e<=47)&&!((23===t||31===t)&&e>=33&&e<=35))return!1;if(Xe(t,e,r))return ze(null,null,r),this.logger.log(_e.DEBUG,"Repeated command ("+Ke([t,e])+") is dropped"),!0;var i=20===t||21===t||23===t?1:2,n=this.channels[i];return 20===t||21===t||28===t||29===t?32===e?n.ccRCL():33===e?n.ccBS():34===e?n.ccAOF():35===e?n.ccAON():36===e?n.ccDER():37===e?n.ccRU(2):38===e?n.ccRU(3):39===e?n.ccRU(4):40===e?n.ccFON():41===e?n.ccRDC():42===e?n.ccTR():43===e?n.ccRTD():44===e?n.ccEDM():45===e?n.ccCR():46===e?n.ccENM():47===e&&n.ccEOC():n.ccTO(e-32),ze(t,e,r),this.currentChannel=i,!0},e.parseMidrow=function(t,e){var r=0;if((17===t||25===t)&&e>=32&&e<=47){if((r=17===t?1:2)!==this.currentChannel)return this.logger.log(_e.ERROR,"Mismatch channel in midrow parsing"),!1;var i=this.channels[r];return!!i&&(i.ccMIDROW(e),this.logger.log(_e.DEBUG,"MIDROW ("+Ke([t,e])+")"),!0)}return!1},e.parsePAC=function(t,e){var r,i=this.cmdHistory;if(!((t>=17&&t<=23||t>=25&&t<=31)&&e>=64&&e<=127)&&!((16===t||24===t)&&e>=64&&e<=95))return!1;if(Xe(t,e,i))return ze(null,null,i),!0;var n=t<=23?1:2;r=e>=64&&e<=95?1===n?Fe[t]:Ue[t]:1===n?Ne[t]:Be[t];var a=this.channels[n];return!!a&&(a.setPAC(this.interpretPAC(r,e)),ze(t,e,i),this.currentChannel=n,!0)},e.interpretPAC=function(t,e){var r,i={color:null,italics:!1,indent:null,underline:!1,row:t};return r=e>95?e-96:e-64,i.underline=1==(1&r),r<=13?i.color=["white","green","blue","cyan","red","yellow","magenta","white"][Math.floor(r/2)]:r<=15?(i.italics=!0,i.color="white"):i.indent=4*Math.floor((r-16)/2),i},e.parseChars=function(t,e){var r,i,n=null,a=null;(t>=25?(r=2,a=t-8):(r=1,a=t),a>=17&&a<=19)?(i=17===a?e+80:18===a?e+112:e+144,this.logger.log(_e.INFO,"Special char '"+Me(i)+"' in channel "+r),n=[i]):t>=32&&t<=127&&(n=0===e?[t]:[t,e]);if(n){var s=Ke(n);this.logger.log(_e.DEBUG,"Char codes =  "+s.join(",")),ze(t,e,this.cmdHistory)}return n},e.parseBackgroundAttributes=function(t,e){var r;if(!((16===t||24===t)&&e>=32&&e<=47)&&!((23===t||31===t)&&e>=45&&e<=47))return!1;var i={};16===t||24===t?(r=Math.floor((e-32)/2),i.background=Ge[r],e%2==1&&(i.background=i.background+"_semi")):45===e?i.background="transparent":(i.foreground="black",47===e&&(i.underline=!0));var n=t<=23?1:2;return this.channels[n].setBkgData(i),ze(t,e,this.cmdHistory),!0},e.reset=function(){for(var t=0;t<Object.keys(this.channels).length;t++){var e=this.channels[t];e&&e.reset()}this.cmdHistory={a:null,b:null}},e.cueSplitAtTime=function(t){for(var e=0;e<this.channels.length;e++){var r=this.channels[e];r&&r.cueSplitAtTime(t)}},t}(),$e=function(){function t(t,e){this.timelineController=void 0,this.cueRanges=[],this.trackName=void 0,this.startTime=null,this.endTime=null,this.screen=null,this.timelineController=t,this.trackName=e}var e=t.prototype;return e.dispatchCue=function(){null!==this.startTime&&(this.timelineController.addCues(this.trackName,this.startTime,this.endTime,this.screen,this.cueRanges),this.startTime=null)},e.newCue=function(t,e,r){(null===this.startTime||this.startTime>t)&&(this.startTime=t),this.endTime=e,this.screen=r,this.timelineController.createCaptionsTrack(this.trackName)},e.reset=function(){this.cueRanges=[],this.startTime=null},t}(),Je=function(){if("undefined"!=typeof self&&self.VTTCue)return self.VTTCue;var t=["","lr","rl"],e=["start","middle","end","left","right"];function r(t,e){if("string"!=typeof e)return!1;if(!Array.isArray(t))return!1;var r=e.toLowerCase();return!!~t.indexOf(r)&&r}function i(t){return r(e,t)}function n(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),i=1;i<e;i++)r[i-1]=arguments[i];for(var n=1;n<arguments.length;n++){var a=arguments[n];for(var s in a)t[s]=a[s]}return t}function a(e,a,s){var o=this,l={enumerable:!0};o.hasBeenReset=!1;var u="",h=!1,d=e,c=a,f=s,g=null,v="",p=!0,m="auto",y="start",T=50,b="middle",E=50,S="middle";Object.defineProperty(o,"id",n({},l,{get:function(){return u},set:function(t){u=""+t}})),Object.defineProperty(o,"pauseOnExit",n({},l,{get:function(){return h},set:function(t){h=!!t}})),Object.defineProperty(o,"startTime",n({},l,{get:function(){return d},set:function(t){if("number"!=typeof t)throw new TypeError("Start time must be set to a number.");d=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"endTime",n({},l,{get:function(){return c},set:function(t){if("number"!=typeof t)throw new TypeError("End time must be set to a number.");c=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"text",n({},l,{get:function(){return f},set:function(t){f=""+t,this.hasBeenReset=!0}})),Object.defineProperty(o,"region",n({},l,{get:function(){return g},set:function(t){g=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"vertical",n({},l,{get:function(){return v},set:function(e){var i=function(e){return r(t,e)}(e);if(!1===i)throw new SyntaxError("An invalid or illegal string was specified.");v=i,this.hasBeenReset=!0}})),Object.defineProperty(o,"snapToLines",n({},l,{get:function(){return p},set:function(t){p=!!t,this.hasBeenReset=!0}})),Object.defineProperty(o,"line",n({},l,{get:function(){return m},set:function(t){if("number"!=typeof t&&"auto"!==t)throw new SyntaxError("An invalid number or illegal string was specified.");m=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"lineAlign",n({},l,{get:function(){return y},set:function(t){var e=i(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");y=e,this.hasBeenReset=!0}})),Object.defineProperty(o,"position",n({},l,{get:function(){return T},set:function(t){if(t<0||t>100)throw new Error("Position must be between 0 and 100.");T=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"positionAlign",n({},l,{get:function(){return b},set:function(t){var e=i(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");b=e,this.hasBeenReset=!0}})),Object.defineProperty(o,"size",n({},l,{get:function(){return E},set:function(t){if(t<0||t>100)throw new Error("Size must be between 0 and 100.");E=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"align",n({},l,{get:function(){return S},set:function(t){var e=i(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");S=e,this.hasBeenReset=!0}})),o.displayState=void 0}return a.prototype.getCueAsHTML=function(){return self.WebVTT.convertCueToDOMTree(self,this.text)},a}(),Ze=function(){function t(){}return t.prototype.decode=function(t,e){if(!t)return"";if("string"!=typeof t)throw new Error("Error - expected string data.");return decodeURIComponent(encodeURIComponent(t))},t}();function tr(t){function e(t,e,r,i){return 3600*(0|t)+60*(0|e)+(0|r)+parseFloat(i||0)}var r=t.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);return r?parseFloat(r[2])>59?e(r[2],r[3],0,r[4]):e(r[1],r[2],r[3],r[4]):null}var er=function(){function t(){this.values=Object.create(null)}var e=t.prototype;return e.set=function(t,e){this.get(t)||""===e||(this.values[t]=e)},e.get=function(t,e,r){return r?this.has(t)?this.values[t]:e[r]:this.has(t)?this.values[t]:e},e.has=function(t){return t in this.values},e.alt=function(t,e,r){for(var i=0;i<r.length;++i)if(e===r[i]){this.set(t,e);break}},e.integer=function(t,e){/^-?\d+$/.test(e)&&this.set(t,parseInt(e,10))},e.percent=function(t,e){if(/^([\d]{1,3})(\.[\d]*)?%$/.test(e)){var r=parseFloat(e);if(r>=0&&r<=100)return this.set(t,r),!0}return!1},t}();function rr(t,e,r,i){var n=i?t.split(i):[t];for(var a in n)if("string"==typeof n[a]){var s=n[a].split(r);if(2===s.length)e(s[0],s[1])}}var ir=new Je(0,0,""),nr="middle"===ir.align?"middle":"center";function ar(t,e,r){var i=t;function n(){var e=tr(t);if(null===e)throw new Error("Malformed timestamp: "+i);return t=t.replace(/^[^\sa-zA-Z-]+/,""),e}function a(){t=t.replace(/^\s+/,"")}if(a(),e.startTime=n(),a(),"--\x3e"!==t.slice(0,3))throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): "+i);t=t.slice(3),a(),e.endTime=n(),a(),function(t,e){var i=new er;rr(t,(function(t,e){var n;switch(t){case"region":for(var a=r.length-1;a>=0;a--)if(r[a].id===e){i.set(t,r[a].region);break}break;case"vertical":i.alt(t,e,["rl","lr"]);break;case"line":n=e.split(","),i.integer(t,n[0]),i.percent(t,n[0])&&i.set("snapToLines",!1),i.alt(t,n[0],["auto"]),2===n.length&&i.alt("lineAlign",n[1],["start",nr,"end"]);break;case"position":n=e.split(","),i.percent(t,n[0]),2===n.length&&i.alt("positionAlign",n[1],["start",nr,"end","line-left","line-right","auto"]);break;case"size":i.percent(t,e);break;case"align":i.alt(t,e,["start",nr,"end","left","right"])}}),/:/,/\s/),e.region=i.get("region",null),e.vertical=i.get("vertical","");var n=i.get("line","auto");"auto"===n&&-1===ir.line&&(n=-1),e.line=n,e.lineAlign=i.get("lineAlign","start"),e.snapToLines=i.get("snapToLines",!0),e.size=i.get("size",100),e.align=i.get("align",nr);var a=i.get("position","auto");"auto"===a&&50===ir.position&&(a="start"===e.align||"left"===e.align?0:"end"===e.align||"right"===e.align?100:50),e.position=a}(t,e)}function sr(t){return t.replace(/<br(?: \/)?>/gi,"\n")}var or=function(){function t(){this.state="INITIAL",this.buffer="",this.decoder=new Ze,this.regionList=[],this.cue=null,this.oncue=void 0,this.onparsingerror=void 0,this.onflush=void 0}var e=t.prototype;return e.parse=function(t){var e=this;function r(){var t=e.buffer,r=0;for(t=sr(t);r<t.length&&"\r"!==t[r]&&"\n"!==t[r];)++r;var i=t.slice(0,r);return"\r"===t[r]&&++r,"\n"===t[r]&&++r,e.buffer=t.slice(r),i}t&&(e.buffer+=e.decoder.decode(t,{stream:!0}));try{var i="";if("INITIAL"===e.state){if(!/\r\n|\n/.test(e.buffer))return this;var n=(i=r()).match(/^(ï»¿)?WEBVTT([ \t].*)?$/);if(!n||!n[0])throw new Error("Malformed WebVTT signature.");e.state="HEADER"}for(var a=!1;e.buffer;){if(!/\r\n|\n/.test(e.buffer))return this;switch(a?a=!1:i=r(),e.state){case"HEADER":/:/.test(i)?rr(i,(function(t,e){}),/:/):i||(e.state="ID");continue;case"NOTE":i||(e.state="ID");continue;case"ID":if(/^NOTE($|[ \t])/.test(i)){e.state="NOTE";break}if(!i)continue;if(e.cue=new Je(0,0,""),e.state="CUE",-1===i.indexOf("--\x3e")){e.cue.id=i;continue}case"CUE":if(!e.cue){e.state="BADCUE";continue}try{ar(i,e.cue,e.regionList)}catch(t){e.cue=null,e.state="BADCUE";continue}e.state="CUETEXT";continue;case"CUETEXT":var s=-1!==i.indexOf("--\x3e");if(!i||s&&(a=!0)){e.oncue&&e.cue&&e.oncue(e.cue),e.cue=null,e.state="ID";continue}if(null===e.cue)continue;e.cue.text&&(e.cue.text+="\n"),e.cue.text+=i;continue;case"BADCUE":i||(e.state="ID")}}}catch(t){"CUETEXT"===e.state&&e.cue&&e.oncue&&e.oncue(e.cue),e.cue=null,e.state="INITIAL"===e.state?"BADWEBVTT":"BADCUE"}return this},e.flush=function(){try{if((this.cue||"HEADER"===this.state)&&(this.buffer+="\n\n",this.parse()),"INITIAL"===this.state||"BADWEBVTT"===this.state)throw new Error("Malformed WebVTT signature.")}catch(t){this.onparsingerror&&this.onparsingerror(t)}return this.onflush&&this.onflush(),this},t}(),lr=r(9),ur=r(13),hr=/\r\n|\n\r|\n|\r/g,dr=function(t,e,r){return void 0===r&&(r=0),t.slice(r,r+e.length)===e},cr=function(t){for(var e=5381,r=t.length;r;)e=33*e^t.charCodeAt(--r);return(e>>>0).toString()};function fr(t,e,r){return cr(t.toString())+cr(e.toString())+cr(r)}function gr(t,e,r,i,n,s,o,l){var u,h=new or,d=Object(G.f)(new Uint8Array(t)).trim().replace(hr,"\n").split("\n"),c=[],f=Object(lr.a)(e,r),g="00:00.000",v=0,p=0,m=!0;h.oncue=function(t){var e=i[n],r=i.ccOffset,a=(v-f)/9e4;null!=e&&e.new&&(void 0!==p?r=i.ccOffset=e.start:function(t,e,r){var i=t[e],n=t[i.prevCC];if(!n||!n.new&&i.new)return t.ccOffset=t.presentationOffset=i.start,void(i.new=!1);for(;null!==(a=n)&&void 0!==a&&a.new;){var a;t.ccOffset+=i.start-n.start,i.new=!1,n=t[(i=n).prevCC]}t.presentationOffset=r}(i,n,a)),a&&(r=a-i.presentationOffset);var o=t.endTime-t.startTime,l=Object(ur.d)(9e4*(t.startTime+r-p),9e4*s)/9e4;t.startTime=Math.max(l,0),t.endTime=Math.max(l+o,0);var u=t.text.trim();t.text=decodeURIComponent(encodeURIComponent(u)),t.id||(t.id=fr(t.startTime,t.endTime,u)),t.endTime>0&&c.push(t)},h.onparsingerror=function(t){u=t},h.onflush=function(){u?l(u):o(c)},d.forEach((function(t){if(m){if(dr(t,"X-TIMESTAMP-MAP=")){m=!1,t.slice(16).split(",").forEach((function(t){dr(t,"LOCAL:")?g=t.slice(6):dr(t,"MPEGTS:")&&(v=parseInt(t.slice(7)))}));try{p=function(t){var e=parseInt(t.slice(-3)),r=parseInt(t.slice(-6,-4)),i=parseInt(t.slice(-9,-7)),n=t.length>9?parseInt(t.substring(0,t.indexOf(":"))):0;if(!(Object(a.a)(e)&&Object(a.a)(r)&&Object(a.a)(i)&&Object(a.a)(n)))throw Error("Malformed X-TIMESTAMP-MAP: Local:"+t);return e+=1e3*r,e+=6e4*i,e+=36e5*n}(g)/1e3}catch(t){u=t}return}""===t&&(m=!1)}h.parse(t+"\n")})),h.flush()}function vr(){return(vr=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}var pr=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,mr=/^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,yr={left:"start",center:"center",right:"end",start:"start",end:"end"};function Tr(t,e,r,i,n){var a=Object(u.c)(new Uint8Array(t),["mdat"]);if(0!==a.length){var s=a.map((function(t){return Object(G.f)(t)})),o=Object(lr.c)(e,1,r);try{s.forEach((function(t){return i(function(t,e){var r=(new DOMParser).parseFromString(t,"text/xml").getElementsByTagName("tt")[0];if(!r)throw new Error("Invalid ttml");var i={frameRate:30,subFrameRate:1,frameRateMultiplier:0,tickRate:0},n=Object.keys(i).reduce((function(t,e){return t[e]=r.getAttribute("ttp:"+e)||i[e],t}),{}),a="preserve"!==r.getAttribute("xml:space"),s=Er(br(r,"styling","style")),o=Er(br(r,"layout","region")),l=br(r,"body","[begin]");return[].map.call(l,(function(t){var r=function t(e,r){return[].slice.call(e.childNodes).reduce((function(e,i,n){var a;return"br"===i.nodeName&&n?e+"\n":null!==(a=i.childNodes)&&void 0!==a&&a.length?t(i,r):r?e+i.textContent.trim().replace(/\s+/g," "):e+i.textContent}),"")}(t,a);if(!r||!t.hasAttribute("begin"))return null;var i=Ar(t.getAttribute("begin"),n),l=Ar(t.getAttribute("dur"),n),u=Ar(t.getAttribute("end"),n);if(null===i)throw Lr(t);if(null===u){if(null===l)throw Lr(t);u=i+l}var h=new Je(i-e,u-e,r);h.id=fr(h.startTime,h.endTime,h.text);var d=o[t.getAttribute("region")],c=s[t.getAttribute("style")];h.position=10,h.size=80;var f=function(t,e,r){var i="http://www.w3.org/ns/ttml#styling",n=null,a=null!=t&&t.hasAttribute("style")?t.getAttribute("style"):null;a&&r.hasOwnProperty(a)&&(n=r[a]);return["displayAlign","textAlign","color","backgroundColor","fontSize","fontFamily"].reduce((function(r,a){var s=Sr(e,i,a)||Sr(t,i,a)||Sr(n,i,a);return s&&(r[a]=s),r}),{})}(d,c,s),g=f.textAlign;if(g){var v=yr[g];v&&(h.lineAlign=v),h.align=g}return vr(h,f),h})).filter((function(t){return null!==t}))}(t,o))}))}catch(t){n(t)}}else n(new Error("Could not parse IMSC1 mdat"))}function br(t,e,r){var i=t.getElementsByTagName(e)[0];return i?[].slice.call(i.querySelectorAll(r)):[]}function Er(t){return t.reduce((function(t,e){var r=e.getAttribute("xml:id");return r&&(t[r]=e),t}),{})}function Sr(t,e,r){return t&&t.hasAttributeNS(e,r)?t.getAttributeNS(e,r):null}function Lr(t){return new Error("Could not parse ttml timestamp "+t)}function Ar(t,e){if(!t)return null;var r=tr(t);return null===r&&(pr.test(t)?r=function(t,e){var r=pr.exec(t),i=(0|r[4])+(0|r[5])/e.subFrameRate;return 3600*(0|r[1])+60*(0|r[2])+(0|r[3])+i/e.frameRate}(t,e):mr.test(t)&&(r=function(t,e){var r=mr.exec(t),i=Number(r[1]);switch(r[2]){case"h":return 3600*i;case"m":return 60*i;case"ms":return 1e3*i;case"f":return i/e.frameRate;case"t":return i/e.tickRate}return i}(t,e))),r}var Dr=function(){function t(t){if(this.hls=void 0,this.media=null,this.config=void 0,this.enabled=!0,this.Cues=void 0,this.textTracks=[],this.tracks=[],this.initPTS=[],this.timescale=[],this.unparsedVttFrags=[],this.captionsTracks={},this.nonNativeCaptionsTracks={},this.cea608Parser1=void 0,this.cea608Parser2=void 0,this.lastSn=-1,this.lastPartIndex=-1,this.prevCC=-1,this.vttCCs={ccOffset:0,presentationOffset:0,0:{start:0,prevCC:-1,new:!1}},this.captionsProperties=void 0,this.hls=t,this.config=t.config,this.Cues=t.config.cueHandler,this.captionsProperties={textTrack1:{label:this.config.captionsTextTrack1Label,languageCode:this.config.captionsTextTrack1LanguageCode},textTrack2:{label:this.config.captionsTextTrack2Label,languageCode:this.config.captionsTextTrack2LanguageCode},textTrack3:{label:this.config.captionsTextTrack3Label,languageCode:this.config.captionsTextTrack3LanguageCode},textTrack4:{label:this.config.captionsTextTrack4Label,languageCode:this.config.captionsTextTrack4LanguageCode}},this.config.enableCEA708Captions){var e=new $e(this,"textTrack1"),r=new $e(this,"textTrack2"),i=new $e(this,"textTrack3"),n=new $e(this,"textTrack4");this.cea608Parser1=new Qe(1,e,r),this.cea608Parser2=new Qe(3,i,n)}t.on(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.on(s.a.MANIFEST_LOADED,this.onManifestLoaded,this),t.on(s.a.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.on(s.a.FRAG_LOADING,this.onFragLoading,this),t.on(s.a.FRAG_LOADED,this.onFragLoaded,this),t.on(s.a.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this),t.on(s.a.FRAG_DECRYPTED,this.onFragDecrypted,this),t.on(s.a.INIT_PTS_FOUND,this.onInitPtsFound,this),t.on(s.a.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this),t.on(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this)}var e=t.prototype;return e.destroy=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(s.a.MANIFEST_LOADING,this.onManifestLoading,this),t.off(s.a.MANIFEST_LOADED,this.onManifestLoaded,this),t.off(s.a.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.off(s.a.FRAG_LOADING,this.onFragLoading,this),t.off(s.a.FRAG_LOADED,this.onFragLoaded,this),t.off(s.a.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this),t.off(s.a.FRAG_DECRYPTED,this.onFragDecrypted,this),t.off(s.a.INIT_PTS_FOUND,this.onInitPtsFound,this),t.off(s.a.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this),t.off(s.a.BUFFER_FLUSHING,this.onBufferFlushing,this),this.hls=this.config=this.cea608Parser1=this.cea608Parser2=null},e.addCues=function(t,e,r,i,n){for(var a,o,l,u,h=!1,d=n.length;d--;){var c=n[d],f=(a=c[0],o=c[1],l=e,u=r,Math.min(o,u)-Math.max(a,l));if(f>=0&&(c[0]=Math.min(c[0],e),c[1]=Math.max(c[1],r),h=!0,f/(r-e)>.5))return}if(h||n.push([e,r]),this.config.renderTextTracksNatively){var g=this.captionsTracks[t];this.Cues.newCue(g,e,r,i)}else{var v=this.Cues.newCue(null,e,r,i);this.hls.trigger(s.a.CUES_PARSED,{type:"captions",cues:v,track:t})}},e.onInitPtsFound=function(t,e){var r=this,i=e.frag,n=e.id,a=e.initPTS,o=e.timescale,l=this.unparsedVttFrags;"main"===n&&(this.initPTS[i.cc]=a,this.timescale[i.cc]=o),l.length&&(this.unparsedVttFrags=[],l.forEach((function(t){r.onFragLoaded(s.a.FRAG_LOADED,t)})))},e.getExistingTrack=function(t){var e=this.media;if(e)for(var r=0;r<e.textTracks.length;r++){var i=e.textTracks[r];if(i[t])return i}return null},e.createCaptionsTrack=function(t){this.config.renderTextTracksNatively?this.createNativeTrack(t):this.createNonNativeTrack(t)},e.createNativeTrack=function(t){if(!this.captionsTracks[t]){var e=this.captionsProperties,r=this.captionsTracks,i=this.media,n=e[t],a=n.label,s=n.languageCode,o=this.getExistingTrack(t);if(o)r[t]=o,U(r[t]),F(r[t],i);else{var l=this.createTextTrack("captions",a,s);l&&(l[t]=!0,r[t]=l)}}},e.createNonNativeTrack=function(t){if(!this.nonNativeCaptionsTracks[t]){var e=this.captionsProperties[t];if(e){var r={_id:t,label:e.label,kind:"captions",default:!!e.media&&!!e.media.default,closedCaptions:e.media};this.nonNativeCaptionsTracks[t]=r,this.hls.trigger(s.a.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:[r]})}}},e.createTextTrack=function(t,e,r){var i=this.media;if(i)return i.addTextTrack(t,e,r)},e.onMediaAttaching=function(t,e){this.media=e.media,this._cleanTracks()},e.onMediaDetaching=function(){var t=this.captionsTracks;Object.keys(t).forEach((function(e){U(t[e]),delete t[e]})),this.nonNativeCaptionsTracks={}},e.onManifestLoading=function(){this.lastSn=-1,this.lastPartIndex=-1,this.prevCC=-1,this.vttCCs={ccOffset:0,presentationOffset:0,0:{start:0,prevCC:-1,new:!1}},this._cleanTracks(),this.tracks=[],this.captionsTracks={},this.nonNativeCaptionsTracks={},this.textTracks=[],this.unparsedVttFrags=this.unparsedVttFrags||[],this.initPTS=[],this.timescale=[],this.cea608Parser1&&this.cea608Parser2&&(this.cea608Parser1.reset(),this.cea608Parser2.reset())},e._cleanTracks=function(){var t=this.media;if(t){var e=t.textTracks;if(e)for(var r=0;r<e.length;r++)U(e[r])}},e.onSubtitleTracksUpdated=function(t,e){var r=this;this.textTracks=[];var i=e.subtitleTracks||[],n=i.some((function(t){return"stpp.ttml.im1t"===t.textCodec}));if(this.config.enableWebVTT||n&&this.config.enableIMSC1){var a=this.tracks&&i&&this.tracks.length===i.length;if(this.tracks=i||[],this.config.renderTextTracksNatively){var o=this.media?this.media.textTracks:[];this.tracks.forEach((function(t,e){var i;if(e<o.length){for(var n=null,a=0;a<o.length;a++)if(Rr(o[a],t)){n=o[a];break}n&&(i=n)}i?U(i):(i=r.createTextTrack("subtitles",t.name,t.lang))&&(i.mode="disabled"),i&&(i.groupId=t.groupId,r.textTracks.push(i))}))}else if(!a&&this.tracks&&this.tracks.length){var l=this.tracks.map((function(t){return{label:t.name,kind:t.type.toLowerCase(),default:t.default,subtitleTrack:t}}));this.hls.trigger(s.a.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:l})}}},e.onManifestLoaded=function(t,e){var r=this;this.config.enableCEA708Captions&&e.captions&&e.captions.forEach((function(t){var e=/(?:CC|SERVICE)([1-4])/.exec(t.instreamId);if(e){var i="textTrack"+e[1],n=r.captionsProperties[i];n&&(n.label=t.name,t.lang&&(n.languageCode=t.lang),n.media=t)}}))},e.onFragLoading=function(t,e){var r=this.cea608Parser1,i=this.cea608Parser2,n=this.lastSn,a=this.lastPartIndex;if(this.enabled&&r&&i&&e.frag.type===C.b.MAIN){var s,o,l=e.frag.sn,u=null!=(s=null==e||null===(o=e.part)||void 0===o?void 0:o.index)?s:-1;l===n+1||l===n&&u===a+1||(r.reset(),i.reset()),this.lastSn=l,this.lastPartIndex=u}},e.onFragLoaded=function(t,e){var r=e.frag,i=e.payload,n=this.initPTS,o=this.unparsedVttFrags;if(r.type===C.b.SUBTITLE)if(i.byteLength){if(!Object(a.a)(n[r.cc]))return o.push(e),void(n.length&&this.hls.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:r,error:new Error("Missing initial subtitle PTS")}));var l=r.decryptdata,u="stats"in e;if(null==l||null==l.key||"AES-128"!==l.method||u){var h=this.tracks[r.level],d=this.vttCCs;d[r.cc]||(d[r.cc]={start:r.start,prevCC:this.prevCC,new:!0},this.prevCC=r.cc),h&&"stpp.ttml.im1t"===h.textCodec?this._parseIMSC1(r,i):this._parseVTTs(r,i,d)}}else this.hls.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:r,error:new Error("Empty subtitle payload")})},e._parseIMSC1=function(t,e){var r=this,i=this.hls;Tr(e,this.initPTS[t.cc],this.timescale[t.cc],(function(e){r._appendCues(e,t.level),i.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!0,frag:t})}),(function(e){l.b.log("Failed to parse IMSC1: "+e),i.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:t,error:e})}))},e._parseVTTs=function(t,e,r){var i=this,n=this.hls;gr(e,this.initPTS[t.cc],this.timescale[t.cc],r,t.cc,t.start,(function(e){i._appendCues(e,t.level),n.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!0,frag:t})}),(function(r){i._fallbackToIMSC1(t,e),l.b.log("Failed to parse VTT cue: "+r),n.trigger(s.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:t,error:r})}))},e._fallbackToIMSC1=function(t,e){var r=this,i=this.tracks[t.level];i.textCodec||Tr(e,this.initPTS[t.cc],this.timescale[t.cc],(function(){i.textCodec="stpp.ttml.im1t",r._parseIMSC1(t,e)}),(function(){i.textCodec="wvtt"}))},e._appendCues=function(t,e){var r=this.hls;if(this.config.renderTextTracksNatively){var i=this.textTracks[e];if(!i||"disabled"===i.mode)return;t.forEach((function(t){return N(i,t)}))}else{var n=this.tracks[e];if(!n)return;var a=n.default?"default":"subtitles"+e;r.trigger(s.a.CUES_PARSED,{type:"subtitles",cues:t,track:a})}},e.onFragDecrypted=function(t,e){var r=e.frag;if(r.type===C.b.SUBTITLE){if(!Object(a.a)(this.initPTS[r.cc]))return void this.unparsedVttFrags.push(e);this.onFragLoaded(s.a.FRAG_LOADED,e)}},e.onSubtitleTracksCleared=function(){this.tracks=[],this.captionsTracks={}},e.onFragParsingUserdata=function(t,e){var r=this.cea608Parser1,i=this.cea608Parser2;if(this.enabled&&r&&i)for(var n=0;n<e.samples.length;n++){var a=e.samples[n].bytes;if(a){var s=this.extractCea608Data(a);r.addData(e.samples[n].pts,s[0]),i.addData(e.samples[n].pts,s[1])}}},e.onBufferFlushing=function(t,e){var r=e.startOffset,i=e.endOffset,n=e.endOffsetSubtitles,a=e.type,s=this.media;if(s&&!(s.currentTime<i)){if(!a||"video"===a){var o=this.captionsTracks;Object.keys(o).forEach((function(t){return B(o[t],r,i)}))}if(this.config.renderTextTracksNatively&&0===r&&void 0!==n){var l=this.textTracks;Object.keys(l).forEach((function(t){return B(l[t],r,n)}))}}},e.extractCea608Data=function(t){for(var e=[[],[]],r=31&t[0],i=2,n=0;n<r;n++){var a=t[i++],s=127&t[i++],o=127&t[i++];if(0!==s||0!==o)if(0!=(4&a)){var l=3&a;0!==l&&1!==l||(e[l].push(s),e[l].push(o))}}return e},t}();function Rr(t,e){return t&&t.label===e.name&&!(t.textTrack1||t.textTrack2)}function kr(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var _r,Ir=function(){function t(t){this.autoLevelCapping=void 0,this.firstLevel=void 0,this.media=void 0,this.restrictedLevels=void 0,this.timer=void 0,this.hls=void 0,this.streamController=void 0,this.clientRect=void 0,this.hls=t,this.autoLevelCapping=Number.POSITIVE_INFINITY,this.firstLevel=-1,this.media=null,this.restrictedLevels=[],this.timer=void 0,this.clientRect=null,this.registerListeners()}var e,r,i,n=t.prototype;return n.setStreamController=function(t){this.streamController=t},n.destroy=function(){this.unregisterListener(),this.hls.config.capLevelToPlayerSize&&this.stopCapping(),this.media=null,this.clientRect=null,this.hls=this.streamController=null},n.registerListeners=function(){var t=this.hls;t.on(s.a.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this),t.on(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.on(s.a.BUFFER_CODECS,this.onBufferCodecs,this),t.on(s.a.MEDIA_DETACHING,this.onMediaDetaching,this)},n.unregisterListener=function(){var t=this.hls;t.off(s.a.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this),t.off(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this),t.off(s.a.BUFFER_CODECS,this.onBufferCodecs,this),t.off(s.a.MEDIA_DETACHING,this.onMediaDetaching,this)},n.onFpsDropLevelCapping=function(e,r){t.isLevelAllowed(r.droppedLevel,this.restrictedLevels)&&this.restrictedLevels.push(r.droppedLevel)},n.onMediaAttaching=function(t,e){this.media=e.media instanceof HTMLVideoElement?e.media:null},n.onManifestParsed=function(t,e){var r=this.hls;this.restrictedLevels=[],this.firstLevel=e.firstLevel,r.config.capLevelToPlayerSize&&e.video&&this.startCapping()},n.onBufferCodecs=function(t,e){this.hls.config.capLevelToPlayerSize&&e.video&&this.startCapping()},n.onMediaDetaching=function(){this.stopCapping()},n.detectPlayerSize=function(){if(this.media&&this.mediaHeight>0&&this.mediaWidth>0){var t=this.hls.levels;if(t.length){var e=this.hls;e.autoLevelCapping=this.getMaxLevel(t.length-1),e.autoLevelCapping>this.autoLevelCapping&&this.streamController&&this.streamController.nextLevelSwitch(),this.autoLevelCapping=e.autoLevelCapping}}},n.getMaxLevel=function(e){var r=this,i=this.hls.levels;if(!i.length)return-1;var n=i.filter((function(i,n){return t.isLevelAllowed(n,r.restrictedLevels)&&n<=e}));return this.clientRect=null,t.getMaxLevelByMediaSize(n,this.mediaWidth,this.mediaHeight)},n.startCapping=function(){this.timer||(this.autoLevelCapping=Number.POSITIVE_INFINITY,this.hls.firstLevel=this.getMaxLevel(this.firstLevel),self.clearInterval(this.timer),this.timer=self.setInterval(this.detectPlayerSize.bind(this),1e3),this.detectPlayerSize())},n.stopCapping=function(){this.restrictedLevels=[],this.firstLevel=-1,this.autoLevelCapping=Number.POSITIVE_INFINITY,this.timer&&(self.clearInterval(this.timer),this.timer=void 0)},n.getDimensions=function(){if(this.clientRect)return this.clientRect;var t=this.media,e={width:0,height:0};if(t){var r=t.getBoundingClientRect();e.width=r.width,e.height=r.height,e.width||e.height||(e.width=r.right-r.left||t.width||0,e.height=r.bottom-r.top||t.height||0)}return this.clientRect=e,e},t.isLevelAllowed=function(t,e){return void 0===e&&(e=[]),-1===e.indexOf(t)},t.getMaxLevelByMediaSize=function(t,e,r){if(!t||!t.length)return-1;for(var i,n,a=t.length-1,s=0;s<t.length;s+=1){var o=t[s];if((o.width>=e||o.height>=r)&&(i=o,!(n=t[s+1])||i.width!==n.width||i.height!==n.height)){a=s;break}}return a},e=t,(r=[{key:"mediaWidth",get:function(){return this.getDimensions().width*this.contentScaleFactor}},{key:"mediaHeight",get:function(){return this.getDimensions().height*this.contentScaleFactor}},{key:"contentScaleFactor",get:function(){var t=1;if(!this.hls.config.ignoreDevicePixelRatio)try{t=self.devicePixelRatio}catch(t){}return t}}])&&kr(e.prototype,r),i&&kr(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}(),Or=function(){function t(t){this.hls=void 0,this.isVideoPlaybackQualityAvailable=!1,this.timer=void 0,this.media=null,this.lastTime=void 0,this.lastDroppedFrames=0,this.lastDecodedFrames=0,this.streamController=void 0,this.hls=t,this.registerListeners()}var e=t.prototype;return e.setStreamController=function(t){this.streamController=t},e.registerListeners=function(){this.hls.on(s.a.MEDIA_ATTACHING,this.onMediaAttaching,this)},e.unregisterListeners=function(){this.hls.off(s.a.MEDIA_ATTACHING,this.onMediaAttaching)},e.destroy=function(){this.timer&&clearInterval(this.timer),this.unregisterListeners(),this.isVideoPlaybackQualityAvailable=!1,this.media=null},e.onMediaAttaching=function(t,e){var r=this.hls.config;if(r.capLevelOnFPSDrop){var i=e.media instanceof self.HTMLVideoElement?e.media:null;this.media=i,i&&"function"==typeof i.getVideoPlaybackQuality&&(this.isVideoPlaybackQualityAvailable=!0),self.clearInterval(this.timer),this.timer=self.setInterval(this.checkFPSInterval.bind(this),r.fpsDroppedMonitoringPeriod)}},e.checkFPS=function(t,e,r){var i=performance.now();if(e){if(this.lastTime){var n=i-this.lastTime,a=r-this.lastDroppedFrames,o=e-this.lastDecodedFrames,u=1e3*a/n,h=this.hls;if(h.trigger(s.a.FPS_DROP,{currentDropped:a,currentDecoded:o,totalDroppedFrames:r}),u>0&&a>h.config.fpsDroppedMonitoringThreshold*o){var d=h.currentLevel;l.b.warn("drop FPS ratio greater than max allowed value for currentLevel: "+d),d>0&&(-1===h.autoLevelCapping||h.autoLevelCapping>=d)&&(d-=1,h.trigger(s.a.FPS_DROP_LEVEL_CAPPING,{level:d,droppedLevel:h.currentLevel}),h.autoLevelCapping=d,this.streamController.nextLevelSwitch())}}this.lastTime=i,this.lastDroppedFrames=r,this.lastDecodedFrames=e}},e.checkFPSInterval=function(){var t=this.media;if(t)if(this.isVideoPlaybackQualityAvailable){var e=t.getVideoPlaybackQuality();this.checkFPS(t,e.totalVideoFrames,e.droppedVideoFrames)}else this.checkFPS(t,t.webkitDecodedFrameCount,t.webkitDroppedFrameCount)},t}();!function(t){t.WIDEVINE="com.widevine.alpha",t.PLAYREADY="com.microsoft.playready"}(_r||(_r={}));var wr="undefined"!=typeof self&&self.navigator&&self.navigator.requestMediaKeySystemAccess?self.navigator.requestMediaKeySystemAccess.bind(self.navigator):null;function Cr(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var xr,Pr,Mr,Fr=function(){function t(t){this.hls=void 0,this._widevineLicenseUrl=void 0,this._licenseXhrSetup=void 0,this._licenseResponseCallback=void 0,this._emeEnabled=void 0,this._requestMediaKeySystemAccess=void 0,this._drmSystemOptions=void 0,this._config=void 0,this._mediaKeysList=[],this._media=null,this._hasSetMediaKeys=!1,this._requestLicenseFailureCount=0,this.mediaKeysPromise=null,this._onMediaEncrypted=this.onMediaEncrypted.bind(this),this.hls=t,this._config=t.config,this._widevineLicenseUrl=this._config.widevineLicenseUrl,this._licenseXhrSetup=this._config.licenseXhrSetup,this._licenseResponseCallback=this._config.licenseResponseCallback,this._emeEnabled=this._config.emeEnabled,this._requestMediaKeySystemAccess=this._config.requestMediaKeySystemAccessFunc,this._drmSystemOptions=this._config.drmSystemOptions,this._registerListeners()}var e,r,i,n=t.prototype;return n.destroy=function(){this._unregisterListeners(),this.hls=this._onMediaEncrypted=null,this._requestMediaKeySystemAccess=null},n._registerListeners=function(){this.hls.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.on(s.a.MEDIA_DETACHED,this.onMediaDetached,this),this.hls.on(s.a.MANIFEST_PARSED,this.onManifestParsed,this)},n._unregisterListeners=function(){this.hls.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.off(s.a.MEDIA_DETACHED,this.onMediaDetached,this),this.hls.off(s.a.MANIFEST_PARSED,this.onManifestParsed,this)},n.getLicenseServerUrl=function(t){switch(t){case _r.WIDEVINE:if(!this._widevineLicenseUrl)break;return this._widevineLicenseUrl}throw new Error('no license server URL configured for key-system "'+t+'"')},n._attemptKeySystemAccess=function(t,e,r){var i=this,n=function(t,e,r,i){switch(t){case _r.WIDEVINE:return function(t,e,r){var i={audioCapabilities:[],videoCapabilities:[]};return t.forEach((function(t){i.audioCapabilities.push({contentType:'audio/mp4; codecs="'+t+'"',robustness:r.audioRobustness||""})})),e.forEach((function(t){i.videoCapabilities.push({contentType:'video/mp4; codecs="'+t+'"',robustness:r.videoRobustness||""})})),[i]}(e,r,i);default:throw new Error("Unknown key-system: "+t)}}(t,e,r,this._drmSystemOptions);l.b.log("Requesting encrypted media key-system access");var a=this.requestMediaKeySystemAccess(t,n);this.mediaKeysPromise=a.then((function(e){return i._onMediaKeySystemAccessObtained(t,e)})),a.catch((function(e){l.b.error('Failed to obtain key-system "'+t+'" access:',e)}))},n._onMediaKeySystemAccessObtained=function(t,e){var r=this;l.b.log('Access for key-system "'+t+'" obtained');var i={mediaKeysSessionInitialized:!1,mediaKeySystemAccess:e,mediaKeySystemDomain:t};this._mediaKeysList.push(i);var n=Promise.resolve().then((function(){return e.createMediaKeys()})).then((function(e){return i.mediaKeys=e,l.b.log('Media-keys created for key-system "'+t+'"'),r._onMediaKeysCreated(),e}));return n.catch((function(t){l.b.error("Failed to create media-keys:",t)})),n},n._onMediaKeysCreated=function(){var t=this;this._mediaKeysList.forEach((function(e){e.mediaKeysSession||(e.mediaKeysSession=e.mediaKeys.createSession(),t._onNewMediaKeySession(e.mediaKeysSession))}))},n._onNewMediaKeySession=function(t){var e=this;l.b.log("New key-system session "+t.sessionId),t.addEventListener("message",(function(r){e._onKeySessionMessage(t,r.message)}),!1)},n._onKeySessionMessage=function(t,e){l.b.log("Got EME message event, creating license request"),this._requestLicense(e,(function(e){l.b.log("Received license data (length: "+(e?e.byteLength:e)+"), updating key-session"),t.update(e).catch((function(t){l.b.warn("Updating key-session failed: "+t)}))}))},n.onMediaEncrypted=function(t){var e=this;if(l.b.log('Media is encrypted using "'+t.initDataType+'" init data type'),!this.mediaKeysPromise)return l.b.error("Fatal: Media is encrypted but no CDM access or no keys have been requested"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_KEYS,fatal:!0});var r=function(r){e._media&&(e._attemptSetMediaKeys(r),e._generateRequestWithPreferredKeySession(t.initDataType,t.initData))};this.mediaKeysPromise.then(r).catch(r)},n._attemptSetMediaKeys=function(t){if(!this._media)throw new Error("Attempted to set mediaKeys without first attaching a media element");if(!this._hasSetMediaKeys){var e=this._mediaKeysList[0];if(!e||!e.mediaKeys)return l.b.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_KEYS,fatal:!0});l.b.log("Setting keys for encrypted media"),this._media.setMediaKeys(e.mediaKeys),this._hasSetMediaKeys=!0}},n._generateRequestWithPreferredKeySession=function(t,e){var r=this,i=this._mediaKeysList[0];if(!i)return l.b.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_ACCESS,fatal:!0});if(i.mediaKeysSessionInitialized)l.b.warn("Key-Session already initialized but requested again");else{var n=i.mediaKeysSession;if(!n)return l.b.error("Fatal: Media is encrypted but no key-session existing"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_SESSION,fatal:!0});if(!e)return l.b.warn("Fatal: initData required for generating a key session is null"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_INIT_DATA,fatal:!0});l.b.log('Generating key-session request for "'+t+'" init data type'),i.mediaKeysSessionInitialized=!0,n.generateRequest(t,e).then((function(){l.b.debug("Key-session generation succeeded")})).catch((function(t){l.b.error("Error generating key-session request:",t),r.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_SESSION,fatal:!1})}))}},n._createLicenseXhr=function(t,e,r){var i=new XMLHttpRequest;i.responseType="arraybuffer",i.onreadystatechange=this._onLicenseRequestReadyStageChange.bind(this,i,t,e,r);var n=this._licenseXhrSetup;if(n)try{n.call(this.hls,i,t),n=void 0}catch(t){l.b.error(t)}try{i.readyState||i.open("POST",t,!0),n&&n.call(this.hls,i,t)}catch(t){throw new Error("issue setting up KeySystem license XHR "+t)}return i},n._onLicenseRequestReadyStageChange=function(t,e,r,i){switch(t.readyState){case 4:if(200===t.status){this._requestLicenseFailureCount=0,l.b.log("License request succeeded");var n=t.response,a=this._licenseResponseCallback;if(a)try{n=a.call(this.hls,t,e)}catch(t){l.b.error(t)}i(n)}else{if(l.b.error("License Request XHR failed ("+e+"). Status: "+t.status+" ("+t.statusText+")"),this._requestLicenseFailureCount++,this._requestLicenseFailureCount>3)return void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_LICENSE_REQUEST_FAILED,fatal:!0});var u=3-this._requestLicenseFailureCount+1;l.b.warn("Retrying license request, "+u+" attempts left"),this._requestLicense(r,i)}}},n._generateLicenseRequestChallenge=function(t,e){switch(t.mediaKeySystemDomain){case _r.WIDEVINE:return e}throw new Error("unsupported key-system: "+t.mediaKeySystemDomain)},n._requestLicense=function(t,e){l.b.log("Requesting content license for key-system");var r=this._mediaKeysList[0];if(!r)return l.b.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"),void this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_NO_ACCESS,fatal:!0});try{var i=this.getLicenseServerUrl(r.mediaKeySystemDomain),n=this._createLicenseXhr(i,t,e);l.b.log("Sending license request to URL: "+i);var a=this._generateLicenseRequestChallenge(r,t);n.send(a)}catch(t){l.b.error("Failure requesting DRM license: "+t),this.hls.trigger(s.a.ERROR,{type:o.b.KEY_SYSTEM_ERROR,details:o.a.KEY_SYSTEM_LICENSE_REQUEST_FAILED,fatal:!0})}},n.onMediaAttached=function(t,e){if(this._emeEnabled){var r=e.media;this._media=r,r.addEventListener("encrypted",this._onMediaEncrypted)}},n.onMediaDetached=function(){var t=this._media,e=this._mediaKeysList;t&&(t.removeEventListener("encrypted",this._onMediaEncrypted),this._media=null,this._mediaKeysList=[],Promise.all(e.map((function(t){if(t.mediaKeysSession)return t.mediaKeysSession.close().catch((function(){}))}))).then((function(){return t.setMediaKeys(null)})).catch((function(){})))},n.onManifestParsed=function(t,e){if(this._emeEnabled){var r=e.levels.map((function(t){return t.audioCodec})).filter((function(t){return!!t})),i=e.levels.map((function(t){return t.videoCodec})).filter((function(t){return!!t}));this._attemptKeySystemAccess(_r.WIDEVINE,r,i)}},e=t,(r=[{key:"requestMediaKeySystemAccess",get:function(){if(!this._requestMediaKeySystemAccess)throw new Error("No requestMediaKeySystemAccess function configured");return this._requestMediaKeySystemAccess}}])&&Cr(e.prototype,r),i&&Cr(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}();function Nr(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function Ur(t,e,r){return e&&Nr(t.prototype,e),r&&Nr(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function Br(t,e){var r="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(r)return(r=r.call(t)).next.bind(r);if(Array.isArray(t)||(r=function(t,e){if(!t)return;if("string"==typeof t)return Gr(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);"Object"===r&&t.constructor&&(r=t.constructor.name);if("Map"===r||"Set"===r)return Array.from(t);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Gr(t,e)}(t))||e&&t&&"number"==typeof t.length){r&&(t=r);var i=0;return function(){return i>=t.length?{done:!0}:{done:!1,value:t[i++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function Gr(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,i=new Array(e);r<e;r++)i[r]=t[r];return i}function jr(){return(jr=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}!function(t){t.MANIFEST="m",t.AUDIO="a",t.VIDEO="v",t.MUXED="av",t.INIT="i",t.CAPTION="c",t.TIMED_TEXT="tt",t.KEY="k",t.OTHER="o"}(xr||(xr={})),function(t){t.DASH="d",t.HLS="h",t.SMOOTH="s",t.OTHER="o"}(Pr||(Pr={})),function(t){t.VOD="v",t.LIVE="l"}(Mr||(Mr={}));var Kr=function(){function t(e){var r=this;this.hls=void 0,this.config=void 0,this.media=void 0,this.sid=void 0,this.cid=void 0,this.useHeaders=!1,this.initialized=!1,this.starved=!1,this.buffering=!0,this.audioBuffer=void 0,this.videoBuffer=void 0,this.onWaiting=function(){r.initialized&&(r.starved=!0),r.buffering=!0},this.onPlaying=function(){r.initialized||(r.initialized=!0),r.buffering=!1},this.applyPlaylistData=function(t){try{r.apply(t,{ot:xr.MANIFEST,su:!r.initialized})}catch(t){l.b.warn("Could not generate manifest CMCD data.",t)}},this.applyFragmentData=function(t){try{var e=t.frag,i=r.hls.levels[e.level],n=r.getObjectType(e),a={d:1e3*e.duration,ot:n};n!==xr.VIDEO&&n!==xr.AUDIO&&n!=xr.MUXED||(a.br=i.bitrate/1e3,a.tb=r.getTopBandwidth(n)/1e3,a.bl=r.getBufferLength(n)),r.apply(t,a)}catch(t){l.b.warn("Could not generate segment CMCD data.",t)}},this.hls=e;var i=this.config=e.config,n=i.cmcd;null!=n&&(i.pLoader=this.createPlaylistLoader(),i.fLoader=this.createFragmentLoader(),this.sid=n.sessionId||t.uuid(),this.cid=n.contentId,this.useHeaders=!0===n.useHeaders,this.registerListeners())}var e=t.prototype;return e.registerListeners=function(){var t=this.hls;t.on(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(s.a.MEDIA_DETACHED,this.onMediaDetached,this),t.on(s.a.BUFFER_CREATED,this.onBufferCreated,this)},e.unregisterListeners=function(){var t=this.hls;t.off(s.a.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(s.a.MEDIA_DETACHED,this.onMediaDetached,this),t.off(s.a.BUFFER_CREATED,this.onBufferCreated,this),this.onMediaDetached()},e.destroy=function(){this.unregisterListeners(),this.hls=this.config=this.audioBuffer=this.videoBuffer=null},e.onMediaAttached=function(t,e){this.media=e.media,this.media.addEventListener("waiting",this.onWaiting),this.media.addEventListener("playing",this.onPlaying)},e.onMediaDetached=function(){this.media&&(this.media.removeEventListener("waiting",this.onWaiting),this.media.removeEventListener("playing",this.onPlaying),this.media=null)},e.onBufferCreated=function(t,e){var r,i;this.audioBuffer=null===(r=e.tracks.audio)||void 0===r?void 0:r.buffer,this.videoBuffer=null===(i=e.tracks.video)||void 0===i?void 0:i.buffer},e.createData=function(){var t;return{v:1,sf:Pr.HLS,sid:this.sid,cid:this.cid,pr:null===(t=this.media)||void 0===t?void 0:t.playbackRate,mtp:this.hls.bandwidthEstimate/1e3}},e.apply=function(e,r){void 0===r&&(r={}),jr(r,this.createData());var i=r.ot===xr.INIT||r.ot===xr.VIDEO||r.ot===xr.MUXED;if(this.starved&&i&&(r.bs=!0,r.su=!0,this.starved=!1),null==r.su&&(r.su=this.buffering),this.useHeaders){var n=t.toHeaders(r);if(!Object.keys(n).length)return;e.headers||(e.headers={}),jr(e.headers,n)}else{var a=t.toQuery(r);if(!a)return;e.url=t.appendQueryToUri(e.url,a)}},e.getObjectType=function(t){var e=t.type;return"subtitle"===e?xr.TIMED_TEXT:"initSegment"===t.sn?xr.INIT:"audio"===e?xr.AUDIO:"main"===e?this.hls.audioTracks.length?xr.VIDEO:xr.MUXED:void 0},e.getTopBandwidth=function(t){var e,r=0,i=this.hls;if(t===xr.AUDIO)e=i.audioTracks;else{var n=i.maxAutoLevel,a=n>-1?n+1:i.levels.length;e=i.levels.slice(0,a)}for(var s,o=Br(e);!(s=o()).done;){var l=s.value;l.bitrate>r&&(r=l.bitrate)}return r>0?r:NaN},e.getBufferLength=function(t){var e=this.hls.media,r=t===xr.AUDIO?this.audioBuffer:this.videoBuffer;return r&&e?1e3*mt.bufferInfo(r,e.currentTime,this.config.maxBufferHole).len:NaN},e.createPlaylistLoader=function(){var t=this.config.pLoader,e=this.applyPlaylistData,r=t||this.config.loader;return function(){function t(t){this.loader=void 0,this.loader=new r(t)}var i=t.prototype;return i.destroy=function(){this.loader.destroy()},i.abort=function(){this.loader.abort()},i.load=function(t,r,i){e(t),this.loader.load(t,r,i)},Ur(t,[{key:"stats",get:function(){return this.loader.stats}},{key:"context",get:function(){return this.loader.context}}]),t}()},e.createFragmentLoader=function(){var t=this.config.fLoader,e=this.applyFragmentData,r=t||this.config.loader;return function(){function t(t){this.loader=void 0,this.loader=new r(t)}var i=t.prototype;return i.destroy=function(){this.loader.destroy()},i.abort=function(){this.loader.abort()},i.load=function(t,r,i){e(t),this.loader.load(t,r,i)},Ur(t,[{key:"stats",get:function(){return this.loader.stats}},{key:"context",get:function(){return this.loader.context}}]),t}()},t.uuid=function(){var t=URL.createObjectURL(new Blob),e=t.toString();return URL.revokeObjectURL(t),e.slice(e.lastIndexOf("/")+1)},t.serialize=function(t){for(var e,r=[],i=function(t){return!Number.isNaN(t)&&null!=t&&""!==t&&!1!==t},n=function(t){return Math.round(t)},a=function(t){return 100*n(t/100)},s={br:n,d:n,bl:a,dl:a,mtp:a,nor:function(t){return encodeURIComponent(t)},rtp:a,tb:n},o=Br(Object.keys(t||{}).sort());!(e=o()).done;){var l=e.value,u=t[l];if(i(u)&&!("v"===l&&1===u||"pr"==l&&1===u)){var h=s[l];h&&(u=h(u));var d=typeof u,c=void 0;c="ot"===l||"sf"===l||"st"===l?l+"="+u:"boolean"===d?l:"number"===d?l+"="+u:l+"="+JSON.stringify(u),r.push(c)}}return r.join(",")},t.toHeaders=function(e){for(var r={},i=["Object","Request","Session","Status"],n=[{},{},{},{}],a={br:0,d:0,ot:0,tb:0,bl:1,dl:1,mtp:1,nor:1,nrr:1,su:1,cid:2,pr:2,sf:2,sid:2,st:2,v:2,bs:3,rtp:3},s=0,o=Object.keys(e);s<o.length;s++){var l=o[s];n[null!=a[l]?a[l]:1][l]=e[l]}for(var u=0;u<n.length;u++){var h=t.serialize(n[u]);h&&(r["CMCD-"+i[u]]=h)}return r},t.toQuery=function(e){return"CMCD="+encodeURIComponent(t.serialize(e))},t.appendQueryToUri=function(t,e){if(!e)return t;var r=t.includes("?")?"&":"?";return""+t+r+e},t}(),Hr=r(14),Vr=/^age:\s*[\d.]+\s*$/m,Wr=function(){function t(t){this.xhrSetup=void 0,this.requestTimeout=void 0,this.retryTimeout=void 0,this.retryDelay=void 0,this.config=null,this.callbacks=null,this.context=void 0,this.loader=null,this.stats=void 0,this.xhrSetup=t?t.xhrSetup:null,this.stats=new Hr.a,this.retryDelay=0}var e=t.prototype;return e.destroy=function(){this.callbacks=null,this.abortInternal(),this.loader=null,this.config=null},e.abortInternal=function(){var t=this.loader;self.clearTimeout(this.requestTimeout),self.clearTimeout(this.retryTimeout),t&&(t.onreadystatechange=null,t.onprogress=null,4!==t.readyState&&(this.stats.aborted=!0,t.abort()))},e.abort=function(){var t;this.abortInternal(),null!==(t=this.callbacks)&&void 0!==t&&t.onAbort&&this.callbacks.onAbort(this.stats,this.context,this.loader)},e.load=function(t,e,r){if(this.stats.loading.start)throw new Error("Loader can only be used once.");this.stats.loading.start=self.performance.now(),this.context=t,this.config=e,this.callbacks=r,this.retryDelay=e.retryDelay,this.loadInternal()},e.loadInternal=function(){var t=this.config,e=this.context;if(t){var r=this.loader=new self.XMLHttpRequest,i=this.stats;i.loading.first=0,i.loaded=0;var n=this.xhrSetup;try{if(n)try{n(r,e.url)}catch(t){r.open("GET",e.url,!0),n(r,e.url)}r.readyState||r.open("GET",e.url,!0);var a=this.context.headers;if(a)for(var s in a)r.setRequestHeader(s,a[s])}catch(t){return void this.callbacks.onError({code:r.status,text:t.message},e,r)}e.rangeEnd&&r.setRequestHeader("Range","bytes="+e.rangeStart+"-"+(e.rangeEnd-1)),r.onreadystatechange=this.readystatechange.bind(this),r.onprogress=this.loadprogress.bind(this),r.responseType=e.responseType,self.clearTimeout(this.requestTimeout),this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),t.timeout),r.send()}},e.readystatechange=function(){var t=this.context,e=this.loader,r=this.stats;if(t&&e){var i=e.readyState,n=this.config;if(!r.aborted&&i>=2)if(self.clearTimeout(this.requestTimeout),0===r.loading.first&&(r.loading.first=Math.max(self.performance.now(),r.loading.start)),4===i){e.onreadystatechange=null,e.onprogress=null;var a=e.status;if(a>=200&&a<300){var s,o;if(r.loading.end=Math.max(self.performance.now(),r.loading.first),o="arraybuffer"===t.responseType?(s=e.response).byteLength:(s=e.responseText).length,r.loaded=r.total=o,!this.callbacks)return;var u=this.callbacks.onProgress;if(u&&u(r,t,s,e),!this.callbacks)return;var h={url:e.responseURL,data:s};this.callbacks.onSuccess(h,r,t,e)}else r.retry>=n.maxRetry||a>=400&&a<499?(l.b.error(a+" while loading "+t.url),this.callbacks.onError({code:a,text:e.statusText},t,e)):(l.b.warn(a+" while loading "+t.url+", retrying in "+this.retryDelay+"..."),this.abortInternal(),this.loader=null,self.clearTimeout(this.retryTimeout),this.retryTimeout=self.setTimeout(this.loadInternal.bind(this),this.retryDelay),this.retryDelay=Math.min(2*this.retryDelay,n.maxRetryDelay),r.retry++)}else self.clearTimeout(this.requestTimeout),this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),n.timeout)}},e.loadtimeout=function(){l.b.warn("timeout while loading "+this.context.url);var t=this.callbacks;t&&(this.abortInternal(),t.onTimeout(this.stats,this.context,this.loader))},e.loadprogress=function(t){var e=this.stats;e.loaded=t.loaded,t.lengthComputable&&(e.total=t.total)},e.getCacheAge=function(){var t=null;if(this.loader&&Vr.test(this.loader.getAllResponseHeaders())){var e=this.loader.getResponseHeader("age");t=e?parseFloat(e):null}return t},t}();function Yr(t){var e="function"==typeof Map?new Map:void 0;return(Yr=function(t){if(null===t||(r=t,-1===Function.toString.call(r).indexOf("[native code]")))return t;var r;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==e){if(e.has(t))return e.get(t);e.set(t,i)}function i(){return qr(t,arguments,Qr(this).constructor)}return i.prototype=Object.create(t.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),Xr(i,t)})(t)}function qr(t,e,r){return(qr=zr()?Reflect.construct.bind():function(t,e,r){var i=[null];i.push.apply(i,e);var n=new(Function.bind.apply(t,i));return r&&Xr(n,r.prototype),n}).apply(null,arguments)}function zr(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}function Xr(t,e){return(Xr=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Qr(t){return(Qr=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function $r(){return($r=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}var Jr=function(){function t(t){this.fetchSetup=void 0,this.requestTimeout=void 0,this.request=void 0,this.response=void 0,this.controller=void 0,this.context=void 0,this.config=null,this.callbacks=null,this.stats=void 0,this.loader=null,this.fetchSetup=t.fetchSetup||Zr,this.controller=new self.AbortController,this.stats=new Hr.a}var e=t.prototype;return e.destroy=function(){this.loader=this.callbacks=null,this.abortInternal()},e.abortInternal=function(){var t=this.response;t&&t.ok||(this.stats.aborted=!0,this.controller.abort())},e.abort=function(){var t;this.abortInternal(),null!==(t=this.callbacks)&&void 0!==t&&t.onAbort&&this.callbacks.onAbort(this.stats,this.context,this.response)},e.load=function(t,e,r){var i=this,n=this.stats;if(n.loading.start)throw new Error("Loader can only be used once.");n.loading.start=self.performance.now();var s=function(t,e){var r={method:"GET",mode:"cors",credentials:"same-origin",signal:e,headers:new self.Headers($r({},t.headers))};t.rangeEnd&&r.headers.set("Range","bytes="+t.rangeStart+"-"+String(t.rangeEnd-1));return r}(t,this.controller.signal),o=r.onProgress,l="arraybuffer"===t.responseType,u=l?"byteLength":"length";this.context=t,this.config=e,this.callbacks=r,this.request=this.fetchSetup(t,s),self.clearTimeout(this.requestTimeout),this.requestTimeout=self.setTimeout((function(){i.abortInternal(),r.onTimeout(n,t,i.response)}),e.timeout),self.fetch(this.request).then((function(r){if(i.response=i.loader=r,!r.ok){var s=r.status,u=r.statusText;throw new ti(u||"fetch, bad network response",s,r)}return n.loading.first=Math.max(self.performance.now(),n.loading.start),n.total=parseInt(r.headers.get("Content-Length")||"0"),o&&Object(a.a)(e.highWaterMark)?i.loadProgressively(r,n,t,e.highWaterMark,o):l?r.arrayBuffer():r.text()})).then((function(s){var l=i.response;self.clearTimeout(i.requestTimeout),n.loading.end=Math.max(self.performance.now(),n.loading.first),n.loaded=n.total=s[u];var h={url:l.url,data:s};o&&!Object(a.a)(e.highWaterMark)&&o(n,t,s,l),r.onSuccess(h,n,t,l)})).catch((function(e){if(self.clearTimeout(i.requestTimeout),!n.aborted){var a=e&&e.code||0,s=e?e.message:null;r.onError({code:a,text:s},t,e?e.details:null)}}))},e.getCacheAge=function(){var t=null;if(this.response){var e=this.response.headers.get("age");t=e?parseFloat(e):null}return t},e.loadProgressively=function(t,e,r,i,n){void 0===i&&(i=0);var a=new ve.a,s=t.body.getReader();return function o(){return s.read().then((function(s){if(s.done)return a.dataLength&&n(e,r,a.flush(),t),Promise.resolve(new ArrayBuffer(0));var l=s.value,u=l.length;return e.loaded+=u,u<i||a.dataLength?(a.push(l),a.dataLength>=i&&n(e,r,a.flush(),t)):n(e,r,l,t),o()})).catch((function(){return Promise.reject()}))}()},t}();function Zr(t,e){return new self.Request(t.url,e)}var ti=function(t){var e,r;function i(e,r,i){var n;return(n=t.call(this,e)||this).code=void 0,n.details=void 0,n.code=r,n.details=i,n}return r=t,(e=i).prototype=Object.create(r.prototype),e.prototype.constructor=e,Xr(e,r),i}(Yr(Error)),ei=Jr,ri=/\s/;function ii(){return(ii=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}).apply(this,arguments)}function ni(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(t);e&&(i=i.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,i)}return r}function ai(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?ni(Object(r),!0).forEach((function(e){si(t,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):ni(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e))}))}return t}function si(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}var oi=ai(ai({autoStartLoad:!0,startPosition:-1,defaultAudioCodec:void 0,debug:!1,capLevelOnFPSDrop:!1,capLevelToPlayerSize:!1,ignoreDevicePixelRatio:!1,initialLiveManifestSize:1,maxBufferLength:30,backBufferLength:1/0,maxBufferSize:6e7,maxBufferHole:.1,highBufferWatchdogPeriod:2,nudgeOffset:.1,nudgeMaxRetry:3,maxFragLookUpTolerance:.25,liveSyncDurationCount:3,liveMaxLatencyDurationCount:1/0,liveSyncDuration:void 0,liveMaxLatencyDuration:void 0,maxLiveSyncPlaybackRate:1,liveDurationInfinity:!1,liveBackBufferLength:null,maxMaxBufferLength:600,enableWorker:!0,enableSoftwareAES:!0,manifestLoadingTimeOut:1e4,manifestLoadingMaxRetry:1,manifestLoadingRetryDelay:1e3,manifestLoadingMaxRetryTimeout:64e3,startLevel:void 0,levelLoadingTimeOut:1e4,levelLoadingMaxRetry:4,levelLoadingRetryDelay:1e3,levelLoadingMaxRetryTimeout:64e3,fragLoadingTimeOut:2e4,fragLoadingMaxRetry:6,fragLoadingRetryDelay:1e3,fragLoadingMaxRetryTimeout:64e3,startFragPrefetch:!1,fpsDroppedMonitoringPeriod:5e3,fpsDroppedMonitoringThreshold:.2,appendErrorMaxRetry:3,loader:Wr,fLoader:void 0,pLoader:void 0,xhrSetup:void 0,licenseXhrSetup:void 0,licenseResponseCallback:void 0,abrController:ge,bufferController:xe,capLevelController:Ir,fpsController:Or,stretchShortVideoTrack:!1,maxAudioFramesDrift:1,forceKeyFrameOnDiscontinuity:!0,abrEwmaFastLive:3,abrEwmaSlowLive:9,abrEwmaFastVoD:3,abrEwmaSlowVoD:9,abrEwmaDefaultEstimate:5e5,abrBandWidthFactor:.95,abrBandWidthUpFactor:.7,abrMaxWithRealBitrate:!1,maxStarvationDelay:4,maxLoadingDelay:4,minAutoBitrate:0,emeEnabled:!1,widevineLicenseUrl:void 0,drmSystemOptions:{},requestMediaKeySystemAccessFunc:wr,testBandwidth:!0,progressive:!1,lowLatencyMode:!0,cmcd:void 0,enableDateRangeMetadataCues:!0,enableEmsgMetadataCues:!0,enableID3MetadataCues:!0},{cueHandler:{newCue:function(t,e,r,i){for(var n,a,s,o,l,u=[],h=self.VTTCue||self.TextTrackCue,d=0;d<i.rows.length;d++)if(s=!0,o=0,l="",!(n=i.rows[d]).isEmpty()){for(var c=0;c<n.chars.length;c++)ri.test(n.chars[c].uchar)&&s?o++:(l+=n.chars[c].uchar,s=!1);n.cueStartTime=e,e===r&&(r+=1e-4),o>=16?o--:o++;var f=sr(l.trim()),g=fr(e,r,f);t&&t.cues&&t.cues.getCueById(g)||((a=new h(e,r,f)).id=g,a.line=d+1,a.align="left",a.position=10+Math.min(80,10*Math.floor(8*o/32)),u.push(a))}return t&&u.length&&(u.sort((function(t,e){return"auto"===t.line||"auto"===e.line?0:t.line>8&&e.line>8?e.line-t.line:t.line-e.line})),u.forEach((function(e){return N(t,e)}))),u}},enableWebVTT:!0,enableIMSC1:!0,enableCEA708Captions:!0,captionsTextTrack1Label:"English",captionsTextTrack1LanguageCode:"en",captionsTextTrack2Label:"Spanish",captionsTextTrack2LanguageCode:"es",captionsTextTrack3Label:"Unknown CC",captionsTextTrack3LanguageCode:"",captionsTextTrack4Label:"Unknown CC",captionsTextTrack4LanguageCode:"",renderTextTracksNatively:!0}),{},{subtitleStreamController:Ae,subtitleTrackController:Ie,timelineController:Dr,audioStreamController:ye,audioTrackController:Ee,emeController:Fr,cmcdController:Kr});function li(t){var e=t.loader;e!==ei&&e!==Wr?(l.b.log("[config]: Custom loader detected, cannot enable progressive streaming"),t.progressive=!1):function(){if(self.fetch&&self.AbortController&&self.ReadableStream&&self.Request)try{return new self.ReadableStream({}),!0}catch(t){}return!1}()&&(t.loader=ei,t.progressive=!0,t.enableSoftwareAES=!0,l.b.log("[config]: Progressive streaming enabled, using FetchLoader"))}function ui(t,e){for(var r=0;r<e.length;r++){var i=e[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}var hi=function(){function t(e){void 0===e&&(e={}),this.config=void 0,this.userConfig=void 0,this.coreComponents=void 0,this.networkControllers=void 0,this._emitter=new ne.EventEmitter,this._autoLevelCapping=void 0,this.abrController=void 0,this.bufferController=void 0,this.capLevelController=void 0,this.latencyController=void 0,this.levelController=void 0,this.streamController=void 0,this.audioTrackController=void 0,this.subtitleTrackController=void 0,this.emeController=void 0,this.cmcdController=void 0,this._media=null,this.url=null;var r=this.config=function(t,e){if((e.liveSyncDurationCount||e.liveMaxLatencyDurationCount)&&(e.liveSyncDuration||e.liveMaxLatencyDuration))throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");if(void 0!==e.liveMaxLatencyDurationCount&&(void 0===e.liveSyncDurationCount||e.liveMaxLatencyDurationCount<=e.liveSyncDurationCount))throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');if(void 0!==e.liveMaxLatencyDuration&&(void 0===e.liveSyncDuration||e.liveMaxLatencyDuration<=e.liveSyncDuration))throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');return ii({},t,e)}(t.DefaultConfig,e);this.userConfig=e,Object(l.a)(r.debug),this._autoLevelCapping=-1,r.progressive&&li(r);var i=r.abrController,n=r.bufferController,a=r.capLevelController,s=r.fpsController,o=this.abrController=new i(this),u=this.bufferController=new n(this),h=this.capLevelController=new a(this),d=new s(this),c=new P(this),f=new M(this),g=new V(this),v=this.levelController=new dt(this),p=new ct(this),m=this.streamController=new he(this,p);h.setStreamController(m),d.setStreamController(m);var y=[v,m];this.networkControllers=y;var T=[c,f,o,u,h,d,g,p];this.audioTrackController=this.createController(r.audioTrackController,null,y),this.createController(r.audioStreamController,p,y),this.subtitleTrackController=this.createController(r.subtitleTrackController,null,y),this.createController(r.subtitleStreamController,p,y),this.createController(r.timelineController,null,T),this.emeController=this.createController(r.emeController,null,T),this.cmcdController=this.createController(r.cmcdController,null,T),this.latencyController=this.createController(q,null,T),this.coreComponents=T}t.isSupported=function(){return function(){var t=te();if(!t)return!1;var e=ee(),r=t&&"function"==typeof t.isTypeSupported&&t.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),i=!e||e.prototype&&"function"==typeof e.prototype.appendBuffer&&"function"==typeof e.prototype.remove;return!!r&&!!i}()};var e,r,i,a=t.prototype;return a.createController=function(t,e,r){if(t){var i=e?new t(this,e):new t(this);return r&&r.push(i),i}return null},a.on=function(t,e,r){void 0===r&&(r=this),this._emitter.on(t,e,r)},a.once=function(t,e,r){void 0===r&&(r=this),this._emitter.once(t,e,r)},a.removeAllListeners=function(t){this._emitter.removeAllListeners(t)},a.off=function(t,e,r,i){void 0===r&&(r=this),this._emitter.off(t,e,r,i)},a.listeners=function(t){return this._emitter.listeners(t)},a.emit=function(t,e,r){return this._emitter.emit(t,e,r)},a.trigger=function(t,e){if(this.config.debug)return this.emit(t,t,e);try{return this.emit(t,t,e)}catch(e){l.b.error("An internal error happened while handling event "+t+'. Error message: "'+e.message+'". Here is a stacktrace:',e),this.trigger(s.a.ERROR,{type:o.b.OTHER_ERROR,details:o.a.INTERNAL_EXCEPTION,fatal:!1,event:t,error:e})}return!1},a.listenerCount=function(t){return this._emitter.listenerCount(t)},a.destroy=function(){l.b.log("destroy"),this.trigger(s.a.DESTROYING,void 0),this.detachMedia(),this.removeAllListeners(),this._autoLevelCapping=-1,this.url=null,this.networkControllers.forEach((function(t){return t.destroy()})),this.networkControllers.length=0,this.coreComponents.forEach((function(t){return t.destroy()})),this.coreComponents.length=0},a.attachMedia=function(t){l.b.log("attachMedia"),this._media=t,this.trigger(s.a.MEDIA_ATTACHING,{media:t})},a.detachMedia=function(){l.b.log("detachMedia"),this.trigger(s.a.MEDIA_DETACHING,void 0),this._media=null},a.loadSource=function(t){this.stopLoad();var e=this.media,r=this.url,i=this.url=n.buildAbsoluteURL(self.location.href,t,{alwaysNormalize:!0});l.b.log("loadSource:"+i),e&&r&&r!==i&&this.bufferController.hasSourceTypes()&&(this.detachMedia(),this.attachMedia(e)),this.trigger(s.a.MANIFEST_LOADING,{url:t})},a.startLoad=function(t){void 0===t&&(t=-1),l.b.log("startLoad("+t+")"),this.networkControllers.forEach((function(e){e.startLoad(t)}))},a.stopLoad=function(){l.b.log("stopLoad"),this.networkControllers.forEach((function(t){t.stopLoad()}))},a.swapAudioCodec=function(){l.b.log("swapAudioCodec"),this.streamController.swapAudioCodec()},a.recoverMediaError=function(){l.b.log("recoverMediaError");var t=this._media;this.detachMedia(),t&&this.attachMedia(t)},a.removeLevel=function(t,e){void 0===e&&(e=0),this.levelController.removeLevel(t,e)},e=t,i=[{key:"version",get:function(){return"1.2.0"}},{key:"Events",get:function(){return s.a}},{key:"ErrorTypes",get:function(){return o.b}},{key:"ErrorDetails",get:function(){return o.a}},{key:"DefaultConfig",get:function(){return t.defaultConfig?t.defaultConfig:oi},set:function(e){t.defaultConfig=e}}],(r=[{key:"levels",get:function(){var t=this.levelController.levels;return t||[]}},{key:"currentLevel",get:function(){return this.streamController.currentLevel},set:function(t){l.b.log("set currentLevel:"+t),this.loadLevel=t,this.abrController.clearTimer(),this.streamController.immediateLevelSwitch()}},{key:"nextLevel",get:function(){return this.streamController.nextLevel},set:function(t){l.b.log("set nextLevel:"+t),this.levelController.manualLevel=t,this.streamController.nextLevelSwitch()}},{key:"loadLevel",get:function(){return this.levelController.level},set:function(t){l.b.log("set loadLevel:"+t),this.levelController.manualLevel=t}},{key:"nextLoadLevel",get:function(){return this.levelController.nextLoadLevel},set:function(t){this.levelController.nextLoadLevel=t}},{key:"firstLevel",get:function(){return Math.max(this.levelController.firstLevel,this.minAutoLevel)},set:function(t){l.b.log("set firstLevel:"+t),this.levelController.firstLevel=t}},{key:"startLevel",get:function(){return this.levelController.startLevel},set:function(t){l.b.log("set startLevel:"+t),-1!==t&&(t=Math.max(t,this.minAutoLevel)),this.levelController.startLevel=t}},{key:"capLevelToPlayerSize",get:function(){return this.config.capLevelToPlayerSize},set:function(t){var e=!!t;e!==this.config.capLevelToPlayerSize&&(e?this.capLevelController.startCapping():(this.capLevelController.stopCapping(),this.autoLevelCapping=-1,this.streamController.nextLevelSwitch()),this.config.capLevelToPlayerSize=e)}},{key:"autoLevelCapping",get:function(){return this._autoLevelCapping},set:function(t){this._autoLevelCapping!==t&&(l.b.log("set autoLevelCapping:"+t),this._autoLevelCapping=t)}},{key:"bandwidthEstimate",get:function(){var t=this.abrController.bwEstimator;return t?t.getEstimate():NaN}},{key:"autoLevelEnabled",get:function(){return-1===this.levelController.manualLevel}},{key:"manualLevel",get:function(){return this.levelController.manualLevel}},{key:"minAutoLevel",get:function(){var t=this.levels,e=this.config.minAutoBitrate;if(!t)return 0;for(var r=t.length,i=0;i<r;i++)if(t[i].maxBitrate>=e)return i;return 0}},{key:"maxAutoLevel",get:function(){var t=this.levels,e=this.autoLevelCapping;return-1===e&&t&&t.length?t.length-1:e}},{key:"nextAutoLevel",get:function(){return Math.min(Math.max(this.abrController.nextAutoLevel,this.minAutoLevel),this.maxAutoLevel)},set:function(t){this.abrController.nextAutoLevel=Math.max(this.minAutoLevel,t)}},{key:"playingDate",get:function(){return this.streamController.currentProgramDateTime}},{key:"audioTracks",get:function(){var t=this.audioTrackController;return t?t.audioTracks:[]}},{key:"audioTrack",get:function(){var t=this.audioTrackController;return t?t.audioTrack:-1},set:function(t){var e=this.audioTrackController;e&&(e.audioTrack=t)}},{key:"subtitleTracks",get:function(){var t=this.subtitleTrackController;return t?t.subtitleTracks:[]}},{key:"subtitleTrack",get:function(){var t=this.subtitleTrackController;return t?t.subtitleTrack:-1},set:function(t){var e=this.subtitleTrackController;e&&(e.subtitleTrack=t)}},{key:"media",get:function(){return this._media}},{key:"subtitleDisplay",get:function(){var t=this.subtitleTrackController;return!!t&&t.subtitleDisplay},set:function(t){var e=this.subtitleTrackController;e&&(e.subtitleDisplay=t)}},{key:"lowLatencyMode",get:function(){return this.config.lowLatencyMode},set:function(t){this.config.lowLatencyMode=t}},{key:"liveSyncPosition",get:function(){return this.latencyController.liveSyncPosition}},{key:"latency",get:function(){return this.latencyController.latency}},{key:"maxLatency",get:function(){return this.latencyController.maxLatency}},{key:"targetLatency",get:function(){return this.latencyController.targetLatency}},{key:"drift",get:function(){return this.latencyController.drift}},{key:"forceStartLoad",get:function(){return this.streamController.forceStartLoad}}])&&ui(e.prototype,r),i&&ui(e,i),Object.defineProperty(e,"prototype",{writable:!1}),t}();hi.defaultConfig=void 0}]).default}));
//# sourceMappingURL=hls.min.js.map

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + chunkId + ".capshine.js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "capshine:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		var scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		var document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript)
/******/ 				scriptUrl = document.currentScript.src
/******/ 			if (!scriptUrl) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) scriptUrl = scripts[scripts.length - 1].src
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkcapshine"] = self["webpackChunkcapshine"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "APIHelper": () => (/* reexport */ APIHelper),
  "ActivityPlaylistType": () => (/* reexport */ src_ActivityPlaylistType),
  "AllMcqBase": () => (/* reexport */ AllMcqBase),
  "AppEnvironment": () => (/* reexport */ AppEnvironment),
  "AppPerPanel": () => (/* binding */ AppPerPanel),
  "AssessYourEnglish": () => (/* reexport */ AssessYourEnglish),
  "CSMainAPIs": () => (/* reexport */ CSMainAPIs),
  "CapshineActivity": () => (/* reexport */ js_Activity),
  "CapshineDI": () => (/* reexport */ CapshineDI),
  "CapshineDailyActivity": () => (/* reexport */ js_DailyActivity),
  "CapshineDailyActivityDetails": () => (/* reexport */ js_DailyActivityDetails),
  "CapshineDailyActivityResponse": () => (/* reexport */ js_DailyActivityResponse),
  "CapshineEditProfile": () => (/* reexport */ js_EditProfile),
  "CapshineHome": () => (/* reexport */ js_Home),
  "CapshineMyAccount": () => (/* reexport */ js_MyAccount),
  "CapshineQuery": () => (/* reexport */ CapshineQuery),
  "CapshineSample": () => (/* reexport */ CapshineSample),
  "CapshineTalktime": () => (/* reexport */ js_Talktime),
  "ClickTracker": () => (/* reexport */ ClickTracker),
  "ClubRegistration": () => (/* reexport */ ClubRegistration),
  "CoachDashboardScript": () => (/* reexport */ js_CoachDashboardScript),
  "CodeOfConduct": () => (/* reexport */ js_CodeOfConduct),
  "FieldRegistry": () => (/* reexport */ FieldRegistry),
  "InitPanel": () => (/* binding */ InitPanel),
  "IntroJS": () => (/* reexport */ Intro_namespaceObject),
  "JobInerviewCourseVideoQuizScript": () => (/* reexport */ js_JobInerviewCourseVideoQuizScript),
  "JobInterviewCoursePreviewScript": () => (/* reexport */ js_JobInterviewCoursePreviewScript),
  "JobInterviewCourseScript": () => (/* reexport */ JobInterviewCourse),
  "LearningVideoMCQScript": () => (/* reexport */ js_LearningVideoMCQScript),
  "LiveSessionManagementToolScript": () => (/* reexport */ js_LiveSessionManagementToolScript),
  "LoginWeb": () => (/* reexport */ LoginWeb),
  "McqTypeOption": () => (/* reexport */ McqTypeOption),
  "MobileApps": () => (/* reexport */ MobileApps),
  "MobilePages": () => (/* reexport */ MobilePages),
  "MyClub": () => (/* reexport */ js_MyClub),
  "PaymentPlans": () => (/* reexport */ PaymentPlans),
  "PaymentThankyou": () => (/* reexport */ PaymentThankyou),
  "PaymentUpgradeRequestScript": () => (/* reexport */ js_PaymentUpgradeRequestScript),
  "Payments": () => (/* reexport */ js_Payments),
  "ScreenActions": () => (/* reexport */ ScreenActions),
  "ShortVideosViewAllScript": () => (/* reexport */ js_ShortVideosViewAllScript),
  "SignUpTalktime": () => (/* reexport */ SignUpTalktime),
  "SlkAppPanel": () => (/* reexport */ SlkAppPanel),
  "SlkBottomSheet": () => (/* reexport */ SlkBottomSheet),
  "SlkCheckBox": () => (/* reexport */ SlkCheckBox),
  "SlkContainer": () => (/* reexport */ SlkContainer),
  "SlkContainerOf": () => (/* reexport */ SlkContainerOf),
  "SlkDatePicker": () => (/* reexport */ SlkDatePicker),
  "SlkField": () => (/* reexport */ SlkField),
  "SlkFixedBottomSheet": () => (/* reexport */ SlkFixedBottomSheet),
  "SlkPanel": () => (/* reexport */ SlkPanel),
  "SlkRadioButton": () => (/* reexport */ SlkRadioButton),
  "SlkTab": () => (/* reexport */ SlkTab),
  "SlkTabs": () => (/* reexport */ SlkTabs),
  "SlkTextBox": () => (/* reexport */ SlkTextBox),
  "SulekhaAPI": () => (/* reexport */ SulekhaAPI),
  "SulekhaAppSource": () => (/* reexport */ SulekhaAppSource),
  "SulekhaCoreDI": () => (/* reexport */ SulekhaCoreDI),
  "SulekhaGetAPI": () => (/* reexport */ SulekhaGetAPI),
  "SulekhaProduct": () => (/* reexport */ SulekhaProduct),
  "TalkTimeManagementToolScript": () => (/* reexport */ js_TalkTimeManagementToolScript),
  "TalktimeManageSession": () => (/* reexport */ js_TalktimeManageSession),
  "VideoLessonsScript": () => (/* reexport */ js_VideoLessonsScript),
  "VideoScript": () => (/* reexport */ js_VideoScript),
  "ViewRegistry": () => (/* reexport */ ViewRegistry),
  "VoiceRecordingScript": () => (/* reexport */ VoiceRecording),
  "WatchJobInterviewVideoScript": () => (/* reexport */ js_WatchJobInterviewVideoScript),
  "WatchJobInterviewYoutubeVideoScript": () => (/* reexport */ js_WatchJobInterviewYoutubeVideoScript),
  "WatchShortVideoHLSPlayerScript": () => (/* reexport */ js_WatchShortVideoHLSPlayerScript),
  "WatchShortVideoScript": () => (/* reexport */ js_WatchShortVideoScript),
  "WatchShortVideoScriptInIOSYt": () => (/* reexport */ js_WatchShortVideoScriptInIOSYt),
  "WatchShortVideosInIOSScript": () => (/* reexport */ js_WatchShortVideosInIOSScript),
  "WatchVideoScript": () => (/* reexport */ js_WatchVideoScript),
  "WathedVideoLessonsScript": () => (/* reexport */ js_WathedVideoLessonsScript),
  "bindGA": () => (/* reexport */ GATrack)
});

// NAMESPACE OBJECT: ./src/js/Intro.js
var Intro_namespaceObject = {};
__webpack_require__.r(Intro_namespaceObject);
__webpack_require__.d(Intro_namespaceObject, {
  "showIntroScreen": () => (showIntroScreen)
});

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/APIHelper.ts
class APIHelper {
    static apiInfo;
    static setApiInfo(info) {
        APIHelper.apiInfo = info;
    }
    static ClearInfo() {
        const apiInfo = APIHelper.apiInfo;
        apiInfo.hadError = false;
        setTimeout(function () { apiInfo.runningCount -= 1; }, 300);
        apiInfo.errorMessage = apiInfo.loadMessage = '';
    }
    static StartRunning(loadMessage) {
        APIHelper.apiInfo.loadMessage = loadMessage;
        APIHelper.apiInfo.runningCount += 1;
    }
    static _LogError(err) {
        APIHelper.apiInfo.runningCount -= 1;
        APIHelper.apiInfo.hadError = true;
        APIHelper.apiInfo.errorMessage = err.toString();
    }
    // eslint-disable-next-line
    static _CheckContract(params, contract) {
        throw new Error('Not Implemented Yet');
    }
    static _GetFormData(obj) {
        const form = new FormData();
        for (const key in obj) {
            form.append(key, obj[key]);
        }
        return form;
    }
    static _ReplaceUrl(apiUrl, obj) {
        for (const key in obj) {
            if (key === null)
                continue;
            apiUrl = apiUrl.replace('{' + key + "}", obj[key]);
        }
        return apiUrl;
    }
    // eslint-disable-next-line
    static _ReplaceRawPathParams(url, obj) {
        for (const key in obj)
            url = url.replace(':' + key, obj[key]);
        return url;
    }
    //public methods begin
    static GetQueryString(apiUrl, obj) {
        const bits = new Array();
        for (const key in obj) {
            if (key === null)
                continue;
            bits.push(key + "=" + obj[key]);
        }
        if (bits.length == 0)
            return '';
        return (apiUrl.indexOf('?') !== -1 ? '&' : '?') + bits.join("&");
    }
    static InvertQueryString(params) {
        const result = {};
        const bits = params.split('&');
        for (const key in bits) {
            const keyVal = bits[key].split('=', 2);
            result[keyVal[0]] = keyVal[1];
        }
        return result;
    }
    static FetchHtml(url, callback) {
        fetch(url)
            .then(function (res) {
            res.text().then(function (html) { callback(html, res); });
        });
    }
    static FetchJson(url, callback) {
        return fetch(url)
            .then(function (res) {
            res.json().then(function (json) { callback(json, res); });
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/SulekhaCoreDI.ts
class SulekhaCoreDI {
    static LogApiCall;
    static LogClick;
    static showToast;
    static getPageName;
    static IsNetworkConnected;
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/SulekhaAPI.ts
//NB: glean from this: https://javascript.plainenglish.io/how-to-make-your-js-fetch-not-look-so-ugly-f45c89f8bc3a


var ContentTypes;
(function (ContentTypes) {
    ContentTypes["Json"] = "application/json";
    ContentTypes["FormUrlEncoded"] = "application/x-www-form-urlencoded";
    ContentTypes["Plain"] = "text/plain";
    ContentTypes["FormData"] = "multipart/form-data";
})(ContentTypes || (ContentTypes = {}));
;
var FetchMethods;
(function (FetchMethods) {
    FetchMethods["Post"] = "POST";
    FetchMethods["Get"] = "GET";
    FetchMethods["Put"] = "PUT";
    FetchMethods["Delete"] = "DELETE";
})(FetchMethods || (FetchMethods = {}));
;
class SlkServer {
    static lastServerCreated;
    name;
    baseUrl = '';
    constructor(name) { this.name = name; SlkServer.lastServerCreated = this; }
    APIs = [];
}
class SulekhaGetAPI {
    server;
    relUrl;
    // eslint-disable-next-line
    contract;
    loadMessage;
    usesUrlReplaces;
    constructor(relUrl, loadMessage, contract, usesUrlReplaces = false) {
        this.server = SlkServer.lastServerCreated;
        this.relUrl = relUrl;
        this.loadMessage = loadMessage;
        this.contract = contract;
        this.usesUrlReplaces = usesUrlReplaces;
    }
    getUrl(urlParams) {
        let apiUrl = this.server.baseUrl + this.relUrl;
        if (this.usesUrlReplaces)
            apiUrl = APIHelper._ReplaceUrl(apiUrl, urlParams);
        else
            apiUrl += APIHelper.GetQueryString(this.relUrl, urlParams);
        return apiUrl;
    }
    execute(urlParams, callback, checkContract = false) {
        APIHelper.StartRunning(this.loadMessage);
        if (checkContract)
            APIHelper._CheckContract(urlParams, this.contract);
        const apiUrl = this.getUrl(urlParams);
        const request = {};
        const headers = new Headers();
        SulekhaAPI.setAppHeadersImpl(headers);
        request.headers = headers;
        SulekhaCoreDI.LogApiCall(this.loadMessage, apiUrl, 'GET');
        return fetch(apiUrl, request)
            .then(function (res) {
            const content = res.headers.get('Content-Type');
            const json = content && content.includes(ContentTypes.Json);
            //TODO: MED: Too much automagic - change contract to pass data directly
            if (json)
                res.json().then(function (json) { callback({ data: json, res: res }); });
            else
                res.text().then(function (text) { callback({ data: text, res: res }); });
        })
            .then(APIHelper.ClearInfo)
            .catch(err => {
            SulekhaCoreDI.showToast({
                message: "Something Went wrong, Please try again later",
                interval: 3000
            });
            console.error(apiUrl, err);
            APIHelper._LogError(err);
            //TODO: HIGH Prio - Need to reset the loader after api failure
            APIHelper.ClearInfo();
        });
    }
}
///Defaults to POST
class SulekhaAPI {
    server;
    relUrl;
    contract;
    querystringContract;
    loadMessage;
    usesFormData = false;
    method = FetchMethods.Post;
    static setAppHeadersImpl;
    constructor(relUrl, loadMessage, contract, querystringContract = null) {
        this.server = SlkServer.lastServerCreated;
        this.server.APIs.push(this);
        this.relUrl = relUrl;
        this.loadMessage = loadMessage;
        this.contract = contract;
        this.querystringContract = querystringContract;
    }
    //NB: This tells the execute method NOT to set any headers as random separator ------WebKitFormBoundary needs to match the header multipart/form-data;
    postsFormData() {
        this.usesFormData = true;
        return this;
    }
    useMethod(method) {
        this.method = method;
        return this;
    }
    execute(postParams, callback, urlParams = null, checkContract = false) {
        let apiUrl = this.server.baseUrl + this.relUrl;
        APIHelper.StartRunning(this.loadMessage);
        if (checkContract) {
            APIHelper._CheckContract(postParams, this.contract);
            if (this.querystringContract)
                APIHelper._CheckContract(urlParams, this.querystringContract);
        }
        if (urlParams != null)
            apiUrl += APIHelper.GetQueryString(this.relUrl, urlParams);
        const body = this.usesFormData
            ? postParams
            : JSON.stringify(postParams);
        const request = { method: this.method.toString(), body: body };
        const headers = new Headers();
        if (!this.usesFormData)
            headers.append('Content-Type', ContentTypes.Json.toString());
        SulekhaAPI.setAppHeadersImpl(headers);
        request.headers = headers;
        SulekhaCoreDI.LogApiCall(this.loadMessage, apiUrl, 'POST');
        return fetch(apiUrl, request)
            .then(function (res) {
            const content = res.headers.get('Content-Type');
            const json = content && content.includes(ContentTypes.Json);
            //TODO: MED: Too much automagic - change contract to pass data directly
            if (json)
                res.json().then(function (json) { callback({ data: json, res: res }); });
            else
                res.text().then(function (text) { callback({ data: text, res: res }); });
        })
            .then(APIHelper.ClearInfo)
            .catch(err => {
            SulekhaCoreDI.showToast({
                message: "Something Went wrong, Please try again later",
                interval: 3000
            });
            console.error(apiUrl, err);
            APIHelper._LogError(err);
            //TODO: HIGH Prio - Need to reset the loader after api failure
            APIHelper.ClearInfo();
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/View/ClickTracker.ts

class ClickTracker {
    static RegisterTracker(app) {
        app.mixin({
            methods: {
                trackClick: function (event, action) {
                    SulekhaCoreDI.LogClick({ name: action });
                }
            }
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/View/ScreenActions.ts

const ScreenKeys = {
    //a class 
    hasAction: 'has-action',
    //holds in memory to know its registered the click event (makes register multiple call safe)
    registered: 'action-registered',
    //attributes available on the 
    name: 'action-name',
    params: 'action-params',
    track: 'track-action',
    //added to tracking
    error: 'action-error',
};
class ScreenActions {
    static actions = {};
    static Functions;
    //called to register functions
    // eslint-disable-next-line
    static RegisterFns(args) {
        ScreenActions.actions = {};
        for (const ix in args) {
            // eslint-disable-next-line
            const fn = args[ix];
            const name = fn.name.replace('bound ', '');
            ScreenActions.actions[name] = fn;
        }
    }
    //called after html is set in place
    //<a class="has-action" action-name="openChatbot" action-params="{arg1:'xyz'}" track-action="true"
    static RegisterAfter(interval = 300) {
        setTimeout(ScreenActions.RegisterImpl, interval);
    }
    static RegisterImpl() {
        const elements = document.querySelectorAll('.' + ScreenKeys.hasAction);
        for (const el of elements) {
            if (el.hasAttribute(ScreenKeys.registered))
                continue;
            //NB: if format is 'change:name' it will register change event instead of click. if 'setData:name', it will call the callback fn with the params immediately
            let eventName = 'click', actionName = el.getAttribute(ScreenKeys.name);
            const bits = actionName.split(':');
            if (bits.length > 1) {
                eventName = bits[0];
                actionName = bits[1];
                el.setAttribute(ScreenKeys.name, actionName);
            }
            if (eventName == 'setData')
                ScreenActions._onElementClick({ currentTarget: el });
            else if (eventName == 'change')
                el.addEventListener(eventName, ScreenActions._onElementClick);
            else
                el.addEventListener(eventName, ScreenActions._onElementClick);
            el.setAttribute(ScreenKeys.registered, 'yes');
        }
    }
    static ThrowError() {
        throw new Error('test error throwing in action click');
    }
    static _onElementClick(event) {
        const el = event.currentTarget;
        const actionName = el.getAttribute(ScreenKeys.name);
        let params = el.getAttribute(ScreenKeys.params), hasError = false;
        const track = el.getAttribute(ScreenKeys.track);
        if (params)
            params = JSON.parse(params);
        else
            params = {};
        params[ScreenKeys.name] = actionName;
        const actionNotFound = !ScreenActions.actions[actionName];
        if (actionNotFound) {
            console.warn(params[ScreenKeys.error] = actionName + ' not found on page ' + SulekhaCoreDI.getPageName());
            hasError = true;
        }
        else {
            // eslint-disable-next-line
            const action = ScreenActions.actions[actionName];
            try {
                action(params, el);
            }
            catch (e) {
                params[ScreenKeys.error] = e.toString();
                hasError = true;
            }
        }
        if (track || hasError)
            SulekhaCoreDI.LogClick(params);
    }
}

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.cjs.js
var vue_cjs = __webpack_require__(961);
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/View/SlkContainer.ts

class Helper {
    static State;
    static OpenContainers = [];
    //containers on the current page
    static PageContainers = [];
    static ClearOpen() {
        Helper.OpenContainers = [];
        Helper.PageContainers = [];
        location.hash = '';
    }
    static HasAnyTabs() {
        return Helper.PageContainers.filter(x => x.isTab).length > 0;
    }
    static BackOneToTab() {
        window.history.back();
    }
    static AddOrRemoveToOpen(c, remove) {
        const foundAt = Helper.OpenContainers.indexOf(c);
        if (remove) {
            if (foundAt != -1)
                Helper.OpenContainers.slice(foundAt, foundAt);
        }
        else {
            if (foundAt == -1)
                Helper.OpenContainers.push(c);
            if (Helper.PageContainers.indexOf(c) == -1)
                Helper.PageContainers.push(c);
        }
        Helper.State.hasContainersOpen = Helper.OpenContainers.length > 0;
    }
    static HideLastOpened() {
        if (!Helper.OpenContainers.length)
            return false;
        const c = Helper.OpenContainers.pop();
        c?.hide();
        return true;
    }
    static onToggleShow(c, newValue) {
        if (newValue == true) {
            if (Helper.isChangingHash)
                return;
            location.hash = c.hash ? '#' + c.hash : '';
        }
        else {
            if (Helper.isChangingHash)
                return;
            if (Helper.HasAnyTabs())
                return;
            location.hash = '';
        }
    }
    static isChangingHash = false;
    static oldHash = '';
    static RegisterHashChanged() {
        window.onhashchange = (ev) => {
            let hash = Helper.oldHash;
            const newHash = location.hash;
            if (Helper.isChangingHash || hash == newHash)
                return;
            if (hash) {
                hash = hash.substr(1);
                const c = Helper.PageContainers.find(x => x.hash == hash);
                Helper.isChangingHash = true;
                if (c && c.state.shown)
                    c.hide();
                Helper.isChangingHash = false;
            }
            Helper.oldHash = hash = newHash;
            if (hash) {
                hash = hash.substr(1);
                const c = Helper.PageContainers.find(x => x.hash == hash);
                Helper.isChangingHash = true;
                if (c && !c.state.shown)
                    c.show();
                Helper.isChangingHash = false;
            }
        };
    }
    static Show(c) {
        Helper.AddOrRemoveToOpen(c, false);
    }
    static Hide(c) {
        Helper.AddOrRemoveToOpen(c, true);
    }
}
class SlkContainer {
    static Register(state) {
        Helper.State = state;
        Helper.RegisterHashChanged();
    }
    static ClearOpen() {
        Helper.ClearOpen();
    }
    static HideLastOpened() {
        return Helper.HideLastOpened();
    }
    hash;
    isTab;
    constructor(name, isTab = false) {
        this.hash = name.replaceAll(' ', '-').toLowerCase();
        this.isTab = isTab;
        // eslint-disable-next-line
        const c = this;
        (0,vue_cjs.watch)(() => this.state.shown, (newValue) => { Helper.onToggleShow(c, newValue); });
    }
    state = (0,vue_cjs.reactive)({
        shown: false
    });
    show() {
        this.state.shown = true;
        Helper.Show(this);
        if (this.onShow)
            this.onShow();
    }
    hide() {
        if (!Helper.isChangingHash && this.isTab == false && Helper.HasAnyTabs()) {
            Helper.BackOneToTab();
        }
        this.state.shown = false;
        Helper.Hide(this);
        if (this.onHide)
            this.onHide();
    }
    onShow;
    onHide;
}
class SlkContainerOf extends SlkContainer {
    data;
    constructor(name, data) {
        super(name);
        this.data = data;
    }
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/View/SlkTab.ts


class SlkTab {
    name;
    block;
    state = (0,vue_cjs.reactive)({
        loading: false,
        loaded: false,
        apiHtml: ''
    });
    firstLoad;
    constructor(name) {
        this.name = name;
        this.block = new SlkContainer(name, true);
    }
    setFirstLoad(firstLoad) {
        this.firstLoad = firstLoad;
        return this;
    }
    beginLoad() {
        this.state.loading = true;
        if (this.firstLoad)
            this.firstLoad(this);
    }
    completeLoading() {
        this.state.loaded = true;
        this.state.loading = false;
    }
}
class SlkTabs {
    name;
    tabs;
    activeTab;
    constructor(pageName, tabs) {
        this.name = pageName;
        this.tabs = tabs;
        this.tabs.forEach(x => {
            (0,vue_cjs.watch)(() => { return x.block.state.shown; }, (newVal, oldVal) => {
                if (newVal && this.activeTab != x)
                    this.setActive(x);
            });
        });
        const tab1 = tabs[0];
        tab1.block.show();
        this.activeTab = tab1;
    }
    setActive(tab) {
        const others = this.tabs.filter(x => x.name != tab.name);
        others.forEach(x => x.block.state.shown = false); //NB: Hide is not multi call safe
        this.activeTab = tab;
        tab.block.show();
        if (tab.firstLoad && !tab.state.loaded) {
            tab.beginLoad();
        }
    }
}

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkAppPanel.vue?vue&type=template&id=eae099c0&ts=true

const _hoisted_1 = { class: "sk-inner" };
const _hoisted_2 = { class: "sk-header" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = { class: "right-nav" };
const _hoisted_5 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconClose" }, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "sk-body" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("section", {
        id: "faqSulekhaPanel",
        class: (0,vue_cjs.normalizeClass)([{ show: _ctx.showPanel }, "section-wrap sk-panel-app"])
    }, [
        (0,vue_cjs.createElementVNode)("div", _hoisted_1, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_2, [
                (0,vue_cjs.createElementVNode)("h2", _hoisted_3, (0,vue_cjs.toDisplayString)(_ctx.title), 1),
                (0,vue_cjs.createElementVNode)("div", _hoisted_4, [
                    ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:showPanel', false))),
                        class: "icon icon-chevron",
                        width: "13",
                        height: "13",
                        viewBox: "0 0 329.26933 329"
                    }, _hoisted_6))
                ])
            ]),
            (0,vue_cjs.createElementVNode)("div", _hoisted_7, [
                (0,vue_cjs.renderSlot)(_ctx.$slots, "default")
            ])
        ])
    ], 2));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkAppPanel.vue?vue&type=template&id=eae099c0&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkAppPanel.vue?vue&type=script&lang=ts

/* harmony default export */ const SlkAppPanelvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkAppPanel',
    props: {
        title: String,
        showPanel: Boolean,
    },
    mounted() {
        console.log(this.showPanel);
    }
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkAppPanel.vue?vue&type=script&lang=ts
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(744);
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkAppPanel.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkAppPanelvue_type_script_lang_ts, [['render',render]])

/* harmony default export */ const SlkAppPanel = (__exports__);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkBottomSheet.vue?vue&type=template&id=7abc1846&ts=true

const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_1 = { class: "sk-inner" };
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_2 = {
    key: 0,
    class: "dragger"
};
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "strip" }, null, -1);
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_4 = [
    SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_3
];
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_5 = { class: "sk-header" };
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_6 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("a", { "aria-label": "go to number input" }, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        class: "icon icon-chevron",
        width: "13",
        height: "13",
        viewBox: "0 0 329.26933 329"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconClose" })
    ])
], -1);
const SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_7 = [
    SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_6
];
const _hoisted_8 = { class: "title" };
const _hoisted_9 = { class: "sk-body" };
function SlkBottomSheetvue_type_template_id_7abc1846_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
        (!_ctx.outsideClickAndSwipeNotAllowed)
            ? (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                key: 0,
                class: "sk-bottom-sheet-background",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.block.hide && _ctx.block.hide(...args)))
            }, null, 512)), [
                [vue_cjs.vShow, _ctx.block.state.shown]
            ])
            : (0,vue_cjs.createCommentVNode)("", true),
        (0,vue_cjs.createElementVNode)("div", {
            class: (0,vue_cjs.normalizeClass)(["sk-bottom-sheet draggable", { show: _ctx.block.state.shown }])
        }, [
            (0,vue_cjs.createElementVNode)("div", SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_1, [
                (!_ctx.outsideClickAndSwipeNotAllowed)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_2, SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_4))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("div", SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_5, [
                    (0,vue_cjs.createElementVNode)("div", {
                        class: "left-nav close-link",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.block.hide && _ctx.block.hide(...args)))
                    }, SlkBottomSheetvue_type_template_id_7abc1846_ts_true_hoisted_7),
                    (0,vue_cjs.createElementVNode)("span", _hoisted_8, (0,vue_cjs.toDisplayString)(_ctx.title), 1)
                ]),
                (0,vue_cjs.createElementVNode)("div", _hoisted_9, [
                    (0,vue_cjs.renderSlot)(_ctx.$slots, "default")
                ])
            ])
        ], 2)
    ]));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkBottomSheet.vue?vue&type=template&id=7abc1846&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkBottomSheet.vue?vue&type=script&lang=ts


/* harmony default export */ const SlkBottomSheetvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkBottomSheet',
    props: {
        title: { type: String, required: true },
        outsideClickAndSwipeNotAllowed: { type: Boolean, default: false },
        block: { type: SlkContainer, required: true },
    },
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkBottomSheet.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkBottomSheet.vue




;
const SlkBottomSheet_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkBottomSheetvue_type_script_lang_ts, [['render',SlkBottomSheetvue_type_template_id_7abc1846_ts_true_render]])

/* harmony default export */ const SlkBottomSheet = (SlkBottomSheet_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkFixedBottomSheet.vue?vue&type=template&id=80fd016e&ts=true

const SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_1 = { class: "sk-inner lcf-wrapper" };
const SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_2 = { class: "title" };
const SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "right-nav show" }, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        class: "icon icon-chevron",
        width: "15",
        height: "10.41",
        viewBox: "0 0 12 7.41"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconDownChevron" })
    ])
], -1);
function SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
        class: (0,vue_cjs.normalizeClass)(["sk-panel draggable", { show: _ctx.show, 'head-view': _ctx.headerObj.isHeadView, 'half-view': _ctx.headerObj.isHalfView, 'full-view': _ctx.headerObj.isFullView }])
    }, [
        (0,vue_cjs.createElementVNode)("div", SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_1, [
            (0,vue_cjs.createElementVNode)("div", {
                class: "sk-header blue-bg",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.toggleView && _ctx.toggleView(...args)))
            }, [
                (0,vue_cjs.createElementVNode)("span", SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_2, (0,vue_cjs.toDisplayString)(_ctx.title), 1),
                SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_hoisted_3
            ]),
            (0,vue_cjs.createElementVNode)("div", {
                class: "sk-body",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.toggleToFullView && _ctx.toggleToFullView(...args)))
            }, [
                (0,vue_cjs.renderSlot)(_ctx.$slots, "default")
            ])
        ])
    ], 2));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkFixedBottomSheet.vue?vue&type=template&id=80fd016e&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkFixedBottomSheet.vue?vue&type=script&lang=ts

/* harmony default export */ const SlkFixedBottomSheetvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkFixedBottomSheet',
    props: {
        title: String,
        show: {
            type: Boolean,
            required: false,
            default: true
        },
        // head, half, full
        defaultView: {
            type: String,
            required: false,
            default: "half"
        },
    },
    setup(props) {
        const headerObj = (0,vue_cjs.reactive)({ isHeadView: props.defaultView === 'head', isHalfView: props.defaultView === 'half', isFullView: props.defaultView === 'full' });
        return { headerObj };
    },
    methods: {
        toggleView() {
            if (this.headerObj.isHalfView || this.headerObj.isHeadView) {
                this.toggleToFullView();
            }
            else if (this.headerObj.isFullView) {
                this.headerObj.isHeadView = true;
                this.headerObj.isHalfView = this.headerObj.isFullView = false;
            }
        },
        toggleToFullView() {
            this.headerObj.isFullView = true;
            this.headerObj.isHalfView = this.headerObj.isHeadView = false;
        }
    }
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkFixedBottomSheet.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkFixedBottomSheet.vue




;
const SlkFixedBottomSheet_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkFixedBottomSheetvue_type_script_lang_ts, [['render',SlkFixedBottomSheetvue_type_template_id_80fd016e_ts_true_render]])

/* harmony default export */ const SlkFixedBottomSheet = (SlkFixedBottomSheet_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkPanel.vue?vue&type=template&id=66016142&ts=true

const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_1 = { class: "sk-inner" };
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_2 = { class: "sk-header" };
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_3 = { class: "left-nav" };
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_4 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconBackArrow" }, null, -1);
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_5 = [
    SlkPanelvue_type_template_id_66016142_ts_true_hoisted_4
];
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_6 = { class: "title" };
const SlkPanelvue_type_template_id_66016142_ts_true_hoisted_7 = { class: "sk-body" };
function SlkPanelvue_type_template_id_66016142_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
        id: "sulekhaPanel",
        class: (0,vue_cjs.normalizeClass)([{ show: _ctx.showPanel }, "sk-panel"])
    }, [
        (0,vue_cjs.createElementVNode)("div", SlkPanelvue_type_template_id_66016142_ts_true_hoisted_1, [
            (0,vue_cjs.createElementVNode)("div", SlkPanelvue_type_template_id_66016142_ts_true_hoisted_2, [
                (0,vue_cjs.createElementVNode)("div", SlkPanelvue_type_template_id_66016142_ts_true_hoisted_3, [
                    ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
                        class: "icon icon-back",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, SlkPanelvue_type_template_id_66016142_ts_true_hoisted_5))
                ]),
                (0,vue_cjs.createElementVNode)("span", SlkPanelvue_type_template_id_66016142_ts_true_hoisted_6, (0,vue_cjs.toDisplayString)(_ctx.title), 1)
            ]),
            (0,vue_cjs.createElementVNode)("div", SlkPanelvue_type_template_id_66016142_ts_true_hoisted_7, [
                (0,vue_cjs.renderSlot)(_ctx.$slots, "default")
            ])
        ])
    ], 2));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkPanel.vue?vue&type=template&id=66016142&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Containers/SlkPanel.vue?vue&type=script&lang=ts

/* harmony default export */ const SlkPanelvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkPanel',
    props: {
        title: String,
        showPanel: Boolean,
    },
    mounted() {
        console.log(this.showPanel);
    },
    methods: {
        goBack() {
            this.$emit('goBack');
        },
    }
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkPanel.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Containers/SlkPanel.vue




;
const SlkPanel_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkPanelvue_type_script_lang_ts, [['render',SlkPanelvue_type_template_id_66016142_ts_true_render]])

/* harmony default export */ const SlkPanel = (SlkPanel_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkCheckBox.vue?vue&type=template&id=3860c62a&ts=true

const SlkCheckBoxvue_type_template_id_3860c62a_ts_true_hoisted_1 = ["type", "checked", "disabled", "id"];
function SlkCheckBoxvue_type_template_id_3860c62a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
        type: _ctx.type,
        checked: _ctx.checked,
        disabled: _ctx.disabled,
        id: _ctx.id,
        ref: _ctx.id
    }, null, 8, SlkCheckBoxvue_type_template_id_3860c62a_ts_true_hoisted_1));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkCheckBox.vue?vue&type=template&id=3860c62a&ts=true

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkField.ts

class fieldValidations {
    none = (val, fld) => { return ''; };
    notImplemented = (val, fld) => { return fld + ' validation is not implemented'; };
    star = (val, fld) => { return val != '' ? '' : fld + ' is invalid'; };
    date = (val, fld) => { return val && new Date(val) instanceof Date ? '' : fld + ' is invalid'; };
    positiveNumber = (val, fld) => { return val > 0 ? '' : fld + ' is invalid'; };
    notEmpty = (val, fld) => { return val != '' ? '' : fld + ' is invalid'; };
}
class fieldHelper {
    resetAllValues(all) {
        all.forEach(x => x.resetValue());
    }
}
class SlkField {
    static Validations = new fieldValidations();
    static Helper = new fieldHelper();
    fieldName;
    validation;
    validating = false;
    state = (0,vue_cjs.reactive)({
        value: null,
        hasError: false,
        errorMessage: '',
        mandatory: false,
    });
    constructor(all, fieldName, value = '', validation, mandatory = false) {
        this.fieldName = fieldName;
        this.validation = validation;
        this.defaultValue = value;
        this.resetValue();
        this.state.mandatory = mandatory;
        if (all)
            all.push(this);
    }
    delayUpdate(val) {
        setTimeout(() => { this.state.value = val; }, 50);
    }
    //#region default value and resetting
    defaultValue = undefined;
    resetValue() {
        this.state.value = this.defaultValue;
    }
    //#region validate / update
    validate() {
        this.validating = true;
        let msg = '';
        if (this.state.mandatory && !this.state.value) {
            this.state.hasError = true;
            msg = this.fieldName + ' is mandatory';
        }
        else if (this.validation && (msg = this.validation(this.state.value, this.fieldName))) {
            this.state.hasError = true;
        }
        else {
            this.state.hasError = false;
        }
        this.state.errorMessage = msg;
        return this;
    }
    checkLength(length) {
        if (!this.state.hasError && this.state.value?.toString().length != length)
            this.setError('Please enter a valid ' + this.fieldName);
        return this;
    }
    clearError() {
        this.state.hasError = false;
        this.state.errorMessage = '';
    }
    setError(error) {
        this.state.errorMessage = error;
        this.state.hasError = true;
    }
}

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkCheckBox.vue?vue&type=script&lang=ts


/* eslint-disable */
/* harmony default export */ const SlkCheckBoxvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkCheckBox',
    props: {
        field: { type: SlkField, required: false },
        id: { type: String, required: true },
        type: { type: String, default: "checkbox" },
        disabled: { type: Boolean, default: false },
        checked: { type: Boolean, default: false },
    },
    //NB: avoids unmutable props
    data() { return { thisField: this.field, }; },
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkCheckBox.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkCheckBox.vue




;
const SlkCheckBox_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkCheckBoxvue_type_script_lang_ts, [['render',SlkCheckBoxvue_type_template_id_3860c62a_ts_true_render]])

/* harmony default export */ const SlkCheckBox = (SlkCheckBox_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkDatePicker.vue?vue&type=template&id=3c2c94c6&ts=true

const SlkDatePickervue_type_template_id_3c2c94c6_ts_true_hoisted_1 = { class: "date-picker-group" };
const SlkDatePickervue_type_template_id_3c2c94c6_ts_true_hoisted_2 = ["innerHTML"];
function SlkDatePickervue_type_template_id_3c2c94c6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SlkDatePickervue_type_template_id_3c2c94c6_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("span", {
            class: (0,vue_cjs.normalizeClass)([{ show: _ctx.thisField.state.hasError }, "error-text"]),
            innerHTML: _ctx.thisField.state.errorMessage
        }, null, 10, SlkDatePickervue_type_template_id_3c2c94c6_ts_true_hoisted_2)
    ]));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkDatePicker.vue?vue&type=template&id=3c2c94c6&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkDatePicker.vue?vue&type=script&lang=ts

/*
import { DatePicker } from 'v-calendar';
*/

/* eslint-disable */
/* harmony default export */ const SlkDatePickervue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkDatePicker',
    /*
    components: { DatePicker },
    */
    props: {
        field: { type: SlkField, required: true },
        label: { type: String, required: true },
        id: { type: String, required: true },
        type: { type: String, default: "text" },
        placeholder: { type: String, required: true },
        isReadonly: { type: Boolean, default: false },
        minDate: { type: Date, required: true },
        maxDate: { type: Date, required: true }
    },
    //NB: avoids unmutable props
    data() { return { thisField: this.field, }; },
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkDatePicker.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkDatePicker.vue




;
const SlkDatePicker_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkDatePickervue_type_script_lang_ts, [['render',SlkDatePickervue_type_template_id_3c2c94c6_ts_true_render]])

/* harmony default export */ const SlkDatePicker = (SlkDatePicker_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkRadioButton.vue?vue&type=template&id=f083097a&ts=true

const SlkRadioButtonvue_type_template_id_f083097a_ts_true_hoisted_1 = ["name", "id"];
function SlkRadioButtonvue_type_template_id_f083097a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
        type: "radio",
        name: _ctx.name,
        id: _ctx.id,
        ref: "inputControl"
    }, null, 8, SlkRadioButtonvue_type_template_id_f083097a_ts_true_hoisted_1));
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkRadioButton.vue?vue&type=template&id=f083097a&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkRadioButton.vue?vue&type=script&lang=ts


/* eslint-disable */
/* harmony default export */ const SlkRadioButtonvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkRadioButton',
    props: {
        field: { type: SlkField, required: false },
        id: { type: String, required: true },
        type: { type: String, default: "radio" },
        isReadonly: { type: Boolean, default: false },
        name: { type: String, default: "name" }
    },
    //NB: avoids unmutable props
    data() { return { thisField: this.field, }; },
    setup() {
        const inputControl = (0,vue_cjs.ref)(null);
        return { inputControl };
    }
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkRadioButton.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkRadioButton.vue




;
const SlkRadioButton_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkRadioButtonvue_type_script_lang_ts, [['render',SlkRadioButtonvue_type_template_id_f083097a_ts_true_render]])

/* harmony default export */ const SlkRadioButton = (SlkRadioButton_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkTextBox.vue?vue&type=template&id=5742f9d7&ts=true

const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_1 = {
    key: 0,
    class: "text-field border-label-over input-icon"
};
const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_2 = {
    key: 0,
    class: "title-large prepand"
};
const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_3 = ["placeholder", "type", "disabled", "id"];
const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_4 = {
    key: 1,
    for: "mobileNumber"
};
const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_5 = {
    key: 2,
    class: "error-text show"
};
const SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_6 = ["placeholder", "type", "disabled", "id"];
function SlkTextBoxvue_type_template_id_5742f9d7_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.specialCase != 'plain')
        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_1, [
            (_ctx.prepend)
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_2, (0,vue_cjs.toDisplayString)(_ctx.prepend), 1))
                : (0,vue_cjs.createCommentVNode)("", true),
            (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.thisField.state.value) = $event)),
                placeholder: _ctx.placeholder,
                type: _ctx.type,
                disabled: _ctx.disabled,
                id: _ctx.id,
                ref: "inputControl"
            }, null, 8, SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_3), [
                [vue_cjs.vModelDynamic, _ctx.thisField.state.value]
            ]),
            (_ctx.label)
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("label", SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_4, (0,vue_cjs.toDisplayString)(_ctx.label), 1))
                : (0,vue_cjs.createCommentVNode)("", true),
            (_ctx.field.state.hasError)
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_5, (0,vue_cjs.toDisplayString)(_ctx.field.state.errorMessage), 1))
                : (0,vue_cjs.createCommentVNode)("", true)
        ]))
        : (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
            key: 1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.thisField.state.value) = $event)),
            placeholder: _ctx.placeholder,
            type: _ctx.type,
            disabled: _ctx.disabled,
            id: _ctx.id,
            ref: "inputControl"
        }, null, 8, SlkTextBoxvue_type_template_id_5742f9d7_ts_true_hoisted_6)), [
            [vue_cjs.vModelDynamic, _ctx.thisField.state.value]
        ]);
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkTextBox.vue?vue&type=template&id=5742f9d7&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./node_modules/@sulekha/core/src/Fields/SlkTextBox.vue?vue&type=script&lang=ts


/* eslint-disable */
/* harmony default export */ const SlkTextBoxvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'SlkTextBox',
    props: {
        field: { type: SlkField, required: true },
        id: { type: String, required: true },
        type: { type: String, default: 'text' },
        label: { type: String, required: false },
        prepend: { type: String, default: '' },
        placeholder: { type: String, required: true },
        disabled: { type: Boolean, default: false },
        ///Use special case only when there is extra markup and this control cant be extended
        specialCase: { type: String, default: '' },
    },
    //NB: avoids unmutable props
    data() { return { thisField: this.field, }; },
    setup() {
        const inputControl = (0,vue_cjs.ref)(null);
        return { inputControl };
    }
}));

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkTextBox.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/SlkTextBox.vue




;
const SlkTextBox_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SlkTextBoxvue_type_script_lang_ts, [['render',SlkTextBoxvue_type_template_id_5742f9d7_ts_true_render]])

/* harmony default export */ const SlkTextBox = (SlkTextBox_exports_);
;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/Fields/FieldRegistry.ts




class FieldRegistry {
    static RegisterFields(app) {
        //props need to be made directives before using
        app.directive('field', {});
        app.directive('id', {});
        app.directive('type', {});
        app.directive('label', {});
        app.directive('prepend', {});
        app.directive('placeholder', {});
        app.directive('disabled', {});
        app.directive('specialCase', {});
        app.component('slk-checkbox', SlkCheckBox);
        app.component('slk-date-picker', SlkDatePicker);
        app.component('slk-radio-button', SlkRadioButton);
        app.component('slk-textbox', SlkTextBox);
    }
    //TODO: Make purely reactive
    static ClearRadio(radio) {
        if (!radio)
            return;
        radio.inputControl.checked = false;
    }
    static FocusText(text) {
        if (!text)
            return;
        text.inputControl.focus();
    }
}

;// CONCATENATED MODULE: ./node_modules/@sulekha/core/src/View/ViewRegistry.ts






class ViewRegistry {
    static Register(app) {
        app.component('slk-bottom-sheet', SlkBottomSheet);
        app.component('slk-fixed-bottom-sheet', SlkFixedBottomSheet);
        app.component('slk-app-panel', SlkAppPanel);
        app.component('slk-panel', SlkPanel);
        FieldRegistry.RegisterFields(app);
        ClickTracker.RegisterTracker(app);
    }
}

;// CONCATENATED MODULE: ./src/export-core.ts






















//

;// CONCATENATED MODULE: ./src/CSMainEnums.ts
//NOTE: These 2 need to match Silk/_Enums.cs
//TODO: change back when deprecating old appsource
var SulekhaAppSource;
(function (SulekhaAppSource) {
    SulekhaAppSource["Web"] = "Web";
    SulekhaAppSource["MobileWeb"] = "Mweb";
    SulekhaAppSource["MobileApp"] = "App";
})(SulekhaAppSource || (SulekhaAppSource = {}));
var SulekhaProduct;
(function (SulekhaProduct) {
    SulekhaProduct[SulekhaProduct["LocalServices"] = 1] = "LocalServices";
    SulekhaProduct[SulekhaProduct["Capshine"] = 2] = "Capshine";
    SulekhaProduct[SulekhaProduct["Promanage"] = 3] = "Promanage";
    SulekhaProduct[SulekhaProduct["SilkLab"] = 4] = "SilkLab";
})(SulekhaProduct || (SulekhaProduct = {}));
//will throw an exception if not matching appSlug of ProductMeta.cs
var MobileApps;
(function (MobileApps) {
    MobileApps["notSet"] = "notSet";
    MobileApps["consumers"] = "consumers";
    MobileApps["capshine"] = "capshine";
    MobileApps["promanage"] = "promanage";
})(MobileApps || (MobileApps = {}));
var AppEnvironment;
(function (AppEnvironment) {
    AppEnvironment["unknown"] = "UNKNOWN";
    AppEnvironment["development"] = "DEV";
    AppEnvironment["qa"] = "QA";
    AppEnvironment["staging"] = "STAGING";
    AppEnvironment["production"] = "PRODUCTION";
})(AppEnvironment || (AppEnvironment = {}));
var MobilePages;
(function (MobilePages) {
    MobilePages["unknown"] = "Unknown";
    MobilePages["login"] = "Login";
    MobilePages["logoff"] = "Logoff";
    MobilePages["search"] = "Search";
    MobilePages["home"] = "Home";
    MobilePages["about"] = "About";
    MobilePages["myAccount"] = "My Account";
    MobilePages["leaningPlan"] = "LeaningPlan";
    MobilePages["errorNotFound"] = "Page Not Found";
    MobilePages["errorReport"] = "Error Report";
    MobilePages["editProfile"] = "Edit Profile";
    MobilePages["samples"] = "Samples";
    MobilePages["uiComponents"] = "UI Components";
    MobilePages["apiTester"] = "API Tester";
    //Consumer / Business
    MobilePages["businessProfilePrivate"] = "Business Profile Private";
    MobilePages["businessProfile"] = "Business Profile";
    MobilePages["userProfile"] = "User Profile";
    MobilePages["managedAddresses"] = "Managed Addresses";
    MobilePages["listings"] = "Listings";
    MobilePages["myNeeds"] = "My Needs";
    MobilePages["enquiries"] = "Enquiries";
    MobilePages["faqs"] = "FAQs";
    MobilePages["termsAndConditions"] = "Terms And Conditions";
    MobilePages["needDetail"] = "Need Detail";
    MobilePages["jobStatusUpdate"] = "Job Status Update";
    MobilePages["clusterDetail"] = "Cluster Detail";
    MobilePages["chatbot"] = "Chatbot";
    MobilePages["chat"] = "Chat";
    MobilePages["paymentList"] = "Payment List";
    MobilePages["notifications"] = "Notifications";
    //Pro Manage
    MobilePages["dashboard"] = "Dashboard";
    MobilePages["insights"] = "Insights";
})(MobilePages || (MobilePages = {}));
var PaymentPlanTypes;
(function (PaymentPlanTypes) {
    PaymentPlanTypes["SEMIANNUAL"] = "semiannual";
    PaymentPlanTypes["MONTHLY"] = "monthly";
})(PaymentPlanTypes || (PaymentPlanTypes = {}));
var ClubMeetingTypeOption;
(function (ClubMeetingTypeOption) {
    ClubMeetingTypeOption["None"] = "None";
    ClubMeetingTypeOption["LiveClass"] = "LiveClass";
    ClubMeetingTypeOption["TalkTime"] = "TalkTime";
    ClubMeetingTypeOption["ClubMeet"] = "ClubMeet";
    ClubMeetingTypeOption["MasterClass"] = "MasterClass";
    ClubMeetingTypeOption["LiveClassRepeat"] = "LiveClassRepeat";
    ClubMeetingTypeOption["StarSpeaker"] = "StarSpeaker";
    ClubMeetingTypeOption["FunFriday"] = "FunFriday";
})(ClubMeetingTypeOption || (ClubMeetingTypeOption = {}));
var PaymentPlanTypeOption;
(function (PaymentPlanTypeOption) {
    PaymentPlanTypeOption[PaymentPlanTypeOption["None"] = 0] = "None";
    PaymentPlanTypeOption[PaymentPlanTypeOption["Monthly"] = 1] = "Monthly";
    PaymentPlanTypeOption[PaymentPlanTypeOption["SixMonths"] = 2] = "SixMonths";
    PaymentPlanTypeOption[PaymentPlanTypeOption["Limited"] = 3] = "Limited";
    PaymentPlanTypeOption[PaymentPlanTypeOption["FreeTrial"] = 4] = "FreeTrial";
    PaymentPlanTypeOption[PaymentPlanTypeOption["ThreeMonths"] = 5] = "ThreeMonths";
})(PaymentPlanTypeOption || (PaymentPlanTypeOption = {}));

;// CONCATENATED MODULE: ./src/CSMainAPIs.ts


class CSMainAPIs {
    static SetEnvironmentUrls(env) {
        //qa
        CSMainAPIs.Capshine.Server.baseUrl = 'https://qa2.capshine.com/';
        if (env == AppEnvironment.development) {
            CSMainAPIs.Capshine.Server.baseUrl = 'https://dev.capshine.com/';
        }
        else if (env == AppEnvironment.qa) {
            CSMainAPIs.Capshine.Server.baseUrl = 'https://qa2.capshine.com/';
        }
        if (env == AppEnvironment.production) {
            CSMainAPIs.Capshine.Server.baseUrl = 'https://www.capshine.com/';
        }
    }
    static Capshine = {
        Server: new SlkServer('SulCS'),
        APIs: {
            SampleSvrFn: new SulekhaGetAPI('api/home/sample/{message}', 'Sample Message', {}, true),
            UpdateDeviceInfoAfterRegistration: new SulekhaGetAPI('api/common/UpdateDeviceInfoAfterRegistration?UserPid={UserPid}', 'UpdateDeviceInfoAfterRegistration', {}, true),
            SampleSvrPage: new SulekhaAPI('api/home/sample-ssr/{content}', 'Sample Content Page', {}, true),
            GetUserInfo: new SulekhaAPI('api/user/get-user-info/', 'Message', {}, true),
            LoadDailyActivity: new SulekhaGetAPI('api/dailyactivity/load-daily-activity-screen/', 'Html Content Page', {}),
            GetFaqContent: new SulekhaGetAPI('api/common/get-faq-content/', 'Message', {}, true),
            GetTermsContent: new SulekhaGetAPI('api/common/get-terms-content/', 'Message', {}, true),
            GetAboutUsContent: new SulekhaGetAPI('api/common/get-aboutus-content/', 'Message', {}, true),
            GetPrivacyPolicyContent: new SulekhaGetAPI('api/common/get-privacy-policy-content/', 'Message', {}, true),
            GetClubInfo: new SulekhaGetAPI('api/clubregistration/GetClubDetailsForClubId', 'Get Club Info', {}),
            GetPincodeDetails: new SulekhaGetAPI('api/clubregistration/GetPincodeDetails', 'Get Code Details', {}),
            SendOtp: new SulekhaAPI('api/clubregistration/send-otp', 'Get Otp', {}),
            VerifyOtp: new SulekhaAPI('api/clubregistration/verify-otp', 'verify Otp', {}),
            CheckIfAlreadyRegistered: new SulekhaGetAPI('api/clubregistration/CheckIfAlreadyRegistered', 'Check if already registered user', {}),
            GetCountryCodeDetails: new SulekhaGetAPI('api/clubregistration/get-countrycode', 'Get country code details', {}),
            RegisterForCapshineAndClub: new SulekhaAPI('api/clubregistration/RegisterForCapshineAndClub', 'Register for capshine and club ', {}),
            checkAccountForEmail: new SulekhaGetAPI('api/clubregistration/CheckAccountForEmail', 'Check account for email ', {}),
            CheckAndUpdateEmail: new SulekhaAPI('api/clubregistration/CheckAndUpdateEmail', 'Check and update email ', {}),
            CheckAndUpdateUserName: new SulekhaAPI('api/clubregistration/CheckAndUpdateUserName', 'Check and update user name ', {}),
            //GetUserInfo: new SulekhaGetAPI('api/clubregistration/GetUserinfoForUserPid', 'Get user info for user pid ', {}),
            GetPaymentPlansPageContent: new SulekhaGetAPI('api/pagecontent/get-payment-plans-content', 'get payment plans page content ', {}),
            DailyAcitivitySaveRecording: new SulekhaAPI('api/dailyactivity/save-recording/', 'Message', {}, true),
            DailyAcitivitySaveAnswer: new SulekhaAPI('api/dailyactivity/save-answer/', 'Message', {}, true),
            GeHomePageContent: new SulekhaGetAPI('api/common/get-home-page-content', 'Message', {}),
            SubmitLearningVideoWatchedStatus: new SulekhaAPI('api/MyClub/SubmitLearningVideoWatchedStatus', 'Message', {}, true),
            SubmitSlotBooking: new SulekhaGetAPI('api/MyClub/SubmitSlotBooking/', 'Message', {}),
            UpdateClubUserLanguage: new SulekhaAPI('api/MyClub/UpdateClubUserLanguage', 'Message', {}, true),
            GetVideoDetails: new SulekhaGetAPI('api/MyClub/GetVideoDetails', 'Message', {}),
            GetMCQQuestionAndAnswer: new SulekhaGetAPI('api/MyClub/GetMCQQuestionAndAnswer', 'Message', {}),
            StoreVideoLearningMCQQuestionAndAnswer: new SulekhaAPI('api/MyClub/StoreMCQQuestionAndAnswer', 'Message', {}, true),
            GetZoomMeetingDetails: new SulekhaGetAPI('api/MyClub/GetMCQQuestionAndAnswer', 'Message', {}),
            GetLearningPlanConent: new SulekhaGetAPI('api/common/get-learning-plan-page-content', 'Message', {}),
            UpdateCalendarEvent: new SulekhaGetAPI('api/MyClub/UpdateClubscheduleCalender/', 'Message', {}),
            UpdateCodeOfConduct: new SulekhaAPI('api/common/updatecodeofconduct', 'Update Code Of Conduct', {}),
            GetMCQDetails: new SulekhaGetAPI('api/MyClub/GetMCQDetails', 'Message', {}),
            GetDiagnosticTestQuestions: new SulekhaGetAPI('api/clubregistration/GetDiagnosticTestQuestions', 'Message', {}, true),
            InsertDiagnosticTestResult: new SulekhaAPI('api/clubregistration/InsertDiagnosticTestResult', 'Insert Diagnostic Test Result', {}, true),
            GetQuizQuestions: new SulekhaGetAPI('api/common/Get-Quiz-FillintheBlanks-Questions?type=quiz&userpid={UserPid}', 'Message', {}, true),
            InsertQuizResult: new SulekhaAPI('api/common/Insert-Quiz-FillintheBlanks-Result?type=quiz', 'Insert Quiz Test Result', {}, true),
            GetFillintheBlanksQuestions: new SulekhaGetAPI('api/common/Get-Quiz-FillintheBlanks-Questions?type=fillintheblanks&userpid={UserPid}', 'Message', {}, true),
            InsertFillintheBlanksResult: new SulekhaAPI('api/common/Insert-Quiz-FillintheBlanks-Result?type=fillintheblanks', 'Insert FilltheGap Test Result', {}, true),
            GetJumbledSentenceQuestions: new SulekhaGetAPI('api/common/Get-Jumbled-Sentence', 'Get Jumbled Sentence Result', {}),
            GetMeanings: new SulekhaGetAPI('api/common/Get-Meaning-Questions', 'Get Meaning Questions', {}),
            InsertMeaningsResult: new SulekhaAPI('api/common/Insert-Meanings-Result', 'Insert Meaning Result', {}, true),
            InsertJumbledSentenceResult: new SulekhaAPI('api/common/Insert-Jumbled-Sentence-Result', 'Insert Jumbled Sentence Test Result', {}, true),
            LoadDailyActivityResponse: new SulekhaGetAPI('api/dailyactivity/load-daily-activity-response-screen/', 'Html Content Page', {}),
            DailyAcitivitySaveResponse: new SulekhaAPI('api/dailyactivity/save-dailyactivity-responsereply/', 'Message', {}, true),
            GetDailyAcitivityResponseComments: new SulekhaGetAPI('api/dailyactivity/get-dailyactivity-response-comments/', 'Message', {}),
            GetDailyAcitivityArchiveDetails: new SulekhaGetAPI('api/dailyactivity/get-daily-activity-archive-details/', 'GetDailyAcitivityArchiveDetails', {}),
            GetDailyActivityTypes: new SulekhaGetAPI('api/dailyactivity/get-daily-activity-types/', 'GetDailyActivityTypes', {}),
            GetDailyActivity: new SulekhaGetAPI('api/dailyactivity/getdailyactivity/', 'getdailyactivity', {}),
            SubmiMCQCompletedStatus: new SulekhaAPI('api/MyClub/UpdateMCQCompletedStatus', 'Message', {}, true),
            GetZoomMeetingInfo: new SulekhaGetAPI('api/MyClub/GetZoomMeetingDetails?MeetingId={MeetingId}&ClubscheduleId={ClubscheduleId}&UserPid={UserPid}', 'get zoom meeting details', {}, true),
            GetMyVideoBasedLearningDetails: new SulekhaGetAPI('api/MyClub/GetMyVideoBasedLearningDetails', 'Message', {}),
            GetWatchVideoPageConent: new SulekhaGetAPI('api/common/get-watch-video-page-content', 'Message', {}),
            GetPaymentUpgrdeRequestPageConent: new SulekhaGetAPI('api/common/get-payment-upgrade-page-content', 'Message', {}),
            GetLearningVideoMCQPageConent: new SulekhaGetAPI('api/common/get-learning-video-MCQ-page-content', 'Message', {}),
            UpdateClubSignUpDetails: new SulekhaAPI('api/common/update-clubsignup-details', 'Message', {}, true),
            GetZoomMeetingURL: new SulekhaGetAPI('api/MyClub/GetClubMeetParticipantUrl', 'Message', {}),
            GetClubMeetDetailsForUser: new SulekhaGetAPI('api/MyClub/GetClubMeetDetailsForUser?ClubScheduleId={ClubScheduleId}&UserPid={UserPid}', 'get zoom meeting details', {}, true),
            GetPreviousActivities: new SulekhaGetAPI('api/dailyactivity/getPreviousActivities/', 'GetPreviousActivities', {}),
            SaveVoiceRecordingForAI: new SulekhaAPI('api/MyClub/UploadVoiceRecordingAudio', 'Message', {}),
            GetVoiceRecordingPageConent: new SulekhaGetAPI('api/common/get-voice-recording-page-content', 'Message', {}),
            GetRecordingAudioPageRedirectionStatus: new SulekhaGetAPI('api/MyClub/GetRecordingAudioPageRedirectionStatus', 'Message', {}),
            SetRecordingAudioPageRedirectionStatus: new SulekhaGetAPI('api/MyClub/SetRecordingAudioPageRedirectionStatus', 'Message', {}),
            GetZoomMeetingCallBack: new SulekhaGetAPI('api/MyClub/getzoommeetingcallback', 'Message', {}),
            GetUserDetailsByName: new SulekhaGetAPI('api/common/get-user-details-byname', 'Message', {}),
            GetVideoPageContent: new SulekhaGetAPI('api/Videos/get-video-page-content/', 'Message', {}),
            GetVideoLessonsPageContent: new SulekhaGetAPI('api/Videos/get-video-lessons-page-content/', 'Message', {}),
            GetWatchedVideoPageContent: new SulekhaGetAPI('api/Videos/get-watched-videos-page-content/', 'Message', {}),
            GetWatcShortVideoPageContent: new SulekhaGetAPI('api/Videos/get-short-videos-page-content/', 'Message', {}),
            SaveShortVideoAction: new SulekhaAPI('api/Videos/SaveShortVideoAction/', 'Message', {}, true),
            UpdateUserActivity: new SulekhaAPI('api/common/UpdateUserActivity/', 'Message', {}, true),
            UpsertCapshineDeviceLogin: new SulekhaAPI('api/common/UpsertCapshineDeviceLogin', 'UpsertCapshineDeviceLogin', {}, true),
            GetCapshineDeviceLogin: new SulekhaGetAPI('api/common/GetCapshineDeviceLogin?UserPid={UserPid}', 'GetCapshineDeviceLogin', {}, true),
            LogoffOtherDevices: new SulekhaAPI('api/common/LogoffOtherDevices', 'LogoffOtherDevices', {}, true),
            IsCapshineSessionActive: new SulekhaGetAPI('api/common/IsCapshineSessionActive?sessionId={sessionId}', 'IsCapshineSessionActive', {}, true),
            ShouldShowAppReview: new SulekhaGetAPI('api/User/ShouldShowAppReview?UserPid={UserPid}', 'ShouldShowAppReview', {}, true),
            SubmitAppReview: new SulekhaAPI('api/User/SubmitAppReview', 'SubmitAppReview', {}, true),
            UpdateCustomPopup: new SulekhaAPI('api/common/UpdateCustomPopup', 'UpdateCustomPopup', {}, true),
            UpdateMeetingFeedBackHasSeenStatus: new SulekhaGetAPI('api/MyClub/UpdateMeetingFeedBackHasSeenStatus/', 'Message', {}),
            GetSFVideoViewAllPageContent: new SulekhaGetAPI('api/Videos/get-viewall-shortvideos-page-content/', 'Message', {}),
            UpdateCapshineAppUpdateLog: new SulekhaAPI('api/common/UpdateCapshineAppUpdateLog/', 'Message', {}, true),
            UpdateUserDailyActivityLog: new SulekhaAPI('api/common/UpdateUserDailyActivityLog/', 'Message', {}, true),
        },
        PageContent: {
            GetPaymentSummaryPageContent: new SulekhaGetAPI('api/pagecontent/get-payment-summary-content', 'get payment summary page content ', {}),
            GetSubscriptionSuccessfulPageContent: new SulekhaGetAPI('api/pagecontent/get-subscription-successful-content', 'get subscription successful page content ', {}),
            GetSubscriptionFailedPageContent: new SulekhaGetAPI('api/pagecontent/get-subscription-failed-content', 'get subscription failed page content ', {}),
            GetPaymentThankyouPageContent: new SulekhaGetAPI('api/pagecontent/get-payment-thankyou-content', 'get payment thankyou page content ', {}),
        },
        PaymentsAPIs: {
            CreateOrder: new SulekhaAPI('api/payments/store-details', 'store details and create payment order ', {}),
            paymentResponse: new SulekhaAPI('api/payments/payment-callback', 'Call back for payment response ', {}),
            GetPaymentSummaryData: new SulekhaGetAPI('api/payments/get-payment-summary-data', 'get payment summary data ', {}),
            CreateSubscription: new SulekhaAPI('api/payments/create-subscription', 'Create subscription ', {}),
            CancelSubscription: new SulekhaAPI('api/payments/cancel-course-payment-subscription', 'Cancel subscription ', {}),
            GetRazorPaymentOptions: new SulekhaGetAPI('api/payments/getrazorpaymentoptions', 'Get Razor Payment Checkout Options', {}),
        },
        MyAccountAPIs: {
            LoadMyAccountScreen: new SulekhaGetAPI('api/myaccount/load-myaccount-screen', 'Message', {}),
            LoadEditProfileScreen: new SulekhaGetAPI('api/myaccount/load-editprofile-screen', 'Message', {}),
            LoadRewardCapsScreen: new SulekhaGetAPI('api/myaccount/load-rewardcaps-screen', 'Message', {}),
            LoadMySubscriptionScreen: new SulekhaGetAPI('api/myaccount/load-mysubscription-screen', 'Message', {}),
            LoadMyFluencyReportScreen: new SulekhaGetAPI('api/myaccount/load-fluencyreport-screen', 'Message', {}),
            DownloadFluencyReport: new SulekhaGetAPI('api/myaccount/Fluency-Monthly-ReportV1', 'Message', {}),
            LoadCoachFeedbacksScreen: new SulekhaGetAPI('api/myaccount/load-coachfeedbacks-screen', 'Message', {}),
            GetClubFluencyReportHistory: new SulekhaGetAPI('api/myaccount/GetClubFluencyReportHistory', 'Message', {}),
        },
        TalktimeAPIs: {
            GetTalkTimeSchedules: new SulekhaGetAPI('api/Talktime/GetTalkTimeSchedules', 'GetTalkTimeSchedules', {}),
            AddTalkTimeSlots: new SulekhaAPI('api/Talktime/AddTalkTimeSlots', 'AddTalkTimeSlots', {}),
            LoadTalkTimeSchedulesScreen: new SulekhaGetAPI('api/Talktime/LoadTalkTimeSchedulesScreen', 'LoadTalkTimeSchedulesScreen', {}),
            LoadTalkTimeSlotBookingScreen: new SulekhaGetAPI('api/Talktime/LoadTalkTimeSlotBookingScreen', 'LoadTalkTimeSlotBookingScreen', {}),
            CancelTalktime: new SulekhaAPI('api/Talktime/CancelTalktime', 'CancelTalktime', {}),
            GetTalktimeInviteUser: new SulekhaGetAPI('api/Talktime/get-user-invite-byname', 'GetTalktimeInviteUser', {}),
            TalktimeInviteUserAdd: new SulekhaAPI('api/Talktime/InviteTalktime', 'InviteTalktime', {}),
            FetchCoachTalkTimeSlotAvailability: new SulekhaGetAPI('api/Talktime/fetch-coach-talktime-avalablity-slots', 'Message', {}),
            FetchCoahList: new SulekhaGetAPI('api/Talktime/fetch-coach-list', 'Message', {}),
            GetCoachInformationForLiveSessions: new SulekhaGetAPI('api/Talktime/GetCoachInformationForLiveSessions', 'Fetch Coach List V1', {}),
            UpdateCoachAvailablity: new SulekhaAPI('api/Talktime/update-coach-talktime-availability', '', true),
            FetchLiveClassSessionAvailability: new SulekhaGetAPI('api/Talktime/fetch_liveclasssession_availability_calendar_View', 'Message', {}),
            FetchModeratorAvailability: new SulekhaGetAPI('api/Talktime/fetch_moderator_availability_calendar_View', 'Message', {}),
            FetchModeratorAvailabilityAllocatedList: new SulekhaGetAPI('api/Talktime/fetch_moderator_availability_allocated_list', 'Message', {}),
            UpdateModuraterLeave: new SulekhaGetAPI('api/Talktime/update_modurater_leave', 'Message', {}),
            ReScheduleModerator: new SulekhaGetAPI('api/Talktime/reschedule_moderator', 'Message', {}),
            getTalkTimeLaunchURL: new SulekhaGetAPI('api/Talktime/get_talktime_launchurl', 'Message', {}),
            ApplyModeratorLeaveForAllDay: new SulekhaGetAPI('api/Talktime/apply_moderator_leave_for_all_day', 'Message', {}),
            GetTalkTimeManageSession: new SulekhaGetAPI('api/Talktime/GetTalkTimeManageSession', 'GetTalkTimeManageSchedules', {}),
            CancelTalkTimeSchedule: new SulekhaGetAPI('api/Talktime/CancelTalkTimeSchedule', 'CancelTalkTimeSchedule', {}),
            GetDashboardMenuForCoaches: new SulekhaGetAPI('api/Talktime/GetDashboardMenuForCoaches', 'GetDashboardMenuForCoaches', {}),
            FetchLiveClassSessionList: new SulekhaGetAPI('api/Talktime/fetch_moderator_live_class_list', 'Message', {}),
            FetchTalktimeReport: new SulekhaGetAPI('api/Talktime/GetTalkTimeReport', 'Message', {}),
        },
        JobInterviewCourse: {
            UpdateUserInteractionForJobInterviewVideo: new SulekhaAPI('api/JobInterview/UpdateUserInteractionForJobInterviewVideo', 'Message', {}),
            GetJobInterviewCoursePageContent: new SulekhaGetAPI('api/JobInterview/get-job_interview_course-page-content', 'GetJobInterviewCoursePageContent', {}),
            GetWatchJobInterviewCourseVideoPageContent: new SulekhaGetAPI('api/JobInterview/get-watch_job_interview_course-video-page-content', 'GetJobInterviewCoursePageContent', {}),
            GetJobInterviewCourseVideoQuiz: new SulekhaGetAPI('api/JobInterview/GetJOBInterviewCourseQuizDetails', 'GetJOBInterviewCourseQuizDetails', {}),
            StoreJobInterviewQuestionAndAnswer: new SulekhaAPI('api/JobInterview/StoreJobInterviewQuestionAndAnswer', 'Message', {}, true),
            GetJobInterviewCourseVideoQuizPageContent: new SulekhaGetAPI('api/JobInterview/get-job_interview_quiz-page-content', 'GetJobInterviewCourseVideoQuizPageContent', {}),
            GetJobInterviewCoursePreviewVideoPageContent: new SulekhaGetAPI('api/JobInterview/get-job_interview_preview-video-page-content', 'GetJobInterviewPreviewVideoPageContent', {}),
            Downloadjobinterviewcertificate: new SulekhaAPI('api/JobInterview/downloadjobinterviewcertificate', 'downloadjobinterviewcertificate', {}),
        }
    };
}

;// CONCATENATED MODULE: ./src/CapshineDI.ts
class CapshineDI {
    static CapshineInstances = {};
}

;// CONCATENATED MODULE: ./src/Util/CapshineQuery.ts
///Handles Common component operations, without using jQuery
class CapshineQuery {
    //#region registration methods (function chaining)
    RegisterCollapsableLabels() {
        return this.OnClickOfEach('.sk-collapse .sk-label', this._toggleShowOnGroup);
    }
    RegisterAccordions(parentClass) {
        return this.OnClickOfEach('.' + parentClass + '>.sk-collapse>.sk-group>.sk-label', this._setHeightOnNextIfShown);
    }
    RegisterChips() {
        return this.ForEach('.sk-paged-content', this._registerChipContainer);
    }
    RegisterChipFiltering(linksSelector, targetSelector) {
        const links = this.GetAllBySelector(linksSelector);
        return this.OnClickOfEach(linksSelector, (link) => this._registerChipFiltering(link, targetSelector, links));
    }
    //#region helper chained/iterator functions
    OnClickOfEach(selector, onClick) {
        this.GetAllBySelector(selector).forEach(function (el) {
            el.addEventListener('click', function (e) { onClick(e.target); });
        });
        return this;
    }
    ForEach(selector, callback) {
        this.GetAllBySelector(selector).forEach(function (e) { callback(e); });
        return this;
    }
    //#region helper functions
    GetAllBySelector(selector) {
        return document.querySelectorAll(selector);
    }
    static ForMatchingChildren(container, cssClass, callback) {
        Array.from(container.children).filter((x, i) => { return x.classList.contains(cssClass); }).forEach((el) => callback(el));
    }
    //#region component functions
    _registerChipContainer(container) {
        const pageSize = parseInt(container.getAttribute('data-page-size'));
        const chips = Array.from(container.children).filter((x, i) => { return x.classList.contains("sk-chip"); });
        CapshineQuery.ForMatchingChildren(container, 'sk-load-more', el => {
            if (chips.length <= pageSize) {
                el.style.display = 'none';
                return;
            }
            el.addEventListener("click", function (e) {
                chips.forEach(x => { x.classList.remove('hide'); });
                el.style.display = 'none';
            });
        });
        //Show particular number of records and hide others
        chips.slice(pageSize, chips.length).forEach(x => { x.classList.add('hide'); });
    }
    _registerChipFiltering(link, targetSelector, links) {
        var match = link.getAttribute('data-match');
        this.GetAllBySelector(targetSelector).forEach(function (target) {
            if (target.classList.contains(match)) {
                if (target.classList.contains('hide'))
                    target.classList.remove('hide');
            }
            else {
                if (!target.classList.contains('hide'))
                    target.classList.add('hide');
            }
        });
        var others = Array.from(links).filter(x => x != link);
        others.forEach(x => { if (x.classList.contains('sk-base-fill') && x.classList.contains('selected'))
            x.classList.remove('sk-base-fill', 'selected'); });
        if (!link.classList.contains('sk-base-fill') && !link.classList.contains('selected'))
            link.classList.add('sk-base-fill', 'selected');
    }
    //#region private functions
    _toggleShowOnGroup(el) {
        el.closest('.sk-collapse').querySelectorAll('.sk-group').forEach(elem => { elem.classList.remove('show'); });
        el.closest('.sk-group').classList.add('show');
    }
    _setHeightOnNextIfShown(label) {
        label.classList.toggle("show");
        const next = label.nextElementSibling, toShow = label.classList.contains("show");
        next.style.maxHeight = (toShow ? next.scrollHeight : 0) + 'px';
    }
    ;
}

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/CapshineSample.vue?vue&type=template&id=7e48bda9&ts=true

const CapshineSamplevue_type_template_id_7e48bda9_ts_true_hoisted_1 = { class: "sample" };
function CapshineSamplevue_type_template_id_7e48bda9_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CapshineSamplevue_type_template_id_7e48bda9_ts_true_hoisted_1, " Hi I am from capshine vue component "));
}

;// CONCATENATED MODULE: ./src/CapshineSample.vue?vue&type=template&id=7e48bda9&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/CapshineSample.vue?vue&type=script&lang=ts
/* harmony default export */ const CapshineSamplevue_type_script_lang_ts = ({
    mounted() {
        //	CSMainAPIs.Capshine.APIs.UserInfo.execute({ Mobilenumber: "9443810115" }, this.apiResponse);
    },
    methods: {}
});

;// CONCATENATED MODULE: ./src/CapshineSample.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/CapshineSample.vue




;
const CapshineSample_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CapshineSamplevue_type_script_lang_ts, [['render',CapshineSamplevue_type_template_id_7e48bda9_ts_true_render]])

/* harmony default export */ const CapshineSample = (CapshineSample_exports_);
// EXTERNAL MODULE: ./node_modules/@capacitor/core/dist/index.js
var dist = __webpack_require__(895);
;// CONCATENATED MODULE: ./node_modules/@capacitor-community/firebase-analytics/dist/esm/index.js

const FirebaseAnalytics = (0,dist/* registerPlugin */.fo)("FirebaseAnalytics", {
    web: () => __webpack_require__.e(/* import() */ 46).then(__webpack_require__.bind(__webpack_require__, 823)).then((m) => new m.FirebaseAnalyticsWeb()),
});


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/js/GA/GoogleAnalytics.js

class GoogleAnalytics {
    isMobileApp = null;
    constructor() {
        if(FirebaseAnalytics){
              FirebaseAnalytics.enable();
        }
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                this.isMobileApp = true;
            }
            else {
                this.isMobileApp = false;
            }
        }
    }
    setScreenName(pagename) {
        
    
        if (this.isMobileApp == null) {
            this.getPlatform();
        }

        if (this.isMobileApp) {
            // code for mobile
            if(FirebaseAnalytics){
           
           // FirebaseAnalytics.enable();
            var nameoverride = pagename + "Screen";
            FirebaseAnalytics.setScreenName({
                screenName: pagename,
                nameOverride: nameoverride,
            });
        
        }
        }
        else {
            // code for  web gtag 
        }
    }
    logEvent(eventName, params) {
     
        if (this.isMobileApp == null) {
            this.getPlatform();
        }

        if (this.isMobileApp) {
            // code for mobile
            if(FirebaseAnalytics){

         //   FirebaseAnalytics.enable();
            FirebaseAnalytics.logEvent({
                name: eventName,
                params: params
            });
        }
        }
        else {
            // code for  web gtag 
        }
    }
    getPlatform() {
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                this.isMobileApp = true;
            }
            else {
                this.isMobileApp = false;
            }
        }
    }
}
;
/* harmony default export */ const GA_GoogleAnalytics = (GoogleAnalytics);

;// CONCATENATED MODULE: ./src/js/GA/ga.js
﻿

var SulGA = {
	userId: '',
	userName: '',
	gTag: '',
	pageType: '',
	platform: '',
	deviceName: '',
	deviceId: '',
	sulekhaApp: null,
	FBA: null,
	init: function (sulekhaApp = null) {
		if (sulekhaApp) {
			this.sulekhaApp = sulekhaApp;
			if (!SulGA.FBA) {
				SulGA.FBA = new GA_GoogleAnalytics();
			}
			if (sulekhaApp.state.currentUser)
				this.userId = sulekhaApp.state.currentUser.UserPid;
			if (sulekhaApp.state.currentUserAndDeviceInfo) {
				this.deviceId = sulekhaApp.state.currentUserAndDeviceInfo.DeviceId;
				this.deviceName = sulekhaApp.state.currentUserAndDeviceInfo.DeviceName;
			}
			this.pageType = sulekhaApp.state.activePage;
			this.platform = 'app';
		}
		else {
			if (document.getElementById("hdnUserPid"))
				this.userId = document.getElementById("hdnUserPid").value;
			if (document.getElementById("hdnPageType"))
				this.pageType = document.getElementById("hdnPageType").value;
			this.platform = 'mweb';
		}
		window.dataLayer = window.dataLayer || [];
		this.gtag('js', new Date());
	},
	gtag: function () {
		//console.log('pushPageView', arguments);
		window.dataLayer.push(arguments);
	},
	pushPageView: function () {

		if (SulGA.platform == 'mweb') {  // Is Web
			if (this.pageType.toLowerCase() == 'unknown')
				console.log('unknown' + window.location.href);


			this.gtag('config', 'G-SQV4E0X5ZJ', {
				'dimension1': this.userId,
				'dimension2': this.pageType,
				'dimension3': window.location.href,
				'dimension4': this.deviceName,
				'dimension5': this.deviceId,
				'dimension6': this.platform,
				'dimension7': '',
				'dimension8': '',
				'dimension9': '',
				'dimension10': '',
				'dimension11': ''
			});

		}
		else { // Is App

			var count = window.location.href.split('/').length;

			var appurl = window.location.href

			if (count >= 2) {
				var st = window.location.href.split('/')[2];
				appurl = appurl.replace(st, 'capshineapp.com');
			}


			var params = {
				'dimension1': this.userId,
				'dimension3': window.location.pathname + window.location.search,
				'dimension2': this.pageType,
				'dimension4': this.deviceName,
				'dimension5': this.deviceId,
				'dimension6': this.platform,
			}

			if (SulGA.FBA) {

				SulGA.FBA.setScreenName(this.sulekhaApp.state.activePage)
				SulGA.FBA.logEvent('config', params)

			}

			this.gtag('config', 'G-SQV4E0X5ZJ', {
				'dimension1': this.userId,
				'dimension2': this.pageType,
				'dimension3':  window.location.pathname + window.location.search,
				'dimension4': this.deviceName,
				'dimension5': this.deviceId,
				'dimension6': this.platform,
				'dimension7': '',
				'dimension8': '',
				'dimension9': '',
				'dimension10': '',
				'dimension11': ''
			});

		}


	},
	pushEvent: function (event_Category, event_Label, event_action, others) {

	     

		if (SulGA.platform == 'mweb') {   // Is Web

			this.gtag('event', event_action, {
				'event_category': event_Category,
				'event_label': event_Label,
				...others
			});
			//console.log("GAEvent");
		//	this.gtag({ 'event_category': event_Category });
			//this.gtag('send', 'event', event_Category,
			//{
			//	'dimension1': this.userId,
			//	'dimension2': this.pageType,
			//	'dimension3': window.location.href,
			//	'dimension4': this.deviceName,
			//	'dimension5': this.deviceId,
			//	'dimension6': this.platform	
			//}
			//);


		}
		else {   // is APP
			//  let category=event_Category+"_NewEventTracking"
			//this.gtag('send', 'event', event_Category,{
			//	'dimension1': this.userId,
			//	'dimension3': appurl,
			//	'dimension2': this.pageType,
			//	'dimension4': this.deviceName,
			//	'dimension5': this.deviceId	
			//});
			



				var pagename = window.location.pathname.split('/').slice(-1)[0];

				if (pagename == "") {
					pagename = "home"
				}

				var count = window.location.href.split('/').length;

				var appurl = window.location.href

				if (count >= 2) {
					var st = window.location.href.split('/')[2];
					appurl = appurl.replace(st, 'capshineapp.com');
				}
				
				if (SulGA.FBA) {

				//SulGA.FBA.logEvent(event_action, {
				//	'event_category': event_Category,
				//	'event_label': event_Label,
				//	'dimension1': this.userId,
				//	'dimension3': appurl,
				//	'dimension2': this.pageType,
				//	'dimension4': this.deviceName,
				//	'dimension5': this.deviceId,
				//})

				SulGA.FBA.logEvent(event_action, {
					'event_category': event_Category,
					'event_label': event_Label,
					'dimension1': this.userId,
					'dimension3': appurl,
					'dimension2': this.pageType,
					'dimension4': this.deviceName,
					'dimension5': this.deviceId
				})

				


			}

			this.gtag('event', event_action, {
				'event_category': event_Category,
				'event_label': event_Label,
				'dimension1': this.userId,
				'dimension3': appurl,
				'dimension2': this.pageType,
				'dimension4': this.deviceName,
				'dimension5': this.deviceId
			});

		}

	}
}

/* harmony default export */ const ga = (SulGA);
;// CONCATENATED MODULE: ./src/js/GA/GATrack.js

let bindGA = {
	sulekhaApp: null,
	init: function (sulekhaApp = null) {
		if (sulekhaApp)
			this.sulekhaApp = sulekhaApp;
		ga.init(this.sulekhaApp);
		ga.pushPageView();

		var sulGaTrackingElements = document.querySelectorAll("[sulga]");
		sulGaTrackingElements.forEach((clickitem) => {
			const gatrackadded = clickitem.getAttribute('data-gatrackadded');
			if (!gatrackadded) {
				clickitem.addEventListener('click', this.onClickGATrack.bind(this));
				clickitem.setAttribute('data-gatrackadded', 'true');
			}
		});
	},
	// onClickGATrack: function (evt) {
	// 	var clickevtdata = evt.currentTarget.getAttribute('sulga');
	// 	var gaEvtParams = clickevtdata;
	// 	if (gaEvtParams && gaEvtParams.length > 0) {
	// 		SulGA.pushEvent(gaEvtParams);

	// 	}
	// },

	// pushValues: function (event_Category, others) {

	// 	SulGA.pushEvent(event_Category, others);
	// }

	onClickGATrack: function (evt) {
		var clickevtdata = evt.currentTarget.getAttribute('sulga');
		var gaEvtParams = clickevtdata.split('^');
		if (gaEvtParams && gaEvtParams.length > 0) {
			ga.pushEvent(gaEvtParams[0], gaEvtParams[1], gaEvtParams[2]);
		}
	},

	pushValues: function (event_Category, event_Label, event_action, others) {
		ga.pushEvent(event_Category, event_Label, event_action, others);
	}



}

/* harmony default export */ const GATrack = (bindGA);
//bindGA.init();
;// CONCATENATED MODULE: ../silk/src/MainEnums.ts
//NOTE: These 2 need to match Silk/_Enums.cs
//TODO: change back when deprecating old appsource
var MainEnums_SulekhaAppSource;
(function (SulekhaAppSource) {
    SulekhaAppSource["Web"] = "Web";
    SulekhaAppSource["MobileWeb"] = "Mweb";
    SulekhaAppSource["MobileApp"] = "App";
})(MainEnums_SulekhaAppSource || (MainEnums_SulekhaAppSource = {}));
var MainEnums_SulekhaProduct;
(function (SulekhaProduct) {
    SulekhaProduct[SulekhaProduct["LocalServices"] = 1] = "LocalServices";
    SulekhaProduct[SulekhaProduct["Capshine"] = 2] = "Capshine";
    SulekhaProduct[SulekhaProduct["Promanage"] = 3] = "Promanage";
    SulekhaProduct[SulekhaProduct["SilkLab"] = 4] = "SilkLab";
})(MainEnums_SulekhaProduct || (MainEnums_SulekhaProduct = {}));
//will throw an exception if not matching appSlug of ProductMeta.cs
var MainEnums_MobileApps;
(function (MobileApps) {
    MobileApps["notSet"] = "notSet";
    MobileApps["consumers"] = "consumers";
    MobileApps["capshine"] = "capshine";
    MobileApps["promanage"] = "promanage";
})(MainEnums_MobileApps || (MainEnums_MobileApps = {}));
var MainEnums_AppEnvironment;
(function (AppEnvironment) {
    AppEnvironment["unknown"] = "UNKNOWN";
    AppEnvironment["development"] = "DEV";
    AppEnvironment["qa"] = "QA";
    AppEnvironment["staging"] = "STAGING";
    AppEnvironment["production"] = "PRODUCTION";
})(MainEnums_AppEnvironment || (MainEnums_AppEnvironment = {}));
var MainEnums_MobilePages;
(function (MobilePages) {
    MobilePages["unknown"] = "Unknown";
    MobilePages["login"] = "Login";
    MobilePages["logoff"] = "Logoff";
    MobilePages["search"] = "Search";
    MobilePages["home"] = "Home";
    MobilePages["about"] = "About";
    MobilePages["myAccount"] = "My Account";
    MobilePages["errorNotFound"] = "Page Not Found";
    MobilePages["errorReport"] = "Error Report";
    MobilePages["samples"] = "Samples";
    MobilePages["uiComponents"] = "UI Components";
    MobilePages["apiTester"] = "API Tester";
    //Consumer / Business
    MobilePages["businessProfilePrivate"] = "Business Profile Private";
    MobilePages["businessProfile"] = "Business Profile";
    MobilePages["userProfile"] = "User Profile";
    MobilePages["managedAddresses"] = "Managed Addresses";
    MobilePages["listings"] = "Listings";
    MobilePages["myNeeds"] = "My Needs";
    MobilePages["enquiries"] = "Enquiries";
    MobilePages["faqs"] = "FAQs";
    MobilePages["termsAndConditions"] = "Terms And Conditions";
    MobilePages["needDetail"] = "Need Detail";
    MobilePages["jobStatusUpdate"] = "Job Status Update";
    MobilePages["clusterDetail"] = "Cluster Detail";
    MobilePages["chatbot"] = "Chatbot";
    MobilePages["chat"] = "Chat";
    MobilePages["paymentList"] = "Payment List";
    MobilePages["notifications"] = "Notifications";
    //Pro Manage
    MobilePages["dashboard"] = "Dashboard";
    MobilePages["insights"] = "Insights";
    //Capshine
    MobilePages["signUp"] = "SignUp";
    MobilePages["dailyActivity"] = "DailyActivity";
    MobilePages["activity"] = "Activity";
    MobilePages["activityPlayList"] = "ActivityPlayList";
    MobilePages["activityPlayListByPlayNo"] = "ActivityPlayListByPlayNo";
    MobilePages["quiz"] = "Quiz";
    MobilePages["fillthegap"] = "FillTheGap";
    MobilePages["faq"] = "Faq";
    MobilePages["terms"] = "Terms";
    MobilePages["privacypolicy"] = "Privacy Policy";
    MobilePages["aboutus"] = "AboutUs";
    MobilePages["paymentPlans"] = "PaymentPlans";
    MobilePages["paymentThankyou"] = "PaymentThankyou";
    MobilePages["dailyActivityresponse"] = "DailyActivityResponse";
    MobilePages["dailyActivitydetails"] = "DailyActivityDetails";
    MobilePages["englishAssessment"] = "EnglishAssessment";
    MobilePages["assessYourEnglish"] = "AssessYourEnglish";
    MobilePages["paymentSummary"] = "PaymentSummary";
    MobilePages["subscriptionSuccessful"] = "SubscriptionSuccessful";
    MobilePages["subscriptionFailed"] = "SubscriptionFailed";
    MobilePages["homeRedirect"] = "HomeRedirect";
    MobilePages["learningPlan"] = "LearningPlan";
    MobilePages["watchVideo"] = "WatchVideo";
    MobilePages["paymentUpgradeRequest"] = "PaymentUpgradeRequest";
    MobilePages["editProfile"] = "EditProfile";
    MobilePages["learningVideoMCQ"] = "LearningVideoMCQ";
    MobilePages["classRoom"] = "ClassRoom";
    MobilePages["myRewards"] = "MyRewards";
    MobilePages["mySubscription"] = "MySubscription";
    MobilePages["previousActivities"] = "PreviousActivities";
    MobilePages["voicerecording"] = "VoiceRecording";
    MobilePages["fluencyReport"] = "FluencyReport";
    MobilePages["coachFeedbacks"] = "CoachFeedbacks";
    MobilePages["jumbledSentence"] = "JumbledSentence";
    MobilePages["meanings"] = "Meanings";
    MobilePages["videos"] = "Videos";
    MobilePages["videoLessons"] = "VideoLessons";
    MobilePages["watchedVideos"] = "WatchedVideos";
    MobilePages["watchShortVideos"] = "WatchShortVideos";
    MobilePages["talktimeSchedules"] = "TalktimeSchedules";
    MobilePages["talktime"] = "Talktime";
    MobilePages["signUpTalktime"] = "SignUpTalktime";
    MobilePages["JobInterviewCourse"] = "JobInterviewCourse";
    MobilePages["WatchJobInterviewCourseVideo"] = "WatchJobInterviewCourseVideo";
    MobilePages["JobInterviewCourseVideoQuiz"] = "JobInterviewCourseVideoQuiz";
    MobilePages["JobInterviewCoursePreview"] = "JobInterviewCoursePreview";
    MobilePages["ShortVideosViewAll"] = "ShortVideosViewAll";
})(MainEnums_MobilePages || (MainEnums_MobilePages = {}));

;// CONCATENATED MODULE: ./src/js/PaymentThankyou.js
﻿





let paymentThankyou = {
	planType: PaymentPlanTypeOption.SixMonths,
	sulekhaApp: null,

	init: function (sulekhaApp = null) {
		paymentThankyou.sulekhaApp = sulekhaApp;
		paymentThankyou.bindEvents();		

		//bindGA.pushValues('gtm.load', 'paymentplan', 'impression');
	},
	bindEvents: function () {

		paymentThankyou.hideHeaderFooter();

		let thankyouContinueBtn = document.querySelector("[payment-thankyou-continue-btn]");
		if (thankyouContinueBtn) {
              
			thankyouContinueBtn.addEventListener('click', () => {
			
				if (paymentThankyou.sulekhaApp) {
					paymentThankyou.sulekhaApp.navigateTo(MainEnums_MobilePages.home)
				}
				else {
					location.href = "/";
				}
			});
		}

		let paymentRetryBtn = document.querySelector("[payment-retry-btn]");
		if (paymentRetryBtn) {
			paymentRetryBtn.addEventListener('click', () => {
				var plantype = paymentThankyou.getQueryStringValue('plantype');
				if (paymentThankyou.sulekhaApp) {
					paymentThankyou.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentSummary, { "plantype": plantype })
				}
				else {
					location.href = "/paymentsummary?plantype=" + plantype;
				}
			});
		}
	},
	hideHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}
	},
	getQueryStringValue: function (id) {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get(id);
	},
}

/* harmony default export */ const PaymentThankyou = (paymentThankyou);
;// CONCATENATED MODULE: ./src/js/PaymentPlans.js
﻿





let paymentPlans = {
	planType: PaymentPlanTypeOption.SixMonths,
	userPid: 0,

	sulekhaApp: null,

	isExistingUser: false,
	paymentPlansGAType: '',
	userType: '',

	bindEvents: function () {

		paymentPlans.hideHeaderFooter();

		let radioBtns = document.querySelectorAll('[data-plantype]');
		radioBtns.forEach((btn) => {
			btn.addEventListener('click', (event) => {
				paymentPlans.planType = event.currentTarget.getAttribute("data-plantype");
			})
		});

		let proceedBtn = document.querySelector("[paymentplans-proceed-btn]");
		if (proceedBtn) {
			proceedBtn.addEventListener('click', (event) => {
				
				if (paymentPlans.planType == PaymentPlanTypeOption.Limited || paymentPlans.planType == PaymentPlanTypeOption.FreeTrial) {
					let step1Slide = document.querySelector("[paymentplans-slide='step1']");
					let step2Slide = document.querySelector("[paymentplans-slide='step2']");
					step1Slide.classList.replace("current-slide", "previous-slide");
					step2Slide.classList.replace("next-slide", "current-slide");
				}
				else {
					// bindGA.pushValues(paymentPlans.userType + '_paymentsummary', paymentPlans.paymentPlansGAType + amount + '_' + paymentPlans.planType, 'Click_' + paymentPlans.userType + '_paymentsummary');
					
					if (paymentPlans.sulekhaApp) {
						paymentPlans.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentSummary, { "plantype": paymentPlans.planType })
						// let openUrl = `${CSMainAPIs.Capshine.Server.baseUrl}paymentsummary?plantype=${paymentPlans.planType}`
						// let closeUrlPath = `${CSMainAPIs.Capshine.Server.baseUrl}paymentthankyou`
						// // location.href = "/paymentthankyou?orderid=" + RazorPayPayments.spid + "&plantype=" + RazorPayPayments.paymentPlan
						// const callback = (url) => {
						// 	console.log("inside exit callback", url);
						// 	if (url) {
						// 		const params = new URL(url)
						// 		const orderid = params.searchParams.get('orderid')
						// 		const plantype = params.searchParams.get('plantype')
						// 		paymentPlans.sulekhaApp.navigateTo(MobilePages.paymentThankyou, {
						// 			"orderid": orderid,
						// 			"plantype": plantype
						// 		})
						// 	}
						// }
						// const appUrl = `${CSMainAPIs.Capshine.Server.baseUrl}api/user/auth?authtoken=${paymentPlans.sulekhaApp.state.currentUser.SulekhaAuth}&nexturl=${openUrl}`
						// SulekhaSilkDI.CapshineInappBrowser_Open(appUrl, closeUrlPath, callback)
					} else {
						location.href = "/paymentsummary?plantype=" + paymentPlans.planType;
					}
				}
			})
		}
		let backToPlansBtn = document.querySelector("[paymentplans-back-btn]");
		if (backToPlansBtn) {
			backToPlansBtn.addEventListener('click', () => {
				let step1Slide = document.querySelector("[paymentplans-slide='step1']");
				let step2Slide = document.querySelector("[paymentplans-slide='step2']");
				step2Slide.classList.replace("current-slide", "next-slide");
				step1Slide.classList.replace("previous-slide", "current-slide");
			})
		}

		let freeVersionBtn = document.querySelector("[free-version-btn]");
		if (freeVersionBtn) {
			freeVersionBtn.addEventListener("click", () => {
				//if (paymentPlans.isExistingUser)
				//	bindGA.pushValues(paymentPlans.userType + '_Continuewithlimitedplan', 'limitedplan_continue', 'Click_' + paymentPlans.userType + '_Continuewithlimitedplan');
				//else
				//	bindGA.pushValues(paymentPlans.userType + '_Continuewithlimitedplan', 'limitedplan_confirm', 'Click_' + paymentPlans.userType + '_Continuewithlimitedplan');
				paymentPlans.updateUserType();
			})
		}

		let continueWithCurrentPlanBtn = document.querySelector("[continue-with-existing-plan]");
		if (continueWithCurrentPlanBtn) {
			GATrack.pushValues('continue with existing plan', 'continue with existing plan','continue with existing plan')
			continueWithCurrentPlanBtn.addEventListener("click", () => {
				if (paymentPlans.sulekhaApp) {
					paymentPlans.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
				} else {
					location.href = '/';
				}
			})

			
		}
		
		document.querySelectorAll("._ancViewPreviewVideo").forEach((ancViewPreviewVideo) => {

            ancViewPreviewVideo.addEventListener("click",  function (e) {
				if (paymentPlans.sulekhaApp) {
					paymentPlans.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCoursePreview, null)
				} else {
					location.href = '/JobInterviewCoursePreview';
				}
            
            })

        })


	},
	checkIfExistingUser: function () {
		let isExistingUser = document.getElementById("paymentPlansUserType");
		if (isExistingUser) {
			paymentPlans.isExistingUser = true;
			paymentPlans.paymentPlansGAType = 'upgrade_';
		}
	},
	updateUserType: function () {
		let requestOptions = {
			ClubUserType: 1, //PaymentPlanTypeOption.Limited,
			UserPid: parseInt(paymentPlans.userPid)
		}
		CSMainAPIs.Capshine.APIs.UpdateClubSignUpDetails.execute(requestOptions, () => {
		
			GATrack.pushValues(paymentPlans.userType + '_limitedplan_thankyou', paymentPlans.paymentPlansGAType + 'subscribed_limitedplan', 'Click_' + paymentPlans.userType + '_limitedplan_thankyou');
			if (paymentPlans.sulekhaApp) {
				paymentPlans.sulekhaApp.navigateTo(MainEnums_MobilePages.subscriptionSuccessful, null)
			} else {
				location.href = '/subscriptionsuccessful';
			}
		});
	},
	hideHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}
	},
	init: function (userPid = 0, sulekhaApp = null) {
		paymentPlans.userPid = userPid > 0 ? userPid : document.getElementById("hdnUserPid").value;
		paymentPlans.bindEvents();
		paymentPlans.checkIfExistingUser();
		paymentPlans.userType = paymentPlans.isExistingUser ? "Existinguser" : "Newuser";
		paymentPlans.sulekhaApp = sulekhaApp;

		GATrack.pushValues('gtm.load', 'paymentplan', 'impression');
	}
}

/* harmony default export */ const PaymentPlans = (paymentPlans);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ClubRegistration.vue?vue&type=template&id=46dea3c6


const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_1 = /*#__PURE__*/(0,vue_cjs.createStaticVNode)("<svg style=\"display:none;\" xmlns=\"http://www.w3.org/2000/svg\"><symbol id=\"skIconbackarrow\"><path d=\"M18 12H3\" stroke=\"#6A6262\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.58755 5.29297L2.76855 11.698L8.58755 18.103\" stroke=\"#6A6262\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></symbol><symbol id=\"skIconchevrondown\"><path d=\"M4.42072 4.59574L0.956724 1.13174C0.878062 1.0517 0.833984 0.943964 0.833984 0.831739C0.833984 0.719515 0.878062 0.61178 0.956724 0.531739L1.35672 0.13174C1.43676 0.0530778 1.5445 0.00899982 1.65672 0.00899982C1.76895 0.00899982 1.87668 0.0530778 1.95672 0.13174L4.71472 2.87674L7.48072 0.122739C7.56077 0.044077 7.6685 0 7.78072 0C7.89295 0 8.00068 0.044077 8.08072 0.122739L8.48072 0.522739C8.55939 0.602781 8.60346 0.710515 8.60346 0.82274C8.60346 0.934964 8.55939 1.0427 8.48072 1.12274L5.02572 4.59574C4.94547 4.67592 4.83667 4.72096 4.72322 4.72096C4.60978 4.72096 4.50098 4.67592 4.42072 4.59574Z\" fill=\"#6A6262\"></path></symbol></svg>", 1)
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_2 = { class: "sk-panel show step-slider" }
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_3 = { class: "sk-inner" }
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_4 = {
  key: 0,
  class: "sk-header"
}
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_5 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  width: "20",
  height: "23",
  id: "back",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconbackarrow" })
], -1)
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_6 = [
  ClubRegistrationvue_type_template_id_46dea3c6_hoisted_5
]
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_7 = {
  class: "sk-header invisible",
  ref: "header"
}
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_8 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  width: "20",
  height: "23",
  id: "back",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconbackarrow" })
], -1)
const ClubRegistrationvue_type_template_id_46dea3c6_hoisted_9 = [
  ClubRegistrationvue_type_template_id_46dea3c6_hoisted_8
]
const _hoisted_10 = {
  id: "progress",
  class: "progress-bar"
}
const _hoisted_11 = {
  class: "progress-inside",
  ref: "progress"
}
const _hoisted_12 = { class: "sk-body no-scroll auto-nav" }
const _hoisted_13 = {
  class: "current-slide welcome",
  id: "step1",
  ref: "step1"
}
const _hoisted_14 = { class: "slide-content align-center" }
const _hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("img", {
  class: "logo-capshine",
  src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/capshine-app-logo.svg"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "",
  xmlns: "http://www.w3.org/2000/svg",
  width: "175",
  height: "175",
  fill: "",
  viewBox: "0 0 500 500"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skRegistration" })
], -1)
const _hoisted_17 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Welcome back to Capshine", -1)
const _hoisted_18 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, " Please register with Capshine to start your learning journey. ", -1)
const _hoisted_19 = { class: "btn-group mt-3" }
const _hoisted_20 = {
  class: "next-slide",
  id: "step2",
  ref: "step2"
}
const _hoisted_21 = { class: "slide-content" }
const _hoisted_22 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "What's your mother tongue?", -1)
const _hoisted_23 = {
  class: "select-option",
  id: "language"
}
const _hoisted_24 = {
  class: "text-field hide",
  "other-input": ""
}
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  class: "hide",
  "data-continue-btn": ""
}
const _hoisted_27 = {
  class: "next-slide",
  id: "step3",
  ref: "step3"
}
const _hoisted_28 = { class: "slide-content" }
const _hoisted_29 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Why do you want to improve your communication skills?", -1)
const _hoisted_30 = { class: "select-option" }
const _hoisted_31 = {
  class: "text-field hide",
  "other-input": ""
}
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  class: "hide",
  "data-continue-btn": ""
}
const _hoisted_34 = {
  class: "next-slide",
  id: "step4",
  ref: "step4"
}
const _hoisted_35 = { class: "slide-content" }
const _hoisted_36 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Where are you from?", -1)
const _hoisted_37 = {
  class: "next-slide",
  id: "step5",
  ref: "step5"
}
const _hoisted_38 = { class: "slide-content" }
const _hoisted_39 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "I am a ……", -1)
const _hoisted_40 = { class: "select-option" }
const _hoisted_41 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "text-field hide" }, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("input", {
    class: "focus",
    type: "text",
    placeholder: "Other",
    required: ""
  })
], -1)
const _hoisted_42 = {
  class: "next-slide",
  id: "step6",
  ref: "step6"
}
const _hoisted_43 = { class: "slide-content" }
const _hoisted_44 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "I am ……", -1)
const _hoisted_45 = { class: "select-option" }
const _hoisted_46 = {
  class: "next-slide",
  id: "step7",
  ref: "step7"
}
const _hoisted_47 = { class: "slide-content" }
const _hoisted_48 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "And… I am", -1)
const _hoisted_49 = { class: "select-option" }
const _hoisted_50 = {
  class: "text-field hide",
  "other-input": ""
}
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  class: "hide",
  "data-continue-btn": ""
}
const _hoisted_53 = {
  class: "next-slide",
  id: "step8",
  ref: "step8"
}
const _hoisted_54 = { class: "slide-content" }
const _hoisted_55 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Thanks! Now Create your account to see your progress.", -1)
const _hoisted_56 = { class: "text-field mobile-number" }
const _hoisted_57 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "error-text" }, "Enter a valid phone number", -1)
const _hoisted_58 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("small", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconchevrondown" })
  ])
], -1)
const _hoisted_59 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("input", {
  id: "countryCode",
  class: "hide",
  type: "text",
  name: "myCountry",
  placeholder: "Country code"
}, null, -1)
const _hoisted_60 = { class: "mt-2" }
const _hoisted_61 = /*#__PURE__*/(0,vue_cjs.createTextVNode)("By registering, you agree to Capshine's ")
const _hoisted_62 = /*#__PURE__*/(0,vue_cjs.createTextVNode)(" and ")
const _hoisted_63 = {
  class: "next-slide otp-number",
  id: "step9",
  ref: "step9"
}
const _hoisted_64 = { class: "slide-content" }
const _hoisted_65 = {
  class: "next-slide",
  id: "step10",
  ref: "step10"
}
const _hoisted_66 = { class: "slide-content" }
const _hoisted_67 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "What is your name?", -1)
const _hoisted_68 = { class: "text-field mb-2" }
const _hoisted_69 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "error-text" }, "Enter a valid name", -1)
const _hoisted_70 = {
  class: "next-slide",
  id: "step11",
  ref: "step11"
}
const _hoisted_71 = { class: "slide-content" }
const _hoisted_72 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "What is your email?", -1)
const _hoisted_73 = { class: "text-field" }
const _hoisted_74 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "error-text" }, "Enter a valid email Id", -1)
const _hoisted_75 = {
  class: "next-slide",
  ref: "termsPrivacyContent"
}
const _hoisted_76 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "slide-content" }, null, -1)
const _hoisted_77 = [
  _hoisted_76
]

function ClubRegistrationvue_type_template_id_46dea3c6_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pincode = (0,vue_cjs.resolveComponent)("Pincode")
  const _component_Countrycode = (0,vue_cjs.resolveComponent)("Countrycode")
  const _component_Otp = (0,vue_cjs.resolveComponent)("Otp")

  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
    ClubRegistrationvue_type_template_id_46dea3c6_hoisted_1,
    (0,vue_cjs.createElementVNode)("div", ClubRegistrationvue_type_template_id_46dea3c6_hoisted_2, [
      (0,vue_cjs.createElementVNode)("div", ClubRegistrationvue_type_template_id_46dea3c6_hoisted_3, [
        ($data.isTermsPrivacyPage)
          ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ClubRegistrationvue_type_template_id_46dea3c6_hoisted_4, [
              (0,vue_cjs.createElementVNode)("div", {
                class: "left-nav",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClickBackMobileNo && $options.onClickBackMobileNo(...args)))
              }, ClubRegistrationvue_type_template_id_46dea3c6_hoisted_6),
              (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)($data.termsPrivacyPageHeader), 1)
            ]))
          : (0,vue_cjs.createCommentVNode)("", true),
        (0,vue_cjs.createElementVNode)("div", ClubRegistrationvue_type_template_id_46dea3c6_hoisted_7, [
          (0,vue_cjs.createElementVNode)("div", {
            id: "showHeaderLeftNav",
            class: "left-nav",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.onClickBack && $options.onClickBack(...args)))
          }, ClubRegistrationvue_type_template_id_46dea3c6_hoisted_9),
          (0,vue_cjs.createElementVNode)("div", _hoisted_10, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_11, null, 512)
          ])
        ], 512),
        (0,vue_cjs.createElementVNode)("div", _hoisted_12, [
          (0,vue_cjs.createElementVNode)("div", _hoisted_13, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              (0,vue_cjs.createElementVNode)("div", _hoisted_19, [
                (0,vue_cjs.createElementVNode)("button", {
                  type: "button",
                  href: "#",
                  class: "button primary medium block",
                  id: "next",
                  onClick: _cache[2] || (_cache[2] = $event => ($options.moveToNextScreen()))
                }, " Get started ")
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_20, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_21, [
              _hoisted_22,
              (0,vue_cjs.createElementVNode)("ul", _hoisted_23, [
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[3] || (_cache[3] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "English"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[4] || (_cache[4] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Hindi"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[5] || (_cache[5] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Tamil"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[6] || (_cache[6] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Malayalam"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[7] || (_cache[7] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Telugu"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[8] || (_cache[8] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Bengali"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[9] || (_cache[9] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Gujarati"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[10] || (_cache[10] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args))),
                  "data-other": ""
                }, "Other")
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_24, [
                (0,vue_cjs.createElementVNode)("input", {
                  class: "focus",
                  value: $data.enteredValues.language,
                  type: "text",
                  placeholder: "Please enter your language",
                  required: "",
                  onKeyup: _cache[11] || (_cache[11] = (...args) => ($options.onKeyupOther && $options.onKeyupOther(...args)))
                }, null, 40, _hoisted_25)
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_26, [
                (0,vue_cjs.createElementVNode)("button", {
                  type: "button",
                  class: (0,vue_cjs.normalizeClass)($options.languageContinueClass),
                  onClick: _cache[12] || (_cache[12] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                  id: "next"
                }, " Continue ", 2)
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_27, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_28, [
              _hoisted_29,
              (0,vue_cjs.createElementVNode)("ul", _hoisted_30, [
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[13] || (_cache[13] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Higher Education"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[14] || (_cache[14] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Job Opportunities"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[15] || (_cache[15] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Travel"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[16] || (_cache[16] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Live and Work Abroad"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[17] || (_cache[17] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Casual Conversation"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[18] || (_cache[18] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args))),
                  "data-other": ""
                }, "Other")
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_31, [
                (0,vue_cjs.createElementVNode)("input", {
                  class: "focus",
                  value: $data.enteredValues.whyPractice,
                  type: "text",
                  placeholder: "Please enter your response",
                  required: "",
                  onKeyup: _cache[19] || (_cache[19] = (...args) => ($options.onKeyupOther && $options.onKeyupOther(...args)))
                }, null, 40, _hoisted_32)
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_33, [
                (0,vue_cjs.createElementVNode)("button", {
                  type: "button",
                  class: (0,vue_cjs.normalizeClass)($options.whyPracticeContinueClass),
                  onClick: _cache[20] || (_cache[20] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                  id: "next"
                }, " Continue ", 2)
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_34, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_35, [
              _hoisted_36,
              (0,vue_cjs.createVNode)(_component_Pincode, {
                pincodeProp: _ctx.pincode,
                value: "",
                pincodeData: $data.pincodeList,
                selectionCallBack: $options.pincodeSelectionCallBack,
                setFocus: $data.isPincodeFocused
              }, null, 8, ["pincodeProp", "pincodeData", "selectionCallBack", "setFocus"]),
              (0,vue_cjs.createElementVNode)("button", {
                type: "button",
                href: "#",
                class: (0,vue_cjs.normalizeClass)($options.pincodeContinueClass),
                id: "next",
                onClick: _cache[21] || (_cache[21] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args)))
              }, " Continue ", 2)
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_37, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_38, [
              _hoisted_39,
              (0,vue_cjs.createElementVNode)("ul", _hoisted_40, [
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[22] || (_cache[22] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Male"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[23] || (_cache[23] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Female"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[24] || (_cache[24] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "Other")
              ]),
              _hoisted_41
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_42, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_43, [
              _hoisted_44,
              (0,vue_cjs.createElementVNode)("ul", _hoisted_45, [
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[25] || (_cache[25] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "< 20 years"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[26] || (_cache[26] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "20 - 25 years"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[27] || (_cache[27] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "25 - 30 years"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[28] || (_cache[28] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "30 - 35 years"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[29] || (_cache[29] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "35 - 40 years"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[30] || (_cache[30] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "> 40 years")
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_46, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_47, [
              _hoisted_48,
              (0,vue_cjs.createElementVNode)("ul", _hoisted_49, [
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[31] || (_cache[31] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "a student"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[32] || (_cache[32] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "looking for a job"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[33] || (_cache[33] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "employed"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[34] || (_cache[34] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "a homemaker"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[35] || (_cache[35] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args)))
                }, "a business owner / freelancer"),
                (0,vue_cjs.createElementVNode)("li", {
                  onClick: _cache[36] || (_cache[36] = (...args) => ($options.onSelectOption && $options.onSelectOption(...args))),
                  "data-other": ""
                }, "Other")
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_50, [
                (0,vue_cjs.createElementVNode)("input", {
                  class: "focus",
                  value: $data.enteredValues.occupation,
                  type: "text",
                  placeholder: "Please enter your occupation",
                  required: "",
                  onKeyup: _cache[37] || (_cache[37] = (...args) => ($options.onKeyupOther && $options.onKeyupOther(...args)))
                }, null, 40, _hoisted_51)
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_52, [
                (0,vue_cjs.createElementVNode)("button", {
                  type: "button",
                  class: (0,vue_cjs.normalizeClass)($options.occupationContinueClass),
                  onClick: _cache[38] || (_cache[38] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                  id: "next"
                }, " Continue ", 2)
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_53, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_54, [
              _hoisted_55,
              (0,vue_cjs.createElementVNode)("div", _hoisted_56, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  type: "text",
                  placeholder: "Enter your phone number",
                  required: "",
                  pattern: "[0-9]*",
                  inputmode: "numeric",
                  ref: "mobileInput",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => (($data.enteredValues.mobile) = $event)),
                  onKeyup: _cache[40] || (_cache[40] = (...args) => ($options.hideErrorText && $options.hideErrorText(...args)))
                }, null, 544), [
                  [vue_cjs.vModelText, $data.enteredValues.mobile]
                ]),
                _hoisted_57,
                (0,vue_cjs.createElementVNode)("h6", {
                  class: "country-code",
                  value: "Show DIV",
                  id: "bt",
                  onClick: _cache[41] || (_cache[41] = (...args) => ($options.openCountrySearch && $options.openCountrySearch(...args)))
                }, [
                  (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)($data.countryCode), 1),
                  _hoisted_58
                ])
              ]),
              _hoisted_59,
              (0,vue_cjs.createElementVNode)("div", {
                class: (0,vue_cjs.normalizeClass)({ hide: !$data.showCountrySearch })
              }, [
                (0,vue_cjs.createVNode)(_component_Countrycode, {
                  onCountryCodeBlur: $options.onCountryCodeBlur,
                  selectionCallBack: $options.countryCodeSelectionCallBack,
                  shouldFocus: $data.showCountrySearch
                }, null, 8, ["onCountryCodeBlur", "selectionCallBack", "shouldFocus"])
              ], 2),
              (0,vue_cjs.createElementVNode)("button", {
                type: "button",
                href: "#",
                class: (0,vue_cjs.normalizeClass)($options.mobileContinueClass),
                onClick: _cache[42] || (_cache[42] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                id: "next"
              }, " Continue ", 2),
              (0,vue_cjs.createElementVNode)("p", _hoisted_60, [
                _hoisted_61,
                (0,vue_cjs.createElementVNode)("a", {
                  onClick: _cache[43] || (_cache[43] = $event => ($options.termsClick()))
                }, "Terms of Service"),
                _hoisted_62,
                (0,vue_cjs.createElementVNode)("a", {
                  onClick: _cache[44] || (_cache[44] = $event => ($options.privacyClick()))
                }, "Privacy Policy")
              ])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_63, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_64, [
              (0,vue_cjs.createVNode)(_component_Otp, {
                mobileNumber: $data.enteredValues.mobile,
                countryCode: $data.countryCode,
                initOtpTimer: $data.initOtpTimer,
                onSuccess: $options.checkIfAlreadyRegistered,
                resendOtp: $options.requestForOtp,
                isSignUpPage: $props.isSignUpPage,
                onClickBack: $options.onClickBack
              }, null, 8, ["mobileNumber", "countryCode", "initOtpTimer", "onSuccess", "resendOtp", "isSignUpPage", "onClickBack"])
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_65, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_66, [
              _hoisted_67,
              (0,vue_cjs.createElementVNode)("div", _hoisted_68, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  type: "text",
                  placeholder: "Enter your full name",
                  required: "",
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => (($data.enteredValues.userName) = $event))
                }, null, 512), [
                  [vue_cjs.vModelText, $data.enteredValues.userName]
                ]),
                _hoisted_69
              ]),
              (0,vue_cjs.createElementVNode)("button", {
                type: "button",
                href: "#",
                class: (0,vue_cjs.normalizeClass)($options.nameContinueClass),
                onClick: _cache[46] || (_cache[46] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                onKeyup: _cache[47] || (_cache[47] = (...args) => ($options.hideErrorText && $options.hideErrorText(...args))),
                id: "next"
              }, " Continue ", 34)
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_70, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_71, [
              _hoisted_72,
              (0,vue_cjs.createElementVNode)("div", _hoisted_73, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  type: "email",
                  placeholder: "Enter your email",
                  required: "",
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => (($data.enteredValues.email) = $event))
                }, null, 512), [
                  [vue_cjs.vModelText, $data.enteredValues.email]
                ]),
                _hoisted_74
              ]),
              (0,vue_cjs.createElementVNode)("button", {
                type: "button",
                href: "#",
                class: (0,vue_cjs.normalizeClass)($options.emailContinueClass),
                onClick: _cache[49] || (_cache[49] = (...args) => ($options.onClickContinue && $options.onClickContinue(...args))),
                onKeyup: _cache[50] || (_cache[50] = (...args) => ($options.hideErrorText && $options.hideErrorText(...args))),
                id: "next"
              }, " Continue ", 34)
            ])
          ], 512),
          (0,vue_cjs.createElementVNode)("div", _hoisted_75, _hoisted_77, 512)
        ])
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/ClubRegistration.vue?vue&type=template&id=46dea3c6

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/Pincode.vue?vue&type=template&id=7d3a553f


const Pincodevue_type_template_id_7d3a553f_hoisted_1 = { class: "text-field autocomplete" }
const Pincodevue_type_template_id_7d3a553f_hoisted_2 = ["onClick"]
const Pincodevue_type_template_id_7d3a553f_hoisted_3 = {
  key: 1,
  class: "error-text show"
}

function Pincodevue_type_template_id_7d3a553f_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Pincodevue_type_template_id_7d3a553f_hoisted_1, [
    (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
      type: "text",
      required: "required",
      placeholder: "Enter your pincode",
      name: "pincode",
      id: "pincode",
      pattern: "[0-9]*",
      inputmode: "numeric",
      maxlength: "6",
      onInput: _cache[0] || (_cache[0] = $event => ($options.updateValue($event.target.value))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.pincodeValue) = $event)),
      onKeydown: [
        _cache[2] || (_cache[2] = (0,vue_cjs.withKeys)($event => ($options.onKeyUp($event)), ["up"])),
        _cache[3] || (_cache[3] = (0,vue_cjs.withKeys)($event => ($options.onKeyDown($event)), ["down"]))
      ],
      onClick: _cache[4] || (_cache[4] = (...args) => ($options.onclickInput && $options.onclickInput(...args))),
      onBlur: _cache[5] || (_cache[5] = (...args) => ($options.onBlur && $options.onBlur(...args))),
      ref: "PincodeSearchInput",
      "data-PincodeSearchInput": "",
      "tab-index": "-1"
    }, null, 544), [
      [vue_cjs.vModelText, $data.pincodeValue]
    ]),
    ($data.showSuggestions)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
          key: 0,
          class: (0,vue_cjs.normalizeClass)(["autocomplete-items", { 'd-none' : !$data.showSuggestions}])
        }, [
          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($options.matches, (suggestion, index) => {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
              key: index,
              class: (0,vue_cjs.normalizeClass)({'active': $options.isActive(index)}),
              pincodesearchsuggestion: "pincodeValue",
              onClick: $event => ($options.suggestionClick(index))
            }, (0,vue_cjs.toDisplayString)(suggestion), 11, Pincodevue_type_template_id_7d3a553f_hoisted_2))
          }), 128))
        ], 2))
      : (0,vue_cjs.createCommentVNode)("", true),
    ($data.isError)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", Pincodevue_type_template_id_7d3a553f_hoisted_3, "Please enter valid pincode"))
      : (0,vue_cjs.createCommentVNode)("", true)
  ]))
}
;// CONCATENATED MODULE: ./src/Components/Common/Pincode.vue?vue&type=template&id=7d3a553f

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/Pincode.vue?vue&type=script&lang=js

	

    /* harmony default export */ const Pincodevue_type_script_lang_js = ({
        name: "Pincode",
        props: {
            selectionCallBack: { type: Function },
            onPincodeBlur: {type :Function},
            pincodeProp: String,
            setFocus: Boolean
        },
        data() {
            return {
                open: false,
                current: 0,
                pageX: 0,
                pageY: 0,
                showSuggestions : false,
                pincodeValue: '',
                pincodeData: [],
                isError: false,
            }

        },
        mounted: function () {
            document.addEventListener('mousemove', (event) => {
                this.pageX = event.clientX;
                this.pageY = event.clientY;
            })

            this.getPincodeDetails();
        },
        computed: {
            // Filtering the suggestion based on the input
            matches() {
                return this.pincodeData.filter(function(obj) {
                    if (this.count < 5 && obj.startsWith(this.pincodeValue)) {
                        this.count++;
                        return true;
                    }
                    return false;
                }, {count : 0, pincodeValue : this.pincodeValue})
            },
            openSuggestion() {
                return this.selection !== '' &&
                    this.matches.length !== 0 &&
                    this.open === true
            }
        },
        methods: {
            getPincodeDetails: function () {
                CSMainAPIs.Capshine.APIs.GetPincodeDetails.execute({}, (response) => {
                    this.pincodeData = response.data;
                })
			},
             init:function() {
                this.pincodeValue = this.pincodeProp  // step1. assign propId to id
            },
            updateValue(value) {
                if( !this.showSuggestions) {
                    this.showSuggestions = true;
                }
                this.pincodeValue = value;
                if (this.validate())
                    this.selectionCallBack(value);
            },
            // When enter pressed on the input
            enter() {
                // this.$emit('input', '')
                // this.open = false,
                this.showSuggestions = false;
                this.selectionCallBack(this.matches[this.current]);
            },
            // When up pressed while suggestions are open
            up() {
                if (this.current > 0) {
                    this.current--
                }
            },
            // When up pressed while suggestions are open
            down() {
                if (this.current < this.matches.length - 1) {
                    this.current++
                }
            },
            // For highlighting element
            isActive(index) {
                return index === this.current
            },
            // When one of the suggestion is clicked
            suggestionClick(index) {
                this.showSuggestions = false;
                // this.$emit('input', '')
                // this.open = false;
                this.pincodeValue = this.matches[index];
                this.selectionCallBack(this.pincodeValue);
            },

            onKeyDown(e) {
                e.preventDefault();
                this.down();
                return false;
            },

            onKeyUp(e) {
                e.preventDefault();
                this.up();
                return false;
            },
            onclickInput: function () {
                this.showSuggestions = !this.showSuggestions;
            },
            onBlur : function() {
                if (document.elementFromPoint(this.pageX, this.pageY).getAttribute("pincodesearchsuggestion")) {
                        return;
                    }
                this.showSuggestions = false;
            },
            validate: function () {
                if (this.matches.length == 0) {
                    this.isError = true;
                    return false;
                }
                else {
                    this.isError = false;
                    return true;
				}  
			}
        },
		watch: {
			pincodeProp: function (new_value) {
				this.init()
			},
			setFocus: function (new_value) {
				if (new_value) {
					setTimeout(() => { this.$refs.PincodeSearchInput.focus() }, 500)
				}
			}
        }
    });

;// CONCATENATED MODULE: ./src/Components/Common/Pincode.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/Common/Pincode.vue




;
const Pincode_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Pincodevue_type_script_lang_js, [['render',Pincodevue_type_template_id_7d3a553f_render]])

/* harmony default export */ const Pincode = (Pincode_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/Otp.vue?vue&type=template&id=4c5f9a70


const Otpvue_type_template_id_4c5f9a70_hoisted_1 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Verify your phone number", -1)
const Otpvue_type_template_id_4c5f9a70_hoisted_2 = /*#__PURE__*/(0,vue_cjs.createTextVNode)(" We have sent an OTP to ")
const Otpvue_type_template_id_4c5f9a70_hoisted_3 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("br", null, null, -1)
const Otpvue_type_template_id_4c5f9a70_hoisted_4 = /*#__PURE__*/(0,vue_cjs.createTextVNode)()
const Otpvue_type_template_id_4c5f9a70_hoisted_5 = { class: "otp-wrap text-field" }
const Otpvue_type_template_id_4c5f9a70_hoisted_6 = { class: "otp-group" }
const Otpvue_type_template_id_4c5f9a70_hoisted_7 = { class: "otp-block" }
const Otpvue_type_template_id_4c5f9a70_hoisted_8 = { class: "otp-input" }
const Otpvue_type_template_id_4c5f9a70_hoisted_9 = /*#__PURE__*/(0,vue_cjs.createStaticVNode)("<span class=\"box-1\"></span><span class=\"box-2\"></span><span class=\"box-3\"></span><span class=\"box-4\"></span><span class=\"last-box\"></span>", 5)
const Otpvue_type_template_id_4c5f9a70_hoisted_14 = {
  key: 0,
  class: "error-text show"
}
const Otpvue_type_template_id_4c5f9a70_hoisted_15 = { key: 1 }
const Otpvue_type_template_id_4c5f9a70_hoisted_16 = {
  class: "sk-toast hide",
  ref: "toast"
}
const Otpvue_type_template_id_4c5f9a70_hoisted_17 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "sk-toast-inner" }, " We have resent the OTP ", -1)
const Otpvue_type_template_id_4c5f9a70_hoisted_18 = [
  Otpvue_type_template_id_4c5f9a70_hoisted_17
]

function Otpvue_type_template_id_4c5f9a70_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
    Otpvue_type_template_id_4c5f9a70_hoisted_1,
    (0,vue_cjs.createElementVNode)("p", null, [
      Otpvue_type_template_id_4c5f9a70_hoisted_2,
      Otpvue_type_template_id_4c5f9a70_hoisted_3,
      Otpvue_type_template_id_4c5f9a70_hoisted_4,
      (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)($props.countryCode) + " " + (0,vue_cjs.toDisplayString)($props.mobileNumber), 1),
      (0,vue_cjs.createElementVNode)("a", {
        class: "button link-no-border no-shadow",
        onClick: _cache[0] || (_cache[0] = $event => ($options.changeMobileNo()))
      }, "Change")
    ]),
    (0,vue_cjs.createElementVNode)("div", Otpvue_type_template_id_4c5f9a70_hoisted_5, [
      (0,vue_cjs.createElementVNode)("div", Otpvue_type_template_id_4c5f9a70_hoisted_6, [
        (0,vue_cjs.createElementVNode)("div", Otpvue_type_template_id_4c5f9a70_hoisted_7, [
          (0,vue_cjs.createElementVNode)("div", Otpvue_type_template_id_4c5f9a70_hoisted_8, [
            Otpvue_type_template_id_4c5f9a70_hoisted_9,
            (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
              type: "text",
              id: "txtotp",
              onKeydown: _cache[1] || (_cache[1] = $event => ($options.onKeyDownVerificationCode($event))),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.verificationCode) = $event)),
              maxlength: "4",
              name: "",
              class: "otp-by-4",
              pattern: "[0-9]*",
              inputmode: "numeric",
              ref: "inputOtp"
            }, null, 544), [
              [vue_cjs.vModelText, $data.verificationCode]
            ])
          ])
        ]),
        ($data.showError)
          ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", Otpvue_type_template_id_4c5f9a70_hoisted_14, "Invalid OTP"))
          : (0,vue_cjs.createCommentVNode)("", true),
        (!$data.resendOtpEnabled)
          ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", Otpvue_type_template_id_4c5f9a70_hoisted_15, " Resend OTP in " + (0,vue_cjs.toDisplayString)($data.countDown) + " Seconds ", 1))
          : (0,vue_cjs.createCommentVNode)("", true),
        ($data.resendOtpEnabled)
          ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("a", {
              key: 2,
              class: "resend-otp button link-no-border no-shadow",
              onClick: _cache[3] || (_cache[3] = (...args) => ($options.onClickResendOtp && $options.onClickResendOtp(...args)))
            }, "Resend OTP"))
          : (0,vue_cjs.createCommentVNode)("", true)
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", Otpvue_type_template_id_4c5f9a70_hoisted_16, Otpvue_type_template_id_4c5f9a70_hoisted_18, 512)
  ]))
}
;// CONCATENATED MODULE: ./src/Components/Common/Otp.vue?vue&type=template&id=4c5f9a70

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/Otp.vue?vue&type=script&lang=js

	
	

	/* harmony default export */ const Otpvue_type_script_lang_js = ({
		name: "pincode",
		props: {
			mobileNumber: {
				type: String,
				required: true,
			},
			countryCode: {
				type: String,
				required: true,
			},
			initOtpTimer: {
				type: Boolean,
				required: true,
			},
			isSignUpPage: {
				type: Boolean
			},
			resendOtp: {
				type: Function,
				required: true,
			},
			onSuccess: {
				type: Function,
				required: true,
			},
			onClickBack: {
				type: Function,
				required: true,
			}
		},
		data() {
			return {
				verificationCode: '',
				countDown: 120,
				timerId: 0,
				resendOtpEnabled: false,
				showError: false,
			}
		},
		methods: {
			changeMobileNo: function () {
				if (this.isSignUpPage)
					GATrack.pushValues('regnflow_change_mobile', 'change mobile', 'Click_Regflo_Changemobile');
				else
					GATrack.pushValues('loginflow_change_mobile', 'change mobile', 'Click_loginflo_Changemobile');
				this.onClickBack();
				this.verificationCode = '';
			},
			onKeyDownVerificationCode: function (evt) {
				if (this.showError)
					this.showError = false;
				if (this.verificationCode.length <= 4) {
					var key = evt.keyCode;
					if (key == 8 || key == 9 || key == 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
						return true;
					}
					evt.preventDefault();
					return;
				}
			},
			verifyOtp: async function () {
				let requestData = {
					MobileNumber: this.mobileNumber,
					CountryCode: this.countryCode,
					VerificationCode: this.verificationCode,
					isClubSignup: true,
				}

				CSMainAPIs.Capshine.APIs.VerifyOtp.execute(requestData, async (response) => {
					if (response.data.mobileVerificationStatus == "ValidNumber") {
						//SulGA.pushEvent(
						//	"confirm-otp",
						//	"otp verified",
						//	"confirm-otp-verify"
						//);
						if (this.isSignUpPage)
							GATrack.pushValues('regnflow_otp', 'otp_success', 'Click_Regflo_OTP');
						else
							GATrack.pushValues('loginflow_otp', 'otp_success', 'Click_loginflo_OTP');
						this.onSuccess();
					}
					else {
						this.showError = true;
					}
				});
			},
			countDownTimer() {
				this.countDown = 120;
				if (this.timerId) {
					clearInterval(this.timerId);
				}
				this.resendOtpEnabled = false;
				this.timerId = setInterval(() => {

					this.countDown -= 1
					if (this.countDown == 0) {
						this.resendOtpEnabled = true;
						clearInterval(this.timerId);
					}
				}, 1000)
			},
			onClickResendOtp() {
				if (this.resendOtp) {
					this.resendOtpEnabled = false;
					this.resendOtp();
					this.showToast();
				}
				else
					throw new ReferenceError('resendOtp function is not defined');
			},
			showToast() {
				if (this.$refs.toast)
					this.$refs.toast.classList.remove("hide");
				setTimeout(() => {
					this.$refs.toast.classList.add("hide");
				},3000)
			}
		},
		watch: {
			verificationCode: function (vcode) {
				if (vcode.length >= 4) {
					this.verifyOtp();
				}
			},
			initOtpTimer: function (newValue, oldValue) {
				if (newValue) {
					setTimeout(() => { 
						this.$refs.inputOtp.focus();
					}, 500)
					
					this.countDownTimer();
				}
					
			}
		}
	});

;// CONCATENATED MODULE: ./src/Components/Common/Otp.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/Common/Otp.vue




;
const Otp_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Otpvue_type_script_lang_js, [['render',Otpvue_type_template_id_4c5f9a70_render]])

/* harmony default export */ const Otp = (Otp_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/CountryCode.vue?vue&type=template&id=08dcc97b


const CountryCodevue_type_template_id_08dcc97b_hoisted_1 = { class: "text-field autocomplete" }
const CountryCodevue_type_template_id_08dcc97b_hoisted_2 = { class: "search-block" }
const CountryCodevue_type_template_id_08dcc97b_hoisted_3 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("i", { class: "far fa-search" }, null, -1)
const CountryCodevue_type_template_id_08dcc97b_hoisted_4 = { class: "autocomplete-items" }
const CountryCodevue_type_template_id_08dcc97b_hoisted_5 = ["onClick"]

function CountryCodevue_type_template_id_08dcc97b_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CountryCodevue_type_template_id_08dcc97b_hoisted_1, [
    (0,vue_cjs.createElementVNode)("div", CountryCodevue_type_template_id_08dcc97b_hoisted_2, [
      (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.value) = $event)),
        onInput: _cache[1] || (_cache[1] = $event => ($options.updateValue($event.target.value))),
        onBlur: _cache[2] || (_cache[2] = (...args) => ($options.onBlur && $options.onBlur(...args))),
        "data-id": "country-code-input",
        ref: "searchInput",
        onKeydown: [
          _cache[3] || (_cache[3] = (0,vue_cjs.withKeys)((...args) => ($options.up && $options.up(...args)), ["up"])),
          _cache[4] || (_cache[4] = (0,vue_cjs.withKeys)((...args) => ($options.down && $options.down(...args)), ["down"])),
          _cache[5] || (_cache[5] = (0,vue_cjs.withKeys)((...args) => ($options.enter && $options.enter(...args)), ["enter"]))
        ],
        placeholder: "Search"
      }, null, 544), [
        [vue_cjs.vModelText, $data.value]
      ])
    ]),
    CountryCodevue_type_template_id_08dcc97b_hoisted_3,
    (0,vue_cjs.createElementVNode)("div", CountryCodevue_type_template_id_08dcc97b_hoisted_4, [
      ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($options.matches, (suggestion, index) => {
        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
          key: index,
          countrycodesuggestion: "countrycodeinput",
          class: (0,vue_cjs.normalizeClass)({'active': $options.isActive(index)}),
          onClick: $event => ($options.suggestionClick(index))
        }, (0,vue_cjs.toDisplayString)(suggestion.countrycode), 11, CountryCodevue_type_template_id_08dcc97b_hoisted_5))
      }), 128))
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/Common/CountryCode.vue?vue&type=template&id=08dcc97b

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Common/CountryCode.vue?vue&type=script&lang=js

	

    /* harmony default export */ const CountryCodevue_type_script_lang_js = ({
        name: "CountryCode",
        props: {
            //value: {
            //    type: String,
            //    required: true
            //},
            selectionCallBack: { type: Function },
            onCountryCodeBlur: { type : Function},
            shouldFocus: { type : Boolean},
        },
        data() {
            return {
                open: false,
                current: 0,
                pageX: 0,
                pageY: 0,
                value: '',
                suggestions: [],
            }
        },
        mounted: function () {
            document.addEventListener('mousemove', (event) => {
                this.pageX = event.clientX;
                this.pageY = event.clientY;

            })

            CSMainAPIs.Capshine.APIs.GetCountryCodeDetails.execute({}, (response) => {
				this.suggestions = response.data;
			})
        },
        computed: {
            // Filtering the suggestion based on the input
            matches() {
                return this.suggestions.filter((obj) => {
                    return obj.country.indexOf(this.value.toLowerCase()) >= 0 || obj.code.indexOf(this.value.toLowerCase()) >= 0
                })
            },
            openSuggestion() {
                return this.selection !== '' &&
                    this.matches.length !== 0 &&
                    this.open === true
            }
        },
        methods: {
            updateValue(value) {
                if (this.open === false) {
                    this.open = true
                    this.current = 0
                }
                this.$emit('input', value)


                //this.selectionCallBack(this.matches[index].code);
            },
            // When enter pressed on the input
            enter() {
                this.$emit('input','')
                this.open = false
                this.selectionCallBack(this.matches[this.current].code);
            },
            // When up pressed while suggestions are open
            up() {
                if (this.current > 0) {
                    this.current--
                }
            },
            // When up pressed while suggestions are open
            down() {
                if (this.current < this.matches.length - 1) {
                    this.current++
                }
            },
            // For highlighting element
            isActive(index) {
                return index === this.current
            },
            // When one of the suggestion is clicked
            suggestionClick(index) {
                /*this.$emit('input', '')*/
                this.open = false
                this.selectionCallBack(this.matches[index].code);
            },
            onBlur() {
                if(this.onCountryCodeBlur) {
                     if (document.elementFromPoint(this.pageX, this.pageY).getAttribute("countrycodesuggestion")) {
                        return;
                    }
                    this.onCountryCodeBlur();
                }
            }
        },
        watch:{
            shouldFocus: function (newVal) {
                if(newVal){
                    window.test = this.$refs.searchInput
                    setTimeout(() => {
                        this.$refs.searchInput.focus();
                    },100)
                    
                }
                
            }
        }
    });

;// CONCATENATED MODULE: ./src/Components/Common/CountryCode.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/Common/CountryCode.vue




;
const CountryCode_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CountryCodevue_type_script_lang_js, [['render',CountryCodevue_type_template_id_08dcc97b_render]])

/* harmony default export */ const CountryCode = (CountryCode_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ClubRegistration.vue?vue&type=script&lang=js

	
	
	
	
	

	/* harmony default export */ const ClubRegistrationvue_type_script_lang_js = ({
		props: {
			showLoginPopup: { type: Function, required: true },
			setUserInfo: { type: Function, required: true },
			skipIntroScreen: { type: Boolean },
			closeSignUpPopup: { type: Function },
			isSignUpPage: { type: Boolean },
			pageSource: {type: String, Default: "Mobile"}
		},
		data() {
			return {
				regexp: {
					alpha: /[a-zA-Z ]{2,30}$/,
					number: /[^0-9]/g,
					email: /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i,
					mobile1: /^[9|7|6|8]\d{8}[\d{1}]$/i,
					internationalmobile: /^[0-9]{6,14}$/,
				},
				availableScreens: {
					intro: 1,
					language: 2,
					whyPractice: 3,
					pincode: 4,
					gender: 5,
					age: 6,
					occupation: 7,
					mobile: 8,
					oTP: 9,
					userName: 10,
					email: 11,
				},
				currentStepName: "",
				currentStepCount: 1,
				firstStep: 0,
				enteredValues: {
					language: "",
					whyPractice: "",
					pincode: "",
					gender: "",
					age: "",
					occupation: "",
					mobile: "",
					userName: "",
					email: "",
				},
				pincodeList: [],
				btnEnabledClass: "button medium block primary",
				btnDisabledClass: "button medium block light disabled ",
				countryCode: "+91",
				initOtpTimer: false,
				isAlreadyCapshineUser: false,
				isAlreadyClubMember: false,
				userpid: false,
				showCountrySearch: false,
				canMoveNext: true,
				totalStepCount: 11,
				skippedScreens: [],
				isUserLoggedIn: false,
				userDetails: [],
				isPincodeFocused: false,
				isTermsPrivacyPage: false,
				ShowMultipleDevicePopUp: false,
				termsPrivacyPageHeader: ''
			};
		},
		components: {
			Pincode: Pincode,
			Otp: Otp,
			Countrycode: CountryCode,
		},
		mounted: function () {
			const userHid = document.getElementById("hdnUserPid");
			this.skippedScreens.push(this.availableScreens.pincode)
			if (userHid)
				if (userHid.value > 0) this.isUserLoggedIn = true; /*set user login here*/

			if (this.isUserLoggedIn) {

				this.isAlreadyCapshineUser = true;
				this.getUserInfo(userHid.value);
			} else {

				if (this.isMobile) {

					this.trueCallerVerification();
				}
			}

			if (this.skipIntroScreen) {
				this.firstStep = this.availableScreens.language;
				this.skipScreenTo(this.availableScreens.language);
			}
			//CSMainAPIs.Capshine.APIs.GetClubInfo.execute({ clubId: 2 }, function (response) {
			//})
			/*this.getPincodeDetails();*/
		},
		methods: {
			isValidName(name) {
				return this.regexp.alpha.test(name);
			},
			isValidEMail(email) {
				return this.regexp.email.test(email);
			},
			isValidMobileNumber(mobileno, countrycode) {
				if (
					countrycode == undefined ||
					countrycode == "" ||
					countrycode == "91" ||
					countrycode == "+91"
				) {
					return this.regexp.mobile1.test(mobileno);
				} else {
					return this.regexp.internationalmobile.test(mobileno);
				}
			},
			moveToNextScreen: function () {
				debugger;
				if (
					this.currentStepCount + 1 <=
					Object.entries(this.availableScreens).length
				) {
					let nextStepCount = this.skippedScreens.includes(this.currentStepCount + 1) ? this.currentStepCount + 2 : this.currentStepCount + 1
					let currentSlide = this.$refs[`step${this.currentStepCount}`];
					let nextSlide = this.$refs[`step${nextStepCount}`];
					currentSlide.classList.replace("current-slide", "previous-slide");
					nextSlide.classList.replace("next-slide", "current-slide");
					this.currentStepCount = this.skippedScreens.includes(this.currentStepCount + 1) ? this.currentStepCount + 2 : this.currentStepCount + 1
					// this.currentStepCount++;
					this.currentStepName = Object.entries(this.availableScreens)[
						this.currentStepCount - 1
					][0];
					this.onPageLoad();
				}
			},
			onClickBack: function () {
				
				var prevSlideNo = this.currentStepCount - 1;
				if (this.currentStepCount == this.firstStep) {
					this.closeSignUpPopup();
					return;
				}

				if (this.currentStepCount == this.availableScreens.oTP) {
					this.initOtpTimer = false;
				}

				if (this.currentStepCount == this.availableScreens.pincode) {
					this.isPincodeFocused = false;
				}

				if (this.skippedScreens.includes(this.currentStepCount - 1)) {
					prevSlideNo = this.currentStepCount - 2
				} else {
					if (this.isAlreadyCapshineUser) {
						if (prevSlideNo == this.availableScreens.userName) {
							if (
								this.userDetails.firstName == "" ||
								this.userDetails.firstName == null ||
								this.userDetails.firstName == "null" ||
								!this.userDetails.firstName
							) {
							} else {
								prevSlideNo--;
							}
						}
						if (prevSlideNo == this.availableScreens.oTP) {
							prevSlideNo--;
						}
						if (prevSlideNo == this.availableScreens.mobile) {
							prevSlideNo--;
						}
					}
				}
				
				if (prevSlideNo > 0) {
					
					let currentSlide = this.$refs[`step${this.currentStepCount}`];
					let prevSlide = this.$refs[`step${prevSlideNo}`];
					let replaceClass = "";
					if (prevSlide.classList.contains("previous-slide"))
						replaceClass = "previous-slide";
					else if (prevSlide.classList.contains("next-slide"))
						replaceClass = "next-slide";
					
					currentSlide.classList.replace("current-slide", "next-slide");
					
					prevSlide.classList.replace(replaceClass, "current-slide");
					this.currentStepCount = prevSlideNo;
					this.currentStepName = Object.entries(this.availableScreens)[
						prevSlideNo - 1
					][0];
				}
			},
			skipScreenTo: function (stepNumber) {
				
				let currentSlide = this.$refs[`step${this.currentStepCount}`];
				currentSlide.classList.replace("current-slide", "previous-slide");
				let nextSlide = this.$refs[`step${stepNumber}`];
				nextSlide.classList.replace("next-slide", "current-slide");
				this.currentStepCount = stepNumber;
				this.currentStepName = Object.entries(this.availableScreens)[
					this.currentStepCount - 1
				][0];
				this.onPageLoad();
			},
			onPageLoad: function () {
				switch (this.currentStepName) {
					case "mobile":
						setTimeout(() => {
							this.$refs.mobileInput.focus();
						}, 500);
						break;
					case "pincode":
						this.isPincodeFocused = true;
				}
			},
			onSelectOption: function (event) {
				debugger;
				if (!this.canMoveNext) return;

				let value = event.currentTarget.innerText;
				this.enteredValues[this.currentStepName] = value;
				this.$refs[`step${this.currentStepCount}`]
					.querySelectorAll("li")
					.forEach((ele) => {
						ele.classList.remove(
							"selected",
							"animate__animated",
							"animate__pulse",
							"animate__faster"
						);
					});
				event.currentTarget.classList.add(
					"selected",
					"animate__animated",
					"animate__pulse",
					"animate__faster"
				);
				let otherInput =
					this.$refs[`step${this.currentStepCount}`].querySelector(
						"[other-input]"
					);
				let continueBtnWrapper = this.$refs[
					`step${this.currentStepCount}`
				].querySelector("[data-continue-btn]");
				if (event.currentTarget.hasAttribute("data-other")) {
					this.enteredValues[this.currentStepName] = "";
					otherInput.classList.remove("hide");
					otherInput.querySelector("input").focus();
					if (continueBtnWrapper) continueBtnWrapper.classList.remove("hide");
					this.$refs[`step${this.currentStepCount}`]
						.querySelector(".slide-content")
						.scrollBy(0, 1000);
					return;
				} else {
					if (otherInput) {
						otherInput.classList.add("hide");
						continueBtnWrapper.classList.add("hide");
					}
				}

				if (otherInput) otherInput.classList.replace("show", "hide");

				this.canMoveNext = false;
				setTimeout(async () => {
					if (
						this.currentStepCount == this.availableScreens.occupation &&
						this.isAlreadyCapshineUser
					) {
						if (
							this.userDetails.firstName == "" ||
							this.userDetails.firstName == null ||
							this.userDetails.firstName == "null" ||
							!this.userDetails.firstName
						)
							this.skipScreenTo(this.availableScreens.userName);
						else {
							this.enteredValues.userName = this.userDetails.firstName;
							if (
								this.userDetails.emailAddress == "" ||
								this.userDetails.emailAddress == null ||
								this.userDetails.emailAddress == "null" ||
								!this.userDetails.emailAddress
							)
								this.skipScreenTo(this.availableScreens.email);
							else {
								this.enteredValues.email = this.userDetails.emailAddress;
								if (this.isValidScreen()) {
									
									await this.RegisterForCapshineAndClub();
									//window.location.href = '/EnglishAssesment';
									this.redirectToNextPage(this.enteredValues.mobile);
								} else this.skipScreenTo(this.availableScreens.email);
							}
						}
					} else {
						switch (this.currentStepCount) {
							case this.availableScreens.occupation:
								GATrack.pushValues(
									"regnflow_profession",
									this.enteredValues.occupation,
									"Click_Regflo_Q6"
								);
								break;
							case this.availableScreens.language:
								GATrack.pushValues(
									"regnflow_language",
									this.enteredValues.language,
									"Click_Regflo_Q1"
								);
								break;
							case this.availableScreens.whyPractice:
								GATrack.pushValues(
									"regnflow_purpose",
									this.enteredValues.whyPractice,
									"Click_Regflo_Q2"
								);
								break;
							case this.availableScreens.gender:
								GATrack.pushValues(
									"regnflow_gender",
									this.enteredValues.gender,
									"Click_Regflo_Q4"
								);
								break;
							case this.availableScreens.age:
								GATrack.pushValues(
									"regnflow_age",
									this.enteredValues.age,
									"Click_Regflo_Q5"
								);
								break;
						}
						this.moveToNextScreen();
					}

					this.canMoveNext = true;
				}, 500);
			},
			onKeyupOther: function (event) {
				this.enteredValues[this.currentStepName] = event.currentTarget.value;
				this.hideErrorText();
			},
			isValidScreen: function () {
				let isValidInput = true;
				switch (this.currentStepName) {
					case "userName":
						if (!this.isValidName(this.enteredValues.userName)) {
							this.showErrorText("Invalid Name");
							isValidInput = false;
						}
						break;
					case "pincode":
						if (!this.validatePincode()) {
							this.showErrorText("Invalid Pincode");
							isValidInput = false;
						}
						break;
					case "mobile":
						if (
							!this.isValidMobileNumber(
								this.enteredValues.mobile,
								this.countryCode
							)
						) {
							this.showErrorText("Invalid Phone Number");
							isValidInput = false;
						}
						break;
					case "email":
						if (!this.isValidEMail(this.enteredValues.email)) {
							this.showErrorText("Invalid email Id");
							isValidInput = false;
						}
						break;
				}
				return isValidInput;
			},
			onClickContinue: async function () {
				if (this.isValidScreen()) {
					switch (this.currentStepName) {
						case "userName":
							if (this.isValidName(this.enteredValues.userName)) {
								if (this.isAlreadyCapshineUser) {
	                                let data = await this.checkAndUpdateName();

																	if (
										this.userDetails.emailAddress == "" ||
										this.userDetails.emailAddress == null ||
										this.userDetails.emailAddress == "null" ||
										!this.userDetails.emailAddress ||
										!this.userDetails.emailAddress.includes("@")
									)
										this.skipScreenTo(this.availableScreens.email);
									else {
										this.enteredValues.email = this.userDetails.emailAddress;
										if (this.isValidScreen()) {
											
											await this.RegisterForCapshineAndClub();
											//window.location.href = '/EnglishAssesment';
											this.redirectToNextPage(this.enteredValues.mobile);
										} else this.skipScreenTo(this.availableScreens.email);
									}
								} else this.moveToNextScreen();
							}
							break;
						case "mobile":
							let canMove = await this.requestForOtp();
							if (canMove) {
								GATrack.pushValues(
									"regnflow_mobile_number",
									this.enteredValues.mobile,
									"Click_Regflo_Mobileinput"
								);
								this.moveToNextScreen();
							} else this.showErrorText("Maximum Limit Reached");
							break;
						case "pincode":
							GATrack.pushValues(
								"regnflow_pincode",
								this.enteredValues.pincode,
								"Click_Regflo_Q3"
							);
							this.moveToNextScreen();
							break;
						case "email":
							if (this.isAlreadyCapshineUser) {
								let data = await this.checkAndUpdateEmail();
								if (data == 0) {
									this.showErrorText(
										"This Email is already associated with another account"
									);
									return;
								} else {
									
									await this.RegisterForCapshineAndClub();
									//window.location.href = '/EnglishAssesment';
									this.redirectToNextPage(this.enteredValues.mobile);
								}
							} else {
								let response = await this.checkAccountForEmail();
								if (response == 0) {
									this.showErrorText(
										"This Email is already associated with another account"
									);
									return;
								} else {
									
									await this.RegisterForCapshineAndClub();
									//window.location.href = '/EnglishAssesment';
									this.redirectToNextPage(this.enteredValues.mobile);
								}
							}
							break;
						case "occupation":
							GATrack.pushValues(
								"regnflow_profession",
								this.enteredValues.occupation,
								"Click_Regflo_Q6"
							);
							if (this.isAlreadyCapshineUser) {
								if (
									this.userDetails.firstName == "" ||
									this.userDetails.firstName == null ||
									this.userDetails.firstName == "null" ||
									!this.userDetails.firstName
								)
									this.skipScreenTo(this.availableScreens.userName);
								else {
									this.enteredValues.userName = this.userDetails.firstName;
									if (
										this.userDetails.emailAddress == "" ||
										this.userDetails.emailAddress == null ||
										this.userDetails.emailAddress == "null" ||
										!this.userDetails.emailAddress
									)
										this.skipScreenTo(this.availableScreens.email);
									else {
										this.enteredValues.email = this.userDetails.emailAddress;
										if (this.isValidScreen()) {
											
											await this.RegisterForCapshineAndClub();
											//window.location.href = '/EnglishAssesment';
											this.redirectToNextPage(this.enteredValues.mobile);
										} else this.skipScreenTo(this.availableScreens.email);
									}
								}
							} else {
								this.moveToNextScreen();
							}
							break;
						case "language":
							GATrack.pushValues(
								"regnflow_language",
								this.enteredValues.language,
								"Click_Regflo_Q1"
							);
							this.moveToNextScreen();
							break;
						case "whyPractice":
							GATrack.pushValues(
								"regnflow_purpose",
								this.enteredValues.whyPractice,
								"Click_Regflo_Q2"
							);
							this.moveToNextScreen();
							break;
					}
					//this.moveToNextScreen();
				} else {
				}
			},
			validatePincode: function () {
				return (
					this.enteredValues.pincode && this.enteredValues.pincode.length == 6
				);
			},
			showSubmitBtn: function (step) {
				this.$refs[step]?.querySelector(".slide-action");
			},
			pincodeSelectionCallBack(code) {
				this.enteredValues.pincode = code;
			},
			requestForOtp: async function () {
				let requestData = {
					MobileNumber: this.enteredValues.mobile,
					CountryCode: this.countryCode,
				};
				// this.initOtpTimer = false;
				return new Promise((resolve) => {
					CSMainAPIs.Capshine.APIs.SendOtp.execute(requestData, (response) => {
						if (
							response.data.mobileVerificationStatus == "VerificationCodeSent"
						) {
							this.initOtpTimer = true;
							resolve(true);
						} else if (response.data.mobileVerificationStatus == "Limit") {
							resolve(false);
						}
					});
				});
			},
			showErrorText: function (errorText) {
				let errorTextNode =
					this.$refs[`step${this.currentStepCount}`].querySelector(".error-text");
				if (errorText) {
					errorTextNode.innerText = errorText;
				}
				errorTextNode?.classList.add("show");
			},
			hideErrorText: function () {
				let textNode =
					this.$refs[`step${this.currentStepCount}`].querySelector(".error-text");
				if (textNode) {
					textNode.classList.remove("show");
				}
			},
			onOtpSuccess: function () { },
			checkIfAlreadyRegistered: async function () {
				CSMainAPIs.Capshine.APIs.CheckIfAlreadyRegistered.execute(
					{ mobileNumber: this.enteredValues.mobile },
					async (response) => {
						let data = response.data;
						this.isAlreadyCapshineUser = data.isAlreadyCapshineUser;
						this.isAlreadyClubMember = data.isAlreadyClubMember;
						this.userpid = data.userPid;

					

						//data.isAlreadyClubMember = false;

						//if (data.isAlreadyCapshineUser && !this.isUserLoggedIn) {
						//	await this.autoLogin(data.mobileNumber);
						//	document.getElementById("hdnUserPid").value = data.userPid;
						//}
						debugger;

						if (data.isAlreadyCapshineUser && data.isAlreadyClubMember) {
							//window.location.href = '/EnglishAssesment';
							this.redirectToNextPage(this.enteredValues.mobile);
						}
						else if (data.firstName==""){
								this.userDetails = response.data;
				        		//this.enteredValues.mobile = this.userDetails.mobileNumber;
						        this.userpid = this.userDetails.pid;
								this.skipScreenTo(this.availableScreens.userName);
						}
						else if (
							(data.isAlreadyCapshineUser && !data.emailAddress) ||
							(data.emailAddress && !data.emailAddress.includes("@"))
						) {
							this.userDetails = response.data;
							this.skipScreenTo(this.availableScreens.email);
							if (!this.skippedScreens.includes(this.availableScreens.userName))
								 this.skippedScreens.push(this.availableScreens.userName);
							     this.firstStep = this.availableScreens.email;
						}
					
						else if (data.isAlreadyCapshineUser && !data.isAlreadyClubMember) {
							
							await this.RegisterForCapshineAndClub();
							//window.location.href = '/EnglishAssesment';
							this.redirectToNextPage(this.enteredValues.mobile);
						} else {
							this.moveToNextScreen();
						}
					}
				);
			},
			onCountryCodeBlur: function () {
				this.showCountrySearch = false;
			},
			openCountrySearch: function () {
				this.showCountrySearch = !this.showCountrySearch;
			},
			countryCodeSelectionCallBack(countrycode) {
				this.showCountrySearch = false;
				this.countryCode = countrycode;
			},
			RegisterForCapshineAndClub: async function () {
				let requestData = this.createRequestData();
				debugger;

				await new Promise((resolve, reject) => {
					CSMainAPIs.Capshine.APIs.RegisterForCapshineAndClub.execute(
						requestData,
						(response) => {
							resolve(true);
						}
					);
				});

				if (window.fbq) {
					window.fbq("track", "SubmitApplication");
				}
				if (window.gtag) {
					window.gtag("event", "conversion", {
						send_to: "AW-1044658860/QukBCMfhneoBEKz1kPID",
					});
				}
			},
			createRequestData() {
				return {
					CountryCode: this.countryCode,
					Email: this.enteredValues.email,
					Mobile: this.enteredValues.mobile,
					Name: this.enteredValues.userName,
					PinCode: this.enteredValues.pincode,
					UserPid: this.userpid ? this.userpid : 0,
					PreferredLanguage: this.enteredValues.language,
					Gender: this.enteredValues.gender,
					AgeGroup: this.enteredValues.age,
					Occupation: this.enteredValues.occupation,
					Reason: this.enteredValues.whyPractice,
					/*PreferredClassTiming: this.enteredValues.PreferredTime,*/
					/*PreferredDay: this.enteredValues.PreferredDay,*/
					isCapshineSignUp: !this.isAlreadyCapshineUser,
					isClubSignUp: !this.isAlreadyClubMember,
					isUserLoggedIn: this.isUserLoggedIn,
					Source: this.pageSource || "Mobile",
					// clubId: this.selectedValues.clubId,
				};
			},
			checkAccountForEmail: async function () {
				return new Promise((resolve, reject) => {
					
					CSMainAPIs.Capshine.APIs.checkAccountForEmail.execute(
						{ emailId: this.enteredValues.email },
						(response) => {
							resolve(response.data);
						}
					);
				});
			},
			checkAndUpdateEmail: async function () {
				let requestData = {
					emailId: this.enteredValues.email,
					userPid:this.userDetails.userPid,
				};

				return new Promise((resolve, reject) => {
					CSMainAPIs.Capshine.APIs.CheckAndUpdateEmail.execute(
						requestData,
						(response) => {
							resolve(response.data);
						}
					);
				});


				//Loader.showAboveModal();
				//let response = await fetch("/api/userlogin/CheckAndUpdateEmail", requestOptions);
				//let data = await response.json();
				//Loader.hideAboveModal();

				//return data;
			},

			checkAndUpdateName: async function () {
				let requestData = {
					userName: this.enteredValues.userName,
					userPid:this.userDetails.userPid
				};

				return new Promise((resolve, reject) => {
					CSMainAPIs.Capshine.APIs.CheckAndUpdateUserName.execute(
						requestData,
						(response) => {
							resolve(response.data);
						}
					);
				});

			},
			trueCallerVerification: function () {
				const UNIQUE_REQUEST_ID = Math.floor(10000000 + Math.random() * 90000000); // eight digit random ID
				this.trueCallerUniqueId = UNIQUE_REQUEST_ID;
				const PARTNER_KEY = "ZN1gnc5652a648e8e45c682b943c8fab24ea0";
				const APP_NAME = "capshine";
				const LANGUAGE_LOCALE = "en";
				const TITLE_STRING = "Verify your mobile number";
				const LOGIN_SUFFIX = "signin";
				const CTA_COLOR = "%23ff7a21";
				window.location = `truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=${UNIQUE_REQUEST_ID}&partnerKey=${PARTNER_KEY}&partnerName=${APP_NAME}&lang=${LANGUAGE_LOCALE}&title=${TITLE_STRING}&loginSuffix=${LOGIN_SUFFIX}&ctaColor=${CTA_COLOR}&skipOption=useanothernum`;

				setTimeout(() => {
					if (document.hasFocus()) {
						// Truecaller app not present on the device and you redirect the user
						// to your alternate verification page
					} else {
						// Truecaller app present on the device and the profile overlay opens
						// The user clicks on verify & you'll receive the user's access token to fetch the profile on your
						// callback URL - post which, you can refresh the session at your frontend and complete the user  verification

						this.trueCallerUserDetailsCheckTimerId = setInterval(() => {
							this.checkForTrueCallerUserDetails();
						}, 3000);
					}
				}, 600);
			},
			checkForTrueCallerUserDetails: async function () {
				this.trueCallerUserDetailsCheckTimerCount++;
				let data = await this.getTrueCallerDetailsForAuthId();
				if (data != null) {
					if (
						data.responseStatus == "user_rejected" ||
						data.responseStatus == "used_another_number"
					) {
						clearInterval(this.trueCallerUserDetailsCheckTimerId);
					} else if (data != null && data.mobileNumber != null) {
						this.userDetails.mobileNo = data.mobileNumber;
						this.userDetails.emailId = data.emailId;
						this.userDetails.countryCode = "+" + data.countryCode;
						this.userDetails.userName = data.name;
						clearInterval(this.trueCallerUserDetailsCheckTimerId);

						this.checkIfAlreadyRegistered();
					}
					//else if (this.trueCallerUserDetailsCheckTimerCount > 5) {
					//    if (!this.userDetails.mobileNo) {
					//        alert("True caller authentication failed, please proceed with the form");
					//    }
					//    Loader.hideAboveModal();
					//    clearInterval(this.trueCallerUserDetailsCheckTimerId);
					//}
				}
			},
			getUserInfo: function (pId) {
				CSMainAPIs.Capshine.APIs.GetUserInfo.execute(
					{ UserPid: pId },
					(response) => {
						this.userDetails = response.data;
						this.enteredValues.mobile = this.userDetails.mobileNumber;
						this.userpid = this.userDetails.pid;
					}
				);
			},
			getTrueCallerDetailsForAuthId: async function () {
				let url = `/truecaller-sdk/GetTrueCallerDetails?authId=${this.trueCallerUniqueId}`;
				let response = await (url);
				let data = await response.json();
				return data;
			},
			updateProgressBar: function () {
				this.$refs.progress.style.width = this.getProgressWidth();
			},
			getProgressWidth: function () {
				return `${(100 / this.totalStepCount) * this.currentStepCount}%`;
			},
			redirectToNextPage: function (mobile) {



				setTimeout(() => {

					if (this.setUserInfo) { this.setUserInfo(mobile); }
					else {
						var apiInput = {
							"Mobilenumber": mobile,
							"UserPid": "",
							"LoginUser": true
						};

						CSMainAPIs.Capshine.APIs.GetUserInfo.execute(apiInput, this._afterGetUserInfoLoad);
						//window.location.href = "/EnglishAssesment";

					}
				}, 2000);
			},
			async _afterGetUserInfoLoad(response) {
				
				const userResponseData = response.data;

				if (userResponseData.pid > 0) {




					var clubUserType = userResponseData.clubUserType;
					var clubUserLevel = userResponseData.clubUserLevel;

					if (clubUserLevel == "0") {
						window.location.href = "/englishassesment";
					}
					else if (clubUserType == "0") {
						window.location.href = "/paymentplans";
					}
					else {
						window.location.href = "/";
					}
				}
			},
			termsClick() {
				CSMainAPIs.Capshine.APIs.GetTermsContent.execute({}, (response) => {
					if (response.res.status == 200) {
						let currentSlide = this.$refs.step8;
						let nextSlide = this.$refs.termsPrivacyContent;
						nextSlide.querySelector('.slide-content').innerHTML = response.data;
						currentSlide.classList.replace("current-slide", "previous-slide");
						nextSlide.classList.replace("next-slide", "current-slide");
						this.isTermsPrivacyPage = true;
						this.termsPrivacyPageHeader = 'Terms of Service';
						if (!this.$refs.header.classList.contains("hide"))
							this.$refs.header.classList.add("hide");
					}
				});
			},
			privacyClick() {
				CSMainAPIs.Capshine.APIs.GetPrivacyPolicyContent.execute({}, (response) => {
					if (response.res.status == 200) {
						let currentSlide = this.$refs.step8;
						let nextSlide = this.$refs.termsPrivacyContent;
						nextSlide.querySelector('.slide-content').innerHTML = response.data;
						currentSlide.classList.replace("current-slide", "previous-slide");
						nextSlide.classList.replace("next-slide", "current-slide");
						this.isTermsPrivacyPage = true;
						this.termsPrivacyPageHeader = 'Privacy Policy';
						if (!this.$refs.header.classList.contains("hide"))
							this.$refs.header.classList.add("hide");
					}
				});
			},
			onClickBackMobileNo() {
				let currentSlide = this.$refs.termsPrivacyContent;
				let previousSlide = this.$refs.step8;
				currentSlide.classList.replace("current-slide", "next-slide");
				previousSlide.classList.replace("previous-slide", "current-slide");
				this.isTermsPrivacyPage = false;
				this.termsPrivacyPageHeader = '';
				this.$refs.header.classList.remove('hide');
			}
		},
		computed: {
			pincodeContinueClass() {
				return this.enteredValues.pincode &&
					this.enteredValues.pincode.length == 6
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			mobileContinueClass() {
				return this.enteredValues.mobile
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			nameContinueClass() {
				return this.enteredValues.userName
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			emailContinueClass() {
				return this.enteredValues.email
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			languageContinueClass() {
				return this.enteredValues.language
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			whyPracticeContinueClass() {
				return this.enteredValues.whyPractice
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
			occupationContinueClass() {
				return this.enteredValues.occupation
					? this.btnEnabledClass
					: this.btnDisabledClass;
			},
		},
		watch: {
			currentStepCount: function (newVal, oldVal) {
				if (newVal == 1) {
					if (!this.$refs.header.classList.contains("invisible"))
						this.$refs.header.classList.add("invisible");
				} else {
					if (this.$refs.header.classList.contains("invisible"))
						this.$refs.header.classList.remove("invisible");
				}
				this.updateProgressBar();
			},
		},
	});

;// CONCATENATED MODULE: ./src/Components/ClubRegistration.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/ClubRegistration.vue




;
const ClubRegistration_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ClubRegistrationvue_type_script_lang_js, [['render',ClubRegistrationvue_type_template_id_46dea3c6_render]])

/* harmony default export */ const ClubRegistration = (ClubRegistration_exports_);
;// CONCATENATED MODULE: ./src/js/DailyActivity.js
﻿

let DailyActivity = {
	recordClicked: false,
	audioChunks: [],
	base64Blob: [],
	audioBlob: [],
	mediaRecorder: null,
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	init: function (userPid, sulekhaApp = null) {
		DailyActivity.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				DailyActivity.isMobileApp = true;
			}
			else {
				DailyActivity.isMobileApp = false;
			}
		}
		this.userPid = userPid;
		this.bindEvents();
		this.BindViewDailyActivityBtn();
	},
	BindViewDailyActivityBtn: function () {
		var viewDABtn = document.querySelector("#viewDailyActivity");
		if (viewDABtn) {
			viewDABtn.addEventListener("click", function () {
				var activityId = viewDABtn.getAttribute("data-ActivityId");
				CSMainAPIs.Capshine.APIs.GetDailyActivity.execute({ activityid: activityId, userpid: parseInt(DailyActivity.userPid) }, DailyActivity.getdailyactivityresponse);
			});
		}

		var lnkdailyactivitydetails = document.getElementById("lnkdailyactivitydetails");
		if (lnkdailyactivitydetails) {
			lnkdailyactivitydetails.addEventListener("click", function () {
				// const userType = lnkdailyactivitydetails.getAttribute('data-userType');
				// if (userType.toLowerCase() == 'limited') {
				// 	if (DailyActivity.isMobileApp) {
				// 		DailyActivity.sulekhaApp.navigateTo(MobilePages.paymentUpgradeRequest, { pageType: 7 });
				// 	} else {
				// 		window.location.href = "/paymentUpgradeRequest?pageType=7";
				// 	}
				// }
				// else {
					if (DailyActivity.isMobileApp) {
						DailyActivity.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivitydetails, null)
					} else {
						window.location.href = "/dailyactivitydetails"
					}
				// }
			})

		}

		var lnkdailyactivityresponse = document.getElementById("lnkdailyactivityresponse");
		if (lnkdailyactivityresponse) {
			lnkdailyactivityresponse.addEventListener("click", function () {
				var activityid = lnkdailyactivityresponse.getAttribute('data-activityid');
				if (DailyActivity.isMobileApp) {
					DailyActivity.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivityresponse, { activityid: activityid });
				} else {
					window.location.href = "/dailyActivityresponse?activityid=" + activityid;
				}
			})
		}
	},
	getdailyactivityresponse: function (response) {
		if (response.data) {
			const data = response.data;
			if (data.activitystatus == 'ActivityDone') {
				DailyActivity.hideCardParticipate();
			}
			else {
				if (DailyActivity.isMobileApp) {
					DailyActivity.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivity, { activityid: data.activityId });
				} else {
					location.href = '/dailyactivity?activityid=' + data.activityId;
				}
			}
		}
	},
	bindEvents: function () {
		let recordingBtn = document.getElementById("mic-recording");
		if (recordingBtn) {
			recordingBtn.addEventListener("click", function () {
				if (DailyActivity.recordClicked)
					DailyActivity.stopRecording();
				else
					DailyActivity.startRecording();
			});
		}
		let subBtn = document.getElementById("submit-btn-activity");
		if (subBtn) {
			subBtn.addEventListener("click", function () {
				subBtn.setAttribute('disabled', '');
				DailyActivity.saveAnswer();
			});
		}
		let subPhoneticsBtn = document.getElementById("submit-btn-phonetics-activity");
		if (subPhoneticsBtn) {
			subPhoneticsBtn.addEventListener("click", function () {
				subPhoneticsBtn.setAttribute('disabled', '');
				DailyActivity.submitRecording();
			});
		}
		let subJumbledBtn = document.getElementById("submit-btn-jumbled-activity");
		if (subJumbledBtn) {
			subJumbledBtn.addEventListener("click", function () {
				subJumbledBtn.setAttribute('disabled', '');
				DailyActivity.GetJumbledWordAnswers(subJumbledBtn);
				DailyActivity.saveAnswer();
			});
		}
		let hintBtn = document.getElementById("jumbled-hint-btn");
		if (hintBtn) {
			let firstWordHintDone = false;
			let secondWordHintDone = false;
			var hintValue = parseInt(document.querySelector("#jumbled-hint-btn span").innerHTML);
			var answers = document.getElementById("jumbled-word-answers").value;
			document.getElementById("jumbled-word-answers").remove();
			hintBtn.addEventListener("mousedown", function () {
				if (hintValue > 0) {
					let activeEle = document.activeElement;
					if (activeEle) {
						if (activeEle.tagName.toLowerCase() == 'input') {
							let locationIndex = parseInt(activeEle.getAttribute('data-runningCount'));
							let eleNameValue = parseInt(activeEle.name.replace('word', ''));
							let answerArray = answers.split(',')[eleNameValue - 1].trim().split('');
							if (answerArray.length > 0) {
								if (eleNameValue == 1) {
									if (firstWordHintDone)
										return;
									else
										firstWordHintDone = true
								}
								else if (eleNameValue == 2) {
									if (secondWordHintDone)
										return;
									else
										secondWordHintDone = true
								}
								activeEle.value = answerArray[locationIndex];
								hintValue--;
								document.querySelector("#jumbled-hint-btn span").innerHTML = hintValue.toString();
							}
						}
						else {
							document.getElementById('hint-validation-text').innerHTML = 'Please click the input & click hint...';
							if (document.getElementById('hint-validation-text').classList.contains('error-text')) {
								document.getElementById('hint-validation-text').style.display = "block";
								setTimeout(function () {
									document.getElementById('hint-validation-text').style.display = "";
								}, 5000);
							}
						}
					}
				}
				else {
					document.getElementById('hint-validation-text').innerHTML = 'Given HINT count is over...';
					if (document.getElementById('hint-validation-text').classList.contains('error-text')) {
						document.getElementById('hint-validation-text').style.display = "block";
						setTimeout(function () {
							document.getElementById('hint-validation-text').style.display = "";
						}, 5000);
					}
				}
			});
		}
		let bindDataSelect = document.querySelectorAll('#select-options li');
		if (bindDataSelect) {
			bindDataSelect.forEach((clickitem) => {
				clickitem.addEventListener("click", function () {
					bindDataSelect.forEach((e) => {
						if (e.className.includes('selected')) {
							e.classList.remove('selected', 'animate__animated', 'animate__pulse', 'animate__faster');
						}
					});
					clickitem.classList.add('selected', 'animate__animated', 'animate__pulse', 'animate__faster');
					document.getElementById('selected-answer').value = clickitem.innerText;
					document.getElementById('validation-text').style.display = "";
				});
			});
		}
		let bindDataEnter = document.querySelector('#enter-answer');
		if (bindDataEnter) {
			bindDataEnter.addEventListener("change", function () {
				document.getElementById('selected-answer').value = bindDataEnter.value;
				if (bindDataEnter.value == '' || bindDataEnter.value == null)
					document.getElementById('validation-text').style.display = "block";
				else
					document.getElementById('validation-text').style.display = "";
			});
		}
		let jumbledInp = document.querySelectorAll("[data-jumbledInput]");
		if (jumbledInp) {
			if (document.getElementById('jumbledInput1'))
				document.getElementById('jumbledInput1').focus();
			let jumbledWordEle = document.getElementById('displayWord');
			if (jumbledWordEle) {
				let jumbledWords = String(jumbledWordEle.innerText).toLowerCase().trim().split('');
				let jumbledCharCodeArr = [];
				jumbledWords.forEach(item => {
					jumbledCharCodeArr.push(parseInt(item.charCodeAt(0)));
					jumbledCharCodeArr.push(parseInt(item.toUpperCase().charCodeAt(0)));
				});
				jumbledInp.forEach(item => {
					if (item) {
						var IsKeyDownPreventDefault = false;
						item.addEventListener("keyup", function (e) {
							if (this.value.length > 0) {
								var kc = e.keyCode || e.which;
								if (kc == 0 || kc == 229) { //for android chrome keycode fix
									IsKeyDownPreventDefault = false;
									if (this.value.length > 1) {
										document.getElementById(String(e.target.id)).value = this.value.substring(0, 1);
									}
									else {
										kc = this.value.charCodeAt(this.value.length - 1);
										if (jumbledCharCodeArr.includes(kc)) {
											let inputEnterd = [];
											let jumbledWordsCheck = String(document.getElementById('displayWord').innerText).toLowerCase().trim().split('');
											jumbledInp.forEach(inp => { if (inp.value && inp.id != e.target.id) inputEnterd.push(inp.value.toLowerCase().trim()); });
											inputEnterd.forEach(val => { if (jumbledWordsCheck.includes(val)) jumbledWordsCheck.splice(jumbledWordsCheck.indexOf(val), 1) });
											if (!jumbledWordsCheck.includes(String.fromCharCode(kc).toLowerCase())) {
												IsKeyDownPreventDefault = true;
												document.getElementById(String(e.target.id)).value = "";
											}
										}
										else {
											IsKeyDownPreventDefault = true;
											document.getElementById(String(e.target.id)).value = "";
										}
									}
								}
								if (!IsKeyDownPreventDefault) {
									DailyActivity.GetJumbledWordAnswers(document.getElementById("submit-btn-jumbled-activity"));
									let answer = document.getElementById('selected-answer').value.trim();
									if (answer != '') {
										document.getElementById('validation-text').style.display = "";
									}
									if (kc != 46 && kc != 8 && kc != 37 && kc != 38 && kc != 39 && kc != 40) {
										let nextId = parseInt(String(e.target.id).replace('jumbledInput', '')) + 1;
										var nextInput = document.getElementById("jumbledInput" + nextId + "");
										if (nextInput)
											nextInput.focus();
										else
											document.getElementById("submit-btn-jumbled-activity").focus();
									}
								}
							}
						});
						item.addEventListener("keydown", function (e) {
							IsKeyDownPreventDefault = false;
							var kc = e.keyCode || e.which;
							if (kc == 0 || kc == 229) { //for android chrome keycode fix
								kc = this.value.charCodeAt(this.value.length - 1);
							}
							if ((jumbledCharCodeArr.includes(kc)) || kc == 46 || kc == 8 || kc == 37 || kc == 38 || kc == 39 || kc == 40) {
								if (jumbledCharCodeArr.includes(kc)) {
									let inputEnterd = [];
									let jumbledWordsCheck = String(document.getElementById('displayWord').innerText).toLowerCase().trim().split('');
									jumbledInp.forEach(inp => { if (inp.value) inputEnterd.push(inp.value.toLowerCase().trim()); });
									inputEnterd.forEach(val => { if (jumbledWordsCheck.includes(val)) jumbledWordsCheck.splice(jumbledWordsCheck.indexOf(val), 1) });
									if (!jumbledWordsCheck.includes(String.fromCharCode(kc).toLowerCase())) {
										IsKeyDownPreventDefault = true;
										e.preventDefault();
									}
								}
							}
							else {
								IsKeyDownPreventDefault = true;
								e.preventDefault();
							}
						});
					}
				});
			}
		}
		let backBtn = document.getElementById("dailyActivityBackBtn");
		if (backBtn) {
			backBtn.addEventListener("click", function () {
				if (DailyActivity.isMobileApp) {
					DailyActivity.sulekhaApp.navigateBack();
				} else {
					history.back();
				}
			});
		}
	},
	startRecording: function () {
		let error = document.getElementById('error-text');
		if (error) {
			error.style.display = '';
			error.innerHTML = '';
		}
		let audioDiv = document.querySelector('#speaker-phonetics');
		if (audioDiv) {
			if (!audioDiv.classList.contains('hide'))
				audioDiv.classList.add('hide');
		}
		DailyActivity.audioChunks = [];
		DailyActivity.base64Blob = [];
		navigator.mediaDevices.getUserMedia({ audio: true })
			.then(stream => {
				DailyActivity.mediaRecorder = new MediaRecorder(stream);
				DailyActivity.mediaRecorder.start();
				DailyActivity.mediaRecorder.addEventListener("dataavailable", event => {
					DailyActivity.audioChunks.push(event.data);
				});

				DailyActivity.mediaRecorder.addEventListener("stop", () => {
					DailyActivity.audioBlob = new Blob(DailyActivity.audioChunks, { type: "audio/mp3" });
					const audioUrl = URL.createObjectURL(DailyActivity.audioBlob);
					document.getElementById('audioPlayRecord').setAttribute('src', audioUrl);
					let subPhoneticsBtn = document.getElementById("submit-btn-phonetics-activity");
					if (subPhoneticsBtn) {
						subPhoneticsBtn.classList.remove('disabled');
					}
				});
				DailyActivity.recordClicked = true;
				document.querySelector('#mic-recording svg').classList.add('Record');
				let info = document.querySelector('#info-text-record');
				if (info) {
					info.innerHTML = 'Stop';
				}
			}).catch(function (err) {
				let errStrng = String(err);
				DailyActivity.mediaRecorder = null;
				DailyActivity.recordClicked = false;
				if (document.querySelector('#mic-recording svg').classList.contains('Record'))
					document.querySelector('#mic-recording svg').classList.remove('Record');
				if (error) {
					error.style.display = 'block';
					if (errStrng.includes('Permission denied')) {
						error.innerHTML = 'Permission denied, Please allow mic permission in the browser...';
					}
					else if (errStrng.includes('Requested device not found')) {
						error.innerHTML = 'Mic not found in your Device...';
					}
					else if (errStrng.split(':').length > 1) {
						error.innerHTML = errStrng.split(':')[1];
					}
					else {
						error.innerHTML = errStrng;
					}
				}
			});
	},
	blobToBase64: function (blob) {
		return new Promise((resolve, _) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.readAsDataURL(blob);
		});
	},
	stopRecording: function () {
		DailyActivity.mediaRecorder.stop();
		DailyActivity.recordClicked = false;
		if (document.querySelector('#mic-recording svg').classList.contains('Record'))
			document.querySelector('#mic-recording svg').classList.remove('Record');
		let audioDiv = document.querySelector('#speaker-phonetics');
		if (audioDiv) {
			if (audioDiv.classList.contains('hide'))
				audioDiv.classList.remove('hide');
			let info = document.querySelector('#info-text-record');
			if (info) {
				info.innerHTML = 'Record Again';
			}
		}
	},
	submitRecording: function () {
		var base64fun = DailyActivity.blobToBase64(DailyActivity.audioBlob);
		base64fun.then(data => {
			let activityTypeId = document.querySelector('[data-dailyactivityTypeId]').getAttribute('data-dailyactivityTypeId');
			let activityId = document.getElementById('dailyActivityId').value;
			var obj = {
				DailyActivityType: parseInt(activityTypeId),
				RowId: parseInt(activityId),
				UserPid: DailyActivity.userPid,
				Data: data.split(',')[1],
			};
			CSMainAPIs.Capshine.APIs.DailyAcitivitySaveRecording.execute(obj, DailyActivity.saveResponse);
		});
	},
	saveResponse: function (response) {
		let activityId = document.getElementById('dailyActivityId').value;
		if (response.data == 1) {
			DailyActivity.hideCardParticipate();
			document.querySelector("#modalDailyActivity").classList.remove("show");
			if (DailyActivity.isMobileApp) {
				DailyActivity.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivityresponse, { activityid: activityId });
			} else {
				window.location.replace("/dailyactivityresponse?activityid=" + activityId);
			}
		}
	},
	hideCardParticipate: function () {
		const activitycontent = document.querySelectorAll('#d-activity-content-div [data-showactivitycontent]');
		if (activitycontent) {
			activitycontent.forEach(e => e.classList.add('hide'));
		}
		const responsecontent = document.querySelectorAll('#d-activity-content-div [data-responsecontent]');
		if (responsecontent) {
			responsecontent.forEach(e => e.classList.remove('hide'));
		}
	},
	saveAnswer: function () {
		let activityTypeId = document.querySelector('[data-dailyactivityTypeId]').getAttribute('data-dailyactivityTypeId');
		let activityId = document.getElementById('dailyActivityId').value;
		let answer = document.getElementById('selected-answer').value.trim();
		if (answer == '' || answer == null) {
			document.getElementById('validation-text').style.display = "block";
			if (document.getElementById("submit-btn-phonetics-activity"))
				document.getElementById("submit-btn-phonetics-activity").removeAttribute('disabled');
			else if (document.getElementById("submit-btn-activity"))
				document.getElementById("submit-btn-activity").removeAttribute('disabled');
		}
		else {
			document.getElementById('validation-text').style.display = "";
			var obj = {
				DailyActivityType: parseInt(activityTypeId),
				RowId: parseInt(activityId),
				UserPid: DailyActivity.userPid,
				Answer: answer,
			};
			CSMainAPIs.Capshine.APIs.DailyAcitivitySaveAnswer.execute(obj, DailyActivity.saveResponse);
		}
	},
	GetJumbledWordAnswers(subJumbledBtn) {
		let jumbledWordCount = subJumbledBtn.getAttribute('data-jumbledwordcount');
		let jumbledAnswerCount = subJumbledBtn.getAttribute('data-jumbledAnswercount');
		let answers = [];
		for (var i = 1; i <= jumbledAnswerCount; i++) {
			const answer = Array.from(document.querySelectorAll('input[name="word' + i + '[]"'), ({ value }) => value.trim()).join('');
			if (answer.length != jumbledWordCount) {
			}
			else {
				answers.push(answer.toLowerCase());
			}
		}
		if (answers.length > 0)
			if (answers.length == 1)
				document.getElementById('selected-answer').value = answers[0];
			else
				document.getElementById('selected-answer').value = answers.join(',');
		else
			document.getElementById('selected-answer').value = '';
	},
}
/* harmony default export */ const js_DailyActivity = (DailyActivity);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ResponseComments.vue?vue&type=template&id=51e68247


const ResponseCommentsvue_type_template_id_51e68247_hoisted_1 = {
  class: "comments-activity",
  id: "response-page-comments"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_2 = { class: "response-header title-large" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_3 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#backarrowm" }, null, -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_4 = [
  ResponseCommentsvue_type_template_id_51e68247_hoisted_3
]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_5 = /*#__PURE__*/(0,vue_cjs.createTextVNode)(" Comments ")
const ResponseCommentsvue_type_template_id_51e68247_hoisted_6 = { class: "activity-comments" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_7 = { class: "comment-information" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_8 = { class: "title-large" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_9 = { class: "hour" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_10 = {
  key: 0,
  class: "answer"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_11 = /*#__PURE__*/(0,vue_cjs.createTextVNode)(" Answered: Play Audio ")
const ResponseCommentsvue_type_template_id_51e68247_hoisted_12 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  onclick: "document.getElementById('playAnswerAudio').play()",
  class: "speaker",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#ff7a21",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconspeaker" })
], -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_13 = {
  controls: "",
  hidden: "",
  id: "playAnswerAudio"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_14 = ["src"]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_15 = {
  key: 1,
  class: "answer"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_16 = {
  key: 0,
  class: "right",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#ffffff"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_17 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcheckanswer" }, null, -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_18 = [
  ResponseCommentsvue_type_template_id_51e68247_hoisted_17
]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_19 = {
  key: 1,
  class: "wrong",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_20 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcross" }, null, -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_21 = [
  ResponseCommentsvue_type_template_id_51e68247_hoisted_20
]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_22 = { class: "current-reply" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_23 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcomment" })
], -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_24 = /*#__PURE__*/(0,vue_cjs.createTextVNode)(" Comment ")
const ResponseCommentsvue_type_template_id_51e68247_hoisted_25 = [
  ResponseCommentsvue_type_template_id_51e68247_hoisted_23,
  ResponseCommentsvue_type_template_id_51e68247_hoisted_24
]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_26 = {
  key: 0,
  class: "comment-title title-large"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_27 = {
  key: 1,
  class: "comment-title title-large"
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_28 = {
  key: 2,
  hidden: ""
}
const ResponseCommentsvue_type_template_id_51e68247_hoisted_29 = ["id"]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_30 = { class: "hour" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_31 = { class: "like-reply" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_32 = ["onClick"]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_33 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconlikee" })
], -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_34 = ["onClick"]
const ResponseCommentsvue_type_template_id_51e68247_hoisted_35 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcomment" })
], -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_36 = { class: "comment-bottom-sheet" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_37 = { class: "bottom-comment" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_38 = { class: "type-comment" }
const ResponseCommentsvue_type_template_id_51e68247_hoisted_39 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("textarea", {
  id: "reply-comment",
  placeholder: "Add your comment"
}, null, -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_40 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconentercomment" }, null, -1)
const ResponseCommentsvue_type_template_id_51e68247_hoisted_41 = [
  ResponseCommentsvue_type_template_id_51e68247_hoisted_40
]

function ResponseCommentsvue_type_template_id_51e68247_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_1, [
    (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_2, [
      ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
        class: "comments-back",
        onClick: _cache[0] || (_cache[0] = $event => ($options.closeComments())),
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "#000000",
        viewBox: "0 0 256 256"
      }, ResponseCommentsvue_type_template_id_51e68247_hoisted_4)),
      ResponseCommentsvue_type_template_id_51e68247_hoisted_5
    ]),
    (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_6, [
      (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_7, [
        (0,vue_cjs.createElementVNode)("h5", ResponseCommentsvue_type_template_id_51e68247_hoisted_8, (0,vue_cjs.toDisplayString)($props.answeredName), 1),
        (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_9, (0,vue_cjs.toDisplayString)($props.answeredTime), 1),
        ($props.playButtonBlobUrl != '')
          ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", ResponseCommentsvue_type_template_id_51e68247_hoisted_10, [
              ResponseCommentsvue_type_template_id_51e68247_hoisted_11,
              ResponseCommentsvue_type_template_id_51e68247_hoisted_12,
              (0,vue_cjs.createElementVNode)("audio", ResponseCommentsvue_type_template_id_51e68247_hoisted_13, [
                (0,vue_cjs.createElementVNode)("source", {
                  src: $props.playButtonBlobUrl,
                  type: "audio/mp3"
                }, null, 8, ResponseCommentsvue_type_template_id_51e68247_hoisted_14)
              ])
            ]))
          : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", ResponseCommentsvue_type_template_id_51e68247_hoisted_15, [
              (0,vue_cjs.createTextVNode)(" Answered: " + (0,vue_cjs.toDisplayString)($props.answer) + " ", 1),
              ([4,6,7].includes($props.activityTypeId) && ($props.isCorrectAnswer == 1))
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", ResponseCommentsvue_type_template_id_51e68247_hoisted_16, ResponseCommentsvue_type_template_id_51e68247_hoisted_18))
                : (0,vue_cjs.createCommentVNode)("", true),
              ([4,6,7].includes($props.activityTypeId) && ($props.isCorrectAnswer == 0))
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", ResponseCommentsvue_type_template_id_51e68247_hoisted_19, ResponseCommentsvue_type_template_id_51e68247_hoisted_21))
                : (0,vue_cjs.createCommentVNode)("", true)
            ])),
        (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_22, [
          (0,vue_cjs.createElementVNode)("a", {
            onClick: _cache[1] || (_cache[1] = $event => ($options.replyClick($props.answeredName,'0')))
          }, ResponseCommentsvue_type_template_id_51e68247_hoisted_25)
        ])
      ]),
      ($data.totalComments > 1)
        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_26, (0,vue_cjs.toDisplayString)($data.totalComments) + " Comments", 1))
        : (0,vue_cjs.createCommentVNode)("", true),
      ($data.totalComments == 1)
        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_27, (0,vue_cjs.toDisplayString)($data.totalComments) + " Comment", 1))
        : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_28)),
      ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.commentsData, (result, index) => {
        return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
          id: 'comments-box-'.concat(result.rowId),
          class: (0,vue_cjs.normalizeClass)(["comments-box", result.level > 0 ? 'reply-comment' : ''])
        }, [
          (0,vue_cjs.createElementVNode)("div", {
            class: (0,vue_cjs.normalizeClass)(["message-comment", result.isCoach ? 'coach-comment' : ''])
          }, [
            (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)(result.isCoach ? 'Coach' : '') + " " + (0,vue_cjs.toDisplayString)(result.name), 1),
            (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_30, (0,vue_cjs.toDisplayString)(result.dateChatFormat), 1),
            (0,vue_cjs.createElementVNode)("p", null, (0,vue_cjs.toDisplayString)(result.comments), 1)
          ], 2),
          (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_31, [
            (0,vue_cjs.createElementVNode)("a", {
              onClick: $event => ($options.submitLike(result.rowId, index)),
              class: (0,vue_cjs.normalizeClass)(result.isLiked ? 'active' : '')
            }, [
              ResponseCommentsvue_type_template_id_51e68247_hoisted_33,
              (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)(result.likeCount>0?result.likeCount:'') + " " + (0,vue_cjs.toDisplayString)(result.likeCount>1?'Likes':'Like'), 1)
            ], 10, ResponseCommentsvue_type_template_id_51e68247_hoisted_32),
            (0,vue_cjs.createElementVNode)("a", {
              onClick: $event => ($options.replyClick(result.name,result.rowId))
            }, [
              ResponseCommentsvue_type_template_id_51e68247_hoisted_35,
              (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)(result.commentsCount>0?result.commentsCount:'') + " " + (0,vue_cjs.toDisplayString)(result.commentsCount>1?'Replies':'Reply'), 1)
            ], 8, ResponseCommentsvue_type_template_id_51e68247_hoisted_34)
          ])
        ], 10, ResponseCommentsvue_type_template_id_51e68247_hoisted_29))
      }), 256))
    ]),
    (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_36, [
      (0,vue_cjs.createElementVNode)("div", ResponseCommentsvue_type_template_id_51e68247_hoisted_37, [
        (0,vue_cjs.createElementVNode)("p", null, "Replying to " + (0,vue_cjs.toDisplayString)($data.replyingName), 1),
        (0,vue_cjs.createElementVNode)("span", ResponseCommentsvue_type_template_id_51e68247_hoisted_38, [
          ResponseCommentsvue_type_template_id_51e68247_hoisted_39,
          ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
            onClick: _cache[2] || (_cache[2] = $event => ($options.submitComments())),
            class: "comment-submit",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "#ff7a21",
            viewBox: "0 0 256 256"
          }, ResponseCommentsvue_type_template_id_51e68247_hoisted_41))
        ]),
        (0,vue_cjs.createElementVNode)("span", {
          class: "error-text mt-2",
          style: (0,vue_cjs.normalizeStyle)($data.showError ? 'display:block' : '')
        }, "Please Enter Reply and Send...", 4)
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/ResponseComments.vue?vue&type=template&id=51e68247

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ResponseComments.vue?vue&type=script&lang=js

	//import Loader from "../../wwwroot/js/Loader.js";
	
	/* harmony default export */ const ResponseCommentsvue_type_script_lang_js = ({
		name: "ResponseComments",
		data() {
			return {
				commentsData: [],
				showError: false,
				replyingName: '',
				parentCommentId: 0,
				totalComments: 0,
			}
		},
		props: {
			activityResponseId: 0,
			activityTypeId: 0,
			isCorrectAnswer: 0,
			userPid: 0,
			answeredName: '',
			answeredTime: '',
			answerHtml: '',
			playButtonBlobUrl: '',
			answer: '',
		},
		beforeMount: function () {
			this.replyingName = this.answeredName;
			if (this.activityResponseId > 0) {
				this.getComments(this.activityResponseId);
			}
			else {
			}
		},
		mounted: function () {
		},
		updated: function () {
		},
		methods: {
			getComments: function (id) {
				var obj = {
					activityResponseId: id,
					userPid: this.userPid,
				};
				CSMainAPIs.Capshine.APIs.GetDailyAcitivityResponseComments.execute(obj, this.getCommentsCallback);
			},
			getCommentsCallback: function (response) {
				if (response.data.length > 0) {
					this.commentsData = response.data;
					this.totalComments = response.data.filter(res => res.level == 0).length;
				} else {
				}
			},
			submitComments: function () {
				let inputReply = document.getElementById("reply-comment").value.trim();
				if (inputReply != '') {
					this.showError = false;
					var obj = {
						ActivityResponseId: this.activityResponseId,
						ReplyType: 'C',
						UserPid: this.userPid,
						Comments: inputReply,
						ParentCommentId: this.parentCommentId,
					};
					CSMainAPIs.Capshine.APIs.DailyAcitivitySaveResponse.execute(obj, this.submitCommentsCallback);
				}
				else {
					this.showError = true;
				}
			},
			submitCommentsCallback: function (response) {
				if (response.data == 1) {
					document.getElementById("reply-comment").value = '';
					if (this.parentCommentId == 0) {
						let commentsContent = document.getElementById("comments-" + this.activityResponseId);
						if (commentsContent.innerHTML.split(' ').length > 1) {
							let val = parseInt(commentsContent.innerHTML.split(' ')[1].trim().replace('(', '').replace(')', ''));
							if ((val + 1) == 2)
								commentsContent.innerHTML = 'Comments (2)';
							else
								commentsContent.innerHTML = commentsContent.innerHTML.replace(val, (val + 1));
						}
						else
							commentsContent.innerHTML = "Comment (1)";
					}
					this.getComments(this.activityResponseId);
				} else {

				}
			},
			closeComments: function () {
				document.getElementById('div-response-comments-main').innerHTML = '';
				let answersDiv = document.getElementById('response-page-answers');
				if (answersDiv) {
					if (answersDiv.classList.contains('hide')) {
						answersDiv.classList.remove('hide')
					}
				}
			},
			replyClick: function (userName, commentId) {
				this.parentCommentId = commentId;
				this.replyingName = userName;
				//let isMobile = document.getElementById('IsMobile').getAttribute('data-ismobile').toLowerCase() == 'true' ? 1 : 0;
				let isMobile = 0;
				let elementToScroll;
				if (commentId > 0) {
					if (isMobile == 1) {
						let element = document.getElementById('comments-box-' + commentId);
						if (element.previousElementSibling.tagName.toLowerCase() == 'h5')
							elementToScroll = element.previousElementSibling;
						else
							elementToScroll = element.previousElementSibling.lastElementChild;
						elementToScroll.scrollIntoView(true);
					}
				}
				setTimeout(function () { document.getElementById('reply-comment').focus(); }, 200);
				if (isMobile == 1)
					setTimeout(function () { elementToScroll.scrollIntoView(true); }, 400);
			},
			submitLike: function (commentId, index) {
				if (this.commentsData[index].isLiked == false) {
					var obj = {
						ActivityResponseId: this.activityResponseId,
						ReplyType: 'L',
						UserPid: this.userPid,
						CommentId: commentId,
					};
					CSMainAPIs.Capshine.APIs.DailyAcitivitySaveResponse.execute(obj, this.submitLikeCallback);
				}
			},
			submitLikeCallback: function (response) {
				if (response.data == 1) {
					this.getComments(this.activityResponseId);
				} else {
				}
			},
		},
	});

;// CONCATENATED MODULE: ./src/Components/ResponseComments.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/ResponseComments.vue




;
const ResponseComments_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ResponseCommentsvue_type_script_lang_js, [['render',ResponseCommentsvue_type_template_id_51e68247_render]])

/* harmony default export */ const ResponseComments = (ResponseComments_exports_);
;// CONCATENATED MODULE: ./src/js/DailyActivityResponse.js
﻿

//import Loader from "../Loader.js";


let DailyActivityResponse = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	init: function (userPid, sulekhaApp = null) {
		DailyActivityResponse.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				DailyActivityResponse.isMobileApp = true;
			}
			else {
				DailyActivityResponse.isMobileApp = false;
			}
		}

		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }
		
		this.userPid = userPid;
		if (this.userPid)
			this.bindEvents();
	},
	bindEvents: function () {
		let backBtn = document.getElementById("dailyActivityResponseBackBtn");
		if (backBtn) {
			backBtn.addEventListener("click", function () {
				if (DailyActivityResponse.isMobileApp) {
					DailyActivityResponse.sulekhaApp.navigateBack();
				} else {
					history.back();
				}
			});
		}
		let commentsBtn = document.querySelectorAll("[data-comments]");
		if (commentsBtn) {
			commentsBtn.forEach((btn) => {
				btn.addEventListener("click", function (e) {
					DailyActivityResponse.commentsBtnClick(btn);
				});
			});
		}
		let likeBtn = document.querySelectorAll("[data-activityLike]");
		if (likeBtn) {
			likeBtn.forEach((btn) => {
				btn.addEventListener("click", function (e) {
					if (!document.getElementById("activityLike-" + btn.getAttribute('data-activityLike')).classList.contains('active')) {
						const activityResponseId = btn.getAttribute('data-activityLike');
						var obj = {
							ActivityResponseId: activityResponseId,
							ReplyType: 'L',
							UserPid: DailyActivityResponse.userPid,
							Comments: '',
						};
						CSMainAPIs.Capshine.APIs.DailyAcitivitySaveResponse.execute(obj, DailyActivityResponse.submitLike);
						if (document.getElementById('activityLike-' + activityResponseId).classList.contains('active'))
							document.getElementById('activityLike-' + activityResponseId).classList.remove('active');
						else
							document.getElementById('activityLike-' + activityResponseId).classList.add('active');
						let likeContent = document.getElementById("like-" + btn.getAttribute('data-activityLike'));
						if (likeContent.innerHTML.split(' ').length > 1) {
							let val = parseInt(likeContent.innerHTML.split(' ')[1].trim().replace('(', '').replace(')', ''));
							if ((val + 1) == 2)
								likeContent.innerHTML = 'Likes (2)';
							else
								likeContent.innerHTML = likeContent.innerHTML.replace(val, (val + 1));
						}
						else
							likeContent.innerHTML = "Like (1)";
						if (likeContent.classList.contains('hide'))
							likeContent.classList.remove('hide');
					}
				});
			});
		}
	},
	commentsBtnClick: function (dataTarget) {
		if (document.getElementById('div-response-comments-main')) {
			let answersDiv = document.getElementById('response-page-answers');
			if (answersDiv) {
				if (!answersDiv.classList.contains('hide')) {
					answersDiv.classList.add('hide')
				}
			}
			let newDiv = document.createElement("div");
			newDiv.id = "div-response-comments";
			document.getElementById('div-response-comments-main').appendChild(newDiv);
			let isCorrectAnswer = document.getElementById('answerElement-' + dataTarget.getAttribute('data-comments')).getAttribute('data-iscorrectanswer');

			const props = {
				activityResponseId: dataTarget.getAttribute('data-comments'),
				answeredName: dataTarget.getAttribute('data-answeredname'),
				answeredTime: dataTarget.getAttribute('data-answereddate'),
				playButtonBlobUrl: dataTarget.getAttribute('data-audiourl'),
				answer: dataTarget.getAttribute('data-answer'),
				userPid: DailyActivityResponse.userPid,
				activityTypeId: parseInt(document.getElementById("responseActivityTypeId").value),
				isCorrectAnswer: parseInt(isCorrectAnswer)
			};
			const createResponseVue = (0,vue_cjs.createApp)(ResponseComments, props);
			createResponseVue.mount('#div-response-comments');
		}
	},
	submitLike: function (response) {
		if (response.data == 1) {
		} else {
		}
	},
}
/* harmony default export */ const js_DailyActivityResponse = (DailyActivityResponse);
// EXTERNAL MODULE: ./node_modules/capacitor-razorpay/dist/esm/web.js
var web = __webpack_require__(41);
;// CONCATENATED MODULE: ./node_modules/capacitor-razorpay/dist/esm/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/js/RazorpayPayment.js
﻿




let RazorPayPayments = {
	sulekhaApp: null,
	isMobileApp: false,
	userPid: "",
	amount: 0,
	isExistingUser: false,
	userType: "",
	checkIfTestPayment: function () {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get("testpayment");
	},
	makeRegularPayment: async function (options, isExistingUser = false) {
		RazorPayPayments.isExistingUser = isExistingUser;
		RazorPayPayments.userType = RazorPayPayments.isExistingUser ? "Existinguser" : "Newuser";
		RazorPayPayments.paymentPlan = options.paymentPlanType;
		RazorPayPayments.freeTrialDays = options.freeTrialDays;
		RazorPayPayments.bonusDays = options.bonusDays;
		let orderId = await RazorPayPayments.createOrder(options.finalAmount, options.userInfo.pid, options.paymentPlanType);
		let regularPaymentOptions = {
			order_id: orderId,
			/*amount: 1,*/
			amount: Math.round(options.finalAmount) * 100
		}
		RazorPayPayments.getCheckoutForm(options, regularPaymentOptions);
		//window.location.href = '/payment?oid=' + RazorPayPayments.oid + '&method=' + options.method;
	},
	createOrder: async function (finalAmount, userPid, paymentPlan) {
		let requestOptions = {
			paymentPlan: paymentPlan,
			amount: Math.round(finalAmount),
			/*amount: 1,*/
			userPid: userPid,
			testpayment: RazorPayPayments.checkIfTestPayment(),
		}
		return new Promise((resolve) => {
			CSMainAPIs.Capshine.PaymentsAPIs.CreateOrder.execute(requestOptions, (response) => {
				let data = response.data;
				RazorPayPayments.oid = data.oid;
				RazorPayPayments.spid = data.spid;
				RazorPayPayments.transaction_id = data.transaction_id;
				resolve(data.orderId);
			}, { testpayment: RazorPayPayments.checkIfTestPayment() })
		})

	},
	makeSubscriptionPayment: async function (options, isExistingUser = false) {
		RazorPayPayments.isExistingUser = isExistingUser;
		RazorPayPayments.userType = RazorPayPayments.isExistingUser ? "Existinguser" : "Newuser";
		RazorPayPayments.paymentPlan = options.paymentPlanType;
		RazorPayPayments.freeTrialDays = options.freeTrialDays;
		RazorPayPayments.bonusDays = options.bonusDays;
		let orderId = await RazorPayPayments.createOrder(options.finalAmount, options.userInfo.pid, options.paymentPlanType);
		let subscriptionId = await RazorPayPayments.createSubscription(options);
		let subscriptionOptions = {
			//order_id: orderId,
			//amount: Math.round(options.finalAmount) * 100,
			subscription_id: subscriptionId,
		}
		RazorPayPayments.getCheckoutForm(options, subscriptionOptions);
		//window.location.href = '/payment?oid=' + RazorPayPayments.oid + '&sid=' + subscriptionId + '&method=' + options.method;
	},
	createSubscription: async function (options) {
		let requestOptions = {
			TotalCount: RazorPayPayments.getSubscriptionCount(options.paymentPlanType),
			userPid: options.userInfo.pid,
			createNewPlan: options.createNewPlan,
			freeTrialDays: options.freeTrialDays,
			bonusDays: options.bonusDays,
			amount: options.finalAmount
		}
		return new Promise((resolve) => {
			CSMainAPIs.Capshine.PaymentsAPIs.CreateSubscription.execute(requestOptions, (response) => {
				resolve(response.data.razorSubscriptionId);
			}, { testpayment: RazorPayPayments.checkIfTestPayment() })
		})
	},
	getSubscriptionCount: function (planType) {
		switch (planType) {
			case 1: return 6;
			case 2: return 1;
			default: return 6;
		}
	},
	regularCheckoutHandler: function (response) {
		let requestData = {
			razorpay_payment_id: response.razorpay_payment_id,
			oid: RazorPayPayments.oid,
			signature: response.razorpay_signature,
			userPid: RazorPayPayments.userPid,
			paymentPlan: RazorPayPayments.paymentPlan,
			freeTrialDays: RazorPayPayments.freeTrialDays,
			bonusDays: RazorPayPayments.bonusDays
		}
		CSMainAPIs.Capshine.PaymentsAPIs.paymentResponse.execute(requestData, (response) => {
			//if (response && response.data) {
			//	if (response.data.status == "captured") {
			//		bindGA.pushValues(RazorPayPayments.userType + '_payment_thankyou', RazorPayPayments.isExistingUser ? 'upgrade_' : '' + 'subscribed_' + RazorPayPayments.amount + '_plan', 'Click_' + RazorPayPayments.userType + 'payment_thankyou');
			//		if (RazorPayPayments.isMobileApp) {
			//			RazorPayPayments.sulekhaApp.navigateTo(MobilePages.subscriptionSuccessful, null)
			//		} else {
			//			location.href = '/subscriptionsuccessful';
			//		}
			//	}
			//	else {
			//		if (RazorPayPayments.isMobileApp) {
			//			RazorPayPayments.sulekhaApp.navigateTo(MobilePages.subscriptionFailed, null)
			//		} else {
			//			location.href = '/subscriptionfailed';
			//		}
			//	}
			//}
			//else
			//	location.href = "/subscriptionfailed";
			if (RazorPayPayments.sulekhaApp) {
				RazorPayPayments.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentThankyou, {
					"orderid": RazorPayPayments.spid,
					"plantype": RazorPayPayments.paymentPlan
				});
			}
			else {
				location.href = "/paymentthankyou?orderid=" + RazorPayPayments.spid + "&plantype=" + RazorPayPayments.paymentPlan;
			}

		}, { testpayment: RazorPayPayments.checkIfTestPayment() })
	},
	//subscriptionCheckoutHandler: function (response) {
	//	console.log("subscription checkout handler response ", response);
	//	if (response.razorpay_payment_id) {
	//		location.href = "/subscriptionsuccessful";
	//	} else {
	//		location.href = "/subscriptionfailed";
	//	}
	//},
	getCheckoutForm: async function (checkoutOptions, paymentTypeOptions) {
		RazorPayPayments.amount = paymentTypeOptions.amount;
		let options = {
			...paymentTypeOptions,
			key: checkoutOptions.paymentKey,
			currency: "INR",
			name: "Capshine",
			description: "English Learning App",
			image: "https://sulcdn.azureedge.net/content/caps/capshine-logo.jpg",
			theme: { color: "#ff8a00" }, //#F36A10
			// handler: RazorPayPayments.regularCheckoutHandler, //paymentTypeOptions.subscription_id ? RazorPayPayments.subscriptionCheckoutHandler : RazorPayPayments.regularCheckoutHandler,
			// callback_url: 'https://dev.capshine.com/api/MyClub/CapshinePaymentCallback',
			// redirect: true,		
			prefill: {
				name: checkoutOptions.userInfo.firstName,
				email: checkoutOptions.userInfo.emailAddress,
				contact: checkoutOptions.userInfo.mobileNumber,
				method: checkoutOptions.method
			},
			notes: {
				spid: RazorPayPayments.spid,
				oid: RazorPayPayments.oid,
				transaction_id: RazorPayPayments.transaction_id,
				subscription_id: paymentTypeOptions.subscription_id ? paymentTypeOptions.subscription_id : "",
				freeTrialDays: checkoutOptions.freeTrialDays,
				bonusDays: checkoutOptions.bonusDays,
				planType: checkoutOptions.planType,
				platform: RazorPayPayments.sulekhaApp ? "App" : "Web"
			}
		}

		if (RazorPayPayments.isMobileApp == true) {

			web.Checkout.open(options).then((data) => {
				RazorPayPayments.regularCheckoutHandler(data.response)
			})
		}
		else {
			options.handler= RazorPayPayments.regularCheckoutHandler;
			var rzp1 = new Razorpay(options);
			rzp1.open();
		}
		// var rzp1 = new Razorpay(options);
		//console.log(data.response+"AcmeCorp");
		// rzp1.open();

	},

	initValues: function (userPid = 0, sulekhaApp = null) {
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				RazorPayPayments.isMobileApp = true;
			}
			else {
				RazorPayPayments.isMobileApp = false;
			}
		}

		RazorPayPayments.sulekhaApp = sulekhaApp;
		RazorPayPayments.userPid = userPid;
	},

	initPage: function (userPid = 0, sulekhaApp = null) {
		var oid = getQueryStringValue("oid");
		var sid = getQueryStringValue("sid");
		var method = getQueryStringValue("method");
		RazorPayPayments.sulekhaApp = sulekhaApp;
		CSMainAPIs.Capshine.PaymentsAPIs.GetRazorPaymentOptions.execute({ oid: oid, sid: sid, method: method }, (response) => { RazorPayPayments.invokeRP(response.data) });
	},
	getQueryStringValue: function (id) {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get(id);
	},
	invokeRP: function (response) {
		
		if (response != null && response != undefined && response.canCall) {
			var options = JSON.parse(response.options);
			var rzp1 = new Razorpay(options);
			rzp1.open();
		}
		else {
			alert('Unable to proceed to payment gateway...');
		}
	},
}
/* harmony default export */ const RazorpayPayment = (RazorPayPayments);
;// CONCATENATED MODULE: ./src/js/Payments.js
﻿//checkout.js is referred in PaymentSummary.cshtml or paymentSummary.vue component







let Payments = {
	sulekhaApp: null,
	userPid: "",
	paymentMethod: "card",
	oid: '',
	planType: "",
	totalAmount: "",
	rewardPointAmount: 0,
	finalAmount: "",
	summaryDetails: "",
	hasRewardPointsDeducted: false,
	isExistingUser: false,
	userType: '',
	checkIfTestPayment: function () {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get("testpayment");
	},
	bindEvents: function () {

		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}

		let payBtns = document.querySelectorAll("[summary-payment-type]");
		if (payBtns) {
			payBtns.forEach((btn) => {
				btn.addEventListener('click', (event) => {
					Payments.paymentMethod = event.currentTarget.getAttribute('summary-payment-type');
					Payments.removeActiveClass();
					event.currentTarget.classList.add("selected", "active");
					//Payments.enableContinueBtn();
				if (PaymentPlans.isExistingUser)
					GATrack.pushValues(Payments.userType + '_Paynow', 'upgrade_paidplan_confirm_' + Payments.totalAmount, 'Click_' + Payments.userType + '_Paynow');
				else
					GATrack.pushValues(Payments.userType + '_Paynow', 'paidplan_confirm_' + Payments.totalAmount, 'Click_' + Payments.userType + '_Paynow');

				Payments.onClickContinueBtn();
				})
			})
		}

		let backBtn = document.querySelector("[data-summary-back]");
		if (backBtn) {
			backBtn.addEventListener('click', () => {
				if (Payments.sulekhaApp) {
					Payments.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null)
				} else {
					location.href = '/paymentplans';
				}
			})
		}

		//let continueBtn = document.querySelector("[summary-continue-btn]");
		//if (continueBtn) {
		//	continueBtn.addEventListener('click', () => {
		//		if (paymentPlans.isExistingUser)
		//			bindGA.pushValues(Payments.userType + '_Paynow', 'upgrade_paidplan_confirm_' + Payments.totalAmount, 'Click_' + Payments.userType + '_Paynow');
		//		else
		//			bindGA.pushValues(Payments.userType + '_Paynow', 'paidplan_confirm_' + Payments.totalAmount, 'Click_' + Payments.userType + '_Paynow');
		//		Payments.onClickContinueBtn();
		//	})
		//}

		let checkBox = document.querySelector("[summary-rewardpoint-checkbox]");
		if (checkBox) {
			checkBox.addEventListener('click', () => {
				Payments.setFinalAmount();
				if (checkBox.checked) {
					document.getElementById("rewardPointsLi").classList.remove("hide");
					var rewardPointsLi = document.getElementById("totalPointsLi");
					if (rewardPointsLi) {
						rewardPointsLi.innerHTML = "<b>To pay</b><b>₹" + rewardPointsLi.getAttribute("data-finalamount") + "</b>";
					}
				}
				else {
					document.getElementById("rewardPointsLi").classList.add("hide");
					var rewardPointsLi = document.getElementById("totalPointsLi");
					if (rewardPointsLi) {
						rewardPointsLi.innerHTML = "<b>To pay</b><b>₹" + rewardPointsLi.getAttribute("data-totalamount") + "</b>";
					}
				}
			})
		}

		let openPopoverBtn = document.querySelector("#openPaymentSummaryPopover");
		if (openPopoverBtn) {
			openPopoverBtn.addEventListener('click', () => {
				document.querySelector(".sk-popover-content").classList.remove("hide");
			})
		}

		let closePopoverBtn = document.querySelector("#closePaymentSummaryPopover");
		if (closePopoverBtn) {
			closePopoverBtn.addEventListener('click', () => {
				document.querySelector(".sk-popover-content").classList.add("hide");
			})
		}
	},
	onClickContinueBtn: function () {
		let checkoutOptions = Payments.summaryDetails;
		checkoutOptions.method = Payments.paymentMethod;
		checkoutOptions.finalAmount = Payments.finalAmount;
		//let isFreeTrialEnabled = false;
		//let freeTrialDays = checkoutOptions.freeTrialDays;
		//if (freeTrialDays > 0 && freeTrialDays <= 30)
		//	isFreeTrialEnabled = true;
		let planType = Payments.getPlanType();

		RazorpayPayment.sulekhaApp = Payments.sulekhaApp;
		RazorpayPayment.userPid = Payments.userPid;

		RazorpayPayment.initValues(Payments.userPid,Payments.sulekhaApp)
		//if (isFreeTrialEnabled) {
		//	if (planType == PaymentPlanTypeOption.SixMonths && Payments.hasRewardPointsDeducted) {
		//		checkoutOptions.createNewPlan = true;
		//	}
		//	RazorPayPayments.makeSubscriptionPayment(checkoutOptions, Payments.isExistingUser);
		//} else {
			// if (planType == PaymentPlanTypeOption.Limited) {
			// 	RazorPayPayments.makeSubscriptionPayment(checkoutOptions, Payments.isExistingUser);
			// }
			// else //if (planType == PaymentPlanTypeOption.SixMonths) 
			// {
			// 	RazorPayPayments.makeRegularPayment(checkoutOptions, Payments.isExistingUser);
			// }
		//}


		if (planType == PaymentPlanTypeOption.Limited) {
			RazorpayPayment.makeSubscriptionPayment(checkoutOptions, Payments.isExistingUser);
		}
		if (planType == PaymentPlanTypeOption.Monthly) {
			alert(5)
			RazorpayPayment.makeSubscriptionPayment(checkoutOptions, Payments.isExistingUser);
		}
		else //if (planType == PaymentPlanTypeOption.SixMonths) 
		{
			RazorpayPayment.makeRegularPayment(checkoutOptions, Payments.isExistingUser);
		}
	},

	enableContinueBtn: function () {
		let continueBtn = document.querySelector("[summary-continue-btn]");
		if (continueBtn) {
			continueBtn.classList.remove("light", "disabled");
			continueBtn.classList.add("primary");
		}
	},
	removeActiveClass: function () {
		let payBtns = document.querySelectorAll("[summary-payment-type]");
		payBtns.forEach((btn) => {
			btn.classList.remove("selected", "active");
		})

	},
	getPlanType: function () {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get("plantype");
	},
	getPaymentSummaryData: function () {
		Payments.planType = Payments.getPlanType();
		CSMainAPIs.Capshine.PaymentsAPIs.GetPaymentSummaryData.execute({ userPid: Payments.userPid, planType: Payments.planType, testpayment: Payments.checkIfTestPayment() }, (response) => {
			let summaryDetails = response.data;
			if (summaryDetails) {
				Payments.summaryDetails = summaryDetails;
				Payments.key = summaryDetails.paymentKey;
				Payments.totalAmount = summaryDetails.totalAmount;
				Payments.rewardPointAmount = summaryDetails.rewardPointsAmount;
				if (Payments.planType == "2" && Payments.rewardPointAmount) {
					Payments.setFinalAmount();
				}
				else {
					Payments.finalAmount = summaryDetails.totalAmount;
				}
			}
		});
	},
	setFinalAmount: function () {
		if (Payments.rewardPointAmount && !Payments.hasRewardPointsDeducted) {
			Payments.finalAmount = ((Payments.totalAmount) - Payments.rewardPointAmount);
		}
		else
			Payments.finalAmount = (Payments.totalAmount);
		//Payments.updateTotalAmountUi();
		Payments.hasRewardPointsDeducted = !Payments.hasRewardPointsDeducted;
	},
	//updateTotalAmountUi: function () {

	//	let totalDiv = document.querySelector("[summary-total-amount]");
	//	let proceedDiv = document.querySelector("[summary-continue-btn]");
	//	if (totalDiv && proceedDiv) {
	//		if (Payments.hasRewardPointsDeducted) {
	//			totalDiv.innerHTML = `₹${(Payments.totalAmount)}`;
	//			proceedDiv.innerHTML = `Proceed to Pay ₹${(Payments.totalAmount)}`;
	//		}
	//		else {
	//			totalDiv.innerHTML = `₹${Payments.finalAmount}`;
	//			proceedDiv.innerHTML = `Proceed to Pay ₹${Payments.finalAmount}`;
	//		}
	//	}
	//},
	init: function (userPid = 0, sulekhaApp = null) {
		Payments.userPid = userPid > 0 ? userPid : document.getElementById("hdnUserPid").value;
		Payments.getPaymentSummaryData();
		Payments.bindEvents();

		Payments.sulekhaApp = sulekhaApp;
		Payments.checkIfExistingUser();
		Payments.userType = Payments.isExistingUser ? "Existinguser" : "Newuser";
	},
	checkIfExistingUser: function () {
		let isExistingUser = document.getElementById("paymentPlansUserType");
		if (isExistingUser)
			Payments.isExistingUser = true;
	},

	initPage: function () {
		var oid = Payments.getQueryStringValue("oid");
		var sid = Payments.getQueryStringValue("sid");
		var method = Payments.getQueryStringValue("method");

		CSMainAPIs.Capshine.PaymentsAPIs.GetRazorPaymentOptions.execute({ oid: oid, sid: sid ? '' : sid, method: method }, (response) => { RazorpayPayment.invokeRP(response.data) });
	},
	getQueryStringValue: function (id) {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (urlSearchParams)
			return urlSearchParams.get(id);
	},
}

/* harmony default export */ const js_Payments = (Payments);


;// CONCATENATED MODULE: ./src/js/GoogleCalendar.js
﻿// import router from "./routerconfig"
var GoogleCalendar = {
	CLIENT_ID: '760903773324-71as0p1190ba082ibp205dv6brjmv6ga.apps.googleusercontent.com',
	API_KEY: 'AIzaSyATI-S28hECfhRrsyNU3hr2Ev80lhe1bTo',
	DISCOVERY_DOCS: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
	SCOPES: "https://www.googleapis.com/auth/calendar",
	callbackSignIn: function () { },
	init: function (callbackSignIn) {
		this.callbackSignIn = callbackSignIn;
		gapi.load('client:auth2', this.initClient);
	},
	initClient: function () {
		gapi.client.init({
			apiKey: GoogleCalendar.API_KEY,
			clientId: GoogleCalendar.CLIENT_ID,
			discoveryDocs: GoogleCalendar.DISCOVERY_DOCS,
			scope: GoogleCalendar.SCOPES
		}).then(function () {
			if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
				gapi.auth2.getAuthInstance().isSignedIn.listen(GoogleCalendar.signInDone);
				GoogleCalendar.signIn();
			}
			else {
				GoogleCalendar.callbackSignIn(false, GoogleCalendar.getProfile().getEmail());
			}
		}, function (error) {
			console.log(error);
		});
	},
	signInDone: function () {
		GoogleCalendar.callbackSignIn(false, GoogleCalendar.getProfile().getEmail());
	},
	signIn: function () {
		gapi.auth2.getAuthInstance().signIn();
	},
	pushEvents: function (data, callbackAddEvent) {
		var request = gapi.client.calendar.events.insert({
			'calendarId': 'primary',
			'resource': data
		});
		request.execute(function (event) {
			callbackAddEvent(event);
		});
	},
	getProfile: function () {
		return gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile();
	},
}
/* harmony default export */ const js_GoogleCalendar = (GoogleCalendar);
;// CONCATENATED MODULE: ./node_modules/@firebase/util/dist/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function index_esm2017_getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(index_esm2017_getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return index_esm2017_getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = index_esm2017_getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return index_esm2017_getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return typeof indexedDB === 'object';
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function index_esm2017_querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function index_esm2017_async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = (/* unused pure expression or super */ null && (4 * 60 * 60 * 1000)); // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function index_esm2017_getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
function promisifyRequest(request, errorMessage) {
    return new Promise((resolve, reject) => {
        request.onsuccess = event => {
            resolve(event.target.result);
        };
        request.onerror = event => {
            var _a;
            reject(`${errorMessage}: ${(_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message}`);
        };
    });
}
/**
 * @internal
 */
class DBWrapper {
    constructor(_db) {
        this._db = _db;
        this.objectStoreNames = this._db.objectStoreNames;
    }
    transaction(storeNames, mode = 'readonly') {
        return new TransactionWrapper(this._db.transaction.call(this._db, storeNames, mode));
    }
    createObjectStore(storeName, options) {
        return new ObjectStoreWrapper(this._db.createObjectStore(storeName, options));
    }
    close() {
        this._db.close();
    }
}
/**
 * @internal
 */
class TransactionWrapper {
    constructor(_transaction) {
        this._transaction = _transaction;
        this.complete = new Promise((resolve, reject) => {
            this._transaction.oncomplete = function () {
                resolve();
            };
            this._transaction.onerror = () => {
                reject(this._transaction.error);
            };
            this._transaction.onabort = () => {
                reject(this._transaction.error);
            };
        });
    }
    objectStore(storeName) {
        return new ObjectStoreWrapper(this._transaction.objectStore(storeName));
    }
}
/**
 * @internal
 */
class ObjectStoreWrapper {
    constructor(_store) {
        this._store = _store;
    }
    index(name) {
        return new IndexWrapper(this._store.index(name));
    }
    createIndex(name, keypath, options) {
        return new IndexWrapper(this._store.createIndex(name, keypath, options));
    }
    get(key) {
        const request = this._store.get(key);
        return promisifyRequest(request, 'Error reading from IndexedDB');
    }
    put(value, key) {
        const request = this._store.put(value, key);
        return promisifyRequest(request, 'Error writing to IndexedDB');
    }
    delete(key) {
        const request = this._store.delete(key);
        return promisifyRequest(request, 'Error deleting from IndexedDB');
    }
    clear() {
        const request = this._store.clear();
        return promisifyRequest(request, 'Error clearing IndexedDB object store');
    }
}
/**
 * @internal
 */
class IndexWrapper {
    constructor(_index) {
        this._index = _index;
    }
    get(key) {
        const request = this._index.get(key);
        return promisifyRequest(request, 'Error reading from IndexedDB');
    }
}
/**
 * @internal
 */
function openDB(dbName, dbVersion, upgradeCallback) {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.open(dbName, dbVersion);
            request.onsuccess = event => {
                resolve(new DBWrapper(event.target.result));
            };
            request.onerror = event => {
                var _a;
                reject(`Error opening indexedDB: ${(_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message}`);
            };
            request.onupgradeneeded = event => {
                upgradeCallback(new DBWrapper(request.result), event.oldVersion, event.newVersion, new TransactionWrapper(request.transaction));
            };
        }
        catch (e) {
            reject(`Error opening indexedDB: ${e.message}`);
        }
    });
}
/**
 * @internal
 */
async function deleteDB(dbName) {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.deleteDatabase(dbName);
            request.onsuccess = () => {
                resolve();
            };
            request.onerror = event => {
                var _a;
                reject(`Error deleting indexedDB database "${dbName}": ${(_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message}`);
            };
        }
        catch (e) {
            reject(`Error deleting indexedDB database "${dbName}": ${e.message}`);
        }
    });
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/component/dist/esm/index.esm2017.js


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new Deferred();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/logger/dist/esm/index.esm2017.js
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function index_esm2017_setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/app/dist/esm/index.esm2017.js





/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

const name$o = "@firebase/app";
const version$1 = "0.7.22";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new Logger('@firebase/app');

const name$n = "@firebase/app-compat";

const name$m = "@firebase/analytics-compat";

const name$l = "@firebase/analytics";

const name$k = "@firebase/app-check-compat";

const name$j = "@firebase/app-check";

const name$i = "@firebase/auth";

const name$h = "@firebase/auth-compat";

const name$g = "@firebase/database";

const name$f = "@firebase/database-compat";

const name$e = "@firebase/functions";

const name$d = "@firebase/functions-compat";

const name$c = "@firebase/installations";

const name$b = "@firebase/installations-compat";

const name$a = "@firebase/messaging";

const name$9 = "@firebase/messaging-compat";

const name$8 = "@firebase/performance";

const name$7 = "@firebase/performance-compat";

const name$6 = "@firebase/remote-config";

const name$5 = "@firebase/remote-config-compat";

const name$4 = "@firebase/storage";

const name$3 = "@firebase/storage-compat";

const name$2 = "@firebase/firestore";

const name$1 = "@firebase/firestore-compat";

const index_esm2017_name = "firebase";
const version = "9.7.0";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const index_esm2017_DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$o]: 'fire-core',
    [name$n]: 'fire-core-compat',
    [name$l]: 'fire-analytics',
    [name$m]: 'fire-analytics-compat',
    [name$j]: 'fire-app-check',
    [name$k]: 'fire-app-check-compat',
    [name$i]: 'fire-auth',
    [name$h]: 'fire-auth-compat',
    [name$g]: 'fire-rtdb',
    [name$f]: 'fire-rtdb-compat',
    [name$e]: 'fire-fn',
    [name$d]: 'fire-fn-compat',
    [name$c]: 'fire-iid',
    [name$b]: 'fire-iid-compat',
    [name$a]: 'fire-fcm',
    [name$9]: 'fire-fcm-compat',
    [name$8]: 'fire-perf',
    [name$7]: 'fire-perf-compat',
    [name$6]: 'fire-rc',
    [name$5]: 'fire-rc-compat',
    [name$4]: 'fire-gcs',
    [name$3]: 'fire-gcs-compat',
    [name$2]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [index_esm2017_name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = index_esm2017_DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    ["bad-app-name" /* BAD_APP_NAME */]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["invalid-app-argument" /* INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["storage-open" /* STORAGE_OPEN */]: 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
    ["storage-get" /* STORAGE_GET */]: 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
    ["storage-set" /* STORAGE_WRITE */]: 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
    ["storage-delete" /* STORAGE_DELETE */]: 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.'
};
const ERROR_FACTORY = new ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new Component('app', () => this, "PUBLIC" /* PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(options, rawConfig = {}) {
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: index_esm2017_DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (deepEqual(options, existingApp.options) &&
            deepEqual(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new ComponentContainer(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = index_esm2017_DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    const name = app.name;
    if (_apps.has(name)) {
        _apps.delete(name);
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new Component(`${library}-version`, () => ({ library, version }), "VERSION" /* VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function index_esm2017_setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = openDB(DB_NAME, DB_VERSION, (db, oldVersion) => {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (oldVersion) {
                case 0:
                    db.createObjectStore(STORE_NAME);
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("storage-open" /* STORAGE_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        return db
            .transaction(STORE_NAME)
            .objectStore(STORE_NAME)
            .get(computeKey(app));
    }
    catch (e) {
        throw ERROR_FACTORY.create("storage-get" /* STORAGE_GET */, {
            originalErrorMessage: e.message
        });
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        return tx.complete;
    }
    catch (e) {
        throw ERROR_FACTORY.create("storage-set" /* STORAGE_WRITE */, {
            originalErrorMessage: e.message
        });
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        const platformLogger = this.container
            .getProvider('platform-logger')
            .getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = getUTCDateString();
        if (this._heartbeatsCache === null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
            this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
            return;
        }
        else {
            // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({ date, agent });
        }
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) {
            await this._heartbeatsCachePromise;
        }
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null ||
            this._heartbeatsCache.heartbeats.length === 0) {
            return '';
        }
        const date = getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = base64urlEncodeWithoutPadding(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        }
        else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            void this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!isIndexedDBAvailable()) {
            return false;
        }
        else {
            return validateIndexedDBOpenable()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || { heartbeats: [] };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return base64urlEncodeWithoutPadding(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new Component('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* PRIVATE */));
    _registerComponent(new Component('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    registerVersion(name$o, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$o, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/auth/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/esm2017/index-7078a255.js






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */
const FactorId = {
    /** Phone as second factor */
    PHONE: 'phone'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */
const ProviderId = {
    /** Facebook provider ID */
    FACEBOOK: 'facebook.com',
    /** GitHub provider ID */
    GITHUB: 'github.com',
    /** Google provider ID */
    GOOGLE: 'google.com',
    /** Password provider */
    PASSWORD: 'password',
    /** Phone provider */
    PHONE: 'phone',
    /** Twitter provider ID */
    TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */
const SignInMethod = {
    /** Email link sign in method */
    EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */
    EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */
    FACEBOOK: 'facebook.com',
    /** GitHub sign in method */
    GITHUB: 'github.com',
    /** Google sign in method */
    GOOGLE: 'google.com',
    /** Phone sign in method */
    PHONE: 'phone',
    /** Twitter sign in method */
    TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */
const OperationType = {
    /** Operation involving linking an additional provider to an already signed-in user. */
    LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */
    REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */
    SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */
const ActionCodeOperation = {
    /** The email link sign-in action. */
    EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */
    PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */
    RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */
    REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */
    VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */
    VERIFY_EMAIL: 'VERIFY_EMAIL'
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _debugErrorMap() {
    return {
        ["admin-restricted-operation" /* ADMIN_ONLY_OPERATION */]: 'This operation is restricted to administrators only.',
        ["argument-error" /* ARGUMENT_ERROR */]: '',
        ["app-not-authorized" /* APP_NOT_AUTHORIZED */]: "This app, identified by the domain where it's hosted, is not " +
            'authorized to use Firebase Authentication with the provided API key. ' +
            'Review your key configuration in the Google API console.',
        ["app-not-installed" /* APP_NOT_INSTALLED */]: 'The requested mobile application corresponding to the identifier (' +
            'Android package name or iOS bundle ID) provided is not installed on ' +
            'this device.',
        ["captcha-check-failed" /* CAPTCHA_CHECK_FAILED */]: 'The reCAPTCHA response token provided is either invalid, expired, ' +
            'already used or the domain associated with it does not match the list ' +
            'of whitelisted domains.',
        ["code-expired" /* CODE_EXPIRED */]: 'The SMS code has expired. Please re-send the verification code to try ' +
            'again.',
        ["cordova-not-ready" /* CORDOVA_NOT_READY */]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* CORS_UNSUPPORTED */]: 'This browser is not supported.',
        ["credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* CREDENTIAL_MISMATCH */]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */]: 'This operation is sensitive and requires recent authentication. Log in ' +
            'again before retrying this request.',
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */]: 'Another Firebase SDK was initialized and is trying to use Auth before Auth is ' +
            'initialized. Please be sure to call `initializeAuth` or `getAuth` before ' +
            'starting any other Firebase SDK.',
        ["dynamic-link-not-activated" /* DYNAMIC_LINK_NOT_ACTIVATED */]: 'Please activate Dynamic Links in the Firebase Console and agree to the terms and ' +
            'conditions.',
        ["email-change-needs-verification" /* EMAIL_CHANGE_NEEDS_VERIFICATION */]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* EMAIL_EXISTS */]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* EMULATOR_CONFIG_FAILED */]: 'Auth instance has already been used to make a network call. Auth can ' +
            'no longer be configured to use the emulator. Try calling ' +
            '"connectAuthEmulator()" sooner.',
        ["expired-action-code" /* EXPIRED_OOB_CODE */]: 'The action code has expired.',
        ["cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* INTERNAL_ERROR */]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* INVALID_APP_CREDENTIAL */]: 'The phone verification request contains an invalid application verifier.' +
            ' The reCAPTCHA token response is either invalid or expired.',
        ["invalid-app-id" /* INVALID_APP_ID */]: 'The mobile app identifier is not registed for the current project.',
        ["invalid-user-token" /* INVALID_AUTH */]: "This user's credential isn't valid for this project. This can happen " +
            "if the user's token has been tampered with, or if the user isn't for " +
            'the project associated with this API key.',
        ["invalid-auth-event" /* INVALID_AUTH_EVENT */]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* INVALID_CODE */]: 'The SMS verification code used to create the phone auth credential is ' +
            'invalid. Please resend the verification code sms and be sure to use the ' +
            'verification code provided by the user.',
        ["invalid-continue-uri" /* INVALID_CONTINUE_URI */]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* INVALID_CORDOVA_CONFIGURATION */]: 'The following Cordova plugins must be installed to enable OAuth sign-in: ' +
            'cordova-plugin-buildinfo, cordova-universal-links-plugin, ' +
            'cordova-plugin-browsertab, cordova-plugin-inappbrowser and ' +
            'cordova-plugin-customurlscheme.',
        ["invalid-custom-token" /* INVALID_CUSTOM_TOKEN */]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* INVALID_EMAIL */]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* INVALID_API_KEY */]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* INVALID_CERT_HASH */]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* INVALID_IDP_RESPONSE */]: 'The supplied auth credential is malformed or has expired.',
        ["invalid-message-payload" /* INVALID_MESSAGE_PAYLOAD */]: 'The email template corresponding to this action contains invalid characters in its message. ' +
            'Please fix by going to the Auth email templates section in the Firebase Console.',
        ["invalid-multi-factor-session" /* INVALID_MFA_SESSION */]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* INVALID_OAUTH_PROVIDER */]: 'EmailAuthProvider is not supported for this operation. This operation ' +
            'only supports OAuth providers.',
        ["invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */]: 'The OAuth client ID provided is either invalid or does not match the ' +
            'specified API key.',
        ["unauthorized-domain" /* INVALID_ORIGIN */]: 'This domain is not authorized for OAuth operations for your Firebase ' +
            'project. Edit the list of authorized domains from the Firebase console.',
        ["invalid-action-code" /* INVALID_OOB_CODE */]: 'The action code is invalid. This can happen if the code is malformed, ' +
            'expired, or has already been used.',
        ["wrong-password" /* INVALID_PASSWORD */]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* INVALID_PERSISTENCE */]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* INVALID_PHONE_NUMBER */]: 'The format of the phone number provided is incorrect. Please enter the ' +
            'phone number in a format that can be parsed into E.164 format. E.164 ' +
            'phone numbers are written in the format [+][country code][subscriber ' +
            'number including area code].',
        ["invalid-provider-id" /* INVALID_PROVIDER_ID */]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* INVALID_RECIPIENT_EMAIL */]: 'The email corresponding to this action failed to send as the provided ' +
            'recipient email address is invalid.',
        ["invalid-sender" /* INVALID_SENDER */]: 'The email template corresponding to this action contains an invalid sender email or name. ' +
            'Please fix by going to the Auth email templates section in the Firebase Console.',
        ["invalid-verification-id" /* INVALID_SESSION_INFO */]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* INVALID_TENANT_ID */]: "The Auth instance's tenant ID is invalid.",
        ["missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* MISSING_AUTH_DOMAIN */]: 'Be sure to include authDomain when calling firebase.initializeApp(), ' +
            'by following the instructions in the Firebase console.',
        ["missing-app-credential" /* MISSING_APP_CREDENTIAL */]: 'The phone verification request is missing an application verifier ' +
            'assertion. A reCAPTCHA response token needs to be provided.',
        ["missing-verification-code" /* MISSING_CODE */]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* MISSING_CONTINUE_URI */]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* MISSING_IFRAME_START */]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* MISSING_OR_INVALID_NONCE */]: 'The request does not contain a valid nonce. This can occur if the ' +
            'SHA-256 hash of the provided raw nonce does not match the hashed nonce ' +
            'in the ID token payload.',
        ["missing-multi-factor-info" /* MISSING_MFA_INFO */]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* MISSING_MFA_SESSION */]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* MISSING_PHONE_NUMBER */]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* MISSING_SESSION_INFO */]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* MODULE_DESTROYED */]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* MFA_REQUIRED */]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* NEED_CONFIRMATION */]: 'An account already exists with the same email address but different ' +
            'sign-in credentials. Sign in using a provider associated with this ' +
            'email address.',
        ["network-request-failed" /* NETWORK_REQUEST_FAILED */]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* NO_AUTH_EVENT */]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* NO_SUCH_PROVIDER */]: 'User was not linked to an account with the given provider.',
        ["null-user" /* NULL_USER */]: 'A null user object was provided as the argument for an operation which ' +
            'requires a non-null user object.',
        ["operation-not-allowed" /* OPERATION_NOT_ALLOWED */]: 'The given sign-in provider is disabled for this Firebase project. ' +
            'Enable it in the Firebase console, under the sign-in method tab of the ' +
            'Auth section.',
        ["operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */]: 'This operation is not supported in the environment this application is ' +
            'running on. "location.protocol" must be http, https or chrome-extension' +
            ' and web storage must be enabled.',
        ["popup-blocked" /* POPUP_BLOCKED */]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* POPUP_CLOSED_BY_USER */]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* PROVIDER_ALREADY_LINKED */]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* QUOTA_EXCEEDED */]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* REDIRECT_CANCELLED_BY_USER */]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* REDIRECT_OPERATION_PENDING */]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* REJECTED_CREDENTIAL */]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* TENANT_ID_MISMATCH */]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* TIMEOUT */]: 'The operation has timed out.',
        ["user-token-expired" /* TOKEN_EXPIRED */]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */]: 'We have blocked all requests from this device due to unusual activity. ' +
            'Try again later.',
        ["unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */]: 'The domain of the continue URL is not whitelisted.  Please whitelist ' +
            'the domain in the Firebase console.',
        ["unsupported-first-factor" /* UNSUPPORTED_FIRST_FACTOR */]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* UNSUPPORTED_PERSISTENCE */]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* UNSUPPORTED_TENANT_OPERATION */]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* UNVERIFIED_EMAIL */]: 'The operation requires a verified email.',
        ["user-cancelled" /* USER_CANCELLED */]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* USER_DELETED */]: 'There is no user record corresponding to this identifier. The user may ' +
            'have been deleted.',
        ["user-disabled" /* USER_DISABLED */]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* USER_MISMATCH */]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* USER_SIGNED_OUT */]: '',
        ["weak-password" /* WEAK_PASSWORD */]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* ALREADY_INITIALIZED */]: 'initializeAuth() has already been called with ' +
            'different options. To avoid this error, call initializeAuth() with the ' +
            'same options as when it was originally called, or call getAuth() to return the' +
            ' already initialized instance.'
    };
}
function _prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */]: 'Another Firebase SDK was initialized and is trying to use Auth before Auth is ' +
            'initialized. Please be sure to call `initializeAuth` or `getAuth` before ' +
            'starting any other Firebase SDK.'
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */
const debugErrorMap = (/* unused pure expression or super */ null && (_debugErrorMap));
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */
const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new ErrorFactory('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */
const AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized'
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logClient = new Logger('@firebase/auth');
function _logError(msg, ...args) {
    if (logClient.logLevel <= LogLevel.ERROR) {
        logClient.error(`Auth (${SDK_VERSION}): ${msg}`, ...args);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _fail(authOrCode, ...rest) {
    throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
    return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, prodErrorMap()), { [code]: message });
    const factory = new ErrorFactory('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name,
    });
}
function _assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) {
            _fail(auth, "argument-error" /* ARGUMENT_ERROR */);
        }
        throw _errorWithCustomMessage(auth, "argument-error" /* ARGUMENT_ERROR */, `Type of ${object.constructor.name} does not match expected instance.` +
            `Did you pass a reference from a different Auth SDK?`);
    }
}
function createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [...rest.slice(1)];
        if (fullParams[0]) {
            fullParams[0].appName = authOrCode.name;
        }
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
    if (!assertion) {
        throw createErrorInternal(authOrCode, ...rest);
    }
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */
function debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    _logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */
function debugAssert(assertion, message) {
    if (!assertion) {
        debugFail(message);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const instanceCache = new Map();
function _getInstance(cls) {
    debugAssert(cls instanceof Function, 'Expected a class definition');
    let instance = instanceCache.get(cls);
    if (instance) {
        debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    instanceCache.set(cls, instance);
    return instance;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */
function initializeAuth(app, deps) {
    const provider = _getProvider(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if (deepEqual(initialOptions, deps !== null && deps !== void 0 ? deps : {})) {
            return auth;
        }
        else {
            _fail(auth, "already-initialized" /* ALREADY_INITIALIZED */);
        }
    }
    const auth = provider.initialize({ options: deps });
    return auth;
}
function _initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [persistence]).map(_getInstance);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) {
        auth._updateErrorMap(deps.errorMap);
    }
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _getCurrentUrl() {
    var _a;
    return (typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href)) || '';
}
function _isHttpOrHttps() {
    return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}
function _getCurrentScheme() {
    var _a;
    return (typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol)) || null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Determine whether the browser is working online
 */
function _isOnline() {
    if (typeof navigator !== 'undefined' &&
        navigator &&
        'onLine' in navigator &&
        typeof navigator.onLine === 'boolean' &&
        // Apply only for traditional web apps and Chrome extensions.
        // This is especially true for Cordova apps which have unreliable
        // navigator.onLine behavior unless cordova-plugin-network-information is
        // installed which overwrites the native navigator.onLine value and
        // defines navigator.connection.
        (_isHttpOrHttps() || isBrowserExtension() || 'connection' in navigator)) {
        return navigator.onLine;
    }
    // If we can't determine the state, assume it is online.
    return true;
}
function _getUserLanguage() {
    if (typeof navigator === 'undefined') {
        return null;
    }
    const navigatorLanguage = navigator;
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language ||
        // Couldn't determine language.
        null);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */
class Delay {
    constructor(shortDelay, longDelay) {
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = isMobileCordova() || isReactNative();
    }
    get() {
        if (!_isOnline()) {
            // Pick the shorter timeout.
            return Math.min(5000 /* OFFLINE */, this.shortDelay);
        }
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _emulatorUrl(config, path) {
    debugAssert(config.emulator, 'Emulator should always be set here');
    const { url } = config.emulator;
    if (!path) {
        return url;
    }
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FetchProvider {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) {
            this.headersImpl = headersImpl;
        }
        if (responseImpl) {
            this.responseImpl = responseImpl;
        }
    }
    static fetch() {
        if (this.fetchImpl) {
            return this.fetchImpl;
        }
        if (typeof self !== 'undefined' && 'fetch' in self) {
            return self.fetch;
        }
        debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) {
            return this.headersImpl;
        }
        if (typeof self !== 'undefined' && 'Headers' in self) {
            return self.Headers;
        }
        debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) {
            return this.responseImpl;
        }
        if (typeof self !== 'undefined' && 'Response' in self) {
            return self.Response;
        }
        debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Map from errors returned by the server to errors to developer visible errors
 */
const SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* CREDENTIAL_MISMATCH */]: "custom-token-mismatch" /* CREDENTIAL_MISMATCH */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* MISSING_CUSTOM_TOKEN */]: "internal-error" /* INTERNAL_ERROR */,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* INVALID_IDENTIFIER */]: "invalid-email" /* INVALID_EMAIL */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* MISSING_CONTINUE_URI */]: "internal-error" /* INTERNAL_ERROR */,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* INVALID_PASSWORD */]: "wrong-password" /* INVALID_PASSWORD */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* MISSING_PASSWORD */]: "internal-error" /* INTERNAL_ERROR */,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* EMAIL_EXISTS */]: "email-already-in-use" /* EMAIL_EXISTS */,
    ["PASSWORD_LOGIN_DISABLED" /* PASSWORD_LOGIN_DISABLED */]: "operation-not-allowed" /* OPERATION_NOT_ALLOWED */,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* INVALID_IDP_RESPONSE */]: "invalid-credential" /* INVALID_IDP_RESPONSE */,
    ["INVALID_PENDING_TOKEN" /* INVALID_PENDING_TOKEN */]: "invalid-credential" /* INVALID_IDP_RESPONSE */,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */]: "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* MISSING_REQ_TYPE */]: "internal-error" /* INTERNAL_ERROR */,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* EMAIL_NOT_FOUND */]: "user-not-found" /* USER_DELETED */,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* RESET_PASSWORD_EXCEED_LIMIT */]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */,
    ["EXPIRED_OOB_CODE" /* EXPIRED_OOB_CODE */]: "expired-action-code" /* EXPIRED_OOB_CODE */,
    ["INVALID_OOB_CODE" /* INVALID_OOB_CODE */]: "invalid-action-code" /* INVALID_OOB_CODE */,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* MISSING_OOB_CODE */]: "internal-error" /* INTERNAL_ERROR */,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */]: "requires-recent-login" /* CREDENTIAL_TOO_OLD_LOGIN_AGAIN */,
    ["INVALID_ID_TOKEN" /* INVALID_ID_TOKEN */]: "invalid-user-token" /* INVALID_AUTH */,
    ["TOKEN_EXPIRED" /* TOKEN_EXPIRED */]: "user-token-expired" /* TOKEN_EXPIRED */,
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */]: "user-token-expired" /* TOKEN_EXPIRED */,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* TOO_MANY_ATTEMPTS_TRY_LATER */]: "too-many-requests" /* TOO_MANY_ATTEMPTS_TRY_LATER */,
    // Phone Auth related errors.
    ["INVALID_CODE" /* INVALID_CODE */]: "invalid-verification-code" /* INVALID_CODE */,
    ["INVALID_SESSION_INFO" /* INVALID_SESSION_INFO */]: "invalid-verification-id" /* INVALID_SESSION_INFO */,
    ["INVALID_TEMPORARY_PROOF" /* INVALID_TEMPORARY_PROOF */]: "invalid-credential" /* INVALID_IDP_RESPONSE */,
    ["MISSING_SESSION_INFO" /* MISSING_SESSION_INFO */]: "missing-verification-id" /* MISSING_SESSION_INFO */,
    ["SESSION_EXPIRED" /* SESSION_EXPIRED */]: "code-expired" /* CODE_EXPIRED */,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* MISSING_ANDROID_PACKAGE_NAME */]: "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */,
    ["UNAUTHORIZED_DOMAIN" /* UNAUTHORIZED_DOMAIN */]: "unauthorized-continue-uri" /* UNAUTHORIZED_DOMAIN */,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* INVALID_OAUTH_CLIENT_ID */]: "invalid-oauth-client-id" /* INVALID_OAUTH_CLIENT_ID */,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ADMIN_ONLY_OPERATION */]: "admin-restricted-operation" /* ADMIN_ONLY_OPERATION */,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* INVALID_MFA_PENDING_CREDENTIAL */]: "invalid-multi-factor-session" /* INVALID_MFA_SESSION */,
    ["MFA_ENROLLMENT_NOT_FOUND" /* MFA_ENROLLMENT_NOT_FOUND */]: "multi-factor-info-not-found" /* MFA_INFO_NOT_FOUND */,
    ["MISSING_MFA_ENROLLMENT_ID" /* MISSING_MFA_ENROLLMENT_ID */]: "missing-multi-factor-info" /* MISSING_MFA_INFO */,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* MISSING_MFA_PENDING_CREDENTIAL */]: "missing-multi-factor-session" /* MISSING_MFA_SESSION */,
    ["SECOND_FACTOR_EXISTS" /* SECOND_FACTOR_EXISTS */]: "second-factor-already-in-use" /* SECOND_FACTOR_ALREADY_ENROLLED */,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* SECOND_FACTOR_LIMIT_EXCEEDED */]: "maximum-second-factor-count-exceeded" /* SECOND_FACTOR_LIMIT_EXCEEDED */,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* BLOCKING_FUNCTION_ERROR_RESPONSE */]: "internal-error" /* INTERNAL_ERROR */,
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);
function _addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) {
        return Object.assign(Object.assign({}, request), { tenantId: auth.tenantId });
    }
    return request;
}
async function _performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return _performFetchWithErrorHandling(auth, customErrorMap, async () => {
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* GET */) {
                params = request;
            }
            else {
                body = {
                    body: JSON.stringify(request)
                };
            }
        }
        const query = index_esm2017_querystring(Object.assign({ key: auth.config.apiKey }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */] = 'application/json';
        if (auth.languageCode) {
            headers["X-Firebase-Locale" /* X_FIREBASE_LOCALE */] = auth.languageCode;
        }
        return FetchProvider.fetch()(_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({ method,
            headers, referrerPolicy: 'no-referrer' }, body));
    });
}
async function _performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) {
            throw _makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */, json);
        }
        if (response.ok && !('errorMessage' in json)) {
            return json;
        }
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* FEDERATED_USER_ID_ALREADY_LINKED */) {
                throw _makeTaggedError(auth, "credential-already-in-use" /* CREDENTIAL_ALREADY_IN_USE */, json);
            }
            else if (serverErrorCode === "EMAIL_EXISTS" /* EMAIL_EXISTS */) {
                throw _makeTaggedError(auth, "email-already-in-use" /* EMAIL_EXISTS */, json);
            }
            const authError = errorMap[serverErrorCode] ||
                serverErrorCode
                    .toLowerCase()
                    .replace(/[_\s]+/g, '-');
            if (serverErrorMessage) {
                throw _errorWithCustomMessage(auth, authError, serverErrorMessage);
            }
            else {
                _fail(auth, authError);
            }
        }
    }
    catch (e) {
        if (e instanceof FirebaseError) {
            throw e;
        }
        _fail(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */);
    }
}
async function _performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = (await _performApiRequest(auth, method, path, request, customErrorMap));
    if ('mfaPendingCredential' in serverResponse) {
        _fail(auth, "multi-factor-auth-required" /* MFA_REQUIRED */, {
            _serverResponse: serverResponse
        });
    }
    return serverResponse;
}
function _getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) {
        return `${auth.config.apiScheme}://${base}`;
    }
    return _emulatorUrl(auth.config, base);
}
class NetworkTimeout {
    constructor(auth) {
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject) => {
            this.timer = setTimeout(() => {
                return reject(_createError(this.auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */));
            }, DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function _makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) {
        errorParams.email = response.email;
    }
    if (response.phoneNumber) {
        errorParams.phoneNumber = response.phoneNumber;
    }
    const error = _createError(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteAccount(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:delete" /* DELETE_ACCOUNT */, request);
}
async function deleteLinkedAccounts(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:update" /* SET_ACCOUNT_INFO */, request);
}
async function getAccountInfo(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:lookup" /* GET_ACCOUNT_INFO */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) {
        return undefined;
    }
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) {
            // Convert to UTC date string.
            return date.toUTCString();
        }
    }
    catch (e) {
        // Do nothing. undefined will be returned.
    }
    return undefined;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
function getIdToken(user, forceRefresh = false) {
    return getModularInstance(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identitfy the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getIdTokenResult(user, forceRefresh = false) {
    const userInternal = index_esm2017_getModularInstance(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = _parseToken(token);
    _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* INTERNAL_ERROR */);
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims,
        token,
        authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
        expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function _parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined ||
        payload === undefined ||
        signature === undefined) {
        _logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = base64Decode(payload);
        if (!decoded) {
            _logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    }
    catch (e) {
        _logError('Caught error parsing JWT payload as JSON', e);
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */
function _tokenExpiresIn(token) {
    const parsedToken = _parseToken(token);
    _assert(parsedToken, "internal-error" /* INTERNAL_ERROR */);
    _assert(typeof parsedToken.exp !== 'undefined', "internal-error" /* INTERNAL_ERROR */);
    _assert(typeof parsedToken.iat !== 'undefined', "internal-error" /* INTERNAL_ERROR */);
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) {
        return promise;
    }
    try {
        return await promise;
    }
    catch (e) {
        if (e instanceof FirebaseError && isUserInvalidated(e)) {
            if (user.auth.currentUser === user) {
                await user.auth.signOut();
            }
        }
        throw e;
    }
}
function isUserInvalidated({ code }) {
    return (code === `auth/${"user-disabled" /* USER_DISABLED */}` ||
        code === `auth/${"user-token-expired" /* TOKEN_EXPIRED */}`);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ProactiveRefresh {
    constructor(user) {
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */;
    }
    _start() {
        if (this.isRunning) {
            return;
        }
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) {
            return;
        }
        this.isRunning = false;
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
        }
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* RETRY_BACKOFF_MAX */);
            return interval;
        }
        else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* RETRY_BACKOFF_MIN */;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* OFFSET */;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) {
            // Just in case...
            return;
        }
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async () => {
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        }
        catch (e) {
            // Only retry on network errors
            if (e.code === `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */}`) {
                this.schedule(/* wasError */ true);
            }
            return;
        }
        this.schedule();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserMetadata {
    constructor(createdAt, lastLoginAt) {
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await _logoutIfInvalidated(user, getAccountInfo(auth, { idToken }));
    _assert(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* INTERNAL_ERROR */);
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length)
        ? extractProviderData(coreAccount.providerUserInfo)
        : [];
    const providerData = mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData,
        metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */
async function reload(user) {
    const userInternal = index_esm2017_getModularInstance(user);
    await _reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
    const deduped = original.filter(o => !newData.some(n => n.providerId === o.providerId));
    return [...deduped, ...newData];
}
function extractProviderData(providers) {
    return providers.map((_a) => {
        var { providerId } = _a, provider = __rest(_a, ["providerId"]);
        return {
            providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function requestStsToken(auth, refreshToken) {
    const response = await _performFetchWithErrorHandling(auth, {}, async () => {
        const body = index_esm2017_querystring({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost, apiKey } = auth.config;
        const url = _getFinalTarget(auth, tokenApiHost, "/v1/token" /* TOKEN */, `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* CONTENT_TYPE */] = 'application/x-www-form-urlencoded';
        return FetchProvider.fetch()(url, {
            method: "POST" /* POST */,
            headers,
            body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */
class StsTokenManager {
    constructor() {
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return (!this.expirationTime ||
            Date.now() > this.expirationTime - 30000 /* TOKEN_REFRESH */);
    }
    updateFromServerResponse(response) {
        _assert(response.idToken, "internal-error" /* INTERNAL_ERROR */);
        _assert(typeof response.idToken !== 'undefined', "internal-error" /* INTERNAL_ERROR */);
        _assert(typeof response.refreshToken !== 'undefined', "internal-error" /* INTERNAL_ERROR */);
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined'
            ? Number(response.expiresIn)
            : _tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        _assert(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* TOKEN_EXPIRED */);
        if (!forceRefresh && this.accessToken && !this.isExpired) {
            return this.accessToken;
        }
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken, refreshToken, expiresIn } = await requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken, accessToken, expirationTime } = object;
        const manager = new StsTokenManager();
        if (refreshToken) {
            _assert(typeof refreshToken === 'string', "internal-error" /* INTERNAL_ERROR */, {
                appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            _assert(typeof accessToken === 'string', "internal-error" /* INTERNAL_ERROR */, {
                appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            _assert(typeof expirationTime === 'number', "internal-error" /* INTERNAL_ERROR */, {
                appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return debugFail('not implemented');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function assertStringOrUndefined(assertion, appName) {
    _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* INTERNAL_ERROR */, { appName });
}
class UserImpl {
    constructor(_a) {
        var { uid, auth, stsTokenManager } = _a, opt = __rest(_a, ["uid", "auth", "stsTokenManager"]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* FIREBASE */;
        this.proactiveRefresh = new ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [...opt.providerData] : [];
        this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        _assert(accessToken, this.auth, "internal-error" /* INTERNAL_ERROR */);
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return getIdTokenResult(this, forceRefresh);
    }
    reload() {
        return reload(this);
    }
    _assign(user) {
        if (this === user) {
            return;
        }
        _assert(this.uid === user.uid, this.auth, "internal-error" /* INTERNAL_ERROR */);
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map(userInfo => (Object.assign({}, userInfo)));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        return new UserImpl(Object.assign(Object.assign({}, this), { auth, stsTokenManager: this.stsTokenManager._clone() }));
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        _assert(!this.reloadListener, this.auth, "internal-error" /* INTERNAL_ERROR */);
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) {
            this.reloadListener(userInfo);
        }
        else {
            // If no listener is subscribed yet, save the result so it's available when they do subscribe
            this.reloadUserInfo = userInfo;
        }
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken &&
            response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) {
            await _reloadWithoutSaving(this);
        }
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) {
            this.auth._notifyListenersIfCurrent(this);
        }
    }
    async delete() {
        const idToken = await this.getIdToken();
        await _logoutIfInvalidated(this, deleteAccount(this.auth, { idToken }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({ uid: this.uid, email: this.email || undefined, emailVerified: this.emailVerified, displayName: this.displayName || undefined, isAnonymous: this.isAnonymous, photoURL: this.photoURL || undefined, phoneNumber: this.phoneNumber || undefined, tenantId: this.tenantId || undefined, providerData: this.providerData.map(userInfo => (Object.assign({}, userInfo))), stsTokenManager: this.stsTokenManager.toJSON(), 
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId }, this.metadata.toJSON()), { 
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey, appName: this.auth.name });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid, emailVerified, isAnonymous, providerData, stsTokenManager: plainObjectTokenManager } = object;
        _assert(uid && plainObjectTokenManager, auth, "internal-error" /* INTERNAL_ERROR */);
        const stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        _assert(typeof uid === 'string', auth, "internal-error" /* INTERNAL_ERROR */);
        assertStringOrUndefined(displayName, auth.name);
        assertStringOrUndefined(email, auth.name);
        _assert(typeof emailVerified === 'boolean', auth, "internal-error" /* INTERNAL_ERROR */);
        _assert(typeof isAnonymous === 'boolean', auth, "internal-error" /* INTERNAL_ERROR */);
        assertStringOrUndefined(phoneNumber, auth.name);
        assertStringOrUndefined(photoURL, auth.name);
        assertStringOrUndefined(tenantId, auth.name);
        assertStringOrUndefined(_redirectEventId, auth.name);
        assertStringOrUndefined(createdAt, auth.name);
        assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new UserImpl({
            uid,
            auth,
            email,
            emailVerified,
            displayName,
            isAnonymous,
            photoURL,
            phoneNumber,
            tenantId,
            stsTokenManager,
            createdAt,
            lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) {
            user.providerData = providerData.map(userInfo => (Object.assign({}, userInfo)));
        }
        if (_redirectEventId) {
            user._redirectEventId = _redirectEventId;
        }
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */
    static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: idTokenResponse.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await _reloadWithoutSaving(user);
        return user;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class InMemoryPersistence {
    constructor() {
        this.type = "NONE" /* NONE */;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */
const inMemoryPersistence = InMemoryPersistence;

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _persistenceKeyName(key, apiKey, appName) {
    return `${"firebase" /* PERSISTENCE */}:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
    constructor(persistence, auth, userKey) {
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config, name } = this.auth;
        this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = _persistenceKeyName("persistence" /* PERSISTENCE_USER */, config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? UserImpl._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) {
            return;
        }
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) {
            return this.setCurrentUser(currentUser);
        }
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* AUTH_USER */) {
        if (!persistenceHierarchy.length) {
            return new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey);
        }
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence) => {
            if (await persistence._isAvailable()) {
                return persistence;
            }
            return undefined;
        }))).filter(persistence => persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] ||
            _getInstance(inMemoryPersistence);
        const key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy) {
            try {
                const blob = await persistence._get(key);
                if (blob) {
                    const user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                    if (persistence !== selectedPersistence) {
                        userToMigrate = user;
                    }
                    selectedPersistence = persistence;
                    break;
                }
            }
            catch (_a) { }
        }
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter(p => p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration ||
            !migrationHierarchy.length) {
            return new PersistenceUserManager(selectedPersistence, auth, userKey);
        }
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) {
            // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
            // we'll just let it bubble to surface the error.
            await selectedPersistence._set(key, userToMigrate.toJSON());
        }
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence) => {
            if (persistence !== selectedPersistence) {
                try {
                    await persistence._remove(key);
                }
                catch (_a) { }
            }
        }));
        return new PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Determine the browser for the purposes of reporting usage to the API
 */
function _getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) {
        return "Opera" /* OPERA */;
    }
    else if (_isIEMobile(ua)) {
        // Windows phone IEMobile browser.
        return "IEMobile" /* IEMOBILE */;
    }
    else if (ua.includes('msie') || ua.includes('trident/')) {
        return "IE" /* IE */;
    }
    else if (ua.includes('edge/')) {
        return "Edge" /* EDGE */;
    }
    else if (_isFirefox(ua)) {
        return "Firefox" /* FIREFOX */;
    }
    else if (ua.includes('silk/')) {
        return "Silk" /* SILK */;
    }
    else if (_isBlackBerry(ua)) {
        // Blackberry browser.
        return "Blackberry" /* BLACKBERRY */;
    }
    else if (_isWebOS(ua)) {
        // WebOS default browser.
        return "Webos" /* WEBOS */;
    }
    else if (_isSafari(ua)) {
        return "Safari" /* SAFARI */;
    }
    else if ((ua.includes('chrome/') || _isChromeIOS(ua)) &&
        !ua.includes('edge/')) {
        return "Chrome" /* CHROME */;
    }
    else if (_isAndroid(ua)) {
        // Android stock browser.
        return "Android" /* ANDROID */;
    }
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) {
            return matches[1];
        }
    }
    return "Other" /* OTHER */;
}
function _isFirefox(ua = index_esm2017_getUA()) {
    return /firefox\//i.test(ua);
}
function _isSafari(userAgent = index_esm2017_getUA()) {
    const ua = userAgent.toLowerCase();
    return (ua.includes('safari/') &&
        !ua.includes('chrome/') &&
        !ua.includes('crios/') &&
        !ua.includes('android'));
}
function _isChromeIOS(ua = index_esm2017_getUA()) {
    return /crios\//i.test(ua);
}
function _isIEMobile(ua = index_esm2017_getUA()) {
    return /iemobile/i.test(ua);
}
function _isAndroid(ua = index_esm2017_getUA()) {
    return /android/i.test(ua);
}
function _isBlackBerry(ua = index_esm2017_getUA()) {
    return /blackberry/i.test(ua);
}
function _isWebOS(ua = index_esm2017_getUA()) {
    return /webos/i.test(ua);
}
function _isIOS(ua = index_esm2017_getUA()) {
    return /iphone|ipad|ipod/i.test(ua);
}
function _isIOS7Or8(ua = getUA()) {
    return (/(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) ||
        /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua));
}
function _isIOSStandalone(ua = index_esm2017_getUA()) {
    var _a;
    return _isIOS(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function _isIE10() {
    return isIE() && document.documentMode === 10;
}
function _isMobileBrowser(ua = index_esm2017_getUA()) {
    // TODO: implement getBrowserName equivalent for OS.
    return (_isIOS(ua) ||
        _isAndroid(ua) ||
        _isWebOS(ua) ||
        _isBlackBerry(ua) ||
        /windows phone/i.test(ua) ||
        _isIEMobile(ua));
}
function _isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    }
    catch (e) {
        return false;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * Determine the SDK version string
 */
function _getClientVersion(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch (clientPlatform) {
        case "Browser" /* BROWSER */:
            // In a browser environment, report the browser name.
            reportedPlatform = _getBrowserName(index_esm2017_getUA());
            break;
        case "Worker" /* WORKER */:
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${_getBrowserName(index_esm2017_getUA())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length
        ? frameworks.join(',')
        : 'FirebaseCore-web'; /* default value if no other framework is used */
    return `${reportedPlatform}/${"JsCore" /* CORE */}/${SDK_VERSION}/${reportedFrameworks}`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthImpl {
    constructor(app, heartbeatServiceProvider, config) {
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new Subscription(this);
        this.idTokenSubscription = new Subscription(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = { appVerificationDisabledForTesting: false };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) {
            this._popupRedirectResolver = _getInstance(popupRedirectResolver);
        }
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async () => {
            var _a, _b;
            if (this._deleted) {
                return;
            }
            this.persistenceManager = await PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) {
                return;
            }
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) {
                // If this fails, don't halt auth loading
                try {
                    await this._popupRedirectResolver._initialize(this);
                }
                catch (e) { /* Ignore the error */ }
            }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) {
                return;
            }
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */
    async _onStorageEvent() {
        if (this._deleted) {
            return;
        }
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) {
            // No change, do nothing (was signed out and remained signed out).
            return;
        }
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        await this._updateCurrentUser(user);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        let storedUser = (await this.assertedPersistence.getCurrentUser());
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = storedUser === null || storedUser === void 0 ? void 0 : storedUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) &&
                (result === null || result === void 0 ? void 0 : result.user)) {
                storedUser = result.user;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!storedUser) {
            return this.directlySetCurrentUser(null);
        }
        if (!storedUser._redirectEventId) {
            // This isn't a redirect user, we can reload and bail
            // This will also catch the redirected user, if available, as that method
            // strips the _redirectEventId
            return this.reloadAndSetCurrentUserOrClear(storedUser);
        }
        _assert(this._popupRedirectResolver, this, "argument-error" /* ARGUMENT_ERROR */);
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser &&
            this.redirectUser._redirectEventId === storedUser._redirectEventId) {
            return this.directlySetCurrentUser(storedUser);
        }
        return this.reloadAndSetCurrentUserOrClear(storedUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        }
        catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await _reloadWithoutSaving(user);
        }
        catch (e) {
            if (e.code !== `auth/${"network-request-failed" /* NETWORK_REQUEST_FAILED */}`) {
                // Something's wrong with the user's token. Log them out and remove
                // them from storage
                return this.directlySetCurrentUser(null);
            }
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = _getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern
            ? index_esm2017_getModularInstance(userExtern)
            : null;
        if (user) {
            _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* INVALID_AUTH */);
        }
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user) {
        if (this._deleted) {
            return;
        }
        if (user) {
            _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */);
        }
        return this.queue(async () => {
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) {
            await this._setRedirectUser(null);
        }
        return this._updateCurrentUser(null);
    }
    setPersistence(persistence) {
        return this.queue(async () => {
            await this.assertedPersistence.setPersistence(_getInstance(persistence));
        });
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new ErrorFactory('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null
            ? redirectManager.removeCurrentUser()
            : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = (popupRedirectResolver && _getInstance(popupRedirectResolver)) ||
                this._popupRedirectResolver;
            _assert(resolver, this, "argument-error" /* ARGUMENT_ERROR */);
            this.redirectPersistenceManager = await PersistenceUserManager.create(this, [_getInstance(resolver._redirectPersistence)], "redirectUser" /* REDIRECT_USER */);
            this.redirectUser =
                await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) {
            await this.queue(async () => { });
        }
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) {
            return this._currentUser;
        }
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) {
            return this.redirectUser;
        }
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) {
            return this.queue(async () => this.directlySetCurrentUser(user));
        }
    }
    /** Notifies listeners only if the user is current */
    _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) {
            this.notifyAuthListeners();
        }
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) {
            this._currentUser._startProactiveRefresh();
        }
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) {
            this._currentUser._stopProactiveRefresh();
        }
    }
    /** Returns the current user cast as the internal type */
    get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) {
            return;
        }
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) {
            return () => { };
        }
        const cb = typeof nextOrObserver === 'function'
            ? nextOrObserver
            : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized
            ? Promise.resolve()
            : this._initializationPromise;
        _assert(promise, this, "internal-error" /* INTERNAL_ERROR */);
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(() => cb(this.currentUser));
        if (typeof nextOrObserver === 'function') {
            return subscription.addObserver(nextOrObserver, error, completed);
        }
        else {
            return subscription.addObserver(nextOrObserver);
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */
    async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) {
            this._currentUser._stopProactiveRefresh();
            if (user && this.isProactiveRefreshEnabled) {
                user._startProactiveRefresh();
            }
        }
        this.currentUser = user;
        if (user) {
            await this.assertedPersistence.setCurrentUser(user);
        }
        else {
            await this.assertedPersistence.removeCurrentUser();
        }
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        _assert(this.persistenceManager, this, "internal-error" /* INTERNAL_ERROR */);
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) {
            return;
        }
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* X_CLIENT_VERSION */]: this.clientVersion,
        };
        if (this.app.options.appId) {
            headers["X-Firebase-gmpid" /* X_FIREBASE_GMPID */] = this.app.options.appId;
        }
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true,
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) {
            headers["X-Firebase-Client" /* X_FIREBASE_CLIENT */] = heartbeatsHeader;
        }
        return headers;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */
function _castAuth(auth) {
    return index_esm2017_getModularInstance(auth);
}
/** Helper class to wrap subscriber logic */
class Subscription {
    constructor(auth) {
        this.auth = auth;
        this.observer = null;
        this.addObserver = createSubscribe(observer => (this.observer = observer));
    }
    get next() {
        _assert(this.observer, this.auth, "internal-error" /* INTERNAL_ERROR */);
        return this.observer.next.bind(this.observer);
    }
}

/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */
function connectAuthEmulator(auth, url, options) {
    const authInternal = _castAuth(auth);
    _assert(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* EMULATOR_CONFIG_FAILED */);
    _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* INVALID_EMULATOR_SCHEME */);
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = extractProtocol(url);
    const { host, port } = extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = { url: `${protocol}//${host}${portStr}/` };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host,
        port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({ disableWarnings })
    });
    if (!disableWarnings) {
        emitEmulatorWarning();
    }
}
function extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
    const protocol = extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) {
        return { host: '', port: null };
    }
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return { host, port: parsePort(hostAndPort.substr(host.length + 1)) };
    }
    else {
        const [host, port] = hostAndPort.split(':');
        return { host, port: parsePort(port) };
    }
}
function parsePort(portStr) {
    if (!portStr) {
        return null;
    }
    const port = Number(portStr);
    if (isNaN(port)) {
        return null;
    }
    return port;
}
function emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText =
            'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') {
        console.info('WARNING: You are using the Auth Emulator,' +
            ' which is intended for local testing only.  Do not use with' +
            ' production credentials.');
    }
    if (typeof window !== 'undefined' &&
        typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            window.addEventListener('DOMContentLoaded', attachBanner);
        }
        else {
            attachBanner();
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */
class AuthCredential {
    /** @internal */
    constructor(
    /**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */
    providerId, 
    /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */
    signInMethod) {
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */
    toJSON() {
        return debugFail('not implemented');
    }
    /** @internal */
    _getIdTokenResponse(_auth) {
        return debugFail('not implemented');
    }
    /** @internal */
    _linkToIdToken(_auth, _idToken) {
        return debugFail('not implemented');
    }
    /** @internal */
    _getReauthenticationResolver(_auth) {
        return debugFail('not implemented');
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function resetPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:resetPassword" /* RESET_PASSWORD */, _addTidIfNecessary(auth, request));
}
async function updateEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:update" /* SET_ACCOUNT_INFO */, request);
}
async function applyActionCode$1(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:update" /* SET_ACCOUNT_INFO */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithPassword(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithPassword" /* SIGN_IN_WITH_PASSWORD */, _addTidIfNecessary(auth, request));
}
async function sendOobCode(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:sendOobCode" /* SEND_OOB_CODE */, _addTidIfNecessary(auth, request));
}
async function sendEmailVerification$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendPasswordResetEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendSignInLinkToEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function verifyAndChangeEmail(auth, request) {
    return sendOobCode(auth, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithEmailLink$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */, _addTidIfNecessary(auth, request));
}
async function signInWithEmailLinkForLinking(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithEmailLink" /* SIGN_IN_WITH_EMAIL_LINK */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */
class EmailAuthCredential extends AuthCredential {
    /** @internal */
    constructor(
    /** @internal */
    _email, 
    /** @internal */
    _password, signInMethod, 
    /** @internal */
    _tenantId = null) {
        super("password" /* PASSWORD */, signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */
    static _fromEmailAndPassword(email, password) {
        return new EmailAuthCredential(email, password, "password" /* EMAIL_PASSWORD */);
    }
    /** @internal */
    static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new EmailAuthCredential(email, oobCode, "emailLink" /* EMAIL_LINK */, tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */
    toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* EMAIL_PASSWORD */) {
                return this._fromEmailAndPassword(obj.email, obj.password);
            }
            else if (obj.signInMethod === "emailLink" /* EMAIL_LINK */) {
                return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
            }
        }
        return null;
    }
    /** @internal */
    async _getIdTokenResponse(auth) {
        switch (this.signInMethod) {
            case "password" /* EMAIL_PASSWORD */:
                return signInWithPassword(auth, {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */:
                return signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* INTERNAL_ERROR */);
        }
    }
    /** @internal */
    async _linkToIdToken(auth, idToken) {
        switch (this.signInMethod) {
            case "password" /* EMAIL_PASSWORD */:
                return updateEmailPassword(auth, {
                    idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* EMAIL_LINK */:
                return signInWithEmailLinkForLinking(auth, {
                    idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* INTERNAL_ERROR */);
        }
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithIdp(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithIdp" /* SIGN_IN_WITH_IDP */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */
class OAuthCredential extends AuthCredential {
    constructor() {
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */
    static _fromParams(params) {
        const cred = new OAuthCredential(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) {
                cred.idToken = params.idToken;
            }
            if (params.accessToken) {
                cred.accessToken = params.accessToken;
            }
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) {
                cred.nonce = params.nonce;
            }
            if (params.pendingToken) {
                cred.pendingToken = params.pendingToken;
            }
        }
        else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        }
        else {
            _fail("argument-error" /* ARGUMENT_ERROR */);
        }
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */
    toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod } = obj, rest = __rest(obj, ["providerId", "signInMethod"]);
        if (!providerId || !signInMethod) {
            return null;
        }
        const cred = new OAuthCredential(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) {
            request.pendingToken = this.pendingToken;
        }
        else {
            const postBody = {};
            if (this.idToken) {
                postBody['id_token'] = this.idToken;
            }
            if (this.accessToken) {
                postBody['access_token'] = this.accessToken;
            }
            if (this.secret) {
                postBody['oauth_token_secret'] = this.secret;
            }
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) {
                postBody['nonce'] = this.nonce;
            }
            request.postBody = index_esm2017_querystring(postBody);
        }
        return request;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function sendPhoneVerificationCode(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:sendVerificationCode" /* SEND_VERIFICATION_CODE */, _addTidIfNecessary(auth, request));
}
async function signInWithPhoneNumber$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, request));
}
async function linkWithPhoneNumber$1(auth, request) {
    const response = await _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, request));
    if (response.temporaryProof) {
        throw _makeTaggedError(auth, "account-exists-with-different-credential" /* NEED_CONFIRMATION */, response);
    }
    return response;
}
const VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* USER_NOT_FOUND */]: "user-not-found" /* USER_DELETED */
};
async function verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), { operation: 'REAUTH' });
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithPhoneNumber" /* SIGN_IN_WITH_PHONE_NUMBER */, _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */
class PhoneAuthCredential extends AuthCredential {
    constructor(params) {
        super("phone" /* PHONE */, "phone" /* PHONE */);
        this.params = params;
    }
    /** @internal */
    static _fromVerification(verificationId, verificationCode) {
        return new PhoneAuthCredential({ verificationId, verificationCode });
    }
    /** @internal */
    static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new PhoneAuthCredential({ phoneNumber, temporaryProof });
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        return linkWithPhoneNumber$1(auth, Object.assign({ idToken }, this._makeVerificationRequest()));
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */
    _makeVerificationRequest() {
        const { temporaryProof, phoneNumber, verificationId, verificationCode } = this.params;
        if (temporaryProof && phoneNumber) {
            return { temporaryProof, phoneNumber };
        }
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */
    toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) {
            obj.phoneNumber = this.params.phoneNumber;
        }
        if (this.params.temporaryProof) {
            obj.temporaryProof = this.params.temporaryProof;
        }
        if (this.params.verificationCode) {
            obj.verificationCode = this.params.verificationCode;
        }
        if (this.params.verificationId) {
            obj.verificationId = this.params.verificationId;
        }
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */
    static fromJSON(json) {
        if (typeof json === 'string') {
            json = JSON.parse(json);
        }
        const { verificationId, verificationCode, phoneNumber, temporaryProof } = json;
        if (!verificationCode &&
            !verificationId &&
            !phoneNumber &&
            !temporaryProof) {
            return null;
        }
        return new PhoneAuthCredential({
            verificationId,
            verificationCode,
            phoneNumber,
            temporaryProof
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */
function parseMode(mode) {
    switch (mode) {
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* RECOVER_EMAIL */;
        case 'resetPassword':
            return "PASSWORD_RESET" /* PASSWORD_RESET */;
        case 'signIn':
            return "EMAIL_SIGNIN" /* EMAIL_SIGNIN */;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* VERIFY_EMAIL */;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */
function parseDeepLink(url) {
    const link = querystringDecode(extractQuerystring(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link
        ? querystringDecode(extractQuerystring(link))['deep_link_id']
        : null;
    // iOS custom scheme links.
    const iOSDeepLink = querystringDecode(extractQuerystring(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink
        ? querystringDecode(extractQuerystring(iOSDeepLink))['link']
        : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */
class ActionCodeURL {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */
    constructor(actionLink) {
        var _a, _b, _c, _d, _e, _f;
        const searchParams = querystringDecode(extractQuerystring(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* API_KEY */]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* CODE */]) !== null && _b !== void 0 ? _b : null;
        const operation = parseMode((_c = searchParams["mode" /* MODE */]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        _assert(apiKey && code && operation, "argument-error" /* ARGUMENT_ERROR */);
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* CONTINUE_URL */]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* LANGUAGE_CODE */]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* TENANT_ID */]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */
    static parseLink(link) {
        const actionLink = parseDeepLink(link);
        try {
            return new ActionCodeURL(actionLink);
        }
        catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */
function parseActionCodeURL(link) {
    return ActionCodeURL.parseLink(link);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */
class EmailAuthProvider {
    constructor() {
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */
        this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */
    static credential(email, password) {
        return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */
    static credentialWithLink(email, emailLink) {
        const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
        _assert(actionCodeUrl, "argument-error" /* ARGUMENT_ERROR */);
        return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */
EmailAuthProvider.PROVIDER_ID = "password" /* PASSWORD */;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */
EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* EMAIL_PASSWORD */;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */
EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* EMAIL_LINK */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */
class FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */
    constructor(providerId) {
        this.providerId = providerId;
        /** @internal */
        this.defaultLanguageCode = null;
        /** @internal */
        this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */
    setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */
    setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */
    getCustomParameters() {
        return this.customParameters;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */
class BaseOAuthProvider extends FederatedAuthProvider {
    constructor() {
        super(...arguments);
        /** @internal */
        this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */
    addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) {
            this.scopes.push(scope);
        }
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */
    getScopes() {
        return [...this.scopes];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */
class OAuthProvider extends BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */
    static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        _assert('providerId' in obj && 'signInMethod' in obj, "argument-error" /* ARGUMENT_ERROR */);
        return OAuthCredential._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */
    credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), { nonce: params.rawNonce }));
    }
    /** An internal credential method that accepts more permissive options */
    _credential(params) {
        _assert(params.idToken || params.accessToken, "argument-error" /* ARGUMENT_ERROR */);
        // For OAuthCredential, sign in method is same as providerId.
        return OAuthCredential._fromParams(Object.assign(Object.assign({}, params), { providerId: this.providerId, signInMethod: this.providerId }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return OAuthProvider.oauthCredentialFromTaggedObject((error.customData || {}));
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthIdToken, oauthAccessToken, oauthTokenSecret, pendingToken, nonce, providerId } = tokenResponse;
        if (!oauthAccessToken &&
            !oauthTokenSecret &&
            !oauthIdToken &&
            !pendingToken) {
            return null;
        }
        if (!providerId) {
            return null;
        }
        try {
            return new OAuthProvider(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce,
                pendingToken
            });
        }
        catch (e) {
            return null;
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */
class FacebookAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("facebook.com" /* FACEBOOK */);
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */
    static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: FacebookAuthProvider.PROVIDER_ID,
            signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return FacebookAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) {
            return null;
        }
        if (!tokenResponse.oauthAccessToken) {
            return null;
        }
        try {
            return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */
FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* FACEBOOK */;
/** Always set to {@link ProviderId}.FACEBOOK. */
FacebookAuthProvider.PROVIDER_ID = "facebook.com" /* FACEBOOK */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */
class GoogleAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("google.com" /* GOOGLE */);
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */
    static credential(idToken, accessToken) {
        return OAuthCredential._fromParams({
            providerId: GoogleAuthProvider.PROVIDER_ID,
            signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
            idToken,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return GoogleAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthIdToken, oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) {
            // This could be an oauth 1 credential or a phone credential
            return null;
        }
        try {
            return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */
GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com" /* GOOGLE */;
/** Always set to {@link ProviderId}.GOOGLE. */
GoogleAuthProvider.PROVIDER_ID = "google.com" /* GOOGLE */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */
class GithubAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("github.com" /* GITHUB */);
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */
    static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: GithubAuthProvider.PROVIDER_ID,
            signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return GithubAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) {
            return null;
        }
        if (!tokenResponse.oauthAccessToken) {
            return null;
        }
        try {
            return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */
GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com" /* GITHUB */;
/** Always set to {@link ProviderId}.GITHUB. */
GithubAuthProvider.PROVIDER_ID = "github.com" /* GITHUB */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */
class SAMLAuthCredential extends (/* unused pure expression or super */ null && (AuthCredential)) {
    /** @internal */
    constructor(providerId, pendingToken) {
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */
    _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */
    _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */
    toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */
    static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, pendingToken } = obj;
        if (!providerId ||
            !signInMethod ||
            !pendingToken ||
            providerId !== signInMethod) {
            return null;
        }
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */
    static _create(providerId, pendingToken) {
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */
class SAMLAuthProvider extends (/* unused pure expression or super */ null && (FederatedAuthProvider)) {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */
    constructor(providerId) {
        _assert(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error" /* ARGUMENT_ERROR */);
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject((error.customData || {}));
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */
    static credentialFromJSON(json) {
        const credential = SAMLAuthCredential.fromJSON(json);
        _assert(credential, "argument-error" /* ARGUMENT_ERROR */);
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { pendingToken, providerId } = tokenResponse;
        if (!pendingToken || !providerId) {
            return null;
        }
        try {
            return SAMLAuthCredential._create(providerId, pendingToken);
        }
        catch (e) {
            return null;
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */
class TwitterAuthProvider extends BaseOAuthProvider {
    constructor() {
        super("twitter.com" /* TWITTER */);
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */
    static credential(token, secret) {
        return OAuthCredential._fromParams({
            providerId: TwitterAuthProvider.PROVIDER_ID,
            signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */
    static credentialFromError(error) {
        return TwitterAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) {
            return null;
        }
        try {
            return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
        }
        catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */
TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com" /* TWITTER */;
/** Always set to {@link ProviderId}.TWITTER. */
TwitterAuthProvider.PROVIDER_ID = "twitter.com" /* TWITTER */;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signUp(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signUp" /* SIGN_UP */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UserCredentialImpl {
    constructor(params) {
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = providerIdForResponse(idTokenResponse);
        const userCred = new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: idTokenResponse,
            operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = providerIdForResponse(response);
        return new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: response,
            operationType
        });
    }
}
function providerIdForResponse(response) {
    if (response.providerId) {
        return response.providerId;
    }
    if ('phoneNumber' in response) {
        return "phone" /* PHONE */;
    }
    return null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
async function signInAnonymously(auth) {
    var _a;
    const authInternal = _castAuth(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) {
        // If an anonymous user is already signed in, no need to sign them in again.
        return new UserCredentialImpl({
            user: authInternal.currentUser,
            providerId: null,
            operationType: "signIn" /* SIGN_IN */
        });
    }
    const response = await signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */, response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorError extends FirebaseError {
    constructor(auth, error, operationType, user) {
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType,
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new MultiFactorError(auth, error, operationType, user);
    }
}
function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* REAUTHENTICATE */
        ? credential._getReauthenticationResolver(auth)
        : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch(error => {
        if (error.code === `auth/${"multi-factor-auth-required" /* MFA_REQUIRED */}`) {
            throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        }
        throw error;
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */
function providerDataAsNames(providerData) {
    return new Set(providerData
        .map(({ providerId }) => providerId)
        .filter(pid => !!pid));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */
async function unlink(user, providerId) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo } = await deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [providerId]
    });
    const providersLeft = providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter(pd => providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* PHONE */)) {
        userInternal.phoneNumber = null;
    }
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function _link$1(user, credential, bypassAuthState = false) {
    const response = await _logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return UserCredentialImpl._forOperation(user, "link" /* LINK */, response);
}
async function _assertLinkedStatus(expected, user, provider) {
    await _reloadWithoutSaving(user);
    const providerIds = providerDataAsNames(user.providerData);
    const code = expected === false
        ? "provider-already-linked" /* PROVIDER_ALREADY_LINKED */
        : "no-such-provider" /* NO_SUCH_PROVIDER */;
    _assert(providerIds.has(provider) === expected, user.auth, code);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _reauthenticate(user, credential, bypassAuthState = false) {
    const { auth } = user;
    const operationType = "reauthenticate" /* REAUTHENTICATE */;
    try {
        const response = await _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        _assert(response.idToken, auth, "internal-error" /* INTERNAL_ERROR */);
        const parsed = _parseToken(response.idToken);
        _assert(parsed, auth, "internal-error" /* INTERNAL_ERROR */);
        const { sub: localId } = parsed;
        _assert(user.uid === localId, auth, "user-mismatch" /* USER_MISMATCH */);
        return UserCredentialImpl._forOperation(user, operationType, response);
    }
    catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* USER_DELETED */}`) {
            _fail(auth, "user-mismatch" /* USER_MISMATCH */);
        }
        throw e;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* SIGN_IN */;
    const response = await _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) {
        await auth._updateCurrentUser(userCredential.user);
    }
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */
async function signInWithCredential(auth, credential) {
    return _signInWithCredential(_castAuth(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */
async function linkWithCredential(user, credential) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(false, userInternal, credential.providerId);
    return _link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */
async function reauthenticateWithCredential(user, credential) {
    return _reauthenticate(getModularInstance(user), credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function signInWithCustomToken$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* POST */, "/v1/accounts:signInWithCustomToken" /* SIGN_IN_WITH_CUSTOM_TOKEN */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */
async function signInWithCustomToken(auth, customToken) {
    const authInternal = _castAuth(auth);
    const response = await signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */, response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorInfoImpl {
    constructor(factorId, response) {
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) {
            return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        }
        return _fail(auth, "internal-error" /* INTERNAL_ERROR */);
    }
}
class PhoneMultiFactorInfoImpl extends (/* unused pure expression or super */ null && (MultiFactorInfoImpl)) {
    constructor(response) {
        super("phone" /* PHONE */, response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new PhoneMultiFactorInfoImpl(enrollment);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    _assert(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* INVALID_CONTINUE_URI */);
    _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' ||
        actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* INVALID_DYNAMIC_LINK_DOMAIN */);
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* MISSING_IOS_BUNDLE_ID */);
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* MISSING_ANDROID_PACKAGE_NAME */);
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode =
            actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendPasswordResetEmail(auth, email, actionCodeSettings) {
    const authModular = getModularInstance(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* PASSWORD_RESET */,
        email
    };
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    }
    await sendPasswordResetEmail$1(authModular, request);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */
async function confirmPasswordReset(auth, oobCode, newPassword) {
    await resetPassword(getModularInstance(auth), {
        oobCode,
        newPassword
    });
    // Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */
async function applyActionCode(auth, oobCode) {
    await applyActionCode$1(getModularInstance(auth), { oobCode });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */
async function checkActionCode(auth, oobCode) {
    const authModular = getModularInstance(auth);
    const response = await resetPassword(authModular, { oobCode });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    _assert(operation, authModular, "internal-error" /* INTERNAL_ERROR */);
    switch (operation) {
        case "EMAIL_SIGNIN" /* EMAIL_SIGNIN */:
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */:
            _assert(response.newEmail, authModular, "internal-error" /* INTERNAL_ERROR */);
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* REVERT_SECOND_FACTOR_ADDITION */:
            _assert(response.mfaInfo, authModular, "internal-error" /* INTERNAL_ERROR */);
        // fall through
        default:
            _assert(response.email, authModular, "internal-error" /* INTERNAL_ERROR */);
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) {
        multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
    }
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */
                ? response.newEmail
                : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */
                ? response.email
                : response.newEmail) || null,
            multiFactorInfo
        },
        operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */
async function verifyPasswordResetCode(auth, code) {
    const { data } = await checkActionCode(getModularInstance(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */
async function createUserWithEmailAndPassword(auth, email, password) {
    const authInternal = _castAuth(auth);
    const response = await signUp(authInternal, {
        returnSecureToken: true,
        email,
        password
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* SIGN_IN */, response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */
function signInWithEmailAndPassword(auth, email, password) {
    return signInWithCredential(getModularInstance(auth), EmailAuthProvider.credential(email, password));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendSignInLinkToEmail(auth, email, actionCodeSettings) {
    const authModular = getModularInstance(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* EMAIL_SIGNIN */,
        email
    };
    _assert(actionCodeSettings.handleCodeInApp, authModular, "argument-error" /* ARGUMENT_ERROR */);
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(authModular, request, actionCodeSettings);
    }
    await sendSignInLinkToEmail$1(authModular, request);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */
function isSignInWithEmailLink(auth, emailLink) {
    const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* EMAIL_SIGNIN */;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */
async function signInWithEmailLink(auth, email, emailLink) {
    const authModular = getModularInstance(auth);
    const credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    _assert(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* TENANT_ID_MISMATCH */);
    return signInWithCredential(authModular, credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createAuthUri(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:createAuthUri" /* CREATE_AUTH_URI */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */
async function fetchSignInMethodsForEmail(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = _isHttpOrHttps() ? _getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri
    };
    const { signinMethods } = await createAuthUri(getModularInstance(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function sendEmailVerification(user, actionCodeSettings) {
    const userInternal = getModularInstance(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* VERIFY_EMAIL */,
        idToken
    };
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    }
    const { email } = await sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) {
        await user.reload();
    }
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */
async function verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings) {
    const userInternal = getModularInstance(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* VERIFY_AND_CHANGE_EMAIL */,
        idToken,
        newEmail
    };
    if (actionCodeSettings) {
        _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    }
    const { email } = await verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) {
        // If the local copy of the email on user is outdated, reload the
        // user.
        await user.reload();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function updateProfile$1(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v1/accounts:update" /* SET_ACCOUNT_INFO */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */
async function updateProfile(user, { displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) {
        return;
    }
    const userInternal = getModularInstance(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken,
        displayName,
        photoUrl,
        returnSecureToken: true
    };
    const response = await _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId }) => providerId === "password" /* PASSWORD */);
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */
function updateEmail(user, newEmail) {
    return updateEmailOrPassword(getModularInstance(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */
function updatePassword(user, newPassword) {
    return updateEmailOrPassword(getModularInstance(user), null, newPassword);
}
async function updateEmailOrPassword(user, email, password) {
    const { auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken,
        returnSecureToken: true
    };
    if (email) {
        request.email = email;
    }
    if (password) {
        request.password = password;
    }
    const response = await _logoutIfInvalidated(user, updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */
function _fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) {
        return null;
    }
    const { providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo
        ? JSON.parse(idTokenResponse.rawUserInfo)
        : {};
    const isNewUser = idTokenResponse.isNewUser ||
        idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* SignupNewUser */;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = _parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ANONYMOUS */ &&
                signInProvider !== "custom" /* CUSTOM */
                ? signInProvider
                : null;
            // Uses generic class in accordance with the legacy SDK.
            return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) {
        return null;
    }
    switch (providerId) {
        case "facebook.com" /* FACEBOOK */:
            return new FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* GITHUB */:
            return new GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* GOOGLE */:
            return new GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* TWITTER */:
            return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* CUSTOM */:
        case "anonymous" /* ANONYMOUS */:
            return new GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}) {
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class FederatedAdditionalUserInfoWithUsername extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, providerId, profile, username) {
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class FacebookAdditionalUserInfo extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "facebook.com" /* FACEBOOK */, profile);
    }
}
class GithubAdditionalUserInfo extends (/* unused pure expression or super */ null && (FederatedAdditionalUserInfoWithUsername)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "github.com" /* GITHUB */, profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class GoogleAdditionalUserInfo extends (/* unused pure expression or super */ null && (GenericAdditionalUserInfo)) {
    constructor(isNewUser, profile) {
        super(isNewUser, "google.com" /* GOOGLE */, profile);
    }
}
class TwitterAdditionalUserInfo extends (/* unused pure expression or super */ null && (FederatedAdditionalUserInfoWithUsername)) {
    constructor(isNewUser, profile, screenName) {
        super(isNewUser, "twitter.com" /* TWITTER */, profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */
function getAdditionalUserInfo(userCredential) {
    const { user, _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) {
        // Handle the special case where signInAnonymously() gets called twice.
        // No network call is made so there's nothing to actually fill this in
        return {
            providerId: null,
            isNewUser: false,
            profile: null
        };
    }
    return _fromIdTokenResponse(_tokenResponse);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */
function setPersistence(auth, persistence) {
    return getModularInstance(auth).setPersistence(persistence);
}
/**
 * Adds an observer for changes to the signed-in user's ID token, which includes sign-in,
 * sign-out, and token refresh events.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - callback triggered on error.
 * @param completed - callback triggered when observer is removed.
 *
 * @public
 */
function onIdTokenChanged(auth, nextOrObserver, error, completed) {
    return getModularInstance(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - callback triggered on error.
 * @param completed - callback triggered when observer is removed.
 *
 * @public
 */
function onAuthStateChanged(auth, nextOrObserver, error, completed) {
    return getModularInstance(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
function useDeviceLanguage(auth) {
    getModularInstance(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */
function updateCurrentUser(auth, user) {
    return getModularInstance(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */
function signOut(auth) {
    return getModularInstance(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */
async function deleteUser(user) {
    return getModularInstance(user).delete();
}

class MultiFactorSessionImpl {
    constructor(type, credential) {
        this.type = type;
        this.credential = credential;
    }
    static _fromIdtoken(idToken) {
        return new MultiFactorSessionImpl("enroll" /* ENROLL */, idToken);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new MultiFactorSessionImpl("signin" /* SIGN_IN */, mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* ENROLL */
            ? 'idToken'
            : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) {
                return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            }
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) {
                return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
            }
        }
        return null;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class MultiFactorResolverImpl {
    constructor(session, hints, signInResolver) {
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */
    static _fromError(authExtern, error) {
        const auth = _castAuth(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map(enrollment => MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        _assert(serverResponse.mfaPendingCredential, auth, "internal-error" /* INTERNAL_ERROR */);
        const session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new MultiFactorResolverImpl(session, hints, async (assertion) => {
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), { idToken: mfaResponse.idToken, refreshToken: mfaResponse.refreshToken });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch (error.operationType) {
                case "signIn" /* SIGN_IN */:
                    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* REAUTHENTICATE */:
                    _assert(error.user, auth, "internal-error" /* INTERNAL_ERROR */);
                    return UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    _fail(auth, "internal-error" /* INTERNAL_ERROR */);
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */
function getMultiFactorResolver(auth, error) {
    var _a;
    const authModular = getModularInstance(auth);
    const errorInternal = error;
    _assert(error.customData.operationType, authModular, "argument-error" /* ARGUMENT_ERROR */);
    _assert((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* ARGUMENT_ERROR */);
    return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function startEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v2/accounts/mfaEnrollment:start" /* START_PHONE_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function finalizeEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v2/accounts/mfaEnrollment:finalize" /* FINALIZE_PHONE_MFA_ENROLLMENT */, _addTidIfNecessary(auth, request));
}
function withdrawMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v2/accounts/mfaEnrollment:withdraw" /* WITHDRAW_MFA */, _addTidIfNecessary(auth, request));
}

class MultiFactorUserImpl {
    constructor(user) {
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(userInfo => {
            if (userInfo.mfaInfo) {
                this.enrolledFactors = userInfo.mfaInfo.map(enrollment => MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
            }
        });
    }
    static _fromUser(user) {
        return new MultiFactorUserImpl(user);
    }
    async getSession() {
        return MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken());
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = (await this.getSession());
        const finalizeMfaResponse = await _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        const idTokenResponse = await _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
            idToken,
            mfaEnrollmentId
        }));
        // Remove the second factor from the user's list.
        this.enrolledFactors = this.enrolledFactors.filter(({ uid }) => uid !== mfaEnrollmentId);
        // Depending on whether the backend decided to revoke the user's session,
        // the tokenResponse may be empty. If the tokens were not updated (and they
        // are now invalid), reloading the user will discover this and invalidate
        // the user's state accordingly.
        await this.user._updateTokensIfNecessary(idTokenResponse);
        try {
            await this.user.reload();
        }
        catch (e) {
            if (e.code !== `auth/${"user-token-expired" /* TOKEN_EXPIRED */}`) {
                throw e;
            }
        }
    }
}
const multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */
function multiFactor(user) {
    const userModular = getModularInstance(user);
    if (!multiFactorUserCache.has(userModular)) {
        multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
    }
    return multiFactorUserCache.get(userModular);
}

const STORAGE_AVAILABLE_KEY = '__sak';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class BrowserPersistenceClass {
    constructor(storageRetriever, type) {
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) {
                return Promise.resolve(false);
            }
            this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem(STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        }
        catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _iframeCannotSyncWebStorage() {
    const ua = index_esm2017_getUA();
    return _isSafari(ua) || _isIOS(ua);
}
// The polling period in case events are not supported
const _POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
    constructor() {
        super(() => window.localStorage, "LOCAL" /* LOCAL */);
        this.boundEventHandler = (event, poll) => this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = _iframeCannotSyncWebStorage() && _isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = _isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)) {
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) {
                cb(key, oldValue, newValue);
            }
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue) => {
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) {
            // Environment detects storage changes via polling.
            // Remove storage event listener to prevent possible event duplication.
            this.detachListener();
        }
        else {
            // Environment detects storage changes via storage event listener.
            // Remove polling listener to prevent possible event duplication.
            this.stopPolling();
        }
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) {
                    // Value changed from current value.
                    this.storage.setItem(key, event.newValue);
                }
                else {
                    // Current value deleted.
                    this.storage.removeItem(key);
                }
            }
            else if (this.localCache[key] === event.newValue && !poll) {
                // Already detected and processed, do not trigger listeners again.
                return;
            }
        }
        const triggerListeners = () => {
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) {
                // Real storage event which has already been detected, do nothing.
                // This seems to trigger in some IE browsers for some reason.
                return;
            }
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if (_isIE10() &&
            storedValue !== event.newValue &&
            event.newValue !== event.oldValue) {
            // IE 10 has this weird bug where a storage event would trigger with the
            // correct key, oldValue and newValue but localStorage.getItem(key) does
            // not yield the updated value until a few milliseconds. This ensures
            // this recovers from that situation.
            setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
        }
        else {
            triggerListeners();
        }
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) {
            for (const listener of Array.from(listeners)) {
                listener(value ? JSON.parse(value) : value);
            }
        }
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(() => {
            this.forAllChangedKeys((key, oldValue, newValue) => {
                this.onStorageEvent(new StorageEvent('storage', {
                    key,
                    oldValue,
                    newValue
                }), 
                /* poll */ true);
            });
        }, _POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) {
                this.startPolling();
            }
            else {
                this.attachListener();
            }
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) {
                delete this.listeners[key];
            }
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */
const browserLocalPersistence = BrowserLocalPersistence;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class BrowserSessionPersistence extends BrowserPersistenceClass {
    constructor() {
        super(() => window.sessionStorage, "SESSION" /* SESSION */);
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */
const browserSessionPersistence = BrowserSessionPersistence;

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */
function _allSettled(promises) {
    return Promise.all(promises.map(async (promise) => {
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value
            };
        }
        catch (reason) {
            return {
                fulfilled: false,
                reason
            };
        }
    }));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface class for receiving messages.
 *
 */
class Receiver {
    constructor(eventTarget) {
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */
    static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find(receiver => receiver.isListeningto(eventTarget));
        if (existingInstance) {
            return existingInstance;
        }
        const newInstance = new Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */
    async handleEvent(event) {
        const messageEvent = event;
        const { eventId, eventType, data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) {
            return;
        }
        messageEvent.ports[0].postMessage({
            status: "ack" /* ACK */,
            eventId,
            eventType
        });
        const promises = Array.from(handlers).map(async (handler) => handler(messageEvent.origin, data));
        const response = await _allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* DONE */,
            eventId,
            eventType,
            response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */
    _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) {
            this.eventTarget.addEventListener('message', this.boundEventHandler);
        }
        if (!this.handlersMap[eventType]) {
            this.handlersMap[eventType] = new Set();
        }
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */
    _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) {
            this.handlersMap[eventType].delete(eventHandler);
        }
        if (!eventHandler || this.handlersMap[eventType].size === 0) {
            delete this.handlersMap[eventType];
        }
        if (Object.keys(this.handlersMap).length === 0) {
            this.eventTarget.removeEventListener('message', this.boundEventHandler);
        }
    }
}
Receiver.receivers = [];

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _generateEventId(prefix = '', digits = 10) {
    let random = '';
    for (let i = 0; i < digits; i++) {
        random += Math.floor(Math.random() * 10);
    }
    return prefix + random;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface for sending messages and waiting for a completion response.
 *
 */
class Sender {
    constructor(target) {
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */
    removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */
    async _send(eventType, data, timeout = 50 /* ACK */) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) {
            throw new Error("connection_unavailable" /* CONNECTION_UNAVAILABLE */);
        }
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject) => {
            const eventId = _generateEventId('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(() => {
                reject(new Error("unsupported_event" /* UNSUPPORTED_EVENT */));
            }, timeout);
            handler = {
                messageChannel,
                onMessage(event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) {
                        return;
                    }
                    switch (messageEvent.data.status) {
                        case "ack" /* ACK */:
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(() => {
                                reject(new Error("timeout" /* TIMEOUT */));
                            }, 3000 /* COMPLETION */);
                            break;
                        case "done" /* DONE */:
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* INVALID_RESPONSE */));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType,
                eventId,
                data
            }, [messageChannel.port2]);
        }).finally(() => {
            if (handler) {
                this.removeMessageHandler(handler);
            }
        });
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */
function _window() {
    return window;
}
function _setWindowLocation(url) {
    _window().location.href = url;
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _isWorker() {
    return (typeof _window()['WorkerGlobalScope'] !== 'undefined' &&
        typeof _window()['importScripts'] === 'function');
}
async function _getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) {
        return null;
    }
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    }
    catch (_a) {
        return null;
    }
}
function _getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function _getWorkerGlobalScope() {
    return _isWorker() ? self : null;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_7078a255_DB_NAME = 'firebaseLocalStorageDb';
const index_7078a255_DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */
class DBPromise {
    constructor(request) {
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject) => {
            this.request.addEventListener('success', () => {
                resolve(this.request.result);
            });
            this.request.addEventListener('error', () => {
                reject(this.request.error);
            });
        });
    }
}
function getObjectStore(db, isReadWrite) {
    return db
        .transaction([DB_OBJECTSTORE_NAME], isReadWrite ? 'readwrite' : 'readonly')
        .objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
    const request = indexedDB.deleteDatabase(index_7078a255_DB_NAME);
    return new DBPromise(request).toPromise();
}
function _openDatabase() {
    const request = indexedDB.open(index_7078a255_DB_NAME, index_7078a255_DB_VERSION);
    return new Promise((resolve, reject) => {
        request.addEventListener('error', () => {
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', () => {
            const db = request.result;
            try {
                db.createObjectStore(DB_OBJECTSTORE_NAME, { keyPath: DB_DATA_KEYPATH });
            }
            catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async () => {
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await _deleteDatabase();
                resolve(await _openDatabase());
            }
            else {
                resolve(db);
            }
        });
    });
}
async function _putObject(db, key, value) {
    const request = getObjectStore(db, true).put({
        [DB_DATA_KEYPATH]: key,
        value
    });
    return new DBPromise(request).toPromise();
}
async function getObject(db, key) {
    const request = getObjectStore(db, false).get(key);
    const data = await new DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function _deleteObject(db, key) {
    const request = getObjectStore(db, true).delete(key);
    return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
    constructor() {
        this.type = "LOCAL" /* LOCAL */;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise =
            this.initializeServiceWorkerMessaging().then(() => { }, () => { });
    }
    async _openDb() {
        if (this.db) {
            return this.db;
        }
        this.db = await _openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while (true) {
            try {
                const db = await this._openDb();
                return await op(db);
            }
            catch (e) {
                if (numAttempts++ > _TRANSACTION_RETRY_COUNT) {
                    throw e;
                }
                if (this.db) {
                    this.db.close();
                    this.db = undefined;
                }
                // TODO: consider adding exponential backoff
            }
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */
    async initializeServiceWorkerMessaging() {
        return _isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */
    async initializeReceiver() {
        this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* KEY_CHANGED */, async (_origin, data) => {
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* PING */, async (_origin, _data) => {
            return ["keyChanged" /* KEY_CHANGED */];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */
    async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await _getActiveServiceWorker();
        if (!this.activeServiceWorker) {
            return;
        }
        this.sender = new Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* PING */, {}, 800 /* LONG_ACK */);
        if (!results) {
            return;
        }
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) &&
            ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* KEY_CHANGED */))) {
            this.serviceWorkerReceiverAvailable = true;
        }
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */
    async notifyServiceWorker(key) {
        if (!this.sender ||
            !this.activeServiceWorker ||
            _getServiceWorkerController() !== this.activeServiceWorker) {
            return;
        }
        try {
            await this.sender._send("keyChanged" /* KEY_CHANGED */, { key }, 
            // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable
                ? 800 /* LONG_ACK */
                : 50 /* ACK */);
        }
        catch (_a) {
            // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) {
                return false;
            }
            const db = await _openDatabase();
            await _putObject(db, STORAGE_AVAILABLE_KEY, '1');
            await _deleteObject(db, STORAGE_AVAILABLE_KEY);
            return true;
        }
        catch (_a) { }
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        }
        finally {
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async () => {
            await this._withRetries((db) => _putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = (await this._withRetries((db) => getObject(db, key)));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async () => {
            await this._withRetries((db) => _deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db) => {
            const getAllRequest = getObjectStore(db, false).getAll();
            return new DBPromise(getAllRequest).toPromise();
        });
        if (!result) {
            return [];
        }
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) {
            return [];
        }
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value } of result) {
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache)) {
            if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                // Deleted
                this.notifyListeners(localKey, null);
                keys.push(localKey);
            }
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) {
            for (const listener of Array.from(listeners)) {
                listener(newValue);
            }
        }
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async () => this._poll(), _POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            this.startPolling();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            void this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) {
                delete this.listeners[key];
            }
        }
        if (Object.keys(this.listeners).length === 0) {
            this.stopPolling();
        }
    }
}
IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */
const indexedDBLocalPersistence = IndexedDBLocalPersistence;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function startSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v2/accounts/mfaSignIn:start" /* START_PHONE_MFA_SIGN_IN */, _addTidIfNecessary(auth, request));
}
function finalizeSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* POST */, "/v2/accounts/mfaSignIn:finalize" /* FINALIZE_PHONE_MFA_SIGN_IN */, _addTidIfNecessary(auth, request));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function getRecaptchaParams(auth) {
    return ((await _performApiRequest(auth, "GET" /* GET */, "/v1/recaptchaParams" /* GET_RECAPTCHA_PARAM */)).recaptchaSiteKey || '');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function _loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.setAttribute('src', url);
        el.onload = resolve;
        el.onerror = e => {
            const error = _createError("internal-error" /* INTERNAL_ERROR */);
            error.customData = e;
            reject(error);
        };
        el.type = 'text/javascript';
        el.charset = 'UTF-8';
        getScriptParentElement().appendChild(el);
    });
}
function _generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _SOLVE_TIME_MS = 500;
const _EXPIRATION_TIME_MS = 60000;
const _WIDGET_ID_START = 1000000000000;
class MockReCaptcha {
    constructor(auth) {
        this.auth = auth;
        this.counter = _WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        void ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.delete());
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || _WIDGET_ID_START;
        void ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.execute());
        return '';
    }
}
class MockWidget {
    constructor(containerOrId, appName, params) {
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = () => {
            this.execute();
        };
        const container = typeof containerOrId === 'string'
            ? document.getElementById(containerOrId)
            : containerOrId;
        _assert(container, "argument-error" /* ARGUMENT_ERROR */, { appName });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) {
            this.execute();
        }
        else {
            this.container.addEventListener('click', this.clickHandler);
        }
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) {
            return;
        }
        this.timerId = window.setTimeout(() => {
            this.responseToken = generateRandomAlphaNumericString(50);
            const { callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) {
                try {
                    callback(this.responseToken);
                }
                catch (e) { }
            }
            this.timerId = window.setTimeout(() => {
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) {
                    try {
                        expiredCallback();
                    }
                    catch (e) { }
                }
                if (this.isVisible) {
                    this.execute();
                }
            }, _EXPIRATION_TIME_MS);
        }, _SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) {
            throw new Error('reCAPTCHA mock was already deleted!');
        }
    }
}
function generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = 0; i < len; i++) {
        chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    }
    return chars.join('');
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const _JSLOAD_CALLBACK = _generateCallbackName('rcb');
const NETWORK_TIMEOUT_DELAY = new Delay(30000, 60000);
const RECAPTCHA_BASE = 'https://www.google.com/recaptcha/api.js?';
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */
class ReCaptchaLoaderImpl {
    constructor() {
        this.hostLanguage = '';
        this.counter = 0;
        this.librarySeparatelyLoaded = !!_window().grecaptcha;
    }
    load(auth, hl = '') {
        _assert(isHostLanguageValid(hl), auth, "argument-error" /* ARGUMENT_ERROR */);
        if (this.shouldResolveImmediately(hl)) {
            return Promise.resolve(_window().grecaptcha);
        }
        return new Promise((resolve, reject) => {
            const networkTimeout = _window().setTimeout(() => {
                reject(_createError(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */));
            }, NETWORK_TIMEOUT_DELAY.get());
            _window()[_JSLOAD_CALLBACK] = () => {
                _window().clearTimeout(networkTimeout);
                delete _window()[_JSLOAD_CALLBACK];
                const recaptcha = _window().grecaptcha;
                if (!recaptcha) {
                    reject(_createError(auth, "internal-error" /* INTERNAL_ERROR */));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params) => {
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${RECAPTCHA_BASE}?${querystring({
                onload: _JSLOAD_CALLBACK,
                render: 'explicit',
                hl
            })}`;
            _loadJS(url).catch(() => {
                clearTimeout(networkTimeout);
                reject(_createError(auth, "internal-error" /* INTERNAL_ERROR */));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return (!!_window().grecaptcha &&
            (hl === this.hostLanguage ||
                this.counter > 0 ||
                this.librarySeparatelyLoaded));
    }
}
function isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class MockReCaptchaLoaderImpl {
    async load(auth) {
        return new MockReCaptcha(auth);
    }
    clearedOneInstance() { }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @public
 */
class RecaptchaVerifier {
    /**
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @remarks
     * If none is provided, the default Firebase {@link Auth} instance is used. A Firebase {@link Auth} instance
     * must be initialized with an API key, otherwise an error will be thrown.
     */
    constructor(containerOrId, parameters = Object.assign({}, DEFAULT_PARAMS), authExtern) {
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */
        this.type = RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = _castAuth(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */);
        const container = typeof containerOrId === 'string'
            ? document.getElementById(containerOrId)
            : containerOrId;
        _assert(container, this.auth, "argument-error" /* ARGUMENT_ERROR */);
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting
            ? new MockReCaptchaLoaderImpl()
            : new ReCaptchaLoaderImpl();
        this.validateStartingState();
        // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */
    async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) {
            return response;
        }
        return new Promise(resolve => {
            const tokenChange = (token) => {
                if (!token) {
                    return; // Ignore token expirations.
                }
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) {
                recaptcha.execute(id);
            }
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */
    render() {
        try {
            this.assertNotDestroyed();
        }
        catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) {
            return this.renderPromise;
        }
        this.renderPromise = this.makeRenderPromise().catch(e => {
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */
    _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) {
            this.getAssertedRecaptcha().reset(this.widgetId);
        }
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */
    clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) {
            this.container.childNodes.forEach(node => {
                this.container.removeChild(node);
            });
        }
    }
    validateStartingState() {
        _assert(!this.parameters.sitekey, this.auth, "argument-error" /* ARGUMENT_ERROR */);
        _assert(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* ARGUMENT_ERROR */);
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* OPERATION_NOT_SUPPORTED */);
    }
    makeTokenCallback(existing) {
        return token => {
            this.tokenChangeListeners.forEach(listener => listener(token));
            if (typeof existing === 'function') {
                existing(token);
            }
            else if (typeof existing === 'string') {
                const globalFunc = _window()[existing];
                if (typeof globalFunc === 'function') {
                    globalFunc(token);
                }
            }
        };
    }
    assertNotDestroyed() {
        _assert(!this.destroyed, this.auth, "internal-error" /* INTERNAL_ERROR */);
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        _assert(_isHttpOrHttps() && !_isWorker(), this.auth, "internal-error" /* INTERNAL_ERROR */);
        await domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await getRecaptchaParams(this.auth);
        _assert(siteKey, this.auth, "internal-error" /* INTERNAL_ERROR */);
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        _assert(this.recaptcha, this.auth, "internal-error" /* INTERNAL_ERROR */);
        return this.recaptcha;
    }
}
function domReady() {
    let resolver = null;
    return new Promise(resolve => {
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = () => resolve();
        window.addEventListener('load', resolver);
    }).catch(e => {
        if (resolver) {
            window.removeEventListener('load', resolver);
        }
        throw e;
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ConfirmationResultImpl {
    constructor(verificationId, onConfirmation) {
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function signInWithPhoneNumber(auth, phoneNumber, appVerifier) {
    const authInternal = _castAuth(auth);
    const verificationId = await _verifyPhoneNumber(authInternal, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => signInWithCredential(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function linkWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = getModularInstance(user);
    await _assertLinkedStatus(false, userInternal, "phone" /* PHONE */);
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => linkWithCredential(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */
async function reauthenticateWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = getModularInstance(user);
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, getModularInstance(appVerifier));
    return new ConfirmationResultImpl(verificationId, cred => reauthenticateWithCredential(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */
async function _verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        _assert(typeof recaptchaToken === 'string', auth, "argument-error" /* ARGUMENT_ERROR */);
        _assert(verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* ARGUMENT_ERROR */);
        let phoneInfoOptions;
        if (typeof options === 'string') {
            phoneInfoOptions = {
                phoneNumber: options
            };
        }
        else {
            phoneInfoOptions = options;
        }
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                _assert(session.type === "enroll" /* ENROLL */, auth, "internal-error" /* INTERNAL_ERROR */);
                const response = await startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            }
            else {
                _assert(session.type === "signin" /* SIGN_IN */, auth, "internal-error" /* INTERNAL_ERROR */);
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) ||
                    phoneInfoOptions.multiFactorUid;
                _assert(mfaEnrollmentId, auth, "missing-multi-factor-info" /* MISSING_MFA_INFO */);
                const response = await startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        }
        else {
            const { sessionInfo } = await sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken
            });
            return sessionInfo;
        }
    }
    finally {
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */
async function updatePhoneNumber(user, credential) {
    await _link$1(getModularInstance(user), credential);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */
class PhoneAuthProvider {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */
    constructor(auth) {
        /** Always set to {@link ProviderId}.PHONE. */
        this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = _castAuth(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */
    verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return _verifyPhoneNumber(this.auth, phoneOptions, index_esm2017_getModularInstance(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */
    static credential(verificationId, verificationCode) {
        return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */
    static credentialFromResult(userCredential) {
        const credential = userCredential;
        return PhoneAuthProvider.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if (e.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */
    static credentialFromError(error) {
        return PhoneAuthProvider.credentialFromTaggedObject((error.customData || {}));
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) {
            return null;
        }
        const { phoneNumber, temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) {
            return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
        }
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */
PhoneAuthProvider.PROVIDER_ID = "phone" /* PHONE */;
/** Always set to {@link SignInMethod}.PHONE. */
PhoneAuthProvider.PHONE_SIGN_IN_METHOD = "phone" /* PHONE */;

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */
function _withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) {
        return _getInstance(resolverOverride);
    }
    _assert(auth._popupRedirectResolver, auth, "argument-error" /* ARGUMENT_ERROR */);
    return auth._popupRedirectResolver;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IdpCredential extends AuthCredential {
    constructor(params) {
        super("custom" /* CUSTOM */, "custom" /* CUSTOM */);
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) {
            request.idToken = idToken;
        }
        return request;
    }
}
function _signIn(params) {
    return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}
function _reauth(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* INTERNAL_ERROR */);
    return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}
async function _link(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* INTERNAL_ERROR */);
    return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */
class AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false) {
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [filter];
    }
    execute() {
        return new Promise(async (resolve, reject) => {
            this.pendingPromise = { resolve, reject };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            }
            catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse, sessionId, postBody, tenantId, error, type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        }
        catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch (type) {
            case "signInViaPopup" /* SIGN_IN_VIA_POPUP */:
            case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */:
                return _signIn;
            case "linkViaPopup" /* LINK_VIA_POPUP */:
            case "linkViaRedirect" /* LINK_VIA_REDIRECT */:
                return _link;
            case "reauthViaPopup" /* REAUTH_VIA_POPUP */:
            case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */:
                return _reauth;
            default:
                _fail(this.auth, "internal-error" /* INTERNAL_ERROR */);
        }
    }
    resolve(cred) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) {
            this.eventManager.unregisterConsumer(this);
        }
        this.pendingPromise = null;
        this.cleanUp();
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */
async function signInWithPopup(auth, provider, resolver) {
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    const action = new PopupOperation(authInternal, "signInViaPopup" /* SIGN_IN_VIA_POPUP */, provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function reauthenticateWithPopup(user, provider, resolver) {
    const userInternal = index_esm2017_getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "reauthViaPopup" /* REAUTH_VIA_POPUP */, provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function linkWithPopup(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "linkViaPopup" /* LINK_VIA_POPUP */, provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */
class PopupOperation extends AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user) {
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if (PopupOperation.currentPopupAction) {
            PopupOperation.currentPopupAction.cancel();
        }
        PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        _assert(result, this.auth, "internal-error" /* INTERNAL_ERROR */);
        return result;
    }
    async onExecution() {
        debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = _generateEventId();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], // There's always one, see constructor
        eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch(e => {
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, isSupported => {
            if (!isSupported) {
                this.reject(_createError(this.auth, "web-storage-unsupported" /* WEB_STORAGE_UNSUPPORTED */));
            }
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject(_createError(this.auth, "cancelled-popup-request" /* EXPIRED_POPUP_REQUEST */));
    }
    cleanUp() {
        if (this.authWindow) {
            this.authWindow.close();
        }
        if (this.pollId) {
            window.clearTimeout(this.pollId);
        }
        this.authWindow = null;
        this.pollId = null;
        PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = () => {
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight.
                this.pollId = window.setTimeout(() => {
                    this.pollId = null;
                    this.reject(_createError(this.auth, "popup-closed-by-user" /* POPUP_CLOSED_BY_USER */));
                }, 2000 /* AUTH_EVENT */);
                return;
            }
            this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
PopupOperation.currentPopupAction = null;

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const redirectOutcomeMap = new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false) {
        super(auth, [
            "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */,
            "linkViaRedirect" /* LINK_VIA_REDIRECT */,
            "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */,
            "unknown" /* UNKNOWN */
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */
    async execute() {
        let readyOutcome = redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await _getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = () => Promise.resolve(result);
            }
            catch (e) {
                readyOutcome = () => Promise.reject(e);
            }
            redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) {
            redirectOutcomeMap.set(this.auth._key(), () => Promise.resolve(null));
        }
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */) {
            return super.onAuthEvent(event);
        }
        else if (event.type === "unknown" /* UNKNOWN */) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            }
            else {
                this.resolve(null);
            }
        }
    }
    async onExecution() { }
    cleanUp() { }
}
async function _getAndClearPendingRedirectStatus(resolver, auth) {
    const key = pendingRedirectKey(auth);
    const persistence = resolverPersistence(resolver);
    if (!(await persistence._isAvailable())) {
        return false;
    }
    const hasPendingRedirect = (await persistence._get(key)) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function _setPendingRedirectStatus(resolver, auth) {
    return resolverPersistence(resolver)._set(pendingRedirectKey(auth), 'true');
}
function _clearRedirectOutcomes() {
    redirectOutcomeMap.clear();
}
function resolverPersistence(resolver) {
    return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth) {
    return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
function signInWithRedirect(auth, provider, resolver) {
    return _signInWithRedirect(auth, provider, resolver);
}
async function _signInWithRedirect(auth, provider, resolver) {
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    await _setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Link using a redirect.
 * await linkWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
function reauthenticateWithRedirect(user, provider, resolver) {
    return _reauthenticateWithRedirect(user, provider, resolver);
}
async function _reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */, eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 *
 * @public
 */
function linkWithRedirect(user, provider, resolver) {
    return _linkWithRedirect(user, provider, resolver);
}
async function _linkWithRedirect(user, provider, resolver) {
    const userInternal = getModularInstance(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _assertLinkedStatus(false, userInternal, provider.providerId);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* LINK_VIA_REDIRECT */, eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns a {@link UserCredential}
 * with a null `user`.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */
async function getRedirectResult(auth, resolver) {
    await _castAuth(auth)._initializationPromise;
    return _getRedirectResult(auth, resolver, false);
}
async function _getRedirectResult(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = _castAuth(auth);
    const resolver = _withDefaultResolver(authInternal, resolverExtern);
    const action = new RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function prepareUserForRedirect(user) {
    const eventId = _generateEventId(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const EVENT_DUPLICATION_CACHE_DURATION_MS = 10 * 60 * 1000;
class AuthEventManager {
    constructor(auth) {
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent &&
            this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) {
            return false;
        }
        let handled = false;
        this.consumers.forEach(consumer => {
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) {
            // If we've already seen a redirect before, or this is a popup event,
            // bail now
            return handled;
        }
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) ||
                "internal-error" /* INTERNAL_ERROR */;
            consumer.onError(_createError(this.auth, code));
        }
        else {
            consumer.onAuthEvent(event);
        }
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null ||
            (!!event.eventId && event.eventId === consumer.eventId);
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >=
            EVENT_DUPLICATION_CACHE_DURATION_MS) {
            this.cachedEventUids.clear();
        }
        return this.cachedEventUids.has(eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add(eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function eventUid(e) {
    return [e.type, e.eventId, e.sessionId, e.tenantId].filter(v => v).join('-');
}
function isNullRedirectEvent({ type, error }) {
    return (type === "unknown" /* UNKNOWN */ &&
        (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* NO_AUTH_EVENT */}`);
}
function isRedirectEvent(event) {
    switch (event.type) {
        case "signInViaRedirect" /* SIGN_IN_VIA_REDIRECT */:
        case "linkViaRedirect" /* LINK_VIA_REDIRECT */:
        case "reauthViaRedirect" /* REAUTH_VIA_REDIRECT */:
            return true;
        case "unknown" /* UNKNOWN */:
            return isNullRedirectEvent(event);
        default:
            return false;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _getProjectConfig(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* GET */, "/v1/projects" /* GET_PROJECT_CONFIG */, request);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) {
        return;
    }
    const { authorizedDomains } = await _getProjectConfig(auth);
    for (const domain of authorizedDomains) {
        try {
            if (matchDomain(domain)) {
                return;
            }
        }
        catch (_a) {
            // Do nothing if there's a URL error; just continue searching
        }
    }
    // In the old SDK, this error also provides helpful messages.
    _fail(auth, "unauthorized-domain" /* INVALID_ORIGIN */);
}
function matchDomain(expected) {
    const currentUrl = _getCurrentUrl();
    const { protocol, hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') {
            // For some reason we're not parsing chrome URLs properly
            return (protocol === 'chrome-extension:' &&
                expected.replace('chrome-extension://', '') ===
                    currentUrl.replace('chrome-extension://', ''));
        }
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!HTTP_REGEX.test(protocol)) {
        return false;
    }
    if (IP_ADDRESS_REGEX.test(expected)) {
        // The domain has to be exactly equal to the pattern, as an IP domain will
        // only contain the IP, no extra character.
        return hostname === expected;
    }
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */
function resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = _window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) {
        // Get gapi hint.
        for (const hint of Object.keys(beacon.H)) {
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = [...beacon.H[hint].L];
            // Clear pending callbacks.
            if (beacon.CP) {
                for (let i = 0; i < beacon.CP.length; i++) {
                    // Remove all failed pending callbacks.
                    beacon.CP[i] = null;
                }
            }
        }
    }
}
function loadGapi(auth) {
    return new Promise((resolve, reject) => {
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: () => {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: () => {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    resetUnloadedGapiModules();
                    reject(_createError(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */));
                },
                timeout: NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = _window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) {
            // If gapi.iframes.Iframe available, resolve.
            resolve(gapi.iframes.getContext());
        }
        else if (!!((_c = _window().gapi) === null || _c === void 0 ? void 0 : _c.load)) {
            // Gapi loader ready, load gapi.iframes.
            loadGapiIframe();
        }
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = _generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            _window()[cbName] = () => {
                // GApi loader should be ready.
                if (!!gapi.load) {
                    loadGapiIframe();
                }
                else {
                    // Gapi loader failed, throw error.
                    reject(_createError(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */));
                }
            };
            // Load GApi loader.
            return _loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch(e => reject(e));
        }
    }).catch(error => {
        // Reset cached promise to allow for retrial.
        cachedGApiLoader = null;
        throw error;
    });
}
let cachedGApiLoader = null;
function _loadGapi(auth) {
    cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
    return cachedGApiLoader;
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PING_TIMEOUT = new Delay(5000, 15000);
const IFRAME_PATH = '__/auth/iframe';
const EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const EID_FROM_APIHOST = new Map([
    ["identitytoolkit.googleapis.com" /* API_HOST */, 'p'],
    ['staging-identitytoolkit.sandbox.googleapis.com', 's'],
    ['test-identitytoolkit.sandbox.googleapis.com', 't'] // test
]);
function getIframeUrl(auth) {
    const config = auth.config;
    _assert(config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */);
    const url = config.emulator
        ? _emulatorUrl(config, EMULATED_IFRAME_PATH)
        : `https://${auth.config.authDomain}/${IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: SDK_VERSION
    };
    const eid = EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) {
        params.eid = eid;
    }
    const frameworks = auth._getFrameworks();
    if (frameworks.length) {
        params.fw = frameworks.join(',');
    }
    return `${url}?${index_esm2017_querystring(params).slice(1)}`;
}
async function _openIframe(auth) {
    const context = await _loadGapi(auth);
    const gapi = _window().gapi;
    _assert(gapi, auth, "internal-error" /* INTERNAL_ERROR */);
    return context.open({
        where: document.body,
        url: getIframeUrl(auth),
        messageHandlersFilter: gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe) => new Promise(async (resolve, reject) => {
        await iframe.restyle({
            // Prevent iframe from closing on mouse out.
            setHideOnLeave: false
        });
        const networkError = _createError(auth, "network-request-failed" /* NETWORK_REQUEST_FAILED */);
        // Confirm iframe is correctly loaded.
        // To fallback on failure, set a timeout.
        const networkErrorTimer = _window().setTimeout(() => {
            reject(networkError);
        }, PING_TIMEOUT.get());
        // Clear timer and resolve pending iframe ready promise.
        function clearTimerAndResolve() {
            _window().clearTimeout(networkErrorTimer);
            resolve(iframe);
        }
        // This returns an IThenable. However the reject part does not call
        // when the iframe is not loaded.
        iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, () => {
            reject(networkError);
        });
    }));
}

/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = '_blank';
const FIREFOX_EMPTY_URL = 'http://localhost';
class AuthPopup {
    constructor(window) {
        this.window = window;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) {
            try {
                this.window.close();
            }
            catch (e) { }
        }
    }
}
function _open(auth, url, name, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, BASE_POPUP_OPTIONS), { width: width.toString(), height: height.toString(), top,
        left });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = index_esm2017_getUA().toLowerCase();
    if (name) {
        target = _isChromeIOS(ua) ? TARGET_BLANK : name;
    }
    if (_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value]) => `${accum}${key}=${value},`, '');
    if (_isIOSStandalone(ua) && target !== '_self') {
        openAsNewWindowIOS(url || '', target);
        return new AuthPopup(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    _assert(newWin, auth, "popup-blocked" /* POPUP_BLOCKED */);
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    }
    catch (e) { }
    return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */
const WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */
const EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
function _getRedirectUrl(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    _assert(auth.config.authDomain, auth, "auth-domain-config-required" /* MISSING_AUTH_DOMAIN */);
    _assert(auth.config.apiKey, auth, "invalid-api-key" /* INVALID_API_KEY */);
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType,
        redirectUrl,
        v: SDK_VERSION,
        eventId
    };
    if (provider instanceof FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!isEmpty(provider.getCustomParameters())) {
            params.customParameters = JSON.stringify(provider.getCustomParameters());
        }
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {})) {
            params[key] = value;
        }
    }
    if (provider instanceof BaseOAuthProvider) {
        const scopes = provider.getScopes().filter(scope => scope !== '');
        if (scopes.length > 0) {
            params.scopes = scopes.join(',');
        }
    }
    if (auth.tenantId) {
        params.tid = auth.tenantId;
    }
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict)) {
        if (paramsDict[key] === undefined) {
            delete paramsDict[key];
        }
    }
    return `${getHandlerBase(auth)}?${index_esm2017_querystring(paramsDict).slice(1)}`;
}
function getHandlerBase({ config }) {
    if (!config.emulator) {
        return `https://${config.authDomain}/${WIDGET_PATH}`;
    }
    return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The special web storage event
 *
 */
const WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class BrowserPopupRedirectResolver {
    constructor() {
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = browserSessionPersistence;
        this._completeRedirectFn = _getRedirectResult;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        debugAssert((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        return _open(auth, url, _generateEventId());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        _setWindowLocation(_getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId));
        return new Promise(() => { });
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager, promise } = this.eventManagers[key];
            if (manager) {
                return Promise.resolve(manager);
            }
            else {
                debugAssert(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = { promise };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(() => {
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await _openIframe(auth);
        const manager = new AuthEventManager(auth);
        iframe.register('authEvent', (iframeEvent) => {
            _assert(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* INVALID_AUTH_EVENT */);
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return { status: handled ? "ACK" /* ACK */ : "ERROR" /* ERROR */ };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = { manager };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send(WEB_STORAGE_SUPPORT_KEY, { type: WEB_STORAGE_SUPPORT_KEY }, result => {
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) {
                cb(!!isSupported);
            }
            _fail(auth, "internal-error" /* INTERNAL_ERROR */);
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) {
            this.originValidationPromises[key] = _validateOrigin(auth);
        }
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return _isMobileBrowser() || _isSafari() || _isIOS();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @public
 */
const browserPopupRedirectResolver = BrowserPopupRedirectResolver;

class MultiFactorAssertionImpl {
    constructor(factorId) {
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch (session.type) {
            case "enroll" /* ENROLL */:
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* SIGN_IN */:
                return this._finalizeSignIn(auth, session.credential);
            default:
                return debugFail('unexpected MultiFactorSessionType');
        }
    }
}

/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */
class PhoneMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(credential) {
        super("phone" /* PHONE */);
        this.credential = credential;
    }
    /** @internal */
    static _fromCredential(credential) {
        return new PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */
    _finalizeEnroll(auth, idToken, displayName) {
        return finalizeEnrollPhoneMfa(auth, {
            idToken,
            displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */
    _finalizeSignIn(auth, mfaPendingCredential) {
        return finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */
class PhoneMultiFactorGenerator {
    constructor() { }
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */
    static assertion(credential) {
        return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */
PhoneMultiFactorGenerator.FACTOR_ID = 'phone';

var index_7078a255_name = "@firebase/auth";
var index_7078a255_version = "0.19.12";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class AuthInterop {
    constructor(auth) {
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) {
            return null;
        }
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return { accessToken };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) {
            return;
        }
        const unsubscribe = this.auth.onIdTokenChanged(user => {
            var _a;
            listener(((_a = user) === null || _a === void 0 ? void 0 : _a.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) {
            return;
        }
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* DEPENDENT_SDK_INIT_BEFORE_AUTH */);
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) {
            this.auth._startProactiveRefresh();
        }
        else {
            this.auth._stopProactiveRefresh();
        }
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getVersionForPlatform(clientPlatform) {
    switch (clientPlatform) {
        case "Node" /* NODE */:
            return 'node';
        case "ReactNative" /* REACT_NATIVE */:
            return 'rn';
        case "Worker" /* WORKER */:
            return 'webworker';
        case "Cordova" /* CORDOVA */:
            return 'cordova';
        default:
            return undefined;
    }
}
/** @internal */
function registerAuth(clientPlatform) {
    _registerComponent(new Component("auth" /* AUTH */, (container, { options: deps }) => {
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const { apiKey, authDomain } = app.options;
        return ((app, heartbeatServiceProvider) => {
            _assert(apiKey && !apiKey.includes(':'), "invalid-api-key" /* INVALID_API_KEY */, { appName: app.name });
            // Auth domain is optional if IdP sign in isn't being used
            _assert(!(authDomain === null || authDomain === void 0 ? void 0 : authDomain.includes(':')), "argument-error" /* ARGUMENT_ERROR */, {
                appName: app.name
            });
            const config = {
                apiKey,
                authDomain,
                clientPlatform,
                apiHost: "identitytoolkit.googleapis.com" /* API_HOST */,
                tokenApiHost: "securetoken.googleapis.com" /* TOKEN_API_HOST */,
                apiScheme: "https" /* API_SCHEME */,
                sdkClientVersion: _getClientVersion(clientPlatform)
            };
            const authInstance = new AuthImpl(app, heartbeatServiceProvider, config);
            _initializeAuthInstance(authInstance, deps);
            return authInstance;
        })(app, heartbeatServiceProvider);
    }, "PUBLIC" /* PUBLIC */)
        /**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */
        .setInstantiationMode("EXPLICIT" /* EXPLICIT */)
        /**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */
        .setInstanceCreatedCallback((container, _instanceIdentifier, _instance) => {
        const authInternalProvider = container.getProvider("auth-internal" /* AUTH_INTERNAL */);
        authInternalProvider.initialize();
    }));
    _registerComponent(new Component("auth-internal" /* AUTH_INTERNAL */, container => {
        const auth = _castAuth(container.getProvider("auth" /* AUTH */).getImmediate());
        return (auth => new AuthInterop(auth))(auth);
    }, "PRIVATE" /* PRIVATE */).setInstantiationMode("EXPLICIT" /* EXPLICIT */));
    registerVersion(index_7078a255_name, index_7078a255_version, getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(index_7078a255_name, index_7078a255_version, 'esm2017');
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */
function getAuth(app = getApp()) {
    const provider = _getProvider(app, 'auth');
    if (provider.isInitialized()) {
        return provider.getImmediate();
    }
    return initializeAuth(app, {
        popupRedirectResolver: browserPopupRedirectResolver,
        persistence: [
            indexedDBLocalPersistence,
            browserLocalPersistence,
            browserSessionPersistence
        ]
    });
}
registerAuth("Browser" /* BROWSER */);


//# sourceMappingURL=index-7078a255.js.map

;// CONCATENATED MODULE: ./node_modules/@firebase/auth/dist/esm2017/index.js






//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/auth/dist/index.esm.js

//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/firebase/app/dist/index.esm.js



var index_esm_name = "firebase";
var index_esm_version = "9.7.0";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
registerVersion(index_esm_name, index_esm_version, 'app');
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/ts/MicrosoftOutlookCalendar.ts


const MicrosoftOutlookCalendar = {
    init: async function (callbackUserData) {
        const firebaseConfig = {
            apiKey: 'AIzaSyAC7JwS09_ViLXnaAMhz9xgdqP8VQassz4',
            authDomain: 'capshine-cc513.firebaseapp.com',
            projectId: 'capshine-cc513',
            storageBucket: 'capshine-cc513.appspot.com',
            messagingSenderId: '760903773324',
            appId: '1:760903773324:android:f581ed25f59b5018c95fa9',
        };
        initializeApp(firebaseConfig);
        this.signInWithMicrosoft(callbackUserData);
    },
    signInWithMicrosoft: async function (callbackUserData) {
        const provider = new OAuthProvider('microsoft.com');
        provider.setCustomParameters({
            prompt: "consent",
            tenant: '453f0eb0-f553-4141-b377-de75359b3aa1'
        });
        provider.addScope('user.read');
        const auth = getAuth();
        if (auth.currentUser) {
            reauthenticateWithPopup(auth.currentUser, provider)
                .then((result) => {
                const credential = OAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                callbackUserData(result.user, accessToken);
            })
                .catch((error) => {
                console.log(error);
            });
        }
        else {
            await signInWithPopup(auth, provider)
                .then(async (result) => {
                const credential = OAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                callbackUserData(result.user, accessToken);
            })
                .catch((error) => {
                console.log(error);
            });
        }
    }
};
/* harmony default export */ const ts_MicrosoftOutlookCalendar = (MicrosoftOutlookCalendar);

;// CONCATENATED MODULE: ./src/js/MyClub.js
﻿





// import router from "./routerconfig"
var MyClub = {
	UserPid: '',
	MyClubEvent: null,
	eventScdId: null,
	userInfo: null,
	isCoach: false,
	isMobileApp: false,
	sulekhaApp: null,
	pagename: "home",
	rootpage: "home",
	isButtonClick: false,
	activevideorowid: 0,
	startTime: '',
	endTime: '',
	description: '',
	summary: '',
	clubScheduleId: '',
	init: function (userpid, sulekhaApp = null, rootpage = null) {


		window.localStorage.removeItem('backpage'); // Handled for shrot video watch video redirection
		//   window.screen.orientation.lock('portrait');  // lock portrait mode 
		window.localStorage.setItem('sfvbackpage', 'ShortVideosViewAll')
		MyClub.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				MyClub.isMobileApp = true;
			}
			else {
				MyClub.isMobileApp = false;
			}
		}

		MyClub.rootpage = rootpage;

		var hdnpage = document.getElementById("hdnPageType");

		if (hdnpage) {
			hdnpage.value = rootpage;
			// if (hdnpage.value == 'Home')
			//     MyClub.pagename = "home";
			// else if (hdnpage.value == 'LearningPlan')
			//     MyClub.pagename = "learningplan";
		}


		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}

		// Strart  Feed back
		document.querySelectorAll("._feedback").forEach((btnfeedback) => {
			btnfeedback.addEventListener('click', (event) => {

				let datarowid = btnfeedback.getAttribute("data-rowid");
				let scheduleid = btnfeedback.getAttribute("data-scheduleid");


				CSMainAPIs.Capshine.APIs.UpdateMeetingFeedBackHasSeenStatus.execute({ "rowid": datarowid }, (response) => {

					if (MyClub.isMobileApp == true) {
						MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.coachFeedbacks, { rowid: datarowid, scheduleid: scheduleid })
					}
					else {
						location.href = "/coachFeedbacks?rowid=" + datarowid + "&scheduleid=" + scheduleid;
					}
				});


			})
		});
		// ** End Feed back


		//

		let dummybtn = document.getElementById("dummybtn");
		if (dummybtn) {
			let secondsLeft = dummybtn.getAttribute('data-secondsleft');
			if (secondsLeft) {
				setInterval(() => {
					if (secondsLeft == 0) {
						if (MyClub.isMobileApp) {
							var rnd = MyClub.getRandomNunber();

							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.home, { rnd: rnd })
						} else {
							location.href = "/home"
						}
						secondsLeft = secondsLeft - 1;

						console.log("secondsLeft nextsession" + secondsLeft)
					}
					else if (secondsLeft > 0) {
						secondsLeft = secondsLeft - 1;
						//	console.log("secondsLeft nextsession"+secondsLeft)

						let totalMinutes = Math.floor(secondsLeft / 60);
						let seconds = secondsLeft % 60;
						let hours = Math.floor(totalMinutes / 60);
						let minutes = totalMinutes % 60;

						if (seconds.toString().length == 1) {
							seconds = "0" + seconds;
						}
						if (hours.toString().length == 1) {
							hours = "0" + hours;
						}
						if (minutes.toString().length == 1) {
							minutes = "0" + minutes;
						}

						dummybtn.firstElementChild.innerText = hours + ':' + minutes + ':' + seconds;
						dummybtn.setAttribute('data-secondsleft', secondsLeft)

					}
				}, 1000);
			}
		}

		//



		let divvoiceRecordingPromptPopup = document.getElementById('divvoiceRecordingPromptPopup');

		let diveaPromotionBanner = document.getElementById('app-promotion-banner')

		if (divvoiceRecordingPromptPopup) {
			let isVoiceRecorded = divvoiceRecordingPromptPopup.getAttribute("data-isVoiceRecorded");
			if (isVoiceRecorded == "True") {
				divvoiceRecordingPromptPopup.classList.remove('show')
				//  divvoiceRecordingPromptPopup.classList.add('show')
			}
			//if (isVoiceRecorded == "False") 
			else {

				var showPopup = false;

				if (MyClub.isMobileApp == true) {

					var currentdate = new Date();
					var voicerecordinglastupdateddate = window.localStorage.getItem('voicerecordinglastupdateddate');

					if (voicerecordinglastupdateddate) {
						currentdate.setHours(0, 0, 0, 0);
						var storegedate = new Date(voicerecordinglastupdateddate);
						storegedate.setHours(0, 0, 0, 0);
						if (currentdate > storegedate) {
							showPopup = true;
						}
						else {
							showPopup = false;
						}
					}
					else {
						showPopup = true;
					}

				}
				else {
					if (document.cookie.indexOf('promptvoicerecodingpopup') >= 0) {
						showPopup = false;
					}
					else {
						showPopup = true;
					}
				}


				if (showPopup == false) {
					let qs = MyClub.getQueryStrings();
					let vrpopup = qs["vrpopup"];
					if (vrpopup) {

						if (vrpopup == 1) {
							showPopup = true;
						}
					}
				}
				//  if come from zoom
				if (showPopup == true) {
					let qs = MyClub.getQueryStrings();
					let vrpopup = qs["vrpopup"];
					if (vrpopup) {

						if (vrpopup == 0) {
							showPopup = false;
							let myDate = new Date();
							myDate.setDate(myDate.getDate() + 1);
							if (MyClub.isMobileApp == true) {
								window.localStorage.setItem('voicerecordinglastupdateddate', myDate)
							}
						}
					}
				}

				if (showPopup == true) {

					divvoiceRecordingPromptPopup.classList.add('show');

					var body = document.body;
					body.classList.add("no-scroll");

					// if(diveaPromotionBanner){
					//     diveaPromotionBanner.classList.remove('show')  
					// }
					if (MyClub.isMobileApp == true) {
						// document.getElementById('app-promotion-banner').classList.remove('show');    

					}
					else {

						setTimeout(() => {
							document.getElementById('app-promotion-banner').classList.remove('show');
						}, 2000);

						//    location.href = "/VoiceRecording";
					}
				}
			}
		}

		let divContinueVoiceRecording = document.getElementById('divContinueVoiceRecording');
		let divNotNowVoiceRecording = document.getElementById('divNotNowVoiceRecording');
		let divStrip = document.getElementById('divStrip');
		let divBackDrop = document.getElementById('divBackDrop');
		if (divContinueVoiceRecording) {
			divContinueVoiceRecording.addEventListener('click', (event) => {
				GATrack.pushValues('Click_continue', 'Start Voice recognition', 'Start voice recognition');
				var body = document.body;
				body.classList.remove("no-scroll");
				if (MyClub.isMobileApp == true) {
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.voicerecording, null)
				}
				else {
					location.href = "/VoiceRecording";
				}
			})
		}

		if (divNotNowVoiceRecording) {
			divNotNowVoiceRecording.addEventListener('click', (event) => {
				GATrack.pushValues('Click_later', 'Later Voice Recognition', 'later');

				var body = document.body;
				body.classList.remove("no-scroll");

				divvoiceRecordingPromptPopup.classList.remove('show')

				var myDate = new Date();
				myDate.setDate(myDate.getDate() + 1);
				if (MyClub.isMobileApp == true) {
					window.localStorage.setItem('voicerecordinglastupdateddate', myDate)
				}
				else {
					document.cookie = "promptvoicerecodingpopup=; Path=/; Expires=" + myDate.toUTCString() + ";Domain=capshine.com";
				}

			})
		}

		if (divStrip) {
			divStrip.addEventListener('click', (event) => {
				GATrack.pushValues('Click_later', 'Later Voice Recognition', 'later');
				var body = document.body;
				body.classList.remove("no-scroll");
				divvoiceRecordingPromptPopup.classList.remove('show')

			})
		}

		if (divBackDrop) {
			divBackDrop.addEventListener('click', (event) => {
				GATrack.pushValues('Click_later', 'Later Voice Recognition', 'later');
				var body = document.body;
				body.classList.remove("no-scroll");
				divvoiceRecordingPromptPopup.classList.remove('show');
			})
		}




		//this.UserPid = document.getElementById("hdnUserPid").value;
		CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, MyClub.afterGetUserInfoLoad);

		MyClub.UserPid = userpid
		//  this.UserPid = userpid;
		let reserveSlotBtn = document.querySelectorAll(".myClubReserveSlotBtn");
		reserveSlotBtn.forEach((btn) => {
			btn.addEventListener('click', (event) => {
				let eventScdId = btn.getAttribute("data-eventscheduleid");
				let clubid = btn.getAttribute("data-clubid");
				let clubScheduleDate = btn.getAttribute("data-clubscheduledate");


				this.SubmitSlotBooking(eventScdId, clubid, clubScheduleDate, event);
			})
		});

		let joinMeetingtBtn = document.querySelectorAll(".join-meeting");
		if (joinMeetingtBtn != null) {
			joinMeetingtBtn.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.stopPropagation();
					//  const clubmeetingtype = e.currentTarget.getAttribute("data-clubmeetingtype")

					let limitedCount = 1;
					const clubmeetingtype = e.currentTarget.getAttribute("data-clubmeetingtype")

					limitedCount = 1;

					if (MyClub.userInfo.clubUserType == 1) {
						let pageType
						limitedCount = 0;
						// Live class Live class Repeat
						if (clubmeetingtype == "LiveClass" || clubmeetingtype == "LiveClassRepeat") {
							limitedCount = MyClub.userInfo.liveClassLimit;
							pageType = 2
						} else if (clubmeetingtype == "TalkTime") {
							limitedCount = MyClub.userInfo.talkTimeLimit
							pageType = 3
						} else if (clubmeetingtype == "StarSpeaker") {
							limitedCount = MyClub.userInfo.startSpeakerLimit
							pageType = 4
						} else if (clubmeetingtype == "FunFriday") {
							limitedCount = MyClub.userInfo.funFridayLimit
							pageType = 5
						} else if (clubmeetingtype == "ClubMeet") {
							limitedCount = 1;
							//  limitedCount = MyClub.userInfo.funFridayLimit
						}
						if (limitedCount == 0) {

							if (MyClub.isMobileApp == true) {

								// location.href = "/PaymentUpgradeRequest"
								var rnd = MyClub.getRandomNunber();

								MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
									pageType
								})


							}
							else {
								location.href = "/PaymentUpgradeRequest?pageType=" + pageType;
							}

							return;


						}
					}
					if (limitedCount != 0) {
						const ClubscheduleId = e.currentTarget.getAttribute("data-clubscheduleid")
						const MeetingId = e.currentTarget.getAttribute("data-meetingid")
						const UserPid = MyClub.UserPid;  //btn.getAttribute("userId");

						const zoomeetingmurl = e.currentTarget.getAttribute("data-meetingurl")

						const coachuserpid = e.currentTarget.getAttribute("data-coachuserpid");


						// https://sulekha.zoom.us/w/89866251679?tk=JFT5l4ACRBER0mnZ_nEMPIf9AfewO3NlcDh_AzojmUU.DQMAAAAU7HItnxZ4SXF0OV9LY1NBV1lZamc4aDlqR2h3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAA&pwd=NXBXdk9Pd2d3QWRXT3pKNWtTMU1pUT09

						//var isCoach=false;

						if (UserPid == coachuserpid) {
							MyClub.isCoach = true;

						}
						const reqURLObj = {
							ClubScheduleId: ClubscheduleId,
							MeetingId: MeetingId,
							UserPid: UserPid,
							Name: "",
							EmailId: "",
							IsCoach: MyClub.isCoach
						}

						const hdnIsMobileApp = document.getElementById('hdnIsMobileApp').value;

						CSMainAPIs.Capshine.APIs.GetZoomMeetingURL.execute(reqURLObj, (response) => {
							if (!response || !response.data) return
							if (!response.data || !response.data.result) return

							var meetingdetails = response.data.result

							let meetingToken = "";
							if (meetingdetails.meetingUrl) {
								const urlObj = new URL(meetingdetails.meetingUrl).searchParams;
								meetingToken = urlObj.get('tk');
							}
							else {
								meetingToken = meetingdetails.meetingToken;
							}

							// if env is web start using browser
							if (MyClub.userInfo.zoomMeetingEnvironment == 'web') {  // web or app

								let isChrome = false;
								let isChromeIOS = false;
								try {
									isChrome = /Google Inc/.test(navigator.vendor);
									isChromeIOS = /CriOS/.test(navigator.userAgent);
								}
								catch (err) {
									console.log(err);
								}

								if (meetingdetails.meetingUrl) {

									if (isChrome || isChromeIOS) {
										window.open(meetingdetails.meetingUrl, '_blank');
									}
									else {
										location.href = meetingdetails.meetingUrl;
									}

								}
								else {
									if (isChrome || isChromeIOS) {
										window.open(zoomeetingmurl, '_blank');
									}
									else {
										location.href = zoomeetingmurl;
									}

								}
							}

							else {   // if env is app


								if (MyClub.isMobileApp == true && !MyClub.isCoach) {

									var rnd = MyClub.getRandomNunber();

									var url = '/classroom';

									var queeySring = '?clubScheduleId=' + ClubscheduleId + "&rnd=" + rnd;

									var urlwithquerystring = url + queeySring;

									var stateObj = { Title: "classroom" + rnd, Url: urlwithquerystring };

									//  RefreshPage(stateObj)

									MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.classRoom, { clubScheduleId: ClubscheduleId, rnd: rnd });

									//location.href = `/classroom?clubScheduleId=${ClubscheduleId}`

								}
								else {
									//   let isSafari = false;

									let isChrome = false;
									let isChromeIOS = false;
									try {
										isChrome = /Google Inc/.test(navigator.vendor);
										isChromeIOS = /CriOS/.test(navigator.userAgent);
									}
									catch (err) {
										console.log(err);
									}


									if (meetingdetails.meetingUrl) {

										if (isChrome || isChromeIOS) {
											window.open(meetingdetails.meetingUrl, '_blank');
										}
										else {
											location.href = meetingdetails.meetingUrl;
										}

									}
									else {
										if (isChrome || isChromeIOS) {
											window.open(zoomeetingmurl, '_blank');
										}
										else {
											location.href = zoomeetingmurl;
										}

									}



								}
							}

							return; // Force to go to browsers and exit from line 




							// if (clubmeetingtype == "TalkTime" || clubmeetingtype == "StarSpeaker" || clubmeetingtype == "ClubMeet") {
							// 	if (meetingdetails.meetingUrl) {
							// 		window.open(meetingdetails.meetingUrl, '_blank');
							// 	}
							// 	else {
							// 		window.open(zoomeetingmurl, '_blank');

							// 	}
							// }
							// else if (hdnIsMobileApp === "true" && !MyClub.isCoach) {

							// 	console.log = function () { };
							// 	console.error = function () { };



							// 	if (MyClub.isMobileApp == true) {
							// 		var rnd = MyClub.getRandomNunber();
							// 		var url = '/classroom';
							// 		var queeySring = '?clubScheduleId=' + ClubscheduleId + "&rnd=" + rnd;
							// 		var urlwithquerystring = url + queeySring;
							// 		var stateObj = { Title: "classroom" + rnd, Url: urlwithquerystring };
							// 		//  RefreshPage(stateObj)
							// 		MyClub.sulekhaApp.navigateTo(MobilePages.classRoom, { clubScheduleId: ClubscheduleId, rnd: rnd });
							// 		//location.href = `/classroom?clubScheduleId=${ClubscheduleId}`
							// 	}
							// 	else {
							// 		location.href = `/classroom?clubScheduleId=${ClubscheduleId}`
							// 	}


							// } else {
							// 	if (meetingdetails.meetingUrl) {
							// 		window.open(meetingdetails.meetingUrl, '_blank');
							// 	}
							// 	else {
							// 		window.open(zoomeetingmurl, '_blank');

							// 	}
							// }

						})
						// Zoom meeting code end 


					}

					//  this.LaunchMeeting(meetingId,clubscheduleId,userId);
				})

			});
		}

		// document.getElementById('divLearningVideoSection').addEventListener('scroll', function (e) { document.getElementById('video-index').scrollLeft = e.target.scrollLeft - 645 })

		document.getElementById('divLearningVideoSection')?.addEventListener('scroll', function (e) {

			e.preventDefault()

			if (MyClub.isButtonClick) return



			document.getElementById('video-index').scrollLeft = e.target.scrollLeft - 645

		})

		//move div


		
		document.querySelectorAll("._sfvinfoicon").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.add('show')
				 }
			})
		})

		document.querySelectorAll("._sfvcontinuebtn").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.remove('show')
				 }
			})
		})

		document.querySelectorAll("._sfvcclosebtn").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.remove('show')
				 }
			})
		})

		document.querySelectorAll(".scrollVideo").forEach((btn) => {


			if (btn.getAttribute('data-iscurrentvideo') == "True") {

				MyClub.activevideorowid = btn.getAttribute('data-rowno');

				var activevideoid = "divLearningVideoId_" + MyClub.activevideorowid;
				var activerowNo = "row-" + MyClub.activevideorowid;

				var activeelement = document.getElementById(activevideoid);

				var activerowElement = document.getElementById(activerowNo);
				MyClub.isButtonClick = true
				if (activeelement) {
					activeelement.classList.add('active')
					activeelement.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });


				}

				if (activerowElement) {

					activerowElement.classList.add('active')

					setTimeout(() => {

						activerowElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });

					}, 1000)



				}

				setTimeout(() => MyClub.isButtonClick = false, 1000)

				// if (activerowElement) {
				//     activerowElement.classList.add('active')
				//     setTimeout(() => {
				//         activerowElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });
				//     }, 1000)
				// }



			}

			btn.addEventListener("click", function (e) {

				// remove active class 
				var currentvideoid = "divLearningVideoId_" + MyClub.activevideorowid;
				var currentrowNo = "row-" + MyClub.activevideorowid;

				var CurrentElement = document.getElementById(currentvideoid);
				var currentrowElement = document.getElementById(currentrowNo);

				if (CurrentElement) {
					CurrentElement.classList.remove('active')
				}

				if (currentrowElement) {
					currentrowElement.classList.remove('active')
				}
				// end 

				// MyClub.activevideorowid=rowno;

				e.stopPropagation();
				var scroller = document.getElementById('divLearningVideoSection')
				var rowno = e.currentTarget.getAttribute('data-rowno');
				MyClub.activevideorowid = rowno;
				var videoid = "divLearningVideoId_" + rowno;
				var rowNo = "row-" + rowno;
				var element = document.getElementById(videoid);
				var rowElement = document.getElementById(rowNo);

				if (element) {
					element.classList.add('active')
				}

				if (rowElement) {
					rowElement.classList.add('active')
				}

				MyClub.isButtonClick = true

				if (element != null) {



					rowElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });

					element.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" });

					setTimeout(() => {

						MyClub.isButtonClick = false;

					}, 1000)

				}





			})
		})




		document.querySelectorAll(".viewVideo").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.stopPropagation();
				var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');

				var videoId = e.currentTarget.getAttribute('data-videoid');
				var userId = e.currentTarget.getAttribute('data-userid');

				var obj = {
					videoid: videoId,
					userid: userId
				}


				if (MyClub.isMobileApp == true) {
					var rnd = MyClub.getRandomNunber();





					if (MyClub.userInfo.clubUserType == 1 && MyClub.userInfo.learningVideoLimit == 0) {

						setTimeout(() => {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
								pageType: 1
							})
						}, 1000);
					}
					else {

						setTimeout(() => {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo, { VideoId: videoId, rnd: rnd, loadnextvideo: 'no' });
						}, 1000);
					}

					// var url = '/WatchVideo';
					// var queeySring = '?VideoId=' + videoId + "&rnd=" + rnd;
					// var urlwithquerystring = url + queeySring;
					// var stateObj = { Title: "WatchVideo", Url: urlwithquerystring };

					//  RefreshPage(stateObj)

					//  history.pushState({}, stateObj.Title, stateObj.Url);


				}
				else {

					if (MyClub.userInfo.clubUserType == 1 && MyClub.userInfo.learningVideoLimit == 0) {
						location.href = "/PaymentUpgradeRequest?pageType=1";
					}
					else {

						location.href = "/WatchVideo?VideoId=" + videoId + "&loadnextvideo=no";
					}
				}





			})
		})


		// Short video 

		document.querySelectorAll("._clicksvftag").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.stopPropagation();
				//  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');   
				var tagid = e.currentTarget.getAttribute('data-tagid');
		//
		if (MyClub.isMobileApp == true) {
			var rnd = MyClub.getRandomNunber();
			
		
				setTimeout(() => {
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid, rnd: rnd});
				}, 1000);
			
		
		}
		else {
		
					location.href = "/ShortVideosViewAll?tagid=" + tagid;	
				
		
		}
		
			})
		}),

		// View All Videos Button
		document.querySelectorAll("._clicksvftagAllVideos").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.stopPropagation();
				//  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');   
				var tagid = e.currentTarget.getAttribute('data-tagid');
		//
		if (MyClub.isMobileApp == true) {
			var rnd = MyClub.getRandomNunber();
			
		
				setTimeout(() => {
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
				}, 1000);
			
		
		}
		else {
		
					location.href = "/videos";	
				
		
		}
		
			})
		}),

		document.querySelectorAll(".viewShortVideo").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.stopPropagation();
				//  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
				var languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
				var videoId = e.currentTarget.getAttribute('data-videoid');
				var userId = e.currentTarget.getAttribute('data-userid');
				var istodaywatchedvideo = e.currentTarget.getAttribute('data-istodaywatchedvideo');
				var tagid = e.currentTarget.getAttribute('data-tagid');

				if (MyClub.isMobileApp == true) {
					var rnd = MyClub.getRandomNunber();
					if (MyClub.userInfo.clubUserType == 1 && MyClub.userInfo.sfvLimit == false && istodaywatchedvideo == "False") {
						setTimeout(() => {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
								pageType: 9
							})
						}, 1000);
					}
					else {
						setTimeout(() => {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.watchShortVideos, { VideoId: videoId, rnd: rnd, iswatched: '3', languagevideoid: languagevideoid, tagid: tagid });
						}, 1000);
					}


				}
				else {

					if (MyClub.userInfo.clubUserType == 1 && MyClub.userInfo.sfvLimit == false && istodaywatchedvideo == "False") {
						location.href = "/PaymentUpgradeRequest?pageType=9";
					}
					else {

						if (MyClub.iOS()) {
							location.href = "/watchShortVideosInIOS?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;;
						}
						else {
							location.href = "/watchShortVideos?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;;

						}
					}
				}

			})
		})

		if (!sulekhaApp)
			this.bindCalendarLink();


		// Job Intevieww 
		if (document.getElementById('btnStartJobInterview')) {

			document.getElementById('btnStartJobInterview').addEventListener("click", function (e) {

				let videoId = e.currentTarget.getAttribute('data-videoid');
				let hasstarted = e.currentTarget.getAttribute('data-hasstarted');



				if (MyClub.userInfo.isJobInterviewCourseUser == 0) {
					if (MyClub.isMobileApp) {
						MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
					}
					else {
						location.href = "/paymentPlans";
					}
				}

				if (MyClub.userInfo.isJobInterviewCourseUser == 1) {
					if (hasstarted == 1) {
						if (MyClub.isMobileApp == true) {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.WatchJobInterviewCourseVideo, {
								videoid: videoId
							})
						}
						else {
							location.href = "/WatchJobInterviewCourseVideo?videoid=" + videoId
						}
					}
					else {

						if (MyClub.isMobileApp == true) {
							MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourse)
						}
						else {
							location.href = "/JobInterviewCourse"
						}
					}
				}


			})
		}


      //Subscribe

		if (document.getElementById('btnViewJobInterview')) {

			document.getElementById('btnViewJobInterview').addEventListener("click", function (e) {

				if (MyClub.userInfo.isJobInterviewCourseUser == 0) {
					if (MyClub.isMobileApp) {
						MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourse, null);
					}
					else {
						location.href = "/JobInterviewCourse";
					}
				}



			})
		}






		if (document.getElementById('btnbooktalktimeslots')) {

			document.getElementById('btnbooktalktimeslots').addEventListener("click", function () {

				if (MyClub.isMobileApp == true) {
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules)
				}
				else {
					location.href = "/talktimeSchedules"
				}

			})
		}





	},

	bindCalendarLink() {
		var addCalendarLink = document.getElementById('addGoogleCalendarBtn');
		var addOutlookLink = document.getElementById('addOutlookCalendarBtn');
		if (addCalendarLink || addOutlookLink) {
			document.querySelectorAll('[data-setReminderLink]').forEach((setReminder) => {
				setReminder.addEventListener("click", function () {
					const val = setReminder.getAttribute('data-setReminderLink');
					document.getElementById('calendarAdd-model').classList.add('show');
					addCalendarLink.classList.remove('disabled');
					addOutlookLink.classList.remove('disabled');
					MyClub.startTime = setReminder.getAttribute('data-starttime');
					MyClub.endTime = setReminder.getAttribute('data-endtime');
					MyClub.description = setReminder.getAttribute('data-description');
					MyClub.summary = setReminder.getAttribute('data-summary');
					MyClub.clubScheduleId = val;
				});
			});
			addCalendarLink.addEventListener("click", function () {
				addCalendarLink.classList.add('disabled');
				addOutlookLink.classList.add('disabled');
				js_GoogleCalendar.init(MyClub.callbackSignIn);
			});
			addOutlookLink.addEventListener("click", function () {
				addCalendarLink.classList.add('disabled');
				addOutlookLink.classList.add('disabled');
				ts_MicrosoftOutlookCalendar.init(MyClub.pushOutlookEvents);
			});
		}
	},
	callbackSignIn(isMobile, email, token = null) {
		const event = {
			'summary': MyClub.summary,
			'location': 'www.capshine.com',
			'description': MyClub.description,
			'start': {
				'dateTime': MyClub.startTime,
				'timeZone': 'IST'
			},
			'end': {
				'dateTime': MyClub.endTime,
				'timeZone': 'IST'
			},
			'attendees': [
				{ 'email': email }
			],
			'reminders': {
				'useDefault': true
			}
		};
		if (isMobile)
			MyClub.pushGoogleEvents(event, token);
		else
			js_GoogleCalendar.pushEvents(event, MyClub.callbackAddEvent);
	},
	callbackAddEvent(response) {
		if (response.status == "confirmed" || response.status == 200)
			CSMainAPIs.Capshine.APIs.UpdateCalendarEvent.execute({ 'ClubScheduleId': parseInt(MyClub.clubScheduleId), 'IsGoogleAdded': 1, 'UserPid': MyClub.UserPid }, (response) => {
				if (response.data.result == 1) {
					document.getElementById('calendarAdd-model').classList.remove('show');
					document.querySelector('[data-setReminderLink="' + MyClub.clubScheduleId + '"]').parentElement.innerHTML = 'Schedule added to your Google Calendar';
				}
			});
		else
			if (window.localStorage.getItem('google-calendar-userInfo'))
				window.localStorage.removeItem('google-calendar-userInfo');
	},
	pushGoogleEvents(event, token) {
		const url = 'https://www.googleapis.com/calendar/v3/calendars/primary/events';
		var request = {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + token + "",
			},
			method: "POST",
			body: JSON.stringify(event)
		};
		fetch(url, request).then(response => response.json())
			.then(MyClub.callbackAddEvent).catch(MyClub.callbackAddEvent);
	},
	pushOutlookEvents: async function (userInfo, token) {
		const event = {
			"subject": MyClub.summary,
			"body": {
				"contentType": "HTML",
				"content": MyClub.description
			},
			"start": {
				"dateTime": MyClub.startTime,
				"timeZone": "India Standard Time"
			},
			"end": {
				"dateTime": MyClub.endTime,
				"timeZone": "India Standard Time"
			},
			"attendees": [
				{
					"emailAddress": {
						"address": userInfo.email,
						"name": userInfo.displayName
					},
					"type": "required"
				}
			]
		}
		let response;
		const url = 'https://graph.microsoft.com/v1.0/me/events';
		const request = {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + token + "",
			},
			method: "POST",
			body: JSON.stringify(event)
		};
		await fetch(url, request).then(response => response.json())
			.then((data) => { response = data; }).catch((data) => { response = data; });
		MyClub.callbackOutlookCreated(response);
	},
	callbackOutlookCreated(response) {
		CSMainAPIs.Capshine.APIs.UpdateCalendarEvent.execute({ 'ClubScheduleId': parseInt(MyClub.clubScheduleId), 'IsOutlookAdded': 1, 'UserPid': MyClub.UserPid }, (response) => {
			if (response.data.result == 1) {
				document.getElementById('calendarAdd-model').classList.remove('show');
				document.querySelector('[data-setReminderLink="' + MyClub.clubScheduleId + '"]').parentElement.innerHTML = 'Schedule added to your Outlook Calendar';
			}
		});
	},
	afterGetUserInfoLoad(response) {
		MyClub.userInfo = response.data;

	},
	// UpdateClubUserLanguageResponse: function () {
	//     console.log('UpdateClubUserLanguageResponse')
	// },
	SubmitVideoWatchedStatusResponse: function () {
		console.log('SubmitVideoWatchedStatusResponse')
	},
	SubmitSlotBooking: function (eventScdId, clubid, clubScheduleDate, event) {
		// Loader.show();
		MyClub.MyClubEvent = event;
		MyClub.eventScdId = eventScdId;
		CSMainAPIs.Capshine.APIs.SubmitSlotBooking.execute({ 'eventScdId': eventScdId, 'clubid': clubid, 'userPid': MyClub.UserPid, 'clubScheduleDate': clubScheduleDate }, this.SubmitSlotResponse);


		// fetch(`/api/MyClub/SubmitSlotBooking?eventScdId=${eventScdId}&userPid=${this.UserPid}&clubid=${clubid}&clubScheduleDate=${clubScheduleDate}`)
		//     .then(response => response.json())
		//     .then(data => {
		//         // Loader.hide();
		//         if (data == 1) {
		//             this.hideDiv(event,eventScdId);
		//         }
		//         else {
		//             alert("Slot Booking Failed Please contact your admin...");
		//             location.reload();
		//         }
		//     });


	},

	GetZoomMeetingLink: function (clubScheduleId, userEmail, userName, meetingId) {
		var meetingUrl = "";
		_Loader__WEBPACK_IMPORTED_MODULE_0__.default.show();
		fetch(`/api/MyClub/GetClubMeetParticipantUrl?ClubScheduleId=${clubScheduleId}&UserPid=${this.UserPid}&Name=${userName}&EmailId=${userEmail}&MeetingId=${meetingId}`)
			.then(response => response.json())
			.then(data => {
				_Loader__WEBPACK_IMPORTED_MODULE_0__.default.hide();
				if (data != null) {
					if (data.meetingUrl != null) {
						meetingUrl = data.meetingUrl;
					}
					else if (data.meetingurl != null) {
						meetingUrl = data.meetingurl;
					}
					else if (data.MeetingUrl != null) {
						meetingUrl = data.MeetingUrl;
					}
				}
			});
		return meetingUrl;
	},

	SubmitSlotResponse: function (response) {

		if (response.data == 1) {
			MyClub.hideDiv(MyClub.MyuClubEvent, MyClub.eventScdId);
		}
		else {
			alert("Slot Booking Failed Please contact your admin...");
			// location.href = "/home"
			///router.push({ path: '/home' })

			if (MyClub.isMobileApp) {
				var rnd = MyClub.getRandomNunber();
				var stateObj = { Title: "home" + rnd, Url: '/home' };
				//  RefreshPage(stateObj)

				if (MyClub.rootpage == 'home') {
					//   stateObj = { Title: "home" + rnd, Url: '/home' };
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null);

				} else {
					//  stateObj = { Title: "LearningPlan" + rnd, Url: '/LearningPlan' };
					MyClub.sulekhaApp.navigateTo(MainEnums_MobilePages.learningPlan, null);
				}

				// history.back();
				// history.replaceState({}, stateObj.Title, stateObj.Url);
				// history.pushState({}, stateObj.Title, stateObj.Url);
				// history.forward();
			}
			else {
				location.href = "/home"
			}
		}
	},
	hideDiv: function (event, eventScdId = 0) {

		var elementdivunreserved = document.getElementById("divUnreserved_" + eventScdId)


		if (elementdivunreserved != null) {
			elementdivunreserved.classList.add("hide");
		}


		var elementdivReserved = document.getElementById("divReserved_" + eventScdId)


		if (elementdivReserved != null) {
			elementdivReserved.classList.remove("hide");
			//         const div = document.getElementById(`mt-2_${eventScdId}`)
			//div.innerText = `You can join the session 5 minutes before start time.`
		}



	},

	getOffset: function (el) {
		const rect = el.getBoundingClientRect();
		return {
			left: rect.left + window.scrollX,
			top: rect.top + window.scrollY
		};
	},

	exitZoom: function () {

		let DivPageMainLayout = document.getElementById('DivPageMainLayout');

		document.getElementById('ZoomCallLayout').innerHTML = '';

		document.getElementById('zmmtg-root').remove();

		if (DivPageMainLayout) {

			DivPageMainLayout.classList.remove('hide')

		}

		window.location.reload()

		// const createResponseVue = createApp(ZoomVideoCall, zoomCallInfo);

	},
	getRandomNunber: function () {
		return Math.floor(1000 + Math.random() * 9000);
	},

	ChangeUrl: function (page, url) {
		if (typeof (history.pushState) != "undefined") {
			var obj = { Page: page, Url: url };
			history.pushState(obj, obj.Page, obj.Url);
		} else {
			window.location.href = "homePage";
			// alert("Browser does not support HTML5.");
		}
	},
	getQueryStrings: function () {
		var assoc = {};
		var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
		var queryString = location.search.substring(1);
		var keyValues = queryString.split('&');

		for (var i in keyValues) {
			var key = keyValues[i].split('=');
			if (key.length > 1) {
				assoc[decode(key[0])] = decode(key[1]);
			}
		}

		return assoc;
	},

	iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

}

function scrollToSmoothly(pos, time = 500) {
	let currentPos = window.pageXOffset;
	let start = null;
	pos = +pos, time = +time;
	window.requestAnimationFrame(function step(currentTime) {
		start = !start ? currentTime : start;
		var progress = currentTime - start;
		if (currentPos < pos) {
			window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
		} else {
			window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
		}
		if (progress < time) {
			window.requestAnimationFrame(step);
		} else {
			window.scrollTo(0, pos);
		}
	});
}




// window.onpopstate = function(event) {
//    // history.pushState(stateObj, stateObj.Title, stateObj.Url);

//     history.forward();
//     //alert(6)
//     //window.location = location.href
//     //   console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));


//     //    if (history.state && "WatchVideo" === history.state.page) {
//     //        load(history.state.name, true);
//     //      }


//      }

/* harmony default export */ const js_MyClub = (MyClub);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/DailyActivityDetails.vue?vue&type=template&id=1655494d


const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_1 = { class: "sk-container top-20" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_2 = { class: "activites" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_3 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "section-title" }, "Archive Activities", -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_4 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, "Here is your chance to practice all the daily activities that you have missed.", -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_5 = ["onClick"]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_6 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "right-arrow-icon",
  viewBox: "0 0 9 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skiconrightarrow" })
], -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_7 = { class: "sk-inner activity" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_8 = { class: "sk-header" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_9 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  width: "20",
  height: "23",
  id: "back",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconbackarrow" })
], -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_10 = [
  DailyActivityDetailsvue_type_template_id_1655494d_hoisted_9
]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_11 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "title" }, "Archive Activities", -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_12 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "icon icon-chevron",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_13 = [
  DailyActivityDetailsvue_type_template_id_1655494d_hoisted_12
]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_14 = { class: "sk-body" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "archive-practice" }, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconnote" })
    ])
  ]),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, "Practice all activities you have missed.")
], -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_16 = { class: "archive-status" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_17 = { class: "archive-date" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_18 = { class: "table archive-table" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_19 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("thead", { class: "thead-light" }, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
    /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", { scope: "col" }, "Date"),
    /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", { scope: "col" }, "Status")
  ])
], -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_20 = { scope: "row" }
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_21 = {
  key: 0,
  class: "right",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "#ffffff"
}
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_22 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcheckanswer" }, null, -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_23 = [
  DailyActivityDetailsvue_type_template_id_1655494d_hoisted_22
]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_24 = {
  key: 1,
  class: "wrong",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#000000",
  viewBox: "0 0 256 256"
}
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_25 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcross" }, null, -1)
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_26 = [
  DailyActivityDetailsvue_type_template_id_1655494d_hoisted_25
]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_27 = ["onClick"]
const DailyActivityDetailsvue_type_template_id_1655494d_hoisted_28 = ["onClick"]

function DailyActivityDetailsvue_type_template_id_1655494d_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
    (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_1, [
      (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_2, [
        DailyActivityDetailsvue_type_template_id_1655494d_hoisted_3,
        DailyActivityDetailsvue_type_template_id_1655494d_hoisted_4,
        (0,vue_cjs.createElementVNode)("ul", null, [
          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($props.activityTypes, (result, index) => {
            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
              onClick: $event => ($options.getArchiveDetails(result.id)),
              key: index
            }, [
              (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(result.description) + " ", 1),
              DailyActivityDetailsvue_type_template_id_1655494d_hoisted_6
            ], 8, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_5))
          }), 128))
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", {
      class: (0,vue_cjs.normalizeClass)(["sk-panel archive", $data.showPopupArchive ? 'show' : _ctx.hide])
    }, [
      (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_7, [
        (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_8, [
          (0,vue_cjs.createElementVNode)("div", {
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeArchiveModal && $options.closeArchiveModal(...args))),
            class: "left-nav"
          }, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_10),
          DailyActivityDetailsvue_type_template_id_1655494d_hoisted_11,
          (0,vue_cjs.createElementVNode)("div", {
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.closeArchiveModal && $options.closeArchiveModal(...args))),
            class: "right-nav"
          }, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_13)
        ]),
        (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_14, [
          DailyActivityDetailsvue_type_template_id_1655494d_hoisted_15,
          (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_16, [
            (0,vue_cjs.createElementVNode)("div", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_17, [
              (0,vue_cjs.createElementVNode)("span", null, (0,vue_cjs.toDisplayString)($data.archiveActivityDesc), 1)
            ]),
            (0,vue_cjs.createElementVNode)("table", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_18, [
              DailyActivityDetailsvue_type_template_id_1655494d_hoisted_19,
              (0,vue_cjs.createElementVNode)("tbody", null, [
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.archiveDetails, (result, index) => {
                  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", { key: index }, [
                    (0,vue_cjs.createElementVNode)("th", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_20, (0,vue_cjs.toDisplayString)(result.reFormatedActivityDate), 1),
                    (0,vue_cjs.createElementVNode)("td", null, [
                      (result.isActivityDone == 1)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_21, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_23))
                        : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", DailyActivityDetailsvue_type_template_id_1655494d_hoisted_24, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_26)),
                      (result.isActivityDone == 1)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("a", {
                            key: 2,
                            onClick: $event => ($options.ViewResponses(result.activityId))
                          }, "View Responses", 8, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_27))
                        : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("a", {
                            key: 3,
                            onClick: $event => ($options.participateActivity(result.activityId))
                          }, "Participate", 8, DailyActivityDetailsvue_type_template_id_1655494d_hoisted_28))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
}
;// CONCATENATED MODULE: ./src/Components/DailyActivityDetails.vue?vue&type=template&id=1655494d

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/DailyActivityDetails.vue?vue&type=script&lang=js

	//import Loader from "../../wwwroot/js/Loader.js";
	
	
	
	/* harmony default export */ const DailyActivityDetailsvue_type_script_lang_js = ({
		name: "DailyActivityDetails",
		data() {
			return {
				archiveDetails: [],
				showPopupArchive: false,
				archiveActivityDesc: '',
			}
		},
		props: {
			activityTypes: [],
			userPid: { type: Number, required: true, default: 0 },
			sulekhaApp: null,
		},
		mounted: function () {
			var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

			if (hdnIsMobileApp) {
				if (hdnIsMobileApp.value == "true") {
					this.isMobileApp = true;
				}
				else {
					this.isMobileApp = false;
				}
			}
		},
		methods: {
			getArchiveDetails: function (id) {
				var name = this.activityTypes.filter(res => res.id == id)[0].name;
				GATrack.pushValues('DEA_activity_cat' + id, name + '_' + id, 'Click_DEA_activity_cat' + id);
				this.archiveActivityDesc = this.activityTypes.filter(res => res.id == id)[0].description;
				var obj = {
					activityTypeId: id,
					userPid: this.userPid,
				};
				CSMainAPIs.Capshine.APIs.GetDailyAcitivityArchiveDetails.execute(obj, this.getArchiveDetailsCallback);
			},
			getArchiveDetailsCallback: function (response) {
				if (response.data.length > 0) {
					this.archiveDetails = response.data;
					this.showPopupArchive = true;
				}
			},
			participateActivity: function (id) {
				const clubUserType = document.getElementById("hdnClubUserType").value;
				// Limited
				if (clubUserType.toLowerCase() === '1' || clubUserType.toLowerCase() === 'limited') {
					if (this.isMobileApp) {
						this.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 7 });
					} else {
						window.location.href = "/paymentUpgradeRequest?pageType=7";
					}
					return
				}
				if (this.isMobileApp)
					this.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivity, { activityid: id });
				else
					location.href = '/dailyactivity?activityid=' + id;
			},
			ViewResponses: function (id) {
				if (this.isMobileApp)
					this.sulekhaApp.navigateTo(MainEnums_MobilePages.dailyActivityresponse, { activityid: id });
				else
					location.href = '/dailyActivityresponse?activityid=' + id;
			},
			closeArchiveModal: function () {
				this.showPopupArchive = false;
			},
			closeDailyActivityModal: function () {
				document.getElementById('modalDailyActivity').remove();
				this.showPopupArchive = true;
			},
		},
	});

;// CONCATENATED MODULE: ./src/Components/DailyActivityDetails.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/DailyActivityDetails.vue




;
const DailyActivityDetails_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DailyActivityDetailsvue_type_script_lang_js, [['render',DailyActivityDetailsvue_type_template_id_1655494d_render]])

/* harmony default export */ const DailyActivityDetails = (DailyActivityDetails_exports_);
;// CONCATENATED MODULE: ./src/js/DailyActivityDetails.js
﻿



let DailyActivityDetails_DailyActivityDetails = {
	userPid: 0,
	activityTypes: [],
	sulekhaApp: null,
	init: function (userPid, sulekhaApp = null) {
		this.sulekhaApp = sulekhaApp;
		this.userPid = userPid;
		if (this.userPid)
		{
			DailyActivityDetails_DailyActivityDetails.ShowHeaderFooter();
			CSMainAPIs.Capshine.APIs.GetDailyActivityTypes.execute({}, this.GetDailyActivityTypes);
		}
	},
	GetDailyActivityTypes: function (response) {
		if (response.data) {
			DailyActivityDetails_DailyActivityDetails.activityTypes = response.data;
			DailyActivityDetails_DailyActivityDetails.bindComponent();
		}
	},
	bindComponent: function () {
		if (document.getElementById('dailyActivityDetails-div')) {
			const props = {
				activityTypes: DailyActivityDetails_DailyActivityDetails.activityTypes,
				userPid: DailyActivityDetails_DailyActivityDetails.userPid,
				sulekhaApp: DailyActivityDetails_DailyActivityDetails.sulekhaApp
			};
			const createResponseVue = (0,vue_cjs.createApp)(DailyActivityDetails, props);
			createResponseVue.mount('#dailyActivityDetails-div');
		}
	},
	ShowHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}
	},
}
/* harmony default export */ const js_DailyActivityDetails = (DailyActivityDetails_DailyActivityDetails);
;// CONCATENATED MODULE: ./node_modules/@capacitor/device/dist/esm/index.js

const Device = (0,dist/* registerPlugin */.fo)('Device', {
    web: () => __webpack_require__.e(/* import() */ 961).then(__webpack_require__.bind(__webpack_require__, 651)).then(m => new m.DeviceWeb()),
});


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/capacitor-rate-app/dist/esm/index.js

const RateApp = (0,dist/* registerPlugin */.fo)('RateApp', {
    web: () => __webpack_require__.e(/* import() */ 540).then(__webpack_require__.bind(__webpack_require__, 540)).then(m => new m.RateAppWeb()),
});


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/js/WatchVideoScript.js








var WatchVideoScript = {
    UserPid: '',
    videoId: 0,
    isVideoViewed: false,
    isMobileApp: false,
    sulekhaApp: null,
    pagename: "home",
    videoEndPopup: null,
    player: null,
    init: function (userId, sulekhaApp = null) {
        WatchVideoScript.videoEndPopup = document.getElementById('startMCQPopup')
        WatchVideoScript.sulekhaApp = sulekhaApp;

        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchVideoScript.isMobileApp = true;
            }
            else {
                WatchVideoScript.isMobileApp = false;
            }
        }


        var hdnpage = document.getElementById("hdnPageType");

        if (hdnpage) {
            if (hdnpage.value == 'Home')
                WatchVideoScript.pagename = "home";
            else if (hdnpage.value == 'LearningPlan')
                WatchVideoScript.pagename = "learningplan";
        }

        WatchVideoScript.UserPid = userId;
        WatchVideoScript.bindEvets()
        //  CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid":userId }, WatchVideoScript.afterGetUserInfoLoad);


    },
    // Initilize after verifiying user informations 
    bindEvets: function () {
        let youtubeIframeExists = document.getElementById('youtubecontainer')
        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');
        let YTiframeApi = document.getElementById('YTiframeApi');
        // 
        let videoContainer = document.getElementById("videoContainer")

        
        // On route change create youtube iframe
        if (!youtubeIframeExists && YTiframeApi) {
            const videoUrl = videoContainer.getAttribute('data-videourl');
            const videoPath = videoUrl.split("/").pop();
            const videoId = videoPath.split('?').shift();

            
            WatchVideoScript.player = new YT.Player('videoContainer', {
                videoId: videoId,
                host: 'https://www.youtube-nocookie.com',
                events: {
                    'onStateChange': WatchVideoScript.onPlayerStateChange
                },
                playerVars: {
                    // origin: window.location.host,
                    rel: 0,
                    modestbranding: 1
                }
            });
        }
        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        var youtubevideoselection = document.querySelector('.youtubevideo') !== null;
        if (youtubevideoselection) {
            document.querySelectorAll(".youtubevideo").forEach((btn) => {
                WatchVideoScript.videoId = btn.getAttribute('data-videoid');  // Fetch video id

            })
        } else {

        }

        if (document.getElementById('ddlLanguage')) {

            // drop down langguge
            document.getElementById('ddlLanguage').addEventListener('change', function (e) {
                GATrack.pushValues('VideoLearning_Languagechange', this.value, 'Click_VideoLearning_Languagechange');
                var userId = e.currentTarget.getAttribute('data-userid');
                var videoid = e.currentTarget.getAttribute('data-videoid');
                WatchVideoScript.videoId = videoid;
                let clientData = {
                    UserPid: userId,
                    Language: this.value
                }
                CSMainAPIs.Capshine.APIs.UpdateClubUserLanguage.execute(clientData, WatchVideoScript.UpdateClubUserLanguageResponse);

            });

            let defaultLanguage = document.getElementById('ddlLanguage').getAttribute('data-preferredlanguage');
            document.getElementById('ddlLanguage').value = defaultLanguage;
        }


        if (document.getElementById('cancelskipvideo')) {
            document.getElementById('cancelskipvideo').addEventListener('click', function (e) {
                e.stopPropagation();
                document.querySelector(".sk-popup").classList.remove("show");
                WatchVideoScript.backToHomePage()

            })

        }

        if (document.getElementById('WatchVideoIconclose')) {
            document.getElementById('WatchVideoIconclose').addEventListener('click', function (e) {
                e.stopPropagation();
                document.querySelector(".sk-popup").classList.remove("show");

            })

        }




        if (document.getElementById('btnokskipvideo')) {
            document.getElementById('btnokskipvideo').addEventListener('click', function (e) {
                e.stopPropagation();
                document.querySelector(".sk-popup").classList.remove("show");
                var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                var userId = e.currentTarget.getAttribute('data-userid');
                var videoId = e.currentTarget.getAttribute('data-videoid');
                var lessionid = e.currentTarget.getAttribute('data-lessionid');
                WatchVideoScript.ShowMCQTestPanel(videouniqueid, videoId, lessionid);

            })
        }

        // var iframe = document.getElementById('divWatchVideoContainer');
        // videoContainer = document.getElementById('videoContainer')





        if (document.getElementById('btnstarttest')) {
            document.getElementById('btnstarttest').addEventListener('click', async function (e) {
                e.stopPropagation();
                // youtube
                // 
                var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                var userId = e.currentTarget.getAttribute('data-userid');
                var videoId = e.currentTarget.getAttribute('data-videoid');
                WatchVideoScript.videoId = e.currentTarget.getAttribute('data-videoid');
                var lessionid = e.currentTarget.getAttribute('data-lessionid');
                GATrack.pushValues('MCQ_Q1', videoId + '_MCQ1', 'Click_MCQ_Q1');
                WatchVideoScript.ShowMCQTestPanel(videouniqueid, videoId, lessionid);

                // var clientData = {
                //     UserPid: userId,
                //     VideoId: videoId,
                //     VideoUniqueId: videouniqueid
                // }


                // const data = await CSMainAPIs.Capshine.APIs.SubmitLearningVideoWatchedStatus.execute(clientData, WatchVideoScript.SubmitVideoWatchedStatusResponse);
                // console.log("data:", data)

                var sk_popup = document.querySelector('.sk-popup') !== null;

                if (sk_popup) {
                    document.querySelector(".sk-popup").classList.remove("show");
                }



            })

        }

        if (document.getElementById('btnVideoBack')) {
            document.getElementById('btnVideoBack').addEventListener('click', async function (e) {
                e.stopPropagation();

                // var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                // var userId = e.currentTarget.getAttribute('data-userid');
                // var videoId = e.currentTarget.getAttribute('data-videoid');
                // WatchVideoScript.videoId = e.currentTarget.getAttribute('data-videoid');

                // 
                // var clientData = {
                //     UserPid: userId,
                //     VideoId: videoId,
                //     VideoUniqueId: videouniqueid
                // }
                // 

                // const data = await CSMainAPIs.Capshine.APIs.SubmitLearningVideoWatchedStatus.execute(clientData, WatchVideoScript.SubmitVideoWatchedStatusResponse);
                // console.log("data:", data)

                var ismcqcompleted = e.currentTarget.getAttribute('data-ismcqcompleted');

                var shortvideobackpage = window.localStorage.getItem('backpage');

                if (ismcqcompleted == "False") {

                    var sk_popup = document.querySelector('.sk-popup') !== null;
                    if (sk_popup) {
                        document.querySelector(".sk-popup").classList.add("show");
                    }
                }
                else {
                    if (WatchVideoScript.isMobileApp) {

                        if (shortvideobackpage == "videos") {
                            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                        }
                        else if (shortvideobackpage == "videolessons") {
                            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
                        }
                        else if (shortvideobackpage == "watchedvideoLesson") {
                            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos,{ atab:'video'});
                        }
                        else {
                            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                        }


                        // if (WatchVideoScript.sulekhaApp.state.rootPage === MobilePages.unknown) {
                        //     WatchVideoScript.sulekhaApp.navigateTo(MobilePages.home, null)
                        // } else {
                        //     WatchVideoScript.sulekhaApp.navigateTo(WatchVideoScript.sulekhaApp.state.rootPage, null);
                        // }
                    }
                    else {
                        // history.back();
                        if (shortvideobackpage) {
                            if (shortvideobackpage == "video") {
                                location.href = "/videos"
                            }
                            else if (shortvideobackpage == "videolessons") {
                                location.href = "/videolessons"
                            }
                            else if (shortvideobackpage == "watchedvideo") {
                                location.href = "/watchedvideos?atab=video"
                             
                            }
                            else if (shortvideobackpage == "home") {
                                location.href = "/home"
                            }
                        }
                        else {
                            location.href = "/home"
                        }

                        // else if (MyClub.rootpage == "home") {
                        //     location.href = "/home"
                        // }
                        // else {
                        //     location.href = "/LearningPlan"
                        // }
                    }


                }


            })

        }

        
        // If Iframe aslready exists Don't call YT api.
        if (!youtubeIframeExists) WatchVideoScript.loadIframeAPI()
    },
    loadIframeAPI: function () {
        
        let videoContainer = document.getElementById("videoContainer")
        document.getElementById('videoClickTracker').addEventListener('click', async (e) => {

            let startMCQPopupClose = document.getElementById('startMCQPopupClose');
            let startMCQPopupCancel = document.getElementById('startMCQPopupCancel');
            let startMCQButton = document.getElementById('startMCQButton');
            startMCQButton.addEventListener('click', (e) => {
                var lessionid = e.currentTarget.getAttribute('data-lessionid');
                WatchVideoScript.ShowMCQTestPanel(WatchVideoScript.videouniqueid, WatchVideoScript.videoId, lessionid);
            })
            startMCQPopupClose.addEventListener('click', () => {
                WatchVideoScript.videoEndPopup.classList.remove('show');
            })
            startMCQPopupCancel.addEventListener('click', () => {
                WatchVideoScript.videoEndPopup.classList.remove('show');
            })

            WatchVideoScript.player.playVideo();
            // check Youtube iframe and iframe embed is already present

            var videouniqueid = videoContainer.getAttribute('data-videouniqueid');
            var userId = videoContainer.getAttribute('data-userid');
            var videoId = videoContainer.getAttribute('data-videoid');
            WatchVideoScript.UserPid = userId
            WatchVideoScript.videoId = videoContainer.getAttribute('data-videoid');
            WatchVideoScript.videouniqueid = videoContainer.getAttribute('data-videouniqueid');
            e.target.classList.add('hide')



            var clientData = {
                UserPid: userId,
                VideoId: videoId,
                VideoUniqueId: videouniqueid
            }


            let url = `${CSMainAPIs.Capshine.Server.baseUrl}api/MyClub/SubmitLearningVideoWatchedStatus`

            const data = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(clientData)
            }).then((data) => data.json())

        })

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        tag.id = "YTiframeApi"
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        const videoUrl = videoContainer.getAttribute('data-videourl');
        const videoPath = videoUrl.split("/").pop();
        const videoId = videoPath.split('?').shift();


        window.onYouTubeIframeAPIReady = function () {
            WatchVideoScript.player = new YT.Player('videoContainer', {
                videoId: videoId,
                host: 'https://www.youtube-nocookie.com',
                events: {
                    'onStateChange': WatchVideoScript.onPlayerStateChange
                },
                playerVars: {
                    // origin: window.location.host,
                    rel: 0,
                    modestbranding: 1
                }
            });
        }
        console.log("WatchVideoScript.player:", WatchVideoScript.player);
        // }
    },
    onPlayerStateChange: async function (event) {
        let deviceInfo
        let deviceId
        if (WatchVideoScript.isMobileApp) {
            deviceInfo = await Device.getInfo()
            deviceId = await Device.getId().uuid
        }
        switch (event.data) {
            case YT.PlayerState.UNSTARTED:
                let event_actions = {}
                event_actions.user_id = WatchVideoScript.UserPid
                event_actions.screen_type = "Learning videos_play video"
                event_actions.page_url = window.location.href
                event_actions.device_name = deviceInfo?.model || null
                event_actions.device_id = deviceId || null
                event_actions.device_os_version = deviceInfo?.osVersion || null
                event_actions.platform = WatchVideoScript.isMobileApp ? "app/mobile" : "web"
                
                GATrack.pushValues('Learning_video_Play', 'Play video', 'click_Play_Video', event_actions);
                break;
            case YT.PlayerState.ENDED:
                WatchVideoScript.isVideoViewed = true;
                WatchVideoScript.videoEndPopup.classList.add('show');
                break;
            case YT.PlayerState.PLAYING:
                break;
            case YT.PlayerState.PAUSED:
                break;
            case YT.PlayerState.BUFFERING:
                break;
            case YT.PlayerState.CUED:
                break;
        }
    },
    UpdateClubUserLanguageResponse: async function (Response) {

        var rnd = WatchVideoScript.getRandomNunber();
        //  alert(rnd)

        //var url ='/WatchVideo'; 

        // var url = window.location.href;      



        //   history.replaceState({},stateObj.Title,stateObj.Url);     
        //   history.pushState({},stateObj.Title , stateObj.Url);    
        //   history.back();
        //   history.forward();



        //  history.replaceState({},stateObj.Title,stateObj.Url);   
        if (WatchVideoScript.isMobileApp) {

            // var urlSplit = (window.location.href).split("?");
            // var url = "/WatchVideo" //urlSplit[0];
            // var queeySring = '?VideoId=' + WatchVideoScript.videoId + "&rnd=" + rnd;
            // var urlwithquerystring = url + queeySring;
            // var stateObj = { Title: "newvide" + rnd, Url: urlwithquerystring };

            // RefreshPage(stateObj)


            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo, { VideoId: WatchVideoScript.videoId, loadnextvideo: 'no', rnd: rnd });



            // history.replaceState({}, stateObj.Title, stateObj.Url);
            // history.pushState({}, stateObj.Title, stateObj.Url);
            // history.back();
            // history.forward();
        }
        else {
            location.href = "/WatchVideo?VideoId=" + WatchVideoScript.videoId + "&loadnextvideo=no";
        }



    },
    SubmitVideoWatchedStatusResponse: function () {
        console.log('SubmitVideoWatchedStatusResponse')
    },

    ShowMCQTestPanel: async function (videouniqueid, VideoId, lessionid) {


        if (WatchVideoScript.isMobileApp) {

            var rnd = WatchVideoScript.getRandomNunber();

            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.learningVideoMCQ, { videoid: VideoId, videouniqueid: videouniqueid, pagename: WatchVideoScript.pagename, lessionid: lessionid, rnd: rnd });

        } else {
            location.href = "/LearningVideoMCQ?videoid=" + VideoId + "&videouniqueid=" + videouniqueid;
        }



    },



    backToHomePage: async function () {



        // var voicerecordinglastupdateddate = window.localStorage.getItem('voicerecordinglastupdateddate');

        var shortvideobackpage = window.localStorage.getItem('backpage');

        if (WatchVideoScript.isMobileApp) {
            if (WatchVideoScript.isVideoViewed) {
                    const UserAppReview = await new Promise((resolve, reject) => {
                        CSMainAPIs.Capshine.APIs.ShouldShowAppReview.execute({ UserPid: this.UserPid }, (data) => {
                            if (!data) reject("Api failed")
                            resolve(data)
                        })
                    })

                    if (!UserAppReview.data.isPopupShown) {
                        await RateApp.requestReview().then(async () => {
                            await new Promise((resolve, reject) => {
                                CSMainAPIs.Capshine.APIs.SubmitAppReview.execute({ UserPid: this.UserPid }, (data) => {
                                    if (!data) reject("Api failed")
                                    resolve(data)
                                })
                            });
                        })
                    }
            }
            if (shortvideobackpage == "videos") {
                WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
            }
            else if (shortvideobackpage == "videolessons") {
                WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
            }
            else if (shortvideobackpage == "watchedvideo") {
                WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos,{ atab:'video'});                
            }
            else {
                WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
            }

            //    else  if (WatchVideoScript.sulekhaApp.state.rootPage === MobilePages.unknown) {
            //         WatchVideoScript.sulekhaApp.navigateTo(MobilePages.home, null)
            //     } else {
            //         WatchVideoScript.sulekhaApp.navigateTo(WatchVideoScript.sulekhaApp.state.rootPage, null);
            //     }

        }
        else {

            // alert(shortvideobackpage)

            if (shortvideobackpage) {
                if (shortvideobackpage == "videos") {
                    location.href = "/videos"
                }
                else if (shortvideobackpage == "videolessons") {
                    location.href = "/videolessons"
                }
                else if (shortvideobackpage == "watchedvideo") {
                    location.href = "/watchedvideos?atab=video"                  
                }
                else if (shortvideobackpage == "home") {
                    location.href = "/home"
                }
            }
            else {
                location.href = "/home"
            }

            //    else  if(MyClub.rootpage=="home"){
            //         location.href = "/home"
            //     }
            //     else {
            //         location.href = "/LearningPlan"
            //     }

        }

        // location.href = "/home"


    },

    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    loadPaymentrequestpage: function () {
        //  location.href = "/PaymentUpgradeRequest";

        if (WatchVideoScript.isMobileApp) {
            // var rnd = WatchVideoScript.getRandomNunber();
            // var stateObj = { Title: "PaymentUpgradeRequest" + rnd, Url: '/PaymentUpgradeRequest' };
            // RefreshPage(stateObj)

            WatchVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                pageType: 1
            });


        }
        else {
            // location.href = "/PaymentUpgradeRequest"
            location.href = "/PaymentUpgradeRequest?pageType=" + 1;
        }


        return Math.floor(1000 + Math.random() * 9000);
    },



}




/* harmony default export */ const js_WatchVideoScript = (WatchVideoScript);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/VideoLearningMCQ.vue?vue&type=template&id=300c9e32&ts=true

function VideoLearningMCQvue_type_template_id_300c9e32_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MCQ = (0,vue_cjs.resolveComponent)("MCQ");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
        (0,vue_cjs.createVNode)(_component_MCQ, {
            id: "mcq",
            basicDetails: _ctx.mcqBasicDetails,
            field: _ctx.field,
            userName: _ctx.userInfo.firstName,
            clubUserLevel: _ctx.userInfo.clubUserLevel,
            showThankyou: _ctx.showThankyou,
            startMcq: _ctx.startMcq,
            playNextQuiz: _ctx.playNextQuiz,
            videoId: _ctx.VideoId
        }, null, 8, ["basicDetails", "field", "userName", "clubUserLevel", "showThankyou", "startMcq", "playNextQuiz", "videoId"])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/VideoLearningMCQ.vue?vue&type=template&id=300c9e32&ts=true

;// CONCATENATED MODULE: ./src/CapshineEnums.ts
var McqTypeOption;
(function (McqTypeOption) {
    McqTypeOption[McqTypeOption["Quiz"] = 10] = "Quiz";
    McqTypeOption[McqTypeOption["FillInTheGap"] = 20] = "FillInTheGap";
    McqTypeOption[McqTypeOption["AssessYourEnglish"] = 30] = "AssessYourEnglish";
    McqTypeOption[McqTypeOption["Assesment"] = 40] = "Assesment";
    McqTypeOption[McqTypeOption["VideoLearning"] = 50] = "VideoLearning";
    McqTypeOption[McqTypeOption["JumbledSentence"] = 60] = "JumbledSentence";
    McqTypeOption[McqTypeOption["Meanings"] = 70] = "Meanings";
    McqTypeOption[McqTypeOption["JobInterviewCourse"] = 80] = "JobInterviewCourse";
})(McqTypeOption || (McqTypeOption = {}));
/* harmony default export */ const CapshineEnums = (McqTypeOption);

;// CONCATENATED MODULE: ./src/ts/Mcq.ts

class IntroScreenContent {
    heading = "";
    instructionList = [];
    content = "";
    hasSkipButton = false;
    constructor(init) { Object.assign(this, init); }
}
class McqBasicDetails {
    mcqType = McqTypeOption.Quiz;
    title = "";
    introScreen = new IntroScreenContent();
    thankyouPageButtonText = "";
    userInfo = {};
    showIntroScreen = true;
    showExplanation = false;
    showEarnedPoints = false;
    showQuestionCount = false;
    showSubmitButton = false;
    showBottomExplanation = false;
    showProgressBar;
    constructor(init) { Object.assign(this, init); }
}
class McqField {
    mcqList = [];
    answerList = [];
    pointsEarned = 0;
    constructor(init) { Object.assign(this, init); }
}
class McqQuestion {
    sno = 0;
    groupId = 0;
    questionId = 0;
    questionPrefix = "";
    question = "";
    a = "";
    b = "";
    c = "";
    d = "";
    answer = "";
    points = 100;
    hasMultipleAnswer = false;
    explanation = "";
    hasExplanation = this.explanation.length > 0 ? true : false;
    constructor(init) { Object.assign(this, init); }
}
class McqAnswer {
    questionId = 0;
    correctAnswer = "";
    answer = "";
    pointsEarned = 0;
    isCorrectAnswer = false;
    constructor(init) { Object.assign(this, init); }
}

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/Mcq.vue?vue&type=template&id=23128595&ts=true

const Mcqvue_type_template_id_23128595_ts_true_hoisted_1 = { class: "sk-panel show step-slider" };
const Mcqvue_type_template_id_23128595_ts_true_hoisted_2 = { class: "sk-header" };
const Mcqvue_type_template_id_23128595_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "left-nav quiz-close" }, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "20",
        height: "23",
        id: "back",
        viewBox: "0 0 20 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconbackarrow" })
    ])
], -1);
const Mcqvue_type_template_id_23128595_ts_true_hoisted_4 = { class: "title" };
const Mcqvue_type_template_id_23128595_ts_true_hoisted_5 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", {
    class: "right-nav close",
    id: "mcqRightNav"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        class: "icon icon-chevron",
        id: "btncloseMCQIcon",
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "#000000",
        viewBox: "0 0 256 256"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
    ])
], -1);
const Mcqvue_type_template_id_23128595_ts_true_hoisted_6 = { class: "sk-body no-scroll auto-nav" };
const Mcqvue_type_template_id_23128595_ts_true_hoisted_7 = {
    class: "next-slide",
    ref: "question2"
};
const Mcqvue_type_template_id_23128595_ts_true_hoisted_8 = {
    key: 1,
    class: "next-slide",
    ref: "thankyou"
};
const Mcqvue_type_template_id_23128595_ts_true_hoisted_9 = {
    key: 2,
    class: "next-slide",
    ref: "thankyou"
};
const Mcqvue_type_template_id_23128595_ts_true_hoisted_10 = {
    key: 3,
    class: "next-slide",
    ref: "thankyou"
};
function Mcqvue_type_template_id_23128595_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_McqIntroScreen = (0,vue_cjs.resolveComponent)("McqIntroScreen");
    const _component_JumbledArea = (0,vue_cjs.resolveComponent)("JumbledArea");
    const _component_McqQuestionScreen = (0,vue_cjs.resolveComponent)("McqQuestionScreen");
    const _component_McqExplanationScreen = (0,vue_cjs.resolveComponent)("McqExplanationScreen");
    const _component_McqThankyouScreen = (0,vue_cjs.resolveComponent)("McqThankyouScreen");
    const _component_VideoLearningMcqThankYouScreen = (0,vue_cjs.resolveComponent)("VideoLearningMcqThankYouScreen");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", {
            class: (0,vue_cjs.normalizeClass)({ 'sk-inner activity': true, 'tap-activity': _ctx.basicDetails.mcqType === 60 && _ctx.pageName !== 'thankYou' && _ctx.pageName !== 'intro' })
        }, [
            (0,vue_cjs.createElementVNode)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_2, [
                Mcqvue_type_template_id_23128595_ts_true_hoisted_3,
                (0,vue_cjs.createElementVNode)("span", Mcqvue_type_template_id_23128595_ts_true_hoisted_4, (0,vue_cjs.toDisplayString)(_ctx.basicDetails.title), 1),
                Mcqvue_type_template_id_23128595_ts_true_hoisted_5
            ]),
            (0,vue_cjs.createElementVNode)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_6, [
                (_ctx.basicDetails.showIntroScreen)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
                        key: 0,
                        class: (0,vue_cjs.normalizeClass)(_ctx.introscreenClass),
                        ref: "introscreen"
                    }, [
                        (0,vue_cjs.createVNode)(_component_McqIntroScreen, {
                            content: _ctx.basicDetails.introScreen,
                            skipMcq: _ctx.skipMcq,
                            startMcq: _ctx.startMcq
                        }, null, 8, ["content", "skipMcq", "startMcq"])
                    ], 2))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("div", {
                    class: (0,vue_cjs.normalizeClass)(_ctx.question1Class),
                    ref: "question1"
                }, [
                    (_ctx.field && _ctx.question1.question && _ctx.basicDetails.mcqType === 60)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_JumbledArea, {
                            key: 0,
                            basicDetails: _ctx.basicDetails,
                            question: _ctx.question1,
                            pointsEarned: _ctx.q1pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            totalPoints: _ctx.field.pointsEarned,
                            validateAnswer: _ctx.validateAnswer,
                            getCurrentQuestion: _ctx.getCurrentQuestion,
                            submitClick: _ctx.submitClick,
                            showError: _ctx.showError,
                            correctAnswer: _ctx.q1correctAnswer,
                            onExplanationNext: _ctx.submitClick,
                            activeQuestion: _ctx.question1.sno,
                            JumbledWordsCount: _ctx.question1.answer.split(' ').length,
                            activeExplanationTitle: _ctx.activeExplanationTitle,
                            activeExplanationText: _ctx.activeExplanationText
                        }, null, 8, ["basicDetails", "question", "pointsEarned", "totalQuestions", "totalPoints", "validateAnswer", "getCurrentQuestion", "submitClick", "showError", "correctAnswer", "onExplanationNext", "activeQuestion", "JumbledWordsCount", "activeExplanationTitle", "activeExplanationText"]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.field && _ctx.question1.question && !_ctx.visitedExplanations.has(_ctx.question1.sno) && _ctx.basicDetails.mcqType !== 60)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_McqQuestionScreen, {
                            key: 1,
                            basicDetails: _ctx.basicDetails,
                            question: _ctx.question1,
                            getCurrentQuestion: _ctx.getCurrentQuestion,
                            updateAnswerAndPoints: _ctx.updateAnswerAndPoints,
                            moveToNextQuestion: _ctx.moveToNextQuestion,
                            updateCurrentAnswer: _ctx.updateCurrentAnswer,
                            showBottomExplanationLayout: _ctx.showBottomExplanationLayout,
                            showSubmitButtonLayout: _ctx.showSubmitButtonLayout,
                            totalPoints: _ctx.field.pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            submitClick: _ctx.submitClick,
                            showError: _ctx.showError,
                            correctAnswer: _ctx.q1correctAnswer,
                            pointsEarned: _ctx.q1pointsEarned
                        }, null, 8, ["basicDetails", "question", "getCurrentQuestion", "updateAnswerAndPoints", "moveToNextQuestion", "updateCurrentAnswer", "showBottomExplanationLayout", "showSubmitButtonLayout", "totalPoints", "totalQuestions", "submitClick", "showError", "correctAnswer", "pointsEarned"]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.field && _ctx.question1.question && _ctx.visitedExplanations.has(_ctx.question1.sno) && _ctx.basicDetails.mcqType === 10)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_McqExplanationScreen, {
                            key: 2,
                            points: _ctx.question1.points,
                            totalPoints: _ctx.field.pointsEarned,
                            onExplanationNext: _ctx.submitClick,
                            pointsEarned: _ctx.field.pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            activeQuestion: _ctx.question1.sno,
                            activeExplanationTitle: _ctx.activeExplanationTitle,
                            activeExplanationText: _ctx.activeExplanationText
                        }, null, 8, ["points", "totalPoints", "onExplanationNext", "pointsEarned", "totalQuestions", "activeQuestion", "activeExplanationTitle", "activeExplanationText"]))
                        : (0,vue_cjs.createCommentVNode)("", true)
                ], 2),
                (0,vue_cjs.createElementVNode)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_7, [
                    (_ctx.field && _ctx.question2.question && _ctx.basicDetails.mcqType === 60)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_JumbledArea, {
                            key: 0,
                            basicDetails: _ctx.basicDetails,
                            question: _ctx.question2,
                            pointsEarned: _ctx.q2pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            totalPoints: _ctx.field.pointsEarned,
                            validateAnswer: _ctx.validateAnswer,
                            submitClick: _ctx.submitClick,
                            showError: _ctx.showError,
                            correctAnswer: _ctx.q2correctAnswer,
                            onExplanationNext: _ctx.submitClick,
                            activeQuestion: _ctx.question2.sno,
                            JumbledWordsCount: _ctx.question2.answer.split(' ').length,
                            activeExplanationTitle: _ctx.activeExplanationTitle,
                            activeExplanationText: _ctx.activeExplanationText
                        }, null, 8, ["basicDetails", "question", "pointsEarned", "totalQuestions", "totalPoints", "validateAnswer", "submitClick", "showError", "correctAnswer", "onExplanationNext", "activeQuestion", "JumbledWordsCount", "activeExplanationTitle", "activeExplanationText"]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.field && _ctx.question2.question && !_ctx.visitedExplanations.has(_ctx.question2.sno) && _ctx.basicDetails.mcqType !== 60)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_McqQuestionScreen, {
                            key: 1,
                            basicDetails: _ctx.basicDetails,
                            question: _ctx.question2,
                            showBottomExplanationLayout: _ctx.showBottomExplanationLayout,
                            showSubmitButtonLayout: _ctx.showSubmitButtonLayout,
                            getCurrentQuestion: _ctx.getCurrentQuestion,
                            updateAnswerAndPoints: _ctx.updateAnswerAndPoints,
                            moveToNextQuestion: _ctx.moveToNextQuestion,
                            updateCurrentAnswer: _ctx.updateCurrentAnswer,
                            totalPoints: _ctx.field.pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            submitClick: _ctx.submitClick,
                            showError: _ctx.showError,
                            correctAnswer: _ctx.q2correctAnswer,
                            pointsEarned: _ctx.q2pointsEarned
                        }, null, 8, ["basicDetails", "question", "showBottomExplanationLayout", "showSubmitButtonLayout", "getCurrentQuestion", "updateAnswerAndPoints", "moveToNextQuestion", "updateCurrentAnswer", "totalPoints", "totalQuestions", "submitClick", "showError", "correctAnswer", "pointsEarned"]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.visitedExplanations.has(_ctx.question2.sno) && _ctx.basicDetails.mcqType === 10)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_McqExplanationScreen, {
                            key: 2,
                            points: _ctx.question2.points,
                            totalPoints: _ctx.field.pointsEarned,
                            onExplanationNext: _ctx.submitClick,
                            pointsEarned: _ctx.field.pointsEarned,
                            totalQuestions: _ctx.field.mcqList.length,
                            activeQuestion: _ctx.question2.sno,
                            activeExplanationTitle: _ctx.activeExplanationTitle,
                            activeExplanationText: _ctx.activeExplanationText
                        }, null, 8, ["points", "totalPoints", "onExplanationNext", "pointsEarned", "totalQuestions", "activeQuestion", "activeExplanationTitle", "activeExplanationText"]))
                        : (0,vue_cjs.createCommentVNode)("", true)
                ], 512),
                (_ctx.basicDetails.mcqType != 50 && _ctx.basicDetails.mcqType != 80)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_8, [
                        (0,vue_cjs.createVNode)(_component_McqThankyouScreen, {
                            mcqType: _ctx.basicDetails.mcqType,
                            userName: _ctx.userName,
                            mcqAnswer: _ctx.field ? _ctx.field.answerList : [],
                            pointsEarned: _ctx.field ? _ctx.field.pointsEarned : 0,
                            playNextQuiz: _ctx.playNextQuiz,
                            thankYouScreenGoBack: _ctx.thankYouScreenGoBack
                        }, null, 8, ["mcqType", "userName", "mcqAnswer", "pointsEarned", "playNextQuiz", "thankYouScreenGoBack"])
                    ], 512))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (_ctx.basicDetails.mcqType == 50)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_9, [
                        (_ctx.field)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_VideoLearningMcqThankYouScreen, {
                                key: 0,
                                pagename: _ctx.basicDetails.pagename,
                                lessionid: _ctx.basicDetails.lessionid,
                                userName: _ctx.userName,
                                mcqAnswer: _ctx.field ? _ctx.field.answerList : [],
                                pointsEarned: _ctx.field ? _ctx.field.pointsEarned : 0
                            }, null, 8, ["pagename", "lessionid", "userName", "mcqAnswer", "pointsEarned"]))
                            : (0,vue_cjs.createCommentVNode)("", true)
                    ], 512))
                    : (0,vue_cjs.createCommentVNode)("", true),
                (_ctx.basicDetails.mcqType == 80)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Mcqvue_type_template_id_23128595_ts_true_hoisted_10, null, 512))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ])
        ], 2)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/Mcq.vue?vue&type=template&id=23128595&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqIntroScreen.vue?vue&type=template&id=01a3646d&ts=true

const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_1 = { class: "slide-content" };
const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_2 = ["innerHTML"];
const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_3 = { class: "app-select-level" };
const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_4 = ["id"];
const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_5 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
    width: "18",
    height: "13",
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconcheck" })
], -1);
const McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_6 = ["innerHTML"];
function McqIntroScreenvue_type_template_id_01a3646d_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", {
            innerHTML: _ctx.content.heading
        }, null, 8, McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_2),
        (0,vue_cjs.createElementVNode)("ul", McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_3, [
            ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.content.instructionList, (option, index) => {
                return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                    key: 'opt' + index,
                    id: index
                }, [
                    McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_5,
                    (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(option), 1)
                ], 8, McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_4));
            }), 128))
        ]),
        (0,vue_cjs.createElementVNode)("div", {
            innerHTML: _ctx.content.content
        }, null, 8, McqIntroScreenvue_type_template_id_01a3646d_ts_true_hoisted_6),
        (0,vue_cjs.createElementVNode)("button", {
            type: "button",
            class: "button primary medium block",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.startMcq()))
        }, "Start Quiz"),
        (0,vue_cjs.createElementVNode)("button", {
            type: "button",
            class: (0,vue_cjs.normalizeClass)(["button link-no-border block skip no-shadow", { 'hide': !_ctx.content.hasSkipButton }]),
            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.fnSkipMcq()))
        }, "Skip", 2)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/McqIntroScreen.vue?vue&type=template&id=01a3646d&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqIntroScreen.vue?vue&type=script&lang=ts



/* harmony default export */ const McqIntroScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'McqIntroScreen',
    components: {},
    props: {
        content: { type: IntroScreenContent, required: true },
        skipMcq: { type: Function, required: true },
        startMcq: { type: Function, required: true }
    },
    mounted() {
    },
    methods: {
        fnSkipMcq: function () {
            GATrack.pushValues('assess_level_skip', 'skip_level_beginner', 'click_assess_level_skip');
            this.skipMcq();
        },
        fnStartMcq: function () {
            this.startMcq();
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/McqIntroScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/McqIntroScreen.vue




;
const McqIntroScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(McqIntroScreenvue_type_script_lang_ts, [['render',McqIntroScreenvue_type_template_id_01a3646d_ts_true_render]])

/* harmony default export */ const McqIntroScreen = (McqIntroScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqQuestionScreen.vue?vue&type=template&id=318ad32a&ts=true

const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_1 = { class: "report-wrapper" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_2 = {
    key: 0,
    class: "report-inner"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_3 = {
    key: 0,
    class: "quiz-questions"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_4 = {
    key: 0,
    class: "questions-count"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_5 = { class: "achieve-score big" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_6 = { class: "outof-score" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_7 = {
    key: 1,
    class: "earn-points"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_8 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, "Total Points", -1);
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_9 = {
    key: 1,
    class: "select-option"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_10 = { class: "question-word" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_11 = ["innerHTML"];
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_12 = ["innerHTML"];
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_13 = { class: "select-option" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_14 = ["onClick", "disabled"];
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_15 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
    class: "right hide",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcheckanswer" })
], -1);
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_16 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
    class: "wrong hide",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    viewBox: "0 0 256 256"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#iconcross" })
], -1);
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_17 = {
    key: 2,
    class: "quiz-bottom"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_18 = ["disabled"];
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_19 = {
    key: 3,
    class: "section-divider"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_20 = {
    key: 4,
    class: "quiz-bottom mt-3"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_21 = { class: "explanation-content" };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_22 = {
    key: 0,
    class: "title-medium"
};
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_23 = { key: 1 };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_24 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("strong", null, "Definition: ", -1);
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_25 = { key: 2 };
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_26 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("strong", null, "Explanation: ", -1);
const McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_27 = ["disabled"];
function McqQuestionScreenvue_type_template_id_318ad32a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProgressBar = (0,vue_cjs.resolveComponent)("ProgressBar");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", {
        class: (0,vue_cjs.normalizeClass)({ 'slide-content': true, 'assessment': _ctx.basicDetails.mcqType === 70, 'select-option': _ctx.basicDetails.mcqType === 70 })
    }, [
        (0,vue_cjs.createElementVNode)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_1, [
            (_ctx.question.question)
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_2, [
                    (_ctx.basicDetails.showQuestionCount || _ctx.basicDetails.showEarnedPoints)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_3, [
                            (_ctx.basicDetails.showQuestionCount)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_4, [
                                    (0,vue_cjs.createElementVNode)("span", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_5, (0,vue_cjs.toDisplayString)(_ctx.question.sno), 1),
                                    (0,vue_cjs.createElementVNode)("span", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_6, "/ " + (0,vue_cjs.toDisplayString)(_ctx.totalQuestions), 1)
                                ]))
                                : (0,vue_cjs.createCommentVNode)("", true),
                            (_ctx.basicDetails.showProgressBar)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_7, [
                                    McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_8,
                                    (0,vue_cjs.createVNode)(_component_ProgressBar, {
                                        totalValue: _ctx.totalQuestions * _ctx.question.points,
                                        value: _ctx.totalPoints
                                    }, null, 8, ["totalValue", "value"])
                                ]))
                                : (0,vue_cjs.createCommentVNode)("", true)
                        ]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.basicDetails.mcqType === 70)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_9, [
                            (0,vue_cjs.createElementVNode)("h2", null, (0,vue_cjs.toDisplayString)(_ctx.question.question) + " means:", 1)
                        ]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (0,vue_cjs.createElementVNode)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_10, [
                        (_ctx.basicDetails.mcqType !== 70)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("h2", {
                                key: 0,
                                innerHTML: _ctx.question.questionPrefix
                            }, null, 8, McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_11))
                            : (0,vue_cjs.createCommentVNode)("", true),
                        (_ctx.basicDetails.mcqType !== 70)
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", {
                                key: 1,
                                innerHTML: _ctx.question.question
                            }, null, 8, McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_12))
                            : (0,vue_cjs.createCommentVNode)("", true),
                        (0,vue_cjs.createElementVNode)("ul", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_13, [
                            ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.options, (option, index) => {
                                return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", { key: index }, [
                                    (_ctx.showquestion(_ctx.question[option.toLowerCase()]))
                                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                                            key: option,
                                            onClick: ($event) => (_ctx.updateAnswer(option)),
                                            class: (0,vue_cjs.normalizeClass)({ 'alert': (_ctx.isSelectedAnswer(option) && _ctx.showAlert), 'success': (_ctx.isSelectedAnswer(option) && _ctx.isCorrectOption(option) && !_ctx.showAlert), 'danger': (_ctx.isSelectedAnswer(option) && !_ctx.isCorrectOption(option) && !_ctx.showAlert) }),
                                            disabled: _ctx.disableClick
                                        }, [
                                            McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_15,
                                            McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_16,
                                            (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)(_ctx.question[option.toLowerCase()]), 1)
                                        ], 10, McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_14))
                                        : (0,vue_cjs.createCommentVNode)("", true)
                                ]));
                            }), 128))
                        ])
                    ]),
                    (_ctx.basicDetails.showSubmitButton && _ctx.showSubmitButtonLayout)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_17, [
                            (0,vue_cjs.createElementVNode)("p", {
                                class: (0,vue_cjs.normalizeClass)(["correct-answer", { 'hide': _ctx.isCorrectAnswer() }])
                            }, "The right answer is '" + (0,vue_cjs.toDisplayString)(_ctx.getCorrectAnswer()) + "'.", 3),
                            (0,vue_cjs.createElementVNode)("p", {
                                class: (0,vue_cjs.normalizeClass)(["earning-point", { 'hide': !_ctx.isCorrectAnswer() }])
                            }, "Well Done! You have earned " + (0,vue_cjs.toDisplayString)(_ctx.pointsEarned) + " points.", 3),
                            (0,vue_cjs.createElementVNode)("p", {
                                class: (0,vue_cjs.normalizeClass)(["error-text", { 'show': _ctx.showError }])
                            }, "Please select an option.", 2),
                            (0,vue_cjs.createElementVNode)("button", {
                                type: "button",
                                class: "button primary medium block",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.submitClick())),
                                disabled: _ctx.isButtonDisabled
                            }, "Continue", 8, McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_18)
                        ]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.basicDetails.showBottomExplanation && _ctx.showBottomExplanationLayout)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_19))
                        : (0,vue_cjs.createCommentVNode)("", true),
                    (_ctx.basicDetails.showBottomExplanation && _ctx.showBottomExplanationLayout)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_20, [
                            (0,vue_cjs.createElementVNode)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_21, [
                                (!_ctx.isCorrectAnswer())
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_22, "Answer: " + (0,vue_cjs.toDisplayString)(_ctx.getCorrectAnswer()), 1))
                                    : (0,vue_cjs.createCommentVNode)("", true),
                                (_ctx.question.explanation && _ctx.basicDetails.mcqType != 80)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_23, [
                                        McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_24,
                                        (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(_ctx.question.explanation) + ".", 1)
                                    ]))
                                    : (0,vue_cjs.createCommentVNode)("", true),
                                (_ctx.question.explanation && _ctx.basicDetails.mcqType == 80)
                                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("p", McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_25, [
                                        McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_26,
                                        (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(_ctx.question.explanation), 1)
                                    ]))
                                    : (0,vue_cjs.createCommentVNode)("", true),
                                (0,vue_cjs.createElementVNode)("button", {
                                    type: "button",
                                    class: "button primary block",
                                    id: "next",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.submitClick())),
                                    disabled: _ctx.isButtonDisabled
                                }, "Next", 8, McqQuestionScreenvue_type_template_id_318ad32a_ts_true_hoisted_27)
                            ])
                        ]))
                        : (0,vue_cjs.createCommentVNode)("", true)
                ]))
                : (0,vue_cjs.createCommentVNode)("", true)
        ])
    ], 2));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/McqQuestionScreen.vue?vue&type=template&id=318ad32a&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ProgressBar.vue?vue&type=template&id=b70e78a6&ts=true

const ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_1 = { class: "progress-score" };
const ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_2 = ["width", "height"];
const ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("circle", {
    class: "progress-circle-back",
    cx: "30",
    cy: "30",
    r: "25"
}, null, -1);
const ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_4 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", {
    class: "progress-score-text odometer",
    id: "progress-score-text-id"
}, "0", -1);
function ProgressBarvue_type_template_id_b70e78a6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_1, [
        ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
            class: "progress-circle",
            width: _ctx.width + 'px',
            height: _ctx.height + 'px',
            xmlns: "http://www.w3.org/2000/svg"
        }, [
            ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_3,
            (0,vue_cjs.createElementVNode)("circle", {
                class: "progress-circle-prog",
                id: 'progress-circle-prog-',
                style: (0,vue_cjs.normalizeStyle)({ strokeDasharray: _ctx.strokeDasharray }),
                cx: "30",
                cy: "30",
                r: "25"
            }, null, 4)
        ], 8, ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_2)),
        ProgressBarvue_type_template_id_b70e78a6_ts_true_hoisted_4
    ]));
}

;// CONCATENATED MODULE: ./src/Components/ProgressBar.vue?vue&type=template&id=b70e78a6&ts=true

// EXTERNAL MODULE: ./src/Components/Odometer.js
var Odometer = __webpack_require__(682);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/ProgressBar.vue?vue&type=script&lang=ts


/* harmony default export */ const ProgressBarvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'ProgressBar',
    props: {
        totalValue: { type: Number, default: 0 },
        value: { type: Number, default: 0 },
        width: { type: Number, default: 60 },
        height: { type: Number, default: 60 },
    },
    data() {
        return {
            od: [],
            strokeDasharray: 0,
            progressScore: 0
        };
    },
    mounted() {
        let elements = document.getElementsByClassName('progress-score-text odometer');
        for (let i = 0; i < elements.length; i++) {
            let od = new Odometer({
                el: elements[i],
                value: this.progress,
                format: '',
                theme: 'minimal'
            });
            this.od.push(od);
        }
        this.updateProgress();
    },
    updated() {
        this.updateProgress();
    },
    methods: {
        updateProgress() {
            let strokeVal = (1.56 * 100) / this.totalValue;
            this.strokeDasharray = this.value * (strokeVal) + ' 999';
            this.progressScore = this.value;
            for (let od of this.od) {
                od.update(this.progressScore);
            }
        }
    },
}));

;// CONCATENATED MODULE: ./src/Components/ProgressBar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/ProgressBar.vue




;
const ProgressBar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressBarvue_type_script_lang_ts, [['render',ProgressBarvue_type_template_id_b70e78a6_ts_true_render]])

/* harmony default export */ const ProgressBar = (ProgressBar_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqQuestionScreen.vue?vue&type=script&lang=ts



/* harmony default export */ const McqQuestionScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'McqQuestionScreen',
    components: {
        ProgressBar: ProgressBar,
    },
    props: {
        basicDetails: { type: McqBasicDetails, required: true },
        question: { required: true },
        pointsEarned: { type: Number, default: 0 },
        totalQuestions: { type: Number, default: 0 },
        totalPoints: { type: Number, default: 0 },
        submitClick: { type: Function, required: true },
        updateCurrentAnswer: { type: Function, required: true },
        getCurrentQuestion: { type: Function, required: true },
        moveToNextQuestion: { type: Function, required: true },
        updateAnswerAndPoints: { type: Function, required: true },
        showError: { type: Boolean, default: false },
        showBottomExplanationLayout: { type: Boolean, default: false },
        showSubmitButtonLayout: { type: Boolean, default: false },
        correctAnswer: { type: String, default: "" },
    },
    data() {
        return {
            selectedAnswer: null,
            options: ["A", "B", "C", "D"],
            disableClick: false,
            isButtonDisabled: true,
            showAlert: true,
        };
    },
    mounted() {
        this.resetOption();
    },
    watch: {
        'question': {
            handler: function () {
                this.resetOption();
            }
        },
    },
    methods: {
        getCorrectAnswer: function () {
            let answers = "";
            this.correctAnswer.toLowerCase().split(",").map((answer) => {
                if (answers.length > 0)
                    return;
                answers += this.question[answer.toLowerCase()];
            });
            return answers.trimEnd();
        },
        isCorrectAnswer: function () {
            return this.correctAnswer.toLowerCase().split(",").indexOf(this.selectedAnswer.toLowerCase()) > -1;
        },
        isSelectedAnswer: function (option) {
            return this.selectedAnswer && this.selectedAnswer.toLowerCase() === option.toLowerCase();
        },
        isCorrectOption: function (option) {
            return this.correctAnswer && this.correctAnswer.toLowerCase().split(",").indexOf(option.toLowerCase()) > -1;
        },
        resetOption: function () {
            this.selectedAnswer = null;
            this.isButtonDisabled = true;
            this.selectedAnswer = null;
            this.disableClick = false;
            this.showAlert = true;
        },
        updateAnswer: async function (answer) {
            if (this.disableClick)
                return;
            this.selectedAnswer = answer;
            this.disableClick = true;
            const currentQuestion = this.getCurrentQuestion();
            await this.updateCurrentAnswer(answer, currentQuestion);
            this.showAlert = false;
            await this.updateAnswerAndPoints(answer, currentQuestion);
            await this.moveToNextQuestion(answer, currentQuestion);
            this.isButtonDisabled = false;
        },
        showquestion(options) {
            if (options) {
                return true;
            }
            else {
                return false;
            }
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/McqQuestionScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/McqQuestionScreen.vue




;
const McqQuestionScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(McqQuestionScreenvue_type_script_lang_ts, [['render',McqQuestionScreenvue_type_template_id_318ad32a_ts_true_render]])

/* harmony default export */ const McqQuestionScreen = (McqQuestionScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqThankyouScreen.vue?vue&type=template&id=76a9f9f6&ts=true

const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_1 = {
    key: 0,
    class: "slide-content"
};
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_2 = { class: "app-gift align-center" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("img", { src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/app-final-bg.png" }, null, -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_4 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
    width: "52",
    height: "54",
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIcongift" })
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_5 = { class: "app-level" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_6 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "title-medium" }, "Rewards and score", -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_7 = { class: "d-flex assessment-score" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_8 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Points Earned: ");
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_9 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "34.807",
        height: "20.277",
        viewBox: "0 0 34.807 20.277"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#captop" })
    ])
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_10 = { class: "d-flex assessment-score" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_11 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Score: ");
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_12 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "31",
        height: "25",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconlinechart" })
    ])
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_13 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "section-divider" }, null, -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_14 = { class: "d-flex" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_15 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Correct answer(s) : ");
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_16 = { class: "correct-answer" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_17 = {
    key: 1,
    class: "slide-content"
};
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_18 = { class: "app-gift align-center" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_19 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("img", { src: "assets/images/app-final-bg.png" }, null, -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_20 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
    width: "52",
    height: "54",
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIcongift" })
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_21 = { class: "app-level" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_22 = { class: "d-flex" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_23 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Your level: ");
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_24 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "31",
        height: "31",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconlinechart" })
    ])
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_25 = { class: "d-flex" };
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_26 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Score: ");
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_27 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconroundcheck" })
    ])
], -1);
const McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_28 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "mascot-message align-center" }, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("p", null, " Let's begin your English journey together! You're practising with 17,568 other learners now.")
], -1);
function McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, [
        (_ctx.mcqType == 10 || _ctx.mcqType == 20 || _ctx.mcqType === 60 || _ctx.mcqType === 70 || _ctx.mcqType === 80)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_1, [
                (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_2, [
                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_3,
                    (0,vue_cjs.createElementVNode)("h2", null, (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length <= 3 ? 'You can do better' : _ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length <= 7 ? 'Good try' : 'Congratulations') + ", " + (0,vue_cjs.toDisplayString)(_ctx.userName) + "!", 1),
                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_4
                ]),
                (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_5, [
                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_6,
                    (0,vue_cjs.createElementVNode)("ul", null, [
                        (0,vue_cjs.createElementVNode)("li", null, [
                            (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_7, [
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_8,
                                    (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)(_ctx.pointsEarned), 1)
                                ]),
                                McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_9
                            ])
                        ]),
                        (0,vue_cjs.createElementVNode)("li", null, [
                            (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_10, [
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_11,
                                    (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)((_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length / _ctx.mcqAnswer.length) * 100) + "%", 1)
                                ]),
                                McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_12
                            ]),
                            McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_13,
                            (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_14, [
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_15,
                                    (0,vue_cjs.createElementVNode)("b", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_16, (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length) + " / " + (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.length), 1)
                                ])
                            ])
                        ])
                    ])
                ]),
                (0,vue_cjs.createElementVNode)("button", {
                    type: "button",
                    class: "button primary medium block test-complete",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.playNextQuiz()))
                }, "Play Next Quiz"),
                (0,vue_cjs.createElementVNode)("button", {
                    class: "button link-no-border block skip no-shadow",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.thankYouScreenGoBack()))
                }, "Back to Activities")
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        (_ctx.mcqType == 30)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_17, [
                (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_18, [
                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_19,
                    (0,vue_cjs.createElementVNode)("h2", null, "Congratulations " + (0,vue_cjs.toDisplayString)(_ctx.userName) + "!", 1),
                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_20
                ]),
                (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_21, [
                    (0,vue_cjs.createElementVNode)("ul", null, [
                        (0,vue_cjs.createElementVNode)("li", null, [
                            (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_22, [
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_23,
                                    (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)(_ctx.getClubUserLevel), 1)
                                ]),
                                McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_24
                            ])
                        ]),
                        (0,vue_cjs.createElementVNode)("li", null, [
                            (0,vue_cjs.createElementVNode)("div", McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_25, [
                                (0,vue_cjs.createElementVNode)("span", null, [
                                    McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_26,
                                    (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length), 1)
                                ]),
                                McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_27
                            ])
                        ])
                    ])
                ]),
                McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_hoisted_28,
                (0,vue_cjs.createElementVNode)("button", {
                    type: "button",
                    class: "button primary medium block",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.playNextQuiz()))
                }, "Continue")
            ]))
            : (0,vue_cjs.createCommentVNode)("", true)
    ], 64));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/McqThankyouScreen.vue?vue&type=template&id=76a9f9f6&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqThankyouScreen.vue?vue&type=script&lang=ts

/* harmony default export */ const McqThankyouScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'McqThankyouScreen',
    components: {},
    props: {
        mcqType: { type: Number, required: true },
        userName: { type: String, required: true },
        mcqAnswer: { type: Array, required: true },
        pointsEarned: { type: Number, required: true },
        playNextQuiz: { type: Function, required: true },
        thankYouScreenGoBack: { type: Function, required: true }
    },
    computed: {
        getClubUserLevel: function () {
            var correctAnswerCount = this.mcqAnswer.filter(item => item.isCorrectAnswer == true).length;
            return correctAnswerCount <= 9 ? "Beginner" : correctAnswerCount <= 15 ? "Intermediate" : "Advanced";
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/McqThankyouScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/McqThankyouScreen.vue




;
const McqThankyouScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(McqThankyouScreenvue_type_script_lang_ts, [['render',McqThankyouScreenvue_type_template_id_76a9f9f6_ts_true_render]])

/* harmony default export */ const McqThankyouScreen = (McqThankyouScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqExplanationScreen.vue?vue&type=template&id=7d6a14cb&ts=true

const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_1 = { class: "slide-content" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_2 = { class: "quiz-questions" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_3 = { class: "questions-count" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_4 = { class: "achieve-score big" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_5 = { class: "outof-score" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_6 = { class: "earn-points" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_7 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, "Total Points", -1);
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_8 = { class: "explanation-content" };
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_9 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, "Explanation", -1);
const McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_10 = { class: "try-again" };
function McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProgressBar = (0,vue_cjs.resolveComponent)("ProgressBar");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_2, [
            (0,vue_cjs.createElementVNode)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_3, [
                (0,vue_cjs.createElementVNode)("span", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_4, (0,vue_cjs.toDisplayString)(_ctx.activeQuestion), 1),
                (0,vue_cjs.createElementVNode)("span", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_5, "/ " + (0,vue_cjs.toDisplayString)(_ctx.totalQuestions), 1)
            ]),
            (0,vue_cjs.createElementVNode)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_6, [
                McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_7,
                (0,vue_cjs.createVNode)(_component_ProgressBar, {
                    totalValue: _ctx.totalQuestions * _ctx.points,
                    value: _ctx.totalPoints
                }, null, 8, ["totalValue", "value"])
            ])
        ]),
        (0,vue_cjs.createElementVNode)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_8, [
            (0,vue_cjs.createElementVNode)("h2", null, (0,vue_cjs.toDisplayString)(_ctx.activeExplanationTitle), 1),
            McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_9,
            (0,vue_cjs.createElementVNode)("p", null, (0,vue_cjs.toDisplayString)(_ctx.activeExplanationText), 1),
            (0,vue_cjs.createElementVNode)("div", McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_hoisted_10, [
                (0,vue_cjs.createElementVNode)("button", {
                    type: "button",
                    class: "button primary medium",
                    id: "next",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.onExplanationNext && _ctx.onExplanationNext(...args)))
                }, "Next")
            ])
        ])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/McqExplanationScreen.vue?vue&type=template&id=7d6a14cb&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/McqExplanationScreen.vue?vue&type=script&lang=ts


/* harmony default export */ const McqExplanationScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'McqExplanationScreen',
    components: {
        ProgressBar: ProgressBar,
    },
    props: {
        onExplanationNext: { type: Function, required: true },
        points: { type: Number, default: 0, required: true },
        totalPoints: { type: Number, default: 0, required: true },
        pointsEarned: { type: Number, default: 0, required: true },
        totalQuestions: { type: Number, default: 0, required: true },
        activeQuestion: { type: Number, default: 0, required: true },
        activeExplanationTitle: { type: String, default: null, required: true },
        activeExplanationText: { type: String, default: null, required: true },
    },
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/McqExplanationScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/McqExplanationScreen.vue




;
const McqExplanationScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(McqExplanationScreenvue_type_script_lang_ts, [['render',McqExplanationScreenvue_type_template_id_7d6a14cb_ts_true_render]])

/* harmony default export */ const McqExplanationScreen = (McqExplanationScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/VideoLearningMcqThankYouScreen.vue?vue&type=template&id=0266ee2c&ts=true

const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_1 = { class: "slide-content" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_2 = { class: "app-gift align-center" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("img", { src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/app-final-bg.png" }, null, -1);
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_4 = { class: "congrats align-center" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_5 = { class: "app-level" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_6 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "title-medium" }, "Performance", -1);
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_7 = { class: "d-flex assessment-score" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_8 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Points Earned: ");
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_9 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("a", { href: "#" }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "34.807",
            height: "20.277",
            viewBox: "0 0 34.807 20.277"
        }, [
            /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#captop" })
        ])
    ])
], -1);
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_10 = { class: "d-flex assessment-score" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_11 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Achievement: ");
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_12 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "31",
        height: "25",
        viewBox: "0 0 31 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconlinechart" })
    ])
], -1);
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_13 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "section-divider" }, null, -1);
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_14 = { class: "d-flex" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_15 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Correct Answer(s): ");
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_16 = { class: "correct-answer" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_17 = { class: "thank-you-bottom align-center" };
const VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_18 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, "OR", -1);
function VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_2, [
            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_3,
            (0,vue_cjs.createElementVNode)("h2", null, "Congratulations " + (0,vue_cjs.toDisplayString)(_ctx.userName) + "!", 1),
            (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_4, [
                (0,vue_cjs.createElementVNode)("h2", null, "Lesson " + (0,vue_cjs.toDisplayString)(_ctx.lessionid) + ": Completed!", 1)
            ])
        ]),
        (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_5, [
            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_6,
            (0,vue_cjs.createElementVNode)("ul", null, [
                (0,vue_cjs.createElementVNode)("li", null, [
                    (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_7, [
                        (0,vue_cjs.createElementVNode)("span", null, [
                            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_8,
                            (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)(_ctx.pointsEarned), 1)
                        ]),
                        VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_9
                    ])
                ]),
                (0,vue_cjs.createElementVNode)("li", null, [
                    (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_10, [
                        (0,vue_cjs.createElementVNode)("span", null, [
                            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_11,
                            (0,vue_cjs.createElementVNode)("b", null, (0,vue_cjs.toDisplayString)((_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length / _ctx.mcqAnswer.length) * 100) + "%", 1)
                        ]),
                        VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_12
                    ]),
                    VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_13,
                    (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_14, [
                        (0,vue_cjs.createElementVNode)("span", null, [
                            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_15,
                            (0,vue_cjs.createElementVNode)("b", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_16, (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.filter(item => item.isCorrectAnswer == true).length) + " / " + (0,vue_cjs.toDisplayString)(_ctx.mcqAnswer.length), 1)
                        ])
                    ])
                ])
            ])
        ]),
        (0,vue_cjs.createElementVNode)("button", {
            type: "button",
            class: "button primary medium block test-complete",
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.nextlesson()))
        }, "Next Lesson"),
        (0,vue_cjs.createElementVNode)("div", VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_17, [
            VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_hoisted_18,
            (0,vue_cjs.createElementVNode)("p", null, (0,vue_cjs.toDisplayString)(_ctx.userName) + ", you have two more activities remaining in your today's schedule ", 1),
            (0,vue_cjs.createElementVNode)("button", {
                class: "button link-no-border block skip no-shadow",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.nextactivity()))
            }, "Next Activity")
        ])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/VideoLearningMcqThankYouScreen.vue?vue&type=template&id=0266ee2c&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/VideoLearningMcqThankYouScreen.vue?vue&type=script&lang=ts


//import { createApp, h } from 'vue'

var VideoLearningMcqThankYouScreenvue_type_script_lang_ts_self;
/* harmony default export */ const VideoLearningMcqThankYouScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "VideoLearningMcqThankyouScreen",
    components: {},
    props: {
        clubUserLevel: { type: String, required: true },
        userName: { type: String, required: true },
        mcqAnswer: { type: Array, required: true },
        pointsEarned: { type: Number, required: true },
        lessionid: { type: String, required: true },
        pagename: { type: String, required: true },
    },
    mounted() {
        VideoLearningMcqThankYouScreenvue_type_script_lang_ts_self = this;
        setTimeout(() => {
            if (document.getElementById("btncloseMCQIcon")) {
                document
                    .getElementById("btncloseMCQIcon")
                    .addEventListener("click", async function (e) {
                    GATrack.pushValues('MCQ_Closebutton', 'close_MCQ_test_' + VideoLearningMcqThankYouScreenvue_type_script_lang_ts_self.lessionid, 'Click_MCQ_Closebutton');
                    js_LearningVideoMCQScript.backtoVideoPage();
                });
            }
        }, 3000);
    },
    methods: {
        nextactivity() {
            GATrack.pushValues('MCQ_thankyou_Otheractivities', this.lessionid + '_ other_activities', 'Click_MCQ_thankyou_Otheractivities');
            //  location.href = "/home";
            js_LearningVideoMCQScript.backToActivityPage();
        },
        nextlesson() {
            GATrack.pushValues('MCQ_thankyou_Next Lesson', this.lessionid + '_next_lesson', 'Click_MCQ_thankyou_Next Lesson');
            // location.reload();
            // remove this component and reload wathch video component
            js_LearningVideoMCQScript.loadnextvideo();
        },
    },
    // computed: {
    // 	getClubUserLevel: function (): string {
    // 		var correctAnswerCount: number = this.mcqAnswer.filter(item => item.isCorrectAnswer == true).length
    // 		return correctAnswerCount <= 9 ? "Beginner" : correctAnswerCount <= 15 ? "Intermediate" : "Advanced";
    // 	}
    // }
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/VideoLearningMcqThankYouScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/VideoLearningMcqThankYouScreen.vue




;
const VideoLearningMcqThankYouScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(VideoLearningMcqThankYouScreenvue_type_script_lang_ts, [['render',VideoLearningMcqThankYouScreenvue_type_template_id_0266ee2c_ts_true_render]])

/* harmony default export */ const VideoLearningMcqThankYouScreen = (VideoLearningMcqThankYouScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/JumbledArea.vue?vue&type=template&id=44328cd3&ts=true

const JumbledAreavue_type_template_id_44328cd3_ts_true_hoisted_1 = { class: "activity-container tap-activity" };
function JumbledAreavue_type_template_id_44328cd3_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuestionArea = (0,vue_cjs.resolveComponent)("QuestionArea");
    const _component_ChooseArea = (0,vue_cjs.resolveComponent)("ChooseArea");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", JumbledAreavue_type_template_id_44328cd3_ts_true_hoisted_1, [
        (0,vue_cjs.createVNode)(_component_QuestionArea, {
            totalPoints: _ctx.totalPoints,
            question: _ctx.question,
            selectedAnswer: _ctx.selectedAnswer,
            totalQuestions: _ctx.totalQuestions,
            activeQuestion: _ctx.activeQuestion,
            removeSentence: _ctx.removeSentence,
            moveSentence: _ctx.moveSentence,
            basicDetails: _ctx.basicDetails,
            updateSentence: _ctx.updateSentence,
            JumbledWordsCount: _ctx.JumbledWordsCount
        }, null, 8, ["totalPoints", "question", "selectedAnswer", "totalQuestions", "activeQuestion", "removeSentence", "moveSentence", "basicDetails", "updateSentence", "JumbledWordsCount"]),
        (0,vue_cjs.createVNode)(_component_ChooseArea, {
            frameSentence: _ctx.frameSentence,
            question: _ctx.question,
            selectedAnswer: _ctx.selectedAnswer,
            correctAnswer: _ctx.correctAnswer,
            submitFramedSentence: _ctx.submitFramedSentence,
            handleNextClick: _ctx.handleNextClick,
            getSelectedAnswer: _ctx.getSelectedAnswer,
            basicDetails: _ctx.basicDetails,
            isSubmitted: _ctx.isSubmitted,
            JumbledWordsCount: _ctx.JumbledWordsCount
        }, null, 8, ["frameSentence", "question", "selectedAnswer", "correctAnswer", "submitFramedSentence", "handleNextClick", "getSelectedAnswer", "basicDetails", "isSubmitted", "JumbledWordsCount"])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/JumbledArea.vue?vue&type=template&id=44328cd3&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/QuestionArea.vue?vue&type=template&id=ef8468ae&ts=true

const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_1 = { class: "activity-body tb-1 sk-container activity-bg" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_2 = { class: "activity-description" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_3 = { class: "quiz-questions" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_4 = { class: "questions-count" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_5 = { class: "achieve-score big" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_6 = { class: "outof-score" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_7 = {
    key: 0,
    class: "earn-points"
};
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_8 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", null, "Total Points", -1);
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_9 = { class: "title-large mt-2" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_10 = { class: "work-area mt-3" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_11 = /*#__PURE__*/ (0,vue_cjs.createStaticVNode)("<div class=\"lines\"><div class=\"line\"></div><div class=\"line\"></div><div class=\"line\"></div><div class=\"line\"></div></div>", 1);
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_12 = { class: "select-option choose-questions" };
const QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_13 = ["onClick"];
function QuestionAreavue_type_template_id_ef8468ae_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProgressBar = (0,vue_cjs.resolveComponent)("ProgressBar");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_2, [
            (0,vue_cjs.createElementVNode)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_3, [
                (0,vue_cjs.createElementVNode)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_4, [
                    (0,vue_cjs.createElementVNode)("span", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_5, (0,vue_cjs.toDisplayString)(_ctx.activeQuestion), 1),
                    (0,vue_cjs.createElementVNode)("span", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_6, "/ " + (0,vue_cjs.toDisplayString)(_ctx.totalQuestions), 1)
                ]),
                (_ctx.basicDetails.showProgressBar)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_7, [
                        QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_8,
                        (0,vue_cjs.createVNode)(_component_ProgressBar, {
                            totalValue: _ctx.totalQuestions * _ctx.question.points,
                            value: _ctx.totalPoints
                        }, null, 8, ["totalValue", "value"])
                    ]))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ]),
            (0,vue_cjs.createElementVNode)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_9, "Frame a sentence with " + (0,vue_cjs.toDisplayString)(_ctx.JumbledWordsCount) + " words.", 1)
        ]),
        (0,vue_cjs.createElementVNode)("div", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_10, [
            QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_11,
            (0,vue_cjs.createElementVNode)("ul", QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_12, [
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.selectedAnswer, ([idx, word]) => {
                    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                        key: idx,
                        onClick: ($event) => (_ctx.remove(idx))
                    }, (0,vue_cjs.toDisplayString)(word), 9, QuestionAreavue_type_template_id_ef8468ae_ts_true_hoisted_13));
                }), 128))
            ])
        ])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/QuestionArea.vue?vue&type=template&id=ef8468ae&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/QuestionArea.vue?vue&type=script&lang=ts


/* harmony default export */ const QuestionAreavue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'QuestionArea',
    props: {
        totalPoints: { type: Number, default: 0, required: true },
        totalQuestions: { type: Number, default: 0, required: true },
        activeQuestion: { type: Number, default: 0, required: true },
        selectedAnswer: { type: Map, default: new Map(), required: true },
        basicDetails: { type: Object, default: null, required: true },
        question: { type: Object, default: null, required: true },
        removeSentence: { type: Function, default: () => { throw new Error("Not Implemented."); }, required: true },
        JumbledWordsCount: { type: Number, default: null, required: true },
        moveSentence: { type: Function, default: () => { throw new Error("Not Implemented."); }, required: true },
    },
    components: {
        ProgressBar: ProgressBar
    },
    methods: {
        move: function (idx, targetIdx) {
            this.moveSentence(idx, targetIdx);
        },
        remove: function (idx) {
            this.removeSentence(idx);
        },
        startDrag: function (e, idx) {
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('itemID', idx.toString());
        },
        onDrop: function (e, targetIdx) {
            e.preventDefault();
            const currentIdx = e.dataTransfer.getData('itemID');
            this.move(parseInt(currentIdx), targetIdx);
            e.dataTransfer.setData('itemID', targetIdx.toString());
        }
    },
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/QuestionArea.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/QuestionArea.vue




;
const QuestionArea_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(QuestionAreavue_type_script_lang_ts, [['render',QuestionAreavue_type_template_id_ef8468ae_ts_true_render]])

/* harmony default export */ const QuestionArea = (QuestionArea_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/ChooseArea.vue?vue&type=template&id=7192a5c4&ts=true

const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_1 = { class: "activity-footer tb-1 sk-container activity-bg" };
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_2 = {
    key: 0,
    class: "select-option choose-questions align-center"
};
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_3 = ["onClick"];
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_4 = {
    key: 0,
    class: "title-large error-color",
    id: "answerType"
};
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_5 = {
    key: 1,
    class: "title-large success-color",
    id: "answerType"
};
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_6 = {
    key: 2,
    id: "answer"
};
const ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_7 = ["disabled"];
function ChooseAreavue_type_template_id_7192a5c4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_1, [
        (_ctx.question.question)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("ul", ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_2, [
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.splitSentence(_ctx.question.question), (word, idx) => {
                    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                        class: (0,vue_cjs.normalizeClass)({ 'selected animate__animated animate__pulse animate__faster': _ctx.selectedAnswer.has(idx) }),
                        onClick: ($event) => (_ctx.addToSentence($event, idx, word)),
                        key: idx
                    }, (0,vue_cjs.toDisplayString)(word), 11, ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_3));
                }), 128))
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        (0,vue_cjs.createElementVNode)("div", {
            class: (0,vue_cjs.normalizeClass)({ 'evaluation-result success show': _ctx.isSubmitted && _ctx.question.answer === _ctx.getSelectedAnswer(), 'evaluation-result fail show': _ctx.isSubmitted && _ctx.question.answer !== _ctx.getSelectedAnswer() })
        }, [
            (_ctx.isSubmitted && _ctx.question.answer !== _ctx.getSelectedAnswer())
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_4, (0,vue_cjs.toDisplayString)(_ctx.getFailedAdjective()), 1))
                : (0,vue_cjs.createCommentVNode)("", true),
            (_ctx.isSubmitted && _ctx.question.answer === _ctx.getSelectedAnswer())
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_5, (0,vue_cjs.toDisplayString)(_ctx.getSuccessAdjective()), 1))
                : (0,vue_cjs.createCommentVNode)("", true),
            (_ctx.isSubmitted && _ctx.question.answer !== _ctx.getSelectedAnswer())
                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_6, "Answer: " + (0,vue_cjs.toDisplayString)(_ctx.correctAnswer), 1))
                : (0,vue_cjs.createCommentVNode)("", true)
        ], 2),
        (!_ctx.isSubmitted)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                key: 1,
                type: "button",
                class: (0,vue_cjs.normalizeClass)({ 'button block  ': true, 'primary': _ctx.JumbledWordsCount === _ctx.selectedAnswer.size, 'light disable': _ctx.JumbledWordsCount !== _ctx.selectedAnswer.size }),
                id: "checkAnswer",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.submit && _ctx.submit(...args))),
                disabled: _ctx.JumbledWordsCount !== _ctx.selectedAnswer.size
            }, "Check", 10, ChooseAreavue_type_template_id_7192a5c4_ts_true_hoisted_7))
            : (0,vue_cjs.createCommentVNode)("", true),
        (_ctx.isSubmitted)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                key: 2,
                type: "button",
                class: (0,vue_cjs.normalizeClass)({ 'button primary': true, 'success': _ctx.isSubmitted && _ctx.question.answer === _ctx.getSelectedAnswer(), 'error': _ctx.isSubmitted && _ctx.question.answer !== _ctx.getSelectedAnswer(), 'block': true }),
                id: "nextAnswer",
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.nextClick && _ctx.nextClick(...args)))
            }, "Next", 2))
            : (0,vue_cjs.createCommentVNode)("", true)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/ChooseArea.vue?vue&type=template&id=7192a5c4&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/ChooseArea.vue?vue&type=script&lang=ts


/* harmony default export */ const ChooseAreavue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'ChooseArea',
    props: {
        handleNextClick: { type: Function, required: true },
        basicDetails: { type: McqBasicDetails, required: true },
        frameSentence: { type: Function, default: null, required: true },
        submitFramedSentence: { type: Function, default: null, required: true },
        question: { type: Object, default: null, required: true },
        correctAnswer: { type: String, default: "", required: true },
        getSelectedAnswer: { type: Function, default: () => { throw new Error("Not Implemented"); }, required: true },
        removeSentence: { type: Function, default: () => { throw new Error("Not Implemented"); }, required: true },
        selectedAnswer: { type: Map, required: true },
        isSubmitted: { type: Boolean, default: false, required: true },
        JumbledWordsCount: { type: Number, required: true }
    },
    methods: {
        splitSentence: function (sentence) {
            return sentence.trimStart().trimEnd().split(" ");
        },
        addToSentence: function (e, idx, ans) {
            e.preventDefault();
            if (this.isSubmitted)
                return;
            if (this.selectedAnswer.has(idx)) {
                return;
            }
            this.frameSentence(idx, ans);
        },
        submit: function (event) {
            if (this.isSubmitted)
                return;
            this.submitFramedSentence(event);
        },
        getRndInteger: function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        getSuccessAdjective: function () {
            const words = [
                "Awesome!",
                "Superb!",
                "Excellent!",
                "Nice!",
                "Great job!",
                "Nicely done!"
            ];
            const wordIdx = this.getRndInteger(0, words.length - 1);
            return words[wordIdx];
        },
        getFailedAdjective: function () {
            const words = [
                "Incorrect!",
                "Wrong sentence!",
                "Nice try!"
            ];
            const wordIdx = this.getRndInteger(0, words.length - 1);
            return words[wordIdx];
        },
        nextClick: function () {
            setTimeout(() => {
                this.handleNextClick();
            }, 500);
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/ChooseArea.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/ChooseArea.vue




;
const ChooseArea_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ChooseAreavue_type_script_lang_ts, [['render',ChooseAreavue_type_template_id_7192a5c4_ts_true_render]])

/* harmony default export */ const ChooseArea = (ChooseArea_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JumbledArea/JumbledArea.vue?vue&type=script&lang=ts




/* harmony default export */ const JumbledAreavue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "JumbledArea",
    props: {
        basicDetails: { type: McqBasicDetails, required: true },
        question: { required: true },
        pointsEarned: { type: Number },
        totalQuestions: { type: Number, default: 0 },
        totalPoints: { type: Number },
        validateAnswer: { type: Function, required: true },
        submitClick: { type: Function, required: true },
        getCurrentQuestion: { type: Function, required: true },
        showError: { type: Boolean, default: false },
        correctAnswer: { type: String, default: "" },
        onExplanationNext: { type: Function, required: true },
        activeQuestion: { type: Number, default: 0, required: true },
        activeExplanationTitle: { type: String, default: null, required: true },
        activeExplanationText: { type: String, default: null, required: true },
        JumbledWordsCount: { type: Number, default: null, required: true }
    },
    data() {
        let selectedAnswer = new Map();
        let isSubmitted = false;
        return {
            selectedAnswer,
            isSubmitted
        };
    },
    components: {
        QuestionArea: QuestionArea,
        ChooseArea: ChooseArea
    },
    methods: {
        frameSentence: function (idx, ans) {
            this.selectedAnswer.set(idx, ans);
        },
        moveSentence: function (idx, targetIdx) {
            if (this.isSubmitted)
                return;
            let targetValue = this.map.get(targetIdx);
            let currentValue = this.map.get(idx);
            this.map.get(idx).set(targetValue);
            this.map.get(targetIdx).set(currentValue);
        },
        removeSentence: function (idx) {
            if (this.isSubmitted)
                return;
            this.selectedAnswer.delete(idx);
        },
        submitFramedSentence: function (event) {
            if (this.isSubmitted)
                return;
            const correctAnswer = this.validateAnswer(event, this.getSelectedAnswer());
            this.isSubmitted = true;
            const Result = [];
            if (this.getSelectedAnswer().split(" ").length !== correctAnswer.split(" ").length) {
                Result.push({
                    userPid: this.userPid,
                    WordId: this.getCurrentQuestion().sno,
                    Score: this.getCurrentQuestion().pointsEarned,
                    answer: this.getCurrentQuestion().answer,
                    isCorrectAnswer: this.getCurrentQuestion().answer.split(",").indexOf(this.getSelectedAnswer()) > -1 ? true : false,
                    // QuizSummaryID: this.field.mcqList[0].groupId,
                });
            }
        },
        handleNextClick: function () {
            this.isSubmitted = false;
            this.selectedAnswer = new Map();
            this.submitClick();
        },
        getSelectedAnswer: function () {
            let ans = "";
            for (let value of this.selectedAnswer.values()) {
                ans += " " + value;
            }
            return ans.trimStart();
        }
    },
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/JumbledArea.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/JumbledArea/JumbledArea.vue




;
const JumbledArea_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(JumbledAreavue_type_script_lang_ts, [['render',JumbledAreavue_type_template_id_44328cd3_ts_true_render]])

/* harmony default export */ const JumbledArea = (JumbledArea_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JobInerviewCourseVideoMcqThankYouScreen.vue?vue&type=template&id=51d1ad12&ts=true

const JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_1 = { class: "slide-content" };
const JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_2 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "app-gift align-center" }, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("img", { src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/app-final-bg.png" }),
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("h2", null, "Please wait...")
], -1);
const JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_3 = [
    JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_2
];
function JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_1, JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_hoisted_3));
}

;// CONCATENATED MODULE: ./src/Components/Mcq/JobInerviewCourseVideoMcqThankYouScreen.vue?vue&type=template&id=51d1ad12&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/JobInerviewCourseVideoMcqThankYouScreen.vue?vue&type=script&lang=ts

var JobInerviewCourseVideoMcqThankYouScreenvue_type_script_lang_ts_self;
/* harmony default export */ const JobInerviewCourseVideoMcqThankYouScreenvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "JobInerviewCourseVideoMcqThankYouScreen",
    components: {},
    props: {
        clubUserLevel: { type: String, required: true },
        userName: { type: String, required: true },
        mcqAnswer: { type: Array, required: true },
        pointsEarned: { type: Number, required: true },
        lessionid: { type: String, required: true },
        pagename: { type: String, required: true },
    },
    mounted() {
    },
    methods: {},
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/JobInerviewCourseVideoMcqThankYouScreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/JobInerviewCourseVideoMcqThankYouScreen.vue




;
const JobInerviewCourseVideoMcqThankYouScreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(JobInerviewCourseVideoMcqThankYouScreenvue_type_script_lang_ts, [['render',JobInerviewCourseVideoMcqThankYouScreenvue_type_template_id_51d1ad12_ts_true_render]])

/* harmony default export */ const JobInerviewCourseVideoMcqThankYouScreen = (JobInerviewCourseVideoMcqThankYouScreen_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Mcq/Mcq.vue?vue&type=script&lang=ts












var Mcqvue_type_script_lang_ts_self;
/* harmony default export */ const Mcqvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    // eslint-disable-next-line vue/multi-word-component-names
    name: "Mcq",
    components: {
        McqIntroScreen: McqIntroScreen,
        McqQuestionScreen: McqQuestionScreen,
        McqThankyouScreen: McqThankyouScreen,
        VideoLearningMcqThankYouScreen: VideoLearningMcqThankYouScreen,
        McqExplanationScreen: McqExplanationScreen,
        JumbledArea: JumbledArea,
        JobInerviewCourseVideoMcqThankYouScreen: JobInerviewCourseVideoMcqThankYouScreen
    },
    props: {
        id: { type: String, required: true },
        basicDetails: { type: McqBasicDetails, required: true },
        field: { type: McqField, required: true },
        userPid: { type: Number, required: true },
        userName: { type: String, required: true, default: "User" },
        clubUserLevel: { type: String, required: true },
        startMcq: { type: Function, required: true },
        showThankyou: { type: Function, required: true },
        playNextQuiz: { type: Function, required: true },
        thankYouScreenGoBack: { type: Function, required: true },
        sulekhaApp: { type: null },
        isMobileApp: { type: Boolean },
        playNo: { type: Number, default: 0 },
        videoId: { type: Number, default: 0 },
    },
    data() {
        return {
            showBottomExplanationLayout: false,
            showSubmitButtonLayout: false,
            isButtonDisabled: true,
            isClickable: true,
            activeExplanationTitle: null,
            activeExplanationText: null,
            activeQuestion: 0,
            question1: new McqQuestion(),
            question2: new McqQuestion(),
            pointsEarned: this.field ? this.field.pointsEarned : 0,
            currentAnswer: new McqAnswer(),
            introscreenClass: "current-slide activity-container tap-activity",
            question1Class: "next-slide activity-container",
            visitedExplanations: new Map(),
            showError: false,
            q1correctAnswer: "",
            q2correctAnswer: "",
            q1pointsEarned: 0,
            q2pointsEarned: 0,
            pageName: "intro"
        };
    },
    beforeMount() {
        if (!this.basicDetails.showIntroScreen)
            this.startMcq();
    },
    mounted() {
        Mcqvue_type_script_lang_ts_self = this;
        if (document.getElementById("mcqRightNav")) {
            document.getElementById("mcqRightNav").classList.remove("hide");
        }
        setTimeout(() => {
            if (document.getElementById("btncloseMCQIcon")) {
                document
                    .getElementById("btncloseMCQIcon")
                    .addEventListener("click", async (e) => {
                    Mcqvue_type_script_lang_ts_self.mcqType;
                    if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.Quiz ||
                        Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.FillInTheGap ||
                        Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.JumbledSentence ||
                        Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.Meanings) {
                        if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.Quiz)
                            GATrack.pushValues('Close_ Vocabulary', 'Close_Vocabulary' + Mcqvue_type_script_lang_ts_self.playNo, 'Click_close');
                        else if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.FillInTheGap)
                            GATrack.pushValues('Close_ Fillthegap', 'Close_Fillthegap' + Mcqvue_type_script_lang_ts_self.playNo, 'Click_close');
                        else if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.JumbledSentence)
                            GATrack.pushValues('Close_jumbledSentence', 'Close_JumbledSentence' + Mcqvue_type_script_lang_ts_self.playNo, 'Click_close');
                        else if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.Meanings)
                            GATrack.pushValues('Close_Meanings', 'CloseMeanings' + Mcqvue_type_script_lang_ts_self.playNo, 'Click_close');
                        if (Mcqvue_type_script_lang_ts_self.isMobileApp) {
                            Mcqvue_type_script_lang_ts_self.sulekhaApp.navigateTo(MainEnums_MobilePages.activity);
                        }
                        else {
                            window.location.href = `/activity`;
                        }
                    }
                    else if (Mcqvue_type_script_lang_ts_self.basicDetails.mcqType == McqTypeOption.AssessYourEnglish) {
                        GATrack.pushValues('assess_level_close', 'assess_close', 'click_assess_level_close');
                        Mcqvue_type_script_lang_ts_self.skipMcq();
                    }
                });
            }
        }, 500);
        if (!this.basicDetails.showIntroScreen) {
            (this.introscreenClass = "previous-slide"),
                (this.question1Class = "current-slide");
        }
        this.$refs["question2"].classList.replace("current-slide", "next-slide");
        this.$refs.thankyou.classList.replace("current-slide", "next-slide");
    },
    watch: {
        "field.mcqList": {
            handler: function (newVal) {
                if (newVal.length > 0) {
                    this.pageName = "mcqQuestions";
                    this.question1 = newVal[0];
                    this.answerWordCount = newVal[0].answer.split(" ");
                    this.activeQuestion = 1;
                    this.$refs["introscreen"]?.classList.replace("current-slide", "previous-slide");
                    this.$refs["question1"].classList.replace("next-slide", "current-slide");
                }
            },
        },
    },
    methods: {
        skipMcq: function () {
            if (this.basicDetails.mcqType == McqTypeOption.AssessYourEnglish) {
                this.pageName = "thankYou";
                this.showThankyou();
            }
            if (this.basicDetails.mcqType != McqTypeOption.VideoLearning) {
                if (document.getElementById("mcqRightNav")) {
                    document.getElementById("mcqRightNav").classList.add("hide");
                }
            }
            this.$refs.introscreen.classList.replace("current-slide", "previous-slide");
            this.$refs.thankyou.classList.replace("next-slide", "current-slide");
        },
        showThankyouScreen: function () {
            this.pageName = "thankYou";
            this.showThankyou();
            if (this.basicDetails.mcqType != McqTypeOption.VideoLearning) {
                if (document.getElementById("mcqRightNav")) {
                    document.getElementById("mcqRightNav").classList.add("hide");
                }
            }
            this.$refs["question" + this.activeQuestion].classList.replace("current-slide", "previous-slide");
            this.$refs.thankyou.classList.replace("next-slide", "current-slide");
        },
        getCurrentQuestion: function () {
            return this.activeQuestion == 1 ? this.question1 : this.question2;
        },
        getNextQuestion: function () {
            var currentQuestion = this.getCurrentQuestion();
            var currentQuestionIndex = this.field.mcqList.findIndex(function (element) {
                return element.questionId == currentQuestion.questionId;
            });
            if (this.basicDetails.mcqType == McqTypeOption.AssessYourEnglish) {
                if (this.currentAnswer.isCorrectAnswer) {
                    var nextQues = this.field.mcqList.find(function (element) {
                        return (element.groupId == currentQuestion.groupId &&
                            element.sno == currentQuestion.sno + 1);
                    });
                    if (nextQues == null) {
                        nextQues = this.field.mcqList.find(function (element) {
                            return (element.groupId == currentQuestion.groupId + 1 &&
                                element.sno == 1);
                        });
                    }
                    return nextQues;
                }
                else {
                    return this.field.mcqList.find(function (element) {
                        return (element.groupId == currentQuestion.groupId + 1 && element.sno == 1);
                    });
                }
            }
            else {
                if (currentQuestionIndex < this.field.mcqList.length)
                    return this.field.mcqList[currentQuestionIndex + 1];
                else
                    return null;
            }
        },
        showNextQuestion: function (question) {
            if (this.activeQuestion == 1) {
                this.question2 = question;
                this.$refs.question1.classList.replace("current-slide", "previous-slide");
                this.$refs.question2.classList.replace("next-slide", "current-slide");
                this.activeQuestion = 2;
            }
            else {
                this.question1 = question;
                this.$refs.question1.classList.replace("next-slide", "current-slide");
                this.$refs.question2.classList.replace("current-slide", "previous-slide");
                this.activeQuestion = 1;
            }
            this.showSubmitButtonLayout = false;
            this.showBottomExplanationLayout = false;
            this.isClickable = true;
            setTimeout(() => {
                var ref = this.activeQuestion == 1 ? "question2" : "question1";
                this.$refs[ref].classList.replace("previous-slide", "next-slide");
                if (this.activeQuestion == 1) {
                    this.q2correctAnswer = "";
                    this.q2pointsEarned = 0;
                }
                else {
                    this.q1correctAnswer = "";
                    this.q1pointsEarned = 0;
                }
            }, 150);
        },
        validateAnswer: function (event, opt) {
            if (this.isClickable) {
                var currentQuestion = this.getCurrentQuestion();
                var currentQuestionIndex = this.field.mcqList.findIndex(element => element.questionId == currentQuestion.questionId);
                this.isClickable = false;
                this.showError = false;
                this.currentAnswer = new McqAnswer({
                    questionId: currentQuestion.questionId,
                    answer: opt,
                    correctAnswer: currentQuestion.answer,
                    isCorrectAnswer: currentQuestion.answer.split(",").indexOf(opt) > -1 ? true : false,
                    pointsEarned: currentQuestion.answer.split(",").indexOf(opt) > -1
                        ? currentQuestion.points
                        : 0,
                });
                // eslint-disable-next-line vue/no-mutating-props
                this.field.answerList.push(this.currentAnswer);
                if (currentQuestion.answer.split(",").indexOf(opt) > -1) {
                    // eslint-disable-next-line vue/no-mutating-props
                    this.field.pointsEarned += currentQuestion.points;
                }
                if (this.basicDetails.showSubmitButton) {
                    if (currentQuestion.answer.split(",").indexOf(opt) > -1) {
                        event.currentTarget.classList?.add("select-correct-answer");
                        event.currentTarget
                            .querySelector(".right")?.classList?.remove("hide");
                        if (this.activeQuestion === 1) {
                            this.q1correctAnswer = currentQuestion.answer;
                            this.q1pointsEarned = currentQuestion.points;
                        }
                        else {
                            this.q2correctAnswer = currentQuestion.answer;
                            this.q2pointsEarned = currentQuestion.points;
                        }
                    }
                    else {
                        this.setCorrectAnswer(currentQuestion);
                        event.currentTarget.classList?.add("select-wrong-answer");
                        event.currentTarget.querySelector(".wrong")?.classList?.remove("hide");
                    }
                }
                else {
                    event.currentTarget.classList?.add("selected", "animate__animated", "animate__pulse", "animate__faster");
                    setTimeout(() => {
                        var nextQuestion = this.getNextQuestion();
                        if (nextQuestion != null) {
                            this.showNextQuestion(nextQuestion);
                        }
                        else {
                            this.showThankyouScreen();
                        }
                    }, 500);
                }
            }
            return currentQuestion.answer;
        },
        updateAnswerAndPoints: function (option, currentQuestion) {
            // eslint-disable-next-line vue/no-mutating-props
            this.field.answerList.push(this.currentAnswer);
            if (currentQuestion.answer.split(",").indexOf(option) > -1) {
                // eslint-disable-next-line vue/no-mutating-props
                this.field.pointsEarned += currentQuestion.points;
            }
            return new Promise((resolve) => {
                if (this.activeQuestion == 1) {
                    this.q1correctAnswer = currentQuestion.answer;
                    this.q1pointsEarned = currentQuestion.points;
                }
                else {
                    this.q2correctAnswer = currentQuestion.answer;
                    this.q2pointsEarned = currentQuestion.points;
                }
                setTimeout(() => {
                    resolve(true);
                }, 200);
            });
        },
        moveToNextQuestion: function () {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const nextQuestion = this.getNextQuestion();
                    if (nextQuestion) {
                        if (!this.basicDetails.showSubmitButton && !this.basicDetails.showBottomExplanation) {
                            this.showNextQuestion(nextQuestion);
                        }
                        else {
                            if (this.basicDetails.showBottomExplanation) {
                                this.showBottomExplanationLayout = true;
                            }
                            else if (this.basicDetails.showSubmitButton) {
                                this.showSubmitButtonLayout = true;
                            }
                        }
                        this.isButtonDisabled = false;
                        resolve();
                    }
                    else {
                        if (!this.basicDetails.showSubmitButton && !this.basicDetails.showBottomExplanation) {
                            this.showThankyouScreen();
                        }
                        else {
                            if (this.basicDetails.showBottomExplanation) {
                                this.showBottomExplanationLayout = true;
                            }
                            else if (this.basicDetails.showSubmitButton) {
                                this.showSubmitButtonLayout = true;
                            }
                        }
                        this.isButtonDisabled = false;
                        resolve();
                    }
                }, 600);
            });
        },
        updateCurrentAnswer: function (option, currentQuestion) {
            let currentQuestionIndex = this.field.mcqList.findIndex(element => element.questionId == currentQuestion.questionId);
            //bindGA.pushValues('MCQ_option_select', (currentQuestionIndex + 1) + "_" + option, 'Click_MCQ_' + McqTypeOption[this.basicDetails.mcqType] + '_option');
            this.showError = false;
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.currentAnswer = new McqAnswer({
                        questionId: currentQuestion.questionId,
                        answer: option,
                        isCorrectAnswer: currentQuestion.answer.split(",").indexOf(option) > -1 ? true : false,
                        correctAnswer: currentQuestion.answer,
                        pointsEarned: currentQuestion.answer.split(",").indexOf(option) > -1
                            ? currentQuestion.points
                            : 0,
                    });
                    resolve();
                }, 275);
            });
        },
        validateAndUpdateAnswer: async function (option) {
            let currentQuestion = this.getCurrentQuestion();
            this.updateCurrentAnswer(option, currentQuestion);
            await this.updateAnswerAndPoints(option, currentQuestion);
            await this.moveToNextQuestion(option, currentQuestion);
            return;
        },
        submitClick: function () {
            let currentQuestion;
            let currentQuestionIndex;
            currentQuestion = this.getCurrentQuestion();
            currentQuestionIndex = this.field.mcqList.findIndex((element) => {
                return element.questionId == currentQuestion.questionId;
            });
            let nextQuestion = this.getNextQuestion();
            const showExplanation = (!(this.visitedExplanations.has(currentQuestion.sno)) && currentQuestion.explanation?.length > 0 && this.basicDetails.mcqType === McqTypeOption.Quiz);
            if ((this.basicDetails.mcqType == McqTypeOption.JumbledSentence || this.basicDetails.mcqType == McqTypeOption.Meanings ||
                this.basicDetails.mcqType == McqTypeOption.FillInTheGap || this.basicDetails.mcqType == McqTypeOption.Quiz) && !showExplanation) {
                GATrack.pushValues("Q" + (currentQuestionIndex + 1) + "_completed " + McqTypeOption[this.basicDetails.mcqType], McqTypeOption[this.basicDetails.mcqType] + currentQuestion.answer.toLowerCase() + "_Q" + (currentQuestionIndex + 1), "Completed_" + McqTypeOption[this.basicDetails.mcqType] + "Q" + (currentQuestionIndex + 1));
                if (nextQuestion)
                    GATrack.pushValues('Start_' + McqTypeOption[this.basicDetails.mcqType] + ' Q' + (currentQuestionIndex + 2), 'Play_' + McqTypeOption[this.basicDetails.mcqType] + ' Q' + (currentQuestionIndex + 2), 'Click Start Now');
            }
            if (showExplanation) {
                this.visitedExplanations.set(currentQuestion.sno, true);
                this.activeExplanationTitle = currentQuestion[currentQuestion.answer.toLowerCase()];
                this.activeExplanationText = currentQuestion.explanation;
                if (this.basicDetails.mcqType == McqTypeOption.VideoLearning)
                    GATrack.pushValues(this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2), this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2), this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2));
            }
            else if (nextQuestion) {
                this.activeExplanationTitle = null;
                this.activeExplanationText = null;
                this.isButtonDisabled = true;
                this.showNextQuestion(nextQuestion);
                if (this.basicDetails.mcqType == McqTypeOption.VideoLearning)
                    GATrack.pushValues(this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2), this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2), this.videoId + '_MCQ_Q' + (currentQuestionIndex + 2));
            }
            else {
                if (this.basicDetails.mcqType == McqTypeOption.VideoLearning)
                    GATrack.pushValues('MCQ_thankyou_' + this.videoId, 'MCQ_thankyou_' + this.videoId, 'MCQ_thankyou_' + this.videoId);
                this.showThankyouScreen();
            }
        },
        setCorrectAnswer: function (question) {
            let ans = "";
            switch (question.answer.split(",")[0].toLowerCase()) {
                case "a":
                    ans = question.a;
                    break;
                case "b":
                    ans = question.b;
                    break;
                case "c":
                    ans = question.c;
                    break;
                case "d":
                    ans = question.d;
                    break;
                default:
                    ans = question.answer;
            }
            if (this.activeQuestion == 1) {
                this.q1correctAnswer = ans;
            }
            else {
                this.q2correctAnswer = ans;
            }
        },
    },
}));

;// CONCATENATED MODULE: ./src/Components/Mcq/Mcq.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Mcq/Mcq.vue




;
const Mcq_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Mcqvue_type_script_lang_ts, [['render',Mcqvue_type_template_id_23128595_ts_true_render]])

/* harmony default export */ const Mcq = (Mcq_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/VideoLearningMCQ.vue?vue&type=script&lang=ts





/* harmony default export */ const VideoLearningMCQvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "VideoLearnigMCQ",
    props: ["VideoId", "UserPid", "videouniqueid", "pagename", "lessionid"],
    components: { MCQ: Mcq },
    setup() {
        return {
            pageHtml: (0,vue_cjs.ref)("...loading"),
            mcqBasicDetails: new McqBasicDetails({
                mcqType: McqTypeOption.VideoLearning,
                title: "Practice Test on Video",
                showIntroScreen: false,
                introScreen: new IntroScreenContent({
                    heading: "",
                    hasSkipButton: true,
                    instructionList: ["", "", ""],
                    content: "",
                }),
                showSubmitButton: true,
                showEarnedPoints: false,
                showQuestionCount: true,
                showProgressBar: true,
            }),
        };
    },
    data() {
        return {
            field: null,
            showMCQ: false,
            userInfo: {},
        };
    },
    watch: {
        userInfo: {
            handler: function (newVal) {
                this.mcqBasicDetails.userInfo = newVal;
            },
        },
    },
    beforeMount() {
        CSMainAPIs.Capshine.APIs.GetMCQQuestionAndAnswer.execute({ videoid: this.VideoId }, this.apiResponse);
        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ UserPid: this.UserPid }, this._afterGetUserInfoLoad);
    },
    methods: {
        _afterGetUserInfoLoad(response) {
            this.userInfo = response.data;
        },
        startMcq() {
            // void
        },
        apiResponse(response) {
            if (response.res.status != 200)
                return;
            var mcqList = JSON.parse(JSON.stringify(response.data));
            this.field = new McqField({ mcqList: mcqList });
            this.mcqBasicDetails.pagename = this.pagename;
            this.mcqBasicDetails.lessionid = this.lessionid;
            this.showMCQ = true;
        },
        showThankyou() {
            var responseObj = {
                VideoId: this.VideoId,
                UserPid: this.UserPid,
                McqAnswer: this.field.answerList,
            };
            CSMainAPIs.Capshine.APIs.StoreVideoLearningMCQQuestionAndAnswer.execute(responseObj, null);
            var mcqStatusUpdateData = {
                UserPid: this.UserPid,
                VideoId: this.VideoId,
                VideoUniqueId: this.videouniqueid,
            };
            // submit Video watched status 
            CSMainAPIs.Capshine.APIs.SubmitLearningVideoWatchedStatus.execute(mcqStatusUpdateData, null);
            // submit MCQ Completed  status 
            setTimeout(function () {
                let that = this;
                CSMainAPIs.Capshine.APIs.SubmiMCQCompletedStatus.execute(mcqStatusUpdateData, that.SubmitMCQStatusResponse);
            }, 2000);
            // var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
            // var userId = e.currentTarget.getAttribute('data-userid');
            // var videoId = e.currentTarget.getAttribute('data-videoid');
            // WatchVideoScript.videoId = e.currentTarget.getAttribute('data-videoid');
            // 
            // var clientData = {
            //     UserPid: userId,
            //     VideoId: videoId,
            //     VideoUniqueId: videouniqueid
            // }
            // 
            //	StoreVideoLearningMCQQuestionAndAnswer
        },
        playNextQuiz() { },
    },
}));

;// CONCATENATED MODULE: ./src/Components/VideoLearningMCQ.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/VideoLearningMCQ.vue




;
const VideoLearningMCQ_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(VideoLearningMCQvue_type_script_lang_ts, [['render',VideoLearningMCQvue_type_template_id_300c9e32_ts_true_render]])

/* harmony default export */ const VideoLearningMCQ = (VideoLearningMCQ_exports_);
;// CONCATENATED MODULE: ./src/js/LearningVideoMCQScript.js





//import router from "./routerconfig"

var LearningVideoMCQScript = {
    UserPid: '',
    videoId: 0,
    isMobileApp: false,
    sulekhaApp:null,
    pagename:"",
    lessionid:"",
    init: function (userId,sulekhaApp=null) {
        LearningVideoMCQScript.sulekhaApp=sulekhaApp

        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                LearningVideoMCQScript.isMobileApp = true;
            }
            else {
                LearningVideoMCQScript.isMobileApp = false;
            }
        }


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        var videouniqueid = LearningVideoMCQScript.getParameterByName('videouniqueid');      //e.currentTarget.getAttribute('videouniqueid');
        var UserId = userId;
        var VideoId = LearningVideoMCQScript.getParameterByName('videoid'); // e.currentTarget.getAttribute('data-videoid');

        var pagename = LearningVideoMCQScript.getParameterByName('pagename');
        var lessionid = LearningVideoMCQScript.getParameterByName('lessionid');
      //  alert(lessionid)
        LearningVideoMCQScript.pagename = pagename;
        LearningVideoMCQScript.lessionid = lessionid;


        LearningVideoMCQScript.videoId = VideoId
        LearningVideoMCQScript.UserPid = userId;
        let newDiv = document.createElement("div");

        newDiv.id = "DivMCQPanel";
        document.getElementById('DivMCQLayout').appendChild(newDiv);
        const createResponseVue = (0,vue_cjs.createApp)(VideoLearningMCQ, { VideoId: VideoId, UserPid: UserId, videouniqueid: videouniqueid,pagename:pagename,lessionid:lessionid });
        createResponseVue.mount('#DivMCQPanel');

    },

    SubmitVideoWatchedStatusResponse: function () {
        console.log('SubmitVideoWatchedStatusResponse')
    },

     
    backToActivityPage: function () {
        if (LearningVideoMCQScript.isMobileApp) {
            LearningVideoMCQScript.sulekhaApp.navigateTo(MainEnums_MobilePages.activity, null);

        }
        else{
            location.href = "/activity"
        }
    },
 

    backToHomePage: function (pagename="home") {
      //  router.push({ path: '/Home' })
        //location.href = "/Home"

        if (LearningVideoMCQScript.isMobileApp) {


            LearningVideoMCQScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null);

           // var rnd = LearningVideoMCQScript.getRandomNunber();


           // var rnd = LearningVideoMCQScript.getRandomNunber();
            //   var stateObj = { Title: "home" + rnd, Url: '/home' };
               //  history.pushState(stateObj, stateObj.Title, stateObj.Url);
   
            //    if (LearningVideoMCQScript.pagename == 'home') {
            //     LearningVideoMCQScript.sulekhaApp.navigateTo(MobilePages.home,null);
              
            //       } else {
            //         LearningVideoMCQScript.sulekhaApp.navigateTo(MobilePages.learningPlan,null);
            //       }
       
            // if (PaymentUpgradeRequestScript.sulekhaApp.RootPage == MobilePages.home || PaymentUpgradeRequestScript.sulekhaApp.RootPage == MobilePages.learningPlan) {
            //     WatchVideoScript.sulekhaApp.navigateTo(WatchVideoScript.sulekhaApp.RootPage, null);
            // }
            // else {state.RootPage
            //     PaymentUpgradeRequestScript.sulekhaApp.navigateBack(); 
            // }

            // var stateObj = { Title: "home" + rnd, Url: '/home' };
            // //  history.pushState(stateObj, stateObj.Title, stateObj.Url);
            // RefreshPage(stateObj)

            // history.replaceState({}, stateObj.Title, stateObj.Url);
            // history.pushState({}, stateObj.Title, stateObj.Url);
            // history.back();
            // history.forward();
        }
        else {
            location.href = "/home"
          ///  location.href = "/home"
        //   if(MyClub.rootpage=="home"){
        //     location.href = "/home"
        // }
        // else {
        //     location.href = "/LearningPlan"
        // }

          //
        }


    },

    loadnextvideo: function () {
        if (LearningVideoMCQScript.isMobileApp) {
            var rnd = LearningVideoMCQScript.getRandomNunber();
                  LearningVideoMCQScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo,{VideoId:LearningVideoMCQScript.videoId,rnd:rnd,loadnextvideo:'yes'});
         
           }
           else {
            location.href = "/WatchVideo?VideoId=" + LearningVideoMCQScript.videoId+"&loadnextvideo='yes'";
           }
    },


    backtoVideoPage: function () {

      //  router.push({ path: '/WatchVideo',query: {VideoId: LearningVideoMCQScript.videoId} })
     
     if (LearningVideoMCQScript.isMobileApp) {
        var rnd = LearningVideoMCQScript.getRandomNunber();
         LearningVideoMCQScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo,{VideoId:LearningVideoMCQScript.videoId,rnd:rnd,loadnextvideo:'no'});
     
       }
       else {
        location.href = "/WatchVideo?VideoId=" + LearningVideoMCQScript.videoId+"&loadnextvideo='no'";
       }

        
    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    // afterGetUserInfoLoad: function (response) {
    //    
    //     var userInfo = response.data;
    //     if (userInfo.clubUserType == 1) { // Limited one 
    //         if (userInfo.learningVideoLimitCount == 0) {
    //             location.href = "/PaymentUpgradeRequest"
    //         }
    //     }
    //     else {
    //         location.href = "/WatchVideo?VideoId=" + LearningVideoMCQScript.videoId;
    //     }

    // }
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

}




/* harmony default export */ const js_LearningVideoMCQScript = (LearningVideoMCQScript);
;// CONCATENATED MODULE: ./src/js/PaymentUpgradeRequestScript.js
﻿



var PaymentUpgradeRequestScript = {
    UserPid: '',
    isMobileApp: false,
    sulekhaApp: null,
    page: "home",
    previousPage: "home",
    init: function (userpid, sulekhaApp = null) {


        var hdnpage = document.getElementById("hdnPageType");

        if (hdnpage) {
            //  hdnpage.value=rootpage;
            js_MyClub.rootpage = hdnpage.value;
        }


        PaymentUpgradeRequestScript.sulekhaApp = sulekhaApp;
        //this.UserPid = document.getElementById("hdnUserPid").value;
        this.UserPid = userpid;


        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                PaymentUpgradeRequestScript.isMobileApp = true;
            }
            else {
                PaymentUpgradeRequestScript.isMobileApp = false;
            }
        }

        const cameFromDiv = document.getElementById("cameFrom")
        const params = new URLSearchParams(window.location.search)
        const pageType = parseInt(params.get('pageType')) || 0

        let content = ''
        switch (pageType) {
            case 1:
                this.previousPage = 'WatchVideo';
                content = '<p>You have reached your daily limit for watching video lessons in the Limited Plan.</p> <p>Upgrade to Capshine Pro and watch <b>unlimited video lessons.</b></p> <p>Get access to our other Pro features as well.</p>'
                break;
            case 2:
                this.previousPage = 'LiveClass';
                content = '<p>You have reached your weekly limit for watching Live Classes in the Limited Plan.</p> <p> Upgrade to Capshine Pro and attend more <b> Live Classes.</b></p> <p> Get access to our other Pro features as well.</p>'
                break;
            case 3:
                this.previousPage = 'TalkTime';
                content = '<p>You have reached your limit for Talk time sessions in the Limited Plan. </p> <p>Upgrade to Capshine Pro to get <b> unlimited speaking practice sessions.</b> </p> <p>Get access to our other Pro features as well.</p>'
                break;
            case 4:
                this.previousPage = 'StarSpeaker';
                content = '<p>You have reached your limit for Star Speaker sessions in the Limited Plan.</p> <p> Upgrade to Capshine Pro to participate in all Star Speaker sessions.</p> <p> Get access to our other Pro features as well.</p>'
                break;
            case 5:
                this.previousPage = 'FunFriday';
                content = '<p>You have reached your limit for Fun Fridays in the Limited Plan.</p> <p> Upgrade to Capshine Pro to improve your listening skills on Fun Fridays.</p> <p> Get access to our other Pro features as well.</p>'
                break;
            case 6:
                this.previousPage = 'quiz';
                content = '<p>You have reached your Daily Limit to play quiz in the Limited Plan. </p> <p>Upgrade to Capshine Pro and play <b> unlimited games.</b> </p> <p>Get access to our other Pro features as well.</p>'
                break;
            case 7:
                this.previousPage = 'Activity';
                content = '<p>You are in Limited Plan. </p> <p>Upgrade to Capshine Pro to access <b> all the Daily Acitvities</b> that you have missed or completed.</p> <p> Get access to our other Pro features as well.</p>'
                break;
            case 8:
                this.previousPage = 'FillintheGap';
                content = '<p>You have reached your Daily Limit to play Fill in the Gap in the Limited Plan. </p> <p>Upgrade to Capshine Pro and play <b> unlimited games.</b> </p> <p>Get access to our other Pro features as well.</p>'
                break;
              
            case 9:
                this.previousPage = 'WatchShortVideo';
                content = '<p>You have reached your daily limit for watching short videos in the Limited Plan.</p> <p>Upgrade to Capshine Pro and watch <b>unlimited short videos.</b></p> <p>Get access to our other Pro features as well.</p>'
                break;
			case 10:
				this.previousPage = 'Talktime';
				content = '<p>You have reached the limit for booking talk-time sessions under FREE Plan. </p> <p>Upgrade to Capshine Pro to <b>book unlimited talk-time sessions</b>. </p> <p>Get access to our other Pro features as well.</p>'
				break;
           
            default:
                content = '<p>You are in Limited Plan. </p> <p>Upgrade to Capshine Pro to access <b> all the Daily Acitvities</b> that you have missed or completed. </p> <p>Get access to our other Pro features as well.</p>'
        }
        GATrack.pushValues('gtm.load', PaymentUpgradeRequestScript.previousPage, 'impression');
        cameFromDiv.innerHTML = content

        var hdnpage = document.getElementById("hdnPageType");

        var shortvideo = window.localStorage.getItem('backpage');

        if (shortvideo) {
            //PaymentUpgradeRequestScript.pagename = "shortvideos"; shortvideobackpage ?
            if (shortvideo == "videos") {
                PaymentUpgradeRequestScript.pagename = "videos";
            }
            else if (shortvideo == "watchedvideoLesson") {
                PaymentUpgradeRequestScript.pagename = "watchedvideoLesson";
            }
            else if (shortvideo == "videolessons") {
                PaymentUpgradeRequestScript.pagename = "videolessons"
            }
            else //if (shortvideo == "home") 
            {
                PaymentUpgradeRequestScript.pagename = "home";
            }

        }
        else {
            PaymentUpgradeRequestScript.pagename = "home";
        }

        //    else  if (hdnpage) {
        //         if (hdnpage.value == 'Home')
        //             PaymentUpgradeRequestScript.pagename = "home";
        //         else if (hdnpage.value == 'LearningPlan')
        //             PaymentUpgradeRequestScript.pagename = "learningplan";
        //     }


        let btnPaymentupgradeB = document.getElementById("btnUpgrade");
        if (btnPaymentupgradeB) {
            btnPaymentupgradeB.addEventListener('click', (event) => {
                //  location.href = "/paymentplans"
                GATrack.pushValues('paywall_Upgrade', PaymentUpgradeRequestScript.previousPage + '_upgrade', 'Click_paywall_Upgrade');

                if (PaymentUpgradeRequestScript.isMobileApp == true) {

                    // location.href = "/PaymentUpgradeRequest"
                    var rnd = PaymentUpgradeRequestScript.getRandomNunber();
                    //   var stateObj = { Title: "paymentplans" + rnd, Url:'/paymentplans' };
                    //  RefreshPage(stateObj)
                    PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null)



                }
                else {
                    location.href = "/paymentplans"
                }
            })
        }

        let btnCancelUpgrade = document.getElementById("btnCancelUpgrade");

        if (btnCancelUpgrade) {

            btnCancelUpgrade.addEventListener('click', (event) => {
                GATrack.pushValues('paywall_notnow', PaymentUpgradeRequestScript.previousPage + '_notnow', 'Click_paywall_notnow');

                // location.href = "/Home"
                event.stopPropagation();

                var shortvideo = window.localStorage.getItem('backpage');

                if (PaymentUpgradeRequestScript.isMobileApp == true) {

                    if (shortvideo) {

                        if (shortvideo == "videos") {
                            PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                        }
                        else if (shortvideo == "videolessons") {
                            PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
                        }
                        else if (shortvideo == "watchedvideoLesson") {
                            PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos, { atab: 'shortvideo' });
                        }
                        else {
                            PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                        }


                    }

                    else if (PaymentUpgradeRequestScript.sulekhaApp.state.rootPage != MainEnums_MobilePages.unknown) {
                        PaymentUpgradeRequestScript.sulekhaApp.navigateTo(PaymentUpgradeRequestScript.sulekhaApp.state.rootPage, null);
                        PaymentUpgradeRequestScript.sulekhaApp.state.rootPage = MainEnums_MobilePages.unknown
                    } else {
                        PaymentUpgradeRequestScript.sulekhaApp.navigateBack();
                    }
                    // if (PaymentUpgradeRequestScript.sulekhaApp.state.rootPage == MobilePages.home || PaymentUpgradeRequestScript.sulekhaApp.state.rootPage == MobilePages.learningPlan) {
                    //     PaymentUpgradeRequestScript.sulekhaApp.navigateTo(PaymentUpgradeRequestScript.sulekhaApp.state.rootPage, null);
                    // }
                    // else {
                    //     PaymentUpgradeRequestScript.sulekhaApp.navigateBack();
                    // }

                }
                else {
                    //  history.back();
                    //location.href = "/Home"
                    if (shortvideo) {
                        if (shortvideo == "videos") {
                            location.href = "/videos"
                        }
                        else if (shortvideo == "videolessons") {
                            location.href = "/videolessons"
                        }
                        else if (shortvideo == "watchedvideoLesson") {
                            location.href = "/watchedvideos?atab=shortvideo"

                        }
                    }
                    else {
                        if (js_MyClub.rootpage == "home" || js_MyClub.rootpage == "learningplan") {
                            location.href = "/home"
                        }
                        else {
                            history.back();
                        }
                    }

                }
                // if (shortvideo == "videos") {
                //     location.href = "/shortvideos"
                // }
                // else if (MyClub.rootpage == "home" || MyClub.rootpage == "learningplan") {
                //     location.href = "/home"
                // }
                // else {
                //     history.back();
                // }

                // else   if (MyClub.rootpage == "home" || MyClub.rootpage == "learningplan") {
                //     if (MyClub.rootpage == "home") {
                //         location.href = "/home"
                //     }
                //     else {
                //         location.href = "/LearningPlan"
                //     }
                // }
                // else {
                //     history.back();
                // }



            })
        }



        let btnclosePayment = document.getElementById("btnclosePaymentScript");

        if (btnclosePayment) {
            btnclosePayment.addEventListener('click', (event) => {

                GATrack.pushValues('paywall_close', PaymentUpgradeRequestScript.previousPage + '_close', 'Click_paywall_close');
                //  location.href = "/paymentplans"
                event.stopPropagation();


                if (PaymentUpgradeRequestScript.isMobileApp == true) {
                    // location.href = "/PaymentUpgradeRequest"
                    //  var rnd = PaymentUpgradeRequestScript.getRandomNunber();
                    // //    var stateObj = { Title: "Home" + rnd, Url:'/Home' };
                    // if (PaymentUpgradeRequestScript.pagename == 'home') {      
                    //     PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MobilePages.home, null);

                    // } else {
                    //       PaymentUpgradeRequestScript.sulekhaApp.navigateTo(MobilePages.learningPlan, null);
                    // } 

                    // PaymentUpgradeRequestScript.sulekhaApp.navigateBack();
                    // Redirect to home if the use came from quiz
                    if (PaymentUpgradeRequestScript.sulekhaApp.state.rootPage != MainEnums_MobilePages.unknown) {
                        PaymentUpgradeRequestScript.sulekhaApp.navigateTo(PaymentUpgradeRequestScript.sulekhaApp.state.rootPage, null);
                        PaymentUpgradeRequestScript.sulekhaApp.state.rootPage = MainEnums_MobilePages.unknown
                    } else {
                        PaymentUpgradeRequestScript.sulekhaApp.navigateBack();
                    }

                    // if (PaymentUpgradeRequestScript.sulekhaApp.state.rootPage == MobilePages.home || PaymentUpgradeRequestScript.sulekhaApp.state.rootPage == MobilePages.learningPlan) {
                    //     PaymentUpgradeRequestScript.sulekhaApp.navigateTo(PaymentUpgradeRequestScript.sulekhaApp.state.rootPage, null);
                    //     PaymentUpgradeRequestScript.sulekhaApp.state.rootPage = null
                    // }
                    // else {
                    //     PaymentUpgradeRequestScript.sulekhaApp.navigateBack();
                    // }

                }
                else {

                    if (js_MyClub.rootpage == "home" || js_MyClub.rootpage == "learningplan") {
                        if (js_MyClub.rootpage == "home") {
                            location.href = "/home"
                        }
                        else {
                            location.href = "/LearningPlan"
                        }
                    }
                    else {
                        history.back();
                    }

                    // if (MyClub.rootpage == "home") {
                    //     location.href = "/home"
                    // }
                    // else {
                    //     location.href = "/LearningPlan"
                    // }
                    //history.back();
                    // if (PaymentUpgradeRequestScript.pagename == 'home') {
                    //    location.href = "/Home"
                    // }
                    // else  {
                    //     location.href = "/LearningPlan"
                    // }
                }
            })

        }




    },
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },


}

/* harmony default export */ const js_PaymentUpgradeRequestScript = (PaymentUpgradeRequestScript);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/LoginWeb.vue?vue&type=template&id=4e8fab9c&ts=true

function LoginWebvue_type_template_id_4e8fab9c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Login = (0,vue_cjs.resolveComponent)("Login");
    const _component_ClubRegistration = (0,vue_cjs.resolveComponent)("ClubRegistration");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
        (_ctx.showLogin)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_Login, {
                key: 0,
                showSignUpPopup: _ctx.showSignUpPopup,
                setUserInfo: _ctx.setUserInfo
            }, null, 8, ["showSignUpPopup", "setUserInfo"]))
            : (0,vue_cjs.createCommentVNode)("", true),
        (_ctx.showSignUp)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_ClubRegistration, {
                key: 1,
                pageSource: 'Web',
                isSignUpPage: _ctx.showSignUp,
                showLoginPopup: _ctx.showLoginPopup,
                setUserInfo: _ctx.setUserInfo,
                skipIntroScreen: _ctx.skipSignupIntroScreen,
                closeSignUpPopup: _ctx.closeSignUpPopup
            }, null, 8, ["isSignUpPage", "showLoginPopup", "setUserInfo", "skipIntroScreen", "closeSignUpPopup"]))
            : (0,vue_cjs.createCommentVNode)("", true)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/LoginWeb.vue?vue&type=template&id=4e8fab9c&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Login.vue?vue&type=template&id=65bc1f70&ts=true

const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_1 = { class: "sk-panel show step-slider" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_2 = { class: "sk-inner sign-in" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_3 = { class: "sk-body no-scroll auto-nav" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_4 = {
    class: "current-slide",
    ref: "mobileNoScreen"
};
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_5 = { class: "slide-content align-center" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_6 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("img", {
    class: "app-bird align-center",
    src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/capshine-app-logo.svg"
}, null, -1);
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_7 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("h2", null, "Welcome back!", -1);
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_8 = { class: "text-field mobile-number" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_9 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("span", { class: "error-text" }, "Enter a valid phone number", -1);
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_10 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("small", null, [
    /*#__PURE__*/ (0,vue_cjs.createElementVNode)("svg", {
        width: "9",
        height: "5",
        viewBox: "0 0 9 5",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconchevrondown" })
    ])
], -1);
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_11 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("There is no account associated with ");
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_12 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("br", null, null, -1);
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_13 = { class: "align-center mt-2" };
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_14 = /*#__PURE__*/ (0,vue_cjs.createTextVNode)("Don't have an account? ");
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_15 = {
    class: "next-slide",
    ref: "otpScreen"
};
const Loginvue_type_template_id_65bc1f70_ts_true_hoisted_16 = { class: "slide-content otp-number" };
function Loginvue_type_template_id_65bc1f70_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Countrycode = (0,vue_cjs.resolveComponent)("Countrycode");
    const _component_Otp = (0,vue_cjs.resolveComponent)("Otp");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_2, [
            (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_3, [
                (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_4, [
                    (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_5, [
                        Loginvue_type_template_id_65bc1f70_ts_true_hoisted_6,
                        Loginvue_type_template_id_65bc1f70_ts_true_hoisted_7,
                        (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_8, [
                            (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                                type: "text",
                                placeholder: "Enter your phone number",
                                required: "",
                                pattern: "[0-9]*",
                                inputmode: "numeric",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.mobileNumber) = $event)),
                                onKeyup: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.hideErrorText && _ctx.hideErrorText(...args))),
                                ref: "mobileInput"
                            }, null, 544), [
                                [vue_cjs.vModelText, _ctx.mobileNumber]
                            ]),
                            Loginvue_type_template_id_65bc1f70_ts_true_hoisted_9,
                            (0,vue_cjs.createElementVNode)("h6", {
                                class: "country-code",
                                value: "Show DIV",
                                id: "bt",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.openCountrySearch && _ctx.openCountrySearch(...args)))
                            }, [
                                (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(_ctx.countryCode), 1),
                                Loginvue_type_template_id_65bc1f70_ts_true_hoisted_10
                            ])
                        ]),
                        (0,vue_cjs.createElementVNode)("div", {
                            class: (0,vue_cjs.normalizeClass)({ 'hide': !_ctx.showCountrySearch })
                        }, [
                            (0,vue_cjs.createVNode)(_component_Countrycode, {
                                onCountryCodeBlur: _ctx.onCountryCodeBlur,
                                selectionCallBack: _ctx.countryCodeSelectionCallBack,
                                shouldFocus: _ctx.showCountrySearch
                            }, null, 8, ["onCountryCodeBlur", "selectionCallBack", "shouldFocus"])
                        ], 2),
                        (0,vue_cjs.createElementVNode)("p", {
                            class: (0,vue_cjs.normalizeClass)(["no-account", { 'hide': !_ctx.showNoAccountError }])
                        }, [
                            Loginvue_type_template_id_65bc1f70_ts_true_hoisted_11,
                            Loginvue_type_template_id_65bc1f70_ts_true_hoisted_12,
                            (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)(_ctx.countryCode) + " " + (0,vue_cjs.toDisplayString)(_ctx.mobileNumber) + ". Click on Sign up to register", 1)
                        ], 2),
                        (0,vue_cjs.createElementVNode)("button", {
                            type: "button",
                            class: "button primary medium block login-btn",
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.onClickContinue()))
                        }, " Login "),
                        (0,vue_cjs.createElementVNode)("p", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_13, [
                            Loginvue_type_template_id_65bc1f70_ts_true_hoisted_14,
                            (0,vue_cjs.createElementVNode)("a", {
                                class: "signup",
                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showSignUpPopup()))
                            }, "Sign up")
                        ])
                    ])
                ], 512),
                (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_15, [
                    (0,vue_cjs.createElementVNode)("div", Loginvue_type_template_id_65bc1f70_ts_true_hoisted_16, [
                        (0,vue_cjs.createVNode)(_component_Otp, {
                            mobileNumber: _ctx.mobileNumber,
                            countryCode: _ctx.countryCode,
                            initOtpTimer: _ctx.initOtpTimer,
                            onSuccess: _ctx.loginSuccess,
                            resendOtp: _ctx.requestForOtp,
                            onClickBack: _ctx.onClickBack
                        }, null, 8, ["mobileNumber", "countryCode", "initOtpTimer", "onSuccess", "resendOtp", "onClickBack"])
                    ])
                ], 512)
            ])
        ])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/Login.vue?vue&type=template&id=65bc1f70&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/Login.vue?vue&type=script&lang=ts




/* harmony default export */ const Loginvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'CapshineLogin',
    components: { Countrycode: CountryCode, Otp: Otp },
    props: {
        showSignUpPopup: { type: Function, required: true },
        setUserInfo: { type: Function, required: true }
    },
    setup() {
        return {
            pageHtml: (0,vue_cjs.ref)('...loading')
        };
    },
    data() {
        return {
            regexp: {
                alpha: /[a-zA-Z ]{2,30}$/,
                number: /[^0-9]/g,
                email: /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i,
                mobile1: /^[9|7|6|8]\d{8}[\d{1}]$/i,
                internationalmobile: /^[0-9]{6,14}$/
            },
            mobileNumber: "",
            showCountrySearch: false,
            countryCode: "+91",
            initOtpTimer: false,
            isAlreadyCapshineUser: false,
            isAlreadyClubMember: false,
            userpid: false,
            showNoAccountError: false
        };
    },
    mounted() {
        this.$refs.mobileInput.focus();
        //CSMainAPIs.Capshine.APIs.GetTermsContent.execute({}, this.apiResponse);
    },
    methods: {
        //apiResponse(response: any) {
        //	if (response.res.status != 200)
        //		return;
        //	this.pageHtml = response.data;
        //},
        loginSuccess: function () {
            this.setUserInfo(this.mobileNumber, "");
        },
        checkIfAlreadyRegistered: async function () {
            return new Promise((resolve) => {
                CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ mobileNumber: this.mobileNumber }, (response) => {
                    if (response.data && response.data.pid) {
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                });
            });
        },
        onCountryCodeBlur: function () {
            this.showCountrySearch = false;
        },
        openCountrySearch: function () {
            this.showCountrySearch = !this.showCountrySearch;
        },
        countryCodeSelectionCallBack(countrycode) {
            this.showCountrySearch = false;
            this.countryCode = countrycode;
        },
        requestForOtp: async function () {
            let requestData = {
                MobileNumber: this.mobileNumber,
                CountryCode: this.countryCode,
            };
            // this.initOtpTimer = false;
            return new Promise((resolve) => {
                CSMainAPIs.Capshine.APIs.SendOtp.execute(requestData, (response) => {
                    if (response.data.mobileVerificationStatus == "VerificationCodeSent") {
                        this.initOtpTimer = true;
                        resolve(true);
                    }
                    else if (response.data.mobileVerificationStatus == "Limit") {
                        resolve(false);
                    }
                });
            });
        },
        showErrorText: function (errorText) {
            let errorTextNode = this.$refs.mobileNoScreen.querySelector(".error-text");
            if (errorText) {
                errorTextNode.innerText = errorText;
            }
            errorTextNode?.classList.add("show");
        },
        hideErrorText: function () {
            let textNode = this.$refs.mobileNoScreen.querySelector(".error-text");
            if (textNode) {
                textNode.classList.remove("show");
            }
            this.showNoAccountError = false;
        },
        isValidMobileNumber(mobileno, countrycode) {
            if (countrycode == undefined || countrycode == "" || countrycode == "91" || countrycode == "+91") {
                return (this.regexp.mobile1.test(mobileno));
            }
            else {
                return (this.regexp.internationalmobile.test(mobileno));
            }
        },
        moveToNextScreen: function () {
            //if ((this.currentStepCount + 1) <= Object.entries(this.availableScreens).length) {
            //	let currentSlide = this.$refs[`step${this.currentStepCount}`];
            //	let nextSlide = this.$refs[`step${this.currentStepCount + 1}`];
            //	currentSlide.classList.replace("current-slide", "previous-slide");
            //	nextSlide.classList.replace("next-slide", "current-slide");
            //	this.currentStepCount++;
            //	this.currentStepName = Object.entries(this.availableScreens)[this.currentStepCount - 1][0];
            //}
        },
        onClickContinue: async function () {
            if (!this.isValidMobileNumber(this.mobileNumber, this.countryCode)) {
                this.showErrorText("Invalid Phone Number");
                return;
            }
            let hasAccount = await this.checkIfAlreadyRegistered();
            if (!hasAccount) {
                this.showNoAccountError = true;
                return;
            }
            let canMove = await this.requestForOtp();
            if (canMove) {
                this.$refs.mobileNoScreen.classList.replace("current-slide", "previous-slide");
                this.$refs.otpScreen.classList.replace("next-slide", "current-slide");
            }
            else
                this.showErrorText("Maximum Limit Reached");
        },
        onClickBack: function () {
            this.$refs.mobileNoScreen.classList.replace("previous-slide", "current-slide");
            this.$refs.otpScreen.classList.replace("current-slide", "next-slide");
            this.initOtpTimer = false;
            this.$refs.mobileInput.focus();
        },
    }
}));

;// CONCATENATED MODULE: ./src/Components/Login.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/Login.vue




;
const Login_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Loginvue_type_script_lang_ts, [['render',Loginvue_type_template_id_65bc1f70_ts_true_render]])

/* harmony default export */ const Login = (Login_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/LoginWeb.vue?vue&type=script&lang=ts





/* harmony default export */ const LoginWebvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'LoginWeb',
    components: { Login: Login, ClubRegistration: ClubRegistration },
    //props: {
    //	showSignUpPopup: { type: Function },
    //	setUserInfo: { type: Function }
    //},
    data() {
        return {
            showLogin: true,
            showSignUp: false,
            skipSignupIntroScreen: true
        };
    },
    methods: {
        showLoginPopup: function () {
            this.showLogin = true;
            this.showSignUp = false;
        },
        showSignUpPopup: function () {
            GATrack.pushValues('intro-Signup', 'Signup', 'Click_signup');
            this.showSignUp = true;
            this.showLogin = false;
        },
        closeSignUpPopup: function () {
            this.showSignUp = false;
            this.showLogin = true;
        },
        setUserInfo(mobileNumber, userPid) {
            var apiInput = {
                "Mobilenumber": mobileNumber,
                "UserPid": userPid != "" && userPid != "0" ? userPid : "",
                "LoginUser": true
            };
            CSMainAPIs.Capshine.APIs.GetUserInfo.execute(apiInput, this._afterGetUserInfoLoad);
        },
        async _afterGetUserInfoLoad(response) {
            const userResponseData = response.data;
            if (userResponseData.pid > 0) {
                if (!userResponseData.clubId) {
                    this.skipSignupIntroScreen = false;
                    this.showSignUpPopup();
                }
                else {
                    var clubUserType = userResponseData.clubUserType;
                    var clubUserLevel = userResponseData.clubUserLevel;
                    // TODO: Uncomment these lines if the login popup needs to be updated.
                    // const upsertCapshineDeviceLogin = async() => {
                    // 	const getIp = async (): Promise<string> => {
                    // 		const x=await fetch('https://api.ipify.org?format=json');
                    // 		const { ip }=await x.json();
                    // 		return ip;
                    // 	}
                    // 	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // 	// @ts-ignore 
                    // 	const uuid = crypto.randomUUID();
                    // 	window.localStorage.setItem("session-id", uuid);
                    // 	const data = {
                    // 		UserPid: userResponseData.pid,
                    // 		DeviceId: uuid,
                    // 		SessionId: uuid,
                    // 		Source: "web",
                    // 		DeviceIp: await getIp(),
                    // 		IsLoggedIn: true
                    // 	}
                    // 	return new Promise ((resolve, reject) => {
                    // 		CSMainAPIs.Capshine.APIs.UpsertCapshineDeviceLogin.execute(data, (resp)=> {
                    // 			resolve(resp.data)
                    // 		})
                    // 	})
                    // }
                    // await upsertCapshineDeviceLogin()
                    // if (clubUserLevel == "0") {
                    // 	window.location.href = "/englishassesment";
                    // } else 
                    if (clubUserType == "0") {
                        window.location.href = "/paymentplans";
                    }
                    else {
                        var nextUrl = this.getQueryStringValue('nexturl');
                        if (nextUrl) {
                            window.location.href = nextUrl;
                        }
                        else {
                            window.location.href = "/";
                        }
                    }
                }
            }
        },
        getQueryStringValue: function (id) {
            const urlSearchParams = new URLSearchParams(window.location.search);
            if (urlSearchParams)
                return urlSearchParams.get(id);
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/LoginWeb.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/LoginWeb.vue




;
const LoginWeb_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(LoginWebvue_type_script_lang_ts, [['render',LoginWebvue_type_template_id_4e8fab9c_ts_true_render]])

/* harmony default export */ const LoginWeb = (LoginWeb_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/AssessYourEnglish.vue?vue&type=template&id=54e6d888&ts=true

function AssessYourEnglishvue_type_template_id_54e6d888_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MCQ = (0,vue_cjs.resolveComponent)("MCQ");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_MCQ, {
        id: "mcq",
        basicDetails: _ctx.mcqBasicDetails,
        field: _ctx.field,
        showThankyou: _ctx.showThankyou,
        startMcq: _ctx.startMcq,
        playNextQuiz: _ctx.playNextQuiz
    }, null, 8, ["basicDetails", "field", "showThankyou", "startMcq", "playNextQuiz"]));
}

;// CONCATENATED MODULE: ./src/Components/AssessYourEnglish.vue?vue&type=template&id=54e6d888&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/AssessYourEnglish.vue?vue&type=script&lang=ts






/* harmony default export */ const AssessYourEnglishvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: 'AssessYourEnglish',
    components: { MCQ: Mcq },
    props: {
        userPid: { type: Number, default: 0 }
    },
    setup() {
        return {
            mcqBasicDetails: new McqBasicDetails({
                mcqType: McqTypeOption.AssessYourEnglish,
                title: "Level Test",
                introScreen: new IntroScreenContent({
                    heading: "Take this 5 mins test to know your language level.<p>A simple and a quick MCQ test!</p>",
                    hasSkipButton: true,
                    instructionList: [
                        "to check your language level",
                        "to get level appropriate lessons",
                        "to learn using the right content"
                    ],
                    content: '',
                }),
            })
        };
    },
    data() {
        return {
            field: new McqField(),
            userInfo: null,
        };
    },
    beforeMount() {
        var curUserPid = this.userPid.toString();
        if (curUserPid == "" || curUserPid == "0") {
            if (document.getElementById('hdnUserPid'))
                curUserPid = document.getElementById('hdnUserPid').value;
        }
        if (curUserPid != "" && curUserPid != "0")
            CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": curUserPid }, this._afterGetUserInfoLoad);
    },
    methods: {
        _afterGetUserInfoLoad(response) {
            this.mcqBasicDetails.userInfo = this.userInfo = response.data;
        },
        apiResponse(response) {
            if (response.res.status != 200)
                return;
            var mcqList = JSON.parse(JSON.stringify(response.data));
            this.field = new McqField({ mcqList: mcqList });
        },
        startMcq() {
            CSMainAPIs.Capshine.APIs.GetDiagnosticTestQuestions.execute({}, this.apiResponse);
        },
        showThankyou() {
            var correctAnswerCount = this.field ? this.field.answerList.filter(item => item.isCorrectAnswer == true).length : 0;
            var level = correctAnswerCount <= 9 ? "Beginner" : correctAnswerCount <= 15 ? "Intermediate" : "Advanced";
            GATrack.pushValues('assess_level_thankyou', level + '_' + correctAnswerCount, 'submit_assess_level_thankyou');
            //if (this.mcqBasicDetails.mcqType == McqTypeOption.AssessYourEnglish)
            this.saveEnglishAssesmentTestResult();
        },
        playNextQuiz() {
            window.location.href = "/paymentplans";
        },
        saveEnglishAssesmentTestResult: function () {
            var dto = [];
            this.field.answerList.forEach(anw => {
                dto.push({
                    "QuestionId": anw.questionId,
                    "UserPid": this.mcqBasicDetails.userInfo.pid,
                    "Answer": anw.answer,
                    "IsCorrectAnswer": anw.isCorrectAnswer
                });
            });
            CSMainAPIs.Capshine.APIs.InsertDiagnosticTestResult.execute({
                "UserPid": this.mcqBasicDetails.userInfo.pid,
                "TestResult": dto
            }, (response) => { });
        }
    }
}));

;// CONCATENATED MODULE: ./src/Components/AssessYourEnglish.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/AssessYourEnglish.vue




;
const AssessYourEnglish_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AssessYourEnglishvue_type_script_lang_ts, [['render',AssessYourEnglishvue_type_template_id_54e6d888_ts_true_render]])

/* harmony default export */ const AssessYourEnglish = (AssessYourEnglish_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/AllMcqBase.vue?vue&type=template&id=083481cc&ts=true

const AllMcqBasevue_type_template_id_083481cc_ts_true_hoisted_1 = { id: "all-mcq-base" };
function AllMcqBasevue_type_template_id_083481cc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MCQ = (0,vue_cjs.resolveComponent)("MCQ");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", AllMcqBasevue_type_template_id_083481cc_ts_true_hoisted_1, [
        (_ctx.mcqBasicDetails)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_MCQ, {
                key: 0,
                id: "mcq",
                basicDetails: _ctx.mcqBasicDetails,
                field: _ctx.field,
                userName: _ctx.userInfo.firstName,
                showThankyou: _ctx.showThankyou,
                startMcq: _ctx.startMcq,
                playNextQuiz: _ctx.playNextQuiz,
                thankYouScreenGoBack: _ctx.thankYouScreenGoBack,
                sulekhaApp: _ctx.sulekhaApp,
                isMobileApp: _ctx.isMobileApp,
                playNo: _ctx.playNo,
                userPid: _ctx.userPid
            }, null, 8, ["basicDetails", "field", "userName", "showThankyou", "startMcq", "playNextQuiz", "thankYouScreenGoBack", "sulekhaApp", "isMobileApp", "playNo", "userPid"]))
            : (0,vue_cjs.createCommentVNode)("", true)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/AllMcqBase.vue?vue&type=template&id=083481cc&ts=true

;// CONCATENATED MODULE: ./src/ActivityPlaylistType.ts
var ActivityPlaylistType;
(function (ActivityPlaylistType) {
    ActivityPlaylistType[ActivityPlaylistType["Quiz"] = 1] = "Quiz";
    ActivityPlaylistType[ActivityPlaylistType["FillTheGap"] = 2] = "FillTheGap";
    ActivityPlaylistType[ActivityPlaylistType["JumbledSentence"] = 3] = "JumbledSentence";
    ActivityPlaylistType[ActivityPlaylistType["Meanings"] = 4] = "Meanings";
})(ActivityPlaylistType || (ActivityPlaylistType = {}));
/* harmony default export */ const src_ActivityPlaylistType = (ActivityPlaylistType);

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/AllMcqBase.vue?vue&type=script&lang=ts










/* harmony default export */ const AllMcqBasevue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "AllMcqBase",
    components: { MCQ: Mcq },
    props: {
        mcqType: { type: Number, required: true },
        userPid: { type: Number, required: true },
        userName: { type: String, default: "User" },
        //clubUserLevel: { type: Number, default: 0 },
        videoId: { type: Number, default: 0 },
        videoUniqueId: { type: Number, default: 0 },
        sulekhaApp: { type: null },
        playNo: { type: Number, default: 0 },
    },
    data() {
        return {
            mcqBasicDetails: null,
            field: null,
            userInfo: {},
            isMobileApp: false,
        };
    },
    beforeMount() {
        var hdnIsMobileApp = document.getElementById("hdnIsMobileApp");
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                this.isMobileApp = true;
            }
            else {
                this.isMobileApp = false;
            }
        }
        var curUserPid = this.userPid.toString();
        if (curUserPid == "" || curUserPid == "0") {
            if (document.getElementById("hdnUserPid"))
                curUserPid = document.getElementById("hdnUserPid")
                    .value;
        }
        if (curUserPid != "" && curUserPid != "0")
            CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ UserPid: curUserPid }, this._afterGetUserInfoLoad);
    },
    mounted() {
        this.mcqBasicDetails = this.getBasicDetails();
    },
    watch: {
        userInfo: {
            handler: function (newVal) {
                this.mcqBasicDetails.userInfo = newVal;
            },
        },
    },
    methods: {
        _afterGetUserInfoLoad(response) {
            this.userInfo = response.data;
        },
        getBasicDetails() {
            switch (this.mcqType) {
                case McqTypeOption.Quiz:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.Quiz,
                        title: "Vocabulary Quiz",
                        introScreen: new IntroScreenContent({
                            heading: "<h2>This quiz contains</h2>",
                            hasSkipButton: false,
                            instructionList: [
                                "a sentence with an idiom in bold letters",
                                "a question",
                                "4 options",
                            ],
                            content: "<div class='quiz-instruction'><div class=''><h4>Earn 100 points for every right answer!</h4><p>No points for incorrect answers.</p></div><div class='caps-image-count'><svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 34.807 20.277'><use xlink:href='#captop'></use></svg><span class='quiz-badge-count-box'>100</span></div></div>",
                        }),
                        showSubmitButton: true,
                        showEarnedPoints: false,
                        showQuestionCount: true,
                        showProgressBar: true,
                    });
                case McqTypeOption.FillInTheGap:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.FillInTheGap,
                        title: "Fill the Gap",
                        introScreen: new IntroScreenContent({
                            heading: "<h2>Fill the Gap contains</h2>",
                            hasSkipButton: false,
                            instructionList: [
                                "a sentence with a missing word",
                                "4 options",
                            ],
                            content: "<div class='quiz-instruction'><div class=''><h4>Earn 100 points for every right answer!</h4><p>No points for incorrect answers.</p></div><div class='caps-image-count'><svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 34.807 20.277'><use xlink:href='#captop'></use></svg><span class='quiz-badge-count-box'>100</span></div></div>",
                        }),
                        showSubmitButton: true,
                        showEarnedPoints: false,
                        showQuestionCount: true,
                        showProgressBar: true,
                    });
                case McqTypeOption.AssessYourEnglish:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.AssessYourEnglish,
                        title: "Level Test",
                        introScreen: new IntroScreenContent({
                            heading: "<h2>Take this 5 mins test to know your language level.</h2><p>A simple and a quick MCQ test!</p>",
                            hasSkipButton: true,
                            instructionList: [
                                "to check your language level",
                                "to get level appropriate lessons",
                                "to learn using the right content",
                            ],
                            content: "",
                        }),
                        showProgressBar: true,
                    });
                case McqTypeOption.VideoLearning:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.VideoLearning,
                        title: "Practice Test on Video",
                        showIntroScreen: false,
                        showProgressBar: true,
                    });
                // case McqTypeOption.JobInterviewCourse:
                // 	return new McqBasicDetails({
                // 		mcqType: McqTypeOption.JobInterviewCourse,
                // 		title: "Practice Test on Video",
                // 		showIntroScreen: false,
                // 		showProgressBar: true,
                // 	});
                case McqTypeOption.JumbledSentence:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.JumbledSentence,
                        title: "Jumbled Sentence",
                        introScreen: new IntroScreenContent({
                            heading: "<h2>Frame a meaningful sentence using the jumbled words.</h2>",
                            hasSkipButton: false,
                            instructionList: [
                                "Note the number of words required to get the right answer.",
                                "Click on a word in the order you think is right to frame a sentence.",
                                "To remove a selected word, click again on the same word."
                            ],
                            content: "<div class='quiz-instruction'><div class=''><h4>Earn 20 points for every right answer!</h4><p>No points for incorrect answers.</p></div><div class='caps-image-count'><svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 34.807 20.277'><use xlink:href='#captop'></use></svg><span class='quiz-badge-count-box'>20</span></div></div>",
                        }),
                        showSubmitButton: true,
                        showEarnedPoints: false,
                        showQuestionCount: true,
                        showProgressBar: true,
                    });
                case McqTypeOption.Meanings:
                    return new McqBasicDetails({
                        mcqType: McqTypeOption.Meanings,
                        title: "Meanings",
                        introScreen: new IntroScreenContent({
                            heading: "<h2>Meanings </h2>",
                            hasSkipButton: false,
                            instructionList: [
                                "Find the meanings for the given words.",
                                "Choose the correct answer from the options given.",
                                "Complete the game by answering 10 questions to earn rewards.",
                            ],
                            content: "<div class='quiz-instruction'><div class=''><h4>Earn 10 points for every right answer!</h4><p>No points for incorrect answers.</p></div><div class='caps-image-count'><svg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 34.807 20.277'><use xlink:href='#captop'></use></svg><span class='quiz-badge-count-box'>10</span></div></div>",
                        }),
                        showSubmitButton: false,
                        showBottomExplanation: true,
                        showEarnedPoints: false,
                        showQuestionCount: true,
                        showProgressBar: true,
                    });
            }
        },
        apiResponse(response) {
            if (response.res.status != 200)
                return;
            var mcqList = JSON.parse(JSON.stringify(response.data));
            this.field = new McqField({ mcqList: mcqList });
        },
        async startMcq() {
            const curUserPid = this.userPid.toString();
            let deviceName;
            let deviceId;
            if (this.isMobileApp) {
                deviceName = await Device.getInfo();
                deviceId = (await Device.getId()).uuid;
            }
            switch (this.mcqType) {
                case McqTypeOption.Quiz:
                    GATrack.pushValues('Start_' + McqTypeOption[this.mcqType] + ' Q1', 'Play_' + McqTypeOption[this.mcqType] + ' Q1', 'Click Start Now');
                    CSMainAPIs.Capshine.APIs.GetQuizQuestions.execute({ UserPid: this.userPid }, this.apiResponse);
                    break;
                case McqTypeOption.FillInTheGap:
                    GATrack.pushValues('Start_' + McqTypeOption[this.mcqType] + ' Q1', 'Play_' + McqTypeOption[this.mcqType] + ' Q1', 'Click Start Now');
                    CSMainAPIs.Capshine.APIs.GetFillintheBlanksQuestions.execute({ UserPid: this.userPid }, this.apiResponse);
                    break;
                case McqTypeOption.AssessYourEnglish:
                    GATrack.pushValues('assess_level_start', 'start_level_test', 'click_assess_level_start');
                    CSMainAPIs.Capshine.APIs.GetDiagnosticTestQuestions.execute({}, this.apiResponse);
                    break;
                case McqTypeOption.VideoLearning:
                    GATrack.pushValues('MCQ_Q1', this.videoId + '_MCQ1', 'Click_MCQ_Q1');
                    //bindGA.pushValues('DEA_Fillthegap', 'Click_StartFillthegap',);
                    CSMainAPIs.Capshine.APIs.GetMCQQuestionAndAnswer.execute({ videoid: this.videoId }, this.apiResponse);
                    break;
                case McqTypeOption.JumbledSentence:
                    GATrack.pushValues('Start_' + McqTypeOption[this.mcqType] + ' Q1', 'Play_' + McqTypeOption[this.mcqType] + ' Q1', 'Click Start Now');
                    CSMainAPIs.Capshine.APIs.GetJumbledSentenceQuestions.execute({ UserPid: this.userPid }, this.apiResponse);
                    break;
                case McqTypeOption.Meanings:
                    GATrack.pushValues('Start_' + McqTypeOption[this.mcqType] + ' Q1', 'Play_' + McqTypeOption[this.mcqType] + ' Q1', 'Click Start Now');
                    CSMainAPIs.Capshine.APIs.GetMeanings.execute({ UserPid: this.userPid }, this.apiResponse);
                    break;
            }
        },
        async showThankyou() {
            switch (this.mcqType) {
                case McqTypeOption.Quiz:
                    GATrack.pushValues('DEA_Quiz_thankyou', this.playNo + '_' + (this.field.answerList.filter(item => item.isCorrectAnswer == true).length / this.field.answerList.length) * 100, 'Click_Quiz_thankyou');
                    this.saveQuizResult();
                    break;
                case McqTypeOption.FillInTheGap:
                    GATrack.pushValues('DEA_Fillthegap_thankyou', 'gap_' + this.playNo + '_' + (this.field.answerList.filter(item => item.isCorrectAnswer == true).length / this.field.answerList.length) * 100, 'Click_Fillthegap_thankyou');
                    this.saveFillintheBlanksResult();
                    break;
                case McqTypeOption.AssessYourEnglish:
                    var correctAnswerCount = this.field ? this.field.answerList.filter(item => item.isCorrectAnswer == true).length : 0;
                    var level = correctAnswerCount <= 9 ? "Beginner" : correctAnswerCount <= 15 ? "Intermediate" : "Advanced";
                    GATrack.pushValues('assess_level_thankyou', level + '_' + correctAnswerCount, 'submit_assess_level_thankyou');
                    this.saveEnglishAssesmentTestResult();
                    break;
                case McqTypeOption.VideoLearning:
                    GATrack.pushValues('MCQ_thankyou', 'MCQ_' + (this.field.answerList.filter(item => item.isCorrectAnswer == true).length / this.field.answerList.length) * 100, 'Click_MCQ_thankyou');
                    this.saveVideoLearningMcqResult();
                    break;
                case McqTypeOption.JumbledSentence:
                    GATrack.pushValues('Jumbledsentence_completed', 'Next Jumbled quiz', 'Play_nextJumbledquiz');
                    this.saveJumbledSentenceResult();
                    break;
                case McqTypeOption.Meanings:
                    GATrack.pushValues('Meanings_thankyou', 'Meanings_' + (this.field.answerList.filter(item => item.isCorrectAnswer == true).length / this.field.answerList.length) * 20, 'Click_Meanings_thankyou');
                    this.saveMeaningsResult();
                    break;
            }
        },
        async playNextQuiz() {
            var clubUserType = 0;
            if (this.userInfo) {
                clubUserType = this.userInfo.clubUserType;
            }
            var playType;
            switch (this.mcqType) {
                case McqTypeOption.Quiz:
                    playType = src_ActivityPlaylistType.Quiz;
                    GATrack.pushValues('Quiz_completed', "Next Quiz quiz", 'Play_nextquiz');
                    break;
                case McqTypeOption.FillInTheGap:
                    GATrack.pushValues('FillInTheGap_completed', "Next FillInTheGap quiz", 'Play_nextquiz');
                    playType = src_ActivityPlaylistType.FillTheGap;
                    break;
                case McqTypeOption.AssessYourEnglish:
                    if (this.isMobileApp) {
                        this.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
                    }
                    else {
                        window.location.href = "/paymentplans";
                    }
                    break;
                case McqTypeOption.JumbledSentence:
                    GATrack.pushValues('Jumbledsentence_completed', "Next Jumbled quiz", 'Play_nextjumbledquiz');
                    playType = src_ActivityPlaylistType.JumbledSentence;
                    break;
                case McqTypeOption.Meanings:
                    GATrack.pushValues('Meanings_completed', "Next Meaning quiz", 'Play_nextmeaningquiz');
                    playType = src_ActivityPlaylistType.Meanings;
                    break;
                case McqTypeOption.VideoLearning:
                    break;
            }
            if (this.mcqType != McqTypeOption.VideoLearning && this.mcqType != McqTypeOption.AssessYourEnglish) {
                if (clubUserType == 1) {
                    if (this.isMobileApp) {
                        this.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 6 });
                    }
                    else {
                        window.location.href = "/PaymentUpgradeRequest?pageType=6";
                    }
                }
                else {
                    if (this.isMobileApp) {
                        this.sulekhaApp.navigateTo(MainEnums_MobilePages.activityPlayList, { activityId: playType, playQuiz: parseInt(this.playNo) + 1 });
                    }
                    else {
                        window.location.href = `/activity/${playType}?playNo=${parseInt(this.playNo) + 1}`;
                    }
                }
            }
        },
        thankYouScreenGoBack: async function () {
            if (this.mcqType == McqTypeOption.Quiz || this.mcqType == McqTypeOption.FillInTheGap || this.mcqType === McqTypeOption.JumbledSentence || this.mcqType === McqTypeOption.Meanings) {
                GATrack.pushValues(this.mcqType + "_Completed" + " " + this.mcqType, 'Back to Activity', this.mcqType + "completed" + "_back to activity");
                if (this.isMobileApp) {
                    const UserAppReview = await new Promise((resolve, reject) => {
                        CSMainAPIs.Capshine.APIs.ShouldShowAppReview.execute({ UserPid: this.UserPid }, (data) => {
                            if (!data)
                                reject("Api failed");
                            resolve(data);
                        });
                    });
                    if (!UserAppReview.data.isPopupShown) {
                        await RateApp.requestReview().then(async () => {
                            await new Promise((resolve, reject) => {
                                CSMainAPIs.Capshine.APIs.SubmitAppReview.execute({ UserPid: this.UserPid }, (data) => {
                                    if (!data)
                                        reject("Api failed");
                                    resolve(data);
                                });
                            });
                        });
                    }
                    this.sulekhaApp.navigateTo(MainEnums_MobilePages.activity);
                }
                else {
                    window.location.href = `/activity`;
                }
            }
        },
        saveQuizResult: function () {
            var Result = [];
            this.field.answerList.forEach((anw) => {
                Result.push({
                    userPid: this.userPid,
                    WordId: anw.questionId,
                    Score: anw.pointsEarned,
                    answer: anw.answer,
                    isCorrectAnswer: anw.isCorrectAnswer,
                    QuizSummaryID: this.field.mcqList[0].groupId,
                });
            });
            CSMainAPIs.Capshine.APIs.InsertQuizResult.execute({
                Result,
            }, null);
        },
        saveFillintheBlanksResult: function () {
            var Result = [];
            this.field.answerList.forEach((anw) => {
                Result.push({
                    userPid: this.userPid,
                    WordId: anw.questionId,
                    Score: anw.pointsEarned,
                    answer: anw.answer,
                    isCorrectAnswer: anw.isCorrectAnswer,
                    QuizSummaryID: this.field.mcqList[0].groupId,
                });
            });
            CSMainAPIs.Capshine.APIs.InsertFillintheBlanksResult.execute({
                Result,
            }, null);
        },
        saveEnglishAssesmentTestResult: function () {
            var dto = [];
            if (this.field && this.field.answerList) {
                this.field.answerList.forEach((anw) => {
                    dto.push({
                        QuestionId: anw.questionId,
                        UserPid: this.userInfo.pid,
                        Answer: anw.answer,
                        IsCorrectAnswer: anw.isCorrectAnswer,
                    });
                });
            }
            CSMainAPIs.Capshine.APIs.InsertDiagnosticTestResult.execute({
                UserPid: this.userInfo.pid,
                TestResult: dto,
            }, null);
        },
        saveVideoLearningMcqResult: function () {
            var responseObj = {
                VideoId: this.videoId,
                UserPid: this.userPid,
                McqAnswer: this.field.answerList,
            };
            CSMainAPIs.Capshine.APIs.StoreVideoLearningMCQQuestionAndAnswer.execute(responseObj, null);
            var mcqStatusUpdateData = {
                UserPid: this.userPid,
                VideoId: this.videoId,
                VideoUniqueId: this.videoUniqueId,
            };
            CSMainAPIs.Capshine.APIs.SubmiMCQCompletedStatus.execute(mcqStatusUpdateData, null);
        },
        saveJumbledSentenceResult: function () {
            var Result = [];
            this.field.answerList.forEach((anw) => {
                Result.push({
                    QuestionId: anw.questionId,
                    answer: anw.answer,
                    Score: anw.pointsEarned,
                    isCorrectAnswer: anw.isCorrectAnswer
                });
            });
            CSMainAPIs.Capshine.APIs.InsertJumbledSentenceResult.execute({
                QuizSummaryID: this.field.mcqList[0].groupId,
                userPid: this.userPid,
                Result,
            }, null);
        },
        saveMeaningsResult: function () {
            var Result = [];
            this.field.answerList.forEach((anw) => {
                Result.push({
                    QuestionId: anw.questionId,
                    answer: anw.answer,
                    Score: anw.pointsEarned,
                    isCorrectAnswer: anw.isCorrectAnswer
                });
            });
            CSMainAPIs.Capshine.APIs.InsertMeaningsResult.execute({
                QuizSummaryID: this.field.mcqList[0].groupId,
                userPid: this.userPid,
                Result,
            }, null);
        }
    },
}));

;// CONCATENATED MODULE: ./src/Components/AllMcqBase.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/AllMcqBase.vue




;
const AllMcqBase_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AllMcqBasevue_type_script_lang_ts, [['render',AllMcqBasevue_type_template_id_083481cc_ts_true_render]])

/* harmony default export */ const AllMcqBase = (AllMcqBase_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/EditProfile.vue?vue&type=template&id=495ddcf5


const EditProfilevue_type_template_id_495ddcf5_hoisted_1 = {
  class: "sk-panel show edit-profile-page",
  id: "editProfileModal"
}
const EditProfilevue_type_template_id_495ddcf5_hoisted_2 = { class: "sk-inner" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_3 = { class: "sk-header" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_4 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  width: "20",
  height: "23",
  id: "back",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconbackarrow" })
], -1)
const EditProfilevue_type_template_id_495ddcf5_hoisted_5 = [
  EditProfilevue_type_template_id_495ddcf5_hoisted_4
]
const EditProfilevue_type_template_id_495ddcf5_hoisted_6 = { class: "sk-body no-scroll auto-nav" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_7 = { class: "current-slide" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_8 = { class: "slide-content" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_9 = { class: "title-xlarge" }
const EditProfilevue_type_template_id_495ddcf5_hoisted_10 = {
  key: 0,
  class: "text-field"
}
const EditProfilevue_type_template_id_495ddcf5_hoisted_11 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "error-text" }, "Please enter valid name", -1)

function EditProfilevue_type_template_id_495ddcf5_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pincode = (0,vue_cjs.resolveComponent)("Pincode")

  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_1, [
    (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_2, [
      (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_3, [
        (0,vue_cjs.createElementVNode)("div", {
          id: "showHeaderLeftNav",
          class: "left-nav",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.popUpClose()))
        }, EditProfilevue_type_template_id_495ddcf5_hoisted_5),
        (0,vue_cjs.createTextVNode)(" " + (0,vue_cjs.toDisplayString)(_ctx.editType), 1)
      ]),
      (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_6, [
        (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_7, [
          (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_8, [
            (0,vue_cjs.createElementVNode)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_9, "Change " + (0,vue_cjs.toDisplayString)(_ctx.editType), 1),
            (0,vue_cjs.createElementVNode)("p", null, "You can edit your " + (0,vue_cjs.toDisplayString)(_ctx.editType) + ".", 1),
            (_ctx.editType.toLowerCase()=='name')
              ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", EditProfilevue_type_template_id_495ddcf5_hoisted_10, [
                  (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                    type: "text",
                    placeholder: "Enter name",
                    "data-NameInput": "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.name) = $event))
                  }, null, 512), [
                    [vue_cjs.vModelText, _ctx.name]
                  ]),
                  EditProfilevue_type_template_id_495ddcf5_hoisted_11
                ]))
              : (0,vue_cjs.createCommentVNode)("", true),
            (_ctx.editType.toLowerCase()=='pincode')
              ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_Pincode, {
                  key: 1,
                  pincodeProp: _ctx.pincode,
                  selectionCallBack: _ctx.selectionCallBack
                }, null, 8, ["pincodeProp", "selectionCallBack"]))
              : (0,vue_cjs.createCommentVNode)("", true),
            (0,vue_cjs.createElementVNode)("button", {
              type: "button",
              class: (0,vue_cjs.normalizeClass)(["button primary medium block", _ctx.isBtnDisabled?'disabled':'']),
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.updateValueToDB()))
            }, " Continue ", 2)
          ])
        ])
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/EditProfile.vue?vue&type=template&id=495ddcf5

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/EditProfile.vue?vue&type=script&lang=js

	
	
	

	/* harmony default export */ const EditProfilevue_type_script_lang_js = ((0,vue_cjs.defineComponent)({
		name: 'CapshineEditProfile',
		components: { Pincode: Pincode },
		props: {
			editType: String,
			editValue: String,
			userpid: Number,
		},
		data() {
			return {
				regexp: {
					alpha: /[a-zA-Z ]{2,30}$/,
				},
				showError: false,
				errorText: '',
				pincode: '',
				name: '',
				isBtnDisabled: false,
				ref: null,
			}
		},
		mounted() {
			this.pincode = this.editValue;
			this.name = this.editValue;
			this.isValid();
		},
		methods: {
			selectionCallBack(value) {
				this.pincode = value;
				this.isValid();
			},
			isValid() {
				let returnVal = false;
				if (this.editType.toLowerCase() == 'pincode') {
					if (this.isValidPincode(this.pincode)) {
						this.isBtnDisabled = false;
						returnVal= true;
					}
					else {
						this.isBtnDisabled = true;
					}
				}
				else if (this.editType.toLowerCase() == 'name') {
					let parentEle = document.querySelector('[data-NameInput]').parentElement;
					if (this.isValidName(this.name)) {
						parentEle.classList.remove('error');
						parentEle.querySelector('span').classList.remove('show');
						//this.isBtnDisabled = false;
						returnVal= true;
					}
					else {
						parentEle.classList.add('error');
						parentEle.querySelector('span').classList.add('show');
						//this.isBtnDisabled = true;
					}
				}
				return returnVal;
			},
			isValidName(name) {
				return (this.regexp.alpha.test(name));
			},
			isValidPincode(code) {
				return code && code.length == 6;
			},
			updateValueToDB() {
				if (this.isValid()) {
					var obj = {};
					if (this.editType.toLowerCase() == 'pincode') {
						if (document.getElementById("profilePincodeInp"))
							document.getElementById("profilePincodeInp").value = this.pincode;
						obj = { UserPid: this.userpid, Pincode: this.pincode, Name: '' };
					}
					else if (this.editType.toLowerCase() == 'name') {
						if (document.getElementById("profileNameInp"))
							document.getElementById("profileNameInp").value = this.name;
						obj = { UserPid: this.userpid, Name: this.name, Pincode: "" };
					}
					CSMainAPIs.Capshine.APIs.UpdateClubSignUpDetails.execute(obj, this.responseCallBack);
				}
			},
			responseCallBack(response) {
				this.popUpClose();
			},
			popUpClose() {
				document.getElementById("div-edit-popup-main").innerHTML = '';
			},
		}
	}));


;// CONCATENATED MODULE: ./src/Components/EditProfile.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/EditProfile.vue




;
const EditProfile_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(EditProfilevue_type_script_lang_js, [['render',EditProfilevue_type_template_id_495ddcf5_render]])

/* harmony default export */ const EditProfile = (EditProfile_exports_);
;// CONCATENATED MODULE: ./src/js/EditProfile.js
﻿




let EditProfile_EditProfile = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	init: function (userPid, sulekhaApp = null) {
		EditProfile_EditProfile.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				EditProfile_EditProfile.isMobileApp = true;
			}
			else {
				EditProfile_EditProfile.isMobileApp = false;
			}
		}
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

		this.userPid = userPid;
		if (this.userPid > 0) {
			this.bindEvents();
		}
	},
	bindEvents: function () {
		if (document.getElementById('div-edit-popup-main')) {
			let profileNameChange = document.getElementById("profileNameChange");
			if (profileNameChange) {
				GATrack.pushValues('Name updated', 'Name updated', 'Name updated');
				profileNameChange.addEventListener("click", function () {
					const props = {
						editType: 'Name',
						editValue: document.getElementById("profileNameInp").value,
						userpid: EditProfile_EditProfile.userPid
					};
					EditProfile_EditProfile.bindEditprofile(props);
				});
			}
			let profilePincodeChange = document.getElementById("profilePincodeChange");
			if (profilePincodeChange) {
				profilePincodeChange.addEventListener("click", function () {
					const props = {
						editType: 'Pincode',
						editValue: document.getElementById("profilePincodeInp").value,
						userpid: EditProfile_EditProfile.userPid
					};
					EditProfile_EditProfile.bindEditprofile(props);
				});
			}
		}
		let backButton = document.getElementById("editProfBackBtn");
		if (backButton) {
			GATrack.pushValues('Back_personaldetails', 'Back_personaldetails', 'Back_personaldetails');
			backButton.addEventListener("click", function () {
				if (EditProfile_EditProfile.isMobileApp) {
					EditProfile_EditProfile.sulekhaApp.navigateTo(MainEnums_MobilePages.myAccount, null)
				} else {
					location.href = '/myaccount';
				}
			});
		}
	},
	bindEditprofile: function (props) {
		if (document.getElementById('div-edit-popup-main')) {
			GATrack.pushValues('Back_name', 'Back_name', 'Back_name');
			let newDiv = document.createElement("div");
			newDiv.id = "div-edit-popup";
			document.getElementById('div-edit-popup-main').appendChild(newDiv);
			const createVue = (0,vue_cjs.createApp)(EditProfile, props);
			createVue.mount('#div-edit-popup');
		}
	},
}
/* harmony default export */ const js_EditProfile = (EditProfile_EditProfile);
;// CONCATENATED MODULE: ./src/js/MyAccount.js
﻿


let MyAccount = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	init: function (pageType, userPid, sulekhaApp = null) {

		MyAccount.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				MyAccount.isMobileApp = true;
			}
			else {
				MyAccount.isMobileApp = false;
			}
		}


		this.userPid = userPid;
		if (this.userPid > 0) {
			if (pageType.toLowerCase() == 'myrewards')
				this.bindRewardCapsEvents();
			else if (pageType.toLowerCase() == 'myaccount')
				this.bindEvents();
			else if (pageType.toLowerCase() == 'mysubscription')
				this.bindMySubscriptionEvents();
			else if (pageType.toLowerCase() == 'fluencyreport')
				this.bindFluencyReportEvents();
			else if (pageType.toLowerCase() == 'coachfeedbacks')
				this.bindCoachFeedbacksEvents();
		}
	},
	ShowHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}
	},
	HideHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}
	},
	bindEvents: function () {
		MyAccount.ShowHeaderFooter();
		var btnEditProfile = document.getElementById('btnEditProfile');

		if (btnEditProfile) {
			btnEditProfile.addEventListener('click', (event) => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.editProfile, null)
				} else {
					window.location.href = "/EditProfile"
				}
			})
		}


		let listrewardItems = document.querySelectorAll('.myaccountrewardranges li');

		if (listrewardItems) {

			listrewardItems.forEach((item, index) => {
				item.addEventListener('click', (event) => {
					//alert(`${event.currentTarget.innerHTML} item was click`);
					var index = item.getAttribute('data-index')

					if (index == 1) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.myRewards, null)
						} else {
							window.location.href = "/MyRewards"
						}
					}
					else if (index == 2) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.mySubscription, null)
						} else {
							window.location.href = "/MySubscription"
						}
					}
					else if (index == 3) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.coachFeedbacks, null)
						} else {
							window.location.href = "/CoachFeedbacks"
						}
					}
					else if (index == 4) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.fluencyReport, null)
						} else {
							window.location.href = "/FluencyReport"
						}
					}


				});

			})
		}


		/// 
		let listItems = document.querySelectorAll('.myaccountranges li');

		if (listItems) {

			listItems.forEach((item, index) => {
				item.addEventListener('click', (event) => {
					//alert(`${event.currentTarget.innerHTML} item was click`);
					var index = item.getAttribute('data-index')

					if (index == 1) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.aboutus, null)
						} else {
							window.location.href = "/aboutus"
						}
					}
					if (index == 2) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.faq, null)
						} else {
							window.location.href = "/faq"
						}
					}
					if (index == 3) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.terms, null)
						} else {
							window.location.href = "/terms"
						}
					}
					if (index == 4) {
						if (MyAccount.isMobileApp) {
							MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.privacypolicy, null)
						} else {
							window.location.href = "/privacypolicy"
						}
					}

				});

			})
		}

		if (MyAccount.isMobileApp == false) {
			let logOutBtn = document.getElementById("logout-btn");
			if (logOutBtn) {
				logOutBtn.addEventListener("click", async function () {
					// TODO: Revert if multiple session feature is needed
					const getIp = async () => {
						const x = await fetch('https://api.ipify.org?format=json');
						const { ip } = await x.json();
						return ip;
					}
					// const uuid = window.localStorage.getItem("session-id")
					// const upsertCapshineDeviceLogin = async () => {
					// 	const data = {
					// 		UserPid: MyAccount.userPid,
					// 		DeviceId: uuid,
					// 		SessionId: uuid,
					// 		Source: "web",
					// 		DeviceIp: await getIp(),
					// 		IsLoggedIn: false
					// 	}
					// 	return new Promise((resolve, reject) => {
					// 		CSMainAPIs.Capshine.APIs.UpsertCapshineDeviceLogin.execute(data, (resp) => {
					// 			resolve(resp.data)
					// 		})
					// 	})
					// }
					// await upsertCapshineDeviceLogin();
					// window.localStorage.removeItem("session-id");
					document.cookie = "capshine_login=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=capshine.com";
					window.location.href = '/';
				});
			}
		}
	},
	bindRewardCapsEvents: function () {
		MyAccount.HideHeaderFooter();
		let rewardMonthDrop = document.getElementById("reward-month-dropdwon");
		if (rewardMonthDrop) {
			GATrack.pushValues('Month Selection_Reward points', 'Month Selection_Reward points', 'Month Selection_Reward points');
			rewardMonthDrop.addEventListener("change", function () {
				if (rewardMonthDrop.value != '' & rewardMonthDrop.value != null)
					MyAccount.LoadRewardCapsScreen(rewardMonthDrop.value);
			});
		}
		MyAccount.bindFeedbackNotFound();
	},
	LoadRewardCapsScreen: function (val) {
		CSMainAPIs.Capshine.MyAccountAPIs.LoadRewardCapsScreen.execute({ userpid: MyAccount.userPid, date: val }, (response) => {
			if (response.data) {
				let bindEle = document.getElementById('rewards-caps-parent');
				if (bindEle) {
					bindEle.innerHTML = '';
					bindEle.innerHTML = response.data.rewardCapsHtmlString;
					document.getElementById("reward-month-dropdwon").value = val;
					MyAccount.bindRewardCapsEvents();
				}
			}
		});
	},
	bindMySubscriptionEvents: function () {
		MyAccount.HideHeaderFooter();
		let cancelSubcriptionBtn = document.getElementById("cancelSubcriptionBtn");
		if (cancelSubcriptionBtn) {
			cancelSubcriptionBtn.addEventListener("click", function () {
				CSMainAPIs.Capshine.PaymentsAPIs.CancelSubscription.execute({ SubscriptionId: cancelSubcriptionBtn.getAttribute('data-subscriptionid') }, MyAccount.CancelSubscriptionResponse);
			});
		}

		let mysubBackBtn = document.querySelector("[mysubscription-back]");
		if (mysubBackBtn) {
			mysubBackBtn.addEventListener("click", () => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateBack();
				} else {
					window.history.back();
				}
			});
		}

		let mysubUpgradeBtn = document.querySelector("[mysubscription-upgrade]");
		if (mysubUpgradeBtn) {
			mysubUpgradeBtn.addEventListener("click", () => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null)
				} else {
					location.href = '/paymentplans';
				}
			})
		}
	},
	CancelSubscriptionResponse: function (response) {

	},
	bindFluencyReportEvents: function () {
		MyAccount.HideHeaderFooter();
		MyAccount.bindFeedbackNotFound();

		let backBtn = document.getElementById("fluency-report-back-btn");
		if (backBtn) {
			backBtn.addEventListener("click", () => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateBack();
				} else {
					window.history.back();
				}
			});
		}

		let reportMonthPdfIcon = document.getElementById("reportDownloadIcon");
		if (reportMonthPdfIcon) {
			reportMonthPdfIcon.addEventListener('click', function (e) {
				let valSelect = document.getElementById('reportMonthlyDrop').value;
				if (valSelect != null)
					MyAccount.FluencyRepPdf(valSelect);
			});
		}

		let reportMonthlyDrop = document.getElementById("reportMonthlyDrop");
		if (reportMonthlyDrop) {
			reportMonthlyDrop.addEventListener('change', function () {
				let selectVal = reportMonthlyDrop.value;
				let selectText = reportMonthlyDrop.options[reportMonthlyDrop.selectedIndex].text;
				if (selectVal != null) {
					document.getElementById('reportContent').innerHTML = "Your Fluency Report Card of " + selectText + " month";
					document.getElementById('report-file-name').innerHTML = "Fluency Report - " + selectText.replace(" - ", " ") + ".pdf";
				}
			});
		}
	},
	async FluencyRepPdf(val) {
		let valSplit = val.split(',');

		let coverspin = document.getElementById('cover-spin')
		if (coverspin) {
			coverspin.style.display = "block";
		}
		CSMainAPIs.Capshine.MyAccountAPIs.DownloadFluencyReport.execute({ MM: valSplit[0], YYYY: valSplit[1], UserPid: this.userPid }, (response) => {
			if (response.data) {
				//	let a = document.createElement("a");
				// a.href = "data:application/pdf;base64," + response.data.string64;
				// a.download = response.data.fileName;
				// a.click();
				// a.remove();

				//const pdfLink = response.data.pdfulr;
				if (coverspin) {
					coverspin.style.display = "none";
				}
				const link = document.createElement('a');
				link.setAttribute('download', response.data.pdfulr);
				link.setAttribute('href', response.data.pdfulr);
				link.setAttribute('target', "_blank");
				link.click();
				link.remove();

				// const download = (url) => {
				// 	const link = document.createElement('a');

				// 	link.setAttribute('download', response.data.filename);
				// 	link.setAttribute('href', url);
				// 	link.click();
				// }

				// var downloadBlob = (blob) => download(URL.createObjectURL(blob))

				// fetch(pdfLink)
				// 	.then(response => response.blob())
				// 	.then(downloadBlob)


			}
		});
		//let url = `/api/myaccount/Fluency-Monthly-Report?MM=${valSplit[0]}&YYYY=${valSplit[1]}&UserPid=${this.userPid}`;
		//window.location.href = url;
	},
	bindCoachFeedbacksEvents: function () {
		MyAccount.HideHeaderFooter();
		MyAccount.bindFeedbackNotFound();

		let backBtn = document.getElementById("coach-feedback-back-btn");
		if (backBtn) {
			backBtn.addEventListener("click", () => {

				let datarowid = MyAccount.getParameterByName('rowid');
				if (datarowid) {
					if (MyAccount.isMobileApp) {
						MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.home)
					} else {
						location.href = "/home"
					}
				}
				else {

					if (MyAccount.isMobileApp) {
						MyAccount.sulekhaApp.navigateBack();
					} else {
						window.history.back();
					}
				}
			});
		}


		let dateOfFeedbackSelect = document.getElementById("dateOfFeedbackSelect");
		if (dateOfFeedbackSelect) {
			let queryscheduleId = MyAccount.getParameterByName('scheduleid');
			if (queryscheduleId != null && queryscheduleId != '' && queryscheduleId > 0) {
				dateOfFeedbackSelect.value = queryscheduleId;
			}
			//	else {

			var scheduleId = dateOfFeedbackSelect.value;
			dateOfFeedbackSelect.addEventListener('change', function (e) {
				scheduleId = dateOfFeedbackSelect.value;
				document.getElementById('feedbackHeading').innerHTML = "";
				document.getElementById('feedbackContent').innerHTML = "";
				document.getElementById('feedbackCoachName').innerHTML = "";
				if (scheduleId != null && scheduleId != '' && scheduleId > 0)
					MyAccount.ClubFluencyFb(scheduleId);
			});
			if (scheduleId != null && scheduleId != '' && scheduleId > 0)
				MyAccount.ClubFluencyFb(scheduleId);
			//}
		}



	},
	ClubFluencyFb: function (scheduleId) {
		debugger;
		CSMainAPIs.Capshine.MyAccountAPIs.GetClubFluencyReportHistory.execute({ userPid: this.userPid, clubScheduleId: scheduleId }, (response) => {
			var data = response.data;
			if (data != null) {
				document.getElementById('feedbackHeading').innerHTML = "Here is what the coach has to say about your performance in " + data.meetingDateTimeString + " session";
				document.getElementById('feedbackContent').innerHTML = "";
				let feedback = data.feedback.split('\n');
				let feedBackArr = [];
				let feedBackValue = "";
				feedback.forEach((val) => {
					val = "<p>" + val + "</p>";
					feedBackArr.push(val);
				});
				if (feedBackArr.length > 0) { feedBackValue = feedBackArr.join(" ") }
				feedback = feedBackValue.split(' ');
				feedback.unshift(`<p>Dear ${data.name},</p>`)
				feedBackArr = [];
				feedback.forEach((val) => {
					if (val.includes("http")) { val = "<a href='" + val.replace("<p>", "").replace("</p>", "") + "' target='_blank'>" + val.replace("<p>", "").replace("</p>", "") + "</a>"; }
					feedBackArr.push(val);
				});
				if (feedBackArr.length > 0) { feedBackValue = feedBackArr.join(" ") }
				document.getElementById('feedbackContent').innerHTML = feedBackValue + "<p>Happy learning</p>";
				document.getElementById('feedbackCoachName').innerHTML = data.coachName;


				let datarowid = MyAccount.getParameterByName('rowid');
				if (datarowid) {
					CSMainAPIs.Capshine.APIs.UpdateMeetingFeedBackHasSeenStatus.execute({ "rowid": datarowid }, (response) => {
					})
				}


			}
			else {
				document.getElementById('feedbackContent').innerHTML = "No Feedback found...";
				document.getElementById('feedbackCoachName').innerHTML = "Not Found...";
			}
		});
	},
	bindFeedbackNotFound: function () {
		let viewLiveClassBtn = document.getElementById("view-live-class-btn");
		if (viewLiveClassBtn) {
			viewLiveClassBtn.addEventListener("click", () => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules, null)
				} else {
					location.href = '/talktimeschedules';
				}
			})
		}
		let viewActivityBtn = document.getElementById("view-activity-btn");
		if (viewActivityBtn) {
			viewActivityBtn.addEventListener("click", () => {
				if (MyAccount.isMobileApp) {
					MyAccount.sulekhaApp.navigateTo(MainEnums_MobilePages.activity, null)
				} else {
					location.href = '/activity';
				}
			})
		}
	},
	getParameterByName: function (name, url = window.location.href) {
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
}
/* harmony default export */ const js_MyAccount = (MyAccount);


;// CONCATENATED MODULE: ./src/js/Home.js
﻿let Home = {
	userPid: 0,
	init: function () {
		if (this.userPid > 0) {
		}
		else {
			this.bindWithoutLoginEvents();
		}
	},
	bindWithoutLoginEvents: function () {
		let openwindowvideoPopup = document.getElementById("Openwindowvideo");
		if (openwindowvideoPopup) {
			let openHpVideoBtn = document.querySelectorAll("[data-openHpVideo]");
			if (openHpVideoBtn) {
				openHpVideoBtn.forEach(item => {
					item.addEventListener("click", function () {
						openwindowvideoPopup.querySelector('iframe').setAttribute("src", openwindowvideoPopup.querySelector('iframe').getAttribute("data-src"));
						openwindowvideoPopup.classList.add("show");
					});
				});
			}

			let closeHpVideoBtn = document.getElementById("closeHpVideo");
			if (closeHpVideoBtn) {
				closeHpVideoBtn.addEventListener("click", function () {
					openwindowvideoPopup.classList.remove("show");
					openwindowvideoPopup.querySelector('iframe').setAttribute("src", "");
				});
			}
		}

		let testimonialVideoPopup = document.getElementById("TestimonialVideoPopup");
		if (testimonialVideoPopup) {
			let openTestimonialBtn = document.querySelectorAll("[data-openTestimonialVideo]");
			if (openTestimonialBtn) {
				openTestimonialBtn.forEach(item => {
					item.addEventListener("click", function () {
						testimonialVideoPopup.classList.add("show");
					});
				});
			}
			let closeTestimonialBtn = document.getElementById("closeTestimonialVideo");
			if (closeTestimonialBtn) {
				closeTestimonialBtn.addEventListener("click", function () {
					testimonialVideoPopup.classList.remove("show");
					testimonialVideoPopup.querySelector('iframe').setAttribute("src", testimonialVideoPopup.querySelector('iframe').getAttribute("src"));
				});
			}
		}
	},
}
/* harmony default export */ const js_Home = (Home);
;// CONCATENATED MODULE: ./src/js/Activity.js
﻿



let Activity = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	init: function (userPid, sulekhaApp = null) {
		Activity.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				Activity.isMobileApp = true;
			}
			else {
				Activity.isMobileApp = false;
			}
		}
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}

		this.userPid = userPid;
		if (this.userPid > 0) {
			this.bindEvents();
			this.bindActivityEvents();
		}
	},
	bindEvents: function () {
		var playNoQuiz = 0;
		var playNoFTG = 0;
		if (document.getElementById("playNoQuiz"))
			playNoQuiz = document.getElementById("playNoQuiz").value;
		if (document.getElementById("playNoFillTheGap"))
			playNoFTG = document.getElementById("playNoFillTheGap").value;

		let quizPlayButton = document.getElementById("playQuizBtn");
		if (quizPlayButton) {
			quizPlayButton.addEventListener("click", function () {
				const IsPlay = quizPlayButton.getAttribute('data-playquiz');
				if (IsPlay.toLowerCase() == 'true') {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.quiz, { playNo: playNoQuiz });
					} else {
						location.href = '/quiz?playNo=' + playNoQuiz;
					}
				}
				else {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 7 });
					} else {
						window.location.href = "/paymentUpgradeRequest?pageType=7";
					}
				}
			});
		}
		let fillthegapPlayButton = document.getElementById("playFillheGapBtn");
		if (fillthegapPlayButton) {
			fillthegapPlayButton.addEventListener("click", function () {
				const IsPlay = fillthegapPlayButton.getAttribute('data-playfillthegap');
				if (IsPlay.toLowerCase() == 'true') {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.fillthegap, { playNo: playNoFTG });
					} else {
						location.href = '/FillTheGap?playNo=' + playNoFTG;
					}
				}
				else {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 7 });
					} else {
						window.location.href = "/paymentUpgradeRequest?pageType=7";
					}
				}
			});
		}
		let jumbledSentenceButton = document.getElementById("playJumbledSentence");
		if (jumbledSentenceButton) {
			jumbledSentenceButton.addEventListener("click", function () {
				const IsPlay = jumbledSentenceButton.getAttribute('data-playjumbledsentence');
				if (IsPlay.toLowerCase() == 'true') {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.jumbledSentence, { playNo: playNoFTG });
					} else {
						location.href = '/JumbledSentence?playNo=' + playNoFTG;
					}
				}
				else {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 7 });
					} else {
						window.location.href = "/paymentUpgradeRequest?pageType=7";
					}
				}
			});
		}
	},
	bindActivityEvents: function () {
		const activityType = parseInt(window.location.pathname.split("/")[2]);
		if (!Activity.isMobileApp) {
			const mcqType = Activity.getMcqType(activityType)
			if (activityType && activityType > 0) {
				const urlParams = new URLSearchParams(window.location.search);
				const playNo = urlParams.get('playNo');
				window.Capshine.capshineApp.InitPanel('AllMcqBase', { mcqType, userPid: Activity.userPid, id: 'ActivityPlaylist_Panel', playNo: playNo });
			}
		}
		document.querySelectorAll("[activity-card-btn]").forEach((el) => {
			if (el.dataset.isplaylistcompleted === "True") return
			el.addEventListener("click", (e) => {
				console.log("el.dataset.iseligibletoplay", el.dataset.iseligibletoplay);
				if (el.dataset.iseligibletoplay === "True") {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.activityPlayList, { activityId: el.dataset.activitytype, playQuiz: el.dataset.activityplayed });
					} else {
						window.location.href = `/activity/${el.dataset.activitytype}?playNo=${el.dataset.activityplayed}`;
					}
				} else {
					if (Activity.isMobileApp) {
						Activity.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 6 });
					} else {
						window.location.href = "/paymentUpgradeRequest?pageType=6";
					}
				}
			})
		})
	},
	getMcqType: function (ActivityId) {
		let mcqType = null
		switch (ActivityId) {
			case src_ActivityPlaylistType.Quiz:
				mcqType = CapshineEnums.Quiz;
				break;
			case src_ActivityPlaylistType.FillTheGap:
				mcqType = CapshineEnums.FillInTheGap;
				break;
			case src_ActivityPlaylistType.JumbledSentence:
				mcqType = CapshineEnums.JumbledSentence;
				break;
			case src_ActivityPlaylistType.Meanings:
				mcqType = CapshineEnums.Meanings;
				break;
			default:
				mcqType = CapshineEnums.Quiz;
		}
		return mcqType;
	}
}
/* harmony default export */ const js_Activity = (Activity);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/TalktimeInvite.vue?vue&type=template&id=355e22a0


const TalktimeInvitevue_type_template_id_355e22a0_hoisted_1 = {
  class: "sk-popup invite-friends",
  id: "invite-popup"
}
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_2 = { class: "sk-inner" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_3 = { class: "sk-header success-gradient" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_4 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, "Invite friends & talk together", -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_5 = { class: "right-nav close-modal" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_6 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" }, null, -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_7 = [
  TalktimeInvitevue_type_template_id_355e22a0_hoisted_6
]
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_8 = { class: "sk-body align-center" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_9 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("img", {
  src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/invite-friends.svg",
  alt: "Invite Friends",
  width: "125",
  height: "85"
}, null, -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_10 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "" }, [
  /*#__PURE__*/(0,vue_cjs.createTextVNode)(" You can invite any "),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("b", null, "Capshine member"),
  /*#__PURE__*/(0,vue_cjs.createTextVNode)(" or your "),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("b", null, "friends from outside"),
  /*#__PURE__*/(0,vue_cjs.createTextVNode)(" to join this custom talk-time session. ")
], -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_11 = { class: "button-group mt-3 no-margin" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_12 = { class: "sk-inner" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_13 = { class: "sk-header" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_14 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, "Invite friends (max 5)", -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_16 = [
  TalktimeInvitevue_type_template_id_355e22a0_hoisted_15
]
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_17 = { class: "sk-body align-center" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_18 = { class: "text-field input-icon" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_19 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  class: "icon",
  width: "25",
  height: "25",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#searchtop" })
], -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_20 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "error-text" }, null, -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_21 = {
  key: 0,
  class: "user-list"
}
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_22 = { class: "list-item" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_23 = { class: "name-card" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_24 = ["src"]
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_25 = { class: "name" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_26 = { class: "username" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_27 = { class: "details" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_28 = { class: "userid" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_29 = { class: "clubname" }
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_30 = {
  key: 0,
  class: "button success-no-border no-shadow no-space"
}
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_31 = ["onClick"]
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_32 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "sk-toast-inner" }, "Maximum invites sent", -1)
const TalktimeInvitevue_type_template_id_355e22a0_hoisted_33 = [
  TalktimeInvitevue_type_template_id_355e22a0_hoisted_32
]

function TalktimeInvitevue_type_template_id_355e22a0_render(_ctx, _cache, $props, $setup, $data, $options) {
  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, [
    (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_1, [
      (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_2, [
        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_3, [
          TalktimeInvitevue_type_template_id_355e22a0_hoisted_4,
          (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_5, [
            ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("svg", {
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.closeInvitePopup())),
              id: "invite-popup-close",
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              fill: "#000000",
              viewBox: "0 0 256 256"
            }, TalktimeInvitevue_type_template_id_355e22a0_hoisted_7))
          ])
        ]),
        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_8, [
          TalktimeInvitevue_type_template_id_355e22a0_hoisted_9,
          TalktimeInvitevue_type_template_id_355e22a0_hoisted_10,
          (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_11, [
            (0,vue_cjs.createElementVNode)("button", {
              type: "button",
              class: "button primary",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.inviteCapshineFriends()))
            }, "Capshine Member"),
            (0,vue_cjs.createElementVNode)("button", {
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.inviteYourFriends())),
              class: "button primary-outline"
            }, "Your Friends")
          ])
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", {
      class: (0,vue_cjs.normalizeClass)(["sk-popup friends-list", _ctx.showMemberPopup ? 'show' : ''])
    }, [
      (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_12, [
        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_13, [
          TalktimeInvitevue_type_template_id_355e22a0_hoisted_14,
          (0,vue_cjs.createElementVNode)("div", {
            class: "right-nav close-modal",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.closeInviteMemberPopup()))
          }, TalktimeInvitevue_type_template_id_355e22a0_hoisted_16)
        ]),
        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_17, [
          (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_18, [
            (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.name) = $event)),
              onInput: _cache[5] || (_cache[5] = $event => (_ctx.searchInviteUser($event.target.value))),
              ref: "inviteInpSearch",
              placeholder: "Search"
            }, null, 544), [
              [vue_cjs.vModelText, _ctx.name]
            ]),
            TalktimeInvitevue_type_template_id_355e22a0_hoisted_19,
            TalktimeInvitevue_type_template_id_355e22a0_hoisted_20
          ]),
          (_ctx.membersList.length > 0)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("ul", TalktimeInvitevue_type_template_id_355e22a0_hoisted_21, [
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)(_ctx.membersList, (result, index) => {
                  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", TalktimeInvitevue_type_template_id_355e22a0_hoisted_22, [
                    (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_23, [
                      (0,vue_cjs.createElementVNode)("div", {
                        class: (0,vue_cjs.normalizeClass)(["avatar", result.isOnline?'online':''])
                      }, [
                        (0,vue_cjs.createElementVNode)("img", {
                          src: 'https://sulcdn.azureedge.net/content/caps/Capshine_v2/avatar-'.concat(result.gender.toLowerCase(), '.svg'),
                          width: "25",
                          height: "25"
                        }, null, 8, TalktimeInvitevue_type_template_id_355e22a0_hoisted_24)
                      ], 2),
                      (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_25, [
                        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_26, (0,vue_cjs.toDisplayString)(result.name), 1),
                        (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_27, [
                          (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_28, "ID: " + (0,vue_cjs.toDisplayString)(result.userPid), 1),
                          (0,vue_cjs.createElementVNode)("div", TalktimeInvitevue_type_template_id_355e22a0_hoisted_29, "Club: " + (0,vue_cjs.toDisplayString)(result.clubName), 1)
                        ])
                      ])
                    ]),
                    (result.hasInvited)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("a", TalktimeInvitevue_type_template_id_355e22a0_hoisted_30, "Invited"))
                      : ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("a", {
                          key: 1,
                          onClick: $event => (_ctx.inviteUser(result.userPid, index)),
                          class: "button primary-no-border no-shadow no-space"
                        }, "Invite", 8, TalktimeInvitevue_type_template_id_355e22a0_hoisted_31))
                  ]))
                }), 256))
              ]))
            : (0,vue_cjs.createCommentVNode)("", true)
        ]),
        (0,vue_cjs.createElementVNode)("div", {
          class: (0,vue_cjs.normalizeClass)(["sk-toast", _ctx.maximumInvited?'':'hide'])
        }, TalktimeInvitevue_type_template_id_355e22a0_hoisted_33, 2)
      ])
    ], 2)
  ], 64))
}
;// CONCATENATED MODULE: ./src/Components/TalktimeInvite.vue?vue&type=template&id=355e22a0

;// CONCATENATED MODULE: ./node_modules/@capacitor/share/dist/esm/index.js

const Share = (0,dist/* registerPlugin */.fo)('Share', {
    web: () => __webpack_require__.e(/* import() */ 811).then(__webpack_require__.bind(__webpack_require__, 811)).then(m => new m.ShareWeb()),
});


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/TalktimeInvite.vue?vue&type=script&lang=js

	
	
	
	

	/* harmony default export */ const TalktimeInvitevue_type_script_lang_js = ((0,vue_cjs.defineComponent)({
		name: 'TalktimeInvite',
		props: {
			topic: String,
			scheduleDateTime: String,
			talkTimeScheduleId: Number,
			userPid: Number,
			sulekhaApp: null,
		},
		data() {
			return {
				name: '',
				showMemberPopup: false,
				maximumInvited: false,
				membersList: []
			}
		},
		mounted: function () {
			this.searchInviteUser('');
		},
		methods: {
			inviteCapshineFriends: async function () {
				GATrack.pushValues('Invitefriends_popupminiTT', 'Invite capshine friends', 'Click_capshineMembers');
				document.getElementById("invite-popup").classList.remove('show');
				this.showMemberPopup = true;
				this.$refs.inviteInpSearch.focus();
			},
			inviteYourFriends: async function () {
				GATrack.pushValues('Invitefriends_popupminiTT', 'Invite Friends', 'Click_Friends');
				const url = CSMainAPIs.Capshine.Server.baseUrl + 'signuptalktime/' + this.talkTimeScheduleId;
				if (!this.sulekhaApp) {
					await navigator.share({
						title: 'Talk-time Sessions',
						text: "Hey, Join Capshine's Talktime on " + this.scheduleDateTime + " to discuss an interesting topic with me.Reserve your slot using this link - " + url + "",
					}).catch(err => {
						console.error("Unsuccessful share", err);
					});
				}
				else {
					await Share.share({
						title: 'Talk-time Sessions',
						text: "Hey, Join Capshine's Talktime on " + this.scheduleDateTime + " to discuss an interesting topic with me.Reserve your slot using this link - " + url + "",
						dialogTitle: 'Share with friends',
					});
				}
			},
			closeInvitePopup() {
				GATrack.pushValues('Invitefriends_popupminiTT', 'Close invite popup', 'Click_close');
				document.getElementById("invite-popup").classList.remove('show');
			},
			closeInviteMemberPopup: async function () {
				GATrack.pushValues('InviteFriend_searchminiTT', 'Close invite clubuser', 'Click_close');
				this.name = '';
				this.$refs.inviteInpSearch.focus();
				this.showMemberPopup = false;
				document.getElementById("invite-popup").classList.add('show');
				await this.searchInviteUser('');
			},
			searchInviteUser: async function (value) {
				this.name = value.trim();
				let val = this.name;
				if (val.length < 3)
					val = "";
				await CSMainAPIs.Capshine.TalktimeAPIs.GetTalktimeInviteUser.execute({ UserPid: this.userPid, Name: val, TalkTimeScheduleId: this.talkTimeScheduleId }, (response) => {
					this.membersList = [];
					if (response.data) {
						if (response.data.searchData) {
							this.membersList = response.data.searchData;
						}
					}
				});
			},
			inviteUser(userPid, index) {
				let inviteBtn = document.getElementById("invite-btn");
				let inviteCount = parseInt(inviteBtn.getAttribute('data-invitecount'));
				if (inviteCount < 5) {
					GATrack.pushValues('InviteFriend_searchminiTT', 'Invited miniTT ' + userPid, 'click_invited');
					const url = CSMainAPIs.Capshine.Server.baseUrl + 'talktime/' + this.talkTimeScheduleId + '/' + this.getRandomNunber();
					CSMainAPIs.Capshine.TalktimeAPIs.TalktimeInviteUserAdd.execute(
						{
							UserPid: this.userPid, InviteUserPid: userPid, TalkTimeScheduleId: this.talkTimeScheduleId,
							MeetingTopic: this.topic, MeetingUrl: url, ScheduleDateTime: this.scheduleDateTime
						},
						(response) => {
						inviteBtn.setAttribute('data-invitecount', String(inviteCount + 1));
						this.membersList[index].hasInvited = true;
					});
				}
				else
					this.maximumInvited = true;
			},
			getRandomNunber: function () {
				return Math.floor(1000 + Math.random() * 9000);
			},
		}
	}));


;// CONCATENATED MODULE: ./src/Components/TalktimeInvite.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/TalktimeInvite.vue




;
const TalktimeInvite_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TalktimeInvitevue_type_script_lang_js, [['render',TalktimeInvitevue_type_template_id_355e22a0_render]])

/* harmony default export */ const TalktimeInvite = (TalktimeInvite_exports_);
;// CONCATENATED MODULE: ./src/js/Talktime.js
﻿




let Talktime = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	userInfo: null,
	init: function (userPid, pageName, sulekhaApp = null) {
		Talktime.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				Talktime.isMobileApp = true;
			}
			else {
				Talktime.isMobileApp = false;
			}
		}
		this.userPid = userPid;


		CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userPid }, Talktime.afterGetUserInfoLoad);


		if (pageName.toLowerCase() == 'talktimeschedules')
			this.bindEvents();
		else if (pageName.toLowerCase() == 'talktime')
			this.bindSlotBooking();
		else if (pageName.toLowerCase() == 'home')
			this.bindBottomSheetEvents();
	},

	afterGetUserInfoLoad(response) {
		Talktime.userInfo = response.data;
	},

	bindEvents: function () {
		Talktime.ShowHeaderFooter();
		Talktime.bindSlotEvents();
		const slotDate = document.querySelectorAll("[data-slotdate]");
		if (slotDate) {
			slotDate.forEach(function (date) {
				date.addEventListener("click", function () {
					const clickedDate = date.getAttribute('data-slotdate');
					GATrack.pushValues('DateSelection_miniTT', 'DateSelection_miniTT', 'DateSelection_miniTT');
					document.getElementById('talktime-slots').innerHTML = "";
					document.querySelectorAll("[data-slotdate]").forEach((e) => { e.classList.remove('selected'); });
					date.classList.add('selected');
					CSMainAPIs.Capshine.TalktimeAPIs.GetTalkTimeSchedules.execute({ ScheduleDateTime: clickedDate, UserPid: parseInt(Talktime.userPid) }, (response) => {
						document.getElementById('talktime-slots').innerHTML = response.data.talktimeHtml;
						setTimeout(Talktime.bindSlotEvents, 500);
					});
				});
			});
		}
		let introPopup = document.getElementById("talk-time-intro-popup");
		let introClose = document.getElementById("talk-time-intro-close");
		const introContinueBtn = document.getElementById("talk-time-intro-continueBtn");
		const infoTalktime = document.getElementById("talk-time-intro-infoEle");
		if (introPopup) {
			if (!window.localStorage.getItem('capshine_talktimeIntro')) {
				introPopup.classList.add('show');
			}
			if (infoTalktime)
				infoTalktime.addEventListener("click", function () {
					introPopup.classList.add('show');
				});
			if (introClose)
				introClose.addEventListener("click", function () {
					introPopup.classList.remove('show');
					var myDate = new Date();
					myDate.setDate(myDate.getDate() + 365);
					window.localStorage.setItem('capshine_talktimeIntro', myDate.toUTCString())
				});
			if (introContinueBtn)
				introContinueBtn.addEventListener("click", function () {
					introPopup.classList.remove('show');
					var myDate = new Date();
					myDate.setDate(myDate.getDate() + 365);
					window.localStorage.setItem('capshine_talktimeIntro', myDate.toUTCString())
				});
		}
	},
	bindSlotEvents: function () {
		const slots = document.querySelectorAll("[data-slot]");
		if (slots) {
			slots.forEach(function (slot) {
				slot.addEventListener("click", function () {
					var availableSlot = slot.getAttribute('data-availableslots');
					var isSlotBooked = slot.getAttribute('data-slotbooked');
					var slotTime = slot.getAttribute('data-slotTime');
					var talkTimeScheduleId = slot.getAttribute('data-slot');
					GATrack.pushValues('SlotSelection_MiniTT', slotTime, 'SlotSelection_MiniTT');
					if (Talktime.isMobileApp) {
						Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktime, { talkTimeScheduleId: talkTimeScheduleId, rnd: Talktime.getRandomNunber() });
					} else {
						window.location.href = "/talktime/" + talkTimeScheduleId + "/" + Talktime.getRandomNunber();
					}
				});
			});
		}
	},
	bindSlotBooking: function () {
		const reserveSeatbtn = document.getElementById("reserve-seat-btn");
		if (reserveSeatbtn) {
			reserveSeatbtn.addEventListener("click", function () {
				var clickedDate = reserveSeatbtn.getAttribute('data-scheduledatetime');
				var talkTimeScheduleId = reserveSeatbtn.getAttribute('data-talkTimeScheduleId');
				GATrack.pushValues('ReserveSeat_miniTT', 'TT Seat reserved ' + clickedDate, 'ReserveSeat_miniTT');
				var bookingEligible = reserveSeatbtn.getAttribute('data-iseligibleforbooking').toLowerCase() == 'true' ? true : false;
				if (bookingEligible) {
					reserveSeatbtn.setAttribute('disabled', 'disabled');
					const url = CSMainAPIs.Capshine.Server.baseUrl + 'talktime/' + talkTimeScheduleId + '/' + Talktime.getRandomNunber();
					CSMainAPIs.Capshine.TalktimeAPIs.AddTalkTimeSlots.execute(
						{ ScheduleDateTime: clickedDate, UserPid: parseInt(Talktime.userPid), TalkTimeScheduleId: talkTimeScheduleId, MeetingUrl: url },
						(response) => {
							if (response.data == -1) {
								if (Talktime.isMobileApp) {
									Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules);
								} else {
									window.location.replace("/talktimeschedules");
								}
							}
							else {
								if (Talktime.isMobileApp) {
									Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktime, { talkTimeScheduleId: talkTimeScheduleId, rnd: Talktime.getRandomNunber() });
								} else {
									window.location.replace("/talktime/" + talkTimeScheduleId + "/" + Talktime.getRandomNunber());
								}
							}
						});
				}
				else {
					if (Talktime.isMobileApp) {
						Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, { pageType: 10 });
					} else {
						location.href = "/PaymentUpgradeRequest?pageType=10";
					}
				}
			});
		}
		let joinTalktimeBtn = document.getElementById("join-talktime-btn");
		if (joinTalktimeBtn) {
			let secondsLeft = joinTalktimeBtn.getAttribute('data-secondsleft');
			var talkTimeScheduleId = joinTalktimeBtn.getAttribute('data-talkTimeScheduleId');
			if (secondsLeft) {
				setInterval(() => {
					if (secondsLeft == 0) {
						if (Talktime.isMobileApp) {
							Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktime, { talkTimeScheduleId: talkTimeScheduleId, rnd: Talktime.getRandomNunber() });
						} else {
							window.location.replace("/talktime/" + talkTimeScheduleId + "/" + Talktime.getRandomNunber());
						}
						secondsLeft = secondsLeft - 1;
					}
					else if (secondsLeft > 0) {
						secondsLeft = secondsLeft - 1;
						joinTalktimeBtn.firstElementChild.innerText = parseInt(secondsLeft / 60) + ':' + parseInt(secondsLeft % 60);
						joinTalktimeBtn.setAttribute('data-secondsleft', secondsLeft);
					}
				}, 1000);
			}
			else {
				joinTalktimeBtn.addEventListener("click", async function () {
					const isDisabled = joinTalktimeBtn.classList.contains('disabled');
					const clubscheduleId = joinTalktimeBtn.getAttribute('data-clubscheduleid');
					const meetingId = joinTalktimeBtn.getAttribute('data-meetingid');
					const meetingUrl = joinTalktimeBtn.getAttribute('data-meetingurl');
					const isCoach = joinTalktimeBtn.getAttribute('data-isCoach');
					if (!isDisabled) {
						const reqURLObj = {
							ClubScheduleId: clubscheduleId,
							MeetingId: meetingId,
							UserPid: parseInt(Talktime.userPid),
							Name: "",
							EmailId: "",
							IsCoach: isCoach.toLowerCase() == 'true' ? true : false,
							meetingUrl: meetingUrl
						}
						await Talktime.joinMeeting(reqURLObj);
					}
				});
			}
		}
		const cancelSeatbtn = document.getElementById("cancel-seat-btn");
		if (cancelSeatbtn) {
			cancelSeatbtn.addEventListener("click", function () {
				GATrack.pushValues('TT Booking cancel confirm', 'TT Booking cancel confirm', 'TT Booking cancel confirm');
				var talkTimeScheduleId = cancelSeatbtn.getAttribute('data-talkTimeScheduleId');
				cancelSeatbtn.setAttribute('disabled', 'disabled');
				CSMainAPIs.Capshine.TalktimeAPIs.CancelTalktime.execute({ UserPid: parseInt(Talktime.userPid), TalkTimeScheduleId: talkTimeScheduleId }, (response) => {
					if (Talktime.isMobileApp) {
						Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules);
					} else {
						window.location.replace("/talktimeschedules");
					}
				});
			});
		}
		const invitePopup = document.getElementById("invite-popup-div");
		if (invitePopup) {
			const topic = invitePopup.getAttribute('data-topic');
			const talkTimeScheduleId = invitePopup.getAttribute('data-talkTimeScheduleId');
			const scheduleDateTime = invitePopup.getAttribute('data-scheduleDateTime');
			const props = {
				topic: topic,
				scheduleDateTime: scheduleDateTime,
				talkTimeScheduleId: talkTimeScheduleId,
				userPid: Talktime.userPid,
				sulekhaApp: Talktime.sulekhaApp
			};
			const createResponseVue = (0,vue_cjs.createApp)(TalktimeInvite, props);
			createResponseVue.mount('#' + invitePopup.id);
			const inviteBtn = document.getElementById("invite-btn");
			if (inviteBtn) {
				inviteBtn.addEventListener("click", function () {
					GATrack.pushValues('InviteFriends_miniTT', 'TT invite friends', 'Click_invite');
					document.getElementById("invite-popup").classList.add('show');
				});
			}
		}
		let backBtn = document.getElementById("talktime-back");
		if (backBtn) {
			backBtn.addEventListener("click", function () {
				if (Talktime.isMobileApp) {
					Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules);
				} else {
					window.location.href = "/talktimeschedules";
				}
			});
		}
		Talktime.HideHeaderFooter();
	},
	ShowHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}
	},
	HideHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}
	},
	getRandomNunber: function () {
		return Math.floor(1000 + Math.random() * 9000);
	},
	bindBottomSheetEvents: function () {
		let scheduleTimer = document.getElementById("schedule-timer");
		if (scheduleTimer) {
			setInterval(() => { if (scheduleTimer.innerText > 0) { scheduleTimer.innerText = (parseInt(scheduleTimer.innerText) - 1); } }, 60000);
		}
		const sheetClick = document.getElementById("talktime-notification-sheet");
		if (sheetClick) {
			var homePageDiv = document.getElementById('homePage-div');
			if (homePageDiv)
				homePageDiv.classList.add('with-page-footer');
			sheetClick.addEventListener("click", function () {
				var talkTimeScheduleId = sheetClick.getAttribute('data-talkTimeScheduleId');
				if (Talktime.isMobileApp) {
					Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.talktime, { talkTimeScheduleId: talkTimeScheduleId, rnd: Talktime.getRandomNunber() });
				} else {
					window.location.href = "/talktime/" + talkTimeScheduleId + "/" + Talktime.getRandomNunber();
				}
			});
		}
		const talktimeNotificationModal = document.getElementById('talktime-notification-modal');
		if (talktimeNotificationModal) {
			talktimeNotificationModal.previousElementSibling.style.paddingBottom = talktimeNotificationModal.querySelector('.sk-body').clientHeight + 'px';
			const talktimeNotificationClose = document.getElementById('talktime-notification-close');
			if (talktimeNotificationClose) {
				talktimeNotificationClose.addEventListener("click", function () {
					talktimeNotificationModal.classList.remove('show');
					var homePageDiv = document.getElementById('homePage-div');
					if (homePageDiv)
						homePageDiv.classList.remove('with-page-footer');
					talktimeNotificationModal.previousElementSibling.style.paddingBottom = 0;
				});
			}
		}
	},
	joinMeeting: async function (reqURLObj) {

		if (Talktime.userInfo.zoomMeetingEnvironment == 'web') {  // web or app

			var meetingUrl = reqURLObj.meetingUrl;

			if (meetingUrl.toLowerCase().indexOf("tk=") <= 0) {
				await CSMainAPIs.Capshine.APIs.GetZoomMeetingURL.execute(reqURLObj, (response) => {
					if (!response || !response.data) return
					if (!response.data || !response.data.result) return
					Talktime.openMeeting(response.data.result.meetingUrl);
				});
			}
			else {
				Talktime.openMeeting(meetingUrl);
			}

		}
		else {

			if (Talktime.isMobileApp == true && !reqURLObj.IsCoach) {
				Talktime.sulekhaApp.navigateTo(MainEnums_MobilePages.classRoom, { clubScheduleId: reqURLObj.ClubScheduleId, rnd: Talktime.getRandomNunber() });
			}
			else {
				var meetingUrl = reqURLObj.meetingUrl;

				if (meetingUrl.toLowerCase().indexOf("tk=") <= 0) {
					await CSMainAPIs.Capshine.APIs.GetZoomMeetingURL.execute(reqURLObj, (response) => {
						if (!response || !response.data) return
						if (!response.data || !response.data.result) return
						Talktime.openMeeting(response.data.result.meetingUrl);
					});
				}
				else {
					Talktime.openMeeting(meetingUrl);
				}
			}
		}
	},
	openMeeting: function (meetingUrl) {
		let isChrome = false;
		let isChromeIOS = false;
		try {
			isChrome = /Google Inc/.test(navigator.vendor);
			isChromeIOS = /CriOS/.test(navigator.userAgent);
		}
		catch (err) {
			console.log(err);
		}
		if (meetingUrl) {
			if (isChrome || isChromeIOS) {
				window.open(meetingUrl, '_blank');
			}
			else {
				location.href = meetingUrl;
			}
		}
	}
}
/* harmony default export */ const js_Talktime = (Talktime);
;// CONCATENATED MODULE: ./node_modules/intro.js/intro.module.js
/*!
 * Intro.js v5.1.0
 * https://introjs.com
 *
 * Copyright (C) 2012-2022 Afshin Mehrabani (@afshinmeh).
 * https://introjs.com
 *
 * Date: Mon, 04 Apr 2022 21:20:28 GMT
 */
function t(e){return t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},t(e)}function e(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function n(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var i,o,r=[],a=!0,s=!1;try{for(n=n.call(t);!(a=(i=n.next()).done)&&(r.push(i.value),!e||r.length!==e);a=!0);}catch(t){s=!0,o=t}finally{try{a||null==n.return||n.return()}finally{if(s)throw o}}return r}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return i(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,i=new Array(e);n<e;n++)i[n]=t[n];return i}var o=function(){var t={};return function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"introjs-stamp";return t[n]=t[n]||0,void 0===e[n]&&(e[n]=t[n]++),e[n]}}();function r(t,e,n){if(t)for(var i=0,o=t.length;i<o;i++)e(t[i],i);"function"==typeof n&&n()}var a=new function(){var t="introjs_event";this._id=function(t,e,n,i){return e+o(n)+(i?"_".concat(o(i)):"")},this.on=function(e,n,i,o,r){var a=this._id.apply(this,arguments),s=function(t){return i.call(o||e,t||window.event)};"addEventListener"in e?e.addEventListener(n,s,r):"attachEvent"in e&&e.attachEvent("on".concat(n),s),e[t]=e[t]||{},e[t][a]=s},this.off=function(e,n,i,o,r){var a=this._id.apply(this,arguments),s=e[t]&&e[t][a];s&&("removeEventListener"in e?e.removeEventListener(n,s,r):"detachEvent"in e&&e.detachEvent("on".concat(n),s),e[t][a]=null)}},s="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function l(t,e){return t(e={exports:{}},e.exports),e.exports}var c,u,h=function(t){return t&&t.Math==Math&&t},f=h("object"==typeof globalThis&&globalThis)||h("object"==typeof window&&window)||h("object"==typeof self&&self)||h("object"==typeof s&&s)||function(){return this}()||Function("return this")(),p=function(t){try{return!!t()}catch(t){return!0}},d=!p((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),g=!p((function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype")})),v=Function.prototype.call,m=g?v.bind(v):function(){return v.apply(v,arguments)},b={}.propertyIsEnumerable,y=Object.getOwnPropertyDescriptor,w={f:y&&!b.call({1:2},1)?function(t){var e=y(this,t);return!!e&&e.enumerable}:b},_=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},S=Function.prototype,x=S.bind,j=S.call,C=g&&x.bind(j,j),A=g?function(t){return t&&C(t)}:function(t){return t&&function(){return j.apply(t,arguments)}},k=A({}.toString),E=A("".slice),T=function(t){return E(k(t),8,-1)},I=f.Object,N=A("".split),L=p((function(){return!I("z").propertyIsEnumerable(0)}))?function(t){return"String"==T(t)?N(t,""):I(t)}:I,O=f.TypeError,P=function(t){if(null==t)throw O("Can't call method on "+t);return t},R=function(t){return L(P(t))},M=function(t){return"function"==typeof t},q=function(t){return"object"==typeof t?null!==t:M(t)},B=function(t){return M(t)?t:void 0},H=function(t,e){return arguments.length<2?B(f[t]):f[t]&&f[t][e]},D=A({}.isPrototypeOf),F=H("navigator","userAgent")||"",$=f.process,G=f.Deno,V=$&&$.versions||G&&G.version,z=V&&V.v8;z&&(u=(c=z.split("."))[0]>0&&c[0]<4?1:+(c[0]+c[1])),!u&&F&&(!(c=F.match(/Edge\/(\d+)/))||c[1]>=74)&&(c=F.match(/Chrome\/(\d+)/))&&(u=+c[1]);var U=u,W=!!Object.getOwnPropertySymbols&&!p((function(){var t=Symbol();return!String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&U&&U<41})),K=W&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,Y=f.Object,X=K?function(t){return"symbol"==typeof t}:function(t){var e=H("Symbol");return M(e)&&D(e.prototype,Y(t))},Q=f.String,J=function(t){try{return Q(t)}catch(t){return"Object"}},Z=f.TypeError,tt=function(t){if(M(t))return t;throw Z(J(t)+" is not a function")},et=function(t,e){var n=t[e];return null==n?void 0:tt(n)},nt=f.TypeError,it=Object.defineProperty,ot=function(t,e){try{it(f,t,{value:e,configurable:!0,writable:!0})}catch(n){f[t]=e}return e},rt=f["__core-js_shared__"]||ot("__core-js_shared__",{}),at=l((function(t){(t.exports=function(t,e){return rt[t]||(rt[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.21.1",mode:"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE",source:"https://github.com/zloirock/core-js"})})),st=f.Object,lt=function(t){return st(P(t))},ct=A({}.hasOwnProperty),ut=Object.hasOwn||function(t,e){return ct(lt(t),e)},ht=0,ft=Math.random(),pt=A(1..toString),dt=function(t){return"Symbol("+(void 0===t?"":t)+")_"+pt(++ht+ft,36)},gt=at("wks"),vt=f.Symbol,mt=vt&&vt.for,bt=K?vt:vt&&vt.withoutSetter||dt,yt=function(t){if(!ut(gt,t)||!W&&"string"!=typeof gt[t]){var e="Symbol."+t;W&&ut(vt,t)?gt[t]=vt[t]:gt[t]=K&&mt?mt(e):bt(e)}return gt[t]},wt=f.TypeError,_t=yt("toPrimitive"),St=function(t,e){if(!q(t)||X(t))return t;var n,i=et(t,_t);if(i){if(void 0===e&&(e="default"),n=m(i,t,e),!q(n)||X(n))return n;throw wt("Can't convert object to primitive value")}return void 0===e&&(e="number"),function(t,e){var n,i;if("string"===e&&M(n=t.toString)&&!q(i=m(n,t)))return i;if(M(n=t.valueOf)&&!q(i=m(n,t)))return i;if("string"!==e&&M(n=t.toString)&&!q(i=m(n,t)))return i;throw nt("Can't convert object to primitive value")}(t,e)},xt=function(t){var e=St(t,"string");return X(e)?e:e+""},jt=f.document,Ct=q(jt)&&q(jt.createElement),At=function(t){return Ct?jt.createElement(t):{}},kt=!d&&!p((function(){return 7!=Object.defineProperty(At("div"),"a",{get:function(){return 7}}).a})),Et=Object.getOwnPropertyDescriptor,Tt={f:d?Et:function(t,e){if(t=R(t),e=xt(e),kt)try{return Et(t,e)}catch(t){}if(ut(t,e))return _(!m(w.f,t,e),t[e])}},It=d&&p((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype})),Nt=f.String,Lt=f.TypeError,Ot=function(t){if(q(t))return t;throw Lt(Nt(t)+" is not an object")},Pt=f.TypeError,Rt=Object.defineProperty,Mt=Object.getOwnPropertyDescriptor,qt={f:d?It?function(t,e,n){if(Ot(t),e=xt(e),Ot(n),"function"==typeof t&&"prototype"===e&&"value"in n&&"writable"in n&&!n.writable){var i=Mt(t,e);i&&i.writable&&(t[e]=n.value,n={configurable:"configurable"in n?n.configurable:i.configurable,enumerable:"enumerable"in n?n.enumerable:i.enumerable,writable:!1})}return Rt(t,e,n)}:Rt:function(t,e,n){if(Ot(t),e=xt(e),Ot(n),kt)try{return Rt(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Pt("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},Bt=d?function(t,e,n){return qt.f(t,e,_(1,n))}:function(t,e,n){return t[e]=n,t},Ht=A(Function.toString);M(rt.inspectSource)||(rt.inspectSource=function(t){return Ht(t)});var Dt,Ft,$t,Gt=rt.inspectSource,Vt=f.WeakMap,zt=M(Vt)&&/native code/.test(Gt(Vt)),Ut=at("keys"),Wt=function(t){return Ut[t]||(Ut[t]=dt(t))},Kt={},Yt=f.TypeError,Xt=f.WeakMap;if(zt||rt.state){var Qt=rt.state||(rt.state=new Xt),Jt=A(Qt.get),Zt=A(Qt.has),te=A(Qt.set);Dt=function(t,e){if(Zt(Qt,t))throw new Yt("Object already initialized");return e.facade=t,te(Qt,t,e),e},Ft=function(t){return Jt(Qt,t)||{}},$t=function(t){return Zt(Qt,t)}}else{var ee=Wt("state");Kt[ee]=!0,Dt=function(t,e){if(ut(t,ee))throw new Yt("Object already initialized");return e.facade=t,Bt(t,ee,e),e},Ft=function(t){return ut(t,ee)?t[ee]:{}},$t=function(t){return ut(t,ee)}}var ne={set:Dt,get:Ft,has:$t,enforce:function(t){return $t(t)?Ft(t):Dt(t,{})},getterFor:function(t){return function(e){var n;if(!q(e)||(n=Ft(e)).type!==t)throw Yt("Incompatible receiver, "+t+" required");return n}}},ie=Function.prototype,oe=d&&Object.getOwnPropertyDescriptor,re=ut(ie,"name"),ae={EXISTS:re,PROPER:re&&"something"===function(){}.name,CONFIGURABLE:re&&(!d||d&&oe(ie,"name").configurable)},se=l((function(t){var e=ae.CONFIGURABLE,n=ne.get,i=ne.enforce,o=String(String).split("String");(t.exports=function(t,n,r,a){var s,l=!!a&&!!a.unsafe,c=!!a&&!!a.enumerable,u=!!a&&!!a.noTargetGet,h=a&&void 0!==a.name?a.name:n;M(r)&&("Symbol("===String(h).slice(0,7)&&(h="["+String(h).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!ut(r,"name")||e&&r.name!==h)&&Bt(r,"name",h),(s=i(r)).source||(s.source=o.join("string"==typeof h?h:""))),t!==f?(l?!u&&t[n]&&(c=!0):delete t[n],c?t[n]=r:Bt(t,n,r)):c?t[n]=r:ot(n,r)})(Function.prototype,"toString",(function(){return M(this)&&n(this).source||Gt(this)}))})),le=Math.ceil,ce=Math.floor,ue=function(t){var e=+t;return e!=e||0===e?0:(e>0?ce:le)(e)},he=Math.max,fe=Math.min,pe=function(t,e){var n=ue(t);return n<0?he(n+e,0):fe(n,e)},de=Math.min,ge=function(t){return t>0?de(ue(t),9007199254740991):0},ve=function(t){return ge(t.length)},me=function(t){return function(e,n,i){var o,r=R(e),a=ve(r),s=pe(i,a);if(t&&n!=n){for(;a>s;)if((o=r[s++])!=o)return!0}else for(;a>s;s++)if((t||s in r)&&r[s]===n)return t||s||0;return!t&&-1}},be={includes:me(!0),indexOf:me(!1)},ye=be.indexOf,we=A([].push),_e=function(t,e){var n,i=R(t),o=0,r=[];for(n in i)!ut(Kt,n)&&ut(i,n)&&we(r,n);for(;e.length>o;)ut(i,n=e[o++])&&(~ye(r,n)||we(r,n));return r},Se=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],xe=Se.concat("length","prototype"),je={f:Object.getOwnPropertyNames||function(t){return _e(t,xe)}},Ce={f:Object.getOwnPropertySymbols},Ae=A([].concat),ke=H("Reflect","ownKeys")||function(t){var e=je.f(Ot(t)),n=Ce.f;return n?Ae(e,n(t)):e},Ee=function(t,e,n){for(var i=ke(e),o=qt.f,r=Tt.f,a=0;a<i.length;a++){var s=i[a];ut(t,s)||n&&ut(n,s)||o(t,s,r(e,s))}},Te=/#|\.prototype\./,Ie=function(t,e){var n=Le[Ne(t)];return n==Pe||n!=Oe&&(M(e)?p(e):!!e)},Ne=Ie.normalize=function(t){return String(t).replace(Te,".").toLowerCase()},Le=Ie.data={},Oe=Ie.NATIVE="N",Pe=Ie.POLYFILL="P",Re=Ie,Me=Tt.f,qe=function(t,e){var n,i,o,r,a,s=t.target,l=t.global,c=t.stat;if(n=l?f:c?f[s]||ot(s,{}):(f[s]||{}).prototype)for(i in e){if(r=e[i],o=t.noTargetGet?(a=Me(n,i))&&a.value:n[i],!Re(l?i:s+(c?".":"#")+i,t.forced)&&void 0!==o){if(typeof r==typeof o)continue;Ee(r,o)}(t.sham||o&&o.sham)&&Bt(r,"sham",!0),se(n,i,r,t)}},Be={};Be[yt("toStringTag")]="z";var He,De="[object z]"===String(Be),Fe=yt("toStringTag"),$e=f.Object,Ge="Arguments"==T(function(){return arguments}()),Ve=De?T:function(t){var e,n,i;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=$e(t),Fe))?n:Ge?T(e):"Object"==(i=T(e))&&M(e.callee)?"Arguments":i},ze=f.String,Ue=function(t){if("Symbol"===Ve(t))throw TypeError("Cannot convert a Symbol value to a string");return ze(t)},We=function(){var t=Ot(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},Ke=f.RegExp,Ye=p((function(){var t=Ke("a","y");return t.lastIndex=2,null!=t.exec("abcd")})),Xe=Ye||p((function(){return!Ke("a","y").sticky})),Qe={BROKEN_CARET:Ye||p((function(){var t=Ke("^r","gy");return t.lastIndex=2,null!=t.exec("str")})),MISSED_STICKY:Xe,UNSUPPORTED_Y:Ye},Je=Object.keys||function(t){return _e(t,Se)},Ze=d&&!It?Object.defineProperties:function(t,e){Ot(t);for(var n,i=R(e),o=Je(e),r=o.length,a=0;r>a;)qt.f(t,n=o[a++],i[n]);return t},tn={f:Ze},en=H("document","documentElement"),nn=Wt("IE_PROTO"),on=function(){},rn=function(t){return"<script>"+t+"<\/script>"},an=function(t){t.write(rn("")),t.close();var e=t.parentWindow.Object;return t=null,e},sn=function(){try{He=new ActiveXObject("htmlfile")}catch(t){}var t,e;sn="undefined"!=typeof document?document.domain&&He?an(He):((e=At("iframe")).style.display="none",en.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write(rn("document.F=Object")),t.close(),t.F):an(He);for(var n=Se.length;n--;)delete sn.prototype[Se[n]];return sn()};Kt[nn]=!0;var ln,cn,un=Object.create||function(t,e){var n;return null!==t?(on.prototype=Ot(t),n=new on,on.prototype=null,n[nn]=t):n=sn(),void 0===e?n:tn.f(n,e)},hn=f.RegExp,fn=p((function(){var t=hn(".","s");return!(t.dotAll&&t.exec("\n")&&"s"===t.flags)})),pn=f.RegExp,dn=p((function(){var t=pn("(?<a>b)","g");return"b"!==t.exec("b").groups.a||"bc"!=="b".replace(t,"$<a>c")})),gn=ne.get,vn=at("native-string-replace",String.prototype.replace),mn=RegExp.prototype.exec,bn=mn,yn=A("".charAt),wn=A("".indexOf),_n=A("".replace),Sn=A("".slice),xn=(cn=/b*/g,m(mn,ln=/a/,"a"),m(mn,cn,"a"),0!==ln.lastIndex||0!==cn.lastIndex),jn=Qe.BROKEN_CARET,Cn=void 0!==/()??/.exec("")[1];(xn||Cn||jn||fn||dn)&&(bn=function(t){var e,n,i,o,r,a,s,l=this,c=gn(l),u=Ue(t),h=c.raw;if(h)return h.lastIndex=l.lastIndex,e=m(bn,h,u),l.lastIndex=h.lastIndex,e;var f=c.groups,p=jn&&l.sticky,d=m(We,l),g=l.source,v=0,b=u;if(p&&(d=_n(d,"y",""),-1===wn(d,"g")&&(d+="g"),b=Sn(u,l.lastIndex),l.lastIndex>0&&(!l.multiline||l.multiline&&"\n"!==yn(u,l.lastIndex-1))&&(g="(?: "+g+")",b=" "+b,v++),n=new RegExp("^(?:"+g+")",d)),Cn&&(n=new RegExp("^"+g+"$(?!\\s)",d)),xn&&(i=l.lastIndex),o=m(mn,p?n:l,b),p?o?(o.input=Sn(o.input,v),o[0]=Sn(o[0],v),o.index=l.lastIndex,l.lastIndex+=o[0].length):l.lastIndex=0:xn&&o&&(l.lastIndex=l.global?o.index+o[0].length:i),Cn&&o&&o.length>1&&m(vn,o[0],n,(function(){for(r=1;r<arguments.length-2;r++)void 0===arguments[r]&&(o[r]=void 0)})),o&&f)for(o.groups=a=un(null),r=0;r<f.length;r++)a[(s=f[r])[0]]=o[s[1]];return o});var An=bn;qe({target:"RegExp",proto:!0,forced:/./.exec!==An},{exec:An});var kn=yt("species"),En=RegExp.prototype,Tn=function(t,e,n,i){var o=yt(t),r=!p((function(){var e={};return e[o]=function(){return 7},7!=""[t](e)})),a=r&&!p((function(){var e=!1,n=/a/;return"split"===t&&((n={}).constructor={},n.constructor[kn]=function(){return n},n.flags="",n[o]=/./[o]),n.exec=function(){return e=!0,null},n[o](""),!e}));if(!r||!a||n){var s=A(/./[o]),l=e(o,""[t],(function(t,e,n,i,o){var a=A(t),l=e.exec;return l===An||l===En.exec?r&&!o?{done:!0,value:s(e,n,i)}:{done:!0,value:a(n,e,i)}:{done:!1}}));se(String.prototype,t,l[0]),se(En,o,l[1])}i&&Bt(En[o],"sham",!0)},In=A("".charAt),Nn=A("".charCodeAt),Ln=A("".slice),On=function(t){return function(e,n){var i,o,r=Ue(P(e)),a=ue(n),s=r.length;return a<0||a>=s?t?"":void 0:(i=Nn(r,a))<55296||i>56319||a+1===s||(o=Nn(r,a+1))<56320||o>57343?t?In(r,a):i:t?Ln(r,a,a+2):o-56320+(i-55296<<10)+65536}},Pn={codeAt:On(!1),charAt:On(!0)}.charAt,Rn=function(t,e,n){return e+(n?Pn(t,e).length:1)},Mn=f.TypeError,qn=function(t,e){var n=t.exec;if(M(n)){var i=m(n,t,e);return null!==i&&Ot(i),i}if("RegExp"===T(t))return m(An,t,e);throw Mn("RegExp#exec called on incompatible receiver")};Tn("match",(function(t,e,n){return[function(e){var n=P(this),i=null==e?void 0:et(e,t);return i?m(i,e,n):new RegExp(e)[t](Ue(n))},function(t){var i=Ot(this),o=Ue(t),r=n(e,i,o);if(r.done)return r.value;if(!i.global)return qn(i,o);var a=i.unicode;i.lastIndex=0;for(var s,l=[],c=0;null!==(s=qn(i,o));){var u=Ue(s[0]);l[c]=u,""===u&&(i.lastIndex=Rn(o,ge(i.lastIndex),a)),c++}return 0===c?null:l}]}));var Bn=Array.isArray||function(t){return"Array"==T(t)},Hn=function(t,e,n){var i=xt(e);i in t?qt.f(t,i,_(0,n)):t[i]=n},Dn=function(){},Fn=[],$n=H("Reflect","construct"),Gn=/^\s*(?:class|function)\b/,Vn=A(Gn.exec),zn=!Gn.exec(Dn),Un=function(t){if(!M(t))return!1;try{return $n(Dn,Fn,t),!0}catch(t){return!1}},Wn=function(t){if(!M(t))return!1;switch(Ve(t)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}try{return zn||!!Vn(Gn,Gt(t))}catch(t){return!0}};Wn.sham=!0;var Kn=!$n||p((function(){var t;return Un(Un.call)||!Un(Object)||!Un((function(){t=!0}))||t}))?Wn:Un,Yn=yt("species"),Xn=f.Array,Qn=function(t,e){return new(function(t){var e;return Bn(t)&&(e=t.constructor,(Kn(e)&&(e===Xn||Bn(e.prototype))||q(e)&&null===(e=e[Yn]))&&(e=void 0)),void 0===e?Xn:e}(t))(0===e?0:e)},Jn=yt("species"),Zn=function(t){return U>=51||!p((function(){var e=[];return(e.constructor={})[Jn]=function(){return{foo:1}},1!==e[t](Boolean).foo}))},ti=yt("isConcatSpreadable"),ei=f.TypeError,ni=U>=51||!p((function(){var t=[];return t[ti]=!1,t.concat()[0]!==t})),ii=Zn("concat"),oi=function(t){if(!q(t))return!1;var e=t[ti];return void 0!==e?!!e:Bn(t)};qe({target:"Array",proto:!0,forced:!ni||!ii},{concat:function(t){var e,n,i,o,r,a=lt(this),s=Qn(a,0),l=0;for(e=-1,i=arguments.length;e<i;e++)if(oi(r=-1===e?a:arguments[e])){if(l+(o=ve(r))>9007199254740991)throw ei("Maximum allowed index exceeded");for(n=0;n<o;n++,l++)n in r&&Hn(s,l,r[n])}else{if(l>=9007199254740991)throw ei("Maximum allowed index exceeded");Hn(s,l++,r)}return s.length=l,s}});var ri=De?{}.toString:function(){return"[object "+Ve(this)+"]"};De||se(Object.prototype,"toString",ri,{unsafe:!0});var ai=ae.PROPER,si=RegExp.prototype,li=si.toString,ci=A(We),ui=p((function(){return"/a/b"!=li.call({source:"a",flags:"b"})})),hi=ai&&"toString"!=li.name;(ui||hi)&&se(RegExp.prototype,"toString",(function(){var t=Ot(this),e=Ue(t.source),n=t.flags;return"/"+e+"/"+Ue(void 0===n&&D(si,t)&&!("flags"in si)?ci(t):n)}),{unsafe:!0});var fi=Function.prototype,pi=fi.apply,di=fi.call,gi="object"==typeof Reflect&&Reflect.apply||(g?di.bind(pi):function(){return di.apply(pi,arguments)}),vi=yt("match"),mi=function(t){var e;return q(t)&&(void 0!==(e=t[vi])?!!e:"RegExp"==T(t))},bi=f.TypeError,yi=yt("species"),wi=function(t,e){var n,i=Ot(t).constructor;return void 0===i||null==(n=Ot(i)[yi])?e:function(t){if(Kn(t))return t;throw bi(J(t)+" is not a constructor")}(n)},_i=f.Array,Si=Math.max,xi=function(t,e,n){for(var i=ve(t),o=pe(e,i),r=pe(void 0===n?i:n,i),a=_i(Si(r-o,0)),s=0;o<r;o++,s++)Hn(a,s,t[o]);return a.length=s,a},ji=Qe.UNSUPPORTED_Y,Ci=Math.min,Ai=[].push,ki=A(/./.exec),Ei=A(Ai),Ti=A("".slice);function Ii(t,e){if(t instanceof SVGElement){var n=t.getAttribute("class")||"";n.match(e)||t.setAttribute("class","".concat(n," ").concat(e))}else{if(void 0!==t.classList)r(e.split(" "),(function(e){t.classList.add(e)}));else t.className.match(e)||(t.className+=" ".concat(e))}}function Ni(t,e){var n="";return t.currentStyle?n=t.currentStyle[e]:document.defaultView&&document.defaultView.getComputedStyle&&(n=document.defaultView.getComputedStyle(t,null).getPropertyValue(e)),n&&n.toLowerCase?n.toLowerCase():n}function Li(t){var e=t.element;if(this._options.scrollToElement){var n=function(t){var e=window.getComputedStyle(t),n="absolute"===e.position,i=/(auto|scroll)/;if("fixed"===e.position)return document.body;for(var o=t;o=o.parentElement;)if(e=window.getComputedStyle(o),(!n||"static"!==e.position)&&i.test(e.overflow+e.overflowY+e.overflowX))return o;return document.body}(e);n!==document.body&&(n.scrollTop=e.offsetTop-n.offsetTop)}}function Oi(){if(void 0!==window.innerWidth)return{width:window.innerWidth,height:window.innerHeight};var t=document.documentElement;return{width:t.clientWidth,height:t.clientHeight}}function Pi(t,e,n){var i,o=e.element;if("off"!==t&&(this._options.scrollToElement&&(i="tooltip"===t?n.getBoundingClientRect():o.getBoundingClientRect(),!function(t){var e=t.getBoundingClientRect();return e.top>=0&&e.left>=0&&e.bottom+80<=window.innerHeight&&e.right<=window.innerWidth}(o)))){var r=Oi().height;i.bottom-(i.bottom-i.top)<0||o.clientHeight>r?window.scrollBy(0,i.top-(r/2-i.height/2)-this._options.scrollPadding):window.scrollBy(0,i.top-(r/2-i.height/2)+this._options.scrollPadding)}}function Ri(t){t.setAttribute("role","button"),t.tabIndex=0}Tn("split",(function(t,e,n){var i;return i="c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1).length||2!="ab".split(/(?:ab)*/).length||4!=".".split(/(.?)(.?)/).length||".".split(/()()/).length>1||"".split(/.?/).length?function(t,n){var i=Ue(P(this)),o=void 0===n?4294967295:n>>>0;if(0===o)return[];if(void 0===t)return[i];if(!mi(t))return m(e,i,t,o);for(var r,a,s,l=[],c=(t.ignoreCase?"i":"")+(t.multiline?"m":"")+(t.unicode?"u":"")+(t.sticky?"y":""),u=0,h=new RegExp(t.source,c+"g");(r=m(An,h,i))&&!((a=h.lastIndex)>u&&(Ei(l,Ti(i,u,r.index)),r.length>1&&r.index<i.length&&gi(Ai,l,xi(r,1)),s=r[0].length,u=a,l.length>=o));)h.lastIndex===r.index&&h.lastIndex++;return u===i.length?!s&&ki(h,"")||Ei(l,""):Ei(l,Ti(i,u)),l.length>o?xi(l,0,o):l}:"0".split(void 0,0).length?function(t,n){return void 0===t&&0===n?[]:m(e,this,t,n)}:e,[function(e,n){var o=P(this),r=null==e?void 0:et(e,t);return r?m(r,e,o,n):m(i,Ue(o),e,n)},function(t,o){var r=Ot(this),a=Ue(t),s=n(i,r,a,o,i!==e);if(s.done)return s.value;var l=wi(r,RegExp),c=r.unicode,u=(r.ignoreCase?"i":"")+(r.multiline?"m":"")+(r.unicode?"u":"")+(ji?"g":"y"),h=new l(ji?"^(?:"+r.source+")":r,u),f=void 0===o?4294967295:o>>>0;if(0===f)return[];if(0===a.length)return null===qn(h,a)?[a]:[];for(var p=0,d=0,g=[];d<a.length;){h.lastIndex=ji?0:d;var v,m=qn(h,ji?Ti(a,d):a);if(null===m||(v=Ci(ge(h.lastIndex+(ji?d:0)),a.length))===p)d=Rn(a,d,c);else{if(Ei(g,Ti(a,p,d)),g.length===f)return g;for(var b=1;b<=m.length-1;b++)if(Ei(g,m[b]),g.length===f)return g;d=p=v}}return Ei(g,Ti(a,p)),g}]}),!!p((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2!==n.length||"a"!==n[0]||"b"!==n[1]})),ji);var Mi=Object.assign,qi=Object.defineProperty,Bi=A([].concat),Hi=!Mi||p((function(){if(d&&1!==Mi({b:1},Mi(qi({},"a",{enumerable:!0,get:function(){qi(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach((function(t){e[t]=t})),7!=Mi({},t)[n]||Je(Mi({},e)).join("")!=i}))?function(t,e){for(var n=lt(t),i=arguments.length,o=1,r=Ce.f,a=w.f;i>o;)for(var s,l=L(arguments[o++]),c=r?Bi(Je(l),r(l)):Je(l),u=c.length,h=0;u>h;)s=c[h++],d&&!m(a,l,s)||(n[s]=l[s]);return n}:Mi;function Di(t){var e=t.parentNode;return!(!e||"HTML"===e.nodeName)&&("fixed"===Ni(t,"position")||Di(e))}function Fi(t,e){var n=document.body,i=document.documentElement,o=window.pageYOffset||i.scrollTop||n.scrollTop,r=window.pageXOffset||i.scrollLeft||n.scrollLeft;e=e||n;var a=t.getBoundingClientRect(),s=e.getBoundingClientRect(),l=Ni(e,"position"),c={width:a.width,height:a.height};return"body"!==e.tagName.toLowerCase()&&"relative"===l||"sticky"===l?Object.assign(c,{top:a.top-s.top,left:a.left-s.left}):Di(t)?Object.assign(c,{top:a.top,left:a.left}):Object.assign(c,{top:a.top+o,left:a.left+r})}qe({target:"Object",stat:!0,forced:Object.assign!==Hi},{assign:Hi});var $i=Math.floor,Gi=A("".charAt),Vi=A("".replace),zi=A("".slice),Ui=/\$([$&'`]|\d{1,2}|<[^>]*>)/g,Wi=/\$([$&'`]|\d{1,2})/g,Ki=function(t,e,n,i,o,r){var a=n+t.length,s=i.length,l=Wi;return void 0!==o&&(o=lt(o),l=Ui),Vi(r,l,(function(r,l){var c;switch(Gi(l,0)){case"$":return"$";case"&":return t;case"`":return zi(e,0,n);case"'":return zi(e,a);case"<":c=o[zi(l,1,-1)];break;default:var u=+l;if(0===u)return r;if(u>s){var h=$i(u/10);return 0===h?r:h<=s?void 0===i[h-1]?Gi(l,1):i[h-1]+Gi(l,1):r}c=i[u-1]}return void 0===c?"":c}))},Yi=yt("replace"),Xi=Math.max,Qi=Math.min,Ji=A([].concat),Zi=A([].push),to=A("".indexOf),eo=A("".slice),no="$0"==="a".replace(/./,"$0"),io=!!/./[Yi]&&""===/./[Yi]("a","$0");function oo(t,e){if(t instanceof SVGElement){var n=t.getAttribute("class")||"";t.setAttribute("class",n.replace(e,"").replace(/^\s+|\s+$/g,""))}else t.className=t.className.replace(e,"").replace(/^\s+|\s+$/g,"")}function ro(t,e){var n="";if(t.style.cssText&&(n+=t.style.cssText),"string"==typeof e)n+=e;else for(var i in e)n+="".concat(i,":").concat(e[i],";");t.style.cssText=n}function ao(t){if(t){if(!this._introItems[this._currentStep])return;var e=this._introItems[this._currentStep],n=Fi(e.element,this._targetElement),i=this._options.helperElementPadding;Di(e.element)?Ii(t,"introjs-fixedTooltip"):oo(t,"introjs-fixedTooltip"),"floating"===e.position&&(i=0),ro(t,{width:"".concat(n.width+i,"px"),height:"".concat(n.height+i,"px"),top:"".concat(n.top-i/2,"px"),left:"".concat(n.left-i/2,"px")})}}Tn("replace",(function(t,e,n){var i=io?"$":"$0";return[function(t,n){var i=P(this),o=null==t?void 0:et(t,Yi);return o?m(o,t,i,n):m(e,Ue(i),t,n)},function(t,o){var r=Ot(this),a=Ue(t);if("string"==typeof o&&-1===to(o,i)&&-1===to(o,"$<")){var s=n(e,r,a,o);if(s.done)return s.value}var l=M(o);l||(o=Ue(o));var c=r.global;if(c){var u=r.unicode;r.lastIndex=0}for(var h=[];;){var f=qn(r,a);if(null===f)break;if(Zi(h,f),!c)break;""===Ue(f[0])&&(r.lastIndex=Rn(a,ge(r.lastIndex),u))}for(var p,d="",g=0,v=0;v<h.length;v++){for(var m=Ue((f=h[v])[0]),b=Xi(Qi(ue(f.index),a.length),0),y=[],w=1;w<f.length;w++)Zi(y,void 0===(p=f[w])?p:String(p));var _=f.groups;if(l){var S=Ji([m],y,b,a);void 0!==_&&Zi(S,_);var x=Ue(gi(o,void 0,S))}else x=Ki(m,a,b,y,_,o);b>=g&&(d+=eo(a,g,b)+x,g=b+m.length)}return d+eo(a,g)}]}),!!p((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}))||!no||io);var so=yt("unscopables"),lo=Array.prototype;null==lo[so]&&qt.f(lo,so,{configurable:!0,value:un(null)});var co,uo=be.includes;qe({target:"Array",proto:!0},{includes:function(t){return uo(this,t,arguments.length>1?arguments[1]:void 0)}}),co="includes",lo[so][co]=!0;var ho=A([].slice),fo=Zn("slice"),po=yt("species"),go=f.Array,vo=Math.max;qe({target:"Array",proto:!0,forced:!fo},{slice:function(t,e){var n,i,o,r=R(this),a=ve(r),s=pe(t,a),l=pe(void 0===e?a:e,a);if(Bn(r)&&(n=r.constructor,(Kn(n)&&(n===go||Bn(n.prototype))||q(n)&&null===(n=n[po]))&&(n=void 0),n===go||void 0===n))return ho(r,s,l);for(i=new(void 0===n?go:n)(vo(l-s,0)),o=0;s<l;s++,o++)s in r&&Hn(i,o,r[s]);return i.length=o,i}});var mo=f.TypeError,bo=function(t){if(mi(t))throw mo("The method doesn't accept regular expressions");return t},yo=yt("match"),wo=A("".indexOf);qe({target:"String",proto:!0,forced:!function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[yo]=!1,"/./"[t](e)}catch(t){}}return!1}("includes")},{includes:function(t){return!!~wo(Ue(P(this)),Ue(bo(t)),arguments.length>1?arguments[1]:void 0)}});var _o=function(t,e){var n=[][t];return!!n&&p((function(){n.call(null,e||function(){return 1},1)}))},So=A([].join),xo=L!=Object,jo=_o("join",",");qe({target:"Array",proto:!0,forced:xo||!jo},{join:function(t){return So(R(this),void 0===t?",":t)}});var Co=A(A.bind),Ao=A([].push),ko=function(t){var e=1==t,n=2==t,i=3==t,o=4==t,r=6==t,a=7==t,s=5==t||r;return function(l,c,u,h){for(var f,p,d=lt(l),v=L(d),m=function(t,e){return tt(t),void 0===e?t:g?Co(t,e):function(){return t.apply(e,arguments)}}(c,u),b=ve(v),y=0,w=h||Qn,_=e?w(l,b):n||a?w(l,0):void 0;b>y;y++)if((s||y in v)&&(p=m(f=v[y],y,d),t))if(e)_[y]=p;else if(p)switch(t){case 3:return!0;case 5:return f;case 6:return y;case 2:Ao(_,f)}else switch(t){case 4:return!1;case 7:Ao(_,f)}return r?-1:i||o?o:_}},Eo={forEach:ko(0),map:ko(1),filter:ko(2),some:ko(3),every:ko(4),find:ko(5),findIndex:ko(6),filterReject:ko(7)},To=Eo.filter;function Io(t,e,n,i,o){return t.left+e+n.width>i.width?(o.style.left="".concat(i.width-n.width-t.left,"px"),!1):(o.style.left="".concat(e,"px"),!0)}function No(t,e,n,i){return t.left+t.width-e-n.width<0?(i.style.left="".concat(-t.left,"px"),!1):(i.style.right="".concat(e,"px"),!0)}qe({target:"Array",proto:!0,forced:!Zn("filter")},{filter:function(t){return To(this,t,arguments.length>1?arguments[1]:void 0)}});var Lo=Zn("splice"),Oo=f.TypeError,Po=Math.max,Ro=Math.min;function Mo(t,e){t.includes(e)&&t.splice(t.indexOf(e),1)}function qo(t,e,n){var i=this._options.positionPrecedence.slice(),o=Oi(),r=Fi(e).height+10,a=Fi(e).width+20,s=t.getBoundingClientRect(),l="floating";s.bottom+r>o.height&&Mo(i,"bottom"),s.top-r<0&&Mo(i,"top"),s.right+a>o.width&&Mo(i,"right"),s.left-a<0&&Mo(i,"left");var c,u,h=-1!==(u=(c=n||"").indexOf("-"))?c.substr(u):"";return n&&(n=n.split("-")[0]),i.length&&(l=i.includes(n)?n:i[0]),["top","bottom"].includes(l)&&(l+=function(t,e,n,i){var o=n.width,r=e/2,a=Math.min(o,window.screen.width),s=["-left-aligned","-middle-aligned","-right-aligned"];return a-t<e&&Mo(s,"-left-aligned"),(t<r||a-t<r)&&Mo(s,"-middle-aligned"),t<e&&Mo(s,"-right-aligned"),s.length?s.includes(i)?i:s[0]:"-middle-aligned"}(s.left,a,o,h)),l}function Bo(t,e,n,i){var o,r,a,s,l,c="";if(i=i||!1,e.style.top=null,e.style.right=null,e.style.bottom=null,e.style.left=null,e.style.marginLeft=null,e.style.marginTop=null,n.style.display="inherit",this._introItems[this._currentStep])switch(c="string"==typeof(o=this._introItems[this._currentStep]).tooltipClass?o.tooltipClass:this._options.tooltipClass,e.className=["introjs-tooltip",c].filter(Boolean).join(" "),e.setAttribute("role","dialog"),"floating"!==(l=this._introItems[this._currentStep].position)&&this._options.autoPosition&&(l=qo.call(this,t,e,l)),a=Fi(t),r=Fi(e),s=Oi(),Ii(e,"introjs-".concat(l)),l){case"top-right-aligned":n.className="introjs-arrow bottom-right";var u=0;No(a,u,r,e),e.style.bottom="".concat(a.height+20,"px");break;case"top-middle-aligned":n.className="introjs-arrow bottom-middle";var h=a.width/2-r.width/2;i&&(h+=5),No(a,h,r,e)&&(e.style.right=null,Io(a,h,r,s,e)),e.style.bottom="".concat(a.height+20,"px");break;case"top-left-aligned":case"top":n.className="introjs-arrow bottom",Io(a,i?0:15,r,s,e),e.style.bottom="".concat(a.height+20,"px");break;case"right":e.style.left="".concat(a.width+20,"px"),a.top+r.height>s.height?(n.className="introjs-arrow left-bottom",e.style.top="-".concat(r.height-a.height-20,"px")):n.className="introjs-arrow left";break;case"left":i||!0!==this._options.showStepNumbers||(e.style.top="15px"),a.top+r.height>s.height?(e.style.top="-".concat(r.height-a.height-20,"px"),n.className="introjs-arrow right-bottom"):n.className="introjs-arrow right",e.style.right="".concat(a.width+20,"px");break;case"floating":n.style.display="none",e.style.left="50%",e.style.top="50%",e.style.marginLeft="-".concat(r.width/2,"px"),e.style.marginTop="-".concat(r.height/2,"px");break;case"bottom-right-aligned":n.className="introjs-arrow top-right",No(a,u=0,r,e),e.style.top="".concat(a.height+20,"px");break;case"bottom-middle-aligned":n.className="introjs-arrow top-middle",h=a.width/2-r.width/2,i&&(h+=5),No(a,h,r,e)&&(e.style.right=null,Io(a,h,r,s,e)),e.style.top="".concat(a.height+20,"px");break;default:n.className="introjs-arrow top",Io(a,0,r,s,e),e.style.top="".concat(a.height+20,"px")}}function Ho(){r(document.querySelectorAll(".introjs-showElement"),(function(t){oo(t,/introjs-[a-zA-Z]+/g)}))}function Do(t,e){var n=document.createElement(t);e=e||{};var i=/^(?:role|data-|aria-)/;for(var o in e){var r=e[o];"style"===o?ro(n,r):o.match(i)?n.setAttribute(o,r):n[o]=r}return n}function Fo(t,e,n){if(n){var i=e.style.opacity||"1";ro(e,{opacity:"0"}),window.setTimeout((function(){ro(e,{opacity:i})}),10)}t.appendChild(e)}function $o(){return parseInt(this._currentStep+1,10)/this._introItems.length*100}function Go(){var t=document.querySelector(".introjs-disableInteraction");null===t&&(t=Do("div",{className:"introjs-disableInteraction"}),this._targetElement.appendChild(t)),ao.call(this,t)}function Vo(t){var e=this,n=Do("div",{className:"introjs-bullets"});!1===this._options.showBullets&&(n.style.display="none");var i=Do("ul");i.setAttribute("role","tablist");var o=function(){e.goToStep(this.getAttribute("data-step-number"))};return r(this._introItems,(function(e,n){var r=e.step,a=Do("li"),s=Do("a");a.setAttribute("role","presentation"),s.setAttribute("role","tab"),s.onclick=o,n===t.step-1&&(s.className="active"),Ri(s),s.innerHTML="&nbsp;",s.setAttribute("data-step-number",r),a.appendChild(s),i.appendChild(a)})),n.appendChild(i),n}function zo(t,e){if(this._options.showBullets){var n=document.querySelector(".introjs-bullets");n&&n.parentNode.replaceChild(Vo.call(this,e),n)}}function Uo(t,e){this._options.showBullets&&(t.querySelector(".introjs-bullets li > a.active").className="",t.querySelector('.introjs-bullets li > a[data-step-number="'.concat(e.step,'"]')).className="active")}function Wo(){var t=Do("div");t.className="introjs-progress",!1===this._options.showProgress&&(t.style.display="none");var e=Do("div",{className:"introjs-progressbar"});return this._options.progressBarAdditionalClass&&(e.className+=" "+this._options.progressBarAdditionalClass),e.setAttribute("role","progress"),e.setAttribute("aria-valuemin",0),e.setAttribute("aria-valuemax",100),e.setAttribute("aria-valuenow",$o.call(this)),e.style.cssText="width:".concat($o.call(this),"%;"),t.appendChild(e),t}function Ko(t){t.querySelector(".introjs-progress .introjs-progressbar").style.cssText="width:".concat($o.call(this),"%;"),t.querySelector(".introjs-progress .introjs-progressbar").setAttribute("aria-valuenow",$o.call(this))}function Yo(t){var e=this;void 0!==this._introChangeCallback&&this._introChangeCallback.call(this,t.element);var n,i,o,r=this,a=document.querySelector(".introjs-helperLayer"),s=document.querySelector(".introjs-tooltipReferenceLayer"),l="introjs-helperLayer";if("string"==typeof t.highlightClass&&(l+=" ".concat(t.highlightClass)),"string"==typeof this._options.highlightClass&&(l+=" ".concat(this._options.highlightClass)),null!==a&&null!==s){var c=s.querySelector(".introjs-helperNumberLayer"),u=s.querySelector(".introjs-tooltiptext"),h=s.querySelector(".introjs-tooltip-title"),f=s.querySelector(".introjs-arrow"),p=s.querySelector(".introjs-tooltip");o=s.querySelector(".introjs-skipbutton"),i=s.querySelector(".introjs-prevbutton"),n=s.querySelector(".introjs-nextbutton"),a.className=l,p.style.opacity=0,p.style.display="none",Li.call(r,t),ao.call(r,a),ao.call(r,s),Ho(),r._lastShowElementTimer&&window.clearTimeout(r._lastShowElementTimer),r._lastShowElementTimer=window.setTimeout((function(){null!==c&&(c.innerHTML="".concat(t.step," ").concat(e._options.stepNumbersOfLabel," ").concat(e._introItems.length)),u.innerHTML=t.intro,h.innerHTML=t.title,p.style.display="block",Bo.call(r,t.element,p,f),Uo.call(r,s,t),Ko.call(r,s),p.style.opacity=1,(null!=n&&/introjs-donebutton/gi.test(n.className)||null!=n)&&n.focus(),Pi.call(r,t.scrollTo,t,u)}),350)}else{var d=Do("div",{className:l}),g=Do("div",{className:"introjs-tooltipReferenceLayer"}),v=Do("div",{className:"introjs-arrow"}),m=Do("div",{className:"introjs-tooltip"}),b=Do("div",{className:"introjs-tooltiptext"}),y=Do("div",{className:"introjs-tooltip-header"}),w=Do("h1",{className:"introjs-tooltip-title"}),_=Do("div");if(ro(d,{"box-shadow":"0 0 1px 2px rgba(33, 33, 33, 0.8), rgba(33, 33, 33, ".concat(r._options.overlayOpacity.toString(),") 0 0 0 5000px")}),Li.call(r,t),ao.call(r,d),ao.call(r,g),Fo(this._targetElement,d,!0),Fo(this._targetElement,g),b.innerHTML=t.intro,w.innerHTML=t.title,_.className="introjs-tooltipbuttons",!1===this._options.showButtons&&(_.style.display="none"),y.appendChild(w),m.appendChild(y),m.appendChild(b),this._options.dontShowAgain){var S=Do("div",{className:"introjs-dontShowAgain"}),x=Do("input",{type:"checkbox",id:"introjs-dontShowAgain",name:"introjs-dontShowAgain"});x.onchange=function(t){e.setDontShowAgain(t.target.checked)};var j=Do("label",{htmlFor:"introjs-dontShowAgain"});j.innerText=this._options.dontShowAgainLabel,S.appendChild(x),S.appendChild(j),m.appendChild(S)}m.appendChild(Vo.call(this,t)),m.appendChild(Wo.call(this));var C=Do("div");!0===this._options.showStepNumbers&&(C.className="introjs-helperNumberLayer",C.innerHTML="".concat(t.step," ").concat(this._options.stepNumbersOfLabel," ").concat(this._introItems.length),m.appendChild(C)),m.appendChild(v),g.appendChild(m),(n=Do("a")).onclick=function(){r._introItems.length-1!==r._currentStep?Jo.call(r):/introjs-donebutton/gi.test(n.className)&&("function"==typeof r._introCompleteCallback&&r._introCompleteCallback.call(r,r._currentStep,"done"),qr.call(r,r._targetElement))},Ri(n),n.innerHTML=this._options.nextLabel,(i=Do("a")).onclick=function(){0!==r._currentStep&&Zo.call(r)},Ri(i),i.innerHTML=this._options.prevLabel,Ri(o=Do("a",{className:"introjs-skipbutton"})),o.innerHTML=this._options.skipLabel,o.onclick=function(){r._introItems.length-1===r._currentStep&&"function"==typeof r._introCompleteCallback&&r._introCompleteCallback.call(r,r._currentStep,"skip"),"function"==typeof r._introSkipCallback&&r._introSkipCallback.call(r),qr.call(r,r._targetElement)},y.appendChild(o),this._introItems.length>1&&_.appendChild(i),_.appendChild(n),m.appendChild(_),Bo.call(r,t.element,m,v),Pi.call(this,t.scrollTo,t,m)}var A=r._targetElement.querySelector(".introjs-disableInteraction");A&&A.parentNode.removeChild(A),t.disableInteraction&&Go.call(r),0===this._currentStep&&this._introItems.length>1?(null!=n&&(n.className="".concat(this._options.buttonClass," introjs-nextbutton"),n.innerHTML=this._options.nextLabel),!0===this._options.hidePrev?(null!=i&&(i.className="".concat(this._options.buttonClass," introjs-prevbutton introjs-hidden")),null!=n&&Ii(n,"introjs-fullbutton")):null!=i&&(i.className="".concat(this._options.buttonClass," introjs-prevbutton introjs-disabled"))):this._introItems.length-1===this._currentStep||1===this._introItems.length?(null!=i&&(i.className="".concat(this._options.buttonClass," introjs-prevbutton")),!0===this._options.hideNext?(null!=n&&(n.className="".concat(this._options.buttonClass," introjs-nextbutton introjs-hidden")),null!=i&&Ii(i,"introjs-fullbutton")):null!=n&&(!0===this._options.nextToDone?(n.innerHTML=this._options.doneLabel,Ii(n,"".concat(this._options.buttonClass," introjs-nextbutton introjs-donebutton"))):n.className="".concat(this._options.buttonClass," introjs-nextbutton introjs-disabled"))):(null!=i&&(i.className="".concat(this._options.buttonClass," introjs-prevbutton")),null!=n&&(n.className="".concat(this._options.buttonClass," introjs-nextbutton"),n.innerHTML=this._options.nextLabel)),null!=i&&i.setAttribute("role","button"),null!=n&&n.setAttribute("role","button"),null!=o&&o.setAttribute("role","button"),null!=n&&n.focus(),function(t){var e=t.element;Ii(e,"introjs-showElement");var n=Ni(e,"position");"absolute"!==n&&"relative"!==n&&"sticky"!==n&&"fixed"!==n&&Ii(e,"introjs-relativePosition")}(t),void 0!==this._introAfterChangeCallback&&this._introAfterChangeCallback.call(this,t.element)}function Xo(t){this._currentStep=t-2,void 0!==this._introItems&&Jo.call(this)}function Qo(t){this._currentStepNumber=t,void 0!==this._introItems&&Jo.call(this)}function Jo(){var t=this;this._direction="forward",void 0!==this._currentStepNumber&&r(this._introItems,(function(e,n){e.step===t._currentStepNumber&&(t._currentStep=n-1,t._currentStepNumber=void 0)})),void 0===this._currentStep?this._currentStep=0:++this._currentStep;var e=this._introItems[this._currentStep],n=!0;return void 0!==this._introBeforeChangeCallback&&(n=this._introBeforeChangeCallback.call(this,e&&e.element)),!1===n?(--this._currentStep,!1):this._introItems.length<=this._currentStep?("function"==typeof this._introCompleteCallback&&this._introCompleteCallback.call(this,this._currentStep,"end"),void qr.call(this,this._targetElement)):void Yo.call(this,e)}function Zo(){if(this._direction="backward",0===this._currentStep)return!1;--this._currentStep;var t=this._introItems[this._currentStep],e=!0;if(void 0!==this._introBeforeChangeCallback&&(e=this._introBeforeChangeCallback.call(this,t&&t.element)),!1===e)return++this._currentStep,!1;Yo.call(this,t)}function tr(){return this._currentStep}function er(t){var e=void 0===t.code?t.which:t.code;if(null===e&&(e=null===t.charCode?t.keyCode:t.charCode),"Escape"!==e&&27!==e||!0!==this._options.exitOnEsc){if("ArrowLeft"===e||37===e)Zo.call(this);else if("ArrowRight"===e||39===e)Jo.call(this);else if("Enter"===e||"NumpadEnter"===e||13===e){var n=t.target||t.srcElement;n&&n.className.match("introjs-prevbutton")?Zo.call(this):n&&n.className.match("introjs-skipbutton")?(this._introItems.length-1===this._currentStep&&"function"==typeof this._introCompleteCallback&&this._introCompleteCallback.call(this,this._currentStep,"skip"),qr.call(this,this._targetElement)):n&&n.getAttribute("data-step-number")?n.click():Jo.call(this),t.preventDefault?t.preventDefault():t.returnValue=!1}}else qr.call(this,this._targetElement)}function nr(e){if(null===e||"object"!==t(e)||void 0!==e.nodeType)return e;var n={};for(var i in e)void 0!==window.jQuery&&e[i]instanceof window.jQuery?n[i]=e[i]:n[i]=nr(e[i]);return n}function ir(t){var e=document.querySelector(".introjs-hints");return e?e.querySelectorAll(t):[]}function or(t){var e=ir('.introjs-hint[data-step="'.concat(t,'"]'))[0];pr.call(this),e&&Ii(e,"introjs-hidehint"),void 0!==this._hintCloseCallback&&this._hintCloseCallback.call(this,t)}function rr(){var t=this;r(ir(".introjs-hint"),(function(e){or.call(t,e.getAttribute("data-step"))}))}function ar(){var t=this,e=ir(".introjs-hint");e&&e.length?r(e,(function(e){sr.call(t,e.getAttribute("data-step"))})):dr.call(this,this._targetElement)}function sr(t){var e=ir('.introjs-hint[data-step="'.concat(t,'"]'))[0];e&&oo(e,/introjs-hidehint/g)}function lr(){var t=this;r(ir(".introjs-hint"),(function(e){cr.call(t,e.getAttribute("data-step"))})),a.off(document,"click",pr,this,!1),a.off(window,"resize",gr,this,!0),this._hintsAutoRefreshFunction&&a.off(window,"scroll",this._hintsAutoRefreshFunction,this,!0)}function cr(t){var e=ir('.introjs-hint[data-step="'.concat(t,'"]'))[0];e&&e.parentNode.removeChild(e)}function ur(){var t=this,e=this,n=document.querySelector(".introjs-hints");null===n&&(n=Do("div",{className:"introjs-hints"}));r(this._introItems,(function(i,o){if(!document.querySelector('.introjs-hint[data-step="'.concat(o,'"]'))){var r=Do("a",{className:"introjs-hint"});Ri(r),r.onclick=function(t){return function(n){var i=n||window.event;i.stopPropagation&&i.stopPropagation(),null!==i.cancelBubble&&(i.cancelBubble=!0),fr.call(e,t)}}(o),i.hintAnimation||Ii(r,"introjs-hint-no-anim"),Di(i.element)&&Ii(r,"introjs-fixedhint");var a=Do("div",{className:"introjs-hint-dot"}),s=Do("div",{className:"introjs-hint-pulse"});r.appendChild(a),r.appendChild(s),r.setAttribute("data-step",o),i.targetElement=i.element,i.element=r,hr.call(t,i.hintPosition,r,i.targetElement),n.appendChild(r)}})),document.body.appendChild(n),void 0!==this._hintsAddedCallback&&this._hintsAddedCallback.call(this),this._options.hintAutoRefreshInterval>=0&&(this._hintsAutoRefreshFunction=function(t,e){var n,i=this;return function(){for(var o=arguments.length,r=new Array(o),a=0;a<o;a++)r[a]=arguments[a];clearTimeout(n),n=setTimeout((function(){t.apply(i,r)}),e)}}((function(){return gr.call(t)}),this._options.hintAutoRefreshInterval),a.on(window,"scroll",this._hintsAutoRefreshFunction,this,!0))}function hr(t,e,n){var i=e.style,o=Fi.call(this,n),r=20,a=20;switch(t){default:i.left="".concat(o.left,"px"),i.top="".concat(o.top,"px");break;case"top-right":i.left="".concat(o.left+o.width-r,"px"),i.top="".concat(o.top,"px");break;case"bottom-left":i.left="".concat(o.left,"px"),i.top="".concat(o.top+o.height-a,"px");break;case"bottom-right":i.left="".concat(o.left+o.width-r,"px"),i.top="".concat(o.top+o.height-a,"px");break;case"middle-left":i.left="".concat(o.left,"px"),i.top="".concat(o.top+(o.height-a)/2,"px");break;case"middle-right":i.left="".concat(o.left+o.width-r,"px"),i.top="".concat(o.top+(o.height-a)/2,"px");break;case"middle-middle":i.left="".concat(o.left+(o.width-r)/2,"px"),i.top="".concat(o.top+(o.height-a)/2,"px");break;case"bottom-middle":i.left="".concat(o.left+(o.width-r)/2,"px"),i.top="".concat(o.top+o.height-a,"px");break;case"top-middle":i.left="".concat(o.left+(o.width-r)/2,"px"),i.top="".concat(o.top,"px")}}function fr(t){var e=document.querySelector('.introjs-hint[data-step="'.concat(t,'"]')),n=this._introItems[t];void 0!==this._hintClickCallback&&this._hintClickCallback.call(this,e,n,t);var i=pr.call(this);if(parseInt(i,10)!==t){var o=Do("div",{className:"introjs-tooltip"}),r=Do("div"),a=Do("div"),s=Do("div");o.onclick=function(t){t.stopPropagation?t.stopPropagation():t.cancelBubble=!0},r.className="introjs-tooltiptext";var l=Do("p");if(l.innerHTML=n.hint,r.appendChild(l),this._options.hintShowButton){var c=Do("a");c.className=this._options.buttonClass,c.setAttribute("role","button"),c.innerHTML=this._options.hintButtonLabel,c.onclick=or.bind(this,t),r.appendChild(c)}a.className="introjs-arrow",o.appendChild(a),o.appendChild(r),this._currentStep=e.getAttribute("data-step"),s.className="introjs-tooltipReferenceLayer introjs-hintReference",s.setAttribute("data-step",e.getAttribute("data-step")),ao.call(this,s),s.appendChild(o),document.body.appendChild(s),Bo.call(this,e,o,a,!0)}}function pr(){var t=document.querySelector(".introjs-hintReference");if(t){var e=t.getAttribute("data-step");return t.parentNode.removeChild(t),e}}function dr(t){var e=this;if(this._introItems=[],this._options.hints)r(this._options.hints,(function(t){var n=nr(t);"string"==typeof n.element&&(n.element=document.querySelector(n.element)),n.hintPosition=n.hintPosition||e._options.hintPosition,n.hintAnimation=n.hintAnimation||e._options.hintAnimation,null!==n.element&&e._introItems.push(n)}));else{var n=t.querySelectorAll("*[data-hint]");if(!n||!n.length)return!1;r(n,(function(t){var n=t.getAttribute("data-hint-animation");n=n?"true"===n:e._options.hintAnimation,e._introItems.push({element:t,hint:t.getAttribute("data-hint"),hintPosition:t.getAttribute("data-hint-position")||e._options.hintPosition,hintAnimation:n,tooltipClass:t.getAttribute("data-tooltip-class"),position:t.getAttribute("data-position")||e._options.tooltipPosition})}))}ur.call(this),a.on(document,"click",pr,this,!1),a.on(window,"resize",gr,this,!0)}function gr(){var t=this;r(this._introItems,(function(e){var n=e.targetElement,i=e.hintPosition,o=e.element;void 0!==n&&hr.call(t,i,o,n)}))}qe({target:"Array",proto:!0,forced:!Lo},{splice:function(t,e){var n,i,o,r,a,s,l=lt(this),c=ve(l),u=pe(t,c),h=arguments.length;if(0===h?n=i=0:1===h?(n=0,i=c-u):(n=h-2,i=Ro(Po(ue(e),0),c-u)),c+n-i>9007199254740991)throw Oo("Maximum allowed length exceeded");for(o=Qn(l,i),r=0;r<i;r++)(a=u+r)in l&&Hn(o,r,l[a]);if(o.length=i,n<i){for(r=u;r<c-i;r++)s=r+n,(a=r+i)in l?l[s]=l[a]:delete l[s];for(r=c;r>c-i+n;r--)delete l[r-1]}else if(n>i)for(r=c-i;r>u;r--)s=r+n-1,(a=r+i-1)in l?l[s]=l[a]:delete l[s];for(r=0;r<n;r++)l[r+u]=arguments[r+2];return l.length=c-i+n,o}});var vr=Math.floor,mr=function(t,e){var n=t.length,i=vr(n/2);return n<8?br(t,e):yr(t,mr(xi(t,0,i),e),mr(xi(t,i),e),e)},br=function(t,e){for(var n,i,o=t.length,r=1;r<o;){for(i=r,n=t[r];i&&e(t[i-1],n)>0;)t[i]=t[--i];i!==r++&&(t[i]=n)}return t},yr=function(t,e,n,i){for(var o=e.length,r=n.length,a=0,s=0;a<o||s<r;)t[a+s]=a<o&&s<r?i(e[a],n[s])<=0?e[a++]:n[s++]:a<o?e[a++]:n[s++];return t},wr=mr,_r=F.match(/firefox\/(\d+)/i),Sr=!!_r&&+_r[1],xr=/MSIE|Trident/.test(F),jr=F.match(/AppleWebKit\/(\d+)\./),Cr=!!jr&&+jr[1],Ar=[],kr=A(Ar.sort),Er=A(Ar.push),Tr=p((function(){Ar.sort(void 0)})),Ir=p((function(){Ar.sort(null)})),Nr=_o("sort"),Lr=!p((function(){if(U)return U<70;if(!(Sr&&Sr>3)){if(xr)return!0;if(Cr)return Cr<603;var t,e,n,i,o="";for(t=65;t<76;t++){switch(e=String.fromCharCode(t),t){case 66:case 69:case 70:case 72:n=3;break;case 68:case 71:n=4;break;default:n=2}for(i=0;i<47;i++)Ar.push({k:e+i,v:n})}for(Ar.sort((function(t,e){return e.v-t.v})),i=0;i<Ar.length;i++)e=Ar[i].k.charAt(0),o.charAt(o.length-1)!==e&&(o+=e);return"DGBEFHACIJK"!==o}}));function Or(t){var e=this,n=t.querySelectorAll("*[data-intro]"),i=[];if(this._options.steps)r(this._options.steps,(function(t){var n=nr(t);if(n.step=i.length+1,n.title=n.title||"","string"==typeof n.element&&(n.element=document.querySelector(n.element)),void 0===n.element||null===n.element){var o=document.querySelector(".introjsFloatingElement");null===o&&(o=Do("div",{className:"introjsFloatingElement"}),document.body.appendChild(o)),n.element=o,n.position="floating"}n.position=n.position||e._options.tooltipPosition,n.scrollTo=n.scrollTo||e._options.scrollTo,void 0===n.disableInteraction&&(n.disableInteraction=e._options.disableInteraction),null!==n.element&&i.push(n)}));else{var o;if(n.length<1)return[];r(n,(function(t){if((!e._options.group||t.getAttribute("data-intro-group")===e._options.group)&&"none"!==t.style.display){var n=parseInt(t.getAttribute("data-step"),10);o=t.hasAttribute("data-disable-interaction")?!!t.getAttribute("data-disable-interaction"):e._options.disableInteraction,n>0&&(i[n-1]={element:t,title:t.getAttribute("data-title")||"",intro:t.getAttribute("data-intro"),step:parseInt(t.getAttribute("data-step"),10),tooltipClass:t.getAttribute("data-tooltip-class"),highlightClass:t.getAttribute("data-highlight-class"),position:t.getAttribute("data-position")||e._options.tooltipPosition,scrollTo:t.getAttribute("data-scroll-to")||e._options.scrollTo,disableInteraction:o})}}));var a=0;r(n,(function(t){if((!e._options.group||t.getAttribute("data-intro-group")===e._options.group)&&null===t.getAttribute("data-step")){for(;void 0!==i[a];)a++;o=t.hasAttribute("data-disable-interaction")?!!t.getAttribute("data-disable-interaction"):e._options.disableInteraction,i[a]={element:t,title:t.getAttribute("data-title")||"",intro:t.getAttribute("data-intro"),step:a+1,tooltipClass:t.getAttribute("data-tooltip-class"),highlightClass:t.getAttribute("data-highlight-class"),position:t.getAttribute("data-position")||e._options.tooltipPosition,scrollTo:t.getAttribute("data-scroll-to")||e._options.scrollTo,disableInteraction:o}}}))}for(var s=[],l=0;l<i.length;l++)i[l]&&s.push(i[l]);return(i=s).sort((function(t,e){return t.step-e.step})),i}function Pr(t){var e=document.querySelector(".introjs-tooltipReferenceLayer"),n=document.querySelector(".introjs-helperLayer"),i=document.querySelector(".introjs-disableInteraction");if(ao.call(this,n),ao.call(this,e),ao.call(this,i),t&&(this._introItems=Or.call(this,this._targetElement),zo.call(this,e,this._introItems[this._currentStep]),Ko.call(this,e)),void 0!==this._currentStep&&null!==this._currentStep){var o=document.querySelector(".introjs-arrow"),r=document.querySelector(".introjs-tooltip");r&&o&&Bo.call(this,this._introItems[this._currentStep].element,r,o)}return gr.call(this),this}function Rr(){Pr.call(this)}function Mr(t,e){if(t&&t.parentElement){var n=t.parentElement;e?(ro(t,{opacity:"0"}),window.setTimeout((function(){try{n.removeChild(t)}catch(t){}}),500)):n.removeChild(t)}}function qr(t,e){var n=!0;if(void 0!==this._introBeforeExitCallback&&(n=this._introBeforeExitCallback.call(this)),e||!1!==n){var i=t.querySelectorAll(".introjs-overlay");i&&i.length&&r(i,(function(t){return Mr(t)})),Mr(t.querySelector(".introjs-helperLayer"),!0),Mr(t.querySelector(".introjs-tooltipReferenceLayer")),Mr(t.querySelector(".introjs-disableInteraction")),Mr(document.querySelector(".introjsFloatingElement")),Ho(),a.off(window,"keydown",er,this,!0),a.off(window,"resize",Rr,this,!0),void 0!==this._introExitCallback&&this._introExitCallback.call(this),this._currentStep=void 0}}function Br(t){var e=this,n=Do("div",{className:"introjs-overlay"});return ro(n,{top:0,bottom:0,left:0,right:0,position:"fixed"}),t.appendChild(n),!0===this._options.exitOnOverlayClick&&(ro(n,{cursor:"pointer"}),n.onclick=function(){qr.call(e,t)}),!0}function Hr(t){if(this.isActive()){void 0!==this._introStartCallback&&this._introStartCallback.call(this,t);var e=Or.call(this,t);return 0===e.length||(this._introItems=e,Br.call(this,t)&&(Jo.call(this),this._options.keyboardNavigation&&a.on(window,"keydown",er,this,!0),a.on(window,"resize",Rr,this,!0))),!1}}qe({target:"Array",proto:!0,forced:Tr||!Ir||!Nr||!Lr},{sort:function(t){void 0!==t&&tt(t);var e=lt(this);if(Lr)return void 0===t?kr(e):kr(e,t);var n,i,o=[],r=ve(e);for(i=0;i<r;i++)i in e&&Er(o,e[i]);for(wr(o,function(t){return function(e,n){return void 0===n?-1:void 0===e?1:void 0!==t?+t(e,n)||0:Ue(e)>Ue(n)?1:-1}}(t)),n=o.length,i=0;i<n;)e[i]=o[i++];for(;i<r;)delete e[i++];return e}});var Dr={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0},Fr=At("span").classList,$r=Fr&&Fr.constructor&&Fr.constructor.prototype,Gr=$r===Object.prototype?void 0:$r,Vr=Eo.forEach,zr=_o("forEach")?[].forEach:function(t){return Vr(this,t,arguments.length>1?arguments[1]:void 0)},Ur=function(t){if(t&&t.forEach!==zr)try{Bt(t,"forEach",zr)}catch(e){t.forEach=zr}};for(var Wr in Dr)Dr[Wr]&&Ur(f[Wr]&&f[Wr].prototype);Ur(Gr);var Kr,Yr="\t\n\v\f\r                　\u2028\u2029\ufeff",Xr=A("".replace),Qr="["+Yr+"]",Jr=RegExp("^"+Qr+Qr+"*"),Zr=RegExp(Qr+Qr+"*$"),ta=function(t){return function(e){var n=Ue(P(e));return 1&t&&(n=Xr(n,Jr,"")),2&t&&(n=Xr(n,Zr,"")),n}},ea={start:ta(1),end:ta(2),trim:ta(3)},na=ae.PROPER,ia=ea.trim;function oa(t,n,i){var o,r=(e(o={},t,n),e(o,"path","/"),o);if(i){var a=new Date;a.setTime(a.getTime()+24*i*60*60*1e3),r.expires=a.toUTCString()}var s=[];for(var l in r)s.push("".concat(l,"=").concat(r[l]));return document.cookie=s.join("; "),ra(t)}function ra(t){return(e={},document.cookie.split(";").forEach((function(t){var i=n(t.split("="),2),o=i[0],r=i[1];e[o.trim()]=r})),e)[t];var e}qe({target:"String",proto:!0,forced:(Kr="trim",p((function(){return!!Yr[Kr]()||"​᠎"!=="​᠎"[Kr]()||na&&Yr[Kr].name!==Kr})))},{trim:function(){return ia(this)}});function aa(t){t?oa(this._options.dontShowAgainCookie,"true",this._options.dontShowAgainCookieDays):oa(this._options.dontShowAgainCookie,"",-1)}function sa(){var t=ra(this._options.dontShowAgainCookie);return t&&"true"===t}function la(t){this._targetElement=t,this._introItems=[],this._options={isActive:!0,nextLabel:"Next",prevLabel:"Back",skipLabel:"×",doneLabel:"Done",hidePrev:!1,hideNext:!1,nextToDone:!0,tooltipPosition:"bottom",tooltipClass:"",group:"",highlightClass:"",exitOnEsc:!0,exitOnOverlayClick:!0,showStepNumbers:!1,stepNumbersOfLabel:"of",keyboardNavigation:!0,showButtons:!0,showBullets:!0,showProgress:!1,scrollToElement:!0,scrollTo:"element",scrollPadding:30,overlayOpacity:.5,autoPosition:!0,positionPrecedence:["bottom","top","right","left"],disableInteraction:!1,dontShowAgain:!1,dontShowAgainLabel:"Don't show this again",dontShowAgainCookie:"introjs-dontShowAgain",dontShowAgainCookieDays:365,helperElementPadding:10,hintPosition:"top-middle",hintButtonLabel:"Got it",hintShowButton:!0,hintAutoRefreshInterval:10,hintAnimation:!0,buttonClass:"introjs-button",progressBarAdditionalClass:!1}}var ca=function e(n){var i;if("object"===t(n))i=new la(n);else if("string"==typeof n){var r=document.querySelector(n);if(!r)throw new Error("There is no element with given selector.");i=new la(r)}else i=new la(document.body);return e.instances[o(i,"introjs-instance")]=i,i};ca.version="5.1.0",ca.instances={},ca.fn=la.prototype={isActive:function(){return(!this._options.dontShowAgain||!sa.call(this))&&this._options.isActive},clone:function(){return new la(this)},setOption:function(t,e){return this._options[t]=e,this},setOptions:function(t){return this._options=function(t,e){var n,i={};for(n in t)i[n]=t[n];for(n in e)i[n]=e[n];return i}(this._options,t),this},start:function(){return Hr.call(this,this._targetElement),this},goToStep:function(t){return Xo.call(this,t),this},addStep:function(t){return this._options.steps||(this._options.steps=[]),this._options.steps.push(t),this},addSteps:function(t){if(t.length){for(var e=0;e<t.length;e++)this.addStep(t[e]);return this}},goToStepNumber:function(t){return Qo.call(this,t),this},nextStep:function(){return Jo.call(this),this},previousStep:function(){return Zo.call(this),this},currentStep:function(){return tr.call(this)},exit:function(t){return qr.call(this,this._targetElement,t),this},refresh:function(t){return Pr.call(this,t),this},setDontShowAgain:function(t){return aa.call(this,t),this},onbeforechange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onbeforechange was not a function");return this._introBeforeChangeCallback=t,this},onchange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onchange was not a function.");return this._introChangeCallback=t,this},onafterchange:function(t){if("function"!=typeof t)throw new Error("Provided callback for onafterchange was not a function");return this._introAfterChangeCallback=t,this},oncomplete:function(t){if("function"!=typeof t)throw new Error("Provided callback for oncomplete was not a function.");return this._introCompleteCallback=t,this},onhintsadded:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintsadded was not a function.");return this._hintsAddedCallback=t,this},onhintclick:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintclick was not a function.");return this._hintClickCallback=t,this},onhintclose:function(t){if("function"!=typeof t)throw new Error("Provided callback for onhintclose was not a function.");return this._hintCloseCallback=t,this},onstart:function(t){if("function"!=typeof t)throw new Error("Provided callback for onstart was not a function.");return this._introStartCallback=t,this},onexit:function(t){if("function"!=typeof t)throw new Error("Provided callback for onexit was not a function.");return this._introExitCallback=t,this},onskip:function(t){if("function"!=typeof t)throw new Error("Provided callback for onskip was not a function.");return this._introSkipCallback=t,this},onbeforeexit:function(t){if("function"!=typeof t)throw new Error("Provided callback for onbeforeexit was not a function.");return this._introBeforeExitCallback=t,this},addHints:function(){return dr.call(this,this._targetElement),this},hideHint:function(t){return or.call(this,t),this},hideHints:function(){return rr.call(this),this},showHint:function(t){return sr.call(this,t),this},showHints:function(){return ar.call(this),this},removeHints:function(){return lr.call(this),this},removeHint:function(t){return cr().call(this,t),this},showHintDialog:function(t){return fr.call(this,t),this}};
//# sourceMappingURL=intro.module.js.map

;// CONCATENATED MODULE: ./src/js/Intro.js


/**
 * @name showIntroScreen
 * @description Show Intro Screen for Web and Mobile.
 * @param {string} pageName
 * @returns {typeof introJs} introJs
 */

const showIntroScreen = (pageName) => {
    let introScreenStr = window.localStorage.getItem("introScreens")
    let introScreenPages = JSON.parse(introScreenStr) || {}
    if(introScreenPages[pageName]) return
    return ca().setOptions({
        disableInteraction: true,
        exitOnEsc: false,
        exitOnOverlayClick: false,
        showBullets: false

    }).onbeforeexit(function () {
        introScreenPages[pageName] = true
        window.localStorage.setItem("introScreens", JSON.stringify(introScreenPages));
    }).start()
}
;// CONCATENATED MODULE: ./src/js/VoiceRecording.js
﻿


let VoiceRecordingScript = {
	recordClicked: false,
	audioChunks: [],
	audioBlob: [],
	audioBlob2: [],
	audioBlob3: [],
	audioBlob4: [],
	audioBlob5: [],
	base64Blob: "",
	base64Blob1: "",
	base64Blob2: "",
	base64Blob3: "",
	base64Blob4: "",
	base64Blob5: "",
	mediaRecorder: null,
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	count: 0,
	assessmentTextNumber: 0,
	duration: 0,
	init: function (sulekhaApp = null) {
		GATrack.init(sulekhaApp);

		VoiceRecordingScript.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				VoiceRecordingScript.isMobileApp = true;
			}
			else {
				VoiceRecordingScript.isMobileApp = false;
			}
		}



		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (!DivHeader.classList.contains('hide')) {
				DivHeader.classList.add('hide')
			}
		}

		if (DivFooter != null) {
			if (!DivFooter.classList.contains('hide')) {
				DivFooter.classList.add('hide')
			}
		}

		var player = document.getElementById('audioPlayRecord')
		if (player) {
			player.addEventListener("ended", function () {
				VoiceRecordingScript.stopplayer();
				//alert("The audio has ended.");
			});
		}


		this.bindEvents();

	},

	bindEvents: function () {

		let btnBack = document.getElementById("btnback");
		if (btnBack) {
			btnBack.addEventListener("click", function () {
				GATrack.pushValues('Click_back_button', 'Back', 'VoiceRec_back');
				if (VoiceRecordingScript.isMobileApp == true) {
					VoiceRecordingScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
				}
				else {
					location.href = "/home"
				}
			})
		}

		let btnStartSpeaking = document.getElementById("btnStartSpeaking");
		if (btnStartSpeaking) {
			btnStartSpeaking.addEventListener("click", function () {


				let firstSlide = document.getElementById("firstSlide");
				if (firstSlide) {
					firstSlide.classList.remove("current-slide")
					firstSlide.classList.add("previous-slide")
					let secondSlide = document.getElementById("secondSlide");
					if (secondSlide) {
						secondSlide.classList.remove("next-slide")
						secondSlide.classList.add("current-slide")
					}

				}

			})
		}



		let btnAudioPlayer = document.getElementById("btnAudioPlayer");
		if (btnAudioPlayer) {

			btnAudioPlayer.addEventListener("click", function () {

				var player = document.getElementById('audioPlayRecord')
				var pgeplayer = document.getElementById('pgeplayer');
				let playBtn = document.querySelector('.play-record')
				if (pgeplayer) {
					if (pgeplayer.innerHTML == "Start Play") {
						GATrack.pushValues('Click_Play_Q' + parseInt(VoiceRecordingScript.assessmentTextNumber + 1), 'Play', 'Click_Play');
						player.play()
						pgeplayer.innerHTML = "Stop Play"

						VoiceRecordingScript.swapBtn(playBtn, '#stopIcon', 'Stop');
					} else {
						player.pause();
						player.currentTime = 0;
						pgeplayer.innerHTML = "Start Play"
						VoiceRecordingScript.swapBtn(playBtn, '#iconaudioplay', 'Start Play');
					}
				}
				//	document.getElementById('audioPlayRecord').play()

			}
			)

		}




		let recordingBtn = document.getElementById("mic-recording");
		if (recordingBtn) {
			recordingBtn.addEventListener("click", function () {
				if (VoiceRecordingScript.recordClicked) {
					GATrack.pushValues('Click_Stop_Q' + parseInt(VoiceRecordingScript.assessmentTextNumber + 1), 'Stop', 'Click_stop');
					VoiceRecordingScript.stopRecording();

				}
				else {
					let info = document.querySelector('#info-text-record');
					if (info) {
						if (info.innerHTML.trim() != 'Record Again')
							GATrack.pushValues('Click_record_Q' + parseInt(VoiceRecordingScript.assessmentTextNumber + 1), 'record', 'Click_record');
						else
							GATrack.pushValues('Click_recordagain_Q' + parseInt(VoiceRecordingScript.assessmentTextNumber + 1), 'recordagain', 'Click_recordagain');
					}
					VoiceRecordingScript.startRecording();
					let recordBtn = document.querySelector('.mic-icon')
					VoiceRecordingScript.swapBtn(recordBtn, '#stopIcon', 'Stop Recording');
				}
			});
		}

		let subPhoneticsBtn = document.getElementById("submit-btn-phonetics-activity");
		if (subPhoneticsBtn) {
			// start 

			let assessmentText = [
				'How many times has language barriers stopped us from expressing ourselves?',
				'I joined Capshine to improve my communication skills and fluency in English.',
				'I will give my best to learn English using the video lessons, live classes, and other activities available in the app.',
				'I know that learning with Capshine is going to be fun, easy and effective.',
				'And, I am sure my language proficiency will improve immensely and quickly.'
			]
			///	let nextBtn = document.querySelector('submit-btn-phonetics-activity')
			let assessmentTextContainer = document.querySelector('.assessment-text')
			assessmentTextContainer.innerHTML = assessmentText[0]
			let assessmentTextNumber = 0;
			let progressStepIncrement = 100 / (assessmentText.length)
			let progressBar = document.querySelector('.progress-text')
			let progressPercentTextContainer = progressBar.querySelector('span')


			VoiceRecordingScript.duration = parseFloat(subPhoneticsBtn.getAttribute('data-duration'));
			subPhoneticsBtn.addEventListener("click", function () {





				GATrack.pushValues('Click_submit_Q' + parseInt(VoiceRecordingScript.assessmentTextNumber + 1), 'submit', 'Click_submit');
				var userid = subPhoneticsBtn.getAttribute('data-userid');

				if (assessmentTextNumber >= 4 && subPhoneticsBtn.innerHTML == 'Submit') {
					VoiceRecordingScript.submitRecording(userid);
				}
				assessmentTextNumber++
				if (assessmentText[assessmentTextNumber]) {

					VoiceRecordingScript.stopplayer();
					VoiceRecordingScript.assessmentTextNumber = assessmentTextNumber;
					assessmentTextContainer.innerHTML = assessmentText[assessmentTextNumber]
					let progress = document.querySelector('.sk-progress-bar')
					progressPercentTextContainer.innerHTML = progress.style.width = progressStepIncrement * assessmentTextNumber + '%'
					progressPercentTextContainer.innerHTML



					subPhoneticsBtn.classList.add('disabled', 'light');
					subPhoneticsBtn.classList.remove('primary');
					// if (assessmentTextNumber>=4) {
					// 	progressBar.innerHTML = 'Submit to complete voice recognition.'
					// 	progressBar.classList.add('success-text')
					// 	subPhoneticsBtn.innerHTML = 'Submit'
					// }

					let audioDiv = document.querySelector('#speaker-phonetics');
					if (audioDiv) {
						if (!audioDiv.classList.contains('hide'))
							audioDiv.classList.add('hide');
						let info = document.querySelector('#info-text-record');
						if (info) {
							info.innerHTML = 'Record';
						}
					}


				}


				//VoiceRecordingScript.submitRecording(userid);
			});
		}

		let btncontinue = document.getElementById("btncontinue");
		if (btncontinue) {
			btncontinue.addEventListener("click", function () {
				var body = document.body;
				const urlParams = new URLSearchParams(window.location.search);
				const nexturl = urlParams.get('nexturl');
				body.classList.remove("no-scroll");
				if (nexturl) {
					if (VoiceRecordingScript.isMobileApp) {
						const splitUrl = nexturl.split('/');
						if (splitUrl[1].toLowerCase() == 'talktimeschedules')
							VoiceRecordingScript.sulekhaApp.navigateTo(MainEnums_MobilePages.talktimeSchedules, null);
						else if (splitUrl[1].toLowerCase() == 'talktime')
							VoiceRecordingScript.sulekhaApp.navigateTo(MainEnums_MobilePages.talktime, { talkTimeScheduleId: splitUrl[2] });
					} else {
						window.location.replace(nexturl);
					}
				}
				else {
					if (VoiceRecordingScript.isMobileApp == true) {
						VoiceRecordingScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
					}
					else {
						location.href = "/home"
					}
				}
			});
		}




	},

	swapBtn: function (button, iconName, text) {
		button.querySelector('use').setAttribute('xlink:href', iconName)
		button.closest('a').querySelector('p').innerHTML = text
	},
	startRecording: function () {

		let error = document.getElementById('error-text');
		if (error) {
			error.style.display = '';
			error.innerHTML = '';
		}
		let subPhoneticsBtn = document.getElementById("submit-btn-phonetics-activity");
		subPhoneticsBtn.classList.add('disabled', 'light');
		subPhoneticsBtn.classList.remove('primary');

		let audioDiv = document.querySelector('#speaker-phonetics');
		if (audioDiv) {
			if (!audioDiv.classList.contains('hide'))
				audioDiv.classList.add('hide');
		}
		VoiceRecordingScript.audioChunks = [];
		//	VoiceRecordingScript.base64Blob = [];
		navigator.mediaDevices.getUserMedia({ audio: true })
			.then(stream => {
				VoiceRecordingScript.count = 1

				//VoiceRecordingScript.assessmentTextNumber==VoiceRecordingScript.assessmentTextNumber+1

				VoiceRecordingScript.audioChunks = [];
				//	setInterval(VoiceRecordingScript.scrollTimeOut, 3000);
				VoiceRecordingScript.mediaRecorder = new MediaRecorder(stream);
				VoiceRecordingScript.mediaRecorder.start();
				VoiceRecordingScript.mediaRecorder.addEventListener("dataavailable", event => {
					VoiceRecordingScript.audioChunks.push(event.data);
				});

				VoiceRecordingScript.mediaRecorder.addEventListener("stop", () => {
					//	clearInterval(VoiceRecordingScript.scrollTimeOut);
					VoiceRecordingScript.count = 0;
					let audioUrl = "";

					if (VoiceRecordingScript.assessmentTextNumber == 0) {

						VoiceRecordingScript.audioBlob = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob);
						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob = data.split(',')[1];

						});



					}
					if (VoiceRecordingScript.assessmentTextNumber == 1) {
						VoiceRecordingScript.audioBlob1 = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob1);

						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob1);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob1 = data.split(',')[1];

						});
					}
					if (VoiceRecordingScript.assessmentTextNumber == 2) {
						VoiceRecordingScript.audioBlob2 = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob2);

						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob2);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob2 = data.split(',')[1];

						});
					}
					if (VoiceRecordingScript.assessmentTextNumber == 3) {
						VoiceRecordingScript.audioBlob3 = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob3);
						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob3);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob3 = data.split(',')[1];

						});
					}
					if (VoiceRecordingScript.assessmentTextNumber == 4) {
						VoiceRecordingScript.audioBlob4 = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob4);

						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob4);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob4 = data.split(',')[1];

						});

						// final step 
						let progressBar = document.querySelector('.progress-text')
						let progressPercentTextContainer = progressBar.querySelector('span')
						let progress = document.querySelector('.sk-progress-bar')
						progressPercentTextContainer.innerHTML = progress.style.width = '100%'




						progressPercentTextContainer.innerHTML
						progressBar.innerHTML = 'Submit to complete voice recognition.'
						progressBar.classList.add('success-text')
						subPhoneticsBtn.innerHTML = 'Submit'


					}
					if (VoiceRecordingScript.assessmentTextNumber == 5) {
						VoiceRecordingScript.audioBlob5 = new Blob(VoiceRecordingScript.audioChunks, { type: "audio/mp3" });
						audioUrl = URL.createObjectURL(VoiceRecordingScript.audioBlob5);

						var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob5);

						base64fun.then(data => {
							VoiceRecordingScript.base64Blob5 = data.split(',')[1];

						});
					}


					document.getElementById('audioPlayRecord').setAttribute('src', audioUrl);

					var aud = document.getElementById('audioPlayRecord');

					subPhoneticsBtn.classList.remove('disabled', 'light');
					subPhoneticsBtn.classList.add('primary');
					//	assessmentTextNumber++

					// aud.addEventListener('loadedmetadata', function () {
					// 	if (aud.duration == Infinity) {
					// 		aud.currentTime = 1e101;
					// 		aud.ontimeupdate = function () {
					// 			this.ontimeupdate = () => {
					// 			//	alert(aud.duration)

					// 			if(aud.duration>VoiceRecordingScript.duration){

					// 				if (subPhoneticsBtn) {
					// 					subPhoneticsBtn.classList.remove('disabled','light');
					// 					subPhoneticsBtn.classList.add('primary');

					// 				}
					// 			}
					// 			else if(aud.duration<=VoiceRecordingScript.duration){  
					// 				error.innerHTML = "Current recoring durration is " +aud.duration +" seconds only. Voice recording duration should at least be "+  VoiceRecordingScript.duration +" seconnds ...";
					// 				error.style.display = 'block';
					// 			    	// subPhoneticsBtn.classList.remove('disabled','light');
					// 				    // subPhoneticsBtn.classList.add('disabled','light');
					// 					// subPhoneticsBtn.classList.remove('primary');
					// 			}
					// 				return;
					// 			}
					// 			aud.currentTime = 0;
					// 			return;
					// 		}
					// 	}
					// });

					// var aud = document.getElementById('audioPlayRecord');

					// aud.addEventListener('loadedmetadata', function () {
					// 	if (aud.duration == Infinity) {
					// 		aud.currentTime = 1e101;
					// 		aud.ontimeupdate = function () {
					// 			this.ontimeupdate = () => {
					// 				alert(aud.duration)
					// 			}

					// 		}
					// 	}
					// })


				});
				VoiceRecordingScript.recordClicked = true;
				document.querySelector('#mic-recording svg').classList.add('Record');
				let info = document.querySelector('#info-text-record');
				if (info) {
					info.innerHTML = 'Stop Record';
				}

			}).catch(function (err) {
				let errStrng = String(err);
				VoiceRecordingScript.mediaRecorder = null;
				VoiceRecordingScript.recordClicked = false;
				if (document.querySelector('#mic-recording svg').classList.contains('Record'))
					document.querySelector('#mic-recording svg').classList.remove('Record');
				if (error) {
					error.style.display = 'block';
					if (errStrng.includes('Permission denied')) {
						error.innerHTML = 'Permission denied, Please allow mic permission in the browser...';
					}
					else if (errStrng.includes('Requested device not found')) {
						error.innerHTML = 'Mic not found in your Device...';
					}
					else if (errStrng.split(':').length > 1) {
						error.innerHTML = errStrng.split(':')[1];
					}
					else {
						error.innerHTML = errStrng;
					}
				}
			});
	},

	getDuration: function () {
		var audio = document.getElementById('audioPlayRecord');
		audio.currentTime = 0
		audio.removeEventListener('timeupdate', VoiceRecordingScript.getDuration)
		//	alert(audio.duration)
	},
	blobToBase64: function (blob) {
		return new Promise((resolve, _) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result);
			reader.readAsDataURL(blob);
		});
	},
	stopRecording: function () {

		VoiceRecordingScript.mediaRecorder.stop();
		VoiceRecordingScript.recordClicked = false;
		if (document.querySelector('#mic-recording svg').classList.contains('Record'))
			document.querySelector('#mic-recording svg').classList.remove('Record');
		let audioDiv = document.querySelector('#speaker-phonetics');
		if (audioDiv) {
			if (audioDiv.classList.contains('hide'))
				audioDiv.classList.remove('hide');
			let info = document.querySelector('#info-text-record');
			if (info) {
				info.innerHTML = 'Record Again';
				let recordBtn = document.querySelector('.mic-icon')
				VoiceRecordingScript.swapBtn(recordBtn, '#iconmic', 'Record Again');


				if (VoiceRecordingScript.assessmentTextNumber >= 4) {
					let subPhoneticsBtn = document.getElementById("submit-btn-phonetics-activity");
					subPhoneticsBtn.classList.remove('disabled', 'light');
					subPhoneticsBtn.classList.add('primary');
				}

			}
		}
	},
	submitRecording: function (userid) {
		//	clearInterval(VoiceRecordingScript.scrollTimeOut);
		// VoiceRecordingScript.count = 0;

		// var aud = document.getElementById('audioPlayRecord');
		// //	alert(aud.duration);
		// var base64fun = VoiceRecordingScript.blobToBase64(VoiceRecordingScript.audioBlob);

		// base64fun.then(data => {

		// 	var obj = {
		// 		UserPid: userid,
		// 		Data: data.split(',')[1]
		// 	};


		// 	CSMainAPIs.Capshine.APIs.SaveVoiceRecordingForAI.execute(obj, VoiceRecordingScript.saveResponse);
		// });

		var obj = {
			UserPid: userid,
			Blob: VoiceRecordingScript.base64Blob,
			Blob1: VoiceRecordingScript.base64Blob1,
			Blob2: VoiceRecordingScript.base64Blob2,
			Blob3: VoiceRecordingScript.base64Blob3,
			Blob4: VoiceRecordingScript.base64Blob4

		};
		CSMainAPIs.Capshine.APIs.SaveVoiceRecordingForAI.execute(obj, VoiceRecordingScript.saveResponse);

	},

	stopplayer: function () {

		var player = document.getElementById('audioPlayRecord')
		var pgeplayer = document.getElementById('pgeplayer');
		let playBtn = document.querySelector('.play-record')
		if (pgeplayer) {
			{
				player.pause();
				player.currentTime = 0;
				pgeplayer.innerHTML = "Start Play"
				VoiceRecordingScript.swapBtn(playBtn, '#iconaudioplay', 'Start Play');
			}
		}
	},

	saveResponse: function (response) {

		if (response.data == 1) {

			let modelpopup = document.getElementById("successpopup");
			if (modelpopup) {
				GATrack.pushValues('Click_Submit_Thankyou', 'Thankyou', 'Click_submit_thank');
				modelpopup.classList.add('show');
			}


			// if (VoiceRecordingScript.isMobileApp == true) {
			// 	VoiceRecordingScript.sulekhaApp.navigateTo(MobilePages.home, null)
			// }
			// else {
			// 	location.href = "/home"
			// }

			// if (VoiceRecordingScript.isMobileApp) {

			// } else {

			// }
		}
	},

	scrollTimeOut: function (id) {
		var div = document.getElementById('divContent');

		var height = div.scrollHeight - div.clientHeight;

		if (VoiceRecordingScript.count > 0 && VoiceRecordingScript.count < 20) {

			var setscroolhight = height / 20;

			div.scrollTop = setscroolhight + div.scrollTop;

			VoiceRecordingScript.count = VoiceRecordingScript.count + 1;
		}
		else {
			//div.scrollTop =height;	
			clearInterval(VoiceRecordingScript.scrollTimeOut)
			VoiceRecordingScript.count = 0;
		}


	},







}
/* harmony default export */ const VoiceRecording = (VoiceRecordingScript);
;// CONCATENATED MODULE: ./src/js/VideoScript.js




// import router from "./routerconfig"
var VideoScript = {
    UserPid: '',
    userInfo: null,
    isCoach: false,
    isMobileApp: false,
    init: function (userpid, sulekhaApp = null) {

        window.localStorage.setItem('backpage', 'videos')
        window.localStorage.setItem('sfvbackpage', 'videos')

        VideoScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                VideoScript.isMobileApp = true;
            }
            else {
                VideoScript.isMobileApp = false;
            }
        }

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (DivHeader.classList.contains('hide')) {
                DivHeader.classList.remove('hide')
            }
        }

        if (DivFooter != null) {
            if (DivFooter.classList.contains('hide')) {
                DivFooter.classList.remove('hide')
            }
        }





        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, VideoScript.afterGetUserInfoLoad);



        document.querySelectorAll(".viewVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
                //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');

                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');

                var obj = {
                    videoid: videoId,
                    userid: userId
                }


                if (VideoScript.isMobileApp == true) {
                    var rnd = VideoScript.getRandomNunber();

                    if (VideoScript.userInfo.clubUserType == 1 && VideoScript.userInfo.learningVideoLimit == 0) {

                        setTimeout(() => {
                            VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 1
                            })
                        }, 1000);
                    }
                    else {

                        setTimeout(() => {
                            VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo, { VideoId: videoId, rnd: rnd, loadnextvideo: 'no' });
                        }, 1000);
                    }



                }
                else {

                    if (VideoScript.userInfo.clubUserType == 1 && VideoScript.userInfo.learningVideoLimit == 0) {
                        location.href = "/PaymentUpgradeRequest?pageType=1";
                    }
                    else {

                        location.href = "/WatchVideo?VideoId=" + videoId + "&loadnextvideo=no";
                    }
                }





            })
        })


        // ddl langugate dropdpown 
        if (document.getElementById('ddlLanguage')) {

            // drop down langguge
            document.getElementById('ddlLanguage').addEventListener('change', function (e) {

                GATrack.pushValues('Videos_Language selection', "Videolanguage_ " + this.value, 'Select Language');
                var userId = e.currentTarget.getAttribute('data-userid');
                let clientData = {
                    UserPid: userId,
                    Language: this.value
                }
                CSMainAPIs.Capshine.APIs.UpdateClubUserLanguage.execute(clientData, VideoScript.UpdateClubUserLanguageResponse);

            });

            let defaultLanguage = document.getElementById('ddlLanguage').getAttribute('data-preferredlanguage');
            document.getElementById('ddlLanguage').value = defaultLanguage;
        }


        document.querySelectorAll("._sfvinfoicon").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.add('show')
				 }
			})
		})

		document.querySelectorAll("._sfvcontinuebtn").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.remove('show')
				 }
			})
		})

		document.querySelectorAll("._sfvcclosebtn").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				var tagid = e.currentTarget.getAttribute('data-tagid');

				 let id="Svf-info-popup_"+tagid;
				 if(document.getElementById(id)){
					document.getElementById(id).classList.remove('show')
				 }
			})
		})


        if (document.getElementById('divViewAllVideos')) {

            document.getElementById('divViewAllVideos').addEventListener('click', function (e) {

                if (VideoScript.isMobileApp == true) {

                    VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons);

                }
                else {

                    location.href = "/videolessons";
                }

            })

        }

        if (document.getElementById('atagWatchedVideos')) {

            document.getElementById('atagWatchedVideos').addEventListener('click', function (e) {

                if (VideoScript.isMobileApp == true) {

                    VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos);

                }
                else {

                    location.href = "/watchedVideos";
                }
            })

        }


        // Short video 

        document.querySelectorAll("._clicksvftag").forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.stopPropagation();
				//  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');   
				var tagid = e.currentTarget.getAttribute('data-tagid');
		//
		if (VideoScript.isMobileApp == true) {
			var rnd = VideoScript.getRandomNunber();
			
		
				setTimeout(() => {
					VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid, rnd: rnd});
				}, 1000);
			
		
		}
		else {
		
					location.href = "/ShortVideosViewAll?tagid=" + tagid;	
				
		
		}
		
			})
		}),

        document.querySelectorAll(".viewShortVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
                //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                var languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');
                var istodaywatchedvideo = e.currentTarget.getAttribute('data-istodaywatchedvideo');
                var tagid = e.currentTarget.getAttribute('data-tagid');

                if (VideoScript.isMobileApp == true) {
                    var rnd = VideoScript.getRandomNunber();

                    if (VideoScript.userInfo.clubUserType == 1 && VideoScript.userInfo.sfvLimit == false && istodaywatchedvideo == "False") {
                        setTimeout(() => {
                            VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 9
                            })
                        }, 1000);
                    }
                    else {
                        setTimeout(() => {
                            VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchShortVideos, { VideoId: videoId, rnd: rnd, iswatched: '3', languagevideoid: languagevideoid, tagid: tagid });
                        }, 1000);
                    }





                }
                else {

                    if (VideoScript.userInfo.clubUserType == 1 && VideoScript.userInfo.sfvLimit == false && istodaywatchedvideo == "False") {
                        location.href = "/PaymentUpgradeRequest?pageType=9";
                    }
                    else {

                        if (VideoScript.iOS()) {
                            location.href = "/watchShortVideosInIOS?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;;
                        }
                        else {
                            location.href = "/watchShortVideos?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;;
                        }

                    }


                    ///  location.href = "/watchShortVideos?VideoId=" + videoId+"&iswatched=3"+"&languagevideoid="+languagevideoid;
                    // if (WathedVideoLessonsScript.userInfo.clubUserType == 1 && WathedVideoLessonsScript.userInfo.learningVideoLimit == 0) {
                    //     location.href = "/PaymentUpgradeRequest?pageType=1";
                    // }
                    // else {

                    //     location.href = "/WatchVideo?VideoId=" + videoId + "&loadnextvideo=no";
                    // }
                }





            })
        })


    },
    iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	},
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        VideoScript.userInfo = response.data;

    },
    UpdateClubUserLanguageResponse: async function (Response) {

        var rnd = VideoScript.getRandomNunber();

        if (VideoScript.isMobileApp) {
            VideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, { rnd: rnd });

        }
        else {
            location.href = "/videos";
        }



    },


}

/* harmony default export */ const js_VideoScript = (VideoScript);
;// CONCATENATED MODULE: ./src/js/VideoLessonsScript.js




// import router from "./routerconfig"
var VideoLessonsScript= {
    UserPid: '',
    userInfo: null,
    isCoach: false,
    isMobileApp: false,   
    init: function (userpid, sulekhaApp = null) {

        window.localStorage.setItem('backpage','videolessons')

        VideoLessonsScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                VideoLessonsScript.isMobileApp = true;
            }
            else {
                VideoLessonsScript.isMobileApp = false;
            }
        }

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }



        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, VideoLessonsScript.afterGetUserInfoLoad);

        document.querySelectorAll(".viewVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
              //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');

                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');

                var obj = {
                    videoid: videoId,
                    userid: userId
                }

                if (VideoLessonsScript.isMobileApp == true) {
                    var rnd = VideoLessonsScript.getRandomNunber();

                    if (VideoLessonsScript.userInfo.clubUserType == 1 && VideoLessonsScript.userInfo.learningVideoLimit == 0) {

                        setTimeout(() => {
                            VideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 1
                            })
                        }, 1000);
                    }
                    else {

                        setTimeout(() => {
                            VideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo, { VideoId: videoId, rnd: rnd, loadnextvideo: 'no' });
                        }, 1000);
                    }
     
                }
                else {

                    if (VideoLessonsScript.userInfo.clubUserType == 1 && VideoLessonsScript.userInfo.learningVideoLimit == 0) {
                        location.href = "/PaymentUpgradeRequest?pageType=1";
                    }
                    else {

                        location.href = "/WatchVideo?VideoId=" + videoId + "&loadnextvideo=no";
                    }
                }

            })
        })


        // ddl langugate dropdpown 
        if (document.getElementById('ddlLanguage')) {

            // drop down langguge
            document.getElementById('ddlLanguage').addEventListener('change', function (e) {
                GATrack.pushValues('VideoLearning_Languagechange', this.value, 'Click_VideoLearning_Languagechange');
                var userId = e.currentTarget.getAttribute('data-userid');
                   let clientData = {
                    UserPid: userId,
                    Language: this.value
                }
                CSMainAPIs.Capshine.APIs.UpdateClubUserLanguage.execute(clientData, VideoLessonsScript.UpdateClubUserLanguageResponse);

            });

            let defaultLanguage = document.getElementById('ddlLanguage').getAttribute('data-preferredlanguage');
            document.getElementById('ddlLanguage').value = defaultLanguage;
        }

        

        if (document.getElementById('svgvideolessonback')) {
    
            document.getElementById('svgvideolessonback').addEventListener('click', function (e) {
                  
                if (VideoLessonsScript.isMobileApp == true) {

                    VideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos);

                }
                else {

                    location.href = "/videos";   
                }

            })

        }


    },
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        VideoLessonsScript.userInfo = response.data;

    },
    UpdateClubUserLanguageResponse: async function (Response) {

        var rnd = VideoLessonsScript.getRandomNunber();
    
        if (VideoLessonsScript.isMobileApp) {               
            VideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, {rnd: rnd });         

        }
        else {
            location.href = "/videolessons";
        }



    },


}

/* harmony default export */ const js_VideoLessonsScript = (VideoLessonsScript);
;// CONCATENATED MODULE: ./src/js/WathedVideoLessonsScript.js




// import router from "./routerconfig"
var WathedVideoLessonsScript = {
    UserPid: '',
    userInfo: null,
    isCoach: false,
    isMobileApp: false,
    init: function (userpid, sulekhaApp = null) {

        var currentPage = "watchedvideoLesson";

       
       
       // set default tab
       
        var qvalue = WathedVideoLessonsScript.getParameterByName('atab');

          if(qvalue=="shortvideo"){  // show short video 
            if (document.getElementById('divVideos')) {
                document.getElementById('atagVideos').classList.remove('active')
                document.getElementById('divVideos').classList.remove('active')
            }

            if (document.getElementById('divShortVideos')) {
                document.getElementById('atagShortVideos').classList.add('active')
                document.getElementById('divShortVideos').classList.add('active')
            }
          }
          else {
              
            if (document.getElementById('divVideos')) {
                document.getElementById('atagVideos').classList.add('active')
                document.getElementById('divVideos').classList.add('active')

            }

            if (document.getElementById('divShortVideos')) {
                document.getElementById('atagShortVideos').classList.remove('active')
                document.getElementById('divShortVideos').classList.remove('active')

            }
          }

          // end 
     

        window.localStorage.setItem('backpage', currentPage)

        WathedVideoLessonsScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WathedVideoLessonsScript.isMobileApp = true;
            }
            else {
                WathedVideoLessonsScript.isMobileApp = false;
            }
        }


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }


        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WathedVideoLessonsScript.afterGetUserInfoLoad);


  /// Show active tab

    


        if (document.getElementById('atagVideos')) {
            document.getElementById('atagVideos').addEventListener('click', function (e) {

                if (document.getElementById('divVideos')) {
                    document.getElementById('atagVideos').classList.add('active')
                    document.getElementById('divVideos').classList.add('active')

                }

                if (document.getElementById('divShortVideos')) {
                    document.getElementById('atagShortVideos').classList.remove('active')
                    document.getElementById('divShortVideos').classList.remove('active')

                }



            })

        }


        if (document.getElementById('atagShortVideos')) {

            document.getElementById('atagShortVideos').addEventListener('click', function (e) {

                if (document.getElementById('divVideos')) {
                    document.getElementById('atagVideos').classList.remove('active')
                    document.getElementById('divVideos').classList.remove('active')
                }

                if (document.getElementById('divShortVideos')) {
                    document.getElementById('atagShortVideos').classList.add('active')
                    document.getElementById('divShortVideos').classList.add('active')
                }

            })

        }


        document.querySelectorAll(".viewVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
                //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');

                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');

                var obj = {
                    videoid: videoId,
                    userid: userId
                }


                if (WathedVideoLessonsScript.isMobileApp == true) {
                    var rnd = WathedVideoLessonsScript.getRandomNunber();

                    if (WathedVideoLessonsScript.userInfo.clubUserType == 1 && WathedVideoLessonsScript.userInfo.learningVideoLimit == 0) {

                        setTimeout(() => {
                            WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 1
                            })
                        }, 1000);
                    }
                    else {

                        setTimeout(() => {
                            WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchVideo, { VideoId: videoId, rnd: rnd, loadnextvideo: 'no' });
                        }, 1000);
                    }



                }
                else {

                    if (WathedVideoLessonsScript.userInfo.clubUserType == 1 && WathedVideoLessonsScript.userInfo.learningVideoLimit == 0) {
                        location.href = "/PaymentUpgradeRequest?pageType=1";
                    }
                    else {

                        location.href = "/WatchVideo?VideoId=" + videoId + "&loadnextvideo=no";
                    }
                }





            })
        })

        // Short video 

        document.querySelectorAll(".viewShortVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
                //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                var languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');
                
                var istodaywatchedvideo = e.currentTarget.getAttribute('data-istodaywatchedvideo');

                var tagid = e.currentTarget.getAttribute('data-tagid');

debugger
                if (WathedVideoLessonsScript.isMobileApp == true) {
                    var rnd = WathedVideoLessonsScript.getRandomNunber();
                    
                    if (WathedVideoLessonsScript.userInfo.clubUserType == 1 && WathedVideoLessonsScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
                        setTimeout(() => {
                            WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 9
                            })
                        }, 1000);
                    }
                    else {
                        setTimeout(() => {
                            WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchShortVideos, { VideoId: videoId, rnd: rnd, iswatched: '1', languagevideoid: languagevideoid, tagid: tagid });
                        }, 1000);
                    }



                }
                else {
                    debugger

                    if (WathedVideoLessonsScript.userInfo.clubUserType == 1 && WathedVideoLessonsScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
                        location.href = "/PaymentUpgradeRequest?pageType=9";
                    }
                    else {
                        location.href = "/watchShortVideos?VideoId=" + videoId + "&iswatched=1" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;

  
                        // if (WathedVideoLessonsScript.iOS()) {
                        //     location.href = "/watchShortVideosInIOS?VideoId=" + videoId + "&iswatched=1" + "&languagevideoid=" + languagevideoid;
                        // }
                        // else {

                        // location.href = "/watchShortVideos?VideoId=" + videoId + "&iswatched=1" + "&languagevideoid=" + languagevideoid;
                        // }
                    }

                }





            })
        })


        // ddl langugate dropdpown 
        if (document.getElementById('ddlLanguage')) {

            // drop down langguge
            document.getElementById('ddlLanguage').addEventListener('change', function (e) {
                GATrack.pushValues('VideoLearning_Languagechange', this.value, 'Click_ViewAllVideoLearning_Languagechange');
                var userId = e.currentTarget.getAttribute('data-userid');
                let clientData = {
                    UserPid: userId,
                    Language: this.value
                }
                CSMainAPIs.Capshine.APIs.UpdateClubUserLanguage.execute(clientData, WathedVideoLessonsScript.UpdateClubUserLanguageResponse);

            });

            let defaultLanguage = document.getElementById('ddlLanguage').getAttribute('data-preferredlanguage');
            document.getElementById('ddlLanguage').value = defaultLanguage;
        }



        if (document.getElementById('divWathedVideoBackBtn')) {

            document.getElementById('divWathedVideoBackBtn').addEventListener('click', function (e) {

                if (WathedVideoLessonsScript.isMobileApp == true) {

                    WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos);

                }
                else {

                    location.href = "/videos";
                }

            })

        }


    },
    iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	},
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WathedVideoLessonsScript.userInfo = response.data;

    },
    UpdateClubUserLanguageResponse: async function (Response) {

        var rnd = WathedVideoLessonsScript.getRandomNunber();

        if (WathedVideoLessonsScript.isMobileApp) {
            WathedVideoLessonsScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, { rnd: rnd });
        }
        else {
            location.href = "/videolessons";
        }



    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


}

/* harmony default export */ const js_WathedVideoLessonsScript = (WathedVideoLessonsScript);
// EXTERNAL MODULE: ./src/js/DashJS/dash.all.debug.js
var dash_all_debug = __webpack_require__(86);
// EXTERNAL MODULE: ./src/js/DashJS/dash.mss.debug.js
var dash_mss_debug = __webpack_require__(509);
// EXTERNAL MODULE: ./src/js/DashJS/seamlessscroll.min.js
var seamlessscroll_min = __webpack_require__(399);
;// CONCATENATED MODULE: ./src/js/TouchDetector.js
var TouchDetector = { 
 swipedetect(el, callback){  

    var touchsurface = el,
    dir,
    dist,
    swipeType,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 500, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    touchMoveId=0,
    handletouch = callback || function(evt, dir, phase, swipetype, distance){}

 
// touchsurface.removeEventListener( "touchend", fixTouchEnd );
 
    touchsurface.addEventListener('touchstart', function(e){
        touchMoveId=1
        var touchobj = e.changedTouches[0]
        dir = 'none'
        swipeType = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY    
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        handletouch(e, 'none', 'start', swipeType, 0) // fire callback function with params dir="none", phase="start", swipetype="none" etc
         e.preventDefault()
      
 
    }, false)
 
    touchsurface.addEventListener('touchmove', function(e){
        touchMoveId=2
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        if (Math.abs(distX) > Math.abs(distY)){ // if distance traveled horizontally is greater than vertically, consider this a horizontal movement
            dir = (distX < 0)? 'left' : 'right'
            handletouch(e, dir, 'move', swipeType, distX) // fire callback function with params dir="left|right", phase="move", swipetype="none" etc
        }
        else{ // else consider this a vertical movement
            dir = (distY < 0)? 'up' : 'down'
            handletouch(e, dir, 'move', swipeType, distY) // fire callback function with params dir="up|down", phase="move", swipetype="none" etc
        }
        if (e.cancelable) {
           e.preventDefault() // prevent scrolling when inside DIV
        }
    }, false)
 
    touchsurface.addEventListener('touchend', function(e){
        if(touchMoveId==3){
            dir = 'none'
        }
        var touchobj = e.changedTouches[0]
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipeType = dir // set swipeType to either "left" or "right"
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipeType = dir // set swipeType to either "top" or "down"
            }
        }
        touchMoveId=3
        // Fire callback function with params dir="left|right|up|down", phase="end", swipetype=dir etc:
        handletouch(e, dir, 'end', swipeType, (dir =='left' || dir =='right')? distX : distY)
      
          e.preventDefault()
       
    }, false)



//     var touchsurface = el,
//     swipedir,
//     startX,
//     startY,
//     distX,
//     distY,
//     threshold = 150, //required min distance traveled to be considered swipe
//     restraint = 100, // maximum distance allowed at the same time in perpendicular direction
//     allowedTime = 300, // maximum time allowed to travel that distance
//     elapsedTime,
//     startTime,
//     dist,
//     handleswipe = callback || function(swipedir){}


//     // touchsurface.addEventListener("touchstart", startTouch, false);
//     // touchsurface.addEventListener("touchmove", moveTouch, false);

//     var initialX = null;
//     var initialY = null;
 
// function startTouch(e) {
//     swipedir="None"
//   initialX = e.touches[0].clientX;
//   initialY = e.touches[0].clientY;
// }

//     touchsurface.addEventListener('touchstart', function(e){
//         swipedir="None"
//         initialX = e.touches[0].clientX;
//         initialY = e.touches[0].clientY;
//         e.preventDefault()
//     }, false)
  

//  touchsurface.addEventListener('touchmove', function(e){
//     if (initialX === null) {
//         return;
//       }
     
//       if (initialY === null) {
//         return;
//       }
     
//       var currentX = e.touches[0].clientX;
//       var currentY = e.touches[0].clientY;
     
//       var diffX = initialX - currentX;
//       var diffY = initialY - currentY;
     
//       if (Math.abs(diffX) > Math.abs(diffY)) {
//         // sliding horizontally
//         if (diffX > 0) {
//           // swiped left
//           swipedir="swiped left"
//           console.log("swiped left");
//         } else {
//           // swiped right
//           swipedir="swiped right"
//           console.log("swiped right");
//         }  
//       } else {

//         if (Math.abs(diffY) >= threshold ){  //&& Math.abs(distX) <= restraint
           
//                  // sliding vertically
//         if (diffY > 0) {
//             // swiped up
//             swipedir="swiped up"
//             console.log("swiped up");
//           } else {
//             // swiped down
//             swipedir="swiped down"
//             console.log("swiped down");
//           } 
//         }

  
//       }
     
//       initialX = null;
//       initialY = null;
//       handleswipe(swipedir)
//       e.preventDefault();

//  },false)


// function moveTouch(e) {
//     if (initialX === null) {
//       return;
//     }
   
//     if (initialY === null) {
//       return;
//     }
   
//     var currentX = e.touches[0].clientX;
//     var currentY = e.touches[0].clientY;
   
//     var diffX = initialX - currentX;
//     var diffY = initialY - currentY;
   
//     if (Math.abs(diffX) > Math.abs(diffY)) {
//       // sliding horizontally
//       if (diffX > 0) {
//         // swiped left
//         swipedir="swiped left"
//         console.log("swiped left");
//       } else {
//         // swiped right
//         swipedir="swiped right"
//         console.log("swiped right");
//       }  
//     } else {
//       // sliding vertically
//       if (diffY > 0) {
//         // swiped up
//         swipedir="swiped up"
//         console.log("swiped up");
//       } else {
//         // swiped down
//         swipedir="swiped down"
//         console.log("swiped down");
//       }  
//     }
   
//     initialX = null;
//     initialY = null;
//     handleswipe(swipedir)
//     e.preventDefault();
//   }

  
    // touchsurface.addEventListener('touchstart', function(e){
    //     var touchobj = e.changedTouches[0]
    //     swipedir = 'none'
    //     dist = 0
    //     startX = touchobj.pageX
    //     startY = touchobj.pageY
    //     startTime = new Date().getTime() // record time when finger first makes contact with surface
    //     e.preventDefault()
    // }, false)
  
    // touchsurface.addEventListener('touchmove', function(e){
    //     e.preventDefault() // prevent scrolling when inside DIV
    // }, false)
  
    // touchsurface.addEventListener('touchend', function(e){
    //     var touchobj = e.changedTouches[0]
    //     distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
    //     distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
    //     elapsedTime = new Date().getTime() - startTime // get time elapsed
    //     if (elapsedTime <= allowedTime){ // first condition for awipe met
    //         if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
    //             swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
    //         }
    //         else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
    //             swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
    //         }
    //     }
    //     handleswipe(swipedir)
    //     e.preventDefault()
    // }, false)
}

}

/* harmony default export */ const js_TouchDetector = (TouchDetector);
;// CONCATENATED MODULE: ./src/js/WatchShortVideoScript.js






// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'

// import router from "./routerconfig"
var WatchShortVideoScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 1,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    init: function (userpid, sulekhaApp = null) {
        // remove touch events 

        WatchShortVideoScript.resetAll();

        WatchShortVideoScript.setEventsForVideo();

        // window.addEventListener("focus", WatchShortVideoScript.playVideOnDocumentOnFocus);
        // window.addEventListener("blur", WatchShortVideoScript.pauseVideOnDocumentLooseFocus);


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        WatchShortVideoScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchShortVideoScript.isMobileApp = true;
            }
            else {
                WatchShortVideoScript.isMobileApp = false;
            }
        }
        WatchShortVideoScript.setupDashJsVideo();
        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WatchShortVideoScript.afterGetUserInfoLoad);

        // WatchShortVideoScript.videos = document.getElementsByTagName("video");
        // WatchShortVideoScript.divVideoList = document.getElementById('divshortVideolist');

        // WatchShortVideoScript.initializeDashJsPlayers()



        document.querySelectorAll(".actionsitem").forEach((btn) => {
            btn.addEventListener("touchend", function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }
                e.stopPropagation();

                WatchShortVideoScript.SaveShortVideoAction(e);


            })


        })



        document.querySelectorAll(".backbutton").forEach((backbutton) => {
            backbutton.addEventListener("touchend", function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }

                e.stopPropagation();

                // WatchShortVideoScript.activePlayer.pause();
                WatchShortVideoScript.pauseAllVideosBeforeExit();
                var shortvideobackpage = window.localStorage.getItem('backpage');
                var sfvBackbyCategory = window.localStorage.getItem('sfvbackpage');

                var currentVideo = WatchShortVideoScript.activePlayer;


                var videoid = currentVideo.getAttribute('data-videoid');

                var language = currentVideo.getAttribute('data-language');
                var tagid = WatchShortVideoScript.getParameterByName('tagid');
                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Back');

                if (WatchShortVideoScript.isMobileApp) {

                    if (shortvideobackpage == "videos") {
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid});
                    }
                    else if (shortvideobackpage == "videolessons") {
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
                    }
                    else if (shortvideobackpage == "watchedvideoLesson") {
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos, { atab: 'shortvideo' });
                    }
                    else if (shortvideobackpage == "ShortVideosViewAll") {
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid});
                    }
                    else if (sfvBackbyCategory == "ShortVideosViewAll"){
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid});
                    }
                    else {
                        WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                    }

                }
                else {
                    // history.back();
                    if (shortvideobackpage || sfvBackbyCategory) {
                        if (shortvideobackpage == "videos") {
                            location.href = "/ShortVideosViewAll?tagid="+tagid;
                        }
                        else if (shortvideobackpage == "videolessons") {
                            location.href = "/videolessons"
                        }
                        else if (shortvideobackpage == "watchedvideoLesson") {
                            location.href = "/watchedvideos?atab=shortvideo"

                        }
                        else if (shortvideobackpage == "home") {
                            location.href = "/home"
                        }
                        else if (shortvideobackpage == "ShortVideosViewAll") {
                            location.href = "/ShortVideosViewAll?tagid="+tagid;
                        }
                        else if (sfvBackbyCategory == "ShortVideosViewAll") {
                            location.href = "/ShortVideosViewAll?tagid="+tagid;
                        }
                    }
                    else {
                        location.href = "/home"
                    }

                }

            })

        })


        // document.getElementsByTagName("video").forEach((video) => {

        //     video.addEventListener('click', async function (e) {

        //         alert(video.id +"Hi I clicked");

        //     });


        // })



        document.querySelectorAll(".list-item").forEach((divvideo) => {
            js_TouchDetector.swipedetect(divvideo, function (evt, dir, phase, swipetype, distance) {


                // var touchreport = ''
                WatchShortVideoScript.touchDetails += '<b>Dir:</b> ' + dir + '<br />'
                WatchShortVideoScript.touchDetails += '<b>Phase:</b> ' + phase + '<br />'
                WatchShortVideoScript.touchDetails += '<b>Swipe Type:</b> ' + swipetype + '<br />'
                WatchShortVideoScript.touchDetails += '<b>Distance:</b> ' + distance + '<br />'
                WatchShortVideoScript.touchDetails += '<b>Element Id:</b> ' + evt.id + '<br />'
                //  //console.log(touchreport);

                var activerowindex = parseInt(evt.currentTarget.id.replace("divvideoid", ""))

                if (dir == "up") {
                    // if(distance<-100){     

                    var itemcount = document.querySelectorAll(".list-item").length;
                    if (parseInt(activerowindex) < itemcount) {


                        //   if (WatchShortVideoScript.touchUpDebounce) {
                        //    WatchShortVideoScript.touchUpDebounce = false;

                        var rowupindex = parseInt(activerowindex + 1)
                        WatchShortVideoScript.activePlayerRowIndex = rowupindex;
                        WatchShortVideoScript.playActiveVideoOnSwap(rowupindex, dir)

                        //    setTimeout(function () { WatchShortVideoScript.touchUpDebounce = true; },0);


                        //   }



                    }

                    // }


                }

                if (dir == "down") {

                    // if(distance>200){
                    if (parseInt(activerowindex) > 1) {
                        //    if (WatchShortVideoScript.touchDownDebounce) {
                        //  WatchShortVideoScript.touchDownDebounce = false;
                        var rowdownindex = parseInt(activerowindex - 1)
                        WatchShortVideoScript.activePlayerRowIndex = rowdownindex;
                        WatchShortVideoScript.playActiveVideoOnSwap(rowdownindex, dir);
                        //    setTimeout(function () { WatchShortVideoScript.touchDownDebounce = true; }, 0);


                        // }
                    }


                    //   }


                }

                if (dir == "none" && phase == "end") {  // if touched 
                    //  alert(evt.id)
                    //   if (WatchShortVideoScript.touchDebounce) {
                    //   WatchShortVideoScript.touchDebounce = false;
                    WatchShortVideoScript.playpausePlayer(WatchShortVideoScript.activePlayerRowIndex);
                    //  setTimeout(function () { WatchShortVideoScript.touchDebounce = true; },100);

                    //  }



                    var replayiconId = "replayicon" + WatchShortVideoScript.activePlayerRowIndex

                    if (document.getElementById(replayiconId)) {
                        if (!document.getElementById(replayiconId).classList.contains('hide')) {

                            document.getElementById(replayiconId).classList.add('hide')
                        }
                    }

                }

                //    //console.log(touchreport)

            })  // swap detect end

        })


        ////   WatchShortVideoScript.initPlayer(); sample test codeing


    },

    playpausePlayer(activerowindex) {

        var curentvideo = WatchShortVideoScript.activePlayer;

        var playiconId = "playicon" + activerowindex

        if (curentvideo != null) {

            var videoid = curentvideo.getAttribute('data-videoid');

            var language = curentvideo.getAttribute('data-language');

            if (curentvideo.paused) {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.add('hide')
                }
                setTimeout(() => {
                    try {
                        curentvideo.play();
                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Play');

                    }
                    catch (err) {
                        //console.log("playpausePlayer pause")
                    }
                }, 50);
            }
            else {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.remove('hide')
                }
                setTimeout(() => {
                    try {
                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Pause');
                        curentvideo.pause();
                    }
                    catch { err } {
                        //console.log("playpausePlayer play")
                    }
                }, 200);

            }
        }

    },



    playActiveVideoOnSwap(activeRow, dir = 'up') {
        // validation
        
          var nextVideo=null
        
        for (var index = 0; index < WatchShortVideoScript.videoItems.length; index++) {
            if (WatchShortVideoScript.videoItems[index].row == activeRow) {
                nextVideo = WatchShortVideoScript.videoItems[index].video;
                break;
            }
        }
        
        var istodaywatchedvideo = nextVideo.getAttribute('data-istodaywatchedvideo');
        if (WatchShortVideoScript.userInfo.clubUserType == 1 && WatchShortVideoScript.sfvLimit == false && istodaywatchedvideo=='False' ) {

            if (WatchShortVideoScript.isMobileApp == true) {
                setTimeout(() => {
                    WatchShortVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                        pageType: 9
                    })
                }, 1000);
            }
            else {
                location.href = "/PaymentUpgradeRequest?pageType=9";
            }

            return;

        }


        //  if (WatchShortVideoScript.isScroll) {

        WatchShortVideoScript.activePlayer.pause();
        WatchShortVideoScript.showHideVideos();
        WatchShortVideoScript.ActiateNextVideoIfNotExists()
        WatchShortVideoScript.isScroll = false;
        //console.log(WatchShortVideoScript.touchDetails)

        for (var index = 0; index < WatchShortVideoScript.videoItems.length; index++) {
            if (WatchShortVideoScript.videoItems[index].row == activeRow) {
                WatchShortVideoScript.activePlayer = WatchShortVideoScript.videoItems[index].video;
                WatchShortVideoScript.setTimeOutActiveVideos = []; // set this to find active video has payed 5 second validation and reset it not reached 5 seconds
                WatchShortVideoScript.setTimeOutActiveVideos.push(WatchShortVideoScript.activePlayer)
                break;
            }
        }

        try {

            var divid = "divvideoid" + activeRow;

            var divEle = document.getElementById(divid)

            // divEle.scrollIntoView({
            //     block: "center",
            //     behavior: "smooth"
            // });
            ;(0,seamlessscroll_min.scrollIntoView)(WatchShortVideoScript.activePlayer, {
                behavior: "smooth",
                block: "center",
                inline: "center",
            });

            // scrollIntoView(divEle, {
            //     behavior: "smooth",
            //     block: "center",
            //     inline: "center",
            // });


        }
        catch (err) {

        }



        setTimeout(async () => {

            WatchShortVideoScript.isScroll = true;
            try {
                await WatchShortVideoScript.activePlayer.play();


                var replayiconId = "replayicon" + WatchShortVideoScript.activePlayerRowIndex;

                if (document.getElementById(replayiconId)) {
                    if (!document.getElementById(replayiconId).classList.contains('hide')) {

                        document.getElementById(replayiconId).classList.add('hide')
                    }
                }
            }
            catch (err) {
                //console.log("playActiveVideoOnSwap play")
            }



            var videoid = WatchShortVideoScript.activePlayer.getAttribute('data-videoid');
            var language = WatchShortVideoScript.activePlayer.getAttribute('data-language');


            if (dir == "down") {
                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Previousvideo_Play');
            }
            else {

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Nextvideo_Play');
            }



            var playiconId = "playicon" + activeRow
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }
            // if (WatchShortVideoScript.isAllowSave) {
            //     WatchShortVideoScript.isAllowSave = false;
            //     setTimeout(() => {
            //         for (var row = 0; row < WatchShortVideoScript.setTimeOutActiveVideos.length; row++) {
            //             if (WatchShortVideoScript.setTimeOutActiveVideos[row] == WatchShortVideoScript.activePlayer) {
            //                 WatchShortVideoScript.SaveShortVideoAction(WatchShortVideoScript.activePlayer);
            //                 break;
            //             }
            //         }
            //         WatchShortVideoScript.isAllowSave = true;

            //     }, 10000);
            // }

        }, 100);


        //   }


    },


    /// Ref code



    playVisibleVideos_() {
        document.querySelectorAll("video").forEach(video => WatchShortVideoScript.isScrolledIntoView(video) ? video.play() : video.pause());
    },

    playVisibleVideos__() {
        //  document.querySelectorAll("video").forEach(video => WatchShortVideoScript.isScrolledIntoView(video) ? video.play() : video.pause());

        var videos = document.querySelectorAll("video");

        var activevideo = null;

        for (var i = 0; i < videos.length; i++) {
            var activevideo_ = videos[i];
            //  videoid=video.id;

            if (WatchShortVideoScript.isScrolledIntoView(activevideo_)) {
                activevideo = activevideo_;
                break
            }
            else {
                activevideo_.pause();
            }
        }

        if (activevideo) {
            activevideo.play();
            WatchShortVideoScript.SaveShortVideoAction(activevideo);
        }


        //  var videoid=0;
        for (var i = 0; i < videos.length; i++) {
            var video = videos[i];

            if (WatchShortVideoScript.isScrolledIntoView(video)) {

                // }

            }
            else {

                video.pause();

            }

        }
    },

    isScrolledIntoView(element) {
        var elementTop = element.getBoundingClientRect().top,
            elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= 0 && elementBottom <= window.innerHeight;
    },


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WatchShortVideoScript.userInfo = response.data;
        // WatchShortVideoScript.sfvWatchedCount=WatchShortVideoScript.userInfo.sfvWatchedCount;
        WatchShortVideoScript.sfvLimit = WatchShortVideoScript.userInfo.sfvLimit;
    },

    SaveShortVideoAction(e) {
        var action = ''
        var userPid = "0";
        var videoid = 0;
        var iswatched = "False";
        var languagevideoid = 0;
        var language = ""

        if (e.currentTarget) {
            action = e.currentTarget.getAttribute('data-action');
            userPid = e.currentTarget.getAttribute('data-userpid');
            videoid = e.currentTarget.getAttribute('data-videoid');
            iswatched = e.currentTarget.getAttribute('data-iswatched');
            languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
            language = e.currentTarget.getAttribute('data-language');

        }
        else {
            action = e.getAttribute('data-action');
            userPid = e.getAttribute('data-userpid');
            videoid = e.getAttribute('data-videoid');
            iswatched = e.getAttribute('data-iswatched');
            languagevideoid = e.getAttribute('data-languagevideoid');

            language = e.getAttribute('data-language');
        }
 /// validation removed in order to save all time
        // if (action == "watched") {

        //     bindGA.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Video_completed');

        //     if (iswatched == "True") { // stop again update the recorded status 
        //         WatchShortVideoScript.isAllowSave = true;
        //         videoid = 0;
        //         return;
        //     }
        // }

        if (videoid > 0) {

            //  WatchShortVideoScript.selectedVideo=videoid;
            var obj = { "UserPid": userPid, "VideoId": videoid, "Action": action, "languageVideoid": languagevideoid }
            let url = `${CSMainAPIs.Capshine.Server.baseUrl}api/Videos/SaveShortVideoAction/`
            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            })
                .then((response) => response.json())
                .then((responseJson) => {

                    //isVideoWatched,isBookMarked,isLiked
                    //this.userInfo = responseJson;
                    if (action == "like") {

                        var likeId = "like" + videoid;
                        var obj = document.getElementById(likeId);

                        if (responseJson.isLiked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Like');

                    }

                    if (action == "bookmark") {
                        var bookmarkId = "bookmark" + videoid;
                        var obj = document.getElementById(bookmarkId);

                        if (responseJson.isBookMarked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_BookMark');
                    }

                    if (action == "watched") {
                        WatchShortVideoScript.isAllowSave = true;
                        e.setAttribute("data-iswatched", "True");
                        if (responseJson.todayWatchedCount >= WatchShortVideoScript.userInfo.sfvDailyWatchLimit) {
                            WatchShortVideoScript.sfvLimit = false;
                        }

                    }

                });

        }

        //   CSMainAPIs.Capshine.APIs.SaveShortVideoAction.execute({ "UserPid": userPid,"VideoId":videoid,"Action":action }, WatchShortVideoScript.afterSaveShortVideoActionResponse);

    },

    afterSaveShortVideoActionResponse(response) {
        WatchShortVideoScript.userInfo = response.data;
        //  WatchShortVideoScript.selectedVideo

    },



    setupDashJsVideo() {

        var videos = document.querySelectorAll("video");
        var url = videos[0].getAttribute("data-videourl");

        var player = dashjs.MediaPlayer().create();

        player.updateSettings({
            'debug': {
                'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
            },
            'streaming': {
                'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                },
                'buffer': {
                    'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                }
            }
        });

        // player.updateSettings({
        //     streaming: {
        //         buffer: {
        //             initialBufferLevel:12,
        //             bufferPruningInterval: 10,
        //             bufferToKeep: 20,
        //         }
        //     }
        // });

        // player.updateSettings({
        //     buffer: {
        //         initialBufferLevel: 12
        //     }
        // });

        player.initialize(videos[0], url, true);

        setTimeout(() => {
            WatchShortVideoScript.toggleControls(videos[0])
        }, 100);




        //** */  

        // player.updateSettings({
        //     'streaming': {
        //         'abr': {
        //             'minBitrate': {
        //                 'video': -1
        //             },
        //             'maxBitrate': {
        //                 'video': 5000
        //             },
        //             'limitBitrateByPortal': false
        //         },
        //         'scheduling': {
        //             'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
        //         },
        //         'delay': { 'liveDelayFragmentCount': 0 }
        //         //     'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
        //         // }
        //     }
        // })




        // player.updateSettings({ 'streaming': { 'delay': { 'liveDelayFragmentCount': 0 } } });
        // let currentTime = player.time();
        // player.seek(currentTime);

        var videoid = videos[0].getAttribute('data-videoid');
        var language = videos[0].getAttribute('data-language');

        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Start_SFV');

        var videoobj = {
            row: 1,
            id: videos[0].id,
            player: player,
            video: videos[0]
        }


        WatchShortVideoScript.videoItems.push(videoobj);

        WatchShortVideoScript.activePlayer = videos[0];

        WatchShortVideoScript.activePlayerRowIndex = 1;

        WatchShortVideoScript.showHideVideos();

        WatchShortVideoScript.ActiateNextVideoIfNotExists()

        // setTimeout(() => {
        //     if (videos[0] == WatchShortVideoScript.activePlayer) {
        //         WatchShortVideoScript.SaveShortVideoAction(WatchShortVideoScript.activePlayer);
        //     }

        // }, 10000);







        //         for (var row = 1; row < videos.length; row++) {
        //             var videourl = videos[row].getAttribute("data-videourl");

        //             var player_ = dashjs.MediaPlayer().create()



        //             player_.updateSettings({
        //                 'streaming': {
        //                     'abr': {
        //                         'minBitrate': {
        //                             'video': -1
        //                         },
        //                         'maxBitrate': {
        //                             'video': 5000
        //                         },
        //                         'limitBitrateByPortal': false
        //                     },
        //                     'scheduling': {
        //                         'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
        //                     }
        //                 }

        //             })

        //             player_.initialize(videos[row], videourl, false);
        //             let currentTime = player_.time();
        //             player_.seek(currentTime);
        // // in loadedmetadata event

        //             var videoobj_ = {
        //                 row: row + 1,
        //                 id: videos[row].id,
        //                 player: player_,
        //                 video: videos[row]
        //             }

        //             WatchShortVideoScript.videoItems.push(videoobj_);

        //         }



    },
    showHideVideos() {
        var activeVideoIndex = parseInt(WatchShortVideoScript.activePlayerRowIndex);

        //    else
        // Show/Hide Next two div video element from current video 

        //Show Next item from current video div
        var showdivid = "divvideoid" + (activeVideoIndex + 1); // next div
        var showdivEle = document.getElementById(showdivid);


        if (showdivEle != null) {

            if (showdivEle.classList.contains('hide')) {
                //   showdivEle.classList.remove('hide')
            }
        }

        //Hide  next one div after Next div from current video div
        var hidedivid = "divvideoid" + (activeVideoIndex + 2);

        var hidedivEle = document.getElementById(hidedivid);

        if (hidedivEle != null) {
            if (!hidedivEle.classList.contains('hide')) {
                //   hidedivEle.classList.add('hide')
            }
        }

        /// 

        // Show/Hide Previous two div video element from current video 

        if (activeVideoIndex < 1) {
            return;
        }


        //Show Prevous item from current video div
        var showdivPreid = "divvideoid" + (activeVideoIndex - 1); // next div
        var showdivPreEle = document.getElementById(showdivPreid);

        if (showdivPreEle != null) {
            if (showdivPreEle.classList.contains('hide')) {
                //  showdivPreEle.classList.remove('hide')
            }
        }

        if (activeVideoIndex < 2) {
            return;
        }

        //Hide before one div before one div from current video div
        var hidedivPreid = "divvideoid" + (activeVideoIndex - 2);

        var hidedivPreEle = document.getElementById(hidedivPreid);

        if (hidedivPreEle != null) {
            if (!hidedivPreEle.classList.contains('hide')) {
                //  hidedivPreEle.classList.add('hide')
            }
        }

    },

    ActiateNextVideoIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchShortVideoScript.activePlayerRowIndex);
        let videos = document.querySelectorAll("video");

        // load next three videos

        for (var row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (var index = 0; index < WatchShortVideoScript.videoItems.length; index++) {
                    if (WatchShortVideoScript.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }


                if (isCreateVideo == true) {
                    let videourl = videos[activeVideoIndex].getAttribute("data-videourl");

                    let player_ = dashjs.MediaPlayer().create()


                    player_.updateSettings({
                        'debug': {
                            'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
                        },
                        'streaming': {
                            'scheduling': {
                                'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                            },
                            'buffer': {
                                'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                            }
                        }
                    });

                    // player_.updateSettings({
                    //     'streaming': {
                    //         'abr': {
                    //             'minBitrate': {
                    //                 'video': -1
                    //             },
                    //             'maxBitrate': {
                    //                 'video': 5000
                    //             },
                    //             'limitBitrateByPortal': false
                    //         },
                    //         'scheduling': {
                    //             'scheduleWhilePaused': true,   /* dont stops the player from loading segments while paused */
                    //         }
                    //     }

                    // })


                    // player_.updateSettings({
                    //     streaming: {
                    //         'scheduling': {
                    //             'scheduleWhilePaused': true,   /* dont stops the player from loading segments while paused */
                    //         },
                    //         buffer: {
                    //             initialBufferLevel: 12,
                    //         }
                    //     }
                    // });
                    player_.initialize(videos[activeVideoIndex], videourl, false);
                    

                    setTimeout(() => {
                        WatchShortVideoScript.toggleControls(videos[activeVideoIndex])
                    }, 50);



                    // player_.updateSettings({
                    //     'streaming': {
                    //         'abr': {
                    //             'minBitrate': {
                    //                 'video': -1
                    //             },
                    //             'maxBitrate': {
                    //                 'video': 5000
                    //             },
                    //             'limitBitrateByPortal': false
                    //         },
                    //         'scheduling': {
                    //             'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                    //         },
                    //         'delay': { 'liveDelayFragmentCount': 0 }
                    //         //     'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                    //         // }
                    //     }
                    // })


                    //  player_.updateSettings({ 'streaming': { 'delay': { 'liveDelayFragmentCount': 0 } } });



                    // let currentTime = player_.time();
                    // player_.seek(currentTime);

                    //  player_.setQualityFor('audio',0);  //low bitrate (64 kbps) 

                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        player: player_,
                        video: videos[activeVideoIndex]
                    }
                    WatchShortVideoScript.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;


                }
            }
        }
    },

    resetAll() {
        WatchShortVideoScript.UserPid = '';
        WatchShortVideoScript.userInfo = null;
        WatchShortVideoScript.isMobileApp = false;
        WatchShortVideoScript.activePlayer = null;
        WatchShortVideoScript.videoItems = [];
        WatchShortVideoScript.activePlayerRowIndex = 1;
        WatchShortVideoScript.setTimeOutActiveVideos = [];

        function fixTouchStart(event) {
            return;
        }


        function fixTouchEnd(event) {
            return;
        }
        function fixTouchMove(event) {
            return;
        }

        function removePauseVideOnDocumentLooseFocus() {
            return;
        }
        function removePlayideOnDocumentOnFocus() {
            return;
        }


        // Remove any previous listners as the page content is ajax loaded and body is never destroyed
        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);

        // reset events 
    },


    initPlayer() {
        var player;
        var video,
            url = "https://capshine-usea.streaming.media.azure.net/4d8afc53-9974-4b17-9d77-4ebdd0616d8f/chore_english.ism/manifest";

        video = document.getElementById("video_test");
        player = dashjs.MediaPlayer().create();
        player.initialize(video, url, true);

        player.updateSettings({
            'streaming': {
                'abr': {
                    'minBitrate': {
                        'video': -1
                    },
                    'maxBitrate': {
                        'video': 5000
                    },
                    'limitBitrateByPortal': false,
                }, 'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                }
            }
        })

        player.on(dashjs.MediaPlayer.events["PLAYBACK_ENDED"], function () {
            clearInterval(eventPoller);
        });

        var eventPoller = setInterval(function () {
            var streamInfo = player.getActiveStream().getStreamInfo();
            var dashMetrics = player.getDashMetrics();
            var dashAdapter = player.getDashAdapter();

            if (dashMetrics && streamInfo) {
                const periodIdx = streamInfo.index;
                var repSwitch = dashMetrics.getCurrentRepresentationSwitch('video', true);
                var bufferLevel = dashMetrics.getCurrentBufferLevel('video', true);
                var bitrate = repSwitch ? Math.round(dashAdapter.getBandwidthForRepresentation(repSwitch.to, periodIdx) / 1000) : NaN;
                // document.getElementById('currentBufferLevel').innerText = bufferLevel + " secs";
                //   document.getElementById('reportedBitrate').innerText = bitrate + " Kbps";
            }
        }, 1000);
    },


    pauseVideOnDocumentLooseFocus() {
        if (WatchShortVideoScript.activePlayer) {
            WatchShortVideoScript.activePlayer.pause();
            var playiconId = "playicon" + WatchShortVideoScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.remove('hide')
            }
            ////console.log("LooseFocus");
        }

    },


    playVideOnDocumentOnFocus() {
        if (WatchShortVideoScript.activePlayer) {
            WatchShortVideoScript.activePlayer.play();
            var playiconId = "playicon" + WatchShortVideoScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }
            //   //console.log("OnFocus");
        }

    },

    pauseAllVideosBeforeExit() {

        for (var index = 0; index < WatchShortVideoScript.videoItems.length; index++) {
            var video = WatchShortVideoScript.videoItems[index].video;
            var player = WatchShortVideoScript.videoItems[index].player;
            if (video.paused) {

            } else {
                video.pause();
            }

            // distory the player 
            if (player) {
                player.reset();
            }


        }

    },
    setEventsForVideo() {

        var videos = document.querySelectorAll("video");

        document.querySelectorAll('video').forEach(video => {
            video.addEventListener('timeupdate', event => {
                if (video.currentTime > 10 && video.currentTime < 11) {


                    if (WatchShortVideoScript.isAllowSave == true) {
                        if (video == WatchShortVideoScript.activePlayer) {
                            WatchShortVideoScript.isAllowSave = false;
                            WatchShortVideoScript.SaveShortVideoAction(video);
                            //WatchShortVideoScript.isAllowSave = true;
                        }

                    }

                    // console.log("video id :"+ video.id + "TIme Passed :"  + video.currentTime)
                }
                //handle click
            })

            // video.addEventListener('ended', event => {
            //     video.currentTime=0;
            //      var activerowindex= WatchShortVideoScript.activePlayerRowIndex;

            //      var playiconId = "playicon" + activerowindex

            //      if (document.getElementById(playiconId)) {
            //         document.getElementById(playiconId).classList.remove('hide')
            //     }
            //     //  alert("Video Id "+ video.id + " end" )
            //     //handle click
            // })

            video.addEventListener('ended', event => {
                video.currentTime = 0;
                var activerowindex = WatchShortVideoScript.activePlayerRowIndex;

                var replayiconId = "replayicon" + activerowindex

                if (document.getElementById(replayiconId)) {
                    document.getElementById(replayiconId).classList.remove('hide')
                }
                //  alert("Video Id "+ video.id + " end" )
                //handle click
            })


        })


    },

    toggleControls(video) {
        if (video.hasAttribute("controls")) {
            video.removeAttribute("controls")
        }
        else {
            video.setAttribute("controls", "controls")
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


}

/* harmony default export */ const js_WatchShortVideoScript = (WatchShortVideoScript);
;// CONCATENATED MODULE: ./src/js/CodeOfConduct.js
﻿

let CodeOfConduct = {
	userPid: 0,
	init: function (userPid) {
		CodeOfConduct.userPid = userPid;
		CodeOfConduct.bindEvents();

		//if (CodeOfConduct.userPid > 0) {
		//	if (document.querySelector(".sk-popup,code-of-conduct") != null) {

		//		document.querySelector(".sk-popup,code-of-conduct").classList.add("show");
		//	}
		//}
	},
	bindEvents: function () {

		let learnersCodeOfConductBtn = document.querySelector("[learners-code-of-conduct-btn]");
		if (learnersCodeOfConductBtn) {
			learnersCodeOfConductBtn.addEventListener('click', () => {
				if (document.querySelector(".Codeof-Conduct-popup,code-of-conduct") != null) {
					document.querySelector(".Codeof-Conduct-popup,code-of-conduct").classList.add("show");
				}
			});
		}

		let agreeCodeOfConductBtn = document.querySelector("[agree-code-of-conduct-btn]");
		if (agreeCodeOfConductBtn) {
			agreeCodeOfConductBtn.addEventListener('click', () => {
				CSMainAPIs.Capshine.APIs.UpdateCodeOfConduct.execute(null, (response) => {
					document.querySelector(".Codeof-Conduct-popup,code-of-conduct").classList.remove("show");
				}, { UserPid: CodeOfConduct.userPid });
			});
		}
	}
}

/* harmony default export */ const js_CodeOfConduct = (CodeOfConduct);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/SignUpTalktime.vue?vue&type=template&id=6c94d324


const SignUpTalktimevue_type_template_id_6c94d324_hoisted_1 = {
  class: "sk-panel show step-slider",
  id: "signup-talktime-div"
}
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_2 = { class: "sk-inner" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_3 = { class: "sk-body no-scroll auto-nav" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_4 = { class: "slide-content quick-onboarding" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_5 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("img", {
  class: "logo-capshine",
  src: "https://sulcdn.azureedge.net/content/caps/Capshine_v2/capshine-app-logo.svg"
}, null, -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_6 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "align-center mt-3" }, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("h2", null, "Hello there!"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, " You've been invited by your friend to join our talk-time session. Please provide below details to continue. ")
], -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_7 = { class: "user-details" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_8 = { class: "text-field border-label-over" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_9 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("label", null, [
  /*#__PURE__*/(0,vue_cjs.createTextVNode)("Name "),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "required" }, "*")
], -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_10 = {
  key: 0,
  class: "error-text show"
}
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_11 = { class: "text-field border-label-over" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_12 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("label", null, [
  /*#__PURE__*/(0,vue_cjs.createTextVNode)("Email "),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "required" }, "*")
], -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_13 = {
  key: 0,
  class: "error-text show"
}
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_14 = { class: "text-field border-label-over mobile-number" }
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("label", null, [
  /*#__PURE__*/(0,vue_cjs.createTextVNode)("Mobile "),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", { class: "required" }, "*")
], -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_16 = {
  key: 0,
  class: "error-text show"
}
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_17 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("small", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconchevrondown" })
  ])
], -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_18 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("input", {
  id: "countryCode",
  class: "hide",
  type: "text",
  name: "myCountry",
  placeholder: "Country code"
}, null, -1)
const SignUpTalktimevue_type_template_id_6c94d324_hoisted_19 = { class: "slide-content" }

function SignUpTalktimevue_type_template_id_6c94d324_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Countrycode = (0,vue_cjs.resolveComponent)("Countrycode")
  const _component_Otp = (0,vue_cjs.resolveComponent)("Otp")

  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_1, [
    (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_2, [
      (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_3, [
        (0,vue_cjs.createElementVNode)("div", {
          class: (0,vue_cjs.normalizeClass)([!_ctx.otpScreen?'current-slide':'previous-slide', "welcome"])
        }, [
          (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_4, [
            SignUpTalktimevue_type_template_id_6c94d324_hoisted_5,
            SignUpTalktimevue_type_template_id_6c94d324_hoisted_6,
            (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_7, [
              (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_8, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.enteredValues.userName) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [vue_cjs.vModelText, _ctx.enteredValues.userName]
                ]),
                SignUpTalktimevue_type_template_id_6c94d324_hoisted_9,
                (_ctx.nameError)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", SignUpTalktimevue_type_template_id_6c94d324_hoisted_10, (0,vue_cjs.toDisplayString)(_ctx.nameError), 1))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]),
              (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_11, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.enteredValues.email) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [vue_cjs.vModelText, _ctx.enteredValues.email]
                ]),
                SignUpTalktimevue_type_template_id_6c94d324_hoisted_12,
                (_ctx.emailError)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", SignUpTalktimevue_type_template_id_6c94d324_hoisted_13, (0,vue_cjs.toDisplayString)(_ctx.emailError), 1))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]),
              (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_14, [
                (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.enteredValues.mobile) = $event)),
                  type: "text",
                  placeholder: "Enter your phone number",
                  required: "",
                  pattern: "[0-9]*",
                  inputmode: "numeric"
                }, null, 512), [
                  [vue_cjs.vModelText, _ctx.enteredValues.mobile]
                ]),
                SignUpTalktimevue_type_template_id_6c94d324_hoisted_15,
                (_ctx.mobileError)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", SignUpTalktimevue_type_template_id_6c94d324_hoisted_16, (0,vue_cjs.toDisplayString)(_ctx.mobileError), 1))
                  : (0,vue_cjs.createCommentVNode)("", true),
                (0,vue_cjs.createElementVNode)("h6", {
                  class: "country-code",
                  id: "bt",
                  value: "Show DIV",
                  onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.openCountrySearch && _ctx.openCountrySearch(...args)))
                }, [
                  (0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(_ctx.enteredValues.countryCode), 1),
                  SignUpTalktimevue_type_template_id_6c94d324_hoisted_17
                ])
              ]),
              SignUpTalktimevue_type_template_id_6c94d324_hoisted_18,
              (0,vue_cjs.createElementVNode)("div", {
                class: (0,vue_cjs.normalizeClass)({ hide: !_ctx.showCountrySearch })
              }, [
                (0,vue_cjs.createVNode)(_component_Countrycode, {
                  onCountryCodeBlur: _ctx.onCountryCodeBlur,
                  selectionCallBack: _ctx.countryCodeSelectionCallBack,
                  shouldFocus: _ctx.showCountrySearch
                }, null, 8, ["onCountryCodeBlur", "selectionCallBack", "shouldFocus"])
              ], 2)
            ]),
            (0,vue_cjs.createElementVNode)("div", {
              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.createAccount && _ctx.createAccount(...args))),
              class: "button primary block"
            }, "Create Account")
          ])
        ], 2),
        (0,vue_cjs.createElementVNode)("div", {
          class: (0,vue_cjs.normalizeClass)([_ctx.otpScreen?'current-slide':'next-slide', "otp-number"])
        }, [
          (0,vue_cjs.createElementVNode)("div", SignUpTalktimevue_type_template_id_6c94d324_hoisted_19, [
            (0,vue_cjs.createVNode)(_component_Otp, {
              mobileNumber: _ctx.enteredValues.mobile,
              countryCode: _ctx.enteredValues.countryCode,
              initOtpTimer: _ctx.initOtpTimer,
              onSuccess: _ctx.checkIfAlreadyRegistered,
              resendOtp: _ctx.requestForOtp,
              isSignUpPage: _ctx.isSignUpPage,
              onClickBack: _ctx.onClickOtpBack
            }, null, 8, ["mobileNumber", "countryCode", "initOtpTimer", "onSuccess", "resendOtp", "isSignUpPage", "onClickBack"])
          ])
        ], 2)
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/SignUpTalktime.vue?vue&type=template&id=6c94d324

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/SignUpTalktime.vue?vue&type=script&lang=js

	
	
	
	
	

	/* harmony default export */ const SignUpTalktimevue_type_script_lang_js = ((0,vue_cjs.defineComponent)({
		name: 'SignUpTalktime',
		components: {
			Otp: Otp,
			Countrycode: CountryCode,
		},
		props: {
			talkTimeScheduleId: Number,
			userPid: Number,
			sulekhaApp: null,
		},
		data() {
			return {
				regexp: {
					alpha: /[a-zA-Z ]{2,30}$/,
					number: /[^0-9]/g,
					email: /^\w+[\+\.\w-]*@([\w-]+\.)*\w+[\w-]*\.([a-z]{2,4}|\d+)$/i,
					mobile1: /^[9|7|6|8]\d{8}[\d{1}]$/i,
					internationalmobile: /^[0-9]{6,14}$/,
				},
				enteredValues: {
					language: "",
					whyPractice: "",
					pincode: "0",
					gender: "",
					age: "",
					occupation: "",
					mobile: "",
					userName: "",
					email: "",
					countryCode: "+91",
				},
				emailError: "",
				nameError: "",
				mobileError: "",
				otpScreen: false,
				initOtpTimer: false,
				isAlreadyCapshineUser: false,
				isAlreadyClubMember: false,
				userpid: false,
				showCountrySearch: false,
				isUserLoggedIn: false,
				isSignUpPage: true,
				userDetails: [],
			}
		},
		mounted: function () {
			GATrack.pushValues('Registration_New userminiTT', 'Newuser_MiniTT', 'login screen');
		},
		methods: {
			isValidName(name) {
				return this.regexp.alpha.test(name);
			},
			isValidEMail(email) {
				return this.regexp.email.test(email);
			},
			isValidMobileNumber(mobileno, countrycode) {
				if (
					countrycode == undefined ||
					countrycode == "" ||
					countrycode == "91" ||
					countrycode == "+91"
				) {
					return this.regexp.mobile1.test(mobileno);
				} else {
					return this.regexp.internationalmobile.test(mobileno);
				}
			},
			isValidScreen: function () {
				let val = true;
				if (!this.isValidName(this.enteredValues.userName)) {
					this.nameError = "Enter a valid name";
					val = false;
				}
				else {
					this.nameError = "";
				}
				if (!this.isValidEMail(this.enteredValues.email)) {
					this.emailError = "Enter a valid email Id";
					val = false;
				}
				else {
					this.emailError = "";
				}
				if (!this.isValidMobileNumber(this.enteredValues.mobile, this.enteredValues.countryCode)) {
					this.mobileError = "Enter a valid phone number";
					val = false;
				}
				else {
					this.mobileError = "";
				}
				return val;
			},
			RegisterForCapshineAndClub: async function () {
				let requestData = {
					CountryCode: this.enteredValues.countryCode,
					Email: this.enteredValues.email,
					Mobile: this.enteredValues.mobile,
					Name: this.enteredValues.userName,
					PinCode: this.enteredValues.pincode,
					UserPid: this.userpid ? this.userpid : 0,
					PreferredLanguage: this.enteredValues.language,
					Gender: this.enteredValues.gender,
					AgeGroup: this.enteredValues.age,
					Occupation: this.enteredValues.occupation,
					Reason: this.enteredValues.whyPractice,
					/*PreferredClassTiming: this.enteredValues.PreferredTime,*/
					/*PreferredDay: this.enteredValues.PreferredDay,*/
					isCapshineSignUp: !this.isAlreadyCapshineUser,
					isClubSignUp: !this.isAlreadyClubMember,
					isUserLoggedIn: this.isUserLoggedIn,
					Source: navigator.userAgent,
					// clubId: this.selectedValues.clubId,
				};
				await new Promise((resolve, reject) => {
					CSMainAPIs.Capshine.APIs.RegisterForCapshineAndClub.execute(
						requestData,
						() => {
							resolve();
						}
					);
				});
			},
			checkAccountForEmail: async function () {
				return new Promise((resolve, reject) => {
					CSMainAPIs.Capshine.APIs.checkAccountForEmail.execute(
						{ emailId: this.enteredValues.email },
						(response) => {
							resolve(response.data);
						}
					);
				});
			},
			requestForOtp: async function () {
				let requestData = {
					MobileNumber: this.enteredValues.mobile,
					CountryCode: this.enteredValues.countryCode,
				};
				// this.initOtpTimer = false;
				return new Promise((resolve) => {
					CSMainAPIs.Capshine.APIs.SendOtp.execute(requestData, (response) => {
						if (
							response.data.mobileVerificationStatus == "VerificationCodeSent"
						) {
							this.initOtpTimer = true;
							resolve(true);
						} else if (response.data.mobileVerificationStatus == "Limit") {
							resolve(false);
						}
					});
				});
			},
			checkIfAlreadyRegistered: function () {
				CSMainAPIs.Capshine.APIs.CheckIfAlreadyRegistered.execute(
					{ mobileNumber: this.enteredValues.mobile },
					(response) => {
						let data = response.data;
						this.isAlreadyCapshineUser = data.isAlreadyCapshineUser;
						this.isAlreadyClubMember = data.isAlreadyClubMember;
						this.userpid = data.userPid;

						if (data.isAlreadyCapshineUser && data.isAlreadyClubMember) {
							this.redirectToNextPage(this.enteredValues.mobile);
						} else {
							this.RegisterForCapshineAndClub();
							this.redirectToNextPage(this.enteredValues.mobile);
						}
					}
				);
			},
			onCountryCodeBlur: function () {
				this.showCountrySearch = false;
			},
			openCountrySearch: function () {
				this.showCountrySearch = !this.showCountrySearch;
			},
			countryCodeSelectionCallBack(countrycode) {
				this.showCountrySearch = false;
				this.enteredValues.countryCode = countrycode;
			},
			createAccount: async function () {
				if (this.isValidScreen()) {
					let response = await this.checkAccountForEmail();
					if (!response) {
						this.emailError = "This Email is already associated with another account";
						return;
					}
					let canMove = await this.requestForOtp();
					if (canMove) {
						GATrack.pushValues('Registration_New userminiTT', 'Newuser regn_MiniTT', 'Click_RegnSubmit');
						this.otpScreen = true;
					}
					else
						this.mobileError = "Maximum Limit Reached";
				}
			},
			onClickOtpBack() {
				this.initOtpTimer = false;
				this.otpScreen = false;
			},
			redirectToNextPage: function (mobile) {
				setTimeout(() => {
					var apiInput = {
						"Mobilenumber": mobile,
						"UserPid": "",
						"LoginUser": true
					};
					CSMainAPIs.Capshine.APIs.GetUserInfo.execute(apiInput, (response) => {
						const userResponseData = response.data;
						if (userResponseData.pid > 0)
							window.location.replace("/talktime/" + this.talkTimeScheduleId + "/SignUpTalktime");
					});
				}, 2000);
			},
		}
	}));


;// CONCATENATED MODULE: ./src/Components/SignUpTalktime.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/SignUpTalktime.vue




;
const SignUpTalktime_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SignUpTalktimevue_type_script_lang_js, [['render',SignUpTalktimevue_type_template_id_6c94d324_render]])

/* harmony default export */ const SignUpTalktime = (SignUpTalktime_exports_);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/TalkTImeManagement.vue?vue&type=template&id=dc4787dc


const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_1 = {
  class: "watched-videos",
  id: "talktimemanagement-form"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_2 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h3", { class: "align-center mt-2" }, "TalkTime Management", -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_3 = { key: 0 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_4 = {
  key: 0,
  class: "sk-container",
  style: {"display":"flex","gap":"3rem"}
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_5 = {
  key: 0,
  class: "filter-group"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_6 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Coach", -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_7 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_8 = ["value", "id", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_9 = {
  key: 1,
  class: "filter-group"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_10 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Month", -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_11 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_12 = ["value", "id"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_13 = {
  key: 1,
  class: "sk-container",
  style: {"display":"flex","gap":"3rem"}
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_14 = {
  key: 0,
  class: "filter-group"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Month", -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_16 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_17 = ["value", "id"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_18 = { class: "sk-tabs" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_19 = {
  class: "sk-tabs-nav",
  id: "divStickyTab"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_20 = { class: "sk-tab-content" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_21 = {
  id: "divCalenderView",
  class: "sk-tab active"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_22 = {
  class: "sk-container",
  id: "divCalenderContainer"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_23 = { class: "short-videos video-group" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_24 = {
  id: "divAvailability",
  class: "sk-tab"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_25 = { class: "sk-container" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_26 = { class: "short-videos video-group" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_27 = { key: 0 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_28 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "TimeSlot"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Sunday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Monday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Tuesday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Wednesday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Thursday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Friday"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Saturday")
], -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_29 = ["id"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_30 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_31 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_32 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_33 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_34 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_35 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_36 = ["checked", "onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_37 = {
  colspan: "8",
  align: "right"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_38 = { key: 0 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_39 = {
  id: "divttreport",
  class: "sk-tab"
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_40 = { class: "sk-container" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_41 = { class: "short-videos video-group" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_42 = { key: 0 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_43 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Date"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Meeting Type"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Sessions Allocated"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Sessions Taken"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Slot Timings"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Missed Slot(s)")
], -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_44 = ["id"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_45 = { key: 1 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_46 = { key: 1 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_47 = { class: "sk-popup cancel-booking show" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_48 = { class: "sk-inner" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_49 = { class: "sk-header" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_50 = { class: "button-group no-margin" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_51 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_52 = [
  TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_51
]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_53 = { class: "sk-body" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_54 = { class: "sk-container" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_55 = {
  key: 0,
  style: {"width":"100% !important"}
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_56 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Time Slot"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Booked Count"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Topic"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Action"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Remark")
], -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_57 = ["id"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_58 = ["href"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_59 = ["onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_60 = ["onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_61 = ["onClick"]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_62 = { style: {"width":"200px"} }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_63 = {
  key: 0,
  class: ""
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_64 = {
  key: 1,
  class: ""
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_65 = { key: 2 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_66 = {
  key: 3,
  class: ""
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_67 = {
  key: 4,
  class: ""
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_68 = {
  key: 5,
  class: ""
}
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_69 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, null, -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_70 = { key: 2 }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_71 = { class: "sk-popup cancel-booking show" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_72 = { class: "sk-inner" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_73 = { class: "sk-header" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_74 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_75 = [
  TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_74
]
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_76 = { class: "sk-body" }
const TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_77 = {
  key: 0,
  class: "sk-container"
}
const _hoisted_78 = {
  key: 0,
  class: "filter-group"
}
const _hoisted_79 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Coach", -1)
const _hoisted_80 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const _hoisted_81 = ["value", "id", "onClick"]
const _hoisted_82 = { key: 3 }
const _hoisted_83 = { class: "sk-popup cancel-booking show" }
const _hoisted_84 = { class: "sk-inner" }
const _hoisted_85 = { class: "sk-header" }
const _hoisted_86 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, "Available slots ", -1)
const _hoisted_87 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "sk-body" }
const _hoisted_90 = { class: "sk-container" }
const _hoisted_91 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_92 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Coach Name"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Coach UserPid"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Scheduled Date"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Time Slot"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Updated Coach Name"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Updated Coach UserPid")
], -1)
const _hoisted_93 = ["id"]
const _hoisted_94 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, null, -1)
const _hoisted_95 = {
  class: "overlay hide",
  id: "dialogMarkAsHoliday"
}
const _hoisted_96 = { class: "popup" }
const _hoisted_97 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, "Are you sure you want to mark all the sessions as holiday?", -1)
const _hoisted_98 = { class: "text-right" }
const _hoisted_99 = {
  class: "overlay hide",
  id: "dialogMarkAsNA"
}
const _hoisted_100 = { class: "popup" }
const _hoisted_101 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, "Are you sure you want to mark as not available?", -1)
const _hoisted_102 = { class: "text-right" }
const _hoisted_103 = {
  class: "overlay hide",
  id: "dialogMarkAsAvailable"
}
const _hoisted_104 = { class: "popup" }
const _hoisted_105 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, "Are you sure you want to cancel your leave?", -1)
const _hoisted_106 = { class: "text-right" }
const _hoisted_107 = {
  class: "overlay hide",
  id: "dialogMonthlyView"
}
const _hoisted_108 = { class: "popup" }
const _hoisted_109 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("p", null, "The changes have been updated", -1)
const _hoisted_110 = { class: "text-right" }
const _hoisted_111 = {
  class: "overlay hide",
  id: "dialogMonthlyUpdatedListView"
}
const _hoisted_112 = { class: "sk-popup cancel-booking show" }
const _hoisted_113 = { class: "sk-inner" }
const _hoisted_114 = { class: "sk-header" }
const _hoisted_115 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("span", null, "Updated Status ", -1)
const _hoisted_116 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = { class: "sk-body" }
const _hoisted_119 = { class: "sk-container" }
const _hoisted_120 = { style: {"width":"100% !important"} }
const _hoisted_121 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Alert Message"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Coach Name"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Coach UserPid"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Scheduled Date"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Time Slot"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Updated Coach Name"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Updated Coach UserPid")
], -1)
const _hoisted_122 = ["id"]
const _hoisted_123 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, null, -1)

function TalkTImeManagementvue_type_template_id_dc4787dc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FullCalendar = (0,vue_cjs.resolveComponent)("FullCalendar")

  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_1, [
    TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_2,
    ($data.showparent)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_3, [
          (this.userRole == 1)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_4, [
                ($data.coachList.length > 0)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_5, [
                      TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_6,
                      (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_7, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[0] || (_cache[0] = $event => ($options.onCoachChange())),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedCoach) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.coachList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.coachid,
                              id: index,
                              onClick: $event => (_ctx.selectCoach(index))
                            }, (0,vue_cjs.toDisplayString)(obj.coachname), 9, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_8))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedCoach]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true),
                ($data.activeTab == 3)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_9, [
                      TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_10,
                      (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_11, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[2] || (_cache[2] = $event => ($options.onMonthChange())),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedMonth) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.monthList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.monthid,
                              id: index
                            }, (0,vue_cjs.toDisplayString)(obj.month), 9, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_12))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedMonth]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]))
            : (0,vue_cjs.createCommentVNode)("", true),
          (this.userRole != 1)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_13, [
                ($data.activeTab == 3)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_14, [
                      TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_15,
                      (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_16, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[4] || (_cache[4] = $event => ($options.onMonthChange())),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedMonth) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.monthList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.monthid,
                              id: index
                            }, (0,vue_cjs.toDisplayString)(obj.month), 9, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_17))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedMonth]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]))
            : (0,vue_cjs.createCommentVNode)("", true),
          (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_18, [
            (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_19, [
              (0,vue_cjs.createElementVNode)("a", {
                id: "atagCalenderView",
                class: "active",
                onClick: _cache[6] || (_cache[6] = $event => ($options.NavigetToTab('CalenderView')))
              }, "Daywise Availability"),
              (0,vue_cjs.createElementVNode)("a", {
                id: "atagAvailability",
                class: "",
                onClick: _cache[7] || (_cache[7] = $event => ($options.NavigetToTab('UpdateAvail')))
              }, "Monthly Schedule"),
              (0,vue_cjs.createElementVNode)("a", {
                id: "atagttreport",
                class: "",
                onClick: _cache[8] || (_cache[8] = $event => ($options.NavigetToTab('TalktimeReport')))
              }, "Talktime Report")
            ]),
            (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_20, [
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_21, [
                (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_22, [
                  (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_23, [
                    (0,vue_cjs.createVNode)(_component_FullCalendar, { options: $data.calendarOptions }, null, 8, ["options"])
                  ])
                ])
              ]),
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_24, [
                (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_25, [
                  (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_26, [
                    ($data.timeslots.length > 0)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_27, [
                          TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_28,
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.timeslots, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                              key: index,
                              id: index
                            }, [
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeSlot), 1),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isSundaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isSundayChecked,
                                      onClick: $event => ($options.check(index, 1))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_30))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isMondaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isMondayChecked,
                                      onClick: $event => ($options.check(index, 2))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_31))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isTuesdaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isTuesdayChecked,
                                      onClick: $event => ($options.check(index, 3))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_32))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isWednesdaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isWednesdayChecked,
                                      onClick: $event => ($options.check(index, 4))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_33))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isThursdaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isThursdayChecked,
                                      onClick: $event => ($options.check(index, 5))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_34))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isFridaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isFridayChecked,
                                      onClick: $event => ($options.check(index, 6))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_35))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ]),
                              (0,vue_cjs.createElementVNode)("td", null, [
                                (obj.isSaturdaySlotAvailable)
                                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("input", {
                                      key: 0,
                                      type: "checkbox",
                                      checked: obj.isSaturdayChecked,
                                      onClick: $event => ($options.check(index, 7))
                                    }, null, 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_36))
                                  : (0,vue_cjs.createCommentVNode)("", true)
                              ])
                            ], 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_29))
                          }), 128)),
                          (0,vue_cjs.createElementVNode)("tr", null, [
                            (0,vue_cjs.createElementVNode)("td", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_37, [
                              ($data.isLoading)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_38, "Updating Please wait...."))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              ($data.isLoading == false)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: 1,
                                    class: "button primary small",
                                    onClick: _cache[9] || (_cache[9] = $event => ($options.updateTimeSlots()))
                                  }, " Update "))
                                : (0,vue_cjs.createCommentVNode)("", true)
                            ])
                          ])
                        ]))
                      : (0,vue_cjs.createCommentVNode)("", true)
                  ])
                ])
              ]),
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_39, [
                (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_40, [
                  (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_41, [
                    ($data.talktimereport.length > 0)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_42, [
                          TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_43,
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.talktimereport, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                              key: index,
                              id: index
                            }, [
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.scheduledate), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.meetingtype), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.sessionallocated), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.sessiontaken), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeslots), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.missedtimeslots), 1)
                            ], 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_44))
                          }), 128))
                        ]))
                      : (0,vue_cjs.createCommentVNode)("", true),
                    ($data.talktimereport.length == 0 && $data.shownorecord == 1)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_45, " No Session Available "))
                      : (0,vue_cjs.createCommentVNode)("", true)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true),
    ($data.showparent == false)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_46, [
          (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_47, [
            (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_48, [
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_49, [
                (0,vue_cjs.createElementVNode)("span", null, "Date : " + (0,vue_cjs.toDisplayString)($data.selectedFormatedDate), 1),
                (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_50, [
                  ($data.showAppyLeaveForTheDayButton == 1)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                        key: 0,
                        type: "button",
                        class: "button primary small",
                        onClick: _cache[10] || (_cache[10] = $event => ($options.displayMarkAsHolidayCofirmDialog()))
                      }, " Mark As Holiday "))
                    : (0,vue_cjs.createCommentVNode)("", true)
                ]),
                (0,vue_cjs.createElementVNode)("div", {
                  class: "right-nav close-modal",
                  onClick: _cache[11] || (_cache[11] = $event => ($options.close()))
                }, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_52)
              ]),
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_53, [
                (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_54, [
                  ($data.allocatedavailableslots.length > 0)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_55, [
                        TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_56,
                        ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.allocatedavailableslots, (obj, index) => {
                          return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                            key: index + 'aa',
                            id: 'slots' + index
                          }, [
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeslot), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.bookedcount), 1),
                            (0,vue_cjs.createElementVNode)("td", null, [
                              (0,vue_cjs.createElementVNode)("a", {
                                href: $options.getPPTURL(obj.topicId),
                                target: "_blank"
                              }, (0,vue_cjs.toDisplayString)(obj.topic), 9, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_58)
                            ]),
                            (0,vue_cjs.createElementVNode)("td", null, [
                              (obj.isleaveeligible == 1 && obj.isleaveupdated == 0)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: 0,
                                    type: "button",
                                    class: "button primary small",
                                    id: "update-btn",
                                    onClick: $event => (
                        $options.displayMarkAsNACofirmDialog(
                          obj.slotid,
                          obj.scheduledatetime,
                          obj.talkTimescheduleid
                        )
                      )
                                  }, " Mark as Not Available ", 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_59))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (
                        obj.isleaveupdated == 1 &&
                        obj.isleavecanceleligible == 1 &&
                        !(obj.issessioncompleted == 1)
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: 1,
                                    type: "button",
                                    class: "button primary small",
                                    style: {"background":"#3aa9e1","border":"#3aa9e1"},
                                    id: "update-btn",
                                    onClick: $event => (
                        $options.displayMarkAsAvaiableCofirmDialog(
                          obj.slotid,
                          obj.scheduledatetime,
                          obj.talkTimescheduleid
                        )
                      )
                                  }, " Mark as Available ", 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_60))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (obj.islauchsession == 1)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: 2,
                                    type: "button",
                                    class: "button success small",
                                    onClick: $event => ($options.FetchLaunchURL(obj.talkTimescheduleid))
                                  }, " Launch session ", 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_61))
                                : (0,vue_cjs.createCommentVNode)("", true)
                            ]),
                            (0,vue_cjs.createElementVNode)("td", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_62, [
                              (
                        obj.issessioncompleted == 1 &&
                        obj.talkTimescheduleid > 0 &&
                        obj.isMeetingStarted == 1 &&
                        obj.isMeetingCanceled != 1
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_63, " Session Completed "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (
                        obj.isleaveupdated == 1 &&
                        !(
                          obj.issessioncompleted == 1 &&
                          obj.talkTimescheduleid > 0
                        )
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_64, "Marked as Not Available "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              ($options.getSessionNotAllocatedStatus(obj))
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_65, " Session Not Allocated "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (
                        obj.isMeetingStarted == 1 && obj.issessioncompleted != 1
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_66, "In progress "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (
                        obj.isMeetingStarted == 0 &&
                        obj.showMeetingNotStartedMsg == 1 &&
                        obj.isMeetingCanceled != 1
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_67, "Coach did not start the session "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (obj.isMeetingCanceled == 1)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_68, "Auto Cancelled "))
                                : (0,vue_cjs.createCommentVNode)("", true)
                            ])
                          ], 8, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_57))
                        }), 128)),
                        TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_69
                      ]))
                    : (0,vue_cjs.createCommentVNode)("", true)
                ])
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true),
    ($data.shownestedchild == true)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_70, [
          (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_71, [
            (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_72, [
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_73, [
                (0,vue_cjs.createElementVNode)("div", {
                  class: "right-nav close-modal",
                  onClick: _cache[12] || (_cache[12] = $event => ($options.closenestedchild()))
                }, TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_75)
              ]),
              (0,vue_cjs.createElementVNode)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_76, [
                (this.userRole == 1)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", TalkTImeManagementvue_type_template_id_dc4787dc_hoisted_77, [
                      ($data.reassignCoachList.length > 0)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", _hoisted_78, [
                            _hoisted_79,
                            (0,vue_cjs.createElementVNode)("div", _hoisted_80, [
                              (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                                id: "dddlReassignCoach",
                                onChange: _cache[13] || (_cache[13] = $event => ($options.onReassignCoachChange())),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($data.reassignSelectedCoach) = $event)),
                                class: "report-date"
                              }, [
                                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.reassignCoachList, (obj, index) => {
                                  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                                    value: obj,
                                    key: obj.coachid,
                                    id: index,
                                    onClick: $event => (_ctx.selectReassignCoach(index))
                                  }, (0,vue_cjs.toDisplayString)(obj.coachname), 9, _hoisted_81))
                                }), 128))
                              ], 544), [
                                [vue_cjs.vModelSelect, $data.reassignSelectedCoach]
                              ])
                            ])
                          ]))
                        : (0,vue_cjs.createCommentVNode)("", true),
                      ($data.isLoading == false)
                        ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                            key: 1,
                            class: "button primary small",
                            onClick: _cache[15] || (_cache[15] = $event => ($options.ReScheduleModerator()))
                          }, " Update Moderator "))
                        : (0,vue_cjs.createCommentVNode)("", true)
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true),
    ($data.shownestedchildtble == true)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", _hoisted_82, [
          (0,vue_cjs.createElementVNode)("div", _hoisted_83, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_84, [
              (0,vue_cjs.createElementVNode)("div", _hoisted_85, [
                _hoisted_86,
                (0,vue_cjs.createElementVNode)("div", {
                  class: "right-nav close-modal",
                  onClick: _cache[16] || (_cache[16] = $event => ($options.closenestedchildtble()))
                }, _hoisted_88)
              ]),
              (0,vue_cjs.createElementVNode)("div", _hoisted_89, [
                (0,vue_cjs.createElementVNode)("div", _hoisted_90, [
                  ($data.allDayReallocateddetails.length > 0)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", _hoisted_91, [
                        _hoisted_92,
                        ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.allDayReallocateddetails, (obj, index) => {
                          return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                            key: index,
                            id: index
                          }, [
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.coachname), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.coachid), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.scheduledatetime), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeSlot), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.nextusername), 1),
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.nextuserpid), 1)
                          ], 8, _hoisted_93))
                        }), 128)),
                        _hoisted_94
                      ]))
                    : (0,vue_cjs.createCommentVNode)("", true)
                ])
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true),
    (0,vue_cjs.createElementVNode)("div", _hoisted_95, [
      (0,vue_cjs.createElementVNode)("div", _hoisted_96, [
        _hoisted_97,
        (0,vue_cjs.createElementVNode)("div", _hoisted_98, [
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-ok-btn",
            onClick: _cache[17] || (_cache[17] = $event => ($options.confirmDialogMarkAsHoliday()))
          }, " Ok "),
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-cancel-btn",
            onClick: _cache[18] || (_cache[18] = $event => ($options.cancelDialogMarkAsHoliday()))
          }, " Cancel ")
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", _hoisted_99, [
      (0,vue_cjs.createElementVNode)("div", _hoisted_100, [
        _hoisted_101,
        (0,vue_cjs.createElementVNode)("div", _hoisted_102, [
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-ok-btn",
            onClick: _cache[19] || (_cache[19] = $event => ($options.confirmDialogMarkAsNA()))
          }, " Ok "),
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-cancel-btn",
            onClick: _cache[20] || (_cache[20] = $event => ($options.cancelDialogMarkAsNA()))
          }, " Cancel ")
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", _hoisted_103, [
      (0,vue_cjs.createElementVNode)("div", _hoisted_104, [
        _hoisted_105,
        (0,vue_cjs.createElementVNode)("div", _hoisted_106, [
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-ok-btn",
            onClick: _cache[21] || (_cache[21] = $event => ($options.confirmDialogMarkAsAvailable()))
          }, " Ok "),
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-cancel-btn",
            onClick: _cache[22] || (_cache[22] = $event => ($options.cancelDialogMarkAsAvailable()))
          }, " Cancel ")
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", _hoisted_107, [
      (0,vue_cjs.createElementVNode)("div", _hoisted_108, [
        _hoisted_109,
        (0,vue_cjs.createElementVNode)("div", _hoisted_110, [
          (0,vue_cjs.createElementVNode)("button", {
            class: "dialog-ok-btn",
            onClick: _cache[23] || (_cache[23] = $event => ($options.confirmDialogMonthlyView()))
          }, " Ok ")
        ])
      ])
    ]),
    (0,vue_cjs.createElementVNode)("div", _hoisted_111, [
      (0,vue_cjs.createElementVNode)("div", _hoisted_112, [
        (0,vue_cjs.createElementVNode)("div", _hoisted_113, [
          (0,vue_cjs.createElementVNode)("div", _hoisted_114, [
            _hoisted_115,
            (0,vue_cjs.createElementVNode)("div", {
              class: "right-nav close-modal",
              onClick: _cache[24] || (_cache[24] = $event => ($options.confirmDialogMonthlyListedView()))
            }, _hoisted_117)
          ]),
          (0,vue_cjs.createElementVNode)("div", _hoisted_118, [
            (0,vue_cjs.createElementVNode)("div", _hoisted_119, [
              (0,vue_cjs.createElementVNode)("table", _hoisted_120, [
                _hoisted_121,
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.reallocateddetails, (obj, index) => {
                  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                    key: index,
                    id: index
                  }, [
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.notificationMessage), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.coachname), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.coachId), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.scheduleDateTime), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeSlot), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.updatedCoachName), 1),
                    (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.updatedCoachId), 1)
                  ], 8, _hoisted_122))
                }), 128)),
                _hoisted_123
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
;// CONCATENATED MODULE: ./src/Components/TalkTImeManagement.vue?vue&type=template&id=dc4787dc

;// CONCATENATED MODULE: ./node_modules/vuejs3-datepicker/dist/datepicker.esm.js
function datepicker_esm_e(e,a){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(e)))return;var a=[],n=!0,r=!1,i=void 0;try{for(var o,l=e[Symbol.iterator]();!(n=(o=l.next()).done)&&(a.push(o.value),!t||a.length!==t);n=!0);}catch(e){r=!0,i=e}finally{try{n||null==l.return||l.return()}finally{if(r)throw i}}return a}(e,a)||function(e,a){if(!e)return;if("string"==typeof e)return datepicker_esm_t(e,a);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(e);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return datepicker_esm_t(e,a)}(e,a)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function datepicker_esm_t(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,n=new Array(t);a<t;a++)n[a]=e[a];return n}function datepicker_esm_a(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,n)}return a}function datepicker_esm_n(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}function datepicker_esm_r(e){return(datepicker_esm_r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var datepicker_esm_=["click"],datepicker_esm_C=[],datepicker_esm_x={instances:datepicker_esm_C,beforeMount:datepicker_esm_M,update:function(e,t){JSON.stringify(t.value)!==JSON.stringify(t.oldValue)&&datepicker_esm_M(e,t)},unmounted:datepicker_esm_j};function datepicker_esm_M(e,t){var a=t.value;datepicker_esm_j(e);var n=a,i="function"==typeof n,o="object"===datepicker_esm_r(n);if((i||o)&&!(!1===n.isActive)){var l=function(e){var t=e.el,a=e.handler;return{el:t,eventHandlers:datepicker_esm_.map((function(e){return{event:e,handler:function(e){return function(e){var t=e.event,a=e.el,n=e.handler,r=t.path||(t.composedPath?t.composedPath():void 0);if(r?r.indexOf(a)<0:!a.contains(t.target))return n&&n(t,a)}({event:e,el:t,handler:a})}}}))}}({el:e,handler:i?n:n.handler});l.eventHandlers.forEach((function(e){var t=e.event,a=e.handler;return setTimeout((function(){return document.addEventListener(t,a,!1)}),0)})),datepicker_esm_C.push(l)}}function datepicker_esm_j(e){var t=datepicker_esm_C.findIndex((function(t){return t.el===e}));-1!==t&&(datepicker_esm_C[t].eventHandlers.forEach((function(e){var t=e.event,a=e.handler;return document.removeEventListener(t,a,!1)})),datepicker_esm_C.splice(t,1))}var datepicker_esm_V=(0,vue_cjs.defineComponent)({name:"IconView",props:{height:{type:[String,Number],default:"16"},width:{type:[String,Number],default:"16"},color:{type:String,default:"black"}},setup:function(){return{}}});datepicker_esm_V.render=function(e,t,a,n,r,i){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)(vue_cjs.Fragment,null,[(0,vue_cjs.createCommentVNode)(" eslint-disable "),((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",height:e.height,width:e.width,role:"img","aria-hidden":"true","data-icon":"calendarAlt"},[(0,vue_cjs.createVNode)("path",{fill:e.color,d:"M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zM148 320h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 96h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-96 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm192 0h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12z"},null,8,["fill"])],8,["height","width"])),(0,vue_cjs.createCommentVNode)("eslint-enable")],64)},datepicker_esm_V.__file="src/components/iconview/IconView.vue";var datepicker_esm_N=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return t?e.getUTCFullYear():e.getFullYear()},datepicker_esm_T=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return t?e.getUTCMonth():e.getMonth()},datepicker_esm_B=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return t?e.getUTCDate():e.getDate()},datepicker_esm_O=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return t?e.getUTCDay():e.getDay()},datepicker_esm_Y=function(e,t){var a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return a?e.setUTCFullYear(t):e.setFullYear(t)},datepicker_esm_A=function(e,t){var a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return a?e.setUTCMonth(t):e.setMonth(t)},datepicker_esm_F=function(e,t){var a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return a?e.setUTCDate(t):e.setDate(t)},datepicker_esm_H=function(e,t){var a=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=new Date(e.getTime()),r=new Date(t.getTime());return a?(n.setUTCHours(0,0,0,0),r.setUTCHours(0,0,0,0)):(n.setHours(0,0,0,0),r.setHours(0,0,0,0)),n.getTime()===r.getTime()},datepicker_esm_I=function(e,t){if("object"!==datepicker_esm_r(e))throw TypeError("Invalid Type");return t[datepicker_esm_O(e)]},datepicker_esm_P=function(e,t){if(!t)throw Error("missing 2nd parameter Months array");if("object"===datepicker_esm_r(e))return t[datepicker_esm_T(e)];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},datepicker_esm_J=function(e,t){if(!t)throw Error("missing 2nd paramter Months array");if("object"===datepicker_esm_r(e))return t[datepicker_esm_T(e)];if("number"==typeof e)return t[e];throw TypeError("Invalid type")},datepicker_esm_R=function(e){return"string"==typeof e?new Date(e):e},datepicker_esm_U=(0,vue_cjs.defineComponent)({name:"DateInput",components:{IconView:datepicker_esm_V},props:{selectedDate:{type:[Date,String]},resetTypedDate:{type:[Date]},format:{type:[String,Function]},translation:{type:Object},inline:{type:Boolean},id:{type:String},name:{type:String},openDate:{type:Date},placeholder:{type:String},inputClass:{type:String},clearButton:{type:Boolean},clearButtonIcon:{type:String},calendarButton:{type:Boolean},calendarButtonIcon:{type:String},calendarButtonIconContent:{type:String},disabled:{type:Boolean},required:{type:Boolean},typeable:{type:Boolean},addBootstrapClass:{type:Boolean},useUtc:{type:Boolean},minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"},hideInput:{type:Boolean,default:!0},fullMonthName:{type:Boolean,default:!1},iconColor:{default:"black",type:String},iconHeight:{default:16,type:[String,Number]},iconWidth:{default:16,type:[String,Number]},theme:{default:"green",type:String}},emits:["show-calendar","typed-date","clear-date","close-calendar"],setup:function(t,r){var i=r.emit,o=(0,vue_cjs.ref)(),l=(0,vue_cjs.ref)(null),s=(0,vue_cjs.computed)((function(){return t.addBootstrapClass?"string"==typeof t.inputClass?[t.inputClass,"form-control"].join(" "):function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?datepicker_esm_a(Object(r),!0).forEach((function(t){datepicker_esm_n(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):datepicker_esm_a(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({"form-control":!0},t.inputClass):t.inputClass})),d=(0,vue_cjs.computed)((function(){if(!t.selectedDate)return null;if(o.value)return o.value;var a=datepicker_esm_R(t.selectedDate),n="function"==typeof t.format?t.format(a):function(e,t,a){var n=datepicker_esm_N(e),r=datepicker_esm_T(e)+1,i=datepicker_esm_B(e);return t.replace(/dd/,"0".concat(i).slice(-2)).replace(/d/,i).replace(/yyyy/,n).replace(/yy/,String(n).slice(2)).replace(/MMMM/,datepicker_esm_P(datepicker_esm_T(e),a.months)).replace(/MMM/,datepicker_esm_J(datepicker_esm_T(e),a.monthsAbbr)).replace(/MM/,"0".concat(r).slice(-2)).replace(/M(?!a|ä|e)/,r.toString()).replace(/su/,function(e){switch(e){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}}(datepicker_esm_B(e))).replace(/D(?!e|é|i)/,datepicker_esm_I(e,a.days))}(a,t.format,t.translation);if(t.minimumView===t.maximumView){var r=datepicker_esm_e(n.split(" "),3),i=r[1],l=r[2];if("month"===t.maximumView){if(t.fullMonthName){var s,d,c=null===(s=t.translation)||void 0===s?void 0:s.monthsAbbr.indexOf(i);return null===(d=t.translation)||void 0===d?void 0:d.months[c]}n=i}else"year"===t.maximumView&&(n=l)}return n}));return (0,vue_cjs.watch)((function(){return t.resetTypedDate}),(function(){o.value=""})),{typedDate:o,computedInputClass:s,formattedValue:d,showCalendar:function(){i("show-calendar")},parseTypedDate:function(e){if([27,13].includes(e.keyCode)&&l.value.blur(),t.typeable){var a=l.value.value,n=Date.parse(a);Number.isNaN(n)||(o.value=a,i("typed-date",new Date(n)))}},inputBlurred:function(){t.typeable&&Number.isNaN(Date.parse(l.value.value))&&(i("clear-date"),l.value.value=null,o.value=""),i("close-calendar",!0)},inputRef:l}}}),datepicker_esm_z={key:0},datepicker_esm_E={key:1,style:{position:"relative"}},datepicker_esm_W={key:0},datepicker_esm_L={key:0,class:"vuejs3-datepicker__value"},datepicker_esm_$={class:"vuejs3-datepicker__icon"},datepicker_esm_q={key:0,class:"vuejs3-datepicker__content"},datepicker_esm_Q={key:1,class:"vuejs3-datepicker__content"},datepicker_esm_X={key:0};datepicker_esm_U.render=function(e,t,a,n,r,i){var s=(0,vue_cjs.resolveComponent)("IconView");return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{class:[e.addBootstrapClass?"input-group":""]},[(0,vue_cjs.createCommentVNode)(" Calendar Button "),e.calendarButton?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{key:0,class:["vuejs3-datepicker__calendar-button",{"input-group-prepend":e.addBootstrapClass}],onClick:t[1]||(t[1]=function(){return e.showCalendar.apply(e,arguments)}),style:{"cursor:not-allowed;":e.disabled}},[(0,vue_cjs.createVNode)("span",{class:{"input-group-text":e.addBootstrapClass}},[(0,vue_cjs.createVNode)("i",{class:e.calendarButtonIcon},[(0,vue_cjs.createTextVNode)((0,vue_cjs.toDisplayString)(e.calendarButtonIconContent)+" ",1),e.calendarButtonIcon?(0,vue_cjs.createCommentVNode)("v-if",!0):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",datepicker_esm_z,"…"))],2)],2)],6)):(0,vue_cjs.createCommentVNode)("v-if",!0),e.typeable||!e.hideInput?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",datepicker_esm_E,[e.inline?(0,vue_cjs.createCommentVNode)("v-if",!0):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",datepicker_esm_W,[(0,vue_cjs.createVNode)(s,{class:"vuejs3-datepicker__typeablecalendar",color:e.iconColor,width:e.iconWidth,height:e.iconHeight},null,8,["color","width","height"])])),(0,vue_cjs.createVNode)("input",{type:e.inline?"hidden":"text",class:[e.computedInputClass,"vuejs3-datepicker__inputvalue"],name:e.name,ref:"inputRef",id:e.id,value:e.formattedValue,"open-date":e.openDate,placeholder:e.placeholder,"clear-button":e.clearButton,disabled:e.disabled,required:e.required,readonly:!e.typeable,onClick:t[2]||(t[2]=function(){return e.showCalendar.apply(e,arguments)}),onKeyup:t[3]||(t[3]=function(){return e.parseTypedDate.apply(e,arguments)}),onBlur:t[4]||(t[4]=function(){return e.inputBlurred.apply(e,arguments)}),autocomplete:"off"},null,42,["type","name","id","value","open-date","placeholder","clear-button","disabled","required","readonly"])])):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{key:2,onClick:t[5]||(t[5]=function(){return e.showCalendar.apply(e,arguments)}),id:"calendar-div"},[e.inline?(0,vue_cjs.createCommentVNode)("v-if",!0):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",datepicker_esm_L,[(0,vue_cjs.createVNode)("span",datepicker_esm_$,[(0,vue_cjs.createVNode)(s,{color:e.iconColor,width:e.iconWidth,height:e.iconHeight},null,8,["color","width","height"])]),e.formattedValue?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",datepicker_esm_q,(0,vue_cjs.toDisplayString)(e.formattedValue),1)):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",datepicker_esm_Q,(0,vue_cjs.toDisplayString)(e.placeholder),1))]))])),e.clearButton&&e.selectedDate?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{key:3,class:["vuejs3-datepicker__clear-button",{"input-group-append":e.addBootstrapClass}],onClick:t[6]||(t[6]=function(t){return e.clearDate()})},[(0,vue_cjs.createVNode)("span",{class:{"input-group-text":e.addBootstrapClass}},[(0,vue_cjs.createVNode)("i",{class:e.clearButtonIcon},[e.clearButtonIcon?(0,vue_cjs.createCommentVNode)("v-if",!0):((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",datepicker_esm_X,"×"))],2)],2)],2)):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.renderSlot)(e.$slots,"belowDate")],2)},datepicker_esm_U.__file="src/components/datepicker/DateInput.vue";var datepicker_esm_G=(0,vue_cjs.defineComponent)({name:"PickerDay",props:{showDayView:{type:Boolean},selectedDate:{type:[String,Date],default:new Date},pageDate:{type:Date,default:new Date},pageTimestamp:{type:Number},fullMonthName:{type:Boolean},allowedToShowView:{type:Function},dayCellContent:{type:Function,default:function(e){return e.date}},disabledDates:{type:Object},highlighted:{type:Object},calendarClass:{type:[String,Object,Array]},calendarStyle:{type:Object},translation:{type:Object},isRtl:{type:Boolean},mondayFirst:{type:Boolean},useUtc:{type:Boolean},minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"},preventDisableDateSelection:{type:Boolean,default:!0},theme:{default:"green",type:String}},emits:["show-year-calendar","changed-month","show-month-calendar","selected-disabled","select-date"],setup:function(e,t){var a=t.emit;function n(t){var n=e.pageDate;datepicker_esm_A(n,datepicker_esm_T(n)+t),a("changed-month",n)}function r(){var t=e.disabledDates;if(!t||!t.to)return!1;var a=e.pageDate;return datepicker_esm_T(t.to)>=datepicker_esm_T(a)&&datepicker_esm_N(t.to)>=datepicker_esm_N(a)}function i(){var t=e.disabledDates;if(!t||!t.from)return!1;var a=e.pageDate;return datepicker_esm_T(t.from)<=datepicker_esm_T(a)&&datepicker_esm_N(t.from)<=datepicker_esm_N(a)}function o(t){var a=datepicker_esm_R(e.selectedDate);return!!e.selectedDate&&datepicker_esm_H(a,t)}function l(t){var a=!1,n=e.disabledDates;return n?void 0!==n&&(void 0!==n.dates&&n.dates.forEach((function(e){datepicker_esm_H(t,e)&&(a=!0)})),void 0!==n.to&&n.to&&t<n.to&&(a=!0),void 0!==n.from&&n.from&&t>n.from&&(a=!0),void 0!==n.ranges&&n.ranges.forEach((function(e){void 0!==e.from&&e.from&&void 0!==e.to&&e.to&&t<e.to&&t>e.from&&(a=!0)})),void 0!==n.days&&-1!==n.days.indexOf(datepicker_esm_O(t))&&(a=!0),void 0!==n.daysOfMonth&&-1!==n.daysOfMonth.indexOf(datepicker_esm_B(t))&&(a=!0),"function"==typeof n.customPredictor&&n.customPredictor(t)&&(a=!0),a):a}function s(e){return void 0!==e&&e}function d(t){var a=e.highlighted;if((!a||!a.includeDisabled)&&l(t))return!1;var n=!1;return void 0!==a&&(void 0!==a.dates&&a.dates.forEach((function(e){datepicker_esm_H(t,e)&&(n=!0)})),s(a.from)&&s(a.to)&&(n=t>=a.from&&t<=a.to),void 0!==a.days&&-1!==a.days.indexOf(datepicker_esm_O(t))&&(n=!0),void 0!==a.daysOfMonth&&-1!==a.daysOfMonth.indexOf(datepicker_esm_B(t))&&(n=!0),"function"==typeof a.customPredictor&&a.customPredictor(t)&&(n=!0),n)}function c(t){var a=e.highlighted;return!!a&&(d(t)&&a.from instanceof Date&&datepicker_esm_N(a.from)===datepicker_esm_N(t)&&datepicker_esm_T(a.from)===datepicker_esm_T(t)&&datepicker_esm_B(a.from)===datepicker_esm_B(t))}function u(t){var a=e.highlighted;return!!a&&(d(t)&&a.to instanceof Date&&datepicker_esm_N(a.to)===datepicker_esm_N(t)&&datepicker_esm_T(a.to)===datepicker_esm_T(t)&&datepicker_esm_B(a.to)===datepicker_esm_B(t))}var m=(0,vue_cjs.computed)((function(){if(e.mondayFirst){var t=e.translation&&e.translation.days&&e.translation.days.slice();return t.push(t.shift()),t}return e.translation&&e.translation.days})),f=(0,vue_cjs.computed)((function(){var t=e.pageDate,a=e.useUtc?new Date(Date.UTC(t.getUTCFullYear(),t.getUTCMonth(),1)):new Date(t.getFullYear(),t.getMonth(),1,t.getHours(),t.getMinutes());return e.mondayFirst?datepicker_esm_O(a)>0?datepicker_esm_O(a)-1:6:datepicker_esm_O(a)})),h=(0,vue_cjs.computed)((function(){for(var t,a,n=e.pageDate,r=[],i=e.useUtc?new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),1)):new Date(n.getFullYear(),n.getMonth(),1,n.getHours(),n.getMinutes()),s=(t=datepicker_esm_N(i),a=datepicker_esm_T(i),/8|3|5|10/.test(a)?30:1===a?(t%4||!(t%100))&&t%400?28:29:31),p=0;p<s;p+=1)r.push({date:datepicker_esm_B(i),timestamp:i.getTime(),isSelected:o(i),isDisabled:l(i),isHighlighted:d(i),isHighlightStart:c(i),isHighlightEnd:u(i),isToday:datepicker_esm_H(i,new Date),isWeekend:0===datepicker_esm_O(i)||6===datepicker_esm_O(i),isSaturday:6===datepicker_esm_O(i),isSunday:0===datepicker_esm_O(i)}),datepicker_esm_F(i,datepicker_esm_B(i)+1);return r})),y=(0,vue_cjs.computed)((function(){var t=e.fullMonthName?e.translation&&e.translation.months:e.translation&&e.translation.monthsAbbr;return datepicker_esm_J(datepicker_esm_T(e.pageDate),t)})),v=(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.months;return datepicker_esm_P(datepicker_esm_T(e.pageDate),t)})),g=(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.yearSuffix;return"".concat(datepicker_esm_N(e.pageDate)).concat(t)}));return{isDefined:s,showMonthCalendar:function(){a("show-month-calendar")},daysOfWeek:m,blankDays:f,isYmd:(0,vue_cjs.computed)((function(){return!0===(e.translation&&e.translation.ymd&&e.translation&&e.translation.ymd)})),days:h,currMonthName:y,currYearName:g,isLeftNavDisabled:(0,vue_cjs.computed)((function(){return e.isRtl?i():r()})),isRightNavDisabled:(0,vue_cjs.computed)((function(){return e.isRtl?r():i()})),selectDate:function(t){t.isDisabled?(a("selected-disabled",t),e.preventDisableDateSelection||a("select-date",t)):a("select-date",t)},previousMonth:function(){r()||n(-1)},nextMonth:function(){i()||n(1)},dayClasses:function(e){return{selected:e.isSelected,disabled:e.isDisabled,highlighted:e.isHighlighted,today:e.isToday,weekend:e.isWeekend,sat:e.isSaturday,sun:e.isSunday,"highlight-start":e.isHighlightStart,"highlight-end":e.isHighlightEnd}},monthName:v,getDayName:(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_I(t,e.translation&&e.translation.daysNames):null})),getDisplayDate:(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_B(t):null})),showYearCalendar:function(){a("show-year-calendar")},isNextMonthDisabled:i,ifDifferentViews:(0,vue_cjs.computed)((function(){return!(e.minimumView===e.maximumView&&("day"!==e.minimumView||"day"!==e.maximumView))})),isSelectedDate:o,isDisabledDate:l,isHighlightedDate:d,isHighlightStart:c,isHighlightEnd:u}}}),datepicker_esm_K={key:0,class:"vuejs3-datepicker__calendar-topbar"},datepicker_esm_Z={class:"vuejs3-datepicker__calendar-topbar-day"},datepicker_esm_ee={class:"vuejs3-datepicker__calendar-actionarea"};datepicker_esm_G.render=function(e,t,a,n,r,i){return (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{class:["vuejs3-datepicker__calendar","vuejs3-".concat(e.theme),e.calendarClass],style:e.calendarStyle,onMousedown:t[5]||(t[5]=(0,vue_cjs.withModifiers)((function(){}),["prevent"]))},[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader"),e.ifDifferentViews&&e.selectedDate?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("section",datepicker_esm_K,[(0,vue_cjs.createVNode)("p",{class:"vuejs3-datepicker__calendar-topbar-year",onClick:t[1]||(t[1]=function(){return e.showYearCalendar.apply(e,arguments)})},(0,vue_cjs.toDisplayString)(e.currYearName),1),(0,vue_cjs.createVNode)("p",datepicker_esm_Z,(0,vue_cjs.toDisplayString)(e.getDayName)+" "+(0,vue_cjs.toDisplayString)(e.getDisplayDate)+" "+(0,vue_cjs.toDisplayString)(e.monthName),1)])):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.createVNode)("div",datepicker_esm_ee,[(0,vue_cjs.createVNode)("header",null,[(0,vue_cjs.createVNode)("span",{onClick:t[2]||(t[2]=function(t){return e.isRtl?e.nextMonth():e.previousMonth()}),class:["prev",{disabled:e.isLeftNavDisabled}]},"<",2),(0,vue_cjs.createVNode)("span",{class:["day__month_btn",e.allowedToShowView("month")?"up":""],onClick:t[3]||(t[3]=function(){return e.showMonthCalendar.apply(e,arguments)})},(0,vue_cjs.toDisplayString)(e.isYmd?e.currYearName:e.currMonthName)+" "+(0,vue_cjs.toDisplayString)(e.isYmd?e.currMonthName:e.currYearName),3),(0,vue_cjs.createVNode)("span",{onClick:t[4]||(t[4]=function(t){return e.isRtl?e.previousMonth():e.nextMonth()}),class:["next",{disabled:e.isRightNavDisabled}]},">",2)]),(0,vue_cjs.createVNode)("div",{class:e.isRtl?"flex-rtl":""},[((0,vue_cjs.openBlock)(!0),(0,vue_cjs.createBlock)(vue_cjs.Fragment,null,(0,vue_cjs.renderList)(e.daysOfWeek,(function(e){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{class:"cell day-header",key:e.timestamp},(0,vue_cjs.toDisplayString)(e),1)})),128)),e.blankDays>0?((0,vue_cjs.openBlock)(!0),(0,vue_cjs.createBlock)(vue_cjs.Fragment,{key:0},(0,vue_cjs.renderList)(e.blankDays,(function(e){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{class:"cell day blank",key:e.timestamp})})),128)):(0,vue_cjs.createCommentVNode)("v-if",!0),((0,vue_cjs.openBlock)(!0),(0,vue_cjs.createBlock)(vue_cjs.Fragment,null,(0,vue_cjs.renderList)(e.days,(function(t){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{class:["cell day",e.dayClasses(t)],key:t.timestamp,innerHTML:e.dayCellContent(t),onClick:function(a){return e.selectDate(t)}},null,10,["innerHTML","onClick"])})),128))],2)])],38)),[[vue_cjs.vShow,e.showDayView]])},datepicker_esm_G.__file="src/components/datepicker/PickerDay.vue";var datepicker_esm_te=(0,vue_cjs.defineComponent)({name:"PickerMonth",props:{showMonthView:{type:Boolean},selectedDate:{type:[String,Date],default:new Date},pageDate:{type:Date,default:new Date},pageTimestamp:{type:Number},disabledDates:{type:Object},calendarClass:{type:[String,Object,Array]},calendarStyle:{type:Object},translation:{type:Object},isRtl:{type:Boolean},allowedToShowView:{type:Function},useUtc:{type:Boolean},fullMonthName:{type:Boolean},minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"},theme:{default:"green",type:String}},setup:function(e,t){var a=t.emit;function n(t){var n=e.pageDate;datepicker_esm_Y(n,datepicker_esm_N(n)+t),a("changed-year",n)}function r(){var t=e.disabledDates;return!(!t||!t.to)&&datepicker_esm_N(t.to)>=datepicker_esm_N(e.pageDate)}function i(){var t=e.disabledDates;return!(!t||!t.from)&&datepicker_esm_N(t.from)<=datepicker_esm_N(e.pageDate)}function o(t){var a=datepicker_esm_R(e.selectedDate);return a&&datepicker_esm_N(a)===datepicker_esm_N(t)&&datepicker_esm_T(a)===datepicker_esm_T(t)}function l(t){var a=!1,n=e.disabledDates;return!!n&&(void 0!==n&&(void 0!==n.to&&n.to&&(datepicker_esm_T(t)<datepicker_esm_T(n.to)&&datepicker_esm_N(t)<=datepicker_esm_N(n.to)||datepicker_esm_N(t)<datepicker_esm_N(n.to))&&(a=!0),void 0!==n.from&&n.from&&(datepicker_esm_T(t)>datepicker_esm_T(n.from)&&datepicker_esm_N(t)>=datepicker_esm_N(n.from)||datepicker_esm_N(t)>datepicker_esm_N(n.from))&&(a=!0),"function"==typeof n.customPredictor&&n.customPredictor(t)&&(a=!0),a))}var s=(0,vue_cjs.computed)((function(){for(var t=e.pageDate,a=[],n=e.useUtc?new Date(Date.UTC(t.getUTCFullYear(),0,t.getUTCDate())):new Date(t.getFullYear(),0,t.getDate(),t.getHours(),t.getMinutes()),r=0;r<12;r+=1)a.push({month:datepicker_esm_P(r,e.translation&&e.translation.months),timestamp:n.getTime(),isSelected:o(n),isDisabled:l(n)}),datepicker_esm_A(n,datepicker_esm_T(n)+1);return a})),d=(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.yearSuffix;return"".concat(datepicker_esm_N(e.pageDate)).concat(t)})),c=(0,vue_cjs.computed)((function(){return e.isRtl?i():r()})),u=(0,vue_cjs.computed)((function(){return e.isRtl?r():i()})),m=(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.months;return datepicker_esm_P(datepicker_esm_T(e.pageDate),t)})),f=(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_B(t):null})),h=(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_I(t,e.translation&&e.translation.daysNames):null}));return{isRightNavDisabled:u,isLeftNavDisabled:c,pageYearName:d,months:s,selectMonth:function(e){e.isDisabled||a("select-month",e)},previousYear:function(){r()||n(-1)},nextYear:function(){i()||n(1)},currYearName:(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.yearSuffix;return"".concat(datepicker_esm_N(e.pageDate)).concat(t)})),getDisplayDate:f,monthName:m,showYearCalendar:function(){a("show-year-calendar")},getDayName:h,currMonthName:(0,vue_cjs.computed)((function(){var t=e.fullMonthName?e.translation&&e.translation.months:e.translation&&e.translation.monthsAbbr;return datepicker_esm_J(datepicker_esm_T(e.pageDate),t)})),ifDifferentViews:(0,vue_cjs.computed)((function(){return!(e.minimumView===e.maximumView&&("day"!==e.minimumView||"day"!==e.maximumView))})),isSelectedMonth:o,isDisabledMonth:l}}}),datepicker_esm_ae={key:0,class:"vuejs3-datepicker__calendar-topbar"},datepicker_esm_ne={key:0,class:"vuejs3-datepicker__calendar-topbar-day"},datepicker_esm_re={class:"vuejs3-datepicker__calendar-actionarea"};datepicker_esm_te.render=function(e,t,a,n,r,i){return (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{class:["vuejs3-datepicker__calendar","vuejs3-".concat(e.theme),e.calendarClass],style:e.calendarStyle,onMousedown:t[5]||(t[5]=(0,vue_cjs.withModifiers)((function(){}),["prevent"]))},[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader"),e.ifDifferentViews?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("section",datepicker_esm_ae,[(0,vue_cjs.createVNode)("p",{class:"vuejs3-datepicker__calendar-topbar-year",onClick:t[1]||(t[1]=function(){return e.showYearCalendar.apply(e,arguments)})},(0,vue_cjs.toDisplayString)(e.currYearName),1),e.selectedDate?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("p",datepicker_esm_ne,(0,vue_cjs.toDisplayString)(e.getDayName)+" "+(0,vue_cjs.toDisplayString)(e.getDisplayDate)+" "+(0,vue_cjs.toDisplayString)(e.monthName),1)):(0,vue_cjs.createCommentVNode)("v-if",!0)])):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.createVNode)("div",datepicker_esm_re,[(0,vue_cjs.createVNode)("header",null,[(0,vue_cjs.createVNode)("span",{onClick:t[2]||(t[2]=function(t){return e.isRtl?e.nextYear():e.previousYear()}),class:["prev",{disabled:e.isLeftNavDisabled}]},"<",2),(0,vue_cjs.createVNode)("span",{class:["month__year_btn",e.allowedToShowView("year")?"up":""],onClick:t[3]||(t[3]=function(){return e.showYearCalendar.apply(e,arguments)})},(0,vue_cjs.toDisplayString)(e.pageYearName),3),(0,vue_cjs.createVNode)("span",{onClick:t[4]||(t[4]=function(t){return e.isRtl?e.previousYear():e.nextYear()}),class:["next",{disabled:e.isRightNavDisabled}]},">",2)]),((0,vue_cjs.openBlock)(!0),(0,vue_cjs.createBlock)(vue_cjs.Fragment,null,(0,vue_cjs.renderList)(e.months,(function(t){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{class:["cell month",{selected:t.isSelected,disabled:t.isDisabled}],key:t.timestamp,onClick:(0,vue_cjs.withModifiers)((function(a){return e.selectMonth(t)}),["stop"])},(0,vue_cjs.toDisplayString)(t.month),11,["onClick"])})),128))])],38)),[[vue_cjs.vShow,e.showMonthView]])},datepicker_esm_te.__file="src/components/datepicker/PickerMonth.vue";var datepicker_esm_ie=(0,vue_cjs.defineComponent)({name:"PickerYear",props:{showYearView:{type:Boolean},selectedDate:{type:[String,Date],default:new Date},pageDate:{type:Date,default:new Date},pageTimestamp:{type:Number},disabledDates:{type:Object},highlighted:{type:Object},calendarClass:{type:[String,Object,Array]},calendarStyle:{type:Object},translation:{type:Object},isRtl:{type:Boolean},allowedToShowView:{type:Function},useUtc:{type:Boolean},fullMonthName:{type:Boolean},minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"},theme:{default:"green",type:String}},emits:["select-year","changed-decade"],setup:function(e,t){var a=t.emit;function n(t){var n=e.pageDate;datepicker_esm_Y(n,datepicker_esm_N(n)+t),a("changed-decade",n)}function r(){var t=e.disabledDates;return!(!t||!t.to)&&datepicker_esm_N(t.to)>10*Math.floor(datepicker_esm_N(e.pageDate)/10)-1}function i(){var t=e.disabledDates;return!(!t||!t.from)&&datepicker_esm_N(t.from)<=10*Math.ceil(datepicker_esm_N(e.pageDate)/10)}function o(t){var a=!1;return!(void 0===e.disabledDates||!e.disabledDates)&&(void 0!==e.disabledDates.to&&e.disabledDates.to&&datepicker_esm_N(t)<datepicker_esm_N(e.disabledDates.to)&&(a=!0),void 0!==e.disabledDates.from&&e.disabledDates.from&&datepicker_esm_N(t)>datepicker_esm_N(e.disabledDates.from)&&(a=!0),"function"==typeof e.disabledDates.customPredictor&&(a=e.disabledDates.customPredictor(t)),a)}var l=(0,vue_cjs.computed)((function(){for(var t,a,n=e.pageDate,r=[],i=e.useUtc?new Date(Date.UTC(10*Math.floor(n.getUTCFullYear()/10),n.getUTCMonth(),n.getUTCDate())):new Date(10*Math.floor(n.getFullYear()/10),n.getMonth(),n.getDate(),n.getHours(),n.getMinutes()),l=0;l<10;l+=1)r.push({year:datepicker_esm_N(i),timestamp:i.getTime(),isSelected:(t=i,a=void 0,a=datepicker_esm_R(e.selectedDate),!!e.selectedDate&&datepicker_esm_N(a)===datepicker_esm_N(t)),isDisabled:o(i)}),datepicker_esm_Y(i,datepicker_esm_N(i)+1);return r})),s=(0,vue_cjs.computed)((function(){var t=10*Math.floor(datepicker_esm_N(e.pageDate)/10),a=t+9,n=e.translation&&e.translation.yearSuffix;return"".concat(t," - ").concat(a).concat(n)})),d=(0,vue_cjs.computed)((function(){return e.isRtl?i():r()}));return{isRightNavDisabled:(0,vue_cjs.computed)((function(){return e.isRtl?r():i()})),isLeftNavDisabled:d,getPageDecade:s,years:l,nextDecade:function(){i()||n(10)},previousDecade:function(){r()||n(-10)},selectYear:function(e){e.isDisabled||a("select-year",e)},getDayName:(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_I(t,e.translation&&e.translation.daysNames):null})),monthName:(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.months;return datepicker_esm_P(datepicker_esm_T(e.pageDate),t)})),getDisplayDate:(0,vue_cjs.computed)((function(){var t=datepicker_esm_R(e.selectedDate);return e.selectedDate?datepicker_esm_B(t):null})),currYearName:(0,vue_cjs.computed)((function(){var t=e.translation&&e.translation.yearSuffix;return"".concat(datepicker_esm_N(e.pageDate)).concat(t)})),currMonthName:(0,vue_cjs.computed)((function(){var t=e.fullMonthName?e.translation&&e.translation.months:e.translation&&e.translation.monthsAbbr;return datepicker_esm_J(datepicker_esm_T(e.pageDate),t)})),ifDifferentViews:(0,vue_cjs.computed)((function(){return!(e.minimumView===e.maximumView&&("day"!==e.minimumView||"day"!==e.maximumView))})),isNextDecadeDisabled:i,isPreviousDecadeDisabled:r,isDisabledYear:o}}}),datepicker_esm_oe={key:0,class:"vuejs3-datepicker__calendar-topbar"},datepicker_esm_le={class:"vuejs3-datepicker__calendar-topbar-year"},datepicker_esm_se={key:0,class:"vuejs3-datepicker__calendar-topbar-day"},datepicker_esm_de={class:"vuejs3-datepicker__calendar-actionarea"};datepicker_esm_ie.render=function(e,t,a,n,r,i){return (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{class:["vuejs3-datepicker__calendar","vuejs3-".concat(e.theme),e.calendarClass],style:e.calendarStyle,onMousedown:t[3]||(t[3]=(0,vue_cjs.withModifiers)((function(){}),["prevent"]))},[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader"),e.ifDifferentViews&&e.selectedDate?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("section",datepicker_esm_oe,[(0,vue_cjs.createVNode)("p",datepicker_esm_le,(0,vue_cjs.toDisplayString)(e.currYearName),1),e.selectedDate?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("p",datepicker_esm_se,(0,vue_cjs.toDisplayString)(e.getDayName)+" "+(0,vue_cjs.toDisplayString)(e.getDisplayDate)+" "+(0,vue_cjs.toDisplayString)(e.monthName),1)):(0,vue_cjs.createCommentVNode)("v-if",!0)])):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.createVNode)("div",datepicker_esm_de,[(0,vue_cjs.createVNode)("header",null,[(0,vue_cjs.createVNode)("span",{onClick:t[1]||(t[1]=function(t){return e.isRtl?e.nextDecade():e.previousDecade()}),class:["prev",{disabled:e.isLeftNavDisabled}]},"<",2),(0,vue_cjs.createVNode)("span",null,(0,vue_cjs.toDisplayString)(e.getPageDecade),1),(0,vue_cjs.createVNode)("span",{onClick:t[2]||(t[2]=function(t){return e.isRtl?e.previousDecade():e.nextDecade()}),class:["next",{disabled:e.isRightNavDisabled}]},">",2)]),((0,vue_cjs.openBlock)(!0),(0,vue_cjs.createBlock)(vue_cjs.Fragment,null,(0,vue_cjs.renderList)(e.years,(function(t){return (0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("span",{class:["cell year",{selected:t.isSelected,disabled:t.isDisabled}],key:t.timestamp,onClick:(0,vue_cjs.withModifiers)((function(a){return e.selectYear(t)}),["stop"])},(0,vue_cjs.toDisplayString)(t.year),11,["onClick"])})),128))])],38)),[[vue_cjs.vShow,e.showYearView]])},datepicker_esm_ie.__file="src/components/datepicker/PickerYear.vue";var datepicker_esm_ce,datepicker_esm_ue,datepicker_esm_pe={af:(datepicker_esm_ce="Afrikaans",datepicker_esm_ue=["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."],{months:["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],monthsAbbr:["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],days:datepicker_esm_ue,yearSuffix:"",ymd:!1,rtl:!1,language:datepicker_esm_ce,langName:datepicker_esm_ce,daysNames:datepicker_esm_ue}),hi:function(){var e="Hindi";return{months:["जनवरी","फ़रवरी","मार्च","अप्रैल","मई","जून","जुलाई","अगस्त","सितंबर","अक्टूबर","नवंबर","दिसंबर"],monthsAbbr:["जन","फ़र","मार्च","अप्रै","मई","जून","जुला","अगस्त","सितं","अक्टू","नवं","दिसं"],days:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"]}}(),ja:function(){var e="Japanese";return{months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthsAbbr:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],days:["日","月","火","水","木","金","土"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"]}}(),de:function(){var e="German";return{months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthsAbbr:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],days:["So","Mo","Di","Mi","Do","Fr","Sa"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"]}}(),en:function(){var e="English";return{months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsAbbr:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],days:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]}}(),fr:function(){var e="Français";return{months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],monthsAbbr:["Jan","Fév","Mar","Avr","Mai","Jui","Juil","Aoû","Sep","Oct","Nov","Déc"],days:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"]}}(),nl:function(){var e="Dutch",t=["zo.","ma.","di.","wo.","do.","vr.","za."];return{months:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthsAbbr:["jan.","feb.","mrt.","apr.","mei","juni","juli","aug.","sep.","okt.","nov.","dec."],days:t,yearSuffix:"",ymd:!1,rtl:!1,langName:e,language:e,daysNames:t}}(),pt:function(){var e="Português";return{months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthsAbbr:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],days:["Dom","Seg","Ter","Qua","Qui","Sex","Sab"],language:e,yearSuffix:"",ymd:!1,rtl:!1,langName:e,daysNames:["Domingo","Segunda-Feira","Terça-Feira","Quarta-Feira","Quinta-Feira","Sexta-Feira","Sábado"]}}()},datepicker_esm_me=(0,vue_cjs.defineComponent)({name:"Datepicker",components:{DateInput:datepicker_esm_U,PickerDay:datepicker_esm_G,PickerMonth:datepicker_esm_te,PickerYear:datepicker_esm_ie},directives:{clickoutside:datepicker_esm_x},props:{modelValue:{type:[Date,String,Number]},value:{type:[Date,String,Number]},format:{type:[String,Function],default:"dd MMM yyyy"},language:{type:String,default:"en"},openDate:{validator:function(e){return function(e){return null===e||e instanceof Date||"string"==typeof e||"number"==typeof e}(e)},type:Date,default:new Date},minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"},name:{type:String},id:{type:String},dayCellContent:{type:Function},fullMonthName:{type:Boolean},disabledDates:{type:Object},highlighted:{type:Object},placeholder:{type:String},inline:{type:Boolean},calendarClass:{type:[String,Object,Array]},inputClass:{type:[String,Object,Array]},wrapperClass:{type:[String,Object,Array]},mondayFirst:{type:Boolean},clearButton:{type:Boolean},clearButtonIcon:{type:String},calendarButton:{type:Boolean},calendarButtonIcon:{type:String},calendarButtonIconContent:{type:String},addBootstrapClass:{type:Boolean},initialView:{type:String},disabled:{type:Boolean},required:{type:Boolean},typeable:{type:Boolean},useUtc:{type:Boolean},hideInput:{type:Boolean,default:!0},preventDisableDateSelection:{type:Boolean,default:!0},iconColor:{default:"black",type:String},iconHeight:{default:16,type:[String,Number]},iconWidth:{default:16,type:[String,Number]},theme:{default:"green",type:String}},emits:["input","cleared","update:modelValue","closed","changed-month","changed-year","changed-day","selected","selected-disabled"],setup:function(e,t){var a,n=t.emit,r=new Date(e.modelValue),i=(0,vue_cjs.ref)(0),o=(0,vue_cjs.ref)(null);e.modelValue&&(a=r,"[object Date]"===Object.prototype.toString.call(a)&&!Number.isNaN(a.getTime()))&&(i.value=r.getTime(),o.value=r),e.openDate&&(i.value=datepicker_esm_F(new Date(e.openDate),1));var l=(0,vue_cjs.ref)(!1),s=(0,vue_cjs.ref)(!1),d=(0,vue_cjs.ref)(!1),c=(0,vue_cjs.ref)(0),f=(0,vue_cjs.ref)(new Date),h=(0,vue_cjs.computed)((function(){return e.initialView?e.initialView:e.minimumView})),y=(0,vue_cjs.computed)((function(){return new Date(i.value)})),v=(0,vue_cjs.computed)((function(){return datepicker_esm_pe[e.language]})),g=(0,vue_cjs.computed)((function(){return!!e.inline})),b=(0,vue_cjs.computed)((function(){return{position:g.value?"static":void 0}})),D=(0,vue_cjs.computed)((function(){return l.value||s.value||d.value})),w=(0,vue_cjs.computed)((function(){return v.value&&!0===v.value.rtl}));function k(t){t||(t=e.openDate?new Date(e.openDate):new Date),i.value=datepicker_esm_F(new Date(t),1)}function S(t){var a=["day","month","year"],n=a.indexOf(e.minimumView),r=a.indexOf(e.maximumView),i=a.indexOf(t);return i>=n&&i<=r}function _(e){l.value=!1,s.value=!1,d.value=!1,g.value||e&&n("closed")}function C(){return!!S("day")&&(_(),l.value=!0,!0)}function x(){return!!S("month")&&(_(),s.value=!0,!0)}function M(){return!!S("year")&&(_(),d.value=!0,!0)}function j(){var t=h.value;if(!S(t))throw new Error("initialView '".concat(t,"' cannot be rendered based on minimum '").concat(e.minimumView,"' and maximum '").concat(e.maximumView,"'"));switch(t){case"year":M();break;case"month":x();break;default:C()}}function V(t){var a=new Date(t);o.value=a,k(a),n("selected",a),e.modelValue?n("update:modelValue",a):n("input",a)}function N(e){V(e.timestamp),g.value||_(!0),f.value=new Date}function T(e){var t=e;if("string"==typeof e||"number"==typeof e){var a=new Date(e);t=Number.isNaN(a.valueOf())?"":a}if(!t)return k(),void(o.value=null);o.value=t,k(e)}return (0,vue_cjs.watch)((function(){return e.modelValue}),(function(e){T(e)})),(0,vue_cjs.watch)((function(){return e.value}),(function(e){T(e)})),(0,vue_cjs.watch)((function(){return e.openDate}),(function(){k()})),(0,vue_cjs.watch)((function(){return e.initialView}),(function(){j()})),e.value&&T(e.value),g.value&&j(),{pageTimestamp:i,selectedDate:o,showDayView:l,showMonthView:s,showYearView:d,calendarHeight:c,resetTypedDate:f,pageDate:y,translation:v,calendarStyle:b,isOpen:D,isInline:g,isRtl:w,setTypedDate:function(e){V(e.getTime())},handleChangedMonthFromDayPicker:function(e){k(e),n("changed-month",e)},selectYear:function(e){var t=new Date(e.timestamp);S("month")?(k(t),x()):N(e),n("changed-year",e)},selectMonth:function(e){var t=new Date(e.timestamp);S("day")?(k(t),C()):N(e),n("changed-month",e)},selectDisabledDate:function(e){n("selected-disabled",e)},clearDate:function(){o.value=null,k(),n("selected",null),e.modelValue?n("update:modelValue",null):n("input",null),n("cleared")},showCalendar:function(){return!e.disabled&&!g.value&&(D.value?_(!0):(j(),!0))},close:_,allowedToShowView:S,showYearCalendar:M,showMonthCalendar:x,setPageDate:k,selectDate:N,closeOnClickOutside:function(){_()},showDayCalendar:C,computedInitialView:h,setDate:datepicker_esm_F,setDate1:V,setValue:T}}});!function(e,t){void 0===t&&(t={});var a=t.insertAt;if(e&&"undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],r=document.createElement("style");r.type="text/css","top"===a&&n.firstChild?n.insertBefore(r,n.firstChild):n.appendChild(r),r.styleSheet?r.styleSheet.cssText=e:r.appendChild(document.createTextNode(e))}}('.rtl{direction:rtl}.vuejs3-datepicker{position:relative;display:inline-block}.vuejs3-datepicker *{box-sizing:border-box}.vuejs3-datepicker input{border:1px solid}.vuejs3-datepicker__icon{display:-webkit-flex;display:-ms-flexbox;display:flex}.vuejs3-datepicker__value{min-width:200px;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;border-radius:5px;padding:13px 15px;cursor:pointer;border:1px solid}.vuejs3-datepicker__content{margin-left:10px;font-size:15px}.vuejs3-datepicker__typeablecalendar{position:absolute;top:10px;left:10px}.vuejs3-datepicker__inputvalue{min-width:200px;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;border-radius:5px;padding:12px 10px 13px 35px;cursor:pointer;border:1px solid}.vuejs3-datepicker__calendar{position:absolute;z-index:100;background:#fff;width:300px;box-shadow:0 .2rem 1rem rgba(0,0,0,.12);border-radius:4px;margin-top:4px}.vuejs3-datepicker__calendar-topbar{background-color:#40b983;color:#fff;border-radius:4px 4px 0 0;padding:25px}.vuejs3-datepicker__calendar-topbar-year{font-size:30px;margin:0;padding-bottom:10px}.vuejs3-datepicker__calendar-topbar-day{font-size:20px;margin:0}.vuejs3-datepicker__calendar-actionarea{padding:10px}.vuejs3-datepicker__calendar header{display:block;line-height:40px}.vuejs3-datepicker__calendar header span{text-align:center;width:71.42857142857143%;float:left}.vuejs3-datepicker__calendar header .next,.vuejs3-datepicker__calendar header .prev{width:14.285714285714286%;float:left;text-indent:-10000px;position:relative}.vuejs3-datepicker__calendar header .next:after,.vuejs3-datepicker__calendar header .prev:after{content:"";position:absolute;left:50%;width:8px;height:8px;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg)}.vuejs3-datepicker__calendar header .prev:after{border-left:1px solid #2f2f2f;border-bottom:1px solid #2f2f2f}.vuejs3-datepicker__calendar header .next.disabled:after,.vuejs3-datepicker__calendar header .prev.disabled:after{opacity:.5}.vuejs3-datepicker__calendar header .next:after{border-top:1px solid #2f2f2f;border-right:1px solid #2f2f2f}.vuejs3-datepicker__calendar header .next:not(.disabled),.vuejs3-datepicker__calendar header .prev:not(.disabled),.vuejs3-datepicker__calendar header .up:not(.disabled){cursor:pointer;font-size:15px;border-radius:4px}.vuejs3-datepicker__calendar header .next:not(.disabled):hover,.vuejs3-datepicker__calendar header .prev:not(.disabled):hover,.vuejs3-datepicker__calendar header .up:not(.disabled):hover{background:#f8f8f8}.vuejs3-datepicker__calendar .disabled{color:#ddd;cursor:default}.vuejs3-datepicker__calendar .flex-rtl{display:-webkit-flex;display:-ms-flexbox;display:flex;width:inherit;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.vuejs3-datepicker__calendar .cell{display:inline-block;padding:0 5px;width:14.285714285714286%;height:40px;line-height:40px;text-align:center;font-size:14px;vertical-align:middle;border:1px solid transparent}.vuejs3-datepicker__calendar .cell.month,.vuejs3-datepicker__calendar .cell.year{padding:10px 5px;height:50px;line-height:28px}.vuejs3-datepicker__calendar .cell.day-header{text-transform:uppercase}.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).day,.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).month,.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).year{cursor:pointer;transition:.45s}.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,.vuejs3-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{border:1px solid #40b983}.vuejs3-datepicker__calendar .cell.selected{background:#40b983;color:#fff}.vuejs3-datepicker__calendar .cell.selected:hover{background:#40b983}.vuejs3-datepicker__calendar .cell.highlighted{background:#40b983;color:#fff}.vuejs3-datepicker__calendar .cell.highlighted.selected{background:#40b983}.vuejs3-datepicker__calendar .cell.highlighted.disabled{color:#a3a3a3}.vuejs3-datepicker__calendar .cell.highlighted.highlight-start,.vuejs3-datepicker__calendar .cell.highlighted:last-child{background:#2f9668}.vuejs3-datepicker__calendar .cell.grey{color:#888}.vuejs3-datepicker__calendar .cell.grey:hover{background:inherit}.vuejs3-datepicker__calendar .cell.day-header{font-size:75%;white-space:nowrap;cursor:inherit}.vuejs3-datepicker__calendar .cell.day-header:hover{background:inherit}.vuejs3-datepicker__calendar .month,.vuejs3-datepicker__calendar .year{width:33.333%}.vuejs3-datepicker__calendar-button,.vuejs3-datepicker__clear-button{cursor:pointer;font-style:normal}.vuejs3-datepicker__calendar-button.disabled,.vuejs3-datepicker__clear-button.disabled{color:#999;cursor:default}.vuejs3-datepicker #calendar-div{background-color:#fff;border-radius:5px}.dp-error{color:red;font-size:12px}.backdrop{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:2;cursor:pointer}'),datepicker_esm_me.render=function(e,t,a,n,r,i){var s=(0,vue_cjs.resolveComponent)("date-input"),u=(0,vue_cjs.resolveComponent)("picker-day"),p=(0,vue_cjs.resolveComponent)("picker-month"),m=(0,vue_cjs.resolveComponent)("picker-year"),h=(0,vue_cjs.resolveDirective)("clickoutside");return (0,vue_cjs.withDirectives)(((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)("div",{class:["vuejs3-datepicker",[e.isRtl?"rtl":"","vuejs3-".concat(e.theme),e.wrapperClass]]},[(0,vue_cjs.createVNode)(s,{selectedDate:e.selectedDate,resetTypedDate:e.resetTypedDate,format:e.format,translation:e.translation,inline:e.inline,id:e.id,name:e.name,fullMonthName:e.fullMonthName,openDate:e.openDate,placeholder:e.placeholder,inputClass:e.inputClass,typeable:e.typeable,clearButton:e.clearButton,clearButtonIcon:e.clearButtonIcon,calendarButton:e.calendarButton,calendarButtonIcon:e.calendarButtonIcon,calendarButtonIconContent:e.calendarButtonIconContent,disabled:e.disabled,required:e.required,addBootstrapClass:e.addBootstrapClass,"use-utc":e.useUtc,onShowCalendar:e.showCalendar,onCloseCalendar:e.close,onTypedDate:e.setTypedDate,onClearDate:e.clearDate,minimumView:e.minimumView,maximumView:e.maximumView,hideInput:e.hideInput,iconWidth:e.iconWidth,iconHeight:e.iconHeight,iconColor:e.iconColor,theme:e.theme},{belowDate:(0,vue_cjs.withCtx)((function(){return[(0,vue_cjs.renderSlot)(e.$slots,"belowDate")]})),_:1},8,["selectedDate","resetTypedDate","format","translation","inline","id","name","fullMonthName","openDate","placeholder","inputClass","typeable","clearButton","clearButtonIcon","calendarButton","calendarButtonIcon","calendarButtonIconContent","disabled","required","addBootstrapClass","use-utc","onShowCalendar","onCloseCalendar","onTypedDate","onClearDate","minimumView","maximumView","hideInput","iconWidth","iconHeight","iconColor","theme"]),(0,vue_cjs.createCommentVNode)("Day View  "),e.allowedToShowView("day")?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)(u,{key:0,pageDate:e.pageDate,selectedDate:e.selectedDate,showDayView:e.showDayView,fullMonthName:e.fullMonthName,allowedToShowView:e.allowedToShowView,disabledDates:e.disabledDates,highlighted:e.highlighted,calendarClass:e.calendarClass,calendarStyle:e.calendarStyle,translation:e.translation,pageTimestamp:e.pageTimestamp,isRtl:e.isRtl,mondayFirst:e.mondayFirst,dayCellContent:e.dayCellContent,onChangedMonth:e.handleChangedMonthFromDayPicker,onSelectDate:e.selectDate,onShowMonthCalendar:e.showMonthCalendar,onSelectedDisabled:e.selectDisabledDate,onShowYearCalendar:e.showYearCalendar,minimumView:e.minimumView,maximumView:e.maximumView,preventDisableDateSelection:e.preventDisableDateSelection,theme:e.theme},{customCalendarHeader:(0,vue_cjs.withCtx)((function(){return[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader")]})),_:1},8,["pageDate","selectedDate","showDayView","fullMonthName","allowedToShowView","disabledDates","highlighted","calendarClass","calendarStyle","translation","pageTimestamp","isRtl","mondayFirst","dayCellContent","onChangedMonth","onSelectDate","onShowMonthCalendar","onSelectedDisabled","onShowYearCalendar","minimumView","maximumView","preventDisableDateSelection","theme"])):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.createCommentVNode)("Month View "),e.allowedToShowView("month")?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)(p,{key:1,pageDate:e.pageDate,selectedDate:e.selectedDate,showMonthView:e.showMonthView,allowedToShowView:e.allowedToShowView,disabledDates:e.disabledDates,calendarClass:e.calendarClass,calendarStyle:e.calendarStyle,translation:e.translation,isRtl:e.isRtl,"use-utc":e.useUtc,fullMonthName:e.fullMonthName,onSelectMonth:e.selectMonth,onShowYearCalendar:e.showYearCalendar,onChangedYear:e.setPageDate,minimumView:e.minimumView,maximumView:e.maximumView,theme:e.theme},{customCalendarHeader:(0,vue_cjs.withCtx)((function(){return[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader")]})),_:1},8,["pageDate","selectedDate","showMonthView","allowedToShowView","disabledDates","calendarClass","calendarStyle","translation","isRtl","use-utc","fullMonthName","onSelectMonth","onShowYearCalendar","onChangedYear","minimumView","maximumView","theme"])):(0,vue_cjs.createCommentVNode)("v-if",!0),(0,vue_cjs.createCommentVNode)(" Year View "),e.allowedToShowView("year")?((0,vue_cjs.openBlock)(),(0,vue_cjs.createBlock)(m,{key:2,pageDate:e.pageDate,selectedDate:e.selectedDate,showYearView:e.showYearView,allowedToShowView:e.allowedToShowView,disabledDates:e.disabledDates,calendarClass:e.calendarClass,calendarStyle:e.calendarStyle,translation:e.translation,isRtl:e.isRtl,"use-utc":e.useUtc,onSelectYear:e.selectYear,onChangedDecade:e.setPageDate,fullMonthName:e.fullMonthName,minimumView:e.minimumView,maximumView:e.maximumView,theme:e.theme},{customCalendarHeader:(0,vue_cjs.withCtx)((function(){return[(0,vue_cjs.renderSlot)(e.$slots,"customCalendarHeader")]})),_:1},8,["pageDate","selectedDate","showYearView","allowedToShowView","disabledDates","calendarClass","calendarStyle","translation","isRtl","use-utc","onSelectYear","onChangedDecade","fullMonthName","minimumView","maximumView","theme"])):(0,vue_cjs.createCommentVNode)("v-if",!0)],2)),[[h,{handler:e.inline?null:e.closeOnClickOutside}]])},datepicker_esm_me.__file="src/components/datepicker/Datepicker.vue";/* harmony default export */ const datepicker_esm = (datepicker_esm_me);

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/core/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_es6_extendStatics = function(d, b) {
    tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_es6_extendStatics(d, b);
};

function tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_tslib_es6_assign = function() {
    tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_es6_createBinding(o, m, p);
}

function tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_es6_await(v) {
    return this instanceof tslib_es6_await ? (this.v = v, this) : new tslib_es6_await(v);
}

function tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_es6_values === "function" ? tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_es6_createBinding(result, mod, k);
    tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/preact/dist/preact.module.js
var preact_module_n,preact_module_l,preact_module_u,preact_module_i,preact_module_t,preact_module_o,preact_module_r,preact_module_f,preact_module_e={},preact_module_c=[],preact_module_s=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function preact_module_a(n,l){for(var u in l)n[u]=l[u];return n}function preact_module_h(n){var l=n.parentNode;l&&l.removeChild(n)}function preact_module_v(l,u,i){var t,o,r,f={};for(r in u)"key"==r?t=u[r]:"ref"==r?o=u[r]:f[r]=u[r];if(arguments.length>2&&(f.children=arguments.length>3?preact_module_n.call(arguments,2):i),"function"==typeof l&&null!=l.defaultProps)for(r in l.defaultProps)void 0===f[r]&&(f[r]=l.defaultProps[r]);return preact_module_y(l,f,t,o,null)}function preact_module_y(n,i,t,o,r){var f={type:n,props:i,key:t,ref:o,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==r?++preact_module_u:r};return null==r&&null!=preact_module_l.vnode&&preact_module_l.vnode(f),f}function preact_module_p(){return{current:null}}function preact_module_d(n){return n.children}function preact_module_(n,l){this.props=n,this.context=l}function preact_module_k(n,l){if(null==l)return n.__?preact_module_k(n.__,n.__.__k.indexOf(n)+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return"function"==typeof n.type?preact_module_k(n):null}function preact_module_b(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return preact_module_b(n)}}function preact_module_m(n){(!n.__d&&(n.__d=!0)&&preact_module_t.push(n)&&!preact_module_g.__r++||preact_module_r!==preact_module_l.debounceRendering)&&((preact_module_r=preact_module_l.debounceRendering)||preact_module_o)(preact_module_g)}function preact_module_g(){for(var n;preact_module_g.__r=preact_module_t.length;)n=preact_module_t.sort(function(n,l){return n.__v.__b-l.__v.__b}),preact_module_t=[],n.some(function(n){var l,u,i,t,o,r;n.__d&&(o=(t=(l=n).__v).__e,(r=l.__P)&&(u=[],(i=preact_module_a({},t)).__v=t.__v+1,preact_module_j(r,t,i,l.__n,void 0!==r.ownerSVGElement,null!=t.__h?[o]:null,u,null==o?preact_module_k(t):o,t.__h),preact_module_z(u,t),t.__e!=o&&preact_module_b(t)))})}function preact_module_w(n,l,u,i,t,o,r,f,s,a){var h,v,p,_,b,m,g,w=i&&i.__k||preact_module_c,A=w.length;for(u.__k=[],h=0;h<l.length;h++)if(null!=(_=u.__k[h]=null==(_=l[h])||"boolean"==typeof _?null:"string"==typeof _||"number"==typeof _||"bigint"==typeof _?preact_module_y(null,_,null,null,_):Array.isArray(_)?preact_module_y(preact_module_d,{children:_},null,null,null):_.__b>0?preact_module_y(_.type,_.props,_.key,null,_.__v):_)){if(_.__=u,_.__b=u.__b+1,null===(p=w[h])||p&&_.key==p.key&&_.type===p.type)w[h]=void 0;else for(v=0;v<A;v++){if((p=w[v])&&_.key==p.key&&_.type===p.type){w[v]=void 0;break}p=null}preact_module_j(n,_,p=p||preact_module_e,t,o,r,f,s,a),b=_.__e,(v=_.ref)&&p.ref!=v&&(g||(g=[]),p.ref&&g.push(p.ref,null,_),g.push(v,_.__c||b,_)),null!=b?(null==m&&(m=b),"function"==typeof _.type&&_.__k===p.__k?_.__d=s=preact_module_x(_,s,n):s=preact_module_P(n,_,p,w,b,s),"function"==typeof u.type&&(u.__d=s)):s&&p.__e==s&&s.parentNode!=n&&(s=preact_module_k(p))}for(u.__e=m,h=A;h--;)null!=w[h]&&("function"==typeof u.type&&null!=w[h].__e&&w[h].__e==u.__d&&(u.__d=preact_module_k(i,h+1)),preact_module_N(w[h],w[h]));if(g)for(h=0;h<g.length;h++)preact_module_M(g[h],g[++h],g[++h])}function preact_module_x(n,l,u){for(var i,t=n.__k,o=0;t&&o<t.length;o++)(i=t[o])&&(i.__=n,l="function"==typeof i.type?preact_module_x(i,l,u):preact_module_P(u,i,i,t,i.__e,l));return l}function preact_module_A(n,l){return l=l||[],null==n||"boolean"==typeof n||(Array.isArray(n)?n.some(function(n){preact_module_A(n,l)}):l.push(n)),l}function preact_module_P(n,l,u,i,t,o){var r,f,e;if(void 0!==l.__d)r=l.__d,l.__d=void 0;else if(null==u||t!=o||null==t.parentNode)n:if(null==o||o.parentNode!==n)n.appendChild(t),r=null;else{for(f=o,e=0;(f=f.nextSibling)&&e<i.length;e+=2)if(f==t)break n;n.insertBefore(t,o),r=o}return void 0!==r?r:t.nextSibling}function preact_module_C(n,l,u,i,t){var o;for(o in u)"children"===o||"key"===o||o in l||preact_module_H(n,o,null,u[o],i);for(o in l)t&&"function"!=typeof l[o]||"children"===o||"key"===o||"value"===o||"checked"===o||u[o]===l[o]||preact_module_H(n,o,l[o],u[o],i)}function preact_module_$(n,l,u){"-"===l[0]?n.setProperty(l,u):n[l]=null==u?"":"number"!=typeof u||preact_module_s.test(l)?u:u+"px"}function preact_module_H(n,l,u,i,t){var o;n:if("style"===l)if("string"==typeof u)n.style.cssText=u;else{if("string"==typeof i&&(n.style.cssText=i=""),i)for(l in i)u&&l in u||preact_module_$(n.style,l,"");if(u)for(l in u)i&&u[l]===i[l]||preact_module_$(n.style,l,u[l])}else if("o"===l[0]&&"n"===l[1])o=l!==(l=l.replace(/Capture$/,"")),l=l.toLowerCase()in n?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+o]=u,u?i||n.addEventListener(l,o?preact_module_T:preact_module_I,o):n.removeEventListener(l,o?preact_module_T:preact_module_I,o);else if("dangerouslySetInnerHTML"!==l){if(t)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("href"!==l&&"list"!==l&&"form"!==l&&"tabIndex"!==l&&"download"!==l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null!=u&&(!1!==u||"a"===l[0]&&"r"===l[1])?n.setAttribute(l,u):n.removeAttribute(l))}}function preact_module_I(n){this.l[n.type+!1](preact_module_l.event?preact_module_l.event(n):n)}function preact_module_T(n){this.l[n.type+!0](preact_module_l.event?preact_module_l.event(n):n)}function preact_module_j(n,u,i,t,o,r,f,e,c){var s,h,v,y,p,k,b,m,g,x,A,P,C,$=u.type;if(void 0!==u.constructor)return null;null!=i.__h&&(c=i.__h,e=u.__e=i.__e,u.__h=null,r=[e]),(s=preact_module_l.__b)&&s(u);try{n:if("function"==typeof $){if(m=u.props,g=(s=$.contextType)&&t[s.__c],x=s?g?g.props.value:s.__:t,i.__c?b=(h=u.__c=i.__c).__=h.__E:("prototype"in $&&$.prototype.render?u.__c=h=new $(m,x):(u.__c=h=new preact_module_(m,x),h.constructor=$,h.render=preact_module_O),g&&g.sub(h),h.props=m,h.state||(h.state={}),h.context=x,h.__n=t,v=h.__d=!0,h.__h=[]),null==h.__s&&(h.__s=h.state),null!=$.getDerivedStateFromProps&&(h.__s==h.state&&(h.__s=preact_module_a({},h.__s)),preact_module_a(h.__s,$.getDerivedStateFromProps(m,h.__s))),y=h.props,p=h.state,v)null==$.getDerivedStateFromProps&&null!=h.componentWillMount&&h.componentWillMount(),null!=h.componentDidMount&&h.__h.push(h.componentDidMount);else{if(null==$.getDerivedStateFromProps&&m!==y&&null!=h.componentWillReceiveProps&&h.componentWillReceiveProps(m,x),!h.__e&&null!=h.shouldComponentUpdate&&!1===h.shouldComponentUpdate(m,h.__s,x)||u.__v===i.__v){h.props=m,h.state=h.__s,u.__v!==i.__v&&(h.__d=!1),h.__v=u,u.__e=i.__e,u.__k=i.__k,u.__k.forEach(function(n){n&&(n.__=u)}),h.__h.length&&f.push(h);break n}null!=h.componentWillUpdate&&h.componentWillUpdate(m,h.__s,x),null!=h.componentDidUpdate&&h.__h.push(function(){h.componentDidUpdate(y,p,k)})}if(h.context=x,h.props=m,h.__v=u,h.__P=n,A=preact_module_l.__r,P=0,"prototype"in $&&$.prototype.render)h.state=h.__s,h.__d=!1,A&&A(u),s=h.render(h.props,h.state,h.context);else do{h.__d=!1,A&&A(u),s=h.render(h.props,h.state,h.context),h.state=h.__s}while(h.__d&&++P<25);h.state=h.__s,null!=h.getChildContext&&(t=preact_module_a(preact_module_a({},t),h.getChildContext())),v||null==h.getSnapshotBeforeUpdate||(k=h.getSnapshotBeforeUpdate(y,p)),C=null!=s&&s.type===preact_module_d&&null==s.key?s.props.children:s,preact_module_w(n,Array.isArray(C)?C:[C],u,i,t,o,r,f,e,c),h.base=u.__e,u.__h=null,h.__h.length&&f.push(h),b&&(h.__E=h.__=null),h.__e=!1}else null==r&&u.__v===i.__v?(u.__k=i.__k,u.__e=i.__e):u.__e=preact_module_L(i.__e,u,i,t,o,r,f,c);(s=preact_module_l.diffed)&&s(u)}catch(n){u.__v=null,(c||null!=r)&&(u.__e=e,u.__h=!!c,r[r.indexOf(e)]=null),preact_module_l.__e(n,u,i)}}function preact_module_z(n,u){preact_module_l.__c&&preact_module_l.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u)})}catch(n){preact_module_l.__e(n,u.__v)}})}function preact_module_L(l,u,i,t,o,r,f,c){var s,a,v,y=i.props,p=u.props,d=u.type,_=0;if("svg"===d&&(o=!0),null!=r)for(;_<r.length;_++)if((s=r[_])&&"setAttribute"in s==!!d&&(d?s.localName===d:3===s.nodeType)){l=s,r[_]=null;break}if(null==l){if(null===d)return document.createTextNode(p);l=o?document.createElementNS("http://www.w3.org/2000/svg",d):document.createElement(d,p.is&&p),r=null,c=!1}if(null===d)y===p||c&&l.data===p||(l.data=p);else{if(r=r&&preact_module_n.call(l.childNodes),a=(y=i.props||preact_module_e).dangerouslySetInnerHTML,v=p.dangerouslySetInnerHTML,!c){if(null!=r)for(y={},_=0;_<l.attributes.length;_++)y[l.attributes[_].name]=l.attributes[_].value;(v||a)&&(v&&(a&&v.__html==a.__html||v.__html===l.innerHTML)||(l.innerHTML=v&&v.__html||""))}if(preact_module_C(l,p,y,o,c),v)u.__k=[];else if(_=u.props.children,preact_module_w(l,Array.isArray(_)?_:[_],u,i,t,o&&"foreignObject"!==d,r,f,r?r[0]:i.__k&&preact_module_k(i,0),c),null!=r)for(_=r.length;_--;)null!=r[_]&&preact_module_h(r[_]);c||("value"in p&&void 0!==(_=p.value)&&(_!==l.value||"progress"===d&&!_||"option"===d&&_!==y.value)&&preact_module_H(l,"value",_,y.value,!1),"checked"in p&&void 0!==(_=p.checked)&&_!==l.checked&&preact_module_H(l,"checked",_,y.checked,!1))}return l}function preact_module_M(n,u,i){try{"function"==typeof n?n(u):n.current=u}catch(n){preact_module_l.__e(n,i)}}function preact_module_N(n,u,i){var t,o;if(preact_module_l.unmount&&preact_module_l.unmount(n),(t=n.ref)&&(t.current&&t.current!==n.__e||preact_module_M(t,null,u)),null!=(t=n.__c)){if(t.componentWillUnmount)try{t.componentWillUnmount()}catch(n){preact_module_l.__e(n,u)}t.base=t.__P=null}if(t=n.__k)for(o=0;o<t.length;o++)t[o]&&preact_module_N(t[o],u,"function"!=typeof n.type);i||null==n.__e||preact_module_h(n.__e),n.__e=n.__d=void 0}function preact_module_O(n,l,u){return this.constructor(n,u)}function preact_module_S(u,i,t){var o,r,f;preact_module_l.__&&preact_module_l.__(u,i),r=(o="function"==typeof t)?null:t&&t.__k||i.__k,f=[],preact_module_j(i,u=(!o&&t||i).__k=preact_module_v(preact_module_d,null,[u]),r||preact_module_e,preact_module_e,void 0!==i.ownerSVGElement,!o&&t?[t]:r?null:i.firstChild?preact_module_n.call(i.childNodes):null,f,!o&&t?t:r?r.__e:i.firstChild,o),preact_module_z(f,u)}function preact_module_q(n,l){preact_module_S(n,l,preact_module_q)}function preact_module_B(l,u,i){var t,o,r,f=preact_module_a({},l.props);for(r in u)"key"==r?t=u[r]:"ref"==r?o=u[r]:f[r]=u[r];return arguments.length>2&&(f.children=arguments.length>3?preact_module_n.call(arguments,2):i),preact_module_y(l.type,f,t||l.key,o||l.ref,null)}function preact_module_D(n,l){var u={__c:l="__cC"+preact_module_f++,__:n,Consumer:function(n,l){return n.children(l)},Provider:function(n){var u,i;return this.getChildContext||(u=[],(i={})[l]=this,this.getChildContext=function(){return i},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&u.some(preact_module_m)},this.sub=function(n){u.push(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){u.splice(u.indexOf(n),1),l&&l.call(n)}}),n.children}};return u.Provider.__=u.Consumer.contextType=u}preact_module_n=preact_module_c.slice,preact_module_l={__e:function(n,l,u,i){for(var t,o,r;l=l.__;)if((t=l.__c)&&!t.__)try{if((o=t.constructor)&&null!=o.getDerivedStateFromError&&(t.setState(o.getDerivedStateFromError(n)),r=t.__d),null!=t.componentDidCatch&&(t.componentDidCatch(n,i||{}),r=t.__d),r)return t.__E=t}catch(l){n=l}throw n}},preact_module_u=0,preact_module_i=function(n){return null!=n&&void 0===n.constructor},preact_module_.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=preact_module_a({},this.state),"function"==typeof n&&(n=n(preact_module_a({},u),this.props)),n&&preact_module_a(u,n),null!=n&&this.__v&&(l&&this.__h.push(l),preact_module_m(this))},preact_module_.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),preact_module_m(this))},preact_module_.prototype.render=preact_module_d,preact_module_t=[],preact_module_o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,preact_module_g.__r=0,preact_module_f=0;
//# sourceMappingURL=preact.module.js.map

;// CONCATENATED MODULE: ./node_modules/preact/hooks/dist/hooks.module.js
var hooks_module_t,hooks_module_u,hooks_module_r,hooks_module_o,hooks_module_i=0,hooks_module_c=[],hooks_module_f=[],hooks_module_e=preact_module_l.__b,hooks_module_a=preact_module_l.__r,hooks_module_v=preact_module_l.diffed,hooks_module_l=preact_module_l.__c,hooks_module_m=preact_module_l.unmount;function hooks_module_p(t,r){preact_module_l.__h&&preact_module_l.__h(hooks_module_u,t,hooks_module_i||r),hooks_module_i=0;var o=hooks_module_u.__H||(hooks_module_u.__H={__:[],__h:[]});return t>=o.__.length&&o.__.push({__V:hooks_module_f}),o.__[t]}function hooks_module_y(n){return hooks_module_i=1,hooks_module_d(hooks_module_z,n)}function hooks_module_d(n,r,o){var i=hooks_module_p(hooks_module_t++,2);return i.t=n,i.__c||(i.__=[o?o(r):hooks_module_z(void 0,r),function(n){var t=i.t(i.__[0],n);i.__[0]!==t&&(i.__=[t,i.__[1]],i.__c.setState({}))}],i.__c=hooks_module_u),i.__}function hooks_module_(r,o){var i=hooks_module_p(hooks_module_t++,3);!preact_module_l.__s&&hooks_module_w(i.__H,o)&&(i.__=r,i.u=o,hooks_module_u.__H.__h.push(i))}function hooks_module_h(r,o){var i=hooks_module_p(hooks_module_t++,4);!preact_module_l.__s&&hooks_module_w(i.__H,o)&&(i.__=r,i.u=o,hooks_module_u.__h.push(i))}function hooks_module_s(n){return hooks_module_i=5,hooks_module_F(function(){return{current:n}},[])}function hooks_module_A(n,t,u){hooks_module_i=6,hooks_module_h(function(){return"function"==typeof n?(n(t()),function(){return n(null)}):n?(n.current=t(),function(){return n.current=null}):void 0},null==u?u:u.concat(n))}function hooks_module_F(n,u){var r=hooks_module_p(hooks_module_t++,7);return hooks_module_w(r.__H,u)?(r.__V=n(),r.u=u,r.__h=n,r.__V):r.__}function hooks_module_T(n,t){return hooks_module_i=8,hooks_module_F(function(){return n},t)}function hooks_module_q(n){var r=hooks_module_u.context[n.__c],o=hooks_module_p(hooks_module_t++,9);return o.c=n,r?(null==o.__&&(o.__=!0,r.sub(hooks_module_u)),r.props.value):n.__}function hooks_module_x(t,u){preact_module_l.useDebugValue&&preact_module_l.useDebugValue(u?u(t):t)}function hooks_module_V(n){var r=hooks_module_p(hooks_module_t++,10),o=hooks_module_y();return r.__=n,hooks_module_u.componentDidCatch||(hooks_module_u.componentDidCatch=function(n){r.__&&r.__(n),o[1](n)}),[o[0],function(){o[1](void 0)}]}function hooks_module_b(){for(var t;t=hooks_module_c.shift();)if(t.__P)try{t.__H.__h.forEach(hooks_module_j),t.__H.__h.forEach(hooks_module_k),t.__H.__h=[]}catch(u){t.__H.__h=[],preact_module_l.__e(u,t.__v)}}preact_module_l.__b=function(n){hooks_module_u=null,hooks_module_e&&hooks_module_e(n)},preact_module_l.__r=function(n){hooks_module_a&&hooks_module_a(n),hooks_module_t=0;var o=(hooks_module_u=n.__c).__H;o&&(hooks_module_r===hooks_module_u?(o.__h=[],hooks_module_u.__h=[],o.__.forEach(function(n){n.__V=hooks_module_f,n.u=void 0})):(o.__h.forEach(hooks_module_j),o.__h.forEach(hooks_module_k),o.__h=[])),hooks_module_r=hooks_module_u},preact_module_l.diffed=function(t){hooks_module_v&&hooks_module_v(t);var i=t.__c;i&&i.__H&&(i.__H.__h.length&&(1!==hooks_module_c.push(i)&&hooks_module_o===preact_module_l.requestAnimationFrame||((hooks_module_o=preact_module_l.requestAnimationFrame)||function(n){var t,u=function(){clearTimeout(r),hooks_module_g&&cancelAnimationFrame(t),setTimeout(n)},r=setTimeout(u,100);hooks_module_g&&(t=requestAnimationFrame(u))})(hooks_module_b)),i.__H.__.forEach(function(n){n.u&&(n.__H=n.u),n.__V!==hooks_module_f&&(n.__=n.__V),n.u=void 0,n.__V=hooks_module_f})),hooks_module_r=hooks_module_u=null},preact_module_l.__c=function(t,u){u.some(function(t){try{t.__h.forEach(hooks_module_j),t.__h=t.__h.filter(function(n){return!n.__||hooks_module_k(n)})}catch(r){u.some(function(n){n.__h&&(n.__h=[])}),u=[],preact_module_l.__e(r,t.__v)}}),hooks_module_l&&hooks_module_l(t,u)},preact_module_l.unmount=function(t){hooks_module_m&&hooks_module_m(t);var u,r=t.__c;r&&r.__H&&(r.__H.__.forEach(function(n){try{hooks_module_j(n)}catch(n){u=n}}),u&&preact_module_l.__e(u,r.__v))};var hooks_module_g="function"==typeof requestAnimationFrame;function hooks_module_j(n){var t=hooks_module_u,r=n.__c;"function"==typeof r&&(n.__c=void 0,r()),hooks_module_u=t}function hooks_module_k(n){var t=hooks_module_u;n.__c=n.__(),hooks_module_u=t}function hooks_module_w(n,t){return!n||n.length!==t.length||t.some(function(t,u){return t!==n[u]})}function hooks_module_z(n,t){return"function"==typeof t?t(n):t}
//# sourceMappingURL=hooks.module.js.map

;// CONCATENATED MODULE: ./node_modules/preact/compat/dist/compat.module.js
function compat_module_C(n,t){for(var e in t)n[e]=t[e];return n}function compat_module_S(n,t){for(var e in n)if("__source"!==e&&!(e in t))return!0;for(var r in t)if("__source"!==r&&n[r]!==t[r])return!0;return!1}function compat_module_E(n){this.props=n}function compat_module_g(n,t){function e(n){var e=this.props.ref,r=e==n.ref;return!r&&e&&(e.call?e(null):e.current=null),t?!t(this.props,n)||!r:compat_module_S(this.props,n)}function r(t){return this.shouldComponentUpdate=e,preact_module_v(n,t)}return r.displayName="Memo("+(n.displayName||n.name)+")",r.prototype.isReactComponent=!0,r.__f=!0,r}(compat_module_E.prototype=new preact_module_).isPureReactComponent=!0,compat_module_E.prototype.shouldComponentUpdate=function(n,t){return compat_module_S(this.props,n)||compat_module_S(this.state,t)};var compat_module_w=preact_module_l.__b;preact_module_l.__b=function(n){n.type&&n.type.__f&&n.ref&&(n.props.ref=n.ref,n.ref=null),compat_module_w&&compat_module_w(n)};var compat_module_R="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.forward_ref")||3911;function compat_module_x(n){function t(t){var e=compat_module_C({},t);return delete e.ref,n(e,t.ref||null)}return t.$$typeof=compat_module_R,t.render=t,t.prototype.isReactComponent=t.__f=!0,t.displayName="ForwardRef("+(n.displayName||n.name)+")",t}var compat_module_N=function(n,t){return null==n?null:preact_module_A(preact_module_A(n).map(t))},compat_module_k={map:compat_module_N,forEach:compat_module_N,count:function(n){return n?preact_module_A(n).length:0},only:function(n){var t=preact_module_A(n);if(1!==t.length)throw"Children.only";return t[0]},toArray:preact_module_A},compat_module_A=preact_module_l.__e;preact_module_l.__e=function(n,t,e,r){if(n.then)for(var u,o=t;o=o.__;)if((u=o.__c)&&u.__c)return null==t.__e&&(t.__e=e.__e,t.__k=e.__k),u.__c(n,t);compat_module_A(n,t,e,r)};var compat_module_O=preact_module_l.unmount;function compat_module_L(){this.__u=0,this.t=null,this.__b=null}function compat_module_U(n){var t=n.__.__c;return t&&t.__e&&t.__e(n)}function compat_module_F(n){var t,e,r;function u(u){if(t||(t=n()).then(function(n){e=n.default||n},function(n){r=n}),r)throw r;if(!e)throw t;return preact_module_v(e,u)}return u.displayName="Lazy",u.__f=!0,u}function compat_module_M(){this.u=null,this.o=null}preact_module_l.unmount=function(n){var t=n.__c;t&&t.__R&&t.__R(),t&&!0===n.__h&&(n.type=null),compat_module_O&&compat_module_O(n)},(compat_module_L.prototype=new preact_module_).__c=function(n,t){var e=t.__c,r=this;null==r.t&&(r.t=[]),r.t.push(e);var u=compat_module_U(r.__v),o=!1,i=function(){o||(o=!0,e.__R=null,u?u(l):l())};e.__R=i;var l=function(){if(!--r.__u){if(r.state.__e){var n=r.state.__e;r.__v.__k[0]=function n(t,e,r){return t&&(t.__v=null,t.__k=t.__k&&t.__k.map(function(t){return n(t,e,r)}),t.__c&&t.__c.__P===e&&(t.__e&&r.insertBefore(t.__e,t.__d),t.__c.__e=!0,t.__c.__P=r)),t}(n,n.__c.__P,n.__c.__O)}var t;for(r.setState({__e:r.__b=null});t=r.t.pop();)t.forceUpdate()}},f=!0===t.__h;r.__u++||f||r.setState({__e:r.__b=r.__v.__k[0]}),n.then(i,i)},compat_module_L.prototype.componentWillUnmount=function(){this.t=[]},compat_module_L.prototype.render=function(n,t){if(this.__b){if(this.__v.__k){var e=document.createElement("div"),r=this.__v.__k[0].__c;this.__v.__k[0]=function n(t,e,r){return t&&(t.__c&&t.__c.__H&&(t.__c.__H.__.forEach(function(n){"function"==typeof n.__c&&n.__c()}),t.__c.__H=null),null!=(t=compat_module_C({},t)).__c&&(t.__c.__P===r&&(t.__c.__P=e),t.__c=null),t.__k=t.__k&&t.__k.map(function(t){return n(t,e,r)})),t}(this.__b,e,r.__O=r.__P)}this.__b=null}var u=t.__e&&preact_module_v(preact_module_d,null,n.fallback);return u&&(u.__h=null),[preact_module_v(preact_module_d,null,t.__e?null:n.children),u]};var compat_module_T=function(n,t,e){if(++e[1]===e[0]&&n.o.delete(t),n.props.revealOrder&&("t"!==n.props.revealOrder[0]||!n.o.size))for(e=n.u;e;){for(;e.length>3;)e.pop()();if(e[1]<e[0])break;n.u=e=e[2]}};function compat_module_D(n){return this.getChildContext=function(){return n.context},n.children}function compat_module_I(n){var t=this,e=n.i;t.componentWillUnmount=function(){preact_module_S(null,t.l),t.l=null,t.i=null},t.i&&t.i!==e&&t.componentWillUnmount(),n.__v?(t.l||(t.i=e,t.l={nodeType:1,parentNode:e,childNodes:[],appendChild:function(n){this.childNodes.push(n),t.i.appendChild(n)},insertBefore:function(n,e){this.childNodes.push(n),t.i.appendChild(n)},removeChild:function(n){this.childNodes.splice(this.childNodes.indexOf(n)>>>1,1),t.i.removeChild(n)}}),preact_module_S(preact_module_v(compat_module_D,{context:t.context},n.__v),t.l)):t.l&&t.componentWillUnmount()}function compat_module_W(n,t){var e=preact_module_v(compat_module_I,{__v:n,i:t});return e.containerInfo=t,e}(compat_module_M.prototype=new preact_module_).__e=function(n){var t=this,e=compat_module_U(t.__v),r=t.o.get(n);return r[0]++,function(u){var o=function(){t.props.revealOrder?(r.push(u),compat_module_T(t,n,r)):u()};e?e(o):o()}},compat_module_M.prototype.render=function(n){this.u=null,this.o=new Map;var t=preact_module_A(n.children);n.revealOrder&&"b"===n.revealOrder[0]&&t.reverse();for(var e=t.length;e--;)this.o.set(t[e],this.u=[1,0,this.u]);return n.children},compat_module_M.prototype.componentDidUpdate=compat_module_M.prototype.componentDidMount=function(){var n=this;this.o.forEach(function(t,e){compat_module_T(n,e,t)})};var compat_module_P="undefined"!=typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,compat_module_V=/^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|shape|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,compat_module_$="undefined"!=typeof document,compat_module_j=function(n){return("undefined"!=typeof Symbol&&"symbol"==typeof Symbol()?/fil|che|rad/i:/fil|che|ra/i).test(n)};function compat_module_z(n,t,e){return null==t.__k&&(t.textContent=""),preact_module_S(n,t),"function"==typeof e&&e(),n?n.__c:null}function compat_module_B(n,t,e){return preact_module_q(n,t),"function"==typeof e&&e(),n?n.__c:null}preact_module_.prototype.isReactComponent={},["componentWillMount","componentWillReceiveProps","componentWillUpdate"].forEach(function(n){Object.defineProperty(preact_module_.prototype,n,{configurable:!0,get:function(){return this["UNSAFE_"+n]},set:function(t){Object.defineProperty(this,n,{configurable:!0,writable:!0,value:t})}})});var compat_module_H=preact_module_l.event;function compat_module_Z(){}function compat_module_Y(){return this.cancelBubble}function compat_module_q(){return this.defaultPrevented}preact_module_l.event=function(n){return compat_module_H&&(n=compat_module_H(n)),n.persist=compat_module_Z,n.isPropagationStopped=compat_module_Y,n.isDefaultPrevented=compat_module_q,n.nativeEvent=n};var compat_module_G,compat_module_J={configurable:!0,get:function(){return this.class}},compat_module_K=preact_module_l.vnode;preact_module_l.vnode=function(n){var t=n.type,e=n.props,r=e;if("string"==typeof t){var u=-1===t.indexOf("-");for(var o in r={},e){var i=e[o];compat_module_$&&"children"===o&&"noscript"===t||"value"===o&&"defaultValue"in e&&null==i||("defaultValue"===o&&"value"in e&&null==e.value?o="value":"download"===o&&!0===i?i="":/ondoubleclick/i.test(o)?o="ondblclick":/^onchange(textarea|input)/i.test(o+t)&&!compat_module_j(e.type)?o="oninput":/^onfocus$/i.test(o)?o="onfocusin":/^onblur$/i.test(o)?o="onfocusout":/^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o)?o=o.toLowerCase():u&&compat_module_V.test(o)?o=o.replace(/[A-Z0-9]/,"-$&").toLowerCase():null===i&&(i=void 0),/^oninput$/i.test(o)&&(o=o.toLowerCase(),r[o]&&(o="oninputCapture")),r[o]=i)}"select"==t&&r.multiple&&Array.isArray(r.value)&&(r.value=preact_module_A(e.children).forEach(function(n){n.props.selected=-1!=r.value.indexOf(n.props.value)})),"select"==t&&null!=r.defaultValue&&(r.value=preact_module_A(e.children).forEach(function(n){n.props.selected=r.multiple?-1!=r.defaultValue.indexOf(n.props.value):r.defaultValue==n.props.value})),n.props=r,e.class!=e.className&&(compat_module_J.enumerable="className"in e,null!=e.className&&(r.class=e.className),Object.defineProperty(r,"className",compat_module_J))}n.$$typeof=compat_module_P,compat_module_K&&compat_module_K(n)};var compat_module_Q=preact_module_l.__r;preact_module_l.__r=function(n){compat_module_Q&&compat_module_Q(n),compat_module_G=n.__c};var compat_module_X={ReactCurrentDispatcher:{current:{readContext:function(n){return compat_module_G.__n[n.__c].props.value}}}},compat_module_nn="17.0.2";function compat_module_tn(n){return preact_module_v.bind(null,n)}function compat_module_en(n){return!!n&&n.$$typeof===compat_module_P}function compat_module_rn(n){return compat_module_en(n)?preact_module_B.apply(null,arguments):n}function compat_module_un(n){return!!n.__k&&(preact_module_S(null,n),!0)}function compat_module_on(n){return n&&(n.base||1===n.nodeType&&n)||null}var compat_module_ln=function(n,t){return n(t)},compat_module_fn=function(n,t){return n(t)},compat_module_cn=preact_module_d;/* harmony default export */ const compat_module = ({useState:hooks_module_y,useReducer:hooks_module_d,useEffect:hooks_module_,useLayoutEffect:hooks_module_h,useRef:hooks_module_s,useImperativeHandle:hooks_module_A,useMemo:hooks_module_F,useCallback:hooks_module_T,useContext:hooks_module_q,useDebugValue:hooks_module_x,version:"17.0.2",Children:compat_module_k,render:compat_module_z,hydrate:compat_module_B,unmountComponentAtNode:compat_module_un,createPortal:compat_module_W,createElement:preact_module_v,createContext:preact_module_D,createFactory:compat_module_tn,cloneElement:compat_module_rn,createRef:preact_module_p,Fragment:preact_module_d,isValidElement:compat_module_en,findDOMNode:compat_module_on,Component:preact_module_,PureComponent:compat_module_E,memo:compat_module_g,forwardRef:compat_module_x,flushSync:compat_module_fn,unstable_batchedUpdates:compat_module_ln,StrictMode:preact_module_d,Suspense:compat_module_L,SuspenseList:compat_module_M,lazy:compat_module_F,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:compat_module_X});
//# sourceMappingURL=compat.module.js.map

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/core/vdom.js




var globalObj = typeof globalThis !== 'undefined' ? globalThis : window; // // TODO: streamline when killing IE11 support
if (globalObj.FullCalendarVDom) {
    console.warn('FullCalendar VDOM already loaded');
}
else {
    globalObj.FullCalendarVDom = {
        Component: preact_module_,
        createElement: preact_module_v,
        render: preact_module_S,
        createRef: preact_module_p,
        Fragment: preact_module_d,
        createContext: createContext,
        createPortal: compat_module_W,
        flushSync: flushSync,
        unmountComponentAtNode: unmountComponentAtNode,
    };
}
// HACKS...
// TODO: lock version
// TODO: link gh issues
function flushSync(runBeforeFlush) {
    runBeforeFlush();
    var oldDebounceRendering = preact_module_l.debounceRendering; // orig
    var callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    preact_module_l.debounceRendering = execCallbackSync;
    preact_module_S(preact_module_v(FakeComponent, {}), document.createElement('div'));
    while (callbackQ.length) {
        callbackQ.shift()();
    }
    preact_module_l.debounceRendering = oldDebounceRendering;
}
var FakeComponent = /** @class */ (function (_super) {
    tslib_es6_extends(FakeComponent, _super);
    function FakeComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FakeComponent.prototype.render = function () { return preact_module_v('div', {}); };
    FakeComponent.prototype.componentDidMount = function () { this.setState({}); };
    return FakeComponent;
}(preact_module_));
function createContext(defaultValue) {
    var ContextType = preact_module_D(defaultValue);
    var origProvider = ContextType.Provider;
    ContextType.Provider = function () {
        var _this = this;
        var isNew = !this.getChildContext;
        var children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            var subs_1 = [];
            this.shouldComponentUpdate = function (_props) {
                if (_this.props.value !== _props.value) {
                    subs_1.forEach(function (c) {
                        c.context = _props.value;
                        c.forceUpdate();
                    });
                }
            };
            this.sub = function (c) {
                subs_1.push(c);
                var old = c.componentWillUnmount;
                c.componentWillUnmount = function () {
                    subs_1.splice(subs_1.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
function unmountComponentAtNode(node) {
    preact_module_S(null, node);
}

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/common/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var tslib_tslib_es6_extendStatics = function(d, b) {
    tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return tslib_tslib_es6_extendStatics(d, b);
};

function tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var node_modules_tslib_tslib_es6_assign = function() {
    node_modules_tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return node_modules_tslib_tslib_es6_assign.apply(this, arguments);
}

function tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) tslib_tslib_es6_createBinding(o, m, p);
}

function tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function tslib_tslib_es6_await(v) {
    return this instanceof tslib_tslib_es6_await ? (this.v = v, this) : new tslib_tslib_es6_await(v);
}

function tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof tslib_tslib_es6_values === "function" ? tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) tslib_tslib_es6_createBinding(result, mod, k);
    tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/common/vdom.js
/// <reference types="@fullcalendar/core-preact" />
if (typeof FullCalendarVDom === 'undefined') {
    throw new Error('Please import the top-level fullcalendar lib before attempting to import a plugin.');
}
var vdom_Component = FullCalendarVDom.Component;
var createElement = FullCalendarVDom.createElement;
var vdom_render = FullCalendarVDom.render;
var createRef = FullCalendarVDom.createRef;
var Fragment = FullCalendarVDom.Fragment;
var vdom_createContext = FullCalendarVDom.createContext;
var createPortal = FullCalendarVDom.createPortal;
var vdom_flushSync = FullCalendarVDom.flushSync;
var vdom_unmountComponentAtNode = FullCalendarVDom.unmountComponentAtNode;
/* eslint-enable */



;// CONCATENATED MODULE: ./node_modules/@fullcalendar/common/main.js
/*!
FullCalendar v5.10.2
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/






// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var EventSourceApi = /** @class */ (function () {
    function EventSourceApi(context, internalEventSource) {
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
    EventSourceApi.prototype.remove = function () {
        this.context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: this.internalEventSource.sourceId,
        });
    };
    EventSourceApi.prototype.refetch = function () {
        this.context.dispatch({
            type: 'FETCH_EVENT_SOURCES',
            sourceIds: [this.internalEventSource.sourceId],
            isRefetch: true,
        });
    };
    Object.defineProperty(EventSourceApi.prototype, "id", {
        get: function () {
            return this.internalEventSource.publicId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "url", {
        get: function () {
            return this.internalEventSource.meta.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSourceApi.prototype, "format", {
        get: function () {
            return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
        },
        enumerable: false,
        configurable: true
    });
    return EventSourceApi;
}());

function removeElement(el) {
    if (el.parentNode) {
        el.parentNode.removeChild(el);
    }
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function elementClosest(el, selector) {
    if (el.closest) {
        return el.closest(selector);
        // really bad fallback for IE
        // from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
    }
    if (!document.documentElement.contains(el)) {
        return null;
    }
    do {
        if (elementMatches(el, selector)) {
            return el;
        }
        el = (el.parentElement || el.parentNode);
    } while (el !== null && el.nodeType === 1);
    return null;
}
function elementMatches(el, selector) {
    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function findElements(container, selector) {
    var containers = container instanceof HTMLElement ? [container] : container;
    var allMatches = [];
    for (var i = 0; i < containers.length; i += 1) {
        var matches = containers[i].querySelectorAll(selector);
        for (var j = 0; j < matches.length; j += 1) {
            allMatches.push(matches[j]);
        }
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function findDirectChildren(parent, selector) {
    var parents = parent instanceof HTMLElement ? [parent] : parent;
    var allMatches = [];
    for (var i = 0; i < parents.length; i += 1) {
        var childNodes = parents[i].children; // only ever elements
        for (var j = 0; j < childNodes.length; j += 1) {
            var childNode = childNodes[j];
            if (!selector || elementMatches(childNode, selector)) {
                allMatches.push(childNode);
            }
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function applyStyle(el, props) {
    for (var propName in props) {
        applyStyleProp(el, propName, props[propName]);
    }
}
function applyStyleProp(el, name, val) {
    if (val == null) {
        el.style[name] = '';
    }
    else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) {
        el.style[name] = val + "px";
    }
    else {
        el.style[name] = val;
    }
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function getEventTargetViaRoot(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Shadow DOM consuderations
// ----------------------------------------------------------------------------------------------------------------
function getElRoot(el) {
    return el.getRootNode ? el.getRootNode() : document;
}
// Unique ID for DOM attribute
var guid$1 = 0;
function getUniqueDomId() {
    guid$1 += 1;
    return 'fc-dom-' + guid$1;
}

// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function buildDelegationHandler(selector, handler) {
    return function (ev) {
        var matchedChild = elementClosest(ev.target, selector);
        if (matchedChild) {
            handler.call(matchedChild, ev, matchedChild);
        }
    };
}
function listenBySelector(container, eventType, selector, handler) {
    var attachedHandler = buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return function () {
        container.removeEventListener(eventType, attachedHandler);
    };
}
function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return listenBySelector(container, 'mouseover', selector, function (mouseOverEv, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            var realOnMouseLeave_1 = function (mouseLeaveEv) {
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave_1);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave_1);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
var transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend',
];
// triggered only when the next single subsequent transition finishes
function whenTransitionDone(el, callback) {
    var realCallback = function (ev) {
        callback(ev);
        transitionEventNames.forEach(function (eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    transitionEventNames.forEach(function (eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function createAriaClickAttrs(handler) {
    return node_modules_tslib_tslib_es6_assign({ onClick: handler }, createAriaKeyboardAttrs(handler));
}
function createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown: function (ev) {
            if (ev.key === 'Enter' || ev.key === ' ') {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        },
    };
}

var guidNumber = 0;
function guid() {
    guidNumber += 1;
    return String(guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    document.body.classList.add('fc-not-allowed');
}
// Returns the mouse cursor to its original look
function enableCursor() {
    document.body.classList.remove('fc-not-allowed');
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/
function preventSelection(el) {
    el.classList.add('fc-unselectable');
    el.addEventListener('selectstart', preventDefault);
}
function allowSelection(el) {
    el.classList.remove('fc-unselectable');
    el.removeEventListener('selectstart', preventDefault);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/
function preventContextMenu(el) {
    el.addEventListener('contextmenu', preventDefault);
}
function allowContextMenu(el) {
    el.removeEventListener('contextmenu', preventDefault);
}
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') {
        tokens = input.split(/\s*,\s*/);
    }
    else if (typeof input === 'function') {
        tokens = [input];
    }
    else if (Array.isArray(input)) {
        tokens = input;
    }
    for (i = 0; i < tokens.length; i += 1) {
        token = tokens[i];
        if (typeof token === 'string') {
            specs.push(token.charAt(0) === '-' ?
                { field: token.substring(1), order: -1 } :
                { field: token, order: 1 });
        }
        else if (typeof token === 'function') {
            specs.push({ func: token });
        }
    }
    return specs;
}
function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
    var i;
    var cmp;
    for (i = 0; i < fieldSpecs.length; i += 1) {
        cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) {
            return cmp;
        }
    }
    return 0;
}
function compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) {
        return fieldSpec.func(obj0, obj1);
    }
    return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field])
        * (fieldSpec.order || 1);
}
function flexibleCompare(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (b == null) {
        return -1;
    }
    if (a == null) {
        return 1;
    }
    if (typeof a === 'string' || typeof b === 'string') {
        return String(a).localeCompare(String(b));
    }
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/
function padStart(val, len) {
    var s = String(val);
    return '000'.substr(0, len - s.length) + s;
}
function formatWithOrdinals(formatter, args, fallbackText) {
    if (typeof formatter === 'function') {
        return formatter.apply(void 0, args);
    }
    if (typeof formatter === 'string') { // non-blank string
        return args.reduce(function (str, arg, index) { return (str.replace('$' + index, arg || '')); }, formatter);
    }
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/
function compareNumbers(a, b) {
    return a - b;
}
function isInt(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/
function computeSmallestCellWidth(cellEl) {
    var allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
    var contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
    if (!allWidthEl) {
        throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
    }
    if (!contentWidthEl) {
        throw new Error('needs fc-scrollgrid-shrink-cushion className');
    }
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
        contentWidthEl.getBoundingClientRect().width;
}

var DAY_IDS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
// Adding
function addWeeks(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n * 7;
    return arrayToUtcDate(a);
}
function addDays(m, n) {
    var a = dateToUtcArray(m);
    a[2] += n;
    return arrayToUtcDate(a);
}
function addMs(m, n) {
    var a = dateToUtcArray(m);
    a[6] += n;
    return arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function diffWeeks(m0, m1) {
    return diffDays(m0, m1) / 7;
}
function diffDays(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60 * 24);
}
function diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60);
}
function diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / (1000 * 60);
}
function diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function diffDayAndTime(m0, m1) {
    var m0day = startOfDay(m0);
    var m1day = startOfDay(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round(diffDays(m0day, m1day)),
        milliseconds: (m1.valueOf() - m1day.valueOf()) - (m0.valueOf() - m0day.valueOf()),
    };
}
// Diffing Whole Units
function diffWholeWeeks(m0, m1) {
    var d = diffWholeDays(m0, m1);
    if (d !== null && d % 7 === 0) {
        return d / 7;
    }
    return null;
}
function diffWholeDays(m0, m1) {
    if (timeAsMs(m0) === timeAsMs(m1)) {
        return Math.round(diffDays(m0, m1));
    }
    return null;
}
// Start-Of
function startOfDay(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
    ]);
}
function startOfHour(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
    ]);
}
function startOfMinute(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
    ]);
}
function startOfSecond(m) {
    return arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds(),
    ]);
}
// Week Computation
function weekOfYear(marker, dow, doy) {
    var y = marker.getUTCFullYear();
    var w = weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) {
        return weekOfGivenYear(marker, y - 1, dow, doy);
    }
    var nextW = weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) {
        return Math.min(w, nextW);
    }
    return w;
}
function weekOfGivenYear(marker, year, dow, doy) {
    var firstWeekStart = arrayToUtcDate([year, 0, 1 + firstWeekOffset(year, dow, doy)]);
    var dayStart = startOfDay(marker);
    var days = Math.round(diffDays(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    var fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    var fwdlw = (7 + arrayToUtcDate([year, 0, fwd]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds(),
    ];
}
function arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], // day of month
    a[3] || 0, a[4] || 0, a[5] || 0);
}
function dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds(),
    ];
}
function arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) {
        a = a.concat([0]);
    }
    return new Date(Date.UTC.apply(Date, a));
}
// Other Utils
function isValidDate(m) {
    return !isNaN(m.valueOf());
}
function timeAsMs(m) {
    return m.getUTCHours() * 1000 * 60 * 60 +
        m.getUTCMinutes() * 1000 * 60 +
        m.getUTCSeconds() * 1000 +
        m.getUTCMilliseconds();
}

function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: guid(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo,
    };
}

var main_hasOwnProperty = Object.prototype.hasOwnProperty;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexPropsMap) {
    var dest = {};
    if (complexPropsMap) {
        for (var name_1 in complexPropsMap) {
            var complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for (var i = propObjs.length - 1; i >= 0; i -= 1) {
                var val = propObjs[i][name_1];
                if (typeof val === 'object' && val) { // non-null object
                    complexObjs.unshift(val);
                }
                else if (val !== undefined) {
                    dest[name_1] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) {
                dest[name_1] = mergeProps(complexObjs);
            }
        }
    }
    // copy values into the destination, going from last to first
    for (var i = propObjs.length - 1; i >= 0; i -= 1) {
        var props = propObjs[i];
        for (var name_2 in props) {
            if (!(name_2 in dest)) { // if already assigned by previous props or complex props, don't reassign
                dest[name_2] = props[name_2];
            }
        }
    }
    return dest;
}
function filterHash(hash, func) {
    var filtered = {};
    for (var key in hash) {
        if (func(hash[key], key)) {
            filtered[key] = hash[key];
        }
    }
    return filtered;
}
function mapHash(hash, func) {
    var newHash = {};
    for (var key in hash) {
        newHash[key] = func(hash[key], key);
    }
    return newHash;
}
function arrayToHash(a) {
    var hash = {};
    for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
        var item = a_1[_i];
        hash[item] = true;
    }
    return hash;
}
function buildHashFromArray(a, func) {
    var hash = {};
    for (var i = 0; i < a.length; i += 1) {
        var tuple = func(a[i], i);
        hash[tuple[0]] = tuple[1];
    }
    return hash;
}
function hashValuesToArray(obj) {
    var a = [];
    for (var key in obj) {
        a.push(obj[key]);
    }
    return a;
}
function isPropsEqual(obj0, obj1) {
    if (obj0 === obj1) {
        return true;
    }
    for (var key in obj0) {
        if (main_hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) {
                return false;
            }
        }
    }
    for (var key in obj1) {
        if (main_hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) {
                return false;
            }
        }
    }
    return true;
}
function getUnequalProps(obj0, obj1) {
    var keys = [];
    for (var key in obj0) {
        if (main_hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) {
                keys.push(key);
            }
        }
    }
    for (var key in obj1) {
        if (main_hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) {
                keys.push(key);
            }
        }
    }
    return keys;
}
function compareObjs(oldProps, newProps, equalityFuncs) {
    if (equalityFuncs === void 0) { equalityFuncs = {}; }
    if (oldProps === newProps) {
        return true;
    }
    for (var key in newProps) {
        if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else {
            return false;
        }
    }
    // check for props that were omitted in the new
    for (var key in oldProps) {
        if (!(key in newProps)) {
            return false;
        }
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/
function isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) {
        return true;
    }
    if (comparator) {
        return comparator(val0, val1);
    }
    return false;
}
function collectFromHash(hash, startIndex, endIndex, step) {
    if (startIndex === void 0) { startIndex = 0; }
    if (step === void 0) { step = 1; }
    var res = [];
    if (endIndex == null) {
        endIndex = Object.keys(hash).length;
    }
    for (var i = startIndex; i < endIndex; i += step) {
        var val = hash[i];
        if (val !== undefined) { // will disregard undefined for sparse arrays
            res.push(val);
        }
    }
    return res;
}

function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for (var i = 0; i < recurringTypes.length; i += 1) {
        var parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            var allDay = refined.allDay;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) {
                        allDay = false;
                    }
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i,
            };
        }
    }
    return null;
}
function expandRecurring(eventStore, framingRange, context) {
    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
    var defs = eventStore.defs, instances = eventStore.instances;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = filterHash(instances, function (instance) { return !defs[instance.defId].recurringDef; });
    for (var defId in defs) {
        var def = defs[defId];
        if (def.recurringDef) {
            var duration = def.recurringDef.duration;
            if (!duration) {
                duration = def.allDay ?
                    options.defaultAllDayEventDuration :
                    options.defaultTimedEventDuration;
            }
            var starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (var _i = 0, starts_1 = starts; _i < starts_1.length; _i++) {
                var start = starts_1[_i];
                var instance = createEventInstance(defId, {
                    start: start,
                    end: dateEnv.add(start, duration),
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return { defs: defs, instances: instances };
}
/*
Event MUST have a recurringDef
*/
function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end,
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) {
        markers = markers.map(startOfDay);
    }
    return markers;
}

var INTERNAL_UNITS = ['years', 'months', 'days', 'milliseconds'];
var PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function createDuration(input, unit) {
    var _a;
    if (typeof input === 'string') {
        return parseString(input);
    }
    if (typeof input === 'object' && input) { // non-null object
        return parseObject(input);
    }
    if (typeof input === 'number') {
        return parseObject((_a = {}, _a[unit || 'milliseconds'] = input, _a));
    }
    return null;
}
function parseString(s) {
    var m = PARSE_RE.exec(s);
    if (m) {
        var sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 60 * 60 * 1000 + // hours
                (m[4] ? parseInt(m[4], 10) : 0) * 60 * 1000 + // minutes
                (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
                (m[6] ? parseInt(m[6], 10) : 0) // ms
            ),
        };
    }
    return null;
}
function parseObject(obj) {
    var duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 60 * 60 * 1000 + // hours
            (obj.minutes || obj.minute || 0) * 60 * 1000 + // minutes
            (obj.seconds || obj.second || 0) * 1000 + // seconds
            (obj.milliseconds || obj.millisecond || obj.ms || 0), // ms
    };
    var weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function durationsEqual(d0, d1) {
    return d0.years === d1.years &&
        d0.months === d1.months &&
        d0.days === d1.days &&
        d0.milliseconds === d1.milliseconds;
}
function asCleanDays(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) {
        return dur.days;
    }
    return 0;
}
// Simple Math
function addDurations(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds,
    };
}
function subtractDurations(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds,
    };
}
function multiplyDuration(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n,
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function asRoughYears(dur) {
    return asRoughDays(dur) / 365;
}
function asRoughMonths(dur) {
    return asRoughDays(dur) / 30;
}
function asRoughDays(dur) {
    return asRoughMs(dur) / 864e5;
}
function asRoughMinutes(dur) {
    return asRoughMs(dur) / (1000 * 60);
}
function asRoughSeconds(dur) {
    return asRoughMs(dur) / 1000;
}
function asRoughMs(dur) {
    return dur.years * (365 * 864e5) +
        dur.months * (30 * 864e5) +
        dur.days * 864e5 +
        dur.milliseconds;
}
// Advanced Math
function wholeDivideDurations(numerator, denominator) {
    var res = null;
    for (var i = 0; i < INTERNAL_UNITS.length; i += 1) {
        var unit = INTERNAL_UNITS[i];
        if (denominator[unit]) {
            var localRes = numerator[unit] / denominator[unit];
            if (!isInt(localRes) || (res !== null && res !== localRes)) {
                return null;
            }
            res = localRes;
        }
        else if (numerator[unit]) {
            // needs to divide by something but can't!
            return null;
        }
    }
    return res;
}
function greatestDurationDenominator(dur) {
    var ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) {
            return { unit: 'millisecond', value: ms };
        }
        if (ms % (1000 * 60) !== 0) {
            return { unit: 'second', value: ms / 1000 };
        }
        if (ms % (1000 * 60 * 60) !== 0) {
            return { unit: 'minute', value: ms / (1000 * 60) };
        }
        if (ms) {
            return { unit: 'hour', value: ms / (1000 * 60 * 60) };
        }
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) {
            return { unit: 'week', value: dur.days / 7 };
        }
        return { unit: 'day', value: dur.days };
    }
    if (dur.months) {
        return { unit: 'month', value: dur.months };
    }
    if (dur.years) {
        return { unit: 'year', value: dur.years };
    }
    return { unit: 'millisecond', value: 0 };
}

// timeZoneOffset is in minutes
function buildIsoString(marker, timeZoneOffset, stripZeroTime) {
    if (stripZeroTime === void 0) { stripZeroTime = false; }
    var s = marker.toISOString();
    s = s.replace('.000', '');
    if (stripZeroTime) {
        s = s.replace('T00:00:00Z', '');
    }
    if (s.length > 10) { // time part wasn't stripped, can add timezone info
        if (timeZoneOffset == null) {
            s = s.replace('Z', '');
        }
        else if (timeZoneOffset !== 0) {
            s = s.replace('Z', formatTimeZoneOffset(timeZoneOffset, true));
        }
        // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function formatDayString(marker) {
    return marker.toISOString().replace(/T.*$/, '');
}
// TODO: use Date::toISOString and use everything after the T?
function formatIsoTimeString(marker) {
    return padStart(marker.getUTCHours(), 2) + ':' +
        padStart(marker.getUTCMinutes(), 2) + ':' +
        padStart(marker.getUTCSeconds(), 2);
}
function formatTimeZoneOffset(minutes, doIso) {
    if (doIso === void 0) { doIso = false; }
    var sign = minutes < 0 ? '-' : '+';
    var abs = Math.abs(minutes);
    var hours = Math.floor(abs / 60);
    var mins = Math.round(abs % 60);
    if (doIso) {
        return sign + padStart(hours, 2) + ":" + padStart(mins, 2);
    }
    return "GMT" + sign + hours + (mins ? ":" + padStart(mins, 2) : '');
}

// TODO: new util arrayify?
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt += 1;
        }
        else {
            i += 1;
        }
    }
    return removeCnt;
}
function isArraysEqual(a0, a1, equalityFunc) {
    if (a0 === a1) {
        return true;
    }
    var len = a0.length;
    var i;
    if (len !== a1.length) { // not array? or not same length?
        return false;
    }
    for (i = 0; i < len; i += 1) {
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) {
            return false;
        }
    }
    return true;
}

function memoize(workerFunc, resEquality, teardownFunc) {
    var currentArgs;
    var currentRes;
    return function () {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (!currentArgs) {
            currentRes = workerFunc.apply(this, newArgs);
        }
        else if (!isArraysEqual(currentArgs, newArgs)) {
            if (teardownFunc) {
                teardownFunc(currentRes);
            }
            var res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) {
                currentRes = res;
            }
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArg;
    var currentRes;
    return function (newArg) {
        if (!currentArg) {
            currentRes = workerFunc.call(_this, newArg);
        }
        else if (!isPropsEqual(currentArg, newArg)) {
            if (teardownFunc) {
                teardownFunc(currentRes);
            }
            var res = workerFunc.call(_this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) {
                currentRes = res;
            }
        }
        currentArg = newArg;
        return currentRes;
    };
}
function memoizeArraylike(// used at all?
workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgSets = [];
    var currentResults = [];
    return function (newArgSets) {
        var currentLen = currentArgSets.length;
        var newLen = newArgSets.length;
        var i = 0;
        for (; i < currentLen; i += 1) {
            if (!newArgSets[i]) { // one of the old sets no longer exists
                if (teardownFunc) {
                    teardownFunc(currentResults[i]);
                }
            }
            else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) {
                    teardownFunc(currentResults[i]);
                }
                var res = workerFunc.apply(_this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) {
                    currentResults[i] = res;
                }
            }
        }
        for (; i < newLen; i += 1) {
            currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
        }
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function memoizeHashlike(// used?
workerFunc, resEquality, teardownFunc) {
    var _this = this;
    var currentArgHash = {};
    var currentResHash = {};
    return function (newArgHash) {
        var newResHash = {};
        for (var key in newArgHash) {
            if (!currentResHash[key]) {
                newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
            }
            else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) {
                    teardownFunc(currentResHash[key]);
                }
                var res = workerFunc.apply(_this, newArgHash[key]);
                newResHash[key] = (resEquality && resEquality(res, currentResHash[key]))
                    ? currentResHash[key]
                    : res;
            }
            else {
                newResHash[key] = currentResHash[key];
            }
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}

var EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0,
};
var STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1,
};
var MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
var COMMA_RE = /,/g; // we need re for globalness
var MULTI_SPACE_RE = /\s+/g;
var LTR_RE = /\u200e/g; // control character
var UTC_RE = /UTC|GMT/;
var NativeFormatter = /** @class */ (function () {
    function NativeFormatter(formatSettings) {
        var standardDateProps = {};
        var extendedSettings = {};
        var severity = 0;
        for (var name_1 in formatSettings) {
            if (name_1 in EXTENDED_SETTINGS_AND_SEVERITIES) {
                extendedSettings[name_1] = formatSettings[name_1];
                severity = Math.max(EXTENDED_SETTINGS_AND_SEVERITIES[name_1], severity);
            }
            else {
                standardDateProps[name_1] = formatSettings[name_1];
                if (name_1 in STANDARD_DATE_PROP_SEVERITIES) { // TODO: what about hour12? no severity
                    severity = Math.max(STANDARD_DATE_PROP_SEVERITIES[name_1], severity);
                }
            }
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = memoize(buildFormattingFunc);
    }
    NativeFormatter.prototype.format = function (date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    };
    NativeFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        var _a = this, standardDateProps = _a.standardDateProps, extendedSettings = _a.extendedSettings;
        var diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) {
            return this.format(start, context);
        }
        var biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
            (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') &&
            (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') &&
            (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) {
            biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        }
        var full0 = this.format(start, context);
        var full1 = this.format(end, context);
        if (full0 === full1) {
            return full0;
        }
        var partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        var partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
        var partial0 = partialFormattingFunc(start);
        var partial1 = partialFormattingFunc(end);
        var insertion = findCommonInsertion(full0, partial0, full1, partial1);
        var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
        if (insertion) {
            return insertion.before + partial0 + separator + partial1 + insertion.after;
        }
        return full0 + separator + full1;
    };
    NativeFormatter.prototype.getLargestUnit = function () {
        switch (this.severity) {
            case 7:
            case 6:
            case 5:
                return 'year';
            case 4:
                return 'month';
            case 3:
                return 'week';
            case 2:
                return 'day';
            default:
                return 'time'; // really?
        }
    };
    return NativeFormatter;
}());
function buildFormattingFunc(standardDateProps, extendedSettings, context) {
    var standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') {
        return function (date) { return (formatTimeZoneOffset(date.timeZoneOffset)); };
    }
    if (standardDatePropCnt === 0 && extendedSettings.week) {
        return function (date) { return (formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week)); };
    }
    return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = node_modules_tslib_tslib_es6_assign({}, standardDateProps); // copy
    extendedSettings = node_modules_tslib_tslib_es6_assign({}, extendedSettings); // copy
    sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    var zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        var zeroProps = node_modules_tslib_tslib_es6_assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return function (date) {
        var marker = date.marker;
        var format;
        if (zeroFormat && !marker.getUTCMinutes()) {
            format = zeroFormat;
        }
        else {
            format = normalFormat;
        }
        var s = format.format(marker);
        return postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) {
            standardDateProps.hour = '2-digit';
        }
        if (!standardDateProps.minute) {
            standardDateProps.minute = '2-digit';
        }
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === 'long') {
        standardDateProps.timeZoneName = 'short';
    }
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) {
        delete extendedSettings.omitZeroMinute;
    }
}
function postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace(LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === 'short') {
        s = injectTzoStr(s, (context.timeZone === 'UTC' || date.timeZoneOffset == null) ?
            'UTC' : // important to normalize for IE, which does "GMT"
            formatTimeZoneOffset(date.timeZoneOffset));
    }
    if (extendedSettings.omitCommas) {
        s = s.replace(COMMA_RE, '').trim();
    }
    if (extendedSettings.omitZeroMinute) {
        s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
    }
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) {
        s = s.replace(MERIDIEM_RE, '').trim();
    }
    else if (extendedSettings.meridiem === 'narrow') { // a/p
        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase(); });
    }
    else if (extendedSettings.meridiem === 'short') { // am/pm
        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase() + "m"; });
    }
    else if (extendedSettings.meridiem === 'lowercase') { // other meridiem transformers already converted to lowercase
        s = s.replace(MERIDIEM_RE, function (m0) { return m0.toLocaleLowerCase(); });
    }
    s = s.replace(MULTI_SPACE_RE, ' ');
    s = s.trim();
    return s;
}
function injectTzoStr(s, tzoStr) {
    var replaced = false;
    s = s.replace(UTC_RE, function () {
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) {
        s += " " + tzoStr;
    }
    return s;
}
function formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    var parts = [];
    if (display === 'long') {
        parts.push(weekTextLong);
    }
    else if (display === 'short' || display === 'narrow') {
        parts.push(weekText);
    }
    if (display === 'long' || display === 'short') {
        parts.push(' ');
    }
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === 'rtl') { // TODO: use control characters instead?
        parts.reverse();
    }
    return parts.join('');
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) {
        return 5;
    }
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) {
        return 4;
    }
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) {
        return 2;
    }
    if (timeAsMs(d0) !== timeAsMs(d1)) {
        return 1;
    }
    return 0;
}
function computePartialFormattingOptions(options, biggestUnit) {
    var partialOptions = {};
    for (var name_2 in options) {
        if (!(name_2 in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
            STANDARD_DATE_PROP_SEVERITIES[name_2] <= biggestUnit) {
            partialOptions[name_2] = options[name_2];
        }
    }
    return partialOptions;
}
function findCommonInsertion(full0, partial0, full1, partial1) {
    var i0 = 0;
    while (i0 < full0.length) {
        var found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) {
            break;
        }
        var before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        var after0 = full0.substr(i0);
        var i1 = 0;
        while (i1 < full1.length) {
            var found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) {
                break;
            }
            var before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            var after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) {
                return {
                    before: before0,
                    after: after0,
                };
            }
        }
    }
    return null;
}

function expandZonedMarker(dateInfo, calendarSystem) {
    var a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6],
    };
}

function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    var startInfo = expandZonedMarker(start, context.calendarSystem);
    var endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator,
    };
}

/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/
/*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/
var CmdFormatter = /** @class */ (function () {
    function CmdFormatter(cmdStr) {
        this.cmdStr = cmdStr;
    }
    CmdFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    CmdFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return CmdFormatter;
}());

var FuncFormatter = /** @class */ (function () {
    function FuncFormatter(func) {
        this.func = func;
    }
    FuncFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    };
    FuncFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
        return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    };
    return FuncFormatter;
}());

function createFormatter(input) {
    if (typeof input === 'object' && input) { // non-null object
        return new NativeFormatter(input);
    }
    if (typeof input === 'string') {
        return new CmdFormatter(input);
    }
    if (typeof input === 'function') {
        return new FuncFormatter(input);
    }
    return null;
}

// base options
// ------------
var BASE_OPTION_REFINERS = {
    navLinkDayClick: identity,
    navLinkWeekClick: identity,
    duration: createDuration,
    bootstrapFontAwesome: identity,
    buttonIcons: identity,
    customButtons: identity,
    defaultAllDayEventDuration: createDuration,
    defaultTimedEventDuration: createDuration,
    nextDayThreshold: createDuration,
    scrollTime: createDuration,
    scrollTimeReset: Boolean,
    slotMinTime: createDuration,
    slotMaxTime: createDuration,
    dayPopoverFormat: createFormatter,
    slotDuration: createDuration,
    snapDuration: createDuration,
    headerToolbar: identity,
    footerToolbar: identity,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: createFormatter,
    dayHeaderClassNames: identity,
    dayHeaderContent: identity,
    dayHeaderDidMount: identity,
    dayHeaderWillUnmount: identity,
    dayCellClassNames: identity,
    dayCellContent: identity,
    dayCellDidMount: identity,
    dayCellWillUnmount: identity,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: identity,
    weekNumbers: Boolean,
    weekNumberClassNames: identity,
    weekNumberContent: identity,
    weekNumberDidMount: identity,
    weekNumberWillUnmount: identity,
    editable: Boolean,
    viewClassNames: identity,
    viewDidMount: identity,
    viewWillUnmount: identity,
    nowIndicator: Boolean,
    nowIndicatorClassNames: identity,
    nowIndicatorContent: identity,
    nowIndicatorDidMount: identity,
    nowIndicatorWillUnmount: identity,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: identity,
    locale: identity,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: identity,
    eventOrder: parseFieldSpecs,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: identity,
    contentHeight: identity,
    direction: String,
    weekNumberFormat: createFormatter,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: identity,
    initialDate: identity,
    now: identity,
    eventDataTransform: identity,
    stickyHeaderDates: identity,
    stickyFooterScrollbar: identity,
    viewHeight: identity,
    defaultAllDay: Boolean,
    eventSourceFailure: identity,
    eventSourceSuccess: identity,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: identity,
    eventConstraint: identity,
    eventAllow: identity,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: identity,
    eventContent: identity,
    eventDidMount: identity,
    eventWillUnmount: identity,
    selectConstraint: identity,
    selectOverlap: identity,
    selectAllow: identity,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: identity,
    slotLaneClassNames: identity,
    slotLaneContent: identity,
    slotLaneDidMount: identity,
    slotLaneWillUnmount: identity,
    slotLabelClassNames: identity,
    slotLabelContent: identity,
    slotLabelDidMount: identity,
    slotLabelWillUnmount: identity,
    dayMaxEvents: identity,
    dayMaxEventRows: identity,
    dayMinWidth: Number,
    slotLabelInterval: createDuration,
    allDayText: String,
    allDayClassNames: identity,
    allDayContent: identity,
    allDayDidMount: identity,
    allDayWillUnmount: identity,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: createFormatter,
    rerenderDelay: Number,
    moreLinkText: identity,
    moreLinkHint: identity,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: identity,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: createDuration,
    hiddenDays: identity,
    monthMode: Boolean,
    fixedWeekCount: Boolean,
    validRange: identity,
    visibleRange: identity,
    titleFormat: identity,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: identity,
    navLinkHint: identity,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: identity,
    moreLinkClassNames: identity,
    moreLinkContent: identity,
    moreLinkDidMount: identity,
    moreLinkWillUnmount: identity,
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
var BASE_OPTION_DEFAULTS = {
    eventDisplay: 'auto',
    defaultRangeSeparator: ' - ',
    titleRangeSeparator: ' \u2013 ',
    defaultTimedEventDuration: '01:00:00',
    defaultAllDayEventDuration: { day: 1 },
    forceEventDuration: false,
    nextDayThreshold: '00:00:00',
    dayHeaders: true,
    initialView: '',
    aspectRatio: 1.35,
    headerToolbar: {
        start: 'title',
        center: '',
        end: 'today prev,next',
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: 'local',
    editable: false,
    nowIndicator: false,
    scrollTime: '06:00:00',
    scrollTimeReset: true,
    slotMinTime: '00:00:00',
    slotMaxTime: '24:00:00',
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timeZoneParam: 'timeZone',
    timeZone: 'local',
    locales: [],
    locale: '',
    themeSystem: 'standard',
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: '*',
    eventOrder: 'start,-duration,allDay,title',
    dayPopoverFormat: { month: 'long', day: 'numeric', year: 'numeric' },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
};
// calendar listeners
// ------------------
var CALENDAR_LISTENER_REFINERS = {
    datesSet: identity,
    eventsSet: identity,
    eventAdd: identity,
    eventChange: identity,
    eventRemove: identity,
    windowResize: identity,
    eventClick: identity,
    eventMouseEnter: identity,
    eventMouseLeave: identity,
    select: identity,
    unselect: identity,
    loading: identity,
    // internal
    _unmount: identity,
    _beforeprint: identity,
    _afterprint: identity,
    _noEventDrop: identity,
    _noEventResize: identity,
    _resize: identity,
    _scrollRequest: identity,
};
// calendar-specific options
// -------------------------
var CALENDAR_OPTION_REFINERS = {
    buttonText: identity,
    buttonHints: identity,
    views: identity,
    plugins: identity,
    initialEvents: identity,
    events: identity,
    eventSources: identity,
};
var COMPLEX_OPTION_COMPARATORS = {
    headerToolbar: isBoolComplexEqual,
    footerToolbar: isBoolComplexEqual,
    buttonText: isBoolComplexEqual,
    buttonHints: isBoolComplexEqual,
    buttonIcons: isBoolComplexEqual,
};
function isBoolComplexEqual(a, b) {
    if (typeof a === 'object' && typeof b === 'object' && a && b) { // both non-null objects
        return isPropsEqual(a, b);
    }
    return a === b;
}
// view-specific options
// ---------------------
var VIEW_OPTION_REFINERS = {
    type: String,
    component: identity,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: identity,
    usesMinMaxTime: Boolean,
    classNames: identity,
    content: identity,
    didMount: identity,
    willUnmount: identity,
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function mergeRawOptions(optionSets) {
    return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
}
function refineProps(input, refiners) {
    var refined = {};
    var extra = {};
    for (var propName in refiners) {
        if (propName in input) {
            refined[propName] = refiners[propName](input[propName]);
        }
    }
    for (var propName in input) {
        if (!(propName in refiners)) {
            extra[propName] = input[propName];
        }
    }
    return { refined: refined, extra: extra };
}
function identity(raw) {
    return raw;
}

function parseEvents(rawEvents, eventSource, context, allowOpenRange) {
    var eventStore = createEmptyEventStore();
    var eventRefiners = buildEventRefiners(context);
    for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
        var rawEvent = rawEvents_1[_i];
        var tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners);
        if (tuple) {
            eventTupleToStore(tuple, eventStore);
        }
    }
    return eventStore;
}
function eventTupleToStore(tuple, eventStore) {
    if (eventStore === void 0) { eventStore = createEmptyEventStore(); }
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) {
        eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    }
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function getRelevantEvents(eventStore, instanceId) {
    var instance = eventStore.instances[instanceId];
    if (instance) {
        var def_1 = eventStore.defs[instance.defId];
        // get events/instances with same group
        var newStore = filterEventStoreDefs(eventStore, function (lookDef) { return isEventDefsGrouped(def_1, lookDef); });
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def_1.defId] = def_1;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return createEmptyEventStore();
}
function isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function createEmptyEventStore() {
    return { defs: {}, instances: {} };
}
function mergeEventStores(store0, store1) {
    return {
        defs: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, store0.defs), store1.defs),
        instances: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, store0.instances), store1.instances),
    };
}
function filterEventStoreDefs(eventStore, filterFunc) {
    var defs = filterHash(eventStore.defs, filterFunc);
    var instances = filterHash(eventStore.instances, function (instance) { return (defs[instance.defId] // still exists?
    ); });
    return { defs: defs, instances: instances };
}
function excludeSubEventStore(master, sub) {
    var defs = master.defs, instances = master.instances;
    var filteredDefs = {};
    var filteredInstances = {};
    for (var defId in defs) {
        if (!sub.defs[defId]) { // not explicitly excluded
            filteredDefs[defId] = defs[defId];
        }
    }
    for (var instanceId in instances) {
        if (!sub.instances[instanceId] && // not explicitly excluded
            filteredDefs[instances[instanceId].defId] // def wasn't filtered away
        ) {
            filteredInstances[instanceId] = instances[instanceId];
        }
    }
    return {
        defs: filteredDefs,
        instances: filteredInstances,
    };
}

function normalizeConstraint(input, context) {
    if (Array.isArray(input)) {
        return parseEvents(input, null, context, true); // allowOpenRange=true
    }
    if (typeof input === 'object' && input) { // non-null object
        return parseEvents([input], null, context, true); // allowOpenRange=true
    }
    if (input != null) {
        return String(input);
    }
    return null;
}

function parseClassNames(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (typeof raw === 'string') {
        return raw.split(/\s+/);
    }
    return [];
}

// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
var EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: identity,
    overlap: identity,
    allow: identity,
    className: parseClassNames,
    classNames: parseClassNames,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String,
};
var EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: '',
    borderColor: '',
    textColor: '',
    classNames: [],
};
function createEventUi(refined, context) {
    var constraint = normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [constraint] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [refined.allow] : [],
        backgroundColor: refined.backgroundColor || refined.color || '',
        borderColor: refined.borderColor || refined.color || '',
        textColor: refined.textColor || '',
        classNames: (refined.className || []).concat(refined.classNames || []), // join singular and plural
    };
}
// TODO: prevent against problems with <2 args!
function combineEventUis(uis) {
    return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
}
function combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames),
    };
}

var EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean,
};
var EVENT_DATE_REFINERS = {
    start: identity,
    end: identity,
    date: identity,
    allDay: Boolean,
};
var EVENT_REFINERS = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), { extendedProps: identity });
function parseEvent(raw, eventSource, context, allowOpenRange, refiners) {
    if (refiners === void 0) { refiners = buildEventRefiners(context); }
    var _a = refineEventDef(raw, context, refiners), refined = _a.refined, extra = _a.extra;
    var defaultAllDay = computeIsDefaultAllDay(eventSource, context);
    var recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration,
        };
        return { def: def, instance: null };
    }
    var singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context);
        var instance = createEventInstance(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        return { def: def, instance: instance };
    }
    return null;
}
function refineEventDef(raw, context, refiners) {
    if (refiners === void 0) { refiners = buildEventRefiners(context); }
    return refineProps(raw, refiners);
}
function buildEventRefiners(context) {
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/
function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context) {
    var def = {
        title: refined.title || '',
        groupId: refined.groupId || '',
        publicId: refined.id || '',
        url: refined.url || '',
        recurringDef: null,
        defId: guid(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: createEventUi(refined, context),
        extendedProps: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, (refined.extendedProps || {})), extra),
    };
    for (var _i = 0, _a = context.pluginHooks.eventDefMemberAdders; _i < _a.length; _i++) {
        var memberAdder = _a[_i];
        node_modules_tslib_tslib_es6_assign(def, memberAdder(refined));
    }
    // help out EventApi from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    var allDay = refined.allDay;
    var startMeta;
    var startMarker = null;
    var hasEnd = false;
    var endMeta;
    var endMarker = null;
    var startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) {
        startMarker = startMeta.marker;
    }
    else if (!allowOpenRange) {
        return null;
    }
    if (refined.end != null) {
        endMeta = context.dateEnv.createMarkerMeta(refined.end);
    }
    if (allDay == null) {
        if (defaultAllDay != null) {
            allDay = defaultAllDay;
        }
        else {
            // fall back to the date props LAST
            allDay = (!startMeta || startMeta.isTimeUnspecified) &&
                (!endMeta || endMeta.isTimeUnspecified);
        }
    }
    if (allDay && startMarker) {
        startMarker = startOfDay(startMarker);
    }
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) {
            endMarker = startOfDay(endMarker);
        }
        if (startMarker && endMarker <= startMarker) {
            endMarker = null;
        }
    }
    if (endMarker) {
        hasEnd = true;
    }
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ?
            context.options.defaultAllDayEventDuration :
            context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: { start: startMarker, end: endMarker },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null,
    };
}
function computeIsDefaultAllDay(eventSource, context) {
    var res = null;
    if (eventSource) {
        res = eventSource.defaultAllDay;
    }
    if (res == null) {
        res = context.options.defaultAllDay;
    }
    return res;
}

/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/
// given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function computeAlignedDayRange(timedRange) {
    var dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
    var start = startOfDay(timedRange.start);
    var end = addDays(start, dayCnt);
    return { start: start, end: end };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function computeVisibleDayRange(timedRange, nextDayThreshold) {
    if (nextDayThreshold === void 0) { nextDayThreshold = createDuration(0); }
    var startDay = null;
    var endDay = null;
    if (timedRange.end) {
        endDay = startOfDay(timedRange.end);
        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) {
            endDay = addDays(endDay, 1);
        }
    }
    if (timedRange.start) {
        startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) {
            endDay = addDays(startDay, 1);
        }
    }
    return { start: startDay, end: endDay };
}
// spans from one day into another?
function isMultiDayRange(range) {
    var visibleRange = computeVisibleDayRange(range);
    return diffDays(visibleRange.start, visibleRange.end) > 1;
}
function diffDates(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === 'year') {
        return createDuration(dateEnv.diffWholeYears(date0, date1), 'year');
    }
    if (largeUnit === 'month') {
        return createDuration(dateEnv.diffWholeMonths(date0, date1), 'month');
    }
    return diffDayAndTime(date0, date1); // returns a duration
}

function parseRange(input, dateEnv) {
    var start = null;
    var end = null;
    if (input.start) {
        start = dateEnv.createMarker(input.start);
    }
    if (input.end) {
        end = dateEnv.createMarker(input.end);
    }
    if (!start && !end) {
        return null;
    }
    if (start && end && end < start) {
        return null;
    }
    return { start: start, end: end };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function invertRanges(ranges, constraintRange) {
    var invertedRanges = [];
    var start = constraintRange.start; // the end of the previous range. the start of the new range
    var i;
    var dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort(compareRanges);
    for (i = 0; i < ranges.length; i += 1) {
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) { // compare millisecond time (skip any ambig logic)
            invertedRanges.push({ start: start, end: dateRange.start });
        }
        if (dateRange.end > start) {
            start = dateRange.end;
        }
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) { // compare millisecond time (skip any ambig logic)
        invertedRanges.push({ start: start, end: constraintRange.end });
    }
    return invertedRanges;
}
function compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function intersectRanges(range0, range1) {
    var start = range0.start, end = range0.end;
    var newRange = null;
    if (range1.start !== null) {
        if (start === null) {
            start = range1.start;
        }
        else {
            start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
        }
    }
    if (range1.end != null) {
        if (end === null) {
            end = range1.end;
        }
        else {
            end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
        }
    }
    if (start === null || end === null || start < end) {
        newRange = { start: start, end: end };
    }
    return newRange;
}
function rangesEqual(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) &&
        (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function rangesIntersect(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) &&
        (range0.start === null || range1.end === null || range0.start < range1.end);
}
function rangeContainsRange(outerRange, innerRange) {
    return (outerRange.start === null || (innerRange.start !== null && innerRange.start >= outerRange.start)) &&
        (outerRange.end === null || (innerRange.end !== null && innerRange.end <= outerRange.end));
}
function rangeContainsMarker(range, date) {
    return (range.start === null || date >= range.start) &&
        (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) {
        return range.start;
    }
    if (range.end != null && date >= range.end) {
        return new Date(range.end.valueOf() - 1);
    }
    return date;
}

/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/
function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    var inverseBgByGroupId = {};
    var inverseBgByDefId = {};
    var defByGroupId = {};
    var bgRanges = [];
    var fgRanges = [];
    var eventUis = compileEventUis(eventStore.defs, eventUiBases);
    for (var defId in eventStore.defs) {
        var def = eventStore.defs[defId];
        var ui = eventUis[def.defId];
        if (ui.display === 'inverse-background') {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) {
                    defByGroupId[def.groupId] = def;
                }
            }
            else {
                inverseBgByDefId[defId] = [];
            }
        }
    }
    for (var instanceId in eventStore.instances) {
        var instance = eventStore.instances[instanceId];
        var def = eventStore.defs[instance.defId];
        var ui = eventUis[def.defId];
        var origRange = instance.range;
        var normalRange = (!def.allDay && nextDayThreshold) ?
            computeVisibleDayRange(origRange, nextDayThreshold) :
            origRange;
        var slicedRange = intersectRanges(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === 'inverse-background') {
                if (def.groupId) {
                    inverseBgByGroupId[def.groupId].push(slicedRange);
                }
                else {
                    inverseBgByDefId[instance.defId].push(slicedRange);
                }
            }
            else if (ui.display !== 'none') {
                (ui.display === 'background' ? bgRanges : fgRanges).push({
                    def: def,
                    ui: ui,
                    instance: instance,
                    range: slicedRange,
                    isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                    isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf(),
                });
            }
        }
    }
    for (var groupId in inverseBgByGroupId) { // BY GROUP
        var ranges = inverseBgByGroupId[groupId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for (var _i = 0, invertedRanges_1 = invertedRanges; _i < invertedRanges_1.length; _i++) {
            var invertedRange = invertedRanges_1[_i];
            var def = defByGroupId[groupId];
            var ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false,
            });
        }
    }
    for (var defId in inverseBgByDefId) {
        var ranges = inverseBgByDefId[defId];
        var invertedRanges = invertRanges(ranges, framingRange);
        for (var _a = 0, invertedRanges_2 = invertedRanges; _a < invertedRanges_2.length; _a++) {
            var invertedRange = invertedRanges_2[_a];
            bgRanges.push({
                def: eventStore.defs[defId],
                ui: eventUis[defId],
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false,
            });
        }
    }
    return { bg: bgRanges, fg: fgRanges };
}
function hasBgRendering(def) {
    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
}
function setElSeg(el, seg) {
    el.fcSeg = seg;
}
function getElSeg(el) {
    return el.fcSeg ||
        el.parentNode.fcSeg || // for the harness
        null;
}
// event ui computation
function compileEventUis(eventDefs, eventUiBases) {
    return mapHash(eventDefs, function (eventDef) { return compileEventUi(eventDef, eventUiBases); });
}
function compileEventUi(eventDef, eventUiBases) {
    var uis = [];
    if (eventUiBases['']) {
        uis.push(eventUiBases['']);
    }
    if (eventUiBases[eventDef.defId]) {
        uis.push(eventUiBases[eventDef.defId]);
    }
    uis.push(eventDef.ui);
    return combineEventUis(uis);
}
function sortEventSegs(segs, eventOrderSpecs) {
    var objs = segs.map(buildSegCompareObj);
    objs.sort(function (obj0, obj1) { return compareByFieldSpecs(obj0, obj1, eventOrderSpecs); });
    return objs.map(function (c) { return c._seg; });
}
// returns a object with all primitive props that can be compared
function buildSegCompareObj(seg) {
    var eventRange = seg.eventRange;
    var eventDef = eventRange.def;
    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    var end = range.end ? range.end.valueOf() : 0; // "
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventDef.extendedProps), eventDef), { id: eventDef.publicId, start: start,
        end: end, duration: end - start, allDay: Number(eventDef.allDay), _seg: seg });
}
function computeSegDraggable(seg, context) {
    var pluginHooks = context.pluginHooks;
    var transformers = pluginHooks.isDraggableTransformers;
    var _a = seg.eventRange, def = _a.def, ui = _a.ui;
    var val = ui.startEditable;
    for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
        var transformer = transformers_1[_i];
        val = transformer(val, def, ui, context);
    }
    return val;
}
function computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, // defaults to true
defaultDisplayEventEnd, // defaults to true
startOverride, endOverride) {
    var dateEnv = context.dateEnv, options = context.options;
    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
    var eventDef = seg.eventRange.def;
    var eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) {
        displayEventTime = defaultDisplayEventTime !== false;
    }
    if (displayEventEnd == null) {
        displayEventEnd = defaultDisplayEventEnd !== false;
    }
    var wholeEventStart = eventInstance.range.start;
    var wholeEventEnd = eventInstance.range.end;
    var segStart = startOverride || seg.start || seg.eventRange.range.start;
    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
    var isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
    var isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) {
            return dateEnv.formatRange(segStart, segEnd, timeFormat, {
                forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
                forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo,
            });
        }
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo, // nooooo, same
        });
    }
    return '';
}
function getSegMeta(seg, todayRange, nowDate) {
    var segRange = seg.eventRange.range;
    return {
        isPast: segRange.end < (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && rangeContainsMarker(todayRange, segRange.start),
    };
}
function getEventClassNames(props) {
    var classNames = ['fc-event'];
    if (props.isMirror) {
        classNames.push('fc-event-mirror');
    }
    if (props.isDraggable) {
        classNames.push('fc-event-draggable');
    }
    if (props.isStartResizable || props.isEndResizable) {
        classNames.push('fc-event-resizable');
    }
    if (props.isDragging) {
        classNames.push('fc-event-dragging');
    }
    if (props.isResizing) {
        classNames.push('fc-event-resizing');
    }
    if (props.isSelected) {
        classNames.push('fc-event-selected');
    }
    if (props.isStart) {
        classNames.push('fc-event-start');
    }
    if (props.isEnd) {
        classNames.push('fc-event-end');
    }
    if (props.isPast) {
        classNames.push('fc-event-past');
    }
    if (props.isToday) {
        classNames.push('fc-event-today');
    }
    if (props.isFuture) {
        classNames.push('fc-event-future');
    }
    return classNames;
}
function buildEventRangeKey(eventRange) {
    return eventRange.instance
        ? eventRange.instance.instanceId
        : eventRange.def.defId + ":" + eventRange.range.start.toISOString();
    // inverse-background events don't have specific instances. TODO: better solution
}
function getSegAnchorAttrs(seg, context) {
    var _a = seg.eventRange, def = _a.def, instance = _a.instance;
    var url = def.url;
    if (url) {
        return { href: url };
    }
    var emitter = context.emitter, options = context.options;
    var eventInteractive = options.eventInteractive;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) {
            eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
        }
    }
    // mock what happens in EventClicking
    if (eventInteractive) {
        // only attach keyboard-related handlers because click handler is already done in EventClicking
        return createAriaKeyboardAttrs(function (ev) {
            emitter.trigger('eventClick', {
                el: ev.target,
                event: new EventApi(context, def, instance),
                jsEvent: ev,
                view: context.viewApi,
            });
        });
    }
    return {};
}

var STANDARD_PROPS = {
    start: identity,
    end: identity,
    allDay: Boolean,
};
function parseDateSpan(raw, dateEnv, defaultDuration) {
    var span = parseOpenDateSpan(raw, dateEnv);
    var range = span.range;
    if (!range.start) {
        return null;
    }
    if (!range.end) {
        if (defaultDuration == null) {
            return null;
        }
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/
function parseOpenDateSpan(raw, dateEnv) {
    var _a = refineProps(raw, STANDARD_PROPS), standardProps = _a.refined, extra = _a.extra;
    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    var allDay = standardProps.allDay;
    if (allDay == null) {
        allDay = (startMeta && startMeta.isTimeUnspecified) &&
            (!endMeta || endMeta.isTimeUnspecified);
    }
    return node_modules_tslib_tslib_es6_assign({ range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null,
        }, allDay: allDay }, extra);
}
function isDateSpansEqual(span0, span1) {
    return rangesEqual(span0.range, span1.range) &&
        span0.allDay === span1.allDay &&
        isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function isSpanPropsEqual(span0, span1) {
    for (var propName in span1) {
        if (propName !== 'range' && propName !== 'allDay') {
            if (span0[propName] !== span1[propName]) {
                return false;
            }
        }
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for (var propName in span0) {
        if (!(propName in span1)) {
            return false;
        }
    }
    return true;
}
function buildDateSpanApi(span, dateEnv) {
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, buildRangeApi(span.range, dateEnv, span.allDay)), { allDay: span.allDay });
}
function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, buildRangeApi(range, dateEnv, omitTime)), { timeZone: dateEnv.timeZone });
}
function buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, { omitTime: omitTime }),
        endStr: dateEnv.formatIso(range.end, { omitTime: omitTime }),
    };
}
function fabricateEventRange(dateSpan, eventUiBases, context) {
    var res = refineEventDef({ editable: false }, context);
    var def = parseEventDef(res.refined, res.extra, '', // sourceId
    dateSpan.allDay, true, // hasEnd
    context);
    return {
        def: def,
        ui: compileEventUi(def, eventUiBases),
        instance: createEventInstance(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true,
    };
}

function triggerDateSelect(selection, pev, context) {
    context.emitter.trigger('select', node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, buildDateSpanApiWithContext(selection, context)), { jsEvent: pev ? pev.origEvent : null, view: context.viewApi || context.calendarApi.view }));
}
function triggerDateUnselect(pev, context) {
    context.emitter.trigger('unselect', {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view,
    });
}
function buildDateSpanApiWithContext(dateSpan, context) {
    var props = {};
    for (var _i = 0, _a = context.pluginHooks.dateSpanTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        node_modules_tslib_tslib_es6_assign(props, transform(dateSpan, context));
    }
    node_modules_tslib_tslib_es6_assign(props, buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function getDefaultEventEnd(allDay, marker, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var end = marker;
    if (allDay) {
        end = startOfDay(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    }
    else {
        end = dateEnv.add(end, options.defaultTimedEventDuration);
    }
    return end;
}

// applies the mutation to ALL defs/instances within the event store
function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
    var eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
    var dest = createEmptyEventStore();
    for (var defId in eventStore.defs) {
        var def = eventStore.defs[defId];
        dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for (var instanceId in eventStore.instances) {
        var instance = eventStore.instances[instanceId];
        var def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    var standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null &&
        eventConfig.durationEditable &&
        (mutation.startDelta || mutation.endDelta)) {
        standardProps.hasEnd = true; // TODO: is this mutation okay?
    }
    var copy = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventDef), standardProps), { ui: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventDef.ui), standardProps.ui) });
    if (mutation.extendedProps) {
        copy.extendedProps = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, copy.extendedProps), mutation.extendedProps);
    }
    for (var _i = 0, _a = context.pluginHooks.eventDefMutationAppliers; _i < _a.length; _i++) {
        var applier = _a[_i];
        applier(copy, mutation, context);
    }
    if (!copy.hasEnd && context.options.forceEventDuration) {
        copy.hasEnd = true;
    }
    return copy;
}
function applyMutationToEventInstance(eventInstance, eventDef, // must first be modified by applyMutationToEventDef
eventConfig, mutation, context) {
    var dateEnv = context.dateEnv;
    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    var copy = node_modules_tslib_tslib_es6_assign({}, eventInstance);
    if (forceAllDay) {
        copy.range = computeAlignedDayRange(copy.range);
    }
    if (mutation.datesDelta && eventConfig.startEditable) {
        copy.range = {
            start: dateEnv.add(copy.range.start, mutation.datesDelta),
            end: dateEnv.add(copy.range.end, mutation.datesDelta),
        };
    }
    if (mutation.startDelta && eventConfig.durationEditable) {
        copy.range = {
            start: dateEnv.add(copy.range.start, mutation.startDelta),
            end: copy.range.end,
        };
    }
    if (mutation.endDelta && eventConfig.durationEditable) {
        copy.range = {
            start: copy.range.start,
            end: dateEnv.add(copy.range.end, mutation.endDelta),
        };
    }
    if (clearEnd) {
        copy.range = {
            start: copy.range.start,
            end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context),
        };
    }
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) {
        copy.range = {
            start: startOfDay(copy.range.start),
            end: startOfDay(copy.range.end),
        };
    }
    // handle invalid durations
    if (copy.range.end < copy.range.start) {
        copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
    }
    return copy;
}

// no public types yet. when there are, export from:
// import {} from './api-type-deps'
var ViewApi = /** @class */ (function () {
    function ViewApi(type, getCurrentData, dateEnv) {
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
    Object.defineProperty(ViewApi.prototype, "calendar", {
        get: function () {
            return this.getCurrentData().calendarApi;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "title", {
        get: function () {
            return this.getCurrentData().viewTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeStart", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "activeEnd", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentStart", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewApi.prototype, "currentEnd", {
        get: function () {
            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
        },
        enumerable: false,
        configurable: true
    });
    ViewApi.prototype.getOption = function (name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    };
    return ViewApi;
}());

var EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: identity,
    eventDataTransform: identity,
    // for any network-related sources
    success: identity,
    failure: identity,
};
function parseEventSource(raw, context, refiners) {
    if (refiners === void 0) { refiners = buildEventSourceRefiners(context); }
    var rawObj;
    if (typeof raw === 'string') {
        rawObj = { url: raw };
    }
    else if (typeof raw === 'function' || Array.isArray(raw)) {
        rawObj = { events: raw };
    }
    else if (typeof raw === 'object' && raw) { // not null
        rawObj = raw;
    }
    if (rawObj) {
        var _a = refineProps(rawObj, refiners), refined = _a.refined, extra = _a.extra;
        var metaRes = buildEventSourceMeta(refined, context);
        if (metaRes) {
            return {
                _raw: raw,
                isFetching: false,
                latestFetchId: '',
                fetchRange: null,
                defaultAllDay: refined.defaultAllDay,
                eventDataTransform: refined.eventDataTransform,
                success: refined.success,
                failure: refined.failure,
                publicId: refined.id || '',
                sourceId: guid(),
                sourceDefId: metaRes.sourceDefId,
                meta: metaRes.meta,
                ui: createEventUi(refined, context),
                extendedProps: extra,
            };
        }
    }
    return null;
}
function buildEventSourceRefiners(context) {
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function buildEventSourceMeta(raw, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    for (var i = defs.length - 1; i >= 0; i -= 1) { // later-added plugins take precedence
        var def = defs[i];
        var meta = def.parseMeta(raw);
        if (meta) {
            return { sourceDefId: i, meta: meta };
        }
    }
    return null;
}

function reduceCurrentDate(currentDate, action) {
    switch (action.type) {
        case 'CHANGE_DATE':
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function getInitialDate(options, dateEnv) {
    var initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) {
        return dateEnv.createMarker(initialDateInput);
    }
    return getNow(options.now, dateEnv); // getNow already returns unzoned
}
function getNow(nowInput, dateEnv) {
    if (typeof nowInput === 'function') {
        nowInput = nowInput();
    }
    if (nowInput == null) {
        return dateEnv.createNowMarker();
    }
    return dateEnv.createMarker(nowInput);
}

var CalendarApi = /** @class */ (function () {
    function CalendarApi() {
    }
    CalendarApi.prototype.getCurrentData = function () {
        return this.currentDataManager.getCurrentData();
    };
    CalendarApi.prototype.dispatch = function (action) {
        return this.currentDataManager.dispatch(action);
    };
    Object.defineProperty(CalendarApi.prototype, "view", {
        get: function () { return this.getCurrentData().viewApi; } // for public API
        ,
        enumerable: false,
        configurable: true
    });
    CalendarApi.prototype.batchRendering = function (callback) {
        callback();
    };
    CalendarApi.prototype.updateSize = function () {
        this.trigger('_resize', true);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.setOption = function (name, val) {
        this.dispatch({
            type: 'SET_OPTION',
            optionName: name,
            rawOptionValue: val,
        });
    };
    CalendarApi.prototype.getOption = function (name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    };
    CalendarApi.prototype.getAvailableLocaleCodes = function () {
        return Object.keys(this.getCurrentData().availableRawLocales);
    };
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.on = function (handlerName, handler) {
        var currentDataManager = this.currentDataManager;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) {
            currentDataManager.emitter.on(handlerName, handler);
        }
        else {
            console.warn("Unknown listener name '" + handlerName + "'");
        }
    };
    CalendarApi.prototype.off = function (handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    };
    // not meant for public use
    CalendarApi.prototype.trigger = function (handlerName) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (_a = this.currentDataManager.emitter).trigger.apply(_a, tslib_tslib_es6_spreadArray([handlerName], args));
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.changeView = function (viewType, dateOrRange) {
        var _this = this;
        this.batchRendering(function () {
            _this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) { // a range
                    _this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                    });
                    _this.dispatch({
                        type: 'SET_OPTION',
                        optionName: 'visibleRange',
                        rawOptionValue: dateOrRange,
                    });
                }
                else {
                    var dateEnv = _this.getCurrentData().dateEnv;
                    _this.dispatch({
                        type: 'CHANGE_VIEW_TYPE',
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange),
                    });
                }
            }
            else {
                _this.dispatch({
                    type: 'CHANGE_VIEW_TYPE',
                    viewType: viewType,
                });
            }
        });
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    CalendarApi.prototype.zoomTo = function (dateMarker, viewType) {
        var state = this.getCurrentData();
        var spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) {
            this.dispatch({
                type: 'CHANGE_VIEW_TYPE',
                viewType: spec.type,
                dateMarker: dateMarker,
            });
        }
        else {
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: dateMarker,
            });
        }
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    CalendarApi.prototype.getUnitViewSpec = function (unit) {
        var _a = this.getCurrentData(), viewSpecs = _a.viewSpecs, toolbarConfig = _a.toolbarConfig;
        var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        var i;
        var spec;
        for (var viewType in viewSpecs) {
            viewTypes.push(viewType);
        }
        for (i = 0; i < viewTypes.length; i += 1) {
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) {
                    return spec;
                }
            }
        }
        return null;
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.prev = function () {
        this.unselect();
        this.dispatch({ type: 'PREV' });
    };
    CalendarApi.prototype.next = function () {
        this.unselect();
        this.dispatch({ type: 'NEXT' });
    };
    CalendarApi.prototype.prevYear = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, -1),
        });
    };
    CalendarApi.prototype.nextYear = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.addYears(state.currentDate, 1),
        });
    };
    CalendarApi.prototype.today = function () {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: getNow(state.calendarOptions.now, state.dateEnv),
        });
    };
    CalendarApi.prototype.gotoDate = function (zonedDateInput) {
        var state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: 'CHANGE_DATE',
            dateMarker: state.dateEnv.createMarker(zonedDateInput),
        });
    };
    CalendarApi.prototype.incrementDate = function (deltaInput) {
        var state = this.getCurrentData();
        var delta = createDuration(deltaInput);
        if (delta) { // else, warn about invalid input?
            this.unselect();
            this.dispatch({
                type: 'CHANGE_DATE',
                dateMarker: state.dateEnv.add(state.currentDate, delta),
            });
        }
    };
    // for external API
    CalendarApi.prototype.getDate = function () {
        var state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    };
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.formatDate = function (d, formatter) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
    };
    // `settings` is for formatter AND isEndExclusive
    CalendarApi.prototype.formatRange = function (d0, d1, settings) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
    };
    CalendarApi.prototype.formatIso = function (d, omitTime) {
        var dateEnv = this.getCurrentData().dateEnv;
        return dateEnv.formatIso(dateEnv.createMarker(d), { omitTime: omitTime });
    };
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    // NOTE: args were changed from v3
    CalendarApi.prototype.select = function (dateOrObj, endDate) {
        var selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) {
                selectionInput = dateOrObj;
            }
            else {
                selectionInput = {
                    start: dateOrObj,
                    end: null,
                };
            }
        }
        else {
            selectionInput = {
                start: dateOrObj,
                end: endDate,
            };
        }
        var state = this.getCurrentData();
        var selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({ days: 1 }));
        if (selection) { // throw parse error otherwise?
            this.dispatch({ type: 'SELECT_DATES', selection: selection });
            triggerDateSelect(selection, null, state);
        }
    };
    // public method
    CalendarApi.prototype.unselect = function (pev) {
        var state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({ type: 'UNSELECT_DATES' });
            triggerDateUnselect(pev, state);
        }
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.addEvent = function (eventInput, sourceInput) {
        if (eventInput instanceof EventApi) {
            var def = eventInput._def;
            var instance = eventInput._instance;
            var currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: 'ADD_EVENTS',
                    eventStore: eventTupleToStore({ def: def, instance: instance }), // TODO: better util for two args?
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        var state = this.getCurrentData();
        var eventSource;
        if (sourceInput instanceof EventSourceApi) {
            eventSource = sourceInput.internalEventSource;
        }
        else if (typeof sourceInput === 'boolean') {
            if (sourceInput) { // true. part of the first event source
                eventSource = hashValuesToArray(state.eventSources)[0];
            }
        }
        else if (sourceInput != null) { // an ID. accepts a number too
            var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn("Could not find an event source with ID \"" + sourceInput + "\""); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        var tuple = parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            var newEventApi = new EventApi(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: 'ADD_EVENTS',
                eventStore: eventTupleToStore(tuple),
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    };
    CalendarApi.prototype.triggerEventAdd = function (eventApi) {
        var _this = this;
        var emitter = this.getCurrentData().emitter;
        emitter.trigger('eventAdd', {
            event: eventApi,
            relatedEvents: [],
            revert: function () {
                _this.dispatch({
                    type: 'REMOVE_EVENTS',
                    eventStore: eventApiToStore(eventApi),
                });
            },
        });
    };
    // TODO: optimize
    CalendarApi.prototype.getEventById = function (id) {
        var state = this.getCurrentData();
        var _a = state.eventStore, defs = _a.defs, instances = _a.instances;
        id = String(id);
        for (var defId in defs) {
            var def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) {
                    return new EventApi(state, def, null);
                }
                for (var instanceId in instances) {
                    var instance = instances[instanceId];
                    if (instance.defId === def.defId) {
                        return new EventApi(state, def, instance);
                    }
                }
            }
        }
        return null;
    };
    CalendarApi.prototype.getEvents = function () {
        var currentData = this.getCurrentData();
        return buildEventApis(currentData.eventStore, currentData);
    };
    CalendarApi.prototype.removeAllEvents = function () {
        this.dispatch({ type: 'REMOVE_ALL_EVENTS' });
    };
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.getEventSources = function () {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        var sourceApis = [];
        for (var internalId in sourceHash) {
            sourceApis.push(new EventSourceApi(state, sourceHash[internalId]));
        }
        return sourceApis;
    };
    CalendarApi.prototype.getEventSourceById = function (id) {
        var state = this.getCurrentData();
        var sourceHash = state.eventSources;
        id = String(id);
        for (var sourceId in sourceHash) {
            if (sourceHash[sourceId].publicId === id) {
                return new EventSourceApi(state, sourceHash[sourceId]);
            }
        }
        return null;
    };
    CalendarApi.prototype.addEventSource = function (sourceInput) {
        var state = this.getCurrentData();
        if (sourceInput instanceof EventSourceApi) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) {
                this.dispatch({
                    type: 'ADD_EVENT_SOURCES',
                    sources: [sourceInput.internalEventSource],
                });
            }
            return sourceInput;
        }
        var eventSource = parseEventSource(sourceInput, state);
        if (eventSource) { // TODO: error otherwise?
            this.dispatch({ type: 'ADD_EVENT_SOURCES', sources: [eventSource] });
            return new EventSourceApi(state, eventSource);
        }
        return null;
    };
    CalendarApi.prototype.removeAllEventSources = function () {
        this.dispatch({ type: 'REMOVE_ALL_EVENT_SOURCES' });
    };
    CalendarApi.prototype.refetchEvents = function () {
        this.dispatch({ type: 'FETCH_EVENT_SOURCES', isRefetch: true });
    };
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    CalendarApi.prototype.scrollToTime = function (timeInput) {
        var time = createDuration(timeInput);
        if (time) {
            this.trigger('_scrollRequest', { time: time });
        }
    };
    return CalendarApi;
}());

var EventApi = /** @class */ (function () {
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    function EventApi(context, def, instance) {
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
    /*
    TODO: make event struct more responsible for this
    */
    EventApi.prototype.setProp = function (name, val) {
        var _a, _b;
        if (name in EVENT_DATE_REFINERS) {
            console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
            // TODO: make proper aliasing system?
        }
        else if (name === 'id') {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: { publicId: val }, // hardcoded internal name
            });
        }
        else if (name in EVENT_NON_DATE_REFINERS) {
            val = EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: (_a = {}, _a[name] = val, _a),
            });
        }
        else if (name in EVENT_UI_REFINERS) {
            var ui = EVENT_UI_REFINERS[name](val);
            if (name === 'color') {
                ui = { backgroundColor: val, borderColor: val };
            }
            else if (name === 'editable') {
                ui = { startEditable: val, durationEditable: val };
            }
            else {
                ui = (_b = {}, _b[name] = val, _b);
            }
            this.mutate({
                standardProps: { ui: ui },
            });
        }
        else {
            console.warn("Could not set prop '" + name + "'. Use setExtendedProp instead.");
        }
    };
    EventApi.prototype.setExtendedProp = function (name, val) {
        var _a;
        this.mutate({
            extendedProps: (_a = {}, _a[name] = val, _a),
        });
    };
    EventApi.prototype.setStart = function (startInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var start = dateEnv.createMarker(startInput);
        if (start && this._instance) { // TODO: warning if parsed bad
            var instanceRange = this._instance.range;
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) {
                this.mutate({ datesDelta: startDelta });
            }
            else {
                this.mutate({ startDelta: startDelta });
            }
        }
    };
    EventApi.prototype.setEnd = function (endInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) {
                return; // TODO: warning if parsed bad
            }
        }
        if (this._instance) {
            if (end) {
                var endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({ endDelta: endDelta });
            }
            else {
                this.mutate({ standardProps: { hasEnd: false } });
            }
        }
    };
    EventApi.prototype.setDates = function (startInput, endInput, options) {
        if (options === void 0) { options = {}; }
        var dateEnv = this._context.dateEnv;
        var standardProps = { allDay: options.allDay };
        var start = dateEnv.createMarker(startInput);
        var end;
        if (!start) {
            return; // TODO: warning if parsed bad
        }
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) { // TODO: warning if parsed bad
                return;
            }
        }
        if (this._instance) {
            var instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) {
                instanceRange = computeAlignedDayRange(instanceRange);
            }
            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                var endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);
                if (durationsEqual(startDelta, endDelta)) {
                    this.mutate({ datesDelta: startDelta, standardProps: standardProps });
                }
                else {
                    this.mutate({ startDelta: startDelta, endDelta: endDelta, standardProps: standardProps });
                }
            }
            else { // means "clear the end"
                standardProps.hasEnd = false;
                this.mutate({ datesDelta: startDelta, standardProps: standardProps });
            }
        }
    };
    EventApi.prototype.moveStart = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ startDelta: delta });
        }
    };
    EventApi.prototype.moveEnd = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ endDelta: delta });
        }
    };
    EventApi.prototype.moveDates = function (deltaInput) {
        var delta = createDuration(deltaInput);
        if (delta) { // TODO: warning if parsed bad
            this.mutate({ datesDelta: delta });
        }
    };
    EventApi.prototype.setAllDay = function (allDay, options) {
        if (options === void 0) { options = {}; }
        var standardProps = { allDay: allDay };
        var maintainDuration = options.maintainDuration;
        if (maintainDuration == null) {
            maintainDuration = this._context.options.allDayMaintainDuration;
        }
        if (this._def.allDay !== allDay) {
            standardProps.hasEnd = maintainDuration;
        }
        this.mutate({ standardProps: standardProps });
    };
    EventApi.prototype.formatRange = function (formatInput) {
        var dateEnv = this._context.dateEnv;
        var instance = this._instance;
        var formatter = createFormatter(formatInput);
        if (this._def.hasEnd) {
            return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
                forcedStartTzo: instance.forcedStartTzo,
                forcedEndTzo: instance.forcedEndTzo,
            });
        }
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo,
        });
    };
    EventApi.prototype.mutate = function (mutation) {
        var instance = this._instance;
        if (instance) {
            var def = this._def;
            var context_1 = this._context;
            var eventStore_1 = context_1.getCurrentData().eventStore;
            var relevantEvents = getRelevantEvents(eventStore_1, instance.instanceId);
            var eventConfigBase = {
                '': {
                    display: '',
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: '',
                    borderColor: '',
                    textColor: '',
                    classNames: [],
                },
            };
            relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context_1);
            var oldEvent = new EventApi(context_1, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context_1.dispatch({
                type: 'MERGE_EVENTS',
                eventStore: relevantEvents,
            });
            context_1.emitter.trigger('eventChange', {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: buildEventApis(relevantEvents, context_1, instance),
                revert: function () {
                    context_1.dispatch({
                        type: 'RESET_EVENTS',
                        eventStore: eventStore_1,
                    });
                },
            });
        }
    };
    EventApi.prototype.remove = function () {
        var context = this._context;
        var asStore = eventApiToStore(this);
        context.dispatch({
            type: 'REMOVE_EVENTS',
            eventStore: asStore,
        });
        context.emitter.trigger('eventRemove', {
            event: this,
            relatedEvents: [],
            revert: function () {
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: asStore,
                });
            },
        });
    };
    Object.defineProperty(EventApi.prototype, "source", {
        get: function () {
            var sourceId = this._def.sourceId;
            if (sourceId) {
                return new EventSourceApi(this._context, this._context.getCurrentData().eventSources[sourceId]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "start", {
        get: function () {
            return this._instance ?
                this._context.dateEnv.toDate(this._instance.range.start) :
                null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "end", {
        get: function () {
            return (this._instance && this._def.hasEnd) ?
                this._context.dateEnv.toDate(this._instance.range.end) :
                null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startStr", {
        get: function () {
            var instance = this._instance;
            if (instance) {
                return this._context.dateEnv.formatIso(instance.range.start, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedStartTzo,
                });
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "endStr", {
        get: function () {
            var instance = this._instance;
            if (instance && this._def.hasEnd) {
                return this._context.dateEnv.formatIso(instance.range.end, {
                    omitTime: this._def.allDay,
                    forcedTzo: instance.forcedEndTzo,
                });
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "id", {
        // computable props that all access the def
        // TODO: find a TypeScript-compatible way to do this at scale
        get: function () { return this._def.publicId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "groupId", {
        get: function () { return this._def.groupId; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allDay", {
        get: function () { return this._def.allDay; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "title", {
        get: function () { return this._def.title; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "url", {
        get: function () { return this._def.url; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "display", {
        get: function () { return this._def.ui.display || 'auto'; } // bad. just normalize the type earlier
        ,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "startEditable", {
        get: function () { return this._def.ui.startEditable; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "durationEditable", {
        get: function () { return this._def.ui.durationEditable; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "constraint", {
        get: function () { return this._def.ui.constraints[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "overlap", {
        get: function () { return this._def.ui.overlap; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "allow", {
        get: function () { return this._def.ui.allows[0] || null; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "backgroundColor", {
        get: function () { return this._def.ui.backgroundColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "borderColor", {
        get: function () { return this._def.ui.borderColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "textColor", {
        get: function () { return this._def.ui.textColor; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "classNames", {
        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
        get: function () { return this._def.ui.classNames; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventApi.prototype, "extendedProps", {
        get: function () { return this._def.extendedProps; },
        enumerable: false,
        configurable: true
    });
    EventApi.prototype.toPlainObject = function (settings) {
        if (settings === void 0) { settings = {}; }
        var def = this._def;
        var ui = def.ui;
        var _a = this, startStr = _a.startStr, endStr = _a.endStr;
        var res = {};
        if (def.title) {
            res.title = def.title;
        }
        if (startStr) {
            res.start = startStr;
        }
        if (endStr) {
            res.end = endStr;
        }
        if (def.publicId) {
            res.id = def.publicId;
        }
        if (def.groupId) {
            res.groupId = def.groupId;
        }
        if (def.url) {
            res.url = def.url;
        }
        if (ui.display && ui.display !== 'auto') {
            res.display = ui.display;
        }
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
            res.color = ui.backgroundColor;
        }
        else {
            if (ui.backgroundColor) {
                res.backgroundColor = ui.backgroundColor;
            }
            if (ui.borderColor) {
                res.borderColor = ui.borderColor;
            }
        }
        if (ui.textColor) {
            res.textColor = ui.textColor;
        }
        if (ui.classNames.length) {
            res.classNames = ui.classNames;
        }
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) {
                node_modules_tslib_tslib_es6_assign(res, def.extendedProps);
            }
            else {
                res.extendedProps = def.extendedProps;
            }
        }
        return res;
    };
    EventApi.prototype.toJSON = function () {
        return this.toPlainObject();
    };
    return EventApi;
}());
function eventApiToStore(eventApi) {
    var _a, _b;
    var def = eventApi._def;
    var instance = eventApi._instance;
    return {
        defs: (_a = {}, _a[def.defId] = def, _a),
        instances: instance
            ? (_b = {}, _b[instance.instanceId] = instance, _b) : {},
    };
}
function buildEventApis(eventStore, context, excludeInstance) {
    var defs = eventStore.defs, instances = eventStore.instances;
    var eventApis = [];
    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
    for (var id in instances) {
        var instance = instances[id];
        var def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) {
            eventApis.push(new EventApi(context, def, instance));
        }
    }
    return eventApis;
}

var calendarSystemClassMap = {};
function registerCalendarSystem(name, theClass) {
    calendarSystemClassMap[name] = theClass;
}
function createCalendarSystem(name) {
    return new calendarSystemClassMap[name]();
}
var GregorianCalendarSystem = /** @class */ (function () {
    function GregorianCalendarSystem() {
    }
    GregorianCalendarSystem.prototype.getMarkerYear = function (d) {
        return d.getUTCFullYear();
    };
    GregorianCalendarSystem.prototype.getMarkerMonth = function (d) {
        return d.getUTCMonth();
    };
    GregorianCalendarSystem.prototype.getMarkerDay = function (d) {
        return d.getUTCDate();
    };
    GregorianCalendarSystem.prototype.arrayToMarker = function (arr) {
        return arrayToUtcDate(arr);
    };
    GregorianCalendarSystem.prototype.markerToArray = function (marker) {
        return dateToUtcArray(marker);
    };
    return GregorianCalendarSystem;
}());
registerCalendarSystem('gregory', GregorianCalendarSystem);

var ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function parse(str) {
    var m = ISO_RE.exec(str);
    if (m) {
        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0." + m[12]) * 1000 : 0));
        if (isValidDate(marker)) {
            var timeZoneOffset = null;
            if (m[13]) {
                timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 +
                    Number(m[18] || 0));
            }
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset,
            };
        }
    }
    return null;
}

var DateEnv = /** @class */ (function () {
    function DateEnv(settings) {
        var timeZone = this.timeZone = settings.timeZone;
        var isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
        if (settings.namedTimeZoneImpl && isNamedTimeZone) {
            this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        }
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === 'ISO') {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === 'number') {
            this.weekDow = settings.firstDay;
        }
        if (typeof settings.weekNumberCalculation === 'function') {
            this.weekNumberFunc = settings.weekNumberCalculation;
        }
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
    // Creating / Parsing
    DateEnv.prototype.createMarker = function (input) {
        var meta = this.createMarkerMeta(input);
        if (meta === null) {
            return null;
        }
        return meta.marker;
    };
    DateEnv.prototype.createNowMarker = function () {
        if (this.canComputeOffset) {
            return this.timestampToMarker(new Date().valueOf());
        }
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return arrayToUtcDate(dateToLocalArray(new Date()));
    };
    DateEnv.prototype.createMarkerMeta = function (input) {
        if (typeof input === 'string') {
            return this.parse(input);
        }
        var marker = null;
        if (typeof input === 'number') {
            marker = this.timestampToMarker(input);
        }
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) {
                marker = this.timestampToMarker(input);
            }
        }
        else if (Array.isArray(input)) {
            marker = arrayToUtcDate(input);
        }
        if (marker === null || !isValidDate(marker)) {
            return null;
        }
        return { marker: marker, isTimeUnspecified: false, forcedTzo: null };
    };
    DateEnv.prototype.parse = function (s) {
        var parts = parse(s);
        if (parts === null) {
            return null;
        }
        var marker = parts.marker;
        var forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) {
                marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60 * 1000);
            }
            else {
                forcedTzo = parts.timeZoneOffset;
            }
        }
        return { marker: marker, isTimeUnspecified: parts.isTimeUnspecified, forcedTzo: forcedTzo };
    };
    // Accessors
    DateEnv.prototype.getYear = function (marker) {
        return this.calendarSystem.getMarkerYear(marker);
    };
    DateEnv.prototype.getMonth = function (marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    };
    // Adding / Subtracting
    DateEnv.prototype.add = function (marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.subtract = function (marker, dur) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addYears = function (marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    DateEnv.prototype.addMonths = function (marker, n) {
        var a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    };
    // Diffing Whole Units
    DateEnv.prototype.diffWholeYears = function (m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) &&
            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) &&
            calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) {
            return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        }
        return null;
    };
    DateEnv.prototype.diffWholeMonths = function (m0, m1) {
        var calendarSystem = this.calendarSystem;
        if (timeAsMs(m0) === timeAsMs(m1) &&
            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) {
            return (calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0)) +
                (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        }
        return null;
    };
    // Range / Duration
    DateEnv.prototype.greatestWholeUnit = function (m0, m1) {
        var n = this.diffWholeYears(m0, m1);
        if (n !== null) {
            return { unit: 'year', value: n };
        }
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) {
            return { unit: 'month', value: n };
        }
        n = diffWholeWeeks(m0, m1);
        if (n !== null) {
            return { unit: 'week', value: n };
        }
        n = diffWholeDays(m0, m1);
        if (n !== null) {
            return { unit: 'day', value: n };
        }
        n = diffHours(m0, m1);
        if (isInt(n)) {
            return { unit: 'hour', value: n };
        }
        n = diffMinutes(m0, m1);
        if (isInt(n)) {
            return { unit: 'minute', value: n };
        }
        n = diffSeconds(m0, m1);
        if (isInt(n)) {
            return { unit: 'second', value: n };
        }
        return { unit: 'millisecond', value: m1.valueOf() - m0.valueOf() };
    };
    DateEnv.prototype.countDurationsBetween = function (m0, m1, d) {
        // TODO: can use greatestWholeUnit
        var diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) {
                return diff / asRoughYears(d);
            }
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) {
                return diff / asRoughMonths(d);
            }
        }
        if (d.days) {
            diff = diffWholeDays(m0, m1);
            if (diff !== null) {
                return diff / asRoughDays(d);
            }
        }
        return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
    };
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    DateEnv.prototype.startOf = function (m, unit) {
        if (unit === 'year') {
            return this.startOfYear(m);
        }
        if (unit === 'month') {
            return this.startOfMonth(m);
        }
        if (unit === 'week') {
            return this.startOfWeek(m);
        }
        if (unit === 'day') {
            return startOfDay(m);
        }
        if (unit === 'hour') {
            return startOfHour(m);
        }
        if (unit === 'minute') {
            return startOfMinute(m);
        }
        if (unit === 'second') {
            return startOfSecond(m);
        }
        return null;
    };
    DateEnv.prototype.startOfYear = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
        ]);
    };
    DateEnv.prototype.startOfMonth = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
        ]);
    };
    DateEnv.prototype.startOfWeek = function (m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - ((m.getUTCDay() - this.weekDow + 7) % 7),
        ]);
    };
    // Week Number
    DateEnv.prototype.computeWeekNumber = function (marker) {
        if (this.weekNumberFunc) {
            return this.weekNumberFunc(this.toDate(marker));
        }
        return weekOfYear(marker, this.weekDow, this.weekDoy);
    };
    // TODO: choke on timeZoneName: long
    DateEnv.prototype.format = function (marker, formatter, dateOptions) {
        if (dateOptions === void 0) { dateOptions = {}; }
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ?
                dateOptions.forcedTzo :
                this.offsetForMarker(marker),
        }, this);
    };
    DateEnv.prototype.formatRange = function (start, end, formatter, dateOptions) {
        if (dateOptions === void 0) { dateOptions = {}; }
        if (dateOptions.isEndExclusive) {
            end = addMs(end, -1);
        }
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ?
                dateOptions.forcedStartTzo :
                this.offsetForMarker(start),
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ?
                dateOptions.forcedEndTzo :
                this.offsetForMarker(end),
        }, this, dateOptions.defaultSeparator);
    };
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */
    DateEnv.prototype.formatIso = function (marker, extraOptions) {
        if (extraOptions === void 0) { extraOptions = {}; }
        var timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) {
                timeZoneOffset = extraOptions.forcedTzo;
            }
            else {
                timeZoneOffset = this.offsetForMarker(marker);
            }
        }
        return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
    };
    // TimeZone
    DateEnv.prototype.timestampToMarker = function (ms) {
        if (this.timeZone === 'local') {
            return arrayToUtcDate(dateToLocalArray(new Date(ms)));
        }
        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) {
            return new Date(ms);
        }
        return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    };
    DateEnv.prototype.offsetForMarker = function (m) {
        if (this.timeZone === 'local') {
            return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        }
        if (this.timeZone === 'UTC') {
            return 0;
        }
        if (this.namedTimeZoneImpl) {
            return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
        }
        return null;
    };
    // Conversion
    DateEnv.prototype.toDate = function (m, forcedTzo) {
        if (this.timeZone === 'local') {
            return arrayToLocalDate(dateToUtcArray(m));
        }
        if (this.timeZone === 'UTC') {
            return new Date(m.valueOf()); // make sure it's a copy
        }
        if (!this.namedTimeZoneImpl) {
            return new Date(m.valueOf() - (forcedTzo || 0));
        }
        return new Date(m.valueOf() -
            this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 1000 * 60);
    };
    return DateEnv;
}());

var globalLocales = [];

var MINIMAL_RAW_EN_LOCALE = {
    code: 'en',
    week: {
        dow: 0,
        doy: 4, // 4 days need to be within the year to be considered the first week
    },
    direction: 'ltr',
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list',
    },
    weekText: 'W',
    weekTextLong: 'Week',
    closeHint: 'Close',
    timeHint: 'Time',
    eventHint: 'Event',
    allDayText: 'all-day',
    moreLinkText: 'more',
    noEventsText: 'No events to display',
};
var RAW_EN_LOCALE = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, MINIMAL_RAW_EN_LOCALE), { 
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: 'Previous $0',
        next: 'Next $0',
        today: function (buttonText, unit) {
            return (unit === 'day')
                ? 'Today'
                : "This " + buttonText;
        },
    }, viewHint: '$0 view', navLinkHint: 'Go to $0', moreLinkHint: function (eventCnt) {
        return "Show " + eventCnt + " more event" + (eventCnt === 1 ? '' : 's');
    } });
function organizeRawLocales(explicitRawLocales) {
    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
    var allRawLocales = globalLocales.concat(explicitRawLocales);
    var rawLocaleMap = {
        en: RAW_EN_LOCALE,
    };
    for (var _i = 0, allRawLocales_1 = allRawLocales; _i < allRawLocales_1.length; _i++) {
        var rawLocale = allRawLocales_1[_i];
        rawLocaleMap[rawLocale.code] = rawLocale;
    }
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode,
    };
}
function buildLocale(inputSingular, available) {
    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) {
        return parseLocale(inputSingular.code, [inputSingular.code], inputSingular);
    }
    return queryLocale(inputSingular, available);
}
function queryLocale(codeArg, available) {
    var codes = [].concat(codeArg || []); // will convert to array
    var raw = queryRawLocale(codes, available) || RAW_EN_LOCALE;
    return parseLocale(codeArg, codes, raw);
}
function queryRawLocale(codes, available) {
    for (var i = 0; i < codes.length; i += 1) {
        var parts = codes[i].toLocaleLowerCase().split('-');
        for (var j = parts.length; j > 0; j -= 1) {
            var simpleId = parts.slice(0, j).join('-');
            if (available[simpleId]) {
                return available[simpleId];
            }
        }
    }
    return null;
}
function parseLocale(codeArg, codes, raw) {
    var merged = mergeProps([MINIMAL_RAW_EN_LOCALE, raw], ['buttonText']);
    delete merged.code; // don't want this part of the options
    var week = merged.week;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged,
    };
}

function formatDate(dateInput, options) {
    if (options === void 0) { options = {}; }
    var dateEnv = buildDateEnv$1(options);
    var formatter = createFormatter(options);
    var dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) { // TODO: warning?
        return '';
    }
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo,
    });
}
function formatRange(startInput, endInput, options) {
    var dateEnv = buildDateEnv$1(typeof options === 'object' && options ? options : {}); // pass in if non-null object
    var formatter = createFormatter(options);
    var startMeta = dateEnv.createMarkerMeta(startInput);
    var endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) { // TODO: warning?
        return '';
    }
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: BASE_OPTION_DEFAULTS.defaultRangeSeparator,
    });
}
// TODO: more DRY and optimized
function buildDateEnv$1(settings) {
    var locale = buildLocale(settings.locale || 'en', organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new DateEnv(__assign(__assign({ timeZone: BASE_OPTION_DEFAULTS.timeZone, calendarSystem: 'gregory' }, settings), { locale: locale }));
}

var DEF_DEFAULTS = {
    startTime: '09:00',
    endTime: '17:00',
    daysOfWeek: [1, 2, 3, 4, 5],
    display: 'inverse-background',
    classNames: 'fc-non-business',
    groupId: '_businessHours', // so multiple defs get grouped
};
/*
TODO: pass around as EventDefHash!!!
*/
function parseBusinessHours(input, context) {
    return parseEvents(refineInputs(input), null, context);
}
function refineInputs(input) {
    var rawDefs;
    if (input === true) {
        rawDefs = [{}]; // will get DEF_DEFAULTS verbatim
    }
    else if (Array.isArray(input)) {
        // if specifying an array, every sub-definition NEEDS a day-of-week
        rawDefs = input.filter(function (rawDef) { return rawDef.daysOfWeek; });
    }
    else if (typeof input === 'object' && input) { // non-null object
        rawDefs = [input];
    }
    else { // is probably false
        rawDefs = [];
    }
    rawDefs = rawDefs.map(function (rawDef) { return (node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, DEF_DEFAULTS), rawDef)); });
    return rawDefs;
}

function pointInsideRect(point, rect) {
    return point.left >= rect.left &&
        point.left < rect.right &&
        point.top >= rect.top &&
        point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom),
    };
    if (res.left < res.right && res.top < res.bottom) {
        return res;
    }
    return false;
}
function translateRect(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY,
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom),
    };
}
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2,
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top,
    };
}

var canVGrowWithinCell;
function getCanVGrowWithinCell() {
    if (canVGrowWithinCell == null) {
        canVGrowWithinCell = computeCanVGrowWithinCell();
    }
    return canVGrowWithinCell;
}
function computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === 'undefined') {
        return true;
    }
    var el = document.createElement('div');
    el.style.position = 'absolute';
    el.style.top = '0px';
    el.style.left = '0px';
    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
    el.querySelector('table').style.height = '100px';
    el.querySelector('div').style.height = '100%';
    document.body.appendChild(el);
    var div = el.querySelector('div');
    var possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}

var EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere
var Splitter = /** @class */ (function () {
    function Splitter() {
        this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
        this.splitDateSelection = memoize(this._splitDateSpan);
        this.splitEventStore = memoize(this._splitEventStore);
        this.splitIndividualUi = memoize(this._splitIndividualUi);
        this.splitEventDrag = memoize(this._splitInteraction);
        this.splitEventResize = memoize(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
    Splitter.prototype.splitProps = function (props) {
        var _this = this;
        var keyInfos = this.getKeyInfo(props);
        var defKeys = this.getKeysForEventDefs(props.eventStore);
        var dateSelections = this.splitDateSelection(props.dateSelection);
        var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        var eventStores = this.splitEventStore(props.eventStore, defKeys);
        var eventDrags = this.splitEventDrag(props.eventDrag);
        var eventResizes = this.splitEventResize(props.eventResize);
        var splitProps = {};
        this.eventUiBuilders = mapHash(keyInfos, function (info, key) { return _this.eventUiBuilders[key] || memoize(buildEventUiForKey); });
        for (var key in keyInfos) {
            var keyInfo = keyInfos[key];
            var eventStore = eventStores[key] || EMPTY_EVENT_STORE;
            var buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null,
            };
        }
        return splitProps;
    };
    Splitter.prototype._splitDateSpan = function (dateSpan) {
        var dateSpans = {};
        if (dateSpan) {
            var keys = this.getKeysForDateSpan(dateSpan);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                dateSpans[key] = dateSpan;
            }
        }
        return dateSpans;
    };
    Splitter.prototype._getKeysForEventDefs = function (eventStore) {
        var _this = this;
        return mapHash(eventStore.defs, function (eventDef) { return _this.getKeysForEventDef(eventDef); });
    };
    Splitter.prototype._splitEventStore = function (eventStore, defKeys) {
        var defs = eventStore.defs, instances = eventStore.instances;
        var splitStores = {};
        for (var defId in defs) {
            for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
                var key = _a[_i];
                if (!splitStores[key]) {
                    splitStores[key] = createEmptyEventStore();
                }
                splitStores[key].defs[defId] = defs[defId];
            }
        }
        for (var instanceId in instances) {
            var instance = instances[instanceId];
            for (var _b = 0, _c = defKeys[instance.defId]; _b < _c.length; _b++) {
                var key = _c[_b];
                if (splitStores[key]) { // must have already been created
                    splitStores[key].instances[instanceId] = instance;
                }
            }
        }
        return splitStores;
    };
    Splitter.prototype._splitIndividualUi = function (eventUiBases, defKeys) {
        var splitHashes = {};
        for (var defId in eventUiBases) {
            if (defId) { // not the '' key
                for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
                    var key = _a[_i];
                    if (!splitHashes[key]) {
                        splitHashes[key] = {};
                    }
                    splitHashes[key][defId] = eventUiBases[defId];
                }
            }
        }
        return splitHashes;
    };
    Splitter.prototype._splitInteraction = function (interaction) {
        var splitStates = {};
        if (interaction) {
            var affectedStores_1 = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            var mutatedStores_1 = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            var populate = function (key) {
                if (!splitStates[key]) {
                    splitStates[key] = {
                        affectedEvents: affectedStores_1[key] || EMPTY_EVENT_STORE,
                        mutatedEvents: mutatedStores_1[key] || EMPTY_EVENT_STORE,
                        isEvent: interaction.isEvent,
                    };
                }
            };
            for (var key in affectedStores_1) {
                populate(key);
            }
            for (var key in mutatedStores_1) {
                populate(key);
            }
        }
        return splitStates;
    };
    return Splitter;
}());
function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    var baseParts = [];
    if (allUi) {
        baseParts.push(allUi);
    }
    if (eventUiForKey) {
        baseParts.push(eventUiForKey);
    }
    var stuff = {
        '': combineEventUis(baseParts),
    };
    if (individualUi) {
        node_modules_tslib_tslib_es6_assign(stuff, individualUi);
    }
    return stuff;
}

function getDateMeta(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !rangeContainsMarker(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
        isPast: Boolean(nowDate ? (date < nowDate) : todayRange ? (date < todayRange.start) : false),
        isFuture: Boolean(nowDate ? (date > nowDate) : todayRange ? (date >= todayRange.end) : false),
    };
}
function getDayClassNames(meta, theme) {
    var classNames = [
        'fc-day',
        "fc-day-" + DAY_IDS[meta.dow],
    ];
    if (meta.isDisabled) {
        classNames.push('fc-day-disabled');
    }
    else {
        if (meta.isToday) {
            classNames.push('fc-day-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) {
            classNames.push('fc-day-past');
        }
        if (meta.isFuture) {
            classNames.push('fc-day-future');
        }
        if (meta.isOther) {
            classNames.push('fc-day-other');
        }
    }
    return classNames;
}
function getSlotClassNames(meta, theme) {
    var classNames = [
        'fc-slot',
        "fc-slot-" + DAY_IDS[meta.dow],
    ];
    if (meta.isDisabled) {
        classNames.push('fc-slot-disabled');
    }
    else {
        if (meta.isToday) {
            classNames.push('fc-slot-today');
            classNames.push(theme.getClass('today'));
        }
        if (meta.isPast) {
            classNames.push('fc-slot-past');
        }
        if (meta.isFuture) {
            classNames.push('fc-slot-future');
        }
    }
    return classNames;
}

var DAY_FORMAT = createFormatter({ year: 'numeric', month: 'long', day: 'numeric' });
var WEEK_FORMAT = createFormatter({ week: 'long' });
function buildNavLinkAttrs(context, dateMarker, viewType, isTabbable) {
    if (viewType === void 0) { viewType = 'day'; }
    if (isTabbable === void 0) { isTabbable = true; }
    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
    var dateStr = dateEnv.format(dateMarker, viewType === 'week' ? WEEK_FORMAT : DAY_FORMAT);
    if (options.navLinks) {
        var zonedDate = dateEnv.toDate(dateMarker);
        var handleInteraction = function (ev) {
            var customAction = viewType === 'day' ? options.navLinkDayClick :
                viewType === 'week' ? options.navLinkWeekClick : null;
            if (typeof customAction === 'function') {
                customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            }
            else {
                if (typeof customAction === 'string') {
                    viewType = customAction;
                }
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return node_modules_tslib_tslib_es6_assign({ title: formatWithOrdinals(options.navLinkHint, [dateStr, zonedDate], dateStr), 'data-navlink': '' }, (isTabbable
            ? createAriaClickAttrs(handleInteraction)
            : { onClick: handleInteraction }));
    }
    return { 'aria-label': dateStr };
}

var _isRtlScrollbarOnLeft = null;
function getIsRtlScrollbarOnLeft() {
    if (_isRtlScrollbarOnLeft === null) {
        _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
    }
    return _isRtlScrollbarOnLeft;
}
function computeIsRtlScrollbarOnLeft() {
    var outerEl = document.createElement('div');
    applyStyle(outerEl, {
        position: 'absolute',
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: 'scroll',
        direction: 'rtl',
    });
    outerEl.innerHTML = '<div></div>';
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    removeElement(outerEl);
    return res;
}

var _scrollbarWidths;
function getScrollbarWidths() {
    if (!_scrollbarWidths) {
        _scrollbarWidths = computeScrollbarWidths();
    }
    return _scrollbarWidths;
}
function computeScrollbarWidths() {
    var el = document.createElement('div');
    el.style.overflow = 'scroll';
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    var res = computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth,
    };
}

function computeEdges(el, getPadding) {
    if (getPadding === void 0) { getPadding = false; }
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!
    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0,
    };
    if (getIsRtlScrollbarOnLeft() && computedStyle.direction === 'rtl') { // is the scrollbar on the left side?
        res.scrollbarLeft = scrollbarLeftRight;
    }
    else {
        res.scrollbarRight = scrollbarLeftRight;
    }
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function computeInnerRect(el, goWithinPadding, doFromWindowViewport) {
    if (goWithinPadding === void 0) { goWithinPadding = false; }
    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
    var edges = computeEdges(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom,
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function computeRect(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset,
    };
}
function computeClippedClientRect(el) {
    var clippingParents = getClippingParents(el);
    var rect = el.getBoundingClientRect();
    for (var _i = 0, clippingParents_1 = clippingParents; _i < clippingParents_1.length; _i++) {
        var clippingParent = clippingParents_1[_i];
        var intersection = intersectRects(rect, clippingParent.getBoundingClientRect());
        if (intersection) {
            rect = intersection;
        }
        else {
            return null;
        }
    }
    return rect;
}
function computeHeightAndMargins(el) {
    return el.getBoundingClientRect().height + computeVMargins(el);
}
function computeVMargins(el) {
    var computed = window.getComputedStyle(el);
    return parseInt(computed.marginTop, 10) +
        parseInt(computed.marginBottom, 10);
}
// does not return window
function getClippingParents(el) {
    var parents = [];
    while (el instanceof HTMLElement) { // will stop when gets to document or null
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') {
            break;
        }
        if ((/(auto|scroll)/).test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) {
            parents.push(el);
        }
        el = el.parentNode;
    }
    return parents;
}

// given a function that resolves a result asynchronously.
// the function can either call passed-in success and failure callbacks,
// or it can return a promise.
// if you need to pass additional params to func, bind them first.
function unpromisify(func, success, failure) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function () {
        if (!isResolved) {
            isResolved = true;
            success.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }
    };
    var wrappedFailure = function () {
        if (!isResolved) {
            isResolved = true;
            if (failure) {
                failure.apply(this, arguments); // eslint-disable-line prefer-rest-params
            }
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') {
        res.then(wrappedSuccess, wrappedFailure);
    }
}

var Emitter = /** @class */ (function () {
    function Emitter() {
        this.handlers = {};
        this.thisContext = null;
    }
    Emitter.prototype.setThisContext = function (thisContext) {
        this.thisContext = thisContext;
    };
    Emitter.prototype.setOptions = function (options) {
        this.options = options;
    };
    Emitter.prototype.on = function (type, handler) {
        addToHash(this.handlers, type, handler);
    };
    Emitter.prototype.off = function (type, handler) {
        removeFromHash(this.handlers, type, handler);
    };
    Emitter.prototype.trigger = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var attachedHandlers = this.handlers[type] || [];
        var optionHandler = this.options && this.options[type];
        var handlers = [].concat(optionHandler || [], attachedHandlers);
        for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
            var handler = handlers_1[_a];
            handler.apply(this.thisContext, args);
        }
    };
    Emitter.prototype.hasHandlers = function (type) {
        return Boolean((this.handlers[type] && this.handlers[type].length) ||
            (this.options && this.options[type]));
    };
    return Emitter;
}());
function addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = []))
        .push(handler);
}
function removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) {
            hash[type] = hash[type].filter(function (func) { return func !== handler; });
        }
    }
    else {
        delete hash[type]; // remove all handler funcs for this type
    }
}

/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/
var PositionCache = /** @class */ (function () {
    function PositionCache(originEl, els, isHorizontal, isVertical) {
        this.els = els;
        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) {
            this.buildElHorizontals(originClientRect.left);
        }
        if (isVertical) {
            this.buildElVerticals(originClientRect.top);
        }
    }
    // Populates the left/right internal coordinate arrays
    PositionCache.prototype.buildElHorizontals = function (originClientLeft) {
        var lefts = [];
        var rights = [];
        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    PositionCache.prototype.buildElVerticals = function (originClientTop) {
        var tops = [];
        var bottoms = [];
        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
            var el = _a[_i];
            var rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.leftToIndex = function (leftPosition) {
        var _a = this, lefts = _a.lefts, rights = _a.rights;
        var len = lefts.length;
        var i;
        for (i = 0; i < len; i += 1) {
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) {
                return i;
            }
        }
        return undefined; // TODO: better
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    PositionCache.prototype.topToIndex = function (topPosition) {
        var _a = this, tops = _a.tops, bottoms = _a.bottoms;
        var len = tops.length;
        var i;
        for (i = 0; i < len; i += 1) {
            if (topPosition >= tops[i] && topPosition < bottoms[i]) {
                return i;
            }
        }
        return undefined; // TODO: better
    };
    // Gets the width of the element at the given index
    PositionCache.prototype.getWidth = function (leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the height of the element at the given index
    PositionCache.prototype.getHeight = function (topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    return PositionCache;
}());

/* eslint max-classes-per-file: "off" */
/*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/
var ScrollController = /** @class */ (function () {
    function ScrollController() {
    }
    ScrollController.prototype.getMaxScrollTop = function () {
        return this.getScrollHeight() - this.getClientHeight();
    };
    ScrollController.prototype.getMaxScrollLeft = function () {
        return this.getScrollWidth() - this.getClientWidth();
    };
    ScrollController.prototype.canScrollVertically = function () {
        return this.getMaxScrollTop() > 0;
    };
    ScrollController.prototype.canScrollHorizontally = function () {
        return this.getMaxScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollUp = function () {
        return this.getScrollTop() > 0;
    };
    ScrollController.prototype.canScrollDown = function () {
        return this.getScrollTop() < this.getMaxScrollTop();
    };
    ScrollController.prototype.canScrollLeft = function () {
        return this.getScrollLeft() > 0;
    };
    ScrollController.prototype.canScrollRight = function () {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    };
    return ScrollController;
}());
var ElementScrollController = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(ElementScrollController, _super);
    function ElementScrollController(el) {
        var _this = _super.call(this) || this;
        _this.el = el;
        return _this;
    }
    ElementScrollController.prototype.getScrollTop = function () {
        return this.el.scrollTop;
    };
    ElementScrollController.prototype.getScrollLeft = function () {
        return this.el.scrollLeft;
    };
    ElementScrollController.prototype.setScrollTop = function (top) {
        this.el.scrollTop = top;
    };
    ElementScrollController.prototype.setScrollLeft = function (left) {
        this.el.scrollLeft = left;
    };
    ElementScrollController.prototype.getScrollWidth = function () {
        return this.el.scrollWidth;
    };
    ElementScrollController.prototype.getScrollHeight = function () {
        return this.el.scrollHeight;
    };
    ElementScrollController.prototype.getClientHeight = function () {
        return this.el.clientHeight;
    };
    ElementScrollController.prototype.getClientWidth = function () {
        return this.el.clientWidth;
    };
    return ElementScrollController;
}(ScrollController));
var WindowScrollController = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(WindowScrollController, _super);
    function WindowScrollController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WindowScrollController.prototype.getScrollTop = function () {
        return window.pageYOffset;
    };
    WindowScrollController.prototype.getScrollLeft = function () {
        return window.pageXOffset;
    };
    WindowScrollController.prototype.setScrollTop = function (n) {
        window.scroll(window.pageXOffset, n);
    };
    WindowScrollController.prototype.setScrollLeft = function (n) {
        window.scroll(n, window.pageYOffset);
    };
    WindowScrollController.prototype.getScrollWidth = function () {
        return document.documentElement.scrollWidth;
    };
    WindowScrollController.prototype.getScrollHeight = function () {
        return document.documentElement.scrollHeight;
    };
    WindowScrollController.prototype.getClientHeight = function () {
        return document.documentElement.clientHeight;
    };
    WindowScrollController.prototype.getClientWidth = function () {
        return document.documentElement.clientWidth;
    };
    return WindowScrollController;
}(ScrollController));

var Theme = /** @class */ (function () {
    function Theme(calendarOptions) {
        if (this.iconOverrideOption) {
            this.setIconOverride(calendarOptions[this.iconOverrideOption]);
        }
    }
    Theme.prototype.setIconOverride = function (iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) { // non-null object
            iconClassesCopy = node_modules_tslib_tslib_es6_assign({}, this.iconClasses);
            for (buttonName in iconOverrideHash) {
                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            }
            this.iconClasses = iconClassesCopy;
        }
        else if (iconOverrideHash === false) {
            this.iconClasses = {};
        }
    };
    Theme.prototype.applyIconOverridePrefix = function (className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) { // if not already present
            className = prefix + className;
        }
        return className;
    };
    Theme.prototype.getClass = function (key) {
        return this.classes[key] || '';
    };
    Theme.prototype.getIconClass = function (buttonName, isRtl) {
        var className;
        if (isRtl && this.rtlIconClasses) {
            className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        }
        else {
            className = this.iconClasses[buttonName];
        }
        if (className) {
            return this.baseIconClass + " " + className;
        }
        return '';
    };
    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) {
                return this.baseIconClass + " " + this.applyIconOverridePrefix(className);
            }
        }
        return '';
    };
    return Theme;
}());
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';

var ScrollResponder = /** @class */ (function () {
    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
        var _this = this;
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = function (request) {
            _this.queuedRequest = node_modules_tslib_tslib_es6_assign({}, _this.queuedRequest || {}, request);
            _this.drain();
        };
        emitter.on('_scrollRequest', this.handleScrollRequest);
        this.fireInitialScroll();
    }
    ScrollResponder.prototype.detach = function () {
        this.emitter.off('_scrollRequest', this.handleScrollRequest);
    };
    ScrollResponder.prototype.update = function (isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) {
            this.fireInitialScroll(); // will drain
        }
        else {
            this.drain();
        }
    };
    ScrollResponder.prototype.fireInitialScroll = function () {
        this.handleScrollRequest({
            time: this.scrollTime,
        });
    };
    ScrollResponder.prototype.drain = function () {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) {
            this.queuedRequest = null;
        }
    };
    return ScrollResponder;
}());

var ViewContextType = vdom_createContext({}); // for Components
function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === 'rtl',
        addResizeHandler: function (handler) {
            emitter.on('_resize', handler);
        },
        removeResizeHandler: function (handler) {
            emitter.off('_resize', handler);
        },
        createScrollResponder: function (execFunc) {
            return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent,
    };
}

/* eslint max-classes-per-file: off */
var PureComponent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(PureComponent, _super);
    function PureComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PureComponent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.debug) {
            // eslint-disable-next-line no-console
            console.log(getUnequalProps(nextProps, this.props), getUnequalProps(nextState, this.state));
        }
        return !compareObjs(this.props, nextProps, this.propEquality) ||
            !compareObjs(this.state, nextState, this.stateEquality);
    };
    PureComponent.addPropsEquality = addPropsEquality;
    PureComponent.addStateEquality = addStateEquality;
    PureComponent.contextType = ViewContextType;
    return PureComponent;
}(vdom_Component));
PureComponent.prototype.propEquality = {};
PureComponent.prototype.stateEquality = {};
var BaseComponent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(BaseComponent, _super);
    function BaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseComponent.contextType = ViewContextType;
    return BaseComponent;
}(PureComponent));
function addPropsEquality(propEquality) {
    var hash = Object.create(this.prototype.propEquality);
    node_modules_tslib_tslib_es6_assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function addStateEquality(stateEquality) {
    var hash = Object.create(this.prototype.stateEquality);
    node_modules_tslib_tslib_es6_assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function setRef(ref, current) {
    if (typeof ref === 'function') {
        ref(current);
    }
    else if (ref) {
        // see https://github.com/facebook/react/issues/13029
        ref.current = current;
    }
}

/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/
var DateComponent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(DateComponent, _super);
    function DateComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uid = guid();
        return _this;
    }
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.prepareHits = function () {
    };
    DateComponent.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    };
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.isValidSegDownEl = function (el) {
        return !this.props.eventDrag && // HACK
            !this.props.eventResize && // HACK
            !elementClosest(el, '.fc-event-mirror');
    };
    DateComponent.prototype.isValidDateDownEl = function (el) {
        return !elementClosest(el, '.fc-event:not(.fc-bg-event)') &&
            !elementClosest(el, '.fc-more-link') && // a "more.." link
            !elementClosest(el, 'a[data-navlink]') && // a clickable nav link
            !elementClosest(el, '.fc-popover'); // hack
    };
    return DateComponent;
}(BaseComponent));

// TODO: easier way to add new hooks? need to update a million things
function createPlugin(input) {
    return {
        id: guid(),
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || '',
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        contentTypeHandlers: input.contentTypeHandlers || {},
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {},
    };
}
function buildPluginHooks(pluginDefs, globalDefs) {
    var isAdded = {};
    var hooks = {
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: '',
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        contentTypeHandlers: {},
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {},
    };
    function addDefs(defs) {
        for (var _i = 0, defs_1 = defs; _i < defs_1.length; _i++) {
            var def = defs_1[_i];
            if (!isAdded[def.id]) {
                isAdded[def.id] = true;
                addDefs(def.deps);
                hooks = combineHooks(hooks, def);
            }
        }
    }
    if (pluginDefs) {
        addDefs(pluginDefs);
    }
    addDefs(globalDefs);
    return hooks;
}
function buildBuildPluginHooks() {
    var currentOverrideDefs = [];
    var currentGlobalDefs = [];
    var currentHooks;
    return function (overrideDefs, globalDefs) {
        if (!currentHooks || !isArraysEqual(overrideDefs, currentOverrideDefs) || !isArraysEqual(globalDefs, currentGlobalDefs)) {
            currentHooks = buildPluginHooks(overrideDefs, globalDefs);
        }
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function combineHooks(hooks0, hooks1) {
    return {
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        contentTypeHandlers: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.contentTypeHandlers), hooks1.contentTypeHandlers),
        listenerRefiners: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers),
    };
}

var StandardTheme = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme));
StandardTheme.prototype.classes = {
    root: 'fc-theme-standard',
    tableCellShaded: 'fc-cell-shaded',
    buttonGroup: 'fc-button-group',
    button: 'fc-button fc-button-primary',
    buttonActive: 'fc-button-active',
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-chevron-left',
    next: 'fc-icon-chevron-right',
    prevYear: 'fc-icon-chevrons-left',
    nextYear: 'fc-icon-chevrons-right',
};
StandardTheme.prototype.rtlIconClasses = {
    prev: 'fc-icon-chevron-right',
    next: 'fc-icon-chevron-left',
    prevYear: 'fc-icon-chevrons-right',
    nextYear: 'fc-icon-chevrons-left',
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';

function compileViewDefs(defaultConfigs, overrideConfigs) {
    var hash = {};
    var viewType;
    for (viewType in defaultConfigs) {
        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    }
    for (viewType in overrideConfigs) {
        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    }
    return hash;
}
function ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) {
        return hash[viewType];
    }
    var viewDef = buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) {
        hash[viewType] = viewDef;
    }
    return viewDef;
}
function buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    var defaultConfig = defaultConfigs[viewType];
    var overrideConfig = overrideConfigs[viewType];
    var queryProp = function (name) { return ((defaultConfig && defaultConfig[name] !== null) ? defaultConfig[name] :
        ((overrideConfig && overrideConfig[name] !== null) ? overrideConfig[name] : null)); };
    var theComponent = queryProp('component');
    var superType = queryProp('superType');
    var superDef = null;
    if (superType) {
        if (superType === viewType) {
            throw new Error('Can\'t have a custom view type that references itself');
        }
        superDef = ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) {
        theComponent = superDef.component;
    }
    if (!theComponent) {
        return null; // don't throw a warning, might be settings for a single-unit view
    }
    return {
        type: viewType,
        component: theComponent,
        defaults: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, (superDef ? superDef.defaults : {})), (defaultConfig ? defaultConfig.rawOptions : {})),
        overrides: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, (superDef ? superDef.overrides : {})), (overrideConfig ? overrideConfig.rawOptions : {})),
    };
}

/* eslint max-classes-per-file: off */
// NOTE: in JSX, you should always use this class with <HookProps> arg. otherwise, will default to any???
var RenderHook = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(RenderHook, _super);
    function RenderHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = createRef();
        _this.handleRootEl = function (el) {
            setRef(_this.rootElRef, el);
            if (_this.props.elRef) {
                setRef(_this.props.elRef, el);
            }
        };
        return _this;
    }
    RenderHook.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var hookProps = props.hookProps;
        return (createElement(MountHook, { hookProps: hookProps, didMount: props.didMount, willUnmount: props.willUnmount, elRef: this.handleRootEl }, function (rootElRef) { return (createElement(ContentHook, { hookProps: hookProps, content: props.content, defaultContent: props.defaultContent, backupElRef: _this.rootElRef }, function (innerElRef, innerContent) { return props.children(rootElRef, normalizeClassNames(props.classNames, hookProps), innerElRef, innerContent); })); }));
    };
    return RenderHook;
}(BaseComponent));
// TODO: rename to be about function, not default. use in above type
// for forcing rerender of components that use the ContentHook
var CustomContentRenderContext = vdom_createContext(0);
function ContentHook(props) {
    return (createElement(CustomContentRenderContext.Consumer, null, function (renderId) { return (createElement(ContentHookInner, node_modules_tslib_tslib_es6_assign({ renderId: renderId }, props))); }));
}
var ContentHookInner = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(ContentHookInner, _super);
    function ContentHookInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerElRef = createRef();
        return _this;
    }
    ContentHookInner.prototype.render = function () {
        return this.props.children(this.innerElRef, this.renderInnerContent());
    };
    ContentHookInner.prototype.componentDidMount = function () {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentDidUpdate = function () {
        this.updateCustomContent();
    };
    ContentHookInner.prototype.componentWillUnmount = function () {
        if (this.customContentInfo && this.customContentInfo.destroy) {
            this.customContentInfo.destroy();
        }
    };
    ContentHookInner.prototype.renderInnerContent = function () {
        var customContentInfo = this.customContentInfo; // only populated if using non-[p]react node(s)
        var innerContent = this.getInnerContent();
        var meta = this.getContentMeta(innerContent);
        // initial run, or content-type changing? (from vue -> react for example)
        if (!customContentInfo || customContentInfo.contentKey !== meta.contentKey) {
            // clearing old value
            if (customContentInfo) {
                if (customContentInfo.destroy) {
                    customContentInfo.destroy();
                }
                customContentInfo = this.customContentInfo = null;
            }
            // assigning new value
            if (meta.contentKey) {
                customContentInfo = this.customContentInfo = node_modules_tslib_tslib_es6_assign({ contentKey: meta.contentKey, contentVal: innerContent[meta.contentKey] }, meta.buildLifecycleFuncs());
            }
            // updating
        }
        else if (customContentInfo) {
            customContentInfo.contentVal = innerContent[meta.contentKey];
        }
        return customContentInfo
            ? [] // signal that something was specified
            : innerContent; // assume a [p]react vdom node. use it
    };
    ContentHookInner.prototype.getInnerContent = function () {
        var props = this.props;
        var innerContent = normalizeContent(props.content, props.hookProps);
        if (innerContent === undefined) { // use the default
            innerContent = normalizeContent(props.defaultContent, props.hookProps);
        }
        return innerContent == null ? null : innerContent; // convert undefined to null (better for React)
    };
    ContentHookInner.prototype.getContentMeta = function (innerContent) {
        var contentTypeHandlers = this.context.pluginHooks.contentTypeHandlers;
        var contentKey = '';
        var buildLifecycleFuncs = null;
        if (innerContent) { // allowed to be null, for convenience to caller
            for (var searchKey in contentTypeHandlers) {
                if (innerContent[searchKey] !== undefined) {
                    contentKey = searchKey;
                    buildLifecycleFuncs = contentTypeHandlers[searchKey];
                    break;
                }
            }
        }
        return { contentKey: contentKey, buildLifecycleFuncs: buildLifecycleFuncs };
    };
    ContentHookInner.prototype.updateCustomContent = function () {
        if (this.customContentInfo) { // for non-[p]react
            this.customContentInfo.render(this.innerElRef.current || this.props.backupElRef.current, // the element to render into
            this.customContentInfo.contentVal);
        }
    };
    return ContentHookInner;
}(BaseComponent));
var MountHook = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(MountHook, _super);
    function MountHook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (_this.props.elRef) {
                setRef(_this.props.elRef, rootEl);
            }
        };
        return _this;
    }
    MountHook.prototype.render = function () {
        return this.props.children(this.handleRootEl);
    };
    MountHook.prototype.componentDidMount = function () {
        var callback = this.props.didMount;
        if (callback) {
            callback(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, this.props.hookProps), { el: this.rootEl }));
        }
    };
    MountHook.prototype.componentWillUnmount = function () {
        var callback = this.props.willUnmount;
        if (callback) {
            callback(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, this.props.hookProps), { el: this.rootEl }));
        }
    };
    return MountHook;
}(BaseComponent));
function buildClassNameNormalizer() {
    var currentGenerator;
    var currentHookProps;
    var currentClassNames = [];
    return function (generator, hookProps) {
        if (!currentHookProps || !isPropsEqual(currentHookProps, hookProps) || generator !== currentGenerator) {
            currentGenerator = generator;
            currentHookProps = hookProps;
            currentClassNames = normalizeClassNames(generator, hookProps);
        }
        return currentClassNames;
    };
}
function normalizeClassNames(classNames, hookProps) {
    if (typeof classNames === 'function') {
        classNames = classNames(hookProps);
    }
    return parseClassNames(classNames);
}
function normalizeContent(input, hookProps) {
    if (typeof input === 'function') {
        return input(hookProps, createElement); // give the function the vdom-creation func
    }
    return input;
}

var ViewRoot = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(ViewRoot, _super);
    function ViewRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    ViewRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = { view: context.viewApi };
        var customClassNames = this.normalizeClassNames(options.viewClassNames, hookProps);
        return (createElement(MountHook, { hookProps: hookProps, didMount: options.viewDidMount, willUnmount: options.viewWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, ["fc-" + props.viewSpec.type + "-view", 'fc-view'].concat(customClassNames)); }));
    };
    return ViewRoot;
}(BaseComponent));

function parseViewConfigs(inputs) {
    return mapHash(inputs, parseViewConfig);
}
function parseViewConfig(input) {
    var rawOptions = typeof input === 'function' ?
        { component: input } :
        input;
    var component = rawOptions.component;
    if (rawOptions.content) {
        component = createViewHookComponent(rawOptions);
        // TODO: remove content/classNames/didMount/etc from options?
    }
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions,
    };
}
function createViewHookComponent(options) {
    return function (viewProps) { return (createElement(ViewContextType.Consumer, null, function (context) { return (createElement(ViewRoot, { viewSpec: context.viewSpec }, function (viewElRef, viewClassNames) {
        var hookProps = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, viewProps), { nextDayThreshold: context.options.nextDayThreshold });
        return (createElement(RenderHook, { hookProps: hookProps, classNames: options.classNames, content: options.content, didMount: options.didMount, willUnmount: options.willUnmount, elRef: viewElRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (createElement("div", { className: viewClassNames.concat(customClassNames).join(' '), ref: rootElRef }, innerContent)); }));
    })); })); };
}

function buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var defaultConfigs = parseViewConfigs(defaultInputs);
    var overrideConfigs = parseViewConfigs(optionOverrides.views);
    var viewDefs = compileViewDefs(defaultConfigs, overrideConfigs);
    return mapHash(viewDefs, function (viewDef) { return buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults); });
}
function buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    var durationInput = viewDef.overrides.duration ||
        viewDef.defaults.duration ||
        dynamicOptionOverrides.duration ||
        optionOverrides.duration;
    var duration = null;
    var durationUnit = '';
    var singleUnit = '';
    var singleUnitOverrides = {};
    if (durationInput) {
        duration = createDurationCached(durationInput);
        if (duration) { // valid?
            var denom = greatestDurationDenominator(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    var queryButtonText = function (optionsSubset) {
        var buttonTextMap = optionsSubset.buttonText || {};
        var buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) {
            return buttonTextMap[buttonTextKey];
        }
        if (buttonTextMap[viewDef.type] != null) {
            return buttonTextMap[viewDef.type];
        }
        if (buttonTextMap[singleUnit] != null) {
            return buttonTextMap[singleUnit];
        }
        return null;
    };
    var queryButtonTitle = function (optionsSubset) {
        var buttonHints = optionsSubset.buttonHints || {};
        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) {
            return buttonHints[buttonKey];
        }
        if (buttonHints[viewDef.type] != null) {
            return buttonHints[viewDef.type];
        }
        if (buttonHints[singleUnit] != null) {
            return buttonHints[singleUnit];
        }
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) ||
            queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
            viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) ||
            viewDef.defaults.buttonText ||
            queryButtonText(BASE_OPTION_DEFAULTS) ||
            viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) ||
            queryButtonTitle(optionOverrides) ||
            viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) ||
            viewDef.defaults.buttonHint ||
            queryButtonTitle(BASE_OPTION_DEFAULTS),
        // will eventually fall back to buttonText
    };
}
// hack to get memoization working
var durationInputMap = {};
function createDurationCached(durationInput) {
    var json = JSON.stringify(durationInput);
    var res = durationInputMap[json];
    if (res === undefined) {
        res = createDuration(durationInput);
        durationInputMap[json] = res;
    }
    return res;
}

var DateProfileGenerator = /** @class */ (function () {
    function DateProfileGenerator(props) {
        this.props = props;
        this.nowDate = getNow(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
        currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function (currentDateProfile, currentDate, forceToValid) {
        var dateEnv = this.props.dateEnv;
        var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
        currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function (currentDate, direction, forceToValid) {
        if (forceToValid === void 0) { forceToValid = true; }
        var props = this.props;
        var validRange;
        var currentInfo;
        var isRangeAllDay;
        var renderRange;
        var activeRange;
        var isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) {
            currentDate = constrainMarkerToRange(currentDate, validRange);
        }
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) {
            activeRange = intersectRanges(activeRange, currentInfo.range);
        }
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = intersectRanges(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = rangesIntersect(currentInfo.range, validRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange: validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange: activeRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange: renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration),
            // pass a fallback (might be null) ^
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function () {
        var input = this.props.validRangeInput;
        var simpleInput = typeof input === 'function'
            ? input.call(this.props.calendarApi, this.nowDate)
            : input;
        return this.refineRange(simpleInput) ||
            { start: null, end: null }; // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
        var props = this.props;
        var duration = null;
        var unit = null;
        var range = null;
        var dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        else if ((dayCount = this.props.dayCount)) {
            unit = 'day';
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        }
        else if ((range = this.buildCustomVisibleRange(date))) {
            unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        }
        else {
            duration = this.getFallbackDuration();
            unit = greatestDurationDenominator(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return { duration: duration, unit: unit, range: range };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function () {
        return createDuration({ day: 1 });
    };
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function (range) {
        var _a = this.props, dateEnv = _a.dateEnv, usesMinMaxTime = _a.usesMinMaxTime, slotMinTime = _a.slotMinTime, slotMaxTime = _a.slotMaxTime;
        var start = range.start, end = range.end;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if (asRoughDays(slotMinTime) < 0) {
                start = startOfDay(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if (asRoughDays(slotMaxTime) > 1) {
                end = startOfDay(end); // necessary?
                end = addDays(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return { start: start, end: end };
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!dateAlignment) {
            var dateIncrement = this.props.dateIncrement;
            if (dateIncrement) {
                // use the smaller of the two units
                if (asRoughMs(dateIncrement) < asRoughMs(duration)) {
                    dateAlignment = greatestDurationDenominator(dateIncrement).unit;
                }
                else {
                    dateAlignment = unit;
                }
            }
            else {
                dateAlignment = unit;
            }
        }
        // if the view displays a single day or smaller
        if (asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = startOfDay(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = { start: start, end: end };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
        var runningCount = 0;
        var start = date;
        var end;
        if (dateAlignment) {
            start = dateEnv.startOf(start, dateAlignment);
        }
        start = startOfDay(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = addDays(end, 1);
            if (!this.isHiddenDay(end)) {
                runningCount += 1;
            }
        } while (runningCount < dayCount);
        return { start: start, end: end };
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
        var props = this.props;
        var input = props.visibleRangeInput;
        var simpleInput = typeof input === 'function'
            ? input.call(props.calendarApi, props.dateEnv.toDate(date))
            : input;
        var range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) {
            return null;
        }
        return range;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function (currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
        var dateIncrement = this.props.dateIncrement;
        var customAlignment;
        if (dateIncrement) {
            return dateIncrement;
        }
        if ((customAlignment = this.props.dateAlignment)) {
            return createDuration(1, customAlignment);
        }
        if (fallback) {
            return fallback;
        }
        return createDuration({ days: 1 });
    };
    DateProfileGenerator.prototype.refineRange = function (rangeInput) {
        if (rangeInput) {
            var range = parseRange(rangeInput, this.props.dateEnv);
            if (range) {
                range = computeVisibleDayRange(range);
            }
            return range;
        }
        return null;
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    DateProfileGenerator.prototype.initHiddenDays = function () {
        var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.props.weekends === false) {
            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        }
        for (i = 0; i < 7; i += 1) {
            if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) {
                dayCnt += 1;
            }
        }
        if (!dayCnt) {
            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        }
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    DateProfileGenerator.prototype.trimHiddenDays = function (range) {
        var start = range.start, end = range.end;
        if (start) {
            start = this.skipHiddenDays(start);
        }
        if (end) {
            end = this.skipHiddenDays(end, -1, true);
        }
        if (start == null || end == null || start < end) {
            return { start: start, end: end };
        }
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    DateProfileGenerator.prototype.isHiddenDay = function (day) {
        if (day instanceof Date) {
            day = day.getUTCDay();
        }
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    DateProfileGenerator.prototype.skipHiddenDays = function (date, inc, isExclusive) {
        if (inc === void 0) { inc = 1; }
        if (isExclusive === void 0) { isExclusive = false; }
        while (this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7]) {
            date = addDays(date, inc);
        }
        return date;
    };
    return DateProfileGenerator;
}());

function reduceViewType(viewType, action) {
    switch (action.type) {
        case 'CHANGE_VIEW_TYPE':
            viewType = action.viewType;
    }
    return viewType;
}

function reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    var _a;
    switch (action.type) {
        case 'SET_OPTION':
            return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, dynamicOptionOverrides), (_a = {}, _a[action.optionName] = action.rawOptionValue, _a));
        default:
            return dynamicOptionOverrides;
    }
}

function reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    var dp;
    switch (action.type) {
        case 'CHANGE_VIEW_TYPE':
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case 'CHANGE_DATE':
            return dateProfileGenerator.build(action.dateMarker);
        case 'PREV':
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) {
                return dp;
            }
            break;
        case 'NEXT':
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) {
                return dp;
            }
            break;
    }
    return currentDateProfile;
}

function initEventSources(calendarOptions, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null;
    return addSources({}, parseInitialSources(calendarOptions, context), activeRange, context);
}
function reduceEventSources(eventSources, action, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch (action.type) {
        case 'ADD_EVENT_SOURCES': // already parsed
            return addSources(eventSources, action.sources, activeRange, context);
        case 'REMOVE_EVENT_SOURCE':
            return removeSource(eventSources, action.sourceId);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) {
                return fetchDirtySources(eventSources, activeRange, context);
            }
            return eventSources;
        case 'FETCH_EVENT_SOURCES':
            return fetchSourcesByIds(eventSources, action.sourceIds ? // why no type?
                arrayToHash(action.sourceIds) :
                excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case 'RECEIVE_EVENTS':
        case 'RECEIVE_EVENT_ERROR':
            return receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return {};
        default:
            return eventSources;
    }
}
function reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return fetchSourcesByIds(eventSources, excludeStaticSources(eventSources, context), activeRange, true, context);
}
function computeEventSourcesLoading(eventSources) {
    for (var sourceId in eventSources) {
        if (eventSources[sourceId].isFetching) {
            return true;
        }
    }
    return false;
}
function addSources(eventSourceHash, sources, fetchRange, context) {
    var hash = {};
    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
        var source = sources_1[_i];
        hash[source.sourceId] = source;
    }
    if (fetchRange) {
        hash = fetchDirtySources(hash, fetchRange, context);
    }
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventSourceHash), hash);
}
function removeSource(eventSourceHash, sourceId) {
    return filterHash(eventSourceHash, function (eventSource) { return eventSource.sourceId !== sourceId; });
}
function fetchDirtySources(sourceHash, fetchRange, context) {
    return fetchSourcesByIds(sourceHash, filterHash(sourceHash, function (eventSource) { return isSourceDirty(eventSource, fetchRange, context); }), fetchRange, false, context);
}
function isSourceDirty(eventSource, fetchRange, context) {
    if (!doesSourceNeedRange(eventSource, context)) {
        return !eventSource.latestFetchId;
    }
    return !context.options.lazyFetching ||
        !eventSource.fetchRange ||
        eventSource.isFetching || // always cancel outdated in-progress fetches
        fetchRange.start < eventSource.fetchRange.start ||
        fetchRange.end > eventSource.fetchRange.end;
}
function fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    var nextSources = {};
    for (var sourceId in prevSources) {
        var source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) {
            nextSources[sourceId] = fetchSource(source, fetchRange, isRefetch, context);
        }
        else {
            nextSources[sourceId] = source;
        }
    }
    return nextSources;
}
function fetchSource(eventSource, fetchRange, isRefetch, context) {
    var options = context.options, calendarApi = context.calendarApi;
    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    var fetchId = guid();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context,
    }, function (res) {
        var rawEvents = res.rawEvents;
        if (options.eventSourceSuccess) {
            rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        }
        if (eventSource.success) {
            rawEvents = eventSource.success.call(calendarApi, rawEvents, res.xhr) || rawEvents;
        }
        context.dispatch({
            type: 'RECEIVE_EVENTS',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents,
        });
    }, function (error) {
        console.warn(error.message, error);
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
        }
        if (eventSource.failure) {
            eventSource.failure(error);
        }
        context.dispatch({
            type: 'RECEIVE_EVENT_ERROR',
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error,
        });
    });
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventSource), { isFetching: true, latestFetchId: fetchId });
}
function receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    var _a;
    var eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
        fetchId === eventSource.latestFetchId) {
        return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, sourceHash), (_a = {}, _a[sourceId] = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, eventSource), { isFetching: false, fetchRange: fetchRange }), _a));
    }
    return sourceHash;
}
function excludeStaticSources(eventSources, context) {
    return filterHash(eventSources, function (eventSource) { return doesSourceNeedRange(eventSource, context); });
}
function parseInitialSources(rawOptions, context) {
    var refiners = buildEventSourceRefiners(context);
    var rawSources = [].concat(rawOptions.eventSources || []);
    var sources = []; // parsed
    if (rawOptions.initialEvents) {
        rawSources.unshift(rawOptions.initialEvents);
    }
    if (rawOptions.events) {
        rawSources.unshift(rawOptions.events);
    }
    for (var _i = 0, rawSources_1 = rawSources; _i < rawSources_1.length; _i++) {
        var rawSource = rawSources_1[_i];
        var source = parseEventSource(rawSource, context, refiners);
        if (source) {
            sources.push(source);
        }
    }
    return sources;
}
function doesSourceNeedRange(eventSource, context) {
    var defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}

function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
    switch (action.type) {
        case 'RECEIVE_EVENTS': // raw
            return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case 'ADD_EVENTS': // already parsed, but not expanded
            return addEvent(eventStore, action.eventStore, // new ones
            dateProfile ? dateProfile.activeRange : null, context);
        case 'RESET_EVENTS':
            return action.eventStore;
        case 'MERGE_EVENTS': // already parsed and expanded
            return mergeEventStores(eventStore, action.eventStore);
        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
        case 'NEXT':
        case 'CHANGE_DATE':
        case 'CHANGE_VIEW_TYPE':
            if (dateProfile) {
                return expandRecurring(eventStore, dateProfile.activeRange, context);
            }
            return eventStore;
        case 'REMOVE_EVENTS':
            return excludeSubEventStore(eventStore, action.eventStore);
        case 'REMOVE_EVENT_SOURCE':
            return excludeEventsBySourceId(eventStore, action.sourceId);
        case 'REMOVE_ALL_EVENT_SOURCES':
            return filterEventStoreDefs(eventStore, function (eventDef) { return (!eventDef.sourceId // only keep events with no source id
            ); });
        case 'REMOVE_ALL_EVENTS':
            return createEmptyEventStore();
        default:
            return eventStore;
    }
}
function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
        fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        var subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) {
            subset = expandRecurring(subset, fetchRange, context);
        }
        return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function transformRawEvents(rawEvents, eventSource, context) {
    var calEachTransform = context.options.eventDataTransform;
    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) {
        rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
    }
    if (calEachTransform) {
        rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
    }
    return rawEvents;
}
function transformEachRawEvent(rawEvents, func) {
    var refinedEvents;
    if (!func) {
        refinedEvents = rawEvents;
    }
    else {
        refinedEvents = [];
        for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
            var rawEvent = rawEvents_1[_i];
            var refinedEvent = func(rawEvent);
            if (refinedEvent) {
                refinedEvents.push(refinedEvent);
            }
            else if (refinedEvent == null) {
                refinedEvents.push(rawEvent);
            } // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) {
        subset = expandRecurring(subset, expandRange, context);
    }
    return mergeEventStores(eventStore, subset);
}
function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
    var defs = eventStore.defs;
    var instances = mapHash(eventStore.instances, function (instance) {
        var def = defs[instance.defId];
        if (def.allDay || def.recurringDef) {
            return instance; // isn't dependent on timezone
        }
        return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, instance), { range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo)),
            }, forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo, forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo });
    });
    return { defs: defs, instances: instances };
}
function excludeEventsBySourceId(eventStore, sourceId) {
    return filterEventStoreDefs(eventStore, function (eventDef) { return eventDef.sourceId !== sourceId; });
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: filterHash(eventStore.instances, function (instance) { return !removals[instance.instanceId]; }),
    };
}

function reduceDateSelection(currentSelection, action) {
    switch (action.type) {
        case 'UNSELECT_DATES':
            return null;
        case 'SELECT_DATES':
            return action.selection;
        default:
            return currentSelection;
    }
}

function reduceSelectedEvent(currentInstanceId, action) {
    switch (action.type) {
        case 'UNSELECT_EVENT':
            return '';
        case 'SELECT_EVENT':
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}

function reduceEventDrag(currentDrag, action) {
    var newDrag;
    switch (action.type) {
        case 'UNSET_EVENT_DRAG':
            return null;
        case 'SET_EVENT_DRAG':
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent,
            };
        default:
            return currentDrag;
    }
}

function reduceEventResize(currentResize, action) {
    var newResize;
    switch (action.type) {
        case 'UNSET_EVENT_RESIZE':
            return null;
        case 'SET_EVENT_RESIZE':
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent,
            };
        default:
            return currentResize;
    }
}

function parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var header = calendarOptions.headerToolbar ? parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    var footer = calendarOptions.footerToolbar ? parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return { header: header, footer: footer };
}
function parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    var sectionWidgets = {};
    var viewsWithButtons = [];
    var hasTitle = false;
    for (var sectionName in sectionStrHash) {
        var sectionStr = sectionStrHash[sectionName];
        var sectionRes = parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push.apply(viewsWithButtons, sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return { sectionWidgets: sectionWidgets, viewsWithButtons: viewsWithButtons, hasTitle: hasTitle };
}
/*
BAD: querying icons and text here. should be done at render time
*/
function parseSection(sectionStr, calendarOptions, // defaults+overrides, then refined
calendarOptionOverrides, // overrides only!, unrefined :(
theme, viewSpecs, calendarApi) {
    var isRtl = calendarOptions.direction === 'rtl';
    var calendarCustomButtons = calendarOptions.customButtons || {};
    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    var calendarButtonText = calendarOptions.buttonText || {};
    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    var calendarButtonHints = calendarOptions.buttonHints || {};
    var sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
    var viewsWithButtons = [];
    var hasTitle = false;
    var widgets = sectionSubstrs.map(function (buttonGroupStr) { return (buttonGroupStr.split(',').map(function (buttonName) {
        if (buttonName === 'title') {
            hasTitle = true;
            return { buttonName: buttonName };
        }
        var customButtonProps;
        var viewSpec;
        var buttonClick;
        var buttonIcon; // only one of these will be set
        var buttonText; // "
        var buttonHint;
        // ^ for the title="" attribute, for accessibility
        if ((customButtonProps = calendarCustomButtons[buttonName])) {
            buttonClick = function (ev) {
                if (customButtonProps.click) {
                    customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                }
            };
            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = customButtonProps.text);
            buttonHint = customButtonProps.hint || customButtonProps.text;
        }
        else if ((viewSpec = viewSpecs[buttonName])) {
            viewsWithButtons.push(buttonName);
            buttonClick = function () {
                calendarApi.changeView(buttonName);
            };
            (buttonText = viewSpec.buttonTextOverride) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = viewSpec.buttonTextDefault);
            var textFallback = viewSpec.buttonTextOverride ||
                viewSpec.buttonTextDefault;
            buttonHint = formatWithOrdinals(viewSpec.buttonTitleOverride ||
                viewSpec.buttonTitleDefault ||
                calendarOptions.viewHint, [textFallback, buttonName], // view-name = buttonName
            textFallback);
        }
        else if (calendarApi[buttonName]) { // a calendarApi method
            buttonClick = function () {
                calendarApi[buttonName]();
            };
            (buttonText = calendarButtonTextOverrides[buttonName]) ||
                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
                (buttonText = calendarButtonText[buttonName]); // everything else is considered default
            if (buttonName === 'prevYear' || buttonName === 'nextYear') {
                var prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
                buttonHint = formatWithOrdinals(calendarButtonHintOverrides[prevOrNext] ||
                    calendarButtonHints[prevOrNext], [
                    calendarButtonText.year || 'year',
                    'year',
                ], calendarButtonText[buttonName]);
            }
            else {
                buttonHint = function (navUnit) { return formatWithOrdinals(calendarButtonHintOverrides[buttonName] ||
                    calendarButtonHints[buttonName], [
                    calendarButtonText[navUnit] || navUnit,
                    navUnit,
                ], calendarButtonText[buttonName]); };
            }
        }
        return { buttonName: buttonName, buttonClick: buttonClick, buttonIcon: buttonIcon, buttonText: buttonText, buttonHint: buttonHint };
    })); });
    return { widgets: widgets, viewsWithButtons: viewsWithButtons, hasTitle: hasTitle };
}

var eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta: function (refined) {
        if (Array.isArray(refined.events)) {
            return refined.events;
        }
        return null;
    },
    fetch: function (arg, success) {
        success({
            rawEvents: arg.eventSource.meta,
        });
    },
};
var arrayEventSourcePlugin = createPlugin({
    eventSourceDefs: [eventSourceDef$2],
});

var eventSourceDef$1 = {
    parseMeta: function (refined) {
        if (typeof refined.events === 'function') {
            return refined.events;
        }
        return null;
    },
    fetch: function (arg, success, failure) {
        var dateEnv = arg.context.dateEnv;
        var func = arg.eventSource.meta;
        unpromisify(func.bind(null, buildRangeApiWithTimeZone(arg.range, dateEnv)), function (rawEvents) {
            success({ rawEvents: rawEvents }); // needs an object response
        }, failure);
    },
};
var funcEventSourcePlugin = createPlugin({
    eventSourceDefs: [eventSourceDef$1],
});

function requestJson(method, url, params, successCallback, failureCallback) {
    method = method.toUpperCase();
    var body = null;
    if (method === 'GET') {
        url = injectQueryStringParams(url, params);
    }
    else {
        body = encodeParams(params);
    }
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    if (method !== 'GET') {
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            var parsed = false;
            var res = void 0;
            try {
                res = JSON.parse(xhr.responseText);
                parsed = true;
            }
            catch (err) {
                // will handle parsed=false
            }
            if (parsed) {
                successCallback(res, xhr);
            }
            else {
                failureCallback('Failure parsing JSON', xhr);
            }
        }
        else {
            failureCallback('Request failed', xhr);
        }
    };
    xhr.onerror = function () {
        failureCallback('Request failed', xhr);
    };
    xhr.send(body);
}
function injectQueryStringParams(url, params) {
    return url +
        (url.indexOf('?') === -1 ? '?' : '&') +
        encodeParams(params);
}
function encodeParams(params) {
    var parts = [];
    for (var key in params) {
        parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
    }
    return parts.join('&');
}

var JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: identity,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
};

var eventSourceDef = {
    parseMeta: function (refined) {
        if (refined.url && (refined.format === 'json' || !refined.format)) {
            return {
                url: refined.url,
                format: 'json',
                method: (refined.method || 'GET').toUpperCase(),
                extraParams: refined.extraParams,
                startParam: refined.startParam,
                endParam: refined.endParam,
                timeZoneParam: refined.timeZoneParam,
            };
        }
        return null;
    },
    fetch: function (arg, success, failure) {
        var meta = arg.eventSource.meta;
        var requestParams = buildRequestParams(meta, arg.range, arg.context);
        requestJson(meta.method, meta.url, requestParams, function (rawEvents, xhr) {
            success({ rawEvents: rawEvents, xhr: xhr });
        }, function (errorMessage, xhr) {
            failure({ message: errorMessage, xhr: xhr });
        });
    },
};
var jsonFeedEventSourcePlugin = createPlugin({
    eventSourceRefiners: JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [eventSourceDef],
});
function buildRequestParams(meta, range, context) {
    var dateEnv = context.dateEnv, options = context.options;
    var startParam;
    var endParam;
    var timeZoneParam;
    var customRequestParams;
    var params = {};
    startParam = meta.startParam;
    if (startParam == null) {
        startParam = options.startParam;
    }
    endParam = meta.endParam;
    if (endParam == null) {
        endParam = options.endParam;
    }
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) {
        timeZoneParam = options.timeZoneParam;
    }
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === 'function') {
        // supplied as a function that returns a key/value object
        customRequestParams = meta.extraParams();
    }
    else {
        // probably supplied as a straight key/value object
        customRequestParams = meta.extraParams || {};
    }
    node_modules_tslib_tslib_es6_assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== 'local') {
        params[timeZoneParam] = dateEnv.timeZone;
    }
    return params;
}

var SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: identity,
    startTime: createDuration,
    endTime: createDuration,
    duration: createDuration,
    startRecur: identity,
    endRecur: identity,
};

var recurring = {
    parse: function (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            var recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
            };
            var duration = void 0;
            if (refined.duration) {
                duration = refined.duration;
            }
            if (!duration && refined.startTime && refined.endTime) {
                duration = subtractDurations(refined.endTime, refined.startTime);
            }
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData, // doesn't need endTime anymore but oh well
            };
        }
        return null;
    },
    expand: function (typeData, framingRange, dateEnv) {
        var clippedFramingRange = intersectRanges(framingRange, { start: typeData.startRecur, end: typeData.endRecur });
        if (clippedFramingRange) {
            return expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        }
        return [];
    },
};
var simpleRecurringEventsPlugin = createPlugin({
    recurringTypes: [recurring],
    eventRefiners: SIMPLE_RECURRING_REFINERS,
});
function expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    var dowHash = daysOfWeek ? arrayToHash(daysOfWeek) : null;
    var dayMarker = startOfDay(framingRange.start);
    var endMarker = framingRange.end;
    var instanceStarts = [];
    while (dayMarker < endMarker) {
        var instanceStart 
        // if everyday, or this particular day-of-week
        = void 0;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) {
                instanceStart = dateEnv.add(dayMarker, startTime);
            }
            else {
                instanceStart = dayMarker;
            }
            instanceStarts.push(instanceStart);
        }
        dayMarker = addDays(dayMarker, 1);
    }
    return instanceStarts;
}

var changeHandlerPlugin = createPlugin({
    optionChangeHandlers: {
        events: function (events, context) {
            handleEventSources([events], context);
        },
        eventSources: handleEventSources,
    },
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/
function handleEventSources(inputs, context) {
    var unfoundSources = hashValuesToArray(context.getCurrentData().eventSources);
    var newInputs = [];
    for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
        var input = inputs_1[_i];
        var inputFound = false;
        for (var i = 0; i < unfoundSources.length; i += 1) {
            if (unfoundSources[i]._raw === input) {
                unfoundSources.splice(i, 1); // delete
                inputFound = true;
                break;
            }
        }
        if (!inputFound) {
            newInputs.push(input);
        }
    }
    for (var _a = 0, unfoundSources_1 = unfoundSources; _a < unfoundSources_1.length; _a++) {
        var unfoundSource = unfoundSources_1[_a];
        context.dispatch({
            type: 'REMOVE_EVENT_SOURCE',
            sourceId: unfoundSource.sourceId,
        });
    }
    for (var _b = 0, newInputs_1 = newInputs; _b < newInputs_1.length; _b++) {
        var newInput = newInputs_1[_b];
        context.calendarApi.addEventSource(newInput);
    }
}

function handleDateProfile(dateProfile, context) {
    context.emitter.trigger('datesSet', node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, buildRangeApiWithTimeZone(dateProfile.activeRange, context.dateEnv)), { view: context.viewApi }));
}

function handleEventStore(eventStore, context) {
    var emitter = context.emitter;
    if (emitter.hasHandlers('eventsSet')) {
        emitter.trigger('eventsSet', buildEventApis(eventStore, context));
    }
}

/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/
var globalPlugins = [
    arrayEventSourcePlugin,
    funcEventSourcePlugin,
    jsonFeedEventSourcePlugin,
    simpleRecurringEventsPlugin,
    changeHandlerPlugin,
    createPlugin({
        isLoadingFuncs: [
            function (state) { return computeEventSourcesLoading(state.eventSources); },
        ],
        contentTypeHandlers: {
            html: buildHtmlRenderer,
            domNodes: buildDomNodeRenderer,
        },
        propSetHandlers: {
            dateProfile: handleDateProfile,
            eventStore: handleEventStore,
        },
    }),
];
function buildHtmlRenderer() {
    var currentEl = null;
    var currentHtml = '';
    function render(el, html) {
        if (el !== currentEl || html !== currentHtml) {
            el.innerHTML = html;
        }
        currentEl = el;
        currentHtml = html;
    }
    function destroy() {
        currentEl.innerHTML = '';
        currentEl = null;
        currentHtml = '';
    }
    return { render: render, destroy: destroy };
}
function buildDomNodeRenderer() {
    var currentEl = null;
    var currentDomNodes = [];
    function render(el, domNodes) {
        var newDomNodes = Array.prototype.slice.call(domNodes);
        if (el !== currentEl || !isArraysEqual(currentDomNodes, newDomNodes)) {
            // append first, remove second (for scroll resetting)
            for (var _i = 0, newDomNodes_1 = newDomNodes; _i < newDomNodes_1.length; _i++) {
                var newNode = newDomNodes_1[_i];
                el.appendChild(newNode);
            }
            destroy();
        }
        currentEl = el;
        currentDomNodes = newDomNodes;
    }
    function destroy() {
        currentDomNodes.forEach(removeElement);
        currentDomNodes = [];
        currentEl = null;
    }
    return { render: render, destroy: destroy };
}

var DelayedRunner = /** @class */ (function () {
    function DelayedRunner(drainedOption) {
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
    DelayedRunner.prototype.request = function (delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) {
                this.tryDrain();
            }
            else {
                this.timeoutId = setTimeout(// NOT OPTIMAL! TODO: look at debounce
                this.tryDrain.bind(this), delay);
            }
        }
    };
    DelayedRunner.prototype.pause = function (scope) {
        if (scope === void 0) { scope = ''; }
        var pauseDepths = this.pauseDepths;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    };
    DelayedRunner.prototype.resume = function (scope, force) {
        if (scope === void 0) { scope = ''; }
        var pauseDepths = this.pauseDepths;
        if (scope in pauseDepths) {
            if (force) {
                delete pauseDepths[scope];
            }
            else {
                pauseDepths[scope] -= 1;
                var depth = pauseDepths[scope];
                if (depth <= 0) {
                    delete pauseDepths[scope];
                }
            }
            this.tryDrain();
        }
    };
    DelayedRunner.prototype.isPaused = function () {
        return Object.keys(this.pauseDepths).length;
    };
    DelayedRunner.prototype.tryDrain = function () {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while (this.isDirty) {
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    };
    DelayedRunner.prototype.clear = function () {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    };
    DelayedRunner.prototype.clearTimeout = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    };
    DelayedRunner.prototype.drained = function () {
        if (this.drainedOption) {
            this.drainedOption();
        }
    };
    return DelayedRunner;
}());

var TaskRunner = /** @class */ (function () {
    function TaskRunner(runTaskOption, drainedOption) {
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new DelayedRunner(this.drain.bind(this));
    }
    TaskRunner.prototype.request = function (task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    };
    TaskRunner.prototype.pause = function (scope) {
        this.delayedRunner.pause(scope);
    };
    TaskRunner.prototype.resume = function (scope, force) {
        this.delayedRunner.resume(scope, force);
    };
    TaskRunner.prototype.drain = function () {
        var queue = this.queue;
        while (queue.length) {
            var completedTasks = [];
            var task = void 0;
            while ((task = queue.shift())) {
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    };
    TaskRunner.prototype.runTask = function (task) {
        if (this.runTaskOption) {
            this.runTaskOption(task);
        }
    };
    TaskRunner.prototype.drained = function (completedTasks) {
        if (this.drainedOption) {
            this.drainedOption(completedTasks);
        }
    };
    return TaskRunner;
}());

// Computes what the title at the top of the calendarApi should be for this view
function buildTitle(dateProfile, viewOptions, dateEnv) {
    var range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
        range = dateProfile.currentRange;
    }
    else { // for day units or smaller, use the actual day range
        range = dateProfile.activeRange;
    }
    return dateEnv.formatRange(range.start, range.end, createFormatter(viewOptions.titleFormat || buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator,
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function buildTitleFormat(dateProfile) {
    var currentRangeUnit = dateProfile.currentRangeUnit;
    if (currentRangeUnit === 'year') {
        return { year: 'numeric' };
    }
    if (currentRangeUnit === 'month') {
        return { year: 'numeric', month: 'long' }; // like "September 2014"
    }
    var days = diffWholeDays(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) {
        // multi-day range. shorter, like "Sep 9 - 10 2014"
        return { year: 'numeric', month: 'short', day: 'numeric' };
    }
    // one day. longer, like "September 9 2014"
    return { year: 'numeric', month: 'long', day: 'numeric' };
}

// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
var CalendarDataManager = /** @class */ (function () {
    function CalendarDataManager(props) {
        var _this = this;
        this.computeOptionsData = memoize(this._computeOptionsData);
        this.computeCurrentViewData = memoize(this._computeCurrentViewData);
        this.organizeRawLocales = memoize(organizeRawLocales);
        this.buildLocale = memoize(buildLocale);
        this.buildPluginHooks = buildBuildPluginHooks();
        this.buildDateEnv = memoize(buildDateEnv);
        this.buildTheme = memoize(buildTheme);
        this.parseToolbars = memoize(parseToolbars);
        this.buildViewSpecs = memoize(buildViewSpecs);
        this.buildDateProfileGenerator = memoizeObjArg(buildDateProfileGenerator);
        this.buildViewApi = memoize(buildViewApi);
        this.buildViewUiProps = memoizeObjArg(buildViewUiProps);
        this.buildEventUiBySource = memoize(buildEventUiBySource, isPropsEqual);
        this.buildEventUiBases = memoize(buildEventUiBases);
        this.parseContextBusinessHours = memoizeObjArg(parseContextBusinessHours);
        this.buildTitle = memoize(buildTitle);
        this.emitter = new Emitter();
        this.actionRunner = new TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.getCurrentData = function () { return _this.data; };
        this.dispatch = function (action) {
            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        var dynamicOptionOverrides = {};
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        var currentDate = getInitialDate(optionsData.calendarOptions, optionsData.dateEnv);
        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!rangeContainsMarker(dateProfile.activeRange, currentDate)) {
            currentDate = dateProfile.currentRange.start;
        }
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData,
        };
        // needs to be after setThisContext
        for (var _i = 0, _a = optionsData.pluginHooks.contextInit; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(calendarContext);
        }
        // NOT DRY
        var eventSources = initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        var initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: createEmptyEventStore(),
            renderableEventStore: createEmptyEventStore(),
            dateSelection: null,
            eventSelection: '',
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig,
        };
        var contextAndState = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, calendarContext), initialState);
        for (var _b = 0, _c = optionsData.pluginHooks.reducers; _b < _c.length; _b++) {
            var reducer = _c[_b];
            node_modules_tslib_tslib_es6_assign(initialState, reducer(null, null, contextAndState));
        }
        if (computeIsLoading(initialState, calendarContext)) {
            this.emitter.trigger('loading', true); // NOT DRY
        }
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
    CalendarDataManager.prototype.resetOptions = function (optionOverrides, append) {
        var props = this.props;
        props.optionOverrides = append
            ? node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, props.optionOverrides), optionOverrides) : optionOverrides;
        this.actionRunner.request({
            type: 'NOTHING',
        });
    };
    CalendarDataManager.prototype._handleAction = function (action) {
        var _a = this, props = _a.props, state = _a.state, emitter = _a.emitter;
        var dynamicOptionOverrides = reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        var currentViewType = reduceViewType(state.currentViewType, action);
        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        var calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData,
        };
        var currentDate = state.currentDate, dateProfile = state.dateProfile;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) { // hack
            dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        }
        currentDate = reduceCurrentDate(currentDate, action);
        dateProfile = reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
            action.type === 'NEXT' || // "
            !rangeContainsMarker(dateProfile.currentRange, currentDate)) {
            currentDate = dateProfile.currentRange.start;
        }
        var eventSources = reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        var eventStore = reduceEventStore(state.eventStore, action, eventSources, dateProfile, calendarContext);
        var isEventsLoading = computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        var renderableEventStore = (isEventsLoading && !currentViewData.options.progressiveEventRendering) ?
            (state.renderableEventStore || eventStore) : // try from previous state
            eventStore;
        var _b = this.buildViewUiProps(calendarContext), eventUiSingleBase = _b.eventUiSingleBase, selectionConfig = _b.selectionConfig; // will memoize obj
        var eventUiBySource = this.buildEventUiBySource(eventSources);
        var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        var newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: reduceDateSelection(state.dateSelection, action),
            eventSelection: reduceSelectedEvent(state.eventSelection, action),
            eventDrag: reduceEventDrag(state.eventDrag, action),
            eventResize: reduceEventResize(state.eventResize, action),
        };
        var contextAndState = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, calendarContext), newState);
        for (var _i = 0, _c = optionsData.pluginHooks.reducers; _i < _c.length; _i++) {
            var reducer = _c[_i];
            node_modules_tslib_tslib_es6_assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        }
        var wasLoading = computeIsLoading(state, calendarContext);
        var isLoading = computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) {
            emitter.trigger('loading', true);
        }
        else if (wasLoading && !isLoading) {
            emitter.trigger('loading', false);
        }
        this.state = newState;
        if (props.onAction) {
            props.onAction(action);
        }
    };
    CalendarDataManager.prototype.updateData = function () {
        var _a = this, props = _a.props, state = _a.state;
        var oldData = this.data;
        var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        var data = this.data = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({ viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv), calendarApi: props.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, optionsData), currentViewData), state);
        var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        var oldCalendarOptions = oldData && oldData.calendarOptions;
        var newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = rezoneEventStoreDates(data.eventStore, oldData.dateEnv, data.dateEnv);
            }
            for (var optionName in changeHandlers) {
                if (oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) {
                    changeHandlers[optionName](newCalendarOptions[optionName], data);
                }
            }
        }
        if (props.onData) {
            props.onData(data);
        }
    };
    CalendarDataManager.prototype._computeOptionsData = function (optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        var _a = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, pluginHooks = _a.pluginHooks, localeDefaults = _a.localeDefaults, availableLocaleData = _a.availableLocaleData, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        var viewSpecs = this.buildViewSpecs(pluginHooks.views, optionOverrides, dynamicOptionOverrides, localeDefaults);
        var theme = this.buildTheme(refinedOptions, pluginHooks);
        var toolbarConfig = this.parseToolbars(refinedOptions, optionOverrides, theme, viewSpecs, calendarApi);
        return {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map,
        };
    };
    // always called from behind a memoizer
    CalendarDataManager.prototype.processRawCalendarOptions = function (optionOverrides, dynamicOptionOverrides) {
        var _a = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            optionOverrides,
            dynamicOptionOverrides,
        ]), locales = _a.locales, locale = _a.locale;
        var availableLocaleData = this.organizeRawLocales(locales);
        var availableRawLocales = availableLocaleData.map;
        var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], globalPlugins);
        var refiners = this.currentCalendarOptionsRefiners = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var extra = {};
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides,
        ]);
        var refined = {};
        var currentRaw = this.currentCalendarOptionsInput;
        var currentRefined = this.currentCalendarOptionsRefined;
        var anyChanges = false;
        for (var optionName in raw) {
            if (optionName !== 'plugins') { // because plugins is special-cased
                if (raw[optionName] === currentRaw[optionName] ||
                    (COMPLEX_OPTION_COMPARATORS[optionName] &&
                        (optionName in currentRaw) &&
                        COMPLEX_OPTION_COMPARATORS[optionName](currentRaw[optionName], raw[optionName]))) {
                    refined[optionName] = currentRefined[optionName];
                }
                else if (refiners[optionName]) {
                    refined[optionName] = refiners[optionName](raw[optionName]);
                    anyChanges = true;
                }
                else {
                    extra[optionName] = currentRaw[optionName];
                }
            }
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra,
        };
    };
    CalendarDataManager.prototype._computeCurrentViewData = function (viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        var viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) {
            throw new Error("viewType \"" + viewType + "\" is not available. Please make sure you've loaded all neccessary plugins");
        }
        var _a = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, extra = _a.extra;
        warnUnknownOptions(extra);
        var dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            nowInput: refinedOptions.now,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            monthMode: refinedOptions.monthMode,
            fixedWeekCount: refinedOptions.fixedWeekCount,
        });
        var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return { viewSpec: viewSpec, options: refinedOptions, dateProfileGenerator: dateProfileGenerator, viewApi: viewApi };
    };
    CalendarDataManager.prototype.processRawViewOptions = function (viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        var raw = mergeRawOptions([
            BASE_OPTION_DEFAULTS,
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides,
        ]);
        var refiners = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), VIEW_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        var refined = {};
        var currentRaw = this.currentViewOptionsInput;
        var currentRefined = this.currentViewOptionsRefined;
        var anyChanges = false;
        var extra = {};
        for (var optionName in raw) {
            if (raw[optionName] === currentRaw[optionName]) {
                refined[optionName] = currentRefined[optionName];
            }
            else {
                if (raw[optionName] === this.currentCalendarOptionsInput[optionName]) {
                    if (optionName in this.currentCalendarOptionsRefined) { // might be an "extra" prop
                        refined[optionName] = this.currentCalendarOptionsRefined[optionName];
                    }
                }
                else if (refiners[optionName]) {
                    refined[optionName] = refiners[optionName](raw[optionName]);
                }
                else {
                    extra[optionName] = raw[optionName];
                }
                anyChanges = true;
            }
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra,
        };
    };
    return CalendarDataManager;
}());
function buildDateEnv(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    var locale = buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new DateEnv({
        calendarSystem: 'gregory',
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator,
    });
}
function buildTheme(options, pluginHooks) {
    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || StandardTheme;
    return new ThemeClass(options);
}
function buildDateProfileGenerator(props) {
    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || DateProfileGenerator;
    return new DateProfileGeneratorClass(props);
}
function buildViewApi(type, getCurrentData, dateEnv) {
    return new ViewApi(type, getCurrentData, dateEnv);
}
function buildEventUiBySource(eventSources) {
    return mapHash(eventSources, function (eventSource) { return eventSource.ui; });
}
function buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    var eventUiBases = { '': eventUiSingleBase };
    for (var defId in eventDefs) {
        var def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) {
            eventUiBases[defId] = eventUiBySource[def.sourceId];
        }
    }
    return eventUiBases;
}
function buildViewUiProps(calendarContext) {
    var options = calendarContext.options;
    return {
        eventUiSingleBase: createEventUi({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor,
            // classNames: options.eventClassNames // render hook will handle this
        }, calendarContext),
        selectionConfig: createEventUi({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
            allow: options.selectAllow,
        }, calendarContext),
    };
}
function computeIsLoading(state, context) {
    for (var _i = 0, _a = context.pluginHooks.isLoadingFuncs; _i < _a.length; _i++) {
        var isLoadingFunc = _a[_i];
        if (isLoadingFunc(state)) {
            return true;
        }
    }
    return false;
}
function parseContextBusinessHours(calendarContext) {
    return parseBusinessHours(calendarContext.options.businessHours, calendarContext);
}
function warnUnknownOptions(options, viewName) {
    for (var optionName in options) {
        console.warn("Unknown option '" + optionName + "'" +
            (viewName ? " for view '" + viewName + "'" : ''));
    }
}

// TODO: move this to react plugin?
var CalendarDataProvider = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(CalendarDataProvider, _super);
    function CalendarDataProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.handleData = function (data) {
            if (!_this.dataManager) { // still within initial run, before assignment in constructor
                // eslint-disable-next-line react/no-direct-mutation-state
                _this.state = data; // can't use setState yet
            }
            else {
                _this.setState(data);
            }
        };
        _this.dataManager = new CalendarDataManager({
            optionOverrides: props.optionOverrides,
            calendarApi: props.calendarApi,
            onData: _this.handleData,
        });
        return _this;
    }
    CalendarDataProvider.prototype.render = function () {
        return this.props.children(this.state);
    };
    CalendarDataProvider.prototype.componentDidUpdate = function (prevProps) {
        var newOptionOverrides = this.props.optionOverrides;
        if (newOptionOverrides !== prevProps.optionOverrides) { // prevent recursive handleData
            this.dataManager.resetOptions(newOptionOverrides);
        }
    };
    return CalendarDataProvider;
}(vdom_Component));

// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/
function sliceEvents(props, allDay) {
    return sliceEventStore(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}

var NamedTimeZoneImpl = /** @class */ (function () {
    function NamedTimeZoneImpl(timeZoneName) {
        this.timeZoneName = timeZoneName;
    }
    return NamedTimeZoneImpl;
}());

var SegHierarchy = /** @class */ (function () {
    function SegHierarchy() {
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
    SegHierarchy.prototype.addSegs = function (inputs) {
        var hiddenEntries = [];
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            this.insertEntry(input, hiddenEntries);
        }
        return hiddenEntries;
    };
    SegHierarchy.prototype.insertEntry = function (entry, hiddenEntries) {
        var insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) {
            this.insertEntryAt(entry, insertion);
            return 1;
        }
        return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    };
    SegHierarchy.prototype.isInsertionValid = function (insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) &&
            (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    };
    // returns number of new entries inserted
    SegHierarchy.prototype.handleInvalidInsertion = function (insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) {
            return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        }
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.splitEntry = function (entry, barrier, hiddenEntries) {
        var partCnt = 0;
        var splitHiddenEntries = [];
        var entrySpan = entry.span;
        var barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) {
            partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: { start: entrySpan.start, end: barrierSpan.start },
            }, splitHiddenEntries);
        }
        if (entrySpan.end > barrierSpan.end) {
            partCnt += this.insertEntry({
                index: entry.index,
                thickness: entry.thickness,
                span: { start: barrierSpan.end, end: entrySpan.end },
            }, splitHiddenEntries);
        }
        if (partCnt) {
            hiddenEntries.push.apply(hiddenEntries, tslib_tslib_es6_spreadArray([{
                    index: entry.index,
                    thickness: entry.thickness,
                    span: intersectSpans(barrierSpan, entrySpan), // guaranteed to intersect
                }], splitHiddenEntries));
            return partCnt;
        }
        hiddenEntries.push(entry);
        return 0;
    };
    SegHierarchy.prototype.insertEntryAt = function (entry, insertion) {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        if (insertion.lateral === -1) {
            // create a new level
            insertAt(levelCoords, insertion.level, insertion.levelCoord);
            insertAt(entriesByLevel, insertion.level, [entry]);
        }
        else {
            // insert into existing level
            insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        }
        this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
    };
    SegHierarchy.prototype.findInsertion = function (newEntry) {
        var _a = this, levelCoords = _a.levelCoords, entriesByLevel = _a.entriesByLevel, strictOrder = _a.strictOrder, stackCnts = _a.stackCnts;
        var levelCnt = levelCoords.length;
        var candidateCoord = 0;
        var touchingLevel = -1;
        var touchingLateral = -1;
        var touchingEntry = null;
        var stackCnt = 0;
        for (var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1) {
            var trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) {
                break;
            }
            var trackingEntries = entriesByLevel[trackingLevel];
            var trackingEntry = void 0;
            var searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end
            var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while ( // loop through entries that horizontally intersect
            (trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
                trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ) {
                var trackingEntryBottom = trackingCoord + trackingEntry.thickness;
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) {
                    // accumulate the highest possible stackCnt of the trackingEntries that butt up
                    stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
                }
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        var destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while (destLevel < levelCnt && levelCoords[destLevel] < candidateCoord) {
                destLevel += 1;
            }
        }
        // if adding to an existing level, find where to insert
        var destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) {
            destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
        }
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral,
        };
    };
    // sorted by levelCoord (lowest to highest)
    SegHierarchy.prototype.toRects = function () {
        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
        var levelCnt = entriesByLevel.length;
        var rects = [];
        for (var level = 0; level < levelCnt; level += 1) {
            var entries = entriesByLevel[level];
            var levelCoord = levelCoords[level];
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                rects.push(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, entry), { levelCoord: levelCoord }));
            }
        }
        return rects;
    };
    return SegHierarchy;
}());
function getEntrySpanEnd(entry) {
    return entry.span.end;
}
function buildEntryKey(entry) {
    return entry.index + ':' + entry.span.start;
}
// returns groups with entries sorted by input order
function groupIntersectingEntries(entries) {
    var merges = [];
    for (var _i = 0, entries_2 = entries; _i < entries_2.length; _i++) {
        var entry = entries_2[_i];
        var filteredMerges = [];
        var hungryMerge = {
            span: entry.span,
            entries: [entry],
        };
        for (var _a = 0, merges_1 = merges; _a < merges_1.length; _a++) {
            var merge = merges_1[_a];
            if (intersectSpans(merge.span, hungryMerge.span)) {
                hungryMerge = {
                    entries: merge.entries.concat(hungryMerge.entries),
                    span: joinSpans(merge.span, hungryMerge.span),
                };
            }
            else {
                filteredMerges.push(merge);
            }
        }
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end),
    };
}
function intersectSpans(span0, span1) {
    var start = Math.max(span0.start, span1.start);
    var end = Math.min(span0.end, span1.end);
    if (start < end) {
        return { start: start, end: end };
    }
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function binarySearch(a, searchVal, getItemVal) {
    var startIndex = 0;
    var endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) { // no items OR before first item
        return [0, 0];
    }
    if (searchVal > getItemVal(a[endIndex - 1])) { // after last item
        return [endIndex, 0];
    }
    while (startIndex < endIndex) {
        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        var middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) {
            endIndex = middleIndex;
        }
        else if (searchVal > middleVal) {
            startIndex = middleIndex + 1;
        }
        else { // equal!
            return [middleIndex, 1];
        }
    }
    return [startIndex, 0];
}

var Interaction = /** @class */ (function () {
    function Interaction(settings) {
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
    Interaction.prototype.destroy = function () {
    };
    return Interaction;
}());
function parseInteractionSettings(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null,
    };
}
function interactionSettingsToStore(settings) {
    var _a;
    return _a = {},
        _a[settings.component.uid] = settings,
        _a;
}
// global state
var interactionSettingsStore = {};

/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/
var ElementDragging = /** @class */ (function () {
    function ElementDragging(el, selector) {
        this.emitter = new Emitter();
    }
    ElementDragging.prototype.destroy = function () {
    };
    ElementDragging.prototype.setMirrorIsVisible = function (bool) {
        // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setMirrorNeedsRevert = function (bool) {
        // optional if subclass doesn't want to support a mirror
    };
    ElementDragging.prototype.setAutoScrollEnabled = function (bool) {
        // optional
    };
    return ElementDragging;
}());

// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
var config = {};

/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/
var DRAG_META_REFINERS = {
    startTime: createDuration,
    duration: createDuration,
    create: Boolean,
    sourceId: String,
};
function parseDragMeta(raw) {
    var _a = refineProps(raw, DRAG_META_REFINERS), refined = _a.refined, extra = _a.extra;
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra,
    };
}

var ToolbarSection = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(ToolbarSection, _super);
    function ToolbarSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarSection.prototype.render = function () {
        var _this = this;
        var children = this.props.widgetGroups.map(function (widgetGroup) { return _this.renderWidgetGroup(widgetGroup); });
        return createElement.apply(void 0, tslib_tslib_es6_spreadArray(['div', { className: 'fc-toolbar-chunk' }], children));
    };
    ToolbarSection.prototype.renderWidgetGroup = function (widgetGroup) {
        var props = this.props;
        var theme = this.context.theme;
        var children = [];
        var isOnlyButtons = true;
        for (var _i = 0, widgetGroup_1 = widgetGroup; _i < widgetGroup_1.length; _i++) {
            var widget = widgetGroup_1[_i];
            var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
            if (buttonName === 'title') {
                isOnlyButtons = false;
                children.push(createElement("h2", { className: "fc-toolbar-title", id: props.titleId }, props.title));
            }
            else {
                var isPressed = buttonName === props.activeButton;
                var isDisabled = (!props.isTodayEnabled && buttonName === 'today') ||
                    (!props.isPrevEnabled && buttonName === 'prev') ||
                    (!props.isNextEnabled && buttonName === 'next');
                var buttonClasses = ["fc-" + buttonName + "-button", theme.getClass('button')];
                if (isPressed) {
                    buttonClasses.push(theme.getClass('buttonActive'));
                }
                children.push(createElement("button", { type: "button", title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint, disabled: isDisabled, "aria-pressed": isPressed, className: buttonClasses.join(' '), onClick: buttonClick }, buttonText || (buttonIcon ? createElement("span", { className: buttonIcon }) : '')));
            }
        }
        if (children.length > 1) {
            var groupClassName = (isOnlyButtons && theme.getClass('buttonGroup')) || '';
            return createElement.apply(void 0, tslib_tslib_es6_spreadArray(['div', { className: groupClassName }], children));
        }
        return children[0];
    };
    return ToolbarSection;
}(BaseComponent));

var Toolbar = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(Toolbar, _super);
    function Toolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toolbar.prototype.render = function () {
        var _a = this.props, model = _a.model, extraClassName = _a.extraClassName;
        var forceLtr = false;
        var startContent;
        var endContent;
        var sectionWidgets = model.sectionWidgets;
        var centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        }
        else {
            startContent = sectionWidgets.start;
        }
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        }
        else {
            endContent = sectionWidgets.end;
        }
        var classNames = [
            extraClassName || '',
            'fc-toolbar',
            forceLtr ? 'fc-toolbar-ltr' : '',
        ];
        return (createElement("div", { className: classNames.join(' ') },
            this.renderSection('start', startContent || []),
            this.renderSection('center', centerContent || []),
            this.renderSection('end', endContent || [])));
    };
    Toolbar.prototype.renderSection = function (key, widgetGroups) {
        var props = this.props;
        return (createElement(ToolbarSection, { key: key, widgetGroups: widgetGroups, title: props.title, navUnit: props.navUnit, activeButton: props.activeButton, isTodayEnabled: props.isTodayEnabled, isPrevEnabled: props.isPrevEnabled, isNextEnabled: props.isNextEnabled, titleId: props.titleId }));
    };
    return Toolbar;
}(BaseComponent));

// TODO: do function component?
var ViewContainer = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(ViewContainer, _super);
    function ViewContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            availableWidth: null,
        };
        _this.handleEl = function (el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
            _this.updateAvailableWidth();
        };
        _this.handleResize = function () {
            _this.updateAvailableWidth();
        };
        return _this;
    }
    ViewContainer.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var aspectRatio = props.aspectRatio;
        var classNames = [
            'fc-view-harness',
            (aspectRatio || props.liquid || props.height)
                ? 'fc-view-harness-active' // harness controls the height
                : 'fc-view-harness-passive', // let the view do the height
        ];
        var height = '';
        var paddingBottom = '';
        if (aspectRatio) {
            if (state.availableWidth !== null) {
                height = state.availableWidth / aspectRatio;
            }
            else {
                // while waiting to know availableWidth, we can't set height to *zero*
                // because will cause lots of unnecessary scrollbars within scrollgrid.
                // BETTER: don't start rendering ANYTHING yet until we know container width
                // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
                paddingBottom = (1 / aspectRatio) * 100 + "%";
            }
        }
        else {
            height = props.height || '';
        }
        return (createElement("div", { "aria-labelledby": props.labeledById, ref: this.handleEl, className: classNames.join(' '), style: { height: height, paddingBottom: paddingBottom } }, props.children));
    };
    ViewContainer.prototype.componentDidMount = function () {
        this.context.addResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.componentWillUnmount = function () {
        this.context.removeResizeHandler(this.handleResize);
    };
    ViewContainer.prototype.updateAvailableWidth = function () {
        if (this.el && // needed. but why?
            this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) {
            this.setState({ availableWidth: this.el.offsetWidth });
        }
    };
    return ViewContainer;
}(BaseComponent));

/*
Detects when the user clicks on an event within a DateComponent
*/
var EventClicking = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(EventClicking, _super);
    function EventClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handleSegClick = function (ev, segEl) {
            var component = _this.component;
            var context = component.context;
            var seg = getElSeg(segEl);
            if (seg && // might be the <div> surrounding the more link
                component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                var hasUrlContainer = elementClosest(ev.target, '.fc-event-forced-url');
                var url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
                context.emitter.trigger('eventClick', {
                    el: segEl,
                    event: new EventApi(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi,
                });
                if (url && !ev.defaultPrevented) {
                    window.location.href = url;
                }
            }
        };
        _this.destroy = listenBySelector(settings.el, 'click', '.fc-event', // on both fg and bg events
        _this.handleSegClick);
        return _this;
    }
    return EventClicking;
}(Interaction));

/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/
var EventHovering = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(EventHovering, _super);
    function EventHovering(settings) {
        var _this = _super.call(this, settings) || this;
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        _this.handleEventElRemove = function (el) {
            if (el === _this.currentSegEl) {
                _this.handleSegLeave(null, _this.currentSegEl);
            }
        };
        _this.handleSegEnter = function (ev, segEl) {
            if (getElSeg(segEl)) { // TODO: better way to make sure not hovering over more+ link or its wrapper
                _this.currentSegEl = segEl;
                _this.triggerEvent('eventMouseEnter', ev, segEl);
            }
        };
        _this.handleSegLeave = function (ev, segEl) {
            if (_this.currentSegEl) {
                _this.currentSegEl = null;
                _this.triggerEvent('eventMouseLeave', ev, segEl);
            }
        };
        _this.removeHoverListeners = listenToHoverBySelector(settings.el, '.fc-event', // on both fg and bg events
        _this.handleSegEnter, _this.handleSegLeave);
        return _this;
    }
    EventHovering.prototype.destroy = function () {
        this.removeHoverListeners();
    };
    EventHovering.prototype.triggerEvent = function (publicEvName, ev, segEl) {
        var component = this.component;
        var context = component.context;
        var seg = getElSeg(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) {
            context.emitter.trigger(publicEvName, {
                el: segEl,
                event: new EventApi(context, seg.eventRange.def, seg.eventRange.instance),
                jsEvent: ev,
                view: context.viewApi,
            });
        }
    };
    return EventHovering;
}(Interaction));

var CalendarContent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(CalendarContent, _super);
    function CalendarContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildViewContext = memoize(buildViewContext);
        _this.buildViewPropTransformers = memoize(buildViewPropTransformers);
        _this.buildToolbarProps = memoize(buildToolbarProps);
        _this.headerRef = createRef();
        _this.footerRef = createRef();
        _this.interactionsStore = {};
        // eslint-disable-next-line
        _this.state = {
            viewLabelId: getUniqueDomId(),
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        _this.registerInteractiveComponent = function (component, settingsInput) {
            var settings = parseInteractionSettings(component, settingsInput);
            var DEFAULT_INTERACTIONS = [
                EventClicking,
                EventHovering,
            ];
            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
            var interactions = interactionClasses.map(function (TheInteractionClass) { return new TheInteractionClass(settings); });
            _this.interactionsStore[component.uid] = interactions;
            interactionSettingsStore[component.uid] = settings;
        };
        _this.unregisterInteractiveComponent = function (component) {
            var listeners = _this.interactionsStore[component.uid];
            if (listeners) {
                for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                    var listener = listeners_1[_i];
                    listener.destroy();
                }
                delete _this.interactionsStore[component.uid];
            }
            delete interactionSettingsStore[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        _this.resizeRunner = new DelayedRunner(function () {
            _this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
            _this.props.emitter.trigger('windowResize', { view: _this.props.viewApi });
        });
        _this.handleWindowResize = function (ev) {
            var options = _this.props.options;
            if (options.handleWindowResize &&
                ev.target === window // avoid jqui events
            ) {
                _this.resizeRunner.request(options.windowResizeDelay);
            }
        };
        return _this;
    }
    /*
    renders INSIDE of an outer div
    */
    CalendarContent.prototype.render = function () {
        var props = this.props;
        var toolbarConfig = props.toolbarConfig, options = props.options;
        var toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, getNow(props.options.now, props.dateEnv), // TODO: use NowTimer????
        props.viewTitle);
        var viewVGrow = false;
        var viewHeight = '';
        var viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) {
            viewHeight = '';
        }
        else if (options.height != null) {
            viewVGrow = true;
        }
        else if (options.contentHeight != null) {
            viewHeight = options.contentHeight;
        }
        else {
            viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        }
        var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        var viewLabelId = (toolbarConfig.header && toolbarConfig.header.hasTitle)
            ? this.state.viewLabelId
            : '';
        return (createElement(ViewContextType.Provider, { value: viewContext },
            toolbarConfig.header && (createElement(Toolbar, node_modules_tslib_tslib_es6_assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: toolbarConfig.header, titleId: viewLabelId }, toolbarProps))),
            createElement(ViewContainer, { liquid: viewVGrow, height: viewHeight, aspectRatio: viewAspectRatio, labeledById: viewLabelId },
                this.renderView(props),
                this.buildAppendContent()),
            toolbarConfig.footer && (createElement(Toolbar, node_modules_tslib_tslib_es6_assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: toolbarConfig.footer, titleId: "" }, toolbarProps)))));
    };
    CalendarContent.prototype.componentDidMount = function () {
        var props = this.props;
        this.calendarInteractions = props.pluginHooks.calendarInteractions
            .map(function (CalendarInteractionClass) { return new CalendarInteractionClass(props); });
        window.addEventListener('resize', this.handleWindowResize);
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for (var propName in propSetHandlers) {
            propSetHandlers[propName](props[propName], props);
        }
    };
    CalendarContent.prototype.componentDidUpdate = function (prevProps) {
        var props = this.props;
        var propSetHandlers = props.pluginHooks.propSetHandlers;
        for (var propName in propSetHandlers) {
            if (props[propName] !== prevProps[propName]) {
                propSetHandlers[propName](props[propName], props);
            }
        }
    };
    CalendarContent.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
        this.resizeRunner.clear();
        for (var _i = 0, _a = this.calendarInteractions; _i < _a.length; _i++) {
            var interaction = _a[_i];
            interaction.destroy();
        }
        this.props.emitter.trigger('_unmount');
    };
    CalendarContent.prototype.buildAppendContent = function () {
        var props = this.props;
        var children = props.pluginHooks.viewContainerAppends.map(function (buildAppendContent) { return buildAppendContent(props); });
        return createElement.apply(void 0, tslib_tslib_es6_spreadArray([Fragment, {}], children));
    };
    CalendarContent.prototype.renderView = function (props) {
        var pluginHooks = props.pluginHooks;
        var viewSpec = props.viewSpec;
        var viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint,
        };
        var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
            var transformer = transformers_1[_i];
            node_modules_tslib_tslib_es6_assign(viewProps, transformer.transform(viewProps, props));
        }
        var ViewComponent = viewSpec.component;
        return (createElement(ViewComponent, node_modules_tslib_tslib_es6_assign({}, viewProps)));
    };
    return CalendarContent;
}(PureComponent));
function buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !rangeContainsMarker(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid,
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function buildViewPropTransformers(theClasses) {
    return theClasses.map(function (TheClass) { return new TheClass(); });
}

var CalendarRoot = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(CalendarRoot, _super);
    function CalendarRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            forPrint: false,
        };
        _this.handleBeforePrint = function () {
            _this.setState({ forPrint: true });
        };
        _this.handleAfterPrint = function () {
            _this.setState({ forPrint: false });
        };
        return _this;
    }
    CalendarRoot.prototype.render = function () {
        var props = this.props;
        var options = props.options;
        var forPrint = this.state.forPrint;
        var isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
        var height = (!isHeightAuto && options.height != null) ? options.height : '';
        var classNames = [
            'fc',
            forPrint ? 'fc-media-print' : 'fc-media-screen',
            "fc-direction-" + options.direction,
            props.theme.getClass('root'),
        ];
        if (!getCanVGrowWithinCell()) {
            classNames.push('fc-liquid-hack');
        }
        return props.children(classNames, height, isHeightAuto, forPrint);
    };
    CalendarRoot.prototype.componentDidMount = function () {
        var emitter = this.props.emitter;
        emitter.on('_beforeprint', this.handleBeforePrint);
        emitter.on('_afterprint', this.handleAfterPrint);
    };
    CalendarRoot.prototype.componentWillUnmount = function () {
        var emitter = this.props.emitter;
        emitter.off('_beforeprint', this.handleBeforePrint);
        emitter.off('_afterprint', this.handleAfterPrint);
    };
    return CalendarRoot;
}(BaseComponent));

// Computes a default column header formatting string if `colFormat` is not explicitly defined
function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) {
        return createFormatter({ weekday: 'short' }); // "Sat"
    }
    if (dayCnt > 1) {
        return createFormatter({ weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true }); // "Sat 11/12"
    }
    return createFormatter({ weekday: 'long' }); // "Saturday"
}

var CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
function renderInner$1(hookProps) {
    return hookProps.text;
}

var TableDateCell = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(TableDateCell, _super);
    function TableDateCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDateCell.prototype.render = function () {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options, theme = _a.theme, viewApi = _a.viewApi;
        var props = this.props;
        var date = props.date, dateProfile = props.dateProfile;
        var dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
        var classNames = [CLASS_NAME].concat(getDayClassNames(dayMeta, theme));
        var text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        var navLinkAttrs = (!dayMeta.isDisabled && props.colCnt > 1)
            ? buildNavLinkAttrs(this.context, date)
            : {};
        var hookProps = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({ date: dateEnv.toDate(date), view: viewApi }, props.extraHookProps), { text: text }), dayMeta);
        return (createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (createElement("th", node_modules_tslib_tslib_es6_assign({ ref: rootElRef, role: "columnheader", className: classNames.concat(customClassNames).join(' '), "data-date": !dayMeta.isDisabled ? formatDayString(date) : undefined, colSpan: props.colSpan }, props.extraDataAttrs),
            createElement("div", { className: "fc-scrollgrid-sync-inner" }, !dayMeta.isDisabled && (createElement("a", node_modules_tslib_tslib_es6_assign({ ref: innerElRef, className: [
                    'fc-col-header-cell-cushion',
                    props.isSticky ? 'fc-sticky' : '',
                ].join(' ') }, navLinkAttrs), innerContent))))); }));
    };
    return TableDateCell;
}(BaseComponent));

var WEEKDAY_FORMAT = createFormatter({ weekday: 'long' });
var TableDowCell = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(TableDowCell, _super);
    function TableDowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableDowCell.prototype.render = function () {
        var props = this.props;
        var _a = this.context, dateEnv = _a.dateEnv, theme = _a.theme, viewApi = _a.viewApi, options = _a.options;
        var date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        var dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false,
        };
        var classNames = [CLASS_NAME].concat(getDayClassNames(dateMeta, theme), props.extraClassNames || []);
        var text = dateEnv.format(date, props.dayHeaderFormat);
        var hookProps = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({ // TODO: make this public?
            date: date }, dateMeta), { view: viewApi }), props.extraHookProps), { text: text });
        return (createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (createElement("th", node_modules_tslib_tslib_es6_assign({ ref: rootElRef, role: "columnheader", className: classNames.concat(customClassNames).join(' '), colSpan: props.colSpan }, props.extraDataAttrs),
            createElement("div", { className: "fc-scrollgrid-sync-inner" },
                createElement("a", { "aria-label": dateEnv.format(date, WEEKDAY_FORMAT), className: [
                        'fc-col-header-cell-cushion',
                        props.isSticky ? 'fc-sticky' : '',
                    ].join(' '), ref: innerElRef }, innerContent)))); }));
    };
    return TableDowCell;
}(BaseComponent));

var NowTimer = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(NowTimer, _super);
    function NowTimer(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.initialNowDate = getNow(context.options.now, context.dateEnv);
        _this.initialNowQueriedMs = new Date().valueOf();
        _this.state = _this.computeTiming().currentState;
        return _this;
    }
    NowTimer.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return props.children(state.nowDate, state.todayRange);
    };
    NowTimer.prototype.componentDidMount = function () {
        this.setTimeout();
    };
    NowTimer.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    };
    NowTimer.prototype.componentWillUnmount = function () {
        this.clearTimeout();
    };
    NowTimer.prototype.computeTiming = function () {
        var _a = this, props = _a.props, context = _a.context;
        var unroundedNow = addMs(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
        var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        var nextUnitStart = context.dateEnv.add(currentUnitStart, createDuration(1, props.unit));
        var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(1000 * 60 * 60 * 24, waitMs);
        return {
            currentState: { nowDate: currentUnitStart, todayRange: buildDayRange(currentUnitStart) },
            nextState: { nowDate: nextUnitStart, todayRange: buildDayRange(nextUnitStart) },
            waitMs: waitMs,
        };
    };
    NowTimer.prototype.setTimeout = function () {
        var _this = this;
        var _a = this.computeTiming(), nextState = _a.nextState, waitMs = _a.waitMs;
        this.timeoutId = setTimeout(function () {
            _this.setState(nextState, function () {
                _this.setTimeout();
            });
        }, waitMs);
    };
    NowTimer.prototype.clearTimeout = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    };
    NowTimer.contextType = ViewContextType;
    return NowTimer;
}(vdom_Component));
function buildDayRange(date) {
    var start = startOfDay(date);
    var end = addDays(start, 1);
    return { start: start, end: end };
}

var DayHeader = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(DayHeader, _super);
    function DayHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
        return _this;
    }
    DayHeader.prototype.render = function () {
        var context = this.context;
        var _a = this.props, dates = _a.dates, dateProfile = _a.dateProfile, datesRepDistinctDays = _a.datesRepDistinctDays, renderIntro = _a.renderIntro;
        var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (createElement(NowTimer, { unit: "day" }, function (nowDate, todayRange) { return (createElement("tr", { role: "row" },
            renderIntro && renderIntro('day'),
            dates.map(function (date) { return (datesRepDistinctDays ? (createElement(TableDateCell, { key: date.toISOString(), date: date, dateProfile: dateProfile, todayRange: todayRange, colCnt: dates.length, dayHeaderFormat: dayHeaderFormat })) : (createElement(TableDowCell, { key: date.getUTCDay(), dow: date.getUTCDay(), dayHeaderFormat: dayHeaderFormat }))); }))); }));
    };
    return DayHeader;
}(BaseComponent));
function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
}

var DaySeriesModel = /** @class */ (function () {
    function DaySeriesModel(range, dateProfileGenerator) {
        var date = range.start;
        var end = range.end;
        var indices = [];
        var dates = [];
        var dayIndex = -1;
        while (date < end) { // loop each day from start to end
            if (dateProfileGenerator.isHiddenDay(date)) {
                indices.push(dayIndex + 0.5); // mark that it's between indices
            }
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = addDays(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
    DaySeriesModel.prototype.sliceRange = function (range) {
        var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        var lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index
        var clippedFirstIndex = Math.max(0, firstIndex);
        var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) {
            return {
                firstIndex: clippedFirstIndex,
                lastIndex: clippedLastIndex,
                isStart: firstIndex === clippedFirstIndex,
                isEnd: lastIndex === clippedLastIndex,
            };
        }
        return null;
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DaySeriesModel.prototype.getDateDayIndex = function (date) {
        var indices = this.indices;
        var dayOffset = Math.floor(diffDays(this.dates[0], date));
        if (dayOffset < 0) {
            return indices[0] - 1;
        }
        if (dayOffset >= indices.length) {
            return indices[indices.length - 1] + 1;
        }
        return indices[dayOffset];
    };
    return DaySeriesModel;
}());

var DayTableModel = /** @class */ (function () {
    function DayTableModel(daySeries, breakOnWeeks) {
        var dates = daySeries.dates;
        var daysPerRow;
        var firstDay;
        var rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for (daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1) {
                if (dates[daysPerRow].getUTCDay() === firstDay) {
                    break;
                }
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        }
        else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
    DayTableModel.prototype.buildCells = function () {
        var rows = [];
        for (var row = 0; row < this.rowCnt; row += 1) {
            var cells = [];
            for (var col = 0; col < this.colCnt; col += 1) {
                cells.push(this.buildCell(row, col));
            }
            rows.push(cells);
        }
        return rows;
    };
    DayTableModel.prototype.buildCell = function (row, col) {
        var date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date,
        };
    };
    DayTableModel.prototype.buildHeaderDates = function () {
        var dates = [];
        for (var col = 0; col < this.colCnt; col += 1) {
            dates.push(this.cells[0][col].date);
        }
        return dates;
    };
    DayTableModel.prototype.sliceRange = function (range) {
        var colCnt = this.colCnt;
        var seriesSeg = this.daySeries.sliceRange(range);
        var segs = [];
        if (seriesSeg) {
            var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
            var index = firstIndex;
            while (index <= lastIndex) {
                var row = Math.floor(index / colCnt);
                var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && (nextIndex - 1) === lastIndex,
                });
                index = nextIndex;
            }
        }
        return segs;
    };
    return DayTableModel;
}());

var Slicer = /** @class */ (function () {
    function Slicer() {
        this.sliceBusinessHours = memoize(this._sliceBusinessHours);
        this.sliceDateSelection = memoize(this._sliceDateSpan);
        this.sliceEventStore = memoize(this._sliceEventStore);
        this.sliceEventDrag = memoize(this._sliceInteraction);
        this.sliceEventResize = memoize(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
    Slicer.prototype.sliceProps = function (props, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        var eventUiBases = props.eventUiBases;
        var eventSegs = this.sliceEventStore.apply(this, tslib_tslib_es6_spreadArray([props.eventStore, eventUiBases, dateProfile, nextDayThreshold], extraArgs));
        return {
            dateSelectionSegs: this.sliceDateSelection.apply(this, tslib_tslib_es6_spreadArray([props.dateSelection, eventUiBases, context], extraArgs)),
            businessHourSegs: this.sliceBusinessHours.apply(this, tslib_tslib_es6_spreadArray([props.businessHours, dateProfile, nextDayThreshold, context], extraArgs)),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag.apply(this, tslib_tslib_es6_spreadArray([props.eventDrag, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
            eventResize: this.sliceEventResize.apply(this, tslib_tslib_es6_spreadArray([props.eventResize, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
            eventSelection: props.eventSelection,
        }; // TODO: give interactionSegs?
    };
    Slicer.prototype.sliceNowDate = function (// does not memoize
    date, context) {
        var extraArgs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extraArgs[_i - 2] = arguments[_i];
        }
        return this._sliceDateSpan.apply(this, tslib_tslib_es6_spreadArray([{ range: { start: date, end: addMs(date, 1) }, allDay: false },
            {},
            context], extraArgs));
    };
    Slicer.prototype._sliceBusinessHours = function (businessHours, dateProfile, nextDayThreshold, context) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (!businessHours) {
            return [];
        }
        return this._sliceEventStore.apply(this, tslib_tslib_es6_spreadArray([expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
            {},
            dateProfile,
            nextDayThreshold], extraArgs)).bg;
    };
    Slicer.prototype._sliceEventStore = function (eventStore, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (eventStore) {
            var rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs),
            };
        }
        return { bg: [], fg: [] };
    };
    Slicer.prototype._sliceInteraction = function (interaction, eventUiBases, dateProfile, nextDayThreshold) {
        var extraArgs = [];
        for (var _i = 4; _i < arguments.length; _i++) {
            extraArgs[_i - 4] = arguments[_i];
        }
        if (!interaction) {
            return null;
        }
        var rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent,
        };
    };
    Slicer.prototype._sliceDateSpan = function (dateSpan, eventUiBases, context) {
        var extraArgs = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            extraArgs[_i - 3] = arguments[_i];
        }
        if (!dateSpan) {
            return [];
        }
        var eventRange = fabricateEventRange(dateSpan, eventUiBases, context);
        var segs = this.sliceRange.apply(this, tslib_tslib_es6_spreadArray([dateSpan.range], extraArgs));
        for (var _a = 0, segs_1 = segs; _a < segs_1.length; _a++) {
            var seg = segs_1[_a];
            seg.eventRange = eventRange;
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */
    Slicer.prototype.sliceEventRanges = function (eventRanges, extraArgs) {
        var segs = [];
        for (var _i = 0, eventRanges_1 = eventRanges; _i < eventRanges_1.length; _i++) {
            var eventRange = eventRanges_1[_i];
            segs.push.apply(segs, this.sliceEventRange(eventRange, extraArgs));
        }
        return segs;
    };
    /*
    "complete" seg means it has component and eventRange
    */
    Slicer.prototype.sliceEventRange = function (eventRange, extraArgs) {
        var dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') {
            dateRange = {
                start: dateRange.start,
                end: addDays(dateRange.start, 1),
            };
        }
        var segs = this.sliceRange.apply(this, tslib_tslib_es6_spreadArray([dateRange], extraArgs));
        for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
            var seg = segs_2[_i];
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    };
    return Slicer;
}());
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/
function computeActiveRange(dateProfile, isComponentAllDay) {
    var range = dateProfile.activeRange;
    if (isComponentAllDay) {
        return range;
    }
    return {
        start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
        end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5), // 864e5 = ms in a day
    };
}

// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionValid(interaction, dateProfile, context) {
    var instances = interaction.mutatedEvents.instances;
    for (var instanceId in instances) {
        if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) {
            return false;
        }
    }
    return isNewPropsValid({ eventDrag: interaction }, context); // HACK: the eventDrag props is used for ALL interactions
}
function isDateSelectionValid(dateSelection, dateProfile, context) {
    if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) {
        return false;
    }
    return isNewPropsValid({ dateSelection: dateSelection }, context);
}
function isNewPropsValid(newProps, context) {
    var calendarState = context.getCurrentData();
    var props = node_modules_tslib_tslib_es6_assign({ businessHours: calendarState.businessHours, dateSelection: '', eventStore: calendarState.eventStore, eventUiBases: calendarState.eventUiBases, eventSelection: '', eventDrag: null, eventResize: null }, newProps);
    return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
}
function isPropsValid(state, context, dateSpanMeta, filterConfig) {
    if (dateSpanMeta === void 0) { dateSpanMeta = {}; }
    if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) {
        return false;
    }
    if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) {
        return false;
    }
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var currentState = context.getCurrentData();
    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    var subjectEventStore = interaction.mutatedEvents;
    var subjectDefs = subjectEventStore.defs;
    var subjectInstances = subjectEventStore.instances;
    var subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ?
        state.eventUiBases :
        { '': currentState.selectionConfig });
    if (filterConfig) {
        subjectConfigs = mapHash(subjectConfigs, filterConfig);
    }
    // exclude the subject events. TODO: exclude defs too?
    var otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    var otherDefs = otherEventStore.defs;
    var otherInstances = otherEventStore.instances;
    var otherConfigs = compileEventUis(otherDefs, state.eventUiBases);
    for (var subjectInstanceId in subjectInstances) {
        var subjectInstance = subjectInstances[subjectInstanceId];
        var subjectRange = subjectInstance.range;
        var subjectConfig = subjectConfigs[subjectInstance.defId];
        var subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) {
            return false;
        }
        // overlap
        var eventOverlap = context.options.eventOverlap;
        var eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
        for (var otherInstanceId in otherInstances) {
            var otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if (rangesIntersect(subjectRange, otherInstance.range)) {
                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) {
                    return false;
                }
                if (subjectConfig.overlap === false) {
                    return false;
                }
                if (eventOverlapFunc && !eventOverlapFunc(new EventApi(context, otherDefs[otherInstance.defId], otherInstance), // still event
                new EventApi(context, subjectDef, subjectInstance))) {
                    return false;
                }
            }
        }
        // allow (a function)
        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (var _i = 0, _a = subjectConfig.allows; _i < _a.length; _i++) {
            var subjectAllow = _a[_i];
            var subjectDateSpan = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, dateSpanMeta), { range: subjectInstance.range, allDay: subjectDef.allDay });
            var origDef = calendarEventStore.defs[subjectDef.defId];
            var origInstance = calendarEventStore.instances[subjectInstanceId];
            var eventApi = void 0;
            if (origDef) { // was previously in the calendar
                eventApi = new EventApi(context, origDef, origInstance);
            }
            else { // was an external event
                eventApi = new EventApi(context, subjectDef); // no instance, because had no dates
            }
            if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) {
                return false;
            }
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    var relevantEventStore = state.eventStore;
    var relevantDefs = relevantEventStore.defs;
    var relevantInstances = relevantEventStore.instances;
    var selection = state.dateSelection;
    var selectionRange = selection.range;
    var selectionConfig = context.getCurrentData().selectionConfig;
    if (filterConfig) {
        selectionConfig = filterConfig(selectionConfig);
    }
    // constraint
    if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) {
        return false;
    }
    // overlap
    var selectOverlap = context.options.selectOverlap;
    var selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
    for (var relevantInstanceId in relevantInstances) {
        var relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if (rangesIntersect(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) {
                return false;
            }
            if (selectOverlapFunc && !selectOverlapFunc(new EventApi(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) {
                return false;
            }
        }
    }
    // allow (a function)
    for (var _i = 0, _a = selectionConfig.allows; _i < _a.length; _i++) {
        var selectionAllow = _a[_i];
        var fullDateSpan = node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({}, dateSpanMeta), selection);
        if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) {
            return false;
        }
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (var _i = 0, constraints_1 = constraints; _i < constraints_1.length; _i++) {
        var constraint = constraints_1[_i];
        if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) {
            return false;
        }
    }
    return true;
}
function constraintToRanges(constraint, subjectRange, // for expanding a recurring constraint, or expanding business hours
otherEventStore, // for if constraint is an even group ID
businessHoursUnexpanded, // for if constraint is 'businessHours'
context) {
    if (constraint === 'businessHours') {
        return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
    }
    if (typeof constraint === 'string') { // an group ID
        return eventStoreToRanges(filterEventStoreDefs(otherEventStore, function (eventDef) { return eventDef.groupId === constraint; }));
    }
    if (typeof constraint === 'object' && constraint) { // non-null object
        return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
    }
    return []; // if it's false
}
// TODO: move to event-store file?
function eventStoreToRanges(eventStore) {
    var instances = eventStore.instances;
    var ranges = [];
    for (var instanceId in instances) {
        ranges.push(instances[instanceId].range);
    }
    return ranges;
}
// TODO: move to geom file?
function anyRangesContainRange(outerRanges, innerRange) {
    for (var _i = 0, outerRanges_1 = outerRanges; _i < outerRanges_1.length; _i++) {
        var outerRange = outerRanges_1[_i];
        if (rangeContainsRange(outerRange, innerRange)) {
            return true;
        }
    }
    return false;
}

var VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
var Scroller = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(Scroller, _super);
    function Scroller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEl = function (el) {
            _this.el = el;
            setRef(_this.props.elRef, el);
        };
        return _this;
    }
    Scroller.prototype.render = function () {
        var props = this.props;
        var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
        var isAbsolute = liquid && liquidIsAbsolute;
        var className = ['fc-scroller'];
        if (liquid) {
            if (liquidIsAbsolute) {
                className.push('fc-scroller-liquid-absolute');
            }
            else {
                className.push('fc-scroller-liquid');
            }
        }
        return (createElement("div", { ref: this.handleEl, className: className.join(' '), style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: (isAbsolute && -(props.overcomeLeft || 0)) || '',
                right: (isAbsolute && -(props.overcomeRight || 0)) || '',
                bottom: (isAbsolute && -(props.overcomeBottom || 0)) || '',
                marginLeft: (!isAbsolute && -(props.overcomeLeft || 0)) || '',
                marginRight: (!isAbsolute && -(props.overcomeRight || 0)) || '',
                marginBottom: (!isAbsolute && -(props.overcomeBottom || 0)) || '',
                maxHeight: props.maxHeight || '',
            } }, props.children));
    };
    Scroller.prototype.needsXScrolling = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
            return false;
        }
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        var children = el.children;
        for (var i = 0; i < children.length; i += 1) {
            var childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) {
                return true;
            }
        }
        return false;
    };
    Scroller.prototype.needsYScrolling = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
            return false;
        }
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        var el = this.el;
        var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        var children = el.children;
        for (var i = 0; i < children.length; i += 1) {
            var childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) {
                return true;
            }
        }
        return false;
    };
    Scroller.prototype.getXScrollbarWidth = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
            return 0;
        }
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    Scroller.prototype.getYScrollbarWidth = function () {
        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
            return 0;
        }
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    };
    return Scroller;
}(BaseComponent));

/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/
var RefMap = /** @class */ (function () {
    function RefMap(masterCallback) {
        var _this = this;
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = function (val, key) {
            var _a = _this, depths = _a.depths, currentMap = _a.currentMap;
            var removed = false;
            var added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = (key in currentMap);
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            }
            else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete _this.callbackMap[key];
                    removed = true;
                }
            }
            if (_this.masterCallback) {
                if (removed) {
                    _this.masterCallback(null, String(key));
                }
                if (added) {
                    _this.masterCallback(val, String(key));
                }
            }
        };
    }
    RefMap.prototype.createRef = function (key) {
        var _this = this;
        var refCallback = this.callbackMap[key];
        if (!refCallback) {
            refCallback = this.callbackMap[key] = function (val) {
                _this.handleValue(val, String(key));
            };
        }
        return refCallback;
    };
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    RefMap.prototype.collect = function (startIndex, endIndex, step) {
        return collectFromHash(this.currentMap, startIndex, endIndex, step);
    };
    RefMap.prototype.getAll = function () {
        return hashValuesToArray(this.currentMap);
    };
    return RefMap;
}());

function computeShrinkWidth(chunkEls) {
    var shrinkCells = findElements(chunkEls, '.fc-scrollgrid-shrink');
    var largestWidth = 0;
    for (var _i = 0, shrinkCells_1 = shrinkCells; _i < shrinkCells_1.length; _i++) {
        var shrinkCell = shrinkCells_1[_i];
        largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
    }
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function getSectionHasLiquidHeight(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function getAllowYScrolling(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
        getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function renderChunkContent(sectionConfig, chunkConfig, arg, isHeader) {
    var expandRows = arg.expandRows;
    var content = typeof chunkConfig.content === 'function' ?
        chunkConfig.content(arg) :
        createElement('table', {
            role: 'presentation',
            className: [
                chunkConfig.tableClassName,
                sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : '',
            ].join(' '),
            style: {
                minWidth: arg.tableMinWidth,
                width: arg.clientWidth,
                height: expandRows ? arg.clientHeight : '', // css `height` on a <table> serves as a min-height
            },
        }, arg.tableColGroupNode, createElement(isHeader ? 'thead' : 'tbody', {
            role: 'presentation',
        }, typeof chunkConfig.rowContent === 'function'
            ? chunkConfig.rowContent(arg)
            : chunkConfig.rowContent));
    return content;
}
function isColPropsEqual(cols0, cols1) {
    return isArraysEqual(cols0, cols1, isPropsEqual);
}
function renderMicroColGroup(cols, shrinkWidth) {
    var colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */
    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
        var colProps = cols_1[_i];
        var span = colProps.span || 1;
        for (var i = 0; i < span; i += 1) {
            colNodes.push(createElement("col", { style: {
                    width: colProps.width === 'shrink' ? sanitizeShrinkWidth(shrinkWidth) : (colProps.width || ''),
                    minWidth: colProps.minWidth || '',
                } }));
        }
    }
    return createElement.apply(void 0, tslib_tslib_es6_spreadArray(['colgroup', {}], colNodes));
}
function sanitizeShrinkWidth(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */
    return shrinkWidth == null ? 4 : shrinkWidth;
}
function hasShrinkWidth(cols) {
    for (var _i = 0, cols_2 = cols; _i < cols_2.length; _i++) {
        var col = cols_2[_i];
        if (col.width === 'shrink') {
            return true;
        }
    }
    return false;
}
function getScrollGridClassNames(liquid, context) {
    var classNames = [
        'fc-scrollgrid',
        context.theme.getClass('table'),
    ];
    if (liquid) {
        classNames.push('fc-scrollgrid-liquid');
    }
    return classNames;
}
function getSectionClassNames(sectionConfig, wholeTableVGrow) {
    var classNames = [
        'fc-scrollgrid-section',
        "fc-scrollgrid-section-" + sectionConfig.type,
        sectionConfig.className, // used?
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) {
        classNames.push('fc-scrollgrid-section-liquid');
    }
    if (sectionConfig.isSticky) {
        classNames.push('fc-scrollgrid-section-sticky');
    }
    return classNames;
}
function renderScrollShim(arg) {
    return (createElement("div", { className: "fc-scrollgrid-sticky-shim", style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth,
        } }));
}
function getStickyHeaderDates(options) {
    var stickyHeaderDates = options.stickyHeaderDates;
    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') {
        stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
    }
    return stickyHeaderDates;
}
function getStickyFooterScrollbar(options) {
    var stickyFooterScrollbar = options.stickyFooterScrollbar;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') {
        stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
    }
    return stickyFooterScrollbar;
}

var SimpleScrollGrid = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(SimpleScrollGrid, _super);
    function SimpleScrollGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processCols = memoize(function (a) { return a; }, isColPropsEqual); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        _this.renderMicroColGroup = memoize(renderMicroColGroup);
        _this.scrollerRefs = new RefMap();
        _this.scrollerElRefs = new RefMap(_this._handleScrollerEl.bind(_this));
        _this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {},
        };
        // TODO: can do a really simple print-view. dont need to join rows
        _this.handleSizing = function () {
            _this.setState(node_modules_tslib_tslib_es6_assign({ shrinkWidth: _this.computeShrinkWidth() }, _this.computeScrollerDims()));
        };
        return _this;
    }
    SimpleScrollGrid.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var sectionConfigs = props.sections || [];
        var cols = this.processCols(props.cols);
        var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        var classNames = getScrollGridClassNames(props.liquid, context);
        if (props.collapsibleWidth) {
            classNames.push('fc-scrollgrid-collapsible');
        }
        // TODO: make DRY
        var configCnt = sectionConfigs.length;
        var configI = 0;
        var currentConfig;
        var headSectionNodes = [];
        var bodySectionNodes = [];
        var footSectionNodes = [];
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header') {
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body') {
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer') {
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        var isBuggy = !getCanVGrowWithinCell();
        var roleAttrs = { role: 'rowgroup' };
        return createElement('table', {
            role: 'grid',
            className: classNames.join(' '),
            style: { height: props.height },
        }, Boolean(!isBuggy && headSectionNodes.length) && createElement.apply(void 0, tslib_tslib_es6_spreadArray(['thead', roleAttrs], headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && createElement.apply(void 0, tslib_tslib_es6_spreadArray(['tbody', roleAttrs], bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && createElement.apply(void 0, tslib_tslib_es6_spreadArray(['tfoot', roleAttrs], footSectionNodes)), isBuggy && createElement.apply(void 0, tslib_tslib_es6_spreadArray(tslib_tslib_es6_spreadArray(tslib_tslib_es6_spreadArray(['tbody', roleAttrs], headSectionNodes), bodySectionNodes), footSectionNodes)));
    };
    SimpleScrollGrid.prototype.renderSection = function (sectionConfig, microColGroupNode, isHeader) {
        if ('outerContent' in sectionConfig) {
            return (createElement(Fragment, { key: sectionConfig.key }, sectionConfig.outerContent));
        }
        return (createElement("tr", { key: sectionConfig.key, role: "presentation", className: getSectionClassNames(sectionConfig, this.props.liquid).join(' ') }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader)));
    };
    SimpleScrollGrid.prototype.renderChunkTd = function (sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ('outerContent' in chunkConfig) {
            return chunkConfig.outerContent;
        }
        var props = this.props;
        var _a = this.state, forceYScrollbars = _a.forceYScrollbars, scrollerClientWidths = _a.scrollerClientWidths, scrollerClientHeights = _a.scrollerClientHeights;
        var needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?
        var isLiquid = getSectionHasLiquidHeight(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        var overflowY = !props.liquid ? 'visible' :
            forceYScrollbars ? 'scroll' :
                !needsYScrolling ? 'hidden' :
                    'auto';
        var sectionKey = sectionConfig.key;
        var content = renderChunkContent(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: '',
            clientWidth: (!props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined) ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: function () { },
        }, isHeader);
        return createElement(isHeader ? 'th' : 'td', {
            ref: chunkConfig.elRef,
            role: 'presentation',
        }, createElement("div", { className: "fc-scroller-harness" + (isLiquid ? ' fc-scroller-harness-liquid' : '') },
            createElement(Scroller, { ref: this.scrollerRefs.createRef(sectionKey), elRef: this.scrollerElRefs.createRef(sectionKey), overflowY: overflowY, overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */, maxHeight: sectionConfig.maxHeight, liquid: isLiquid, liquidIsAbsolute // because its within a harness
                : true }, content)));
    };
    SimpleScrollGrid.prototype._handleScrollerEl = function (scrollerEl, key) {
        var section = getSectionByKey(this.props.sections, key);
        if (section) {
            setRef(section.chunk.scrollerElRef, scrollerEl);
        }
    };
    SimpleScrollGrid.prototype.componentDidMount = function () {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.componentDidUpdate = function () {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    };
    SimpleScrollGrid.prototype.componentWillUnmount = function () {
        this.context.removeResizeHandler(this.handleSizing);
    };
    SimpleScrollGrid.prototype.computeShrinkWidth = function () {
        return hasShrinkWidth(this.props.cols)
            ? computeShrinkWidth(this.scrollerElRefs.getAll())
            : 0;
    };
    SimpleScrollGrid.prototype.computeScrollerDims = function () {
        var scrollbarWidth = getScrollbarWidths();
        var _a = this, scrollerRefs = _a.scrollerRefs, scrollerElRefs = _a.scrollerElRefs;
        var forceYScrollbars = false;
        var scrollerClientWidths = {};
        var scrollerClientHeights = {};
        for (var sectionKey in scrollerRefs.currentMap) {
            var scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (var _i = 0, _b = this.props.sections; _i < _b.length; _i++) {
            var section = _b[_i];
            var sectionKey = section.key;
            var scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars
                    ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                    : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights };
    };
    return SimpleScrollGrid;
}(BaseComponent));
SimpleScrollGrid.addStateEquality({
    scrollerClientWidths: isPropsEqual,
    scrollerClientHeights: isPropsEqual,
});
function getSectionByKey(sections, key) {
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        if (section.key === key) {
            return section;
        }
    }
    return null;
}

var EventRoot = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(EventRoot, _super);
    function EventRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elRef = createRef();
        return _this;
    }
    EventRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var seg = props.seg;
        var eventRange = seg.eventRange;
        var ui = eventRange.ui;
        var hookProps = {
            event: new EventApi(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing),
        };
        var standardClassNames = getEventClassNames(hookProps).concat(ui.classNames);
        return (createElement(RenderHook, { hookProps: hookProps, classNames: options.eventClassNames, content: options.eventContent, defaultContent: props.defaultContent, didMount: options.eventDidMount, willUnmount: options.eventWillUnmount, elRef: this.elRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, standardClassNames.concat(customClassNames), innerElRef, innerContent, hookProps); }));
    };
    EventRoot.prototype.componentDidMount = function () {
        setElSeg(this.elRef.current, this.props.seg);
    };
    /*
    need to re-assign seg to the element if seg changes, even if the element is the same
    */
    EventRoot.prototype.componentDidUpdate = function (prevProps) {
        var seg = this.props.seg;
        if (seg !== prevProps.seg) {
            setElSeg(this.elRef.current, seg);
        }
    };
    return EventRoot;
}(BaseComponent));

// should not be a purecomponent
var StandardEvent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(StandardEvent, _super);
    function StandardEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StandardEvent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var seg = props.seg;
        var timeFormat = context.options.eventTimeFormat || props.defaultTimeFormat;
        var timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (createElement(EventRoot, { seg: seg, timeText: timeText, disableDragging: props.disableDragging, disableResizing: props.disableResizing, defaultContent: props.defaultContent || renderInnerContent$1, isDragging: props.isDragging, isResizing: props.isResizing, isDateSelecting: props.isDateSelecting, isSelected: props.isSelected, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (createElement("a", node_modules_tslib_tslib_es6_assign({ className: props.extraClassNames.concat(classNames).join(' '), style: {
                borderColor: hookProps.borderColor,
                backgroundColor: hookProps.backgroundColor,
            }, ref: rootElRef }, getSegAnchorAttrs(seg, context)),
            createElement("div", { className: "fc-event-main", ref: innerElRef, style: { color: hookProps.textColor } }, innerContent),
            hookProps.isStartResizable &&
                createElement("div", { className: "fc-event-resizer fc-event-resizer-start" }),
            hookProps.isEndResizable &&
                createElement("div", { className: "fc-event-resizer fc-event-resizer-end" }))); }));
    };
    return StandardEvent;
}(BaseComponent));
function renderInnerContent$1(innerProps) {
    return (createElement("div", { className: "fc-event-main-frame" },
        innerProps.timeText && (createElement("div", { className: "fc-event-time" }, innerProps.timeText)),
        createElement("div", { className: "fc-event-title-container" },
            createElement("div", { className: "fc-event-title fc-sticky" }, innerProps.event.title || createElement(Fragment, null, "\u00A0")))));
}

var NowIndicatorRoot = function (props) { return (createElement(ViewContextType.Consumer, null, function (context) {
    var options = context.options;
    var hookProps = {
        isAxis: props.isAxis,
        date: context.dateEnv.toDate(props.date),
        view: context.viewApi,
    };
    return (createElement(RenderHook, { hookProps: hookProps, classNames: options.nowIndicatorClassNames, content: options.nowIndicatorContent, didMount: options.nowIndicatorDidMount, willUnmount: options.nowIndicatorWillUnmount }, props.children));
})); };

var DAY_NUM_FORMAT = createFormatter({ day: 'numeric' });
var DayCellContent = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(DayCellContent, _super);
    function DayCellContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayCellContent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = refineDayCellHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
        });
        return (createElement(ContentHook, { hookProps: hookProps, content: options.dayCellContent, defaultContent: props.defaultContent }, props.children));
    };
    return DayCellContent;
}(BaseComponent));
function refineDayCellHookProps(raw) {
    var date = raw.date, dateEnv = raw.dateEnv;
    var dayMeta = getDateMeta(date, raw.todayRange, null, raw.dateProfile);
    return node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign(node_modules_tslib_tslib_es6_assign({ date: dateEnv.toDate(date), view: raw.viewApi }, dayMeta), { dayNumberText: raw.showDayNumber ? dateEnv.format(date, DAY_NUM_FORMAT) : '' }), raw.extraProps);
}

var DayCellRoot = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(DayCellRoot, _super);
    function DayCellRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.refineHookProps = memoizeObjArg(refineDayCellHookProps);
        _this.normalizeClassNames = buildClassNameNormalizer();
        return _this;
    }
    DayCellRoot.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var hookProps = this.refineHookProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            extraProps: props.extraHookProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
        });
        var classNames = getDayClassNames(hookProps, context.theme).concat(hookProps.isDisabled
            ? [] // don't use custom classNames if disabled
            : this.normalizeClassNames(options.dayCellClassNames, hookProps));
        var dataAttrs = hookProps.isDisabled ? {} : {
            'data-date': formatDayString(props.date),
        };
        return (createElement(MountHook, { hookProps: hookProps, didMount: options.dayCellDidMount, willUnmount: options.dayCellWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, classNames, dataAttrs, hookProps.isDisabled); }));
    };
    return DayCellRoot;
}(BaseComponent));

function renderFill(fillType) {
    return (createElement("div", { className: "fc-" + fillType }));
}
var BgEvent = function (props) { return (createElement(EventRoot, { defaultContent: renderInnerContent, seg: props.seg /* uselesss i think */, timeText: "", disableDragging: true, disableResizing: true, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: false, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (createElement("div", { ref: rootElRef, className: ['fc-bg-event'].concat(classNames).join(' '), style: {
        backgroundColor: hookProps.backgroundColor,
    } }, innerContent)); })); };
function renderInnerContent(props) {
    var title = props.event.title;
    return title && (createElement("div", { className: "fc-event-title" }, props.event.title));
}

var WeekNumberRoot = function (props) { return (createElement(ViewContextType.Consumer, null, function (context) {
    var dateEnv = context.dateEnv, options = context.options;
    var date = props.date;
    var format = options.weekNumberFormat || props.defaultFormat;
    var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
    var text = dateEnv.format(date, format);
    var hookProps = { num: num, text: text, date: date };
    return (createElement(RenderHook, { hookProps: hookProps, classNames: options.weekNumberClassNames, content: options.weekNumberContent, defaultContent: renderInner, didMount: options.weekNumberDidMount, willUnmount: options.weekNumberWillUnmount }, props.children));
})); };
function renderInner(innerProps) {
    return innerProps.text;
}

var PADDING_FROM_VIEWPORT = 10;
var Popover = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            titleId: getUniqueDomId(),
        };
        _this.handleRootEl = function (el) {
            _this.rootEl = el;
            if (_this.props.elRef) {
                setRef(_this.props.elRef, el);
            }
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        _this.handleDocumentMouseDown = function (ev) {
            // only hide the popover if the click happened outside the popover
            var target = getEventTargetViaRoot(ev);
            if (!_this.rootEl.contains(target)) {
                _this.handleCloseClick();
            }
        };
        _this.handleDocumentKeyDown = function (ev) {
            if (ev.key === 'Escape') {
                _this.handleCloseClick();
            }
        };
        _this.handleCloseClick = function () {
            var onClose = _this.props.onClose;
            if (onClose) {
                onClose();
            }
        };
        return _this;
    }
    Popover.prototype.render = function () {
        var _a = this.context, theme = _a.theme, options = _a.options;
        var _b = this, props = _b.props, state = _b.state;
        var classNames = [
            'fc-popover',
            theme.getClass('popover'),
        ].concat(props.extraClassNames || []);
        return createPortal(createElement("div", node_modules_tslib_tslib_es6_assign({ id: props.id, className: classNames.join(' '), "aria-labelledby": state.titleId }, props.extraAttrs, { ref: this.handleRootEl }),
            createElement("div", { className: 'fc-popover-header ' + theme.getClass('popoverHeader') },
                createElement("span", { className: "fc-popover-title", id: state.titleId }, props.title),
                createElement("span", { className: 'fc-popover-close ' + theme.getIconClass('close'), title: options.closeHint, onClick: this.handleCloseClick })),
            createElement("div", { className: 'fc-popover-body ' + theme.getClass('popoverContent') }, props.children)), props.parentEl);
    };
    Popover.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleDocumentMouseDown);
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        this.updateSize();
    };
    Popover.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    };
    Popover.prototype.updateSize = function () {
        var isRtl = this.context.isRtl;
        var _a = this.props, alignmentEl = _a.alignmentEl, alignGridTop = _a.alignGridTop;
        var rootEl = this.rootEl;
        var alignmentRect = computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            var popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            var popoverTop = alignGridTop
                ? elementClosest(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top
                : alignmentRect.top;
            var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
            var origin_1 = rootEl.offsetParent.getBoundingClientRect();
            applyStyle(rootEl, {
                top: popoverTop - origin_1.top,
                left: popoverLeft - origin_1.left,
            });
        }
    };
    return Popover;
}(BaseComponent));

var MorePopover = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(MorePopover, _super);
    function MorePopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) {
                _this.context.registerInteractiveComponent(_this, {
                    el: rootEl,
                    useEventCenter: false,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        return _this;
    }
    MorePopover.prototype.render = function () {
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv;
        var props = this.props;
        var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
        var title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (createElement(DayCellRoot, { date: startDate, dateProfile: dateProfile, todayRange: todayRange, elRef: this.handleRootEl }, function (rootElRef, dayClassNames, dataAttrs) { return (createElement(Popover, { elRef: rootElRef, id: props.id, title: title, extraClassNames: ['fc-more-popover'].concat(dayClassNames), extraAttrs: dataAttrs /* TODO: make these time-based when not whole-day? */, parentEl: props.parentEl, alignmentEl: props.alignmentEl, alignGridTop: props.alignGridTop, onClose: props.onClose },
            createElement(DayCellContent, { date: startDate, dateProfile: dateProfile, todayRange: todayRange }, function (innerElRef, innerContent) { return (innerContent &&
                createElement("div", { className: "fc-more-popover-misc", ref: innerElRef }, innerContent)); }),
            props.children)); }));
    };
    MorePopover.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
        var _a = this, rootEl = _a.rootEl, props = _a.props;
        if (positionLeft >= 0 && positionLeft < elWidth &&
            positionTop >= 0 && positionTop < elHeight) {
            return {
                dateProfile: props.dateProfile,
                dateSpan: node_modules_tslib_tslib_es6_assign({ allDay: true, range: {
                        start: props.startDate,
                        end: props.endDate,
                    } }, props.extraDateSpan),
                dayEl: rootEl,
                rect: {
                    left: 0,
                    top: 0,
                    right: elWidth,
                    bottom: elHeight,
                },
                layer: 1, // important when comparing with hits from other components
            };
        }
        return null;
    };
    return MorePopover;
}(DateComponent));

var MoreLinkRoot = /** @class */ (function (_super) {
    tslib_tslib_es6_extends(MoreLinkRoot, _super);
    function MoreLinkRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.linkElRef = createRef();
        _this.state = {
            isPopoverOpen: false,
            popoverId: getUniqueDomId(),
        };
        _this.handleClick = function (ev) {
            var _a = _this, props = _a.props, context = _a.context;
            var moreLinkClick = context.options.moreLinkClick;
            var date = computeRange(props).start;
            function buildPublicSeg(seg) {
                var _a = seg.eventRange, def = _a.def, instance = _a.instance, range = _a.range;
                return {
                    event: new EventApi(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd,
                };
            }
            if (typeof moreLinkClick === 'function') {
                moreLinkClick = moreLinkClick({
                    date: date,
                    allDay: Boolean(props.allDayDate),
                    allSegs: props.allSegs.map(buildPublicSeg),
                    hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                    jsEvent: ev,
                    view: context.viewApi,
                });
            }
            if (!moreLinkClick || moreLinkClick === 'popover') {
                _this.setState({ isPopoverOpen: true });
            }
            else if (typeof moreLinkClick === 'string') { // a view name
                context.calendarApi.zoomTo(date, moreLinkClick);
            }
        };
        _this.handlePopoverClose = function () {
            _this.setState({ isPopoverOpen: false });
        };
        return _this;
    }
    MoreLinkRoot.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        return (createElement(ViewContextType.Consumer, null, function (context) {
            var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
            var moreLinkText = options.moreLinkText;
            var moreCnt = props.moreCnt;
            var range = computeRange(props);
            var text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
                ? moreLinkText.call(calendarApi, moreCnt)
                : "+" + moreCnt + " " + moreLinkText;
            var title = formatWithOrdinals(options.moreLinkHint, [moreCnt], text);
            var hookProps = {
                num: moreCnt,
                shortText: "+" + moreCnt,
                text: text,
                view: viewApi,
            };
            return (createElement(Fragment, null,
                Boolean(props.moreCnt) && (createElement(RenderHook, { elRef: _this.linkElRef, hookProps: hookProps, classNames: options.moreLinkClassNames, content: options.moreLinkContent, defaultContent: props.defaultContent || renderMoreLinkInner, didMount: options.moreLinkDidMount, willUnmount: options.moreLinkWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, ['fc-more-link'].concat(customClassNames), innerElRef, innerContent, _this.handleClick, title, state.isPopoverOpen, state.isPopoverOpen ? state.popoverId : ''); })),
                state.isPopoverOpen && (createElement(MorePopover, { id: state.popoverId, startDate: range.start, endDate: range.end, dateProfile: props.dateProfile, todayRange: props.todayRange, extraDateSpan: props.extraDateSpan, parentEl: _this.parentEl, alignmentEl: props.alignmentElRef.current, alignGridTop: props.alignGridTop, onClose: _this.handlePopoverClose }, props.popoverContent()))));
        }));
    };
    MoreLinkRoot.prototype.componentDidMount = function () {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.componentDidUpdate = function () {
        this.updateParentEl();
    };
    MoreLinkRoot.prototype.updateParentEl = function () {
        if (this.linkElRef.current) {
            this.parentEl = elementClosest(this.linkElRef.current, '.fc-view-harness');
        }
    };
    return MoreLinkRoot;
}(BaseComponent));
function renderMoreLinkInner(props) {
    return props.text;
}
function computeRange(props) {
    if (props.allDayDate) {
        return {
            start: props.allDayDate,
            end: addDays(props.allDayDate, 1),
        };
    }
    var hiddenSegs = props.hiddenSegs;
    return {
        start: computeEarliestSegStart(hiddenSegs),
        end: computeLatestSegEnd(hiddenSegs),
    };
}
function computeEarliestSegStart(segs) {
    return segs.reduce(pickEarliestStart).eventRange.range.start;
}
function pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function computeLatestSegEnd(segs) {
    return segs.reduce(pickLatestEnd).eventRange.range.end;
}
function pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}

// exports
// --------------------------------------------------------------------------------------------------
var main_version = '5.10.2'; // important to type it, so .d.ts has generic string


//# sourceMappingURL=main.js.map

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/core/main.js
/*!
FullCalendar v5.10.2
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/





var Calendar = /** @class */ (function (_super) {
    tslib_es6_extends(Calendar, _super);
    function Calendar(el, optionOverrides) {
        if (optionOverrides === void 0) { optionOverrides = {}; }
        var _this = _super.call(this) || this;
        _this.isRendering = false;
        _this.isRendered = false;
        _this.currentClassNames = [];
        _this.customContentRenderId = 0; // will affect custom generated classNames?
        _this.handleAction = function (action) {
            // actions we know we want to render immediately
            switch (action.type) {
                case 'SET_EVENT_DRAG':
                case 'SET_EVENT_RESIZE':
                    _this.renderRunner.tryDrain();
            }
        };
        _this.handleData = function (data) {
            _this.currentData = data;
            _this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        _this.handleRenderRequest = function () {
            if (_this.isRendering) {
                _this.isRendered = true;
                var currentData_1 = _this.currentData;
                vdom_flushSync(function () {
                    vdom_render(createElement(CalendarRoot, { options: currentData_1.calendarOptions, theme: currentData_1.theme, emitter: currentData_1.emitter }, function (classNames, height, isHeightAuto, forPrint) {
                        _this.setClassNames(classNames);
                        _this.setHeight(height);
                        return (createElement(CustomContentRenderContext.Provider, { value: _this.customContentRenderId },
                            createElement(CalendarContent, tslib_tslib_es6_assign({ isHeightAuto: isHeightAuto, forPrint: forPrint }, currentData_1))));
                    }), _this.el);
                });
            }
            else if (_this.isRendered) {
                _this.isRendered = false;
                vdom_unmountComponentAtNode(_this.el);
                _this.setClassNames([]);
                _this.setHeight('');
            }
        };
        _this.el = el;
        _this.renderRunner = new DelayedRunner(_this.handleRenderRequest);
        new CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: _this,
            onAction: _this.handleAction,
            onData: _this.handleData,
        });
        return _this;
    }
    Object.defineProperty(Calendar.prototype, "view", {
        get: function () { return this.currentData.viewApi; } // for public API
        ,
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.render = function () {
        var wasRendering = this.isRendering;
        if (!wasRendering) {
            this.isRendering = true;
        }
        else {
            this.customContentRenderId += 1;
        }
        this.renderRunner.request();
        if (wasRendering) {
            this.updateSize();
        }
    };
    Calendar.prototype.destroy = function () {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    };
    Calendar.prototype.updateSize = function () {
        var _this = this;
        vdom_flushSync(function () {
            _super.prototype.updateSize.call(_this);
        });
    };
    Calendar.prototype.batchRendering = function (func) {
        this.renderRunner.pause('batchRendering');
        func();
        this.renderRunner.resume('batchRendering');
    };
    Calendar.prototype.pauseRendering = function () {
        this.renderRunner.pause('pauseRendering');
    };
    Calendar.prototype.resumeRendering = function () {
        this.renderRunner.resume('pauseRendering', true);
    };
    Calendar.prototype.resetOptions = function (optionOverrides, append) {
        this.currentDataManager.resetOptions(optionOverrides, append);
    };
    Calendar.prototype.setClassNames = function (classNames) {
        if (!isArraysEqual(classNames, this.currentClassNames)) {
            var classList = this.el.classList;
            for (var _i = 0, _a = this.currentClassNames; _i < _a.length; _i++) {
                var className = _a[_i];
                classList.remove(className);
            }
            for (var _b = 0, classNames_1 = classNames; _b < classNames_1.length; _b++) {
                var className = classNames_1[_b];
                classList.add(className);
            }
            this.currentClassNames = classNames;
        }
    };
    Calendar.prototype.setHeight = function (height) {
        applyStyleProp(this.el, 'height', height);
    };
    return Calendar;
}(CalendarApi));


//# sourceMappingURL=main.js.map

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/vue3/dist/options.js
const OPTION_IS_COMPLEX = {
    headerToolbar: true,
    footerToolbar: true,
    events: true,
    eventSources: true,
    resources: true
};
//# sourceMappingURL=options.js.map
;// CONCATENATED MODULE: ./node_modules/@fullcalendar/vue3/dist/utils.js
// TODO: add types!
/*
works with objects and arrays
*/
function shallowCopy(val) {
    if (typeof val === 'object') {
        if (Array.isArray(val)) {
            val = Array.prototype.slice.call(val);
        }
        else if (val) { // non-null
            val = { ...val };
        }
    }
    return val;
}
function utils_mapHash(input, func) {
    const output = {};
    for (const key in input) {
        if (input.hasOwnProperty(key)) {
            output[key] = func(input[key], key);
        }
    }
    return output;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@fullcalendar/vue3/dist/custom-content-type.js


/*
wrap it in an object with a `vue` key, which the custom content-type handler system will look for
*/
function wrapVDomGenerator(vDomGenerator) {
    return function (props) {
        return { vue: vDomGenerator(props) };
    };
}
function createVueContentTypePlugin(appContext) {
    return createPlugin({
        contentTypeHandlers: {
            vue: () => buildVDomHandler(appContext), // looks for the `vue` key
        }
    });
}
function buildVDomHandler(appContext) {
    let currentEl;
    let app;
    let componentInstance;
    function render(el, vDomContent) {
        if (currentEl !== el) {
            if (currentEl && app) { // if changing elements, recreate the vue
                app.unmount();
            }
            currentEl = el;
        }
        if (!app) {
            app = initApp(vDomContent, appContext);
            // vue's mount method *replaces* the given element. create an artificial inner el
            let innerEl = document.createElement('span');
            el.appendChild(innerEl);
            componentInstance = app.mount(innerEl);
        }
        else {
            componentInstance.content = vDomContent;
        }
    }
    function destroy() {
        if (app) { // needed?
            app.unmount();
        }
    }
    return { render, destroy };
}
function initApp(initialContent, appContext) {
    // TODO: do something with appContext
    return (0,vue_cjs.createApp)({
        data() {
            return {
                content: initialContent,
            };
        },
        render() {
            let { content } = this;
            // the slot result can be an array, but the returned value of a vue component's
            // render method must be a single node.
            if (content.length === 1) {
                return content[0];
            }
            else {
                return (0,vue_cjs.h)('span', {}, content);
            }
        }
    });
}
//# sourceMappingURL=custom-content-type.js.map
;// CONCATENATED MODULE: ./node_modules/@fullcalendar/vue3/dist/FullCalendar.js





const FullCalendar = (0,vue_cjs.defineComponent)({
    props: {
        options: Object
    },
    data: initData,
    render() {
        return (0,vue_cjs.h)('div', {
            // when renderId is changed, Vue will trigger a real-DOM async rerender, calling beforeUpdate/updated
            attrs: { 'data-fc-render-id': this.renderId }
        });
    },
    mounted() {
        // store internal data (slotOptions, calendar)
        // https://github.com/vuejs/vue/issues/1988#issuecomment-163013818
        this.slotOptions = utils_mapHash(this.$slots, wrapVDomGenerator); // needed for buildOptions
        let calendarOptions = this.buildOptions(this.options, this.$.appContext);
        let calendar = new Calendar(this.$el, calendarOptions);
        this.calendar = calendar;
        calendar.render();
    },
    methods: {
        getApi,
        buildOptions,
    },
    beforeUpdate() {
        this.getApi().resumeRendering(); // the watcher handlers paused it
    },
    beforeUnmount() {
        this.getApi().destroy();
    },
    watch: buildWatchers()
});
/* harmony default export */ const dist_FullCalendar = (FullCalendar);
function initData() {
    return {
        renderId: 0
    };
}
function buildOptions(suppliedOptions, appContext) {
    suppliedOptions = suppliedOptions || {};
    return {
        ...this.slotOptions,
        ...suppliedOptions,
        plugins: (suppliedOptions.plugins || []).concat([
            createVueContentTypePlugin(appContext)
        ])
    };
}
function getApi() {
    return this.calendar;
}
function buildWatchers() {
    let watchers = {
        // watches changes of ALL options and their nested objects,
        // but this is only a means to be notified of top-level non-complex options changes.
        options: {
            deep: true,
            handler(options) {
                let calendar = this.getApi();
                calendar.pauseRendering();
                let calendarOptions = this.buildOptions(options, this.$.appContext);
                calendar.resetOptions(calendarOptions);
                this.renderId++; // will queue a rerender
            }
        }
    };
    for (let complexOptionName in OPTION_IS_COMPLEX) {
        // handlers called when nested objects change
        watchers[`options.${complexOptionName}`] = {
            deep: true,
            handler(val) {
                // unfortunately the handler is called with undefined if new props were set, but the complex one wasn't ever set
                if (val !== undefined) {
                    let calendar = this.getApi();
                    calendar.pauseRendering();
                    calendar.resetOptions({
                        // the only reason we shallow-copy is to trick FC into knowing there's a nested change.
                        // TODO: future versions of FC will more gracefully handle event option-changes that are same-reference.
                        [complexOptionName]: shallowCopy(val)
                    }, true);
                    this.renderId++; // will queue a rerender
                }
            }
        };
    }
    return watchers;
}
//# sourceMappingURL=FullCalendar.js.map
;// CONCATENATED MODULE: ./node_modules/@fullcalendar/vue3/dist/main.js

/* harmony default export */ const main = (dist_FullCalendar);
// so can access any of the utils/types from this lib

//# sourceMappingURL=main.js.map
;// CONCATENATED MODULE: ./node_modules/@fullcalendar/daygrid/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var node_modules_tslib_tslib_es6_extendStatics = function(d, b) {
    node_modules_tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return node_modules_tslib_tslib_es6_extendStatics(d, b);
};

function node_modules_tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    node_modules_tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var daygrid_node_modules_tslib_tslib_es6_assign = function() {
    daygrid_node_modules_tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return daygrid_node_modules_tslib_tslib_es6_assign.apply(this, arguments);
}

function node_modules_tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function node_modules_tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function node_modules_tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function node_modules_tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function node_modules_tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function node_modules_tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var node_modules_tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function node_modules_tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) node_modules_tslib_tslib_es6_createBinding(o, m, p);
}

function node_modules_tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function node_modules_tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function node_modules_tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(node_modules_tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function node_modules_tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function node_modules_tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function node_modules_tslib_tslib_es6_await(v) {
    return this instanceof node_modules_tslib_tslib_es6_await ? (this.v = v, this) : new node_modules_tslib_tslib_es6_await(v);
}

function node_modules_tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof node_modules_tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function node_modules_tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: node_modules_tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function node_modules_tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof node_modules_tslib_tslib_es6_values === "function" ? node_modules_tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function node_modules_tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var node_modules_tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function node_modules_tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) node_modules_tslib_tslib_es6_createBinding(result, mod, k);
    node_modules_tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function node_modules_tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function node_modules_tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function node_modules_tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function node_modules_tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/daygrid/main.js
/*!
FullCalendar v5.10.2
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/





/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var TableView = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableView, _super);
    function TableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headerElRef = createRef();
        return _this;
    }
    TableView.prototype.renderSimpleLayout = function (headerRowContent, bodyContent) {
        var _a = this, props = _a.props, context = _a.context;
        var sections = [];
        var stickyHeaderDates = getStickyHeaderDates(context.options);
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunk: {
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent,
                },
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunk: { content: bodyContent },
        });
        return (createElement(ViewRoot, { viewSpec: context.viewSpec }, function (rootElRef, classNames) { return (createElement("div", { ref: rootElRef, className: ['fc-daygrid'].concat(classNames).join(' ') },
            createElement(SimpleScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, cols: [] /* TODO: make optional? */, sections: sections }))); }));
    };
    TableView.prototype.renderHScrollLayout = function (headerRowContent, bodyContent, colCnt, dayMinWidth) {
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) {
            throw new Error('No ScrollGrid implementation');
        }
        var _a = this, props = _a.props, context = _a.context;
        var stickyHeaderDates = !props.forPrint && getStickyHeaderDates(context.options);
        var stickyFooterScrollbar = !props.forPrint && getStickyFooterScrollbar(context.options);
        var sections = [];
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunks: [{
                        key: 'main',
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent,
                    }],
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            chunks: [{
                    key: 'main',
                    content: bodyContent,
                }],
        });
        if (stickyFooterScrollbar) {
            sections.push({
                type: 'footer',
                key: 'footer',
                isSticky: true,
                chunks: [{
                        key: 'main',
                        content: renderScrollShim,
                    }],
            });
        }
        return (createElement(ViewRoot, { viewSpec: context.viewSpec }, function (rootElRef, classNames) { return (createElement("div", { ref: rootElRef, className: ['fc-daygrid'].concat(classNames).join(' ') },
            createElement(ScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, colGroups: [{ cols: [{ span: colCnt, minWidth: dayMinWidth }] }], sections: sections }))); }));
    };
    return TableView;
}(DateComponent));

function splitSegsByRow(segs, rowCnt) {
    var byRow = [];
    for (var i = 0; i < rowCnt; i += 1) {
        byRow[i] = [];
    }
    for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
        var seg = segs_1[_i];
        byRow[seg.row].push(seg);
    }
    return byRow;
}
function splitSegsByFirstCol(segs, colCnt) {
    var byCol = [];
    for (var i = 0; i < colCnt; i += 1) {
        byCol[i] = [];
    }
    for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
        var seg = segs_2[_i];
        byCol[seg.firstCol].push(seg);
    }
    return byCol;
}
function splitInteractionByRow(ui, rowCnt) {
    var byRow = [];
    if (!ui) {
        for (var i = 0; i < rowCnt; i += 1) {
            byRow[i] = null;
        }
    }
    else {
        for (var i = 0; i < rowCnt; i += 1) {
            byRow[i] = {
                affectedInstances: ui.affectedInstances,
                isEvent: ui.isEvent,
                segs: [],
            };
        }
        for (var _i = 0, _a = ui.segs; _i < _a.length; _i++) {
            var seg = _a[_i];
            byRow[seg.row].segs.push(seg);
        }
    }
    return byRow;
}

var TableCellTop = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableCellTop, _super);
    function TableCellTop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableCellTop.prototype.render = function () {
        var props = this.props;
        var navLinkAttrs = buildNavLinkAttrs(this.context, props.date);
        return (createElement(DayCellContent, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, showDayNumber: props.showDayNumber, extraHookProps: props.extraHookProps, defaultContent: renderTopInner }, function (innerElRef, innerContent) { return ((innerContent || props.forceDayTop) && (createElement("div", { className: "fc-daygrid-day-top", ref: innerElRef },
            createElement("a", daygrid_node_modules_tslib_tslib_es6_assign({ id: props.dayNumberId, className: "fc-daygrid-day-number" }, navLinkAttrs), innerContent || createElement(Fragment, null, "\u00A0"))))); }));
    };
    return TableCellTop;
}(BaseComponent));
function renderTopInner(props) {
    return props.dayNumberText;
}

var DEFAULT_TABLE_EVENT_TIME_FORMAT = createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'narrow',
});
function hasListItemDisplay(seg) {
    var display = seg.eventRange.ui.display;
    return display === 'list-item' || (display === 'auto' &&
        !seg.eventRange.def.allDay &&
        seg.firstCol === seg.lastCol && // can't be multi-day
        seg.isStart && // "
        seg.isEnd // "
    );
}

var TableBlockEvent = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableBlockEvent, _super);
    function TableBlockEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableBlockEvent.prototype.render = function () {
        var props = this.props;
        return (createElement(StandardEvent, daygrid_node_modules_tslib_tslib_es6_assign({}, props, { extraClassNames: ['fc-daygrid-event', 'fc-daygrid-block-event', 'fc-h-event'], defaultTimeFormat: DEFAULT_TABLE_EVENT_TIME_FORMAT, defaultDisplayEventEnd: props.defaultDisplayEventEnd, disableResizing: !props.seg.eventRange.def.allDay })));
    };
    return TableBlockEvent;
}(BaseComponent));

var TableListItemEvent = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableListItemEvent, _super);
    function TableListItemEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableListItemEvent.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var timeFormat = context.options.eventTimeFormat || DEFAULT_TABLE_EVENT_TIME_FORMAT;
        var timeText = buildSegTimeText(props.seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (createElement(EventRoot, { seg: props.seg, timeText: timeText, defaultContent: main_renderInnerContent, isDragging: props.isDragging, isResizing: false, isDateSelecting: false, isSelected: props.isSelected, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent) { return ( // we don't use styles!
        createElement("a", daygrid_node_modules_tslib_tslib_es6_assign({ className: ['fc-daygrid-event', 'fc-daygrid-dot-event'].concat(classNames).join(' '), ref: rootElRef }, getSegAnchorAttrs(props.seg, context)), innerContent)); }));
    };
    return TableListItemEvent;
}(BaseComponent));
function main_renderInnerContent(innerProps) {
    return (createElement(Fragment, null,
        createElement("div", { className: "fc-daygrid-event-dot", style: { borderColor: innerProps.borderColor || innerProps.backgroundColor } }),
        innerProps.timeText && (createElement("div", { className: "fc-event-time" }, innerProps.timeText)),
        createElement("div", { className: "fc-event-title" }, innerProps.event.title || createElement(Fragment, null, "\u00A0"))));
}

var TableCellMoreLink = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableCellMoreLink, _super);
    function TableCellMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.compileSegs = memoize(compileSegs);
        return _this;
    }
    TableCellMoreLink.prototype.render = function () {
        var props = this.props;
        var _a = this.compileSegs(props.singlePlacements), allSegs = _a.allSegs, invisibleSegs = _a.invisibleSegs;
        return (createElement(MoreLinkRoot, { dateProfile: props.dateProfile, todayRange: props.todayRange, allDayDate: props.allDayDate, moreCnt: props.moreCnt, allSegs: allSegs, hiddenSegs: invisibleSegs, alignmentElRef: props.alignmentElRef, alignGridTop: props.alignGridTop, extraDateSpan: props.extraDateSpan, popoverContent: function () {
                var isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) ||
                    (props.eventResize ? props.eventResize.affectedInstances : null) ||
                    {};
                return (createElement(Fragment, null, allSegs.map(function (seg) {
                    var instanceId = seg.eventRange.instance.instanceId;
                    return (createElement("div", { className: "fc-daygrid-event-harness", key: instanceId, style: {
                            visibility: isForcedInvisible[instanceId] ? 'hidden' : '',
                        } }, hasListItemDisplay(seg) ? (createElement(TableListItemEvent, daygrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: false, isSelected: instanceId === props.eventSelection, defaultDisplayEventEnd: false }, getSegMeta(seg, props.todayRange)))) : (createElement(TableBlockEvent, daygrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: instanceId === props.eventSelection, defaultDisplayEventEnd: false }, getSegMeta(seg, props.todayRange))))));
                })));
            } }, function (rootElRef, classNames, innerElRef, innerContent, handleClick, title, isExpanded, popoverId) { return (createElement("a", daygrid_node_modules_tslib_tslib_es6_assign({ ref: rootElRef, className: ['fc-daygrid-more-link'].concat(classNames).join(' '), title: title, "aria-expanded": isExpanded, "aria-controls": popoverId }, createAriaClickAttrs(handleClick)), innerContent)); }));
    };
    return TableCellMoreLink;
}(BaseComponent));
function compileSegs(singlePlacements) {
    var allSegs = [];
    var invisibleSegs = [];
    for (var _i = 0, singlePlacements_1 = singlePlacements; _i < singlePlacements_1.length; _i++) {
        var placement = singlePlacements_1[_i];
        allSegs.push(placement.seg);
        if (!placement.isVisible) {
            invisibleSegs.push(placement.seg);
        }
    }
    return { allSegs: allSegs, invisibleSegs: invisibleSegs };
}

var DEFAULT_WEEK_NUM_FORMAT = createFormatter({ week: 'narrow' });
var TableCell = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableCell, _super);
    function TableCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = createRef();
        _this.state = {
            dayNumberId: getUniqueDomId(),
        };
        _this.handleRootEl = function (el) {
            setRef(_this.rootElRef, el);
            setRef(_this.props.elRef, el);
        };
        return _this;
    }
    TableCell.prototype.render = function () {
        var _a = this, context = _a.context, props = _a.props, state = _a.state, rootElRef = _a.rootElRef;
        var date = props.date, dateProfile = props.dateProfile;
        var navLinkAttrs = buildNavLinkAttrs(context, date, 'week');
        return (createElement(DayCellRoot, { date: date, dateProfile: dateProfile, todayRange: props.todayRange, showDayNumber: props.showDayNumber, extraHookProps: props.extraHookProps, elRef: this.handleRootEl }, function (dayElRef, dayClassNames, rootDataAttrs, isDisabled) { return (createElement("td", daygrid_node_modules_tslib_tslib_es6_assign({ ref: dayElRef, role: "gridcell", className: ['fc-daygrid-day'].concat(dayClassNames, props.extraClassNames || []).join(' ') }, rootDataAttrs, props.extraDataAttrs, (props.showDayNumber ? { 'aria-labelledby': state.dayNumberId } : {})),
            createElement("div", { className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner", ref: props.innerElRef /* different from hook system! RENAME */ },
                props.showWeekNumber && (createElement(WeekNumberRoot, { date: date, defaultFormat: DEFAULT_WEEK_NUM_FORMAT }, function (weekElRef, weekClassNames, innerElRef, innerContent) { return (createElement("a", daygrid_node_modules_tslib_tslib_es6_assign({ ref: weekElRef, className: ['fc-daygrid-week-number'].concat(weekClassNames).join(' ') }, navLinkAttrs), innerContent)); })),
                !isDisabled && (createElement(TableCellTop, { date: date, dateProfile: dateProfile, showDayNumber: props.showDayNumber, dayNumberId: state.dayNumberId, forceDayTop: props.forceDayTop, todayRange: props.todayRange, extraHookProps: props.extraHookProps })),
                createElement("div", { className: "fc-daygrid-day-events", ref: props.fgContentElRef },
                    props.fgContent,
                    createElement("div", { className: "fc-daygrid-day-bottom", style: { marginTop: props.moreMarginTop } },
                        createElement(TableCellMoreLink, { allDayDate: date, singlePlacements: props.singlePlacements, moreCnt: props.moreCnt, alignmentElRef: rootElRef, alignGridTop: !props.showDayNumber, extraDateSpan: props.extraDateSpan, dateProfile: props.dateProfile, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, todayRange: props.todayRange }))),
                createElement("div", { className: "fc-daygrid-day-bg" }, props.bgContent)))); }));
    };
    return TableCell;
}(DateComponent));

function computeFgSegPlacement(segs, // assumed already sorted
dayMaxEvents, dayMaxEventRows, strictOrder, eventInstanceHeights, maxContentHeight, cells) {
    var hierarchy = new DayGridSegHierarchy();
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    }
    else if (typeof dayMaxEvents === 'number') {
        hierarchy.maxStackCnt = dayMaxEvents;
    }
    else if (typeof dayMaxEventRows === 'number') {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    var segInputs = [];
    var unknownHeightSegs = [];
    for (var i = 0; i < segs.length; i += 1) {
        var seg = segs[i];
        var instanceId = seg.eventRange.instance.instanceId;
        var eventHeight = eventInstanceHeights[instanceId];
        if (eventHeight != null) {
            segInputs.push({
                index: i,
                thickness: eventHeight,
                span: {
                    start: seg.firstCol,
                    end: seg.lastCol + 1,
                },
            });
        }
        else {
            unknownHeightSegs.push(seg);
        }
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var segRects = hierarchy.toRects();
    var _a = placeRects(segRects, segs, cells), singleColPlacements = _a.singleColPlacements, multiColPlacements = _a.multiColPlacements, leftoverMargins = _a.leftoverMargins;
    var moreCnts = [];
    var moreMarginTops = [];
    // add segs with unknown heights
    for (var _i = 0, unknownHeightSegs_1 = unknownHeightSegs; _i < unknownHeightSegs_1.length; _i++) {
        var seg = unknownHeightSegs_1[_i];
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0,
        });
        for (var col = seg.firstCol; col <= seg.lastCol; col += 1) {
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0,
            });
        }
    }
    // add the hidden entries
    for (var col = 0; col < cells.length; col += 1) {
        moreCnts.push(0);
    }
    for (var _b = 0, hiddenEntries_1 = hiddenEntries; _b < hiddenEntries_1.length; _b++) {
        var hiddenEntry = hiddenEntries_1[_b];
        var seg = segs[hiddenEntry.index];
        var hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0,
        });
        for (var col = hiddenSpan.start; col < hiddenSpan.end; col += 1) {
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0,
            });
        }
    }
    // deal with leftover margins
    for (var col = 0; col < cells.length; col += 1) {
        moreMarginTops.push(leftoverMargins[col]);
    }
    return { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops };
}
// rects ordered by top coord, then left
function placeRects(allRects, segs, cells) {
    var rectsByEachCol = groupRectsByEachCol(allRects, cells.length);
    var singleColPlacements = [];
    var multiColPlacements = [];
    var leftoverMargins = [];
    for (var col = 0; col < cells.length; col += 1) {
        var rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        var singlePlacements = [];
        var currentHeight = 0;
        var currentMarginTop = 0;
        for (var _i = 0, rects_1 = rects; _i < rects_1.length; _i++) {
            var rect = rects_1[_i];
            var seg = segs[rect.index];
            singlePlacements.push({
                seg: resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight,
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        var multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (var _a = 0, rects_2 = rects; _a < rects_2.length; _a++) {
            var rect = rects_2[_a];
            var seg = segs[rect.index];
            var isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            var isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) {
                    multiPlacements.push({
                        seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                        isVisible: true,
                        isAbsolute: true,
                        absoluteTop: rect.levelCoord,
                        marginTop: 0,
                    });
                }
            }
            else if (isFirstCol) {
                multiPlacements.push({
                    seg: resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop, // claim the margin
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins };
}
function groupRectsByEachCol(rects, colCnt) {
    var rectsByEachCol = [];
    for (var col = 0; col < colCnt; col += 1) {
        rectsByEachCol.push([]);
    }
    for (var _i = 0, rects_3 = rects; _i < rects_3.length; _i++) {
        var rect = rects_3[_i];
        for (var col = rect.span.start; col < rect.span.end; col += 1) {
            rectsByEachCol[col].push(rect);
        }
    }
    return rectsByEachCol;
}
function resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) {
        return seg;
    }
    var eventRange = seg.eventRange;
    var origRange = eventRange.range;
    var slicedRange = intersectRanges(origRange, {
        start: cells[spanStart].date,
        end: addDays(cells[spanEnd - 1].date, 1),
    });
    return daygrid_node_modules_tslib_tslib_es6_assign(daygrid_node_modules_tslib_tslib_es6_assign({}, seg), { firstCol: spanStart, lastCol: spanEnd - 1, eventRange: {
            def: eventRange.def,
            ui: daygrid_node_modules_tslib_tslib_es6_assign(daygrid_node_modules_tslib_tslib_es6_assign({}, eventRange.ui), { durationEditable: false }),
            instance: eventRange.instance,
            range: slicedRange,
        }, isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(), isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf() });
}
var DayGridSegHierarchy = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(DayGridSegHierarchy, _super);
    function DayGridSegHierarchy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // config
        _this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        _this.forceHidden = {};
        return _this;
    }
    DayGridSegHierarchy.prototype.addSegs = function (segInputs) {
        var _this = this;
        var hiddenSegs = _super.prototype.addSegs.call(this, segInputs);
        var entriesByLevel = this.entriesByLevel;
        var excludeHidden = function (entry) { return !_this.forceHidden[buildEntryKey(entry)]; };
        // remove the forced-hidden segs
        for (var level = 0; level < entriesByLevel.length; level += 1) {
            entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        }
        return hiddenSegs;
    };
    DayGridSegHierarchy.prototype.handleInvalidInsertion = function (insertion, entry, hiddenEntries) {
        var _a = this, entriesByLevel = _a.entriesByLevel, forceHidden = _a.forceHidden;
        var touchingEntry = insertion.touchingEntry, touchingLevel = insertion.touchingLevel, touchingLateral = insertion.touchingLateral;
        if (this.hiddenConsumes && touchingEntry) {
            var touchingEntryId = buildEntryKey(touchingEntry);
            // if not already hidden
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    var placeholderEntry = daygrid_node_modules_tslib_tslib_es6_assign(daygrid_node_modules_tslib_tslib_es6_assign({}, touchingEntry), { span: intersectSpans(touchingEntry.span, entry.span) });
                    var placeholderEntryId = buildEntryKey(placeholderEntry);
                    forceHidden[placeholderEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry; // replace touchingEntry with our placeholder
                    this.splitEntry(touchingEntry, entry, hiddenEntries); // split up the touchingEntry, reinsert it
                }
                else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        return _super.prototype.handleInvalidInsertion.call(this, insertion, entry, hiddenEntries);
    };
    return DayGridSegHierarchy;
}(SegHierarchy));

var TableRow = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableRow, _super);
    function TableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cellElRefs = new RefMap(); // the <td>
        _this.frameElRefs = new RefMap(); // the fc-daygrid-day-frame
        _this.fgElRefs = new RefMap(); // the fc-daygrid-day-events
        _this.segHarnessRefs = new RefMap(); // indexed by "instanceId:firstCol"
        _this.rootElRef = createRef();
        _this.state = {
            framePositions: null,
            maxContentHeight: null,
            eventInstanceHeights: {},
        };
        return _this;
    }
    TableRow.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state, context = _a.context;
        var options = context.options;
        var colCnt = props.cells.length;
        var businessHoursByCol = splitSegsByFirstCol(props.businessHourSegs, colCnt);
        var bgEventSegsByCol = splitSegsByFirstCol(props.bgEventSegs, colCnt);
        var highlightSegsByCol = splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        var mirrorSegsByCol = splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        var _b = computeFgSegPlacement(sortEventSegs(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.eventInstanceHeights, state.maxContentHeight, props.cells), singleColPlacements = _b.singleColPlacements, multiColPlacements = _b.multiColPlacements, moreCnts = _b.moreCnts, moreMarginTops = _b.moreMarginTops;
        var isForcedInvisible = // TODO: messy way to compute this
         (props.eventDrag && props.eventDrag.affectedInstances) ||
            (props.eventResize && props.eventResize.affectedInstances) ||
            {};
        return (createElement("tr", { ref: this.rootElRef, role: "row" },
            props.renderIntro && props.renderIntro(),
            props.cells.map(function (cell, col) {
                var normalFgNodes = _this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
                var mirrorFgNodes = _this.renderFgSegs(col, buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
                return (createElement(TableCell, { key: cell.key, elRef: _this.cellElRefs.createRef(cell.key), innerElRef: _this.frameElRefs.createRef(cell.key) /* FF <td> problem, but okay to use for left/right. TODO: rename prop */, dateProfile: props.dateProfile, date: cell.date, showDayNumber: props.showDayNumbers, showWeekNumber: props.showWeekNumbers && col === 0, forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */, todayRange: props.todayRange, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, extraHookProps: cell.extraHookProps, extraDataAttrs: cell.extraDataAttrs, extraClassNames: cell.extraClassNames, extraDateSpan: cell.extraDateSpan, moreCnt: moreCnts[col], moreMarginTop: moreMarginTops[col], singlePlacements: singleColPlacements[col], fgContentElRef: _this.fgElRefs.createRef(cell.key), fgContent: ( // Fragment scopes the keys
                    createElement(Fragment, null,
                        createElement(Fragment, null, normalFgNodes),
                        createElement(Fragment, null, mirrorFgNodes))), bgContent: ( // Fragment scopes the keys
                    createElement(Fragment, null,
                        _this.renderFillSegs(highlightSegsByCol[col], 'highlight'),
                        _this.renderFillSegs(businessHoursByCol[col], 'non-business'),
                        _this.renderFillSegs(bgEventSegsByCol[col], 'bg-event'))) }));
            })));
    };
    TableRow.prototype.componentDidMount = function () {
        this.updateSizing(true);
    };
    TableRow.prototype.componentDidUpdate = function (prevProps, prevState) {
        var currentProps = this.props;
        this.updateSizing(!isPropsEqual(prevProps, currentProps));
    };
    TableRow.prototype.getHighlightSegs = function () {
        var props = this.props;
        if (props.eventDrag && props.eventDrag.segs.length) { // messy check
            return props.eventDrag.segs;
        }
        if (props.eventResize && props.eventResize.segs.length) { // messy check
            return props.eventResize.segs;
        }
        return props.dateSelectionSegs;
    };
    TableRow.prototype.getMirrorSegs = function () {
        var props = this.props;
        if (props.eventResize && props.eventResize.segs.length) { // messy check
            return props.eventResize.segs;
        }
        return [];
    };
    TableRow.prototype.renderFgSegs = function (col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        var context = this.context;
        var eventSelection = this.props.eventSelection;
        var framePositions = this.state.framePositions;
        var defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        var isMirror = isDragging || isResizing || isDateSelecting;
        var nodes = [];
        if (framePositions) {
            for (var _i = 0, segPlacements_1 = segPlacements; _i < segPlacements_1.length; _i++) {
                var placement = segPlacements_1[_i];
                var seg = placement.seg;
                var instanceId = seg.eventRange.instance.instanceId;
                var key = instanceId + ':' + col;
                var isVisible = placement.isVisible && !isForcedInvisible[instanceId];
                var isAbsolute = placement.isAbsolute;
                var left = '';
                var right = '';
                if (isAbsolute) {
                    if (context.isRtl) {
                        right = 0;
                        left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                    }
                    else {
                        left = 0;
                        right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                    }
                }
                /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */
                nodes.push(createElement("div", { className: 'fc-daygrid-event-harness' + (isAbsolute ? ' fc-daygrid-event-harness-abs' : ''), key: key, ref: isMirror ? null : this.segHarnessRefs.createRef(key), style: {
                        visibility: isVisible ? '' : 'hidden',
                        marginTop: isAbsolute ? '' : placement.marginTop,
                        top: isAbsolute ? placement.absoluteTop : '',
                        left: left,
                        right: right,
                    } }, hasListItemDisplay(seg) ? (createElement(TableListItemEvent, daygrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: isDragging, isSelected: instanceId === eventSelection, defaultDisplayEventEnd: defaultDisplayEventEnd }, getSegMeta(seg, todayRange)))) : (createElement(TableBlockEvent, daygrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: isDragging, isResizing: isResizing, isDateSelecting: isDateSelecting, isSelected: instanceId === eventSelection, defaultDisplayEventEnd: defaultDisplayEventEnd }, getSegMeta(seg, todayRange))))));
            }
        }
        return nodes;
    };
    TableRow.prototype.renderFillSegs = function (segs, fillType) {
        var isRtl = this.context.isRtl;
        var todayRange = this.props.todayRange;
        var framePositions = this.state.framePositions;
        var nodes = [];
        if (framePositions) {
            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
                var seg = segs_1[_i];
                var leftRightCss = isRtl ? {
                    right: 0,
                    left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol],
                } : {
                    left: 0,
                    right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol],
                };
                nodes.push(createElement("div", { key: buildEventRangeKey(seg.eventRange), className: "fc-daygrid-bg-harness", style: leftRightCss }, fillType === 'bg-event' ?
                    createElement(BgEvent, daygrid_node_modules_tslib_tslib_es6_assign({ seg: seg }, getSegMeta(seg, todayRange))) :
                    renderFill(fillType)));
            }
        }
        return createElement.apply(void 0, node_modules_tslib_tslib_es6_spreadArray([Fragment, {}], nodes));
    };
    TableRow.prototype.updateSizing = function (isExternalSizingChange) {
        var _a = this, props = _a.props, frameElRefs = _a.frameElRefs;
        if (!props.forPrint &&
            props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                var frameEls = props.cells.map(function (cell) { return frameElRefs.currentMap[cell.key]; });
                if (frameEls.length) {
                    var originEl = this.rootElRef.current;
                    this.setState({
                        framePositions: new PositionCache(originEl, frameEls, true, // isHorizontal
                        false),
                    });
                }
            }
            var oldInstanceHeights = this.state.eventInstanceHeights;
            var newInstanceHeights = this.queryEventInstanceHeights();
            var limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.setState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                eventInstanceHeights: daygrid_node_modules_tslib_tslib_es6_assign(daygrid_node_modules_tslib_tslib_es6_assign({}, oldInstanceHeights), newInstanceHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null,
            });
        }
    };
    TableRow.prototype.queryEventInstanceHeights = function () {
        var segElMap = this.segHarnessRefs.currentMap;
        var eventInstanceHeights = {};
        // get the max height amongst instance segs
        for (var key in segElMap) {
            var height = Math.round(segElMap[key].getBoundingClientRect().height);
            var instanceId = key.split(':')[0]; // deconstruct how renderFgSegs makes the key
            eventInstanceHeights[instanceId] = Math.max(eventInstanceHeights[instanceId] || 0, height);
        }
        return eventInstanceHeights;
    };
    TableRow.prototype.computeMaxContentHeight = function () {
        var firstKey = this.props.cells[0].key;
        var cellEl = this.cellElRefs.currentMap[firstKey];
        var fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    };
    TableRow.prototype.getCellEls = function () {
        var elMap = this.cellElRefs.currentMap;
        return this.props.cells.map(function (cell) { return elMap[cell.key]; });
    };
    return TableRow;
}(DateComponent));
TableRow.addStateEquality({
    eventInstanceHeights: isPropsEqual,
});
function buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) {
        return [];
    }
    var topsByInstanceId = buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map(function (seg) { return ({
        seg: seg,
        isVisible: true,
        isAbsolute: true,
        absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
        marginTop: 0,
    }); });
}
function buildAbsoluteTopHash(colPlacements) {
    var topsByInstanceId = {};
    for (var _i = 0, colPlacements_1 = colPlacements; _i < colPlacements_1.length; _i++) {
        var placements = colPlacements_1[_i];
        for (var _a = 0, placements_1 = placements; _a < placements_1.length; _a++) {
            var placement = placements_1[_a];
            topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
        }
    }
    return topsByInstanceId;
}

var Table = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitBusinessHourSegs = memoize(splitSegsByRow);
        _this.splitBgEventSegs = memoize(splitSegsByRow);
        _this.splitFgEventSegs = memoize(splitSegsByRow);
        _this.splitDateSelectionSegs = memoize(splitSegsByRow);
        _this.splitEventDrag = memoize(splitInteractionByRow);
        _this.splitEventResize = memoize(splitInteractionByRow);
        _this.rowRefs = new RefMap();
        _this.handleRootEl = function (rootEl) {
            _this.rootEl = rootEl;
            if (rootEl) {
                _this.context.registerInteractiveComponent(_this, {
                    el: rootEl,
                    isHitComboAllowed: _this.props.isHitComboAllowed,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        return _this;
    }
    Table.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var dateProfile = props.dateProfile, dayMaxEventRows = props.dayMaxEventRows, dayMaxEvents = props.dayMaxEvents, expandRows = props.expandRows;
        var rowCnt = props.cells.length;
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        var limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        var classNames = [
            'fc-daygrid-body',
            limitViaBalanced ? 'fc-daygrid-body-balanced' : 'fc-daygrid-body-unbalanced',
            expandRows ? '' : 'fc-daygrid-body-natural', // will height of one row depend on the others?
        ];
        return (createElement("div", { className: classNames.join(' '), ref: this.handleRootEl, style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
            } },
            createElement(NowTimer, { unit: "day" }, function (nowDate, todayRange) { return (createElement(Fragment, null,
                createElement("table", { role: "presentation", className: "fc-scrollgrid-sync-table", style: {
                        width: props.clientWidth,
                        minWidth: props.tableMinWidth,
                        height: expandRows ? props.clientHeight : '',
                    } },
                    props.colGroupNode,
                    createElement("tbody", { role: "presentation" }, props.cells.map(function (cells, row) { return (createElement(TableRow, { ref: _this.rowRefs.createRef(row), key: cells.length
                            ? cells[0].date.toISOString() /* best? or put key on cell? or use diff formatter? */
                            : row // in case there are no cells (like when resource view is loading)
                        , showDayNumbers: rowCnt > 1, showWeekNumbers: props.showWeekNumbers, todayRange: todayRange, dateProfile: dateProfile, cells: cells, renderIntro: props.renderRowIntro, businessHourSegs: businessHourSegsByRow[row], eventSelection: props.eventSelection, bgEventSegs: bgEventSegsByRow[row].filter(isSegAllDay) /* hack */, fgEventSegs: fgEventSegsByRow[row], dateSelectionSegs: dateSelectionSegsByRow[row], eventDrag: eventDragByRow[row], eventResize: eventResizeByRow[row], dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows, clientWidth: props.clientWidth, clientHeight: props.clientHeight, forPrint: props.forPrint })); }))))); })));
    };
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    Table.prototype.prepareHits = function () {
        this.rowPositions = new PositionCache(this.rootEl, this.rowRefs.collect().map(function (rowObj) { return rowObj.getCellEls()[0]; }), // first cell el in each row. TODO: not optimal
        false, true);
        this.colPositions = new PositionCache(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), // cell els in first row
        true, // horizontal
        false);
    };
    Table.prototype.queryHit = function (positionLeft, positionTop) {
        var _a = this, colPositions = _a.colPositions, rowPositions = _a.rowPositions;
        var col = colPositions.leftToIndex(positionLeft);
        var row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            var cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: daygrid_node_modules_tslib_tslib_es6_assign({ range: this.getCellRange(row, col), allDay: true }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row],
                },
                layer: 0,
            };
        }
        return null;
    };
    Table.prototype.getCellEl = function (row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    };
    Table.prototype.getCellRange = function (row, col) {
        var start = this.props.cells[row][col].date;
        var end = addDays(start, 1);
        return { start: start, end: end };
    };
    return Table;
}(DateComponent));
function isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}

var DayTableSlicer = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(DayTableSlicer, _super);
    function DayTableSlicer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceDayIfListItem = true;
        return _this;
    }
    DayTableSlicer.prototype.sliceRange = function (dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    };
    return DayTableSlicer;
}(Slicer));

var DayTable = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(DayTable, _super);
    function DayTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slicer = new DayTableSlicer();
        _this.tableRef = createRef();
        return _this;
    }
    DayTable.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        return (createElement(Table, daygrid_node_modules_tslib_tslib_es6_assign({ ref: this.tableRef }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), { dateProfile: props.dateProfile, cells: props.dayTableModel.cells, colGroupNode: props.colGroupNode, tableMinWidth: props.tableMinWidth, renderRowIntro: props.renderRowIntro, dayMaxEvents: props.dayMaxEvents, dayMaxEventRows: props.dayMaxEventRows, showWeekNumbers: props.showWeekNumbers, expandRows: props.expandRows, headerAlignElRef: props.headerAlignElRef, clientWidth: props.clientWidth, clientHeight: props.clientHeight, forPrint: props.forPrint })));
    };
    return DayTable;
}(DateComponent));

var DayTableView = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(DayTableView, _super);
    function DayTableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayTableModel = memoize(buildDayTableModel);
        _this.headerRef = createRef();
        _this.tableRef = createRef();
        return _this;
    }
    DayTableView.prototype.render = function () {
        var _this = this;
        var _a = this.context, options = _a.options, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        var headerContent = options.dayHeaders && (createElement(DayHeader, { ref: this.headerRef, dateProfile: props.dateProfile, dates: dayTableModel.headerDates, datesRepDistinctDays: dayTableModel.rowCnt === 1 }));
        var bodyContent = function (contentArg) { return (createElement(DayTable, { ref: _this.tableRef, dateProfile: props.dateProfile, dayTableModel: dayTableModel, businessHours: props.businessHours, dateSelection: props.dateSelection, eventStore: props.eventStore, eventUiBases: props.eventUiBases, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, nextDayThreshold: options.nextDayThreshold, colGroupNode: contentArg.tableColGroupNode, tableMinWidth: contentArg.tableMinWidth, dayMaxEvents: options.dayMaxEvents, dayMaxEventRows: options.dayMaxEventRows, showWeekNumbers: options.weekNumbers, expandRows: !props.isHeightAuto, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint })); };
        return options.dayMinWidth
            ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth)
            : this.renderSimpleLayout(headerContent, bodyContent);
    };
    return DayTableView;
}(TableView));
function buildDayTableModel(dateProfile, dateProfileGenerator) {
    var daySeries = new DaySeriesModel(dateProfile.renderRange, dateProfileGenerator);
    return new DayTableModel(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}

var TableDateProfileGenerator = /** @class */ (function (_super) {
    node_modules_tslib_tslib_es6_extends(TableDateProfileGenerator, _super);
    function TableDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    TableDateProfileGenerator.prototype.buildRenderRange = function (currentRange, currentRangeUnit, isRangeAllDay) {
        var dateEnv = this.props.dateEnv;
        var renderRange = _super.prototype.buildRenderRange.call(this, currentRange, currentRangeUnit, isRangeAllDay);
        var start = renderRange.start;
        var end = renderRange.end;
        var endOfWeek;
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start = dateEnv.startOfWeek(start);
            // make end-of-week if not already
            endOfWeek = dateEnv.startOfWeek(end);
            if (endOfWeek.valueOf() !== end.valueOf()) {
                end = addWeeks(endOfWeek, 1);
            }
        }
        // ensure 6 weeks
        if (this.props.monthMode &&
            this.props.fixedWeekCount) {
            var rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
            diffWeeks(start, end));
            end = addWeeks(end, 6 - rowCnt);
        }
        return { start: start, end: end };
    };
    return TableDateProfileGenerator;
}(DateProfileGenerator));

var main_main = createPlugin({
    initialView: 'dayGridMonth',
    views: {
        dayGrid: {
            component: DayTableView,
            dateProfileGeneratorClass: TableDateProfileGenerator,
        },
        dayGridDay: {
            type: 'dayGrid',
            duration: { days: 1 },
        },
        dayGridWeek: {
            type: 'dayGrid',
            duration: { weeks: 1 },
        },
        dayGridMonth: {
            type: 'dayGrid',
            duration: { months: 1 },
            monthMode: true,
            fixedWeekCount: true,
        },
    },
});

/* harmony default export */ const daygrid_main = (main_main);

//# sourceMappingURL=main.js.map

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/timegrid/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var timegrid_node_modules_tslib_tslib_es6_extendStatics = function(d, b) {
    timegrid_node_modules_tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return timegrid_node_modules_tslib_tslib_es6_extendStatics(d, b);
};

function timegrid_node_modules_tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    timegrid_node_modules_tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var timegrid_node_modules_tslib_tslib_es6_assign = function() {
    timegrid_node_modules_tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return timegrid_node_modules_tslib_tslib_es6_assign.apply(this, arguments);
}

function timegrid_node_modules_tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function timegrid_node_modules_tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function timegrid_node_modules_tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function timegrid_node_modules_tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function timegrid_node_modules_tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function timegrid_node_modules_tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var timegrid_node_modules_tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function timegrid_node_modules_tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) timegrid_node_modules_tslib_tslib_es6_createBinding(o, m, p);
}

function timegrid_node_modules_tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function timegrid_node_modules_tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function timegrid_node_modules_tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(timegrid_node_modules_tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function timegrid_node_modules_tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function timegrid_node_modules_tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function timegrid_node_modules_tslib_tslib_es6_await(v) {
    return this instanceof timegrid_node_modules_tslib_tslib_es6_await ? (this.v = v, this) : new timegrid_node_modules_tslib_tslib_es6_await(v);
}

function timegrid_node_modules_tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof timegrid_node_modules_tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function timegrid_node_modules_tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: timegrid_node_modules_tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function timegrid_node_modules_tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof timegrid_node_modules_tslib_tslib_es6_values === "function" ? timegrid_node_modules_tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function timegrid_node_modules_tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var timegrid_node_modules_tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function timegrid_node_modules_tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) timegrid_node_modules_tslib_tslib_es6_createBinding(result, mod, k);
    timegrid_node_modules_tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function timegrid_node_modules_tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function timegrid_node_modules_tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function timegrid_node_modules_tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function timegrid_node_modules_tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/timegrid/main.js
/*!
FullCalendar v5.10.2
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/






var AllDaySplitter = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(AllDaySplitter, _super);
    function AllDaySplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllDaySplitter.prototype.getKeyInfo = function () {
        return {
            allDay: {},
            timed: {},
        };
    };
    AllDaySplitter.prototype.getKeysForDateSpan = function (dateSpan) {
        if (dateSpan.allDay) {
            return ['allDay'];
        }
        return ['timed'];
    };
    AllDaySplitter.prototype.getKeysForEventDef = function (eventDef) {
        if (!eventDef.allDay) {
            return ['timed'];
        }
        if (hasBgRendering(eventDef)) {
            return ['timed', 'allDay'];
        }
        return ['allDay'];
    };
    return AllDaySplitter;
}(Splitter));

var DEFAULT_SLAT_LABEL_FORMAT = createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    omitZeroMinute: true,
    meridiem: 'short',
});
function TimeColsAxisCell(props) {
    var classNames = [
        'fc-timegrid-slot',
        'fc-timegrid-slot-label',
        props.isLabeled ? 'fc-scrollgrid-shrink' : 'fc-timegrid-slot-minor',
    ];
    return (createElement(ViewContextType.Consumer, null, function (context) {
        if (!props.isLabeled) {
            return (createElement("td", { className: classNames.join(' '), "data-time": props.isoTimeStr }));
        }
        var dateEnv = context.dateEnv, options = context.options, viewApi = context.viewApi;
        var labelFormat = // TODO: fully pre-parse
         options.slotLabelFormat == null ? DEFAULT_SLAT_LABEL_FORMAT :
            Array.isArray(options.slotLabelFormat) ? createFormatter(options.slotLabelFormat[0]) :
                createFormatter(options.slotLabelFormat);
        var hookProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat),
        };
        return (createElement(RenderHook, { hookProps: hookProps, classNames: options.slotLabelClassNames, content: options.slotLabelContent, defaultContent: timegrid_main_renderInnerContent, didMount: options.slotLabelDidMount, willUnmount: options.slotLabelWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (createElement("td", { ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-time": props.isoTimeStr },
            createElement("div", { className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame" },
                createElement("div", { className: "fc-timegrid-slot-label-cushion fc-scrollgrid-shrink-cushion", ref: innerElRef }, innerContent)))); }));
    }));
}
function timegrid_main_renderInnerContent(props) {
    return props.text;
}

var TimeBodyAxis = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeBodyAxis, _super);
    function TimeBodyAxis() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeBodyAxis.prototype.render = function () {
        return this.props.slatMetas.map(function (slatMeta) { return (createElement("tr", { key: slatMeta.key },
            createElement(TimeColsAxisCell, timegrid_node_modules_tslib_tslib_es6_assign({}, slatMeta)))); });
    };
    return TimeBodyAxis;
}(BaseComponent));

var main_DEFAULT_WEEK_NUM_FORMAT = createFormatter({ week: 'short' });
var AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
var TimeColsView = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColsView, _super);
    function TimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allDaySplitter = new AllDaySplitter(); // for use by subclasses
        _this.headerElRef = createRef();
        _this.rootElRef = createRef();
        _this.scrollerElRef = createRef();
        _this.state = {
            slatCoords: null,
        };
        _this.handleScrollTopRequest = function (scrollTop) {
            var scrollerEl = _this.scrollerElRef.current;
            if (scrollerEl) { // TODO: not sure how this could ever be null. weirdness with the reducer
                scrollerEl.scrollTop = scrollTop;
            }
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/
        _this.renderHeadAxis = function (rowKey, frameHeight) {
            if (frameHeight === void 0) { frameHeight = ''; }
            var options = _this.context.options;
            var dateProfile = _this.props.dateProfile;
            var range = dateProfile.renderRange;
            var dayCnt = diffDays(range.start, range.end);
            var navLinkAttrs = (dayCnt === 1) // only do in day views (to avoid doing in week views that dont need it)
                ? buildNavLinkAttrs(_this.context, range.start, 'week')
                : {};
            if (options.weekNumbers && rowKey === 'day') {
                return (createElement(WeekNumberRoot, { date: range.start, defaultFormat: main_DEFAULT_WEEK_NUM_FORMAT }, function (rootElRef, classNames, innerElRef, innerContent) { return (createElement("th", { ref: rootElRef, "aria-hidden": true, className: [
                        'fc-timegrid-axis',
                        'fc-scrollgrid-shrink',
                    ].concat(classNames).join(' ') },
                    createElement("div", { className: "fc-timegrid-axis-frame fc-scrollgrid-shrink-frame fc-timegrid-axis-frame-liquid", style: { height: frameHeight } },
                        createElement("a", timegrid_node_modules_tslib_tslib_es6_assign({ ref: innerElRef, className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner" }, navLinkAttrs), innerContent)))); }));
            }
            return (createElement("th", { "aria-hidden": true, className: "fc-timegrid-axis" },
                createElement("div", { className: "fc-timegrid-axis-frame", style: { height: frameHeight } })));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/
        // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        _this.renderTableRowAxis = function (rowHeight) {
            var _a = _this.context, options = _a.options, viewApi = _a.viewApi;
            var hookProps = {
                text: options.allDayText,
                view: viewApi,
            };
            return (
            // TODO: make reusable hook. used in list view too
            createElement(RenderHook, { hookProps: hookProps, classNames: options.allDayClassNames, content: options.allDayContent, defaultContent: renderAllDayInner, didMount: options.allDayDidMount, willUnmount: options.allDayWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (createElement("td", { ref: rootElRef, "aria-hidden": true, className: [
                    'fc-timegrid-axis',
                    'fc-scrollgrid-shrink',
                ].concat(classNames).join(' ') },
                createElement("div", { className: 'fc-timegrid-axis-frame fc-scrollgrid-shrink-frame' + (rowHeight == null ? ' fc-timegrid-axis-frame-liquid' : ''), style: { height: rowHeight } },
                    createElement("span", { className: "fc-timegrid-axis-cushion fc-scrollgrid-shrink-cushion fc-scrollgrid-sync-inner", ref: innerElRef }, innerContent)))); }));
        };
        _this.handleSlatCoords = function (slatCoords) {
            _this.setState({ slatCoords: slatCoords });
        };
        return _this;
    }
    // rendering
    // ----------------------------------------------------------------------------------------------------
    TimeColsView.prototype.renderSimpleLayout = function (headerRowContent, allDayContent, timeContent) {
        var _a = this, context = _a.context, props = _a.props;
        var sections = [];
        var stickyHeaderDates = getStickyHeaderDates(context.options);
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                chunk: {
                    elRef: this.headerElRef,
                    tableClassName: 'fc-col-header',
                    rowContent: headerRowContent,
                },
            });
        }
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                chunk: { content: allDayContent },
            });
            sections.push({
                type: 'body',
                key: 'all-day-divider',
                outerContent: ( // TODO: rename to cellContent so don't need to define <tr>?
                createElement("tr", { role: "presentation", className: "fc-scrollgrid-section" },
                    createElement("td", { className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded') }))),
            });
        }
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent,
            },
        });
        return (createElement(ViewRoot, { viewSpec: context.viewSpec, elRef: this.rootElRef }, function (rootElRef, classNames) { return (createElement("div", { className: ['fc-timegrid'].concat(classNames).join(' '), ref: rootElRef },
            createElement(SimpleScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: props.forPrint, cols: [{ width: 'shrink' }], sections: sections }))); }));
    };
    TimeColsView.prototype.renderHScrollLayout = function (headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        var _this = this;
        var ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) {
            throw new Error('No ScrollGrid implementation');
        }
        var _a = this, context = _a.context, props = _a.props;
        var stickyHeaderDates = !props.forPrint && getStickyHeaderDates(context.options);
        var stickyFooterScrollbar = !props.forPrint && getStickyFooterScrollbar(context.options);
        var sections = [];
        if (headerRowContent) {
            sections.push({
                type: 'header',
                key: 'header',
                isSticky: stickyHeaderDates,
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: function (arg) { return (createElement("tr", { role: "presentation" }, _this.renderHeadAxis('day', arg.rowSyncHeights[0]))); },
                    },
                    {
                        key: 'cols',
                        elRef: this.headerElRef,
                        tableClassName: 'fc-col-header',
                        rowContent: headerRowContent,
                    },
                ],
            });
        }
        if (allDayContent) {
            sections.push({
                type: 'body',
                key: 'all-day',
                syncRowHeights: true,
                chunks: [
                    {
                        key: 'axis',
                        rowContent: function (contentArg) { return (createElement("tr", { role: "presentation" }, _this.renderTableRowAxis(contentArg.rowSyncHeights[0]))); },
                    },
                    {
                        key: 'cols',
                        content: allDayContent,
                    },
                ],
            });
            sections.push({
                key: 'all-day-divider',
                type: 'body',
                outerContent: ( // TODO: rename to cellContent so don't need to define <tr>?
                createElement("tr", { role: "presentation", className: "fc-scrollgrid-section" },
                    createElement("td", { colSpan: 2, className: 'fc-timegrid-divider ' + context.theme.getClass('tableCellShaded') }))),
            });
        }
        var isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: 'body',
            key: 'body',
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: 'axis',
                    content: function (arg) { return (
                    // TODO: make this now-indicator arrow more DRY with TimeColsContent
                    createElement("div", { className: "fc-timegrid-axis-chunk" },
                        createElement("table", { "aria-hidden": true, style: { height: arg.expandRows ? arg.clientHeight : '' } },
                            arg.tableColGroupNode,
                            createElement("tbody", null,
                                createElement(TimeBodyAxis, { slatMetas: slatMetas }))),
                        createElement("div", { className: "fc-timegrid-now-indicator-container" },
                            createElement(NowTimer, { unit: isNowIndicator ? 'minute' : 'day' /* hacky */ }, function (nowDate) {
                                var nowIndicatorTop = isNowIndicator &&
                                    slatCoords &&
                                    slatCoords.safeComputeTop(nowDate); // might return void
                                if (typeof nowIndicatorTop === 'number') {
                                    return (createElement(NowIndicatorRoot, { isAxis: true, date: nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-arrow'].concat(classNames).join(' '), style: { top: nowIndicatorTop } }, innerContent)); }));
                                }
                                return null;
                            })))); },
                },
                {
                    key: 'cols',
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent,
                },
            ],
        });
        if (stickyFooterScrollbar) {
            sections.push({
                key: 'footer',
                type: 'footer',
                isSticky: true,
                chunks: [
                    {
                        key: 'axis',
                        content: renderScrollShim,
                    },
                    {
                        key: 'cols',
                        content: renderScrollShim,
                    },
                ],
            });
        }
        return (createElement(ViewRoot, { viewSpec: context.viewSpec, elRef: this.rootElRef }, function (rootElRef, classNames) { return (createElement("div", { className: ['fc-timegrid'].concat(classNames).join(' '), ref: rootElRef },
            createElement(ScrollGrid, { liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: false, colGroups: [
                    { width: 'shrink', cols: [{ width: 'shrink' }] },
                    { cols: [{ span: colCnt, minWidth: dayMinWidth }] },
                ], sections: sections }))); }));
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    TimeColsView.prototype.getAllDayMaxEventProps = function () {
        var _a = this.context.options, dayMaxEvents = _a.dayMaxEvents, dayMaxEventRows = _a.dayMaxEventRows;
        if (dayMaxEvents === true || dayMaxEventRows === true) { // is auto?
            dayMaxEvents = undefined;
            dayMaxEventRows = AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows };
    };
    return TimeColsView;
}(DateComponent));
function renderAllDayInner(hookProps) {
    return hookProps.text;
}

var TimeColsSlatsCoords = /** @class */ (function () {
    function TimeColsSlatsCoords(positions, dateProfile, slotDuration) {
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
    TimeColsSlatsCoords.prototype.safeComputeTop = function (date) {
        var dateProfile = this.dateProfile;
        if (rangeContainsMarker(dateProfile.currentRange, date)) {
            var startOfDayDate = startOfDay(date);
            var timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= asRoughMs(dateProfile.slotMinTime) &&
                timeMs < asRoughMs(dateProfile.slotMaxTime)) {
                return this.computeTimeTop(createDuration(timeMs));
            }
        }
        return null;
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeColsSlatsCoords.prototype.computeDateTop = function (when, startOfDayDate) {
        if (!startOfDayDate) {
            startOfDayDate = startOfDay(when);
        }
        return this.computeTimeTop(createDuration(when.valueOf() - startOfDayDate.valueOf()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    TimeColsSlatsCoords.prototype.computeTimeTop = function (duration) {
        var _a = this, positions = _a.positions, dateProfile = _a.dateProfile;
        var len = positions.els.length;
        // floating-point value of # of slots covered
        var slatCoverage = (duration.milliseconds - asRoughMs(dateProfile.slotMinTime)) / asRoughMs(this.slotDuration);
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] +
            positions.getHeight(slatIndex) * slatRemainder;
    };
    return TimeColsSlatsCoords;
}());

var TimeColsSlatsBody = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColsSlatsBody, _super);
    function TimeColsSlatsBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColsSlatsBody.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        var options = context.options;
        var slatElRefs = props.slatElRefs;
        return (createElement("tbody", null, props.slatMetas.map(function (slatMeta, i) {
            var hookProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi,
            };
            var classNames = [
                'fc-timegrid-slot',
                'fc-timegrid-slot-lane',
                slatMeta.isLabeled ? '' : 'fc-timegrid-slot-minor',
            ];
            return (createElement("tr", { key: slatMeta.key, ref: slatElRefs.createRef(slatMeta.key) },
                props.axis && (createElement(TimeColsAxisCell, timegrid_node_modules_tslib_tslib_es6_assign({}, slatMeta))),
                createElement(RenderHook, { hookProps: hookProps, classNames: options.slotLaneClassNames, content: options.slotLaneContent, didMount: options.slotLaneDidMount, willUnmount: options.slotLaneWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (createElement("td", { ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-time": slatMeta.isoTimeStr }, innerContent)); })));
        })));
    };
    return TimeColsSlatsBody;
}(BaseComponent));

/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/
var TimeColsSlats = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColsSlats, _super);
    function TimeColsSlats() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = createRef();
        _this.slatElRefs = new RefMap();
        return _this;
    }
    TimeColsSlats.prototype.render = function () {
        var _a = this, props = _a.props, context = _a.context;
        return (createElement("div", { ref: this.rootElRef, className: "fc-timegrid-slots" },
            createElement("table", { "aria-hidden": true, className: context.theme.getClass('table'), style: {
                    minWidth: props.tableMinWidth,
                    width: props.clientWidth,
                    height: props.minHeight,
                } },
                props.tableColGroupNode /* relies on there only being a single <col> for the axis */,
                createElement(TimeColsSlatsBody, { slatElRefs: this.slatElRefs, axis: props.axis, slatMetas: props.slatMetas }))));
    };
    TimeColsSlats.prototype.componentDidMount = function () {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentDidUpdate = function () {
        this.updateSizing();
    };
    TimeColsSlats.prototype.componentWillUnmount = function () {
        if (this.props.onCoords) {
            this.props.onCoords(null);
        }
    };
    TimeColsSlats.prototype.updateSizing = function () {
        var _a = this, context = _a.context, props = _a.props;
        if (props.onCoords &&
            props.clientWidth !== null // means sizing has stabilized
        ) {
            var rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) { // not hidden by css
                props.onCoords(new TimeColsSlatsCoords(new PositionCache(this.rootElRef.current, collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
            }
        }
    };
    return TimeColsSlats;
}(BaseComponent));
function collectSlatEls(elMap, slatMetas) {
    return slatMetas.map(function (slatMeta) { return elMap[slatMeta.key]; });
}

function splitSegsByCol(segs, colCnt) {
    var segsByCol = [];
    var i;
    for (i = 0; i < colCnt; i += 1) {
        segsByCol.push([]);
    }
    if (segs) {
        for (i = 0; i < segs.length; i += 1) {
            segsByCol[segs[i].col].push(segs[i]);
        }
    }
    return segsByCol;
}
function splitInteractionByCol(ui, colCnt) {
    var byRow = [];
    if (!ui) {
        for (var i = 0; i < colCnt; i += 1) {
            byRow[i] = null;
        }
    }
    else {
        for (var i = 0; i < colCnt; i += 1) {
            byRow[i] = {
                affectedInstances: ui.affectedInstances,
                isEvent: ui.isEvent,
                segs: [],
            };
        }
        for (var _i = 0, _a = ui.segs; _i < _a.length; _i++) {
            var seg = _a[_i];
            byRow[seg.col].segs.push(seg);
        }
    }
    return byRow;
}

var TimeColMoreLink = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColMoreLink, _super);
    function TimeColMoreLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootElRef = createRef();
        return _this;
    }
    TimeColMoreLink.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (createElement(MoreLinkRoot, { allDayDate: null, moreCnt: props.hiddenSegs.length, allSegs: props.hiddenSegs, hiddenSegs: props.hiddenSegs, alignmentElRef: this.rootElRef, defaultContent: main_renderMoreLinkInner, extraDateSpan: props.extraDateSpan, dateProfile: props.dateProfile, todayRange: props.todayRange, popoverContent: function () { return renderPlainFgSegs(props.hiddenSegs, props); } }, function (rootElRef, classNames, innerElRef, innerContent, handleClick, title, isExpanded, popoverId) { return (createElement("a", { ref: function (el) {
                setRef(rootElRef, el);
                setRef(_this.rootElRef, el);
            }, className: ['fc-timegrid-more-link'].concat(classNames).join(' '), style: { top: props.top, bottom: props.bottom }, onClick: handleClick, title: title, "aria-expanded": isExpanded, "aria-controls": popoverId },
            createElement("div", { ref: innerElRef, className: "fc-timegrid-more-link-inner fc-sticky" }, innerContent))); }));
    };
    return TimeColMoreLink;
}(BaseComponent));
function main_renderMoreLinkInner(props) {
    return props.shortText;
}

// segInputs assumed sorted
function buildPositioning(segInputs, strictOrder, maxStackCnt) {
    var hierarchy = new SegHierarchy();
    if (strictOrder != null) {
        hierarchy.strictOrder = strictOrder;
    }
    if (maxStackCnt != null) {
        hierarchy.maxStackCnt = maxStackCnt;
    }
    var hiddenEntries = hierarchy.addSegs(segInputs);
    var hiddenGroups = groupIntersectingEntries(hiddenEntries);
    var web = buildWeb(hierarchy);
    web = stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    var segRects = webToRects(web);
    return { segRects: segRects, hiddenGroups: hiddenGroups };
}
function buildWeb(hierarchy) {
    var entriesByLevel = hierarchy.entriesByLevel;
    var buildNode = cacheable(function (level, lateral) { return level + ':' + lateral; }, function (level, lateral) {
        var siblingRange = findNextLevelSegs(hierarchy, level, lateral);
        var nextLevelRes = buildNodes(siblingRange, buildNode);
        var entry = entriesByLevel[level][lateral];
        return [
            timegrid_node_modules_tslib_tslib_es6_assign(timegrid_node_modules_tslib_tslib_es6_assign({}, entry), { nextLevelNodes: nextLevelRes[0] }),
            entry.thickness + nextLevelRes[1], // the pressure builds
        ];
    });
    return buildNodes(entriesByLevel.length
        ? { level: 0, lateralStart: 0, lateralEnd: entriesByLevel[0].length }
        : null, buildNode)[0];
}
function buildNodes(siblingRange, buildNode) {
    if (!siblingRange) {
        return [[], 0];
    }
    var level = siblingRange.level, lateralStart = siblingRange.lateralStart, lateralEnd = siblingRange.lateralEnd;
    var lateral = lateralStart;
    var pairs = [];
    while (lateral < lateralEnd) {
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort(cmpDescPressures);
    return [
        pairs.map(extractNode),
        pairs[0][1], // first item's pressure
    ];
}
function cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function extractNode(a) {
    return a[0];
}
function findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    var levelCoords = hierarchy.levelCoords, entriesByLevel = hierarchy.entriesByLevel;
    var subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    var afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    var levelCnt = levelCoords.length;
    var level = subjectLevel;
    // skip past levels that are too high up
    for (; level < levelCnt && levelCoords[level] < afterSubject; level += 1)
        ; // do nothing
    for (; level < levelCnt; level += 1) {
        var entries = entriesByLevel[level];
        var entry = void 0;
        var searchIndex = binarySearch(entries, subjectEntry.span.start, getEntrySpanEnd);
        var lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        var lateralEnd = lateralStart;
        while ( // loop through entries that horizontally intersect
        (entry = entries[lateralEnd]) && // but not past the whole seg list
            entry.span.start < subjectEntry.span.end) {
            lateralEnd += 1;
        }
        if (lateralStart < lateralEnd) {
            return { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd };
        }
    }
    return null;
}
function stretchWeb(topLevelNodes, totalThickness) {
    var stretchNode = cacheable(function (node, startCoord, prevThickness) { return buildEntryKey(node); }, function (node, startCoord, prevThickness) {
        var nextLevelNodes = node.nextLevelNodes, thickness = node.thickness;
        var allThickness = thickness + prevThickness;
        var thicknessFraction = thickness / allThickness;
        var endCoord;
        var newChildren = [];
        if (!nextLevelNodes.length) {
            endCoord = totalThickness;
        }
        else {
            for (var _i = 0, nextLevelNodes_1 = nextLevelNodes; _i < nextLevelNodes_1.length; _i++) {
                var childNode = nextLevelNodes_1[_i];
                if (endCoord === undefined) {
                    var res = stretchNode(childNode, startCoord, allThickness);
                    endCoord = res[0];
                    newChildren.push(res[1]);
                }
                else {
                    var res = stretchNode(childNode, endCoord, 0);
                    newChildren.push(res[1]);
                }
            }
        }
        var newThickness = (endCoord - startCoord) * thicknessFraction;
        return [endCoord - newThickness, timegrid_node_modules_tslib_tslib_es6_assign(timegrid_node_modules_tslib_tslib_es6_assign({}, node), { thickness: newThickness, nextLevelNodes: newChildren })];
    });
    return topLevelNodes.map(function (node) { return stretchNode(node, 0, 0)[1]; });
}
// not sorted in any particular order
function webToRects(topLevelNodes) {
    var rects = [];
    var processNode = cacheable(function (node, levelCoord, stackDepth) { return buildEntryKey(node); }, function (node, levelCoord, stackDepth) {
        var rect = timegrid_node_modules_tslib_tslib_es6_assign(timegrid_node_modules_tslib_tslib_es6_assign({}, node), { levelCoord: levelCoord,
            stackDepth: stackDepth, stackForward: 0 });
        rects.push(rect);
        return (rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1);
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        var stackForward = 0;
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var node = nodes_1[_i];
            stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        }
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function cacheable(keyFunc, workFunc) {
    var cache = {};
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyFunc.apply(void 0, args);
        return (key in cache)
            ? cache[key]
            : (cache[key] = workFunc.apply(void 0, args));
    };
}

function computeSegVCoords(segs, colDate, slatCoords, eventMinHeight) {
    if (slatCoords === void 0) { slatCoords = null; }
    if (eventMinHeight === void 0) { eventMinHeight = 0; }
    var vcoords = [];
    if (slatCoords) {
        for (var i = 0; i < segs.length; i += 1) {
            var seg = segs[i];
            var spanStart = slatCoords.computeDateTop(seg.start, colDate);
            var spanEnd = Math.max(spanStart + (eventMinHeight || 0), // :(
            slatCoords.computeDateTop(seg.end, colDate));
            vcoords.push({
                start: Math.round(spanStart),
                end: Math.round(spanEnd), //
            });
        }
    }
    return vcoords;
}
function computeFgSegPlacements(segs, segVCoords, // might not have for every seg
eventOrderStrict, eventMaxStack) {
    var segInputs = [];
    var dumbSegs = []; // segs without coords
    for (var i = 0; i < segs.length; i += 1) {
        var vcoords = segVCoords[i];
        if (vcoords) {
            segInputs.push({
                index: i,
                thickness: 1,
                span: vcoords,
            });
        }
        else {
            dumbSegs.push(segs[i]);
        }
    }
    var _a = buildPositioning(segInputs, eventOrderStrict, eventMaxStack), segRects = _a.segRects, hiddenGroups = _a.hiddenGroups;
    var segPlacements = [];
    for (var _i = 0, segRects_1 = segRects; _i < segRects_1.length; _i++) {
        var segRect = segRects_1[_i];
        segPlacements.push({
            seg: segs[segRect.index],
            rect: segRect,
        });
    }
    for (var _b = 0, dumbSegs_1 = dumbSegs; _b < dumbSegs_1.length; _b++) {
        var dumbSeg = dumbSegs_1[_b];
        segPlacements.push({ seg: dumbSeg, rect: null });
    }
    return { segPlacements: segPlacements, hiddenGroups: hiddenGroups };
}

var DEFAULT_TIME_FORMAT = createFormatter({
    hour: 'numeric',
    minute: '2-digit',
    meridiem: false,
});
var TimeColEvent = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColEvent, _super);
    function TimeColEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColEvent.prototype.render = function () {
        var classNames = [
            'fc-timegrid-event',
            'fc-v-event',
        ];
        if (this.props.isShort) {
            classNames.push('fc-timegrid-event-short');
        }
        return (createElement(StandardEvent, timegrid_node_modules_tslib_tslib_es6_assign({}, this.props, { defaultTimeFormat: DEFAULT_TIME_FORMAT, extraClassNames: classNames })));
    };
    return TimeColEvent;
}(BaseComponent));

var TimeColMisc = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColMisc, _super);
    function TimeColMisc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeColMisc.prototype.render = function () {
        var props = this.props;
        return (createElement(DayCellContent, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps }, function (innerElRef, innerContent) { return (innerContent &&
            createElement("div", { className: "fc-timegrid-col-misc", ref: innerElRef }, innerContent)); }));
    };
    return TimeColMisc;
}(BaseComponent));

var TimeCol = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeCol, _super);
    function TimeCol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortEventSegs = memoize(sortEventSegs);
        return _this;
    }
    // TODO: memoize event-placement?
    TimeCol.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var isSelectMirror = context.options.selectMirror;
        var mirrorSegs = (props.eventDrag && props.eventDrag.segs) ||
            (props.eventResize && props.eventResize.segs) ||
            (isSelectMirror && props.dateSelectionSegs) ||
            [];
        var interactionAffectedInstances = // TODO: messy way to compute this
         (props.eventDrag && props.eventDrag.affectedInstances) ||
            (props.eventResize && props.eventResize.affectedInstances) ||
            {};
        var sortedFgSegs = this.sortEventSegs(props.fgEventSegs, context.options.eventOrder);
        return (createElement(DayCellRoot, { elRef: props.elRef, date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps }, function (rootElRef, classNames, dataAttrs) { return (createElement("td", timegrid_node_modules_tslib_tslib_es6_assign({ ref: rootElRef, role: "gridcell", className: ['fc-timegrid-col'].concat(classNames, props.extraClassNames || []).join(' ') }, dataAttrs, props.extraDataAttrs),
            createElement("div", { className: "fc-timegrid-col-frame" },
                createElement("div", { className: "fc-timegrid-col-bg" },
                    _this.renderFillSegs(props.businessHourSegs, 'non-business'),
                    _this.renderFillSegs(props.bgEventSegs, 'bg-event'),
                    _this.renderFillSegs(props.dateSelectionSegs, 'highlight')),
                createElement("div", { className: "fc-timegrid-col-events" }, _this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)),
                createElement("div", { className: "fc-timegrid-col-events" }, _this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror))),
                createElement("div", { className: "fc-timegrid-now-indicator-container" }, _this.renderNowIndicator(props.nowIndicatorSegs)),
                createElement(TimeColMisc, { date: props.date, dateProfile: props.dateProfile, todayRange: props.todayRange, extraHookProps: props.extraHookProps })))); }));
    };
    TimeCol.prototype.renderFgSegs = function (sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var props = this.props;
        if (props.forPrint) {
            return renderPlainFgSegs(sortedFgSegs, props);
        }
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting);
    };
    TimeCol.prototype.renderPositionedFgSegs = function (segs, // if not mirror, needs to be sorted
    segIsInvisible, isDragging, isResizing, isDateSelecting) {
        var _this = this;
        var _a = this.context.options, eventMaxStack = _a.eventMaxStack, eventShortHeight = _a.eventShortHeight, eventOrderStrict = _a.eventOrderStrict, eventMinHeight = _a.eventMinHeight;
        var _b = this.props, date = _b.date, slatCoords = _b.slatCoords, eventSelection = _b.eventSelection, todayRange = _b.todayRange, nowDate = _b.nowDate;
        var isMirror = isDragging || isResizing || isDateSelecting;
        var segVCoords = computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        var _c = computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack), segPlacements = _c.segPlacements, hiddenGroups = _c.hiddenGroups;
        return (createElement(Fragment, null,
            this.renderHiddenGroups(hiddenGroups, segs),
            segPlacements.map(function (segPlacement) {
                var seg = segPlacement.seg, rect = segPlacement.rect;
                var instanceId = seg.eventRange.instance.instanceId;
                var isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
                var vStyle = computeSegVStyle(rect && rect.span);
                var hStyle = (!isMirror && rect) ? _this.computeSegHStyle(rect) : { left: 0, right: 0 };
                var isInset = Boolean(rect) && rect.stackForward > 0;
                var isShort = Boolean(rect) && (rect.span.end - rect.span.start) < eventShortHeight; // look at other places for this problem
                return (createElement("div", { className: 'fc-timegrid-event-harness' +
                        (isInset ? ' fc-timegrid-event-harness-inset' : ''), key: instanceId, style: timegrid_node_modules_tslib_tslib_es6_assign(timegrid_node_modules_tslib_tslib_es6_assign({ visibility: isVisible ? '' : 'hidden' }, vStyle), hStyle) },
                    createElement(TimeColEvent, timegrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: isDragging, isResizing: isResizing, isDateSelecting: isDateSelecting, isSelected: instanceId === eventSelection, isShort: isShort }, getSegMeta(seg, todayRange, nowDate)))));
            })));
    };
    // will already have eventMinHeight applied because segInputs already had it
    TimeCol.prototype.renderHiddenGroups = function (hiddenGroups, segs) {
        var _a = this.props, extraDateSpan = _a.extraDateSpan, dateProfile = _a.dateProfile, todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
        return (createElement(Fragment, null, hiddenGroups.map(function (hiddenGroup) {
            var positionCss = computeSegVStyle(hiddenGroup.span);
            var hiddenSegs = compileSegsFromEntries(hiddenGroup.entries, segs);
            return (createElement(TimeColMoreLink, { key: buildIsoString(computeEarliestSegStart(hiddenSegs)), hiddenSegs: hiddenSegs, top: positionCss.top, bottom: positionCss.bottom, extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }));
        })));
    };
    TimeCol.prototype.renderFillSegs = function (segs, fillType) {
        var _a = this, props = _a.props, context = _a.context;
        var segVCoords = computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        var children = segVCoords.map(function (vcoords, i) {
            var seg = segs[i];
            return (createElement("div", { key: buildEventRangeKey(seg.eventRange), className: "fc-timegrid-bg-harness", style: computeSegVStyle(vcoords) }, fillType === 'bg-event' ?
                createElement(BgEvent, timegrid_node_modules_tslib_tslib_es6_assign({ seg: seg }, getSegMeta(seg, props.todayRange, props.nowDate))) :
                renderFill(fillType)));
        });
        return createElement(Fragment, null, children);
    };
    TimeCol.prototype.renderNowIndicator = function (segs) {
        var _a = this.props, slatCoords = _a.slatCoords, date = _a.date;
        if (!slatCoords) {
            return null;
        }
        return segs.map(function (seg, i) { return (createElement(NowIndicatorRoot, { isAxis: false, date: date, 
            // key doesn't matter. will only ever be one
            key: i }, function (rootElRef, classNames, innerElRef, innerContent) { return (createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-line'].concat(classNames).join(' '), style: { top: slatCoords.computeDateTop(seg.start, date) } }, innerContent)); })); });
    };
    TimeCol.prototype.computeSegHStyle = function (segHCoords) {
        var _a = this.context, isRtl = _a.isRtl, options = _a.options;
        var shouldOverlap = options.slotEventOverlap;
        var nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        var farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) {
            // double the width, but don't go beyond the maximum forward coordinate (1.0)
            farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        }
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        }
        else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        var props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + '%',
            right: right * 100 + '%',
        };
        if (shouldOverlap && !segHCoords.stackForward) {
            // add padding to the edge so that forward stacked events don't cover the resizer's icon
            props[isRtl ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
        }
        return props;
    };
    return TimeCol;
}(BaseComponent));
function renderPlainFgSegs(sortedFgSegs, _a) {
    var todayRange = _a.todayRange, nowDate = _a.nowDate, eventSelection = _a.eventSelection, eventDrag = _a.eventDrag, eventResize = _a.eventResize;
    var hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) ||
        (eventResize ? eventResize.affectedInstances : null) ||
        {};
    return (createElement(Fragment, null, sortedFgSegs.map(function (seg) {
        var instanceId = seg.eventRange.instance.instanceId;
        return (createElement("div", { key: instanceId, style: { visibility: hiddenInstances[instanceId] ? 'hidden' : '' } },
            createElement(TimeColEvent, timegrid_node_modules_tslib_tslib_es6_assign({ seg: seg, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: instanceId === eventSelection, isShort: false }, getSegMeta(seg, todayRange, nowDate)))));
    })));
}
function computeSegVStyle(segVCoords) {
    if (!segVCoords) {
        return { top: '', bottom: '' };
    }
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end,
    };
}
function compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map(function (segEntry) { return allSegs[segEntry.index]; });
}

var TimeColsContent = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeColsContent, _super);
    function TimeColsContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.splitFgEventSegs = memoize(splitSegsByCol);
        _this.splitBgEventSegs = memoize(splitSegsByCol);
        _this.splitBusinessHourSegs = memoize(splitSegsByCol);
        _this.splitNowIndicatorSegs = memoize(splitSegsByCol);
        _this.splitDateSelectionSegs = memoize(splitSegsByCol);
        _this.splitEventDrag = memoize(splitInteractionByCol);
        _this.splitEventResize = memoize(splitInteractionByCol);
        _this.rootElRef = createRef();
        _this.cellElRefs = new RefMap();
        return _this;
    }
    TimeColsContent.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var nowIndicatorTop = context.options.nowIndicator &&
            props.slatCoords &&
            props.slatCoords.safeComputeTop(props.nowDate); // might return void
        var colCnt = props.cells.length;
        var fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        var bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        var businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        var nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        var dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        var eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        var eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (createElement("div", { className: "fc-timegrid-cols", ref: this.rootElRef },
            createElement("table", { role: "presentation", style: {
                    minWidth: props.tableMinWidth,
                    width: props.clientWidth,
                } },
                props.tableColGroupNode,
                createElement("tbody", { role: "presentation" },
                    createElement("tr", { role: "row" },
                        props.axis && (createElement("td", { "aria-hidden": true, className: "fc-timegrid-col fc-timegrid-axis" },
                            createElement("div", { className: "fc-timegrid-col-frame" },
                                createElement("div", { className: "fc-timegrid-now-indicator-container" }, typeof nowIndicatorTop === 'number' && (createElement(NowIndicatorRoot, { isAxis: true, date: props.nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (createElement("div", { ref: rootElRef, className: ['fc-timegrid-now-indicator-arrow'].concat(classNames).join(' '), style: { top: nowIndicatorTop } }, innerContent)); })))))),
                        props.cells.map(function (cell, i) { return (createElement(TimeCol, { key: cell.key, elRef: _this.cellElRefs.createRef(cell.key), dateProfile: props.dateProfile, date: cell.date, nowDate: props.nowDate, todayRange: props.todayRange, extraHookProps: cell.extraHookProps, extraDataAttrs: cell.extraDataAttrs, extraClassNames: cell.extraClassNames, extraDateSpan: cell.extraDateSpan, fgEventSegs: fgEventSegsByRow[i], bgEventSegs: bgEventSegsByRow[i], businessHourSegs: businessHourSegsByRow[i], nowIndicatorSegs: nowIndicatorSegsByRow[i], dateSelectionSegs: dateSelectionSegsByRow[i], eventDrag: eventDragByRow[i], eventResize: eventResizeByRow[i], slatCoords: props.slatCoords, eventSelection: props.eventSelection, forPrint: props.forPrint })); }))))));
    };
    TimeColsContent.prototype.componentDidMount = function () {
        this.updateCoords();
    };
    TimeColsContent.prototype.componentDidUpdate = function () {
        this.updateCoords();
    };
    TimeColsContent.prototype.updateCoords = function () {
        var props = this.props;
        if (props.onColCoords &&
            props.clientWidth !== null // means sizing has stabilized
        ) {
            props.onColCoords(new PositionCache(this.rootElRef.current, collectCellEls(this.cellElRefs.currentMap, props.cells), true, // horizontal
            false));
        }
    };
    return TimeColsContent;
}(BaseComponent));
function collectCellEls(elMap, cells) {
    return cells.map(function (cell) { return elMap[cell.key]; });
}

/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
var TimeCols = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(TimeCols, _super);
    function TimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processSlotOptions = memoize(processSlotOptions);
        _this.state = {
            slatCoords: null,
        };
        _this.handleRootEl = function (el) {
            if (el) {
                _this.context.registerInteractiveComponent(_this, {
                    el: el,
                    isHitComboAllowed: _this.props.isHitComboAllowed,
                });
            }
            else {
                _this.context.unregisterInteractiveComponent(_this);
            }
        };
        _this.handleScrollRequest = function (request) {
            var onScrollTopRequest = _this.props.onScrollTopRequest;
            var slatCoords = _this.state.slatCoords;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    var top_1 = slatCoords.computeTimeTop(request.time);
                    top_1 = Math.ceil(top_1); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top_1) {
                        top_1 += 1; // to overcome top border that slots beyond the first have. looks better
                    }
                    onScrollTopRequest(top_1);
                }
                return true;
            }
            return false;
        };
        _this.handleColCoords = function (colCoords) {
            _this.colCoords = colCoords;
        };
        _this.handleSlatCoords = function (slatCoords) {
            _this.setState({ slatCoords: slatCoords });
            if (_this.props.onSlatCoords) {
                _this.props.onSlatCoords(slatCoords);
            }
        };
        return _this;
    }
    TimeCols.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        return (createElement("div", { className: "fc-timegrid-body", ref: this.handleRootEl, style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
            } },
            createElement(TimeColsSlats, { axis: props.axis, dateProfile: props.dateProfile, slatMetas: props.slatMetas, clientWidth: props.clientWidth, minHeight: props.expandRows ? props.clientHeight : '', tableMinWidth: props.tableMinWidth, tableColGroupNode: props.axis ? props.tableColGroupNode : null /* axis depends on the colgroup's shrinking */, onCoords: this.handleSlatCoords }),
            createElement(TimeColsContent, { cells: props.cells, axis: props.axis, dateProfile: props.dateProfile, businessHourSegs: props.businessHourSegs, bgEventSegs: props.bgEventSegs, fgEventSegs: props.fgEventSegs, dateSelectionSegs: props.dateSelectionSegs, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, todayRange: props.todayRange, nowDate: props.nowDate, nowIndicatorSegs: props.nowIndicatorSegs, clientWidth: props.clientWidth, tableMinWidth: props.tableMinWidth, tableColGroupNode: props.tableColGroupNode, slatCoords: state.slatCoords, onColCoords: this.handleColCoords, forPrint: props.forPrint })));
    };
    TimeCols.prototype.componentDidMount = function () {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    };
    TimeCols.prototype.componentDidUpdate = function (prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    };
    TimeCols.prototype.componentWillUnmount = function () {
        this.scrollResponder.detach();
    };
    TimeCols.prototype.queryHit = function (positionLeft, positionTop) {
        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options;
        var colCoords = this.colCoords;
        var dateProfile = this.props.dateProfile;
        var slatCoords = this.state.slatCoords;
        var _b = this.processSlotOptions(this.props.slotDuration, options.snapDuration), snapDuration = _b.snapDuration, snapsPerSlot = _b.snapsPerSlot;
        var colIndex = colCoords.leftToIndex(positionLeft);
        var slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            var cell = this.props.cells[colIndex];
            var slatTop = slatCoords.positions.tops[slatIndex];
            var slatHeight = slatCoords.positions.getHeight(slatIndex);
            var partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            var dayDate = this.props.cells[colIndex].date;
            var time = addDurations(dateProfile.slotMinTime, multiplyDuration(snapDuration, snapIndex));
            var start = dateEnv.add(dayDate, time);
            var end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: timegrid_node_modules_tslib_tslib_es6_assign({ range: { start: start, end: end }, allDay: false }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight,
                },
                layer: 0,
            };
        }
        return null;
    };
    return TimeCols;
}(DateComponent));
function processSlotOptions(slotDuration, snapDurationOverride) {
    var snapDuration = snapDurationOverride || slotDuration;
    var snapsPerSlot = wholeDivideDurations(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
        // TODO: say warning?
    }
    return { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot };
}

var DayTimeColsSlicer = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(DayTimeColsSlicer, _super);
    function DayTimeColsSlicer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayTimeColsSlicer.prototype.sliceRange = function (range, dayRanges) {
        var segs = [];
        for (var col = 0; col < dayRanges.length; col += 1) {
            var segRange = intersectRanges(range, dayRanges[col]);
            if (segRange) {
                segs.push({
                    start: segRange.start,
                    end: segRange.end,
                    isStart: segRange.start.valueOf() === range.start.valueOf(),
                    isEnd: segRange.end.valueOf() === range.end.valueOf(),
                    col: col,
                });
            }
        }
        return segs;
    };
    return DayTimeColsSlicer;
}(Slicer));

var DayTimeCols = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(DayTimeCols, _super);
    function DayTimeCols() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildDayRanges = memoize(buildDayRanges);
        _this.slicer = new DayTimeColsSlicer();
        _this.timeColsRef = createRef();
        return _this;
    }
    DayTimeCols.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, context = _a.context;
        var dateProfile = props.dateProfile, dayTableModel = props.dayTableModel;
        var isNowIndicator = context.options.nowIndicator;
        var dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (createElement(NowTimer, { unit: isNowIndicator ? 'minute' : 'day' }, function (nowDate, todayRange) { return (createElement(TimeCols, timegrid_node_modules_tslib_tslib_es6_assign({ ref: _this.timeColsRef }, _this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), { forPrint: props.forPrint, axis: props.axis, dateProfile: dateProfile, slatMetas: props.slatMetas, slotDuration: props.slotDuration, cells: dayTableModel.cells[0], tableColGroupNode: props.tableColGroupNode, tableMinWidth: props.tableMinWidth, clientWidth: props.clientWidth, clientHeight: props.clientHeight, expandRows: props.expandRows, nowDate: nowDate, nowIndicatorSegs: isNowIndicator && _this.slicer.sliceNowDate(nowDate, context, dayRanges), todayRange: todayRange, onScrollTopRequest: props.onScrollTopRequest, onSlatCoords: props.onSlatCoords }))); }));
    };
    return DayTimeCols;
}(DateComponent));
function buildDayRanges(dayTableModel, dateProfile, dateEnv) {
    var ranges = [];
    for (var _i = 0, _a = dayTableModel.headerDates; _i < _a.length; _i++) {
        var date = _a[_i];
        ranges.push({
            start: dateEnv.add(date, dateProfile.slotMinTime),
            end: dateEnv.add(date, dateProfile.slotMaxTime),
        });
    }
    return ranges;
}

// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 },
];
function buildSlatMetas(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    var dayStart = new Date(0);
    var slatTime = slotMinTime;
    var slatIterator = createDuration(0);
    var labelInterval = explicitLabelInterval || computeLabelInterval(slotDuration);
    var metas = [];
    while (asRoughMs(slatTime) < asRoughMs(slotMaxTime)) {
        var date = dateEnv.add(dayStart, slatTime);
        var isLabeled = wholeDivideDurations(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: formatIsoTimeString(date),
            isLabeled: isLabeled,
        });
        slatTime = addDurations(slatTime, slotDuration);
        slatIterator = addDurations(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function computeLabelInterval(slotDuration) {
    var i;
    var labelInterval;
    var slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for (i = STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1) {
        labelInterval = createDuration(STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = wholeDivideDurations(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) {
            return labelInterval;
        }
    }
    return slotDuration; // fall back
}

var DayTimeColsView = /** @class */ (function (_super) {
    timegrid_node_modules_tslib_tslib_es6_extends(DayTimeColsView, _super);
    function DayTimeColsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildTimeColsModel = memoize(buildTimeColsModel);
        _this.buildSlatMetas = memoize(buildSlatMetas);
        return _this;
    }
    DayTimeColsView.prototype.render = function () {
        var _this = this;
        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv, dateProfileGenerator = _a.dateProfileGenerator;
        var props = this.props;
        var dateProfile = props.dateProfile;
        var dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        var splitProps = this.allDaySplitter.splitProps(props);
        var slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        var dayMinWidth = options.dayMinWidth;
        var hasAttachedAxis = !dayMinWidth;
        var hasDetachedAxis = dayMinWidth;
        var headerContent = options.dayHeaders && (createElement(DayHeader, { dates: dayTableModel.headerDates, dateProfile: dateProfile, datesRepDistinctDays: true, renderIntro: hasAttachedAxis ? this.renderHeadAxis : null }));
        var allDayContent = (options.allDaySlot !== false) && (function (contentArg) { return (createElement(DayTable, timegrid_node_modules_tslib_tslib_es6_assign({}, splitProps.allDay, { dateProfile: dateProfile, dayTableModel: dayTableModel, nextDayThreshold: options.nextDayThreshold, tableMinWidth: contentArg.tableMinWidth, colGroupNode: contentArg.tableColGroupNode, renderRowIntro: hasAttachedAxis ? _this.renderTableRowAxis : null, showWeekNumbers: false, expandRows: false, headerAlignElRef: _this.headerElRef, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, forPrint: props.forPrint }, _this.getAllDayMaxEventProps()))); });
        var timeGridContent = function (contentArg) { return (createElement(DayTimeCols, timegrid_node_modules_tslib_tslib_es6_assign({}, splitProps.timed, { dayTableModel: dayTableModel, dateProfile: dateProfile, axis: hasAttachedAxis, slotDuration: options.slotDuration, slatMetas: slatMetas, forPrint: props.forPrint, tableColGroupNode: contentArg.tableColGroupNode, tableMinWidth: contentArg.tableMinWidth, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, onSlatCoords: _this.handleSlatCoords, expandRows: contentArg.expandRows, onScrollTopRequest: _this.handleScrollTopRequest }))); };
        return hasDetachedAxis
            ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords)
            : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    };
    return DayTimeColsView;
}(TimeColsView));
function buildTimeColsModel(dateProfile, dateProfileGenerator) {
    var daySeries = new DaySeriesModel(dateProfile.renderRange, dateProfileGenerator);
    return new DayTableModel(daySeries, false);
}

var OPTION_REFINERS = {
    allDaySlot: Boolean,
};

var timegrid_main_main = createPlugin({
    initialView: 'timeGridWeek',
    optionRefiners: OPTION_REFINERS,
    views: {
        timeGrid: {
            component: DayTimeColsView,
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: '00:30:00',
            slotEventOverlap: true, // a bad name. confused with overlap/constraint system
        },
        timeGridDay: {
            type: 'timeGrid',
            duration: { days: 1 },
        },
        timeGridWeek: {
            type: 'timeGrid',
            duration: { weeks: 1 },
        },
    },
});

/* harmony default export */ const timegrid_main = ((/* unused pure expression or super */ null && (timegrid_main_main)));

//# sourceMappingURL=main.js.map

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/interaction/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var interaction_node_modules_tslib_tslib_es6_extendStatics = function(d, b) {
    interaction_node_modules_tslib_tslib_es6_extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return interaction_node_modules_tslib_tslib_es6_extendStatics(d, b);
};

function interaction_node_modules_tslib_tslib_es6_extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    interaction_node_modules_tslib_tslib_es6_extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var interaction_node_modules_tslib_tslib_es6_assign = function() {
    interaction_node_modules_tslib_tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return interaction_node_modules_tslib_tslib_es6_assign.apply(this, arguments);
}

function interaction_node_modules_tslib_tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function interaction_node_modules_tslib_tslib_es6_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function interaction_node_modules_tslib_tslib_es6_param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function interaction_node_modules_tslib_tslib_es6_metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function interaction_node_modules_tslib_tslib_es6_awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function interaction_node_modules_tslib_tslib_es6_generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var interaction_node_modules_tslib_tslib_es6_createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function interaction_node_modules_tslib_tslib_es6_exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) interaction_node_modules_tslib_tslib_es6_createBinding(o, m, p);
}

function interaction_node_modules_tslib_tslib_es6_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function interaction_node_modules_tslib_tslib_es6_read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function interaction_node_modules_tslib_tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(interaction_node_modules_tslib_tslib_es6_read(arguments[i]));
    return ar;
}

/** @deprecated */
function interaction_node_modules_tslib_tslib_es6_spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function interaction_node_modules_tslib_tslib_es6_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function interaction_node_modules_tslib_tslib_es6_await(v) {
    return this instanceof interaction_node_modules_tslib_tslib_es6_await ? (this.v = v, this) : new interaction_node_modules_tslib_tslib_es6_await(v);
}

function interaction_node_modules_tslib_tslib_es6_asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof interaction_node_modules_tslib_tslib_es6_await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function interaction_node_modules_tslib_tslib_es6_asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: interaction_node_modules_tslib_tslib_es6_await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function interaction_node_modules_tslib_tslib_es6_asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof interaction_node_modules_tslib_tslib_es6_values === "function" ? interaction_node_modules_tslib_tslib_es6_values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function interaction_node_modules_tslib_tslib_es6_makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var interaction_node_modules_tslib_tslib_es6_setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function interaction_node_modules_tslib_tslib_es6_importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) interaction_node_modules_tslib_tslib_es6_createBinding(result, mod, k);
    interaction_node_modules_tslib_tslib_es6_setModuleDefault(result, mod);
    return result;
}

function interaction_node_modules_tslib_tslib_es6_importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function interaction_node_modules_tslib_tslib_es6_classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function interaction_node_modules_tslib_tslib_es6_classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function interaction_node_modules_tslib_tslib_es6_classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@fullcalendar/interaction/main.js
/*!
FullCalendar v5.10.2
Docs & License: https://fullcalendar.io/
(c) 2021 Adam Shaw
*/



config.touchMouseIgnoreWait = 500;
var ignoreMouseDepth = 0;
var listenerCnt = 0;
var isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/
var PointerDragging = /** @class */ (function () {
    function PointerDragging(containerEl) {
        var _this = this;
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ''; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = '';
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = function (ev) {
            if (!_this.shouldIgnoreMouse() &&
                isPrimaryMouseButton(ev) &&
                _this.tryStart(ev)) {
                var pev = _this.createEventFromMouse(ev, true);
                _this.emitter.trigger('pointerdown', pev);
                _this.initScrollWatch(pev);
                if (!_this.shouldIgnoreMove) {
                    document.addEventListener('mousemove', _this.handleMouseMove);
                }
                document.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        this.handleMouseMove = function (ev) {
            var pev = _this.createEventFromMouse(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger('pointermove', pev);
        };
        this.handleMouseUp = function (ev) {
            document.removeEventListener('mousemove', _this.handleMouseMove);
            document.removeEventListener('mouseup', _this.handleMouseUp);
            _this.emitter.trigger('pointerup', _this.createEventFromMouse(ev));
            _this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = function (ev) {
            if (_this.tryStart(ev)) {
                _this.isTouchDragging = true;
                var pev = _this.createEventFromTouch(ev, true);
                _this.emitter.trigger('pointerdown', pev);
                _this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                var targetEl = ev.target;
                if (!_this.shouldIgnoreMove) {
                    targetEl.addEventListener('touchmove', _this.handleTouchMove);
                }
                targetEl.addEventListener('touchend', _this.handleTouchEnd);
                targetEl.addEventListener('touchcancel', _this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener('scroll', _this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = function (ev) {
            var pev = _this.createEventFromTouch(ev);
            _this.recordCoords(pev);
            _this.emitter.trigger('pointermove', pev);
        };
        this.handleTouchEnd = function (ev) {
            if (_this.isDragging) { // done to guard against touchend followed by touchcancel
                var targetEl = ev.target;
                targetEl.removeEventListener('touchmove', _this.handleTouchMove);
                targetEl.removeEventListener('touchend', _this.handleTouchEnd);
                targetEl.removeEventListener('touchcancel', _this.handleTouchEnd);
                window.removeEventListener('scroll', _this.handleTouchScroll, true); // useCaptured=true
                _this.emitter.trigger('pointerup', _this.createEventFromTouch(ev));
                _this.cleanup(); // call last so that pointerup has access to props
                _this.isTouchDragging = false;
                startIgnoringMouse();
            }
        };
        this.handleTouchScroll = function () {
            _this.wasTouchScroll = true;
        };
        this.handleScroll = function (ev) {
            if (!_this.shouldIgnoreMove) {
                var pageX = (window.pageXOffset - _this.prevScrollX) + _this.prevPageX;
                var pageY = (window.pageYOffset - _this.prevScrollY) + _this.prevPageY;
                _this.emitter.trigger('pointermove', {
                    origEvent: ev,
                    isTouch: _this.isTouchDragging,
                    subjectEl: _this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - _this.origPageX,
                    deltaY: pageY - _this.origPageY,
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new Emitter();
        containerEl.addEventListener('mousedown', this.handleMouseDown);
        containerEl.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        listenerCreated();
    }
    PointerDragging.prototype.destroy = function () {
        this.containerEl.removeEventListener('mousedown', this.handleMouseDown);
        this.containerEl.removeEventListener('touchstart', this.handleTouchStart, { passive: true });
        listenerDestroyed();
    };
    PointerDragging.prototype.tryStart = function (ev) {
        var subjectEl = this.querySubjectEl(ev);
        var downEl = ev.target;
        if (subjectEl &&
            (!this.handleSelector || elementClosest(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    };
    PointerDragging.prototype.cleanup = function () {
        isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    };
    PointerDragging.prototype.querySubjectEl = function (ev) {
        if (this.selector) {
            return elementClosest(ev.target, this.selector);
        }
        return this.containerEl;
    };
    PointerDragging.prototype.shouldIgnoreMouse = function () {
        return ignoreMouseDepth || this.isTouchDragging;
    };
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    PointerDragging.prototype.cancelTouchScroll = function () {
        if (this.isDragging) {
            isWindowTouchMoveCancelled = true;
        }
    };
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.initScrollWatch = function (ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener('scroll', this.handleScroll, true); // useCapture=true
        }
    };
    PointerDragging.prototype.recordCoords = function (ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.pageXOffset;
            this.prevScrollY = window.pageYOffset;
        }
    };
    PointerDragging.prototype.destroyScrollWatch = function () {
        if (this.shouldWatchScroll) {
            window.removeEventListener('scroll', this.handleScroll, true); // useCaptured=true
        }
    };
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    PointerDragging.prototype.createEventFromMouse = function (ev, isFirst) {
        var deltaX = 0;
        var deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        }
        else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY,
        };
    };
    PointerDragging.prototype.createEventFromTouch = function (ev, isFirst) {
        var touches = ev.touches;
        var pageX;
        var pageY;
        var deltaX = 0;
        var deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        }
        else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        }
        else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY,
        };
    };
    return PointerDragging;
}());
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function startIgnoringMouse() {
    ignoreMouseDepth += 1;
    setTimeout(function () {
        ignoreMouseDepth -= 1;
    }, config.touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function listenerCreated() {
    listenerCnt += 1;
    if (listenerCnt === 1) {
        window.addEventListener('touchmove', onWindowTouchMove, { passive: false });
    }
}
function listenerDestroyed() {
    listenerCnt -= 1;
    if (!listenerCnt) {
        window.removeEventListener('touchmove', onWindowTouchMove, { passive: false });
    }
}
function onWindowTouchMove(ev) {
    if (isWindowTouchMoveCancelled) {
        ev.preventDefault();
    }
}

/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/
var ElementMirror = /** @class */ (function () {
    function ElementMirror() {
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
    ElementMirror.prototype.start = function (sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.pageXOffset;
        this.origScreenY = pageY - window.pageYOffset;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    };
    ElementMirror.prototype.handleMove = function (pageX, pageY) {
        this.deltaX = (pageX - window.pageXOffset) - this.origScreenX;
        this.deltaY = (pageY - window.pageYOffset) - this.origScreenY;
        this.updateElPosition();
    };
    // can be called before start
    ElementMirror.prototype.setIsVisible = function (bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) {
                    this.mirrorEl.style.display = '';
                }
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        }
        else if (this.isVisible) {
            if (this.mirrorEl) {
                this.mirrorEl.style.display = 'none';
            }
            this.isVisible = bool;
        }
    };
    // always async
    ElementMirror.prototype.stop = function (needsRevertAnimation, callback) {
        var _this = this;
        var done = function () {
            _this.cleanup();
            callback();
        };
        if (needsRevertAnimation &&
            this.mirrorEl &&
            this.isVisible &&
            this.revertDuration && // if 0, transition won't work
            (this.deltaX || this.deltaY) // if same coords, transition won't work
        ) {
            this.doRevertAnimation(done, this.revertDuration);
        }
        else {
            setTimeout(done, 0);
        }
    };
    ElementMirror.prototype.doRevertAnimation = function (callback, revertDuration) {
        var mirrorEl = this.mirrorEl;
        var finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition =
            'top ' + revertDuration + 'ms,' +
                'left ' + revertDuration + 'ms';
        applyStyle(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top,
        });
        whenTransitionDone(mirrorEl, function () {
            mirrorEl.style.transition = '';
            callback();
        });
    };
    ElementMirror.prototype.cleanup = function () {
        if (this.mirrorEl) {
            removeElement(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    };
    ElementMirror.prototype.updateElPosition = function () {
        if (this.sourceEl && this.isVisible) {
            applyStyle(this.getMirrorEl(), {
                left: this.sourceElRect.left + this.deltaX,
                top: this.sourceElRect.top + this.deltaY,
            });
        }
    };
    ElementMirror.prototype.getMirrorEl = function () {
        var sourceElRect = this.sourceElRect;
        var mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.classList.add('fc-unselectable');
            mirrorEl.classList.add('fc-event-dragging');
            applyStyle(mirrorEl, {
                position: 'fixed',
                zIndex: this.zIndex,
                visibility: '',
                boxSizing: 'border-box',
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: 'auto',
                bottom: 'auto',
                margin: 0,
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    };
    return ElementMirror;
}());

/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/
var ScrollGeomCache = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(ScrollGeomCache, _super);
    function ScrollGeomCache(scrollController, doesListening) {
        var _this = _super.call(this) || this;
        _this.handleScroll = function () {
            _this.scrollTop = _this.scrollController.getScrollTop();
            _this.scrollLeft = _this.scrollController.getScrollLeft();
            _this.handleScrollChange();
        };
        _this.scrollController = scrollController;
        _this.doesListening = doesListening;
        _this.scrollTop = _this.origScrollTop = scrollController.getScrollTop();
        _this.scrollLeft = _this.origScrollLeft = scrollController.getScrollLeft();
        _this.scrollWidth = scrollController.getScrollWidth();
        _this.scrollHeight = scrollController.getScrollHeight();
        _this.clientWidth = scrollController.getClientWidth();
        _this.clientHeight = scrollController.getClientHeight();
        _this.clientRect = _this.computeClientRect(); // do last in case it needs cached values
        if (_this.doesListening) {
            _this.getEventTarget().addEventListener('scroll', _this.handleScroll);
        }
        return _this;
    }
    ScrollGeomCache.prototype.destroy = function () {
        if (this.doesListening) {
            this.getEventTarget().removeEventListener('scroll', this.handleScroll);
        }
    };
    ScrollGeomCache.prototype.getScrollTop = function () {
        return this.scrollTop;
    };
    ScrollGeomCache.prototype.getScrollLeft = function () {
        return this.scrollLeft;
    };
    ScrollGeomCache.prototype.setScrollTop = function (top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.setScrollLeft = function (top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    };
    ScrollGeomCache.prototype.getClientWidth = function () {
        return this.clientWidth;
    };
    ScrollGeomCache.prototype.getClientHeight = function () {
        return this.clientHeight;
    };
    ScrollGeomCache.prototype.getScrollWidth = function () {
        return this.scrollWidth;
    };
    ScrollGeomCache.prototype.getScrollHeight = function () {
        return this.scrollHeight;
    };
    ScrollGeomCache.prototype.handleScrollChange = function () {
    };
    return ScrollGeomCache;
}(ScrollController));

var ElementScrollGeomCache = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(ElementScrollGeomCache, _super);
    function ElementScrollGeomCache(el, doesListening) {
        return _super.call(this, new ElementScrollController(el), doesListening) || this;
    }
    ElementScrollGeomCache.prototype.getEventTarget = function () {
        return this.scrollController.el;
    };
    ElementScrollGeomCache.prototype.computeClientRect = function () {
        return computeInnerRect(this.scrollController.el);
    };
    return ElementScrollGeomCache;
}(ScrollGeomCache));

var WindowScrollGeomCache = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(WindowScrollGeomCache, _super);
    function WindowScrollGeomCache(doesListening) {
        return _super.call(this, new WindowScrollController(), doesListening) || this;
    }
    WindowScrollGeomCache.prototype.getEventTarget = function () {
        return window;
    };
    WindowScrollGeomCache.prototype.computeClientRect = function () {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight,
        };
    };
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    WindowScrollGeomCache.prototype.handleScrollChange = function () {
        this.clientRect = this.computeClientRect();
    };
    return WindowScrollGeomCache;
}(ScrollGeomCache));

// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
var getTime = typeof performance === 'function' ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/
var AutoScroller = /** @class */ (function () {
    function AutoScroller() {
        var _this = this;
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [window, '.fc-scroller'];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = function () {
            if (_this.isAnimating) { // wasn't cancelled between animation calls
                var edge = _this.computeBestEdge(_this.pointerScreenX + window.pageXOffset, _this.pointerScreenY + window.pageYOffset);
                if (edge) {
                    var now = getTime();
                    _this.handleSide(edge, (now - _this.msSinceRequest) / 1000);
                    _this.requestAnimation(now);
                }
                else {
                    _this.isAnimating = false; // will stop animation
                }
            }
        };
    }
    AutoScroller.prototype.start = function (pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    };
    AutoScroller.prototype.handleMove = function (pageX, pageY) {
        if (this.isEnabled) {
            var pointerScreenX = pageX - window.pageXOffset;
            var pointerScreenY = pageY - window.pageYOffset;
            var yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            var xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) {
                this.everMovedUp = true;
            }
            else if (yDelta > 0) {
                this.everMovedDown = true;
            }
            if (xDelta < 0) {
                this.everMovedLeft = true;
            }
            else if (xDelta > 0) {
                this.everMovedRight = true;
            }
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation(getTime());
            }
        }
    };
    AutoScroller.prototype.stop = function () {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
                var scrollCache = _a[_i];
                scrollCache.destroy();
            }
            this.scrollCaches = null;
        }
    };
    AutoScroller.prototype.requestAnimation = function (now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    };
    AutoScroller.prototype.handleSide = function (edge, seconds) {
        var scrollCache = edge.scrollCache;
        var edgeThreshold = this.edgeThreshold;
        var invDistance = edgeThreshold - edge.distance;
        var velocity = // the closer to the edge, the faster we scroll
         ((invDistance * invDistance) / (edgeThreshold * edgeThreshold)) * // quadratic
            this.maxVelocity * seconds;
        var sign = 1;
        switch (edge.name) {
            case 'left':
                sign = -1;
            // falls through
            case 'right':
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case 'top':
                sign = -1;
            // falls through
            case 'bottom':
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    };
    // left/top are relative to document topleft
    AutoScroller.prototype.computeBestEdge = function (left, top) {
        var edgeThreshold = this.edgeThreshold;
        var bestSide = null;
        var scrollCaches = this.scrollCaches || [];
        for (var _i = 0, scrollCaches_1 = scrollCaches; _i < scrollCaches_1.length; _i++) {
            var scrollCache = scrollCaches_1[_i];
            var rect = scrollCache.clientRect;
            var leftDist = left - rect.left;
            var rightDist = rect.right - left;
            var topDist = top - rect.top;
            var bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() &&
                    (!bestSide || bestSide.distance > topDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'top', distance: topDist };
                }
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() &&
                    (!bestSide || bestSide.distance > bottomDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'bottom', distance: bottomDist };
                }
                if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() &&
                    (!bestSide || bestSide.distance > leftDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'left', distance: leftDist };
                }
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() &&
                    (!bestSide || bestSide.distance > rightDist)) {
                    bestSide = { scrollCache: scrollCache, name: 'right', distance: rightDist };
                }
            }
        }
        return bestSide;
    };
    AutoScroller.prototype.buildCaches = function (scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map(function (el) {
            if (el === window) {
                return new WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            }
            return new ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    };
    AutoScroller.prototype.queryScrollEls = function (scrollStartEl) {
        var els = [];
        for (var _i = 0, _a = this.scrollQuery; _i < _a.length; _i++) {
            var query = _a[_i];
            if (typeof query === 'object') {
                els.push(query);
            }
            else {
                els.push.apply(els, Array.prototype.slice.call(getElRoot(scrollStartEl).querySelectorAll(query)));
            }
        }
        return els;
    };
    return AutoScroller;
}());

/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/
var FeaturefulElementDragging = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(FeaturefulElementDragging, _super);
    function FeaturefulElementDragging(containerEl, selector) {
        var _this = _super.call(this, containerEl) || this;
        _this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        _this.delay = null;
        _this.minDistance = 0;
        _this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        _this.mirrorNeedsRevert = false;
        _this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        _this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        _this.isDelayEnded = false;
        _this.isDistanceSurpassed = false;
        _this.delayTimeoutId = null;
        _this.onPointerDown = function (ev) {
            if (!_this.isDragging) { // so new drag doesn't happen while revert animation is going
                _this.isInteracting = true;
                _this.isDelayEnded = false;
                _this.isDistanceSurpassed = false;
                preventSelection(document.body);
                preventContextMenu(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) {
                    ev.origEvent.preventDefault();
                }
                _this.emitter.trigger('pointerdown', ev);
                if (_this.isInteracting && // not destroyed via pointerdown handler
                    !_this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    _this.mirror.setIsVisible(false); // reset. caller must set-visible
                    _this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    _this.startDelay(ev);
                    if (!_this.minDistance) {
                        _this.handleDistanceSurpassed(ev);
                    }
                }
            }
        };
        _this.onPointerMove = function (ev) {
            if (_this.isInteracting) {
                _this.emitter.trigger('pointermove', ev);
                if (!_this.isDistanceSurpassed) {
                    var minDistance = _this.minDistance;
                    var distanceSq = void 0; // current distance from the origin, squared
                    var deltaX = ev.deltaX, deltaY = ev.deltaY;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
                        _this.handleDistanceSurpassed(ev);
                    }
                }
                if (_this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== 'scroll') {
                        _this.mirror.handleMove(ev.pageX, ev.pageY);
                        _this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    _this.emitter.trigger('dragmove', ev);
                }
            }
        };
        _this.onPointerUp = function (ev) {
            if (_this.isInteracting) {
                _this.isInteracting = false;
                allowSelection(document.body);
                allowContextMenu(document.body);
                _this.emitter.trigger('pointerup', ev); // can potentially set mirrorNeedsRevert
                if (_this.isDragging) {
                    _this.autoScroller.stop();
                    _this.tryStopDrag(ev); // which will stop the mirror
                }
                if (_this.delayTimeoutId) {
                    clearTimeout(_this.delayTimeoutId);
                    _this.delayTimeoutId = null;
                }
            }
        };
        var pointer = _this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', _this.onPointerDown);
        pointer.emitter.on('pointermove', _this.onPointerMove);
        pointer.emitter.on('pointerup', _this.onPointerUp);
        if (selector) {
            pointer.selector = selector;
        }
        _this.mirror = new ElementMirror();
        _this.autoScroller = new AutoScroller();
        return _this;
    }
    FeaturefulElementDragging.prototype.destroy = function () {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    };
    FeaturefulElementDragging.prototype.startDelay = function (ev) {
        var _this = this;
        if (typeof this.delay === 'number') {
            this.delayTimeoutId = setTimeout(function () {
                _this.delayTimeoutId = null;
                _this.handleDelayEnd(ev);
            }, this.delay); // not assignable to number!
        }
        else {
            this.handleDelayEnd(ev);
        }
    };
    FeaturefulElementDragging.prototype.handleDelayEnd = function (ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.handleDistanceSurpassed = function (ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    };
    FeaturefulElementDragging.prototype.tryStartDrag = function (ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger('dragstart', ev);
                if (this.touchScrollAllowed === false) {
                    this.pointer.cancelTouchScroll();
                }
            }
        }
    };
    FeaturefulElementDragging.prototype.tryStopDrag = function (ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    };
    FeaturefulElementDragging.prototype.stopDrag = function (ev) {
        this.isDragging = false;
        this.emitter.trigger('dragend', ev);
    };
    // fill in the implementations...
    FeaturefulElementDragging.prototype.setIgnoreMove = function (bool) {
        this.pointer.shouldIgnoreMove = bool;
    };
    FeaturefulElementDragging.prototype.setMirrorIsVisible = function (bool) {
        this.mirror.setIsVisible(bool);
    };
    FeaturefulElementDragging.prototype.setMirrorNeedsRevert = function (bool) {
        this.mirrorNeedsRevert = bool;
    };
    FeaturefulElementDragging.prototype.setAutoScrollEnabled = function (bool) {
        this.autoScroller.isEnabled = bool;
    };
    return FeaturefulElementDragging;
}(ElementDragging));

/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/
var OffsetTracker = /** @class */ (function () {
    function OffsetTracker(el) {
        this.origRect = computeRect(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = getClippingParents(el).map(function (scrollEl) { return new ElementScrollGeomCache(scrollEl, true); });
    }
    OffsetTracker.prototype.destroy = function () {
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            scrollCache.destroy();
        }
    };
    OffsetTracker.prototype.computeLeft = function () {
        var left = this.origRect.left;
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        }
        return left;
    };
    OffsetTracker.prototype.computeTop = function () {
        var top = this.origRect.top;
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        }
        return top;
    };
    OffsetTracker.prototype.isWithinClipping = function (pageX, pageY) {
        var point = { left: pageX, top: pageY };
        for (var _i = 0, _a = this.scrollCaches; _i < _a.length; _i++) {
            var scrollCache = _a[_i];
            if (!isIgnoredClipping(scrollCache.getEventTarget()) &&
                !pointInsideRect(point, scrollCache.clientRect)) {
                return false;
            }
        }
        return true;
    };
    return OffsetTracker;
}());
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function isIgnoredClipping(node) {
    var tagName = node.tagName;
    return tagName === 'HTML' || tagName === 'BODY';
}

/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/
var HitDragging = /** @class */ (function () {
    function HitDragging(dragging, droppableStore) {
        var _this = this;
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = function (ev) {
            var dragging = _this.dragging;
            _this.initialHit = null;
            _this.movingHit = null;
            _this.finalHit = null;
            _this.prepareHits();
            _this.processFirstCoord(ev);
            if (_this.initialHit || !_this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                _this.emitter.trigger('pointerdown', ev);
            }
            else {
                dragging.setIgnoreMove(true);
            }
        };
        this.handleDragStart = function (ev) {
            _this.emitter.trigger('dragstart', ev);
            _this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = function (ev) {
            _this.emitter.trigger('dragmove', ev);
            _this.handleMove(ev);
        };
        this.handlePointerUp = function (ev) {
            _this.releaseHits();
            _this.emitter.trigger('pointerup', ev);
        };
        this.handleDragEnd = function (ev) {
            if (_this.movingHit) {
                _this.emitter.trigger('hitupdate', null, true, ev);
            }
            _this.finalHit = _this.movingHit;
            _this.movingHit = null;
            _this.emitter.trigger('dragend', ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        dragging.emitter.on('dragmove', this.handleDragMove);
        dragging.emitter.on('pointerup', this.handlePointerUp);
        dragging.emitter.on('dragend', this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new Emitter();
    }
    // sets initialHit
    // sets coordAdjust
    HitDragging.prototype.processFirstCoord = function (ev) {
        var origPoint = { left: ev.pageX, top: ev.pageY };
        var adjustedPoint = origPoint;
        var subjectEl = ev.subjectEl;
        var subjectRect;
        if (subjectEl instanceof HTMLElement) { // i.e. not a Document/ShadowRoot
            subjectRect = computeRect(subjectEl);
            adjustedPoint = constrainPoint(adjustedPoint, subjectRect);
        }
        var initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                var slicedSubjectRect = intersectRects(subjectRect, initialHit.rect);
                if (slicedSubjectRect) {
                    adjustedPoint = getRectCenter(slicedSubjectRect);
                }
            }
            this.coordAdjust = diffPoints(adjustedPoint, origPoint);
        }
        else {
            this.coordAdjust = { left: 0, top: 0 };
        }
    };
    HitDragging.prototype.handleMove = function (ev, forceHandle) {
        var hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger('hitupdate', hit, false, ev);
        }
    };
    HitDragging.prototype.prepareHits = function () {
        this.offsetTrackers = mapHash(this.droppableStore, function (interactionSettings) {
            interactionSettings.component.prepareHits();
            return new OffsetTracker(interactionSettings.el);
        });
    };
    HitDragging.prototype.releaseHits = function () {
        var offsetTrackers = this.offsetTrackers;
        for (var id in offsetTrackers) {
            offsetTrackers[id].destroy();
        }
        this.offsetTrackers = {};
    };
    HitDragging.prototype.queryHitForOffset = function (offsetLeft, offsetTop) {
        var _a = this, droppableStore = _a.droppableStore, offsetTrackers = _a.offsetTrackers;
        var bestHit = null;
        for (var id in droppableStore) {
            var component = droppableStore[id].component;
            var offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
                offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                var originLeft = offsetTracker.computeLeft();
                var originTop = offsetTracker.computeTop();
                var positionLeft = offsetLeft - originLeft;
                var positionTop = offsetTop - originTop;
                var origRect = offsetTracker.origRect;
                var width = origRect.right - origRect.left;
                var height = origRect.bottom - origRect.top;
                if (
                // must be within the element's bounds
                positionLeft >= 0 && positionLeft < width &&
                    positionTop >= 0 && positionTop < height) {
                    var hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && (
                    // make sure the hit is within activeRange, meaning it's not a dead cell
                    rangeContainsRange(hit.dateProfile.activeRange, hit.dateSpan.range)) &&
                        (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    };
    return HitDragging;
}());
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
        return true;
    }
    if (Boolean(hit0) !== Boolean(hit1)) {
        return false;
    }
    return isDateSpansEqual(hit0.dateSpan, hit1.dateSpan);
}

function buildDatePointApiWithContext(dateSpan, context) {
    var props = {};
    for (var _i = 0, _a = context.pluginHooks.datePointTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        interaction_node_modules_tslib_tslib_es6_assign(props, transform(dateSpan, context));
    }
    interaction_node_modules_tslib_tslib_es6_assign(props, buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, { omitTime: span.allDay }),
        allDay: span.allDay,
    };
}

/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/
var DateClicking = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(DateClicking, _super);
    function DateClicking(settings) {
        var _this = _super.call(this, settings) || this;
        _this.handlePointerDown = function (pev) {
            var dragging = _this.dragging;
            var downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!_this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        _this.handleDragEnd = function (ev) {
            var component = _this.component;
            var pointer = _this.dragging.pointer;
            if (!pointer.wasTouchScroll) {
                var _a = _this.hitDragging, initialHit = _a.initialHit, finalHit = _a.finalHit;
                if (initialHit && finalHit && isHitsEqual(initialHit, finalHit)) {
                    var context = component.context;
                    var arg = interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, buildDatePointApiWithContext(initialHit.dateSpan, context)), { dayEl: initialHit.dayEl, jsEvent: ev.origEvent, view: context.viewApi || context.calendarApi.view });
                    context.emitter.trigger('dateClick', arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        _this.dragging = new FeaturefulElementDragging(settings.el);
        _this.dragging.autoScroller.isEnabled = false;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    DateClicking.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return DateClicking;
}(Interaction));

/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/
var DateSelecting = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(DateSelecting, _super);
    function DateSelecting(settings) {
        var _this = _super.call(this, settings) || this;
        _this.dragSelection = null;
        _this.handlePointerDown = function (ev) {
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var options = component.context.options;
            var canSelect = options.selectable &&
                component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? getComponentTouchDelay$1(component) : null;
        };
        _this.handleDragStart = function (ev) {
            _this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        _this.handleHitUpdate = function (hit, isFinal) {
            var context = _this.component.context;
            var dragSelection = null;
            var isInvalid = false;
            if (hit) {
                var initialHit = _this.hitDragging.initialHit;
                var disallowed = hit.componentId === initialHit.componentId
                    && _this.isHitComboAllowed
                    && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) {
                    dragSelection = joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                }
                if (!dragSelection || !isDateSelectionValid(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) {
                context.dispatch({ type: 'SELECT_DATES', selection: dragSelection });
            }
            else if (!isFinal) { // only unselect if moved away while dragging
                context.dispatch({ type: 'UNSELECT_DATES' });
            }
            if (!isInvalid) {
                enableCursor();
            }
            else {
                disableCursor();
            }
            if (!isFinal) {
                _this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
            }
        };
        _this.handlePointerUp = function (pev) {
            if (_this.dragSelection) {
                // selection is already rendered, so just need to report selection
                triggerDateSelect(_this.dragSelection, pev, _this.component.context);
                _this.dragSelection = null;
            }
        };
        var component = settings.component;
        var options = component.context.options;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', _this.handlePointerUp);
        return _this;
    }
    DateSelecting.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return DateSelecting;
}(Interaction));
function getComponentTouchDelay$1(component) {
    var options = component.context.options;
    var delay = options.selectLongPressDelay;
    if (delay == null) {
        delay = options.longPressDelay;
    }
    return delay;
}
function joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end,
    ];
    ms.sort(compareNumbers);
    var props = {};
    for (var _i = 0, dateSelectionTransformers_1 = dateSelectionTransformers; _i < dateSelectionTransformers_1.length; _i++) {
        var transformer = dateSelectionTransformers_1[_i];
        var res = transformer(hit0, hit1);
        if (res === false) {
            return null;
        }
        if (res) {
            interaction_node_modules_tslib_tslib_es6_assign(props, res);
        }
    }
    props.range = { start: ms[0], end: ms[3] };
    props.allDay = dateSpan0.allDay;
    return props;
}

var EventDragging = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(EventDragging, _super);
    function EventDragging(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.subjectEl = null;
        _this.subjectSeg = null; // the seg being selected/dragged
        _this.isDragging = false;
        _this.eventRange = null;
        _this.relevantEvents = null; // the events being dragged
        _this.receivingContext = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function (ev) {
            var origTarget = ev.origEvent.target;
            var _a = _this, component = _a.component, dragging = _a.dragging;
            var mirror = dragging.mirror;
            var options = component.context.options;
            var initialContext = component.context;
            _this.subjectEl = ev.subjectEl;
            var subjectSeg = _this.subjectSeg = getElSeg(ev.subjectEl);
            var eventRange = _this.eventRange = subjectSeg.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            _this.relevantEvents = getRelevantEvents(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay =
                // only do a touch delay if touch and this event hasn't been selected yet
                (ev.isTouch && eventInstanceId !== component.props.eventSelection) ?
                    getComponentTouchDelay(component) :
                    null;
            if (options.fixedMirrorParent) {
                mirror.parentNode = options.fixedMirrorParent;
            }
            else {
                mirror.parentNode = elementClosest(origTarget, '.fc');
            }
            mirror.revertDuration = options.dragRevertDuration;
            var isValid = component.isValidSegDownEl(origTarget) &&
                !elementClosest(origTarget, '.fc-event-resizer'); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            _this.isDragging = isValid &&
                ev.subjectEl.classList.contains('fc-event-draggable');
        };
        _this.handleDragStart = function (ev) {
            var initialContext = _this.component.context;
            var eventRange = _this.eventRange;
            var eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) {
                // need to select a different event?
                if (eventInstanceId !== _this.component.props.eventSelection) {
                    initialContext.dispatch({ type: 'SELECT_EVENT', eventInstanceId: eventInstanceId });
                }
            }
            else {
                // if now using mouse, but was previous touch interaction, clear selected event
                initialContext.dispatch({ type: 'UNSELECT_EVENT' });
            }
            if (_this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger('eventDragStart', {
                    el: _this.subjectEl,
                    event: new EventApi(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi,
                });
            }
        };
        _this.handleHitUpdate = function (hit, isFinal) {
            if (!_this.isDragging) {
                return;
            }
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var initialContext = _this.component.context;
            // states based on new hit
            var receivingContext = null;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: createEmptyEventStore(),
                isEvent: true,
            };
            if (hit) {
                receivingContext = hit.context;
                var receivingOptions = receivingContext.options;
                if (initialContext === receivingContext ||
                    (receivingOptions.editable && receivingOptions.droppable)) {
                    mutation = computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = applyMutationToEventStore(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!isInteractionValid(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = createEmptyEventStore();
                        }
                    }
                }
                else {
                    receivingContext = null;
                }
            }
            _this.displayDrag(receivingContext, interaction);
            if (!isInvalid) {
                enableCursor();
            }
            else {
                disableCursor();
            }
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                    isHitsEqual(initialHit, hit)) {
                    mutation = null;
                }
                _this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                _this.dragging.setMirrorIsVisible(!hit || !getElRoot(_this.subjectEl).querySelector('.fc-event-mirror'));
                // assign states based on new hit
                _this.receivingContext = receivingContext;
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handlePointerUp = function () {
            if (!_this.isDragging) {
                _this.cleanup(); // because handleDragEnd won't fire
            }
        };
        _this.handleDragEnd = function (ev) {
            if (_this.isDragging) {
                var initialContext_1 = _this.component.context;
                var initialView = initialContext_1.viewApi;
                var _a = _this, receivingContext_1 = _a.receivingContext, validMutation = _a.validMutation;
                var eventDef = _this.eventRange.def;
                var eventInstance = _this.eventRange.instance;
                var eventApi = new EventApi(initialContext_1, eventDef, eventInstance);
                var relevantEvents_1 = _this.relevantEvents;
                var mutatedRelevantEvents_1 = _this.mutatedRelevantEvents;
                var finalHit = _this.hitDragging.finalHit;
                _this.clearDrag(); // must happen after revert animation
                initialContext_1.emitter.trigger('eventDragStop', {
                    el: _this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView,
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext_1 === initialContext_1) {
                        var updatedEventApi = new EventApi(initialContext_1, mutatedRelevantEvents_1.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents_1.instances[eventInstance.instanceId] : null);
                        initialContext_1.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents_1,
                        });
                        var eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: buildEventApis(mutatedRelevantEvents_1, initialContext_1, eventInstance),
                            revert: function () {
                                initialContext_1.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents_1, // the pre-change data
                                });
                            },
                        };
                        var transformed = {};
                        for (var _i = 0, _b = initialContext_1.getCurrentData().pluginHooks.eventDropTransformers; _i < _b.length; _i++) {
                            var transformer = _b[_i];
                            interaction_node_modules_tslib_tslib_es6_assign(transformed, transformer(validMutation, initialContext_1));
                        }
                        initialContext_1.emitter.trigger('eventDrop', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, eventChangeArg), transformed), { el: ev.subjectEl, delta: validMutation.datesDelta, jsEvent: ev.origEvent, view: initialView }));
                        initialContext_1.emitter.trigger('eventChange', eventChangeArg);
                        // dropped in different calendar
                    }
                    else if (receivingContext_1) {
                        var eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: buildEventApis(relevantEvents_1, initialContext_1, eventInstance),
                            revert: function () {
                                initialContext_1.dispatch({
                                    type: 'MERGE_EVENTS',
                                    eventStore: relevantEvents_1,
                                });
                            },
                        };
                        initialContext_1.emitter.trigger('eventLeave', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, eventRemoveArg), { draggedEl: ev.subjectEl, view: initialView }));
                        initialContext_1.dispatch({
                            type: 'REMOVE_EVENTS',
                            eventStore: relevantEvents_1,
                        });
                        initialContext_1.emitter.trigger('eventRemove', eventRemoveArg);
                        var addedEventDef = mutatedRelevantEvents_1.defs[eventDef.defId];
                        var addedEventInstance = mutatedRelevantEvents_1.instances[eventInstance.instanceId];
                        var addedEventApi = new EventApi(receivingContext_1, addedEventDef, addedEventInstance);
                        receivingContext_1.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: mutatedRelevantEvents_1,
                        });
                        var eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: buildEventApis(mutatedRelevantEvents_1, receivingContext_1, addedEventInstance),
                            revert: function () {
                                receivingContext_1.dispatch({
                                    type: 'REMOVE_EVENTS',
                                    eventStore: mutatedRelevantEvents_1,
                                });
                            },
                        };
                        receivingContext_1.emitter.trigger('eventAdd', eventAddArg);
                        if (ev.isTouch) {
                            receivingContext_1.dispatch({
                                type: 'SELECT_EVENT',
                                eventInstanceId: eventInstance.instanceId,
                            });
                        }
                        receivingContext_1.emitter.trigger('drop', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext_1)), { draggedEl: ev.subjectEl, jsEvent: ev.origEvent, view: finalHit.context.viewApi }));
                        receivingContext_1.emitter.trigger('eventReceive', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, eventAddArg), { draggedEl: ev.subjectEl, view: finalHit.context.viewApi }));
                    }
                }
                else {
                    initialContext_1.emitter.trigger('_noEventDrop');
                }
            }
            _this.cleanup();
        };
        var component = _this.component;
        var options = component.context.options;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, interactionSettingsStore);
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('pointerup', _this.handlePointerUp);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    EventDragging.prototype.destroy = function () {
        this.dragging.destroy();
    };
    // render a drag state on the next receivingCalendar
    EventDragging.prototype.displayDrag = function (nextContext, state) {
        var initialContext = this.component.context;
        var prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) {
                prevContext.dispatch({
                    type: 'SET_EVENT_DRAG',
                    state: {
                        affectedEvents: state.affectedEvents,
                        mutatedEvents: createEmptyEventStore(),
                        isEvent: true,
                    },
                });
                // completely clear the old calendar if it wasn't the initial
            }
            else {
                prevContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
            }
        }
        if (nextContext) {
            nextContext.dispatch({ type: 'SET_EVENT_DRAG', state: state });
        }
    };
    EventDragging.prototype.clearDrag = function () {
        var initialCalendar = this.component.context;
        var receivingContext = this.receivingContext;
        if (receivingContext) {
            receivingContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) {
            initialCalendar.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
    };
    EventDragging.prototype.cleanup = function () {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    };
    // TODO: test this in IE11
    // QUESTION: why do we need it on the resizable???
    EventDragging.SELECTOR = '.fc-event-draggable, .fc-event-resizable';
    return EventDragging;
}(Interaction));
function computeEventMutation(hit0, hit1, massagers) {
    var dateSpan0 = hit0.dateSpan;
    var dateSpan1 = hit1.dateSpan;
    var date0 = dateSpan0.range.start;
    var date1 = dateSpan1.range.start;
    var standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) {
            // means date1 is already start-of-day,
            // but date0 needs to be converted
            date0 = startOfDay(date0);
        }
    }
    var delta = diffDates(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ?
        hit0.largeUnit :
        null);
    if (delta.milliseconds) { // has hours/minutes/seconds
        standardProps.allDay = false;
    }
    var mutation = {
        datesDelta: delta,
        standardProps: standardProps,
    };
    for (var _i = 0, massagers_1 = massagers; _i < massagers_1.length; _i++) {
        var massager = massagers_1[_i];
        massager(mutation, hit0, hit1);
    }
    return mutation;
}
function getComponentTouchDelay(component) {
    var options = component.context.options;
    var delay = options.eventLongPressDelay;
    if (delay == null) {
        delay = options.longPressDelay;
    }
    return delay;
}

var EventResizing = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(EventResizing, _super);
    function EventResizing(settings) {
        var _this = _super.call(this, settings) || this;
        // internal state
        _this.draggingSegEl = null;
        _this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        _this.eventRange = null;
        _this.relevantEvents = null;
        _this.validMutation = null;
        _this.mutatedRelevantEvents = null;
        _this.handlePointerDown = function (ev) {
            var component = _this.component;
            var segEl = _this.querySegEl(ev);
            var seg = getElSeg(segEl);
            var eventRange = _this.eventRange = seg.eventRange;
            _this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            _this.dragging.setIgnoreMove(!_this.component.isValidSegDownEl(ev.origEvent.target) ||
                (ev.isTouch && _this.component.props.eventSelection !== eventRange.instance.instanceId));
        };
        _this.handleDragStart = function (ev) {
            var context = _this.component.context;
            var eventRange = _this.eventRange;
            _this.relevantEvents = getRelevantEvents(context.getCurrentData().eventStore, _this.eventRange.instance.instanceId);
            var segEl = _this.querySegEl(ev);
            _this.draggingSegEl = segEl;
            _this.draggingSeg = getElSeg(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger('eventResizeStart', {
                el: segEl,
                event: new EventApi(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi,
            });
        };
        _this.handleHitUpdate = function (hit, isFinal, ev) {
            var context = _this.component.context;
            var relevantEvents = _this.relevantEvents;
            var initialHit = _this.hitDragging.initialHit;
            var eventInstance = _this.eventRange.instance;
            var mutation = null;
            var mutatedRelevantEvents = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: createEmptyEventStore(),
                isEvent: true,
            };
            if (hit) {
                var disallowed = hit.componentId === initialHit.componentId
                    && _this.isHitComboAllowed
                    && !_this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) {
                    mutation = computeMutation(initialHit, hit, ev.subjectEl.classList.contains('fc-event-resizer-start'), eventInstance.range);
                }
            }
            if (mutation) {
                mutatedRelevantEvents = applyMutationToEventStore(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!isInteractionValid(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) {
                context.dispatch({
                    type: 'SET_EVENT_RESIZE',
                    state: interaction,
                });
            }
            else {
                context.dispatch({ type: 'UNSET_EVENT_RESIZE' });
            }
            if (!isInvalid) {
                enableCursor();
            }
            else {
                disableCursor();
            }
            if (!isFinal) {
                if (mutation && isHitsEqual(initialHit, hit)) {
                    mutation = null;
                }
                _this.validMutation = mutation;
                _this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        _this.handleDragEnd = function (ev) {
            var context = _this.component.context;
            var eventDef = _this.eventRange.def;
            var eventInstance = _this.eventRange.instance;
            var eventApi = new EventApi(context, eventDef, eventInstance);
            var relevantEvents = _this.relevantEvents;
            var mutatedRelevantEvents = _this.mutatedRelevantEvents;
            context.emitter.trigger('eventResizeStop', {
                el: _this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi,
            });
            if (_this.validMutation) {
                var updatedEventApi = new EventApi(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: 'MERGE_EVENTS',
                    eventStore: mutatedRelevantEvents,
                });
                var eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: buildEventApis(mutatedRelevantEvents, context, eventInstance),
                    revert: function () {
                        context.dispatch({
                            type: 'MERGE_EVENTS',
                            eventStore: relevantEvents, // the pre-change events
                        });
                    },
                };
                context.emitter.trigger('eventResize', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, eventChangeArg), { el: _this.draggingSegEl, startDelta: _this.validMutation.startDelta || createDuration(0), endDelta: _this.validMutation.endDelta || createDuration(0), jsEvent: ev.origEvent, view: context.viewApi }));
                context.emitter.trigger('eventChange', eventChangeArg);
            }
            else {
                context.emitter.trigger('_noEventResize');
            }
            // reset all internal state
            _this.draggingSeg = null;
            _this.relevantEvents = null;
            _this.validMutation = null;
            // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        var component = settings.component;
        var dragging = _this.dragging = new FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = '.fc-event-resizer';
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        var hitDragging = _this.hitDragging = new HitDragging(_this.dragging, interactionSettingsToStore(settings));
        hitDragging.emitter.on('pointerdown', _this.handlePointerDown);
        hitDragging.emitter.on('dragstart', _this.handleDragStart);
        hitDragging.emitter.on('hitupdate', _this.handleHitUpdate);
        hitDragging.emitter.on('dragend', _this.handleDragEnd);
        return _this;
    }
    EventResizing.prototype.destroy = function () {
        this.dragging.destroy();
    };
    EventResizing.prototype.querySegEl = function (ev) {
        return elementClosest(ev.subjectEl, '.fc-event');
    };
    return EventResizing;
}(Interaction));
function computeMutation(hit0, hit1, isFromStart, instanceRange) {
    var dateEnv = hit0.context.dateEnv;
    var date0 = hit0.dateSpan.range.start;
    var date1 = hit1.dateSpan.range.start;
    var delta = diffDates(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) {
            return { startDelta: delta };
        }
    }
    else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) {
        return { endDelta: delta };
    }
    return null;
}

var UnselectAuto = /** @class */ (function () {
    function UnselectAuto(context) {
        var _this = this;
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = function (selectInfo) {
            if (selectInfo.jsEvent) {
                _this.isRecentPointerDateSelect = true;
            }
        };
        this.onDocumentPointerDown = function (pev) {
            var unselectCancel = _this.context.options.unselectCancel;
            var downEl = getEventTargetViaRoot(pev.origEvent);
            _this.matchesCancel = !!elementClosest(downEl, unselectCancel);
            _this.matchesEvent = !!elementClosest(downEl, EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = function (pev) {
            var context = _this.context;
            var documentPointer = _this.documentPointer;
            var calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                    !_this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    var unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !_this.matchesCancel)) {
                        context.calendarApi.unselect(pev);
                    }
                }
                if (calendarState.eventSelection && // an existing event selected?
                    !_this.matchesEvent // interaction DIDN'T start on an event
                ) {
                    context.dispatch({ type: 'UNSELECT_EVENT' });
                }
            }
            _this.isRecentPointerDateSelect = false;
        };
        var documentPointer = this.documentPointer = new PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on('pointerdown', this.onDocumentPointerDown);
        documentPointer.emitter.on('pointerup', this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */
        context.emitter.on('select', this.onSelect);
    }
    UnselectAuto.prototype.destroy = function () {
        this.context.emitter.off('select', this.onSelect);
        this.documentPointer.destroy();
    };
    return UnselectAuto;
}());

var main_OPTION_REFINERS = {
    fixedMirrorParent: identity,
};
var LISTENER_REFINERS = {
    dateClick: identity,
    eventDragStart: identity,
    eventDragStop: identity,
    eventDrop: identity,
    eventResizeStart: identity,
    eventResizeStop: identity,
    eventResize: identity,
    drop: identity,
    eventReceive: identity,
    eventLeave: identity,
};

/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/
var ExternalElementDragging = /** @class */ (function () {
    function ExternalElementDragging(dragging, suppliedDragMeta) {
        var _this = this;
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = function (ev) {
            _this.dragMeta = _this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = function (hit, isFinal, ev) {
            var dragging = _this.hitDragging.dragging;
            var receivingContext = null;
            var droppableEvent = null;
            var isInvalid = false;
            var interaction = {
                affectedEvents: createEmptyEventStore(),
                mutatedEvents: createEmptyEventStore(),
                isEvent: _this.dragMeta.create,
            };
            if (hit) {
                receivingContext = hit.context;
                if (_this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = computeEventForDateSpan(hit.dateSpan, _this.dragMeta, receivingContext);
                    interaction.mutatedEvents = eventTupleToStore(droppableEvent);
                    isInvalid = !isInteractionValid(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = createEmptyEventStore();
                        droppableEvent = null;
                    }
                }
            }
            _this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector('.fc-event-mirror'));
            if (!isInvalid) {
                enableCursor();
            }
            else {
                disableCursor();
            }
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                _this.receivingContext = receivingContext;
                _this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = function (pev) {
            var _a = _this, receivingContext = _a.receivingContext, droppableEvent = _a.droppableEvent;
            _this.clearDrag();
            if (receivingContext && droppableEvent) {
                var finalHit = _this.hitDragging.finalHit;
                var finalView = finalHit.context.viewApi;
                var dragMeta = _this.dragMeta;
                receivingContext.emitter.trigger('drop', interaction_node_modules_tslib_tslib_es6_assign(interaction_node_modules_tslib_tslib_es6_assign({}, buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), { draggedEl: pev.subjectEl, jsEvent: pev.origEvent, view: finalView }));
                if (dragMeta.create) {
                    var addingEvents_1 = eventTupleToStore(droppableEvent);
                    receivingContext.dispatch({
                        type: 'MERGE_EVENTS',
                        eventStore: addingEvents_1,
                    });
                    if (pev.isTouch) {
                        receivingContext.dispatch({
                            type: 'SELECT_EVENT',
                            eventInstanceId: droppableEvent.instance.instanceId,
                        });
                    }
                    // signal that an external event landed
                    receivingContext.emitter.trigger('eventReceive', {
                        event: new EventApi(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert: function () {
                            receivingContext.dispatch({
                                type: 'REMOVE_EVENTS',
                                eventStore: addingEvents_1,
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView,
                    });
                }
            }
            _this.receivingContext = null;
            _this.droppableEvent = null;
        };
        var hitDragging = this.hitDragging = new HitDragging(dragging, interactionSettingsStore);
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on('dragstart', this.handleDragStart);
        hitDragging.emitter.on('hitupdate', this.handleHitUpdate);
        hitDragging.emitter.on('dragend', this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
    ExternalElementDragging.prototype.buildDragMeta = function (subjectEl) {
        if (typeof this.suppliedDragMeta === 'object') {
            return parseDragMeta(this.suppliedDragMeta);
        }
        if (typeof this.suppliedDragMeta === 'function') {
            return parseDragMeta(this.suppliedDragMeta(subjectEl));
        }
        return getDragMetaFromEl(subjectEl);
    };
    ExternalElementDragging.prototype.displayDrag = function (nextContext, state) {
        var prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) {
            prevContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
        if (nextContext) {
            nextContext.dispatch({ type: 'SET_EVENT_DRAG', state: state });
        }
    };
    ExternalElementDragging.prototype.clearDrag = function () {
        if (this.receivingContext) {
            this.receivingContext.dispatch({ type: 'UNSET_EVENT_DRAG' });
        }
    };
    ExternalElementDragging.prototype.canDropElOnCalendar = function (el, receivingContext) {
        var dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === 'function') {
            return dropAccept.call(receivingContext.calendarApi, el);
        }
        if (typeof dropAccept === 'string' && dropAccept) {
            return Boolean(elementMatches(el, dropAccept));
        }
        return true;
    };
    return ExternalElementDragging;
}());
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function computeEventForDateSpan(dateSpan, dragMeta, context) {
    var defProps = interaction_node_modules_tslib_tslib_es6_assign({}, dragMeta.leftoverProps);
    for (var _i = 0, _a = context.pluginHooks.externalDefTransforms; _i < _a.length; _i++) {
        var transform = _a[_i];
        interaction_node_modules_tslib_tslib_es6_assign(defProps, transform(dateSpan, dragMeta));
    }
    var _b = refineEventDef(defProps, context), refined = _b.refined, extra = _b.extra;
    var def = parseEventDef(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), // hasEnd
    context);
    var start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) {
        start = context.dateEnv.add(start, dragMeta.startTime);
    }
    var end = dragMeta.duration ?
        context.dateEnv.add(start, dragMeta.duration) :
        getDefaultEventEnd(dateSpan.allDay, start, context);
    var instance = createEventInstance(def.defId, { start: start, end: end });
    return { def: def, instance: instance };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function getDragMetaFromEl(el) {
    var str = getEmbeddedElData(el, 'event');
    var obj = str ?
        JSON.parse(str) :
        { create: false }; // if no embedded data, assume no event creation
    return parseDragMeta(obj);
}
config.dataAttrPrefix = '';
function getEmbeddedElData(el, name) {
    var prefix = config.dataAttrPrefix;
    var prefixedName = (prefix ? prefix + '-' : '') + name;
    return el.getAttribute('data-' + prefixedName) || '';
}

/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/
var ExternalDraggable = /** @class */ (function () {
    function ExternalDraggable(el, settings) {
        var _this = this;
        if (settings === void 0) { settings = {}; }
        this.handlePointerDown = function (ev) {
            var dragging = _this.dragging;
            var _a = _this.settings, minDistance = _a.minDistance, longPressDelay = _a.longPressDelay;
            dragging.minDistance =
                minDistance != null ?
                    minDistance :
                    (ev.isTouch ? 0 : BASE_OPTION_DEFAULTS.eventDragMinDistance);
            dragging.delay =
                ev.isTouch ? // TODO: eventually read eventLongPressDelay instead vvv
                    (longPressDelay != null ? longPressDelay : BASE_OPTION_DEFAULTS.longPressDelay) :
                    0;
        };
        this.handleDragStart = function (ev) {
            if (ev.isTouch &&
                _this.dragging.delay &&
                ev.subjectEl.classList.contains('fc-event')) {
                _this.dragging.mirror.getMirrorEl().classList.add('fc-event-selected');
            }
        };
        this.settings = settings;
        var dragging = this.dragging = new FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) {
            dragging.pointer.selector = settings.itemSelector;
        }
        if (settings.appendTo != null) {
            dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        }
        dragging.emitter.on('pointerdown', this.handlePointerDown);
        dragging.emitter.on('dragstart', this.handleDragStart);
        new ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ExternalDraggable.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return ExternalDraggable;
}());

/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/
var InferredElementDragging = /** @class */ (function (_super) {
    interaction_node_modules_tslib_tslib_es6_extends(InferredElementDragging, _super);
    function InferredElementDragging(containerEl) {
        var _this = _super.call(this, containerEl) || this;
        _this.shouldIgnoreMove = false;
        _this.mirrorSelector = '';
        _this.currentMirrorEl = null;
        _this.handlePointerDown = function (ev) {
            _this.emitter.trigger('pointerdown', ev);
            if (!_this.shouldIgnoreMove) {
                // fire dragstart right away. does not support delay or min-distance
                _this.emitter.trigger('dragstart', ev);
            }
        };
        _this.handlePointerMove = function (ev) {
            if (!_this.shouldIgnoreMove) {
                _this.emitter.trigger('dragmove', ev);
            }
        };
        _this.handlePointerUp = function (ev) {
            _this.emitter.trigger('pointerup', ev);
            if (!_this.shouldIgnoreMove) {
                // fire dragend right away. does not support a revert animation
                _this.emitter.trigger('dragend', ev);
            }
        };
        var pointer = _this.pointer = new PointerDragging(containerEl);
        pointer.emitter.on('pointerdown', _this.handlePointerDown);
        pointer.emitter.on('pointermove', _this.handlePointerMove);
        pointer.emitter.on('pointerup', _this.handlePointerUp);
        return _this;
    }
    InferredElementDragging.prototype.destroy = function () {
        this.pointer.destroy();
    };
    InferredElementDragging.prototype.setIgnoreMove = function (bool) {
        this.shouldIgnoreMove = bool;
    };
    InferredElementDragging.prototype.setMirrorIsVisible = function (bool) {
        if (bool) {
            // restore a previously hidden element.
            // use the reference in case the selector class has already been removed.
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = '';
                this.currentMirrorEl = null;
            }
        }
        else {
            var mirrorEl = this.mirrorSelector
                // TODO: somehow query FullCalendars WITHIN shadow-roots
                ? document.querySelector(this.mirrorSelector)
                : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = 'hidden';
            }
        }
    };
    return InferredElementDragging;
}(ElementDragging));

/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/
var ThirdPartyDraggable = /** @class */ (function () {
    function ThirdPartyDraggable(containerOrSettings, settings) {
        var containerEl = document;
        if (
        // wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document ||
            containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        }
        else {
            settings = (containerOrSettings || {});
        }
        var dragging = this.dragging = new InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === 'string') {
            dragging.pointer.selector = settings.itemSelector;
        }
        else if (containerEl === document) {
            dragging.pointer.selector = '[data-event]';
        }
        if (typeof settings.mirrorSelector === 'string') {
            dragging.mirrorSelector = settings.mirrorSelector;
        }
        new ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
    ThirdPartyDraggable.prototype.destroy = function () {
        this.dragging.destroy();
    };
    return ThirdPartyDraggable;
}());

var interaction_main_main = createPlugin({
    componentInteractions: [DateClicking, DateSelecting, EventDragging, EventResizing],
    calendarInteractions: [UnselectAuto],
    elementDraggingImpl: FeaturefulElementDragging,
    optionRefiners: main_OPTION_REFINERS,
    listenerRefiners: LISTENER_REFINERS,
});

/* harmony default export */ const interaction_main = (interaction_main_main);

//# sourceMappingURL=main.js.map

;// CONCATENATED MODULE: ./node_modules/dateformat/lib/dateformat.js
var token=/d{1,4}|D{3,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|W{1,2}|[LlopSZN]|"[^"]*"|'[^']*'/g;var timezone=/\b(?:[A-Z]{1,3}[A-Z][TC])(?:[-+]\d{4})?|((?:Australian )?(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time)\b/g;var timezoneClip=/[^-+\dA-Z]/g;function dateFormat(date,mask,utc,gmt){if(arguments.length===1&&typeof date==="string"&&!/\d/.test(date)){mask=date;date=undefined}date=date||date===0?date:new Date;if(!(date instanceof Date)){date=new Date(date)}if(isNaN(date)){throw TypeError("Invalid date")}mask=String(masks[mask]||mask||masks["default"]);var maskSlice=mask.slice(0,4);if(maskSlice==="UTC:"||maskSlice==="GMT:"){mask=mask.slice(4);utc=true;if(maskSlice==="GMT:"){gmt=true}}var _=function _(){return utc?"getUTC":"get"};var _d=function d(){return date[_()+"Date"]()};var D=function D(){return date[_()+"Day"]()};var _m=function m(){return date[_()+"Month"]()};var y=function y(){return date[_()+"FullYear"]()};var _H=function H(){return date[_()+"Hours"]()};var _M=function M(){return date[_()+"Minutes"]()};var _s=function s(){return date[_()+"Seconds"]()};var _L=function L(){return date[_()+"Milliseconds"]()};var _o=function o(){return utc?0:date.getTimezoneOffset()};var _W=function W(){return getWeek(date)};var _N=function N(){return getDayOfWeek(date)};var flags={d:function d(){return _d()},dd:function dd(){return pad(_d())},ddd:function ddd(){return i18n.dayNames[D()]},DDD:function DDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:i18n.dayNames[D()],short:true})},dddd:function dddd(){return i18n.dayNames[D()+7]},DDDD:function DDDD(){return getDayName({y:y(),m:_m(),d:_d(),_:_(),dayName:i18n.dayNames[D()+7]})},m:function m(){return _m()+1},mm:function mm(){return pad(_m()+1)},mmm:function mmm(){return i18n.monthNames[_m()]},mmmm:function mmmm(){return i18n.monthNames[_m()+12]},yy:function yy(){return String(y()).slice(2)},yyyy:function yyyy(){return pad(y(),4)},h:function h(){return _H()%12||12},hh:function hh(){return pad(_H()%12||12)},H:function H(){return _H()},HH:function HH(){return pad(_H())},M:function M(){return _M()},MM:function MM(){return pad(_M())},s:function s(){return _s()},ss:function ss(){return pad(_s())},l:function l(){return pad(_L(),3)},L:function L(){return pad(Math.floor(_L()/10))},t:function t(){return _H()<12?i18n.timeNames[0]:i18n.timeNames[1]},tt:function tt(){return _H()<12?i18n.timeNames[2]:i18n.timeNames[3]},T:function T(){return _H()<12?i18n.timeNames[4]:i18n.timeNames[5]},TT:function TT(){return _H()<12?i18n.timeNames[6]:i18n.timeNames[7]},Z:function Z(){return gmt?"GMT":utc?"UTC":formatTimezone(date)},o:function o(){return(_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60)*100+Math.abs(_o())%60,4)},p:function p(){return(_o()>0?"-":"+")+pad(Math.floor(Math.abs(_o())/60),2)+":"+pad(Math.floor(Math.abs(_o())%60),2)},S:function S(){return["th","st","nd","rd"][_d()%10>3?0:(_d()%100-_d()%10!=10)*_d()%10]},W:function W(){return _W()},WW:function WW(){return pad(_W())},N:function N(){return _N()}};return mask.replace(token,function(match){if(match in flags){return flags[match]()}return match.slice(1,match.length-1)})}var masks={default:"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",paddedShortDate:"mm/dd/yyyy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"};var i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"],timeNames:["a","p","am","pm","A","P","AM","PM"]};var pad=function pad(val){var len=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2;return String(val).padStart(len,"0")};var getDayName=function getDayName(_ref){var y=_ref.y,m=_ref.m,d=_ref.d,_=_ref._,dayName=_ref.dayName,_ref$short=_ref["short"],_short=_ref$short===void 0?false:_ref$short;var today=new Date;var yesterday=new Date;yesterday.setDate(yesterday[_+"Date"]()-1);var tomorrow=new Date;tomorrow.setDate(tomorrow[_+"Date"]()+1);var today_d=function today_d(){return today[_+"Date"]()};var today_m=function today_m(){return today[_+"Month"]()};var today_y=function today_y(){return today[_+"FullYear"]()};var yesterday_d=function yesterday_d(){return yesterday[_+"Date"]()};var yesterday_m=function yesterday_m(){return yesterday[_+"Month"]()};var yesterday_y=function yesterday_y(){return yesterday[_+"FullYear"]()};var tomorrow_d=function tomorrow_d(){return tomorrow[_+"Date"]()};var tomorrow_m=function tomorrow_m(){return tomorrow[_+"Month"]()};var tomorrow_y=function tomorrow_y(){return tomorrow[_+"FullYear"]()};if(today_y()===y&&today_m()===m&&today_d()===d){return _short?"Tdy":"Today"}else if(yesterday_y()===y&&yesterday_m()===m&&yesterday_d()===d){return _short?"Ysd":"Yesterday"}else if(tomorrow_y()===y&&tomorrow_m()===m&&tomorrow_d()===d){return _short?"Tmw":"Tomorrow"}return dayName};var getWeek=function getWeek(date){var targetThursday=new Date(date.getFullYear(),date.getMonth(),date.getDate());targetThursday.setDate(targetThursday.getDate()-(targetThursday.getDay()+6)%7+3);var firstThursday=new Date(targetThursday.getFullYear(),0,4);firstThursday.setDate(firstThursday.getDate()-(firstThursday.getDay()+6)%7+3);var ds=targetThursday.getTimezoneOffset()-firstThursday.getTimezoneOffset();targetThursday.setHours(targetThursday.getHours()-ds);var weekDiff=(targetThursday-firstThursday)/(864e5*7);return 1+Math.floor(weekDiff)};var getDayOfWeek=function getDayOfWeek(date){var dow=date.getDay();if(dow===0){dow=7}return dow};var formatTimezone=function formatTimezone(date){return(String(date).match(timezone)||[""]).pop().replace(timezoneClip,"").replace(/GMT\+0000/g,"UTC")};
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/TalkTImeManagement.vue?vue&type=script&lang=js












/* harmony default export */ const TalkTImeManagementvue_type_script_lang_js = ({
  name: "TalkTImeManagement",
  components: {
    Datepicker: datepicker_esm,
    FullCalendar: main,
  },
  data() {
    return {
      isMobileApp: false,
      timeslots: [],
      isLoading: false,
      showparent: true,
      shownestedchild: false,
      allocatedavailableslots: [],
      selectedDate: "",
      selectedFormatedDate: "",
      showAppyLeaveForTheDayButton: 0,
      calendarOptions: {
        plugins: [daygrid_main, interaction_main],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        showNonCurrentDates: false,
        //   eventsSet: this.handleEvents,
        events: [],
      },
      slotid: 0,
      scheduledatetime: null,
      talkTimescheduleid: 0,
      dropdown1_List: [
        { label: "event1", value: 1 },
        { label: "event2", value: 2 },
      ],
      dropdown2_List: [
        { label: "event3", value: 3 },
        { label: "event4", value: 4 },
      ],
      ddl1SeletedItem: { label: "event1", value: 1 },
      ddl2SeletedItem: { label: "event4", value: 4 },
      coachList: [],
      reassignCoachList: [],
      coachid: 0,
      selectedCoach: {},
      columnHeader: [],
      reallocateddetails: [],
      activeTab: 1,
      CalenderViewAvailabilitySlots: [],
      reassignSelectedCoach: {},
      reassigncoachid: 0,
      ApplyLeaveStatusList: [],
      allDayReallocateddetails: [],
      shownestedchildtble: false,
      talktimereport: [],
      shownorecord: 0,
      monthList: [],
      filterMonthList: [],
      selectedMonth: {},
    };
  },

  props: {
    userPid: { type: Number, required: true, default: 0 },
    sulekhaApp: null,
    userRole: 0,
  },

  mounted: function () {
    var hdnIsMobileApp = document.getElementById("hdnIsMobileApp");
    this.populatemonth();

    //   const d = new Date();
    //   let premonth=d.getMonth();
    //   let month = d.getMonth() + 1;
    //  let selcurrentmonth=this.monthList[month]
    //  this.selectedMonth = selcurrentmonth;
    //  var selpreviousmonth=this.monthList[premonth]
    // let fmonthlist=[];
    //       fmonthlist.push(selpreviousmonth)
    //       fmonthlist.push(selcurrentmonth)
    // this.filterMonthList=fmonthlist;

    if (hdnIsMobileApp) {
      if (hdnIsMobileApp.value == "true") {
        this.isMobileApp = true;
      } else {
        this.isMobileApp = false;
      }
    }
    // assign props to vue componets state value
    //this.timeslots = this.availableSlots;

    if (this.userRole == 1) {
      // admin

      this.FetchCoahList();
    } else if (this.userRole == 2) {
      // Coach
      this.coachid = this.userPid;
      //  this.FetchCoachTalkTimeAvailabilitySlot();
      this.FetchModeratorCalenderViewSlotAvailability();
    }
  },
  methods: {
    populatemonth() {
      // var Months = [
      //   { month: "February", monthid: 2, year: 2023 },
      //   { month: "March", monthid: 3, year: 2023 },
      //   { month: "April", monthid: 4, year: 2023 },
      //   { month: "May", monthid: 5, year: 2023 },
      //   { month: "June", monthid: 6, year: 2023 },
      //   { month: "July", monthid: 7, year: 2023 },
      //   { month: "August", monthid: 8, year: 2023 },
      //   { month: "September", monthid: 9, year: 2023 },
      //   { month: "October", monthid: 10, year: 2023 },
      //   { month: "November", monthid: 11, year: 2023 },
      //   { month: "December", monthid: 12, year: 2023 },
      // ];

      let currentmonth = new Date();
      let previousmonth = new Date();
      previousmonth = new Date(previousmonth.setMonth(previousmonth.getMonth()-1));

      var currentmonthname = currentmonth.toLocaleString("default", {
        month: "long",
      });
      var previousmonthname = previousmonth.toLocaleString("default", {
        month: "long",
      });

      let currentmonthyear = currentmonth.getFullYear();
      let previousmonthyear = previousmonth.getFullYear();

      // alert(currentmonth + "" + previousmonth);
      // alert(currentmonthname + "" + previousmonthname);
      // alert(currentmonthyear + "" + previousmonthyear);

      let Months = [];
      if (previousmonth.getMonth() + 1 == 1 && previousmonthyear == 2023) {
        Months.push({
          month: currentmonthname + "-" + currentmonthyear,
          monthid: currentmonth.getMonth() + 1,
          year: currentmonthyear,
        });
        this.selectedMonth = Months[0];
      } else {
        Months.push({
          month: previousmonthname + "-" + previousmonthyear,
          monthid: previousmonth.getMonth() + 1,
          year: previousmonthyear,
        });
        Months.push({
          month: currentmonthname + "-" + currentmonthyear,
          monthid: currentmonth.getMonth() + 1,
          year: currentmonthyear,
        });
        this.selectedMonth = Months[1];
      }

      //   let premonth=d.getMonth();
      //   let month = d.getMonth() + 1;
      //  let selcurrentmonth=this.monthList[month]
      //  this.selectedMonth = selcurrentmonth;
      //  var selpreviousmonth=this.monthList[premonth]

      this.monthList = Months;
    },
    displayMarkAsHolidayCofirmDialog() {
      document.getElementById("dialogMarkAsHoliday").classList.remove("hide");
    },
    cancelDialogMarkAsHoliday() {
      document.getElementById("dialogMarkAsHoliday").classList.add("hide");
    },

    confirmDialogMarkAsHoliday() {
      this.ApplyLeaveForTheDay();
    },

    displayMarkAsNACofirmDialog(slotid, scheduledatetime, talkTimescheduleid) {
      document.getElementById("dialogMarkAsNA").classList.remove("hide");
      this.slotid = slotid;
      this.scheduledatetime = scheduledatetime;
      this.talkTimescheduleid = talkTimescheduleid;
    },
    cancelDialogMarkAsNA() {
      document.getElementById("dialogMarkAsNA").classList.add("hide");
    },

    confirmDialogMarkAsNA() {
      this.updateLeave(
        this.slotid,
        this.scheduledatetime,
        this.talkTimescheduleid
      );
    },

    displayMarkAsAvaiableCofirmDialog(
      slotid,
      scheduledatetime,
      talkTimescheduleid
    ) {
      document.getElementById("dialogMarkAsAvailable").classList.remove("hide");
      this.slotid = slotid;
      this.scheduledatetime = scheduledatetime;
      this.talkTimescheduleid = talkTimescheduleid;
    },

    cancelDialogMarkAsAvailable() {
      document.getElementById("dialogMarkAsAvailable").classList.add("hide");
    },

    confirmDialogMarkAsAvailable() {
      this.cancelLeave(
        this.slotid,
        this.scheduledatetime,
        this.talkTimescheduleid
      );
    },

    confirmDialogMonthlyView() {
      document.getElementById("dialogMonthlyView").classList.add("hide");
    },

    confirmDialogMonthlyListedView() {
      document
        .getElementById("dialogMonthlyUpdatedListView")
        .classList.add("hide");
    },

    //  cancelDialogMarkAsHoliday()
    //    {

    //    },
    NavigetToTab(tab) {
      if (tab == "UpdateAvail") {
        this.activeTab = 2;
        this.FetchCoachTalkTimeAvailabilitySlot();
        document.getElementById("atagAvailability").classList.add("active");
        document.getElementById("divAvailability").classList.add("active");

        document.getElementById("atagCalenderView").classList.remove("active");
        document.getElementById("divCalenderView").classList.remove("active");
        document.getElementById("atagttreport").classList.remove("active");
        document.getElementById("divttreport").classList.remove("active");
      } else if (tab == "CalenderView") {
        this.activeTab = 1;
        this.FetchModeratorCalenderViewSlotAvailability();

        document.getElementById("atagCalenderView").classList.add("active");
        document.getElementById("divCalenderView").classList.add("active");

        document.getElementById("atagAvailability").classList.remove("active");
        document.getElementById("divAvailability").classList.remove("active");
        document.getElementById("atagttreport").classList.remove("active");
        document.getElementById("divttreport").classList.remove("active");
      } else if (tab == "TalktimeReport") {
        this.activeTab = 3;
        this.FetchTalktimeReport();

        document.getElementById("atagttreport").classList.add("active");
        document.getElementById("divttreport").classList.add("active");

        document.getElementById("atagAvailability").classList.remove("active");
        document.getElementById("divAvailability").classList.remove("active");
        document.getElementById("atagCalenderView").classList.remove("active");
        document.getElementById("divCalenderView").classList.remove("active");
      }
    },
    FetchCoachTalkTimeAvailabilitySlot() {
      CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachTalkTimeSlotAvailability.execute(
        { UserPid: this.userPid, CoachUserPid: this.coachid },
        (response) => {
          this.timeslots = response.data;
        }
      );
    },

    FetchTalktimeReport() {
      this.shownorecord = 0;
      CSMainAPIs.Capshine.TalktimeAPIs.FetchTalktimeReport.execute(
        {
          UserPid: this.coachid,
          sessiontypeid: 2,
          monthid: this.selectedMonth.monthid,
          year: this.selectedMonth.year,
        },
        (response) => {
          this.talktimereport = response.data;
          this.shownorecord = 1;
        }
      );
    },

    FetchModeratorCalenderViewSlotAvailability() {
      this.calendarOptions.events = [];
      var clendereventlist = [];
      var rowindex = 1;
      var eventcolore = "#bfbfbf";
      var bgrndcolor = " #bfbfbf";
      CSMainAPIs.Capshine.TalktimeAPIs.FetchModeratorAvailability.execute(
        { coachUserPid: this.coachid },
        (response) => {
          this.CalenderViewAvailabilitySlots = response.data;

          this.CalenderViewAvailabilitySlots.forEach((resobj) => {
            ///	availableCount	allocatedCount	CoachUserPid
            var Title =
              resobj.availableCount +
              " Slots" +
              "," +
              resobj.allocatedCount +
              " Booked";
            console.log(Title);
            clendereventlist.push({
              id: rowindex,
              title: Title,
              borderColor: eventcolore,
              // backgroundColor:"#FFFFFF",
              extendedProps: {
                availableDate: resobj.availableDate,
                coachUserPid: resobj.coachUserPid,
              },
              date: dateFormat(resobj.availableDate, "yyyy-mm-dd"),
              textColor: "#333",
              color: bgrndcolor,
              allDaySlot: false,
            });
          });

          this.calendarOptions.events = clendereventlist;

          setTimeout(() => {
            var divScroolElement = document.getElementsByClassName(
              "fc-scroller-liquid-absolute"
            )[0];
            var divCalenderContainer = document.getElementById(
              "divCalenderContainer"
            );
            var divStickyTab = document.getElementById("divStickyTab");

            if (divStickyTab) {
              divStickyTab.style.position = "inherit";
            }

            if (divScroolElement) {
              divScroolElement.style.overflow = "";
            }

            if (divCalenderContainer) {
              divCalenderContainer.style.overflow = "auto";
              // divCalenderContainer.style.height = "800px";
            }
          }, 500);
        }
      );
    },

    FetchCoahList() {
      CSMainAPIs.Capshine.TalktimeAPIs.FetchCoahList.execute(
        { UserPid: this.userPid },
        (response) => {
          this.coachList = response.data;
          this.selectedCoach = this.coachList[0];
          this.coachid = this.selectedCoach.coachid;

          if (this.activeTab == 2) {
            this.FetchCoachTalkTimeAvailabilitySlot();
          }
          if (this.activeTab == 1) {
            this.FetchModeratorCalenderViewSlotAvailability();
          }
          if (this.activeTab == 3) {
            this.FetchTalktimeReport();
          }
        }
      );
    },
    FetchReAssignCoachList(ScheduledId) {
      ///reassignCoachList

      CSMainAPIs.Capshine.TalktimeAPIs.FetchCoahList.execute(
        { UserPid: this.coachid, ScheduledId: ScheduledId },
        (response) => {
          this.shownestedchild = true;
          this.reassignCoachList = response.data;
          this.reassignSelectedCoach = this.reassignCoachList[0];
          this.reassigncoachid = this.reassignSelectedCoach.coachid;
        }
      );
    },

    onCoachChange(index) {
      this.reallocateddetails = [];
      //this.selectedCoach=this.coachList[index];
      this.coachid = this.selectedCoach.coachid;
      // this.FetchCoachTalkTimeAvailabilitySlot();
      if (this.activeTab == 2) {
        this.FetchCoachTalkTimeAvailabilitySlot();
      }
      if (this.activeTab == 1) {
        this.FetchModeratorCalenderViewSlotAvailability();
      }
      if (this.activeTab == 3) {
        this.FetchTalktimeReport();
      }
    },

    onMonthChange(index) {
      if (this.activeTab == 3) {
        this.FetchTalktimeReport();
      }
    },

    onReassignCoachChange(index) {
      //this.selectedCoach=this.coachList[index];
      this.reassigncoachid = this.reassignSelectedCoach.coachid;
      // this.FetchCoachTalkTimeAvailabilitySlot();
    },

    // handleDateClick: function (arg) {
    //   alert("date click! " + arg.dateStr);
    // },
    selectiddl2(obj) {
      this.onselectioncallback(obj);
    },
    selectiddl1(obj) {
      this.onselectioncallback(obj);
    },
    check(rowindex, day) {
      if (day == 1) {
        this.timeslots[rowindex].isSundayChecked =
          !this.timeslots[rowindex].isSundayChecked;
      }
      if (day == 2) {
        this.timeslots[rowindex].isMondayChecked =
          !this.timeslots[rowindex].isMondayChecked;
      }
      if (day == 3) {
        this.timeslots[rowindex].isTuesdayChecked =
          !this.timeslots[rowindex].isTuesdayChecked;
      }
      if (day == 4) {
        this.timeslots[rowindex].isWednesdayChecked =
          !this.timeslots[rowindex].isWednesdayChecked;
      }
      if (day == 5) {
        this.timeslots[rowindex].isThursdayChecked =
          !this.timeslots[rowindex].isThursdayChecked;
      }
      if (day == 6) {
        this.timeslots[rowindex].isFridayChecked =
          !this.timeslots[rowindex].isFridayChecked;
      }
      if (day == 7) {
        this.timeslots[rowindex].isSaturdayChecked =
          !this.timeslots[rowindex].isSaturdayChecked;
      }
    },
    updateTimeSlots() {
      this.isLoading = true;
      this.reallocateddetails = [];
      CSMainAPIs.Capshine.TalktimeAPIs.UpdateCoachAvailablity.execute(
        this.timeslots,
        (response) => {
          this.isLoading = false;
          console.log(response);
          this.reallocateddetails = response.data;

          if (this.reallocateddetails.length > 0) {
            document
              .getElementById("dialogMonthlyUpdatedListView")
              .classList.remove("hide");
          } else {
            document
              .getElementById("dialogMonthlyView")
              .classList.remove("hide");
          }

          ///  alert("Has been updated");
        }
      );
    },
    handleDateSelect(selectInfo) {},
    handleEventClick(clickInfo) {
      console.log(clickInfo.event.startStr);
      this.fetchAailableslotforselcteday(clickInfo.event.startStr);
      // alert("handleEventClick click! " + clickInfo.event.startStr);
    },
    handleDateClick: function (arg) {
      ///    alert("handleDateClick click! " + arg.dateStr);
      this.fetchAailableslotforselcteday(arg.dateStr);
    },
    handleEvents(events) {},

    fetchAailableslotforselcteday(dateStr) {
      var now = new Date(dateStr);

      var nextmonth = new Date();

      nextmonth.setMonth(nextmonth.getMonth() + 1);
      debugger;
      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      nextmonth.setHours(0, 0, 0, 0);

      //  alert(currentDate.setHours(0,0,0,0));
      //  alert(now.setHours(0,0,0,0));
      if (now < currentDate) {
        alert("You can update schedule for current & next month only");
      } else if (now > nextmonth) {
        alert("You can update schedule for current & next month only");
      } else {
        this.selectedDate = dateStr;
        this.selectedFormatedDate = dateFormat(now, "dddd, mmmm dS, yyyy");
        CSMainAPIs.Capshine.TalktimeAPIs.FetchModeratorAvailabilityAllocatedList.execute(
          { ScheduleDate: dateStr, CoachUserPid: this.coachid },
          (response) => {
            this.allocatedavailableslots = response.data;
            this.showparent = false;
            if (this.allocatedavailableslots.length > 0) {
              this.showAppyLeaveForTheDayButton =
                this.allocatedavailableslots[0].showAppyLeaveForTheDayButton;
            }
          }
        );
      }
    },
    close() {
      this.showparent = true;
      this.FetchModeratorCalenderViewSlotAvailability();
    },
    closenestedchild() {
      this.shownestedchild = false;
      this.showparent = true;
      this.FetchModeratorCalenderViewSlotAvailability();
    },

    closenestedchildtble() {
      this.shownestedchild = false;
      this.shownestedchildtble = false;
      this.showparent = true;
      this.FetchModeratorCalenderViewSlotAvailability();
    },

    updateLeave(SlotId, ScheduleDate, talkTimescheduleid) {
      this.talkTimescheduleid = talkTimescheduleid;
      //this.coachid
      /// this.userPid
      //int CoachUserPid, int SlotId, int UserPid, string ScheduleDate

      CSMainAPIs.Capshine.TalktimeAPIs.UpdateModuraterLeave.execute(
        {
          ScheduleDate: ScheduleDate,
          CoachUserPid: this.coachid,
          UserPid: this.userPid,
          SlotId: SlotId,
          Mode: "Update",
        },
        (response) => {
          var res = response.data;

          // if (this.userRole == 1) {
          //   this.FetchReAssignCoachList(talkTimescheduleid);
          // }

          this.cancelDialogMarkAsNA();

          if (res[0].nextuserpid == -1) {
            // alert("Leave Updated for corresponding slot");
            this.fetchAailableslotforselcteday(this.selectedDate);
          } else {
            if (res[0].nextuserpid == 0) {
              if (this.userRole == 1) {
                this.FetchReAssignCoachList(talkTimescheduleid);
                //this.shownestedchild=true;
              } else {
                // if coach
                if (this.userRole == 2) {
                  alert(
                    "Unable to allocate the session to another coach. Please check with Admin."
                  );
                }
              }
            } else {
              // if admin
              if (this.userRole == 1) {
                alert("Slot Rescheduled to " + res[0].nextusername);
                this.fetchAailableslotforselcteday(this.selectedDate);
              }
            }
          }
          // this.allocatedavailableslots = response.data;
          // this.showparent = false;
        }
      );
    },

    cancelLeave(SlotId, ScheduleDate, talkTimescheduleid) {
      this.talkTimescheduleid = talkTimescheduleid;
      //this.coachid
      /// this.userPid
      //int CoachUserPid, int SlotId, int UserPid, string ScheduleDate

      CSMainAPIs.Capshine.TalktimeAPIs.UpdateModuraterLeave.execute(
        {
          ScheduleDate: ScheduleDate,
          CoachUserPid: this.coachid,
          UserPid: this.userPid,
          SlotId: SlotId,
          Mode: "Cancel",
        },
        (response) => {
          var res = response.data;
          this.fetchAailableslotforselcteday(this.selectedDate);
          this.cancelDialogMarkAsAvailable();

          // this.allocatedavailableslots = response.data;
          // this.showparent = false;
        }
      );
    },
    ReScheduleModerator() {
      // this.talkTimescheduleid ,this.coachid ,this.userPid,this.reassigncoachid
      //  int CoachUserPid, int ScheduledId, int UserPid, int NextUserPid
      this.isLoading = true;
      CSMainAPIs.Capshine.TalktimeAPIs.ReScheduleModerator.execute(
        {
          CoachUserPid: this.coachid,
          ScheduledId: this.talkTimescheduleid,
          UserPid: this.userPid,
          NextUserPid: this.reassigncoachid,
        },
        (response) => {
          this.isLoading = false;
          var res = response.data;

          if (res.status == "1") {
            alert("Updated");
            this.fetchAailableslotforselcteday(this.selectedDate);
          } else {
            alert("Unable to update");
          }
        }
      );
    },

    FetchLaunchURL(talkTimescheduleid) {
      // this.talkTimescheduleid ,this.coachid ,this.userPid,this.reassigncoachid
      //  int CoachUserPid, int ScheduledId, int UserPid, int NextUserPid

      CSMainAPIs.Capshine.TalktimeAPIs.getTalkTimeLaunchURL.execute(
        {
          CoachUserPid: this.coachid,
          ScheduledId: talkTimescheduleid,
        },
        (response) => {
          var res = response.data;
          if (res.status == 1) {
            this.close();
            window.open(res.meetingUrl, "_blank");
          } else {
            alert(res.status);
          }
        }
      );
    },

    ApplyLeaveForTheDay() {
      this.coachid, this.userPid;

      CSMainAPIs.Capshine.TalktimeAPIs.ApplyModeratorLeaveForAllDay.execute(
        {
          ScheduleDate: this.selectedDate,
          CoachUserPid: this.coachid,
          UserPid: this.userPid,
        },
        (response) => {
          //  var res = response.data;
          this.allDayReallocateddetails = response.data;
          this.shownestedchildtble = true;

          this.cancelDialogMarkAsHoliday();
        }
      );
    },
    getSessionNotAllocatedStatus(obj) {
      var curreentDatetime = new Date(); //Today Date

      curreentDatetime.setMinutes(curreentDatetime.getMinutes() + 16);

      if (
        (obj.issessioncompleted == 1 || obj.issessioncompleted == 1) &&
        obj.issessioncompleted.scheduledatetime < curreentDatetime &&
        obj.talkTimescheduleid == 0 &&
        obj.isleaveupdated == 0
      ) {
        return true;
      } else return false;
    },
    getPPTURL(topicId) {
      var url =
        "https://view.officeapps.live.com/op/view.aspx?src=https://sulcdn.azureedge.net/capshine-core/talktimedocs/" +
        topicId +
        ".pptx?src=" +
        Math.floor(1000 + Math.random() * 9000);
      return url;
    },
  },
});

;// CONCATENATED MODULE: ./src/Components/TalkTImeManagement.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/TalkTImeManagement.vue




;
const TalkTImeManagement_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TalkTImeManagementvue_type_script_lang_js, [['render',TalkTImeManagementvue_type_template_id_dc4787dc_render]])

/* harmony default export */ const TalkTImeManagement = (TalkTImeManagement_exports_);
;// CONCATENATED MODULE: ./src/js/TalkTimeManagementToolScript.js




let TalkTimeManagementToolScript = {
	userPid: 0,
	activityTypes: [],
	sulekhaApp: null,
	userRole:0,
	init: function (userPid, sulekhaApp = null) {
		this.sulekhaApp = sulekhaApp;
		TalkTimeManagementToolScript.userPid = userPid;
		var page=document.getElementById('divAdminpage');

		if (page) {
			TalkTimeManagementToolScript.userRole=page.getAttribute("data-userrole");

			TalkTimeManagementToolScript.bindComponent();
			//  if(TalkTimeManagementToolScript.userRole==1) // admin 
			//  {
			// 	TalkTimeManagementToolScript.FetchCoahList()
			//  }
			//  else if (TalkTimeManagementToolScript.userRole==2){ // Coach
			// 	if (TalkTimeManagementToolScript.userPid)
			// 	{	
			// 		TalkTimeManagementToolScript.FetchCoachTalkTimeAvailabilitySlot();
			// 	}
			//  }
		}
		

		
	},

	FetchCoahList(){
		CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachList.execute({ "UserPid": TalkTimeManagementToolScript.userPid }, TalkTimeManagementToolScript.apiCoachApiCallBackResponse);
	},

	apiCoachApiCallBackResponse:function(response){
		if (document.getElementById('divMiniTalkTimeAdmin')) {
			const props = {
			     userRole:TalkTimeManagementToolScript.userRole,
			     userPid: TalkTimeManagementToolScript.userPid,
				 sulekhaApp:TalkTimeManagementToolScript.sulekhaApp
				// coachList: response.data
			};
			const createResponseVue = (0,vue_cjs.createApp)(TalkTImeManagement, props);
			createResponseVue.mount('#divMiniTalkTimeAdmin');

		}
	},

 FetchCoachTalkTimeAvailabilitySlot(){
	CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachTalkTimeSlotAvailability.execute({ "UserPid": TalkTimeManagementToolScript.userPid }, TalkTimeManagementToolScript.bindComponent);
   },

	bindComponent: function (response) {


		if (document.getElementById('divMiniTalkTimeAdmin')) {
			// const props = {
			//      userPid: TalkTimeManagementToolScript.userPid,
			// 	 sulekhaApp:TalkTimeManagementToolScript.sulekhaApp,
			// 	 availableSlots: response.data
			// };
			// const createResponseVue = createApp(TalkTImeManagement, props);
			// createResponseVue.mount('#divMiniTalkTimeAdmin');

			const props = {
				userRole:TalkTimeManagementToolScript.userRole,
				userPid: TalkTimeManagementToolScript.userPid,
				sulekhaApp:TalkTimeManagementToolScript.sulekhaApp
			   // coachList: response.data
		   };
		   const createResponseVue = (0,vue_cjs.createApp)(TalkTImeManagement, props);
		   createResponseVue.mount('#divMiniTalkTimeAdmin');

		}
	},
	ShowHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}
	},
}
/* harmony default export */ const js_TalkTimeManagementToolScript = (TalkTimeManagementToolScript);
// EXTERNAL MODULE: ./src/js/HLSJS/hls.js
var HLSJS_hls = __webpack_require__(629);
var hls_default = /*#__PURE__*/__webpack_require__.n(HLSJS_hls);
;// CONCATENATED MODULE: ./node_modules/iphone-inline-video/dist/iphone-inline-video.es-modules.js
/*! npm.im/iphone-inline-video 2.2.2 */


function preventEvent(element, eventName, test) {
	function handler(e) {
		if (!test || test(element, eventName)) {
			e.stopImmediatePropagation();
			// // console.log(eventName, 'prevented on', element);
		}
	}
	element.addEventListener(eventName, handler);

	// Return handler to allow to disable the prevention. Usage:
	// const preventionHandler = preventEvent(el, 'click');
	// el.removeEventHandler('click', preventionHandler);
	return handler;
}

function proxyProperty(object, propertyName, sourceObject, copyFirst) {
	function get() {
		return sourceObject[propertyName];
	}
	function set(value) {
		sourceObject[propertyName] = value;
	}

	if (copyFirst) {
		set(object[propertyName]);
	}

	Object.defineProperty(object, propertyName, {get: get, set: set});
}

function proxyEvent(object, eventName, sourceObject) {
	sourceObject.addEventListener(eventName, function () { return object.dispatchEvent(new Event(eventName)); });
}

function dispatchEventAsync(element, type) {
	Promise.resolve().then(function () {
		element.dispatchEvent(new Event(type));
	});
}

var iOS8or9 = typeof document === 'object' && 'object-fit' in document.head.style && !matchMedia('(-webkit-video-playable-inline)').matches;

var IIV = 'bfred-it:iphone-inline-video';
var IIVEvent = 'bfred-it:iphone-inline-video:event';
var IIVPlay = 'bfred-it:iphone-inline-video:nativeplay';
var IIVPause = 'bfred-it:iphone-inline-video:nativepause';

/**
 * UTILS
 */

function getAudioFromVideo(video) {
	var audio = new Audio();
	proxyEvent(video, 'play', audio);
	proxyEvent(video, 'playing', audio);
	proxyEvent(video, 'pause', audio);
	audio.crossOrigin = video.crossOrigin;

	// 'data:' causes audio.networkState > 0
	// which then allows to keep <audio> in a resumable playing state
	// i.e. once you set a real src it will keep playing if it was if .play() was called
	audio.src = video.src || video.currentSrc || 'data:';

	// // if (audio.src === 'data:') {
	//   TODO: wait for video to be selected
	// // }
	return audio;
}

var lastRequests = (/* unused pure expression or super */ null && ([]));
var requestIndex = 0;
var lastTimeupdateEvent;

function setTime(video, time, rememberOnly) {
	// Allow one timeupdate event every 200+ ms
	if ((lastTimeupdateEvent || 0) + 200 < Date.now()) {
		video[IIVEvent] = true;
		lastTimeupdateEvent = Date.now();
	}
	if (!rememberOnly) {
		video.currentTime = time;
	}
	lastRequests[++requestIndex % 3] = time * 100 | 0 / 100;
}

function isPlayerEnded(player) {
	return player.driver.currentTime >= player.video.duration;
}

function update(timeDiff) {
	var player = this;
	// // console.log('update', player.video.readyState, player.video.networkState, player.driver.readyState, player.driver.networkState, player.driver.paused);
	if (player.video.readyState >= player.video.HAVE_FUTURE_DATA) {
		if (!player.hasAudio) {
			player.driver.currentTime = player.video.currentTime + ((timeDiff * player.video.playbackRate) / 1000);
			if (player.video.loop && isPlayerEnded(player)) {
				player.driver.currentTime = 0;
			}
		}
		setTime(player.video, player.driver.currentTime);
	} else if (player.video.networkState === player.video.NETWORK_IDLE && player.video.buffered.length === 0) {
		// This should happen when the source is available but:
		// - it's potentially playing (.paused === false)
		// - it's not ready to play
		// - it's not loading
		// If it hasAudio, that will be loaded in the 'emptied' handler below
		player.video.load();
		// // console.log('Will load');
	}

	// // console.assert(player.video.currentTime === player.driver.currentTime, 'Video not updating!');

	if (player.video.ended) {
		delete player.video[IIVEvent]; // Allow timeupdate event
		player.video.pause(true);
	}
}

/**
 * METHODS
 */

function play() {
	// // console.log('play');
	var video = this;
	var player = video[IIV];

	// If it's fullscreen, use the native player
	if (video.webkitDisplayingFullscreen) {
		video[IIVPlay]();
		return;
	}

	if (player.driver.src !== 'data:' && player.driver.src !== video.src) {
		// // console.log('src changed on play', video.src);
		setTime(video, 0, true);
		player.driver.src = video.src;
	}

	if (!video.paused) {
		return;
	}
	player.paused = false;

	if (video.buffered.length === 0) {
		// .load() causes the emptied event
		// the alternative is .play()+.pause() but that triggers play/pause events, even worse
		// possibly the alternative is preventing this event only once
		video.load();
	}

	player.driver.play();
	player.updater.start();

	if (!player.hasAudio) {
		dispatchEventAsync(video, 'play');
		if (player.video.readyState >= player.video.HAVE_ENOUGH_DATA) {
			// // console.log('onplay');
			dispatchEventAsync(video, 'playing');
		}
	}
}
function pause(forceEvents) {
	// // console.log('pause');
	var video = this;
	var player = video[IIV];

	player.driver.pause();
	player.updater.stop();

	// If it's fullscreen, the developer the native player.pause()
	// This is at the end of pause() because it also
	// needs to make sure that the simulation is paused
	if (video.webkitDisplayingFullscreen) {
		video[IIVPause]();
	}

	if (player.paused && !forceEvents) {
		return;
	}

	player.paused = true;
	if (!player.hasAudio) {
		dispatchEventAsync(video, 'pause');
	}

	// Handle the 'ended' event only if it's not fullscreen
	if (video.ended && !video.webkitDisplayingFullscreen) {
		video[IIVEvent] = true;
		dispatchEventAsync(video, 'ended');
	}
}

/**
 * SETUP
 */

function addPlayer(video, hasAudio) {
	var player = {};
	video[IIV] = player;
	player.paused = true; // Track whether 'pause' events have been fired
	player.hasAudio = hasAudio;
	player.video = video;
	player.updater = frameIntervalometer(update.bind(player));

	if (hasAudio) {
		player.driver = getAudioFromVideo(video);
	} else {
		video.addEventListener('canplay', function () {
			if (!video.paused) {
				// // console.log('oncanplay');
				dispatchEventAsync(video, 'playing');
			}
		});
		player.driver = {
			src: video.src || video.currentSrc || 'data:',
			muted: true,
			paused: true,
			pause: function () {
				player.driver.paused = true;
			},
			play: function () {
				player.driver.paused = false;
				// Media automatically goes to 0 if .play() is called when it's done
				if (isPlayerEnded(player)) {
					setTime(video, 0);
				}
			},
			get ended() {
				return isPlayerEnded(player);
			}
		};
	}

	// .load() causes the emptied event
	video.addEventListener('emptied', function () {
		// // console.log('driver src is', player.driver.src);
		var wasEmpty = !player.driver.src || player.driver.src === 'data:';
		if (player.driver.src && player.driver.src !== video.src) {
			// // console.log('src changed to', video.src);
			setTime(video, 0, true);
			player.driver.src = video.src;
			// Playing videos will only keep playing if no src was present when .play()’ed
			if (wasEmpty || (!hasAudio && video.autoplay)) {
				player.driver.play();
			} else {
				player.updater.stop();
			}
		}
	}, false);

	// Stop programmatic player when OS takes over
	video.addEventListener('webkitbeginfullscreen', function () {
		if (!video.paused) {
			// Make sure that the <audio> and the syncer/updater are stopped
			video.pause();

			// Play video natively
			video[IIVPlay]();
		} else if (hasAudio && player.driver.buffered.length === 0) {
			// If the first play is native,
			// the <audio> needs to be buffered manually
			// so when the fullscreen ends, it can be set to the same current time
			player.driver.load();
		}
	});
	if (hasAudio) {
		video.addEventListener('webkitendfullscreen', function () {
			// Sync audio to new video position
			player.driver.currentTime = video.currentTime;
			// // console.assert(player.driver.currentTime === video.currentTime, 'Audio not synced');
		});

		// Allow seeking
		video.addEventListener('seeking', function () {
			if (lastRequests.indexOf(video.currentTime * 100 | 0 / 100) < 0) {
				// // console.log('User-requested seeking');
				player.driver.currentTime = video.currentTime;
			}
		});
	}
}

function preventWithPropOrFullscreen(el) {
	var isAllowed = el[IIVEvent];
	delete el[IIVEvent];
	return !el.webkitDisplayingFullscreen && !isAllowed;
}

function overloadAPI(video) {
	var player = video[IIV];
	video[IIVPlay] = video.play;
	video[IIVPause] = video.pause;
	video.play = play;
	video.pause = pause;
	proxyProperty(video, 'paused', player.driver);
	proxyProperty(video, 'muted', player.driver, true);
	proxyProperty(video, 'playbackRate', player.driver, true);
	proxyProperty(video, 'ended', player.driver);
	proxyProperty(video, 'loop', player.driver, true);

	// IIV works by seeking 60 times per second.
	// These events are now useless.
	preventEvent(video, 'seeking', function (el) { return !el.webkitDisplayingFullscreen; });
	preventEvent(video, 'seeked', function (el) { return !el.webkitDisplayingFullscreen; });

	// Limit timeupdate events
	preventEvent(video, 'timeupdate', preventWithPropOrFullscreen);

	// Prevent occasional native ended events
	preventEvent(video, 'ended', preventWithPropOrFullscreen);
}

function enableInlineVideo(video, opts) {
	if ( opts === void 0 ) opts = {};

	// Stop if already enabled
	if (video[IIV]) {
		return;
	}

	// Allow the user to skip detection
	if (!opts.everywhere) {
		// Only iOS8 and 9 are supported
		if (!iOS8or9) {
			return;
		}

		// Stop if it's not an allowed device
		if (!(opts.iPad || opts.ipad ? /iPhone|iPod|iPad/ : /iPhone|iPod/).test(navigator.userAgent)) {
			return;
		}
	}

	// Try to pause
	video.pause();

	// Prevent autoplay.
	// An non-started autoplaying video can't be .pause()'d
	var willAutoplay = video.autoplay;
	video.autoplay = false;

	addPlayer(video, !video.muted);
	overloadAPI(video);
	video.classList.add('IIV');

	// Autoplay
	if (video.muted && willAutoplay) {
		video.play();
		video.addEventListener('playing', function restoreAutoplay() {
			video.autoplay = true;
			video.removeEventListener('playing', restoreAutoplay);
		});
	}

	if (!/iPhone|iPod|iPad/.test(navigator.platform)) {
		console.warn('iphone-inline-video is not guaranteed to work in emulated environments');
	}
}

/* harmony default export */ const iphone_inline_video_es_modules = ((/* unused pure expression or super */ null && (enableInlineVideo)));

;// CONCATENATED MODULE: ./src/js/WatchShortVideoHLSPlayerScript.js








// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'

// import router from "./routerconfig"
var WatchShortVideoHLSPlayerScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 1,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    init: function (userpid, sulekhaApp = null) {
        // remove touch events 
        //  alert(5)


        var myOptions = {
            "nativeControlsForTouch": false,
            autoplay: true,
            controls: true,
            "width": "100%",
            "height": "auto",
            "logo": { enabled: false }          
        };
        var myPlayer = amp("azuremediaplayer", myOptions);
        myPlayer.src([{ src: "https://capshine-usea.streaming.media.azure.net/0531efe7-ddaa-41bb-afd6-9f3ee47f56f6/a-vs-an_english.ism/manifest", type: "application/vnd.ms-sstr+xml" }, ]);





return 
        // video js 
        var video = document.getElementById('video');
        var videosource = document.getElementById('videosource');
        
        var playbutton = document.getElementById('testbutton');

        var videoSrc = 'https://capshine-usea.streaming.media.azure.net/9ea3bdcd-38a8-4179-878b-1925f0bfad31/30_8_English.ism/manifest';


        var overrideNative = false;
     ///   videosource.src = videoSrc;
        var player = videojs(video, {
          html5: {
            hls: {
              overrideNative: overrideNative
            },
            nativeVideoTracks: !overrideNative,
            nativeAudioTracks: !overrideNative,
            nativeTextTracks: !overrideNative
          }
        });
        player.play();

        return ;

        playbutton.addEventListener('click', event => {
            //  video.muted=false;
            //  alert('clicked')
        })



    
       // if (Hls.isSupported()) {
            var hls = new (hls_default())();
            hls.loadSource(videoSrc);
            hls.attachMedia(video);

            hls.on((hls_default()).Events.MEDIA_ATTACHED, function () {
                WatchShortVideoHLSPlayerScript.toggleControls(video);
                setTimeout(() => {
                    // playbutton.click();         
                }, 5000)
         


            });

      


        //}
        // HLS.js is not supported on platforms that do not have Media Source
        // Extensions (MSE) enabled.
        //
        // When the browser has built-in HLS support (check using `canPlayType`),
        // we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
        // element through the `src` property. This is using the built-in support
        // of the plain video element, without using HLS.js.
        //
        // Note: it would be more normal to wait on the 'canplay' event below however
        // on Safari (where you are most likely to find built-in HLS support) the
        // video.src URL must be on the user-driven white-list before a 'canplay'
        // event will be emitted; the last video event that can be reliably
        // listened-for when the URL is not on the white-list is 'loadedmetadata'.
        // else if (video.canPlayType('application/vnd.apple.mpegurl')) {

        //     video.src = videoSrc;

        //     video.addEventListener('loadedmetadata', function () {
        //         video.play();
        //     });

           


        // }



    },
    toggleControls(video) {
        if (video.hasAttribute("controls")) {
            video.removeAttribute("controls")
        }
        else {
            video.setAttribute("controls", "controls")
        }
    }
}

/* harmony default export */ const js_WatchShortVideoHLSPlayerScript = (WatchShortVideoHLSPlayerScript);
// EXTERNAL MODULE: ./src/js/DashJS/dash.all.min.js
var dash_all_min = __webpack_require__(46);
// EXTERNAL MODULE: ./src/js/DashJS/dash.mss.min.js
var dash_mss_min = __webpack_require__(343);
;// CONCATENATED MODULE: ./node_modules/seamless-scroll-polyfill/lib/common.js
const checkBehavior = (behavior) => {
    return behavior === undefined || behavior === "auto" || behavior === "instant" || behavior === "smooth";
};
function elementScrollXY(x, y) {
    this.scrollLeft = x;
    this.scrollTop = y;
}
const failedExecute = (method, object, reason = "cannot convert to dictionary.") => `Failed to execute '${method}' on '${object}': ${reason}`;
const failedExecuteInvalidEnumValue = (method, object, value) => failedExecute(method, object, `The provided value '${value}' is not a valid enum value of type ScrollBehavior.`);
/* eslint-disable */
const backupMethod = (proto, method, fallback) => {
    var _a;
    const backup = `__SEAMLESS.BACKUP$${method}`;
    if (!proto[backup] && proto[method] && !((_a = proto[method]) === null || _a === void 0 ? void 0 : _a.__isPolyfill)) {
        proto[backup] = proto[method];
    }
    return proto[backup] || fallback;
};
/* eslint-enable */
const common_isObject = (value) => {
    const type = typeof value;
    return value !== null && (type === "object" || type === "function");
};
const isScrollBehaviorSupported = (config) => "scrollBehavior" in window.document.documentElement.style && (config === null || config === void 0 ? void 0 : config.forcePolyfill) !== true;
const markPolyfill = (method) => {
    Object.defineProperty(method, "__isPolyfill", { value: true });
};
const modifyPrototypes = (prop, func) => {
    markPolyfill(func);
    [HTMLElement.prototype, SVGElement.prototype, Element.prototype].forEach((prototype) => {
        backupMethod(prototype, prop);
        prototype[prop] = func;
    });
};
/**
 * - On Chrome and Firefox, document.scrollingElement will return the <html> element.
 * - Safari, document.scrollingElement will return the <body> element.
 * - On Edge, document.scrollingElement will return the <body> element.
 * - IE11 does not support document.scrollingElement, but you can assume its <html>.
 */
const scrollingElement = (element) => element.ownerDocument.scrollingElement || element.ownerDocument.documentElement;
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ./node_modules/seamless-scroll-polyfill/lib/scroll-step.js
const ease = (k) => {
    return 0.5 * (1 - Math.cos(Math.PI * k));
};
/* eslint-disable */
function now() {
    var _a;
    let fn;
    if ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.now) {
        fn = () => window.performance.now();
    }
    else {
        fn = () => window.Date.now();
    }
    // @ts-ignore
    now = fn;
    return fn();
}
/* eslint-enable */
const DURATION = 500;
const step = (context) => {
    const currentTime = now();
    const elapsed = (currentTime - context.timeStamp) / (context.duration || DURATION);
    if (elapsed > 1) {
        context.method(context.targetX, context.targetY);
        context.callback();
        return;
    }
    const value = (context.timingFunc || ease)(elapsed);
    const currentX = context.startX + (context.targetX - context.startX) * value;
    const currentY = context.startY + (context.targetY - context.startY) * value;
    context.method(currentX, currentY);
    context.rafId = window.requestAnimationFrame(() => {
        step(context);
    });
};
//# sourceMappingURL=scroll-step.js.map
;// CONCATENATED MODULE: ./node_modules/seamless-scroll-polyfill/lib/scroll.js


// https://drafts.csswg.org/cssom-view/#normalize-non-finite-values
const nonFinite = (value) => {
    if (!isFinite(value)) {
        return 0;
    }
    return Number(value);
};
const isConnected = (node) => {
    var _a;
    return ((_a = node.isConnected) !== null && _a !== void 0 ? _a : (!node.ownerDocument ||
        // eslint-disable-next-line no-bitwise
        !(node.ownerDocument.compareDocumentPosition(node) & /** DOCUMENT_POSITION_DISCONNECTED */ 1)));
};
const scrollWithOptions = (element, options, config) => {
    var _a, _b;
    if (!isConnected(element)) {
        return;
    }
    const startX = element.scrollLeft;
    const startY = element.scrollTop;
    const targetX = nonFinite((_a = options.left) !== null && _a !== void 0 ? _a : startX);
    const targetY = nonFinite((_b = options.top) !== null && _b !== void 0 ? _b : startY);
    if (targetX === startX && targetY === startY) {
        return;
    }
    const fallback = backupMethod(HTMLElement.prototype, "scroll", elementScrollXY);
    const method = backupMethod(Object.getPrototypeOf(element), "scroll", fallback).bind(element);
    if (options.behavior !== "smooth") {
        method(targetX, targetY);
        return;
    }
    const removeEventListener = () => {
        window.removeEventListener("wheel", cancelScroll);
        window.removeEventListener("touchmove", cancelScroll);
    };
    const context = Object.assign(Object.assign({}, config), { timeStamp: now(), startX,
        startY,
        targetX,
        targetY, rafId: 0, method, callback: removeEventListener });
    const cancelScroll = () => {
        window.cancelAnimationFrame(context.rafId);
        removeEventListener();
    };
    window.addEventListener("wheel", cancelScroll, {
        passive: true,
        once: true,
    });
    window.addEventListener("touchmove", cancelScroll, {
        passive: true,
        once: true,
    });
    step(context);
};
const isWindow = (obj) => obj.window === obj;
const createScroll = (scrollName) => (target, scrollOptions, config) => {
    const [element, scrollType] = isWindow(target)
        ? [scrollingElement(target.document.documentElement), "Window"]
        : [target, "Element"];
    const options = scrollOptions !== null && scrollOptions !== void 0 ? scrollOptions : {};
    if (!common_isObject(options)) {
        throw new TypeError(failedExecute(scrollName, scrollType));
    }
    if (!checkBehavior(options.behavior)) {
        throw new TypeError(failedExecuteInvalidEnumValue(scrollName, scrollType, options.behavior));
    }
    if (scrollName === "scrollBy") {
        options.left = nonFinite(options.left) + element.scrollLeft;
        options.top = nonFinite(options.top) + element.scrollTop;
    }
    scrollWithOptions(element, options, config);
};
const scroll_scroll = /* #__PURE__ */ createScroll("scroll");
const scrollTo = /* #__PURE__ */ (/* unused pure expression or super */ null && (createScroll("scrollTo")));
const scrollBy = /* #__PURE__ */ (/* unused pure expression or super */ null && (createScroll("scrollBy")));
const elementScroll = scroll_scroll;
const elementScrollTo = (/* unused pure expression or super */ null && (scrollTo));
const elementScrollBy = (/* unused pure expression or super */ null && (scrollBy));
const windowScroll = (/* unused pure expression or super */ null && (scroll_scroll));
const windowScrollTo = (/* unused pure expression or super */ null && (scrollTo));
const windowScrollBy = (/* unused pure expression or super */ null && (scrollBy));
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ./node_modules/seamless-scroll-polyfill/lib/scrollIntoView.js
/* eslint-disable no-bitwise */


// https://drafts.csswg.org/css-writing-modes-4/#block-flow
const normalizeWritingMode = (writingMode) => {
    switch (writingMode) {
        case "horizontal-tb":
        case "lr":
        case "lr-tb":
        case "rl":
        case "rl-tb":
            return 0 /* HorizontalTb */;
        case "vertical-rl":
        case "tb":
        case "tb-rl":
            return 1 /* VerticalRl */;
        case "vertical-lr":
        case "tb-lr":
            return 2 /* VerticalLr */;
        case "sideways-rl":
            return 3 /* SidewaysRl */;
        case "sideways-lr":
            return 4 /* SidewaysLr */;
    }
    return 0 /* HorizontalTb */;
};
const calcPhysicalAxis = (writingMode, isLTR, hPos, vPos) => {
    /**  0b{vertical}{horizontal}  0: normal, 1: reverse */
    let layout = 0b00;
    /**
     * WritingMode.VerticalLr: ↓→
     * | 1 | 4 |   |
     * | 2 | 5 |   |
     * | 3 |   |   |
     *
     * RTL: ↑→
     * | 3 |   |   |
     * | 2 | 5 |   |
     * | 1 | 4 |   |
     */
    if (!isLTR) {
        layout ^= 2 /* ReverseVertical */;
    }
    switch (writingMode) {
        /**
         * ↓→
         * | 1 | 2 | 3 |
         * | 4 | 5 |   |
         * |   |   |   |
         *
         * RTL: ↓←
         * | 3 | 2 | 1 |
         * |   | 5 | 4 |
         * |   |   |   |
         */
        case 0 /* HorizontalTb */:
            // swap horizontal and vertical
            layout = (layout >> 1) | ((layout & 1) << 1);
            [hPos, vPos] = [vPos, hPos];
            break;
        /**
         * ↓←
         * |   | 4 | 1 |
         * |   | 5 | 2 |
         * |   |   | 3 |
         *
         * RTL: ↑←
         * |   |   | 3 |
         * |   | 5 | 2 |
         * |   | 4 | 1 |
         */
        case 1 /* VerticalRl */:
        case 3 /* SidewaysRl */:
            //  reverse horizontal
            layout ^= 1 /* ReverseHorizontal */;
            break;
        /**
         * ↑→
         * | 3 |   |   |
         * | 2 | 5 |   |
         * | 1 | 4 |   |
         *
         * RTL: ↓→
         * | 1 | 4 |   |
         * | 2 | 5 |   |
         * | 3 |   |   |
         */
        case 4 /* SidewaysLr */:
            // reverse vertical
            layout ^= 2 /* ReverseVertical */;
            break;
    }
    return [layout, hPos, vPos];
};
const isXReversed = (computedStyle) => {
    const layout = calcPhysicalAxis(normalizeWritingMode(computedStyle.writingMode), computedStyle.direction !== "rtl", undefined, undefined)[0];
    return (layout & 1) === 1;
};
// https://source.chromium.org/chromium/chromium/src/+/main:third_party/blink/renderer/core/dom/element.cc;l=1097-1189;drc=6a7533d4a1e9f2372223a9d912a9e53a6fa35ae0
const toPhysicalAlignment = (options, writingMode, isLTR) => {
    const [layout, hPos, vPos] = calcPhysicalAxis(writingMode, isLTR, options.block || "start", options.inline || "nearest");
    return [hPos, vPos].map((value, index) => {
        switch (value) {
            case "center":
                return 1 /* CenterAlways */;
            case "nearest":
                return 0 /* ToEdgeIfNeeded */;
            default: {
                const reverse = (layout >> index) & 1;
                return (value === "start") === !reverse ? 2 /* LeftOrTop */ : 3 /* RightOrBottom */;
            }
        }
    });
};
// code from stipsan/compute-scroll-into-view
// https://github.com/stipsan/compute-scroll-into-view/blob/5396c6b78af5d0bbce11a7c4e93cc3146546fcd3/src/index.ts
/**
 * Find out which edge to align against when logical scroll position is "nearest"
 * Interesting fact: "nearest" works similarily to "if-needed", if the element is fully visible it will not scroll it
 *
 * Legends:
 * ┌────────┐ ┏ ━ ━ ━ ┓
 * │ target │   frame
 * └────────┘ ┗ ━ ━ ━ ┛
 */
const mapNearest = (align, scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, elementEdgeStart, elementEdgeEnd, elementSize) => {
    if (align !== 0 /* ToEdgeIfNeeded */) {
        return align;
    }
    /**
     * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
     *
     *          ┌──┐
     *        ┏━│━━│━┓
     *          │  │
     *        ┃ │  │ ┃        do nothing
     *          │  │
     *        ┗━│━━│━┛
     *          └──┘
     *
     *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
     *
     *    ┏ ━ ━ ━ ━ ┓
     *   ┌───────────┐
     *   │┃         ┃│        do nothing
     *   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
        (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
        return null;
    }
    /**
     * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
     *
     *          ┌──┐
     *        ┏━│━━│━┓         ┏━┌━━┐━┓
     *          └──┘             │  │
     *  from  ┃      ┃     to  ┃ └──┘ ┃
     *
     *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
     *
     * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
     *                           │  │
     *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
     *          │  │             │  │
     *        ┗━│━━│━┛         ┗━│━━│━┛
     *          │  │             └──┘
     *          │  │
     *          └──┘
     *
     * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───┐                 ┌───┐
     *  │ ┃ │       ┃         ┃   │     ┃
     *  └───┘                 └───┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *        ┌───────────┐   ┌───────────┐
     *    ┃   │     ┃     │   ┃         ┃ │
     *        └───────────┘   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
        (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
        return 2 /* LeftOrTop */;
    }
    /**
     * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
     *
     *  from  ┃      ┃     to  ┃ ┌──┐ ┃
     *          ┌──┐             │  │
     *        ┗━│━━│━┛         ┗━└━━┘━┛
     *          └──┘
     *
     * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
     *
     *          ┌──┐
     *          │  │
     *          │  │             ┌──┐
     *        ┏━│━━│━┓         ┏━│━━│━┓
     *          │  │             │  │
     *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
     *                           │  │
     *        ┗━ ━━ ━┛         ┗━└━━┘━┛
     *
     * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───────────┐           ┌───────────┐
     *  │     ┃     │   ┃       │ ┃         ┃
     *  └───────────┘           └───────────┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *                ┌───┐             ┌───┐
     *        ┃       │ ┃ │       ┃     │   ┃
     *                └───┘             └───┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     */
    if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) ||
        (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
        return 3 /* RightOrBottom */;
    }
    return null;
};
const canOverflow = (overflow) => {
    return overflow !== "visible" && overflow !== "clip";
};
const getFrameElement = (element) => {
    var _a;
    try {
        return ((_a = element.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement) || null;
    }
    catch (_b) {
        return null;
    }
};
const isScrollable = (element, computedStyle) => {
    if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
        return (canOverflow(computedStyle.overflowY) ||
            canOverflow(computedStyle.overflowX) ||
            element === scrollingElement(element));
    }
    return false;
};
const parentElement = (element) => {
    const pNode = element.parentNode;
    const pElement = element.parentElement;
    if (pElement === null && pNode !== null) {
        if (pNode.nodeType === /** Node.DOCUMENT_FRAGMENT_NODE */ 11) {
            return pNode.host;
        }
        if (pNode.nodeType === /** Node.DOCUMENT_NODE */ 9) {
            return getFrameElement(element);
        }
    }
    return pElement;
};
const clamp = (value, min, max) => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
const getSupportedScrollMarginProperty = (ownerDocument) => {
    // Webkit uses "scroll-snap-margin" https://bugs.webkit.org/show_bug.cgi?id=189265.
    return ["scroll-margin", "scroll-snap-margin"].filter((property) => property in ownerDocument.documentElement.style)[0];
};
const getElementScrollSnapArea = (element, elementRect, computedStyle) => {
    const { top, right, bottom, left } = elementRect;
    const scrollProperty = getSupportedScrollMarginProperty(element.ownerDocument);
    if (!scrollProperty) {
        return [top, right, bottom, left];
    }
    const scrollMarginValue = (edge) => {
        const value = computedStyle.getPropertyValue(`${scrollProperty}-${edge}`);
        return parseInt(value, 10) || 0;
    };
    return [
        top - scrollMarginValue("top"),
        right + scrollMarginValue("right"),
        bottom + scrollMarginValue("bottom"),
        left - scrollMarginValue("left"),
    ];
};
const calcAlignEdge = (align, start, end) => {
    switch (align) {
        case 1 /* CenterAlways */:
            return (start + end) / 2;
        case 3 /* RightOrBottom */:
            return end;
        case 2 /* LeftOrTop */:
        case 0 /* ToEdgeIfNeeded */:
            return start;
    }
};
const getFrameViewport = (frame, frameRect) => {
    var _a, _b, _c;
    const visualViewport = (_a = frame.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.visualViewport;
    const [x, y, width, height] = frame === scrollingElement(frame)
        ? [0, 0, (_b = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _b !== void 0 ? _b : frame.clientWidth, (_c = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _c !== void 0 ? _c : frame.clientHeight]
        : [frameRect.left, frameRect.top, frame.clientWidth, frame.clientHeight];
    const left = x + frame.clientLeft;
    const top = y + frame.clientTop;
    const right = left + width;
    const bottom = top + height;
    return [top, right, bottom, left];
};
const computeScrollIntoView = (element, options) => {
    // Collect all the scrolling boxes, as defined in the spec: https://drafts.csswg.org/cssom-view/#scrolling-box
    const actions = [];
    let ownerDocument = element.ownerDocument;
    let ownerWindow = ownerDocument.defaultView;
    if (!ownerWindow) {
        return actions;
    }
    const computedStyle = window.getComputedStyle(element);
    const isLTR = computedStyle.direction !== "rtl";
    const writingMode = normalizeWritingMode(computedStyle.writingMode ||
        computedStyle.getPropertyValue("-webkit-writing-mode") ||
        computedStyle.getPropertyValue("-ms-writing-mode"));
    const [alignH, alignV] = toPhysicalAlignment(options, writingMode, isLTR);
    let [top, right, bottom, left] = getElementScrollSnapArea(element, element.getBoundingClientRect(), computedStyle);
    for (let frame = parentElement(element); frame !== null; frame = parentElement(frame)) {
        if (ownerDocument !== frame.ownerDocument) {
            ownerDocument = frame.ownerDocument;
            ownerWindow = ownerDocument.defaultView;
            if (!ownerWindow) {
                break;
            }
            const { left: dX, top: dY } = frame.getBoundingClientRect();
            top += dY;
            right += dX;
            bottom += dY;
            left += dX;
        }
        const frameStyle = ownerWindow.getComputedStyle(frame);
        if (frameStyle.position === "fixed") {
            break;
        }
        if (!isScrollable(frame, frameStyle)) {
            continue;
        }
        const frameRect = frame.getBoundingClientRect();
        const [frameTop, frameRight, frameBottom, frameLeft] = getFrameViewport(frame, frameRect);
        const eAlignH = mapNearest(alignH, frameLeft, frameRight, frame.clientWidth, left, right, right - left);
        const eAlignV = mapNearest(alignV, frameTop, frameBottom, frame.clientHeight, top, bottom, bottom - top);
        const diffX = eAlignH === null ? 0 : calcAlignEdge(eAlignH, left, right) - calcAlignEdge(eAlignH, frameLeft, frameRight);
        const diffY = eAlignV === null ? 0 : calcAlignEdge(eAlignV, top, bottom) - calcAlignEdge(eAlignV, frameTop, frameBottom);
        const moveX = isXReversed(frameStyle)
            ? clamp(diffX, -frame.scrollWidth + frame.clientWidth - frame.scrollLeft, -frame.scrollLeft)
            : clamp(diffX, -frame.scrollLeft, frame.scrollWidth - frame.clientWidth - frame.scrollLeft);
        const moveY = clamp(diffY, -frame.scrollTop, frame.scrollHeight - frame.clientHeight - frame.scrollTop);
        actions.push([
            frame,
            { left: frame.scrollLeft + moveX, top: frame.scrollTop + moveY, behavior: options.behavior },
        ]);
        top = Math.max(top - moveY, frameTop);
        right = Math.min(right - moveX, frameRight);
        bottom = Math.min(bottom - moveY, frameBottom);
        left = Math.max(left - moveX, frameLeft);
    }
    return actions;
};
const scrollIntoView = (element, scrollIntoViewOptions, config) => {
    const options = scrollIntoViewOptions || {};
    if (!checkBehavior(options.behavior)) {
        throw new TypeError(failedExecuteInvalidEnumValue("scrollIntoView", "Element", options.behavior));
    }
    const actions = computeScrollIntoView(element, options);
    actions.forEach(([frame, scrollToOptions]) => {
        elementScroll(frame, scrollToOptions, config);
    });
};
const elementScrollIntoView = (/* unused pure expression or super */ null && (scrollIntoView));
//# sourceMappingURL=scrollIntoView.js.map
;// CONCATENATED MODULE: ./src/js/WatchShortVideosInIOSScript.js





// import { scrollIntoView } from './DashJS/seamlessscroll.min.js'

// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'


// import router from "./routerconfig"
var WatchShortVideosInIOSScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 1,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    init: function (userpid, sulekhaApp = null) {
        // remove touch events 

        WatchShortVideosInIOSScript.resetAll();

        WatchShortVideosInIOSScript.setEventsForVideo();

        // window.addEventListener("focus", WatchShortVideosInIOSScript.playVideOnDocumentOnFocus);
        // window.addEventListener("blur", WatchShortVideosInIOSScript.pauseVideOnDocumentLooseFocus);


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        WatchShortVideosInIOSScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchShortVideosInIOSScript.isMobileApp = true;
            }
            else {
                WatchShortVideosInIOSScript.isMobileApp = false;
            }
        }


        if (WatchShortVideosInIOSScript.iOS()) {

            WatchShortVideosInIOSScript.setupDashJsVideoForIOS();
        }
        else {
            WatchShortVideosInIOSScript.setupDashJsVideo();
        }

        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WatchShortVideosInIOSScript.afterGetUserInfoLoad);

        // WatchShortVideosInIOSScript.videos = document.getElementsByTagName("video");
        // WatchShortVideosInIOSScript.divVideoList = document.getElementById('divshortVideolist');

        // WatchShortVideosInIOSScript.initializeDashJsPlayers()



        document.querySelectorAll(".actionsitem").forEach((btn) => {
            btn.addEventListener("touchend", function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }
                e.stopPropagation();

                WatchShortVideosInIOSScript.SaveShortVideoAction(e);


            })


        })



        document.querySelectorAll(".backbutton").forEach((backbutton) => {
            backbutton.addEventListener("touchend", function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }

                e.stopPropagation();

                // WatchShortVideosInIOSScript.activePlayer.pause();
                WatchShortVideosInIOSScript.pauseAllVideosBeforeExit();
                var shortvideobackpage = window.localStorage.getItem('backpage');

                var currentVideo = WatchShortVideosInIOSScript.activePlayer;


                var videoid = currentVideo.getAttribute('data-videoid');

                var language = currentVideo.getAttribute('data-language');

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Back');

                if (WatchShortVideosInIOSScript.isMobileApp) {

                    if (shortvideobackpage == "videos") {
                        WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                    }
                    else if (shortvideobackpage == "videolessons") {
                        WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
                    }
                    else if (shortvideobackpage == "watchedvideoLesson") {
                        WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos, { atab: 'shortvideo' });
                    }
                    else {
                        WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                    }

                }
                else {
                    // history.back();
                    if (shortvideobackpage) {
                        if (shortvideobackpage == "videos") {
                            location.href = "/videos"
                        }
                        else if (shortvideobackpage == "videolessons") {
                            location.href = "/videolessons"
                        }
                        else if (shortvideobackpage == "watchedvideoLesson") {
                            location.href = "/watchedvideos?atab=shortvideo"

                        }
                        else if (shortvideobackpage == "home") {
                            location.href = "/home"
                        }
                    }
                    else {
                        location.href = "/home"
                    }

                }

            })

        })


        // document.getElementsByTagName("video").forEach((video) => {

        //     video.addEventListener('click', async function (e) {

        //         alert(video.id +"Hi I clicked");

        //     });


        // })



        document.querySelectorAll(".list-item").forEach((divvideo) => {
            js_TouchDetector.swipedetect(divvideo, function (evt, dir, phase, swipetype, distance) {


                // var touchreport = ''
                WatchShortVideosInIOSScript.touchDetails += '<b>Dir:</b> ' + dir + '<br />'
                WatchShortVideosInIOSScript.touchDetails += '<b>Phase:</b> ' + phase + '<br />'
                WatchShortVideosInIOSScript.touchDetails += '<b>Swipe Type:</b> ' + swipetype + '<br />'
                WatchShortVideosInIOSScript.touchDetails += '<b>Distance:</b> ' + distance + '<br />'
                WatchShortVideosInIOSScript.touchDetails += '<b>Element Id:</b> ' + evt.id + '<br />'
                //  //console.log(touchreport);

                var activerowindex = parseInt(evt.currentTarget.id.replace("divvideoid", ""))

                if (dir == "up") {
                    // if(distance<-100){     

                    var itemcount = document.querySelectorAll(".list-item").length;
                    if (parseInt(activerowindex) < itemcount) {


                        //   if (WatchShortVideosInIOSScript.touchUpDebounce) {
                        //    WatchShortVideosInIOSScript.touchUpDebounce = false;

                        var rowupindex = parseInt(activerowindex + 1)
                        WatchShortVideosInIOSScript.activePlayerRowIndex = rowupindex;
                        if (WatchShortVideosInIOSScript.iOS()) {
                            WatchShortVideosInIOSScript.playActiveVideoOnSwapForIOS(rowupindex, dir)
                        }
                        else {
                            WatchShortVideosInIOSScript.playActiveVideoOnSwap(rowupindex, dir)
                        }





                        //    setTimeout(function () { WatchShortVideosInIOSScript.touchUpDebounce = true; },0);


                        //   }



                    }

                    // }


                }

                if (dir == "down") {

                    // if(distance>200){
                    if (parseInt(activerowindex) > 1) {
                        //    if (WatchShortVideosInIOSScript.touchDownDebounce) {
                        //  WatchShortVideosInIOSScript.touchDownDebounce = false;
                        var rowdownindex = parseInt(activerowindex - 1)
                        WatchShortVideosInIOSScript.activePlayerRowIndex = rowdownindex;

                        if (WatchShortVideosInIOSScript.iOS()) {
                            WatchShortVideosInIOSScript.playActiveVideoOnSwapForIOS(rowdownindex, dir)
                        }
                        else {

                            WatchShortVideosInIOSScript.playActiveVideoOnSwap(rowdownindex, dir);
                        }
                        //    setTimeout(function () { WatchShortVideosInIOSScript.touchDownDebounce = true; }, 0);


                        // }
                    }


                    //   }


                }

                if (dir == "none" && phase == "end") {  // if touched 
                    //  alert(evt.id)
                    //   if (WatchShortVideosInIOSScript.touchDebounce) {
                    //   WatchShortVideosInIOSScript.touchDebounce = false;
                    WatchShortVideosInIOSScript.playpausePlayer(WatchShortVideosInIOSScript.activePlayerRowIndex);
                    //  setTimeout(function () { WatchShortVideosInIOSScript.touchDebounce = true; },100);

                    //  }



                    var replayiconId = "replayicon" + WatchShortVideosInIOSScript.activePlayerRowIndex

                    if (document.getElementById(replayiconId)) {
                        if (!document.getElementById(replayiconId).classList.contains('hide')) {

                            document.getElementById(replayiconId).classList.add('hide')
                        }
                    }

                }

                //    //console.log(touchreport)

            })  // swap detect end

        })


        ////   WatchShortVideosInIOSScript.initPlayer(); sample test codeing


    },

    playpausePlayer(activerowindex) {

        var curentvideo = WatchShortVideosInIOSScript.activePlayer;

        var playiconId = "playicon" + activerowindex

        if (curentvideo != null) {

            var videoid = curentvideo.getAttribute('data-videoid');

            var language = curentvideo.getAttribute('data-language');

            if (curentvideo.paused) {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.add('hide')
                }
                setTimeout(() => {
                    try {
                        curentvideo.play();
                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Play');

                    }
                    catch (err) {
                        //console.log("playpausePlayer pause")
                    }
                }, 50);
            }
            else {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.remove('hide')
                }
                setTimeout(() => {
                    try {
                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Pause');
                        curentvideo.pause();
                    }
                    catch { err } {
                        //console.log("playpausePlayer play")
                    }
                }, 200);

            }
        }

    },


    playActiveVideoOnSwapForIOS(activeRow, dir = 'up') {
        // validation

        var nextVideo = null

        for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
            if (WatchShortVideosInIOSScript.videoItems[index].row == activeRow) {
                nextVideo = WatchShortVideosInIOSScript.videoItems[index].video;
                break;
            }
        }

        var istodaywatchedvideo = nextVideo.getAttribute('data-istodaywatchedvideo');
        if (WatchShortVideosInIOSScript.userInfo.clubUserType == 1 && WatchShortVideosInIOSScript.sfvLimit == false && istodaywatchedvideo == 'False') {

            if (WatchShortVideosInIOSScript.isMobileApp == true) {
                setTimeout(() => {
                    WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                        pageType: 9
                    })
                }, 1000);
            }
            else {
                location.href = "/PaymentUpgradeRequest?pageType=9";
            }

            return;

        }


        //  if (WatchShortVideosInIOSScript.isScroll) {

        WatchShortVideosInIOSScript.activePlayer.pause();
        WatchShortVideosInIOSScript.showHideVideos();
        WatchShortVideosInIOSScript.ActiateNextVideoIfNotExistsForIOS();     //ActiateNextVideoIfNotExists()
        WatchShortVideosInIOSScript.isScroll = false;
        //console.log(WatchShortVideosInIOSScript.touchDetails)

        for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
            if (WatchShortVideosInIOSScript.videoItems[index].row == activeRow) {
                WatchShortVideosInIOSScript.activePlayer = WatchShortVideosInIOSScript.videoItems[index].video;
                WatchShortVideosInIOSScript.setTimeOutActiveVideos = []; // set this to find active video has payed 5 second validation and reset it not reached 5 seconds
                WatchShortVideosInIOSScript.setTimeOutActiveVideos.push(WatchShortVideosInIOSScript.activePlayer)
                break;
            }
        }

        try {

            var divid = "divvideoid" + activeRow;

            var divEle = document.getElementById(divid)

            // divEle.scrollIntoView(true);

            scrollIntoView(divEle, { behavior: "smooth", block: "center" })

            // divEle.scrollIntoView({
            //     block: "center",
            //     behavior: "smooth"
            // });



        }
        catch (err) {

        }



        setTimeout(async () => {

            WatchShortVideosInIOSScript.isScroll = true;
            try {
                await WatchShortVideosInIOSScript.activePlayer.play();


                var replayiconId = "replayicon" + WatchShortVideosInIOSScript.activePlayerRowIndex;

                if (document.getElementById(replayiconId)) {
                    if (!document.getElementById(replayiconId).classList.contains('hide')) {

                        document.getElementById(replayiconId).classList.add('hide')
                    }
                }
            }
            catch (err) {
                //console.log("playActiveVideoOnSwap play")
            }



            var videoid = WatchShortVideosInIOSScript.activePlayer.getAttribute('data-videoid');
            var language = WatchShortVideosInIOSScript.activePlayer.getAttribute('data-language');


            if (dir == "down") {
                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Previousvideo_Play');
            }
            else {

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Nextvideo_Play');
            }



            var playiconId = "playicon" + activeRow
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }


        }, 100);


        //   }


    },


    playActiveVideoOnSwap(activeRow, dir = 'up') {
        // validation

        var nextVideo = null

        for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
            if (WatchShortVideosInIOSScript.videoItems[index].row == activeRow) {
                nextVideo = WatchShortVideosInIOSScript.videoItems[index].video;
                break;
            }
        }

        var istodaywatchedvideo = nextVideo.getAttribute('data-istodaywatchedvideo');
        if (WatchShortVideosInIOSScript.userInfo.clubUserType == 1 && WatchShortVideosInIOSScript.sfvLimit == false && istodaywatchedvideo == 'False') {

            if (WatchShortVideosInIOSScript.isMobileApp == true) {
                setTimeout(() => {
                    WatchShortVideosInIOSScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                        pageType: 9
                    })
                }, 1000);
            }
            else {
                location.href = "/PaymentUpgradeRequest?pageType=9";
            }

            return;

        }


        //  if (WatchShortVideosInIOSScript.isScroll) {

        WatchShortVideosInIOSScript.activePlayer.pause();
        WatchShortVideosInIOSScript.showHideVideos();
        WatchShortVideosInIOSScript.ActiateNextVideoIfNotExists()
        WatchShortVideosInIOSScript.isScroll = false;
        //console.log(WatchShortVideosInIOSScript.touchDetails)

        for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
            if (WatchShortVideosInIOSScript.videoItems[index].row == activeRow) {
                WatchShortVideosInIOSScript.activePlayer = WatchShortVideosInIOSScript.videoItems[index].video;
                WatchShortVideosInIOSScript.setTimeOutActiveVideos = []; // set this to find active video has payed 5 second validation and reset it not reached 5 seconds
                WatchShortVideosInIOSScript.setTimeOutActiveVideos.push(WatchShortVideosInIOSScript.activePlayer)
                break;
            }
        }

        try {

            var divid = "divvideoid" + activeRow;

            var divEle = document.getElementById(divid)

            divEle.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });



        }
        catch (err) {

        }



        setTimeout(async () => {

            WatchShortVideosInIOSScript.isScroll = true;
            try {
                await WatchShortVideosInIOSScript.activePlayer.play();


                var replayiconId = "replayicon" + WatchShortVideosInIOSScript.activePlayerRowIndex;

                if (document.getElementById(replayiconId)) {
                    if (!document.getElementById(replayiconId).classList.contains('hide')) {

                        document.getElementById(replayiconId).classList.add('hide')
                    }
                }
            }
            catch (err) {
                //console.log("playActiveVideoOnSwap play")
            }



            var videoid = WatchShortVideosInIOSScript.activePlayer.getAttribute('data-videoid');
            var language = WatchShortVideosInIOSScript.activePlayer.getAttribute('data-language');


            if (dir == "down") {
                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Previousvideo_Play');
            }
            else {

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Nextvideo_Play');
            }



            var playiconId = "playicon" + activeRow
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }


        }, 100);


        //   }


    },


    /// Ref code



    playVisibleVideos_() {
        document.querySelectorAll("video").forEach(video => WatchShortVideosInIOSScript.isScrolledIntoView(video) ? video.play() : video.pause());
    },

    playVisibleVideos__() {
        //  document.querySelectorAll("video").forEach(video => WatchShortVideosInIOSScript.isScrolledIntoView(video) ? video.play() : video.pause());

        var videos = document.querySelectorAll("video");

        var activevideo = null;

        for (var i = 0; i < videos.length; i++) {
            var activevideo_ = videos[i];
            //  videoid=video.id;

            if (WatchShortVideosInIOSScript.isScrolledIntoView(activevideo_)) {
                activevideo = activevideo_;
                break
            }
            else {
                activevideo_.pause();
            }
        }

        if (activevideo) {
            activevideo.play();
            WatchShortVideosInIOSScript.SaveShortVideoAction(activevideo);
        }


        //  var videoid=0;
        for (var i = 0; i < videos.length; i++) {
            var video = videos[i];

            if (WatchShortVideosInIOSScript.isScrolledIntoView(video)) {

                // }

            }
            else {

                video.pause();

            }

        }
    },

    isScrolledIntoView(element) {
        var elementTop = element.getBoundingClientRect().top,
            elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= 0 && elementBottom <= window.innerHeight;
    },


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WatchShortVideosInIOSScript.userInfo = response.data;
        // WatchShortVideosInIOSScript.sfvWatchedCount=WatchShortVideosInIOSScript.userInfo.sfvWatchedCount;
        WatchShortVideosInIOSScript.sfvLimit = WatchShortVideosInIOSScript.userInfo.sfvLimit;
    },

    SaveShortVideoAction(e) {
        var action = ''
        var userPid = "0";
        var videoid = 0;
        var iswatched = "False";
        var languagevideoid = 0;
        var language = ""

        if (e.currentTarget) {
            action = e.currentTarget.getAttribute('data-action');
            userPid = e.currentTarget.getAttribute('data-userpid');
            videoid = e.currentTarget.getAttribute('data-videoid');
            iswatched = e.currentTarget.getAttribute('data-iswatched');
            languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
            language = e.currentTarget.getAttribute('data-language');

        }
        else {
            action = e.getAttribute('data-action');
            userPid = e.getAttribute('data-userpid');
            videoid = e.getAttribute('data-videoid');
            iswatched = e.getAttribute('data-iswatched');
            languagevideoid = e.getAttribute('data-languagevideoid');

            language = e.getAttribute('data-language');
        }
        /// validation removed in order to save all time
        // if (action == "watched") {

        //     bindGA.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Video_completed');

        //     if (iswatched == "True") { // stop again update the recorded status 
        //         WatchShortVideosInIOSScript.isAllowSave = true;
        //         videoid = 0;
        //         return;
        //     }
        // }

        if (videoid > 0) {

            //  WatchShortVideosInIOSScript.selectedVideo=videoid;
            var obj = { "UserPid": userPid, "VideoId": videoid, "Action": action, "languageVideoid": languagevideoid }
            fetch("https://www.capshine.com/api/Videos/SaveShortVideoAction/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            })
                .then((response) => response.json())
                .then((responseJson) => {

                    //isVideoWatched,isBookMarked,isLiked
                    //this.userInfo = responseJson;
                    if (action == "like") {

                        var likeId = "like" + videoid;
                        var obj = document.getElementById(likeId);

                        if (responseJson.isLiked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Like');

                    }

                    if (action == "bookmark") {
                        var bookmarkId = "bookmark" + videoid;
                        var obj = document.getElementById(bookmarkId);

                        if (responseJson.isBookMarked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_BookMark');
                    }

                    if (action == "watched") {
                        WatchShortVideosInIOSScript.isAllowSave = true;
                        e.setAttribute("data-iswatched", "True");
                        if (responseJson.todayWatchedCount >= WatchShortVideosInIOSScript.userInfo.sfvDailyWatchLimit) {
                            WatchShortVideosInIOSScript.sfvLimit = false;
                        }

                    }

                });

        }

        //   CSMainAPIs.Capshine.APIs.SaveShortVideoAction.execute({ "UserPid": userPid,"VideoId":videoid,"Action":action }, WatchShortVideosInIOSScript.afterSaveShortVideoActionResponse);

    },

    afterSaveShortVideoActionResponse(response) {
        WatchShortVideosInIOSScript.userInfo = response.data;
        //  WatchShortVideosInIOSScript.selectedVideo

    },


    setupDashJsVideoForIOS() {

        var videos = document.querySelectorAll("video");
        var url = videos[0].getAttribute("data-hlsvideourl");

        videos[0].src = url;

        setTimeout(() => {
            WatchShortVideosInIOSScript.toggleControls(videos[0])
        }, 100);


        // var hls = new Hls();
        // hls.loadSource(url);
        // hls.attachMedia(videos[0]);



        videos[0].oncanplay = (event) => {
            console.log('Video can start, but not sure it will play through.');
            videos[0].play();
        };


        var videoid = videos[0].getAttribute('data-videoid');
        var language = videos[0].getAttribute('data-language');

        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Start_SFV');

        var videoobj = {
            row: 1,
            id: videos[0].id,
            video: videos[0]
        }

        WatchShortVideosInIOSScript.videoItems.push(videoobj);

        WatchShortVideosInIOSScript.activePlayer = videos[0];

        WatchShortVideosInIOSScript.activePlayerRowIndex = 1;

        WatchShortVideosInIOSScript.showHideVideos();

        WatchShortVideosInIOSScript.ActiateNextVideoIfNotExistsForIOS()




    },


    setupDashJsVideo() {

        var videos = document.querySelectorAll("video");
        var url = videos[0].getAttribute("data-videourl");

        var player = dashjs.MediaPlayer().create();

        player.updateSettings({
            'debug': {
                'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
            },
            'streaming': {
                'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                },
                'buffer': {
                    'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                }
            }
        });



        player.initialize(videos[0], url, true);

        setTimeout(() => {
            WatchShortVideosInIOSScript.toggleControls(videos[0])
        }, 100);



        var videoid = videos[0].getAttribute('data-videoid');
        var language = videos[0].getAttribute('data-language');

        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Start_SFV');

        var videoobj = {
            row: 1,
            id: videos[0].id,
            player: player,
            video: videos[0]
        }

        WatchShortVideosInIOSScript.videoItems.push(videoobj);

        WatchShortVideosInIOSScript.activePlayer = videos[0];

        WatchShortVideosInIOSScript.activePlayerRowIndex = 1;

        WatchShortVideosInIOSScript.showHideVideos();

        WatchShortVideosInIOSScript.ActiateNextVideoIfNotExists()




    },
    showHideVideos() {
        var activeVideoIndex = parseInt(WatchShortVideosInIOSScript.activePlayerRowIndex);

        //    else
        // Show/Hide Next two div video element from current video 

        //Show Next item from current video div
        var showdivid = "divvideoid" + (activeVideoIndex + 1); // next div
        var showdivEle = document.getElementById(showdivid);


        if (showdivEle != null) {

            if (showdivEle.classList.contains('hide')) {
                //   showdivEle.classList.remove('hide')
            }
        }

        //Hide  next one div after Next div from current video div
        var hidedivid = "divvideoid" + (activeVideoIndex + 2);

        var hidedivEle = document.getElementById(hidedivid);

        if (hidedivEle != null) {
            if (!hidedivEle.classList.contains('hide')) {
                //   hidedivEle.classList.add('hide')
            }
        }

        /// 

        // Show/Hide Previous two div video element from current video 

        if (activeVideoIndex < 1) {
            return;
        }


        //Show Prevous item from current video div
        var showdivPreid = "divvideoid" + (activeVideoIndex - 1); // next div
        var showdivPreEle = document.getElementById(showdivPreid);

        if (showdivPreEle != null) {
            if (showdivPreEle.classList.contains('hide')) {
                //  showdivPreEle.classList.remove('hide')
            }
        }

        if (activeVideoIndex < 2) {
            return;
        }

        //Hide before one div before one div from current video div
        var hidedivPreid = "divvideoid" + (activeVideoIndex - 2);

        var hidedivPreEle = document.getElementById(hidedivPreid);

        if (hidedivPreEle != null) {
            if (!hidedivPreEle.classList.contains('hide')) {
                //  hidedivPreEle.classList.add('hide')
            }
        }

    },

    ActiateNextVideoIfNotExistsForIOS() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchShortVideosInIOSScript.activePlayerRowIndex);
        let videos = document.querySelectorAll("video");

        // load next three videos

        for (var row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
                    if (WatchShortVideosInIOSScript.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }


                if (isCreateVideo == true) {
                    let videourl = videos[activeVideoIndex].getAttribute("data-hlsvideourl");

                    setTimeout(() => {
                        WatchShortVideosInIOSScript.toggleControls(videos[activeVideoIndex])
                    }, 50);


                    videos[activeVideoIndex].src = videourl;


                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        video: videos[activeVideoIndex]
                    }
                    WatchShortVideosInIOSScript.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;


                }
            }
        }
    },

    ActiateNextVideoIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchShortVideosInIOSScript.activePlayerRowIndex);
        let videos = document.querySelectorAll("video");

        // load next three videos

        for (var row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
                    if (WatchShortVideosInIOSScript.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }


                if (isCreateVideo == true) {
                    let videourl = videos[activeVideoIndex].getAttribute("data-videourl");

                    let player_ = dashjs.MediaPlayer().create()


                    player_.updateSettings({
                        'debug': {
                            'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
                        },
                        'streaming': {
                            'scheduling': {
                                'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                            },
                            'buffer': {
                                'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                            }
                        }
                    });


                    player_.initialize(videos[activeVideoIndex], videourl, false);


                    setTimeout(() => {
                        WatchShortVideosInIOSScript.toggleControls(videos[activeVideoIndex])
                    }, 50);





                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        player: player_,
                        video: videos[activeVideoIndex]
                    }
                    WatchShortVideosInIOSScript.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;


                }
            }
        }
    },

    resetAll() {
        WatchShortVideosInIOSScript.UserPid = '';
        WatchShortVideosInIOSScript.userInfo = null;
        WatchShortVideosInIOSScript.isMobileApp = false;
        WatchShortVideosInIOSScript.activePlayer = null;
        WatchShortVideosInIOSScript.videoItems = [];
        WatchShortVideosInIOSScript.activePlayerRowIndex = 1;
        WatchShortVideosInIOSScript.setTimeOutActiveVideos = [];

        function fixTouchStart(event) {
            return;
        }


        function fixTouchEnd(event) {
            return;
        }
        function fixTouchMove(event) {
            return;
        }

        function removePauseVideOnDocumentLooseFocus() {
            return;
        }
        function removePlayideOnDocumentOnFocus() {
            return;
        }


        // Remove any previous listners as the page content is ajax loaded and body is never destroyed
        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);

        // reset events 
    },


    initPlayer() {
        var player;
        var video,
            url = "https://capshine-usea.streaming.media.azure.net/4d8afc53-9974-4b17-9d77-4ebdd0616d8f/chore_english.ism/manifest";

        video = document.getElementById("video_test");
        player = dashjs.MediaPlayer().create();
        player.initialize(video, url, true);

        player.updateSettings({
            'streaming': {
                'abr': {
                    'minBitrate': {
                        'video': -1
                    },
                    'maxBitrate': {
                        'video': 5000
                    },
                    'limitBitrateByPortal': false,
                }, 'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                }
            }
        })

        player.on(dashjs.MediaPlayer.events["PLAYBACK_ENDED"], function () {
            clearInterval(eventPoller);
        });

        var eventPoller = setInterval(function () {
            var streamInfo = player.getActiveStream().getStreamInfo();
            var dashMetrics = player.getDashMetrics();
            var dashAdapter = player.getDashAdapter();

            if (dashMetrics && streamInfo) {
                const periodIdx = streamInfo.index;
                var repSwitch = dashMetrics.getCurrentRepresentationSwitch('video', true);
                var bufferLevel = dashMetrics.getCurrentBufferLevel('video', true);
                var bitrate = repSwitch ? Math.round(dashAdapter.getBandwidthForRepresentation(repSwitch.to, periodIdx) / 1000) : NaN;
                // document.getElementById('currentBufferLevel').innerText = bufferLevel + " secs";
                //   document.getElementById('reportedBitrate').innerText = bitrate + " Kbps";
            }
        }, 1000);
    },


    pauseVideOnDocumentLooseFocus() {
        if (WatchShortVideosInIOSScript.activePlayer) {
            WatchShortVideosInIOSScript.activePlayer.pause();
            var playiconId = "playicon" + WatchShortVideosInIOSScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.remove('hide')
            }
            ////console.log("LooseFocus");
        }

    },


    playVideOnDocumentOnFocus() {
        if (WatchShortVideosInIOSScript.activePlayer) {
            WatchShortVideosInIOSScript.activePlayer.play();
            var playiconId = "playicon" + WatchShortVideosInIOSScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }
            //   //console.log("OnFocus");
        }

    },

    pauseAllVideosBeforeExit() {

        for (var index = 0; index < WatchShortVideosInIOSScript.videoItems.length; index++) {
            var video = WatchShortVideosInIOSScript.videoItems[index].video;
            var player = WatchShortVideosInIOSScript.videoItems[index].player;
            if (video.paused) {

            } else {
                video.pause();
            }

            // distory the player 
            if (player) {
                player.reset();
            }


        }

    },
    setEventsForVideo() {

        var videos = document.querySelectorAll("video");

        document.querySelectorAll('video').forEach(video => {
            video.addEventListener('timeupdate', event => {
                if (video.currentTime > 10 && video.currentTime < 11) {


                    if (WatchShortVideosInIOSScript.isAllowSave == true) {
                        if (video == WatchShortVideosInIOSScript.activePlayer) {
                            WatchShortVideosInIOSScript.isAllowSave = false;
                            WatchShortVideosInIOSScript.SaveShortVideoAction(video);
                            //WatchShortVideosInIOSScript.isAllowSave = true;
                        }

                    }

                    // console.log("video id :"+ video.id + "TIme Passed :"  + video.currentTime)
                }
                //handle click
            })

            // video.addEventListener('ended', event => {
            //     video.currentTime=0;
            //      var activerowindex= WatchShortVideosInIOSScript.activePlayerRowIndex;

            //      var playiconId = "playicon" + activerowindex

            //      if (document.getElementById(playiconId)) {
            //         document.getElementById(playiconId).classList.remove('hide')
            //     }
            //     //  alert("Video Id "+ video.id + " end" )
            //     //handle click
            // })

            video.addEventListener('ended', event => {
                video.currentTime = 0;
                var activerowindex = WatchShortVideosInIOSScript.activePlayerRowIndex;

                var replayiconId = "replayicon" + activerowindex

                if (document.getElementById(replayiconId)) {
                    document.getElementById(replayiconId).classList.remove('hide')
                }
                //  alert("Video Id "+ video.id + " end" )
                //handle click
            })


        })


    },

    toggleControls(video) {
        if (video.hasAttribute("controls")) {
            video.removeAttribute("controls")
        }
        else {
            video.setAttribute("controls", "controls")
        }
    },

    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }


}

/* harmony default export */ const js_WatchShortVideosInIOSScript = (WatchShortVideosInIOSScript);
// EXTERNAL MODULE: ./node_modules/youtube-player/dist/index.js
var youtube_player_dist = __webpack_require__(62);
var dist_default = /*#__PURE__*/__webpack_require__.n(youtube_player_dist);
;// CONCATENATED MODULE: ./src/js/TouchDetectorForIOS.js
var TouchDetectorForIOS = { 
 swipedetect(el, callback){  

    var touchsurface = el,
    dir,
    dist,
    swipeType,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 500, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    touchMoveId=0,
    handletouch = callback || function(evt, dir, phase, swipetype, distance){}

 
// touchsurface.removeEventListener( "touchend", fixTouchEnd );
 
    touchsurface.addEventListener('touchstart', function(e){
        touchMoveId=1
        var touchobj = e.changedTouches[0]
        dir = 'none'
        swipeType = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY    
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        handletouch(e, 'none', 'start', swipeType, 0) // fire callback function with params dir="none", phase="start", swipetype="none" etc
        // e.preventDefault()
      
 
    }, false)
 
    touchsurface.addEventListener('touchmove', function(e){
        touchMoveId=2
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        if (Math.abs(distX) > Math.abs(distY)){ // if distance traveled horizontally is greater than vertically, consider this a horizontal movement
            dir = (distX < 0)? 'left' : 'right'
            handletouch(e, dir, 'move', swipeType, distX) // fire callback function with params dir="left|right", phase="move", swipetype="none" etc
        }
        else{ // else consider this a vertical movement
            dir = (distY < 0)? 'up' : 'down'
            handletouch(e, dir, 'move', swipeType, distY) // fire callback function with params dir="up|down", phase="move", swipetype="none" etc
        }
        if (e.cancelable) {
         //  e.preventDefault() // prevent scrolling when inside DIV
        }
    }, false)
 
    touchsurface.addEventListener('touchend', function(e){
        if(touchMoveId==3){
            dir = 'none'
        }
        var touchobj = e.changedTouches[0]
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipeType = dir // set swipeType to either "left" or "right"
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipeType = dir // set swipeType to either "top" or "down"
            }
        }
        touchMoveId=3
        // Fire callback function with params dir="left|right|up|down", phase="end", swipetype=dir etc:
        handletouch(e, dir, 'end', swipeType, (dir =='left' || dir =='right')? distX : distY)
      
      //    e.preventDefault()
       
    }, false)



//     var touchsurface = el,
//     swipedir,
//     startX,
//     startY,
//     distX,
//     distY,
//     threshold = 150, //required min distance traveled to be considered swipe
//     restraint = 100, // maximum distance allowed at the same time in perpendicular direction
//     allowedTime = 300, // maximum time allowed to travel that distance
//     elapsedTime,
//     startTime,
//     dist,
//     handleswipe = callback || function(swipedir){}


//     // touchsurface.addEventListener("touchstart", startTouch, false);
//     // touchsurface.addEventListener("touchmove", moveTouch, false);

//     var initialX = null;
//     var initialY = null;
 
// function startTouch(e) {
//     swipedir="None"
//   initialX = e.touches[0].clientX;
//   initialY = e.touches[0].clientY;
// }

//     touchsurface.addEventListener('touchstart', function(e){
//         swipedir="None"
//         initialX = e.touches[0].clientX;
//         initialY = e.touches[0].clientY;
//         e.preventDefault()
//     }, false)
  

//  touchsurface.addEventListener('touchmove', function(e){
//     if (initialX === null) {
//         return;
//       }
     
//       if (initialY === null) {
//         return;
//       }
     
//       var currentX = e.touches[0].clientX;
//       var currentY = e.touches[0].clientY;
     
//       var diffX = initialX - currentX;
//       var diffY = initialY - currentY;
     
//       if (Math.abs(diffX) > Math.abs(diffY)) {
//         // sliding horizontally
//         if (diffX > 0) {
//           // swiped left
//           swipedir="swiped left"
//           console.log("swiped left");
//         } else {
//           // swiped right
//           swipedir="swiped right"
//           console.log("swiped right");
//         }  
//       } else {

//         if (Math.abs(diffY) >= threshold ){  //&& Math.abs(distX) <= restraint
           
//                  // sliding vertically
//         if (diffY > 0) {
//             // swiped up
//             swipedir="swiped up"
//             console.log("swiped up");
//           } else {
//             // swiped down
//             swipedir="swiped down"
//             console.log("swiped down");
//           } 
//         }

  
//       }
     
//       initialX = null;
//       initialY = null;
//       handleswipe(swipedir)
//       e.preventDefault();

//  },false)


// function moveTouch(e) {
//     if (initialX === null) {
//       return;
//     }
   
//     if (initialY === null) {
//       return;
//     }
   
//     var currentX = e.touches[0].clientX;
//     var currentY = e.touches[0].clientY;
   
//     var diffX = initialX - currentX;
//     var diffY = initialY - currentY;
   
//     if (Math.abs(diffX) > Math.abs(diffY)) {
//       // sliding horizontally
//       if (diffX > 0) {
//         // swiped left
//         swipedir="swiped left"
//         console.log("swiped left");
//       } else {
//         // swiped right
//         swipedir="swiped right"
//         console.log("swiped right");
//       }  
//     } else {
//       // sliding vertically
//       if (diffY > 0) {
//         // swiped up
//         swipedir="swiped up"
//         console.log("swiped up");
//       } else {
//         // swiped down
//         swipedir="swiped down"
//         console.log("swiped down");
//       }  
//     }
   
//     initialX = null;
//     initialY = null;
//     handleswipe(swipedir)
//     e.preventDefault();
//   }

  
    // touchsurface.addEventListener('touchstart', function(e){
    //     var touchobj = e.changedTouches[0]
    //     swipedir = 'none'
    //     dist = 0
    //     startX = touchobj.pageX
    //     startY = touchobj.pageY
    //     startTime = new Date().getTime() // record time when finger first makes contact with surface
    //     e.preventDefault()
    // }, false)
  
    // touchsurface.addEventListener('touchmove', function(e){
    //     e.preventDefault() // prevent scrolling when inside DIV
    // }, false)
  
    // touchsurface.addEventListener('touchend', function(e){
    //     var touchobj = e.changedTouches[0]
    //     distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
    //     distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
    //     elapsedTime = new Date().getTime() - startTime // get time elapsed
    //     if (elapsedTime <= allowedTime){ // first condition for awipe met
    //         if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
    //             swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
    //         }
    //         else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
    //             swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
    //         }
    //     }
    //     handleswipe(swipedir)
    //     e.preventDefault()
    // }, false)
}

}

/* harmony default export */ const js_TouchDetectorForIOS = ((/* unused pure expression or super */ null && (TouchDetectorForIOS)));
;// CONCATENATED MODULE: ./src/js/WatchShortVideoScriptInIOSYt.js







// import { scrollIntoView } from './DashJS/seamlessscroll.min.js'

// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'



// import router from "./routerconfig"
var WatchShortVideoScriptInIOSYt = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    initialVideoPlayed: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 1,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isPlaying: false,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    activeVideoPlayer: null,
    activeVideoPlayerInterval: null,
    activeVideoPlayerElapsedTimeInSeconds: null,
    activeVideoPlayerIdx: null,
    updatedSaveActionVideoId: new Map(),
    init: async function (userpid, sulekhaApp = null) {
        // remove touch events 

        // define youtube ref
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        tag.id = "YTiframeApi"
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        // //


        WatchShortVideoScriptInIOSYt.resetAll();

        WatchShortVideoScriptInIOSYt.setEventsForVideo();

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        WatchShortVideoScriptInIOSYt.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchShortVideoScriptInIOSYt.isMobileApp = true;
            }
            else {
                WatchShortVideoScriptInIOSYt.isMobileApp = false;
            }
        }

        await WatchShortVideoScriptInIOSYt.setupInitialVideo();

        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WatchShortVideoScriptInIOSYt.afterGetUserInfoLoad);

        document.querySelectorAll(".actionsitem").forEach((btn) => {
            btn.addEventListener("touchend", function (e) {
                e.stopPropagation();
                if (e.cancelable) {
                    e.preventDefault();
                }
                e.stopPropagation();

                WatchShortVideoScriptInIOSYt.SaveShortVideoAction(e);
            })
        })



        document.querySelectorAll(".backbutton").forEach((backbutton) => {
            backbutton.addEventListener("touchend", function (e) {
                e.stopPropagation();
                if (e.cancelable) {
                    e.preventDefault();
                }

                e.stopPropagation();

                WatchShortVideoScriptInIOSYt.pauseAllVideosBeforeExit();
                var shortvideobackpage = window.localStorage.getItem('backpage');

                var currentVideo = WatchShortVideoScriptInIOSYt.activePlayer;


                var videoid = currentVideo.getAttribute('data-youtube-url');

                var language = currentVideo.getAttribute('data-language');

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Back');

                if (WatchShortVideoScriptInIOSYt.isMobileApp) {

                    if (shortvideobackpage == "videos") {
                        WatchShortVideoScriptInIOSYt.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                    }
                    else if (shortvideobackpage == "videolessons") {
                        WatchShortVideoScriptInIOSYt.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, null);
                    }
                    else if (shortvideobackpage == "watchedvideoLesson") {
                        WatchShortVideoScriptInIOSYt.sulekhaApp.navigateTo(MainEnums_MobilePages.watchedVideos, { atab: 'shortvideo' });
                    }
                    else {
                        WatchShortVideoScriptInIOSYt.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                    }

                }
                else {
                    // history.back();
                    if (shortvideobackpage) {
                        if (shortvideobackpage == "videos") {
                            location.href = "/videos"
                        }
                        else if (shortvideobackpage == "videolessons") {
                            location.href = "/videolessons"
                        }
                        else if (shortvideobackpage == "watchedvideoLesson") {
                            location.href = "/watchedvideos?atab=shortvideo"

                        }
                        else if (shortvideobackpage == "home") {
                            location.href = "/home"
                        }
                    }
                    else {
                        location.href = "/home"
                    }

                }

            })

        })

        Array.from(document.getElementsByClassName("prev-button")).forEach((el) => {
            el.addEventListener("click", async (e) => {
                e.stopPropagation(); // prevent event bubling
                e.preventDefault();
                await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo();
                const playerState = await WatchShortVideoScriptInIOSYt.activeVideoPlayer.getPlayerState()
                if (playerState !== 1) await WatchShortVideoScriptInIOSYt.activeVideoPlayer.stopVideo();
                await WatchShortVideoScriptInIOSYt.scrollDown()
            })
        })

        Array.from(document.getElementsByClassName("next-button")).forEach((el) => {
            el.addEventListener("click", async(e) => {
                e.stopPropagation(); // prevent event bubling
                e.preventDefault();
                await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo();
                await WatchShortVideoScriptInIOSYt.scrollUp()
            })
        })

    },

    async playActiveVideoOnSwap(activeRow, dir = 'up') {
        // validation
        await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo();

        var nextVideo = null
        var nextPlayer = null

        for (let index = 0; index < WatchShortVideoScriptInIOSYt.videoItems.length; index++) {
            if (WatchShortVideoScriptInIOSYt.videoItems[index].row == activeRow) {
                nextVideo = WatchShortVideoScriptInIOSYt.videoItems[index].video;
                nextPlayer = WatchShortVideoScriptInIOSYt.videoItems[index].player;
                break;
            }
        }
        var istodaywatchedvideo = nextVideo.getAttribute('data-istodaywatchedvideo');

        if (WatchShortVideoScriptInIOSYt.userInfo.clubUserType == 1 && WatchShortVideoScriptInIOSYt.sfvLimit == false && istodaywatchedvideo == 'False') {

            if (WatchShortVideoScriptInIOSYt.isMobileApp == true) {
                setTimeout(() => {
                    WatchShortVideoScriptInIOSYt.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                        pageType: 9
                    })
                }, 1000);
            }
            else {
                location.href = "/PaymentUpgradeRequest?pageType=9";
            }

            return;

        }

        await WatchShortVideoScriptInIOSYt.ActivateNextVideoIfNotExists()
        WatchShortVideoScriptInIOSYt.isScroll = false;

        for (let index = 0; index < WatchShortVideoScriptInIOSYt.videoItems.length; index++) {
            if (WatchShortVideoScriptInIOSYt.videoItems[index].row == activeRow) {
                WatchShortVideoScriptInIOSYt.activeVideoPlayer = WatchShortVideoScriptInIOSYt.videoItems[index].player;
                WatchShortVideoScriptInIOSYt.setTimeOutActiveVideos = [];
                WatchShortVideoScriptInIOSYt.setTimeOutActiveVideos.push(WatchShortVideoScriptInIOSYt.activeVideoPlayer)
                break;
            }
        }
        let divid = "list-item-" + activeRow;

        let divEle = document.getElementById(divid)

        scrollIntoView(divEle, { behavior: "smooth", block: "center" })

            WatchShortVideoScriptInIOSYt.isScroll = true;
            try {
                


                var replayiconId = "replayicon" + WatchShortVideoScriptInIOSYt.activePlayerRowIndex;

                if (document.getElementById(replayiconId)) {
                    if (!document.getElementById(replayiconId).classList.contains('hide')) {

                        document.getElementById(replayiconId).classList.add('hide')
                    }
                }
            }
            catch (err) {
            }
            var videoid = WatchShortVideoScriptInIOSYt.activePlayer.getAttribute('data-youtube-url');
            var language = WatchShortVideoScriptInIOSYt.activePlayer.getAttribute('data-language');
            if (dir == "down") {
                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Previousvideo_Play');
            }
            else {

                GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Nextvideo_Play');
            }
            var playiconId = "playicon" + activeRow
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }

    },


    /// Ref code

    isScrolledIntoView(element) {
        var elementTop = element.getBoundingClientRect().top,
            elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= 0 && elementBottom <= window.innerHeight;
    },


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WatchShortVideoScriptInIOSYt.userInfo = response.data;
        // WatchShortVideoScriptInIOSYt.sfvWatchedCount=WatchShortVideoScriptInIOSYt.userInfo.sfvWatchedCount;
        WatchShortVideoScriptInIOSYt.sfvLimit = WatchShortVideoScriptInIOSYt.userInfo.sfvLimit;
    },

    SaveShortVideoAction(e) {
        var action = ''
        var userPid = "0";
        var videoid = 0;
        var iswatched = "False";
        var languagevideoid = 0;
        var language = ""

        if (e.currentTarget) {
            action = e.currentTarget.getAttribute('data-action');
            userPid = e.currentTarget.getAttribute('data-userpid');
            videoid = e.currentTarget.getAttribute('data-videoid');
            iswatched = e.currentTarget.getAttribute('data-iswatched');
            languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
            language = e.currentTarget.getAttribute('data-language');

        }
        else {
            action = e.getAttribute('data-action');
            userPid = e.getAttribute('data-userpid');
            videoid = e.getAttribute('data-videoid');
            iswatched = e.getAttribute('data-iswatched');
            languagevideoid = e.getAttribute('data-languagevideoid');

            language = e.getAttribute('data-language');
        }
        if (WatchShortVideoScriptInIOSYt.updatedSaveActionVideoId.has(videoid)) {
            clearInterval(WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval);
            WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
            return
        }
        WatchShortVideoScriptInIOSYt.updatedSaveActionVideoId.set(videoid, true)

        if (videoid > 0) {

            //  WatchShortVideoScriptInIOSYt.selectedVideo=videoid;
            var obj = { "UserPid": userPid, "VideoId": videoid, "Action": action, "languageVideoid": languagevideoid }
            fetch("https://www.capshine.com/api/Videos/SaveShortVideoAction/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    clearInterval(WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval);
                    WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
                    console.log("responseJson", responseJson)
                    //isVideoWatched,isBookMarked,isLiked
                    //WatchShortVideoScriptInIOSYt.userInfo = responseJson;
                    if (action == "like") {

                        var likeId = "like" + videoid;
                        var obj = document.getElementById(likeId);

                        if (responseJson.isLiked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Like');

                    }

                    if (action == "bookmark") {
                        var bookmarkId = "bookmark" + videoid;
                        var obj = document.getElementById(bookmarkId);

                        if (responseJson.isBookMarked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_BookMark');
                    }

                    if (action == "watched") {
                        WatchShortVideoScriptInIOSYt.isAllowSave = true;
                        e.setAttribute("data-iswatched", "True");
                        // 
                        if (responseJson.todayWatchedCount >= WatchShortVideoScriptInIOSYt.userInfo.sfvDailyWatchLimit) {
                            WatchShortVideoScriptInIOSYt.sfvLimit = false;
                        }

                    }

                });

        }

        //   CSMainAPIs.Capshine.APIs.SaveShortVideoAction.execute({ "UserPid": userPid,"VideoId":videoid,"Action":action }, WatchShortVideoScriptInIOSYt.afterSaveShortVideoActionResponse);

    },

    afterSaveShortVideoActionResponse(response) {
        WatchShortVideoScriptInIOSYt.userInfo = response.data;
    },

    getYoutubeIdFromUrl(url) {
        var regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|shorts|)(.*?((?=[&#?])|$))/gm;
        return regExp.exec(url)[3];
    },

    async setupInitialVideo() {
        const videos = document.getElementsByClassName("youtube-video-ios")

        WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx = videos[0].getAttribute("data-row-no")
        const youtubeUrl = videos[0].getAttribute("data-youtube-url");
        const shortVideoId = "yt-player-" + WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx

        await WatchShortVideoScriptInIOSYt.createYtIframeForElement(shortVideoId, youtubeUrl)


        const videoid = videos[0].getAttribute('data-youtube-url');
        const language = videos[0].getAttribute('data-language');

        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Start_SFV');

        const videoobj = {
            row: 1,
            id: videos[0].id,
            video: document.getElementById(`wrapper-1`),
            player: WatchShortVideoScriptInIOSYt.activeVideoPlayer
        }

        WatchShortVideoScriptInIOSYt.videoItems.push(videoobj);

        WatchShortVideoScriptInIOSYt.activePlayer = videos[0];

        WatchShortVideoScriptInIOSYt.activePlayerRowIndex = 1;

        await WatchShortVideoScriptInIOSYt.ActivateNextVideoIfNotExists()


    },

    async createYtIframeForElement(element, youtubeUrl) {
        const videoId = WatchShortVideoScriptInIOSYt.getYoutubeIdFromUrl(youtubeUrl);

        let player = await WatchShortVideoScriptInIOSYt.loadPlayer(element, videoId)

        WatchShortVideoScriptInIOSYt.activeVideoPlayer = player;

    },
    async scrollUp () {
        await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo(); // pause current video before playing next
        await Promise.all(WatchShortVideoScriptInIOSYt.videoItems.map(async (videoItems) => await videoItems.player.pauseVideo()))
        let rowdownindex = parseInt(WatchShortVideoScriptInIOSYt.activePlayerRowIndex + 1)
        WatchShortVideoScriptInIOSYt.activePlayerRowIndex = rowdownindex;
        clearInterval(WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval)
        WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
        await WatchShortVideoScriptInIOSYt.playActiveVideoOnSwap(rowdownindex, "up");
        await WatchShortVideoScriptInIOSYt.activeVideoPlayer.playVideo();
    },
    async scrollDown () {
        await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo(); // pause current video before playing next
        await Promise.all(WatchShortVideoScriptInIOSYt.videoItems.map(async (videoItems) => await videoItems.player.pauseVideo()))
        let rowdownindex = parseInt(WatchShortVideoScriptInIOSYt.activePlayerRowIndex - 1)
        WatchShortVideoScriptInIOSYt.activePlayerRowIndex = rowdownindex;
        clearInterval(WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval)
        WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
        await WatchShortVideoScriptInIOSYt.playActiveVideoOnSwap(rowdownindex, "down");
        await WatchShortVideoScriptInIOSYt.activeVideoPlayer.playVideo();
    },

    // youTubePlayerActive() {

    //     return YouTubePlayer && WatchShortVideoScriptInIOSYt.activeVideoPlayer.hasOwnProperty('getPlayerState');
    // },

    async loadPlayer(container, videoId) {
        let player = dist_default()(container, {
            videoId: videoId,
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                autoplay: 0,
                rel: 0,
                modestbranding: 1,
                fs: 0,
                controls: 1,
                disablekb: 1,
                loop: 0,
                playsinline: 1,
                mute: 0
            }
        });
        player.on('stateChange', async (event) => {
            WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval = setInterval(WatchShortVideoScriptInIOSYt.updateVideoAction, 1000)
            switch (event.data) { //(https://developers.google.com/youtube/iframe_api_reference#Events)
                case -1:
                    WatchShortVideoScriptInIOSYt.isPlaying = false;
                    if (!WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval) {
                        WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval = setInterval(WatchShortVideoScriptInIOSYt.updateVideoAction, 1000)
                    }
                    return;
                case 0:
                    WatchShortVideoScriptInIOSYt.isPlaying = false;
                    clearInterval(WatchShortVideoScriptInIOSYt.updateVideoAction)
                    WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
                    await WatchShortVideoScriptInIOSYt.scrollUp();
                    return
                case 1:
                    WatchShortVideoScriptInIOSYt.isPlaying = true;
                    if (!WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval) {
                        WatchShortVideoScriptInIOSYt.activeVideoPlayerInterval = setInterval(WatchShortVideoScriptInIOSYt.updateVideoAction, 1000)
                    }
                return;
                case 2:
                    WatchShortVideoScriptInIOSYt.isPlaying = false;
                    return;
                case 3:
                    return;
                case 5:
                    return;
            }
        });

        return player
    },
    updateVideoAction() {
        WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds++
        WatchShortVideoScriptInIOSYt.activeVideoPlayer;
        if (WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds > 10 && WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds < 16) {
            const element = document.getElementById(`yt-player-${WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx}`)
            WatchShortVideoScriptInIOSYt.SaveShortVideoAction(element);
        } else if (WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds > 16) {
            clearInterval(WatchShortVideoScriptInIOSYt.updateVideoAction)
            WatchShortVideoScriptInIOSYt.activeVideoPlayerElapsedTimeInSeconds = 0
        }
    },

    async ActivateNextVideoIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchShortVideoScriptInIOSYt.activePlayerRowIndex);
        let videos = document.getElementsByClassName("short-videos-wrapper");

        // load next three videos
        for (let row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (let index = 0; index < WatchShortVideoScriptInIOSYt.videoItems.length; index++) {
                    if (WatchShortVideoScriptInIOSYt.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }
                if (isCreateVideo == true) {

                    WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx = videos[activeVideoIndex].getAttribute("data-row-no")

                    const youtubeUrl = videos[activeVideoIndex].getAttribute("data-youtube-url");
                    const shortVideoId = "yt-player-" + WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx

                    await WatchShortVideoScriptInIOSYt.createYtIframeForElement(shortVideoId, youtubeUrl)

                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        player: WatchShortVideoScriptInIOSYt.activeVideoPlayer,
                        video: document.getElementById(`wrapper-${NextVideoIndex}`)
                    }
                    WatchShortVideoScriptInIOSYt.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;
                }
            }
        }
    },

    resetAll() {
        WatchShortVideoScriptInIOSYt.UserPid = '';
        WatchShortVideoScriptInIOSYt.userInfo = null;
        WatchShortVideoScriptInIOSYt.isMobileApp = false;
        WatchShortVideoScriptInIOSYt.activePlayer = null;
        WatchShortVideoScriptInIOSYt.videoItems = [];
        WatchShortVideoScriptInIOSYt.activePlayerRowIndex = 1;
        WatchShortVideoScriptInIOSYt.setTimeOutActiveVideos = [];

        function fixTouchStart(event) {
            return;
        }


        function fixTouchEnd(event) {
            return;
        }
        function fixTouchMove(event) {
            return;
        }

        function removePauseVideOnDocumentLooseFocus() {
            return;
        }
        function removePlayideOnDocumentOnFocus() {
            return;
        }


        // Remove any previous listners as the page content is ajax loaded and body is never destroyed
        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);

        // reset events 
    },


    async pauseVideOnDocumentLooseFocus() {
        if (WatchShortVideoScriptInIOSYt.activeVideoPlayer) {
            await WatchShortVideoScriptInIOSYt.activeVideoPlayer.pauseVideo();
            var playiconId = "playicon" + WatchShortVideoScriptInIOSYt.activeVideoPlayerIdx
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.remove('hide')
            }
        }

    },

    pauseAllVideosBeforeExit() {

        for (var index = 0; index < WatchShortVideoScriptInIOSYt.videoItems.length; index++) {
            // var video = WatchShortVideoScriptInIOSYt.videoItems[index].video;
            var player = WatchShortVideoScriptInIOSYt.videoItems[index].player;
            // TODO: Pause state
            if (!WatchShortVideoScriptInIOSYt.isPlaying) {

            } else {
                player.pauseVideo();
            }
        }

    },
    initializeVideo() {
        function formatTime(timeInSeconds) {
            const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);

            return {
                minutes: result.substr(3, 2),
                seconds: result.substr(6, 2),
            };
        };
        const videoDuration = Math.round(video.duration);
        const time = formatTime(videoDuration);
        duration.innerText = `${time.minutes}:${time.seconds}`;
        duration.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
    },

    setEventsForVideo() {

        var videos = document.querySelectorAll("video");

        document.querySelectorAll('video').forEach(video => {
            video.addEventListener('timeupdate', event => {
                if (video.currentTime > 10 && video.currentTime < 11) {
                    if (WatchShortVideoScriptInIOSYt.isAllowSave == true) {
                        if (video == WatchShortVideoScriptInIOSYt.activePlayer) {
                            WatchShortVideoScriptInIOSYt.isAllowSave = false;
                            WatchShortVideoScriptInIOSYt.SaveShortVideoAction(video);
                            //WatchShortVideoScriptInIOSYt.isAllowSave = true;
                        }
                    }
                }
                //handle click
            })

            // video.addEventListener('ended', event => {
            //     video.currentTime=0;
            //      var activerowindex= WatchShortVideoScriptInIOSYt.activePlayerRowIndex;

            //      var playiconId = "playicon" + activerowindex

            //      if (document.getElementById(playiconId)) {
            //         document.getElementById(playiconId).classList.remove('hide')
            //     }
            //     //  alert("Video Id "+ video.id + " end" )
            //     //handle click
            // })

            video.addEventListener('ended', event => {
                video.currentTime = 0;
                var activerowindex = WatchShortVideoScriptInIOSYt.activePlayerRowIndex;

                var replayiconId = "replayicon" + activerowindex

                if (document.getElementById(replayiconId)) {
                    document.getElementById(replayiconId).classList.remove('hide')
                }
                //  alert("Video Id "+ video.id + " end" )
                //handle click
            })


        })


    },


}

/* harmony default export */ const js_WatchShortVideoScriptInIOSYt = (WatchShortVideoScriptInIOSYt);
;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/LiveSessionManagement.vue?vue&type=template&id=ccc7fbe8


const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_1 = {
  class: "watched-videos",
  id: "talktimemanagement-form"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_2 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("h3", { class: "align-center mt-2" }, "Live-Session Management", -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_3 = { key: 0 }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_4 = {
  key: 0,
  class: "sk-container",
  style: {"display":"flex","gap":"3rem"}
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_5 = {
  key: 0,
  class: "filter-group"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_6 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Coach", -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_7 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_8 = ["value", "id", "onClick"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_9 = {
  key: 1,
  class: "filter-group"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_10 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Month", -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_11 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_12 = ["value", "id"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_13 = {
  key: 1,
  class: "sk-container",
  style: {"display":"flex","gap":"3rem"}
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_14 = {
  key: 0,
  class: "filter-group"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_15 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("div", { class: "label" }, "Select Month", -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_16 = {
  class: "filter-dropdown",
  id: "filter-dropdown",
  "data-title": "Language Filter",
  "data-intro": "Select your preferred language to watch videos in that selected language.",
  "data-tooltip-class": "introjs-inherit",
  "data-highlight-class": "introjs-inherit"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_17 = ["value", "id"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_18 = { class: "sk-tabs" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_19 = {
  class: "sk-tabs-nav",
  id: "divStickyTab"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_20 = { class: "sk-tab-content" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_21 = {
  id: "divCalenderViewls",
  class: "sk-tab active"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_22 = {
  class: "sk-container",
  id: "divCalenderContainer"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_23 = { class: "short-videos video-group" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_24 = {
  id: "divttreportls",
  class: "sk-tab"
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_25 = { class: "sk-container" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_26 = { class: "short-videos video-group" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_27 = { key: 0 }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_28 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Date"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Meeting Type"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Sessions Allocated"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Sessions Taken"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Slot Timings"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Missed Slot(s)")
], -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_29 = ["id"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_30 = { key: 1 }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_31 = { key: 1 }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_32 = { class: "sk-popup cancel-booking show" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_33 = { class: "sk-inner" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_34 = { class: "sk-header" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_35 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#000000",
  viewBox: "0 0 256 256"
}, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("use", { "xlink:href": "#skIconclose" })
], -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_36 = [
  LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_35
]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_37 = { class: "sk-body" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_38 = { class: "sk-container" }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_39 = {
  key: 0,
  style: {"width":"100% !important"}
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_40 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, [
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Time Slot"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Topic"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Action"),
  /*#__PURE__*/(0,vue_cjs.createElementVNode)("th", null, "Remark")
], -1)
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_41 = ["id"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_42 = ["href"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_43 = ["onClick"]
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_44 = { style: {"width":"200px"} }
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_45 = {
  key: 0,
  class: ""
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_46 = {
  key: 1,
  class: ""
}
const LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_47 = /*#__PURE__*/(0,vue_cjs.createElementVNode)("tr", null, null, -1)

function LiveSessionManagementvue_type_template_id_ccc7fbe8_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FullCalendar = (0,vue_cjs.resolveComponent)("FullCalendar")

  return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_1, [
    LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_2,
    ($data.showparent)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_3, [
          (this.userRole == 1)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_4, [
                ($data.coachList.length > 0)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_5, [
                      LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_6,
                      (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_7, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[0] || (_cache[0] = $event => ($options.onCoachChange())),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedCoach) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.coachList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.coachid,
                              id: index,
                              onClick: $event => (_ctx.selectCoach(index))
                            }, (0,vue_cjs.toDisplayString)(obj.coachname), 9, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_8))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedCoach]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true),
                ($data.activeTab==3)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_9, [
                      LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_10,
                      (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_11, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[2] || (_cache[2] = $event => ($options.onMonthChange())),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedMonth) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.monthList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.monthid,
                              id: index
                            }, (0,vue_cjs.toDisplayString)(obj.month), 9, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_12))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedMonth]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]))
            : (0,vue_cjs.createCommentVNode)("", true),
          (this.userRole != 1)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_13, [
                ($data.activeTab == 3)
                  ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_14, [
                      LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_15,
                      (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_16, [
                        (0,vue_cjs.withDirectives)((0,vue_cjs.createElementVNode)("select", {
                          id: "dddlCoach",
                          onChange: _cache[4] || (_cache[4] = $event => ($options.onMonthChange())),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedMonth) = $event)),
                          class: "report-date"
                        }, [
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.monthList, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("option", {
                              value: obj,
                              key: obj.monthid,
                              id: index
                            }, (0,vue_cjs.toDisplayString)(obj.month), 9, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_17))
                          }), 128))
                        ], 544), [
                          [vue_cjs.vModelSelect, $data.selectedMonth]
                        ])
                      ])
                    ]))
                  : (0,vue_cjs.createCommentVNode)("", true)
              ]))
            : (0,vue_cjs.createCommentVNode)("", true),
          (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_18, [
            (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_19, [
              (0,vue_cjs.createElementVNode)("a", {
                id: "atagCalenderViewls",
                class: "active",
                onClick: _cache[6] || (_cache[6] = $event => ($options.NavigetToTab('CalenderView')))
              }, "Live Session Availability"),
              (0,vue_cjs.createElementVNode)("a", {
                id: "atagttreportls",
                class: "",
                onClick: _cache[7] || (_cache[7] = $event => ($options.NavigetToTab('TalktimeReport')))
              }, "Live Session Report")
            ]),
            (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_20, [
              (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_21, [
                (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_22, [
                  (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_23, [
                    (0,vue_cjs.createVNode)(_component_FullCalendar, { options: $data.calendarOptions }, null, 8, ["options"])
                  ])
                ])
              ]),
              (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_24, [
                (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_25, [
                  (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_26, [
                    ($data.talktimereport.length > 0)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_27, [
                          LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_28,
                          ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.talktimereport, (obj, index) => {
                            return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                              key: index,
                              id: index
                            }, [
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.scheduledate), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.meetingtype), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.sessionallocated), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.sessiontaken), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.timeslots), 1),
                              (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.missedtimeslots), 1)
                            ], 8, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_29))
                          }), 128))
                        ]))
                      : (0,vue_cjs.createCommentVNode)("", true),
                    ($data.talktimereport.length == 0 && $data.shownorecord == 1)
                      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_30, " No Session Available "))
                      : (0,vue_cjs.createCommentVNode)("", true)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true),
    ($data.showSlots == true)
      ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_31, [
          (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_32, [
            (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_33, [
              (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_34, [
                (0,vue_cjs.createElementVNode)("span", null, "Date : " + (0,vue_cjs.toDisplayString)($data.selectedFormatedDate), 1),
                (0,vue_cjs.createElementVNode)("div", {
                  class: "right-nav close-modal",
                  onClick: _cache[8] || (_cache[8] = $event => ($options.close()))
                }, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_36)
              ]),
              (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_37, [
                (0,vue_cjs.createElementVNode)("div", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_38, [
                  ($data.allocatedavailableslots.length > 0)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("table", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_39, [
                        LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_40,
                        ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($data.allocatedavailableslots, (obj, index) => {
                          return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("tr", {
                            key: index + 'aa',
                            id: 'slots' + index
                          }, [
                            (0,vue_cjs.createElementVNode)("td", null, (0,vue_cjs.toDisplayString)(obj.scheduleTimes), 1),
                            (0,vue_cjs.createElementVNode)("td", null, [
                              (0,vue_cjs.createElementVNode)("a", {
                                href: obj.ppturl,
                                target: "_blank"
                              }, (0,vue_cjs.toDisplayString)(obj.topic), 9, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_42)
                            ]),
                            (0,vue_cjs.createElementVNode)("td", null, [
                              (obj.isLaunchSession == 1)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("button", {
                                    key: 0,
                                    type: "button",
                                    class: "button success small",
                                    onClick: $event => (
                        $options.FetchLaunchURL(
                          obj.clubScheduleId,
                          obj.meetingId,
                          obj.coachUserId
                        )
                      )
                                  }, " Launch session ", 8, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_43))
                                : (0,vue_cjs.createCommentVNode)("", true)
                            ]),
                            (0,vue_cjs.createElementVNode)("td", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_44, [
                              (obj.isSessioncompleted == 1)
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_45, " Session Completed "))
                                : (0,vue_cjs.createCommentVNode)("", true),
                              (
                        obj.isMeetingStarted == 1 && obj.issessioncompleted != 1
                      )
                                ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("span", LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_46, "In progress "))
                                : (0,vue_cjs.createCommentVNode)("", true)
                            ])
                          ], 8, LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_41))
                        }), 128)),
                        LiveSessionManagementvue_type_template_id_ccc7fbe8_hoisted_47
                      ]))
                    : (0,vue_cjs.createCommentVNode)("", true)
                ])
              ])
            ])
          ])
        ]))
      : (0,vue_cjs.createCommentVNode)("", true)
  ]))
}
;// CONCATENATED MODULE: ./src/Components/LiveSessionManagement.vue?vue&type=template&id=ccc7fbe8

;// CONCATENATED MODULE: ./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/LiveSessionManagement.vue?vue&type=script&lang=js












/* harmony default export */ const LiveSessionManagementvue_type_script_lang_js = ({
  name: "LiveSessionManagement",
  components: {
    Datepicker: datepicker_esm,
    FullCalendar: main,
  },
  data() {
    return {
      isMobileApp: false,
      timeslots: [],
      isLoading: false,
      showparent: true,
      shownestedchild: false,
      allocatedavailableslots: [],
      selectedDate: "",
      selectedFormatedDate: "",
      showAppyLeaveForTheDayButton: 0,
      customButtons: {
        myCustomButton: {
          text: "custom!",
          click: function () {
            alert("clicked the custom button!");
          },
        },
      },
      calendarOptions: {
        plugins: [daygrid_main, interaction_main],
        initialView: "dayGridMonth",
        // dateClick: this.handleDateClick,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        showNonCurrentDates: false,
        eventsSet: this.handleEvents,
        events: [],
      },
      slotid: 0,
      scheduledatetime: null,
      talkTimescheduleid: 0,
      dropdown1_List: [
        { label: "event1", value: 1 },
        { label: "event2", value: 2 },
      ],
      dropdown2_List: [
        { label: "event3", value: 3 },
        { label: "event4", value: 4 },
      ],
      ddl1SeletedItem: { label: "event1", value: 1 },
      ddl2SeletedItem: { label: "event4", value: 4 },
      coachList: [],
      reassignCoachList: [],
      coachid: 0,
      selectedCoach: {},
      columnHeader: [],
      reallocateddetails: [],
      activeTab: 1,
      CalenderViewAvailabilitySlots: [],
      reassignSelectedCoach: {},
      reassigncoachid: 0,
      ApplyLeaveStatusList: [],
      allDayReallocateddetails: [],
      shownestedchildtble: false,
      showSlots: false,
      talktimereport: [],
      shownorecord: 0,
      monthList: [],
      selectedMonth: {},
    };
  },

  props: {
    userPid: { type: Number, required: true, default: 0 },
    sulekhaApp: null,
    userRole: 0,
  },

  mounted: function () {
    var hdnIsMobileApp = document.getElementById("hdnIsMobileApp");
    const d = new Date();
    let month = d.getMonth() + 1;
    this.selectedMonth =   { month: "February", monthid: 2, year: 2023 }
    this.populatemonth();
    if (hdnIsMobileApp) {
      if (hdnIsMobileApp.value == "true") {
        this.isMobileApp = true;
      } else {
        this.isMobileApp = false;
      }
    }
    // assign props to vue componets state value
    //this.timeslots = this.availableSlots;

    if (this.userRole == 1) {
      // admin

      this.FetchCoahList();
    } else if (this.userRole == 2) {
      // Coach
      this.coachid = this.userPid;
      //  this.FetchCoachTalkTimeAvailabilitySlot();    { month: "January", monthid: 1, year: 2023 },
      this.FetchModeratorCalenderViewSlotAvailability();
    }
  },
  methods: {
    // populatemonth() {
    //   var Months = [     
    //     { month: "February", monthid: 2, year: 2023 },
    //     { month: "March", monthid: 3, year: 2023 },
    //     { month: "April", monthid: 4, year: 2023 },
    //     { month: "May", monthid: 5, year: 2023 },
    //     { month: "June", monthid: 6, year: 2023 },
    //     { month: "July", monthid: 7, year: 2023 },
    //     { month: "August", monthid: 8, year: 2023 },
    //     { month: "September", monthid: 9, year: 2023 },
    //     { month: "October", monthid: 10, year: 2023 },
    //     { month: "November", monthid: 11, year: 2023 },
    //     { month: "December", monthid: 12, year: 2023 },
    //   ];
    //   this.monthList = Months;
    // },


    populatemonth() {
      // var Months = [
      //   { month: "February", monthid: 2, year: 2023 },
      //   { month: "March", monthid: 3, year: 2023 },
      //   { month: "April", monthid: 4, year: 2023 },
      //   { month: "May", monthid: 5, year: 2023 },
      //   { month: "June", monthid: 6, year: 2023 },
      //   { month: "July", monthid: 7, year: 2023 },
      //   { month: "August", monthid: 8, year: 2023 },
      //   { month: "September", monthid: 9, year: 2023 },
      //   { month: "October", monthid: 10, year: 2023 },
      //   { month: "November", monthid: 11, year: 2023 },
      //   { month: "December", monthid: 12, year: 2023 },
      // ];

      let currentmonth = new Date();
      let previousmonth = new Date();
      previousmonth = new Date(previousmonth.setMonth(previousmonth.getMonth()-1));

      var currentmonthname = currentmonth.toLocaleString("default", {
        month: "long",
      });
      var previousmonthname = previousmonth.toLocaleString("default", {
        month: "long",
      });

      let currentmonthyear = currentmonth.getFullYear();
      let previousmonthyear = previousmonth.getFullYear();

      // alert(currentmonth + "" + previousmonth);
      // alert(currentmonthname + "" + previousmonthname);
      // alert(currentmonthyear + "" + previousmonthyear);

      let Months = [];
      if (previousmonth.getMonth() + 1 == 1 && previousmonthyear == 2023) {
        Months.push({
          month: currentmonthname + "-" + currentmonthyear,
          monthid: currentmonth.getMonth() + 1,
          year: currentmonthyear,
        });
        this.selectedMonth = Months[0];
      } else {
        Months.push({
          month: previousmonthname + "-" + previousmonthyear,
          monthid: previousmonth.getMonth() + 1,
          year: previousmonthyear,
        });
        Months.push({
          month: currentmonthname + "-" + currentmonthyear,
          monthid: currentmonth.getMonth() + 1,
          year: currentmonthyear,
        });
        this.selectedMonth = Months[1];
      }

      //   let premonth=d.getMonth();
      //   let month = d.getMonth() + 1;
      //  let selcurrentmonth=this.monthList[month]
      //  this.selectedMonth = selcurrentmonth;
      //  var selpreviousmonth=this.monthList[premonth]

      this.monthList = Months;
    },
    displayMarkAsHolidayCofirmDialog() {
      document.getElementById("dialogMarkAsHoliday").classList.remove("hide");
    },
    cancelDialogMarkAsHoliday() {
      document.getElementById("dialogMarkAsHoliday").classList.add("hide");
    },

    confirmDialogMarkAsHoliday() {
      this.ApplyLeaveForTheDay();
    },

    displayMarkAsNACofirmDialog(slotid, scheduledatetime, talkTimescheduleid) {
      document.getElementById("dialogMarkAsNA").classList.remove("hide");
      this.slotid = slotid;
      this.scheduledatetime = scheduledatetime;
      this.talkTimescheduleid = talkTimescheduleid;
    },
    cancelDialogMarkAsNA() {
      document.getElementById("dialogMarkAsNA").classList.add("hide");
    },

    confirmDialogMarkAsNA() {
      this.updateLeave(
        this.slotid,
        this.scheduledatetime,
        this.talkTimescheduleid
      );
    },

    displayMarkAsAvaiableCofirmDialog(
      slotid,
      scheduledatetime,
      talkTimescheduleid
    ) {
      document.getElementById("dialogMarkAsAvailable").classList.remove("hide");
      this.slotid = slotid;
      this.scheduledatetime = scheduledatetime;
      this.talkTimescheduleid = talkTimescheduleid;
    },

    cancelDialogMarkAsAvailable() {
      document.getElementById("dialogMarkAsAvailable").classList.add("hide");
    },

    confirmDialogMarkAsAvailable() {
      this.cancelLeave(
        this.slotid,
        this.scheduledatetime,
        this.talkTimescheduleid
      );
    },

    confirmDialogMonthlyView() {
      document.getElementById("dialogMonthlyView").classList.add("hide");
    },

    //  cancelDialogMarkAsHoliday()
    //    {

    //    },
    NavigetToTab(tab) {
      if (tab == "UpdateAvail") {
        this.activeTab = 2;
        this.FetchCoachTalkTimeAvailabilitySlot();
        document.getElementById("atagAvailability").classList.add("active");
        document.getElementById("divAvailability").classList.add("active");

        document.getElementById("atagCalenderViewls").classList.remove("active");
        document.getElementById("divCalenderViewls").classList.remove("active");
        document.getElementById("atagttreportls").classList.remove("active");
        document.getElementById("divttreportls").classList.remove("active");
      } else if (tab == "CalenderView") {
        this.activeTab = 1;
        this.FetchModeratorCalenderViewSlotAvailability();

        document.getElementById("atagCalenderViewls").classList.add("active");
        document.getElementById("divCalenderViewls").classList.add("active");

        document.getElementById("atagttreportls").classList.remove("active");
        document.getElementById("divttreportls").classList.remove("active");

        document.getElementById("atagAvailability").classList.remove("active");
        document.getElementById("divAvailability").classList.remove("active");

        
      } else if (tab == "TalktimeReport") {
        this.activeTab = 3;
        this.FetchTalktimeReport();
        document.getElementById("atagttreportls").classList.add("active");
        document.getElementById("divttreportls").classList.add("active");

        document.getElementById("atagCalenderViewls").classList.remove("active");
        document.getElementById("divCalenderViewls").classList.remove("active");

        document.getElementById("atagAvailability").classList.remove("active");
        document.getElementById("divAvailability").classList.remove("active");
      }
    },
    FetchCoachTalkTimeAvailabilitySlot() {
      CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachTalkTimeSlotAvailability.execute(
        { UserPid: this.userPid, CoachUserPid: this.coachid },
        (response) => {
          this.timeslots = response.data;
        }
      );
    },
    FetchTalktimeReport() {
      this.shownorecord = 0;
      CSMainAPIs.Capshine.TalktimeAPIs.FetchTalktimeReport.execute(
        { UserPid: this.coachid, sessiontypeid: 1,monthid:this.selectedMonth.monthid,year:this.selectedMonth.year },
        (response) => {
          this.talktimereport = response.data;
          this.shownorecord = 1;
        }
      );
    },

    FetchModeratorCalenderViewSlotAvailability() {
      this.calendarOptions.events = [];
      var calendarEventList = [];
      var rowindex = 1;
      var eventcolore = "#bfbfbf";
      var bgrndcolor = " #bfbfbf";
      CSMainAPIs.Capshine.TalktimeAPIs.FetchLiveClassSessionAvailability.execute(
        { CoachUserPid: this.coachid },
        (response) => {
          this.CalenderViewAvailabilitySlots = response.data;

          this.CalenderViewAvailabilitySlots.forEach((resobj) => {
            // allocatedCount CoachUserPid
            var Title =
              resobj.availableCount +
              " Slots" +
              "," +
              resobj.allocatedCount +
              " Booked";
            console.log(Title);

            //  mode: "launchsession",

            calendarEventList.push({
              id: rowindex,
              title: resobj.scheduleTimes,
              borderColor: eventcolore,
              // backgroundColor:"#FFFFFF",
              extendedProps: {
                date: dateFormat(resobj.scheduleDate, "yyyy-mm-dd"),
              },
              date: dateFormat(resobj.scheduleDate, "yyyy-mm-dd"),
              textColor: "#333",
              color: bgrndcolor,
              allDaySlot: false,
            });

            // if(resobj.mode=="launchsession") {

            //   calendarEventList.push({
            //     id: rowindex,
            //     title: dateFormat(resobj.scheduleDateTime, "yyyy-mm-dd hh:MM TT"),
            //     dateTime: resobj.scheduleDateTime,
            //     clubScheduleId: resobj.clubScheduleId,
            //     borderColor: eventcolore,
            //     // backgroundColor:"#FFFFFF",
            //     extendedProps: {
            //     clubScheduleId: resobj.clubScheduleId,
            //     meetingId: parseInt(resobj.meetingId),
            //       userPid: resobj.coachUserId,
            //       availableDate: resobj.availableDate,
            //       coachUserPid: resobj.coachUserPid,
            //       isLaunchSession: resobj.isLaunchSession,
            //       isSessionCompleted: resobj.isSessionCompleted,
            //       date: dateFormat(resobj.scheduleDateTime, "yyyy-mm-dd"),
            //       topicrowid:0,
            //       mode:'launchsession',
            //       meetingurl:''
            //     },
            //     date: dateFormat(resobj.scheduleDateTime, "yyyy-mm-dd"),
            //     textColor: "#333",
            //     color: bgrndcolor,
            //     allDaySlot: false,
            //   });
            // }
            // else {
            //   if(resobj.topicrowid>0){
            //     calendarEventList.push({
            //     id: rowindex,
            //     title:"OpenPPT",
            //     dateTime: resobj.scheduleDateTime,
            //     clubScheduleId: resobj.clubScheduleId,
            //     borderColor:"#0000EE",
            //     // backgroundColor:"#FFFFFF",
            //     extendedProps: {
            //     clubScheduleId: resobj.clubScheduleId,
            //     meetingId: parseInt(resobj.meetingId),
            //       userPid: resobj.coachUserId,
            //       availableDate: resobj.availableDate,
            //       coachUserPid: resobj.coachUserPid,
            //       isLaunchSession: resobj.isLaunchSession,
            //       isSessionCompleted: resobj.isSessionCompleted,
            //       date: dateFormat(resobj.scheduleDateTime, "yyyy-mm-dd"),
            //       topicrowid:resobj.topicrowid,
            //       mode:'openppt',
            //       meetingurl:resobj.ppturl
            //     },
            //     date: dateFormat(resobj.scheduleDateTime, "yyyy-mm-dd"),
            //     textColor: "#FFFFFF",
            //     color: "#0000EE",
            //     allDaySlot: false,
            //   });
            //   }
            // }
          });

          this.calendarOptions.events = calendarEventList;

          setTimeout(() => {
            var divScroolElement = document.getElementsByClassName(
              "fc-scroller-liquid-absolute"
            )[0];
            var divCalenderContainer = document.getElementById(
              "divCalenderContainer"
            );
            var divStickyTab = document.getElementById("divStickyTab");

            if (divStickyTab) {
              divStickyTab.style.position = "inherit";
            }

            if (divScroolElement) {
              divScroolElement.style.overflow = "";
            }

            if (divCalenderContainer) {
              divCalenderContainer.style.overflow = "auto";
              divCalenderContainer.style.height = "800px";
            }
          }, 500);
        }
      );
    },

    FetchCoahList() {
      // CSMainAPIs.Capshine.TalktimeAPIs.FetchCoahList.execute(
      //   { UserPid: this.userPid },
      //   (response) => {
      //     this.coachList = response.data;
      //     this.selectedCoach = this.coachList[0];
      //     this.coachid = this.selectedCoach.coachid;

      //     if (this.activeTab == 2) {
      //       this.FetchCoachTalkTimeAvailabilitySlot();
      //     }
      //     if (this.activeTab == 1) {
      //       this.FetchModeratorCalenderViewSlotAvailability();
      //     }
      //   }
      // );
      CSMainAPIs.Capshine.TalktimeAPIs.GetCoachInformationForLiveSessions.execute(
        {},
        (response) => {
          this.coachList = response.data;
          this.selectedCoach = this.coachList[0];
          this.coachid = this.selectedCoach.coachid;

          if (this.activeTab == 2) {
            this.FetchCoachTalkTimeAvailabilitySlot();
          }
          if (this.activeTab == 1) {
            this.FetchModeratorCalenderViewSlotAvailability();
          }
          if (this.activeTab == 3) {
            this.FetchTalktimeReport();
          }
        }
      );
    },
    FetchReAssignCoachList(ScheduledId) {
      ///reassignCoachList

      CSMainAPIs.Capshine.TalktimeAPIs.FetchCoahList.execute(
        { UserPid: this.coachid, ScheduledId: ScheduledId },
        (response) => {
          this.shownestedchild = true;
          this.reassignCoachList = response.data;
          this.reassignSelectedCoach = this.reassignCoachList[0];
          this.reassigncoachid = this.reassignSelectedCoach.coachid;
        }
      );
    },

    onCoachChange(index) {
      this.reallocateddetails = [];
      //this.selectedCoach=this.coachList[index];
      this.coachid = this.selectedCoach.coachid;
      // this.FetchCoachTalkTimeAvailabilitySlot();
      if (this.activeTab == 2) {
        this.FetchCoachTalkTimeAvailabilitySlot();
      }
      if (this.activeTab == 1) {
        this.FetchModeratorCalenderViewSlotAvailability();
      }
      if (this.activeTab == 3) {
        this.FetchTalktimeReport();
      }
    },
  onMonthChange(index) {
   
      if (this.activeTab == 3) {
        this.FetchTalktimeReport();
      }
    },
    onReassignCoachChange(index) {
      //this.selectedCoach=this.coachList[index];
      this.reassigncoachid = this.reassignSelectedCoach.coachid;
      // this.FetchCoachTalkTimeAvailabilitySlot();
    },

    // handleDateClick: function (arg) {
    //   alert("date click! " + arg.dateStr);
    // },
    selectiddl2(obj) {
      this.onselectioncallback(obj);
    },
    selectiddl1(obj) {
      this.onselectioncallback(obj);
    },

    handleDateSelect(selectInfo) {},
    async handleEventClick(clickInfo) {
      this.calendarOptions.events = [];
      var calendarEventList = [];
      var rowindex = 1;
      var eventcolore = "#bfbfbf";
      var bgrndcolor = " #bfbfbf";

      this.selectedDate = clickInfo.event.extendedProps.date;

      var now = new Date(clickInfo.event.extendedProps.date);

      this.selectedFormatedDate = dateFormat(now, "dddd, mmmm dS, yyyy");

      CSMainAPIs.Capshine.TalktimeAPIs.FetchLiveClassSessionList.execute(
        {
          CoachUserPid: this.coachid,
          ScheduleDate: clickInfo.event.extendedProps.date,
        },
        (response) => {
          this.showSlots = true;
          this.allocatedavailableslots = response.data;
          console.log(this.allocatedavailableslots);
        }
      );

      return;

      if (clickInfo.event.extendedProps.mode == "launchsession") {
        if (
          !clickInfo.event.extendedProps.isLaunchSession ||
          clickInfo.event.extendedProps.isSessionCompleted
        )
          return;
        console.log(clickInfo.event.startStr);
        fetch(
          `/api/MyClub/GetClubMeetParticipantUrl?ClubScheduleId=${clickInfo.event.extendedProps.clubScheduleId}&UserPid=${clickInfo.event.extendedProps.userPid}&MeetingId=${clickInfo.event.extendedProps.meetingId}&IsCoach=true`
        )
          .then((response) => response.json())
          .then((data) => {
            window.open(data.result.meetingUrl, "_blank");
          });
      } else {
        window.open(clickInfo.event.extendedProps.meetingurl, "_blank");

        //  var url="https://view.officeapps.live.com/op/view.aspx?src="+clickInfo.event.extendedProps.meetingurl
        //    window.open(url, '_blank');
      }
    },
    // handleDateClick: function (arg) {
    //   ///    alert("handleDateClick click! " + arg.dateStr);
    //   this.fetchAailableslotforselcteday(arg.dateStr);
    // },
    handleEvents(events) {},
    // fetchAailableslotforselcteday(dateStr) {
    //   var now = new Date(dateStr);

    //   var nextmonth = new Date();

    //   nextmonth.setMonth(nextmonth.getMonth() + 1);

    //   var currentDate = new Date();
    //   if (now.getMonth() < currentDate.getMonth()) {
    //     alert("You can update schedule for current & next month only");
    //   } else if (now > nextmonth) {
    //     alert("You can update schedule for current & next month only");
    //   } else {
    //     this.selectedDate = dateStr;
    //     this.selectedFormatedDate = dateFormat(now, "dddd, mmmm dS, yyyy");
    //     CSMainAPIs.Capshine.TalktimeAPIs.FetchLiveClassSessionAvailability.execute(
    //       { CoachUserPid: this.coachid },
    //       (response) => {
    //         this.allocatedavailableslots = response.data;
    //         this.showparent = false;
    //         //  if(this.allocatedavailableslots.length>0){
    //         // this.showAppyLeaveForTheDayButton=this.allocatedavailableslots[0].showAppyLeaveForTheDayButton;
    //         //  }
    //       }
    //     );
    //   }
    // },
    close() {
      this.showparent = true;
      this.showSlots = false;
      this.FetchModeratorCalenderViewSlotAvailability();
    },
    closenestedchild() {
      this.shownestedchild = false;
      this.showparent = true;
      this.FetchModeratorCalenderViewSlotAvailability();
    },

    closenestedchildtble() {
      this.shownestedchild = false;
      this.shownestedchildtble = false;
      this.showparent = true;
      this.FetchModeratorCalenderViewSlotAvailability();
    },

    FetchLaunchURL(clubScheduleId, meetingId, coachUserId) {
      fetch(
        `/api/MyClub/GetClubMeetParticipantUrl?ClubScheduleId=${clubScheduleId}&UserPid=${coachUserId}&MeetingId=${meetingId}&IsCoach=true`
      )
        .then((response) => response.json())
        .then((data) => {
          this.close();
          window.open(data.result.meetingUrl, "_blank");
        });
    },

    getSessionNotAllocatedStatus(obj) {
      var curreentDatetime = new Date(); //Today Date

      curreentDatetime.setMinutes(curreentDatetime.getMinutes() + 16);

      if (
        (obj.issessioncompleted == 1 || obj.issessioncompleted == 1) &&
        obj.issessioncompleted.scheduledatetime < curreentDatetime &&
        obj.talkTimescheduleid == 0 &&
        obj.isleaveupdated == 0
      ) {
        return true;
      } else return false;
    },
  },
});

;// CONCATENATED MODULE: ./src/Components/LiveSessionManagement.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Components/LiveSessionManagement.vue




;
const LiveSessionManagement_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(LiveSessionManagementvue_type_script_lang_js, [['render',LiveSessionManagementvue_type_template_id_ccc7fbe8_render]])

/* harmony default export */ const LiveSessionManagement = (LiveSessionManagement_exports_);
;// CONCATENATED MODULE: ./src/js/LiveSessionManagementToolScript.js




let LiveSessionManagementToolScript = {
	userPid: 0,
	activityTypes: [],
	sulekhaApp: null,
	userRole:0,
	init: function (userPid, sulekhaApp = null) {
		
		this.sulekhaApp = sulekhaApp;
		LiveSessionManagementToolScript.userPid = userPid;
       
		var page=document.getElementById('divAdminpage');

		if (page) {
			LiveSessionManagementToolScript.userRole=page.getAttribute("data-userrole");

			LiveSessionManagementToolScript.bindComponent();
			//  if(LiveSessionManagementToolScript.userRole==1) // admin 
			//  {
			// 	LiveSessionManagementToolScript.FetchCoahList()
			//  }
			//  else if (LiveSessionManagementToolScript.userRole==2){ // Coach
			// 	if (LiveSessionManagementToolScript.userPid)
			// 	{	
			// 		LiveSessionManagementToolScript.FetchCoachTalkTimeAvailabilitySlot();
			// 	}
			//  }
		}
		

		
	},

	FetchCoahList(){
		CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachList.execute({ "UserPid": LiveSessionManagementToolScript.userPid }, LiveSessionManagementToolScript.apiCoachApiCallBackResponse);
	},

	apiCoachApiCallBackResponse:function(response){
		if (document.getElementById('divMiniTalkTimeAdmin')) {
			const props = {
				userRole:LiveSessionManagementToolScript.userRole,
				userPid: LiveSessionManagementToolScript.userPid,
				sulekhaApp:LiveSessionManagementToolScript.sulekhaApp
				// coachList: response.data
			};
			const createResponseVue = (0,vue_cjs.createApp)(LiveSessionManagement, props);
			createResponseVue.mount('#divMiniTalkTimeAdmin');

		}
	},

 FetchCoachTalkTimeAvailabilitySlot(){
	CSMainAPIs.Capshine.TalktimeAPIs.FetchCoachTalkTimeSlotAvailability.execute({ "UserPid": LiveSessionManagementToolScript.userPid }, LiveSessionManagementToolScript.bindComponent);
   },

	bindComponent: function (response) {


		if (document.getElementById('divMiniTalkTimeAdmin')) {
			// const props = {
			//      userPid: LiveSessionManagementToolScript.userPid,
			// 	 sulekhaApp:LiveSessionManagementToolScript.sulekhaApp,
			// 	 availableSlots: response.data
			// };
			// const createResponseVue = createApp(LiveSessionManagement, props);
			// createResponseVue.mount('#divMiniTalkTimeAdmin');

			const props = {
				userRole:LiveSessionManagementToolScript.userRole,
				userPid: LiveSessionManagementToolScript.userPid,
				sulekhaApp:LiveSessionManagementToolScript.sulekhaApp
				// coachList: response.data
			};
			const createResponseVue = (0,vue_cjs.createApp)(LiveSessionManagement, props);
			createResponseVue.mount('#divMiniTalkTimeAdmin');

		}
	},
	ShowHeaderFooter: function () {
		let DivHeader = document.getElementById('capShineHeader');    //header-sticky
		let DivFooter = document.getElementById('capShineFooter');

		if (DivHeader != null) {
			if (DivHeader.classList.contains('hide')) {
				DivHeader.classList.remove('hide')
			}
		}

		if (DivFooter != null) {
			if (DivFooter.classList.contains('hide')) {
				DivFooter.classList.remove('hide')
			}
		}
	},
}
/* harmony default export */ const js_LiveSessionManagementToolScript = (LiveSessionManagementToolScript);
;// CONCATENATED MODULE: ./src/js/TalktimeManageSession.js
﻿




let TalktimeManageSession = {
	userPid: 0,
	sulekhaApp: null,
	isMobileApp: false,
	selectedTalkTimeScheduleId: 0,
	selectedDate: '',
	coachId: 0,
	reassignCoachList: [],
	reassigncoachid: 0,
	reassigncoachname: '',
	divreassignpopup: null,
	ddlReassignCoach: null,
	isLoading: false,
	coachname: '',
	time: '',
	init: function (userPid, pageName, sulekhaApp = null) {
		TalktimeManageSession.sulekhaApp = sulekhaApp;
		var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

		if (hdnIsMobileApp) {
			if (hdnIsMobileApp.value == "true") {
				TalktimeManageSession.isMobileApp = true;
			}
			else {
				TalktimeManageSession.isMobileApp = false;
			}
		}
		TalktimeManageSession.userPid = userPid;

		TalktimeManageSession.bindEvents();

	},
	bindEvents: function () {

		// TalktimeManageSession.bindSlotEvents();

		// 	<div class="overlay hide" id="confirmDialogCancelSession">
		// 	<div class="popup">
		// 		<p>Are you sure you want to Cancel the session?</p>
		// 		<div class="text-right">
		// 			<button class="dialog-ok-btn" id="cancelconfirmDialogOk">
		// 				Ok
		// 			</button>
		// 			<button class="dialog-cancel-btn"
		// 					id="cancelconfirmDialogCancel">
		// 				Cancel
		// 			</button>
		// 		</div>
		// 	</div>
		// </div>



		var cancelconfirmDialogOk = document.getElementById("cancelconfirmDialogOk");
		var cancelconfirmDialogCancel = document.getElementById("cancelconfirmDialogCancel");

		var confirmDialogCancelSession = document.getElementById("confirmDialogCancelSession");

		if (cancelconfirmDialogOk) {
			cancelconfirmDialogOk.addEventListener("click", function () {

				TalktimeManageSession.CancelTalkTimeSchedule();
			})
		}


		if (cancelconfirmDialogCancel) {
			cancelconfirmDialogCancel.addEventListener("click", function () {

				confirmDialogCancelSession.classList.add('hide');


			})
		}



		var reallocateconfirmDialogOk = document.getElementById("reallocateconfirmDialogOk");
		var cancelconfirmDialogReallocate = document.getElementById("cancelconfirmDialogReallocate");

		var confirmDialogReallocateSession = document.getElementById("confirmDialogReallocateSession");

		if (reallocateconfirmDialogOk) {
			reallocateconfirmDialogOk.addEventListener("click", function () {
				//var confirmDialogReallocateSession = document.getElementById("confirmDialogReallocateSession");
				////confirmDialogReallocateSession.classList.remove('hide');
				TalktimeManageSession.ReScheduleModerator();

			})
		}


		if (cancelconfirmDialogReallocate) {
			cancelconfirmDialogReallocate.addEventListener("click", function () {

				confirmDialogReallocateSession.classList.add('hide');


			})
		}




		const slotDate = document.querySelectorAll("[data-slotdate]");
		if (slotDate) {
			let row = 1;
			slotDate.forEach(function (date) {
				if (row == 1) {
					TalktimeManageSession.selectedDate = date.getAttribute('data-slotdate');;
				}
				row = row + 1;
				date.addEventListener("click", function () {
					const clickedDate = date.getAttribute('data-slotdate');
					TalktimeManageSession.selectedDate = clickedDate;
					document.getElementById('talktime-slots').innerHTML = "";
					document.querySelectorAll("[data-slotdate]").forEach((e) => { e.classList.remove('selected'); });
					date.classList.add('selected');
					CSMainAPIs.Capshine.TalktimeAPIs.GetTalkTimeManageSession.execute({ ScheduleDateTime: clickedDate, UserPid: parseInt(TalktimeManageSession.userPid) }, (response) => {
						document.getElementById('talktime-slots').innerHTML = response.data.talktimeHtml;
						setTimeout(TalktimeManageSession.bindEvents, 500);


					});
				});
			});
		}

		const cancellist = document.querySelectorAll("[data-cancel]");
		if (cancellist) {
			cancellist.forEach(function (data) {
				data.addEventListener("click", function () {
					const talkTimeScheduleId = data.getAttribute('data-talkTimeScheduleId');
					TalktimeManageSession.selectedTalkTimeScheduleId = talkTimeScheduleId;

					TalktimeManageSession.coachId = data.getAttribute('data-coachid');

					TalktimeManageSession.coachname = data.getAttribute('data-name');

					TalktimeManageSession.time = data.getAttribute('data-time');

					var confirmDialogCancelSession = document.getElementById("confirmDialogCancelSession");

					confirmDialogCancelSession.classList.remove('hide');


				});
			});
		}

		const reallocatelist = document.querySelectorAll("[data-reallocate]");
		if (reallocatelist) {
			reallocatelist.forEach(function (data) {
				data.addEventListener("click", function () {
					const talkTimeScheduleId = data.getAttribute('data-talkTimeScheduleId');
					TalktimeManageSession.selectedTalkTimeScheduleId = talkTimeScheduleId;
					TalktimeManageSession.coachId = data.getAttribute('data-coachid');

					TalktimeManageSession.coachname = data.getAttribute('data-name');

					TalktimeManageSession.time = data.getAttribute('data-time');




					TalktimeManageSession.FetchReAssignCoachList();


				});
			});
		}

		TalktimeManageSession.divreassignpopup = document.getElementById("divreassingpopup");

		var svgpopupclose = document.getElementById("svgpopupclose");


		if (svgpopupclose) {
			svgpopupclose.addEventListener("click", function () {
				TalktimeManageSession.divreassignpopup.classList.add('hide');
			})
		}

		var btnupdate = document.getElementById("btnupdate");


		if (btnupdate) {
			btnupdate.addEventListener("click", function () {
				//TalktimeManageSession.divreassignpopup.classList.add('hide');
				//TalktimeManageSession.ReScheduleModerator();

				if (TalktimeManageSession.reassigncoachid == 0) {
					alert("Please select moderator")
				}
				else {
					var p = document.getElementById("pageReallocate");
					if (p) {
						p.innerHTML = "You are reassigning the " + TalktimeManageSession.time
							+ " Session from " + TalktimeManageSession.coachname + " to " + TalktimeManageSession.reassigncoachname
					}

					var confirmDialogReallocateSession = document.getElementById("confirmDialogReallocateSession");

					confirmDialogReallocateSession.classList.remove('hide')

				}
			})
		}

		const ddlReassignCoach = document.getElementById("dddlReassignCoach");
		TalktimeManageSession.ddlReassignCoach = ddlReassignCoach;
		if (ddlReassignCoach) {
			ddlReassignCoach.onchange = function () {
				
				TalktimeManageSession.reassigncoachid = ddlReassignCoach.value;
				TalktimeManageSession.reassigncoachname = ddlReassignCoach.selectedOptions[0].text;

				// const value = select.value;
				// const desc = select.selectedOptions[0].text;
				//alert(TalktimeManageSession.reassigncoachid);
			}
		}

	},

	CancelTalkTimeSchedule() {
		TalktimeManageSession.isLoading = true;

		var divCancelActionBtn = document.getElementById("divCancelActionBtn");

		var pageCancel = document.getElementById("pageCancel");


		divCancelActionBtn.classList.add('hide')
		pageCancel.innerHTML = "Cancelling  the session.  Please wait...."

		CSMainAPIs.Capshine.TalktimeAPIs.CancelTalkTimeSchedule.execute(
			{
				CoachUserPid: TalktimeManageSession.coachId,
				ScheduledId: TalktimeManageSession.selectedTalkTimeScheduleId,
				UserPid: TalktimeManageSession.userPid
			},
			(response) => {

				divCancelActionBtn.classList.remove('hide')
				pageCancel.innerHTML = "Are you sure you want to Cancel the session?"
				let clickedDate = TalktimeManageSession.selectedDate
				document.getElementById('talktime-slots').innerHTML = "";
				document.querySelectorAll("[data-slotdate]").forEach((e) => { e.classList.remove('selected'); });
				//date.classList.add('selected');
				CSMainAPIs.Capshine.TalktimeAPIs.GetTalkTimeManageSession.execute({ ScheduleDateTime: clickedDate, UserPid: parseInt(TalktimeManageSession.userPid) }, (response) => {
					document.getElementById('talktime-slots').innerHTML = response.data.talktimeHtml;
					setTimeout(TalktimeManageSession.bindEvents, 500);
				});

				//alert('Session Successfully canceled')
				var res = response.data;
				TalktimeManageSession.isLoading = false;
				var confirmDialogCancelSession = document.getElementById("confirmDialogCancelSession");
				if (confirmDialogCancelSession) {
					confirmDialogCancelSession.classList.add('hide');
				}

			})

	},

	ReScheduleModerator() {
		// this.talkTimescheduleid ,this.coachid ,this.userPid,this.reassigncoachid
		//  int CoachUserPid, int ScheduledId, int UserPid, int NextUserPid

		var divReAllocateActionBtn = document.getElementById("divReAllocateActionBtn");

		var pageReallocate = document.getElementById("pageReallocate");


		divReAllocateActionBtn.classList.add('hide')
		pageReallocate.innerHTML = "Reallocating the Moderator.  Please wait...."

		TalktimeManageSession.isLoading = true;
		CSMainAPIs.Capshine.TalktimeAPIs.ReScheduleModerator.execute(
			{
				CoachUserPid: TalktimeManageSession.coachId,
				ScheduledId: TalktimeManageSession.selectedTalkTimeScheduleId,
				UserPid: TalktimeManageSession.userPid,
				NextUserPid: TalktimeManageSession.reassigncoachid
			},
			(response) => {
				TalktimeManageSession.isLoading = false;
				var res = response.data;

				divReAllocateActionBtn.classList.remove('hide')
				pageReallocate.innerHTML = ""

				if (res.status == "1") {

					// TalktimeManageSession.selectedDate = clickedDate;
					let clickedDate = TalktimeManageSession.selectedDate
					document.getElementById('talktime-slots').innerHTML = "";
					document.querySelectorAll("[data-slotdate]").forEach((e) => { e.classList.remove('selected'); });
					//date.classList.add('selected');
					CSMainAPIs.Capshine.TalktimeAPIs.GetTalkTimeManageSession.execute({ ScheduleDateTime: clickedDate, UserPid: parseInt(TalktimeManageSession.userPid) }, (response) => {
						document.getElementById('talktime-slots').innerHTML = response.data.talktimeHtml;
						setTimeout(TalktimeManageSession.bindEvents, 500);
					});

					///alert("Updated");

					var confirmDialogReallocateSession = document.getElementById("confirmDialogReallocateSession");
					confirmDialogReallocateSession.classList.remove('hide');


				} else {
					alert("Unable to update");
					TalktimeManageSession.divreassignpopup.classList.add('hide');
				}
			}
		);
	},
	bindSlotEvents: function () {

	},
	FetchReAssignCoachList() {
		///reassignCoachList

		//	if(TalktimeManageSession.reassignCoachList.length==0) {
		TalktimeManageSession.reassigncoachid = 0;
		CSMainAPIs.Capshine.TalktimeAPIs.FetchCoahList.execute(
			{ UserPid: TalktimeManageSession.coachId, ScheduledId: TalktimeManageSession.selectedTalkTimeScheduleId },
			(response) => {

				TalktimeManageSession.reassignCoachList = response.data;
				if (TalktimeManageSession.reassignCoachList.length > 0) {
					TalktimeManageSession.reassignCoachList.forEach(obj =>    // create dropdown items
					{
						TalktimeManageSession.ddlReassignCoach.add(new Option(obj.coachname, obj.coachid))
					})


				}

			}
		);

		//}

		if (TalktimeManageSession.divreassignpopup != null) {
			TalktimeManageSession.divreassignpopup.classList.remove('hide');
		}
	},





}
/* harmony default export */ const js_TalktimeManageSession = (TalktimeManageSession);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/CoachDashboard.vue?vue&type=template&id=f899c268&ts=true

const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_1 = { class: "admin-container" };
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_2 = {
    key: 1,
    class: "admin-main-content"
};
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_3 = {
    key: 2,
    class: "admin-main-content"
};
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_4 = {
    key: 3,
    class: "admin-main-content"
};
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_5 = ["src", "height"];
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_6 = {
    key: 4,
    class: "admin-main-content"
};
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_7 = ["src", "height"];
const CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_8 = { key: 5 };
function CoachDashboardvue_type_template_id_f899c268_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SideBar = (0,vue_cjs.resolveComponent)("SideBar");
    const _component_TalkTImeManagement = (0,vue_cjs.resolveComponent)("TalkTImeManagement");
    const _component_LiveSessionManagement = (0,vue_cjs.resolveComponent)("LiveSessionManagement");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_1, [
        ($data.menuItems.length > 0 && $data.isLoaded)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createBlock)(_component_SideBar, {
                key: 0,
                menuItems: $data.menuItems,
                openLink: $options.openLink,
                activePage: $data.activePage
            }, null, 8, ["menuItems", "openLink", "activePage"]))
            : (0,vue_cjs.createCommentVNode)("", true),
        ($data.activecomponent == 'talktimemanagementtool')
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_2, [
                (0,vue_cjs.createVNode)(_component_TalkTImeManagement, {
                    userPid: $props.userPid,
                    sulekhaApp: $props.sulekhaApp,
                    userRole: $props.userRole
                }, null, 8, ["userPid", "sulekhaApp", "userRole"])
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        ($data.activecomponent == 'LiveSessionManagementTool')
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_3, [
                (0,vue_cjs.createVNode)(_component_LiveSessionManagement, {
                    userPid: $props.userPid,
                    sulekhaApp: $props.sulekhaApp,
                    userRole: $props.userRole
                }, null, 8, ["userPid", "sulekhaApp", "userRole"])
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        ($data.activecomponent == 'myclubfeedback')
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_4, [
                ($data.menuItems.length > 0 && $data.isLoaded)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("iframe", {
                        key: 0,
                        src: $data.iframeUrl,
                        height: $data.iframeheight
                    }, null, 8, CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_5))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        ($data.activecomponent == 'TalktimeManageSession')
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_6, [
                ($data.menuItems.length > 0 && $data.isLoaded)
                    ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("iframe", {
                        key: 0,
                        src: $data.iframeUrl,
                        height: $data.iframeheight
                    }, null, 8, CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_7))
                    : (0,vue_cjs.createCommentVNode)("", true)
            ]))
            : (0,vue_cjs.createCommentVNode)("", true),
        ($data.isLoaded && $data.menuItems.length === 0)
            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", CoachDashboardvue_type_template_id_f899c268_ts_true_hoisted_8, " You are not Allowed to view this page, Contact Admin for further details. "))
            : (0,vue_cjs.createCommentVNode)("", true)
    ]));
}

;// CONCATENATED MODULE: ./src/Components/CoachDashboard.vue?vue&type=template&id=f899c268&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/SideBar.vue?vue&type=template&id=94801266&ts=true

const SideBarvue_type_template_id_94801266_ts_true_hoisted_1 = { class: "sk-sidebar" };
const SideBarvue_type_template_id_94801266_ts_true_hoisted_2 = { class: "sk-vertical-menu" };
const SideBarvue_type_template_id_94801266_ts_true_hoisted_3 = /*#__PURE__*/ (0,vue_cjs.createElementVNode)("div", { class: "lr-1 mb-2" }, " Menu ", -1);
const SideBarvue_type_template_id_94801266_ts_true_hoisted_4 = ["onClick"];
const SideBarvue_type_template_id_94801266_ts_true_hoisted_5 = { class: "vertical-menu-title" };
const SideBarvue_type_template_id_94801266_ts_true_hoisted_6 = ["onClick"];
const SideBarvue_type_template_id_94801266_ts_true_hoisted_7 = { class: "vertical-menu-title" };
function SideBarvue_type_template_id_94801266_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", SideBarvue_type_template_id_94801266_ts_true_hoisted_1, [
        (0,vue_cjs.createElementVNode)("div", SideBarvue_type_template_id_94801266_ts_true_hoisted_2, [
            SideBarvue_type_template_id_94801266_ts_true_hoisted_3,
            (0,vue_cjs.createElementVNode)("ul", null, [
                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($props.menuItems.filter(item => item.parentId === 0), (data, index) => {
                    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                        class: (0,vue_cjs.normalizeClass)({ 'active': data.menuUrl === $props.activePage }),
                        key: index,
                        onClick: ($event) => ($props.openLink(data.menuUrl))
                    }, [
                        (0,vue_cjs.createElementVNode)("a", null, [
                            (0,vue_cjs.createElementVNode)("span", SideBarvue_type_template_id_94801266_ts_true_hoisted_5, (0,vue_cjs.toDisplayString)(data.menuName), 1)
                        ]),
                        ($props.menuItems.filter(item => item.parentId === 0))
                            ? ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("ul", {
                                key: 0,
                                class: (0,vue_cjs.normalizeClass)($props.menuItems.filter(item => item.parentId === 0) ? 'sub-menu' : '')
                            }, [
                                ((0,vue_cjs.openBlock)(true), (0,vue_cjs.createElementBlock)(vue_cjs.Fragment, null, (0,vue_cjs.renderList)($props.menuItems.filter(item => item.parentId == data.rowId), (subItems, subIdx) => {
                                    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("li", {
                                        key: subIdx,
                                        class: (0,vue_cjs.normalizeClass)({ 'active': data.menuUrl === $props.activePage }),
                                        onClick: ($event) => ($props.openLink(subItems.menuUrl))
                                    }, [
                                        (0,vue_cjs.createElementVNode)("a", null, [
                                            (0,vue_cjs.createElementVNode)("span", SideBarvue_type_template_id_94801266_ts_true_hoisted_7, (0,vue_cjs.toDisplayString)(subItems.menuName), 1)
                                        ])
                                    ], 10, SideBarvue_type_template_id_94801266_ts_true_hoisted_6));
                                }), 128))
                            ], 2))
                            : (0,vue_cjs.createCommentVNode)("", true)
                    ], 10, SideBarvue_type_template_id_94801266_ts_true_hoisted_4));
                }), 128))
            ])
        ])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/SideBar.vue?vue&type=template&id=94801266&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/SideBar.vue?vue&type=script&lang=ts
/* harmony default export */ const SideBarvue_type_script_lang_ts = ({
    name: "SideBar",
    data() {
        return {
            isSidebarOpen: true
        };
    },
    props: {
        menuItems: { type: Array, required: true },
        openLink: { type: Function, required: true },
        activePage: { type: String, required: true },
    },
    methods: {
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen;
        },
    },
});

;// CONCATENATED MODULE: ./src/Components/SideBar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/SideBar.vue




;
const SideBar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SideBarvue_type_script_lang_ts, [['render',SideBarvue_type_template_id_94801266_ts_true_render]])

/* harmony default export */ const SideBar = (SideBar_exports_);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/CoachDashboard.vue?vue&type=script&lang=ts





/* harmony default export */ const CoachDashboardvue_type_script_lang_ts = ({
    name: "CoachDashboard",
    data() {
        return {
            isSidebarOpen: (0,vue_cjs.shallowRef)(false),
            iframeUrl: "https://" + window.location.host + "/talktimemanagementtool" + "?showHeader=false",
            activePage: "/talktimemanagementtool",
            isLoaded: false,
            menuItems: [],
            iframeheight: "2000px",
            activecomponent: 'talktimemanagementtool'
        };
    },
    components: {
        SideBar: SideBar, TalkTImeManagement: TalkTImeManagement, LiveSessionManagement: LiveSessionManagement
    },
    props: {
        userPid: { type: Number, required: true, default: 0 },
        sulekhaApp: null,
        userRole: 0,
    },
    mounted: function () {
        let menuUrl = null;
        CSMainAPIs.Capshine.TalktimeAPIs.GetDashboardMenuForCoaches.execute({ userPid: this.userPid }, (response) => {
            this.menuItems = response.data;
            this.isLoaded = true;
        });
    },
    methods: {
        openLink(path) {
            this.activePage = path;
            const isValidUrl = urlString => {
                const urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
                    '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
                    '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
                    '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
                return !!urlPattern.test(urlString);
            };
            if (isValidUrl(path)) {
                this.iframeUrl = path;
                if (path.includes('myclubfeedback')) {
                    this.iframeheight = "800px";
                    this.activecomponent = 'myclubfeedback';
                }
            }
            else {
                if (path.includes('TalktimeManageSession')) {
                    this.iframeheight = "800px";
                    this.activecomponent = 'TalktimeManageSession';
                }
                else if (path.includes('LiveSessionManagementTool')) {
                    this.activecomponent = 'LiveSessionManagementTool';
                }
                else if (path.includes('myclubfeedback')) {
                    this.iframeheight = "800px";
                    this.activecomponent = 'myclubfeedback';
                }
                else if (path.includes('talktimemanagementtool')) {
                    this.activecomponent = 'talktimemanagementtool';
                }
                else {
                    this.iframeheight = "800px";
                }
                this.iframeUrl = "https://" + window.location.host + path + "?showHeader=false";
            }
        },
    },
});

;// CONCATENATED MODULE: ./src/Components/CoachDashboard.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/CoachDashboard.vue




;
const CoachDashboard_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CoachDashboardvue_type_script_lang_ts, [['render',CoachDashboardvue_type_template_id_f899c268_ts_true_render]])

/* harmony default export */ const CoachDashboard = (CoachDashboard_exports_);
;// CONCATENATED MODULE: ./src/js/CoachDashboardScript.js



let CoachDashboardScript = {
    userPid: 0,
    activityTypes: [],
    sulekhaApp: null,
    userRole: 0,
    init: function (userPid, sulekhaApp = null) {
        
        console.log("CoachesDashboard triggered")
        this.sulekhaApp = sulekhaApp;
        CoachDashboardScript.userPid = userPid;

        var page = document.getElementById('divCoachDashboardpage');

        if (page) {
            CoachDashboardScript.userRole = page.getAttribute("data-userrole");
        }

        const props = {
            userRole: CoachDashboardScript.userRole,
            userPid: CoachDashboardScript.userPid,
            sulekhaApp: CoachDashboardScript.sulekhaApp
            // coachList: response.data
        };
        

        const createResponseVue = (0,vue_cjs.createApp)(CoachDashboard, props);
        console.log("createResponseVue:", createResponseVue);
        createResponseVue.mount('#divCoachDashboardAdmin');

        let logOutBtn = document.getElementById("logout-btn");
        if (logOutBtn) {
            logOutBtn.addEventListener("click", function () {
                document.cookie = "capshine_login=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=capshine.com";
                window.location.href = '/';
            });
        }
    },
    ShowHeaderFooter: function () {
        let DivHeader = document.getElementById('capShineHeader');
        let DivFooter = document.getElementById('capShineFooter');
        
        if (DivHeader != null) {
            if (DivHeader.classList.contains('hide')) {
                DivHeader.classList.remove('hide')
            }
        }

        if (DivFooter != null) {
            if (DivFooter.classList.contains('hide')) {
                DivFooter.classList.remove('hide')
            }
        }
    },
}

/* harmony default export */ const js_CoachDashboardScript = (CoachDashboardScript);
;// CONCATENATED MODULE: ./src/js/JobInterviewCourse.js




// import router from "./routerconfig"
var JobInterviewCourseScript = {
    UserPid: '',
    userInfo: null,
    isCoach: false,
    isMobileApp: false,
    init: function (userpid, sulekhaApp = null) {

        JobInterviewCourseScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                JobInterviewCourseScript.isMobileApp = true;
            }
            else {
                JobInterviewCourseScript.isMobileApp = false;
            }
        }

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (DivHeader.classList.contains('hide')) {
                DivHeader.classList.remove('hide')
            }
        }

        if (DivFooter != null) {
            if (DivFooter.classList.contains('hide')) {
                DivFooter.classList.remove('hide')
            }
        }


        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, JobInterviewCourseScript.afterGetUserInfoLoad);

        var btnDivJobInterview = document.getElementById('submit-btn-jobinerview');

        if (btnDivJobInterview) {
            btnDivJobInterview.addEventListener("click", function (e) {
                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');


                if(JobInterviewCourseScript.userInfo.isJobInterviewCourseUser==0){
					if (JobInterviewCourseScript.isMobileApp) {
						JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
					}
					else {
						location.href = "/paymentPlans";
					}	
				}

				if(JobInterviewCourseScript.userInfo.isJobInterviewCourseUser==1){

                    if (JobInterviewCourseScript.isMobileApp == true) {
                        JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.WatchJobInterviewCourseVideo, {
                            videoid: videoId
                        })
                    }
                    else {
                      location.href = "/WatchJobInterviewCourseVideo?videoid=" + videoId
                    }	
				}

            })
        }


        var btnDivJobInterviewpaymentplan = document.getElementById('submit-btn-paymentplan');

        if (btnDivJobInterviewpaymentplan) {
            btnDivJobInterviewpaymentplan.addEventListener("click", function (e) {
       
                if(JobInterviewCourseScript.userInfo.isJobInterviewCourseUser==0){
					if (JobInterviewCourseScript.isMobileApp) {
						JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
					}
					else {
						location.href = "/paymentPlans";
					}	
				}

            })
        }





        var jobInterviewBackBackBtn = document.getElementById('jobInterviewBackBackBtn');

        if (jobInterviewBackBackBtn) {
            jobInterviewBackBackBtn.addEventListener("click", function (e) {

                if (JobInterviewCourseScript.isMobileApp == true) {
                    JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home)
                }
                else {
                    location.href = "/home"
                }

            })

        }

        var jobInterviewCloseBtn = document.getElementById('jobInterviewBackBackBtn');

        if (jobInterviewCloseBtn) {
            jobInterviewCloseBtn.addEventListener("click", function (e) {

                if (JobInterviewCourseScript.isMobileApp == true) {
                    JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home);
                }
                else {
                    location.href = "/home"
                }

            })

        }

        document.querySelectorAll("._watchvideo").forEach((lielement) => {
            lielement.addEventListener("click", async function (e) {

                var videoId = e.currentTarget.getAttribute('data-videoid');
  
                if(JobInterviewCourseScript.userInfo.isJobInterviewCourseUser==0){
					if (JobInterviewCourseScript.isMobileApp) {
						JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
					}
					else {
						location.href = "/paymentPlans";
					}	
				}

				if(JobInterviewCourseScript.userInfo.isJobInterviewCourseUser==1){

                    if (JobInterviewCourseScript.isMobileApp == true) {
                        JobInterviewCourseScript.sulekhaApp.navigateTo(MainEnums_MobilePages.WatchJobInterviewCourseVideo, {
                            videoid: videoId
                        })
                    }
                    else {
                      location.href = "/WatchJobInterviewCourseVideo?videoid=" + videoId
                    }	
				}
            })            

        })        


    },
    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        JobInterviewCourseScript.userInfo = response.data;
    },



}

/* harmony default export */ const JobInterviewCourse = (JobInterviewCourseScript);
;// CONCATENATED MODULE: ./src/js/WatchJobInterviewVideoScript.js







// import router from "./routerconfig"
var WatchJobInterviewVideoScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 1,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    videoEvent: null,
    activeVideo: null,
    init: function (userpid, sulekhaApp = null) {
        // remove touch events 

        WatchJobInterviewVideoScript.resetAll();

        WatchJobInterviewVideoScript.setEventsForVideo();

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        WatchJobInterviewVideoScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchJobInterviewVideoScript.isMobileApp = true;
            }
            else {
                WatchJobInterviewVideoScript.isMobileApp = false;
            }
        }
        WatchJobInterviewVideoScript.setupDashJsVideo();
        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WatchJobInterviewVideoScript.afterGetUserInfoLoad);


        let divCloseDocumentDownload = document.getElementById('divCloseDocumentDownload');
        if (divCloseDocumentDownload) {
            divCloseDocumentDownload.addEventListener("click", function (e) {
                //e.stopPropagation();
                let dialogWatchJobVideo = document.getElementById('dialogWatchJobVideo');
                dialogWatchJobVideo.classList.remove('show')
            })
        }

        let ancDocumentLink = document.getElementById('ancDocumentLink'); //or grab it by tagname etc
        // WatchJobInterviewVideoScript.popuptitle='Download Document'
        if (ancDocumentLink) {
            ancDocumentLink.addEventListener("click", function (e) {
                ///  alert('Document Downloaded')            
                WatchJobInterviewVideoScript.updatevideoaction(WatchJobInterviewVideoScript.activeVideo, 'downloaded')

                let svgmextbtnId = "svgnexticon" + WatchJobInterviewVideoScript.activePlayerRowIndex;
                let svgnextelement = document.getElementById(svgmextbtnId);
                if (svgnextelement) {
                    svgnextelement.setAttribute("data-isdocumentdownloaded", 1);
                }

                return false;
            })

        }

        document.querySelectorAll(".backbutton").forEach((backbutton) => {
            backbutton.addEventListener("touchend", function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                }

                e.stopPropagation();

                // WatchJobInterviewVideoScript.activePlayer.pause();
                WatchJobInterviewVideoScript.pauseAllVideosBeforeExit();
                var shortvideobackpage = window.localStorage.getItem('backpage');

                var currentVideo = WatchJobInterviewVideoScript.activePlayer;


                // var videoid = currentVideo.getAttribute('data-videoid');

                // var language = currentVideo.getAttribute('data-language');


                if (WatchJobInterviewVideoScript.isMobileApp) {

                    WatchJobInterviewVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourse, null);


                }
                else {
                    // history.back();
                    location.href = "/JobInterviewCourse"

                }

            })

        }),



            document.querySelectorAll(".list-item").forEach((divvideo) => {
                js_TouchDetector.swipedetect(divvideo, function (evt, dir, phase, swipetype, distance) {



                    if (dir == "none" && phase == "end") {  // if touched 



                        var targetlement = evt.target.getAttribute('data-elementname');
                        // Move Next
                        if (targetlement == "svgnexticon") {
                            WatchJobInterviewVideoScript.moveNext(evt.target);
                        }


                        else if (targetlement == "svgpreviousicon") {
                            WatchJobInterviewVideoScript.movePrevious(evt.target);
                        }

                        else {

                            WatchJobInterviewVideoScript.playpausePlayer(WatchJobInterviewVideoScript.activePlayerRowIndex);


                            var mediaactioniconId = "mediaactionicon" + WatchJobInterviewVideoScript.activePlayerRowIndex

                            if (document.getElementById(mediaactioniconId)) {
                                if (!document.getElementById(mediaactioniconId).classList.contains('hide')) {

                                    document.getElementById(mediaactioniconId).classList.add('hide')
                                }
                            }

                        }



                    }


                })  // swap detect end

            })

    },

    moveNext(ele) {

        debugger;
        let isquizexists = ele.getAttribute("data-isquizexists");
        let isdocumentexists = ele.getAttribute("data-isdocumentexists");
        let documenturl = ele.getAttribute("data-documenturl");
        let isdocumentdownloaded = ele.getAttribute("data-isdocumentdownloaded");
        let isquizcompleted = ele.getAttribute("data-isquizcompleted");
        let moduleorderid = ele.getAttribute("data-moduleorderid");
        let videoid = ele.getAttribute("data-videoid");
        
        let activerowindex = parseInt(ele.id.replace("svgnexticon", ""))



        if (isquizexists == 1 && isquizcompleted == 0) {
            //  alert(isquizexists)


            if (WatchJobInterviewVideoScript.isMobileApp == true) {
                WatchJobInterviewVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourseVideoQuiz, {
                    moduleid: moduleorderid,videoid:videoid
                })
            }
            else {
                location.href = "/JobInterviewCourseVideoQuiz??moduleid=" + moduleorderid +"&videoid="+videoid;

            }

        }
        else if (isdocumentexists == 1 && isdocumentdownloaded == 0) {
            let dialogWatchJobVideo = document.getElementById('dialogWatchJobVideo');

            if (dialogWatchJobVideo) {
                dialogWatchJobVideo.classList.add('show')
                ///   WatchJobInterviewVideoScript.documenturl=documenturl
                let ancDocumentLink = document.getElementById('ancDocumentLink'); //or grab it by tagname etc
                // WatchJobInterviewVideoScript.popuptitle='Download Document'
                if (ancDocumentLink) {
                    ancDocumentLink.href = documenturl
                    //    ancDocumentLink.click();
                }

            }

        }
        //else if (isquizexists == 0 && isdocumentexists == 0) {
        else {
            let dir = "up"


            let itemcount = document.querySelectorAll(".list-item").length;
            if (parseInt(activerowindex) < itemcount) {

                let rowupindex = parseInt(activerowindex + 1)
                WatchJobInterviewVideoScript.activePlayerRowIndex = rowupindex;
                WatchJobInterviewVideoScript.playActiveVideoOnSwap(rowupindex, dir)

            }
        }

    },

    movePrevious(ele) {
        let dir = "down"
        let activerowindex = parseInt(ele.id.replace("svgpreviousicon", ""))
        let itemcount = document.querySelectorAll(".list-item").length;
        if (parseInt(activerowindex) > 1) {
            let rowdownindex = parseInt(activerowindex - 1)
            WatchJobInterviewVideoScript.activePlayerRowIndex = rowdownindex;
            WatchJobInterviewVideoScript.playActiveVideoOnSwap(rowdownindex, dir);
        }
    },

    playpausePlayer(activerowindex) {

        var curentvideo = WatchJobInterviewVideoScript.activePlayer;

        var playiconId = "playicon" + activerowindex

        if (curentvideo != null) {

            var videoid = curentvideo.getAttribute('data-videoid');

            var language = curentvideo.getAttribute('data-language');

            if (curentvideo.paused) {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.add('hide')
                }
                setTimeout(() => {
                    try {
                        curentvideo.play();
                        //  bindGA.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Play');

                    }
                    catch (err) {
                        //console.log("playpausePlayer pause")
                    }
                }, 50);
            }
            else {
                if (document.getElementById(playiconId)) {
                    document.getElementById(playiconId).classList.remove('hide')
                }
                setTimeout(() => {
                    try {
                        ///    bindGA.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Pause');
                        curentvideo.pause();
                    }
                    catch { err } {
                        //console.log("playpausePlayer play")
                    }
                }, 200);

            }
        }

    },



    playActiveVideoOnSwap(activeRow, dir = 'up') {
        // validation

        var nextVideo = null

        for (var index = 0; index < WatchJobInterviewVideoScript.videoItems.length; index++) {
            if (WatchJobInterviewVideoScript.videoItems[index].row == activeRow) {
                nextVideo = WatchJobInterviewVideoScript.videoItems[index].video;
                break;
            }
        }

        // var istodaywatchedvideo = nextVideo.getAttribute('data-istodaywatchedvideo');
        // if (WatchJobInterviewVideoScript.userInfo.clubUserType == 1 && WatchJobInterviewVideoScript.sfvLimit == false && istodaywatchedvideo=='False' ) {

        //     if (WatchJobInterviewVideoScript.isMobileApp == true) {
        //         setTimeout(() => {
        //             WatchJobInterviewVideoScript.sulekhaApp.navigateTo(MobilePages.paymentUpgradeRequest, {
        //                 pageType: 9
        //             })
        //         }, 1000);
        //     }
        //     else {
        //         location.href = "/PaymentUpgradeRequest?pageType=9";
        //     }

        //     return;

        // }


        WatchJobInterviewVideoScript.activePlayer.pause();
        WatchJobInterviewVideoScript.showHideVideos();
        WatchJobInterviewVideoScript.ActiateNextVideoIfNotExists()
        WatchJobInterviewVideoScript.isScroll = false;
        //console.log(WatchJobInterviewVideoScript.touchDetails)

        for (var index = 0; index < WatchJobInterviewVideoScript.videoItems.length; index++) {
            if (WatchJobInterviewVideoScript.videoItems[index].row == activeRow) {
                WatchJobInterviewVideoScript.activePlayer = WatchJobInterviewVideoScript.videoItems[index].video;
                // WatchJobInterviewVideoScript.setTimeOutActiveVideos = []; // set this to find active video has payed 5 second validation and reset it not reached 5 seconds
                // WatchJobInterviewVideoScript.setTimeOutActiveVideos.push(WatchJobInterviewVideoScript.activePlayer)
                break;
            }
        }

        try {
            var divid = "divvideoid" + activeRow;
            var divEle = document.getElementById(divid)
            divEle.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });

        }
        catch (err) {

        }



        setTimeout(async () => {

            WatchJobInterviewVideoScript.isScroll = true;
            try {
                await WatchJobInterviewVideoScript.activePlayer.play();

            }
            catch (err) {
                //console.log("playActiveVideoOnSwap play")
            }



            var playiconId = "playicon" + activeRow
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }


        }, 200);





    },


    /// Ref code



    playVisibleVideos_() {
        document.querySelectorAll("video").forEach(video => WatchJobInterviewVideoScript.isScrolledIntoView(video) ? video.play() : video.pause());
    },

    playVisibleVideos__() {
        //  document.querySelectorAll("video").forEach(video => WatchJobInterviewVideoScript.isScrolledIntoView(video) ? video.play() : video.pause());

        var videos = document.querySelectorAll("video");

        var activevideo = null;

        for (var i = 0; i < videos.length; i++) {
            var activevideo_ = videos[i];
            //  videoid=video.id;

            if (WatchJobInterviewVideoScript.isScrolledIntoView(activevideo_)) {
                activevideo = activevideo_;
                break
            }
            else {
                activevideo_.pause();
            }
        }

        if (activevideo) {
            activevideo.play();
            WatchJobInterviewVideoScript.SaveShortVideoAction(activevideo);
        }


        //  var videoid=0;
        for (var i = 0; i < videos.length; i++) {
            var video = videos[i];

            if (WatchJobInterviewVideoScript.isScrolledIntoView(video)) {

                // }

            }
            else {

                video.pause();

            }

        }
    },

    isScrolledIntoView(element) {
        var elementTop = element.getBoundingClientRect().top,
            elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= 0 && elementBottom <= window.innerHeight;
    },


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WatchJobInterviewVideoScript.userInfo = response.data;
        // WatchJobInterviewVideoScript.sfvWatchedCount=WatchJobInterviewVideoScript.userInfo.sfvWatchedCount;
        WatchJobInterviewVideoScript.sfvLimit = WatchJobInterviewVideoScript.userInfo.sfvLimit;
    },

    SaveShortVideoAction(e) {
        var action = ''
        var userPid = "0";
        var videoid = 0;
        var iswatched = "False";
        var languagevideoid = 0;
        var language = ""

        if (e.currentTarget) {
            action = e.currentTarget.getAttribute('data-action');
            userPid = e.currentTarget.getAttribute('data-userpid');
            videoid = e.currentTarget.getAttribute('data-videoid');
            iswatched = e.currentTarget.getAttribute('data-iswatched');
            languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
            language = e.currentTarget.getAttribute('data-language');

        }
        else {
            action = e.getAttribute('data-action');
            userPid = e.getAttribute('data-userpid');
            videoid = e.getAttribute('data-videoid');
            iswatched = e.getAttribute('data-iswatched');
            languagevideoid = e.getAttribute('data-languagevideoid');

            language = e.getAttribute('data-language');
        }

        if (videoid > 0) {

            //  WatchJobInterviewVideoScript.selectedVideo=videoid;
            var obj = { "UserPid": userPid, "VideoId": videoid, "Action": action, "languageVideoid": languagevideoid }
          
            let url = `${CSMainAPIs.Capshine.Server.baseUrl}api/Videos/SaveJobInterviewVideoAction/`
            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            })
                .then((response) => response.json())
                .then((responseJson) => {

                    //isVideoWatched,isBookMarked,isLiked
                    //this.userInfo = responseJson;
                    if (action == "like") {

                        var likeId = "like" + videoid;
                        var obj = document.getElementById(likeId);

                        if (responseJson.isLiked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_Like');

                    }

                    if (action == "bookmark") {
                        var bookmarkId = "bookmark" + videoid;
                        var obj = document.getElementById(bookmarkId);

                        if (responseJson.isBookMarked) {
                            obj.classList.add("checked")
                        }
                        else {
                            obj.classList.remove("checked")
                        }

                        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Click_BookMark');
                    }

                    if (action == "watched") {
                        WatchJobInterviewVideoScript.isAllowSave = true;
                        e.setAttribute("data-iswatched", "True");
                        if (responseJson.todayWatchedCount >= WatchJobInterviewVideoScript.userInfo.sfvDailyWatchLimit) {
                            WatchJobInterviewVideoScript.sfvLimit = false;
                        }

                    }

                });

        }

        //   CSMainAPIs.Capshine.APIs.SaveShortVideoAction.execute({ "UserPid": userPid,"VideoId":videoid,"Action":action }, WatchJobInterviewVideoScript.afterSaveShortVideoActionResponse);

    },

    afterSaveShortVideoActionResponse(response) {
        WatchJobInterviewVideoScript.userInfo = response.data;
        //  WatchJobInterviewVideoScript.selectedVideo

    },



    setupDashJsVideo() {

        var videos = document.querySelectorAll("video");
        var url = videos[0].getAttribute("data-videourl");

        var player = dashjs.MediaPlayer().create();

        player.updateSettings({
            'debug': {
                'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
            },
            'streaming': {
                'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                },
                'buffer': {
                    'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                }
            }
        });


        player.initialize(videos[0], url, true);

        setTimeout(() => {
            WatchJobInterviewVideoScript.toggleControls(videos[0])
        }, 100);




        var videoid = videos[0].getAttribute('data-videoid');
        var language = videos[0].getAttribute('data-language');

        GATrack.pushValues('Videos_SFV', 'SFV_' + videoid + "," + language, 'Start_SFV');

        var videoobj = {
            row: 1,
            id: videos[0].id,
            player: player,
            video: videos[0]
        }


        WatchJobInterviewVideoScript.videoItems.push(videoobj);

        WatchJobInterviewVideoScript.activePlayer = videos[0];

        WatchJobInterviewVideoScript.activePlayerRowIndex = 1;

        WatchJobInterviewVideoScript.showHideVideos();

        WatchJobInterviewVideoScript.ActiateNextVideoIfNotExists()




    },
    showHideVideos() {
        var activeVideoIndex = parseInt(WatchJobInterviewVideoScript.activePlayerRowIndex);

        //    else
        // Show/Hide Next two div video element from current video 

        //Show Next item from current video div
        var showdivid = "divvideoid" + (activeVideoIndex + 1); // next div
        var showdivEle = document.getElementById(showdivid);


        if (showdivEle != null) {

            if (showdivEle.classList.contains('hide')) {
                //   showdivEle.classList.remove('hide')
            }
        }

        //Hide  next one div after Next div from current video div
        var hidedivid = "divvideoid" + (activeVideoIndex + 2);

        var hidedivEle = document.getElementById(hidedivid);

        if (hidedivEle != null) {
            if (!hidedivEle.classList.contains('hide')) {
                //   hidedivEle.classList.add('hide')
            }
        }

        /// 

        // Show/Hide Previous two div video element from current video 

        if (activeVideoIndex < 1) {
            return;
        }


        //Show Prevous item from current video div
        var showdivPreid = "divvideoid" + (activeVideoIndex - 1); // next div
        var showdivPreEle = document.getElementById(showdivPreid);

        if (showdivPreEle != null) {
            if (showdivPreEle.classList.contains('hide')) {
                //  showdivPreEle.classList.remove('hide')
            }
        }

        if (activeVideoIndex < 2) {
            return;
        }

        //Hide before one div before one div from current video div
        var hidedivPreid = "divvideoid" + (activeVideoIndex - 2);

        var hidedivPreEle = document.getElementById(hidedivPreid);

        if (hidedivPreEle != null) {
            if (!hidedivPreEle.classList.contains('hide')) {
                //  hidedivPreEle.classList.add('hide')
            }
        }

    },

    ActiateNextVideoIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchJobInterviewVideoScript.activePlayerRowIndex);
        let videos = document.querySelectorAll("video");

        // load next three videos

        for (var row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (var index = 0; index < WatchJobInterviewVideoScript.videoItems.length; index++) {
                    if (WatchJobInterviewVideoScript.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }


                if (isCreateVideo == true) {
                    let videourl = videos[activeVideoIndex].getAttribute("data-videourl");

                    let player_ = dashjs.MediaPlayer().create()


                    player_.updateSettings({
                        'debug': {
                            'logLevel': dashjs.Debug.LOG_LEVEL_NONE  /* turns off console logging */
                        },
                        'streaming': {
                            'scheduling': {
                                'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                            },
                            'buffer': {
                                'fastSwitchEnabled': true   /* enables buffer replacement when switching bitrates for faster switching */
                            }
                        }
                    });


                    player_.initialize(videos[activeVideoIndex], videourl, false);


                    setTimeout(() => {
                        WatchJobInterviewVideoScript.toggleControls(videos[activeVideoIndex])
                    }, 50);





                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        player: player_,
                        video: videos[activeVideoIndex]
                    }
                    WatchJobInterviewVideoScript.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;


                }
            }
        }
    },

    resetAll() {
        WatchJobInterviewVideoScript.UserPid = '';
        WatchJobInterviewVideoScript.userInfo = null;
        WatchJobInterviewVideoScript.isMobileApp = false;
        WatchJobInterviewVideoScript.activePlayer = null;
        WatchJobInterviewVideoScript.videoItems = [];
        WatchJobInterviewVideoScript.activePlayerRowIndex = 1;
        WatchJobInterviewVideoScript.setTimeOutActiveVideos = [];

        function fixTouchStart(event) {
            return;
        }


        function fixTouchEnd(event) {
            return;
        }
        function fixTouchMove(event) {
            return;
        }

        function removePauseVideOnDocumentLooseFocus() {
            return;
        }
        function removePlayideOnDocumentOnFocus() {
            return;
        }


        // Remove any previous listners as the page content is ajax loaded and body is never destroyed
        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);

        // reset events 
    },


    initPlayer() {
        var player;
        var video,
            url = "https://capshine-usea.streaming.media.azure.net/4d8afc53-9974-4b17-9d77-4ebdd0616d8f/chore_english.ism/manifest";

        video = document.getElementById("video_test");
        player = dashjs.MediaPlayer().create();
        player.initialize(video, url, true);

        player.updateSettings({
            'streaming': {
                'abr': {
                    'minBitrate': {
                        'video': -1
                    },
                    'maxBitrate': {
                        'video': 5000
                    },
                    'limitBitrateByPortal': false,
                }, 'scheduling': {
                    'scheduleWhilePaused': false,   /* stops the player from loading segments while paused */
                }
            }
        })

        player.on(dashjs.MediaPlayer.events["PLAYBACK_ENDED"], function () {
            clearInterval(eventPoller);
        });

        var eventPoller = setInterval(function () {
            var streamInfo = player.getActiveStream().getStreamInfo();
            var dashMetrics = player.getDashMetrics();
            var dashAdapter = player.getDashAdapter();

            if (dashMetrics && streamInfo) {
                const periodIdx = streamInfo.index;
                var repSwitch = dashMetrics.getCurrentRepresentationSwitch('video', true);
                var bufferLevel = dashMetrics.getCurrentBufferLevel('video', true);
                var bitrate = repSwitch ? Math.round(dashAdapter.getBandwidthForRepresentation(repSwitch.to, periodIdx) / 1000) : NaN;
                // document.getElementById('currentBufferLevel').innerText = bufferLevel + " secs";
                //   document.getElementById('reportedBitrate').innerText = bitrate + " Kbps";
            }
        }, 1000);
    },


    pauseVideOnDocumentLooseFocus() {
        if (WatchJobInterviewVideoScript.activePlayer) {
            WatchJobInterviewVideoScript.activePlayer.pause();
            var playiconId = "playicon" + WatchJobInterviewVideoScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.remove('hide')
            }
            ////console.log("LooseFocus");
        }

    },


    playVideOnDocumentOnFocus() {
        if (WatchJobInterviewVideoScript.activePlayer) {
            WatchJobInterviewVideoScript.activePlayer.play();
            var playiconId = "playicon" + WatchJobInterviewVideoScript.activePlayerRowIndex
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.add('hide')
            }
            //   //console.log("OnFocus");
        }

    },

    pauseAllVideosBeforeExit() {

        for (var index = 0; index < WatchJobInterviewVideoScript.videoItems.length; index++) {
            var video = WatchJobInterviewVideoScript.videoItems[index].video;
            var player = WatchJobInterviewVideoScript.videoItems[index].player;
            if (video.paused) {

            } else {
                video.pause();
            }

            // distory the player 
            if (player) {
                player.reset();
            }


        }

    },
    setEventsForVideo() {

        let videos = document.querySelectorAll("video");
        let timeupdateTimeout;

        document.querySelectorAll('video').forEach(video => {
            video.addEventListener('timeupdate', event => {

                WatchJobInterviewVideoScript.videoEvent = event;
                WatchJobInterviewVideoScript.activeVideo = video;
                // if (video.currentTime > 10 && video.currentTime < 11) {


                //     if (WatchJobInterviewVideoScript.isAllowSave == true) {
                //         if (video == WatchJobInterviewVideoScript.activePlayer) {
                //             WatchJobInterviewVideoScript.isAllowSave = false;                                               
                //         }
                //     }

                //     // console.log("video id :"+ video.id + "TIme Passed :"  + video.currentTime)
                // }

                timeupdateTimeout = setTimeout(() => {
                    WatchJobInterviewVideoScript.updatevideoaction(WatchJobInterviewVideoScript.activeVideo, 'timetracking')
                }, 3000);
                //handle click
            })


            video.addEventListener('ended', event => {


                var activerowindex = WatchJobInterviewVideoScript.activePlayerRowIndex;
                WatchJobInterviewVideoScript.activeVideo = video;
                var mediaactionicon = "mediaactionicon" + activerowindex

                if (document.getElementById(mediaactionicon)) {
                    document.getElementById(mediaactionicon).classList.remove('hide')
                }

                //  CSMainAPIs.Capshine.TalktimeAPIs.FetchLiveClassSessionAvailability


                // var replayiconId = "replayicon" + activerowindex

                // if (document.getElementById(replayiconId)) {
                //     document.getElementById(replayiconId).classList.remove('hide')
                // }

                ///  CSMainAPIs.Capshine.TalktimeAPIs.FetchLiveClassSessionAvailability.execute(}
                clearTimeout(timeupdateTimeout);
                WatchJobInterviewVideoScript.updatevideoaction(WatchJobInterviewVideoScript.activeVideo, 'iswatchd')



            })


        })


    },

    updatevideoaction(video, action) {
        // var userPid = event.currentTarget.getAttribute('data-userpid');
        // var videoid = event.currentTarget.getAttribute('data-videoid');

        ///var video= WatchJobInterviewVideoScript.activePlayer


        var userPid = video.getAttribute('data-userpid');
        var videoid = video.getAttribute('data-videoid');
        var duration = video.currentTime;

        var obj = { "userPid": userPid, "videoId": videoid, "action": action, "duration": duration }
        fetch("https://dev.capshine.com/api/JobInterview/UpdateUserInteractionForJobInterviewVideo/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(obj),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                if (action == 'iswatchd') {
                    video.currentTime = 0;
                }

                //isVideoWatched,isBookMarked,isLiked
                //this.userInfo = responseJson;


            });
    },

    toggleControls(video) {
        if (video.hasAttribute("controls")) {
            video.removeAttribute("controls")
        }
        else {
            video.setAttribute("controls", "controls")
        }
    }


}

/* harmony default export */ const js_WatchJobInterviewVideoScript = (WatchJobInterviewVideoScript);
;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/JobInterviewCourseVideoQuiz.vue?vue&type=template&id=76c37ac8&ts=true

function JobInterviewCourseVideoQuizvue_type_template_id_76c37ac8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MCQ = (0,vue_cjs.resolveComponent)("MCQ");
    return ((0,vue_cjs.openBlock)(), (0,vue_cjs.createElementBlock)("div", null, [
        (0,vue_cjs.createVNode)(_component_MCQ, {
            id: "mcq",
            basicDetails: _ctx.mcqBasicDetails,
            field: _ctx.field,
            userName: _ctx.userInfo.firstName,
            clubUserLevel: _ctx.userInfo.clubUserLevel,
            showThankyou: _ctx.showThankyou,
            startMcq: _ctx.startMcq,
            playNextQuiz: _ctx.playNextQuiz,
            videoId: _ctx.moduleid
        }, null, 8, ["basicDetails", "field", "userName", "clubUserLevel", "showThankyou", "startMcq", "playNextQuiz", "videoId"])
    ]));
}

;// CONCATENATED MODULE: ./src/Components/JobInterviewCourseVideoQuiz.vue?vue&type=template&id=76c37ac8&ts=true

;// CONCATENATED MODULE: ./node_modules/ts-loader/index.js??clonedRuleSet-1!./node_modules/vue-loader/dist/index.js??ruleSet[0]!./src/Components/JobInterviewCourseVideoQuiz.vue?vue&type=script&lang=ts







var JobInterviewCourseVideoQuizvue_type_script_lang_ts_self;
/* harmony default export */ const JobInterviewCourseVideoQuizvue_type_script_lang_ts = ((0,vue_cjs.defineComponent)({
    name: "JobInterviewCourseVideoQuiz",
    props: {
        moduleid: { type: String },
        videoid: { type: String },
        userpid: { type: String },
        sulekhaApp: { type: null },
        isMobileApp: { type: Boolean },
        nextvideoid: { type: String },
    },
    components: { MCQ: Mcq },
    setup() {
        return {
            pageHtml: (0,vue_cjs.ref)("...loading"),
            mcqBasicDetails: new McqBasicDetails({
                mcqType: McqTypeOption.JobInterviewCourse,
                title: "Practice Test on Video",
                showIntroScreen: false,
                introScreen: new IntroScreenContent({
                    heading: "",
                    hasSkipButton: true,
                    instructionList: ["", "", ""],
                    content: "",
                }),
                showSubmitButton: true,
                showEarnedPoints: false,
                showQuestionCount: true,
                showProgressBar: true,
                showBottomExplanation: true
            }),
        };
    },
    data() {
        return {
            field: null,
            showMCQ: false,
            userInfo: {},
        };
    },
    watch: {
        userInfo: {
            handler: function (newVal) {
                this.mcqBasicDetails.userInfo = newVal;
            },
        },
    },
    beforeMount() {
        CSMainAPIs.Capshine.JobInterviewCourse.GetJobInterviewCourseVideoQuiz.execute({ ModuleId: this.moduleid, VideoId: this.videoid }, this.apiResponse);
        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ UserPid: this.UserPid }, this._afterGetUserInfoLoad);
    },
    mounted() {
        JobInterviewCourseVideoQuizvue_type_script_lang_ts_self = this;
    },
    methods: {
        _afterGetUserInfoLoad(response) {
            this.userInfo = response.data;
            if (document.getElementById("btncloseMCQIcon")) {
                document
                    .getElementById("btncloseMCQIcon")
                    .addEventListener("click", async function (e) {
                    js_JobInerviewCourseVideoQuizScript.backtoJobInerviewVideoPage();
                });
            }
        },
        startMcq() {
            // void
        },
        apiResponse(response) {
            if (response.res.status != 200)
                return;
            var mcqList = JSON.parse(JSON.stringify(response.data));
            this.field = new McqField({ mcqList: mcqList });
            this.mcqBasicDetails.pagename = this.pagename;
            this.mcqBasicDetails.lessionid = this.lessionid;
            this.showMCQ = true;
        },
        showThankyou() {
            debugger;
            var requestObj = {
                ModuleId: this.moduleid,
                UserPid: this.userpid,
                videoid: this.videoid,
                McqAnswer: this.field.answerList,
            };
            // CSMainAPIs.Capshine.APIs.StoreVideoLearningMCQQuestionAndAnswer.execute(
            //   responseObj,
            //   null
            // );
            CSMainAPIs.Capshine.JobInterviewCourse.StoreJobInterviewQuestionAndAnswer.execute(requestObj, (response) => {
                if (JobInterviewCourseVideoQuizvue_type_script_lang_ts_self.isMobileApp) {
                    JobInterviewCourseVideoQuizvue_type_script_lang_ts_self.sulekhaApp.navigateTo(MainEnums_MobilePages.WatchJobInterviewCourseVideo, {
                        videoid: JobInterviewCourseVideoQuizvue_type_script_lang_ts_self.nextvideoid
                    });
                }
                else {
                    location.href = "/WatchJobInterviewCourseVideo?videoid=" + JobInterviewCourseVideoQuizvue_type_script_lang_ts_self.nextvideoid;
                }
            });
            // var mcqStatusUpdateData = {
            //   UserPid: this.userpid,
            //   moduleid: this.moduleid,
            //   VideoUniqueId: this.videouniqueid,
            // };
            // submit Video watched status
            //  CSMainAPIs.Capshine.APIs.SubmitLearningVideoWatchedStatus.execute(mcqStatusUpdateData, null);
            //  setTimeout(function(){
            //    let that=this;
            // //   CSMainAPIs.Capshine.APIs.SubmiMCQCompletedStatus.execute(
            // //         mcqStatusUpdateData,
            // //         that.SubmitMCQStatusResponse
            // //       );
            //  },2000)
        },
        playNextQuiz() { },
    },
}));

;// CONCATENATED MODULE: ./src/Components/JobInterviewCourseVideoQuiz.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/Components/JobInterviewCourseVideoQuiz.vue




;
const JobInterviewCourseVideoQuiz_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(JobInterviewCourseVideoQuizvue_type_script_lang_ts, [['render',JobInterviewCourseVideoQuizvue_type_template_id_76c37ac8_ts_true_render]])

/* harmony default export */ const JobInterviewCourseVideoQuiz = (JobInterviewCourseVideoQuiz_exports_);
;// CONCATENATED MODULE: ./src/js/JobInerviewCourseVideoQuizScript.js




var JobInerviewCourseVideoQuizScript = {
    UserPid: '',
    videoId: 0,
    isMobileApp: false,
    sulekhaApp: null,
    pagename: "",
    lessionid: "",
    init: function (userId, sulekhaApp = null) {


        JobInerviewCourseVideoQuizScript.sulekhaApp = sulekhaApp

        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');
        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                JobInerviewCourseVideoQuizScript.isMobileApp = true;
            }
            else {
                JobInerviewCourseVideoQuizScript.isMobileApp = false;
            }
        }


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        var moduleid = JobInerviewCourseVideoQuizScript.getParameterByName('moduleid');      //e.currentTarget.getAttribute('videouniqueid');

        var videoid = JobInerviewCourseVideoQuizScript.getParameterByName('videoid');
        var nextvideoid = JobInerviewCourseVideoQuizScript.getParameterByName('nextvideoid');
      
      
        
        let newDiv = document.createElement("div");

        newDiv.id = "DivobInterviewQuizPanel";
        document.getElementById('DivJobInterviewQuizLayout').appendChild(newDiv);

        const createResponseVue = (0,vue_cjs.createApp)(JobInterviewCourseVideoQuiz, { videoid: videoid,nextvideoid:nextvideoid, moduleid: moduleid, userpid: userId, sulekhaApp: JobInerviewCourseVideoQuizScript.sulekhaApp, isMobileApp: JobInerviewCourseVideoQuizScript.isMobileApp });
        createResponseVue.mount('#DivobInterviewQuizPanel');

    },

    SubmitVideoWatchedStatusResponse: function () {
        console.log('SubmitVideoWatchedStatusResponse')
    },

    backtoJobInerviewVideoPage: function () {
      //  debugger;

        var videoid = JobInerviewCourseVideoQuizScript.getParameterByName('videoid');
        if(!videoid){
            videoid="1";
        }
        if (JobInerviewCourseVideoQuizScript.isMobileApp) {
            JobInerviewCourseVideoQuizScript.sulekhaApp.navigateTo(MainEnums_MobilePages.WatchJobInterviewCourseVideo, {
                videoid:videoid
            });
        }
        else {
            location.href = "/WatchJobInterviewCourseVideo?videoid="+videoid;
        }


    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

}




/* harmony default export */ const js_JobInerviewCourseVideoQuizScript = (JobInerviewCourseVideoQuizScript);
;// CONCATENATED MODULE: ./src/js/WatchJobInterviewYoutubeVideoScript.js




// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'
// import { scrollIntoView } from './DashJS/seamlessscroll.min.js'


// import './DashJS/dash.all.min.js'
// import './DashJS/dash.mss.min.js'



// import router from "./routerconfig"
var WatchJobInterviewYoutubeVideoScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    initialVideoPlayed: false,
    activePlayer: null,
    videoItems: [],
    activePlayerRowIndex: 0,
    setTimeOutActiveVideos: [],
    touchDebounce: true,
    touchUpDebounce: true,
    touchDownDebounce: true,
    isScroll: true,
    isPlaying: false,
    isAllowSave: true,
    touchDetails: "",
    sfvLimit: true,
    activeVideoPlayer: null,
    activeVideoPlayerInterval: null,
    activeVideoPlayerElapsedTimeInSeconds: null,
    activeVideoPlayerIdx: 0,
    updatedSaveActionVideoId: new Map(),
    ytubeplayer: null,
    coursecertificateurl: "",
    iscertificatedownloaded: 0,
    coursecompleteddatetime: null,
    videoid: 0,
    done: false,
    init: async function (userpid, sulekhaApp = null) {
        // remove touch events 

        // define youtube ref
        // var tag = document.createElement('script');
        // tag.src = "https://www.youtube.com/iframe_api";
        // tag.id = "YTiframeApi"
        // var firstScriptTag = document.getElementsByTagName('script')[0];
        // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        WatchJobInterviewYoutubeVideoScript.UserPid = userpid;


        // //
        WatchJobInterviewYoutubeVideoScript.resetAll();

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        WatchJobInterviewYoutubeVideoScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                WatchJobInterviewYoutubeVideoScript.isMobileApp = true;
            }
            else {
                WatchJobInterviewYoutubeVideoScript.isMobileApp = false;
            }
        }

        await WatchJobInterviewYoutubeVideoScript.setupInitialYoutubeVideo();

        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, WatchJobInterviewYoutubeVideoScript.afterGetUserInfoLoad);



        document.querySelectorAll(".document-link").forEach((ancDocumentLink) => {
            ancDocumentLink.addEventListener("click", function (e) {
                e.stopPropagation();
                // alert(ancDocumentLink.id)
                ancDocumentLink.href = e.currentTarget.getAttribute('data-documenturl')
                let element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                if (element) {
                    WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'downloaded')
                }
            })

        });

        // quiz page
        document.querySelectorAll(".docment-quiz").forEach((quizlink) => {
            quizlink.addEventListener("click", function (e) {
                e.stopPropagation();
                // alert(ancDocumentLink.id)
                let moduleorderid = e.currentTarget.getAttribute("data-moduleorderid");
                let videoid = e.currentTarget.getAttribute("data-videoid");


                //Start to  find nextvideoindex
                var itemcount = document.querySelectorAll(".list-item").length;
                let nextindex = WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex;

                if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) < itemcount) {
                    nextindex = nextindex + 1;
                }

                let element = document.getElementById(`yt-player-${nextindex}`)
                let nextvideoid = 0;
                if (element) {
                    nextvideoid = element.getAttribute('data-videoid');
                }
                // End finding next video index
                WatchJobInterviewYoutubeVideoScript.resetAll();
                if (WatchJobInterviewYoutubeVideoScript.isMobileApp == true) {
                    WatchJobInterviewYoutubeVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourseVideoQuiz, {
                        moduleid: moduleorderid, videoid: videoid, nextvideoid: nextvideoid
                    })
                }
                else {
                    location.href = "/JobInterviewCourseVideoQuiz??moduleid=" + moduleorderid + "&videoid=" + videoid + "&nextvideoid=" + nextvideoid;

                }

            })

        });





        let btnnavigateback = document.getElementById('btnnavigateback'); //or grab it by tagname etc
        // WatchJobInterviewYoutubeVideoScript.popuptitle='Download Document'
        if (btnnavigateback) {
            btnnavigateback.addEventListener("click", function (e) {
                WatchJobInterviewYoutubeVideoScript.resetAll();
                if (WatchJobInterviewYoutubeVideoScript.isMobileApp) {
                    WatchJobInterviewYoutubeVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.JobInterviewCourse, null);
                }
                else {
                    // history.back();
                    location.href = "/JobInterviewCourse"

                }

            })

        }

        document.querySelectorAll(".btnprev").forEach((btnprev) => {

            btnprev.addEventListener("click", async function (e) {
                await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo();
                const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                if (element) {
                let modulewithfilename= element.getAttribute('data-modulewithfilename');
					let gacategory = modulewithfilename + "_Previous" + "," + modulewithfilename + "_Previous" + "," + modulewithfilename + "_Previous"
                 GATrack.pushValues(gacategory);
                }
                WatchJobInterviewYoutubeVideoScript.HideCurrentVideoBeforeNextVideoStarted();

                const playerState = await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.getPlayerState()
                if (playerState !== 1) await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.stopVideo();
                await WatchJobInterviewYoutubeVideoScript.scrollDown()
            })

        })

        document.querySelectorAll(".btnnex").forEach((btnnex) => {
            btnnex.addEventListener("click", async function (evt) {
                await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo();
                // Save Whole video watched status 
                const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                if (element) {

                    const iswholevideowatched = element.getAttribute('data-iswholevideowatched');
                    if (iswholevideowatched == 0) {
                        WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'iswatchd');
                    }
                    let modulewithfilename= element.getAttribute('data-modulewithfilename');
					let gacategory = modulewithfilename + "_Next" + "," + modulewithfilename + "_Next" + "," + modulewithfilename + "_Next"
                     GATrack.pushValues(gacategory);
                }

                WatchJobInterviewYoutubeVideoScript.HideCurrentVideoBeforeNextVideoStarted();
                await WatchJobInterviewYoutubeVideoScript.scrollUp();
            })
        })



        let ancDownloadCertificate = document.getElementById('ancDownloadCertificate'); //or grab it by tagname etc
        let divAncDownloadCertificate = document.getElementById('divAncDownloadCertificate'); //or grab it by tagname etc



        // WatchJobInterviewYoutubeVideoScript.popuptitle='Download Document'
        if (divAncDownloadCertificate) {
            divAncDownloadCertificate.addEventListener("click", function (e) {
                //downloadjobinterviewcertificate
                e.stopPropagation();
                const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                if (element) {
                    var userPid = element.getAttribute('data-userpid');
                    var videoid = element.getAttribute('data-videoid');

                    let coverspin = document.getElementById('cover-spin')
                    if (coverspin) {
                        coverspin.style.display = "block";
                    }

                    CSMainAPIs.Capshine.JobInterviewCourse.Downloadjobinterviewcertificate.execute(
                        {
                            userPid: userPid, videoid: videoid
                        },
                        (response) => {
                            //  inviteBtn.setAttribute('data-invitecount', String(inviteCount + 1));
                            console.log(response)
                            if (response.data)
                                //  ancDownloadCertificate.href = response.data.coursecertificateurl;
                                //  ancDownloadCertificate.target = "_blank";

                                //   const pdfLink = response.data.coursecertificateurl


                                if (coverspin) {
                                    coverspin.style.display = "none";
                                }
							let gacategory = "MJI_coursecompletion download, MJI_coursecompletion download, MJI_coursecompletion download";
                                GATrack.pushValues(gacategory);

                            const link = document.createElement('a');
                            link.setAttribute('download', response.data.coursecertificateurl);
                            link.setAttribute('href', response.data.coursecertificateurl);
                            link.setAttribute('target', "_blank");
                            link.click();
                            link.remove();


                        });
                }
            })


        }




        document.querySelectorAll("._thankyouclose").forEach((closebtn) => {
            closebtn.addEventListener("click", async function (evt) {

				let gacategory ="MJI_coursecompletion close, MJI_coursecompletion close, MJI_coursecompletion close";
                     GATrack.pushValues(gacategory);

                if (WatchJobInterviewYoutubeVideoScript.isMobileApp) {
                    WatchJobInterviewYoutubeVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null);
                }
                else {
                    location.href = "/home";
                }
            })
        })

        // document.querySelectorAll(".list-item").forEach((divvideo) => {

        //     TouchDetector.swipedetect(divvideo, async function (evt, dir, phase, swipetype, distance) {


        //         if (dir == "none" && phase == "end") {  // if touched 


        //             var targetlement = evt.target.getAttribute('data-elementname');
        //             // Move Next
        //             if (targetlement == "svgnexticon") {

        //                 await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo();
        //                 await WatchJobInterviewYoutubeVideoScript.scrollUp(evt.target)
        //             }


        //             else if (targetlement == "svgpreviousicon") {

        //                 await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo();
        //                 const playerState = await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.getPlayerState()
        //                 if (playerState !== 1) await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.stopVideo();
        //                 await WatchJobInterviewYoutubeVideoScript.scrollDown()
        //             }

        //             else {



        //             }



        //         }


        //     })  // swap detect end

        // })





    },

    async playActiveVideoOnSwap(activeRow, dir = 'up') {
        // validation

        await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer?.pauseVideo();

        document.querySelectorAll(".list-item").forEach((divvideo) => {
            divvideo.classList.remove('current-video')
        });

        let divid = "list-item-" + activeRow;

        let divEle = document.getElementById(divid)

        if (divEle) {
            divEle.classList.add('current-video')
        }

        await WatchJobInterviewYoutubeVideoScript.CreateYoutubePlayerIfNotExists()
        // WatchJobInterviewYoutubeVideoScript.isScroll = false;

        for (let index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
            if (WatchJobInterviewYoutubeVideoScript.videoItems[index].row == activeRow) {
                WatchJobInterviewYoutubeVideoScript.activeVideoPlayer = WatchJobInterviewYoutubeVideoScript.videoItems[index].player;
                break;
            }
        }

        // document.querySelectorAll(".list-item").forEach((divvideo) => {
        //     divvideo.classList.remove('current-video')
        // });

        // let divid = "list-item-" + activeRow;

        // let divEle = document.getElementById(divid)

        // if (divEle) {
        //     divEle.classList.add('current-video')
        // }


    },



    /// Ref code

    isScrolledIntoView(element) {
        var elementTop = element.getBoundingClientRect().top,
            elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= 0 && elementBottom <= window.innerHeight;
    },


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        WatchJobInterviewYoutubeVideoScript.userInfo = response.data;

        let allow = false;

        if (WatchJobInterviewYoutubeVideoScript.userInfo.isJobInterviewCourseUser == 0) {
            if (WatchJobInterviewYoutubeVideoScript.isMobileApp) {
                WatchJobInterviewYoutubeVideoScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
            }
            else {
                location.href = "/paymentPlans";
            }
        }


    },

    async SaveShortVideoAction(video, action) {
        // var userPid = event.currentTarget.getAttribute('data-userpid');
        // var videoid = event.currentTarget.getAttribute('data-videoid');

        ///var video= WatchJobInterviewVideoScript.activePlayer
        if (!video) {
            return;
        }
        if (!WatchJobInterviewYoutubeVideoScript.activeVideoPlayer) {
            return;
        }


        var userPid = video.getAttribute('data-userpid');
        var videoid = video.getAttribute('data-videoid');
        //  var duration = video.currentTime;
        //  var duration = WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.playerInfo.currentTime;
        var duration = await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.getCurrentTime();
        //  console.log('duration: '+duration)
        var obj = { "userPid": userPid, "videoId": videoid, "action": action, "duration": duration }
        fetch("https://www.capshine.com/api/JobInterview/UpdateUserInteractionForJobInterviewVideo/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(obj),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                if (action == 'iswatchd') {
                    video.currentTime = 0;
                }

                //isVideoWatched,isBookMarked,isLiked
                //this.userInfo = responseJson;


            });
    },




    afterSaveShortVideoActionResponse(response) {
        WatchJobInterviewYoutubeVideoScript.userInfo = response.data;
    },

    getYoutubeIdFromUrl(url) {
        var regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|shorts|)(.*?((?=[&#?])|$))/gm;
        return regExp.exec(url)[3];
    },



    async setupInitialYoutubeVideo() {
        /// const videos = document.getElementsByClassName("youtube-video")

        let coverspin = document.getElementById('cover-spin')
        if (coverspin) {
            coverspin.style.display = "block";
        }


        let videos = document.getElementsByClassName("youtube_video_wraper");

        let currentVideoIndex = parseInt(videos[0].getAttribute("data-currentvideoindex"))
        WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx = currentVideoIndex;

        let videoobj = null;
        //Show First Video
        let divid = "list-item-" + currentVideoIndex;

        let divEle = document.getElementById(divid)

        if (divEle) {
            divEle.classList.add('current-video')
        }

        // end

        if (WatchJobInterviewYoutubeVideoScript.videoItems.length == 0) {
            for (var row = 0; row < videos.length; row++) {
                let rowid = row + 1;
                let videoeleid = 'wrapper-' + rowid
                let videoele = document.getElementById(videoeleid);
                if (videoele) {
                    var youtubeUrl = videoele.getAttribute("data-youtube-url");
                    var shortVideoId = "yt-player-" + rowid;
                }

                const videoobj = {
                    row: rowid,
                    id: videos[0].id,
                    video: videoele,
                    player: null,
                    shortVideoId: shortVideoId,
                    youtubeUrl: youtubeUrl
                }
                WatchJobInterviewYoutubeVideoScript.videoItems.push(videoobj);
            }
        }

        for (let index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
            if (WatchJobInterviewYoutubeVideoScript.videoItems[index].row == currentVideoIndex) {
                let sid = WatchJobInterviewYoutubeVideoScript.videoItems[index].shortVideoId;
                let yurl = WatchJobInterviewYoutubeVideoScript.videoItems[index].youtubeUrl;
                await WatchJobInterviewYoutubeVideoScript.createYtIframeForElement(sid, yurl)
                WatchJobInterviewYoutubeVideoScript.videoItems[index].player = WatchJobInterviewYoutubeVideoScript.ytubeplayer
                WatchJobInterviewYoutubeVideoScript.activeVideoPlayer = WatchJobInterviewYoutubeVideoScript.videoItems[index].player;
                WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx = currentVideoIndex;
                WatchJobInterviewYoutubeVideoScript.activePlayer = WatchJobInterviewYoutubeVideoScript.videoItems[index];
                WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex = currentVideoIndex; //WatchJobInterviewYoutubeVideoScript.videoItems[index].row;
                // alert('Hi I am set up video. Active player index is '+currentVideoIndex);
                // let capsinevideoloader = document.getElementById('capsinevideoloader');
                // if (capsinevideoloader) {
                //     capsinevideoloader.classList.remove('show')
                // }
                // show next button for started video
                WatchJobInterviewYoutubeVideoScript.ShowCurrentVideoAfterPlayingStarted();
                break;
            }
        }
        await WatchJobInterviewYoutubeVideoScript.CreateYoutubePlayerIfNotExists();
    },

    async createYtIframeForElement(element, youtubeUrl) {
        const videoId = WatchJobInterviewYoutubeVideoScript.getYoutubeIdFromUrl(youtubeUrl);

        let player = await WatchJobInterviewYoutubeVideoScript.loadPlayer(element, videoId)

        WatchJobInterviewYoutubeVideoScript.ytubeplayer = player;

    },
    async scrollUp() {

        var itemcount = document.querySelectorAll(".list-item").length;
        if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) < itemcount) {
            await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo(); // pause current video before playing next
            await Promise.all(WatchJobInterviewYoutubeVideoScript.videoItems.map(async (videoItems) => await videoItems.player?.pauseVideo()))
            let rowdownindex = parseInt(parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) + 1)
            WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex = rowdownindex;
            //  clearInterval(WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval)
            WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds = 0
            // WatchJobInterviewYoutubeVideoScript.showHideMoveNextMovePrevious('hide','btnclick');
            await WatchJobInterviewYoutubeVideoScript.playActiveVideoOnSwap(rowdownindex, "up");
            await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer?.playVideo();
        }

    },
    async scrollDown() {
        if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) > 1) {
            await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo(); // pause current video before playing next
            await Promise.all(WatchJobInterviewYoutubeVideoScript.videoItems.map(async (videoItems) => await videoItems.player?.pauseVideo()))
            let rowdownindex = parseInt(parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) - 1)
            WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex = rowdownindex;
            //  clearInterval(WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval)
            WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds = 0
            //  WatchJobInterviewYoutubeVideoScript.showHideMoveNextMovePrevious('hide','btnclick');
            await WatchJobInterviewYoutubeVideoScript.playActiveVideoOnSwap(rowdownindex, "down");
            await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer?.playVideo();
        }
    },

    // youTubePlayerActive() {

    //     return YouTubePlayer && WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.hasOwnProperty('getPlayerState');
    // },

    async loadPlayer(container, videoId) {
        //-1 (unstarted)
        // 0 (ended)
        // 1 (playing)
        // 2 (paused)
        // 3 (buffering)
        // 5 (video cued).

        debugger;
        let player = await new (dist_default())(container, {
            videoId: videoId,
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                autoplay: 0,
                rel: 0,
                // modestbranding: 1,
                // fs: 0,
                // disablekb: 1,
                // loop: 0,
                // playsinline: 1,
                //  mute: 0
            }

        });

        // function onPlayerReady(event) {
        //     // event.target.playVideo();

        //     let activeplayerid = `yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`;
        //     alert('Active element id ' + event.target.id + ': active player id ' + activeplayerid)
        //     if (activeplayerid == event.target.id) {

        //     }


        // }

        player.on('ready', function (event) {
            let activeplayerid = `yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`;

            if (activeplayerid == event.target.h.id) {
                //  alert('Active element id ' + event.target.id + ': active player id ' + activeplayerid)
                let coverspin = document.getElementById('cover-spin')
                if (coverspin) {
                    coverspin.style.display = "none";
                }
            }
        });

        //   WatchJobInterviewYoutubeVideoScript.done = false;



        player.on('stateChange', async (event) => {
            if (!WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval) {
                //  WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = setInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction, 1000)
            }

            switch (event.data) { //(https://developers.google.com/youtube/iframe_api_reference#Events)
                case -1:
                    WatchJobInterviewYoutubeVideoScript.isPlaying = false;
                    if (!WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval) {
                        // WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = setInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction, 1000)
                    }
                    return;
                case 0:
                    WatchJobInterviewYoutubeVideoScript.isPlaying = false;
                    // clearInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction)
                    WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = null;
                    WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds = 0
                    const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                    if (element) {
                        WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'iswatchd');
                    }
                    WatchJobInterviewYoutubeVideoScript.showHideMoveNextMovePrevious('show', 'youtube');


                    if (element) {

                        let isquizexists = element.getAttribute("data-isquizexists");
                        let isdocumentexists = element.getAttribute("data-isdocumentexists");
                        let isdocumentdownloaded = element.getAttribute("data-isdocumentdownloaded");
                        let isquizcompleted = element.getAttribute("data-isquizcompleted");


                        if (isquizexists == 1) {  // && isquizcompleted == 0
                            var QuzPageBlockId = "QuzPageBlock-" + WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex;
                            let QuzPageBlock = document.getElementById(QuzPageBlockId);
                            if (QuzPageBlock) {
                                QuzPageBlock.classList.remove("hide")
                            }
                        }
                        else if (isdocumentexists == 1) { // && isdocumentdownloaded == 0
                            var DocumentDownloadBlockId = "DocumentDownloadBlock-" + WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex;
                            let DocumentDownloadBlock = document.getElementById(DocumentDownloadBlockId);
                            if (DocumentDownloadBlock) {
                                DocumentDownloadBlock.classList.remove("hide")
                            }
                        }
                    }


                    // await WatchJobInterviewYoutubeVideoScript.scrollUp();
                    return
                case 1:
                    WatchJobInterviewYoutubeVideoScript.isPlaying = true;
                    const elementgapl = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                    if (elementgapl) {
                     let modulewithfilename= elementgapl.getAttribute('data-modulewithfilename');
						let gacategory = modulewithfilename + "_Play" + "," + modulewithfilename + "_Play" + "," + modulewithfilename + "_Play"
                     GATrack.pushValues(gacategory);

                    }
                       if (!WatchJobInterviewYoutubeVideoScript.done) {
                        WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = setInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction, 5000)
                        WatchJobInterviewYoutubeVideoScript.done = true;
                    }

                    WatchJobInterviewYoutubeVideoScript.ShowCurrentVideoAfterPlayingStarted();

                    // if (!WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval) {
                    //    // WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = setInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction, 1000)
                    // }
                    return;
                case 2:
                    WatchJobInterviewYoutubeVideoScript.isPlaying = false;
                    const elementgap = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
                    if (elementgap) {
                        let modulewithfilename= elementgap.getAttribute('data-modulewithfilename');
						let gacategory = modulewithfilename + "_Pause" + "," + modulewithfilename + "_Pause" + "," + modulewithfilename + "_Pause"
                     GATrack.pushValues(gacategory);

                    }
               
                    return;
                case 3:
                    // capsinevideoloader.classList.add('show')
                    return;
                case 5:
                    if (capsinevideoloader) {
                        capsinevideoloader.classList.remove('show');
                    }
                    return;
            }


        });

        return player
    },
    updateVideoAction() {
        const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        if (element) {
            WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'timetracking');
        }
        // WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds++
        // WatchJobInterviewYoutubeVideoScript.activeVideoPlayer;
        // if (WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds > 10 && WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds < 16) {
        //     const element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        //     if (element) {
        //         WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'timetracking');
        //     }
        // } else if (WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds > 16) {
        //   //  clearInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction)
        //     WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = null;
        //     WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds = 0
        // }
    },

    async ActivateNextVideoIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex);
        let videos = document.getElementsByClassName("youtube_video_wraper");

        // load next three videos
        for (let row = 1; row <= 1; row++) {

            let isCreateVideo = true;
            let NextVideoIndex = parseInt(activeVideoIndex) + row;

            if (activeVideoIndex < videos.length) {

                for (let index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
                    if (WatchJobInterviewYoutubeVideoScript.videoItems[index].row == NextVideoIndex) {
                        isCreateVideo = false;
                        break;
                    }
                }
                if (isCreateVideo == true) {

                    //    WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx = videos[activeVideoIndex].getAttribute("data-row-no")

                    let index = videos[activeVideoIndex].getAttribute("data-row-no")
                    const youtubeUrl = videos[activeVideoIndex].getAttribute("data-youtube-url");
                    const shortVideoId = "yt-player-" + index;   //WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx

                    await WatchJobInterviewYoutubeVideoScript.createYtIframeForElement(shortVideoId, youtubeUrl)

                    let videoobj_ = {
                        row: NextVideoIndex,
                        id: videos[activeVideoIndex].id,
                        player: WatchJobInterviewYoutubeVideoScript.ytubeplayer,
                        video: document.getElementById(`wrapper-${NextVideoIndex}`)
                    }
                    WatchJobInterviewYoutubeVideoScript.videoItems.push(videoobj_);

                    activeVideoIndex = NextVideoIndex;
                }
            }
        }
    },

    async CreateYoutubePlayerIfNotExists() {
        // Activate Next Video 

        let activeVideoIndex = parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex);
        let videos = document.getElementsByClassName("youtube_video_wraper");



        let isCreateNextVideo = true;

        let isCreatePreviousVideo = true;

        let NextVideoIndex = parseInt(activeVideoIndex) + 1;

        let PreviousVideoIndex = parseInt(activeVideoIndex) - 1;

        // update next video player if not exists
        if (activeVideoIndex < videos.length) {

            for (let index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
                if (WatchJobInterviewYoutubeVideoScript.videoItems[index].row == NextVideoIndex) {
                    if (WatchJobInterviewYoutubeVideoScript.videoItems[index].player) {
                        isCreateNextVideo = false;
                    }
                    else {
                        let sid = WatchJobInterviewYoutubeVideoScript.videoItems[index].shortVideoId;
                        let yurl = WatchJobInterviewYoutubeVideoScript.videoItems[index].youtubeUrl;
                        await WatchJobInterviewYoutubeVideoScript.createYtIframeForElement(sid, yurl)
                        WatchJobInterviewYoutubeVideoScript.videoItems[index].player = WatchJobInterviewYoutubeVideoScript.ytubeplayer

                    }
                    break;
                }
            }

        }


        // update previous video player if not exists
        if (activeVideoIndex > 1) {

            for (let index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
                if (WatchJobInterviewYoutubeVideoScript.videoItems[index].row == PreviousVideoIndex) {
                    if (WatchJobInterviewYoutubeVideoScript.videoItems[index].player) {
                        isCreatePreviousVideo = false;
                    }
                    else {
                        let sid = WatchJobInterviewYoutubeVideoScript.videoItems[index].shortVideoId;
                        let yurl = WatchJobInterviewYoutubeVideoScript.videoItems[index].youtubeUrl;
                        await WatchJobInterviewYoutubeVideoScript.createYtIframeForElement(sid, yurl)
                        WatchJobInterviewYoutubeVideoScript.videoItems[index].player = WatchJobInterviewYoutubeVideoScript.ytubeplayer

                    }
                    break;
                }
            }

        }

        // WatchJobInterviewYoutubeVideoScript.showHideMoveNextMovePrevious('show','btnclick');

    },

    resetAll() {
        WatchJobInterviewYoutubeVideoScript.UserPid = '';
        WatchJobInterviewYoutubeVideoScript.userInfo = null;
        WatchJobInterviewYoutubeVideoScript.activePlayer = null;
        WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex = 0;
        WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx = 0;
        WatchJobInterviewYoutubeVideoScript.setTimeOutActiveVideos = [];
        WatchJobInterviewYoutubeVideoScript.initialVideoPlayed = false;
        WatchJobInterviewYoutubeVideoScript.activePlayer = null;
        WatchJobInterviewYoutubeVideoScript.videoItems = [];
        // WatchJobInterviewYoutubeVideoScript.setTimeOutActiveVideos = [];
        WatchJobInterviewYoutubeVideoScript.isScroll = true;
        WatchJobInterviewYoutubeVideoScript.isPlaying = false;
        WatchJobInterviewYoutubeVideoScript.isAllowSave = true;
        WatchJobInterviewYoutubeVideoScript.touchDetails = "";
        WatchJobInterviewYoutubeVideoScript.sfvLimit = true;
        WatchJobInterviewYoutubeVideoScript.activeVideoPlayer = null;
        WatchJobInterviewYoutubeVideoScript.activeVideoPlayerInterval = null;
        WatchJobInterviewYoutubeVideoScript.activeVideoPlayerElapsedTimeInSeconds = null;
        WatchJobInterviewYoutubeVideoScript.updatedSaveActionVideoId = new Map();
        WatchJobInterviewYoutubeVideoScript.ytubeplayer = null;
        WatchJobInterviewYoutubeVideoScript.done = false;
        clearInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction)
        document.querySelectorAll(".list-item").forEach((divvideo) => {
            divvideo.classList.remove('current-video')
        });

        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);



        function fixTouchStart(event) {
            return;
        }


        function fixTouchEnd(event) {
            return;
        }
        function fixTouchMove(event) {
            return;
        }

        function removePauseVideOnDocumentLooseFocus() {
            return;
        }
        function removePlayideOnDocumentOnFocus() {
            return;
        }


        // Remove any previous listners as the page content is ajax loaded and body is never destroyed
        document.body.removeEventListener("touchstart", fixTouchStart);
        document.body.removeEventListener("touchend", fixTouchEnd);
        document.body.removeEventListener("touchstart", fixTouchMove);
        window.removeEventListener("blur", removePauseVideOnDocumentLooseFocus);
        window.removeEventListener("focus", removePlayideOnDocumentOnFocus);

        // reset events 
    },


    async pauseVideOnDocumentLooseFocus() {
        if (WatchJobInterviewYoutubeVideoScript.activeVideoPlayer) {
            await WatchJobInterviewYoutubeVideoScript.activeVideoPlayer.pauseVideo();
            var playiconId = "playicon" + WatchJobInterviewYoutubeVideoScript.activeVideoPlayerIdx
            if (document.getElementById(playiconId)) {
                document.getElementById(playiconId).classList.remove('hide')
            }
        }

    },

    pauseAllVideosBeforeExit() {

        for (var index = 0; index < WatchJobInterviewYoutubeVideoScript.videoItems.length; index++) {
            // var video = WatchJobInterviewYoutubeVideoScript.videoItems[index].video;
            var player = WatchJobInterviewYoutubeVideoScript.videoItems[index].player;
            // TODO: Pause state
            if (!WatchJobInterviewYoutubeVideoScript.isPlaying) {

            } else {
                player.pauseVideo();
            }
        }

    },
    initializeVideo() {
        function formatTime(timeInSeconds) {
            const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);

            return {
                minutes: result.substr(3, 2),
                seconds: result.substr(6, 2),
            };
        };
        const videoDuration = Math.round(video.duration);
        const time = formatTime(videoDuration);
        duration.innerText = `${time.minutes}:${time.seconds}`;
        duration.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
    },

    ShowCurrentVideoAfterPlayingStarted(){
        let itemcount = document.querySelectorAll(".list-item").length;
        let btnNext = document.getElementById(`yt-next-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        let btnPrevious = document.getElementById(`yt-previous-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        let iswholevideowatched='0'
        if (btnNext) {
            iswholevideowatched = btnNext.getAttribute('data-iswholevideowatched')
        }
        if(iswholevideowatched==1){
            // btnNext.classList.remove('visiblehide');
            // btnNext.classList.remove('visiblehide');

            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) < itemcount) {
                // Show move next button
                if (btnNext) {
                    btnNext.classList.remove('visiblehide');
                }
            }
            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) > 1) {
                // Show move previous button
                if (btnPrevious) {
                    btnPrevious.classList.remove('visiblehide');
                }
            }

        }

    },

    HideCurrentVideoBeforeNextVideoStarted(){
        let itemcount = document.querySelectorAll(".list-item").length;
        let btnNext = document.getElementById(`yt-next-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        let btnPrevious = document.getElementById(`yt-previous-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)
        let iswholevideowatched='0'
      
        if (btnNext) {
            iswholevideowatched = btnNext.getAttribute('data-iswholevideowatched')
        }
        if (btnNext) {
            btnNext.classList.add('visiblehide');
        }

        if (btnPrevious) {
            btnPrevious.classList.add('visiblehide');
        }
  

    },


    showHideMoveNextMovePrevious(mode, src) {
        let itemcount = document.querySelectorAll(".list-item").length;

        let btnNext = document.getElementById(`yt-next-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)

        let btnPrevious = document.getElementById(`yt-previous-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)

        let iswholevideowatched = '0';

        if (src == 'youtube') {
            if (btnNext) {
                btnNext.setAttribute('data-iswholevideowatched', '1')
            }
        }

        if (btnNext) {
            iswholevideowatched = btnNext.getAttribute('data-iswholevideowatched')
        }

        if (mode == 'show' && iswholevideowatched == 1) {
            //MoveNextEnable
            // Show Thank you screen
            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) == itemcount) {
                let thankyoupopup = document.getElementById("divJobInterviewThankyouPopup")
                if (thankyoupopup) {
                    thankyoupopup.classList.add('show')
                    // clearInterval(WatchJobInterviewYoutubeVideoScript.updateVideoAction)
                    let element = document.getElementById(`yt-player-${WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex}`)


                    WatchJobInterviewYoutubeVideoScript.SaveShortVideoAction(element, 'finalvidowatchd');

                    WatchJobInterviewYoutubeVideoScript.coursecertificateurl = btnNext.getAttribute('data-coursecertificateurl')
                    WatchJobInterviewYoutubeVideoScript.iscertificatedownloaded = btnNext.getAttribute('data-iscertificatedownloaded')
                    WatchJobInterviewYoutubeVideoScript.coursecompleteddatetime = btnNext.getAttribute('data-coursecompleteddatetime')

                }
            }

            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) < itemcount) {
                // Show move next button
                if (btnNext) {
                    btnNext.classList.remove('visiblehide');
                }
            }
            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) > 1) {
                // Show move previous button
                if (btnPrevious) {
                    btnPrevious.classList.remove('visiblehide');
                }
            }
            
        }
        else {

            if (iswholevideowatched == 0) {
                if (btnNext) {
                    btnNext.classList.add('visiblehide')
                }
                if (btnPrevious) {
                    btnPrevious.classList.add('visiblehide')
                }

            }

            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) < itemcount) {
                // Show move next button
                if (btnNext) {
                    btnNext.classList.remove('visiblehide')
                }
            }
            if (parseInt(WatchJobInterviewYoutubeVideoScript.activePlayerRowIndex) > 1) {
                // Show move previous button
                if (btnPrevious) {
                    btnPrevious.classList.remove('visiblehide')
                }
            }

        }



    },

    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }


}

/* harmony default export */ const js_WatchJobInterviewYoutubeVideoScript = (WatchJobInterviewYoutubeVideoScript);
;// CONCATENATED MODULE: ./src/js/JobInterviewCoursePreviewScript.js







// import router from "./routerconfig"
var JobInterviewCoursePreviewScript = {
    UserPid: '',
    userInfo: null,
    isMobileApp: false,
    ytubeplayer: null,
    activeVideoPlayer:null,
    init: async function (userpid, sulekhaApp = null) {
        // remove touch events 

        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }

        JobInterviewCoursePreviewScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');

        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                JobInterviewCoursePreviewScript.isMobileApp = true;
            }
            else {
                JobInterviewCoursePreviewScript.isMobileApp = false;
            }
        }

        await JobInterviewCoursePreviewScript.setupInitialYoutubeVideo();

        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, JobInterviewCoursePreviewScript.afterGetUserInfoLoad);

        

           let btnnavigateback = document.getElementById('btnnavigateback'); //or grab it by tagname etc
        // JobInterviewCoursePreviewScript.popuptitle='Download Document'
		if (btnnavigateback) {
			GATrack.pushValues('paymentplan MJI preview_back', 'paymentplan MJI preview_back', 'paymentplan MJI preview_back')
            btnnavigateback.addEventListener("click", function (e) {

                if (JobInterviewCoursePreviewScript.isMobileApp) {
                    JobInterviewCoursePreviewScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentPlans, null);
                }
                else {
                    // history.back();
                    location.href = "/paymentPlans"
                }

            })

        }
       

           

    },

    


    ///  End


    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        JobInterviewCoursePreviewScript.userInfo = response.data;
        // JobInterviewCoursePreviewScript.sfvWatchedCount=JobInterviewCoursePreviewScript.userInfo.sfvWatchedCount;
        JobInterviewCoursePreviewScript.sfvLimit = JobInterviewCoursePreviewScript.userInfo.sfvLimit;
    },

  

    getYoutubeIdFromUrl(url) {
        var regExp = /(youtu.*be.*)\/(watch\?v=|embed\/|shorts|)(.*?((?=[&#?])|$))/gm;
        return regExp.exec(url)[3];
    },

   

    async setupInitialYoutubeVideo() {
        let videos = document.getElementById("yt-player-1");
        var shortVideoId = 'yt-player-1'
        var youtubeUrl = videos.getAttribute("data-youtube-url");
        await JobInterviewCoursePreviewScript.createYtIframeForElement(shortVideoId, youtubeUrl)
        JobInterviewCoursePreviewScript.activeVideoPlayer = JobInterviewCoursePreviewScript.ytubeplayer
    
    },

    async createYtIframeForElement(element, youtubeUrl) {
        const videoId = JobInterviewCoursePreviewScript.getYoutubeIdFromUrl(youtubeUrl);
        let player = await JobInterviewCoursePreviewScript.loadPlayer(element, videoId)
        JobInterviewCoursePreviewScript.ytubeplayer = player;

    },
   
  
    async loadPlayer(container, videoId) {
        //         -1 (unstarted)
        // 0 (ended)
        // 1 (playing)
        // 2 (paused)
        // 3 (buffering)
        // 5 (video cued).
        debugger;
        let player = await new (dist_default())(container, {
            videoId: videoId,
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                autoplay: 0,
                rel: 0,
                modestbranding: 1,
                fs: 0,
                controls: 1,
                disablekb: 1,
                loop: 0,
                playsinline: 1,
                mute: 0
            }
        });
        player.on('stateChange', async (event) => {
          
            switch (event.data) { //(https://developers.google.com/youtube/iframe_api_reference#Events)
                case -1:
                    JobInterviewCoursePreviewScript.isPlaying = false;
                return;
                case 0:
                    JobInterviewCoursePreviewScript.isPlaying = false;             
                    return
                case 1:
                    JobInterviewCoursePreviewScript.isPlaying = true;
                       return;
                case 2:
                    JobInterviewCoursePreviewScript.isPlaying = false;
                    return;
                case 3:
                    return;
                case 5:
                    return;
            }


        });

        return player
    },
   
 

    iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }


}

/* harmony default export */ const js_JobInterviewCoursePreviewScript = (JobInterviewCoursePreviewScript);
;// CONCATENATED MODULE: ./src/js/ShortVideosViewAllScript.js




// import router from "./routerconfig"
var ShortVideosViewAllScript = {
    UserPid: '',
    userInfo: null,
    isCoach: false,
    isMobileApp: false,
    init: function (userpid, sulekhaApp = null) {

        var currentPage = "watchedvideoLesson";

        window.localStorage.setItem('backpage','ShortVideosViewAll');

        ShortVideosViewAllScript.sulekhaApp = sulekhaApp;
        var hdnIsMobileApp = document.getElementById('hdnIsMobileApp');


        if (hdnIsMobileApp) {
            if (hdnIsMobileApp.value == "true") {
                ShortVideosViewAllScript.isMobileApp = true;
            }
            else {
                ShortVideosViewAllScript.isMobileApp = false;
            }
        }


        let DivHeader = document.getElementById('capShineHeader');    //header-sticky
        let DivFooter = document.getElementById('capShineFooter');

        if (DivHeader != null) {
            if (!DivHeader.classList.contains('hide')) {
                DivHeader.classList.add('hide')
            }
        }

        if (DivFooter != null) {
            if (!DivFooter.classList.contains('hide')) {
                DivFooter.classList.add('hide')
            }
        }


        CSMainAPIs.Capshine.APIs.GetUserInfo.execute({ "UserPid": userpid }, ShortVideosViewAllScript.afterGetUserInfoLoad);


  /// Show active tab

    
  
  document.querySelectorAll("._clicksvftag").forEach((btn) => {
    btn.addEventListener("click", function (e) {
        e.stopPropagation();
        //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');   
        var tagid = e.currentTarget.getAttribute('data-tagid');
//
if (ShortVideosViewAllScript.isMobileApp == true) {
    var rnd = ShortVideosViewAllScript.getRandomNunber();
    
    if (ShortVideosViewAllScript.userInfo.clubUserType == 1 && ShortVideosViewAllScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
        setTimeout(() => {
            ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                pageType: 9
            })
        }, 1000);
    }
    else {
        setTimeout(() => {
            ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.ShortVideosViewAll, { tagid: tagid, rnd: rnd});
        }, 1000);
    }

}
else {
   
    if (ShortVideosViewAllScript.userInfo.clubUserType == 1 && ShortVideosViewAllScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
        location.href = "/PaymentUpgradeRequest?pageType=9";
    }
    else {      
        location.href = "/ShortVideosViewAll?tagid=" + tagid;
        
    }

}



     //

    })
}),

        document.querySelectorAll(".tagidshow-more-less").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                var tagid = e.currentTarget.getAttribute('data-tagid');
              
            
                let id="Sfvcontent_"+tagid;
                if(document.getElementById(id)){
                    var status= document.getElementById(id).getAttribute('data-contentstatus')
                    if(status=='less'){
                    document.getElementById(id).classList.remove('sk-line-clamp')
                    btn.innerHTML='less'
                    document.getElementById(id).setAttribute('data-contentstatus','more')  
                    }
                    else {
                        document.getElementById(id).classList.add('sk-line-clamp')
                        btn.innerHTML='more'
                        document.getElementById(id).setAttribute('data-contentstatus','less')    
                    }
                }
            })
        })

             // Short video 

        document.querySelectorAll(".viewShortVideo").forEach((btn) => {
            btn.addEventListener("click", function (e) {
                e.stopPropagation();
                //  var videouniqueid = e.currentTarget.getAttribute('data-videouniqueid');
                var languagevideoid = e.currentTarget.getAttribute('data-languagevideoid');
                var videoId = e.currentTarget.getAttribute('data-videoid');
                var userId = e.currentTarget.getAttribute('data-userid');
                
                var istodaywatchedvideo = e.currentTarget.getAttribute('data-istodaywatchedvideo');
                var tagid = ShortVideosViewAllScript.getParameterByName('tagid');
                


                if (ShortVideosViewAllScript.isMobileApp == true) {
                    var rnd = ShortVideosViewAllScript.getRandomNunber();
                    
                    if (ShortVideosViewAllScript.userInfo.clubUserType == 1 && ShortVideosViewAllScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
                        setTimeout(() => {
                            ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.paymentUpgradeRequest, {
                                pageType: 9
                            })
                        }, 1000);
                    }
                    else {
                        setTimeout(() => {
                            ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.watchShortVideos, { VideoId: videoId, rnd: rnd, iswatched: '3', languagevideoid: languagevideoid,tagid:tagid });
                        }, 1000);
                    }

                }
                else {
                    
                    if (ShortVideosViewAllScript.userInfo.clubUserType == 1 && ShortVideosViewAllScript.userInfo.sfvLimit == false && istodaywatchedvideo=="False") {
                        location.href = "/PaymentUpgradeRequest?pageType=9";
                    }
                    else {
                        if (ShortVideosViewAllScript.iOS()) {
                            location.href = "/watchShortVideosInIOS?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;
                        }
                        else {

                        location.href = "/watchShortVideos?VideoId=" + videoId + "&iswatched=3" + "&languagevideoid=" + languagevideoid + "&tagid=" + tagid;
                        }
                    }

                }


            })
        })



        if (document.getElementById('svfBackBtn')) {

            document.getElementById('svfBackBtn').addEventListener('click', function (e) {
                
                var shortvideobackpage = window.localStorage.getItem('sfvbackpage');

                if (ShortVideosViewAllScript.isMobileApp == true) {

                    if (shortvideobackpage == "videos") {
                        ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                    }
                    else if(shortvideobackpage == "ShortVideosViewAll") {
                        ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videos, null);
                    }
                    else {
                        ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.home, null)
                    }

                }
                else {

                    if (shortvideobackpage) {
                        if (shortvideobackpage == "videos") {
                            location.href = "/videos"
                        }
                        else if (shortvideobackpage == "home") {
                            location.href = "/home"
                        }
                        else if (shortvideobackpage == "ShortVideosViewAll") {
                            location.href = "/videos"
                        }
                    }
                    else {
                        location.href = "/home"
                    }
                }

            })

        }


    },
    iOS() {
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		].includes(navigator.platform)
			// iPad on iOS 13 detection
			|| (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	},
    getRandomNunber: function () {
        return Math.floor(1000 + Math.random() * 9000);
    },

    afterGetUserInfoLoad(response) {
        ShortVideosViewAllScript.userInfo = response.data;

    },
    UpdateClubUserLanguageResponse: async function (Response) {

        var rnd = ShortVideosViewAllScript.getRandomNunber();

        if (ShortVideosViewAllScript.isMobileApp) {
            ShortVideosViewAllScript.sulekhaApp.navigateTo(MainEnums_MobilePages.videoLessons, { rnd: rnd });
        }
        else {
            location.href = "/videolessons";
        }



    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


}

/* harmony default export */ const js_ShortVideosViewAllScript = (ShortVideosViewAllScript);
;// CONCATENATED MODULE: ./src/export-capshine.ts
// Core  Library  

// Js  Library ref 





// Vue js components 

//import WatchVideo from './Components/WatchVideo.vue';
// @ts-ignore












































//#region Screens


let AppPerPanel = {};
function InitPanel(nameAndInst, props) {
    let app = null;
    const name = nameAndInst.split('_')[0];
    if (name == 'Sample') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(CapshineSample, props) });
    }
    else if (name == 'Club') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(ClubRegistration, props) });
    }
    else if (name == 'LoginWeb') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(LoginWeb, props) });
    }
    else if (name == 'EnglishAssesment') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(AssessYourEnglish, props) });
    }
    else if (name == 'FillTheGap' || name == 'Quiz' || name == 'JumbledSentence' || name === "AllMcqBase") {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(AllMcqBase, props) });
    }
    else if (name == 'VocabularyQuiz') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(AllMcqBase, props) });
    }
    else if (name == 'SignUpTalktime') {
        app = (0,vue_cjs.createApp)({ render: () => (0,vue_cjs.h)(SignUpTalktime, props) });
    }
    else {
        throw new Error('Unknown Panel: ' + name);
    }
    ViewRegistry.Register(app);
    const vm = app.mount('#' + nameAndInst + '_Panel');
    const inst = CapshineDI.CapshineInstances[name];
    AppPerPanel[nameAndInst] = { app, vm, inst };
}


})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});